import * as be from "react";
import h, { useState as ye, useEffect as Pe, useRef as An, createContext as Nxe, forwardRef as r1, memo as cM, Component as Txe, PureComponent as r7, Children as Ixe, cloneElement as Oxe, Fragment as Rxe, createRef as Vxe, useContext as bn, useLayoutEffect as Fg, createElement as Hxe, useCallback as ds, useImperativeHandle as uFe, useMemo as Bxe } from "react";
import Q4 from "bpmn-moddle";
import * as fFe from "react-dom";
import { unstable_batchedUpdates as pFe, createPortal as un } from "react-dom";
import q, { keyframes as zg, css as rs } from "styled-components";
import { MenuItemDivider as Pxe, Layer as Wg, Button as Rn, CodeSnippet as s7, Modal as M1, TextInput as ha, FormLabel as K4, ModalHeader as Fxe, ModalBody as zxe, ComposedModal as Wxe, ModalFooter as jxe, Stack as In, Tabs as Zxe, TabList as Uxe, Tab as qxe, TreeNode as Gxe, Tag as o7, TreeView as Qxe, Table as Y4, TableHead as X4, TableRow as ko, TableHeader as to, TableBody as J4, TableCell as di, ProgressBar as Kxe, ActionableNotification as Hf, Form as $4, Link as ja, InlineLoading as UT, Tooltip as ew, InlineNotification as qT, ToggletipActions as Yxe, Toggletip as Xxe, ToggletipContent as Jxe, ComboBox as tw, IconButton as hM, Callout as gFe, DefinitionTooltip as mFe, TabPanel as AFe, SkeletonText as $xe, SkeletonIcon as wFe, Loading as GT } from "@carbon/react";
import eSe, { loader as l8 } from "@monaco-editor/react";
import { Form as nw, getSchemaVariables as dM } from "@bpmn-io/form-js";
import { isNil as tSe, isEqual as ku } from "lodash";
var fv = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function a7(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var pv = { exports: {} }, Sm = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KH;
function vFe() {
  if (KH) return Sm;
  KH = 1;
  var r = h, e = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, l, c) {
    var d, u = {}, f = null, p = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (d in l) n.call(l, d) && !s.hasOwnProperty(d) && (u[d] = l[d]);
    if (a && a.defaultProps) for (d in l = a.defaultProps, l) u[d] === void 0 && (u[d] = l[d]);
    return { $$typeof: e, type: a, key: f, ref: p, props: u, _owner: i.current };
  }
  return Sm.Fragment = t, Sm.jsx = o, Sm.jsxs = o, Sm;
}
var Mm = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YH;
function bFe() {
  return YH || (YH = 1, process.env.NODE_ENV !== "production" && function() {
    var r = h, e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, m = "@@iterator";
    function A(ie) {
      if (ie === null || typeof ie != "object")
        return null;
      var Te = g && ie[g] || ie[m];
      return typeof Te == "function" ? Te : null;
    }
    var w = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(ie) {
      {
        for (var Te = arguments.length, nt = new Array(Te > 1 ? Te - 1 : 0), Vt = 1; Vt < Te; Vt++)
          nt[Vt - 1] = arguments[Vt];
        y("error", ie, nt);
      }
    }
    function y(ie, Te, nt) {
      {
        var Vt = w.ReactDebugCurrentFrame, Zn = Vt.getStackAddendum();
        Zn !== "" && (Te += "%s", nt = nt.concat([Zn]));
        var Ze = nt.map(function(re) {
          return String(re);
        });
        Ze.unshift("Warning: " + Te), Function.prototype.apply.call(console[ie], console, Ze);
      }
    }
    var _ = !1, S = !1, D = !1, M = !1, L = !1, T;
    T = Symbol.for("react.module.reference");
    function B(ie) {
      return !!(typeof ie == "string" || typeof ie == "function" || ie === n || ie === s || L || ie === i || ie === c || ie === d || M || ie === p || _ || S || D || typeof ie == "object" && ie !== null && (ie.$$typeof === f || ie.$$typeof === u || ie.$$typeof === o || ie.$$typeof === a || ie.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ie.$$typeof === T || ie.getModuleId !== void 0));
    }
    function V(ie, Te, nt) {
      var Vt = ie.displayName;
      if (Vt)
        return Vt;
      var Zn = Te.displayName || Te.name || "";
      return Zn !== "" ? nt + "(" + Zn + ")" : nt;
    }
    function N(ie) {
      return ie.displayName || "Context";
    }
    function R(ie) {
      if (ie == null)
        return null;
      if (typeof ie.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ie == "function")
        return ie.displayName || ie.name || null;
      if (typeof ie == "string")
        return ie;
      switch (ie) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof ie == "object")
        switch (ie.$$typeof) {
          case a:
            var Te = ie;
            return N(Te) + ".Consumer";
          case o:
            var nt = ie;
            return N(nt._context) + ".Provider";
          case l:
            return V(ie, ie.render, "ForwardRef");
          case u:
            var Vt = ie.displayName || null;
            return Vt !== null ? Vt : R(ie.type) || "Memo";
          case f: {
            var Zn = ie, Ze = Zn._payload, re = Zn._init;
            try {
              return R(re(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, z = 0, U, ee, ce, se, te, ue, G;
    function j() {
    }
    j.__reactDisabledLog = !0;
    function pe() {
      {
        if (z === 0) {
          U = console.log, ee = console.info, ce = console.warn, se = console.error, te = console.group, ue = console.groupCollapsed, G = console.groupEnd;
          var ie = {
            configurable: !0,
            enumerable: !0,
            value: j,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ie,
            log: ie,
            warn: ie,
            error: ie,
            group: ie,
            groupCollapsed: ie,
            groupEnd: ie
          });
        }
        z++;
      }
    }
    function De() {
      {
        if (z--, z === 0) {
          var ie = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, ie, {
              value: U
            }),
            info: H({}, ie, {
              value: ee
            }),
            warn: H({}, ie, {
              value: ce
            }),
            error: H({}, ie, {
              value: se
            }),
            group: H({}, ie, {
              value: te
            }),
            groupCollapsed: H({}, ie, {
              value: ue
            }),
            groupEnd: H({}, ie, {
              value: G
            })
          });
        }
        z < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ce = w.ReactCurrentDispatcher, F;
    function I(ie, Te, nt) {
      {
        if (F === void 0)
          try {
            throw Error();
          } catch (Zn) {
            var Vt = Zn.stack.trim().match(/\n( *(at )?)/);
            F = Vt && Vt[1] || "";
          }
        return `
` + F + ie;
      }
    }
    var O = !1, Y;
    {
      var K = typeof WeakMap == "function" ? WeakMap : Map;
      Y = new K();
    }
    function ae(ie, Te) {
      if (!ie || O)
        return "";
      {
        var nt = Y.get(ie);
        if (nt !== void 0)
          return nt;
      }
      var Vt;
      O = !0;
      var Zn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = Ce.current, Ce.current = null, pe();
      try {
        if (Te) {
          var re = function() {
            throw Error();
          };
          if (Object.defineProperty(re.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(re, []);
            } catch (Qr) {
              Vt = Qr;
            }
            Reflect.construct(ie, [], re);
          } else {
            try {
              re.call();
            } catch (Qr) {
              Vt = Qr;
            }
            ie.call(re.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Qr) {
            Vt = Qr;
          }
          ie();
        }
      } catch (Qr) {
        if (Qr && Vt && typeof Qr.stack == "string") {
          for (var Ee = Qr.stack.split(`
`), je = Vt.stack.split(`
`), Ot = Ee.length - 1, pn = je.length - 1; Ot >= 1 && pn >= 0 && Ee[Ot] !== je[pn]; )
            pn--;
          for (; Ot >= 1 && pn >= 0; Ot--, pn--)
            if (Ee[Ot] !== je[pn]) {
              if (Ot !== 1 || pn !== 1)
                do
                  if (Ot--, pn--, pn < 0 || Ee[Ot] !== je[pn]) {
                    var Li = `
` + Ee[Ot].replace(" at new ", " at ");
                    return ie.displayName && Li.includes("<anonymous>") && (Li = Li.replace("<anonymous>", ie.displayName)), typeof ie == "function" && Y.set(ie, Li), Li;
                  }
                while (Ot >= 1 && pn >= 0);
              break;
            }
        }
      } finally {
        O = !1, Ce.current = Ze, De(), Error.prepareStackTrace = Zn;
      }
      var ni = ie ? ie.displayName || ie.name : "", Gr = ni ? I(ni) : "";
      return typeof ie == "function" && Y.set(ie, Gr), Gr;
    }
    function Oe(ie, Te, nt) {
      return ae(ie, !1);
    }
    function ot(ie) {
      var Te = ie.prototype;
      return !!(Te && Te.isReactComponent);
    }
    function It(ie, Te, nt) {
      if (ie == null)
        return "";
      if (typeof ie == "function")
        return ae(ie, ot(ie));
      if (typeof ie == "string")
        return I(ie);
      switch (ie) {
        case c:
          return I("Suspense");
        case d:
          return I("SuspenseList");
      }
      if (typeof ie == "object")
        switch (ie.$$typeof) {
          case l:
            return Oe(ie.render);
          case u:
            return It(ie.type, Te, nt);
          case f: {
            var Vt = ie, Zn = Vt._payload, Ze = Vt._init;
            try {
              return It(Ze(Zn), Te, nt);
            } catch {
            }
          }
        }
      return "";
    }
    var Mn = Object.prototype.hasOwnProperty, Ii = {}, os = w.ReactDebugCurrentFrame;
    function Cc(ie) {
      if (ie) {
        var Te = ie._owner, nt = It(ie.type, ie._source, Te ? Te.type : null);
        os.setExtraStackFrame(nt);
      } else
        os.setExtraStackFrame(null);
    }
    function we(ie, Te, nt, Vt, Zn) {
      {
        var Ze = Function.call.bind(Mn);
        for (var re in ie)
          if (Ze(ie, re)) {
            var Ee = void 0;
            try {
              if (typeof ie[re] != "function") {
                var je = Error((Vt || "React class") + ": " + nt + " type `" + re + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ie[re] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              Ee = ie[re](Te, re, Vt, nt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ot) {
              Ee = Ot;
            }
            Ee && !(Ee instanceof Error) && (Cc(Zn), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Vt || "React class", nt, re, typeof Ee), Cc(null)), Ee instanceof Error && !(Ee.message in Ii) && (Ii[Ee.message] = !0, Cc(Zn), v("Failed %s type: %s", nt, Ee.message), Cc(null));
          }
      }
    }
    var de = Array.isArray;
    function he(ie) {
      return de(ie);
    }
    function P(ie) {
      {
        var Te = typeof Symbol == "function" && Symbol.toStringTag, nt = Te && ie[Symbol.toStringTag] || ie.constructor.name || "Object";
        return nt;
      }
    }
    function W(ie) {
      try {
        return ne(ie), !1;
      } catch {
        return !0;
      }
    }
    function ne(ie) {
      return "" + ie;
    }
    function X(ie) {
      if (W(ie))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", P(ie)), ne(ie);
    }
    var Ae = w.ReactCurrentOwner, Le = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, We, Ue;
    function ut(ie) {
      if (Mn.call(ie, "ref")) {
        var Te = Object.getOwnPropertyDescriptor(ie, "ref").get;
        if (Te && Te.isReactWarning)
          return !1;
      }
      return ie.ref !== void 0;
    }
    function ct(ie) {
      if (Mn.call(ie, "key")) {
        var Te = Object.getOwnPropertyDescriptor(ie, "key").get;
        if (Te && Te.isReactWarning)
          return !1;
      }
      return ie.key !== void 0;
    }
    function yn(ie, Te) {
      typeof ie.ref == "string" && Ae.current;
    }
    function fn(ie, Te) {
      {
        var nt = function() {
          We || (We = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Te));
        };
        nt.isReactWarning = !0, Object.defineProperty(ie, "key", {
          get: nt,
          configurable: !0
        });
      }
    }
    function it(ie, Te) {
      {
        var nt = function() {
          Ue || (Ue = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Te));
        };
        nt.isReactWarning = !0, Object.defineProperty(ie, "ref", {
          get: nt,
          configurable: !0
        });
      }
    }
    var ei = function(ie, Te, nt, Vt, Zn, Ze, re) {
      var Ee = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: ie,
        key: Te,
        ref: nt,
        props: re,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return Ee._store = {}, Object.defineProperty(Ee._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ee, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Vt
      }), Object.defineProperty(Ee, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Zn
      }), Object.freeze && (Object.freeze(Ee.props), Object.freeze(Ee)), Ee;
    };
    function ti(ie, Te, nt, Vt, Zn) {
      {
        var Ze, re = {}, Ee = null, je = null;
        nt !== void 0 && (X(nt), Ee = "" + nt), ct(Te) && (X(Te.key), Ee = "" + Te.key), ut(Te) && (je = Te.ref, yn(Te, Zn));
        for (Ze in Te)
          Mn.call(Te, Ze) && !Le.hasOwnProperty(Ze) && (re[Ze] = Te[Ze]);
        if (ie && ie.defaultProps) {
          var Ot = ie.defaultProps;
          for (Ze in Ot)
            re[Ze] === void 0 && (re[Ze] = Ot[Ze]);
        }
        if (Ee || je) {
          var pn = typeof ie == "function" ? ie.displayName || ie.name || "Unknown" : ie;
          Ee && fn(re, pn), je && it(re, pn);
        }
        return ei(ie, Ee, je, Zn, Vt, Ae.current, re);
      }
    }
    var Ds = w.ReactCurrentOwner, Gt = w.ReactDebugCurrentFrame;
    function Yn(ie) {
      if (ie) {
        var Te = ie._owner, nt = It(ie.type, ie._source, Te ? Te.type : null);
        Gt.setExtraStackFrame(nt);
      } else
        Gt.setExtraStackFrame(null);
    }
    var El;
    El = !1;
    function _l(ie) {
      return typeof ie == "object" && ie !== null && ie.$$typeof === e;
    }
    function mo() {
      {
        if (Ds.current) {
          var ie = R(Ds.current.type);
          if (ie)
            return `

Check the render method of \`` + ie + "`.";
        }
        return "";
      }
    }
    function Ec(ie) {
      return "";
    }
    var _c = {};
    function Oh(ie) {
      {
        var Te = mo();
        if (!Te) {
          var nt = typeof ie == "string" ? ie : ie.displayName || ie.name;
          nt && (Te = `

Check the top-level render call using <` + nt + ">.");
        }
        return Te;
      }
    }
    function Rh(ie, Te) {
      {
        if (!ie._store || ie._store.validated || ie.key != null)
          return;
        ie._store.validated = !0;
        var nt = Oh(Te);
        if (_c[nt])
          return;
        _c[nt] = !0;
        var Vt = "";
        ie && ie._owner && ie._owner !== Ds.current && (Vt = " It was passed a child from " + R(ie._owner.type) + "."), Yn(ie), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', nt, Vt), Yn(null);
      }
    }
    function xc(ie, Te) {
      {
        if (typeof ie != "object")
          return;
        if (he(ie))
          for (var nt = 0; nt < ie.length; nt++) {
            var Vt = ie[nt];
            _l(Vt) && Rh(Vt, Te);
          }
        else if (_l(ie))
          ie._store && (ie._store.validated = !0);
        else if (ie) {
          var Zn = A(ie);
          if (typeof Zn == "function" && Zn !== ie.entries)
            for (var Ze = Zn.call(ie), re; !(re = Ze.next()).done; )
              _l(re.value) && Rh(re.value, Te);
        }
      }
    }
    function xm(ie) {
      {
        var Te = ie.type;
        if (Te == null || typeof Te == "string")
          return;
        var nt;
        if (typeof Te == "function")
          nt = Te.propTypes;
        else if (typeof Te == "object" && (Te.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Te.$$typeof === u))
          nt = Te.propTypes;
        else
          return;
        if (nt) {
          var Vt = R(Te);
          we(nt, ie.props, "prop", Vt, ie);
        } else if (Te.PropTypes !== void 0 && !El) {
          El = !0;
          var Zn = R(Te);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Zn || "Unknown");
        }
        typeof Te.getDefaultProps == "function" && !Te.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ia(ie) {
      {
        for (var Te = Object.keys(ie.props), nt = 0; nt < Te.length; nt++) {
          var Vt = Te[nt];
          if (Vt !== "children" && Vt !== "key") {
            Yn(ie), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Vt), Yn(null);
            break;
          }
        }
        ie.ref !== null && (Yn(ie), v("Invalid attribute `ref` supplied to `React.Fragment`."), Yn(null));
      }
    }
    var ou = {};
    function au(ie, Te, nt, Vt, Zn, Ze) {
      {
        var re = B(ie);
        if (!re) {
          var Ee = "";
          (ie === void 0 || typeof ie == "object" && ie !== null && Object.keys(ie).length === 0) && (Ee += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = Ec();
          je ? Ee += je : Ee += mo();
          var Ot;
          ie === null ? Ot = "null" : he(ie) ? Ot = "array" : ie !== void 0 && ie.$$typeof === e ? (Ot = "<" + (R(ie.type) || "Unknown") + " />", Ee = " Did you accidentally export a JSX literal instead of a component?") : Ot = typeof ie, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ot, Ee);
        }
        var pn = ti(ie, Te, nt, Zn, Ze);
        if (pn == null)
          return pn;
        if (re) {
          var Li = Te.children;
          if (Li !== void 0)
            if (Vt)
              if (he(Li)) {
                for (var ni = 0; ni < Li.length; ni++)
                  xc(Li[ni], ie);
                Object.freeze && Object.freeze(Li);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xc(Li, ie);
        }
        if (Mn.call(Te, "key")) {
          var Gr = R(ie), Qr = Object.keys(Te).filter(function(dFe) {
            return dFe !== "key";
          }), w2 = Qr.length > 0 ? "{key: someKey, " + Qr.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ou[Gr + w2]) {
            var QH = Qr.length > 0 ? "{" + Qr.join(": ..., ") + ": ...}" : "{}";
            v(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, w2, Gr, QH, Gr), ou[Gr + w2] = !0;
          }
        }
        return ie === n ? Ia(pn) : xm(pn), pn;
      }
    }
    function m2(ie, Te, nt) {
      return au(ie, Te, nt, !0);
    }
    function LC(ie, Te, nt) {
      return au(ie, Te, nt, !1);
    }
    var A2 = LC, xl = m2;
    Mm.Fragment = n, Mm.jsx = A2, Mm.jsxs = xl;
  }()), Mm;
}
var XH;
function yFe() {
  return XH || (XH = 1, process.env.NODE_ENV === "production" ? pv.exports = vFe() : pv.exports = bFe()), pv.exports;
}
var x = yFe(), CFe = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(e, t) {
    return "Cannot apply '" + e + "' to '" + t.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(e, t) {
    return "[mobx.array] Index out of bounds, " + e + " is larger than " + t;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(e) {
    return "Cannot initialize from classes that inherit from Map: " + e.constructor.name;
  },
  20: function(e) {
    return "Cannot initialize map from " + e;
  },
  21: function(e) {
    return "Cannot convert to map from '" + e + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(e) {
    return "Cannot obtain administration from " + e;
  },
  25: function(e, t) {
    return "the entry '" + e + "' does not exist in the observable map '" + t + "'";
  },
  26: "please specify a property",
  27: function(e, t) {
    return "no observable property '" + e.toString() + "' found on the observable object '" + t + "'";
  },
  28: function(e) {
    return "Cannot obtain atom from " + e;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(e, t) {
    return "Cycle detected in computation " + e + ": " + t;
  },
  33: function(e) {
    return "The setter of computed value '" + e + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(e) {
    return "[ComputedValue '" + e + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(e) {
    return "[mobx] `observableArray." + e + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + e + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, EFe = process.env.NODE_ENV !== "production" ? CFe : {};
function Xe(r) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    t[n - 1] = arguments[n];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof r == "string" ? r : EFe[r];
    throw typeof i == "function" && (i = i.apply(null, t)), new Error("[MobX] " + i);
  }
  throw new Error(typeof r == "number" ? "[MobX] minified error nr: " + r + (t.length ? " " + t.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + r);
}
var _Fe = {};
function l7() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : _Fe;
}
var nSe = Object.assign, c8 = Object.getOwnPropertyDescriptor, th = Object.defineProperty, c7 = Object.prototype, h8 = [];
Object.freeze(h8);
var QT = {};
Object.freeze(QT);
var xFe = typeof Proxy < "u", SFe = /* @__PURE__ */ Object.toString();
function iSe() {
  xFe || Xe(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Dm(r) {
  process.env.NODE_ENV !== "production" && Ie.verifyProxies && Xe("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + r);
}
function Ea() {
  return ++Ie.mobxGuid;
}
function KT(r) {
  var e = !1;
  return function() {
    if (!e)
      return e = !0, r.apply(this, arguments);
  };
}
var j2 = function() {
};
function vr(r) {
  return typeof r == "function";
}
function lf(r) {
  var e = typeof r;
  switch (e) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function h7(r) {
  return r !== null && typeof r == "object";
}
function Oo(r) {
  if (!h7(r))
    return !1;
  var e = Object.getPrototypeOf(r);
  if (e == null)
    return !0;
  var t = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t.toString() === SFe;
}
function rSe(r) {
  var e = r?.constructor;
  return e ? e.name === "GeneratorFunction" || e.displayName === "GeneratorFunction" : !1;
}
function iw(r, e, t) {
  th(r, e, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: t
  });
}
function sSe(r, e, t) {
  th(r, e, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: t
  });
}
function Bf(r, e) {
  var t = "isMobX" + r;
  return e.prototype[t] = !0, function(n) {
    return h7(n) && n[t] === !0;
  };
}
function jg(r) {
  return r != null && Object.prototype.toString.call(r) === "[object Map]";
}
function MFe(r) {
  var e = Object.getPrototypeOf(r), t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t);
  return n === null;
}
function nd(r) {
  return r != null && Object.prototype.toString.call(r) === "[object Set]";
}
var oSe = typeof Object.getOwnPropertySymbols < "u";
function DFe(r) {
  var e = Object.keys(r);
  if (!oSe)
    return e;
  var t = Object.getOwnPropertySymbols(r);
  return t.length ? [].concat(e, t.filter(function(n) {
    return c7.propertyIsEnumerable.call(r, n);
  })) : e;
}
var Gp = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : oSe ? function(r) {
  return Object.getOwnPropertyNames(r).concat(Object.getOwnPropertySymbols(r));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function uM(r) {
  return typeof r == "string" ? r : typeof r == "symbol" ? r.toString() : new String(r).toString();
}
function aSe(r) {
  return r === null ? null : typeof r == "object" ? "" + r : r;
}
function fa(r, e) {
  return c7.hasOwnProperty.call(r, e);
}
var LFe = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Gp(e).forEach(function(n) {
    t[n] = c8(e, n);
  }), t;
};
function ia(r, e) {
  return !!(r & e);
}
function ra(r, e, t) {
  return t ? r |= e : r &= ~e, r;
}
function JH(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = Array(e); t < e; t++) n[t] = r[t];
  return n;
}
function kFe(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, TFe(n.key), n);
  }
}
function Zg(r, e, t) {
  return e && kFe(r.prototype, e), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function Z2(r, e) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = IFe(r)) || e) {
    t && (r = t);
    var n = 0;
    return function() {
      return n >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ah() {
  return ah = Object.assign ? Object.assign.bind() : function(r) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (r[n] = t[n]);
    }
    return r;
  }, ah.apply(null, arguments);
}
function lSe(r, e) {
  r.prototype = Object.create(e.prototype), r.prototype.constructor = r, fM(r, e);
}
function fM(r, e) {
  return fM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, fM(r, e);
}
function NFe(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function TFe(r) {
  var e = NFe(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
function IFe(r, e) {
  if (r) {
    if (typeof r == "string") return JH(r, e);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? JH(r, e) : void 0;
  }
}
var So = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Gl(r) {
  function e(t, n) {
    if (sw(n))
      return r.decorate_20223_(t, n);
    rw(t, n, r);
  }
  return Object.assign(e, r);
}
function rw(r, e, t) {
  if (fa(r, So) || iw(r, So, ah({}, r[So])), process.env.NODE_ENV !== "production" && d8(t) && !fa(r[So], e)) {
    var n = r.constructor.name + ".prototype." + e.toString();
    Xe("'" + n + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  OFe(r, t, e), d8(t) || (r[So][e] = t);
}
function OFe(r, e, t) {
  if (process.env.NODE_ENV !== "production" && !d8(e) && fa(r[So], t)) {
    var n = r.constructor.name + ".prototype." + t.toString(), i = r[So][t].annotationType_, s = e.annotationType_;
    Xe("Cannot apply '@" + s + "' to '" + n + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function RFe(r) {
  return fa(r, So) || iw(r, So, ah({}, r[So])), r[So];
}
function sw(r) {
  return typeof r == "object" && typeof r.kind == "string";
}
function d7(r, e) {
  process.env.NODE_ENV !== "production" && !e.includes(r.kind) && Xe("The decorator applied to '" + String(r.name) + "' cannot be used on a " + r.kind + " element");
}
var Bt = /* @__PURE__ */ Symbol("mobx administration"), D1 = /* @__PURE__ */ function() {
  function r(t) {
    t === void 0 && (t = process.env.NODE_ENV !== "production" ? "Atom@" + Ea() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = Gn.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = t;
  }
  var e = r.prototype;
  return e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, e.reportObserved = function() {
    return xSe(this);
  }, e.reportChanged = function() {
    $a(), SSe(this), el();
  }, e.toString = function() {
    return this.name_;
  }, Zg(r, [{
    key: "isBeingObserved",
    get: function() {
      return ia(this.flags_, r.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return ia(this.flags_, r.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return ia(this.flags_, r.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.diffValueMask_, n === 1);
    }
  }]);
}();
D1.isBeingObservedMask_ = 1;
D1.isPendingUnobservationMask_ = 2;
D1.diffValueMask_ = 4;
var YT = /* @__PURE__ */ Bf("Atom", D1);
function cSe(r, e, t) {
  e === void 0 && (e = j2), t === void 0 && (t = j2);
  var n = new D1(r);
  return e !== j2 && Kze(n, e), t !== j2 && ISe(n, t), n;
}
function VFe(r, e) {
  return GSe(r, e);
}
function HFe(r, e) {
  return Object.is ? Object.is(r, e) : r === e ? r !== 0 || 1 / r === 1 / e : r !== r && e !== e;
}
var Qp = {
  structural: VFe,
  default: HFe
};
function cf(r, e, t) {
  return x3(r) ? r : Array.isArray(r) ? $n.array(r, {
    name: t
  }) : Oo(r) ? $n.object(r, void 0, {
    name: t
  }) : jg(r) ? $n.map(r, {
    name: t
  }) : nd(r) ? $n.set(r, {
    name: t
  }) : typeof r == "function" && !Kp(r) && !_3(r) ? rSe(r) ? Yp(r) : E3(t, r) : r;
}
function BFe(r, e, t) {
  if (r == null || Ug(r) || w7(r) || L1(r) || qc(r))
    return r;
  if (Array.isArray(r))
    return $n.array(r, {
      name: t,
      deep: !1
    });
  if (Oo(r))
    return $n.object(r, void 0, {
      name: t,
      deep: !1
    });
  if (jg(r))
    return $n.map(r, {
      name: t,
      deep: !1
    });
  if (nd(r))
    return $n.set(r, {
      name: t,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && Xe("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function u7(r) {
  return r;
}
function PFe(r, e) {
  return process.env.NODE_ENV !== "production" && x3(r) && Xe("observable.struct should not be used with observable values"), GSe(r, e) ? e : r;
}
var hSe = "override", yh = /* @__PURE__ */ Gl({
  annotationType_: hSe,
  make_: FFe,
  extend_: zFe,
  decorate_20223_: WFe
});
function d8(r) {
  return r.annotationType_ === hSe;
}
function FFe(r, e) {
  return process.env.NODE_ENV !== "production" && r.isPlainObject_ && Xe("Cannot apply '" + this.annotationType_ + "' to '" + r.name_ + "." + e.toString() + "':" + (`
'` + this.annotationType_ + "' cannot be used on plain objects.")), process.env.NODE_ENV !== "production" && !fa(r.appliedAnnotations_, e) && Xe("'" + r.name_ + "." + e.toString() + "' is annotated with '" + this.annotationType_ + "', but no such annotated member was found on prototype."), 0;
}
function zFe(r, e, t, n) {
  Xe("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function WFe(r, e) {
  console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function ow(r, e) {
  return {
    annotationType_: r,
    options_: e,
    make_: jFe,
    extend_: ZFe,
    decorate_20223_: UFe
  };
}
function jFe(r, e, t, n) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(r, e, t, !1) === null ? 0 : 1;
  if (n === r.target_)
    return this.extend_(r, e, t, !1) === null ? 0 : 2;
  if (Kp(t.value))
    return 1;
  var s = dSe(r, this, e, t, !1);
  return th(n, e, s), 2;
}
function ZFe(r, e, t, n) {
  var i = dSe(r, this, e, t);
  return r.defineProperty_(e, i, n);
}
function UFe(r, e) {
  process.env.NODE_ENV !== "production" && d7(e, ["method", "field"]);
  var t = e.kind, n = e.name, i = e.addInitializer, s = this, o = function(c) {
    var d, u, f, p;
    return s1((d = (u = s.options_) == null ? void 0 : u.name) != null ? d : n.toString(), c, (f = (p = s.options_) == null ? void 0 : p.autoAction) != null ? f : !1);
  };
  if (t == "field")
    return function(l) {
      var c, d = l;
      return Kp(d) || (d = o(d)), (c = s.options_) != null && c.bound && (d = d.bind(this), d.isMobxAction = !0), d;
    };
  if (t == "method") {
    var a;
    return Kp(r) || (r = o(r)), (a = this.options_) != null && a.bound && i(function() {
      var l = this, c = l[n].bind(l);
      c.isMobxAction = !0, l[n] = c;
    }), r;
  }
  Xe("Cannot apply '" + s.annotationType_ + "' to '" + String(n) + "' (kind: " + t + "):" + (`
'` + s.annotationType_ + "' can only be used on properties with a function value."));
}
function qFe(r, e, t, n) {
  var i = e.annotationType_, s = n.value;
  process.env.NODE_ENV !== "production" && !vr(s) && Xe("Cannot apply '" + i + "' to '" + r.name_ + "." + t.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function dSe(r, e, t, n, i) {
  var s, o, a, l, c, d, u;
  i === void 0 && (i = Ie.safeDescriptors), qFe(r, e, t, n);
  var f = n.value;
  if ((s = e.options_) != null && s.bound) {
    var p;
    f = f.bind((p = r.proxy_) != null ? p : r.target_);
  }
  return {
    value: s1(
      (o = (a = e.options_) == null ? void 0 : a.name) != null ? o : t.toString(),
      f,
      (l = (c = e.options_) == null ? void 0 : c.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (d = e.options_) != null && d.bound ? (u = r.proxy_) != null ? u : r.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? r.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function uSe(r, e) {
  return {
    annotationType_: r,
    options_: e,
    make_: GFe,
    extend_: QFe,
    decorate_20223_: KFe
  };
}
function GFe(r, e, t, n) {
  var i;
  if (n === r.target_)
    return this.extend_(r, e, t, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!fa(r.target_, e) || !_3(r.target_[e])) && this.extend_(r, e, t, !1) === null)
    return 0;
  if (_3(t.value))
    return 1;
  var s = fSe(r, this, e, t, !1, !1);
  return th(n, e, s), 2;
}
function QFe(r, e, t, n) {
  var i, s = fSe(r, this, e, t, (i = this.options_) == null ? void 0 : i.bound);
  return r.defineProperty_(e, s, n);
}
function KFe(r, e) {
  var t;
  process.env.NODE_ENV !== "production" && d7(e, ["method"]);
  var n = e.name, i = e.addInitializer;
  return _3(r) || (r = Yp(r)), (t = this.options_) != null && t.bound && i(function() {
    var s = this, o = s[n].bind(s);
    o.isMobXFlow = !0, s[n] = o;
  }), r;
}
function YFe(r, e, t, n) {
  var i = e.annotationType_, s = n.value;
  process.env.NODE_ENV !== "production" && !vr(s) && Xe("Cannot apply '" + i + "' to '" + r.name_ + "." + t.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function fSe(r, e, t, n, i, s) {
  s === void 0 && (s = Ie.safeDescriptors), YFe(r, e, t, n);
  var o = n.value;
  if (_3(o) || (o = Yp(o)), i) {
    var a;
    o = o.bind((a = r.proxy_) != null ? a : r.target_), o.isMobXFlow = !0;
  }
  return {
    value: o,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: s ? r.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !s
  };
}
function XT(r, e) {
  return {
    annotationType_: r,
    options_: e,
    make_: XFe,
    extend_: JFe,
    decorate_20223_: $Fe
  };
}
function XFe(r, e, t) {
  return this.extend_(r, e, t, !1) === null ? 0 : 1;
}
function JFe(r, e, t, n) {
  return eze(r, this, e, t), r.defineComputedProperty_(e, ah({}, this.options_, {
    get: t.get,
    set: t.set
  }), n);
}
function $Fe(r, e) {
  process.env.NODE_ENV !== "production" && d7(e, ["getter"]);
  var t = this, n = e.name, i = e.addInitializer;
  return i(function() {
    var s = Ff(this)[Bt], o = ah({}, t.options_, {
      get: r,
      context: this
    });
    o.name || (o.name = process.env.NODE_ENV !== "production" ? s.name_ + "." + n.toString() : "ObservableObject." + n.toString()), s.values_.set(n, new dl(o));
  }), function() {
    return this[Bt].getObservablePropValue_(n);
  };
}
function eze(r, e, t, n) {
  var i = e.annotationType_, s = n.get;
  process.env.NODE_ENV !== "production" && !s && Xe("Cannot apply '" + i + "' to '" + r.name_ + "." + t.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function f7(r, e) {
  return {
    annotationType_: r,
    options_: e,
    make_: tze,
    extend_: nze,
    decorate_20223_: ize
  };
}
function tze(r, e, t) {
  return this.extend_(r, e, t, !1) === null ? 0 : 1;
}
function nze(r, e, t, n) {
  var i, s;
  return rze(r, this, e, t), r.defineObservableProperty_(e, t.value, (i = (s = this.options_) == null ? void 0 : s.enhancer) != null ? i : cf, n);
}
function ize(r, e) {
  if (process.env.NODE_ENV !== "production") {
    if (e.kind === "field")
      throw Xe("Please use `@observable accessor " + String(e.name) + "` instead of `@observable " + String(e.name) + "`");
    d7(e, ["accessor"]);
  }
  var t = this, n = e.kind, i = e.name, s = /* @__PURE__ */ new WeakSet();
  function o(a, l) {
    var c, d, u = Ff(a)[Bt], f = new W0(l, (c = (d = t.options_) == null ? void 0 : d.enhancer) != null ? c : cf, process.env.NODE_ENV !== "production" ? u.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    u.values_.set(i, f), s.add(a);
  }
  if (n == "accessor")
    return {
      get: function() {
        return s.has(this) || o(this, r.get.call(this)), this[Bt].getObservablePropValue_(i);
      },
      set: function(l) {
        return s.has(this) || o(this, l), this[Bt].setObservablePropValue_(i, l);
      },
      init: function(l) {
        return s.has(this) || o(this, l), l;
      }
    };
}
function rze(r, e, t, n) {
  var i = e.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in n) && Xe("Cannot apply '" + i + "' to '" + r.name_ + "." + t.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var sze = "true", oze = /* @__PURE__ */ pSe();
function pSe(r) {
  return {
    annotationType_: sze,
    options_: r,
    make_: aze,
    extend_: lze,
    decorate_20223_: cze
  };
}
function aze(r, e, t, n) {
  var i, s;
  if (t.get)
    return qn.make_(r, e, t, n);
  if (t.set) {
    var o = s1(e.toString(), t.set);
    return n === r.target_ ? r.defineProperty_(e, {
      configurable: Ie.safeDescriptors ? r.isPlainObject_ : !0,
      set: o
    }) === null ? 0 : 2 : (th(n, e, {
      configurable: !0,
      set: o
    }), 2);
  }
  if (n !== r.target_ && typeof t.value == "function") {
    var a;
    if (rSe(t.value)) {
      var l, c = (l = this.options_) != null && l.autoBind ? Yp.bound : Yp;
      return c.make_(r, e, t, n);
    }
    var d = (a = this.options_) != null && a.autoBind ? E3.bound : E3;
    return d.make_(r, e, t, n);
  }
  var u = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? $n.ref : $n;
  if (typeof t.value == "function" && (s = this.options_) != null && s.autoBind) {
    var f;
    t.value = t.value.bind((f = r.proxy_) != null ? f : r.target_);
  }
  return u.make_(r, e, t, n);
}
function lze(r, e, t, n) {
  var i, s;
  if (t.get)
    return qn.extend_(r, e, t, n);
  if (t.set)
    return r.defineProperty_(e, {
      configurable: Ie.safeDescriptors ? r.isPlainObject_ : !0,
      set: s1(e.toString(), t.set)
    }, n);
  if (typeof t.value == "function" && (i = this.options_) != null && i.autoBind) {
    var o;
    t.value = t.value.bind((o = r.proxy_) != null ? o : r.target_);
  }
  var a = ((s = this.options_) == null ? void 0 : s.deep) === !1 ? $n.ref : $n;
  return a.extend_(r, e, t, n);
}
function cze(r, e) {
  Xe("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var hze = "observable", dze = "observable.ref", uze = "observable.shallow", fze = "observable.struct", gSe = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(gSe);
function gv(r) {
  return r || gSe;
}
var pM = /* @__PURE__ */ f7(hze), pze = /* @__PURE__ */ f7(dze, {
  enhancer: u7
}), gze = /* @__PURE__ */ f7(uze, {
  enhancer: BFe
}), mze = /* @__PURE__ */ f7(fze, {
  enhancer: PFe
}), mSe = /* @__PURE__ */ Gl(pM);
function mv(r) {
  return r.deep === !0 ? cf : r.deep === !1 ? u7 : wze(r.defaultDecorator);
}
function Aze(r) {
  var e;
  return r ? (e = r.defaultDecorator) != null ? e : pSe(r) : void 0;
}
function wze(r) {
  var e, t;
  return r && (e = (t = r.options_) == null ? void 0 : t.enhancer) != null ? e : cf;
}
function ASe(r, e, t) {
  if (sw(e))
    return pM.decorate_20223_(r, e);
  if (lf(e)) {
    rw(r, e, pM);
    return;
  }
  return x3(r) ? r : Oo(r) ? $n.object(r, e, t) : Array.isArray(r) ? $n.array(r, e) : jg(r) ? $n.map(r, e) : nd(r) ? $n.set(r, e) : typeof r == "object" && r !== null ? r : $n.box(r, e);
}
nSe(ASe, mSe);
var vze = {
  box: function(e, t) {
    var n = gv(t);
    return new W0(e, mv(n), n.name, !0, n.equals);
  },
  array: function(e, t) {
    var n = gv(t);
    return (Ie.useProxies === !1 || n.proxy === !1 ? bWe : hWe)(e, mv(n), n.name);
  },
  map: function(e, t) {
    var n = gv(t);
    return new zSe(e, mv(n), n.name);
  },
  set: function(e, t) {
    var n = gv(t);
    return new WSe(e, mv(n), n.name);
  },
  object: function(e, t, n) {
    return k1(function() {
      return RSe(Ie.useProxies === !1 || n?.proxy === !1 ? Ff({}, n) : aWe({}, n), e, t);
    });
  },
  ref: /* @__PURE__ */ Gl(pze),
  shallow: /* @__PURE__ */ Gl(gze),
  deep: mSe,
  struct: /* @__PURE__ */ Gl(mze)
}, $n = /* @__PURE__ */ nSe(ASe, vze), wSe = "computed", bze = "computed.struct", gM = /* @__PURE__ */ XT(wSe), yze = /* @__PURE__ */ XT(bze, {
  equals: Qp.structural
}), qn = function(e, t) {
  if (sw(t))
    return gM.decorate_20223_(e, t);
  if (lf(t))
    return rw(e, t, gM);
  if (Oo(e))
    return Gl(XT(wSe, e));
  process.env.NODE_ENV !== "production" && (vr(e) || Xe("First argument to `computed` should be an expression."), vr(t) && Xe("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var n = Oo(t) ? t : {};
  return n.get = e, n.name || (n.name = e.name || ""), new dl(n);
};
Object.assign(qn, gM);
qn.struct = /* @__PURE__ */ Gl(yze);
var $H, eB, u8 = 0, Cze = 1, Eze = ($H = (eB = /* @__PURE__ */ c8(function() {
}, "name")) == null ? void 0 : eB.configurable) != null ? $H : !1, tB = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function s1(r, e, t, n) {
  t === void 0 && (t = !1), process.env.NODE_ENV !== "production" && (vr(e) || Xe("`action` can only be invoked on functions"), (typeof r != "string" || !r) && Xe("actions should have valid names, got: '" + r + "'"));
  function i() {
    return _ze(r, t, e, n || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return e.toString();
  }, Eze && (tB.value = r, th(i, "name", tB)), i;
}
function _ze(r, e, t, n, i) {
  var s = xze(r, e, n, i);
  try {
    return t.apply(n, i);
  } catch (o) {
    throw s.error_ = o, o;
  } finally {
    Sze(s);
  }
}
function xze(r, e, t, n) {
  var i = process.env.NODE_ENV !== "production" && bs() && !!r, s = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    s = Date.now();
    var o = n ? Array.from(n) : h8;
    pa({
      type: eI,
      name: r,
      object: t,
      arguments: o
    });
  }
  var a = Ie.trackingDerivation, l = !e || !a;
  $a();
  var c = Ie.allowStateChanges;
  l && (Pf(), c = p7(!0));
  var d = $T(!0), u = {
    runAsAction_: l,
    prevDerivation_: a,
    prevAllowStateChanges_: c,
    prevAllowStateReads_: d,
    notifySpy_: i,
    startTime_: s,
    actionId_: Cze++,
    parentActionId_: u8
  };
  return u8 = u.actionId_, u;
}
function Sze(r) {
  u8 !== r.actionId_ && Xe(30), u8 = r.parentActionId_, r.error_ !== void 0 && (Ie.suppressReactionErrors = !0), g7(r.prevAllowStateChanges_), IA(r.prevAllowStateReads_), el(), r.runAsAction_ && wd(r.prevDerivation_), process.env.NODE_ENV !== "production" && r.notifySpy_ && ga({
    time: Date.now() - r.startTime_
  }), Ie.suppressReactionErrors = !1;
}
function JT(r, e) {
  var t = p7(r);
  try {
    return e();
  } finally {
    g7(t);
  }
}
function p7(r) {
  var e = Ie.allowStateChanges;
  return Ie.allowStateChanges = r, e;
}
function g7(r) {
  Ie.allowStateChanges = r;
}
var Mze = "create", W0 = /* @__PURE__ */ function(r) {
  function e(n, i, s, o, a) {
    var l;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableValue@" + Ea() : "ObservableValue"), o === void 0 && (o = !0), a === void 0 && (a = Qp.default), l = r.call(this, s) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = i, l.name_ = s, l.equals = a, l.value_ = i(n, void 0, s), process.env.NODE_ENV !== "production" && o && bs() && hf({
      type: Mze,
      object: l,
      observableKind: "value",
      debugObjectName: l.name_,
      newValue: "" + l.value_
    }), l;
  }
  lSe(e, r);
  var t = e.prototype;
  return t.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, t.set = function(i) {
    var s = this.value_;
    if (i = this.prepareNewValue_(i), i !== Ie.UNCHANGED) {
      var o = bs();
      process.env.NODE_ENV !== "production" && o && pa({
        type: Fl,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: s
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && o && ga();
    }
  }, t.prepareNewValue_ = function(i) {
    if (Jc(this), Ga(this)) {
      var s = Qa(this, {
        object: this,
        type: Fl,
        newValue: i
      });
      if (!s)
        return Ie.UNCHANGED;
      i = s.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? Ie.UNCHANGED : i;
  }, t.setNewValue_ = function(i) {
    var s = this.value_;
    this.value_ = i, this.reportChanged(), Ql(this) && Kl(this, {
      type: Fl,
      object: this,
      newValue: i,
      oldValue: s
    });
  }, t.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, t.intercept_ = function(i) {
    return aw(this, i);
  }, t.observe_ = function(i, s) {
    return s && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Fl,
      newValue: this.value_,
      oldValue: void 0
    }), lw(this, i);
  }, t.raw = function() {
    return this.value_;
  }, t.toJSON = function() {
    return this.get();
  }, t.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, t.valueOf = function() {
    return aSe(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, e;
}(D1), dl = /* @__PURE__ */ function() {
  function r(t) {
    this.dependenciesState_ = Gn.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Gn.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new f8(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = sl.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, t.get || Xe(31), this.derivation = t.get, this.name_ = t.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + Ea() : "ComputedValue"), t.set && (this.setter_ = s1(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", t.set)), this.equals_ = t.equals || (t.compareStructural || t.struct ? Qp.structural : Qp.default), this.scope_ = t.context, this.requiresReaction_ = t.requiresReaction, this.keepAlive_ = !!t.keepAlive;
  }
  var e = r.prototype;
  return e.onBecomeStale_ = function() {
    Rze(this);
  }, e.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(n) {
      return n();
    });
  }, e.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(n) {
      return n();
    });
  }, e.get = function() {
    if (this.isComputing && Xe(32, this.name_, this.derivation), Ie.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      mM(this) && (this.warnAboutUntrackedRead_(), $a(), this.value_ = this.computeValue_(!1), el());
    else if (xSe(this), mM(this)) {
      var n = Ie.trackingContext;
      this.keepAlive_ && !n && (Ie.trackingContext = this), this.trackAndCompute() && Oze(this), Ie.trackingContext = n;
    }
    var i = this.value_;
    if (o6(i))
      throw i.cause;
    return i;
  }, e.set = function(n) {
    if (this.setter_) {
      this.isRunningSetter && Xe(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, n);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      Xe(34, this.name_);
  }, e.trackAndCompute = function() {
    var n = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === Gn.NOT_TRACKING_
    ), s = this.computeValue_(!0), o = i || o6(n) || o6(s) || !this.equals_(n, s);
    return o && (this.value_ = s, process.env.NODE_ENV !== "production" && bs() && hf({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: n,
      newValue: s
    })), o;
  }, e.computeValue_ = function(n) {
    this.isComputing = !0;
    var i = p7(!1), s;
    if (n)
      s = vSe(this, this.derivation, this.scope_);
    else if (Ie.disableErrorBoundaries === !0)
      s = this.derivation.call(this.scope_);
    else
      try {
        s = this.derivation.call(this.scope_);
      } catch (o) {
        s = new f8(o);
      }
    return g7(i), this.isComputing = !1, s;
  }, e.suspend_ = function() {
    this.keepAlive_ || (AM(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== sl.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, e.observe_ = function(n, i) {
    var s = this, o = !0, a = void 0;
    return A7(function() {
      var l = s.get();
      if (!o || i) {
        var c = Pf();
        n({
          observableKind: "computed",
          debugObjectName: s.name_,
          type: Fl,
          object: s,
          newValue: l,
          oldValue: a
        }), wd(c);
      }
      o = !1, a = l;
    });
  }, e.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== sl.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : Ie.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, e.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, e.valueOf = function() {
    return aSe(this.get());
  }, e[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, Zg(r, [{
    key: "isComputing",
    get: function() {
      return ia(this.flags_, r.isComputingMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isComputingMask_, n);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return ia(this.flags_, r.isRunningSetterMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isRunningSetterMask_, n);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return ia(this.flags_, r.isBeingObservedMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isBeingObservedMask_, n);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return ia(this.flags_, r.isPendingUnobservationMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isPendingUnobservationMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return ia(this.flags_, r.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.diffValueMask_, n === 1);
    }
  }]);
}();
dl.isComputingMask_ = 1;
dl.isRunningSetterMask_ = 2;
dl.isBeingObservedMask_ = 4;
dl.isPendingUnobservationMask_ = 8;
dl.diffValueMask_ = 16;
var m7 = /* @__PURE__ */ Bf("ComputedValue", dl), Gn;
(function(r) {
  r[r.NOT_TRACKING_ = -1] = "NOT_TRACKING_", r[r.UP_TO_DATE_ = 0] = "UP_TO_DATE_", r[r.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", r[r.STALE_ = 2] = "STALE_";
})(Gn || (Gn = {}));
var sl;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.LOG = 1] = "LOG", r[r.BREAK = 2] = "BREAK";
})(sl || (sl = {}));
var f8 = function(e) {
  this.cause = void 0, this.cause = e;
};
function o6(r) {
  return r instanceof f8;
}
function mM(r) {
  switch (r.dependenciesState_) {
    case Gn.UP_TO_DATE_:
      return !1;
    case Gn.NOT_TRACKING_:
    case Gn.STALE_:
      return !0;
    case Gn.POSSIBLY_STALE_: {
      for (var e = $T(!0), t = Pf(), n = r.observing_, i = n.length, s = 0; s < i; s++) {
        var o = n[s];
        if (m7(o)) {
          if (Ie.disableErrorBoundaries)
            o.get();
          else
            try {
              o.get();
            } catch {
              return wd(t), IA(e), !0;
            }
          if (r.dependenciesState_ === Gn.STALE_)
            return wd(t), IA(e), !0;
        }
      }
      return ySe(r), wd(t), IA(e), !1;
    }
  }
}
function Jc(r) {
  if (process.env.NODE_ENV !== "production") {
    var e = r.observers_.size > 0;
    !Ie.allowStateChanges && (e || Ie.enforceActions === "always") && console.warn("[MobX] " + (Ie.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + r.name_);
  }
}
function Dze(r) {
  process.env.NODE_ENV !== "production" && !Ie.allowStateReads && Ie.observableRequiresReaction && console.warn("[mobx] Observable '" + r.name_ + "' being read outside a reactive context.");
}
function vSe(r, e, t) {
  var n = $T(!0);
  ySe(r), r.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    r.runId_ === 0 ? 100 : r.observing_.length
  ), r.unboundDepsCount_ = 0, r.runId_ = ++Ie.runId;
  var i = Ie.trackingDerivation;
  Ie.trackingDerivation = r, Ie.inBatch++;
  var s;
  if (Ie.disableErrorBoundaries === !0)
    s = e.call(t);
  else
    try {
      s = e.call(t);
    } catch (o) {
      s = new f8(o);
    }
  return Ie.inBatch--, Ie.trackingDerivation = i, kze(r), Lze(r), IA(n), s;
}
function Lze(r) {
  process.env.NODE_ENV !== "production" && r.observing_.length === 0 && (typeof r.requiresObservable_ == "boolean" ? r.requiresObservable_ : Ie.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + r.name_ + "' is created/updated without reading any observable value.");
}
function kze(r) {
  for (var e = r.observing_, t = r.observing_ = r.newObserving_, n = Gn.UP_TO_DATE_, i = 0, s = r.unboundDepsCount_, o = 0; o < s; o++) {
    var a = t[o];
    a.diffValue === 0 && (a.diffValue = 1, i !== o && (t[i] = a), i++), a.dependenciesState_ > n && (n = a.dependenciesState_);
  }
  for (t.length = i, r.newObserving_ = null, s = e.length; s--; ) {
    var l = e[s];
    l.diffValue === 0 && ESe(l, r), l.diffValue = 0;
  }
  for (; i--; ) {
    var c = t[i];
    c.diffValue === 1 && (c.diffValue = 0, Ize(c, r));
  }
  n !== Gn.UP_TO_DATE_ && (r.dependenciesState_ = n, r.onBecomeStale_());
}
function AM(r) {
  var e = r.observing_;
  r.observing_ = [];
  for (var t = e.length; t--; )
    ESe(e[t], r);
  r.dependenciesState_ = Gn.NOT_TRACKING_;
}
function bSe(r) {
  var e = Pf();
  try {
    return r();
  } finally {
    wd(e);
  }
}
function Pf() {
  var r = Ie.trackingDerivation;
  return Ie.trackingDerivation = null, r;
}
function wd(r) {
  Ie.trackingDerivation = r;
}
function $T(r) {
  var e = Ie.allowStateReads;
  return Ie.allowStateReads = r, e;
}
function IA(r) {
  Ie.allowStateReads = r;
}
function ySe(r) {
  if (r.dependenciesState_ !== Gn.UP_TO_DATE_) {
    r.dependenciesState_ = Gn.UP_TO_DATE_;
    for (var e = r.observing_, t = e.length; t--; )
      e[t].lowestObserverState_ = Gn.UP_TO_DATE_;
  }
}
var a6 = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, l6 = !0, CSe = !1, Ie = /* @__PURE__ */ function() {
  var r = /* @__PURE__ */ l7();
  return r.__mobxInstanceCount > 0 && !r.__mobxGlobals && (l6 = !1), r.__mobxGlobals && r.__mobxGlobals.version !== new a6().version && (l6 = !1), l6 ? r.__mobxGlobals ? (r.__mobxInstanceCount += 1, r.__mobxGlobals.UNCHANGED || (r.__mobxGlobals.UNCHANGED = {}), r.__mobxGlobals) : (r.__mobxInstanceCount = 1, r.__mobxGlobals = /* @__PURE__ */ new a6()) : (setTimeout(function() {
    CSe || Xe(35);
  }, 1), new a6());
}();
function Nze() {
  if ((Ie.pendingReactions.length || Ie.inBatch || Ie.isRunningReactions) && Xe(36), CSe = !0, l6) {
    var r = l7();
    --r.__mobxInstanceCount === 0 && (r.__mobxGlobals = void 0), Ie = new a6();
  }
}
function Tze() {
  return Ie;
}
function Ize(r, e) {
  r.observers_.add(e), r.lowestObserverState_ > e.dependenciesState_ && (r.lowestObserverState_ = e.dependenciesState_);
}
function ESe(r, e) {
  r.observers_.delete(e), r.observers_.size === 0 && _Se(r);
}
function _Se(r) {
  r.isPendingUnobservation === !1 && (r.isPendingUnobservation = !0, Ie.pendingUnobservations.push(r));
}
function $a() {
  Ie.inBatch++;
}
function el() {
  if (--Ie.inBatch === 0) {
    LSe();
    for (var r = Ie.pendingUnobservations, e = 0; e < r.length; e++) {
      var t = r[e];
      t.isPendingUnobservation = !1, t.observers_.size === 0 && (t.isBeingObserved && (t.isBeingObserved = !1, t.onBUO()), t instanceof dl && t.suspend_());
    }
    Ie.pendingUnobservations = [];
  }
}
function xSe(r) {
  Dze(r);
  var e = Ie.trackingDerivation;
  return e !== null ? (e.runId_ !== r.lastAccessedBy_ && (r.lastAccessedBy_ = e.runId_, e.newObserving_[e.unboundDepsCount_++] = r, !r.isBeingObserved && Ie.trackingContext && (r.isBeingObserved = !0, r.onBO())), r.isBeingObserved) : (r.observers_.size === 0 && Ie.inBatch > 0 && _Se(r), !1);
}
function SSe(r) {
  r.lowestObserverState_ !== Gn.STALE_ && (r.lowestObserverState_ = Gn.STALE_, r.observers_.forEach(function(e) {
    e.dependenciesState_ === Gn.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && e.isTracing_ !== sl.NONE && MSe(e, r), e.onBecomeStale_()), e.dependenciesState_ = Gn.STALE_;
  }));
}
function Oze(r) {
  r.lowestObserverState_ !== Gn.STALE_ && (r.lowestObserverState_ = Gn.STALE_, r.observers_.forEach(function(e) {
    e.dependenciesState_ === Gn.POSSIBLY_STALE_ ? (e.dependenciesState_ = Gn.STALE_, process.env.NODE_ENV !== "production" && e.isTracing_ !== sl.NONE && MSe(e, r)) : e.dependenciesState_ === Gn.UP_TO_DATE_ && (r.lowestObserverState_ = Gn.UP_TO_DATE_);
  }));
}
function Rze(r) {
  r.lowestObserverState_ === Gn.UP_TO_DATE_ && (r.lowestObserverState_ = Gn.POSSIBLY_STALE_, r.observers_.forEach(function(e) {
    e.dependenciesState_ === Gn.UP_TO_DATE_ && (e.dependenciesState_ = Gn.POSSIBLY_STALE_, e.onBecomeStale_());
  }));
}
function MSe(r, e) {
  if (console.log("[mobx.trace] '" + r.name_ + "' is invalidated due to a change in: '" + e.name_ + "'"), r.isTracing_ === sl.BREAK) {
    var t = [];
    DSe(VSe(r), t, 1), new Function(`debugger;
/*
Tracing '` + r.name_ + `'

You are entering this break point because derivation '` + r.name_ + "' is being traced and '" + e.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (r instanceof dl ? r.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + t.join(`
`) + `
*/
    `)();
  }
}
function DSe(r, e, t) {
  if (e.length >= 1e3) {
    e.push("(and many more)");
    return;
  }
  e.push("" + "	".repeat(t - 1) + r.name), r.dependencies && r.dependencies.forEach(function(n) {
    return DSe(n, e, t + 1);
  });
}
var $l = /* @__PURE__ */ function() {
  function r(t, n, i, s) {
    t === void 0 && (t = process.env.NODE_ENV !== "production" ? "Reaction@" + Ea() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = Gn.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = sl.NONE, this.name_ = t, this.onInvalidate_ = n, this.errorHandler_ = i, this.requiresObservable_ = s;
  }
  var e = r.prototype;
  return e.onBecomeStale_ = function() {
    this.schedule_();
  }, e.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, Ie.pendingReactions.push(this), LSe());
  }, e.runReaction_ = function() {
    if (!this.isDisposed) {
      $a(), this.isScheduled = !1;
      var n = Ie.trackingContext;
      if (Ie.trackingContext = this, mM(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && bs() && hf({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      Ie.trackingContext = n, el();
    }
  }, e.track = function(n) {
    if (!this.isDisposed) {
      $a();
      var i = bs(), s;
      process.env.NODE_ENV !== "production" && i && (s = Date.now(), pa({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var o = Ie.trackingContext;
      Ie.trackingContext = this;
      var a = vSe(this, n, void 0);
      Ie.trackingContext = o, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && AM(this), o6(a) && this.reportExceptionInDerivation_(a.cause), process.env.NODE_ENV !== "production" && i && ga({
        time: Date.now() - s
      }), el();
    }
  }, e.reportExceptionInDerivation_ = function(n) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(n, this);
      return;
    }
    if (Ie.disableErrorBoundaries)
      throw n;
    var s = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    Ie.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(s, n), process.env.NODE_ENV !== "production" && bs() && hf({
      type: "error",
      name: this.name_,
      message: s,
      error: "" + n
    }), Ie.globalReactionErrorHandlers.forEach(function(o) {
      return o(n, i);
    });
  }, e.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || ($a(), AM(this), el()));
  }, e.getDisposer_ = function(n) {
    var i = this, s = function o() {
      i.dispose(), n == null || n.removeEventListener == null || n.removeEventListener("abort", o);
    };
    return n == null || n.addEventListener == null || n.addEventListener("abort", s), s[Bt] = this, s;
  }, e.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, e.trace = function(n) {
    n === void 0 && (n = !1), iWe(this, n);
  }, Zg(r, [{
    key: "isDisposed",
    get: function() {
      return ia(this.flags_, r.isDisposedMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isDisposedMask_, n);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return ia(this.flags_, r.isScheduledMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isScheduledMask_, n);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return ia(this.flags_, r.isTrackPendingMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isTrackPendingMask_, n);
    }
  }, {
    key: "isRunning",
    get: function() {
      return ia(this.flags_, r.isRunningMask_);
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.isRunningMask_, n);
    }
  }, {
    key: "diffValue",
    get: function() {
      return ia(this.flags_, r.diffValueMask_) ? 1 : 0;
    },
    set: function(n) {
      this.flags_ = ra(this.flags_, r.diffValueMask_, n === 1);
    }
  }]);
}();
$l.isDisposedMask_ = 1;
$l.isScheduledMask_ = 2;
$l.isTrackPendingMask_ = 4;
$l.isRunningMask_ = 8;
$l.diffValueMask_ = 16;
var nB = 100, wM = function(e) {
  return e();
};
function LSe() {
  Ie.inBatch > 0 || Ie.isRunningReactions || wM(Vze);
}
function Vze() {
  Ie.isRunningReactions = !0;
  for (var r = Ie.pendingReactions, e = 0; r.length > 0; ) {
    ++e === nB && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + nB + " iterations." + (" Probably there is a cycle in the reactive function: " + r[0]) : "[mobx] cycle in reaction: " + r[0]), r.splice(0));
    for (var t = r.splice(0), n = 0, i = t.length; n < i; n++)
      t[n].runReaction_();
  }
  Ie.isRunningReactions = !1;
}
var p8 = /* @__PURE__ */ Bf("Reaction", $l);
function Hze(r) {
  var e = wM;
  wM = function(n) {
    return r(function() {
      return e(n);
    });
  };
}
function bs() {
  return process.env.NODE_ENV !== "production" && !!Ie.spyListeners.length;
}
function hf(r) {
  if (process.env.NODE_ENV !== "production" && Ie.spyListeners.length)
    for (var e = Ie.spyListeners, t = 0, n = e.length; t < n; t++)
      e[t](r);
}
function pa(r) {
  if (process.env.NODE_ENV !== "production") {
    var e = ah({}, r, {
      spyReportStart: !0
    });
    hf(e);
  }
}
var Bze = {
  type: "report-end",
  spyReportEnd: !0
};
function ga(r) {
  process.env.NODE_ENV !== "production" && hf(r ? ah({}, r, {
    type: "report-end",
    spyReportEnd: !0
  }) : Bze);
}
function Pze(r) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (Ie.spyListeners.push(r), KT(function() {
    Ie.spyListeners = Ie.spyListeners.filter(function(e) {
      return e !== r;
    });
  }));
}
var eI = "action", Fze = "action.bound", kSe = "autoAction", zze = "autoAction.bound", Wze = "<unnamed action>", vM = /* @__PURE__ */ ow(eI), jze = /* @__PURE__ */ ow(Fze, {
  bound: !0
}), bM = /* @__PURE__ */ ow(kSe, {
  autoAction: !0
}), Zze = /* @__PURE__ */ ow(zze, {
  autoAction: !0,
  bound: !0
});
function NSe(r) {
  var e = function(n, i) {
    if (vr(n))
      return s1(n.name || Wze, n, r);
    if (vr(i))
      return s1(n, i, r);
    if (sw(i))
      return (r ? bM : vM).decorate_20223_(n, i);
    if (lf(i))
      return rw(n, i, r ? bM : vM);
    if (lf(n))
      return Gl(ow(r ? kSe : eI, {
        name: n,
        autoAction: r
      }));
    process.env.NODE_ENV !== "production" && Xe("Invalid arguments for `action`");
  };
  return e;
}
var Et = /* @__PURE__ */ NSe(!1);
Object.assign(Et, vM);
var E3 = /* @__PURE__ */ NSe(!0);
Object.assign(E3, bM);
Et.bound = /* @__PURE__ */ Gl(jze);
E3.bound = /* @__PURE__ */ Gl(Zze);
function Kp(r) {
  return vr(r) && r.isMobxAction === !0;
}
function A7(r, e) {
  var t, n, i, s;
  e === void 0 && (e = QT), process.env.NODE_ENV !== "production" && (vr(r) || Xe("Autorun expects a function as first argument"), Kp(r) && Xe("Autorun does not accept actions since actions are untrackable"));
  var o = (t = (n = e) == null ? void 0 : n.name) != null ? t : process.env.NODE_ENV !== "production" ? r.name || "Autorun@" + Ea() : "Autorun", a = !e.scheduler && !e.delay, l;
  if (a)
    l = new $l(o, function() {
      this.track(u);
    }, e.onError, e.requiresObservable);
  else {
    var c = TSe(e), d = !1;
    l = new $l(o, function() {
      d || (d = !0, c(function() {
        d = !1, l.isDisposed || l.track(u);
      }));
    }, e.onError, e.requiresObservable);
  }
  function u() {
    r(l);
  }
  return (i = e) != null && (i = i.signal) != null && i.aborted || l.schedule_(), l.getDisposer_((s = e) == null ? void 0 : s.signal);
}
var Uze = function(e) {
  return e();
};
function TSe(r) {
  return r.scheduler ? r.scheduler : r.delay ? function(e) {
    return setTimeout(e, r.delay);
  } : Uze;
}
function ms(r, e, t) {
  var n, i, s;
  t === void 0 && (t = QT), process.env.NODE_ENV !== "production" && ((!vr(r) || !vr(e)) && Xe("First and second argument to reaction should be functions"), Oo(t) || Xe("Third argument of reactions should be an object"));
  var o = (n = t.name) != null ? n : process.env.NODE_ENV !== "production" ? "Reaction@" + Ea() : "Reaction", a = Et(o, t.onError ? qze(t.onError, e) : e), l = !t.scheduler && !t.delay, c = TSe(t), d = !0, u = !1, f, p = t.compareStructural ? Qp.structural : t.equals || Qp.default, g = new $l(o, function() {
    d || l ? m() : u || (u = !0, c(m));
  }, t.onError, t.requiresObservable);
  function m() {
    if (u = !1, !g.isDisposed) {
      var A = !1, w = f;
      g.track(function() {
        var v = JT(!1, function() {
          return r(g);
        });
        A = d || !p(f, v), f = v;
      }), (d && t.fireImmediately || !d && A) && a(f, w, g), d = !1;
    }
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || g.schedule_(), g.getDisposer_((s = t) == null ? void 0 : s.signal);
}
function qze(r, e) {
  return function() {
    try {
      return e.apply(this, arguments);
    } catch (t) {
      r.call(this, t);
    }
  };
}
var Gze = "onBO", Qze = "onBUO";
function Kze(r, e, t) {
  return OSe(Gze, r, e, t);
}
function ISe(r, e, t) {
  return OSe(Qze, r, e, t);
}
function OSe(r, e, t, n) {
  var i = Jp(e), s = vr(n) ? n : t, o = r + "L";
  return i[o] ? i[o].add(s) : i[o] = /* @__PURE__ */ new Set([s]), function() {
    var a = i[o];
    a && (a.delete(s), a.size === 0 && delete i[o]);
  };
}
var Yze = "never", Av = "always", Xze = "observed";
function Jze(r) {
  r.isolateGlobalState === !0 && Nze();
  var e = r.useProxies, t = r.enforceActions;
  if (e !== void 0 && (Ie.useProxies = e === Av ? !0 : e === Yze ? !1 : typeof Proxy < "u"), e === "ifavailable" && (Ie.verifyProxies = !0), t !== void 0) {
    var n = t === Av ? Av : t === Xze;
    Ie.enforceActions = n, Ie.allowStateChanges = !(n === !0 || n === Av);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in r && (Ie[i] = !!r[i]);
  }), Ie.allowStateReads = !Ie.observableRequiresReaction, process.env.NODE_ENV !== "production" && Ie.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), r.reactionScheduler && Hze(r.reactionScheduler);
}
function RSe(r, e, t, n) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && Xe("'extendObservable' expected 2-4 arguments"), typeof r != "object" && Xe("'extendObservable' expects an object as first argument"), L1(r) && Xe("'extendObservable' should not be used on maps, use map.merge instead"), Oo(e) || Xe("'extendObservable' only accepts plain objects as second argument"), (x3(e) || x3(t)) && Xe("Extending an object with another observable (object) is not supported"));
  var i = LFe(e);
  return k1(function() {
    var s = Ff(r, n)[Bt];
    Gp(i).forEach(function(o) {
      s.extend_(
        o,
        i[o],
        // must pass "undefined" for { key: undefined }
        t && o in t ? t[o] : !0
      );
    });
  }), r;
}
function VSe(r, e) {
  return HSe(Jp(r, e));
}
function HSe(r) {
  var e = {
    name: r.name_
  };
  return r.observing_ && r.observing_.length > 0 && (e.dependencies = $ze(r.observing_).map(HSe)), e;
}
function $ze(r) {
  return Array.from(new Set(r));
}
var eWe = 0;
function BSe() {
  this.message = "FLOW_CANCELLED";
}
BSe.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var kC = /* @__PURE__ */ uSe("flow"), tWe = /* @__PURE__ */ uSe("flow.bound", {
  bound: !0
}), Yp = /* @__PURE__ */ Object.assign(function(e, t) {
  if (sw(t))
    return kC.decorate_20223_(e, t);
  if (lf(t))
    return rw(e, t, kC);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && Xe("Flow expects single argument with generator function");
  var n = e, i = n.name || "<unnamed flow>", s = function() {
    var a = this, l = arguments, c = ++eWe, d = Et(i + " - runid: " + c + " - init", n).apply(a, l), u, f = void 0, p = new Promise(function(g, m) {
      var A = 0;
      u = m;
      function w(_) {
        f = void 0;
        var S;
        try {
          S = Et(i + " - runid: " + c + " - yield " + A++, d.next).call(d, _);
        } catch (D) {
          return m(D);
        }
        y(S);
      }
      function v(_) {
        f = void 0;
        var S;
        try {
          S = Et(i + " - runid: " + c + " - yield " + A++, d.throw).call(d, _);
        } catch (D) {
          return m(D);
        }
        y(S);
      }
      function y(_) {
        if (vr(_?.then)) {
          _.then(y, m);
          return;
        }
        return _.done ? g(_.value) : (f = Promise.resolve(_.value), f.then(w, v));
      }
      w(void 0);
    });
    return p.cancel = Et(i + " - runid: " + c + " - cancel", function() {
      try {
        f && iB(f);
        var g = d.return(void 0), m = Promise.resolve(g.value);
        m.then(j2, j2), iB(m), u(new BSe());
      } catch (A) {
        u(A);
      }
    }), p;
  };
  return s.isMobXFlow = !0, s;
}, kC);
Yp.bound = /* @__PURE__ */ Gl(tWe);
function iB(r) {
  vr(r.cancel) && r.cancel();
}
function _3(r) {
  return r?.isMobXFlow === !0;
}
function nWe(r, e) {
  return r ? Ug(r) || !!r[Bt] || YT(r) || p8(r) || m7(r) : !1;
}
function x3(r) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && Xe("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), nWe(r);
}
function iWe() {
  if (process.env.NODE_ENV !== "production") {
    for (var r = !1, e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    typeof t[t.length - 1] == "boolean" && (r = t.pop());
    var i = rWe(t);
    if (!i)
      return Xe("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === sl.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = r ? sl.BREAK : sl.LOG;
  }
}
function rWe(r) {
  switch (r.length) {
    case 0:
      return Ie.trackingDerivation;
    case 1:
      return Jp(r[0]);
    case 2:
      return Jp(r[0], r[1]);
  }
}
function id(r, e) {
  e === void 0 && (e = void 0), $a();
  try {
    return r.apply(e);
  } finally {
    el();
  }
}
function Xp(r, e, t) {
  return arguments.length === 1 || e && typeof e == "object" ? sWe(r, e) : PSe(r, e, {});
}
function PSe(r, e, t) {
  var n;
  if (typeof t.timeout == "number") {
    var i = new Error("WHEN_TIMEOUT");
    n = setTimeout(function() {
      if (!o[Bt].isDisposed)
        if (o(), t.onError)
          t.onError(i);
        else
          throw i;
    }, t.timeout);
  }
  t.name = process.env.NODE_ENV !== "production" ? t.name || "When@" + Ea() : "When";
  var s = s1(process.env.NODE_ENV !== "production" ? t.name + "-effect" : "When-effect", e), o = A7(function(a) {
    var l = JT(!1, r);
    l && (a.dispose(), n && clearTimeout(n), s());
  }, t);
  return o;
}
function sWe(r, e) {
  var t;
  if (process.env.NODE_ENV !== "production" && e && e.onError)
    return Xe("the options 'onError' and 'promise' cannot be combined");
  if (e != null && (t = e.signal) != null && t.aborted)
    return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
      cancel: function() {
        return null;
      }
    });
  var n, i, s = new Promise(function(o, a) {
    var l, c = PSe(r, o, ah({}, e, {
      onError: a
    }));
    n = function() {
      c(), a(new Error("WHEN_CANCELLED"));
    }, i = function() {
      c(), a(new Error("WHEN_ABORTED"));
    }, e == null || (l = e.signal) == null || l.addEventListener == null || l.addEventListener("abort", i);
  }).finally(function() {
    var o;
    return e == null || (o = e.signal) == null || o.removeEventListener == null ? void 0 : o.removeEventListener("abort", i);
  });
  return s.cancel = n, s;
}
function j1(r) {
  return r[Bt];
}
var oWe = {
  has: function(e, t) {
    return process.env.NODE_ENV !== "production" && Ie.trackingDerivation && Dm("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), j1(e).has_(t);
  },
  get: function(e, t) {
    return j1(e).get_(t);
  },
  set: function(e, t, n) {
    var i;
    return lf(t) ? (process.env.NODE_ENV !== "production" && !j1(e).values_.has(t) && Dm("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = j1(e).set_(t, n, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(e, t) {
    var n;
    return process.env.NODE_ENV !== "production" && Dm("delete properties from an observable object. Use 'remove' from 'mobx' instead."), lf(t) ? (n = j1(e).delete_(t, !0)) != null ? n : !0 : !1;
  },
  defineProperty: function(e, t, n) {
    var i;
    return process.env.NODE_ENV !== "production" && Dm("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = j1(e).defineProperty_(t, n)) != null ? i : !0;
  },
  ownKeys: function(e) {
    return process.env.NODE_ENV !== "production" && Ie.trackingDerivation && Dm("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), j1(e).ownKeys_();
  },
  preventExtensions: function(e) {
    Xe(13);
  }
};
function aWe(r, e) {
  var t, n;
  return iSe(), r = Ff(r, e), (n = (t = r[Bt]).proxy_) != null ? n : t.proxy_ = new Proxy(r, oWe);
}
function Ga(r) {
  return r.interceptors_ !== void 0 && r.interceptors_.length > 0;
}
function aw(r, e) {
  var t = r.interceptors_ || (r.interceptors_ = []);
  return t.push(e), KT(function() {
    var n = t.indexOf(e);
    n !== -1 && t.splice(n, 1);
  });
}
function Qa(r, e) {
  var t = Pf();
  try {
    for (var n = [].concat(r.interceptors_ || []), i = 0, s = n.length; i < s && (e = n[i](e), e && !e.type && Xe(14), !!e); i++)
      ;
    return e;
  } finally {
    wd(t);
  }
}
function Ql(r) {
  return r.changeListeners_ !== void 0 && r.changeListeners_.length > 0;
}
function lw(r, e) {
  var t = r.changeListeners_ || (r.changeListeners_ = []);
  return t.push(e), KT(function() {
    var n = t.indexOf(e);
    n !== -1 && t.splice(n, 1);
  });
}
function Kl(r, e) {
  var t = Pf(), n = r.changeListeners_;
  if (n) {
    n = n.slice();
    for (var i = 0, s = n.length; i < s; i++)
      n[i](e);
    wd(t);
  }
}
function xs(r, e, t) {
  return k1(function() {
    var n, i = Ff(r, t)[Bt];
    process.env.NODE_ENV !== "production" && e && r[So] && Xe("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (n = e) != null || (e = RFe(r)), Gp(e).forEach(function(s) {
      return i.make_(s, e[s]);
    });
  }), r;
}
var NC = /* @__PURE__ */ Symbol("mobx-keys");
function Hi(r, e, t) {
  return process.env.NODE_ENV !== "production" && (!Oo(r) && !Oo(Object.getPrototypeOf(r)) && Xe("'makeAutoObservable' can only be used for classes that don't have a superclass"), Ug(r) && Xe("makeAutoObservable can only be used on objects not already made observable")), Oo(r) ? RSe(r, r, e, t) : (k1(function() {
    var n = Ff(r, t)[Bt];
    if (!r[NC]) {
      var i = Object.getPrototypeOf(r), s = new Set([].concat(Gp(r), Gp(i)));
      s.delete("constructor"), s.delete(Bt), iw(i, NC, s);
    }
    r[NC].forEach(function(o) {
      return n.make_(
        o,
        // must pass "undefined" for { key: undefined }
        e && o in e ? e[o] : !0
      );
    });
  }), r);
}
var rB = "splice", Fl = "update", lWe = 1e4, cWe = {
  get: function(e, t) {
    var n = e[Bt];
    return t === Bt ? n : t === "length" ? n.getArrayLength_() : typeof t == "string" && !isNaN(t) ? n.get_(parseInt(t)) : fa(g8, t) ? g8[t] : e[t];
  },
  set: function(e, t, n) {
    var i = e[Bt];
    return t === "length" && i.setArrayLength_(n), typeof t == "symbol" || isNaN(t) ? e[t] = n : i.set_(parseInt(t), n), !0;
  },
  preventExtensions: function() {
    Xe(15);
  }
}, tI = /* @__PURE__ */ function() {
  function r(t, n, i, s) {
    t === void 0 && (t = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ea() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = s, this.atom_ = new D1(t), this.enhancer_ = function(o, a) {
      return n(o, a, process.env.NODE_ENV !== "production" ? t + "[..]" : "ObservableArray[..]");
    };
  }
  var e = r.prototype;
  return e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.dehanceValues_ = function(n) {
    return this.dehancer !== void 0 && n.length > 0 ? n.map(this.dehancer) : n;
  }, e.intercept_ = function(n) {
    return aw(this, n);
  }, e.observe_ = function(n, i) {
    return i === void 0 && (i = !1), i && n({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), lw(this, n);
  }, e.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, e.setArrayLength_ = function(n) {
    (typeof n != "number" || isNaN(n) || n < 0) && Xe("Out of range: " + n);
    var i = this.values_.length;
    if (n !== i)
      if (n > i) {
        for (var s = new Array(n - i), o = 0; o < n - i; o++)
          s[o] = void 0;
        this.spliceWithArray_(i, 0, s);
      } else
        this.spliceWithArray_(n, i - n);
  }, e.updateArrayLength_ = function(n, i) {
    n !== this.lastKnownLength_ && Xe(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && USe(n + i + 1);
  }, e.spliceWithArray_ = function(n, i, s) {
    var o = this;
    Jc(this.atom_);
    var a = this.values_.length;
    if (n === void 0 ? n = 0 : n > a ? n = a : n < 0 && (n = Math.max(0, a + n)), arguments.length === 1 ? i = a - n : i == null ? i = 0 : i = Math.max(0, Math.min(i, a - n)), s === void 0 && (s = h8), Ga(this)) {
      var l = Qa(this, {
        object: this.proxy_,
        type: rB,
        index: n,
        removedCount: i,
        added: s
      });
      if (!l)
        return h8;
      i = l.removedCount, s = l.added;
    }
    if (s = s.length === 0 ? s : s.map(function(u) {
      return o.enhancer_(u, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var c = s.length - i;
      this.updateArrayLength_(a, c);
    }
    var d = this.spliceItemsIntoValues_(n, i, s);
    return (i !== 0 || s.length !== 0) && this.notifyArraySplice_(n, s, d), this.dehanceValues_(d);
  }, e.spliceItemsIntoValues_ = function(n, i, s) {
    if (s.length < lWe) {
      var o;
      return (o = this.values_).splice.apply(o, [n, i].concat(s));
    } else {
      var a = this.values_.slice(n, n + i), l = this.values_.slice(n + i);
      this.values_.length += s.length - i;
      for (var c = 0; c < s.length; c++)
        this.values_[n + c] = s[c];
      for (var d = 0; d < l.length; d++)
        this.values_[n + s.length + d] = l[d];
      return a;
    }
  }, e.notifyArrayChildUpdate_ = function(n, i, s) {
    var o = !this.owned_ && bs(), a = Ql(this), l = a || o ? {
      observableKind: "array",
      object: this.proxy_,
      type: Fl,
      debugObjectName: this.atom_.name_,
      index: n,
      newValue: i,
      oldValue: s
    } : null;
    process.env.NODE_ENV !== "production" && o && pa(l), this.atom_.reportChanged(), a && Kl(this, l), process.env.NODE_ENV !== "production" && o && ga();
  }, e.notifyArraySplice_ = function(n, i, s) {
    var o = !this.owned_ && bs(), a = Ql(this), l = a || o ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: rB,
      index: n,
      removed: s,
      added: i,
      removedCount: s.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && o && pa(l), this.atom_.reportChanged(), a && Kl(this, l), process.env.NODE_ENV !== "production" && o && ga();
  }, e.get_ = function(n) {
    if (this.legacyMode_ && n >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + n + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + n);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[n]);
  }, e.set_ = function(n, i) {
    var s = this.values_;
    if (this.legacyMode_ && n > s.length && Xe(17, n, s.length), n < s.length) {
      Jc(this.atom_);
      var o = s[n];
      if (Ga(this)) {
        var a = Qa(this, {
          type: Fl,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: n,
          newValue: i
        });
        if (!a)
          return;
        i = a.newValue;
      }
      i = this.enhancer_(i, o);
      var l = i !== o;
      l && (s[n] = i, this.notifyArrayChildUpdate_(n, i, o));
    } else {
      for (var c = new Array(n + 1 - s.length), d = 0; d < c.length - 1; d++)
        c[d] = void 0;
      c[c.length - 1] = i, this.spliceWithArray_(s.length, 0, c);
    }
  }, r;
}();
function hWe(r, e, t, n) {
  return t === void 0 && (t = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ea() : "ObservableArray"), n === void 0 && (n = !1), iSe(), k1(function() {
    var i = new tI(t, e, n, !1);
    sSe(i.values_, Bt, i);
    var s = new Proxy(i.values_, cWe);
    return i.proxy_ = s, r && r.length && i.spliceWithArray_(0, 0, r), s;
  });
}
var g8 = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(e) {
    var t = this[Bt];
    return t.spliceWithArray_(0, t.values_.length, e);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(e, t) {
    for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
      i[s - 2] = arguments[s];
    var o = this[Bt];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return o.spliceWithArray_(e);
      case 2:
        return o.spliceWithArray_(e, t);
    }
    return o.spliceWithArray_(e, t, i);
  },
  spliceWithArray: function(e, t, n) {
    return this[Bt].spliceWithArray_(e, t, n);
  },
  push: function() {
    for (var e = this[Bt], t = arguments.length, n = new Array(t), i = 0; i < t; i++)
      n[i] = arguments[i];
    return e.spliceWithArray_(e.values_.length, 0, n), e.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Bt].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var e = this[Bt], t = arguments.length, n = new Array(t), i = 0; i < t; i++)
      n[i] = arguments[i];
    return e.spliceWithArray_(0, 0, n), e.values_.length;
  },
  reverse: function() {
    return Ie.trackingDerivation && Xe(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    Ie.trackingDerivation && Xe(37, "sort");
    var e = this.slice();
    return e.sort.apply(e, arguments), this.replace(e), this;
  },
  remove: function(e) {
    var t = this[Bt], n = t.dehanceValues_(t.values_).indexOf(e);
    return n > -1 ? (this.splice(n, 1), !0) : !1;
  }
};
Di("at", _a);
Di("concat", _a);
Di("flat", _a);
Di("includes", _a);
Di("indexOf", _a);
Di("join", _a);
Di("lastIndexOf", _a);
Di("slice", _a);
Di("toString", _a);
Di("toLocaleString", _a);
Di("toSorted", _a);
Di("toSpliced", _a);
Di("with", _a);
Di("every", uc);
Di("filter", uc);
Di("find", uc);
Di("findIndex", uc);
Di("findLast", uc);
Di("findLastIndex", uc);
Di("flatMap", uc);
Di("forEach", uc);
Di("map", uc);
Di("some", uc);
Di("toReversed", uc);
Di("reduce", FSe);
Di("reduceRight", FSe);
function Di(r, e) {
  typeof Array.prototype[r] == "function" && (g8[r] = e(r));
}
function _a(r) {
  return function() {
    var e = this[Bt];
    e.atom_.reportObserved();
    var t = e.dehanceValues_(e.values_);
    return t[r].apply(t, arguments);
  };
}
function uc(r) {
  return function(e, t) {
    var n = this, i = this[Bt];
    i.atom_.reportObserved();
    var s = i.dehanceValues_(i.values_);
    return s[r](function(o, a) {
      return e.call(t, o, a, n);
    });
  };
}
function FSe(r) {
  return function() {
    var e = this, t = this[Bt];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_), i = arguments[0];
    return arguments[0] = function(s, o, a) {
      return i(s, o, a, e);
    }, n[r].apply(n, arguments);
  };
}
var dWe = /* @__PURE__ */ Bf("ObservableArrayAdministration", tI);
function w7(r) {
  return h7(r) && dWe(r[Bt]);
}
var uWe = {}, Nu = "add", m8 = "delete", zSe = /* @__PURE__ */ function() {
  function r(t, n, i) {
    var s = this;
    n === void 0 && (n = cf), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + Ea() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Bt] = uWe, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = n, this.name_ = i, vr(Map) || Xe(18), k1(function() {
      s.keysAtom_ = cSe(process.env.NODE_ENV !== "production" ? s.name_ + ".keys()" : "ObservableMap.keys()"), s.data_ = /* @__PURE__ */ new Map(), s.hasMap_ = /* @__PURE__ */ new Map(), t && s.merge(t);
    });
  }
  var e = r.prototype;
  return e.has_ = function(n) {
    return this.data_.has(n);
  }, e.has = function(n) {
    var i = this;
    if (!Ie.trackingDerivation)
      return this.has_(n);
    var s = this.hasMap_.get(n);
    if (!s) {
      var o = s = new W0(this.has_(n), u7, process.env.NODE_ENV !== "production" ? this.name_ + "." + uM(n) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(n, o), ISe(o, function() {
        return i.hasMap_.delete(n);
      });
    }
    return s.get();
  }, e.set = function(n, i) {
    var s = this.has_(n);
    if (Ga(this)) {
      var o = Qa(this, {
        type: s ? Fl : Nu,
        object: this,
        newValue: i,
        name: n
      });
      if (!o)
        return this;
      i = o.newValue;
    }
    return s ? this.updateValue_(n, i) : this.addValue_(n, i), this;
  }, e.delete = function(n) {
    var i = this;
    if (Jc(this.keysAtom_), Ga(this)) {
      var s = Qa(this, {
        type: m8,
        object: this,
        name: n
      });
      if (!s)
        return !1;
    }
    if (this.has_(n)) {
      var o = bs(), a = Ql(this), l = a || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: m8,
        object: this,
        oldValue: this.data_.get(n).value_,
        name: n
      } : null;
      return process.env.NODE_ENV !== "production" && o && pa(l), id(function() {
        var c;
        i.keysAtom_.reportChanged(), (c = i.hasMap_.get(n)) == null || c.setNewValue_(!1);
        var d = i.data_.get(n);
        d.setNewValue_(void 0), i.data_.delete(n);
      }), a && Kl(this, l), process.env.NODE_ENV !== "production" && o && ga(), !0;
    }
    return !1;
  }, e.updateValue_ = function(n, i) {
    var s = this.data_.get(n);
    if (i = s.prepareNewValue_(i), i !== Ie.UNCHANGED) {
      var o = bs(), a = Ql(this), l = a || o ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Fl,
        object: this,
        oldValue: s.value_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && o && pa(l), s.setNewValue_(i), a && Kl(this, l), process.env.NODE_ENV !== "production" && o && ga();
    }
  }, e.addValue_ = function(n, i) {
    var s = this;
    Jc(this.keysAtom_), id(function() {
      var c, d = new W0(i, s.enhancer_, process.env.NODE_ENV !== "production" ? s.name_ + "." + uM(n) : "ObservableMap.key", !1);
      s.data_.set(n, d), i = d.value_, (c = s.hasMap_.get(n)) == null || c.setNewValue_(!0), s.keysAtom_.reportChanged();
    });
    var o = bs(), a = Ql(this), l = a || o ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: Nu,
      object: this,
      name: n,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && o && pa(l), a && Kl(this, l), process.env.NODE_ENV !== "production" && o && ga();
  }, e.get = function(n) {
    return this.has(n) ? this.dehanceValue_(this.data_.get(n).get()) : this.dehanceValue_(void 0);
  }, e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, e.values = function() {
    var n = this, i = this.keys();
    return sB({
      next: function() {
        var o = i.next(), a = o.done, l = o.value;
        return {
          done: a,
          value: a ? void 0 : n.get(l)
        };
      }
    });
  }, e.entries = function() {
    var n = this, i = this.keys();
    return sB({
      next: function() {
        var o = i.next(), a = o.done, l = o.value;
        return {
          done: a,
          value: a ? void 0 : [l, n.get(l)]
        };
      }
    });
  }, e[Symbol.iterator] = function() {
    return this.entries();
  }, e.forEach = function(n, i) {
    for (var s = Z2(this), o; !(o = s()).done; ) {
      var a = o.value, l = a[0], c = a[1];
      n.call(i, c, l, this);
    }
  }, e.merge = function(n) {
    var i = this;
    return L1(n) && (n = new Map(n)), id(function() {
      Oo(n) ? DFe(n).forEach(function(s) {
        return i.set(s, n[s]);
      }) : Array.isArray(n) ? n.forEach(function(s) {
        var o = s[0], a = s[1];
        return i.set(o, a);
      }) : jg(n) ? (MFe(n) || Xe(19, n), n.forEach(function(s, o) {
        return i.set(o, s);
      })) : n != null && Xe(20, n);
    }), this;
  }, e.clear = function() {
    var n = this;
    id(function() {
      bSe(function() {
        for (var i = Z2(n.keys()), s; !(s = i()).done; ) {
          var o = s.value;
          n.delete(o);
        }
      });
    });
  }, e.replace = function(n) {
    var i = this;
    return id(function() {
      for (var s = fWe(n), o = /* @__PURE__ */ new Map(), a = !1, l = Z2(i.data_.keys()), c; !(c = l()).done; ) {
        var d = c.value;
        if (!s.has(d)) {
          var u = i.delete(d);
          if (u)
            a = !0;
          else {
            var f = i.data_.get(d);
            o.set(d, f);
          }
        }
      }
      for (var p = Z2(s.entries()), g; !(g = p()).done; ) {
        var m = g.value, A = m[0], w = m[1], v = i.data_.has(A);
        if (i.set(A, w), i.data_.has(A)) {
          var y = i.data_.get(A);
          o.set(A, y), v || (a = !0);
        }
      }
      if (!a)
        if (i.data_.size !== o.size)
          i.keysAtom_.reportChanged();
        else
          for (var _ = i.data_.keys(), S = o.keys(), D = _.next(), M = S.next(); !D.done; ) {
            if (D.value !== M.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            D = _.next(), M = S.next();
          }
      i.data_ = o;
    }), this;
  }, e.toString = function() {
    return "[object ObservableMap]";
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Xe("`observe` doesn't support fireImmediately=true in combination with maps."), lw(this, n);
  }, e.intercept_ = function(n) {
    return aw(this, n);
  }, Zg(r, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
}(), L1 = /* @__PURE__ */ Bf("ObservableMap", zSe);
function sB(r) {
  return r[Symbol.toStringTag] = "MapIterator", iI(r);
}
function fWe(r) {
  if (jg(r) || L1(r))
    return r;
  if (Array.isArray(r))
    return new Map(r);
  if (Oo(r)) {
    var e = /* @__PURE__ */ new Map();
    for (var t in r)
      e.set(t, r[t]);
    return e;
  } else
    return Xe(21, r);
}
var pWe = {}, WSe = /* @__PURE__ */ function() {
  function r(t, n, i) {
    var s = this;
    n === void 0 && (n = cf), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + Ea() : "ObservableSet"), this.name_ = void 0, this[Bt] = pWe, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, vr(Set) || Xe(22), this.enhancer_ = function(o, a) {
      return n(o, a, i);
    }, k1(function() {
      s.atom_ = cSe(s.name_), t && s.replace(t);
    });
  }
  var e = r.prototype;
  return e.dehanceValue_ = function(n) {
    return this.dehancer !== void 0 ? this.dehancer(n) : n;
  }, e.clear = function() {
    var n = this;
    id(function() {
      bSe(function() {
        for (var i = Z2(n.data_.values()), s; !(s = i()).done; ) {
          var o = s.value;
          n.delete(o);
        }
      });
    });
  }, e.forEach = function(n, i) {
    for (var s = Z2(this), o; !(o = s()).done; ) {
      var a = o.value;
      n.call(i, a, a, this);
    }
  }, e.add = function(n) {
    var i = this;
    if (Jc(this.atom_), Ga(this)) {
      var s = Qa(this, {
        type: Nu,
        object: this,
        newValue: n
      });
      if (!s)
        return this;
      n = s.newValue;
    }
    if (!this.has(n)) {
      id(function() {
        i.data_.add(i.enhancer_(n, void 0)), i.atom_.reportChanged();
      });
      var o = process.env.NODE_ENV !== "production" && bs(), a = Ql(this), l = a || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Nu,
        object: this,
        newValue: n
      } : null;
      o && process.env.NODE_ENV !== "production" && pa(l), a && Kl(this, l), o && process.env.NODE_ENV !== "production" && ga();
    }
    return this;
  }, e.delete = function(n) {
    var i = this;
    if (Ga(this)) {
      var s = Qa(this, {
        type: m8,
        object: this,
        oldValue: n
      });
      if (!s)
        return !1;
    }
    if (this.has(n)) {
      var o = process.env.NODE_ENV !== "production" && bs(), a = Ql(this), l = a || o ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: m8,
        object: this,
        oldValue: n
      } : null;
      return o && process.env.NODE_ENV !== "production" && pa(l), id(function() {
        i.atom_.reportChanged(), i.data_.delete(n);
      }), a && Kl(this, l), o && process.env.NODE_ENV !== "production" && ga(), !0;
    }
    return !1;
  }, e.has = function(n) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(n));
  }, e.entries = function() {
    var n = this.values();
    return oB({
      next: function() {
        var s = n.next(), o = s.value, a = s.done;
        return a ? {
          value: void 0,
          done: a
        } : {
          value: [o, o],
          done: a
        };
      }
    });
  }, e.keys = function() {
    return this.values();
  }, e.values = function() {
    this.atom_.reportObserved();
    var n = this, i = this.data_.values();
    return oB({
      next: function() {
        var o = i.next(), a = o.value, l = o.done;
        return l ? {
          value: void 0,
          done: l
        } : {
          value: n.dehanceValue_(a),
          done: l
        };
      }
    });
  }, e.intersection = function(n) {
    if (nd(n) && !qc(n))
      return n.intersection(this);
    var i = new Set(this);
    return i.intersection(n);
  }, e.union = function(n) {
    if (nd(n) && !qc(n))
      return n.union(this);
    var i = new Set(this);
    return i.union(n);
  }, e.difference = function(n) {
    return new Set(this).difference(n);
  }, e.symmetricDifference = function(n) {
    if (nd(n) && !qc(n))
      return n.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(n);
  }, e.isSubsetOf = function(n) {
    return new Set(this).isSubsetOf(n);
  }, e.isSupersetOf = function(n) {
    return new Set(this).isSupersetOf(n);
  }, e.isDisjointFrom = function(n) {
    if (nd(n) && !qc(n))
      return n.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(n);
  }, e.replace = function(n) {
    var i = this;
    return qc(n) && (n = new Set(n)), id(function() {
      Array.isArray(n) ? (i.clear(), n.forEach(function(s) {
        return i.add(s);
      })) : nd(n) ? (i.clear(), n.forEach(function(s) {
        return i.add(s);
      })) : n != null && Xe("Cannot initialize set from " + n);
    }), this;
  }, e.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Xe("`observe` doesn't support fireImmediately=true in combination with sets."), lw(this, n);
  }, e.intercept_ = function(n) {
    return aw(this, n);
  }, e.toJSON = function() {
    return Array.from(this);
  }, e.toString = function() {
    return "[object ObservableSet]";
  }, e[Symbol.iterator] = function() {
    return this.values();
  }, Zg(r, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
}(), qc = /* @__PURE__ */ Bf("ObservableSet", WSe);
function oB(r) {
  return r[Symbol.toStringTag] = "SetIterator", iI(r);
}
var aB = /* @__PURE__ */ Object.create(null), lB = "remove", yM = /* @__PURE__ */ function() {
  function r(t, n, i, s) {
    n === void 0 && (n = /* @__PURE__ */ new Map()), s === void 0 && (s = oze), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = t, this.values_ = n, this.name_ = i, this.defaultAnnotation_ = s, this.keysAtom_ = new D1(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = Oo(this.target_), process.env.NODE_ENV !== "production" && !QSe(this.defaultAnnotation_) && Xe("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var e = r.prototype;
  return e.getObservablePropValue_ = function(n) {
    return this.values_.get(n).get();
  }, e.setObservablePropValue_ = function(n, i) {
    var s = this.values_.get(n);
    if (s instanceof dl)
      return s.set(i), !0;
    if (Ga(this)) {
      var o = Qa(this, {
        type: Fl,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: i
      });
      if (!o)
        return null;
      i = o.newValue;
    }
    if (i = s.prepareNewValue_(i), i !== Ie.UNCHANGED) {
      var a = Ql(this), l = process.env.NODE_ENV !== "production" && bs(), c = a || l ? {
        type: Fl,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && l && pa(c), s.setNewValue_(i), a && Kl(this, c), process.env.NODE_ENV !== "production" && l && ga();
    }
    return !0;
  }, e.get_ = function(n) {
    return Ie.trackingDerivation && !fa(this.target_, n) && this.has_(n), this.target_[n];
  }, e.set_ = function(n, i, s) {
    return s === void 0 && (s = !1), fa(this.target_, n) ? this.values_.has(n) ? this.setObservablePropValue_(n, i) : s ? Reflect.set(this.target_, n, i) : (this.target_[n] = i, !0) : this.extend_(n, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, s);
  }, e.has_ = function(n) {
    if (!Ie.trackingDerivation)
      return n in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(n);
    return i || (i = new W0(n in this.target_, u7, process.env.NODE_ENV !== "production" ? this.name_ + "." + uM(n) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(n, i)), i.get();
  }, e.make_ = function(n, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (dB(this, i, n), !(n in this.target_)) {
        var s;
        if ((s = this.target_[So]) != null && s[n])
          return;
        Xe(1, i.annotationType_, this.name_ + "." + n.toString());
      }
      for (var o = this.target_; o && o !== c7; ) {
        var a = c8(o, n);
        if (a) {
          var l = i.make_(this, n, a, o);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        o = Object.getPrototypeOf(o);
      }
      hB(this, i, n);
    }
  }, e.extend_ = function(n, i, s, o) {
    if (o === void 0 && (o = !1), s === !0 && (s = this.defaultAnnotation_), s === !1)
      return this.defineProperty_(n, i, o);
    dB(this, s, n);
    var a = s.extend_(this, n, i, o);
    return a && hB(this, s, n), a;
  }, e.defineProperty_ = function(n, i, s) {
    s === void 0 && (s = !1), Jc(this.keysAtom_);
    try {
      $a();
      var o = this.delete_(n);
      if (!o)
        return o;
      if (Ga(this)) {
        var a = Qa(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Nu,
          newValue: i.value
        });
        if (!a)
          return null;
        var l = a.newValue;
        i.value !== l && (i = ah({}, i, {
          value: l
        }));
      }
      if (s) {
        if (!Reflect.defineProperty(this.target_, n, i))
          return !1;
      } else
        th(this.target_, n, i);
      this.notifyPropertyAddition_(n, i.value);
    } finally {
      el();
    }
    return !0;
  }, e.defineObservableProperty_ = function(n, i, s, o) {
    o === void 0 && (o = !1), Jc(this.keysAtom_);
    try {
      $a();
      var a = this.delete_(n);
      if (!a)
        return a;
      if (Ga(this)) {
        var l = Qa(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Nu,
          newValue: i
        });
        if (!l)
          return null;
        i = l.newValue;
      }
      var c = cB(n), d = {
        configurable: Ie.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: c.get,
        set: c.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, n, d))
          return !1;
      } else
        th(this.target_, n, d);
      var u = new W0(i, s, process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key", !1);
      this.values_.set(n, u), this.notifyPropertyAddition_(n, u.value_);
    } finally {
      el();
    }
    return !0;
  }, e.defineComputedProperty_ = function(n, i, s) {
    s === void 0 && (s = !1), Jc(this.keysAtom_);
    try {
      $a();
      var o = this.delete_(n);
      if (!o)
        return o;
      if (Ga(this)) {
        var a = Qa(this, {
          object: this.proxy_ || this.target_,
          name: n,
          type: Nu,
          newValue: void 0
        });
        if (!a)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + n.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var l = cB(n), c = {
        configurable: Ie.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (s) {
        if (!Reflect.defineProperty(this.target_, n, c))
          return !1;
      } else
        th(this.target_, n, c);
      this.values_.set(n, new dl(i)), this.notifyPropertyAddition_(n, void 0);
    } finally {
      el();
    }
    return !0;
  }, e.delete_ = function(n, i) {
    if (i === void 0 && (i = !1), Jc(this.keysAtom_), !fa(this.target_, n))
      return !0;
    if (Ga(this)) {
      var s = Qa(this, {
        object: this.proxy_ || this.target_,
        name: n,
        type: lB
      });
      if (!s)
        return null;
    }
    try {
      var o;
      $a();
      var a = Ql(this), l = process.env.NODE_ENV !== "production" && bs(), c = this.values_.get(n), d = void 0;
      if (!c && (a || l)) {
        var u;
        d = (u = c8(this.target_, n)) == null ? void 0 : u.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, n))
          return !1;
      } else
        delete this.target_[n];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[n], c && (this.values_.delete(n), c instanceof W0 && (d = c.value_), SSe(c)), this.keysAtom_.reportChanged(), (o = this.pendingKeys_) == null || (o = o.get(n)) == null || o.set(n in this.target_), a || l) {
        var f = {
          type: lB,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: d,
          name: n
        };
        process.env.NODE_ENV !== "production" && l && pa(f), a && Kl(this, f), process.env.NODE_ENV !== "production" && l && ga();
      }
    } finally {
      el();
    }
    return !0;
  }, e.observe_ = function(n, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Xe("`observe` doesn't support the fire immediately property for observable objects."), lw(this, n);
  }, e.intercept_ = function(n) {
    return aw(this, n);
  }, e.notifyPropertyAddition_ = function(n, i) {
    var s, o = Ql(this), a = process.env.NODE_ENV !== "production" && bs();
    if (o || a) {
      var l = o || a ? {
        type: Nu,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: n,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && pa(l), o && Kl(this, l), process.env.NODE_ENV !== "production" && a && ga();
    }
    (s = this.pendingKeys_) == null || (s = s.get(n)) == null || s.set(!0), this.keysAtom_.reportChanged();
  }, e.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Gp(this.target_);
  }, e.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, r;
}();
function Ff(r, e) {
  var t;
  if (process.env.NODE_ENV !== "production" && e && Ug(r) && Xe("Options can't be provided for already observable objects."), fa(r, Bt))
    return process.env.NODE_ENV !== "production" && !(qSe(r) instanceof yM) && Xe("Cannot convert '" + A8(r) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), r;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(r) && Xe("Cannot make the designated object observable; it is not extensible");
  var n = (t = e?.name) != null ? t : process.env.NODE_ENV !== "production" ? (Oo(r) ? "ObservableObject" : r.constructor.name) + "@" + Ea() : "ObservableObject", i = new yM(r, /* @__PURE__ */ new Map(), String(n), Aze(e));
  return iw(r, Bt, i), r;
}
var gWe = /* @__PURE__ */ Bf("ObservableObjectAdministration", yM);
function cB(r) {
  return aB[r] || (aB[r] = {
    get: function() {
      return this[Bt].getObservablePropValue_(r);
    },
    set: function(t) {
      return this[Bt].setObservablePropValue_(r, t);
    }
  });
}
function Ug(r) {
  return h7(r) ? gWe(r[Bt]) : !1;
}
function hB(r, e, t) {
  var n;
  process.env.NODE_ENV !== "production" && (r.appliedAnnotations_[t] = e), (n = r.target_[So]) == null || delete n[t];
}
function dB(r, e, t) {
  if (process.env.NODE_ENV !== "production" && !QSe(e) && Xe("Cannot annotate '" + r.name_ + "." + t.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !d8(e) && fa(r.appliedAnnotations_, t)) {
    var n = r.name_ + "." + t.toString(), i = r.appliedAnnotations_[t].annotationType_, s = e.annotationType_;
    Xe("Cannot apply '" + s + "' to '" + n + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var mWe = /* @__PURE__ */ ZSe(0), AWe = /* @__PURE__ */ function() {
  var r = !1, e = {};
  return Object.defineProperty(e, "0", {
    set: function() {
      r = !0;
    }
  }), Object.create(e)[0] = 1, r === !1;
}(), TC = 0, jSe = function() {
};
function wWe(r, e) {
  Object.setPrototypeOf ? Object.setPrototypeOf(r.prototype, e) : r.prototype.__proto__ !== void 0 ? r.prototype.__proto__ = e : r.prototype = e;
}
wWe(jSe, Array.prototype);
var nI = /* @__PURE__ */ function(r) {
  function e(n, i, s, o) {
    var a;
    return s === void 0 && (s = process.env.NODE_ENV !== "production" ? "ObservableArray@" + Ea() : "ObservableArray"), o === void 0 && (o = !1), a = r.call(this) || this, k1(function() {
      var l = new tI(s, i, o, !0);
      l.proxy_ = a, sSe(a, Bt, l), n && n.length && a.spliceWithArray(0, 0, n), AWe && Object.defineProperty(a, "0", mWe);
    }), a;
  }
  lSe(e, r);
  var t = e.prototype;
  return t.concat = function() {
    this[Bt].atom_.reportObserved();
    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      s.map(function(a) {
        return w7(a) ? a.slice() : a;
      })
    );
  }, t[Symbol.iterator] = function() {
    var n = this, i = 0;
    return iI({
      next: function() {
        return i < n.length ? {
          value: n[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, Zg(e, [{
    key: "length",
    get: function() {
      return this[Bt].getArrayLength_();
    },
    set: function(i) {
      this[Bt].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
}(jSe);
Object.entries(g8).forEach(function(r) {
  var e = r[0], t = r[1];
  e !== "concat" && iw(nI.prototype, e, t);
});
function ZSe(r) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Bt].get_(r);
    },
    set: function(t) {
      this[Bt].set_(r, t);
    }
  };
}
function vWe(r) {
  th(nI.prototype, "" + r, ZSe(r));
}
function USe(r) {
  if (r > TC) {
    for (var e = TC; e < r + 100; e++)
      vWe(e);
    TC = r;
  }
}
USe(1e3);
function bWe(r, e, t) {
  return new nI(r, e, t);
}
function Jp(r, e) {
  if (typeof r == "object" && r !== null) {
    if (w7(r))
      return e !== void 0 && Xe(23), r[Bt].atom_;
    if (qc(r))
      return r.atom_;
    if (L1(r)) {
      if (e === void 0)
        return r.keysAtom_;
      var t = r.data_.get(e) || r.hasMap_.get(e);
      return t || Xe(25, e, A8(r)), t;
    }
    if (Ug(r)) {
      if (!e)
        return Xe(26);
      var n = r[Bt].values_.get(e);
      return n || Xe(27, e, A8(r)), n;
    }
    if (YT(r) || m7(r) || p8(r))
      return r;
  } else if (vr(r) && p8(r[Bt]))
    return r[Bt];
  Xe(28);
}
function qSe(r, e) {
  if (r || Xe(29), YT(r) || m7(r) || p8(r) || L1(r) || qc(r))
    return r;
  if (r[Bt])
    return r[Bt];
  Xe(24, r);
}
function A8(r, e) {
  var t;
  if (e !== void 0)
    t = Jp(r, e);
  else {
    if (Kp(r))
      return r.name;
    Ug(r) || L1(r) || qc(r) ? t = qSe(r) : t = Jp(r);
  }
  return t.name_;
}
function k1(r) {
  var e = Pf(), t = p7(!0);
  $a();
  try {
    return r();
  } finally {
    el(), g7(t), wd(e);
  }
}
var uB = c7.toString;
function GSe(r, e, t) {
  return t === void 0 && (t = -1), CM(r, e, t);
}
function CM(r, e, t, n, i) {
  if (r === e)
    return r !== 0 || 1 / r === 1 / e;
  if (r == null || e == null)
    return !1;
  if (r !== r)
    return e !== e;
  var s = typeof r;
  if (s !== "function" && s !== "object" && typeof e != "object")
    return !1;
  var o = uB.call(r);
  if (o !== uB.call(e))
    return !1;
  switch (o) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + r == "" + e;
    case "[object Number]":
      return +r != +r ? +e != +e : +r == 0 ? 1 / +r === 1 / e : +r == +e;
    case "[object Date]":
    case "[object Boolean]":
      return +r == +e;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(r) === Symbol.valueOf.call(e);
    case "[object Map]":
    case "[object Set]":
      t >= 0 && t++;
      break;
  }
  r = fB(r), e = fB(e);
  var a = o === "[object Array]";
  if (!a) {
    if (typeof r != "object" || typeof e != "object")
      return !1;
    var l = r.constructor, c = e.constructor;
    if (l !== c && !(vr(l) && l instanceof l && vr(c) && c instanceof c) && "constructor" in r && "constructor" in e)
      return !1;
  }
  if (t === 0)
    return !1;
  t < 0 && (t = -1), n = n || [], i = i || [];
  for (var d = n.length; d--; )
    if (n[d] === r)
      return i[d] === e;
  if (n.push(r), i.push(e), a) {
    if (d = r.length, d !== e.length)
      return !1;
    for (; d--; )
      if (!CM(r[d], e[d], t - 1, n, i))
        return !1;
  } else {
    var u = Object.keys(r), f = u.length;
    if (Object.keys(e).length !== f)
      return !1;
    for (var p = 0; p < f; p++) {
      var g = u[p];
      if (!(fa(e, g) && CM(r[g], e[g], t - 1, n, i)))
        return !1;
    }
  }
  return n.pop(), i.pop(), !0;
}
function fB(r) {
  return w7(r) ? r.slice() : jg(r) || L1(r) || nd(r) || qc(r) ? Array.from(r.entries()) : r;
}
var pB, yWe = ((pB = l7().Iterator) == null ? void 0 : pB.prototype) || {};
function iI(r) {
  return r[Symbol.iterator] = CWe, Object.assign(Object.create(yWe), r);
}
function CWe() {
  return this;
}
function QSe(r) {
  return (
    // Can be function
    r instanceof Object && typeof r.annotationType_ == "string" && vr(r.make_) && vr(r.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(r) {
  var e = l7();
  typeof e[r] > "u" && Xe("MobX requires global '" + r + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: Pze,
  extras: {
    getDebugName: A8
  },
  $mobx: Bt
});
var IC, gB;
function v7() {
  if (gB) return IC;
  gB = 1;
  function r(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return IC = r, IC;
}
var OC, mB;
function KSe() {
  if (mB) return OC;
  mB = 1;
  var r = typeof fv == "object" && fv && fv.Object === Object && fv;
  return OC = r, OC;
}
var RC, AB;
function Ch() {
  if (AB) return RC;
  AB = 1;
  var r = KSe(), e = typeof self == "object" && self && self.Object === Object && self, t = r || e || Function("return this")();
  return RC = t, RC;
}
var VC, wB;
function EWe() {
  if (wB) return VC;
  wB = 1;
  var r = Ch(), e = function() {
    return r.Date.now();
  };
  return VC = e, VC;
}
var HC, vB;
function _We() {
  if (vB) return HC;
  vB = 1;
  var r = /\s/;
  function e(t) {
    for (var n = t.length; n-- && r.test(t.charAt(n)); )
      ;
    return n;
  }
  return HC = e, HC;
}
var BC, bB;
function xWe() {
  if (bB) return BC;
  bB = 1;
  var r = _We(), e = /^\s+/;
  function t(n) {
    return n && n.slice(0, r(n) + 1).replace(e, "");
  }
  return BC = t, BC;
}
var PC, yB;
function rI() {
  if (yB) return PC;
  yB = 1;
  var r = Ch(), e = r.Symbol;
  return PC = e, PC;
}
var FC, CB;
function SWe() {
  if (CB) return FC;
  CB = 1;
  var r = rI(), e = Object.prototype, t = e.hasOwnProperty, n = e.toString, i = r ? r.toStringTag : void 0;
  function s(o) {
    var a = t.call(o, i), l = o[i];
    try {
      o[i] = void 0;
      var c = !0;
    } catch {
    }
    var d = n.call(o);
    return c && (a ? o[i] = l : delete o[i]), d;
  }
  return FC = s, FC;
}
var zC, EB;
function MWe() {
  if (EB) return zC;
  EB = 1;
  var r = Object.prototype, e = r.toString;
  function t(n) {
    return e.call(n);
  }
  return zC = t, zC;
}
var WC, _B;
function cw() {
  if (_B) return WC;
  _B = 1;
  var r = rI(), e = SWe(), t = MWe(), n = "[object Null]", i = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function o(a) {
    return a == null ? a === void 0 ? i : n : s && s in Object(a) ? e(a) : t(a);
  }
  return WC = o, WC;
}
var jC, xB;
function hw() {
  if (xB) return jC;
  xB = 1;
  function r(e) {
    return e != null && typeof e == "object";
  }
  return jC = r, jC;
}
var ZC, SB;
function DWe() {
  if (SB) return ZC;
  SB = 1;
  var r = cw(), e = hw(), t = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || e(i) && r(i) == t;
  }
  return ZC = n, ZC;
}
var UC, MB;
function LWe() {
  if (MB) return UC;
  MB = 1;
  var r = xWe(), e = v7(), t = DWe(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, o = /^0o[0-7]+$/i, a = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (t(c))
      return n;
    if (e(c)) {
      var d = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(d) ? d + "" : d;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = r(c);
    var u = s.test(c);
    return u || o.test(c) ? a(c.slice(2), u ? 2 : 8) : i.test(c) ? n : +c;
  }
  return UC = l, UC;
}
var qC, DB;
function kWe() {
  if (DB) return qC;
  DB = 1;
  var r = v7(), e = EWe(), t = LWe(), n = "Expected a function", i = Math.max, s = Math.min;
  function o(a, l, c) {
    var d, u, f, p, g, m, A = 0, w = !1, v = !1, y = !0;
    if (typeof a != "function")
      throw new TypeError(n);
    l = t(l) || 0, r(c) && (w = !!c.leading, v = "maxWait" in c, f = v ? i(t(c.maxWait) || 0, l) : f, y = "trailing" in c ? !!c.trailing : y);
    function _(R) {
      var H = d, z = u;
      return d = u = void 0, A = R, p = a.apply(z, H), p;
    }
    function S(R) {
      return A = R, g = setTimeout(L, l), w ? _(R) : p;
    }
    function D(R) {
      var H = R - m, z = R - A, U = l - H;
      return v ? s(U, f - z) : U;
    }
    function M(R) {
      var H = R - m, z = R - A;
      return m === void 0 || H >= l || H < 0 || v && z >= f;
    }
    function L() {
      var R = e();
      if (M(R))
        return T(R);
      g = setTimeout(L, D(R));
    }
    function T(R) {
      return g = void 0, y && d ? _(R) : (d = u = void 0, p);
    }
    function B() {
      g !== void 0 && clearTimeout(g), A = 0, d = m = u = g = void 0;
    }
    function V() {
      return g === void 0 ? p : T(e());
    }
    function N() {
      var R = e(), H = M(R);
      if (d = arguments, u = this, m = R, H) {
        if (g === void 0)
          return S(m);
        if (v)
          return clearTimeout(g), g = setTimeout(L, l), _(m);
      }
      return g === void 0 && (g = setTimeout(L, l)), p;
    }
    return N.cancel = B, N.flush = V, N;
  }
  return qC = o, qC;
}
var NWe = kWe();
const LB = /* @__PURE__ */ a7(NWe), dw = Object.prototype.toString, TWe = Object.prototype.hasOwnProperty;
function IWe(r) {
  return r === void 0;
}
function OA(r) {
  return r !== void 0;
}
function ul(r) {
  return dw.call(r) === "[object Array]";
}
function Od(r) {
  return dw.call(r) === "[object Object]";
}
function ec(r) {
  return dw.call(r) === "[object Number]";
}
function ol(r) {
  const e = dw.call(r);
  return e === "[object Function]" || e === "[object AsyncFunction]" || e === "[object GeneratorFunction]" || e === "[object AsyncGeneratorFunction]" || e === "[object Proxy]";
}
function EM(r) {
  return dw.call(r) === "[object String]";
}
function qg(r, e) {
  return TWe.call(r, e);
}
function Rd(r, e) {
  const t = YSe(e);
  let n;
  return vn(r, function(i, s) {
    if (t(i, s))
      return n = i, !1;
  }), n;
}
function _M(r, e) {
  const t = YSe(e);
  let n = [];
  return vn(r, function(i, s) {
    t(i, s) && n.push(i);
  }), n;
}
function vn(r, e) {
  let t, n;
  if (IWe(r))
    return;
  const i = ul(r) ? VWe : RWe;
  for (let s in r)
    if (qg(r, s) && (t = r[s], n = e(t, i(s)), n === !1))
      return t;
}
function $p(r, e, t) {
  return vn(r, function(n, i) {
    t = e(t, n, i);
  }), t;
}
function sI(r, e) {
  return !!$p(r, function(t, n, i) {
    return t && e(n, i);
  }, !0);
}
function b7(r, e) {
  return !!Rd(r, e);
}
function OWe(r, e) {
  let t = [];
  return vn(r, function(n, i) {
    t.push(e(n, i));
  }), t;
}
function kB(r) {
  return function(e) {
    return sI(r, function(t, n) {
      return e[n] === t;
    });
  };
}
function YSe(r) {
  return ol(r) ? r : (e) => e === r;
}
function RWe(r) {
  return r;
}
function VWe(r) {
  return Number(r);
}
function HWe(r, e) {
  let t, n, i, s;
  function o(u) {
    let f = Date.now(), p = u ? 0 : s + e - f;
    if (p > 0)
      return a(p);
    r.apply(i, n), l();
  }
  function a(u) {
    t = setTimeout(o, u);
  }
  function l() {
    t && clearTimeout(t), t = s = n = i = void 0;
  }
  function c() {
    t && o(!0), l();
  }
  function d(...u) {
    s = Date.now(), n = u, i = this, t || a(e);
  }
  return d.flush = c, d.cancel = l, d;
}
function oI(r, e) {
  return r.bind(e);
}
function Ft(r, ...e) {
  return Object.assign(r, ...e);
}
function BWe(r, e) {
  let t = {}, n = Object(r);
  return vn(n, function(i, s) {
    e.indexOf(s) === -1 && (t[s] = i);
  }), t;
}
function He(r, e) {
  var t = an(r);
  return t && typeof t.$instanceOf == "function" && t.$instanceOf(e);
}
function XSe(r, e) {
  return b7(e, function(t) {
    return He(r, t);
  });
}
function an(r) {
  return r && r.businessObject || r;
}
function df(r) {
  return r && r.di;
}
const PWe = "camundaModeler:exampleOutputJson", lh = (r) => {
  const e = FWe(r, PWe);
  if (e)
    return e.get("value");
}, FWe = (r, e) => {
  const t = zWe(r, "zeebe:Properties");
  return t.length === 0 ? void 0 : t[0].get("properties").find((i) => i.get("name") === e);
}, zWe = (r, e) => {
  const t = an(r);
  let n = [];
  const i = t.get("extensionElements");
  if (i !== void 0) {
    const s = i.get("values");
    s !== void 0 && (n = s.filter((o) => He(o, e)));
  }
  return n;
}, JSe = (r) => He(r, "bpmn:BusinessRuleTask"), WWe = (r) => r?.get("values").filter((e) => e.$type === "zeebe:CalledDecision" || e.$type === "zeebe:calledDecision")[0], $Se = (r) => {
  const e = WWe(r);
  if (e?.decisionId)
    return e?.decisionId?.trim();
}, eMe = (r) => r?.trim()?.startsWith("="), jWe = "bpmn:Process";
function tMe(r) {
  if (!r)
    throw new Error(
      "You need to pass modeler definitions to get the processId of the executable process"
    );
  let e, t;
  const n = r.rootElements;
  if (n)
    return n.forEach((i) => {
      i.$type === jWe && (t || (t = i), e || i.isExecutable && (e = i));
    }), e || (e = t), e;
}
const ZWe = (r) => r === "zeebe:CalledElement" || r === "zeebe:calledElement", UWe = (r) => r?.get("values").filter((e) => ZWe(e.$type))[0], nMe = (r) => {
  const e = UWe(r);
  if (e?.processId)
    return e?.processId?.trim();
};
function qWe({
  projectId: r,
  elementRegistry: e,
  fetchFilesByDecisionId: t,
  fetchFilesByProcessId: n,
  fetchFileById: i
}) {
  const s = e?.filter((a) => JSe(a)).map((a) => ({
    element: a,
    id: $Se(a.businessObject?.get("extensionElements"))
  })).filter(
    ({ id: a }) => !!a && !eMe(a)
  ), o = e?.filter((a) => He(a, "bpmn:CallActivity")).map((a) => ({
    element: a,
    id: nMe(
      a.businessObject?.get("extensionElements")
    )
  })).filter(({ id: a }) => !!a);
  if (!((s === void 0 || s.length === 0) && (o === void 0 || o.length === 0)))
    return new Promise((a) => {
      const l = {}, c = s?.map(
        ({ id: u, element: f }) => w8({
          projectId: r,
          type: "decision",
          id: u,
          relatedFiles: l,
          element: f,
          fetchFilesByDecisionId: t,
          fetchFilesByProcessId: n,
          fetchFileById: i
        })
      ) ?? [], d = o?.map(
        ({ id: u, element: f }) => w8({
          projectId: r,
          type: "process",
          id: u,
          relatedFiles: l,
          element: f,
          fetchFilesByDecisionId: t,
          fetchFilesByProcessId: n,
          fetchFileById: i
        })
      ) ?? [];
      Promise.all([...c, ...d]).then(
        () => Promise.all(Object.values(l)).then(a)
      );
    });
}
function w8({
  projectId: r,
  type: e,
  id: t,
  relatedFiles: n,
  element: i,
  fetchFilesByDecisionId: s,
  fetchFilesByProcessId: o,
  fetchFileById: a
}) {
  const l = e + "_" + t;
  if (n[l] === void 0)
    return n[l] = new Promise((c) => {
      (async () => {
        let d;
        e === "decision" ? d = await s(r, t) : d = await o(r, t);
        let u = null;
        if (d?.[0]?.id && (u = await a(d[0].id)), e === "process" && u?.content) {
          const g = (await new Q4().fromXML(u.content)).elementsById, m = Object.values(g).filter((w) => JSe(w)).map(
            (w) => $Se(w?.get("extensionElements"))
          ).filter(
            (w) => !!w && !eMe(w)
          ).map(
            (w) => w8({
              projectId: r,
              type: "decision",
              id: w,
              relatedFiles: n,
              element: i,
              fetchFilesByDecisionId: s,
              fetchFilesByProcessId: o,
              fetchFileById: a
            })
          ), A = Object.values(g).filter((w) => He(w, "bpmn:CallActivity")).map(
            (w) => nMe(w?.get("extensionElements"))
          ).filter((w) => !!w).map(
            (w) => w8({
              projectId: r,
              type: "process",
              id: w,
              relatedFiles: n,
              element: i,
              fetchFilesByDecisionId: s,
              fetchFilesByProcessId: o,
              fetchFileById: a
            })
          );
          await Promise.all([...m, ...A]);
        }
        c({
          type: e,
          id: t,
          element: i,
          filename: d?.[0]?.name ?? null,
          fileId: d?.[0]?.id ?? null,
          content: u?.content ?? null,
          status: "waiting"
        });
      })();
    }), n[l];
}
async function NB({
  diagramId: r,
  content: e,
  convertLinkedFormsToEmbeddedForms: t
}) {
  return e.includes('formId="') ? (await t(r)).content : e;
}
async function xM() {
  let r;
  try {
    r = await (await fetch("https://spawn.play.camunda.io/api/cluster", {
      method: "POST"
    })).json();
  } catch {
    return await rMe(5e3), await xM();
  }
  $i.trackClusterCreation(), window.localStorage.setItem("zeebePlayCluster", r.uuid), window.localStorage.setItem("zeebePlayDeployments", "{}");
}
async function iMe() {
  const r = window.localStorage.getItem("zeebePlayCluster");
  if (!r)
    return await xM();
  try {
    if (!(await fetch(
      "https://spawn.play.camunda.io/api/cluster/" + r
    )).ok)
      return await xM();
    await fetch(`https://spawn.play.camunda.io/api/cluster/${r}/extend`, {
      method: "PUT"
    });
  } catch {
    await rMe(5e3), await iMe();
  }
}
function GWe() {
  return new Promise((r) => {
    const e = localStorage.getItem("zeebePlayCluster"), t = async () => {
      let n, i;
      try {
        i = await (await fetch(
          "https://spawn.play.camunda.io/api/cluster/" + e
        )).json(), localStorage.setItem(
          "zeebePlayClusterDeathDate",
          new Date(i.spec.deathDate).valueOf().toString()
        ), n = i.status.conditions[0];
      } catch {
        n = {};
      }
      n?.type === "Available" && n?.status === "True" ? r(i?.status.httpEndpoint) : setTimeout(t, 1e3);
    };
    t();
  });
}
async function QWe() {
  return await iMe(), await GWe();
}
async function rMe(r = 0) {
  return new Promise((e) => setTimeout(e, r));
}
function TB(r) {
  return r.replaceAll(/ bioc:([^"]+")([^"]+")/gm, "");
}
function t0(r, e) {
  return He(r, "bpmn:CallActivity") ? !1 : He(r, "bpmn:SubProcess") ? (e = e || df(r), e && He(e, "bpmndi:BPMNPlane") ? !0 : e && !!e.isExpanded) : He(r, "bpmn:Participant") ? !!an(r).processRef : !0;
}
function IB(r) {
  if (!(!He(r, "bpmn:Participant") && !He(r, "bpmn:Lane"))) {
    var e = df(r).isHorizontal;
    return e === void 0 ? !0 : e;
  }
}
function aI(r) {
  return r && !!an(r).triggeredByEvent;
}
function zf(r, e) {
  var t = an(r).eventDefinitions;
  return b7(t, function(n) {
    return He(n, e);
  });
}
function Gg(r) {
  return zf(r, "bpmn:ErrorEventDefinition");
}
function sMe(r) {
  return He(r, "bpmn:FlowNode");
}
function KWe(r) {
  return He(r, "bpmn:Error");
}
function YWe(r) {
  return He(r, "bpmn:BoundaryEvent") && Gg(r);
}
function XWe(r) {
  return He(r, "bpmn:StartEvent") && Gg(r);
}
function JWe(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => sMe(e));
}
function $We(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => KWe(e));
}
const eje = (r) => YWe(r) || XWe(r);
function tje(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => eje(e));
}
function oMe(r) {
  return an(r).modelerTemplate !== void 0;
}
let nje = class {
  constructor() {
    this.browser = {}, this.unsupportedBrowsers = {
      Chrome: 61,
      Firefox: 55,
      IE: 11,
      Edge: 15,
      Opera: 50,
      Safari: 10
    }, this._detectBrowser();
  }
  /**
   * Detects the current browser and its version number.
   *
   * @returns {Object} An object with keys for browser `name` and `version`.
   */
  _detectBrowser() {
    this.browser = function() {
      if (typeof navigator > "u") return;
      let e = navigator.userAgent, t, n = e.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
      return /trident/i.test(n[1]) ? (t = /\brv[ :]+(\d+)/g.exec(e) || [], { name: "IE", version: t[1] || "" }) : n[1] === "Chrome" && (t = e.match(/\b(OPR|Edge)\/(\d+)/), t != null) ? { name: t[1].replace("OPR", "Opera"), version: t[2] } : (n = n[2] ? [n[1], n[2]] : [navigator.appName, navigator.appVersion, "-?"], (t = e.match(/version\/(\d+)/i)) != null && n.splice(1, 1, t[1]), { name: n[0], version: n[1] });
    }();
  }
  /**
   * Checks if the current browser is Internet Explorer.
   *
   * @returns {Boolean}
   */
  get isIE() {
    return this.browser.name === "IE";
  }
  /**
   * Checks if the current browser is Edge.
   *
   * @returns {Boolean}
   */
  get isEdge() {
    return this.browser.name === "Edge";
  }
  /**
   * Checks if the current browser is from Microsoft (Edge
   * or Internet Explorer).
   *
   * @returns {Boolean}
   */
  get isMicrosoft() {
    return this.isIE || this.isEdge;
  }
  /**
   * Checks if the current browser is Firefox.
   *
   * @returns {Boolean}
   */
  get isFirefox() {
    return this.browser.name === "Firefox";
  }
  /**
   * Checks if the current browser is Chrome.
   *
   * @returns {Boolean}
   */
  get isChrome() {
    return this.browser.name === "Chrome";
  }
  /**
   * Checks if the current browser is Safari.
   *
   * @returns {Boolean}
   */
  get isSafari() {
    return this.browser.name === "Safari";
  }
  /**
   * Checks if the current browser is from an Android device.
   *
   * @returns {Boolean}
   */
  get isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is from a BlackBerry device.
   *
   * @returns {Boolean}
   */
  get isBlackBerry() {
    return /BlackBerry/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is from a Windows Mobile device.
   *
   * @returns {Boolean}
   */
  get isWindowsMobile() {
    return /IEMobile/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is Mobile Safari.
   *
   * @returns {Boolean}
   */
  get isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is a mobile browser.
   *
   * @returns {Boolean}
   */
  get isMobile() {
    return this.isAndroid || this.isBlackBerry || this.isWindowsMobile || this.isIOS;
  }
  /**
   * Checks if the current browser is supported by
   * our environment.
   *
   * @returns {Boolean}
   */
  isSupported() {
    return !!(Object.prototype.hasOwnProperty.call(
      //@ts-expect-error Property 'unsupportedBrowsers' does not exist on type 'BrowserDetector'.ts(2339)
      this.unsupportedBrowsers,
      //@ts-expect-error Property 'browser' does not exist on type 'BrowserDetector'.ts(2339)
      this.browser.name
    ) && +this.browser.version > this.unsupportedBrowsers[this.browser.name]);
  }
};
const ije = new Q4();
function rje(r) {
  return ije.fromXML(r);
}
const OB = {
  elementInstances: void 0,
  status: "initial"
};
let sje = class {
  state = { ...OB };
  constructor() {
    Hi(this);
  }
  fetchElementInstances = async ({
    instanceKey: e,
    processId: t,
    elementRegistry: n
  }) => {
    this.startFetching();
    const { success: i, elementInstances: s } = await _t.fetchElementInstances({
      instanceKey: e
    });
    i ? (this.handleSuccess(s), s?.elementInstances?.forEach((o) => {
      o.state === "COMPLETED" && $i.trackBpmnElementCompletion(
        o,
        t,
        n
      );
    })) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.elementInstances = e, this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get takenSequenceFlows() {
    return this.state.elementInstances?.takenSequenceFlows ?? [];
  }
  get completedElementInstances() {
    return this.state.elementInstances?.completedElementInstances ?? [];
  }
  get elementInstances() {
    return this.state.elementInstances?.elementInstances ?? [];
  }
  get elementIds() {
    return this.elementInstances.map(({ element: e }) => e.elementId);
  }
  reset = () => {
    this.state = { ...OB };
  };
};
const Ro = new sje(), aMe = (r) => {
  const e = r.parent;
  return e === void 0 ? !1 : aI(e.businessObject) ? !0 : aMe(e);
}, RB = new nje(), VB = {
  definitions: void 0,
  elementsById: void 0,
  isMinimapActive: !1,
  isFullscreenActive: !1,
  isLoaded: !1,
  elementRegistry: void 0,
  viewer: void 0
};
let oje = class {
  state = { ...VB };
  constructor() {
    Hi(this);
  }
  setDiagramDetails = async (e) => {
    const { rootElement: t, elementsById: n } = await rje(e);
    this.setDefinitions(t, n);
  };
  setDefinitions(e, t) {
    this.state.definitions = e, this.state.elementsById = t;
  }
  get flowNodes() {
    return JWe(this.state.elementsById);
  }
  get errorEventDefinitions() {
    return $We(this.state.elementsById);
  }
  get errorEvents() {
    return tje(this.state.elementsById).map(
      ({ attachedToRef: e, eventDefinitions: t, id: n }) => {
        const i = t[0].errorRef.id, s = this.errorEventDefinitions.find(
          ({ id: o }) => o === i
        );
        return {
          attachedElementId: e?.id ?? null,
          errorId: i,
          errorElementId: n,
          errorCode: s?.errorCode,
          errorName: s?.name
        };
      }
    );
  }
  get errorBoundaryEvents() {
    return this.errorEvents.filter(
      ({ attachedElementId: e }) => e !== null
    );
  }
  get errorStartEvents() {
    return this.errorEvents.filter(
      ({ attachedElementId: e }) => e === null
    );
  }
  getErrorBoundaryEventsForElement = (e, t = []) => {
    if (e === void 0)
      return t;
    const n = this.errorBoundaryEvents.find(
      ({ attachedElementId: i }) => i === e.id
    );
    return n !== void 0 && t.push(n.errorId), this.getErrorBoundaryEventsForElement(
      e.parent,
      t
    );
  };
  getAvailableErrorEvents = (e) => e === void 0 ? [] : [
    ...this.errorBoundaryEvents.filter(({ errorId: t }) => this.getErrorBoundaryEventsForElement(e).includes(t)),
    ...aMe(e) ? [] : this.errorStartEvents
  ].map(({ errorCode: t, errorName: n, errorElementId: i }) => ({
    errorElementId: i,
    errorCode: t,
    errorName: n
  }));
  get elements() {
    return this.state.elementRegistry?.getAll();
  }
  get flowNodeIds() {
    return this.flowNodes.map(({ id: e }) => e);
  }
  get selectableFlowNodeIds() {
    return Array.from(new Set(Ro.elementIds)).filter(
      (e) => this.flowNodeIds.includes(e)
    );
  }
  get viewer() {
    return this.state.viewer;
  }
  toggleMinimap = () => {
    this.state.isMinimapActive = !this.state.isMinimapActive;
  };
  /**
   * Forces a recalculation of the root container which
   * most of the times fixes a Safari viewport height bug.
   *
   * Shall only be used in Safari
   */
  forceRootResize = () => {
    const e = document.querySelector("#root");
    e.style.height = "99.9vh", requestAnimationFrame(() => {
      e.style.height = "100vh";
    });
  };
  exitFullscreen() {
    this.state.isFullscreenActive = !1, RB.isSafari && this.forceRootResize();
  }
  startLoading = () => {
    this.state.isLoaded = !1;
  };
  finishLoading = (e) => {
    this.state.elementRegistry = e.getElementRegistry(), this.state.viewer = e, this.state.isLoaded = !0;
  };
  toXml = async () => this.state.viewer?.saveXML();
  setIsLoaded = (e = !0) => {
    this.state.isLoaded = e;
  };
  handleFullscreenToggle = () => {
    RB.isSafari ? document.webkitFullscreenEnabled && (document.webkitRequestFullscreen ? (document.webkitExitFullscreen(), this.exitFullscreen()) : (document.documentElement.webkitRequestFullscreen(), this.state.isFullscreenActive = !0)) : document.fullscreenEnabled && (document.fullscreenElement ? (document.exitFullscreen(), this.exitFullscreen()) : (document.documentElement.requestFullscreen(), this.state.isFullscreenActive = !0));
  };
  focusOnElement = (e) => {
    this.state.viewer?.focusOnElement(e);
  };
  reset = () => {
    this.state = { ...VB };
  };
};
const mi = new oje(), v8 = (r) => {
  try {
    return JSON.parse(r), !0;
  } catch {
    return !1;
  }
}, aje = () => new Promise((r) => {
  const e = async () => {
    try {
      const { response: t } = await _t.checkReadiness();
      t?.ready ? r() : setTimeout(e, 1e3);
    } catch {
      setTimeout(e, 1e3);
    }
  };
  e();
}), lje = (r) => lMe()[r], lMe = () => JSON.parse(localStorage.getItem("zeebePlayDeployments") || "{}"), cje = (r, e) => {
  const t = lMe();
  t[r] = e, localStorage.setItem("zeebePlayDeployments", JSON.stringify(t));
}, HB = {
  status: "initial",
  isRedeployment: !1,
  deployedFiles: void 0,
  endpoint: void 0,
  playId: void 0,
  deployedProcess: void 0
};
let hje = class {
  state = { ...HB };
  disposer = null;
  xml;
  projectId;
  processId;
  fetchFilesByProcessId;
  fetchFilesByDecisionId;
  fetchFileById;
  onDeploymentError;
  convertLinkedFormsToEmbeddedForms;
  setExecutionPlatformVersion;
  updateFileById;
  currentDiagramRevision = 0;
  originAppInstanceId;
  canUserSaveExampleData = !1;
  diagramId;
  constructor() {
    Hi(this);
  }
  init({
    xml: e,
    processId: t,
    projectId: n,
    diagramId: i,
    fetchFilesByProcessId: s,
    fetchFilesByDecisionId: o,
    fetchFileById: a,
    onDeploymentError: l,
    convertLinkedFormsToEmbeddedForms: c,
    setExecutionPlatformVersion: d,
    currentDiagramRevision: u,
    updateFileById: f,
    originAppInstanceId: p,
    canUserSaveExampleData: g
  }) {
    this.xml = e, this.currentDiagramRevision = u, this.processId = t, this.projectId = n, this.diagramId = i, this.fetchFilesByProcessId = s, this.fetchFilesByDecisionId = o, this.fetchFileById = a, this.onDeploymentError = l, this.convertLinkedFormsToEmbeddedForms = c, this.setExecutionPlatformVersion = d, this.updateFileById = f, this.originAppInstanceId = p, this.canUserSaveExampleData = g;
  }
  get isClusterReady() {
    return !["initial", "creating-cluster"].includes(this.state.status);
  }
  get isEnvironmentCreated() {
    return this.state.status === "environment-created";
  }
  get hasDiagramError() {
    return this.state.deployedProcess?.status === "diagram-error";
  }
  get hasServerError() {
    return this.state.deployedFiles?.some(
      (e) => e.status === "server error"
    ) || this.state.deployedProcess?.status === "server-error";
  }
  setIsRedeployment = (e) => {
    this.state.isRedeployment = e;
  };
  setDeployedProcess = (e) => {
    this.state.deployedProcess = e;
  };
  setDeployedFiles = (e) => {
    this.state.deployedFiles = e;
  };
  setStatus = (e) => {
    this.state.status = e;
  };
  setEndpoint = (e) => {
    this.state.endpoint = e;
  };
  setPlayId = (e) => {
    this.state.playId = e;
  };
  setupEnvironment = async () => {
    this.setStatus("creating-cluster"), this.setExecutionPlatformVersion?.("8.2.0");
    const e = qWe({
      projectId: this.projectId,
      elementRegistry: mi.state.elementRegistry,
      fetchFilesByDecisionId: this.fetchFilesByDecisionId,
      fetchFilesByProcessId: this.fetchFilesByProcessId,
      fetchFileById: this.fetchFileById
    });
    try {
      const [t, n] = await Promise.all([
        QWe(),
        e
      ]);
      _t.setEndpoint(t), this.setEndpoint(t), await aje(), this.setStatus("deploying-files");
      const i = await this.deployFiles({
        convertLinkedFormsToEmbeddedForms: this.convertLinkedFormsToEmbeddedForms,
        filesInfo: n
      }), s = await this.deployProcess();
      this.setDeployedProcess(s), this.setDeployedFiles(i), this.setPlayId(s.playId), this.setStatus("environment-created");
    } catch (t) {
      console.error("Uncaught cluster creation error", t);
    }
  };
  updateFile = async () => {
    const e = await mi.toXml?.();
    if (e?.error)
      return { success: !1, reason: "serialization" };
    const t = e?.xml;
    if (this.xml === t)
      return { success: !1, reason: "unchanged" };
    const n = mi.state.viewer?.getDefinitions(), i = n.$attrs["camunda:diagramRelationId"] ?? n.diagramRelationId, s = {
      content: t,
      revision: this.currentDiagramRevision,
      relationId: i,
      originAppInstanceId: this.originAppInstanceId
    };
    try {
      const o = await this.updateFileById?.(this.diagramId, s);
      return $i.trackDiagramUpdated(), this.currentDiagramRevision = o.revision, this.xml = t, { success: !0 };
    } catch (o) {
      return o?.status === 409 ? { success: !1, reason: "conflict" } : { success: !1, reason: "unknown" };
    }
  };
  deployFiles = async ({
    convertLinkedFormsToEmbeddedForms: e,
    filesInfo: t = []
  }) => Promise.all(
    t.map(async (n) => {
      if (n.content === null)
        return {
          ...n,
          element: {
            id: n.element.id,
            businessObject: {
              id: n.element.businessObject.id,
              name: n.element.businessObject.name
            }
          },
          status: "not found"
        };
      const i = TB(n.content), { response: s } = await _t.deploy({
        xml: await NB({
          diagramId: this.diagramId,
          content: i,
          convertLinkedFormsToEmbeddedForms: e
        }),
        isDmn: n.type === "decision"
      });
      if (!v8(s.payload))
        return {
          ...n,
          element: {
            id: n.element.id,
            businessObject: {
              id: n.element.businessObject.id,
              name: n.element.businessObject.name
            }
          },
          status: "server error"
        };
      const o = JSON.parse(s.payload || "{}");
      return {
        ...n,
        element: {
          id: n.element.id,
          businessObject: {
            id: n.element.businessObject.id,
            name: n.element.businessObject.name
          }
        },
        playId: o?.deployedProcesses?.[0]?.processKey,
        status: s.success ? "success" : "deployment error"
      };
    })
  );
  deployProcess = async () => {
    const e = TB(this.xml), t = !!lje(this.processId), n = await NB({
      diagramId: this.diagramId,
      content: e,
      convertLinkedFormsToEmbeddedForms: this.convertLinkedFormsToEmbeddedForms
    });
    await mi.setDiagramDetails(n);
    const { response: i } = await _t.deploy({
      xml: n
    });
    if (this.setIsRedeployment(t), !v8(i.payload))
      return { status: "server-error" };
    if (i.success) {
      const o = JSON.parse(i.payload || "{}").deployedProcesses[0].processKey;
      return cje(this.processId, o), $i.trackDeployment({ redeployment: t, success: !0 }), { status: "success", playId: o };
    } else {
      const s = JSON.parse(i.payload || "{}");
      $i.trackDeployment({
        redeployment: t,
        success: !1,
        message: s.message,
        failure_type: s.failureType,
        details: s.details
      });
      const o = [
        {
          detail: s?.details ?? "Unknown error"
        }
      ];
      return this.onDeploymentError?.(o), { status: "diagram-error" };
    }
  };
  get fileProblems() {
    return this.state.deployedFiles?.filter((e) => e.status !== "success") ?? [];
  }
  reset = () => {
    this.state = { ...HB };
  };
};
const kt = new hje();
function S3(r, e) {
  const t = lh(r), n = localStorage.getItem(
    `jobCompletion ${kt.processId} ${r.id}`
  ), i = n && e, s = t && !i;
  return i ? {
    prefillData: n,
    originalDataSource: n === t ? "bpmn" : "cache"
  } : s ? {
    prefillData: t,
    originalDataSource: "bpmn"
  } : { prefillData: "", originalDataSource: "none" };
}
let dje = class {
  mixpanelTrack = void 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  init = (e) => {
    this.mixpanelTrack = e;
  };
  trackClusterCreation() {
    return this.mixpanelTrack?.("modeler:zeebePlay:clusterCreated");
  }
  trackDeployment({
    redeployment: e,
    success: t,
    message: n,
    failure_type: i,
    details: s
  }) {
    return this.mixpanelTrack?.("modeler:zeebePlay:deployment", {
      redeployment: e,
      success: t,
      message: n,
      failure_type: i,
      details: s
    });
  }
  trackResolveIncident(e) {
    return this.mixpanelTrack?.("zeebePlay:single-operation", {
      operationType: "RESOLVE_INCIDENT",
      process_id: e
    });
  }
  //@ts-expect-error Parameter 'incident' implicitly has an 'any' type.ts(7006)
  trackIncident(e, t) {
    const n = JSON.parse(
      localStorage.getItem("play-incidentTracking") || "{}"
    );
    n[e.key] || (this.mixpanelTrack?.("zeebePlay:incident:trigger", {
      error: e.errorMessage,
      process_id: t
    }), n[e.key] = !0, localStorage.setItem(
      "play-incidentTracking",
      JSON.stringify(n)
    ));
  }
  trackBpmnElementCompletion(e, t, n) {
    if (!n) return;
    const { bpmnElementType: i } = e.element, s = i === "UNKNOWN" ? "TASK" : i;
    if (s === "START_EVENT") return;
    const o = JSON.parse(
      localStorage.getItem("tracking:" + t) || "{}"
    ), a = n.get(e.element.elementId), l = a?.businessObject ?? a;
    let c = null;
    l?.hasOwnProperty("modelerTemplate") ? c = l?.modelerTemplate : (
      // eslint-disable-next-line no-prototype-builtins
      l?.$attrs?.hasOwnProperty("zeebe:modelerTemplate") && (c = l?.$attrs["zeebe:modelerTemplate"])
    );
    const d = this.convertConnectorId(c), u = !!d, f = d || s;
    s === "PROCESS" && !o[s + ":" + e.key] && (this.mixpanelTrack?.("zeebePlay:bpmnelement:completed", {
      element_type: "PROCESS",
      process_id: t
    }), o[s + ":" + e.key] = !0, o[s] = !0), o[f] || (this.mixpanelTrack?.("zeebePlay:bpmnelement:completed", {
      element_type: s,
      process_id: t,
      ...u ? { connector_type: d } : {}
    }), o[f] = !0), localStorage.setItem(
      "tracking:" + t,
      JSON.stringify(o)
    );
  }
  //@ts-expect-error Parameter 'process_id' implicitly has an 'any' type.ts(7006)
  trackInstanceStart(e) {
    return this.mixpanelTrack?.("zeebePlay:bpmnelement:completed", {
      element_type: "START_EVENT",
      From: "webModeler",
      process_id: e
    });
  }
  trackRewindedInstanceStart(e) {
    return this.mixpanelTrack?.("zeebePlay:bpmnelement:completed", {
      element_type: "START_EVENT",
      From: "rewind",
      process_id: e
    });
  }
  //@ts-expect-error Parameter 'path' implicitly has an 'any' type.ts(7006)
  trackAPIError(e, t) {
    return this.mixpanelTrack?.("zeebePlay:apiError", {
      path: e,
      status_code: t
    });
  }
  //@ts-expect-error Parameter 'id' implicitly has an 'any' type.ts(7006)
  convertConnectorId(e) {
    return e && !e.startsWith("io.camunda.connectors.") ? "proprietary_connector" : e;
  }
  trackTutorialVideoStopped(e) {
    return this.mixpanelTrack?.("tutorialVideo:stop", {
      to: "8-h2-validate-play",
      from: "play",
      playbackPositionInSeconds: e
    });
  }
  trackAcademyHatClicked() {
    return this.mixpanelTrack?.("tutorialVideo:open", {
      to: "8-h2-validate-play",
      from: "play"
    });
  }
  trackIncidentAIModalOpened({
    areAIFeaturesEnabled: e
  }) {
    return this.mixpanelTrack?.("docsAI:open", {
      enabled: e,
      from: "playIncident"
    });
  }
  trackUserCompletesElement(e, t) {
    const { prefillData: n, originalDataSource: i } = S3(e, !0), s = t === n ? i : "manual", o = an(e).$type;
    this.mixpanelTrack?.("play:element:completed ", {
      fileId: kt.diagramId,
      elementType: o,
      exampleDataUsed: s
    });
  }
  trackDiagramUpdated() {
    const e = {
      fileId: kt.diagramId,
      mode: "play",
      fileType: "bpmn"
    };
    return this.mixpanelTrack?.("modeler:edit:file", e);
  }
};
const $i = new dje();
function uje(r, e) {
  const t = JSON.parse(
    localStorage.getItem("play-connectorSecrets") || "[]"
  ), n = t.findIndex(
    (i) => i.name === r
  );
  n !== -1 ? t[n].value = e : t.push({ name: r, value: e }), localStorage.setItem(
    "play-connectorSecrets",
    JSON.stringify(t)
  );
}
function fje() {
  return JSON.parse(localStorage.getItem("play-connectorSecrets") || "[]");
}
function cMe(r) {
  return fje().find(
    (n) => n.name === r
  )?.value;
}
let pje = class {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handlePostRequest = void 0;
  endpoint = void 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  init = ({ handlePostRequest: e }) => {
    this.handlePostRequest = e;
  };
  setEndpoint = (e) => {
    this.endpoint = e;
  };
  async postWithErrorHandling(e, t) {
    try {
      return { success: !0, response: await this.handlePostRequest(e, t) };
    } catch (n) {
      return $i.trackAPIError(e, n.status), { success: !1, response: n };
    }
  }
  async getConnectorSecrets() {
    const { success: e, response: t } = await this.postWithErrorHandling("/zeebe-play/connector-secrets", {
      endpoint: this.endpoint
    });
    return {
      success: e,
      secrets: t?.secrets ?? []
    };
  }
  async setConnectorSecret({ name: e, value: t }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: n } = await this.postWithErrorHandling(
      "/zeebe-play/set-connector-secret",
      {
        endpoint: this.endpoint,
        name: e,
        value: t
      }
    );
    return uje(e, t), { success: n };
  }
  async terminateProcessInstance(e) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: t } = await this.postWithErrorHandling(
      "/zeebe-play/terminate",
      {
        endpoint: this.endpoint,
        processInstanceKey: e
      }
    );
    return { success: t };
  }
  async checkReadiness() {
    const { success: e, response: t } = await this.postWithErrorHandling("/zeebe-play/check-readiness", {
      endpoint: this.endpoint
    });
    return { success: e, response: t };
  }
  async deploy({ xml: e, isDmn: t = !1 }) {
    const { success: n, response: i } = await this.postWithErrorHandling("/zeebe-play/deploy", {
      endpoint: this.endpoint,
      xml: e,
      isDmn: t
    });
    return { success: n, response: i };
  }
  async startInstance({
    playId: e,
    variables: t
  }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { response: n, success: i } = await this.postWithErrorHandling("/zeebe-play/start-instance", {
      endpoint: this.endpoint,
      id: e,
      variables: t
    });
    return { instanceId: n.instanceId, success: i };
  }
  async fetchJobs({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/jobs", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { jobs: t.processInstance?.jobs, success: n };
  }
  async fetchElementInstances({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/element-instances", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { elementInstances: t?.processInstance, success: n };
  }
  async fetchChildInstances({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/child-instances", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return {
      childInstances: t.processInstance?.childProcessInstances,
      success: n
    };
  }
  async fetchInstances({
    id: e,
    perPage: t = 1e4,
    page: n = 0
  }) {
    const { response: i, success: s } = await this.postWithErrorHandling("/zeebe-play/query/instances", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, perPage: t, page: n, zoneId: Sl() }
      }
    });
    return i?.process?.processInstances?.nodes && i.process.processInstances.nodes.sort(
      (o, a) => new Date(a.startTime).valueOf() - new Date(o.startTime).valueOf()
    ), { process: i?.process, success: s };
  }
  async fetchTimers({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/timers", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { timers: t?.processInstance?.timers, success: n };
  }
  async fetchProcessTimers({ playId: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/process-timers", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { timers: t?.process?.timers, success: n };
  }
  async fetchMessageSubscriptions({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/message-subscriptions", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return {
      messageSubscriptions: t?.processInstance?.messageSubscriptions,
      success: n
    };
  }
  async fetchProcessMessageSubscriptions({ playId: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/process-message-subscriptions", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return {
      messageSubscriptions: t?.process?.messageSubscriptions,
      success: n
    };
  }
  async fetchUserTasks({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/user-tasks", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e }
      }
    });
    return { userTasks: t?.processInstance?.userTasks?.nodes, success: n };
  }
  async invokeConnector({ jobType: e, jobKey: t }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: n } = await this.postWithErrorHandling(
      `/zeebe-play/connectors/${e}/execute/${t}`,
      { endpoint: this.endpoint }
    );
    return { success: n };
  }
  async completeJob({ jobKey: e, variables: t }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: n } = await this.postWithErrorHandling(
      `/zeebe-play/jobs/${e}/complete`,
      {
        endpoint: this.endpoint,
        variables: t
      }
    );
    return { success: n };
  }
  async failJob({
    jobKey: e,
    retries: t,
    errorMessage: n
  }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: i } = await this.postWithErrorHandling(
      `/zeebe-play/jobs/${e}/fail`,
      {
        endpoint: this.endpoint,
        retries: t,
        errorMessage: n
      }
    );
    return { success: i };
  }
  async throwError({ jobKey: e, errorCode: t }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: n } = await this.postWithErrorHandling(
      `/zeebe-play/jobs/${e}/throw-error`,
      { endpoint: this.endpoint, errorCode: t, errorMessage: "" }
    );
    return { success: n };
  }
  async timeTravel({ dateTime: e }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: t } = await this.postWithErrorHandling("/zeebe-play/timers", {
      endpoint: this.endpoint,
      dateTime: e
    });
    return { success: t };
  }
  async publishMessage({
    messageName: e,
    correlationKey: t,
    variables: n,
    timeToLive: i,
    messageId: s
  }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: o } = await this.postWithErrorHandling("/zeebe-play/messages", {
      endpoint: this.endpoint,
      messageName: e,
      correlationKey: t,
      variables: n,
      timeToLive: i,
      messageId: s
    });
    return { success: o };
  }
  async fetchVariablesByUserTask({ userTask: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/variables-by-user-task", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e }
      }
    });
    return { variables: t?.userTask?.elementInstance?.variables, success: n };
  }
  async fetchInstanceDetails({ instanceId: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/instance-details", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { processInstance: t?.processInstance, success: n };
  }
  async fetchIncidents({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/incidents", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { incidents: t?.processInstance?.incidents, success: n };
  }
  async fetchVariables({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/zeebe-play/query/variables", {
      endpoint: this.endpoint,
      payload: {
        variables: { key: e, zoneId: Sl() }
      }
    });
    return { variables: t?.processInstance?.variables, success: n };
  }
  async setVariables({
    instanceKey: e,
    scope: t,
    variablesString: n
  }) {
    fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    );
    const { success: i } = await this.postWithErrorHandling(
      "/zeebe-play/process-instances/" + e + "/variables",
      {
        endpoint: this.endpoint,
        scopeKey: t,
        variables: n
      }
    );
    return { success: i };
  }
  async updateRetries({ jobKey: e, retries: t }) {
    return fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    ), this.postWithErrorHandling(
      "/zeebe-play/jobs/" + e + "/update-retries",
      {
        endpoint: this.endpoint,
        retries: t
      }
    );
  }
  async resolveIncident({ incidentKey: e }) {
    return fetch(
      `https://spawn.play.camunda.io/api/cluster/${Oa(
        this.endpoint
      )}/extend`,
      { method: "PUT" }
    ), this.postWithErrorHandling(
      "/zeebe-play/incidents/" + e + "/resolve",
      {
        endpoint: this.endpoint
      }
    );
  }
};
const _t = new pje();
function Sl() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function Oa(r) {
  return r.substring(0, 36);
}
const BB = {
  incidents: [],
  status: "initial"
};
let gje = class {
  state = { ...BB };
  constructor() {
    Hi(this);
  }
  fetchIncidents = async ({
    instanceKey: e,
    processId: t
  }) => {
    this.startFetching();
    const { success: n, incidents: i } = await _t.fetchIncidents({
      instanceKey: e
    });
    n ? (this.handleSuccess(i), i?.forEach(
      (s) => $i.trackIncident(s, t)
    )) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.incidents = e ?? [], this.state.status = "fetched";
  };
  updateRetries = async ({
    jobKey: e,
    numberOfRetries: t = 1
  }) => (await _t.updateRetries({
    jobKey: e,
    retries: t
  }))?.success !== !1;
  resolveIncident = async ({ incidentKey: e }) => _t.resolveIncident({ incidentKey: e });
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...BB };
  };
};
const uf = new gje(), PB = {
  messageSubscriptions: [],
  status: "initial"
};
let mje = class {
  state = { ...PB };
  constructor() {
    Hi(this);
  }
  fetchMessageSubscriptions = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, messageSubscriptions: n } = await _t.fetchMessageSubscriptions({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.messageSubscriptions = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...PB };
  };
};
const M3 = new mje(), FB = {
  definitionMessageSubscriptions: [],
  status: "initial"
};
class Aje {
  state = { ...FB };
  constructor() {
    Hi(this);
  }
  fetchMessageSubscriptions = async ({ playId: e }) => {
    this.startFetching();
    const { success: t, messageSubscriptions: n } = await _t.fetchProcessMessageSubscriptions({
      playId: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.definitionMessageSubscriptions = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...FB };
  };
}
const y7 = new Aje(), SM = () => (localStorage.getItem("play-firstProcessCompleted") ?? "false").toLowerCase() === "true", wje = () => {
  localStorage.setItem("play-firstProcessCompleted", "true");
}, zB = {
  instanceKey: void 0,
  processInstance: void 0,
  status: "initial",
  isProcessManuallyCompleted: !1,
  isCalledProcess: !1,
  instanceType: void 0
};
let vje = class {
  state = { ...zB };
  processManuallyCompletedDisposer = null;
  calledProcessDisposer = null;
  constructor() {
    Hi(this, { init: !1 });
  }
  init = () => {
    this.calledProcessDisposer = Xp(
      () => this.state.processInstance !== void 0,
      () => {
        const e = JSON.parse(
          localStorage.getItem("play-calledProcesses") || "[]"
        ), t = this.state.processInstance?.key !== void 0 && e.includes(this.state.processInstance?.key);
        this.setIsCalledProcess(t);
      }
    ), this.processManuallyCompletedDisposer = ms(
      () => this.state.processInstance?.state,
      (e, t) => {
        t !== void 0 && t !== "COMPLETED" && e === "COMPLETED" && !SM() && this.setIsProcessManuallyCompleted(!0);
      }
    );
  };
  setIsProcessManuallyCompleted = (e) => {
    this.state.isProcessManuallyCompleted = e;
  };
  setIsCalledProcess = (e) => {
    this.state.isCalledProcess = e;
  };
  fetchInstanceDetails = async ({ instanceId: e }) => {
    this.startFetching();
    const { success: t, processInstance: n } = await _t.fetchInstanceDetails({
      instanceId: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  setInstanceDetails = ({
    instanceKey: e,
    instanceType: t
  }) => {
    this.state.instanceKey = e, this.state.instanceType = t;
  };
  handleSuccess = (e) => {
    this.state.processInstance = e, this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.processManuallyCompletedDisposer?.(), this.calledProcessDisposer?.(), this.state = { ...zB };
  };
};
const Kt = new vje(), WB = {
  userTasks: [],
  status: "initial"
};
let bje = class {
  state = { ...WB };
  constructor() {
    Hi(this);
  }
  fetchUserTasks = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, userTasks: n } = await _t.fetchUserTasks({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.userTasks = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...WB };
  };
};
const D3 = new bje(), jB = {
  timers: [],
  status: "initial"
};
class yje {
  state = { ...jB };
  constructor() {
    Hi(this);
  }
  fetchTimers = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, timers: n } = await _t.fetchTimers({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.timers = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...jB };
  };
}
const b8 = new yje(), ZB = {
  timers: [],
  status: "initial"
};
class Cje {
  state = { ...ZB };
  constructor() {
    Hi(this);
  }
  fetchTimers = async ({ playId: e }) => {
    this.startFetching();
    const { success: t, timers: n } = await _t.fetchProcessTimers({
      playId: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.timers = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...ZB };
  };
}
const C7 = new Cje(), UB = { selection: null };
let Eje = class {
  state = { ...UB };
  rootNodeSelectionDisposer = null;
  constructor() {
    Hi(this, { init: !1 });
  }
  init = () => {
    this.rootNodeSelectionDisposer = Xp(
      () => Kt.state.processInstance?.key !== void 0,
      () => this.clearSelection()
    );
  };
  setSelection = (e) => {
    this.state.selection = e;
  };
  clearSelection = () => {
    this.setSelection(this.rootNode);
  };
  selectFlowNode = (e) => {
    e.flowNodeId === void 0 || !this.areMultipleInstancesSelected && this.isSelected(e) ? this.clearSelection() : this.setSelection(e);
  };
  get areMultipleInstancesSelected() {
    if (this.state.selection === null)
      return !1;
    const { flowNodeInstanceId: e, flowNodeId: t } = this.state.selection;
    return t !== void 0 && e === void 0;
  }
  get rootNode() {
    return {
      flowNodeInstanceId: Kt.state.processInstance?.key,
      isMultiInstance: !1
    };
  }
  get isRootNodeSelected() {
    return this.state.selection?.flowNodeInstanceId === Kt.state.processInstance?.key;
  }
  isSelected = ({
    flowNodeId: e,
    flowNodeInstanceId: t,
    isMultiInstance: n
  }) => {
    const { selection: i } = this.state;
    if (i === null || i.isMultiInstance !== n)
      return !1;
    if (i.flowNodeInstanceId === void 0) {
      const s = Ro.elementInstances.filter(
        ({ element: o }) => o.elementId === i.flowNodeId
      );
      return s.length > 1 ? s[s.length - 1].key === t : i.flowNodeId === e;
    }
    return i.flowNodeInstanceId === t;
  };
  reset = () => {
    this.state = { ...UB };
  };
};
const nh = new Eje(), qB = {
  variables: [],
  isUpdatingVariable: !1,
  status: "initial"
};
let _je = class {
  state = { ...qB };
  constructor() {
    Hi(this);
  }
  fetchVariables = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, variables: n } = await _t.fetchVariables({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.variables = e ?? [], this.state.status = "fetched";
  };
  setVariables = async ({
    instanceKey: e,
    scope: t,
    variablesString: n
  }) => {
    this.setIsUpdatingVariable(!0);
    const i = await _t.setVariables({
      instanceKey: e,
      scope: t,
      variablesString: n
    });
    return this.setIsUpdatingVariable(!1), i?.success !== !1;
  };
  setIsUpdatingVariable = (e) => {
    this.state.isUpdatingVariable = e;
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get scopeId() {
    const { selection: e } = nh.state;
    if (e?.flowNodeInstanceId !== void 0)
      return e.flowNodeInstanceId;
    const { elementInstances: t } = Ro.state, n = t?.elementInstances.filter(
      (i) => i.element.elementId === e?.flowNodeId
    );
    return n === void 0 || n.length === 0 ? null : n.length > 1 ? n[n.length - 1].key : n[0].key;
  }
  reset = () => {
    this.state = { ...qB };
  };
};
const tl = new _je(), GB = {
  jobs: [],
  status: "initial"
};
let xje = class {
  state = { ...GB };
  constructor() {
    Hi(this);
  }
  fetchJobs = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, jobs: n } = await _t.fetchJobs({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.jobs = e ?? [], this.state.status = "fetched";
  };
  completeJob = async ({
    jobKey: e,
    variables: t
  }) => (await _t.completeJob({
    jobKey: e,
    variables: t || "{}"
  }))?.success !== !1;
  failJob = async ({
    jobKey: e,
    retries: t,
    errorMessage: n
  }) => (await _t.failJob({
    jobKey: e,
    retries: t,
    errorMessage: n
  }))?.success !== !1;
  throwError = async ({
    jobKey: e,
    errorCode: t
  }) => (await _t.throwError({
    jobKey: e,
    errorCode: t
  }))?.success !== !1;
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get errorThrowableJobsByErrorId() {
    return this.state.jobs.filter(({ state: e }) => e === "ACTIVATABLE").reduce((e, { key: t, elementInstance: n }) => {
      const i = mi.elements?.find(
        ({ id: s }) => s === n.element.elementId
      );
      return mi.getAvailableErrorEvents(i).forEach(({ errorCode: s, errorName: o, errorElementId: a }) => {
        const l = {
          errorCode: s,
          errorName: o,
          job: {
            key: t,
            elementId: n.element.elementId,
            elementName: n.element.elementName ?? n.element.elementId
          }
        };
        e[a] === void 0 ? e[a] = [l] : e[a].push(l);
      }), e;
    }, {});
  }
  reset = () => {
    this.state = { ...GB };
  };
};
const ts = new xje(), QB = {
  childInstances: [],
  status: "initial"
};
let Sje = class {
  state = { ...QB };
  constructor() {
    Hi(this);
  }
  fetchChildInstances = async ({ instanceKey: e }) => {
    this.startFetching();
    const { success: t, childInstances: n } = await _t.fetchChildInstances({
      instanceKey: e
    });
    t ? this.handleSuccess(n) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.childInstances = e ?? [], this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...QB };
  };
};
const y8 = new Sje();
function Mje({ processId: r }) {
  const [e, t] = ye(
    () => Kt.state.instanceKey
  ), [n, i] = ye(() => kt.state.playId), [s, o] = ye(
    () => kt.state.endpoint
  ), [a, l] = ye(
    () => mi.state.elementRegistry
  );
  Pe(
    () => ms(
      () => Kt.state.instanceKey,
      (w) => t(w)
    ),
    []
  ), Pe(
    () => ms(
      () => mi.state.elementRegistry,
      (w) => l(w)
    ),
    []
  ), Pe(
    () => ms(
      () => kt.state.playId,
      (w) => i(w)
    ),
    []
  ), Pe(
    () => ms(
      () => kt.state.endpoint,
      (w) => o(w)
    ),
    []
  );
  const [c, d] = ye(!1), u = An(0), f = An(0);
  function p(w, v, y) {
    d(!1);
    let _;
    if (s?.startsWith("http")) {
      const M = new URL(s);
      _ = (M.protocol === "https" ? "wss" : "ws") + "://" + M.host + "/graphql";
    } else
      _ = "wss://" + s + "/graphql";
    const S = new WebSocket(_);
    S.addEventListener("open", () => {
      S.send(JSON.stringify({ type: "connection_init", payload: {} })), S.send(
        JSON.stringify({
          // since we only have one subscription on the socket,
          // the id is irrelevant and can be a single character to reduce traffic
          id: "1",
          type: "subscribe",
          payload: {
            variables: {},
            extensions: {},
            operationName: null,
            query: `subscription { ${w} }`
          }
        })
      );
    }), S.addEventListener("message", (M) => {
      const L = JSON.parse(M.data);
      L.type === "next" && v(L);
    }), S.addEventListener("error", (M) => {
      console.error("GraphQL subscription error", M);
    });
    const D = () => {
      const M = Date.now(), L = y === "process" ? u : f;
      M - L.current < 1e4 ? (d(!0), L.current = 0) : (L.current = M, p(w, v, y));
    };
    return S.addEventListener("close", D), () => {
      S.removeEventListener("close", D), S.close();
    };
  }
  const g = LB(
    async function(v) {
      Kt.fetchInstanceDetails({ instanceId: v }), ts.fetchJobs({ instanceKey: v }), D3.fetchUserTasks({ instanceKey: v }), b8.fetchTimers({ instanceKey: v }), M3.fetchMessageSubscriptions({
        instanceKey: v
      }), uf.fetchIncidents({ instanceKey: v, processId: r }), tl.fetchVariables({ instanceKey: v }), Ro.fetchElementInstances({
        instanceKey: v,
        processId: r,
        elementRegistry: a
      }), y8.fetchChildInstances({ instanceKey: v });
    },
    150
  ), m = LB(
    async function(v) {
      C7.fetchTimers({ playId: v }), y7.fetchMessageSubscriptions({
        playId: v
      });
    },
    150
  ), A = async function() {
    g(e), m(n);
  };
  return Pe(() => {
    if (e)
      return g(e), p(
        `processInstanceUpdates(filter: {processInstanceKey: ${e}}) {
        updateType
      }`,
        () => g(e),
        "processInstance"
      );
    if (n)
      return m(n), p(
        `processInstanceUpdates(filter: {processKey: ${n}}) {
        updateType
      }`,
        () => m(n),
        "process"
      );
  }, [e, n]), Pe(() => (e && (Kt.init(), nh.init()), () => {
    ts.reset(), b8.reset(), uf.reset(), M3.reset(), D3.reset(), tl.reset(), y8.reset(), Ro.reset(), nh.reset();
  }), [e]), {
    isConnectionDead: c,
    reloadFailedAPIs: A
  };
}
const Cr = Nxe({
  featureFlags: {
    isAcademyVideoExperiment: !1,
    areAIFeaturesEnabled: !1,
    isSaveExampleDataEnabled: !1
  }
});
if (!ye)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!xs)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function Dje(r) {
  r();
}
function Lje(r) {
  r || (r = Dje, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), Jze({ reactionScheduler: r });
}
function kje(r) {
  return VSe(r);
}
var Nje = 1e4, Tje = 1e4, Ije = (
  /** @class */
  function() {
    function r(e) {
      var t = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(n) {
          n === void 0 && (n = Nje), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
          var i = Date.now();
          t.registrations.forEach(function(s, o) {
            i - s.registeredAt >= n && (t.finalize(s.value), t.registrations.delete(o));
          }), t.registrations.size > 0 && t.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          t.sweep(0);
        }
      });
    }
    return Object.defineProperty(r.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e, t, n) {
        this.registrations.set(n, {
          value: t,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(r.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(e) {
        this.registrations.delete(e);
      }
    }), Object.defineProperty(r.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, Tje));
      }
    }), r;
  }()
), Oje = typeof FinalizationRegistry < "u" ? FinalizationRegistry : Ije, L3 = new Oje(function(r) {
  var e;
  (e = r.reaction) === null || e === void 0 || e.dispose(), r.reaction = null;
}), wv = { exports: {} }, GC = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KB;
function Rje() {
  if (KB) return GC;
  KB = 1;
  var r = h;
  function e(u, f) {
    return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
  }
  var t = typeof Object.is == "function" ? Object.is : e, n = r.useState, i = r.useEffect, s = r.useLayoutEffect, o = r.useDebugValue;
  function a(u, f) {
    var p = f(), g = n({ inst: { value: p, getSnapshot: f } }), m = g[0].inst, A = g[1];
    return s(
      function() {
        m.value = p, m.getSnapshot = f, l(m) && A({ inst: m });
      },
      [u, p, f]
    ), i(
      function() {
        return l(m) && A({ inst: m }), u(function() {
          l(m) && A({ inst: m });
        });
      },
      [u]
    ), o(p), p;
  }
  function l(u) {
    var f = u.getSnapshot;
    u = u.value;
    try {
      var p = f();
      return !t(u, p);
    } catch {
      return !0;
    }
  }
  function c(u, f) {
    return f();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return GC.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : d, GC;
}
var QC = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YB;
function Vje() {
  return YB || (YB = 1, process.env.NODE_ENV !== "production" && function() {
    function r(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function e(p, g) {
      d || i.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = g();
      if (!u) {
        var A = g();
        s(m, A) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), u = !0);
      }
      A = o({
        inst: { value: m, getSnapshot: g }
      });
      var w = A[0].inst, v = A[1];
      return l(
        function() {
          w.value = m, w.getSnapshot = g, t(w) && v({ inst: w });
        },
        [p, m, g]
      ), a(
        function() {
          return t(w) && v({ inst: w }), p(function() {
            t(w) && v({ inst: w });
          });
        },
        [p]
      ), c(m), m;
    }
    function t(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var m = g();
        return !s(p, m);
      } catch {
        return !0;
      }
    }
    function n(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = h, s = typeof Object.is == "function" ? Object.is : r, o = i.useState, a = i.useEffect, l = i.useLayoutEffect, c = i.useDebugValue, d = !1, u = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : e;
    QC.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), QC;
}
var XB;
function Hje() {
  return XB || (XB = 1, process.env.NODE_ENV === "production" ? wv.exports = Rje() : wv.exports = Vje()), wv.exports;
}
var Bje = Hje();
function JB(r) {
  r.reaction = new $l("observer".concat(r.name), function() {
    var e;
    r.stateVersion = Symbol(), (e = r.onStoreChange) === null || e === void 0 || e.call(r);
  });
}
function Pje(r, e) {
  e === void 0 && (e = "observed");
  var t = h.useRef(null);
  if (!t.current) {
    var n = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: e,
      subscribe: function(a) {
        return L3.unregister(n), n.onStoreChange = a, n.reaction || (JB(n), n.stateVersion = Symbol()), function() {
          var l;
          n.onStoreChange = null, (l = n.reaction) === null || l === void 0 || l.dispose(), n.reaction = null;
        };
      },
      getSnapshot: function() {
        return n.stateVersion;
      }
    };
    t.current = n;
  }
  var i = t.current;
  i.reaction || (JB(i), L3.register(t, i, i)), h.useDebugValue(i.reaction, kje), Bje.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var s, o;
  if (i.reaction.track(function() {
    try {
      s = r();
    } catch (a) {
      o = a;
    }
  }), o)
    throw o;
  return s;
}
var KC, YC, Fje = !0, $B = !0, hMe = typeof Symbol == "function" && Symbol.for, zje = (YC = (KC = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || KC === void 0 ? void 0 : KC.configurable) !== null && YC !== void 0 ? YC : !1, eP = hMe ? Symbol.for("react.forward_ref") : typeof r1 == "function" && r1(function(r) {
  return null;
}).$$typeof, tP = hMe ? Symbol.for("react.memo") : typeof cM == "function" && cM(function(r) {
  return null;
}).$$typeof;
function Wje(r, e) {
  var t;
  if (process.env.NODE_ENV, tP && r.$$typeof === tP)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var n = (t = void 0) !== null && t !== void 0 ? t : !1, i = r, s = r.displayName || r.name;
  if (eP && r.$$typeof === eP && (n = !0, i = r.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var o = function(a, l) {
    return Pje(function() {
      return i(a, l);
    }, s);
  };
  return o.displayName = r.displayName, zje && Object.defineProperty(o, "name", {
    value: r.name,
    writable: !0,
    configurable: !0
  }), r.contextTypes && (o.contextTypes = r.contextTypes, process.env.NODE_ENV !== "production" && $B && ($B = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), n && (o = r1(o)), o = cM(o), Zje(r, o), process.env.NODE_ENV !== "production" && Object.defineProperty(o, "contextTypes", {
    set: function() {
      var a, l;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((a = this.type) === null || a === void 0 ? void 0 : a.displayName) || ((l = this.type) === null || l === void 0 ? void 0 : l.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), o;
}
var jje = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function Zje(r, e) {
  Object.keys(r).forEach(function(t) {
    jje[t] || Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
  });
}
process.env.NODE_ENV;
var XC;
Lje(pFe);
XC = L3.finalizeAllImmediately;
function Uje(r, e) {
  if (nP(r, e))
    return !0;
  if (typeof r != "object" || r === null || typeof e != "object" || e === null)
    return !1;
  var t = Object.keys(r), n = Object.keys(e);
  if (t.length !== n.length)
    return !1;
  for (var i = 0; i < t.length; i++)
    if (!Object.hasOwnProperty.call(e, t[i]) || !nP(r[t[i]], e[t[i]]))
      return !1;
  return !0;
}
function nP(r, e) {
  return r === e ? r !== 0 || 1 / r === 1 / e : r !== r && e !== e;
}
var iP = /* @__PURE__ */ Symbol("patchMixins"), dMe = /* @__PURE__ */ Symbol("patchedDefinition");
function qje(r, e) {
  var t = r[iP] = r[iP] || {}, n = t[e] = t[e] || {};
  return n.locks = n.locks || 0, n.methods = n.methods || [], n;
}
function rP(r, e) {
  for (var t = this, n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)
    i[s - 2] = arguments[s];
  e.locks++;
  try {
    var o;
    return r != null && (o = r.apply(this, i)), o;
  } finally {
    e.locks--, e.locks === 0 && e.methods.forEach(function(a) {
      a.apply(t, i);
    });
  }
}
function sP(r, e) {
  var t = function() {
    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    rP.call.apply(rP, [this, r, e].concat(s));
  };
  return t;
}
function Gje(r, e, t) {
  var n = qje(r, e);
  n.methods.indexOf(t) < 0 && n.methods.push(t);
  var i = Object.getOwnPropertyDescriptor(r, e);
  if (!(i && i[dMe])) {
    var s = r[e], o = uMe(r, e, i ? i.enumerable : void 0, n, s);
    Object.defineProperty(r, e, o);
  }
}
function uMe(r, e, t, n, i) {
  var s, o = sP(i, n);
  return s = {}, s[dMe] = !0, s.get = function() {
    return o;
  }, s.set = function(l) {
    if (this === r)
      o = sP(l, n);
    else {
      var c = uMe(this, e, t, n, l);
      Object.defineProperty(this, e, c);
    }
  }, s.configurable = !0, s.enumerable = t, s;
}
var oP = /* @__PURE__ */ Symbol("ObserverAdministration"), aP = /* @__PURE__ */ Symbol("isMobXReactObserver"), fMe;
process.env.NODE_ENV !== "production" && (fMe = {
  props: /* @__PURE__ */ JC("props"),
  state: /* @__PURE__ */ JC("state"),
  context: /* @__PURE__ */ JC("context")
});
function k3(r) {
  var e;
  return (e = r[oP]) != null ? e : r[oP] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: c6(r.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function Qje(r) {
  var e = r.prototype;
  if (r[aP]) {
    var t = c6(r);
    throw new Error("The provided component class (" + t + ") has already been declared as an observer component.");
  } else
    r[aP] = !0;
  if (e.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (r.__proto__ !== r7) {
    if (!e.shouldComponentUpdate)
      e.shouldComponentUpdate = lP;
    else if (e.shouldComponentUpdate !== lP)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(e, fMe);
  var n = e.render;
  if (typeof n != "function") {
    var i = c6(r);
    throw new Error("[mobx-react] class component (" + i + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  e.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: Kje.call(this, n)
    }), this.render();
  };
  var s = e.componentDidMount;
  return e.componentDidMount = function() {
    var o = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var a = c6(r);
      throw new Error("[mobx-react] `observer(" + a + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var l = k3(this);
    return l.mounted = !0, L3.unregister(this), l.forceUpdate = function() {
      return o.forceUpdate();
    }, (!l.reaction || l.reactionInvalidatedBeforeMount) && l.forceUpdate(), s?.apply(this, arguments);
  }, Gje(e, "componentWillUnmount", function() {
    var o, a = k3(this);
    (o = a.reaction) == null || o.dispose(), a.reaction = null, a.forceUpdate = null, a.mounted = !1, a.reactionInvalidatedBeforeMount = !1;
  }), r;
}
function c6(r) {
  return r.displayName || r.name || "<component>";
}
function Kje(r) {
  var e = r.bind(this), t = k3(this);
  function n() {
    t.reaction || (t.reaction = Yje(t), t.mounted || L3.register(this, t, this));
    var i = void 0, s = void 0;
    if (t.reaction.track(function() {
      try {
        s = JT(!1, e);
      } catch (o) {
        i = o;
      }
    }), i)
      throw i;
    return s;
  }
  return n;
}
function Yje(r) {
  return new $l(r.name + ".render()", function() {
    if (!r.mounted) {
      r.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      r.forceUpdate == null || r.forceUpdate();
    } catch {
      var e;
      (e = r.reaction) == null || e.dispose(), r.reaction = null;
    }
  });
}
function lP(r, e) {
  return this.state !== e ? !0 : !Uje(this.props, r);
}
function JC(r) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var t = k3(this), n = Tze().trackingDerivation;
      if (n && n !== t.reaction)
        throw new Error('[mobx-react] Cannot read "' + t.name + "." + r + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return t[r];
    },
    set: function(t) {
      k3(this)[r] = t;
    }
  };
}
function rt(r, e) {
  return r.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Txe, r) || Object.prototype.isPrototypeOf.call(r7, r) ? Qje(r) : Wje(r);
}
h.version.split(".")[0];
if (!Txe)
  throw new Error("mobx-react requires React to be available");
if (!$n)
  throw new Error("mobx-react requires mobx to be available");
function Xje(r, e, t) {
  return (e = eZe(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function cP(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function $C(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cP(Object(t), !0).forEach(function(n) {
      Xje(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : cP(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function hP(r, e) {
  if (r == null) return {};
  var t, n, i = Jje(r, e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(r);
    for (n = 0; n < s.length; n++) t = s[n], e.includes(t) || {}.propertyIsEnumerable.call(r, t) && (i[t] = r[t]);
  }
  return i;
}
function Jje(r, e) {
  if (r == null) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function $je(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function eZe(r) {
  var e = $je(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
var tZe = ["width", "height", "viewBox"], nZe = ["tabindex"], iZe = {
  // Reference:
  // https://github.com/IBM/carbon-components-react/issues/1392
  // https://github.com/PolymerElements/iron-iconset-svg/pull/47
  // `focusable` is a string attribute which is why we do not use a boolean here
  focusable: "false",
  preserveAspectRatio: "xMidYMid meet"
};
function rZe() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = r.width, t = r.height, n = r.viewBox, i = n === void 0 ? "0 0 ".concat(e, " ").concat(t) : n, s = hP(r, tZe), o = s.tabindex, a = hP(s, nZe), l = $C($C($C({}, iZe), a), {}, {
    width: e,
    height: t,
    viewBox: i
  });
  return l["aria-label"] || l["aria-labelledby"] || l.title ? (l.role = "img", o != null && (l.focusable = "true", l.tabindex = o)) : l["aria-hidden"] = !0, l;
}
var vv = { exports: {} }, bv = { exports: {} }, ii = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dP;
function sZe() {
  if (dP) return ii;
  dP = 1;
  var r = typeof Symbol == "function" && Symbol.for, e = r ? Symbol.for("react.element") : 60103, t = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, s = r ? Symbol.for("react.profiler") : 60114, o = r ? Symbol.for("react.provider") : 60109, a = r ? Symbol.for("react.context") : 60110, l = r ? Symbol.for("react.async_mode") : 60111, c = r ? Symbol.for("react.concurrent_mode") : 60111, d = r ? Symbol.for("react.forward_ref") : 60112, u = r ? Symbol.for("react.suspense") : 60113, f = r ? Symbol.for("react.suspense_list") : 60120, p = r ? Symbol.for("react.memo") : 60115, g = r ? Symbol.for("react.lazy") : 60116, m = r ? Symbol.for("react.block") : 60121, A = r ? Symbol.for("react.fundamental") : 60117, w = r ? Symbol.for("react.responder") : 60118, v = r ? Symbol.for("react.scope") : 60119;
  function y(S) {
    if (typeof S == "object" && S !== null) {
      var D = S.$$typeof;
      switch (D) {
        case e:
          switch (S = S.type, S) {
            case l:
            case c:
            case n:
            case s:
            case i:
            case u:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case a:
                case d:
                case g:
                case p:
                case o:
                  return S;
                default:
                  return D;
              }
          }
        case t:
          return D;
      }
    }
  }
  function _(S) {
    return y(S) === c;
  }
  return ii.AsyncMode = l, ii.ConcurrentMode = c, ii.ContextConsumer = a, ii.ContextProvider = o, ii.Element = e, ii.ForwardRef = d, ii.Fragment = n, ii.Lazy = g, ii.Memo = p, ii.Portal = t, ii.Profiler = s, ii.StrictMode = i, ii.Suspense = u, ii.isAsyncMode = function(S) {
    return _(S) || y(S) === l;
  }, ii.isConcurrentMode = _, ii.isContextConsumer = function(S) {
    return y(S) === a;
  }, ii.isContextProvider = function(S) {
    return y(S) === o;
  }, ii.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === e;
  }, ii.isForwardRef = function(S) {
    return y(S) === d;
  }, ii.isFragment = function(S) {
    return y(S) === n;
  }, ii.isLazy = function(S) {
    return y(S) === g;
  }, ii.isMemo = function(S) {
    return y(S) === p;
  }, ii.isPortal = function(S) {
    return y(S) === t;
  }, ii.isProfiler = function(S) {
    return y(S) === s;
  }, ii.isStrictMode = function(S) {
    return y(S) === i;
  }, ii.isSuspense = function(S) {
    return y(S) === u;
  }, ii.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === n || S === c || S === s || S === i || S === u || S === f || typeof S == "object" && S !== null && (S.$$typeof === g || S.$$typeof === p || S.$$typeof === o || S.$$typeof === a || S.$$typeof === d || S.$$typeof === A || S.$$typeof === w || S.$$typeof === v || S.$$typeof === m);
  }, ii.typeOf = y, ii;
}
var ri = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var uP;
function oZe() {
  return uP || (uP = 1, process.env.NODE_ENV !== "production" && function() {
    var r = typeof Symbol == "function" && Symbol.for, e = r ? Symbol.for("react.element") : 60103, t = r ? Symbol.for("react.portal") : 60106, n = r ? Symbol.for("react.fragment") : 60107, i = r ? Symbol.for("react.strict_mode") : 60108, s = r ? Symbol.for("react.profiler") : 60114, o = r ? Symbol.for("react.provider") : 60109, a = r ? Symbol.for("react.context") : 60110, l = r ? Symbol.for("react.async_mode") : 60111, c = r ? Symbol.for("react.concurrent_mode") : 60111, d = r ? Symbol.for("react.forward_ref") : 60112, u = r ? Symbol.for("react.suspense") : 60113, f = r ? Symbol.for("react.suspense_list") : 60120, p = r ? Symbol.for("react.memo") : 60115, g = r ? Symbol.for("react.lazy") : 60116, m = r ? Symbol.for("react.block") : 60121, A = r ? Symbol.for("react.fundamental") : 60117, w = r ? Symbol.for("react.responder") : 60118, v = r ? Symbol.for("react.scope") : 60119;
    function y(ae) {
      return typeof ae == "string" || typeof ae == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ae === n || ae === c || ae === s || ae === i || ae === u || ae === f || typeof ae == "object" && ae !== null && (ae.$$typeof === g || ae.$$typeof === p || ae.$$typeof === o || ae.$$typeof === a || ae.$$typeof === d || ae.$$typeof === A || ae.$$typeof === w || ae.$$typeof === v || ae.$$typeof === m);
    }
    function _(ae) {
      if (typeof ae == "object" && ae !== null) {
        var Oe = ae.$$typeof;
        switch (Oe) {
          case e:
            var ot = ae.type;
            switch (ot) {
              case l:
              case c:
              case n:
              case s:
              case i:
              case u:
                return ot;
              default:
                var It = ot && ot.$$typeof;
                switch (It) {
                  case a:
                  case d:
                  case g:
                  case p:
                  case o:
                    return It;
                  default:
                    return Oe;
                }
            }
          case t:
            return Oe;
        }
      }
    }
    var S = l, D = c, M = a, L = o, T = e, B = d, V = n, N = g, R = p, H = t, z = s, U = i, ee = u, ce = !1;
    function se(ae) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), te(ae) || _(ae) === l;
    }
    function te(ae) {
      return _(ae) === c;
    }
    function ue(ae) {
      return _(ae) === a;
    }
    function G(ae) {
      return _(ae) === o;
    }
    function j(ae) {
      return typeof ae == "object" && ae !== null && ae.$$typeof === e;
    }
    function pe(ae) {
      return _(ae) === d;
    }
    function De(ae) {
      return _(ae) === n;
    }
    function Ce(ae) {
      return _(ae) === g;
    }
    function F(ae) {
      return _(ae) === p;
    }
    function I(ae) {
      return _(ae) === t;
    }
    function O(ae) {
      return _(ae) === s;
    }
    function Y(ae) {
      return _(ae) === i;
    }
    function K(ae) {
      return _(ae) === u;
    }
    ri.AsyncMode = S, ri.ConcurrentMode = D, ri.ContextConsumer = M, ri.ContextProvider = L, ri.Element = T, ri.ForwardRef = B, ri.Fragment = V, ri.Lazy = N, ri.Memo = R, ri.Portal = H, ri.Profiler = z, ri.StrictMode = U, ri.Suspense = ee, ri.isAsyncMode = se, ri.isConcurrentMode = te, ri.isContextConsumer = ue, ri.isContextProvider = G, ri.isElement = j, ri.isForwardRef = pe, ri.isFragment = De, ri.isLazy = Ce, ri.isMemo = F, ri.isPortal = I, ri.isProfiler = O, ri.isStrictMode = Y, ri.isSuspense = K, ri.isValidElementType = y, ri.typeOf = _;
  }()), ri;
}
var fP;
function pMe() {
  return fP || (fP = 1, process.env.NODE_ENV === "production" ? bv.exports = sZe() : bv.exports = oZe()), bv.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var eE, pP;
function aZe() {
  if (pP) return eE;
  pP = 1;
  var r = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(d) {
        return o[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return eE = i() ? Object.assign : function(s, o) {
    for (var a, l = n(s), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var u in a)
        e.call(a, u) && (l[u] = a[u]);
      if (r) {
        c = r(a);
        for (var f = 0; f < c.length; f++)
          t.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, eE;
}
var tE, gP;
function lI() {
  if (gP) return tE;
  gP = 1;
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return tE = r, tE;
}
var nE, mP;
function gMe() {
  return mP || (mP = 1, nE = Function.call.bind(Object.prototype.hasOwnProperty)), nE;
}
var iE, AP;
function lZe() {
  if (AP) return iE;
  AP = 1;
  var r = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ lI(), t = {}, n = /* @__PURE__ */ gMe();
    r = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(s, o, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in s)
        if (n(s, d)) {
          var u;
          try {
            if (typeof s[d] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            u = s[d](o, d, l, a, null, e);
          } catch (g) {
            u = g;
          }
          if (u && !(u instanceof Error) && r(
            (l || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in t)) {
            t[u.message] = !0;
            var p = c ? c() : "";
            r(
              "Failed " + a + " type: " + u.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, iE = i, iE;
}
var rE, wP;
function cZe() {
  if (wP) return rE;
  wP = 1;
  var r = pMe(), e = aZe(), t = /* @__PURE__ */ lI(), n = /* @__PURE__ */ gMe(), i = /* @__PURE__ */ lZe(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return rE = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function u(te) {
      var ue = te && (c && te[c] || te[d]);
      if (typeof ue == "function")
        return ue;
    }
    var f = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: v(),
      arrayOf: y,
      element: _(),
      elementType: S(),
      instanceOf: D,
      node: B(),
      objectOf: L,
      oneOf: M,
      oneOfType: T,
      shape: N,
      exact: R
    };
    function g(te, ue) {
      return te === ue ? te !== 0 || 1 / te === 1 / ue : te !== te && ue !== ue;
    }
    function m(te, ue) {
      this.message = te, this.data = ue && typeof ue == "object" ? ue : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function A(te) {
      if (process.env.NODE_ENV !== "production")
        var ue = {}, G = 0;
      function j(De, Ce, F, I, O, Y, K) {
        if (I = I || f, Y = Y || F, K !== t) {
          if (l) {
            var ae = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ae.name = "Invariant Violation", ae;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Oe = I + ":" + F;
            !ue[Oe] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ue[Oe] = !0, G++);
          }
        }
        return Ce[F] == null ? De ? Ce[F] === null ? new m("The " + O + " `" + Y + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new m("The " + O + " `" + Y + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : te(Ce, F, I, O, Y);
      }
      var pe = j.bind(null, !1);
      return pe.isRequired = j.bind(null, !0), pe;
    }
    function w(te) {
      function ue(G, j, pe, De, Ce, F) {
        var I = G[j], O = U(I);
        if (O !== te) {
          var Y = ee(I);
          return new m(
            "Invalid " + De + " `" + Ce + "` of type " + ("`" + Y + "` supplied to `" + pe + "`, expected ") + ("`" + te + "`."),
            { expectedType: te }
          );
        }
        return null;
      }
      return A(ue);
    }
    function v() {
      return A(o);
    }
    function y(te) {
      function ue(G, j, pe, De, Ce) {
        if (typeof te != "function")
          return new m("Property `" + Ce + "` of component `" + pe + "` has invalid PropType notation inside arrayOf.");
        var F = G[j];
        if (!Array.isArray(F)) {
          var I = U(F);
          return new m("Invalid " + De + " `" + Ce + "` of type " + ("`" + I + "` supplied to `" + pe + "`, expected an array."));
        }
        for (var O = 0; O < F.length; O++) {
          var Y = te(F, O, pe, De, Ce + "[" + O + "]", t);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return A(ue);
    }
    function _() {
      function te(ue, G, j, pe, De) {
        var Ce = ue[G];
        if (!a(Ce)) {
          var F = U(Ce);
          return new m("Invalid " + pe + " `" + De + "` of type " + ("`" + F + "` supplied to `" + j + "`, expected a single ReactElement."));
        }
        return null;
      }
      return A(te);
    }
    function S() {
      function te(ue, G, j, pe, De) {
        var Ce = ue[G];
        if (!r.isValidElementType(Ce)) {
          var F = U(Ce);
          return new m("Invalid " + pe + " `" + De + "` of type " + ("`" + F + "` supplied to `" + j + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return A(te);
    }
    function D(te) {
      function ue(G, j, pe, De, Ce) {
        if (!(G[j] instanceof te)) {
          var F = te.name || f, I = se(G[j]);
          return new m("Invalid " + De + " `" + Ce + "` of type " + ("`" + I + "` supplied to `" + pe + "`, expected ") + ("instance of `" + F + "`."));
        }
        return null;
      }
      return A(ue);
    }
    function M(te) {
      if (!Array.isArray(te))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function ue(G, j, pe, De, Ce) {
        for (var F = G[j], I = 0; I < te.length; I++)
          if (g(F, te[I]))
            return null;
        var O = JSON.stringify(te, function(K, ae) {
          var Oe = ee(ae);
          return Oe === "symbol" ? String(ae) : ae;
        });
        return new m("Invalid " + De + " `" + Ce + "` of value `" + String(F) + "` " + ("supplied to `" + pe + "`, expected one of " + O + "."));
      }
      return A(ue);
    }
    function L(te) {
      function ue(G, j, pe, De, Ce) {
        if (typeof te != "function")
          return new m("Property `" + Ce + "` of component `" + pe + "` has invalid PropType notation inside objectOf.");
        var F = G[j], I = U(F);
        if (I !== "object")
          return new m("Invalid " + De + " `" + Ce + "` of type " + ("`" + I + "` supplied to `" + pe + "`, expected an object."));
        for (var O in F)
          if (n(F, O)) {
            var Y = te(F, O, pe, De, Ce + "." + O, t);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return A(ue);
    }
    function T(te) {
      if (!Array.isArray(te))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var ue = 0; ue < te.length; ue++) {
        var G = te[ue];
        if (typeof G != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(G) + " at index " + ue + "."
          ), o;
      }
      function j(pe, De, Ce, F, I) {
        for (var O = [], Y = 0; Y < te.length; Y++) {
          var K = te[Y], ae = K(pe, De, Ce, F, I, t);
          if (ae == null)
            return null;
          ae.data && n(ae.data, "expectedType") && O.push(ae.data.expectedType);
        }
        var Oe = O.length > 0 ? ", expected one of type [" + O.join(", ") + "]" : "";
        return new m("Invalid " + F + " `" + I + "` supplied to " + ("`" + Ce + "`" + Oe + "."));
      }
      return A(j);
    }
    function B() {
      function te(ue, G, j, pe, De) {
        return H(ue[G]) ? null : new m("Invalid " + pe + " `" + De + "` supplied to " + ("`" + j + "`, expected a ReactNode."));
      }
      return A(te);
    }
    function V(te, ue, G, j, pe) {
      return new m(
        (te || "React class") + ": " + ue + " type `" + G + "." + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + pe + "`."
      );
    }
    function N(te) {
      function ue(G, j, pe, De, Ce) {
        var F = G[j], I = U(F);
        if (I !== "object")
          return new m("Invalid " + De + " `" + Ce + "` of type `" + I + "` " + ("supplied to `" + pe + "`, expected `object`."));
        for (var O in te) {
          var Y = te[O];
          if (typeof Y != "function")
            return V(pe, De, Ce, O, ee(Y));
          var K = Y(F, O, pe, De, Ce + "." + O, t);
          if (K)
            return K;
        }
        return null;
      }
      return A(ue);
    }
    function R(te) {
      function ue(G, j, pe, De, Ce) {
        var F = G[j], I = U(F);
        if (I !== "object")
          return new m("Invalid " + De + " `" + Ce + "` of type `" + I + "` " + ("supplied to `" + pe + "`, expected `object`."));
        var O = e({}, G[j], te);
        for (var Y in O) {
          var K = te[Y];
          if (n(te, Y) && typeof K != "function")
            return V(pe, De, Ce, Y, ee(K));
          if (!K)
            return new m(
              "Invalid " + De + " `" + Ce + "` key `" + Y + "` supplied to `" + pe + "`.\nBad object: " + JSON.stringify(G[j], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(te), null, "  ")
            );
          var ae = K(F, Y, pe, De, Ce + "." + Y, t);
          if (ae)
            return ae;
        }
        return null;
      }
      return A(ue);
    }
    function H(te) {
      switch (typeof te) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !te;
        case "object":
          if (Array.isArray(te))
            return te.every(H);
          if (te === null || a(te))
            return !0;
          var ue = u(te);
          if (ue) {
            var G = ue.call(te), j;
            if (ue !== te.entries) {
              for (; !(j = G.next()).done; )
                if (!H(j.value))
                  return !1;
            } else
              for (; !(j = G.next()).done; ) {
                var pe = j.value;
                if (pe && !H(pe[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(te, ue) {
      return te === "symbol" ? !0 : ue ? ue["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ue instanceof Symbol : !1;
    }
    function U(te) {
      var ue = typeof te;
      return Array.isArray(te) ? "array" : te instanceof RegExp ? "object" : z(ue, te) ? "symbol" : ue;
    }
    function ee(te) {
      if (typeof te > "u" || te === null)
        return "" + te;
      var ue = U(te);
      if (ue === "object") {
        if (te instanceof Date)
          return "date";
        if (te instanceof RegExp)
          return "regexp";
      }
      return ue;
    }
    function ce(te) {
      var ue = ee(te);
      switch (ue) {
        case "array":
        case "object":
          return "an " + ue;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ue;
        default:
          return ue;
      }
    }
    function se(te) {
      return !te.constructor || !te.constructor.name ? f : te.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, rE;
}
var sE, vP;
function hZe() {
  if (vP) return sE;
  vP = 1;
  var r = /* @__PURE__ */ lI();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, sE = function() {
    function n(o, a, l, c, d, u) {
      if (u !== r) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var s = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, sE;
}
var bP;
function dZe() {
  if (bP) return vv.exports;
  if (bP = 1, process.env.NODE_ENV !== "production") {
    var r = pMe(), e = !0;
    vv.exports = /* @__PURE__ */ cZe()(r.isElement, e);
  } else
    vv.exports = /* @__PURE__ */ hZe()();
  return vv.exports;
}
var N3 = /* @__PURE__ */ dZe();
const Hn = /* @__PURE__ */ a7(N3), b = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    className: n,
    children: i,
    tabIndex: s,
    xmlns: o = "http://www.w3.org/2000/svg",
    preserveAspectRatio: a = "xMidYMid meet",
    ...l
  } = e;
  const {
    tabindex: c,
    ...d
  } = rZe({
    ...l,
    tabindex: s
  }), u = d;
  return n && (u.className = n), c != null && (typeof c == "number" ? u.tabIndex = c : u.tabIndex = Number(s)), t && (u.ref = t), o && (u.xmlns = o), a && (u.preserveAspectRatio = a), /* @__PURE__ */ h.createElement("svg", u, i);
});
b.displayName = "Icon";
b.propTypes = {
  "aria-hidden": Hn.oneOfType([Hn.bool, Hn.oneOf(["true", "false"])]),
  "aria-label": Hn.string,
  "aria-labelledby": Hn.string,
  children: Hn.node,
  className: Hn.string,
  height: Hn.oneOfType([Hn.number, Hn.string]),
  preserveAspectRatio: Hn.string,
  tabIndex: Hn.oneOfType([Hn.number, Hn.string]),
  viewBox: Hn.string,
  width: Hn.oneOfType([Hn.number, Hn.string]),
  xmlns: Hn.string
};
const E = {
  size: Hn.oneOfType([Hn.number, Hn.string])
};
var yP, CP, EP, _P, xP, SP, MP, DP, LP, kP, NP, TP, IP, OP, RP, VP, HP, BP, PP, FP, zP, WP, jP, ZP, UP, qP, GP, QP, KP, YP, XP, JP, $P, eF, tF, nF, iF, rF, sF, oF, aF, lF, cF, hF, dF, uF, fF, pF, gF, mF, AF, wF, vF, bF, yF, CF, EF, _F, xF, SF, MF, DF, LF, kF, NF, TF, IF, OF, RF, VF, HF, BF, PF, FF, zF, WF, jF, ZF, UF, qF, GF, QF, KF, YF, XF, JF, $F, ez, tz, nz, iz, rz, sz, oz, az, lz, cz, hz, dz, uz, fz, pz, gz, mz, Az, wz, vz, bz, yz, Cz, Ez, _z, xz, Sz, Mz, Dz, Lz, kz, Nz, Tz, Iz, Oz, Rz, Vz, Hz, Bz, Pz, Fz, zz, Wz, jz, Zz, Uz, qz, Gz, Qz, Kz, Yz, Xz, Jz, $z, eW, tW, nW, iW, rW, sW, oW, aW, lW, cW, hW, dW, uW, fW, pW, gW, mW, AW, wW, vW, bW, yW, CW, EW, _W, xW, SW, MW, DW, LW, kW, NW, TW, IW, OW, RW, VW, HW, BW, PW, FW, zW, WW, jW, ZW, UW, qW, GW, QW, KW, YW, XW, JW, $W, ej, tj, nj, ij, rj, sj, oj, aj, lj, cj, hj, dj, uj;
const fj = {}, uZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yP || (yP = /* @__PURE__ */ h.createElement("path", {
    d: "M13 4L4 4 4 13.01 6 13.01 6 6 13 6 13 4zM29.49 13.12l-9-5a1 1 0 00-1 0l-9 5A1 1 0 0010 14V24a1 1 0 00.52.87l9 5A1 1 0 0020 30a1.05 1.05 0 00.49-.13l9-5A1 1 0 0030 24V14A1 1 0 0029.49 13.12zM19 27.3l-7-3.89V15.69l7 3.89zm1-9.45L13.06 14 20 10.14 26.94 14zm8 5.56L21 27.3V19.58l7-3.89z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uZe.propTypes = E);
const fZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CP || (CP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), EP || (EP = /* @__PURE__ */ h.createElement("path", {
    d: "M15 7H17V14H15zM7 15H14V17H7zM15 18H17V25H15zM18 15H25V17H18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fZe.propTypes = E);
const pZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _P || (_P = /* @__PURE__ */ h.createElement("path", {
    d: "M9.5,8H20.1a5,5,0,1,0,0-2H9.5a5.5,5.5,0,0,0,0,11h11a3.5,3.5,0,0,1,0,7H11.9a5,5,0,1,0,0,2h8.6a5.5,5.5,0,0,0,0-11H9.5a3.5,3.5,0,0,1,0-7ZM25,4a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pZe.propTypes = E);
const gZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xP || (xP = /* @__PURE__ */ h.createElement("path", {
    d: "M17,11a3,3,0,0,1,3-3h.1a5,5,0,1,0,0-2H20a5,5,0,0,0-5,5v1H13a3,3,0,0,1-3-3V7A5,5,0,0,0,5,2H4V4H5A3,3,0,0,1,8,7V9a5,5,0,0,0,5,5h2v7a3,3,0,0,1-3,3h-.1a5,5,0,1,0,0,2H12a5,5,0,0,0,5-5h2.5A2.5,2.5,0,0,1,22,23.5,4.51,4.51,0,0,0,26.5,28H28V26H26.5A2.5,2.5,0,0,1,24,23.5,4.51,4.51,0,0,0,19.5,19H17Zm8-7a3,3,0,1,1-3,3A3,3,0,0,1,25,4ZM7,28a3,3,0,1,1,3-3A3,3,0,0,1,7,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gZe.propTypes = E);
const mZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SP || (SP = /* @__PURE__ */ h.createElement("path", {
    d: "M15 21a3 3 0 01-3 3h-.1a5 5 0 100 2H12a5 5 0 005-5zM7 28a3 3 0 113-3A3 3 0 017 28zM15 13H17V19H15zM25 2a5 5 0 00-4.9 4H20a5 5 0 00-5 5h2a3 3 0 013-3h.1A5 5 0 1025 2zm0 8a3 3 0 113-3A3 3 0 0125 10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mZe.propTypes = E);
const AZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MP || (MP = /* @__PURE__ */ h.createElement("path", {
    d: "M15 14H10a2 2 0 01-2-2V4a2 2 0 01.59-1.42A3.57 3.57 0 0110 2h5V4H10v8h5zM4 6H6V14H4zM4 2H6V4H4zM27.45 19.11l-6-3a1 1 0 00-.9 0l-6 3A1 1 0 0014 20v7a1 1 0 00.55.89l6 3a1 1 0 00.9 0l6-3A1 1 0 0028 27V20A1 1 0 0027.45 19.11zm-6.45-1L24.76 20 21 21.88 17.24 20zm-5 3.5l4 2v4.76l-4-2zm6 6.76V23.62l4-2v4.76zM23 2H19a2 2 0 00-2 2V14h2V10h4v4h2V4A2 2 0 0023 2zM19 8V4h4V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AZe.propTypes = E);
const wZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DP || (DP = /* @__PURE__ */ h.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM25.49 10.13l-9-5a1 1 0 00-1 0l-9 5A1 1 0 006 11V21a1 1 0 00.51.87l9 5a1 1 0 001 0l9-5A1 1 0 0026 21V11A1 1 0 0025.49 10.13zM16 7.14L22.94 11 16 14.86 9.06 11zM8 12.7l7 3.89V24.3L8 20.41zm9 11.6V16.59l7-3.89v7.71z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wZe.propTypes = E);
const vZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, LP || (LP = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9761,15.7832l-2-9a.9992.9992,0,0,0-.4214-.6152l-6-4A1.0008,1.0008,0,0,0,21,2H11a1.0008,1.0008,0,0,0-.5547.168l-6,4a.9992.9992,0,0,0-.4214.6152l-2,9a1.0019,1.0019,0,0,0,.0181.5039l3,10a1,1,0,0,0,.6709.6709l10,3,.0051.0005a.9789.9789,0,0,0,.564,0l.0051-.0005,10-3a1,1,0,0,0,.6709-.6709l3-10A1.0019,1.0019,0,0,0,29.9761,15.7832Zm-19.05.833L7.0168,8.7974l7.2815,2.6479ZM16,12.4971,19.5889,18H12.4111ZM19.3818,20,16,26.7637,12.6182,20Zm-1.68-8.5547,7.2815-2.6479-3.91,7.8188ZM18.19,9.14l3.0961-4.747,3.5152,2.3432ZM16,8.8364,12.8459,4h6.3082Zm-2.19.3032L7.1992,6.7358l3.5152-2.3432Zm-4.8439,8.03-4.802-1.8007L5.3652,9.9668ZM14.07,27.377,7.5679,25.4263l3.1284-4.7969Zm7.2334-6.7476,3.1284,4.7969L17.93,27.377ZM26.6348,9.9668l1.2006,5.4019-4.802,1.8007ZM4.5374,17.6445l4.5944,1.7227L6.3391,23.65ZM25.6609,23.65l-2.7927-4.2827,4.5944-1.7227Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vZe.propTypes = E);
const bZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kP || (kP = /* @__PURE__ */ h.createElement("path", {
    d: "M21.49 13.1151l-9-5a1 1 0 00-1 0l-9 5A1.0078 1.0078 0 002 14v9.9951a1 1 0 00.52.87l9 5A1.0045 1.0045 0 0012 30a1.0559 1.0559 0 00.49-.1349l9-5A.9923.9923 0 0022 24V14A1.0079 1.0079 0 0021.49 13.1151zM11 27.2951l-7-3.89v-7.72l7 3.89zm1-9.45L5.06 14 12 10.1351l6.94 3.86zm8 5.56l-7 3.89v-7.72l7-3.89zM30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bZe.propTypes = E);
const yZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, NP || (NP = /* @__PURE__ */ h.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yZe.propTypes = E);
const CZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TP || (TP = /* @__PURE__ */ h.createElement("path", {
    d: "M12 11.03L12 15.03 10 15.03 10 11.03 8 11.03 8 17.03 12 17.03 12 21.03 14 21.03 14 11.03 12 11.03zM24.19 11.03L22 11.03 19 15.42 19 11.03 17 11.03 17 21.03 19 21.03 19 18.3 19.91 16.97 22 21.03 24.19 21.03 21.2 15.41 24.19 11.03z"
  })), IP || (IP = /* @__PURE__ */ h.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CZe.propTypes = E);
const EZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OP || (OP = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM14,21H12V17H8V11h2v4h2V11h2Zm10.19,0H22l-2.09-4.06L19,18.27V21H17V11h2v4.39L22,11h2.19l-3,4.38Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EZe.propTypes = E);
const _Ze = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RP || (RP = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m23.0022,11.0323l-15.0022-.0323,6.9985,5-6.9956,5h14.9971c.5523,0,1-.4477,1-1v-7.9677c0-.5514-.4464-.9988-.9978-1Z"
  })), VP || (VP = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Ze.propTypes = E);
const xZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HP || (HP = /* @__PURE__ */ h.createElement("path", {
    d: "M29.55 26.11L26.5 27.63 23.66 21H15a2 2 0 01-2-2V13a2 2 0 014 0v4h7V15H19V13a4 4 0 00-8 0v1a9 9 0 108.77 11H17.71A7 7 0 1111 16v3a4 4 0 004 4h7.34l3.16 7.37 4.95-2.48zM15.5 8A3.5 3.5 0 1119 4.5 3.5 3.5 0 0115.5 8zm0-5A1.5 1.5 0 1017 4.5 1.5 1.5 0 0015.5 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xZe.propTypes = E);
const SZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BP || (BP = /* @__PURE__ */ h.createElement("path", {
    d: "M23 14L23 12 9 12 9 14 14 14 14 16.734 10.132 23.504 11.868 24.496 15.58 18 16.42 18 20.132 24.496 21.868 23.504 18 16.734 18 14 23 14z"
  })), PP || (PP = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), FP || (FP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SZe.propTypes = E);
const MZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zP || (zP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), WP || (WP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), jP || (jP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MZe.propTypes = E);
const DZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZP || (ZP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,10a8.5975,8.5975,0,0,0-7.9648,6A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), UP || (UP = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,22a10.6543,10.6543,0,0,1-9.97-7.7578L5.9692,16l.0606-.2422A10.6543,10.6543,0,0,1,16,8a10.6543,10.6543,0,0,1,9.97,7.7578L26.0308,16l-.0606.2422A10.6543,10.6543,0,0,1,16,24Z"
  })), qP || (qP = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), GP || (GP = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), QP || (QP = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,24a10.6547,10.6547,0,0,1-9.97-7.7576L5.9692,16l.0606-.2424A10.6547,10.6547,0,0,1,16,8a10.6547,10.6547,0,0,1,9.97,7.7576L26.0308,16l-.0606.2424A10.6547,10.6547,0,0,1,16,24ZM8.0352,16A8.5975,8.5975,0,0,0,16,22a8.5975,8.5975,0,0,0,7.9648-6A8.5975,8.5975,0,0,0,16,10,8.5975,8.5975,0,0,0,8.0352,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DZe.propTypes = E);
const LZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KP || (KP = /* @__PURE__ */ h.createElement("path", {
    d: "M8,14H19v2H8Zm0,5H21v2H8Z"
  })), YP || (YP = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V8H4V6ZM4,26V10H28V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LZe.propTypes = E);
const kZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, XP || (XP = /* @__PURE__ */ h.createElement("path", {
    d: "M22 8L22 16 23 18 24 16 24 8 22 8zM18 8L18 18 19 20 20 18 20 8 18 8z"
  })), JP || (JP = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h8v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kZe.propTypes = E);
const NZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $P || ($P = /* @__PURE__ */ h.createElement("path", {
    d: "M16 16H18V18H16zM18 18H20V20H18zM20 20H22V22H20zM20 16H22V18H20zM16 20H18V22H16zM20 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L19.17 2.4141a1.0381 1.0381 0 011.6592 0L23.3154 6.11A3.9693 3.9693 0 0124 8.223 3.8978 3.8978 0 0120 12zm0-7.2368L18.3438 7.2257A1.89 1.89 0 0018 8.223 1.9 1.9 0 0020 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466z"
  })), eF || (eF = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V10H8v8l1,2,1-2V10h2v4l1,2,1-2V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NZe.propTypes = E);
const TZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tF || (tF = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V8H24a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,5a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,8a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,5a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4ZM6,26V22h4V20H6V16h4V14H6V10H8a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,10h2V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TZe.propTypes = E);
const IZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nF || (nF = /* @__PURE__ */ h.createElement("path", {
    d: "M12 2H14V4H12zM14 4H16V6H14zM16 6H18V8H16zM16 2H18V4H16zM12 6H14V8H12zM14 18H16V20H14zM16 20H18V22H16zM18 22H20V24H18zM18 18H20V20H18zM14 22H16V24H14zM18 10H20V12H18zM20 12H22V14H20zM22 14H24V16H22zM22 10H24V12H22zM18 14H20V16H18z"
  })), iF || (iF = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4a2.0023,2.0023,0,0,0-2,2V26H6V22h4V20H6V16h4V14H6V10h4V8H6V6A2.0023,2.0023,0,0,0,4,4H2V6H4V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6h2V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IZe.propTypes = E);
const OZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rF || (rF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.98 17.4922c0-2.8734 1.4971-4.68 4.1466-4.68 1.8067 0 2.9939.8603 3.5272 2.2712l-1.8067.8087c-.2065-.7571-.7743-1.3076-1.7206-1.3076-1.2215 0-1.841.8602-1.841 2.1162v1.6345c0 1.2561.6194 2.0992 1.841 2.0992 1.0496 0 1.5657-.6023 1.8927-1.411l1.686.8087c-.5849 1.5829-1.841 2.3744-3.5788 2.3744-2.6496 0-4.1466-1.8238-4.1466-4.7144zM14.623 22.0001l-.9635-3.0626h-4.267l-.9465 3.0626h-2.3055l4.026-12.0096h2.8217l3.9917 12.0096h-2.357zm-3.0627-9.9449h-.0861l-1.5311 4.9381h3.1659l-1.5486-4.9381z"
  })), sF || (sF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OZe.propTypes = E);
const RZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, oF || (oF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.98 17.4921c0-2.8734 1.4971-4.68 4.1466-4.68 1.8067 0 2.9939.8603 3.5272 2.2712l-1.8067.8087c-.2065-.7571-.7743-1.3076-1.7206-1.3076-1.2215 0-1.841.8602-1.841 2.1162v1.6345c0 1.2561.6194 2.0992 1.841 2.0992 1.0496 0 1.5657-.6023 1.8927-1.411l1.686.8087c-.5849 1.5829-1.841 2.3744-3.5788 2.3744-2.6496 0-4.1466-1.8238-4.1466-4.7144zM14.623 22l-.9635-3.0626h-4.267l-.9465 3.0626h-2.3055l4.026-12.0096h2.8217l3.9917 12.0096h-2.357zm-3.0627-9.9449h-.0861l-1.5311 4.9381h3.1659l-1.5486-4.9381z"
  })), aF || (aF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RZe.propTypes = E);
const VZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lF || (lF = /* @__PURE__ */ h.createElement("path", {
    d: "M12,29a1,1,0,0,1-.92-.62L6.33,17H2V15H7a1,1,0,0,1,.92.62L12,25.28,20.06,3.65A1,1,0,0,1,21,3a1,1,0,0,1,.93.68L25.72,15H30v2H25a1,1,0,0,1-.95-.68L21,7,12.94,28.35A1,1,0,0,1,12,29Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VZe.propTypes = E);
const E7 = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cF || (cF = /* @__PURE__ */ h.createElement("path", {
    d: "M17 15L17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17 24 15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (E7.propTypes = E);
const HZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hF || (hF = /* @__PURE__ */ h.createElement("path", {
    d: "M16,4c6.6,0,12,5.4,12,12s-5.4,12-12,12S4,22.6,4,16S9.4,4,16,4 M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14 S23.7,2,16,2z"
  })), dF || (dF = /* @__PURE__ */ h.createElement("path", {
    d: "M24 15L17 15 17 8 15 8 15 15 8 15 8 17 15 17 15 24 17 24 17 17 24 17z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HZe.propTypes = E);
const BZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uF || (uF = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14.1725,14.1725,0,0,0,2,16,14.1725,14.1725,0,0,0,16,30,14.1725,14.1725,0,0,0,30,16,14.1725,14.1725,0,0,0,16,2Zm8,15H17v7H15V17H8V15h7V8h2v7h7Z"
  })), fF || (fF = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M24 17L17 17 17 24 15 24 15 17 8 17 8 15 15 15 15 8 17 8 17 15 24 15 24 17z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (BZe.propTypes = E);
const PZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pF || (pF = /* @__PURE__ */ h.createElement("path", {
    d: "M17 15L17 5 15 5 15 15 5 15 5 17 15 17 15 27 17 27 17 17 27 17 27 15 17 15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PZe.propTypes = E);
const FZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gF || (gF = /* @__PURE__ */ h.createElement("path", {
    d: "M17.74,30,16,29l4-7h6a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2H6A2,2,0,0,0,4,8V20a2,2,0,0,0,2,2h9v2H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4H26a4,4,0,0,1,4,4V20a4,4,0,0,1-4,4H21.16Z"
  })), mF || (mF = /* @__PURE__ */ h.createElement("path", {
    d: "M17 9L15 9 15 13 11 13 11 15 15 15 15 19 17 19 17 15 21 15 21 13 17 13 17 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FZe.propTypes = E);
const zZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AF || (AF = /* @__PURE__ */ h.createElement("path", {
    d: "M24.251 21.3691l2.1943 1.4629A1 1 0 0027.8 22.6l3-4-1.6-1.2-2.4326 3.2437L24.5547 19.168a1 1 0 00-1.3687.2509L20 23.8789V16H18V26a2.0023 2.0023 0 002 2H30V26H20.9434zM2 21H16V23H2zM2 26H16V28H2zM11 16V11h1a4.0046 4.0046 0 004-4V4H13a3.9782 3.9782 0 00-2.7468 1.1066A6.0033 6.0033 0 005 2H2V5a6.0066 6.0066 0 006 6H9v5H2v2H16V16zM13 6h1V7a2.002 2.002 0 01-2 2H11V8A2.0019 2.0019 0 0113 6zM8 9A4.0046 4.0046 0 014 5V4H5A4.0045 4.0045 0 019 8V9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zZe.propTypes = E);
const WZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (fj.Ai || (fj.Ai = !0, console.warn("Icon should not be used. Teams should use the Carbon AILabel component.. As a result, the Ai component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wF || (wF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17 11L20 11 20 21 17 21 17 23 25 23 25 21 22 21 22 11 25 11 25 9 17 9 17 11zM13 9h-4c-1.103 0-2 .897-2 2v12h2v-5h4v5h2v-12c0-1.103-.897-2-2-2zm-4 7v-5h4v5h-4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WZe.propTypes = E);
const jZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vF || (vF = /* @__PURE__ */ h.createElement("path", {
    d: "M24 23H26V31H24zM28 21H30V31H28zM20 27H22V31H20zM18 20v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4zM14.5005 20h2l-3.5005-11h-3l-3.4966 11h1.9988l.6018-2h4.7781l.6184 2zM9.7058 16l1.6284-5.4111.2559-.0024 1.6736 5.4136h-3.5579z"
  })), bF || (bF = /* @__PURE__ */ h.createElement("path", {
    d: "M17 30L0 30 0 0 30 0 30 17 28 17 28 2 2 2 2 28 17 28 17 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jZe.propTypes = E);
const ZZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yF || (yF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16 23.4142L11.293 18.7072 12.707 17.2928 16 20.5858 27.293 9.2928 28.707 10.7072 16 23.4142zM12.707 8.7073l-1.4141-1.4141-4.2928 4.2928-2.5861-2.5863 4.293-4.2925-1.4141-1.4141-5 4.9995c-.1875.1875-.293.4419-.293.707s.1055.5195.293.707l7 7.0005 1.4141-1.4141-2.2929-2.293 4.2929-4.2929z"
  })), CF || (CF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16 30c-7.7197 0-14-6.2804-14-14h2c0 6.6168 5.3833 12 12 12s12-5.3832 12-12h2c0 7.7196-6.2803 14-14 14zM24.3076 7.3407c-2.2446-2.1543-5.1948-3.3407-8.3076-3.3407-.9365 0-1.8682.108-2.77.321l-.46-1.9463c1.0522-.2487 2.1387-.3748 3.23-.3748 3.6313 0 7.0737 1.3843 9.6924 3.8978l-1.3848 1.4429z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZZe.propTypes = E);
const UZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, EF || (EF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M19 22v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4zM15.5005 22h2l-3.5005-11h-3l-3.4966 11h1.9988l.6018-2h4.7781l.6184 2zm-4.7947-4l1.6284-5.4111.2559-.0024 1.6736 5.4136h-3.5579zM32 4L28 4 28 0 26 0 26 4 22 4 22 6 26 6 26 10 28 10 28 6 32 6 32 4zM30 12H32V14H30zM18 0H20V2H18z"
  })), _F || (_F = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M32 32L0 32 0 0 14 0 14 2 2 2 2 30 30 30 30 18 32 18 32 32z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UZe.propTypes = E);
const qZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xF || (xF = /* @__PURE__ */ h.createElement("path", {
    d: "M16 23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zm-3-10v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109v-4.4678h-6zM4.1208 17.6562c.5305-.3594.8792-.9673.8792-1.6562 0-1.1045-.8955-2-2-2s-2 .8955-2 2c0 .7886.4607 1.4644 1.124 1.79.6792 5.334 4.3472 9.8477 9.5686 11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651zM29.3247 20.3076l-1.9033-.6152c-1.4329 4.4355-5.2461 7.5645-9.7651 8.1865-.3596-.5303-.967-.8789-1.6562-.8789-1.1045 0-2 .8955-2 2s.8955 2 2 2c.7888 0 1.4644-.4604 1.7898-1.124 5.334-.6792 9.8479-4.3472 11.5349-9.5684zM29.876 14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147 1.9033c4.4355 1.4326 7.5642 5.2461 8.1865 9.7651-.5305.3594-.8792.9673-.8792 1.6562 0 1.1045.8955 2 2 2s2-.8955 2-2c0-.7886-.4604-1.4644-1.124-1.79zM16 1c-.7888 0-1.4644.4604-1.7898 1.124-5.334.6792-9.8479 4.3472-11.5349 9.5684l1.9033.6152c1.4329-4.4355 5.2461-7.5645 9.7651-8.1865.3596.5303.967.8789 1.6562.8789 1.1045 0 2-.8955 2-2s-.8955-2-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qZe.propTypes = E);
const GZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SF || (SF = /* @__PURE__ */ h.createElement("path", {
    d: "M23 27.5898L20.41 24.9999 19 26.41 23 30.41 31 22.41 29.5899 21 23 27.5898zM16 23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zm-3-10v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109v-4.4678h-6zM4.1208 17.6562c.5305-.3594.8792-.9673.8792-1.6562 0-1.1045-.8955-2-2-2s-2 .8955-2 2c0 .7886.4607 1.4644 1.124 1.79.6792 5.334 4.3472 9.8477 9.5686 11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651zM29.876 14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147 1.9033c4.4355 1.4326 7.5642 5.2461 8.1865 9.7651-.5305.3594-.8792.9673-.8792 1.6562 0 1.1045.8955 2 2 2s2-.8955 2-2c0-.7886-.4604-1.4644-1.124-1.79zM16 1c-.7888 0-1.4644.4604-1.7898 1.124-5.334.6792-9.8479 4.3472-11.5349 9.5684l1.9033.6152c1.4329-4.4355 5.2461-7.5645 9.7651-8.1865.3596.5303.967.8789 1.6562.8789 1.1045 0 2-.8955 2-2s-.8955-2-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GZe.propTypes = E);
const QZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MF || (MF = /* @__PURE__ */ h.createElement("path", {
    d: "M27.4102 26L31 22.4102 29.5901 21 26 24.5898 22.4102 21 21 22.4102 24.5901 26 21 29.5898 22.4102 31 26 27.4102 29.5901 31 31 29.5898 27.4102 26zM16 23l-2.1387-1.0127c-1.7383-.8223-2.8613-2.5967-2.8613-4.5195v-6.4678h10v6.4678c0 1.9229-1.123 3.6973-2.8613 4.5195l-2.1387 1.0127zm-3-10v4.4678c0 1.1533.6738 2.2178 1.7168 2.7109l1.2832.6074 1.2832-.6074c1.043-.4932 1.7168-1.5576 1.7168-2.7109v-4.4678h-6zM4.1208 17.6562c.5305-.3594.8792-.9673.8792-1.6562 0-1.1045-.8955-2-2-2s-2 .8955-2 2c0 .7886.4607 1.4644 1.124 1.79.6792 5.334 4.3472 9.8477 9.5686 11.5347l.6147-1.9033c-4.4355-1.4326-7.5642-5.2461-8.1865-9.7651zM29.876 14.21c-.6792-5.334-4.3472-9.8477-9.5686-11.5347l-.6147 1.9033c4.4355 1.4326 7.5642 5.2461 8.1865 9.7651-.5305.3594-.8792.9673-.8792 1.6562 0 1.1045.8955 2 2 2s2-.8955 2-2c0-.7886-.4604-1.4644-1.124-1.79zM16 1c-.7888 0-1.4644.4604-1.7898 1.124-5.334.6792-9.8479 4.3472-11.5349 9.5684l1.9033.6152c1.4329-4.4355 5.2461-7.5645 9.7651-8.1865.3596.5303.967.8789 1.6562.8789 1.1045 0 2-.8955 2-2s-.8955-2-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QZe.propTypes = E);
const KZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DF || (DF = /* @__PURE__ */ h.createElement("path", {
    d: "M19 21v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4zM15.5005 21h2l-3.5005-11h-3l-3.4966 11h1.9988l.6018-2h4.7781l.6184 2zM10.7058 17l1.6284-5.4111.2559-.0024 1.6736 5.4136h-3.5579z"
  })), LF || (LF = /* @__PURE__ */ h.createElement("path", {
    d: "M32,32H0V0h32v32ZM2,30h28V2H2v28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KZe.propTypes = E);
const YZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kF || (kF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M15 19l-1.4141 1.4141 3.5859 3.5859H4v-13h-2v13c0 1.1046.8954 2 2 2h13.1719l-3.5859 3.5859 1.4141 1.4141 6-6-6-6zM24 18v-2h2V4h-2v-2h6v2h-2v12h2v2h-6z"
  })), NF || (NF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,18h2l-5.5-16-3,.0088-5.5,15.9912h2l1.3333-4h7.3335l1.3333,4Zm-8-6l3-9,3,9h-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YZe.propTypes = E);
const XZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TF || (TF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M18 20v-2h1v-7h-1v-2h4v2h-1v7h1v2h-4zM14.5005 20h2l-3.5005-11h-3l-3.4966 11h1.9988l.6018-2h4.7781l.6184 2zm-4.7947-4l1.6284-5.4111.2559-.0024 1.6736 5.4136h-3.5579zM26.2171 21l-1.7871 3.621-3.9958.5806 2.8914 2.8188-.6827 3.9796 3.5741-1.879 3.5741 1.879-.6827-3.9796 2.8914-2.8186-3.9958-.5808-1.7871-3.621z"
  })), IF || (IF = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17 30L0 30 0 0 30 0 30 17 28 17 28 2 2 2 2 28 17 28 17 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XZe.propTypes = E);
const JZe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OF || (OF = /* @__PURE__ */ h.createElement("path", {
    d: "M16 8a5.9908 5.9908 0 009.4712 4.8853L28.586 16 30 14.586l-3.115-3.1148A5.997 5.997 0 1016 8zm2 0a4 4 0 114 4A4.0045 4.0045 0 0118 8zM11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0055 8.0055 0 016-7.7373L13.6138 2.3A10.0088 10.0088 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.0493 16a9.5991 9.5991 0 01-1.8716 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857a10.9664 10.9664 0 002.3686-2.8331z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JZe.propTypes = E);
const $Ze = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RF || (RF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.9279 7.9279 0 013.69.9106l.8958-1.791A9.99 9.99 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4zM29 14H19a1 1 0 01-.8945-1.4473l5-10a1 1 0 011.7888 0l5 10A1 1 0 0129 14zm-8.3818-2h6.7636L24 5.2361z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Ze.propTypes = E);
const eUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VF || (VF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM24 14a6 6 0 116-6A6.0067 6.0067 0 0124 14zM24 4a4 4 0 104 4A4.0045 4.0045 0 0024 4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eUe.propTypes = E);
const tUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HF || (HF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM28 14H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2v8A2.0021 2.0021 0 0128 14zM20 4v8h8V4zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tUe.propTypes = E);
const nUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BF || (BF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM20 2H22V9H20zM21 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0021 11zM26 2H28V9H26zM27 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0027 11zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nUe.propTypes = E);
const iUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, PF || (PF = /* @__PURE__ */ h.createElement("path", {
    d: "M24 2H26V9H24zM25 11a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0025 11zM11 24H21V26H11zM13 28H19V30H13zM23.0488 16a9.6136 9.6136 0 01-1.8711 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9886 9.9886 0 0025.2815 16zM16 4a7.94 7.94 0 014 1.0825V2.8408A9.9887 9.9887 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2c0-1.84-1.1108-2.8662-2.1855-3.8594A7.1851 7.1851 0 018 12 8.0092 8.0092 0 0116 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iUe.propTypes = E);
const rUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FF || (FF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM20 14a1 1 0 01-.8945-.5527L17.3818 10H14V8h4a1 1 0 01.8945.5527L20 10.7639l3.1055-6.2112a1.0416 1.0416 0 011.789 0L26.6182 8H30v2H26a1 1 0 01-.8945-.5527L24 7.2361l-3.1055 6.2112A1 1 0 0120 14z"
  })), zF || (zF = /* @__PURE__ */ h.createElement("path", {
    d: "M10.8145,18.1406A7.1851,7.1851,0,0,1,8,12a8.0092,8.0092,0,0,1,8-8V2A10.0111,10.0111,0,0,0,6,12a9.1793,9.1793,0,0,0,3.46,7.6162C10.4717,20.5508,11,21.0815,11,22h2C13,20.16,11.8892,19.1338,10.8145,18.1406Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rUe.propTypes = E);
const sUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WF || (WF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21 9.59L17.41 6 16 7.41 21 12.41 30 3.41 28.59 2 21 9.59zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sUe.propTypes = E);
const oUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jF || (jF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.8 14a7.28 7.28 0 01-2.6219 4.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.1426 9.1426 0 0025.8389 14zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oUe.propTypes = E);
const aUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZF || (ZF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426z"
  })), UF || (UF = /* @__PURE__ */ h.createElement("circle", {
    cx: "18.5",
    cy: "7.5",
    r: "1.5"
  })), qF || (qF = /* @__PURE__ */ h.createElement("circle", {
    cx: "28.5",
    cy: "7.5",
    r: "1.5"
  })), GF || (GF = /* @__PURE__ */ h.createElement("circle", {
    cx: "23.5",
    cy: "7.5",
    r: "1.5"
  })), n);
});
process.env.NODE_ENV !== "production" && (aUe.propTypes = E);
const lUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, QF || (QF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM21.1777 18.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.193 9.193 0 0026 12H24A7.2032 7.2032 0 0121.1777 18.1426zM18 6H28V8H18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lUe.propTypes = E);
const cUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KF || (KF = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM10.8145 18.1406A7.1851 7.1851 0 018 12a8.0092 8.0092 0 018-8V2A10.0111 10.0111 0 006 12a9.1793 9.1793 0 003.46 7.6162C10.4717 20.5508 11 21.0815 11 22h2C13 20.16 11.8892 19.1338 10.8145 18.1406zM23.04 16a9.4858 9.4858 0 01-1.8623 2.1426C20.1069 19.1348 19 20.1611 19 22h2c0-.9194.5264-1.45 1.5352-2.3857A9.9838 9.9838 0 0025.2756 16zM30 8a6 6 0 10-6 6A6.0066 6.0066 0 0030 8zM28 8a3.9521 3.9521 0 01-.5669 2.019L21.981 4.5669A3.9529 3.9529 0 0124 4 4.0045 4.0045 0 0128 8zM20 8a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 12 4.0045 4.0045 0 0120 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cUe.propTypes = E);
const hUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YF || (YF = /* @__PURE__ */ h.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0058 5.0058 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM31.9658 11.7413a1.0007 1.0007 0 00-1.2246-.707l-3.0861.826L24 7l-1 .2676 1.4584 5.4483-2.7663.7405L20 11.2066l-1 .2676.9337 3.4883a.9993.9993 0 001.2246.707l10.1005-2.7036A1 1 0 0031.9658 11.7413z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hUe.propTypes = E);
const dUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, XF || (XF = /* @__PURE__ */ h.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM22 4L22 6 26.586 6 20 12.586 21.414 14 28 7.414 28 12 30 12 30 4 22 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dUe.propTypes = E);
const uUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JF || (JF = /* @__PURE__ */ h.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM27.303 8a2.6616 2.6616 0 00-1.9079.8058L25 9.2112l-.3951-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25 17l4.2108-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uUe.propTypes = E);
const fUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $F || ($F = /* @__PURE__ */ h.createElement("path", {
    d: "M18 23H16V21a3.0033 3.0033 0 00-3-3H9a3.0033 3.0033 0 00-3 3v2H4V21a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM11 6A3 3 0 118 9a3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0011 4zM2 26H30V28H2zM30 8L28 8 28 6 26 6 26 4 30 4 30 8zM19 4L23 4 23 6 21 6 21 8 19 8 19 4zM28 13H30V15H28zM26 11H28V13H26zM19 11L21 11 21 13 23 13 23 15 19 15 19 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fUe.propTypes = E);
const pUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ez || (ez = /* @__PURE__ */ h.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30ZM10.92,28H21.08L16,20.7439Z"
  })), tz || (tz = /* @__PURE__ */ h.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pUe.propTypes = E);
const gUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nz || (nz = /* @__PURE__ */ h.createElement("path", {
    d: "M22.9961,30H9.0039a1.0022,1.0022,0,0,1-.821-1.5769l6.9977-9.9965a1,1,0,0,1,1.6388,0l6.9977,9.9965A1.0022,1.0022,0,0,1,22.9961,30Z"
  })), iz || (iz = /* @__PURE__ */ h.createElement("path", {
    d: "M28,24H24V22h4V6H4V22H8v2H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,28,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gUe.propTypes = E);
const mUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rz || (rz = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M17,14.5,23,17V15l-6-3V9a1,1,0,0,0-2,0v3L9,15v2l6-2.5V20l-3,2v1l4-1,4,1V22l-3-2Z"
  })), sz || (sz = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mUe.propTypes = E);
const AUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, oz || (oz = /* @__PURE__ */ h.createElement("path", {
    d: "M23,17H19.4141L16,13H14l2.5859,4H10.7207L9.5,15H8l1.0569,3.3046A1,1,0,0,0,10.0094,19H23a1,1,0,0,0,0-2Z"
  })), az || (az = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AUe.propTypes = E);
const wUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lz || (lz = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15h-6.07A8.0076,8.0076,0,0,0,17,8.0693V2H15V8.0693A8.0076,8.0076,0,0,0,8.07,15H2v2H8.07A8.0076,8.0076,0,0,0,15,23.9307V30h2V23.9307A8.0076,8.0076,0,0,0,23.9305,17H30ZM16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wUe.propTypes = E);
const vUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cz || (cz = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), hz || (hz = /* @__PURE__ */ h.createElement("path", {
    d: "M18.59 21L15 17.41 15 11 17 11 17 16.58 20 19.59 18.59 21z"
  })), dz || (dz = /* @__PURE__ */ h.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), uz || (uz = /* @__PURE__ */ h.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), n);
});
process.env.NODE_ENV !== "production" && (vUe.propTypes = E);
const bUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fz || (fz = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), pz || (pz = /* @__PURE__ */ h.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), gz || (gz = /* @__PURE__ */ h.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), mz || (mz = /* @__PURE__ */ h.createElement("path", {
    d: "M21 16L17 16 17 12 15 12 15 16 11 16 11 18 15 18 15 22 17 22 17 18 21 18 21 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bUe.propTypes = E);
const yUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Az || (Az = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28A11,11,0,1,1,27,17,11,11,0,0,1,16,28ZM16,8a9,9,0,1,0,9,9A9,9,0,0,0,16,8Z"
  })), wz || (wz = /* @__PURE__ */ h.createElement("path", {
    d: "M3.96 5.5H9.030000000000001V7.5H3.96z",
    transform: "rotate(-45.06 6.502 6.497)"
  })), vz || (vz = /* @__PURE__ */ h.createElement("path", {
    d: "M24.5 3.96H26.5V9.030000000000001H24.5z",
    transform: "rotate(-44.94 25.5 6.498)"
  })), bz || (bz = /* @__PURE__ */ h.createElement("path", {
    d: "M11 16H21V18H11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yUe.propTypes = E);
const CUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yz || (yz = /* @__PURE__ */ h.createElement("path", {
    d: "M24,18H17V14h3a2.0025,2.0025,0,0,0,2-2V8a2.0025,2.0025,0,0,0-2-2H17V2H15V6H12a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h3v4H8a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2h7v4h2V26h7a2.0025,2.0025,0,0,0,2-2V20A2.0025,2.0025,0,0,0,24,18ZM12,8h8v4H12ZM24,24H8V20H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CUe.propTypes = E);
const EUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cz || (Cz = /* @__PURE__ */ h.createElement("path", {
    d: "M26 26H11a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H26a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0126 26zm0-6.0012L11 20v4H26zM18 14H11a2.0023 2.0023 0 01-2-2V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0118 14zm0-6.0012L11 8v4h7zM4 2H6V30H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EUe.propTypes = E);
const _Ue = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ez || (Ez = /* @__PURE__ */ h.createElement("path", {
    d: "M4 24V20a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H6A2.0023 2.0023 0 014 24zm2 0H21V20L6 19.9988zM12 12V8a2.0023 2.0023 0 012-2h7a2.0023 2.0023 0 012 2v4a2.0023 2.0023 0 01-2 2H14A2.0023 2.0023 0 0112 12zm2 0h7V8l-7-.0012z"
  })), _z || (_z = /* @__PURE__ */ h.createElement("path", {
    d: "M26 2H28V30H26z",
    transform: "rotate(-180 27 16)"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Ue.propTypes = E);
const xUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xz || (xz = /* @__PURE__ */ h.createElement("path", {
    d: "M2 26H30V28H2zM24 23H20a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 23zm-4-9v7h4.0012L24 14zM12 23H8a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 018 4h4a2.0023 2.0023 0 012 2V21A2.0023 2.0023 0 0112 23zM8 6V21h4.0012L12 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xUe.propTypes = E);
const SUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sz || (Sz = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H26V12a2.0025,2.0025,0,0,0-2-2H20a2.0025,2.0025,0,0,0-2,2v3H14V8a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,8v7H2v2H6v7a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4v3a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V17h4ZM8,24V8h4l.0012,16Zm12-4V12h4l.0012,8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SUe.propTypes = E);
const MUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mz || (Mz = /* @__PURE__ */ h.createElement("path", {
    d: "M24 20H20a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2h4a2.0023 2.0023 0 012 2v7A2.0023 2.0023 0 0124 20zm-4-9v7h4.0012L24 11zM12 28H8a2.0023 2.0023 0 01-2-2V11A2.0023 2.0023 0 018 9h4a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28zM8 11V26h4.0012L12 11zM2 4H30V6H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MUe.propTypes = E);
const DUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dz || (Dz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Lz || (Lz = /* @__PURE__ */ h.createElement("path", {
    d: "M10 18H22V20H10z",
    transform: "rotate(-180 16 19)"
  })), kz || (kz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 23H20V25H12z",
    transform: "rotate(-180 16 24)"
  })), n);
});
process.env.NODE_ENV !== "production" && (DUe.propTypes = E);
const LUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nz || (Nz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Tz || (Tz = /* @__PURE__ */ h.createElement("path", {
    d: "M9 18H20V20H9zM9 23H16V25H9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LUe.propTypes = E);
const kUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Iz || (Iz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Oz || (Oz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 18H23V20H12z",
    transform: "rotate(-180 17.5 19)"
  })), Rz || (Rz = /* @__PURE__ */ h.createElement("path", {
    d: "M16 23H23V25H16z",
    transform: "rotate(-180 19.5 24)"
  })), n);
});
process.env.NODE_ENV !== "production" && (kUe.propTypes = E);
const NUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vz || (Vz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Hz || (Hz = /* @__PURE__ */ h.createElement("path", {
    d: "M10 13H22V15H10z",
    transform: "rotate(-180 16 14)"
  })), Bz || (Bz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 18H20V20H12z",
    transform: "rotate(-180 16 19)"
  })), n);
});
process.env.NODE_ENV !== "production" && (NUe.propTypes = E);
const TUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pz || (Pz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Fz || (Fz = /* @__PURE__ */ h.createElement("path", {
    d: "M9 13H20V15H9zM9 18H16V20H9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TUe.propTypes = E);
const IUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zz || (zz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Wz || (Wz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 13H23V15H12z",
    transform: "rotate(-180 17.5 14)"
  })), jz || (jz = /* @__PURE__ */ h.createElement("path", {
    d: "M16 18H23V20H16z",
    transform: "rotate(-180 19.5 19)"
  })), n);
});
process.env.NODE_ENV !== "production" && (IUe.propTypes = E);
const OUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zz || (Zz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Uz || (Uz = /* @__PURE__ */ h.createElement("path", {
    d: "M10 7H22V9H10z",
    transform: "rotate(-180 16 8)"
  })), qz || (qz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 12H20V14H12z",
    transform: "rotate(-180 16 13)"
  })), n);
});
process.env.NODE_ENV !== "production" && (OUe.propTypes = E);
const RUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gz || (Gz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Qz || (Qz = /* @__PURE__ */ h.createElement("path", {
    d: "M9 7H20V9H9zM9 12H16V14H9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RUe.propTypes = E);
const VUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kz || (Kz = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H6a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,6,2H26a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,26,30ZM6,4V28H26V4Z"
  })), Yz || (Yz = /* @__PURE__ */ h.createElement("path", {
    d: "M12 7H23V9H12z",
    transform: "rotate(-180 17.5 8)"
  })), Xz || (Xz = /* @__PURE__ */ h.createElement("path", {
    d: "M16 12H23V14H16z",
    transform: "rotate(-180 19.5 13)"
  })), n);
});
process.env.NODE_ENV !== "production" && (VUe.propTypes = E);
const HUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jz || (Jz = /* @__PURE__ */ h.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2H30V28H4Z"
  })), $z || ($z = /* @__PURE__ */ h.createElement("path", {
    d: "M30,9H23v2h3.59L19,18.59l-4.29-4.3a1,1,0,0,0-1.42,0L6,21.59,7.41,23,14,16.41l4.29,4.3a1,1,0,0,0,1.42,0L28,12.41V16h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HUe.propTypes = E);
const BUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eW || (eW = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L6 16.5859 7.4141 18 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2z"
  })), tW || (tW = /* @__PURE__ */ h.createElement("path", {
    d: "M4,2H2V28a2,2,0,0,0,2,2h8V28H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BUe.propTypes = E);
const PUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nW || (nW = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 4H23V6h3.5859L19 13.5859 14.707 9.293a1 1 0 00-1.414 0L8 14.5858 9.4142 16 14 11.4141l4.293 4.2929a1 1 0 001.414 0L28 7.4141V11h2zM16 28H30V30H16zM2 2H4V16H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PUe.propTypes = E);
const FUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iW || (iW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M2.257 25.5H8.742V27.5H2.257z",
    transform: "rotate(-45 5.5 26.5)"
  })), rW || (rW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M9.257 18.5H15.742V20.5H9.257z",
    transform: "rotate(-45 12.5 19.5)"
  })), sW || (sW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16.257 11.5H22.742V13.5H16.257z",
    transform: "rotate(-45 19.5 12.5)"
  })), oW || (oW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M23.257 4.5H29.742V6.5H23.257z",
    transform: "rotate(-45 26.5 5.5)"
  })), n);
});
process.env.NODE_ENV !== "production" && (FUe.propTypes = E);
const zUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aW || (aW = /* @__PURE__ */ h.createElement("path", {
    d: "M9,24a3.51,3.51,0,0,0-.88-1.86L17.65,5.56l-1.73-1L6.35,21.12A3.06,3.06,0,0,0,5.5,21a3.5,3.5,0,1,0,3.15,5H28V24ZM5.5,26A1.5,1.5,0,1,1,7,24.5,1.5,1.5,0,0,1,5.5,26Z"
  })), lW || (lW = /* @__PURE__ */ h.createElement("path", {
    d: "M22,21h2a13,13,0,0,0-5.42-10.56l-1.16,1.62A11,11,0,0,1,22,21Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zUe.propTypes = E);
const WUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cW || (cW = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H4V6H28Z"
  })), hW || (hW = /* @__PURE__ */ h.createElement("path", {
    d: "M21 20H13a3.51 3.51 0 00-.88-1.86l3.8-6.64-1.74-1-3.78 6.62A3.35 3.35 0 009.5 17a3.5 3.5 0 103.15 5H21zM9.5 22A1.5 1.5 0 1111 20.5 1.5 1.5 0 019.5 22zM19 8H26V10H19zM19 12H23V14H19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WUe.propTypes = E);
const jUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dW || (dW = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM27.84,14.14,22,17.52V5.62A12,12,0,0,1,27.84,14.14ZM12,18.68V13.32L16,11l4,2.31v5.36L16,21Zm8-14V11L10.34,5.42A11.9,11.9,0,0,1,20,4.7Zm-11.52,2L14,9.85,4,15.62A12,12,0,0,1,8.48,6.66ZM4.16,17.85,10,14.47V26.38A12,12,0,0,1,4.16,17.85ZM12,27.3V21l9.67,5.58A11.92,11.92,0,0,1,16,28,12.05,12.05,0,0,1,12,27.3Zm11.52-2L18,22.14l10-5.77A12,12,0,0,1,23.52,25.34Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jUe.propTypes = E);
const ZUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uW || (uW = /* @__PURE__ */ h.createElement("path", {
    d: "M26,22a3.86,3.86,0,0,0-2,.57l-3.09-3.1a6,6,0,0,0,0-6.94L24,9.43A3.86,3.86,0,0,0,26,10a4,4,0,1,0-4-4,3.86,3.86,0,0,0,.57,2l-3.1,3.09a6,6,0,0,0-6.94,0L9.43,8A3.86,3.86,0,0,0,10,6a4,4,0,1,0-4,4,3.86,3.86,0,0,0,2-.57l3.09,3.1a6,6,0,0,0,0,6.94L8,22.57A3.86,3.86,0,0,0,6,22a4,4,0,1,0,4,4,3.86,3.86,0,0,0-.57-2l3.1-3.09a6,6,0,0,0,6.94,0L22.57,24A3.86,3.86,0,0,0,22,26a4,4,0,1,0,4-4ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm10-8a4,4,0,1,1,4-4A4,4,0,0,1,16,20Zm10,8a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZUe.propTypes = E);
const UUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fW || (fW = /* @__PURE__ */ h.createElement("path", {
    d: "M8 9H4a2 2 0 00-2 2V23H4V18H8v5h2V11A2 2 0 008 9zM4 16V11H8v5zM22 11L25 11 25 21 22 21 22 23 30 23 30 21 27 21 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UUe.propTypes = E);
const qUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pW || (pW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m28,26c-.178,0-.3472.0308-.5115.0742l-1.0554-1.0552c.3516-.5947.5669-1.2798.5669-2.019s-.2153-1.4243-.5669-2.019l1.0554-1.0552c.1643.0435.3335.0742.5115.0742,1.1045,0,2-.8955,2-2s-.8955-2-2-2-2,.8955-2,2c0,.1777.0308.3472.0742.5117l-1.0552,1.0552c-.595-.3516-1.2795-.5669-2.019-.5669s-1.4241.2153-2.019.5669l-1.0552-1.0552c.0435-.1646.0742-.334.0742-.5117,0-1.1045-.8955-2-2-2s-2,.8955-2,2,.8955,2,2,2c.178,0,.3472-.0308.5115-.0742l1.0554,1.0552c-.3516.5947-.5669,1.2798-.5669,2.019s.2153,1.4243.5669,2.019l-1.0554,1.0552c-.1643-.0435-.3335-.0742-.5115-.0742-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.1777-.0308-.3472-.0742-.5117l1.0552-1.0552c.595.3516,1.2795.5669,2.019.5669s1.4241-.2153,2.019-.5669l1.0552,1.0552c-.0435.1646-.0742.334-.0742.5117,0,1.1045.8955,2,2,2s2-.8955,2-2-.8955-2-2-2Zm-7-3c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Z"
  })), gW || (gW = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "10",
    r: "2",
    strokeWidth: "0"
  })), mW || (mW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,2c-4.9626,0-9,4.0371-9,9,0,.7788.0989,1.5469.2944,2.291L2,23.5859v6.4141h6.4143l7-7-2.7073-2.707-1.4141,1.4141,1.2927,1.293-1.5896,1.5898-1.2869-1.2949-1.4185,1.4102,1.2913,1.2988-1.9963,1.9961h-3.5857v-3.5859l9.7122-9.7119.8555-.8677-.1982-.5845c-.2451-.7217-.3694-1.4785-.3694-2.25,0-3.8599,3.1401-7,7-7s7,3.1401,7,7h2c0-4.9629-4.0374-9-9-9Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qUe.propTypes = E);
const GUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AW || (AW = /* @__PURE__ */ h.createElement("path", {
    d: "M28 10H22V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0028 10zm-4 8V12h4v6zM18 10H12V24h2V20h4a2.0027 2.0027 0 002-2V12A2.0023 2.0023 0 0018 10zm-4 8V12h4v6zM8 10H3v2H8v2H4a2 2 0 00-2 2v2a2 2 0 002 2h6V12A2.0023 2.0023 0 008 10zm0 8H4V16H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GUe.propTypes = E);
const QUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wW || (wW = /* @__PURE__ */ h.createElement("path", {
    d: "M20,14h8a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2H9A2.0023,2.0023,0,0,0,7,6v4H4a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2H6v4a2.0023,2.0023,0,0,0,2,2H18a2.0023,2.0023,0,0,0,2,2h8a2.0023,2.0023,0,0,0,2-2V20a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2v6H8V22h4a2.0023,2.0023,0,0,0,2-2V12a2.0023,2.0023,0,0,0-2-2H9V6h9v6A2.0023,2.0023,0,0,0,20,14Zm0,14V24h8v4Zm8-8,0,2H20V20ZM4,20V16h8v4Zm8.0005-6H4V12h8ZM20,12V8h8v4Zm8-8,0,2H20V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QUe.propTypes = E);
const KUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vW || (vW = /* @__PURE__ */ h.createElement("path", {
    d: "M21.7788,8a11.4843,11.4843,0,0,0-3.0547.5342,14.5665,14.5665,0,0,1-1.8225.4126A6.0054,6.0054,0,0,0,11,4V6a3.9933,3.9933,0,0,1,3.8267,2.9c-.5181-.0879-1.0569-.2207-1.6172-.3648A12.89,12.89,0,0,0,10.0317,8C6.311,8,4,11.0652,4,16c0,7.51,4.0679,11.999,8.0005,12h.0015a7.1576,7.1576,0,0,0,2.49-.59A5.0128,5.0128,0,0,1,16,27a5.0266,5.0266,0,0,1,1.5112.41A7.15,7.15,0,0,0,20,28h0c3.9307-.001,8-4.49,8-12C28,12.3094,26.3706,8,21.7788,8ZM20,26h0a5.5038,5.5038,0,0,1-1.7905-.4639A6.4168,6.4168,0,0,0,16,25a6.4043,6.4043,0,0,0-2.2061.5361A5.5343,5.5343,0,0,1,12,26h.0015C9.0513,25.9988,6,22.2586,6,16c0-1.8037.3931-6,4.0317-6a11.2363,11.2363,0,0,1,2.6807.4726A12.9819,12.9819,0,0,0,15.7612,11h.4922a11.7955,11.7955,0,0,0,2.9956-.5361A9.8483,9.8483,0,0,1,21.7788,10C25.7964,10,26,14.9978,26,16,26,22.2586,22.9482,25.9988,20,26Z"
  })), bW || (bW = /* @__PURE__ */ h.createElement("path", {
    d: "M18,7H17V6a2.0021,2.0021,0,0,1,2-2h1V5A2.0021,2.0021,0,0,1,18,7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KUe.propTypes = E);
const YUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yW || (yW = /* @__PURE__ */ h.createElement("path", {
    d: "M7.0825 11.6714l-1.6748-1.0928c-.9062 1.3887-1.3928 3.2305-1.4072 5.3267l2 .0137c.0117-1.7119.3857-3.1807 1.082-4.2476zM6.0852 17.8164l-1.9907.1934c.1887 1.938.6592 3.6738 1.3982 5.1592l1.7905-.8911c-.6301-1.2661-1.0332-2.7676-1.198-4.4614zM8.2378 23.7964l-1.5688 1.2402c1.333 1.6865 3.0972 2.7573 4.8396 2.9375l.2061-1.9893c-1.1912-.1235-2.491-.9414-3.4768-2.1885zM16 25c-.7334 0-1.4783.271-2.1987.5332-.1809.0654-.3635.1318-.5469.1943l.6426 1.894c.197-.0669.3936-.1382.5879-.209.5576-.2026 1.134-.4126 1.5151-.4126.3809 0 .9575.21 1.5149.4121.1809.0659.3635.1323.5466.1953l.6479-1.8926c-.1711-.0586-.3418-.1206-.511-.1821-.7205-.2617-1.4653-.5327-2.1985-.5327zM20.2546 25.9878l.1855 1.9917c1.7456-.1631 3.5178-1.2227 4.8621-2.9072l-1.5632-1.2476c-.9924 1.2437-2.2949 2.0522-3.4844 2.1631zM24.7004 22.3115l1.7871.8975c.7449-1.4834 1.2205-3.2178 1.4138-5.1558l-1.9902-.1987c-.1689 1.6938-.5762 3.1934-1.2107 4.457zM28 15.9492c-.0076-2.0938-.4854-3.9365-1.3818-5.3311l-1.6821 1.082c.6897 1.0728 1.0576 2.5444 1.064 4.2559l2-.0068zM20 4h-1c-1.1046 0-2 .8954-2 2v1h1c1.1046 0 2-.8954 2-2v-1z"
  })), CW || (CW = /* @__PURE__ */ h.createElement("path", {
    d: "M23.8125,10.5308l1.1035-1.668c-.8655-.5728-1.8467-.8628-2.916-.8628-1.4155,0-2.4175,.2881-3.3013,.542-.5764,.1655-1.1362,.3203-1.7979,.4004-.502-2.8047-2.9541-4.9424-5.9009-4.9424v2c1.8223,0,3.3464,1.2319,3.8274,2.9014-.5442-.0864-1.031-.2173-1.5261-.3594-.8838-.2539-1.8857-.542-3.3013-.542-1.0693,0-2.0505,.29-2.916,.8628l1.1035,1.668c.5325-.3521,1.1423-.5308,1.8125-.5308,1.134,0,1.9185,.2256,2.7488,.4639,.917,.2637,1.8652,.5361,3.2512,.5361s2.3342-.2725,3.2512-.5361c.8303-.2383,1.6147-.4639,2.7488-.4639,.6702,0,1.28,.1787,1.8125,.5308Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YUe.propTypes = E);
const XUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, EW || (EW = /* @__PURE__ */ h.createElement("path", {
    d: "M16 18H6a2 2 0 01-2-2V6A2 2 0 016 4H16a2 2 0 012 2V16A2 2 0 0116 18zM6 6V16H16V6zM26 12v4H22V12h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V12a2 2 0 00-2-2zM26 22v4H22V22h4m0-2H22a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2zM16 22v4H12V22h4m0-2H12a2 2 0 00-2 2v4a2 2 0 002 2h4a2 2 0 002-2V22a2 2 0 00-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XUe.propTypes = E);
const JUe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _W || (_W = /* @__PURE__ */ h.createElement("path", {
    d: "M23 7H27V11H23zM23 13H27V17H23zM17 7H21V11H17zM17 13H21V17H17z"
  })), xW || (xW = /* @__PURE__ */ h.createElement("circle", {
    cx: "14.5",
    cy: "24.5",
    r: "1.5"
  })), SW || (SW = /* @__PURE__ */ h.createElement("path", {
    d: "M21,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H21V4H8V28H21V20h2v8A2.0023,2.0023,0,0,1,21,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JUe.propTypes = E);
const $Ue = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MW || (MW = /* @__PURE__ */ h.createElement("path", {
    d: "M17 19H21V23H17zM11 19H15V23H11zM17 25H21V29H17zM11 25H15V29H11z"
  })), DW || (DW = /* @__PURE__ */ h.createElement("path", {
    d: "M24.5,25H24V23h.5a5.4961,5.4961,0,0,0,.377-10.9795l-.8365-.0566-.09-.834a7.9979,7.9979,0,0,0-15.9014,0l-.09.834-.8365.0566A5.4961,5.4961,0,0,0,7.5,23H8v2H7.5A7.4964,7.4964,0,0,1,6.1782,10.124a9.9992,9.9992,0,0,1,19.6436,0A7.4964,7.4964,0,0,1,24.5,25Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Ue.propTypes = E);
const eqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, LW || (LW = /* @__PURE__ */ h.createElement("path", {
    d: "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20z"
  })), kW || (kW = /* @__PURE__ */ h.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eqe.propTypes = E);
const tqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, NW || (NW = /* @__PURE__ */ h.createElement("path", {
    d: "M4 2v2H2V2h2zm1-1H1v4h4V1zM9 2v2H7V2h2zm1-1H6v4h4V1zM14 2v2h-2V2h2zm1-1h-4v4h4V1zM4 7v2H2V7h2zm1-1H1v4h4V6zM9 7v2H7V7h2zm1-1H6v4h4V6zM14 7v2h-2V7h2zm1-1h-4v4h4V6zM4 12v2H2v-2h2zm1-1H1v4h4v-4zM9 12v2H7v-2h2zm1-1H6v4h4v-4zM14 12v2h-2v-2h2zm1-1h-4v4h4v-4z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TW || (TW = /* @__PURE__ */ h.createElement("path", {
    d: "M8,4V8H4V4Zm2-2H2v8h8Zm8,2V8H14V4Zm2-2H12v8h8Zm8,2V8H24V4Zm2-2H22v8h8ZM8,14v4H4V14Zm2-2H2v8h8Zm8,2v4H14V14Zm2-2H12v8h8Zm8,2v4H24V14Zm2-2H22v8h8ZM8,24v4H4V24Zm2-2H2v8h8Zm8,2v4H14V24Zm2-2H12v8h8Zm8,2v4H24V24Zm2-2H22v8h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tqe.propTypes = E);
const nqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, IW || (IW = /* @__PURE__ */ h.createElement("path", {
    d: "M14 19H18V21H14z"
  })), OW || (OW = /* @__PURE__ */ h.createElement("path", {
    d: "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nqe.propTypes = E);
const iqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RW || (RW = /* @__PURE__ */ h.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iqe.propTypes = E);
const rqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VW || (VW = /* @__PURE__ */ h.createElement("path", {
    d: "M30,6a3.9916,3.9916,0,0,0-7.9773-.2241L9.5864,8.2627A3.99,3.99,0,1,0,5,13.8579v8.2842A3.9915,3.9915,0,1,0,9.8579,27h8.2842a3.9912,3.9912,0,1,0,5.595-4.5864l2.487-12.4361A3.9945,3.9945,0,0,0,30,6ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,10a2,2,0,1,1,2,2A2.0023,2.0023,0,0,1,4,10ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm12.1421-3H9.8579A3.9942,3.9942,0,0,0,7,22.1421V13.8579a3.9871,3.9871,0,0,0,2.9773-3.6338L22.4136,7.7373a4.0053,4.0053,0,0,0,1.8493,1.8491l-2.487,12.4361A3.9874,3.9874,0,0,0,18.1421,25ZM22,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,22,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rqe.propTypes = E);
const sqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HW || (HW = /* @__PURE__ */ h.createElement("path", {
    d: "M24 9L22 9 16 17.5713 10 9 8 9 15 19 8 29 10 29 16 20.4287 22 29 24 29 17 19 24 9zM8 3H24V5H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sqe.propTypes = E);
const oqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BW || (BW = /* @__PURE__ */ h.createElement("path", {
    d: "M24 9L22 9 16 17.5713 10 9 8 9 15 19 8 29 10 29 16 20.4287 22 29 24 29 17 19 24 9zM20 7c-1.7771 0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977 0-2.449.8629-3.2927 1.707l-1.4146-1.4141c1.0674-1.0675 2.5669-2.293 4.7073-2.293 1.7771 0 3.2314.8726 4.5144 1.6425 1.1636.6981 2.2627 1.3575 3.4856 1.3575 1.3975 0 2.4487-.8629 3.293-1.7072l1.4141 1.4143c-1.0674 1.0675-2.5671 2.2928-4.707 2.2928z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oqe.propTypes = E);
const aqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, PW || (PW = /* @__PURE__ */ h.createElement("path", {
    d: "M30,29H2v-2h28v2ZM27,19H5v2h22v-2ZM24,11H8v2h16v-2ZM21,3h-10v2h10v-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aqe.propTypes = E);
const lqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FW || (FW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M2 3H30V5H2zM13 21H5c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM5 13v6h8v-6H5zM27 21h-8c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zm-8-8v6h8v-6h-8zM2 27H30V29H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lqe.propTypes = E);
const cqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zW || (zW = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M27 2H29V30H27zM20 15h-8c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2h8c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2zM12 7v6h8v-6h-8zM12 17h8c1.1028 0 2 .8972 2 2v6c0 1.1028-.8972 2-2 2h-8c-1.1028 0-2-.8972-2-2v-6c0-1.1028.8972-2 2-2zm8 8v-6h-8v6h8zM3 2H5V30H3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cqe.propTypes = E);
const hqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WW || (WW = /* @__PURE__ */ h.createElement("path", {
    d: "M4,5v22c0,1.1.9,2,2,2h4v-2h-4V5h4v-2h-4c-1.1,0-2,.9-2,2ZM26,3h-4v2h4v22h-4v2h4c1.1,0,2-.9,2-2V5c0-1.1-.9-2-2-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hqe.propTypes = E);
const dqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jW || (jW = /* @__PURE__ */ h.createElement("path", {
    d: "M4,2h4v2h-4v4h-2v-4c0-1.1046.8954-2,2-2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2ZM16,16c0-3.3137-2.6863-6-6-6s-6,2.6863-6,6,2.6863,6,6,6,6-2.6863,6-6ZM22,12c-2.2056,0-4,1.7944-4,4s1.7944,4,4,4,4-1.7944,4-4-1.7944-4-4-4M22,10c3.3137,0,6,2.6863,6,6s-2.6863,6-6,6-6-2.6863-6-6,2.6863-6,6-6h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dqe.propTypes = E);
const uqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZW || (ZW = /* @__PURE__ */ h.createElement("path", {
    d: "M23,8h-2v-2h-2v2h-6v-2h-2v2h-2c-1.1047,0-2,.8953-2,2v12c0,1.1047.8953,2,2,2h14c1.1047,0,2-.8953,2-2v-12c0-1.1047-.8953-2-2-2ZM9,22v-7h14v7h-14ZM22.9999,13h-13.9999v-3h2v1h2v-1h6v1h2v-1h2v3ZM4,2h4v2h-4v4h-2v-4c0-1.1046.8954-2,2-2ZM30,4v4h-2v-4h-4v-2h4c1.1046,0,2,.8954,2,2ZM8,28v2h-4c-1.1046,0-2-.8954-2-2v-4h2v4h4ZM30,24v4c0,1.1046-.8954,2-2,2h-4v-2h4v-4h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uqe.propTypes = E);
const fqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UW || (UW = /* @__PURE__ */ h.createElement("path", {
    d: "M11,19v2h-6v-2h2v-5h-2v-2h2v-1h2v8h2ZM19,19h-4v-2h2c1.1025,0,2-.897,2-2v-2c0-1.103-.8975-2-2-2h-4v2h4v2h-2c-1.103,0-2,.897-2,2v4h6v-2ZM25,11h-4v2h4v2h-3v2h3v2h-4v2h4c1.1025,0,2-.8975,2-2v-6c0-1.103-.8975-2-2-2ZM2,4v4h2v-4h4v-2h-4c-1.1046,0-2,.8954-2,2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fqe.propTypes = E);
const pqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qW || (qW = /* @__PURE__ */ h.createElement("path", {
    d: "M10,7h3v2h-3v4c0,1.2002-.5425,2.2661-1.3823,3,.8398.7339,1.3823,1.7998,1.3823,3v4h3v2h-3c-1.103,0-2-.8975-2-2v-4c0-1.1025-.897-2-2-2v-2c1.103,0,2-.8975,2-2v-4c0-1.1025.897-2,2-2ZM24,13v-4c0-1.1025-.897-2-2-2h-3v2h3v4c0,1.2002.5425,2.2661,1.3823,3-.8398.7339-1.3823,1.7998-1.3823,3v4h-3v2h3c1.103,0,2-.8975,2-2v-4c0-1.1025.897-2,2-2v-2c-1.103,0-2-.8975-2-2ZM2,4v4h2v-4h4v-2h-4c-1.1046,0-2,.8954-2,2ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM4,28v-4h-2v4c0,1.1046.8954,2,2,2h4v-2h-4ZM28,24v4h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pqe.propTypes = E);
const gqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GW || (GW = /* @__PURE__ */ h.createElement("path", {
    d: "M4,28h4v2h-4c-1.1046,0-2-.8954-2-2v-4h2v4ZM11,13v8h-5c-1.1046,0-2-.8954-2-2v-2c0-1.1046.8954-2,2-2h3v-2h-4v-2h4c1.1025,0,2,.897,2,2ZM9,17h-3v2h3v-2ZM4,4h4v-2h-4c-1.1046,0-2,.8954-2,2v4h2v-4ZM28,2h-4v2h4v4h2v-4c0-1.1046-.8954-2-2-2ZM28,28h-4v2h4c1.1046,0,2-.8954,2-2v-4h-2v4ZM28,21v-2h-4v-6h4v-2h-4c-1.1025,0-2,.897-2,2v6c0,1.1025.8975,2,2,2h4ZM20,13v6c0,1.1025-.8975,2-2,2h-5v-13h2v3h3c1.1025,0,2,.897,2,2ZM18,13h-3v6h3v-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gqe.propTypes = E);
const mqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, QW || (QW = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H30V30H2zM17.21 5.23l1.39.38 1 11.29 5.87 1.57A2 2 0 0127 20.62a1.88 1.88 0 01-1.37 1.52 2 2 0 01-1 0l-18.7-5a1.89 1.89 0 01-1.33-2.3L6.35 8.34l1.44.38L8.4 13.9l6 1.62L17.21 5.23m-1-2.2a1 1 0 00-.68.69L13 13.07l-2.81-.75L9.69 7.79A1 1 0 009 7L5.87 6.14a.94.94 0 00-.5 0 1 1 0 00-.68.68l-2 7.49a3.87 3.87 0 002.74 4.74l18.71 5A3.87 3.87 0 0029 21a4 4 0 00-3-4.42l-4.52-1.21L20.53 4.71a1 1 0 00-.72-.85L16.73 3a1.06 1.06 0 00-.5 0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mqe.propTypes = E);
const Aqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KW || (KW = /* @__PURE__ */ h.createElement("path", {
    d: "M13.71 12.29L7.42 6 14 6 14 4 4 4 4 13.99 6 14.01 6 7.41 12.29 13.7 13.71 12.29zM28 10H18v2H28V28H12V18H10V28a2 2 0 002 2H28a2 2 0 002-2V12A2 2 0 0028 10z"
  })), YW || (YW = /* @__PURE__ */ h.createElement("path", {
    d: "M19 25L21 25 21 18 24 18 24 16 16 16 16 18 19 18 19 25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Aqe.propTypes = E);
const wqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, XW || (XW = /* @__PURE__ */ h.createElement("path", {
    d: "M12.3 9.3L8.5 13.1 8.5 1 7.5 1 7.5 13.1 3.7 9.3 3 10 8 15 13 10z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JW || (JW = /* @__PURE__ */ h.createElement("path", {
    d: "M24.59 16.59L17 24.17 17 4 15 4 15 24.17 7.41 16.59 6 18 16 28 26 18 24.59 16.59z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wqe.propTypes = E);
const vqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $W || ($W = /* @__PURE__ */ h.createElement("path", {
    d: "M22 26L22 24 9.41 24 26 7.41 24.59 6 8 22.59 8 10 6 10 6 26 22 26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vqe.propTypes = E);
const bqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ej || (ej = /* @__PURE__ */ h.createElement("path", {
    d: "M10 26L10 24 22.59 24 6 7.41 7.41 6 24 22.59 24 10 26 10 26 26 10 26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bqe.propTypes = E);
const yqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, tj || (tj = /* @__PURE__ */ h.createElement("path", {
    d: "M6.7 12.3L2.9 8.5 15 8.5 15 7.5 2.9 7.5 6.7 3.7 6 3 1 8 6 13z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nj || (nj = /* @__PURE__ */ h.createElement("path", {
    d: "M14 26L15.41 24.59 7.83 17 28 17 28 15 7.83 15 15.41 7.41 14 6 4 16 14 26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yqe.propTypes = E);
const mMe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, ij || (ij = /* @__PURE__ */ h.createElement("path", {
    d: "M9.3 3.7L13.1 7.5 1 7.5 1 8.5 13.1 8.5 9.3 12.3 10 13 15 8 10 3z"
  })), n) : i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, rj || (rj = /* @__PURE__ */ h.createElement("path", {
    d: "M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, sj || (sj = /* @__PURE__ */ h.createElement("path", {
    d: "M14 4L12.9 5.1 18.9 11.2 2 11.2 2 12.8 18.9 12.8 12.9 18.9 14 20 22 12z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, oj || (oj = /* @__PURE__ */ h.createElement("path", {
    d: "M18 6L16.57 7.393 24.15 15 4 15 4 17 24.15 17 16.57 24.573 18 26 28 16 18 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mMe.propTypes = E);
const Cqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, aj || (aj = /* @__PURE__ */ h.createElement("path", {
    d: "M3.7 6.7L7.5 2.9 7.5 15 8.5 15 8.5 2.9 12.3 6.7 13 6 8 1 3 6z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lj || (lj = /* @__PURE__ */ h.createElement("path", {
    d: "M16 4L6 14 7.41 15.41 15 7.83 15 28 17 28 17 7.83 24.59 15.41 26 14 16 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cqe.propTypes = E);
const Eqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cj || (cj = /* @__PURE__ */ h.createElement("path", {
    d: "M22 6L22 8 9.41 8 26 24.59 24.59 26 8 9.41 8 22 6 22 6 6 22 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eqe.propTypes = E);
const _qe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hj || (hj = /* @__PURE__ */ h.createElement("path", {
    d: "M10 6L10 8 22.59 8 6 24.59 7.41 26 24 9.41 24 22 26 22 26 6 10 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_qe.propTypes = E);
const xqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dj || (dj = /* @__PURE__ */ h.createElement("path", {
    d: "M23,6V16h5a1,1,0,0,1,.707,1.707l-12,12a.9994.9994,0,0,1-1.414,0l-12-12A1,1,0,0,1,4,16H9V6a2.0023,2.0023,0,0,1,2-2H21A2.0027,2.0027,0,0,1,23,6ZM16,27.5859,25.5859,18H21V6H11V18H6.4141Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xqe.propTypes = E);
const Sqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uj || (uj = /* @__PURE__ */ h.createElement("path", {
    d: "M11.41 26.59L7.83 23 28 23 28 21 7.83 21 11.41 17.41 10 16 4 22 10 28 11.41 26.59zM28 10L22 4 20.59 5.41 24.17 9 4 9 4 11 24.17 11 20.59 14.59 22 16 28 10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sqe.propTypes = E);
var pj, gj, mj, Aj, wj, vj, bj, yj, Cj, Ej, _j, xj, Sj, Mj, Dj, Lj, kj, Nj, Tj, Ij, Oj, Rj, Vj, Hj, Bj, Pj, Fj, zj, Wj, jj, Zj, Uj, qj, Gj, Qj, Kj, Yj, Xj, Jj, $j, eZ, tZ, nZ, iZ, rZ, sZ, oZ, aZ, lZ, cZ, hZ, dZ, uZ, fZ, pZ, gZ, mZ, AZ, wZ, vZ, bZ, yZ, CZ, EZ, _Z, xZ, SZ, MZ, DZ, LZ, kZ, NZ, TZ, IZ, OZ, RZ, VZ, HZ, BZ, PZ, FZ, zZ, WZ, jZ, ZZ, UZ, qZ, GZ, QZ, KZ, YZ, XZ, JZ, $Z, eU, tU, nU, iU, rU, sU, oU, aU, lU, cU, hU, dU, uU, fU, pU, gU, mU, AU, wU, vU, bU, yU, CU, EU, _U, xU, SU, MU, DU, LU, kU, NU, TU, IU, OU, RU, VU, HU, BU, PU, FU, zU, WU, jU, ZU, UU, qU, GU, QU, KU, YU, XU, JU, $U, eq, tq, nq, iq, rq, sq, oq, aq, lq, cq, hq, dq, uq, fq, pq, gq, mq, Aq, wq, vq, bq, yq, Cq, Eq, _q, xq, Sq, Mq, Dq, Lq, kq, Nq, Tq, Iq, Oq, Rq, Vq, Hq, Bq, Pq, Fq, zq, Wq, jq, Zq, Uq, qq, Gq, Qq, Kq, Yq, Xq, Jq, $q, eG, tG, nG, iG, rG, sG, oG, aG, lG, cG, hG, dG, uG, fG, pG, gG, mG, AG, wG, vG, bG, yG, CG, EG, _G, xG, SG, MG, DG, LG, kG, NG, TG, IG, OG, RG, VG, HG, BG, PG, FG, zG, WG, jG, ZG, UG;
const Mqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pj || (pj = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), gj || (gj = /* @__PURE__ */ h.createElement("path", {
    d: "M14 21.5L9 16.54 10.59 15 14 18.35 21.41 11 23 12.58 14 21.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mqe.propTypes = E);
const Dqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mj || (mj = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z"
  })), Aj || (Aj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M14,21.5,9,16.5427,10.5908,15,14,18.3456,21.4087,11l1.5918,1.5772Z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dqe.propTypes = E);
const Lqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wj || (wj = /* @__PURE__ */ h.createElement("path", {
    d: "M10 14H22V18H10z"
  })), vj || (vj = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM6,26V6H26V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lqe.propTypes = E);
const kqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bj || (bj = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM22,18H10V14H22Z"
  })), yj || (yj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M22,18H10V14H22Z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (kqe.propTypes = E);
const Qg = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, Cj || (Cj = /* @__PURE__ */ h.createElement("path", {
    d: "M8 13.2L3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
  })), Ej || (Ej = /* @__PURE__ */ h.createElement("path", {
    d: "M15.6 5.6L8 13.2 3.6 8.8 2.7 9.7 7.1 14.1 8 15 16.5 6.5 15.6 5.6z"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, _j || (_j = /* @__PURE__ */ h.createElement("path", {
    d: "M10 15.9L4.7 10.6 3.6 11.6 8.9 16.9 10 18 20.6 7.4 19.5 6.3z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xj || (xj = /* @__PURE__ */ h.createElement("path", {
    d: "M13 24L4 15 5.414 13.586 13 21.171 26.586 7.586 28 9 13 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qg.propTypes = E);
const _7 = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Sj || (Sj = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8c0,3.9,3.1,7,7,7s7-3.1,7-7C15,4.1,11.9,1,8,1z M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z"
  })), Mj || (Mj = /* @__PURE__ */ h.createElement("path", {
    d: "M7,11L4.3,8.3l0.9-0.8L7,9.3l4-3.9l0.9,0.8L7,11z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, Dj || (Dj = /* @__PURE__ */ h.createElement("path", {
    d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z"
  })), Lj || (Lj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M8.7,13.5l-3.2-3.2l1-1l2.2,2.2l4.8-4.8l1,1L8.7,13.5z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, kj || (kj = /* @__PURE__ */ h.createElement("path", {
    d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z"
  })), Nj || (Nj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M10.4,16.3l-3.9-3.9l1.3-1.2l2.7,2.7l5.8-5.8l1.3,1.3L10.4,16.3z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tj || (Tj = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM14,21.5908l-5-5L10.5906,15,14,18.4092,21.41,11l1.5957,1.5859Z"
  })), Ij || (Ij = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M14 21.591L9 16.591 10.591 15 14 18.409 21.41 11 23.005 12.585 14 21.591z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (_7.propTypes = E);
const Nqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Oj || (Oj = /* @__PURE__ */ h.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), Rj || (Rj = /* @__PURE__ */ h.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.82V24a8,8,0,0,1,8-8h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), Vj || (Vj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nqe.propTypes = E);
const Tqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hj || (Hj = /* @__PURE__ */ h.createElement("path", {
    d: "M14,2a12,12,0,1,0,3.3928,23.5059l3.9246-7.8492A2.9846,2.9846,0,0,1,24,16h1.82A11.9348,11.9348,0,0,0,14,2ZM12,18.5908l-4-4L9.5908,13,12,15.4092,17.4092,10,19,11.5908Z"
  })), Bj || (Bj = /* @__PURE__ */ h.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), Pj || (Pj = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M12 18.591L8 14.591 9.591 13 12 15.409 17.409 10 19 11.591 12 18.591z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tqe.propTypes = E);
const cI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fj || (Fj = /* @__PURE__ */ h.createElement("path", {
    d: "M14 21.414L9 16.413 10.413 15 14 18.586 21.585 11 23 12.415 14 21.414z"
  })), zj || (zj = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cI.propTypes = E);
const Iqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wj || (Wj = /* @__PURE__ */ h.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), jj || (jj = /* @__PURE__ */ h.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iqe.propTypes = E);
const Oqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zj || (Zj = /* @__PURE__ */ h.createElement("path", {
    d: "M14,24A10,10,0,1,1,24,14h2A12,12,0,1,0,14,26Z"
  })), Uj || (Uj = /* @__PURE__ */ h.createElement("path", {
    d: "M12 15.59L9.41 13 8 14.41 12 18.41 19 11.41 17.59 10 12 15.59zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oqe.propTypes = E);
const Rqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qj || (qj = /* @__PURE__ */ h.createElement("path", {
    d: "M27.2314,23.6182,20,13.6748V4h2V2H10V4h2v9.6748L4.7686,23.6182A4.0183,4.0183,0,0,0,8.0186,30H23.9814a4.0183,4.0183,0,0,0,3.25-6.3818ZM14,14.3252V4h4V14.3252L20.6728,18H11.3272ZM23.9814,28H8.0186a2.0192,2.0192,0,0,1-1.6329-3.2061L9.8726,20H22.1274l3.4869,4.7939A2.0192,2.0192,0,0,1,23.9814,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rqe.propTypes = E);
const Vqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gj || (Gj = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), Qj || (Qj = /* @__PURE__ */ h.createElement("path", {
    d: "M20,13.67V4h2V2H10V4h2v9.67L9.58,17h2.4767L14,14.33V4h4V14.33l7.61,10.46a2.0133,2.0133,0,0,1-.44,2.82,2.0406,2.0406,0,0,1-1.19.39H15v2h8.98a4.0154,4.0154,0,0,0,3.25-6.38Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vqe.propTypes = E);
const Hqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6",
    fill: "currentColor",
    ...s
  }, Kj || (Kj = /* @__PURE__ */ h.createElement("path", {
    d: "M5 6L0 1 0.7 0.3 5 4.6 9.3 0.3 10 1z"
  })), n) : i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Yj || (Yj = /* @__PURE__ */ h.createElement("path", {
    d: "M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xj || (Xj = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hqe.propTypes = E);
const Bqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jj || (Jj = /* @__PURE__ */ h.createElement("path", {
    d: "M9.4142 12.5858L16 19.1714 22.5858 12.5858 24 14 16 22 8 14 9.4142 12.5858z"
  })), $j || ($j = /* @__PURE__ */ h.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bqe.propTypes = E);
const Pqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    fill: "currentColor",
    ...s
  }, eZ || (eZ = /* @__PURE__ */ h.createElement("path", {
    d: "M0 5L5 0 5.7 0.7 1.4 5 5.7 9.3 5 10z"
  })), n) : i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, tZ || (tZ = /* @__PURE__ */ h.createElement("path", {
    d: "M5 8L10 3 10.7 3.7 6.4 8 10.7 12.3 10 13z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nZ || (nZ = /* @__PURE__ */ h.createElement("path", {
    d: "M10 16L20 6 21.4 7.4 12.8 16 21.4 24.6 20 26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pqe.propTypes = E);
const Fqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, iZ || (iZ = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9L15 15 9 15z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rZ || (rZ = /* @__PURE__ */ h.createElement("path", {
    d: "M31 19L31 31 19 31 31 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fqe.propTypes = E);
const zqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10",
    fill: "currentColor",
    ...s
  }, sZ || (sZ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 5L1 10 0.3 9.3 4.6 5 0.3 0.7 1 0z"
  })), n) : i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, oZ || (oZ = /* @__PURE__ */ h.createElement("path", {
    d: "M11 8L6 13 5.3 12.3 9.6 8 5.3 3.7 6 3z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aZ || (aZ = /* @__PURE__ */ h.createElement("path", {
    d: "M22 16L12 26 10.6 24.6 19.2 16 10.6 7.4 12 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zqe.propTypes = E);
const Wqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, lZ || (lZ = /* @__PURE__ */ h.createElement("path", {
    d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5zM8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cZ || (cZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 28L9 21 10.41 19.59 16 25.17 21.59 19.59 23 21 16 28zM16 4L23 11 21.59 12.41 16 6.83 10.41 12.41 9 11 16 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wqe.propTypes = E);
const jqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, hZ || (hZ = /* @__PURE__ */ h.createElement("path", {
    d: "M8 14L4.5 10.5 5.2 9.8 8 12.6 10.8 9.8 11.5 10.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dZ || (dZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 28L9 21 10.4 19.6 16 25.2 21.6 19.6 23 21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jqe.propTypes = E);
const Zqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, uZ || (uZ = /* @__PURE__ */ h.createElement("path", {
    d: "M8 2L11.5 5.5 10.8 6.2 8 3.4 5.2 6.2 4.5 5.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fZ || (fZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 4L23 11 21.6 12.4 16 6.8 10.4 12.4 9 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zqe.propTypes = E);
const Uqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6",
    fill: "currentColor",
    ...s
  }, pZ || (pZ = /* @__PURE__ */ h.createElement("path", {
    d: "M5 0L10 5 9.3 5.7 5 1.4 0.7 5.7 0 5z"
  })), n) : i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, gZ || (gZ = /* @__PURE__ */ h.createElement("path", {
    d: "M8 5L13 10 12.3 10.7 8 6.4 3.7 10.7 3 10z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mZ || (mZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 10L26 20 24.6 21.4 16 12.8 7.4 21.4 6 20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uqe.propTypes = E);
const qqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AZ || (AZ = /* @__PURE__ */ h.createElement("path", {
    d: "M9.4142 19.4142L16 12.8286 22.5858 19.4142 24 18 16 10 8 18 9.4142 19.4142z"
  })), wZ || (wZ = /* @__PURE__ */ h.createElement("path", {
    d: "m30,16c0,7.7197-6.2803,14-14,14S2,23.7197,2,16,8.2803,2,16,2s14,6.2803,14,14Zm-26,0c0,6.6167,5.3833,12,12,12s12-5.3833,12-12-5.3833-12-12-12S4,9.3833,4,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qqe.propTypes = E);
const Gqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vZ || (vZ = /* @__PURE__ */ h.createElement("path", {
    d: "M11,11V21H21V11Zm8,8H13V13h6Z"
  })), bZ || (bZ = /* @__PURE__ */ h.createElement("path", {
    d: "M30,13V11H26V8a2,2,0,0,0-2-2H21V2H19V6H13V2H11V6H8A2,2,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2,2,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2,2,0,0,0,2-2V21h4V19H26V13ZM24,24H8V8H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gqe.propTypes = E);
const Qqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yZ || (yZ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 13L28 4 19 4 19 6 24.586 6 16 14.586 7.414 6 13 6 13 4 4 4 4 13 6 13 6 7.414 15 16.414 15 26 4 26 4 28 28 28 28 26 17 26 17 16.414 26 7.414 26 13 28 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qqe.propTypes = E);
const Kqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CZ || (CZ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 6H30V26H28zM17 6L15.57 7.393 23.15 15 2 15 2 17 23.15 17 15.57 24.573 17 26 27 16 17 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kqe.propTypes = E);
const Yqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, EZ || (EZ = /* @__PURE__ */ h.createElement("path", {
    d: "M29.2427,4.03l-8-2a1.0065,1.0065,0,0,0-.6143.0415l-9.7,3.88L3.2427,4.03A1,1,0,0,0,2,5V27a1,1,0,0,0,.7573.97l8,2A1.0244,1.0244,0,0,0,11,30a.9953.9953,0,0,0,.3716-.0718l9.7-3.88,7.686,1.9219A1,1,0,0,0,30,27V5A1,1,0,0,0,29.2427,4.03ZM28,11H22V4.2806l6,1.5ZM10,19H4V13h6Zm2-8V7.6771l8-3.2V11Zm8,2v6H12V13Zm-8,8h8v3.3227l-8,3.2Zm10-8h6v6H22ZM10,7.7806V11H4V6.2806ZM4,21h6v6.7192l-6-1.5Zm18,3.2187V21h6v4.7192Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yqe.propTypes = E);
const Xqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _Z || (_Z = /* @__PURE__ */ h.createElement("path", {
    d: "M30.3335 30H26V28h4V26H28a2.002 2.002 0 01-2-2V21.6665A1.6684 1.6684 0 0127.6665 20H32v2H28v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0130.3335 30zM22.3335 20h-2.667A1.6665 1.6665 0 0018 21.6665V30h2V26h2v4h2V21.6665A1.6665 1.6665 0 0022.3335 20zM20 24V22h2v2zM12.5 24L11 20 9 20 9 30 11 30 11 23 12.5 27 14 23 14 30 16 30 16 20 14 20 12.5 24zM1 22v6.5A1.4727 1.4727 0 002.5 30H7V28H3V22H7V20H3A2.0059 2.0059 0 001 22zM13 8L11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11 13 11 13 8z"
  })), xZ || (xZ = /* @__PURE__ */ h.createElement("path", {
    d: "M6,6H26V18h2V6a2.0059,2.0059,0,0,0-2-2H6A2.0059,2.0059,0,0,0,4,6V18H6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xqe.propTypes = E);
const Jqe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SZ || (SZ = /* @__PURE__ */ h.createElement("path", {
    d: "M22.5,30c-1.9299,0-3.5-1.5701-3.5-3.5,0-.9346,.3638-1.8134,1.0244-2.4742l1.4146,1.4138c-.283,.2832-.439,.6598-.439,1.0604,0,.8271,.6729,1.5,1.5,1.5,.4009,0,.7776-.1561,1.061-.4396l4.9998-4.9998c.2832-.2833,.4392-.66,.4392-1.0607,0-.8271-.6729-1.5-1.5-1.5-.4011,0-.7783,.1564-1.0618,.4404l-1.4155-1.4131c.6616-.6625,1.5413-1.0273,2.4773-1.0273,1.9299,0,3.5,1.5701,3.5,3.5,0,.9348-.364,1.8137-1.0249,2.4749l-4.9998,4.9996c-.6609,.6613-1.54,1.0255-2.4753,1.0255Z"
  })), MZ || (MZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16.5 31c-1.9299 0-3.5-1.5701-3.5-3.5 0-.9348.364-1.8137 1.0249-2.4749l4.9998-4.9996c.6609-.6613 1.54-1.0255 2.4753-1.0255 1.9299 0 3.5 1.5701 3.5 3.5 0 .9346-.3638 1.8134-1.0244 2.4742l-1.4146-1.4138c.283-.2832.439-.6598.439-1.0604 0-.8271-.6729-1.5-1.5-1.5-.4009 0-.7776.1561-1.061.4396l-4.9998 4.9998c-.2832.2833-.4392.66-.4392 1.0607 0 .8271.6729 1.5 1.5 1.5.4011 0 .7783-.1564 1.0618-.4404l1.4155 1.4131c-.6616.6625-1.5413 1.0273-2.4773 1.0273zM16 2c-5.2979 0-11 1.252-11 4V24c0 1.6797 2.134 2.7979 5 3.415v-2.0459c-1.9939-.4727-2.9453-1.1431-3-1.3691v-3.5723c1.4937.749 3.6738 1.2153 6 1.4302v-1.9976c-3.8779-.3774-5.8774-1.4219-6-1.8604v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723 5.2979 0 11-1.252 11-4V5.9995c-.0007-2.748-5.7024-3.9995-11-3.9995zM6.9985 6.0151c.1523-.5552 3.1514-2.0151 9.0015-2.0151 5.7976 0 8.7949 1.4341 8.9968 2-.2019.5659-3.1992 2-8.9968 2-5.8501 0-8.8491-1.46-9.0015-1.9849zm18.0015 5.9722c-.1606.5571-3.1587 2.0127-9 2.0127-5.8501 0-8.8491-1.46-9-2v-3.5723c2.1279 1.0674 5.6426 1.5723 9 1.5723s6.8721-.5049 9-1.5723v3.5596z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jqe.propTypes = E);
const $qe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DZ || (DZ = /* @__PURE__ */ h.createElement("path", {
    d: "M24 16L19.4 14.6 21.7 10.3 17.4 12.6 16 8 14.6 12.6 10.3 10.3 12.6 14.6 8 16 12.6 17.4 10.3 21.7 14.6 19.4 16 24 17.4 19.4 21.7 21.7 19.4 17.4 24 16z"
  })), LZ || (LZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($qe.propTypes = E);
const eGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kZ || (kZ = /* @__PURE__ */ h.createElement("path", {
    d: "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), NZ || (NZ = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), TZ || (TZ = /* @__PURE__ */ h.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), IZ || (IZ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H28c1.1028,0,2-.8975,2-2V6c0-1.1025-.8972-2-2-2Zm0,2v4H4V6H28ZM4,26V12H28v14H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eGe.propTypes = E);
const tGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OZ || (OZ = /* @__PURE__ */ h.createElement("path", {
    d: "M23 22L30 27 23 32 23 22z"
  })), RZ || (RZ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,3H6c-1.6543,0-3,1.3457-3,3V26c0,1.6543,1.3457,3,3,3h11v-9h12V6c0-1.6543-1.3457-3-3-3ZM6,5H26c.5515,0,1,.4482,1,1v3H5v-3c0-.5518,.4485-1,1-1Zm9,6v7H5v-7H15Zm0,16H6c-.5515,0-1-.4482-1-1v-6H15v7Zm2-9v-7h10v7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tGe.propTypes = E);
const nGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VZ || (VZ = /* @__PURE__ */ h.createElement("path", {
    d: "M31.707 20.293l-3-3c-.3901-.3906-1.0239-.3906-1.4141 0l-9.293 9.293v4.4141h4.4143l9.2927-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-7.4141 6l-2.7073 2.707h-1.5857v-1.5859l2.707-2.707 2.293-2.293 1.5859 1.5859-2.293 2.293zm3.707-3.707l-1.5859-1.5859 1.5859-1.5859 1.5857 1.5859-1.5857 1.5859zM20 20v-2h-4v-7h10v2h2V6c0-1.6543-1.3457-3-3-3H5c-1.6543 0-3 1.3457-3 3V26c0 1.6543 1.3457 3 3 3h11v-9h4zm-6-2H4v-7H14v7zM5 5H25c.5515 0 1 .4482 1 1v3H4v-3c0-.5518.4485-1 1-1zM14 27H5c-.5515 0-1-.4482-1-1v-6H14v7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nGe.propTypes = E);
const iGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HZ || (HZ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 2H23V4h5V28H23v2h5a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0028 2zM14 17H8a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V18A.9448.9448 0 0014 17zm-1 6H9V19h4z"
  })), BZ || (BZ = /* @__PURE__ */ h.createElement("path", {
    d: "M25 24V18a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6a.9448.9448 0 001 1h6A1.0021 1.0021 0 0025 24zm-2-1H19V19h4zM14 7H8A.9448.9448 0 007 8v6a.9448.9448 0 001 1h6a.9448.9448 0 001-1V8A.9448.9448 0 0014 7zm-1 6H9V9h4zM18 15h6a.9448.9448 0 001-1V8a.9448.9448 0 00-1-1H18a.9448.9448 0 00-1 1v6A1.0021 1.0021 0 0018 15zm1-6h4v4H19z"
  })), PZ || (PZ = /* @__PURE__ */ h.createElement("path", {
    d: "M4,4H9V2H4A2.0059,2.0059,0,0,0,2,4V28a2.0059,2.0059,0,0,0,2,2H9V28H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iGe.propTypes = E);
const rGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FZ || (FZ = /* @__PURE__ */ h.createElement("circle", {
    cx: "28",
    cy: "10",
    r: "2"
  })), zZ || (zZ = /* @__PURE__ */ h.createElement("path", {
    d: "M18,29h-7v-2h7c4.9626,0,9-4.0374,9-9v-4h2v4c0,6.0654-4.9346,11-11,11Z"
  })), WZ || (WZ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,21c-2.7571,0-5-2.2429-5-5s2.2429-5,5-5,5,2.2429,5,5-2.2429,5-5,5Zm0-8c-1.6543,0-3,1.3457-3,3s1.3457,3,3,3,3-1.3457,3-3-1.3457-3-3-3Z"
  })), jZ || (jZ = /* @__PURE__ */ h.createElement("circle", {
    cx: "4",
    cy: "22",
    r: "2"
  })), ZZ || (ZZ = /* @__PURE__ */ h.createElement("path", {
    d: "M5,18H3v-4C3,7.9346,7.9346,3,14,3h7v2h-7c-4.9626,0-9,4.0374-9,9v4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rGe.propTypes = E);
const sGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UZ || (UZ = /* @__PURE__ */ h.createElement("path", {
    d: "M22 22L24 22 24 28 22 28 22 30 28 30 28 28 26 28 26 22 28 22 28 20 22 20 22 22zM18 28H16V20H14v8.6A1.4529 1.4529 0 0015.5 30h3A1.4529 1.4529 0 0020 28.6V20H18zM10.2 20L10 28.5 9 22 7 22 6 28.5 5.8 20 4 20 4.72 30 7 30 8 23.5 9 30 11.28 30 12 20 10.2 20zM16 11L13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13 16 11z"
  })), qZ || (qZ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V18H6V6H26V18h2V6A2.0059,2.0059,0,0,0,26,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sGe.propTypes = E);
const oGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GZ || (GZ = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5 18L21 18.7 21 16 19 16 19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18zM16 13L16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16 13 13 16 13z"
  })), QZ || (QZ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,26,4ZM6,26V6H26V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oGe.propTypes = E);
const aGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KZ || (KZ = /* @__PURE__ */ h.createElement("path", {
    d: "M31 13v-2h-4c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h2v2h-4v2h4c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-2v-2h4zM17 13v6c0 1.1025.8972 2 2 2h4v-2h-4v-6h4v-2h-4c-1.1028 0-2 .8975-2 2zM9 13L11 13 11 19 9 19 9 21 15 21 15 19 13 19 13 13 15 13 15 11 9 11 9 13zM1 13v6c0 1.1025.8972 2 2 2H7v-2H3v-6H7v-2H3c-1.1028 0-2 .8975-2 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aGe.propTypes = E);
const lGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YZ || (YZ = /* @__PURE__ */ h.createElement("path", {
    d: "M22 2L22 4 26.6 4 20 10.6 21.4 12 28 5.4 28 10 30 10 30 2 22 2zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), XZ || (XZ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lGe.propTypes = E);
const cGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JZ || (JZ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 7H28V10H26zM29 4H32V6H29zM26 0H28V3H26zM22 4H25V6H22zM19 16L19 18.7 16.5 18 16 19.9 18.4 20.6 17 23 18.7 24 20 21.8 21.3 24 23 23 21.6 20.6 24 19.9 23.5 18 21 18.7 21 16 19 16zM13 16L13 13 16 13 16 11 13 11 13 8 11 8 11 11 8 11 8 13 11 13 11 16 13 16z"
  })), $Z || ($Z = /* @__PURE__ */ h.createElement("path", {
    d: "M26,26H6V6H19V4H6A2.0059,2.0059,0,0,0,4,6V26a2.0059,2.0059,0,0,0,2,2H26a2.0059,2.0059,0,0,0,2-2V13H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cGe.propTypes = E);
const hGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eU || (eU = /* @__PURE__ */ h.createElement("path", {
    d: "M8 18.6V17H6v1.6A7.3833 7.3833 0 0013.4 26H15V24H13.4A5.3775 5.3775 0 018 18.6zM28 18H20a2.0059 2.0059 0 00-2 2v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V20A2.0059 2.0059 0 0028 18zM20 28V20h8v8zM24 13.4V15h2V13.4A7.3833 7.3833 0 0018.6 6H17V8h1.6A5.3775 5.3775 0 0124 13.4zM12 2H4A2.0059 2.0059 0 002 4v8a2.0059 2.0059 0 002 2h8a2.0059 2.0059 0 002-2V4A2.0059 2.0059 0 0012 2zM4 12V4h8v8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hGe.propTypes = E);
const dGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tU || (tU = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "10"
  })), nU || (nU = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dGe.propTypes = E);
const uGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iU || (iU = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-7.732,0-14,6.268-14,14s6.268,14,14,14,14-6.268,14-14S23.732,2,16,2Zm0,26c-6.6274,0-12-5.3726-12-12s5.3726-12,12-12,12,5.3726,12,12-5.3726,12-12,12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uGe.propTypes = E);
const fGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rU || (rU = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "14"
  })), n);
});
process.env.NODE_ENV !== "production" && (fGe.propTypes = E);
const pGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sU || (sU = /* @__PURE__ */ h.createElement("path", {
    d: "M7.7 4.7a14.7 14.7 0 00-3 3.1L6.3 9A13.26 13.26 0 018.9 6.3zM4.6 12.3l-1.9-.6A12.51 12.51 0 002 16H4A11.48 11.48 0 014.6 12.3zM2.7 20.4a14.4 14.4 0 002 3.9l1.6-1.2a12.89 12.89 0 01-1.7-3.3zM7.8 27.3a14.4 14.4 0 003.9 2l.6-1.9A12.89 12.89 0 019 25.7zM11.7 2.7l.6 1.9A11.48 11.48 0 0116 4V2A12.51 12.51 0 0011.7 2.7zM24.2 27.3a15.18 15.18 0 003.1-3.1L25.7 23A11.53 11.53 0 0123 25.7zM27.4 19.7l1.9.6A15.47 15.47 0 0030 16H28A11.48 11.48 0 0127.4 19.7zM29.2 11.6a14.4 14.4 0 00-2-3.9L25.6 8.9a12.89 12.89 0 011.7 3.3zM24.1 4.6a14.4 14.4 0 00-3.9-2l-.6 1.9a12.89 12.89 0 013.3 1.7zM20.3 29.3l-.6-1.9A11.48 11.48 0 0116 28v2A21.42 21.42 0 0020.3 29.3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pGe.propTypes = E);
const gGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, oU || (oU = /* @__PURE__ */ h.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, aU || (aU = /* @__PURE__ */ h.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "6"
  })), n);
});
process.env.NODE_ENV !== "production" && (gGe.propTypes = E);
const mGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lU || (lU = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), cU || (cU = /* @__PURE__ */ h.createElement("path", {
    d: "M21,12.41V16h2V9H16v2h3.59L11,19.59V16H9v7h7V21H12.41Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mGe.propTypes = E);
const AGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hU || (hU = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.5,7A3.5,3.5,0,1,1,20,12.5,3.5041,3.5041,0,0,1,23.5,9Zm.4348-1.978C23.791,7.0107,23.6467,7,23.5,7a5.4826,5.4826,0,0,0-4.1323,1.8784,8.0109,8.0109,0,0,0-5.5664-4.6675A11.8554,11.8554,0,0,1,23.9348,7.022ZM16,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,28ZM12,18a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,12,18ZM4,16a11.97,11.97,0,0,1,.2112-2.1987,7.9921,7.9921,0,0,0,7.3459,6.1762,5.9581,5.9581,0,0,0-.89,6.7564A12.0025,12.0025,0,0,1,4,16ZM21.3325,26.7339a5.9834,5.9834,0,0,0-4.1782-8.6206,8.02,8.02,0,0,0,1.9126-2.3672,5.4883,5.4883,0,0,0,8.9167-.0679c.003.1079.0164.2134.0164.3218A12.0025,12.0025,0,0,1,21.3325,26.7339Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AGe.propTypes = E);
const wGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, dU || (dU = /* @__PURE__ */ h.createElement("path", {
    d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, uU || (uU = /* @__PURE__ */ h.createElement("path", {
    d: "M8,4A4,4,0,1,1,4,8,4.0045,4.0045,0,0,1,8,4M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wGe.propTypes = E);
const vGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fU || (fU = /* @__PURE__ */ h.createElement("path", {
    d: "M18 9L18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), pU || (pU = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H26V6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6v9H2v2H6v9a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V17h4ZM8,26V6H24V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vGe.propTypes = E);
const bGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gU || (gU = /* @__PURE__ */ h.createElement("circle", {
    cx: "15",
    cy: "19",
    r: "1"
  })), mU || (mU = /* @__PURE__ */ h.createElement("path", {
    d: "M27.7,9.3l-7-7A.9087.9087,0,0,0,20,2H10A2.0058,2.0058,0,0,0,8,4V14H6a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2H8v4a2.0058,2.0058,0,0,0,2,2H26a2.0058,2.0058,0,0,0,2-2V10A.9092.9092,0,0,0,27.7,9.3ZM20,4.4,25.6,10H20ZM6,16h9.5972L19,19l-3.3926,3H6ZM26,28H10V24h5.6089a2.0076,2.0076,0,0,0,1.3135-.4927l3.3833-2.9917a2.0015,2.0015,0,0,0,.01-3.0229l-3.4033-3.0083A1.9961,1.9961,0,0,0,15.6089,14H10V4h8v6a2.0058,2.0058,0,0,0,2,2h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bGe.propTypes = E);
const yGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AU || (AU = /* @__PURE__ */ h.createElement("path", {
    d: "M30 10V2H22v8h3v4H23v2h7V14H27V10zM24 4h4V8H24zM20 23.41L18.59 22 16 24.59 13.41 22 12 23.41 14.59 26 12 28.59 13.41 30 16 27.41 18.59 30 20 28.59 17.41 26 20 23.41zM20 14L12 14 12 16 15 16 15 21 17 21 17 16 20 16 20 14zM7 9.86a4 4 0 10-2 0V14H2v2H9V14H7zM4 6A2 2 0 116 8 2 2 0 014 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yGe.propTypes = E);
const CGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wU || (wU = /* @__PURE__ */ h.createElement("path", {
    d: "M20 18H26V20H20z",
    transform: "rotate(-180 23 19)"
  })), vU || (vU = /* @__PURE__ */ h.createElement("path", {
    d: "M24 26H30V28H24z",
    transform: "rotate(-180 27 27)"
  })), bU || (bU = /* @__PURE__ */ h.createElement("path", {
    d: "M22 22H28V24H22z",
    transform: "rotate(-180 25 23)"
  })), yU || (yU = /* @__PURE__ */ h.createElement("path", {
    d: "M17.0029,20a4.8952,4.8952,0,0,0-2.4044-4.1729L22,3,20.2691,2,12.6933,15.126A5.6988,5.6988,0,0,0,7.45,16.6289C3.7064,20.24,3.9963,28.6821,4.01,29.04a1,1,0,0,0,1,.96H20.0012a1,1,0,0,0,.6-1.8C17.0615,25.5439,17.0029,20.0537,17.0029,20ZM11.93,16.9971A3.11,3.11,0,0,1,15.0041,20c0,.0381.0019.208.0168.4688L9.1215,17.8452A3.8,3.8,0,0,1,11.93,16.9971ZM15.4494,28A5.2,5.2,0,0,1,14,25H12a6.4993,6.4993,0,0,0,.9684,3H10.7451A16.6166,16.6166,0,0,1,10,24H8a17.3424,17.3424,0,0,0,.6652,4H6c.031-1.8364.29-5.8921,1.8027-8.5527l7.533,3.35A13.0253,13.0253,0,0,0,17.5968,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CGe.propTypes = E);
const AMe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CU || (CU = /* @__PURE__ */ h.createElement("path", {
    d: "M17.4141 16L24 9.4141 22.5859 8 16 14.5859 9.4143 8 8 9.4141 14.5859 16 8 22.5859 9.4143 24 16 17.4141 22.5859 24 24 22.5859 17.4141 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AMe.propTypes = E);
const wMe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, EU || (EU = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _U || (_U = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), xU || (xU = /* @__PURE__ */ h.createElement("path", {
    d: "M14.4 16L9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4 21.4 23 16 17.6 10.6 23 9 21.4 14.4 16",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n);
});
process.env.NODE_ENV !== "production" && (wMe.propTypes = E);
const EGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SU || (SU = /* @__PURE__ */ h.createElement("path", {
    d: "M17.4141 16L26 7.4141 24.5859 6 16 14.5859 7.4143 6 6 7.4141 14.5859 16 6 24.5859 7.4143 26 16 17.4141 24.5859 26 26 24.5859 17.4141 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EGe.propTypes = E);
const _Ge = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MU || (MU = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
  })), DU || (DU = /* @__PURE__ */ h.createElement("path", {
    d: "M21.4 23L16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Ge.propTypes = E);
const xGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, LU || (LU = /* @__PURE__ */ h.createElement("path", {
    d: "M15 21H10a2 2 0 01-2-2V13a2 2 0 012-2h5v2H10v6h5zM25 21H20a2 2 0 01-2-2V13a2 2 0 012-2h5v2H20v6h5z"
  })), kU || (kU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,8V24H28V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xGe.propTypes = E);
const SGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, NU || (NU = /* @__PURE__ */ h.createElement("path", {
    d: "M19 17H25V19H19zM11 17H17V19H11zM6 17H9V19H6zM22 13H26V15H22zM13 13H20V15H13zM6 13H11V15H6z"
  })), TU || (TU = /* @__PURE__ */ h.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SGe.propTypes = E);
const MGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, IU || (IU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM15,13H10v6h5v2H10a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm10,0H20v6h5v2H20a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MGe.propTypes = E);
const DGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OU || (OU = /* @__PURE__ */ h.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DGe.propTypes = E);
const LGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RU || (RU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,17v5H4V6H15V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), VU || (VU = /* @__PURE__ */ h.createElement("path", {
    d: "M29,14H17a1,1,0,0,1-.8574-1.5144l6-10a1,1,0,0,1,1.7154,0l6,10A1,1,0,0,1,29,14ZM18.7661,12h8.4678L23,4.9436Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LGe.propTypes = E);
const kGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HU || (HU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,16v6H4V6H16V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), BU || (BU = /* @__PURE__ */ h.createElement("path", {
    d: "M21 15L16 10.04 17.59 8.47 21 11.85 28.41 4.5 30 6.08 21 15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kGe.propTypes = E);
const NGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, PU || (PU = /* @__PURE__ */ h.createElement("path", {
    d: "M28 18H30V28H28zM24 14H26V28H24zM20 22H22V28H20zM22.175 10L23.76 8.7339A9.9522 9.9522 0 0017.89 5.1816 10.0025 10.0025 0 006.17 13.1152 7.5054 7.5054 0 00.0544 21.4087 7.6843 7.6843 0 007.7692 28H16V26H7.6945a5.632 5.632 0 01-5.6023-4.4858 5.5064 5.5064 0 014.4339-6.4307l1.3486-.2441.2139-1.11a8.206 8.206 0 016.7426-6.6426 7.9666 7.9666 0 013.0137.13A7.8037 7.8037 0 0122.175 10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NGe.propTypes = E);
const TGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FU || (FU = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), zU || (zU = /* @__PURE__ */ h.createElement("path", {
    d: "M17 26.17L17 14 15 14 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TGe.propTypes = E);
const IGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WU || (WU = /* @__PURE__ */ h.createElement("path", {
    d: "M28 16v6H4V6H15V4H4A2 2 0 002 6V22a2 2 0 002 2h8v4H8v2H24V28H20V24h8a2 2 0 002-2V16zM18 28H14V24h4zM18 4H30V6H18z"
  })), jU || (jU = /* @__PURE__ */ h.createElement("path", {
    d: "M18 8H30V10H18zM18 12H24V14H18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IGe.propTypes = E);
const OGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZU || (ZU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,16v6H4V6h7V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V16ZM18,28H14V24h4Z"
  })), UU || (UU = /* @__PURE__ */ h.createElement("path", {
    d: "M18,18h-.01a1,1,0,0,1-.9511-.7253L15.2456,11H11V9h5a1,1,0,0,1,.9615.7252l1.0742,3.7589,3.0088-9.7783A1.0142,1.0142,0,0,1,22,3a.98.98,0,0,1,.9487.6838L24.7207,9H30v2H24a1,1,0,0,1-.9487-.6838l-1.0132-3.04L18.9556,17.2942A1,1,0,0,1,18,18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OGe.propTypes = E);
const RGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qU || (qU = /* @__PURE__ */ h.createElement("path", {
    d: "M24.8008 12.1362a8.8694 8.8694 0 00-.9795-2.5434L30 3.4142 28.5872 2 2 28.5872 3.4142 30l5-5H23.5a6.4974 6.4974 0 001.3008-12.8638zM23.5 23H10.4141L22.3418 11.0723a6.9049 6.9049 0 01.6006 2.0708l.0986.812.8154.0639A4.4975 4.4975 0 0123.5 23zM4.2964 23.4487l1.4313-1.4311A4.4774 4.4774 0 018.144 14.019l.8155-.0639.0991-.812a6.9867 6.9867 0 0110.63-5.0865l1.4431-1.4428A8.9859 8.9859 0 007.2 12.1362 6.4891 6.4891 0 004.2964 23.4487z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RGe.propTypes = E);
const VGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GU || (GU = /* @__PURE__ */ h.createElement("path", {
    d: "M28,17v5H4V6H14V4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V17ZM18,28H14V24h4Z"
  })), QU || (QU = /* @__PURE__ */ h.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VGe.propTypes = E);
const HGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KU || (KU = /* @__PURE__ */ h.createElement("path", {
    d: "M11 18L12.41 19.41 15 16.83 15 29 17 29 17 16.83 19.59 19.41 21 18 16 13 11 18z"
  })), YU || (YU = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HGe.propTypes = E);
const BGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, XU || (XU = /* @__PURE__ */ h.createElement("path", {
    d: "M25.8289 13.1155A10.02 10.02 0 0016 5.0005V7a8.0233 8.0233 0 017.8649 6.4934l.2591 1.346 1.3488.2441A5.5019 5.5019 0 0124.5076 26H16v2h8.5076a7.5019 7.5019 0 001.3213-14.8845zM8 24H14V26H8zM4 24H6V26H4zM6 20H14V22H6zM2 20H4V22H2zM8 16H14V18H8zM4 16H6V18H4zM10 12H14V14H10zM6 12H8V14H6zM12 8H14V10H12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BGe.propTypes = E);
const PGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JU || (JU = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H11V30H2zM21 28H30V30H21zM17 26.167L17 17.832 19.586 20.414 21 19 16 14 11 19 12.413 20.415 15 17.832 15 26.167 12.413 23.584 11 25 16 30 21 25 19.586 23.586 17 26.167z"
  })), $U || ($U = /* @__PURE__ */ h.createElement("path", {
    d: "M23,16H21V14h2a3,3,0,0,0,0-6c-.0938.0144-.1538.0219-.2153.0263l-.8037.0572L21.7544,7.31a5.9927,5.9927,0,0,0-11.1758-.8655l-.2832.5994-.8423-.0455A3.5008,3.5008,0,0,0,9.5,14H11v2H9.5A5.5,5.5,0,0,1,9.07,5.0166,7.9909,7.9909,0,0,1,23.42,6.0175,5,5,0,0,1,23,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PGe.propTypes = E);
const FGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eq || (eq = /* @__PURE__ */ h.createElement("path", {
    d: "M16,7h0a7.66,7.66,0,0,1,1.51.15,8,8,0,0,1,6.35,6.34l.26,1.35,1.35.24a5.5,5.5,0,0,1-1,10.92H7.5a5.5,5.5,0,0,1-1-10.92l1.34-.24.26-1.35A8,8,0,0,1,16,7m0-2a10,10,0,0,0-9.83,8.12A7.5,7.5,0,0,0,7.49,28h17a7.5,7.5,0,0,0,1.32-14.88,10,10,0,0,0-7.94-7.94A10.27,10.27,0,0,0,16,5Z"
  })), tq || (tq = /* @__PURE__ */ h.createElement("path", {
    d: "M14 24H11a2 2 0 01-2-2V19a2 2 0 012-2h3v2H11v3h3zM21 15V13H19a2 2 0 00-2 2v2H16v2h1v5h2V19h2V17H19V15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FGe.propTypes = E);
const zGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nq || (nq = /* @__PURE__ */ h.createElement("path", {
    d: "M25 11L25 9 17 9 17 23 19 23 19 17 24 17 24 15 19 15 19 11 25 11zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zGe.propTypes = E);
const WGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iq || (iq = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H23a2.0023 2.0023 0 01-2-2V23a2.0023 2.0023 0 012-2h5a2.0023 2.0023 0 012 2v5A2.0023 2.0023 0 0128 30zm-5-7h-.0012L23 28h5V23zM16 23H11a2.0023 2.0023 0 01-2-2V11a2.0023 2.0023 0 012-2H21a2.0023 2.0023 0 012 2v5H21V11H11V21h5z"
  })), rq || (rq = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V16H28V4H4V28H16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WGe.propTypes = E);
const jGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sq || (sq = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2"
  })), oq || (oq = /* @__PURE__ */ h.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,16,14Z"
  })), aq || (aq = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), lq || (lq = /* @__PURE__ */ h.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jGe.propTypes = E);
const ZGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cq || (cq = /* @__PURE__ */ h.createElement("path", {
    d: "M32,26V24H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,20.1011V18H24v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,24H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,29.8989V32h2V29.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,26Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,28Z"
  })), hq || (hq = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), dq || (dq = /* @__PURE__ */ h.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), uq || (uq = /* @__PURE__ */ h.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), fq || (fq = /* @__PURE__ */ h.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZGe.propTypes = E);
const UGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pq || (pq = /* @__PURE__ */ h.createElement("path", {
    d: "M30.9763,24.9748l-5.0015,5.0015a3.501,3.501,0,0,1-4.9511-4.9511L22.4383,26.44A1.5,1.5,0,0,0,24.56,28.5617L29.5617,23.56A1.5,1.5,0,0,0,27.44,21.4383l-1.4146-1.4146a3.501,3.501,0,0,1,4.9511,4.9511Z"
  })), gq || (gq = /* @__PURE__ */ h.createElement("path", {
    d: "M20.0252,21.0237l-5.0015,5.0015a3.501,3.501,0,0,0,4.9511,4.9511L18.56,29.5617A1.5,1.5,0,0,1,16.4383,27.44L21.44,22.4383A1.5,1.5,0,0,1,23.5617,24.56l1.4146,1.4146a3.501,3.501,0,0,0-4.9511-4.9511Z"
  })), mq || (mq = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), Aq || (Aq = /* @__PURE__ */ h.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), wq || (wq = /* @__PURE__ */ h.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), vq || (vq = /* @__PURE__ */ h.createElement("path", {
    d: "M11.3076,27.2725,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L10.3,29Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UGe.propTypes = E);
const qGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bq || (bq = /* @__PURE__ */ h.createElement("path", {
    d: "M29,26a2.97,2.97,0,0,0-1.8551.6607L25,25.4224V23.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,19,26a3.02,3.02,0,1,0,2.9254,2.3525L24,27.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,29,26ZM19,30a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,19,30Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,24,20Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,29,30Z"
  })), yq || (yq = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "20",
    r: "2"
  })), Cq || (Cq = /* @__PURE__ */ h.createElement("path", {
    d: "M14,20a4,4,0,1,1,4-4A4.0118,4.0118,0,0,1,14,20Zm0-6a2,2,0,1,0,2,2A2.0059,2.0059,0,0,0,14,14Z"
  })), Eq || (Eq = /* @__PURE__ */ h.createElement("circle", {
    cx: "21",
    cy: "12",
    r: "2"
  })), _q || (_q = /* @__PURE__ */ h.createElement("path", {
    d: "M13.0205,28.2715,3,22.4258V9.5742L14,3.1577,25.4961,9.8638l1.0078-1.7276-12-7a1,1,0,0,0-1.0078,0l-12,7A.9994.9994,0,0,0,1,9V23a1.0008,1.0008,0,0,0,.4961.8643L12.0127,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qGe.propTypes = E);
const GGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xq || (xq = /* @__PURE__ */ h.createElement("path", {
    d: "M25.8218,10.124a9.9991,9.9991,0,0,0-19.6435,0A7.4964,7.4964,0,0,0,7.5,25H8V23H7.5a5.4961,5.4961,0,0,1-.3769-10.9795l.8364-.0571.09-.8335a7.9979,7.9979,0,0,1,15.9013,0l.09.8335.8364.0571A5.4961,5.4961,0,0,1,24.5,23H24v2h.5a7.4964,7.4964,0,0,0,1.3218-14.876Z"
  })), Sq || (Sq = /* @__PURE__ */ h.createElement("path", {
    d: "M23,22V20H20.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,17,16.1011V14H15v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,11.1011,20H9v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,15,25.8989V28h2V25.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,20.8989,22Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,16,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GGe.propTypes = E);
const QGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mq || (Mq = /* @__PURE__ */ h.createElement("path", {
    d: "M30.0005,15.5005a6.5324,6.5324,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0,6.5321,6.5321,0,0,0-5.2,6.3638,6.4543,6.4543,0,0,0,1.6887,4.35A5.9829,5.9829,0,0,0,8,30H19a5.9764,5.9764,0,0,0,5.6094-8.1016A6.5051,6.5051,0,0,0,30.0005,15.5005ZM19,28H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,19.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,28Zm4.5-8h-.0554a5.9562,5.9562,0,0,0-2.7959-1.7564,7.4952,7.4952,0,0,0-14.2984,0,5.9877,5.9877,0,0,0-1.0315.4073A4.4446,4.4446,0,0,1,4,15.5005a4.5171,4.5171,0,0,1,4.144-4.481l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639a4.4975,4.4975,0,0,1-.3564,8.981Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QGe.propTypes = E);
const KGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dq || (Dq = /* @__PURE__ */ h.createElement("path", {
    d: "M20 17V15a2 2 0 00-2-2H10a2 2 0 00-2 2v2a2 2 0 002 2h8A2 2 0 0020 17zM10 15h8v2H10zM23.42 24.48A2 2 0 0021 23.06l-7.73 2.07a2 2 0 00-1.42 2.44h0l.52 1.93A2 2 0 0014.27 31a3 3 0 00.52-.07l7.73-2.07h0a2 2 0 001.41-2.45zM14.27 29l-.51-1.94L21.48 25 22 26.92zM13.24 6.86L21 8.93h0a2.24 2.24 0 00.51.07 2 2 0 001.94-1.48L24 5.58a2 2 0 00-1.41-2.45L14.79 1.06a2 2 0 00-2.45 1.41h0l-.52 1.93a2 2 0 001.42 2.44zm1-3.86L22 5.07 21.48 7 13.76 4.93zM14 21H16V23H14zM14 9H16V11H14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KGe.propTypes = E);
const YGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lq || (Lq = /* @__PURE__ */ h.createElement("path", {
    d: "M31 16L24 23 22.59 21.59 28.17 16 22.59 10.41 24 9 31 16zM1 16L8 9 9.41 10.41 3.83 16 9.41 21.59 8 23 1 16z"
  })), kq || (kq = /* @__PURE__ */ h.createElement("path", {
    d: "M5.91 15H26.080000000000002V17H5.91z",
    transform: "rotate(-75 15.996 16)"
  })), n);
});
process.env.NODE_ENV !== "production" && (YGe.propTypes = E);
const XGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nq || (Nq = /* @__PURE__ */ h.createElement("path", {
    d: "M17.713 13.471L19.576 6.518 17.645 6 16.08 11.838 17.713 13.471zM24.207 19.965L25.621 21.379 31 16 24 9 22.586 10.414 28.172 16 24.207 19.965zM30 28.586L3.414 2 2 3.414 7.793 9.207 1 16 8 23 9.414 21.586 3.828 16 9.207 10.621 14.884 16.298 12.423 25.482 14.355 26 16.517 17.931 28.586 30 30 28.586z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XGe.propTypes = E);
const JGe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tq || (Tq = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM30 10L24 4 22.586 5.414 27.172 10 22.586 14.586 24 16 30 10z"
  })), Iq || (Iq = /* @__PURE__ */ h.createElement("path", {
    d: "M8.944 9.001H24.974000000000004V11.001H8.944z",
    transform: "rotate(-74.995 16.96 10)"
  })), Oq || (Oq = /* @__PURE__ */ h.createElement("path", {
    d: "M4 10L10 4 11.414 5.414 6.828 10 11.414 14.586 10 16 4 10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JGe.propTypes = E);
const $Ge = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rq || (Rq = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M2 3H10V5H2zM6 9H30V11H6zM6 15H30V17H6zM2 27H10V29H2zM6 21H22V23H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Ge.propTypes = E);
const eQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vq || (Vq = /* @__PURE__ */ h.createElement("circle", {
    cx: "25",
    cy: "20",
    r: "1"
  })), Hq || (Hq = /* @__PURE__ */ h.createElement("path", {
    d: "M19.4141 30H15V25.5857l5.0337-5.0337A4.6069 4.6069 0 0120 20a5 5 0 114.4478 4.9663zM17 28h1.5859l5.2061-5.2063.5395.1238a3.0351 3.0351 0 10-2.249-2.2488l.1236.5393L17 26.4143zM6 8H8V16H6zM2 8H4V16H2zM18 8H20V14H18zM14 16H12a2 2 0 01-2-2V10a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0114 16zm-2-2h2V10H12zM2 18H4V26H2zM14 18H16V22H14zM10 26H8a2 2 0 01-2-2V20a2 2 0 012-2h2a2 2 0 012 2v4A2 2 0 0110 26zM8 24h2V20H8zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM10 6H8A2 2 0 016 4V2H8V4h2V2h2V4A2 2 0 0110 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eQe.propTypes = E);
const tQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bq || (Bq = /* @__PURE__ */ h.createElement("path", {
    d: "M30,13A11,11,0,0,0,19,2H11a9,9,0,0,0-9,9v3a5,5,0,0,0,5,5H8.1A5,5,0,0,0,13,23h1.38l4,7,1.73-1-4-6.89A2,2,0,0,0,14.38,21H13a3,3,0,0,1,0-6h1V13H13a5,5,0,0,0-4.9,4H7a3,3,0,0,1-3-3V12H6A3,3,0,0,0,9,9V8H7V9a1,1,0,0,1-1,1H4.08A7,7,0,0,1,11,4h6V6a1,1,0,0,1-1,1H14V9h2a3,3,0,0,0,3-3V4a9,9,0,0,1,8.05,5H26a3,3,0,0,0-3,3v1h2V12a1,1,0,0,1,1-1h1.77A8.76,8.76,0,0,1,28,13v1a5,5,0,0,1-5,5H20v2h3a7,7,0,0,0,3-.68V21a3,3,0,0,1-3,3H22v2h1a5,5,0,0,0,5-5V18.89A7,7,0,0,0,30,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tQe.propTypes = E);
const nQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pq || (Pq = /* @__PURE__ */ h.createElement("path", {
    d: "M6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM24 11v1h2V11a7 7 0 00-7-7H16V6h3A5 5 0 0124 11zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nQe.propTypes = E);
const iQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fq || (Fq = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H28V7H13V5H28a2.0023,2.0023,0,0,1,2,2Z"
  })), zq || (zq = /* @__PURE__ */ h.createElement("path", {
    d: "M25,20H23V12H8V10H23a2.0023,2.0023,0,0,1,2,2Z"
  })), Wq || (Wq = /* @__PURE__ */ h.createElement("path", {
    d: "M18,27H4a2.0023,2.0023,0,0,1-2-2V17a2.0023,2.0023,0,0,1,2-2H18a2.0023,2.0023,0,0,1,2,2v8A2.0023,2.0023,0,0,1,18,27ZM4,17v8H18.0012L18,17Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iQe.propTypes = E);
const rQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jq || (jq = /* @__PURE__ */ h.createElement("path", {
    d: "M14 25H28V27H14zM7.17 26L4.59 28.58 6 30 10 26 6 22 4.58 23.41 7.17 26zM14 15H28V17H14zM7.17 16L4.59 18.58 6 20 10 16 6 12 4.58 13.41 7.17 16zM14 5H28V7H14zM7.17 6L4.59 8.58 6 10 10 6 6 2 4.58 3.41 7.17 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rQe.propTypes = E);
const sQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zq || (Zq = /* @__PURE__ */ h.createElement("circle", {
    cx: "10",
    cy: "12",
    r: "2"
  })), Uq || (Uq = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), qq || (qq = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "12",
    r: "2"
  })), Gq || (Gq = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "18",
    r: "2"
  })), Qq || (Qq = /* @__PURE__ */ h.createElement("circle", {
    cx: "19",
    cy: "23",
    r: "2"
  })), Kq || (Kq = /* @__PURE__ */ h.createElement("path", {
    d: "M16.54,2A14,14,0,0,0,2,16a4.82,4.82,0,0,0,6.09,4.65l1.12-.31A3,3,0,0,1,13,23.24V27a3,3,0,0,0,3,3A14,14,0,0,0,30,15.46,14.05,14.05,0,0,0,16.54,2Zm8.11,22.31A11.93,11.93,0,0,1,16,28a1,1,0,0,1-1-1V23.24a5,5,0,0,0-5-5,5.07,5.07,0,0,0-1.33.18l-1.12.31A2.82,2.82,0,0,1,4,16,12,12,0,0,1,16.47,4,12.18,12.18,0,0,1,28,15.53,11.89,11.89,0,0,1,24.65,24.32Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sQe.propTypes = E);
const oQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yq || (Yq = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM6,26,26,6V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oQe.propTypes = E);
const aQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xq || (Xq = /* @__PURE__ */ h.createElement("path", {
    d: "M24 4H26V28H24zM18 6V26H14V6h4m0-2H14a2 2 0 00-2 2V26a2 2 0 002 2h4a2 2 0 002-2V6a2 2 0 00-2-2zM6 4H8V28H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aQe.propTypes = E);
const lQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jq || (Jq = /* @__PURE__ */ h.createElement("path", {
    d: "M30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), $q || ($q = /* @__PURE__ */ h.createElement("path", {
    d: "M24 14V28H18V6H16V28a2.0023 2.0023 0 002 2h6a2.0023 2.0023 0 002-2V14zM10 30H4a2.0021 2.0021 0 01-2-2V8A2.0021 2.0021 0 014 6h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 8V28h6V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lQe.propTypes = E);
const cQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eG || (eG = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H22a2.0021 2.0021 0 01-2-2V10a2.0021 2.0021 0 012-2h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM22 10V28h6V10zM16 9L21.586 3.414 20.172 2 16 6.172 11.828 2 10.414 3.414 16 9zM10 30H4a2.0021 2.0021 0 01-2-2V10A2.0021 2.0021 0 014 8h6a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0110 30zM4 10V28h6V10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cQe.propTypes = E);
const hQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tG || (tG = /* @__PURE__ */ h.createElement("path", {
    d: "M30,10V2H22V5H17a2.0023,2.0023,0,0,0-2,2v8H10V12H2v8h8V17h5v8a2.0023,2.0023,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3h8V12H22v3H17V7h5v3ZM8,18H4V14H8Zm16,6h4v4H24Zm0-10h4v4H24ZM24,4h4V8H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hQe.propTypes = E);
const dQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nG || (nG = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H21.91A5.9925,5.9925,0,0,0,10.09,15H2v2h8.09A5.9925,5.9925,0,0,0,21.91,17H30ZM16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dQe.propTypes = E);
const uQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iG || (iG = /* @__PURE__ */ h.createElement("path", {
    d: "M28 17H18a2.0025 2.0025 0 00-2 2v6a2.0025 2.0025 0 002 2h4V25H18V19H28v6H25.4648l-2.5937 3.8906L24.5352 30l2-3H28a2.0025 2.0025 0 002-2V19A2.0025 2.0025 0 0028 17zM8.6667 24.1086l.8614-.8615a.8334.8334 0 01.8988-.1844l1.0493.42A.8334.8334 0 0112 24.2561v1.9082a.8334.8334 0 01-.8786.8341c-7.3546-.4578-8.84-6.6863-9.1158-9.0723A.8316.8316 0 012.8343 17H4.7085a.8335.8335 0 01.7737.5238l.42 1.0493a.8332.8332 0 01-.1845.8988l-.8614.8614A4.5267 4.5267 0 008.6667 24.1086zM21 9H28V11H21zM21 5H30V7H21zM17 6L14 8.2V6a2.0024 2.0024 0 00-2-2H4A2.0024 2.0024 0 002 6v6a2.0024 2.0024 0 002 2h8a2.0024 2.0024 0 002-2V9.8L17 12zM4 12V6h8v6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uQe.propTypes = E);
const fQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rG || (rG = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H18V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V24a2,2,0,0,0,2,2H14v2a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,15h6.17L7.59,17.59,9,19l5-5L9,9,7.59,10.41,10.17,13H4V4H16V24H4ZM16,28V26a2,2,0,0,0,2-2V8H28v9H21.83l2.58-2.59L23,13l-5,5,5,5,1.41-1.41L21.83,19H28v9Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fQe.propTypes = E);
const pQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sG || (sG = /* @__PURE__ */ h.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), oG || (oG = /* @__PURE__ */ h.createElement("path", {
    d: "M23,10.41,21.59,9l-4.3,4.3a3,3,0,0,0-4,4L9,21.59,10.41,23l4.3-4.3a3,3,0,0,0,4-4ZM17,16a1,1,0,1,1-1-1A1,1,0,0,1,17,16Z"
  })), aG || (aG = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "7.5",
    r: "1.5"
  })), n);
});
process.env.NODE_ENV !== "production" && (pQe.propTypes = E);
const gQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lG || (lG = /* @__PURE__ */ h.createElement("path", {
    d: "M25.82,10H30V8H25.82a3,3,0,0,0-5.64,0H13V5H5V8H2v2H5v3h8V10h7.18A3,3,0,0,0,22,11.82v7.32A4,4,0,0,0,19.14,22H2v2H19.14a4,4,0,0,0,7.72,0H30V22H26.86A4,4,0,0,0,24,19.14V11.82A3,3,0,0,0,25.82,10ZM11,11H7V7h4ZM25,23a2,2,0,1,1-2-2A2,2,0,0,1,25,23Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gQe.propTypes = E);
const mQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cG || (cG = /* @__PURE__ */ h.createElement("path", {
    d: "M20.8851,19.4711a5.9609,5.9609,0,0,0,0-6.9422L23,10.4141l1.293,1.2929a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414l-4-4a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414L21.5859,9l-2.1148,2.1149a5.9609,5.9609,0,0,0-6.9422,0L10,8.5859V2H2v8H8.5859l2.529,2.5289a5.9609,5.9609,0,0,0,0,6.9422L9,21.5859,7.707,20.293a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l4,4a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414L10.4141,23l2.1148-2.1149a5.9609,5.9609,0,0,0,6.9422,0L22,23.4141V30h8V22H23.4141ZM25,4.4141,27.5859,7,25,9.5859,22.4141,7ZM7,27.5859,4.4141,25,7,22.4141,9.5859,25ZM8,8H4V4H8Zm4,8a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Zm12,8h4v4H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mQe.propTypes = E);
const AQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hG || (hG = /* @__PURE__ */ h.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), dG || (dG = /* @__PURE__ */ h.createElement("path", {
    d: "M29.3906,14.5269,17.4731,2.6094a2.0852,2.0852,0,0,0-2.9462,0L2.6094,14.5269a2.0852,2.0852,0,0,0,0,2.9462L14.5269,29.3906a2.0852,2.0852,0,0,0,2.9462,0L29.3906,17.4731a2.0852,2.0852,0,0,0,0-2.9462ZM16,28.0356,3.9646,16,16,3.9644,28.0356,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AQe.propTypes = E);
const wQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uG || (uG = /* @__PURE__ */ h.createElement("path", {
    d: "M10.343 10.343H21.657V21.657H10.343z",
    transform: "rotate(-45 16 16)"
  })), fG || (fG = /* @__PURE__ */ h.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12.0136,12.0136,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wQe.propTypes = E);
const x7 = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pG || (pG = /* @__PURE__ */ h.createElement("path", {
    d: "M23,16a7,7,0,0,0-4.18,1.39L14.6,13.17A6.86,6.86,0,0,0,16,9a7,7,0,1,0-2.81,5.59l4.21,4.22A7,7,0,1,0,23,16ZM4,9a5,5,0,1,1,5,5A5,5,0,0,1,4,9Z",
    transform: "translate(0 .01)"
  })), n);
});
process.env.NODE_ENV !== "production" && (x7.propTypes = E);
const vQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gG || (gG = /* @__PURE__ */ h.createElement("path", {
    d: "M28,7H13.8281l3.586-3.5859L16,2,10,8l6,6,1.4141-1.4141L13.8281,9H28V20H11.8989A5.0145,5.0145,0,0,0,8,16.1011V2H6V16.1011a5,5,0,0,0,0,9.7978V30H8V25.8989A5.0145,5.0145,0,0,0,11.8989,22H28a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,28,7ZM7,24a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vQe.propTypes = E);
const bQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mG || (mG = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), AG || (AG = /* @__PURE__ */ h.createElement("path", {
    d: "M23,16c-1.5696,0-3.0124,.5159-4.1813,1.3919l-4.2173-4.2174c.876-1.1689,1.3986-2.6048,1.3986-4.1745,0-3.8599-3.1406-7-7-7S2,5.1401,2,9s3.1406,7,7,7c1.5696,0,3.0184-.5355,4.1873-1.4114l4.2173,4.2174c-.8759,1.1689-1.4046,2.6243-1.4046,4.194,0,3.8599,3.1406,7,7,7s7-3.1401,7-7-3.1406-7-7-7ZM4,9c0-2.7568,2.2432-5,5-5s5,2.2432,5,5-2.2432,5-5,5-5-2.2432-5-5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bQe.propTypes = E);
const yQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wG || (wG = /* @__PURE__ */ h.createElement("path", {
    d: "M24,10l-1.4141,1.4141L26.1719,15H11.8989A5.0145,5.0145,0,0,0,8,11.1011V2H6v9.1011a5,5,0,0,0,0,9.7978V30H8V20.8989A5.0145,5.0145,0,0,0,11.8989,17h14.273l-3.586,3.5859L24,22l6-6ZM7,19a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,7,19Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yQe.propTypes = E);
const CQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vG || (vG = /* @__PURE__ */ h.createElement("path", {
    d: "M28 2H30V30H28zM20 10l-1.4141 1.4141L22.1719 15H11.8989a5 5 0 100 2h10.273l-3.586 3.5859L20 22l6-6zM7 19a3 3 0 113-3A3.0033 3.0033 0 017 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CQe.propTypes = E);
const EQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bG || (bG = /* @__PURE__ */ h.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 14L21.83 14 24.41 16.59 23 18 18 13 23 8 24.41 9.41 21.83 12 30 12 30 14z"
  })), yG || (yG = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EQe.propTypes = E);
const _Qe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CG || (CG = /* @__PURE__ */ h.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM18 14L26.17 14 23.59 16.59 25 18 30 13 25 8 23.59 9.41 26.17 12 18 12 18 14z"
  })), EG || (EG = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20v8H22V20H20v8H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Qe.propTypes = E);
const xQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _G || (_G = /* @__PURE__ */ h.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14zM30 22L21.83 22 24.41 24.59 23 26 18 21 23 16 24.41 17.41 21.83 20 30 20 30 22zM19 12L27.17 12 24.59 14.59 26 16 31 11 26 6 24.59 7.41 27.17 10 19 10 19 12z"
  })), xG || (xG = /* @__PURE__ */ h.createElement("path", {
    d: "M28,26v2H4V4H20V6h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xQe.propTypes = E);
const SQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SG || (SG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m17,26V6c0-1.1046-.8954-2-2-2H4v2h11v20c0,1.1046.8954,2,2,2h11v-2h-11Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SQe.propTypes = E);
const MQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MG || (MG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m22,16l-1.4141,1.4141,4.5859,4.5859h-10.1719V5c0-1.1046-.8954-2-2-2H3v2h10v17c0,1.1046.8954,2,2,2h10.1719l-4.5859,4.5859,1.4141,1.4141,7-7-7-7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MQe.propTypes = E);
const DQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DG || (DG = /* @__PURE__ */ h.createElement("path", {
    d: "M15 12H17V30H15zM11.33 18.22a7 7 0 010-10.44l1.34 1.49a5 5 0 000 7.46zM20.67 18.22l-1.34-1.49a5 5 0 000-7.46l1.34-1.49a7 7 0 010 10.44z"
  })), LG || (LG = /* @__PURE__ */ h.createElement("path", {
    d: "M8.4 21.8a11 11 0 010-17.6L9.6 5.8a9 9 0 000 14.4zM23.6 21.8l-1.2-1.6a9 9 0 000-14.4l1.2-1.6a11 11 0 010 17.6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DQe.propTypes = E);
const LQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kG || (kG = /* @__PURE__ */ h.createElement("path", {
    d: "M26,13a8.9089,8.9089,0,0,1-2.5249,6.2339l1.4133,1.4131A10.9795,10.9795,0,0,0,23.6006,4.2l-1.2012,1.6A8.932,8.932,0,0,1,26,13Z"
  })), NG || (NG = /* @__PURE__ */ h.createElement("path", {
    d: "M21 13a5.0022 5.0022 0 01-.9023 2.8564l1.4277 1.4278a6.9831 6.9831 0 00-.8584-9.5015l-1.334 1.49A5.0077 5.0077 0 0121 13zM30 28.5859L3.4143 2 2 3.4141l3.71 3.71A10.9824 10.9824 0 008.3994 21.8008l1.2012-1.6A8.9678 8.9678 0 017.1714 8.5854l2.1963 2.1963a6.9664 6.9664 0 001.9648 7.4351l1.334-1.49A5.0072 5.0072 0 0111 13a4.8854 4.8854 0 01.0393-.5464L15 16.4141V30h2V18.4141L28.5857 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LQe.propTypes = E);
const kQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TG || (TG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M27 13V5s-4 0-4 0v-2h4c1.1028 0 2 .8975 2 2v8c0 1.5234.8799 2 2 2v2c-1.1201 0-2 .4502-2 2v8c0 1.1025-.8972 2-2 2h-4v-2h4s0-8 0-8c0-1.6841.8799-2.5645 2-2.8584v-.2676c-1.1201-.2939-2-1.1899-2-2.874zM12 12H20V20H12zM5 13V5h4v-2h-4c-1.1028 0-2 .8975-2 2v8c0 1.5234-.8799 2-2 2v2c1.1201 0 2 .4502 2 2v8c0 1.1025.8972 2 2 2h4v-2h-4v-8c0-1.6841-.8799-2.5645-2-2.8584v-.2676c1.1201-.2939 2-1.1899 2-2.874z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kQe.propTypes = E);
const NQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, IG || (IG = /* @__PURE__ */ h.createElement("path", {
    d: "M29.34 16.06a1.0007 1.0007 0 00-1.1084.3L24.46 20.8857l-5.4355-.9882-3.602-8.9512A3.014 3.014 0 0012.6138 9h-4.06A3.0018 3.0018 0 007.01 9.4277L2 12.4336v6.4009l5 .9092V30H9V20.1074l3.5652.648L14 24.2V30h2V23.8l-1.0911-2.6182L22.99 22.6509 18.2319 28.36A1 1 0 0019 30H29a1 1 0 001-1V17A1 1 0 0029.34 16.06zM4 17.1655V13.5664l3-1.8v5.9448zm5 .9092V11h3.6138a1.0141 1.0141 0 01.9453.6709l3.14 7.8037zM28 28H21.1353L28 19.7617zM12.5 8A3.5 3.5 0 1116 4.5 3.5042 3.5042 0 0112.5 8zm0-5A1.5 1.5 0 1014 4.5 1.5017 1.5017 0 0012.5 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NQe.propTypes = E);
const TQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OG || (OG = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "23",
    r: "1",
    strokeWidth: "0"
  })), RG || (RG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m25.7903,18.8535l-8.9897-6.2378c-.5029-.3809-1.1223-.6157-1.8005-.6157-1.6543,0-3,1.3457-3,3,0,.6553.2173,1.2573.5752,1.7515l6.3408,9.1157c.9055,1.2861,2.395,2.1328,4.084,2.1328,2.7571,0,5-2.2432,5-5,0-1.7246-.8777-3.2476-2.2097-4.1465Zm-7.5203,2.5986l-2.4829-3.5703c1.0181-.2788,1.8145-1.0752,2.0942-2.0928l3.5698,2.4814c-1.5061.4951-2.6863,1.6758-3.1812,3.1816Zm-3.27-7.4521c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm8,12c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3Z"
  })), VG || (VG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,28H6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v10h-2V6H6v20h10v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TQe.propTypes = E);
const IQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HG || (HG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M10 10H22V12H10zM10 15H22V17H10zM10 20H22V22H10z"
  })), BG || (BG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m26,28H6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v20c0,1.1028-.8972,2-2,2ZM6,6v20h20V6H6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IQe.propTypes = E);
const OQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, PG || (PG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m30,24v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5,1.5c-.5-.3-1.1-.6-1.8-.7v-2.1h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4,1.4,1.5,1.5c-.3.5-.6,1.1-.7,1.8h-2.1v2h2.1c.1.6.4,1.2.7,1.8l-1.5,1.5,1.4,1.4,1.5-1.5c.5.3,1.1.6,1.8.7v2.1h2v-2.1c.6-.1,1.2-.4,1.8-.7l1.5,1.5,1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8h2.1Zm-7,2c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3Z"
  })), FG || (FG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m14,28H6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v8h-2V6H6v20h8v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OQe.propTypes = E);
const RQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zG || (zG = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "23",
    r: "2",
    strokeWidth: "0"
  })), WG || (WG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m29.7769,22.4785c-1.2631-3.2173-4.3221-5.3723-7.7769-5.4785-3.4548.1062-6.5138,2.2612-7.7769,5.4785l-.2231.5215.2231.5215c1.2631,3.2173,4.3221,5.3723,7.7769,5.4785,3.4548-.1062,6.5138-2.2612,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2091,0-4-1.7909-4-4s1.7909-4,4-4,4,1.7909,4,4c-.0025,2.2081-1.7919,3.9975-4,4Z"
  })), jG || (jG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m12,28h-6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v10h-2V6H6v20h6v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RQe.propTypes = E);
const VQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZG || (ZG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M30 23h-10c-1.1028 0-2-.8972-2-2v-10c0-1.1028.8972-2 2-2h10c1.1028 0 2 .8972 2 2v10c0 1.1028-.8972 2-2 2zm-10-12v10h10v-10h-10zM5 11L0 16 5 21 6.419 19.591 3.847 17 14 17 14 15 3.794 15 6.419 12.409 5 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VQe.propTypes = E);
const HQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UG || (UG = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M30 23h-10c-1.1028 0-2-.8972-2-2v-10c0-1.1028.8972-2 2-2h10c1.1028 0 2 .8972 2 2v10c0 1.1028-.8972 2-2 2zm-10-12v10h10v-10h-10zM9 11L14 16 9 21 7.581 19.591 10.153 17 0 17 0 15 10.206 15 7.581 12.409 9 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HQe.propTypes = E);
var qG, GG, QG, KG, YG, XG, JG, $G, eQ, tQ, nQ, iQ, rQ, sQ, oQ, aQ, lQ, cQ, hQ, dQ, uQ, fQ, pQ, gQ, mQ, AQ, wQ, vQ, bQ, yQ, CQ, EQ, _Q, xQ, SQ, MQ, DQ, LQ, kQ, NQ, TQ, IQ, OQ, RQ, VQ, HQ, BQ, PQ, FQ, zQ, WQ, jQ, ZQ, UQ, qQ, GQ, QQ, KQ, YQ, XQ, JQ, $Q, eK, tK, nK, iK, rK, sK, oK, aK, lK, cK, hK, dK, uK, fK, pK, gK, mK, AK, wK, vK, bK, yK, CK, EK, _K, xK, SK, MK, DK, LK, kK, NK, TK, IK, OK, RK, VK, HK, BK, PK, FK, zK, WK, jK, ZK, UK, qK, GK, QK, KK, YK, XK, JK, $K, eY, tY, nY, iY, rY, sY, oY, aY, lY, cY, hY, dY, uY, fY, pY, gY, mY, AY, wY, vY, bY, yY, CY, EY, _Y, xY, SY, MY, DY, LY, kY, NY, TY, IY, OY, RY, VY, HY, BY, PY, FY, zY, WY, jY, ZY, UY, qY, GY, QY, KY, YY, XY, JY, $Y, eX, tX, nX, iX, rX, sX, oX, aX, lX, cX, hX, dX, uX, fX, pX, gX, mX, AX, wX, vX, bX, yX, CX, EX, _X, xX, SX, MX, DX, LX, kX, NX, TX, IX, OX, RX, VX, HX, BX, PX, FX, zX, WX, jX, ZX, UX, qX, GX, QX, KX, YX, XX, JX, $X, eJ, tJ, nJ, iJ, rJ, sJ, oJ;
const BQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qG || (qG = /* @__PURE__ */ h.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), GG || (GG = /* @__PURE__ */ h.createElement("path", {
    d: "M15,1h-5c-.5522,0-1,.4478-1,1v7.3706c-1.0674,.6055-3,2.1777-3,5.6294v14c0,.5527,.4478,1,1,1h5v-2h-4V15c0-3.7536,3-4.2793,3-4.2793V3h3v7h2V2c0-.5522-.4478-1-1-1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BQe.propTypes = E);
const PQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, QG || (QG = /* @__PURE__ */ h.createElement("path", {
    d: "M23,10.4141l3-3-1.4141-1.4141-3.293,3.293c-.1875,.1875-.293,.4419-.293,.707v4h-7.0742l1.1436,16h8.8613l1.1436-16h-2.0742v-3.5859Zm-.9307,17.5859h-5.1387l-.8564-12h6.8516l-.8564,12Z"
  })), KG || (KG = /* @__PURE__ */ h.createElement("path", {
    d: "M16,7.0513v-3.0513c0-.5522-.4478-1-1-1h-6c-.5522,0-1,.4478-1,1v3.0513c-1.2771,1.1411-2,2.7358-2,4.4487V29c0,.5522,.4478,1,1,1h5v-2h-4V11.5c0-2.356,2-3.48,2-3.48v-3.02h4v3.02s2,1.124,2,3.48v.5h2v-.5c0-1.7129-.7229-3.3076-2-4.4487Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PQe.propTypes = E);
const FQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YG || (YG = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "16",
    r: "2"
  })), XG || (XG = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H27.91A6.0048,6.0048,0,0,0,22,10l-.022.001A9.9833,9.9833,0,0,0,4.0508,15H2v2H4.0508A9.9833,9.9833,0,0,0,21.978,21.999L22,22a6.0048,6.0048,0,0,0,5.91-5H30ZM14,8a7.9769,7.9769,0,0,1,5.7383,2.4463A6.0152,6.0152,0,0,0,16.0891,15H6.0693A8.0073,8.0073,0,0,1,14,8Zm0,16a8.0073,8.0073,0,0,1-7.9307-7h10.02a6.0152,6.0152,0,0,0,3.6492,4.5537A7.9769,7.9769,0,0,1,14,24Zm8-4a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FQe.propTypes = E);
const zQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JG || (JG = /* @__PURE__ */ h.createElement("path", {
    d: "M7 12a5 5 0 115-5H10a3 3 0 10-3 3zM25 12V10a3 3 0 10-3-3H20a5 5 0 115 5zM7 30A5 5 0 017 20v2a3 3 0 103 3h2A5.0055 5.0055 0 017 30zM25 30a5.0055 5.0055 0 01-5-5h2a3 3 0 103-3V20a5 5 0 010 10z"
  })), $G || ($G = /* @__PURE__ */ h.createElement("path", {
    d: "M20,18.5859V13.4141L25.707,7.707a1,1,0,1,0-1.414-1.414l-4.4995,4.5a3.9729,3.9729,0,0,0-7.587,0L7.707,6.293a.9994.9994,0,0,0-1.414,0h0a.9994.9994,0,0,0,0,1.414L12,13.4141v5.1718L6.293,24.293a.9994.9994,0,0,0,0,1.414h0a.9994.9994,0,0,0,1.414,0l4.5-4.5a3.9729,3.9729,0,0,0,7.587,0l4.4995,4.5a1,1,0,0,0,1.414-1.414ZM18,20a2,2,0,0,1-4,0V12a2,2,0,0,1,4,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zQe.propTypes = E);
const WQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eQ || (eQ = /* @__PURE__ */ h.createElement("path", {
    d: "M20,30H12V22h8Zm-6-2h4V24H14Z"
  })), tQ || (tQ = /* @__PURE__ */ h.createElement("path", {
    d: "M32 11L22 11 22 13 26 13 26 16 6 16 6 13 10 13 10 11 0 11 0 13 4 13 4 18 9.132 18 6 22.697 6 27 8 27 8 23.303 11.535 18 20.465 18 24 23.303 24 27 26 27 26 22.697 22.868 18 28 18 28 13 32 13 32 11zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), nQ || (nQ = /* @__PURE__ */ h.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WQe.propTypes = E);
const jQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iQ || (iQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), rQ || (rQ = /* @__PURE__ */ h.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jQe.propTypes = E);
const ZQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sQ || (sQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "1"
  })), oQ || (oQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 19V15H26v2H6V15H4v4h7v4.4116L7 25.6367V30H9V26.8125L12.26 25h7.481L23 26.8125V30h2V25.6367l-4-2.2251V19zm-9 4H13V19h6zM0 11H10V13H0zM22 11H32V13H22zM16 6a5.9817 5.9817 0 00-4.2407 1.7593l1.4136 1.4136a3.9936 3.9936 0 015.6542 0l1.4136-1.4136A5.9814 5.9814 0 0016 6z"
  })), aQ || (aQ = /* @__PURE__ */ h.createElement("path", {
    d: "M8.9324,4.9321l1.4133,1.4136a7.9877,7.9877,0,0,1,11.3086,0l1.4136-1.4136a9.9844,9.9844,0,0,0-14.1355,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZQe.propTypes = E);
const UQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lQ || (lQ = /* @__PURE__ */ h.createElement("path", {
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z"
  })), cQ || (cQ = /* @__PURE__ */ h.createElement("path", {
    d: "M27 29H11a2 2 0 01-2-2V18a2 2 0 012-2h3.2793l.5441-1.6324A2 2 0 0116.7208 13h4.5584a2 2 0 011.8974 1.3676L23.7207 16H27a2 2 0 012 2v9A2 2 0 0127 29zM11 27H27V18H22.2792l-1-3H16.7207l-1 3H11zM27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UQe.propTypes = E);
const qQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hQ || (hQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "19",
    cy: "22",
    r: "2"
  })), dQ || (dQ = /* @__PURE__ */ h.createElement("path", {
    d: "M27,16H23.7207l-.5439-1.6328A1.9983,1.9983,0,0,0,21.2793,13H16.7207a1.9981,1.9981,0,0,0-1.8975,1.3677L14.2793,16H11a2.0023,2.0023,0,0,0-2,2v9a2.0023,2.0023,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,27,16ZM19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Z"
  })), uQ || (uQ = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M19,26a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,19,26Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,19,20Z",
    "data-icon-path": "inner-path"
  })), fQ || (fQ = /* @__PURE__ */ h.createElement("path", {
    d: "M27 11H29V13H27zM27 7H29V9H27zM27 3H29V5H27zM23 3H25V5H23zM19 3H21V5H19zM15 3H17V5H15zM11 3H13V5H11zM7 3H9V5H7zM3 3H5V5H3zM3 7H5V9H3zM3 11H5V13H3zM3 15H5V17H3zM3 19H5V21H3zM3 23H5V25H3zM3 27H5V29H3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qQe.propTypes = E);
const GQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pQ || (pQ = /* @__PURE__ */ h.createElement("path", {
    d: "M27,18h3V15a4.0045,4.0045,0,0,0-4-4H25V9.5A3.5042,3.5042,0,0,0,21.5,6a3.4556,3.4556,0,0,0-1.5.3511V5.41a3.41,3.41,0,0,0-6.5449-1.3433L11.3408,9H9a5.0059,5.0059,0,0,0-5,5v4H8a5.0059,5.0059,0,0,0,5-5V10.2051l2.293-5.35A1.41,1.41,0,0,1,18,5.41V22H14.6123L11,25.2939,7.3877,22H2v2H6.6123L11,28l4.3877-4H30V22H20V9.5a1.5,1.5,0,0,1,3,0V14A4.0045,4.0045,0,0,0,27,18Zm-2-5h1a2.0023,2.0023,0,0,1,2,2v1H27a2.0023,2.0023,0,0,1-2-2ZM11,13a3.0033,3.0033,0,0,1-3,3H6V14a3.0033,3.0033,0,0,1,3-3h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GQe.propTypes = E);
const QQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gQ || (gQ = /* @__PURE__ */ h.createElement("path", {
    d: "M30 15V11a2 2 0 00-2-2H22V23h2V17h1.48l2.34 6H30l-2.33-6H28A2 2 0 0030 15zm-6-4h4v4H24zM18 9L16 22 14 9 12 9 14.52 23 17.48 23 20 9 18 9zM6 23H2V9H6a4 4 0 014 4v6A4 4 0 016 23zM4 21H6a2 2 0 002-2V13a2 2 0 00-2-2H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QQe.propTypes = E);
const KQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mQ || (mQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm5,3.1055a12.0136,12.0136,0,0,1,2.9158,1.8994L23.5034,8H21ZM13.3784,27.7026A11.9761,11.9761,0,0,1,8.1157,6.9761L9.4648,9h3.3423l-1.5,4H7.2793L5.8967,17.1475,8.4648,21h5l1.4319,2.1475ZM16,28c-.2034,0-.4016-.02-.6025-.03l1.3967-4.19a1.9876,1.9876,0,0,0-.2334-1.7412l-1.4319-2.1475A1.9962,1.9962,0,0,0,13.4648,19h-3.93L8.1033,16.8525,8.7207,15H11v2h2V14.1812l2.9363-7.83-1.8726-.7022L13.5571,7H10.5352L9.728,5.7891A11.7941,11.7941,0,0,1,19,4.395V8a2.0025,2.0025,0,0,0,2,2h2.5857A1.9865,1.9865,0,0,0,25,9.4141l.1406-.1407.2818-.68A11.9813,11.9813,0,0,1,27.3,12H22.5986a1.9927,1.9927,0,0,0-1.9719,1.665L20.03,17.1064a1.99,1.99,0,0,0,.991,2.086l2.1647,1.4638,1.4585,3.646A11.9577,11.9577,0,0,1,16,28Zm8.8145-8.6563L22.1,17.5088l-.1-.06L22.5986,14h5.2207a11.743,11.743,0,0,1-1.7441,8.4951Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KQe.propTypes = E);
const YQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AQ || (AQ = /* @__PURE__ */ h.createElement("path", {
    d: "M30,16a14.0313,14.0313,0,1,0-7.14,12.1914l.1165.0254.0249-.1113A13.9983,13.9983,0,0,0,30,16ZM4,16a11.9369,11.9369,0,0,1,.395-3H8.6382L13.63,17.16l-1.9092,2.5459a2.0088,2.0088,0,0,0,.1855,2.6142L14,24.4141v3.4052A12.0093,12.0093,0,0,1,4,16Zm9.32,4.9062L16.37,16.84,9.3618,11H5.1055A11.9619,11.9619,0,0,1,22.8838,6.1865L22.2793,8H16.5859L13.543,11.043l9.3535,8.3134L21.248,26.7749A11.9034,11.9034,0,0,1,16,28V23.5859Zm10.315,4.3443,1.2133-5.46a2.0007,2.0007,0,0,0-.6235-1.9277L16.457,10.957,17.4141,10h4.8652a1.9981,1.9981,0,0,0,1.8975-1.3677l.3532-1.06a11.9777,11.9777,0,0,1-.8947,17.6782Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YQe.propTypes = E);
const XQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wQ || (wQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16a11.915,11.915,0,0,1,.7-4H10l5,4-2.8,3.6929A1,1,0,0,0,12.293,21L15,24v3.9492A12.01,12.01,0,0,1,4,16ZM21.4348,26.6846l2.5457-7.6992A1,1,0,0,0,23.614,18L15,11l2-2h5.2793a1,1,0,0,0,.9487-.6836L23.7234,6.83a11.9742,11.9742,0,0,1-2.2886,19.855Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XQe.propTypes = E);
const JQe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vQ || (vQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.96,11.96,0,0,1,8,7.0811V9a2,2,0,0,0,2,2h3.3818a2,2,0,0,0,1.7893-1.106L15.6182,9H18v4H13.2354a2,2,0,0,0-.8936.2109L9.1055,14.8291A2,2,0,0,0,8,16.6177v3.7055A2,2,0,0,0,9.2573,22.18l3.8487,1.54.6779,4.0664A12.0135,12.0135,0,0,1,4,16ZM15.8457,27.9922,14.894,22.28,10,20.3232v-3.705L13.2358,15H20V7H14.3818l-1,2H10V5.6235A11.9578,11.9578,0,0,1,27.3,12H22v4l.9224,3.8135L21,22.6973v4.1972A11.9083,11.9083,0,0,1,16,28C15.948,28,15.8977,27.9927,15.8457,27.9922ZM23,25.7266V23.3027l1.5859-2.3789a2.0027,2.0027,0,0,0,.2769-1.5957L24,15.877V14h3.8193A11.8409,11.8409,0,0,1,23,25.7266Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JQe.propTypes = E);
const $Qe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bQ || (bQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4,16A11.9814,11.9814,0,0,1,9,6.2734V9a1,1,0,0,0,1,1h3.3821a1,1,0,0,0,.8943-.5527L15,8h4v6H13.2361a1.0006,1.0006,0,0,0-.4473.1055L9.5527,15.7236A1,1,0,0,0,9,16.6182v3.7046a1,1,0,0,0,.6287.9287L14,23l.8235,4.94A12.0152,12.0152,0,0,1,4,16ZM22,26.376V23l1.7546-2.6318a1.0012,1.0012,0,0,0,.1382-.7974L23,16V13h4.605A11.901,11.901,0,0,1,22,26.376Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Qe.propTypes = E);
const eKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yQ || (yQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.02,16.394l1.3384.4458L7,19.3027v1.2831a1,1,0,0,0,.2929.7071L10,24v2.3765A11.9941,11.9941,0,0,1,4.02,16.394ZM16,28a11.9682,11.9682,0,0,1-2.5718-.2847L14,26l1.8046-4.5116a1,1,0,0,0-.0964-.9261l-1.4113-2.117A1,1,0,0,0,13.4648,18h-4.93L7.2866,16.1274,9.4141,14H11v2h2V13.2656l3.8682-6.7695-1.7364-.9922L14.2769,7H11.5352l-1.086-1.6289A11.861,11.861,0,0,1,20,4.7V8a1,1,0,0,0,1,1h1.4648a1,1,0,0,0,.8321-.4453l.8769-1.3154A12.0331,12.0331,0,0,1,26.8945,11H22.82a1,1,0,0,0-.9806.8039l-.7221,4.4708a1,1,0,0,0,.54,1.0539L25,19l.6851,4.0557A11.9793,11.9793,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eKe.propTypes = E);
const tKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CQ || (CQ = /* @__PURE__ */ h.createElement("path", {
    d: "M14 24H17V26H14zM17 22H19V24H17zM17 18H19V20H17z"
  })), EQ || (EQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm-.603,2.03,2.5073,5.0156L16.3228,13H10.271l-1.41,4.3872,2.8521,2.8521L10.7056,21.751,6.2856,19H4.395A11.9363,11.9363,0,0,1,15.397,4.03ZM5.1055,21h.6089l3.9345,2.4487A1.9912,1.9912,0,0,0,12.37,22.86l1.0078-1.5118a2.005,2.005,0,0,0-.25-2.5234l-1.9887-1.9888L11.729,15h4.5938A1.9906,1.9906,0,0,0,18.18,13.7427L19.7612,9.79a2.0019,2.0019,0,0,0-.0674-1.6382L17.6843,4.1323A11.9592,11.9592,0,0,1,26.8945,21H23a2.0023,2.0023,0,0,0-2,2v3.8945A11.9477,11.9477,0,0,1,5.1055,21ZM23,25.7266V23h2.7268A12.0762,12.0762,0,0,1,23,25.7266Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tKe.propTypes = E);
const nKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _Q || (_Q = /* @__PURE__ */ h.createElement("path", {
    d: "M17 22H19V24H17zM17 18H19V20H17zM14 24H17V26H14z"
  })), xQ || (xQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM4.7,20H6l4.1772,2.6a1,1,0,0,0,1.36-.2939l1.0078-1.5118a1,1,0,0,0-.125-1.2617L10,17.1118,11,14h5.323a1,1,0,0,0,.9285-.6284L18.8333,9.417a1,1,0,0,0-.034-.8189L16.5129,4.0259A11.9652,11.9652,0,0,1,26.3762,22H23a1,1,0,0,0-1,1v3.3765A11.9578,11.9578,0,0,1,4.7,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nKe.propTypes = E);
const iKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SQ || (SQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211V26a2.0041,2.0041,0,0,0,2,2H26a2.0037,2.0037,0,0,0,2-2V13.63L29.7573,15,31,13.4282ZM6,12.0615,15,5.05v7.3638l3.458,3.458-6.7344,4.8105L14.3818,26H6ZM26,26H16.6182l-2.3418-4.6826,7.2656-5.1895L17,11.5859V5.0518l9,7.02Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iKe.propTypes = E);
const rKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MQ || (MQ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 7a3 3 0 113-3A3.0033 3.0033 0 0116 7zm0-4a1 1 0 101 1A1.001 1.001 0 0016 3zM11 30a3 3 0 113-3A3.0033 3.0033 0 0111 30zm0-4a1 1 0 101 1A1.001 1.001 0 0011 26zM7 11a3 3 0 113-3A3.0033 3.0033 0 017 11zM7 7A1 1 0 108 8 1.001 1.001 0 007 7zM21 30a3 3 0 113-3A3.0033 3.0033 0 0121 30zm0-4a1 1 0 101 1A1.001 1.001 0 0021 26zM25 11a3 3 0 113-3A3.0033 3.0033 0 0125 11zm0-4a1 1 0 101 1A1.001 1.001 0 0025 7zM4 21a3 3 0 113-3A3.0033 3.0033 0 014 21zm0-4a1 1 0 101 1A1.001 1.001 0 004 17zM28 21a3 3 0 113-3A3.0033 3.0033 0 0128 21zm0-4a1 1 0 101 1A1.001 1.001 0 0028 17zM16 22a6 6 0 116-6A6.0069 6.0069 0 0116 22zm0-10a4 4 0 104 4A4.0045 4.0045 0 0016 12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rKe.propTypes = E);
const sKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DQ || (DQ = /* @__PURE__ */ h.createElement("path", {
    d: "M9 21H23V23H9zM11 14a2 2 0 102 2A1.9806 1.9806 0 0011 14zM21 14a2 2 0 102 2A1.9806 1.9806 0 0021 14z"
  })), LQ || (LQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H18.4141l2.0722-2.0723A2.04,2.04,0,0,0,21,6a2,2,0,1,0-2-2,2.0412,2.0412,0,0,0,.0723.5137L15.5859,8H4a2.0025,2.0025,0,0,0-2,2V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V10A2.0025,2.0025,0,0,0,28,8ZM4,26V10H28V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sKe.propTypes = E);
const oKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kQ || (kQ = /* @__PURE__ */ h.createElement("path", {
    d: "M11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM16 26A10 10 0 0016 6h0z"
  })), NQ || (NQ = /* @__PURE__ */ h.createElement("path", {
    d: "M30,16A14,14,0,0,0,16,2V4a11.9933,11.9933,0,0,1,4.0493,23.2847c-.1682.06-.334.1294-.5044.1821-.2512.0771-.51.1362-.7683.1973-.1262.03-.25.0693-.3772.0952-.2908.0591-.5884.0976-.8862.1352-.1.0122-.1983.0342-.2988.044A12.0015,12.0015,0,0,1,5.416,21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207,13.1207,0,0,1,4.19,18l-1.9677.4131A13.9173,13.9173,0,0,0,2.7,20.2993l-.0251.0083A13.9615,13.9615,0,0,0,16,30q.7134,0,1.415-.0713c.135-.0137.2654-.042.3995-.06.3286-.0424.6574-.0839.9814-.1494.18-.0366.3533-.0908.5308-.1338.2685-.0659.5383-.125.8027-.2065.2463-.0762.4831-.1724.7234-.2612.18-.0664.3635-.1211.5412-.1953l-.0009-.0025A14.0015,14.0015,0,0,0,30,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oKe.propTypes = E);
const aKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TQ || (TQ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 28L26 20 24 20 24 21 22 21 22 23 24 23 24 28 22 28 22 30 28 30 28 28 26 28zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), IQ || (IQ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aKe.propTypes = E);
const lKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OQ || (OQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H22V26a2.002 2.002 0 012-2h2V22H22V20h4a2.0023 2.0023 0 012 2v2a2.0023 2.0023 0 01-2 2H24v2h4zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), RQ || (RQ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lKe.propTypes = E);
const cKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VQ || (VQ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 20H22v2h4v2H23v2h3v2H22v2h4a2.0027 2.0027 0 002-2V22A2.0023 2.0023 0 0026 20zM28 16h2A14 14 0 0016 2V4A12 12 0 0128 16z"
  })), HQ || (HQ = /* @__PURE__ */ h.createElement("path", {
    d: "M26 16A10 10 0 0016 6V16zM16 28A11.96 11.96 0 015.416 21.6548c-.0664-.127-.133-.2534-.1953-.3843-.0547-.1123-.106-.227-.1572-.3413A13.1207 13.1207 0 014.19 18l-1.9677.4131A13.9173 13.9173 0 002.7 20.2993l-.0251.0083A13.9615 13.9615 0 0016 30zM5.5913 10L3.86 9a14.14 14.14 0 00-1.6382 4.5872l1.9677.3469A12.1519 12.1519 0 015.5913 10zM11.8164 4.7646L11.1328 2.887A13.976 13.976 0 006.9507 5.3278L8.2358 6.8593A11.9729 11.9729 0 0111.8164 4.7646z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cKe.propTypes = E);
const hKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BQ || (BQ = /* @__PURE__ */ h.createElement("path", {
    d: "M22 6H26V10H22z"
  })), PQ || (PQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), FQ || (FQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), zQ || (zQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "25",
    cy: "21",
    r: "1"
  })), WQ || (WQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "25",
    cy: "17",
    r: "1"
  })), jQ || (jQ = /* @__PURE__ */ h.createElement("path", {
    d: "M22,17V15H20V14a2.0023,2.0023,0,0,0-2-2H17V10H15v2H13V10H11v2H10a2.0023,2.0023,0,0,0-2,2v1H6v2H8v2H6v2H8v1a2.0023,2.0023,0,0,0,2,2h1v2h2V24h2v2h2V24h1a2.0023,2.0023,0,0,0,2-2V21h2V19H20V17Zm-4,5H10V14h8Z"
  })), ZQ || (ZQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hKe.propTypes = E);
const dKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UQ || (UQ = /* @__PURE__ */ h.createElement("path", {
    d: "M27,22a2.981,2.981,0,0,0-2.0374.811l-4.0039-2.4023a2.0429,2.0429,0,0,0,0-.8174l4.0039-2.4023A2.9909,2.9909,0,1,0,24,15a2.9345,2.9345,0,0,0,.0415.4092l-4.0039,2.4023a3,3,0,1,0,0,4.377l4.0039,2.4023A2.9345,2.9345,0,0,0,24,25a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,27,14Zm-9,7a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,18,21Zm9,5a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,27,26Z"
  })), qQ || (qQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "8",
    r: "1"
  })), GQ || (GQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), QQ || (QQ = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "24",
    r: "1"
  })), KQ || (KQ = /* @__PURE__ */ h.createElement("path", {
    d: "M22,13V5a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,5V27a2.0023,2.0023,0,0,0,2,2H20V27H4V21h8V19H4V13ZM4,5H20v6H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dKe.propTypes = E);
const uKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YQ || (YQ = /* @__PURE__ */ h.createElement("path", {
    d: "M7 11H9V21H7zM11 11H13V21H11zM15 11H17V21H15zM19 11H21V21H19zM23 11H25V21H23z"
  })), XQ || (XQ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H28a2.0023,2.0023,0,0,1,2,2V24A2.0023,2.0023,0,0,1,28,26ZM4,8V24H28V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uKe.propTypes = E);
const hI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JQ || (JQ = /* @__PURE__ */ h.createElement("path", {
    d: "M2 26H30V28H2zM25.4 9c.8-.8.8-2 0-2.8 0 0 0 0 0 0l-3.6-3.6c-.8-.8-2-.8-2.8 0 0 0 0 0 0 0l-15 15V24h6.4L25.4 9zM20.4 4L24 7.6l-3 3L17.4 7 20.4 4zM6 22v-3.6l10-10 3.6 3.6-10 10H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hI.propTypes = E);
const fKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $Q || ($Q = /* @__PURE__ */ h.createElement("path", {
    d: "M30 28.6L3.4 2 2 3.4l10.1 10.1L4 21.6V28h6.4l8.1-8.1L28.6 30 30 28.6zM9.6 26H6v-3.6l7.5-7.5 3.6 3.6L9.6 26zM29.4 6.2L29.4 6.2l-3.6-3.6c-.8-.8-2-.8-2.8 0l0 0 0 0-8 8 1.4 1.4L20 8.4l3.6 3.6L20 15.6l1.4 1.4 8-8C30.2 8.2 30.2 7 29.4 6.2L29.4 6.2zM25 10.6L21.4 7l3-3L28 7.6 25 10.6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fKe.propTypes = E);
const pKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eK || (eK = /* @__PURE__ */ h.createElement("path", {
    d: "M23.625,22.5875a6.1287,6.1287,0,0,1-4.5-1.9l-3.1-3.2-3.1,3.2a6.4582,6.4582,0,0,1-9.1,0,7.028,7.028,0,0,1-1.8-4.7,6.6547,6.6547,0,0,1,1.9-4.7,6.3375,6.3375,0,0,1,9,0l3.1,3.2,3.1-3.2a6.3375,6.3375,0,0,1,9,0,6.8282,6.8282,0,0,1,0,9.4A6.5418,6.5418,0,0,1,23.625,22.5875Zm-6.2-6.6,3.1,3.3a4.4061,4.4061,0,0,0,6.2,0,4.9077,4.9077,0,0,0,0-6.6,4.4061,4.4061,0,0,0-6.2,0Zm-9-4.6a4.1582,4.1582,0,0,0-3.1,1.3,4.8385,4.8385,0,0,0,0,6.6,4.4061,4.4061,0,0,0,6.2,0l3.1-3.3-3.1-3.3A4.7706,4.7706,0,0,0,8.425,11.3875Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pKe.propTypes = E);
const gKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tK || (tK = /* @__PURE__ */ h.createElement("path", {
    d: "M26 30H24V27a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v3H6V27a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM5 6A1 1 0 004 7v9H6V7A1 1 0 005 6z"
  })), nK || (nK = /* @__PURE__ */ h.createElement("path", {
    d: "M4,2V4H9v7a7,7,0,0,0,14,0V4h5V2Zm7,2H21V7H11Zm5,12a5,5,0,0,1-5-5V9H21v2A5,5,0,0,1,16,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gKe.propTypes = E);
const mKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iK || (iK = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mKe.propTypes = E);
const AKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rK || (rK = /* @__PURE__ */ h.createElement("path", {
    d: "M19,24H4L3.9966,8.9062l11.4341,7.9161a1.0008,1.0008,0,0,0,1.1386,0L28,8.9087,28,18h2V8a2.0027,2.0027,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,8V24a2.0027,2.0027,0,0,0,2,2H19ZM25.7986,8,16,14.7837,6.2014,8Z"
  })), sK || (sK = /* @__PURE__ */ h.createElement("circle", {
    cx: "26",
    cy: "24",
    r: "4"
  })), n);
});
process.env.NODE_ENV !== "production" && (AKe.propTypes = E);
const wKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, oK || (oK = /* @__PURE__ */ h.createElement("path", {
    d: "M4,2h-2v26c0,1.1046.8954,2,2,2h11v-2H4V2ZM23,4v2h3.5859l-7.5859,7.5859-4.293-4.293c-.3905-.3905-1.0236-.3905-1.4141,0l-7.293,7.293,1.4141,1.4141,6.5859-6.5859,4.293,4.293c.3905.3904,1.0236.3904,1.4141,0l8.293-8.293v3.5859h2v-7s-7,0-7,0ZM22.48,20.863c-.682-.54-1.544-.863-2.48-.863h-3v3c0,2.206,1.794,4,4,4h1v3h2v-3h1c2.757,0,5-2.243,5-5v-4h-3c-1.933.0016-3.6925,1.116-4.52,2.863ZM22,25h-1c-1.103,0-2-.897-2-2v-1h1c1.103,0,2,.897,2,2v1ZM28,22c0,1.654-1.346,3-3,3h-1v-2c0-1.654,1.346-3,3-3h1v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wKe.propTypes = E);
const vKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aK || (aK = /* @__PURE__ */ h.createElement("path", {
    d: "M29 21.2783V19a4 4 0 00-8 0v2.2783A1.9935 1.9935 0 0020 23v5a2.0025 2.0025 0 002 2h6a2.0025 2.0025 0 002-2V23A1.9935 1.9935 0 0029 21.2783zM25 17a2.0025 2.0025 0 012 2v2H23V19A2.0025 2.0025 0 0125 17zM22 28V23h6v5zM2 2H4V6H2zM14 2H16V6H14zM18 2H20V6H18zM2 8H4V16H2zM2 18H4V26H2zM14 18H16V26H14zM6 8H8V16H6zM18 8H20V14H18zM10 26H8a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0110 26zM8 20v4h2V20zM14 16H12a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2h2a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0114 16zm-2-6v4h2V10zM10 6H8A2.0023 2.0023 0 016 4V2H8V4h2V2h2V4A2.0023 2.0023 0 0110 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vKe.propTypes = E);
const bKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lK || (lK = /* @__PURE__ */ h.createElement("path", {
    d: "M29,14H28V10H26v4H24V10H22v4H21a1,1,0,0,0-1,1v4a5.0079,5.0079,0,0,0,4,4.8989V27a1.0008,1.0008,0,0,1-1,1H5a1,1,0,0,1,0-2h5a3,3,0,0,0,0-6H5a1,1,0,0,1,0-2h5a3.0033,3.0033,0,0,0,3-3V11h1a4.0045,4.0045,0,0,0,4-4V4H15a3.979,3.979,0,0,0-2.7468,1.1064A6.0041,6.0041,0,0,0,7,2H4V5a6.0066,6.0066,0,0,0,6,6h1v4a1.0008,1.0008,0,0,1-1,1H5a3,3,0,0,0,0,6h5a1,1,0,0,1,0,2H5a3,3,0,0,0,0,6H23a3.0033,3.0033,0,0,0,3-3V23.8989A5.0079,5.0079,0,0,0,30,19V15A1,1,0,0,0,29,14ZM13,8a2.002,2.002,0,0,1,2-2h1V7a2.002,2.002,0,0,1-2,2H13ZM10,9A4.0045,4.0045,0,0,1,6,5V4H7a4.0045,4.0045,0,0,1,4,4V9ZM28,19a3,3,0,0,1-6,0V16h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bKe.propTypes = E);
const yKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cK || (cK = /* @__PURE__ */ h.createElement("path", {
    d: "M8 8H10V12H8zM8 14H10V18H8zM14 8H16V12H14zM14 14H16V18H14zM8 20H10V24H8zM14 20H16V24H14z"
  })), hK || (hK = /* @__PURE__ */ h.createElement("path", {
    d: "M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yKe.propTypes = E);
const CKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dK || (dK = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M19.5328 16.0691c0-.9631.8772-1.4445 1.7885-1.4445 1.0486 0 1.4783.6532 1.4783 1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922 0-2.1488.7395-2.5096 1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309zM14.908 19.9883L9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), uK || (uK = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CKe.propTypes = E);
const EKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fK || (fK = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M19.5328 16.0691c0-.9631.8772-1.4445 1.7885-1.4445 1.0486 0 1.4783.6532 1.4783 1.9257v5.4497h2.2004v-5.6732c0-2.2352-1.0315-3.5072-2.8712-3.5072-1.3922 0-2.1488.7395-2.5096 1.7021h-.0863v-1.4957h-2.2006v8.974h2.2006v-5.9309zM14.908 19.9883L9.2693 19.9883 9.2693 16.9282 14.2548 16.9282 14.2548 14.917 9.2693 14.917 9.2693 12.0117 14.908 12.0117 14.908 10 7 10 7 22 14.908 22 14.908 19.9883z"
  })), pK || (pK = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EKe.propTypes = E);
const _Ke = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gK || (gK = /* @__PURE__ */ h.createElement("path", {
    d: "M20 15c-1.7771 0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977 0-2.449.8629-3.2927 1.707l-1.4146-1.4141c1.0674-1.0675 2.5669-2.293 4.7073-2.293 1.7771 0 3.2314.8726 4.5144 1.6425 1.1636.6981 2.2627 1.3575 3.4856 1.3575 1.3975 0 2.4487-.8629 3.293-1.7072l1.4141 1.4143c-1.0674 1.0675-2.5671 2.2928-4.707 2.2928zM20 22c-1.7771 0-3.2314-.8726-4.5144-1.6425-1.1636-.6981-2.2627-1.3575-3.4856-1.3575-1.3977 0-2.449.8629-3.2927 1.707l-1.4146-1.4141c1.0674-1.0675 2.5669-2.293 4.7073-2.293 1.7771 0 3.2314.8726 4.5144 1.6425 1.1636.6981 2.2627 1.3575 3.4856 1.3575 1.3975 0 2.4487-.8629 3.293-1.7072l1.4141 1.4143c-1.0674 1.0675-2.5671 2.2928-4.707 2.2928z"
  })), mK || (mK = /* @__PURE__ */ h.createElement("path", {
    d: "m16,30c-7.7197,0-14-6.2804-14-14S8.2802,2,16,2s14,6.2804,14,14-6.2803,14-14,14Zm0-26c-6.6167,0-12,5.3832-12,12s5.3833,12,12,12,12-5.3832,12-12-5.3833-12-12-12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Ke.propTypes = E);
const xKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AK || (AK = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H10V30H2zM2 24H10V26H2zM12 28H20V30H12zM12 24H20V26H12zM2 20H10V22H2zM12 20H20V22H12zM2 16H10V18H2zM12 16H20V18H12zM12 12H20V14H12zM12 8H20V10H12zM12 4H20V6H12zM22 28H30V30H22zM22 24H30V26H22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xKe.propTypes = E);
const SKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wK || (wK = /* @__PURE__ */ h.createElement("path", {
    d: "M7 27H30V29H7zM27.38 10.51L19.45 2.59a2 2 0 00-2.83 0l-14 14a2 2 0 000 2.83L7.13 24h9.59L27.38 13.34A2 2 0 0027.38 10.51zM15.89 22H8L4 18l6.31-6.31 7.93 7.92zm3.76-3.76l-7.92-7.93L18 4 26 11.93z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SKe.propTypes = E);
const MKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vK || (vK = /* @__PURE__ */ h.createElement("path", {
    d: "M30.4148 16.5132L22.488 8.5859a2.0014 2.0014 0 00-2.8291 0L5.6208 22.624a2.0024 2.0024 0 000 2.8291L10.1663 30h9.5908L30.4148 19.3413A2.001 2.001 0 0030.4148 16.5132zM18.929 28H10.9949l-3.96-3.9619 6.3123-6.3118 7.9276 7.9276zm3.76-3.76l-7.9276-7.9276L21.074 10l7.9267 7.9272zM11 12H8V2h3a3.0033 3.0033 0 013 3V9A3.0033 3.0033 0 0111 12zm-1-2h1a1.0009 1.0009 0 001-1V5a1.0009 1.0009 0 00-1-1H10zM4 2H0V4H4V6H1V8H4v2H0v2H4a2.0027 2.0027 0 002-2V4A2.0023 2.0023 0 004 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MKe.propTypes = E);
const Vd = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bK || (bK = /* @__PURE__ */ h.createElement("path", {
    d: "M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vd.propTypes = E);
const dI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, yK || (yK = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z"
  })), CK || (CK = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M10.7,11.5L4.5,5.3l0.8-0.8l6.2,6.2L10.7,11.5z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, EK || (EK = /* @__PURE__ */ h.createElement("path", {
    d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z"
  })), _K || (_K = /* @__PURE__ */ h.createElement("path", {
    d: "M13.5,14.5l-8-8l1-1l8,8L13.5,14.5z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, xK || (xK = /* @__PURE__ */ h.createElement("path", {
    d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z"
  })), SK || (SK = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16.3,17.5L6.5,7.7l1.2-1.2l9.8,9.8L16.3,17.5z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MK || (MK = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M14.9 7.2H17.1V24.799H14.9z",
    "data-icon-path": "inner-path",
    transform: "rotate(-45 16 16)"
  })), DK || (DK = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A13.914,13.914,0,0,0,2,16,13.914,13.914,0,0,0,16,30,13.914,13.914,0,0,0,30,16,13.914,13.914,0,0,0,16,2Zm5.4449,21L9,10.5557,10.5557,9,23,21.4448Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dI.propTypes = E);
const DKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, LK || (LK = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
  })), kK || (kK = /* @__PURE__ */ h.createElement("path", {
    d: "M7.4 3.6H8.5V12.4H7.4z",
    transform: "rotate(-45.001 8 8)"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, NK || (NK = /* @__PURE__ */ h.createElement("path", {
    d: "M14.9 7.2H17.1V24.799H14.9z",
    transform: "rotate(-45 16 16)"
  })), TK || (TK = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A13.9138,13.9138,0,0,0,2,16,13.9138,13.9138,0,0,0,16,30,13.9138,13.9138,0,0,0,30,16,13.9138,13.9138,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12.0353,12.0353,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DKe.propTypes = E);
const LKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, IK || (IK = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), OK || (OK = /* @__PURE__ */ h.createElement("path", {
    d: "M21 15L23.549 19.938 29 20.729 25 24.573 26 30 21 27.438 16 30 17 24.573 13 20.729 18.6 19.938 21 15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LKe.propTypes = E);
const kKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RK || (RK = /* @__PURE__ */ h.createElement("path", {
    d: "M17 15H19V22H17z"
  })), VK || (VK = /* @__PURE__ */ h.createElement("circle", {
    cx: "18",
    cy: "25",
    r: "1.25"
  })), HK || (HK = /* @__PURE__ */ h.createElement("path", {
    d: "M29 30H7c-.3499 0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L17.1143 7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11 21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823zm-20.3474-2h18.6948l-9.3474-17.8448-9.3474 17.8448zM7 23H3c-.3467 0-.6685-.1794-.8506-.4742-.1824-.2948-.1987-.663-.0439-.973l2.5-5 1.7891.8945-1.7766 3.5527h2.3821v2z"
  })), BK || (BK = /* @__PURE__ */ h.createElement("path", {
    d: "M4.955 11.5H10.545V13.5H4.955z",
    transform: "rotate(-63.435 7.75 12.5)"
  })), PK || (PK = /* @__PURE__ */ h.createElement("path", {
    d: "m10.8945,8.4473l-1.7891-.8945,2.5-5c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l2,4-1.7891.8945-1.1055-2.2112-1.6055,3.2112Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kKe.propTypes = E);
const NKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FK || (FK = /* @__PURE__ */ h.createElement("path", {
    d: "M21.0176 26.7217L22.016 28.4541 24.9938 26.7322 24.9938 30 26.9907 30 26.9907 26.7316 30.0016 28.4727 31 26.7402 27.9898 24.9996 30.9902 23.2646 29.9918 21.5322 26.9907 23.2677 26.9907 20 24.9938 20 24.9938 23.2672 21.9984 21.5352 21 23.2676 23.9954 24.9996 21.0176 26.7217zM16 23c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 12H17V21H15z"
  })), zK || (zK = /* @__PURE__ */ h.createElement("path", {
    d: "m18,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6.76,13-1.7744.9226-5.8728-11.2938L4.6472,28h13.3528v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NKe.propTypes = E);
const TKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WK || (WK = /* @__PURE__ */ h.createElement("path", {
    d: "M21,30a8,8,0,1,1,8-8A8,8,0,0,1,21,30Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,21,16Z"
  })), jK || (jK = /* @__PURE__ */ h.createElement("path", {
    d: "M22.59 25L20 22.41 20 18 22 18 22 21.59 24 23.59 22.59 25z"
  })), ZK || (ZK = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TKe.propTypes = E);
const IKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UK || (UK = /* @__PURE__ */ h.createElement("path", {
    d: "M27.3803 28h-6.7625l3.3822-6.7642 3.3803 6.7642zm-3.3803-10c-.3915 0-.7305.2251-.8947.5527l-5 10c-.0674.1348-.1053.2866-.1053.4473 0 .5522.4477 1 1 1h10c.5523 0 1-.4478 1-1 0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0zM16 23c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 12H17V21H15z"
  })), qK || (qK = /* @__PURE__ */ h.createElement("path", {
    d: "m15,30H3c-.3494,0-.6736-.1824-.8547-.4811-.1814-.2986-.1936-.6703-.0325-.9802L15.1128,3.5387c.1721-.3311.5297-.5387.8872-.5387s.7151.2076.8872.5387l6,11.5385-1.7744.9226-5.1128-9.8322L4.6472,28h10.3528v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IKe.propTypes = E);
const OKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GK || (GK = /* @__PURE__ */ h.createElement("path", {
    d: "M26 14H24v2h2a3.0033 3.0033 0 013 3v4h2V19A5.0058 5.0058 0 0026 14zM24 4a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0024 2zM23 30H21V28a3.0033 3.0033 0 00-3-3H14a3.0033 3.0033 0 00-3 3v2H9V28a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM16 13a3 3 0 11-3 3 3 3 0 013-3m0-2a5 5 0 105 5A5 5 0 0016 11zM8 14H6a5.0059 5.0059 0 00-5 5v4H3V19a3.0033 3.0033 0 013-3H8zM8 4A3 3 0 115 7 3 3 0 018 4M8 2a5 5 0 105 5A5 5 0 008 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OKe.propTypes = E);
const RKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, QK || (QK = /* @__PURE__ */ h.createElement("path", {
    d: "M18 31h2V29a1.0006 1.0006 0 011-1h6a1.0006 1.0006 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 25a4 4 0 114-4A4.0039 4.0039 0 0124 25zm0-6a2 2 0 102 2A2.0027 2.0027 0 0024 19zM2 31H4V29a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V29a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 25a4 4 0 114-4A4.0042 4.0042 0 018 25zm0-6a2 2 0 102 2A2.0023 2.0023 0 008 19zM18 16h2V14a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 10a4 4 0 114-4A4.0042 4.0042 0 0124 10zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 4zM2 16H4V14a1.0013 1.0013 0 011-1h6a1.0013 1.0013 0 011 1v2h2V14a3.0033 3.0033 0 00-3-3H5a3.0033 3.0033 0 00-3 3zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RKe.propTypes = E);
const VKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KK || (KK = /* @__PURE__ */ h.createElement("path", {
    d: "M25 23v3H7V16.83l3.59 3.58L12 19 6 13 0 19l1.41 1.41L5 16.83V26a2 2 0 002 2H25a2 2 0 002-2V23zM27 7v9.17l3.59-3.58L32 14l-6 6-6-6 1.41-1.41L25 16.17V7H13V5H25A2 2 0 0127 7zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VKe.propTypes = E);
const HKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YK || (YK = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M25 21L32 26 25 31 25 21z"
  })), XK || (XK = /* @__PURE__ */ h.createElement("path", {
    d: "M20.17 19L17.58 21.59 19 23 23 19 19 15 17.58 16.41 20.17 19zM11.83 19L14.42 16.41 13 15 9 19 13 23 14.42 21.59 11.83 19z"
  })), JK || (JK = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "8",
    r: "1"
  })), $K || ($K = /* @__PURE__ */ h.createElement("circle", {
    cx: "6",
    cy: "8",
    r: "1"
  })), eY || (eY = /* @__PURE__ */ h.createElement("path", {
    d: "M21,26H4V12H28v7h2V6c0-1.1025-.8972-2-2-2H4c-1.1028,0-2,.8975-2,2V26c0,1.1025,.8972,2,2,2H21v-2ZM4,6H28v4H4V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HKe.propTypes = E);
const BKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tY || (tY = /* @__PURE__ */ h.createElement("path", {
    d: "M26 4H28V28H26zM11.414 20.586L7.828 17 22 17 22 15 7.828 15 11.414 11.414 10 10 4 16 10 22 11.414 20.586z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BKe.propTypes = E);
const PKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nY || (nY = /* @__PURE__ */ h.createElement("path", {
    d: "M12,10H26a2.0025,2.0025,0,0,0,2-2V4a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2V5H6V2H4V25a2.0025,2.0025,0,0,0,2,2h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V24a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V17h4v1a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V14a2.0025,2.0025,0,0,0-2-2H12a2.0025,2.0025,0,0,0-2,2v1H6V7h4V8A2.0025,2.0025,0,0,0,12,10Zm0-6H26l.0012,4H12Zm0,20H26l.0012,4H12Zm0-10H26l.0012,4H12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PKe.propTypes = E);
const FKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iY || (iY = /* @__PURE__ */ h.createElement("path", {
    d: "M20 26H26V28H20zM20 18H28V20H20zM20 10H30V12H20zM15 4H17V28H15zM10.586 3.959L7 7.249 3.412 3.958 2 5.373 7 10 12 5.373 10.586 3.959z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FKe.propTypes = E);
const zKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rY || (rY = /* @__PURE__ */ h.createElement("path", {
    d: "M22.707,9.2931a.9992.9992,0,0,0-1.0234-.2417l-9,3a1.001,1.001,0,0,0-.6323.6323l-3,9a1,1,0,0,0,1.2651,1.2651l9-3a1.0013,1.0013,0,0,0,.6323-.6324l3-9A1,1,0,0,0,22.707,9.2931ZM11.5811,20.419l2.2094-6.6284L18.21,18.21Z"
  })), sY || (sY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zKe.propTypes = E);
const WKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, oY || (oY = /* @__PURE__ */ h.createElement("path", {
    d: "M13 12v2H3v-2H2v2l0 0c0 .6.4 1 1 1h10c.6 0 1-.4 1-1l0 0v-2H13zM3 6L3.7 6.7 7.5 2.9 7.5 12 8.5 12 8.5 2.9 12.3 6.7 13 6 8 1z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aY || (aY = /* @__PURE__ */ h.createElement("path", {
    d: "M26 24v4H6V24H4v4l.0076-.0049A1.9977 1.9977 0 006 30H26a2 2 0 002-2h0V24zM6 12L7.411 13.405 15 5.825 15 24 17 24 17 5.825 24.591 13.405 26 12 16 2 6 12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WKe.propTypes = E);
const jKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lY || (lY = /* @__PURE__ */ h.createElement("path", {
    d: "M2 27H5V30H2zM29.71 7.29l-5-5a1 1 0 00-1.41 0h0L20 5.59l-1.29-1.3L17.29 5.71 18.59 7 8.29 17.29A1 1 0 008 18v1.59l-2.71 2.7a1 1 0 000 1.41h0l3 3a1 1 0 001.41 0h0L12.41 24H14a1 1 0 00.71-.29L25 13.41l1.29 1.3 1.42-1.42L26.41 12l3.3-3.29a1 1 0 000-1.41zM13.59 22h-2L9 24.59 7.41 23 10 20.41v-2l10-10L23.59 12zM25 10.59L21.41 7 24 4.41 27.59 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jKe.propTypes = E);
const ZKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cY || (cY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), hY || (hY = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZKe.propTypes = E);
const UKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dY || (dY = /* @__PURE__ */ h.createElement("path", {
    d: "M30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM9 20a8.13 8.13 0 0014 0z"
  })), uY || (uY = /* @__PURE__ */ h.createElement("path", {
    d: "M27.82,14A12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a14.71,14.71,0,0,0-.16-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UKe.propTypes = E);
const qKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fY || (fY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8.11,8.11,0,0,1-7-4H23A8.11,8.11,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qKe.propTypes = E);
const GKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pY || (pY = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22a6 6 0 01-5.14-2.92l-1.71 1a8 8 0 0013.7 0l-1.71-1A6 6 0 0116 22zM30 4L26 4 26 0 24 0 24 4 20 4 20 6 24 6 24 10 26 10 26 6 30 6 30 4zM11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
  })), gY || (gY = /* @__PURE__ */ h.createElement("path", {
    d: "M27.61,13A12.33,12.33,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,29.67,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GKe.propTypes = E);
const QKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mY || (mY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,24a8,8,0,0,0,6.85-3.89l-1.71-1a6,6,0,0,1-10.28,0l-1.71,1A8,8,0,0,0,16,24Z"
  })), AY || (AY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,2a12,12,0,0,1,10.89,7H25a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1H5.11A12,12,0,0,1,16,4Zm0,24A12,12,0,0,1,4,16a11.86,11.86,0,0,1,.4-3H7v2a2,2,0,0,0,2,2h3.31a2,2,0,0,0,2-1.67L14.83,12h2.34l.55,3.33a2,2,0,0,0,2,1.67H23a2,2,0,0,0,2-2V13h2.6a11.86,11.86,0,0,1,.4,3A12,12,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QKe.propTypes = E);
const KKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wY || (wY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), vY || (vY = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM16 19a8 8 0 00-6.85 3.89l1.71 1a6 6 0 0110.28 0l1.71-1A8 8 0 0016 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KKe.propTypes = E);
const YKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bY || (bY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9h0A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.54,11Zm9.64,12.92a6,6,0,0,0-10.28,0l-1.71-1a8,8,0,0,1,13.7,0ZM20.5,16a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YKe.propTypes = E);
const XKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yY || (yY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), CY || (CY = /* @__PURE__ */ h.createElement("path", {
    d: "M24.41 11L23 9.59 21 11.59 19 9.59 17.59 11 19.59 13 17.59 15 19 16.41 21 14.41 23 16.41 24.41 15 22.41 13 24.41 11zM14.41 11L13 9.59 11 11.59 9 9.59 7.59 11 9.59 13 7.59 15 9 16.41 11 14.41 13 16.41 14.41 15 12.41 13 14.41 11zM16 19a3 3 0 103 3 3 3 0 00-3-3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XKe.propTypes = E);
const JKe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, EY || (EY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,16.41,7.59,15l2-2-2-2L9,9.59l2,2,2-2L14.41,11l-2,2,2,2L13,16.41l-2-2ZM16,25a3,3,0,1,1,3-3A3,3,0,0,1,16,25Zm8.41-10L23,16.41l-2-2-2,2L17.59,15l2-2-2-2L19,9.59l2,2,2-2L24.41,11l-2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JKe.propTypes = E);
const $Ke = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _Y || (_Y = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11z"
  })), xY || (xY = /* @__PURE__ */ h.createElement("path", {
    d: "M30,16A14,14,0,1,0,8.8994,28.042l.0156.1562A1.993,1.993,0,0,0,10.9048,30h10.19a1.9929,1.9929,0,0,0,1.99-1.8008l.0156-.1572A13.9674,13.9674,0,0,0,30,16ZM16,4A11.99,11.99,0,0,1,27.97,15.397L22.7637,18H9.2363L4.0305,15.397A11.99,11.99,0,0,1,16,4ZM4.12,17.6777l3.94,1.97.5813,5.81A11.97,11.97,0,0,1,4.12,17.6777ZM21.0947,28H10.9053l-.8-8h11.79Zm2.2644-2.542.5811-5.81,3.94-1.97A11.9712,11.9712,0,0,1,23.3591,25.458Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Ke.propTypes = E);
const eYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, SY || (SY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), MY || (MY = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.5 2.5 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM10 20H22V22H10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eYe.propTypes = E);
const tYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DY || (DY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM9,13.5A2.5,2.5,0,1,1,11.5,16,2.5,2.5,0,0,1,9,13.5ZM22,22H10V20H22Zm-1.5-6A2.5,2.5,0,1,1,23,13.5,2.5,2.5,0,0,1,20.5,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tYe.propTypes = E);
const nYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, LY || (LY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), kY || (kY = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nYe.propTypes = E);
const iYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, NY || (NY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM11.5,16A2.5,2.5,0,1,1,14,13.5,2.48,2.48,0,0,1,11.5,16Zm9,0A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iYe.propTypes = E);
const rYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TY || (TY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), IY || (IY = /* @__PURE__ */ h.createElement("path", {
    d: "M11.5 11A2.5 2.5 0 1014 13.5 2.48 2.48 0 0011.5 11zM20.5 11A2.5 2.5 0 1023 13.5 2.48 2.48 0 0020.5 11zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rYe.propTypes = E);
const sYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OY || (OY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm-4.5,9A2.5,2.5,0,1,1,9,13.5,2.48,2.48,0,0,1,11.5,11ZM16,24a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8A2.5,2.5,0,1,1,23,13.5,2.48,2.48,0,0,1,20.5,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sYe.propTypes = E);
const oYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RY || (RY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), VY || (VY = /* @__PURE__ */ h.createElement("path", {
    d: "M20.5 11A2.5 2.5 0 1023 13.5 2.5 2.5 0 0020.5 11zM8 13H14V15H8zM16 24a8 8 0 006.85-3.89l-1.71-1a6 6 0 01-10.28 0l-1.71 1A8 8 0 0016 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oYe.propTypes = E);
const aYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, HY || (HY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,13h6v2H8Zm8,11a8,8,0,0,1-6.85-3.89l1.71-1a6,6,0,0,0,10.28,0l1.71,1A8,8,0,0,1,16,24Zm4.5-8a2.5,2.5,0,0,1,0-5h0a2.5,2.5,0,0,1,0,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aYe.propTypes = E);
const lYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BY || (BY = /* @__PURE__ */ h.createElement("path", {
    d: "M27,28V9H24V4h2V2H20V4h2V9H19V28H15V16H12V11h2V9H8v2h2v5H7V28H4V2H2V28a2,2,0,0,0,2,2H30V28ZM13,28H9V18h4Zm8-17h4V28H21Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lYe.propTypes = E);
const cYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, PY || (PY = /* @__PURE__ */ h.createElement("path", {
    d: "M4.1 12.6l-.6.8c.6.5 1.3.9 2.1 1.2l.3-.9C5.3 13.4 4.7 13 4.1 12.6zM2.1 9l-1 .2c.1.8.4 1.6.8 2.3L2.8 11C2.4 10.4 2.2 9.7 2.1 9zM5.9 2.4L5.6 1.4C4.8 1.7 4.1 2.1 3.5 2.7l.6.8C4.7 3 5.3 2.6 5.9 2.4zM2.8 5L1.9 4.5C1.5 5.2 1.3 6 1.1 6.8l1 .2C2.2 6.3 2.5 5.6 2.8 5zM8 1v1c3.3 0 6 2.7 6 6s-2.7 6-6 6v1c3.9 0 7-3.1 7-7S11.9 1 8 1z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FY || (FY = /* @__PURE__ */ h.createElement("path", {
    d: "M8.24 25.14L7 26.67a13.79 13.79 0 004.18 2.44l.69-1.87A12 12 0 018.24 25.14zM4.19 18l-2 .41A14.09 14.09 0 003.86 23L5.59 22A12.44 12.44 0 014.19 18zM11.82 4.76l-.69-1.87A13.79 13.79 0 007 5.33L8.24 6.86A12 12 0 0111.82 4.76zM5.59 10L3.86 9a14.37 14.37 0 00-1.64 4.59l2 .34A12.05 12.05 0 015.59 10zM16 2V4a12 12 0 010 24v2A14 14 0 0016 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cYe.propTypes = E);
const hYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zY || (zY = /* @__PURE__ */ h.createElement("path", {
    d: "M22.45,6a5.47,5.47,0,0,1,3.91,1.64,5.7,5.7,0,0,1,0,8L16,26.13,5.64,15.64a5.7,5.7,0,0,1,0-8,5.48,5.48,0,0,1,7.82,0L16,10.24l2.53-2.58A5.44,5.44,0,0,1,22.45,6m0-2a7.47,7.47,0,0,0-5.34,2.24L16,7.36,14.89,6.24a7.49,7.49,0,0,0-10.68,0,7.72,7.72,0,0,0,0,10.82L16,29,27.79,17.06a7.72,7.72,0,0,0,0-10.82A7.49,7.49,0,0,0,22.45,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hYe.propTypes = E);
const dYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WY || (WY = /* @__PURE__ */ h.createElement("path", {
    d: "M22.5,4c-2,0-3.9,0.8-5.3,2.2L16,7.4l-1.1-1.1C12,3.3,7.2,3.3,4.3,6.2c0,0-0.1,0.1-0.1,0.1c-3,3-3,7.8,0,10.8L16,29 l11.8-11.9c3-3,3-7.8,0-10.8C26.4,4.8,24.5,4,22.5,4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dYe.propTypes = E);
const uYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jY || (jY = /* @__PURE__ */ h.createElement("path", {
    d: "M4.21,17.0615,16,29,27.79,17.0615a7.7313,7.7313,0,0,0,0-10.8232,7.494,7.494,0,0,0-10.6841,0L16,7.3643l-1.1062-1.126a7.494,7.494,0,0,0-10.6841,0A7.7313,7.7313,0,0,0,4.21,17.0615ZM26.3552,15.645,16,26.1255V10.23q1.2708-1.2876,2.5413-2.5742a5.4768,5.4768,0,0,1,7.8139,0A5.708,5.708,0,0,1,26.3552,15.645Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uYe.propTypes = E);
const fYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZY || (ZY = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m14,28v-9l8-8L13,2,4,11l8,8v9c0,1.1045.8955,2,2,2h14v-2h-14Zm-1-23.1716l6.1716,6.1716-6.1716,6.1716-6.1716-6.1716,6.1716-6.1716Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fYe.propTypes = E);
const pYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UY || (UY = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m14,28v-9l8-8L13,2,4,11l8,8v9c0,1.1045.8955,2,2,2h14v-2h-14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pYe.propTypes = E);
const gYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qY || (qY = /* @__PURE__ */ h.createElement("circle", {
    cx: "17.5",
    cy: "22.5",
    r: "1.5",
    strokeWidth: "0"
  })), GY || (GY = /* @__PURE__ */ h.createElement("circle", {
    cx: "6.5",
    cy: "22.5",
    r: "1.5",
    strokeWidth: "0"
  })), QY || (QY = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m13,28v-10h7c.3564,0,.686-.1899.8647-.498.0902-.1551.1353-.3285.1353-.502,0-.1711-.0441-.3424-.1318-.4961L12.8682,2.504c-.1919-.3359-.5301-.504-.8682-.504s-.6763.1681-.8682.504l-7.9999,13.9999c-.0878.1537-.1318.3249-.1318.4961,0,.1735.0451.3469.1353.502.1787.3081.5083.498.8647.498h7v10c0,1.1046.8954,2,2,2h15v-2h-15Zm-7.2769-12l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gYe.propTypes = E);
const mYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KY || (KY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,7,6,17l1.41,1.41L15,10.83V28H2v2H15a2,2,0,0,0,2-2V10.83l7.59,7.58L26,17Z"
  })), YY || (YY = /* @__PURE__ */ h.createElement("path", {
    d: "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mYe.propTypes = E);
const AYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, XY || (XY = /* @__PURE__ */ h.createElement("path", {
    d: "M16,13l-5,5,1.41,1.41L15,16.83V28H6v2h9a2,2,0,0,0,2-2V16.83l2.59,2.58L21,18Z"
  })), JY || (JY = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,22H23V20h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,20H9v2H8.5A6.4973,6.4973,0,0,1,7.2,9.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AYe.propTypes = E);
const wYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $Y || ($Y = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), eX || (eX = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), tX || (tX = /* @__PURE__ */ h.createElement("path", {
    d: "M22.707,7.293l-5-5A1,1,0,0,0,17,2H11A2.0023,2.0023,0,0,0,9,4V20a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V8A1,1,0,0,0,22.707,7.293ZM20.5857,8H17V4.4141ZM11,20V4h4V8a2.0023,2.0023,0,0,0,2,2h4V20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wYe.propTypes = E);
const vYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nX || (nX = /* @__PURE__ */ h.createElement("path", {
    d: "M18,28H14a2,2,0,0,1-2-2V18.41L4.59,11A2,2,0,0,1,4,9.59V6A2,2,0,0,1,6,4H26a2,2,0,0,1,2,2V9.59A2,2,0,0,1,27.41,11L20,18.41V26A2,2,0,0,1,18,28ZM6,6V9.59l8,8V26h4V17.59l8-8V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vYe.propTypes = E);
const bYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iX || (iX = /* @__PURE__ */ h.createElement("path", {
    d: "M26,6H4V9.17l7.41,7.42.59.58V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.59,10.59A2,2,0,0,1,2,9.17V6A2,2,0,0,1,4,4H26Z"
  })), rX || (rX = /* @__PURE__ */ h.createElement("path", {
    d: "M29.71,11.29l-3-3a1,1,0,0,0-1.42,0L16,17.59V22h4.41l9.3-9.29A1,1,0,0,0,29.71,11.29ZM19.59,20H18V18.41l5-5L24.59,15ZM26,13.59,24.41,12,26,10.41,27.59,12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bYe.propTypes = E);
const yYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sX || (sX = /* @__PURE__ */ h.createElement("path", {
    d: "M30 11.414L28.586 10 24 14.586 19.414 10 18 11.414 22.586 16 18 20.585 19.415 22 24 17.414 28.587 22 30 20.587 25.414 16 30 11.414z"
  })), oX || (oX = /* @__PURE__ */ h.createElement("path", {
    d: "M4,4A2,2,0,0,0,2,6V9.1709a2,2,0,0,0,.5859,1.4145L10,18v8a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V24H16v2H12V17.1709l-.5859-.5855L4,9.1709V6H24V8h2V6a2,2,0,0,0-2-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yYe.propTypes = E);
const CYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aX || (aX = /* @__PURE__ */ h.createElement("path", {
    d: "M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z"
  })), lX || (lX = /* @__PURE__ */ h.createElement("path", {
    d: "M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CYe.propTypes = E);
const EYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cX || (cX = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H30V30H2zM27 11a1 1 0 001-1V7a1 1 0 00-.66-.94l-11-4a1 1 0 00-.68 0l-11 4A1 1 0 004 7v3a1 1 0 001 1H6V24H4v2H28V24H26V11zM6 7.7L16 4.06 26 7.7V9H6zM18 24H14V11h4zM8 11h4V24H8zM24 24H20V11h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EYe.propTypes = E);
const _Ye = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hX || (hX = /* @__PURE__ */ h.createElement("path", {
    d: "M27,16h-2v2h-1c-1.1,0-2,.9-2,2v2c0,1.1.9,2,2,2h4v2h-6v2h3v2h2v-2h1c1.1,0,2-.9,2-2v-2c0-1.1-.9-2-2-2h-4v-2h6v-2h-3v-2ZM28,8h-6v-4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v4h-6c-1.1,0-2,.9-2,2v14c0,1.1.9,2,2,2h15v-2H4v-14h24v4h2v-4c0-1.1-.9-2-2-2ZM20,8h-8v-4h8v4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Ye.propTypes = E);
const xYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dX || (dX = /* @__PURE__ */ h.createElement("path", {
    d: "M7,5.21a.77.77,0,0,1-.46-1.38A15.46,15.46,0,0,1,16,1c2.66,0,6.48.45,9.5,2.62a.77.77,0,0,1,.18,1.07.78.78,0,0,1-1.08.17A15,15,0,0,0,16,2.53,14,14,0,0,0,7.5,5.05.74.74,0,0,1,7,5.21Z"
  })), uX || (uX = /* @__PURE__ */ h.createElement("path", {
    d: "M28.23,12.26a.78.78,0,0,1-.63-.33C25.87,9.49,22.78,6.24,16,6.24a14,14,0,0,0-11.63,5.7.77.77,0,0,1-1.07.17A.76.76,0,0,1,3.15,11,15.54,15.54,0,0,1,16,4.71c5.61,0,9.81,2.08,12.84,6.34a.77.77,0,0,1-.19,1.07A.79.79,0,0,1,28.23,12.26Z"
  })), fX || (fX = /* @__PURE__ */ h.createElement("path", {
    d: "M12.28,31a.78.78,0,0,1-.72-.49.75.75,0,0,1,.44-1c4.37-1.68,7-5.12,7-9.21a2.8,2.8,0,0,0-3-3c-1.86,0-2.76,1-3,3.35a4.27,4.27,0,0,1-4.52,3.83,4.27,4.27,0,0,1-4.32-4.59A11.71,11.71,0,0,1,16,8.39a12,12,0,0,1,12,11.93,18.66,18.66,0,0,1-1.39,6.5.78.78,0,0,1-1,.41.76.76,0,0,1-.41-1,17.25,17.25,0,0,0,1.27-5.91A10.45,10.45,0,0,0,16,9.92a10.18,10.18,0,0,0-10.38,10,2.77,2.77,0,0,0,2.79,3.06,2.74,2.74,0,0,0,3-2.48c.36-3.11,1.89-4.69,4.56-4.69a4.31,4.31,0,0,1,4.52,4.56c0,4.74-3,8.72-8,10.63A.92.92,0,0,1,12.28,31Z"
  })), pX || (pX = /* @__PURE__ */ h.createElement("path", {
    d: "M19.77,30.28a.81.81,0,0,1-.52-.2.76.76,0,0,1,0-1.08,12.63,12.63,0,0,0,3.54-8.68c0-1.56-.48-6.65-6.7-6.65a6.83,6.83,0,0,0-4.94,1.87A6.17,6.17,0,0,0,9.32,20a.77.77,0,0,1-.77.76h0A.76.76,0,0,1,7.78,20,7.73,7.73,0,0,1,10,14.46a8.34,8.34,0,0,1,6-2.32c6.08,0,8.24,4.4,8.24,8.18A14.09,14.09,0,0,1,20.34,30,.75.75,0,0,1,19.77,30.28Z"
  })), gX || (gX = /* @__PURE__ */ h.createElement("path", {
    d: "M8.66,27.74a14.14,14.14,0,0,1-1.56-.09.76.76,0,1,1,.17-1.52c2.49.28,4.45-.16,5.84-1.32a6.37,6.37,0,0,0,2.12-4.53.75.75,0,0,1,.82-.71.78.78,0,0,1,.72.81A7.89,7.89,0,0,1,14.09,26,8.2,8.2,0,0,1,8.66,27.74Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xYe.propTypes = E);
const SYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mX || (mX = /* @__PURE__ */ h.createElement("path", {
    d: "M24.832,16.9688c-.2724-.6465-.5815-1.38-.8833-2.2852-.79-2.3682,1.7344-4.9522,1.7583-4.9766L24.293,8.293c-.1407.1406-3.4234,3.4775-2.2417,7.0234.3261.978.6513,1.749.938,2.43A9.3812,9.3812,0,0,1,24,22a6.24,6.24,0,0,1-4.1892,5.293,8.52,8.52,0,0,0-2.1038-8l-1.0444-1.0445-.5815,1.3575C14.2449,23.89,12.06,25.76,10.7747,26.54A5.8437,5.8437,0,0,1,8,22a9.6239,9.6239,0,0,1,.9287-3.6289A11.3329,11.3329,0,0,0,10,14V12.2217c.8735.36,2,1.3037,2,3.7783v2.6035l1.7432-1.9341c3.1118-3.4546,2.4624-7.5678,1.206-10.3081A4.4859,4.4859,0,0,1,18,11h2c0-5.5371-4.5786-7-7-7H11l1.1992,1.5986c.1377.1856,2.8628,3.9278,1.3535,7.688A4.9426,4.9426,0,0,0,9,10H8v4a9.6239,9.6239,0,0,1-.9287,3.6289A11.3329,11.3329,0,0,0,6,22c0,3.8477,3.8232,8,10,8s10-4.1523,10-8A11.3771,11.3771,0,0,0,24.832,16.9688ZM12.8352,27.5264a16.4987,16.4987,0,0,0,4.3665-5.5987,6.1053,6.1053,0,0,1,.2573,5.9717A11.3213,11.3213,0,0,1,16,28,10.3278,10.3278,0,0,1,12.8352,27.5264Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SYe.propTypes = E);
const MYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AX || (AX = /* @__PURE__ */ h.createElement("path", {
    d: "M27 20.3972v3c-1 0-2-1.5-2-4v-3c-4 5-5 7-5 9A5.0008 5.0008 0 0023.0458 30 7.5281 7.5281 0 0125 26.3972 7.5281 7.5281 0 0126.9542 30 5.0008 5.0008 0 0030 25.3972C30 23.3972 28.875 21.8258 27 20.3972zM17 28H4V24H17V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17z"
  })), wX || (wX = /* @__PURE__ */ h.createElement("path", {
    d: "M28 12H7a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2H17V18H7V14H28l.0011 2H30V14A2.0023 2.0023 0 0028 12zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MYe.propTypes = E);
const DYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vX || (vX = /* @__PURE__ */ h.createElement("path", {
    d: "M28 20V17a4 4 0 00-8 0v3a2.0023 2.0023 0 00-2 2v6a2.0023 2.0023 0 002 2h8a2.0023 2.0023 0 002-2V22A2.0023 2.0023 0 0028 20zm-6-3a2 2 0 014 0v3H22zm6 11H20V22h8zM15 27H4a2 2 0 01-2-2V22a2 2 0 012-2H15v2H4v3H15zM17 18H8a2 2 0 01-2-2V13a2 2 0 012-2H19v2H8v3h9zM22 9H4A2 2 0 012 7V4A2 2 0 014 2H22a2 2 0 012 2V7A2 2 0 0122 9zM4 7H22V4H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DYe.propTypes = E);
const LYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bX || (bX = /* @__PURE__ */ h.createElement("circle", {
    cx: "24",
    cy: "7",
    r: "1"
  })), yX || (yX = /* @__PURE__ */ h.createElement("path", {
    d: "M26,2A16.0183,16.0183,0,0,0,10,18v2H3a1,1,0,0,0-.707,1.707l8,8A1,1,0,0,0,12,29V22h2A16.0183,16.0183,0,0,0,30,6V2ZM10,26.5857,5.4141,22H10ZM12,20V18a13.9394,13.9394,0,0,1,3.908-9.6777l7.77,7.7695A13.94,13.94,0,0,1,14,20ZM28,6a13.9163,13.9163,0,0,1-2.98,8.6055L17.3945,6.98A13.9163,13.9163,0,0,1,26,4h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LYe.propTypes = E);
const kYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CX || (CX = /* @__PURE__ */ h.createElement("path", {
    d: "M30,14a12.9845,12.9845,0,0,0-3.8286-9.2427L24.4143,3,23,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L22,24.5857,23.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,30,14Z"
  })), EX || (EX = /* @__PURE__ */ h.createElement("circle", {
    cx: "17",
    cy: "11",
    r: "1"
  })), _X || (_X = /* @__PURE__ */ h.createElement("path", {
    d: "M22,14a12.9845,12.9845,0,0,0-3.8286-9.2427L16.4143,3,15,4.4138l1.7573,1.7574a11.0713,11.0713,0,0,1,0,15.6572L14,24.5857,15.4143,26l2.7571-2.7573A12.9845,12.9845,0,0,0,22,14Z"
  })), xX || (xX = /* @__PURE__ */ h.createElement("circle", {
    cx: "25",
    cy: "11",
    r: "1"
  })), SX || (SX = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "11",
    r: "1"
  })), MX || (MX = /* @__PURE__ */ h.createElement("path", {
    d: "M9.4141,24l.7573-.7573a13.0708,13.0708,0,0,0,0-18.4854L8,2.5857,5.8286,4.7571a13.0708,13.0708,0,0,0,0,18.4854L6.5859,24,2.293,28.2928A1,1,0,0,0,3,30H13a1,1,0,0,0,.707-1.707ZM4,14A10.9988,10.9988,0,0,1,7.2427,6.1712L8,5.4138l.7573.7574a11.0713,11.0713,0,0,1,0,15.6572L8,22.5857l-.7573-.7573A10.9988,10.9988,0,0,1,4,14ZM5.4141,28,8,25.4138,10.5859,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kYe.propTypes = E);
const NYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DX || (DX = /* @__PURE__ */ h.createElement("path", {
    d: "M11 10L12.41 11.41 15 8.83 15 23.17 12.41 20.59 11 22 16 27 21 22 19.59 20.59 17 23.17 17 8.83 19.59 11.41 21 10 16 5 11 10z"
  })), LX || (LX = /* @__PURE__ */ h.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NYe.propTypes = E);
const TYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kX || (kX = /* @__PURE__ */ h.createElement("path", {
    d: "M22 16L24 16 24 8 16 8 16 10 22 10 22 16zM8 24L16 24 16 22 10 22 10 16 8 16 8 24z"
  })), NX || (NX = /* @__PURE__ */ h.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TYe.propTypes = E);
const IYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TX || (TX = /* @__PURE__ */ h.createElement("path", {
    d: "M22 11L20.59 12.41 23.17 15 8.83 15 11.41 12.41 10 11 5 16 10 21 11.41 19.59 8.83 17 23.17 17 20.59 19.59 22 21 27 16 22 11z"
  })), IX || (IX = /* @__PURE__ */ h.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM4,4V28H28V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IYe.propTypes = E);
const OYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OX || (OX = /* @__PURE__ */ h.createElement("path", {
    d: "M6,30H4V2H28l-5.8,9L28,20H6ZM6,18H24.33L19.8,11l4.53-7H6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OYe.propTypes = E);
const RYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RX || (RX = /* @__PURE__ */ h.createElement("path", {
    d: "M6,30H4V2H28l-5.8,9L28,20H6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RYe.propTypes = E);
const VYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VX || (VX = /* @__PURE__ */ h.createElement("path", {
    d: "M24.7976,2,20.3555,8.6641A2.9941,2.9941,0,0,1,17.8594,10H12a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V16H17V28H13V19H11V13a1.0009,1.0009,0,0,1,1-1h5.8594a4.9881,4.9881,0,0,0,4.16-2.2266l4.4422-6.664Z"
  })), HX || (HX = /* @__PURE__ */ h.createElement("path", {
    d: "M11,5a4,4,0,1,1,4,4A4.0042,4.0042,0,0,1,11,5Zm2,0a2,2,0,1,0,2-2A2.0023,2.0023,0,0,0,13,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VYe.propTypes = E);
const HYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BX || (BX = /* @__PURE__ */ h.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HYe.propTypes = E);
const BYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, PX || (PX = /* @__PURE__ */ h.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BYe.propTypes = E);
const PYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, FX || (FX = /* @__PURE__ */ h.createElement("path", {
    d: "M11.13 6.89L11.8 4h8l-2 9H23l-2.49 3.25 1.43 1.43 3.87-5.07a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77L9.46 5.22zM30 28.59l-9.31-9.31h0l-1.42-1.43h0L10.6 9.19h0L8.93 7.52h0L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM9.26 15l.81-3.52L13.59 15zm4.32 10.28L15 16.37 18 19.45z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PYe.propTypes = E);
const FYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zX || (zX = /* @__PURE__ */ h.createElement("path", {
    d: "M30 28.59L3.41 2 2 3.41 8.4 9.82 7 15.77A1 1 0 008 17h4.83L11 28.85a1 1 0 00.6 1.07A1.09 1.09 0 0012 30a1 1 0 00.79-.39l6.68-8.73L28.59 30zM22.53 16.87l3.26-4.26a1 1 0 00.11-1A1 1 0 0025 11H20.25L22 3.22a1 1 0 00-.2-.85A1 1 0 0021 2H11a1 1 0 00-1 .77l-.3 1.3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FYe.propTypes = E);
const zYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WX || (WX = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28a5.3257,5.3257,0,0,1-.6714-.044A21.7855,21.7855,0,0,1,12.0332,17H29.95c.0236-.3315.05-.6626.05-1A14,14,0,1,0,16,30ZM27.9492,15H21.9631A24.3247,24.3247,0,0,0,19.21,4.4492,12.0123,12.0123,0,0,1,27.9492,15ZM16.6714,4.0439A21.7855,21.7855,0,0,1,19.9668,15H12.0332A21.7855,21.7855,0,0,1,15.3286,4.0439,5.159,5.159,0,0,1,16.6714,4.0439ZM12.79,4.4492A24.3275,24.3275,0,0,0,10.0369,15H4.0508A12.0126,12.0126,0,0,1,12.79,4.4492ZM4.0508,17h5.9861A24.3275,24.3275,0,0,0,12.79,27.5508,12.0126,12.0126,0,0,1,4.0508,17Z"
  })), jX || (jX = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M25,25l5,2V25l-5-2.5V20a1,1,0,0,0-2,0v2.5L18,25v2l5-2v3.5L21,30v1l3-1,3,1V30l-2-1.5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zYe.propTypes = E);
const WYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZX || (ZX = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M26,6a2,2,0,0,0-2-2H8A2,2,0,0,0,6,6V26a2,2,0,0,0,2,2h8V26H8V6H24v6h2Z"
  })), UX || (UX = /* @__PURE__ */ h.createElement("path", {
    d: "M10 18H16V20H10zM10 14H22V16H10z"
  })), qX || (qX = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M22 10v2H10V10zM25 23l5 2V23l-5-2.5V18a1 1 0 00-2 0v2.5L18 23v2l5-2v3.5L21 28v1l3-1 3 1V28l-2-1.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WYe.propTypes = E);
const jYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GX || (GX = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M25,23l5,2V23l-5-2.5V18a1,1,0,0,0-2,0v2.5L18,23v2l5-2v3.5L21,28v1l3-1,3,1V28l-2-1.5Z"
  })), QX || (QX = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16V26H6V6h4V8h2V6h8V8h2V6h4v7h2V6A2,2,0,0,0,26,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jYe.propTypes = E);
const ZYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KX || (KX = /* @__PURE__ */ h.createElement("path", {
    d: "M25,11a5.0083,5.0083,0,0,0-4.8989,4H11.8989a5,5,0,1,0,0,2h8.2022A5,5,0,1,0,25,11Zm0,8a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,19Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZYe.propTypes = E);
const UYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YX || (YX = /* @__PURE__ */ h.createElement("path", {
    d: "M29 28a2.8828 2.8828 0 01-1-.1816v-.0059a3.7662 3.7662 0 01-2.0532-2.1338A.971.971 0 0025 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0121 28a3.44 3.44 0 01-3.0532-2.3213A.9894.9894 0 0017 25a1.007 1.007 0 00-.9487.6836A3.4376 3.4376 0 0113 28a3.44 3.44 0 01-3.0532-2.3213 1 1 0 00-1.8955.0049A3.4376 3.4376 0 015 28H2v2H5a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0 5.1433 5.1433 0 002.1379 1.62A4.8374 4.8374 0 0029 30h1V28zM28 13.63L29.7573 15 31 13.4282 16.6123 2.2139a1.0094 1.0094 0 00-1.2427 0L1 13.4194l1.2427 1.5718L4 13.6211v5.1875a3.6907 3.6907 0 01-2 2.0039V22.896a4.9958 4.9958 0 003-1.8833 5.0192 5.0192 0 008 0 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0025 23h5V21H28zm-6.0513 5.0532a1 1 0 00-1.8955-.0049A3.44 3.44 0 0117 21a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0013 18a.9894.9894 0 00-.9468.6787A3.44 3.44 0 019 21a3.37 3.37 0 01-3.0021-2.19L6 12.0615l9.991-7.79L26 12.0718 26.0017 21H25A3.4376 3.4376 0 0121.9487 18.6836z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UYe.propTypes = E);
const qYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, XX || (XX = /* @__PURE__ */ h.createElement("path", {
    d: "M29,28a2.8828,2.8828,0,0,1-1-.1816v-.0059a3.7662,3.7662,0,0,1-2.0532-2.1338A.971.971,0,0,0,25,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,21,28a3.44,3.44,0,0,1-3.0532-2.3213A.9894.9894,0,0,0,17,25a1.007,1.007,0,0,0-.9487.6836A3.4376,3.4376,0,0,1,13,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,5,28H2v2H5a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0,5.1433,5.1433,0,0,0,2.1379,1.62A4.8374,4.8374,0,0,0,29,30h1V28Z"
  })), JX || (JX = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M23.75,11h-1.5V7h1.5ZM23,12a1,1,0,1,0,1,1A1,1,0,0,0,23,12Z"
  })), $X || ($X = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9115,14.9355,23.6284,3.3706a.7181.7181,0,0,0-1.2568,0L16.0885,14.9355A.72.72,0,0,0,16.72,16H29.28A.72.72,0,0,0,29.9115,14.9355ZM22.25,7h1.5v4h-1.5ZM23,14a1,1,0,1,1,1-1A1,1,0,0,1,23,14Z"
  })), eJ || (eJ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,21V18H26v3H25a3.4376,3.4376,0,0,1-3.0513-2.3164,1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,17,21a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,13,18a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,9,21a3.3663,3.3663,0,0,1-3-2.1855v-6.753l10-7.79,2.5327,1.9756.9682-1.7818L16.6123,2.2139a1.0094,1.0094,0,0,0-1.2427,0L1,13.4194l1.2427,1.5718L4,13.6211v5.1875a3.6892,3.6892,0,0,1-2,2.0039V22.896a4.9958,4.9958,0,0,0,3-1.8833,5.0192,5.0192,0,0,0,8,0,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,25,23h5V21Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qYe.propTypes = E);
const GYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tJ || (tJ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h15v-2c0-2.8,2.2-5,5-5v-2c-3.9,0-7,3.1-7,7h-3v-4h-2v4H4V4h8v14h2v-5h4v-2h-4V4 h14v7h-4v2h4v15h-4v2h4c1.1,0,2-0.9,2-2V4C30,2.9,29.1,2,28,2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GYe.propTypes = E);
const QYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nJ || (nJ = /* @__PURE__ */ h.createElement("path", {
    d: "M27,22.14V17a2,2,0,0,0-2-2H17V9.86a4,4,0,1,0-2,0V15H7a2,2,0,0,0-2,2v5.14a4,4,0,1,0,2,0V17H25v5.14a4,4,0,1,0,2,0ZM8,26a2,2,0,1,1-2-2A2,2,0,0,1,8,26ZM14,6a2,2,0,1,1,2,2A2,2,0,0,1,14,6ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QYe.propTypes = E);
const KYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iJ || (iJ = /* @__PURE__ */ h.createElement("path", {
    d: "M28,18H22a2.0023,2.0023,0,0,0-2,2v2H14.4141L10,17.5859V12h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4v6a2.0023,2.0023,0,0,0,2,2H8v5.5859L3.293,22.293a.9994.9994,0,0,0,0,1.414l5,5a.9995.9995,0,0,0,1.414,0L14.4141,24H20v2a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V20A2.0023,2.0023,0,0,0,28,18ZM6,4h6v6H6ZM9,26.5859,5.4141,23,9,19.4141,12.5859,23ZM22,26V20h6v6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KYe.propTypes = E);
const YYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rJ || (rJ = /* @__PURE__ */ h.createElement("path", {
    d: "M20,23H11.86a4.17,4.17,0,0,0-.43-1L22,11.43A3.86,3.86,0,0,0,24,12a4,4,0,1,0-3.86-5H11.86a4,4,0,1,0,0,2h8.28a4.17,4.17,0,0,0,.43,1L10,20.57A3.86,3.86,0,0,0,8,20a4,4,0,1,0,3.86,5H20v3h8V20H20ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10ZM24,6a2,2,0,1,1-2,2A2,2,0,0,1,24,6ZM8,26a2,2,0,1,1,2-2A2,2,0,0,1,8,26Zm14-4h4v4H22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YYe.propTypes = E);
const XYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sJ || (sJ = /* @__PURE__ */ h.createElement("path", {
    d: "M10 10H2V2h8zM4 8H8V4H4zM30 30H22V22h8zm-6-2h4V24H24zM20 27H8A6 6 0 018 15v2a4 4 0 000 8H20zM24 17V15a4 4 0 000-8H12V5H24a6 6 0 010 12z"
  })), oJ || (oJ = /* @__PURE__ */ h.createElement("path", {
    d: "M19,11H13l-3,4,6,6,6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XYe.propTypes = E);
var aJ, lJ, cJ, hJ, dJ, uJ, fJ, pJ, gJ, mJ, AJ, wJ, vJ, bJ, yJ, CJ, EJ, _J, xJ, SJ, MJ, DJ, LJ, kJ, NJ, TJ, IJ, OJ, RJ, VJ, HJ, BJ, PJ, FJ, zJ, WJ, jJ, ZJ, UJ, qJ, GJ, QJ, KJ, YJ, XJ, JJ, $J, e$, t$, n$, i$, r$, s$, o$, a$, l$, c$, h$, d$, u$, f$, p$, g$, m$, A$, w$, v$, b$, y$, C$, E$, _$, x$, S$, M$, D$, L$, k$, N$, T$, I$, O$, R$, V$, H$, B$, P$, F$, z$, W$, j$, Z$, U$, q$, G$, Q$, K$, Y$, X$, J$, $$, eee, tee, nee, iee, ree, see, oee, aee, lee, cee, hee, dee, uee, fee, pee, gee, mee, Aee, wee, vee, bee, yee, Cee, Eee, _ee, xee, See, Mee, Dee, Lee, kee, Nee, Tee, Iee, Oee, Ree, Vee, Hee, Bee, Pee, Fee, zee, Wee, jee, Zee, Uee, qee, Gee, Qee, Kee, Yee, Xee, Jee, $ee, ete, tte, nte, ite, rte, ste, ote, ate, lte, cte, hte, dte, ute, fte, pte, gte, mte, Ate, wte, vte, bte, yte, Cte, Ete, _te, xte, Ste, Mte, Dte, Lte, kte, Nte, Tte, Ite, Ote, Rte, Vte, Hte, Bte, Pte, Fte, zte, Wte, jte, Zte, Ute, qte, Gte, Qte, Kte, Yte, Xte, Jte, $te, ene, tne, nne, ine, rne, sne, one, ane, lne, cne, hne, dne, une, fne, pne, gne, mne, Ane, wne, vne, bne, yne, Cne, Ene, _ne, xne, Sne, Mne, Dne, Lne, kne, Nne, Tne, Ine, One, Rne, Vne, Hne, Bne, Pne, Fne, zne, Wne, jne, Zne, Une, qne, Gne, Qne, Kne, Yne, Xne, Jne, $ne, eie, tie, nie, iie, rie, sie, oie;
const C8 = {}, JYe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aJ || (aJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), lJ || (lJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JYe.propTypes = E);
const $Ye = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cJ || (cJ = /* @__PURE__ */ h.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), hJ || (hJ = /* @__PURE__ */ h.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), dJ || (dJ = /* @__PURE__ */ h.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), uJ || (uJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Ye.propTypes = E);
const eXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fJ || (fJ = /* @__PURE__ */ h.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), pJ || (pJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eXe.propTypes = E);
const tXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gJ || (gJ = /* @__PURE__ */ h.createElement("path", {
    d: "M21.5,31c-5.24,0-9.5-4.26-9.5-9.5s4.26-9.5,9.5-9.5,9.5,4.26,9.5,9.5c0,1.74-.47,3.43-1.36,4.91.1.52.65,1.9,1.26,3.15.19.38.11.84-.19,1.14s-.76.38-1.14.2c-1.27-.61-2.68-1.15-3.2-1.24-1.47.88-3.15,1.34-4.87,1.34ZM26.56,29.54h0ZM21.5,14c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5c1.42,0,2.8-.4,4-1.15.26-.17.7-.44,2.57.23-.69-1.84-.42-2.26-.24-2.54.77-1.2,1.18-2.6,1.18-4.04,0-4.14-3.36-7.5-7.5-7.5h-.01ZM29.51,26.61h0ZM23.63,21c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1ZM18.63,21c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1ZM24.58,23c-.63.62-1.5,1-2.45,1s-1.82-.38-2.45-1l-1.4,1.43c.99.97,2.35,1.57,3.85,1.57s2.85-.6,3.85-1.57l-1.4-1.43ZM10,28h-5.38L16,5.23l2.61,5.21,1.79-.89-3.5-7c-.34-.68-1.45-.68-1.79,0L2.1,28.55c-.16.31-.14.68.04.97.18.29.5.47.85.47h7v-2l.01.01Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tXe.propTypes = E);
const nXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mJ || (mJ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,28H6c-1.1,0-2-.9-2-2V6c0-1.1.9-2,2-2h22v2H6v20h20V8h2v18c0,1.1-.9,2-2,2ZM15,10h-5v5h5v-5ZM22,10h-5v5h5v-5ZM15,17h-5v5h5v-5ZM22,17h-5v5h5v-5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nXe.propTypes = E);
const iXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AJ || (AJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30c-7.72,0-14-6.28-14-14S8.28,2,16,2s14,6.28,14,14c0,2.62-.73,5.18-2.11,7.39.05.74,1.05,3.21,2.01,5.17.19.38.11.84-.19,1.14-.3.3-.76.38-1.14.2-1.99-.96-4.5-1.94-5.24-1.97-2.2,1.35-4.73,2.07-7.33,2.07ZM16,4c-6.62,0-12,5.38-12,12s5.38,12,12,12c2.27,0,4.48-.64,6.39-1.84.32-.21,1.01-.63,4.58.84-1.5-3.54-1.07-4.22-.87-4.54,1.23-1.93,1.89-4.16,1.89-6.46,0-6.62-5.38-12-12-12h.01ZM23.83,20.87l-1.67-1.11c-.37.56-.85,1.03-1.4,1.4-2.3,1.53-5.4.9-6.93-1.4l-1.67,1.11c1.3,1.96,3.49,3.13,5.83,3.13,2.35,0,4.54-1.17,5.83-3.13h.01ZM22,13c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c.01-1.09-.87-1.99-1.96-2h-.04ZM14,13c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c.01-1.09-.87-1.99-1.96-2h-.04Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iXe.propTypes = E);
const rXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wJ || (wJ = /* @__PURE__ */ h.createElement("path", {
    d: "M27,24c-1.302,0-2.4016.8389-2.8157,2h-2.5662l-1.5579-3.1157c2.3552-1.3921,3.9397-3.9502,3.9397-6.8843s-1.5845-5.4922-3.9397-6.8843l1.5576-3.1157h2.5664c.4141,1.1611,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8389-2.8157,2h-2.5664c-.7622,0-1.4475.4238-1.7888,1.1055l-1.6069,3.2139c-.7063-.2041-1.4502-.3193-2.2222-.3193s-1.5159.1152-2.2222.3193l-1.6072-3.2139c-.3411-.6816-1.0264-1.1055-1.7886-1.1055h-2.5664c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h2.5662l1.5579,3.1157c-2.3552,1.3921-3.9397,3.9502-3.9397,6.8843s1.5845,5.4922,3.9397,6.8843l-1.5576,3.1157h-2.5664c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h2.5664c.7622,0,1.4475-.4238,1.7888-1.1055l1.6069-3.2139c.7063.2041,1.4502.3193,2.2222.3193s1.5159-.1152,2.2222-.3193l1.6072,3.2139c.3411.6816,1.0264,1.1055,1.7886,1.1055h2.5664c.4141,1.1611,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3ZM27,4c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1ZM5,6c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM5,28c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM10.2856,16c0-3.1509,2.5635-5.7144,5.7144-5.7144s5.7144,2.5635,5.7144,5.7144-2.5635,5.7144-5.7144,5.7144-5.7144-2.5635-5.7144-5.7144ZM27,28c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM18.5901,12.5566l1.4099,1.4434-5,5-3-3,1.4441-1.4438,1.5605,1.6221,3.5854-3.6216Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rXe.propTypes = E);
const sXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vJ || (vJ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,16.44c0,4.96-4.68,7.7-8.45,9.9-.54.32-1.07.62-1.55.92-.49-.3-1.01-.61-1.55-.92-3.76-2.2-8.45-4.94-8.45-9.9V4h21v-2H6c-1.1,0-2,.9-2,2v12.44c0,6.11,5.45,9.3,9.44,11.63.72.42,1.41.82,2.02,1.22l.54.35.54-.35c.61-.39,1.3-.79,2.02-1.22,3.98-2.33,9.44-5.52,9.44-11.63v-3.62c1.16-.41,2-1.51,2-2.82,0-1.65-1.35-3-3-3s-3,1.35-3,3c0,1.3.84,2.4,2,2.82v3.62ZM27,11c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM21,9h-8v-2h8v2ZM21,21h-8v-2h8v2ZM15,13h8v1.99h-8v-1.99ZM9.71,17.71l-1.41-1.41,2.29-2.29-2.29-2.29,1.41-1.41,3.71,3.71-3.71,3.71v-.02Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sXe.propTypes = E);
const oXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bJ || (bJ = /* @__PURE__ */ h.createElement("path", {
    d: "M10,18h8v2h-8v-2ZM28,12.82v3.62c0,6.11-5.45,9.3-9.44,11.63-.72.42-1.41.82-2.02,1.22l-.54.35-.54-.35c-.61-.39-1.3-.79-2.02-1.22-3.98-2.33-9.44-5.52-9.44-11.63V4c0-1.1.9-2,2-2h21v2H6v9h6v2h-6v1.44c0,4.96,4.68,7.7,8.45,9.9.54.32,1.07.62,1.55.92.49-.3,1.01-.61,1.55-.92,2.75-1.6,5.97-3.5,7.52-6.33h-5.08v-2h5.83c.11-.5.17-1.01.17-1.56v-3.62c-1.16-.41-2-1.51-2-2.82,0-1.65,1.35-3,3-3s3,1.35,3,3c0,1.3-.84,2.4-2,2.82l.01-.01ZM28,10c0-.55-.45-1-1-1s-1,.45-1,1,.45,1,1,1,1-.45,1-1ZM22,13h-8v2h8v-2ZM18,8h-8v2h8v-2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oXe.propTypes = E);
const aXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yJ || (yJ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,16.44c0,4.96-4.68,7.7-8.45,9.9-.54.32-1.07.62-1.55.92-.49-.3-1.01-.61-1.55-.92-3.76-2.2-8.45-4.94-8.45-9.9V4h21v-2H6c-1.1,0-2,.9-2,2v12.44c0,6.11,5.45,9.3,9.44,11.63.72.42,1.41.82,2.02,1.22l.54.35.54-.35c.61-.39,1.3-.79,2.02-1.22,3.98-2.33,9.44-5.52,9.44-11.63v-3.62c1.16-.41,2-1.51,2-2.82,0-1.65-1.35-3-3-3s-3,1.35-3,3c0,1.3.84,2.4,2,2.82v3.62ZM27,11c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM16,18c-1.48,0-2.77-.8-3.46-2l1.73-1c.35.6.99,1,1.73,1,1.1,0,2-.9,2-2s-.9-2-2-2v-2c2.21,0,4,1.79,4,4s-1.79,4-4,4ZM16,22c-.68,0-1.38-.09-2.07-.27-4.26-1.14-6.8-5.54-5.66-9.8,1.14-4.26,5.54-6.8,9.8-5.66l-.52,1.93c-3.2-.86-6.49,1.05-7.35,4.24-.86,3.2,1.05,6.49,4.24,7.35,3.19.86,6.49-1.05,7.35-4.24l1.93.52c-.96,3.57-4.2,5.93-7.73,5.93h.01Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aXe.propTypes = E);
const lXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, CJ || (CJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lXe.propTypes = E);
const cXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, EJ || (EJ = /* @__PURE__ */ h.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _J || (_J = /* @__PURE__ */ h.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cXe.propTypes = E);
const hXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (C8.IbmWatsonAssistant || (C8.IbmWatsonAssistant = !0, console.warn("Icon renamed and replaced by ibm-watsonx--assistant to correspond with the new watsonx platform and product suite. As a result, the IbmWatsonAssistant component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xJ || (xJ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 2H18c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H18V4h10v6h-3v2h3c1.1 0 2-.9 2-2V4C30 2.9 29.1 2 28 2zM14.7 31L13 30l3.5-6H22c1.1 0 2-.9 2-2v-5h2v5c0 2.2-1.8 4-4 4h-4.4L14.7 31z"
  })), SJ || (SJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), MJ || (MJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), DJ || (DJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), LJ || (LJ = /* @__PURE__ */ h.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hXe.propTypes = E);
const dXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kJ || (kJ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 17H14V19H6z"
  })), NJ || (NJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), TJ || (TJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), IJ || (IJ = /* @__PURE__ */ h.createElement("path", {
    d: "M2 13H10V15H2zM6 9H14V11H6z"
  })), OJ || (OJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), RJ || (RJ = /* @__PURE__ */ h.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4 c5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dXe.propTypes = E);
const uXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (C8.IbmWatsonKnowledgeCatalog || (C8.IbmWatsonKnowledgeCatalog = !0, console.warn("Icon renamed, slightly redesigned and replaced by ibm--knowledge-catalog. As a result, the IbmWatsonKnowledgeCatalog component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, VJ || (VJ = /* @__PURE__ */ h.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6zM12 18H20V20H12zM12 13H20V15H12zM12 8H20V10H12z"
  })), HJ || (HJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4 c0,1.1,0.9,2,2,2h10V28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uXe.propTypes = E);
const fXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, BJ || (BJ = /* @__PURE__ */ h.createElement("path", {
    d: "M20 25H27V27H20zM22 29H25V31H22zM27 23h-2c0-1.1.4-2 1.2-2.8l.5-.5c.8-.8 1.3-2 1.3-3.2 0-2.5-2-4.5-4.5-4.5S19 14 19 16.5c0 1.2.5 2.3 1.3 3.2l.5.5C21.6 21 22 21.9 22 23h-2c0-.5-.2-1-.6-1.4l-.5-.5c-1.2-1.2-1.9-2.9-1.9-4.6 0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5c0 1.7-.7 3.4-1.9 4.6l-.5.5C27.2 22 27 22.5 27 23zM6 22H14V24H6z"
  })), PJ || (PJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), FJ || (FJ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 18H9V20H6zM6 14H13V16H6zM10 10H17V12H10z"
  })), zJ || (zJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), WJ || (WJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 6H20V8H16z"
  })), jJ || (jJ = /* @__PURE__ */ h.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), ZJ || (ZJ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 6H10V8H6z"
  })), UJ || (UJ = /* @__PURE__ */ h.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fXe.propTypes = E);
const pXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qJ || (qJ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 28h-3c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h3V28zM28 30h2.2l-4.6-11h-2.2l-4.6 11H21l.8-2h5.3L28 30zM22.7 26l1.8-4.4 1.8 4.4H22.7zM28 15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9 0 7 3.1 7 7V15zM14 5V3H9V1H7v2H2v2h8.2C10 5.9 9.4 7.5 8 9 7.4 8.3 6.9 7.6 6.6 7H4.3c.4 1 1.1 2.2 2.1 3.3C5.6 11 4.4 11.6 3 12.1L3.7 14c1.8-.7 3.2-1.5 4.3-2.3 1.1.9 2.5 1.7 4.3 2.3l.7-1.9c-1.4-.5-2.6-1.2-3.5-1.8 1.9-2 2.5-4.1 2.7-5.3H14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pXe.propTypes = E);
const gXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GJ || (GJ = /* @__PURE__ */ h.createElement("path", {
    d: "M3.6 22.5c-1-2-1.6-4.2-1.6-6.5C2 8.3 8.3 2 16 2v2C9.4 4 4 9.4 4 16c0 2 .5 3.8 1.4 5.5L3.6 22.5zM28 16c0 6.6-5.4 12-12 12-2.9 0-5.6-1-7.7-2.8l5.7-5.7L12.6 18l-6.5 6.5c-.4.4-.4 1 0 1.4C8.7 28.5 12.3 30 16 30c7.7 0 14-6.3 14-14H28z"
  })), QJ || (QJ = /* @__PURE__ */ h.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2 c0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7 c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5 c0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gXe.propTypes = E);
const mXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KJ || (KJ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h1v4h-3v2h8v-2h-3v-4H28zM24 4h4v6h-4V4zM21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26zM12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16zM10 12V4c0-1.1-.9-2-2-2H3v2h5v2H4C2.9 6 2 6.9 2 8v2c0 1.1.9 2 2 2h1v4H2v2h8v-2H7v-4H10zM4 8h4v2H4V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mXe.propTypes = E);
const AXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, YJ || (YJ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 23H11V25H6zM6 19H11V21H6z"
  })), XJ || (XJ = /* @__PURE__ */ h.createElement("path", {
    d: "M13 30H4c-1.1 0-2-.9-2-2V17c0-1.1.9-2 2-2h9c1.1 0 2 .9 2 2v11C15 29.1 14.1 30 13 30zM4 17v11h9V17H4zM19 2H27V4H19zM22 6H30V8H22zM22 10H30V12H22zM19 14H27V16H19zM22 18H30V20H22zM12 1l-1.4 1.4L13.2 5H4C2.9 5 2 5.9 2 7v5h2V7h9.2l-2.6 2.6L12 11l5-5L12 1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AXe.propTypes = E);
const wXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, JJ || (JJ = /* @__PURE__ */ h.createElement("path", {
    d: "M4 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S5.7 28 4 28zM4 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S4.6 24 4 24zM28 28c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S29.7 28 28 28zM28 24c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S28.6 24 28 24zM22.4 4.4l-.9 1.8C26.1 8.4 29 13 29 18c0 .7-.1 1.4-.2 2.1l2 .3c.1-.8.2-1.6.2-2.5C31 12.2 27.6 6.9 22.4 4.4zM16 7c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S17.7 7 16 7zM16 3c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1S16.6 3 16 3z"
  })), $J || ($J = /* @__PURE__ */ h.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30 c0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wXe.propTypes = E);
const vXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, e$ || (e$ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9 0 7 3.1 7 7V13zM22 20H25V22H22zM22 24H25V26H22z"
  })), t$ || (t$ = /* @__PURE__ */ h.createElement("path", {
    d: "M27 30h-5v-2h5V18h-7v9c0 1.7-1.3 3-3 3s-3-1.3-3-3v-3h2v3c0 .6.4 1 1 1s1-.4 1-1V16h11v12C29 29.1 28.1 30 27 30zM12 28h-1c-3.9 0-7-3.1-7-7v-4h2v4c0 2.8 2.2 5 5 5h1V28zM11 10v2h3c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4C2.9 2 2 2.9 2 4v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4V4h10v6H11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vXe.propTypes = E);
const bXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n$ || (n$ = /* @__PURE__ */ h.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24 c-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1 c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), i$ || (i$ = /* @__PURE__ */ h.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bXe.propTypes = E);
const yXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, r$ || (r$ = /* @__PURE__ */ h.createElement("path", {
    d: "M14 18H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h2.4l1.7 3 1.7-1-2.3-4H4v-6h10v6h-3v2h3c1.1 0 2-.9 2-2v-6C16 18.9 15.1 18 14 18zM19 26h2c3.9 0 7-3.1 7-7v-2h-2v2c0 2.8-2.2 5-5 5h-2V26zM18 11H24V13H18zM18 7H30V9H18zM18 3H30V5H18zM4 14h2v-2c0-2.8 2.2-5 5-5h4V5h-4c-3.9 0-7 3.1-7 7V14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yXe.propTypes = E);
const CXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, s$ || (s$ = /* @__PURE__ */ h.createElement("path", {
    d: "M25 21c-2.8 0-5-2.2-5-5s2.2-5 5-5 5 2.2 5 5S27.8 21 25 21zM25 13c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3S26.7 13 25 13zM14 11V6c0-1.1-.9-2-2-2h-2v2h2v5c0 2.1 1.1 3.9 2.7 5-1.6 1.1-2.7 2.9-2.7 5v5h-2v2h2c1.1 0 2-.9 2-2v-5c0-2.2 1.8-4 4-4v-2C15.8 15 14 13.2 14 11zM2 30v-6h6v6H2zM4 26v2h2v-2H4zM2 19v-6h6v6H2zM4 15v2h2v-2H4zM2 8V2h6v6H2zM4 4v2h2V4H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CXe.propTypes = E);
const EXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o$ || (o$ = /* @__PURE__ */ h.createElement("path", {
    d: "M13 26h-2c-3.9 0-7-3.1-7-7v-2h2v2c0 2.8 2.2 5 5 5h2V26zM18 18h10c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-2.4l-1.7 3-1.7-1 2.3-4H28v-6H18v6h3v2h-3c-1.1 0-2-.9-2-2v-6C16 18.9 16.9 18 18 18zM28 14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9 0 7 3.1 7 7V14zM2 11H8V13H2zM2 7H14V9H2zM2 3H14V5H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EXe.propTypes = E);
const _Xe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, a$ || (a$ = /* @__PURE__ */ h.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), l$ || (l$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), c$ || (c$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), h$ || (h$ = /* @__PURE__ */ h.createElement("path", {
    d: "M15 0l13 0c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2h-3.5l-1.7 3L21 16l2.3-4H28V2H15v10h5v2h-5c-1.1 0-2-.9-2-2V2C13 .9 13.9 0 15 0zM20 19v6c0 .6-.4 1-1 1h-5v2h5c1.7 0 3-1.3 3-3v-6H20zM15.4 20.4c-.8 1-2.1 1.6-3.4 1.6s-2.6-.6-3.4-1.6L7 21.6c1.2 1.4 3 2.4 5 2.4s3.8-.9 5-2.4L15.4 20.4z"
  })), d$ || (d$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), u$ || (u$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), f$ || (f$ = /* @__PURE__ */ h.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Xe.propTypes = E);
const xXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, p$ || (p$ = /* @__PURE__ */ h.createElement("path", {
    d: "M28 2h-10c-1.1035 0-2 .8965-2 2v6c0 1.1035.8965 2 2 2h2.4229s1.7314 3 1.7314 3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0 2 0 2h3c1.1035 0 2-.8965 2-2V4c0-1.1035-.8965-2-2-2zM14.6904 31l-1.7324-1 3.4648-6h5.5771c1.1046 0 2-.8954 2-2v-5h2v5c0 2.2091-1.7909 4-4 4h-4.4229l-2.8867 5z"
  })), g$ || (g$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), m$ || (m$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), A$ || (A$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), w$ || (w$ = /* @__PURE__ */ h.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xXe.propTypes = E);
const SXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, v$ || (v$ = /* @__PURE__ */ h.createElement("path", {
    d: "M11 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26zM22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31zM16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26zM30 19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866 0 7 3.134 7 7v7z"
  })), b$ || (b$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), y$ || (y$ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 3H16V5H6z"
  })), C$ || (C$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), E$ || (E$ = /* @__PURE__ */ h.createElement("path", {
    d: "M6 11H16V13H6zM2 15H12V17H2z"
  })), _$ || (_$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), x$ || (x$ = /* @__PURE__ */ h.createElement("path", {
    d: "M2 7H12V9H2z"
  })), S$ || (S$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), n);
});
process.env.NODE_ENV !== "production" && (SXe.propTypes = E);
const MXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, M$ || (M$ = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9916 19h-2v-7c0-2.7614-2.2386-5-5-5h-8.9948v-2h8.9948c3.866 0 7 3.134 7 7v7zM11.9916 28h-3c-3.86 0-7-3.14-7-7v-5h2v5c0 2.757 2.243 5 5 5h3v2zM9.9916 14h-4c-1.103 0-2-.897-2-2v-2h2v2h4V2h2v10c0 1.103-.897 2-2 2zM28.15 26l-2.58 2.58 1.41 1.42 4-4-4-4-1.42 1.41 2.59 2.59zM16.81 26l2.58-2.58-1.41-1.42-4 4 4 4 1.42-1.41-2.59-2.59zM21.98 31l-1.915-.577 2.915-9.423 1.915.577-2.915 9.423z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MXe.propTypes = E);
const DXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D$ || (D$ = /* @__PURE__ */ h.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25zM23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30zM17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25zM18 19h-2V5c0-1.1028.8972-2 2-2h9c1.1028 0 2 .8972 2 2v11h-2V5h-9v14zM12 3H3c-1.1028 0-2 .8975-2 2v22c0 1.1025.8972 2 2 2h9c1.1028 0 2-.8975 2-2V5c0-1.1025-.8972-2-2-2zm.0002 7.0366l-6.925-5.0366h6.9248l.0002 5.0366zm-.7004 1.9634l-8.2998 6.0361V5.9639l8.2998 6.0361zm.7007 1.9634l.0007 11.8169-8.2795-5.7959 8.2788-6.021zm-9.0005 7.9575l7.2563 5.0791H3v-5.0791zm9 5.0791l.0012-.002v.002h-.0012z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DXe.propTypes = E);
const LXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, L$ || (L$ = /* @__PURE__ */ h.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16zM15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21zM9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), k$ || (k$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), N$ || (N$ = /* @__PURE__ */ h.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), T$ || (T$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), I$ || (I$ = /* @__PURE__ */ h.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LXe.propTypes = E);
const kXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, O$ || (O$ = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2c-7.73,0-14,6.2821-14,14.0269,0,5.0697,2.69,9.5082,6.71,11.9731l1.1-1.6632c-3.48-2.104-5.81-5.9314-5.81-10.3098,0-6.6428,5.37-12.0231,12-12.0231s12,5.396,12,12.0388h2c0-7.7449-6.27-14.0426-14-14.0426ZM14,21.414l-5-5.001,1.413-1.413,3.587,3.586,7.585-7.586,1.415,1.415-9,8.999ZM26.58,24.41l1.42-1.41,4,4-4,4-1.41-1.42,2.58-2.58-2.59-2.59ZM22.5,32l-1.9149-.5771,2.9149-9.4229,1.9149.5771-2.9149,9.4229ZM19.42,29.59l-1.42,1.41-4-4,4-4,1.41,1.42-2.58,2.58,2.59,2.59Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kXe.propTypes = E);
const NXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, R$ || (R$ = /* @__PURE__ */ h.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), V$ || (V$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), H$ || (H$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), B$ || (B$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), P$ || (P$ = /* @__PURE__ */ h.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NXe.propTypes = E);
const TXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, F$ || (F$ = /* @__PURE__ */ h.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2 s-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7 C15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), z$ || (z$ = /* @__PURE__ */ h.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19 c0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137 c0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), W$ || (W$ = /* @__PURE__ */ h.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2 C24,18.262,23.595,17.624,23,17.277z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TXe.propTypes = E);
const IXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, j$ || (j$ = /* @__PURE__ */ h.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), Z$ || (Z$ = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5 26c1.3807 0 2.5-1.1193 2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217 0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141 1.4141 4.8837 4.8837c-.1107.2825-.1766.5876-.1766.9093 0 1.3807 1.1193 2.5 2.5 2.5zM29 13h-2v-3.4257l-11-6.4166-3 1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12 7c.3071.1792.4961.5081.4961.8638v4zM7 6H9V16H7z"
  })), U$ || (U$ = /* @__PURE__ */ h.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IXe.propTypes = E);
const OXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, q$ || (q$ = /* @__PURE__ */ h.createElement("path", {
    d: "M29,13h-2v-3.4257l-11-6.4166-3,1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12,7c.3071.1792.4961.5081.4961.8638v4ZM7,16h2V6h-2v10ZM15,28.2718l-10.0013-5.8403v-13.4315h-1.9987v14.006c0,.3559.1889.6849.4958.8642l10.4971,6.1298,1.0072-1.7282h-.0001ZM26,17l-1.4141,1.4141,3.5854,3.5859-3.5854,3.5859,1.4141,1.4141,5-5-5-5ZM15,22l5,5,1.4141-1.4141-3.5854-3.5859,3.5854-3.5859-1.4141-1.4141-5,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OXe.propTypes = E);
const RXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, G$ || (G$ = /* @__PURE__ */ h.createElement("path", {
    d: "M25 25H27V29H25zM21 23H23V29H21zM29 20H31V29H29z"
  })), Q$ || (Q$ = /* @__PURE__ */ h.createElement("path", {
    d: "M30 17V5c0-1.1046-.8954-2-2-2h-9c-1.1046 0-2 .8954-2 2v24h2V5h9v12h2zM13 3H4c-1.1046 0-2 .8954-2 2v22c0 1.1046.8954 2 2 2h9c1.1046 0 2-.8954 2-2V5c0-1.1046-.8954-2-2-2zm-9 2.9635l8.2998 6.0365-8.2998 6.0365V5.9635zm0 21.0365v-5.0366l6.9253 5.0366h-6.9253zm9-.9635l-8.2998-6.0365 8.2998-6.0365v12.073zm0-15.9999l-6.9253-5.0366h6.9253v5.0366z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RXe.propTypes = E);
const VXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, K$ || (K$ = /* @__PURE__ */ h.createElement("path", {
    d: "M10 17H14V21H10zM17 10H21V14H17zM17 17H21V21H17z"
  })), Y$ || (Y$ = /* @__PURE__ */ h.createElement("path", {
    d: "M19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VXe.propTypes = E);
const HXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, X$ || (X$ = /* @__PURE__ */ h.createElement("path", {
    d: "M16 32c-5.0793 0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736 3.5585 6.7561 5.5994 11.2007 5.5994s8.5281-2.0413 11.2014-5.6005l1.5991 1.2012c-3.0547 4.0668-7.7202 6.3993-12.8005 6.3993zM30 22h-5v-2h5v-3h-3c-1.1028 0-2-.8972-2-2v-3c0-1.1028.8972-2 2-2h5v2h-5v3h3c1.1028 0 2 .8972 2 2v3c0 1.1028-.8972 2-2 2zM21 22h-4c-1.1028 0-2-.8972-2-2v-8c0-1.1028.8972-2 2-2h4c1.1028 0 2 .8972 2 2v8c0 1.1028-.8972 2-2 2zm-4-10v8h4v-8h-4zM11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10zM6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22zM16.0001 0C10.9207 0 6.2552 2.3319 3.2003 6.3979l1.5991 1.2014c2.6736-3.5585 6.7561-5.5994 11.2007-5.5994s8.5281 2.0413 11.2014 5.6005l1.5991-1.2012C25.7459 2.3325 21.0804 0 16.0001 0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HXe.propTypes = E);
const BXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, J$ || (J$ = /* @__PURE__ */ h.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), $$ || ($$ = /* @__PURE__ */ h.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), eee || (eee = /* @__PURE__ */ h.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), tee || (tee = /* @__PURE__ */ h.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), nee || (nee = /* @__PURE__ */ h.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), iee || (iee = /* @__PURE__ */ h.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), ree || (ree = /* @__PURE__ */ h.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), see || (see = /* @__PURE__ */ h.createElement("path", {
    d: "M0 10H5V12H0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BXe.propTypes = E);
const PXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, oee || (oee = /* @__PURE__ */ h.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), aee || (aee = /* @__PURE__ */ h.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PXe.propTypes = E);
const FXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lee || (lee = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9v10.172l-2.586-2.586L11 18l5 5 5-5-1.414-1.414L17 19.172V9H15zM19.758 26.65L16 28.842 5 22.426V18H3v5c0 .355.189.685.496.864l12 7C15.652 30.955 15.826 31 16 31s.348-.045.504-.136l4.282-2.498L19.758 26.65zM28.504 8.136l-4.269-2.49-1.029 1.715L27 9.574v12.852l-3.787 2.209 1.029 1.715 4.262-2.486C28.811 23.685 29 23.355 29 23V9C29 8.645 28.811 8.315 28.504 8.136zM5 9.574l11-6.417 3.751 2.188L20.78 3.63l-4.276-2.494C16.348 1.045 16.174 1 16 1s-.348.045-.504.136l-12 7C3.189 8.315 3 8.645 3 9v5h2V9.574z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FXe.propTypes = E);
const zXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cee || (cee = /* @__PURE__ */ h.createElement("path", {
    d: "M22 24H10a2.0023 2.0023 0 01-2-2V10a2.0023 2.0023 0 012-2H22a2.0023 2.0023 0 012 2V22A2.0023 2.0023 0 0122 24zM10 10V22H22V10zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM2 21L2 30 11 30 11 28 4 28 4 21 2 21zM30 11L30 2 21 2 21 4 28 4 28 11 30 11zM21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zXe.propTypes = E);
const WXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hee || (hee = /* @__PURE__ */ h.createElement("path", {
    d: "M4 2A2 2 0 002 4V20l1 2 1-2V4H8V14l1 2 1-2V2zM28 2H14v8l1 2 1-2V4h2V17l1 2 1-2V4h4V14l1 2 1-2V4h2V24l1 2 1-2V4A2 2 0 0028 2zM14 28L13 30 12 28 12 16 14 16 14 28z"
  })), dee || (dee = /* @__PURE__ */ h.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26zM8 24L7 26 6 24 6 18 8 18 8 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WXe.propTypes = E);
const jXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uee || (uee = /* @__PURE__ */ h.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14zM17 14H13a2 2 0 00-2 2v4l1 2 1-2V16h2v7l1 2 1-2z"
  })), fee || (fee = /* @__PURE__ */ h.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jXe.propTypes = E);
const ZXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pee || (pee = /* @__PURE__ */ h.createElement("path", {
    d: "M10 9H12V11H10zM18 23H14V9h4a4 4 0 014 4v6A4 4 0 0118 23zm-2-2h2a2 2 0 002-2V13a2 2 0 00-2-2H16zM10 13H12V23H10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZXe.propTypes = E);
const UXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gee || (gee = /* @__PURE__ */ h.createElement("path", {
    d: "M15 20H9a3 3 0 00-3 3v2H8V23a1 1 0 011-1h6a1 1 0 011 1v2h2V23A3 3 0 0015 20zM12 19a4 4 0 10-4-4A4 4 0 0012 19zm0-6a2 2 0 11-2 2A2 2 0 0112 13z"
  })), mee || (mee = /* @__PURE__ */ h.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), Aee || (Aee = /* @__PURE__ */ h.createElement("path", {
    d: "M20 19H26V21H20zM22 23H26V25H22zM32 10V8H29.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0026 4.1011V2H24V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0020.1011 8H18v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0024 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0029.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0125 12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UXe.propTypes = E);
const qXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wee || (wee = /* @__PURE__ */ h.createElement("path", {
    d: "M11 24H21V26H11zM13 28H19V30H13zM16 2A10 10 0 006 12a9.19 9.19 0 003.46 7.62c1 .93 1.54 1.46 1.54 2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2 7.2 0 018 12a8 8 0 0116 0 7.2 7.2 0 01-2.82 6.14c-1.07 1-2.18 2-2.18 3.86h2c0-.92.53-1.45 1.54-2.39A9.18 9.18 0 0026 12 10 10 0 0016 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qXe.propTypes = E);
const GXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vee || (vee = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), bee || (bee = /* @__PURE__ */ h.createElement("path", {
    d: "M6 10H13V12H6zM6 14H10V16H6zM23 18H17a3 3 0 00-3 3v2h2V21a1 1 0 011-1h6a1 1 0 011 1v2h2V21A3 3 0 0023 18zM20 17a4 4 0 10-4-4A4 4 0 0020 17zm0-6a2 2 0 11-2 2A2 2 0 0120 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GXe.propTypes = E);
const QXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yee || (yee = /* @__PURE__ */ h.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), Cee || (Cee = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QXe.propTypes = E);
const KXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Eee || (Eee = /* @__PURE__ */ h.createElement("path", {
    d: "M4 22H2V4A2.0023 2.0023 0 014 2H22V4H4zM21 17a3 3 0 10-3-3A3.0033 3.0033 0 0021 17zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0121 13z"
  })), _ee || (_ee = /* @__PURE__ */ h.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KXe.propTypes = E);
const YXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xee || (xee = /* @__PURE__ */ h.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), See || (See = /* @__PURE__ */ h.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YXe.propTypes = E);
const XXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mee || (Mee = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM19 14a3 3 0 10-3-3A3 3 0 0019 14zm0-4a1 1 0 11-1 1A1 1 0 0119 10z"
  })), Dee || (Dee = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XXe.propTypes = E);
const JXe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lee || (Lee = /* @__PURE__ */ h.createElement("path", {
    d: "M24 14a5.99 5.99 0 00-4.885 9.4712L14 28.5859 15.4141 30l5.1147-5.1147A5.9971 5.9971 0 1024 14zm0 10a4 4 0 114-4A4.0045 4.0045 0 0124 24zM17 12a3 3 0 10-3-3A3.0033 3.0033 0 0017 12zm0-4a1 1 0 11-1 1A1.0009 1.0009 0 0117 8z"
  })), kee || (kee = /* @__PURE__ */ h.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JXe.propTypes = E);
const $Xe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nee || (Nee = /* @__PURE__ */ h.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), Tee || (Tee = /* @__PURE__ */ h.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Xe.propTypes = E);
const eJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Iee || (Iee = /* @__PURE__ */ h.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), Oee || (Oee = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eJe.propTypes = E);
const tJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ree || (Ree = /* @__PURE__ */ h.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), Vee || (Vee = /* @__PURE__ */ h.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4 C7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10 c0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tJe.propTypes = E);
const nJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hee || (Hee = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), Bee || (Bee = /* @__PURE__ */ h.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17 z"
  })), Pee || (Pee = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nJe.propTypes = E);
const iJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fee || (Fee = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), zee || (zee = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), Wee || (Wee = /* @__PURE__ */ h.createElement("path", {
    d: "M13 4H15V12H13zM9 4H11V12H9zM21 12H19a2.0021 2.0021 0 01-2-2V6a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0121 12zM19 6v4h2V6zM21 14H23V22H21zM9 14H11V22H9zM17 22H15a2.0021 2.0021 0 01-2-2V16a2.0021 2.0021 0 012-2h2a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0117 22zm-2-6v4h2V16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iJe.propTypes = E);
const rJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jee || (jee = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m25,2v7h7V2h-7Zm5,5h-3v-3h3v3Z"
  })), Zee || (Zee = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m23,6h-7v12h12v-7h-5v-5Zm-2,10h-3v-3h3v3Zm5-3v3h-3v-3h3Zm-8-2v-3h3v3h-3Z"
  })), Uee || (Uee = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M26 20v2H6v-14h8v-2H6c-1.104.0011-1.999.8959-2 2v14c.0012 1.104.896 1.9987 2 2h20c1.104-.0015 1.9985-.8961 2-2v-2h-2zM2 26H30V28H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rJe.propTypes = E);
const sJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qee || (qee = /* @__PURE__ */ h.createElement("path", {
    d: "M28 24v4H4V24H2v4l.0076-.0049A1.9977 1.9977 0 004 30H28a2 2 0 002-2h0V24zM27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6zM9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sJe.propTypes = E);
const oJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gee || (Gee = /* @__PURE__ */ h.createElement("path", {
    d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
  })), Qee || (Qee = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), Kee || (Kee = /* @__PURE__ */ h.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), Yee || (Yee = /* @__PURE__ */ h.createElement("path", {
    d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oJe.propTypes = E);
const aJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xee || (Xee = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aJe.propTypes = E);
const lJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jee || (Jee = /* @__PURE__ */ h.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), $ee || ($ee = /* @__PURE__ */ h.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lJe.propTypes = E);
const cJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ete || (ete = /* @__PURE__ */ h.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), tte || (tte = /* @__PURE__ */ h.createElement("path", {
    d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cJe.propTypes = E);
const hJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === "glyph" || i === "glyph" || i === "glyphpx" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, nte || (nte = /* @__PURE__ */ h.createElement("path", {
    d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ite || (ite = /* @__PURE__ */ h.createElement("path", {
    d: "M23.7642 6.8593l1.2851-1.5315A13.976 13.976 0 0020.8672 2.887l-.6836 1.8776A11.9729 11.9729 0 0123.7642 6.8593zM27.81 14l1.9677-.4128A13.8888 13.8888 0 0028.14 9.0457L26.4087 10A12.52 12.52 0 0127.81 14zM20.1836 27.2354l.6836 1.8776a13.976 13.976 0 004.1821-2.4408l-1.2851-1.5315A11.9729 11.9729 0 0120.1836 27.2354zM26.4087 22L28.14 23a14.14 14.14 0 001.6382-4.5872L27.81 18.0659A12.1519 12.1519 0 0126.4087 22zM16 30V2a14 14 0 000 28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hJe.propTypes = E);
const dJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rte || (rte = /* @__PURE__ */ h.createElement("path", {
    d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41zM14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dJe.propTypes = E);
const uJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ste || (ste = /* @__PURE__ */ h.createElement("path", {
    d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uJe.propTypes = E);
const fJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ote || (ote = /* @__PURE__ */ h.createElement("path", {
    d: "M14 26A12 12 0 0114 2zM17.8257 4.7642a10.0288 10.0288 0 013.2422 2.1679l1.4133-1.4135a12.0359 12.0359 0 00-3.89-2.6016zM26 14a11.93 11.93 0 00-.9167-4.5908l-1.8472.7651A9.9428 9.9428 0 0124 14zM27.38 28H20.6178L24 21.2358zM24 18a1 1 0 00-.8947.5527l-5 10A1.0005 1.0005 0 0019 30H29a1 1 0 00.9214-1.3892L24.8946 18.5527A1 1 0 0024 18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fJe.propTypes = E);
const pJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ate || (ate = /* @__PURE__ */ h.createElement("path", {
    d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pJe.propTypes = E);
const gJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lte || (lte = /* @__PURE__ */ h.createElement("path", {
    d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gJe.propTypes = E);
const mJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cte || (cte = /* @__PURE__ */ h.createElement("path", {
    d: "m23,23c-5.6558,0-7.8577-6.4109-7.9487-6.6837-.0173-.0514-1.8435-5.3163-6.0513-5.3163-2.7571,0-5,2.243-5,5s2.2429,5,5,5c1.5876,0,3.0134-.7322,4.2373-2.1764l1.5259,1.2932c-1.5989,1.8862-3.5916,2.8832-5.7632,2.8832-3.8599,0-7-3.1401-7-7s3.1401-7,7-7c5.6558,0,7.8577,6.4109,7.9487,6.6837.0173.0514,1.8435,5.3163,6.0513,5.3163,2.7571,0,5-2.243,5-5s-2.2429-5-5-5c-1.5876,0-3.0134.7322-4.2373,2.1764l-1.5259-1.2932c1.5989-1.8862,3.5916-2.8832,5.7632-2.8832,3.8599,0,7,3.1401,7,7s-3.1401,7-7,7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mJe.propTypes = E);
const uI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, hte || (hte = /* @__PURE__ */ h.createElement("path", {
    d: "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11zM8 3.5c-.4 0-.8.3-.8.8S7.6 5 8 5c.4 0 .8-.3.8-.8S8.4 3.5 8 3.5z"
  })), dte || (dte = /* @__PURE__ */ h.createElement("path", {
    d: "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ute || (ute = /* @__PURE__ */ h.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), fte || (fte = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uI.propTypes = E);
const AJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pte || (pte = /* @__PURE__ */ h.createElement("path", {
    d: "M30 3.4141L28.5859 2 2 28.5859 3.4141 30l3.4433-3.4434A13.9614 13.9614 0 0026.5565 6.8574zM28 16A11.9734 11.9734 0 018.2678 25.146L15 18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967 11.8967 0 0128 16zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), gte || (gte = /* @__PURE__ */ h.createElement("path", {
    d: "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (AJe.propTypes = E);
const wJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mte || (mte = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), Ate || (Ate = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wJe.propTypes = E);
const vJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wte || (wte = /* @__PURE__ */ h.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22zM16 8a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 8z"
  })), vte || (vte = /* @__PURE__ */ h.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vJe.propTypes = E);
const bJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bte || (bte = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), yte || (yte = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bJe.propTypes = E);
const yJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cte || (Cte = /* @__PURE__ */ h.createElement("path", {
    d: "M18 26H30V28H18zM18 21H30V23H18zM18 16H30V18H18z"
  })), Ete || (Ete = /* @__PURE__ */ h.createElement("path", {
    d: "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yJe.propTypes = E);
const CJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _te || (_te = /* @__PURE__ */ h.createElement("path", {
    d: "M2 9h9V2H2zM4 4H9V7H4zM2 19h9V12H2zm2-5H9v3H4zM2 29h9V22H2zm2-5H9v3H4zM27 9H18l3.41-3.59L20 4l-6 6 6 6 1.41-1.41L18 11h9a1 1 0 011 1V24a1 1 0 01-1 1H15v2H27a3 3 0 003-3V12A3 3 0 0027 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (CJe.propTypes = E);
const EJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xte || (xte = /* @__PURE__ */ h.createElement("path", {
    d: "M26 30H24V20H12V30H10V20a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2zM5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16zM24 14H12a2.0021 2.0021 0 01-2-2V2h2V12H24V2h2V12A2.0021 2.0021 0 0124 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (EJe.propTypes = E);
const _Je = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ste || (Ste = /* @__PURE__ */ h.createElement("path", {
    d: "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16zM11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
  })), Mte || (Mte = /* @__PURE__ */ h.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_Je.propTypes = E);
const xJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dte || (Dte = /* @__PURE__ */ h.createElement("path", {
    d: "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
  })), Lte || (Lte = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xJe.propTypes = E);
const SJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kte || (kte = /* @__PURE__ */ h.createElement("path", {
    d: "M12 5A3.0033 3.0033 0 009 2H4V15H9a3.0033 3.0033 0 003-3V10.5a2.977 2.977 0 00-.78-2 2.9768 2.9768 0 00.78-2zM6 4H9a1.0013 1.0013 0 011 1V6.5513A.9587.9587 0 019 7.5H6zm4 8a1.0009 1.0009 0 01-1 1H6V9.5H9a1.0009 1.0009 0 011 1zM22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
  })), Nte || (Nte = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), Tte || (Tte = /* @__PURE__ */ h.createElement("path", {
    d: "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (SJe.propTypes = E);
const MJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ite || (Ite = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
  })), Ote || (Ote = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), Rte || (Rte = /* @__PURE__ */ h.createElement("path", {
    d: "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (MJe.propTypes = E);
const DJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vte || (Vte = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), Hte || (Hte = /* @__PURE__ */ h.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM12 15H6a2.0023 2.0023 0 01-2-2V4A2.002 2.002 0 016 2h6V4H6v9h6zM2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (DJe.propTypes = E);
const LJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bte || (Bte = /* @__PURE__ */ h.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5zM10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
  })), Pte || (Pte = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), Fte || (Fte = /* @__PURE__ */ h.createElement("path", {
    d: "M2 18H6V20H2zM8 18H12V20H8zM14 18H18V20H14zM20 18H24V20H20zM26 18H30V20H26zM26 31H6a2.0021 2.0021 0 01-2-2V25a2.0021 2.0021 0 012-2H26a2.0021 2.0021 0 012 2v4A2.0021 2.0021 0 0126 31zM6 25v4H26V25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (LJe.propTypes = E);
const kJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zte || (zte = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), Wte || (Wte = /* @__PURE__ */ h.createElement("path", {
    d: "M2 6H6V8H2zM8 6H12V8H8zM14 6H18V8H14zM20 6H24V8H20zM26 6H30V8H26zM28 28H4a2.0021 2.0021 0 01-2-2V20a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 28zM4 20v6H28V20zM2 12H30V14H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kJe.propTypes = E);
const NJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jte || (jte = /* @__PURE__ */ h.createElement("path", {
    d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (NJe.propTypes = E);
const TJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zte || (Zte = /* @__PURE__ */ h.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
  })), Ute || (Ute = /* @__PURE__ */ h.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (TJe.propTypes = E);
const IJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qte || (qte = /* @__PURE__ */ h.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
  })), Gte || (Gte = /* @__PURE__ */ h.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (IJe.propTypes = E);
const OJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qte || (Qte = /* @__PURE__ */ h.createElement("path", {
    d: "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8 l4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
  })), Kte || (Kte = /* @__PURE__ */ h.createElement("path", {
    d: "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30 L16.6,28.6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (OJe.propTypes = E);
const RJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yte || (Yte = /* @__PURE__ */ h.createElement("circle", {
    cx: "18.5",
    cy: "22.5",
    r: "1.5"
  })), Xte || (Xte = /* @__PURE__ */ h.createElement("circle", {
    cx: "23.5",
    cy: "22.5",
    r: "1.5"
  })), Jte || (Jte = /* @__PURE__ */ h.createElement("circle", {
    cx: "28.5",
    cy: "22.5",
    r: "1.5"
  })), $te || ($te = /* @__PURE__ */ h.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (RJe.propTypes = E);
const VJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ene || (ene = /* @__PURE__ */ h.createElement("path", {
    d: "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4zM2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21zM17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (VJe.propTypes = E);
const HJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tne || (tne = /* @__PURE__ */ h.createElement("path", {
    d: "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28zM13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28zM17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (HJe.propTypes = E);
const BJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nne || (nne = /* @__PURE__ */ h.createElement("path", {
    d: "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
  })), ine || (ine = /* @__PURE__ */ h.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (BJe.propTypes = E);
const PJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rne || (rne = /* @__PURE__ */ h.createElement("path", {
    d: "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
  })), sne || (sne = /* @__PURE__ */ h.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (PJe.propTypes = E);
const FJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, one || (one = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ane || (ane = /* @__PURE__ */ h.createElement("path", {
    d: "M26 18H22V14H20V28h6a2.0027 2.0027 0 002-2V20A2.0023 2.0023 0 0026 18zm-4 8V20h4v6zM20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076zM10 18H5v2h5v2H6a2 2 0 00-2 2v2a2 2 0 002 2h6V20A2.0023 2.0023 0 0010 18zm0 8H6V24h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (FJe.propTypes = E);
const zJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lne || (lne = /* @__PURE__ */ h.createElement("path", {
    d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
  })), cne || (cne = /* @__PURE__ */ h.createElement("path", {
    d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
    transform: "rotate(-45 9 20)"
  })), hne || (hne = /* @__PURE__ */ h.createElement("path", {
    d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
    transform: "rotate(-45 20 9)"
  })), dne || (dne = /* @__PURE__ */ h.createElement("path", {
    d: "M7.586 7.586H10.414V10.414H7.586z",
    transform: "rotate(-45 9 9)"
  })), une || (une = /* @__PURE__ */ h.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zJe.propTypes = E);
const WJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fne || (fne = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M18.3242 11.7334v1.29h-1.3242v1.7368h1.3242v7.2397h2.2012v-7.2397h1.8398v-1.7368h-1.8398v-1.9951h1.8398v-1.7539h-1.5649c-1.6167 0-2.4761.877-2.4761 2.459zM10 11.8193L11.582 11.8193 11.582 20.1772 10 20.1772 10 22 15.4516 22 15.4516 20.1772 13.8525 20.1772 13.8525 11.8193 15.4516 11.8193 15.4516 9.9966 10 9.9966 10 11.8193z"
  })), pne || (pne = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (WJe.propTypes = E);
const jJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gne || (gne = /* @__PURE__ */ h.createElement("path", {
    d: "M22 24H18V22h4V18h2v4A2.0021 2.0021 0 0122 24zM10 14H8V10a2.0022 2.0022 0 012-2h4v2H10z"
  })), mne || (mne = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jJe.propTypes = E);
const ZJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ane || (Ane = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "23.887",
    r: "2"
  })), wne || (wne = /* @__PURE__ */ h.createElement("path", {
    d: "M29.7769 23.4785A8.64 8.64 0 0022 18a8.64 8.64 0 00-7.7769 5.4785L14 24l.2231.5215A8.64 8.64 0 0022 30a8.64 8.64 0 007.7769-5.4785L30 24zM22 28a4 4 0 114-4A4.0045 4.0045 0 0122 28zM25 10H4A2.0021 2.0021 0 012 8V4A2.0021 2.0021 0 014 2H25a2.0021 2.0021 0 012 2V8A2.0021 2.0021 0 0125 10zM4 4V8H25V4zM12 28H4V24h8V22H4a2.0023 2.0023 0 00-2 2v4a2.0023 2.0023 0 002 2h8z"
  })), vne || (vne = /* @__PURE__ */ h.createElement("path", {
    d: "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ZJe.propTypes = E);
const UJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bne || (bne = /* @__PURE__ */ h.createElement("path", {
    d: "M19 24H23V28H19zM26 24H30V28H26zM19 17H23V21H19zM26 17H30V21H26z"
  })), yne || (yne = /* @__PURE__ */ h.createElement("path", {
    d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (UJe.propTypes = E);
const qJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cne || (Cne = /* @__PURE__ */ h.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), Ene || (Ene = /* @__PURE__ */ h.createElement("path", {
    d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qJe.propTypes = E);
const GJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _ne || (_ne = /* @__PURE__ */ h.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), xne || (xne = /* @__PURE__ */ h.createElement("path", {
    d: "M21 21H11V11H21zm-8-2h6V13H13zM31 13H29A10.0117 10.0117 0 0019 3V1A12.0131 12.0131 0 0131 13z"
  })), Sne || (Sne = /* @__PURE__ */ h.createElement("path", {
    d: "M26,13H24a5.0059,5.0059,0,0,0-5-5V6A7.0085,7.0085,0,0,1,26,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (GJe.propTypes = E);
const QJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mne || (Mne = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M19 23h-2v-14h6c1.103 0 2 .897 2 2v5c0 1.103-.897 2-2 2h-4v5zm0-7h4v-5.0015h-4v5.0015zM7 11L10 11 10 21 7 21 7 23 15 23 15 21 12 21 12 11 15 11 15 9 7 9 7 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (QJe.propTypes = E);
const KJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dne || (Dne = /* @__PURE__ */ h.createElement("path", {
    d: "M28 23H24a2 2 0 01-2-2V11a2 2 0 012-2h4a2 2 0 012 2V21A2 2 0 0128 23zM24 11V21h4V11zM18 23H12V21h6V17H14a2 2 0 01-2-2V11a2 2 0 012-2h6v2H14v4h4a2 2 0 012 2v4A2 2 0 0118 23zM2 11L5 11 5 21 2 21 2 23 10 23 10 21 7 21 7 11 10 11 10 9 2 9 2 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (KJe.propTypes = E);
const YJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lne || (Lne = /* @__PURE__ */ h.createElement("path", {
    d: "M21 13H24V19H21z"
  })), kne || (kne = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM8,21H6V11H8Zm9-8H12v2h3a2,2,0,0,1,2,2v2a2,2,0,0,1-2,2H10V19h5V17H12a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h5Zm9,6a2,2,0,0,1-2,2H21a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2h3a2,2,0,0,1,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (YJe.propTypes = E);
const XJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nne || (Nne = /* @__PURE__ */ h.createElement("path", {
    d: "M24 21H21a2 2 0 01-2-2V13a2 2 0 012-2h3a2 2 0 012 2v6A2 2 0 0124 21zm-3-8v6h3V13zM15 21H10V19h5V17H12a2 2 0 01-2-2V13a2 2 0 012-2h5v2H12v2h3a2 2 0 012 2v2A2 2 0 0115 21zM6 11H8V21H6z"
  })), Tne || (Tne = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM4,24V8H28V24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (XJe.propTypes = E);
const JJe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ine || (Ine = /* @__PURE__ */ h.createElement("path", {
    d: "M12,17h8c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v11c0,1.1.9,2,2,2ZM12,4h8v11h-8V4ZM8,19h5v2h-5c-1.1,0-2-.9-2-2v-11h2v11ZM4,23h5v2h-5c-1.1,0-2-.9-2-2v-11h2v11ZM27,20c-1.6,0-3.1,1.4-4,2.4-.9-1-2.4-2.4-4-2.4-2.6,0-4,2-4,4s1.4,4,4,4,3.1-1.4,4-2.4c.9,1,2.4,2.4,4,2.4,2.6,0,4-2,4-4s-1.4-4-4-4ZM19,26c-1.5,0-2-1.1-2-2s.5-2,2-2,2,1.1,2.8,2c-.7.9-1.9,2-2.8,2ZM27,26c-.9,0-2-1.1-2.8-2,.7-.9,1.9-2,2.8-2,1.5,0,2,1.1,2,2s-.5,2-2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (JJe.propTypes = E);
const $Je = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, One || (One = /* @__PURE__ */ h.createElement("path", {
    d: "M12,17h8c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2h-8c-1.1,0-2,.9-2,2v11c0,1.1.9,2,2,2ZM12,4h8v11h-8V4ZM8,19h6v2h-6c-1.1,0-2-.9-2-2v-11h2v11ZM4,23h6v2h-6c-1.1,0-2-.9-2-2v-11h2v11ZM30,24l-6,6-1.4-1.4,3.6-3.6h-9.2v-2h9.2l-3.6-3.6,1.4-1.4,6,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($Je.propTypes = E);
const e$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rne || (Rne = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,9.0752a7.9941,7.9941,0,0,1,0,13.85,7.9941,7.9941,0,0,1,0-13.85m0-2.2373a9.9953,9.9953,0,0,0,0,18.3242A9.9953,9.9953,0,0,0,16,6.8379Z",
    "data-icon-path": "inner-path"
  })), Vne || (Vne = /* @__PURE__ */ h.createElement("path", {
    d: "M10,16a9.9976,9.9976,0,0,1,6-9.1621,10,10,0,1,0,0,18.3242A9.9976,9.9976,0,0,1,10,16Z"
  })), Hne || (Hne = /* @__PURE__ */ h.createElement("path", {
    d: "M16,9.0752a7.9941,7.9941,0,0,0,0,13.85,7.9941,7.9941,0,0,0,0-13.85Z"
  })), Bne || (Bne = /* @__PURE__ */ h.createElement("path", {
    d: "M20,6a9.9539,9.9539,0,0,0-4,.8379,9.9953,9.9953,0,0,1,0,18.3242A9.9988,9.9988,0,1,0,20,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (e$e.propTypes = E);
const t$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pne || (Pne = /* @__PURE__ */ h.createElement("path", {
    d: "M20,6a9.9355,9.9355,0,0,0-4,.8418A9.999,9.999,0,1,0,16,25.16,9.998,9.998,0,1,0,20,6ZM12,24A8,8,0,1,1,13.7573,8.2017a9.9734,9.9734,0,0,0,0,15.5986A7.9919,7.9919,0,0,1,12,24Zm8,0a7.9919,7.9919,0,0,1-1.7573-.2,9.9734,9.9734,0,0,0,0-15.5986A7.9972,7.9972,0,1,1,20,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (t$e.propTypes = E);
const n$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fne || (Fne = /* @__PURE__ */ h.createElement("path", {
    d: "M20,6a9.9272,9.9272,0,0,0-3.9968.8394,9.9758,9.9758,0,0,1,2.2451,1.36,8,8,0,1,1,0,15.6016,9.9758,9.9758,0,0,1-2.2451,1.36A9.9976,9.9976,0,1,0,20,6Z"
  })), zne || (zne = /* @__PURE__ */ h.createElement("path", {
    d: "M12,16a8.01,8.01,0,0,0,6.2483,7.8008,9.9858,9.9858,0,0,0,0-15.6016A8.01,8.01,0,0,0,12,16Z"
  })), Wne || (Wne = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M12,16a8.01,8.01,0,0,1,6.2483-7.8008,9.9758,9.9758,0,0,0-2.2451-1.36,9.9909,9.9909,0,0,0,0,18.3212,9.9758,9.9758,0,0,0,2.2451-1.36A8.01,8.01,0,0,1,12,16Z",
    "data-icon-path": "inner-path"
  })), jne || (jne = /* @__PURE__ */ h.createElement("path", {
    d: "M10,16a10.0105,10.0105,0,0,1,6.0032-9.1606,10,10,0,1,0,0,18.3212A10.0105,10.0105,0,0,1,10,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (n$e.propTypes = E);
const i$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zne || (Zne = /* @__PURE__ */ h.createElement("path", {
    d: "M20 6a9.9539 9.9539 0 00-4 .8379 9.9953 9.9953 0 010 18.3242A9.9988 9.9988 0 1020 6zM10 16a9.9976 9.9976 0 016-9.1621 10 10 0 100 18.3242A9.9976 9.9976 0 0110 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (i$e.propTypes = E);
const r$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Une || (Une = /* @__PURE__ */ h.createElement("path", {
    d: "M20,6a9.95,9.95,0,0,0-4.0032.8394,9.9909,9.9909,0,0,1,0,18.3212A9.9988,9.9988,0,1,0,20,6Z"
  })), qne || (qne = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M20,16a8.01,8.01,0,0,0-6.2483-7.8008,9.9758,9.9758,0,0,1,2.2451-1.36,9.9909,9.9909,0,0,1,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A8.01,8.01,0,0,0,20,16Z",
    "data-icon-path": "inner-path"
  })), Gne || (Gne = /* @__PURE__ */ h.createElement("path", {
    d: "M10,16a9.9759,9.9759,0,0,0,3.7517,7.8008,7.9937,7.9937,0,0,0,0-15.6016A9.9759,9.9759,0,0,0,10,16Z"
  })), Qne || (Qne = /* @__PURE__ */ h.createElement("path", {
    d: "M12,24A8,8,0,1,1,13.7517,8.1992a9.9758,9.9758,0,0,1,2.2451-1.36,10,10,0,1,0,0,18.3212,9.9758,9.9758,0,0,1-2.2451-1.36A7.9727,7.9727,0,0,1,12,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (r$e.propTypes = E);
const s$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kne || (Kne = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M2 9H6V11H2zM2 21H6V23H2zM25 11L23.5859 12.4141 26.1719 15 18 15 18 4 12 4 12 9 8 9 8 11 12 11 12 21 8 21 8 23 12 23 12 28 18 28 18 17 26.1719 17 23.5859 19.5859 25 21 30 16 25 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (s$e.propTypes = E);
const o$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yne || (Yne = /* @__PURE__ */ h.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM8 23H4a2 2 0 01-2-2V19H4v2H8V9h2V21A2 2 0 018 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (o$e.propTypes = E);
const a$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xne || (Xne = /* @__PURE__ */ h.createElement("path", {
    d: "M20.3335 30h-2.667c-.9189 0-1.6665-.7476-1.6665-1.6665v-2.3335h2v2h2v-8h2v8.3335c0 .9189-.7476 1.6665-1.6665 1.6665zM28.3335 30h-4.3335v-2h4v-2h-2c-1.103 0-2-.897-2-2v-2.3335c0-.9189.7476-1.6665 1.6665-1.6665h4.3335v2h-4v2h2c1.103 0 2 .897 2 2v2.3335c0 .9189-.7476 1.6665-1.6665 1.6665zM16 18c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 7H17V16H15z"
  })), Jne || (Jne = /* @__PURE__ */ h.createElement("path", {
    d: "m14,26h-4.5c-.3538,0-.6809-.1868-.8608-.4912L2.1392,14.5088c-.0928-.1569-.1392-.3329-.1392-.5088s.0464-.3519.1392-.5088L8.6392,2.4912c.1799-.3044.5071-.4912.8608-.4912h13c.3538,0,.6809.1868.8608.4912l6.5,11c.0928.1569.1392.3328.1392.5088s-.0464.3519-.1392.5088l-2,3.3845-1.7217-1.0173,1.6992-2.876-5.9089-10h-11.8589l-5.9089,10,5.9089,10h3.9294v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (a$e.propTypes = E);
const l$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $ne || ($ne = /* @__PURE__ */ h.createElement("path", {
    d: "M31 11L31 21 29 21 27 15 27 21 25 21 25 11 27 11 29 17 29 11 31 11zM21.3335 21h-2.667A1.6684 1.6684 0 0117 19.3335v-6.667A1.6684 1.6684 0 0118.6665 11h2.667A1.6684 1.6684 0 0123 12.6665v6.667A1.6684 1.6684 0 0121.3335 21zM19 19h2V13H19zM13.3335 21H9V19h4V17H11a2.002 2.002 0 01-2-2V12.6665A1.6684 1.6684 0 0110.6665 11H15v2H11v2h2a2.002 2.002 0 012 2v2.3335A1.6684 1.6684 0 0113.3335 21zM5.3335 21H2.6665A1.6684 1.6684 0 011 19.3335V17H3v2H5V11H7v8.3335A1.6684 1.6684 0 015.3335 21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (l$e.propTypes = E);
const c$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eie || (eie = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM29 12L27 6 25 6 25 16 27 16 27 10 29 16 31 16 31 6 29 6 29 12zM21.3335 6h-2.667A1.6683 1.6683 0 0017 7.6665v6.667A1.6684 1.6684 0 0018.6665 16h2.667A1.6683 1.6683 0 0023 14.3335V7.6665A1.6683 1.6683 0 0021.3335 6zM21 14H19V8h2zM9 7.6665V10a2.002 2.002 0 002 2h2v2H9v2h4.3335A1.6683 1.6683 0 0015 14.3335V12a2.002 2.002 0 00-2-2H11V8h4V6H10.6665A1.6683 1.6683 0 009 7.6665zM5 14H3V12H1v2.3335A1.6684 1.6684 0 002.6665 16h2.667A1.6683 1.6683 0 007 14.3335V6H5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (c$e.propTypes = E);
const h$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tie || (tie = /* @__PURE__ */ h.createElement("path", {
    d: "M13.4141,17.5859,18,22.1719V8H8V6H18a2.0024,2.0024,0,0,1,2,2V22.1719l4.5859-4.586L26,19l-7,7-7-7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (h$e.propTypes = E);
const d$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nie || (nie = /* @__PURE__ */ h.createElement("path", {
    d: "M25,10a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L24.17.4141a1.0381,1.0381,0,0,1,1.6592,0L28.3154,4.11A3.9693,3.9693,0,0,1,29,6.223,3.8978,3.8978,0,0,1,25,10Zm0-7.2368L23.3438,5.2257A1.89,1.89,0,0,0,23,6.223a2.014,2.014,0,0,0,4,0,1.98,1.98,0,0,0-.375-1.0466Z"
  })), iie || (iie = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9854,15.83a13.9726,13.9726,0,0,0-1.8147-4.8323L26.4329,12.001a12.092,12.092,0,0,1,1.07,2.2124A5.4079,5.4079,0,0,0,26,14a6.5439,6.5439,0,0,0-3.939,1.333,14.5177,14.5177,0,0,0-3.0456-8.9341A13.8858,13.8858,0,0,0,17,4.4014V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM9.939,15.333A6.5439,6.5439,0,0,0,6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4413,12.4413,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333ZM16,14a6.5526,6.5526,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0564-9.1763,3.4307,2.6768,4.009,6.9487,4.0522,9.1728A6.552,6.552,0,0,0,16,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (d$e.propTypes = E);
const u$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rie || (rie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M30 9L28.0001 9 26 16 24.0001 9 22 9 25 17.9996 25 23 27 23 27 18 27.0001 18 30 9zM21 11L21 9 13 9 13 23 21 23 21 21 15 21 15 17 20 17 20 15 15 15 15 11 21 11zM11 9L8.8941 9 5 15.5527 5 9 3 9 3 23 5 23 5 18.7062 5.9277 17.2208 8.8941 23 11 23 7.1093 15.4308 11 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (u$e.propTypes = E);
const f$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sie || (sie = /* @__PURE__ */ h.createElement("path", {
    d: "M28,26H4a2,2,0,0,1-2-2V10A2,2,0,0,1,4,8H28a2,2,0,0,1,2,2V24A2,2,0,0,1,28,26ZM4,10V24H28V10Z"
  })), oie || (oie = /* @__PURE__ */ h.createElement("path", {
    d: "M10 20H21V22H10zM6 12H8V14H6zM10 12H12V14H10zM14 12H16V14H14zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM14 16H16V18H14zM22 12H26V14H22zM22 16H26V18H22zM18 16H20V18H18zM23 20H26V22H23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (f$e.propTypes = E);
var aie, lie, cie, hie, die, uie, fie, pie, gie, mie, Aie, wie, vie, bie, yie, Cie, Eie, _ie, xie, Sie, Mie, Die, Lie, kie, Nie, Tie, Iie, Oie, Rie, Vie, Hie, Bie, Pie, Fie, zie, Wie, jie, Zie, Uie, qie, Gie, Qie, Kie, Yie, Xie, Jie, $ie, ere, tre, nre, ire, rre, sre, ore, are, lre, cre, hre, dre, ure, fre, pre, gre, mre, Are, wre, vre, bre, yre, Cre, Ere, _re, xre, Sre, Mre, Dre, Lre, kre, Nre, Tre, Ire, Ore, Rre, Vre, Hre, Bre, Pre, Fre, zre, Wre, jre, Zre, Ure, qre, Gre, Qre, Kre, Yre, Xre, Jre, $re, ese, tse, nse, ise, rse, sse, ose, ase, lse, cse, hse, dse, use, fse, pse, gse, mse, Ase, wse, vse, bse, yse, Cse, Ese, _se, xse, Sse, Mse, Dse, Lse, kse, Nse, Tse, Ise, Ose, Rse, Vse, Hse, Bse, Pse, Fse, zse, Wse, jse, Zse, Use, qse, Gse, Qse, Kse, Yse, Xse, Jse, $se, eoe, toe, noe, ioe, roe, soe, ooe, aoe, loe, coe, hoe, doe, uoe, foe, poe, goe, moe, Aoe, woe, voe, boe, yoe, Coe, Eoe, _oe, xoe, Soe, Moe, Doe, Loe, koe, Noe, Toe, Ioe, Ooe, Roe, Voe, Hoe, Boe, Poe, Foe, zoe, Woe, joe, Zoe, Uoe, qoe, Goe, Qoe, Koe, Yoe, Xoe, Joe, $oe, eae, tae, nae, iae, rae, sae, oae, aae, lae, cae, hae, dae;
const uae = {}, p$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aie || (aie = /* @__PURE__ */ h.createElement("path", {
    d: "M6 12H8V14H6zM18 12H20V14H18zM6 20H8V22H6zM6 16H8V18H6zM10 16H12V18H10zM22 12H26V14H22zM22 16H26V18H22z"
  })), lie || (lie = /* @__PURE__ */ h.createElement("path", {
    d: "M14.2 10H28v13h2V10c0-1.1-.9-2-2-2H12.2L14.2 10zM30 28.6L3.4 2 2 3.4 6.6 8H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h20.6l4 4L30 28.6zM4 24V10h4.6l2 2H10v2h2.6l2 2H14v2h2.6l2 2H10v2h10.6l2 2H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (p$e.propTypes = E);
const g$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cie || (cie = /* @__PURE__ */ h.createElement("path", {
    d: "M26,19c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v13c0,1.1.9,2,2,2h7v9H4v2h24v-2h-9v-9h7ZM17,28h-2v-9h2v9ZM6,17V4h20v13H6ZM16,13c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (g$e.propTypes = E);
const m$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hie || (hie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m20.0444,27.2942l-3.0825-10.018-1.0132,3.04c-.1361.4084-.5183.6838-.9487.6838h-6s0-2,0-2h5.2793s1.772-5.3162,1.772-5.3162c.1307-.4123.5162-.6902.9487-.6838.4374.0046.8225.2891.9555.7058l3.0088,9.7783,1.0742-3.7589c.1227-.4293.5151-.7252.9615-.7252h5s0,2,0,2h-4.2456s-1.7933,6.2747-1.7933,6.2747c-.1216.4256-.5085.7207-.9511.7253h-.01c-.4389,0-.8265-.2863-.9556-.7058Z"
  })), die || (die = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,28H6c-1.1028,0-2-.8972-2-2V6c0-1.1028.8972-2,2-2h20c1.1028,0,2,.8972,2,2v9h-2V6H6v20h10v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (m$e.propTypes = E);
const A$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (uae.Kubernetes || (uae.Kubernetes = !0, console.warn("The current kubernetes icon has been replaced by logo--kubernetes. As a result, the Kubernetes component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uie || (uie = /* @__PURE__ */ h.createElement("path", {
    d: "M29.2227,17.9639,25.9194,17.21a9.7843,9.7843,0,0,0-1.5249-6.6245l2.54-2.0254L25.6875,6.9961,23.1482,9.0205A9.97,9.97,0,0,0,17,6.0508V3H15V6.0508a9.97,9.97,0,0,0-6.1482,2.97L6.3125,6.9961,5.0654,8.56l2.54,2.0254A9.7843,9.7843,0,0,0,6.0806,17.21l-3.3033.7544.4454,1.9492L6.52,19.1606a10.0359,10.0359,0,0,0,4.2688,5.358l-1.33,2.7631,1.8018.8677L12.59,25.3882a9.8113,9.8113,0,0,0,6.8208,0L20.74,28.1494l1.8018-.8682-1.33-2.7626a10.0359,10.0359,0,0,0,4.2688-5.358l3.2973.7525ZM24,16c0,.2573-.0148.5112-.0386.7627l-5-1.1416a2.9664,2.9664,0,0,0-.1376-.5942L22.82,11.84A7.9392,7.9392,0,0,1,24,16Zm-9,0a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,15,16Zm6.5758-5.7256L17.58,13.4609a3.0028,3.0028,0,0,0-.58-.2768V8.0693A7.9762,7.9762,0,0,1,21.5758,10.2744ZM15,8.0693v5.1148a3.0028,3.0028,0,0,0-.58.2768l-3.9956-3.1865A7.9762,7.9762,0,0,1,15,8.0693ZM8,16a7.9392,7.9392,0,0,1,1.18-4.16l3.9962,3.1866a2.9664,2.9664,0,0,0-.1376.5942l-5,1.1416C8.0148,16.5112,8,16.2573,8,16Zm.4835,2.7124,4.9752-1.1362a3.0132,3.0132,0,0,0,.4146.5366L11.6594,22.71A8.031,8.031,0,0,1,8.4835,18.7124ZM16,24a7.9679,7.9679,0,0,1-2.54-.42l2.2206-4.6123A2.9988,2.9988,0,0,0,16,19a2.9988,2.9988,0,0,0,.319-.0322L18.54,23.58A7.9546,7.9546,0,0,1,16,24Zm4.3406-1.29-2.2139-4.5976a3.0132,3.0132,0,0,0,.4146-.5366l4.9752,1.1362A8.031,8.031,0,0,1,20.3406,22.71Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (A$e.propTypes = E);
const w$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fie || (fie = /* @__PURE__ */ h.createElement("path", {
    d: "M22.951 20h-2.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157 2H8.951v2h6.1843c.4141 1.1611 1.5137 2 2.8157 2s2.4016-.8389 2.8157-2h2.1843v-2Zm-5 2c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1Zm5-10h-6.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157 2H8.951v2h2.1843c.4141 1.1611 1.5137 2 2.8157 2s2.4016-.8389 2.8157-2h6.1843v-2Zm-9 2c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1Z"
  })), pie || (pie = /* @__PURE__ */ h.createElement("path", {
    d: "m29.8993 18.9897-2.593-11.1865a2 2 0 0 0-1.124-1.3711l-9.407-4.2544C16.5133 2.059 16.2321 2 15.9511 2s-.5623.0591-.8242.1777L5.7197 6.4321a2 2 0 0 0-1.124 1.3711l-2.593 11.1865a2.0008 2.0008 0 0 0 .3899 1.7056l6.886 8.5586A2.0001 2.0001 0 0 0 10.8367 30h10.2286a2.0001 2.0001 0 0 0 1.5581-.7461l6.886-8.5586a2.0008 2.0008 0 0 0 .3899-1.7056ZM21.0653 28H10.837l-6.886-8.5586 2.593-11.187L15.951 4l9.407 4.2549 2.593 11.1865L21.0652 28Z"
  })), gie || (gie = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (w$e.propTypes = E);
const v$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mie || (mie = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), Aie || (Aie = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), wie || (wie = /* @__PURE__ */ h.createElement("path", {
    d: "m18.8157,26c-.302-.8472-.9685-1.5137-1.8157-1.8159v-2.1841h3c.2969,0,.5781-.1318.7683-.3599l5-6c.1982-.2378.2751-.5547.2078-.8569l-2-9c-.0696-.3145-.2864-.5757-.5823-.7021l-7-3c-.1257-.0542-.2598-.0811-.3938-.0811s-.2681.0269-.3938.0811l-7.0015,3c-.2959.1265-.5127.3877-.5825.7021l-1.9985,9c-.0671.3027.0098.6191.208.8569l5,6c.1902.228.4714.3599.7683.3599h3v2.1846c-.8472.3018-1.5137.9683-1.8157,1.8154H4v2h9.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h9.1843v-2h-9.1843Zm-10.7329-11.2627l1.7808-8.02,6.1365-2.6294,6.135,2.6294,1.7822,8.02-4.3855,5.2627h-7.0635l-4.3855-5.2627Zm7.9172,13.2627c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (v$e.propTypes = E);
const b$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vie || (vie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m19,21h-6c-1.1028,0-2-.8972-2-2v-6c0-1.1028.8972-2,2-2h6c1.1028,0,2,.8972,2,2v6c0,1.1028-.8972,2-2,2Zm-6-8v6h6v-6h-6Z"
  })), bie || (bie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-7.7197-6.2803-14-14-14S2,8.2803,2,16s6.2803,14,14,14c2.7773,0,5.417-.7959,7.7012-2.3081.3948.1914.8315.3081,1.2988.3081,1.6543,0,3-1.3457,3-3,0-.4673-.1167-.9043-.3079-1.2988,1.5122-2.2842,2.3079-4.9238,2.3079-7.7012Zm-26,0c0-6.6167,5.3833-12,12-12s12,5.3833,12,12c0,2.248-.6152,4.3877-1.7744,6.2681-.375-.1689-.7881-.2681-1.2256-.2681-1.6543,0-3,1.3457-3,3,0,.4375.0991.8506.2681,1.2256-1.8801,1.1592-4.0198,1.7744-6.2681,1.7744-6.6167,0-12-5.3833-12-12Zm21,10c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (b$e.propTypes = E);
const y$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yie || (yie = /* @__PURE__ */ h.createElement("path", {
    d: "m22.5046,11.6368l-5.9883-3.5c-.1594-.0933-.3381-.1387-.5164-.1367-.1699.002-.3394.0474-.4915.1357l-6.0117,3.5c-.3076.1792-.4968.5083-.4968.8643v7c0,.356.1892.6851.4968.8643l6.0117,3.5c.1555.0903.3176.1357.4915.1357.1743,0,.3604-.0454.5164-.1367l5.9883-3.5c.3069-.1792.4954-.5078.4954-.8633v-7c0-.3555-.1885-.6841-.4954-.8633Zm-6.4939-1.479l4.0076,2.3423-4.0076,2.3423-4.0232-2.3423,4.0232-2.3423Zm-5.0107,4.0815l4,2.3291v4.6855l-4-2.3291v-4.6855Zm6,7.0249v-4.6836l4-2.3379v4.6836l-4,2.3379Z"
  })), Cie || (Cie = /* @__PURE__ */ h.createElement("path", {
    d: "m16,31c-.1741,0-.3481-.0454-.5039-.1362l-12-7c-.3071-.1792-.4961-.5081-.4961-.8638v-14c0-.3557.189-.6846.4961-.8638L15.4961,1.1362c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l11,6.4166-1.0078,1.7275-10.4961-6.1227-11,6.4166v12.8513l11,6.4166,11-6.4166v-7.4257h2v8c0,.3557-.189.6846-.4961.8638l-12,7c-.1558.0908-.3298.1362-.5039.1362Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (y$e.propTypes = E);
const C$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Eie || (Eie = /* @__PURE__ */ h.createElement("path", {
    d: "M23 18v-2h-2.1c-.1-.6-.4-1.2-.7-1.8l1.5-1.5-1.4-1.4-1.5 1.5c-.5-.3-1.1-.6-1.8-.7V10h-2v2.1c-.6.1-1.2.4-1.8.7l-1.5-1.5-1.4 1.4 1.5 1.5c-.3.5-.6 1.1-.7 1.8H9v2h2.1c.1.6.4 1.2.7 1.8l-1.5 1.5 1.4 1.4 1.5-1.5c.5.3 1.1.6 1.8.7V24h2v-2.1c.6-.1 1.2-.4 1.8-.7l1.5 1.5 1.4-1.4-1.5-1.5c.3-.5.6-1.1.7-1.8H23Zm-7 2c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3Z"
  })), _ie || (_ie = /* @__PURE__ */ h.createElement("path", {
    d: "m29.9483 18.9897-2.593-11.1865a2 2 0 0 0-1.124-1.3711l-9.407-4.2544C16.5623 2.059 16.2811 2 16.0001 2s-.5623.0591-.8242.1777L5.7687 6.4321a2 2 0 0 0-1.124 1.3711l-2.593 11.1865a2.0008 2.0008 0 0 0 .3899 1.7056l6.886 8.5586A2.0001 2.0001 0 0 0 10.8857 30h10.2286a2.0001 2.0001 0 0 0 1.5581-.7461l6.886-8.5586a2.0008 2.0008 0 0 0 .3899-1.7056ZM21.1143 28H10.886L4 19.4414l2.593-11.187L16 4l9.407 4.2549L28 19.4414 21.1142 28Z"
  })), xie || (xie = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (C$e.propTypes = E);
const E$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sie || (Sie = /* @__PURE__ */ h.createElement("path", {
    d: "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2.0023 2.0023 0 0023 13zm0 8H19V19h4zM13 9H9a2.002 2.002 0 00-2 2V23H9V18h4v5h2V11A2.002 2.002 0 0013 9zM9 16V11h4v5z"
  })), Mie || (Mie = /* @__PURE__ */ h.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (E$e.propTypes = E);
const _$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Die || (Die = /* @__PURE__ */ h.createElement("path", {
    d: "M18 19H24V21H18zM18 15H30V17H18zM18 11H30V13H18zM14 21V19H9V17H7v2H2v2h8.2148a8.5914 8.5914 0 01-2.2159 3.9771A9.2731 9.2731 0 016.5521 23H4.3334a10.8553 10.8553 0 002.1451 3.2966A14.6584 14.6584 0 013 28.127L3.7021 30a16.42 16.42 0 004.2907-2.3362A16.4883 16.4883 0 0012.2979 30L13 28.127A14.664 14.664 0 019.5228 26.3 10.3132 10.3132 0 0012.2516 21zM11.1666 13H13.333L8.75 2H6.5832L2 13H4.1664L5 11h5.3335zM5.8331 9L7.6665 4.6 9.5 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_$e.propTypes = E);
const x$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lie || (Lie = /* @__PURE__ */ h.createElement("path", {
    d: "M26,24H6a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,6,6H26a2.0023,2.0023,0,0,1,2,2V22A2.0027,2.0027,0,0,1,26,24ZM6,8V22H26V8Z",
    transform: "translate(0 .005)"
  })), kie || (kie = /* @__PURE__ */ h.createElement("path", {
    d: "M2 26.005H30V28.005H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (x$e.propTypes = E);
const S$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nie || (Nie = /* @__PURE__ */ h.createElement("path", {
    d: "M20,2H12A9.9842,9.9842,0,0,0,7.0349,20.6553C7.0249,20.7705,7,20.8818,7,21a3.9929,3.9929,0,0,0,2.9106,3.83A4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,3.9966,3.9966,0,0,0,2.93-2.88H20A10,10,0,0,0,20,2ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm9-3H14.8579a3.9841,3.9841,0,0,0-7.15-1.2637A7.99,7.99,0,0,1,12,4h8a8,8,0,0,1,0,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (S$e.propTypes = E);
const M$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tie || (Tie = /* @__PURE__ */ h.createElement("path", {
    d: "M29.6245,2.2193a1.0005,1.0005,0,0,0-1.0972-.1006L17.9353,7.8,3.366,2.0694a1,1,0,0,0-1.28,1.3369l6.4353,14.479A3.965,3.965,0,0,0,9.9106,24.83,4.0049,4.0049,0,0,1,6,28H4v2H6a6.0044,6.0044,0,0,0,5.928-5.12,4.0021,4.0021,0,0,0,2.93-2.88H23.24a2,2,0,0,0,1.9273-1.4649L29.9634,3.2676A1,1,0,0,0,29.6245,2.2193ZM11,23a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,11,23Zm12.24-3H14.8579a3.897,3.897,0,0,0-4.5117-2.9336L4.905,4.8238,18.0647,10,27.41,4.9878Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (M$e.propTypes = E);
const S7 = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Iie || (Iie = /* @__PURE__ */ h.createElement("path", {
    d: "M13,14H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5v1H3v10h10V8h1v5C14,13.6,13.6,14,13,14z"
  })), Oie || (Oie = /* @__PURE__ */ h.createElement("path", {
    d: "M10 1L10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rie || (Rie = /* @__PURE__ */ h.createElement("path", {
    d: "M26,28H6a2.0027,2.0027,0,0,1-2-2V6A2.0027,2.0027,0,0,1,6,4H16V6H6V26H26V16h2V26A2.0027,2.0027,0,0,1,26,28Z"
  })), Vie || (Vie = /* @__PURE__ */ h.createElement("path", {
    d: "M20 2L20 4 26.586 4 18 12.586 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (S7.propTypes = E);
const D$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hie || (Hie = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), Bie || (Bie = /* @__PURE__ */ h.createElement("path", {
    d: "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 10.59L17 14.17 17 2 15 2 15 14.17 11.41 10.59 10 12 16 18 22 12 20.59 10.59z"
  })), Pie || (Pie = /* @__PURE__ */ h.createElement("path", {
    d: "M8 24H20V26H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (D$e.propTypes = E);
const L$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fie || (Fie = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "7",
    r: "1"
  })), zie || (zie = /* @__PURE__ */ h.createElement("path", {
    d: "M26 4v6H6V4H26m0-2H6A2 2 0 004 4v6a2 2 0 002 2H26a2 2 0 002-2V4a2 2 0 00-2-2zM20.59 21.41L17 17.83 17 30 15 30 15 17.83 11.41 21.41 10 20 16 14 22 20 20.59 21.41z"
  })), Wie || (Wie = /* @__PURE__ */ h.createElement("path", {
    d: "M8 6H20V8H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (L$e.propTypes = E);
const k$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jie || (jie = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "25",
    r: "1"
  })), Zie || (Zie = /* @__PURE__ */ h.createElement("path", {
    d: "M26 22v6H6V22H26m0-2H6a2 2 0 00-2 2v6a2 2 0 002 2H26a2 2 0 002-2V22a2 2 0 00-2-2zM20.59 4.59L17 8.17 17 0 15 0 15 8.17 11.41 4.59 10 6 16 12 22 6 20.59 4.59z"
  })), Uie || (Uie = /* @__PURE__ */ h.createElement("path", {
    d: "M20.59 10.59L16 15.16 11.41 10.59 10 12 16 18 22 12 20.59 10.59zM8 24H20V26H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (k$e.propTypes = E);
const N$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qie || (qie = /* @__PURE__ */ h.createElement("path", {
    d: "M16,24a.9967.9967,0,0,1-.4741-.12l-13-7L3.4741,15.12,16,21.8643,28.5259,15.12l.9482,1.7607-13,7A.9967.9967,0,0,1,16,24Z"
  })), Gie || (Gie = /* @__PURE__ */ h.createElement("path", {
    d: "M16 30a.9967.9967 0 01-.4741-.12l-13-7L3.4741 21.12 16 27.8643 28.5259 21.12l.9482 1.7607-13 7A.9967.9967 0 0116 30zM16 18a.9967.9967 0 01-.4741-.12l-13-7a1 1 0 010-1.7607l13-7a.9982.9982 0 01.9482 0l13 7a1 1 0 010 1.7607l-13 7A.9967.9967 0 0116 18zM5.1094 10L16 15.8643 26.8906 10 16 4.1358z"
  })), n);
});
process.env.NODE_ENV !== "production" && (N$e.propTypes = E);
const T$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qie || (Qie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,24c-.1631,0-.3262-.0398-.4741-.1196l-13-7,.9482-1.7607,12.5259,6.7446,12.5259-6.7446.9482,1.7607-13,7c-.1479.0798-.311.1196-.4741.1196Z"
  })), Kie || (Kie = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16 30c-.1631 0-.3262-.0398-.4741-.1196l-13-7 .9482-1.7607 12.5259 6.7446 12.5259-6.7446.9482 1.7607-13 7c-.1479.0798-.311.1196-.4741.1196zM29.4741 9.1196L16 1.8643v2.2715l10.8906 5.8643-10.8906 5.8643v2.2715l13.4741-7.2554c.324-.1743.5259-.5122.5259-.8804s-.2019-.7061-.5259-.8804zM4.4141 9.4141l3.5859-3.586v8.1719s2 0 2 0V5.8281s3.5859 3.5859 3.5859 3.5859l1.4141-1.414L9 2 3 8l1.4141 1.4141z"
  })), n);
});
process.env.NODE_ENV !== "production" && (T$e.propTypes = E);
const I$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yie || (Yie = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22H30V24H16z"
  })), Xie || (Xie = /* @__PURE__ */ h.createElement("rect", {
    width: "6",
    height: "6",
    x: "4",
    y: "20",
    rx: "1"
  })), Jie || (Jie = /* @__PURE__ */ h.createElement("path", {
    d: "M16 8H30V10H16zM9.5 12h-5a.5.5 0 01-.4473-.7236l2.5-5.0224a.5206.5206 0 01.8945 0l2.5 5.0225A.5.5 0 019.5 12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (I$e.propTypes = E);
const O$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $ie || ($ie = /* @__PURE__ */ h.createElement("path", {
    d: "M23 13H18v2h5v2H19a2 2 0 00-2 2v2a2 2 0 002 2h6V15A2 2 0 0023 13zm0 8H19V19h4zM13 9H9a2 2 0 00-2 2V23H9V18h4v5h2V11A2 2 0 0013 9zM9 16V11h4v5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (O$e.propTypes = E);
const R$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ere || (ere = /* @__PURE__ */ h.createElement("path", {
    d: "M23 13H19V9H17V23h6a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM15 12a3 3 0 00-3-3H7V23h5a3 3 0 003-3V18a3 3 0 00-.78-2A3 3 0 0015 14zM9 11h3a1 1 0 011 1v2a1 1 0 01-1 1H9zm4 9a1 1 0 01-1 1H9V17h3a1 1 0 011 1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (R$e.propTypes = E);
const V$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tre || (tre = /* @__PURE__ */ h.createElement("path", {
    d: "M24 23H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v6h5zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (V$e.propTypes = E);
const H$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nre || (nre = /* @__PURE__ */ h.createElement("path", {
    d: "M23 9v4H19a2 2 0 00-2 2v6a2 2 0 002 2h6V9zm-4 6h4v6H19zM11 23H7V9h4a4 4 0 014 4v6A4 4 0 0111 23zM9 21h2a2 2 0 002-2V13a2 2 0 00-2-2H9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (H$e.propTypes = E);
const B$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ire || (ire = /* @__PURE__ */ h.createElement("path", {
    d: "M25 19V15a2.0023 2.0023 0 00-2-2H19a2.0023 2.0023 0 00-2 2v6a2.0077 2.0077 0 002 2h5V21H19V19zm-6-4h4v2H19zM15 11L15 9 7 9 7 23 15 23 15 21 9 21 9 17 14 17 14 15 9 15 9 11 15 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (B$e.propTypes = E);
const P$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rre || (rre = /* @__PURE__ */ h.createElement("path", {
    d: "M16 11L16 9 8 9 8 23 10 23 10 17 15 17 15 15 10 15 10 11 16 11zM24 11V9H21a2 2 0 00-2 2v2H17v2h2v8h2V15h3V13H21V11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (P$e.propTypes = E);
const F$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sre || (sre = /* @__PURE__ */ h.createElement("path", {
    d: "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v2H18v2h5a2 2 0 002-2V13zm4 8H19V15h4zM15 23H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9V21h4V17H11V15h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (F$e.propTypes = E);
const z$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ore || (ore = /* @__PURE__ */ h.createElement("path", {
    d: "M13 9L13 15 9 15 9 9 7 9 7 23 9 23 9 17 13 17 13 23 15 23 15 9 13 9zM23 13H19V9H17V23h2V15h4v8h2V15A2 2 0 0023 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (z$e.propTypes = E);
const W$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, are || (are = /* @__PURE__ */ h.createElement("path", {
    d: "M10 11L13 11 13 21 10 21 10 23 18 23 18 21 15 21 15 11 18 11 18 9 10 9 10 11zM20 13H22V23H20zM20 9H22V11H20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (W$e.propTypes = E);
const j$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lre || (lre = /* @__PURE__ */ h.createElement("path", {
    d: "M20 9H22V11H20zM20 25H17v2h3a2 2 0 002-2V13H20zM14 23H10a2 2 0 01-2-2V19h2v2h4V9h2V21A2 2 0 0114 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (j$e.propTypes = E);
const Z$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cre || (cre = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9L12.89 9 9 15.55 9 9 7 9 7 23 9 23 9 18.71 9.93 17.22 12.89 23 15 23 11.11 15.43 15 9zM22.78 23L25 23 21.22 17 25 13 22.76 13 19 17.17 19 9 17 9 17 23 19 23 19 19.25 19.96 18.21 22.78 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Z$e.propTypes = E);
const U$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hre || (hre = /* @__PURE__ */ h.createElement("path", {
    d: "M11 21L11 9 9 9 9 23 17 23 17 21 11 21zM23 23H21a2 2 0 01-2-2V9h2V21h2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (U$e.propTypes = E);
const q$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dre || (dre = /* @__PURE__ */ h.createElement("path", {
    d: "M24 13H16V23h2V15h2v8h2V15h2v8h2V15A2 2 0 0024 13zM12 9L10.48 14 10 15.98 9.54 14 8 9 6 9 6 23 8 23 8 15 7.84 13 8.42 15 10 19.63 11.58 15 12.16 13 12 15 12 23 14 23 14 9 12 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (q$e.propTypes = E);
const G$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ure || (ure = /* @__PURE__ */ h.createElement("path", {
    d: "M25 23H23V15H19v8H17V13h6a2 2 0 012 2zM13 19L9.32 9 7 9 7 23 9 23 9 13 12.68 23 15 23 15 9 13 9 13 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (G$e.propTypes = E);
const Q$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fre || (fre = /* @__PURE__ */ h.createElement("path", {
    d: "M23 23H19a2 2 0 01-2-2V15a2 2 0 012-2h4a2 2 0 012 2v6A2 2 0 0123 23zm-4-8v6h4V15zM13 23H9a2 2 0 01-2-2V11A2 2 0 019 9h4a2 2 0 012 2V21A2 2 0 0113 23zM9 11V21h4V11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Q$e.propTypes = E);
const K$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pre || (pre = /* @__PURE__ */ h.createElement("path", {
    d: "M23 13H17V27h2V23h4a2 2 0 002-2V15A2 2 0 0023 13zm-4 8V15h4v6zM9 23H7V9h6a2 2 0 012 2v5a2 2 0 01-2 2H9zm0-7h4V11H9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (K$e.propTypes = E);
const Y$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gre || (gre = /* @__PURE__ */ h.createElement("path", {
    d: "M19 13a2 2 0 00-2 2v6a2 2 0 002 2h4v4h2V13zm4 8H19V15h4zM13 9H9a2 2 0 00-2 2V21a2 2 0 002 2h1v2a2 2 0 002 2h2V25H12V23h1a2 2 0 002-2V11A2 2 0 0013 9zM9 21V11h4V21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Y$e.propTypes = E);
const X$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mre || (mre = /* @__PURE__ */ h.createElement("path", {
    d: "M16 15V11a2 2 0 00-2-2H8V23h2V17h1.48l2.34 6H16l-2.33-6H14A2 2 0 0016 15zm-6-4h4v4H10zM24 13L18 13 18 23 20 23 20 15 24 15 24 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (X$e.propTypes = E);
const J$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Are || (Are = /* @__PURE__ */ h.createElement("path", {
    d: "M22 23H17V21h5V19H19a2 2 0 01-2-2V15a2 2 0 012-2h5v2H19v2h3a2 2 0 012 2v2A2 2 0 0122 23zM13 23H7V21h6V17H9a2 2 0 01-2-2V11A2 2 0 019 9h6v2H9v4h4a2 2 0 012 2v4A2 2 0 0113 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (J$e.propTypes = E);
const $$e = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wre || (wre = /* @__PURE__ */ h.createElement("path", {
    d: "M8 11L11 11 11 23 13 23 13 11 16 11 16 9 8 9 8 11zM23 15V13H20V11H18v2H16v2h2v6a2 2 0 002 2h3V21H20V15z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($$e.propTypes = E);
const eet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vre || (vre = /* @__PURE__ */ h.createElement("path", {
    d: "M23 23H19a2 2 0 01-2-2V13h2v8h4V13h2v8A2 2 0 0123 23zM13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eet.propTypes = E);
const tet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bre || (bre = /* @__PURE__ */ h.createElement("path", {
    d: "M25 13L23.25 13 21 22.03 18.79 13 17 13 19.5 23 22.5 23 25 13zM13 9L11 22 9 9 7 9 9.52 23 12.48 23 15 9 13 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tet.propTypes = E);
const net = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yre || (yre = /* @__PURE__ */ h.createElement("path", {
    d: "M24.3 13L23.39 21.61 22 13 20 13 18.61 21.61 17.7 13 16 13 17.36 23 19.64 23 21 14.63 22.36 23 24.64 23 26 13 24.3 13zM12.21 9L11.87 17 11.61 21.54 11.2 18 10.52 12.54 8.5 12.54 7.82 18 7.41 21.54 7.16 17 6.81 9 5.01 9 6.01 23 8.28 23 9.04 18.07 9.5 14 9.51 13.97 9.52 14 9.98 18.07 10.74 23 13.01 23 14.01 9 12.21 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (net.propTypes = E);
const iet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cre || (Cre = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9L13 9 11 15 9 9 7 9 9.75 16 7 23 9 23 11 17 13 23 15 23 12.24 16 15 9zM25 13L23 13 21 16.9 19 13 17 13 19.91 18 17 23 19 23 21 19.2 23 23 25 23 22.1 18 25 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iet.propTypes = E);
const ret = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ere || (Ere = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9L13 9 11 16 9 9 7 9 10 18 10 23 12 23 12 18 12 18 15 9zM23 13l-2 7.52L19.08 13H17l3.15 9.87L19.53 25H17v2h2.26a2 2 0 001.91-1.42L25 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ret.propTypes = E);
const set = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _re || (_re = /* @__PURE__ */ h.createElement("path", {
    d: "M25 15L25 13 17 13 17 15 22.5 15 17 21 17 23 25 23 25 21 19.51 21 25 15zM15 9L7 9 7 11 13 11 7 21 7 23 15 23 15 21 9 21 15 11 15 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (set.propTypes = E);
const oet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xre || (xre = /* @__PURE__ */ h.createElement("path", {
    d: "M10 6H22V8H10zM10 10H22V12H10zM10 24H16V26H10zM10 14H16V16H10z"
  })), Sre || (Sre = /* @__PURE__ */ h.createElement("path", {
    d: "M24,30H8a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,8,2H24a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,24,30ZM8,4V28H24V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oet.propTypes = E);
const aet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mre || (Mre = /* @__PURE__ */ h.createElement("path", {
    d: "M8 6H20V8H8zM8 10H20V12H8zM8 14H14V16H8zM8 24H12V26H8z"
  })), Dre || (Dre = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM12 30H6a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 016 2H22a2.0021 2.0021 0 012 2V14H22V4H6V28h6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aet.propTypes = E);
const cet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lre || (Lre = /* @__PURE__ */ h.createElement("path", {
    d: "M22 14a8 8 0 108 8A8.0092 8.0092 0 0022 14zm5.91 7H25.9563a12.03 12.03 0 00-1.2183-4.3325A6.01 6.01 0 0127.91 21zm-7.8545 0A10.0135 10.0135 0 0122 16.0146 10.0121 10.0121 0 0123.9448 21zm3.89 2A10.01 10.01 0 0122 27.9854 10.0121 10.0121 0 0120.0552 23zm-4.6831-6.332A12.0265 12.0265 0 0018.0435 21H16.09A6.01 6.01 0 0119.2617 16.668zM16.09 23h1.9532a12.0265 12.0265 0 001.2182 4.332A6.01 6.01 0 0116.09 23zm8.6482 4.332A12.0242 12.0242 0 0025.9565 23H27.91A6.0088 6.0088 0 0124.7385 27.332zM6 14H12V16H6zM6 6H18V8H6zM6 10H18V12H6zM6 24H12V26H6z"
  })), kre || (kre = /* @__PURE__ */ h.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H20a2.0021,2.0021,0,0,1,2,2v8H20V4H4V28h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cet.propTypes = E);
const het = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nre || (Nre = /* @__PURE__ */ h.createElement("path", {
    d: "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM30 24V22H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 18.1011V16H22v2.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 22H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 27.8989V30h2V27.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 24zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 26z"
  })), Tre || (Tre = /* @__PURE__ */ h.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (het.propTypes = E);
const det = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ire || (Ire = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM20 13V11H17.8579a3.94 3.94 0 00-.4248-1.019L18.95 8.4644 17.5356 7.05 16.019 8.5669A3.9443 3.9443 0 0015 8.1421V6H13V8.1421a3.9443 3.9443 0 00-1.019.4248L10.4644 7.05 9.05 8.4644 10.5669 9.981A3.94 3.94 0 0010.1421 11H8v2h2.1421a3.94 3.94 0 00.4248 1.019L9.05 15.5356 10.4644 16.95l1.5166-1.5166A3.9443 3.9443 0 0013 15.8579V18h2V15.8579a3.9443 3.9443 0 001.019-.4248L17.5356 16.95 18.95 15.5356 17.4331 14.019A3.94 3.94 0 0017.8579 13zm-6 1a2 2 0 112-2A2.0025 2.0025 0 0114 14z"
  })), Ore || (Ore = /* @__PURE__ */ h.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (det.propTypes = E);
const uet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rre || (Rre = /* @__PURE__ */ h.createElement("path", {
    d: "M8 14H14V16H8zM8 6H20V8H8zM8 10H20V12H8zM8 24H14V26H8zM27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM24 24a4 4 0 10-4-4A4 4 0 0024 24zm0-6a2 2 0 11-2 2A2 2 0 0124 18z"
  })), Vre || (Vre = /* @__PURE__ */ h.createElement("path", {
    d: "M14,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uet.propTypes = E);
const fet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hre || (Hre = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM17 15H11a3 3 0 00-3 3v1h2V18a1 1 0 011-1h6a1 1 0 011 1v1h2V18A3 3 0 0017 15zM14 14a4 4 0 10-4-4A4 4 0 0014 14zm0-6a2 2 0 11-2 2A2 2 0 0114 8z"
  })), Bre || (Bre = /* @__PURE__ */ h.createElement("path", {
    d: "M12,30H6a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V14H22V4H6V28h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fet.propTypes = E);
const pet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pre || (Pre = /* @__PURE__ */ h.createElement("path", {
    d: "M28.2261,22.812a13.9664,13.9664,0,0,0,0-13.624L28.4141,9a2.0021,2.0021,0,0,0,0-2.8281l-2.5857-2.586a2.0028,2.0028,0,0,0-2.8284,0l-.1877.1875a13.9687,13.9687,0,0,0-13.6243,0L9,3.5859a2.0024,2.0024,0,0,0-2.8284,0L3.5859,6.1719A2.0021,2.0021,0,0,0,3.5859,9l.1878.1875a13.97,13.97,0,0,0,0,13.625L3.5859,23a2.0021,2.0021,0,0,0,0,2.8281l2.5857,2.586a2.0021,2.0021,0,0,0,2.8284,0l.188-.188a13.9687,13.9687,0,0,0,13.6243.0005L23,28.4141a2.0021,2.0021,0,0,0,2.8284,0l2.5857-2.586a2.0021,2.0021,0,0,0,0-2.8281ZM28,16a11.973,11.973,0,0,1-1.2546,5.3315l-3.8948-3.895a6.9808,6.9808,0,0,0,0-2.873l3.8948-3.895A11.973,11.973,0,0,1,28,16ZM27,7.5859l-4.9346,4.9346A7.0434,7.0434,0,0,0,19.48,9.9346L24.4143,5ZM16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21ZM21.3154,5.2705,17.4365,9.1494a6.9808,6.9808,0,0,0-2.873,0L10.6846,5.2705A12.2484,12.2484,0,0,1,21.3154,5.2705ZM7.5859,5l4.9346,4.9346a7.0449,7.0449,0,0,0-2.5859,2.5859L5,7.5859ZM4,16a11.9716,11.9716,0,0,1,1.2546-5.3311l3.8948,3.8946a6.9808,6.9808,0,0,0,0,2.873L5.2546,21.3311A11.9716,11.9716,0,0,1,4,16ZM7.5857,27,5,24.4141,9.9346,19.48a7.0434,7.0434,0,0,0,2.5859,2.5859Zm3.0989-.27,3.8789-3.8789a6.9808,6.9808,0,0,0,2.873,0L21.3154,26.73A12.2484,12.2484,0,0,1,10.6846,26.73Zm13.73.27L19.48,22.0654A7.0449,7.0449,0,0,0,22.0654,19.48L27,24.4141Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pet.propTypes = E);
const get = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Fre || (Fre = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5 1H8.5V3.5H7.5z"
  })), zre || (zre = /* @__PURE__ */ h.createElement("path", {
    d: "M10.8 3.4H13.3V4.4H10.8z",
    transform: "rotate(-45.001 12.041 3.923)"
  })), Wre || (Wre = /* @__PURE__ */ h.createElement("path", {
    d: "M12.5 7.5H15V8.5H12.5z"
  })), jre || (jre = /* @__PURE__ */ h.createElement("path", {
    d: "M11.6 10.8H12.6V13.3H11.6z",
    transform: "rotate(-45.001 12.075 12.041)"
  })), Zre || (Zre = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5 12.5H8.5V15H7.5z"
  })), Ure || (Ure = /* @__PURE__ */ h.createElement("path", {
    d: "M2.7 11.6H5.2V12.6H2.7z",
    transform: "rotate(-45.001 3.96 12.079)"
  })), qre || (qre = /* @__PURE__ */ h.createElement("path", {
    d: "M1 7.5H3.5V8.5H1z"
  })), Gre || (Gre = /* @__PURE__ */ h.createElement("path", {
    d: "M3.4 2.7H4.4V5.2H3.4z",
    transform: "rotate(-45.001 3.925 3.961)"
  })), Qre || (Qre = /* @__PURE__ */ h.createElement("path", {
    d: "M8,6c1.1,0,2,0.9,2,2s-0.9,2-2,2S6,9.1,6,8S6.9,6,8,6 M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kre || (Kre = /* @__PURE__ */ h.createElement("path", {
    d: "M15 2H17V7H15z"
  })), Yre || (Yre = /* @__PURE__ */ h.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), Xre || (Xre = /* @__PURE__ */ h.createElement("path", {
    d: "M25 15H30V17H25z"
  })), Jre || (Jre = /* @__PURE__ */ h.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), $re || ($re = /* @__PURE__ */ h.createElement("path", {
    d: "M15 25H17V30H15z"
  })), ese || (ese = /* @__PURE__ */ h.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), tse || (tse = /* @__PURE__ */ h.createElement("path", {
    d: "M2 15H7V17H2z"
  })), nse || (nse = /* @__PURE__ */ h.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), ise || (ise = /* @__PURE__ */ h.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4.0045,4.0045,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (get.propTypes = E);
const met = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rse || (rse = /* @__PURE__ */ h.createElement("path", {
    d: "M15 2H17V7H15z"
  })), sse || (sse = /* @__PURE__ */ h.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), ose || (ose = /* @__PURE__ */ h.createElement("path", {
    d: "M25 15H30V17H25z"
  })), ase || (ase = /* @__PURE__ */ h.createElement("path", {
    d: "M23.147 21.668H25.147V26.625999999999998H23.147z",
    transform: "rotate(-45 24.147 24.146)"
  })), lse || (lse = /* @__PURE__ */ h.createElement("path", {
    d: "M15 25H17V30H15z"
  })), cse || (cse = /* @__PURE__ */ h.createElement("path", {
    d: "M5.375 23.147H10.333V25.147H5.375z",
    transform: "rotate(-45 7.853 24.146)"
  })), hse || (hse = /* @__PURE__ */ h.createElement("path", {
    d: "M2 15H7V17H2z"
  })), dse || (dse = /* @__PURE__ */ h.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), use || (use = /* @__PURE__ */ h.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (met.propTypes = E);
const Aet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fse || (fse = /* @__PURE__ */ h.createElement("path", {
    d: "M11.61,29.92a1,1,0,0,1-.6-1.07L12.83,17H8a1,1,0,0,1-1-1.23l3-13A1,1,0,0,1,11,2H21a1,1,0,0,1,.78.37,1,1,0,0,1,.2.85L20.25,11H25a1,1,0,0,1,.9.56,1,1,0,0,1-.11,1l-13,17A1,1,0,0,1,12,30,1.09,1.09,0,0,1,11.61,29.92ZM17.75,13l2-9H11.8L9.26,15h5.91L13.58,25.28,23,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Aet.propTypes = E);
const wet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pse || (pse = /* @__PURE__ */ h.createElement("path", {
    d: "M29.25,6.76a6,6,0,0,0-8.5,0l1.42,1.42a4,4,0,1,1,5.67,5.67l-8,8a4,4,0,1,1-5.67-5.66l1.41-1.42-1.41-1.42-1.42,1.42a6,6,0,0,0,0,8.5A6,6,0,0,0,17,25a6,6,0,0,0,4.27-1.76l8-8A6,6,0,0,0,29.25,6.76Z"
  })), gse || (gse = /* @__PURE__ */ h.createElement("path", {
    d: "M4.19,24.82a4,4,0,0,1,0-5.67l8-8a4,4,0,0,1,5.67,0A3.94,3.94,0,0,1,19,14a4,4,0,0,1-1.17,2.85L15.71,19l1.42,1.42,2.12-2.12a6,6,0,0,0-8.51-8.51l-8,8a6,6,0,0,0,0,8.51A6,6,0,0,0,7,28a6.07,6.07,0,0,0,4.28-1.76L9.86,24.82A4,4,0,0,1,4.19,24.82Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wet.propTypes = E);
const vet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mse || (mse = /* @__PURE__ */ h.createElement("path", {
    d: "M29.8945,23.542l-1.7238-3.4473a1.9994,1.9994,0,0,0-1.7886-1.1054h-.4683a14.887,14.887,0,0,0-1.8193-4.5977C23.0647,12.4429,22,10.4277,22,8A6,6,0,0,0,10,8a13.0041,13.0041,0,0,1-2.0486,6.2153,14.7022,14.7022,0,0,0-1.8708,4.7759H5.6184a2.0007,2.0007,0,0,0-1.7893,1.106L2.1055,23.5439a1,1,0,0,0,.0971,1.0508L6.2319,29.92a2.9995,2.9995,0,0,0,3.8482.6519l1.8735-1.1241A13.8223,13.8223,0,0,0,16,30a13.8034,13.8034,0,0,0,4.0488-.5527L21.92,30.57a2.9819,2.9819,0,0,0,1.5385.43,3.0385,3.0385,0,0,0,2.3389-1.1187l4-5.2885A1.001,1.001,0,0,0,29.8945,23.542Zm-7.5683-8.2158a14.8311,14.8311,0,0,1,1.5591,3.6631H21.738a16.6591,16.6591,0,0,0-.98-2.6455,12.7083,12.7083,0,0,1-.8789-2.4454,8.8046,8.8046,0,0,0,1.0034-1.4277l.0384-.0718A30.746,30.746,0,0,0,22.3262,15.3262ZM12,21a9.3959,9.3959,0,0,1,1.0728-3.8516c.2563-.5825.5158-1.1757.726-1.7993a4.0474,4.0474,0,0,0,4.4024,0c.21.6236.47,1.2168.726,1.7993A9.3959,9.3959,0,0,1,20,21c0,1.2881-.4146,3-4,3S12,22.2881,12,21Zm6.5105-8.5752A3.6265,3.6265,0,0,1,16,14a3.6273,3.6273,0,0,1-2.5107-1.5757,7.6356,7.6356,0,0,1,5.0212,0ZM12,8a4,4,0,0,1,8,0,10.9164,10.9164,0,0,0,.4673,3.1152A7.9811,7.9811,0,0,0,19,10.4849V8H17v2.0542a9.2522,9.2522,0,0,0-2,0V8H13v2.4849a7.9019,7.9019,0,0,0-1.4785.6372A10.7093,10.7093,0,0,0,12,8ZM9.7146,15.1592A29.8007,29.8007,0,0,0,11.0693,12.38l.0484.09a8.8046,8.8046,0,0,0,1.0034,1.4277,12.7083,12.7083,0,0,1-.8789,2.4454,16.6574,16.6574,0,0,0-.981,2.6474H8.1047A14.0567,14.0567,0,0,1,9.7146,15.1592Zm1.3708,12.4775L9.0508,28.8574a.9866.9866,0,0,1-1.2529-.1806L4.1724,23.8833l1.4458-2.8921h3.706L11.49,26.3853A1.0036,1.0036,0,0,1,11.0854,27.6367Zm2.316.1177a2.9571,2.9571,0,0,0-.0562-2.11A9.03,9.03,0,0,0,16,26a9.0237,9.0237,0,0,0,2.6562-.3564,2.9889,2.9889,0,0,0-.0546,2.11,13.8722,13.8722,0,0,1-5.2,0Zm10.83.8833a.996.996,0,0,1-1.2827.2178l-2.0342-1.2207h0a1.01,1.01,0,0,1-.396-1.273l2.157-5.3725h3.7058l1.4461,2.892Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vet.propTypes = E);
const bet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ase || (Ase = /* @__PURE__ */ h.createElement("path", {
    d: "M22.6121,20.5215A6.1582,6.1582,0,0,0,24,16.5254C24,13.4785,21.9812,11,19.5,11A4.2435,4.2435,0,0,0,16,13.06,4.2435,4.2435,0,0,0,12.5,11C10.0188,11,8,13.4785,8,16.5254a6.1593,6.1593,0,0,0,1.3879,3.9961c-.5688.3686-.9389.6416-.988.6787a1,1,0,0,0-.1807,1.4248C8.6592,23.1748,12.6169,28,16,28s7.3408-4.8252,7.7808-5.375A1,1,0,0,0,23.6,21.2C23.551,21.1631,23.1812,20.89,22.6121,20.5215ZM12.5,13c1.3552,0,2.5,1.6143,2.5,3.5254v1.5664a9.1005,9.1005,0,0,0-1.0244.2314A2.6411,2.6411,0,0,0,14,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.38,2.38,0,0,0,.4072,1.3623c-.0813.0415-.1687.0806-.248.1221A4.0291,4.0291,0,0,1,10,16.5254C10,14.6143,11.1448,13,12.5,13ZM16,26c-1.5691,0-3.9648-2.084-5.52-3.8057C11.9,21.2788,14.2656,20,16,20s4.1,1.2788,5.52,2.1943C19.9648,23.916,17.5691,26,16,26Zm4.8408-6.5156c-.0793-.0415-.1667-.0806-.248-.1221A2.38,2.38,0,0,0,21,18c0-1.1045-.6716-2-1.5-2s-1.5.8955-1.5,2a2.6411,2.6411,0,0,0,.0244.3232A9.1005,9.1005,0,0,0,17,18.0918V16.5254C17,14.6143,18.1448,13,19.5,13S22,14.6143,22,16.5254A4.0291,4.0291,0,0,1,20.8408,19.4844Z"
  })), wse || (wse = /* @__PURE__ */ h.createElement("path", {
    d: "M30,30a3.8876,3.8876,0,0,1-4-4V14A10,10,0,0,0,6,14V26a3.8876,3.8876,0,0,1-4,4V28a1.8793,1.8793,0,0,0,2-2V14a12,12,0,0,1,24,0V26a1.8825,1.8825,0,0,0,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bet.propTypes = E);
const yet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vse || (vse = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M26 2H28V30H26zM20 25H6c-1.1046 0-2-.8954-2-2v-14c0-1.1046.8954-2 2-2h14c1.1046 0 2 .8954 2 2v14c0 1.1046-.8954 2-2 2zm0-16H6v14h14v-14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yet.propTypes = E);
const Cet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bse || (bse = /* @__PURE__ */ h.createElement("path", {
    d: "M10 6H28V8H10zM10 24H28V26H10zM10 15H28V17H10zM4 15H6V17H4zM4 6H6V8H4zM4 24H6V26H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cet.propTypes = E);
const Eet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yse || (yse = /* @__PURE__ */ h.createElement("path", {
    d: "M16 8H30V10H16zM16 22H30V24H16zM10 14H4a2.0023 2.0023 0 01-2-2V6A2.0023 2.0023 0 014 4h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 14zM4 6v6h6.0012L10 6zM10 28H4a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0110 28zM4 20v6h6.0012L10 20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eet.propTypes = E);
const _et = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Cse || (Cse = /* @__PURE__ */ h.createElement("circle", {
    cx: "3.5",
    cy: "4.5",
    r: "1.5"
  })), Ese || (Ese = /* @__PURE__ */ h.createElement("circle", {
    cx: "3.5",
    cy: "11.5",
    r: "1.5"
  })), _se || (_se = /* @__PURE__ */ h.createElement("path", {
    d: "M8 11H15V12H8zM8 4H15V5H8z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xse || (xse = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "9",
    r: "3"
  })), Sse || (Sse = /* @__PURE__ */ h.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "3"
  })), Mse || (Mse = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22H30V24H16zM16 8H30V10H16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_et.propTypes = E);
const xet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dse || (Dse = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22H30V24H16zM14 19.4L12.6 18 6 24.6 3.4 22 2 23.4 6 27.4zM16 8H30V10H16zM14 5.4L12.6 4 6 10.6 3.4 8 2 9.4 6 13.4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xet.propTypes = E);
const Met = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lse || (Lse = /* @__PURE__ */ h.createElement("path", {
    d: "M30 19.4L28.6 18 22 24.6 19.4 22 18 23.4 22 27.4zM2 22H16V24H2zM30 5.4L28.6 4 22 10.6 19.4 8 18 9.4 22 13.4zM2 8H16V10H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Met.propTypes = E);
const Det = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kse || (kse = /* @__PURE__ */ h.createElement("path", {
    d: "M26,6V2H2V12h9V30H30V6ZM4,10V4H24V6H11v4ZM28,28H13V8H28Z"
  })), Nse || (Nse = /* @__PURE__ */ h.createElement("path", {
    d: "M15 11H17V13H15zM19 11H26V13H19zM15 17H17V19H15zM19 17H26V19H19zM15 23H17V25H15zM19 23H26V25H19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Det.propTypes = E);
const Let = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tse || (Tse = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22H30V24H16zM16 8H30V10H16zM8 12L8 4 6 4 6 5 4 5 4 7 6 7 6 12 4 12 4 14 6 14 8 14 10 14 10 12 8 12zM10 28H4V24a2 2 0 012-2H8V20H4V18H8a2 2 0 012 2v2a2 2 0 01-2 2H6v2h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Let.propTypes = E);
const ket = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ise || (Ise = /* @__PURE__ */ h.createElement("path", {
    d: "M28 28h-6v-4c0-1.1.9-2 2-2h2v-2h-4v-2h4c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-2v2h4V28zM2 22H16V24H2zM26 12L26 4 24 4 24 5 22 5 22 7 24 7 24 12 22 12 22 14 24 14 26 14 28 14 28 12zM2 8H16V10H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ket.propTypes = E);
const Net = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ose || (Ose = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V14H15v2H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM9 2V12H23V2zm2 2h2v6H11zm10 6H15V4h6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Net.propTypes = E);
const Tet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rse || (Rse = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8zM14 8V4h4V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tet.propTypes = E);
const Iet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vse || (Vse = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.0021 2.0021 0 0016 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iet.propTypes = E);
const Oet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hse || (Hse = /* @__PURE__ */ h.createElement("path", {
    d: "M15 8H17V10H15zM19 8H21V10H19zM11 8H13V10H11zM25 16H17V13H15v3H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 3H21V5H11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oet.propTypes = E);
const Ret = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bse || (Bse = /* @__PURE__ */ h.createElement("path", {
    d: "M25 16H17V10H15v6H7a2.0023 2.0023 0 00-2 2v6H7V18h8v6h2V18h8v6h2V18A2.0023 2.0023 0 0025 16zM4 26H8V30H4zM14 26H18V30H14zM24 26H28V30H24zM11 5H21V7H11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ret.propTypes = E);
const Vet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pse || (Pse = /* @__PURE__ */ h.createElement("path", {
    d: "M25 16H17V12H15v4H7a2.0023 2.0023 0 00-2 2v4H7V18h8v4h2V18h8v4h2V18A2.0023 2.0023 0 0025 16zM20 10V2H12v8h8zM14 8V4h4V8zM26 24a2.9948 2.9948 0 00-2.8157 2H18.8157a2.982 2.982 0 00-5.6314 0H8.8157a3 3 0 100 2h4.3686a2.982 2.982 0 005.6314 0h4.3686A2.9947 2.9947 0 1026 24zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0116 28zm10 0a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vet.propTypes = E);
const Het = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fse || (Fse = /* @__PURE__ */ h.createElement("path", {
    d: "M10 15H22V17H10zM8.7 6.2852A2.9665 2.9665 0 009 5 3 3 0 106 8a2.96 2.96 0 001.2852-.3008L10 10.4141V13h2V9.5859zM6 6A1 1 0 117 5 1.0009 1.0009 0 016 6zM19 5a3 3 0 10-4 2.8154V13h2V7.8159A2.9957 2.9957 0 0019 5zM16 6a1 1 0 111-1A1.0009 1.0009 0 0116 6zM26 2a3.0033 3.0033 0 00-3 3 2.9665 2.9665 0 00.3 1.2852L20 9.5859V13h2V10.4141l2.7148-2.7149A2.96 2.96 0 0026 8a3 3 0 000-6zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 6zM12 19H10v2.5859L7.2854 24.3008A2.9609 2.9609 0 006 24a3 3 0 103 3 2.9665 2.9665 0 00-.3-1.2852L12 22.4141zM6 28a1 1 0 111-1A1.0009 1.0009 0 016 28zM17 24.1841V19H15v5.1841a3 3 0 102 0zM16 28a1 1 0 111-1A1.0009 1.0009 0 0116 28zM26 24a2.9609 2.9609 0 00-1.2854.3008L22 21.5859V19H20v3.4141l3.3 3.3007A2.9665 2.9665 0 0023 27a3 3 0 103-3zm0 4a1 1 0 111-1A1.0009 1.0009 0 0126 28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Het.propTypes = E);
const Bet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zse || (zse = /* @__PURE__ */ h.createElement("path", {
    d: "M8 30H2V24H8zM4 28H6V26H4zM19 30H13V24h6zm-4-2h2V26H15zM30 30H24V24h6zm-4-2h2V26H26zM16 10a4 4 0 114-4A4.0045 4.0045 0 0116 10zm0-6a2 2 0 102 2A2.002 2.002 0 0016 4zM26 16H21a4.0045 4.0045 0 01-4-4H15a4.0045 4.0045 0 01-4 4H6a2.0023 2.0023 0 00-2 2v4H6V18h5A5.9694 5.9694 0 0015 16.46V22h2V16.46A5.9694 5.9694 0 0021 18h5v4h2V18A2.0023 2.0023 0 0026 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bet.propTypes = E);
const Pet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wse || (Wse = /* @__PURE__ */ h.createElement("path", {
    d: "M16,18a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,18Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,10Z"
  })), jse || (jse = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,1,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pet.propTypes = E);
const Fet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zse || (Zse = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), Use || (Use = /* @__PURE__ */ h.createElement("path", {
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Z"
  })), qse || (qse = /* @__PURE__ */ h.createElement("path", {
    d: "M15 16H17V18H15zM15 12H17V14H15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fet.propTypes = E);
const zet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gse || (Gse = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M21,18H19V10H13v8H11V10a2.0021,2.0021,0,0,1,2-2h6a2.0021,2.0021,0,0,1,2,2Zm-4-2H15v2h2Zm0-4H15v2h2Z"
  })), Qse || (Qse = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm1,16H15V16h2Zm0-4H15V12h2Zm4,4H19V10H13v8H11V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zet.propTypes = E);
const Wet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kse || (Kse = /* @__PURE__ */ h.createElement("path", {
    d: "M4,12.9835a1,1,0,0,0,.6289.9448l9.6015,3.8409,3.8407,9.6019A1,1,0,0,0,19,28h.0162a1.0009,1.0009,0,0,0,.9238-.6582l8-22.0007A1,1,0,0,0,26.658,4.0594l-22,8A1.0011,1.0011,0,0,0,4,12.9835Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wet.propTypes = E);
const jet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yse || (Yse = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,15a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,17Z"
  })), Xse || (Xse = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "4",
    fill: "none"
  })), n);
});
process.env.NODE_ENV !== "production" && (jet.propTypes = E);
const Zet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jse || (Jse = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), $se || ($se = /* @__PURE__ */ h.createElement("path", {
    d: "M15 7H17V16H15z"
  })), eoe || (eoe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zet.propTypes = E);
const Uet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, toe || (toe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Zm-1.125-6h2.25V7h-2.25Z"
  })), noe || (noe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2ZM14.875,7h2.25v9h-2.25ZM16,22a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uet.propTypes = E);
const qet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ioe || (ioe = /* @__PURE__ */ h.createElement("path", {
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), roe || (roe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qet.propTypes = E);
const Get = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, soe || (soe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M18.303,9a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,18l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,9Z"
  })), ooe || (ooe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm4.2109,11.7021L16.002,18l-4.2129-4.2979a2.7992,2.7992,0,0,1,0-3.8964,2.6619,2.6619,0,0,1,3.8159,0l.397.4057.393-.4057a2.6619,2.6619,0,0,1,3.8159,0A2.7992,2.7992,0,0,1,20.2109,13.7021Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Get.propTypes = E);
const Qet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aoe || (aoe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17 18L17 11 13 11 13 13 15 13 15 18 12 18 12 20 20 20 20 18 17 18zM15.5 6c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5z"
  })), loe || (loe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,30l-8.4355-9.9487c-.0479-.0571-.3481-.4516-.3481-.4516-1.4507-1.9268-2.2163-4.2065-2.2163-6.5998,0-6.0641,4.9346-11,11-11s11,4.9359,11,11c0,2.3933-.7656,4.673-2.2148,6.5973l-.0015.0024s-.3003.3944-.3447.4474l-8.439,9.9528Zm-7.1875-11.605c.001.0007.2334.3083.2866.3744l6.9009,8.1385,6.9102-8.1498c.0439-.0552.2783-.3649.2788-.3656,1.1851-1.5746,1.811-3.4376,1.811-5.3925,0-4.9615-4.0376-9-9-9S7,8.0385,7,13c0,1.9559.627,3.8199,1.8125,5.395h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qet.propTypes = E);
const Ket = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, coe || (coe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-6.0654,0-11,4.936-11,11,0,2.3931.7656,4.6729,2.2163,6.5996,0,0,.3003.3945.3481.4517l8.4355,9.9487,8.439-9.9526c.0444-.0532.3447-.4478.3447-.4478l.0015-.0024c1.4492-1.9243,2.2148-4.2041,2.2148-6.5972,0-6.064-4.9346-11-11-11Zm-.5,4c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), hoe || (hoe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    strokeWidth: "0",
    d: "m15.5,6c.8284,0,1.5.6714,1.5,1.5s-.6716,1.5-1.5,1.5-1.5-.6714-1.5-1.5.6716-1.5,1.5-1.5Zm4.5,14h-8v-2h3v-5h-2v-2h4v7h3v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ket.propTypes = E);
const Yet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, doe || (doe = /* @__PURE__ */ h.createElement("path", {
    d: "M20 19H18V17H14v2H12V17a2.0021 2.0021 0 012-2h4a2.0021 2.0021 0 012 2zM16 14a3 3 0 113-3A3.0033 3.0033 0 0116 14zm0-4a1 1 0 101 1A1.0011 1.0011 0 0016 10z"
  })), uoe || (uoe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yet.propTypes = E);
const Xet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, foe || (foe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M20,19H18V17H14v2H12V17a2.0021,2.0021,0,0,1,2-2h4a2.0021,2.0021,0,0,1,2,2Zm-1-8a3,3,0,1,0-3,3A3.0033,3.0033,0,0,0,19,11Zm-2,0a1,1,0,1,1-1-1A1.0011,1.0011,0,0,1,17,11Z"
  })), poe || (poe = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), goe || (goe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm0,6a3,3,0,1,1-3,3A3.0033,3.0033,0,0,1,16,8Zm4,11H18V17H14v2H12V17a2.0023,2.0023,0,0,1,2-2h4a2.0023,2.0023,0,0,1,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xet.propTypes = E);
const Jet = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, moe || (moe = /* @__PURE__ */ h.createElement("path", {
    d: "M18 30h2V28a1.0009 1.0009 0 011-1h6a1.0009 1.0009 0 011 1v2h2V28a3.0033 3.0033 0 00-3-3H21a3.0033 3.0033 0 00-3 3zM24 24a4 4 0 114-4A4.0042 4.0042 0 0124 24zm0-6a2 2 0 102 2A2.0023 2.0023 0 0024 18zM25.3418 10.06l-22-8A1 1 0 002.06 3.3415l8 22A1.001 1.001 0 0010.9839 26H11a1 1 0 00.9287-.6289L15.77 15.7692l9.6016-3.8408a1 1 0 00-.0293-1.8687zM14.6284 14.0709v0l-.3979.1591-.1591.3979 0 0-3.0269 7.5678L4.6719 4.6715l17.5244 6.3726z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jet.propTypes = E);
const $et = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Aoe || (Aoe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), woe || (woe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,7.5645,20.0513c-.0479-.0571-.3482-.4515-.3482-.4515A10.8888,10.8888,0,0,1,5,13a11,11,0,0,1,22,0,10.8844,10.8844,0,0,1-2.2148,6.5973l-.0015.0025s-.3.3944-.3447.4474ZM8.8125,18.395c.001.0007.2334.3082.2866.3744L16,26.9079l6.91-8.15c.0439-.0552.2783-.3649.2788-.3657A8.901,8.901,0,0,0,25,13,9,9,0,0,0,7,13a8.9054,8.9054,0,0,0,1.8125,5.395Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($et.propTypes = E);
const ett = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, voe || (voe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16 7L17.912 10.667 22 11.173 19 13.926 19.6 18 16 15.708 12.4 18 13 13.926 10 11.173 14.2 10.667 16 7z"
  })), boe || (boe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A11.0134,11.0134,0,0,0,5,13a10.8885,10.8885,0,0,0,2.2163,6.6s.3.3945.3482.4517L16,30l8.439-9.9526c.0444-.0533.3447-.4478.3447-.4478l.0015-.0024A10.8846,10.8846,0,0,0,27,13,11.0134,11.0134,0,0,0,16,2Zm3.6,16L16,15.7085,12.4,18l.6-4.0742-3-2.7529,4.2-.5064L16,7l1.9116,3.6665L22,11.1729l-3,2.7529Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ett.propTypes = E);
const ttt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yoe || (yoe = /* @__PURE__ */ h.createElement("path", {
    d: "M24,14H22V8A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14ZM12,8a4,4,0,0,1,8,0v6H12ZM24,28H8V16H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ttt.propTypes = E);
const ntt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Coe || (Coe = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "7",
    r: "1"
  })), Eoe || (Eoe = /* @__PURE__ */ h.createElement("path", {
    d: "M27,22v-4c0-1.1046-.8954-2-2-2h-8v-4h9c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H6c-1.1046,0-2,.8954-2,2v6c0,1.1046,.8954,2,2,2H15v4H7c-1.1046,0-2,.8954-2,2v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4H15v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1v-4h8v4h-1c-1.1046,0-2,.8954-2,2v4c0,1.1046,.8954,2,2,2h4c1.1046,0,2-.8954,2-2v-4c0-1.1046-.8954-2-2-2h-1Zm-19,6H4v-4h4v4Zm10-4v4h-4v-4h4ZM6,10V4H26v6H6ZM28,28h-4v-4h4v4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ntt.propTypes = E);
const itt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _oe || (_oe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H14a2,2,0,0,1-2-2V25h2v3H26V4H14V7H12V4a2,2,0,0,1,2-2H26a2,2,0,0,1,2,2V28A2,2,0,0,1,26,30Z"
  })), xoe || (xoe = /* @__PURE__ */ h.createElement("path", {
    d: "M14.59 20.59L18.17 17 4 17 4 15 18.17 15 14.59 11.41 16 10 22 16 16 22 14.59 20.59z"
  })), n);
});
process.env.NODE_ENV !== "production" && (itt.propTypes = E);
const rtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Soe || (Soe = /* @__PURE__ */ h.createElement("path", {
    d: "M13.5,16h4.9L16,10.8L13.5,16z"
  })), Moe || (Moe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,3L3,7.6l2.7,15.8L16,29l10.3-5.6L29,7.6L16,3z M21.1,21.6l-1.5-3.2h-7.1l-1.5,3.2H8.6L16,5.3l7.4,16.2H21.1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rtt.propTypes = E);
const stt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Doe || (Doe = /* @__PURE__ */ h.createElement("path", {
    d: "M27.8,27.7L17.5,3.1C17.2,2.4,16.6,2,15.9,2c-0.7,0-1.3,0.4-1.6,1.1L3,30h3.9l4.5-11.1l13.3,10.7c0.5,0.4,0.9,0.6,1.4,0.6 c1,0,1.9-0.7,1.9-1.8C28,28.2,27.9,28,27.8,27.7z M15.9,7.5l6.7,16.4L12.5,16L15.9,7.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (stt.propTypes = E);
const ott = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Loe || (Loe = /* @__PURE__ */ h.createElement("path", {
    d: "M6.48 7.6v3.92H2V21H9.28V7.6zm0 11.2H4.8v-5H6.48zM10.4 11.52H13.2V21.04H10.4zM10.4 7.6H13.2V10.399999999999999H10.4zM14.32 11.52V21H18.8v1.12H14.32V24.4H21.6V11.52zM18.8 18.8H17.12v-5H18.8zM22.72 11.52V21H27.2v1.12H22.72V24.4H30V11.52zM27.2 18.8H25.52v-5H27.2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ott.propTypes = E);
const att = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, koe || (koe = /* @__PURE__ */ h.createElement("path", {
    d: "M25.7,7.1C23.9,6.3,22,5.7,20,5.3c0,0-0.1,0-0.1,0c-0.2,0.4-0.5,1-0.7,1.5c-2.2-0.3-4.3-0.3-6.4,0c-0.2-0.5-0.5-1-0.7-1.5 c0,0-0.1,0-0.1,0c-2,0.3-3.9,0.9-5.7,1.8c0,0,0,0,0,0c-3.6,5.4-4.6,10.7-4.1,15.9c0,0,0,0.1,0,0.1c2.4,1.8,4.7,2.8,7,3.5 c0,0,0.1,0,0.1,0c0.5-0.7,1-1.5,1.4-2.3c0,0,0-0.1,0-0.1c-0.8-0.3-1.5-0.6-2.2-1c-0.1,0-0.1-0.1,0-0.1c0.1-0.1,0.3-0.2,0.4-0.3 c0,0,0.1,0,0.1,0c4.6,2.1,9.5,2.1,14.1,0c0,0,0.1,0,0.1,0c0.1,0.1,0.3,0.2,0.4,0.3c0.1,0,0,0.1,0,0.1c-0.7,0.4-1.4,0.8-2.2,1 c0,0-0.1,0.1,0,0.1c0.4,0.8,0.9,1.6,1.4,2.3c0,0,0.1,0,0.1,0c2.3-0.7,4.6-1.8,7-3.5c0,0,0,0,0-0.1C30.5,17,28.9,11.8,25.7,7.1 C25.7,7.1,25.7,7.1,25.7,7.1z M11.4,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C13.9,18.6,12.8,19.9,11.4,19.9z M20.7,19.9c-1.4,0-2.5-1.3-2.5-2.8s1.1-2.8,2.5-2.8c1.4,0,2.5,1.3,2.5,2.8 C23.2,18.6,22.1,19.9,20.7,19.9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (att.propTypes = E);
const ltt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Noe || (Noe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.67,4H5.33A1.34,1.34,0,0,0,4,5.33V26.67A1.34,1.34,0,0,0,5.33,28H16.82V18.72H13.7V15.09h3.12V12.42c0-3.1,1.89-4.79,4.67-4.79.93,0,1.86,0,2.79.14V11H22.37c-1.51,0-1.8.72-1.8,1.77v2.31h3.6l-.47,3.63H20.57V28h6.1A1.34,1.34,0,0,0,28,26.67V5.33A1.34,1.34,0,0,0,26.67,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ltt.propTypes = E);
const ctt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Toe || (Toe = /* @__PURE__ */ h.createElement("path", {
    d: "M23.6,11.6c1-0.6,1.7-1.5,2.1-2.6c0.4-1.1,0.4-2.2,0.1-3.3c-0.3-1.1-1-2-1.9-2.7c-0.9-0.7-2.1-1-3.2-1h-9.2 c-1.2,0-2.3,0.4-3.2,1C7.2,3.7,6.6,4.7,6.2,5.7C5.9,6.8,5.9,8,6.3,9c0.4,1.1,1.1,2,2.1,2.6c-0.7,0.5-1.4,1.1-1.8,1.9 C6.2,14.3,6,15.1,6,16c0,0.9,0.2,1.7,0.6,2.5c0.4,0.8,1,1.4,1.8,1.9c-1,0.6-1.7,1.5-2.1,2.6c-0.4,1.1-0.4,2.2-0.1,3.3 c0.3,1.1,1,2,2,2.7c0.9,0.7,2.1,1,3.2,1c1.4,0,2.8-0.6,3.9-1.5c1-1,1.6-2.3,1.6-3.7v-4.8c1,0.9,2.3,1.4,3.6,1.4h0.1 c1.2,0,2.3-0.4,3.2-1c0.9-0.7,1.6-1.6,1.9-2.7c0.3-1.1,0.3-2.2-0.1-3.3C25.3,13.1,24.5,12.2,23.6,11.6z M16.9,3.7h3.7 c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2s0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2 c-0.4,0.3-0.8,0.6-1.2,0.8c-0.5,0.2-1,0.2-1.4,0.2h-3.7V3.7z M11.4,3.7h3.7v7h-3.7c-0.9,0-1.8-0.4-2.4-1.1C8.3,9,8,8.1,8,7.2 s0.4-1.8,1-2.4C9.6,4.2,10.5,3.8,11.4,3.7L11.4,3.7z M7.8,16c0-0.9,0.4-1.8,1.1-2.5c0.7-0.7,1.6-1,2.6-1h3.7v7h-3.7 c-1,0-1.9-0.4-2.6-1C8.2,17.8,7.8,16.9,7.8,16L7.8,16z M15.1,24.7c0,1-0.4,1.9-1.1,2.5c-0.7,0.7-1.6,1-2.6,1c-0.5,0-1,0-1.4-0.2 c-0.5-0.2-0.9-0.4-1.2-0.7c-0.4-0.3-0.6-0.7-0.8-1.2c-0.2-0.4-0.3-0.9-0.3-1.4c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.5-0.8,0.8-1.2 c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.2,1.4-0.2h3.7L15.1,24.7z M20.6,19.5h-0.1c-0.9,0-1.8-0.4-2.4-1.1c-0.6-0.7-1-1.5-1-2.4 c0-0.9,0.4-1.8,1-2.4c0.6-0.7,1.5-1,2.4-1.1h0.1c0.5,0,1,0,1.4,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2 c0.2,0.4,0.3,0.9,0.3,1.4c0,0.5-0.1,1-0.3,1.4c-0.2,0.4-0.5,0.8-0.8,1.2c-0.4,0.3-0.8,0.6-1.2,0.8C21.6,19.5,21.1,19.5,20.6,19.5 L20.6,19.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ctt.propTypes = E);
const htt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ioe || (Ioe = /* @__PURE__ */ h.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "6"
  })), Ooe || (Ooe = /* @__PURE__ */ h.createElement("circle", {
    cx: "24",
    cy: "16",
    r: "6"
  })), n);
});
process.env.NODE_ENV !== "production" && (htt.propTypes = E);
const dtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Roe || (Roe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.5242,14.8021L17.2022,2.5241c-.7013-.6988-1.8032-.6988-2.5045,0h0l-2.5045,2.4955,3.2057,3.1943c.8014-.2995,1.6029,0,2.2039.4991.6011.5989.8014,1.3975.5009,2.1961l3.1055,3.0945c.8014-.2995,1.6029,0,2.2039.4991.8014.7986.8014,2.1961,0,2.9947h0c-.8014.7986-2.2039.7986-3.0054,0-.6011-.5989-.8014-1.4973-.5009-2.2959l-2.9052-2.8948v7.5865c1.102.4991,1.5027,1.7968,1.0018,2.8948-.1002.1996-.2004.3993-.4007.5989-.8014.7986-2.2039.7986-3.0054,0h0c-.8014-.7986-.8014-2.1961,0-2.9947h0c.2004-.1996.4007-.3993.7013-.4991v-7.6863c-.3005-.0998-.5009-.2995-.7013-.4991-.6011-.5989-.8014-1.4973-.5009-2.2959l-3.2057-3.1943L2.4759,14.7023c-.7013.6988-.7013,1.7968,0,2.5954h0l12.2218,12.1783c.7013.6988,1.8032.6988,2.5045,0l12.2218-12.1783c.7013-.6988.7013-1.7968,0-2.5954"
  })), n);
});
process.env.NODE_ENV !== "production" && (dtt.propTypes = E);
const utt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Voe || (Voe = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M16,2a14,14,0,0,0-4.43,27.28c.7.13,1-.3,1-.67s0-1.21,0-2.38c-3.89.84-4.71-1.88-4.71-1.88A3.71,3.71,0,0,0,6.24,22.3c-1.27-.86.1-.85.1-.85A2.94,2.94,0,0,1,8.48,22.9a3,3,0,0,0,4.08,1.16,2.93,2.93,0,0,1,.88-1.87c-3.1-.36-6.37-1.56-6.37-6.92a5.4,5.4,0,0,1,1.44-3.76,5,5,0,0,1,.14-3.7s1.17-.38,3.85,1.43a13.3,13.3,0,0,1,7,0c2.67-1.81,3.84-1.43,3.84-1.43a5,5,0,0,1,.14,3.7,5.4,5.4,0,0,1,1.44,3.76c0,5.38-3.27,6.56-6.39,6.91a3.33,3.33,0,0,1,.95,2.59c0,1.87,0,3.38,0,3.84s.25.81,1,.67A14,14,0,0,0,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (utt.propTypes = E);
const ftt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hoe || (Hoe = /* @__PURE__ */ h.createElement("path", {
    d: "m28.5678,12.8926l-.0366-.0934-3.5388-9.2356c-.072-.181-.1995-.3346-.3642-.4386-.3375-.2095-.7699-.1863-1.083.0582-.1512.1228-.2608.2892-.3141.4765l-2.3894,7.3105h-9.6756l-2.3894-7.3105c-.0518-.1884-.1617-.3556-.3141-.4779-.3131-.2445-.7455-.2677-1.083-.0582-.1643.1045-.2917.2579-.3642.4386l-3.5456,9.2315-.0352.0934c-1.0465,2.7345-.1578,5.8315,2.1796,7.5948l.0122.0095.0325.023,5.3908,4.037,2.667,2.0185,1.6246,1.2265c.3905.2965.9308.2965,1.3213,0l1.6246-1.2265,2.667-2.0185,5.4233-4.0614.0135-.0108c2.3319-1.7635,3.219-4.8551,2.1769-7.5867Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ftt.propTypes = E);
const ptt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Boe || (Boe = /* @__PURE__ */ h.createElement("path", {
    d: "M10.8281,28H21.1719a3.43,3.43,0,0,0,3.43-3.43V10.3306h-3.43V24.57H7.3981A3.43,3.43,0,0,0,10.8281,28Z"
  })), Poe || (Poe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.1719,4H10.8281a3.43,3.43,0,0,0-3.43,3.43v14.24h3.43V7.43H24.6019A3.43,3.43,0,0,0,21.1719,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ptt.propTypes = E);
const gtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Foe || (Foe = /* @__PURE__ */ h.createElement("circle", {
    cx: "22.406",
    cy: "9.594",
    r: "1.44"
  })), zoe || (zoe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,9.8378A6.1622,6.1622,0,1,0,22.1622,16,6.1622,6.1622,0,0,0,16,9.8378ZM16,20a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), Woe || (Woe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,6.1622c3.2041,0,3.5837.0122,4.849.07a6.6418,6.6418,0,0,1,2.2283.4132,3.9748,3.9748,0,0,1,2.2774,2.2774,6.6418,6.6418,0,0,1,.4132,2.2283c.0577,1.2653.07,1.6449.07,4.849s-.0122,3.5837-.07,4.849a6.6418,6.6418,0,0,1-.4132,2.2283,3.9748,3.9748,0,0,1-2.2774,2.2774,6.6418,6.6418,0,0,1-2.2283.4132c-1.2652.0577-1.6446.07-4.849.07s-3.5838-.0122-4.849-.07a6.6418,6.6418,0,0,1-2.2283-.4132,3.9748,3.9748,0,0,1-2.2774-2.2774,6.6418,6.6418,0,0,1-.4132-2.2283c-.0577-1.2653-.07-1.6449-.07-4.849s.0122-3.5837.07-4.849a6.6418,6.6418,0,0,1,.4132-2.2283A3.9748,3.9748,0,0,1,8.9227,6.6453a6.6418,6.6418,0,0,1,2.2283-.4132c1.2653-.0577,1.6449-.07,4.849-.07M16,4c-3.259,0-3.6677.0138-4.9476.0722A8.8068,8.8068,0,0,0,8.14,4.63,6.1363,6.1363,0,0,0,4.63,8.14a8.8068,8.8068,0,0,0-.5578,2.9129C4.0138,12.3323,4,12.741,4,16s.0138,3.6677.0722,4.9476A8.8074,8.8074,0,0,0,4.63,23.8605a6.1363,6.1363,0,0,0,3.51,3.51,8.8068,8.8068,0,0,0,2.9129.5578C12.3323,27.9862,12.741,28,16,28s3.6677-.0138,4.9476-.0722a8.8074,8.8074,0,0,0,2.9129-.5578,6.1363,6.1363,0,0,0,3.51-3.51,8.8074,8.8074,0,0,0,.5578-2.9129C27.9862,19.6677,28,19.259,28,16s-.0138-3.6677-.0722-4.9476A8.8068,8.8068,0,0,0,27.37,8.14a6.1363,6.1363,0,0,0-3.51-3.5095,8.8074,8.8074,0,0,0-2.9129-.5578C19.6677,4.0138,19.259,4,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gtt.propTypes = E);
const mtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, joe || (joe = /* @__PURE__ */ h.createElement("path", {
    d: "M4,4v24h24V4H4z M12.1,9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c0,0,0,0,0,0c-0.8,0-1.4-0.6-1.4-1.4 C10.8,9.6,11.4,9,12.1,9z M21.5,22.2c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1l0.7-2.4c0.1-0.2,0.1-0.5,0.1-0.7 c0-0.8-0.5-1.3-1.2-1.3c-1,0-1.6,0.7-1.9,2L15.9,22h-2.3l0.4-1.7c-0.7,1.1-1.6,1.8-2.8,1.8c-1.4,0-2.1-0.8-2.1-2c0-0.3,0-0.7,0.1-1 l1.1-4.3H8.7L9.2,13h3.9l-1.5,6.1c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.4,0.2,0.5,0.5,0.6c0.2,0,1.6,0,2.4-1.8l1-4.1h-1.6l0.5-1.8h3.5 l-0.5,2.1c0.6-1.2,1.9-2.2,3.1-2.2c1.3,0,2.4,0.9,2.4,2.7c0,0.5-0.1,1-0.2,1.5l-0.7,2.4c-0.1,0.2-0.1,0.4-0.1,0.6 c0,0.4,0.2,0.6,0.5,0.6c0.3,0,0.7-0.2,1.2-1.5l0.9,0.4C23.7,21.4,22.7,22.2,21.5,22.2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mtt.propTypes = E);
const Att = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zoe || (Zoe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.0766 3.5878a1.69 1.69 0 11-1.76-1.5853 1.67 1.67 0 011.76 1.5853zM16.2191 23.1113c-4.4866 0-8.43-1.61-10.4688-3.9882a11.1618 11.1618 0 0020.9377 0C24.6541 21.5011 20.7257 23.1113 16.2191 23.1113zM16.2191 7.6483c4.4867 0 8.43 1.61 10.4689 3.9881a11.1618 11.1618 0 00-20.9377 0C7.7892 9.2535 11.7126 7.6483 16.2191 7.6483zM10.0427 27.7388a2.1085 2.1085 0 11-.2031-.7976 2.1278 2.1278 0 01.2031.7976zM6.26 7.1064A1.2263 1.2263 0 117.4517 5.83 1.2415 1.2415 0 016.26 7.1064z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Att.propTypes = E);
const wtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Uoe || (Uoe = /* @__PURE__ */ h.createElement("path", {
    d: "M14.1233 26.9328a1.1122 1.1122 0 11-1.1121-1.1122 1.112 1.112 0 011.1121 1.1122M21.0257 26.9328a1.1122 1.1122 0 11-1.1122-1.1122 1.1121 1.1121 0 011.1122 1.1122"
  })), qoe || (qoe = /* @__PURE__ */ h.createElement("path", {
    d: "M9.999 5.797H10.973V6.771H9.999z",
    transform: "rotate(-86.462 10.486 6.284)"
  })), Goe || (Goe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.4275,16.3825l-.0013.001a13.0868,13.0868,0,0,0-5.1431-4.1825c-.3754-.1667-.7543-.3142-1.1354-.4454.0128-.0314.0277-.0615.04-.0933a4.83,4.83,0,0,0-2.9861-6.319,5.9368,5.9368,0,0,0-1.9962-.3558c-.0366-.1253-.1165-.6743.58-2.1571L14.3742,2q-.17.236-.3368.4661c-.384.5309-.7549,1.0444-1.1029,1.55a2.1657,2.1657,0,0,0-1.4486-.6771L9.8543,3.2377H9.852l-.0025,0c-.0429-.0025-.0864-.0039-.1293-.0039A2.1877,2.1877,0,0,0,7.54,5.2825L7.4388,6.9169l0,.003,0,.0028A2.1882,2.1882,0,0,0,9.4854,9.23l1.1673.0723a5.1711,5.1711,0,0,0,.47,2.688,13.1954,13.1954,0,0,0-4.2637,2.9C3,18.7883,3,23.06,3,26.4916v2.0706l1.524-1.6163A12.3293,12.3293,0,0,0,5.8548,30H7.8367A10.7091,10.7091,0,0,1,5.878,25.51l2.2353-2.3708L6.963,26.745l2.03-1.4774c3.5858-2.61,7.8678-3.2093,12.7263-1.7826a4.6276,4.6276,0,0,0,5.2189-1.468c.0441-.0628.0828-.128.1228-.1926a9.6141,9.6141,0,0,1,.1638,1.7454,12.4214,12.4214,0,0,1-1.61,6.43h1.877A14.4022,14.4022,0,0,0,28.87,23.57,12.2666,12.2666,0,0,0,26.4275,16.3825ZM13.8455,5.9257a1.5872,1.5872,0,0,0,1.3983.7068,4.2111,4.2111,0,0,1,1.44.2719,3.17,3.17,0,0,1,1.0279,5.4638l-.4752-.5849-.0032-.004a1.7048,1.7048,0,0,0-3.0235.9865,3.2143,3.2143,0,0,1-1.899-3.5412,8.4815,8.4815,0,0,1,1.4374-3.466A1.642,1.642,0,0,0,13.8455,5.9257Zm3.49,9.2589-.6072.4962a.2675.2675,0,0,1-.376-.038l-.1264-.1549a.2791.2791,0,0,1,.0394-.3927l.6-.49-1.235-1.5158a.362.362,0,1,1,.5611-.4575l3.4546,4.2517a.3619.3619,0,0,1-.1988.5815.3566.3566,0,0,1-.0816.0094.3609.3609,0,0,1-.2806-.1332l-.3441-.4239-1.2215.9971a.2815.2815,0,0,1-.3965-.04l-.5532-.6775a.2786.2786,0,0,1,.04-.3919l1.2275-1.002ZM9.08,7.0184l.1014-1.6342A.5394.5394,0,0,1,9.72,4.8781l.0326.001,1.6335.1013a.5387.5387,0,0,1,.5046.5716l-.0073.1182a10.6739,10.6739,0,0,0-.9028,2.0046L9.5859,7.5886A.5407.5407,0,0,1,9.08,7.0184ZM25.5944,21.07a2.9883,2.9883,0,0,1-3.4112.8373c-4.5313-1.3305-8.6289-1.0534-12.2124.82l1.9069-5.978-7.203,7.6393a11.67,11.67,0,0,1,3.3532-8.3419,11.4953,11.4953,0,0,1,4.1073-2.6908,5.42,5.42,0,0,0,2.2411,1.2214,4.714,4.714,0,0,0,.5627.12,1.6258,1.6258,0,0,0,.2449,1.6416l.0847.1038a1.6247,1.6247,0,0,0,.2594,1.605l.5532.6777a1.6276,1.6276,0,0,0,2.29.2314l.3314-.2705a1.7079,1.7079,0,0,0,1.9867-2.6535l-1.9427-2.3911a4.88,4.88,0,0,0,.4863-.456,12.449,12.449,0,0,1,1.3829.5181,11.419,11.419,0,0,1,4.5085,3.6838C26.0987,18.7278,26.2745,20.1043,25.5944,21.07Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wtt.propTypes = E);
const vtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qoe || (Qoe = /* @__PURE__ */ h.createElement("path", {
    d: "M15.134 17.189L15.999 17.605 16.862 17.19 17.076 16.259 16.479 15.512 15.518 15.512 14.919 16.257 15.134 17.189zM14.2166 13.88l.0024.0019a.5239.5239 0 00.8321-.4013l0-.003.0127-.0063L15.242 10.33c-.2173.0268-.43.0635-.6333.1094a6.2 6.2 0 00-2.9727 1.6176l2.5752 1.8257zM12.8347 16.2622l.003-.001a.5241.5241 0 00.206-.9008l-.0024-.002.0029-.0127-2.3515-2.1035a6.1775 6.1775 0 00-.8746 3.9l3.0142-.87zM13.8645 18.501a.5229.5229 0 00-.6059-.3989l-.0034 0-.0049-.0063-3.0908.5249a6.2052 6.2052 0 002.4863 3.1108l1.1972-2.8935-.0087-.0117.0009-.003A.5184.5184 0 0013.8645 18.501zM16.4622 19.6431l-.0015-.0025a.53.53 0 00-.48-.2759.5269.5269 0 00-.4434.2769l-.0015.0029H15.533l-1.52 2.7481a6.2277 6.2277 0 003.38.1723c.207-.0468.41-.104.6044-.1684l-1.5234-2.7534zM18.7371 18.09l-.0034 0a.51.51 0 00-.1206-.0088.5263.5263 0 00-.4546.7319l.001.0024-.004.0054 1.21 2.9234A6.185 6.185 0 0021.86 18.61l-3.1176-.5269zM21.2893 13.2437L18.951 15.3364l.0014.0064-.0024.0019a.5249.5249 0 00.2055.9014l.0035.0005.0024.0132 3.0293.872a6.2915 6.2915 0 00-.9014-3.8881zM16.9383 13.4673l0 .0029a.5161.5161 0 00.1143.3037.5236.5236 0 00.7192.0967l.0025-.0019.0088.0039 2.5586-1.814a6.2307 6.2307 0 00-3.584-1.7285l.1777 3.1357z"
  })), Koe || (Koe = /* @__PURE__ */ h.createElement("path", {
    d: "M30.3806,19.0376,27.9016,8.2705a1.9057,1.9057,0,0,0-1.038-1.291L16.83,2.1885a1.9332,1.9332,0,0,0-1.6656,0L5.1326,6.9819a1.9072,1.9072,0,0,0-1.0381,1.291L1.6194,19.04A1.89,1.89,0,0,0,1.88,20.499a1.8364,1.8364,0,0,0,.1088.1514l6.9439,8.6338a1.9244,1.9244,0,0,0,1.5.7158l11.1357-.0024a1.9251,1.9251,0,0,0,1.5-.7149L30.01,20.6479A1.8911,1.8911,0,0,0,30.3806,19.0376Zm-3.8115-.13a.6432.6432,0,0,1-.7812.4429l-.0039,0-.0049-.001-.0069-.0019-.0048-.002-.0572-.0117c-.0346-.0068-.07-.0142-.0981-.0215a2.4643,2.4643,0,0,1-.3589-.1328c-.0576-.0249-.1172-.0513-.1807-.0752l-.0175-.0063a5.5192,5.5192,0,0,0-1.0284-.3013.4119.4119,0,0,0-.2954.0981l-.0371.0254-.0019.0015-.002,0c-.0439-.0088-.1748-.0322-.2519-.0444a7.8166,7.8166,0,0,1-3.459,4.351c.0093.022.02.05.0307.0806a.9352.9352,0,0,0,.0669.1567l.002.002-.001.0029-.0166.042a.4148.4148,0,0,0-.03.3091,5.69,5.69,0,0,0,.5322.9517c.0376.0561.0757.1084.1128.1591a2.4,2.4,0,0,1,.2095.32c.0166.0312.0371.0752.0552.1137l.0229.0484a.6083.6083,0,1,1-1.0947.5176l-.0224-.0455c-.0186-.038-.0381-.0776-.0518-.1088a2.5059,2.5059,0,0,1-.1211-.3658c-.0166-.0595-.0337-.1215-.0537-.185l-.0059-.0166a5.5441,5.5441,0,0,0-.4052-.9922.4177.4177,0,0,0-.2627-.1709l-.0415-.0127-.0015,0-.0015-.0019c-.01-.0171-.0337-.0611-.0595-.1075-.0235-.042-.0484-.0874-.0664-.12a7.8868,7.8868,0,0,1-1.0269.3091,7.7588,7.7588,0,0,1-4.51-.3233l-.1352.2442-.002.001a.481.481,0,0,0-.2563.124,2.2827,2.2827,0,0,0-.336.7207c-.04.1172-.08.2383-.1279.3569-.0205.064-.0376.127-.0537.188a2.4747,2.4747,0,0,1-.12.3623c-.0127.03-.0313.0669-.0493.1025l-.0245.0494h0l-.0005.0024-.0019.002a.6773.6773,0,0,1-.5952.3945.5484.5484,0,0,1-.24-.0542.6426.6426,0,0,1-.2578-.86c.0088-.0171.0176-.0371.0274-.0576.0171-.0371.0346-.0757.05-.1045a2.53,2.53,0,0,1,.21-.3222c.0367-.05.0747-.1026.1118-.1578a5.8209,5.8209,0,0,0,.543-.976.5889.5889,0,0,0-.0532-.336l0-.0019,0-.002.1074-.2573a7.8224,7.8224,0,0,1-3.46-4.32l-.2593.0444-.0015-.001-.0264-.0151a.5961.5961,0,0,0-.3159-.106,5.5447,5.5447,0,0,0-1.0283.3013l-.0171.0064c-.062.0239-.1211.0488-.1782.0732a2.4949,2.4949,0,0,1-.3613.1333c-.0308.0083-.0708.0171-.1094.0249l-.0459.01-.0049.0019-.0068.002-.0049.001-.0039,0a.6078.6078,0,1,1-.2695-1.18l.0039-.001.0053-.0015.002,0,.0034-.0009.0469-.0113c.04-.01.081-.02.1133-.0258a2.4132,2.4132,0,0,1,.3808-.0357c.063-.0024.1284-.0054.1958-.0107l.0142-.0015A5.554,5.554,0,0,0,7.77,17.92a.72.72,0,0,0,.231-.227l.0244-.0318.001-.0014.0014,0,.2471-.0718a7.7765,7.7765,0,0,1,1.2246-5.4126l-.19-.17,0-.002-.0044-.0278a.5983.5983,0,0,0-.1153-.3159,5.6171,5.6171,0,0,0-.8916-.6265c-.0585-.0342-.1157-.0649-.1713-.0942a2.4731,2.4731,0,0,1-.3267-.1973c-.0264-.0195-.0586-.0459-.0894-.0713l-.0356-.0288L7.67,10.6387l-.0049-.0039A.7045.7045,0,0,1,7.4041,10.2a.5725.5725,0,0,1,.1128-.4575A.5835.5835,0,0,1,8,9.5288a.7226.7226,0,0,1,.4214.1592l.0361.0283c.0332.0259.07.0552.0972.0781a2.5254,2.5254,0,0,1,.2671.2759c.04.0469.0825.0952.1284.1441l.01.01a5.5221,5.5221,0,0,0,.7989.72.4159.4159,0,0,0,.31.0406l.043-.0069h.0019l.0015.001c.0357.0264.1484.1074.2134.1514a7.7273,7.7273,0,0,1,3.9233-2.24,7.9671,7.9671,0,0,1,1.0816-.1665l.0141-.2515.001-.0014a.6486.6486,0,0,0,.1939-.3076,5.5779,5.5779,0,0,0-.066-1.0791l-.0009-.0088c-.0093-.0664-.021-.13-.0328-.1914a2.5611,2.5611,0,0,1-.0493-.38c-.0009-.03-.0005-.0679,0-.1045l.0005-.05-.0005-.0073,0-.0093a.6088.6088,0,1,1,1.211,0l.0009.0605c.001.0386.0015.0791.0005.11a2.5348,2.5348,0,0,1-.0493.38c-.0117.0615-.0234.125-.0327.1914l-.0039.0317a5.4479,5.4479,0,0,0-.064,1.0567.4132.4132,0,0,0,.1616.2666l.0328.03.0019.0015v.0019c.0015.0435.0083.1836.0137.2637a7.79,7.79,0,0,1,2.7173.7559,7.8812,7.8812,0,0,1,2.2632,1.65l.226-.1612h.002l.0312.002a.5914.5914,0,0,0,.33-.041,5.4885,5.4885,0,0,0,.7871-.71l.0215-.022c.0454-.0478.0869-.0952.1274-.1416a2.57,2.57,0,0,1,.27-.2783c.0263-.0229.062-.05.0967-.0776l.0366-.0288a.6088.6088,0,1,1,.7544.9472l-.0435.0357c-.0307.0254-.063.0517-.0884.0708a2.4733,2.4733,0,0,1-.3266.1968c-.0562.0293-.1143.06-.1734.0947a5.6889,5.6889,0,0,0-.8921.6269.4152.4152,0,0,0-.1079.293l-.0034.044v.0019l-.0014.001c-.0162.0146-.0508.0459-.0914.082s-.0864.0772-.1186.1065a7.7983,7.7983,0,0,1,1.25,5.3994l.24.07.001.001.0171.0254a.6014.6014,0,0,0,.24.2334,5.595,5.595,0,0,0,1.063.1757l.0122.001c.0674.0059.1328.0083.1963.0108a2.4617,2.4617,0,0,1,.38.0356c.0312.0059.0713.0156.11.0254l.0644.0156A.643.643,0,0,1,26.5691,18.9077Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vtt.propTypes = E);
const btt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yoe || (Yoe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.2,4H5.8C4.8,4,4,4.8,4,5.7v20.5c0,0.9,0.8,1.7,1.8,1.7h20.4c1,0,1.8-0.8,1.8-1.7V5.7C28,4.8,27.2,4,26.2,4z M11.1,24.4 H7.6V13h3.5V24.4z M9.4,11.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1S10.5,11.4,9.4,11.4z M24.5,24.3 H21v-5.6c0-1.3,0-3.1-1.9-3.1c-1.9,0-2.1,1.5-2.1,2.9v5.7h-3.5V13h3.3v1.5h0.1c0.5-0.9,1.7-1.9,3.4-1.9c3.6,0,4.3,2.4,4.3,5.5V24.3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (btt.propTypes = E);
const ytt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xoe || (Xoe = /* @__PURE__ */ h.createElement("path", {
    d: "M22.49 23.71h-.76c-2.26 0-4.52 0-6.78 0a3.12 3.12 0 01-2.41-1A14.91 14.91 0 0110 18.88c-1.3-2.6-2.54-5.22-3.82-7.82-.39-.8-.82-1.56-1.28-2.32A7.84 7.84 0 002 5.6c1.24 0 2.41 0 3.57 0a45.63 45.63 0 017 .61 8.09 8.09 0 016.34 5.09 48.51 48.51 0 012.17 7.36A26 26 0 0022.49 23.71zM28.1 26.38a2.93 2.93 0 01-2.74-2.64 42.08 42.08 0 01-.14-4.9 48 48 0 00-.61-7.58 3.75 3.75 0 00-.83-2h2.65c.54 0 .73.37.89.78A12.1 12.1 0 0128 13.28c.29 2.72.31 5.45.33 8.18a10.94 10.94 0 000 1.15c.09.78.4 1.1 1.17 1.08.5 0 .5-.06.5-.06v2.69A8.62 8.62 0 0128.1 26.38z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ytt.propTypes = E);
const Ctt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Joe || (Joe = /* @__PURE__ */ h.createElement("path", {
    d: "m29.0581,11.1929c0-6.0742-3.9797-7.8545-3.9797-7.8545-2.0066-.9214-5.4522-1.3091-9.0318-1.3384h-.0879c-3.5798.0293-7.023.417-9.0296,1.3384,0,0-3.98,1.7803-3.98,7.8545,0,1.3911-.0271,3.0537.0171,4.8174.1445,5.9404,1.0889,11.7945,6.5811,13.2481,2.5322.6704,4.7063.8105,6.4573.7144,3.1755-.1758,4.958-1.1333,4.958-1.1333l-.1047-2.3037s-2.269.7153-4.8176.6284c-2.5249-.0869-5.1902-.2725-5.5986-3.3726-.0378-.272-.0566-.563-.0566-.8691,0,0,2.4785.606,5.6196.75,1.9207.0879,3.7219-.1128,5.5515-.3311,3.5083-.4189,6.563-2.5806,6.9468-4.5557.605-3.1113.5552-7.5928.5552-7.5928Zm-4.6943,7.8257h-2.9138v-7.1382c0-1.5049-.6331-2.2686-1.8997-2.2686-1.4002,0-2.1018.9058-2.1018,2.6973v3.9077h-2.8967v-3.9077c0-1.7915-.7019-2.6973-2.1021-2.6973-1.2666,0-1.8997.7637-1.8997,2.2686v7.1382h-2.9138v-7.3545c0-1.5029.3828-2.6978,1.1516-3.5811.7927-.8838,1.8308-1.3369,3.1196-1.3369,1.491,0,2.6204.5732,3.367,1.7192l.7256,1.2168.7261-1.2168c.7463-1.146,1.8755-1.7192,3.3667-1.7192,1.2886,0,2.3267.4531,3.1196,1.3369.7686.8833,1.1514,2.0781,1.1514,3.5811v7.3545Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ctt.propTypes = E);
const Ett = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $oe || ($oe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 16c0 3.7-.6 6.7-1.4 6.7-.8 0-1.4-3-1.4-6.7s.6-6.7 1.4-6.7C29.4 9.3 30 12.3 30 16M26.5 16c0 4.1-1.8 7.5-3.9 7.5s-3.9-3.4-3.9-7.5 1.8-7.5 3.9-7.5S26.5 11.9 26.5 16M17.8 16c0 4.4-3.5 8-7.9 8S2 20.4 2 16s3.5-8 7.9-8S17.8 11.6 17.8 16"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ett.propTypes = E);
const _tt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eae || (eae = /* @__PURE__ */ h.createElement("path", {
    d: "M4,28V4h24v24H4z M8.5,8.5v15H16v-12h4.5v12h3v-15H8.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_tt.propTypes = E);
const xtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tae || (tae = /* @__PURE__ */ h.createElement("path", {
    d: "M26.4612,15.7968A12.1352,12.1352,0,0,0,25.2821,11.48L29,10.13a11.9879,11.9879,0,0,0-1.0281-1.7382l-1.7431.635a11.9884,11.9884,0,0,0-21.71,7.9129l1.7477-.6412a12.19,12.19,0,0,0,.3309,1.9846L2.8838,19.6384A12.1451,12.1451,0,0,0,4.7565,23.7l1.9663-.7163.0026.0039a11.8856,11.8856,0,0,0,4.67,3.8909A12.013,12.013,0,0,0,27.34,21.0743a11.8725,11.8725,0,0,0,1.08-5.992Zm-2.92,3.4967a7.8,7.8,0,0,1-10.3533,3.7744,7.7207,7.7207,0,0,1-2.2714-1.6128l-1.9846.7235a7.84,7.84,0,0,1-2.0742-3.9895l.0009-.0008,3.7242-1.3566a7.8175,7.8175,0,0,1-.1232-2.0653l-1.7517.6362A7.7729,7.7729,0,0,1,19.7645,8.94h.0067a7.7442,7.7442,0,0,1,2.2646,1.615L23.78,9.921a7.8014,7.8014,0,0,1,1.229,1.6558l-3.71,1.3595a7.8245,7.8245,0,0,1,.9766,4.3882l1.9685-.7151A7.6714,7.6714,0,0,1,23.5411,19.2935Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xtt.propTypes = E);
const Stt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nae || (nae = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2a14,14,0,0,0-5.1,27,13.24,13.24,0,0,1,0-4l1.65-7A5.05,5.05,0,0,1,12.17,16c0-1.94,1.13-3.4,2.53-3.4a1.76,1.76,0,0,1,1.77,2c0,1.2-.76,3-1.16,4.66a2,2,0,0,0,2.08,2.53c2.48,0,4.4-2.63,4.4-6.41a5.53,5.53,0,0,0-5.85-5.7,6.06,6.06,0,0,0-6.32,6.08,5.42,5.42,0,0,0,1,3.19.44.44,0,0,1,.1.4c-.11.44-.35,1.4-.39,1.59s-.21.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43,0-4.41,3.21-8.47,9.25-8.47,4.85,0,8.63,3.46,8.63,8.09,0,4.82-3,8.7-7.27,8.7a3.76,3.76,0,0,1-3.21-1.6l-.87,3.33a15.55,15.55,0,0,1-1.74,3.67A14.17,14.17,0,0,0,16,30,14,14,0,0,0,16,2"
  })), n);
});
process.env.NODE_ENV !== "production" && (Stt.propTypes = E);
const Mtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iae || (iae = /* @__PURE__ */ h.createElement("path", {
    d: "M23.4882,9.14v2.9663a4.2843,4.2843,0,0,1-4.173,4.2352H12.6431a3.4077,3.4077,0,0,0-3.34,3.3945v6.3607c0,1.81,1.5742,2.8751,3.34,3.3945a11.1762,11.1762,0,0,0,6.6721,0c1.6817-.4869,3.34-1.4668,3.34-3.3945V23.55H15.983v-.8486H25.9951c1.9414,0,2.6648-1.3542,3.34-3.3867a11.4642,11.4642,0,0,0,0-6.7889c-.48-1.9327-1.3961-3.3867-3.34-3.3867ZM19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), rae || (rae = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M19.7356,25.2476a1.2731,1.2731,0,1,1-1.2534,1.269A1.2607,1.2607,0,0,1,19.7356,25.2476Z"
  })), sae || (sae = /* @__PURE__ */ h.createElement("path", {
    d: "M15.8351,2a19.0717,19.0717,0,0,0-3.192.2725c-2.8268.4994-3.34,1.5447-3.34,3.4723V8.2909h6.68V9.14H6.7962a4.1708,4.1708,0,0,0-4.173,3.3867,12.4855,12.4855,0,0,0,0,6.7889c.4748,1.9776,1.6088,3.3867,3.55,3.3867H8.47V19.65a4.2449,4.2449,0,0,1,4.173-4.15h6.6721a3.3654,3.3654,0,0,0,3.34-3.3944V5.745a3.729,3.729,0,0,0-3.34-3.4723A20.8377,20.8377,0,0,0,15.8351,2ZM12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), oae || (oae = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M12.2226,4.0478a1.2731,1.2731,0,1,1-1.2534,1.2768A1.2675,1.2675,0,0,1,12.2226,4.0478Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mtt.propTypes = E);
const Dtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aae || (aae = /* @__PURE__ */ h.createElement("path", {
    d: "M29,23.86H27a1.72,1.72,0,0,1-1.73,1.72c-1.15,0-1.82-.86-2.58-2a11,11,0,0,0,4.79-9.1c.09-7.19-5.85-11.89-12.17-11.89S3,7.37,3,14.37,9,26.16,15.17,26.16a10.71,10.71,0,0,0,3.07-.48c1.15,2.11,2.59,3.74,5.46,3.74A5,5,0,0,0,29,23.86Zm-8.14-3.45a6.31,6.31,0,0,0-5.56-3.16,6,6,0,0,0-3.74,1.15L12.2,20a2.56,2.56,0,0,1,.86-.1c1.82,0,3,1.53,4.12,3.64a7.58,7.58,0,0,1-1.91.19C10.86,23.76,9,20.6,9,14.47s1.91-9.3,6.23-9.3,6.32,3.16,6.32,9.3A20.68,20.68,0,0,1,20.83,20.41Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dtt.propTypes = E);
const Ltt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lae || (lae = /* @__PURE__ */ h.createElement("path", {
    fillRule: "evenodd",
    d: "M30,14.7842c0-5.1782-6.2681-9.376-14-9.376S2,9.606,2,14.7842c0,4.6147,4.9814,8.4419,11.5361,9.2226v2.9917l4.7762-.0019,0-2.9741a19.3812,19.3812,0,0,0,3.3418-.6646L23.593,27l5.3975-.0024-3.253-5.4849C28.3625,19.8086,30,17.4263,30,14.7842Zm-22.4983.7c0-3.54,4.7644-6.41,10.6414-6.41s10.2138,1.9629,10.2138,6.41A5.4694,5.4694,0,0,1,24.9587,20.61a3.2252,3.2252,0,0,0-.2978-.1749,10.4735,10.4735,0,0,0-1.34-.5048s4.1743-.31,4.1743-4.4659-4.3684-4.2343-4.3684-4.2343H13.5361V21.2554C9.97,20.22,7.5017,18.0283,7.5017,15.4839Zm13.7422,1.8452-2.8928.001.0014-2.6812,2.8914.0015a1.2476,1.2476,0,0,1,1.34,1.3149A1.3232,1.3232,0,0,1,21.2439,17.3291Zm-2.9326,3.4946h1.2825a.8785.8785,0,0,1,.6406.291,3.2917,3.2917,0,0,1,.51.63,22.4033,22.4033,0,0,1-2.4326.1455Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ltt.propTypes = E);
const ktt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cae || (cae = /* @__PURE__ */ h.createElement("path", {
    d: "M25,11.6c-0.3-0.1-0.6-0.2-0.9-0.3c0-0.2,0.1-0.4,0.1-0.6c0.7-3.3,0.2-6-1.3-6.9c-1.5-0.8-3.9,0-6.3,2.1 c-0.2,0.2-0.5,0.4-0.7,0.6c-0.2-0.1-0.3-0.3-0.5-0.4C13,3.9,10.5,3,9,3.9c-1.5,0.8-1.9,3.4-1.3,6.5c0.1,0.3,0.1,0.6,0.2,0.9 c-0.4,0.1-0.7,0.2-1,0.3c-3,1-4.9,2.7-4.9,4.3c0,1.7,2,3.5,5.1,4.5c0.2,0.1,0.5,0.2,0.8,0.2c-0.1,0.3-0.2,0.7-0.2,1 c-0.6,3.1-0.1,5.5,1.3,6.4c1.5,0.9,4,0,6.5-2.2c0.2-0.2,0.4-0.4,0.6-0.5c0.2,0.2,0.5,0.5,0.8,0.7c2.4,2.1,4.7,2.9,6.2,2 c1.5-0.9,2-3.5,1.4-6.7c0-0.2-0.1-0.5-0.2-0.8c0.2-0.1,0.4-0.1,0.5-0.2c3.2-1.1,5.3-2.8,5.3-4.5C30,14.3,28,12.7,25,11.6z M17.5,6.9 c2.1-1.8,4-2.5,4.9-2c0.9,0.5,1.3,2.7,0.7,5.6c0,0.2-0.1,0.4-0.1,0.6c-1.2-0.3-2.5-0.5-3.7-0.6c-0.7-1-1.5-2-2.4-3 C17.1,7.3,17.3,7.1,17.5,6.9L17.5,6.9z M10.3,17.4c0.3,0.5,0.5,1,0.8,1.5c0.3,0.5,0.6,1,0.9,1.4c-0.9-0.1-1.7-0.2-2.6-0.4 C9.6,19.1,9.9,18.3,10.3,17.4z M10.3,14.6c-0.4-0.8-0.6-1.6-0.9-2.4c0.8-0.2,1.7-0.3,2.5-0.4c-0.3,0.5-0.6,0.9-0.9,1.4 C10.8,13.6,10.5,14.1,10.3,14.6L10.3,14.6z M10.9,16c0.4-0.8,0.8-1.5,1.2-2.3c0.4-0.7,0.9-1.5,1.4-2.2c0.8-0.1,1.7-0.1,2.6-0.1 c0.9,0,1.7,0,2.6,0.1c0.5,0.7,0.9,1.4,1.3,2.2c0.4,0.7,0.8,1.5,1.2,2.3c-0.4,0.8-0.8,1.5-1.2,2.3c-0.4,0.7-0.9,1.5-1.3,2.2 c-0.8,0.1-1.7,0.1-2.6,0.1c-0.9,0-1.7,0-2.5-0.1c-0.5-0.7-0.9-1.4-1.4-2.2C11.7,17.5,11.3,16.8,10.9,16L10.9,16z M20.9,18.9 c0.3-0.5,0.6-1,0.8-1.5c0.4,0.8,0.7,1.6,0.9,2.5c-0.9,0.2-1.7,0.3-2.6,0.4C20.4,19.8,20.7,19.3,20.9,18.9z M21.7,14.6 c-0.3-0.5-0.5-1-0.8-1.5c-0.3-0.5-0.6-0.9-0.8-1.4c0.9,0.1,1.7,0.3,2.6,0.4C22.4,13,22.1,13.8,21.7,14.6z M16,8.3 c0.6,0.6,1.1,1.3,1.6,2c-1.1-0.1-2.2-0.1-3.3,0C14.9,9.6,15.5,8.9,16,8.3z M9.6,4.9c0.9-0.5,3,0.2,5.2,2.2c0.1,0.1,0.3,0.3,0.4,0.4 c-0.9,0.9-1.7,1.9-2.4,3c-1.3,0.1-2.5,0.3-3.7,0.6c-0.1-0.3-0.1-0.6-0.2-0.9C8.3,7.5,8.7,5.4,9.6,4.9z M8.2,19.6 c-0.2-0.1-0.5-0.1-0.7-0.2c-1.4-0.5-2.5-1.1-3.3-1.7c-0.7-0.6-1-1.2-1-1.7c0-1,1.5-2.3,4.1-3.2c0.3-0.1,0.6-0.2,1-0.3 C8.6,13.7,9,14.9,9.6,16C9,17.2,8.6,18.4,8.2,19.6z M14.7,25.1c-1.1,1-2.2,1.6-3.1,2c-0.9,0.3-1.5,0.3-2,0.1 c-0.9-0.5-1.3-2.5-0.8-5.1C8.9,21.7,9,21.4,9,21c1.2,0.3,2.5,0.5,3.8,0.5c0.7,1,1.5,2,2.4,3C15,24.7,14.9,24.9,14.7,25.1z M16,23.7 c-0.6-0.6-1.1-1.3-1.7-2c0.5,0,1.1,0,1.6,0c0.6,0,1.1,0,1.7,0C17.2,22.4,16.6,23.1,16,23.7z M23.3,25.4c-0.2,0.9-0.5,1.5-0.9,1.7 c-0.9,0.5-2.8-0.2-4.8-1.9c-0.2-0.2-0.5-0.4-0.7-0.6c0.8-0.9,1.6-1.9,2.3-3c1.3-0.1,2.5-0.3,3.8-0.6c0.1,0.2,0.1,0.5,0.2,0.7 C23.5,23.1,23.5,24.4,23.3,25.4z M24.3,19.4c-0.2,0-0.3,0.1-0.5,0.1c-0.4-1.2-0.9-2.4-1.4-3.6c0.5-1.1,1-2.3,1.4-3.5 c0.3,0.1,0.6,0.2,0.8,0.3c2.6,0.9,4.2,2.2,4.2,3.2C28.8,17.1,27.1,18.5,24.3,19.4z"
  })), hae || (hae = /* @__PURE__ */ h.createElement("path", {
    d: "M16,18.5c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.7,0.9-1.1c0.2-0.5,0.2-1,0.1-1.5c-0.1-0.5-0.3-0.9-0.7-1.3 c-0.3-0.4-0.8-0.6-1.3-0.7c-0.5-0.1-1,0-1.5,0.1c-0.5,0.2-0.9,0.5-1.1,0.9c-0.3,0.4-0.4,0.9-0.4,1.4c0,0.3,0.1,0.7,0.2,1 c0.1,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.5,0.4,0.8,0.5C15.3,18.4,15.7,18.5,16,18.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ktt.propTypes = E);
const Ntt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dae || (dae = /* @__PURE__ */ h.createElement("path", {
    d: "M13.2148,13.1793c.2327-.501-.4158-.9337-.9252-.8189-.3831.0863-.8737.7158-1.0126,1.0705.0842.5294,1.6957.2715,1.9378-.2516ZM12.8453,12.7614c.06.5895-.6263.5432-1.0515.5242.2484-.3642.5768-.7484,1.0515-.5242ZM16,21.8211c.9062-.0084,1.2-1.8673.4673-2.0052-.0768-.0137-.2548-.0231-.4673-.0253-.2126.0021-.3906.0116-.4674.0253-.7326.1379-.4389,1.9968.4674,2.0052ZM12.154,19.6017c1.2337-.0746,1.1996-2.8773-.0815-2.8101-1.4228.0746-1.2452,2.8903.0815,2.8101ZM26.8406,9.7584c-.52-.6715-1.2484-2.2767-2.0789-2.4473-1.2431-.2547-2.1147.3842-2.923,1.221-1.6652-1.2252-3.7147-2.3188-5.8387-2.3052-2.1241-.0137-4.1736,1.08-5.8387,2.3052-.8084-.8368-1.68-1.4757-2.9231-1.221-.8305.1705-1.5589,1.7758-2.0789,2.4473-.9073,1.1747-3.1978,3.1746-3.1588,4.7346.0484,1.9073,4.4714,7.2376,6.3776,7.5229.4211.0631.7842-.0421,1.1874-.0842.7214,1.4147,1.8981,2.4644,3.2742,3.1268,1.9797.953,4.3409.953,6.3207,0,1.376-.6624,2.5527-1.7121,3.2742-3.1268.4031.0421.7662.1473,1.1873.0842,1.9062-.2853,6.3292-5.6156,6.3777-7.5229.0389-1.56-2.2515-3.5599-3.1589-4.7346h-.0001ZM11.1285,9.2016c1.6884-1.1799,3.2167-1.8304,4.8715-1.7957,1.6547-.0347,3.183.6158,4.8714,1.7957.3747.261,1.4536,1.0516,1.6978,1.3547.5905.7305.5526,3.2515.5853,4.204h-2.1263c-.9337,0-1.8673.001-2.801,0-.3168,0-.6905.201-.9157.421-.6642.6505-.2316,1.52-.2632,2.3157-.3494-.1453-.6979-.2-1.0483-.2084-.3505.0084-.699.0632-1.0484.2084-.0316-.7958.401-1.6652-.2632-2.3157-.2252-.22-.5989-.421-.9157-.421-.9337.001-1.8673,0-2.801,0h-2.1263c.0327-.9526-.0052-3.4736.5853-4.204.2442-.3032,1.3231-1.0937,1.6978-1.3547ZM8.6855,20.9191c-1.3947-.0516-5.3871-4.9725-5.5187-6.3293-.1126-1.1673,2.2062-3.2589,2.9399-4.1998.3547-.4537,1.14-2.0147,1.641-2.0473.4168-.0263,1.3157.5378,1.5052.9052.3968.7684-.179.8516-.4274,1.4389-.5137,1.2126-.3632,2.7736-.4127,4.062-.782.1769-1.4136.5273-1.361,1.4294.0253.4453.9062,3.3241,1.141,3.7094.3074.5042.8189.7263,1.3894.7684l-.8968.2632h0ZM9.3718,20.2338c-.4716.0221-.7389-.319-.9337-.6968-.2158-.4189-1.0146-3.0568-1.0431-3.4894-.0347-.52.5684-.8505,1.0294-.8652,0,1.7273.481,3.4041.9473,5.0514h0ZM8.8455,15.1814h5.1051c.3379.0674.7642.5432.7852.9.0264.4274-.3221,2.5242-.4452,3.0189-.0569.2274-.1937.6463-.3453.8126-.5737.6305-3.1567.1979-4.0346.3084-.5968-1.6241-.8789-3.3209-1.0652-5.0399ZM16,24.7495c-2.481-.18-4.9062-1.5852-5.7861-4.0946.9337-.0937,2.0989.1274,2.9999,0,1.6063-.2263,1.34-1.7242,1.7368-2.8957.3389-.1053.6926-.1579,1.0494-.1705.3568.0126.7104.0652,1.0494.1705.3968,1.1715.1305,2.6694,1.7368,2.8957.901.1274,2.0662-.0937,2.9999,0-.8799,2.5094-3.3051,3.9146-5.7861,4.0946ZM18.0546,19.9128c-.1516-.1663-.2884-.5853-.3452-.8126-.1232-.4947-.4716-2.5915-.4453-3.0189.0211-.3568.4473-.8326.7852-.9h5.1051c-.1863,1.7189-.4684,3.4157-1.0652,5.0399-.8779-.1105-3.4609.3221-4.0346-.3084ZM23.5755,15.1825c.4611.0147,1.0641.3452,1.0294.8652-.0284.4326-.8273,3.0704-1.0431,3.4894-.1948.3779-.4621.7189-.9337.6968.4663-1.6473.9473-3.3241.9473-5.0514h.0001ZM23.3144,20.9191l-.8968-.2632c.5705-.0421,1.082-.2642,1.3894-.7684.2347-.3853,1.1157-3.2641,1.141-3.7094.0527-.9021-.5789-1.2526-1.361-1.4294-.0495-1.2883.101-2.8494-.4127-4.062-.2484-.5873-.8242-.6705-.4273-1.4389.1895-.3674,1.0884-.9315,1.5052-.9052.501.0326,1.2863,1.5936,1.641,2.0473.7336.941,3.0526,3.0325,2.9399,4.1998-.1315,1.3568-4.124,6.2777-5.5187,6.3293h0ZM20.723,13.4309c-.1389-.3547-.6295-.9842-1.0126-1.0705-.5095-.1147-1.1579.3179-.9252.8189.2421.5231,1.8536.781,1.9378.2516ZM20.2061,13.2857c-.4252.0189-1.1115.0652-1.0515-.5242.4747-.2242.8031.16,1.0515.5242ZM16,22.0274c-.6074,1.041-1.6042.2295-2.3115-.4252.3514,1.0421,1.1141,1.8438,1.985,2.1157.2104.0657.4424.0657.6529,0,.871-.2719,1.6337-1.0736,1.985-2.1157-.7073.6547-1.7042,1.4662-2.3115.4252h.0001ZM16.4631,23.3104c-.2929.1281-.6333.1281-.9262,0-.213-.0932-.4126-.2253-.5853-.3925.3663-.0379.7895-.0547,1.0484-.2895.2589.2347.682.2516,1.0483.2895-.1727.1671-.3723.2993-.5853.3925h.0001ZM19.9274,16.7916c-1.2811-.0672-1.3152,2.7355-.0814,2.8101,1.3266.0803,1.5042-2.7354.0814-2.8101Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ntt.propTypes = E);
var fae, pae, gae, mae, Aae, wae, vae, bae, yae, Cae, Eae, _ae, xae, Sae, Mae, Dae, Lae, kae, Nae, Tae, Iae, Oae, Rae, Vae, Hae, Bae, Pae, Fae, zae, Wae, jae, Zae, Uae, qae, Gae, Qae, Kae, Yae, Xae, Jae, $ae, ele, tle, nle, ile, rle, sle, ole, ale, lle, cle, hle, dle, ule, fle, ple, gle, mle, Ale, wle, vle, ble, yle, Cle, Ele, _le, xle, Sle, Mle, Dle, Lle, kle, Nle, Tle, Ile, Ole, Rle, Vle, Hle, Ble, Ple, Fle, zle, Wle, jle, Zle, Ule, qle, Gle, Qle, Kle, Yle, Xle, Jle, $le, ece, tce, nce, ice, rce, sce, oce, ace, lce, cce, hce, dce, uce, fce, pce, gce, mce, Ace, wce, vce, bce, yce, Cce, Ece, _ce, xce, Sce, Mce, Dce, Lce, kce, Nce, Tce, Ice, Oce, Rce, Vce, Hce, Bce, Pce, Fce, zce, Wce, jce, Zce, Uce, qce, Gce, Qce, Kce, Yce, Xce, Jce, $ce, ehe, the, nhe, ihe, rhe, she, ohe, ahe, lhe, che, hhe, dhe, uhe, fhe, phe, ghe, mhe, Ahe, whe, vhe, bhe, yhe, Che, Ehe, _he, xhe, She, Mhe, Dhe, Lhe, khe, Nhe, The, Ihe, Ohe, Rhe, Vhe, Hhe, Bhe, Phe, Fhe, zhe, Whe, jhe, Zhe, Uhe, qhe, Ghe, Qhe, Khe, Yhe, Xhe, Jhe, $he, ede, tde, nde, ide, rde, sde, ode, ade, lde, cde, hde, dde, ude, fde, pde, gde, mde, Ade, wde, vde, bde, yde, Cde, Ede, _de, xde, Sde, Mde, Dde, Lde, kde, Nde, Tde, Ide, Ode, Rde, Vde, Hde, Bde, Pde, Fde, zde, Wde, jde, Zde, Ude, qde, Gde, Qde, Kde, Yde, Xde;
const Ttt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fae || (fae = /* @__PURE__ */ h.createElement("path", {
    d: "M21.6772,14l-1.2456-3.1143A2.9861,2.9861,0,0,0,17.646,9H13.5542a3.0018,3.0018,0,0,0-1.5439.4277L7,12.4336V18H9V13.5664l3-1.8V23.6973L8.5383,28.8906,10.2024,30,14,24.3027V11h3.646a.9949.9949,0,0,1,.9282.6289L20.3228,16H26V14Z"
  })), pae || (pae = /* @__PURE__ */ h.createElement("path", {
    d: "M17.051 18.316L19 24.162 19 30 21 30 21 23.838 18.949 17.684 17.051 18.316zM16.5 8A3.5 3.5 0 1120 4.5 3.5042 3.5042 0 0116.5 8zm0-5A1.5 1.5 0 1018 4.5 1.5017 1.5017 0 0016.5 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ttt.propTypes = E);
const Itt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gae || (gae = /* @__PURE__ */ h.createElement("path", {
    d: "M20 30H17a2.0021 2.0021 0 01-2-2V23h2v5h3V23h2V19a1.0011 1.0011 0 00-1-1H12.2793l-2-6H4a1.0011 1.0011 0 00-1 1v6H5v9H9V21h2v7a2.0021 2.0021 0 01-2 2H5a2.0021 2.0021 0 01-2-2V21a2.0021 2.0021 0 01-2-2V13a3.0033 3.0033 0 013-3h6.2793a1.998 1.998 0 011.8975 1.3674L13.7207 16H21a3.0033 3.0033 0 013 3v4a2.0021 2.0021 0 01-2 2v3A2.0021 2.0021 0 0120 30zM28 30H26V19h3V13a1.0011 1.0011 0 00-1-1H24V10h4a3.0033 3.0033 0 013 3v6a2.0021 2.0021 0 01-2 2H28zM7 9a4 4 0 114-4A4.0045 4.0045 0 017 9zM7 3A2 2 0 109 5 2.0021 2.0021 0 007 3zM25 9a4 4 0 114-4A4.0045 4.0045 0 0125 9zm0-6a2 2 0 102 2A2.0021 2.0021 0 0025 3z"
  })), mae || (mae = /* @__PURE__ */ h.createElement("path", {
    d: "M18.5,15A3.5,3.5,0,1,1,22,11.5,3.5041,3.5041,0,0,1,18.5,15Zm0-5A1.5,1.5,0,1,0,20,11.5,1.5017,1.5017,0,0,0,18.5,10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Itt.propTypes = E);
const Ott = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Aae || (Aae = /* @__PURE__ */ h.createElement("path", {
    d: "M26,16H17.4683l-5-6H5a3.0033,3.0033,0,0,0-3,3v6a2.0023,2.0023,0,0,0,2,2v7a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V21H10v7H6V19H4V13a1.0009,1.0009,0,0,1,1-1h6.5317l5,6H26a1.0009,1.0009,0,0,1,1,1v3H25v6H22V22H20v6a2.0023,2.0023,0,0,0,2,2h3a2.0023,2.0023,0,0,0,2-2V24a2.0023,2.0023,0,0,0,2-2V19A3.0033,3.0033,0,0,0,26,16Z"
  })), wae || (wae = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5 15A3.5 3.5 0 1127 11.5 3.5042 3.5042 0 0123.5 15zm0-5A1.5 1.5 0 1025 11.5 1.5017 1.5017 0 0023.5 10zM8 9a4 4 0 114-4A4.0042 4.0042 0 018 9zM8 3a2 2 0 102 2A2.0023 2.0023 0 008 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ott.propTypes = E);
const Rtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vae || (vae = /* @__PURE__ */ h.createElement("path", {
    d: "M27.3069,6.1069,30,3.4141,28.5859,2,25.8931,4.6929,24.8,3.6a1.9328,1.9328,0,0,0-2.8,0L4,21.6V28h6.4l18-18a1.9329,1.9329,0,0,0,0-2.8ZM9.6,26H6V22.4L23.4,5,27,8.6Z"
  })), bae || (bae = /* @__PURE__ */ h.createElement("path", {
    d: "M8.136 7.5H18.863999999999997V9.5H8.136z",
    transform: "rotate(-45 13.5 8.5)"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rtt.propTypes = E);
const Vtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yae || (yae = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707,5.293l-3-3a.9994.9994,0,0,0-1.414,0L19.5859,8H17.0947A11.0118,11.0118,0,0,0,6.7124,15.3662L2.0562,28.67a1,1,0,0,0,1.2744,1.2739l13.3037-4.6562A11.012,11.012,0,0,0,24,14.9053V12.4141L29.707,6.707A.9994.9994,0,0,0,29.707,5.293Zm-7.414,6A1,1,0,0,0,22,12v2.9053A9.01,9.01,0,0,1,15.9731,23.4l-9.1677,3.209L16,17.4141,14.5859,16,5.3914,25.1948,8.6,16.0269A9.01,9.01,0,0,1,17.0947,10H20a1,1,0,0,0,.707-.293L26,4.4141,27.5859,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vtt.propTypes = E);
const Htt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cae || (Cae = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), Eae || (Eae = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _ae || (_ae = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), xae || (xae = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Htt.propTypes = E);
const Btt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sae || (Sae = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM8,18a2,2,0,1,1,2-2A2,2,0,0,1,8,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm8,0a2,2,0,1,1,2-2A2,2,0,0,1,24,18Z"
  })), Mae || (Mae = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M10,16a2,2,0,1,1-2-2A2,2,0,0,1,10,16Zm6-2a2,2,0,1,0,2,2A2,2,0,0,0,16,14Zm8,0a2,2,0,1,0,2,2A2,2,0,0,0,24,14Z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Btt.propTypes = E);
const Ptt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dae || (Dae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,27.7593l-11.8274-8.6831,4.5261-14.0762h14.6025l4.5261,14.0762-11.8274,8.6831m0,2.2407c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ptt.propTypes = E);
const Ftt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lae || (Lae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,30c.2078,0,.4158-.0645.5918-.1938l13-9.5444c.2599-.1907.4066-.4904.4082-.8009.0005-.1036-.0151-.2085-.0481-.3109l-4.9697-15.4561c-.1331-.4136-.5176-.6938-.9519-.6938H7.9697c-.4343,0-.8188.2803-.9519.6938l-4.9697,15.4561c-.0329.1021-.0485.2067-.0481.31.0013.3108.1481.6109.4082.8018l13,9.5444c.176.1294.384.1938.5918.1938h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ftt.propTypes = E);
const ztt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kae || (kae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m4.2407,16L12.9238,4.1726l14.0762,4.5261v14.6025l-14.0762,4.5261-8.6831-11.8274m-2.2407,0c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ztt.propTypes = E);
const Wtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nae || (Nae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,16c0,.2078.0645.4158.1938.5918l9.5444,13c.1907.2599.4904.4066.8009.4082.1036.0005.2085-.0151.3109-.0481l15.4561-4.9697c.4136-.1331.6938-.5176.6938-.9519V7.9697c0-.4343-.2803-.8188-.6938-.9519L12.8501,2.0481c-.1021-.0329-.2067-.0485-.31-.0481-.3108.0013-.6109.1481-.8018.4082L2.1938,15.4082c-.1294.176-.1938.384-.1938.5918h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wtt.propTypes = E);
const jtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tae || (Tae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,4.2407l11.8274,8.6831-4.5261,14.0762h-14.6025l-4.5261-14.0762,11.8274-8.6831m0-2.2407c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jtt.propTypes = E);
const Ztt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Iae || (Iae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m27.7593,16l-8.6831,11.8274-14.0762-4.5261v-14.6025l14.0762-4.5261,8.6831,11.8274m2.2407,0c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ztt.propTypes = E);
const Utt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Oae || (Oae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m30,16c0-.2078-.0645-.4158-.1938-.5918L20.2617,2.4082c-.1907-.2599-.4904-.4066-.8009-.4082-.1036-.0005-.2085.0151-.3109.0481L3.6938,7.0178c-.4136.1331-.6938.5176-.6938.9519v16.0605c0,.4343.2803.8188.6938.9519l15.4561,4.9697c.1021.0329.2067.0485.31.0481.3108-.0013.6109-.1481.8018-.4082l9.5444-13c.1294-.176.1938-.384.1938-.5918h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Utt.propTypes = E);
const qtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rae || (Rae = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,2c-.2078,0-.4158.0645-.5918.1938L2.4082,11.7383c-.2599.1907-.4066.4904-.4082.8009-.0005.1036.0151.2085.0481.3109l4.9697,15.4561c.1331.4136.5176.6938.9519.6938h16.0605c.4343,0,.8188-.2803.9519-.6938l4.9697-15.4561c.0329-.1021.0485-.2067.0481-.31-.0013-.3108-.1481-.6109-.4082-.8018L16.5918,2.1938c-.176-.1294-.384-.1938-.5918-.1938h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qtt.propTypes = E);
const Gtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vae || (Vae = /* @__PURE__ */ h.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14ZM9,6a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,9,6Z"
  })), Hae || (Hae = /* @__PURE__ */ h.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), Bae || (Bae = /* @__PURE__ */ h.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,23,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gtt.propTypes = E);
const Qtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pae || (Pae = /* @__PURE__ */ h.createElement("path", {
    d: "M9,14a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,9,14Z"
  })), Fae || (Fae = /* @__PURE__ */ h.createElement("path", {
    d: "M0.029 15H31.97V17H0.029z",
    transform: "rotate(-45 16 16)"
  })), zae || (zae = /* @__PURE__ */ h.createElement("path", {
    d: "M23,28a5,5,0,1,1,5-5A5.0055,5.0055,0,0,1,23,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qtt.propTypes = E);
const Ktt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wae || (Wae = /* @__PURE__ */ h.createElement("path", {
    d: "M18 30H14a2 2 0 01-2-2V21a2 2 0 01-2-2V13a3 3 0 013-3h6a3 3 0 013 3v6a2 2 0 01-2 2v7A2 2 0 0118 30zM13 12a.94.94 0 00-1 1v6h2v9h4V19h2V13a.94.94 0 00-1-1zM16 9a4 4 0 114-4h0A4 4 0 0116 9zm0-6a2 2 0 102 2h0a2 2 0 00-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ktt.propTypes = E);
const Ytt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jae || (jae = /* @__PURE__ */ h.createElement("path", {
    d: "M10 31H6a2.0059 2.0059 0 01-2-2V22a2.0059 2.0059 0 01-2-2V14a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0110 31zM5 13a.9448.9448 0 00-1 1v6H6v9h4V20h2V14a.9448.9448 0 00-1-1zM8 10a4 4 0 114-4A4.0045 4.0045 0 018 10zM8 4a2 2 0 102 2A2.002 2.002 0 008 4zM28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ytt.propTypes = E);
const Xtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zae || (Zae = /* @__PURE__ */ h.createElement("circle", {
    cx: "7.5",
    cy: "9.5",
    r: "1.5"
  })), Uae || (Uae = /* @__PURE__ */ h.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "1"
  })), qae || (qae = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "21",
    r: "1"
  })), Gae || (Gae = /* @__PURE__ */ h.createElement("path", {
    d: "M25,14a8.9844,8.9844,0,0,0-7,3.3555V13a10.9054,10.9054,0,0,0-1.0093-4.5845l-.3569-.7768L15.811,7.87A2.9549,2.9549,0,0,1,15,8a3.0033,3.0033,0,0,1-3-3,2.9574,2.9574,0,0,1,.1294-.8105l.2324-.8233-.7773-.3569A10.9115,10.9115,0,0,0,7,2H2V9a10.8954,10.8954,0,0,0,2.2339,6.627l.3887.4277.54-.0381a5.5286,5.5286,0,0,1,5.3628,3.2559l.2207.497.5376.0845A11.0219,11.0219,0,0,0,13,20h3V30h2V26h3a9.01,9.01,0,0,0,9-9V14ZM12.1016,17.9468A7.51,7.51,0,0,0,5.5283,14,8.8945,8.8945,0,0,1,4,9V4H7a8.8624,8.8624,0,0,1,3.0259.53A4.2457,4.2457,0,0,0,10,5a4.9658,4.9658,0,0,0,5.47,4.9736A8.8793,8.8793,0,0,1,16,13v5H13A8.1153,8.1153,0,0,1,12.1016,17.9468ZM28,17a7.0078,7.0078,0,0,1-7,7H18V23a7.01,7.01,0,0,1,5.0212-6.7109A1.4971,1.4971,0,1,0,26,16.5a1.485,1.485,0,0,0-.0918-.5H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xtt.propTypes = E);
const Jtt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qae || (Qae = /* @__PURE__ */ h.createElement("path", {
    d: "M19 21H21V24H19zM19 0H21V3H19zM8 11H11V13H8zM29 11H32V13H29z"
  })), Kae || (Kae = /* @__PURE__ */ h.createElement("path", {
    d: "M11.59 3.07H13.57V6.07H11.59z",
    transform: "rotate(-45 12.586 4.577)"
  })), Yae || (Yae = /* @__PURE__ */ h.createElement("path", {
    d: "M26.44 17.92H28.42V20.92H26.44z",
    transform: "rotate(-45 27.43 19.408)"
  })), Xae || (Xae = /* @__PURE__ */ h.createElement("path", {
    d: "M11.09 18.42H14.09V20.400000000000002H11.09z",
    transform: "rotate(-45 12.592 19.414)"
  })), Jae || (Jae = /* @__PURE__ */ h.createElement("path", {
    d: "M25.93 3.58H28.93V5.5600000000000005H25.93z",
    transform: "rotate(-45 27.423 4.57)"
  })), $ae || ($ae = /* @__PURE__ */ h.createElement("path", {
    d: "M20 5a7 7 0 107 7A7 7 0 0020 5zm0 12A5 5 0 0120 7zM5 18H0V32H5a3 3 0 003-3V27a3 3 0 00-.78-2A3 3 0 008 23V21A3 3 0 005 18zM2 20H5a1 1 0 011 1v2a1 1 0 01-1 1H2zm4 9a1 1 0 01-1 1H2V26H5a1 1 0 011 1zM2 2L9 2 9 0 0 0 0 9 2 9 2 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jtt.propTypes = E);
const $tt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ele || (ele = /* @__PURE__ */ h.createElement("path", {
    d: "M11 29H13V32H11zM11 8H13V11H11zM0 19H3V21H0zM21 19H24V21H21z"
  })), tle || (tle = /* @__PURE__ */ h.createElement("path", {
    d: "M3.59 11.09H5.57V14.09H3.59z",
    transform: "rotate(-45 4.585 12.59)"
  })), nle || (nle = /* @__PURE__ */ h.createElement("path", {
    d: "M18.44 25.93H20.42V28.93H18.44z",
    transform: "rotate(-45 19.429 27.422)"
  })), ile || (ile = /* @__PURE__ */ h.createElement("path", {
    d: "M3.09 26.44H6.09V28.42H3.09z",
    transform: "rotate(-45 4.591 27.428)"
  })), rle || (rle = /* @__PURE__ */ h.createElement("path", {
    d: "M17.93 11.59H20.93V13.57H17.93z",
    transform: "rotate(-45 19.423 12.585)"
  })), sle || (sle = /* @__PURE__ */ h.createElement("path", {
    d: "M12 13a7 7 0 107 7A7 7 0 0012 13zm0 12a5 5 0 010-10zM2 2L9 2 9 0 0 0 0 9 2 9 2 2zM30 0H26a2 2 0 00-2 2V12a2 2 0 002 2h4a2 2 0 002-2V2A2 2 0 0030 0zM26 12V2h4V12z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($tt.propTypes = E);
const ent = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ole || (ole = /* @__PURE__ */ h.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.76,3h5.51a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.37,9.37,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5A1,1,0,0,0,5,6v.08C5.46,12,8.41,26,25.94,27A1,1,0,0,0,27,26.06V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ent.propTypes = E);
const tnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ale || (ale = /* @__PURE__ */ h.createElement("path", {
    d: "M26 2H30V6H26zM26 8H30V12H26zM20 2H24V6H20zM20 8H24V12H20zM25 30h-.17C5.18 28.87 2.39 12.29 2 7.23A3 3 0 014.7611 4.0088Q4.88 4 5 4h5.27a2 2 0 011.86 1.26L13.65 9a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0123 18.35l3.77 1.51A2 2 0 0128 21.72V27A3 3 0 0125 30zM5 6a1 1 0 00-1.0032.9968c0 .0278.001.0555.0032.0832C4.46 13 7.41 27 24.94 28a1 1 0 001.0581-.9382Q26 27.0309 26 27V21.72l-3.77-1.51-2.87 2.85L18.88 23C10.18 21.91 9 13.21 9 13.12l-.06-.48 2.84-2.87L10.28 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tnt.propTypes = E);
const nnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lle || (lle = /* @__PURE__ */ h.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), cle || (cle = /* @__PURE__ */ h.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nnt.propTypes = E);
const int = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hle || (hle = /* @__PURE__ */ h.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), dle || (dle = /* @__PURE__ */ h.createElement("path", {
    d: "M24.41 9L28 5.41 26.59 4 23 7.59 19.41 4 18 5.41 21.59 9 18 12.59 19.41 14 23 10.41 26.59 14 28 12.59 24.41 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (int.propTypes = E);
const rnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ule || (ule = /* @__PURE__ */ h.createElement("path", {
    d: "M20.33,21.48l2.24-2.24a2.19,2.19,0,0,1,2.34-.48l2.73,1.09a2.18,2.18,0,0,1,1.36,2v5A2.17,2.17,0,0,1,26.72,29C7.59,27.81,3.73,11.61,3,5.41A2.17,2.17,0,0,1,5.17,3H10a2.16,2.16,0,0,1,2,1.36l1.09,2.73a2.16,2.16,0,0,1-.47,2.34l-2.24,2.24S11.67,20.4,20.33,21.48Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rnt.propTypes = E);
const snt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fle || (fle = /* @__PURE__ */ h.createElement("path", {
    d: "M26,29h-.17C6.18,27.87,3.39,11.29,3,6.23A3,3,0,0,1,5.7612,3.0088Q5.88,3,6,3h5.27a2,2,0,0,1,1.86,1.26L14.65,8a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,24,17.35l3.77,1.51A2,2,0,0,1,29,20.72V26A3,3,0,0,1,26,29ZM6,5a1,1,0,0,0-1.0032.9968q0,.0417.0032.0832C5.46,12,8.41,26,25.94,27a1,1,0,0,0,1.0582-.9382Q27,26.0309,27,26V20.72l-3.77-1.51-2.87,2.85L19.88,22C11.18,20.91,10,12.21,10,12.12l-.06-.48,2.84-2.87L11.28,5Z"
  })), ple || (ple = /* @__PURE__ */ h.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (snt.propTypes = E);
const ont = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gle || (gle = /* @__PURE__ */ h.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), mle || (mle = /* @__PURE__ */ h.createElement("path", {
    d: "M27 13L27 11 22.414 11 29 4.414 27.586 3 21 9.586 21 5 19 5 19 13 27 13z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ont.propTypes = E);
const ant = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ale || (Ale = /* @__PURE__ */ h.createElement("path", {
    d: "M16 14H18V16H16zM20 14H22V16H20zM24 14H26V16H24zM16 18H18V20H16zM20 18H22V20H20zM24 18H26V20H24zM16 22H18V24H16zM20 22H22V24H20zM24 22H26V24H24zM16 10H26V12H16z"
  })), wle || (wle = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H14V5a2.0025,2.0025,0,0,0-2-2H8A2.0025,2.0025,0,0,0,6,5V6H4A2.0025,2.0025,0,0,0,2,8V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V8A2.0025,2.0025,0,0,0,28,6ZM8,5h4V22H8ZM28,26H4V8H6V22a2.0025,2.0025,0,0,0,2,2h4a2.0025,2.0025,0,0,0,2-2V8H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ant.propTypes = E);
const lnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vle || (vle = /* @__PURE__ */ h.createElement("path", {
    d: "M9.19 18.56A25.66 25.66 0 015 6.08V6A1 1 0 016 5h5.28l1.5 3.77L9.94 11.64l.06.48a13 13 0 001.46 4.17l1.46-1.46a9.34 9.34 0 01-.84-2.52l2.13-2.15A2 2 0 0014.65 8L13.13 4.26A2 2 0 0011.27 3H5.76A3 3 0 003 6.23 28 28 0 007.79 20zM27.77 18.86L24 17.35a2 2 0 00-2.17.41l-2.17 2.15A9.17 9.17 0 0115.45 18L30 3.41 28.59 2 2 28.59 3.41 30l7-7c3.38 3.18 8.28 5.62 15.39 6H26a3 3 0 003-3V20.72A2 2 0 0027.77 18.86zM27 26v.06a1 1 0 01-1.06.94c-6.51-.37-11-2.54-14.11-5.42L14 19.44A10.77 10.77 0 0019.88 22l.48.06 2.87-2.85L27 20.72z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lnt.propTypes = E);
const cnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ble || (ble = /* @__PURE__ */ h.createElement("path", {
    d: "M26.74 19.56l-2.52-1a2 2 0 00-2.15.44L20 21.06a9.93 9.93 0 01-5.35-2.29L30 3.41 28.59 2 2 28.59 3.41 30l7.93-7.92c3.24 3.12 7.89 5.5 14.55 5.92A2 2 0 0028 26V21.41A2 2 0 0026.74 19.56zM8.15 18.19l3.52-3.52A11.68 11.68 0 0110.85 12l2.07-2.07a2 2 0 00.44-2.15l-1-2.52A2 2 0 0010.5 4H6A2 2 0 004 6.22 29 29 0 008.15 18.19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cnt.propTypes = E);
const hnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yle || (yle = /* @__PURE__ */ h.createElement("path", {
    d: "M26,29h-0.2C6.2,27.9,3.4,11.3,3,6.2C2.9,4.6,4.1,3.1,5.8,3C5.8,3,5.9,3,6,3h5.3c0.8,0,1.6,0.5,1.9,1.3L14.6,8 c0.3,0.7,0.1,1.6-0.4,2.2l-2.1,2.1c0.7,3.9,3.7,6.9,7.6,7.6l2.2-2.1c0.6-0.6,1.4-0.7,2.2-0.4l3.8,1.5c0.7,0.3,1.2,1,1.2,1.9V26 C29,27.7,27.7,29,26,29z M6,5C5.4,5,5,5.4,5,6c0,0,0,0.1,0,0.1C5.5,12,8.4,26,25.9,27c0.6,0,1-0.4,1.1-0.9c0,0,0,0,0-0.1v-5.3 l-3.8-1.5l-2.9,2.9L19.9,22c-8.7-1.1-9.9-9.8-9.9-9.9l-0.1-0.5l2.8-2.9L11.3,5H6z"
  })), Cle || (Cle = /* @__PURE__ */ h.createElement("path", {
    d: "M20 4L20 6 24.6 6 18 12.6 19.4 14 26 7.4 26 12 28 12 28 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hnt.propTypes = E);
const dnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ele || (Ele = /* @__PURE__ */ h.createElement("path", {
    d: "M20.3333,21.4823l2.24-2.24a2.1667,2.1667,0,0,1,2.3368-.48l2.7281,1.0913A2.1666,2.1666,0,0,1,29,21.8659v4.9613a2.1668,2.1668,0,0,1-2.2843,2.1686C7.5938,27.8054,3.7321,11.6114,3.0146,5.4079A2.162,2.162,0,0,1,5.1692,3H10.042a2.1666,2.1666,0,0,1,2.0117,1.362L13.145,7.09a2.1666,2.1666,0,0,1-.48,2.3367l-2.24,2.24S11.6667,20.399,20.3333,21.4823Z"
  })), _le || (_le = /* @__PURE__ */ h.createElement("path", {
    d: "M20 4L20 6 24.586 6 18 12.586 19.414 14 26 7.414 26 12 28 12 28 4 20 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dnt.propTypes = E);
const unt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xle || (xle = /* @__PURE__ */ h.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), Sle || (Sle = /* @__PURE__ */ h.createElement("path", {
    d: "M25,30h-.17C5.18,28.87,2.39,12.29,2,7.23A3,3,0,0,1,4.7611,4.0088Q4.88,4,5,4h5.27a2,2,0,0,1,1.86,1.26L13.65,9a2,2,0,0,1-.44,2.16l-2.13,2.15a9.36,9.36,0,0,0,7.58,7.6l2.17-2.15A2,2,0,0,1,23,18.35l3.77,1.51A2,2,0,0,1,28,21.72V27A3,3,0,0,1,25,30ZM5,6a1,1,0,0,0-1.0032.9968c0,.0278.001.0555.0032.0832C4.46,13,7.41,27,24.94,28a1,1,0,0,0,1.0581-.9382Q26,27.0309,26,27V21.72l-3.77-1.51-2.87,2.85L18.88,23C10.18,21.91,9,13.21,9,13.12l-.06-.48,2.84-2.87L10.28,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (unt.propTypes = E);
const fnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mle || (Mle = /* @__PURE__ */ h.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), Dle || (Dle = /* @__PURE__ */ h.createElement("path", {
    d: "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM26 29h-.17C6.18 27.87 3.39 11.29 3 6.23A3 3 0 015.7612 3.0088Q5.88 3 6 3h5.27a2 2 0 011.86 1.26L14.65 8a2 2 0 01-.44 2.16l-2.13 2.15a9.36 9.36 0 007.58 7.6l2.17-2.15A2 2 0 0124 17.35l3.77 1.51A2 2 0 0129 20.72V26A3 3 0 0126 29zM6 5a1 1 0 00-1.0032.9968q0 .0417.0032.0832C5.46 12 8.41 26 25.94 27a1 1 0 001.0582-.9382Q27 26.0309 27 26V20.72l-3.77-1.51-2.87 2.85L19.88 22C11.18 20.91 10 12.21 10 12.12l-.06-.48 2.84-2.87L11.28 5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fnt.propTypes = E);
const pnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lle || (Lle = /* @__PURE__ */ h.createElement("path", {
    d: "M24,13H22a3.0033,3.0033,0,0,0-3-3V8A5.0057,5.0057,0,0,1,24,13Z"
  })), kle || (kle = /* @__PURE__ */ h.createElement("path", {
    d: "M28 13H26a7.0078 7.0078 0 00-7-7V4A9.01 9.01 0 0128 13zM20.3333 21.4823l2.24-2.24a2.1667 2.1667 0 012.3368-.48l2.7281 1.0913A2.1666 2.1666 0 0129 21.8659v4.9613a2.1668 2.1668 0 01-2.2843 2.1686C7.5938 27.8054 3.7321 11.6114 3.0146 5.4079A2.162 2.162 0 015.1692 3H10.042a2.1666 2.1666 0 012.0117 1.362L13.145 7.09a2.1666 2.1666 0 01-.48 2.3367l-2.24 2.24S11.6667 20.399 20.3333 21.4823z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pnt.propTypes = E);
const gnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nle || (Nle = /* @__PURE__ */ h.createElement("path", {
    d: "M18.303,10a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L16.0019,19l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,18.303,10Z"
  })), Tle || (Tle = /* @__PURE__ */ h.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gnt.propTypes = E);
const mnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ile || (Ile = /* @__PURE__ */ h.createElement("path", {
    d: "M24 12a4 4 0 114-4A4.0045 4.0045 0 0124 12zm0-6a2 2 0 102 2A2.0021 2.0021 0 0024 6zM26 22H21.8472L21.18 18H24V16H8v2h2.82l-.6668 4H6v2H9.82l-.6668 4H11.18l.6668-4h8.3056l.6668 4h2.0276L22.18 24H26zM12.18 22l.6665-4h6.3062l.6665 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mnt.propTypes = E);
const Ant = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ole || (Ole = /* @__PURE__ */ h.createElement("path", {
    d: "M16.5,14H20V12H18V11H16v1.0508A2.5,2.5,0,0,0,16.5,17h1a.5.5,0,0,1,0,1H14v2h2v1h2V19.9492A2.5,2.5,0,0,0,17.5,15h-1a.5.5,0,0,1,0-1Z"
  })), Rle || (Rle = /* @__PURE__ */ h.createElement("path", {
    d: "M29,13H26.98A5.7789,5.7789,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0926,5.0926,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.013,7.013,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ant.propTypes = E);
const wnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vle || (Vle = /* @__PURE__ */ h.createElement("path", {
    d: "M13 11H20V13H13z"
  })), Hle || (Hle = /* @__PURE__ */ h.createElement("path", {
    d: "M29,13H26.98A5.7791,5.7791,0,0,0,25,8.8525V5a1,1,0,0,0-1.6-.8L19.6665,7H15c-5.5095,0-9.4634,3.2412-9.9485,8H5a1.0009,1.0009,0,0,1-1-1V12H2v2a3.0033,3.0033,0,0,0,3,3h.07A9.1733,9.1733,0,0,0,9,23.5566V27a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V25h3v2a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V23.6372A5.0928,5.0928,0,0,0,26.8188,20H29a1,1,0,0,0,1-1V14A1,1,0,0,0,29,13Zm-1,5H25.124c-.3052,2.7529-.8235,3.4854-3.124,4.3154V26H20V23H13v3H11V22.3779A7.0129,7.0129,0,0,1,7,16c0-4.8354,4.0181-7,8-7h5.3335L23,7V9.7764c2.4182,1.8593,1.9126,3.186,2.0183,5.2236H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wnt.propTypes = E);
const vnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ble || (Ble = /* @__PURE__ */ h.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.999,6.999,0,0,0,12.2855,4.5878A7.9969,7.9969,0,1,0,22,14Zm0,2a6.0046,6.0046,0,0,1,5.91,5H16.09A6.0046,6.0046,0,0,1,22,16ZM6,9A5,5,0,0,1,16,9v6H6Zm5,19a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9566,7.9566,0,0,0-.7242,8.9315A4.9885,4.9885,0,0,1,11,28Zm11,0a6.0046,6.0046,0,0,1-5.91-5H27.91A6.0046,6.0046,0,0,1,22,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vnt.propTypes = E);
const bnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ple || (Ple = /* @__PURE__ */ h.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), Fle || (Fle = /* @__PURE__ */ h.createElement("path", {
    d: "M25 21L23 21 23 19 21 19 21 21 19 21 19 23 21 23 21 25 23 25 23 23 25 23 25 21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bnt.propTypes = E);
const ynt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zle || (zle = /* @__PURE__ */ h.createElement("path", {
    d: "M22,14a7.94,7.94,0,0,0-4,1.0825V9A7,7,0,0,0,4,9V23a6.9857,6.9857,0,0,0,12.2756,4.5768A7.9966,7.9966,0,1,0,22,14ZM11,4a5.0059,5.0059,0,0,1,5,5v6H6V9A5.0059,5.0059,0,0,1,11,4Zm0,24a5.0059,5.0059,0,0,1-5-5V17h9.765a7.9564,7.9564,0,0,0-.7239,8.9319A5.0147,5.0147,0,0,1,11,28Zm11,0a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,22,28Z"
  })), Wle || (Wle = /* @__PURE__ */ h.createElement("path", {
    d: "M19 21H25V23H19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ynt.propTypes = E);
const Cnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jle || (jle = /* @__PURE__ */ h.createElement("path", {
    d: "M28.59,13.31,30,11.9,20,2,18.69,3.42,19.87,4.6,8.38,14.32,6.66,12.61,5.25,14l5.66,5.68L2,28.58,3.41,30l8.91-8.91L18,26.75l1.39-1.42-1.71-1.71L27.4,12.13ZM16.26,22.2,9.8,15.74,21.29,6,26,10.71Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cnt.propTypes = E);
const Ent = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zle || (Zle = /* @__PURE__ */ h.createElement("path", {
    d: "M28.5858,13.3137,30,11.9,20,2,18.6858,3.415l1.1858,1.1857L8.38,14.3225,6.6641,12.6067,5.25,14l5.6572,5.6773L2,28.5831,3.41,30l8.9111-8.9087L18,26.7482l1.3929-1.414L17.6765,23.618l9.724-11.4895Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ent.propTypes = E);
const _nt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ule || (Ule = /* @__PURE__ */ h.createElement("path", {
    d: "M22,12h6c1.1028,0,2-.8975,2-2V4c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-2.7571,0-5,2.2432-5,5h-2c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h2c0,2.7568,2.2429,5,5,5h9v2c0,1.1025.8972,2,2,2h6c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-6c-1.1028,0-2,.8975-2,2v2h-9c-1.6543,0-3-1.3457-3-3h2c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2h-2c0-1.6543,1.3457-3,3-3h9v2c0,1.1025.8972,2,2,2ZM22,22h6v6h-6l-.0012-6h.0012ZM10,13v6h-6l-.0012-6h6.0012ZM22,4h6v6h-6l-.0012-6h.0012Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_nt.propTypes = E);
const xnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qle || (qle = /* @__PURE__ */ h.createElement("path", {
    d: "M31,8c0-0.4-0.2-0.7-0.5-0.9l-7-4C23.3,3,23.2,3,23,3s-0.3,0-0.5,0.1L16,6.8L9.5,3.1C9.3,3,9.2,3,9,3S8.7,3,8.5,3.1l-7,4 C1.2,7.3,1,7.6,1,8v20c0,0.6,0.4,1,1,1c0.2,0,0.3-0.1,0.5-0.1l0,0L9,25.2l6.5,3.7C15.7,29,15.8,29,16,29s0.3,0,0.5-0.1l6.5-3.7 l6.5,3.7l0,0c0.1,0.1,0.3,0.1,0.5,0.1c0.6,0,1-0.4,1-1V8z M3,8.6l5-2.9v17.7l-5,2.9V8.6z M15,26.3l-5-2.9V5.7l5,2.9V26.3z M22,23.4 l-5,2.9V8.6l5-2.9V23.4z M24,23.4V5.7l5,2.9l0,17.7L24,23.4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xnt.propTypes = E);
const Snt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gle || (Gle = /* @__PURE__ */ h.createElement("path", {
    d: "M29.37,14.75,20,10V6a4,4,0,0,0-8,0v4L2.63,14.75a1,1,0,0,0-.63.93v5a1,1,0,0,0,1,1,1,1,0,0,0,.29-.05L12,18v5L8.55,24.72a1,1,0,0,0-.55.9V29a1,1,0,0,0,1,1,.9.9,0,0,0,.28,0L16,28l6.72,2A.9.9,0,0,0,23,30a1,1,0,0,0,1-1V25.62a1,1,0,0,0-.55-.9L20,23V18l8.71,3.61a1,1,0,0,0,.29.05,1,1,0,0,0,1-1v-5A1,1,0,0,0,29.37,14.75ZM28,19.15,18,15v9.24l4,2v1.43l-6-1.75-6,1.75V26.24l4-2V15L4,19.15V16.3l10-5.07V6a2,2,0,0,1,4,0v5.23L28,16.3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Snt.propTypes = E);
const Mnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qle || (Qle = /* @__PURE__ */ h.createElement("path", {
    d: "M28.5845,14.585l-3.12-1.8721A4.9951,4.9951,0,0,0,22.8921,12H7.7808L7.16,9.5151A1.9975,1.9975,0,0,0,5.2192,8H4a2.0023,2.0023,0,0,0-2,2v7a3.0033,3.0033,0,0,0,3,3h7v6a2.0023,2.0023,0,0,0,2,2h1.3071A2.0086,2.0086,0,0,0,17.18,26.7021L19.6929,20h7.3916a2.9152,2.9152,0,0,0,1.5-5.415ZM27.0845,18H18.3071l-3,8H14V18H5a1.0009,1.0009,0,0,1-1-1V10H5.2192l1,4H10v2h2V14h3v2h2V14h3v2h2V14h.8921a2.9977,2.9977,0,0,1,1.5434.4277l3.12,1.8721a.9154.9154,0,0,1-.4712,1.7Z"
  })), Kle || (Kle = /* @__PURE__ */ h.createElement("path", {
    d: "M14,4h1.3228l2.4,6h2.1545L17.18,3.2573A1.9906,1.9906,0,0,0,15.3228,2H14a2.0023,2.0023,0,0,0-2,2v6h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mnt.propTypes = E);
const Dnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yle || (Yle = /* @__PURE__ */ h.createElement("path", {
    d: "M30 30H28a4.9316 4.9316 0 01-4-1.9873 5.0192 5.0192 0 01-8 0 5.0192 5.0192 0 01-8 0A4.9316 4.9316 0 014 30H2V28H4a3.44 3.44 0 003.0532-2.3215A.9712.9712 0 018 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0012 28a3.44 3.44 0 003.0532-2.3215A.99.99 0 0116 25a1.0069 1.0069 0 01.9487.6838A3.4381 3.4381 0 0020 28a3.44 3.44 0 003.0532-2.3215 1 1 0 011.8955.0053A3.4381 3.4381 0 0028 28h2zM28 6v4H25.5L23.4 7.2A3.0129 3.0129 0 0021 6H15a3.0033 3.0033 0 00-3 3v1H8.6182L7.8945 8.5527l-1-2A1 1 0 006 6H3A1 1 0 002 7v6a3.0033 3.0033 0 003 3h6.82l-.6666 4H7a1 1 0 000 2H27a1 1 0 000-2H22.847L22.18 16h.1629a4.9662 4.9662 0 003.5351-1.4648L28 12.4141V16h2V6zM14 9a1.0009 1.0009 0 011-1h6a1.0045 1.0045 0 01.8.4L23 10H14zm6.82 11H13.18l.6666-4h6.306zm1.5237-6H5a1.0009 1.0009 0 01-1-1V8H5.3818l.7237 1.4473L7.3818 12h18.204l-1.1214 1.1211A2.9789 2.9789 0 0122.3433 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dnt.propTypes = E);
const Lnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xle || (Xle = /* @__PURE__ */ h.createElement("path", {
    d: "m28,28H4c-1.1028,0-2-.8972-2-2v-6h2v6h24v-6h2v6c0,1.1028-.8972,2-2,2Z"
  })), Jle || (Jle = /* @__PURE__ */ h.createElement("path", {
    d: "M17 17v4c0 .5522.4477 1 1 1h4c.5523 0 1-.4478 1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1zm2 1h2v2h-2v-2zM9 17v4c0 .5522.4477 1 1 1h4c.5523 0 1-.4478 1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1zm2 1h2v2h-2v-2zM17 9v4c0 .5522.4477 1 1 1h4c.5523 0 1-.4478 1-1v-4c0-.5523-.4477-1-1-1h-4c-.5523 0-1 .4477-1 1zm2 1h2v2h-2v-2zM5 5v8c0 .5522.4477 1 1 1h8c.5523 0 1-.4478 1-1V5c0-.5523-.4477-1-1-1H6c-.5523 0-1 .4477-1 1zm2 1h6v6h-6v-6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lnt.propTypes = E);
const knt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, $le || ($le = /* @__PURE__ */ h.createElement("path", {
    d: "M3.5,14C3.2,14,3,13.8,3,13.5v-11c0-0.2,0.1-0.3,0.2-0.4C3.4,2,3.6,2,3.8,2.1l9.5,5.5c0.2,0.1,0.3,0.4,0.2,0.7 c0,0.1-0.1,0.1-0.2,0.2l-9.5,5.5C3.7,14,3.6,14,3.5,14z M4,3.4v9.3L12,8L4,3.4z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ece || (ece = /* @__PURE__ */ h.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28ZM8,6.6909V25.3088L24.9248,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (knt.propTypes = E);
const Nnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, tce || (tce = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nce || (nce = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Z"
  })), ice || (ice = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nnt.propTypes = E);
const fI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rce || (rce = /* @__PURE__ */ h.createElement("path", {
    d: "M7,28a1,1,0,0,1-1-1V5a1,1,0,0,1,1.4819-.8763l20,11a1,1,0,0,1,0,1.7525l-20,11A1.0005,1.0005,0,0,1,7,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fI.propTypes = E);
const Tnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, sce || (sce = /* @__PURE__ */ h.createElement("path", {
    d: "M8,2c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S4.7,2,8,2 M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z"
  })), oce || (oce = /* @__PURE__ */ h.createElement("path", {
    d: "M6,11.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.2-0.3-0.2-0.4V5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3 C12,7.7,12.1,8,11.9,8.2c0,0.1-0.1,0.2-0.2,0.2l-5.5,3C6.2,11.5,6.1,11.5,6,11.5z M6.5,5.8v4.3l4-2.2L6.5,5.8z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ace || (ace = /* @__PURE__ */ h.createElement("path", {
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), lce || (lce = /* @__PURE__ */ h.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tnt.propTypes = E);
const Int = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, cce || (cce = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M11.7,8.4l-5.5,3c-0.2,0.1-0.3,0.1-0.5,0c-0.2-0.1-0.2-0.3-0.2-0.4V5 c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.5,3C12,7.7,12.1,8,11.9,8.2C11.9,8.3,11.8,8.4,11.7,8.4L11.7,8.4z"
  })), hce || (hce = /* @__PURE__ */ h.createElement("path", {
    d: "M6.5 10.2L10.5 8 6.5 5.8z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dce || (dce = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M11,23a1,1,0,0,1-1-1V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789l-12,6A1.001,1.001,0,0,1,11,23Zm1-11.3821v8.7642L20.7642,16Z"
  })), uce || (uce = /* @__PURE__ */ h.createElement("path", {
    d: "M12 20.382L20.764 16 12 11.618 12 20.382z"
  })), fce || (fce = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm7.4473,14.8945-12,6A1,1,0,0,1,10,22V10a1,1,0,0,1,1.4473-.8945l12,6a1,1,0,0,1,0,1.789Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Int.propTypes = E);
const Ont = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pce || (pce = /* @__PURE__ */ h.createElement("path", {
    d: "M4 6H22V8H4zM4 12H22V14H4zM4 18H16V20H4zM21 18L28 23 21 28 21 18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ont.propTypes = E);
const Rnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gce || (gce = /* @__PURE__ */ h.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Zm0,8a6,6,0,0,1-12,0V10H22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rnt.propTypes = E);
const Vnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mce || (mce = /* @__PURE__ */ h.createElement("path", {
    d: "M22,8H21V2H19V8H13V2H11V8H10a2,2,0,0,0-2,2v6a8.0073,8.0073,0,0,0,7,7.9307V30h2V23.9307A8.0073,8.0073,0,0,0,24,16V10A2,2,0,0,0,22,8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vnt.propTypes = E);
const Hnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ace || (Ace = /* @__PURE__ */ h.createElement("path", {
    d: "M30 23H24a2 2 0 01-2-2V11a2 2 0 012-2h6v2H24V21h4V17H26V15h4zM18 19L14.32 9 12 9 12 23 14 23 14 13 17.68 23 20 23 20 9 18 9 18 19zM4 23H2V9H8a2 2 0 012 2v5a2 2 0 01-2 2H4zm0-7H8V11H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hnt.propTypes = E);
const Bnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wce || (wce = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H18a2.0021 2.0021 0 01-2-2V18a2.0021 2.0021 0 012-2h2v2H18V28H28V18H26V16h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM14 16H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2H14a2.0021 2.0021 0 012 2V6H14V4H4V14H14V12h2v2A2.0021 2.0021 0 0114 16z"
  })), vce || (vce = /* @__PURE__ */ h.createElement("path", {
    d: "M26,9a2.9926,2.9926,0,0,0-5.8157-1H9v2H20.1843A2.9939,2.9939,0,0,0,22,11.8154V23h2V11.8159A2.9958,2.9958,0,0,0,26,9Zm-3,1a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,23,10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bnt.propTypes = E);
const Pnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bce || (bce = /* @__PURE__ */ h.createElement("path", {
    d: "M13.71 12.29L7.41 6 13 6 13 4 4 4 4 13 6 13 6 7.41 12.29 13.71 13.71 12.29zM28 30H12a2 2 0 01-2-2V18h2V28H28V12H18V10H28a2 2 0 012 2V28A2 2 0 0128 30z"
  })), yce || (yce = /* @__PURE__ */ h.createElement("path", {
    d: "M22,15H17v2h5v2H18a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V17A2,2,0,0,0,22,15Zm0,8H18V21h4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pnt.propTypes = E);
const Fnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cce || (Cce = /* @__PURE__ */ h.createElement("path", {
    d: "M10 24H12V30H10z"
  })), Ece || (Ece = /* @__PURE__ */ h.createElement("path", {
    d: "M21,20H7a3.0033,3.0033,0,0,1-3-3V6H2V17a5.0059,5.0059,0,0,0,5,5H21a4.9419,4.9419,0,0,1,2.105.481L17,28.5859,18.4141,30l6.3071-6.3071A4.96,4.96,0,0,1,26,27v3h2V27A7.0078,7.0078,0,0,0,21,20Z"
  })), _ce || (_ce = /* @__PURE__ */ h.createElement("path", {
    d: "M25.2746,4.0386l-7-2a1.0013,1.0013,0,0,0-.55,0l-7,2A.9993.9993,0,0,0,10.03,5.2422L11,9.123V11A7,7,0,1,0,25,11V9.123l.97-3.8808A.9993.9993,0,0,0,25.2746,4.0386ZM18,4.04l5.7952,1.6558L23.219,8H19V6H17V8H12.781l-.5762-2.3042ZM18,16a5.0058,5.0058,0,0,1-5-5V10H23v1A5.0058,5.0058,0,0,1,18,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fnt.propTypes = E);
const znt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xce || (xce = /* @__PURE__ */ h.createElement("path", {
    d: "M30 18A6 6 0 1020 22.46v7.54l4-1.8926 4 1.8926V22.46A5.98 5.98 0 0030 18zm-4 8.84l-2-.9467L22 26.84V23.65a5.8877 5.8877 0 004 0zM24 22a4 4 0 114-4A4.0045 4.0045 0 0124 22zM9 14H16V16H9zM9 8H19V10H9z"
  })), Sce || (Sce = /* @__PURE__ */ h.createElement("path", {
    d: "M6,30a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,6,2H22a2.0021,2.0021,0,0,1,2,2V8H22V4H6V28H16v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (znt.propTypes = E);
const Wnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mce || (Mce = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4H10A2.0059,2.0059,0,0,0,8,6V20a2.0059,2.0059,0,0,0,2,2H28a2.0059,2.0059,0,0,0,2-2V6A2.0059,2.0059,0,0,0,28,4Zm0,16H10V6H28Z"
  })), Dce || (Dce = /* @__PURE__ */ h.createElement("path", {
    d: "M18,26H4V16H6V14H4a2.0059,2.0059,0,0,0-2,2V26a2.0059,2.0059,0,0,0,2,2H18a2.0059,2.0059,0,0,0,2-2V24H18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wnt.propTypes = E);
const jnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lce || (Lce = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m19,7v-3.3999c0-.8837-.7164-1.6001-1.6001-1.6001H4v2h13v3h-6c-1.1046,0-2,.8954-2,2v14c0,1.1046.8954,2,2,2h6v3H4v2h13.3999c.8837,0,1.6001-.7164,1.6001-1.6001v-3.3999h6c1.1046,0,2-.8954,2-2v-14c0-1.1046-.8954-2-2-2h-6Zm6,16h-14v-14h14v14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jnt.propTypes = E);
const Znt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kce || (kce = /* @__PURE__ */ h.createElement("path", {
    d: "M18,28c-3.5928,0-6.9666-1.5903-9.2566-4.3632l1.542-1.2737c1.9087,2.3113,4.7207,3.6368,7.7146,3.6368,5.5139,0,10-4.486,10-10s-4.4861-10-10-10c-2.9939,0-5.8059,1.3256-7.7146,3.6368l-1.542-1.2737c2.29-2.7728,5.6638-4.3632,9.2566-4.3632,6.6169,0,12,5.3832,12,12s-5.3831,12-12,12Z"
  })), Nce || (Nce = /* @__PURE__ */ h.createElement("path", {
    d: "M23 16L16 9 14.5859 10.4141 19.1719 15 2 15 2 17 19.1719 17 14.5859 21.5859 16 23 23 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Znt.propTypes = E);
const Unt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tce || (Tce = /* @__PURE__ */ h.createElement("path", {
    d: "M30 16L23 9 21.5859 10.4141 26.1719 15 9 15 9 17 26.1719 17 21.5859 21.5859 23 23 30 16z"
  })), Ice || (Ice = /* @__PURE__ */ h.createElement("path", {
    d: "M14,28c-6.6167,0-12-5.3832-12-12S7.3833,4,14,4c2.335,0,4.5986,.6714,6.5461,1.9414l-1.0923,1.6753c-1.6221-1.0576-3.5078-1.6167-5.4539-1.6167-5.5139,0-10,4.486-10,10s4.4861,10,10,10c1.946,0,3.8318-.5591,5.4539-1.6167l1.0923,1.6753c-1.9475,1.27-4.2112,1.9414-6.5461,1.9414Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Unt.propTypes = E);
const qnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Oce || (Oce = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,7h-2v-3.3999c0-.8999-.7002-1.6001-1.6001-1.6001H4v2h13v3h-2c-3.3,0-6,2.7002-6,6v6c0,3.2998,2.7,6,6,6h2v3H4v2h13.3999c.8999,0,1.6001-.7002,1.6001-1.6001v-3.3999h2c3.3,0,6-2.7002,6-6v-6c0-3.2998-2.7-6-6-6Zm4,12c0,2.2002-1.8,4-4,4h-6c-2.2,0-4-1.7998-4-4v-6c0-2.2002,1.8-4,4-4h6c2.2,0,4,1.7998,4,4v6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qnt.propTypes = E);
const Gnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rce || (Rce = /* @__PURE__ */ h.createElement("path", {
    d: "M28,10H22V6a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v4H4a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,6h8v4H12ZM4,26V12H28V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gnt.propTypes = E);
const Qnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Vce || (Vce = /* @__PURE__ */ h.createElement("path", {
    d: "M11.2,2.9l-0.5,0.9c2.6,1.5,3.5,4.9,2,7.5s-4.9,3.5-7.5,2s-3.5-4.9-2-7.5c0.5-0.8,1.2-1.5,2-2L4.8,2.9 c-3.1,1.8-4.2,5.8-2.4,8.9s5.8,4.2,8.9,2.4s4.2-5.8,2.4-8.9C13.1,4.3,12.2,3.4,11.2,2.9z"
  })), Hce || (Hce = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5 1H8.5V8H7.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bce || (Bce = /* @__PURE__ */ h.createElement("path", {
    d: "M22.5,5.74l-1,1.73a11,11,0,1,1-11,0l-1-1.73a13,13,0,1,0,13,0Z"
  })), Pce || (Pce = /* @__PURE__ */ h.createElement("path", {
    d: "M15 2H17V16H15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qnt.propTypes = E);
const Knt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fce || (Fce = /* @__PURE__ */ h.createElement("path", {
    d: "M16.0166,29.9937c-7.7085,0-13.9863-6.2646-13.9995-13.9761-.0068-3.7358,1.4443-7.2534,4.0854-9.9043l1.417,1.4121c-2.2642,2.272-3.5083,5.2866-3.5024,8.4888.0054,3.2056,1.2588,6.2168,3.5293,8.4795,2.2651,2.2573,5.2725,3.5,8.4702,3.5h.021c1.3477-.0024,2.6533-.2212,3.8799-.6514l.6611,1.8877c-1.4385.5039-2.9653.7612-4.5381.7637h-.0239Z"
  })), zce || (zce = /* @__PURE__ */ h.createElement("path", {
    d: "M15 16h2v4h2c1.1046 0 2 .8954 2 2v3h-2v-3h-2v3h-2v-3h-2v3h-2v-3c0-1.1046.8954-2 2-2h2v-4zM23 26h0c.5523 0 1 .4477 1 1h0c0 .5523-.4477 1-1 1h0c-.5523 0-1-.4477-1-1h0c0-.5523.4477-1 1-1zM9 4h0c.5523 0 1 .4477 1 1h0c0 .5523-.4477 1-1 1h0c-.5523 0-1-.4477-1-1h0c0-.5523.4477-1 1-1z"
  })), Wce || (Wce = /* @__PURE__ */ h.createElement("path", {
    d: "M20.9199,10.1064c-.4219-2.332-2.4678-4.1064-4.9199-4.1064s-4.498,1.7744-4.9199,4.1064c-1.7637.417-3.0801,2.0049-3.0801,3.8936,0,2.2061,1.7939,4,4,4h1v-2h-1c-1.1025,0-2-.8975-2-2s.8975-2,2-2h1v-1c0-1.6543,1.3457-3,3-3s3,1.3457,3,3v1h1c1.1025,0,2,.8975,2,2s-.8975,2-2,2h-1v2h1c2.2061,0,4-1.7939,4-4,0-1.8887-1.3164-3.4766-3.0801-3.8936Z"
  })), jce || (jce = /* @__PURE__ */ h.createElement("path", {
    d: "M25.8999,25.8885l-1.4141-1.4141c2.2681-2.2681,3.5171-5.2808,3.5171-8.4829,0-6.6167-5.3833-12-12-12-1.3491,0-2.6548.2168-3.8809.644l-.6582-1.8887c1.4385-.501,2.9653-.7554,4.5391-.7554,7.7197,0,14,6.2803,14,14,0,3.7363-1.457,7.251-4.103,9.897Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Knt.propTypes = E);
const Ynt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zce || (Zce = /* @__PURE__ */ h.createElement("path", {
    d: "M9,16h0c0,.3369.024.6749.0714,1.006l-1.9795.2832c-.061-.4238-.0919-.858-.0919-1.2892,0-4.9629,4.0376-9,9-9,2.0435,0,4.0444.7041,5.6348,1.9814l-1.2529,1.5596c-1.2544-1.0083-2.7696-1.541-4.3819-1.541-3.8599,0-6.9999,3.1401-6.9999,7.0001h-.0001ZM8,20c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM16,4c6.6166,0,12,5.3833,12,12h2c0-7.7197-6.2803-14-14-14-1.6431,0-3.2529.2822-4.7846.8389l.6836,1.8799c1.3115-.4771,2.6913-.7188,4.101-.7188ZM22,12c0,.5522.4478,1,1,1s1-.4478,1-1-.4478-1-1-1-1,.4478-1,1ZM9,6c.5522,0,1-.4478,1-1s-.4478-1-1-1-1,.4478-1,1,.4478,1,1,1ZM4,16h0c0-3.2051,1.2481-6.2188,3.5147-8.4854l-1.4141-1.4141c-2.6445,2.6445-4.1006,6.1603-4.1006,9.8995,0,7.7197,6.2803,14,14,14v-2c-6.6166,0-12-5.3832-12-12ZM28.5,25.5c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-.4617.1135-.8942.3006-1.2853l-5.5153-5.5153c-.3911.1871-.8236.3006-1.2853.3006-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3c0,.4617-.1135.8942-.3006,1.2853l5.5153,5.5153c.3911-.1871.8236-.3006,1.2853-.3006,1.6543,0,3,1.3456,3,2.9999h0ZM16,17c.5513,0,1-.4487,1-1s-.4487-1-1-1-1,.4487-1,1,.4487,1,1,1ZM26.5,25.5c0-.5518-.4482-1-1-1s-1,.4482-1,1,.4482,1,1,1,1-.4482,1-1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ynt.propTypes = E);
const Xnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Uce || (Uce = /* @__PURE__ */ h.createElement("path", {
    d: "M22 11L25 11 25 23 27 23 27 11 30 11 30 9 22 9 22 11zM14 23H12V9h6a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H14zm0-7h4V10.9985H14zM4 23H2V9H8a2.002 2.002 0 012 2v5a2.002 2.002 0 01-2 2H4zm0-7H8V10.9985H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xnt.propTypes = E);
const Jnt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qce || (qce = /* @__PURE__ */ h.createElement("path", {
    d: "M15 10H17V18H15zM20 14H22V18H20zM10 12H12V18H10z"
  })), Gce || (Gce = /* @__PURE__ */ h.createElement("path", {
    d: "M25,4H17V2H15V4H7A2,2,0,0,0,5,6V20a2,2,0,0,0,2,2h8v6H11v2H21V28H17V22h8a2,2,0,0,0,2-2V6A2,2,0,0,0,25,4Zm0,16H7V6H25Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jnt.propTypes = E);
const $nt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qce || (Qce = /* @__PURE__ */ h.createElement("path", {
    d: "M17.5053,16l8.1591-7.2529A1,1,0,0,0,25,7H22V2H20V9h2.37L16,14.6621,9.63,9H12V2H10V7H7a1,1,0,0,0-.6646,1.7471L14.4945,16,6.3353,23.2529A1,1,0,0,0,7,25h3v5h2V23H9.63L16,17.3379,22.37,23H20v7h2V25h3a1,1,0,0,0,.6645-1.7471Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($nt.propTypes = E);
const eit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kce || (Kce = /* @__PURE__ */ h.createElement("path", {
    d: "M22 30H10V25H6l10-9 10 9H22zM16 16L6 7h4V2H22V7h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eit.propTypes = E);
const tit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yce || (Yce = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm8,15H11.85l5.58,5.5728L16,24,8,16l8-8,1.43,1.3926L11.85,15H24Z"
  })), Xce || (Xce = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (tit.propTypes = E);
const nit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jce || (Jce = /* @__PURE__ */ h.createElement("path", {
    d: "M16 8L17.43 9.393 11.85 15 24 15 24 17 11.85 17 17.43 22.573 16 24 8 16 16 8z"
  })), $ce || ($ce = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nit.propTypes = E);
const iit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ehe || (ehe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16 2v2c6.63 0 12 5.37 12 12s-5.37 12-12 12v2c7.73 0 14-6.27 14-14S23.73 2 16 2zM8.24 25.14l-1.29 1.53c1.23 1.04 2.64 1.87 4.18 2.44l.68-1.88c-1.32-.49-2.53-1.2-3.58-2.09h.01zM4.19 18l-1.97.41c.28 1.63.84 3.16 1.64 4.54l1.73-.95c-.68-1.18-1.16-2.61-1.4-4zM5.59 10l-1.73-1c-.79 1.38-1.35 2.96-1.64 4.59l1.97.35c.24-1.39.72-2.75 1.4-3.93v-.01zM11.82 4.76l-.68-1.88c-1.54.57-2.95 1.4-4.18 2.44l1.29 1.53c1.05-.89 2.26-1.6 3.58-2.09h-.01z"
  })), the || (the = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,12v-2h-4v-3h-2v3h-2c-1.103,0-2,.897-2,2v3c0,1.103.897,2,2,2h6v3h-8v2h4v3h2v-3h2c1.103,0,2-.8975,2-2v-3c0-1.103-.897-2-2-2h-6v-3h8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iit.propTypes = E);
const rit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nhe || (nhe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M28 2h-5v2h5v24h-5v2h5c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM23 20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71 0-2.39 2.51-3.24 4.65-3.24 2.32 0 4.14.86 5.57 2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6 2.26-6 5.22 0 4.73 3.83 5.26 6.91 5.69 3.25.45 5.09.84 5.09 3.58 0 3.03-3.13 3.48-5 3.48-3.43 0-4.88-.96-6.22-2.63l-1.56 1.26c1.77 2.19 3.73 3.17 6.78 3.34v3.04h2v-3.04c3.73-.3 6-2.33 6-5.44z"
  })), ihe || (ihe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m4,4h5V2H4c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h5v-2H4V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rit.propTypes = E);
const sit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rhe || (rhe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M29 20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71 0-2.39 2.51-3.24 4.65-3.24 2.32 0 4.14.86 5.57 2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6 2.26-6 5.22 0 4.73 3.83 5.26 6.91 5.69 3.25.45 5.09.84 5.09 3.58 0 3.03-3.13 3.48-5 3.48-3.43 0-4.88-.96-6.22-2.63l-1.56 1.26c1.77 2.19 3.73 3.17 6.78 3.34v3.04h2v-3.04c3.73-.3 6-2.33 6-5.44zM3 11H11V13H3zM3 19H11V21H3zM5 15H13V17H5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sit.propTypes = E);
const oit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, she || (she = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M27 21h-2c0-2.8226 0-7.0881-10.0903-8.0042l.1807-1.9917c11.9097 1.0811 11.9097 6.8802 11.9097 9.9958zM16.9097 20.9958c-11.9097-1.0811-11.9097-6.8802-11.9097-9.9958h2c0 2.8226 0 7.0881 10.0903 8.0042l-.1807 1.9917z"
  })), ohe || (ohe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m23,20.52c0-4.62-3.78-5.14-6.82-5.56-3.31-.46-5.18-.86-5.18-3.71,0-2.39,2.51-3.24,4.65-3.24,2.32,0,4.14.86,5.57,2.63l1.56-1.26c-1.52-1.88-3.46-2.97-5.78-3.28v-3.1h-2v3.02c-3.62.22-6,2.26-6,5.22,0,4.73,3.83,5.26,6.91,5.69,3.25.45,5.09.84,5.09,3.58,0,3.03-3.13,3.48-5,3.48-3.43,0-4.88-.96-6.22-2.63l-1.56,1.26c1.77,2.19,3.73,3.17,6.78,3.34v3.04h2v-3.04c3.73-.3,6-2.33,6-5.44Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oit.propTypes = E);
const ait = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ahe || (ahe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m17,15.0698v-6.9536c1.6909.2793,3.084,1.1021,4.2219,2.5117l1.5562-1.2559c-1.5195-1.8823-3.4619-2.9736-5.7781-3.2759v-3.0962h-2v3.022c-3.6152.2192-6,2.2603-6,5.2202,0,4.2739,3.1265,5.1191,6,5.5586v7.1616c-2.7192-.1777-4.0186-1.1001-5.2219-2.5903l-1.5562,1.2559c1.7703,2.1934,3.7332,3.168,6.7781,3.3369v3.0352h2v-3.0449c3.7256-.3042,6-2.3271,6-5.4399,0-4.209-3.1428-5.0156-6-5.4453Zm-6-3.8276c0-2.1533,2.0293-3.0537,4-3.2134v6.7466c-2.5696-.4238-4-1.043-4-3.5332Zm6,12.71v-6.8574c2.5669.4155,4,1.0044,4,3.4204,0,2.5361-2.1902,3.2656-4,3.437Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ait.propTypes = E);
const lit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lhe || (lhe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,9H25V3H7V9H4a2,2,0,0,0-2,2V21a2,2,0,0,0,2,2H7v6H25V23h3a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9ZM9,5H23V9H9ZM23,27H9V17H23Zm5-6H25V15H7v6H4V11H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lit.propTypes = E);
const cit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, che || (che = /* @__PURE__ */ h.createElement("path", {
    d: "M12 25c-.7383 0-1.3762.4048-1.7227 1h-5.6301l2.6479-5.0923c.2273.0552.4609.0923.7048.0923 1.6543 0 3-1.3457 3-3s-1.3457-3-3-3-3 1.3457-3 3c0 .6787.2349 1.2979.6162 1.8013l-3.5034 6.7373c-.1611.3101-.1489.6816.0325.9805.1812.2983.5054.481.8547.481h7.2773c.3464.5952.9844 1 1.7227 1 1.1045 0 2-.8955 2-2s-.8955-2-2-2zm-4-8c.5515 0 1 .4487 1 1s-.4485 1-1 1-1-.4487-1-1 .4485-1 1-1zM29.8872 26.5386l-4.041-7.771c.0986-.2363.1538-.4956.1538-.7676 0-1.1045-.8955-2-2-2s-2 .8955-2 2 .8955 2 2 2c.0757 0 .1477-.0142.2212-.0225l3.1316 6.0225h-4.5371c-.4141-1.1611-1.5137-2-2.8157-2-1.6543 0-3 1.3457-3 3s1.3457 3 3 3c1.302 0 2.4016-.8389 2.8157-2h6.1843c.3494 0 .6736-.1826.8547-.481.1814-.2988.1936-.6704.0325-.9805zm-9.8872 1.4614c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1zM21 8c-.2439 0-.4778.0371-.7048.0923l-3.408-6.5537c-.1721-.3311-.5298-.5386-.8872-.5386s-.7151.2075-.8872.5386l-3.8914 7.4839c-.0737-.0083-.1458-.0225-.2214-.0225-1.1045 0-2 .8955-2 2s.8955 2 2 2 2-.8955 2-2c0-.272-.0552-.5312-.1538-.7676l3.1538-6.0649 2.6162 5.0312c-.3813.5034-.6162 1.1226-.6162 1.8013 0 1.6543 1.3457 3 3 3s3-1.3457 3-3-1.3457-3-3-3zm0 4c-.5515 0-1-.4487-1-1s.4485-1 1-1 1 .4487 1 1-.4485 1-1 1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cit.propTypes = E);
const hit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hhe || (hhe = /* @__PURE__ */ h.createElement("path", {
    d: "m31,17c0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,1.3018.8384,2.4014,2,2.8154v2.6104l-11,6.4165-10.0154-5.8423,22.5193-13.1362c.3071-.1792.4961-.5083.4961-.8638s-.189-.6846-.4961-.8638L16.5039,1.1362c-.1558-.0908-.3298-.1362-.5039-.1362s-.3481.0454-.5039.1362L3.4961,8.1362c-.3071.1792-.4961.5083-.4961.8638v3.1846c-1.1616.4141-2,1.5137-2,2.8154,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-1.3018-.8384-2.4014-2-2.8159v-2.6099l11-6.4165,10.0154,5.8423L3.4961,22.1362c-.3071.1792-.4961.5083-.4961.8638s.189.6846.4961.8638l12,7c.1558.0908.3298.1362.5039.1362s.3481-.0454.5039-.1362l12-7c.3071-.1792.4961-.5083.4961-.8638v-3.1841c1.1616-.4146,2-1.5142,2-2.8159Zm-27-1c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm24,2c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hit.propTypes = E);
const dit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dhe || (dhe = /* @__PURE__ */ h.createElement("path", {
    d: "M8 18H14V20H8zM8 22H18V24H8z"
  })), uhe || (uhe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0025,2.0025,0,0,0,2-2V6A2.0025,2.0025,0,0,0,26,4ZM18,6v4H14V6ZM6,26V6h6v6h8V6h6l.0012,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dit.propTypes = E);
const uit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fhe || (fhe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,21H4a2.0021,2.0021,0,0,1-2-2V13a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,21ZM4,13v6H28V13Z"
  })), phe || (phe = /* @__PURE__ */ h.createElement("path", {
    d: "M6 15H20V17H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uit.propTypes = E);
const fit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ghe || (ghe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), mhe || (mhe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,26a10.0162,10.0162,0,0,1-7.4531-3.3325l1.49-1.334A8,8,0,1,0,16,8V6a10,10,0,0,1,0,20Z"
  })), Ahe || (Ahe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fit.propTypes = E);
const pit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, whe || (whe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 21L17.4 22.4 14.8 25 23 25 23 27 14.8 27 17.4 29.6 16 31 11 26z"
  })), vhe || (vhe = /* @__PURE__ */ h.createElement("path", {
    d: "M6.3 19H17.6V21H6.3z",
    transform: "rotate(-45.001 12 20)"
  })), bhe || (bhe = /* @__PURE__ */ h.createElement("path", {
    d: "M23,22h-2v-5c0-0.3,0.1-0.5,0.3-0.7l4.1-4.1c1.7-1.7,2.6-4,2.6-6.4V4h-1.9c-2.4,0-4.7,0.9-6.4,2.6l-4.1,4.1 C15.5,10.9,15.3,11,15,11H7.5l-2.6,3.3l5.3,0.8l-0.3,2l-7-1c-0.4-0.1-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l4-5C6.4,9.1,6.7,9,7,9h7.6 l3.8-3.8C20.4,3.1,23.2,2,26.1,2H28c1.1,0,2,0.9,2,2v1.9c0,2.9-1.1,5.7-3.2,7.8L23,17.4V22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pit.propTypes = E);
const git = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yhe || (yhe = /* @__PURE__ */ h.createElement("path", {
    d: "M27 25.5859L25 23.5859 25 21 23 21 23 24.4141 25.5859 27 27 25.5859z"
  })), Che || (Che = /* @__PURE__ */ h.createElement("path", {
    d: "M24 31c-3.8599 0-7-3.1401-7-7s3.1401-7 7-7 7 3.1401 7 7-3.1401 7-7 7zm0-12c-2.7571 0-5 2.2429-5 5s2.2429 5 5 5 5-2.2429 5-5-2.2429-5-5-5zM28 15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10z"
  })), Ehe || (Ehe = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), _he || (_he = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), xhe || (xhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), She || (She = /* @__PURE__ */ h.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (git.propTypes = E);
const mit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mhe || (Mhe = /* @__PURE__ */ h.createElement("path", {
    d: "M31.5 23c-.8271 0-1.5-.6729-1.5-1.5v-1.5c0-1.1025-.8972-2-2-2h-2v2h2v1.5c0 .98.4072 1.8643 1.0581 2.5-.6509.6357-1.0581 1.52-1.0581 2.5v1.5h-2v2h2c1.1028 0 2-.8975 2-2v-1.5c0-.8271.6729-1.5 1.5-1.5h.5v-2h-.5zM16 20v1.5c0 .8271-.6729 1.5-1.5 1.5h-.5v2h.5c.8271 0 1.5.6729 1.5 1.5v1.5c0 1.1025.8972 2 2 2h2v-2h-2v-1.5c0-.98-.4072-1.8643-1.0581-2.5.6509-.6357 1.0581-1.52 1.0581-2.5v-1.5h2v-2h-2c-1.1028 0-2 .8975-2 2zM28 15h2V5c0-1.103-.8975-2-2-2h-3v2h3v10z"
  })), Dhe || (Dhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "13",
    r: "2"
  })), Lhe || (Lhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), khe || (khe = /* @__PURE__ */ h.createElement("circle", {
    cx: "9",
    cy: "13",
    r: "2"
  })), Nhe || (Nhe = /* @__PURE__ */ h.createElement("path", {
    d: "m7,23h-3c-1.103,0-2-.8975-2-2V5c0-1.103.897-2,2-2h3v2h-3v16h3v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mit.propTypes = E);
const Ait = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, The || (The = /* @__PURE__ */ h.createElement("path", {
    d: "M30 16L22 24 20.6 22.6 27.2 16 20.6 9.4 22 8zM12 15H20V17H12zM2 16L10 8 11.4 9.4 4.8 16 11.4 22.6 10 24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ait.propTypes = E);
const wit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ihe || (Ihe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M25 22.1421v-13.1421c0-2.2056-1.7944-4-4-4h-4.1719l2.5859-2.5859-1.4141-1.4141-5 5 5 5 1.4141-1.4141-2.5859-2.5859h4.1719c1.1028 0 2 .8975 2 2v13.1421c-1.7202.4473-3 1.9995-3 3.8579 0 2.2056 1.7944 4 4 4s4-1.7944 4-4c0-1.8584-1.2798-3.4106-3-3.8579zm-1 5.8579c-1.1028 0-2-.8975-2-2s.8972-2 2-2 2 .8975 2 2-.8972 2-2 2zM4 6c0 1.8584 1.2798 3.4106 3 3.8579v12.2842c-1.7202.447-3 1.9993-3 3.8579 0 2.2061 1.7944 4 4 4s4-1.7939 4-4c0-1.8586-1.2798-3.4109-3-3.8579v-12.2842c1.7202-.4473 3-1.9995 3-3.8579 0-2.2056-1.7944-4-4-4s-4 1.7944-4 4zm6 20c0 1.1025-.897 2-2 2s-2-.8975-2-2c0-1.1025.897-2 2-2s2 .8975 2 2zm0-20c0 1.103-.897 2-2 2s-2-.897-2-2c0-1.103.897-2 2-2s2 .897 2 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wit.propTypes = E);
const vit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ohe || (Ohe = /* @__PURE__ */ h.createElement("path", {
    d: "M23,27.1781l-2.59-2.59-1.41,1.4119,4,4,7-7-1.41-1.4119-5.59,5.59ZM14,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM22,16h-3v-.1689c0-1.397.7441-2.7114,1.9419-3.4302l1.1416-.6865-1.03-1.7144-1.1404.686c-1.7969,1.0781-2.9131,3.0493-2.9131,5.145v5.1689c0,.5522.4478,1,1,1h4c.5522,0,1-.4478,1-1v-4c0-.5522-.4478-1-1-1h0ZM12,28h-6c-1.103,0-2-.8975-2-2V6c0-1.103.897-2,2-2h20c1.1025,0,2,.897,2,2v11h-2V6H6v20h6v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vit.propTypes = E);
const bit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rhe || (Rhe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6Zm0,2v3H4V8ZM4,24V13H28V24Z"
  })), Vhe || (Vhe = /* @__PURE__ */ h.createElement("path", {
    d: "M6 20H16V22H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bit.propTypes = E);
const yit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hhe || (Hhe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 22H19a2.0023 2.0023 0 01-2-2V10a2.002 2.002 0 012-2h6v2H19V20h6zM13 8H9a2.002 2.002 0 00-2 2V20a2.0023 2.0023 0 002 2h1v2a2.0023 2.0023 0 002 2h2V24H12V22h1a2.0023 2.0023 0 002-2V10A2.002 2.002 0 0013 8zM9 20V10h4V20z"
  })), Bhe || (Bhe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,30H4a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,4,2H28a2.0023,2.0023,0,0,1,2,2V28A2.0027,2.0027,0,0,1,28,30ZM4,4V28H28V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yit.propTypes = E);
const Cit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Phe || (Phe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m16,1C7.729,1,1,7.729,1,16s6.729,15,15,15,15-6.729,15-15S24.271,1,16,1Zm6.5825,20.5c-.5203-.8926-1.4771-1.5-2.5825-1.5-.1821,0-.3586.0225-.532.0537l-1.7258-3.0205c6.7866.2388,10.1216,1.8262,10.2571,2.4668-.0979.4624-1.8899,1.4141-5.4167,2Zm-2.5825.5c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1ZM3,16c0-.5435.0442-1.0762.1094-1.6025.8552.666,2.1555,1.1973,3.7239,1.6025-1.5684.4053-2.8687.9365-3.7239,1.6025-.0652-.5264-.1094-1.0591-.1094-1.6025Zm6.4175-5.4995c.5205.8921,1.4773,1.4995,2.5825,1.4995.1821,0,.3586-.0225.532-.0537l1.7258,3.0205c-6.8042-.2393-10.1387-1.8335-10.2581-2.4619.0862-.4609,1.8784-1.416,5.4177-2.0044Zm2.5825-.5005c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm13.167,6c1.5681-.4053,2.8684-.9365,3.7236-1.6025.0652.5264.1094,1.0591.1094,1.6025s-.0442,1.0762-.1094,1.6025c-.8552-.666-2.1555-1.1973-3.7236-1.6025ZM16,3c4.9019,0,9.1758,2.7285,11.3901,6.7451-2.2891-.9961-5.7993-1.5513-9.3901-1.6997v1.999c6.6108.2695,9.8655,1.8232,9.9993,2.4556-.1431.6763-3.8533,2.4062-11.4236,2.4917l-2.3118-4.0454c.4524-.5254.7361-1.2002.7361-1.9463,0-1.6543-1.3457-3-3-3-1.4956,0-2.7285,1.1035-2.9531,2.5371-1.7056.2837-3.2363.6841-4.4351,1.2051,2.2151-4.0146,6.4878-6.7422,11.3882-6.7422Zm0,26c-4.9019,0-9.1758-2.7285-11.3901-6.7451,2.2891.9961,5.7993,1.5513,9.3901,1.6997v-1.999c-6.6282-.2705-9.8823-1.8306-10.0002-2.4507.126-.6729,3.8357-2.4106,11.4246-2.4966l2.3118,4.0454c-.4524.5254-.7361,1.2002-.7361,1.9463,0,1.6543,1.3457,3,3,3,1.4956,0,2.7285-1.1035,2.9531-2.5371,1.7056-.2837,3.2363-.6841,4.4351-1.2051-2.2151,4.0146-6.4878,6.7422-11.3882,6.7422Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cit.propTypes = E);
const Eit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fhe || (Fhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "20",
    cy: "4",
    r: "2"
  })), zhe || (zhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "8",
    cy: "16",
    r: "2"
  })), Whe || (Whe = /* @__PURE__ */ h.createElement("circle", {
    cx: "28",
    cy: "12",
    r: "2"
  })), jhe || (jhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "11",
    cy: "7",
    r: "2"
  })), Zhe || (Zhe = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "2"
  })), Uhe || (Uhe = /* @__PURE__ */ h.createElement("path", {
    d: "M30,3.4131,28.5859,2,4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4131Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eit.propTypes = E);
const _it = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qhe || (qhe = /* @__PURE__ */ h.createElement("path", {
    d: "M24 26H26V28H24z",
    transform: "rotate(-90 25 27)"
  })), Ghe || (Ghe = /* @__PURE__ */ h.createElement("path", {
    d: "M18 22H20V24H18z",
    transform: "rotate(-90 19 23)"
  })), Qhe || (Qhe = /* @__PURE__ */ h.createElement("path", {
    d: "M18 30L22 30 22 28 20 28 20 26 18 26 18 30z"
  })), Khe || (Khe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 23H29V25H25z",
    transform: "rotate(-90 27 24)"
  })), Yhe || (Yhe = /* @__PURE__ */ h.createElement("path", {
    d: "M28 26L30 26 30 30 26 30 26 28 28 28 28 26zM26 20L26 18 30 18 30 22 28 22 28 20 26 20zM24 20L22 20 22 24 20 24 20 26 24 26 24 20z"
  })), Xhe || (Xhe = /* @__PURE__ */ h.createElement("path", {
    d: "M19 17H21V21H19z",
    transform: "rotate(-90 20 19)"
  })), Jhe || (Jhe = /* @__PURE__ */ h.createElement("path", {
    d: "M6 22H10V26H6z"
  })), $he || ($he = /* @__PURE__ */ h.createElement("path", {
    d: "M14 30H2V18H14zM4 28h8V20H4zM22 6H26V10H22z"
  })), ede || (ede = /* @__PURE__ */ h.createElement("path", {
    d: "M30 14H18V2H30zM20 12h8V4H20zM6 6H10V10H6z"
  })), tde || (tde = /* @__PURE__ */ h.createElement("path", {
    d: "M14,14H2V2H14ZM4,12h8V4H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_it.propTypes = E);
const xit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nde || (nde = /* @__PURE__ */ h.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), ide || (ide = /* @__PURE__ */ h.createElement("path", {
    d: "M5 30a3 3 0 113-3A3.0033 3.0033 0 015 30zm0-4a1 1 0 101 1A1.001 1.001 0 005 26zM8 8a3 3 0 113-3A3.0033 3.0033 0 018 8zM8 4A1 1 0 109 5 1.001 1.001 0 008 4zM22 13a3 3 0 113-3A3.0033 3.0033 0 0122 13zm0-4a1 1 0 101 1A1.001 1.001 0 0022 9z"
  })), rde || (rde = /* @__PURE__ */ h.createElement("circle", {
    cx: "11",
    cy: "11",
    r: "2"
  })), sde || (sde = /* @__PURE__ */ h.createElement("circle", {
    cx: "11",
    cy: "21",
    r: "2"
  })), ode || (ode = /* @__PURE__ */ h.createElement("circle", {
    cx: "21",
    cy: "21",
    r: "2"
  })), ade || (ade = /* @__PURE__ */ h.createElement("circle", {
    cx: "22",
    cy: "28",
    r: "2"
  })), lde || (lde = /* @__PURE__ */ h.createElement("circle", {
    cx: "28",
    cy: "24",
    r: "2"
  })), cde || (cde = /* @__PURE__ */ h.createElement("circle", {
    cx: "4",
    cy: "11",
    r: "2"
  })), hde || (hde = /* @__PURE__ */ h.createElement("circle", {
    cx: "28",
    cy: "4",
    r: "2"
  })), n);
});
process.env.NODE_ENV !== "production" && (xit.propTypes = E);
const Sit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dde || (dde = /* @__PURE__ */ h.createElement("circle", {
    cx: "11",
    cy: "15.5",
    r: "1.5"
  })), ude || (ude = /* @__PURE__ */ h.createElement("path", {
    d: "M12,12H10V8h2a2,2,0,0,0,0-4H10A2.0023,2.0023,0,0,0,8,6v.5H6V6a4.0045,4.0045,0,0,1,4-4h2a4,4,0,0,1,0,8Z"
  })), fde || (fde = /* @__PURE__ */ h.createElement("path", {
    d: "M22.4479,21.0337A10.971,10.971,0,0,0,19.9211,4.7446l-.999,1.73A8.9967,8.9967,0,1,1,5,14H3a10.9916,10.9916,0,0,0,18.0338,8.4478L28.5859,30,30,28.5859Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sit.propTypes = E);
const Mit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pde || (pde = /* @__PURE__ */ h.createElement("path", {
    d: "M10 6H28V8H10zM10 12H28V14H10zM15 18H28V20H15zM10 24H28V26H10zM4 14L11 19 4 24 4 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mit.propTypes = E);
const Dit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gde || (gde = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M20 15.1798L17.41 12.59 16 14 20 18 26 12 24.59 10.59 20 15.1798zM8 18H10V20H8zM12 9h-5v2h4v2h-3v3h2v-1h2c.5522 0 1-.4478 1-1v-4c0-.5522-.4478-1-1-1z"
  })), mde || (mde = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m17.7358,30l-1.7358-1,4-7h6c1.1071,0,2-.8926,2-2v-12c0-1.1074-.8929-2-2-2H6c-1.1071,0-2,.8926-2,2v12c0,1.1074.8929,2,2,2h9v2H6c-2.2093,0-4-1.79-4-4v-12c0-2.2109,1.7907-4,4-4h20c2.2093,0,4,1.7891,4,4v12c0,2.21-1.7907,4-4,4h-4.8354l-3.4287,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dit.propTypes = E);
const Lit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ade || (Ade = /* @__PURE__ */ h.createElement("path", {
    d: "M22 20H30V22H22zM22 24H30V26H22zM22 28H30V30H22zM18 24H20V26H18zM18 20H20V22H18zM18 28H20V30H18zM6.8149 8.293A12.0777 12.0777 0 0110.0068 5.62L9.0079 3.89A14.0845 14.0845 0 005.2841 7.0083zM25.1851 8.293l1.5308-1.2847A14.0845 14.0845 0 0022.9921 3.89l-.9989 1.73A12.0777 12.0777 0 0125.1851 8.293zM4.7366 11.9l-1.8772-.6831A13.9019 13.9019 0 002 16H4A11.917 11.917 0 014.7366 11.9zM6.8149 23.707A11.9975 11.9975 0 014.7366 20.1l-1.8772.6831a13.99 13.99 0 002.4247 4.209zM27.2634 11.9A11.917 11.917 0 0128 16h2a13.8971 13.8971 0 00-.8594-4.7827zM13.9182 27.8066A11.8894 11.8894 0 0110.0068 26.38l-.9989 1.73a13.8673 13.8673 0 004.5633 1.664zM13.9182 4.1934a11.3012 11.3012 0 014.1636 0l.347-1.9678a13.187 13.187 0 00-4.8576 0z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lit.propTypes = E);
const kit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wde || (wde = /* @__PURE__ */ h.createElement("path", {
    d: "M12 15H6.11A9 9 0 0110 8.86l1.79-1.2L10.69 6 8.9 7.2A11 11 0 004 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0012 15zM26 15H20.11A9 9 0 0124 8.86l1.79-1.2L24.7 6 22.9 7.2A11 11 0 0018 16.35V23a2 2 0 002 2h6a2 2 0 002-2V17A2 2 0 0026 15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kit.propTypes = E);
const Nit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vde || (vde = /* @__PURE__ */ h.createElement("path", {
    d: "M30,3.4141,28.5859,2,15.293,15.293a1,1,0,0,0,1.414,1.414l4.18-4.1792A5.9956,5.9956,0,1,1,16,10V8a8.011,8.011,0,1,0,6.3164,3.0977L25.1631,8.251A11.881,11.881,0,0,1,28,16,12,12,0,1,1,16,4V2A14,14,0,1,0,30,16a13.8572,13.8572,0,0,0-3.4224-9.1636Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nit.propTypes = E);
const Tit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bde || (bde = /* @__PURE__ */ h.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541A4.9817,4.9817,0,0,1,18,19a5.0385,5.0385,0,0,1-.6074-.05,8.0432,8.0432,0,0,0-4.3421-4.3423A4.9,4.9,0,0,1,18,9V7a7.0078,7.0078,0,0,0-7,7c0,.0234.0056.0469.0059.07A8.0469,8.0469,0,0,0,10,14a7.95,7.95,0,0,0-1.9883.26C8.0095,14.1729,8,14.0879,8,14A10.0114,10.0114,0,0,1,18,4V2A12.0137,12.0137,0,0,0,6,14c0,.355.0171.7061.0471,1.0537A7.9943,7.9943,0,1,0,16.9465,25.9521c.35.03.7019.0479,1.0535.0479A11.9853,11.9853,0,0,0,27.1538,6.2607ZM15.91,21H13.9563a12.029,12.029,0,0,0-1.218-4.332A6.01,6.01,0,0,1,15.91,21ZM4.09,23H6.0435a12.0318,12.0318,0,0,0,1.2182,4.3325A6.01,6.01,0,0,1,4.09,23Zm1.9532-2H4.09a6.01,6.01,0,0,1,3.1714-4.332A12.0321,12.0321,0,0,0,6.0435,21ZM10,27.9858A10.0149,10.0149,0,0,1,8.0552,23h3.89A10.0149,10.0149,0,0,1,10,27.9858ZM8.0552,21A10.0118,10.0118,0,0,1,10,16.0151,10.01,10.01,0,0,1,11.9448,21Zm4.6831,6.3325A12.0318,12.0318,0,0,0,13.9565,23H15.91A6.01,6.01,0,0,1,12.7383,27.3325ZM28,14A10.0114,10.0114,0,0,1,18,24c-.0869,0-.1733-.01-.26-.0117a7.5527,7.5527,0,0,0,.19-2.9942c.0237,0,.0466.0059.07.0059A6.9991,6.9991,0,0,0,23.6055,9.8086l2.1313-2.1314A9.95,9.95,0,0,1,28,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tit.propTypes = E);
const Iit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yde || (yde = /* @__PURE__ */ h.createElement("path", {
    d: "M30,3.4146,28.5854,2,17.2932,13.2925a1,1,0,1,0,1.4141,1.414l3.4543-3.4541a4.9646,4.9646,0,0,1-3.8811,7.7193,7.0485,7.0485,0,0,0-5.1438-3.8731A4.9431,4.9431,0,0,1,18,9V7a6.9551,6.9551,0,0,0-6.9087,8.0791,6.93,6.93,0,0,0-2.8525,1.06A9.97,9.97,0,0,1,18,4V2A11.9756,11.9756,0,0,0,6.573,17.6357a6.9293,6.9293,0,0,0-1.3674,2.7061A4.9948,4.9948,0,0,0,7,30H17a4.9921,4.9921,0,0,0,4.9678-4.68A12.0391,12.0391,0,0,0,30,14a11.8678,11.8678,0,0,0-2.8389-7.7466ZM17,28H7a2.9945,2.9945,0,0,1-.6963-5.9082l.6587-.1572.0986-.67a4.9923,4.9923,0,0,1,9.878,0l.0986.6695.6587.1572A2.9945,2.9945,0,0,1,17,28ZM28,14a10.0346,10.0346,0,0,1-6.3118,9.291,4.9577,4.9577,0,0,0-2.0207-2.5,6.9922,6.9922,0,0,0,3.938-10.9824l2.132-2.1318A9.8873,9.8873,0,0,1,28,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iit.propTypes = E);
const Oit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cde || (Cde = /* @__PURE__ */ h.createElement("path", {
    d: "M28,10H24V2H22v8H13V8H11v2H8V8H6v2H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM4,28V12H28V28Z"
  })), Ede || (Ede = /* @__PURE__ */ h.createElement("path", {
    d: "M10 26a4 4 0 114-4A4 4 0 0110 26zm0-6a2 2 0 102 2A2 2 0 0010 20zM7 14H13V16H7zM17 16H26V18H17zM17 20H26V22H17zM17 24H26V26H17z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oit.propTypes = E);
const Rit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _de || (_de = /* @__PURE__ */ h.createElement("path", {
    d: "M10 26a4 4 0 114-4A4.0045 4.0045 0 0110 26zm0-6a2 2 0 102 2A2.0021 2.0021 0 0010 20zM17 20H26V22H17zM17 24H26V26H17z"
  })), xde || (xde = /* @__PURE__ */ h.createElement("path", {
    d: "M20,12h8a2.0023,2.0023,0,0,0,2-2V6a2.0023,2.0023,0,0,0-2-2H20a2.0023,2.0023,0,0,0-2,2V7H12a4.0045,4.0045,0,0,0-4,4v3H6V4H4V14a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V16a2.0023,2.0023,0,0,0-2-2H10V11a2.0023,2.0023,0,0,1,2-2h6v1A2.0023,2.0023,0,0,0,20,12Zm4-6h4v4H24ZM20,6h2v4H20Zm8,22H4V16H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rit.propTypes = E);
const Vit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sde || (Sde = /* @__PURE__ */ h.createElement("path", {
    d: "M13 11H19V13H13zM13 15H19V17H13z"
  })), Mde || (Mde = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "23",
    r: "2"
  })), Dde || (Dde = /* @__PURE__ */ h.createElement("path", {
    d: "M22,7H21V2H19V7H10A2.0023,2.0023,0,0,0,8,9v2H6v2H8v2H6v2H8V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V9A2.0023,2.0023,0,0,0,22,7ZM10,28V9H22V28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vit.propTypes = E);
const Hit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lde || (Lde = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hit.propTypes = E);
const pI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kde || (kde = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), Nde || (Nde = /* @__PURE__ */ h.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pI.propTypes = E);
const Bit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tde || (Tde = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M12 28h-2c-3.8599 0-7-3.1401-7-7v-2h2v2c0 2.7568 2.2432 5 5 5h2v2zM28 19h-9c-1.104.0014-1.9986.896-2 2v5c0 1.1046.8954 2 2 2h3v-2h-3v-5h9v5h-2.5352l-2.5937 3.8906 1.6641 1.1094 2-3h1.4648c1.1046 0 2-.8954 2-2v-5c-.0014-1.104-.896-1.9986-2-2zM29 15v-4c0-3.8599-3.1401-7-7-7h-3v2h3c2.7568 0 5 2.2432 5 5v4h2zM6 10H9V12H6z"
  })), Ide || (Ide = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m12.606,6.4355l-2.5251-3.6855c-.3821-.4766-.9512-.75-1.5615-.75h-4.5193c-1.1028,0-2,.8975-2,2v10c0,1.1025.8972,2,2,2h7c1.1028,0,2-.8975,2-2v-6.375c0-.4526-.1558-.8965-.394-1.1895Zm-8.606,7.5645V4h4v3c0,.5522.4478,1,1,1h2v6h-7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bit.propTypes = E);
const Pit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ode || (Ode = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5 22H8.5A6.5 6.5 0 017.2 9.14a9 9 0 0117.6 0A6.5 6.5 0 0123.5 22zM16 4a7 7 0 00-6.94 6.14L9 11 8.14 11a4.5 4.5 0 00.36 9h15a4.5 4.5 0 00.36-9L23 11l-.1-.82A7 7 0 0016 4zM14 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0114 30zM20 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 0120 30zM8 30a.93.93 0 01-.45-.11 1 1 0 01-.44-1.34l2-4a1 1 0 111.78.9l-2 4A1 1 0 018 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pit.propTypes = E);
const Fit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rde || (Rde = /* @__PURE__ */ h.createElement("path", {
    d: "M11,30a1,1,0,0,1-.8944-1.4474l2-4a1,1,0,1,1,1.7887.8946l-2,4A.9979.9979,0,0,1,11,30Z"
  })), Vde || (Vde = /* @__PURE__ */ h.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0A6.4973,6.4973,0,0,0,8.5,22H19.3813L18.105,24.5527a1,1,0,0,0,1.789.8946L21.6177,22H23.5A6.4974,6.4974,0,0,0,24.8008,9.1362ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fit.propTypes = E);
const zit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hde || (Hde = /* @__PURE__ */ h.createElement("path", {
    d: "M17 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0117 30zM8 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 018 30z"
  })), Bde || (Bde = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zit.propTypes = E);
const Wit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pde || (Pde = /* @__PURE__ */ h.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), Fde || (Fde = /* @__PURE__ */ h.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.009 28.232 17.233)"
  })), zde || (zde = /* @__PURE__ */ h.createElement("path", {
    d: "M29 10H32V12H29z"
  })), Wde || (Wde = /* @__PURE__ */ h.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), jde || (jde = /* @__PURE__ */ h.createElement("path", {
    d: "M20 0H22V3H20z"
  })), Zde || (Zde = /* @__PURE__ */ h.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), Ude || (Ude = /* @__PURE__ */ h.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wit.propTypes = E);
const jit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qde || (qde = /* @__PURE__ */ h.createElement("path", {
    d: "M8.5084 32a1.0115 1.0115 0 01-.4485-.1055.9986.9986 0 01-.4486-1.3418l1.4934-3a1.0025 1.0025 0 011.7943.8945l-1.4934 3A1.0015 1.0015 0 018.5084 32zM29.8442 13.0347a1.5184 1.5184 0 00-1.2309-.8658 5.3587 5.3587 0 01-3.4094-1.7163 6.4648 6.4648 0 01-1.285-6.393 1.6031 1.6031 0 00-.3-1.5459 1.4535 1.4535 0 00-1.3594-.4922l-.0191.0029a7.8549 7.8549 0 00-6.1054 6.48A7.3725 7.3725 0 0013.5 8a7.5511 7.5511 0 00-7.1494 5.2441A5.9926 5.9926 0 008 25h7.3818L14.106 27.5527a1 1 0 101.7885.8946L17.6177 25H19a5.9549 5.9549 0 005.88-7.1455 7.5 7.5 0 004.8672-3.3A1.5381 1.5381 0 0029.8442 13.0347zM19 23H8a3.9926 3.9926 0 01-.6733-7.9292l.663-.1128.1456-.6562a5.496 5.496 0 0110.7294 0l.1456.6562.6626.1128A3.9925 3.9925 0 0119 23zm5.1509-7.0479a5.9639 5.9639 0 00-3.5015-2.708A7.5076 7.5076 0 0018.0286 9.55a6.01 6.01 0 013.77-5.334 8.4581 8.4581 0 001.9395 7.5972A7.4007 7.4007 0 0027.64 14.041 5.4392 5.4392 0 0124.1509 15.9521z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jit.propTypes = E);
const Zit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gde || (Gde = /* @__PURE__ */ h.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), Qde || (Qde = /* @__PURE__ */ h.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zit.propTypes = E);
const Uit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kde || (Kde = /* @__PURE__ */ h.createElement("path", {
    d: "M29.2 9L28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9zM18 9H14a2 2 0 00-2 2V23h2V18h4v5h2V11A2 2 0 0018 9zm-4 7V11h4v5zM10 15V11A2 2 0 008 9H2V23H4V17H5.48l2.34 6H10L7.63 17H8A2 2 0 0010 15zM4 11H8v4H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uit.propTypes = E);
const qit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yde || (Yde = /* @__PURE__ */ h.createElement("path", {
    d: "M21 16H23V18H21zM9 16H17V18H9zM21 12H23V14H21zM9 12H17V14H9zM9 8H23V10H9z"
  })), Xde || (Xde = /* @__PURE__ */ h.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qit.propTypes = E);
var Jde, $de, eue, tue, nue, iue, rue, sue, oue, aue, lue, cue, hue, due, uue, fue, pue, gue, mue, Aue, wue, vue, bue, yue, Cue, Eue, _ue, xue, Sue, Mue, Due, Lue, kue, Nue, Tue, Iue, Oue, Rue, Vue, Hue, Bue, Pue, Fue, zue, Wue, jue, Zue, Uue, que, Gue, Que, Kue, Yue, Xue, Jue, $ue, e1e, t1e, n1e, i1e, r1e, s1e, o1e, a1e, l1e, c1e, h1e, d1e, u1e, f1e, p1e, g1e, m1e, A1e, w1e, v1e, b1e, y1e, C1e, E1e, _1e, x1e, S1e, M1e, D1e, L1e, k1e, N1e, T1e, I1e, O1e, R1e, V1e, H1e, B1e, P1e, F1e, z1e, W1e, j1e, Z1e, U1e, q1e, G1e, Q1e, K1e, Y1e, X1e, J1e, $1e, e0e, t0e, n0e, i0e, r0e, s0e, o0e, a0e, l0e, c0e, h0e, d0e, u0e, f0e, p0e, g0e, m0e, A0e, w0e, v0e, b0e, y0e, C0e, E0e, _0e, x0e, S0e, M0e, D0e, L0e, k0e, N0e, T0e, I0e, O0e, R0e, V0e, H0e, B0e, P0e, F0e, z0e, W0e, j0e, Z0e, U0e, q0e, G0e, Q0e, K0e, Y0e, X0e, J0e, $0e, efe, tfe, nfe, ife, rfe, sfe, ofe, afe, lfe, cfe, hfe, dfe, ufe, ffe, pfe, gfe, mfe, Afe, wfe, vfe, bfe, yfe, Cfe, Efe, _fe, xfe, Sfe, Mfe, Dfe, Lfe, kfe, Nfe, Tfe, Ife, Ofe, Rfe, Vfe, Hfe, Bfe, Pfe, Ffe, zfe, Wfe, jfe, Zfe;
const Git = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jde || (Jde = /* @__PURE__ */ h.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), $de || ($de = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Git.propTypes = E);
const Qit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eue || (eue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qit.propTypes = E);
const Kit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tue || (tue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), nue || (nue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kit.propTypes = E);
const Yit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iue || (iue = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), rue || (rue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yit.propTypes = E);
const Xit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sue || (sue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22 z"
  })), oue || (oue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xit.propTypes = E);
const Jit = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aue || (aue = /* @__PURE__ */ h.createElement("path", {
    d: "M29.5081 22.2549l-2.0781-3.7402-1.7485.9707 2.0781 3.7412c.3247.584.3162 1.2769-.0229 1.8535-.3391.5762-.9407.9199-1.6091.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5 5 5 5 1.4102-1.4102-2.5801-2.5898h7.2974c1.3848 0 2.6306-.7124 3.3328-1.9058.7024-1.1938.7202-2.6284.0479-3.8394zM5.8726 26c-.6685 0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004 1.0479 3.52 1.9121-.5664-2.0083-6.7798-6.7798 2.0083.5664 1.9121 3.4934-1.0298-4.0913 7.3643c-.6724 1.2109-.6545 2.6455.0479 3.8394.7021 1.1934 1.948 1.9058 3.3328 1.9058h6.1274v-2H5.8726zM25.51 9.6538l-1.0476 3.519L19.3503 3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646.7368-3.3503 1.9712l-3.0796 5.5435 1.7485.9707 3.0796-5.543c.3276-.5898.9265-.9424 1.6018-.9424s1.2742.3525 1.6018.9424l5.0925 9.167-3.4939-1.0298-.5664 1.9121 6.78 2.0083 2.0083-6.7798-1.9124-.5664z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jit.propTypes = E);
const $it = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lue || (lue = /* @__PURE__ */ h.createElement("path", {
    d: "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($it.propTypes = E);
const ert = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cue || (cue = /* @__PURE__ */ h.createElement("path", {
    d: "M14 12a3.8978 3.8978 0 01-4-3.777 3.9017 3.9017 0 01.6533-2.0639L13.17 2.4141a1.0381 1.0381 0 011.6592 0L17.3154 6.11A3.9693 3.9693 0 0118 8.223 3.8978 3.8978 0 0114 12zm.0005-7.2368L12.3438 7.2257A1.89 1.89 0 0012 8.223 1.9 1.9 0 0014 10a1.9 1.9 0 002-1.777 1.98 1.98 0 00-.375-1.0466zM7.5 26A5.385 5.385 0 012 20.751 5.3837 5.3837 0 012.874 17.92L6.49 12.5383a1.2168 1.2168 0 012.02-.0006l3.55 5.2777A5.4923 5.4923 0 0113 20.751 5.385 5.385 0 017.5 26zm0-11.38L4.5649 18.9868A3.3586 3.3586 0 004 20.751 3.3855 3.3855 0 007.5 24 3.3855 3.3855 0 0011 20.751a3.4354 3.4354 0 00-.63-1.867zM25 2L20 7l1.4141 1.4141L24 5.8281V16a4.0045 4.0045 0 01-4 4H16v2h4a6.0066 6.0066 0 006-6V5.8281l2.5859 2.586L30 7zM2 28H30V30H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ert.propTypes = E);
const trt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hue || (hue = /* @__PURE__ */ h.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "1"
  })), due || (due = /* @__PURE__ */ h.createElement("path", {
    d: "m28,20c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-5c0-1.1025-.8972-2-2-2h-5v-1c0-1.1025-.8972-2-2-2h-4c-1.1028,0-2,.8975-2,2v1h-5c-1.1028,0-2,.8975-2,2v5.1421c-1.7202.4473-3,1.9995-3,3.8579s1.2798,3.4106,3,3.8579v5.1421c0,1.1025.8972,2,2,2h7v1c0,1.1025.8972,2,2,2h12c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-2h1Zm0-2h-4v-4h4v4ZM14,4h4v4h-4v-4Zm-2,3v1c0,1.1025.8972,2,2,2h4c1.1028,0,2-.8975,2-2v-1h5v5h-1c-1.1028,0-2,.8975-2,2v1h-12.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-5.1421h5Zm-8,9c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Zm24,12h-12v-4h12v4Zm-3-6h-9c-1.1028,0-2,.8975-2,2v1h-7v-5.1421c1.3987-.3638,2.4941-1.459,2.8579-2.8579h12.1421v1c0,1.1025.8972,2,2,2h1v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (trt.propTypes = E);
const nrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, uue || (uue = /* @__PURE__ */ h.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), fue || (fue = /* @__PURE__ */ h.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-180 16 16)"
  })), pue || (pue = /* @__PURE__ */ h.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nrt.propTypes = E);
const irt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gue || (gue = /* @__PURE__ */ h.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), mue || (mue = /* @__PURE__ */ h.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), Aue || (Aue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (irt.propTypes = E);
const rrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wue || (wue = /* @__PURE__ */ h.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), vue || (vue = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rrt.propTypes = E);
const srt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bue || (bue = /* @__PURE__ */ h.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), yue || (yue = /* @__PURE__ */ h.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (srt.propTypes = E);
const ort = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cue || (Cue = /* @__PURE__ */ h.createElement("path", {
    d: "M28 25H20a2.0027 2.0027 0 01-2-2V20h2v3h8V9H20v3H18V9a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2V23A2.0027 2.0027 0 0128 25zM8 15H12V17H8z"
  })), Eue || (Eue = /* @__PURE__ */ h.createElement("path", {
    d: "M20 15H24V17H20zM14 15H18V17H14zM12 25H4a2.0023 2.0023 0 01-2-2V9A2.002 2.002 0 014 7h8a2.002 2.002 0 012 2v3H12V9H4V23h8V20h2v3A2.0023 2.0023 0 0112 25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ort.propTypes = E);
const art = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _ue || (_ue = /* @__PURE__ */ h.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), xue || (xue = /* @__PURE__ */ h.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (art.propTypes = E);
const lrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sue || (Sue = /* @__PURE__ */ h.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), Mue || (Mue = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lrt.propTypes = E);
const uw = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Due || (Due = /* @__PURE__ */ h.createElement("path", {
    d: "M12 10H6.78A11 11 0 0127 16h2A13 13 0 006 7.68V4H4v8h8zM20 22h5.22A11 11 0 015 16H3a13 13 0 0023 8.32V28h2V20H20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uw.propTypes = E);
const crt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Lue || (Lue = /* @__PURE__ */ h.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (crt.propTypes = E);
const hrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kue || (kue = /* @__PURE__ */ h.createElement("path", {
    d: "M6 6H26.1719l-3.586-3.5859L24 1l6 6-6 6-1.4141-1.4141L26.1719 8H6v7H4V8A2.0024 2.0024 0 016 6zM9.4141 20.4141L5.8281 24H26V17h2v7a2.0024 2.0024 0 01-2 2H5.8281L9.414 29.5859 8 31 2 25l6-6z"
  })), Nue || (Nue = /* @__PURE__ */ h.createElement("path", {
    d: "M17 19L17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hrt.propTypes = E);
const drt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tue || (Tue = /* @__PURE__ */ h.createElement("path", {
    d: "M28 8h2V4a2.0021 2.0021 0 00-2-2H24V4h4zM17 2H21V4H17zM28 11H30V15H28zM28 18v4H24V10a2.0023 2.0023 0 00-2-2H10V4h4V2H10A2.0023 2.0023 0 008 4V8H4a2.0023 2.0023 0 00-2 2V28a2.0023 2.0023 0 002 2H22a2.0023 2.0023 0 002-2V24h4a2.0023 2.0023 0 002-2V18zM22 28H4V10H22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (drt.propTypes = E);
const urt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Iue || (Iue = /* @__PURE__ */ h.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (urt.propTypes = E);
const frt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Oue || (Oue = /* @__PURE__ */ h.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), Rue || (Rue = /* @__PURE__ */ h.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (frt.propTypes = E);
const prt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vue || (Vue = /* @__PURE__ */ h.createElement("path", {
    d: "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
  })), Hue || (Hue = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5 C30,8.9,29.1,8,28,8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (prt.propTypes = E);
const grt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bue || (Bue = /* @__PURE__ */ h.createElement("path", {
    d: "M23.6 21.4L27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20zM20.4 21.4L16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
  })), Pue || (Pue = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (grt.propTypes = E);
const mrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fue || (Fue = /* @__PURE__ */ h.createElement("path", {
    d: "M10 18H18V20H10zM10 13H22V15H10zM10 23H15V25H10z"
  })), zue || (zue = /* @__PURE__ */ h.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mrt.propTypes = E);
const Art = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wue || (Wue = /* @__PURE__ */ h.createElement("path", {
    d: "M15 20H17V24H15zM20 18H22V24H20zM10 14H12V24H10z"
  })), jue || (jue = /* @__PURE__ */ h.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Art.propTypes = E);
const wrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zue || (Zue = /* @__PURE__ */ h.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), Uue || (Uue = /* @__PURE__ */ h.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wrt.propTypes = E);
const vrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, que || (que = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.1788 17.4959c0-2.8367 1.5301-4.6764 4.1606-4.6764 2.8025 0 4.0919 2.0631 4.0919 4.5217v.7221h-5.9658v.2235c0 1.2894.7392 2.1663 2.1834 2.1663 1.0833 0 1.7365-.5158 2.2867-1.2207l1.1863 1.3239c-.7392 1.0143-2.0459 1.6505-3.7137 1.6505-2.6475 0-4.2293-1.8397-4.2293-4.7109zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152 0-1.9083.8597-1.9083 2.0975zM9.2694 22h-2.2693v-12h5.4154c2.1835 0 3.5416 1.4441 3.5416 3.7135 0 1.6504-.7565 2.9054-2.2349 3.4039l2.4584 4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247zm3.1215-6.533c.8769 0 1.4097-.4813 1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227z"
  })), Gue || (Gue = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vrt.propTypes = E);
const brt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Que || (Que = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.1788 17.4959c0-2.8367 1.5301-4.6764 4.1606-4.6764 2.8025 0 4.0919 2.0631 4.0919 4.5217v.7221h-5.9658v.2235c0 1.2894.7392 2.1663 2.1834 2.1663 1.0833 0 1.7365-.5158 2.2867-1.2207l1.1863 1.3239c-.7392 1.0143-2.0459 1.6505-3.7137 1.6505-2.6475 0-4.2293-1.8397-4.2293-4.7109zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152 0-1.9083.8597-1.9083 2.0975zM9.2694 22h-2.2693v-12h5.4154c2.1835 0 3.5416 1.4441 3.5416 3.7135 0 1.6504-.7565 2.9054-2.2349 3.4039l2.4584 4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247zm3.1215-6.533c.8769 0 1.4097-.4813 1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227z"
  })), Kue || (Kue = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (brt.propTypes = E);
const yrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yue || (Yue = /* @__PURE__ */ h.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yrt.propTypes = E);
const Crt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xue || (Xue = /* @__PURE__ */ h.createElement("path", {
    d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Crt.propTypes = E);
const Ert = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Jue || (Jue = /* @__PURE__ */ h.createElement("path", {
    d: "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6 s6-2.7,6-6H13z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $ue || ($ue = /* @__PURE__ */ h.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ert.propTypes = E);
const _rt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, e1e || (e1e = /* @__PURE__ */ h.createElement("path", {
    d: "M9 2H11V12H9z"
  })), t1e || (t1e = /* @__PURE__ */ h.createElement("path", {
    d: "M14 11a4 4 0 01-8 0V2H4v9a6 6 0 005 5.91V30h2V16.91A6 6 0 0016 11V2H14zM22 2H21V30h2V20h3a2 2 0 002-2V8A5.78 5.78 0 0022 2zm4 16H23V4.09c2.88.56 3 3.54 3 3.91z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_rt.propTypes = E);
const xrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n1e || (n1e = /* @__PURE__ */ h.createElement("path", {
    d: "M30 11.0005v-8a1 1 0 00-1-1H19a1 1 0 00-1 1v8A6.0039 6.0039 0 0023 16.91V28H19v2H29V28H25V16.91A6.0039 6.0039 0 0030 11.0005zm-10 0V4h8v7.0005a4 4 0 11-8 0zM12 2v9.02a3.9644 3.9644 0 01-3.96 3.96A4.0052 4.0052 0 014 11.02V2H2v9.02a5.9888 5.9888 0 005 5.8652V30H9V16.8953A5.9646 5.9646 0 0014 11.02V2z"
  })), i1e || (i1e = /* @__PURE__ */ h.createElement("path", {
    d: "M7 2H9V11.98H7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xrt.propTypes = E);
const Srt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, r1e || (r1e = /* @__PURE__ */ h.createElement("path", {
    d: "M14 23H22V25H14zM10 23H12V25H10zM14 18H22V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
  })), s1e || (s1e = /* @__PURE__ */ h.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Srt.propTypes = E);
const Mrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o1e || (o1e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.7 19.3l-3-3c-.4-.4-1-.4-1.4 0L16 25.6V30h4.4l9.3-9.3C30.1 20.3 30.1 19.7 29.7 19.3zM19.6 28H18v-1.6l5-5 1.6 1.6L19.6 28zM26 21.6L24.4 20l1.6-1.6 1.6 1.6L26 21.6zM10 23H12V25H10zM14 18H18V20H14zM10 18H12V20H10zM14 13H22V15H14zM10 13H12V15H10z"
  })), a1e || (a1e = /* @__PURE__ */ h.createElement("path", {
    d: "M7,28V7h3v3h12V7h3v6h2V7c0-1.1-0.9-2-2-2h-3V4c0-1.1-0.9-2-2-2h-8c-1.1,0-2,0.9-2,2v1H7C5.9,5,5,5.9,5,7v21 c0,1.1,0.9,2,2,2h5v-2H7z M12,4h8v4h-8V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mrt.propTypes = E);
const Drt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, l1e || (l1e = /* @__PURE__ */ h.createElement("circle", {
    cx: "26",
    cy: "26",
    r: "4"
  })), c1e || (c1e = /* @__PURE__ */ h.createElement("path", {
    d: "M10 13H12V15H10zM10 18H12V20H10zM10 23H12V25H10zM14 13H22V15H14zM14 18H22V20H14zM14 23H18V25H14z"
  })), h1e || (h1e = /* @__PURE__ */ h.createElement("path", {
    d: "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Drt.propTypes = E);
const Lrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, d1e || (d1e = /* @__PURE__ */ h.createElement("path", {
    d: "M10 13H12V15H10zM14 13H22V15H14zM10 18H12V20H10zM10 23H12V25H10z"
  })), u1e || (u1e = /* @__PURE__ */ h.createElement("path", {
    d: "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
  })), f1e || (f1e = /* @__PURE__ */ h.createElement("path", {
    d: "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lrt.propTypes = E);
const krt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, p1e || (p1e = /* @__PURE__ */ h.createElement("path", {
    d: "M26.41 25L30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25zM18 2A12.0351 12.0351 0 006 14v6.2L2.4 16.6 1 18l6 6 6-6-1.4-1.4L8 20.2V14a10 10 0 0120 0v3h2V14A12.0351 12.0351 0 0018 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (krt.propTypes = E);
const Nrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, g1e || (g1e = /* @__PURE__ */ h.createElement("path", {
    d: "m22,8v2c2.2061,0,4,1.7944,4,4s-1.7939,4-4,4h-12v-5l-6,6,6,6v-5h12c3.3086,0,6-2.6914,6-6s-2.6914-6-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nrt.propTypes = E);
const Trt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, m1e || (m1e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 8L17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
  })), A1e || (A1e = /* @__PURE__ */ h.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Trt.propTypes = E);
const Irt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, w1e || (w1e = /* @__PURE__ */ h.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), v1e || (v1e = /* @__PURE__ */ h.createElement("path", {
    d: "M19.63 22.13a2.84 2.84 0 01-1.28-.27 2.44 2.44 0 01-.89-.77 3.57 3.57 0 01-.52-1.25 7.69 7.69 0 01-.17-1.68 7.83 7.83 0 01.17-1.68 3.65 3.65 0 01.52-1.25 2.44 2.44 0 01.89-.77 2.84 2.84 0 011.28-.27 2.44 2.44 0 012.16 1 5.23 5.23 0 01.7 2.93 5.23 5.23 0 01-.7 2.93A2.44 2.44 0 0119.63 22.13zm0-1.22a1.07 1.07 0 001-.55A3.38 3.38 0 0021 18.85V17.47a3.31 3.31 0 00-.29-1.5 1.23 1.23 0 00-2.06 0 3.31 3.31 0 00-.29 1.5v1.38a3.38 3.38 0 00.29 1.51A1.06 1.06 0 0019.63 20.91zM10.63 22V20.82h2V15.63l-1.86 1-.55-1.06 2.32-1.3H14v6.5h1.78V22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Irt.propTypes = E);
const Ort = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, b1e || (b1e = /* @__PURE__ */ h.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), y1e || (y1e = /* @__PURE__ */ h.createElement("path", {
    d: "M19.64 22.13a2.81 2.81 0 01-1.28-.27 2.36 2.36 0 01-.89-.77A3.39 3.39 0 0117 19.84a7.12 7.12 0 01-.17-1.68A7.24 7.24 0 0117 16.48a3.46 3.46 0 01.52-1.25 2.36 2.36 0 01.89-.77 2.81 2.81 0 011.28-.27 2.44 2.44 0 012.16 1 5.31 5.31 0 01.7 2.93 5.31 5.31 0 01-.7 2.93A2.44 2.44 0 0119.64 22.13zm0-1.22a1 1 0 001-.55 3.24 3.24 0 00.3-1.51V17.47a3.17 3.17 0 00-.3-1.5 1.22 1.22 0 00-2.05 0 3.18 3.18 0 00-.29 1.5v1.38a3.25 3.25 0 00.29 1.51A1 1 0 0019.64 20.91zM12.62 17.42a1.46 1.46 0 001-.27.84.84 0 00.31-.68v-.08a.94.94 0 00-.3-.74 1.2 1.2 0 00-.83-.27 1.65 1.65 0 00-.89.24 2.1 2.1 0 00-.68.68l-.93-.83a5.37 5.37 0 01.44-.51 2.7 2.7 0 01.54-.4 2.55 2.55 0 01.7-.27 3.25 3.25 0 01.87-.1 3.94 3.94 0 011.06.14 2.33 2.33 0 01.82.4 1.91 1.91 0 01.54.63 1.87 1.87 0 01.18.83 2 2 0 01-.11.67 1.82 1.82 0 01-.32.52 1.79 1.79 0 01-.47.36 2.27 2.27 0 01-.57.2V18a2.34 2.34 0 01.63.21 1.7 1.7 0 01.51.38 1.89 1.89 0 01.34.55 2.07 2.07 0 01.12.73 2 2 0 01-.2.92 2 2 0 01-.58.72 2.66 2.66 0 01-.89.45 3.76 3.76 0 01-1.15.16 4.1 4.1 0 01-1-.11A3.1 3.1 0 0111 21.7a2.76 2.76 0 01-.56-.45A4.22 4.22 0 0110 20.7l1.07-.81a3.07 3.07 0 00.28.42 1.94 1.94 0 00.36.34 1.57 1.57 0 00.45.22 2 2 0 00.57.07 1.45 1.45 0 001-.3 1.12 1.12 0 00.34-.85v-.08a1 1 0 00-.37-.8 1.78 1.78 0 00-1.06-.28h-.76V17.42z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ort.propTypes = E);
const Rrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, C1e || (C1e = /* @__PURE__ */ h.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), E1e || (E1e = /* @__PURE__ */ h.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rrt.propTypes = E);
const Vrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _1e || (_1e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vrt.propTypes = E);
const Hrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, x1e || (x1e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hrt.propTypes = E);
const Brt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, S1e || (S1e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Brt.propTypes = E);
const Prt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, M1e || (M1e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Prt.propTypes = E);
const Frt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D1e || (D1e = /* @__PURE__ */ h.createElement("path", {
    d: "M13 13H19V15H13z"
  })), L1e || (L1e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.4409 8L24.1687 3.45A2.009 2.009 0 0022.2456 2H9.7544A2.0089 2.0089 0 007.8313 3.4507L6.5315 8H4v2H6v7a2.0025 2.0025 0 002 2v3h2V19H22v3h2V19a2.0025 2.0025 0 002-2V10h2V8zM9.7544 4H22.2458l1.4285 5H8.3257zM24 13H22v2h2v2H8V15h2V13H8V11H24zM2 16H4V30H2zM28 16H30V30H28z"
  })), k1e || (k1e = /* @__PURE__ */ h.createElement("path", {
    d: "M15 21H17V24H15zM15 26H17V30H15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Frt.propTypes = E);
const zrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, N1e || (N1e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 31H14v-.228a3.0135 3.0135 0 00-1.9468-2.8091L8.5215 26.6384A3.9034 3.9034 0 016 23H8a1.8946 1.8946 0 001.2236 1.7659L12.7554 26.09A5.0226 5.0226 0 0116 30.772zM30 31H28v-.228a3.0135 3.0135 0 00-1.9468-2.8091l-3.5317-1.3245A3.9034 3.9034 0 0120 23h2a1.8946 1.8946 0 001.2236 1.7659L26.7554 26.09A5.0226 5.0226 0 0130 30.772zM11 13H17V15H11z"
  })), T1e || (T1e = /* @__PURE__ */ h.createElement("path", {
    d: "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zrt.propTypes = E);
const Wrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, I1e || (I1e = /* @__PURE__ */ h.createElement("path", {
    d: "M12 30H4a2.0023 2.0023 0 01-2-2V24a2.0023 2.0023 0 012-2h8a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0112 30zM4 24v4h8V24zM28 20H12a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2v4A2.0023 2.0023 0 0128 20zM12 14v4H28V14zM16 10H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H16a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0116 10zM4 4V8H16V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wrt.propTypes = E);
const jrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, O1e || (O1e = /* @__PURE__ */ h.createElement("path", {
    d: "M6.34 19H17.65V21H6.34z",
    transform: "rotate(-45 11.995 20.002)"
  })), R1e || (R1e = /* @__PURE__ */ h.createElement("path", {
    d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jrt.propTypes = E);
const Zrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, V1e || (V1e = /* @__PURE__ */ h.createElement("path", {
    d: "M17.91 26.82l.35 2a12.9 12.9 0 004.24-1.54l-1-1.73A10.88 10.88 0 0117.91 26.82zM24.42 23.07L26 24.35a13 13 0 002.24-3.91l-1.87-.68A11 11 0 0124.42 23.07zM9.5 27.25a12.9 12.9 0 004.24 1.54l.35-2a10.88 10.88 0 01-3.59-1.3zM5.67 19.76l-1.87.68A13 13 0 006 24.35l.32-.26 1.22-1h0a11 11 0 01-1.91-3.31zM29 16a12.85 12.85 0 00-.8-4.44l-1.87.68A11.18 11.18 0 0127 16zM26 7.65a13 13 0 00-20 0V4H4v8h8V10H6.81A11 11 0 0124.42 8.93z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zrt.propTypes = E);
const Urt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, H1e || (H1e = /* @__PURE__ */ h.createElement("path", {
    d: "M14.0913 26.8235l-.3467 1.968a12.8956 12.8956 0 01-4.24-1.5418l1-1.7307A10.9086 10.9086 0 0014.0913 26.8235zM7.5767 23.0682L6.0449 24.3533a12.9811 12.9811 0 01-2.25-3.9112l1.8775-.6834A10.9808 10.9808 0 007.5767 23.0682zM22.4951 27.25a12.8956 12.8956 0 01-4.24 1.5418l-.3467-1.968a10.9086 10.9086 0 003.5869-1.3045zM26.3271 19.7587l1.8775.6834a12.9811 12.9811 0 01-2.2495 3.9112l-.3115-.2614-1.22-1.0237h0a10.9822 10.9822 0 001.9038-3.3093zM13.6616 5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438 10.9438 0 005 16H3A12.9363 12.9363 0 016.05 7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331 12.9331 0 0126 7.7031V4h2v8H20V10h5.1885A10.961 10.961 0 0016 5a11.1114 11.1114 0 00-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575 5.165 13.907 5.2026 13.6616 5.2559z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Urt.propTypes = E);
const qrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, B1e || (B1e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qrt.propTypes = E);
const Grt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, P1e || (P1e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM16 16V28H28.0012L28 16zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Grt.propTypes = E);
const Qrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, F1e || (F1e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM4 16V28H16.0012L16 16zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qrt.propTypes = E);
const Krt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, z1e || (z1e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 30H4a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0116 30zM30 15l-1.41-1.41L26 16.17V11a7.0078 7.0078 0 00-7-7H14V6h5a5.0057 5.0057 0 015 5v5.17l-2.59-2.58L20 15l5 5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Krt.propTypes = E);
const Yrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, W1e || (W1e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 30H16a2.0023 2.0023 0 01-2-2V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM15 2L13.59 3.41 16.17 6H11a7.0078 7.0078 0 00-7 7v5H6V13a5.0057 5.0057 0 015-5h5.17l-2.58 2.59L15 12l5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yrt.propTypes = E);
const Xrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, j1e || (j1e = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM4 16L3.9988 28H16V16zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xrt.propTypes = E);
const Jrt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Z1e || (Z1e = /* @__PURE__ */ h.createElement("path", {
    d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zm2-12l-.0012 12H28V16zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jrt.propTypes = E);
const $rt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, U1e || (U1e = /* @__PURE__ */ h.createElement("path", {
    d: "M14 28V16a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H16A2.0023 2.0023 0 0114 28zM2 15l1.41-1.41L6 16.17V11a7.0078 7.0078 0 017-7h5V6H13a5.0057 5.0057 0 00-5 5v5.17l2.59-2.58L12 15 7 20z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($rt.propTypes = E);
const est = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, q1e || (q1e = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28V16a2.0023 2.0023 0 012-2H16a2.0023 2.0023 0 012 2V28a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 28zM17 2l1.41 1.41L15.83 6H21a7.0078 7.0078 0 017 7v5H26V13a5.0057 5.0057 0 00-5-5H15.83l2.58 2.59L17 12 12 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (est.propTypes = E);
const tst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, G1e || (G1e = /* @__PURE__ */ h.createElement("path", {
    d: "M21 7L16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tst.propTypes = E);
const nst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Q1e || (Q1e = /* @__PURE__ */ h.createElement("path", {
    d: "M21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11zM12.4289 5.8227v1.63a1.1269 1.1269 0 01-.6767 1.026l-1.39.5967A1.1218 1.1218 0 019.14 8.8424L7.3208 7.0233a1.1165 1.1165 0 01.0125-1.579l.0348-.0328c7.393-6.527 14.6913-2.0374 17.2127-.0473a1.1166 1.1166 0 01.1746 1.5693 1.1011 1.1011 0 01-.0873.0971L22.9108 8.7878a1.1114 1.1114 0 01-1.2225.2329l-1.39-.5967a1.1112 1.1112 0 01-.68-1.0223v-1.63S15.9726 3.0648 12.4289 5.8227z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nst.propTypes = E);
const ist = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, K1e || (K1e = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "13.5",
    r: "1.5"
  })), Y1e || (Y1e = /* @__PURE__ */ h.createElement("path", {
    d: "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
  })), X1e || (X1e = /* @__PURE__ */ h.createElement("path", {
    d: "M23.0713 6.929a10 10 0 00-14.1426 0L7.5146 5.5144a12.0011 12.0011 0 0116.9708 0zM21 25L16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25zM24 11L19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11zM8 11L13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ist.propTypes = E);
const rst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, J1e || (J1e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 24H28V26H4zM26 18H6V14H26v4m2 0V14a2 2 0 00-2-2H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2zM4 6H28V8H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rst.propTypes = E);
const sst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $1e || ($1e = /* @__PURE__ */ h.createElement("path", {
    d: "M26 20H6a2 2 0 00-2 2v4a2 2 0 002 2H26a2 2 0 002-2V22A2 2 0 0026 20zm0 6H6V22H26zM17 7.828L19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sst.propTypes = E);
const ost = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, e0e || (e0e = /* @__PURE__ */ h.createElement("path", {
    d: "M24 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H24a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0124 30zM4 22H3.9985L4 28H24V22zM30 3.41L28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), t0e || (t0e = /* @__PURE__ */ h.createElement("path", {
    d: "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ost.propTypes = E);
const ast = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n0e || (n0e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 18L15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18zM26 4H6A2 2 0 004 6v4a2 2 0 002 2H26a2 2 0 002-2V6A2 2 0 0026 4zm0 6H6V6H26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ast.propTypes = E);
const lst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, i0e || (i0e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 12H10a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 12zM10 4v6H28V4zM28 30H10a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM10 22v6H28V22zM9 16L3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lst.propTypes = E);
const cst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, r0e || (r0e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
  })), s0e || (s0e = /* @__PURE__ */ h.createElement("path", {
    d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cst.propTypes = E);
const hst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o0e || (o0e = /* @__PURE__ */ h.createElement("path", {
    d: "M10 16H22V18H10zM10 10H22V12H10z"
  })), a0e || (a0e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hst.propTypes = E);
const dst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, l0e || (l0e = /* @__PURE__ */ h.createElement("path", {
    d: "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
  })), c0e || (c0e = /* @__PURE__ */ h.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dst.propTypes = E);
const ust = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, h0e || (h0e = /* @__PURE__ */ h.createElement("switch", null, /* @__PURE__ */ h.createElement("g", null, /* @__PURE__ */ h.createElement("path", {
    d: "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
  }), /* @__PURE__ */ h.createElement("path", {
    d: "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
  })))), n);
});
process.env.NODE_ENV !== "production" && (ust.propTypes = E);
const fst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, d0e || (d0e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
  })), u0e || (u0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fst.propTypes = E);
const pst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, f0e || (f0e = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M9 16H23V18H9z",
    "data-icon-path": "inner-path"
  })), p0e || (p0e = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M9 10H23V12H9z"
  })), g0e || (g0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pst.propTypes = E);
const gst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, m0e || (m0e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 22v-3c0-2.2-1.8-4-4-4s-4 1.8-4 4v3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-5C30 22.9 29.1 22 28 22zM22 19c0-1.1.9-2 2-2s2 .9 2 2v3h-4V19zM20 29v-5h8v5H20zM8 16H14V18H8zM8 10H20V12H8z"
  })), A0e || (A0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v8h2V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gst.propTypes = E);
const mst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, w0e || (w0e = /* @__PURE__ */ h.createElement("path", {
    d: "M23 16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7S26.9 16 23 16zM23 28V18c2.8 0 5 2.2 5 5S25.8 28 23 28zM8 16H14V18H8zM8 10H20V12H8z"
  })), v0e || (v0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v9h2V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mst.propTypes = E);
const Ast = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, b0e || (b0e = /* @__PURE__ */ h.createElement("path", {
    d: "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
  })), y0e || (y0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
  })), C0e || (C0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ast.propTypes = E);
const wst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, E0e || (E0e = /* @__PURE__ */ h.createElement("path", {
    d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wst.propTypes = E);
const vst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _0e || (_0e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vst.propTypes = E);
const bst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, x0e || (x0e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
  })), S0e || (S0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
  })), M0e || (M0e = /* @__PURE__ */ h.createElement("path", {
    d: "M19 19L19 25 24 22 19 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bst.propTypes = E);
const yst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D0e || (D0e = /* @__PURE__ */ h.createElement("path", {
    d: "M9 19L9 25 14 22z"
  })), L0e || (L0e = /* @__PURE__ */ h.createElement("path", {
    d: "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14 L11,14z"
  })), k0e || (k0e = /* @__PURE__ */ h.createElement("path", {
    d: "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yst.propTypes = E);
const Cst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, N0e || (N0e = /* @__PURE__ */ h.createElement("path", {
    d: "m21.707,20.293l-5-5c-.1951-.1953-.451-.293-.707-.293s-.512.0977-.707.293L2,28.5859l1.4143,1.4141,12.5857-12.5859,3.5857,3.5859-5.5857,5.5859,1.4143,1.4141,2.292-2.292,4.0007-4.001c.1953-.1953.293-.4512.293-.707s-.0977-.5117-.293-.707Z"
  })), T0e || (T0e = /* @__PURE__ */ h.createElement("path", {
    d: "m28.5859,9l-5.5859,5.5859-6.0012-6.0015c-.392-.3918-.9073-.5865-1.422-.5845-.5096.002-1.0185.1968-1.4063.5845l-6.1704,6.1753,1.4143,1.4141,6.1704-6.1748,6.7083,6.708c.1951.1953.4512.293.707.293s.512-.0977.707-.293l6.293-6.293-1.4141-1.4141Z"
  })), I0e || (I0e = /* @__PURE__ */ h.createElement("path", {
    d: "m22.5,9c-1.9299,0-3.5-1.5701-3.5-3.5s1.5701-3.5,3.5-3.5,3.5,1.5701,3.5,3.5-1.5701,3.5-3.5,3.5Zm0-5c-.8271,0-1.5.6729-1.5,1.5s.6729,1.5,1.5,1.5,1.5-.6729,1.5-1.5-.6729-1.5-1.5-1.5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cst.propTypes = E);
const Est = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, O0e || (O0e = /* @__PURE__ */ h.createElement("path", {
    d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Est.propTypes = E);
const _st = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, R0e || (R0e = /* @__PURE__ */ h.createElement("path", {
    d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_st.propTypes = E);
const xst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, V0e || (V0e = /* @__PURE__ */ h.createElement("path", {
    d: "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xst.propTypes = E);
const Sst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, H0e || (H0e = /* @__PURE__ */ h.createElement("path", {
    d: "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
  })), B0e || (B0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sst.propTypes = E);
const Mst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, P0e || (P0e = /* @__PURE__ */ h.createElement("path", {
    d: "M30 6v-2h-3v-2h-2v2h-1c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h4v2h-6v2h3v2h2v-2h1c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-4v-2h6zM24 20v2h2.5859l-3.5857 3.5859-2.2917-2.293c-.1875-.1875-.4419-.293-.707-.293h-.0015c-.2651 0-.5183.1055-.7058.293l-5.2942 5.293 1.4143 1.4141 4.5867-4.5859 2.2917 2.293c.1875.1875.4419.293.7073.293.2651 0 .5195-.1055.707-.293l4.293-4.293v2.5859h2v-6h-6zM4 30h-2v-5c0-3.8599 3.1401-7 7-7h6c1.9885 0 3.8901.8502 5.217 2.3328l-1.4902 1.334c-.948-1.0592-2.3064-1.6667-3.7268-1.6667h-6c-2.7571 0-5 2.243-5 5v5zM12 16c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm0-12c2.7615 0 5 2.2385 5 5s-2.2385 5-5 5-5-2.2385-5-5c.0032-2.7601 2.2399-4.9968 5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mst.propTypes = E);
const Dst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, F0e || (F0e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dst.propTypes = E);
const Lst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, z0e || (z0e = /* @__PURE__ */ h.createElement("path", {
    d: "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lst.propTypes = E);
const kst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, W0e || (W0e = /* @__PURE__ */ h.createElement("path", {
    d: "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kst.propTypes = E);
const Nst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, j0e || (j0e = /* @__PURE__ */ h.createElement("path", {
    d: "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
  })), Z0e || (Z0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nst.propTypes = E);
const Tst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, U0e || (U0e = /* @__PURE__ */ h.createElement("path", {
    d: "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tst.propTypes = E);
const Ist = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, q0e || (q0e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.3945 19.5537c0-1.8433 1.3953-2.7563 3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337 0-1.6194.5168-2.05 1.137l-1.3093-1.1714c.6545-1.0337 1.7056-1.7228 3.5144-1.7228 2.429 0 3.7209 1.1543 3.7209 3.2042v4.2379h.896v1.7572h-1.2231c-.9475 0-1.5332-.6201-1.6711-1.5504h-.1033c-.293 1.1542-1.2749 1.7572-2.6187 1.7572-1.8259 0-2.8596-1.0509-2.8596-2.6531zm5.3624-.2412v-1.1886h-1.4126c-1.1541 0-1.7227.3962-1.7227 1.1025v.2928c0 .7235.4995 1.0853 1.3608 1.0853.9819 0 1.7744-.4479 1.7744-1.2921zM6.6195 20.2084l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), G0e || (G0e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ist.propTypes = E);
const Ost = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Q0e || (Q0e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M17.3934 19.5537c0-1.8433 1.3953-2.7563 3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337 0-1.6194.5168-2.05 1.137l-1.3093-1.1714c.6545-1.0337 1.7056-1.7228 3.5144-1.7228 2.429 0 3.7209 1.1543 3.7209 3.2042v4.2379h.896v1.7572h-1.2231c-.9475 0-1.5332-.6201-1.6711-1.5504h-.1033c-.293 1.1542-1.2749 1.7572-2.6187 1.7572-1.8259 0-2.8596-1.0509-2.8596-2.6531zm5.3624-.2412v-1.1886h-1.4126c-1.1541 0-1.7227.3962-1.7227 1.1025v.2928c0 .7235.4995 1.0853 1.3608 1.0853.9819 0 1.7744-.4479 1.7744-1.2921zM6.6184 20.2084l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), K0e || (K0e = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ost.propTypes = E);
const Rst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Y0e || (Y0e = /* @__PURE__ */ h.createElement("path", {
    d: "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5 C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
  })), n) : i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, X0e || (X0e = /* @__PURE__ */ h.createElement("path", {
    d: "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1 C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3 c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4 L14,16.7L14,16.7z"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, J0e || (J0e = /* @__PURE__ */ h.createElement("path", {
    d: "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12 C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6 h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $0e || ($0e = /* @__PURE__ */ h.createElement("path", {
    d: "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rst.propTypes = E);
const Vst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, efe || (efe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), tfe || (tfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), nfe || (nfe = /* @__PURE__ */ h.createElement("path", {
    d: "M20 6H26V8H20zM22 10H26V12H22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vst.propTypes = E);
const Hst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ife || (ife = /* @__PURE__ */ h.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), rfe || (rfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hst.propTypes = E);
const Bst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sfe || (sfe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), ofe || (ofe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bst.propTypes = E);
const Pst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, afe || (afe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), lfe || (lfe = /* @__PURE__ */ h.createElement("path", {
    d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
  })), cfe || (cfe = /* @__PURE__ */ h.createElement("path", {
    d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pst.propTypes = E);
const Fst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hfe || (hfe = /* @__PURE__ */ h.createElement("path", {
    d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
  })), dfe || (dfe = /* @__PURE__ */ h.createElement("path", {
    d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fst.propTypes = E);
const zst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ufe || (ufe = /* @__PURE__ */ h.createElement("path", {
    d: "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zst.propTypes = E);
const Wst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ffe || (ffe = /* @__PURE__ */ h.createElement("path", {
    d: "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wst.propTypes = E);
const jst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pfe || (pfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jst.propTypes = E);
const Zst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gfe || (gfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zst.propTypes = E);
const Ust = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mfe || (mfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ust.propTypes = E);
const qst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Afe || (Afe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qst.propTypes = E);
const Gst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wfe || (wfe = /* @__PURE__ */ h.createElement("path", {
    d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
  })), vfe || (vfe = /* @__PURE__ */ h.createElement("path", {
    d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gst.propTypes = E);
const Qst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bfe || (bfe = /* @__PURE__ */ h.createElement("path", {
    d: "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qst.propTypes = E);
const Kst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yfe || (yfe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kst.propTypes = E);
const Yst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cfe || (Cfe = /* @__PURE__ */ h.createElement("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "2.5"
  })), Efe || (Efe = /* @__PURE__ */ h.createElement("circle", {
    cx: "9.5",
    cy: "22.5",
    r: "2.5"
  })), _fe || (_fe = /* @__PURE__ */ h.createElement("circle", {
    cx: "22.5",
    cy: "22.5",
    r: "2.5"
  })), xfe || (xfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yst.propTypes = E);
const Xst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Sfe || (Sfe = /* @__PURE__ */ h.createElement("path", {
    d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xst.propTypes = E);
const Jst = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mfe || (Mfe = /* @__PURE__ */ h.createElement("path", {
    d: "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2 C5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3 c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6 c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1 s0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,23,27,23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jst.propTypes = E);
const $st = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dfe || (Dfe = /* @__PURE__ */ h.createElement("path", {
    d: "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
  })), Lfe || (Lfe = /* @__PURE__ */ h.createElement("path", {
    d: "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
  })), kfe || (kfe = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($st.propTypes = E);
const eot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nfe || (Nfe = /* @__PURE__ */ h.createElement("path", {
    d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eot.propTypes = E);
const tot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tfe || (Tfe = /* @__PURE__ */ h.createElement("path", {
    d: "M15 19H17V28H15z"
  })), Ife || (Ife = /* @__PURE__ */ h.createElement("path", {
    d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tot.propTypes = E);
const not = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ofe || (Ofe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (not.propTypes = E);
const iot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rfe || (Rfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iot.propTypes = E);
const rot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vfe || (Vfe = /* @__PURE__ */ h.createElement("path", {
    d: "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
  })), Hfe || (Hfe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rot.propTypes = E);
const sot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bfe || (Bfe = /* @__PURE__ */ h.createElement("path", {
    d: "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
  })), Pfe || (Pfe = /* @__PURE__ */ h.createElement("path", {
    d: "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
  })), Ffe || (Ffe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sot.propTypes = E);
const oot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zfe || (zfe = /* @__PURE__ */ h.createElement("path", {
    d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), Wfe || (Wfe = /* @__PURE__ */ h.createElement("path", {
    d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oot.propTypes = E);
const aot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jfe || (jfe = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aot.propTypes = E);
const lot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zfe || (Zfe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lot.propTypes = E);
var Ufe, qfe, Gfe, Qfe, Kfe, Yfe, Xfe, Jfe, $fe, e2e, t2e, n2e, i2e, r2e, s2e, o2e, a2e, l2e, c2e, h2e, d2e, u2e, f2e, p2e, g2e, m2e, A2e, w2e, v2e, b2e, y2e, C2e, E2e, _2e, x2e, S2e, M2e, D2e, L2e, k2e, N2e, T2e, I2e, O2e, R2e, V2e, H2e, B2e, P2e, F2e, z2e, W2e, j2e, Z2e, U2e, q2e, G2e, Q2e, K2e, Y2e, X2e, J2e, $2e, epe, tpe, npe, ipe, rpe, spe, ope, ape, lpe, cpe, hpe, dpe, upe, fpe, ppe, gpe, mpe, Ape, wpe, vpe, bpe, ype, Cpe, Epe, _pe, xpe, Spe, Mpe, Dpe, Lpe, kpe, Npe, Tpe, Ipe, Ope, Rpe, Vpe, Hpe, Bpe, Ppe, Fpe, zpe, Wpe, jpe, Zpe, Upe, qpe, Gpe, Qpe, Kpe, Ype, Xpe, Jpe, $pe, ege, tge, nge, ige, rge, sge, oge, age, lge, cge, hge, dge, uge, fge, pge, gge, mge, Age, wge, vge, bge, yge, Cge, Ege, _ge, xge, Sge, Mge, Dge, Lge, kge, Nge, Tge, Ige, Oge, Rge, Vge, Hge, Bge, Pge, Fge, zge, Wge, jge, Zge, Uge, qge, Gge, Qge, Kge, Yge, Xge, Jge, $ge, eme, tme, nme, ime, rme, sme, ome, ame, lme, cme, hme, dme, ume, fme, pme, gme, mme, Ame, wme, vme, bme, yme, Cme, Eme, _me, xme, Sme, Mme, Dme, Lme, kme, Nme, Tme;
const cot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ufe || (Ufe = /* @__PURE__ */ h.createElement("path", {
    d: "M2 6H12V8H2zM5 12H12V14H5zM2 18H12V20H2zM5 24H12V26H5zM16 4H18V28H16zM28.15 23.5L29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cot.propTypes = E);
const hot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qfe || (qfe = /* @__PURE__ */ h.createElement("path", {
    d: "M20 6H30V8H20zM20 12H27V14H20zM20 18H30V20H20zM20 24H27V26H20zM14 4H16V28H14zM3.85 22.5L2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hot.propTypes = E);
const dot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gfe || (Gfe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 9L25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dot.propTypes = E);
const uot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qfe || (Qfe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 24L18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24zM14 21L20 4 18 4 12 21 14 21zM13 4L9 16 5 4 3 4 8 18 10 18 15 4 13 4zM28 18h2L25 4H23L18 18h2l1-3h6zm-6.33-5L24 6l2.33 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uot.propTypes = E);
const fot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kfe || (Kfe = /* @__PURE__ */ h.createElement("path", {
    d: "M14 13H30V15H14zM15 28H30V30H15zM25.85 27H28L23.64 17H21.36L17 27h2.15l.8-2h5.1zm-5.1-4l1.75-4.37L24.25 23zM25.85 12H28L23.64 2H21.36L17 12h2.15l.8-2h5.1zm-5.1-4L22.5 3.63 24.25 8zM6 15.83L8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83zM6 27.17L3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fot.propTypes = E);
const pot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yfe || (Yfe = /* @__PURE__ */ h.createElement("path", {
    d: "M17 6H30V8H17zM17 12H27V14H17zM17 18H30V20H17zM17 24H27V26H17zM11.59 13.41L8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41zM11.59 18.59L8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pot.propTypes = E);
const got = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Xfe || (Xfe = /* @__PURE__ */ h.createElement("path", {
    d: "M6 24H20V26H6zM6 18H26V20H6zM6 12H26V14H6zM6 6H26V8H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (got.propTypes = E);
const mot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jfe || (Jfe = /* @__PURE__ */ h.createElement("path", {
    d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mot.propTypes = E);
const Aot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $fe || ($fe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 5L30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
  })), e2e || (e2e = /* @__PURE__ */ h.createElement("path", {
    d: "M7 26L7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Aot.propTypes = E);
const wot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, t2e || (t2e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 27H21a3 3 0 01-3-3V22a3 3 0 013-3h5V17a1 1 0 00-1-1H19V14h6a3 3 0 013 3zm-7-6a1 1 0 00-1 1v2a1 1 0 001 1h5V21zM13 7h3V5H13a4 4 0 00-3 1.38A4 4 0 007 5H4V7H7A2 2 0 019 9v5H5v2H9v7a2 2 0 01-2 2H4v2H7a4 4 0 003-1.38A4 4 0 0013 27h3V25H13a2 2 0 01-2-2V16h4V14H11V9A2 2 0 0113 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wot.propTypes = E);
const vot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n2e || (n2e = /* @__PURE__ */ h.createElement("path", {
    d: "M6 18H20V20H6zM6 12H26V14H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vot.propTypes = E);
const bot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, i2e || (i2e = /* @__PURE__ */ h.createElement("path", {
    d: "M23 27L23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
  })), r2e || (r2e = /* @__PURE__ */ h.createElement("path", {
    d: "M11 27L11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bot.propTypes = E);
const yot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, s2e || (s2e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yot.propTypes = E);
const Cot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o2e || (o2e = /* @__PURE__ */ h.createElement("path", {
    d: "M26 25L20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25zM5 7L5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cot.propTypes = E);
const Eot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, a2e || (a2e = /* @__PURE__ */ h.createElement("path", {
    d: "M29 17L23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17zM4 7L4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eot.propTypes = E);
const _ot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, l2e || (l2e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.29 19.29L23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29zM26 17h2L23 3H21L16 17h2l1-3h6zm-6.33-5L22 5l2.33 7zM14 3L10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_ot.propTypes = E);
const xot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, c2e || (c2e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H28V28H4zM16 23a7 7 0 01-7-7V5h2V16a5 5 0 0010 0V5h2V16A7 7 0 0116 23z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xot.propTypes = E);
const Sot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, h2e || (h2e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 28H30V30H16zM16 23H30V25H16zM10.8458 30H13L8.64 20H6.36L2 30H4.1542l.8-2h5.0916zM5.7541 26L7.5 21.6347 9.2459 26zM2 15H30V17H2zM16 7H30V9H16zM16 2H30V4H16zM10.8458 12H13L8.64 2H6.36L2 12H4.1542l.8-2h5.0916zM5.7541 8L7.5 3.6347 9.2459 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sot.propTypes = E);
const Mot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, d2e || (d2e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 23H12V25H4zM24.5232 14H4v2H24.5a3.5 3.5 0 010 7H18.8281l2.586-2.5859L20 19l-5 5 5 5 1.4141-1.4141L18.8281 25H24.533a5.5 5.5 0 00-.01-11zM4 5H28V7H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mot.propTypes = E);
const Dot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, u2e || (u2e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.537 13.76L26.24 10.463a1.5862 1.5862 0 00-2.24 0L10 24.4674V30h5.5326L29.537 16a1.5862 1.5862 0 000-2.24zM14.7042 28H12V25.2958l9.4409-9.4409 2.7042 2.7042zM25.5591 17.145L22.855 14.4409l2.2672-2.2672 2.7042 2.7042zM11 17L13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
  })), f2e || (f2e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dot.propTypes = E);
const Lot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, p2e || (p2e = /* @__PURE__ */ h.createElement("path", {
    d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
  })), g2e || (g2e = /* @__PURE__ */ h.createElement("path", {
    d: "M10.2642 29.9971A5.2619 5.2619 0 016.542 21.0137l6.03-6.03a5.2636 5.2636 0 117.4438 7.4438l-1.414-1.414a3.2639 3.2639 0 10-4.6158-4.6158l-6.03 6.03a3.264 3.264 0 004.6157 4.6162l1.414 1.4141A5.2452 5.2452 0 0110.2642 29.9971zM2 10H10V12H2zM2 6H14V8H2zM2 2H14V4H2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lot.propTypes = E);
const kot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, m2e || (m2e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 10H16V12H8zM8 6H20V8H8zM8 2H20V4H8z"
  })), A2e || (A2e = /* @__PURE__ */ h.createElement("path", {
    d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kot.propTypes = E);
const Not = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, w2e || (w2e = /* @__PURE__ */ h.createElement("path", {
    d: "M18 28H26V30H18zM18 24H30V26H18zM18 20H30V22H18z"
  })), v2e || (v2e = /* @__PURE__ */ h.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Not.propTypes = E);
const Tot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, b2e || (b2e = /* @__PURE__ */ h.createElement("path", {
    d: "M16.001 26.473L16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), y2e || (y2e = /* @__PURE__ */ h.createElement("path", {
    d: "M20 19L27 24 20 29 20 19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tot.propTypes = E);
const Iot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, C2e || (C2e = /* @__PURE__ */ h.createElement("path", {
    d: "M20 25a6.9908 6.9908 0 01-5.833-3.1287l1.666-1.1074a5.0007 5.0007 0 008.334 0l1.666 1.1074A6.9908 6.9908 0 0120 25zM24 14a2 2 0 102 2A1.9806 1.9806 0 0024 14zM16 14a2 2 0 102 2A1.9806 1.9806 0 0016 14z"
  })), E2e || (E2e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iot.propTypes = E);
const Oot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _2e || (_2e = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H30V30H2zM7 5.828L7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828zM23 5.828L23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oot.propTypes = E);
const Rot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, x2e || (x2e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
  })), S2e || (S2e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 20H10V22H8zM12 20H14V22H12zM16 20H18V22H16zM20 20H22V22H20zM8 16H10V18H8zM16 16H18V18H16zM20 16H22V18H20zM20 12H22V14H20zM20 8H22V10H20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rot.propTypes = E);
const Vot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, M2e || (M2e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM28 20H4a2 2 0 01-2-2V4A2 2 0 014 2H28a2 2 0 012 2V18A2 2 0 0128 20zM4 4V18H28V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vot.propTypes = E);
const Hot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D2e || (D2e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 30H4a2 2 0 01-2-2V24a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 30zM4 24v4H8V24zM18 30H14a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 30zm-4-6v4h4V24zM28 30H24a2 2 0 01-2-2V24a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 30zm-4-6v4h4V24zM8 20H4a2 2 0 01-2-2V14a2 2 0 012-2H8a2 2 0 012 2v4A2 2 0 018 20zM4 14v4H8V14zM18 20H14a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0118 20zm-4-6v4h4V14zM28 20H24a2 2 0 01-2-2V14a2 2 0 012-2h4a2 2 0 012 2v4A2 2 0 0128 20zm-4-6v4h4V14zM8 10H4A2 2 0 012 8V4A2 2 0 014 2H8a2 2 0 012 2V8A2 2 0 018 10zM4 4V8H8V4zM18 10H14a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0118 10zM14 4V8h4V4zM28 10H24a2 2 0 01-2-2V4a2 2 0 012-2h4a2 2 0 012 2V8A2 2 0 0128 10zM24 4V8h4V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hot.propTypes = E);
const Bot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, L2e || (L2e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
  })), k2e || (k2e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 23a4 4 0 114-4A4.0042 4.0042 0 0116 23zm0-6a2 2 0 102 2A2.0023 2.0023 0 0016 17zM30 4V8a2.0027 2.0027 0 01-2 2H24a2.0027 2.0027 0 01-2-2V4a2.0027 2.0027 0 012-2h4A2.0027 2.0027 0 0130 4zM28 8l.002-4H24V8zM20 4V8a2.0027 2.0027 0 01-2 2H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h4A2.0027 2.0027 0 0120 4zM18 8l.002-4H14V8zM10 4V8a2.0023 2.0023 0 01-2 2H4A2.0023 2.0023 0 012 8V4A2.0023 2.0023 0 014 2H8A2.0023 2.0023 0 0110 4zM8 8l.0015-4H4V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bot.propTypes = E);
const Pot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, N2e || (N2e = /* @__PURE__ */ h.createElement("path", {
    d: "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pot.propTypes = E);
const Fot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, T2e || (T2e = /* @__PURE__ */ h.createElement("path", {
    d: "M2 2H7V16H2zM23 2H9V16.8027l3.0422 4.5635.8453 5.9165A2.0094 2.0094 0 0014.8672 29H15a3.0033 3.0033 0 003-3V20h8a4.0045 4.0045 0 004-4V9A7.0078 7.0078 0 0023 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fot.propTypes = E);
const zot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, I2e || (I2e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zot.propTypes = E);
const Wot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, O2e || (O2e = /* @__PURE__ */ h.createElement("path", {
    d: "M2 16H7V30H2zM23 30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094 2.0094 0 0114.8672 3H15a3.0033 3.0033 0 013 3v6h8a4.0045 4.0045 0 014 4v7A7.0078 7.0078 0 0123 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wot.propTypes = E);
const jot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, R2e || (R2e = /* @__PURE__ */ h.createElement("path", {
    d: "M20.8,14h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.4,0,.1,0,.3-.1.5l-.6,4.3-2,3.9H2v13h16.3c3.7,0,6.7-3,6.7-6.7v-5.1c0-2.4-1.9-4.3-4.2-4.3h0ZM4,28v-9h2v9h-2ZM23,23.3c0,2.6-2.1,4.7-4.7,4.7h-10.3v-9.8l2.4-4.5.6-4.5c0-.2.1-.4.1-.5,0-.2.1-.5.1-.6h.8c1,0,1,1.4,1,1.6v6.3h7.8c1.2,0,2.2,1,2.2,2.2v5.1h0ZM27,9h-6v-4.6c0-2-1.2-3.4-3-3.4h-.8c-1.8,0-2,1.9-2.1,2.6l-.2,2.4h2l.1-1,.1-1.2c0-.5.1-.7.1-.8h.8c.9,0,1,.9,1,1.4v6.6h8c1.2,0,2,.8,2,2v5c0,1.7-.9,3.4-2.1,4.2l1.1,1.7c1.8-1.2,2.9-3.5,2.9-5.9v-5c.1-2.4-1.5-4-3.9-4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jot.propTypes = E);
const Zot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, V2e || (V2e = /* @__PURE__ */ h.createElement("path", {
    d: "M20.8,14h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.4,0,.1,0,.3-.1.5l-.6,4.3-1.4,2.8v14h11.3c3.7,0,6.7-3,6.7-6.7v-5.1c0-2.3-1.9-4.2-4.2-4.2ZM2,30v-13h3v13h-3ZM26.8,9h-5.8v-4.4c0-2.1-1.2-3.6-3-3.6h-1c-1.5,0-1.8,1.5-1.9,2.3,0,.2,0,.3-.1.5l-.1,1.1c1.3,1,2.1,2.6,2.1,4.6v2.5h3.8c3.4,0,6.2,2.8,6.2,6.2v5.1c0,.4,0,.8-.1,1.1,2.4-1,4.1-3.4,4.1-6.1v-5.1c0-2.3-1.9-4.2-4.2-4.2h0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zot.propTypes = E);
const Uot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, H2e || (H2e = /* @__PURE__ */ h.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), B2e || (B2e = /* @__PURE__ */ h.createElement("path", {
    d: "M15.87 30.5L14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uot.propTypes = E);
const qot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, P2e || (P2e = /* @__PURE__ */ h.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), F2e || (F2e = /* @__PURE__ */ h.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), z2e || (z2e = /* @__PURE__ */ h.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(-135 28.232 17.233)"
  })), W2e || (W2e = /* @__PURE__ */ h.createElement("path", {
    d: "M29 10H32V12H29z"
  })), j2e || (j2e = /* @__PURE__ */ h.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), Z2e || (Z2e = /* @__PURE__ */ h.createElement("path", {
    d: "M20 0H22V3H20z"
  })), U2e || (U2e = /* @__PURE__ */ h.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(-135 13.768 4.768)"
  })), n);
});
process.env.NODE_ENV !== "production" && (qot.propTypes = E);
const Got = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, q2e || (q2e = /* @__PURE__ */ h.createElement("path", {
    d: "M13.338 30L11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), G2e || (G2e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Got.propTypes = E);
const Qot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Q2e || (Q2e = /* @__PURE__ */ h.createElement("path", {
    d: "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7887.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496zM27.9516 15A4.399 4.399 0 0128 15.5 4.5049 4.5049 0 0123.5 20H23v2h.5A6.5075 6.5075 0 0030 15.5c0-.17-.0312-.333-.0444-.5z"
  })), K2e || (K2e = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
  })), Y2e || (Y2e = /* @__PURE__ */ h.createElement("path", {
    d: "M31.9115 11.9355L25.6283.3706a.7181.7181 0 00-1.2568 0L18.0883 11.9355A.72.72 0 0018.72 13H31.28A.72.72 0 0031.9115 11.9355zM24.25 4h1.5V8h-1.5zM25 11a1 1 0 111-1A1 1 0 0125 11zM8.144 11.019l.8154-.0639.0991-.812a6.9863 6.9863 0 019.97-5.45L20 2.9468A8.9777 8.9777 0 007.2 9.1362 6.4929 6.4929 0 007.43 21.9043L6.1059 24.5527a1 1 0 101.7885.8946l2-4a1 1 0 00-.4471-1.3418A.9786.9786 0 009 20.01V20H8.5a4.4975 4.4975 0 01-.3559-8.981z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qot.propTypes = E);
const Kot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, X2e || (X2e = /* @__PURE__ */ h.createElement("path", {
    d: "M21 30a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 0121 30zM9 32a1 1 0 01-.8944-1.4474l2-4.0005a1 1 0 111.7888.8947l-2 4A.9981.9981 0 019 32zM15.901 30.496L14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), J2e || (J2e = /* @__PURE__ */ h.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kot.propTypes = E);
const Yot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $2e || ($2e = /* @__PURE__ */ h.createElement("path", {
    d: "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
  })), epe || (epe = /* @__PURE__ */ h.createElement("path", {
    d: "M19 13H21V19H19z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yot.propTypes = E);
const Xot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tpe || (tpe = /* @__PURE__ */ h.createElement("path", {
    d: "M14 7L9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7zM26.586 7.586L24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586zM20 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 17a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0112 20a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 008 17a.971.971 0 00-.9468.6787A3.44 3.44 0 014 20H2v2H4a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0020 22H30V20zM28 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0024 25a.9894.9894 0 00-.9468.6787A3.44 3.44 0 0120 28a3.4376 3.4376 0 01-3.0513-2.3164A1.007 1.007 0 0016 25a.971.971 0 00-.9468.6787A3.44 3.44 0 0112 28H2v2H12a4.9316 4.9316 0 004-1.9873 5.0192 5.0192 0 008 0A4.9316 4.9316 0 0028 30h2V28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xot.propTypes = E);
const Jot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, npe || (npe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 11L30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11zM12 11L15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jot.propTypes = E);
const $ot = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, ipe || (ipe = /* @__PURE__ */ h.createElement("path", {
    d: "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7 S14.3,2.3,10,2.3z"
  })), rpe || (rpe = /* @__PURE__ */ h.createElement("path", {
    d: "M13 13.9L9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, spe || (spe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), ope || (ope = /* @__PURE__ */ h.createElement("path", {
    d: "M20.59 22L15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($ot.propTypes = E);
const eat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ape || (ape = /* @__PURE__ */ h.createElement("path", {
    d: "m16,2c-7.6001,0-14,6.3999-14,14s6.3999,14,14,14,14-6.3999,14-14S23.6001,2,16,2Zm4.5872,20l-5.5872-5.5898V7h2v8.582l5,5.0044-1.4128,1.4136Z"
  })), lpe || (lpe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M20.5872 22L15 16.4099 15 7 17 7 17 15.5822 22 20.5866 20.5872 22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eat.propTypes = E);
const tat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cpe || (cpe = /* @__PURE__ */ h.createElement("path", {
    d: "M23.586 13L21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
  })), hpe || (hpe = /* @__PURE__ */ h.createElement("path", {
    d: "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
  })), dpe || (dpe = /* @__PURE__ */ h.createElement("path", {
    d: "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tat.propTypes = E);
const nat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, upe || (upe = /* @__PURE__ */ h.createElement("path", {
    d: "M15 11H17V20H15zM13 2H19V4H13z"
  })), fpe || (fpe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nat.propTypes = E);
const iat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ppe || (ppe = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "1",
    strokeWidth: "0"
  })), gpe || (gpe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m30,12c0-1.8237-1.2344-3.3496-2.9062-3.8286L7.2087,2.207c-.3838-.123-.7847-.207-1.2087-.207-2.2056,0-4,1.7944-4,4,0,.6025.1438,1.1689.3835,1.6816l8.1016,18.6782c.9185,2.1382,3.0442,3.6401,5.5149,3.6401,2.252,0,4.2161-1.249,5.2422-3.0889l8.002-12.5894c.4712-.6562.7559-1.4541.7559-2.3218Zm-14,6c-2.4155,0-4.4971,1.438-5.4475,3.5005l-5.0149-11.5474c.1536.0181.3042.0469.4624.0469,2.2056,0,4-1.7944,4-4,0-.3193-.0474-.6255-.1182-.9233l13.3882,4.0161c-.7771.73-1.27,1.7593-1.27,2.9072,0,2.1465,1.7029,3.8896,3.8267,3.9824l-4.0593,6.3809c-.7148-2.5146-3.0271-4.3633-5.7673-4.3633Zm12-6c0,1.1025-.8972,2-2,2s-2-.8975-2-2,.8972-2,2-2,2,.8975,2,2ZM6,4c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Zm10,24c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iat.propTypes = E);
const rat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mpe || (mpe = /* @__PURE__ */ h.createElement("path", {
    d: "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rat.propTypes = E);
const sat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ape || (Ape = /* @__PURE__ */ h.createElement("path", {
    d: "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
  })), wpe || (wpe = /* @__PURE__ */ h.createElement("path", {
    d: "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
  })), vpe || (vpe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sat.propTypes = E);
const oat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bpe || (bpe = /* @__PURE__ */ h.createElement("path", {
    d: "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oat.propTypes = E);
const aat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ype || (ype = /* @__PURE__ */ h.createElement("path", {
    d: "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8 c-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4 L28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1 l4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aat.propTypes = E);
const lat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cpe || (Cpe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 26H20V28H16zM12 22H18V24H12zM8 18H18V20H8zM8 14H20V16H8zM10 10H24V12H10zM8 6H26V8H8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lat.propTypes = E);
const cat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Epe || (Epe = /* @__PURE__ */ h.createElement("path", {
    d: "M2 4H18V6H2zM4 8H16V10H4zM2 12H14V14H2zM2 16H12V18H2zM4 20H12V22H4zM8 24H14V26H8zM12 28H16V30H12z"
  })), _pe || (_pe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), xpe || (xpe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cat.propTypes = E);
const hat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Spe || (Spe = /* @__PURE__ */ h.createElement("path", {
    d: "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
  })), Mpe || (Mpe = /* @__PURE__ */ h.createElement("path", {
    d: "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hat.propTypes = E);
const dat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dpe || (Dpe = /* @__PURE__ */ h.createElement("path", {
    d: "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
  })), Lpe || (Lpe = /* @__PURE__ */ h.createElement("path", {
    d: "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dat.propTypes = E);
const uat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kpe || (kpe = /* @__PURE__ */ h.createElement("path", {
    d: "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
  })), Npe || (Npe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uat.propTypes = E);
const fat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tpe || (Tpe = /* @__PURE__ */ h.createElement("path", {
    d: "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
  })), Ipe || (Ipe = /* @__PURE__ */ h.createElement("path", {
    d: "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fat.propTypes = E);
const pat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ope || (Ope = /* @__PURE__ */ h.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), Rpe || (Rpe = /* @__PURE__ */ h.createElement("path", {
    d: "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
  })), Vpe || (Vpe = /* @__PURE__ */ h.createElement("path", {
    d: "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pat.propTypes = E);
const gat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hpe || (Hpe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
  })), Bpe || (Bpe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
  })), Ppe || (Ppe = /* @__PURE__ */ h.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gat.propTypes = E);
const mat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fpe || (Fpe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
  })), zpe || (zpe = /* @__PURE__ */ h.createElement("path", {
    d: "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mat.propTypes = E);
const Aat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wpe || (Wpe = /* @__PURE__ */ h.createElement("path", {
    d: "m24,18l-4.7788-6.4019c-.7979-1.0562-1.2212-2.302-1.2212-3.5981,0-3.3083,2.6914-6,6-6s6,2.6917,6,6c0,1.2961-.4233,2.542-1.2246,3.6028l-4.7754,6.3972Zm0-14c-2.2056,0-4,1.7944-4,4,0,.8577.2837,1.6865.8203,2.3972l3.1797,4.2595,3.1763-4.2549c.54-.7153.8237-1.5442.8237-2.4019,0-2.2056-1.7944-4-4-4Z"
  })), jpe || (jpe = /* @__PURE__ */ h.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), Zpe || (Zpe = /* @__PURE__ */ h.createElement("path", {
    d: "m28,18v4H4V6h10v-2H4c-1.1045,0-2,.8955-2,2v16c0,1.1045.8955,2,2,2h8v4h-4v2h16v-2h-4v-4h8c1.1046,0,2-.8955,2-2v-4h-2Zm-10,10h-4v-4h4v4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Aat.propTypes = E);
const wat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Upe || (Upe = /* @__PURE__ */ h.createElement("path", {
    d: "M11 21H17V23H11z"
  })), qpe || (qpe = /* @__PURE__ */ h.createElement("path", {
    d: "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wat.propTypes = E);
const vat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gpe || (Gpe = /* @__PURE__ */ h.createElement("path", {
    d: "M26 8L22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8zM12.59 22.58L11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vat.propTypes = E);
const bat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qpe || (Qpe = /* @__PURE__ */ h.createElement("path", {
    d: "M26 9.42L24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42zM14 17.42L12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42zM2 2H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bat.propTypes = E);
const yat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kpe || (Kpe = /* @__PURE__ */ h.createElement("path", {
    d: "M2 28H30V30H2z"
  })), Ype || (Ype = /* @__PURE__ */ h.createElement("path", {
    d: "M11.314 11.514H17.314V13.514H11.314z",
    transform: "rotate(-45 14.314 12.514)"
  })), Xpe || (Xpe = /* @__PURE__ */ h.createElement("path", {
    d: "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yat.propTypes = E);
const Cat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jpe || (Jpe = /* @__PURE__ */ h.createElement("path", {
    d: "M2 24H4V30H2zM28 2H30V30H28zM15 2H17V6H15zM15 10H17V14H15zM15 18H17V22H15zM15 26H17V30H15zM6 12A3.8978 3.8978 0 012 8.223a3.9017 3.9017 0 01.6533-2.0639L5.17 2.4141a1.0381 1.0381 0 011.6592 0L9.3154 6.11A3.9693 3.9693 0 0110 8.223 3.8978 3.8978 0 016 12zm0-7.2368L4.3438 7.2257A1.89 1.89 0 004 8.223a1.9007 1.9007 0 002 1.7775A1.9007 1.9007 0 008 8.223a1.98 1.98 0 00-.375-1.0466zM11 11.7627L9.3438 14.2253A1.89 1.89 0 009 15.2226 1.9007 1.9007 0 0011 17a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467zM6 15.7627L4.3438 18.2253A1.89 1.89 0 004 19.2226 1.9007 1.9007 0 006 21a1.9007 1.9007 0 002-1.7774 1.98 1.98 0 00-.375-1.0467z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cat.propTypes = E);
const Eat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $pe || ($pe = /* @__PURE__ */ h.createElement("path", {
    d: "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eat.propTypes = E);
const _at = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ege || (ege = /* @__PURE__ */ h.createElement("path", {
    d: "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_at.propTypes = E);
const xat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tge || (tge = /* @__PURE__ */ h.createElement("path", {
    d: "M27.303 2a2.6613 2.6613 0 00-1.9079.8059l-.3932.4053-.397-.4053a2.6612 2.6612 0 00-3.8157 0 2.7991 2.7991 0 000 3.8963L25.0019 11l4.2089-4.2978a2.7991 2.7991 0 000-3.8963A2.6613 2.6613 0 0027.303 2zM22 13v3H6V10h9V8H6.1843A2.9948 2.9948 0 019 6h6V4H9A5.0057 5.0057 0 004 9V21a4.99 4.99 0 003.582 4.77L5.7693 30H7.9451l1.7143-4h8.6812l1.7143 4h2.1758L20.418 25.77A4.99 4.99 0 0024 21V13zm0 7H19v2h2.8157A2.9948 2.9948 0 0119 24H9a2.9948 2.9948 0 01-2.8157-2H9V20H6V18H22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xat.propTypes = E);
const Sat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nge || (nge = /* @__PURE__ */ h.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM8 16H2V14H8V12H2V10H8a2.0021 2.0021 0 012 2v2A2.0021 2.0021 0 018 16z"
  })), ige || (ige = /* @__PURE__ */ h.createElement("path", {
    d: "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sat.propTypes = E);
const Mat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rge || (rge = /* @__PURE__ */ h.createElement("path", {
    d: "M30 25L2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25zM29.7144 16.59L18.1494 8.64A14.9327 14.9327 0 009.6519 6H2V8H9.6519a12.9459 12.9459 0 017.3647 2.2871L18.0532 11H9v2H20.9624l7.6187 5.2378A.966.966 0 0128.0342 20H2v2H28.0342a2.9661 2.9661 0 001.68-5.41z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mat.propTypes = E);
const Dat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sge || (sge = /* @__PURE__ */ h.createElement("path", {
    d: "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
  })), oge || (oge = /* @__PURE__ */ h.createElement("path", {
    d: "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dat.propTypes = E);
const Lat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, age || (age = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M25.496 10.088L22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
  })), lge || (lge = /* @__PURE__ */ h.createElement("path", {
    d: "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
  })), cge || (cge = /* @__PURE__ */ h.createElement("path", {
    d: "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lat.propTypes = E);
const kat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hge || (hge = /* @__PURE__ */ h.createElement("path", {
    d: "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kat.propTypes = E);
const Nat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dge || (dge = /* @__PURE__ */ h.createElement("path", {
    d: "M23 20h-2c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C25 19.1 24.1 20 23 20zM21 14v4h2v-4H21zM15 12H17V20H15z"
  })), uge || (uge = /* @__PURE__ */ h.createElement("path", {
    d: "M11 20H9c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v4C13 19.1 12.1 20 11 20zM9 14v4h2v-4H9zM16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nat.propTypes = E);
const Tat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fge || (fge = /* @__PURE__ */ h.createElement("path", {
    d: "M11.9005,4.7366c-1.325.4839-2.5369,1.2001-3.5983,2.0895l-1.2829-1.5289c1.2383-1.0377,2.6521-1.8732,4.1979-2.4378l.6832,1.8772ZM3.9009,9.0146c-.8087,1.3865-1.3839,2.9225-1.6776,4.5562l1.9838.3498c.2518-1.3993.7294-2.7205,1.4221-3.9081l-1.7283-.9979ZM4.1932,18.0818l-1.9678.347c.2878,1.6357.8603,3.1745,1.6635,4.5635l1.7302-.9989c-.6884-1.1906-1.1791-2.5095-1.4258-3.9116ZM8.3065,25.1687l-1.293,1.541c1.2365,1.042,2.6556,1.8721,4.2007,2.4393l.6859-1.8845c-1.3211-.489-2.5342-1.203-3.5936-2.0958ZM29.7747,13.5712c-.2878-1.6357-.8603-3.1745-1.6635-4.5635-.8185-1.4156-1.8817-2.67-3.1246-3.7173-1.2365-1.042-2.6557-1.872-4.2007-2.4392-1.493-.5482-3.1035-.8511-4.7858-.8511v2c1.4429,0,2.8219.2625,4.0999.7355,1.321.489,2.5342,1.2031,3.5934,2.0958.4588.3867.8842.8102,1.2835,1.2573.5247.5933.9986,1.2321,1.3982,1.9213.6902,1.1904,1.1827,2.5085,1.4306,3.9084.12.6777.1943,1.3708.1943,2.0817,0,.7123-.0859,1.4019-.2086,2.0792-.2529,1.397-.7322,2.7173-1.4267,3.9049-.7058,1.2069-1.6058,2.2883-2.6725,3.1831-1.061.8899-2.2716,1.6071-3.5941,2.0923-1.2819.4703-2.6584.7405-4.0981.7405v2c1.6817,0,3.2878-.3134,4.7828-.8594,1.5458-.5646,2.9597-1.4001,4.1979-2.4378,1.2458-1.044,2.2957-2.3068,3.1183-3.7174.8087-1.3865,1.3839-2.9225,1.6776-4.5562.1418-.7889.2234-1.5988.2234-2.4292,0-.8298-.0862-1.6384-.2253-2.4288ZM12.7233,14.1082l.9186-.9185.7781-.778-1.4195-1.4117-.6503.6503-1.4218,1.4217-1.729,1.7289-1.1994,1.1993,1.1991,1.1989,1.7292,1.729,1.4218,1.4216.6504.6503,1.4195-1.4118-.7781-.7779-.9186-.9185-1.1173-1.1171-.7748-.7745.7751-.775,1.1171-1.1171ZM19.2768,17.8918l-.9186.9185-.7781.7779,1.4195,1.4118.6504-.6503,1.4218-1.4216,1.7292-1.729,1.1991-1.1989-1.1994-1.1993-1.7291-1.7289-1.4217-1.4217-.6503-.6503-1.4195,1.4117.7781.778.9186.9185,1.1171,1.1171.7751.775-.7748.7745-1.1173,1.1171Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tat.propTypes = E);
const Iat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pge || (pge = /* @__PURE__ */ h.createElement("path", {
    d: "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
  })), gge || (gge = /* @__PURE__ */ h.createElement("path", {
    d: "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iat.propTypes = E);
const Oat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mge || (mge = /* @__PURE__ */ h.createElement("path", {
    d: "M10 19H18V21H10zM10 15H22V17H10zM10 11H22V13H10z"
  })), Age || (Age = /* @__PURE__ */ h.createElement("path", {
    d: "M16 2v2c6.6 0 12 5.4 12 12s-5.4 12-12 12v2c7.7 0 14-6.3 14-14S23.7 2 16 2zM8.2 25.1L7 26.7c1.2 1 2.6 1.9 4.2 2.4l.7-1.9C10.5 26.7 9.3 26 8.2 25.1zM4.2 18l-2 .4C2.5 20 3.1 21.6 3.9 23l1.7-1C4.9 20.8 4.4 19.4 4.2 18zM5.6 10L3.9 9c-.8 1.4-1.4 3-1.6 4.6l2 .3C4.4 12.5 4.9 11.2 5.6 10zM11.8 4.8l-.7-1.9C9.6 3.5 8.2 4.3 7 5.3l1.3 1.5C9.3 6 10.5 5.3 11.8 4.8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oat.propTypes = E);
const Rat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wge || (wge = /* @__PURE__ */ h.createElement("path", {
    d: "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rat.propTypes = E);
const Vat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vge || (vge = /* @__PURE__ */ h.createElement("path", {
    d: "M27.85 29H30L24 14H21.65l-6 15H17.8l1.6-4h6.85zM20.2 23l2.62-6.56L25.45 23zM18 7V5H11V2H9V5H2V7H12.74a14.71 14.71 0 01-3.19 6.18A13.5 13.5 0 017.26 9H5.16a16.47 16.47 0 003 5.58A16.84 16.84 0 013 18l.75 1.86A18.47 18.47 0 009.53 16a16.92 16.92 0 005.76 3.84L16 18a14.48 14.48 0 01-5.12-3.37A17.64 17.64 0 0014.8 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vat.propTypes = E);
const Hat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bge || (bge = /* @__PURE__ */ h.createElement("path", {
    d: "M10.57 30l.9333-2h8.9928l.9333 2h2.2072L17 15.7778V11H15v4.7778L8.3631 30zM16 18.3647L17.6965 22h-3.393zM13.37 24h5.26l.9333 2H12.4369zM10.7832 9.3325a7.0007 7.0007 0 0110.4341 0l-1.49 1.334a5 5 0 00-7.4537 0z"
  })), yge || (yge = /* @__PURE__ */ h.createElement("path", {
    d: "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hat.propTypes = E);
const Bat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cge || (Cge = /* @__PURE__ */ h.createElement("path", {
    d: "M19 26H14V24h5a5.0055 5.0055 0 005-5V14h2v5A7.0078 7.0078 0 0119 26zM8 30H4a2.0023 2.0023 0 01-2-2V14a2.0023 2.0023 0 012-2H8a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 018 30zM4 14V28H8V14zM28 10H14a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V8A2.0023 2.0023 0 0128 10zM14 4V8H28V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bat.propTypes = E);
const vMe = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ege || (Ege = /* @__PURE__ */ h.createElement("path", {
    d: "M12 12H14V24H12zM18 12H20V24H18z"
  })), _ge || (_ge = /* @__PURE__ */ h.createElement("path", {
    d: "M4 6V8H6V28a2 2 0 002 2H24a2 2 0 002-2V8h2V6zM8 28V8H24V28zM12 2H20V4H12z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vMe.propTypes = E);
const Pat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xge || (xge = /* @__PURE__ */ h.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
  })), Sge || (Sge = /* @__PURE__ */ h.createElement("path", {
    d: "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pat.propTypes = E);
const Fat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Mge || (Mge = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
    "data-icon-path": "inner-path"
  })), Dge || (Dge = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9115 13.9355L23.6284 2.3706a.7181.7181 0 00-1.2568 0L16.0885 13.9355A.72.72 0 0016.72 15H29.28A.72.72 0 0029.9115 13.9355zM22.25 6h1.5v4h-1.5zM23 13a1 1 0 111-1A1 1 0 0123 13zM26 19V17H17V28a2.0027 2.0027 0 002 2h3V28H19V19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
  })), Lge || (Lge = /* @__PURE__ */ h.createElement("path", {
    d: "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fat.propTypes = E);
const zat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kge || (kge = /* @__PURE__ */ h.createElement("path", {
    d: "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zat.propTypes = E);
const Wat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Nge || (Nge = /* @__PURE__ */ h.createElement("path", {
    d: "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
    transform: "translate(0 .005)"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wat.propTypes = E);
const jat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Tge || (Tge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2.1245,4.4883l13.0195,23.9868c.1865.3438.5212.5249.856.5249.3345,0,.6689-.1812.8555-.5249L29.875,4.4883c.0862-.1582.1255-.3257.125-.4883-.0017-.5229-.4114-1-.9805-1H2.9802c-.5691,0-.9788.4771-.9802,1-.0005.1626.0386.3301.1245.4883Zm25.1985.5117l-11.323,20.8677L4.677,5h22.646Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jat.propTypes = E);
const Zat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ige || (Ige = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m29.0194,3c.5692,0,.979.4772.9806,1,.0005.1628-.0388.3299-.1249.4885l-13.0196,23.9867c-.1865.3435-.521.5248-.8555.5248s-.6694-.1812-.8559-.5248L2.1246,4.4885c-.0861-.1586-.1251-.3257-.1246-.4885.0016-.5228.4111-1,.9803-1h26.0391Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zat.propTypes = E);
const Uat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Oge || (Oge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m27.5117,2.1245L3.5249,15.144c-.3438.1865-.5249.5212-.5249.856,0,.3345.1812.6689.5249.8555l23.9868,13.0195c.1582.0862.3257.1255.4883.125.5229-.0017,1-.4114,1-.9805V2.9802c0-.5691-.4771-.9788-1-.9802-.1626-.0005-.3301.0386-.4883.1245Zm-.5117,25.1985L6.1323,16,27,4.677v22.646Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uat.propTypes = E);
const qat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rge || (Rge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m29,29.0194c0,.5692-.4772.979-1,.9806-.1628.0005-.3299-.0388-.4885-.1249L3.5248,16.8556c-.3435-.1865-.5248-.521-.5248-.8555s.1812-.6694.5248-.8559L27.5115,2.1246c.1586-.0861.3257-.1251.4885-.1246.5228.0016,1,.4111,1,.9803v26.0391Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qat.propTypes = E);
const Gat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vge || (Vge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m29.8755,27.5117L16.856,3.5249c-.1865-.3438-.5212-.5249-.856-.5249-.3345,0-.6689.1812-.8555.5249L2.125,27.5117c-.0862.1582-.1255.3257-.125.4883.0017.5229.4114,1,.9805,1h26.0393c.5691,0,.9788-.4771.9802-1,.0005-.1626-.0386-.3301-.1245-.4883Zm-25.1985-.5117L16,6.1323l11.323,20.8677H4.677Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gat.propTypes = E);
const Qat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hge || (Hge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m4.4883,29.8755l23.9868-13.0195c.3438-.1865.5249-.5212.5249-.856,0-.3345-.1812-.6689-.5249-.8555L4.4883,2.125c-.1582-.0862-.3257-.1255-.4883-.125-.5229.0017-1,.4114-1,.9805v26.0393c0,.5691.4771.9788,1,.9802.1626.0005.3301-.0386.4883-.1245Zm.5117-25.1985l20.8677,11.323L5,27.323V4.677Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qat.propTypes = E);
const Kat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bge || (Bge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m3,2.9806c0-.5692.4772-.979,1-.9806.1628-.0005.3299.0388.4885.1249l23.9867,13.0196c.3435.1865.5248.521.5248.8555s-.1812.6694-.5248.8559L4.4885,29.8754c-.1586.0861-.3257.1251-.4885.1246-.5228-.0016-1-.4111-1-.9803V2.9806Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kat.propTypes = E);
const Yat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Pge || (Pge = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2.9806,29c-.5692,0-.979-.4772-.9806-1-.0005-.1628.0388-.3299.1249-.4885L15.1444,3.5248c.1865-.3435.521-.5248.8555-.5248s.6694.1812.8559.5248l13.0195,23.9867c.0861.1586.1251.3257.1246.4885-.0016.5228-.4111,1-.9803,1H2.9806Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yat.propTypes = E);
const Xat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fge || (Fge = /* @__PURE__ */ h.createElement("path", {
    d: "M2,19l1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-7-7-7,7ZM28.6,11.6l-5.6,5.6-5.6-5.6-1.4,1.4,7,7,7-7-1.4-1.4ZM9,22c-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2-.8954-2-2-2ZM23,10c1.1046,0,2-.8954,2-2s-.8954-2-2-2-2,.8954-2,2,.8954,2,2,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xat.propTypes = E);
const Jat = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, zge || (zge = /* @__PURE__ */ h.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jat.propTypes = E);
const $at = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wge || (Wge = /* @__PURE__ */ h.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($at.propTypes = E);
const elt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jge || (jge = /* @__PURE__ */ h.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), Zge || (Zge = /* @__PURE__ */ h.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (elt.propTypes = E);
const tlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Uge || (Uge = /* @__PURE__ */ h.createElement("path", {
    d: "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
  })), qge || (qge = /* @__PURE__ */ h.createElement("path", {
    d: "M14.8188 6.65c.1163-.1211 1.8643-1.919 2.8882-2.9434A1 1 0 0017 2C11.812 2 2 4.2988 2 13a7.8938 7.8938 0 003.1812 6.35c-.1612.1675-1.9507 2.0054-2.8882 2.9429A1 1 0 003 24c5.188 0 15-2.2988 15-11A7.8927 7.8927 0 0014.8188 6.65zM9.7065 20.793a20.94 20.94 0 01-4.0932.9853c.1621-.166 2.7685-2.9053 2.7685-2.9053l-1.1743-.6074A5.9064 5.9064 0 014 13c0-3.667 2.1177-6.2886 6.2935-7.793a20.94 20.94 0 014.0932-.9853c-.227.2324-2.769 2.9057-2.769 2.9057l1.1748.607A5.9075 5.9075 0 0116 13C16 16.667 13.8823 19.2886 9.7065 20.793zM30 17l-5-5-5 5 1.4126 1.4155L24 15.8325V19a9.01 9.01 0 01-9 9H12v2h3A11.0125 11.0125 0 0026 19V15.8325l2.5859 2.5816z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tlt.propTypes = E);
const nlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gge || (Gge = /* @__PURE__ */ h.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), Qge || (Qge = /* @__PURE__ */ h.createElement("path", {
    d: "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nlt.propTypes = E);
const ilt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Kge || (Kge = /* @__PURE__ */ h.createElement("path", {
    d: "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
  })), Yge || (Yge = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), Xge || (Xge = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ilt.propTypes = E);
const rlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jge || (Jge = /* @__PURE__ */ h.createElement("path", {
    d: "M19 26H30V28H19zM19 22H30V24H19zM30 20h-11V12h11v8zm-9-2h7v-4h-7v4zM19 8H30V10H19zM19 4H30V6H19zM10.293 18.707L8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
  })), $ge || ($ge = /* @__PURE__ */ h.createElement("path", {
    d: "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rlt.propTypes = E);
const slt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eme || (eme = /* @__PURE__ */ h.createElement("path", {
    d: "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (slt.propTypes = E);
const olt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tme || (tme = /* @__PURE__ */ h.createElement("path", {
    d: "M28 9L26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9zM18 23H12V21h6V17H14a2.002 2.002 0 01-2-2V11a2.002 2.002 0 012-2h6v2H14v4h4a2.002 2.002 0 012 2v4A2.002 2.002 0 0118 23zM2 11L5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (olt.propTypes = E);
const alt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nme || (nme = /* @__PURE__ */ h.createElement("path", {
    d: "M24 30v-4.1c2.3-.5 4-2.5 4-4.9 0-2.4-1.7-4.4-4-4.9V2s-2 0-2 0v14.1c-2.3.5-4 2.5-4 4.9 0 2.4 1.7 4.4 4 4.9v4.1s2 0 2 0zm-4-9c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.7-1.3 3-3 3s-3-1.3-3-3zM8 2v4.1c-2.3.5-4 2.5-4 4.9 0 2.4 1.7 4.4 4 4.9v14.1s2 0 2 0v-14.1c2.3-.5 4-2.5 4-4.9 0-2.4-1.7-4.4-4-4.9V2s-2 0-2 0zm4 9c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.3 3 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (alt.propTypes = E);
const llt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ime || (ime = /* @__PURE__ */ h.createElement("path", {
    d: "M11 23.18L9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18zM28 30H24V28h4V16H24V8a4.0045 4.0045 0 00-4-4V2a6.0067 6.0067 0 016 6v6h2a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30z"
  })), rme || (rme = /* @__PURE__ */ h.createElement("path", {
    d: "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (llt.propTypes = E);
const clt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, sme || (sme = /* @__PURE__ */ h.createElement("path", {
    d: "M26.96 30l-1.9215-6.7253a1.0008 1.0008 0 01.3369-1.0554L29.874 18.62 28.52 13.2014l-2.7382 3.4234A1.0026 1.0026 0 0125 17H20V15h4.52l3.6993-4.6248a1 1 0 011.7509.3824l2 8a.9989.9989 0 01-.3447 1.0232l-4.48 3.5845 1.7389 6.0854zM23 5.5A3.5 3.5 0 1126.5 9 3.5042 3.5042 0 0123 5.5zm2 0A1.5 1.5 0 1026.5 4 1.5017 1.5017 0 0025 5.5z"
  })), ome || (ome = /* @__PURE__ */ h.createElement("path", {
    d: "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
  })), ame || (ame = /* @__PURE__ */ h.createElement("path", {
    d: "M5.04 30l1.9215-6.7253a1.0013 1.0013 0 00-.3369-1.0555L2.126 18.62l1.3545-5.4185 2.7382 3.4234A1.0026 1.0026 0 007 17h5V15H7.4805L3.7812 10.3752a1 1 0 00-1.7509.3824l-2 8A.9989.9989 0 00.375 19.7808l4.4805 3.5844-1.739 6.0855zM5.5 9A3.5 3.5 0 119 5.5 3.5042 3.5042 0 015.5 9zm0-5A1.5 1.5 0 107 5.5 1.5017 1.5017 0 005.5 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (clt.propTypes = E);
const hlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, lme || (lme = /* @__PURE__ */ h.createElement("path", {
    d: "M21 11L24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11zM20 9L18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9zM3 11L6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hlt.propTypes = E);
const dlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cme || (cme = /* @__PURE__ */ h.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM21 4L24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4zM20 2L18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2zM3 4L6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dlt.propTypes = E);
const ult = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hme || (hme = /* @__PURE__ */ h.createElement("path", {
    d: "M30 15L17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), dme || (dme = /* @__PURE__ */ h.createElement("path", {
    d: "M25.586 20L27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20zM11 30H3a1 1 0 01-.8945-1.4473l4-8a1.0412 1.0412 0 011.789 0l4 8A1 1 0 0111 30zM4.6182 28H9.3818L7 23.2363zM28 12H22a2.0023 2.0023 0 01-2-2V4a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2v6A2.0023 2.0023 0 0128 12zM22 4v6h6.001L28 4zM7 12a5 5 0 115-5A5.0059 5.0059 0 017 12zM7 4a3 3 0 103 3A3.0033 3.0033 0 007 4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ult.propTypes = E);
const flt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ume || (ume = /* @__PURE__ */ h.createElement("path", {
    d: "M30 16L22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
  })), fme || (fme = /* @__PURE__ */ h.createElement("path", {
    d: "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
  })), pme || (pme = /* @__PURE__ */ h.createElement("path", {
    d: "M2 16L10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
  })), n);
});
process.env.NODE_ENV !== "production" && (flt.propTypes = E);
const plt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gme || (gme = /* @__PURE__ */ h.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM22 21L22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
  })), n);
});
process.env.NODE_ENV !== "production" && (plt.propTypes = E);
const glt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mme || (mme = /* @__PURE__ */ h.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM25 23H17V17a2 2 0 012-2h4V11H17V9h6a2 2 0 012 2v4a2 2 0 01-2 2H19v4h6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (glt.propTypes = E);
const mlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ame || (Ame = /* @__PURE__ */ h.createElement("path", {
    d: "M13 23H9a2 2 0 01-2-2V9H9V21h4V9h2V21A2 2 0 0113 23zM23 9H17v2h6v4H18v2h5v4H17v2h6a2 2 0 002-2V11A2 2 0 0023 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mlt.propTypes = E);
const Alt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wme || (wme = /* @__PURE__ */ h.createElement("path", {
    d: "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Alt.propTypes = E);
const wlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vme || (vme = /* @__PURE__ */ h.createElement("path", {
    d: "M11 14H21V18H11z"
  })), bme || (bme = /* @__PURE__ */ h.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wlt.propTypes = E);
const vlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yme || (yme = /* @__PURE__ */ h.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
  })), Cme || (Cme = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M11 14H21V18H11z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (vlt.propTypes = E);
const blt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Eme || (Eme = /* @__PURE__ */ h.createElement("path", {
    d: "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (blt.propTypes = E);
const ylt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _me || (_me = /* @__PURE__ */ h.createElement("path", {
    d: "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ylt.propTypes = E);
const Clt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, xme || (xme = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "22.5",
    r: "1.5"
  })), Sme || (Sme = /* @__PURE__ */ h.createElement("path", {
    d: "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2 c2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
  })), Mme || (Mme = /* @__PURE__ */ h.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Clt.propTypes = E);
const Elt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dme || (Dme = /* @__PURE__ */ h.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5 S16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2 c-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125 C21.125,15.358,19.342,17.182,17.125,17.248z"
  })), Lme || (Lme = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21 z M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5 c0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Elt.propTypes = E);
const _lt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kme || (kme = /* @__PURE__ */ h.createElement("path", {
    d: "M5 3.59H7V8.42H5z",
    transform: "rotate(-45.01 5.996 6.005)"
  })), Nme || (Nme = /* @__PURE__ */ h.createElement("path", {
    d: "M25 23.58H27V28.409999999999997H25z",
    transform: "rotate(-44.99 25.995 25.999)"
  })), Tme || (Tme = /* @__PURE__ */ h.createElement("path", {
    d: "M11 2H13V6H11zM2 11H6V13H2zM26 19H30V21H26zM19 26H21V30H19zM16.58 21.07l-3.71 3.72a4 4 0 11-5.66-5.66l3.72-3.72L9.51 14 5.8 17.72a6 6 0 00-.06 8.54A6 6 0 0010 28a6.07 6.07 0 004.32-1.8L18 22.49zM15.41 10.93l3.72-3.72a4 4 0 115.66 5.66l-3.72 3.72L22.49 18l3.71-3.72a6 6 0 00.06-8.54A6 6 0 0022 4a6.07 6.07 0 00-4.32 1.8L14 9.51z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_lt.propTypes = E);
var Ime, Ome, Rme, Vme, Hme, Bme, Pme, Fme, zme, Wme, jme, Zme, Ume, qme, Gme, Qme, Kme, Yme, Xme, Jme, $me, eAe, tAe, nAe, iAe, rAe, sAe, oAe, aAe, lAe, cAe, hAe, dAe, uAe, fAe, pAe, gAe, mAe, AAe, wAe, vAe, bAe, yAe, CAe, EAe, _Ae, xAe, SAe, MAe, DAe, LAe, kAe, NAe, TAe, IAe, OAe, RAe, VAe, HAe, BAe, PAe, FAe, zAe, WAe, jAe, ZAe, UAe, qAe, GAe, QAe, KAe, YAe, XAe, JAe, $Ae, e3e, t3e, n3e, i3e, r3e, s3e, o3e, a3e, l3e, c3e, h3e, d3e, u3e, f3e, p3e, g3e, m3e, A3e, w3e, v3e, b3e, y3e, C3e, E3e, _3e, x3e, S3e, M3e, D3e, L3e, k3e, N3e, T3e, I3e, O3e, R3e, V3e, H3e, B3e, P3e, F3e, z3e, W3e, j3e, Z3e, U3e, q3e, G3e, Q3e, K3e, Y3e, X3e, J3e, $3e, e4e, t4e, n4e, i4e, r4e, s4e, o4e, a4e, l4e, c4e, h4e, d4e, u4e, f4e, p4e, g4e, m4e, A4e, w4e, v4e, b4e, y4e, C4e, E4e, _4e, x4e, S4e, M4e, D4e, L4e, k4e, N4e, T4e, I4e, O4e, R4e, V4e, H4e, B4e, P4e, F4e, z4e, W4e, j4e, Z4e, U4e, q4e, G4e, Q4e, K4e, Y4e, X4e, J4e, $4e, ewe, twe, nwe, iwe, rwe, swe, owe, awe, lwe, cwe, hwe, dwe, uwe, fwe, pwe, gwe, mwe, Awe, wwe, vwe, bwe, ywe, Cwe, Ewe, _we, xwe, Swe, Mwe, Dwe, Lwe, kwe, Nwe, Twe, Iwe, Owe, Rwe, Vwe, Hwe, Bwe, Pwe, Fwe, zwe, Wwe, jwe, Zwe, Uwe, qwe, Gwe, Qwe, Kwe, Ywe, Xwe, Jwe, $we, eve, tve, nve, ive;
const eg = {}, xlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Ime || (Ime = /* @__PURE__ */ h.createElement("path", {
    d: "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1 V8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ome || (Ome = /* @__PURE__ */ h.createElement("path", {
    d: "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xlt.propTypes = E);
const Slt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rme || (Rme = /* @__PURE__ */ h.createElement("path", {
    d: "M30 19.4L28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
  })), Vme || (Vme = /* @__PURE__ */ h.createElement("path", {
    d: "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6 c0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Slt.propTypes = E);
const Mlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hme || (Hme = /* @__PURE__ */ h.createElement("path", {
    d: "M16 14L6 24 7.4 25.4 16 16.8 24.6 25.4 26 24zM4 8H28V10H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mlt.propTypes = E);
const Dlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bme || (Bme = /* @__PURE__ */ h.createElement("path", {
    d: "M27 25.586L25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
  })), Pme || (Pme = /* @__PURE__ */ h.createElement("path", {
    d: "M24 31a7 7 0 117-7A7.0078 7.0078 0 0124 31zm0-12a5 5 0 105 5A5.0055 5.0055 0 0024 19zM16 28A12.0134 12.0134 0 014 16H2A14.0158 14.0158 0 0016 30zM12 8H7.0784A11.9843 11.9843 0 0128 16h2A13.9778 13.9778 0 006 6.2344V2H4v8h8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dlt.propTypes = E);
const Llt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Fme || (Fme = /* @__PURE__ */ h.createElement("path", {
    d: "M21 24H11a2 2 0 00-2 2v2a2 2 0 002 2H21a2 2 0 002-2V26A2 2 0 0021 24zm0 4H11V26H21zM28.707 14.293l-12-12a.9994.9994 0 00-1.414 0l-12 12A1 1 0 004 16H9v4a2.0023 2.0023 0 002 2H21a2.0027 2.0027 0 002-2V16h5a1 1 0 00.707-1.707zM21 14v6H11V14H6.4141L16 4.4141 25.5859 14z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Llt.propTypes = E);
const klt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, zme || (zme = /* @__PURE__ */ h.createElement("path", {
    d: "M3 9L3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4zM3 4V2h10v2h1V2c0-.6-.4-1-1-1H3C2.4 1 2 1.4 2 2v2H3z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wme || (Wme = /* @__PURE__ */ h.createElement("path", {
    d: "M6 18L7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18zM6 8V4H26V8h2V4a2 2 0 00-2-2H6A2 2 0 004 4V8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (klt.propTypes = E);
const Nlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, jme || (jme = /* @__PURE__ */ h.createElement("path", {
    d: "M10 24c0 3.3137 2.6863 6 6 6s6-2.6863 6-6-2.6863-6-6-6-6 2.6863-6 6zm2 0c0-2.2056 1.7944-4 4-4s4 1.7944 4 4-1.7944 4-4 4-4-1.7944-4-4zM30 5c0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.1836c0 1.7217-.752 3.3438-2 4.4673v-2.4673h-2v6h6v-2h-2.7168c1.6938-1.4995 2.7168-3.6816 2.7168-6v-5.1836c1.1626-.4136 2-1.5122 2-2.8164zm-3 1c-.5522 0-1-.4478-1-1s.4478-1 1-1 1 .4478 1 1-.4478 1-1 1zM18.586 11.5859l-1.5859 1.5859v-5.3555c1.1626-.4136 2-1.5122 2-2.8164 0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.3555l-1.5859-1.5859-1.4141 1.4141 4 4 4-4-1.4141-1.4141zm-2.5859-7.5859c.5522 0 1 .4478 1 1s-.4478 1-1 1-1-.4478-1-1 .4478-1 1-1zM8 15v2.4673c-1.248-1.1235-2-2.7456-2-4.4673v-5.1836c1.1626-.4136 2-1.5122 2-2.8164 0-1.6567-1.3433-3-3-3s-3 1.3433-3 3c0 1.3042.8374 2.4028 2 2.8164v5.1836c0 2.3184 1.0229 4.5005 2.7168 6h-2.7168v2h6v-6h-2zm-3-11c.5522 0 1 .4478 1 1s-.4478 1-1 1-1-.4478-1-1 .4478-1 1-1z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nlt.propTypes = E);
const Tlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Zme || (Zme = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M24 21L24 9 22 9 22 23 30 23 30 21 24 21zM20 15v-4c0-1.103-.8975-2-2-2h-6v14h2v-6h1.4807l2.3345 6h2.1453l-2.3331-6h.3726c1.1025 0 2-.8975 2-2zm-6-4h4v4h-4v-4zM8 23h-4c-1.103 0-2-.8975-2-2v-12h2v12h4v-12h2v12c0 1.1025-.897 2-2 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tlt.propTypes = E);
const Ilt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Ume || (Ume = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m13,28V5.8281l7.5859,7.5859,1.4141-1.4141L12,2,2,12l1.4143,1.4141,7.5857-7.5854v22.1714c0,1.1045.8955,2,2,2h15v-2h-15Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ilt.propTypes = E);
const Olt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, qme || (qme = /* @__PURE__ */ h.createElement("path", {
    d: "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
  })), Gme || (Gme = /* @__PURE__ */ h.createElement("path", {
    d: "M12 10H15V12H12zM17 10H20V12H17z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Olt.propTypes = E);
const Rlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Qme || (Qme = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M22.0735 21.9922c1.7068 0 2.9407-.7773 3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828 1.386-1.859 1.386-1.2002 0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787 1.8086-2.0787.9294 0 1.4871.5409 1.6899 1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603 0-4.0735 1.7744-4.0735 4.5969 0 2.8394 1.4705 4.6311 4.0735 4.6311zM11.5126 21.9922c3.3129 0 4.5468-1.572 4.5468-5.0369v-6.9631h-2.1973v7.2507c0 1.8422-.6423 2.772-2.3324 2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0 3.4648 1.2 5.0369 4.5126 5.0369z"
  })), Kme || (Kme = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rlt.propTypes = E);
const Vlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Yme || (Yme = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M22.0735 21.9922c1.7068 0 2.9407-.7773 3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828 1.386-1.859 1.386-1.2002 0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787 1.8086-2.0787.9294 0 1.4871.5409 1.6899 1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603 0-4.0735 1.7744-4.0735 4.5969 0 2.8394 1.4705 4.6311 4.0735 4.6311zM11.5126 21.9922c3.3129 0 4.5468-1.572 4.5468-5.0369v-6.9631h-2.1973v7.2507c0 1.8422-.6423 2.772-2.3324 2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0 3.4648 1.2 5.0369 4.5126 5.0369z"
  })), Xme || (Xme = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vlt.propTypes = E);
const Hlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Jme || (Jme = /* @__PURE__ */ h.createElement("path", {
    d: "M8 2c1.4 0 2.5 1.1 2.5 2.5S9.4 7 8 7 5.5 5.9 5.5 4.5 6.6 2 8 2M8 1C6.1 1 4.5 2.6 4.5 4.5S6.1 8 8 8s3.5-1.6 3.5-3.5S9.9 1 8 1zM13 15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1 10 4 11.1 4 12.5V15H3v-2.5C3 10.6 4.6 9 6.5 9h3c1.9 0 3.5 1.6 3.5 3.5V15z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $me || ($me = /* @__PURE__ */ h.createElement("path", {
    d: "M16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2zM26 30H24V25a5 5 0 00-5-5H13a5 5 0 00-5 5v5H6V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hlt.propTypes = E);
const Blt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, eAe || (eAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8zM30 12a1.9922 1.9922 0 00-.5117.0742L28.4331 11.019a3.8788 3.8788 0 000-4.038l1.0552-1.0552a2.0339 2.0339 0 10-1.4141-1.4141L27.019 5.5669a3.8788 3.8788 0 00-4.038 0L21.9258 4.5117a2.0339 2.0339 0 10-1.4141 1.4141L21.5669 6.981a3.8788 3.8788 0 000 4.038l-1.0552 1.0552a2.0339 2.0339 0 101.4141 1.4141l1.0552-1.0552a3.8788 3.8788 0 004.038 0l1.0552 1.0552A1.9957 1.9957 0 1030 12zM23 9a2 2 0 112 2A2.0025 2.0025 0 0123 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Blt.propTypes = E);
const Plt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, tAe || (tAe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M28 8v-3c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v3c-1.1028 0-2 .8975-2 2v6c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2v-6c0-1.1025-.8972-2-2-2zm-6-3c0-1.1025.8972-2 2-2s2 .8975 2 2v3h-4v-3zm-2 11v-6h8v6h-8zM16 30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982 1.3439-3 3v5h-2v-5c.0033-2.7601 2.2399-4.9967 5-5h4c2.7601.0033 4.9967 2.2399 5 5v5zM9 10c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3m0-2c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Plt.propTypes = E);
const Flt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nAe || (nAe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M16 30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982 1.3439-3 3v5h-2v-5c.0033-2.7601 2.2399-4.9967 5-5h4c2.7601.0033 4.9967 2.2399 5 5v5zM9 10c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3 1.3431-3 3-3m0-2c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5zM28 8h-6v-3c0-1.1025.8972-2 2-2s2 .8975 2 2h2c0-2.2056-1.7944-4-4-4s-4 1.7944-4 4v3c-1.1028 0-2 .8975-2 2v6c0 1.1025.8972 2 2 2h8c1.1028 0 2-.8975 2-2v-6c0-1.1025-.8972-2-2-2zm0 8h-8v-6h8v6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Flt.propTypes = E);
const zlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, iAe || (iAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 23h-.0215a1.0016 1.0016 0 01-.94-.7256L20.8711 11.19l-1.9346 5.1607A1.0005 1.0005 0 0118 17H14V15h3.3066l2.7569-7.3511a1.0005 1.0005 0 011.8984.0762l3.1113 10.8921 1.9786-5.9336A.9988.9988 0 0128 12h4v2H28.7207l-2.7725 8.3164A.9984.9984 0 0125 23zM15 30H13V23a3.0033 3.0033 0 00-3-3H6a3.0033 3.0033 0 00-3 3v7H1V23a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM8 8a3 3 0 11-3 3A3 3 0 018 8M8 6a5 5 0 105 5A5 5 0 008 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zlt.propTypes = E);
const Wlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, rAe || (rAe = /* @__PURE__ */ h.createElement("path", {
    d: "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM25 16.18L22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wlt.propTypes = E);
const jlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, sAe || (sAe = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5 C9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5 s6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
  })), oAe || (oAe = /* @__PURE__ */ h.createElement("path", {
    d: "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5 S8.8,7,8,7z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, aAe || (aAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
  })), lAe || (lAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jlt.propTypes = E);
const Zlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, cAe || (cAe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
  })), hAe || (hAe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zlt.propTypes = E);
const Ult = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, dAe || (dAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
  })), uAe || (uAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ult.propTypes = E);
const qlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, fAe || (fAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 10L26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qlt.propTypes = E);
const Glt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, pAe || (pAe = /* @__PURE__ */ h.createElement("path", {
    d: "M28 8H30V16H28zM23 5H25V16H23zM18 10H20V16H18zM16 30H14V24a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v6H2V24a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 9a3 3 0 11-3 3A3 3 0 019 9M9 7a5 5 0 105 5A5 5 0 009 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Glt.propTypes = E);
const Qlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, gAe || (gAe = /* @__PURE__ */ h.createElement("path", {
    d: "M27.303 12a2.6616 2.6616 0 00-1.9079.8058l-.3932.4054-.397-.4054a2.6615 2.6615 0 00-3.8157 0 2.7992 2.7992 0 000 3.8964L25.0019 21l4.2089-4.2978a2.7992 2.7992 0 000-3.8964A2.6616 2.6616 0 0027.303 12zM2 30H4V25a5.0059 5.0059 0 015-5h6a5.0059 5.0059 0 015 5v5h2V25a7.0082 7.0082 0 00-7-7H9a7.0082 7.0082 0 00-7 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qlt.propTypes = E);
const Klt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, mAe || (mAe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.7663 4.2558A4.2121 4.2121 0 0023 4.0321a4.2121 4.2121 0 00-5.7663.2237 4.319 4.319 0 000 6.0447L22.998 16.14 23 16.1376l.002.0019 5.7643-5.839A4.319 4.319 0 0028.7663 4.2558zM27.342 8.8948l-4.34 4.3973L23 13.29l-.002.002-4.34-4.3973a2.3085 2.3085 0 010-3.2338 2.2639 2.2639 0 013.1561 0l1.181 1.2074L23 6.8634l.0049.005 1.181-1.2074a2.2639 2.2639 0 013.1561 0A2.3085 2.3085 0 0127.342 8.8948zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Klt.propTypes = E);
const Ylt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, AAe || (AAe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.4938 3a3.4735 3.4735 0 00-2.48 1.0393l-.5111.5228-.5161-.5228a3.4792 3.4792 0 00-4.96 0 3.59 3.59 0 000 5.0251l5.4766 5.5427 5.4716-5.5427a3.59 3.59 0 000-5.0251A3.4738 3.4738 0 0026.4938 3zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ylt.propTypes = E);
const Xlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wAe || (wAe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M19 3h10c1.1035 0 2 .8965 2 2v6c0 1.1035-.8965 2-2 2h-2.4229s-1.7314 3-1.7314 3l-1.7324-1 2.3096-4h3.5771s0-6 0-6h-10s0 6 0 6h3v2h-3c-1.1035 0-2-.8965-2-2v-6c0-1.1035.8965-2 2-2zM15 30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982 1.3439-3 3v5H1v-5c.0033-2.7601 2.2399-4.9967 5-5h4c2.7601.0033 4.9967 2.2399 5 5v5zM8 10c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3c.0019-1.6561 1.3439-2.9981 3-3m0-2c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xlt.propTypes = E);
const Jlt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, vAe || (vAe = /* @__PURE__ */ h.createElement("path", {
    d: "M6 30H26V25a7.0082 7.0082 0 00-7-7H13a7.0082 7.0082 0 00-7 7zM9 9a7 7 0 107-7A7 7 0 009 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jlt.propTypes = E);
const $lt = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bAe || (bAe = /* @__PURE__ */ h.createElement("path", {
    d: "M32 14L28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($lt.propTypes = E);
const ect = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, yAe || (yAe = /* @__PURE__ */ h.createElement("path", {
    d: "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
  })), CAe || (CAe = /* @__PURE__ */ h.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), EAe || (EAe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 18H18a2.0023 2.0023 0 01-2-2V4a2.002 2.002 0 012-2H30a2.0023 2.0023 0 012 2V16A2.0027 2.0027 0 0130 18zM18 4V16H30.001L30 4zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ect.propTypes = E);
const tct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _Ae || (_Ae = /* @__PURE__ */ h.createElement("path", {
    d: "M25 13L23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
  })), xAe || (xAe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.414 13.414L25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
  })), SAe || (SAe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.414 8.414L25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tct.propTypes = E);
const nct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, MAe || (MAe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 30H28V25a5.0057 5.0057 0 00-5-5V18a7.0078 7.0078 0 017 7zM22 30H20V25a5.0059 5.0059 0 00-5-5H9a5.0059 5.0059 0 00-5 5v5H2V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM20 2V4a5 5 0 010 10v2A7 7 0 0020 2zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nct.propTypes = E);
const ict = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, DAe || (DAe = /* @__PURE__ */ h.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), LAe || (LAe = /* @__PURE__ */ h.createElement("path", {
    d: "M22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ict.propTypes = E);
const rct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kAe || (kAe = /* @__PURE__ */ h.createElement("path", {
    d: "M12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM22 4H32V6H22zM22 9H32V11H22zM22 14H29V16H22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rct.propTypes = E);
const sct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, NAe || (NAe = /* @__PURE__ */ h.createElement("path", {
    d: "M28.07 21L22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21zM22 30H20V25a5 5 0 00-5-5H9a5 5 0 00-5 5v5H2V25a7 7 0 017-7h6a7 7 0 017 7zM12 4A5 5 0 117 9a5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0012 2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sct.propTypes = E);
const oct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, TAe || (TAe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "M23.019 10.4332c-.595.3514-1.2795.5668-2.019.5668-2.2056 0-4-1.7944-4-4 0-.3557.0615-.6943.1492-1.0228l2.4368 2.4368.0005-.0004c.3621.3621.8621.5864 1.4136.5864 1.103 0 2-.897 2-2 0-.5515-.2242-1.0515-.5864-1.4136l.0005-.0004-2.4368-2.4368c.3284-.0875.667-.1491 1.0227-.1491 2.2056 0 4 1.7944 4 4 0 .7396-.2155 1.4241-.5669 2.0191l5.5669 5.5668-1.4141 1.4141-5.5669-5.5668zM16 30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982 1.3439-3 3v5h-2v-5c.0033-2.7601 2.2399-4.9967 5-5h4c2.7601.0033 4.9967 2.2399 5 5v5zM9 10c1.6569 0 3 1.3431 3 3s-1.3431 3-3 3-3-1.3431-3-3c.0019-1.6561 1.3439-2.9981 3-3m0-2c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5-2.2386-5-5-5z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oct.propTypes = E);
const act = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, IAe || (IAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25.334 11.95l1.2055-1.206a1.178 1.178 0 011.2593-.2584l1.4693.5868A1.1736 1.1736 0 0130 12.1489v2.692A1.1681 1.1681 0 0128.8229 16l-.05-.0015C18.4775 15.3578 16.4 6.6357 16.0073 3.2976a1.1681 1.1681 0 011.0315-1.29A1.1492 1.1492 0 0117.1751 2h2.5994a1.1626 1.1626 0 011.0764.7322l.5866 1.47a1.1635 1.1635 0 01-.2529 1.26L19.9791 6.668S20.6733 11.3682 25.334 11.95zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (act.propTypes = E);
const lct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, OAe || (OAe = /* @__PURE__ */ h.createElement("path", {
    d: "M30 10V8H27.8989a4.9678 4.9678 0 00-.7319-1.7529l1.49-1.49-1.414-1.414-1.49 1.49A4.9678 4.9678 0 0024 4.1011V2H22V4.1011a4.9678 4.9678 0 00-1.7529.7319l-1.49-1.49-1.414 1.414 1.49 1.49A4.9678 4.9678 0 0018.1011 8H16v2h2.1011a4.9678 4.9678 0 00.7319 1.7529l-1.49 1.49 1.414 1.414 1.49-1.49A4.9678 4.9678 0 0022 13.8989V16h2V13.8989a4.9678 4.9678 0 001.7529-.7319l1.49 1.49 1.414-1.414-1.49-1.49A4.9678 4.9678 0 0027.8989 10zm-7 2a3 3 0 113-3A3.0033 3.0033 0 0123 12zM16 30H14V25a3.0033 3.0033 0 00-3-3H7a3.0033 3.0033 0 00-3 3v5H2V25a5.0059 5.0059 0 015-5h4a5.0059 5.0059 0 015 5zM9 10a3 3 0 11-3 3 3 3 0 013-3M9 8a5 5 0 105 5A5 5 0 009 8z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lct.propTypes = E);
const cct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, RAe || (RAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25.232 12.866H29.232V14.866H25.232z",
    transform: "rotate(30 27.232 13.866)"
  })), VAe || (VAe = /* @__PURE__ */ h.createElement("path", {
    d: "M26 8H30V10H26z"
  })), HAe || (HAe = /* @__PURE__ */ h.createElement("path", {
    d: "M2.768 12.866H6.768V14.866H2.768z",
    transform: "rotate(150 4.768 13.866)"
  })), BAe || (BAe = /* @__PURE__ */ h.createElement("path", {
    d: "M26 30H24V25a5.0059 5.0059 0 00-5-5H13a5.0059 5.0059 0 00-5 5v5H6V25a7.0082 7.0082 0 017-7h6a7.0082 7.0082 0 017 7zM16 4a5 5 0 11-5 5 5 5 0 015-5m0-2a7 7 0 107 7A7 7 0 0016 2z"
  })), PAe || (PAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25.232 3.134H29.232V5.134H25.232z",
    transform: "rotate(-30 27.232 4.134)"
  })), FAe || (FAe = /* @__PURE__ */ h.createElement("path", {
    d: "M2 8H6V10H2z"
  })), zAe || (zAe = /* @__PURE__ */ h.createElement("path", {
    d: "M2.768 3.134H6.768V5.134H2.768z",
    transform: "rotate(-150 4.768 4.134)"
  })), n);
});
process.env.NODE_ENV !== "production" && (cct.propTypes = E);
const hct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, WAe || (WAe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
  })), jAe || (jAe = /* @__PURE__ */ h.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hct.propTypes = E);
const dct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ZAe || (ZAe = /* @__PURE__ */ h.createElement("path", {
    d: "M31.8301 13.3662L30.8301 11.6338 28 13.2681 28 10 26 10 26 13.2676 23.1699 11.6338 22.1699 13.3662 25 15 22.1699 16.6338 23.1699 18.3662 26 16.7324 26 20 28 20 28 16.7319 30.8301 18.3662 31.8301 16.6338 29 15 31.8301 13.3662zM22 30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967 2.2399-5 5v5h-2v-5c.0045-3.8641 3.1359-6.9955 7-7h6c3.8641.0045 6.9955 3.1359 7 7v5zM12 4c2.7614 0 5 2.2386 5 5s-2.2386 5-5 5-5-2.2386-5-5c.0031-2.7601 2.2399-4.9969 5-5m0-2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dct.propTypes = E);
const uct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, UAe || (UAe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M28 9L28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
  })), qAe || (qAe = /* @__PURE__ */ h.createElement("path", {
    d: "M31 3H17a1 1 0 00-1 1V17a1 1 0 001 1H31a1 1 0 001-1V4A1 1 0 0031 3zM28 9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3zM15 30H13V26a2.9465 2.9465 0 00-3-3H6a2.9465 2.9465 0 00-3 3v4H1V26a4.9514 4.9514 0 015-5h4a4.9514 4.9514 0 015 5zM8 11a3 3 0 010 6 3 3 0 010-6M8 9A5 5 0 008 19 5 5 0 008 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uct.propTypes = E);
const fct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, GAe || (GAe = /* @__PURE__ */ h.createElement("path", {
    d: "M19 13H26V15H19zM19 8H30V10H19zM19 3H30V5H19zM11 30H7a2.0059 2.0059 0 01-2-2V21a2.0059 2.0059 0 01-2-2V13a2.9465 2.9465 0 013-3h6a2.9465 2.9465 0 013 3v6a2.0059 2.0059 0 01-2 2v7A2.0059 2.0059 0 0111 30zM6 12a.9448.9448 0 00-1 1v6H7v9h4V19h2V13a.9448.9448 0 00-1-1zM9 9a4 4 0 114-4h0A4.0118 4.0118 0 019 9zM9 3a2 2 0 102 2h0A2.0059 2.0059 0 009 3z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fct.propTypes = E);
const pct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, QAe || (QAe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pct.propTypes = E);
const gct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, KAe || (KAe = /* @__PURE__ */ h.createElement("path", {
    d: "M13 30H9a2.0027 2.0027 0 01-2-2V20H9v8h4V20h2v8A2.0027 2.0027 0 0113 30zM25 20L23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20zM15 2H17V7H15z"
  })), YAe || (YAe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), XAe || (XAe = /* @__PURE__ */ h.createElement("path", {
    d: "M25 15H30V17H25zM2 15H7V17H2z"
  })), JAe || (JAe = /* @__PURE__ */ h.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), $Ae || ($Ae = /* @__PURE__ */ h.createElement("path", {
    d: "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gct.propTypes = E);
const mct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, e3e || (e3e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mct.propTypes = E);
const Act = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, t3e || (t3e = /* @__PURE__ */ h.createElement("path", {
    d: "M26 28H22V26h4V6H22V4h4a2.0021 2.0021 0 012 2V26A2.0021 2.0021 0 0126 28zM20 11L18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11zM10 28H6a2.0021 2.0021 0 01-2-2V6A2.0021 2.0021 0 016 4h4V6H6V26h4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Act.propTypes = E);
const wct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n3e || (n3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wct.propTypes = E);
const vct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, i3e || (i3e = /* @__PURE__ */ h.createElement("circle", {
    cx: "21.5",
    cy: "10.5",
    r: "1.5"
  })), r3e || (r3e = /* @__PURE__ */ h.createElement("path", {
    d: "M28.5 1a2.4518 2.4518 0 00-1.2061.3105L18.9834 5.6084l.0027.0054a5.497 5.497 0 107.3257 7.5444l.0031.0015 4.4-8.5A2.5 2.5 0 0028.5 1zm-7 13A3.5 3.5 0 1125 10.5 3.5042 3.5042 0 0121.5 14zM28.9414 3.7354L26.5571 8.3408A5.5279 5.5279 0 0023.658 5.4424l4.5949-2.377A.5165.5165 0 0129 3.5.4985.4985 0 0128.9414 3.7354zM19 20h7V18H17V28a2.0027 2.0027 0 002 2h3V28H19zM12 30H9V28h3V15.5664L8.4854 13.4575l1.0292-1.7148 3.5147 2.1084A2.0115 2.0115 0 0114 15.5664V28A2.0024 2.0024 0 0112 30z"
  })), s3e || (s3e = /* @__PURE__ */ h.createElement("path", {
    d: "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vct.propTypes = E);
const bct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o3e || (o3e = /* @__PURE__ */ h.createElement("path", {
    d: "M19 20h7v-2h-9v10c.0015 1.104.896 1.9985 2 2h3v-2h-3v-8zM12 30h-3v-2h3v-12.4336l-3.5146-2.1089 1.0292-1.7148 3.5147 2.1084c.6007.3632.9686 1.0133.9707 1.7153v12.4336c-.0013 1.104-.896 1.9987-2 2zM30 6.4102L28.59 5 25 8.5898 21.41 5 20 6.4102 23.59 10 20 13.5898 21.41 15 25 11.4102 28.59 15 30 13.5898 26.41 10 30 6.4102z"
  })), a3e || (a3e = /* @__PURE__ */ h.createElement("path", {
    d: "m17.3079,2.2852c-.7283-.1821-1.4995-.2852-2.3079-.2852-2.8545.0083-5.4897,1.5317-6.9214,4.001-.0261-.001-.0522-.001-.0786-.001-3.3137,0-6,2.6865-6,6s2.6863,6,6,6v-2c-2.209,0-4-1.791-4-4s1.791-4,4-4c.1299.0039.259.0166.387.0391l.863.1143.3086-.6675c.9834-2.1196,3.1047-3.4785,5.4414-3.4858.6079,0,1.1819.0854,1.731.2148l.5769-1.9297Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bct.propTypes = E);
const yct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, l3e || (l3e = /* @__PURE__ */ h.createElement("path", {
    d: "m13,8l-5,5,1.4102,1.4102,2.5898-2.5801v16.1699h-3v2h3c1.104-.0015,1.9988-.896,2-2V11.8301l2.5898,2.5801,1.4102-1.4102-5-5Z"
  })), c3e || (c3e = /* @__PURE__ */ h.createElement("path", {
    d: "m22,30h-3c-1.104-.0013-1.9987-.896-2-2v-11h6c2.2096-.0001,4.0007-1.7915,4.0006-4.001,0-.1319-.0065-.2637-.0196-.395-.277-2.0943-2.0835-3.6461-4.1957-3.604h-1.5837l-.1766-.779c-.573-2.5249-2.9942-4.221-6.025-4.221-2.3366.0074-4.4579,1.3664-5.4415,3.4859l-.3085.6672-.863-.1143c-.1279-.022-.2573-.0349-.387-.0388-2.2091,0-4,1.7909-4,4s1.7909,4,4,4v2c-3.3137,0-6-2.6863-6-6s2.6863-6,6-6c.0264,0,.0525,0,.0786.001,1.4317-2.4694,4.067-3.9928,6.9214-4.001,3.6788,0,6.6923,1.9776,7.7516,5h.0337c3.1405-.0351,5.8053,2.2967,6.1872,5.4141.323,3.2985-2.0892,6.2344-5.3877,6.5573-.1943.019-.3895.0286-.5848.0286h-4v9h3v2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yct.propTypes = E);
const Cct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, h3e || (h3e = /* @__PURE__ */ h.createElement("path", {
    d: "M28 11a1.9907 1.9907 0 00-.8247.1821L24.8337 9.51A3.45 3.45 0 0025 8.5a3.45 3.45 0 00-.1663-1.01l2.3416-1.6723A1.9975 1.9975 0 1026 4c0 .064.0129.124.0188.1865L23.7273 5.8232A3.4652 3.4652 0 0021.5 5a3.5 3.5 0 000 7 3.4652 3.4652 0 002.2273-.8232l2.2915 1.6367C26.0129 12.876 26 12.936 26 13a2 2 0 102-2zm-6.5-1A1.5 1.5 0 1123 8.5 1.5017 1.5017 0 0121.5 10zM29.3379 19.9336l-7.7324-2.7783L18.374 13.0967A2.99 2.99 0 0016.0537 12H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 17.2949A4.9884 4.9884 0 002 20.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V20.875A1 1 0 0029.3379 19.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V20.1074A2.9977 2.9977 0 014.52 18.4189l2.711-3.9814A.9992.9992 0 018.0576 14h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 21.5781z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cct.propTypes = E);
const Ect = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, d3e || (d3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM25 11H23a2.0021 2.0021 0 00-2-2V7A4.0045 4.0045 0 0125 11z"
  })), u3e || (u3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ect.propTypes = E);
const _ct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, f3e || (f3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM28 2H30V9H28zM24 6H26V9H24zM20 4H22V9H20z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_ct.propTypes = E);
const xct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, p3e || (p3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.3379 17.9336l-7.7324-2.7783L18.374 11.0967A2.99 2.99 0 0016.0537 10H8.0576a2.9982 2.9982 0 00-2.48 1.3115L2.8662 15.2949A4.9884 4.9884 0 002 18.1074V26a1 1 0 001 1H5.1421a3.9806 3.9806 0 007.7158 0h6.2842a3.9806 3.9806 0 007.7158 0H29a1 1 0 001-1V18.875A1 1 0 0029.3379 17.9336zM9 28a2 2 0 112-2A2.0027 2.0027 0 019 28zm14 0a2 2 0 112-2A2.0025 2.0025 0 0123 28zm5-3H26.8579a3.9806 3.9806 0 00-7.7158 0H12.8579a3.9806 3.9806 0 00-7.7158 0H4V18.1074A2.9977 2.9977 0 014.52 16.4189l2.711-3.9814A.9992.9992 0 018.0576 12h7.9961a.9928.9928 0 01.7647.3545l3.3994 4.2685a1.0007 1.0007 0 00.4443.3184L28 19.5781zM24.5547 6a2 2 0 012-2H30a3.9756 3.9756 0 00-7.304 1H16V7h6.696A3.9756 3.9756 0 0030 8H26.5547A2 2 0 0124.5547 6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xct.propTypes = E);
const Sct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, g3e || (g3e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
  })), m3e || (m3e = /* @__PURE__ */ h.createElement("path", {
    d: "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
  })), A3e || (A3e = /* @__PURE__ */ h.createElement("path", {
    d: "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sct.propTypes = E);
const Mct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, w3e || (w3e = /* @__PURE__ */ h.createElement("path", {
    d: "M18.5859 17.4141L16 14.8345 16 14.8345 13.4125 17.4156 12 16 16 12 20 16 18.5859 17.4141zM18.5859 11.4141L16 8.8345 16 8.8345 13.4125 11.4156 12 10 16 6 20 10 18.5859 11.4141zM18.5859 23.4141L16 20.8345 16 20.8345 13.4125 23.4156 12 22 16 18 20 22 18.5859 23.4141z"
  })), v3e || (v3e = /* @__PURE__ */ h.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mct.propTypes = E);
const Dct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, b3e || (b3e = /* @__PURE__ */ h.createElement("path", {
    d: "M18.5859 15.4141L16 12.8345 16 12.8345 13.4125 15.4156 12 14 16 10 20 14 18.5859 15.4141zM18.5859 21.4141L16 18.8345 16 18.8345 13.4125 21.4156 12 20 16 16 20 20 18.5859 21.4141z"
  })), y3e || (y3e = /* @__PURE__ */ h.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dct.propTypes = E);
const Lct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, C3e || (C3e = /* @__PURE__ */ h.createElement("path", {
    d: "M18.5859 18.4141L16 15.8345 16 15.8345 13.4125 18.4156 12 17 16 13 20 17 18.5859 18.4141z"
  })), E3e || (E3e = /* @__PURE__ */ h.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lct.propTypes = E);
const kct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _3e || (_3e = /* @__PURE__ */ h.createElement("path", {
    d: "M12 30H4a2.0021 2.0021 0 01-2-2V4A2.0021 2.0021 0 014 2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0112 30zM4 4V28h8V4zM28 30H20a2.0021 2.0021 0 01-2-2V4a2.0021 2.0021 0 012-2h8a2.0021 2.0021 0 012 2V28A2.0021 2.0021 0 0128 30zM20 4V28h8V4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kct.propTypes = E);
const Nct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, x3e || (x3e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nct.propTypes = E);
const Tct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, S3e || (S3e = /* @__PURE__ */ h.createElement("path", {
    d: "M18 15L14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
  })), M3e || (M3e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tct.propTypes = E);
const Ict = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D3e || (D3e = /* @__PURE__ */ h.createElement("path", {
    d: "M8 12H17V14H8zM8 17H13V19H8z"
  })), L3e || (L3e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Ict.propTypes = E);
const Oct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, k3e || (k3e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oct.propTypes = E);
const Rct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, N3e || (N3e = /* @__PURE__ */ h.createElement("path", {
    d: "M29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11zM28 21.06l-5.42-3.87A1 1 0 0021 18v6H9.44L21 12.44V14a1 1 0 001.58.81L28 10.94zM4 24V8H20V6H4A2 2 0 002 8V24z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rct.propTypes = E);
const Vct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, T3e || (T3e = /* @__PURE__ */ h.createElement("path", {
    d: "M20.31 6H4A2 2 0 002 8V24a2.85 2.85 0 000 .29zM29.46 8.11a1 1 0 00-1 .08L23 12.06V10.44l7-7L28.56 2 2 28.56 3.44 30l4-4H21a2 2 0 002-2V19.94l5.42 3.87A1 1 0 0030 23V9A1 1 0 0029.46 8.11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vct.propTypes = E);
const Hct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, I3e || (I3e = /* @__PURE__ */ h.createElement("path", {
    d: "M13 11L13 21 21 16 13 11z"
  })), O3e || (O3e = /* @__PURE__ */ h.createElement("path", {
    d: "m28,6H4c-1.103,0-2,.8975-2,2v16c0,1.1025.897,2,2,2h24c1.103,0,2-.8975,2-2V8c0-1.1025-.897-2-2-2Zm0,18H4V8h24v16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hct.propTypes = E);
const M7 = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, R3e || (R3e = /* @__PURE__ */ h.createElement("path", {
    d: "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z"
  })), V3e || (V3e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, H3e || (H3e = /* @__PURE__ */ h.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
  })), B3e || (B3e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (M7.propTypes = E);
const Bct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, P3e || (P3e = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), F3e || (F3e = /* @__PURE__ */ h.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bct.propTypes = E);
const Pct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, z3e || (z3e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM26 6v6H6V6H26m0-2H6A2 2 0 004 6v6a2 2 0 002 2H26a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Pct.propTypes = E);
const Fct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, W3e || (W3e = /* @__PURE__ */ h.createElement("path", {
    d: "M4 26H28V28H4zM4 19H28V21H4zM12 6v6H6V6h6m0-2H6A2 2 0 004 6v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2zM26 6v6H20V6h6m0-2H20a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Fct.propTypes = E);
const zct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, j3e || (j3e = /* @__PURE__ */ h.createElement("path", {
    d: "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
  })), Z3e || (Z3e = /* @__PURE__ */ h.createElement("path", {
    d: "M6 7.9c.1-1 .9-1.8 1.8-1.8l.9-.9C7.2 4.7 5.5 5.6 5.1 7.2 5 7.7 5 8.3 5.1 8.8L6 7.9zM15.5 7.8c-.6-1.5-1.6-2.8-2.9-3.7L15 1.7 14.3 1 1 14.3 1.7 15l2.6-2.6c1.1.7 2.4 1 3.7 1.1 3.3-.1 6.3-2.2 7.5-5.3C15.5 8.1 15.5 7.9 15.5 7.8zM10 8c0 1.1-.9 2-2 2-.3 0-.7-.1-1-.3L9.7 7C9.9 7.3 10 7.6 10 8zM8 12.5c-1 0-2.1-.3-3-.8l1.3-1.3c1.4.9 3.2.6 4.2-.8.7-1 .7-2.4 0-3.4l1.4-1.4c1.1.8 2 1.9 2.6 3.2C13.4 10.5 10.6 12.5 8 12.5z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, U3e || (U3e = /* @__PURE__ */ h.createElement("path", {
    d: "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
  })), q3e || (q3e = /* @__PURE__ */ h.createElement("path", {
    d: "M12 15.73a4 4 0 013.7-3.7l1.81-1.82a6 6 0 00-7.33 7.33zM30.94 15.66A16.4 16.4 0 0025.2 8.22L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.1A15.29 15.29 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM20 16a4 4 0 01-6 3.44L19.44 14A4 4 0 0120 16zm-4 9a13.05 13.05 0 01-6-1.58l2.54-2.54a6 6 0 008.35-8.35l2.87-2.87A14.54 14.54 0 0128.93 16C26.9 21.07 21.3 25 16 25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (zct.propTypes = E);
const Wct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, G3e || (G3e = /* @__PURE__ */ h.createElement("path", {
    d: "M30.94 15.66a16.4 16.4 0 00-5.73-7.45L30 3.41 28.59 2 2 28.59 3.41 30l5.1-5.09A15.38 15.38 0 0016 27 16.69 16.69 0 0030.94 16.34 1 1 0 0030.94 15.66zM16 22.5a6.46 6.46 0 01-3.83-1.26L14 19.43A4 4 0 0019.43 14l1.81-1.81A6.49 6.49 0 0116 22.5zM4.53 21.81l5-5A6.84 6.84 0 019.5 16 6.51 6.51 0 0116 9.5a6.84 6.84 0 01.79.05l3.78-3.77A14.39 14.39 0 0016 5 16.69 16.69 0 001.06 15.66a1 1 0 000 .68A15.86 15.86 0 004.53 21.81z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Wct.propTypes = E);
const jct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Q3e || (Q3e = /* @__PURE__ */ h.createElement("path", {
    d: "M20.587 22L15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), K3e || (K3e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (jct.propTypes = E);
const Zct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Y3e || (Y3e = /* @__PURE__ */ h.createElement("path", {
    d: "M25 11L26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), X3e || (X3e = /* @__PURE__ */ h.createElement("path", {
    d: "M30 28H20a2.0023 2.0023 0 01-2-2V6a2.0023 2.0023 0 012-2H30V6H20V26H30zM12 28H2V26H12V6H2V4H12a2.0023 2.0023 0 012 2V26A2.0023 2.0023 0 0112 28z"
  })), J3e || (J3e = /* @__PURE__ */ h.createElement("path", {
    d: "M7 11L5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Zct.propTypes = E);
const Uct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, $3e || ($3e = /* @__PURE__ */ h.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), e4e || (e4e = /* @__PURE__ */ h.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), t4e || (t4e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Uct.propTypes = E);
const qct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, n4e || (n4e = /* @__PURE__ */ h.createElement("path", {
    d: "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
  })), i4e || (i4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (qct.propTypes = E);
const Gct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, r4e || (r4e = /* @__PURE__ */ h.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), s4e || (s4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Gct.propTypes = E);
const Qct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, o4e || (o4e = /* @__PURE__ */ h.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), a4e || (a4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Qct.propTypes = E);
const Kct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (eg.VirtualPrivateCloudAlt || (eg.VirtualPrivateCloudAlt = !0, console.warn("Icon name was requested by the product team to be renamed to and replaced by ibm-cloud--vpc. As a result, the VirtualPrivateCloudAlt component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, l4e || (l4e = /* @__PURE__ */ h.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), c4e || (c4e = /* @__PURE__ */ h.createElement("path", {
    d: "M30 6a3.9915 3.9915 0 00-7.8579-1H13V7h9.1421A3.9945 3.9945 0 0025 9.8579V19h2V9.8579A3.9962 3.9962 0 0030 6zM26 8a2 2 0 112-2A2.0023 2.0023 0 0126 8zM19 25H9.8579A3.9945 3.9945 0 007 22.1421V13H5v9.1421A3.9915 3.9915 0 109.8579 27H19zM6 28a2 2 0 112-2A2.0023 2.0023 0 016 28z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Kct.propTypes = E);
const Yct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, h4e || (h4e = /* @__PURE__ */ h.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), d4e || (d4e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Yct.propTypes = E);
const Xct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, u4e || (u4e = /* @__PURE__ */ h.createElement("path", {
    d: "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Xct.propTypes = E);
const Jct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, f4e || (f4e = /* @__PURE__ */ h.createElement("path", {
    d: "M16 22a4 4 0 104 4A4.0045 4.0045 0 0016 22zm0 6a2 2 0 112-2A2.002 2.002 0 0116 28zM30 5a3 3 0 10-4 2.8154V15H17V9H15v6H6V7.8159a3.0007 3.0007 0 10-2 0V15a2.002 2.002 0 002 2h9v3h2V17h9a2.002 2.002 0 002-2V7.8159A2.9958 2.9958 0 0030 5zM5 4A1 1 0 114 5 1.0013 1.0013 0 015 4zM27 6a1 1 0 111-1A1.0013 1.0013 0 0127 6z"
  })), p4e || (p4e = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "5",
    r: "2"
  })), n);
});
process.env.NODE_ENV !== "production" && (Jct.propTypes = E);
const $ct = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, g4e || (g4e = /* @__PURE__ */ h.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), m4e || (m4e = /* @__PURE__ */ h.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), A4e || (A4e = /* @__PURE__ */ h.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), w4e || (w4e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), v4e || (v4e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), n);
});
process.env.NODE_ENV !== "production" && ($ct.propTypes = E);
const eht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, b4e || (b4e = /* @__PURE__ */ h.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), y4e || (y4e = /* @__PURE__ */ h.createElement("path", {
    d: "M19 12H23V14H19zM9.3325 25.2168a7.0007 7.0007 0 010-10.4341l1.334 1.49a5 5 0 000 7.4537z"
  })), C4e || (C4e = /* @__PURE__ */ h.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (eht.propTypes = E);
const tht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, E4e || (E4e = /* @__PURE__ */ h.createElement("path", {
    d: "M24,10a6,6,0,0,0-4.46,10H12.46A6,6,0,1,0,8,22H24a6,6,0,0,0,0-12ZM4,16a4,4,0,1,1,4,4A4,4,0,0,1,4,16Zm20,4a4,4,0,1,1,4-4A4,4,0,0,1,24,20Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (tht.propTypes = E);
const nht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _4e || (_4e = /* @__PURE__ */ h.createElement("path", {
    d: "M17 21H10V14h7zm-5-2h3V16H12zM17 30H10V23h7zm-5-2h3V25H12zM26 21H19V14h7zm-5-2h3V16H21zM26 30H19V23h7zm-5-2h3V25H21z"
  })), x4e || (x4e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (nht.propTypes = E);
const iht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, S4e || (S4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30zM6 20h6a1.17 1.17 0 01.79.3L19 26.57V5.43L12.79 11.7A1.17 1.17 0 0112 12H6z"
  })), n);
});
process.env.NODE_ENV !== "production" && (iht.propTypes = E);
const rht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, M4e || (M4e = /* @__PURE__ */ h.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (rht.propTypes = E);
const sht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, D4e || (D4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.1 10.66L23.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM20 30a1 1 0 01-.71-.3L11.67 22H5a1 1 0 01-1-1H4V11a1 1 0 011-1h6.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0121 3V29A1 1 0 0120 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (sht.propTypes = E);
const oht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, L4e || (L4e = /* @__PURE__ */ h.createElement("path", {
    d: "M22 15H32V17H22zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (oht.propTypes = E);
const aht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, k4e || (k4e = /* @__PURE__ */ h.createElement("path", {
    d: "M25.707,17.293l-5-5A1,1,0,0,0,20,12H14a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V18A1,1,0,0,0,25.707,17.293ZM23.5857,18H20V14.4141ZM14,28V14h4v4a2,2,0,0,0,2,2h4v8Z"
  })), N4e || (N4e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,27H4a2.0023,2.0023,0,0,1-2-2V5A2.0023,2.0023,0,0,1,4,3h7.5857A1.9865,1.9865,0,0,1,13,3.5859L16.4143,7H28a2.0023,2.0023,0,0,1,2,2v8H28V9H15.5857l-4-4H4V25H8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (aht.propTypes = E);
const lht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, T4e || (T4e = /* @__PURE__ */ h.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6a1.17 1.17 0 01.79.3L17 26.57V5.43L10.79 11.7A1.17 1.17 0 0110 12H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (lht.propTypes = E);
const cht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, I4e || (I4e = /* @__PURE__ */ h.createElement("path", {
    d: "M31 12.41L29.59 11 26 14.59 22.41 11 21 12.41 24.59 16 21 19.59 22.41 21 26 17.41 29.59 21 31 19.59 27.41 16 31 12.41zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (cht.propTypes = E);
const hht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, O4e || (O4e = /* @__PURE__ */ h.createElement("path", {
    d: "M23,24a2.98,2.98,0,0,0-2.0376.8115l-4.0037-2.4023a2.0478,2.0478,0,0,0,0-.8184l4.0037-2.4023a3.2463,3.2463,0,1,0-.9211-1.7793l-4.0037,2.4023a3,3,0,1,0,0,4.377l4.0037,2.4023A2.9729,2.9729,0,0,0,20,27a3,3,0,1,0,3-3Zm0-8a1,1,0,1,1-1,1A1.0008,1.0008,0,0,1,23,16Zm-9,7a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,14,23Zm9,5a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,23,28Z"
  })), R4e || (R4e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,28H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4h7.5857A1.9865,1.9865,0,0,1,13,4.5859L16.4143,8H28a2.0023,2.0023,0,0,1,2,2v8H28V10H15.5857l-4-4H4V26H8Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (hht.propTypes = E);
const dht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, V4e || (V4e = /* @__PURE__ */ h.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), H4e || (H4e = /* @__PURE__ */ h.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30zM4 20h6.08a1 1 0 01.71.3L17 26.57V5.43L10.79 11.7a1 1 0 01-.71.3H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (dht.propTypes = E);
const uht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, B4e || (B4e = /* @__PURE__ */ h.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30zM4 20h6a1.2008 1.2008 0 01.7939.2969L17 26.5684V5.4316l-6.2061 6.2715A1.2013 1.2013 0 0110 12H4z"
  })), n);
});
process.env.NODE_ENV !== "production" && (uht.propTypes = E);
const fht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, P4e || (P4e = /* @__PURE__ */ h.createElement("path", {
    d: "M27.16,8.08,25.63,9.37a10,10,0,0,1-.29,13.23L26.81,24a12,12,0,0,0,.35-15.88Z"
  })), F4e || (F4e = /* @__PURE__ */ h.createElement("path", {
    d: "M21.58 12a6 6 0 01-.18 7.94l1.47 1.36a8 8 0 00.23-10.59zM18 30a1 1 0 01-.71-.3L9.67 22H3a1 1 0 01-1-1H2V11a1 1 0 011-1H9.67l7.62-7.7a1 1 0 011.41 0A1 1 0 0119 3V29A1 1 0 0118 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (fht.propTypes = E);
const pht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, z4e || (z4e = /* @__PURE__ */ h.createElement("path", {
    d: "M32 15L28 15 28 11 26 11 26 15 22 15 22 17 26 17 26 21 28 21 28 17 32 17 32 15zM18 30a.997.997 0 01-.7109-.2969L9.666 22H3a.9993.9993 0 01-1-.9988V11a.9993.9993 0 01.9988-1H9.666l7.623-7.7031A1 1 0 0119 3V29A1.0007 1.0007 0 0118 30z"
  })), n);
});
process.env.NODE_ENV !== "production" && (pht.propTypes = E);
const ght = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, W4e || (W4e = /* @__PURE__ */ h.createElement("path", {
    d: "M14 23H12V9h6a2 2 0 012 2v5a2 2 0 01-2 2H14zm0-7h4V11H14zM28 19L24.32 9 22 9 22 23 24 23 24 13 27.68 23 30 23 30 9 28 9 28 19zM8 9L6 22 4 9 2 9 4.52 23 7.48 23 10 9 8 9z"
  })), n);
});
process.env.NODE_ENV !== "production" && (ght.propTypes = E);
const mht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, j4e || (j4e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,7a1.9919,1.9919,0,0,0-1.7227,1H22A6,6,0,0,0,10,8H5.7227a2,2,0,1,0,0,2H10v4H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H22V10h4.2773A1.9966,1.9966,0,1,0,28,7ZM12,8a4,4,0,0,1,8,0v6H12V10h5V8Zm12,8V28H8V16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (mht.propTypes = E);
const Aht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Z4e || (Z4e = /* @__PURE__ */ h.createElement("path", {
    d: "M30,15A6,6,0,1,0,20,19.46V29l4-1.8838L28,29V19.46A5.98,5.98,0,0,0,30,15ZM26,25.8477l-2-.9415-2,.9415V20.65a5.8877,5.8877,0,0,0,4,0ZM24,19a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,19Z"
  })), U4e || (U4e = /* @__PURE__ */ h.createElement("path", {
    d: "M14,2A6.0066,6.0066,0,0,0,8,8v6H6a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H17V28H6V16h9V14H10V8a4,4,0,0,1,7.92-.8008l1.96-.3984A6.0167,6.0167,0,0,0,14,2Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Aht.propTypes = E);
const wht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, q4e || (q4e = /* @__PURE__ */ h.createElement("path", {
    d: "M22 17H24V19H22z"
  })), G4e || (G4e = /* @__PURE__ */ h.createElement("path", {
    d: "M28,8H4V5H26V3H4A2,2,0,0,0,2,5V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10A2,2,0,0,0,28,8ZM4,26V10H28v3H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h8v3ZM28,15v6H20V15Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (wht.propTypes = E);
const gI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, Q4e || (Q4e = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
  })), K4e || (K4e = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5 4H8.5V9H7.5zM8 10.2c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.2 8 10.2z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Y4e || (Y4e = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  })), X4e || (X4e = /* @__PURE__ */ h.createElement("path", {
    d: "M15 8H17V19H15zM16 22a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 22z"
  })), n);
});
process.env.NODE_ENV !== "production" && (gI.propTypes = E);
const vht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, J4e || (J4e = /* @__PURE__ */ h.createElement("path", {
    d: "M14.5,14h-13c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.3,0-0.5l6.5-12C7.7,1,8,0.9,8.2,1.1c0.1,0,0.2,0.1,0.2,0.2l6.5,12 c0.1,0.2,0.1,0.3,0,0.5C14.9,13.9,14.7,14,14.5,14z M2.3,13h11.3L8,2.5L2.3,13z"
  })), $4e || ($4e = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5 6H8.5V9.5H7.5zM8 10.8c-.4 0-.8.3-.8.8s.3.8.8.8c.4 0 .8-.3.8-.8S8.4 10.8 8 10.8z"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, ewe || (ewe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 23a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 23zM15 12H17V21H15z"
  })), twe || (twe = /* @__PURE__ */ h.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (vht.propTypes = E);
const bht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nwe || (nwe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Zm-1.125-5h2.25V12h-2.25Z",
    "data-icon-path": "inner-path"
  })), iwe || (iwe = /* @__PURE__ */ h.createElement("path", {
    d: "M16.002,6.1714h-.004L4.6487,27.9966,4.6506,28H27.3494l.0019-.0034ZM14.875,12h2.25v9h-2.25ZM16,26a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,26Z"
  })), rwe || (rwe = /* @__PURE__ */ h.createElement("path", {
    d: "M29,30H3a1,1,0,0,1-.8872-1.4614l13-25a1,1,0,0,1,1.7744,0l13,25A1,1,0,0,1,29,30ZM4.6507,28H27.3493l.002-.0033L16.002,6.1714h-.004L4.6487,27.9967Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (bht.propTypes = E);
const yht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, swe || (swe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 17a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 17zM15 6H17V15H15z"
  })), owe || (owe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (yht.propTypes = E);
const Cht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, awe || (awe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Zm-1.125-5h2.25V6h-2.25Z",
    "data-icon-path": "inner-path"
  })), lwe || (lwe = /* @__PURE__ */ h.createElement("path", {
    d: "M27.3494,4H4.6506l-.0019.0034L15.998,25.8286h.004L27.3513,4.0034ZM14.875,6h2.25v9h-2.25ZM16,20a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,20Z"
  })), cwe || (cwe = /* @__PURE__ */ h.createElement("path", {
    d: "M29.855,2.481a1.001,1.001,0,0,1,.0322.98l-13,25a1,1,0,0,1-1.7744,0l-13-25A1,1,0,0,1,3,2H29A1.0007,1.0007,0,0,1,29.855,2.481ZM4.6487,4.0033,15.998,25.8286h.004L27.3513,4.0033,27.3493,4H4.6507Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Cht.propTypes = E);
const Eht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, hwe || (hwe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 20c-.8284 0-1.5.6716-1.5 1.5s.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5-.6716-1.5-1.5-1.5h0zM15 9H17V18H15z"
  })), dwe || (dwe = /* @__PURE__ */ h.createElement("path", {
    d: "m16,30c-.5335,0-1.0672-.2031-1.4732-.6094L2.6094,17.4732c-.8126-.8123-.8126-2.1342,0-2.9465L14.5268,2.6094c.8121-.8126,2.1344-.8126,2.9465,0l11.9173,11.9173c.8126.8123.8126,2.1342,0,2.9465l-11.9173,11.9173c-.406.4063-.9398.6094-1.4732.6094Zm0-26.0008c-.0215,0-.0427.0083-.0591.0244L4.0236,15.9409c-.0325.0327-.0325.0855,0,.1182l11.9173,11.9173c.0327.0322.0855.0322.1182,0l11.9173-11.9173c.0325-.0327.0325-.0855,0-.1182l-11.9173-11.9173c-.0164-.0161-.0376-.0244-.0591-.0244Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Eht.propTypes = E);
const mI = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return i === 16 || i === "16" || i === "16px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...s
  }, uwe || (uwe = /* @__PURE__ */ h.createElement("path", {
    d: "M8,1C4.2,1,1,4.2,1,8s3.2,7,7,7s7-3.1,7-7S11.9,1,8,1z M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2 c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z"
  })), fwe || (fwe = /* @__PURE__ */ h.createElement("path", {
    d: "M7.5,4h1v5h-1C7.5,9,7.5,4,7.5,4z M8,12.2c-0.4,0-0.8-0.4-0.8-0.8s0.3-0.8,0.8-0.8 c0.4,0,0.8,0.4,0.8,0.8S8.4,12.2,8,12.2z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 20 || i === "20" || i === "20px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ...s
  }, pwe || (pwe = /* @__PURE__ */ h.createElement("path", {
    d: "M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S10.6,16,10,16z"
  })), gwe || (gwe = /* @__PURE__ */ h.createElement("path", {
    d: "M9.2,5h1.5v7H9.2V5z M10,16c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,16,10,16z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : i === 24 || i === "24" || i === "24px" ? /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ...s
  }, mwe || (mwe = /* @__PURE__ */ h.createElement("path", {
    d: "M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11C23,5.9,18.1,1,12,1z M11.1,6h1.8v8h-1.8V6z M12,19.2 c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2S12.7,19.2,12,19.2z"
  })), Awe || (Awe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M13.2,18c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2S13.2,17.3,13.2,18z M12.9,6 h-1.8v8h1.8V6z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n) : /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, wwe || (wwe = /* @__PURE__ */ h.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25 c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z"
  })), vwe || (vwe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M17.5,23.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22 C16.8,22,17.5,22.7,17.5,23.5z M17.1,8h-2.2v11h2.2V8z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), n);
});
process.env.NODE_ENV !== "production" && (mI.propTypes = E);
const _ht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, bwe || (bwe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 21a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 21zM15 8H17V18H15z"
  })), ywe || (ywe = /* @__PURE__ */ h.createElement("path", {
    d: "M23,29H9a1,1,0,0,1-.8638-.4961l-7-12a1,1,0,0,1,0-1.0078l7-12A1,1,0,0,1,9,3H23a1,1,0,0,1,.8638.4961l7,12a1,1,0,0,1,0,1.0078l-7,12A1,1,0,0,1,23,29ZM9.5742,27H22.4258l6.4165-11L22.4258,5H9.5742L3.1577,16Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (_ht.propTypes = E);
const xht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Cwe || (Cwe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z",
    "data-icon-path": "inner-path"
  })), Ewe || (Ewe = /* @__PURE__ */ h.createElement("path", {
    d: "M30.8508,15.4487,23.8867,3.5322A1.0687,1.0687,0,0,0,22.9643,3H9.0357a1.0687,1.0687,0,0,0-.9224.5322L1.1492,15.4487a1.0933,1.0933,0,0,0,0,1.1026L8.1133,28.4678A1.0687,1.0687,0,0,0,9.0357,29H22.9643a1.0687,1.0687,0,0,0,.9224-.5322l6.9641-11.9165A1.0933,1.0933,0,0,0,30.8508,15.4487ZM14.875,8h2.25V19h-2.25ZM16,25a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,25Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (xht.propTypes = E);
const Sht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, _we || (_we = /* @__PURE__ */ h.createElement("path", {
    d: "m29,23h-4v-2h2.3821l-7.8821-15.7639-1.1055,2.2112-1.7891-.8945,2-4c.1694-.3387.532-.5527.8945-.5527s.7251.214.8945.5527l9.5,19c.1548.3101.1384.6782-.0439.973-.1821.2948-.5039.4742-.8506.4742Z"
  })), xwe || (xwe = /* @__PURE__ */ h.createElement("circle", {
    cx: "14",
    cy: "25",
    r: "1.25"
  })), Swe || (Swe = /* @__PURE__ */ h.createElement("path", {
    d: "M13 15H15V22H13z"
  })), Mwe || (Mwe = /* @__PURE__ */ h.createElement("path", {
    d: "m25,30H3c-.3499,0-.6743-.1829-.8555-.4823s-.1926-.6718-.0303-.9817L13.1143,7.536c.1726-.3296.5292-.536.8857-.536s.7131.2064.8857.536l11,21c.1624.3099.1509.6823-.0303.9817s-.5056.4823-.8555.4823Zm-20.3474-2h18.6948L14,10.1552,4.6526,28Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Sht.propTypes = E);
const Mht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Dwe || (Dwe = /* @__PURE__ */ h.createElement("path", {
    d: "M18 20H30V22H18zM18 24H30V26H18zM18 28H30V30H18zM14 18a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0014 18zM13 7H15V16H13z"
  })), Lwe || (Lwe = /* @__PURE__ */ h.createElement("path", {
    d: "M14,4A10.0111,10.0111,0,0,1,24,14h2A12,12,0,1,0,14,26V24A10,10,0,0,1,14,4Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Mht.propTypes = E);
const Dht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, kwe || (kwe = /* @__PURE__ */ h.createElement("path", {
    d: "M16 20a1.5 1.5 0 101.5 1.5A1.5 1.5 0 0016 20zM15 9H17V18H15z"
  })), Nwe || (Nwe = /* @__PURE__ */ h.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26.0012L26,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Dht.propTypes = E);
const Lht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Twe || (Twe = /* @__PURE__ */ h.createElement("path", {
    d: "M26.0022,4H5.998A1.998,1.998,0,0,0,4,5.998V26.002A1.998,1.998,0,0,0,5.998,28H26.0022A1.9979,1.9979,0,0,0,28,26.002V5.998A1.9979,1.9979,0,0,0,26.0022,4ZM14.8752,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z"
  })), Iwe || (Iwe = /* @__PURE__ */ h.createElement("path", {
    fill: "none",
    d: "M14.8751,8h2.25V18h-2.25ZM16,24a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,24Z",
    "data-icon-path": "inner-path"
  })), n);
});
process.env.NODE_ENV !== "production" && (Lht.propTypes = E);
const kht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Owe || (Owe = /* @__PURE__ */ h.createElement("path", {
    d: "M22 8H21V2H19V8H13V2H11V8H10a2 2 0 00-2 2V22a2 2 0 002 2h1v6h2V24h6v6h2V24h1a2 2 0 002-2V10A2 2 0 0022 8zM10 22V10H22V22zM25 14H27V18H25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (kht.propTypes = E);
const Nht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (eg.Watson || (eg.Watson = !0, console.warn("Icon represents the old avatar for the Watson brand, which is retired since the watsonx brand launch. Replaced by the icon watsonx. As a result, the Watson component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Rwe || (Rwe = /* @__PURE__ */ h.createElement("path", {
    d: "M21.74 9.49h0A11.41 11.41 0 0016 8h0a.76.76 0 100 1.51 10.15 10.15 0 011.91.21c-2.26 1.08-4.76 3.58-6.73 7a22.48 22.48 0 00-2 4.44A9.58 9.58 0 017 17.22a3.43 3.43 0 01.28-2.66v0h0c.79-1.37 2.44-2.15 4.63-2.2a.76.76 0 00.74-.78.75.75 0 00-.78-.74C9.19 10.88 7.1 11.92 6 13.74H6v0s0 0 0 0a4.84 4.84 0 00-.44 3.79 12 12 0 003.2 5.22A11.36 11.36 0 008.52 26a10 10 0 01-2-3.48A.75.75 0 005.57 22a.76.76 0 00-.49 1 11.45 11.45 0 005.18 6.38h0A11.42 11.42 0 0016 30.92a11.74 11.74 0 003-.39 11.48 11.48 0 002.77-21zM18.58 29.06a9.9 9.9 0 01-7.56-1h0c-.86-.49-1.21-2-.94-4a18.85 18.85 0 002.48 1.72 13.92 13.92 0 006.93 2 11 11 0 002.42-.28A9.78 9.78 0 0118.58 29.06zm6.06-4.66c-2 2-6.66 2.74-11.32.05a17.36 17.36 0 01-2.89-2.12 21.08 21.08 0 012.08-4.91c2.94-5.08 6.83-7.57 8.47-6.62h0A10 10 0 0124.64 24.4zM4.16 11.72L1.14 10a.76.76 0 10-.76 1.31L3.4 13a.86.86 0 00.38.1.77.77 0 00.66-.38A.76.76 0 004.16 11.72zM8.29 7.59A.74.74 0 008.94 8a.75.75 0 00.38-.1.76.76 0 00.28-1l-1.74-3a.76.76 0 00-1-.27.75.75 0 00-.28 1zM16 6.08a.76.76 0 00.76-.76V1.83a.76.76 0 00-1.52 0V5.32A.76.76 0 0016 6.08zM22.68 7.87a.75.75 0 001-.28l1.75-3a.75.75 0 00-.28-1 .76.76 0 00-1 .27l-1.74 3A.76.76 0 0022.68 7.87zM31.9 10.25a.76.76 0 00-1-.27l-3 1.74a.76.76 0 00-.28 1 .77.77 0 00.66.38.86.86 0 00.38-.1l3-1.75A.76.76 0 0031.9 10.25z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Nht.propTypes = E);
const Tht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return process.env.NODE_ENV !== "production" && (eg.WatsonMachineLearning || (eg.WatsonMachineLearning = !0, console.warn("Icon design is defunct, replaced with the existing icon ibm-watson--machine-learning. As a result, the WatsonMachineLearning component will be removed in the next major version of @carbon/icons-react."))), /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Vwe || (Vwe = /* @__PURE__ */ h.createElement("path", {
    d: "M22 26H20V17.76l-3.23 3.88a1 1 0 01-1.54 0L12 17.76V26H10V15a1 1 0 01.66-.94 1 1 0 011.11.3L16 19.44l4.23-5.08a1 1 0 011.11-.3A1 1 0 0122 15zM4.16 14.65l-3-1.75a.76.76 0 10-.76 1.32L3.4 16a.76.76 0 10.76-1.31zM8.29 10.52a.73.73 0 001 .27.75.75 0 00.28-1l-1.74-3a.76.76 0 10-1.32.76zM16 9a.76.76 0 00.76-.76V4.76a.76.76 0 10-1.52 0V8.25A.76.76 0 0016 9zM22.68 10.79a.75.75 0 00.37.11.76.76 0 00.66-.38l1.75-3a.76.76 0 00-1.32-.76l-1.74 3A.75.75 0 0022.68 10.79zM31.9 13.18a.76.76 0 00-1-.28l-3 1.75A.76.76 0 0028.6 16l3-1.74A.77.77 0 0031.9 13.18z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Tht.propTypes = E);
const Iht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Hwe || (Hwe = /* @__PURE__ */ h.createElement("path", {
    strokeWidth: "0",
    d: "m29.312,22.9189c1.1042-2.1201,1.688-4.5127,1.688-6.9189C31,7.729,24.271,1,16,1c-3.3738,0-6.5815,1.1191-9.2046,3.1665-.2441-.106-.5125-.1665-.7954-.1665-1.1045,0-2,.8955-2,2s.8955,2,2,2,2-.8955,2-2c0-.0762-.0142-.1489-.0225-.2227,2.2812-1.7964,5.0793-2.7773,8.0225-2.7773.9727,0,1.9172.1157,2.8293.3193-3.3938.9258-5.8994,4.0273-5.8994,7.7109,0,.7891.1167,1.5503.332,2.27-.6985-.2021-1.4285-.3306-2.1919-.3306-3.7039,0-6.8191,2.5342-7.7256,5.957-.218-.9424-.3445-1.9189-.3445-2.9268,0-2.1162.4919-4.1328,1.4619-5.9951l-1.7739-.9238c-1.1042,2.1201-1.688,4.5127-1.688,6.9189,0,8.271,6.729,15,15,15,3.3738,0,6.5815-1.1191,9.2046-3.1665.2441.106.5125.1665.7954.1665,1.1045,0,2-.8955,2-2s-.8955-2-2-2-2,.8955-2,2c0,.0762.0142.1489.0225.2231-1.0796.8496-2.2776,1.5098-3.5493,1.9771.3315-.6641.5269-1.4072.5269-2.2002,0-1.6304-.7959-3.0669-2.0068-3.9805.0457-.3472.0769-.6978.0769-1.0498,0-.7856-.1257-1.54-.3381-2.2573.6995.2012,1.4346.3179,2.198.3179,3.7039,0,6.8191-2.5342,7.7256-5.957.218.9424.3445,1.9189.3445,2.9268,0,2.1162-.4919,4.1328-1.4619,5.9951l1.7739.9238Zm-17.7935,5.2646c-1.8389-.6807-3.49-1.7529-4.8325-3.1338-1.0366-1.1143-1.616-2.5527-1.616-4.0801,0-3.3081,2.6917-6,6-6s6,2.6919,6,6c0,.0498-.0125.0977-.0134.1475-.3413-.0737-.6936-.1172-1.0566-.1172-2.7571,0-5,2.2432-5,5,0,.7861.1924,1.5234.5186,2.1836Zm7.4814-2.1836c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3,1.3457-3,3-3,3,1.3457,3,3Zm1.9299-8.9697c-3.3083,0-6-2.6919-6-6s2.6917-6,6-6c1.4294,0,2.7422.5039,3.7742,1.3418.3027.2739.5918.561.8677.8618.8479,1.0352,1.3582,2.3569,1.3582,3.7964,0,3.3081-2.6917,6-6,6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Iht.propTypes = E);
const Oht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Bwe || (Bwe = /* @__PURE__ */ h.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-4.2617,0-8-3.9722-8-8.5,0-4.687,3.813-8.5,8.5-8.5h.5v-2h-.5c-5.7896,0-10.5,4.7104-10.5,10.5,0,1.8839.5304,3.6896,1.4371,5.2565-2.7133-2.3843-4.4371-5.869-4.4371-9.7565,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), Pwe || (Pwe = /* @__PURE__ */ h.createElement("path", {
    d: "M11 20H13V22H11z",
    transform: "rotate(90 12 21)"
  })), Fwe || (Fwe = /* @__PURE__ */ h.createElement("path", {
    d: "M19 10H21V12H19z",
    transform: "rotate(90 20 11)"
  })), zwe || (zwe = /* @__PURE__ */ h.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,4.2617,0,8,3.9722,8,8.5,0,4.687-3.813,8.5-8.5,8.5h-.5v2h.5c5.7896,0,10.5-4.7104,10.5-10.5,0-1.8853-.5322-3.6917-1.4401-5.2593,2.715,2.3843,4.4401,5.8704,4.4401,9.7593,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Oht.propTypes = E);
const Rht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Wwe || (Wwe = /* @__PURE__ */ h.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-2.7746,0-5.3432-.881-7.4566-2.3676.2576.0261.517.0444.7798.0444,4.2329,0,7.6768-3.4438,7.6768-7.6768h-2c0,3.1304-2.5464,5.6768-5.6768,5.6768-2.2111,0-4.1977-1.2816-5.1318-3.2725-.1365-.2972-.2595-.6007-.3738-.9094.6602.322,1.3998.5051,2.1824.5051,2.7568,0,5-2.2432,5-5v-2h-2v2c0,1.6543-1.3457,3-3,3s-3-1.3457-3-3c0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), jwe || (jwe = /* @__PURE__ */ h.createElement("path", {
    d: "M21 21H23V23H21z",
    transform: "rotate(90 22 22)"
  })), Zwe || (Zwe = /* @__PURE__ */ h.createElement("path", {
    d: "M15 15H17V17H15z",
    transform: "rotate(90 16 16)"
  })), Uwe || (Uwe = /* @__PURE__ */ h.createElement("path", {
    d: "M9 9H11V11H9z",
    transform: "rotate(-90 10 10)"
  })), qwe || (qwe = /* @__PURE__ */ h.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,2.7708,0,5.3363.8784,7.4481,2.3613-.249-.0242-.5005-.038-.7547-.038-4.2329,0-7.6768,3.4438-7.6768,7.6768h2c0-3.1304,2.5464-5.6768,5.6768-5.6768,2.0554,0,3.9068,1.0953,4.9186,2.8651.2153.4283.4053.8701.5729,1.3237-.6615-.3234-1.4005-.5121-2.1849-.5121-2.7568,0-5,2.2432-5,5v2h2v-2c0-1.6543,1.3457-3,3-3s3,1.3457,3,3c0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Rht.propTypes = E);
const Vht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Gwe || (Gwe = /* @__PURE__ */ h.createElement("path", {
    d: "m26,24c-1.1046,0-2,.8954-2,2,0,.0764.0142.1488.0225.2229-2.2808,1.7963-5.0792,2.7771-8.0225,2.7771-7.1685,0-13-5.8315-13-13,0-2.1152.4917-4.1328,1.4619-5.9956l-1.7744-.9238c-1.104,2.1211-1.6875,4.5137-1.6875,6.9194,0,8.271,6.729,15,15,15,3.3744,0,6.5818-1.1193,9.2048-3.1662.244.106.5123.1662.7952.1662,1.1046,0,2-.8954,2-2s-.8954-2-2-2Z"
  })), Qwe || (Qwe = /* @__PURE__ */ h.createElement("path", {
    d: "M11 23H13V25H11z",
    transform: "rotate(90 12 24)"
  })), Kwe || (Kwe = /* @__PURE__ */ h.createElement("path", {
    d: "M11 9H13V11H11z",
    transform: "rotate(90 12 10)"
  })), Ywe || (Ywe = /* @__PURE__ */ h.createElement("path", {
    d: "M11 16H13V18H11z",
    transform: "rotate(90 12 17)"
  })), Xwe || (Xwe = /* @__PURE__ */ h.createElement("path", {
    d: "m16,1c-3.3744,0-6.5818,1.1193-9.2048,3.1662-.244-.106-.5123-.1662-.7952-.1662-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2c0-.0764-.0142-.1488-.0225-.2229,2.2808-1.7963,5.0792-2.7771,8.0225-2.7771,1.6543,0,3,1.3457,3,3s-1.3457,3-3,3h-1v2h1c2.7568,0,5-2.2432,5-5,0-.2399-.0203-.4748-.0531-.7057.9663,1.1348,1.5531,2.6021,1.5531,4.2057,0,3.584-2.916,6.5-6.5,6.5h-1v2h1c4.687,0,8.5-3.813,8.5-8.5,0-.7654-.1111-1.5036-.3017-2.2096,1.1321,1.6206,1.8017,3.587,1.8017,5.7096,0,5.5142-4.4858,10-10,10h-1v2h1c6.6167,0,12-5.3833,12-12,0-.8995-.1058-1.774-.2944-2.6176.8207,1.7031,1.2944,3.6038,1.2944,5.6176,0,2.1152-.4917,4.1328-1.4619,5.9956l1.7744.9238c1.104-2.1211,1.6875-4.5137,1.6875-6.9194C31,7.729,24.271,1,16,1Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Vht.propTypes = E);
const Hht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, Jwe || (Jwe = /* @__PURE__ */ h.createElement("path", {
    d: "M22,30H17a7.0078,7.0078,0,0,1-7-7,6.6832,6.6832,0,0,1,2.0244-4.6967A6.7126,6.7126,0,0,0,10.0093,18C5.0425,18.0466,4,24.5513,4,30H2C2,18.4907,6.3452,16.0342,9.9907,16a10.0962,10.0962,0,0,1,4.4785,1.117,1,1,0,0,1,.0616,1.73A4.8773,4.8773,0,0,0,17,28h5Z"
  })), $we || ($we = /* @__PURE__ */ h.createElement("path", {
    d: "M18,24V22a8,8,0,1,0-8-8H8A10,10,0,1,1,18,24Z"
  })), eve || (eve = /* @__PURE__ */ h.createElement("circle", {
    cx: "18",
    cy: "8",
    r: "1"
  })), tve || (tve = /* @__PURE__ */ h.createElement("path", {
    d: "M23,17.5859l-2.3-2.3007A2.9665,2.9665,0,0,0,21,14a3.0033,3.0033,0,0,0-3-3,2.9609,2.9609,0,0,0-1.2854.3008L14.4141,9,13,10.4141l2.3,2.3007A2.9665,2.9665,0,0,0,15,14a3.0033,3.0033,0,0,0,3,3,2.9609,2.9609,0,0,0,1.2854-.3008L21.5859,19ZM17,14a1,1,0,1,1,1,1A1.0009,1.0009,0,0,1,17,14Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Hht.propTypes = E);
const Bht = /* @__PURE__ */ h.forwardRef(function(e, t) {
  let {
    children: n,
    size: i = 16,
    ...s
  } = e;
  return /* @__PURE__ */ h.createElement(b, {
    width: i,
    height: i,
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...s
  }, nve || (nve = /* @__PURE__ */ h.createElement("path", {
    d: "M24 2H30V4H24zM24 8H28V10H24zM24 14H30V16H24zM24 20H28V22H24z"
  })), ive || (ive = /* @__PURE__ */ h.createElement("path", {
    d: "M30,28H24a10.0349,10.0349,0,0,1-6.9268-17.2622A11.9629,11.9629,0,0,0,12.9937,10a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,16.4348,4,21.34,4,28H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,8h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,26h6Z"
  })), n);
});
process.env.NODE_ENV !== "production" && (Bht.propTypes = E);
const Pht = q(mI)`
  fill: #da1e28;
`, Fht = q(cI)`
  fill: #525252;
`, zht = q(pI)`
  fill: #24a148;
`, Wht = {
  ACTIVATED: zht,
  COMPLETED: Fht,
  INCIDENT: Pht,
  CANCELED: Vd,
  TERMINATED: Vd,
  TAKEN: null
}, AI = ({ state: r, ...e }) => {
  const t = Wht[r] || Vd;
  return /* @__PURE__ */ x.jsx(t, { ...e });
}, bMe = (r) => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    }).format(new Date(r));
  } catch {
    return r;
  }
}, oE = (r = "white") => `'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon fill="${r}" points="12.5 16.45 7.55 11.5 8.964 10.086 12.5 13.621 16.036 10.086 17.45 11.5"/></svg>'`, jht = q.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: inherit;
  font-size: 14px;
  padding: 0 21px;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: inherit;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
  border-radius: 0;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;

  .cds--btn::-moz-focus-inner {
    padding: 0;
    border: 0;
  }

  &[disabled] {
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  .loader {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  ${({ $variant: r, $isDropdown: e }) => {
  if (r === "primary")
    return `
        background-color: var(--cds-blue-60, #0f62fe);
        ${e ? `background-image: url(${oE()}); padding-right: 40px;` : ""};
        color: white;
        font-weight: bold;

        &:not([disabled]):hover {
          background-color: var(--cds-blue-70, #0043ce);
        }

        &:not([disabled]):focus {
          border-color: var(--cds-blue-60);
          box-shadow: inset 0 0 0 1px var(--cds-blue-60, #0f62fe),inset 0 0 0 2px white
        }

        &:not([disabled]):active {
          background-color: var(--cds-blue-80, #002d9c)
        }

        &[disabled] {
          background-color: var(--cds-blue-40, #78a9ff);
        }
      `;
  if (r === "danger-primary")
    return `
        border-size: 1px;
        border-color: var(--cm-color-button-red3, #ff0a0a);
        background-color: var(--cm-color-red-base, #ff3d3d);
        color: white;
        font-weight: bold;
      `;
  if (r === "secondary")
    return `
        background-color: var(--silver-base-97);
        ${e ? `background-image: url(${oE(
      "hsl(0,0%,33%)"
    )}); padding-right: 40px;` : ""};
        color: var(--grey-darken-30);
        border: 1px solid var(--silver-darken-80);
        font-weight: bold;

        &:not([disabled]):hover, &:not([disabled]):focus {
          background-color: var(--silver-darken-94);
          border-color: var(--silver-darken-80);
        }

        &:not([disabled]):active {
          background-color: var(--silver-darken-87);
          border-color: var(--silver-darken-80);
        }

        &[disabled] {
          background-color: var(--silver-base-97);
          border-color: var(--silver-darken-87);
          color: var(--grey-lighten-56);
        }
      `;
  if (r === "text")
    return `
        font-weight: 500;
        background-color: transparent;
        ${e ? `background-image: url(${oE("hsl(0,0%,33%)")});` : ""};
        border: none;
        padding: ${e ? "0 35px 0 0" : "0"};
        margin: 0;
      `;
}}
  ${({ $size: r }) => r == "small" ? `
        height: 30px;
        border-radius: 2px;
        line-height: 26px;
        font-size: 13px;
        ` : `
      height: 36px;
      line-height: 32px;
      border-radius: 3px;
    `}
`, Zht = q.div`
  display: flex;
  align-items: center;

  &.is-loading {
    opacity: 0.35;
  }
`, ji = r1(
  ({
    children: r,
    component: e = "button",
    dropdown: t = !1,
    disabled: n = !1,
    loading: i = !1,
    lightLoader: s = !1,
    loaderSize: o = "normal",
    size: a = "normal",
    variant: l = "primary",
    ...c
  }, d) => /* @__PURE__ */ x.jsx(
    jht,
    {
      as: e,
      ref: d,
      $isDropdown: t,
      disabled: i || n,
      $size: a,
      $variant: l,
      ...c,
      children: i ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(Ght, { className: "loader", light: s, size: o }),
        /* @__PURE__ */ x.jsx(Zht, { className: "is-loading", children: r })
      ] }) : r
    }
  )
), Uht = zg`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`, qht = q.span`
  display: inline-block;
  width: ${({ size: r = "small" }) => r == "small" ? "20px" : "40px"};
  height: ${({ size: r = "small" }) => r == "small" ? "20px" : "40px"};
  border-radius: 50%;
  border: ${({ size: r = "small" }) => r == "small" ? "2px" : "4px"} solid
    ${({ light: r = !1 }) => r ? "white" : "var(--cds-blue-60)"};
  border-bottom-color: transparent;
  animation: ${Uht} 1.2s linear infinite;
`, Ght = qht, Qht = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-clock", viewBox: "0 0 16 16", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" }), /* @__PURE__ */ be.createElement("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" })), Kht = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M15 4.5L13.5 3L9 7.5L4.5 3L3 4.5L7.5 9L3 13.5L4.5 15L9 10.5L13.5 15L15 13.5L10.5 9L15 4.5Z", fill: "currentColor" })), Yht = (r) => /* @__PURE__ */ be.createElement("svg", { width: 2, height: 10, viewBox: "0 0 2 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z", fill: "white" }), /* @__PURE__ */ be.createElement("path", { d: "M1 6C1.55228 6 2 5.55228 2 5C2 4.44772 1.55228 4 1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6Z", fill: "white" }), /* @__PURE__ */ be.createElement("path", { d: "M1 10C1.55228 10 2 9.55228 2 9C2 8.44771 1.55228 8 1 8C0.447715 8 0 8.44771 0 9C0 9.55228 0.447715 10 1 10Z", fill: "white" })), D7 = (r) => /* @__PURE__ */ be.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M14.7685 5.87999L13.12 4.23149C12.9713 4.08325 12.7699 4 12.56 4C12.3501 4 12.1487 4.08325 12 4.23149L5 11.2337V14H7.7663L14.7685 6.99999C14.9167 6.85132 15 6.64994 15 6.43999C15 6.23004 14.9167 6.02866 14.7685 5.87999ZM7.3521 13H6V11.6479L10.7205 6.92744L12.0725 8.27954L7.3521 13ZM12.7795 7.57249L11.4275 6.22044L12.5611 5.08684L13.9132 6.43894L12.7795 7.57249Z", fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 2, width: 10, height: 1, fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 5, width: 7, height: 1, fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 8, width: 4, height: 1, fill: "white" })), Xht = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-envelope", viewBox: "0 0 16 16", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" })), Jht = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 81, height: 81, viewBox: "0 0 81 81", fill: "none", ...r }, /* @__PURE__ */ be.createElement("g", { clipPath: "url(#clip0_2300_3747)" }, /* @__PURE__ */ be.createElement("path", { d: "M40.5 2.0625C49.3681 2.06727 57.9619 5.13756 64.8254 10.7532C71.689 16.3689 76.4002 24.1846 78.1608 32.8761C79.9215 41.5677 78.6234 50.6007 74.4864 58.4448C70.3495 66.2888 63.6281 72.4615 55.4609 75.9172C46.0677 79.8851 35.483 79.959 26.0352 76.1227C16.5875 72.2864 9.0507 64.8542 5.08281 55.4609C1.11493 46.0677 1.041 35.483 4.87729 26.0352C8.71358 16.5875 16.1458 9.0507 25.5391 5.08281C30.272 3.07942 35.3606 2.05213 40.5 2.0625ZM40.5 0.5C18.4094 0.5 0.5 18.4094 0.5 40.5C0.5 62.5906 18.4094 80.5 40.5 80.5C62.5906 80.5 80.5 62.5906 80.5 40.5C80.5 18.4094 62.5906 0.5 40.5 0.5Z", fill: "#C6C6C6" }), /* @__PURE__ */ be.createElement("path", { d: "M43.6781 54.4547C43.6781 55.0938 43.4886 55.7185 43.1336 56.2499C42.7785 56.7813 42.2739 57.1954 41.6834 57.44C41.093 57.6845 40.4433 57.7485 39.8165 57.6239C39.1897 57.4992 38.6139 57.1914 38.162 56.7395C37.7101 56.2876 37.4024 55.7119 37.2777 55.0851C37.153 54.4583 37.217 53.8086 37.4616 53.2182C37.7062 52.6277 38.1203 52.1231 38.6517 51.768C39.1831 51.413 39.8078 51.2234 40.4469 51.2234C41.3039 51.2234 42.1257 51.5639 42.7317 52.1699C43.3377 52.7758 43.6781 53.5977 43.6781 54.4547ZM69.2938 39.9234V44.3734C69.2198 44.7098 69.046 45.016 68.795 45.2518C68.5441 45.4877 68.2278 45.6423 67.8875 45.6953C67.8005 45.7074 67.7128 45.7127 67.625 45.7109C67.3579 45.7146 67.0938 45.6549 66.8543 45.5367C66.6147 45.4186 66.4066 45.2454 66.2469 45.0313C66.0494 44.7728 65.7942 44.5641 65.5018 44.4217C65.2094 44.2793 64.8877 44.2071 64.5625 44.2109H63.9766C64.0312 44.8359 64.0672 45.4609 64.0687 46.0969C64.0743 47.8222 63.8781 49.5421 63.4844 51.2219C61.8547 58.55 56.4922 64.5547 49.3891 67.3313C46.5563 68.4354 43.5419 68.9998 40.5016 68.9953H40.5C37.4596 68.9998 34.4453 68.4354 31.6125 67.3313C24.5094 64.5547 19.1469 58.55 17.5172 51.2219C17.1234 49.5421 16.9273 47.8222 16.9328 46.0969C16.9328 45.4609 16.9703 44.8328 17.025 44.2109H16.4375C16.1131 44.2078 15.7923 44.2804 15.5008 44.4227C15.2092 44.5651 14.9549 44.7735 14.7578 45.0313C14.5981 45.2454 14.39 45.4186 14.1504 45.5367C13.9109 45.6549 13.6468 45.7146 13.3797 45.7109C13.2919 45.7127 13.2041 45.7074 13.1172 45.6953C12.7769 45.6423 12.4606 45.4877 12.2097 45.2518C11.9587 45.016 11.7849 44.7098 11.7109 44.3734V39.9297C11.7845 39.5932 11.9582 39.2868 12.2092 39.0508C12.4602 38.8149 12.7767 38.6604 13.1172 38.6078C13.2047 38.5957 13.293 38.5904 13.3813 38.5922C13.6186 38.5898 13.8539 38.6372 14.0719 38.7313C14.5126 35.257 15.5208 31.8788 17.0562 28.7313L17.1047 28.6313C17.1703 28.4984 17.2375 28.3672 17.3047 28.2359C17.3484 28.1484 17.3938 28.0609 17.4391 27.9734L17.5781 27.7109C17.6516 27.575 17.7344 27.4391 17.8016 27.3031L17.8719 27.175C19.5235 24.2098 21.6822 21.5571 24.25 19.3375L23.0969 16.175C22.6282 16.2316 22.1541 16.1283 21.7515 15.8818C21.3488 15.6353 21.0412 15.2601 20.8785 14.8169C20.7159 14.3737 20.7076 13.8885 20.8551 13.4401C21.0027 12.9916 21.2973 12.6061 21.6913 12.3461C22.0854 12.086 22.5557 11.9666 23.026 12.0073C23.4964 12.048 23.9392 12.2463 24.2827 12.5701C24.6263 12.8939 24.8504 13.3243 24.9187 13.7914C24.9871 14.2585 24.8957 14.7351 24.6594 15.1438L27.1594 17.175C30.4805 15.0096 34.2757 13.6786 38.2219 13.2953L38.3781 13.2813L38.7063 13.2547L38.9766 13.2359L39.325 13.2156L39.7359 13.2H39.9359H40.3375H40.6813H41.0828H41.2828L41.6938 13.2156L42.0422 13.2359L42.3125 13.2547L42.6406 13.2813L42.7969 13.2953C46.743 13.6786 50.5382 15.0096 53.8594 17.175L56.3594 15.1438C56.1238 14.7356 56.0328 14.2599 56.1013 13.7936C56.1698 13.3274 56.3938 12.8979 56.7368 12.5748C57.0799 12.2516 57.522 12.0538 57.9915 12.0133C58.461 11.9728 58.9304 12.092 59.3238 12.3516C59.7171 12.6112 60.0113 12.996 60.1586 13.4436C60.306 13.8912 60.2978 14.3755 60.1356 14.818C59.9734 15.2604 59.6665 15.6352 59.2647 15.8815C58.8629 16.1278 58.3898 16.2312 57.9219 16.175L56.75 19.3375C59.3157 21.5561 61.4728 24.2071 63.1234 27.1703L63.1937 27.2984C63.2687 27.4344 63.35 27.5703 63.4172 27.7063L63.5563 27.9688C63.6016 28.0563 63.6469 28.1438 63.6906 28.2313C63.7578 28.3625 63.825 28.4938 63.8906 28.625C63.9063 28.6594 63.9234 28.6938 63.9406 28.7281C65.4748 31.876 66.4825 35.2542 66.9234 38.7281C67.1414 38.6341 67.3767 38.5867 67.6141 38.5891C67.7024 38.5873 67.7907 38.5925 67.8781 38.6047C68.2207 38.6558 68.5396 38.8099 68.7924 39.0466C69.0453 39.2832 69.2201 39.5913 69.2938 39.9297V39.9234ZM47.3422 32.8109H33.6578C30.1854 32.8109 26.8552 34.1902 24.3997 36.6455C21.9442 39.1007 20.5645 42.4307 20.5641 45.9031V47.0875C20.5641 54.3188 26.4266 63.1188 33.6578 63.1188H47.3422C54.5734 63.1188 60.4359 54.3188 60.4359 47.0875V45.9031C60.4355 42.4307 59.0558 39.1007 56.6003 36.6455C54.1448 34.1902 50.8146 32.8109 47.3422 32.8109ZM64.5625 40.0984C64.9218 40.0978 65.275 40.0059 65.5891 39.8313C62.6922 29.0594 52.5859 21.0688 40.5703 21.025H40.4141C28.3984 21.0688 18.2922 29.0594 15.3953 39.8313C15.7093 40.0059 16.0626 40.0978 16.4219 40.0984H17.7687C20.5203 30.4953 29.6438 23.425 40.4469 23.4156H40.5344C51.3359 23.425 60.4609 30.4953 63.2125 40.0984H64.5625ZM37.1859 46.2938L34.5891 43.6969L37.1859 41.1C37.4613 40.8244 37.6159 40.4508 37.6158 40.0612C37.6156 39.6716 37.4607 39.298 37.1852 39.0227C36.9096 38.7473 36.5359 38.5927 36.1463 38.5928C35.7567 38.593 35.3832 38.7479 35.1078 39.0234L32.5125 41.6203L29.9156 39.0234C29.6357 38.7723 29.2701 38.638 28.8942 38.6484C28.5182 38.6588 28.1606 38.813 27.8949 39.0792C27.6293 39.3454 27.4759 39.7034 27.4664 40.0794C27.4569 40.4554 27.5919 40.8207 27.8438 41.1L30.4391 43.6969L27.8438 46.2938C27.5789 46.5713 27.4331 46.9414 27.4376 47.325C27.442 47.7085 27.5964 48.0752 27.8677 48.3464C28.1389 48.6177 28.5055 48.772 28.8891 48.7765C29.2727 48.781 29.6428 48.6352 29.9203 48.3703L32.5172 45.7734L35.1125 48.3703C35.2488 48.5068 35.4107 48.615 35.5889 48.6889C35.7671 48.7628 35.9581 48.8009 36.151 48.8009C36.3439 48.801 36.5349 48.7631 36.7132 48.6893C36.8914 48.6156 37.0534 48.5075 37.1898 48.3711C37.3263 48.2348 37.4346 48.0729 37.5084 47.8947C37.5823 47.7165 37.6204 47.5255 37.6205 47.3326C37.6205 47.1397 37.5826 46.9487 37.5089 46.7704C37.4351 46.5922 37.327 46.4302 37.1906 46.2938H37.1859ZM53.0469 39.0234C52.7712 38.7481 52.3975 38.5934 52.0078 38.5934C51.6182 38.5934 51.2444 38.7481 50.9688 39.0234L48.3734 41.6203L45.7766 39.0234C45.4991 38.7586 45.129 38.6128 44.7454 38.6173C44.3618 38.6217 43.9952 38.7761 43.7239 39.0474C43.4527 39.3186 43.2983 39.6852 43.2938 40.0688C43.2894 40.4524 43.4351 40.8225 43.7 41.1L46.2969 43.6969L43.7 46.2938C43.4351 46.5713 43.2894 46.9414 43.2938 47.325C43.2983 47.7085 43.4527 48.0752 43.7239 48.3464C43.9952 48.6177 44.3618 48.772 44.7454 48.7765C45.129 48.781 45.4991 48.6352 45.7766 48.3703L48.3734 45.7734L50.9688 48.3703C51.2441 48.6459 51.6177 48.8008 52.0073 48.8009C52.3968 48.8011 52.7705 48.6465 53.0461 48.3711C53.3217 48.0957 53.4766 47.7222 53.4767 47.3326C53.4769 46.943 53.3222 46.5693 53.0469 46.2938L50.45 43.6969L53.0469 41.1C53.3221 40.8246 53.4768 40.4511 53.4768 40.0617C53.4768 39.6723 53.3221 39.2989 53.0469 39.0234Z", fill: "url(#paint0_linear_2300_3747)" })), /* @__PURE__ */ be.createElement("defs", null, /* @__PURE__ */ be.createElement("linearGradient", { id: "paint0_linear_2300_3747", x1: 11.7063, y1: 40.5, x2: 69.2938, y2: 40.5, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ be.createElement("stop", { offset: 0.11, stopColor: "#FF1E00" }), /* @__PURE__ */ be.createElement("stop", { offset: 0.25, stopColor: "#FF2700" }), /* @__PURE__ */ be.createElement("stop", { offset: 0.48, stopColor: "#FF3F00" }), /* @__PURE__ */ be.createElement("stop", { offset: 0.77, stopColor: "#FF6700" }), /* @__PURE__ */ be.createElement("stop", { offset: 1, stopColor: "#FF8B00" })), /* @__PURE__ */ be.createElement("clipPath", { id: "clip0_2300_3747" }, /* @__PURE__ */ be.createElement("rect", { width: 80, height: 80, fill: "white", transform: "translate(0.5 0.5)" })))), yMe = (r) => /* @__PURE__ */ be.createElement("svg", { style: {
  paddingLeft: 4
}, width: 11, height: 12, viewBox: "0 0 11 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M0.5 12C0.367392 12 0.240215 11.9473 0.146447 11.8535C0.0526785 11.7598 1.36127e-09 11.6326 1.36127e-09 11.5V0.499976C-6.40951e-06 0.413085 0.0226312 0.327692 0.065681 0.252216C0.108731 0.176739 0.170707 0.113784 0.245499 0.0695563C0.320292 0.0253287 0.405319 0.00135537 0.4922 -1.73655e-07C0.57908 -0.00135572 0.664814 0.0199533 0.74095 0.0618261L10.7409 5.56183C10.8194 5.60497 10.8848 5.66839 10.9304 5.74546C10.976 5.82252 11 5.91042 11 5.99995C11 6.08949 10.976 6.17738 10.9304 6.25445C10.8848 6.33152 10.8194 6.39493 10.7409 6.43808L0.74095 11.9381C0.667127 11.9787 0.584248 12 0.5 12Z", fill: "white" })), L7 = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-arrow-counterclockwise", viewBox: "0 0 16 16", ...r }, /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", d: "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" }), /* @__PURE__ */ be.createElement("path", { d: "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" })), $ht = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "#52C16B" }, /* @__PURE__ */ be.createElement("path", { d: "M9 0C4.0374 0 0 4.0375 0 9c0 4.9627 4.0374 9 9 9s9-4.0373 9-9c0-4.9625-4.0374-9-9-9zm0 16.3636c-4.0604 0-7.3636-3.3032-7.3636-7.3635 0-4.0604 3.3032-7.3637 7.3636-7.3637S16.3636 4.9397 16.3636 9c0 4.0603-3.3033 7.3635-7.3636 7.3635z" }), /* @__PURE__ */ be.createElement("path", { d: "M5.101 9.85C5.0337 9.78 5 9.675 5 9.605s.0337-.175.101-.245l.4711-.49c.1346-.14.3366-.14.4712 0l.0336.035 1.851 2.065c.0673.07.1683.07.2356 0l4.5096-4.865h.0336c.1346-.14.3366-.14.4712 0l.4711.49c.1347.14.1347.35 0 .49l-5.3846 5.81c-.0673.07-.1346.105-.2356.105s-.1682-.035-.2355-.105l-2.625-2.94-.0673-.105z" }))), edt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { clipPath: "url(#clip0_2557_56096)" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, transform: "translate(0.5)", fill: "transparent" }), /* @__PURE__ */ be.createElement("g", { clipPath: "url(#clip1_2557_56096)" }, /* @__PURE__ */ be.createElement("path", { d: "M9.69601 7.99995L15.5 4.63295V11.3669L9.69601 7.99995ZM8.90401 7.30395C8.78141 7.37414 8.67952 7.47547 8.60866 7.59769C8.5378 7.71991 8.50049 7.85868 8.50049 7.99995C8.50049 8.14122 8.5378 8.27999 8.60866 8.40221C8.67952 8.52442 8.78141 8.62576 8.90401 8.69595L15.267 12.3879C15.787 12.6899 16.5 12.3449 16.5 11.6919V4.30795C16.5 3.65495 15.787 3.30995 15.267 3.61195L8.90401 7.30395Z" }), /* @__PURE__ */ be.createElement("path", { d: "M1.69601 7.99995L7.50001 4.63295V11.3669L1.69601 7.99995ZM0.904006 7.30395C0.781405 7.37414 0.679521 7.47547 0.608663 7.59769C0.537805 7.71991 0.500488 7.85868 0.500488 7.99995C0.500488 8.14122 0.537805 8.27999 0.608663 8.40221C0.679521 8.52442 0.781405 8.62576 0.904006 8.69595L7.26701 12.3879C7.78701 12.6899 8.50001 12.3449 8.50001 11.6919V4.30795C8.50001 3.65495 7.78701 3.30995 7.26701 3.61195L0.904006 7.30395Z" }))), /* @__PURE__ */ be.createElement("defs", null, /* @__PURE__ */ be.createElement("clipPath", { id: "clip0_2557_56096" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" })), /* @__PURE__ */ be.createElement("clipPath", { id: "clip1_2557_56096" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" })))), tdt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 180, height: 180, viewBox: "0 0 180 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M150.804 55.8922L150.494 49.0623H126.417C126.82 39.786 126.418 29.1415 126.418 29.1415H53.5819C53.5819 29.1415 53.1795 39.786 53.5831 49.0623H29.5059L29.1962 55.8922C29.1692 56.4865 28.6164 70.6236 35.6237 86.0315C41.7589 99.5223 54.8975 116.447 82.846 122.946V131.977H77.9039V138.148H53.4032V152.456H126.597V138.148H102.096V131.977H97.1541V122.946C125.102 116.447 138.241 99.5222 144.376 86.0315C151.384 70.6235 150.831 56.4865 150.804 55.8922ZM48.8725 80.5957C45.861 74.1454 44.5261 67.8866 43.9383 63.3704H54.7619C56.2251 75.2305 59.1824 88.702 65.0259 99.9776C58.0146 95.0724 52.6113 88.6029 48.8725 80.5957ZM101.322 104.518H79.4116V92.1394H101.322V104.518ZM101.331 73.5114C101.279 80.9953 97.5643 85.2491 90.3501 85.2491C83.1358 85.2491 79.4211 80.9929 79.4211 73.5658L79.4116 49.2818C79.4637 41.798 83.1784 37.5441 90.3926 37.5441C97.6069 37.5441 101.322 41.8004 101.322 49.2818V53.8029H94.3864V48.8089C94.3864 45.4702 92.8801 44.1791 90.5652 44.1791C88.2007 44.1247 86.7417 45.4158 86.7417 48.7545V73.9962C86.7417 77.3349 88.2503 78.5196 90.5652 78.5196C92.9298 78.5196 94.3864 77.3373 94.3864 73.9962V67.321H101.331V73.5114ZM131.352 80.1083C127.607 88.3417 122.128 94.9736 114.974 99.9781C120.817 88.7023 123.775 75.2307 125.238 63.3704H136.06C135.486 67.7767 134.203 73.8395 131.352 80.1083Z", fill: "#FC5D0D" })), ndt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", d: "M13 5H11V11H5V13H11V19H13V13H19V11H13V5Z" })), idt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22.0833 10H1.9167c-.55 0-.9167.3667-.9167.9167V12.75c0 .55.3667.9167.9167.9167h20.1666c.55 0 .9167-.3667.9167-.9167v-1.8333c0-.55-.3667-.9167-.9167-.9167z" })), rdt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 15 15", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", d: "M.531 8.031H1.697c.2461 2.798 2.487 5.026 5.272 5.2721v1.1658c0 .285.2332.5311.5311.5311.285 0 .531-.2332.531-.531V13.303c2.798-.2461 5.026-2.487 5.2721-5.272h1.1658c.285 0 .5311-.2332.5311-.5311 0-.285-.2332-.531-.531-.531H13.303c-.2461-2.798-2.487-5.026-5.272-5.2721V.531C8.031.246 7.7979 0 7.5 0c-.285 0-.531.2332-.531.531V1.697c-2.798.2461-5.026 2.487-5.2721 5.272H.531C.233 6.969 0 7.2021 0 7.5c0 .298.2461.531.531.531zm4.3654-1.062H2.759c.246-2.2151 2.0077-3.9768 4.2098-4.21v2.1374c0 .285.2332.531.5311.531.285 0 .531-.2331.531-.531V2.759c2.2151.246 3.9768 2.0077 4.21 4.2098h-2.1374c-.285 0-.531.2332-.531.5311 0 .285.2331.531.531.531h2.1373c-.246 2.2151-2.0077 3.9768-4.2098 4.21v-2.1374c0-.285-.2332-.531-.5311-.531-.285 0-.531.2331-.531.531v2.1373c-2.2151-.246-3.9768-2.0077-4.21-4.2098h2.1374c.285 0 .531-.2332.531-.5311 0-.285-.246-.531-.531-.531z" })), sdt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.8557 1.5478a.3332.3332 0 0 0-.328-.009l-5.5162 2.9204-5.516-2.9204a.5482.5482 0 0 0-.0627-.0234c-.046-.0113-.0647-.0127-.0837-.0133-.0434 0-.061.0033-.0788.0073-.0213.0047-2.0354.6745-6.042 2.0096A.3334.3334 0 0 0 1 3.8356v14.3471a.334.334 0 0 0 .3337.3336.3279.3279 0 0 0 .1054-.0173l5.8876-1.9625 5.5577 2.2885c.0514.016.0887.025.127.025a.334.334 0 0 0 .0888-.013c.0407-.0154.0548-.019.0674-.0257l5.6721-3.0029a.334.334 0 0 0 .1775-.295V1.8338a.334.334 0 0 0-.1615-.286zM2.0598 4.6795l4.6633-1.5897v12.188l-4.6633 1.5898V4.6796zM7.783 3.0898l4.5573 2.6495v11.6583L7.783 15.2779V3.0898zm10.1744 11.9761l-4.5043 2.3317V5.7393l4.5043-2.6495v11.9761z" })), odt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ be.createElement("path", { d: "M7.8434 11.358H1.7862a.7985.7985 0 1 0 0 1.5971h5.2587v5.2587a.7985.7985 0 1 0 1.597 0v-6.0572a.7985.7985 0 0 0-.7985-.7986zM18.2138 7.0449h-5.2586V1.7862a.7985.7985 0 1 0-1.5971 0v6.0572c0 .441.3575.7986.7985.7986h6.0572a.7985.7985 0 1 0 0-1.5971z" }), /* @__PURE__ */ be.createElement("path", { d: "M19.7667.2333a.7965.7965 0 0 0-1.1265 0l-7.0489 7.0489a.7966.7966 0 0 0 1.1265 1.1265l7.049-7.049a.7966.7966 0 0 0 0-1.1264zM8.4087 11.5913a.7965.7965 0 0 0-1.1265 0l-7.0489 7.049a.7965.7965 0 1 0 1.1265 1.1264l7.0489-7.049a.7965.7965 0 0 0 0-1.1264z" }))), adt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ be.createElement("path", { d: "M19.2015 0h-6.0573a.7985.7985 0 1 0 0 1.5971h5.2587v5.2587a.7985.7985 0 1 0 1.5971 0V.7985A.7985.7985 0 0 0 19.2015 0zM6.8558 18.4029H1.597v-5.2587a.7985.7985 0 1 0-1.5971 0v6.0573c0 .441.3575.7985.7985.7985h6.0573a.7985.7985 0 1 0 0-1.5971z" }), /* @__PURE__ */ be.createElement("path", { d: "M19.7667.2333a.7965.7965 0 0 0-1.1265 0l-7.0489 7.0489a.7966.7966 0 0 0 1.1265 1.1265l7.049-7.049a.7966.7966 0 0 0 0-1.1264zM8.4087 11.5913a.7965.7965 0 0 0-1.1265 0l-7.0489 7.049a.7965.7965 0 1 0 1.1265 1.1264l7.0489-7.049a.7965.7965 0 0 0 0-1.1264z" }))), ldt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 24, height: 22, viewBox: "0 0 24 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M23.5113 6.50953L11.9999 0.541748L0.488525 6.53879V16.7191H3.15063V7.88446L11.9999 12.0678L23.5113 6.50953Z", fill: "#525252" }), /* @__PURE__ */ be.createElement("path", { d: "M4.46704 10.7952V17.392L11.9999 21.4583L19.5328 17.392V10.7952L11.9999 14.5105L4.46704 10.7952Z", fill: "#525252" })), cdt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 17, height: 15, viewBox: "0 0 17 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.7219 5.2691C8.6668 4.2126 7.7435 2.4757 7.0638 1.00772C7.0445 1.00316 7.0206 1 6.9941 1C6.9675 1 6.9436 1.00316 6.9243 1.00773C6.2447 2.4757 5.322 4.2122 4.2662 5.2687C3.2106 6.325 1.47501 7.2485 0.00802994 7.9287C0.00328994 7.9483 0 7.9728 0 8C0 8.0271 0.00324982 8.0515 0.00793982 8.071C1.47467 8.751 3.2101 9.6743 4.2659 10.7311C5.322 11.7875 6.2448 13.5244 6.9245 14.9923C6.9437 14.9969 6.9675 15 6.994 15C7.0205 15 7.0444 14.9968 7.0636 14.9923C7.7433 13.5244 8.666 11.7877 9.7215 10.7315M9.7215 10.7315C10.773 9.6791 12.4531 8.7468 13.8721 8.0577C13.8756 8.0415 13.878 8.0217 13.878 7.9998C13.878 7.9779 13.8756 7.9582 13.8721 7.942C12.4537 7.2529 10.7734 6.3207 9.7219 5.2691", fill: "white" }), /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4808 1.52468C15.104 1.14737 14.7742 0.52704 14.5315 0.00275993C14.5246 0.00112993 14.5161 0 14.5066 0C14.4971 0 14.4885 0.00112993 14.4817 0.00275993C14.2389 0.52705 13.9094 1.14721 13.5323 1.52455C13.1553 1.9018 12.5355 2.2316 12.0116 2.4745C12.0099 2.4815 12.0087 2.4903 12.0087 2.5C12.0087 2.5097 12.0099 2.5184 12.0115 2.5254C12.5354 2.7682 13.1552 3.098 13.5322 3.4754C13.9094 3.8527 14.239 4.473 14.4817 4.9972C14.4886 4.9989 14.4971 5 14.5066 5C14.516 5 14.5246 4.9989 14.5314 4.9972C14.7742 4.473 15.1037 3.8528 15.4806 3.4755M15.4806 3.4755C15.8562 3.0997 16.4562 2.7667 16.963 2.5206C16.9643 2.5148 16.9651 2.5078 16.9651 2.4999C16.9651 2.4921 16.9643 2.4851 16.963 2.4793C16.4565 2.2332 15.8563 1.90026 15.4808 1.52468", fill: "white" })), hdt = q.div`
  position: fixed;
  z-index: var(--z-dialog);
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`, ddt = q.div`
  position: relative;
  background-color: white;
  box-shadow:
    0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14),
    0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  margin: 32px;
  overflow-y: auto;
  width: 100%;
  max-width: ${({ $maxWidth: r }) => `${r}px`};
  max-height: calc(100% - 64px);
  border-radius: var(--spacing-tiny);
`, udt = q.header`
  text-align: center;
  padding: 15px 25px;
  border-bottom: 1px solid var(--silver-darken-87);
`, fdt = q.h2.attrs({ id: "dialog-title" })`
  margin: 0;
  font-size: 16px;
`, pdt = q.p`
  margin: 0;
`, gdt = q.div`
  padding: 25px;
`, mdt = q.footer`
  display: flex;
  padding: 15px 25px;
  align-items: center;
  justify-content: ${({
  //@ts-expect-error Property 'justify' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>, never>'.ts(2339)
  justify: r
}) => `${r || "flex-end"}`};
  border-top: 1px solid var(--silver-darken-87);
  background-color: var(--silver-darken-94);

  > *:not(:last-child) {
    margin-right: 5px;
  }
`, Adt = q.div`
  position: absolute;
  top: 11px;
  right: 5px;
  z-index: 1;
`, tn = ({
  open: r,
  clickOutsideToClose: e = !0,
  onClose: t,
  onConfirm: n,
  children: i,
  maxWidth: s = 750,
  ...o
}) => {
  const a = An();
  Pe(() => {
    if (r) {
      const u = l();
      u.length > 0 && u[0].focus();
    }
  }, [r]);
  const l = () => a.current ? Array.from(
    //@ts-expect-error Property 'querySelectorAll' does not exist on type 'never'.ts(2339)
    a.current.querySelectorAll("select, input, textarea, button, a")
  ).filter(
    //@ts-expect-error 'element' is of type 'unknown'.ts(18046)
    (u) => !u.disabled
  ) : [], c = (u) => {
    if (u.key == "Escape" && typeof t == "function")
      return t();
    if (u.key == "Enter" && typeof n == "function")
      return n(u);
    const f = l();
    u.key == "Tab" && f.length > 0 && f.indexOf(document.activeElement) == f.length - 1 && (u.preventDefault(), f[0].focus());
  }, d = (u) => {
    u.currentTarget == u.target && typeof t == "function" && e && t();
  };
  return r ? un(
    /* @__PURE__ */ x.jsx(hdt, { onClick: d, children: /* @__PURE__ */ x.jsxs(
      ddt,
      {
        tabIndex: 1,
        onKeyDown: c,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "dialog-title",
        ref: a,
        $maxWidth: s,
        ...o,
        children: [
          t && /* @__PURE__ */ x.jsx(Adt, { children: /* @__PURE__ */ x.jsx(
            bdt,
            {
              onClick: t,
              variant: "inherit",
              title: "Close the dialog",
              "data-test": "close-dialog",
              children: /* @__PURE__ */ x.jsx(Kht, { width: "16", height: "16" })
            }
          ) }),
          i
        ]
      }
    ) }),
    document.body
  ) : null;
}, wdt = ({ children: r }) => /* @__PURE__ */ x.jsx(udt, { children: r });
tn.Header = wdt;
tn.Title = fdt;
tn.Subtitle = pdt;
tn.Content = gdt;
tn.Footer = mdt;
const vdt = q.button`
  border-radius: ${({ noRadius: r }) => r ? "inherit" : "50%"};
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  color: inherit;

  &::-moz-focus-inner {
    border: 0;
  }

  &:not([disabled]):hover {
    background-color: rgba(0, 0, 0, 0.07);
  }

  &:not([disabled]):active {
    background-color: rgba(0, 0, 0, 0.16);
  }

  &[disabled] {
    color: var(--grey-lighten-56);
    cursor: not-allowed;
  }

  ${({ isActive: r, isHover: e }) => {
  if (r)
    return `
      background-color: rgba(0, 0, 0, 0.16);
      opacity: 1 !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.16);
      }
    `;
  if (e) return "background-color: rgba(0, 0, 0, 0.07);";
}}

  ${({ size: r = "normal" }) => r == "small" ? `
        height: 30px;
        width: 30px;
      ` : `
      height: 36px;
      width: 36px;
    `}
`, bdt = vdt, ydt = q.a`
  color: var(--cds-blue-60);
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: var(--cds-blue-70);
  }
`, Cdt = ydt, Mi = {
  title: "Unable to process request",
  subtitle: "Please try again"
}, Edt = 255, vd = "Instance started", _dt = [
  "SERVICE_TASK",
  "USER_TASK",
  "RECEIVE_TASK",
  "INTERMEDIATE_CATCH_EVENT",
  "SEND_TASK"
], fw = `{
  "variableName": "variableValue"
}`, xdt = q.input`
  font: inherit;
  color: var(--grey-darken-33);
  width: 100%;

  border: 1px solid
    ${({
  //@ts-expect-error Property 'error' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, never>'.ts(2339)
  error: r
}) => r ? "var(--red-base-62)" : "var(--silver-darken-80)"};
  margin: 0;
  height: 36px;
  padding: 8px 15px;
  background-color: white;
  transition: border 0.15s linear;
  border-radius: 3px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-sizing: border-box;

  &:disabled {
    background-color: var(--silver-base-97);
    cursor: not-allowed;
  }

  &:focus {
    border-color: var(--cds-blue-60);
  }

  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }
`, Sdt = q.textarea`
  font: inherit;
  color: var(--grey-darken-33);
  width: 100%;
  border: 1px solid
    ${({
  //@ts-expect-error Property 'error' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, never>'.ts(2339)
  error: r
}) => r ? "var(--red-base-62)" : "var(--silver-darken-80)"};
  margin: 0;
  padding: 8px 15px;
  min-height: 36px;
  ${({
  //@ts-expect-error Property 'grow' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, never>'.ts(2339)
  grow: r
}) => r ? "max-height: 100px" : ""};
  background-color: white;
  line-height: 1.3;
  transition: border 0.15s linear;
  border-radius: 3px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-sizing: border-box;

  &:disabled {
    background-color: var(--silver-base-97);
    cursor: not-allowed;
  }

  &:focus {
    border-color: var(--cds-blue-60);
  }
`, Mdt = q.label`
  display: block;
  margin-bottom: var(--spacing-tiny);
`;
q.p`
  margin: 3px 0 0 0;
  font-size: 12px;
  color: var(--red-darken-52);
`;
const Ddt = q.div`
  width: 100%;
  position: relative;

  ${({
  //@ts-expect-error Property 'hasMarginBottom' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, never>'.ts(2339)
  hasMarginBottom: r
}) => r && "margin-bottom: 15px"};
`;
r1(
  ({
    label: r,
    error: e = !1,
    multiline: t = !1,
    grow: n = !1,
    type: i = "text",
    hasMarginBottom: s = !1,
    ...o
  }, a) => {
    const l = r?.toLowerCase() + "-" + Math.random().toString(36).replace(/[^a-z]+/g, "").substr(2, 10), c = (u) => {
      const f = u ? u.target : a.current;
      f.style.height = "initial";
      const p = window.getComputedStyle(f), g = parseInt(p.getPropertyValue("border-top-width"), 10) + f.scrollHeight + parseInt(p.getPropertyValue("border-bottom-width"), 10);
      f.style.height = g + "px";
    }, d = (u) => {
      u.key == "Enter" && c();
    };
    return Pe(() => {
      if (t && a && a.current) {
        const u = a.current;
        return u.addEventListener("input", c), u.addEventListener("keyup", d), c(), () => {
          u.removeEventListener("input", c), u.removeEventListener("keyup", d);
        };
      }
    }, []), //@ts-expect-error Property 'hasMarginBottom' does not exist on type 'IntrinsicAttributes & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, never>'.ts(2769)
    /* @__PURE__ */ x.jsxs(Ddt, { hasMarginBottom: s, children: [
      r && /* @__PURE__ */ x.jsx(Mdt, { htmlFor: l, children: r }),
      t ? (
        //@ts-expect-error Type 'ForwardedRef<HTMLDivElement>' is not assignable to type 'LegacyRef<HTMLTextAreaElement> | undefined'.ts(2769)
        /* @__PURE__ */ x.jsx(
          Sdt,
          {
            ...o,
            grow: n,
            id: r ? l : null,
            error: e,
            ref: a
          }
        )
      ) : (
        //@ts-expect-error Type 'ForwardedRef<HTMLDivElement>' is not assignable to type 'LegacyRef<HTMLInputElement> | undefined'.ts(2769)
        /* @__PURE__ */ x.jsx(
          xdt,
          {
            type: i,
            maxLength: Edt,
            ...o,
            id: r ? l : null,
            error: e,
            ref: a
          }
        )
      )
    ] });
  }
);
const rve = 5, Ldt = zg`
  from { opacity: 0; }
  to { opacity: 1; }
`, kdt = q.div`
  position: fixed;
  top: ${({ $position: r }) => `${r.top}px`};
  left: ${({ $position: r }) => `${r.left}px`};
  border-radius: 4px;
  color: white;
  z-index: var(--z-tooltip);
  padding: 6px 8px;
  max-width: 380px;
  font-weight: 500;
  word-break: break-word;
  animation: ${Ldt} 0.2s ease-out forwards;

  ${({ color: r }) => `
      background-color: ${aE(r)};
    `}

  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    width: 0;
    height: 0;
    border: 5px solid transparent;

    ${({ $align: r, color: e }) => {
  switch (r) {
    case "bottom":
      return `
            border-bottom-color: ${aE(e)};
            bottom: 100%;
          `;
    default:
      return `
            border-top-color: ${aE(e)};
            top: 100%;
          `;
  }
}}

    ${({ $justify: r }) => {
  switch (r) {
    case "left":
      return `left: ${rve}px;`;
    case "right":
      return `right: ${rve}px;`;
    default:
      return `
            left: 50%;
            transform: translateX(-50%);
          `;
  }
}}
  }
`, aE = (r) => r === "blue" ? "var(--cds-blue-60)" : "var(--grey-darken-33)", lE = 5, Ndt = (r) => {
  const e = ({
    //@ts-expect-error Binding element 'children' implicitly has an 'any' type.ts(7031)
    children: t,
    showOnlyOnOverflow: n = !1,
    interactive: i = !1,
    ...s
  }) => {
    const [o, a] = ye(), [l, c] = ye();
    Pe(() => () => {
    }, []), t = Ixe.map(t, (u) => Oxe(u, {
      //@ts-expect-error Argument of type 'EventTarget & HTMLElement' is not assignable to parameter of type 'SetStateAction<undefined>'.ts(2345)
      onMouseEnter: (f) => a(f.currentTarget),
      onMouseLeave: () => {
        i ? c(setTimeout(a, 200)) : a();
      }
    }));
    let d = !1;
    return d = !!o, n && (d = //@ts-expect-error 'anchorEl' is possibly 'undefined'.ts(18048)
    !!o && o.scrollWidth > o.clientWidth), /* @__PURE__ */ x.jsxs(Rxe, { children: [
      t,
      d && /* @__PURE__ */ x.jsx(
        r,
        {
          anchorEl: o,
          setAnchorEl: a,
          timer: l,
          ...s
        }
      )
    ] });
  };
  return e.propTypes = {
    interactive: N3.PropTypes.bool,
    showOnlyOnOverflow: N3.PropTypes.bool
  }, e;
}, Tdt = ({
  //@ts-expect-error Binding element 'timer' implicitly has an 'any' type.ts(7031)
  timer: r,
  //@ts-expect-error Binding element 'setAnchorEl' implicitly has an 'any' type.ts(7031)
  setAnchorEl: e,
  //@ts-expect-error Binding element 'anchorEl' implicitly has an 'any' type.ts(7031)
  anchorEl: t,
  title: n,
  align: i = "bottom",
  justify: s = "center",
  controlledByTimer: o = !1,
  color: a = "grey",
  onClose: l,
  keepOpen: c = !1
}) => {
  const [d, u] = ye({ top: 0, left: 0 }), [f, p] = ye(i), g = An();
  return Pe(() => {
    const { top: m, bottom: A, left: w, width: v } = t.getBoundingClientRect(), y = (
      //@ts-expect-error 'tooltip.current' is possibly 'undefined'.ts(18048)
      A + g.current.offsetHeight + lE > window.innerHeight
    ), _ = () => {
      switch (s) {
        case "left":
          return w;
        case "right":
          return w + v - g.current.offsetWidth;
        default:
          return w - g.current.offsetWidth / 2 + v / 2;
      }
    }, S = () => f == "top" || y ? m - g.current.offsetHeight - lE - 5 : A + lE + 5;
    y && p("top"), u({
      top: S(),
      left: _()
    });
  }, [t, t?.getBoundingClientRect().top]), Pe(() => {
    if (o) {
      const m = (A) => {
        g.current.contains(A.target) || c || e();
      };
      return document.addEventListener("mousedown", m), () => {
        document.removeEventListener("mousedown", m);
      };
    }
  }, []), Pe(() => {
    if (o && l)
      return () => {
        l();
      };
  }, []), un(
    /* @__PURE__ */ x.jsx(
      kdt,
      {
        onMouseEnter: () => clearTimeout(r),
        onMouseLeave: () => !o && e(),
        $position: d,
        $justify: s,
        $align: f,
        ref: g,
        color: a,
        role: "tooltip",
        "aria-hidden": !t,
        children: n
      }
    ),
    document.body
  );
}, V2 = Ndt(Tdt), Idt = q.ul`
  list-style: none;
  margin: 4px 0 0 0;
  position: fixed;
  z-index: var(--z-dropdown);
  border-radius: 3px;
  padding: 5px 0;
  min-width: 70px;
  max-width: 350px;

  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 10px 0px;
  background: var(--silver-base-98);

  ${({
  //@ts-expect-error Property 'size' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>, never>'.ts(2339)
  size: r
}) => {
  if (r == "small")
    return `
        font-size: 13px;

        li {
          padding: 5px 10px;
        }

        a {
          padding: 0;
        }
      `;
}}

  ${({
  //@ts-expect-error Property 'width' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>, never>'.ts(2339)
  width: r
}) => {
  if (r)
    return `
        min-width: ${r}px;
      `;
}}

  hr {
    margin: 5px 0;
    height: 1px;
    border: none;
    background-color: var(--silver-darken-87);
  }
`, Odt = q.li`
  display: flex;
  align-items: center;
  padding: ${({ $noPadding: r }) => r ? "0" : "7px 20px"};
  position: relative;
  color: var(--grey-darken-23);
  white-space: nowrap;
  outline: none;
  font-size: 14px;
  transition: all 150ms linear 0s;
  border-radius: 3px;

  ${({ $isDangerous: r }) => r && "color: var(--red-darken-42);"}

  ${({ $isDisabled: r }) => r ? `
        color: var(--grey-lighten-56);
        pointer-events: none;
        ` : `
        cursor: pointer;

        &:hover,
        &:focus {
          background-color: var(--silver-darken-94);
        }

        &:active {
          background-color: var(--silver-darken-80);
        }
      `}

  &::-moz-focus-inner {
    border: 0;
  }

  ${({ $isActive: r, $isHover: e }) => {
  if (r)
    return `
        background-color: var(--silver-darken-94);

        &:hover, &:focus {
          background-color: var(--silver-darken-94);
        }
      `;
  if (e) return "background-color: var(--silver-darken-94);";
}}

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`, Rdt = rs`
  display: flex;
  align-items: center;
  padding: 7px 20px;
  color: inherit;
  white-space: nowrap;
  outline: none;
  text-decoration: none;
`;
q.a`
  ${Rdt}
`;
q.div`
  padding: var(--spacing-tiny) var(--spacing-medium, 20px) 0px;
  color: var(--cm-color-ui-light6);
  font-family: var(--cm-font-text);
  font-size: 11px;
`;
const Vdt = q(Pxe)`
  &.cds--menu-item-divider {
    padding: 0;
  }
`;
function Hdt({
  //@ts-expect-error Binding element 'children' implicitly has an 'any' type.ts(7031)
  children: r,
  //@ts-expect-error Binding element 'noPadding' implicitly has an 'any' type.ts(7031)
  noPadding: e,
  //@ts-expect-error Binding element 'disabled' implicitly has an 'any' type.ts(7031)
  disabled: t,
  ...n
}) {
  return /* @__PURE__ */ x.jsx(
    Odt,
    {
      disabled: t,
      tabIndex: "0",
      role: "menuitem",
      $noPadding: e,
      ...n,
      children: /* @__PURE__ */ x.jsx(V2, { title: r, showOnlyOnOverflow: !0, children: /* @__PURE__ */ x.jsx("div", { className: "overflow-ellipsis", children: r }) })
    }
  );
}
let j0 = class extends r7 {
  state = {};
  ref = Vxe();
  //@ts-expect-error type-error
  componentDidUpdate(e) {
    e.open != this.props.open && (this.props.open ? this.init() : this.reset());
  }
  componentWillUnmount() {
    this.reset();
  }
  init() {
    document.body.addEventListener("click", this.handleBodyClick, !0), window.addEventListener("keydown", this.handleKeyPress), window.addEventListener("scroll", this.handleClose), this.setState(this.position);
  }
  reset() {
    document.body.removeEventListener("click", this.handleBodyClick, !0), window.removeEventListener("keydown", this.handleKeyPress), window.removeEventListener("scroll", this.handleClose);
  }
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleBodyClick = (e) => {
    e.target.id !== "runtime-download" && !e.target.closest("[data-dropdown]") && this.handleClose(e);
  };
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleKeyPress = (e) => {
    e.key == "Escape" && this.handleClose(e);
  };
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleClose = (e) => {
    e.preventDefault(), typeof this.props.onClose == "function" && (e.stopPropagation(), this.props.onClose(e));
  };
  get position() {
    const e = {};
    if (this.props.anchorEl && this.props.open && this.ref.current) {
      const t = this.props.anchorEl.getBoundingClientRect();
      this.props.align == "left" ? document.body.offsetWidth - t.right > this.props.width ? e.left = t.left : e.right = document.body.offsetWidth - t.right : t.right < this.props.width ? e.left = t.left : e.right = document.body.offsetWidth - t.right, document.body.offsetHeight - t.bottom > //@ts-expect-error Property 'offsetHeight' does not exist on type '{}'.ts(2339)
      this.ref.current.offsetHeight ? e.top = t.bottom : e.top = t.top - this.ref.current.offsetHeight;
    }
    return e;
  }
  render() {
    return this.props.open ? un(
      /* @__PURE__ */ x.jsx(
        Idt,
        {
          size: this.props.size,
          role: "menu",
          "data-dropdown": !0,
          style: this.state,
          "data-test": this.props["data-test"],
          width: this.props.width,
          ref: this.ref,
          children: this.props.children
        }
      ),
      document.body
    ) : null;
  }
};
j0.propTypes = {
  onClose: Hn.func,
  anchorEl: Hn.object,
  align: Hn.string,
  open: Hn.bool.isRequired,
  size: Hn.string,
  width: Hn.number
};
j0.defaultProps = {
  open: !1,
  size: "normal",
  align: "right",
  width: 200
};
j0.ListItem = Hdt;
j0.ListItemDivider = Vdt;
const sve = q.header`
  width: 100%;
  background: white;

  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--cds-border-subtle-01, #e0e0e0);
`, Bdt = q.div`
  display: flex;
  align-items: center;
  padding: 6px 10px 6px 20px;
`, Pdt = q.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  margin-left: 14px;
  width: 768px;
`, cE = q.th`
  color: #525252;
  font-size: 12px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.32px;
  word-wrap: break-word;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 256px;
`, hE = q.td`
  color: #525252;
  font-size: 14px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 256px;
`, Fdt = q(ji)`
  color: #0f62fe;
  font-size: 14px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  height: 20px;
`, zdt = q(Wg)`
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  background: var(--cds-layer-accent, #e0e0e0);

  inset: 3rem 0 0 0;

  span.cds--popover-container {
    display: inline-block;
    position: absolute;
    right: 8px;
  }

  background-color: #fff1f1;
  border: 1px solid #da1e28;
  height: 3rem;
  padding: 0;
  width: 100%;
  gap: 1rem;
`, ove = ({ isOpen: r = !1, onClick: e }) => r ? /* @__PURE__ */ x.jsxs(zdt, { role: "banner", "data-test": "banner", children: [
  /* @__PURE__ */ x.jsx("div", { children: "We were not able to retrieve some of the information required to proceed" }),
  " ",
  /* @__PURE__ */ x.jsx(Rn, { kind: "tertiary", size: "sm", renderIcon: uw, onClick: e, children: "Retry" })
] }) : null, ave = {
  process: void 0,
  status: "initial"
};
let Wdt = class {
  state = { ...ave };
  constructor() {
    Hi(this);
  }
  fetchInstances = async ({ id: e }) => {
    this.startFetching();
    const { success: t, process: n } = await _t.fetchInstances({
      id: e
    });
    t ? this.handleSuccess(n?.processInstances?.nodes) : this.handleError();
  };
  handleSuccess = (e) => {
    this.state.process = e, this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset = () => {
    this.state = { ...ave };
  };
};
const MM = new Wdt(), jdt = rt(() => {
  const r = bn(Cr), { instanceKey: e, processInstance: t } = Kt.state, n = MM.state.status === "error" || uf.state.status === "error" || M3.state.status === "error" || y7.state.status === "error" || D3.state.status === "error" || b8.state.status === "error" || C7.state.status === "error" || tl.state.status === "error" || ts.state.status === "error" || y8.state.status === "error" || Ro.state.status === "error" || Kt.state.status === "error";
  if (n)
    return /* @__PURE__ */ x.jsx(sve, { children: /* @__PURE__ */ x.jsx(ove, { isOpen: n, onClick: r.reloadFailedAPIs }) });
  if (!e || !t)
    return null;
  const i = t.incidents.length > 0 ? "INCIDENT" : t.state;
  return /* @__PURE__ */ x.jsxs(sve, { children: [
    /* @__PURE__ */ x.jsxs(Bdt, { children: [
      /* @__PURE__ */ x.jsx(AI, { state: i, size: 24 }),
      /* @__PURE__ */ x.jsxs(Pdt, { children: [
        /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(cE, { children: "Process Instance Key" }),
          /* @__PURE__ */ x.jsx(cE, { children: "Started at" }),
          /* @__PURE__ */ x.jsx(cE, { children: "Process Instances" })
        ] }) }),
        /* @__PURE__ */ x.jsx("tbody", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(hE, { children: e }),
          /* @__PURE__ */ x.jsx(hE, { children: bMe(t.startTime) }),
          /* @__PURE__ */ x.jsx(hE, { children: /* @__PURE__ */ x.jsx(
            Fdt,
            {
              variant: "text",
              onClick: () => {
                Kt.reset();
              },
              children: "View all"
            }
          ) })
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx(ove, { isOpen: n, onClick: r.reloadFailedAPIs })
  ] });
}), Zdt = q.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--cds-layer);
  border-right: 1px solid rgb(216, 220, 227);
  border-top: 1px solid rgb(216, 220, 227);
`, Udt = q.div`
  flex: 1;
  overflow: auto;
  border-top: solid 1px var(--cds-border-subtle-01);

  ${({ $isEmpty: r }) => r && `
    display: flex;
    align-items: center;
    
  `}
`, qdt = q.div`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  flex: 1;
  text-align: center;
`, Gdt = q.table`
  border-collapse: separate;
  border-spacing: 8px;
  width: calc(100% - 16px);
  margin: 8px;
`, Qdt = q.thead`
  text-align: left;
  color: var(--text-text-secondary, #525252);

  font-family: IBM Plex Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.32px;
`, Kdt = q.tbody`
  color: var(--text-text-primary, #161616);

  font-family: IBM Plex Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.16px;

  td {
    height: 32px;
    vertical-align: top;
  }
`, Ydt = q.th`
  width: 15%;
`, Xdt = q.th`
  width: 80%;
`, Jdt = q.th`
  width: 5%;
`, $dt = q.td`
  display: flex;
  align-items: center;
  text-align: right;
  width: 5%;
`, lve = q(Rn)`
  margin-top: -15px;
  transform: translateY(9px);
`, eut = q.td`
  width: 15%;
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, tut = q.td`
  width: 80%;
`, CMe = zg`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
q.span`
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 8px 15px;
  border: 3px solid var(--cds-blue-60, #0f62fe);
  border-bottom-color: transparent;
  animation: ${CMe} 1.2s linear infinite;
`;
const nut = q.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  margin-top: 5px;
  border: 2px solid var(--cds-blue-60, #0f62fe);
  border-bottom-color: transparent;
  animation: ${CMe} 1.2s linear infinite;
`, iut = q(s7)`
  .cds--snippet-container {
    width: 100%;
  }
`;
function Lr(r) {
  const e = JSON.parse(
    localStorage.getItem("historyEntries") || "[]"
  );
  for (e.includes(r) || e.push(r); e.length > 20; ) {
    const n = e.shift();
    localStorage.removeItem("history " + n);
  }
  return localStorage.setItem("historyEntries", JSON.stringify(e)), `history ${r}`;
}
function is(r, e) {
  const t = localStorage.getItem(r) || "[]", n = JSON.parse(t);
  localStorage.setItem(r, JSON.stringify([...n, e]));
}
function rut(r, e) {
  localStorage.setItem(r, JSON.stringify(e));
}
function sut(r) {
  return JSON.parse(localStorage.getItem(r) || "[]");
}
function EMe(r, e = "	") {
  try {
    const t = JSON.parse(r);
    return JSON.stringify(t, null, e);
  } catch {
    return r;
  }
}
function qo(r, e = 0) {
  return r[r.length - (1 + e)];
}
function out(r) {
  if (r.length === 0)
    throw new Error("Invalid tail call");
  return [r.slice(0, r.length - 1), r[r.length - 1]];
}
function Zi(r, e, t = (n, i) => n === i) {
  if (r === e)
    return !0;
  if (!r || !e || r.length !== e.length)
    return !1;
  for (let n = 0, i = r.length; n < i; n++)
    if (!t(r[n], e[n]))
      return !1;
  return !0;
}
function aut(r, e) {
  const t = r.length - 1;
  e < t && (r[e] = r[t]), r.pop();
}
function lut(r, e, t) {
  return cut(r.length, (n) => t(r[n], e));
}
function cut(r, e) {
  let t = 0, n = r - 1;
  for (; t <= n; ) {
    const i = (t + n) / 2 | 0, s = e(i);
    if (s < 0)
      t = i + 1;
    else if (s > 0)
      n = i - 1;
    else
      return i;
  }
  return -(t + 1);
}
function* wI(r, e) {
  let t, n;
  for (const i of r)
    n !== void 0 && e(n, i) ? t.push(i) : (t && (yield t), t = [i]), n = i;
  t && (yield t);
}
function _Me(r, e) {
  for (let t = 0; t <= r.length; t++)
    e(t === 0 ? void 0 : r[t - 1], t === r.length ? void 0 : r[t]);
}
function hut(r, e) {
  for (let t = 0; t < r.length; t++)
    e(t === 0 ? void 0 : r[t - 1], r[t], t + 1 === r.length ? void 0 : r[t + 1]);
}
function xMe(r) {
  return r.filter((e) => !!e);
}
function cve(r) {
  let e = 0;
  for (let t = 0; t < r.length; t++)
    r[t] && (r[e] = r[t], e += 1);
  r.length = e;
}
function dut(r) {
  return !Array.isArray(r) || r.length === 0;
}
function k7(r) {
  return Array.isArray(r) && r.length > 0;
}
function ff(r, e = (t) => t) {
  const t = /* @__PURE__ */ new Set();
  return r.filter((n) => {
    const i = e(n);
    return t.has(i) ? !1 : (t.add(i), !0);
  });
}
function vI(r, e) {
  return r.length > 0 ? r[0] : e;
}
function ks(r, e) {
  let t = typeof e == "number" ? r : 0;
  typeof e == "number" ? t = r : (t = 0, e = r);
  const n = [];
  if (t <= e)
    for (let i = t; i < e; i++)
      n.push(i);
  else
    for (let i = t; i > e; i--)
      n.push(i);
  return n;
}
function N7(r, e, t) {
  const n = r.slice(0, e), i = r.slice(e);
  return n.concat(t, i);
}
function dE(r, e) {
  const t = r.indexOf(e);
  t > -1 && (r.splice(t, 1), r.unshift(e));
}
function yv(r, e) {
  const t = r.indexOf(e);
  t > -1 && (r.splice(t, 1), r.push(e));
}
function DM(r, e) {
  for (const t of e)
    r.push(t);
}
function uut(r, e, t) {
  const n = SMe(r, e), i = r.length, s = t.length;
  r.length = i + s;
  for (let o = i - 1; o >= n; o--)
    r[o + s] = r[o];
  for (let o = 0; o < s; o++)
    r[o + n] = t[o];
}
function hve(r, e, t, n) {
  const i = SMe(r, e);
  let s = r.splice(i, t);
  return s === void 0 && (s = []), uut(r, i, n), s;
}
function SMe(r, e) {
  return e < 0 ? Math.max(e + r.length, 0) : Math.min(e, r.length);
}
var T3;
(function(r) {
  function e(s) {
    return s < 0;
  }
  r.isLessThan = e;
  function t(s) {
    return s <= 0;
  }
  r.isLessThanOrEqual = t;
  function n(s) {
    return s > 0;
  }
  r.isGreaterThan = n;
  function i(s) {
    return s === 0;
  }
  r.isNeitherLessOrGreaterThan = i, r.greaterThan = 1, r.lessThan = -1, r.neitherLessOrGreaterThan = 0;
})(T3 || (T3 = {}));
function al(r, e) {
  return (t, n) => e(r(t), r(n));
}
function fut(...r) {
  return (e, t) => {
    for (const n of r) {
      const i = n(e, t);
      if (!T3.isNeitherLessOrGreaterThan(i))
        return i;
    }
    return T3.neitherLessOrGreaterThan;
  };
}
const Gu = (r, e) => r - e, put = (r, e) => Gu(r ? 1 : 0, e ? 1 : 0);
function gut(r) {
  return (e, t) => -r(e, t);
}
class Hd {
  /**
   * Constructs a queue that is backed by the given array. Runtime is O(1).
  */
  constructor(e) {
    this.items = e, this.firstIdx = 0, this.lastIdx = this.items.length - 1;
  }
  get length() {
    return this.lastIdx - this.firstIdx + 1;
  }
  /**
   * Consumes elements from the beginning of the queue as long as the predicate returns true.
   * If no elements were consumed, `null` is returned. Has a runtime of O(result.length).
  */
  takeWhile(e) {
    let t = this.firstIdx;
    for (; t < this.items.length && e(this.items[t]); )
      t++;
    const n = t === this.firstIdx ? null : this.items.slice(this.firstIdx, t);
    return this.firstIdx = t, n;
  }
  /**
   * Consumes elements from the end of the queue as long as the predicate returns true.
   * If no elements were consumed, `null` is returned.
   * The result has the same order as the underlying array!
  */
  takeFromEndWhile(e) {
    let t = this.lastIdx;
    for (; t >= 0 && e(this.items[t]); )
      t--;
    const n = t === this.lastIdx ? null : this.items.slice(t + 1, this.lastIdx + 1);
    return this.lastIdx = t, n;
  }
  peek() {
    if (this.length !== 0)
      return this.items[this.firstIdx];
  }
  dequeue() {
    const e = this.items[this.firstIdx];
    return this.firstIdx++, e;
  }
  takeCount(e) {
    const t = this.items.slice(this.firstIdx, this.firstIdx + e);
    return this.firstIdx += e, t;
  }
}
class bd {
  static {
    this.empty = new bd((e) => {
    });
  }
  constructor(e) {
    this.iterate = e;
  }
  toArray() {
    const e = [];
    return this.iterate((t) => (e.push(t), !0)), e;
  }
  filter(e) {
    return new bd((t) => this.iterate((n) => e(n) ? t(n) : !0));
  }
  map(e) {
    return new bd((t) => this.iterate((n) => t(e(n))));
  }
  findLast(e) {
    let t;
    return this.iterate((n) => (e(n) && (t = n), !0)), t;
  }
  findLastMaxBy(e) {
    let t, n = !0;
    return this.iterate((i) => ((n || T3.isGreaterThan(e(i, t))) && (n = !1, t = i), !0)), t;
  }
}
function Vo(r) {
  return typeof r == "string";
}
function Rs(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r) && !(r instanceof RegExp) && !(r instanceof Date);
}
function mut(r) {
  const e = Object.getPrototypeOf(Uint8Array);
  return typeof r == "object" && r instanceof e;
}
function Kg(r) {
  return typeof r == "number" && !isNaN(r);
}
function dve(r) {
  return !!r && typeof r[Symbol.iterator] == "function";
}
function MMe(r) {
  return r === !0 || r === !1;
}
function da(r) {
  return typeof r > "u";
}
function tg(r) {
  return !Mo(r);
}
function Mo(r) {
  return da(r) || r === null;
}
function Qu(r, e) {
  if (!r)
    throw new Error("Unexpected type");
}
function E8(r) {
  if (Mo(r))
    throw new Error("Assertion Failed: argument is undefined or null");
  return r;
}
function _8(r) {
  return typeof r == "function";
}
function Aut(r, e) {
  const t = Math.min(r.length, e.length);
  for (let n = 0; n < t; n++)
    wut(r[n], e[n]);
}
function wut(r, e) {
  if (Vo(e)) {
    if (typeof r !== e)
      throw new Error(`argument does not match constraint: typeof ${e}`);
  } else if (_8(e)) {
    try {
      if (r instanceof e)
        return;
    } catch {
    }
    if (!Mo(r) && r.constructor === e || e.length === 1 && e.call(void 0, r) === !0)
      return;
    throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
  }
}
function pu(r) {
  if (!r || typeof r != "object" || r instanceof RegExp)
    return r;
  const e = Array.isArray(r) ? [] : {};
  return Object.entries(r).forEach(([t, n]) => {
    e[t] = n && typeof n == "object" ? pu(n) : n;
  }), e;
}
function vut(r) {
  if (!r || typeof r != "object")
    return r;
  const e = [r];
  for (; e.length > 0; ) {
    const t = e.shift();
    Object.freeze(t);
    for (const n in t)
      if (DMe.call(t, n)) {
        const i = t[n];
        typeof i == "object" && !Object.isFrozen(i) && !mut(i) && e.push(i);
      }
  }
  return r;
}
const DMe = Object.prototype.hasOwnProperty;
function LMe(r, e) {
  return LM(r, e, /* @__PURE__ */ new Set());
}
function LM(r, e, t) {
  if (Mo(r))
    return r;
  const n = e(r);
  if (typeof n < "u")
    return n;
  if (Array.isArray(r)) {
    const i = [];
    for (const s of r)
      i.push(LM(s, e, t));
    return i;
  }
  if (Rs(r)) {
    if (t.has(r))
      throw new Error("Cannot clone recursive data-structure");
    t.add(r);
    const i = {};
    for (const s in r)
      DMe.call(r, s) && (i[s] = LM(r[s], e, t));
    return t.delete(r), i;
  }
  return r;
}
function Ho(r, e) {
  if (r === e)
    return !0;
  if (r == null || e === null || e === void 0 || typeof r != typeof e || typeof r != "object" || Array.isArray(r) !== Array.isArray(e))
    return !1;
  let t, n;
  if (Array.isArray(r)) {
    if (r.length !== e.length)
      return !1;
    for (t = 0; t < r.length; t++)
      if (!Ho(r[t], e[t]))
        return !1;
  } else {
    const i = [];
    for (n in r)
      i.push(n);
    i.sort();
    const s = [];
    for (n in e)
      s.push(n);
    if (s.sort(), !Ho(i, s))
      return !1;
    for (t = 0; t < i.length; t++)
      if (!Ho(r[i[t]], e[i[t]]))
        return !1;
  }
  return !0;
}
function but(r) {
  let e = [];
  for (; Object.prototype !== r; )
    e = e.concat(Object.getOwnPropertyNames(r)), r = Object.getPrototypeOf(r);
  return e;
}
function bI(r) {
  const e = [];
  for (const t of but(r))
    typeof r[t] == "function" && e.push(t);
  return e;
}
function yut(r, e) {
  const t = (i) => function() {
    const s = Array.prototype.slice.call(arguments, 0);
    return e(i, s);
  }, n = {};
  for (const i of r)
    n[i] = t(i);
  return n;
}
function Cut() {
  return globalThis._VSCODE_NLS_MESSAGES;
}
function kMe() {
  return globalThis._VSCODE_NLS_LANGUAGE;
}
const Eut = kMe() === "pseudo" || typeof document < "u" && document.location && document.location.hash.indexOf("pseudo=true") >= 0;
function uve(r, e) {
  let t;
  return e.length === 0 ? t = r : t = r.replace(/\{(\d+)\}/g, (n, i) => {
    const s = i[0], o = e[s];
    let a = n;
    return typeof o == "string" ? a = o : (typeof o == "number" || typeof o == "boolean" || o === void 0 || o === null) && (a = String(o)), a;
  }), Eut && (t = "［" + t.replace(/[aouei]/g, "$&$&") + "］"), t;
}
function C(r, e, ...t) {
  return uve(typeof r == "number" ? _ut(r, e) : e, t);
}
function _ut(r, e) {
  const t = Cut()?.[r];
  if (typeof t != "string") {
    if (typeof e == "string")
      return e;
    throw new Error(`!!! NLS MISSING: ${r} !!!`);
  }
  return t;
}
const U2 = "en";
let x8 = !1, S8 = !1, h6 = !1, NMe = !1, yI = !1, CI = !1, TMe = !1, Cv, uE = U2, fve = U2, xut, jh;
const yd = globalThis;
let Xo;
typeof yd.vscode < "u" && typeof yd.vscode.process < "u" ? Xo = yd.vscode.process : typeof process < "u" && typeof process?.versions?.node == "string" && (Xo = process);
const Sut = typeof Xo?.versions?.electron == "string", Mut = Sut && Xo?.type === "renderer";
if (typeof Xo == "object") {
  x8 = Xo.platform === "win32", S8 = Xo.platform === "darwin", h6 = Xo.platform === "linux", h6 && Xo.env.SNAP && Xo.env.SNAP_REVISION, Xo.env.CI || Xo.env.BUILD_ARTIFACTSTAGINGDIRECTORY, Cv = U2, uE = U2;
  const r = Xo.env.VSCODE_NLS_CONFIG;
  if (r)
    try {
      const e = JSON.parse(r);
      Cv = e.userLocale, fve = e.osLocale, uE = e.resolvedLanguage || U2, xut = e.languagePack?.translationsConfigFile;
    } catch {
    }
  NMe = !0;
} else typeof navigator == "object" && !Mut ? (jh = navigator.userAgent, x8 = jh.indexOf("Windows") >= 0, S8 = jh.indexOf("Macintosh") >= 0, CI = (jh.indexOf("Macintosh") >= 0 || jh.indexOf("iPad") >= 0 || jh.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0, h6 = jh.indexOf("Linux") >= 0, TMe = jh?.indexOf("Mobi") >= 0, yI = !0, uE = kMe() || U2, Cv = navigator.language.toLowerCase(), fve = Cv) : console.error("Unable to resolve platform.");
const zs = x8, zt = S8, Cs = h6, I3 = NMe, Yg = yI, Dut = yI && typeof yd.importScripts == "function", Lut = Dut ? yd.origin : void 0, pf = CI, IMe = TMe, ch = jh, kut = typeof yd.postMessage == "function" && !yd.importScripts, OMe = (() => {
  if (kut) {
    const r = [];
    yd.addEventListener("message", (t) => {
      if (t.data && t.data.vscodeScheduleAsyncWork)
        for (let n = 0, i = r.length; n < i; n++) {
          const s = r[n];
          if (s.id === t.data.vscodeScheduleAsyncWork) {
            r.splice(n, 1), s.callback();
            return;
          }
        }
    });
    let e = 0;
    return (t) => {
      const n = ++e;
      r.push({
        id: n,
        callback: t
      }), yd.postMessage({ vscodeScheduleAsyncWork: n }, "*");
    };
  }
  return (r) => setTimeout(r);
})(), nl = S8 || CI ? 2 : x8 ? 1 : 3;
let pve = !0, gve = !1;
function Nut() {
  if (!gve) {
    gve = !0;
    const r = new Uint8Array(2);
    r[0] = 1, r[1] = 2, pve = new Uint16Array(r.buffer)[0] === 513;
  }
  return pve;
}
const RMe = !!(ch && ch.indexOf("Chrome") >= 0), Tut = !!(ch && ch.indexOf("Firefox") >= 0), Iut = !!(!RMe && ch && ch.indexOf("Safari") >= 0), Out = !!(ch && ch.indexOf("Edg/") >= 0), Rut = !!(ch && ch.indexOf("Android") >= 0), Hr = {
  tabSize: 4,
  indentSize: 4,
  insertSpaces: !0,
  detectIndentation: !0,
  trimAutoWhitespace: !0,
  largeFileOptimizations: !0,
  bracketPairColorizationOptions: {
    enabled: !0,
    independentColorPoolPerBracketType: !1
  }
};
var Jt;
(function(r) {
  function e(_) {
    return _ && typeof _ == "object" && typeof _[Symbol.iterator] == "function";
  }
  r.is = e;
  const t = Object.freeze([]);
  function n() {
    return t;
  }
  r.empty = n;
  function* i(_) {
    yield _;
  }
  r.single = i;
  function s(_) {
    return e(_) ? _ : i(_);
  }
  r.wrap = s;
  function o(_) {
    return _ || t;
  }
  r.from = o;
  function* a(_) {
    for (let S = _.length - 1; S >= 0; S--)
      yield _[S];
  }
  r.reverse = a;
  function l(_) {
    return !_ || _[Symbol.iterator]().next().done === !0;
  }
  r.isEmpty = l;
  function c(_) {
    return _[Symbol.iterator]().next().value;
  }
  r.first = c;
  function d(_, S) {
    let D = 0;
    for (const M of _)
      if (S(M, D++))
        return !0;
    return !1;
  }
  r.some = d;
  function u(_, S) {
    for (const D of _)
      if (S(D))
        return D;
  }
  r.find = u;
  function* f(_, S) {
    for (const D of _)
      S(D) && (yield D);
  }
  r.filter = f;
  function* p(_, S) {
    let D = 0;
    for (const M of _)
      yield S(M, D++);
  }
  r.map = p;
  function* g(_, S) {
    let D = 0;
    for (const M of _)
      yield* S(M, D++);
  }
  r.flatMap = g;
  function* m(..._) {
    for (const S of _)
      yield* S;
  }
  r.concat = m;
  function A(_, S, D) {
    let M = D;
    for (const L of _)
      M = S(M, L);
    return M;
  }
  r.reduce = A;
  function* w(_, S, D = _.length) {
    for (S < 0 && (S += _.length), D < 0 ? D += _.length : D > _.length && (D = _.length); S < D; S++)
      yield _[S];
  }
  r.slice = w;
  function v(_, S = Number.POSITIVE_INFINITY) {
    const D = [];
    if (S === 0)
      return [D, _];
    const M = _[Symbol.iterator]();
    for (let L = 0; L < S; L++) {
      const T = M.next();
      if (T.done)
        return [D, r.empty()];
      D.push(T.value);
    }
    return [D, { [Symbol.iterator]() {
      return M;
    } }];
  }
  r.consume = v;
  async function y(_) {
    const S = [];
    for await (const D of _)
      S.push(D);
    return Promise.resolve(S);
  }
  r.asyncToArray = y;
})(Jt || (Jt = {}));
let Bi = class d6 {
  static {
    this.Undefined = new d6(void 0);
  }
  constructor(e) {
    this.element = e, this.next = d6.Undefined, this.prev = d6.Undefined;
  }
};
class no {
  constructor() {
    this._first = Bi.Undefined, this._last = Bi.Undefined, this._size = 0;
  }
  get size() {
    return this._size;
  }
  isEmpty() {
    return this._first === Bi.Undefined;
  }
  clear() {
    let e = this._first;
    for (; e !== Bi.Undefined; ) {
      const t = e.next;
      e.prev = Bi.Undefined, e.next = Bi.Undefined, e = t;
    }
    this._first = Bi.Undefined, this._last = Bi.Undefined, this._size = 0;
  }
  unshift(e) {
    return this._insert(e, !1);
  }
  push(e) {
    return this._insert(e, !0);
  }
  _insert(e, t) {
    const n = new Bi(e);
    if (this._first === Bi.Undefined)
      this._first = n, this._last = n;
    else if (t) {
      const s = this._last;
      this._last = n, n.prev = s, s.next = n;
    } else {
      const s = this._first;
      this._first = n, n.next = s, s.prev = n;
    }
    this._size += 1;
    let i = !1;
    return () => {
      i || (i = !0, this._remove(n));
    };
  }
  shift() {
    if (this._first !== Bi.Undefined) {
      const e = this._first.element;
      return this._remove(this._first), e;
    }
  }
  pop() {
    if (this._last !== Bi.Undefined) {
      const e = this._last.element;
      return this._remove(this._last), e;
    }
  }
  _remove(e) {
    if (e.prev !== Bi.Undefined && e.next !== Bi.Undefined) {
      const t = e.prev;
      t.next = e.next, e.next.prev = t;
    } else e.prev === Bi.Undefined && e.next === Bi.Undefined ? (this._first = Bi.Undefined, this._last = Bi.Undefined) : e.next === Bi.Undefined ? (this._last = this._last.prev, this._last.next = Bi.Undefined) : e.prev === Bi.Undefined && (this._first = this._first.next, this._first.prev = Bi.Undefined);
    this._size -= 1;
  }
  *[Symbol.iterator]() {
    let e = this._first;
    for (; e !== Bi.Undefined; )
      yield e.element, e = e.next;
  }
}
const VMe = "`~!@#$%^&*()-=+[{]}\\|;:'\",.<>/?";
function Vut(r = "") {
  let e = "(-?\\d*\\.\\d\\w*)|([^";
  for (const t of VMe)
    r.indexOf(t) >= 0 || (e += "\\" + t);
  return e += "\\s]+)", new RegExp(e, "g");
}
const EI = Vut();
function _I(r) {
  let e = EI;
  if (r && r instanceof RegExp)
    if (r.global)
      e = r;
    else {
      let t = "g";
      r.ignoreCase && (t += "i"), r.multiline && (t += "m"), r.unicode && (t += "u"), e = new RegExp(r.source, t);
    }
  return e.lastIndex = 0, e;
}
const HMe = new no();
HMe.unshift({
  maxLen: 1e3,
  windowSize: 15,
  timeBudget: 150
});
function O3(r, e, t, n, i) {
  if (e = _I(e), i || (i = Jt.first(HMe)), t.length > i.maxLen) {
    let c = r - i.maxLen / 2;
    return c < 0 ? c = 0 : n += c, t = t.substring(c, r + i.maxLen / 2), O3(r, e, t, n, i);
  }
  const s = Date.now(), o = r - 1 - n;
  let a = -1, l = null;
  for (let c = 1; !(Date.now() - s >= i.timeBudget); c++) {
    const d = o - i.windowSize * c;
    e.lastIndex = Math.max(0, d);
    const u = Hut(e, t, o, a);
    if (!u && l || (l = u, d <= 0))
      break;
    a = d;
  }
  if (l) {
    const c = {
      word: l[0],
      startColumn: n + 1 + l.index,
      endColumn: n + 1 + l.index + l[0].length
    };
    return e.lastIndex = 0, c;
  }
  return null;
}
function Hut(r, e, t, n) {
  let i;
  for (; i = r.exec(e); ) {
    const s = i.index || 0;
    if (s <= t && r.lastIndex >= t)
      return i;
    if (n > 0 && s > n)
      return null;
  }
  return null;
}
const Rc = 8;
class BMe {
  /**
   * @internal
   */
  constructor(e) {
    this._values = e;
  }
  hasChanged(e) {
    return this._values[e];
  }
}
class PMe {
  constructor() {
    this.stableMinimapLayoutInput = null, this.stableFitMaxMinimapScale = 0, this.stableFitRemainingWidth = 0;
  }
}
class Wn {
  constructor(e, t, n, i) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = i;
  }
  applyUpdate(e, t) {
    return T7(e, t);
  }
  compute(e, t, n) {
    return n;
  }
}
class RA {
  constructor(e, t) {
    this.newValue = e, this.didChange = t;
  }
}
function T7(r, e) {
  if (typeof r != "object" || typeof e != "object" || !r || !e)
    return new RA(e, r !== e);
  if (Array.isArray(r) || Array.isArray(e)) {
    const n = Array.isArray(r) && Array.isArray(e) && Zi(r, e);
    return new RA(e, !n);
  }
  let t = !1;
  for (const n in e)
    if (e.hasOwnProperty(n)) {
      const i = T7(r[n], e[n]);
      i.didChange && (r[n] = i.newValue, t = !0);
    }
  return new RA(r, t);
}
class pw {
  constructor(e) {
    this.schema = void 0, this.id = e, this.name = "_never_", this.defaultValue = void 0;
  }
  applyUpdate(e, t) {
    return T7(e, t);
  }
  validate(e) {
    return this.defaultValue;
  }
}
class Xg {
  constructor(e, t, n, i) {
    this.id = e, this.name = t, this.defaultValue = n, this.schema = i;
  }
  applyUpdate(e, t) {
    return T7(e, t);
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : e;
  }
  compute(e, t, n) {
    return n;
  }
}
function Re(r, e) {
  return typeof r > "u" ? e : r === "false" ? !1 : !!r;
}
class Rt extends Xg {
  constructor(e, t, n, i = void 0) {
    typeof i < "u" && (i.type = "boolean", i.default = n), super(e, t, n, i);
  }
  validate(e) {
    return Re(e, this.defaultValue);
  }
}
function n0(r, e, t, n) {
  if (typeof r > "u")
    return e;
  let i = parseInt(r, 10);
  return isNaN(i) ? e : (i = Math.max(t, i), i = Math.min(n, i), i | 0);
}
class Cn extends Xg {
  static clampedInt(e, t, n, i) {
    return n0(e, t, n, i);
  }
  constructor(e, t, n, i, s, o = void 0) {
    typeof o < "u" && (o.type = "integer", o.default = n, o.minimum = i, o.maximum = s), super(e, t, n, o), this.minimum = i, this.maximum = s;
  }
  validate(e) {
    return Cn.clampedInt(e, this.defaultValue, this.minimum, this.maximum);
  }
}
function But(r, e, t, n) {
  if (typeof r > "u")
    return e;
  const i = No.float(r, e);
  return No.clamp(i, t, n);
}
class No extends Xg {
  static clamp(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static float(e, t) {
    if (typeof e == "number")
      return e;
    if (typeof e > "u")
      return t;
    const n = parseFloat(e);
    return isNaN(n) ? t : n;
  }
  constructor(e, t, n, i, s) {
    typeof s < "u" && (s.type = "number", s.default = n), super(e, t, n, s), this.validationFn = i;
  }
  validate(e) {
    return this.validationFn(No.float(e, this.defaultValue));
  }
}
class $r extends Xg {
  static string(e, t) {
    return typeof e != "string" ? t : e;
  }
  constructor(e, t, n, i = void 0) {
    typeof i < "u" && (i.type = "string", i.default = n), super(e, t, n, i);
  }
  validate(e) {
    return $r.string(e, this.defaultValue);
  }
}
function ai(r, e, t, n) {
  return typeof r != "string" ? e : n && r in n ? n[r] : t.indexOf(r) === -1 ? e : r;
}
class si extends Xg {
  constructor(e, t, n, i, s = void 0) {
    typeof s < "u" && (s.type = "string", s.enum = i, s.default = n), super(e, t, n, s), this._allowedValues = i;
  }
  validate(e) {
    return ai(e, this.defaultValue, this._allowedValues);
  }
}
class Ev extends Wn {
  constructor(e, t, n, i, s, o, a = void 0) {
    typeof a < "u" && (a.type = "string", a.enum = s, a.default = i), super(e, t, n, a), this._allowedValues = s, this._convert = o;
  }
  validate(e) {
    return typeof e != "string" ? this.defaultValue : this._allowedValues.indexOf(e) === -1 ? this.defaultValue : this._convert(e);
  }
}
function Put(r) {
  switch (r) {
    case "none":
      return 0;
    case "keep":
      return 1;
    case "brackets":
      return 2;
    case "advanced":
      return 3;
    case "full":
      return 4;
  }
}
class Fut extends Wn {
  constructor() {
    super(2, "accessibilitySupport", 0, {
      type: "string",
      enum: ["auto", "on", "off"],
      enumDescriptions: [
        C("accessibilitySupport.auto", "Use platform APIs to detect when a Screen Reader is attached."),
        C("accessibilitySupport.on", "Optimize for usage with a Screen Reader."),
        C("accessibilitySupport.off", "Assume a screen reader is not attached.")
      ],
      default: "auto",
      tags: ["accessibility"],
      description: C("accessibilitySupport", "Controls if the UI should run in a mode where it is optimized for screen readers.")
    });
  }
  validate(e) {
    switch (e) {
      case "auto":
        return 0;
      case "off":
        return 1;
      case "on":
        return 2;
    }
    return this.defaultValue;
  }
  compute(e, t, n) {
    return n === 0 ? e.accessibilitySupport : n;
  }
}
class zut extends Wn {
  constructor() {
    const e = {
      insertSpace: !0,
      ignoreEmptyLines: !0
    };
    super(23, "comments", e, {
      "editor.comments.insertSpace": {
        type: "boolean",
        default: e.insertSpace,
        description: C("comments.insertSpace", "Controls whether a space character is inserted when commenting.")
      },
      "editor.comments.ignoreEmptyLines": {
        type: "boolean",
        default: e.ignoreEmptyLines,
        description: C("comments.ignoreEmptyLines", "Controls if empty lines should be ignored with toggle, add or remove actions for line comments.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      insertSpace: Re(t.insertSpace, this.defaultValue.insertSpace),
      ignoreEmptyLines: Re(t.ignoreEmptyLines, this.defaultValue.ignoreEmptyLines)
    };
  }
}
function Wut(r) {
  switch (r) {
    case "blink":
      return 1;
    case "smooth":
      return 2;
    case "phase":
      return 3;
    case "expand":
      return 4;
    case "solid":
      return 5;
  }
}
var gr;
(function(r) {
  r[r.Line = 1] = "Line", r[r.Block = 2] = "Block", r[r.Underline = 3] = "Underline", r[r.LineThin = 4] = "LineThin", r[r.BlockOutline = 5] = "BlockOutline", r[r.UnderlineThin = 6] = "UnderlineThin";
})(gr || (gr = {}));
function jut(r) {
  switch (r) {
    case "line":
      return gr.Line;
    case "block":
      return gr.Block;
    case "underline":
      return gr.Underline;
    case "line-thin":
      return gr.LineThin;
    case "block-outline":
      return gr.BlockOutline;
    case "underline-thin":
      return gr.UnderlineThin;
  }
}
class Zut extends pw {
  constructor() {
    super(
      143
      /* EditorOption.editorClassName */
    );
  }
  compute(e, t, n) {
    const i = ["monaco-editor"];
    return t.get(
      39
      /* EditorOption.extraEditorClassName */
    ) && i.push(t.get(
      39
      /* EditorOption.extraEditorClassName */
    )), e.extraEditorClassName && i.push(e.extraEditorClassName), t.get(
      74
      /* EditorOption.mouseStyle */
    ) === "default" ? i.push("mouse-default") : t.get(
      74
      /* EditorOption.mouseStyle */
    ) === "copy" && i.push("mouse-copy"), t.get(
      112
      /* EditorOption.showUnused */
    ) && i.push("showUnused"), t.get(
      141
      /* EditorOption.showDeprecated */
    ) && i.push("showDeprecated"), i.join(" ");
  }
}
class Uut extends Rt {
  constructor() {
    super(37, "emptySelectionClipboard", !0, { description: C("emptySelectionClipboard", "Controls whether copying without a selection copies the current line.") });
  }
  compute(e, t, n) {
    return n && e.emptySelectionClipboard;
  }
}
class qut extends Wn {
  constructor() {
    const e = {
      cursorMoveOnType: !0,
      seedSearchStringFromSelection: "always",
      autoFindInSelection: "never",
      globalFindClipboard: !1,
      addExtraSpaceOnTop: !0,
      loop: !0
    };
    super(41, "find", e, {
      "editor.find.cursorMoveOnType": {
        type: "boolean",
        default: e.cursorMoveOnType,
        description: C("find.cursorMoveOnType", "Controls whether the cursor should jump to find matches while typing.")
      },
      "editor.find.seedSearchStringFromSelection": {
        type: "string",
        enum: ["never", "always", "selection"],
        default: e.seedSearchStringFromSelection,
        enumDescriptions: [
          C("editor.find.seedSearchStringFromSelection.never", "Never seed search string from the editor selection."),
          C("editor.find.seedSearchStringFromSelection.always", "Always seed search string from the editor selection, including word at cursor position."),
          C("editor.find.seedSearchStringFromSelection.selection", "Only seed search string from the editor selection.")
        ],
        description: C("find.seedSearchStringFromSelection", "Controls whether the search string in the Find Widget is seeded from the editor selection.")
      },
      "editor.find.autoFindInSelection": {
        type: "string",
        enum: ["never", "always", "multiline"],
        default: e.autoFindInSelection,
        enumDescriptions: [
          C("editor.find.autoFindInSelection.never", "Never turn on Find in Selection automatically (default)."),
          C("editor.find.autoFindInSelection.always", "Always turn on Find in Selection automatically."),
          C("editor.find.autoFindInSelection.multiline", "Turn on Find in Selection automatically when multiple lines of content are selected.")
        ],
        description: C("find.autoFindInSelection", "Controls the condition for turning on Find in Selection automatically.")
      },
      "editor.find.globalFindClipboard": {
        type: "boolean",
        default: e.globalFindClipboard,
        description: C("find.globalFindClipboard", "Controls whether the Find Widget should read or modify the shared find clipboard on macOS."),
        included: zt
      },
      "editor.find.addExtraSpaceOnTop": {
        type: "boolean",
        default: e.addExtraSpaceOnTop,
        description: C("find.addExtraSpaceOnTop", "Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.")
      },
      "editor.find.loop": {
        type: "boolean",
        default: e.loop,
        description: C("find.loop", "Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      cursorMoveOnType: Re(t.cursorMoveOnType, this.defaultValue.cursorMoveOnType),
      seedSearchStringFromSelection: typeof e.seedSearchStringFromSelection == "boolean" ? e.seedSearchStringFromSelection ? "always" : "never" : ai(t.seedSearchStringFromSelection, this.defaultValue.seedSearchStringFromSelection, ["never", "always", "selection"]),
      autoFindInSelection: typeof e.autoFindInSelection == "boolean" ? e.autoFindInSelection ? "always" : "never" : ai(t.autoFindInSelection, this.defaultValue.autoFindInSelection, ["never", "always", "multiline"]),
      globalFindClipboard: Re(t.globalFindClipboard, this.defaultValue.globalFindClipboard),
      addExtraSpaceOnTop: Re(t.addExtraSpaceOnTop, this.defaultValue.addExtraSpaceOnTop),
      loop: Re(t.loop, this.defaultValue.loop)
    };
  }
}
class Bl extends Wn {
  static {
    this.OFF = '"liga" off, "calt" off';
  }
  static {
    this.ON = '"liga" on, "calt" on';
  }
  constructor() {
    super(51, "fontLigatures", Bl.OFF, {
      anyOf: [
        {
          type: "boolean",
          description: C("fontLigatures", "Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.")
        },
        {
          type: "string",
          description: C("fontFeatureSettings", "Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.")
        }
      ],
      description: C("fontLigaturesGeneral", "Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property."),
      default: !1
    });
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : typeof e == "string" ? e === "false" || e.length === 0 ? Bl.OFF : e === "true" ? Bl.ON : e : e ? Bl.ON : Bl.OFF;
  }
}
class rd extends Wn {
  static {
    this.OFF = "normal";
  }
  static {
    this.TRANSLATE = "translate";
  }
  constructor() {
    super(54, "fontVariations", rd.OFF, {
      anyOf: [
        {
          type: "boolean",
          description: C("fontVariations", "Enables/Disables the translation from font-weight to font-variation-settings. Change this to a string for fine-grained control of the 'font-variation-settings' CSS property.")
        },
        {
          type: "string",
          description: C("fontVariationSettings", "Explicit 'font-variation-settings' CSS property. A boolean can be passed instead if one only needs to translate font-weight to font-variation-settings.")
        }
      ],
      description: C("fontVariationsGeneral", "Configures font variations. Can be either a boolean to enable/disable the translation from font-weight to font-variation-settings or a string for the value of the CSS 'font-variation-settings' property."),
      default: !1
    });
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : typeof e == "string" ? e === "false" ? rd.OFF : e === "true" ? rd.TRANSLATE : e : e ? rd.TRANSLATE : rd.OFF;
  }
  compute(e, t, n) {
    return e.fontInfo.fontVariationSettings;
  }
}
class Gut extends pw {
  constructor() {
    super(
      50
      /* EditorOption.fontInfo */
    );
  }
  compute(e, t, n) {
    return e.fontInfo;
  }
}
class Qut extends Xg {
  constructor() {
    super(52, "fontSize", Bo.fontSize, {
      type: "number",
      minimum: 6,
      maximum: 100,
      default: Bo.fontSize,
      description: C("fontSize", "Controls the font size in pixels.")
    });
  }
  validate(e) {
    const t = No.float(e, this.defaultValue);
    return t === 0 ? Bo.fontSize : No.clamp(t, 6, 100);
  }
  compute(e, t, n) {
    return e.fontInfo.fontSize;
  }
}
class f0 extends Wn {
  static {
    this.SUGGESTION_VALUES = ["normal", "bold", "100", "200", "300", "400", "500", "600", "700", "800", "900"];
  }
  static {
    this.MINIMUM_VALUE = 1;
  }
  static {
    this.MAXIMUM_VALUE = 1e3;
  }
  constructor() {
    super(53, "fontWeight", Bo.fontWeight, {
      anyOf: [
        {
          type: "number",
          minimum: f0.MINIMUM_VALUE,
          maximum: f0.MAXIMUM_VALUE,
          errorMessage: C("fontWeightErrorMessage", 'Only "normal" and "bold" keywords or numbers between 1 and 1000 are allowed.')
        },
        {
          type: "string",
          pattern: "^(normal|bold|1000|[1-9][0-9]{0,2})$"
        },
        {
          enum: f0.SUGGESTION_VALUES
        }
      ],
      default: Bo.fontWeight,
      description: C("fontWeight", 'Controls the font weight. Accepts "normal" and "bold" keywords or numbers between 1 and 1000.')
    });
  }
  validate(e) {
    return e === "normal" || e === "bold" ? e : String(Cn.clampedInt(e, Bo.fontWeight, f0.MINIMUM_VALUE, f0.MAXIMUM_VALUE));
  }
}
class Kut extends Wn {
  constructor() {
    const e = {
      multiple: "peek",
      multipleDefinitions: "peek",
      multipleTypeDefinitions: "peek",
      multipleDeclarations: "peek",
      multipleImplementations: "peek",
      multipleReferences: "peek",
      multipleTests: "peek",
      alternativeDefinitionCommand: "editor.action.goToReferences",
      alternativeTypeDefinitionCommand: "editor.action.goToReferences",
      alternativeDeclarationCommand: "editor.action.goToReferences",
      alternativeImplementationCommand: "",
      alternativeReferenceCommand: "",
      alternativeTestsCommand: ""
    }, t = {
      type: "string",
      enum: ["peek", "gotoAndPeek", "goto"],
      default: e.multiple,
      enumDescriptions: [
        C("editor.gotoLocation.multiple.peek", "Show Peek view of the results (default)"),
        C("editor.gotoLocation.multiple.gotoAndPeek", "Go to the primary result and show a Peek view"),
        C("editor.gotoLocation.multiple.goto", "Go to the primary result and enable Peek-less navigation to others")
      ]
    }, n = ["", "editor.action.referenceSearch.trigger", "editor.action.goToReferences", "editor.action.peekImplementation", "editor.action.goToImplementation", "editor.action.peekTypeDefinition", "editor.action.goToTypeDefinition", "editor.action.peekDeclaration", "editor.action.revealDeclaration", "editor.action.peekDefinition", "editor.action.revealDefinitionAside", "editor.action.revealDefinition"];
    super(58, "gotoLocation", e, {
      "editor.gotoLocation.multiple": {
        deprecationMessage: C("editor.gotoLocation.multiple.deprecated", "This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.")
      },
      "editor.gotoLocation.multipleDefinitions": {
        description: C("editor.editor.gotoLocation.multipleDefinitions", "Controls the behavior the 'Go to Definition'-command when multiple target locations exist."),
        ...t
      },
      "editor.gotoLocation.multipleTypeDefinitions": {
        description: C("editor.editor.gotoLocation.multipleTypeDefinitions", "Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist."),
        ...t
      },
      "editor.gotoLocation.multipleDeclarations": {
        description: C("editor.editor.gotoLocation.multipleDeclarations", "Controls the behavior the 'Go to Declaration'-command when multiple target locations exist."),
        ...t
      },
      "editor.gotoLocation.multipleImplementations": {
        description: C("editor.editor.gotoLocation.multipleImplemenattions", "Controls the behavior the 'Go to Implementations'-command when multiple target locations exist."),
        ...t
      },
      "editor.gotoLocation.multipleReferences": {
        description: C("editor.editor.gotoLocation.multipleReferences", "Controls the behavior the 'Go to References'-command when multiple target locations exist."),
        ...t
      },
      "editor.gotoLocation.alternativeDefinitionCommand": {
        type: "string",
        default: e.alternativeDefinitionCommand,
        enum: n,
        description: C("alternativeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Definition' is the current location.")
      },
      "editor.gotoLocation.alternativeTypeDefinitionCommand": {
        type: "string",
        default: e.alternativeTypeDefinitionCommand,
        enum: n,
        description: C("alternativeTypeDefinitionCommand", "Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.")
      },
      "editor.gotoLocation.alternativeDeclarationCommand": {
        type: "string",
        default: e.alternativeDeclarationCommand,
        enum: n,
        description: C("alternativeDeclarationCommand", "Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.")
      },
      "editor.gotoLocation.alternativeImplementationCommand": {
        type: "string",
        default: e.alternativeImplementationCommand,
        enum: n,
        description: C("alternativeImplementationCommand", "Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.")
      },
      "editor.gotoLocation.alternativeReferenceCommand": {
        type: "string",
        default: e.alternativeReferenceCommand,
        enum: n,
        description: C("alternativeReferenceCommand", "Alternative command id that is being executed when the result of 'Go to Reference' is the current location.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      multiple: ai(t.multiple, this.defaultValue.multiple, ["peek", "gotoAndPeek", "goto"]),
      multipleDefinitions: t.multipleDefinitions ?? ai(t.multipleDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleTypeDefinitions: t.multipleTypeDefinitions ?? ai(t.multipleTypeDefinitions, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleDeclarations: t.multipleDeclarations ?? ai(t.multipleDeclarations, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleImplementations: t.multipleImplementations ?? ai(t.multipleImplementations, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleReferences: t.multipleReferences ?? ai(t.multipleReferences, "peek", ["peek", "gotoAndPeek", "goto"]),
      multipleTests: t.multipleTests ?? ai(t.multipleTests, "peek", ["peek", "gotoAndPeek", "goto"]),
      alternativeDefinitionCommand: $r.string(t.alternativeDefinitionCommand, this.defaultValue.alternativeDefinitionCommand),
      alternativeTypeDefinitionCommand: $r.string(t.alternativeTypeDefinitionCommand, this.defaultValue.alternativeTypeDefinitionCommand),
      alternativeDeclarationCommand: $r.string(t.alternativeDeclarationCommand, this.defaultValue.alternativeDeclarationCommand),
      alternativeImplementationCommand: $r.string(t.alternativeImplementationCommand, this.defaultValue.alternativeImplementationCommand),
      alternativeReferenceCommand: $r.string(t.alternativeReferenceCommand, this.defaultValue.alternativeReferenceCommand),
      alternativeTestsCommand: $r.string(t.alternativeTestsCommand, this.defaultValue.alternativeTestsCommand)
    };
  }
}
class Yut extends Wn {
  constructor() {
    const e = {
      enabled: !0,
      delay: 300,
      hidingDelay: 300,
      sticky: !0,
      above: !0
    };
    super(60, "hover", e, {
      "editor.hover.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("hover.enabled", "Controls whether the hover is shown.")
      },
      "editor.hover.delay": {
        type: "number",
        default: e.delay,
        minimum: 0,
        maximum: 1e4,
        description: C("hover.delay", "Controls the delay in milliseconds after which the hover is shown.")
      },
      "editor.hover.sticky": {
        type: "boolean",
        default: e.sticky,
        description: C("hover.sticky", "Controls whether the hover should remain visible when mouse is moved over it.")
      },
      "editor.hover.hidingDelay": {
        type: "integer",
        minimum: 0,
        default: e.hidingDelay,
        description: C("hover.hidingDelay", "Controls the delay in milliseconds after which the hover is hidden. Requires `editor.hover.sticky` to be enabled.")
      },
      "editor.hover.above": {
        type: "boolean",
        default: e.above,
        description: C("hover.above", "Prefer showing hovers above the line, if there's space.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      delay: Cn.clampedInt(t.delay, this.defaultValue.delay, 0, 1e4),
      sticky: Re(t.sticky, this.defaultValue.sticky),
      hidingDelay: Cn.clampedInt(t.hidingDelay, this.defaultValue.hidingDelay, 0, 6e5),
      above: Re(t.above, this.defaultValue.above)
    };
  }
}
class pp extends pw {
  constructor() {
    super(
      146
      /* EditorOption.layoutInfo */
    );
  }
  compute(e, t, n) {
    return pp.computeLayout(t, {
      memory: e.memory,
      outerWidth: e.outerWidth,
      outerHeight: e.outerHeight,
      isDominatedByLongLines: e.isDominatedByLongLines,
      lineHeight: e.fontInfo.lineHeight,
      viewLineCount: e.viewLineCount,
      lineNumbersDigitCount: e.lineNumbersDigitCount,
      typicalHalfwidthCharacterWidth: e.fontInfo.typicalHalfwidthCharacterWidth,
      maxDigitWidth: e.fontInfo.maxDigitWidth,
      pixelRatio: e.pixelRatio,
      glyphMarginDecorationLaneCount: e.glyphMarginDecorationLaneCount
    });
  }
  static computeContainedMinimapLineCount(e) {
    const t = e.height / e.lineHeight, n = Math.floor(e.paddingTop / e.lineHeight);
    let i = Math.floor(e.paddingBottom / e.lineHeight);
    e.scrollBeyondLastLine && (i = Math.max(i, t - 1));
    const s = (n + e.viewLineCount + i) / (e.pixelRatio * e.height), o = Math.floor(e.viewLineCount / s);
    return { typicalViewportLineCount: t, extraLinesBeforeFirstLine: n, extraLinesBeyondLastLine: i, desiredRatio: s, minimapLineCount: o };
  }
  static _computeMinimapLayout(e, t) {
    const n = e.outerWidth, i = e.outerHeight, s = e.pixelRatio;
    if (!e.minimap.enabled)
      return {
        renderMinimap: 0,
        minimapLeft: 0,
        minimapWidth: 0,
        minimapHeightIsEditorHeight: !1,
        minimapIsSampling: !1,
        minimapScale: 1,
        minimapLineHeight: 1,
        minimapCanvasInnerWidth: 0,
        minimapCanvasInnerHeight: Math.floor(s * i),
        minimapCanvasOuterWidth: 0,
        minimapCanvasOuterHeight: i
      };
    const o = t.stableMinimapLayoutInput, a = o && e.outerHeight === o.outerHeight && e.lineHeight === o.lineHeight && e.typicalHalfwidthCharacterWidth === o.typicalHalfwidthCharacterWidth && e.pixelRatio === o.pixelRatio && e.scrollBeyondLastLine === o.scrollBeyondLastLine && e.paddingTop === o.paddingTop && e.paddingBottom === o.paddingBottom && e.minimap.enabled === o.minimap.enabled && e.minimap.side === o.minimap.side && e.minimap.size === o.minimap.size && e.minimap.showSlider === o.minimap.showSlider && e.minimap.renderCharacters === o.minimap.renderCharacters && e.minimap.maxColumn === o.minimap.maxColumn && e.minimap.scale === o.minimap.scale && e.verticalScrollbarWidth === o.verticalScrollbarWidth && e.isViewportWrapping === o.isViewportWrapping, l = e.lineHeight, c = e.typicalHalfwidthCharacterWidth, d = e.scrollBeyondLastLine, u = e.minimap.renderCharacters;
    let f = s >= 2 ? Math.round(e.minimap.scale * 2) : e.minimap.scale;
    const p = e.minimap.maxColumn, g = e.minimap.size, m = e.minimap.side, A = e.verticalScrollbarWidth, w = e.viewLineCount, v = e.remainingWidth, y = e.isViewportWrapping, _ = u ? 2 : 3;
    let S = Math.floor(s * i);
    const D = S / s;
    let M = !1, L = !1, T = _ * f, B = f / s, V = 1;
    if (g === "fill" || g === "fit") {
      const { typicalViewportLineCount: ce, extraLinesBeforeFirstLine: se, extraLinesBeyondLastLine: te, desiredRatio: ue, minimapLineCount: G } = pp.computeContainedMinimapLineCount({
        viewLineCount: w,
        scrollBeyondLastLine: d,
        paddingTop: e.paddingTop,
        paddingBottom: e.paddingBottom,
        height: i,
        lineHeight: l,
        pixelRatio: s
      });
      if (w / G > 1)
        M = !0, L = !0, f = 1, T = 1, B = f / s;
      else {
        let pe = !1, De = f + 1;
        if (g === "fit") {
          const Ce = Math.ceil((se + w + te) * T);
          y && a && v <= t.stableFitRemainingWidth ? (pe = !0, De = t.stableFitMaxMinimapScale) : pe = Ce > S;
        }
        if (g === "fill" || pe) {
          M = !0;
          const Ce = f;
          T = Math.min(l * s, Math.max(1, Math.floor(1 / ue))), y && a && v <= t.stableFitRemainingWidth && (De = t.stableFitMaxMinimapScale), f = Math.min(De, Math.max(1, Math.floor(T / _))), f > Ce && (V = Math.min(2, f / Ce)), B = f / s / V, S = Math.ceil(Math.max(ce, se + w + te) * T), y ? (t.stableMinimapLayoutInput = e, t.stableFitRemainingWidth = v, t.stableFitMaxMinimapScale = f) : (t.stableMinimapLayoutInput = null, t.stableFitRemainingWidth = 0);
        }
      }
    }
    const N = Math.floor(p * B), R = Math.min(N, Math.max(0, Math.floor((v - A - 2) * B / (c + B))) + Rc);
    let H = Math.floor(s * R);
    const z = H / s;
    H = Math.floor(H * V);
    const U = u ? 1 : 2, ee = m === "left" ? 0 : n - R - A;
    return {
      renderMinimap: U,
      minimapLeft: ee,
      minimapWidth: R,
      minimapHeightIsEditorHeight: M,
      minimapIsSampling: L,
      minimapScale: f,
      minimapLineHeight: T,
      minimapCanvasInnerWidth: H,
      minimapCanvasInnerHeight: S,
      minimapCanvasOuterWidth: z,
      minimapCanvasOuterHeight: D
    };
  }
  static computeLayout(e, t) {
    const n = t.outerWidth | 0, i = t.outerHeight | 0, s = t.lineHeight | 0, o = t.lineNumbersDigitCount | 0, a = t.typicalHalfwidthCharacterWidth, l = t.maxDigitWidth, c = t.pixelRatio, d = t.viewLineCount, u = e.get(
      138
      /* EditorOption.wordWrapOverride2 */
    ), f = u === "inherit" ? e.get(
      137
      /* EditorOption.wordWrapOverride1 */
    ) : u, p = f === "inherit" ? e.get(
      133
      /* EditorOption.wordWrap */
    ) : f, g = e.get(
      136
      /* EditorOption.wordWrapColumn */
    ), m = t.isDominatedByLongLines, A = e.get(
      57
      /* EditorOption.glyphMargin */
    ), w = e.get(
      68
      /* EditorOption.lineNumbers */
    ).renderType !== 0, v = e.get(
      69
      /* EditorOption.lineNumbersMinChars */
    ), y = e.get(
      106
      /* EditorOption.scrollBeyondLastLine */
    ), _ = e.get(
      84
      /* EditorOption.padding */
    ), S = e.get(
      73
      /* EditorOption.minimap */
    ), D = e.get(
      104
      /* EditorOption.scrollbar */
    ), M = D.verticalScrollbarSize, L = D.verticalHasArrows, T = D.arrowSize, B = D.horizontalScrollbarSize, V = e.get(
      43
      /* EditorOption.folding */
    ), N = e.get(
      111
      /* EditorOption.showFoldingControls */
    ) !== "never";
    let R = e.get(
      66
      /* EditorOption.lineDecorationsWidth */
    );
    V && N && (R += 16);
    let H = 0;
    if (w) {
      const I = Math.max(o, v);
      H = Math.round(I * l);
    }
    let z = 0;
    A && (z = s * t.glyphMarginDecorationLaneCount);
    let U = 0, ee = U + z, ce = ee + H, se = ce + R;
    const te = n - z - H - R;
    let ue = !1, G = !1, j = -1;
    f === "inherit" && m ? (ue = !0, G = !0) : p === "on" || p === "bounded" ? G = !0 : p === "wordWrapColumn" && (j = g);
    const pe = pp._computeMinimapLayout({
      outerWidth: n,
      outerHeight: i,
      lineHeight: s,
      typicalHalfwidthCharacterWidth: a,
      pixelRatio: c,
      scrollBeyondLastLine: y,
      paddingTop: _.top,
      paddingBottom: _.bottom,
      minimap: S,
      verticalScrollbarWidth: M,
      viewLineCount: d,
      remainingWidth: te,
      isViewportWrapping: G
    }, t.memory || new PMe());
    pe.renderMinimap !== 0 && pe.minimapLeft === 0 && (U += pe.minimapWidth, ee += pe.minimapWidth, ce += pe.minimapWidth, se += pe.minimapWidth);
    const De = te - pe.minimapWidth, Ce = Math.max(1, Math.floor((De - M - 2) / a)), F = L ? T : 0;
    return G && (j = Math.max(1, Ce), p === "bounded" && (j = Math.min(j, g))), {
      width: n,
      height: i,
      glyphMarginLeft: U,
      glyphMarginWidth: z,
      glyphMarginDecorationLaneCount: t.glyphMarginDecorationLaneCount,
      lineNumbersLeft: ee,
      lineNumbersWidth: H,
      decorationsLeft: ce,
      decorationsWidth: R,
      contentLeft: se,
      contentWidth: De,
      minimap: pe,
      viewportColumn: Ce,
      isWordWrapMinified: ue,
      isViewportWrapping: G,
      wrappingColumn: j,
      verticalScrollbarWidth: M,
      horizontalScrollbarHeight: B,
      overviewRuler: {
        top: F,
        width: M,
        height: i - 2 * F,
        right: 0
      }
    };
  }
}
class Xut extends Wn {
  constructor() {
    super(140, "wrappingStrategy", "simple", {
      "editor.wrappingStrategy": {
        enumDescriptions: [
          C("wrappingStrategy.simple", "Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width."),
          C("wrappingStrategy.advanced", "Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.")
        ],
        type: "string",
        enum: ["simple", "advanced"],
        default: "simple",
        description: C("wrappingStrategy", "Controls the algorithm that computes wrapping points. Note that when in accessibility mode, advanced will be used for the best experience.")
      }
    });
  }
  validate(e) {
    return ai(e, "simple", ["simple", "advanced"]);
  }
  compute(e, t, n) {
    return t.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 2 ? "advanced" : n;
  }
}
var qh;
(function(r) {
  r.Off = "off", r.OnCode = "onCode", r.On = "on";
})(qh || (qh = {}));
class Jut extends Wn {
  constructor() {
    const e = { enabled: qh.On };
    super(65, "lightbulb", e, {
      "editor.lightbulb.enabled": {
        type: "string",
        tags: ["experimental"],
        enum: [qh.Off, qh.OnCode, qh.On],
        default: e.enabled,
        enumDescriptions: [
          C("editor.lightbulb.enabled.off", "Disable the code action menu."),
          C("editor.lightbulb.enabled.onCode", "Show the code action menu when the cursor is on lines with code."),
          C("editor.lightbulb.enabled.on", "Show the code action menu when the cursor is on lines with code or on empty lines.")
        ],
        description: C("enabled", "Enables the Code Action lightbulb in the editor.")
      }
    });
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : {
      enabled: ai(e.enabled, this.defaultValue.enabled, [qh.Off, qh.OnCode, qh.On])
    };
  }
}
class $ut extends Wn {
  constructor() {
    const e = { enabled: !0, maxLineCount: 5, defaultModel: "outlineModel", scrollWithEditor: !0 };
    super(116, "stickyScroll", e, {
      "editor.stickyScroll.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("editor.stickyScroll.enabled", "Shows the nested current scopes during the scroll at the top of the editor."),
        tags: ["experimental"]
      },
      "editor.stickyScroll.maxLineCount": {
        type: "number",
        default: e.maxLineCount,
        minimum: 1,
        maximum: 20,
        description: C("editor.stickyScroll.maxLineCount", "Defines the maximum number of sticky lines to show.")
      },
      "editor.stickyScroll.defaultModel": {
        type: "string",
        enum: ["outlineModel", "foldingProviderModel", "indentationModel"],
        default: e.defaultModel,
        description: C("editor.stickyScroll.defaultModel", "Defines the model to use for determining which lines to stick. If the outline model does not exist, it will fall back on the folding provider model which falls back on the indentation model. This order is respected in all three cases.")
      },
      "editor.stickyScroll.scrollWithEditor": {
        type: "boolean",
        default: e.scrollWithEditor,
        description: C("editor.stickyScroll.scrollWithEditor", "Enable scrolling of Sticky Scroll with the editor's horizontal scrollbar.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      maxLineCount: Cn.clampedInt(t.maxLineCount, this.defaultValue.maxLineCount, 1, 20),
      defaultModel: ai(t.defaultModel, this.defaultValue.defaultModel, ["outlineModel", "foldingProviderModel", "indentationModel"]),
      scrollWithEditor: Re(t.scrollWithEditor, this.defaultValue.scrollWithEditor)
    };
  }
}
class e1t extends Wn {
  constructor() {
    const e = { enabled: "on", fontSize: 0, fontFamily: "", padding: !1 };
    super(142, "inlayHints", e, {
      "editor.inlayHints.enabled": {
        type: "string",
        default: e.enabled,
        description: C("inlayHints.enable", "Enables the inlay hints in the editor."),
        enum: ["on", "onUnlessPressed", "offUnlessPressed", "off"],
        markdownEnumDescriptions: [
          C("editor.inlayHints.on", "Inlay hints are enabled"),
          C("editor.inlayHints.onUnlessPressed", "Inlay hints are showing by default and hide when holding {0}", zt ? "Ctrl+Option" : "Ctrl+Alt"),
          C("editor.inlayHints.offUnlessPressed", "Inlay hints are hidden by default and show when holding {0}", zt ? "Ctrl+Option" : "Ctrl+Alt"),
          C("editor.inlayHints.off", "Inlay hints are disabled")
        ]
      },
      "editor.inlayHints.fontSize": {
        type: "number",
        default: e.fontSize,
        markdownDescription: C("inlayHints.fontSize", "Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.", "`#editor.fontSize#`", "`5`")
      },
      "editor.inlayHints.fontFamily": {
        type: "string",
        default: e.fontFamily,
        markdownDescription: C("inlayHints.fontFamily", "Controls font family of inlay hints in the editor. When set to empty, the {0} is used.", "`#editor.fontFamily#`")
      },
      "editor.inlayHints.padding": {
        type: "boolean",
        default: e.padding,
        description: C("inlayHints.padding", "Enables the padding around the inlay hints in the editor.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return typeof t.enabled == "boolean" && (t.enabled = t.enabled ? "on" : "off"), {
      enabled: ai(t.enabled, this.defaultValue.enabled, ["on", "off", "offUnlessPressed", "onUnlessPressed"]),
      fontSize: Cn.clampedInt(t.fontSize, this.defaultValue.fontSize, 0, 100),
      fontFamily: $r.string(t.fontFamily, this.defaultValue.fontFamily),
      padding: Re(t.padding, this.defaultValue.padding)
    };
  }
}
class t1t extends Wn {
  constructor() {
    super(66, "lineDecorationsWidth", 10);
  }
  validate(e) {
    return typeof e == "string" && /^\d+(\.\d+)?ch$/.test(e) ? -parseFloat(e.substring(0, e.length - 2)) : Cn.clampedInt(e, this.defaultValue, 0, 1e3);
  }
  compute(e, t, n) {
    return n < 0 ? Cn.clampedInt(-n * e.fontInfo.typicalHalfwidthCharacterWidth, this.defaultValue, 0, 1e3) : n;
  }
}
class n1t extends No {
  constructor() {
    super(67, "lineHeight", Bo.lineHeight, (e) => No.clamp(e, 0, 150), { markdownDescription: C("lineHeight", `Controls the line height. 
 - Use 0 to automatically compute the line height from the font size.
 - Values between 0 and 8 will be used as a multiplier with the font size.
 - Values greater than or equal to 8 will be used as effective values.`) });
  }
  compute(e, t, n) {
    return e.fontInfo.lineHeight;
  }
}
class i1t extends Wn {
  constructor() {
    const e = {
      enabled: !0,
      size: "proportional",
      side: "right",
      showSlider: "mouseover",
      autohide: !1,
      renderCharacters: !0,
      maxColumn: 120,
      scale: 1,
      showRegionSectionHeaders: !0,
      showMarkSectionHeaders: !0,
      sectionHeaderFontSize: 9,
      sectionHeaderLetterSpacing: 1
    };
    super(73, "minimap", e, {
      "editor.minimap.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("minimap.enabled", "Controls whether the minimap is shown.")
      },
      "editor.minimap.autohide": {
        type: "boolean",
        default: e.autohide,
        description: C("minimap.autohide", "Controls whether the minimap is hidden automatically.")
      },
      "editor.minimap.size": {
        type: "string",
        enum: ["proportional", "fill", "fit"],
        enumDescriptions: [
          C("minimap.size.proportional", "The minimap has the same size as the editor contents (and might scroll)."),
          C("minimap.size.fill", "The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling)."),
          C("minimap.size.fit", "The minimap will shrink as necessary to never be larger than the editor (no scrolling).")
        ],
        default: e.size,
        description: C("minimap.size", "Controls the size of the minimap.")
      },
      "editor.minimap.side": {
        type: "string",
        enum: ["left", "right"],
        default: e.side,
        description: C("minimap.side", "Controls the side where to render the minimap.")
      },
      "editor.minimap.showSlider": {
        type: "string",
        enum: ["always", "mouseover"],
        default: e.showSlider,
        description: C("minimap.showSlider", "Controls when the minimap slider is shown.")
      },
      "editor.minimap.scale": {
        type: "number",
        default: e.scale,
        minimum: 1,
        maximum: 3,
        enum: [1, 2, 3],
        description: C("minimap.scale", "Scale of content drawn in the minimap: 1, 2 or 3.")
      },
      "editor.minimap.renderCharacters": {
        type: "boolean",
        default: e.renderCharacters,
        description: C("minimap.renderCharacters", "Render the actual characters on a line as opposed to color blocks.")
      },
      "editor.minimap.maxColumn": {
        type: "number",
        default: e.maxColumn,
        description: C("minimap.maxColumn", "Limit the width of the minimap to render at most a certain number of columns.")
      },
      "editor.minimap.showRegionSectionHeaders": {
        type: "boolean",
        default: e.showRegionSectionHeaders,
        description: C("minimap.showRegionSectionHeaders", "Controls whether named regions are shown as section headers in the minimap.")
      },
      "editor.minimap.showMarkSectionHeaders": {
        type: "boolean",
        default: e.showMarkSectionHeaders,
        description: C("minimap.showMarkSectionHeaders", "Controls whether MARK: comments are shown as section headers in the minimap.")
      },
      "editor.minimap.sectionHeaderFontSize": {
        type: "number",
        default: e.sectionHeaderFontSize,
        description: C("minimap.sectionHeaderFontSize", "Controls the font size of section headers in the minimap.")
      },
      "editor.minimap.sectionHeaderLetterSpacing": {
        type: "number",
        default: e.sectionHeaderLetterSpacing,
        description: C("minimap.sectionHeaderLetterSpacing", "Controls the amount of space (in pixels) between characters of section header. This helps the readability of the header in small font sizes.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      autohide: Re(t.autohide, this.defaultValue.autohide),
      size: ai(t.size, this.defaultValue.size, ["proportional", "fill", "fit"]),
      side: ai(t.side, this.defaultValue.side, ["right", "left"]),
      showSlider: ai(t.showSlider, this.defaultValue.showSlider, ["always", "mouseover"]),
      renderCharacters: Re(t.renderCharacters, this.defaultValue.renderCharacters),
      scale: Cn.clampedInt(t.scale, 1, 1, 3),
      maxColumn: Cn.clampedInt(t.maxColumn, this.defaultValue.maxColumn, 1, 1e4),
      showRegionSectionHeaders: Re(t.showRegionSectionHeaders, this.defaultValue.showRegionSectionHeaders),
      showMarkSectionHeaders: Re(t.showMarkSectionHeaders, this.defaultValue.showMarkSectionHeaders),
      sectionHeaderFontSize: No.clamp(t.sectionHeaderFontSize ?? this.defaultValue.sectionHeaderFontSize, 4, 32),
      sectionHeaderLetterSpacing: No.clamp(t.sectionHeaderLetterSpacing ?? this.defaultValue.sectionHeaderLetterSpacing, 0, 5)
    };
  }
}
function r1t(r) {
  return r === "ctrlCmd" ? zt ? "metaKey" : "ctrlKey" : "altKey";
}
class s1t extends Wn {
  constructor() {
    super(84, "padding", { top: 0, bottom: 0 }, {
      "editor.padding.top": {
        type: "number",
        default: 0,
        minimum: 0,
        maximum: 1e3,
        description: C("padding.top", "Controls the amount of space between the top edge of the editor and the first line.")
      },
      "editor.padding.bottom": {
        type: "number",
        default: 0,
        minimum: 0,
        maximum: 1e3,
        description: C("padding.bottom", "Controls the amount of space between the bottom edge of the editor and the last line.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      top: Cn.clampedInt(t.top, 0, 0, 1e3),
      bottom: Cn.clampedInt(t.bottom, 0, 0, 1e3)
    };
  }
}
class o1t extends Wn {
  constructor() {
    const e = {
      enabled: !0,
      cycle: !0
    };
    super(86, "parameterHints", e, {
      "editor.parameterHints.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("parameterHints.enabled", "Enables a pop-up that shows parameter documentation and type information as you type.")
      },
      "editor.parameterHints.cycle": {
        type: "boolean",
        default: e.cycle,
        description: C("parameterHints.cycle", "Controls whether the parameter hints menu cycles or closes when reaching the end of the list.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      cycle: Re(t.cycle, this.defaultValue.cycle)
    };
  }
}
class a1t extends pw {
  constructor() {
    super(
      144
      /* EditorOption.pixelRatio */
    );
  }
  compute(e, t, n) {
    return e.pixelRatio;
  }
}
class l1t extends Wn {
  constructor() {
    super(88, "placeholder", void 0);
  }
  validate(e) {
    return typeof e > "u" ? this.defaultValue : typeof e == "string" ? e : this.defaultValue;
  }
}
class c1t extends Wn {
  constructor() {
    const e = {
      other: "on",
      comments: "off",
      strings: "off"
    }, t = [
      { type: "boolean" },
      {
        type: "string",
        enum: ["on", "inline", "off"],
        enumDescriptions: [C("on", "Quick suggestions show inside the suggest widget"), C("inline", "Quick suggestions show as ghost text"), C("off", "Quick suggestions are disabled")]
      }
    ];
    super(90, "quickSuggestions", e, {
      type: "object",
      additionalProperties: !1,
      properties: {
        strings: {
          anyOf: t,
          default: e.strings,
          description: C("quickSuggestions.strings", "Enable quick suggestions inside strings.")
        },
        comments: {
          anyOf: t,
          default: e.comments,
          description: C("quickSuggestions.comments", "Enable quick suggestions inside comments.")
        },
        other: {
          anyOf: t,
          default: e.other,
          description: C("quickSuggestions.other", "Enable quick suggestions outside of strings and comments.")
        }
      },
      default: e,
      markdownDescription: C("quickSuggestions", "Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the {0}-setting which controls if suggestions are triggered by special characters.", "`#editor.suggestOnTriggerCharacters#`")
    }), this.defaultValue = e;
  }
  validate(e) {
    if (typeof e == "boolean") {
      const c = e ? "on" : "off";
      return { comments: c, strings: c, other: c };
    }
    if (!e || typeof e != "object")
      return this.defaultValue;
    const { other: t, comments: n, strings: i } = e, s = ["on", "inline", "off"];
    let o, a, l;
    return typeof t == "boolean" ? o = t ? "on" : "off" : o = ai(t, this.defaultValue.other, s), typeof n == "boolean" ? a = n ? "on" : "off" : a = ai(n, this.defaultValue.comments, s), typeof i == "boolean" ? l = i ? "on" : "off" : l = ai(i, this.defaultValue.strings, s), {
      other: o,
      comments: a,
      strings: l
    };
  }
}
class h1t extends Wn {
  constructor() {
    super(68, "lineNumbers", { renderType: 1, renderFn: null }, {
      type: "string",
      enum: ["off", "on", "relative", "interval"],
      enumDescriptions: [
        C("lineNumbers.off", "Line numbers are not rendered."),
        C("lineNumbers.on", "Line numbers are rendered as absolute number."),
        C("lineNumbers.relative", "Line numbers are rendered as distance in lines to cursor position."),
        C("lineNumbers.interval", "Line numbers are rendered every 10 lines.")
      ],
      default: "on",
      description: C("lineNumbers", "Controls the display of line numbers.")
    });
  }
  validate(e) {
    let t = this.defaultValue.renderType, n = this.defaultValue.renderFn;
    return typeof e < "u" && (typeof e == "function" ? (t = 4, n = e) : e === "interval" ? t = 3 : e === "relative" ? t = 2 : e === "on" ? t = 1 : t = 0), {
      renderType: t,
      renderFn: n
    };
  }
}
function M8(r) {
  const e = r.get(
    99
    /* EditorOption.renderValidationDecorations */
  );
  return e === "editable" ? r.get(
    92
    /* EditorOption.readOnly */
  ) : e !== "on";
}
class d1t extends Wn {
  constructor() {
    const e = [], t = { type: "number", description: C("rulers.size", "Number of monospace characters at which this editor ruler will render.") };
    super(103, "rulers", e, {
      type: "array",
      items: {
        anyOf: [
          t,
          {
            type: [
              "object"
            ],
            properties: {
              column: t,
              color: {
                type: "string",
                description: C("rulers.color", "Color of this editor ruler."),
                format: "color-hex"
              }
            }
          }
        ]
      },
      default: e,
      description: C("rulers", "Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.")
    });
  }
  validate(e) {
    if (Array.isArray(e)) {
      const t = [];
      for (const n of e)
        if (typeof n == "number")
          t.push({
            column: Cn.clampedInt(n, 0, 0, 1e4),
            color: null
          });
        else if (n && typeof n == "object") {
          const i = n;
          t.push({
            column: Cn.clampedInt(i.column, 0, 0, 1e4),
            color: i.color
          });
        }
      return t.sort((n, i) => n.column - i.column), t;
    }
    return this.defaultValue;
  }
}
class u1t extends Wn {
  constructor() {
    super(93, "readOnlyMessage", void 0);
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : e;
  }
}
function mve(r, e) {
  if (typeof r != "string")
    return e;
  switch (r) {
    case "hidden":
      return 2;
    case "visible":
      return 3;
    default:
      return 1;
  }
}
let f1t = class extends Wn {
  constructor() {
    const e = {
      vertical: 1,
      horizontal: 1,
      arrowSize: 11,
      useShadows: !0,
      verticalHasArrows: !1,
      horizontalHasArrows: !1,
      horizontalScrollbarSize: 12,
      horizontalSliderSize: 12,
      verticalScrollbarSize: 14,
      verticalSliderSize: 14,
      handleMouseWheel: !0,
      alwaysConsumeMouseWheel: !0,
      scrollByPage: !1,
      ignoreHorizontalScrollbarInContentHeight: !1
    };
    super(104, "scrollbar", e, {
      "editor.scrollbar.vertical": {
        type: "string",
        enum: ["auto", "visible", "hidden"],
        enumDescriptions: [
          C("scrollbar.vertical.auto", "The vertical scrollbar will be visible only when necessary."),
          C("scrollbar.vertical.visible", "The vertical scrollbar will always be visible."),
          C("scrollbar.vertical.fit", "The vertical scrollbar will always be hidden.")
        ],
        default: "auto",
        description: C("scrollbar.vertical", "Controls the visibility of the vertical scrollbar.")
      },
      "editor.scrollbar.horizontal": {
        type: "string",
        enum: ["auto", "visible", "hidden"],
        enumDescriptions: [
          C("scrollbar.horizontal.auto", "The horizontal scrollbar will be visible only when necessary."),
          C("scrollbar.horizontal.visible", "The horizontal scrollbar will always be visible."),
          C("scrollbar.horizontal.fit", "The horizontal scrollbar will always be hidden.")
        ],
        default: "auto",
        description: C("scrollbar.horizontal", "Controls the visibility of the horizontal scrollbar.")
      },
      "editor.scrollbar.verticalScrollbarSize": {
        type: "number",
        default: e.verticalScrollbarSize,
        description: C("scrollbar.verticalScrollbarSize", "The width of the vertical scrollbar.")
      },
      "editor.scrollbar.horizontalScrollbarSize": {
        type: "number",
        default: e.horizontalScrollbarSize,
        description: C("scrollbar.horizontalScrollbarSize", "The height of the horizontal scrollbar.")
      },
      "editor.scrollbar.scrollByPage": {
        type: "boolean",
        default: e.scrollByPage,
        description: C("scrollbar.scrollByPage", "Controls whether clicks scroll by page or jump to click position.")
      },
      "editor.scrollbar.ignoreHorizontalScrollbarInContentHeight": {
        type: "boolean",
        default: e.ignoreHorizontalScrollbarInContentHeight,
        description: C("scrollbar.ignoreHorizontalScrollbarInContentHeight", "When set, the horizontal scrollbar will not increase the size of the editor's content.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e, n = Cn.clampedInt(t.horizontalScrollbarSize, this.defaultValue.horizontalScrollbarSize, 0, 1e3), i = Cn.clampedInt(t.verticalScrollbarSize, this.defaultValue.verticalScrollbarSize, 0, 1e3);
    return {
      arrowSize: Cn.clampedInt(t.arrowSize, this.defaultValue.arrowSize, 0, 1e3),
      vertical: mve(t.vertical, this.defaultValue.vertical),
      horizontal: mve(t.horizontal, this.defaultValue.horizontal),
      useShadows: Re(t.useShadows, this.defaultValue.useShadows),
      verticalHasArrows: Re(t.verticalHasArrows, this.defaultValue.verticalHasArrows),
      horizontalHasArrows: Re(t.horizontalHasArrows, this.defaultValue.horizontalHasArrows),
      handleMouseWheel: Re(t.handleMouseWheel, this.defaultValue.handleMouseWheel),
      alwaysConsumeMouseWheel: Re(t.alwaysConsumeMouseWheel, this.defaultValue.alwaysConsumeMouseWheel),
      horizontalScrollbarSize: n,
      horizontalSliderSize: Cn.clampedInt(t.horizontalSliderSize, n, 0, 1e3),
      verticalScrollbarSize: i,
      verticalSliderSize: Cn.clampedInt(t.verticalSliderSize, i, 0, 1e3),
      scrollByPage: Re(t.scrollByPage, this.defaultValue.scrollByPage),
      ignoreHorizontalScrollbarInContentHeight: Re(t.ignoreHorizontalScrollbarInContentHeight, this.defaultValue.ignoreHorizontalScrollbarInContentHeight)
    };
  }
};
const Ml = "inUntrustedWorkspace", Z1 = {
  allowedCharacters: "editor.unicodeHighlight.allowedCharacters",
  invisibleCharacters: "editor.unicodeHighlight.invisibleCharacters",
  nonBasicASCII: "editor.unicodeHighlight.nonBasicASCII",
  ambiguousCharacters: "editor.unicodeHighlight.ambiguousCharacters",
  includeComments: "editor.unicodeHighlight.includeComments",
  includeStrings: "editor.unicodeHighlight.includeStrings",
  allowedLocales: "editor.unicodeHighlight.allowedLocales"
};
class p1t extends Wn {
  constructor() {
    const e = {
      nonBasicASCII: Ml,
      invisibleCharacters: !0,
      ambiguousCharacters: !0,
      includeComments: Ml,
      includeStrings: !0,
      allowedCharacters: {},
      allowedLocales: { _os: !0, _vscode: !0 }
    };
    super(126, "unicodeHighlight", e, {
      [Z1.nonBasicASCII]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ml],
        default: e.nonBasicASCII,
        description: C("unicodeHighlight.nonBasicASCII", "Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.")
      },
      [Z1.invisibleCharacters]: {
        restricted: !0,
        type: "boolean",
        default: e.invisibleCharacters,
        description: C("unicodeHighlight.invisibleCharacters", "Controls whether characters that just reserve space or have no width at all are highlighted.")
      },
      [Z1.ambiguousCharacters]: {
        restricted: !0,
        type: "boolean",
        default: e.ambiguousCharacters,
        description: C("unicodeHighlight.ambiguousCharacters", "Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.")
      },
      [Z1.includeComments]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ml],
        default: e.includeComments,
        description: C("unicodeHighlight.includeComments", "Controls whether characters in comments should also be subject to Unicode highlighting.")
      },
      [Z1.includeStrings]: {
        restricted: !0,
        type: ["boolean", "string"],
        enum: [!0, !1, Ml],
        default: e.includeStrings,
        description: C("unicodeHighlight.includeStrings", "Controls whether characters in strings should also be subject to Unicode highlighting.")
      },
      [Z1.allowedCharacters]: {
        restricted: !0,
        type: "object",
        default: e.allowedCharacters,
        description: C("unicodeHighlight.allowedCharacters", "Defines allowed characters that are not being highlighted."),
        additionalProperties: {
          type: "boolean"
        }
      },
      [Z1.allowedLocales]: {
        restricted: !0,
        type: "object",
        additionalProperties: {
          type: "boolean"
        },
        default: e.allowedLocales,
        description: C("unicodeHighlight.allowedLocales", "Unicode characters that are common in allowed locales are not being highlighted.")
      }
    });
  }
  applyUpdate(e, t) {
    let n = !1;
    t.allowedCharacters && e && (Ho(e.allowedCharacters, t.allowedCharacters) || (e = { ...e, allowedCharacters: t.allowedCharacters }, n = !0)), t.allowedLocales && e && (Ho(e.allowedLocales, t.allowedLocales) || (e = { ...e, allowedLocales: t.allowedLocales }, n = !0));
    const i = super.applyUpdate(e, t);
    return n ? new RA(i.newValue, !0) : i;
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      nonBasicASCII: gp(t.nonBasicASCII, Ml, [!0, !1, Ml]),
      invisibleCharacters: Re(t.invisibleCharacters, this.defaultValue.invisibleCharacters),
      ambiguousCharacters: Re(t.ambiguousCharacters, this.defaultValue.ambiguousCharacters),
      includeComments: gp(t.includeComments, Ml, [!0, !1, Ml]),
      includeStrings: gp(t.includeStrings, Ml, [!0, !1, Ml]),
      allowedCharacters: this.validateBooleanMap(e.allowedCharacters, this.defaultValue.allowedCharacters),
      allowedLocales: this.validateBooleanMap(e.allowedLocales, this.defaultValue.allowedLocales)
    };
  }
  validateBooleanMap(e, t) {
    if (typeof e != "object" || !e)
      return t;
    const n = {};
    for (const [i, s] of Object.entries(e))
      s === !0 && (n[i] = !0);
    return n;
  }
}
class g1t extends Wn {
  constructor() {
    const e = {
      enabled: !0,
      mode: "subwordSmart",
      showToolbar: "onHover",
      suppressSuggestions: !1,
      keepOnBlur: !1,
      fontFamily: "default"
    };
    super(62, "inlineSuggest", e, {
      "editor.inlineSuggest.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("inlineSuggest.enabled", "Controls whether to automatically show inline suggestions in the editor.")
      },
      "editor.inlineSuggest.showToolbar": {
        type: "string",
        default: e.showToolbar,
        enum: ["always", "onHover", "never"],
        enumDescriptions: [
          C("inlineSuggest.showToolbar.always", "Show the inline suggestion toolbar whenever an inline suggestion is shown."),
          C("inlineSuggest.showToolbar.onHover", "Show the inline suggestion toolbar when hovering over an inline suggestion."),
          C("inlineSuggest.showToolbar.never", "Never show the inline suggestion toolbar.")
        ],
        description: C("inlineSuggest.showToolbar", "Controls when to show the inline suggestion toolbar.")
      },
      "editor.inlineSuggest.suppressSuggestions": {
        type: "boolean",
        default: e.suppressSuggestions,
        description: C("inlineSuggest.suppressSuggestions", "Controls how inline suggestions interact with the suggest widget. If enabled, the suggest widget is not shown automatically when inline suggestions are available.")
      },
      "editor.inlineSuggest.fontFamily": {
        type: "string",
        default: e.fontFamily,
        description: C("inlineSuggest.fontFamily", "Controls the font family of the inline suggestions.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      mode: ai(t.mode, this.defaultValue.mode, ["prefix", "subword", "subwordSmart"]),
      showToolbar: ai(t.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]),
      suppressSuggestions: Re(t.suppressSuggestions, this.defaultValue.suppressSuggestions),
      keepOnBlur: Re(t.keepOnBlur, this.defaultValue.keepOnBlur),
      fontFamily: $r.string(t.fontFamily, this.defaultValue.fontFamily)
    };
  }
}
class m1t extends Wn {
  constructor() {
    const e = {
      enabled: !1,
      showToolbar: "onHover",
      fontFamily: "default",
      keepOnBlur: !1
    };
    super(63, "experimentalInlineEdit", e, {
      "editor.experimentalInlineEdit.enabled": {
        type: "boolean",
        default: e.enabled,
        description: C("inlineEdit.enabled", "Controls whether to show inline edits in the editor.")
      },
      "editor.experimentalInlineEdit.showToolbar": {
        type: "string",
        default: e.showToolbar,
        enum: ["always", "onHover", "never"],
        enumDescriptions: [
          C("inlineEdit.showToolbar.always", "Show the inline edit toolbar whenever an inline suggestion is shown."),
          C("inlineEdit.showToolbar.onHover", "Show the inline edit toolbar when hovering over an inline suggestion."),
          C("inlineEdit.showToolbar.never", "Never show the inline edit toolbar.")
        ],
        description: C("inlineEdit.showToolbar", "Controls when to show the inline edit toolbar.")
      },
      "editor.experimentalInlineEdit.fontFamily": {
        type: "string",
        default: e.fontFamily,
        description: C("inlineEdit.fontFamily", "Controls the font family of the inline edit.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      showToolbar: ai(t.showToolbar, this.defaultValue.showToolbar, ["always", "onHover", "never"]),
      fontFamily: $r.string(t.fontFamily, this.defaultValue.fontFamily),
      keepOnBlur: Re(t.keepOnBlur, this.defaultValue.keepOnBlur)
    };
  }
}
class A1t extends Wn {
  constructor() {
    const e = {
      enabled: Hr.bracketPairColorizationOptions.enabled,
      independentColorPoolPerBracketType: Hr.bracketPairColorizationOptions.independentColorPoolPerBracketType
    };
    super(15, "bracketPairColorization", e, {
      "editor.bracketPairColorization.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("bracketPairColorization.enabled", "Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.", "`#workbench.colorCustomizations#`")
      },
      "editor.bracketPairColorization.independentColorPoolPerBracketType": {
        type: "boolean",
        default: e.independentColorPoolPerBracketType,
        description: C("bracketPairColorization.independentColorPoolPerBracketType", "Controls whether each bracket type has its own independent color pool.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      independentColorPoolPerBracketType: Re(t.independentColorPoolPerBracketType, this.defaultValue.independentColorPoolPerBracketType)
    };
  }
}
class w1t extends Wn {
  constructor() {
    const e = {
      bracketPairs: !1,
      bracketPairsHorizontal: "active",
      highlightActiveBracketPair: !0,
      indentation: !0,
      highlightActiveIndentation: !0
    };
    super(16, "guides", e, {
      "editor.guides.bracketPairs": {
        type: ["boolean", "string"],
        enum: [!0, "active", !1],
        enumDescriptions: [
          C("editor.guides.bracketPairs.true", "Enables bracket pair guides."),
          C("editor.guides.bracketPairs.active", "Enables bracket pair guides only for the active bracket pair."),
          C("editor.guides.bracketPairs.false", "Disables bracket pair guides.")
        ],
        default: e.bracketPairs,
        description: C("editor.guides.bracketPairs", "Controls whether bracket pair guides are enabled or not.")
      },
      "editor.guides.bracketPairsHorizontal": {
        type: ["boolean", "string"],
        enum: [!0, "active", !1],
        enumDescriptions: [
          C("editor.guides.bracketPairsHorizontal.true", "Enables horizontal guides as addition to vertical bracket pair guides."),
          C("editor.guides.bracketPairsHorizontal.active", "Enables horizontal guides only for the active bracket pair."),
          C("editor.guides.bracketPairsHorizontal.false", "Disables horizontal bracket pair guides.")
        ],
        default: e.bracketPairsHorizontal,
        description: C("editor.guides.bracketPairsHorizontal", "Controls whether horizontal bracket pair guides are enabled or not.")
      },
      "editor.guides.highlightActiveBracketPair": {
        type: "boolean",
        default: e.highlightActiveBracketPair,
        description: C("editor.guides.highlightActiveBracketPair", "Controls whether the editor should highlight the active bracket pair.")
      },
      "editor.guides.indentation": {
        type: "boolean",
        default: e.indentation,
        description: C("editor.guides.indentation", "Controls whether the editor should render indent guides.")
      },
      "editor.guides.highlightActiveIndentation": {
        type: ["boolean", "string"],
        enum: [!0, "always", !1],
        enumDescriptions: [
          C("editor.guides.highlightActiveIndentation.true", "Highlights the active indent guide."),
          C("editor.guides.highlightActiveIndentation.always", "Highlights the active indent guide even if bracket guides are highlighted."),
          C("editor.guides.highlightActiveIndentation.false", "Do not highlight the active indent guide.")
        ],
        default: e.highlightActiveIndentation,
        description: C("editor.guides.highlightActiveIndentation", "Controls whether the editor should highlight the active indent guide.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      bracketPairs: gp(t.bracketPairs, this.defaultValue.bracketPairs, [!0, !1, "active"]),
      bracketPairsHorizontal: gp(t.bracketPairsHorizontal, this.defaultValue.bracketPairsHorizontal, [!0, !1, "active"]),
      highlightActiveBracketPair: Re(t.highlightActiveBracketPair, this.defaultValue.highlightActiveBracketPair),
      indentation: Re(t.indentation, this.defaultValue.indentation),
      highlightActiveIndentation: gp(t.highlightActiveIndentation, this.defaultValue.highlightActiveIndentation, [!0, !1, "always"])
    };
  }
}
function gp(r, e, t) {
  const n = t.indexOf(r);
  return n === -1 ? e : t[n];
}
class v1t extends Wn {
  constructor() {
    const e = {
      insertMode: "insert",
      filterGraceful: !0,
      snippetsPreventQuickSuggestions: !1,
      localityBonus: !1,
      shareSuggestSelections: !1,
      selectionMode: "always",
      showIcons: !0,
      showStatusBar: !1,
      preview: !1,
      previewMode: "subwordSmart",
      showInlineDetails: !0,
      showMethods: !0,
      showFunctions: !0,
      showConstructors: !0,
      showDeprecated: !0,
      matchOnWordStartOnly: !0,
      showFields: !0,
      showVariables: !0,
      showClasses: !0,
      showStructs: !0,
      showInterfaces: !0,
      showModules: !0,
      showProperties: !0,
      showEvents: !0,
      showOperators: !0,
      showUnits: !0,
      showValues: !0,
      showConstants: !0,
      showEnums: !0,
      showEnumMembers: !0,
      showKeywords: !0,
      showWords: !0,
      showColors: !0,
      showFiles: !0,
      showReferences: !0,
      showFolders: !0,
      showTypeParameters: !0,
      showSnippets: !0,
      showUsers: !0,
      showIssues: !0
    };
    super(119, "suggest", e, {
      "editor.suggest.insertMode": {
        type: "string",
        enum: ["insert", "replace"],
        enumDescriptions: [
          C("suggest.insertMode.insert", "Insert suggestion without overwriting text right of the cursor."),
          C("suggest.insertMode.replace", "Insert suggestion and overwrite text right of the cursor.")
        ],
        default: e.insertMode,
        description: C("suggest.insertMode", "Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.")
      },
      "editor.suggest.filterGraceful": {
        type: "boolean",
        default: e.filterGraceful,
        description: C("suggest.filterGraceful", "Controls whether filtering and sorting suggestions accounts for small typos.")
      },
      "editor.suggest.localityBonus": {
        type: "boolean",
        default: e.localityBonus,
        description: C("suggest.localityBonus", "Controls whether sorting favors words that appear close to the cursor.")
      },
      "editor.suggest.shareSuggestSelections": {
        type: "boolean",
        default: e.shareSuggestSelections,
        markdownDescription: C("suggest.shareSuggestSelections", "Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).")
      },
      "editor.suggest.selectionMode": {
        type: "string",
        enum: ["always", "never", "whenTriggerCharacter", "whenQuickSuggestion"],
        enumDescriptions: [
          C("suggest.insertMode.always", "Always select a suggestion when automatically triggering IntelliSense."),
          C("suggest.insertMode.never", "Never select a suggestion when automatically triggering IntelliSense."),
          C("suggest.insertMode.whenTriggerCharacter", "Select a suggestion only when triggering IntelliSense from a trigger character."),
          C("suggest.insertMode.whenQuickSuggestion", "Select a suggestion only when triggering IntelliSense as you type.")
        ],
        default: e.selectionMode,
        markdownDescription: C("suggest.selectionMode", "Controls whether a suggestion is selected when the widget shows. Note that this only applies to automatically triggered suggestions ({0} and {1}) and that a suggestion is always selected when explicitly invoked, e.g via `Ctrl+Space`.", "`#editor.quickSuggestions#`", "`#editor.suggestOnTriggerCharacters#`")
      },
      "editor.suggest.snippetsPreventQuickSuggestions": {
        type: "boolean",
        default: e.snippetsPreventQuickSuggestions,
        description: C("suggest.snippetsPreventQuickSuggestions", "Controls whether an active snippet prevents quick suggestions.")
      },
      "editor.suggest.showIcons": {
        type: "boolean",
        default: e.showIcons,
        description: C("suggest.showIcons", "Controls whether to show or hide icons in suggestions.")
      },
      "editor.suggest.showStatusBar": {
        type: "boolean",
        default: e.showStatusBar,
        description: C("suggest.showStatusBar", "Controls the visibility of the status bar at the bottom of the suggest widget.")
      },
      "editor.suggest.preview": {
        type: "boolean",
        default: e.preview,
        description: C("suggest.preview", "Controls whether to preview the suggestion outcome in the editor.")
      },
      "editor.suggest.showInlineDetails": {
        type: "boolean",
        default: e.showInlineDetails,
        description: C("suggest.showInlineDetails", "Controls whether suggest details show inline with the label or only in the details widget.")
      },
      "editor.suggest.maxVisibleSuggestions": {
        type: "number",
        deprecationMessage: C("suggest.maxVisibleSuggestions.dep", "This setting is deprecated. The suggest widget can now be resized.")
      },
      "editor.suggest.filteredTypes": {
        type: "object",
        deprecationMessage: C("deprecated", "This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.")
      },
      "editor.suggest.showMethods": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showMethods", "When enabled IntelliSense shows `method`-suggestions.")
      },
      "editor.suggest.showFunctions": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFunctions", "When enabled IntelliSense shows `function`-suggestions.")
      },
      "editor.suggest.showConstructors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showConstructors", "When enabled IntelliSense shows `constructor`-suggestions.")
      },
      "editor.suggest.showDeprecated": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showDeprecated", "When enabled IntelliSense shows `deprecated`-suggestions.")
      },
      "editor.suggest.matchOnWordStartOnly": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.matchOnWordStartOnly", "When enabled IntelliSense filtering requires that the first character matches on a word start. For example, `c` on `Console` or `WebContext` but _not_ on `description`. When disabled IntelliSense will show more results but still sorts them by match quality.")
      },
      "editor.suggest.showFields": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFields", "When enabled IntelliSense shows `field`-suggestions.")
      },
      "editor.suggest.showVariables": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showVariables", "When enabled IntelliSense shows `variable`-suggestions.")
      },
      "editor.suggest.showClasses": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showClasss", "When enabled IntelliSense shows `class`-suggestions.")
      },
      "editor.suggest.showStructs": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showStructs", "When enabled IntelliSense shows `struct`-suggestions.")
      },
      "editor.suggest.showInterfaces": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showInterfaces", "When enabled IntelliSense shows `interface`-suggestions.")
      },
      "editor.suggest.showModules": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showModules", "When enabled IntelliSense shows `module`-suggestions.")
      },
      "editor.suggest.showProperties": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showPropertys", "When enabled IntelliSense shows `property`-suggestions.")
      },
      "editor.suggest.showEvents": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEvents", "When enabled IntelliSense shows `event`-suggestions.")
      },
      "editor.suggest.showOperators": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showOperators", "When enabled IntelliSense shows `operator`-suggestions.")
      },
      "editor.suggest.showUnits": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showUnits", "When enabled IntelliSense shows `unit`-suggestions.")
      },
      "editor.suggest.showValues": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showValues", "When enabled IntelliSense shows `value`-suggestions.")
      },
      "editor.suggest.showConstants": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showConstants", "When enabled IntelliSense shows `constant`-suggestions.")
      },
      "editor.suggest.showEnums": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEnums", "When enabled IntelliSense shows `enum`-suggestions.")
      },
      "editor.suggest.showEnumMembers": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showEnumMembers", "When enabled IntelliSense shows `enumMember`-suggestions.")
      },
      "editor.suggest.showKeywords": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showKeywords", "When enabled IntelliSense shows `keyword`-suggestions.")
      },
      "editor.suggest.showWords": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showTexts", "When enabled IntelliSense shows `text`-suggestions.")
      },
      "editor.suggest.showColors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showColors", "When enabled IntelliSense shows `color`-suggestions.")
      },
      "editor.suggest.showFiles": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFiles", "When enabled IntelliSense shows `file`-suggestions.")
      },
      "editor.suggest.showReferences": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showReferences", "When enabled IntelliSense shows `reference`-suggestions.")
      },
      "editor.suggest.showCustomcolors": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showCustomcolors", "When enabled IntelliSense shows `customcolor`-suggestions.")
      },
      "editor.suggest.showFolders": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showFolders", "When enabled IntelliSense shows `folder`-suggestions.")
      },
      "editor.suggest.showTypeParameters": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showTypeParameters", "When enabled IntelliSense shows `typeParameter`-suggestions.")
      },
      "editor.suggest.showSnippets": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showSnippets", "When enabled IntelliSense shows `snippet`-suggestions.")
      },
      "editor.suggest.showUsers": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showUsers", "When enabled IntelliSense shows `user`-suggestions.")
      },
      "editor.suggest.showIssues": {
        type: "boolean",
        default: !0,
        markdownDescription: C("editor.suggest.showIssues", "When enabled IntelliSense shows `issues`-suggestions.")
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      insertMode: ai(t.insertMode, this.defaultValue.insertMode, ["insert", "replace"]),
      filterGraceful: Re(t.filterGraceful, this.defaultValue.filterGraceful),
      snippetsPreventQuickSuggestions: Re(t.snippetsPreventQuickSuggestions, this.defaultValue.filterGraceful),
      localityBonus: Re(t.localityBonus, this.defaultValue.localityBonus),
      shareSuggestSelections: Re(t.shareSuggestSelections, this.defaultValue.shareSuggestSelections),
      selectionMode: ai(t.selectionMode, this.defaultValue.selectionMode, ["always", "never", "whenQuickSuggestion", "whenTriggerCharacter"]),
      showIcons: Re(t.showIcons, this.defaultValue.showIcons),
      showStatusBar: Re(t.showStatusBar, this.defaultValue.showStatusBar),
      preview: Re(t.preview, this.defaultValue.preview),
      previewMode: ai(t.previewMode, this.defaultValue.previewMode, ["prefix", "subword", "subwordSmart"]),
      showInlineDetails: Re(t.showInlineDetails, this.defaultValue.showInlineDetails),
      showMethods: Re(t.showMethods, this.defaultValue.showMethods),
      showFunctions: Re(t.showFunctions, this.defaultValue.showFunctions),
      showConstructors: Re(t.showConstructors, this.defaultValue.showConstructors),
      showDeprecated: Re(t.showDeprecated, this.defaultValue.showDeprecated),
      matchOnWordStartOnly: Re(t.matchOnWordStartOnly, this.defaultValue.matchOnWordStartOnly),
      showFields: Re(t.showFields, this.defaultValue.showFields),
      showVariables: Re(t.showVariables, this.defaultValue.showVariables),
      showClasses: Re(t.showClasses, this.defaultValue.showClasses),
      showStructs: Re(t.showStructs, this.defaultValue.showStructs),
      showInterfaces: Re(t.showInterfaces, this.defaultValue.showInterfaces),
      showModules: Re(t.showModules, this.defaultValue.showModules),
      showProperties: Re(t.showProperties, this.defaultValue.showProperties),
      showEvents: Re(t.showEvents, this.defaultValue.showEvents),
      showOperators: Re(t.showOperators, this.defaultValue.showOperators),
      showUnits: Re(t.showUnits, this.defaultValue.showUnits),
      showValues: Re(t.showValues, this.defaultValue.showValues),
      showConstants: Re(t.showConstants, this.defaultValue.showConstants),
      showEnums: Re(t.showEnums, this.defaultValue.showEnums),
      showEnumMembers: Re(t.showEnumMembers, this.defaultValue.showEnumMembers),
      showKeywords: Re(t.showKeywords, this.defaultValue.showKeywords),
      showWords: Re(t.showWords, this.defaultValue.showWords),
      showColors: Re(t.showColors, this.defaultValue.showColors),
      showFiles: Re(t.showFiles, this.defaultValue.showFiles),
      showReferences: Re(t.showReferences, this.defaultValue.showReferences),
      showFolders: Re(t.showFolders, this.defaultValue.showFolders),
      showTypeParameters: Re(t.showTypeParameters, this.defaultValue.showTypeParameters),
      showSnippets: Re(t.showSnippets, this.defaultValue.showSnippets),
      showUsers: Re(t.showUsers, this.defaultValue.showUsers),
      showIssues: Re(t.showIssues, this.defaultValue.showIssues)
    };
  }
}
class b1t extends Wn {
  constructor() {
    super(114, "smartSelect", {
      selectLeadingAndTrailingWhitespace: !0,
      selectSubwords: !0
    }, {
      "editor.smartSelect.selectLeadingAndTrailingWhitespace": {
        description: C("selectLeadingAndTrailingWhitespace", "Whether leading and trailing whitespace should always be selected."),
        default: !0,
        type: "boolean"
      },
      "editor.smartSelect.selectSubwords": {
        description: C("selectSubwords", "Whether subwords (like 'foo' in 'fooBar' or 'foo_bar') should be selected."),
        default: !0,
        type: "boolean"
      }
    });
  }
  validate(e) {
    return !e || typeof e != "object" ? this.defaultValue : {
      selectLeadingAndTrailingWhitespace: Re(e.selectLeadingAndTrailingWhitespace, this.defaultValue.selectLeadingAndTrailingWhitespace),
      selectSubwords: Re(e.selectSubwords, this.defaultValue.selectSubwords)
    };
  }
}
class y1t extends Wn {
  constructor() {
    const e = [];
    super(131, "wordSegmenterLocales", e, {
      anyOf: [
        {
          description: C("wordSegmenterLocales", "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."),
          type: "string"
        },
        {
          description: C("wordSegmenterLocales", "Locales to be used for word segmentation when doing word related navigations or operations. Specify the BCP 47 language tag of the word you wish to recognize (e.g., ja, zh-CN, zh-Hant-TW, etc.)."),
          type: "array",
          items: {
            type: "string"
          }
        }
      ]
    });
  }
  validate(e) {
    if (typeof e == "string" && (e = [e]), Array.isArray(e)) {
      const t = [];
      for (const n of e)
        if (typeof n == "string")
          try {
            Intl.Segmenter.supportedLocalesOf(n).length > 0 && t.push(n);
          } catch {
          }
      return t;
    }
    return this.defaultValue;
  }
}
class C1t extends Wn {
  constructor() {
    super(139, "wrappingIndent", 1, {
      "editor.wrappingIndent": {
        type: "string",
        enum: ["none", "same", "indent", "deepIndent"],
        enumDescriptions: [
          C("wrappingIndent.none", "No indentation. Wrapped lines begin at column 1."),
          C("wrappingIndent.same", "Wrapped lines get the same indentation as the parent."),
          C("wrappingIndent.indent", "Wrapped lines get +1 indentation toward the parent."),
          C("wrappingIndent.deepIndent", "Wrapped lines get +2 indentation toward the parent.")
        ],
        description: C("wrappingIndent", "Controls the indentation of wrapped lines."),
        default: "same"
      }
    });
  }
  validate(e) {
    switch (e) {
      case "none":
        return 0;
      case "same":
        return 1;
      case "indent":
        return 2;
      case "deepIndent":
        return 3;
    }
    return 1;
  }
  compute(e, t, n) {
    return t.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 2 ? 0 : n;
  }
}
class E1t extends pw {
  constructor() {
    super(
      147
      /* EditorOption.wrappingInfo */
    );
  }
  compute(e, t, n) {
    const i = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return {
      isDominatedByLongLines: e.isDominatedByLongLines,
      isWordWrapMinified: i.isWordWrapMinified,
      isViewportWrapping: i.isViewportWrapping,
      wrappingColumn: i.wrappingColumn
    };
  }
}
class _1t extends Wn {
  constructor() {
    const e = { enabled: !0, showDropSelector: "afterDrop" };
    super(36, "dropIntoEditor", e, {
      "editor.dropIntoEditor.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("dropIntoEditor.enabled", "Controls whether you can drag and drop a file into a text editor by holding down the `Shift` key (instead of opening the file in an editor).")
      },
      "editor.dropIntoEditor.showDropSelector": {
        type: "string",
        markdownDescription: C("dropIntoEditor.showDropSelector", "Controls if a widget is shown when dropping files into the editor. This widget lets you control how the file is dropped."),
        enum: [
          "afterDrop",
          "never"
        ],
        enumDescriptions: [
          C("dropIntoEditor.showDropSelector.afterDrop", "Show the drop selector widget after a file is dropped into the editor."),
          C("dropIntoEditor.showDropSelector.never", "Never show the drop selector widget. Instead the default drop provider is always used.")
        ],
        default: "afterDrop"
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      showDropSelector: ai(t.showDropSelector, this.defaultValue.showDropSelector, ["afterDrop", "never"])
    };
  }
}
class x1t extends Wn {
  constructor() {
    const e = { enabled: !0, showPasteSelector: "afterPaste" };
    super(85, "pasteAs", e, {
      "editor.pasteAs.enabled": {
        type: "boolean",
        default: e.enabled,
        markdownDescription: C("pasteAs.enabled", "Controls whether you can paste content in different ways.")
      },
      "editor.pasteAs.showPasteSelector": {
        type: "string",
        markdownDescription: C("pasteAs.showPasteSelector", "Controls if a widget is shown when pasting content in to the editor. This widget lets you control how the file is pasted."),
        enum: [
          "afterPaste",
          "never"
        ],
        enumDescriptions: [
          C("pasteAs.showPasteSelector.afterPaste", "Show the paste selector widget after content is pasted into the editor."),
          C("pasteAs.showPasteSelector.never", "Never show the paste selector widget. Instead the default pasting behavior is always used.")
        ],
        default: "afterPaste"
      }
    });
  }
  validate(e) {
    if (!e || typeof e != "object")
      return this.defaultValue;
    const t = e;
    return {
      enabled: Re(t.enabled, this.defaultValue.enabled),
      showPasteSelector: ai(t.showPasteSelector, this.defaultValue.showPasteSelector, ["afterPaste", "never"])
    };
  }
}
const S1t = "Consolas, 'Courier New', monospace", M1t = "Menlo, Monaco, 'Courier New', monospace", D1t = "'Droid Sans Mono', 'monospace', monospace", Bo = {
  fontFamily: zt ? M1t : Cs ? D1t : S1t,
  fontWeight: "normal",
  fontSize: zt ? 12 : 14,
  lineHeight: 0,
  letterSpacing: 0
}, q2 = [];
function ve(r) {
  return q2[r.id] = r, r;
}
const Wf = {
  acceptSuggestionOnCommitCharacter: ve(new Rt(0, "acceptSuggestionOnCommitCharacter", !0, { markdownDescription: C("acceptSuggestionOnCommitCharacter", "Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.") })),
  acceptSuggestionOnEnter: ve(new si(1, "acceptSuggestionOnEnter", "on", ["on", "smart", "off"], {
    markdownEnumDescriptions: [
      "",
      C("acceptSuggestionOnEnterSmart", "Only accept a suggestion with `Enter` when it makes a textual change."),
      ""
    ],
    markdownDescription: C("acceptSuggestionOnEnter", "Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.")
  })),
  accessibilitySupport: ve(new Fut()),
  accessibilityPageSize: ve(new Cn(3, "accessibilityPageSize", 10, 1, 1073741824, {
    description: C("accessibilityPageSize", "Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default."),
    tags: ["accessibility"]
  })),
  ariaLabel: ve(new $r(4, "ariaLabel", C("editorViewAccessibleLabel", "Editor content"))),
  ariaRequired: ve(new Rt(5, "ariaRequired", !1, void 0)),
  screenReaderAnnounceInlineSuggestion: ve(new Rt(8, "screenReaderAnnounceInlineSuggestion", !0, {
    description: C("screenReaderAnnounceInlineSuggestion", "Control whether inline suggestions are announced by a screen reader."),
    tags: ["accessibility"]
  })),
  autoClosingBrackets: ve(new si(6, "autoClosingBrackets", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingBrackets.languageDefined", "Use language configurations to determine when to autoclose brackets."),
      C("editor.autoClosingBrackets.beforeWhitespace", "Autoclose brackets only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingBrackets", "Controls whether the editor should automatically close brackets after the user adds an opening bracket.")
  })),
  autoClosingComments: ve(new si(7, "autoClosingComments", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingComments.languageDefined", "Use language configurations to determine when to autoclose comments."),
      C("editor.autoClosingComments.beforeWhitespace", "Autoclose comments only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingComments", "Controls whether the editor should automatically close comments after the user adds an opening comment.")
  })),
  autoClosingDelete: ve(new si(9, "autoClosingDelete", "auto", ["always", "auto", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingDelete.auto", "Remove adjacent closing quotes or brackets only if they were automatically inserted."),
      ""
    ],
    description: C("autoClosingDelete", "Controls whether the editor should remove adjacent closing quotes or brackets when deleting.")
  })),
  autoClosingOvertype: ve(new si(10, "autoClosingOvertype", "auto", ["always", "auto", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingOvertype.auto", "Type over closing quotes or brackets only if they were automatically inserted."),
      ""
    ],
    description: C("autoClosingOvertype", "Controls whether the editor should type over closing quotes or brackets.")
  })),
  autoClosingQuotes: ve(new si(11, "autoClosingQuotes", "languageDefined", ["always", "languageDefined", "beforeWhitespace", "never"], {
    enumDescriptions: [
      "",
      C("editor.autoClosingQuotes.languageDefined", "Use language configurations to determine when to autoclose quotes."),
      C("editor.autoClosingQuotes.beforeWhitespace", "Autoclose quotes only when the cursor is to the left of whitespace."),
      ""
    ],
    description: C("autoClosingQuotes", "Controls whether the editor should automatically close quotes after the user adds an opening quote.")
  })),
  autoIndent: ve(new Ev(12, "autoIndent", 4, "full", ["none", "keep", "brackets", "advanced", "full"], Put, {
    enumDescriptions: [
      C("editor.autoIndent.none", "The editor will not insert indentation automatically."),
      C("editor.autoIndent.keep", "The editor will keep the current line's indentation."),
      C("editor.autoIndent.brackets", "The editor will keep the current line's indentation and honor language defined brackets."),
      C("editor.autoIndent.advanced", "The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages."),
      C("editor.autoIndent.full", "The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.")
    ],
    description: C("autoIndent", "Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.")
  })),
  automaticLayout: ve(new Rt(13, "automaticLayout", !1)),
  autoSurround: ve(new si(14, "autoSurround", "languageDefined", ["languageDefined", "quotes", "brackets", "never"], {
    enumDescriptions: [
      C("editor.autoSurround.languageDefined", "Use language configurations to determine when to automatically surround selections."),
      C("editor.autoSurround.quotes", "Surround with quotes but not brackets."),
      C("editor.autoSurround.brackets", "Surround with brackets but not quotes."),
      ""
    ],
    description: C("autoSurround", "Controls whether the editor should automatically surround selections when typing quotes or brackets.")
  })),
  bracketPairColorization: ve(new A1t()),
  bracketPairGuides: ve(new w1t()),
  stickyTabStops: ve(new Rt(117, "stickyTabStops", !1, { description: C("stickyTabStops", "Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.") })),
  codeLens: ve(new Rt(17, "codeLens", !0, { description: C("codeLens", "Controls whether the editor shows CodeLens.") })),
  codeLensFontFamily: ve(new $r(18, "codeLensFontFamily", "", { description: C("codeLensFontFamily", "Controls the font family for CodeLens.") })),
  codeLensFontSize: ve(new Cn(19, "codeLensFontSize", 0, 0, 100, {
    type: "number",
    default: 0,
    minimum: 0,
    maximum: 100,
    markdownDescription: C("codeLensFontSize", "Controls the font size in pixels for CodeLens. When set to 0, 90% of `#editor.fontSize#` is used.")
  })),
  colorDecorators: ve(new Rt(20, "colorDecorators", !0, { description: C("colorDecorators", "Controls whether the editor should render the inline color decorators and color picker.") })),
  colorDecoratorActivatedOn: ve(new si(149, "colorDecoratorsActivatedOn", "clickAndHover", ["clickAndHover", "hover", "click"], {
    enumDescriptions: [
      C("editor.colorDecoratorActivatedOn.clickAndHover", "Make the color picker appear both on click and hover of the color decorator"),
      C("editor.colorDecoratorActivatedOn.hover", "Make the color picker appear on hover of the color decorator"),
      C("editor.colorDecoratorActivatedOn.click", "Make the color picker appear on click of the color decorator")
    ],
    description: C("colorDecoratorActivatedOn", "Controls the condition to make a color picker appear from a color decorator")
  })),
  colorDecoratorsLimit: ve(new Cn(21, "colorDecoratorsLimit", 500, 1, 1e6, {
    markdownDescription: C("colorDecoratorsLimit", "Controls the max number of color decorators that can be rendered in an editor at once.")
  })),
  columnSelection: ve(new Rt(22, "columnSelection", !1, { description: C("columnSelection", "Enable that the selection with the mouse and keys is doing column selection.") })),
  comments: ve(new zut()),
  contextmenu: ve(new Rt(24, "contextmenu", !0)),
  copyWithSyntaxHighlighting: ve(new Rt(25, "copyWithSyntaxHighlighting", !0, { description: C("copyWithSyntaxHighlighting", "Controls whether syntax highlighting should be copied into the clipboard.") })),
  cursorBlinking: ve(new Ev(26, "cursorBlinking", 1, "blink", ["blink", "smooth", "phase", "expand", "solid"], Wut, { description: C("cursorBlinking", "Control the cursor animation style.") })),
  cursorSmoothCaretAnimation: ve(new si(27, "cursorSmoothCaretAnimation", "off", ["off", "explicit", "on"], {
    enumDescriptions: [
      C("cursorSmoothCaretAnimation.off", "Smooth caret animation is disabled."),
      C("cursorSmoothCaretAnimation.explicit", "Smooth caret animation is enabled only when the user moves the cursor with an explicit gesture."),
      C("cursorSmoothCaretAnimation.on", "Smooth caret animation is always enabled.")
    ],
    description: C("cursorSmoothCaretAnimation", "Controls whether the smooth caret animation should be enabled.")
  })),
  cursorStyle: ve(new Ev(28, "cursorStyle", gr.Line, "line", ["line", "block", "underline", "line-thin", "block-outline", "underline-thin"], jut, { description: C("cursorStyle", "Controls the cursor style.") })),
  cursorSurroundingLines: ve(new Cn(29, "cursorSurroundingLines", 0, 0, 1073741824, { description: C("cursorSurroundingLines", "Controls the minimal number of visible leading lines (minimum 0) and trailing lines (minimum 1) surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.") })),
  cursorSurroundingLinesStyle: ve(new si(30, "cursorSurroundingLinesStyle", "default", ["default", "all"], {
    enumDescriptions: [
      C("cursorSurroundingLinesStyle.default", "`cursorSurroundingLines` is enforced only when triggered via the keyboard or API."),
      C("cursorSurroundingLinesStyle.all", "`cursorSurroundingLines` is enforced always.")
    ],
    markdownDescription: C("cursorSurroundingLinesStyle", "Controls when `#editor.cursorSurroundingLines#` should be enforced.")
  })),
  cursorWidth: ve(new Cn(31, "cursorWidth", 0, 0, 1073741824, { markdownDescription: C("cursorWidth", "Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.") })),
  disableLayerHinting: ve(new Rt(32, "disableLayerHinting", !1)),
  disableMonospaceOptimizations: ve(new Rt(33, "disableMonospaceOptimizations", !1)),
  domReadOnly: ve(new Rt(34, "domReadOnly", !1)),
  dragAndDrop: ve(new Rt(35, "dragAndDrop", !0, { description: C("dragAndDrop", "Controls whether the editor should allow moving selections via drag and drop.") })),
  emptySelectionClipboard: ve(new Uut()),
  dropIntoEditor: ve(new _1t()),
  stickyScroll: ve(new $ut()),
  experimentalWhitespaceRendering: ve(new si(38, "experimentalWhitespaceRendering", "svg", ["svg", "font", "off"], {
    enumDescriptions: [
      C("experimentalWhitespaceRendering.svg", "Use a new rendering method with svgs."),
      C("experimentalWhitespaceRendering.font", "Use a new rendering method with font characters."),
      C("experimentalWhitespaceRendering.off", "Use the stable rendering method.")
    ],
    description: C("experimentalWhitespaceRendering", "Controls whether whitespace is rendered with a new, experimental method.")
  })),
  extraEditorClassName: ve(new $r(39, "extraEditorClassName", "")),
  fastScrollSensitivity: ve(new No(40, "fastScrollSensitivity", 5, (r) => r <= 0 ? 5 : r, { markdownDescription: C("fastScrollSensitivity", "Scrolling speed multiplier when pressing `Alt`.") })),
  find: ve(new qut()),
  fixedOverflowWidgets: ve(new Rt(42, "fixedOverflowWidgets", !1)),
  folding: ve(new Rt(43, "folding", !0, { description: C("folding", "Controls whether the editor has code folding enabled.") })),
  foldingStrategy: ve(new si(44, "foldingStrategy", "auto", ["auto", "indentation"], {
    enumDescriptions: [
      C("foldingStrategy.auto", "Use a language-specific folding strategy if available, else the indentation-based one."),
      C("foldingStrategy.indentation", "Use the indentation-based folding strategy.")
    ],
    description: C("foldingStrategy", "Controls the strategy for computing folding ranges.")
  })),
  foldingHighlight: ve(new Rt(45, "foldingHighlight", !0, { description: C("foldingHighlight", "Controls whether the editor should highlight folded ranges.") })),
  foldingImportsByDefault: ve(new Rt(46, "foldingImportsByDefault", !1, { description: C("foldingImportsByDefault", "Controls whether the editor automatically collapses import ranges.") })),
  foldingMaximumRegions: ve(new Cn(
    47,
    "foldingMaximumRegions",
    5e3,
    10,
    65e3,
    // limit must be less than foldingRanges MAX_FOLDING_REGIONS
    { description: C("foldingMaximumRegions", "The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.") }
  )),
  unfoldOnClickAfterEndOfLine: ve(new Rt(48, "unfoldOnClickAfterEndOfLine", !1, { description: C("unfoldOnClickAfterEndOfLine", "Controls whether clicking on the empty content after a folded line will unfold the line.") })),
  fontFamily: ve(new $r(49, "fontFamily", Bo.fontFamily, { description: C("fontFamily", "Controls the font family.") })),
  fontInfo: ve(new Gut()),
  fontLigatures2: ve(new Bl()),
  fontSize: ve(new Qut()),
  fontWeight: ve(new f0()),
  fontVariations: ve(new rd()),
  formatOnPaste: ve(new Rt(55, "formatOnPaste", !1, { description: C("formatOnPaste", "Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.") })),
  formatOnType: ve(new Rt(56, "formatOnType", !1, { description: C("formatOnType", "Controls whether the editor should automatically format the line after typing.") })),
  glyphMargin: ve(new Rt(57, "glyphMargin", !0, { description: C("glyphMargin", "Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.") })),
  gotoLocation: ve(new Kut()),
  hideCursorInOverviewRuler: ve(new Rt(59, "hideCursorInOverviewRuler", !1, { description: C("hideCursorInOverviewRuler", "Controls whether the cursor should be hidden in the overview ruler.") })),
  hover: ve(new Yut()),
  inDiffEditor: ve(new Rt(61, "inDiffEditor", !1)),
  letterSpacing: ve(new No(64, "letterSpacing", Bo.letterSpacing, (r) => No.clamp(r, -5, 20), { description: C("letterSpacing", "Controls the letter spacing in pixels.") })),
  lightbulb: ve(new Jut()),
  lineDecorationsWidth: ve(new t1t()),
  lineHeight: ve(new n1t()),
  lineNumbers: ve(new h1t()),
  lineNumbersMinChars: ve(new Cn(69, "lineNumbersMinChars", 5, 1, 300)),
  linkedEditing: ve(new Rt(70, "linkedEditing", !1, { description: C("linkedEditing", "Controls whether the editor has linked editing enabled. Depending on the language, related symbols such as HTML tags, are updated while editing.") })),
  links: ve(new Rt(71, "links", !0, { description: C("links", "Controls whether the editor should detect links and make them clickable.") })),
  matchBrackets: ve(new si(72, "matchBrackets", "always", ["always", "near", "never"], { description: C("matchBrackets", "Highlight matching brackets.") })),
  minimap: ve(new i1t()),
  mouseStyle: ve(new si(74, "mouseStyle", "text", ["text", "default", "copy"])),
  mouseWheelScrollSensitivity: ve(new No(75, "mouseWheelScrollSensitivity", 1, (r) => r === 0 ? 1 : r, { markdownDescription: C("mouseWheelScrollSensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.") })),
  mouseWheelZoom: ve(new Rt(76, "mouseWheelZoom", !1, {
    markdownDescription: zt ? C("mouseWheelZoom.mac", "Zoom the font of the editor when using mouse wheel and holding `Cmd`.") : C("mouseWheelZoom", "Zoom the font of the editor when using mouse wheel and holding `Ctrl`.")
  })),
  multiCursorMergeOverlapping: ve(new Rt(77, "multiCursorMergeOverlapping", !0, { description: C("multiCursorMergeOverlapping", "Merge multiple cursors when they are overlapping.") })),
  multiCursorModifier: ve(new Ev(78, "multiCursorModifier", "altKey", "alt", ["ctrlCmd", "alt"], r1t, {
    markdownEnumDescriptions: [
      C("multiCursorModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
      C("multiCursorModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
    ],
    markdownDescription: C({
      key: "multiCursorModifier",
      comment: [
        "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
        "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
      ]
    }, "The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).")
  })),
  multiCursorPaste: ve(new si(79, "multiCursorPaste", "spread", ["spread", "full"], {
    markdownEnumDescriptions: [
      C("multiCursorPaste.spread", "Each cursor pastes a single line of the text."),
      C("multiCursorPaste.full", "Each cursor pastes the full text.")
    ],
    markdownDescription: C("multiCursorPaste", "Controls pasting when the line count of the pasted text matches the cursor count.")
  })),
  multiCursorLimit: ve(new Cn(80, "multiCursorLimit", 1e4, 1, 1e5, {
    markdownDescription: C("multiCursorLimit", "Controls the max number of cursors that can be in an active editor at once.")
  })),
  occurrencesHighlight: ve(new si(81, "occurrencesHighlight", "singleFile", ["off", "singleFile", "multiFile"], {
    markdownEnumDescriptions: [
      C("occurrencesHighlight.off", "Does not highlight occurrences."),
      C("occurrencesHighlight.singleFile", "Highlights occurrences only in the current file."),
      C("occurrencesHighlight.multiFile", "Experimental: Highlights occurrences across all valid open files.")
    ],
    markdownDescription: C("occurrencesHighlight", "Controls whether occurrences should be highlighted across open files.")
  })),
  overviewRulerBorder: ve(new Rt(82, "overviewRulerBorder", !0, { description: C("overviewRulerBorder", "Controls whether a border should be drawn around the overview ruler.") })),
  overviewRulerLanes: ve(new Cn(83, "overviewRulerLanes", 3, 0, 3)),
  padding: ve(new s1t()),
  pasteAs: ve(new x1t()),
  parameterHints: ve(new o1t()),
  peekWidgetDefaultFocus: ve(new si(87, "peekWidgetDefaultFocus", "tree", ["tree", "editor"], {
    enumDescriptions: [
      C("peekWidgetDefaultFocus.tree", "Focus the tree when opening peek"),
      C("peekWidgetDefaultFocus.editor", "Focus the editor when opening peek")
    ],
    description: C("peekWidgetDefaultFocus", "Controls whether to focus the inline editor or the tree in the peek widget.")
  })),
  placeholder: ve(new l1t()),
  definitionLinkOpensInPeek: ve(new Rt(89, "definitionLinkOpensInPeek", !1, { description: C("definitionLinkOpensInPeek", "Controls whether the Go to Definition mouse gesture always opens the peek widget.") })),
  quickSuggestions: ve(new c1t()),
  quickSuggestionsDelay: ve(new Cn(91, "quickSuggestionsDelay", 10, 0, 1073741824, { description: C("quickSuggestionsDelay", "Controls the delay in milliseconds after which quick suggestions will show up.") })),
  readOnly: ve(new Rt(92, "readOnly", !1)),
  readOnlyMessage: ve(new u1t()),
  renameOnType: ve(new Rt(94, "renameOnType", !1, { description: C("renameOnType", "Controls whether the editor auto renames on type."), markdownDeprecationMessage: C("renameOnTypeDeprecate", "Deprecated, use `editor.linkedEditing` instead.") })),
  renderControlCharacters: ve(new Rt(95, "renderControlCharacters", !0, { description: C("renderControlCharacters", "Controls whether the editor should render control characters."), restricted: !0 })),
  renderFinalNewline: ve(new si(96, "renderFinalNewline", Cs ? "dimmed" : "on", ["off", "on", "dimmed"], { description: C("renderFinalNewline", "Render last line number when the file ends with a newline.") })),
  renderLineHighlight: ve(new si(97, "renderLineHighlight", "line", ["none", "gutter", "line", "all"], {
    enumDescriptions: [
      "",
      "",
      "",
      C("renderLineHighlight.all", "Highlights both the gutter and the current line.")
    ],
    description: C("renderLineHighlight", "Controls how the editor should render the current line highlight.")
  })),
  renderLineHighlightOnlyWhenFocus: ve(new Rt(98, "renderLineHighlightOnlyWhenFocus", !1, { description: C("renderLineHighlightOnlyWhenFocus", "Controls if the editor should render the current line highlight only when the editor is focused.") })),
  renderValidationDecorations: ve(new si(99, "renderValidationDecorations", "editable", ["editable", "on", "off"])),
  renderWhitespace: ve(new si(100, "renderWhitespace", "selection", ["none", "boundary", "selection", "trailing", "all"], {
    enumDescriptions: [
      "",
      C("renderWhitespace.boundary", "Render whitespace characters except for single spaces between words."),
      C("renderWhitespace.selection", "Render whitespace characters only on selected text."),
      C("renderWhitespace.trailing", "Render only trailing whitespace characters."),
      ""
    ],
    description: C("renderWhitespace", "Controls how the editor should render whitespace characters.")
  })),
  revealHorizontalRightPadding: ve(new Cn(101, "revealHorizontalRightPadding", 15, 0, 1e3)),
  roundedSelection: ve(new Rt(102, "roundedSelection", !0, { description: C("roundedSelection", "Controls whether selections should have rounded corners.") })),
  rulers: ve(new d1t()),
  scrollbar: ve(new f1t()),
  scrollBeyondLastColumn: ve(new Cn(105, "scrollBeyondLastColumn", 4, 0, 1073741824, { description: C("scrollBeyondLastColumn", "Controls the number of extra characters beyond which the editor will scroll horizontally.") })),
  scrollBeyondLastLine: ve(new Rt(106, "scrollBeyondLastLine", !0, { description: C("scrollBeyondLastLine", "Controls whether the editor will scroll beyond the last line.") })),
  scrollPredominantAxis: ve(new Rt(107, "scrollPredominantAxis", !0, { description: C("scrollPredominantAxis", "Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.") })),
  selectionClipboard: ve(new Rt(108, "selectionClipboard", !0, {
    description: C("selectionClipboard", "Controls whether the Linux primary clipboard should be supported."),
    included: Cs
  })),
  selectionHighlight: ve(new Rt(109, "selectionHighlight", !0, { description: C("selectionHighlight", "Controls whether the editor should highlight matches similar to the selection.") })),
  selectOnLineNumbers: ve(new Rt(110, "selectOnLineNumbers", !0)),
  showFoldingControls: ve(new si(111, "showFoldingControls", "mouseover", ["always", "never", "mouseover"], {
    enumDescriptions: [
      C("showFoldingControls.always", "Always show the folding controls."),
      C("showFoldingControls.never", "Never show the folding controls and reduce the gutter size."),
      C("showFoldingControls.mouseover", "Only show the folding controls when the mouse is over the gutter.")
    ],
    description: C("showFoldingControls", "Controls when the folding controls on the gutter are shown.")
  })),
  showUnused: ve(new Rt(112, "showUnused", !0, { description: C("showUnused", "Controls fading out of unused code.") })),
  showDeprecated: ve(new Rt(141, "showDeprecated", !0, { description: C("showDeprecated", "Controls strikethrough deprecated variables.") })),
  inlayHints: ve(new e1t()),
  snippetSuggestions: ve(new si(113, "snippetSuggestions", "inline", ["top", "bottom", "inline", "none"], {
    enumDescriptions: [
      C("snippetSuggestions.top", "Show snippet suggestions on top of other suggestions."),
      C("snippetSuggestions.bottom", "Show snippet suggestions below other suggestions."),
      C("snippetSuggestions.inline", "Show snippets suggestions with other suggestions."),
      C("snippetSuggestions.none", "Do not show snippet suggestions.")
    ],
    description: C("snippetSuggestions", "Controls whether snippets are shown with other suggestions and how they are sorted.")
  })),
  smartSelect: ve(new b1t()),
  smoothScrolling: ve(new Rt(115, "smoothScrolling", !1, { description: C("smoothScrolling", "Controls whether the editor will scroll using an animation.") })),
  stopRenderingLineAfter: ve(new Cn(
    118,
    "stopRenderingLineAfter",
    1e4,
    -1,
    1073741824
    /* Constants.MAX_SAFE_SMALL_INTEGER */
  )),
  suggest: ve(new v1t()),
  inlineSuggest: ve(new g1t()),
  inlineEdit: ve(new m1t()),
  inlineCompletionsAccessibilityVerbose: ve(new Rt(150, "inlineCompletionsAccessibilityVerbose", !1, { description: C("inlineCompletionsAccessibilityVerbose", "Controls whether the accessibility hint should be provided to screen reader users when an inline completion is shown.") })),
  suggestFontSize: ve(new Cn(120, "suggestFontSize", 0, 0, 1e3, { markdownDescription: C("suggestFontSize", "Font size for the suggest widget. When set to {0}, the value of {1} is used.", "`0`", "`#editor.fontSize#`") })),
  suggestLineHeight: ve(new Cn(121, "suggestLineHeight", 0, 0, 1e3, { markdownDescription: C("suggestLineHeight", "Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.", "`0`", "`#editor.lineHeight#`") })),
  suggestOnTriggerCharacters: ve(new Rt(122, "suggestOnTriggerCharacters", !0, { description: C("suggestOnTriggerCharacters", "Controls whether suggestions should automatically show up when typing trigger characters.") })),
  suggestSelection: ve(new si(123, "suggestSelection", "first", ["first", "recentlyUsed", "recentlyUsedByPrefix"], {
    markdownEnumDescriptions: [
      C("suggestSelection.first", "Always select the first suggestion."),
      C("suggestSelection.recentlyUsed", "Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently."),
      C("suggestSelection.recentlyUsedByPrefix", "Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.")
    ],
    description: C("suggestSelection", "Controls how suggestions are pre-selected when showing the suggest list.")
  })),
  tabCompletion: ve(new si(124, "tabCompletion", "off", ["on", "off", "onlySnippets"], {
    enumDescriptions: [
      C("tabCompletion.on", "Tab complete will insert the best matching suggestion when pressing tab."),
      C("tabCompletion.off", "Disable tab completions."),
      C("tabCompletion.onlySnippets", "Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.")
    ],
    description: C("tabCompletion", "Enables tab completions.")
  })),
  tabIndex: ve(new Cn(
    125,
    "tabIndex",
    0,
    -1,
    1073741824
    /* Constants.MAX_SAFE_SMALL_INTEGER */
  )),
  unicodeHighlight: ve(new p1t()),
  unusualLineTerminators: ve(new si(127, "unusualLineTerminators", "prompt", ["auto", "off", "prompt"], {
    enumDescriptions: [
      C("unusualLineTerminators.auto", "Unusual line terminators are automatically removed."),
      C("unusualLineTerminators.off", "Unusual line terminators are ignored."),
      C("unusualLineTerminators.prompt", "Unusual line terminators prompt to be removed.")
    ],
    description: C("unusualLineTerminators", "Remove unusual line terminators that might cause problems.")
  })),
  useShadowDOM: ve(new Rt(128, "useShadowDOM", !0)),
  useTabStops: ve(new Rt(129, "useTabStops", !0, { description: C("useTabStops", "Spaces and tabs are inserted and deleted in alignment with tab stops.") })),
  wordBreak: ve(new si(130, "wordBreak", "normal", ["normal", "keepAll"], {
    markdownEnumDescriptions: [
      C("wordBreak.normal", "Use the default line break rule."),
      C("wordBreak.keepAll", "Word breaks should not be used for Chinese/Japanese/Korean (CJK) text. Non-CJK text behavior is the same as for normal.")
    ],
    description: C("wordBreak", "Controls the word break rules used for Chinese/Japanese/Korean (CJK) text.")
  })),
  wordSegmenterLocales: ve(new y1t()),
  wordSeparators: ve(new $r(132, "wordSeparators", VMe, { description: C("wordSeparators", "Characters that will be used as word separators when doing word related navigations or operations.") })),
  wordWrap: ve(new si(133, "wordWrap", "off", ["off", "on", "wordWrapColumn", "bounded"], {
    markdownEnumDescriptions: [
      C("wordWrap.off", "Lines will never wrap."),
      C("wordWrap.on", "Lines will wrap at the viewport width."),
      C({
        key: "wordWrap.wordWrapColumn",
        comment: [
          "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
        ]
      }, "Lines will wrap at `#editor.wordWrapColumn#`."),
      C({
        key: "wordWrap.bounded",
        comment: [
          "- viewport means the edge of the visible window size.",
          "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
        ]
      }, "Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.")
    ],
    description: C({
      key: "wordWrap",
      comment: [
        "- 'off', 'on', 'wordWrapColumn' and 'bounded' refer to values the setting can take and should not be localized.",
        "- `editor.wordWrapColumn` refers to a different setting and should not be localized."
      ]
    }, "Controls how lines should wrap.")
  })),
  wordWrapBreakAfterCharacters: ve(new $r(
    134,
    "wordWrapBreakAfterCharacters",
    // allow-any-unicode-next-line
    " 	})]?|/&.,;¢°′″‰℃、。｡､￠，．：；？！％・･ゝゞヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻ｧｨｩｪｫｬｭｮｯｰ”〉》」』】〕）］｝｣"
  )),
  wordWrapBreakBeforeCharacters: ve(new $r(
    135,
    "wordWrapBreakBeforeCharacters",
    // allow-any-unicode-next-line
    "([{‘“〈《「『【〔（［｛｢£¥＄￡￥+＋"
  )),
  wordWrapColumn: ve(new Cn(136, "wordWrapColumn", 80, 1, 1073741824, {
    markdownDescription: C({
      key: "wordWrapColumn",
      comment: [
        "- `editor.wordWrap` refers to a different setting and should not be localized.",
        "- 'wordWrapColumn' and 'bounded' refer to values the different setting can take and should not be localized."
      ]
    }, "Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.")
  })),
  wordWrapOverride1: ve(new si(137, "wordWrapOverride1", "inherit", ["off", "on", "inherit"])),
  wordWrapOverride2: ve(new si(138, "wordWrapOverride2", "inherit", ["off", "on", "inherit"])),
  // Leave these at the end (because they have dependencies!)
  editorClassName: ve(new Zut()),
  defaultColorDecorators: ve(new Rt(148, "defaultColorDecorators", !1, { markdownDescription: C("defaultColorDecorators", "Controls whether inline color decorations should be shown using the default document color provider") })),
  pixelRatio: ve(new a1t()),
  tabFocusMode: ve(new Rt(145, "tabFocusMode", !1, { markdownDescription: C("tabFocusMode", "Controls whether the editor receives tabs or defers them to the workbench for navigation.") })),
  layoutInfo: ve(new pp()),
  wrappingInfo: ve(new E1t()),
  wrappingIndent: ve(new C1t()),
  wrappingStrategy: ve(new Xut())
};
class L1t {
  constructor() {
    this.listeners = [], this.unexpectedErrorHandler = function(e) {
      setTimeout(() => {
        throw e.stack ? ng.isErrorNoTelemetry(e) ? new ng(e.message + `

` + e.stack) : new Error(e.message + `

` + e.stack) : e;
      }, 0);
    };
  }
  emit(e) {
    this.listeners.forEach((t) => {
      t(e);
    });
  }
  onUnexpectedError(e) {
    this.unexpectedErrorHandler(e), this.emit(e);
  }
  // For external errors, we don't want the listeners to be called
  onUnexpectedExternalError(e) {
    this.unexpectedErrorHandler(e);
  }
}
const FMe = new L1t();
function wn(r) {
  gw(r) || FMe.onUnexpectedError(r);
}
function xI(r) {
  gw(r) || FMe.onUnexpectedExternalError(r);
}
function Ave(r) {
  if (r instanceof Error) {
    const { name: e, message: t } = r, n = r.stacktrace || r.stack;
    return {
      $isError: !0,
      name: e,
      message: t,
      stack: n,
      noTelemetry: ng.isErrorNoTelemetry(r)
    };
  }
  return r;
}
const D8 = "Canceled";
function gw(r) {
  return r instanceof mw ? !0 : r instanceof Error && r.name === D8 && r.message === D8;
}
class mw extends Error {
  constructor() {
    super(D8), this.name = this.message;
  }
}
function k1t() {
  const r = new Error(D8);
  return r.name = r.message, r;
}
function I7(r) {
  return r ? new Error(`Illegal argument: ${r}`) : new Error("Illegal argument");
}
function SI(r) {
  return r ? new Error(`Illegal state: ${r}`) : new Error("Illegal state");
}
class N1t extends Error {
  constructor(e) {
    super("NotSupported"), e && (this.message = e);
  }
}
class ng extends Error {
  constructor(e) {
    super(e), this.name = "CodeExpectedError";
  }
  static fromError(e) {
    if (e instanceof ng)
      return e;
    const t = new ng();
    return t.message = e.message, t.stack = e.stack, t;
  }
  static isErrorNoTelemetry(e) {
    return e.name === "CodeExpectedError";
  }
}
class cn extends Error {
  constructor(e) {
    super(e || "An unexpected bug occurred."), Object.setPrototypeOf(this, cn.prototype);
  }
}
function ig(r, e) {
  const t = this;
  let n = !1, i;
  return function() {
    return n || (n = !0, i = r.apply(t, arguments)), i;
  };
}
function zMe(r) {
  return typeof r == "object" && r !== null && typeof r.dispose == "function" && r.dispose.length === 0;
}
function br(r) {
  if (Jt.is(r)) {
    const e = [];
    for (const t of r)
      if (t)
        try {
          t.dispose();
        } catch (n) {
          e.push(n);
        }
    if (e.length === 1)
      throw e[0];
    if (e.length > 1)
      throw new AggregateError(e, "Encountered errors while disposing of store");
    return Array.isArray(r) ? [] : r;
  } else if (r)
    return r.dispose(), r;
}
function ih(...r) {
  return ht(() => br(r));
}
function ht(r) {
  return {
    dispose: ig(() => {
      r();
    })
  };
}
class ze {
  static {
    this.DISABLE_DISPOSED_WARNING = !1;
  }
  constructor() {
    this._toDispose = /* @__PURE__ */ new Set(), this._isDisposed = !1;
  }
  /**
   * Dispose of all registered disposables and mark this object as disposed.
   *
   * Any future disposables added to this object will be disposed of on `add`.
   */
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this.clear());
  }
  /**
   * @return `true` if this object has been disposed of.
   */
  get isDisposed() {
    return this._isDisposed;
  }
  /**
   * Dispose of all registered disposables but do not mark this object as disposed.
   */
  clear() {
    if (this._toDispose.size !== 0)
      try {
        br(this._toDispose);
      } finally {
        this._toDispose.clear();
      }
  }
  /**
   * Add a new {@link IDisposable disposable} to the collection.
   */
  add(e) {
    if (!e)
      return e;
    if (e === this)
      throw new Error("Cannot register a disposable on itself!");
    return this._isDisposed ? ze.DISABLE_DISPOSED_WARNING || console.warn(new Error("Trying to add a disposable to a DisposableStore that has already been disposed of. The added object will be leaked!").stack) : this._toDispose.add(e), e;
  }
  /**
   * Deletes the value from the store, but does not dispose it.
   */
  deleteAndLeak(e) {
    e && this._toDispose.has(e) && this._toDispose.delete(e);
  }
}
class me {
  static {
    this.None = Object.freeze({ dispose() {
    } });
  }
  constructor() {
    this._store = new ze(), this._store;
  }
  dispose() {
    this._store.dispose();
  }
  /**
   * Adds `o` to the collection of disposables managed by this object.
   */
  _register(e) {
    if (e === this)
      throw new Error("Cannot register a disposable on itself!");
    return this._store.add(e);
  }
}
class Bd {
  constructor() {
    this._isDisposed = !1;
  }
  get value() {
    return this._isDisposed ? void 0 : this._value;
  }
  set value(e) {
    this._isDisposed || e === this._value || (this._value?.dispose(), this._value = e);
  }
  /**
   * Resets the stored value and disposed of the previously stored value.
   */
  clear() {
    this.value = void 0;
  }
  dispose() {
    this._isDisposed = !0, this._value?.dispose(), this._value = void 0;
  }
}
class T1t {
  constructor(e) {
    this.object = e;
  }
  dispose() {
  }
}
class MI {
  constructor() {
    this._store = /* @__PURE__ */ new Map(), this._isDisposed = !1;
  }
  /**
   * Disposes of all stored values and mark this object as disposed.
   *
   * Trying to use this object after it has been disposed of is an error.
   */
  dispose() {
    this._isDisposed = !0, this.clearAndDisposeAll();
  }
  /**
   * Disposes of all stored values and clear the map, but DO NOT mark this object as disposed.
   */
  clearAndDisposeAll() {
    if (this._store.size)
      try {
        br(this._store.values());
      } finally {
        this._store.clear();
      }
  }
  get(e) {
    return this._store.get(e);
  }
  set(e, t, n = !1) {
    this._isDisposed && console.warn(new Error("Trying to add a disposable to a DisposableMap that has already been disposed of. The added object will be leaked!").stack), n || this._store.get(e)?.dispose(), this._store.set(e, t);
  }
  /**
   * Delete the value stored for `key` from this map and also dispose of it.
   */
  deleteAndDispose(e) {
    this._store.get(e)?.dispose(), this._store.delete(e);
  }
  [Symbol.iterator]() {
    return this._store[Symbol.iterator]();
  }
}
const I1t = globalThis.performance && typeof globalThis.performance.now == "function";
class jf {
  static create(e) {
    return new jf(e);
  }
  constructor(e) {
    this._now = I1t && e === !1 ? Date.now : globalThis.performance.now.bind(globalThis.performance), this._startTime = this._now(), this._stopTime = -1;
  }
  stop() {
    this._stopTime = this._now();
  }
  reset() {
    this._startTime = this._now(), this._stopTime = -1;
  }
  elapsed() {
    return this._stopTime !== -1 ? this._stopTime - this._startTime : this._now() - this._startTime;
  }
}
var xe;
(function(r) {
  r.None = () => me.None;
  function e(N, R) {
    return u(N, () => {
    }, 0, void 0, !0, void 0, R);
  }
  r.defer = e;
  function t(N) {
    return (R, H = null, z) => {
      let U = !1, ee;
      return ee = N((ce) => {
        if (!U)
          return ee ? ee.dispose() : U = !0, R.call(H, ce);
      }, null, z), U && ee.dispose(), ee;
    };
  }
  r.once = t;
  function n(N, R, H) {
    return c((z, U = null, ee) => N((ce) => z.call(U, R(ce)), null, ee), H);
  }
  r.map = n;
  function i(N, R, H) {
    return c((z, U = null, ee) => N((ce) => {
      R(ce), z.call(U, ce);
    }, null, ee), H);
  }
  r.forEach = i;
  function s(N, R, H) {
    return c((z, U = null, ee) => N((ce) => R(ce) && z.call(U, ce), null, ee), H);
  }
  r.filter = s;
  function o(N) {
    return N;
  }
  r.signal = o;
  function a(...N) {
    return (R, H = null, z) => {
      const U = ih(...N.map((ee) => ee((ce) => R.call(H, ce))));
      return d(U, z);
    };
  }
  r.any = a;
  function l(N, R, H, z) {
    let U = H;
    return n(N, (ee) => (U = R(U, ee), U), z);
  }
  r.reduce = l;
  function c(N, R) {
    let H;
    const z = {
      onWillAddFirstListener() {
        H = N(U.fire, U);
      },
      onDidRemoveLastListener() {
        H?.dispose();
      }
    }, U = new $(z);
    return R?.add(U), U.event;
  }
  function d(N, R) {
    return R instanceof Array ? R.push(N) : R && R.add(N), N;
  }
  function u(N, R, H = 100, z = !1, U = !1, ee, ce) {
    let se, te, ue, G = 0, j;
    const pe = {
      leakWarningThreshold: ee,
      onWillAddFirstListener() {
        se = N((Ce) => {
          G++, te = R(te, Ce), z && !ue && (De.fire(te), te = void 0), j = () => {
            const F = te;
            te = void 0, ue = void 0, (!z || G > 1) && De.fire(F), G = 0;
          }, typeof H == "number" ? (clearTimeout(ue), ue = setTimeout(j, H)) : ue === void 0 && (ue = 0, queueMicrotask(j));
        });
      },
      onWillRemoveListener() {
        U && G > 0 && j?.();
      },
      onDidRemoveLastListener() {
        j = void 0, se.dispose();
      }
    }, De = new $(pe);
    return ce?.add(De), De.event;
  }
  r.debounce = u;
  function f(N, R = 0, H) {
    return r.debounce(N, (z, U) => z ? (z.push(U), z) : [U], R, void 0, !0, void 0, H);
  }
  r.accumulate = f;
  function p(N, R = (z, U) => z === U, H) {
    let z = !0, U;
    return s(N, (ee) => {
      const ce = z || !R(ee, U);
      return z = !1, U = ee, ce;
    }, H);
  }
  r.latch = p;
  function g(N, R, H) {
    return [
      r.filter(N, R, H),
      r.filter(N, (z) => !R(z), H)
    ];
  }
  r.split = g;
  function m(N, R = !1, H = [], z) {
    let U = H.slice(), ee = N((te) => {
      U ? U.push(te) : se.fire(te);
    });
    z && z.add(ee);
    const ce = () => {
      U?.forEach((te) => se.fire(te)), U = null;
    }, se = new $({
      onWillAddFirstListener() {
        ee || (ee = N((te) => se.fire(te)), z && z.add(ee));
      },
      onDidAddFirstListener() {
        U && (R ? setTimeout(ce) : ce());
      },
      onDidRemoveLastListener() {
        ee && ee.dispose(), ee = null;
      }
    });
    return z && z.add(se), se.event;
  }
  r.buffer = m;
  function A(N, R) {
    return (z, U, ee) => {
      const ce = R(new v());
      return N(function(se) {
        const te = ce.evaluate(se);
        te !== w && z.call(U, te);
      }, void 0, ee);
    };
  }
  r.chain = A;
  const w = Symbol("HaltChainable");
  class v {
    constructor() {
      this.steps = [];
    }
    map(R) {
      return this.steps.push(R), this;
    }
    forEach(R) {
      return this.steps.push((H) => (R(H), H)), this;
    }
    filter(R) {
      return this.steps.push((H) => R(H) ? H : w), this;
    }
    reduce(R, H) {
      let z = H;
      return this.steps.push((U) => (z = R(z, U), z)), this;
    }
    latch(R = (H, z) => H === z) {
      let H = !0, z;
      return this.steps.push((U) => {
        const ee = H || !R(U, z);
        return H = !1, z = U, ee ? U : w;
      }), this;
    }
    evaluate(R) {
      for (const H of this.steps)
        if (R = H(R), R === w)
          break;
      return R;
    }
  }
  function y(N, R, H = (z) => z) {
    const z = (...se) => ce.fire(H(...se)), U = () => N.on(R, z), ee = () => N.removeListener(R, z), ce = new $({ onWillAddFirstListener: U, onDidRemoveLastListener: ee });
    return ce.event;
  }
  r.fromNodeEventEmitter = y;
  function _(N, R, H = (z) => z) {
    const z = (...se) => ce.fire(H(...se)), U = () => N.addEventListener(R, z), ee = () => N.removeEventListener(R, z), ce = new $({ onWillAddFirstListener: U, onDidRemoveLastListener: ee });
    return ce.event;
  }
  r.fromDOMEventEmitter = _;
  function S(N) {
    return new Promise((R) => t(N)(R));
  }
  r.toPromise = S;
  function D(N) {
    const R = new $();
    return N.then((H) => {
      R.fire(H);
    }, () => {
      R.fire(void 0);
    }).finally(() => {
      R.dispose();
    }), R.event;
  }
  r.fromPromise = D;
  function M(N, R) {
    return N((H) => R.fire(H));
  }
  r.forward = M;
  function L(N, R, H) {
    return R(H), N((z) => R(z));
  }
  r.runAndSubscribe = L;
  class T {
    constructor(R, H) {
      this._observable = R, this._counter = 0, this._hasChanged = !1;
      const z = {
        onWillAddFirstListener: () => {
          R.addObserver(this);
        },
        onDidRemoveLastListener: () => {
          R.removeObserver(this);
        }
      };
      this.emitter = new $(z), H && H.add(this.emitter);
    }
    beginUpdate(R) {
      this._counter++;
    }
    handlePossibleChange(R) {
    }
    handleChange(R, H) {
      this._hasChanged = !0;
    }
    endUpdate(R) {
      this._counter--, this._counter === 0 && (this._observable.reportChanges(), this._hasChanged && (this._hasChanged = !1, this.emitter.fire(this._observable.get())));
    }
  }
  function B(N, R) {
    return new T(N, R).emitter.event;
  }
  r.fromObservable = B;
  function V(N) {
    return (R, H, z) => {
      let U = 0, ee = !1;
      const ce = {
        beginUpdate() {
          U++;
        },
        endUpdate() {
          U--, U === 0 && (N.reportChanges(), ee && (ee = !1, R.call(H)));
        },
        handlePossibleChange() {
        },
        handleChange() {
          ee = !0;
        }
      };
      N.addObserver(ce), N.reportChanges();
      const se = {
        dispose() {
          N.removeObserver(ce);
        }
      };
      return z instanceof ze ? z.add(se) : Array.isArray(z) && z.push(se), se;
    };
  }
  r.fromObservableLight = V;
})(xe || (xe = {}));
class L8 {
  static {
    this.all = /* @__PURE__ */ new Set();
  }
  static {
    this._idPool = 0;
  }
  constructor(e) {
    this.listenerCount = 0, this.invocationCount = 0, this.elapsedOverall = 0, this.durations = [], this.name = `${e}_${L8._idPool++}`, L8.all.add(this);
  }
  start(e) {
    this._stopWatch = new jf(), this.listenerCount = e;
  }
  stop() {
    if (this._stopWatch) {
      const e = this._stopWatch.elapsed();
      this.durations.push(e), this.elapsedOverall += e, this.invocationCount += 1, this._stopWatch = void 0;
    }
  }
}
let O1t = -1;
class DI {
  static {
    this._idPool = 1;
  }
  constructor(e, t, n = (DI._idPool++).toString(16).padStart(3, "0")) {
    this._errorHandler = e, this.threshold = t, this.name = n, this._warnCountdown = 0;
  }
  dispose() {
    this._stacks?.clear();
  }
  check(e, t) {
    const n = this.threshold;
    if (n <= 0 || t < n)
      return;
    this._stacks || (this._stacks = /* @__PURE__ */ new Map());
    const i = this._stacks.get(e.value) || 0;
    if (this._stacks.set(e.value, i + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
      this._warnCountdown = n * 0.5;
      const [s, o] = this.getMostFrequentStack(), a = `[${this.name}] potential listener LEAK detected, having ${t} listeners already. MOST frequent listener (${o}):`;
      console.warn(a), console.warn(s);
      const l = new R1t(a, s);
      this._errorHandler(l);
    }
    return () => {
      const s = this._stacks.get(e.value) || 0;
      this._stacks.set(e.value, s - 1);
    };
  }
  getMostFrequentStack() {
    if (!this._stacks)
      return;
    let e, t = 0;
    for (const [n, i] of this._stacks)
      (!e || t < i) && (e = [n, i], t = i);
    return e;
  }
}
class LI {
  static create() {
    const e = new Error();
    return new LI(e.stack ?? "");
  }
  constructor(e) {
    this.value = e;
  }
  print() {
    console.warn(this.value.split(`
`).slice(2).join(`
`));
  }
}
class R1t extends Error {
  constructor(e, t) {
    super(e), this.name = "ListenerLeakError", this.stack = t;
  }
}
class V1t extends Error {
  constructor(e, t) {
    super(e), this.name = "ListenerRefusalError", this.stack = t;
  }
}
class fE {
  constructor(e) {
    this.value = e;
  }
}
const H1t = 2;
let $ = class {
  constructor(e) {
    this._size = 0, this._options = e, this._leakageMon = this._options?.leakWarningThreshold ? new DI(e?.onListenerError ?? wn, this._options?.leakWarningThreshold ?? O1t) : void 0, this._perfMon = this._options?._profName ? new L8(this._options._profName) : void 0, this._deliveryQueue = this._options?.deliveryQueue;
  }
  dispose() {
    this._disposed || (this._disposed = !0, this._deliveryQueue?.current === this && this._deliveryQueue.reset(), this._listeners && (this._listeners = void 0, this._size = 0), this._options?.onDidRemoveLastListener?.(), this._leakageMon?.dispose());
  }
  /**
   * For the public to allow to subscribe
   * to events from this Emitter
   */
  get event() {
    return this._event ??= (e, t, n) => {
      if (this._leakageMon && this._size > this._leakageMon.threshold ** 2) {
        const a = `[${this._leakageMon.name}] REFUSES to accept new listeners because it exceeded its threshold by far (${this._size} vs ${this._leakageMon.threshold})`;
        console.warn(a);
        const l = this._leakageMon.getMostFrequentStack() ?? ["UNKNOWN stack", -1], c = new V1t(`${a}. HINT: Stack shows most frequent listener (${l[1]}-times)`, l[0]);
        return (this._options?.onListenerError || wn)(c), me.None;
      }
      if (this._disposed)
        return me.None;
      t && (e = e.bind(t));
      const i = new fE(e);
      let s;
      this._leakageMon && this._size >= Math.ceil(this._leakageMon.threshold * 0.2) && (i.stack = LI.create(), s = this._leakageMon.check(i.stack, this._size + 1)), this._listeners ? this._listeners instanceof fE ? (this._deliveryQueue ??= new WMe(), this._listeners = [this._listeners, i]) : this._listeners.push(i) : (this._options?.onWillAddFirstListener?.(this), this._listeners = i, this._options?.onDidAddFirstListener?.(this)), this._size++;
      const o = ht(() => {
        s?.(), this._removeListener(i);
      });
      return n instanceof ze ? n.add(o) : Array.isArray(n) && n.push(o), o;
    }, this._event;
  }
  _removeListener(e) {
    if (this._options?.onWillRemoveListener?.(this), !this._listeners)
      return;
    if (this._size === 1) {
      this._listeners = void 0, this._options?.onDidRemoveLastListener?.(this), this._size = 0;
      return;
    }
    const t = this._listeners, n = t.indexOf(e);
    if (n === -1)
      throw console.log("disposed?", this._disposed), console.log("size?", this._size), console.log("arr?", JSON.stringify(this._listeners)), new Error("Attempted to dispose unknown listener");
    this._size--, t[n] = void 0;
    const i = this._deliveryQueue.current === this;
    if (this._size * H1t <= t.length) {
      let s = 0;
      for (let o = 0; o < t.length; o++)
        t[o] ? t[s++] = t[o] : i && (this._deliveryQueue.end--, s < this._deliveryQueue.i && this._deliveryQueue.i--);
      t.length = s;
    }
  }
  _deliver(e, t) {
    if (!e)
      return;
    const n = this._options?.onListenerError || wn;
    if (!n) {
      e.value(t);
      return;
    }
    try {
      e.value(t);
    } catch (i) {
      n(i);
    }
  }
  /** Delivers items in the queue. Assumes the queue is ready to go. */
  _deliverQueue(e) {
    const t = e.current._listeners;
    for (; e.i < e.end; )
      this._deliver(t[e.i++], e.value);
    e.reset();
  }
  /**
   * To be kept private to fire an event to
   * subscribers
   */
  fire(e) {
    if (this._deliveryQueue?.current && (this._deliverQueue(this._deliveryQueue), this._perfMon?.stop()), this._perfMon?.start(this._size), this._listeners) if (this._listeners instanceof fE)
      this._deliver(this._listeners, e);
    else {
      const t = this._deliveryQueue;
      t.enqueue(this, e, this._listeners.length), this._deliverQueue(t);
    }
    this._perfMon?.stop();
  }
  hasListeners() {
    return this._size > 0;
  }
};
const B1t = () => new WMe();
class WMe {
  constructor() {
    this.i = -1, this.end = 0;
  }
  enqueue(e, t, n) {
    this.i = 0, this.end = n, this.current = e, this.value = t;
  }
  reset() {
    this.i = this.end, this.current = void 0, this.value = void 0;
  }
}
class R3 extends $ {
  constructor(e) {
    super(e), this._isPaused = 0, this._eventQueue = new no(), this._mergeFn = e?.merge;
  }
  pause() {
    this._isPaused++;
  }
  resume() {
    if (this._isPaused !== 0 && --this._isPaused === 0)
      if (this._mergeFn) {
        if (this._eventQueue.size > 0) {
          const e = Array.from(this._eventQueue);
          this._eventQueue.clear(), super.fire(this._mergeFn(e));
        }
      } else
        for (; !this._isPaused && this._eventQueue.size !== 0; )
          super.fire(this._eventQueue.shift());
  }
  fire(e) {
    this._size && (this._isPaused !== 0 ? this._eventQueue.push(e) : super.fire(e));
  }
}
class jMe extends R3 {
  constructor(e) {
    super(e), this._delay = e.delay ?? 100;
  }
  fire(e) {
    this._handle || (this.pause(), this._handle = setTimeout(() => {
      this._handle = void 0, this.resume();
    }, this._delay)), super.fire(e);
  }
}
class P1t extends $ {
  constructor(e) {
    super(e), this._queuedEvents = [], this._mergeFn = e?.merge;
  }
  fire(e) {
    this.hasListeners() && (this._queuedEvents.push(e), this._queuedEvents.length === 1 && queueMicrotask(() => {
      this._mergeFn ? super.fire(this._mergeFn(this._queuedEvents)) : this._queuedEvents.forEach((t) => super.fire(t)), this._queuedEvents = [];
    }));
  }
}
class F1t {
  constructor() {
    this.hasListeners = !1, this.events = [], this.emitter = new $({
      onWillAddFirstListener: () => this.onFirstListenerAdd(),
      onDidRemoveLastListener: () => this.onLastListenerRemove()
    });
  }
  get event() {
    return this.emitter.event;
  }
  add(e) {
    const t = { event: e, listener: null };
    return this.events.push(t), this.hasListeners && this.hook(t), ht(ig(() => {
      this.hasListeners && this.unhook(t);
      const i = this.events.indexOf(t);
      this.events.splice(i, 1);
    }));
  }
  onFirstListenerAdd() {
    this.hasListeners = !0, this.events.forEach((e) => this.hook(e));
  }
  onLastListenerRemove() {
    this.hasListeners = !1, this.events.forEach((e) => this.unhook(e));
  }
  hook(e) {
    e.listener = e.event((t) => this.emitter.fire(t));
  }
  unhook(e) {
    e.listener?.dispose(), e.listener = null;
  }
  dispose() {
    this.emitter.dispose();
    for (const e of this.events)
      e.listener?.dispose();
    this.events = [];
  }
}
class Aw {
  constructor() {
    this.data = [];
  }
  wrapEvent(e, t, n) {
    return (i, s, o) => e((a) => {
      const l = this.data[this.data.length - 1];
      if (!t) {
        l ? l.buffers.push(() => i.call(s, a)) : i.call(s, a);
        return;
      }
      const c = l;
      if (!c) {
        i.call(s, t(n, a));
        return;
      }
      c.items ??= [], c.items.push(a), c.buffers.length === 0 && l.buffers.push(() => {
        c.reducedResult ??= n ? c.items.reduce(t, n) : c.items.reduce(t), i.call(s, c.reducedResult);
      });
    }, void 0, o);
  }
  bufferEvents(e) {
    const t = { buffers: new Array() };
    this.data.push(t);
    const n = e();
    return this.data.pop(), t.buffers.forEach((i) => i()), n;
  }
}
class wve {
  constructor() {
    this.listening = !1, this.inputEvent = xe.None, this.inputEventListener = me.None, this.emitter = new $({
      onDidAddFirstListener: () => {
        this.listening = !0, this.inputEventListener = this.inputEvent(this.emitter.fire, this.emitter);
      },
      onDidRemoveLastListener: () => {
        this.listening = !1, this.inputEventListener.dispose();
      }
    }), this.event = this.emitter.event;
  }
  set input(e) {
    this.inputEvent = e, this.listening && (this.inputEventListener.dispose(), this.inputEventListener = e(this.emitter.fire, this.emitter));
  }
  dispose() {
    this.inputEventListener.dispose(), this.emitter.dispose();
  }
}
const ZMe = Object.freeze(function(r, e) {
  const t = setTimeout(r.bind(e), 0);
  return { dispose() {
    clearTimeout(t);
  } };
});
var fl;
(function(r) {
  function e(t) {
    return t === r.None || t === r.Cancelled || t instanceof u6 ? !0 : !t || typeof t != "object" ? !1 : typeof t.isCancellationRequested == "boolean" && typeof t.onCancellationRequested == "function";
  }
  r.isCancellationToken = e, r.None = Object.freeze({
    isCancellationRequested: !1,
    onCancellationRequested: xe.None
  }), r.Cancelled = Object.freeze({
    isCancellationRequested: !0,
    onCancellationRequested: ZMe
  });
})(fl || (fl = {}));
class u6 {
  constructor() {
    this._isCancelled = !1, this._emitter = null;
  }
  cancel() {
    this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
  }
  get isCancellationRequested() {
    return this._isCancelled;
  }
  get onCancellationRequested() {
    return this._isCancelled ? ZMe : (this._emitter || (this._emitter = new $()), this._emitter.event);
  }
  dispose() {
    this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
}
let Jg = class {
  constructor(e) {
    this._token = void 0, this._parentListener = void 0, this._parentListener = e && e.onCancellationRequested(this.cancel, this);
  }
  get token() {
    return this._token || (this._token = new u6()), this._token;
  }
  cancel() {
    this._token ? this._token instanceof u6 && this._token.cancel() : this._token = fl.Cancelled;
  }
  dispose(e = !1) {
    e && this.cancel(), this._parentListener?.dispose(), this._token ? this._token instanceof u6 && this._token.dispose() : this._token = fl.None;
  }
};
class kI {
  constructor() {
    this._keyCodeToStr = [], this._strToKeyCode = /* @__PURE__ */ Object.create(null);
  }
  define(e, t) {
    this._keyCodeToStr[e] = t, this._strToKeyCode[t.toLowerCase()] = e;
  }
  keyCodeToStr(e) {
    return this._keyCodeToStr[e];
  }
  strToKeyCode(e) {
    return this._strToKeyCode[e.toLowerCase()] || 0;
  }
}
const f6 = new kI(), kM = new kI(), NM = new kI(), UMe = new Array(230), z1t = /* @__PURE__ */ Object.create(null), W1t = /* @__PURE__ */ Object.create(null), NI = [];
for (let r = 0; r <= 193; r++)
  NI[r] = -1;
(function() {
  const r = "", e = [
    // immutable, scanCode, scanCodeStr, keyCode, keyCodeStr, eventKeyCode, vkey, usUserSettingsLabel, generalUserSettingsLabel
    [1, 0, "None", 0, "unknown", 0, "VK_UNKNOWN", r, r],
    [1, 1, "Hyper", 0, r, 0, r, r, r],
    [1, 2, "Super", 0, r, 0, r, r, r],
    [1, 3, "Fn", 0, r, 0, r, r, r],
    [1, 4, "FnLock", 0, r, 0, r, r, r],
    [1, 5, "Suspend", 0, r, 0, r, r, r],
    [1, 6, "Resume", 0, r, 0, r, r, r],
    [1, 7, "Turbo", 0, r, 0, r, r, r],
    [1, 8, "Sleep", 0, r, 0, "VK_SLEEP", r, r],
    [1, 9, "WakeUp", 0, r, 0, r, r, r],
    [0, 10, "KeyA", 31, "A", 65, "VK_A", r, r],
    [0, 11, "KeyB", 32, "B", 66, "VK_B", r, r],
    [0, 12, "KeyC", 33, "C", 67, "VK_C", r, r],
    [0, 13, "KeyD", 34, "D", 68, "VK_D", r, r],
    [0, 14, "KeyE", 35, "E", 69, "VK_E", r, r],
    [0, 15, "KeyF", 36, "F", 70, "VK_F", r, r],
    [0, 16, "KeyG", 37, "G", 71, "VK_G", r, r],
    [0, 17, "KeyH", 38, "H", 72, "VK_H", r, r],
    [0, 18, "KeyI", 39, "I", 73, "VK_I", r, r],
    [0, 19, "KeyJ", 40, "J", 74, "VK_J", r, r],
    [0, 20, "KeyK", 41, "K", 75, "VK_K", r, r],
    [0, 21, "KeyL", 42, "L", 76, "VK_L", r, r],
    [0, 22, "KeyM", 43, "M", 77, "VK_M", r, r],
    [0, 23, "KeyN", 44, "N", 78, "VK_N", r, r],
    [0, 24, "KeyO", 45, "O", 79, "VK_O", r, r],
    [0, 25, "KeyP", 46, "P", 80, "VK_P", r, r],
    [0, 26, "KeyQ", 47, "Q", 81, "VK_Q", r, r],
    [0, 27, "KeyR", 48, "R", 82, "VK_R", r, r],
    [0, 28, "KeyS", 49, "S", 83, "VK_S", r, r],
    [0, 29, "KeyT", 50, "T", 84, "VK_T", r, r],
    [0, 30, "KeyU", 51, "U", 85, "VK_U", r, r],
    [0, 31, "KeyV", 52, "V", 86, "VK_V", r, r],
    [0, 32, "KeyW", 53, "W", 87, "VK_W", r, r],
    [0, 33, "KeyX", 54, "X", 88, "VK_X", r, r],
    [0, 34, "KeyY", 55, "Y", 89, "VK_Y", r, r],
    [0, 35, "KeyZ", 56, "Z", 90, "VK_Z", r, r],
    [0, 36, "Digit1", 22, "1", 49, "VK_1", r, r],
    [0, 37, "Digit2", 23, "2", 50, "VK_2", r, r],
    [0, 38, "Digit3", 24, "3", 51, "VK_3", r, r],
    [0, 39, "Digit4", 25, "4", 52, "VK_4", r, r],
    [0, 40, "Digit5", 26, "5", 53, "VK_5", r, r],
    [0, 41, "Digit6", 27, "6", 54, "VK_6", r, r],
    [0, 42, "Digit7", 28, "7", 55, "VK_7", r, r],
    [0, 43, "Digit8", 29, "8", 56, "VK_8", r, r],
    [0, 44, "Digit9", 30, "9", 57, "VK_9", r, r],
    [0, 45, "Digit0", 21, "0", 48, "VK_0", r, r],
    [1, 46, "Enter", 3, "Enter", 13, "VK_RETURN", r, r],
    [1, 47, "Escape", 9, "Escape", 27, "VK_ESCAPE", r, r],
    [1, 48, "Backspace", 1, "Backspace", 8, "VK_BACK", r, r],
    [1, 49, "Tab", 2, "Tab", 9, "VK_TAB", r, r],
    [1, 50, "Space", 10, "Space", 32, "VK_SPACE", r, r],
    [0, 51, "Minus", 88, "-", 189, "VK_OEM_MINUS", "-", "OEM_MINUS"],
    [0, 52, "Equal", 86, "=", 187, "VK_OEM_PLUS", "=", "OEM_PLUS"],
    [0, 53, "BracketLeft", 92, "[", 219, "VK_OEM_4", "[", "OEM_4"],
    [0, 54, "BracketRight", 94, "]", 221, "VK_OEM_6", "]", "OEM_6"],
    [0, 55, "Backslash", 93, "\\", 220, "VK_OEM_5", "\\", "OEM_5"],
    [0, 56, "IntlHash", 0, r, 0, r, r, r],
    // has been dropped from the w3c spec
    [0, 57, "Semicolon", 85, ";", 186, "VK_OEM_1", ";", "OEM_1"],
    [0, 58, "Quote", 95, "'", 222, "VK_OEM_7", "'", "OEM_7"],
    [0, 59, "Backquote", 91, "`", 192, "VK_OEM_3", "`", "OEM_3"],
    [0, 60, "Comma", 87, ",", 188, "VK_OEM_COMMA", ",", "OEM_COMMA"],
    [0, 61, "Period", 89, ".", 190, "VK_OEM_PERIOD", ".", "OEM_PERIOD"],
    [0, 62, "Slash", 90, "/", 191, "VK_OEM_2", "/", "OEM_2"],
    [1, 63, "CapsLock", 8, "CapsLock", 20, "VK_CAPITAL", r, r],
    [1, 64, "F1", 59, "F1", 112, "VK_F1", r, r],
    [1, 65, "F2", 60, "F2", 113, "VK_F2", r, r],
    [1, 66, "F3", 61, "F3", 114, "VK_F3", r, r],
    [1, 67, "F4", 62, "F4", 115, "VK_F4", r, r],
    [1, 68, "F5", 63, "F5", 116, "VK_F5", r, r],
    [1, 69, "F6", 64, "F6", 117, "VK_F6", r, r],
    [1, 70, "F7", 65, "F7", 118, "VK_F7", r, r],
    [1, 71, "F8", 66, "F8", 119, "VK_F8", r, r],
    [1, 72, "F9", 67, "F9", 120, "VK_F9", r, r],
    [1, 73, "F10", 68, "F10", 121, "VK_F10", r, r],
    [1, 74, "F11", 69, "F11", 122, "VK_F11", r, r],
    [1, 75, "F12", 70, "F12", 123, "VK_F12", r, r],
    [1, 76, "PrintScreen", 0, r, 0, r, r, r],
    [1, 77, "ScrollLock", 84, "ScrollLock", 145, "VK_SCROLL", r, r],
    [1, 78, "Pause", 7, "PauseBreak", 19, "VK_PAUSE", r, r],
    [1, 79, "Insert", 19, "Insert", 45, "VK_INSERT", r, r],
    [1, 80, "Home", 14, "Home", 36, "VK_HOME", r, r],
    [1, 81, "PageUp", 11, "PageUp", 33, "VK_PRIOR", r, r],
    [1, 82, "Delete", 20, "Delete", 46, "VK_DELETE", r, r],
    [1, 83, "End", 13, "End", 35, "VK_END", r, r],
    [1, 84, "PageDown", 12, "PageDown", 34, "VK_NEXT", r, r],
    [1, 85, "ArrowRight", 17, "RightArrow", 39, "VK_RIGHT", "Right", r],
    [1, 86, "ArrowLeft", 15, "LeftArrow", 37, "VK_LEFT", "Left", r],
    [1, 87, "ArrowDown", 18, "DownArrow", 40, "VK_DOWN", "Down", r],
    [1, 88, "ArrowUp", 16, "UpArrow", 38, "VK_UP", "Up", r],
    [1, 89, "NumLock", 83, "NumLock", 144, "VK_NUMLOCK", r, r],
    [1, 90, "NumpadDivide", 113, "NumPad_Divide", 111, "VK_DIVIDE", r, r],
    [1, 91, "NumpadMultiply", 108, "NumPad_Multiply", 106, "VK_MULTIPLY", r, r],
    [1, 92, "NumpadSubtract", 111, "NumPad_Subtract", 109, "VK_SUBTRACT", r, r],
    [1, 93, "NumpadAdd", 109, "NumPad_Add", 107, "VK_ADD", r, r],
    [1, 94, "NumpadEnter", 3, r, 0, r, r, r],
    [1, 95, "Numpad1", 99, "NumPad1", 97, "VK_NUMPAD1", r, r],
    [1, 96, "Numpad2", 100, "NumPad2", 98, "VK_NUMPAD2", r, r],
    [1, 97, "Numpad3", 101, "NumPad3", 99, "VK_NUMPAD3", r, r],
    [1, 98, "Numpad4", 102, "NumPad4", 100, "VK_NUMPAD4", r, r],
    [1, 99, "Numpad5", 103, "NumPad5", 101, "VK_NUMPAD5", r, r],
    [1, 100, "Numpad6", 104, "NumPad6", 102, "VK_NUMPAD6", r, r],
    [1, 101, "Numpad7", 105, "NumPad7", 103, "VK_NUMPAD7", r, r],
    [1, 102, "Numpad8", 106, "NumPad8", 104, "VK_NUMPAD8", r, r],
    [1, 103, "Numpad9", 107, "NumPad9", 105, "VK_NUMPAD9", r, r],
    [1, 104, "Numpad0", 98, "NumPad0", 96, "VK_NUMPAD0", r, r],
    [1, 105, "NumpadDecimal", 112, "NumPad_Decimal", 110, "VK_DECIMAL", r, r],
    [0, 106, "IntlBackslash", 97, "OEM_102", 226, "VK_OEM_102", r, r],
    [1, 107, "ContextMenu", 58, "ContextMenu", 93, r, r, r],
    [1, 108, "Power", 0, r, 0, r, r, r],
    [1, 109, "NumpadEqual", 0, r, 0, r, r, r],
    [1, 110, "F13", 71, "F13", 124, "VK_F13", r, r],
    [1, 111, "F14", 72, "F14", 125, "VK_F14", r, r],
    [1, 112, "F15", 73, "F15", 126, "VK_F15", r, r],
    [1, 113, "F16", 74, "F16", 127, "VK_F16", r, r],
    [1, 114, "F17", 75, "F17", 128, "VK_F17", r, r],
    [1, 115, "F18", 76, "F18", 129, "VK_F18", r, r],
    [1, 116, "F19", 77, "F19", 130, "VK_F19", r, r],
    [1, 117, "F20", 78, "F20", 131, "VK_F20", r, r],
    [1, 118, "F21", 79, "F21", 132, "VK_F21", r, r],
    [1, 119, "F22", 80, "F22", 133, "VK_F22", r, r],
    [1, 120, "F23", 81, "F23", 134, "VK_F23", r, r],
    [1, 121, "F24", 82, "F24", 135, "VK_F24", r, r],
    [1, 122, "Open", 0, r, 0, r, r, r],
    [1, 123, "Help", 0, r, 0, r, r, r],
    [1, 124, "Select", 0, r, 0, r, r, r],
    [1, 125, "Again", 0, r, 0, r, r, r],
    [1, 126, "Undo", 0, r, 0, r, r, r],
    [1, 127, "Cut", 0, r, 0, r, r, r],
    [1, 128, "Copy", 0, r, 0, r, r, r],
    [1, 129, "Paste", 0, r, 0, r, r, r],
    [1, 130, "Find", 0, r, 0, r, r, r],
    [1, 131, "AudioVolumeMute", 117, "AudioVolumeMute", 173, "VK_VOLUME_MUTE", r, r],
    [1, 132, "AudioVolumeUp", 118, "AudioVolumeUp", 175, "VK_VOLUME_UP", r, r],
    [1, 133, "AudioVolumeDown", 119, "AudioVolumeDown", 174, "VK_VOLUME_DOWN", r, r],
    [1, 134, "NumpadComma", 110, "NumPad_Separator", 108, "VK_SEPARATOR", r, r],
    [0, 135, "IntlRo", 115, "ABNT_C1", 193, "VK_ABNT_C1", r, r],
    [1, 136, "KanaMode", 0, r, 0, r, r, r],
    [0, 137, "IntlYen", 0, r, 0, r, r, r],
    [1, 138, "Convert", 0, r, 0, r, r, r],
    [1, 139, "NonConvert", 0, r, 0, r, r, r],
    [1, 140, "Lang1", 0, r, 0, r, r, r],
    [1, 141, "Lang2", 0, r, 0, r, r, r],
    [1, 142, "Lang3", 0, r, 0, r, r, r],
    [1, 143, "Lang4", 0, r, 0, r, r, r],
    [1, 144, "Lang5", 0, r, 0, r, r, r],
    [1, 145, "Abort", 0, r, 0, r, r, r],
    [1, 146, "Props", 0, r, 0, r, r, r],
    [1, 147, "NumpadParenLeft", 0, r, 0, r, r, r],
    [1, 148, "NumpadParenRight", 0, r, 0, r, r, r],
    [1, 149, "NumpadBackspace", 0, r, 0, r, r, r],
    [1, 150, "NumpadMemoryStore", 0, r, 0, r, r, r],
    [1, 151, "NumpadMemoryRecall", 0, r, 0, r, r, r],
    [1, 152, "NumpadMemoryClear", 0, r, 0, r, r, r],
    [1, 153, "NumpadMemoryAdd", 0, r, 0, r, r, r],
    [1, 154, "NumpadMemorySubtract", 0, r, 0, r, r, r],
    [1, 155, "NumpadClear", 131, "Clear", 12, "VK_CLEAR", r, r],
    [1, 156, "NumpadClearEntry", 0, r, 0, r, r, r],
    [1, 0, r, 5, "Ctrl", 17, "VK_CONTROL", r, r],
    [1, 0, r, 4, "Shift", 16, "VK_SHIFT", r, r],
    [1, 0, r, 6, "Alt", 18, "VK_MENU", r, r],
    [1, 0, r, 57, "Meta", 91, "VK_COMMAND", r, r],
    [1, 157, "ControlLeft", 5, r, 0, "VK_LCONTROL", r, r],
    [1, 158, "ShiftLeft", 4, r, 0, "VK_LSHIFT", r, r],
    [1, 159, "AltLeft", 6, r, 0, "VK_LMENU", r, r],
    [1, 160, "MetaLeft", 57, r, 0, "VK_LWIN", r, r],
    [1, 161, "ControlRight", 5, r, 0, "VK_RCONTROL", r, r],
    [1, 162, "ShiftRight", 4, r, 0, "VK_RSHIFT", r, r],
    [1, 163, "AltRight", 6, r, 0, "VK_RMENU", r, r],
    [1, 164, "MetaRight", 57, r, 0, "VK_RWIN", r, r],
    [1, 165, "BrightnessUp", 0, r, 0, r, r, r],
    [1, 166, "BrightnessDown", 0, r, 0, r, r, r],
    [1, 167, "MediaPlay", 0, r, 0, r, r, r],
    [1, 168, "MediaRecord", 0, r, 0, r, r, r],
    [1, 169, "MediaFastForward", 0, r, 0, r, r, r],
    [1, 170, "MediaRewind", 0, r, 0, r, r, r],
    [1, 171, "MediaTrackNext", 124, "MediaTrackNext", 176, "VK_MEDIA_NEXT_TRACK", r, r],
    [1, 172, "MediaTrackPrevious", 125, "MediaTrackPrevious", 177, "VK_MEDIA_PREV_TRACK", r, r],
    [1, 173, "MediaStop", 126, "MediaStop", 178, "VK_MEDIA_STOP", r, r],
    [1, 174, "Eject", 0, r, 0, r, r, r],
    [1, 175, "MediaPlayPause", 127, "MediaPlayPause", 179, "VK_MEDIA_PLAY_PAUSE", r, r],
    [1, 176, "MediaSelect", 128, "LaunchMediaPlayer", 181, "VK_MEDIA_LAUNCH_MEDIA_SELECT", r, r],
    [1, 177, "LaunchMail", 129, "LaunchMail", 180, "VK_MEDIA_LAUNCH_MAIL", r, r],
    [1, 178, "LaunchApp2", 130, "LaunchApp2", 183, "VK_MEDIA_LAUNCH_APP2", r, r],
    [1, 179, "LaunchApp1", 0, r, 0, "VK_MEDIA_LAUNCH_APP1", r, r],
    [1, 180, "SelectTask", 0, r, 0, r, r, r],
    [1, 181, "LaunchScreenSaver", 0, r, 0, r, r, r],
    [1, 182, "BrowserSearch", 120, "BrowserSearch", 170, "VK_BROWSER_SEARCH", r, r],
    [1, 183, "BrowserHome", 121, "BrowserHome", 172, "VK_BROWSER_HOME", r, r],
    [1, 184, "BrowserBack", 122, "BrowserBack", 166, "VK_BROWSER_BACK", r, r],
    [1, 185, "BrowserForward", 123, "BrowserForward", 167, "VK_BROWSER_FORWARD", r, r],
    [1, 186, "BrowserStop", 0, r, 0, "VK_BROWSER_STOP", r, r],
    [1, 187, "BrowserRefresh", 0, r, 0, "VK_BROWSER_REFRESH", r, r],
    [1, 188, "BrowserFavorites", 0, r, 0, "VK_BROWSER_FAVORITES", r, r],
    [1, 189, "ZoomToggle", 0, r, 0, r, r, r],
    [1, 190, "MailReply", 0, r, 0, r, r, r],
    [1, 191, "MailForward", 0, r, 0, r, r, r],
    [1, 192, "MailSend", 0, r, 0, r, r, r],
    // See https://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
    // If an Input Method Editor is processing key input and the event is keydown, return 229.
    [1, 0, r, 114, "KeyInComposition", 229, r, r, r],
    [1, 0, r, 116, "ABNT_C2", 194, "VK_ABNT_C2", r, r],
    [1, 0, r, 96, "OEM_8", 223, "VK_OEM_8", r, r],
    [1, 0, r, 0, r, 0, "VK_KANA", r, r],
    [1, 0, r, 0, r, 0, "VK_HANGUL", r, r],
    [1, 0, r, 0, r, 0, "VK_JUNJA", r, r],
    [1, 0, r, 0, r, 0, "VK_FINAL", r, r],
    [1, 0, r, 0, r, 0, "VK_HANJA", r, r],
    [1, 0, r, 0, r, 0, "VK_KANJI", r, r],
    [1, 0, r, 0, r, 0, "VK_CONVERT", r, r],
    [1, 0, r, 0, r, 0, "VK_NONCONVERT", r, r],
    [1, 0, r, 0, r, 0, "VK_ACCEPT", r, r],
    [1, 0, r, 0, r, 0, "VK_MODECHANGE", r, r],
    [1, 0, r, 0, r, 0, "VK_SELECT", r, r],
    [1, 0, r, 0, r, 0, "VK_PRINT", r, r],
    [1, 0, r, 0, r, 0, "VK_EXECUTE", r, r],
    [1, 0, r, 0, r, 0, "VK_SNAPSHOT", r, r],
    [1, 0, r, 0, r, 0, "VK_HELP", r, r],
    [1, 0, r, 0, r, 0, "VK_APPS", r, r],
    [1, 0, r, 0, r, 0, "VK_PROCESSKEY", r, r],
    [1, 0, r, 0, r, 0, "VK_PACKET", r, r],
    [1, 0, r, 0, r, 0, "VK_DBE_SBCSCHAR", r, r],
    [1, 0, r, 0, r, 0, "VK_DBE_DBCSCHAR", r, r],
    [1, 0, r, 0, r, 0, "VK_ATTN", r, r],
    [1, 0, r, 0, r, 0, "VK_CRSEL", r, r],
    [1, 0, r, 0, r, 0, "VK_EXSEL", r, r],
    [1, 0, r, 0, r, 0, "VK_EREOF", r, r],
    [1, 0, r, 0, r, 0, "VK_PLAY", r, r],
    [1, 0, r, 0, r, 0, "VK_ZOOM", r, r],
    [1, 0, r, 0, r, 0, "VK_NONAME", r, r],
    [1, 0, r, 0, r, 0, "VK_PA1", r, r],
    [1, 0, r, 0, r, 0, "VK_OEM_CLEAR", r, r]
  ], t = [], n = [];
  for (const i of e) {
    const [s, o, a, l, c, d, u, f, p] = i;
    if (n[o] || (n[o] = !0, z1t[a] = o, W1t[a.toLowerCase()] = o, s && (NI[o] = l)), !t[l]) {
      if (t[l] = !0, !c)
        throw new Error(`String representation missing for key code ${l} around scan code ${a}`);
      f6.define(l, c), kM.define(l, f || c), NM.define(l, p || f || c);
    }
    d && (UMe[d] = l);
  }
})();
var sd;
(function(r) {
  function e(a) {
    return f6.keyCodeToStr(a);
  }
  r.toString = e;
  function t(a) {
    return f6.strToKeyCode(a);
  }
  r.fromString = t;
  function n(a) {
    return kM.keyCodeToStr(a);
  }
  r.toUserSettingsUS = n;
  function i(a) {
    return NM.keyCodeToStr(a);
  }
  r.toUserSettingsGeneral = i;
  function s(a) {
    return kM.strToKeyCode(a) || NM.strToKeyCode(a);
  }
  r.fromUserSettings = s;
  function o(a) {
    if (a >= 98 && a <= 113)
      return null;
    switch (a) {
      case 16:
        return "Up";
      case 18:
        return "Down";
      case 15:
        return "Left";
      case 17:
        return "Right";
    }
    return f6.keyCodeToStr(a);
  }
  r.toElectronAccelerator = o;
})(sd || (sd = {}));
function j1t(r, e) {
  const t = (e & 65535) << 16 >>> 0;
  return (r | t) >>> 0;
}
let mp;
const pE = globalThis.vscode;
if (typeof pE < "u" && typeof pE.process < "u") {
  const r = pE.process;
  mp = {
    get platform() {
      return r.platform;
    },
    get arch() {
      return r.arch;
    },
    get env() {
      return r.env;
    },
    cwd() {
      return r.cwd();
    }
  };
} else typeof process < "u" ? mp = {
  get platform() {
    return process.platform;
  },
  get arch() {
    return process.arch;
  },
  get env() {
    return process.env;
  },
  cwd() {
    return process.env.VSCODE_CWD || process.cwd();
  }
} : mp = {
  // Supported
  get platform() {
    return zs ? "win32" : zt ? "darwin" : "linux";
  },
  get arch() {
  },
  // Unsupported
  get env() {
    return {};
  },
  cwd() {
    return "/";
  }
};
const k8 = mp.cwd, TM = mp.env, Z1t = mp.platform, U1t = 65, q1t = 97, G1t = 90, Q1t = 122, Ku = 46, Xr = 47, Ao = 92, lu = 58, K1t = 63;
class qMe extends Error {
  constructor(e, t, n) {
    let i;
    typeof t == "string" && t.indexOf("not ") === 0 ? (i = "must not be", t = t.replace(/^not /, "")) : i = "must be";
    const s = e.indexOf(".") !== -1 ? "property" : "argument";
    let o = `The "${e}" ${s} ${i} of type ${t}`;
    o += `. Received type ${typeof n}`, super(o), this.code = "ERR_INVALID_ARG_TYPE";
  }
}
function Y1t(r, e) {
  if (r === null || typeof r != "object")
    throw new qMe(e, "Object", r);
}
function Qi(r, e) {
  if (typeof r != "string")
    throw new qMe(e, "string", r);
}
const N1 = Z1t === "win32";
function ln(r) {
  return r === Xr || r === Ao;
}
function IM(r) {
  return r === Xr;
}
function cu(r) {
  return r >= U1t && r <= G1t || r >= q1t && r <= Q1t;
}
function N8(r, e, t, n) {
  let i = "", s = 0, o = -1, a = 0, l = 0;
  for (let c = 0; c <= r.length; ++c) {
    if (c < r.length)
      l = r.charCodeAt(c);
    else {
      if (n(l))
        break;
      l = Xr;
    }
    if (n(l)) {
      if (!(o === c - 1 || a === 1)) if (a === 2) {
        if (i.length < 2 || s !== 2 || i.charCodeAt(i.length - 1) !== Ku || i.charCodeAt(i.length - 2) !== Ku) {
          if (i.length > 2) {
            const d = i.lastIndexOf(t);
            d === -1 ? (i = "", s = 0) : (i = i.slice(0, d), s = i.length - 1 - i.lastIndexOf(t)), o = c, a = 0;
            continue;
          } else if (i.length !== 0) {
            i = "", s = 0, o = c, a = 0;
            continue;
          }
        }
        e && (i += i.length > 0 ? `${t}..` : "..", s = 2);
      } else
        i.length > 0 ? i += `${t}${r.slice(o + 1, c)}` : i = r.slice(o + 1, c), s = c - o - 1;
      o = c, a = 0;
    } else l === Ku && a !== -1 ? ++a : a = -1;
  }
  return i;
}
function X1t(r) {
  return r ? `${r[0] === "." ? "" : "."}${r}` : "";
}
function GMe(r, e) {
  Y1t(e, "pathObject");
  const t = e.dir || e.root, n = e.base || `${e.name || ""}${X1t(e.ext)}`;
  return t ? t === e.root ? `${t}${n}` : `${t}${r}${n}` : n;
}
const io = {
  // path.resolve([from ...], to)
  resolve(...r) {
    let e = "", t = "", n = !1;
    for (let i = r.length - 1; i >= -1; i--) {
      let s;
      if (i >= 0) {
        if (s = r[i], Qi(s, `paths[${i}]`), s.length === 0)
          continue;
      } else e.length === 0 ? s = k8() : (s = TM[`=${e}`] || k8(), (s === void 0 || s.slice(0, 2).toLowerCase() !== e.toLowerCase() && s.charCodeAt(2) === Ao) && (s = `${e}\\`));
      const o = s.length;
      let a = 0, l = "", c = !1;
      const d = s.charCodeAt(0);
      if (o === 1)
        ln(d) && (a = 1, c = !0);
      else if (ln(d))
        if (c = !0, ln(s.charCodeAt(1))) {
          let u = 2, f = u;
          for (; u < o && !ln(s.charCodeAt(u)); )
            u++;
          if (u < o && u !== f) {
            const p = s.slice(f, u);
            for (f = u; u < o && ln(s.charCodeAt(u)); )
              u++;
            if (u < o && u !== f) {
              for (f = u; u < o && !ln(s.charCodeAt(u)); )
                u++;
              (u === o || u !== f) && (l = `\\\\${p}\\${s.slice(f, u)}`, a = u);
            }
          }
        } else
          a = 1;
      else cu(d) && s.charCodeAt(1) === lu && (l = s.slice(0, 2), a = 2, o > 2 && ln(s.charCodeAt(2)) && (c = !0, a = 3));
      if (l.length > 0)
        if (e.length > 0) {
          if (l.toLowerCase() !== e.toLowerCase())
            continue;
        } else
          e = l;
      if (n) {
        if (e.length > 0)
          break;
      } else if (t = `${s.slice(a)}\\${t}`, n = c, c && e.length > 0)
        break;
    }
    return t = N8(t, !n, "\\", ln), n ? `${e}\\${t}` : `${e}${t}` || ".";
  },
  normalize(r) {
    Qi(r, "path");
    const e = r.length;
    if (e === 0)
      return ".";
    let t = 0, n, i = !1;
    const s = r.charCodeAt(0);
    if (e === 1)
      return IM(s) ? "\\" : r;
    if (ln(s))
      if (i = !0, ln(r.charCodeAt(1))) {
        let a = 2, l = a;
        for (; a < e && !ln(r.charCodeAt(a)); )
          a++;
        if (a < e && a !== l) {
          const c = r.slice(l, a);
          for (l = a; a < e && ln(r.charCodeAt(a)); )
            a++;
          if (a < e && a !== l) {
            for (l = a; a < e && !ln(r.charCodeAt(a)); )
              a++;
            if (a === e)
              return `\\\\${c}\\${r.slice(l)}\\`;
            a !== l && (n = `\\\\${c}\\${r.slice(l, a)}`, t = a);
          }
        }
      } else
        t = 1;
    else cu(s) && r.charCodeAt(1) === lu && (n = r.slice(0, 2), t = 2, e > 2 && ln(r.charCodeAt(2)) && (i = !0, t = 3));
    let o = t < e ? N8(r.slice(t), !i, "\\", ln) : "";
    return o.length === 0 && !i && (o = "."), o.length > 0 && ln(r.charCodeAt(e - 1)) && (o += "\\"), n === void 0 ? i ? `\\${o}` : o : i ? `${n}\\${o}` : `${n}${o}`;
  },
  isAbsolute(r) {
    Qi(r, "path");
    const e = r.length;
    if (e === 0)
      return !1;
    const t = r.charCodeAt(0);
    return ln(t) || // Possible device root
    e > 2 && cu(t) && r.charCodeAt(1) === lu && ln(r.charCodeAt(2));
  },
  join(...r) {
    if (r.length === 0)
      return ".";
    let e, t;
    for (let s = 0; s < r.length; ++s) {
      const o = r[s];
      Qi(o, "path"), o.length > 0 && (e === void 0 ? e = t = o : e += `\\${o}`);
    }
    if (e === void 0)
      return ".";
    let n = !0, i = 0;
    if (typeof t == "string" && ln(t.charCodeAt(0))) {
      ++i;
      const s = t.length;
      s > 1 && ln(t.charCodeAt(1)) && (++i, s > 2 && (ln(t.charCodeAt(2)) ? ++i : n = !1));
    }
    if (n) {
      for (; i < e.length && ln(e.charCodeAt(i)); )
        i++;
      i >= 2 && (e = `\\${e.slice(i)}`);
    }
    return io.normalize(e);
  },
  // It will solve the relative path from `from` to `to`, for instance:
  //  from = 'C:\\orandea\\test\\aaa'
  //  to = 'C:\\orandea\\impl\\bbb'
  // The output of the function should be: '..\\..\\impl\\bbb'
  relative(r, e) {
    if (Qi(r, "from"), Qi(e, "to"), r === e)
      return "";
    const t = io.resolve(r), n = io.resolve(e);
    if (t === n || (r = t.toLowerCase(), e = n.toLowerCase(), r === e))
      return "";
    let i = 0;
    for (; i < r.length && r.charCodeAt(i) === Ao; )
      i++;
    let s = r.length;
    for (; s - 1 > i && r.charCodeAt(s - 1) === Ao; )
      s--;
    const o = s - i;
    let a = 0;
    for (; a < e.length && e.charCodeAt(a) === Ao; )
      a++;
    let l = e.length;
    for (; l - 1 > a && e.charCodeAt(l - 1) === Ao; )
      l--;
    const c = l - a, d = o < c ? o : c;
    let u = -1, f = 0;
    for (; f < d; f++) {
      const g = r.charCodeAt(i + f);
      if (g !== e.charCodeAt(a + f))
        break;
      g === Ao && (u = f);
    }
    if (f !== d) {
      if (u === -1)
        return n;
    } else {
      if (c > d) {
        if (e.charCodeAt(a + f) === Ao)
          return n.slice(a + f + 1);
        if (f === 2)
          return n.slice(a + f);
      }
      o > d && (r.charCodeAt(i + f) === Ao ? u = f : f === 2 && (u = 3)), u === -1 && (u = 0);
    }
    let p = "";
    for (f = i + u + 1; f <= s; ++f)
      (f === s || r.charCodeAt(f) === Ao) && (p += p.length === 0 ? ".." : "\\..");
    return a += u, p.length > 0 ? `${p}${n.slice(a, l)}` : (n.charCodeAt(a) === Ao && ++a, n.slice(a, l));
  },
  toNamespacedPath(r) {
    if (typeof r != "string" || r.length === 0)
      return r;
    const e = io.resolve(r);
    if (e.length <= 2)
      return r;
    if (e.charCodeAt(0) === Ao) {
      if (e.charCodeAt(1) === Ao) {
        const t = e.charCodeAt(2);
        if (t !== K1t && t !== Ku)
          return `\\\\?\\UNC\\${e.slice(2)}`;
      }
    } else if (cu(e.charCodeAt(0)) && e.charCodeAt(1) === lu && e.charCodeAt(2) === Ao)
      return `\\\\?\\${e}`;
    return r;
  },
  dirname(r) {
    Qi(r, "path");
    const e = r.length;
    if (e === 0)
      return ".";
    let t = -1, n = 0;
    const i = r.charCodeAt(0);
    if (e === 1)
      return ln(i) ? r : ".";
    if (ln(i)) {
      if (t = n = 1, ln(r.charCodeAt(1))) {
        let a = 2, l = a;
        for (; a < e && !ln(r.charCodeAt(a)); )
          a++;
        if (a < e && a !== l) {
          for (l = a; a < e && ln(r.charCodeAt(a)); )
            a++;
          if (a < e && a !== l) {
            for (l = a; a < e && !ln(r.charCodeAt(a)); )
              a++;
            if (a === e)
              return r;
            a !== l && (t = n = a + 1);
          }
        }
      }
    } else cu(i) && r.charCodeAt(1) === lu && (t = e > 2 && ln(r.charCodeAt(2)) ? 3 : 2, n = t);
    let s = -1, o = !0;
    for (let a = e - 1; a >= n; --a)
      if (ln(r.charCodeAt(a))) {
        if (!o) {
          s = a;
          break;
        }
      } else
        o = !1;
    if (s === -1) {
      if (t === -1)
        return ".";
      s = t;
    }
    return r.slice(0, s);
  },
  basename(r, e) {
    e !== void 0 && Qi(e, "suffix"), Qi(r, "path");
    let t = 0, n = -1, i = !0, s;
    if (r.length >= 2 && cu(r.charCodeAt(0)) && r.charCodeAt(1) === lu && (t = 2), e !== void 0 && e.length > 0 && e.length <= r.length) {
      if (e === r)
        return "";
      let o = e.length - 1, a = -1;
      for (s = r.length - 1; s >= t; --s) {
        const l = r.charCodeAt(s);
        if (ln(l)) {
          if (!i) {
            t = s + 1;
            break;
          }
        } else
          a === -1 && (i = !1, a = s + 1), o >= 0 && (l === e.charCodeAt(o) ? --o === -1 && (n = s) : (o = -1, n = a));
      }
      return t === n ? n = a : n === -1 && (n = r.length), r.slice(t, n);
    }
    for (s = r.length - 1; s >= t; --s)
      if (ln(r.charCodeAt(s))) {
        if (!i) {
          t = s + 1;
          break;
        }
      } else n === -1 && (i = !1, n = s + 1);
    return n === -1 ? "" : r.slice(t, n);
  },
  extname(r) {
    Qi(r, "path");
    let e = 0, t = -1, n = 0, i = -1, s = !0, o = 0;
    r.length >= 2 && r.charCodeAt(1) === lu && cu(r.charCodeAt(0)) && (e = n = 2);
    for (let a = r.length - 1; a >= e; --a) {
      const l = r.charCodeAt(a);
      if (ln(l)) {
        if (!s) {
          n = a + 1;
          break;
        }
        continue;
      }
      i === -1 && (s = !1, i = a + 1), l === Ku ? t === -1 ? t = a : o !== 1 && (o = 1) : t !== -1 && (o = -1);
    }
    return t === -1 || i === -1 || // We saw a non-dot character immediately before the dot
    o === 0 || // The (right-most) trimmed path component is exactly '..'
    o === 1 && t === i - 1 && t === n + 1 ? "" : r.slice(t, i);
  },
  format: GMe.bind(null, "\\"),
  parse(r) {
    Qi(r, "path");
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (r.length === 0)
      return e;
    const t = r.length;
    let n = 0, i = r.charCodeAt(0);
    if (t === 1)
      return ln(i) ? (e.root = e.dir = r, e) : (e.base = e.name = r, e);
    if (ln(i)) {
      if (n = 1, ln(r.charCodeAt(1))) {
        let u = 2, f = u;
        for (; u < t && !ln(r.charCodeAt(u)); )
          u++;
        if (u < t && u !== f) {
          for (f = u; u < t && ln(r.charCodeAt(u)); )
            u++;
          if (u < t && u !== f) {
            for (f = u; u < t && !ln(r.charCodeAt(u)); )
              u++;
            u === t ? n = u : u !== f && (n = u + 1);
          }
        }
      }
    } else if (cu(i) && r.charCodeAt(1) === lu) {
      if (t <= 2)
        return e.root = e.dir = r, e;
      if (n = 2, ln(r.charCodeAt(2))) {
        if (t === 3)
          return e.root = e.dir = r, e;
        n = 3;
      }
    }
    n > 0 && (e.root = r.slice(0, n));
    let s = -1, o = n, a = -1, l = !0, c = r.length - 1, d = 0;
    for (; c >= n; --c) {
      if (i = r.charCodeAt(c), ln(i)) {
        if (!l) {
          o = c + 1;
          break;
        }
        continue;
      }
      a === -1 && (l = !1, a = c + 1), i === Ku ? s === -1 ? s = c : d !== 1 && (d = 1) : s !== -1 && (d = -1);
    }
    return a !== -1 && (s === -1 || // We saw a non-dot character immediately before the dot
    d === 0 || // The (right-most) trimmed path component is exactly '..'
    d === 1 && s === a - 1 && s === o + 1 ? e.base = e.name = r.slice(o, a) : (e.name = r.slice(o, s), e.base = r.slice(o, a), e.ext = r.slice(s, a))), o > 0 && o !== n ? e.dir = r.slice(0, o - 1) : e.dir = e.root, e;
  },
  sep: "\\",
  delimiter: ";",
  win32: null,
  posix: null
}, J1t = (() => {
  if (N1) {
    const r = /\\/g;
    return () => {
      const e = k8().replace(r, "/");
      return e.slice(e.indexOf("/"));
    };
  }
  return () => k8();
})(), Si = {
  // path.resolve([from ...], to)
  resolve(...r) {
    let e = "", t = !1;
    for (let n = r.length - 1; n >= -1 && !t; n--) {
      const i = n >= 0 ? r[n] : J1t();
      Qi(i, `paths[${n}]`), i.length !== 0 && (e = `${i}/${e}`, t = i.charCodeAt(0) === Xr);
    }
    return e = N8(e, !t, "/", IM), t ? `/${e}` : e.length > 0 ? e : ".";
  },
  normalize(r) {
    if (Qi(r, "path"), r.length === 0)
      return ".";
    const e = r.charCodeAt(0) === Xr, t = r.charCodeAt(r.length - 1) === Xr;
    return r = N8(r, !e, "/", IM), r.length === 0 ? e ? "/" : t ? "./" : "." : (t && (r += "/"), e ? `/${r}` : r);
  },
  isAbsolute(r) {
    return Qi(r, "path"), r.length > 0 && r.charCodeAt(0) === Xr;
  },
  join(...r) {
    if (r.length === 0)
      return ".";
    let e;
    for (let t = 0; t < r.length; ++t) {
      const n = r[t];
      Qi(n, "path"), n.length > 0 && (e === void 0 ? e = n : e += `/${n}`);
    }
    return e === void 0 ? "." : Si.normalize(e);
  },
  relative(r, e) {
    if (Qi(r, "from"), Qi(e, "to"), r === e || (r = Si.resolve(r), e = Si.resolve(e), r === e))
      return "";
    const t = 1, n = r.length, i = n - t, s = 1, o = e.length - s, a = i < o ? i : o;
    let l = -1, c = 0;
    for (; c < a; c++) {
      const u = r.charCodeAt(t + c);
      if (u !== e.charCodeAt(s + c))
        break;
      u === Xr && (l = c);
    }
    if (c === a)
      if (o > a) {
        if (e.charCodeAt(s + c) === Xr)
          return e.slice(s + c + 1);
        if (c === 0)
          return e.slice(s + c);
      } else i > a && (r.charCodeAt(t + c) === Xr ? l = c : c === 0 && (l = 0));
    let d = "";
    for (c = t + l + 1; c <= n; ++c)
      (c === n || r.charCodeAt(c) === Xr) && (d += d.length === 0 ? ".." : "/..");
    return `${d}${e.slice(s + l)}`;
  },
  toNamespacedPath(r) {
    return r;
  },
  dirname(r) {
    if (Qi(r, "path"), r.length === 0)
      return ".";
    const e = r.charCodeAt(0) === Xr;
    let t = -1, n = !0;
    for (let i = r.length - 1; i >= 1; --i)
      if (r.charCodeAt(i) === Xr) {
        if (!n) {
          t = i;
          break;
        }
      } else
        n = !1;
    return t === -1 ? e ? "/" : "." : e && t === 1 ? "//" : r.slice(0, t);
  },
  basename(r, e) {
    e !== void 0 && Qi(e, "ext"), Qi(r, "path");
    let t = 0, n = -1, i = !0, s;
    if (e !== void 0 && e.length > 0 && e.length <= r.length) {
      if (e === r)
        return "";
      let o = e.length - 1, a = -1;
      for (s = r.length - 1; s >= 0; --s) {
        const l = r.charCodeAt(s);
        if (l === Xr) {
          if (!i) {
            t = s + 1;
            break;
          }
        } else
          a === -1 && (i = !1, a = s + 1), o >= 0 && (l === e.charCodeAt(o) ? --o === -1 && (n = s) : (o = -1, n = a));
      }
      return t === n ? n = a : n === -1 && (n = r.length), r.slice(t, n);
    }
    for (s = r.length - 1; s >= 0; --s)
      if (r.charCodeAt(s) === Xr) {
        if (!i) {
          t = s + 1;
          break;
        }
      } else n === -1 && (i = !1, n = s + 1);
    return n === -1 ? "" : r.slice(t, n);
  },
  extname(r) {
    Qi(r, "path");
    let e = -1, t = 0, n = -1, i = !0, s = 0;
    for (let o = r.length - 1; o >= 0; --o) {
      const a = r.charCodeAt(o);
      if (a === Xr) {
        if (!i) {
          t = o + 1;
          break;
        }
        continue;
      }
      n === -1 && (i = !1, n = o + 1), a === Ku ? e === -1 ? e = o : s !== 1 && (s = 1) : e !== -1 && (s = -1);
    }
    return e === -1 || n === -1 || // We saw a non-dot character immediately before the dot
    s === 0 || // The (right-most) trimmed path component is exactly '..'
    s === 1 && e === n - 1 && e === t + 1 ? "" : r.slice(e, n);
  },
  format: GMe.bind(null, "/"),
  parse(r) {
    Qi(r, "path");
    const e = { root: "", dir: "", base: "", ext: "", name: "" };
    if (r.length === 0)
      return e;
    const t = r.charCodeAt(0) === Xr;
    let n;
    t ? (e.root = "/", n = 1) : n = 0;
    let i = -1, s = 0, o = -1, a = !0, l = r.length - 1, c = 0;
    for (; l >= n; --l) {
      const d = r.charCodeAt(l);
      if (d === Xr) {
        if (!a) {
          s = l + 1;
          break;
        }
        continue;
      }
      o === -1 && (a = !1, o = l + 1), d === Ku ? i === -1 ? i = l : c !== 1 && (c = 1) : i !== -1 && (c = -1);
    }
    if (o !== -1) {
      const d = s === 0 && t ? 1 : s;
      i === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && i === o - 1 && i === s + 1 ? e.base = e.name = r.slice(d, o) : (e.name = r.slice(d, i), e.base = r.slice(d, o), e.ext = r.slice(i, o));
    }
    return s > 0 ? e.dir = r.slice(0, s - 1) : t && (e.dir = "/"), e;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
Si.win32 = io.win32 = io;
Si.posix = io.posix = Si;
const QMe = N1 ? io.normalize : Si.normalize, $1t = N1 ? io.resolve : Si.resolve, e0t = N1 ? io.relative : Si.relative, t0t = N1 ? io.dirname : Si.dirname, KMe = N1 ? io.basename : Si.basename, n0t = N1 ? io.extname : Si.extname, Yu = N1 ? io.sep : Si.sep, i0t = /^\w[\w\d+.-]*$/, r0t = /^\//, s0t = /^\/\//;
function o0t(r, e) {
  if (!r.scheme && e)
    throw new Error(`[UriError]: Scheme is missing: {scheme: "", authority: "${r.authority}", path: "${r.path}", query: "${r.query}", fragment: "${r.fragment}"}`);
  if (r.scheme && !i0t.test(r.scheme))
    throw new Error("[UriError]: Scheme contains illegal characters.");
  if (r.path) {
    if (r.authority) {
      if (!r0t.test(r.path))
        throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
    } else if (s0t.test(r.path))
      throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
  }
}
function a0t(r, e) {
  return !r && !e ? "file" : r;
}
function l0t(r, e) {
  switch (r) {
    case "https":
    case "http":
    case "file":
      e ? e[0] !== Rl && (e = Rl + e) : e = Rl;
      break;
  }
  return e;
}
const vi = "", Rl = "/", c0t = /^(([^:/?#]+?):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;
class Pt {
  static isUri(e) {
    return e instanceof Pt ? !0 : e ? typeof e.authority == "string" && typeof e.fragment == "string" && typeof e.path == "string" && typeof e.query == "string" && typeof e.scheme == "string" && typeof e.fsPath == "string" && typeof e.with == "function" && typeof e.toString == "function" : !1;
  }
  /**
   * @internal
   */
  constructor(e, t, n, i, s, o = !1) {
    typeof e == "object" ? (this.scheme = e.scheme || vi, this.authority = e.authority || vi, this.path = e.path || vi, this.query = e.query || vi, this.fragment = e.fragment || vi) : (this.scheme = a0t(e, o), this.authority = t || vi, this.path = l0t(this.scheme, n || vi), this.query = i || vi, this.fragment = s || vi, o0t(this, o));
  }
  // ---- filesystem path -----------------------
  /**
   * Returns a string representing the corresponding file system path of this URI.
   * Will handle UNC paths, normalizes windows drive letters to lower-case, and uses the
   * platform specific path separator.
   *
   * * Will *not* validate the path for invalid characters and semantics.
   * * Will *not* look at the scheme of this URI.
   * * The result shall *not* be used for display purposes but for accessing a file on disk.
   *
   *
   * The *difference* to `URI#path` is the use of the platform specific separator and the handling
   * of UNC paths. See the below sample of a file-uri with an authority (UNC path).
   *
   * ```ts
      const u = URI.parse('file://server/c$/folder/file.txt')
      u.authority === 'server'
      u.path === '/shares/c$/file.txt'
      u.fsPath === '\\server\c$\folder\file.txt'
  ```
   *
   * Using `URI#path` to read a file (using fs-apis) would not be enough because parts of the path,
   * namely the server name, would be missing. Therefore `URI#fsPath` exists - it's sugar to ease working
   * with URIs that represent files on disk (`file` scheme).
   */
  get fsPath() {
    return T8(this, !1);
  }
  // ---- modify to new -------------------------
  with(e) {
    if (!e)
      return this;
    let { scheme: t, authority: n, path: i, query: s, fragment: o } = e;
    return t === void 0 ? t = this.scheme : t === null && (t = vi), n === void 0 ? n = this.authority : n === null && (n = vi), i === void 0 ? i = this.path : i === null && (i = vi), s === void 0 ? s = this.query : s === null && (s = vi), o === void 0 ? o = this.fragment : o === null && (o = vi), t === this.scheme && n === this.authority && i === this.path && s === this.query && o === this.fragment ? this : new v2(t, n, i, s, o);
  }
  // ---- parse & validate ------------------------
  /**
   * Creates a new URI from a string, e.g. `http://www.example.com/some/path`,
   * `file:///usr/home`, or `scheme:with/path`.
   *
   * @param value A string which represents an URI (see `URI#toString`).
   */
  static parse(e, t = !1) {
    const n = c0t.exec(e);
    return n ? new v2(n[2] || vi, _v(n[4] || vi), _v(n[5] || vi), _v(n[7] || vi), _v(n[9] || vi), t) : new v2(vi, vi, vi, vi, vi);
  }
  /**
   * Creates a new URI from a file system path, e.g. `c:\my\files`,
   * `/usr/home`, or `\\server\share\some\path`.
   *
   * The *difference* between `URI#parse` and `URI#file` is that the latter treats the argument
   * as path, not as stringified-uri. E.g. `URI.file(path)` is **not the same as**
   * `URI.parse('file://' + path)` because the path might contain characters that are
   * interpreted (# and ?). See the following sample:
   * ```ts
  const good = URI.file('/coding/c#/project1');
  good.scheme === 'file';
  good.path === '/coding/c#/project1';
  good.fragment === '';
  const bad = URI.parse('file://' + '/coding/c#/project1');
  bad.scheme === 'file';
  bad.path === '/coding/c'; // path is now broken
  bad.fragment === '/project1';
  ```
   *
   * @param path A file system path (see `URI#fsPath`)
   */
  static file(e) {
    let t = vi;
    if (zs && (e = e.replace(/\\/g, Rl)), e[0] === Rl && e[1] === Rl) {
      const n = e.indexOf(Rl, 2);
      n === -1 ? (t = e.substring(2), e = Rl) : (t = e.substring(2, n), e = e.substring(n) || Rl);
    }
    return new v2("file", t, e, vi, vi);
  }
  /**
   * Creates new URI from uri components.
   *
   * Unless `strict` is `true` the scheme is defaults to be `file`. This function performs
   * validation and should be used for untrusted uri components retrieved from storage,
   * user input, command arguments etc
   */
  static from(e, t) {
    return new v2(e.scheme, e.authority, e.path, e.query, e.fragment, t);
  }
  /**
   * Join a URI path with path fragments and normalizes the resulting path.
   *
   * @param uri The input URI.
   * @param pathFragment The path fragment to add to the URI path.
   * @returns The resulting URI.
   */
  static joinPath(e, ...t) {
    if (!e.path)
      throw new Error("[UriError]: cannot call joinPath on URI without path");
    let n;
    return zs && e.scheme === "file" ? n = Pt.file(io.join(T8(e, !0), ...t)).path : n = Si.join(e.path, ...t), e.with({ path: n });
  }
  // ---- printing/externalize ---------------------------
  /**
   * Creates a string representation for this URI. It's guaranteed that calling
   * `URI.parse` with the result of this function creates an URI which is equal
   * to this URI.
   *
   * * The result shall *not* be used for display purposes but for externalization or transport.
   * * The result will be encoded using the percentage encoding and encoding happens mostly
   * ignore the scheme-specific encoding rules.
   *
   * @param skipEncoding Do not encode the result, default is `false`
   */
  toString(e = !1) {
    return OM(this, e);
  }
  toJSON() {
    return this;
  }
  static revive(e) {
    if (e) {
      if (e instanceof Pt)
        return e;
      {
        const t = new v2(e);
        return t._formatted = e.external ?? null, t._fsPath = e._sep === YMe ? e.fsPath ?? null : null, t;
      }
    } else return e;
  }
}
const YMe = zs ? 1 : void 0;
let v2 = class extends Pt {
  constructor() {
    super(...arguments), this._formatted = null, this._fsPath = null;
  }
  get fsPath() {
    return this._fsPath || (this._fsPath = T8(this, !1)), this._fsPath;
  }
  toString(e = !1) {
    return e ? OM(this, !0) : (this._formatted || (this._formatted = OM(this, !1)), this._formatted);
  }
  toJSON() {
    const e = {
      $mid: 1
      /* MarshalledId.Uri */
    };
    return this._fsPath && (e.fsPath = this._fsPath, e._sep = YMe), this._formatted && (e.external = this._formatted), this.path && (e.path = this.path), this.scheme && (e.scheme = this.scheme), this.authority && (e.authority = this.authority), this.query && (e.query = this.query), this.fragment && (e.fragment = this.fragment), e;
  }
};
const XMe = {
  58: "%3A",
  // gen-delims
  47: "%2F",
  63: "%3F",
  35: "%23",
  91: "%5B",
  93: "%5D",
  64: "%40",
  33: "%21",
  // sub-delims
  36: "%24",
  38: "%26",
  39: "%27",
  40: "%28",
  41: "%29",
  42: "%2A",
  43: "%2B",
  44: "%2C",
  59: "%3B",
  61: "%3D",
  32: "%20"
};
function vve(r, e, t) {
  let n, i = -1;
  for (let s = 0; s < r.length; s++) {
    const o = r.charCodeAt(s);
    if (o >= 97 && o <= 122 || o >= 65 && o <= 90 || o >= 48 && o <= 57 || o === 45 || o === 46 || o === 95 || o === 126 || e && o === 47 || t && o === 91 || t && o === 93 || t && o === 58)
      i !== -1 && (n += encodeURIComponent(r.substring(i, s)), i = -1), n !== void 0 && (n += r.charAt(s));
    else {
      n === void 0 && (n = r.substr(0, s));
      const a = XMe[o];
      a !== void 0 ? (i !== -1 && (n += encodeURIComponent(r.substring(i, s)), i = -1), n += a) : i === -1 && (i = s);
    }
  }
  return i !== -1 && (n += encodeURIComponent(r.substring(i))), n !== void 0 ? n : r;
}
function h0t(r) {
  let e;
  for (let t = 0; t < r.length; t++) {
    const n = r.charCodeAt(t);
    n === 35 || n === 63 ? (e === void 0 && (e = r.substr(0, t)), e += XMe[n]) : e !== void 0 && (e += r[t]);
  }
  return e !== void 0 ? e : r;
}
function T8(r, e) {
  let t;
  return r.authority && r.path.length > 1 && r.scheme === "file" ? t = `//${r.authority}${r.path}` : r.path.charCodeAt(0) === 47 && (r.path.charCodeAt(1) >= 65 && r.path.charCodeAt(1) <= 90 || r.path.charCodeAt(1) >= 97 && r.path.charCodeAt(1) <= 122) && r.path.charCodeAt(2) === 58 ? e ? t = r.path.substr(1) : t = r.path[1].toLowerCase() + r.path.substr(2) : t = r.path, zs && (t = t.replace(/\//g, "\\")), t;
}
function OM(r, e) {
  const t = e ? h0t : vve;
  let n = "", { scheme: i, authority: s, path: o, query: a, fragment: l } = r;
  if (i && (n += i, n += ":"), (s || i === "file") && (n += Rl, n += Rl), s) {
    let c = s.indexOf("@");
    if (c !== -1) {
      const d = s.substr(0, c);
      s = s.substr(c + 1), c = d.lastIndexOf(":"), c === -1 ? n += t(d, !1, !1) : (n += t(d.substr(0, c), !1, !1), n += ":", n += t(d.substr(c + 1), !1, !0)), n += "@";
    }
    s = s.toLowerCase(), c = s.lastIndexOf(":"), c === -1 ? n += t(s, !1, !0) : (n += t(s.substr(0, c), !1, !0), n += s.substr(c));
  }
  if (o) {
    if (o.length >= 3 && o.charCodeAt(0) === 47 && o.charCodeAt(2) === 58) {
      const c = o.charCodeAt(1);
      c >= 65 && c <= 90 && (o = `/${String.fromCharCode(c + 32)}:${o.substr(3)}`);
    } else if (o.length >= 2 && o.charCodeAt(1) === 58) {
      const c = o.charCodeAt(0);
      c >= 65 && c <= 90 && (o = `${String.fromCharCode(c + 32)}:${o.substr(2)}`);
    }
    n += t(o, !0, !1);
  }
  return a && (n += "?", n += t(a, !1, !1)), l && (n += "#", n += e ? l : vve(l, !1, !1)), n;
}
function JMe(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    return r.length > 3 ? r.substr(0, 3) + JMe(r.substr(3)) : r;
  }
}
const bve = /(%[0-9A-Za-z][0-9A-Za-z])+/g;
function _v(r) {
  return r.match(bve) ? r.replace(bve, (e) => JMe(e)) : r;
}
let le = class i0 {
  constructor(e, t) {
    this.lineNumber = e, this.column = t;
  }
  /**
   * Create a new position from this position.
   *
   * @param newLineNumber new line number
   * @param newColumn new column
   */
  with(e = this.lineNumber, t = this.column) {
    return e === this.lineNumber && t === this.column ? this : new i0(e, t);
  }
  /**
   * Derive a new position from this position.
   *
   * @param deltaLineNumber line number delta
   * @param deltaColumn column delta
   */
  delta(e = 0, t = 0) {
    return this.with(this.lineNumber + e, this.column + t);
  }
  /**
   * Test if this position equals other position
   */
  equals(e) {
    return i0.equals(this, e);
  }
  /**
   * Test if position `a` equals position `b`
   */
  static equals(e, t) {
    return !e && !t ? !0 : !!e && !!t && e.lineNumber === t.lineNumber && e.column === t.column;
  }
  /**
   * Test if this position is before other position.
   * If the two positions are equal, the result will be false.
   */
  isBefore(e) {
    return i0.isBefore(this, e);
  }
  /**
   * Test if position `a` is before position `b`.
   * If the two positions are equal, the result will be false.
   */
  static isBefore(e, t) {
    return e.lineNumber < t.lineNumber ? !0 : t.lineNumber < e.lineNumber ? !1 : e.column < t.column;
  }
  /**
   * Test if this position is before other position.
   * If the two positions are equal, the result will be true.
   */
  isBeforeOrEqual(e) {
    return i0.isBeforeOrEqual(this, e);
  }
  /**
   * Test if position `a` is before position `b`.
   * If the two positions are equal, the result will be true.
   */
  static isBeforeOrEqual(e, t) {
    return e.lineNumber < t.lineNumber ? !0 : t.lineNumber < e.lineNumber ? !1 : e.column <= t.column;
  }
  /**
   * A function that compares positions, useful for sorting
   */
  static compare(e, t) {
    const n = e.lineNumber | 0, i = t.lineNumber | 0;
    if (n === i) {
      const s = e.column | 0, o = t.column | 0;
      return s - o;
    }
    return n - i;
  }
  /**
   * Clone this position.
   */
  clone() {
    return new i0(this.lineNumber, this.column);
  }
  /**
   * Convert to a human-readable representation.
   */
  toString() {
    return "(" + this.lineNumber + "," + this.column + ")";
  }
  // ---
  /**
   * Create a `Position` from an `IPosition`.
   */
  static lift(e) {
    return new i0(e.lineNumber, e.column);
  }
  /**
   * Test if `obj` is an `IPosition`.
   */
  static isIPosition(e) {
    return e && typeof e.lineNumber == "number" && typeof e.column == "number";
  }
  toJSON() {
    return {
      lineNumber: this.lineNumber,
      column: this.column
    };
  }
}, Q = class ar {
  constructor(e, t, n, i) {
    e > n || e === n && t > i ? (this.startLineNumber = n, this.startColumn = i, this.endLineNumber = e, this.endColumn = t) : (this.startLineNumber = e, this.startColumn = t, this.endLineNumber = n, this.endColumn = i);
  }
  /**
   * Test if this range is empty.
   */
  isEmpty() {
    return ar.isEmpty(this);
  }
  /**
   * Test if `range` is empty.
   */
  static isEmpty(e) {
    return e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn;
  }
  /**
   * Test if position is in this range. If the position is at the edges, will return true.
   */
  containsPosition(e) {
    return ar.containsPosition(this, e);
  }
  /**
   * Test if `position` is in `range`. If the position is at the edges, will return true.
   */
  static containsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber || t.lineNumber === e.startLineNumber && t.column < e.startColumn || t.lineNumber === e.endLineNumber && t.column > e.endColumn);
  }
  /**
   * Test if `position` is in `range`. If the position is at the edges, will return false.
   * @internal
   */
  static strictContainsPosition(e, t) {
    return !(t.lineNumber < e.startLineNumber || t.lineNumber > e.endLineNumber || t.lineNumber === e.startLineNumber && t.column <= e.startColumn || t.lineNumber === e.endLineNumber && t.column >= e.endColumn);
  }
  /**
   * Test if range is in this range. If the range is equal to this range, will return true.
   */
  containsRange(e) {
    return ar.containsRange(this, e);
  }
  /**
   * Test if `otherRange` is in `range`. If the ranges are equal, will return true.
   */
  static containsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber || t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber || t.startLineNumber === e.startLineNumber && t.startColumn < e.startColumn || t.endLineNumber === e.endLineNumber && t.endColumn > e.endColumn);
  }
  /**
   * Test if `range` is strictly in this range. `range` must start after and end before this range for the result to be true.
   */
  strictContainsRange(e) {
    return ar.strictContainsRange(this, e);
  }
  /**
   * Test if `otherRange` is strictly in `range` (must start after, and end before). If the ranges are equal, will return false.
   */
  static strictContainsRange(e, t) {
    return !(t.startLineNumber < e.startLineNumber || t.endLineNumber < e.startLineNumber || t.startLineNumber > e.endLineNumber || t.endLineNumber > e.endLineNumber || t.startLineNumber === e.startLineNumber && t.startColumn <= e.startColumn || t.endLineNumber === e.endLineNumber && t.endColumn >= e.endColumn);
  }
  /**
   * A reunion of the two ranges.
   * The smallest position will be used as the start point, and the largest one as the end point.
   */
  plusRange(e) {
    return ar.plusRange(this, e);
  }
  /**
   * A reunion of the two ranges.
   * The smallest position will be used as the start point, and the largest one as the end point.
   */
  static plusRange(e, t) {
    let n, i, s, o;
    return t.startLineNumber < e.startLineNumber ? (n = t.startLineNumber, i = t.startColumn) : t.startLineNumber === e.startLineNumber ? (n = t.startLineNumber, i = Math.min(t.startColumn, e.startColumn)) : (n = e.startLineNumber, i = e.startColumn), t.endLineNumber > e.endLineNumber ? (s = t.endLineNumber, o = t.endColumn) : t.endLineNumber === e.endLineNumber ? (s = t.endLineNumber, o = Math.max(t.endColumn, e.endColumn)) : (s = e.endLineNumber, o = e.endColumn), new ar(n, i, s, o);
  }
  /**
   * A intersection of the two ranges.
   */
  intersectRanges(e) {
    return ar.intersectRanges(this, e);
  }
  /**
   * A intersection of the two ranges.
   */
  static intersectRanges(e, t) {
    let n = e.startLineNumber, i = e.startColumn, s = e.endLineNumber, o = e.endColumn;
    const a = t.startLineNumber, l = t.startColumn, c = t.endLineNumber, d = t.endColumn;
    return n < a ? (n = a, i = l) : n === a && (i = Math.max(i, l)), s > c ? (s = c, o = d) : s === c && (o = Math.min(o, d)), n > s || n === s && i > o ? null : new ar(n, i, s, o);
  }
  /**
   * Test if this range equals other.
   */
  equalsRange(e) {
    return ar.equalsRange(this, e);
  }
  /**
   * Test if range `a` equals `b`.
   */
  static equalsRange(e, t) {
    return !e && !t ? !0 : !!e && !!t && e.startLineNumber === t.startLineNumber && e.startColumn === t.startColumn && e.endLineNumber === t.endLineNumber && e.endColumn === t.endColumn;
  }
  /**
   * Return the end position (which will be after or equal to the start position)
   */
  getEndPosition() {
    return ar.getEndPosition(this);
  }
  /**
   * Return the end position (which will be after or equal to the start position)
   */
  static getEndPosition(e) {
    return new le(e.endLineNumber, e.endColumn);
  }
  /**
   * Return the start position (which will be before or equal to the end position)
   */
  getStartPosition() {
    return ar.getStartPosition(this);
  }
  /**
   * Return the start position (which will be before or equal to the end position)
   */
  static getStartPosition(e) {
    return new le(e.startLineNumber, e.startColumn);
  }
  /**
   * Transform to a user presentable string representation.
   */
  toString() {
    return "[" + this.startLineNumber + "," + this.startColumn + " -> " + this.endLineNumber + "," + this.endColumn + "]";
  }
  /**
   * Create a new range using this range's start position, and using endLineNumber and endColumn as the end position.
   */
  setEndPosition(e, t) {
    return new ar(this.startLineNumber, this.startColumn, e, t);
  }
  /**
   * Create a new range using this range's end position, and using startLineNumber and startColumn as the start position.
   */
  setStartPosition(e, t) {
    return new ar(e, t, this.endLineNumber, this.endColumn);
  }
  /**
   * Create a new empty range using this range's start position.
   */
  collapseToStart() {
    return ar.collapseToStart(this);
  }
  /**
   * Create a new empty range using this range's start position.
   */
  static collapseToStart(e) {
    return new ar(e.startLineNumber, e.startColumn, e.startLineNumber, e.startColumn);
  }
  /**
   * Create a new empty range using this range's end position.
   */
  collapseToEnd() {
    return ar.collapseToEnd(this);
  }
  /**
   * Create a new empty range using this range's end position.
   */
  static collapseToEnd(e) {
    return new ar(e.endLineNumber, e.endColumn, e.endLineNumber, e.endColumn);
  }
  /**
   * Moves the range by the given amount of lines.
   */
  delta(e) {
    return new ar(this.startLineNumber + e, this.startColumn, this.endLineNumber + e, this.endColumn);
  }
  // ---
  static fromPositions(e, t = e) {
    return new ar(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  static lift(e) {
    return e ? new ar(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : null;
  }
  /**
   * Test if `obj` is an `IRange`.
   */
  static isIRange(e) {
    return e && typeof e.startLineNumber == "number" && typeof e.startColumn == "number" && typeof e.endLineNumber == "number" && typeof e.endColumn == "number";
  }
  /**
   * Test if the two ranges are touching in any way.
   */
  static areIntersectingOrTouching(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn < t.startColumn || t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn < e.startColumn);
  }
  /**
   * Test if the two ranges are intersecting. If the ranges are touching it returns true.
   */
  static areIntersecting(e, t) {
    return !(e.endLineNumber < t.startLineNumber || e.endLineNumber === t.startLineNumber && e.endColumn <= t.startColumn || t.endLineNumber < e.startLineNumber || t.endLineNumber === e.startLineNumber && t.endColumn <= e.startColumn);
  }
  /**
   * A function that compares ranges, useful for sorting ranges
   * It will first compare ranges on the startPosition and then on the endPosition
   */
  static compareRangesUsingStarts(e, t) {
    if (e && t) {
      const s = e.startLineNumber | 0, o = t.startLineNumber | 0;
      if (s === o) {
        const a = e.startColumn | 0, l = t.startColumn | 0;
        if (a === l) {
          const c = e.endLineNumber | 0, d = t.endLineNumber | 0;
          if (c === d) {
            const u = e.endColumn | 0, f = t.endColumn | 0;
            return u - f;
          }
          return c - d;
        }
        return a - l;
      }
      return s - o;
    }
    return (e ? 1 : 0) - (t ? 1 : 0);
  }
  /**
   * A function that compares ranges, useful for sorting ranges
   * It will first compare ranges on the endPosition and then on the startPosition
   */
  static compareRangesUsingEnds(e, t) {
    return e.endLineNumber === t.endLineNumber ? e.endColumn === t.endColumn ? e.startLineNumber === t.startLineNumber ? e.startColumn - t.startColumn : e.startLineNumber - t.startLineNumber : e.endColumn - t.endColumn : e.endLineNumber - t.endLineNumber;
  }
  /**
   * Test if the range spans multiple lines.
   */
  static spansMultipleLines(e) {
    return e.endLineNumber > e.startLineNumber;
  }
  toJSON() {
    return this;
  }
}, _n = class Va extends Q {
  constructor(e, t, n, i) {
    super(e, t, n, i), this.selectionStartLineNumber = e, this.selectionStartColumn = t, this.positionLineNumber = n, this.positionColumn = i;
  }
  /**
   * Transform to a human-readable representation.
   */
  toString() {
    return "[" + this.selectionStartLineNumber + "," + this.selectionStartColumn + " -> " + this.positionLineNumber + "," + this.positionColumn + "]";
  }
  /**
   * Test if equals other selection.
   */
  equalsSelection(e) {
    return Va.selectionsEqual(this, e);
  }
  /**
   * Test if the two selections are equal.
   */
  static selectionsEqual(e, t) {
    return e.selectionStartLineNumber === t.selectionStartLineNumber && e.selectionStartColumn === t.selectionStartColumn && e.positionLineNumber === t.positionLineNumber && e.positionColumn === t.positionColumn;
  }
  /**
   * Get directions (LTR or RTL).
   */
  getDirection() {
    return this.selectionStartLineNumber === this.startLineNumber && this.selectionStartColumn === this.startColumn ? 0 : 1;
  }
  /**
   * Create a new selection with a different `positionLineNumber` and `positionColumn`.
   */
  setEndPosition(e, t) {
    return this.getDirection() === 0 ? new Va(this.startLineNumber, this.startColumn, e, t) : new Va(e, t, this.startLineNumber, this.startColumn);
  }
  /**
   * Get the position at `positionLineNumber` and `positionColumn`.
   */
  getPosition() {
    return new le(this.positionLineNumber, this.positionColumn);
  }
  /**
   * Get the position at the start of the selection.
  */
  getSelectionStart() {
    return new le(this.selectionStartLineNumber, this.selectionStartColumn);
  }
  /**
   * Create a new selection with a different `selectionStartLineNumber` and `selectionStartColumn`.
   */
  setStartPosition(e, t) {
    return this.getDirection() === 0 ? new Va(e, t, this.endLineNumber, this.endColumn) : new Va(this.endLineNumber, this.endColumn, e, t);
  }
  // ----
  /**
   * Create a `Selection` from one or two positions
   */
  static fromPositions(e, t = e) {
    return new Va(e.lineNumber, e.column, t.lineNumber, t.column);
  }
  /**
   * Creates a `Selection` from a range, given a direction.
   */
  static fromRange(e, t) {
    return t === 0 ? new Va(e.startLineNumber, e.startColumn, e.endLineNumber, e.endColumn) : new Va(e.endLineNumber, e.endColumn, e.startLineNumber, e.startColumn);
  }
  /**
   * Create a `Selection` from an `ISelection`.
   */
  static liftSelection(e) {
    return new Va(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
  }
  /**
   * `a` equals `b`.
   */
  static selectionsArrEqual(e, t) {
    if (e && !t || !e && t)
      return !1;
    if (!e && !t)
      return !0;
    if (e.length !== t.length)
      return !1;
    for (let n = 0, i = e.length; n < i; n++)
      if (!this.selectionsEqual(e[n], t[n]))
        return !1;
    return !0;
  }
  /**
   * Test if `obj` is an `ISelection`.
   */
  static isISelection(e) {
    return e && typeof e.selectionStartLineNumber == "number" && typeof e.selectionStartColumn == "number" && typeof e.positionLineNumber == "number" && typeof e.positionColumn == "number";
  }
  /**
   * Create with a direction.
   */
  static createWithDirection(e, t, n, i, s) {
    return s === 0 ? new Va(e, t, n, i) : new Va(n, i, e, t);
  }
};
const RM = /* @__PURE__ */ Object.create(null);
function k(r, e) {
  if (Vo(e)) {
    const t = RM[e];
    if (t === void 0)
      throw new Error(`${r} references an unknown codicon: ${e}`);
    e = t;
  }
  return RM[r] = e, { id: r };
}
function $Me() {
  return RM;
}
const d0t = {
  add: k("add", 6e4),
  plus: k("plus", 6e4),
  gistNew: k("gist-new", 6e4),
  repoCreate: k("repo-create", 6e4),
  lightbulb: k("lightbulb", 60001),
  lightBulb: k("light-bulb", 60001),
  repo: k("repo", 60002),
  repoDelete: k("repo-delete", 60002),
  gistFork: k("gist-fork", 60003),
  repoForked: k("repo-forked", 60003),
  gitPullRequest: k("git-pull-request", 60004),
  gitPullRequestAbandoned: k("git-pull-request-abandoned", 60004),
  recordKeys: k("record-keys", 60005),
  keyboard: k("keyboard", 60005),
  tag: k("tag", 60006),
  gitPullRequestLabel: k("git-pull-request-label", 60006),
  tagAdd: k("tag-add", 60006),
  tagRemove: k("tag-remove", 60006),
  person: k("person", 60007),
  personFollow: k("person-follow", 60007),
  personOutline: k("person-outline", 60007),
  personFilled: k("person-filled", 60007),
  gitBranch: k("git-branch", 60008),
  gitBranchCreate: k("git-branch-create", 60008),
  gitBranchDelete: k("git-branch-delete", 60008),
  sourceControl: k("source-control", 60008),
  mirror: k("mirror", 60009),
  mirrorPublic: k("mirror-public", 60009),
  star: k("star", 60010),
  starAdd: k("star-add", 60010),
  starDelete: k("star-delete", 60010),
  starEmpty: k("star-empty", 60010),
  comment: k("comment", 60011),
  commentAdd: k("comment-add", 60011),
  alert: k("alert", 60012),
  warning: k("warning", 60012),
  search: k("search", 60013),
  searchSave: k("search-save", 60013),
  logOut: k("log-out", 60014),
  signOut: k("sign-out", 60014),
  logIn: k("log-in", 60015),
  signIn: k("sign-in", 60015),
  eye: k("eye", 60016),
  eyeUnwatch: k("eye-unwatch", 60016),
  eyeWatch: k("eye-watch", 60016),
  circleFilled: k("circle-filled", 60017),
  primitiveDot: k("primitive-dot", 60017),
  closeDirty: k("close-dirty", 60017),
  debugBreakpoint: k("debug-breakpoint", 60017),
  debugBreakpointDisabled: k("debug-breakpoint-disabled", 60017),
  debugHint: k("debug-hint", 60017),
  terminalDecorationSuccess: k("terminal-decoration-success", 60017),
  primitiveSquare: k("primitive-square", 60018),
  edit: k("edit", 60019),
  pencil: k("pencil", 60019),
  info: k("info", 60020),
  issueOpened: k("issue-opened", 60020),
  gistPrivate: k("gist-private", 60021),
  gitForkPrivate: k("git-fork-private", 60021),
  lock: k("lock", 60021),
  mirrorPrivate: k("mirror-private", 60021),
  close: k("close", 60022),
  removeClose: k("remove-close", 60022),
  x: k("x", 60022),
  repoSync: k("repo-sync", 60023),
  sync: k("sync", 60023),
  clone: k("clone", 60024),
  desktopDownload: k("desktop-download", 60024),
  beaker: k("beaker", 60025),
  microscope: k("microscope", 60025),
  vm: k("vm", 60026),
  deviceDesktop: k("device-desktop", 60026),
  file: k("file", 60027),
  fileText: k("file-text", 60027),
  more: k("more", 60028),
  ellipsis: k("ellipsis", 60028),
  kebabHorizontal: k("kebab-horizontal", 60028),
  mailReply: k("mail-reply", 60029),
  reply: k("reply", 60029),
  organization: k("organization", 60030),
  organizationFilled: k("organization-filled", 60030),
  organizationOutline: k("organization-outline", 60030),
  newFile: k("new-file", 60031),
  fileAdd: k("file-add", 60031),
  newFolder: k("new-folder", 60032),
  fileDirectoryCreate: k("file-directory-create", 60032),
  trash: k("trash", 60033),
  trashcan: k("trashcan", 60033),
  history: k("history", 60034),
  clock: k("clock", 60034),
  folder: k("folder", 60035),
  fileDirectory: k("file-directory", 60035),
  symbolFolder: k("symbol-folder", 60035),
  logoGithub: k("logo-github", 60036),
  markGithub: k("mark-github", 60036),
  github: k("github", 60036),
  terminal: k("terminal", 60037),
  console: k("console", 60037),
  repl: k("repl", 60037),
  zap: k("zap", 60038),
  symbolEvent: k("symbol-event", 60038),
  error: k("error", 60039),
  stop: k("stop", 60039),
  variable: k("variable", 60040),
  symbolVariable: k("symbol-variable", 60040),
  array: k("array", 60042),
  symbolArray: k("symbol-array", 60042),
  symbolModule: k("symbol-module", 60043),
  symbolPackage: k("symbol-package", 60043),
  symbolNamespace: k("symbol-namespace", 60043),
  symbolObject: k("symbol-object", 60043),
  symbolMethod: k("symbol-method", 60044),
  symbolFunction: k("symbol-function", 60044),
  symbolConstructor: k("symbol-constructor", 60044),
  symbolBoolean: k("symbol-boolean", 60047),
  symbolNull: k("symbol-null", 60047),
  symbolNumeric: k("symbol-numeric", 60048),
  symbolNumber: k("symbol-number", 60048),
  symbolStructure: k("symbol-structure", 60049),
  symbolStruct: k("symbol-struct", 60049),
  symbolParameter: k("symbol-parameter", 60050),
  symbolTypeParameter: k("symbol-type-parameter", 60050),
  symbolKey: k("symbol-key", 60051),
  symbolText: k("symbol-text", 60051),
  symbolReference: k("symbol-reference", 60052),
  goToFile: k("go-to-file", 60052),
  symbolEnum: k("symbol-enum", 60053),
  symbolValue: k("symbol-value", 60053),
  symbolRuler: k("symbol-ruler", 60054),
  symbolUnit: k("symbol-unit", 60054),
  activateBreakpoints: k("activate-breakpoints", 60055),
  archive: k("archive", 60056),
  arrowBoth: k("arrow-both", 60057),
  arrowDown: k("arrow-down", 60058),
  arrowLeft: k("arrow-left", 60059),
  arrowRight: k("arrow-right", 60060),
  arrowSmallDown: k("arrow-small-down", 60061),
  arrowSmallLeft: k("arrow-small-left", 60062),
  arrowSmallRight: k("arrow-small-right", 60063),
  arrowSmallUp: k("arrow-small-up", 60064),
  arrowUp: k("arrow-up", 60065),
  bell: k("bell", 60066),
  bold: k("bold", 60067),
  book: k("book", 60068),
  bookmark: k("bookmark", 60069),
  debugBreakpointConditionalUnverified: k("debug-breakpoint-conditional-unverified", 60070),
  debugBreakpointConditional: k("debug-breakpoint-conditional", 60071),
  debugBreakpointConditionalDisabled: k("debug-breakpoint-conditional-disabled", 60071),
  debugBreakpointDataUnverified: k("debug-breakpoint-data-unverified", 60072),
  debugBreakpointData: k("debug-breakpoint-data", 60073),
  debugBreakpointDataDisabled: k("debug-breakpoint-data-disabled", 60073),
  debugBreakpointLogUnverified: k("debug-breakpoint-log-unverified", 60074),
  debugBreakpointLog: k("debug-breakpoint-log", 60075),
  debugBreakpointLogDisabled: k("debug-breakpoint-log-disabled", 60075),
  briefcase: k("briefcase", 60076),
  broadcast: k("broadcast", 60077),
  browser: k("browser", 60078),
  bug: k("bug", 60079),
  calendar: k("calendar", 60080),
  caseSensitive: k("case-sensitive", 60081),
  check: k("check", 60082),
  checklist: k("checklist", 60083),
  chevronDown: k("chevron-down", 60084),
  chevronLeft: k("chevron-left", 60085),
  chevronRight: k("chevron-right", 60086),
  chevronUp: k("chevron-up", 60087),
  chromeClose: k("chrome-close", 60088),
  chromeMaximize: k("chrome-maximize", 60089),
  chromeMinimize: k("chrome-minimize", 60090),
  chromeRestore: k("chrome-restore", 60091),
  circleOutline: k("circle-outline", 60092),
  circle: k("circle", 60092),
  debugBreakpointUnverified: k("debug-breakpoint-unverified", 60092),
  terminalDecorationIncomplete: k("terminal-decoration-incomplete", 60092),
  circleSlash: k("circle-slash", 60093),
  circuitBoard: k("circuit-board", 60094),
  clearAll: k("clear-all", 60095),
  clippy: k("clippy", 60096),
  closeAll: k("close-all", 60097),
  cloudDownload: k("cloud-download", 60098),
  cloudUpload: k("cloud-upload", 60099),
  code: k("code", 60100),
  collapseAll: k("collapse-all", 60101),
  colorMode: k("color-mode", 60102),
  commentDiscussion: k("comment-discussion", 60103),
  creditCard: k("credit-card", 60105),
  dash: k("dash", 60108),
  dashboard: k("dashboard", 60109),
  database: k("database", 60110),
  debugContinue: k("debug-continue", 60111),
  debugDisconnect: k("debug-disconnect", 60112),
  debugPause: k("debug-pause", 60113),
  debugRestart: k("debug-restart", 60114),
  debugStart: k("debug-start", 60115),
  debugStepInto: k("debug-step-into", 60116),
  debugStepOut: k("debug-step-out", 60117),
  debugStepOver: k("debug-step-over", 60118),
  debugStop: k("debug-stop", 60119),
  debug: k("debug", 60120),
  deviceCameraVideo: k("device-camera-video", 60121),
  deviceCamera: k("device-camera", 60122),
  deviceMobile: k("device-mobile", 60123),
  diffAdded: k("diff-added", 60124),
  diffIgnored: k("diff-ignored", 60125),
  diffModified: k("diff-modified", 60126),
  diffRemoved: k("diff-removed", 60127),
  diffRenamed: k("diff-renamed", 60128),
  diff: k("diff", 60129),
  diffSidebyside: k("diff-sidebyside", 60129),
  discard: k("discard", 60130),
  editorLayout: k("editor-layout", 60131),
  emptyWindow: k("empty-window", 60132),
  exclude: k("exclude", 60133),
  extensions: k("extensions", 60134),
  eyeClosed: k("eye-closed", 60135),
  fileBinary: k("file-binary", 60136),
  fileCode: k("file-code", 60137),
  fileMedia: k("file-media", 60138),
  filePdf: k("file-pdf", 60139),
  fileSubmodule: k("file-submodule", 60140),
  fileSymlinkDirectory: k("file-symlink-directory", 60141),
  fileSymlinkFile: k("file-symlink-file", 60142),
  fileZip: k("file-zip", 60143),
  files: k("files", 60144),
  filter: k("filter", 60145),
  flame: k("flame", 60146),
  foldDown: k("fold-down", 60147),
  foldUp: k("fold-up", 60148),
  fold: k("fold", 60149),
  folderActive: k("folder-active", 60150),
  folderOpened: k("folder-opened", 60151),
  gear: k("gear", 60152),
  gift: k("gift", 60153),
  gistSecret: k("gist-secret", 60154),
  gist: k("gist", 60155),
  gitCommit: k("git-commit", 60156),
  gitCompare: k("git-compare", 60157),
  compareChanges: k("compare-changes", 60157),
  gitMerge: k("git-merge", 60158),
  githubAction: k("github-action", 60159),
  githubAlt: k("github-alt", 60160),
  globe: k("globe", 60161),
  grabber: k("grabber", 60162),
  graph: k("graph", 60163),
  gripper: k("gripper", 60164),
  heart: k("heart", 60165),
  home: k("home", 60166),
  horizontalRule: k("horizontal-rule", 60167),
  hubot: k("hubot", 60168),
  inbox: k("inbox", 60169),
  issueReopened: k("issue-reopened", 60171),
  issues: k("issues", 60172),
  italic: k("italic", 60173),
  jersey: k("jersey", 60174),
  json: k("json", 60175),
  kebabVertical: k("kebab-vertical", 60176),
  key: k("key", 60177),
  law: k("law", 60178),
  lightbulbAutofix: k("lightbulb-autofix", 60179),
  linkExternal: k("link-external", 60180),
  link: k("link", 60181),
  listOrdered: k("list-ordered", 60182),
  listUnordered: k("list-unordered", 60183),
  liveShare: k("live-share", 60184),
  loading: k("loading", 60185),
  location: k("location", 60186),
  mailRead: k("mail-read", 60187),
  mail: k("mail", 60188),
  markdown: k("markdown", 60189),
  megaphone: k("megaphone", 60190),
  mention: k("mention", 60191),
  milestone: k("milestone", 60192),
  gitPullRequestMilestone: k("git-pull-request-milestone", 60192),
  mortarBoard: k("mortar-board", 60193),
  move: k("move", 60194),
  multipleWindows: k("multiple-windows", 60195),
  mute: k("mute", 60196),
  noNewline: k("no-newline", 60197),
  note: k("note", 60198),
  octoface: k("octoface", 60199),
  openPreview: k("open-preview", 60200),
  package: k("package", 60201),
  paintcan: k("paintcan", 60202),
  pin: k("pin", 60203),
  play: k("play", 60204),
  run: k("run", 60204),
  plug: k("plug", 60205),
  preserveCase: k("preserve-case", 60206),
  preview: k("preview", 60207),
  project: k("project", 60208),
  pulse: k("pulse", 60209),
  question: k("question", 60210),
  quote: k("quote", 60211),
  radioTower: k("radio-tower", 60212),
  reactions: k("reactions", 60213),
  references: k("references", 60214),
  refresh: k("refresh", 60215),
  regex: k("regex", 60216),
  remoteExplorer: k("remote-explorer", 60217),
  remote: k("remote", 60218),
  remove: k("remove", 60219),
  replaceAll: k("replace-all", 60220),
  replace: k("replace", 60221),
  repoClone: k("repo-clone", 60222),
  repoForcePush: k("repo-force-push", 60223),
  repoPull: k("repo-pull", 60224),
  repoPush: k("repo-push", 60225),
  report: k("report", 60226),
  requestChanges: k("request-changes", 60227),
  rocket: k("rocket", 60228),
  rootFolderOpened: k("root-folder-opened", 60229),
  rootFolder: k("root-folder", 60230),
  rss: k("rss", 60231),
  ruby: k("ruby", 60232),
  saveAll: k("save-all", 60233),
  saveAs: k("save-as", 60234),
  save: k("save", 60235),
  screenFull: k("screen-full", 60236),
  screenNormal: k("screen-normal", 60237),
  searchStop: k("search-stop", 60238),
  server: k("server", 60240),
  settingsGear: k("settings-gear", 60241),
  settings: k("settings", 60242),
  shield: k("shield", 60243),
  smiley: k("smiley", 60244),
  sortPrecedence: k("sort-precedence", 60245),
  splitHorizontal: k("split-horizontal", 60246),
  splitVertical: k("split-vertical", 60247),
  squirrel: k("squirrel", 60248),
  starFull: k("star-full", 60249),
  starHalf: k("star-half", 60250),
  symbolClass: k("symbol-class", 60251),
  symbolColor: k("symbol-color", 60252),
  symbolConstant: k("symbol-constant", 60253),
  symbolEnumMember: k("symbol-enum-member", 60254),
  symbolField: k("symbol-field", 60255),
  symbolFile: k("symbol-file", 60256),
  symbolInterface: k("symbol-interface", 60257),
  symbolKeyword: k("symbol-keyword", 60258),
  symbolMisc: k("symbol-misc", 60259),
  symbolOperator: k("symbol-operator", 60260),
  symbolProperty: k("symbol-property", 60261),
  wrench: k("wrench", 60261),
  wrenchSubaction: k("wrench-subaction", 60261),
  symbolSnippet: k("symbol-snippet", 60262),
  tasklist: k("tasklist", 60263),
  telescope: k("telescope", 60264),
  textSize: k("text-size", 60265),
  threeBars: k("three-bars", 60266),
  thumbsdown: k("thumbsdown", 60267),
  thumbsup: k("thumbsup", 60268),
  tools: k("tools", 60269),
  triangleDown: k("triangle-down", 60270),
  triangleLeft: k("triangle-left", 60271),
  triangleRight: k("triangle-right", 60272),
  triangleUp: k("triangle-up", 60273),
  twitter: k("twitter", 60274),
  unfold: k("unfold", 60275),
  unlock: k("unlock", 60276),
  unmute: k("unmute", 60277),
  unverified: k("unverified", 60278),
  verified: k("verified", 60279),
  versions: k("versions", 60280),
  vmActive: k("vm-active", 60281),
  vmOutline: k("vm-outline", 60282),
  vmRunning: k("vm-running", 60283),
  watch: k("watch", 60284),
  whitespace: k("whitespace", 60285),
  wholeWord: k("whole-word", 60286),
  window: k("window", 60287),
  wordWrap: k("word-wrap", 60288),
  zoomIn: k("zoom-in", 60289),
  zoomOut: k("zoom-out", 60290),
  listFilter: k("list-filter", 60291),
  listFlat: k("list-flat", 60292),
  listSelection: k("list-selection", 60293),
  selection: k("selection", 60293),
  listTree: k("list-tree", 60294),
  debugBreakpointFunctionUnverified: k("debug-breakpoint-function-unverified", 60295),
  debugBreakpointFunction: k("debug-breakpoint-function", 60296),
  debugBreakpointFunctionDisabled: k("debug-breakpoint-function-disabled", 60296),
  debugStackframeActive: k("debug-stackframe-active", 60297),
  circleSmallFilled: k("circle-small-filled", 60298),
  debugStackframeDot: k("debug-stackframe-dot", 60298),
  terminalDecorationMark: k("terminal-decoration-mark", 60298),
  debugStackframe: k("debug-stackframe", 60299),
  debugStackframeFocused: k("debug-stackframe-focused", 60299),
  debugBreakpointUnsupported: k("debug-breakpoint-unsupported", 60300),
  symbolString: k("symbol-string", 60301),
  debugReverseContinue: k("debug-reverse-continue", 60302),
  debugStepBack: k("debug-step-back", 60303),
  debugRestartFrame: k("debug-restart-frame", 60304),
  debugAlt: k("debug-alt", 60305),
  callIncoming: k("call-incoming", 60306),
  callOutgoing: k("call-outgoing", 60307),
  menu: k("menu", 60308),
  expandAll: k("expand-all", 60309),
  feedback: k("feedback", 60310),
  gitPullRequestReviewer: k("git-pull-request-reviewer", 60310),
  groupByRefType: k("group-by-ref-type", 60311),
  ungroupByRefType: k("ungroup-by-ref-type", 60312),
  account: k("account", 60313),
  gitPullRequestAssignee: k("git-pull-request-assignee", 60313),
  bellDot: k("bell-dot", 60314),
  debugConsole: k("debug-console", 60315),
  library: k("library", 60316),
  output: k("output", 60317),
  runAll: k("run-all", 60318),
  syncIgnored: k("sync-ignored", 60319),
  pinned: k("pinned", 60320),
  githubInverted: k("github-inverted", 60321),
  serverProcess: k("server-process", 60322),
  serverEnvironment: k("server-environment", 60323),
  pass: k("pass", 60324),
  issueClosed: k("issue-closed", 60324),
  stopCircle: k("stop-circle", 60325),
  playCircle: k("play-circle", 60326),
  record: k("record", 60327),
  debugAltSmall: k("debug-alt-small", 60328),
  vmConnect: k("vm-connect", 60329),
  cloud: k("cloud", 60330),
  merge: k("merge", 60331),
  export: k("export", 60332),
  graphLeft: k("graph-left", 60333),
  magnet: k("magnet", 60334),
  notebook: k("notebook", 60335),
  redo: k("redo", 60336),
  checkAll: k("check-all", 60337),
  pinnedDirty: k("pinned-dirty", 60338),
  passFilled: k("pass-filled", 60339),
  circleLargeFilled: k("circle-large-filled", 60340),
  circleLarge: k("circle-large", 60341),
  circleLargeOutline: k("circle-large-outline", 60341),
  combine: k("combine", 60342),
  gather: k("gather", 60342),
  table: k("table", 60343),
  variableGroup: k("variable-group", 60344),
  typeHierarchy: k("type-hierarchy", 60345),
  typeHierarchySub: k("type-hierarchy-sub", 60346),
  typeHierarchySuper: k("type-hierarchy-super", 60347),
  gitPullRequestCreate: k("git-pull-request-create", 60348),
  runAbove: k("run-above", 60349),
  runBelow: k("run-below", 60350),
  notebookTemplate: k("notebook-template", 60351),
  debugRerun: k("debug-rerun", 60352),
  workspaceTrusted: k("workspace-trusted", 60353),
  workspaceUntrusted: k("workspace-untrusted", 60354),
  workspaceUnknown: k("workspace-unknown", 60355),
  terminalCmd: k("terminal-cmd", 60356),
  terminalDebian: k("terminal-debian", 60357),
  terminalLinux: k("terminal-linux", 60358),
  terminalPowershell: k("terminal-powershell", 60359),
  terminalTmux: k("terminal-tmux", 60360),
  terminalUbuntu: k("terminal-ubuntu", 60361),
  terminalBash: k("terminal-bash", 60362),
  arrowSwap: k("arrow-swap", 60363),
  copy: k("copy", 60364),
  personAdd: k("person-add", 60365),
  filterFilled: k("filter-filled", 60366),
  wand: k("wand", 60367),
  debugLineByLine: k("debug-line-by-line", 60368),
  inspect: k("inspect", 60369),
  layers: k("layers", 60370),
  layersDot: k("layers-dot", 60371),
  layersActive: k("layers-active", 60372),
  compass: k("compass", 60373),
  compassDot: k("compass-dot", 60374),
  compassActive: k("compass-active", 60375),
  azure: k("azure", 60376),
  issueDraft: k("issue-draft", 60377),
  gitPullRequestClosed: k("git-pull-request-closed", 60378),
  gitPullRequestDraft: k("git-pull-request-draft", 60379),
  debugAll: k("debug-all", 60380),
  debugCoverage: k("debug-coverage", 60381),
  runErrors: k("run-errors", 60382),
  folderLibrary: k("folder-library", 60383),
  debugContinueSmall: k("debug-continue-small", 60384),
  beakerStop: k("beaker-stop", 60385),
  graphLine: k("graph-line", 60386),
  graphScatter: k("graph-scatter", 60387),
  pieChart: k("pie-chart", 60388),
  bracket: k("bracket", 60175),
  bracketDot: k("bracket-dot", 60389),
  bracketError: k("bracket-error", 60390),
  lockSmall: k("lock-small", 60391),
  azureDevops: k("azure-devops", 60392),
  verifiedFilled: k("verified-filled", 60393),
  newline: k("newline", 60394),
  layout: k("layout", 60395),
  layoutActivitybarLeft: k("layout-activitybar-left", 60396),
  layoutActivitybarRight: k("layout-activitybar-right", 60397),
  layoutPanelLeft: k("layout-panel-left", 60398),
  layoutPanelCenter: k("layout-panel-center", 60399),
  layoutPanelJustify: k("layout-panel-justify", 60400),
  layoutPanelRight: k("layout-panel-right", 60401),
  layoutPanel: k("layout-panel", 60402),
  layoutSidebarLeft: k("layout-sidebar-left", 60403),
  layoutSidebarRight: k("layout-sidebar-right", 60404),
  layoutStatusbar: k("layout-statusbar", 60405),
  layoutMenubar: k("layout-menubar", 60406),
  layoutCentered: k("layout-centered", 60407),
  target: k("target", 60408),
  indent: k("indent", 60409),
  recordSmall: k("record-small", 60410),
  errorSmall: k("error-small", 60411),
  terminalDecorationError: k("terminal-decoration-error", 60411),
  arrowCircleDown: k("arrow-circle-down", 60412),
  arrowCircleLeft: k("arrow-circle-left", 60413),
  arrowCircleRight: k("arrow-circle-right", 60414),
  arrowCircleUp: k("arrow-circle-up", 60415),
  layoutSidebarRightOff: k("layout-sidebar-right-off", 60416),
  layoutPanelOff: k("layout-panel-off", 60417),
  layoutSidebarLeftOff: k("layout-sidebar-left-off", 60418),
  blank: k("blank", 60419),
  heartFilled: k("heart-filled", 60420),
  map: k("map", 60421),
  mapHorizontal: k("map-horizontal", 60421),
  foldHorizontal: k("fold-horizontal", 60421),
  mapFilled: k("map-filled", 60422),
  mapHorizontalFilled: k("map-horizontal-filled", 60422),
  foldHorizontalFilled: k("fold-horizontal-filled", 60422),
  circleSmall: k("circle-small", 60423),
  bellSlash: k("bell-slash", 60424),
  bellSlashDot: k("bell-slash-dot", 60425),
  commentUnresolved: k("comment-unresolved", 60426),
  gitPullRequestGoToChanges: k("git-pull-request-go-to-changes", 60427),
  gitPullRequestNewChanges: k("git-pull-request-new-changes", 60428),
  searchFuzzy: k("search-fuzzy", 60429),
  commentDraft: k("comment-draft", 60430),
  send: k("send", 60431),
  sparkle: k("sparkle", 60432),
  insert: k("insert", 60433),
  mic: k("mic", 60434),
  thumbsdownFilled: k("thumbsdown-filled", 60435),
  thumbsupFilled: k("thumbsup-filled", 60436),
  coffee: k("coffee", 60437),
  snake: k("snake", 60438),
  game: k("game", 60439),
  vr: k("vr", 60440),
  chip: k("chip", 60441),
  piano: k("piano", 60442),
  music: k("music", 60443),
  micFilled: k("mic-filled", 60444),
  repoFetch: k("repo-fetch", 60445),
  copilot: k("copilot", 60446),
  lightbulbSparkle: k("lightbulb-sparkle", 60447),
  robot: k("robot", 60448),
  sparkleFilled: k("sparkle-filled", 60449),
  diffSingle: k("diff-single", 60450),
  diffMultiple: k("diff-multiple", 60451),
  surroundWith: k("surround-with", 60452),
  share: k("share", 60453),
  gitStash: k("git-stash", 60454),
  gitStashApply: k("git-stash-apply", 60455),
  gitStashPop: k("git-stash-pop", 60456),
  vscode: k("vscode", 60457),
  vscodeInsiders: k("vscode-insiders", 60458),
  codeOss: k("code-oss", 60459),
  runCoverage: k("run-coverage", 60460),
  runAllCoverage: k("run-all-coverage", 60461),
  coverage: k("coverage", 60462),
  githubProject: k("github-project", 60463),
  mapVertical: k("map-vertical", 60464),
  foldVertical: k("fold-vertical", 60464),
  mapVerticalFilled: k("map-vertical-filled", 60465),
  foldVerticalFilled: k("fold-vertical-filled", 60465),
  goToSearch: k("go-to-search", 60466),
  percentage: k("percentage", 60467),
  sortPercentage: k("sort-percentage", 60467),
  attach: k("attach", 60468)
}, u0t = {
  dialogError: k("dialog-error", "error"),
  dialogWarning: k("dialog-warning", "warning"),
  dialogInfo: k("dialog-info", "info"),
  dialogClose: k("dialog-close", "close"),
  treeItemExpanded: k("tree-item-expanded", "chevron-down"),
  // collapsed is done with rotation
  treeFilterOnTypeOn: k("tree-filter-on-type-on", "list-filter"),
  treeFilterOnTypeOff: k("tree-filter-on-type-off", "list-selection"),
  treeFilterClear: k("tree-filter-clear", "close"),
  treeItemLoading: k("tree-item-loading", "loading"),
  menuSelection: k("menu-selection", "check"),
  menuSubmenu: k("menu-submenu", "chevron-right"),
  menuBarMore: k("menubar-more", "more"),
  scrollbarButtonLeft: k("scrollbar-button-left", "triangle-left"),
  scrollbarButtonRight: k("scrollbar-button-right", "triangle-right"),
  scrollbarButtonUp: k("scrollbar-button-up", "triangle-up"),
  scrollbarButtonDown: k("scrollbar-button-down", "triangle-down"),
  toolBarMore: k("toolbar-more", "more"),
  quickInputBack: k("quick-input-back", "arrow-left"),
  dropDownButton: k("drop-down-button", 60084),
  symbolCustomColor: k("symbol-customcolor", 60252),
  exportIcon: k("export", 60332),
  workspaceUnspecified: k("workspace-unspecified", 60355),
  newLine: k("newline", 60394),
  thumbsDownFilled: k("thumbsdown-filled", 60435),
  thumbsUpFilled: k("thumbsup-filled", 60436),
  gitFetch: k("git-fetch", 60445),
  lightbulbSparkleAutofix: k("lightbulb-sparkle-autofix", 60447),
  debugBreakpointPending: k("debug-breakpoint-pending", 60377)
}, ke = {
  ...d0t,
  ...u0t
};
let f0t = class {
  constructor() {
    this._tokenizationSupports = /* @__PURE__ */ new Map(), this._factories = /* @__PURE__ */ new Map(), this._onDidChange = new $(), this.onDidChange = this._onDidChange.event, this._colorMap = null;
  }
  handleChange(e) {
    this._onDidChange.fire({
      changedLanguages: e,
      changedColorMap: !1
    });
  }
  register(e, t) {
    return this._tokenizationSupports.set(e, t), this.handleChange([e]), ht(() => {
      this._tokenizationSupports.get(e) === t && (this._tokenizationSupports.delete(e), this.handleChange([e]));
    });
  }
  get(e) {
    return this._tokenizationSupports.get(e) || null;
  }
  registerFactory(e, t) {
    this._factories.get(e)?.dispose();
    const n = new p0t(this, e, t);
    return this._factories.set(e, n), ht(() => {
      const i = this._factories.get(e);
      !i || i !== n || (this._factories.delete(e), i.dispose());
    });
  }
  async getOrCreate(e) {
    const t = this.get(e);
    if (t)
      return t;
    const n = this._factories.get(e);
    return !n || n.isResolved ? null : (await n.resolve(), this.get(e));
  }
  isResolved(e) {
    if (this.get(e))
      return !0;
    const n = this._factories.get(e);
    return !!(!n || n.isResolved);
  }
  setColorMap(e) {
    this._colorMap = e, this._onDidChange.fire({
      changedLanguages: Array.from(this._tokenizationSupports.keys()),
      changedColorMap: !0
    });
  }
  getColorMap() {
    return this._colorMap;
  }
  getDefaultBackground() {
    return this._colorMap && this._colorMap.length > 2 ? this._colorMap[
      2
      /* ColorId.DefaultBackground */
    ] : null;
  }
};
class p0t extends me {
  get isResolved() {
    return this._isResolved;
  }
  constructor(e, t, n) {
    super(), this._registry = e, this._languageId = t, this._factory = n, this._isDisposed = !1, this._resolvePromise = null, this._isResolved = !1;
  }
  dispose() {
    this._isDisposed = !0, super.dispose();
  }
  async resolve() {
    return this._resolvePromise || (this._resolvePromise = this._create()), this._resolvePromise;
  }
  async _create() {
    const e = await this._factory.tokenizationSupport;
    this._isResolved = !0, e && !this._isDisposed && this._register(this._registry.register(this._languageId, e));
  }
}
let V3 = class {
  constructor(e, t, n) {
    this.offset = e, this.type = t, this.language = n, this._tokenBrand = void 0;
  }
  toString() {
    return "(" + this.offset + ", " + this.type + ")";
  }
};
class TI {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._tokenizationResultBrand = void 0;
  }
}
class O7 {
  constructor(e, t) {
    this.tokens = e, this.endState = t, this._encodedTokenizationResultBrand = void 0;
  }
}
var yve;
(function(r) {
  r[r.Increase = 0] = "Increase", r[r.Decrease = 1] = "Decrease";
})(yve || (yve = {}));
var Cve;
(function(r) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ke.symbolMethod), e.set(1, ke.symbolFunction), e.set(2, ke.symbolConstructor), e.set(3, ke.symbolField), e.set(4, ke.symbolVariable), e.set(5, ke.symbolClass), e.set(6, ke.symbolStruct), e.set(7, ke.symbolInterface), e.set(8, ke.symbolModule), e.set(9, ke.symbolProperty), e.set(10, ke.symbolEvent), e.set(11, ke.symbolOperator), e.set(12, ke.symbolUnit), e.set(13, ke.symbolValue), e.set(15, ke.symbolEnum), e.set(14, ke.symbolConstant), e.set(15, ke.symbolEnum), e.set(16, ke.symbolEnumMember), e.set(17, ke.symbolKeyword), e.set(27, ke.symbolSnippet), e.set(18, ke.symbolText), e.set(19, ke.symbolColor), e.set(20, ke.symbolFile), e.set(21, ke.symbolReference), e.set(22, ke.symbolCustomColor), e.set(23, ke.symbolFolder), e.set(24, ke.symbolTypeParameter), e.set(25, ke.account), e.set(26, ke.issues);
  function t(s) {
    let o = e.get(s);
    return o || (console.info("No codicon found for CompletionItemKind " + s), o = ke.symbolProperty), o;
  }
  r.toIcon = t;
  const n = /* @__PURE__ */ new Map();
  n.set(
    "method",
    0
    /* CompletionItemKind.Method */
  ), n.set(
    "function",
    1
    /* CompletionItemKind.Function */
  ), n.set(
    "constructor",
    2
    /* CompletionItemKind.Constructor */
  ), n.set(
    "field",
    3
    /* CompletionItemKind.Field */
  ), n.set(
    "variable",
    4
    /* CompletionItemKind.Variable */
  ), n.set(
    "class",
    5
    /* CompletionItemKind.Class */
  ), n.set(
    "struct",
    6
    /* CompletionItemKind.Struct */
  ), n.set(
    "interface",
    7
    /* CompletionItemKind.Interface */
  ), n.set(
    "module",
    8
    /* CompletionItemKind.Module */
  ), n.set(
    "property",
    9
    /* CompletionItemKind.Property */
  ), n.set(
    "event",
    10
    /* CompletionItemKind.Event */
  ), n.set(
    "operator",
    11
    /* CompletionItemKind.Operator */
  ), n.set(
    "unit",
    12
    /* CompletionItemKind.Unit */
  ), n.set(
    "value",
    13
    /* CompletionItemKind.Value */
  ), n.set(
    "constant",
    14
    /* CompletionItemKind.Constant */
  ), n.set(
    "enum",
    15
    /* CompletionItemKind.Enum */
  ), n.set(
    "enum-member",
    16
    /* CompletionItemKind.EnumMember */
  ), n.set(
    "enumMember",
    16
    /* CompletionItemKind.EnumMember */
  ), n.set(
    "keyword",
    17
    /* CompletionItemKind.Keyword */
  ), n.set(
    "snippet",
    27
    /* CompletionItemKind.Snippet */
  ), n.set(
    "text",
    18
    /* CompletionItemKind.Text */
  ), n.set(
    "color",
    19
    /* CompletionItemKind.Color */
  ), n.set(
    "file",
    20
    /* CompletionItemKind.File */
  ), n.set(
    "reference",
    21
    /* CompletionItemKind.Reference */
  ), n.set(
    "customcolor",
    22
    /* CompletionItemKind.Customcolor */
  ), n.set(
    "folder",
    23
    /* CompletionItemKind.Folder */
  ), n.set(
    "type-parameter",
    24
    /* CompletionItemKind.TypeParameter */
  ), n.set(
    "typeParameter",
    24
    /* CompletionItemKind.TypeParameter */
  ), n.set(
    "account",
    25
    /* CompletionItemKind.User */
  ), n.set(
    "issue",
    26
    /* CompletionItemKind.Issue */
  );
  function i(s, o) {
    let a = n.get(s);
    return typeof a > "u" && !o && (a = 9), a;
  }
  r.fromString = i;
})(Cve || (Cve = {}));
var Eve;
(function(r) {
  r[r.Automatic = 0] = "Automatic", r[r.Explicit = 1] = "Explicit";
})(Eve || (Eve = {}));
class g0t {
  constructor(e, t, n, i) {
    this.range = e, this.text = t, this.completionKind = n, this.isSnippetText = i;
  }
  equals(e) {
    return Q.lift(this.range).equalsRange(e.range) && this.text === e.text && this.completionKind === e.completionKind && this.isSnippetText === e.isSnippetText;
  }
}
var _ve;
(function(r) {
  r[r.Automatic = 0] = "Automatic", r[r.PasteAs = 1] = "PasteAs";
})(_ve || (_ve = {}));
var xve;
(function(r) {
  r[r.Invoke = 1] = "Invoke", r[r.TriggerCharacter = 2] = "TriggerCharacter", r[r.ContentChange = 3] = "ContentChange";
})(xve || (xve = {}));
var Sve;
(function(r) {
  r[r.Text = 0] = "Text", r[r.Read = 1] = "Read", r[r.Write = 2] = "Write";
})(Sve || (Sve = {}));
C("Array", "array"), C("Boolean", "boolean"), C("Class", "class"), C("Constant", "constant"), C("Constructor", "constructor"), C("Enum", "enumeration"), C("EnumMember", "enumeration member"), C("Event", "event"), C("Field", "field"), C("File", "file"), C("Function", "function"), C("Interface", "interface"), C("Key", "key"), C("Method", "method"), C("Module", "module"), C("Namespace", "namespace"), C("Null", "null"), C("Number", "number"), C("Object", "object"), C("Operator", "operator"), C("Package", "package"), C("Property", "property"), C("String", "string"), C("Struct", "struct"), C("TypeParameter", "type parameter"), C("Variable", "variable");
var VM;
(function(r) {
  const e = /* @__PURE__ */ new Map();
  e.set(0, ke.symbolFile), e.set(1, ke.symbolModule), e.set(2, ke.symbolNamespace), e.set(3, ke.symbolPackage), e.set(4, ke.symbolClass), e.set(5, ke.symbolMethod), e.set(6, ke.symbolProperty), e.set(7, ke.symbolField), e.set(8, ke.symbolConstructor), e.set(9, ke.symbolEnum), e.set(10, ke.symbolInterface), e.set(11, ke.symbolFunction), e.set(12, ke.symbolVariable), e.set(13, ke.symbolConstant), e.set(14, ke.symbolString), e.set(15, ke.symbolNumber), e.set(16, ke.symbolBoolean), e.set(17, ke.symbolArray), e.set(18, ke.symbolObject), e.set(19, ke.symbolKey), e.set(20, ke.symbolNull), e.set(21, ke.symbolEnumMember), e.set(22, ke.symbolStruct), e.set(23, ke.symbolEvent), e.set(24, ke.symbolOperator), e.set(25, ke.symbolTypeParameter);
  function t(n) {
    let i = e.get(n);
    return i || (console.info("No codicon found for SymbolKind " + n), i = ke.symbolProperty), i;
  }
  r.toIcon = t;
})(VM || (VM = {}));
class Gh {
  static {
    this.Comment = new Gh("comment");
  }
  static {
    this.Imports = new Gh("imports");
  }
  static {
    this.Region = new Gh("region");
  }
  /**
   * Returns a {@link FoldingRangeKind} for the given value.
   *
   * @param value of the kind.
   */
  static fromValue(e) {
    switch (e) {
      case "comment":
        return Gh.Comment;
      case "imports":
        return Gh.Imports;
      case "region":
        return Gh.Region;
    }
    return new Gh(e);
  }
  /**
   * Creates a new {@link FoldingRangeKind}.
   *
   * @param value of the kind.
   */
  constructor(e) {
    this.value = e;
  }
}
var Mve;
(function(r) {
  r[r.AIGenerated = 1] = "AIGenerated";
})(Mve || (Mve = {}));
var Dve;
(function(r) {
  r[r.Invoke = 0] = "Invoke", r[r.Automatic = 1] = "Automatic";
})(Dve || (Dve = {}));
var Lve;
(function(r) {
  function e(t) {
    return !t || typeof t != "object" ? !1 : typeof t.id == "string" && typeof t.title == "string";
  }
  r.is = e;
})(Lve || (Lve = {}));
var kve;
(function(r) {
  r[r.Type = 1] = "Type", r[r.Parameter = 2] = "Parameter";
})(kve || (kve = {}));
class m0t {
  constructor(e) {
    this.createSupport = e, this._tokenizationSupport = null;
  }
  dispose() {
    this._tokenizationSupport && this._tokenizationSupport.then((e) => {
      e && e.dispose();
    });
  }
  get tokenizationSupport() {
    return this._tokenizationSupport || (this._tokenizationSupport = this.createSupport()), this._tokenizationSupport;
  }
}
const xi = new f0t();
var Nve;
(function(r) {
  r[r.Invoke = 0] = "Invoke", r[r.Automatic = 1] = "Automatic";
})(Nve || (Nve = {}));
var HM;
(function(r) {
  r[r.Unknown = 0] = "Unknown", r[r.Disabled = 1] = "Disabled", r[r.Enabled = 2] = "Enabled";
})(HM || (HM = {}));
var BM;
(function(r) {
  r[r.Invoke = 1] = "Invoke", r[r.Auto = 2] = "Auto";
})(BM || (BM = {}));
var PM;
(function(r) {
  r[r.None = 0] = "None", r[r.KeepWhitespace = 1] = "KeepWhitespace", r[r.InsertAsSnippet = 4] = "InsertAsSnippet";
})(PM || (PM = {}));
var FM;
(function(r) {
  r[r.Method = 0] = "Method", r[r.Function = 1] = "Function", r[r.Constructor = 2] = "Constructor", r[r.Field = 3] = "Field", r[r.Variable = 4] = "Variable", r[r.Class = 5] = "Class", r[r.Struct = 6] = "Struct", r[r.Interface = 7] = "Interface", r[r.Module = 8] = "Module", r[r.Property = 9] = "Property", r[r.Event = 10] = "Event", r[r.Operator = 11] = "Operator", r[r.Unit = 12] = "Unit", r[r.Value = 13] = "Value", r[r.Constant = 14] = "Constant", r[r.Enum = 15] = "Enum", r[r.EnumMember = 16] = "EnumMember", r[r.Keyword = 17] = "Keyword", r[r.Text = 18] = "Text", r[r.Color = 19] = "Color", r[r.File = 20] = "File", r[r.Reference = 21] = "Reference", r[r.Customcolor = 22] = "Customcolor", r[r.Folder = 23] = "Folder", r[r.TypeParameter = 24] = "TypeParameter", r[r.User = 25] = "User", r[r.Issue = 26] = "Issue", r[r.Snippet = 27] = "Snippet";
})(FM || (FM = {}));
var zM;
(function(r) {
  r[r.Deprecated = 1] = "Deprecated";
})(zM || (zM = {}));
var WM;
(function(r) {
  r[r.Invoke = 0] = "Invoke", r[r.TriggerCharacter = 1] = "TriggerCharacter", r[r.TriggerForIncompleteCompletions = 2] = "TriggerForIncompleteCompletions";
})(WM || (WM = {}));
var jM;
(function(r) {
  r[r.EXACT = 0] = "EXACT", r[r.ABOVE = 1] = "ABOVE", r[r.BELOW = 2] = "BELOW";
})(jM || (jM = {}));
var ZM;
(function(r) {
  r[r.NotSet = 0] = "NotSet", r[r.ContentFlush = 1] = "ContentFlush", r[r.RecoverFromMarkers = 2] = "RecoverFromMarkers", r[r.Explicit = 3] = "Explicit", r[r.Paste = 4] = "Paste", r[r.Undo = 5] = "Undo", r[r.Redo = 6] = "Redo";
})(ZM || (ZM = {}));
var UM;
(function(r) {
  r[r.LF = 1] = "LF", r[r.CRLF = 2] = "CRLF";
})(UM || (UM = {}));
var qM;
(function(r) {
  r[r.Text = 0] = "Text", r[r.Read = 1] = "Read", r[r.Write = 2] = "Write";
})(qM || (qM = {}));
var GM;
(function(r) {
  r[r.None = 0] = "None", r[r.Keep = 1] = "Keep", r[r.Brackets = 2] = "Brackets", r[r.Advanced = 3] = "Advanced", r[r.Full = 4] = "Full";
})(GM || (GM = {}));
var QM;
(function(r) {
  r[r.acceptSuggestionOnCommitCharacter = 0] = "acceptSuggestionOnCommitCharacter", r[r.acceptSuggestionOnEnter = 1] = "acceptSuggestionOnEnter", r[r.accessibilitySupport = 2] = "accessibilitySupport", r[r.accessibilityPageSize = 3] = "accessibilityPageSize", r[r.ariaLabel = 4] = "ariaLabel", r[r.ariaRequired = 5] = "ariaRequired", r[r.autoClosingBrackets = 6] = "autoClosingBrackets", r[r.autoClosingComments = 7] = "autoClosingComments", r[r.screenReaderAnnounceInlineSuggestion = 8] = "screenReaderAnnounceInlineSuggestion", r[r.autoClosingDelete = 9] = "autoClosingDelete", r[r.autoClosingOvertype = 10] = "autoClosingOvertype", r[r.autoClosingQuotes = 11] = "autoClosingQuotes", r[r.autoIndent = 12] = "autoIndent", r[r.automaticLayout = 13] = "automaticLayout", r[r.autoSurround = 14] = "autoSurround", r[r.bracketPairColorization = 15] = "bracketPairColorization", r[r.guides = 16] = "guides", r[r.codeLens = 17] = "codeLens", r[r.codeLensFontFamily = 18] = "codeLensFontFamily", r[r.codeLensFontSize = 19] = "codeLensFontSize", r[r.colorDecorators = 20] = "colorDecorators", r[r.colorDecoratorsLimit = 21] = "colorDecoratorsLimit", r[r.columnSelection = 22] = "columnSelection", r[r.comments = 23] = "comments", r[r.contextmenu = 24] = "contextmenu", r[r.copyWithSyntaxHighlighting = 25] = "copyWithSyntaxHighlighting", r[r.cursorBlinking = 26] = "cursorBlinking", r[r.cursorSmoothCaretAnimation = 27] = "cursorSmoothCaretAnimation", r[r.cursorStyle = 28] = "cursorStyle", r[r.cursorSurroundingLines = 29] = "cursorSurroundingLines", r[r.cursorSurroundingLinesStyle = 30] = "cursorSurroundingLinesStyle", r[r.cursorWidth = 31] = "cursorWidth", r[r.disableLayerHinting = 32] = "disableLayerHinting", r[r.disableMonospaceOptimizations = 33] = "disableMonospaceOptimizations", r[r.domReadOnly = 34] = "domReadOnly", r[r.dragAndDrop = 35] = "dragAndDrop", r[r.dropIntoEditor = 36] = "dropIntoEditor", r[r.emptySelectionClipboard = 37] = "emptySelectionClipboard", r[r.experimentalWhitespaceRendering = 38] = "experimentalWhitespaceRendering", r[r.extraEditorClassName = 39] = "extraEditorClassName", r[r.fastScrollSensitivity = 40] = "fastScrollSensitivity", r[r.find = 41] = "find", r[r.fixedOverflowWidgets = 42] = "fixedOverflowWidgets", r[r.folding = 43] = "folding", r[r.foldingStrategy = 44] = "foldingStrategy", r[r.foldingHighlight = 45] = "foldingHighlight", r[r.foldingImportsByDefault = 46] = "foldingImportsByDefault", r[r.foldingMaximumRegions = 47] = "foldingMaximumRegions", r[r.unfoldOnClickAfterEndOfLine = 48] = "unfoldOnClickAfterEndOfLine", r[r.fontFamily = 49] = "fontFamily", r[r.fontInfo = 50] = "fontInfo", r[r.fontLigatures = 51] = "fontLigatures", r[r.fontSize = 52] = "fontSize", r[r.fontWeight = 53] = "fontWeight", r[r.fontVariations = 54] = "fontVariations", r[r.formatOnPaste = 55] = "formatOnPaste", r[r.formatOnType = 56] = "formatOnType", r[r.glyphMargin = 57] = "glyphMargin", r[r.gotoLocation = 58] = "gotoLocation", r[r.hideCursorInOverviewRuler = 59] = "hideCursorInOverviewRuler", r[r.hover = 60] = "hover", r[r.inDiffEditor = 61] = "inDiffEditor", r[r.inlineSuggest = 62] = "inlineSuggest", r[r.inlineEdit = 63] = "inlineEdit", r[r.letterSpacing = 64] = "letterSpacing", r[r.lightbulb = 65] = "lightbulb", r[r.lineDecorationsWidth = 66] = "lineDecorationsWidth", r[r.lineHeight = 67] = "lineHeight", r[r.lineNumbers = 68] = "lineNumbers", r[r.lineNumbersMinChars = 69] = "lineNumbersMinChars", r[r.linkedEditing = 70] = "linkedEditing", r[r.links = 71] = "links", r[r.matchBrackets = 72] = "matchBrackets", r[r.minimap = 73] = "minimap", r[r.mouseStyle = 74] = "mouseStyle", r[r.mouseWheelScrollSensitivity = 75] = "mouseWheelScrollSensitivity", r[r.mouseWheelZoom = 76] = "mouseWheelZoom", r[r.multiCursorMergeOverlapping = 77] = "multiCursorMergeOverlapping", r[r.multiCursorModifier = 78] = "multiCursorModifier", r[r.multiCursorPaste = 79] = "multiCursorPaste", r[r.multiCursorLimit = 80] = "multiCursorLimit", r[r.occurrencesHighlight = 81] = "occurrencesHighlight", r[r.overviewRulerBorder = 82] = "overviewRulerBorder", r[r.overviewRulerLanes = 83] = "overviewRulerLanes", r[r.padding = 84] = "padding", r[r.pasteAs = 85] = "pasteAs", r[r.parameterHints = 86] = "parameterHints", r[r.peekWidgetDefaultFocus = 87] = "peekWidgetDefaultFocus", r[r.placeholder = 88] = "placeholder", r[r.definitionLinkOpensInPeek = 89] = "definitionLinkOpensInPeek", r[r.quickSuggestions = 90] = "quickSuggestions", r[r.quickSuggestionsDelay = 91] = "quickSuggestionsDelay", r[r.readOnly = 92] = "readOnly", r[r.readOnlyMessage = 93] = "readOnlyMessage", r[r.renameOnType = 94] = "renameOnType", r[r.renderControlCharacters = 95] = "renderControlCharacters", r[r.renderFinalNewline = 96] = "renderFinalNewline", r[r.renderLineHighlight = 97] = "renderLineHighlight", r[r.renderLineHighlightOnlyWhenFocus = 98] = "renderLineHighlightOnlyWhenFocus", r[r.renderValidationDecorations = 99] = "renderValidationDecorations", r[r.renderWhitespace = 100] = "renderWhitespace", r[r.revealHorizontalRightPadding = 101] = "revealHorizontalRightPadding", r[r.roundedSelection = 102] = "roundedSelection", r[r.rulers = 103] = "rulers", r[r.scrollbar = 104] = "scrollbar", r[r.scrollBeyondLastColumn = 105] = "scrollBeyondLastColumn", r[r.scrollBeyondLastLine = 106] = "scrollBeyondLastLine", r[r.scrollPredominantAxis = 107] = "scrollPredominantAxis", r[r.selectionClipboard = 108] = "selectionClipboard", r[r.selectionHighlight = 109] = "selectionHighlight", r[r.selectOnLineNumbers = 110] = "selectOnLineNumbers", r[r.showFoldingControls = 111] = "showFoldingControls", r[r.showUnused = 112] = "showUnused", r[r.snippetSuggestions = 113] = "snippetSuggestions", r[r.smartSelect = 114] = "smartSelect", r[r.smoothScrolling = 115] = "smoothScrolling", r[r.stickyScroll = 116] = "stickyScroll", r[r.stickyTabStops = 117] = "stickyTabStops", r[r.stopRenderingLineAfter = 118] = "stopRenderingLineAfter", r[r.suggest = 119] = "suggest", r[r.suggestFontSize = 120] = "suggestFontSize", r[r.suggestLineHeight = 121] = "suggestLineHeight", r[r.suggestOnTriggerCharacters = 122] = "suggestOnTriggerCharacters", r[r.suggestSelection = 123] = "suggestSelection", r[r.tabCompletion = 124] = "tabCompletion", r[r.tabIndex = 125] = "tabIndex", r[r.unicodeHighlighting = 126] = "unicodeHighlighting", r[r.unusualLineTerminators = 127] = "unusualLineTerminators", r[r.useShadowDOM = 128] = "useShadowDOM", r[r.useTabStops = 129] = "useTabStops", r[r.wordBreak = 130] = "wordBreak", r[r.wordSegmenterLocales = 131] = "wordSegmenterLocales", r[r.wordSeparators = 132] = "wordSeparators", r[r.wordWrap = 133] = "wordWrap", r[r.wordWrapBreakAfterCharacters = 134] = "wordWrapBreakAfterCharacters", r[r.wordWrapBreakBeforeCharacters = 135] = "wordWrapBreakBeforeCharacters", r[r.wordWrapColumn = 136] = "wordWrapColumn", r[r.wordWrapOverride1 = 137] = "wordWrapOverride1", r[r.wordWrapOverride2 = 138] = "wordWrapOverride2", r[r.wrappingIndent = 139] = "wrappingIndent", r[r.wrappingStrategy = 140] = "wrappingStrategy", r[r.showDeprecated = 141] = "showDeprecated", r[r.inlayHints = 142] = "inlayHints", r[r.editorClassName = 143] = "editorClassName", r[r.pixelRatio = 144] = "pixelRatio", r[r.tabFocusMode = 145] = "tabFocusMode", r[r.layoutInfo = 146] = "layoutInfo", r[r.wrappingInfo = 147] = "wrappingInfo", r[r.defaultColorDecorators = 148] = "defaultColorDecorators", r[r.colorDecoratorsActivatedOn = 149] = "colorDecoratorsActivatedOn", r[r.inlineCompletionsAccessibilityVerbose = 150] = "inlineCompletionsAccessibilityVerbose";
})(QM || (QM = {}));
var KM;
(function(r) {
  r[r.TextDefined = 0] = "TextDefined", r[r.LF = 1] = "LF", r[r.CRLF = 2] = "CRLF";
})(KM || (KM = {}));
var YM;
(function(r) {
  r[r.LF = 0] = "LF", r[r.CRLF = 1] = "CRLF";
})(YM || (YM = {}));
var XM;
(function(r) {
  r[r.Left = 1] = "Left", r[r.Center = 2] = "Center", r[r.Right = 3] = "Right";
})(XM || (XM = {}));
var JM;
(function(r) {
  r[r.Increase = 0] = "Increase", r[r.Decrease = 1] = "Decrease";
})(JM || (JM = {}));
var $M;
(function(r) {
  r[r.None = 0] = "None", r[r.Indent = 1] = "Indent", r[r.IndentOutdent = 2] = "IndentOutdent", r[r.Outdent = 3] = "Outdent";
})($M || ($M = {}));
var eD;
(function(r) {
  r[r.Both = 0] = "Both", r[r.Right = 1] = "Right", r[r.Left = 2] = "Left", r[r.None = 3] = "None";
})(eD || (eD = {}));
var tD;
(function(r) {
  r[r.Type = 1] = "Type", r[r.Parameter = 2] = "Parameter";
})(tD || (tD = {}));
var nD;
(function(r) {
  r[r.Automatic = 0] = "Automatic", r[r.Explicit = 1] = "Explicit";
})(nD || (nD = {}));
var iD;
(function(r) {
  r[r.Invoke = 0] = "Invoke", r[r.Automatic = 1] = "Automatic";
})(iD || (iD = {}));
var rD;
(function(r) {
  r[r.DependsOnKbLayout = -1] = "DependsOnKbLayout", r[r.Unknown = 0] = "Unknown", r[r.Backspace = 1] = "Backspace", r[r.Tab = 2] = "Tab", r[r.Enter = 3] = "Enter", r[r.Shift = 4] = "Shift", r[r.Ctrl = 5] = "Ctrl", r[r.Alt = 6] = "Alt", r[r.PauseBreak = 7] = "PauseBreak", r[r.CapsLock = 8] = "CapsLock", r[r.Escape = 9] = "Escape", r[r.Space = 10] = "Space", r[r.PageUp = 11] = "PageUp", r[r.PageDown = 12] = "PageDown", r[r.End = 13] = "End", r[r.Home = 14] = "Home", r[r.LeftArrow = 15] = "LeftArrow", r[r.UpArrow = 16] = "UpArrow", r[r.RightArrow = 17] = "RightArrow", r[r.DownArrow = 18] = "DownArrow", r[r.Insert = 19] = "Insert", r[r.Delete = 20] = "Delete", r[r.Digit0 = 21] = "Digit0", r[r.Digit1 = 22] = "Digit1", r[r.Digit2 = 23] = "Digit2", r[r.Digit3 = 24] = "Digit3", r[r.Digit4 = 25] = "Digit4", r[r.Digit5 = 26] = "Digit5", r[r.Digit6 = 27] = "Digit6", r[r.Digit7 = 28] = "Digit7", r[r.Digit8 = 29] = "Digit8", r[r.Digit9 = 30] = "Digit9", r[r.KeyA = 31] = "KeyA", r[r.KeyB = 32] = "KeyB", r[r.KeyC = 33] = "KeyC", r[r.KeyD = 34] = "KeyD", r[r.KeyE = 35] = "KeyE", r[r.KeyF = 36] = "KeyF", r[r.KeyG = 37] = "KeyG", r[r.KeyH = 38] = "KeyH", r[r.KeyI = 39] = "KeyI", r[r.KeyJ = 40] = "KeyJ", r[r.KeyK = 41] = "KeyK", r[r.KeyL = 42] = "KeyL", r[r.KeyM = 43] = "KeyM", r[r.KeyN = 44] = "KeyN", r[r.KeyO = 45] = "KeyO", r[r.KeyP = 46] = "KeyP", r[r.KeyQ = 47] = "KeyQ", r[r.KeyR = 48] = "KeyR", r[r.KeyS = 49] = "KeyS", r[r.KeyT = 50] = "KeyT", r[r.KeyU = 51] = "KeyU", r[r.KeyV = 52] = "KeyV", r[r.KeyW = 53] = "KeyW", r[r.KeyX = 54] = "KeyX", r[r.KeyY = 55] = "KeyY", r[r.KeyZ = 56] = "KeyZ", r[r.Meta = 57] = "Meta", r[r.ContextMenu = 58] = "ContextMenu", r[r.F1 = 59] = "F1", r[r.F2 = 60] = "F2", r[r.F3 = 61] = "F3", r[r.F4 = 62] = "F4", r[r.F5 = 63] = "F5", r[r.F6 = 64] = "F6", r[r.F7 = 65] = "F7", r[r.F8 = 66] = "F8", r[r.F9 = 67] = "F9", r[r.F10 = 68] = "F10", r[r.F11 = 69] = "F11", r[r.F12 = 70] = "F12", r[r.F13 = 71] = "F13", r[r.F14 = 72] = "F14", r[r.F15 = 73] = "F15", r[r.F16 = 74] = "F16", r[r.F17 = 75] = "F17", r[r.F18 = 76] = "F18", r[r.F19 = 77] = "F19", r[r.F20 = 78] = "F20", r[r.F21 = 79] = "F21", r[r.F22 = 80] = "F22", r[r.F23 = 81] = "F23", r[r.F24 = 82] = "F24", r[r.NumLock = 83] = "NumLock", r[r.ScrollLock = 84] = "ScrollLock", r[r.Semicolon = 85] = "Semicolon", r[r.Equal = 86] = "Equal", r[r.Comma = 87] = "Comma", r[r.Minus = 88] = "Minus", r[r.Period = 89] = "Period", r[r.Slash = 90] = "Slash", r[r.Backquote = 91] = "Backquote", r[r.BracketLeft = 92] = "BracketLeft", r[r.Backslash = 93] = "Backslash", r[r.BracketRight = 94] = "BracketRight", r[r.Quote = 95] = "Quote", r[r.OEM_8 = 96] = "OEM_8", r[r.IntlBackslash = 97] = "IntlBackslash", r[r.Numpad0 = 98] = "Numpad0", r[r.Numpad1 = 99] = "Numpad1", r[r.Numpad2 = 100] = "Numpad2", r[r.Numpad3 = 101] = "Numpad3", r[r.Numpad4 = 102] = "Numpad4", r[r.Numpad5 = 103] = "Numpad5", r[r.Numpad6 = 104] = "Numpad6", r[r.Numpad7 = 105] = "Numpad7", r[r.Numpad8 = 106] = "Numpad8", r[r.Numpad9 = 107] = "Numpad9", r[r.NumpadMultiply = 108] = "NumpadMultiply", r[r.NumpadAdd = 109] = "NumpadAdd", r[r.NUMPAD_SEPARATOR = 110] = "NUMPAD_SEPARATOR", r[r.NumpadSubtract = 111] = "NumpadSubtract", r[r.NumpadDecimal = 112] = "NumpadDecimal", r[r.NumpadDivide = 113] = "NumpadDivide", r[r.KEY_IN_COMPOSITION = 114] = "KEY_IN_COMPOSITION", r[r.ABNT_C1 = 115] = "ABNT_C1", r[r.ABNT_C2 = 116] = "ABNT_C2", r[r.AudioVolumeMute = 117] = "AudioVolumeMute", r[r.AudioVolumeUp = 118] = "AudioVolumeUp", r[r.AudioVolumeDown = 119] = "AudioVolumeDown", r[r.BrowserSearch = 120] = "BrowserSearch", r[r.BrowserHome = 121] = "BrowserHome", r[r.BrowserBack = 122] = "BrowserBack", r[r.BrowserForward = 123] = "BrowserForward", r[r.MediaTrackNext = 124] = "MediaTrackNext", r[r.MediaTrackPrevious = 125] = "MediaTrackPrevious", r[r.MediaStop = 126] = "MediaStop", r[r.MediaPlayPause = 127] = "MediaPlayPause", r[r.LaunchMediaPlayer = 128] = "LaunchMediaPlayer", r[r.LaunchMail = 129] = "LaunchMail", r[r.LaunchApp2 = 130] = "LaunchApp2", r[r.Clear = 131] = "Clear", r[r.MAX_VALUE = 132] = "MAX_VALUE";
})(rD || (rD = {}));
var sD;
(function(r) {
  r[r.Hint = 1] = "Hint", r[r.Info = 2] = "Info", r[r.Warning = 4] = "Warning", r[r.Error = 8] = "Error";
})(sD || (sD = {}));
var oD;
(function(r) {
  r[r.Unnecessary = 1] = "Unnecessary", r[r.Deprecated = 2] = "Deprecated";
})(oD || (oD = {}));
var aD;
(function(r) {
  r[r.Inline = 1] = "Inline", r[r.Gutter = 2] = "Gutter";
})(aD || (aD = {}));
var lD;
(function(r) {
  r[r.Normal = 1] = "Normal", r[r.Underlined = 2] = "Underlined";
})(lD || (lD = {}));
var cD;
(function(r) {
  r[r.UNKNOWN = 0] = "UNKNOWN", r[r.TEXTAREA = 1] = "TEXTAREA", r[r.GUTTER_GLYPH_MARGIN = 2] = "GUTTER_GLYPH_MARGIN", r[r.GUTTER_LINE_NUMBERS = 3] = "GUTTER_LINE_NUMBERS", r[r.GUTTER_LINE_DECORATIONS = 4] = "GUTTER_LINE_DECORATIONS", r[r.GUTTER_VIEW_ZONE = 5] = "GUTTER_VIEW_ZONE", r[r.CONTENT_TEXT = 6] = "CONTENT_TEXT", r[r.CONTENT_EMPTY = 7] = "CONTENT_EMPTY", r[r.CONTENT_VIEW_ZONE = 8] = "CONTENT_VIEW_ZONE", r[r.CONTENT_WIDGET = 9] = "CONTENT_WIDGET", r[r.OVERVIEW_RULER = 10] = "OVERVIEW_RULER", r[r.SCROLLBAR = 11] = "SCROLLBAR", r[r.OVERLAY_WIDGET = 12] = "OVERLAY_WIDGET", r[r.OUTSIDE_EDITOR = 13] = "OUTSIDE_EDITOR";
})(cD || (cD = {}));
var hD;
(function(r) {
  r[r.AIGenerated = 1] = "AIGenerated";
})(hD || (hD = {}));
var dD;
(function(r) {
  r[r.Invoke = 0] = "Invoke", r[r.Automatic = 1] = "Automatic";
})(dD || (dD = {}));
var uD;
(function(r) {
  r[r.TOP_RIGHT_CORNER = 0] = "TOP_RIGHT_CORNER", r[r.BOTTOM_RIGHT_CORNER = 1] = "BOTTOM_RIGHT_CORNER", r[r.TOP_CENTER = 2] = "TOP_CENTER";
})(uD || (uD = {}));
var fD;
(function(r) {
  r[r.Left = 1] = "Left", r[r.Center = 2] = "Center", r[r.Right = 4] = "Right", r[r.Full = 7] = "Full";
})(fD || (fD = {}));
var pD;
(function(r) {
  r[r.Word = 0] = "Word", r[r.Line = 1] = "Line", r[r.Suggest = 2] = "Suggest";
})(pD || (pD = {}));
var gD;
(function(r) {
  r[r.Left = 0] = "Left", r[r.Right = 1] = "Right", r[r.None = 2] = "None", r[r.LeftOfInjectedText = 3] = "LeftOfInjectedText", r[r.RightOfInjectedText = 4] = "RightOfInjectedText";
})(gD || (gD = {}));
var mD;
(function(r) {
  r[r.Off = 0] = "Off", r[r.On = 1] = "On", r[r.Relative = 2] = "Relative", r[r.Interval = 3] = "Interval", r[r.Custom = 4] = "Custom";
})(mD || (mD = {}));
var AD;
(function(r) {
  r[r.None = 0] = "None", r[r.Text = 1] = "Text", r[r.Blocks = 2] = "Blocks";
})(AD || (AD = {}));
var wD;
(function(r) {
  r[r.Smooth = 0] = "Smooth", r[r.Immediate = 1] = "Immediate";
})(wD || (wD = {}));
var vD;
(function(r) {
  r[r.Auto = 1] = "Auto", r[r.Hidden = 2] = "Hidden", r[r.Visible = 3] = "Visible";
})(vD || (vD = {}));
var bD;
(function(r) {
  r[r.LTR = 0] = "LTR", r[r.RTL = 1] = "RTL";
})(bD || (bD = {}));
var yD;
(function(r) {
  r.Off = "off", r.OnCode = "onCode", r.On = "on";
})(yD || (yD = {}));
var CD;
(function(r) {
  r[r.Invoke = 1] = "Invoke", r[r.TriggerCharacter = 2] = "TriggerCharacter", r[r.ContentChange = 3] = "ContentChange";
})(CD || (CD = {}));
var ED;
(function(r) {
  r[r.File = 0] = "File", r[r.Module = 1] = "Module", r[r.Namespace = 2] = "Namespace", r[r.Package = 3] = "Package", r[r.Class = 4] = "Class", r[r.Method = 5] = "Method", r[r.Property = 6] = "Property", r[r.Field = 7] = "Field", r[r.Constructor = 8] = "Constructor", r[r.Enum = 9] = "Enum", r[r.Interface = 10] = "Interface", r[r.Function = 11] = "Function", r[r.Variable = 12] = "Variable", r[r.Constant = 13] = "Constant", r[r.String = 14] = "String", r[r.Number = 15] = "Number", r[r.Boolean = 16] = "Boolean", r[r.Array = 17] = "Array", r[r.Object = 18] = "Object", r[r.Key = 19] = "Key", r[r.Null = 20] = "Null", r[r.EnumMember = 21] = "EnumMember", r[r.Struct = 22] = "Struct", r[r.Event = 23] = "Event", r[r.Operator = 24] = "Operator", r[r.TypeParameter = 25] = "TypeParameter";
})(ED || (ED = {}));
var _D;
(function(r) {
  r[r.Deprecated = 1] = "Deprecated";
})(_D || (_D = {}));
var xD;
(function(r) {
  r[r.Hidden = 0] = "Hidden", r[r.Blink = 1] = "Blink", r[r.Smooth = 2] = "Smooth", r[r.Phase = 3] = "Phase", r[r.Expand = 4] = "Expand", r[r.Solid = 5] = "Solid";
})(xD || (xD = {}));
var SD;
(function(r) {
  r[r.Line = 1] = "Line", r[r.Block = 2] = "Block", r[r.Underline = 3] = "Underline", r[r.LineThin = 4] = "LineThin", r[r.BlockOutline = 5] = "BlockOutline", r[r.UnderlineThin = 6] = "UnderlineThin";
})(SD || (SD = {}));
var MD;
(function(r) {
  r[r.AlwaysGrowsWhenTypingAtEdges = 0] = "AlwaysGrowsWhenTypingAtEdges", r[r.NeverGrowsWhenTypingAtEdges = 1] = "NeverGrowsWhenTypingAtEdges", r[r.GrowsOnlyWhenTypingBefore = 2] = "GrowsOnlyWhenTypingBefore", r[r.GrowsOnlyWhenTypingAfter = 3] = "GrowsOnlyWhenTypingAfter";
})(MD || (MD = {}));
var DD;
(function(r) {
  r[r.None = 0] = "None", r[r.Same = 1] = "Same", r[r.Indent = 2] = "Indent", r[r.DeepIndent = 3] = "DeepIndent";
})(DD || (DD = {}));
let A0t = class {
  static {
    this.CtrlCmd = 2048;
  }
  static {
    this.Shift = 1024;
  }
  static {
    this.Alt = 512;
  }
  static {
    this.WinCtrl = 256;
  }
  static chord(e, t) {
    return j1t(e, t);
  }
};
function eDe() {
  return {
    editor: void 0,
    // undefined override expected here
    languages: void 0,
    // undefined override expected here
    CancellationTokenSource: Jg,
    Emitter: $,
    KeyCode: rD,
    KeyMod: A0t,
    Position: le,
    Range: Q,
    Selection: _n,
    SelectionDirection: bD,
    MarkerSeverity: sD,
    MarkerTag: oD,
    Uri: Pt,
    Token: V3
  };
}
function w0t(r, e) {
  const t = r;
  typeof t.vscodeWindowId != "number" && Object.defineProperty(t, "vscodeWindowId", {
    get: () => e
  });
}
const Sn = window;
function tDe(r) {
  return r;
}
class v0t {
  constructor(e, t) {
    this.lastCache = void 0, this.lastArgKey = void 0, typeof e == "function" ? (this._fn = e, this._computeKey = tDe) : (this._fn = t, this._computeKey = e.getCacheKey);
  }
  get(e) {
    const t = this._computeKey(e);
    return this.lastArgKey !== t && (this.lastArgKey = t, this.lastCache = this._fn(e)), this.lastCache;
  }
}
class Tve {
  get cachedValues() {
    return this._map;
  }
  constructor(e, t) {
    this._map = /* @__PURE__ */ new Map(), this._map2 = /* @__PURE__ */ new Map(), typeof e == "function" ? (this._fn = e, this._computeKey = tDe) : (this._fn = t, this._computeKey = e.getCacheKey);
  }
  get(e) {
    const t = this._computeKey(e);
    if (this._map2.has(t))
      return this._map2.get(t);
    const n = this._fn(e);
    return this._map.set(e, n), this._map2.set(t, n), n;
  }
}
class o1 {
  constructor(e) {
    this.executor = e, this._didRun = !1;
  }
  /**
   * Get the wrapped value.
   *
   * This will force evaluation of the lazy value if it has not been resolved yet. Lazy values are only
   * resolved once. `getValue` will re-throw exceptions that are hit while resolving the value
   */
  get value() {
    if (!this._didRun)
      try {
        this._value = this.executor();
      } catch (e) {
        this._error = e;
      } finally {
        this._didRun = !0;
      }
    if (this._error)
      throw this._error;
    return this._value;
  }
  /**
   * Get the wrapped value without forcing evaluation.
   */
  get rawValue() {
    return this._value;
  }
}
function b0t(r) {
  return !r || typeof r != "string" ? !0 : r.trim().length === 0;
}
const y0t = /{(\d+)}/g;
function I8(r, ...e) {
  return e.length === 0 ? r : r.replace(y0t, function(t, n) {
    const i = parseInt(n, 10);
    return isNaN(i) || i < 0 || i >= e.length ? t : e[i];
  });
}
function C0t(r) {
  return r.replace(/[<>"'&]/g, (e) => {
    switch (e) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case '"':
        return "&quot;";
      case "'":
        return "&apos;";
      case "&":
        return "&amp;";
    }
    return e;
  });
}
function VA(r) {
  return r.replace(/[<>&]/g, function(e) {
    switch (e) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      default:
        return e;
    }
  });
}
function tc(r) {
  return r.replace(/[\\\{\}\*\+\?\|\^\$\.\[\]\(\)]/g, "\\$&");
}
function R7(r, e) {
  if (!r || !e)
    return r;
  const t = e.length;
  if (t === 0 || r.length === 0)
    return r;
  let n = 0;
  for (; r.indexOf(e, n) === n; )
    n = n + t;
  return r.substring(n);
}
function E0t(r, e) {
  if (!r)
    return r;
  const t = e.length, n = r.length;
  if (t === 0 || n === 0)
    return r;
  let i = n, s = -1;
  for (; s = r.lastIndexOf(e, i - 1), !(s === -1 || s + t !== i); ) {
    if (s === 0)
      return "";
    i = s;
  }
  return r.substring(0, i);
}
function _0t(r) {
  return r.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&").replace(/[\*]/g, ".*");
}
function nDe(r, e, t = {}) {
  if (!r)
    throw new Error("Cannot create regex from empty string");
  e || (r = tc(r)), t.wholeWord && (/\B/.test(r.charAt(0)) || (r = "\\b" + r), /\B/.test(r.charAt(r.length - 1)) || (r = r + "\\b"));
  let n = "";
  return t.global && (n += "g"), t.matchCase || (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), new RegExp(r, n);
}
function x0t(r) {
  return r.source === "^" || r.source === "^$" || r.source === "$" || r.source === "^\\s*$" ? !1 : !!(r.exec("") && r.lastIndex === 0);
}
function $g(r) {
  return r.split(/\r\n|\r|\n/);
}
function so(r) {
  for (let e = 0, t = r.length; e < t; e++) {
    const n = r.charCodeAt(e);
    if (n !== 32 && n !== 9)
      return e;
  }
  return -1;
}
function hs(r, e = 0, t = r.length) {
  for (let n = e; n < t; n++) {
    const i = r.charCodeAt(n);
    if (i !== 32 && i !== 9)
      return r.substring(e, n);
  }
  return r.substring(e, t);
}
function Zf(r, e = r.length - 1) {
  for (let t = e; t >= 0; t--) {
    const n = r.charCodeAt(t);
    if (n !== 32 && n !== 9)
      return t;
  }
  return -1;
}
function LD(r, e) {
  return r < e ? -1 : r > e ? 1 : 0;
}
function II(r, e, t = 0, n = r.length, i = 0, s = e.length) {
  for (; t < n && i < s; t++, i++) {
    const l = r.charCodeAt(t), c = e.charCodeAt(i);
    if (l < c)
      return -1;
    if (l > c)
      return 1;
  }
  const o = n - t, a = s - i;
  return o < a ? -1 : o > a ? 1 : 0;
}
function Ive(r, e) {
  return ww(r, e, 0, r.length, 0, e.length);
}
function ww(r, e, t = 0, n = r.length, i = 0, s = e.length) {
  for (; t < n && i < s; t++, i++) {
    let l = r.charCodeAt(t), c = e.charCodeAt(i);
    if (l === c)
      continue;
    if (l >= 128 || c >= 128)
      return II(r.toLowerCase(), e.toLowerCase(), t, n, i, s);
    G2(l) && (l -= 32), G2(c) && (c -= 32);
    const d = l - c;
    if (d !== 0)
      return d;
  }
  const o = n - t, a = s - i;
  return o < a ? -1 : o > a ? 1 : 0;
}
function xv(r) {
  return r >= 48 && r <= 57;
}
function G2(r) {
  return r >= 97 && r <= 122;
}
function gu(r) {
  return r >= 65 && r <= 90;
}
function Q2(r, e) {
  return r.length === e.length && ww(r, e) === 0;
}
function OI(r, e) {
  const t = e.length;
  return e.length > r.length ? !1 : ww(r, e, 0, t) === 0;
}
function kD(r, e) {
  const t = Math.min(r.length, e.length);
  let n;
  for (n = 0; n < t; n++)
    if (r.charCodeAt(n) !== e.charCodeAt(n))
      return n;
  return t;
}
function ND(r, e) {
  const t = Math.min(r.length, e.length);
  let n;
  const i = r.length - 1, s = e.length - 1;
  for (n = 0; n < t; n++)
    if (r.charCodeAt(i - n) !== e.charCodeAt(s - n))
      return n;
  return t;
}
function Ki(r) {
  return 55296 <= r && r <= 56319;
}
function rg(r) {
  return 56320 <= r && r <= 57343;
}
function RI(r, e) {
  return (r - 55296 << 10) + (e - 56320) + 65536;
}
function O8(r, e, t) {
  const n = r.charCodeAt(t);
  if (Ki(n) && t + 1 < e) {
    const i = r.charCodeAt(t + 1);
    if (rg(i))
      return RI(n, i);
  }
  return n;
}
function S0t(r, e) {
  const t = r.charCodeAt(e - 1);
  if (rg(t) && e > 1) {
    const n = r.charCodeAt(e - 2);
    if (Ki(n))
      return RI(n, t);
  }
  return t;
}
class VI {
  get offset() {
    return this._offset;
  }
  constructor(e, t = 0) {
    this._str = e, this._len = e.length, this._offset = t;
  }
  setOffset(e) {
    this._offset = e;
  }
  prevCodePoint() {
    const e = S0t(this._str, this._offset);
    return this._offset -= e >= 65536 ? 2 : 1, e;
  }
  nextCodePoint() {
    const e = O8(this._str, this._len, this._offset);
    return this._offset += e >= 65536 ? 2 : 1, e;
  }
  eol() {
    return this._offset >= this._len;
  }
}
class R8 {
  get offset() {
    return this._iterator.offset;
  }
  constructor(e, t = 0) {
    this._iterator = new VI(e, t);
  }
  nextGraphemeLength() {
    const e = N0.getInstance(), t = this._iterator, n = t.offset;
    let i = e.getGraphemeBreakType(t.nextCodePoint());
    for (; !t.eol(); ) {
      const s = t.offset, o = e.getGraphemeBreakType(t.nextCodePoint());
      if (Ove(i, o)) {
        t.setOffset(s);
        break;
      }
      i = o;
    }
    return t.offset - n;
  }
  prevGraphemeLength() {
    const e = N0.getInstance(), t = this._iterator, n = t.offset;
    let i = e.getGraphemeBreakType(t.prevCodePoint());
    for (; t.offset > 0; ) {
      const s = t.offset, o = e.getGraphemeBreakType(t.prevCodePoint());
      if (Ove(o, i)) {
        t.setOffset(s);
        break;
      }
      i = o;
    }
    return n - t.offset;
  }
  eol() {
    return this._iterator.eol();
  }
}
function HI(r, e) {
  return new R8(r, e).nextGraphemeLength();
}
function iDe(r, e) {
  return new R8(r, e).prevGraphemeLength();
}
function M0t(r, e) {
  e > 0 && rg(r.charCodeAt(e)) && e--;
  const t = e + HI(r, e);
  return [t - iDe(r, t), t];
}
let gE;
function D0t() {
  return /(?:[\u05BE\u05C0\u05C3\u05C6\u05D0-\u05F4\u0608\u060B\u060D\u061B-\u064A\u066D-\u066F\u0671-\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u0710\u0712-\u072F\u074D-\u07A5\u07B1-\u07EA\u07F4\u07F5\u07FA\u07FE-\u0815\u081A\u0824\u0828\u0830-\u0858\u085E-\u088E\u08A0-\u08C9\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFD3D\uFD50-\uFDC7\uFDF0-\uFDFC\uFE70-\uFEFC]|\uD802[\uDC00-\uDD1B\uDD20-\uDE00\uDE10-\uDE35\uDE40-\uDEE4\uDEEB-\uDF35\uDF40-\uDFFF]|\uD803[\uDC00-\uDD23\uDE80-\uDEA9\uDEAD-\uDF45\uDF51-\uDF81\uDF86-\uDFF6]|\uD83A[\uDC00-\uDCCF\uDD00-\uDD43\uDD4B-\uDFFF]|\uD83B[\uDC00-\uDEBB])/;
}
function H3(r) {
  return gE || (gE = D0t()), gE.test(r);
}
const L0t = /^[\t\n\r\x20-\x7E]*$/;
function BI(r) {
  return L0t.test(r);
}
const rDe = /[\u2028\u2029]/;
function sDe(r) {
  return rDe.test(r);
}
function a1(r) {
  return r >= 11904 && r <= 55215 || r >= 63744 && r <= 64255 || r >= 65281 && r <= 65374;
}
function PI(r) {
  return r >= 127462 && r <= 127487 || r === 8986 || r === 8987 || r === 9200 || r === 9203 || r >= 9728 && r <= 10175 || r === 11088 || r === 11093 || r >= 127744 && r <= 128591 || r >= 128640 && r <= 128764 || r >= 128992 && r <= 129008 || r >= 129280 && r <= 129535 || r >= 129648 && r <= 129782;
}
const k0t = "\uFEFF";
function FI(r) {
  return !!(r && r.length > 0 && r.charCodeAt(0) === 65279);
}
function N0t(r, e = !1) {
  return r ? (e && (r = r.replace(/\\./g, "")), r.toLowerCase() !== r) : !1;
}
function oDe(r) {
  return r = r % (2 * 26), r < 26 ? String.fromCharCode(97 + r) : String.fromCharCode(65 + r - 26);
}
function Ove(r, e) {
  return r === 0 ? e !== 5 && e !== 7 : r === 2 && e === 3 ? !1 : r === 4 || r === 2 || r === 3 || e === 4 || e === 2 || e === 3 ? !0 : !(r === 8 && (e === 8 || e === 9 || e === 11 || e === 12) || (r === 11 || r === 9) && (e === 9 || e === 10) || (r === 12 || r === 10) && e === 10 || e === 5 || e === 13 || e === 7 || r === 1 || r === 13 && e === 14 || r === 6 && e === 6);
}
class N0 {
  static {
    this._INSTANCE = null;
  }
  static getInstance() {
    return N0._INSTANCE || (N0._INSTANCE = new N0()), N0._INSTANCE;
  }
  constructor() {
    this._data = T0t();
  }
  getGraphemeBreakType(e) {
    if (e < 32)
      return e === 10 ? 3 : e === 13 ? 2 : 4;
    if (e < 127)
      return 0;
    const t = this._data, n = t.length / 3;
    let i = 1;
    for (; i <= n; )
      if (e < t[3 * i])
        i = 2 * i;
      else if (e > t[3 * i + 1])
        i = 2 * i + 1;
      else
        return t[3 * i + 2];
    return 0;
  }
}
function T0t() {
  return JSON.parse("[0,0,0,51229,51255,12,44061,44087,12,127462,127487,6,7083,7085,5,47645,47671,12,54813,54839,12,128678,128678,14,3270,3270,5,9919,9923,14,45853,45879,12,49437,49463,12,53021,53047,12,71216,71218,7,128398,128399,14,129360,129374,14,2519,2519,5,4448,4519,9,9742,9742,14,12336,12336,14,44957,44983,12,46749,46775,12,48541,48567,12,50333,50359,12,52125,52151,12,53917,53943,12,69888,69890,5,73018,73018,5,127990,127990,14,128558,128559,14,128759,128760,14,129653,129655,14,2027,2035,5,2891,2892,7,3761,3761,5,6683,6683,5,8293,8293,4,9825,9826,14,9999,9999,14,43452,43453,5,44509,44535,12,45405,45431,12,46301,46327,12,47197,47223,12,48093,48119,12,48989,49015,12,49885,49911,12,50781,50807,12,51677,51703,12,52573,52599,12,53469,53495,12,54365,54391,12,65279,65279,4,70471,70472,7,72145,72147,7,119173,119179,5,127799,127818,14,128240,128244,14,128512,128512,14,128652,128652,14,128721,128722,14,129292,129292,14,129445,129450,14,129734,129743,14,1476,1477,5,2366,2368,7,2750,2752,7,3076,3076,5,3415,3415,5,4141,4144,5,6109,6109,5,6964,6964,5,7394,7400,5,9197,9198,14,9770,9770,14,9877,9877,14,9968,9969,14,10084,10084,14,43052,43052,5,43713,43713,5,44285,44311,12,44733,44759,12,45181,45207,12,45629,45655,12,46077,46103,12,46525,46551,12,46973,46999,12,47421,47447,12,47869,47895,12,48317,48343,12,48765,48791,12,49213,49239,12,49661,49687,12,50109,50135,12,50557,50583,12,51005,51031,12,51453,51479,12,51901,51927,12,52349,52375,12,52797,52823,12,53245,53271,12,53693,53719,12,54141,54167,12,54589,54615,12,55037,55063,12,69506,69509,5,70191,70193,5,70841,70841,7,71463,71467,5,72330,72342,5,94031,94031,5,123628,123631,5,127763,127765,14,127941,127941,14,128043,128062,14,128302,128317,14,128465,128467,14,128539,128539,14,128640,128640,14,128662,128662,14,128703,128703,14,128745,128745,14,129004,129007,14,129329,129330,14,129402,129402,14,129483,129483,14,129686,129704,14,130048,131069,14,173,173,4,1757,1757,1,2200,2207,5,2434,2435,7,2631,2632,5,2817,2817,5,3008,3008,5,3201,3201,5,3387,3388,5,3542,3542,5,3902,3903,7,4190,4192,5,6002,6003,5,6439,6440,5,6765,6770,7,7019,7027,5,7154,7155,7,8205,8205,13,8505,8505,14,9654,9654,14,9757,9757,14,9792,9792,14,9852,9853,14,9890,9894,14,9937,9937,14,9981,9981,14,10035,10036,14,11035,11036,14,42654,42655,5,43346,43347,7,43587,43587,5,44006,44007,7,44173,44199,12,44397,44423,12,44621,44647,12,44845,44871,12,45069,45095,12,45293,45319,12,45517,45543,12,45741,45767,12,45965,45991,12,46189,46215,12,46413,46439,12,46637,46663,12,46861,46887,12,47085,47111,12,47309,47335,12,47533,47559,12,47757,47783,12,47981,48007,12,48205,48231,12,48429,48455,12,48653,48679,12,48877,48903,12,49101,49127,12,49325,49351,12,49549,49575,12,49773,49799,12,49997,50023,12,50221,50247,12,50445,50471,12,50669,50695,12,50893,50919,12,51117,51143,12,51341,51367,12,51565,51591,12,51789,51815,12,52013,52039,12,52237,52263,12,52461,52487,12,52685,52711,12,52909,52935,12,53133,53159,12,53357,53383,12,53581,53607,12,53805,53831,12,54029,54055,12,54253,54279,12,54477,54503,12,54701,54727,12,54925,54951,12,55149,55175,12,68101,68102,5,69762,69762,7,70067,70069,7,70371,70378,5,70720,70721,7,71087,71087,5,71341,71341,5,71995,71996,5,72249,72249,7,72850,72871,5,73109,73109,5,118576,118598,5,121505,121519,5,127245,127247,14,127568,127569,14,127777,127777,14,127872,127891,14,127956,127967,14,128015,128016,14,128110,128172,14,128259,128259,14,128367,128368,14,128424,128424,14,128488,128488,14,128530,128532,14,128550,128551,14,128566,128566,14,128647,128647,14,128656,128656,14,128667,128673,14,128691,128693,14,128715,128715,14,128728,128732,14,128752,128752,14,128765,128767,14,129096,129103,14,129311,129311,14,129344,129349,14,129394,129394,14,129413,129425,14,129466,129471,14,129511,129535,14,129664,129666,14,129719,129722,14,129760,129767,14,917536,917631,5,13,13,2,1160,1161,5,1564,1564,4,1807,1807,1,2085,2087,5,2307,2307,7,2382,2383,7,2497,2500,5,2563,2563,7,2677,2677,5,2763,2764,7,2879,2879,5,2914,2915,5,3021,3021,5,3142,3144,5,3263,3263,5,3285,3286,5,3398,3400,7,3530,3530,5,3633,3633,5,3864,3865,5,3974,3975,5,4155,4156,7,4229,4230,5,5909,5909,7,6078,6085,7,6277,6278,5,6451,6456,7,6744,6750,5,6846,6846,5,6972,6972,5,7074,7077,5,7146,7148,7,7222,7223,5,7416,7417,5,8234,8238,4,8417,8417,5,9000,9000,14,9203,9203,14,9730,9731,14,9748,9749,14,9762,9763,14,9776,9783,14,9800,9811,14,9831,9831,14,9872,9873,14,9882,9882,14,9900,9903,14,9929,9933,14,9941,9960,14,9974,9974,14,9989,9989,14,10006,10006,14,10062,10062,14,10160,10160,14,11647,11647,5,12953,12953,14,43019,43019,5,43232,43249,5,43443,43443,5,43567,43568,7,43696,43696,5,43765,43765,7,44013,44013,5,44117,44143,12,44229,44255,12,44341,44367,12,44453,44479,12,44565,44591,12,44677,44703,12,44789,44815,12,44901,44927,12,45013,45039,12,45125,45151,12,45237,45263,12,45349,45375,12,45461,45487,12,45573,45599,12,45685,45711,12,45797,45823,12,45909,45935,12,46021,46047,12,46133,46159,12,46245,46271,12,46357,46383,12,46469,46495,12,46581,46607,12,46693,46719,12,46805,46831,12,46917,46943,12,47029,47055,12,47141,47167,12,47253,47279,12,47365,47391,12,47477,47503,12,47589,47615,12,47701,47727,12,47813,47839,12,47925,47951,12,48037,48063,12,48149,48175,12,48261,48287,12,48373,48399,12,48485,48511,12,48597,48623,12,48709,48735,12,48821,48847,12,48933,48959,12,49045,49071,12,49157,49183,12,49269,49295,12,49381,49407,12,49493,49519,12,49605,49631,12,49717,49743,12,49829,49855,12,49941,49967,12,50053,50079,12,50165,50191,12,50277,50303,12,50389,50415,12,50501,50527,12,50613,50639,12,50725,50751,12,50837,50863,12,50949,50975,12,51061,51087,12,51173,51199,12,51285,51311,12,51397,51423,12,51509,51535,12,51621,51647,12,51733,51759,12,51845,51871,12,51957,51983,12,52069,52095,12,52181,52207,12,52293,52319,12,52405,52431,12,52517,52543,12,52629,52655,12,52741,52767,12,52853,52879,12,52965,52991,12,53077,53103,12,53189,53215,12,53301,53327,12,53413,53439,12,53525,53551,12,53637,53663,12,53749,53775,12,53861,53887,12,53973,53999,12,54085,54111,12,54197,54223,12,54309,54335,12,54421,54447,12,54533,54559,12,54645,54671,12,54757,54783,12,54869,54895,12,54981,55007,12,55093,55119,12,55243,55291,10,66045,66045,5,68325,68326,5,69688,69702,5,69817,69818,5,69957,69958,7,70089,70092,5,70198,70199,5,70462,70462,5,70502,70508,5,70750,70750,5,70846,70846,7,71100,71101,5,71230,71230,7,71351,71351,5,71737,71738,5,72000,72000,7,72160,72160,5,72273,72278,5,72752,72758,5,72882,72883,5,73031,73031,5,73461,73462,7,94192,94193,7,119149,119149,7,121403,121452,5,122915,122916,5,126980,126980,14,127358,127359,14,127535,127535,14,127759,127759,14,127771,127771,14,127792,127793,14,127825,127867,14,127897,127899,14,127945,127945,14,127985,127986,14,128000,128007,14,128021,128021,14,128066,128100,14,128184,128235,14,128249,128252,14,128266,128276,14,128335,128335,14,128379,128390,14,128407,128419,14,128444,128444,14,128481,128481,14,128499,128499,14,128526,128526,14,128536,128536,14,128543,128543,14,128556,128556,14,128564,128564,14,128577,128580,14,128643,128645,14,128649,128649,14,128654,128654,14,128660,128660,14,128664,128664,14,128675,128675,14,128686,128689,14,128695,128696,14,128705,128709,14,128717,128719,14,128725,128725,14,128736,128741,14,128747,128748,14,128755,128755,14,128762,128762,14,128981,128991,14,129009,129023,14,129160,129167,14,129296,129304,14,129320,129327,14,129340,129342,14,129356,129356,14,129388,129392,14,129399,129400,14,129404,129407,14,129432,129442,14,129454,129455,14,129473,129474,14,129485,129487,14,129648,129651,14,129659,129660,14,129671,129679,14,129709,129711,14,129728,129730,14,129751,129753,14,129776,129782,14,917505,917505,4,917760,917999,5,10,10,3,127,159,4,768,879,5,1471,1471,5,1536,1541,1,1648,1648,5,1767,1768,5,1840,1866,5,2070,2073,5,2137,2139,5,2274,2274,1,2363,2363,7,2377,2380,7,2402,2403,5,2494,2494,5,2507,2508,7,2558,2558,5,2622,2624,7,2641,2641,5,2691,2691,7,2759,2760,5,2786,2787,5,2876,2876,5,2881,2884,5,2901,2902,5,3006,3006,5,3014,3016,7,3072,3072,5,3134,3136,5,3157,3158,5,3260,3260,5,3266,3266,5,3274,3275,7,3328,3329,5,3391,3392,7,3405,3405,5,3457,3457,5,3536,3537,7,3551,3551,5,3636,3642,5,3764,3772,5,3895,3895,5,3967,3967,7,3993,4028,5,4146,4151,5,4182,4183,7,4226,4226,5,4253,4253,5,4957,4959,5,5940,5940,7,6070,6070,7,6087,6088,7,6158,6158,4,6432,6434,5,6448,6449,7,6679,6680,5,6742,6742,5,6754,6754,5,6783,6783,5,6912,6915,5,6966,6970,5,6978,6978,5,7042,7042,7,7080,7081,5,7143,7143,7,7150,7150,7,7212,7219,5,7380,7392,5,7412,7412,5,8203,8203,4,8232,8232,4,8265,8265,14,8400,8412,5,8421,8432,5,8617,8618,14,9167,9167,14,9200,9200,14,9410,9410,14,9723,9726,14,9733,9733,14,9745,9745,14,9752,9752,14,9760,9760,14,9766,9766,14,9774,9774,14,9786,9786,14,9794,9794,14,9823,9823,14,9828,9828,14,9833,9850,14,9855,9855,14,9875,9875,14,9880,9880,14,9885,9887,14,9896,9897,14,9906,9916,14,9926,9927,14,9935,9935,14,9939,9939,14,9962,9962,14,9972,9972,14,9978,9978,14,9986,9986,14,9997,9997,14,10002,10002,14,10017,10017,14,10055,10055,14,10071,10071,14,10133,10135,14,10548,10549,14,11093,11093,14,12330,12333,5,12441,12442,5,42608,42610,5,43010,43010,5,43045,43046,5,43188,43203,7,43302,43309,5,43392,43394,5,43446,43449,5,43493,43493,5,43571,43572,7,43597,43597,7,43703,43704,5,43756,43757,5,44003,44004,7,44009,44010,7,44033,44059,12,44089,44115,12,44145,44171,12,44201,44227,12,44257,44283,12,44313,44339,12,44369,44395,12,44425,44451,12,44481,44507,12,44537,44563,12,44593,44619,12,44649,44675,12,44705,44731,12,44761,44787,12,44817,44843,12,44873,44899,12,44929,44955,12,44985,45011,12,45041,45067,12,45097,45123,12,45153,45179,12,45209,45235,12,45265,45291,12,45321,45347,12,45377,45403,12,45433,45459,12,45489,45515,12,45545,45571,12,45601,45627,12,45657,45683,12,45713,45739,12,45769,45795,12,45825,45851,12,45881,45907,12,45937,45963,12,45993,46019,12,46049,46075,12,46105,46131,12,46161,46187,12,46217,46243,12,46273,46299,12,46329,46355,12,46385,46411,12,46441,46467,12,46497,46523,12,46553,46579,12,46609,46635,12,46665,46691,12,46721,46747,12,46777,46803,12,46833,46859,12,46889,46915,12,46945,46971,12,47001,47027,12,47057,47083,12,47113,47139,12,47169,47195,12,47225,47251,12,47281,47307,12,47337,47363,12,47393,47419,12,47449,47475,12,47505,47531,12,47561,47587,12,47617,47643,12,47673,47699,12,47729,47755,12,47785,47811,12,47841,47867,12,47897,47923,12,47953,47979,12,48009,48035,12,48065,48091,12,48121,48147,12,48177,48203,12,48233,48259,12,48289,48315,12,48345,48371,12,48401,48427,12,48457,48483,12,48513,48539,12,48569,48595,12,48625,48651,12,48681,48707,12,48737,48763,12,48793,48819,12,48849,48875,12,48905,48931,12,48961,48987,12,49017,49043,12,49073,49099,12,49129,49155,12,49185,49211,12,49241,49267,12,49297,49323,12,49353,49379,12,49409,49435,12,49465,49491,12,49521,49547,12,49577,49603,12,49633,49659,12,49689,49715,12,49745,49771,12,49801,49827,12,49857,49883,12,49913,49939,12,49969,49995,12,50025,50051,12,50081,50107,12,50137,50163,12,50193,50219,12,50249,50275,12,50305,50331,12,50361,50387,12,50417,50443,12,50473,50499,12,50529,50555,12,50585,50611,12,50641,50667,12,50697,50723,12,50753,50779,12,50809,50835,12,50865,50891,12,50921,50947,12,50977,51003,12,51033,51059,12,51089,51115,12,51145,51171,12,51201,51227,12,51257,51283,12,51313,51339,12,51369,51395,12,51425,51451,12,51481,51507,12,51537,51563,12,51593,51619,12,51649,51675,12,51705,51731,12,51761,51787,12,51817,51843,12,51873,51899,12,51929,51955,12,51985,52011,12,52041,52067,12,52097,52123,12,52153,52179,12,52209,52235,12,52265,52291,12,52321,52347,12,52377,52403,12,52433,52459,12,52489,52515,12,52545,52571,12,52601,52627,12,52657,52683,12,52713,52739,12,52769,52795,12,52825,52851,12,52881,52907,12,52937,52963,12,52993,53019,12,53049,53075,12,53105,53131,12,53161,53187,12,53217,53243,12,53273,53299,12,53329,53355,12,53385,53411,12,53441,53467,12,53497,53523,12,53553,53579,12,53609,53635,12,53665,53691,12,53721,53747,12,53777,53803,12,53833,53859,12,53889,53915,12,53945,53971,12,54001,54027,12,54057,54083,12,54113,54139,12,54169,54195,12,54225,54251,12,54281,54307,12,54337,54363,12,54393,54419,12,54449,54475,12,54505,54531,12,54561,54587,12,54617,54643,12,54673,54699,12,54729,54755,12,54785,54811,12,54841,54867,12,54897,54923,12,54953,54979,12,55009,55035,12,55065,55091,12,55121,55147,12,55177,55203,12,65024,65039,5,65520,65528,4,66422,66426,5,68152,68154,5,69291,69292,5,69633,69633,5,69747,69748,5,69811,69814,5,69826,69826,5,69932,69932,7,70016,70017,5,70079,70080,7,70095,70095,5,70196,70196,5,70367,70367,5,70402,70403,7,70464,70464,5,70487,70487,5,70709,70711,7,70725,70725,7,70833,70834,7,70843,70844,7,70849,70849,7,71090,71093,5,71103,71104,5,71227,71228,7,71339,71339,5,71344,71349,5,71458,71461,5,71727,71735,5,71985,71989,7,71998,71998,5,72002,72002,7,72154,72155,5,72193,72202,5,72251,72254,5,72281,72283,5,72344,72345,5,72766,72766,7,72874,72880,5,72885,72886,5,73023,73029,5,73104,73105,5,73111,73111,5,92912,92916,5,94095,94098,5,113824,113827,4,119142,119142,7,119155,119162,4,119362,119364,5,121476,121476,5,122888,122904,5,123184,123190,5,125252,125258,5,127183,127183,14,127340,127343,14,127377,127386,14,127491,127503,14,127548,127551,14,127744,127756,14,127761,127761,14,127769,127769,14,127773,127774,14,127780,127788,14,127796,127797,14,127820,127823,14,127869,127869,14,127894,127895,14,127902,127903,14,127943,127943,14,127947,127950,14,127972,127972,14,127988,127988,14,127992,127994,14,128009,128011,14,128019,128019,14,128023,128041,14,128064,128064,14,128102,128107,14,128174,128181,14,128238,128238,14,128246,128247,14,128254,128254,14,128264,128264,14,128278,128299,14,128329,128330,14,128348,128359,14,128371,128377,14,128392,128393,14,128401,128404,14,128421,128421,14,128433,128434,14,128450,128452,14,128476,128478,14,128483,128483,14,128495,128495,14,128506,128506,14,128519,128520,14,128528,128528,14,128534,128534,14,128538,128538,14,128540,128542,14,128544,128549,14,128552,128555,14,128557,128557,14,128560,128563,14,128565,128565,14,128567,128576,14,128581,128591,14,128641,128642,14,128646,128646,14,128648,128648,14,128650,128651,14,128653,128653,14,128655,128655,14,128657,128659,14,128661,128661,14,128663,128663,14,128665,128666,14,128674,128674,14,128676,128677,14,128679,128685,14,128690,128690,14,128694,128694,14,128697,128702,14,128704,128704,14,128710,128714,14,128716,128716,14,128720,128720,14,128723,128724,14,128726,128727,14,128733,128735,14,128742,128744,14,128746,128746,14,128749,128751,14,128753,128754,14,128756,128758,14,128761,128761,14,128763,128764,14,128884,128895,14,128992,129003,14,129008,129008,14,129036,129039,14,129114,129119,14,129198,129279,14,129293,129295,14,129305,129310,14,129312,129319,14,129328,129328,14,129331,129338,14,129343,129343,14,129351,129355,14,129357,129359,14,129375,129387,14,129393,129393,14,129395,129398,14,129401,129401,14,129403,129403,14,129408,129412,14,129426,129431,14,129443,129444,14,129451,129453,14,129456,129465,14,129472,129472,14,129475,129482,14,129484,129484,14,129488,129510,14,129536,129647,14,129652,129652,14,129656,129658,14,129661,129663,14,129667,129670,14,129680,129685,14,129705,129708,14,129712,129718,14,129723,129727,14,129731,129733,14,129744,129750,14,129754,129759,14,129768,129775,14,129783,129791,14,917504,917504,4,917506,917535,4,917632,917759,4,918000,921599,4,0,9,4,11,12,4,14,31,4,169,169,14,174,174,14,1155,1159,5,1425,1469,5,1473,1474,5,1479,1479,5,1552,1562,5,1611,1631,5,1750,1756,5,1759,1764,5,1770,1773,5,1809,1809,5,1958,1968,5,2045,2045,5,2075,2083,5,2089,2093,5,2192,2193,1,2250,2273,5,2275,2306,5,2362,2362,5,2364,2364,5,2369,2376,5,2381,2381,5,2385,2391,5,2433,2433,5,2492,2492,5,2495,2496,7,2503,2504,7,2509,2509,5,2530,2531,5,2561,2562,5,2620,2620,5,2625,2626,5,2635,2637,5,2672,2673,5,2689,2690,5,2748,2748,5,2753,2757,5,2761,2761,7,2765,2765,5,2810,2815,5,2818,2819,7,2878,2878,5,2880,2880,7,2887,2888,7,2893,2893,5,2903,2903,5,2946,2946,5,3007,3007,7,3009,3010,7,3018,3020,7,3031,3031,5,3073,3075,7,3132,3132,5,3137,3140,7,3146,3149,5,3170,3171,5,3202,3203,7,3262,3262,7,3264,3265,7,3267,3268,7,3271,3272,7,3276,3277,5,3298,3299,5,3330,3331,7,3390,3390,5,3393,3396,5,3402,3404,7,3406,3406,1,3426,3427,5,3458,3459,7,3535,3535,5,3538,3540,5,3544,3550,7,3570,3571,7,3635,3635,7,3655,3662,5,3763,3763,7,3784,3789,5,3893,3893,5,3897,3897,5,3953,3966,5,3968,3972,5,3981,3991,5,4038,4038,5,4145,4145,7,4153,4154,5,4157,4158,5,4184,4185,5,4209,4212,5,4228,4228,7,4237,4237,5,4352,4447,8,4520,4607,10,5906,5908,5,5938,5939,5,5970,5971,5,6068,6069,5,6071,6077,5,6086,6086,5,6089,6099,5,6155,6157,5,6159,6159,5,6313,6313,5,6435,6438,7,6441,6443,7,6450,6450,5,6457,6459,5,6681,6682,7,6741,6741,7,6743,6743,7,6752,6752,5,6757,6764,5,6771,6780,5,6832,6845,5,6847,6862,5,6916,6916,7,6965,6965,5,6971,6971,7,6973,6977,7,6979,6980,7,7040,7041,5,7073,7073,7,7078,7079,7,7082,7082,7,7142,7142,5,7144,7145,5,7149,7149,5,7151,7153,5,7204,7211,7,7220,7221,7,7376,7378,5,7393,7393,7,7405,7405,5,7415,7415,7,7616,7679,5,8204,8204,5,8206,8207,4,8233,8233,4,8252,8252,14,8288,8292,4,8294,8303,4,8413,8416,5,8418,8420,5,8482,8482,14,8596,8601,14,8986,8987,14,9096,9096,14,9193,9196,14,9199,9199,14,9201,9202,14,9208,9210,14,9642,9643,14,9664,9664,14,9728,9729,14,9732,9732,14,9735,9741,14,9743,9744,14,9746,9746,14,9750,9751,14,9753,9756,14,9758,9759,14,9761,9761,14,9764,9765,14,9767,9769,14,9771,9773,14,9775,9775,14,9784,9785,14,9787,9791,14,9793,9793,14,9795,9799,14,9812,9822,14,9824,9824,14,9827,9827,14,9829,9830,14,9832,9832,14,9851,9851,14,9854,9854,14,9856,9861,14,9874,9874,14,9876,9876,14,9878,9879,14,9881,9881,14,9883,9884,14,9888,9889,14,9895,9895,14,9898,9899,14,9904,9905,14,9917,9918,14,9924,9925,14,9928,9928,14,9934,9934,14,9936,9936,14,9938,9938,14,9940,9940,14,9961,9961,14,9963,9967,14,9970,9971,14,9973,9973,14,9975,9977,14,9979,9980,14,9982,9985,14,9987,9988,14,9992,9996,14,9998,9998,14,10000,10001,14,10004,10004,14,10013,10013,14,10024,10024,14,10052,10052,14,10060,10060,14,10067,10069,14,10083,10083,14,10085,10087,14,10145,10145,14,10175,10175,14,11013,11015,14,11088,11088,14,11503,11505,5,11744,11775,5,12334,12335,5,12349,12349,14,12951,12951,14,42607,42607,5,42612,42621,5,42736,42737,5,43014,43014,5,43043,43044,7,43047,43047,7,43136,43137,7,43204,43205,5,43263,43263,5,43335,43345,5,43360,43388,8,43395,43395,7,43444,43445,7,43450,43451,7,43454,43456,7,43561,43566,5,43569,43570,5,43573,43574,5,43596,43596,5,43644,43644,5,43698,43700,5,43710,43711,5,43755,43755,7,43758,43759,7,43766,43766,5,44005,44005,5,44008,44008,5,44012,44012,7,44032,44032,11,44060,44060,11,44088,44088,11,44116,44116,11,44144,44144,11,44172,44172,11,44200,44200,11,44228,44228,11,44256,44256,11,44284,44284,11,44312,44312,11,44340,44340,11,44368,44368,11,44396,44396,11,44424,44424,11,44452,44452,11,44480,44480,11,44508,44508,11,44536,44536,11,44564,44564,11,44592,44592,11,44620,44620,11,44648,44648,11,44676,44676,11,44704,44704,11,44732,44732,11,44760,44760,11,44788,44788,11,44816,44816,11,44844,44844,11,44872,44872,11,44900,44900,11,44928,44928,11,44956,44956,11,44984,44984,11,45012,45012,11,45040,45040,11,45068,45068,11,45096,45096,11,45124,45124,11,45152,45152,11,45180,45180,11,45208,45208,11,45236,45236,11,45264,45264,11,45292,45292,11,45320,45320,11,45348,45348,11,45376,45376,11,45404,45404,11,45432,45432,11,45460,45460,11,45488,45488,11,45516,45516,11,45544,45544,11,45572,45572,11,45600,45600,11,45628,45628,11,45656,45656,11,45684,45684,11,45712,45712,11,45740,45740,11,45768,45768,11,45796,45796,11,45824,45824,11,45852,45852,11,45880,45880,11,45908,45908,11,45936,45936,11,45964,45964,11,45992,45992,11,46020,46020,11,46048,46048,11,46076,46076,11,46104,46104,11,46132,46132,11,46160,46160,11,46188,46188,11,46216,46216,11,46244,46244,11,46272,46272,11,46300,46300,11,46328,46328,11,46356,46356,11,46384,46384,11,46412,46412,11,46440,46440,11,46468,46468,11,46496,46496,11,46524,46524,11,46552,46552,11,46580,46580,11,46608,46608,11,46636,46636,11,46664,46664,11,46692,46692,11,46720,46720,11,46748,46748,11,46776,46776,11,46804,46804,11,46832,46832,11,46860,46860,11,46888,46888,11,46916,46916,11,46944,46944,11,46972,46972,11,47000,47000,11,47028,47028,11,47056,47056,11,47084,47084,11,47112,47112,11,47140,47140,11,47168,47168,11,47196,47196,11,47224,47224,11,47252,47252,11,47280,47280,11,47308,47308,11,47336,47336,11,47364,47364,11,47392,47392,11,47420,47420,11,47448,47448,11,47476,47476,11,47504,47504,11,47532,47532,11,47560,47560,11,47588,47588,11,47616,47616,11,47644,47644,11,47672,47672,11,47700,47700,11,47728,47728,11,47756,47756,11,47784,47784,11,47812,47812,11,47840,47840,11,47868,47868,11,47896,47896,11,47924,47924,11,47952,47952,11,47980,47980,11,48008,48008,11,48036,48036,11,48064,48064,11,48092,48092,11,48120,48120,11,48148,48148,11,48176,48176,11,48204,48204,11,48232,48232,11,48260,48260,11,48288,48288,11,48316,48316,11,48344,48344,11,48372,48372,11,48400,48400,11,48428,48428,11,48456,48456,11,48484,48484,11,48512,48512,11,48540,48540,11,48568,48568,11,48596,48596,11,48624,48624,11,48652,48652,11,48680,48680,11,48708,48708,11,48736,48736,11,48764,48764,11,48792,48792,11,48820,48820,11,48848,48848,11,48876,48876,11,48904,48904,11,48932,48932,11,48960,48960,11,48988,48988,11,49016,49016,11,49044,49044,11,49072,49072,11,49100,49100,11,49128,49128,11,49156,49156,11,49184,49184,11,49212,49212,11,49240,49240,11,49268,49268,11,49296,49296,11,49324,49324,11,49352,49352,11,49380,49380,11,49408,49408,11,49436,49436,11,49464,49464,11,49492,49492,11,49520,49520,11,49548,49548,11,49576,49576,11,49604,49604,11,49632,49632,11,49660,49660,11,49688,49688,11,49716,49716,11,49744,49744,11,49772,49772,11,49800,49800,11,49828,49828,11,49856,49856,11,49884,49884,11,49912,49912,11,49940,49940,11,49968,49968,11,49996,49996,11,50024,50024,11,50052,50052,11,50080,50080,11,50108,50108,11,50136,50136,11,50164,50164,11,50192,50192,11,50220,50220,11,50248,50248,11,50276,50276,11,50304,50304,11,50332,50332,11,50360,50360,11,50388,50388,11,50416,50416,11,50444,50444,11,50472,50472,11,50500,50500,11,50528,50528,11,50556,50556,11,50584,50584,11,50612,50612,11,50640,50640,11,50668,50668,11,50696,50696,11,50724,50724,11,50752,50752,11,50780,50780,11,50808,50808,11,50836,50836,11,50864,50864,11,50892,50892,11,50920,50920,11,50948,50948,11,50976,50976,11,51004,51004,11,51032,51032,11,51060,51060,11,51088,51088,11,51116,51116,11,51144,51144,11,51172,51172,11,51200,51200,11,51228,51228,11,51256,51256,11,51284,51284,11,51312,51312,11,51340,51340,11,51368,51368,11,51396,51396,11,51424,51424,11,51452,51452,11,51480,51480,11,51508,51508,11,51536,51536,11,51564,51564,11,51592,51592,11,51620,51620,11,51648,51648,11,51676,51676,11,51704,51704,11,51732,51732,11,51760,51760,11,51788,51788,11,51816,51816,11,51844,51844,11,51872,51872,11,51900,51900,11,51928,51928,11,51956,51956,11,51984,51984,11,52012,52012,11,52040,52040,11,52068,52068,11,52096,52096,11,52124,52124,11,52152,52152,11,52180,52180,11,52208,52208,11,52236,52236,11,52264,52264,11,52292,52292,11,52320,52320,11,52348,52348,11,52376,52376,11,52404,52404,11,52432,52432,11,52460,52460,11,52488,52488,11,52516,52516,11,52544,52544,11,52572,52572,11,52600,52600,11,52628,52628,11,52656,52656,11,52684,52684,11,52712,52712,11,52740,52740,11,52768,52768,11,52796,52796,11,52824,52824,11,52852,52852,11,52880,52880,11,52908,52908,11,52936,52936,11,52964,52964,11,52992,52992,11,53020,53020,11,53048,53048,11,53076,53076,11,53104,53104,11,53132,53132,11,53160,53160,11,53188,53188,11,53216,53216,11,53244,53244,11,53272,53272,11,53300,53300,11,53328,53328,11,53356,53356,11,53384,53384,11,53412,53412,11,53440,53440,11,53468,53468,11,53496,53496,11,53524,53524,11,53552,53552,11,53580,53580,11,53608,53608,11,53636,53636,11,53664,53664,11,53692,53692,11,53720,53720,11,53748,53748,11,53776,53776,11,53804,53804,11,53832,53832,11,53860,53860,11,53888,53888,11,53916,53916,11,53944,53944,11,53972,53972,11,54000,54000,11,54028,54028,11,54056,54056,11,54084,54084,11,54112,54112,11,54140,54140,11,54168,54168,11,54196,54196,11,54224,54224,11,54252,54252,11,54280,54280,11,54308,54308,11,54336,54336,11,54364,54364,11,54392,54392,11,54420,54420,11,54448,54448,11,54476,54476,11,54504,54504,11,54532,54532,11,54560,54560,11,54588,54588,11,54616,54616,11,54644,54644,11,54672,54672,11,54700,54700,11,54728,54728,11,54756,54756,11,54784,54784,11,54812,54812,11,54840,54840,11,54868,54868,11,54896,54896,11,54924,54924,11,54952,54952,11,54980,54980,11,55008,55008,11,55036,55036,11,55064,55064,11,55092,55092,11,55120,55120,11,55148,55148,11,55176,55176,11,55216,55238,9,64286,64286,5,65056,65071,5,65438,65439,5,65529,65531,4,66272,66272,5,68097,68099,5,68108,68111,5,68159,68159,5,68900,68903,5,69446,69456,5,69632,69632,7,69634,69634,7,69744,69744,5,69759,69761,5,69808,69810,7,69815,69816,7,69821,69821,1,69837,69837,1,69927,69931,5,69933,69940,5,70003,70003,5,70018,70018,7,70070,70078,5,70082,70083,1,70094,70094,7,70188,70190,7,70194,70195,7,70197,70197,7,70206,70206,5,70368,70370,7,70400,70401,5,70459,70460,5,70463,70463,7,70465,70468,7,70475,70477,7,70498,70499,7,70512,70516,5,70712,70719,5,70722,70724,5,70726,70726,5,70832,70832,5,70835,70840,5,70842,70842,5,70845,70845,5,70847,70848,5,70850,70851,5,71088,71089,7,71096,71099,7,71102,71102,7,71132,71133,5,71219,71226,5,71229,71229,5,71231,71232,5,71340,71340,7,71342,71343,7,71350,71350,7,71453,71455,5,71462,71462,7,71724,71726,7,71736,71736,7,71984,71984,5,71991,71992,7,71997,71997,7,71999,71999,1,72001,72001,1,72003,72003,5,72148,72151,5,72156,72159,7,72164,72164,7,72243,72248,5,72250,72250,1,72263,72263,5,72279,72280,7,72324,72329,1,72343,72343,7,72751,72751,7,72760,72765,5,72767,72767,5,72873,72873,7,72881,72881,7,72884,72884,7,73009,73014,5,73020,73021,5,73030,73030,1,73098,73102,7,73107,73108,7,73110,73110,7,73459,73460,5,78896,78904,4,92976,92982,5,94033,94087,7,94180,94180,5,113821,113822,5,118528,118573,5,119141,119141,5,119143,119145,5,119150,119154,5,119163,119170,5,119210,119213,5,121344,121398,5,121461,121461,5,121499,121503,5,122880,122886,5,122907,122913,5,122918,122922,5,123566,123566,5,125136,125142,5,126976,126979,14,126981,127182,14,127184,127231,14,127279,127279,14,127344,127345,14,127374,127374,14,127405,127461,14,127489,127490,14,127514,127514,14,127538,127546,14,127561,127567,14,127570,127743,14,127757,127758,14,127760,127760,14,127762,127762,14,127766,127768,14,127770,127770,14,127772,127772,14,127775,127776,14,127778,127779,14,127789,127791,14,127794,127795,14,127798,127798,14,127819,127819,14,127824,127824,14,127868,127868,14,127870,127871,14,127892,127893,14,127896,127896,14,127900,127901,14,127904,127940,14,127942,127942,14,127944,127944,14,127946,127946,14,127951,127955,14,127968,127971,14,127973,127984,14,127987,127987,14,127989,127989,14,127991,127991,14,127995,127999,5,128008,128008,14,128012,128014,14,128017,128018,14,128020,128020,14,128022,128022,14,128042,128042,14,128063,128063,14,128065,128065,14,128101,128101,14,128108,128109,14,128173,128173,14,128182,128183,14,128236,128237,14,128239,128239,14,128245,128245,14,128248,128248,14,128253,128253,14,128255,128258,14,128260,128263,14,128265,128265,14,128277,128277,14,128300,128301,14,128326,128328,14,128331,128334,14,128336,128347,14,128360,128366,14,128369,128370,14,128378,128378,14,128391,128391,14,128394,128397,14,128400,128400,14,128405,128406,14,128420,128420,14,128422,128423,14,128425,128432,14,128435,128443,14,128445,128449,14,128453,128464,14,128468,128475,14,128479,128480,14,128482,128482,14,128484,128487,14,128489,128494,14,128496,128498,14,128500,128505,14,128507,128511,14,128513,128518,14,128521,128525,14,128527,128527,14,128529,128529,14,128533,128533,14,128535,128535,14,128537,128537,14]");
}
function I0t(r, e) {
  if (r === 0)
    return 0;
  const t = O0t(r, e);
  if (t !== void 0)
    return t;
  const n = new VI(e, r);
  return n.prevCodePoint(), n.offset;
}
function O0t(r, e) {
  const t = new VI(e, r);
  let n = t.prevCodePoint();
  for (; R0t(n) || n === 65039 || n === 8419; ) {
    if (t.offset === 0)
      return;
    n = t.prevCodePoint();
  }
  if (!PI(n))
    return;
  let i = t.offset;
  return i > 0 && t.prevCodePoint() === 8205 && (i = t.offset), i;
}
function R0t(r) {
  return 127995 <= r && r <= 127999;
}
class Tu {
  static {
    this.ambiguousCharacterData = new o1(() => JSON.parse('{"_common":[8232,32,8233,32,5760,32,8192,32,8193,32,8194,32,8195,32,8196,32,8197,32,8198,32,8200,32,8201,32,8202,32,8287,32,8199,32,8239,32,2042,95,65101,95,65102,95,65103,95,8208,45,8209,45,8210,45,65112,45,1748,45,8259,45,727,45,8722,45,10134,45,11450,45,1549,44,1643,44,8218,44,184,44,42233,44,894,59,2307,58,2691,58,1417,58,1795,58,1796,58,5868,58,65072,58,6147,58,6153,58,8282,58,1475,58,760,58,42889,58,8758,58,720,58,42237,58,451,33,11601,33,660,63,577,63,2429,63,5038,63,42731,63,119149,46,8228,46,1793,46,1794,46,42510,46,68176,46,1632,46,1776,46,42232,46,1373,96,65287,96,8219,96,8242,96,1370,96,1523,96,8175,96,65344,96,900,96,8189,96,8125,96,8127,96,8190,96,697,96,884,96,712,96,714,96,715,96,756,96,699,96,701,96,700,96,702,96,42892,96,1497,96,2036,96,2037,96,5194,96,5836,96,94033,96,94034,96,65339,91,10088,40,10098,40,12308,40,64830,40,65341,93,10089,41,10099,41,12309,41,64831,41,10100,123,119060,123,10101,125,65342,94,8270,42,1645,42,8727,42,66335,42,5941,47,8257,47,8725,47,8260,47,9585,47,10187,47,10744,47,119354,47,12755,47,12339,47,11462,47,20031,47,12035,47,65340,92,65128,92,8726,92,10189,92,10741,92,10745,92,119311,92,119355,92,12756,92,20022,92,12034,92,42872,38,708,94,710,94,5869,43,10133,43,66203,43,8249,60,10094,60,706,60,119350,60,5176,60,5810,60,5120,61,11840,61,12448,61,42239,61,8250,62,10095,62,707,62,119351,62,5171,62,94015,62,8275,126,732,126,8128,126,8764,126,65372,124,65293,45,120784,50,120794,50,120804,50,120814,50,120824,50,130034,50,42842,50,423,50,1000,50,42564,50,5311,50,42735,50,119302,51,120785,51,120795,51,120805,51,120815,51,120825,51,130035,51,42923,51,540,51,439,51,42858,51,11468,51,1248,51,94011,51,71882,51,120786,52,120796,52,120806,52,120816,52,120826,52,130036,52,5070,52,71855,52,120787,53,120797,53,120807,53,120817,53,120827,53,130037,53,444,53,71867,53,120788,54,120798,54,120808,54,120818,54,120828,54,130038,54,11474,54,5102,54,71893,54,119314,55,120789,55,120799,55,120809,55,120819,55,120829,55,130039,55,66770,55,71878,55,2819,56,2538,56,2666,56,125131,56,120790,56,120800,56,120810,56,120820,56,120830,56,130040,56,547,56,546,56,66330,56,2663,57,2920,57,2541,57,3437,57,120791,57,120801,57,120811,57,120821,57,120831,57,130041,57,42862,57,11466,57,71884,57,71852,57,71894,57,9082,97,65345,97,119834,97,119886,97,119938,97,119990,97,120042,97,120094,97,120146,97,120198,97,120250,97,120302,97,120354,97,120406,97,120458,97,593,97,945,97,120514,97,120572,97,120630,97,120688,97,120746,97,65313,65,119808,65,119860,65,119912,65,119964,65,120016,65,120068,65,120120,65,120172,65,120224,65,120276,65,120328,65,120380,65,120432,65,913,65,120488,65,120546,65,120604,65,120662,65,120720,65,5034,65,5573,65,42222,65,94016,65,66208,65,119835,98,119887,98,119939,98,119991,98,120043,98,120095,98,120147,98,120199,98,120251,98,120303,98,120355,98,120407,98,120459,98,388,98,5071,98,5234,98,5551,98,65314,66,8492,66,119809,66,119861,66,119913,66,120017,66,120069,66,120121,66,120173,66,120225,66,120277,66,120329,66,120381,66,120433,66,42932,66,914,66,120489,66,120547,66,120605,66,120663,66,120721,66,5108,66,5623,66,42192,66,66178,66,66209,66,66305,66,65347,99,8573,99,119836,99,119888,99,119940,99,119992,99,120044,99,120096,99,120148,99,120200,99,120252,99,120304,99,120356,99,120408,99,120460,99,7428,99,1010,99,11429,99,43951,99,66621,99,128844,67,71922,67,71913,67,65315,67,8557,67,8450,67,8493,67,119810,67,119862,67,119914,67,119966,67,120018,67,120174,67,120226,67,120278,67,120330,67,120382,67,120434,67,1017,67,11428,67,5087,67,42202,67,66210,67,66306,67,66581,67,66844,67,8574,100,8518,100,119837,100,119889,100,119941,100,119993,100,120045,100,120097,100,120149,100,120201,100,120253,100,120305,100,120357,100,120409,100,120461,100,1281,100,5095,100,5231,100,42194,100,8558,68,8517,68,119811,68,119863,68,119915,68,119967,68,120019,68,120071,68,120123,68,120175,68,120227,68,120279,68,120331,68,120383,68,120435,68,5024,68,5598,68,5610,68,42195,68,8494,101,65349,101,8495,101,8519,101,119838,101,119890,101,119942,101,120046,101,120098,101,120150,101,120202,101,120254,101,120306,101,120358,101,120410,101,120462,101,43826,101,1213,101,8959,69,65317,69,8496,69,119812,69,119864,69,119916,69,120020,69,120072,69,120124,69,120176,69,120228,69,120280,69,120332,69,120384,69,120436,69,917,69,120492,69,120550,69,120608,69,120666,69,120724,69,11577,69,5036,69,42224,69,71846,69,71854,69,66182,69,119839,102,119891,102,119943,102,119995,102,120047,102,120099,102,120151,102,120203,102,120255,102,120307,102,120359,102,120411,102,120463,102,43829,102,42905,102,383,102,7837,102,1412,102,119315,70,8497,70,119813,70,119865,70,119917,70,120021,70,120073,70,120125,70,120177,70,120229,70,120281,70,120333,70,120385,70,120437,70,42904,70,988,70,120778,70,5556,70,42205,70,71874,70,71842,70,66183,70,66213,70,66853,70,65351,103,8458,103,119840,103,119892,103,119944,103,120048,103,120100,103,120152,103,120204,103,120256,103,120308,103,120360,103,120412,103,120464,103,609,103,7555,103,397,103,1409,103,119814,71,119866,71,119918,71,119970,71,120022,71,120074,71,120126,71,120178,71,120230,71,120282,71,120334,71,120386,71,120438,71,1292,71,5056,71,5107,71,42198,71,65352,104,8462,104,119841,104,119945,104,119997,104,120049,104,120101,104,120153,104,120205,104,120257,104,120309,104,120361,104,120413,104,120465,104,1211,104,1392,104,5058,104,65320,72,8459,72,8460,72,8461,72,119815,72,119867,72,119919,72,120023,72,120179,72,120231,72,120283,72,120335,72,120387,72,120439,72,919,72,120494,72,120552,72,120610,72,120668,72,120726,72,11406,72,5051,72,5500,72,42215,72,66255,72,731,105,9075,105,65353,105,8560,105,8505,105,8520,105,119842,105,119894,105,119946,105,119998,105,120050,105,120102,105,120154,105,120206,105,120258,105,120310,105,120362,105,120414,105,120466,105,120484,105,618,105,617,105,953,105,8126,105,890,105,120522,105,120580,105,120638,105,120696,105,120754,105,1110,105,42567,105,1231,105,43893,105,5029,105,71875,105,65354,106,8521,106,119843,106,119895,106,119947,106,119999,106,120051,106,120103,106,120155,106,120207,106,120259,106,120311,106,120363,106,120415,106,120467,106,1011,106,1112,106,65322,74,119817,74,119869,74,119921,74,119973,74,120025,74,120077,74,120129,74,120181,74,120233,74,120285,74,120337,74,120389,74,120441,74,42930,74,895,74,1032,74,5035,74,5261,74,42201,74,119844,107,119896,107,119948,107,120000,107,120052,107,120104,107,120156,107,120208,107,120260,107,120312,107,120364,107,120416,107,120468,107,8490,75,65323,75,119818,75,119870,75,119922,75,119974,75,120026,75,120078,75,120130,75,120182,75,120234,75,120286,75,120338,75,120390,75,120442,75,922,75,120497,75,120555,75,120613,75,120671,75,120729,75,11412,75,5094,75,5845,75,42199,75,66840,75,1472,108,8739,73,9213,73,65512,73,1633,108,1777,73,66336,108,125127,108,120783,73,120793,73,120803,73,120813,73,120823,73,130033,73,65321,73,8544,73,8464,73,8465,73,119816,73,119868,73,119920,73,120024,73,120128,73,120180,73,120232,73,120284,73,120336,73,120388,73,120440,73,65356,108,8572,73,8467,108,119845,108,119897,108,119949,108,120001,108,120053,108,120105,73,120157,73,120209,73,120261,73,120313,73,120365,73,120417,73,120469,73,448,73,120496,73,120554,73,120612,73,120670,73,120728,73,11410,73,1030,73,1216,73,1493,108,1503,108,1575,108,126464,108,126592,108,65166,108,65165,108,1994,108,11599,73,5825,73,42226,73,93992,73,66186,124,66313,124,119338,76,8556,76,8466,76,119819,76,119871,76,119923,76,120027,76,120079,76,120131,76,120183,76,120235,76,120287,76,120339,76,120391,76,120443,76,11472,76,5086,76,5290,76,42209,76,93974,76,71843,76,71858,76,66587,76,66854,76,65325,77,8559,77,8499,77,119820,77,119872,77,119924,77,120028,77,120080,77,120132,77,120184,77,120236,77,120288,77,120340,77,120392,77,120444,77,924,77,120499,77,120557,77,120615,77,120673,77,120731,77,1018,77,11416,77,5047,77,5616,77,5846,77,42207,77,66224,77,66321,77,119847,110,119899,110,119951,110,120003,110,120055,110,120107,110,120159,110,120211,110,120263,110,120315,110,120367,110,120419,110,120471,110,1400,110,1404,110,65326,78,8469,78,119821,78,119873,78,119925,78,119977,78,120029,78,120081,78,120185,78,120237,78,120289,78,120341,78,120393,78,120445,78,925,78,120500,78,120558,78,120616,78,120674,78,120732,78,11418,78,42208,78,66835,78,3074,111,3202,111,3330,111,3458,111,2406,111,2662,111,2790,111,3046,111,3174,111,3302,111,3430,111,3664,111,3792,111,4160,111,1637,111,1781,111,65359,111,8500,111,119848,111,119900,111,119952,111,120056,111,120108,111,120160,111,120212,111,120264,111,120316,111,120368,111,120420,111,120472,111,7439,111,7441,111,43837,111,959,111,120528,111,120586,111,120644,111,120702,111,120760,111,963,111,120532,111,120590,111,120648,111,120706,111,120764,111,11423,111,4351,111,1413,111,1505,111,1607,111,126500,111,126564,111,126596,111,65259,111,65260,111,65258,111,65257,111,1726,111,64428,111,64429,111,64427,111,64426,111,1729,111,64424,111,64425,111,64423,111,64422,111,1749,111,3360,111,4125,111,66794,111,71880,111,71895,111,66604,111,1984,79,2534,79,2918,79,12295,79,70864,79,71904,79,120782,79,120792,79,120802,79,120812,79,120822,79,130032,79,65327,79,119822,79,119874,79,119926,79,119978,79,120030,79,120082,79,120134,79,120186,79,120238,79,120290,79,120342,79,120394,79,120446,79,927,79,120502,79,120560,79,120618,79,120676,79,120734,79,11422,79,1365,79,11604,79,4816,79,2848,79,66754,79,42227,79,71861,79,66194,79,66219,79,66564,79,66838,79,9076,112,65360,112,119849,112,119901,112,119953,112,120005,112,120057,112,120109,112,120161,112,120213,112,120265,112,120317,112,120369,112,120421,112,120473,112,961,112,120530,112,120544,112,120588,112,120602,112,120646,112,120660,112,120704,112,120718,112,120762,112,120776,112,11427,112,65328,80,8473,80,119823,80,119875,80,119927,80,119979,80,120031,80,120083,80,120187,80,120239,80,120291,80,120343,80,120395,80,120447,80,929,80,120504,80,120562,80,120620,80,120678,80,120736,80,11426,80,5090,80,5229,80,42193,80,66197,80,119850,113,119902,113,119954,113,120006,113,120058,113,120110,113,120162,113,120214,113,120266,113,120318,113,120370,113,120422,113,120474,113,1307,113,1379,113,1382,113,8474,81,119824,81,119876,81,119928,81,119980,81,120032,81,120084,81,120188,81,120240,81,120292,81,120344,81,120396,81,120448,81,11605,81,119851,114,119903,114,119955,114,120007,114,120059,114,120111,114,120163,114,120215,114,120267,114,120319,114,120371,114,120423,114,120475,114,43847,114,43848,114,7462,114,11397,114,43905,114,119318,82,8475,82,8476,82,8477,82,119825,82,119877,82,119929,82,120033,82,120189,82,120241,82,120293,82,120345,82,120397,82,120449,82,422,82,5025,82,5074,82,66740,82,5511,82,42211,82,94005,82,65363,115,119852,115,119904,115,119956,115,120008,115,120060,115,120112,115,120164,115,120216,115,120268,115,120320,115,120372,115,120424,115,120476,115,42801,115,445,115,1109,115,43946,115,71873,115,66632,115,65331,83,119826,83,119878,83,119930,83,119982,83,120034,83,120086,83,120138,83,120190,83,120242,83,120294,83,120346,83,120398,83,120450,83,1029,83,1359,83,5077,83,5082,83,42210,83,94010,83,66198,83,66592,83,119853,116,119905,116,119957,116,120009,116,120061,116,120113,116,120165,116,120217,116,120269,116,120321,116,120373,116,120425,116,120477,116,8868,84,10201,84,128872,84,65332,84,119827,84,119879,84,119931,84,119983,84,120035,84,120087,84,120139,84,120191,84,120243,84,120295,84,120347,84,120399,84,120451,84,932,84,120507,84,120565,84,120623,84,120681,84,120739,84,11430,84,5026,84,42196,84,93962,84,71868,84,66199,84,66225,84,66325,84,119854,117,119906,117,119958,117,120010,117,120062,117,120114,117,120166,117,120218,117,120270,117,120322,117,120374,117,120426,117,120478,117,42911,117,7452,117,43854,117,43858,117,651,117,965,117,120534,117,120592,117,120650,117,120708,117,120766,117,1405,117,66806,117,71896,117,8746,85,8899,85,119828,85,119880,85,119932,85,119984,85,120036,85,120088,85,120140,85,120192,85,120244,85,120296,85,120348,85,120400,85,120452,85,1357,85,4608,85,66766,85,5196,85,42228,85,94018,85,71864,85,8744,118,8897,118,65366,118,8564,118,119855,118,119907,118,119959,118,120011,118,120063,118,120115,118,120167,118,120219,118,120271,118,120323,118,120375,118,120427,118,120479,118,7456,118,957,118,120526,118,120584,118,120642,118,120700,118,120758,118,1141,118,1496,118,71430,118,43945,118,71872,118,119309,86,1639,86,1783,86,8548,86,119829,86,119881,86,119933,86,119985,86,120037,86,120089,86,120141,86,120193,86,120245,86,120297,86,120349,86,120401,86,120453,86,1140,86,11576,86,5081,86,5167,86,42719,86,42214,86,93960,86,71840,86,66845,86,623,119,119856,119,119908,119,119960,119,120012,119,120064,119,120116,119,120168,119,120220,119,120272,119,120324,119,120376,119,120428,119,120480,119,7457,119,1121,119,1309,119,1377,119,71434,119,71438,119,71439,119,43907,119,71919,87,71910,87,119830,87,119882,87,119934,87,119986,87,120038,87,120090,87,120142,87,120194,87,120246,87,120298,87,120350,87,120402,87,120454,87,1308,87,5043,87,5076,87,42218,87,5742,120,10539,120,10540,120,10799,120,65368,120,8569,120,119857,120,119909,120,119961,120,120013,120,120065,120,120117,120,120169,120,120221,120,120273,120,120325,120,120377,120,120429,120,120481,120,5441,120,5501,120,5741,88,9587,88,66338,88,71916,88,65336,88,8553,88,119831,88,119883,88,119935,88,119987,88,120039,88,120091,88,120143,88,120195,88,120247,88,120299,88,120351,88,120403,88,120455,88,42931,88,935,88,120510,88,120568,88,120626,88,120684,88,120742,88,11436,88,11613,88,5815,88,42219,88,66192,88,66228,88,66327,88,66855,88,611,121,7564,121,65369,121,119858,121,119910,121,119962,121,120014,121,120066,121,120118,121,120170,121,120222,121,120274,121,120326,121,120378,121,120430,121,120482,121,655,121,7935,121,43866,121,947,121,8509,121,120516,121,120574,121,120632,121,120690,121,120748,121,1199,121,4327,121,71900,121,65337,89,119832,89,119884,89,119936,89,119988,89,120040,89,120092,89,120144,89,120196,89,120248,89,120300,89,120352,89,120404,89,120456,89,933,89,978,89,120508,89,120566,89,120624,89,120682,89,120740,89,11432,89,1198,89,5033,89,5053,89,42220,89,94019,89,71844,89,66226,89,119859,122,119911,122,119963,122,120015,122,120067,122,120119,122,120171,122,120223,122,120275,122,120327,122,120379,122,120431,122,120483,122,7458,122,43923,122,71876,122,66293,90,71909,90,65338,90,8484,90,8488,90,119833,90,119885,90,119937,90,119989,90,120041,90,120197,90,120249,90,120301,90,120353,90,120405,90,120457,90,918,90,120493,90,120551,90,120609,90,120667,90,120725,90,5059,90,42204,90,71849,90,65282,34,65284,36,65285,37,65286,38,65290,42,65291,43,65294,46,65295,47,65296,48,65297,49,65298,50,65299,51,65300,52,65301,53,65302,54,65303,55,65304,56,65305,57,65308,60,65309,61,65310,62,65312,64,65316,68,65318,70,65319,71,65324,76,65329,81,65330,82,65333,85,65334,86,65335,87,65343,95,65346,98,65348,100,65350,102,65355,107,65357,109,65358,110,65361,113,65362,114,65364,116,65365,117,65367,119,65370,122,65371,123,65373,125,119846,109],"_default":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"cs":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"de":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"es":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"fr":[65374,126,65306,58,65281,33,8216,96,8245,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"it":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ja":[8211,45,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65292,44,65307,59],"ko":[8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pl":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"pt-BR":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"qps-ploc":[160,32,8211,45,65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"ru":[65374,126,65306,58,65281,33,8216,96,8217,96,8245,96,180,96,12494,47,305,105,921,73,1009,112,215,120,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"tr":[160,32,8211,45,65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65288,40,65289,41,65292,44,65307,59,65311,63],"zh-hans":[65374,126,65306,58,65281,33,8245,96,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65288,40,65289,41],"zh-hant":[8211,45,65374,126,180,96,12494,47,1047,51,1073,54,1072,97,1040,65,1068,98,1042,66,1089,99,1057,67,1077,101,1045,69,1053,72,305,105,1050,75,921,73,1052,77,1086,111,1054,79,1009,112,1088,112,1056,80,1075,114,1058,84,215,120,1093,120,1061,88,1091,121,1059,89,65283,35,65307,59]}'));
  }
  static {
    this.cache = new v0t({ getCacheKey: JSON.stringify }, (e) => {
      function t(d) {
        const u = /* @__PURE__ */ new Map();
        for (let f = 0; f < d.length; f += 2)
          u.set(d[f], d[f + 1]);
        return u;
      }
      function n(d, u) {
        const f = new Map(d);
        for (const [p, g] of u)
          f.set(p, g);
        return f;
      }
      function i(d, u) {
        if (!d)
          return u;
        const f = /* @__PURE__ */ new Map();
        for (const [p, g] of d)
          u.has(p) && f.set(p, g);
        return f;
      }
      const s = this.ambiguousCharacterData.value;
      let o = e.filter((d) => !d.startsWith("_") && d in s);
      o.length === 0 && (o = ["_default"]);
      let a;
      for (const d of o) {
        const u = t(s[d]);
        a = i(a, u);
      }
      const l = t(s._common), c = n(l, a);
      return new Tu(c);
    });
  }
  static getInstance(e) {
    return Tu.cache.get(Array.from(e));
  }
  static {
    this._locales = new o1(() => Object.keys(Tu.ambiguousCharacterData.value).filter((e) => !e.startsWith("_")));
  }
  static getLocales() {
    return Tu._locales.value;
  }
  constructor(e) {
    this.confusableDictionary = e;
  }
  isAmbiguous(e) {
    return this.confusableDictionary.has(e);
  }
  /**
   * Returns the non basic ASCII code point that the given code point can be confused,
   * or undefined if such code point does note exist.
   */
  getPrimaryConfusable(e) {
    return this.confusableDictionary.get(e);
  }
  getConfusableCodePoints() {
    return new Set(this.confusableDictionary.keys());
  }
}
class Z0 {
  static getRawData() {
    return JSON.parse("[9,10,11,12,13,32,127,160,173,847,1564,4447,4448,6068,6069,6155,6156,6157,6158,7355,7356,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8203,8204,8205,8206,8207,8234,8235,8236,8237,8238,8239,8287,8288,8289,8290,8291,8292,8293,8294,8295,8296,8297,8298,8299,8300,8301,8302,8303,10240,12288,12644,65024,65025,65026,65027,65028,65029,65030,65031,65032,65033,65034,65035,65036,65037,65038,65039,65279,65440,65520,65521,65522,65523,65524,65525,65526,65527,65528,65532,78844,119155,119156,119157,119158,119159,119160,119161,119162,917504,917505,917506,917507,917508,917509,917510,917511,917512,917513,917514,917515,917516,917517,917518,917519,917520,917521,917522,917523,917524,917525,917526,917527,917528,917529,917530,917531,917532,917533,917534,917535,917536,917537,917538,917539,917540,917541,917542,917543,917544,917545,917546,917547,917548,917549,917550,917551,917552,917553,917554,917555,917556,917557,917558,917559,917560,917561,917562,917563,917564,917565,917566,917567,917568,917569,917570,917571,917572,917573,917574,917575,917576,917577,917578,917579,917580,917581,917582,917583,917584,917585,917586,917587,917588,917589,917590,917591,917592,917593,917594,917595,917596,917597,917598,917599,917600,917601,917602,917603,917604,917605,917606,917607,917608,917609,917610,917611,917612,917613,917614,917615,917616,917617,917618,917619,917620,917621,917622,917623,917624,917625,917626,917627,917628,917629,917630,917631,917760,917761,917762,917763,917764,917765,917766,917767,917768,917769,917770,917771,917772,917773,917774,917775,917776,917777,917778,917779,917780,917781,917782,917783,917784,917785,917786,917787,917788,917789,917790,917791,917792,917793,917794,917795,917796,917797,917798,917799,917800,917801,917802,917803,917804,917805,917806,917807,917808,917809,917810,917811,917812,917813,917814,917815,917816,917817,917818,917819,917820,917821,917822,917823,917824,917825,917826,917827,917828,917829,917830,917831,917832,917833,917834,917835,917836,917837,917838,917839,917840,917841,917842,917843,917844,917845,917846,917847,917848,917849,917850,917851,917852,917853,917854,917855,917856,917857,917858,917859,917860,917861,917862,917863,917864,917865,917866,917867,917868,917869,917870,917871,917872,917873,917874,917875,917876,917877,917878,917879,917880,917881,917882,917883,917884,917885,917886,917887,917888,917889,917890,917891,917892,917893,917894,917895,917896,917897,917898,917899,917900,917901,917902,917903,917904,917905,917906,917907,917908,917909,917910,917911,917912,917913,917914,917915,917916,917917,917918,917919,917920,917921,917922,917923,917924,917925,917926,917927,917928,917929,917930,917931,917932,917933,917934,917935,917936,917937,917938,917939,917940,917941,917942,917943,917944,917945,917946,917947,917948,917949,917950,917951,917952,917953,917954,917955,917956,917957,917958,917959,917960,917961,917962,917963,917964,917965,917966,917967,917968,917969,917970,917971,917972,917973,917974,917975,917976,917977,917978,917979,917980,917981,917982,917983,917984,917985,917986,917987,917988,917989,917990,917991,917992,917993,917994,917995,917996,917997,917998,917999]");
  }
  static {
    this._data = void 0;
  }
  static getData() {
    return this._data || (this._data = new Set(Z0.getRawData())), this._data;
  }
  static isInvisibleCharacter(e) {
    return Z0.getData().has(e);
  }
  static get codePoints() {
    return Z0.getData();
  }
}
class zI {
  constructor() {
    this.mapWindowIdToZoomFactor = /* @__PURE__ */ new Map();
  }
  static {
    this.INSTANCE = new zI();
  }
  getZoomFactor(e) {
    return this.mapWindowIdToZoomFactor.get(this.getWindowId(e)) ?? 1;
  }
  getWindowId(e) {
    return e.vscodeWindowId;
  }
}
function aDe(r, e, t) {
  typeof e == "string" && (e = r.matchMedia(e)), e.addEventListener("change", t);
}
function V0t(r) {
  return zI.INSTANCE.getZoomFactor(r);
}
const em = navigator.userAgent, pl = em.indexOf("Firefox") >= 0, V7 = em.indexOf("AppleWebKit") >= 0, vw = em.indexOf("Chrome") >= 0, l1 = !vw && em.indexOf("Safari") >= 0, lDe = !vw && !l1 && V7;
em.indexOf("Electron/") >= 0;
const Rve = em.indexOf("Android") >= 0;
let mE = !1;
if (typeof Sn.matchMedia == "function") {
  const r = Sn.matchMedia("(display-mode: standalone) or (display-mode: window-controls-overlay)"), e = Sn.matchMedia("(display-mode: fullscreen)");
  mE = r.matches, aDe(Sn, r, ({ matches: t }) => {
    mE && e.matches || (mE = t);
  });
}
const cDe = {
  clipboard: {
    writeText: I3 || document.queryCommandSupported && document.queryCommandSupported("copy") || !!(navigator && navigator.clipboard && navigator.clipboard.writeText),
    readText: I3 || !!(navigator && navigator.clipboard && navigator.clipboard.readText)
  },
  pointerEvents: Sn.PointerEvent && ("ontouchstart" in Sn || navigator.maxTouchPoints > 0)
};
function TD(r, e) {
  if (typeof r == "number") {
    if (r === 0)
      return null;
    const t = (r & 65535) >>> 0, n = (r & 4294901760) >>> 16;
    return n !== 0 ? new AE([
      Sv(t, e),
      Sv(n, e)
    ]) : new AE([Sv(t, e)]);
  } else {
    const t = [];
    for (let n = 0; n < r.length; n++)
      t.push(Sv(r[n], e));
    return new AE(t);
  }
}
function Sv(r, e) {
  const t = !!(r & 2048), n = !!(r & 256), i = e === 2 ? n : t, s = !!(r & 1024), o = !!(r & 512), a = e === 2 ? t : n, l = r & 255;
  return new gf(i, s, o, a, l);
}
class gf {
  constructor(e, t, n, i, s) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = i, this.keyCode = s;
  }
  equals(e) {
    return e instanceof gf && this.ctrlKey === e.ctrlKey && this.shiftKey === e.shiftKey && this.altKey === e.altKey && this.metaKey === e.metaKey && this.keyCode === e.keyCode;
  }
  isModifierKey() {
    return this.keyCode === 0 || this.keyCode === 5 || this.keyCode === 57 || this.keyCode === 6 || this.keyCode === 4;
  }
  /**
   * Does this keybinding refer to the key code of a modifier and it also has the modifier flag?
   */
  isDuplicateModifierCase() {
    return this.ctrlKey && this.keyCode === 5 || this.shiftKey && this.keyCode === 4 || this.altKey && this.keyCode === 6 || this.metaKey && this.keyCode === 57;
  }
}
class AE {
  constructor(e) {
    if (e.length === 0)
      throw I7("chords");
    this.chords = e;
  }
}
class H0t {
  constructor(e, t, n, i, s, o) {
    this.ctrlKey = e, this.shiftKey = t, this.altKey = n, this.metaKey = i, this.keyLabel = s, this.keyAriaLabel = o;
  }
}
class B0t {
}
function P0t(r) {
  if (r.charCode) {
    const t = String.fromCharCode(r.charCode).toUpperCase();
    return sd.fromString(t);
  }
  const e = r.keyCode;
  if (e === 3)
    return 7;
  if (pl)
    switch (e) {
      case 59:
        return 85;
      case 60:
        if (Cs)
          return 97;
        break;
      case 61:
        return 86;
      // based on: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#numpad_keys
      case 107:
        return 109;
      case 109:
        return 111;
      case 173:
        return 88;
      case 224:
        if (zt)
          return 57;
        break;
    }
  else if (V7) {
    if (zt && e === 93)
      return 57;
    if (!zt && e === 92)
      return 57;
  }
  return UMe[e] || 0;
}
const F0t = zt ? 256 : 2048, z0t = 512, W0t = 1024, j0t = zt ? 2048 : 256;
class zn {
  constructor(e) {
    this._standardKeyboardEventBrand = !0;
    const t = e;
    this.browserEvent = t, this.target = t.target, this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, this.altGraphKey = t.getModifierState?.("AltGraph"), this.keyCode = P0t(t), this.code = t.code, this.ctrlKey = this.ctrlKey || this.keyCode === 5, this.altKey = this.altKey || this.keyCode === 6, this.shiftKey = this.shiftKey || this.keyCode === 4, this.metaKey = this.metaKey || this.keyCode === 57, this._asKeybinding = this._computeKeybinding(), this._asKeyCodeChord = this._computeKeyCodeChord();
  }
  preventDefault() {
    this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
  }
  toKeyCodeChord() {
    return this._asKeyCodeChord;
  }
  equals(e) {
    return this._asKeybinding === e;
  }
  _computeKeybinding() {
    let e = 0;
    this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode);
    let t = 0;
    return this.ctrlKey && (t |= F0t), this.altKey && (t |= z0t), this.shiftKey && (t |= W0t), this.metaKey && (t |= j0t), t |= e, t;
  }
  _computeKeyCodeChord() {
    let e = 0;
    return this.keyCode !== 5 && this.keyCode !== 4 && this.keyCode !== 6 && this.keyCode !== 57 && (e = this.keyCode), new gf(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, e);
  }
}
const Vve = /* @__PURE__ */ new WeakMap();
function Z0t(r) {
  if (!r.parent || r.parent === r)
    return null;
  try {
    const e = r.location, t = r.parent.location;
    if (e.origin !== "null" && t.origin !== "null" && e.origin !== t.origin)
      return null;
  } catch {
    return null;
  }
  return r.parent;
}
class U0t {
  /**
   * Returns a chain of embedded windows with the same origin (which can be accessed programmatically).
   * Having a chain of length 1 might mean that the current execution environment is running outside of an iframe or inside an iframe embedded in a window with a different origin.
   */
  static getSameOriginWindowChain(e) {
    let t = Vve.get(e);
    if (!t) {
      t = [], Vve.set(e, t);
      let n = e, i;
      do
        i = Z0t(n), i ? t.push({
          window: new WeakRef(n),
          iframeElement: n.frameElement || null
        }) : t.push({
          window: new WeakRef(n),
          iframeElement: null
        }), n = i;
      while (n);
    }
    return t.slice(0);
  }
  /**
   * Returns the position of `childWindow` relative to `ancestorWindow`
   */
  static getPositionOfChildWindowRelativeToAncestorWindow(e, t) {
    if (!t || e === t)
      return {
        top: 0,
        left: 0
      };
    let n = 0, i = 0;
    const s = this.getSameOriginWindowChain(e);
    for (const o of s) {
      const a = o.window.deref();
      if (n += a?.scrollY ?? 0, i += a?.scrollX ?? 0, a === t || !o.iframeElement)
        break;
      const l = o.iframeElement.getBoundingClientRect();
      n += l.top, i += l.left;
    }
    return {
      top: n,
      left: i
    };
  }
}
class zl {
  constructor(e, t) {
    this.timestamp = Date.now(), this.browserEvent = t, this.leftButton = t.button === 0, this.middleButton = t.button === 1, this.rightButton = t.button === 2, this.buttons = t.buttons, this.target = t.target, this.detail = t.detail || 1, t.type === "dblclick" && (this.detail = 2), this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, typeof t.pageX == "number" ? (this.posx = t.pageX, this.posy = t.pageY) : (this.posx = t.clientX + this.target.ownerDocument.body.scrollLeft + this.target.ownerDocument.documentElement.scrollLeft, this.posy = t.clientY + this.target.ownerDocument.body.scrollTop + this.target.ownerDocument.documentElement.scrollTop);
    const n = U0t.getPositionOfChildWindowRelativeToAncestorWindow(e, t.view);
    this.posx -= n.left, this.posy -= n.top;
  }
  preventDefault() {
    this.browserEvent.preventDefault();
  }
  stopPropagation() {
    this.browserEvent.stopPropagation();
  }
}
class mf {
  constructor(e, t = 0, n = 0) {
    this.browserEvent = e || null, this.target = e ? e.target || e.targetNode || e.srcElement : null, this.deltaY = n, this.deltaX = t;
    let i = !1;
    if (vw) {
      const s = navigator.userAgent.match(/Chrome\/(\d+)/);
      i = (s ? parseInt(s[1]) : 123) <= 122;
    }
    if (e) {
      const s = e, o = e, a = e.view?.devicePixelRatio || 1;
      if (typeof s.wheelDeltaY < "u")
        i ? this.deltaY = s.wheelDeltaY / (120 * a) : this.deltaY = s.wheelDeltaY / 120;
      else if (typeof o.VERTICAL_AXIS < "u" && o.axis === o.VERTICAL_AXIS)
        this.deltaY = -o.detail / 3;
      else if (e.type === "wheel") {
        const l = e;
        l.deltaMode === l.DOM_DELTA_LINE ? pl && !zt ? this.deltaY = -e.deltaY / 3 : this.deltaY = -e.deltaY : this.deltaY = -e.deltaY / 40;
      }
      if (typeof s.wheelDeltaX < "u")
        l1 && zs ? this.deltaX = -(s.wheelDeltaX / 120) : i ? this.deltaX = s.wheelDeltaX / (120 * a) : this.deltaX = s.wheelDeltaX / 120;
      else if (typeof o.HORIZONTAL_AXIS < "u" && o.axis === o.HORIZONTAL_AXIS)
        this.deltaX = -e.detail / 3;
      else if (e.type === "wheel") {
        const l = e;
        l.deltaMode === l.DOM_DELTA_LINE ? pl && !zt ? this.deltaX = -e.deltaX / 3 : this.deltaX = -e.deltaX : this.deltaX = -e.deltaX / 40;
      }
      this.deltaY === 0 && this.deltaX === 0 && e.wheelDelta && (i ? this.deltaY = e.wheelDelta / (120 * a) : this.deltaY = e.wheelDelta / 120);
    }
  }
  preventDefault() {
    this.browserEvent?.preventDefault();
  }
  stopPropagation() {
    this.browserEvent?.stopPropagation();
  }
}
const hDe = Symbol("MicrotaskDelay");
function ID(r) {
  return !!r && typeof r.then == "function";
}
function dDe(r) {
  const e = new Jg(), t = r(e.token), n = new Promise((i, s) => {
    const o = e.token.onCancellationRequested(() => {
      o.dispose(), s(new mw());
    });
    Promise.resolve(t).then((a) => {
      o.dispose(), e.dispose(), i(a);
    }, (a) => {
      o.dispose(), e.dispose(), s(a);
    });
  });
  return new class {
    cancel() {
      e.cancel(), e.dispose();
    }
    then(i, s) {
      return n.then(i, s);
    }
    catch(i) {
      return this.then(void 0, i);
    }
    finally(i) {
      return n.finally(i);
    }
  }();
}
class q0t {
  constructor() {
    this.isDisposed = !1, this.activePromise = null, this.queuedPromise = null, this.queuedPromiseFactory = null;
  }
  queue(e) {
    if (this.isDisposed)
      return Promise.reject(new Error("Throttler is disposed"));
    if (this.activePromise) {
      if (this.queuedPromiseFactory = e, !this.queuedPromise) {
        const t = () => {
          if (this.queuedPromise = null, this.isDisposed)
            return;
          const n = this.queue(this.queuedPromiseFactory);
          return this.queuedPromiseFactory = null, n;
        };
        this.queuedPromise = new Promise((n) => {
          this.activePromise.then(t, t).then(n);
        });
      }
      return new Promise((t, n) => {
        this.queuedPromise.then(t, n);
      });
    }
    return this.activePromise = e(), new Promise((t, n) => {
      this.activePromise.then((i) => {
        this.activePromise = null, t(i);
      }, (i) => {
        this.activePromise = null, n(i);
      });
    });
  }
  dispose() {
    this.isDisposed = !0;
  }
}
const G0t = (r, e) => {
  let t = !0;
  const n = setTimeout(() => {
    t = !1, e();
  }, r);
  return {
    isTriggered: () => t,
    dispose: () => {
      clearTimeout(n), t = !1;
    }
  };
}, Q0t = (r) => {
  let e = !0;
  return queueMicrotask(() => {
    e && (e = !1, r());
  }), {
    isTriggered: () => e,
    dispose: () => {
      e = !1;
    }
  };
};
class Uf {
  constructor(e) {
    this.defaultDelay = e, this.deferred = null, this.completionPromise = null, this.doResolve = null, this.doReject = null, this.task = null;
  }
  trigger(e, t = this.defaultDelay) {
    this.task = e, this.cancelTimeout(), this.completionPromise || (this.completionPromise = new Promise((i, s) => {
      this.doResolve = i, this.doReject = s;
    }).then(() => {
      if (this.completionPromise = null, this.doResolve = null, this.task) {
        const i = this.task;
        return this.task = null, i();
      }
    }));
    const n = () => {
      this.deferred = null, this.doResolve?.(null);
    };
    return this.deferred = t === hDe ? Q0t(n) : G0t(t, n), this.completionPromise;
  }
  isTriggered() {
    return !!this.deferred?.isTriggered();
  }
  cancel() {
    this.cancelTimeout(), this.completionPromise && (this.doReject?.(new mw()), this.completionPromise = null);
  }
  cancelTimeout() {
    this.deferred?.dispose(), this.deferred = null;
  }
  dispose() {
    this.cancel();
  }
}
class uDe {
  constructor(e) {
    this.delayer = new Uf(e), this.throttler = new q0t();
  }
  trigger(e, t) {
    return this.delayer.trigger(() => this.throttler.queue(e), t);
  }
  cancel() {
    this.delayer.cancel();
  }
  dispose() {
    this.delayer.dispose(), this.throttler.dispose();
  }
}
function B3(r, e) {
  return e ? new Promise((t, n) => {
    const i = setTimeout(() => {
      s.dispose(), t();
    }, r), s = e.onCancellationRequested(() => {
      clearTimeout(i), s.dispose(), n(new mw());
    });
  }) : dDe((t) => B3(r, t));
}
function OD(r, e = 0, t) {
  const n = setTimeout(() => {
    r(), t && i.dispose();
  }, e), i = ht(() => {
    clearTimeout(n), t?.deleteAndLeak(i);
  });
  return t?.add(i), i;
}
class T1 {
  constructor(e, t) {
    this._isDisposed = !1, this._token = -1, typeof e == "function" && typeof t == "number" && this.setIfNotSet(e, t);
  }
  dispose() {
    this.cancel(), this._isDisposed = !0;
  }
  cancel() {
    this._token !== -1 && (clearTimeout(this._token), this._token = -1);
  }
  cancelAndSet(e, t) {
    if (this._isDisposed)
      throw new cn("Calling 'cancelAndSet' on a disposed TimeoutTimer");
    this.cancel(), this._token = setTimeout(() => {
      this._token = -1, e();
    }, t);
  }
  setIfNotSet(e, t) {
    if (this._isDisposed)
      throw new cn("Calling 'setIfNotSet' on a disposed TimeoutTimer");
    this._token === -1 && (this._token = setTimeout(() => {
      this._token = -1, e();
    }, t));
  }
}
class WI {
  constructor() {
    this.disposable = void 0, this.isDisposed = !1;
  }
  cancel() {
    this.disposable?.dispose(), this.disposable = void 0;
  }
  cancelAndSet(e, t, n = globalThis) {
    if (this.isDisposed)
      throw new cn("Calling 'cancelAndSet' on a disposed IntervalTimer");
    this.cancel();
    const i = n.setInterval(() => {
      e();
    }, t);
    this.disposable = ht(() => {
      n.clearInterval(i), this.disposable = void 0;
    });
  }
  dispose() {
    this.cancel(), this.isDisposed = !0;
  }
}
class Nr {
  constructor(e, t) {
    this.timeoutToken = -1, this.runner = e, this.timeout = t, this.timeoutHandler = this.onTimeout.bind(this);
  }
  /**
   * Dispose RunOnceScheduler
   */
  dispose() {
    this.cancel(), this.runner = null;
  }
  /**
   * Cancel current scheduled runner (if any).
   */
  cancel() {
    this.isScheduled() && (clearTimeout(this.timeoutToken), this.timeoutToken = -1);
  }
  /**
   * Cancel previous runner (if any) & schedule a new runner.
   */
  schedule(e = this.timeout) {
    this.cancel(), this.timeoutToken = setTimeout(this.timeoutHandler, e);
  }
  get delay() {
    return this.timeout;
  }
  set delay(e) {
    this.timeout = e;
  }
  /**
   * Returns true if scheduled.
   */
  isScheduled() {
    return this.timeoutToken !== -1;
  }
  onTimeout() {
    this.timeoutToken = -1, this.runner && this.doRun();
  }
  doRun() {
    this.runner?.();
  }
}
let fDe, HA;
(function() {
  typeof globalThis.requestIdleCallback != "function" || typeof globalThis.cancelIdleCallback != "function" ? HA = (r, e) => {
    OMe(() => {
      if (t)
        return;
      const n = Date.now() + 15;
      e(Object.freeze({
        didTimeout: !0,
        timeRemaining() {
          return Math.max(0, n - Date.now());
        }
      }));
    });
    let t = !1;
    return {
      dispose() {
        t || (t = !0);
      }
    };
  } : HA = (r, e, t) => {
    const n = r.requestIdleCallback(e, typeof t == "number" ? { timeout: t } : void 0);
    let i = !1;
    return {
      dispose() {
        i || (i = !0, r.cancelIdleCallback(n));
      }
    };
  }, fDe = (r) => HA(globalThis, r);
})();
class K0t {
  constructor(e, t) {
    this._didRun = !1, this._executor = () => {
      try {
        this._value = t();
      } catch (n) {
        this._error = n;
      } finally {
        this._didRun = !0;
      }
    }, this._handle = HA(e, () => this._executor());
  }
  dispose() {
    this._handle.dispose();
  }
  get value() {
    if (this._didRun || (this._handle.dispose(), this._executor()), this._error)
      throw this._error;
    return this._value;
  }
  get isInitialized() {
    return this._didRun;
  }
}
class Y0t extends K0t {
  constructor(e) {
    super(globalThis, e);
  }
}
class pDe {
  get isRejected() {
    return this.outcome?.outcome === 1;
  }
  get isSettled() {
    return !!this.outcome;
  }
  constructor() {
    this.p = new Promise((e, t) => {
      this.completeCallback = e, this.errorCallback = t;
    });
  }
  complete(e) {
    return new Promise((t) => {
      this.completeCallback(e), this.outcome = { outcome: 0, value: e }, t();
    });
  }
  error(e) {
    return new Promise((t) => {
      this.errorCallback(e), this.outcome = { outcome: 1, value: e }, t();
    });
  }
  cancel() {
    return this.error(new mw());
  }
}
var RD;
(function(r) {
  async function e(n) {
    let i;
    const s = await Promise.all(n.map((o) => o.then((a) => a, (a) => {
      i || (i = a);
    })));
    if (typeof i < "u")
      throw i;
    return s;
  }
  r.settled = e;
  function t(n) {
    return new Promise(async (i, s) => {
      try {
        await n(i, s);
      } catch (o) {
        s(o);
      }
    });
  }
  r.withAsyncBody = t;
})(RD || (RD = {}));
class Yo {
  static fromArray(e) {
    return new Yo((t) => {
      t.emitMany(e);
    });
  }
  static fromPromise(e) {
    return new Yo(async (t) => {
      t.emitMany(await e);
    });
  }
  static fromPromises(e) {
    return new Yo(async (t) => {
      await Promise.all(e.map(async (n) => t.emitOne(await n)));
    });
  }
  static merge(e) {
    return new Yo(async (t) => {
      await Promise.all(e.map(async (n) => {
        for await (const i of n)
          t.emitOne(i);
      }));
    });
  }
  static {
    this.EMPTY = Yo.fromArray([]);
  }
  constructor(e, t) {
    this._state = 0, this._results = [], this._error = null, this._onReturn = t, this._onStateChanged = new $(), queueMicrotask(async () => {
      const n = {
        emitOne: (i) => this.emitOne(i),
        emitMany: (i) => this.emitMany(i),
        reject: (i) => this.reject(i)
      };
      try {
        await Promise.resolve(e(n)), this.resolve();
      } catch (i) {
        this.reject(i);
      } finally {
        n.emitOne = void 0, n.emitMany = void 0, n.reject = void 0;
      }
    });
  }
  [Symbol.asyncIterator]() {
    let e = 0;
    return {
      next: async () => {
        do {
          if (this._state === 2)
            throw this._error;
          if (e < this._results.length)
            return { done: !1, value: this._results[e++] };
          if (this._state === 1)
            return { done: !0, value: void 0 };
          await xe.toPromise(this._onStateChanged.event);
        } while (!0);
      },
      return: async () => (this._onReturn?.(), { done: !0, value: void 0 })
    };
  }
  static map(e, t) {
    return new Yo(async (n) => {
      for await (const i of e)
        n.emitOne(t(i));
    });
  }
  map(e) {
    return Yo.map(this, e);
  }
  static filter(e, t) {
    return new Yo(async (n) => {
      for await (const i of e)
        t(i) && n.emitOne(i);
    });
  }
  filter(e) {
    return Yo.filter(this, e);
  }
  static coalesce(e) {
    return Yo.filter(e, (t) => !!t);
  }
  coalesce() {
    return Yo.coalesce(this);
  }
  static async toPromise(e) {
    const t = [];
    for await (const n of e)
      t.push(n);
    return t;
  }
  toPromise() {
    return Yo.toPromise(this);
  }
  /**
   * The value will be appended at the end.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  emitOne(e) {
    this._state === 0 && (this._results.push(e), this._onStateChanged.fire());
  }
  /**
   * The values will be appended at the end.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  emitMany(e) {
    this._state === 0 && (this._results = this._results.concat(e), this._onStateChanged.fire());
  }
  /**
   * Calling `resolve()` will mark the result array as complete.
   *
   * **NOTE** `resolve()` must be called, otherwise all consumers of this iterable will hang indefinitely, similar to a non-resolved promise.
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  resolve() {
    this._state === 0 && (this._state = 1, this._onStateChanged.fire());
  }
  /**
   * Writing an error will permanently invalidate this iterable.
   * The current users will receive an error thrown, as will all future users.
   *
   * **NOTE** If `resolve()` or `reject()` have already been called, this method has no effect.
   */
  reject(e) {
    this._state === 0 && (this._state = 2, this._error = e, this._onStateChanged.fire());
  }
}
/*! @license DOMPurify 3.0.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.5/LICENSE */
const {
  entries: gDe,
  setPrototypeOf: Hve,
  isFrozen: X0t,
  getPrototypeOf: J0t,
  getOwnPropertyDescriptor: $0t
} = Object;
let {
  freeze: lo,
  seal: nc,
  create: eft
} = Object, {
  apply: VD,
  construct: HD
} = typeof Reflect < "u" && Reflect;
VD || (VD = function(e, t, n) {
  return e.apply(t, n);
});
lo || (lo = function(e) {
  return e;
});
nc || (nc = function(e) {
  return e;
});
HD || (HD = function(e, t) {
  return new e(...t);
});
const tft = gl(Array.prototype.forEach), Bve = gl(Array.prototype.pop), Lm = gl(Array.prototype.push), p6 = gl(String.prototype.toLowerCase), wE = gl(String.prototype.toString), nft = gl(String.prototype.match), Dl = gl(String.prototype.replace), ift = gl(String.prototype.indexOf), rft = gl(String.prototype.trim), Go = gl(RegExp.prototype.test), km = sft(TypeError);
function gl(r) {
  return function(e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
      n[i - 1] = arguments[i];
    return VD(r, e, n);
  };
}
function sft(r) {
  return function() {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    return HD(r, t);
  };
}
function hn(r, e, t) {
  var n;
  t = (n = t) !== null && n !== void 0 ? n : p6, Hve && Hve(r, null);
  let i = e.length;
  for (; i--; ) {
    let s = e[i];
    if (typeof s == "string") {
      const o = t(s);
      o !== s && (X0t(e) || (e[i] = o), s = o);
    }
    r[s] = !0;
  }
  return r;
}
function b2(r) {
  const e = eft(null);
  for (const [t, n] of gDe(r))
    e[t] = n;
  return e;
}
function Mv(r, e) {
  for (; r !== null; ) {
    const n = $0t(r, e);
    if (n) {
      if (n.get)
        return gl(n.get);
      if (typeof n.value == "function")
        return gl(n.value);
    }
    r = J0t(r);
  }
  function t(n) {
    return console.warn("fallback value for", n), null;
  }
  return t;
}
const Pve = lo(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), vE = lo(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), bE = lo(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), oft = lo(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), yE = lo(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), aft = lo(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Fve = lo(["#text"]), zve = lo(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]), CE = lo(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Wve = lo(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Dv = lo(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), lft = nc(/\{\{[\w\W]*|[\w\W]*\}\}/gm), cft = nc(/<%[\w\W]*|[\w\W]*%>/gm), hft = nc(/\${[\w\W]*}/gm), dft = nc(/^data-[\-\w.\u00B7-\uFFFF]/), uft = nc(/^aria-[\-\w]+$/), mDe = nc(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), fft = nc(/^(?:\w+script|data):/i), pft = nc(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), ADe = nc(/^html$/i);
var jve = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: lft,
  ERB_EXPR: cft,
  TMPLIT_EXPR: hft,
  DATA_ATTR: dft,
  ARIA_ATTR: uft,
  IS_ALLOWED_URI: mDe,
  IS_SCRIPT_OR_DATA: fft,
  ATTR_WHITESPACE: pft,
  DOCTYPE_NAME: ADe
});
const gft = () => typeof window > "u" ? null : window, mft = function(e, t) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let n = null;
  const i = "data-tt-policy-suffix";
  t && t.hasAttribute(i) && (n = t.getAttribute(i));
  const s = "dompurify" + (n ? "#" + n : "");
  try {
    return e.createPolicy(s, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + s + " could not be created."), null;
  }
};
function wDe() {
  let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : gft();
  const e = (Ze) => wDe(Ze);
  if (e.version = "3.0.5", e.removed = [], !r || !r.document || r.document.nodeType !== 9)
    return e.isSupported = !1, e;
  const t = r.document, n = t.currentScript;
  let {
    document: i
  } = r;
  const {
    DocumentFragment: s,
    HTMLTemplateElement: o,
    Node: a,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: d = r.NamedNodeMap || r.MozNamedAttrMap,
    HTMLFormElement: u,
    DOMParser: f,
    trustedTypes: p
  } = r, g = l.prototype, m = Mv(g, "cloneNode"), A = Mv(g, "nextSibling"), w = Mv(g, "childNodes"), v = Mv(g, "parentNode");
  if (typeof o == "function") {
    const Ze = i.createElement("template");
    Ze.content && Ze.content.ownerDocument && (i = Ze.content.ownerDocument);
  }
  let y, _ = "";
  const {
    implementation: S,
    createNodeIterator: D,
    createDocumentFragment: M,
    getElementsByTagName: L
  } = i, {
    importNode: T
  } = t;
  let B = {};
  e.isSupported = typeof gDe == "function" && typeof v == "function" && S && S.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: V,
    ERB_EXPR: N,
    TMPLIT_EXPR: R,
    DATA_ATTR: H,
    ARIA_ATTR: z,
    IS_SCRIPT_OR_DATA: U,
    ATTR_WHITESPACE: ee
  } = jve;
  let {
    IS_ALLOWED_URI: ce
  } = jve, se = null;
  const te = hn({}, [...Pve, ...vE, ...bE, ...yE, ...Fve]);
  let ue = null;
  const G = hn({}, [...zve, ...CE, ...Wve, ...Dv]);
  let j = Object.seal(Object.create(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), pe = null, De = null, Ce = !0, F = !0, I = !1, O = !0, Y = !1, K = !1, ae = !1, Oe = !1, ot = !1, It = !1, Mn = !1, Ii = !0, os = !1;
  const Cc = "user-content-";
  let we = !0, de = !1, he = {}, P = null;
  const W = hn({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let ne = null;
  const X = hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Ae = null;
  const Le = hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), We = "http://www.w3.org/1998/Math/MathML", Ue = "http://www.w3.org/2000/svg", ut = "http://www.w3.org/1999/xhtml";
  let ct = ut, yn = !1, fn = null;
  const it = hn({}, [We, Ue, ut], wE);
  let ei;
  const ti = ["application/xhtml+xml", "text/html"], Ds = "text/html";
  let Gt, Yn = null;
  const El = i.createElement("form"), _l = function(re) {
    return re instanceof RegExp || re instanceof Function;
  }, mo = function(re) {
    if (!(Yn && Yn === re)) {
      if ((!re || typeof re != "object") && (re = {}), re = b2(re), ei = // eslint-disable-next-line unicorn/prefer-includes
      ti.indexOf(re.PARSER_MEDIA_TYPE) === -1 ? ei = Ds : ei = re.PARSER_MEDIA_TYPE, Gt = ei === "application/xhtml+xml" ? wE : p6, se = "ALLOWED_TAGS" in re ? hn({}, re.ALLOWED_TAGS, Gt) : te, ue = "ALLOWED_ATTR" in re ? hn({}, re.ALLOWED_ATTR, Gt) : G, fn = "ALLOWED_NAMESPACES" in re ? hn({}, re.ALLOWED_NAMESPACES, wE) : it, Ae = "ADD_URI_SAFE_ATTR" in re ? hn(
        b2(Le),
        // eslint-disable-line indent
        re.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        Gt
        // eslint-disable-line indent
      ) : Le, ne = "ADD_DATA_URI_TAGS" in re ? hn(
        b2(X),
        // eslint-disable-line indent
        re.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        Gt
        // eslint-disable-line indent
      ) : X, P = "FORBID_CONTENTS" in re ? hn({}, re.FORBID_CONTENTS, Gt) : W, pe = "FORBID_TAGS" in re ? hn({}, re.FORBID_TAGS, Gt) : {}, De = "FORBID_ATTR" in re ? hn({}, re.FORBID_ATTR, Gt) : {}, he = "USE_PROFILES" in re ? re.USE_PROFILES : !1, Ce = re.ALLOW_ARIA_ATTR !== !1, F = re.ALLOW_DATA_ATTR !== !1, I = re.ALLOW_UNKNOWN_PROTOCOLS || !1, O = re.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Y = re.SAFE_FOR_TEMPLATES || !1, K = re.WHOLE_DOCUMENT || !1, ot = re.RETURN_DOM || !1, It = re.RETURN_DOM_FRAGMENT || !1, Mn = re.RETURN_TRUSTED_TYPE || !1, Oe = re.FORCE_BODY || !1, Ii = re.SANITIZE_DOM !== !1, os = re.SANITIZE_NAMED_PROPS || !1, we = re.KEEP_CONTENT !== !1, de = re.IN_PLACE || !1, ce = re.ALLOWED_URI_REGEXP || mDe, ct = re.NAMESPACE || ut, j = re.CUSTOM_ELEMENT_HANDLING || {}, re.CUSTOM_ELEMENT_HANDLING && _l(re.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (j.tagNameCheck = re.CUSTOM_ELEMENT_HANDLING.tagNameCheck), re.CUSTOM_ELEMENT_HANDLING && _l(re.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (j.attributeNameCheck = re.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), re.CUSTOM_ELEMENT_HANDLING && typeof re.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (j.allowCustomizedBuiltInElements = re.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Y && (F = !1), It && (ot = !0), he && (se = hn({}, [...Fve]), ue = [], he.html === !0 && (hn(se, Pve), hn(ue, zve)), he.svg === !0 && (hn(se, vE), hn(ue, CE), hn(ue, Dv)), he.svgFilters === !0 && (hn(se, bE), hn(ue, CE), hn(ue, Dv)), he.mathMl === !0 && (hn(se, yE), hn(ue, Wve), hn(ue, Dv))), re.ADD_TAGS && (se === te && (se = b2(se)), hn(se, re.ADD_TAGS, Gt)), re.ADD_ATTR && (ue === G && (ue = b2(ue)), hn(ue, re.ADD_ATTR, Gt)), re.ADD_URI_SAFE_ATTR && hn(Ae, re.ADD_URI_SAFE_ATTR, Gt), re.FORBID_CONTENTS && (P === W && (P = b2(P)), hn(P, re.FORBID_CONTENTS, Gt)), we && (se["#text"] = !0), K && hn(se, ["html", "head", "body"]), se.table && (hn(se, ["tbody"]), delete pe.tbody), re.TRUSTED_TYPES_POLICY) {
        if (typeof re.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw km('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof re.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw km('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        y = re.TRUSTED_TYPES_POLICY, _ = y.createHTML("");
      } else
        y === void 0 && (y = mft(p, n)), y !== null && typeof _ == "string" && (_ = y.createHTML(""));
      lo && lo(re), Yn = re;
    }
  }, Ec = hn({}, ["mi", "mo", "mn", "ms", "mtext"]), _c = hn({}, ["foreignobject", "desc", "title", "annotation-xml"]), Oh = hn({}, ["title", "style", "font", "a", "script"]), Rh = hn({}, vE);
  hn(Rh, bE), hn(Rh, oft);
  const xc = hn({}, yE);
  hn(xc, aft);
  const xm = function(re) {
    let Ee = v(re);
    (!Ee || !Ee.tagName) && (Ee = {
      namespaceURI: ct,
      tagName: "template"
    });
    const je = p6(re.tagName), Ot = p6(Ee.tagName);
    return fn[re.namespaceURI] ? re.namespaceURI === Ue ? Ee.namespaceURI === ut ? je === "svg" : Ee.namespaceURI === We ? je === "svg" && (Ot === "annotation-xml" || Ec[Ot]) : !!Rh[je] : re.namespaceURI === We ? Ee.namespaceURI === ut ? je === "math" : Ee.namespaceURI === Ue ? je === "math" && _c[Ot] : !!xc[je] : re.namespaceURI === ut ? Ee.namespaceURI === Ue && !_c[Ot] || Ee.namespaceURI === We && !Ec[Ot] ? !1 : !xc[je] && (Oh[je] || !Rh[je]) : !!(ei === "application/xhtml+xml" && fn[re.namespaceURI]) : !1;
  }, Ia = function(re) {
    Lm(e.removed, {
      element: re
    });
    try {
      re.parentNode.removeChild(re);
    } catch {
      re.remove();
    }
  }, ou = function(re, Ee) {
    try {
      Lm(e.removed, {
        attribute: Ee.getAttributeNode(re),
        from: Ee
      });
    } catch {
      Lm(e.removed, {
        attribute: null,
        from: Ee
      });
    }
    if (Ee.removeAttribute(re), re === "is" && !ue[re])
      if (ot || It)
        try {
          Ia(Ee);
        } catch {
        }
      else
        try {
          Ee.setAttribute(re, "");
        } catch {
        }
  }, au = function(re) {
    let Ee, je;
    if (Oe)
      re = "<remove></remove>" + re;
    else {
      const Li = nft(re, /^[\r\n\t ]+/);
      je = Li && Li[0];
    }
    ei === "application/xhtml+xml" && ct === ut && (re = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + re + "</body></html>");
    const Ot = y ? y.createHTML(re) : re;
    if (ct === ut)
      try {
        Ee = new f().parseFromString(Ot, ei);
      } catch {
      }
    if (!Ee || !Ee.documentElement) {
      Ee = S.createDocument(ct, "template", null);
      try {
        Ee.documentElement.innerHTML = yn ? _ : Ot;
      } catch {
      }
    }
    const pn = Ee.body || Ee.documentElement;
    return re && je && pn.insertBefore(i.createTextNode(je), pn.childNodes[0] || null), ct === ut ? L.call(Ee, K ? "html" : "body")[0] : K ? Ee.documentElement : pn;
  }, m2 = function(re) {
    return D.call(
      re.ownerDocument || re,
      re,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT,
      null,
      !1
    );
  }, LC = function(re) {
    return re instanceof u && (typeof re.nodeName != "string" || typeof re.textContent != "string" || typeof re.removeChild != "function" || !(re.attributes instanceof d) || typeof re.removeAttribute != "function" || typeof re.setAttribute != "function" || typeof re.namespaceURI != "string" || typeof re.insertBefore != "function" || typeof re.hasChildNodes != "function");
  }, A2 = function(re) {
    return typeof a == "object" ? re instanceof a : re && typeof re == "object" && typeof re.nodeType == "number" && typeof re.nodeName == "string";
  }, xl = function(re, Ee, je) {
    B[re] && tft(B[re], (Ot) => {
      Ot.call(e, Ee, je, Yn);
    });
  }, ie = function(re) {
    let Ee;
    if (xl("beforeSanitizeElements", re, null), LC(re))
      return Ia(re), !0;
    const je = Gt(re.nodeName);
    if (xl("uponSanitizeElement", re, {
      tagName: je,
      allowedTags: se
    }), re.hasChildNodes() && !A2(re.firstElementChild) && (!A2(re.content) || !A2(re.content.firstElementChild)) && Go(/<[/\w]/g, re.innerHTML) && Go(/<[/\w]/g, re.textContent))
      return Ia(re), !0;
    if (!se[je] || pe[je]) {
      if (!pe[je] && nt(je) && (j.tagNameCheck instanceof RegExp && Go(j.tagNameCheck, je) || j.tagNameCheck instanceof Function && j.tagNameCheck(je)))
        return !1;
      if (we && !P[je]) {
        const Ot = v(re) || re.parentNode, pn = w(re) || re.childNodes;
        if (pn && Ot) {
          const Li = pn.length;
          for (let ni = Li - 1; ni >= 0; --ni)
            Ot.insertBefore(m(pn[ni], !0), A(re));
        }
      }
      return Ia(re), !0;
    }
    return re instanceof l && !xm(re) || (je === "noscript" || je === "noembed" || je === "noframes") && Go(/<\/no(script|embed|frames)/i, re.innerHTML) ? (Ia(re), !0) : (Y && re.nodeType === 3 && (Ee = re.textContent, Ee = Dl(Ee, V, " "), Ee = Dl(Ee, N, " "), Ee = Dl(Ee, R, " "), re.textContent !== Ee && (Lm(e.removed, {
      element: re.cloneNode()
    }), re.textContent = Ee)), xl("afterSanitizeElements", re, null), !1);
  }, Te = function(re, Ee, je) {
    if (Ii && (Ee === "id" || Ee === "name") && (je in i || je in El))
      return !1;
    if (!(F && !De[Ee] && Go(H, Ee))) {
      if (!(Ce && Go(z, Ee))) {
        if (!ue[Ee] || De[Ee]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(nt(re) && (j.tagNameCheck instanceof RegExp && Go(j.tagNameCheck, re) || j.tagNameCheck instanceof Function && j.tagNameCheck(re)) && (j.attributeNameCheck instanceof RegExp && Go(j.attributeNameCheck, Ee) || j.attributeNameCheck instanceof Function && j.attributeNameCheck(Ee)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Ee === "is" && j.allowCustomizedBuiltInElements && (j.tagNameCheck instanceof RegExp && Go(j.tagNameCheck, je) || j.tagNameCheck instanceof Function && j.tagNameCheck(je)))
          ) return !1;
        } else if (!Ae[Ee]) {
          if (!Go(ce, Dl(je, ee, ""))) {
            if (!((Ee === "src" || Ee === "xlink:href" || Ee === "href") && re !== "script" && ift(je, "data:") === 0 && ne[re])) {
              if (!(I && !Go(U, Dl(je, ee, "")))) {
                if (je)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, nt = function(re) {
    return re.indexOf("-") > 0;
  }, Vt = function(re) {
    let Ee, je, Ot, pn;
    xl("beforeSanitizeAttributes", re, null);
    const {
      attributes: Li
    } = re;
    if (!Li)
      return;
    const ni = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ue
    };
    for (pn = Li.length; pn--; ) {
      Ee = Li[pn];
      const {
        name: Gr,
        namespaceURI: Qr
      } = Ee;
      if (je = Gr === "value" ? Ee.value : rft(Ee.value), Ot = Gt(Gr), ni.attrName = Ot, ni.attrValue = je, ni.keepAttr = !0, ni.forceKeepAttr = void 0, xl("uponSanitizeAttribute", re, ni), je = ni.attrValue, ni.forceKeepAttr || (ou(Gr, re), !ni.keepAttr))
        continue;
      if (!O && Go(/\/>/i, je)) {
        ou(Gr, re);
        continue;
      }
      Y && (je = Dl(je, V, " "), je = Dl(je, N, " "), je = Dl(je, R, " "));
      const w2 = Gt(re.nodeName);
      if (Te(w2, Ot, je)) {
        if (os && (Ot === "id" || Ot === "name") && (ou(Gr, re), je = Cc + je), y && typeof p == "object" && typeof p.getAttributeType == "function" && !Qr)
          switch (p.getAttributeType(w2, Ot)) {
            case "TrustedHTML": {
              je = y.createHTML(je);
              break;
            }
            case "TrustedScriptURL": {
              je = y.createScriptURL(je);
              break;
            }
          }
        try {
          Qr ? re.setAttributeNS(Qr, Gr, je) : re.setAttribute(Gr, je), Bve(e.removed);
        } catch {
        }
      }
    }
    xl("afterSanitizeAttributes", re, null);
  }, Zn = function Ze(re) {
    let Ee;
    const je = m2(re);
    for (xl("beforeSanitizeShadowDOM", re, null); Ee = je.nextNode(); )
      xl("uponSanitizeShadowNode", Ee, null), !ie(Ee) && (Ee.content instanceof s && Ze(Ee.content), Vt(Ee));
    xl("afterSanitizeShadowDOM", re, null);
  };
  return e.sanitize = function(Ze) {
    let re = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ee, je, Ot, pn;
    if (yn = !Ze, yn && (Ze = "<!-->"), typeof Ze != "string" && !A2(Ze))
      if (typeof Ze.toString == "function") {
        if (Ze = Ze.toString(), typeof Ze != "string")
          throw km("dirty is not a string, aborting");
      } else
        throw km("toString is not a function");
    if (!e.isSupported)
      return Ze;
    if (ae || mo(re), e.removed = [], typeof Ze == "string" && (de = !1), de) {
      if (Ze.nodeName) {
        const Gr = Gt(Ze.nodeName);
        if (!se[Gr] || pe[Gr])
          throw km("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Ze instanceof a)
      Ee = au("<!---->"), je = Ee.ownerDocument.importNode(Ze, !0), je.nodeType === 1 && je.nodeName === "BODY" || je.nodeName === "HTML" ? Ee = je : Ee.appendChild(je);
    else {
      if (!ot && !Y && !K && // eslint-disable-next-line unicorn/prefer-includes
      Ze.indexOf("<") === -1)
        return y && Mn ? y.createHTML(Ze) : Ze;
      if (Ee = au(Ze), !Ee)
        return ot ? null : Mn ? _ : "";
    }
    Ee && Oe && Ia(Ee.firstChild);
    const Li = m2(de ? Ze : Ee);
    for (; Ot = Li.nextNode(); )
      ie(Ot) || (Ot.content instanceof s && Zn(Ot.content), Vt(Ot));
    if (de)
      return Ze;
    if (ot) {
      if (It)
        for (pn = M.call(Ee.ownerDocument); Ee.firstChild; )
          pn.appendChild(Ee.firstChild);
      else
        pn = Ee;
      return (ue.shadowroot || ue.shadowrootmode) && (pn = T.call(t, pn, !0)), pn;
    }
    let ni = K ? Ee.outerHTML : Ee.innerHTML;
    return K && se["!doctype"] && Ee.ownerDocument && Ee.ownerDocument.doctype && Ee.ownerDocument.doctype.name && Go(ADe, Ee.ownerDocument.doctype.name) && (ni = "<!DOCTYPE " + Ee.ownerDocument.doctype.name + `>
` + ni), Y && (ni = Dl(ni, V, " "), ni = Dl(ni, N, " "), ni = Dl(ni, R, " ")), y && Mn ? y.createHTML(ni) : ni;
  }, e.setConfig = function(Ze) {
    mo(Ze), ae = !0;
  }, e.clearConfig = function() {
    Yn = null, ae = !1;
  }, e.isValidAttribute = function(Ze, re, Ee) {
    Yn || mo({});
    const je = Gt(Ze), Ot = Gt(re);
    return Te(je, Ot, Ee);
  }, e.addHook = function(Ze, re) {
    typeof re == "function" && (B[Ze] = B[Ze] || [], Lm(B[Ze], re));
  }, e.removeHook = function(Ze) {
    if (B[Ze])
      return Bve(B[Ze]);
  }, e.removeHooks = function(Ze) {
    B[Ze] && (B[Ze] = []);
  }, e.removeAllHooks = function() {
    B = {};
  }, e;
}
var Eh = wDe();
Eh.version;
Eh.isSupported;
const vDe = Eh.sanitize;
Eh.setConfig;
Eh.clearConfig;
Eh.isValidAttribute;
const bDe = Eh.addHook, yDe = Eh.removeHook;
Eh.removeHooks;
Eh.removeAllHooks;
var Ct;
(function(r) {
  r.inMemory = "inmemory", r.vscode = "vscode", r.internal = "private", r.walkThrough = "walkThrough", r.walkThroughSnippet = "walkThroughSnippet", r.http = "http", r.https = "https", r.file = "file", r.mailto = "mailto", r.untitled = "untitled", r.data = "data", r.command = "command", r.vscodeRemote = "vscode-remote", r.vscodeRemoteResource = "vscode-remote-resource", r.vscodeManagedRemoteResource = "vscode-managed-remote-resource", r.vscodeUserData = "vscode-userdata", r.vscodeCustomEditor = "vscode-custom-editor", r.vscodeNotebookCell = "vscode-notebook-cell", r.vscodeNotebookCellMetadata = "vscode-notebook-cell-metadata", r.vscodeNotebookCellOutput = "vscode-notebook-cell-output", r.vscodeInteractiveInput = "vscode-interactive-input", r.vscodeSettings = "vscode-settings", r.vscodeWorkspaceTrust = "vscode-workspace-trust", r.vscodeTerminal = "vscode-terminal", r.vscodeChatCodeBlock = "vscode-chat-code-block", r.vscodeCopilotBackingChatCodeBlock = "vscode-copilot-chat-code-block", r.vscodeChatCodeCompareBlock = "vscode-chat-code-compare-block", r.vscodeChatSesssion = "vscode-chat-editor", r.webviewPanel = "webview-panel", r.vscodeWebview = "vscode-webview", r.extension = "extension", r.vscodeFileResource = "vscode-file", r.tmp = "tmp", r.vsls = "vsls", r.vscodeSourceControl = "vscode-scm", r.commentsInput = "comment", r.codeSetting = "code-setting";
})(Ct || (Ct = {}));
function jI(r, e) {
  return Pt.isUri(r) ? Q2(r.scheme, e) : OI(r, e + ":");
}
function Zve(r, ...e) {
  return e.some((t) => jI(r, t));
}
const Aft = "tkn";
class wft {
  constructor() {
    this._hosts = /* @__PURE__ */ Object.create(null), this._ports = /* @__PURE__ */ Object.create(null), this._connectionTokens = /* @__PURE__ */ Object.create(null), this._preferredWebSchema = "http", this._delegate = null, this._serverRootPath = "/";
  }
  setPreferredWebSchema(e) {
    this._preferredWebSchema = e;
  }
  get _remoteResourcesPath() {
    return Si.join(this._serverRootPath, Ct.vscodeRemoteResource);
  }
  rewrite(e) {
    if (this._delegate)
      try {
        return this._delegate(e);
      } catch (a) {
        return wn(a), e;
      }
    const t = e.authority;
    let n = this._hosts[t];
    n && n.indexOf(":") !== -1 && n.indexOf("[") === -1 && (n = `[${n}]`);
    const i = this._ports[t], s = this._connectionTokens[t];
    let o = `path=${encodeURIComponent(e.path)}`;
    return typeof s == "string" && (o += `&${Aft}=${encodeURIComponent(s)}`), Pt.from({
      scheme: Yg ? this._preferredWebSchema : Ct.vscodeRemoteResource,
      authority: `${n}:${i}`,
      path: this._remoteResourcesPath,
      query: o
    });
  }
}
const CDe = new wft(), vft = "vscode-app";
class V8 {
  static {
    this.FALLBACK_AUTHORITY = vft;
  }
  /**
   * Returns a URI to use in contexts where the browser is responsible
   * for loading (e.g. fetch()) or when used within the DOM.
   *
   * **Note:** use `dom.ts#asCSSUrl` whenever the URL is to be used in CSS context.
   */
  uriToBrowserUri(e) {
    return e.scheme === Ct.vscodeRemote ? CDe.rewrite(e) : (
      // ...only ever for `file` resources
      e.scheme === Ct.file && // ...and we run in native environments
      (I3 || // ...or web worker extensions on desktop
      Lut === `${Ct.vscodeFileResource}://${V8.FALLBACK_AUTHORITY}`) ? e.with({
        scheme: Ct.vscodeFileResource,
        // We need to provide an authority here so that it can serve
        // as origin for network and loading matters in chromium.
        // If the URI is not coming with an authority already, we
        // add our own
        authority: e.authority || V8.FALLBACK_AUTHORITY,
        query: null,
        fragment: null
      }) : e
    );
  }
}
const EDe = new V8();
var Uve;
(function(r) {
  const e = /* @__PURE__ */ new Map([
    ["1", { "Cross-Origin-Opener-Policy": "same-origin" }],
    ["2", { "Cross-Origin-Embedder-Policy": "require-corp" }],
    ["3", { "Cross-Origin-Opener-Policy": "same-origin", "Cross-Origin-Embedder-Policy": "require-corp" }]
  ]);
  r.CoopAndCoep = Object.freeze(e.get("3"));
  const t = "vscode-coi";
  function n(s) {
    let o;
    typeof s == "string" ? o = new URL(s).searchParams : s instanceof URL ? o = s.searchParams : Pt.isUri(s) && (o = new URL(s.toString(!0)).searchParams);
    const a = o?.get(t);
    if (a)
      return e.get(a);
  }
  r.getHeadersFromQuery = n;
  function i(s, o, a) {
    if (!globalThis.crossOriginIsolated)
      return;
    const l = o && a ? "3" : a ? "2" : "1";
    s instanceof URLSearchParams ? s.set(t, l) : s[t] = l;
  }
  r.addSearchParam = i;
})(Uve || (Uve = {}));
function _De(r) {
  return H7(r, 0);
}
function H7(r, e) {
  switch (typeof r) {
    case "object":
      return r === null ? ud(349, e) : Array.isArray(r) ? yft(r, e) : Cft(r, e);
    case "string":
      return ZI(r, e);
    case "boolean":
      return bft(r, e);
    case "number":
      return ud(r, e);
    case "undefined":
      return ud(937, e);
    default:
      return ud(617, e);
  }
}
function ud(r, e) {
  return (e << 5) - e + r | 0;
}
function bft(r, e) {
  return ud(r ? 433 : 863, e);
}
function ZI(r, e) {
  e = ud(149417, e);
  for (let t = 0, n = r.length; t < n; t++)
    e = ud(r.charCodeAt(t), e);
  return e;
}
function yft(r, e) {
  return e = ud(104579, e), r.reduce((t, n) => H7(n, t), e);
}
function Cft(r, e) {
  return e = ud(181387, e), Object.keys(r).sort().reduce((t, n) => (t = ZI(n, t), H7(r[n], t)), e);
}
function EE(r, e, t = 32) {
  const n = t - e, i = ~((1 << n) - 1);
  return (r << e | (i & r) >>> n) >>> 0;
}
function qve(r, e = 0, t = r.byteLength, n = 0) {
  for (let i = 0; i < t; i++)
    r[e + i] = n;
}
function Eft(r, e, t = "0") {
  for (; r.length < e; )
    r = t + r;
  return r;
}
function Nm(r, e = 32) {
  return r instanceof ArrayBuffer ? Array.from(new Uint8Array(r)).map((t) => t.toString(16).padStart(2, "0")).join("") : Eft((r >>> 0).toString(16), e / 4);
}
class UI {
  static {
    this._bigBlock32 = new DataView(new ArrayBuffer(320));
  }
  // 80 * 4 = 320
  constructor() {
    this._h0 = 1732584193, this._h1 = 4023233417, this._h2 = 2562383102, this._h3 = 271733878, this._h4 = 3285377520, this._buff = new Uint8Array(
      67
      /* to fit any utf-8 */
    ), this._buffDV = new DataView(this._buff.buffer), this._buffLen = 0, this._totalLen = 0, this._leftoverHighSurrogate = 0, this._finished = !1;
  }
  update(e) {
    const t = e.length;
    if (t === 0)
      return;
    const n = this._buff;
    let i = this._buffLen, s = this._leftoverHighSurrogate, o, a;
    for (s !== 0 ? (o = s, a = -1, s = 0) : (o = e.charCodeAt(0), a = 0); ; ) {
      let l = o;
      if (Ki(o))
        if (a + 1 < t) {
          const c = e.charCodeAt(a + 1);
          rg(c) ? (a++, l = RI(o, c)) : l = 65533;
        } else {
          s = o;
          break;
        }
      else rg(o) && (l = 65533);
      if (i = this._push(n, i, l), a++, a < t)
        o = e.charCodeAt(a);
      else
        break;
    }
    this._buffLen = i, this._leftoverHighSurrogate = s;
  }
  _push(e, t, n) {
    return n < 128 ? e[t++] = n : n < 2048 ? (e[t++] = 192 | (n & 1984) >>> 6, e[t++] = 128 | (n & 63) >>> 0) : n < 65536 ? (e[t++] = 224 | (n & 61440) >>> 12, e[t++] = 128 | (n & 4032) >>> 6, e[t++] = 128 | (n & 63) >>> 0) : (e[t++] = 240 | (n & 1835008) >>> 18, e[t++] = 128 | (n & 258048) >>> 12, e[t++] = 128 | (n & 4032) >>> 6, e[t++] = 128 | (n & 63) >>> 0), t >= 64 && (this._step(), t -= 64, this._totalLen += 64, e[0] = e[64], e[1] = e[65], e[2] = e[66]), t;
  }
  digest() {
    return this._finished || (this._finished = !0, this._leftoverHighSurrogate && (this._leftoverHighSurrogate = 0, this._buffLen = this._push(
      this._buff,
      this._buffLen,
      65533
      /* SHA1Constant.UNICODE_REPLACEMENT */
    )), this._totalLen += this._buffLen, this._wrapUp()), Nm(this._h0) + Nm(this._h1) + Nm(this._h2) + Nm(this._h3) + Nm(this._h4);
  }
  _wrapUp() {
    this._buff[this._buffLen++] = 128, qve(this._buff, this._buffLen), this._buffLen > 56 && (this._step(), qve(this._buff));
    const e = 8 * this._totalLen;
    this._buffDV.setUint32(56, Math.floor(e / 4294967296), !1), this._buffDV.setUint32(60, e % 4294967296, !1), this._step();
  }
  _step() {
    const e = UI._bigBlock32, t = this._buffDV;
    for (let u = 0; u < 64; u += 4)
      e.setUint32(u, t.getUint32(u, !1), !1);
    for (let u = 64; u < 320; u += 4)
      e.setUint32(u, EE(e.getUint32(u - 12, !1) ^ e.getUint32(u - 32, !1) ^ e.getUint32(u - 56, !1) ^ e.getUint32(u - 64, !1), 1), !1);
    let n = this._h0, i = this._h1, s = this._h2, o = this._h3, a = this._h4, l, c, d;
    for (let u = 0; u < 80; u++)
      u < 20 ? (l = i & s | ~i & o, c = 1518500249) : u < 40 ? (l = i ^ s ^ o, c = 1859775393) : u < 60 ? (l = i & s | i & o | s & o, c = 2400959708) : (l = i ^ s ^ o, c = 3395469782), d = EE(n, 5) + l + a + c + e.getUint32(u * 4, !1) & 4294967295, a = o, o = s, s = EE(i, 30), i = n, n = d;
    this._h0 = this._h0 + n & 4294967295, this._h1 = this._h1 + i & 4294967295, this._h2 = this._h2 + s & 4294967295, this._h3 = this._h3 + o & 4294967295, this._h4 = this._h4 + a & 4294967295;
  }
}
const { getWindow: qe, getWindows: xDe, getWindowsCount: _ft, getWindowId: H8, getWindowById: Gve, onDidRegisterWindow: B7, onWillUnregisterWindow: xft, onDidUnregisterWindow: Sft } = function() {
  const r = /* @__PURE__ */ new Map();
  w0t(Sn, 1);
  const e = { window: Sn, disposables: new ze() };
  r.set(Sn.vscodeWindowId, e);
  const t = new $(), n = new $(), i = new $();
  function s(o, a) {
    return (typeof o == "number" ? r.get(o) : void 0) ?? (a ? e : void 0);
  }
  return {
    onDidRegisterWindow: t.event,
    onWillUnregisterWindow: i.event,
    onDidUnregisterWindow: n.event,
    registerWindow(o) {
      if (r.has(o.vscodeWindowId))
        return me.None;
      const a = new ze(), l = {
        window: o,
        disposables: a.add(new ze())
      };
      return r.set(o.vscodeWindowId, l), a.add(ht(() => {
        r.delete(o.vscodeWindowId), n.fire(o);
      })), a.add(fe(o, Se.BEFORE_UNLOAD, () => {
        i.fire(o);
      })), t.fire(l), a;
    },
    getWindows() {
      return r.values();
    },
    getWindowsCount() {
      return r.size;
    },
    getWindowId(o) {
      return o.vscodeWindowId;
    },
    hasWindow(o) {
      return r.has(o);
    },
    getWindowById: s,
    getWindow(o) {
      const a = o;
      if (a?.ownerDocument?.defaultView)
        return a.ownerDocument.defaultView.window;
      const l = o;
      return l?.view ? l.view.window : Sn;
    },
    getDocument(o) {
      return qe(o).document;
    }
  };
}();
function ic(r) {
  for (; r.firstChild; )
    r.firstChild.remove();
}
class Mft {
  constructor(e, t, n, i) {
    this._node = e, this._type = t, this._handler = n, this._options = i || !1, this._node.addEventListener(this._type, this._handler, this._options);
  }
  dispose() {
    this._handler && (this._node.removeEventListener(this._type, this._handler, this._options), this._node = null, this._handler = null);
  }
}
function fe(r, e, t, n) {
  return new Mft(r, e, t, n);
}
function Dft(r, e) {
  return function(t) {
    return e(new zl(r, t));
  };
}
function Lft(r) {
  return function(e) {
    return r(new zn(e));
  };
}
const ir = function(e, t, n, i) {
  let s = n;
  return t === "click" || t === "mousedown" || t === "contextmenu" ? s = Dft(qe(e), n) : (t === "keydown" || t === "keypress" || t === "keyup") && (s = Lft(n)), fe(e, t, s, i);
};
function Lv(r, e, t) {
  return HA(r, e, t);
}
let SDe, co;
class qI extends WI {
  /**
   *
   * @param node The optional node from which the target window is determined
   */
  constructor(e) {
    super(), this.defaultTarget = e && qe(e);
  }
  cancelAndSet(e, t, n) {
    return super.cancelAndSet(e, t, n ?? this.defaultTarget);
  }
}
class _E {
  constructor(e, t = 0) {
    this._runner = e, this.priority = t, this._canceled = !1;
  }
  dispose() {
    this._canceled = !0;
  }
  execute() {
    if (!this._canceled)
      try {
        this._runner();
      } catch (e) {
        wn(e);
      }
  }
  // Sort by priority (largest to lowest)
  static sort(e, t) {
    return t.priority - e.priority;
  }
}
(function() {
  const r = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), i = (s) => {
    t.set(s, !1);
    const o = r.get(s) ?? [];
    for (e.set(s, o), r.set(s, []), n.set(s, !0); o.length > 0; )
      o.sort(_E.sort), o.shift().execute();
    n.set(s, !1);
  };
  co = (s, o, a = 0) => {
    const l = H8(s), c = new _E(o, a);
    let d = r.get(l);
    return d || (d = [], r.set(l, d)), d.push(c), t.get(l) || (t.set(l, !0), s.requestAnimationFrame(() => i(l))), c;
  }, SDe = (s, o, a) => {
    const l = H8(s);
    if (n.get(l)) {
      const c = new _E(o, a);
      let d = e.get(l);
      return d || (d = [], e.set(l, d)), d.push(c), c;
    } else
      return co(s, o, a);
  };
})();
function P7(r) {
  return qe(r).getComputedStyle(r, null);
}
function BD(r, e) {
  const t = qe(r), n = t.document;
  if (r !== n.body)
    return new Ka(r.clientWidth, r.clientHeight);
  if (pf && t?.visualViewport)
    return new Ka(t.visualViewport.width, t.visualViewport.height);
  if (t?.innerWidth && t.innerHeight)
    return new Ka(t.innerWidth, t.innerHeight);
  if (n.body && n.body.clientWidth && n.body.clientHeight)
    return new Ka(n.body.clientWidth, n.body.clientHeight);
  if (n.documentElement && n.documentElement.clientWidth && n.documentElement.clientHeight)
    return new Ka(n.documentElement.clientWidth, n.documentElement.clientHeight);
  throw new Error("Unable to figure out browser width and height");
}
class gi {
  // Adapted from WinJS
  // Converts a CSS positioning string for the specified element to pixels.
  static convertToPixels(e, t) {
    return parseFloat(t) || 0;
  }
  static getDimension(e, t, n) {
    const i = P7(e), s = i ? i.getPropertyValue(t) : "0";
    return gi.convertToPixels(e, s);
  }
  static getBorderLeftWidth(e) {
    return gi.getDimension(e, "border-left-width", "borderLeftWidth");
  }
  static getBorderRightWidth(e) {
    return gi.getDimension(e, "border-right-width", "borderRightWidth");
  }
  static getBorderTopWidth(e) {
    return gi.getDimension(e, "border-top-width", "borderTopWidth");
  }
  static getBorderBottomWidth(e) {
    return gi.getDimension(e, "border-bottom-width", "borderBottomWidth");
  }
  static getPaddingLeft(e) {
    return gi.getDimension(e, "padding-left", "paddingLeft");
  }
  static getPaddingRight(e) {
    return gi.getDimension(e, "padding-right", "paddingRight");
  }
  static getPaddingTop(e) {
    return gi.getDimension(e, "padding-top", "paddingTop");
  }
  static getPaddingBottom(e) {
    return gi.getDimension(e, "padding-bottom", "paddingBottom");
  }
  static getMarginLeft(e) {
    return gi.getDimension(e, "margin-left", "marginLeft");
  }
  static getMarginTop(e) {
    return gi.getDimension(e, "margin-top", "marginTop");
  }
  static getMarginRight(e) {
    return gi.getDimension(e, "margin-right", "marginRight");
  }
  static getMarginBottom(e) {
    return gi.getDimension(e, "margin-bottom", "marginBottom");
  }
}
class Ka {
  static {
    this.None = new Ka(0, 0);
  }
  constructor(e, t) {
    this.width = e, this.height = t;
  }
  with(e = this.width, t = this.height) {
    return e !== this.width || t !== this.height ? new Ka(e, t) : this;
  }
  static is(e) {
    return typeof e == "object" && typeof e.height == "number" && typeof e.width == "number";
  }
  static lift(e) {
    return e instanceof Ka ? e : new Ka(e.width, e.height);
  }
  static equals(e, t) {
    return e === t ? !0 : !e || !t ? !1 : e.width === t.width && e.height === t.height;
  }
}
function MDe(r) {
  let e = r.offsetParent, t = r.offsetTop, n = r.offsetLeft;
  for (; (r = r.parentNode) !== null && r !== r.ownerDocument.body && r !== r.ownerDocument.documentElement; ) {
    t -= r.scrollTop;
    const i = LDe(r) ? null : P7(r);
    i && (n -= i.direction !== "rtl" ? r.scrollLeft : -r.scrollLeft), r === e && (n += gi.getBorderLeftWidth(r), t += gi.getBorderTopWidth(r), t += r.offsetTop, n += r.offsetLeft, e = r.offsetParent);
  }
  return {
    left: n,
    top: t
  };
}
function To(r) {
  const e = r.getBoundingClientRect(), t = qe(r);
  return {
    left: e.left + t.scrollX,
    top: e.top + t.scrollY,
    width: e.width,
    height: e.height
  };
}
function DDe(r) {
  let e = r, t = 1;
  do {
    const n = P7(e).zoom;
    n != null && n !== "1" && (t *= n), e = e.parentElement;
  } while (e !== null && e !== e.ownerDocument.documentElement);
  return t;
}
function Fa(r) {
  const e = gi.getMarginLeft(r) + gi.getMarginRight(r);
  return r.offsetWidth + e;
}
function xE(r) {
  const e = gi.getBorderLeftWidth(r) + gi.getBorderRightWidth(r), t = gi.getPaddingLeft(r) + gi.getPaddingRight(r);
  return r.offsetWidth - e - t;
}
function kft(r) {
  const e = gi.getBorderTopWidth(r) + gi.getBorderBottomWidth(r), t = gi.getPaddingTop(r) + gi.getPaddingBottom(r);
  return r.offsetHeight - e - t;
}
function PD(r) {
  const e = gi.getMarginTop(r) + gi.getMarginBottom(r);
  return r.offsetHeight + e;
}
function Ji(r, e) {
  return !!e?.contains(r);
}
function Nft(r, e, t) {
  for (; r && r.nodeType === r.ELEMENT_NODE; ) {
    if (r.classList.contains(e))
      return r;
    if (t) {
      if (typeof t == "string") {
        if (r.classList.contains(t))
          return null;
      } else if (r === t)
        return null;
    }
    r = r.parentNode;
  }
  return null;
}
function SE(r, e, t) {
  return !!Nft(r, e, t);
}
function LDe(r) {
  return r && !!r.host && !!r.mode;
}
function B8(r) {
  return !!sg(r);
}
function sg(r) {
  for (; r.parentNode; ) {
    if (r === r.ownerDocument?.body)
      return null;
    r = r.parentNode;
  }
  return LDe(r) ? r : null;
}
function ss() {
  let r = GI().activeElement;
  for (; r?.shadowRoot; )
    r = r.shadowRoot.activeElement;
  return r;
}
function F7(r) {
  return ss() === r;
}
function kDe(r) {
  return Ji(ss(), r);
}
function GI() {
  return _ft() <= 1 ? Sn.document : Array.from(xDe()).map(({ window: e }) => e.document).find((e) => e.hasFocus()) ?? Sn.document;
}
function g6() {
  return GI().defaultView?.window ?? Sn;
}
const NDe = /* @__PURE__ */ new Map();
function ya(r = Sn.document.head, e, t) {
  const n = document.createElement("style");
  if (n.type = "text/css", n.media = "screen", e?.(n), r.appendChild(n), t && t.add(ht(() => n.remove())), r === Sn.document.head) {
    const i = /* @__PURE__ */ new Set();
    NDe.set(n, i);
    for (const { window: s, disposables: o } of xDe()) {
      if (s === Sn)
        continue;
      const a = o.add(Tft(n, i, s));
      t?.add(a);
    }
  }
  return n;
}
function Tft(r, e, t) {
  const n = new ze(), i = r.cloneNode(!0);
  t.document.head.appendChild(i), n.add(ht(() => i.remove()));
  for (const s of Rft(r))
    i.sheet?.insertRule(s.cssText, i.sheet?.cssRules.length);
  return n.add(Ift.observe(r, n, { childList: !0 })(() => {
    i.textContent = r.textContent;
  })), e.add(i), n.add(ht(() => e.delete(i))), n;
}
const Ift = new class {
  constructor() {
    this.mutationObservers = /* @__PURE__ */ new Map();
  }
  observe(r, e, t) {
    let n = this.mutationObservers.get(r);
    n || (n = /* @__PURE__ */ new Map(), this.mutationObservers.set(r, n));
    const i = _De(t);
    let s = n.get(i);
    if (s)
      s.users += 1;
    else {
      const o = new $(), a = new MutationObserver((c) => o.fire(c));
      a.observe(r, t);
      const l = s = {
        users: 1,
        observer: a,
        onDidMutate: o.event
      };
      e.add(ht(() => {
        l.users -= 1, l.users === 0 && (o.dispose(), a.disconnect(), n?.delete(i), n?.size === 0 && this.mutationObservers.delete(r));
      })), n.set(i, s);
    }
    return s.onDidMutate;
  }
}();
let ME = null;
function Oft() {
  return ME || (ME = ya()), ME;
}
function Rft(r) {
  return r?.sheet?.rules ? r.sheet.rules : r?.sheet?.cssRules ? r.sheet.cssRules : [];
}
function FD(r, e, t = Oft()) {
  if (!(!t || !e)) {
    t.sheet?.insertRule(`${r} {${e}}`, 0);
    for (const n of NDe.get(t) ?? [])
      FD(r, e, n);
  }
}
function wr(r) {
  return r instanceof HTMLElement || r instanceof qe(r).HTMLElement;
}
function Qve(r) {
  return r instanceof HTMLAnchorElement || r instanceof qe(r).HTMLAnchorElement;
}
function Vft(r) {
  return r instanceof SVGElement || r instanceof qe(r).SVGElement;
}
function QI(r) {
  return r instanceof MouseEvent || r instanceof qe(r).MouseEvent;
}
function Xh(r) {
  return r instanceof KeyboardEvent || r instanceof qe(r).KeyboardEvent;
}
const Se = {
  // Mouse
  CLICK: "click",
  AUXCLICK: "auxclick",
  DBLCLICK: "dblclick",
  MOUSE_UP: "mouseup",
  MOUSE_DOWN: "mousedown",
  MOUSE_OVER: "mouseover",
  MOUSE_MOVE: "mousemove",
  MOUSE_OUT: "mouseout",
  MOUSE_LEAVE: "mouseleave",
  MOUSE_WHEEL: "wheel",
  POINTER_UP: "pointerup",
  POINTER_DOWN: "pointerdown",
  POINTER_MOVE: "pointermove",
  POINTER_LEAVE: "pointerleave",
  CONTEXT_MENU: "contextmenu",
  // Keyboard
  KEY_DOWN: "keydown",
  KEY_UP: "keyup",
  BEFORE_UNLOAD: "beforeunload",
  CHANGE: "change",
  FOCUS: "focus",
  FOCUS_IN: "focusin",
  FOCUS_OUT: "focusout",
  BLUR: "blur",
  INPUT: "input",
  // Drag
  DRAG_START: "dragstart",
  DRAG: "drag",
  DRAG_ENTER: "dragenter",
  DRAG_LEAVE: "dragleave",
  DRAG_OVER: "dragover",
  DROP: "drop",
  DRAG_END: "dragend"
};
function Hft(r) {
  const e = r;
  return !!(e && typeof e.preventDefault == "function" && typeof e.stopPropagation == "function");
}
const Lt = {
  stop: (r, e) => (r.preventDefault(), e && r.stopPropagation(), r)
};
function Bft(r) {
  const e = [];
  for (let t = 0; r && r.nodeType === r.ELEMENT_NODE; t++)
    e[t] = r.scrollTop, r = r.parentNode;
  return e;
}
function Pft(r, e) {
  for (let t = 0; r && r.nodeType === r.ELEMENT_NODE; t++)
    r.scrollTop !== e[t] && (r.scrollTop = e[t]), r = r.parentNode;
}
class P8 extends me {
  static hasFocusWithin(e) {
    if (wr(e)) {
      const t = sg(e), n = t ? t.activeElement : e.ownerDocument.activeElement;
      return Ji(n, e);
    } else {
      const t = e;
      return Ji(t.document.activeElement, t.document);
    }
  }
  constructor(e) {
    super(), this._onDidFocus = this._register(new $()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new $()), this.onDidBlur = this._onDidBlur.event;
    let t = P8.hasFocusWithin(e), n = !1;
    const i = () => {
      n = !1, t || (t = !0, this._onDidFocus.fire());
    }, s = () => {
      t && (n = !0, (wr(e) ? qe(e) : e).setTimeout(() => {
        n && (n = !1, t = !1, this._onDidBlur.fire());
      }, 0));
    };
    this._refreshStateHandler = () => {
      P8.hasFocusWithin(e) !== t && (t ? s() : i());
    }, this._register(fe(e, Se.FOCUS, i, !0)), this._register(fe(e, Se.BLUR, s, !0)), wr(e) && (this._register(fe(e, Se.FOCUS_IN, () => this._refreshStateHandler())), this._register(fe(e, Se.FOCUS_OUT, () => this._refreshStateHandler())));
  }
}
function Af(r) {
  return new P8(r);
}
function Fft(r, e) {
  return r.after(e), e;
}
function Fe(r, ...e) {
  if (r.append(...e), e.length === 1 && typeof e[0] != "string")
    return e[0];
}
function KI(r, e) {
  return r.insertBefore(e, r.firstChild), e;
}
function ys(r, ...e) {
  r.innerText = "", Fe(r, ...e);
}
const zft = /([\w\-]+)?(#([\w\-]+))?((\.([\w\-]+))*)/;
var P3;
(function(r) {
  r.HTML = "http://www.w3.org/1999/xhtml", r.SVG = "http://www.w3.org/2000/svg";
})(P3 || (P3 = {}));
function TDe(r, e, t, ...n) {
  const i = zft.exec(e);
  if (!i)
    throw new Error("Bad use of emmet");
  const s = i[1] || "div";
  let o;
  return r !== P3.HTML ? o = document.createElementNS(r, s) : o = document.createElement(s), i[3] && (o.id = i[3]), i[4] && (o.className = i[4].replace(/\./g, " ").trim()), t && Object.entries(t).forEach(([a, l]) => {
    typeof l > "u" || (/^on\w+$/.test(a) ? o[a] = l : a === "selected" ? l && o.setAttribute(a, "true") : o.setAttribute(a, l));
  }), o.append(...n), o;
}
function $e(r, e, ...t) {
  return TDe(P3.HTML, r, e, ...t);
}
$e.SVG = function(r, e, ...t) {
  return TDe(P3.SVG, r, e, ...t);
};
function IDe(...r) {
  for (const e of r)
    e.style.display = "", e.removeAttribute("aria-hidden");
}
function Kve(...r) {
  for (const e of r)
    e.style.display = "none", e.setAttribute("aria-hidden", "true");
}
function Yve(r, e) {
  const t = r.devicePixelRatio * e;
  return Math.max(1, Math.floor(t)) / r.devicePixelRatio;
}
function ODe(r) {
  Sn.open(r, "_blank", "noopener");
}
function Wft(r, e) {
  const t = () => {
    e(), n = co(r, t);
  };
  let n = co(r, t);
  return ht(() => n.dispose());
}
CDe.setPreferredWebSchema(/^https:/.test(Sn.location.href) ? "https" : "http");
function Pd(r) {
  return r ? `url('${EDe.uriToBrowserUri(r).toString(!0).replace(/'/g, "%27")}')` : "url('')";
}
function DE(r) {
  return `'${r.replace(/'/g, "%27")}'`;
}
function Cd(r, e) {
  if (r !== void 0) {
    const t = r.match(/^\s*var\((.+)\)$/);
    if (t) {
      const n = t[1].split(",", 2);
      return n.length === 2 && (e = Cd(n[1].trim(), e)), `var(${n[0]}, ${e})`;
    }
    return r;
  }
  return e;
}
function jft(r, e = !1) {
  const t = document.createElement("a");
  return bDe("afterSanitizeAttributes", (n) => {
    for (const i of ["href", "src"])
      if (n.hasAttribute(i)) {
        const s = n.getAttribute(i);
        if (i === "href" && s.startsWith("#"))
          continue;
        if (t.href = s, !r.includes(t.protocol.replace(/:$/, ""))) {
          if (e && i === "src" && t.href.startsWith("data:"))
            continue;
          n.removeAttribute(i);
        }
      }
  }), ht(() => {
    yDe("afterSanitizeAttributes");
  });
}
const Zft = Object.freeze([
  "a",
  "abbr",
  "b",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "li",
  "mark",
  "ol",
  "p",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "samp",
  "small",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
]);
class Iu extends $ {
  constructor() {
    super(), this._subscriptions = new ze(), this._keyStatus = {
      altKey: !1,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1
    }, this._subscriptions.add(xe.runAndSubscribe(B7, ({ window: e, disposables: t }) => this.registerListeners(e, t), { window: Sn, disposables: this._subscriptions }));
  }
  registerListeners(e, t) {
    t.add(fe(e, "keydown", (n) => {
      if (n.defaultPrevented)
        return;
      const i = new zn(n);
      if (!(i.keyCode === 6 && n.repeat)) {
        if (n.altKey && !this._keyStatus.altKey)
          this._keyStatus.lastKeyPressed = "alt";
        else if (n.ctrlKey && !this._keyStatus.ctrlKey)
          this._keyStatus.lastKeyPressed = "ctrl";
        else if (n.metaKey && !this._keyStatus.metaKey)
          this._keyStatus.lastKeyPressed = "meta";
        else if (n.shiftKey && !this._keyStatus.shiftKey)
          this._keyStatus.lastKeyPressed = "shift";
        else if (i.keyCode !== 6)
          this._keyStatus.lastKeyPressed = void 0;
        else
          return;
        this._keyStatus.altKey = n.altKey, this._keyStatus.ctrlKey = n.ctrlKey, this._keyStatus.metaKey = n.metaKey, this._keyStatus.shiftKey = n.shiftKey, this._keyStatus.lastKeyPressed && (this._keyStatus.event = n, this.fire(this._keyStatus));
      }
    }, !0)), t.add(fe(e, "keyup", (n) => {
      n.defaultPrevented || (!n.altKey && this._keyStatus.altKey ? this._keyStatus.lastKeyReleased = "alt" : !n.ctrlKey && this._keyStatus.ctrlKey ? this._keyStatus.lastKeyReleased = "ctrl" : !n.metaKey && this._keyStatus.metaKey ? this._keyStatus.lastKeyReleased = "meta" : !n.shiftKey && this._keyStatus.shiftKey ? this._keyStatus.lastKeyReleased = "shift" : this._keyStatus.lastKeyReleased = void 0, this._keyStatus.lastKeyPressed !== this._keyStatus.lastKeyReleased && (this._keyStatus.lastKeyPressed = void 0), this._keyStatus.altKey = n.altKey, this._keyStatus.ctrlKey = n.ctrlKey, this._keyStatus.metaKey = n.metaKey, this._keyStatus.shiftKey = n.shiftKey, this._keyStatus.lastKeyReleased && (this._keyStatus.event = n, this.fire(this._keyStatus)));
    }, !0)), t.add(fe(e.document.body, "mousedown", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), t.add(fe(e.document.body, "mouseup", () => {
      this._keyStatus.lastKeyPressed = void 0;
    }, !0)), t.add(fe(e.document.body, "mousemove", (n) => {
      n.buttons && (this._keyStatus.lastKeyPressed = void 0);
    }, !0)), t.add(fe(e, "blur", () => {
      this.resetKeyStatus();
    }));
  }
  get keyStatus() {
    return this._keyStatus;
  }
  /**
   * Allows to explicitly reset the key status based on more knowledge (#109062)
   */
  resetKeyStatus() {
    this.doResetKeyStatus(), this.fire(this._keyStatus);
  }
  doResetKeyStatus() {
    this._keyStatus = {
      altKey: !1,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1
    };
  }
  static getInstance() {
    return Iu.instance || (Iu.instance = new Iu()), Iu.instance;
  }
  dispose() {
    super.dispose(), this._subscriptions.dispose();
  }
}
class Uft extends me {
  constructor(e, t) {
    super(), this.element = e, this.callbacks = t, this.counter = 0, this.dragStartTime = 0, this.registerListeners();
  }
  registerListeners() {
    this.callbacks.onDragStart && this._register(fe(this.element, Se.DRAG_START, (e) => {
      this.callbacks.onDragStart?.(e);
    })), this.callbacks.onDrag && this._register(fe(this.element, Se.DRAG, (e) => {
      this.callbacks.onDrag?.(e);
    })), this._register(fe(this.element, Se.DRAG_ENTER, (e) => {
      this.counter++, this.dragStartTime = e.timeStamp, this.callbacks.onDragEnter?.(e);
    })), this._register(fe(this.element, Se.DRAG_OVER, (e) => {
      e.preventDefault(), this.callbacks.onDragOver?.(e, e.timeStamp - this.dragStartTime);
    })), this._register(fe(this.element, Se.DRAG_LEAVE, (e) => {
      this.counter--, this.counter === 0 && (this.dragStartTime = 0, this.callbacks.onDragLeave?.(e));
    })), this._register(fe(this.element, Se.DRAG_END, (e) => {
      this.counter = 0, this.dragStartTime = 0, this.callbacks.onDragEnd?.(e);
    })), this._register(fe(this.element, Se.DROP, (e) => {
      this.counter = 0, this.dragStartTime = 0, this.callbacks.onDrop?.(e);
    }));
  }
}
const qft = /(?<tag>[\w\-]+)?(?:#(?<id>[\w\-]+))?(?<class>(?:\.(?:[\w\-]+))*)(?:@(?<name>(?:[\w\_])+))?/;
function Ut(r, ...e) {
  let t, n;
  Array.isArray(e[0]) ? (t = {}, n = e[0]) : (t = e[0] || {}, n = e[1]);
  const i = qft.exec(r);
  if (!i || !i.groups)
    throw new Error("Bad use of h");
  const s = i.groups.tag || "div", o = document.createElement(s);
  i.groups.id && (o.id = i.groups.id);
  const a = [];
  if (i.groups.class)
    for (const c of i.groups.class.split("."))
      c !== "" && a.push(c);
  if (t.className !== void 0)
    for (const c of t.className.split("."))
      c !== "" && a.push(c);
  a.length > 0 && (o.className = a.join(" "));
  const l = {};
  if (i.groups.name && (l[i.groups.name] = o), n)
    for (const c of n)
      wr(c) ? o.appendChild(c) : typeof c == "string" ? o.append(c) : "root" in c && (Object.assign(l, c), o.appendChild(c.root));
  for (const [c, d] of Object.entries(t))
    if (c !== "className")
      if (c === "style")
        for (const [u, f] of Object.entries(d))
          o.style.setProperty(Xve(u), typeof f == "number" ? f + "px" : "" + f);
      else c === "tabIndex" ? o.tabIndex = d : o.setAttribute(Xve(c), d.toString());
  return l.root = o, l;
}
function Xve(r) {
  return r.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
class Gft extends me {
  constructor(e) {
    super(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._listener = () => this._handleChange(e, !0), this._mediaQueryList = null, this._handleChange(e, !1);
  }
  _handleChange(e, t) {
    this._mediaQueryList?.removeEventListener("change", this._listener), this._mediaQueryList = e.matchMedia(`(resolution: ${e.devicePixelRatio}dppx)`), this._mediaQueryList.addEventListener("change", this._listener), t && this._onDidChange.fire();
  }
}
class Qft extends me {
  get value() {
    return this._value;
  }
  constructor(e) {
    super(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._value = this._getPixelRatio(e);
    const t = this._register(new Gft(e));
    this._register(t.onDidChange(() => {
      this._value = this._getPixelRatio(e), this._onDidChange.fire(this._value);
    }));
  }
  _getPixelRatio(e) {
    const t = document.createElement("canvas").getContext("2d"), n = e.devicePixelRatio || 1, i = t.webkitBackingStorePixelRatio || t.mozBackingStorePixelRatio || t.msBackingStorePixelRatio || t.oBackingStorePixelRatio || t.backingStorePixelRatio || 1;
    return n / i;
  }
}
class Kft {
  constructor() {
    this.mapWindowIdToPixelRatioMonitor = /* @__PURE__ */ new Map();
  }
  _getOrCreatePixelRatioMonitor(e) {
    const t = H8(e);
    let n = this.mapWindowIdToPixelRatioMonitor.get(t);
    return n || (n = new Qft(e), this.mapWindowIdToPixelRatioMonitor.set(t, n), xe.once(Sft)(({ vscodeWindowId: i }) => {
      i === t && (n?.dispose(), this.mapWindowIdToPixelRatioMonitor.delete(t));
    })), n;
  }
  getInstance(e) {
    return this._getOrCreatePixelRatioMonitor(e);
  }
}
const F8 = new Kft();
class RDe {
  constructor(e) {
    this.domNode = e, this._maxWidth = "", this._width = "", this._height = "", this._top = "", this._left = "", this._bottom = "", this._right = "", this._paddingLeft = "", this._fontFamily = "", this._fontWeight = "", this._fontSize = "", this._fontStyle = "", this._fontFeatureSettings = "", this._fontVariationSettings = "", this._textDecoration = "", this._lineHeight = "", this._letterSpacing = "", this._className = "", this._display = "", this._position = "", this._visibility = "", this._color = "", this._backgroundColor = "", this._layerHint = !1, this._contain = "none", this._boxShadow = "";
  }
  setMaxWidth(e) {
    const t = Ll(e);
    this._maxWidth !== t && (this._maxWidth = t, this.domNode.style.maxWidth = this._maxWidth);
  }
  setWidth(e) {
    const t = Ll(e);
    this._width !== t && (this._width = t, this.domNode.style.width = this._width);
  }
  setHeight(e) {
    const t = Ll(e);
    this._height !== t && (this._height = t, this.domNode.style.height = this._height);
  }
  setTop(e) {
    const t = Ll(e);
    this._top !== t && (this._top = t, this.domNode.style.top = this._top);
  }
  setLeft(e) {
    const t = Ll(e);
    this._left !== t && (this._left = t, this.domNode.style.left = this._left);
  }
  setBottom(e) {
    const t = Ll(e);
    this._bottom !== t && (this._bottom = t, this.domNode.style.bottom = this._bottom);
  }
  setRight(e) {
    const t = Ll(e);
    this._right !== t && (this._right = t, this.domNode.style.right = this._right);
  }
  setPaddingLeft(e) {
    const t = Ll(e);
    this._paddingLeft !== t && (this._paddingLeft = t, this.domNode.style.paddingLeft = this._paddingLeft);
  }
  setFontFamily(e) {
    this._fontFamily !== e && (this._fontFamily = e, this.domNode.style.fontFamily = this._fontFamily);
  }
  setFontWeight(e) {
    this._fontWeight !== e && (this._fontWeight = e, this.domNode.style.fontWeight = this._fontWeight);
  }
  setFontSize(e) {
    const t = Ll(e);
    this._fontSize !== t && (this._fontSize = t, this.domNode.style.fontSize = this._fontSize);
  }
  setFontStyle(e) {
    this._fontStyle !== e && (this._fontStyle = e, this.domNode.style.fontStyle = this._fontStyle);
  }
  setFontFeatureSettings(e) {
    this._fontFeatureSettings !== e && (this._fontFeatureSettings = e, this.domNode.style.fontFeatureSettings = this._fontFeatureSettings);
  }
  setFontVariationSettings(e) {
    this._fontVariationSettings !== e && (this._fontVariationSettings = e, this.domNode.style.fontVariationSettings = this._fontVariationSettings);
  }
  setTextDecoration(e) {
    this._textDecoration !== e && (this._textDecoration = e, this.domNode.style.textDecoration = this._textDecoration);
  }
  setLineHeight(e) {
    const t = Ll(e);
    this._lineHeight !== t && (this._lineHeight = t, this.domNode.style.lineHeight = this._lineHeight);
  }
  setLetterSpacing(e) {
    const t = Ll(e);
    this._letterSpacing !== t && (this._letterSpacing = t, this.domNode.style.letterSpacing = this._letterSpacing);
  }
  setClassName(e) {
    this._className !== e && (this._className = e, this.domNode.className = this._className);
  }
  toggleClassName(e, t) {
    this.domNode.classList.toggle(e, t), this._className = this.domNode.className;
  }
  setDisplay(e) {
    this._display !== e && (this._display = e, this.domNode.style.display = this._display);
  }
  setPosition(e) {
    this._position !== e && (this._position = e, this.domNode.style.position = this._position);
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this.domNode.style.visibility = this._visibility);
  }
  setColor(e) {
    this._color !== e && (this._color = e, this.domNode.style.color = this._color);
  }
  setBackgroundColor(e) {
    this._backgroundColor !== e && (this._backgroundColor = e, this.domNode.style.backgroundColor = this._backgroundColor);
  }
  setLayerHinting(e) {
    this._layerHint !== e && (this._layerHint = e, this.domNode.style.transform = this._layerHint ? "translate3d(0px, 0px, 0px)" : "");
  }
  setBoxShadow(e) {
    this._boxShadow !== e && (this._boxShadow = e, this.domNode.style.boxShadow = e);
  }
  setContain(e) {
    this._contain !== e && (this._contain = e, this.domNode.style.contain = this._contain);
  }
  setAttribute(e, t) {
    this.domNode.setAttribute(e, t);
  }
  removeAttribute(e) {
    this.domNode.removeAttribute(e);
  }
  appendChild(e) {
    this.domNode.appendChild(e.domNode);
  }
  removeChild(e) {
    this.domNode.removeChild(e.domNode);
  }
}
function Ll(r) {
  return typeof r == "number" ? `${r}px` : r;
}
function Yt(r) {
  return new RDe(r);
}
function Br(r, e) {
  r instanceof RDe ? (r.setFontFamily(e.getMassagedFontFamily()), r.setFontWeight(e.fontWeight), r.setFontSize(e.fontSize), r.setFontFeatureSettings(e.fontFeatureSettings), r.setFontVariationSettings(e.fontVariationSettings), r.setLineHeight(e.lineHeight), r.setLetterSpacing(e.letterSpacing)) : (r.style.fontFamily = e.getMassagedFontFamily(), r.style.fontWeight = e.fontWeight, r.style.fontSize = e.fontSize + "px", r.style.fontFeatureSettings = e.fontFeatureSettings, r.style.fontVariationSettings = e.fontVariationSettings, r.style.lineHeight = e.lineHeight + "px", r.style.letterSpacing = e.letterSpacing + "px");
}
class Yft {
  constructor(e, t) {
    this.chr = e, this.type = t, this.width = 0;
  }
  fulfill(e) {
    this.width = e;
  }
}
class YI {
  constructor(e, t) {
    this._bareFontInfo = e, this._requests = t, this._container = null, this._testElements = null;
  }
  read(e) {
    this._createDomElements(), e.document.body.appendChild(this._container), this._readFromDomElements(), this._container?.remove(), this._container = null, this._testElements = null;
  }
  _createDomElements() {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.top = "-50000px", e.style.width = "50000px";
    const t = document.createElement("div");
    Br(t, this._bareFontInfo), e.appendChild(t);
    const n = document.createElement("div");
    Br(n, this._bareFontInfo), n.style.fontWeight = "bold", e.appendChild(n);
    const i = document.createElement("div");
    Br(i, this._bareFontInfo), i.style.fontStyle = "italic", e.appendChild(i);
    const s = [];
    for (const o of this._requests) {
      let a;
      o.type === 0 && (a = t), o.type === 2 && (a = n), o.type === 1 && (a = i), a.appendChild(document.createElement("br"));
      const l = document.createElement("span");
      YI._render(l, o), a.appendChild(l), s.push(l);
    }
    this._container = e, this._testElements = s;
  }
  static _render(e, t) {
    if (t.chr === " ") {
      let n = " ";
      for (let i = 0; i < 8; i++)
        n += n;
      e.innerText = n;
    } else {
      let n = t.chr;
      for (let i = 0; i < 8; i++)
        n += n;
      e.textContent = n;
    }
  }
  _readFromDomElements() {
    for (let e = 0, t = this._requests.length; e < t; e++) {
      const n = this._requests[e], i = this._testElements[e];
      n.fulfill(i.offsetWidth / 256);
    }
  }
}
function Xft(r, e, t) {
  new YI(e, t).read(r);
}
const bu = new class {
  constructor() {
    this._zoomLevel = 0, this._onDidChangeZoomLevel = new $(), this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event;
  }
  getZoomLevel() {
    return this._zoomLevel;
  }
  setZoomLevel(r) {
    r = Math.min(Math.max(-5, r), 20), this._zoomLevel !== r && (this._zoomLevel = r, this._onDidChangeZoomLevel.fire(this._zoomLevel));
  }
}(), Jft = zt ? 1.5 : 1.35, LE = 8;
class U0 {
  /**
   * @internal
   */
  static createFromValidatedSettings(e, t, n) {
    const i = e.get(
      49
      /* EditorOption.fontFamily */
    ), s = e.get(
      53
      /* EditorOption.fontWeight */
    ), o = e.get(
      52
      /* EditorOption.fontSize */
    ), a = e.get(
      51
      /* EditorOption.fontLigatures */
    ), l = e.get(
      54
      /* EditorOption.fontVariations */
    ), c = e.get(
      67
      /* EditorOption.lineHeight */
    ), d = e.get(
      64
      /* EditorOption.letterSpacing */
    );
    return U0._create(i, s, o, a, l, c, d, t, n);
  }
  /**
   * @internal
   */
  static _create(e, t, n, i, s, o, a, l, c) {
    o === 0 ? o = Jft * n : o < LE && (o = o * n), o = Math.round(o), o < LE && (o = LE);
    const d = 1 + (c ? 0 : bu.getZoomLevel() * 0.1);
    return n *= d, o *= d, s === rd.TRANSLATE && (t === "normal" || t === "bold" ? s = rd.OFF : (s = `'wght' ${parseInt(t, 10)}`, t = "normal")), new U0({
      pixelRatio: l,
      fontFamily: e,
      fontWeight: t,
      fontSize: n,
      fontFeatureSettings: i,
      fontVariationSettings: s,
      lineHeight: o,
      letterSpacing: a
    });
  }
  /**
   * @internal
   */
  constructor(e) {
    this._bareFontInfoBrand = void 0, this.pixelRatio = e.pixelRatio, this.fontFamily = String(e.fontFamily), this.fontWeight = String(e.fontWeight), this.fontSize = e.fontSize, this.fontFeatureSettings = e.fontFeatureSettings, this.fontVariationSettings = e.fontVariationSettings, this.lineHeight = e.lineHeight | 0, this.letterSpacing = e.letterSpacing;
  }
  /**
   * @internal
   */
  getId() {
    return `${this.pixelRatio}-${this.fontFamily}-${this.fontWeight}-${this.fontSize}-${this.fontFeatureSettings}-${this.fontVariationSettings}-${this.lineHeight}-${this.letterSpacing}`;
  }
  /**
   * @internal
   */
  getMassagedFontFamily() {
    const e = Bo.fontFamily, t = U0._wrapInQuotes(this.fontFamily);
    return e && this.fontFamily !== e ? `${t}, ${e}` : t;
  }
  static _wrapInQuotes(e) {
    return /[,"']/.test(e) ? e : /[+ ]/.test(e) ? `"${e}"` : e;
  }
}
const $ft = 2;
class zD extends U0 {
  /**
   * @internal
   */
  constructor(e, t) {
    super(e), this._editorStylingBrand = void 0, this.version = $ft, this.isTrusted = t, this.isMonospace = e.isMonospace, this.typicalHalfwidthCharacterWidth = e.typicalHalfwidthCharacterWidth, this.typicalFullwidthCharacterWidth = e.typicalFullwidthCharacterWidth, this.canUseHalfwidthRightwardsArrow = e.canUseHalfwidthRightwardsArrow, this.spaceWidth = e.spaceWidth, this.middotWidth = e.middotWidth, this.wsmiddotWidth = e.wsmiddotWidth, this.maxDigitWidth = e.maxDigitWidth;
  }
  /**
   * @internal
   */
  equals(e) {
    return this.fontFamily === e.fontFamily && this.fontWeight === e.fontWeight && this.fontSize === e.fontSize && this.fontFeatureSettings === e.fontFeatureSettings && this.fontVariationSettings === e.fontVariationSettings && this.lineHeight === e.lineHeight && this.letterSpacing === e.letterSpacing && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.typicalFullwidthCharacterWidth === e.typicalFullwidthCharacterWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.maxDigitWidth === e.maxDigitWidth;
  }
}
class e2t extends me {
  constructor() {
    super(...arguments), this._cache = /* @__PURE__ */ new Map(), this._evictUntrustedReadingsTimeout = -1, this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event;
  }
  dispose() {
    this._evictUntrustedReadingsTimeout !== -1 && (clearTimeout(this._evictUntrustedReadingsTimeout), this._evictUntrustedReadingsTimeout = -1), super.dispose();
  }
  /**
   * Clear all cached font information and trigger a change event.
   */
  clearAllFontInfos() {
    this._cache.clear(), this._onDidChange.fire();
  }
  _ensureCache(e) {
    const t = H8(e);
    let n = this._cache.get(t);
    return n || (n = new t2t(), this._cache.set(t, n)), n;
  }
  _writeToCache(e, t, n) {
    this._ensureCache(e).put(t, n), !n.isTrusted && this._evictUntrustedReadingsTimeout === -1 && (this._evictUntrustedReadingsTimeout = e.setTimeout(() => {
      this._evictUntrustedReadingsTimeout = -1, this._evictUntrustedReadings(e);
    }, 5e3));
  }
  _evictUntrustedReadings(e) {
    const t = this._ensureCache(e), n = t.getValues();
    let i = !1;
    for (const s of n)
      s.isTrusted || (i = !0, t.remove(s));
    i && this._onDidChange.fire();
  }
  /**
   * Read font information.
   */
  readFontInfo(e, t) {
    const n = this._ensureCache(e);
    if (!n.has(t)) {
      let i = this._actualReadFontInfo(e, t);
      (i.typicalHalfwidthCharacterWidth <= 2 || i.typicalFullwidthCharacterWidth <= 2 || i.spaceWidth <= 2 || i.maxDigitWidth <= 2) && (i = new zD({
        pixelRatio: F8.getInstance(e).value,
        fontFamily: i.fontFamily,
        fontWeight: i.fontWeight,
        fontSize: i.fontSize,
        fontFeatureSettings: i.fontFeatureSettings,
        fontVariationSettings: i.fontVariationSettings,
        lineHeight: i.lineHeight,
        letterSpacing: i.letterSpacing,
        isMonospace: i.isMonospace,
        typicalHalfwidthCharacterWidth: Math.max(i.typicalHalfwidthCharacterWidth, 5),
        typicalFullwidthCharacterWidth: Math.max(i.typicalFullwidthCharacterWidth, 5),
        canUseHalfwidthRightwardsArrow: i.canUseHalfwidthRightwardsArrow,
        spaceWidth: Math.max(i.spaceWidth, 5),
        middotWidth: Math.max(i.middotWidth, 5),
        wsmiddotWidth: Math.max(i.wsmiddotWidth, 5),
        maxDigitWidth: Math.max(i.maxDigitWidth, 5)
      }, !1)), this._writeToCache(e, t, i);
    }
    return n.get(t);
  }
  _createRequest(e, t, n, i) {
    const s = new Yft(e, t);
    return n.push(s), i?.push(s), s;
  }
  _actualReadFontInfo(e, t) {
    const n = [], i = [], s = this._createRequest("n", 0, n, i), o = this._createRequest("ｍ", 0, n, null), a = this._createRequest(" ", 0, n, i), l = this._createRequest("0", 0, n, i), c = this._createRequest("1", 0, n, i), d = this._createRequest("2", 0, n, i), u = this._createRequest("3", 0, n, i), f = this._createRequest("4", 0, n, i), p = this._createRequest("5", 0, n, i), g = this._createRequest("6", 0, n, i), m = this._createRequest("7", 0, n, i), A = this._createRequest("8", 0, n, i), w = this._createRequest("9", 0, n, i), v = this._createRequest("→", 0, n, i), y = this._createRequest("￫", 0, n, null), _ = this._createRequest("·", 0, n, i), S = this._createRequest("⸱", 0, n, null), D = "|/-_ilm%";
    for (let V = 0, N = D.length; V < N; V++)
      this._createRequest(D.charAt(V), 0, n, i), this._createRequest(D.charAt(V), 1, n, i), this._createRequest(D.charAt(V), 2, n, i);
    Xft(e, t, n);
    const M = Math.max(l.width, c.width, d.width, u.width, f.width, p.width, g.width, m.width, A.width, w.width);
    let L = t.fontFeatureSettings === Bl.OFF;
    const T = i[0].width;
    for (let V = 1, N = i.length; L && V < N; V++) {
      const R = T - i[V].width;
      if (R < -1e-3 || R > 1e-3) {
        L = !1;
        break;
      }
    }
    let B = !0;
    return L && y.width !== T && (B = !1), y.width > v.width && (B = !1), new zD({
      pixelRatio: F8.getInstance(e).value,
      fontFamily: t.fontFamily,
      fontWeight: t.fontWeight,
      fontSize: t.fontSize,
      fontFeatureSettings: t.fontFeatureSettings,
      fontVariationSettings: t.fontVariationSettings,
      lineHeight: t.lineHeight,
      letterSpacing: t.letterSpacing,
      isMonospace: L,
      typicalHalfwidthCharacterWidth: s.width,
      typicalFullwidthCharacterWidth: o.width,
      canUseHalfwidthRightwardsArrow: B,
      spaceWidth: a.width,
      middotWidth: _.width,
      wsmiddotWidth: S.width,
      maxDigitWidth: M
    }, !0);
  }
}
class t2t {
  constructor() {
    this._keys = /* @__PURE__ */ Object.create(null), this._values = /* @__PURE__ */ Object.create(null);
  }
  has(e) {
    const t = e.getId();
    return !!this._values[t];
  }
  get(e) {
    const t = e.getId();
    return this._values[t];
  }
  put(e, t) {
    const n = e.getId();
    this._keys[n] = e, this._values[n] = t;
  }
  remove(e) {
    const t = e.getId();
    delete this._keys[t], delete this._values[t];
  }
  getValues() {
    return Object.keys(this._keys).map((e) => this._values[e]);
  }
}
const WD = new e2t();
var Wl;
(function(r) {
  r.serviceIds = /* @__PURE__ */ new Map(), r.DI_TARGET = "$di$target", r.DI_DEPENDENCIES = "$di$dependencies";
  function e(t) {
    return t[r.DI_DEPENDENCIES] || [];
  }
  r.getServiceDependencies = e;
})(Wl || (Wl = {}));
const xn = Wt("instantiationService");
function n2t(r, e, t) {
  e[Wl.DI_TARGET] === e ? e[Wl.DI_DEPENDENCIES].push({ id: r, index: t }) : (e[Wl.DI_DEPENDENCIES] = [{ id: r, index: t }], e[Wl.DI_TARGET] = e);
}
function Wt(r) {
  if (Wl.serviceIds.has(r))
    return Wl.serviceIds.get(r);
  const e = function(t, n, i) {
    if (arguments.length !== 3)
      throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
    n2t(e, t, i);
  };
  return e.toString = () => r, Wl.serviceIds.set(r, e), e;
}
const Ui = Wt("codeEditorService"), Wo = Wt("modelService"), z7 = Wt("textModelService");
class Ed extends me {
  constructor(e, t = "", n = "", i = !0, s) {
    super(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._enabled = !0, this._id = e, this._label = t, this._cssClass = n, this._enabled = i, this._actionCallback = s;
  }
  get id() {
    return this._id;
  }
  get label() {
    return this._label;
  }
  set label(e) {
    this._setLabel(e);
  }
  _setLabel(e) {
    this._label !== e && (this._label = e, this._onDidChange.fire({ label: e }));
  }
  get tooltip() {
    return this._tooltip || "";
  }
  set tooltip(e) {
    this._setTooltip(e);
  }
  _setTooltip(e) {
    this._tooltip !== e && (this._tooltip = e, this._onDidChange.fire({ tooltip: e }));
  }
  get class() {
    return this._cssClass;
  }
  set class(e) {
    this._setClass(e);
  }
  _setClass(e) {
    this._cssClass !== e && (this._cssClass = e, this._onDidChange.fire({ class: e }));
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._setEnabled(e);
  }
  _setEnabled(e) {
    this._enabled !== e && (this._enabled = e, this._onDidChange.fire({ enabled: e }));
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._setChecked(e);
  }
  _setChecked(e) {
    this._checked !== e && (this._checked = e, this._onDidChange.fire({ checked: e }));
  }
  async run(e, t) {
    this._actionCallback && await this._actionCallback(e);
  }
}
class wf extends me {
  constructor() {
    super(...arguments), this._onWillRun = this._register(new $()), this.onWillRun = this._onWillRun.event, this._onDidRun = this._register(new $()), this.onDidRun = this._onDidRun.event;
  }
  async run(e, t) {
    if (!e.enabled)
      return;
    this._onWillRun.fire({ action: e });
    let n;
    try {
      await this.runAction(e, t);
    } catch (i) {
      n = i;
    }
    this._onDidRun.fire({ action: e, error: n });
  }
  async runAction(e, t) {
    await e.run(t);
  }
}
class Pr {
  constructor() {
    this.id = Pr.ID, this.label = "", this.tooltip = "", this.class = "separator", this.enabled = !1, this.checked = !1;
  }
  /**
   * Joins all non-empty lists of actions with separators.
   */
  static join(...e) {
    let t = [];
    for (const n of e)
      n.length && (t.length ? t = [...t, new Pr(), ...n] : t = n);
    return t;
  }
  static {
    this.ID = "vs.actions.separator";
  }
  async run() {
  }
}
class W7 {
  get actions() {
    return this._actions;
  }
  constructor(e, t, n, i) {
    this.tooltip = "", this.enabled = !0, this.checked = void 0, this.id = e, this.label = t, this.class = i, this._actions = n;
  }
  async run() {
  }
}
class XI extends Ed {
  static {
    this.ID = "vs.actions.empty";
  }
  constructor() {
    super(XI.ID, C("submenu.empty", "(empty)"), void 0, !1);
  }
}
function Ap(r) {
  return {
    id: r.id,
    label: r.label,
    tooltip: r.tooltip ?? r.label,
    class: r.class,
    enabled: r.enabled ?? !0,
    checked: r.checked,
    run: async (...e) => r.run(...e)
  };
}
var jD;
(function(r) {
  function e(t) {
    return t && typeof t == "object" && typeof t.id == "string";
  }
  r.isThemeColor = e;
})(jD || (jD = {}));
var Tt;
(function(r) {
  r.iconNameSegment = "[A-Za-z0-9]+", r.iconNameExpression = "[A-Za-z0-9-]+", r.iconModifierExpression = "~[A-Za-z]+", r.iconNameCharacter = "[A-Za-z0-9~-]";
  const e = new RegExp(`^(${r.iconNameExpression})(${r.iconModifierExpression})?$`);
  function t(f) {
    const p = e.exec(f.id);
    if (!p)
      return t(ke.error);
    const [, g, m] = p, A = ["codicon", "codicon-" + g];
    return m && A.push("codicon-modifier-" + m.substring(1)), A;
  }
  r.asClassNameArray = t;
  function n(f) {
    return t(f).join(" ");
  }
  r.asClassName = n;
  function i(f) {
    return "." + t(f).join(".");
  }
  r.asCSSSelector = i;
  function s(f) {
    return f && typeof f == "object" && typeof f.id == "string" && (typeof f.color > "u" || jD.isThemeColor(f.color));
  }
  r.isThemeIcon = s;
  const o = new RegExp(`^\\$\\((${r.iconNameExpression}(?:${r.iconModifierExpression})?)\\)$`);
  function a(f) {
    const p = o.exec(f);
    if (!p)
      return;
    const [, g] = p;
    return { id: g };
  }
  r.fromString = a;
  function l(f) {
    return { id: f };
  }
  r.fromId = l;
  function c(f, p) {
    let g = f.id;
    const m = g.lastIndexOf("~");
    return m !== -1 && (g = g.substring(0, m)), p && (g = `${g}~${p}`), { id: g };
  }
  r.modify = c;
  function d(f) {
    const p = f.id.lastIndexOf("~");
    if (p !== -1)
      return f.id.substring(p + 1);
  }
  r.getModifier = d;
  function u(f, p) {
    return f.id === p.id && f.color?.id === p.color?.id;
  }
  r.isEqual = u;
})(Tt || (Tt = {}));
const jo = Wt("commandService"), Zs = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._onDidRegisterCommand = new $(), this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }
  registerCommand(r, e) {
    if (!r)
      throw new Error("invalid command");
    if (typeof r == "string") {
      if (!e)
        throw new Error("invalid command");
      return this.registerCommand({ id: r, handler: e });
    }
    if (r.metadata && Array.isArray(r.metadata.args)) {
      const o = [];
      for (const l of r.metadata.args)
        o.push(l.constraint);
      const a = r.handler;
      r.handler = function(l, ...c) {
        return Aut(c, o), a(l, ...c);
      };
    }
    const { id: t } = r;
    let n = this._commands.get(t);
    n || (n = new no(), this._commands.set(t, n));
    const i = n.unshift(r), s = ht(() => {
      i(), this._commands.get(t)?.isEmpty() && this._commands.delete(t);
    });
    return this._onDidRegisterCommand.fire(t), s;
  }
  registerCommandAlias(r, e) {
    return Zs.registerCommand(r, (t, ...n) => t.get(jo).executeCommand(e, ...n));
  }
  getCommand(r) {
    const e = this._commands.get(r);
    if (!(!e || e.isEmpty()))
      return Jt.first(e);
  }
  getCommands() {
    const r = /* @__PURE__ */ new Map();
    for (const e of this._commands.keys()) {
      const t = this.getCommand(e);
      t && r.set(e, t);
    }
    return r;
  }
}();
Zs.registerCommand("noop", () => {
});
function kE(...r) {
  switch (r.length) {
    case 1:
      return C("contextkey.scanner.hint.didYouMean1", "Did you mean {0}?", r[0]);
    case 2:
      return C("contextkey.scanner.hint.didYouMean2", "Did you mean {0} or {1}?", r[0], r[1]);
    case 3:
      return C("contextkey.scanner.hint.didYouMean3", "Did you mean {0}, {1} or {2}?", r[0], r[1], r[2]);
    default:
      return;
  }
}
const i2t = C("contextkey.scanner.hint.didYouForgetToOpenOrCloseQuote", "Did you forget to open or close the quote?"), r2t = C("contextkey.scanner.hint.didYouForgetToEscapeSlash", "Did you forget to escape the '/' (slash) character? Put two backslashes before it to escape, e.g., '\\\\/'.");
class yu {
  constructor() {
    this._input = "", this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this.stringRe = /[a-zA-Z0-9_<>\-\./\\:\*\?\+\[\]\^,#@;"%\$\p{L}-]+/uy;
  }
  static getLexeme(e) {
    switch (e.type) {
      case 0:
        return "(";
      case 1:
        return ")";
      case 2:
        return "!";
      case 3:
        return e.isTripleEq ? "===" : "==";
      case 4:
        return e.isTripleEq ? "!==" : "!=";
      case 5:
        return "<";
      case 6:
        return "<=";
      case 7:
        return ">=";
      case 8:
        return ">=";
      case 9:
        return "=~";
      case 10:
        return e.lexeme;
      case 11:
        return "true";
      case 12:
        return "false";
      case 13:
        return "in";
      case 14:
        return "not";
      case 15:
        return "&&";
      case 16:
        return "||";
      case 17:
        return e.lexeme;
      case 18:
        return e.lexeme;
      case 19:
        return e.lexeme;
      case 20:
        return "EOF";
      default:
        throw SI(`unhandled token type: ${JSON.stringify(e)}; have you forgotten to add a case?`);
    }
  }
  static {
    this._regexFlags = new Set(["i", "g", "s", "m", "y", "u"].map((e) => e.charCodeAt(0)));
  }
  static {
    this._keywords = /* @__PURE__ */ new Map([
      [
        "not",
        14
        /* TokenType.Not */
      ],
      [
        "in",
        13
        /* TokenType.In */
      ],
      [
        "false",
        12
        /* TokenType.False */
      ],
      [
        "true",
        11
        /* TokenType.True */
      ]
    ]);
  }
  reset(e) {
    return this._input = e, this._start = 0, this._current = 0, this._tokens = [], this._errors = [], this;
  }
  scan() {
    for (; !this._isAtEnd(); )
      switch (this._start = this._current, this._advance()) {
        case 40:
          this._addToken(
            0
            /* TokenType.LParen */
          );
          break;
        case 41:
          this._addToken(
            1
            /* TokenType.RParen */
          );
          break;
        case 33:
          if (this._match(
            61
            /* CharCode.Equals */
          )) {
            const t = this._match(
              61
              /* CharCode.Equals */
            );
            this._tokens.push({ type: 4, offset: this._start, isTripleEq: t });
          } else
            this._addToken(
              2
              /* TokenType.Neg */
            );
          break;
        case 39:
          this._quotedString();
          break;
        case 47:
          this._regex();
          break;
        case 61:
          if (this._match(
            61
            /* CharCode.Equals */
          )) {
            const t = this._match(
              61
              /* CharCode.Equals */
            );
            this._tokens.push({ type: 3, offset: this._start, isTripleEq: t });
          } else this._match(
            126
            /* CharCode.Tilde */
          ) ? this._addToken(
            9
            /* TokenType.RegexOp */
          ) : this._error(kE("==", "=~"));
          break;
        case 60:
          this._addToken(
            this._match(
              61
              /* CharCode.Equals */
            ) ? 6 : 5
            /* TokenType.Lt */
          );
          break;
        case 62:
          this._addToken(
            this._match(
              61
              /* CharCode.Equals */
            ) ? 8 : 7
            /* TokenType.Gt */
          );
          break;
        case 38:
          this._match(
            38
            /* CharCode.Ampersand */
          ) ? this._addToken(
            15
            /* TokenType.And */
          ) : this._error(kE("&&"));
          break;
        case 124:
          this._match(
            124
            /* CharCode.Pipe */
          ) ? this._addToken(
            16
            /* TokenType.Or */
          ) : this._error(kE("||"));
          break;
        // TODO@ulugbekna: 1) rewrite using a regex 2) reconsider what characters are considered whitespace, including unicode, nbsp, etc.
        case 32:
        case 13:
        case 9:
        case 10:
        case 160:
          break;
        default:
          this._string();
      }
    return this._start = this._current, this._addToken(
      20
      /* TokenType.EOF */
    ), Array.from(this._tokens);
  }
  _match(e) {
    return this._isAtEnd() || this._input.charCodeAt(this._current) !== e ? !1 : (this._current++, !0);
  }
  _advance() {
    return this._input.charCodeAt(this._current++);
  }
  _peek() {
    return this._isAtEnd() ? 0 : this._input.charCodeAt(this._current);
  }
  _addToken(e) {
    this._tokens.push({ type: e, offset: this._start });
  }
  _error(e) {
    const t = this._start, n = this._input.substring(this._start, this._current), i = { type: 19, offset: this._start, lexeme: n };
    this._errors.push({ offset: t, lexeme: n, additionalInfo: e }), this._tokens.push(i);
  }
  _string() {
    this.stringRe.lastIndex = this._start;
    const e = this.stringRe.exec(this._input);
    if (e) {
      this._current = this._start + e[0].length;
      const t = this._input.substring(this._start, this._current), n = yu._keywords.get(t);
      n ? this._addToken(n) : this._tokens.push({ type: 17, lexeme: t, offset: this._start });
    }
  }
  // captures the lexeme without the leading and trailing '
  _quotedString() {
    for (; this._peek() !== 39 && !this._isAtEnd(); )
      this._advance();
    if (this._isAtEnd()) {
      this._error(i2t);
      return;
    }
    this._advance(), this._tokens.push({ type: 18, lexeme: this._input.substring(this._start + 1, this._current - 1), offset: this._start + 1 });
  }
  /*
   * Lexing a regex expression: /.../[igsmyu]*
   * Based on https://github.com/microsoft/TypeScript/blob/9247ef115e617805983740ba795d7a8164babf89/src/compiler/scanner.ts#L2129-L2181
   *
   * Note that we want slashes within a regex to be escaped, e.g., /file:\\/\\/\\// should match `file:///`
   */
  _regex() {
    let e = this._current, t = !1, n = !1;
    for (; ; ) {
      if (e >= this._input.length) {
        this._current = e, this._error(r2t);
        return;
      }
      const s = this._input.charCodeAt(e);
      if (t)
        t = !1;
      else if (s === 47 && !n) {
        e++;
        break;
      } else s === 91 ? n = !0 : s === 92 ? t = !0 : s === 93 && (n = !1);
      e++;
    }
    for (; e < this._input.length && yu._regexFlags.has(this._input.charCodeAt(e)); )
      e++;
    this._current = e;
    const i = this._input.substring(this._start, this._current);
    this._tokens.push({ type: 10, lexeme: i, offset: this._start });
  }
  _isAtEnd() {
    return this._current >= this._input.length;
  }
}
const Wr = /* @__PURE__ */ new Map();
Wr.set("false", !1);
Wr.set("true", !0);
Wr.set("isMac", zt);
Wr.set("isLinux", Cs);
Wr.set("isWindows", zs);
Wr.set("isWeb", Yg);
Wr.set("isMacNative", zt && !Yg);
Wr.set("isEdge", Out);
Wr.set("isFirefox", Tut);
Wr.set("isChrome", RMe);
Wr.set("isSafari", Iut);
const s2t = Object.prototype.hasOwnProperty, o2t = {
  regexParsingWithErrorRecovery: !0
}, a2t = C("contextkey.parser.error.emptyString", "Empty context key expression"), l2t = C("contextkey.parser.error.emptyString.hint", "Did you forget to write an expression? You can also put 'false' or 'true' to always evaluate to false or true, respectively."), c2t = C("contextkey.parser.error.noInAfterNot", "'in' after 'not'."), Jve = C("contextkey.parser.error.closingParenthesis", "closing parenthesis ')'"), h2t = C("contextkey.parser.error.unexpectedToken", "Unexpected token"), d2t = C("contextkey.parser.error.unexpectedToken.hint", "Did you forget to put && or || before the token?"), u2t = C("contextkey.parser.error.unexpectedEOF", "Unexpected end of expression"), f2t = C("contextkey.parser.error.unexpectedEOF.hint", "Did you forget to put a context key?");
let p2t = class uA {
  static {
    this._parseError = new Error();
  }
  constructor(e = o2t) {
    this._config = e, this._scanner = new yu(), this._tokens = [], this._current = 0, this._parsingErrors = [], this._flagsGYRe = /g|y/g;
  }
  /**
   * Parse a context key expression.
   *
   * @param input the expression to parse
   * @returns the parsed expression or `undefined` if there's an error - call `lexingErrors` and `parsingErrors` to see the errors
   */
  parse(e) {
    if (e === "") {
      this._parsingErrors.push({ message: a2t, offset: 0, lexeme: "", additionalInfo: l2t });
      return;
    }
    this._tokens = this._scanner.reset(e).scan(), this._current = 0, this._parsingErrors = [];
    try {
      const t = this._expr();
      if (!this._isAtEnd()) {
        const n = this._peek(), i = n.type === 17 ? d2t : void 0;
        throw this._parsingErrors.push({ message: h2t, offset: n.offset, lexeme: yu.getLexeme(n), additionalInfo: i }), uA._parseError;
      }
      return t;
    } catch (t) {
      if (t !== uA._parseError)
        throw t;
      return;
    }
  }
  _expr() {
    return this._or();
  }
  _or() {
    const e = [this._and()];
    for (; this._matchOne(
      16
      /* TokenType.Or */
    ); ) {
      const t = this._and();
      e.push(t);
    }
    return e.length === 1 ? e[0] : mt.or(...e);
  }
  _and() {
    const e = [this._term()];
    for (; this._matchOne(
      15
      /* TokenType.And */
    ); ) {
      const t = this._term();
      e.push(t);
    }
    return e.length === 1 ? e[0] : mt.and(...e);
  }
  _term() {
    if (this._matchOne(
      2
      /* TokenType.Neg */
    )) {
      const e = this._peek();
      switch (e.type) {
        case 11:
          return this._advance(), Es.INSTANCE;
        case 12:
          return this._advance(), Ws.INSTANCE;
        case 0: {
          this._advance();
          const t = this._expr();
          return this._consume(1, Jve), t?.negate();
        }
        case 17:
          return this._advance(), Gf.create(e.lexeme);
        default:
          throw this._errExpectedButGot("KEY | true | false | '(' expression ')'", e);
      }
    }
    return this._primary();
  }
  _primary() {
    const e = this._peek();
    switch (e.type) {
      case 11:
        return this._advance(), mt.true();
      case 12:
        return this._advance(), mt.false();
      case 0: {
        this._advance();
        const t = this._expr();
        return this._consume(1, Jve), t;
      }
      case 17: {
        const t = e.lexeme;
        if (this._advance(), this._matchOne(
          9
          /* TokenType.RegexOp */
        )) {
          const i = this._peek();
          if (!this._config.regexParsingWithErrorRecovery) {
            if (this._advance(), i.type !== 10)
              throw this._errExpectedButGot("REGEX", i);
            const s = i.lexeme, o = s.lastIndexOf("/"), a = o === s.length - 1 ? void 0 : this._removeFlagsGY(s.substring(o + 1));
            let l;
            try {
              l = new RegExp(s.substring(1, o), a);
            } catch {
              throw this._errExpectedButGot("REGEX", i);
            }
            return F3.create(t, l);
          }
          switch (i.type) {
            case 10:
            case 19: {
              const s = [i.lexeme];
              this._advance();
              let o = this._peek(), a = 0;
              for (let f = 0; f < i.lexeme.length; f++)
                i.lexeme.charCodeAt(f) === 40 ? a++ : i.lexeme.charCodeAt(f) === 41 && a--;
              for (; !this._isAtEnd() && o.type !== 15 && o.type !== 16; ) {
                switch (o.type) {
                  case 0:
                    a++;
                    break;
                  case 1:
                    a--;
                    break;
                  case 10:
                  case 18:
                    for (let f = 0; f < o.lexeme.length; f++)
                      o.lexeme.charCodeAt(f) === 40 ? a++ : i.lexeme.charCodeAt(f) === 41 && a--;
                }
                if (a < 0)
                  break;
                s.push(yu.getLexeme(o)), this._advance(), o = this._peek();
              }
              const l = s.join(""), c = l.lastIndexOf("/"), d = c === l.length - 1 ? void 0 : this._removeFlagsGY(l.substring(c + 1));
              let u;
              try {
                u = new RegExp(l.substring(1, c), d);
              } catch {
                throw this._errExpectedButGot("REGEX", i);
              }
              return mt.regex(t, u);
            }
            case 18: {
              const s = i.lexeme;
              this._advance();
              let o = null;
              if (!b0t(s)) {
                const a = s.indexOf("/"), l = s.lastIndexOf("/");
                if (a !== l && a >= 0) {
                  const c = s.slice(a + 1, l), d = s[l + 1] === "i" ? "i" : "";
                  try {
                    o = new RegExp(c, d);
                  } catch {
                    throw this._errExpectedButGot("REGEX", i);
                  }
                }
              }
              if (o === null)
                throw this._errExpectedButGot("REGEX", i);
              return F3.create(t, o);
            }
            default:
              throw this._errExpectedButGot("REGEX", this._peek());
          }
        }
        if (this._matchOne(
          14
          /* TokenType.Not */
        )) {
          this._consume(13, c2t);
          const i = this._value();
          return mt.notIn(t, i);
        }
        switch (this._peek().type) {
          case 3: {
            this._advance();
            const i = this._value();
            if (this._previous().type === 18)
              return mt.equals(t, i);
            switch (i) {
              case "true":
                return mt.has(t);
              case "false":
                return mt.not(t);
              default:
                return mt.equals(t, i);
            }
          }
          case 4: {
            this._advance();
            const i = this._value();
            if (this._previous().type === 18)
              return mt.notEquals(t, i);
            switch (i) {
              case "true":
                return mt.not(t);
              case "false":
                return mt.has(t);
              default:
                return mt.notEquals(t, i);
            }
          }
          // TODO: ContextKeyExpr.smaller(key, right) accepts only `number` as `right` AND during eval of this node, we just eval to `false` if `right` is not a number
          // consequently, package.json linter should _warn_ the user if they're passing undesired things to ops
          case 5:
            return this._advance(), K7.create(t, this._value());
          case 6:
            return this._advance(), Y7.create(t, this._value());
          case 7:
            return this._advance(), G7.create(t, this._value());
          case 8:
            return this._advance(), Q7.create(t, this._value());
          case 13:
            return this._advance(), mt.in(t, this._value());
          default:
            return mt.has(t);
        }
      }
      case 20:
        throw this._parsingErrors.push({ message: u2t, offset: e.offset, lexeme: "", additionalInfo: f2t }), uA._parseError;
      default:
        throw this._errExpectedButGot(`true | false | KEY 
	| KEY '=~' REGEX 
	| KEY ('==' | '!=' | '<' | '<=' | '>' | '>=' | 'in' | 'not' 'in') value`, this._peek());
    }
  }
  _value() {
    const e = this._peek();
    switch (e.type) {
      case 17:
      case 18:
        return this._advance(), e.lexeme;
      case 11:
        return this._advance(), "true";
      case 12:
        return this._advance(), "false";
      case 13:
        return this._advance(), "in";
      default:
        return "";
    }
  }
  _removeFlagsGY(e) {
    return e.replaceAll(this._flagsGYRe, "");
  }
  // careful: this can throw if current token is the initial one (ie index = 0)
  _previous() {
    return this._tokens[this._current - 1];
  }
  _matchOne(e) {
    return this._check(e) ? (this._advance(), !0) : !1;
  }
  _advance() {
    return this._isAtEnd() || this._current++, this._previous();
  }
  _consume(e, t) {
    if (this._check(e))
      return this._advance();
    throw this._errExpectedButGot(t, this._peek());
  }
  _errExpectedButGot(e, t, n) {
    const i = C("contextkey.parser.error.expectedButGot", `Expected: {0}
Received: '{1}'.`, e, yu.getLexeme(t)), s = t.offset, o = yu.getLexeme(t);
    return this._parsingErrors.push({ message: i, offset: s, lexeme: o, additionalInfo: n }), uA._parseError;
  }
  _check(e) {
    return this._peek().type === e;
  }
  _peek() {
    return this._tokens[this._current];
  }
  _isAtEnd() {
    return this._peek().type === 20;
  }
};
class mt {
  static false() {
    return Es.INSTANCE;
  }
  static true() {
    return Ws.INSTANCE;
  }
  static has(e) {
    return qf.create(e);
  }
  static equals(e, t) {
    return bw.create(e, t);
  }
  static notEquals(e, t) {
    return U7.create(e, t);
  }
  static regex(e, t) {
    return F3.create(e, t);
  }
  static in(e, t) {
    return j7.create(e, t);
  }
  static notIn(e, t) {
    return Z7.create(e, t);
  }
  static not(e) {
    return Gf.create(e);
  }
  static and(...e) {
    return T0.create(e, null, !0);
  }
  static or(...e) {
    return od.create(e, null, !0);
  }
  static {
    this._parser = new p2t({ regexParsingWithErrorRecovery: !1 });
  }
  static deserialize(e) {
    return e == null ? void 0 : this._parser.parse(e);
  }
}
function g2t(r, e) {
  const t = r ? r.substituteConstants() : void 0, n = e ? e.substituteConstants() : void 0;
  return !t && !n ? !0 : !t || !n ? !1 : t.equals(n);
}
function BA(r, e) {
  return r.cmp(e);
}
class Es {
  static {
    this.INSTANCE = new Es();
  }
  constructor() {
    this.type = 0;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !1;
  }
  serialize() {
    return "false";
  }
  keys() {
    return [];
  }
  negate() {
    return Ws.INSTANCE;
  }
}
class Ws {
  static {
    this.INSTANCE = new Ws();
  }
  constructor() {
    this.type = 1;
  }
  cmp(e) {
    return this.type - e.type;
  }
  equals(e) {
    return e.type === this.type;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !0;
  }
  serialize() {
    return "true";
  }
  keys() {
    return [];
  }
  negate() {
    return Es.INSTANCE;
  }
}
class qf {
  static create(e, t = null) {
    const n = Wr.get(e);
    return typeof n == "boolean" ? n ? Ws.INSTANCE : Es.INSTANCE : new qf(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 2;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : HDe(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key : !1;
  }
  substituteConstants() {
    const e = Wr.get(this.key);
    return typeof e == "boolean" ? e ? Ws.INSTANCE : Es.INSTANCE : this;
  }
  evaluate(e) {
    return !!e.getValue(this.key);
  }
  serialize() {
    return this.key;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = Gf.create(this.key, this)), this.negated;
  }
}
class bw {
  static create(e, t, n = null) {
    if (typeof t == "boolean")
      return t ? qf.create(e, n) : Gf.create(e, n);
    const i = Wr.get(e);
    return typeof i == "boolean" ? t === (i ? "true" : "false") ? Ws.INSTANCE : Es.INSTANCE : new bw(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 4;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    const e = Wr.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? Ws.INSTANCE : Es.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) == this.value;
  }
  serialize() {
    return `${this.key} == '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = U7.create(this.key, this.value, this)), this.negated;
  }
}
class j7 {
  static create(e, t) {
    return new j7(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 10, this.negated = null;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.valueKey, e.key, e.valueKey);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.valueKey === e.valueKey : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.valueKey), n = e.getValue(this.key);
    return Array.isArray(t) ? t.includes(n) : typeof n == "string" && typeof t == "object" && t !== null ? s2t.call(t, n) : !1;
  }
  serialize() {
    return `${this.key} in '${this.valueKey}'`;
  }
  keys() {
    return [this.key, this.valueKey];
  }
  negate() {
    return this.negated || (this.negated = Z7.create(this.key, this.valueKey)), this.negated;
  }
}
class Z7 {
  static create(e, t) {
    return new Z7(e, t);
  }
  constructor(e, t) {
    this.key = e, this.valueKey = t, this.type = 11, this._negated = j7.create(e, t);
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._negated.cmp(e._negated);
  }
  equals(e) {
    return e.type === this.type ? this._negated.equals(e._negated) : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._negated.evaluate(e);
  }
  serialize() {
    return `${this.key} not in '${this.valueKey}'`;
  }
  keys() {
    return this._negated.keys();
  }
  negate() {
    return this._negated;
  }
}
class U7 {
  static create(e, t, n = null) {
    if (typeof t == "boolean")
      return t ? Gf.create(e, n) : qf.create(e, n);
    const i = Wr.get(e);
    return typeof i == "boolean" ? t === (i ? "true" : "false") ? Es.INSTANCE : Ws.INSTANCE : new U7(e, t, n);
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 5;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    const e = Wr.get(this.key);
    if (typeof e == "boolean") {
      const t = e ? "true" : "false";
      return this.value === t ? Es.INSTANCE : Ws.INSTANCE;
    }
    return this;
  }
  evaluate(e) {
    return e.getValue(this.key) != this.value;
  }
  serialize() {
    return `${this.key} != '${this.value}'`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = bw.create(this.key, this.value, this)), this.negated;
  }
}
class Gf {
  static create(e, t = null) {
    const n = Wr.get(e);
    return typeof n == "boolean" ? n ? Es.INSTANCE : Ws.INSTANCE : new Gf(e, t);
  }
  constructor(e, t) {
    this.key = e, this.negated = t, this.type = 3;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : HDe(this.key, e.key);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key : !1;
  }
  substituteConstants() {
    const e = Wr.get(this.key);
    return typeof e == "boolean" ? e ? Es.INSTANCE : Ws.INSTANCE : this;
  }
  evaluate(e) {
    return !e.getValue(this.key);
  }
  serialize() {
    return `!${this.key}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = qf.create(this.key, this)), this.negated;
  }
}
function q7(r, e) {
  if (typeof r == "string") {
    const t = parseFloat(r);
    isNaN(t) || (r = t);
  }
  return typeof r == "string" || typeof r == "number" ? e(r) : Es.INSTANCE;
}
class G7 {
  static create(e, t, n = null) {
    return q7(t, (i) => new G7(e, i, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 12;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) > this.value;
  }
  serialize() {
    return `${this.key} > ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = Y7.create(this.key, this.value, this)), this.negated;
  }
}
class Q7 {
  static create(e, t, n = null) {
    return q7(t, (i) => new Q7(e, i, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 13;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) >= this.value;
  }
  serialize() {
    return `${this.key} >= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = K7.create(this.key, this.value, this)), this.negated;
  }
}
class K7 {
  static create(e, t, n = null) {
    return q7(t, (i) => new K7(e, i, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 14;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) < this.value;
  }
  serialize() {
    return `${this.key} < ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = Q7.create(this.key, this.value, this)), this.negated;
  }
}
class Y7 {
  static create(e, t, n = null) {
    return q7(t, (i) => new Y7(e, i, n));
  }
  constructor(e, t, n) {
    this.key = e, this.value = t, this.negated = n, this.type = 15;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : Qf(this.key, this.value, e.key, e.value);
  }
  equals(e) {
    return e.type === this.type ? this.key === e.key && this.value === e.value : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return typeof this.value == "string" ? !1 : parseFloat(e.getValue(this.key)) <= this.value;
  }
  serialize() {
    return `${this.key} <= ${this.value}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = G7.create(this.key, this.value, this)), this.negated;
  }
}
class F3 {
  static create(e, t) {
    return new F3(e, t);
  }
  constructor(e, t) {
    this.key = e, this.regexp = t, this.type = 7, this.negated = null;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.key < e.key)
      return -1;
    if (this.key > e.key)
      return 1;
    const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
    return t < n ? -1 : t > n ? 1 : 0;
  }
  equals(e) {
    if (e.type === this.type) {
      const t = this.regexp ? this.regexp.source : "", n = e.regexp ? e.regexp.source : "";
      return this.key === e.key && t === n;
    }
    return !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    const t = e.getValue(this.key);
    return this.regexp ? this.regexp.test(t) : !1;
  }
  serialize() {
    const e = this.regexp ? `/${this.regexp.source}/${this.regexp.flags}` : "/invalid/";
    return `${this.key} =~ ${e}`;
  }
  keys() {
    return [this.key];
  }
  negate() {
    return this.negated || (this.negated = JI.create(this)), this.negated;
  }
}
class JI {
  static create(e) {
    return new JI(e);
  }
  constructor(e) {
    this._actual = e, this.type = 8;
  }
  cmp(e) {
    return e.type !== this.type ? this.type - e.type : this._actual.cmp(e._actual);
  }
  equals(e) {
    return e.type === this.type ? this._actual.equals(e._actual) : !1;
  }
  substituteConstants() {
    return this;
  }
  evaluate(e) {
    return !this._actual.evaluate(e);
  }
  serialize() {
    return `!(${this._actual.serialize()})`;
  }
  keys() {
    return this._actual.keys();
  }
  negate() {
    return this._actual;
  }
}
function VDe(r) {
  let e = null;
  for (let t = 0, n = r.length; t < n; t++) {
    const i = r[t].substituteConstants();
    if (r[t] !== i && e === null) {
      e = [];
      for (let s = 0; s < t; s++)
        e[s] = r[s];
    }
    e !== null && (e[t] = i);
  }
  return e === null ? r : e;
}
class T0 {
  static create(e, t, n) {
    return T0._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 6;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.expr.length < e.expr.length)
      return -1;
    if (this.expr.length > e.expr.length)
      return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const i = BA(this.expr[t], e.expr[t]);
      if (i !== 0)
        return i;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length)
        return !1;
      for (let t = 0, n = this.expr.length; t < n; t++)
        if (!this.expr[t].equals(e.expr[t]))
          return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = VDe(this.expr);
    return e === this.expr ? this : T0.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++)
      if (!this.expr[t].evaluate(e))
        return !1;
    return !0;
  }
  static _normalizeArr(e, t, n) {
    const i = [];
    let s = !1;
    for (const o of e)
      if (o) {
        if (o.type === 1) {
          s = !0;
          continue;
        }
        if (o.type === 0)
          return Es.INSTANCE;
        if (o.type === 6) {
          i.push(...o.expr);
          continue;
        }
        i.push(o);
      }
    if (i.length === 0 && s)
      return Ws.INSTANCE;
    if (i.length !== 0) {
      if (i.length === 1)
        return i[0];
      i.sort(BA);
      for (let o = 1; o < i.length; o++)
        i[o - 1].equals(i[o]) && (i.splice(o, 1), o--);
      if (i.length === 1)
        return i[0];
      for (; i.length > 1; ) {
        const o = i[i.length - 1];
        if (o.type !== 9)
          break;
        i.pop();
        const a = i.pop(), l = i.length === 0, c = od.create(o.expr.map((d) => T0.create([d, a], null, n)), null, l);
        c && (i.push(c), i.sort(BA));
      }
      if (i.length === 1)
        return i[0];
      if (n) {
        for (let o = 0; o < i.length; o++)
          for (let a = o + 1; a < i.length; a++)
            if (i[o].negate().equals(i[a]))
              return Es.INSTANCE;
        if (i.length === 1)
          return i[0];
      }
      return new T0(i, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" && ");
  }
  keys() {
    const e = [];
    for (const t of this.expr)
      e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr)
        e.push(t.negate());
      this.negated = od.create(e, this, !0);
    }
    return this.negated;
  }
}
class od {
  static create(e, t, n) {
    return od._normalizeArr(e, t, n);
  }
  constructor(e, t) {
    this.expr = e, this.negated = t, this.type = 9;
  }
  cmp(e) {
    if (e.type !== this.type)
      return this.type - e.type;
    if (this.expr.length < e.expr.length)
      return -1;
    if (this.expr.length > e.expr.length)
      return 1;
    for (let t = 0, n = this.expr.length; t < n; t++) {
      const i = BA(this.expr[t], e.expr[t]);
      if (i !== 0)
        return i;
    }
    return 0;
  }
  equals(e) {
    if (e.type === this.type) {
      if (this.expr.length !== e.expr.length)
        return !1;
      for (let t = 0, n = this.expr.length; t < n; t++)
        if (!this.expr[t].equals(e.expr[t]))
          return !1;
      return !0;
    }
    return !1;
  }
  substituteConstants() {
    const e = VDe(this.expr);
    return e === this.expr ? this : od.create(e, this.negated, !1);
  }
  evaluate(e) {
    for (let t = 0, n = this.expr.length; t < n; t++)
      if (this.expr[t].evaluate(e))
        return !0;
    return !1;
  }
  static _normalizeArr(e, t, n) {
    let i = [], s = !1;
    if (e) {
      for (let o = 0, a = e.length; o < a; o++) {
        const l = e[o];
        if (l) {
          if (l.type === 0) {
            s = !0;
            continue;
          }
          if (l.type === 1)
            return Ws.INSTANCE;
          if (l.type === 9) {
            i = i.concat(l.expr);
            continue;
          }
          i.push(l);
        }
      }
      if (i.length === 0 && s)
        return Es.INSTANCE;
      i.sort(BA);
    }
    if (i.length !== 0) {
      if (i.length === 1)
        return i[0];
      for (let o = 1; o < i.length; o++)
        i[o - 1].equals(i[o]) && (i.splice(o, 1), o--);
      if (i.length === 1)
        return i[0];
      if (n) {
        for (let o = 0; o < i.length; o++)
          for (let a = o + 1; a < i.length; a++)
            if (i[o].negate().equals(i[a]))
              return Ws.INSTANCE;
        if (i.length === 1)
          return i[0];
      }
      return new od(i, t);
    }
  }
  serialize() {
    return this.expr.map((e) => e.serialize()).join(" || ");
  }
  keys() {
    const e = [];
    for (const t of this.expr)
      e.push(...t.keys());
    return e;
  }
  negate() {
    if (!this.negated) {
      const e = [];
      for (const t of this.expr)
        e.push(t.negate());
      for (; e.length > 1; ) {
        const t = e.shift(), n = e.shift(), i = [];
        for (const s of e5e(t))
          for (const o of e5e(n))
            i.push(T0.create([s, o], null, !1));
        e.unshift(od.create(i, null, !1));
      }
      this.negated = od.create(e, this, !0);
    }
    return this.negated;
  }
}
class Ve extends qf {
  static {
    this._info = [];
  }
  static all() {
    return Ve._info.values();
  }
  constructor(e, t, n) {
    super(e, null), this._defaultValue = t, typeof n == "object" ? Ve._info.push({ ...n, key: e }) : n !== !0 && Ve._info.push({ key: e, description: n, type: t != null ? typeof t : void 0 });
  }
  bindTo(e) {
    return e.createKey(this.key, this._defaultValue);
  }
  getValue(e) {
    return e.getContextKeyValue(this.key);
  }
  toNegated() {
    return this.negate();
  }
  isEqualTo(e) {
    return bw.create(this.key, e);
  }
}
const sn = Wt("contextKeyService");
function HDe(r, e) {
  return r < e ? -1 : r > e ? 1 : 0;
}
function Qf(r, e, t, n) {
  return r < t ? -1 : r > t ? 1 : e < n ? -1 : e > n ? 1 : 0;
}
function ZD(r, e) {
  if (r.type === 0 || e.type === 1)
    return !0;
  if (r.type === 9)
    return e.type === 9 ? $ve(r.expr, e.expr) : !1;
  if (e.type === 9) {
    for (const t of e.expr)
      if (ZD(r, t))
        return !0;
    return !1;
  }
  if (r.type === 6) {
    if (e.type === 6)
      return $ve(e.expr, r.expr);
    for (const t of r.expr)
      if (ZD(t, e))
        return !0;
    return !1;
  }
  return r.equals(e);
}
function $ve(r, e) {
  let t = 0, n = 0;
  for (; t < r.length && n < e.length; ) {
    const i = r[t].cmp(e[n]);
    if (i < 0)
      return !1;
    i === 0 && t++, n++;
  }
  return t === r.length;
}
function e5e(r) {
  return r.type === 9 ? r.expr : [r];
}
function NE(r, e) {
  if (!r)
    throw new Error(e ? `Assertion failed (${e})` : "Assertion Failed");
}
function $I(r, e = "Unreachable") {
  throw new Error(e);
}
function t5e(r) {
  r || wn(new cn("Soft Assertion Failed"));
}
function vf(r) {
  if (!r()) {
    debugger;
    r(), wn(new cn("Assertion Failed"));
  }
}
function eO(r, e) {
  let t = 0;
  for (; t < r.length - 1; ) {
    const n = r[t], i = r[t + 1];
    if (!e(n, i))
      return !1;
    t++;
  }
  return !0;
}
class m2t {
  constructor() {
    this.data = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    NE(Vo(e)), NE(Rs(t)), NE(!this.data.has(e), "There is already an extension with this id"), this.data.set(e, t);
  }
  as(e) {
    return this.data.get(e) || null;
  }
}
const Er = new m2t();
class tO {
  constructor() {
    this._coreKeybindings = new no(), this._extensionKeybindings = [], this._cachedMergedKeybindings = null;
  }
  /**
   * Take current platform into account and reduce to primary & secondary.
   */
  static bindToCurrentPlatform(e) {
    if (nl === 1) {
      if (e && e.win)
        return e.win;
    } else if (nl === 2) {
      if (e && e.mac)
        return e.mac;
    } else if (e && e.linux)
      return e.linux;
    return e;
  }
  registerKeybindingRule(e) {
    const t = tO.bindToCurrentPlatform(e), n = new ze();
    if (t && t.primary) {
      const i = TD(t.primary, nl);
      i && n.add(this._registerDefaultKeybinding(i, e.id, e.args, e.weight, 0, e.when));
    }
    if (t && Array.isArray(t.secondary))
      for (let i = 0, s = t.secondary.length; i < s; i++) {
        const o = t.secondary[i], a = TD(o, nl);
        a && n.add(this._registerDefaultKeybinding(a, e.id, e.args, e.weight, -i - 1, e.when));
      }
    return n;
  }
  registerCommandAndKeybindingRule(e) {
    return ih(this.registerKeybindingRule(e), Zs.registerCommand(e));
  }
  _registerDefaultKeybinding(e, t, n, i, s, o) {
    const a = this._coreKeybindings.push({
      keybinding: e,
      command: t,
      commandArgs: n,
      when: o,
      weight1: i,
      weight2: s,
      extensionId: null,
      isBuiltinExtension: !1
    });
    return this._cachedMergedKeybindings = null, ht(() => {
      a(), this._cachedMergedKeybindings = null;
    });
  }
  getDefaultKeybindings() {
    return this._cachedMergedKeybindings || (this._cachedMergedKeybindings = Array.from(this._coreKeybindings).concat(this._extensionKeybindings), this._cachedMergedKeybindings.sort(w2t)), this._cachedMergedKeybindings.slice(0);
  }
}
const Kf = new tO(), A2t = {
  EditorModes: "platform.keybindingsRegistry"
};
Er.add(A2t.EditorModes, Kf);
function w2t(r, e) {
  if (r.weight1 !== e.weight1)
    return r.weight1 - e.weight1;
  if (r.command && e.command) {
    if (r.command < e.command)
      return -1;
    if (r.command > e.command)
      return 1;
  }
  return r.weight2 - e.weight2;
}
var v2t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, n5e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, m6;
function PA(r) {
  return r.command !== void 0;
}
function b2t(r) {
  return r.submenu !== void 0;
}
class oe {
  static {
    this._instances = /* @__PURE__ */ new Map();
  }
  static {
    this.CommandPalette = new oe("CommandPalette");
  }
  static {
    this.DebugBreakpointsContext = new oe("DebugBreakpointsContext");
  }
  static {
    this.DebugCallStackContext = new oe("DebugCallStackContext");
  }
  static {
    this.DebugConsoleContext = new oe("DebugConsoleContext");
  }
  static {
    this.DebugVariablesContext = new oe("DebugVariablesContext");
  }
  static {
    this.NotebookVariablesContext = new oe("NotebookVariablesContext");
  }
  static {
    this.DebugHoverContext = new oe("DebugHoverContext");
  }
  static {
    this.DebugWatchContext = new oe("DebugWatchContext");
  }
  static {
    this.DebugToolBar = new oe("DebugToolBar");
  }
  static {
    this.DebugToolBarStop = new oe("DebugToolBarStop");
  }
  static {
    this.DebugCallStackToolbar = new oe("DebugCallStackToolbar");
  }
  static {
    this.EditorContext = new oe("EditorContext");
  }
  static {
    this.SimpleEditorContext = new oe("SimpleEditorContext");
  }
  static {
    this.EditorContent = new oe("EditorContent");
  }
  static {
    this.EditorLineNumberContext = new oe("EditorLineNumberContext");
  }
  static {
    this.EditorContextCopy = new oe("EditorContextCopy");
  }
  static {
    this.EditorContextPeek = new oe("EditorContextPeek");
  }
  static {
    this.EditorContextShare = new oe("EditorContextShare");
  }
  static {
    this.EditorTitle = new oe("EditorTitle");
  }
  static {
    this.EditorTitleRun = new oe("EditorTitleRun");
  }
  static {
    this.EditorTitleContext = new oe("EditorTitleContext");
  }
  static {
    this.EditorTitleContextShare = new oe("EditorTitleContextShare");
  }
  static {
    this.EmptyEditorGroup = new oe("EmptyEditorGroup");
  }
  static {
    this.EmptyEditorGroupContext = new oe("EmptyEditorGroupContext");
  }
  static {
    this.EditorTabsBarContext = new oe("EditorTabsBarContext");
  }
  static {
    this.EditorTabsBarShowTabsSubmenu = new oe("EditorTabsBarShowTabsSubmenu");
  }
  static {
    this.EditorTabsBarShowTabsZenModeSubmenu = new oe("EditorTabsBarShowTabsZenModeSubmenu");
  }
  static {
    this.EditorActionsPositionSubmenu = new oe("EditorActionsPositionSubmenu");
  }
  static {
    this.ExplorerContext = new oe("ExplorerContext");
  }
  static {
    this.ExplorerContextShare = new oe("ExplorerContextShare");
  }
  static {
    this.ExtensionContext = new oe("ExtensionContext");
  }
  static {
    this.GlobalActivity = new oe("GlobalActivity");
  }
  static {
    this.CommandCenter = new oe("CommandCenter");
  }
  static {
    this.CommandCenterCenter = new oe("CommandCenterCenter");
  }
  static {
    this.LayoutControlMenuSubmenu = new oe("LayoutControlMenuSubmenu");
  }
  static {
    this.LayoutControlMenu = new oe("LayoutControlMenu");
  }
  static {
    this.MenubarMainMenu = new oe("MenubarMainMenu");
  }
  static {
    this.MenubarAppearanceMenu = new oe("MenubarAppearanceMenu");
  }
  static {
    this.MenubarDebugMenu = new oe("MenubarDebugMenu");
  }
  static {
    this.MenubarEditMenu = new oe("MenubarEditMenu");
  }
  static {
    this.MenubarCopy = new oe("MenubarCopy");
  }
  static {
    this.MenubarFileMenu = new oe("MenubarFileMenu");
  }
  static {
    this.MenubarGoMenu = new oe("MenubarGoMenu");
  }
  static {
    this.MenubarHelpMenu = new oe("MenubarHelpMenu");
  }
  static {
    this.MenubarLayoutMenu = new oe("MenubarLayoutMenu");
  }
  static {
    this.MenubarNewBreakpointMenu = new oe("MenubarNewBreakpointMenu");
  }
  static {
    this.PanelAlignmentMenu = new oe("PanelAlignmentMenu");
  }
  static {
    this.PanelPositionMenu = new oe("PanelPositionMenu");
  }
  static {
    this.ActivityBarPositionMenu = new oe("ActivityBarPositionMenu");
  }
  static {
    this.MenubarPreferencesMenu = new oe("MenubarPreferencesMenu");
  }
  static {
    this.MenubarRecentMenu = new oe("MenubarRecentMenu");
  }
  static {
    this.MenubarSelectionMenu = new oe("MenubarSelectionMenu");
  }
  static {
    this.MenubarShare = new oe("MenubarShare");
  }
  static {
    this.MenubarSwitchEditorMenu = new oe("MenubarSwitchEditorMenu");
  }
  static {
    this.MenubarSwitchGroupMenu = new oe("MenubarSwitchGroupMenu");
  }
  static {
    this.MenubarTerminalMenu = new oe("MenubarTerminalMenu");
  }
  static {
    this.MenubarViewMenu = new oe("MenubarViewMenu");
  }
  static {
    this.MenubarHomeMenu = new oe("MenubarHomeMenu");
  }
  static {
    this.OpenEditorsContext = new oe("OpenEditorsContext");
  }
  static {
    this.OpenEditorsContextShare = new oe("OpenEditorsContextShare");
  }
  static {
    this.ProblemsPanelContext = new oe("ProblemsPanelContext");
  }
  static {
    this.SCMInputBox = new oe("SCMInputBox");
  }
  static {
    this.SCMChangesSeparator = new oe("SCMChangesSeparator");
  }
  static {
    this.SCMChangesContext = new oe("SCMChangesContext");
  }
  static {
    this.SCMIncomingChanges = new oe("SCMIncomingChanges");
  }
  static {
    this.SCMIncomingChangesContext = new oe("SCMIncomingChangesContext");
  }
  static {
    this.SCMIncomingChangesSetting = new oe("SCMIncomingChangesSetting");
  }
  static {
    this.SCMOutgoingChanges = new oe("SCMOutgoingChanges");
  }
  static {
    this.SCMOutgoingChangesContext = new oe("SCMOutgoingChangesContext");
  }
  static {
    this.SCMOutgoingChangesSetting = new oe("SCMOutgoingChangesSetting");
  }
  static {
    this.SCMIncomingChangesAllChangesContext = new oe("SCMIncomingChangesAllChangesContext");
  }
  static {
    this.SCMIncomingChangesHistoryItemContext = new oe("SCMIncomingChangesHistoryItemContext");
  }
  static {
    this.SCMOutgoingChangesAllChangesContext = new oe("SCMOutgoingChangesAllChangesContext");
  }
  static {
    this.SCMOutgoingChangesHistoryItemContext = new oe("SCMOutgoingChangesHistoryItemContext");
  }
  static {
    this.SCMChangeContext = new oe("SCMChangeContext");
  }
  static {
    this.SCMResourceContext = new oe("SCMResourceContext");
  }
  static {
    this.SCMResourceContextShare = new oe("SCMResourceContextShare");
  }
  static {
    this.SCMResourceFolderContext = new oe("SCMResourceFolderContext");
  }
  static {
    this.SCMResourceGroupContext = new oe("SCMResourceGroupContext");
  }
  static {
    this.SCMSourceControl = new oe("SCMSourceControl");
  }
  static {
    this.SCMSourceControlInline = new oe("SCMSourceControlInline");
  }
  static {
    this.SCMSourceControlTitle = new oe("SCMSourceControlTitle");
  }
  static {
    this.SCMTitle = new oe("SCMTitle");
  }
  static {
    this.SearchContext = new oe("SearchContext");
  }
  static {
    this.SearchActionMenu = new oe("SearchActionContext");
  }
  static {
    this.StatusBarWindowIndicatorMenu = new oe("StatusBarWindowIndicatorMenu");
  }
  static {
    this.StatusBarRemoteIndicatorMenu = new oe("StatusBarRemoteIndicatorMenu");
  }
  static {
    this.StickyScrollContext = new oe("StickyScrollContext");
  }
  static {
    this.TestItem = new oe("TestItem");
  }
  static {
    this.TestItemGutter = new oe("TestItemGutter");
  }
  static {
    this.TestProfilesContext = new oe("TestProfilesContext");
  }
  static {
    this.TestMessageContext = new oe("TestMessageContext");
  }
  static {
    this.TestMessageContent = new oe("TestMessageContent");
  }
  static {
    this.TestPeekElement = new oe("TestPeekElement");
  }
  static {
    this.TestPeekTitle = new oe("TestPeekTitle");
  }
  static {
    this.TestCallStack = new oe("TestCallStack");
  }
  static {
    this.TouchBarContext = new oe("TouchBarContext");
  }
  static {
    this.TitleBarContext = new oe("TitleBarContext");
  }
  static {
    this.TitleBarTitleContext = new oe("TitleBarTitleContext");
  }
  static {
    this.TunnelContext = new oe("TunnelContext");
  }
  static {
    this.TunnelPrivacy = new oe("TunnelPrivacy");
  }
  static {
    this.TunnelProtocol = new oe("TunnelProtocol");
  }
  static {
    this.TunnelPortInline = new oe("TunnelInline");
  }
  static {
    this.TunnelTitle = new oe("TunnelTitle");
  }
  static {
    this.TunnelLocalAddressInline = new oe("TunnelLocalAddressInline");
  }
  static {
    this.TunnelOriginInline = new oe("TunnelOriginInline");
  }
  static {
    this.ViewItemContext = new oe("ViewItemContext");
  }
  static {
    this.ViewContainerTitle = new oe("ViewContainerTitle");
  }
  static {
    this.ViewContainerTitleContext = new oe("ViewContainerTitleContext");
  }
  static {
    this.ViewTitle = new oe("ViewTitle");
  }
  static {
    this.ViewTitleContext = new oe("ViewTitleContext");
  }
  static {
    this.CommentEditorActions = new oe("CommentEditorActions");
  }
  static {
    this.CommentThreadTitle = new oe("CommentThreadTitle");
  }
  static {
    this.CommentThreadActions = new oe("CommentThreadActions");
  }
  static {
    this.CommentThreadAdditionalActions = new oe("CommentThreadAdditionalActions");
  }
  static {
    this.CommentThreadTitleContext = new oe("CommentThreadTitleContext");
  }
  static {
    this.CommentThreadCommentContext = new oe("CommentThreadCommentContext");
  }
  static {
    this.CommentTitle = new oe("CommentTitle");
  }
  static {
    this.CommentActions = new oe("CommentActions");
  }
  static {
    this.CommentsViewThreadActions = new oe("CommentsViewThreadActions");
  }
  static {
    this.InteractiveToolbar = new oe("InteractiveToolbar");
  }
  static {
    this.InteractiveCellTitle = new oe("InteractiveCellTitle");
  }
  static {
    this.InteractiveCellDelete = new oe("InteractiveCellDelete");
  }
  static {
    this.InteractiveCellExecute = new oe("InteractiveCellExecute");
  }
  static {
    this.InteractiveInputExecute = new oe("InteractiveInputExecute");
  }
  static {
    this.InteractiveInputConfig = new oe("InteractiveInputConfig");
  }
  static {
    this.ReplInputExecute = new oe("ReplInputExecute");
  }
  static {
    this.IssueReporter = new oe("IssueReporter");
  }
  static {
    this.NotebookToolbar = new oe("NotebookToolbar");
  }
  static {
    this.NotebookStickyScrollContext = new oe("NotebookStickyScrollContext");
  }
  static {
    this.NotebookCellTitle = new oe("NotebookCellTitle");
  }
  static {
    this.NotebookCellDelete = new oe("NotebookCellDelete");
  }
  static {
    this.NotebookCellInsert = new oe("NotebookCellInsert");
  }
  static {
    this.NotebookCellBetween = new oe("NotebookCellBetween");
  }
  static {
    this.NotebookCellListTop = new oe("NotebookCellTop");
  }
  static {
    this.NotebookCellExecute = new oe("NotebookCellExecute");
  }
  static {
    this.NotebookCellExecuteGoTo = new oe("NotebookCellExecuteGoTo");
  }
  static {
    this.NotebookCellExecutePrimary = new oe("NotebookCellExecutePrimary");
  }
  static {
    this.NotebookDiffCellInputTitle = new oe("NotebookDiffCellInputTitle");
  }
  static {
    this.NotebookDiffCellMetadataTitle = new oe("NotebookDiffCellMetadataTitle");
  }
  static {
    this.NotebookDiffCellOutputsTitle = new oe("NotebookDiffCellOutputsTitle");
  }
  static {
    this.NotebookOutputToolbar = new oe("NotebookOutputToolbar");
  }
  static {
    this.NotebookOutlineFilter = new oe("NotebookOutlineFilter");
  }
  static {
    this.NotebookOutlineActionMenu = new oe("NotebookOutlineActionMenu");
  }
  static {
    this.NotebookEditorLayoutConfigure = new oe("NotebookEditorLayoutConfigure");
  }
  static {
    this.NotebookKernelSource = new oe("NotebookKernelSource");
  }
  static {
    this.BulkEditTitle = new oe("BulkEditTitle");
  }
  static {
    this.BulkEditContext = new oe("BulkEditContext");
  }
  static {
    this.TimelineItemContext = new oe("TimelineItemContext");
  }
  static {
    this.TimelineTitle = new oe("TimelineTitle");
  }
  static {
    this.TimelineTitleContext = new oe("TimelineTitleContext");
  }
  static {
    this.TimelineFilterSubMenu = new oe("TimelineFilterSubMenu");
  }
  static {
    this.AccountsContext = new oe("AccountsContext");
  }
  static {
    this.SidebarTitle = new oe("SidebarTitle");
  }
  static {
    this.PanelTitle = new oe("PanelTitle");
  }
  static {
    this.AuxiliaryBarTitle = new oe("AuxiliaryBarTitle");
  }
  static {
    this.AuxiliaryBarHeader = new oe("AuxiliaryBarHeader");
  }
  static {
    this.TerminalInstanceContext = new oe("TerminalInstanceContext");
  }
  static {
    this.TerminalEditorInstanceContext = new oe("TerminalEditorInstanceContext");
  }
  static {
    this.TerminalNewDropdownContext = new oe("TerminalNewDropdownContext");
  }
  static {
    this.TerminalTabContext = new oe("TerminalTabContext");
  }
  static {
    this.TerminalTabEmptyAreaContext = new oe("TerminalTabEmptyAreaContext");
  }
  static {
    this.TerminalStickyScrollContext = new oe("TerminalStickyScrollContext");
  }
  static {
    this.WebviewContext = new oe("WebviewContext");
  }
  static {
    this.InlineCompletionsActions = new oe("InlineCompletionsActions");
  }
  static {
    this.InlineEditsActions = new oe("InlineEditsActions");
  }
  static {
    this.InlineEditActions = new oe("InlineEditActions");
  }
  static {
    this.NewFile = new oe("NewFile");
  }
  static {
    this.MergeInput1Toolbar = new oe("MergeToolbar1Toolbar");
  }
  static {
    this.MergeInput2Toolbar = new oe("MergeToolbar2Toolbar");
  }
  static {
    this.MergeBaseToolbar = new oe("MergeBaseToolbar");
  }
  static {
    this.MergeInputResultToolbar = new oe("MergeToolbarResultToolbar");
  }
  static {
    this.InlineSuggestionToolbar = new oe("InlineSuggestionToolbar");
  }
  static {
    this.InlineEditToolbar = new oe("InlineEditToolbar");
  }
  static {
    this.ChatContext = new oe("ChatContext");
  }
  static {
    this.ChatCodeBlock = new oe("ChatCodeblock");
  }
  static {
    this.ChatCompareBlock = new oe("ChatCompareBlock");
  }
  static {
    this.ChatMessageTitle = new oe("ChatMessageTitle");
  }
  static {
    this.ChatExecute = new oe("ChatExecute");
  }
  static {
    this.ChatExecuteSecondary = new oe("ChatExecuteSecondary");
  }
  static {
    this.ChatInputSide = new oe("ChatInputSide");
  }
  static {
    this.AccessibleView = new oe("AccessibleView");
  }
  static {
    this.MultiDiffEditorFileToolbar = new oe("MultiDiffEditorFileToolbar");
  }
  static {
    this.DiffEditorHunkToolbar = new oe("DiffEditorHunkToolbar");
  }
  static {
    this.DiffEditorSelectionToolbar = new oe("DiffEditorSelectionToolbar");
  }
  /**
   * Create a new `MenuId` with the unique identifier. Will throw if a menu
   * with the identifier already exists, use `MenuId.for(ident)` or a unique
   * identifier
   */
  constructor(e) {
    if (oe._instances.has(e))
      throw new TypeError(`MenuId with identifier '${e}' already exists. Use MenuId.for(ident) or a unique identifier`);
    oe._instances.set(e, this), this.id = e;
  }
}
const Yf = Wt("menuService");
class Cu {
  static {
    this._all = /* @__PURE__ */ new Map();
  }
  static for(e) {
    let t = this._all.get(e);
    return t || (t = new Cu(e), this._all.set(e, t)), t;
  }
  static merge(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e)
      n instanceof Cu && t.add(n.id);
    return t;
  }
  constructor(e) {
    this.id = e, this.has = (t) => t === e;
  }
}
const og = new class {
  constructor() {
    this._commands = /* @__PURE__ */ new Map(), this._menuItems = /* @__PURE__ */ new Map(), this._onDidChangeMenu = new P1t({
      merge: Cu.merge
    }), this.onDidChangeMenu = this._onDidChangeMenu.event;
  }
  addCommand(r) {
    return this._commands.set(r.id, r), this._onDidChangeMenu.fire(Cu.for(oe.CommandPalette)), ht(() => {
      this._commands.delete(r.id) && this._onDidChangeMenu.fire(Cu.for(oe.CommandPalette));
    });
  }
  getCommand(r) {
    return this._commands.get(r);
  }
  getCommands() {
    const r = /* @__PURE__ */ new Map();
    return this._commands.forEach((e, t) => r.set(t, e)), r;
  }
  appendMenuItem(r, e) {
    let t = this._menuItems.get(r);
    t || (t = new no(), this._menuItems.set(r, t));
    const n = t.push(e);
    return this._onDidChangeMenu.fire(Cu.for(r)), ht(() => {
      n(), this._onDidChangeMenu.fire(Cu.for(r));
    });
  }
  appendMenuItems(r) {
    const e = new ze();
    for (const { id: t, item: n } of r)
      e.add(this.appendMenuItem(t, n));
    return e;
  }
  getMenuItems(r) {
    let e;
    return this._menuItems.has(r) ? e = [...this._menuItems.get(r)] : e = [], r === oe.CommandPalette && this._appendImplicitItems(e), e;
  }
  _appendImplicitItems(r) {
    const e = /* @__PURE__ */ new Set();
    for (const t of r)
      PA(t) && (e.add(t.command.id), t.alt && e.add(t.alt.id));
    this._commands.forEach((t, n) => {
      e.has(n) || r.push({ command: t });
    });
  }
}();
class FA extends W7 {
  constructor(e, t, n) {
    super(`submenuitem.${e.submenu.id}`, typeof e.title == "string" ? e.title : e.title.value, n, "submenu"), this.item = e, this.hideActions = t;
  }
}
let _d = m6 = class {
  static label(e, t) {
    return t?.renderShortTitle && e.shortTitle ? typeof e.shortTitle == "string" ? e.shortTitle : e.shortTitle.value : typeof e.title == "string" ? e.title : e.title.value;
  }
  constructor(e, t, n, i, s, o, a) {
    this.hideActions = i, this.menuKeybinding = s, this._commandService = a, this.id = e.id, this.label = m6.label(e, n), this.tooltip = (typeof e.tooltip == "string" ? e.tooltip : e.tooltip?.value) ?? "", this.enabled = !e.precondition || o.contextMatchesRules(e.precondition), this.checked = void 0;
    let l;
    if (e.toggled) {
      const c = e.toggled.condition ? e.toggled : { condition: e.toggled };
      this.checked = o.contextMatchesRules(c.condition), this.checked && c.tooltip && (this.tooltip = typeof c.tooltip == "string" ? c.tooltip : c.tooltip.value), this.checked && Tt.isThemeIcon(c.icon) && (l = c.icon), this.checked && c.title && (this.label = typeof c.title == "string" ? c.title : c.title.value);
    }
    l || (l = Tt.isThemeIcon(e.icon) ? e.icon : void 0), this.item = e, this.alt = t ? new m6(t, void 0, n, i, void 0, o, a) : void 0, this._options = n, this.class = l && Tt.asClassName(l);
  }
  run(...e) {
    let t = [];
    return this._options?.arg && (t = [...t, this._options.arg]), this._options?.shouldForwardArgs && (t = [...t, ...e]), this._commandService.executeCommand(this.id, ...t);
  }
};
_d = m6 = v2t([
  n5e(5, sn),
  n5e(6, jo)
], _d);
const I1 = Wt("telemetryService"), _h = Wt("logService");
var Is;
(function(r) {
  r[r.Off = 0] = "Off", r[r.Trace = 1] = "Trace", r[r.Debug = 2] = "Debug", r[r.Info = 3] = "Info", r[r.Warning = 4] = "Warning", r[r.Error = 5] = "Error";
})(Is || (Is = {}));
const BDe = Is.Info;
class PDe extends me {
  constructor() {
    super(...arguments), this.level = BDe, this._onDidChangeLogLevel = this._register(new $()), this.onDidChangeLogLevel = this._onDidChangeLogLevel.event;
  }
  setLevel(e) {
    this.level !== e && (this.level = e, this._onDidChangeLogLevel.fire(this.level));
  }
  getLevel() {
    return this.level;
  }
  checkLogLevel(e) {
    return this.level !== Is.Off && this.level <= e;
  }
}
class y2t extends PDe {
  constructor(e = BDe, t = !0) {
    super(), this.useColors = t, this.setLevel(e);
  }
  trace(e, ...t) {
    this.checkLogLevel(Is.Trace) && (this.useColors ? console.log("%cTRACE", "color: #888", e, ...t) : console.log(e, ...t));
  }
  debug(e, ...t) {
    this.checkLogLevel(Is.Debug) && (this.useColors ? console.log("%cDEBUG", "background: #eee; color: #888", e, ...t) : console.log(e, ...t));
  }
  info(e, ...t) {
    this.checkLogLevel(Is.Info) && (this.useColors ? console.log("%c INFO", "color: #33f", e, ...t) : console.log(e, ...t));
  }
  warn(e, ...t) {
    this.checkLogLevel(Is.Warning) && (this.useColors ? console.log("%c WARN", "color: #993", e, ...t) : console.log(e, ...t));
  }
  error(e, ...t) {
    this.checkLogLevel(Is.Error) && (this.useColors ? console.log("%c  ERR", "color: #f33", e, ...t) : console.error(e, ...t));
  }
}
class C2t extends PDe {
  constructor(e) {
    super(), this.loggers = e, e.length && this.setLevel(e[0].getLevel());
  }
  setLevel(e) {
    for (const t of this.loggers)
      t.setLevel(e);
    super.setLevel(e);
  }
  trace(e, ...t) {
    for (const n of this.loggers)
      n.trace(e, ...t);
  }
  debug(e, ...t) {
    for (const n of this.loggers)
      n.debug(e, ...t);
  }
  info(e, ...t) {
    for (const n of this.loggers)
      n.info(e, ...t);
  }
  warn(e, ...t) {
    for (const n of this.loggers)
      n.warn(e, ...t);
  }
  error(e, ...t) {
    for (const n of this.loggers)
      n.error(e, ...t);
  }
  dispose() {
    for (const e of this.loggers)
      e.dispose();
    super.dispose();
  }
}
function E2t(r) {
  switch (r) {
    case Is.Trace:
      return "trace";
    case Is.Debug:
      return "debug";
    case Is.Info:
      return "info";
    case Is.Warning:
      return "warn";
    case Is.Error:
      return "error";
    case Is.Off:
      return "off";
  }
}
new Ve("logLevel", E2t(Is.Info));
class X7 {
  constructor(e) {
    this.id = e.id, this.precondition = e.precondition, this._kbOpts = e.kbOpts, this._menuOpts = e.menuOpts, this.metadata = e.metadata;
  }
  register() {
    if (Array.isArray(this._menuOpts) ? this._menuOpts.forEach(this._registerMenuItem, this) : this._menuOpts && this._registerMenuItem(this._menuOpts), this._kbOpts) {
      const e = Array.isArray(this._kbOpts) ? this._kbOpts : [this._kbOpts];
      for (const t of e) {
        let n = t.kbExpr;
        this.precondition && (n ? n = mt.and(n, this.precondition) : n = this.precondition);
        const i = {
          id: this.id,
          weight: t.weight,
          args: t.args,
          when: n,
          primary: t.primary,
          secondary: t.secondary,
          win: t.win,
          linux: t.linux,
          mac: t.mac
        };
        Kf.registerKeybindingRule(i);
      }
    }
    Zs.registerCommand({
      id: this.id,
      handler: (e, t) => this.runCommand(e, t),
      metadata: this.metadata
    });
  }
  _registerMenuItem(e) {
    og.appendMenuItem(e.menuId, {
      group: e.group,
      command: {
        id: this.id,
        title: e.title,
        icon: e.icon,
        precondition: this.precondition
      },
      when: e.when,
      order: e.order
    });
  }
}
class nO extends X7 {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  /**
   * A higher priority gets to be looked at first
   */
  addImplementation(e, t, n, i) {
    return this._implementations.push({ priority: e, name: t, implementation: n, when: i }), this._implementations.sort((s, o) => o.priority - s.priority), {
      dispose: () => {
        for (let s = 0; s < this._implementations.length; s++)
          if (this._implementations[s].implementation === n) {
            this._implementations.splice(s, 1);
            return;
          }
      }
    };
  }
  runCommand(e, t) {
    const n = e.get(_h), i = e.get(sn);
    n.trace(`Executing Command '${this.id}' which has ${this._implementations.length} bound.`);
    for (const s of this._implementations) {
      if (s.when) {
        const a = i.getContext(ss());
        if (!s.when.evaluate(a))
          continue;
      }
      const o = s.implementation(e, t);
      if (o)
        return n.trace(`Command '${this.id}' was handled by '${s.name}'.`), typeof o == "boolean" ? void 0 : o;
    }
    n.trace(`The Command '${this.id}' was not handled by any implementation.`);
  }
}
class FDe extends X7 {
  constructor(e, t) {
    super(t), this.command = e;
  }
  runCommand(e, t) {
    return this.command.runCommand(e, t);
  }
}
class Fd extends X7 {
  /**
   * Create a command class that is bound to a certain editor contribution.
   */
  static bindToContribution(e) {
    return class extends Fd {
      constructor(n) {
        super(n), this._callback = n.handler;
      }
      runEditorCommand(n, i, s) {
        const o = e(i);
        o && this._callback(o, s);
      }
    };
  }
  static runEditorCommand(e, t, n, i) {
    const s = e.get(Ui), o = s.getFocusedCodeEditor() || s.getActiveCodeEditor();
    if (o)
      return o.invokeWithinContext((a) => {
        if (a.get(sn).contextMatchesRules(n ?? void 0))
          return i(a, o, t);
      });
  }
  runCommand(e, t) {
    return Fd.runEditorCommand(e, t, this.precondition, (n, i, s) => this.runEditorCommand(n, i, s));
  }
}
class O1 extends Fd {
  static convertOptions(e) {
    let t;
    Array.isArray(e.menuOpts) ? t = e.menuOpts : e.menuOpts ? t = [e.menuOpts] : t = [];
    function n(i) {
      return i.menuId || (i.menuId = oe.EditorContext), i.title || (i.title = e.label), i.when = mt.and(e.precondition, i.when), i;
    }
    return Array.isArray(e.contextMenuOpts) ? t.push(...e.contextMenuOpts.map(n)) : e.contextMenuOpts && t.push(n(e.contextMenuOpts)), e.menuOpts = t, e;
  }
  constructor(e) {
    super(O1.convertOptions(e)), this.label = e.label, this.alias = e.alias;
  }
  runEditorCommand(e, t, n) {
    return this.reportTelemetry(e, t), this.run(e, t, n || {});
  }
  reportTelemetry(e, t) {
    e.get(I1).publicLog2("editorActionInvoked", { name: this.label, id: this.id });
  }
}
class zDe extends O1 {
  constructor() {
    super(...arguments), this._implementations = [];
  }
  /**
   * A higher priority gets to be looked at first
   */
  addImplementation(e, t) {
    return this._implementations.push([e, t]), this._implementations.sort((n, i) => i[0] - n[0]), {
      dispose: () => {
        for (let n = 0; n < this._implementations.length; n++)
          if (this._implementations[n][1] === t) {
            this._implementations.splice(n, 1);
            return;
          }
      }
    };
  }
  run(e, t, n) {
    for (const i of this._implementations) {
      const s = i[1](e, t, n);
      if (s)
        return typeof s == "boolean" ? void 0 : s;
    }
  }
}
function Je(r) {
  return Ya.INSTANCE.registerEditorCommand(r), r;
}
function Xf(r) {
  const e = new r();
  return Ya.INSTANCE.registerEditorAction(e), e;
}
function WDe(r) {
  return Ya.INSTANCE.registerEditorAction(r), r;
}
function iO(r, e, t) {
  Ya.INSTANCE.registerEditorContribution(r, e, t);
}
var wp;
(function(r) {
  function e(o) {
    return Ya.INSTANCE.getEditorCommand(o);
  }
  r.getEditorCommand = e;
  function t() {
    return Ya.INSTANCE.getEditorActions();
  }
  r.getEditorActions = t;
  function n() {
    return Ya.INSTANCE.getEditorContributions();
  }
  r.getEditorContributions = n;
  function i(o) {
    return Ya.INSTANCE.getEditorContributions().filter((a) => o.indexOf(a.id) >= 0);
  }
  r.getSomeEditorContributions = i;
  function s() {
    return Ya.INSTANCE.getDiffEditorContributions();
  }
  r.getDiffEditorContributions = s;
})(wp || (wp = {}));
const _2t = {
  EditorCommonContributions: "editor.contributions"
};
class Ya {
  static {
    this.INSTANCE = new Ya();
  }
  constructor() {
    this.editorContributions = [], this.diffEditorContributions = [], this.editorActions = [], this.editorCommands = /* @__PURE__ */ Object.create(null);
  }
  registerEditorContribution(e, t, n) {
    this.editorContributions.push({ id: e, ctor: t, instantiation: n });
  }
  getEditorContributions() {
    return this.editorContributions.slice(0);
  }
  getDiffEditorContributions() {
    return this.diffEditorContributions.slice(0);
  }
  registerEditorAction(e) {
    e.register(), this.editorActions.push(e);
  }
  getEditorActions() {
    return this.editorActions;
  }
  registerEditorCommand(e) {
    e.register(), this.editorCommands[e.id] = e;
  }
  getEditorCommand(e) {
    return this.editorCommands[e] || null;
  }
}
Er.add(_2t.EditorCommonContributions, Ya.INSTANCE);
function yw(r) {
  return r.register(), r;
}
const jDe = yw(new nO({
  id: "undo",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    primary: 2104
    /* KeyCode.KeyZ */
  },
  menuOpts: [{
    menuId: oe.MenubarEditMenu,
    group: "1_do",
    title: C({ key: "miUndo", comment: ["&& denotes a mnemonic"] }, "&&Undo"),
    order: 1
  }, {
    menuId: oe.CommandPalette,
    group: "",
    title: C("undo", "Undo"),
    order: 1
  }]
}));
yw(new FDe(jDe, { id: "default:undo", precondition: void 0 }));
const ZDe = yw(new nO({
  id: "redo",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    primary: 2103,
    secondary: [
      3128
      /* KeyCode.KeyZ */
    ],
    mac: {
      primary: 3128
      /* KeyCode.KeyZ */
    }
  },
  menuOpts: [{
    menuId: oe.MenubarEditMenu,
    group: "1_do",
    title: C({ key: "miRedo", comment: ["&& denotes a mnemonic"] }, "&&Redo"),
    order: 2
  }, {
    menuId: oe.CommandPalette,
    group: "",
    title: C("redo", "Redo"),
    order: 1
  }]
}));
yw(new FDe(ZDe, { id: "default:redo", precondition: void 0 }));
const x2t = yw(new nO({
  id: "editor.action.selectAll",
  precondition: void 0,
  kbOpts: {
    weight: 0,
    kbExpr: null,
    primary: 2079
    /* KeyCode.KeyA */
  },
  menuOpts: [{
    menuId: oe.MenubarSelectionMenu,
    group: "1_basic",
    title: C({ key: "miSelectAll", comment: ["&& denotes a mnemonic"] }, "&&Select All"),
    order: 1
  }, {
    menuId: oe.CommandPalette,
    group: "",
    title: C("selectAll", "Select All"),
    order: 1
  }]
})), S2t = "$initialize";
let i5e = !1;
function UD(r) {
  Yg && (i5e || (i5e = !0, console.warn("Could not create web worker(s). Falling back to loading web worker code in main thread, which might cause UI freezes. Please see https://github.com/microsoft/monaco-editor#faq")), console.warn(r.message));
}
class M2t {
  constructor(e, t, n, i) {
    this.vsWorker = e, this.req = t, this.method = n, this.args = i, this.type = 0;
  }
}
class r5e {
  constructor(e, t, n, i) {
    this.vsWorker = e, this.seq = t, this.res = n, this.err = i, this.type = 1;
  }
}
class D2t {
  constructor(e, t, n, i) {
    this.vsWorker = e, this.req = t, this.eventName = n, this.arg = i, this.type = 2;
  }
}
class L2t {
  constructor(e, t, n) {
    this.vsWorker = e, this.req = t, this.event = n, this.type = 3;
  }
}
class k2t {
  constructor(e, t) {
    this.vsWorker = e, this.req = t, this.type = 4;
  }
}
class N2t {
  constructor(e) {
    this._workerId = -1, this._handler = e, this._lastSentReq = 0, this._pendingReplies = /* @__PURE__ */ Object.create(null), this._pendingEmitters = /* @__PURE__ */ new Map(), this._pendingEvents = /* @__PURE__ */ new Map();
  }
  setWorkerId(e) {
    this._workerId = e;
  }
  sendMessage(e, t) {
    const n = String(++this._lastSentReq);
    return new Promise((i, s) => {
      this._pendingReplies[n] = {
        resolve: i,
        reject: s
      }, this._send(new M2t(this._workerId, n, e, t));
    });
  }
  listen(e, t) {
    let n = null;
    const i = new $({
      onWillAddFirstListener: () => {
        n = String(++this._lastSentReq), this._pendingEmitters.set(n, i), this._send(new D2t(this._workerId, n, e, t));
      },
      onDidRemoveLastListener: () => {
        this._pendingEmitters.delete(n), this._send(new k2t(this._workerId, n)), n = null;
      }
    });
    return i.event;
  }
  handleMessage(e) {
    !e || !e.vsWorker || this._workerId !== -1 && e.vsWorker !== this._workerId || this._handleMessage(e);
  }
  _handleMessage(e) {
    switch (e.type) {
      case 1:
        return this._handleReplyMessage(e);
      case 0:
        return this._handleRequestMessage(e);
      case 2:
        return this._handleSubscribeEventMessage(e);
      case 3:
        return this._handleEventMessage(e);
      case 4:
        return this._handleUnsubscribeEventMessage(e);
    }
  }
  _handleReplyMessage(e) {
    if (!this._pendingReplies[e.seq]) {
      console.warn("Got reply to unknown seq");
      return;
    }
    const t = this._pendingReplies[e.seq];
    if (delete this._pendingReplies[e.seq], e.err) {
      let n = e.err;
      e.err.$isError && (n = new Error(), n.name = e.err.name, n.message = e.err.message, n.stack = e.err.stack), t.reject(n);
      return;
    }
    t.resolve(e.res);
  }
  _handleRequestMessage(e) {
    const t = e.req;
    this._handler.handleMessage(e.method, e.args).then((i) => {
      this._send(new r5e(this._workerId, t, i, void 0));
    }, (i) => {
      i.detail instanceof Error && (i.detail = Ave(i.detail)), this._send(new r5e(this._workerId, t, void 0, Ave(i)));
    });
  }
  _handleSubscribeEventMessage(e) {
    const t = e.req, n = this._handler.handleEvent(e.eventName, e.arg)((i) => {
      this._send(new L2t(this._workerId, t, i));
    });
    this._pendingEvents.set(t, n);
  }
  _handleEventMessage(e) {
    if (!this._pendingEmitters.has(e.req)) {
      console.warn("Got event for unknown req");
      return;
    }
    this._pendingEmitters.get(e.req).fire(e.event);
  }
  _handleUnsubscribeEventMessage(e) {
    if (!this._pendingEvents.has(e.req)) {
      console.warn("Got unsubscribe for unknown req");
      return;
    }
    this._pendingEvents.get(e.req).dispose(), this._pendingEvents.delete(e.req);
  }
  _send(e) {
    const t = [];
    if (e.type === 0)
      for (let n = 0; n < e.args.length; n++)
        e.args[n] instanceof ArrayBuffer && t.push(e.args[n]);
    else e.type === 1 && e.res instanceof ArrayBuffer && t.push(e.res);
    this._handler.sendMessage(e, t);
  }
}
class T2t extends me {
  constructor(e, t, n) {
    super();
    let i = null;
    this._worker = this._register(e.create("vs/base/common/worker/simpleWorker", (d) => {
      this._protocol.handleMessage(d);
    }, (d) => {
      i?.(d);
    })), this._protocol = new N2t({
      sendMessage: (d, u) => {
        this._worker.postMessage(d, u);
      },
      handleMessage: (d, u) => {
        if (typeof n[d] != "function")
          return Promise.reject(new Error("Missing method " + d + " on main thread host."));
        try {
          return Promise.resolve(n[d].apply(n, u));
        } catch (f) {
          return Promise.reject(f);
        }
      },
      handleEvent: (d, u) => {
        if (qDe(d)) {
          const f = n[d].call(n, u);
          if (typeof f != "function")
            throw new Error(`Missing dynamic event ${d} on main thread host.`);
          return f;
        }
        if (UDe(d)) {
          const f = n[d];
          if (typeof f != "function")
            throw new Error(`Missing event ${d} on main thread host.`);
          return f;
        }
        throw new Error(`Malformed event name ${d}`);
      }
    }), this._protocol.setWorkerId(this._worker.getId());
    let s = null;
    const o = globalThis.require;
    typeof o < "u" && typeof o.getConfig == "function" ? s = o.getConfig() : typeof globalThis.requirejs < "u" && (s = globalThis.requirejs.s.contexts._.config);
    const a = bI(n);
    this._onModuleLoaded = this._protocol.sendMessage(S2t, [
      this._worker.getId(),
      JSON.parse(JSON.stringify(s)),
      t,
      a
    ]);
    const l = (d, u) => this._request(d, u), c = (d, u) => this._protocol.listen(d, u);
    this._lazyProxy = new Promise((d, u) => {
      i = u, this._onModuleLoaded.then((f) => {
        d(I2t(f, l, c));
      }, (f) => {
        u(f), this._onError("Worker failed to load " + t, f);
      });
    });
  }
  getProxyObject() {
    return this._lazyProxy;
  }
  _request(e, t) {
    return new Promise((n, i) => {
      this._onModuleLoaded.then(() => {
        this._protocol.sendMessage(e, t).then(n, i);
      }, i);
    });
  }
  _onError(e, t) {
    console.error(e), console.info(t);
  }
}
function UDe(r) {
  return r[0] === "o" && r[1] === "n" && gu(r.charCodeAt(2));
}
function qDe(r) {
  return /^onDynamic/.test(r) && gu(r.charCodeAt(9));
}
function I2t(r, e, t) {
  const n = (o) => function() {
    const a = Array.prototype.slice.call(arguments, 0);
    return e(o, a);
  }, i = (o) => function(a) {
    return t(o, a);
  }, s = {};
  for (const o of r) {
    if (qDe(o)) {
      s[o] = i(o);
      continue;
    }
    if (UDe(o)) {
      s[o] = t(o, void 0);
      continue;
    }
    s[o] = n(o);
  }
  return s;
}
function Jf(r, e) {
  const t = globalThis.MonacoEnvironment;
  if (t?.createTrustedTypesPolicy)
    try {
      return t.createTrustedTypesPolicy(r, e);
    } catch (n) {
      wn(n);
      return;
    }
  try {
    return globalThis.trustedTypes?.createPolicy(r, e);
  } catch (n) {
    wn(n);
    return;
  }
}
let z8;
typeof self == "object" && self.constructor && self.constructor.name === "DedicatedWorkerGlobalScope" && globalThis.workerttPolicy !== void 0 ? z8 = globalThis.workerttPolicy : z8 = Jf("defaultWorkerFactory", { createScriptURL: (r) => r });
function O2t(r) {
  const e = globalThis.MonacoEnvironment;
  if (e) {
    if (typeof e.getWorker == "function")
      return e.getWorker("workerMain.js", r);
    if (typeof e.getWorkerUrl == "function") {
      const t = e.getWorkerUrl("workerMain.js", r);
      return new Worker(z8 ? z8.createScriptURL(t) : t, { name: r });
    }
  }
  throw new Error("You must define a function MonacoEnvironment.getWorkerUrl or MonacoEnvironment.getWorker");
}
function R2t(r) {
  return typeof r.then == "function";
}
class V2t extends me {
  constructor(e, t, n, i, s) {
    super(), this.id = t, this.label = n;
    const o = O2t(n);
    R2t(o) ? this.worker = o : this.worker = Promise.resolve(o), this.postMessage(e, []), this.worker.then((a) => {
      a.onmessage = function(l) {
        i(l.data);
      }, a.onmessageerror = s, typeof a.addEventListener == "function" && a.addEventListener("error", s);
    }), this._register(ht(() => {
      this.worker?.then((a) => {
        a.onmessage = null, a.onmessageerror = null, a.removeEventListener("error", s), a.terminate();
      }), this.worker = null;
    }));
  }
  getId() {
    return this.id;
  }
  postMessage(e, t) {
    this.worker?.then((n) => {
      try {
        n.postMessage(e, t);
      } catch (i) {
        wn(i), wn(new Error(`FAILED to post message to '${this.label}'-worker`, { cause: i }));
      }
    });
  }
}
class rO {
  static {
    this.LAST_WORKER_ID = 0;
  }
  constructor(e) {
    this._label = e, this._webWorkerFailedBeforeError = !1;
  }
  create(e, t, n) {
    const i = ++rO.LAST_WORKER_ID;
    if (this._webWorkerFailedBeforeError)
      throw this._webWorkerFailedBeforeError;
    return new V2t(e, i, this._label || "anonymous" + i, t, (s) => {
      UD(s), this._webWorkerFailedBeforeError = s, n(s);
    });
  }
}
var As;
(function(r) {
  r[r.None = 0] = "None", r[r.Indent = 1] = "Indent", r[r.IndentOutdent = 2] = "IndentOutdent", r[r.Outdent = 3] = "Outdent";
})(As || (As = {}));
class TE {
  constructor(e) {
    if (this._neutralCharacter = null, this._neutralCharacterSearched = !1, this.open = e.open, this.close = e.close, this._inString = !0, this._inComment = !0, this._inRegEx = !0, Array.isArray(e.notIn))
      for (let t = 0, n = e.notIn.length; t < n; t++)
        switch (e.notIn[t]) {
          case "string":
            this._inString = !1;
            break;
          case "comment":
            this._inComment = !1;
            break;
          case "regex":
            this._inRegEx = !1;
            break;
        }
  }
  isOK(e) {
    switch (e) {
      case 0:
        return !0;
      case 1:
        return this._inComment;
      case 2:
        return this._inString;
      case 3:
        return this._inRegEx;
    }
  }
  shouldAutoClose(e, t) {
    if (e.getTokenCount() === 0)
      return !0;
    const n = e.findTokenIndexAtOffset(t - 2), i = e.getStandardTokenType(n);
    return this.isOK(i);
  }
  _findNeutralCharacterInRange(e, t) {
    for (let n = e; n <= t; n++) {
      const i = String.fromCharCode(n);
      if (!this.open.includes(i) && !this.close.includes(i))
        return i;
    }
    return null;
  }
  /**
   * Find a character in the range [0-9a-zA-Z] that does not appear in the open or close
   */
  findNeutralCharacter() {
    return this._neutralCharacterSearched || (this._neutralCharacterSearched = !0, this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      48,
      57
      /* CharCode.Digit9 */
    )), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      97,
      122
      /* CharCode.z */
    )), this._neutralCharacter || (this._neutralCharacter = this._findNeutralCharacterInRange(
      65,
      90
      /* CharCode.Z */
    ))), this._neutralCharacter;
  }
}
class H2t {
  constructor(e) {
    this.autoClosingPairsOpenByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsOpenByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByStart = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseByEnd = /* @__PURE__ */ new Map(), this.autoClosingPairsCloseSingleChar = /* @__PURE__ */ new Map();
    for (const t of e)
      Tm(this.autoClosingPairsOpenByStart, t.open.charAt(0), t), Tm(this.autoClosingPairsOpenByEnd, t.open.charAt(t.open.length - 1), t), Tm(this.autoClosingPairsCloseByStart, t.close.charAt(0), t), Tm(this.autoClosingPairsCloseByEnd, t.close.charAt(t.close.length - 1), t), t.close.length === 1 && t.open.length === 1 && Tm(this.autoClosingPairsCloseSingleChar, t.close, t);
  }
}
function Tm(r, e, t) {
  r.has(e) ? r.get(e).push(t) : r.set(e, [t]);
}
class W8 {
  static {
    this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES = `;:.,=}])> 
	`;
  }
  static {
    this.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS = `'"\`;:.,=}])> 
	`;
  }
  constructor(e) {
    if (e.autoClosingPairs ? this._autoClosingPairs = e.autoClosingPairs.map((t) => new TE(t)) : e.brackets ? this._autoClosingPairs = e.brackets.map((t) => new TE({ open: t[0], close: t[1] })) : this._autoClosingPairs = [], e.__electricCharacterSupport && e.__electricCharacterSupport.docComment) {
      const t = e.__electricCharacterSupport.docComment;
      this._autoClosingPairs.push(new TE({ open: t.open, close: t.close || "" }));
    }
    this._autoCloseBeforeForQuotes = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : W8.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_QUOTES, this._autoCloseBeforeForBrackets = typeof e.autoCloseBefore == "string" ? e.autoCloseBefore : W8.DEFAULT_AUTOCLOSE_BEFORE_LANGUAGE_DEFINED_BRACKETS, this._surroundingPairs = e.surroundingPairs || this._autoClosingPairs;
  }
  getAutoClosingPairs() {
    return this._autoClosingPairs;
  }
  getAutoCloseBeforeSet(e) {
    return e ? this._autoCloseBeforeForQuotes : this._autoCloseBeforeForBrackets;
  }
  getSurroundingPairs() {
    return this._surroundingPairs;
  }
}
function I0(r, e) {
  const t = r.getCount(), n = r.findTokenIndexAtOffset(e), i = r.getLanguageId(n);
  let s = n;
  for (; s + 1 < t && r.getLanguageId(s + 1) === i; )
    s++;
  let o = n;
  for (; o > 0 && r.getLanguageId(o - 1) === i; )
    o--;
  return new B2t(r, i, o, s + 1, r.getStartOffset(o), r.getEndOffset(s));
}
class B2t {
  constructor(e, t, n, i, s, o) {
    this._scopedLineTokensBrand = void 0, this._actual = e, this.languageId = t, this._firstTokenIndex = n, this._lastTokenIndex = i, this.firstCharOffset = s, this._lastCharOffset = o, this.languageIdCodec = e.languageIdCodec;
  }
  getLineContent() {
    return this._actual.getLineContent().substring(this.firstCharOffset, this._lastCharOffset);
  }
  getLineLength() {
    return this._lastCharOffset - this.firstCharOffset;
  }
  getActualLineContentBefore(e) {
    return this._actual.getLineContent().substring(0, this.firstCharOffset + e);
  }
  getTokenCount() {
    return this._lastTokenIndex - this._firstTokenIndex;
  }
  findTokenIndexAtOffset(e) {
    return this._actual.findTokenIndexAtOffset(e + this.firstCharOffset) - this._firstTokenIndex;
  }
  getStandardTokenType(e) {
    return this._actual.getStandardTokenType(e + this._firstTokenIndex);
  }
  toIViewLineTokens() {
    return this._actual.sliceAndInflate(this.firstCharOffset, this._lastCharOffset, 0);
  }
}
function Vc(r) {
  return (r & 3) !== 0;
}
const s5e = typeof Buffer < "u";
let IE;
class sO {
  /**
   * When running in a nodejs context, if `actual` is not a nodejs Buffer, the backing store for
   * the returned `VSBuffer` instance might use a nodejs Buffer allocated from node's Buffer pool,
   * which is not transferrable.
   */
  static wrap(e) {
    return s5e && !Buffer.isBuffer(e) && (e = Buffer.from(e.buffer, e.byteOffset, e.byteLength)), new sO(e);
  }
  constructor(e) {
    this.buffer = e, this.byteLength = this.buffer.byteLength;
  }
  toString() {
    return s5e ? this.buffer.toString() : (IE || (IE = new TextDecoder()), IE.decode(this.buffer));
  }
}
function P2t(r, e) {
  return r[e + 0] << 0 >>> 0 | r[e + 1] << 8 >>> 0;
}
function F2t(r, e, t) {
  r[t + 0] = e & 255, e = e >>> 8, r[t + 1] = e & 255;
}
function Il(r, e) {
  return r[e] * 2 ** 24 + r[e + 1] * 2 ** 16 + r[e + 2] * 2 ** 8 + r[e + 3];
}
function Ol(r, e, t) {
  r[t + 3] = e, e = e >>> 8, r[t + 2] = e, e = e >>> 8, r[t + 1] = e, e = e >>> 8, r[t] = e;
}
function o5e(r, e) {
  return r[e];
}
function a5e(r, e, t) {
  r[t] = e;
}
let OE;
function GDe() {
  return OE || (OE = new TextDecoder("UTF-16LE")), OE;
}
let RE;
function z2t() {
  return RE || (RE = new TextDecoder("UTF-16BE")), RE;
}
let VE;
function QDe() {
  return VE || (VE = Nut() ? GDe() : z2t()), VE;
}
function W2t(r, e, t) {
  const n = new Uint16Array(r.buffer, e, t);
  return t > 0 && (n[0] === 65279 || n[0] === 65534) ? j2t(r, e, t) : GDe().decode(n);
}
function j2t(r, e, t) {
  const n = [];
  let i = 0;
  for (let s = 0; s < t; s++) {
    const o = P2t(r, e);
    e += 2, n[i++] = String.fromCharCode(o);
  }
  return n.join("");
}
class J7 {
  constructor(e) {
    this._capacity = e | 0, this._buffer = new Uint16Array(this._capacity), this._completedStrings = null, this._bufferLength = 0;
  }
  reset() {
    this._completedStrings = null, this._bufferLength = 0;
  }
  build() {
    return this._completedStrings !== null ? (this._flushBuffer(), this._completedStrings.join("")) : this._buildBuffer();
  }
  _buildBuffer() {
    if (this._bufferLength === 0)
      return "";
    const e = new Uint16Array(this._buffer.buffer, 0, this._bufferLength);
    return QDe().decode(e);
  }
  _flushBuffer() {
    const e = this._buildBuffer();
    this._bufferLength = 0, this._completedStrings === null ? this._completedStrings = [e] : this._completedStrings[this._completedStrings.length] = e;
  }
  /**
   * Append a char code (<2^16)
   */
  appendCharCode(e) {
    const t = this._capacity - this._bufferLength;
    t <= 1 && (t === 0 || Ki(e)) && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  /**
   * Append an ASCII char code (<2^8)
   */
  appendASCIICharCode(e) {
    this._bufferLength === this._capacity && this._flushBuffer(), this._buffer[this._bufferLength++] = e;
  }
  appendString(e) {
    const t = e.length;
    if (this._bufferLength + t >= this._capacity) {
      this._flushBuffer(), this._completedStrings[this._completedStrings.length] = e;
      return;
    }
    for (let n = 0; n < t; n++)
      this._buffer[this._bufferLength++] = e.charCodeAt(n);
  }
}
class j8 {
  constructor(e, t, n, i, s, o) {
    this._richEditBracketBrand = void 0, this.languageId = e, this.index = t, this.open = n, this.close = i, this.forwardRegex = s, this.reversedRegex = o, this._openSet = j8._toSet(this.open), this._closeSet = j8._toSet(this.close);
  }
  /**
   * Check if the provided `text` is an open bracket in this group.
   */
  isOpen(e) {
    return this._openSet.has(e);
  }
  /**
   * Check if the provided `text` is a close bracket in this group.
   */
  isClose(e) {
    return this._closeSet.has(e);
  }
  static _toSet(e) {
    const t = /* @__PURE__ */ new Set();
    for (const n of e)
      t.add(n);
    return t;
  }
}
function Z2t(r) {
  const e = r.length;
  r = r.map((o) => [o[0].toLowerCase(), o[1].toLowerCase()]);
  const t = [];
  for (let o = 0; o < e; o++)
    t[o] = o;
  const n = (o, a) => {
    const [l, c] = o, [d, u] = a;
    return l === d || l === u || c === d || c === u;
  }, i = (o, a) => {
    const l = Math.min(o, a), c = Math.max(o, a);
    for (let d = 0; d < e; d++)
      t[d] === c && (t[d] = l);
  };
  for (let o = 0; o < e; o++) {
    const a = r[o];
    for (let l = o + 1; l < e; l++) {
      const c = r[l];
      n(a, c) && i(t[o], t[l]);
    }
  }
  const s = [];
  for (let o = 0; o < e; o++) {
    const a = [], l = [];
    for (let c = 0; c < e; c++)
      if (t[c] === o) {
        const [d, u] = r[c];
        a.push(d), l.push(u);
      }
    a.length > 0 && s.push({
      open: a,
      close: l
    });
  }
  return s;
}
class U2t {
  constructor(e, t) {
    this._richEditBracketsBrand = void 0;
    const n = Z2t(t);
    this.brackets = n.map((i, s) => new j8(e, s, i.open, i.close, q2t(i.open, i.close, n, s), G2t(i.open, i.close, n, s))), this.forwardRegex = Q2t(this.brackets), this.reversedRegex = K2t(this.brackets), this.textIsBracket = {}, this.textIsOpenBracket = {}, this.maxBracketLength = 0;
    for (const i of this.brackets) {
      for (const s of i.open)
        this.textIsBracket[s] = i, this.textIsOpenBracket[s] = !0, this.maxBracketLength = Math.max(this.maxBracketLength, s.length);
      for (const s of i.close)
        this.textIsBracket[s] = i, this.textIsOpenBracket[s] = !1, this.maxBracketLength = Math.max(this.maxBracketLength, s.length);
    }
  }
}
function KDe(r, e, t, n) {
  for (let i = 0, s = e.length; i < s; i++) {
    if (i === t)
      continue;
    const o = e[i];
    for (const a of o.open)
      a.indexOf(r) >= 0 && n.push(a);
    for (const a of o.close)
      a.indexOf(r) >= 0 && n.push(a);
  }
}
function YDe(r, e) {
  return r.length - e.length;
}
function $7(r) {
  if (r.length <= 1)
    return r;
  const e = [], t = /* @__PURE__ */ new Set();
  for (const n of r)
    t.has(n) || (e.push(n), t.add(n));
  return e;
}
function q2t(r, e, t, n) {
  let i = [];
  i = i.concat(r), i = i.concat(e);
  for (let s = 0, o = i.length; s < o; s++)
    KDe(i[s], t, n, i);
  return i = $7(i), i.sort(YDe), i.reverse(), Cw(i);
}
function G2t(r, e, t, n) {
  let i = [];
  i = i.concat(r), i = i.concat(e);
  for (let s = 0, o = i.length; s < o; s++)
    KDe(i[s], t, n, i);
  return i = $7(i), i.sort(YDe), i.reverse(), Cw(i.map(oO));
}
function Q2t(r) {
  let e = [];
  for (const t of r) {
    for (const n of t.open)
      e.push(n);
    for (const n of t.close)
      e.push(n);
  }
  return e = $7(e), Cw(e);
}
function K2t(r) {
  let e = [];
  for (const t of r) {
    for (const n of t.open)
      e.push(n);
    for (const n of t.close)
      e.push(n);
  }
  return e = $7(e), Cw(e.map(oO));
}
function Y2t(r) {
  const e = /^[\w ]+$/.test(r);
  return r = tc(r), e ? `\\b${r}\\b` : r;
}
function Cw(r, e) {
  const t = `(${r.map(Y2t).join(")|(")})`;
  return nDe(t, !0, e);
}
const oO = /* @__PURE__ */ function() {
  function r(n) {
    const i = new Uint16Array(n.length);
    let s = 0;
    for (let o = n.length - 1; o >= 0; o--)
      i[s++] = n.charCodeAt(o);
    return QDe().decode(i);
  }
  let e = null, t = null;
  return function(i) {
    return e !== i && (e = i, t = r(e)), t;
  };
}();
class Ha {
  static _findPrevBracketInText(e, t, n, i) {
    const s = n.match(e);
    if (!s)
      return null;
    const o = n.length - (s.index || 0), a = s[0].length, l = i + o;
    return new Q(t, l - a + 1, t, l + 1);
  }
  static findPrevBracketInRange(e, t, n, i, s) {
    const a = oO(n).substring(n.length - s, n.length - i);
    return this._findPrevBracketInText(e, t, a, i);
  }
  static findNextBracketInText(e, t, n, i) {
    const s = n.match(e);
    if (!s)
      return null;
    const o = s.index || 0, a = s[0].length;
    if (a === 0)
      return null;
    const l = i + o;
    return new Q(t, l + 1, t, l + 1 + a);
  }
  static findNextBracketInRange(e, t, n, i, s) {
    const o = n.substring(i, s);
    return this.findNextBracketInText(e, t, o, i);
  }
}
class X2t {
  constructor(e) {
    this._richEditBrackets = e;
  }
  getElectricCharacters() {
    const e = [];
    if (this._richEditBrackets)
      for (const t of this._richEditBrackets.brackets)
        for (const n of t.close) {
          const i = n.charAt(n.length - 1);
          e.push(i);
        }
    return ff(e);
  }
  onElectricCharacter(e, t, n) {
    if (!this._richEditBrackets || this._richEditBrackets.brackets.length === 0)
      return null;
    const i = t.findTokenIndexAtOffset(n - 1);
    if (Vc(t.getStandardTokenType(i)))
      return null;
    const s = this._richEditBrackets.reversedRegex, o = t.getLineContent().substring(0, n - 1) + e, a = Ha.findPrevBracketInRange(s, 1, o, 0, o.length);
    if (!a)
      return null;
    const l = o.substring(a.startColumn - 1, a.endColumn - 1).toLowerCase();
    if (this._richEditBrackets.textIsOpenBracket[l])
      return null;
    const d = t.getActualLineContentBefore(a.startColumn - 1);
    return /^\s*$/.test(d) ? {
      matchOpenBracket: l
    } : null;
  }
}
function kv(r) {
  return r.global && (r.lastIndex = 0), !0;
}
class J2t {
  constructor(e) {
    this._indentationRules = e;
  }
  shouldIncrease(e) {
    return !!(this._indentationRules && this._indentationRules.increaseIndentPattern && kv(this._indentationRules.increaseIndentPattern) && this._indentationRules.increaseIndentPattern.test(e));
  }
  shouldDecrease(e) {
    return !!(this._indentationRules && this._indentationRules.decreaseIndentPattern && kv(this._indentationRules.decreaseIndentPattern) && this._indentationRules.decreaseIndentPattern.test(e));
  }
  shouldIndentNextLine(e) {
    return !!(this._indentationRules && this._indentationRules.indentNextLinePattern && kv(this._indentationRules.indentNextLinePattern) && this._indentationRules.indentNextLinePattern.test(e));
  }
  shouldIgnore(e) {
    return !!(this._indentationRules && this._indentationRules.unIndentedLinePattern && kv(this._indentationRules.unIndentedLinePattern) && this._indentationRules.unIndentedLinePattern.test(e));
  }
  getIndentMetadata(e) {
    let t = 0;
    return this.shouldIncrease(e) && (t += 1), this.shouldDecrease(e) && (t += 2), this.shouldIndentNextLine(e) && (t += 4), this.shouldIgnore(e) && (t += 8), t;
  }
}
class K2 {
  constructor(e) {
    e = e || {}, e.brackets = e.brackets || [
      ["(", ")"],
      ["{", "}"],
      ["[", "]"]
    ], this._brackets = [], e.brackets.forEach((t) => {
      const n = K2._createOpenBracketRegExp(t[0]), i = K2._createCloseBracketRegExp(t[1]);
      n && i && this._brackets.push({
        open: t[0],
        openRegExp: n,
        close: t[1],
        closeRegExp: i
      });
    }), this._regExpRules = e.onEnterRules || [];
  }
  onEnter(e, t, n, i) {
    if (e >= 3)
      for (let s = 0, o = this._regExpRules.length; s < o; s++) {
        const a = this._regExpRules[s];
        if ([{
          reg: a.beforeText,
          text: n
        }, {
          reg: a.afterText,
          text: i
        }, {
          reg: a.previousLineText,
          text: t
        }].every((c) => c.reg ? (c.reg.lastIndex = 0, c.reg.test(c.text)) : !0))
          return a.action;
      }
    if (e >= 2 && n.length > 0 && i.length > 0)
      for (let s = 0, o = this._brackets.length; s < o; s++) {
        const a = this._brackets[s];
        if (a.openRegExp.test(n) && a.closeRegExp.test(i))
          return { indentAction: As.IndentOutdent };
      }
    if (e >= 2 && n.length > 0) {
      for (let s = 0, o = this._brackets.length; s < o; s++)
        if (this._brackets[s].openRegExp.test(n))
          return { indentAction: As.Indent };
    }
    return null;
  }
  static _createOpenBracketRegExp(e) {
    let t = tc(e);
    return /\B/.test(t.charAt(0)) || (t = "\\b" + t), t += "\\s*$", K2._safeRegExp(t);
  }
  static _createCloseBracketRegExp(e) {
    let t = tc(e);
    return /\B/.test(t.charAt(t.length - 1)) || (t = t + "\\b"), t = "^\\s*" + t, K2._safeRegExp(t);
  }
  static _safeRegExp(e) {
    try {
      return new RegExp(e);
    } catch (t) {
      return wn(t), null;
    }
  }
}
const Ai = Wt("configurationService");
function qD(r, e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n in r)
    XDe(t, n, r[n], e);
  return t;
}
function XDe(r, e, t, n) {
  const i = e.split("."), s = i.pop();
  let o = r;
  for (let a = 0; a < i.length; a++) {
    const l = i[a];
    let c = o[l];
    switch (typeof c) {
      case "undefined":
        c = o[l] = /* @__PURE__ */ Object.create(null);
        break;
      case "object":
        if (c === null) {
          n(`Ignoring ${e} as ${i.slice(0, a + 1).join(".")} is null`);
          return;
        }
        break;
      default:
        n(`Ignoring ${e} as ${i.slice(0, a + 1).join(".")} is ${JSON.stringify(c)}`);
        return;
    }
    o = c;
  }
  if (typeof o == "object" && o !== null)
    try {
      o[s] = t;
    } catch {
      n(`Ignoring ${e} as ${i.join(".")} is ${JSON.stringify(o)}`);
    }
  else
    n(`Ignoring ${e} as ${i.join(".")} is ${JSON.stringify(o)}`);
}
function $2t(r, e) {
  const t = e.split(".");
  JDe(r, t);
}
function JDe(r, e) {
  const t = e.shift();
  if (e.length === 0) {
    delete r[t];
    return;
  }
  if (Object.keys(r).indexOf(t) !== -1) {
    const n = r[t];
    typeof n == "object" && !Array.isArray(n) && (JDe(n, e), Object.keys(n).length === 0 && delete r[t]);
  }
}
function l5e(r, e, t) {
  function n(o, a) {
    let l = o;
    for (const c of a) {
      if (typeof l != "object" || l === null)
        return;
      l = l[c];
    }
    return l;
  }
  const i = e.split("."), s = n(r, i);
  return typeof s > "u" ? t : s;
}
function ept(r) {
  return r.replace(/[\[\]]/g, "");
}
const sr = Wt("languageService");
class jc {
  constructor(e, t = [], n = !1) {
    this.ctor = e, this.staticArguments = t, this.supportsDelayedInstantiation = n;
  }
}
const $De = [];
function en(r, e, t) {
  e instanceof jc || (e = new jc(e, [], !!t)), $De.push([r, e]);
}
function c5e() {
  return $De;
}
const ad = Object.freeze({
  text: "text/plain",
  binary: "application/octet-stream",
  unknown: "application/unknown",
  markdown: "text/markdown",
  latex: "text/latex",
  uriList: "text/uri-list"
}), ey = {
  JSONContribution: "base.contributions.json"
};
function tpt(r) {
  return r.length > 0 && r.charAt(r.length - 1) === "#" ? r.substring(0, r.length - 1) : r;
}
class npt {
  constructor() {
    this._onDidChangeSchema = new $(), this.schemasById = {};
  }
  registerSchema(e, t) {
    this.schemasById[tpt(e)] = t, this._onDidChangeSchema.fire(e);
  }
  notifySchemaChanged(e) {
    this._onDidChangeSchema.fire(e);
  }
}
const ipt = new npt();
Er.add(ey.JSONContribution, ipt);
const $f = {
  Configuration: "base.contributions.configuration"
}, Nv = "vscode://schemas/settings/resourceLanguage", h5e = Er.as(ey.JSONContribution);
class rpt {
  constructor() {
    this.registeredConfigurationDefaults = [], this.overrideIdentifiers = /* @__PURE__ */ new Set(), this._onDidSchemaChange = new $(), this._onDidUpdateConfiguration = new $(), this.configurationDefaultsOverrides = /* @__PURE__ */ new Map(), this.defaultLanguageConfigurationOverridesNode = {
      id: "defaultOverrides",
      title: C("defaultLanguageConfigurationOverrides.title", "Default Language Configuration Overrides"),
      properties: {}
    }, this.configurationContributors = [this.defaultLanguageConfigurationOverridesNode], this.resourceLanguageSettingsSchema = {
      properties: {},
      patternProperties: {},
      additionalProperties: !0,
      allowTrailingCommas: !0,
      allowComments: !0
    }, this.configurationProperties = {}, this.policyConfigurations = /* @__PURE__ */ new Map(), this.excludedConfigurationProperties = {}, h5e.registerSchema(Nv, this.resourceLanguageSettingsSchema), this.registerOverridePropertyPatternKey();
  }
  registerConfiguration(e, t = !0) {
    this.registerConfigurations([e], t);
  }
  registerConfigurations(e, t = !0) {
    const n = /* @__PURE__ */ new Set();
    this.doRegisterConfigurations(e, t, n), h5e.registerSchema(Nv, this.resourceLanguageSettingsSchema), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: n });
  }
  registerDefaultConfigurations(e) {
    const t = /* @__PURE__ */ new Set();
    this.doRegisterDefaultConfigurations(e, t), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire({ properties: t, defaultsOverrides: !0 });
  }
  doRegisterDefaultConfigurations(e, t) {
    this.registeredConfigurationDefaults.push(...e);
    const n = [];
    for (const { overrides: i, source: s } of e)
      for (const o in i) {
        t.add(o);
        const a = this.configurationDefaultsOverrides.get(o) ?? this.configurationDefaultsOverrides.set(o, { configurationDefaultOverrides: [] }).get(o), l = i[o];
        if (a.configurationDefaultOverrides.push({ value: l, source: s }), c1.test(o)) {
          const c = this.mergeDefaultConfigurationsForOverrideIdentifier(o, l, s, a.configurationDefaultOverrideValue);
          if (!c)
            continue;
          a.configurationDefaultOverrideValue = c, this.updateDefaultOverrideProperty(o, c, s), n.push(...Z8(o));
        } else {
          const c = this.mergeDefaultConfigurationsForConfigurationProperty(o, l, s, a.configurationDefaultOverrideValue);
          if (!c)
            continue;
          a.configurationDefaultOverrideValue = c;
          const d = this.configurationProperties[o];
          d && (this.updatePropertyDefaultValue(o, d), this.updateSchema(o, d));
        }
      }
    this.doRegisterOverrideIdentifiers(n);
  }
  updateDefaultOverrideProperty(e, t, n) {
    const i = {
      type: "object",
      default: t.value,
      description: C("defaultLanguageConfiguration.description", "Configure settings to be overridden for the {0} language.", ept(e)),
      $ref: Nv,
      defaultDefaultValue: t.value,
      source: n,
      defaultValueSource: n
    };
    this.configurationProperties[e] = i, this.defaultLanguageConfigurationOverridesNode.properties[e] = i;
  }
  mergeDefaultConfigurationsForOverrideIdentifier(e, t, n, i) {
    const s = i?.value || {}, o = i?.source ?? /* @__PURE__ */ new Map();
    if (!(o instanceof Map)) {
      console.error("objectConfigurationSources is not a Map");
      return;
    }
    for (const a of Object.keys(t)) {
      const l = t[a];
      if (Rs(l) && (da(s[a]) || Rs(s[a]))) {
        if (s[a] = { ...s[a] ?? {}, ...l }, n)
          for (const d in l)
            o.set(`${a}.${d}`, n);
      } else
        s[a] = l, n ? o.set(a, n) : o.delete(a);
    }
    return { value: s, source: o };
  }
  mergeDefaultConfigurationsForConfigurationProperty(e, t, n, i) {
    const s = this.configurationProperties[e], o = i?.value ?? s?.defaultDefaultValue;
    let a = n;
    if (Rs(t) && (s !== void 0 && s.type === "object" || s === void 0 && (da(o) || Rs(o)))) {
      if (a = i?.source ?? /* @__PURE__ */ new Map(), !(a instanceof Map)) {
        console.error("defaultValueSource is not a Map");
        return;
      }
      for (const c in t)
        n && a.set(`${e}.${c}`, n);
      t = { ...Rs(o) ? o : {}, ...t };
    }
    return { value: t, source: a };
  }
  registerOverrideIdentifiers(e) {
    this.doRegisterOverrideIdentifiers(e), this._onDidSchemaChange.fire();
  }
  doRegisterOverrideIdentifiers(e) {
    for (const t of e)
      this.overrideIdentifiers.add(t);
    this.updateOverridePropertyPatternKey();
  }
  doRegisterConfigurations(e, t, n) {
    e.forEach((i) => {
      this.validateAndRegisterProperties(i, t, i.extensionInfo, i.restrictedProperties, void 0, n), this.configurationContributors.push(i), this.registerJSONConfiguration(i);
    });
  }
  validateAndRegisterProperties(e, t = !0, n, i, s = 3, o) {
    s = Mo(e.scope) ? s : e.scope;
    const a = e.properties;
    if (a)
      for (const c in a) {
        const d = a[c];
        if (t && apt(c, d)) {
          delete a[c];
          continue;
        }
        if (d.source = n, d.defaultDefaultValue = a[c].default, this.updatePropertyDefaultValue(c, d), c1.test(c) ? d.scope = void 0 : (d.scope = Mo(d.scope) ? s : d.scope, d.restricted = Mo(d.restricted) ? !!i?.includes(c) : d.restricted), a[c].hasOwnProperty("included") && !a[c].included) {
          this.excludedConfigurationProperties[c] = a[c], delete a[c];
          continue;
        } else
          this.configurationProperties[c] = a[c], a[c].policy?.name && this.policyConfigurations.set(a[c].policy.name, c);
        !a[c].deprecationMessage && a[c].markdownDeprecationMessage && (a[c].deprecationMessage = a[c].markdownDeprecationMessage), o.add(c);
      }
    const l = e.allOf;
    if (l)
      for (const c of l)
        this.validateAndRegisterProperties(c, t, n, i, s, o);
  }
  getConfigurationProperties() {
    return this.configurationProperties;
  }
  getPolicyConfigurations() {
    return this.policyConfigurations;
  }
  registerJSONConfiguration(e) {
    const t = (n) => {
      const i = n.properties;
      if (i)
        for (const o in i)
          this.updateSchema(o, i[o]);
      n.allOf?.forEach(t);
    };
    t(e);
  }
  updateSchema(e, t) {
    switch (t.scope) {
      case 1:
        break;
      case 2:
        break;
      case 6:
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        this.resourceLanguageSettingsSchema.properties[e] = t;
        break;
    }
  }
  updateOverridePropertyPatternKey() {
    for (const e of this.overrideIdentifiers.values()) {
      const t = `[${e}]`, n = {
        type: "object",
        description: C("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."),
        errorMessage: C("overrideSettings.errorMessage", "This setting does not support per-language configuration."),
        $ref: Nv
      };
      this.updatePropertyDefaultValue(t, n);
    }
  }
  registerOverridePropertyPatternKey() {
    C("overrideSettings.defaultDescription", "Configure editor settings to be overridden for a language."), C("overrideSettings.errorMessage", "This setting does not support per-language configuration."), this._onDidSchemaChange.fire();
  }
  updatePropertyDefaultValue(e, t) {
    const n = this.configurationDefaultsOverrides.get(e)?.configurationDefaultOverrideValue;
    let i, s;
    n && (!t.disallowConfigurationDefault || !n.source) && (i = n.value, s = n.source), da(i) && (i = t.defaultDefaultValue, s = void 0), da(i) && (i = opt(t.type)), t.default = i, t.defaultValueSource = s;
  }
}
const eLe = "\\[([^\\]]+)\\]", d5e = new RegExp(eLe, "g"), spt = `^(${eLe})+$`, c1 = new RegExp(spt);
function Z8(r) {
  const e = [];
  if (c1.test(r)) {
    let t = d5e.exec(r);
    for (; t?.length; ) {
      const n = t[1].trim();
      n && e.push(n), t = d5e.exec(r);
    }
  }
  return ff(e);
}
function opt(r) {
  switch (Array.isArray(r) ? r[0] : r) {
    case "boolean":
      return !1;
    case "integer":
    case "number":
      return 0;
    case "string":
      return "";
    case "array":
      return [];
    case "object":
      return {};
    default:
      return null;
  }
}
const A6 = new rpt();
Er.add($f.Configuration, A6);
function apt(r, e) {
  return r.trim() ? c1.test(r) ? C("config.property.languageDefault", "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.", r) : A6.getConfigurationProperties()[r] !== void 0 ? C("config.property.duplicate", "Cannot register '{0}'. This property is already registered.", r) : e.policy?.name && A6.getPolicyConfigurations().get(e.policy?.name) !== void 0 ? C("config.policy.duplicate", "Cannot register '{0}'. The associated policy {1} is already registered with {2}.", r, e.policy?.name, A6.getPolicyConfigurations().get(e.policy?.name)) : null : C("config.property.empty", "Cannot register an empty property");
}
const lpt = {
  ModesRegistry: "editor.modesRegistry"
};
class cpt {
  constructor() {
    this._onDidChangeLanguages = new $(), this.onDidChangeLanguages = this._onDidChangeLanguages.event, this._languages = [];
  }
  registerLanguage(e) {
    return this._languages.push(e), this._onDidChangeLanguages.fire(void 0), {
      dispose: () => {
        for (let t = 0, n = this._languages.length; t < n; t++)
          if (this._languages[t] === e) {
            this._languages.splice(t, 1);
            return;
          }
      }
    };
  }
  getLanguages() {
    return this._languages;
  }
}
const ag = new cpt();
Er.add(lpt.ModesRegistry, ag);
const ll = "plaintext", hpt = ".txt";
ag.registerLanguage({
  id: ll,
  extensions: [hpt],
  aliases: [C("plainText.alias", "Plain Text"), "text"],
  mimetypes: [ad.text]
});
Er.as($f.Configuration).registerDefaultConfigurations([{
  overrides: {
    "[plaintext]": {
      "editor.unicodeHighlight.ambiguousCharacters": !1,
      "editor.unicodeHighlight.invisibleCharacters": !1
    }
  }
}]);
class dpt {
  constructor(e, t) {
    this.languageId = e;
    const n = t.brackets ? u5e(t.brackets) : [], i = new Tve((a) => {
      const l = /* @__PURE__ */ new Set();
      return {
        info: new upt(this, a, l),
        closing: l
      };
    }), s = new Tve((a) => {
      const l = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
      return {
        info: new fpt(this, a, l, c),
        opening: l,
        openingColorized: c
      };
    });
    for (const [a, l] of n) {
      const c = i.get(a), d = s.get(l);
      c.closing.add(d.info), d.opening.add(c.info);
    }
    const o = t.colorizedBracketPairs ? u5e(t.colorizedBracketPairs) : n.filter((a) => !(a[0] === "<" && a[1] === ">"));
    for (const [a, l] of o) {
      const c = i.get(a), d = s.get(l);
      c.closing.add(d.info), d.openingColorized.add(c.info), d.opening.add(c.info);
    }
    this._openingBrackets = new Map([...i.cachedValues].map(([a, l]) => [a, l.info])), this._closingBrackets = new Map([...s.cachedValues].map(([a, l]) => [a, l.info]));
  }
  /**
   * No two brackets have the same bracket text.
  */
  get openingBrackets() {
    return [...this._openingBrackets.values()];
  }
  /**
   * No two brackets have the same bracket text.
  */
  get closingBrackets() {
    return [...this._closingBrackets.values()];
  }
  getOpeningBracketInfo(e) {
    return this._openingBrackets.get(e);
  }
  getClosingBracketInfo(e) {
    return this._closingBrackets.get(e);
  }
  getBracketInfo(e) {
    return this.getOpeningBracketInfo(e) || this.getClosingBracketInfo(e);
  }
  getBracketRegExp(e) {
    const t = Array.from([...this._openingBrackets.keys(), ...this._closingBrackets.keys()]);
    return Cw(t, e);
  }
}
function u5e(r) {
  return r.filter(([e, t]) => e !== "" && t !== "");
}
class tLe {
  constructor(e, t) {
    this.config = e, this.bracketText = t;
  }
  get languageId() {
    return this.config.languageId;
  }
}
class upt extends tLe {
  constructor(e, t, n) {
    super(e, t), this.openedBrackets = n, this.isOpeningBracket = !0;
  }
}
class fpt extends tLe {
  constructor(e, t, n, i) {
    super(e, t), this.openingBrackets = n, this.openingColorizedBrackets = i, this.isOpeningBracket = !1;
  }
  /**
   * Checks if this bracket closes the given other bracket.
   * If the bracket infos come from different configurations, this method will return false.
  */
  closes(e) {
    return e.config !== this.config ? !1 : this.openingBrackets.has(e);
  }
  closesColorized(e) {
    return e.config !== this.config ? !1 : this.openingColorizedBrackets.has(e);
  }
  getOpeningBrackets() {
    return [...this.openingBrackets];
  }
}
var ppt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, f5e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
class HE {
  constructor(e) {
    this.languageId = e;
  }
  affects(e) {
    return this.languageId ? this.languageId === e : !0;
  }
}
const xh = Wt("languageConfigurationService");
let GD = class extends me {
  constructor(e, t) {
    super(), this.configurationService = e, this.languageService = t, this._registry = this._register(new wpt()), this.onDidChangeEmitter = this._register(new $()), this.onDidChange = this.onDidChangeEmitter.event, this.configurations = /* @__PURE__ */ new Map();
    const n = new Set(Object.values(QD));
    this._register(this.configurationService.onDidChangeConfiguration((i) => {
      const s = i.change.keys.some((a) => n.has(a)), o = i.change.overrides.filter(([a, l]) => l.some((c) => n.has(c))).map(([a]) => a);
      if (s)
        this.configurations.clear(), this.onDidChangeEmitter.fire(new HE(void 0));
      else
        for (const a of o)
          this.languageService.isRegisteredLanguageId(a) && (this.configurations.delete(a), this.onDidChangeEmitter.fire(new HE(a)));
    })), this._register(this._registry.onDidChange((i) => {
      this.configurations.delete(i.languageId), this.onDidChangeEmitter.fire(new HE(i.languageId));
    }));
  }
  register(e, t, n) {
    return this._registry.register(e, t, n);
  }
  getLanguageConfiguration(e) {
    let t = this.configurations.get(e);
    return t || (t = gpt(e, this._registry, this.configurationService, this.languageService), this.configurations.set(e, t)), t;
  }
};
GD = ppt([
  f5e(0, Ai),
  f5e(1, sr)
], GD);
function gpt(r, e, t, n) {
  let i = e.getLanguageConfiguration(r);
  if (!i) {
    if (!n.isRegisteredLanguageId(r))
      return new vp(r, {});
    i = new vp(r, {});
  }
  const s = mpt(i.languageId, t), o = iLe([i.underlyingConfig, s]);
  return new vp(i.languageId, o);
}
const QD = {
  brackets: "editor.language.brackets",
  colorizedBracketPairs: "editor.language.colorizedBracketPairs"
};
function mpt(r, e) {
  const t = e.getValue(QD.brackets, {
    overrideIdentifier: r
  }), n = e.getValue(QD.colorizedBracketPairs, {
    overrideIdentifier: r
  });
  return {
    brackets: p5e(t),
    colorizedBracketPairs: p5e(n)
  };
}
function p5e(r) {
  if (Array.isArray(r))
    return r.map((e) => {
      if (!(!Array.isArray(e) || e.length !== 2))
        return [e[0], e[1]];
    }).filter((e) => !!e);
}
function nLe(r, e, t) {
  const n = r.getLineContent(e);
  let i = hs(n);
  return i.length > t - 1 && (i = i.substring(0, t - 1)), i;
}
class Apt {
  constructor(e) {
    this.languageId = e, this._resolved = null, this._entries = [], this._order = 0, this._resolved = null;
  }
  register(e, t) {
    const n = new g5e(e, t, ++this._order);
    return this._entries.push(n), this._resolved = null, ht(() => {
      for (let i = 0; i < this._entries.length; i++)
        if (this._entries[i] === n) {
          this._entries.splice(i, 1), this._resolved = null;
          break;
        }
    });
  }
  getResolvedConfiguration() {
    if (!this._resolved) {
      const e = this._resolve();
      e && (this._resolved = new vp(this.languageId, e));
    }
    return this._resolved;
  }
  _resolve() {
    return this._entries.length === 0 ? null : (this._entries.sort(g5e.cmp), iLe(this._entries.map((e) => e.configuration)));
  }
}
function iLe(r) {
  let e = {
    comments: void 0,
    brackets: void 0,
    wordPattern: void 0,
    indentationRules: void 0,
    onEnterRules: void 0,
    autoClosingPairs: void 0,
    surroundingPairs: void 0,
    autoCloseBefore: void 0,
    folding: void 0,
    colorizedBracketPairs: void 0,
    __electricCharacterSupport: void 0
  };
  for (const t of r)
    e = {
      comments: t.comments || e.comments,
      brackets: t.brackets || e.brackets,
      wordPattern: t.wordPattern || e.wordPattern,
      indentationRules: t.indentationRules || e.indentationRules,
      onEnterRules: t.onEnterRules || e.onEnterRules,
      autoClosingPairs: t.autoClosingPairs || e.autoClosingPairs,
      surroundingPairs: t.surroundingPairs || e.surroundingPairs,
      autoCloseBefore: t.autoCloseBefore || e.autoCloseBefore,
      folding: t.folding || e.folding,
      colorizedBracketPairs: t.colorizedBracketPairs || e.colorizedBracketPairs,
      __electricCharacterSupport: t.__electricCharacterSupport || e.__electricCharacterSupport
    };
  return e;
}
class g5e {
  constructor(e, t, n) {
    this.configuration = e, this.priority = t, this.order = n;
  }
  static cmp(e, t) {
    return e.priority === t.priority ? e.order - t.order : e.priority - t.priority;
  }
}
class m5e {
  constructor(e) {
    this.languageId = e;
  }
}
class wpt extends me {
  constructor() {
    super(), this._entries = /* @__PURE__ */ new Map(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._register(this.register(ll, {
      brackets: [
        ["(", ")"],
        ["[", "]"],
        ["{", "}"]
      ],
      surroundingPairs: [
        { open: "{", close: "}" },
        { open: "[", close: "]" },
        { open: "(", close: ")" },
        { open: "<", close: ">" },
        { open: '"', close: '"' },
        { open: "'", close: "'" },
        { open: "`", close: "`" }
      ],
      colorizedBracketPairs: [],
      folding: {
        offSide: !0
      }
    }, 0));
  }
  /**
   * @param priority Use a higher number for higher priority
   */
  register(e, t, n = 0) {
    let i = this._entries.get(e);
    i || (i = new Apt(e), this._entries.set(e, i));
    const s = i.register(t, n);
    return this._onDidChange.fire(new m5e(e)), ht(() => {
      s.dispose(), this._onDidChange.fire(new m5e(e));
    });
  }
  getLanguageConfiguration(e) {
    return this._entries.get(e)?.getResolvedConfiguration() || null;
  }
}
class vp {
  constructor(e, t) {
    this.languageId = e, this.underlyingConfig = t, this._brackets = null, this._electricCharacter = null, this._onEnterSupport = this.underlyingConfig.brackets || this.underlyingConfig.indentationRules || this.underlyingConfig.onEnterRules ? new K2(this.underlyingConfig) : null, this.comments = vp._handleComments(this.underlyingConfig), this.characterPair = new W8(this.underlyingConfig), this.wordDefinition = this.underlyingConfig.wordPattern || EI, this.indentationRules = this.underlyingConfig.indentationRules, this.underlyingConfig.indentationRules ? this.indentRulesSupport = new J2t(this.underlyingConfig.indentationRules) : this.indentRulesSupport = null, this.foldingRules = this.underlyingConfig.folding || {}, this.bracketsNew = new dpt(e, this.underlyingConfig);
  }
  getWordDefinition() {
    return _I(this.wordDefinition);
  }
  get brackets() {
    return !this._brackets && this.underlyingConfig.brackets && (this._brackets = new U2t(this.languageId, this.underlyingConfig.brackets)), this._brackets;
  }
  get electricCharacter() {
    return this._electricCharacter || (this._electricCharacter = new X2t(this.brackets)), this._electricCharacter;
  }
  onEnter(e, t, n, i) {
    return this._onEnterSupport ? this._onEnterSupport.onEnter(e, t, n, i) : null;
  }
  getAutoClosingPairs() {
    return new H2t(this.characterPair.getAutoClosingPairs());
  }
  getAutoCloseBeforeSet(e) {
    return this.characterPair.getAutoCloseBeforeSet(e);
  }
  getSurroundingPairs() {
    return this.characterPair.getSurroundingPairs();
  }
  static _handleComments(e) {
    const t = e.comments;
    if (!t)
      return null;
    const n = {};
    if (t.lineComment && (n.lineCommentToken = t.lineComment), t.blockComment) {
      const [i, s] = t.blockComment;
      n.blockCommentStartToken = i, n.blockCommentEndToken = s;
    }
    return n;
  }
}
en(
  xh,
  GD,
  1
  /* InstantiationType.Delayed */
);
class du {
  /**
   * Constructs a new DiffChange with the given sequence information
   * and content.
   */
  constructor(e, t, n, i) {
    this.originalStart = e, this.originalLength = t, this.modifiedStart = n, this.modifiedLength = i;
  }
  /**
   * The end point (exclusive) of the change in the original sequence.
   */
  getOriginalEnd() {
    return this.originalStart + this.originalLength;
  }
  /**
   * The end point (exclusive) of the change in the modified sequence.
   */
  getModifiedEnd() {
    return this.modifiedStart + this.modifiedLength;
  }
}
class A5e {
  constructor(e) {
    this.source = e;
  }
  getElements() {
    const e = this.source, t = new Int32Array(e.length);
    for (let n = 0, i = e.length; n < i; n++)
      t[n] = e.charCodeAt(n);
    return t;
  }
}
function vpt(r, e, t) {
  return new ld(new A5e(r), new A5e(e)).ComputeDiff(t).changes;
}
class y2 {
  static Assert(e, t) {
    if (!e)
      throw new Error(t);
  }
}
class C2 {
  /**
   * Copies a range of elements from an Array starting at the specified source index and pastes
   * them to another Array starting at the specified destination index. The length and the indexes
   * are specified as 64-bit integers.
   * sourceArray:
   *		The Array that contains the data to copy.
   * sourceIndex:
   *		A 64-bit integer that represents the index in the sourceArray at which copying begins.
   * destinationArray:
   *		The Array that receives the data.
   * destinationIndex:
   *		A 64-bit integer that represents the index in the destinationArray at which storing begins.
   * length:
   *		A 64-bit integer that represents the number of elements to copy.
   */
  static Copy(e, t, n, i, s) {
    for (let o = 0; o < s; o++)
      n[i + o] = e[t + o];
  }
  static Copy2(e, t, n, i, s) {
    for (let o = 0; o < s; o++)
      n[i + o] = e[t + o];
  }
}
class w5e {
  /**
   * Constructs a new DiffChangeHelper for the given DiffSequences.
   */
  constructor() {
    this.m_changes = [], this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824, this.m_originalCount = 0, this.m_modifiedCount = 0;
  }
  /**
   * Marks the beginning of the next change in the set of differences.
   */
  MarkNextChange() {
    (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.m_changes.push(new du(this.m_originalStart, this.m_originalCount, this.m_modifiedStart, this.m_modifiedCount)), this.m_originalCount = 0, this.m_modifiedCount = 0, this.m_originalStart = 1073741824, this.m_modifiedStart = 1073741824;
  }
  /**
   * Adds the original element at the given position to the elements
   * affected by the current change. The modified index gives context
   * to the change position with respect to the original sequence.
   * @param originalIndex The index of the original element to add.
   * @param modifiedIndex The index of the modified element that provides corresponding position in the modified sequence.
   */
  AddOriginalElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_originalCount++;
  }
  /**
   * Adds the modified element at the given position to the elements
   * affected by the current change. The original index gives context
   * to the change position with respect to the modified sequence.
   * @param originalIndex The index of the original element that provides corresponding position in the original sequence.
   * @param modifiedIndex The index of the modified element to add.
   */
  AddModifiedElement(e, t) {
    this.m_originalStart = Math.min(this.m_originalStart, e), this.m_modifiedStart = Math.min(this.m_modifiedStart, t), this.m_modifiedCount++;
  }
  /**
   * Retrieves all of the changes marked by the class.
   */
  getChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes;
  }
  /**
   * Retrieves all of the changes marked by the class in the reverse order
   */
  getReverseChanges() {
    return (this.m_originalCount > 0 || this.m_modifiedCount > 0) && this.MarkNextChange(), this.m_changes.reverse(), this.m_changes;
  }
}
class ld {
  /**
   * Constructs the DiffFinder
   */
  constructor(e, t, n = null) {
    this.ContinueProcessingPredicate = n, this._originalSequence = e, this._modifiedSequence = t;
    const [i, s, o] = ld._getElements(e), [a, l, c] = ld._getElements(t);
    this._hasStrings = o && c, this._originalStringElements = i, this._originalElementsOrHash = s, this._modifiedStringElements = a, this._modifiedElementsOrHash = l, this.m_forwardHistory = [], this.m_reverseHistory = [];
  }
  static _isStringArray(e) {
    return e.length > 0 && typeof e[0] == "string";
  }
  static _getElements(e) {
    const t = e.getElements();
    if (ld._isStringArray(t)) {
      const n = new Int32Array(t.length);
      for (let i = 0, s = t.length; i < s; i++)
        n[i] = ZI(t[i], 0);
      return [t, n, !0];
    }
    return t instanceof Int32Array ? [[], t, !1] : [[], new Int32Array(t), !1];
  }
  ElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] !== this._modifiedElementsOrHash[t] ? !1 : this._hasStrings ? this._originalStringElements[e] === this._modifiedStringElements[t] : !0;
  }
  ElementsAreStrictEqual(e, t) {
    if (!this.ElementsAreEqual(e, t))
      return !1;
    const n = ld._getStrictElement(this._originalSequence, e), i = ld._getStrictElement(this._modifiedSequence, t);
    return n === i;
  }
  static _getStrictElement(e, t) {
    return typeof e.getStrictElement == "function" ? e.getStrictElement(t) : null;
  }
  OriginalElementsAreEqual(e, t) {
    return this._originalElementsOrHash[e] !== this._originalElementsOrHash[t] ? !1 : this._hasStrings ? this._originalStringElements[e] === this._originalStringElements[t] : !0;
  }
  ModifiedElementsAreEqual(e, t) {
    return this._modifiedElementsOrHash[e] !== this._modifiedElementsOrHash[t] ? !1 : this._hasStrings ? this._modifiedStringElements[e] === this._modifiedStringElements[t] : !0;
  }
  ComputeDiff(e) {
    return this._ComputeDiff(0, this._originalElementsOrHash.length - 1, 0, this._modifiedElementsOrHash.length - 1, e);
  }
  /**
   * Computes the differences between the original and modified input
   * sequences on the bounded range.
   * @returns An array of the differences between the two input sequences.
   */
  _ComputeDiff(e, t, n, i, s) {
    const o = [!1];
    let a = this.ComputeDiffRecursive(e, t, n, i, o);
    return s && (a = this.PrettifyChanges(a)), {
      quitEarly: o[0],
      changes: a
    };
  }
  /**
   * Private helper method which computes the differences on the bounded range
   * recursively.
   * @returns An array of the differences between the two input sequences.
   */
  ComputeDiffRecursive(e, t, n, i, s) {
    for (s[0] = !1; e <= t && n <= i && this.ElementsAreEqual(e, n); )
      e++, n++;
    for (; t >= e && i >= n && this.ElementsAreEqual(t, i); )
      t--, i--;
    if (e > t || n > i) {
      let u;
      return n <= i ? (y2.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), u = [
        new du(e, 0, n, i - n + 1)
      ]) : e <= t ? (y2.Assert(n === i + 1, "modifiedStart should only be one more than modifiedEnd"), u = [
        new du(e, t - e + 1, n, 0)
      ]) : (y2.Assert(e === t + 1, "originalStart should only be one more than originalEnd"), y2.Assert(n === i + 1, "modifiedStart should only be one more than modifiedEnd"), u = []), u;
    }
    const o = [0], a = [0], l = this.ComputeRecursionPoint(e, t, n, i, o, a, s), c = o[0], d = a[0];
    if (l !== null)
      return l;
    if (!s[0]) {
      const u = this.ComputeDiffRecursive(e, c, n, d, s);
      let f = [];
      return s[0] ? f = [
        new du(c + 1, t - (c + 1) + 1, d + 1, i - (d + 1) + 1)
      ] : f = this.ComputeDiffRecursive(c + 1, t, d + 1, i, s), this.ConcatenateChanges(u, f);
    }
    return [
      new du(e, t - e + 1, n, i - n + 1)
    ];
  }
  WALKTRACE(e, t, n, i, s, o, a, l, c, d, u, f, p, g, m, A, w, v) {
    let y = null, _ = null, S = new w5e(), D = t, M = n, L = p[0] - A[0] - i, T = -1073741824, B = this.m_forwardHistory.length - 1;
    do {
      const V = L + e;
      V === D || V < M && c[V - 1] < c[V + 1] ? (u = c[V + 1], g = u - L - i, u < T && S.MarkNextChange(), T = u, S.AddModifiedElement(u + 1, g), L = V + 1 - e) : (u = c[V - 1] + 1, g = u - L - i, u < T && S.MarkNextChange(), T = u - 1, S.AddOriginalElement(u, g + 1), L = V - 1 - e), B >= 0 && (c = this.m_forwardHistory[B], e = c[0], D = 1, M = c.length - 1);
    } while (--B >= -1);
    if (y = S.getReverseChanges(), v[0]) {
      let V = p[0] + 1, N = A[0] + 1;
      if (y !== null && y.length > 0) {
        const R = y[y.length - 1];
        V = Math.max(V, R.getOriginalEnd()), N = Math.max(N, R.getModifiedEnd());
      }
      _ = [
        new du(V, f - V + 1, N, m - N + 1)
      ];
    } else {
      S = new w5e(), D = o, M = a, L = p[0] - A[0] - l, T = 1073741824, B = w ? this.m_reverseHistory.length - 1 : this.m_reverseHistory.length - 2;
      do {
        const V = L + s;
        V === D || V < M && d[V - 1] >= d[V + 1] ? (u = d[V + 1] - 1, g = u - L - l, u > T && S.MarkNextChange(), T = u + 1, S.AddOriginalElement(u + 1, g + 1), L = V + 1 - s) : (u = d[V - 1], g = u - L - l, u > T && S.MarkNextChange(), T = u, S.AddModifiedElement(u + 1, g + 1), L = V - 1 - s), B >= 0 && (d = this.m_reverseHistory[B], s = d[0], D = 1, M = d.length - 1);
      } while (--B >= -1);
      _ = S.getChanges();
    }
    return this.ConcatenateChanges(y, _);
  }
  /**
   * Given the range to compute the diff on, this method finds the point:
   * (midOriginal, midModified)
   * that exists in the middle of the LCS of the two sequences and
   * is the point at which the LCS problem may be broken down recursively.
   * This method will try to keep the LCS trace in memory. If the LCS recursion
   * point is calculated and the full trace is available in memory, then this method
   * will return the change list.
   * @param originalStart The start bound of the original sequence range
   * @param originalEnd The end bound of the original sequence range
   * @param modifiedStart The start bound of the modified sequence range
   * @param modifiedEnd The end bound of the modified sequence range
   * @param midOriginal The middle point of the original sequence range
   * @param midModified The middle point of the modified sequence range
   * @returns The diff changes, if available, otherwise null
   */
  ComputeRecursionPoint(e, t, n, i, s, o, a) {
    let l = 0, c = 0, d = 0, u = 0, f = 0, p = 0;
    e--, n--, s[0] = 0, o[0] = 0, this.m_forwardHistory = [], this.m_reverseHistory = [];
    const g = t - e + (i - n), m = g + 1, A = new Int32Array(m), w = new Int32Array(m), v = i - n, y = t - e, _ = e - n, S = t - i, M = (y - v) % 2 === 0;
    A[v] = e, w[y] = t, a[0] = !1;
    for (let L = 1; L <= g / 2 + 1; L++) {
      let T = 0, B = 0;
      d = this.ClipDiagonalBound(v - L, L, v, m), u = this.ClipDiagonalBound(v + L, L, v, m);
      for (let N = d; N <= u; N += 2) {
        N === d || N < u && A[N - 1] < A[N + 1] ? l = A[N + 1] : l = A[N - 1] + 1, c = l - (N - v) - _;
        const R = l;
        for (; l < t && c < i && this.ElementsAreEqual(l + 1, c + 1); )
          l++, c++;
        if (A[N] = l, l + c > T + B && (T = l, B = c), !M && Math.abs(N - y) <= L - 1 && l >= w[N])
          return s[0] = l, o[0] = c, R <= w[N] && L <= 1448 ? this.WALKTRACE(v, d, u, _, y, f, p, S, A, w, l, t, s, c, i, o, M, a) : null;
      }
      const V = (T - e + (B - n) - L) / 2;
      if (this.ContinueProcessingPredicate !== null && !this.ContinueProcessingPredicate(T, V))
        return a[0] = !0, s[0] = T, o[0] = B, V > 0 && L <= 1448 ? this.WALKTRACE(v, d, u, _, y, f, p, S, A, w, l, t, s, c, i, o, M, a) : (e++, n++, [
          new du(e, t - e + 1, n, i - n + 1)
        ]);
      f = this.ClipDiagonalBound(y - L, L, y, m), p = this.ClipDiagonalBound(y + L, L, y, m);
      for (let N = f; N <= p; N += 2) {
        N === f || N < p && w[N - 1] >= w[N + 1] ? l = w[N + 1] - 1 : l = w[N - 1], c = l - (N - y) - S;
        const R = l;
        for (; l > e && c > n && this.ElementsAreEqual(l, c); )
          l--, c--;
        if (w[N] = l, M && Math.abs(N - v) <= L && l <= A[N])
          return s[0] = l, o[0] = c, R >= A[N] && L <= 1448 ? this.WALKTRACE(v, d, u, _, y, f, p, S, A, w, l, t, s, c, i, o, M, a) : null;
      }
      if (L <= 1447) {
        let N = new Int32Array(u - d + 2);
        N[0] = v - d + 1, C2.Copy2(A, d, N, 1, u - d + 1), this.m_forwardHistory.push(N), N = new Int32Array(p - f + 2), N[0] = y - f + 1, C2.Copy2(w, f, N, 1, p - f + 1), this.m_reverseHistory.push(N);
      }
    }
    return this.WALKTRACE(v, d, u, _, y, f, p, S, A, w, l, t, s, c, i, o, M, a);
  }
  /**
   * Shifts the given changes to provide a more intuitive diff.
   * While the first element in a diff matches the first element after the diff,
   * we shift the diff down.
   *
   * @param changes The list of changes to shift
   * @returns The shifted changes
   */
  PrettifyChanges(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t], i = t < e.length - 1 ? e[t + 1].originalStart : this._originalElementsOrHash.length, s = t < e.length - 1 ? e[t + 1].modifiedStart : this._modifiedElementsOrHash.length, o = n.originalLength > 0, a = n.modifiedLength > 0;
      for (; n.originalStart + n.originalLength < i && n.modifiedStart + n.modifiedLength < s && (!o || this.OriginalElementsAreEqual(n.originalStart, n.originalStart + n.originalLength)) && (!a || this.ModifiedElementsAreEqual(n.modifiedStart, n.modifiedStart + n.modifiedLength)); ) {
        const c = this.ElementsAreStrictEqual(n.originalStart, n.modifiedStart);
        if (this.ElementsAreStrictEqual(n.originalStart + n.originalLength, n.modifiedStart + n.modifiedLength) && !c)
          break;
        n.originalStart++, n.modifiedStart++;
      }
      const l = [null];
      if (t < e.length - 1 && this.ChangesOverlap(e[t], e[t + 1], l)) {
        e[t] = l[0], e.splice(t + 1, 1), t--;
        continue;
      }
    }
    for (let t = e.length - 1; t >= 0; t--) {
      const n = e[t];
      let i = 0, s = 0;
      if (t > 0) {
        const u = e[t - 1];
        i = u.originalStart + u.originalLength, s = u.modifiedStart + u.modifiedLength;
      }
      const o = n.originalLength > 0, a = n.modifiedLength > 0;
      let l = 0, c = this._boundaryScore(n.originalStart, n.originalLength, n.modifiedStart, n.modifiedLength);
      for (let u = 1; ; u++) {
        const f = n.originalStart - u, p = n.modifiedStart - u;
        if (f < i || p < s || o && !this.OriginalElementsAreEqual(f, f + n.originalLength) || a && !this.ModifiedElementsAreEqual(p, p + n.modifiedLength))
          break;
        const m = (f === i && p === s ? 5 : 0) + this._boundaryScore(f, n.originalLength, p, n.modifiedLength);
        m > c && (c = m, l = u);
      }
      n.originalStart -= l, n.modifiedStart -= l;
      const d = [null];
      if (t > 0 && this.ChangesOverlap(e[t - 1], e[t], d)) {
        e[t - 1] = d[0], e.splice(t, 1), t++;
        continue;
      }
    }
    if (this._hasStrings)
      for (let t = 1, n = e.length; t < n; t++) {
        const i = e[t - 1], s = e[t], o = s.originalStart - i.originalStart - i.originalLength, a = i.originalStart, l = s.originalStart + s.originalLength, c = l - a, d = i.modifiedStart, u = s.modifiedStart + s.modifiedLength, f = u - d;
        if (o < 5 && c < 20 && f < 20) {
          const p = this._findBetterContiguousSequence(a, c, d, f, o);
          if (p) {
            const [g, m] = p;
            (g !== i.originalStart + i.originalLength || m !== i.modifiedStart + i.modifiedLength) && (i.originalLength = g - i.originalStart, i.modifiedLength = m - i.modifiedStart, s.originalStart = g + o, s.modifiedStart = m + o, s.originalLength = l - s.originalStart, s.modifiedLength = u - s.modifiedStart);
          }
        }
      }
    return e;
  }
  _findBetterContiguousSequence(e, t, n, i, s) {
    if (t < s || i < s)
      return null;
    const o = e + t - s + 1, a = n + i - s + 1;
    let l = 0, c = 0, d = 0;
    for (let u = e; u < o; u++)
      for (let f = n; f < a; f++) {
        const p = this._contiguousSequenceScore(u, f, s);
        p > 0 && p > l && (l = p, c = u, d = f);
      }
    return l > 0 ? [c, d] : null;
  }
  _contiguousSequenceScore(e, t, n) {
    let i = 0;
    for (let s = 0; s < n; s++) {
      if (!this.ElementsAreEqual(e + s, t + s))
        return 0;
      i += this._originalStringElements[e + s].length;
    }
    return i;
  }
  _OriginalIsBoundary(e) {
    return e <= 0 || e >= this._originalElementsOrHash.length - 1 ? !0 : this._hasStrings && /^\s*$/.test(this._originalStringElements[e]);
  }
  _OriginalRegionIsBoundary(e, t) {
    if (this._OriginalIsBoundary(e) || this._OriginalIsBoundary(e - 1))
      return !0;
    if (t > 0) {
      const n = e + t;
      if (this._OriginalIsBoundary(n - 1) || this._OriginalIsBoundary(n))
        return !0;
    }
    return !1;
  }
  _ModifiedIsBoundary(e) {
    return e <= 0 || e >= this._modifiedElementsOrHash.length - 1 ? !0 : this._hasStrings && /^\s*$/.test(this._modifiedStringElements[e]);
  }
  _ModifiedRegionIsBoundary(e, t) {
    if (this._ModifiedIsBoundary(e) || this._ModifiedIsBoundary(e - 1))
      return !0;
    if (t > 0) {
      const n = e + t;
      if (this._ModifiedIsBoundary(n - 1) || this._ModifiedIsBoundary(n))
        return !0;
    }
    return !1;
  }
  _boundaryScore(e, t, n, i) {
    const s = this._OriginalRegionIsBoundary(e, t) ? 1 : 0, o = this._ModifiedRegionIsBoundary(n, i) ? 1 : 0;
    return s + o;
  }
  /**
   * Concatenates the two input DiffChange lists and returns the resulting
   * list.
   * @param The left changes
   * @param The right changes
   * @returns The concatenated list
   */
  ConcatenateChanges(e, t) {
    const n = [];
    if (e.length === 0 || t.length === 0)
      return t.length > 0 ? t : e;
    if (this.ChangesOverlap(e[e.length - 1], t[0], n)) {
      const i = new Array(e.length + t.length - 1);
      return C2.Copy(e, 0, i, 0, e.length - 1), i[e.length - 1] = n[0], C2.Copy(t, 1, i, e.length, t.length - 1), i;
    } else {
      const i = new Array(e.length + t.length);
      return C2.Copy(e, 0, i, 0, e.length), C2.Copy(t, 0, i, e.length, t.length), i;
    }
  }
  /**
   * Returns true if the two changes overlap and can be merged into a single
   * change
   * @param left The left change
   * @param right The right change
   * @param mergedChange The merged change if the two overlap, null otherwise
   * @returns True if the two changes overlap
   */
  ChangesOverlap(e, t, n) {
    if (y2.Assert(e.originalStart <= t.originalStart, "Left change is not less than or equal to right change"), y2.Assert(e.modifiedStart <= t.modifiedStart, "Left change is not less than or equal to right change"), e.originalStart + e.originalLength >= t.originalStart || e.modifiedStart + e.modifiedLength >= t.modifiedStart) {
      const i = e.originalStart;
      let s = e.originalLength;
      const o = e.modifiedStart;
      let a = e.modifiedLength;
      return e.originalStart + e.originalLength >= t.originalStart && (s = t.originalStart + t.originalLength - e.originalStart), e.modifiedStart + e.modifiedLength >= t.modifiedStart && (a = t.modifiedStart + t.modifiedLength - e.modifiedStart), n[0] = new du(i, s, o, a), !0;
    } else
      return n[0] = null, !1;
  }
  /**
   * Helper method used to clip a diagonal index to the range of valid
   * diagonals. This also decides whether or not the diagonal index,
   * if it exceeds the boundary, should be clipped to the boundary or clipped
   * one inside the boundary depending on the Even/Odd status of the boundary
   * and numDifferences.
   * @param diagonal The index of the diagonal to clip.
   * @param numDifferences The current number of differences being iterated upon.
   * @param diagonalBaseIndex The base reference diagonal.
   * @param numDiagonals The total number of diagonals.
   * @returns The clipped diagonal index.
   */
  ClipDiagonalBound(e, t, n, i) {
    if (e >= 0 && e < i)
      return e;
    const s = n, o = i - n - 1, a = t % 2 === 0;
    if (e < 0) {
      const l = s % 2 === 0;
      return a === l ? 0 : 1;
    } else {
      const l = o % 2 === 0;
      return a === l ? i - 1 : i - 2;
    }
  }
}
function U8(r) {
  return r < 0 ? 0 : r > 255 ? 255 : r | 0;
}
function E2(r) {
  return r < 0 ? 0 : r > 4294967295 ? 4294967295 : r | 0;
}
class bpt {
  constructor(e) {
    this.values = e, this.prefixSum = new Uint32Array(e.length), this.prefixSumValidIndex = new Int32Array(1), this.prefixSumValidIndex[0] = -1;
  }
  insertValues(e, t) {
    e = E2(e);
    const n = this.values, i = this.prefixSum, s = t.length;
    return s === 0 ? !1 : (this.values = new Uint32Array(n.length + s), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e), e + s), this.values.set(t, e), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSum = new Uint32Array(this.values.length), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(i.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  setValue(e, t) {
    return e = E2(e), t = E2(t), this.values[e] === t ? !1 : (this.values[e] = t, e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), !0);
  }
  removeValues(e, t) {
    e = E2(e), t = E2(t);
    const n = this.values, i = this.prefixSum;
    if (e >= n.length)
      return !1;
    const s = n.length - e;
    return t >= s && (t = s), t === 0 ? !1 : (this.values = new Uint32Array(n.length - t), this.values.set(n.subarray(0, e), 0), this.values.set(n.subarray(e + t), e), this.prefixSum = new Uint32Array(this.values.length), e - 1 < this.prefixSumValidIndex[0] && (this.prefixSumValidIndex[0] = e - 1), this.prefixSumValidIndex[0] >= 0 && this.prefixSum.set(i.subarray(0, this.prefixSumValidIndex[0] + 1)), !0);
  }
  getTotalSum() {
    return this.values.length === 0 ? 0 : this._getPrefixSum(this.values.length - 1);
  }
  /**
   * Returns the sum of the first `index + 1` many items.
   * @returns `SUM(0 <= j <= index, values[j])`.
   */
  getPrefixSum(e) {
    return e < 0 ? 0 : (e = E2(e), this._getPrefixSum(e));
  }
  _getPrefixSum(e) {
    if (e <= this.prefixSumValidIndex[0])
      return this.prefixSum[e];
    let t = this.prefixSumValidIndex[0] + 1;
    t === 0 && (this.prefixSum[0] = this.values[0], t++), e >= this.values.length && (e = this.values.length - 1);
    for (let n = t; n <= e; n++)
      this.prefixSum[n] = this.prefixSum[n - 1] + this.values[n];
    return this.prefixSumValidIndex[0] = Math.max(this.prefixSumValidIndex[0], e), this.prefixSum[e];
  }
  getIndexOf(e) {
    e = Math.floor(e), this.getTotalSum();
    let t = 0, n = this.values.length - 1, i = 0, s = 0, o = 0;
    for (; t <= n; )
      if (i = t + (n - t) / 2 | 0, s = this.prefixSum[i], o = s - this.values[i], e < o)
        n = i - 1;
      else if (e >= s)
        t = i + 1;
      else
        break;
    return new rLe(i, e - o);
  }
}
class ypt {
  constructor(e) {
    this._values = e, this._isValid = !1, this._validEndIndex = -1, this._prefixSum = [], this._indexBySum = [];
  }
  /**
   * @returns SUM(0 <= j < values.length, values[j])
   */
  getTotalSum() {
    return this._ensureValid(), this._indexBySum.length;
  }
  /**
   * Returns the sum of the first `count` many items.
   * @returns `SUM(0 <= j < count, values[j])`.
   */
  getPrefixSum(e) {
    return this._ensureValid(), e === 0 ? 0 : this._prefixSum[e - 1];
  }
  /**
   * @returns `result`, such that `getPrefixSum(result.index) + result.remainder = sum`
   */
  getIndexOf(e) {
    this._ensureValid();
    const t = this._indexBySum[e], n = t > 0 ? this._prefixSum[t - 1] : 0;
    return new rLe(t, e - n);
  }
  removeValues(e, t) {
    this._values.splice(e, t), this._invalidate(e);
  }
  insertValues(e, t) {
    this._values = N7(this._values, e, t), this._invalidate(e);
  }
  _invalidate(e) {
    this._isValid = !1, this._validEndIndex = Math.min(this._validEndIndex, e - 1);
  }
  _ensureValid() {
    if (!this._isValid) {
      for (let e = this._validEndIndex + 1, t = this._values.length; e < t; e++) {
        const n = this._values[e], i = e > 0 ? this._prefixSum[e - 1] : 0;
        this._prefixSum[e] = i + n;
        for (let s = 0; s < n; s++)
          this._indexBySum[i + s] = e;
      }
      this._prefixSum.length = this._values.length, this._indexBySum.length = this._prefixSum[this._prefixSum.length - 1], this._isValid = !0, this._validEndIndex = this._values.length - 1;
    }
  }
  setValue(e, t) {
    this._values[e] !== t && (this._values[e] = t, this._invalidate(e));
  }
}
class rLe {
  constructor(e, t) {
    this.index = e, this.remainder = t, this._prefixSumIndexOfResultBrand = void 0, this.index = e, this.remainder = t;
  }
}
class Cpt {
  constructor(e, t, n, i) {
    this._uri = e, this._lines = t, this._eol = n, this._versionId = i, this._lineStarts = null, this._cachedTextValue = null;
  }
  dispose() {
    this._lines.length = 0;
  }
  get version() {
    return this._versionId;
  }
  getText() {
    return this._cachedTextValue === null && (this._cachedTextValue = this._lines.join(this._eol)), this._cachedTextValue;
  }
  onEvents(e) {
    e.eol && e.eol !== this._eol && (this._eol = e.eol, this._lineStarts = null);
    const t = e.changes;
    for (const n of t)
      this._acceptDeleteRange(n.range), this._acceptInsertText(new le(n.range.startLineNumber, n.range.startColumn), n.text);
    this._versionId = e.versionId, this._cachedTextValue = null;
  }
  _ensureLineStarts() {
    if (!this._lineStarts) {
      const e = this._eol.length, t = this._lines.length, n = new Uint32Array(t);
      for (let i = 0; i < t; i++)
        n[i] = this._lines[i].length + e;
      this._lineStarts = new bpt(n);
    }
  }
  /**
   * All changes to a line's text go through this method
   */
  _setLineText(e, t) {
    this._lines[e] = t, this._lineStarts && this._lineStarts.setValue(e, this._lines[e].length + this._eol.length);
  }
  _acceptDeleteRange(e) {
    if (e.startLineNumber === e.endLineNumber) {
      if (e.startColumn === e.endColumn)
        return;
      this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.startLineNumber - 1].substring(e.endColumn - 1));
      return;
    }
    this._setLineText(e.startLineNumber - 1, this._lines[e.startLineNumber - 1].substring(0, e.startColumn - 1) + this._lines[e.endLineNumber - 1].substring(e.endColumn - 1)), this._lines.splice(e.startLineNumber, e.endLineNumber - e.startLineNumber), this._lineStarts && this._lineStarts.removeValues(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t) {
    if (t.length === 0)
      return;
    const n = $g(t);
    if (n.length === 1) {
      this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0] + this._lines[e.lineNumber - 1].substring(e.column - 1));
      return;
    }
    n[n.length - 1] += this._lines[e.lineNumber - 1].substring(e.column - 1), this._setLineText(e.lineNumber - 1, this._lines[e.lineNumber - 1].substring(0, e.column - 1) + n[0]);
    const i = new Uint32Array(n.length - 1);
    for (let s = 1; s < n.length; s++)
      this._lines.splice(e.lineNumber + s - 1, 0, n[s]), i[s - 1] = n[s].length + this._eol.length;
    this._lineStarts && this._lineStarts.insertValues(e.lineNumber, i);
  }
}
class Ew {
  constructor(e) {
    const t = U8(e);
    this._defaultValue = t, this._asciiMap = Ew._createAsciiMap(t), this._map = /* @__PURE__ */ new Map();
  }
  static _createAsciiMap(e) {
    const t = new Uint8Array(256);
    return t.fill(e), t;
  }
  set(e, t) {
    const n = U8(t);
    e >= 0 && e < 256 ? this._asciiMap[e] = n : this._map.set(e, n);
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : this._map.get(e) || this._defaultValue;
  }
  clear() {
    this._asciiMap.fill(this._defaultValue), this._map.clear();
  }
}
class Ept {
  constructor(e, t, n) {
    const i = new Uint8Array(e * t);
    for (let s = 0, o = e * t; s < o; s++)
      i[s] = n;
    this._data = i, this.rows = e, this.cols = t;
  }
  get(e, t) {
    return this._data[e * this.cols + t];
  }
  set(e, t, n) {
    this._data[e * this.cols + t] = n;
  }
}
class _pt {
  constructor(e) {
    let t = 0, n = 0;
    for (let s = 0, o = e.length; s < o; s++) {
      const [a, l, c] = e[s];
      l > t && (t = l), a > n && (n = a), c > n && (n = c);
    }
    t++, n++;
    const i = new Ept(
      n,
      t,
      0
      /* State.Invalid */
    );
    for (let s = 0, o = e.length; s < o; s++) {
      const [a, l, c] = e[s];
      i.set(a, l, c);
    }
    this._states = i, this._maxCharCode = t;
  }
  nextState(e, t) {
    return t < 0 || t >= this._maxCharCode ? 0 : this._states.get(e, t);
  }
}
let BE = null;
function xpt() {
  return BE === null && (BE = new _pt([
    [
      1,
      104,
      2
      /* State.H */
    ],
    [
      1,
      72,
      2
      /* State.H */
    ],
    [
      1,
      102,
      6
      /* State.F */
    ],
    [
      1,
      70,
      6
      /* State.F */
    ],
    [
      2,
      116,
      3
      /* State.HT */
    ],
    [
      2,
      84,
      3
      /* State.HT */
    ],
    [
      3,
      116,
      4
      /* State.HTT */
    ],
    [
      3,
      84,
      4
      /* State.HTT */
    ],
    [
      4,
      112,
      5
      /* State.HTTP */
    ],
    [
      4,
      80,
      5
      /* State.HTTP */
    ],
    [
      5,
      115,
      9
      /* State.BeforeColon */
    ],
    [
      5,
      83,
      9
      /* State.BeforeColon */
    ],
    [
      5,
      58,
      10
      /* State.AfterColon */
    ],
    [
      6,
      105,
      7
      /* State.FI */
    ],
    [
      6,
      73,
      7
      /* State.FI */
    ],
    [
      7,
      108,
      8
      /* State.FIL */
    ],
    [
      7,
      76,
      8
      /* State.FIL */
    ],
    [
      8,
      101,
      9
      /* State.BeforeColon */
    ],
    [
      8,
      69,
      9
      /* State.BeforeColon */
    ],
    [
      9,
      58,
      10
      /* State.AfterColon */
    ],
    [
      10,
      47,
      11
      /* State.AlmostThere */
    ],
    [
      11,
      47,
      12
      /* State.End */
    ]
  ])), BE;
}
let Im = null;
function Spt() {
  if (Im === null) {
    Im = new Ew(
      0
      /* CharacterClass.None */
    );
    const r = ` 	<>'"、。｡､，．：；‘〈「『〔（［｛｢｣｝］）〕』」〉’｀～…`;
    for (let t = 0; t < r.length; t++)
      Im.set(
        r.charCodeAt(t),
        1
        /* CharacterClass.ForceTermination */
      );
    const e = ".,;:";
    for (let t = 0; t < e.length; t++)
      Im.set(
        e.charCodeAt(t),
        2
        /* CharacterClass.CannotEndIn */
      );
  }
  return Im;
}
class q8 {
  static _createLink(e, t, n, i, s) {
    let o = s - 1;
    do {
      const a = t.charCodeAt(o);
      if (e.get(a) !== 2)
        break;
      o--;
    } while (o > i);
    if (i > 0) {
      const a = t.charCodeAt(i - 1), l = t.charCodeAt(o);
      (a === 40 && l === 41 || a === 91 && l === 93 || a === 123 && l === 125) && o--;
    }
    return {
      range: {
        startLineNumber: n,
        startColumn: i + 1,
        endLineNumber: n,
        endColumn: o + 2
      },
      url: t.substring(i, o + 1)
    };
  }
  static computeLinks(e, t = xpt()) {
    const n = Spt(), i = [];
    for (let s = 1, o = e.getLineCount(); s <= o; s++) {
      const a = e.getLineContent(s), l = a.length;
      let c = 0, d = 0, u = 0, f = 1, p = !1, g = !1, m = !1, A = !1;
      for (; c < l; ) {
        let w = !1;
        const v = a.charCodeAt(c);
        if (f === 13) {
          let y;
          switch (v) {
            case 40:
              p = !0, y = 0;
              break;
            case 41:
              y = p ? 0 : 1;
              break;
            case 91:
              m = !0, g = !0, y = 0;
              break;
            case 93:
              m = !1, y = g ? 0 : 1;
              break;
            case 123:
              A = !0, y = 0;
              break;
            case 125:
              y = A ? 0 : 1;
              break;
            // The following three rules make it that ' or " or ` are allowed inside links
            // only if the link is wrapped by some other quote character
            case 39:
            case 34:
            case 96:
              u === v ? y = 1 : u === 39 || u === 34 || u === 96 ? y = 0 : y = 1;
              break;
            case 42:
              y = u === 42 ? 1 : 0;
              break;
            case 124:
              y = u === 124 ? 1 : 0;
              break;
            case 32:
              y = m ? 0 : 1;
              break;
            default:
              y = n.get(v);
          }
          y === 1 && (i.push(q8._createLink(n, a, s, d, c)), w = !0);
        } else if (f === 12) {
          let y;
          v === 91 ? (g = !0, y = 0) : y = n.get(v), y === 1 ? w = !0 : f = 13;
        } else
          f = t.nextState(f, v), f === 0 && (w = !0);
        w && (f = 1, p = !1, g = !1, A = !1, d = c + 1, u = v), c++;
      }
      f === 13 && i.push(q8._createLink(n, a, s, d, l));
    }
    return i;
  }
}
function Mpt(r) {
  return !r || typeof r.getLineCount != "function" || typeof r.getLineContent != "function" ? [] : q8.computeLinks(r);
}
class aO {
  constructor() {
    this._defaultValueSet = [
      ["true", "false"],
      ["True", "False"],
      ["Private", "Public", "Friend", "ReadOnly", "Partial", "Protected", "WriteOnly"],
      ["public", "protected", "private"]
    ];
  }
  static {
    this.INSTANCE = new aO();
  }
  navigateValueSet(e, t, n, i, s) {
    if (e && t) {
      const o = this.doNavigateValueSet(t, s);
      if (o)
        return {
          range: e,
          value: o
        };
    }
    if (n && i) {
      const o = this.doNavigateValueSet(i, s);
      if (o)
        return {
          range: n,
          value: o
        };
    }
    return null;
  }
  doNavigateValueSet(e, t) {
    const n = this.numberReplace(e, t);
    return n !== null ? n : this.textReplace(e, t);
  }
  numberReplace(e, t) {
    const n = Math.pow(10, e.length - (e.lastIndexOf(".") + 1));
    let i = Number(e);
    const s = parseFloat(e);
    return !isNaN(i) && !isNaN(s) && i === s ? i === 0 && !t ? null : (i = Math.floor(i * n), i += t ? n : -n, String(i / n)) : null;
  }
  textReplace(e, t) {
    return this.valueSetsReplace(this._defaultValueSet, e, t);
  }
  valueSetsReplace(e, t, n) {
    let i = null;
    for (let s = 0, o = e.length; i === null && s < o; s++)
      i = this.valueSetReplace(e[s], t, n);
    return i;
  }
  valueSetReplace(e, t, n) {
    let i = e.indexOf(t);
    return i >= 0 ? (i += n ? 1 : -1, i < 0 ? i = e.length - 1 : i %= e.length, e[i]) : null;
  }
}
var v5e, b5e;
class Dpt {
  constructor(e, t) {
    this.uri = e, this.value = t;
  }
}
function Lpt(r) {
  return Array.isArray(r);
}
class ws {
  static {
    this.defaultToKey = (e) => e.toString();
  }
  constructor(e, t) {
    if (this[v5e] = "ResourceMap", e instanceof ws)
      this.map = new Map(e.map), this.toKey = t ?? ws.defaultToKey;
    else if (Lpt(e)) {
      this.map = /* @__PURE__ */ new Map(), this.toKey = t ?? ws.defaultToKey;
      for (const [n, i] of e)
        this.set(n, i);
    } else
      this.map = /* @__PURE__ */ new Map(), this.toKey = e ?? ws.defaultToKey;
  }
  set(e, t) {
    return this.map.set(this.toKey(e), new Dpt(e, t)), this;
  }
  get(e) {
    return this.map.get(this.toKey(e))?.value;
  }
  has(e) {
    return this.map.has(this.toKey(e));
  }
  get size() {
    return this.map.size;
  }
  clear() {
    this.map.clear();
  }
  delete(e) {
    return this.map.delete(this.toKey(e));
  }
  forEach(e, t) {
    typeof t < "u" && (e = e.bind(t));
    for (const [n, i] of this.map)
      e(i.value, i.uri, this);
  }
  *values() {
    for (const e of this.map.values())
      yield e.value;
  }
  *keys() {
    for (const e of this.map.values())
      yield e.uri;
  }
  *entries() {
    for (const e of this.map.values())
      yield [e.uri, e.value];
  }
  *[(v5e = Symbol.toStringTag, Symbol.iterator)]() {
    for (const [, e] of this.map)
      yield [e.uri, e.value];
  }
}
class kpt {
  constructor() {
    this[b5e] = "LinkedMap", this._map = /* @__PURE__ */ new Map(), this._head = void 0, this._tail = void 0, this._size = 0, this._state = 0;
  }
  clear() {
    this._map.clear(), this._head = void 0, this._tail = void 0, this._size = 0, this._state++;
  }
  isEmpty() {
    return !this._head && !this._tail;
  }
  get size() {
    return this._size;
  }
  get first() {
    return this._head?.value;
  }
  get last() {
    return this._tail?.value;
  }
  has(e) {
    return this._map.has(e);
  }
  get(e, t = 0) {
    const n = this._map.get(e);
    if (n)
      return t !== 0 && this.touch(n, t), n.value;
  }
  set(e, t, n = 0) {
    let i = this._map.get(e);
    if (i)
      i.value = t, n !== 0 && this.touch(i, n);
    else {
      switch (i = { key: e, value: t, next: void 0, previous: void 0 }, n) {
        case 0:
          this.addItemLast(i);
          break;
        case 1:
          this.addItemFirst(i);
          break;
        case 2:
          this.addItemLast(i);
          break;
        default:
          this.addItemLast(i);
          break;
      }
      this._map.set(e, i), this._size++;
    }
    return this;
  }
  delete(e) {
    return !!this.remove(e);
  }
  remove(e) {
    const t = this._map.get(e);
    if (t)
      return this._map.delete(e), this.removeItem(t), this._size--, t.value;
  }
  shift() {
    if (!this._head && !this._tail)
      return;
    if (!this._head || !this._tail)
      throw new Error("Invalid list");
    const e = this._head;
    return this._map.delete(e.key), this.removeItem(e), this._size--, e.value;
  }
  forEach(e, t) {
    const n = this._state;
    let i = this._head;
    for (; i; ) {
      if (t ? e.bind(t)(i.value, i.key, this) : e(i.value, i.key, this), this._state !== n)
        throw new Error("LinkedMap got modified during iteration.");
      i = i.next;
    }
  }
  keys() {
    const e = this, t = this._state;
    let n = this._head;
    const i = {
      [Symbol.iterator]() {
        return i;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: n.key, done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return i;
  }
  values() {
    const e = this, t = this._state;
    let n = this._head;
    const i = {
      [Symbol.iterator]() {
        return i;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: n.value, done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return i;
  }
  entries() {
    const e = this, t = this._state;
    let n = this._head;
    const i = {
      [Symbol.iterator]() {
        return i;
      },
      next() {
        if (e._state !== t)
          throw new Error("LinkedMap got modified during iteration.");
        if (n) {
          const s = { value: [n.key, n.value], done: !1 };
          return n = n.next, s;
        } else
          return { value: void 0, done: !0 };
      }
    };
    return i;
  }
  [(b5e = Symbol.toStringTag, Symbol.iterator)]() {
    return this.entries();
  }
  trimOld(e) {
    if (e >= this.size)
      return;
    if (e === 0) {
      this.clear();
      return;
    }
    let t = this._head, n = this.size;
    for (; t && n > e; )
      this._map.delete(t.key), t = t.next, n--;
    this._head = t, this._size = n, t && (t.previous = void 0), this._state++;
  }
  trimNew(e) {
    if (e >= this.size)
      return;
    if (e === 0) {
      this.clear();
      return;
    }
    let t = this._tail, n = this.size;
    for (; t && n > e; )
      this._map.delete(t.key), t = t.previous, n--;
    this._tail = t, this._size = n, t && (t.next = void 0), this._state++;
  }
  addItemFirst(e) {
    if (!this._head && !this._tail)
      this._tail = e;
    else if (this._head)
      e.next = this._head, this._head.previous = e;
    else
      throw new Error("Invalid list");
    this._head = e, this._state++;
  }
  addItemLast(e) {
    if (!this._head && !this._tail)
      this._head = e;
    else if (this._tail)
      e.previous = this._tail, this._tail.next = e;
    else
      throw new Error("Invalid list");
    this._tail = e, this._state++;
  }
  removeItem(e) {
    if (e === this._head && e === this._tail)
      this._head = void 0, this._tail = void 0;
    else if (e === this._head) {
      if (!e.next)
        throw new Error("Invalid list");
      e.next.previous = void 0, this._head = e.next;
    } else if (e === this._tail) {
      if (!e.previous)
        throw new Error("Invalid list");
      e.previous.next = void 0, this._tail = e.previous;
    } else {
      const t = e.next, n = e.previous;
      if (!t || !n)
        throw new Error("Invalid list");
      t.previous = n, n.next = t;
    }
    e.next = void 0, e.previous = void 0, this._state++;
  }
  touch(e, t) {
    if (!this._head || !this._tail)
      throw new Error("Invalid list");
    if (!(t !== 1 && t !== 2)) {
      if (t === 1) {
        if (e === this._head)
          return;
        const n = e.next, i = e.previous;
        e === this._tail ? (i.next = void 0, this._tail = i) : (n.previous = i, i.next = n), e.previous = void 0, e.next = this._head, this._head.previous = e, this._head = e, this._state++;
      } else if (t === 2) {
        if (e === this._tail)
          return;
        const n = e.next, i = e.previous;
        e === this._head ? (n.previous = void 0, this._head = n) : (n.previous = i, i.next = n), e.next = void 0, e.previous = this._tail, this._tail.next = e, this._tail = e, this._state++;
      }
    }
  }
  toJSON() {
    const e = [];
    return this.forEach((t, n) => {
      e.push([n, t]);
    }), e;
  }
  fromJSON(e) {
    this.clear();
    for (const [t, n] of e)
      this.set(t, n);
  }
}
class Npt extends kpt {
  constructor(e, t = 1) {
    super(), this._limit = e, this._ratio = Math.min(Math.max(0, t), 1);
  }
  get limit() {
    return this._limit;
  }
  set limit(e) {
    this._limit = e, this.checkTrim();
  }
  get(e, t = 2) {
    return super.get(e, t);
  }
  peek(e) {
    return super.get(
      e,
      0
      /* Touch.None */
    );
  }
  set(e, t) {
    return super.set(
      e,
      t,
      2
      /* Touch.AsNew */
    ), this;
  }
  checkTrim() {
    this.size > this._limit && this.trim(Math.round(this._limit * this._ratio));
  }
}
class _w extends Npt {
  constructor(e, t = 1) {
    super(e, t);
  }
  trim(e) {
    this.trimOld(e);
  }
  set(e, t) {
    return super.set(e, t), this.checkTrim(), this;
  }
}
class Tpt {
  constructor(e) {
    if (this._m1 = /* @__PURE__ */ new Map(), this._m2 = /* @__PURE__ */ new Map(), e)
      for (const [t, n] of e)
        this.set(t, n);
  }
  clear() {
    this._m1.clear(), this._m2.clear();
  }
  set(e, t) {
    this._m1.set(e, t), this._m2.set(t, e);
  }
  get(e) {
    return this._m1.get(e);
  }
  getKey(e) {
    return this._m2.get(e);
  }
  delete(e) {
    const t = this._m1.get(e);
    return t === void 0 ? !1 : (this._m1.delete(e), this._m2.delete(t), !0);
  }
  keys() {
    return this._m1.keys();
  }
  values() {
    return this._m1.values();
  }
}
class sLe {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  add(e, t) {
    let n = this.map.get(e);
    n || (n = /* @__PURE__ */ new Set(), this.map.set(e, n)), n.add(t);
  }
  delete(e, t) {
    const n = this.map.get(e);
    n && (n.delete(t), n.size === 0 && this.map.delete(e));
  }
  forEach(e, t) {
    const n = this.map.get(e);
    n && n.forEach(t);
  }
  get(e) {
    const t = this.map.get(e);
    return t || /* @__PURE__ */ new Set();
  }
}
class Ipt extends Ew {
  constructor(e, t) {
    super(
      0
      /* WordCharacterClass.Regular */
    ), this._segmenter = null, this._cachedLine = null, this._cachedSegments = [], this.intlSegmenterLocales = t, this.intlSegmenterLocales.length > 0 ? this._segmenter = new Intl.Segmenter(this.intlSegmenterLocales, { granularity: "word" }) : this._segmenter = null;
    for (let n = 0, i = e.length; n < i; n++)
      this.set(
        e.charCodeAt(n),
        2
        /* WordCharacterClass.WordSeparator */
      );
    this.set(
      32,
      1
      /* WordCharacterClass.Whitespace */
    ), this.set(
      9,
      1
      /* WordCharacterClass.Whitespace */
    );
  }
  findPrevIntlWordBeforeOrAtOffset(e, t) {
    let n = null;
    for (const i of this._getIntlSegmenterWordsOnLine(e)) {
      if (i.index > t)
        break;
      n = i;
    }
    return n;
  }
  findNextIntlWordAtOrAfterOffset(e, t) {
    for (const n of this._getIntlSegmenterWordsOnLine(e))
      if (!(n.index < t))
        return n;
    return null;
  }
  _getIntlSegmenterWordsOnLine(e) {
    return this._segmenter ? this._cachedLine === e ? this._cachedSegments : (this._cachedLine = e, this._cachedSegments = this._filterWordSegments(this._segmenter.segment(e)), this._cachedSegments) : [];
  }
  _filterWordSegments(e) {
    const t = [];
    for (const n of e)
      this._isWordLike(n) && t.push(n);
    return t;
  }
  _isWordLike(e) {
    return !!e.isWordLike;
  }
}
const y5e = new _w(10);
function lg(r, e) {
  const t = `${r}/${e.join(",")}`;
  let n = y5e.get(t);
  return n || (n = new Ipt(r, e), y5e.set(t, n)), n;
}
var Xu;
(function(r) {
  r[r.Left = 1] = "Left", r[r.Center = 2] = "Center", r[r.Right = 4] = "Right", r[r.Full = 7] = "Full";
})(Xu || (Xu = {}));
var h1;
(function(r) {
  r[r.Left = 1] = "Left", r[r.Center = 2] = "Center", r[r.Right = 3] = "Right";
})(h1 || (h1 = {}));
var cg;
(function(r) {
  r[r.Both = 0] = "Both", r[r.Right = 1] = "Right", r[r.Left = 2] = "Left", r[r.None = 3] = "None";
})(cg || (cg = {}));
class w6 {
  get originalIndentSize() {
    return this._indentSizeIsTabSize ? "tabSize" : this.indentSize;
  }
  /**
   * @internal
   */
  constructor(e) {
    this._textModelResolvedOptionsBrand = void 0, this.tabSize = Math.max(1, e.tabSize | 0), e.indentSize === "tabSize" ? (this.indentSize = this.tabSize, this._indentSizeIsTabSize = !0) : (this.indentSize = Math.max(1, e.indentSize | 0), this._indentSizeIsTabSize = !1), this.insertSpaces = !!e.insertSpaces, this.defaultEOL = e.defaultEOL | 0, this.trimAutoWhitespace = !!e.trimAutoWhitespace, this.bracketPairColorizationOptions = e.bracketPairColorizationOptions;
  }
  /**
   * @internal
   */
  equals(e) {
    return this.tabSize === e.tabSize && this._indentSizeIsTabSize === e._indentSizeIsTabSize && this.indentSize === e.indentSize && this.insertSpaces === e.insertSpaces && this.defaultEOL === e.defaultEOL && this.trimAutoWhitespace === e.trimAutoWhitespace && Ho(this.bracketPairColorizationOptions, e.bracketPairColorizationOptions);
  }
  /**
   * @internal
   */
  createChangeEvent(e) {
    return {
      tabSize: this.tabSize !== e.tabSize,
      indentSize: this.indentSize !== e.indentSize,
      insertSpaces: this.insertSpaces !== e.insertSpaces,
      trimAutoWhitespace: this.trimAutoWhitespace !== e.trimAutoWhitespace
    };
  }
}
class z3 {
  /**
   * @internal
   */
  constructor(e, t) {
    this._findMatchBrand = void 0, this.range = e, this.matches = t;
  }
}
function Opt(r) {
  return r && typeof r.read == "function";
}
class PE {
  constructor(e, t, n, i, s, o) {
    this.identifier = e, this.range = t, this.text = n, this.forceMoveMarkers = i, this.isAutoWhitespaceEdit = s, this._isTracked = o;
  }
}
class Rpt {
  constructor(e, t, n) {
    this.regex = e, this.wordSeparators = t, this.simpleSearch = n;
  }
}
class Vpt {
  constructor(e, t, n) {
    this.reverseEdits = e, this.changes = t, this.trimAutoWhitespaceLineNumbers = n;
  }
}
function Hpt(r) {
  return !r.isTooLargeForSyncing() && !r.isForSimpleWidget;
}
const Bpt = 999;
class r0 {
  constructor(e, t, n, i) {
    this.searchString = e, this.isRegex = t, this.matchCase = n, this.wordSeparators = i;
  }
  parseSearchRequest() {
    if (this.searchString === "")
      return null;
    let e;
    this.isRegex ? e = Ppt(this.searchString) : e = this.searchString.indexOf(`
`) >= 0;
    let t = null;
    try {
      t = nDe(this.searchString, this.isRegex, {
        matchCase: this.matchCase,
        wholeWord: !1,
        multiline: e,
        global: !0,
        unicode: !0
      });
    } catch {
      return null;
    }
    if (!t)
      return null;
    let n = !this.isRegex && !e;
    return n && this.searchString.toLowerCase() !== this.searchString.toUpperCase() && (n = this.matchCase), new Rpt(t, this.wordSeparators ? lg(this.wordSeparators, []) : null, n ? this.searchString : null);
  }
}
function Ppt(r) {
  if (!r || r.length === 0)
    return !1;
  for (let e = 0, t = r.length; e < t; e++) {
    const n = r.charCodeAt(e);
    if (n === 10)
      return !0;
    if (n === 92) {
      if (e++, e >= t)
        break;
      const i = r.charCodeAt(e);
      if (i === 110 || i === 114 || i === 87)
        return !0;
    }
  }
  return !1;
}
function p0(r, e, t) {
  if (!t)
    return new z3(r, null);
  const n = [];
  for (let i = 0, s = e.length; i < s; i++)
    n[i] = e[i];
  return new z3(r, n);
}
class C5e {
  constructor(e) {
    const t = [];
    let n = 0;
    for (let i = 0, s = e.length; i < s; i++)
      e.charCodeAt(i) === 10 && (t[n++] = i);
    this._lineFeedsOffsets = t;
  }
  findLineFeedCountBeforeOffset(e) {
    const t = this._lineFeedsOffsets;
    let n = 0, i = t.length - 1;
    if (i === -1 || e <= t[0])
      return 0;
    for (; n < i; ) {
      const s = n + ((i - n) / 2 >> 0);
      t[s] >= e ? i = s - 1 : t[s + 1] >= e ? (n = s, i = s) : n = s + 1;
    }
    return n + 1;
  }
}
class Tv {
  static findMatches(e, t, n, i, s) {
    const o = t.parseSearchRequest();
    return o ? o.regex.multiline ? this._doFindMatchesMultiline(e, n, new Y2(o.wordSeparators, o.regex), i, s) : this._doFindMatchesLineByLine(e, n, o, i, s) : [];
  }
  /**
   * Multiline search always executes on the lines concatenated with \n.
   * We must therefore compensate for the count of \n in case the model is CRLF
   */
  static _getMultilineMatchRange(e, t, n, i, s, o) {
    let a, l = 0;
    i ? (l = i.findLineFeedCountBeforeOffset(s), a = t + s + l) : a = t + s;
    let c;
    if (i) {
      const p = i.findLineFeedCountBeforeOffset(s + o.length) - l;
      c = a + o.length + p;
    } else
      c = a + o.length;
    const d = e.getPositionAt(a), u = e.getPositionAt(c);
    return new Q(d.lineNumber, d.column, u.lineNumber, u.column);
  }
  static _doFindMatchesMultiline(e, t, n, i, s) {
    const o = e.getOffsetAt(t.getStartPosition()), a = e.getValueInRange(
      t,
      1
      /* EndOfLinePreference.LF */
    ), l = e.getEOL() === `\r
` ? new C5e(a) : null, c = [];
    let d = 0, u;
    for (n.reset(0); u = n.next(a); )
      if (c[d++] = p0(this._getMultilineMatchRange(e, o, a, l, u.index, u[0]), u, i), d >= s)
        return c;
    return c;
  }
  static _doFindMatchesLineByLine(e, t, n, i, s) {
    const o = [];
    let a = 0;
    if (t.startLineNumber === t.endLineNumber) {
      const c = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1, t.endColumn - 1);
      return a = this._findMatchesInLine(n, c, t.startLineNumber, t.startColumn - 1, a, o, i, s), o;
    }
    const l = e.getLineContent(t.startLineNumber).substring(t.startColumn - 1);
    a = this._findMatchesInLine(n, l, t.startLineNumber, t.startColumn - 1, a, o, i, s);
    for (let c = t.startLineNumber + 1; c < t.endLineNumber && a < s; c++)
      a = this._findMatchesInLine(n, e.getLineContent(c), c, 0, a, o, i, s);
    if (a < s) {
      const c = e.getLineContent(t.endLineNumber).substring(0, t.endColumn - 1);
      a = this._findMatchesInLine(n, c, t.endLineNumber, 0, a, o, i, s);
    }
    return o;
  }
  static _findMatchesInLine(e, t, n, i, s, o, a, l) {
    const c = e.wordSeparators;
    if (!a && e.simpleSearch) {
      const f = e.simpleSearch, p = f.length, g = t.length;
      let m = -p;
      for (; (m = t.indexOf(f, m + p)) !== -1; )
        if ((!c || lO(c, t, g, m, p)) && (o[s++] = new z3(new Q(n, m + 1 + i, n, m + 1 + p + i), null), s >= l))
          return s;
      return s;
    }
    const d = new Y2(e.wordSeparators, e.regex);
    let u;
    d.reset(0);
    do
      if (u = d.next(t), u && (o[s++] = p0(new Q(n, u.index + 1 + i, n, u.index + 1 + u[0].length + i), u, a), s >= l))
        return s;
    while (u);
    return s;
  }
  static findNextMatch(e, t, n, i) {
    const s = t.parseSearchRequest();
    if (!s)
      return null;
    const o = new Y2(s.wordSeparators, s.regex);
    return s.regex.multiline ? this._doFindNextMatchMultiline(e, n, o, i) : this._doFindNextMatchLineByLine(e, n, o, i);
  }
  static _doFindNextMatchMultiline(e, t, n, i) {
    const s = new le(t.lineNumber, 1), o = e.getOffsetAt(s), a = e.getLineCount(), l = e.getValueInRange(
      new Q(s.lineNumber, s.column, a, e.getLineMaxColumn(a)),
      1
      /* EndOfLinePreference.LF */
    ), c = e.getEOL() === `\r
` ? new C5e(l) : null;
    n.reset(t.column - 1);
    const d = n.next(l);
    return d ? p0(this._getMultilineMatchRange(e, o, l, c, d.index, d[0]), d, i) : t.lineNumber !== 1 || t.column !== 1 ? this._doFindNextMatchMultiline(e, new le(1, 1), n, i) : null;
  }
  static _doFindNextMatchLineByLine(e, t, n, i) {
    const s = e.getLineCount(), o = t.lineNumber, a = e.getLineContent(o), l = this._findFirstMatchInLine(n, a, o, t.column, i);
    if (l)
      return l;
    for (let c = 1; c <= s; c++) {
      const d = (o + c - 1) % s, u = e.getLineContent(d + 1), f = this._findFirstMatchInLine(n, u, d + 1, 1, i);
      if (f)
        return f;
    }
    return null;
  }
  static _findFirstMatchInLine(e, t, n, i, s) {
    e.reset(i - 1);
    const o = e.next(t);
    return o ? p0(new Q(n, o.index + 1, n, o.index + 1 + o[0].length), o, s) : null;
  }
  static findPreviousMatch(e, t, n, i) {
    const s = t.parseSearchRequest();
    if (!s)
      return null;
    const o = new Y2(s.wordSeparators, s.regex);
    return s.regex.multiline ? this._doFindPreviousMatchMultiline(e, n, o, i) : this._doFindPreviousMatchLineByLine(e, n, o, i);
  }
  static _doFindPreviousMatchMultiline(e, t, n, i) {
    const s = this._doFindMatchesMultiline(e, new Q(1, 1, t.lineNumber, t.column), n, i, 10 * Bpt);
    if (s.length > 0)
      return s[s.length - 1];
    const o = e.getLineCount();
    return t.lineNumber !== o || t.column !== e.getLineMaxColumn(o) ? this._doFindPreviousMatchMultiline(e, new le(o, e.getLineMaxColumn(o)), n, i) : null;
  }
  static _doFindPreviousMatchLineByLine(e, t, n, i) {
    const s = e.getLineCount(), o = t.lineNumber, a = e.getLineContent(o).substring(0, t.column - 1), l = this._findLastMatchInLine(n, a, o, i);
    if (l)
      return l;
    for (let c = 1; c <= s; c++) {
      const d = (s + o - c - 1) % s, u = e.getLineContent(d + 1), f = this._findLastMatchInLine(n, u, d + 1, i);
      if (f)
        return f;
    }
    return null;
  }
  static _findLastMatchInLine(e, t, n, i) {
    let s = null, o;
    for (e.reset(0); o = e.next(t); )
      s = p0(new Q(n, o.index + 1, n, o.index + 1 + o[0].length), o, i);
    return s;
  }
}
function Fpt(r, e, t, n, i) {
  if (n === 0)
    return !0;
  const s = e.charCodeAt(n - 1);
  if (r.get(s) !== 0 || s === 13 || s === 10)
    return !0;
  if (i > 0) {
    const o = e.charCodeAt(n);
    if (r.get(o) !== 0)
      return !0;
  }
  return !1;
}
function zpt(r, e, t, n, i) {
  if (n + i === t)
    return !0;
  const s = e.charCodeAt(n + i);
  if (r.get(s) !== 0 || s === 13 || s === 10)
    return !0;
  if (i > 0) {
    const o = e.charCodeAt(n + i - 1);
    if (r.get(o) !== 0)
      return !0;
  }
  return !1;
}
function lO(r, e, t, n, i) {
  return Fpt(r, e, t, n, i) && zpt(r, e, t, n, i);
}
class Y2 {
  constructor(e, t) {
    this._wordSeparators = e, this._searchRegex = t, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  reset(e) {
    this._searchRegex.lastIndex = e, this._prevMatchStartIndex = -1, this._prevMatchLength = 0;
  }
  next(e) {
    const t = e.length;
    let n;
    do {
      if (this._prevMatchStartIndex + this._prevMatchLength === t || (n = this._searchRegex.exec(e), !n))
        return null;
      const i = n.index, s = n[0].length;
      if (i === this._prevMatchStartIndex && s === this._prevMatchLength) {
        if (s === 0) {
          O8(e, t, this._searchRegex.lastIndex) > 65535 ? this._searchRegex.lastIndex += 2 : this._searchRegex.lastIndex += 1;
          continue;
        }
        return null;
      }
      if (this._prevMatchStartIndex = i, this._prevMatchLength = s, !this._wordSeparators || lO(this._wordSeparators, e, t, i, s))
        return n;
    } while (n);
    return null;
  }
}
class Wpt {
  static computeUnicodeHighlights(e, t, n) {
    const i = n ? n.startLineNumber : 1, s = n ? n.endLineNumber : e.getLineCount(), o = new E5e(t), a = o.getCandidateCodePoints();
    let l;
    a === "allNonBasicAscii" ? l = new RegExp("[^\\t\\n\\r\\x20-\\x7E]", "g") : l = new RegExp(`${jpt(Array.from(a))}`, "g");
    const c = new Y2(null, l), d = [];
    let u = !1, f, p = 0, g = 0, m = 0;
    e: for (let A = i, w = s; A <= w; A++) {
      const v = e.getLineContent(A), y = v.length;
      c.reset(0);
      do
        if (f = c.next(v), f) {
          let _ = f.index, S = f.index + f[0].length;
          if (_ > 0) {
            const T = v.charCodeAt(_ - 1);
            Ki(T) && _--;
          }
          if (S + 1 < y) {
            const T = v.charCodeAt(S - 1);
            Ki(T) && S++;
          }
          const D = v.substring(_, S);
          let M = O3(_ + 1, EI, v, 0);
          M && M.endColumn <= _ + 1 && (M = null);
          const L = o.shouldHighlightNonBasicASCII(D, M ? M.word : null);
          if (L !== 0) {
            if (L === 3 ? p++ : L === 2 ? g++ : L === 1 ? m++ : $I(), d.length >= 1e3) {
              u = !0;
              break e;
            }
            d.push(new Q(A, _ + 1, A, S + 1));
          }
        }
      while (f);
    }
    return {
      ranges: d,
      hasMore: u,
      ambiguousCharacterCount: p,
      invisibleCharacterCount: g,
      nonBasicAsciiCharacterCount: m
    };
  }
  static computeUnicodeHighlightReason(e, t) {
    const n = new E5e(t);
    switch (n.shouldHighlightNonBasicASCII(e, null)) {
      case 0:
        return null;
      case 2:
        return {
          kind: 1
          /* UnicodeHighlighterReasonKind.Invisible */
        };
      case 3: {
        const s = e.codePointAt(0), o = n.ambiguousCharacters.getPrimaryConfusable(s), a = Tu.getLocales().filter((l) => !Tu.getInstance(/* @__PURE__ */ new Set([...t.allowedLocales, l])).isAmbiguous(s));
        return { kind: 0, confusableWith: String.fromCodePoint(o), notAmbiguousInLocales: a };
      }
      case 1:
        return {
          kind: 2
          /* UnicodeHighlighterReasonKind.NonBasicAscii */
        };
    }
  }
}
function jpt(r, e) {
  return `[${tc(r.map((n) => String.fromCodePoint(n)).join(""))}]`;
}
class E5e {
  constructor(e) {
    this.options = e, this.allowedCodePoints = new Set(e.allowedCodePoints), this.ambiguousCharacters = Tu.getInstance(new Set(e.allowedLocales));
  }
  getCandidateCodePoints() {
    if (this.options.nonBasicASCII)
      return "allNonBasicAscii";
    const e = /* @__PURE__ */ new Set();
    if (this.options.invisibleCharacters)
      for (const t of Z0.codePoints)
        _5e(String.fromCodePoint(t)) || e.add(t);
    if (this.options.ambiguousCharacters)
      for (const t of this.ambiguousCharacters.getConfusableCodePoints())
        e.add(t);
    for (const t of this.allowedCodePoints)
      e.delete(t);
    return e;
  }
  shouldHighlightNonBasicASCII(e, t) {
    const n = e.codePointAt(0);
    if (this.allowedCodePoints.has(n))
      return 0;
    if (this.options.nonBasicASCII)
      return 1;
    let i = !1, s = !1;
    if (t)
      for (const o of t) {
        const a = o.codePointAt(0), l = BI(o);
        i = i || l, !l && !this.ambiguousCharacters.isAmbiguous(a) && !Z0.isInvisibleCharacter(a) && (s = !0);
      }
    return (
      /* Don't allow mixing weird looking characters with ASCII */
      !i && /* Is there an obviously weird looking character? */
      s ? 0 : this.options.invisibleCharacters && !_5e(e) && Z0.isInvisibleCharacter(n) ? 2 : this.options.ambiguousCharacters && this.ambiguousCharacters.isAmbiguous(n) ? 3 : 0
    );
  }
}
function _5e(r) {
  return r === " " || r === `
` || r === "	";
}
class v6 {
  constructor(e, t, n) {
    this.changes = e, this.moves = t, this.hitTimeout = n;
  }
}
class oLe {
  constructor(e, t) {
    this.lineRangeMapping = e, this.changes = t;
  }
}
class pt {
  static addRange(e, t) {
    let n = 0;
    for (; n < t.length && t[n].endExclusive < e.start; )
      n++;
    let i = n;
    for (; i < t.length && t[i].start <= e.endExclusive; )
      i++;
    if (n === i)
      t.splice(n, 0, e);
    else {
      const s = Math.min(e.start, t[n].start), o = Math.max(e.endExclusive, t[i - 1].endExclusive);
      t.splice(n, i - n, new pt(s, o));
    }
  }
  static tryCreate(e, t) {
    if (!(e > t))
      return new pt(e, t);
  }
  static ofLength(e) {
    return new pt(0, e);
  }
  static ofStartAndLength(e, t) {
    return new pt(e, e + t);
  }
  constructor(e, t) {
    if (this.start = e, this.endExclusive = t, e > t)
      throw new cn(`Invalid range: ${this.toString()}`);
  }
  get isEmpty() {
    return this.start === this.endExclusive;
  }
  delta(e) {
    return new pt(this.start + e, this.endExclusive + e);
  }
  deltaStart(e) {
    return new pt(this.start + e, this.endExclusive);
  }
  deltaEnd(e) {
    return new pt(this.start, this.endExclusive + e);
  }
  get length() {
    return this.endExclusive - this.start;
  }
  toString() {
    return `[${this.start}, ${this.endExclusive})`;
  }
  contains(e) {
    return this.start <= e && e < this.endExclusive;
  }
  /**
   * for all numbers n: range1.contains(n) or range2.contains(n) => range1.join(range2).contains(n)
   * The joined range is the smallest range that contains both ranges.
   */
  join(e) {
    return new pt(Math.min(this.start, e.start), Math.max(this.endExclusive, e.endExclusive));
  }
  /**
   * for all numbers n: range1.contains(n) and range2.contains(n) <=> range1.intersect(range2).contains(n)
   *
   * The resulting range is empty if the ranges do not intersect, but touch.
   * If the ranges don't even touch, the result is undefined.
   */
  intersect(e) {
    const t = Math.max(this.start, e.start), n = Math.min(this.endExclusive, e.endExclusive);
    if (t <= n)
      return new pt(t, n);
  }
  intersects(e) {
    const t = Math.max(this.start, e.start), n = Math.min(this.endExclusive, e.endExclusive);
    return t < n;
  }
  isBefore(e) {
    return this.endExclusive <= e.start;
  }
  isAfter(e) {
    return this.start >= e.endExclusive;
  }
  slice(e) {
    return e.slice(this.start, this.endExclusive);
  }
  substring(e) {
    return e.substring(this.start, this.endExclusive);
  }
  /**
   * Returns the given value if it is contained in this instance, otherwise the closest value that is contained.
   * The range must not be empty.
   */
  clip(e) {
    if (this.isEmpty)
      throw new cn(`Invalid clipping range: ${this.toString()}`);
    return Math.max(this.start, Math.min(this.endExclusive - 1, e));
  }
  /**
   * Returns `r := value + k * length` such that `r` is contained in this range.
   * The range must not be empty.
   *
   * E.g. `[5, 10).clipCyclic(10) === 5`, `[5, 10).clipCyclic(11) === 6` and `[5, 10).clipCyclic(4) === 9`.
   */
  clipCyclic(e) {
    if (this.isEmpty)
      throw new cn(`Invalid clipping range: ${this.toString()}`);
    return e < this.start ? this.endExclusive - (this.start - e) % this.length : e >= this.endExclusive ? this.start + (e - this.start) % this.length : e;
  }
  forEach(e) {
    for (let t = this.start; t < this.endExclusive; t++)
      e(t);
  }
}
class cO {
  constructor() {
    this._sortedRanges = [];
  }
  addRange(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive < e.start; )
      t++;
    let n = t;
    for (; n < this._sortedRanges.length && this._sortedRanges[n].start <= e.endExclusive; )
      n++;
    if (t === n)
      this._sortedRanges.splice(t, 0, e);
    else {
      const i = Math.min(e.start, this._sortedRanges[t].start), s = Math.max(e.endExclusive, this._sortedRanges[n - 1].endExclusive);
      this._sortedRanges.splice(t, n - t, new pt(i, s));
    }
  }
  toString() {
    return this._sortedRanges.map((e) => e.toString()).join(", ");
  }
  /**
   * Returns of there is a value that is contained in this instance and the given range.
   */
  intersectsStrict(e) {
    let t = 0;
    for (; t < this._sortedRanges.length && this._sortedRanges[t].endExclusive <= e.start; )
      t++;
    return t < this._sortedRanges.length && this._sortedRanges[t].start < e.endExclusive;
  }
  intersectWithRange(e) {
    const t = new cO();
    for (const n of this._sortedRanges) {
      const i = n.intersect(e);
      i && t.addRange(i);
    }
    return t;
  }
  intersectWithRangeLength(e) {
    return this.intersectWithRange(e).length;
  }
  get length() {
    return this._sortedRanges.reduce((e, t) => e + t.length, 0);
  }
}
function G8(r, e) {
  const t = Zpt(r, e);
  if (t !== -1)
    return r[t];
}
function Zpt(r, e, t = r.length - 1) {
  for (let n = t; n >= 0; n--) {
    const i = r[n];
    if (e(i))
      return n;
  }
  return -1;
}
function hg(r, e) {
  const t = W3(r, e);
  return t === -1 ? void 0 : r[t];
}
function W3(r, e, t = 0, n = r.length) {
  let i = t, s = n;
  for (; i < s; ) {
    const o = Math.floor((i + s) / 2);
    e(r[o]) ? i = o + 1 : s = o;
  }
  return i - 1;
}
function Upt(r, e) {
  const t = Q8(r, e);
  return t === r.length ? void 0 : r[t];
}
function Q8(r, e, t = 0, n = r.length) {
  let i = t, s = n;
  for (; i < s; ) {
    const o = Math.floor((i + s) / 2);
    e(r[o]) ? s = o : i = o + 1;
  }
  return i;
}
class ty {
  static {
    this.assertInvariants = !1;
  }
  constructor(e) {
    this._array = e, this._findLastMonotonousLastIdx = 0;
  }
  /**
   * The predicate must be monotonous, i.e. `arr.map(predicate)` must be like `[true, ..., true, false, ..., false]`!
   * For subsequent calls, current predicate must be weaker than (or equal to) the previous predicate, i.e. more entries must be `true`.
   */
  findLastMonotonous(e) {
    if (ty.assertInvariants) {
      if (this._prevFindLastPredicate) {
        for (const n of this._array)
          if (this._prevFindLastPredicate(n) && !e(n))
            throw new Error("MonotonousArray: current predicate must be weaker than (or equal to) the previous predicate.");
      }
      this._prevFindLastPredicate = e;
    }
    const t = W3(this._array, e, this._findLastMonotonousLastIdx);
    return this._findLastMonotonousLastIdx = t + 1, t === -1 ? void 0 : this._array[t];
  }
}
function aLe(r, e) {
  if (r.length === 0)
    return;
  let t = r[0];
  for (let n = 1; n < r.length; n++) {
    const i = r[n];
    e(i, t) > 0 && (t = i);
  }
  return t;
}
function qpt(r, e) {
  if (r.length === 0)
    return;
  let t = r[0];
  for (let n = 1; n < r.length; n++) {
    const i = r[n];
    e(i, t) >= 0 && (t = i);
  }
  return t;
}
function Gpt(r, e) {
  return aLe(r, (t, n) => -e(t, n));
}
function Qpt(r, e) {
  if (r.length === 0)
    return -1;
  let t = 0;
  for (let n = 1; n < r.length; n++) {
    const i = r[n];
    e(i, r[t]) > 0 && (t = n);
  }
  return t;
}
let lt = class Zh {
  static fromRangeInclusive(e) {
    return new Zh(e.startLineNumber, e.endLineNumber + 1);
  }
  /**
   * @param lineRanges An array of sorted line ranges.
   */
  static joinMany(e) {
    if (e.length === 0)
      return [];
    let t = new sa(e[0].slice());
    for (let n = 1; n < e.length; n++)
      t = t.getUnion(new sa(e[n].slice()));
    return t.ranges;
  }
  static join(e) {
    if (e.length === 0)
      throw new cn("lineRanges cannot be empty");
    let t = e[0].startLineNumber, n = e[0].endLineNumberExclusive;
    for (let i = 1; i < e.length; i++)
      t = Math.min(t, e[i].startLineNumber), n = Math.max(n, e[i].endLineNumberExclusive);
    return new Zh(t, n);
  }
  static ofLength(e, t) {
    return new Zh(e, e + t);
  }
  /**
   * @internal
   */
  static deserialize(e) {
    return new Zh(e[0], e[1]);
  }
  constructor(e, t) {
    if (e > t)
      throw new cn(`startLineNumber ${e} cannot be after endLineNumberExclusive ${t}`);
    this.startLineNumber = e, this.endLineNumberExclusive = t;
  }
  /**
   * Indicates if this line range contains the given line number.
   */
  contains(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  /**
   * Indicates if this line range is empty.
   */
  get isEmpty() {
    return this.startLineNumber === this.endLineNumberExclusive;
  }
  /**
   * Moves this line range by the given offset of line numbers.
   */
  delta(e) {
    return new Zh(this.startLineNumber + e, this.endLineNumberExclusive + e);
  }
  deltaLength(e) {
    return new Zh(this.startLineNumber, this.endLineNumberExclusive + e);
  }
  /**
   * The number of lines this line range spans.
   */
  get length() {
    return this.endLineNumberExclusive - this.startLineNumber;
  }
  /**
   * Creates a line range that combines this and the given line range.
   */
  join(e) {
    return new Zh(Math.min(this.startLineNumber, e.startLineNumber), Math.max(this.endLineNumberExclusive, e.endLineNumberExclusive));
  }
  toString() {
    return `[${this.startLineNumber},${this.endLineNumberExclusive})`;
  }
  /**
   * The resulting range is empty if the ranges do not intersect, but touch.
   * If the ranges don't even touch, the result is undefined.
   */
  intersect(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumberExclusive, e.endLineNumberExclusive);
    if (t <= n)
      return new Zh(t, n);
  }
  intersectsStrict(e) {
    return this.startLineNumber < e.endLineNumberExclusive && e.startLineNumber < this.endLineNumberExclusive;
  }
  overlapOrTouch(e) {
    return this.startLineNumber <= e.endLineNumberExclusive && e.startLineNumber <= this.endLineNumberExclusive;
  }
  equals(e) {
    return this.startLineNumber === e.startLineNumber && this.endLineNumberExclusive === e.endLineNumberExclusive;
  }
  toInclusiveRange() {
    return this.isEmpty ? null : new Q(this.startLineNumber, 1, this.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER);
  }
  /**
   * @deprecated Using this function is discouraged because it might lead to bugs: The end position is not guaranteed to be a valid position!
  */
  toExclusiveRange() {
    return new Q(this.startLineNumber, 1, this.endLineNumberExclusive, 1);
  }
  mapToLineArray(e) {
    const t = [];
    for (let n = this.startLineNumber; n < this.endLineNumberExclusive; n++)
      t.push(e(n));
    return t;
  }
  forEach(e) {
    for (let t = this.startLineNumber; t < this.endLineNumberExclusive; t++)
      e(t);
  }
  /**
   * @internal
   */
  serialize() {
    return [this.startLineNumber, this.endLineNumberExclusive];
  }
  includes(e) {
    return this.startLineNumber <= e && e < this.endLineNumberExclusive;
  }
  /**
   * Converts this 1-based line range to a 0-based offset range (subtracts 1!).
   * @internal
   */
  toOffsetRange() {
    return new pt(this.startLineNumber - 1, this.endLineNumberExclusive - 1);
  }
};
class sa {
  constructor(e = []) {
    this._normalizedRanges = e;
  }
  get ranges() {
    return this._normalizedRanges;
  }
  addRange(e) {
    if (e.length === 0)
      return;
    const t = Q8(this._normalizedRanges, (i) => i.endLineNumberExclusive >= e.startLineNumber), n = W3(this._normalizedRanges, (i) => i.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n)
      this._normalizedRanges.splice(t, 0, e);
    else if (t === n - 1) {
      const i = this._normalizedRanges[t];
      this._normalizedRanges[t] = i.join(e);
    } else {
      const i = this._normalizedRanges[t].join(this._normalizedRanges[n - 1]).join(e);
      this._normalizedRanges.splice(t, n - t, i);
    }
  }
  contains(e) {
    const t = hg(this._normalizedRanges, (n) => n.startLineNumber <= e);
    return !!t && t.endLineNumberExclusive > e;
  }
  intersects(e) {
    const t = hg(this._normalizedRanges, (n) => n.startLineNumber < e.endLineNumberExclusive);
    return !!t && t.endLineNumberExclusive > e.startLineNumber;
  }
  getUnion(e) {
    if (this._normalizedRanges.length === 0)
      return e;
    if (e._normalizedRanges.length === 0)
      return this;
    const t = [];
    let n = 0, i = 0, s = null;
    for (; n < this._normalizedRanges.length || i < e._normalizedRanges.length; ) {
      let o = null;
      if (n < this._normalizedRanges.length && i < e._normalizedRanges.length) {
        const a = this._normalizedRanges[n], l = e._normalizedRanges[i];
        a.startLineNumber < l.startLineNumber ? (o = a, n++) : (o = l, i++);
      } else n < this._normalizedRanges.length ? (o = this._normalizedRanges[n], n++) : (o = e._normalizedRanges[i], i++);
      s === null ? s = o : s.endLineNumberExclusive >= o.startLineNumber ? s = new lt(s.startLineNumber, Math.max(s.endLineNumberExclusive, o.endLineNumberExclusive)) : (t.push(s), s = o);
    }
    return s !== null && t.push(s), new sa(t);
  }
  /**
   * Subtracts all ranges in this set from `range` and returns the result.
   */
  subtractFrom(e) {
    const t = Q8(this._normalizedRanges, (o) => o.endLineNumberExclusive >= e.startLineNumber), n = W3(this._normalizedRanges, (o) => o.startLineNumber <= e.endLineNumberExclusive) + 1;
    if (t === n)
      return new sa([e]);
    const i = [];
    let s = e.startLineNumber;
    for (let o = t; o < n; o++) {
      const a = this._normalizedRanges[o];
      a.startLineNumber > s && i.push(new lt(s, a.startLineNumber)), s = a.endLineNumberExclusive;
    }
    return s < e.endLineNumberExclusive && i.push(new lt(s, e.endLineNumberExclusive)), new sa(i);
  }
  toString() {
    return this._normalizedRanges.map((e) => e.toString()).join(", ");
  }
  getIntersection(e) {
    const t = [];
    let n = 0, i = 0;
    for (; n < this._normalizedRanges.length && i < e._normalizedRanges.length; ) {
      const s = this._normalizedRanges[n], o = e._normalizedRanges[i], a = s.intersect(o);
      a && !a.isEmpty && t.push(a), s.endLineNumberExclusive < o.endLineNumberExclusive ? n++ : i++;
    }
    return new sa(t);
  }
  getWithDelta(e) {
    return new sa(this._normalizedRanges.map((t) => t.delta(e)));
  }
}
class Xa {
  static {
    this.zero = new Xa(0, 0);
  }
  static betweenPositions(e, t) {
    return e.lineNumber === t.lineNumber ? new Xa(0, t.column - e.column) : new Xa(t.lineNumber - e.lineNumber, t.column - 1);
  }
  static ofRange(e) {
    return Xa.betweenPositions(e.getStartPosition(), e.getEndPosition());
  }
  static ofText(e) {
    let t = 0, n = 0;
    for (const i of e)
      i === `
` ? (t++, n = 0) : n++;
    return new Xa(t, n);
  }
  constructor(e, t) {
    this.lineCount = e, this.columnCount = t;
  }
  isGreaterThanOrEqualTo(e) {
    return this.lineCount !== e.lineCount ? this.lineCount > e.lineCount : this.columnCount >= e.columnCount;
  }
  createRange(e) {
    return this.lineCount === 0 ? new Q(e.lineNumber, e.column, e.lineNumber, e.column + this.columnCount) : new Q(e.lineNumber, e.column, e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  addToPosition(e) {
    return this.lineCount === 0 ? new le(e.lineNumber, e.column + this.columnCount) : new le(e.lineNumber + this.lineCount, this.columnCount + 1);
  }
  toString() {
    return `${this.lineCount},${this.columnCount}`;
  }
}
class Kpt {
  constructor(e) {
    this.text = e, this.lineStartOffsetByLineIdx = [], this.lineStartOffsetByLineIdx.push(0);
    for (let t = 0; t < e.length; t++)
      e.charAt(t) === `
` && this.lineStartOffsetByLineIdx.push(t + 1);
  }
  getOffset(e) {
    return this.lineStartOffsetByLineIdx[e.lineNumber - 1] + e.column - 1;
  }
  getOffsetRange(e) {
    return new pt(this.getOffset(e.getStartPosition()), this.getOffset(e.getEndPosition()));
  }
  get textLength() {
    const e = this.lineStartOffsetByLineIdx.length - 1;
    return new Xa(e, this.text.length - this.lineStartOffsetByLineIdx[e]);
  }
}
class Ypt {
  constructor(e) {
    this.edits = e, vf(() => eO(e, (t, n) => t.range.getEndPosition().isBeforeOrEqual(n.range.getStartPosition())));
  }
  apply(e) {
    let t = "", n = new le(1, 1);
    for (const s of this.edits) {
      const o = s.range, a = o.getStartPosition(), l = o.getEndPosition(), c = x5e(n, a);
      c.isEmpty() || (t += e.getValueOfRange(c)), t += s.text, n = l;
    }
    const i = x5e(n, e.endPositionExclusive);
    return i.isEmpty() || (t += e.getValueOfRange(i)), t;
  }
  applyToString(e) {
    const t = new Jpt(e);
    return this.apply(t);
  }
  getNewRanges() {
    const e = [];
    let t = 0, n = 0, i = 0;
    for (const s of this.edits) {
      const o = Xa.ofText(s.text), a = le.lift({
        lineNumber: s.range.startLineNumber + n,
        column: s.range.startColumn + (s.range.startLineNumber === t ? i : 0)
      }), l = o.createRange(a);
      e.push(l), n = l.endLineNumber - s.range.endLineNumber, i = l.endColumn - s.range.endColumn, t = s.range.endLineNumber;
    }
    return e;
  }
}
class Xpt {
  constructor(e, t) {
    this.range = e, this.text = t;
  }
  toSingleEditOperation() {
    return {
      range: this.range,
      text: this.text
    };
  }
}
function x5e(r, e) {
  if (r.lineNumber === e.lineNumber && r.column === Number.MAX_SAFE_INTEGER)
    return Q.fromPositions(e, e);
  if (!r.isBeforeOrEqual(e))
    throw new cn("start must be before end");
  return new Q(r.lineNumber, r.column, e.lineNumber, e.column);
}
class lLe {
  get endPositionExclusive() {
    return this.length.addToPosition(new le(1, 1));
  }
}
class Jpt extends lLe {
  constructor(e) {
    super(), this.value = e, this._t = new Kpt(this.value);
  }
  getValueOfRange(e) {
    return this._t.getOffsetRange(e).substring(this.value);
  }
  get length() {
    return this._t.textLength;
  }
}
class ns {
  static inverse(e, t, n) {
    const i = [];
    let s = 1, o = 1;
    for (const l of e) {
      const c = new ns(new lt(s, l.original.startLineNumber), new lt(o, l.modified.startLineNumber));
      c.modified.isEmpty || i.push(c), s = l.original.endLineNumberExclusive, o = l.modified.endLineNumberExclusive;
    }
    const a = new ns(new lt(s, t + 1), new lt(o, n + 1));
    return a.modified.isEmpty || i.push(a), i;
  }
  static clip(e, t, n) {
    const i = [];
    for (const s of e) {
      const o = s.original.intersect(t), a = s.modified.intersect(n);
      o && !o.isEmpty && a && !a.isEmpty && i.push(new ns(o, a));
    }
    return i;
  }
  constructor(e, t) {
    this.original = e, this.modified = t;
  }
  toString() {
    return `{${this.original.toString()}->${this.modified.toString()}}`;
  }
  flip() {
    return new ns(this.modified, this.original);
  }
  join(e) {
    return new ns(this.original.join(e.original), this.modified.join(e.modified));
  }
  /**
   * This method assumes that the LineRangeMapping describes a valid diff!
   * I.e. if one range is empty, the other range cannot be the entire document.
   * It avoids various problems when the line range points to non-existing line-numbers.
  */
  toRangeMapping() {
    const e = this.original.toInclusiveRange(), t = this.modified.toInclusiveRange();
    if (e && t)
      return new Eo(e, t);
    if (this.original.startLineNumber === 1 || this.modified.startLineNumber === 1) {
      if (!(this.modified.startLineNumber === 1 && this.original.startLineNumber === 1))
        throw new cn("not a valid diff");
      return new Eo(new Q(this.original.startLineNumber, 1, this.original.endLineNumberExclusive, 1), new Q(this.modified.startLineNumber, 1, this.modified.endLineNumberExclusive, 1));
    } else
      return new Eo(new Q(this.original.startLineNumber - 1, Number.MAX_SAFE_INTEGER, this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), new Q(this.modified.startLineNumber - 1, Number.MAX_SAFE_INTEGER, this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER));
  }
  /**
   * This method assumes that the LineRangeMapping describes a valid diff!
   * I.e. if one range is empty, the other range cannot be the entire document.
   * It avoids various problems when the line range points to non-existing line-numbers.
  */
  toRangeMapping2(e, t) {
    if (S5e(this.original.endLineNumberExclusive, e) && S5e(this.modified.endLineNumberExclusive, t))
      return new Eo(new Q(this.original.startLineNumber, 1, this.original.endLineNumberExclusive, 1), new Q(this.modified.startLineNumber, 1, this.modified.endLineNumberExclusive, 1));
    if (!this.original.isEmpty && !this.modified.isEmpty)
      return new Eo(Q.fromPositions(new le(this.original.startLineNumber, 1), _2(new le(this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), e)), Q.fromPositions(new le(this.modified.startLineNumber, 1), _2(new le(this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), t)));
    if (this.original.startLineNumber > 1 && this.modified.startLineNumber > 1)
      return new Eo(Q.fromPositions(_2(new le(this.original.startLineNumber - 1, Number.MAX_SAFE_INTEGER), e), _2(new le(this.original.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), e)), Q.fromPositions(_2(new le(this.modified.startLineNumber - 1, Number.MAX_SAFE_INTEGER), t), _2(new le(this.modified.endLineNumberExclusive - 1, Number.MAX_SAFE_INTEGER), t)));
    throw new cn();
  }
}
function _2(r, e) {
  if (r.lineNumber < 1)
    return new le(1, 1);
  if (r.lineNumber > e.length)
    return new le(e.length, e[e.length - 1].length + 1);
  const t = e[r.lineNumber - 1];
  return r.column > t.length + 1 ? new le(r.lineNumber, t.length + 1) : r;
}
function S5e(r, e) {
  return r >= 1 && r <= e.length;
}
class Po extends ns {
  static fromRangeMappings(e) {
    const t = lt.join(e.map((i) => lt.fromRangeInclusive(i.originalRange))), n = lt.join(e.map((i) => lt.fromRangeInclusive(i.modifiedRange)));
    return new Po(t, n, e);
  }
  constructor(e, t, n) {
    super(e, t), this.innerChanges = n;
  }
  flip() {
    return new Po(this.modified, this.original, this.innerChanges?.map((e) => e.flip()));
  }
  withInnerChangesFromLineRanges() {
    return new Po(this.original, this.modified, [this.toRangeMapping()]);
  }
}
class Eo {
  static assertSorted(e) {
    for (let t = 1; t < e.length; t++) {
      const n = e[t - 1], i = e[t];
      if (!(n.originalRange.getEndPosition().isBeforeOrEqual(i.originalRange.getStartPosition()) && n.modifiedRange.getEndPosition().isBeforeOrEqual(i.modifiedRange.getStartPosition())))
        throw new cn("Range mappings must be sorted");
    }
  }
  constructor(e, t) {
    this.originalRange = e, this.modifiedRange = t;
  }
  toString() {
    return `{${this.originalRange.toString()}->${this.modifiedRange.toString()}}`;
  }
  flip() {
    return new Eo(this.modifiedRange, this.originalRange);
  }
  /**
   * Creates a single text edit that describes the change from the original to the modified text.
  */
  toTextEdit(e) {
    const t = e.getValueOfRange(this.modifiedRange);
    return new Xpt(this.originalRange, t);
  }
}
const $pt = 3;
class egt {
  computeDiff(e, t, n) {
    const s = new igt(e, t, {
      maxComputationTime: n.maxComputationTimeMs,
      shouldIgnoreTrimWhitespace: n.ignoreTrimWhitespace,
      shouldComputeCharChanges: !0,
      shouldMakePrettyDiff: !0,
      shouldPostProcessCharChanges: !0
    }).computeDiff(), o = [];
    let a = null;
    for (const l of s.changes) {
      let c;
      l.originalEndLineNumber === 0 ? c = new lt(l.originalStartLineNumber + 1, l.originalStartLineNumber + 1) : c = new lt(l.originalStartLineNumber, l.originalEndLineNumber + 1);
      let d;
      l.modifiedEndLineNumber === 0 ? d = new lt(l.modifiedStartLineNumber + 1, l.modifiedStartLineNumber + 1) : d = new lt(l.modifiedStartLineNumber, l.modifiedEndLineNumber + 1);
      let u = new Po(c, d, l.charChanges?.map((f) => new Eo(new Q(f.originalStartLineNumber, f.originalStartColumn, f.originalEndLineNumber, f.originalEndColumn), new Q(f.modifiedStartLineNumber, f.modifiedStartColumn, f.modifiedEndLineNumber, f.modifiedEndColumn))));
      a && (a.modified.endLineNumberExclusive === u.modified.startLineNumber || a.original.endLineNumberExclusive === u.original.startLineNumber) && (u = new Po(a.original.join(u.original), a.modified.join(u.modified), a.innerChanges && u.innerChanges ? a.innerChanges.concat(u.innerChanges) : void 0), o.pop()), o.push(u), a = u;
    }
    return vf(() => eO(o, (l, c) => c.original.startLineNumber - l.original.endLineNumberExclusive === c.modified.startLineNumber - l.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
    l.original.endLineNumberExclusive < c.original.startLineNumber && l.modified.endLineNumberExclusive < c.modified.startLineNumber)), new v6(o, [], s.quitEarly);
  }
}
function cLe(r, e, t, n) {
  return new ld(r, e, t).ComputeDiff(n);
}
let M5e = class {
  constructor(e) {
    const t = [], n = [];
    for (let i = 0, s = e.length; i < s; i++)
      t[i] = KD(e[i], 1), n[i] = YD(e[i], 1);
    this.lines = e, this._startColumns = t, this._endColumns = n;
  }
  getElements() {
    const e = [];
    for (let t = 0, n = this.lines.length; t < n; t++)
      e[t] = this.lines[t].substring(this._startColumns[t] - 1, this._endColumns[t] - 1);
    return e;
  }
  getStrictElement(e) {
    return this.lines[e];
  }
  getStartLineNumber(e) {
    return e + 1;
  }
  getEndLineNumber(e) {
    return e + 1;
  }
  createCharSequence(e, t, n) {
    const i = [], s = [], o = [];
    let a = 0;
    for (let l = t; l <= n; l++) {
      const c = this.lines[l], d = e ? this._startColumns[l] : 1, u = e ? this._endColumns[l] : c.length + 1;
      for (let f = d; f < u; f++)
        i[a] = c.charCodeAt(f - 1), s[a] = l + 1, o[a] = f, a++;
      !e && l < n && (i[a] = 10, s[a] = l + 1, o[a] = c.length + 1, a++);
    }
    return new tgt(i, s, o);
  }
};
class tgt {
  constructor(e, t, n) {
    this._charCodes = e, this._lineNumbers = t, this._columns = n;
  }
  toString() {
    return "[" + this._charCodes.map((e, t) => (e === 10 ? "\\n" : String.fromCharCode(e)) + `-(${this._lineNumbers[t]},${this._columns[t]})`).join(", ") + "]";
  }
  _assertIndex(e, t) {
    if (e < 0 || e >= t.length)
      throw new Error("Illegal index");
  }
  getElements() {
    return this._charCodes;
  }
  getStartLineNumber(e) {
    return e > 0 && e === this._lineNumbers.length ? this.getEndLineNumber(e - 1) : (this._assertIndex(e, this._lineNumbers), this._lineNumbers[e]);
  }
  getEndLineNumber(e) {
    return e === -1 ? this.getStartLineNumber(e + 1) : (this._assertIndex(e, this._lineNumbers), this._charCodes[e] === 10 ? this._lineNumbers[e] + 1 : this._lineNumbers[e]);
  }
  getStartColumn(e) {
    return e > 0 && e === this._columns.length ? this.getEndColumn(e - 1) : (this._assertIndex(e, this._columns), this._columns[e]);
  }
  getEndColumn(e) {
    return e === -1 ? this.getStartColumn(e + 1) : (this._assertIndex(e, this._columns), this._charCodes[e] === 10 ? 1 : this._columns[e] + 1);
  }
}
class bp {
  constructor(e, t, n, i, s, o, a, l) {
    this.originalStartLineNumber = e, this.originalStartColumn = t, this.originalEndLineNumber = n, this.originalEndColumn = i, this.modifiedStartLineNumber = s, this.modifiedStartColumn = o, this.modifiedEndLineNumber = a, this.modifiedEndColumn = l;
  }
  static createFromDiffChange(e, t, n) {
    const i = t.getStartLineNumber(e.originalStart), s = t.getStartColumn(e.originalStart), o = t.getEndLineNumber(e.originalStart + e.originalLength - 1), a = t.getEndColumn(e.originalStart + e.originalLength - 1), l = n.getStartLineNumber(e.modifiedStart), c = n.getStartColumn(e.modifiedStart), d = n.getEndLineNumber(e.modifiedStart + e.modifiedLength - 1), u = n.getEndColumn(e.modifiedStart + e.modifiedLength - 1);
    return new bp(i, s, o, a, l, c, d, u);
  }
}
function ngt(r) {
  if (r.length <= 1)
    return r;
  const e = [r[0]];
  let t = e[0];
  for (let n = 1, i = r.length; n < i; n++) {
    const s = r[n], o = s.originalStart - (t.originalStart + t.originalLength), a = s.modifiedStart - (t.modifiedStart + t.modifiedLength);
    Math.min(o, a) < $pt ? (t.originalLength = s.originalStart + s.originalLength - t.originalStart, t.modifiedLength = s.modifiedStart + s.modifiedLength - t.modifiedStart) : (e.push(s), t = s);
  }
  return e;
}
class zA {
  constructor(e, t, n, i, s) {
    this.originalStartLineNumber = e, this.originalEndLineNumber = t, this.modifiedStartLineNumber = n, this.modifiedEndLineNumber = i, this.charChanges = s;
  }
  static createFromDiffResult(e, t, n, i, s, o, a) {
    let l, c, d, u, f;
    if (t.originalLength === 0 ? (l = n.getStartLineNumber(t.originalStart) - 1, c = 0) : (l = n.getStartLineNumber(t.originalStart), c = n.getEndLineNumber(t.originalStart + t.originalLength - 1)), t.modifiedLength === 0 ? (d = i.getStartLineNumber(t.modifiedStart) - 1, u = 0) : (d = i.getStartLineNumber(t.modifiedStart), u = i.getEndLineNumber(t.modifiedStart + t.modifiedLength - 1)), o && t.originalLength > 0 && t.originalLength < 20 && t.modifiedLength > 0 && t.modifiedLength < 20 && s()) {
      const p = n.createCharSequence(e, t.originalStart, t.originalStart + t.originalLength - 1), g = i.createCharSequence(e, t.modifiedStart, t.modifiedStart + t.modifiedLength - 1);
      if (p.getElements().length > 0 && g.getElements().length > 0) {
        let m = cLe(p, g, s, !0).changes;
        a && (m = ngt(m)), f = [];
        for (let A = 0, w = m.length; A < w; A++)
          f.push(bp.createFromDiffChange(m[A], p, g));
      }
    }
    return new zA(l, c, d, u, f);
  }
}
class igt {
  constructor(e, t, n) {
    this.shouldComputeCharChanges = n.shouldComputeCharChanges, this.shouldPostProcessCharChanges = n.shouldPostProcessCharChanges, this.shouldIgnoreTrimWhitespace = n.shouldIgnoreTrimWhitespace, this.shouldMakePrettyDiff = n.shouldMakePrettyDiff, this.originalLines = e, this.modifiedLines = t, this.original = new M5e(e), this.modified = new M5e(t), this.continueLineDiff = D5e(n.maxComputationTime), this.continueCharDiff = D5e(n.maxComputationTime === 0 ? 0 : Math.min(n.maxComputationTime, 5e3));
  }
  computeDiff() {
    if (this.original.lines.length === 1 && this.original.lines[0].length === 0)
      return this.modified.lines.length === 1 && this.modified.lines[0].length === 0 ? {
        quitEarly: !1,
        changes: []
      } : {
        quitEarly: !1,
        changes: [{
          originalStartLineNumber: 1,
          originalEndLineNumber: 1,
          modifiedStartLineNumber: 1,
          modifiedEndLineNumber: this.modified.lines.length,
          charChanges: void 0
        }]
      };
    if (this.modified.lines.length === 1 && this.modified.lines[0].length === 0)
      return {
        quitEarly: !1,
        changes: [{
          originalStartLineNumber: 1,
          originalEndLineNumber: this.original.lines.length,
          modifiedStartLineNumber: 1,
          modifiedEndLineNumber: 1,
          charChanges: void 0
        }]
      };
    const e = cLe(this.original, this.modified, this.continueLineDiff, this.shouldMakePrettyDiff), t = e.changes, n = e.quitEarly;
    if (this.shouldIgnoreTrimWhitespace) {
      const a = [];
      for (let l = 0, c = t.length; l < c; l++)
        a.push(zA.createFromDiffResult(this.shouldIgnoreTrimWhitespace, t[l], this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges));
      return {
        quitEarly: n,
        changes: a
      };
    }
    const i = [];
    let s = 0, o = 0;
    for (let a = -1, l = t.length; a < l; a++) {
      const c = a + 1 < l ? t[a + 1] : null, d = c ? c.originalStart : this.originalLines.length, u = c ? c.modifiedStart : this.modifiedLines.length;
      for (; s < d && o < u; ) {
        const f = this.originalLines[s], p = this.modifiedLines[o];
        if (f !== p) {
          {
            let g = KD(f, 1), m = KD(p, 1);
            for (; g > 1 && m > 1; ) {
              const A = f.charCodeAt(g - 2), w = p.charCodeAt(m - 2);
              if (A !== w)
                break;
              g--, m--;
            }
            (g > 1 || m > 1) && this._pushTrimWhitespaceCharChange(i, s + 1, 1, g, o + 1, 1, m);
          }
          {
            let g = YD(f, 1), m = YD(p, 1);
            const A = f.length + 1, w = p.length + 1;
            for (; g < A && m < w; ) {
              const v = f.charCodeAt(g - 1), y = f.charCodeAt(m - 1);
              if (v !== y)
                break;
              g++, m++;
            }
            (g < A || m < w) && this._pushTrimWhitespaceCharChange(i, s + 1, g, A, o + 1, m, w);
          }
        }
        s++, o++;
      }
      c && (i.push(zA.createFromDiffResult(this.shouldIgnoreTrimWhitespace, c, this.original, this.modified, this.continueCharDiff, this.shouldComputeCharChanges, this.shouldPostProcessCharChanges)), s += c.originalLength, o += c.modifiedLength);
    }
    return {
      quitEarly: n,
      changes: i
    };
  }
  _pushTrimWhitespaceCharChange(e, t, n, i, s, o, a) {
    if (this._mergeTrimWhitespaceCharChange(e, t, n, i, s, o, a))
      return;
    let l;
    this.shouldComputeCharChanges && (l = [new bp(t, n, t, i, s, o, s, a)]), e.push(new zA(t, t, s, s, l));
  }
  _mergeTrimWhitespaceCharChange(e, t, n, i, s, o, a) {
    const l = e.length;
    if (l === 0)
      return !1;
    const c = e[l - 1];
    return c.originalEndLineNumber === 0 || c.modifiedEndLineNumber === 0 ? !1 : c.originalEndLineNumber === t && c.modifiedEndLineNumber === s ? (this.shouldComputeCharChanges && c.charChanges && c.charChanges.push(new bp(t, n, t, i, s, o, s, a)), !0) : c.originalEndLineNumber + 1 === t && c.modifiedEndLineNumber + 1 === s ? (c.originalEndLineNumber = t, c.modifiedEndLineNumber = s, this.shouldComputeCharChanges && c.charChanges && c.charChanges.push(new bp(t, n, t, i, s, o, s, a)), !0) : !1;
  }
}
function KD(r, e) {
  const t = so(r);
  return t === -1 ? e : t + 1;
}
function YD(r, e) {
  const t = Zf(r);
  return t === -1 ? e : t + 2;
}
function D5e(r) {
  if (r === 0)
    return () => !0;
  const e = Date.now();
  return () => Date.now() - e < r;
}
class xd {
  static trivial(e, t) {
    return new xd([new Fi(pt.ofLength(e.length), pt.ofLength(t.length))], !1);
  }
  static trivialTimedOut(e, t) {
    return new xd([new Fi(pt.ofLength(e.length), pt.ofLength(t.length))], !0);
  }
  constructor(e, t) {
    this.diffs = e, this.hitTimeout = t;
  }
}
class Fi {
  static invert(e, t) {
    const n = [];
    return _Me(e, (i, s) => {
      n.push(Fi.fromOffsetPairs(i ? i.getEndExclusives() : jl.zero, s ? s.getStarts() : new jl(t, (i ? i.seq2Range.endExclusive - i.seq1Range.endExclusive : 0) + t)));
    }), n;
  }
  static fromOffsetPairs(e, t) {
    return new Fi(new pt(e.offset1, t.offset1), new pt(e.offset2, t.offset2));
  }
  static assertSorted(e) {
    let t;
    for (const n of e) {
      if (t && !(t.seq1Range.endExclusive <= n.seq1Range.start && t.seq2Range.endExclusive <= n.seq2Range.start))
        throw new cn("Sequence diffs must be sorted");
      t = n;
    }
  }
  constructor(e, t) {
    this.seq1Range = e, this.seq2Range = t;
  }
  swap() {
    return new Fi(this.seq2Range, this.seq1Range);
  }
  toString() {
    return `${this.seq1Range} <-> ${this.seq2Range}`;
  }
  join(e) {
    return new Fi(this.seq1Range.join(e.seq1Range), this.seq2Range.join(e.seq2Range));
  }
  delta(e) {
    return e === 0 ? this : new Fi(this.seq1Range.delta(e), this.seq2Range.delta(e));
  }
  deltaStart(e) {
    return e === 0 ? this : new Fi(this.seq1Range.deltaStart(e), this.seq2Range.deltaStart(e));
  }
  deltaEnd(e) {
    return e === 0 ? this : new Fi(this.seq1Range.deltaEnd(e), this.seq2Range.deltaEnd(e));
  }
  intersect(e) {
    const t = this.seq1Range.intersect(e.seq1Range), n = this.seq2Range.intersect(e.seq2Range);
    if (!(!t || !n))
      return new Fi(t, n);
  }
  getStarts() {
    return new jl(this.seq1Range.start, this.seq2Range.start);
  }
  getEndExclusives() {
    return new jl(this.seq1Range.endExclusive, this.seq2Range.endExclusive);
  }
}
class jl {
  static {
    this.zero = new jl(0, 0);
  }
  static {
    this.max = new jl(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
  }
  constructor(e, t) {
    this.offset1 = e, this.offset2 = t;
  }
  toString() {
    return `${this.offset1} <-> ${this.offset2}`;
  }
  delta(e) {
    return e === 0 ? this : new jl(this.offset1 + e, this.offset2 + e);
  }
  equals(e) {
    return this.offset1 === e.offset1 && this.offset2 === e.offset2;
  }
}
class xw {
  static {
    this.instance = new xw();
  }
  isValid() {
    return !0;
  }
}
class rgt {
  constructor(e) {
    if (this.timeout = e, this.startTime = Date.now(), this.valid = !0, e <= 0)
      throw new cn("timeout must be positive");
  }
  // Recommendation: Set a log-point `{this.disable()}` in the body
  isValid() {
    if (!(Date.now() - this.startTime < this.timeout) && this.valid) {
      this.valid = !1;
      debugger;
    }
    return this.valid;
  }
}
class FE {
  constructor(e, t) {
    this.width = e, this.height = t, this.array = [], this.array = new Array(e * t);
  }
  get(e, t) {
    return this.array[e + t * this.width];
  }
  set(e, t, n) {
    this.array[e + t * this.width] = n;
  }
}
function XD(r) {
  return r === 32 || r === 9;
}
class j3 {
  static {
    this.chrKeys = /* @__PURE__ */ new Map();
  }
  static getKey(e) {
    let t = this.chrKeys.get(e);
    return t === void 0 && (t = this.chrKeys.size, this.chrKeys.set(e, t)), t;
  }
  constructor(e, t, n) {
    this.range = e, this.lines = t, this.source = n, this.histogram = [];
    let i = 0;
    for (let s = e.startLineNumber - 1; s < e.endLineNumberExclusive - 1; s++) {
      const o = t[s];
      for (let l = 0; l < o.length; l++) {
        i++;
        const c = o[l], d = j3.getKey(c);
        this.histogram[d] = (this.histogram[d] || 0) + 1;
      }
      i++;
      const a = j3.getKey(`
`);
      this.histogram[a] = (this.histogram[a] || 0) + 1;
    }
    this.totalCount = i;
  }
  computeSimilarity(e) {
    let t = 0;
    const n = Math.max(this.histogram.length, e.histogram.length);
    for (let i = 0; i < n; i++)
      t += Math.abs((this.histogram[i] ?? 0) - (e.histogram[i] ?? 0));
    return 1 - t / (this.totalCount + e.totalCount);
  }
}
class sgt {
  compute(e, t, n = xw.instance, i) {
    if (e.length === 0 || t.length === 0)
      return xd.trivial(e, t);
    const s = new FE(e.length, t.length), o = new FE(e.length, t.length), a = new FE(e.length, t.length);
    for (let g = 0; g < e.length; g++)
      for (let m = 0; m < t.length; m++) {
        if (!n.isValid())
          return xd.trivialTimedOut(e, t);
        const A = g === 0 ? 0 : s.get(g - 1, m), w = m === 0 ? 0 : s.get(g, m - 1);
        let v;
        e.getElement(g) === t.getElement(m) ? (g === 0 || m === 0 ? v = 0 : v = s.get(g - 1, m - 1), g > 0 && m > 0 && o.get(g - 1, m - 1) === 3 && (v += a.get(g - 1, m - 1)), v += i ? i(g, m) : 1) : v = -1;
        const y = Math.max(A, w, v);
        if (y === v) {
          const _ = g > 0 && m > 0 ? a.get(g - 1, m - 1) : 0;
          a.set(g, m, _ + 1), o.set(g, m, 3);
        } else y === A ? (a.set(g, m, 0), o.set(g, m, 1)) : y === w && (a.set(g, m, 0), o.set(g, m, 2));
        s.set(g, m, y);
      }
    const l = [];
    let c = e.length, d = t.length;
    function u(g, m) {
      (g + 1 !== c || m + 1 !== d) && l.push(new Fi(new pt(g + 1, c), new pt(m + 1, d))), c = g, d = m;
    }
    let f = e.length - 1, p = t.length - 1;
    for (; f >= 0 && p >= 0; )
      o.get(f, p) === 3 ? (u(f, p), f--, p--) : o.get(f, p) === 1 ? f-- : p--;
    return u(-1, -1), l.reverse(), new xd(l, !1);
  }
}
class hLe {
  compute(e, t, n = xw.instance) {
    if (e.length === 0 || t.length === 0)
      return xd.trivial(e, t);
    const i = e, s = t;
    function o(m, A) {
      for (; m < i.length && A < s.length && i.getElement(m) === s.getElement(A); )
        m++, A++;
      return m;
    }
    let a = 0;
    const l = new ogt();
    l.set(0, o(0, 0));
    const c = new agt();
    c.set(0, l.get(0) === 0 ? null : new L5e(null, 0, 0, l.get(0)));
    let d = 0;
    e: for (; ; ) {
      if (a++, !n.isValid())
        return xd.trivialTimedOut(i, s);
      const m = -Math.min(a, s.length + a % 2), A = Math.min(a, i.length + a % 2);
      for (d = m; d <= A; d += 2) {
        const w = d === A ? -1 : l.get(d + 1), v = d === m ? -1 : l.get(d - 1) + 1, y = Math.min(Math.max(w, v), i.length), _ = y - d;
        if (y > i.length || _ > s.length)
          continue;
        const S = o(y, _);
        l.set(d, S);
        const D = y === w ? c.get(d + 1) : c.get(d - 1);
        if (c.set(d, S !== y ? new L5e(D, y, _, S - y) : D), l.get(d) === i.length && l.get(d) - d === s.length)
          break e;
      }
    }
    let u = c.get(d);
    const f = [];
    let p = i.length, g = s.length;
    for (; ; ) {
      const m = u ? u.x + u.length : 0, A = u ? u.y + u.length : 0;
      if ((m !== p || A !== g) && f.push(new Fi(new pt(m, p), new pt(A, g))), !u)
        break;
      p = u.x, g = u.y, u = u.prev;
    }
    return f.reverse(), new xd(f, !1);
  }
}
class L5e {
  constructor(e, t, n, i) {
    this.prev = e, this.x = t, this.y = n, this.length = i;
  }
}
class ogt {
  constructor() {
    this.positiveArr = new Int32Array(10), this.negativeArr = new Int32Array(10);
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    if (e < 0) {
      if (e = -e - 1, e >= this.negativeArr.length) {
        const n = this.negativeArr;
        this.negativeArr = new Int32Array(n.length * 2), this.negativeArr.set(n);
      }
      this.negativeArr[e] = t;
    } else {
      if (e >= this.positiveArr.length) {
        const n = this.positiveArr;
        this.positiveArr = new Int32Array(n.length * 2), this.positiveArr.set(n);
      }
      this.positiveArr[e] = t;
    }
  }
}
class agt {
  constructor() {
    this.positiveArr = [], this.negativeArr = [];
  }
  get(e) {
    return e < 0 ? (e = -e - 1, this.negativeArr[e]) : this.positiveArr[e];
  }
  set(e, t) {
    e < 0 ? (e = -e - 1, this.negativeArr[e] = t) : this.positiveArr[e] = t;
  }
}
class K8 {
  constructor(e, t, n) {
    this.lines = e, this.range = t, this.considerWhitespaceChanges = n, this.elements = [], this.firstElementOffsetByLineIdx = [], this.lineStartOffsets = [], this.trimmedWsLengthsByLineIdx = [], this.firstElementOffsetByLineIdx.push(0);
    for (let i = this.range.startLineNumber; i <= this.range.endLineNumber; i++) {
      let s = e[i - 1], o = 0;
      i === this.range.startLineNumber && this.range.startColumn > 1 && (o = this.range.startColumn - 1, s = s.substring(o)), this.lineStartOffsets.push(o);
      let a = 0;
      if (!n) {
        const c = s.trimStart();
        a = s.length - c.length, s = c.trimEnd();
      }
      this.trimmedWsLengthsByLineIdx.push(a);
      const l = i === this.range.endLineNumber ? Math.min(this.range.endColumn - 1 - o - a, s.length) : s.length;
      for (let c = 0; c < l; c++)
        this.elements.push(s.charCodeAt(c));
      i < this.range.endLineNumber && (this.elements.push(10), this.firstElementOffsetByLineIdx.push(this.elements.length));
    }
  }
  toString() {
    return `Slice: "${this.text}"`;
  }
  get text() {
    return this.getText(new pt(0, this.length));
  }
  getText(e) {
    return this.elements.slice(e.start, e.endExclusive).map((t) => String.fromCharCode(t)).join("");
  }
  getElement(e) {
    return this.elements[e];
  }
  get length() {
    return this.elements.length;
  }
  getBoundaryScore(e) {
    const t = N5e(e > 0 ? this.elements[e - 1] : -1), n = N5e(e < this.elements.length ? this.elements[e] : -1);
    if (t === 7 && n === 8)
      return 0;
    if (t === 8)
      return 150;
    let i = 0;
    return t !== n && (i += 10, t === 0 && n === 1 && (i += 1)), i += k5e(t), i += k5e(n), i;
  }
  translateOffset(e, t = "right") {
    const n = W3(this.firstElementOffsetByLineIdx, (s) => s <= e), i = e - this.firstElementOffsetByLineIdx[n];
    return new le(this.range.startLineNumber + n, 1 + this.lineStartOffsets[n] + i + (i === 0 && t === "left" ? 0 : this.trimmedWsLengthsByLineIdx[n]));
  }
  translateRange(e) {
    const t = this.translateOffset(e.start, "right"), n = this.translateOffset(e.endExclusive, "left");
    return n.isBefore(t) ? Q.fromPositions(n, n) : Q.fromPositions(t, n);
  }
  /**
   * Finds the word that contains the character at the given offset
   */
  findWordContaining(e) {
    if (e < 0 || e >= this.elements.length || !zE(this.elements[e]))
      return;
    let t = e;
    for (; t > 0 && zE(this.elements[t - 1]); )
      t--;
    let n = e;
    for (; n < this.elements.length && zE(this.elements[n]); )
      n++;
    return new pt(t, n);
  }
  countLinesIn(e) {
    return this.translateOffset(e.endExclusive).lineNumber - this.translateOffset(e.start).lineNumber;
  }
  isStronglyEqual(e, t) {
    return this.elements[e] === this.elements[t];
  }
  extendToFullLines(e) {
    const t = hg(this.firstElementOffsetByLineIdx, (i) => i <= e.start) ?? 0, n = Upt(this.firstElementOffsetByLineIdx, (i) => e.endExclusive <= i) ?? this.elements.length;
    return new pt(t, n);
  }
}
function zE(r) {
  return r >= 97 && r <= 122 || r >= 65 && r <= 90 || r >= 48 && r <= 57;
}
const lgt = {
  0: 0,
  1: 0,
  2: 0,
  3: 10,
  4: 2,
  5: 30,
  6: 3,
  7: 10,
  8: 10
};
function k5e(r) {
  return lgt[r];
}
function N5e(r) {
  return r === 10 ? 8 : r === 13 ? 7 : XD(r) ? 6 : r >= 97 && r <= 122 ? 0 : r >= 65 && r <= 90 ? 1 : r >= 48 && r <= 57 ? 2 : r === -1 ? 3 : r === 44 || r === 59 ? 5 : 4;
}
function cgt(r, e, t, n, i, s) {
  let { moves: o, excludedChanges: a } = dgt(r, e, t, s);
  if (!s.isValid())
    return [];
  const l = r.filter((d) => !a.has(d)), c = ugt(l, n, i, e, t, s);
  return DM(o, c), o = fgt(o), o = o.filter((d) => {
    const u = d.original.toOffsetRange().slice(e).map((p) => p.trim());
    return u.join(`
`).length >= 15 && hgt(u, (p) => p.length >= 2) >= 2;
  }), o = pgt(r, o), o;
}
function hgt(r, e) {
  let t = 0;
  for (const n of r)
    e(n) && t++;
  return t;
}
function dgt(r, e, t, n) {
  const i = [], s = r.filter((l) => l.modified.isEmpty && l.original.length >= 3).map((l) => new j3(l.original, e, l)), o = new Set(r.filter((l) => l.original.isEmpty && l.modified.length >= 3).map((l) => new j3(l.modified, t, l))), a = /* @__PURE__ */ new Set();
  for (const l of s) {
    let c = -1, d;
    for (const u of o) {
      const f = l.computeSimilarity(u);
      f > c && (c = f, d = u);
    }
    if (c > 0.9 && d && (o.delete(d), i.push(new ns(l.range, d.range)), a.add(l.source), a.add(d.source)), !n.isValid())
      return { moves: i, excludedChanges: a };
  }
  return { moves: i, excludedChanges: a };
}
function ugt(r, e, t, n, i, s) {
  const o = [], a = new sLe();
  for (const f of r)
    for (let p = f.original.startLineNumber; p < f.original.endLineNumberExclusive - 2; p++) {
      const g = `${e[p - 1]}:${e[p + 1 - 1]}:${e[p + 2 - 1]}`;
      a.add(g, { range: new lt(p, p + 3) });
    }
  const l = [];
  r.sort(al((f) => f.modified.startLineNumber, Gu));
  for (const f of r) {
    let p = [];
    for (let g = f.modified.startLineNumber; g < f.modified.endLineNumberExclusive - 2; g++) {
      const m = `${t[g - 1]}:${t[g + 1 - 1]}:${t[g + 2 - 1]}`, A = new lt(g, g + 3), w = [];
      a.forEach(m, ({ range: v }) => {
        for (const _ of p)
          if (_.originalLineRange.endLineNumberExclusive + 1 === v.endLineNumberExclusive && _.modifiedLineRange.endLineNumberExclusive + 1 === A.endLineNumberExclusive) {
            _.originalLineRange = new lt(_.originalLineRange.startLineNumber, v.endLineNumberExclusive), _.modifiedLineRange = new lt(_.modifiedLineRange.startLineNumber, A.endLineNumberExclusive), w.push(_);
            return;
          }
        const y = {
          modifiedLineRange: A,
          originalLineRange: v
        };
        l.push(y), w.push(y);
      }), p = w;
    }
    if (!s.isValid())
      return [];
  }
  l.sort(gut(al((f) => f.modifiedLineRange.length, Gu)));
  const c = new sa(), d = new sa();
  for (const f of l) {
    const p = f.modifiedLineRange.startLineNumber - f.originalLineRange.startLineNumber, g = c.subtractFrom(f.modifiedLineRange), m = d.subtractFrom(f.originalLineRange).getWithDelta(p), A = g.getIntersection(m);
    for (const w of A.ranges) {
      if (w.length < 3)
        continue;
      const v = w, y = w.delta(-p);
      o.push(new ns(y, v)), c.addRange(v), d.addRange(y);
    }
  }
  o.sort(al((f) => f.original.startLineNumber, Gu));
  const u = new ty(r);
  for (let f = 0; f < o.length; f++) {
    const p = o[f], g = u.findLastMonotonous((D) => D.original.startLineNumber <= p.original.startLineNumber), m = hg(r, (D) => D.modified.startLineNumber <= p.modified.startLineNumber), A = Math.max(p.original.startLineNumber - g.original.startLineNumber, p.modified.startLineNumber - m.modified.startLineNumber), w = u.findLastMonotonous((D) => D.original.startLineNumber < p.original.endLineNumberExclusive), v = hg(r, (D) => D.modified.startLineNumber < p.modified.endLineNumberExclusive), y = Math.max(w.original.endLineNumberExclusive - p.original.endLineNumberExclusive, v.modified.endLineNumberExclusive - p.modified.endLineNumberExclusive);
    let _;
    for (_ = 0; _ < A; _++) {
      const D = p.original.startLineNumber - _ - 1, M = p.modified.startLineNumber - _ - 1;
      if (D > n.length || M > i.length || c.contains(M) || d.contains(D) || !T5e(n[D - 1], i[M - 1], s))
        break;
    }
    _ > 0 && (d.addRange(new lt(p.original.startLineNumber - _, p.original.startLineNumber)), c.addRange(new lt(p.modified.startLineNumber - _, p.modified.startLineNumber)));
    let S;
    for (S = 0; S < y; S++) {
      const D = p.original.endLineNumberExclusive + S, M = p.modified.endLineNumberExclusive + S;
      if (D > n.length || M > i.length || c.contains(M) || d.contains(D) || !T5e(n[D - 1], i[M - 1], s))
        break;
    }
    S > 0 && (d.addRange(new lt(p.original.endLineNumberExclusive, p.original.endLineNumberExclusive + S)), c.addRange(new lt(p.modified.endLineNumberExclusive, p.modified.endLineNumberExclusive + S))), (_ > 0 || S > 0) && (o[f] = new ns(new lt(p.original.startLineNumber - _, p.original.endLineNumberExclusive + S), new lt(p.modified.startLineNumber - _, p.modified.endLineNumberExclusive + S)));
  }
  return o;
}
function T5e(r, e, t) {
  if (r.trim() === e.trim())
    return !0;
  if (r.length > 300 && e.length > 300)
    return !1;
  const i = new hLe().compute(new K8([r], new Q(1, 1, 1, r.length), !1), new K8([e], new Q(1, 1, 1, e.length), !1), t);
  let s = 0;
  const o = Fi.invert(i.diffs, r.length);
  for (const d of o)
    d.seq1Range.forEach((u) => {
      XD(r.charCodeAt(u)) || s++;
    });
  function a(d) {
    let u = 0;
    for (let f = 0; f < r.length; f++)
      XD(d.charCodeAt(f)) || u++;
    return u;
  }
  const l = a(r.length > e.length ? r : e);
  return s / l > 0.6 && l > 10;
}
function fgt(r) {
  if (r.length === 0)
    return r;
  r.sort(al((t) => t.original.startLineNumber, Gu));
  const e = [r[0]];
  for (let t = 1; t < r.length; t++) {
    const n = e[e.length - 1], i = r[t], s = i.original.startLineNumber - n.original.endLineNumberExclusive, o = i.modified.startLineNumber - n.modified.endLineNumberExclusive;
    if (s >= 0 && o >= 0 && s + o <= 2) {
      e[e.length - 1] = n.join(i);
      continue;
    }
    e.push(i);
  }
  return e;
}
function pgt(r, e) {
  const t = new ty(r);
  return e = e.filter((n) => {
    const i = t.findLastMonotonous((a) => a.original.startLineNumber < n.original.endLineNumberExclusive) || new ns(new lt(1, 1), new lt(1, 1)), s = hg(r, (a) => a.modified.startLineNumber < n.modified.endLineNumberExclusive);
    return i !== s;
  }), e;
}
function JD(r, e, t) {
  let n = t;
  return n = I5e(r, e, n), n = I5e(r, e, n), n = ggt(r, e, n), n;
}
function I5e(r, e, t) {
  if (t.length === 0)
    return t;
  const n = [];
  n.push(t[0]);
  for (let s = 1; s < t.length; s++) {
    const o = n[n.length - 1];
    let a = t[s];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = a.seq1Range.start - o.seq1Range.endExclusive;
      let c;
      for (c = 1; c <= l && !(r.getElement(a.seq1Range.start - c) !== r.getElement(a.seq1Range.endExclusive - c) || e.getElement(a.seq2Range.start - c) !== e.getElement(a.seq2Range.endExclusive - c)); c++)
        ;
      if (c--, c === l) {
        n[n.length - 1] = new Fi(new pt(o.seq1Range.start, a.seq1Range.endExclusive - l), new pt(o.seq2Range.start, a.seq2Range.endExclusive - l));
        continue;
      }
      a = a.delta(-c);
    }
    n.push(a);
  }
  const i = [];
  for (let s = 0; s < n.length - 1; s++) {
    const o = n[s + 1];
    let a = n[s];
    if (a.seq1Range.isEmpty || a.seq2Range.isEmpty) {
      const l = o.seq1Range.start - a.seq1Range.endExclusive;
      let c;
      for (c = 0; c < l && !(!r.isStronglyEqual(a.seq1Range.start + c, a.seq1Range.endExclusive + c) || !e.isStronglyEqual(a.seq2Range.start + c, a.seq2Range.endExclusive + c)); c++)
        ;
      if (c === l) {
        n[s + 1] = new Fi(new pt(a.seq1Range.start + l, o.seq1Range.endExclusive), new pt(a.seq2Range.start + l, o.seq2Range.endExclusive));
        continue;
      }
      c > 0 && (a = a.delta(c));
    }
    i.push(a);
  }
  return n.length > 0 && i.push(n[n.length - 1]), i;
}
function ggt(r, e, t) {
  if (!r.getBoundaryScore || !e.getBoundaryScore)
    return t;
  for (let n = 0; n < t.length; n++) {
    const i = n > 0 ? t[n - 1] : void 0, s = t[n], o = n + 1 < t.length ? t[n + 1] : void 0, a = new pt(i ? i.seq1Range.endExclusive + 1 : 0, o ? o.seq1Range.start - 1 : r.length), l = new pt(i ? i.seq2Range.endExclusive + 1 : 0, o ? o.seq2Range.start - 1 : e.length);
    s.seq1Range.isEmpty ? t[n] = O5e(s, r, e, a, l) : s.seq2Range.isEmpty && (t[n] = O5e(s.swap(), e, r, l, a).swap());
  }
  return t;
}
function O5e(r, e, t, n, i) {
  let o = 1;
  for (; r.seq1Range.start - o >= n.start && r.seq2Range.start - o >= i.start && t.isStronglyEqual(r.seq2Range.start - o, r.seq2Range.endExclusive - o) && o < 100; )
    o++;
  o--;
  let a = 0;
  for (; r.seq1Range.start + a < n.endExclusive && r.seq2Range.endExclusive + a < i.endExclusive && t.isStronglyEqual(r.seq2Range.start + a, r.seq2Range.endExclusive + a) && a < 100; )
    a++;
  if (o === 0 && a === 0)
    return r;
  let l = 0, c = -1;
  for (let d = -o; d <= a; d++) {
    const u = r.seq2Range.start + d, f = r.seq2Range.endExclusive + d, p = r.seq1Range.start + d, g = e.getBoundaryScore(p) + t.getBoundaryScore(u) + t.getBoundaryScore(f);
    g > c && (c = g, l = d);
  }
  return r.delta(l);
}
function mgt(r, e, t) {
  const n = [];
  for (const i of t) {
    const s = n[n.length - 1];
    if (!s) {
      n.push(i);
      continue;
    }
    i.seq1Range.start - s.seq1Range.endExclusive <= 2 || i.seq2Range.start - s.seq2Range.endExclusive <= 2 ? n[n.length - 1] = new Fi(s.seq1Range.join(i.seq1Range), s.seq2Range.join(i.seq2Range)) : n.push(i);
  }
  return n;
}
function Agt(r, e, t) {
  const n = Fi.invert(t, r.length), i = [];
  let s = new jl(0, 0);
  function o(l, c) {
    if (l.offset1 < s.offset1 || l.offset2 < s.offset2)
      return;
    const d = r.findWordContaining(l.offset1), u = e.findWordContaining(l.offset2);
    if (!d || !u)
      return;
    let f = new Fi(d, u);
    const p = f.intersect(c);
    let g = p.seq1Range.length, m = p.seq2Range.length;
    for (; n.length > 0; ) {
      const A = n[0];
      if (!(A.seq1Range.intersects(f.seq1Range) || A.seq2Range.intersects(f.seq2Range)))
        break;
      const v = r.findWordContaining(A.seq1Range.start), y = e.findWordContaining(A.seq2Range.start), _ = new Fi(v, y), S = _.intersect(A);
      if (g += S.seq1Range.length, m += S.seq2Range.length, f = f.join(_), f.seq1Range.endExclusive >= A.seq1Range.endExclusive)
        n.shift();
      else
        break;
    }
    g + m < (f.seq1Range.length + f.seq2Range.length) * 2 / 3 && i.push(f), s = f.getEndExclusives();
  }
  for (; n.length > 0; ) {
    const l = n.shift();
    l.seq1Range.isEmpty || (o(l.getStarts(), l), o(l.getEndExclusives().delta(-1), l));
  }
  return wgt(t, i);
}
function wgt(r, e) {
  const t = [];
  for (; r.length > 0 || e.length > 0; ) {
    const n = r[0], i = e[0];
    let s;
    n && (!i || n.seq1Range.start < i.seq1Range.start) ? s = r.shift() : s = e.shift(), t.length > 0 && t[t.length - 1].seq1Range.endExclusive >= s.seq1Range.start ? t[t.length - 1] = t[t.length - 1].join(s) : t.push(s);
  }
  return t;
}
function vgt(r, e, t) {
  let n = t;
  if (n.length === 0)
    return n;
  let i = 0, s;
  do {
    s = !1;
    const o = [
      n[0]
    ];
    for (let a = 1; a < n.length; a++) {
      let d = function(f, p) {
        const g = new pt(c.seq1Range.endExclusive, l.seq1Range.start);
        return r.getText(g).replace(/\s/g, "").length <= 4 && (f.seq1Range.length + f.seq2Range.length > 5 || p.seq1Range.length + p.seq2Range.length > 5);
      };
      const l = n[a], c = o[o.length - 1];
      d(c, l) ? (s = !0, o[o.length - 1] = o[o.length - 1].join(l)) : o.push(l);
    }
    n = o;
  } while (i++ < 10 && s);
  return n;
}
function bgt(r, e, t) {
  let n = t;
  if (n.length === 0)
    return n;
  let i = 0, s;
  do {
    s = !1;
    const a = [
      n[0]
    ];
    for (let l = 1; l < n.length; l++) {
      let u = function(p, g) {
        const m = new pt(d.seq1Range.endExclusive, c.seq1Range.start);
        if (r.countLinesIn(m) > 5 || m.length > 500)
          return !1;
        const w = r.getText(m).trim();
        if (w.length > 20 || w.split(/\r\n|\r|\n/).length > 1)
          return !1;
        const v = r.countLinesIn(p.seq1Range), y = p.seq1Range.length, _ = e.countLinesIn(p.seq2Range), S = p.seq2Range.length, D = r.countLinesIn(g.seq1Range), M = g.seq1Range.length, L = e.countLinesIn(g.seq2Range), T = g.seq2Range.length, B = 2 * 40 + 50;
        function V(N) {
          return Math.min(N, B);
        }
        return Math.pow(Math.pow(V(v * 40 + y), 1.5) + Math.pow(V(_ * 40 + S), 1.5), 1.5) + Math.pow(Math.pow(V(D * 40 + M), 1.5) + Math.pow(V(L * 40 + T), 1.5), 1.5) > (B ** 1.5) ** 1.5 * 1.3;
      };
      const c = n[l], d = a[a.length - 1];
      u(d, c) ? (s = !0, a[a.length - 1] = a[a.length - 1].join(c)) : a.push(c);
    }
    n = a;
  } while (i++ < 10 && s);
  const o = [];
  return hut(n, (a, l, c) => {
    let d = l;
    function u(w) {
      return w.length > 0 && w.trim().length <= 3 && l.seq1Range.length + l.seq2Range.length > 100;
    }
    const f = r.extendToFullLines(l.seq1Range), p = r.getText(new pt(f.start, l.seq1Range.start));
    u(p) && (d = d.deltaStart(-p.length));
    const g = r.getText(new pt(l.seq1Range.endExclusive, f.endExclusive));
    u(g) && (d = d.deltaEnd(g.length));
    const m = Fi.fromOffsetPairs(a ? a.getEndExclusives() : jl.zero, c ? c.getStarts() : jl.max), A = d.intersect(m);
    o.length > 0 && A.getStarts().equals(o[o.length - 1].getEndExclusives()) ? o[o.length - 1] = o[o.length - 1].join(A) : o.push(A);
  }), o;
}
class R5e {
  constructor(e, t) {
    this.trimmedHash = e, this.lines = t;
  }
  getElement(e) {
    return this.trimmedHash[e];
  }
  get length() {
    return this.trimmedHash.length;
  }
  getBoundaryScore(e) {
    const t = e === 0 ? 0 : V5e(this.lines[e - 1]), n = e === this.lines.length ? 0 : V5e(this.lines[e]);
    return 1e3 - (t + n);
  }
  getText(e) {
    return this.lines.slice(e.start, e.endExclusive).join(`
`);
  }
  isStronglyEqual(e, t) {
    return this.lines[e] === this.lines[t];
  }
}
function V5e(r) {
  let e = 0;
  for (; e < r.length && (r.charCodeAt(e) === 32 || r.charCodeAt(e) === 9); )
    e++;
  return e;
}
class dLe {
  constructor() {
    this.dynamicProgrammingDiffing = new sgt(), this.myersDiffingAlgorithm = new hLe();
  }
  computeDiff(e, t, n) {
    if (e.length <= 1 && Zi(e, t, (S, D) => S === D))
      return new v6([], [], !1);
    if (e.length === 1 && e[0].length === 0 || t.length === 1 && t[0].length === 0)
      return new v6([
        new Po(new lt(1, e.length + 1), new lt(1, t.length + 1), [
          new Eo(new Q(1, 1, e.length, e[e.length - 1].length + 1), new Q(1, 1, t.length, t[t.length - 1].length + 1))
        ])
      ], [], !1);
    const i = n.maxComputationTimeMs === 0 ? xw.instance : new rgt(n.maxComputationTimeMs), s = !n.ignoreTrimWhitespace, o = /* @__PURE__ */ new Map();
    function a(S) {
      let D = o.get(S);
      return D === void 0 && (D = o.size, o.set(S, D)), D;
    }
    const l = e.map((S) => a(S.trim())), c = t.map((S) => a(S.trim())), d = new R5e(l, e), u = new R5e(c, t), f = d.length + u.length < 1700 ? this.dynamicProgrammingDiffing.compute(d, u, i, (S, D) => e[S] === t[D] ? t[D].length === 0 ? 0.1 : 1 + Math.log(1 + t[D].length) : 0.99) : this.myersDiffingAlgorithm.compute(d, u, i);
    let p = f.diffs, g = f.hitTimeout;
    p = JD(d, u, p), p = vgt(d, u, p);
    const m = [], A = (S) => {
      if (s)
        for (let D = 0; D < S; D++) {
          const M = w + D, L = v + D;
          if (e[M] !== t[L]) {
            const T = this.refineDiff(e, t, new Fi(new pt(M, M + 1), new pt(L, L + 1)), i, s);
            for (const B of T.mappings)
              m.push(B);
            T.hitTimeout && (g = !0);
          }
        }
    };
    let w = 0, v = 0;
    for (const S of p) {
      vf(() => S.seq1Range.start - w === S.seq2Range.start - v);
      const D = S.seq1Range.start - w;
      A(D), w = S.seq1Range.endExclusive, v = S.seq2Range.endExclusive;
      const M = this.refineDiff(e, t, S, i, s);
      M.hitTimeout && (g = !0);
      for (const L of M.mappings)
        m.push(L);
    }
    A(e.length - w);
    const y = H5e(m, e, t);
    let _ = [];
    return n.computeMoves && (_ = this.computeMoves(y, e, t, l, c, i, s)), vf(() => {
      function S(M, L) {
        if (M.lineNumber < 1 || M.lineNumber > L.length)
          return !1;
        const T = L[M.lineNumber - 1];
        return !(M.column < 1 || M.column > T.length + 1);
      }
      function D(M, L) {
        return !(M.startLineNumber < 1 || M.startLineNumber > L.length + 1 || M.endLineNumberExclusive < 1 || M.endLineNumberExclusive > L.length + 1);
      }
      for (const M of y) {
        if (!M.innerChanges)
          return !1;
        for (const L of M.innerChanges)
          if (!(S(L.modifiedRange.getStartPosition(), t) && S(L.modifiedRange.getEndPosition(), t) && S(L.originalRange.getStartPosition(), e) && S(L.originalRange.getEndPosition(), e)))
            return !1;
        if (!D(M.modified, t) || !D(M.original, e))
          return !1;
      }
      return !0;
    }), new v6(y, _, g);
  }
  computeMoves(e, t, n, i, s, o, a) {
    return cgt(e, t, n, i, s, o).map((d) => {
      const u = this.refineDiff(t, n, new Fi(d.original.toOffsetRange(), d.modified.toOffsetRange()), o, a), f = H5e(u.mappings, t, n, !0);
      return new oLe(d, f);
    });
  }
  refineDiff(e, t, n, i, s) {
    const a = Cgt(n).toRangeMapping2(e, t), l = new K8(e, a.originalRange, s), c = new K8(t, a.modifiedRange, s), d = l.length + c.length < 500 ? this.dynamicProgrammingDiffing.compute(l, c, i) : this.myersDiffingAlgorithm.compute(l, c, i);
    let u = d.diffs;
    return u = JD(l, c, u), u = Agt(l, c, u), u = mgt(l, c, u), u = bgt(l, c, u), {
      mappings: u.map((p) => new Eo(l.translateRange(p.seq1Range), c.translateRange(p.seq2Range))),
      hitTimeout: d.hitTimeout
    };
  }
}
function H5e(r, e, t, n = !1) {
  const i = [];
  for (const s of wI(r.map((o) => ygt(o, e, t)), (o, a) => o.original.overlapOrTouch(a.original) || o.modified.overlapOrTouch(a.modified))) {
    const o = s[0], a = s[s.length - 1];
    i.push(new Po(o.original.join(a.original), o.modified.join(a.modified), s.map((l) => l.innerChanges[0])));
  }
  return vf(() => !n && i.length > 0 && (i[0].modified.startLineNumber !== i[0].original.startLineNumber || t.length - i[i.length - 1].modified.endLineNumberExclusive !== e.length - i[i.length - 1].original.endLineNumberExclusive) ? !1 : eO(i, (s, o) => o.original.startLineNumber - s.original.endLineNumberExclusive === o.modified.startLineNumber - s.modified.endLineNumberExclusive && // There has to be an unchanged line in between (otherwise both diffs should have been joined)
  s.original.endLineNumberExclusive < o.original.startLineNumber && s.modified.endLineNumberExclusive < o.modified.startLineNumber)), i;
}
function ygt(r, e, t) {
  let n = 0, i = 0;
  r.modifiedRange.endColumn === 1 && r.originalRange.endColumn === 1 && r.originalRange.startLineNumber + n <= r.originalRange.endLineNumber && r.modifiedRange.startLineNumber + n <= r.modifiedRange.endLineNumber && (i = -1), r.modifiedRange.startColumn - 1 >= t[r.modifiedRange.startLineNumber - 1].length && r.originalRange.startColumn - 1 >= e[r.originalRange.startLineNumber - 1].length && r.originalRange.startLineNumber <= r.originalRange.endLineNumber + i && r.modifiedRange.startLineNumber <= r.modifiedRange.endLineNumber + i && (n = 1);
  const s = new lt(r.originalRange.startLineNumber + n, r.originalRange.endLineNumber + 1 + i), o = new lt(r.modifiedRange.startLineNumber + n, r.modifiedRange.endLineNumber + 1 + i);
  return new Po(s, o, [r]);
}
function Cgt(r) {
  return new ns(new lt(r.seq1Range.start + 1, r.seq1Range.endExclusive + 1), new lt(r.seq2Range.start + 1, r.seq2Range.endExclusive + 1));
}
const B5e = {
  getLegacy: () => new egt(),
  getDefault: () => new dLe()
};
function Ju(r, e) {
  const t = Math.pow(10, e);
  return Math.round(r * t) / t;
}
class Zt {
  constructor(e, t, n, i = 1) {
    this._rgbaBrand = void 0, this.r = Math.min(255, Math.max(0, e)) | 0, this.g = Math.min(255, Math.max(0, t)) | 0, this.b = Math.min(255, Math.max(0, n)) | 0, this.a = Ju(Math.max(Math.min(1, i), 0), 3);
  }
  static equals(e, t) {
    return e.r === t.r && e.g === t.g && e.b === t.b && e.a === t.a;
  }
}
class Za {
  constructor(e, t, n, i) {
    this._hslaBrand = void 0, this.h = Math.max(Math.min(360, e), 0) | 0, this.s = Ju(Math.max(Math.min(1, t), 0), 3), this.l = Ju(Math.max(Math.min(1, n), 0), 3), this.a = Ju(Math.max(Math.min(1, i), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.l === t.l && e.a === t.a;
  }
  /**
   * Converts an RGB color value to HSL. Conversion formula
   * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
   * Assumes r, g, and b are contained in the set [0, 255] and
   * returns h in the set [0, 360], s, and l in the set [0, 1].
   */
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, i = e.b / 255, s = e.a, o = Math.max(t, n, i), a = Math.min(t, n, i);
    let l = 0, c = 0;
    const d = (a + o) / 2, u = o - a;
    if (u > 0) {
      switch (c = Math.min(d <= 0.5 ? u / (2 * d) : u / (2 - 2 * d), 1), o) {
        case t:
          l = (n - i) / u + (n < i ? 6 : 0);
          break;
        case n:
          l = (i - t) / u + 2;
          break;
        case i:
          l = (t - n) / u + 4;
          break;
      }
      l *= 60, l = Math.round(l);
    }
    return new Za(l, c, d, s);
  }
  static _hue2rgb(e, t, n) {
    return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
  }
  /**
   * Converts an HSL color value to RGB. Conversion formula
   * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
   * Assumes h in the set [0, 360] s, and l are contained in the set [0, 1] and
   * returns r, g, and b in the set [0, 255].
   */
  static toRGBA(e) {
    const t = e.h / 360, { s: n, l: i, a: s } = e;
    let o, a, l;
    if (n === 0)
      o = a = l = i;
    else {
      const c = i < 0.5 ? i * (1 + n) : i + n - i * n, d = 2 * i - c;
      o = Za._hue2rgb(d, c, t + 1 / 3), a = Za._hue2rgb(d, c, t), l = Za._hue2rgb(d, c, t - 1 / 3);
    }
    return new Zt(Math.round(o * 255), Math.round(a * 255), Math.round(l * 255), s);
  }
}
class X2 {
  constructor(e, t, n, i) {
    this._hsvaBrand = void 0, this.h = Math.max(Math.min(360, e), 0) | 0, this.s = Ju(Math.max(Math.min(1, t), 0), 3), this.v = Ju(Math.max(Math.min(1, n), 0), 3), this.a = Ju(Math.max(Math.min(1, i), 0), 3);
  }
  static equals(e, t) {
    return e.h === t.h && e.s === t.s && e.v === t.v && e.a === t.a;
  }
  // from http://www.rapidtables.com/convert/color/rgb-to-hsv.htm
  static fromRGBA(e) {
    const t = e.r / 255, n = e.g / 255, i = e.b / 255, s = Math.max(t, n, i), o = Math.min(t, n, i), a = s - o, l = s === 0 ? 0 : a / s;
    let c;
    return a === 0 ? c = 0 : s === t ? c = ((n - i) / a % 6 + 6) % 6 : s === n ? c = (i - t) / a + 2 : c = (t - n) / a + 4, new X2(Math.round(c * 60), l, s, e.a);
  }
  // from http://www.rapidtables.com/convert/color/hsv-to-rgb.htm
  static toRGBA(e) {
    const { h: t, s: n, v: i, a: s } = e, o = i * n, a = o * (1 - Math.abs(t / 60 % 2 - 1)), l = i - o;
    let [c, d, u] = [0, 0, 0];
    return t < 60 ? (c = o, d = a) : t < 120 ? (c = a, d = o) : t < 180 ? (d = o, u = a) : t < 240 ? (d = a, u = o) : t < 300 ? (c = a, u = o) : t <= 360 && (c = o, u = a), c = Math.round((c + l) * 255), d = Math.round((d + l) * 255), u = Math.round((u + l) * 255), new Zt(c, d, u, s);
  }
}
class ge {
  static fromHex(e) {
    return ge.Format.CSS.parseHex(e) || ge.red;
  }
  static equals(e, t) {
    return !e && !t ? !0 : !e || !t ? !1 : e.equals(t);
  }
  get hsla() {
    return this._hsla ? this._hsla : Za.fromRGBA(this.rgba);
  }
  get hsva() {
    return this._hsva ? this._hsva : X2.fromRGBA(this.rgba);
  }
  constructor(e) {
    if (e)
      if (e instanceof Zt)
        this.rgba = e;
      else if (e instanceof Za)
        this._hsla = e, this.rgba = Za.toRGBA(e);
      else if (e instanceof X2)
        this._hsva = e, this.rgba = X2.toRGBA(e);
      else
        throw new Error("Invalid color ctor argument");
    else throw new Error("Color needs a value");
  }
  equals(e) {
    return !!e && Zt.equals(this.rgba, e.rgba) && Za.equals(this.hsla, e.hsla) && X2.equals(this.hsva, e.hsva);
  }
  /**
   * http://www.w3.org/TR/WCAG20/#relativeluminancedef
   * Returns the number in the set [0, 1]. O => Darkest Black. 1 => Lightest white.
   */
  getRelativeLuminance() {
    const e = ge._relativeLuminanceForComponent(this.rgba.r), t = ge._relativeLuminanceForComponent(this.rgba.g), n = ge._relativeLuminanceForComponent(this.rgba.b), i = 0.2126 * e + 0.7152 * t + 0.0722 * n;
    return Ju(i, 4);
  }
  static _relativeLuminanceForComponent(e) {
    const t = e / 255;
    return t <= 0.03928 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
  }
  /**
   *	http://24ways.org/2010/calculating-color-contrast
   *  Return 'true' if lighter color otherwise 'false'
   */
  isLighter() {
    return (this.rgba.r * 299 + this.rgba.g * 587 + this.rgba.b * 114) / 1e3 >= 128;
  }
  isLighterThan(e) {
    const t = this.getRelativeLuminance(), n = e.getRelativeLuminance();
    return t > n;
  }
  isDarkerThan(e) {
    const t = this.getRelativeLuminance(), n = e.getRelativeLuminance();
    return t < n;
  }
  lighten(e) {
    return new ge(new Za(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * e, this.hsla.a));
  }
  darken(e) {
    return new ge(new Za(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * e, this.hsla.a));
  }
  transparent(e) {
    const { r: t, g: n, b: i, a: s } = this.rgba;
    return new ge(new Zt(t, n, i, s * e));
  }
  isTransparent() {
    return this.rgba.a === 0;
  }
  isOpaque() {
    return this.rgba.a === 1;
  }
  opposite() {
    return new ge(new Zt(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
  }
  makeOpaque(e) {
    if (this.isOpaque() || e.rgba.a !== 1)
      return this;
    const { r: t, g: n, b: i, a: s } = this.rgba;
    return new ge(new Zt(e.rgba.r - s * (e.rgba.r - t), e.rgba.g - s * (e.rgba.g - n), e.rgba.b - s * (e.rgba.b - i), 1));
  }
  toString() {
    return this._toString || (this._toString = ge.Format.CSS.format(this)), this._toString;
  }
  static getLighterColor(e, t, n) {
    if (e.isLighterThan(t))
      return e;
    n = n || 0.5;
    const i = e.getRelativeLuminance(), s = t.getRelativeLuminance();
    return n = n * (s - i) / s, e.lighten(n);
  }
  static getDarkerColor(e, t, n) {
    if (e.isDarkerThan(t))
      return e;
    n = n || 0.5;
    const i = e.getRelativeLuminance(), s = t.getRelativeLuminance();
    return n = n * (i - s) / i, e.darken(n);
  }
  static {
    this.white = new ge(new Zt(255, 255, 255, 1));
  }
  static {
    this.black = new ge(new Zt(0, 0, 0, 1));
  }
  static {
    this.red = new ge(new Zt(255, 0, 0, 1));
  }
  static {
    this.blue = new ge(new Zt(0, 0, 255, 1));
  }
  static {
    this.green = new ge(new Zt(0, 255, 0, 1));
  }
  static {
    this.cyan = new ge(new Zt(0, 255, 255, 1));
  }
  static {
    this.lightgrey = new ge(new Zt(211, 211, 211, 1));
  }
  static {
    this.transparent = new ge(new Zt(0, 0, 0, 0));
  }
}
(function(r) {
  (function(e) {
    (function(t) {
      function n(p) {
        return p.rgba.a === 1 ? `rgb(${p.rgba.r}, ${p.rgba.g}, ${p.rgba.b})` : r.Format.CSS.formatRGBA(p);
      }
      t.formatRGB = n;
      function i(p) {
        return `rgba(${p.rgba.r}, ${p.rgba.g}, ${p.rgba.b}, ${+p.rgba.a.toFixed(2)})`;
      }
      t.formatRGBA = i;
      function s(p) {
        return p.hsla.a === 1 ? `hsl(${p.hsla.h}, ${(p.hsla.s * 100).toFixed(2)}%, ${(p.hsla.l * 100).toFixed(2)}%)` : r.Format.CSS.formatHSLA(p);
      }
      t.formatHSL = s;
      function o(p) {
        return `hsla(${p.hsla.h}, ${(p.hsla.s * 100).toFixed(2)}%, ${(p.hsla.l * 100).toFixed(2)}%, ${p.hsla.a.toFixed(2)})`;
      }
      t.formatHSLA = o;
      function a(p) {
        const g = p.toString(16);
        return g.length !== 2 ? "0" + g : g;
      }
      function l(p) {
        return `#${a(p.rgba.r)}${a(p.rgba.g)}${a(p.rgba.b)}`;
      }
      t.formatHex = l;
      function c(p, g = !1) {
        return g && p.rgba.a === 1 ? r.Format.CSS.formatHex(p) : `#${a(p.rgba.r)}${a(p.rgba.g)}${a(p.rgba.b)}${a(Math.round(p.rgba.a * 255))}`;
      }
      t.formatHexA = c;
      function d(p) {
        return p.isOpaque() ? r.Format.CSS.formatHex(p) : r.Format.CSS.formatRGBA(p);
      }
      t.format = d;
      function u(p) {
        const g = p.length;
        if (g === 0 || p.charCodeAt(0) !== 35)
          return null;
        if (g === 7) {
          const m = 16 * f(p.charCodeAt(1)) + f(p.charCodeAt(2)), A = 16 * f(p.charCodeAt(3)) + f(p.charCodeAt(4)), w = 16 * f(p.charCodeAt(5)) + f(p.charCodeAt(6));
          return new r(new Zt(m, A, w, 1));
        }
        if (g === 9) {
          const m = 16 * f(p.charCodeAt(1)) + f(p.charCodeAt(2)), A = 16 * f(p.charCodeAt(3)) + f(p.charCodeAt(4)), w = 16 * f(p.charCodeAt(5)) + f(p.charCodeAt(6)), v = 16 * f(p.charCodeAt(7)) + f(p.charCodeAt(8));
          return new r(new Zt(m, A, w, v / 255));
        }
        if (g === 4) {
          const m = f(p.charCodeAt(1)), A = f(p.charCodeAt(2)), w = f(p.charCodeAt(3));
          return new r(new Zt(16 * m + m, 16 * A + A, 16 * w + w));
        }
        if (g === 5) {
          const m = f(p.charCodeAt(1)), A = f(p.charCodeAt(2)), w = f(p.charCodeAt(3)), v = f(p.charCodeAt(4));
          return new r(new Zt(16 * m + m, 16 * A + A, 16 * w + w, (16 * v + v) / 255));
        }
        return null;
      }
      t.parseHex = u;
      function f(p) {
        switch (p) {
          case 48:
            return 0;
          case 49:
            return 1;
          case 50:
            return 2;
          case 51:
            return 3;
          case 52:
            return 4;
          case 53:
            return 5;
          case 54:
            return 6;
          case 55:
            return 7;
          case 56:
            return 8;
          case 57:
            return 9;
          case 97:
            return 10;
          case 65:
            return 10;
          case 98:
            return 11;
          case 66:
            return 11;
          case 99:
            return 12;
          case 67:
            return 12;
          case 100:
            return 13;
          case 68:
            return 13;
          case 101:
            return 14;
          case 69:
            return 14;
          case 102:
            return 15;
          case 70:
            return 15;
        }
        return 0;
      }
    })(e.CSS || (e.CSS = {}));
  })(r.Format || (r.Format = {}));
})(ge || (ge = {}));
function uLe(r) {
  const e = [];
  for (const t of r) {
    const n = Number(t);
    (n || n === 0 && t.replace(/\s/g, "") !== "") && e.push(n);
  }
  return e;
}
function hO(r, e, t, n) {
  return {
    red: r / 255,
    blue: t / 255,
    green: e / 255,
    alpha: n
  };
}
function Om(r, e) {
  const t = e.index, n = e[0].length;
  if (!t)
    return;
  const i = r.positionAt(t);
  return {
    startLineNumber: i.lineNumber,
    startColumn: i.column,
    endLineNumber: i.lineNumber,
    endColumn: i.column + n
  };
}
function Egt(r, e) {
  if (!r)
    return;
  const t = ge.Format.CSS.parseHex(e);
  if (t)
    return {
      range: r,
      color: hO(t.rgba.r, t.rgba.g, t.rgba.b, t.rgba.a)
    };
}
function P5e(r, e, t) {
  if (!r || e.length !== 1)
    return;
  const i = e[0].values(), s = uLe(i);
  return {
    range: r,
    color: hO(s[0], s[1], s[2], t ? s[3] : 1)
  };
}
function F5e(r, e, t) {
  if (!r || e.length !== 1)
    return;
  const i = e[0].values(), s = uLe(i), o = new ge(new Za(s[0], s[1] / 100, s[2] / 100, t ? s[3] : 1));
  return {
    range: r,
    color: hO(o.rgba.r, o.rgba.g, o.rgba.b, o.rgba.a)
  };
}
function Rm(r, e) {
  return typeof r == "string" ? [...r.matchAll(e)] : r.findMatches(e);
}
function _gt(r) {
  const e = [], n = Rm(r, /\b(rgb|rgba|hsl|hsla)(\([0-9\s,.\%]*\))|(#)([A-Fa-f0-9]{3})\b|(#)([A-Fa-f0-9]{4})\b|(#)([A-Fa-f0-9]{6})\b|(#)([A-Fa-f0-9]{8})\b/gm);
  if (n.length > 0)
    for (const i of n) {
      const s = i.filter((c) => c !== void 0), o = s[1], a = s[2];
      if (!a)
        continue;
      let l;
      if (o === "rgb") {
        const c = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*\)$/gm;
        l = P5e(Om(r, i), Rm(a, c), !1);
      } else if (o === "rgba") {
        const c = /^\(\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]|[0-9])\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = P5e(Om(r, i), Rm(a, c), !0);
      } else if (o === "hsl") {
        const c = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*\)$/gm;
        l = F5e(Om(r, i), Rm(a, c), !1);
      } else if (o === "hsla") {
        const c = /^\(\s*(36[0]|3[0-5][0-9]|[12][0-9][0-9]|[1-9]?[0-9])\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(100|\d{1,2}[.]\d*|\d{1,2})%\s*,\s*(0[.][0-9]+|[.][0-9]+|[01][.]|[01])\s*\)$/gm;
        l = F5e(Om(r, i), Rm(a, c), !0);
      } else o === "#" && (l = Egt(Om(r, i), o + a));
      l && e.push(l);
    }
  return e;
}
function xgt(r) {
  return !r || typeof r.getValue != "function" || typeof r.positionAt != "function" ? [] : _gt(r);
}
const z5e = new RegExp("\\bMARK:\\s*(.*)$", "d"), Sgt = /^-+|-+$/g;
function Mgt(r, e) {
  let t = [];
  if (e.findRegionSectionHeaders && e.foldingRules?.markers) {
    const n = Dgt(r, e);
    t = t.concat(n);
  }
  if (e.findMarkSectionHeaders) {
    const n = Lgt(r);
    t = t.concat(n);
  }
  return t;
}
function Dgt(r, e) {
  const t = [], n = r.getLineCount();
  for (let i = 1; i <= n; i++) {
    const s = r.getLineContent(i), o = s.match(e.foldingRules.markers.start);
    if (o) {
      const a = { startLineNumber: i, startColumn: o[0].length + 1, endLineNumber: i, endColumn: s.length + 1 };
      if (a.endColumn > a.startColumn) {
        const l = {
          range: a,
          ...fLe(s.substring(o[0].length)),
          shouldBeInComments: !1
        };
        (l.text || l.hasSeparatorLine) && t.push(l);
      }
    }
  }
  return t;
}
function Lgt(r) {
  const e = [], t = r.getLineCount();
  for (let n = 1; n <= t; n++) {
    const i = r.getLineContent(n);
    kgt(i, n, e);
  }
  return e;
}
function kgt(r, e, t) {
  z5e.lastIndex = 0;
  const n = z5e.exec(r);
  if (n) {
    const i = n.indices[1][0] + 1, s = n.indices[1][1] + 1, o = { startLineNumber: e, startColumn: i, endLineNumber: e, endColumn: s };
    if (o.endColumn > o.startColumn) {
      const a = {
        range: o,
        ...fLe(n[1]),
        shouldBeInComments: !0
      };
      (a.text || a.hasSeparatorLine) && t.push(a);
    }
  }
}
function fLe(r) {
  r = r.trim();
  const e = r.startsWith("-");
  return r = r.replace(Sgt, ""), { text: r, hasSeparatorLine: e };
}
class Ngt extends Cpt {
  get uri() {
    return this._uri;
  }
  get eol() {
    return this._eol;
  }
  getValue() {
    return this.getText();
  }
  findMatches(e) {
    const t = [];
    for (let n = 0; n < this._lines.length; n++) {
      const i = this._lines[n], s = this.offsetAt(new le(n + 1, 1)), o = i.matchAll(e);
      for (const a of o)
        (a.index || a.index === 0) && (a.index = a.index + s), t.push(a);
    }
    return t;
  }
  getLinesContent() {
    return this._lines.slice(0);
  }
  getLineCount() {
    return this._lines.length;
  }
  getLineContent(e) {
    return this._lines[e - 1];
  }
  getWordAtPosition(e, t) {
    const n = O3(e.column, _I(t), this._lines[e.lineNumber - 1], 0);
    return n ? new Q(e.lineNumber, n.startColumn, e.lineNumber, n.endColumn) : null;
  }
  words(e) {
    const t = this._lines, n = this._wordenize.bind(this);
    let i = 0, s = "", o = 0, a = [];
    return {
      *[Symbol.iterator]() {
        for (; ; )
          if (o < a.length) {
            const l = s.substring(a[o].start, a[o].end);
            o += 1, yield l;
          } else if (i < t.length)
            s = t[i], a = n(s, e), o = 0, i += 1;
          else
            break;
      }
    };
  }
  getLineWords(e, t) {
    const n = this._lines[e - 1], i = this._wordenize(n, t), s = [];
    for (const o of i)
      s.push({
        word: n.substring(o.start, o.end),
        startColumn: o.start + 1,
        endColumn: o.end + 1
      });
    return s;
  }
  _wordenize(e, t) {
    const n = [];
    let i;
    for (t.lastIndex = 0; (i = t.exec(e)) && i[0].length !== 0; )
      n.push({ start: i.index, end: i.index + i[0].length });
    return n;
  }
  getValueInRange(e) {
    if (e = this._validateRange(e), e.startLineNumber === e.endLineNumber)
      return this._lines[e.startLineNumber - 1].substring(e.startColumn - 1, e.endColumn - 1);
    const t = this._eol, n = e.startLineNumber - 1, i = e.endLineNumber - 1, s = [];
    s.push(this._lines[n].substring(e.startColumn - 1));
    for (let o = n + 1; o < i; o++)
      s.push(this._lines[o]);
    return s.push(this._lines[i].substring(0, e.endColumn - 1)), s.join(t);
  }
  offsetAt(e) {
    return e = this._validatePosition(e), this._ensureLineStarts(), this._lineStarts.getPrefixSum(e.lineNumber - 2) + (e.column - 1);
  }
  positionAt(e) {
    e = Math.floor(e), e = Math.max(0, e), this._ensureLineStarts();
    const t = this._lineStarts.getIndexOf(e), n = this._lines[t.index].length;
    return {
      lineNumber: 1 + t.index,
      column: 1 + Math.min(t.remainder, n)
    };
  }
  _validateRange(e) {
    const t = this._validatePosition({ lineNumber: e.startLineNumber, column: e.startColumn }), n = this._validatePosition({ lineNumber: e.endLineNumber, column: e.endColumn });
    return t.lineNumber !== e.startLineNumber || t.column !== e.startColumn || n.lineNumber !== e.endLineNumber || n.column !== e.endColumn ? {
      startLineNumber: t.lineNumber,
      startColumn: t.column,
      endLineNumber: n.lineNumber,
      endColumn: n.column
    } : e;
  }
  _validatePosition(e) {
    if (!le.isIPosition(e))
      throw new Error("bad position");
    let { lineNumber: t, column: n } = e, i = !1;
    if (t < 1)
      t = 1, n = 1, i = !0;
    else if (t > this._lines.length)
      t = this._lines.length, n = this._lines[t - 1].length + 1, i = !0;
    else {
      const s = this._lines[t - 1].length + 1;
      n < 1 ? (n = 1, i = !0) : n > s && (n = s, i = !0);
    }
    return i ? { lineNumber: t, column: n } : e;
  }
}
class yp {
  constructor(e, t) {
    this._host = e, this._models = /* @__PURE__ */ Object.create(null), this._foreignModuleFactory = t, this._foreignModule = null;
  }
  dispose() {
    this._models = /* @__PURE__ */ Object.create(null);
  }
  _getModel(e) {
    return this._models[e];
  }
  _getModels() {
    const e = [];
    return Object.keys(this._models).forEach((t) => e.push(this._models[t])), e;
  }
  acceptNewModel(e) {
    this._models[e.url] = new Ngt(Pt.parse(e.url), e.lines, e.EOL, e.versionId);
  }
  acceptModelChanged(e, t) {
    if (!this._models[e])
      return;
    this._models[e].onEvents(t);
  }
  acceptRemovedModel(e) {
    this._models[e] && delete this._models[e];
  }
  async computeUnicodeHighlights(e, t, n) {
    const i = this._getModel(e);
    return i ? Wpt.computeUnicodeHighlights(i, t, n) : { ranges: [], hasMore: !1, ambiguousCharacterCount: 0, invisibleCharacterCount: 0, nonBasicAsciiCharacterCount: 0 };
  }
  async findSectionHeaders(e, t) {
    const n = this._getModel(e);
    return n ? Mgt(n, t) : [];
  }
  // ---- BEGIN diff --------------------------------------------------------------------------
  async computeDiff(e, t, n, i) {
    const s = this._getModel(e), o = this._getModel(t);
    return !s || !o ? null : yp.computeDiff(s, o, n, i);
  }
  static computeDiff(e, t, n, i) {
    const s = i === "advanced" ? B5e.getDefault() : B5e.getLegacy(), o = e.getLinesContent(), a = t.getLinesContent(), l = s.computeDiff(o, a, n), c = l.changes.length > 0 ? !1 : this._modelsAreIdentical(e, t);
    function d(u) {
      return u.map((f) => [f.original.startLineNumber, f.original.endLineNumberExclusive, f.modified.startLineNumber, f.modified.endLineNumberExclusive, f.innerChanges?.map((p) => [
        p.originalRange.startLineNumber,
        p.originalRange.startColumn,
        p.originalRange.endLineNumber,
        p.originalRange.endColumn,
        p.modifiedRange.startLineNumber,
        p.modifiedRange.startColumn,
        p.modifiedRange.endLineNumber,
        p.modifiedRange.endColumn
      ])]);
    }
    return {
      identical: c,
      quitEarly: l.hitTimeout,
      changes: d(l.changes),
      moves: l.moves.map((u) => [
        u.lineRangeMapping.original.startLineNumber,
        u.lineRangeMapping.original.endLineNumberExclusive,
        u.lineRangeMapping.modified.startLineNumber,
        u.lineRangeMapping.modified.endLineNumberExclusive,
        d(u.changes)
      ])
    };
  }
  static _modelsAreIdentical(e, t) {
    const n = e.getLineCount(), i = t.getLineCount();
    if (n !== i)
      return !1;
    for (let s = 1; s <= n; s++) {
      const o = e.getLineContent(s), a = t.getLineContent(s);
      if (o !== a)
        return !1;
    }
    return !0;
  }
  static {
    this._diffLimit = 1e5;
  }
  async computeMoreMinimalEdits(e, t, n) {
    const i = this._getModel(e);
    if (!i)
      return t;
    const s = [];
    let o;
    t = t.slice(0).sort((l, c) => {
      if (l.range && c.range)
        return Q.compareRangesUsingStarts(l.range, c.range);
      const d = l.range ? 0 : 1, u = c.range ? 0 : 1;
      return d - u;
    });
    let a = 0;
    for (let l = 1; l < t.length; l++)
      Q.getEndPosition(t[a].range).equals(Q.getStartPosition(t[l].range)) ? (t[a].range = Q.fromPositions(Q.getStartPosition(t[a].range), Q.getEndPosition(t[l].range)), t[a].text += t[l].text) : (a++, t[a] = t[l]);
    t.length = a + 1;
    for (let { range: l, text: c, eol: d } of t) {
      if (typeof d == "number" && (o = d), Q.isEmpty(l) && !c)
        continue;
      const u = i.getValueInRange(l);
      if (c = c.replace(/\r\n|\n|\r/g, i.eol), u === c)
        continue;
      if (Math.max(c.length, u.length) > yp._diffLimit) {
        s.push({ range: l, text: c });
        continue;
      }
      const f = vpt(u, c, n), p = i.offsetAt(Q.lift(l).getStartPosition());
      for (const g of f) {
        const m = i.positionAt(p + g.originalStart), A = i.positionAt(p + g.originalStart + g.originalLength), w = {
          text: c.substr(g.modifiedStart, g.modifiedLength),
          range: { startLineNumber: m.lineNumber, startColumn: m.column, endLineNumber: A.lineNumber, endColumn: A.column }
        };
        i.getValueInRange(w.range) !== w.text && s.push(w);
      }
    }
    return typeof o == "number" && s.push({ eol: o, text: "", range: { startLineNumber: 0, startColumn: 0, endLineNumber: 0, endColumn: 0 } }), s;
  }
  // ---- END minimal edits ---------------------------------------------------------------
  async computeLinks(e) {
    const t = this._getModel(e);
    return t ? Mpt(t) : null;
  }
  // --- BEGIN default document colors -----------------------------------------------------------
  async computeDefaultDocumentColors(e) {
    const t = this._getModel(e);
    return t ? xgt(t) : null;
  }
  static {
    this._suggestionsLimit = 1e4;
  }
  async textualSuggest(e, t, n, i) {
    const s = new jf(), o = new RegExp(n, i), a = /* @__PURE__ */ new Set();
    e: for (const l of e) {
      const c = this._getModel(l);
      if (c) {
        for (const d of c.words(o))
          if (!(d === t || !isNaN(Number(d))) && (a.add(d), a.size > yp._suggestionsLimit))
            break e;
      }
    }
    return { words: Array.from(a), duration: s.elapsed() };
  }
  // ---- END suggest --------------------------------------------------------------------------
  //#region -- word ranges --
  async computeWordRanges(e, t, n, i) {
    const s = this._getModel(e);
    if (!s)
      return /* @__PURE__ */ Object.create(null);
    const o = new RegExp(n, i), a = /* @__PURE__ */ Object.create(null);
    for (let l = t.startLineNumber; l < t.endLineNumber; l++) {
      const c = s.getLineWords(l, o);
      for (const d of c) {
        if (!isNaN(Number(d.word)))
          continue;
        let u = a[d.word];
        u || (u = [], a[d.word] = u), u.push({
          startLineNumber: l,
          startColumn: d.startColumn,
          endLineNumber: l,
          endColumn: d.endColumn
        });
      }
    }
    return a;
  }
  //#endregion
  async navigateValueSet(e, t, n, i, s) {
    const o = this._getModel(e);
    if (!o)
      return null;
    const a = new RegExp(i, s);
    t.startColumn === t.endColumn && (t = {
      startLineNumber: t.startLineNumber,
      startColumn: t.startColumn,
      endLineNumber: t.endLineNumber,
      endColumn: t.endColumn + 1
    });
    const l = o.getValueInRange(t), c = o.getWordAtPosition({ lineNumber: t.startLineNumber, column: t.startColumn }, a);
    if (!c)
      return null;
    const d = o.getValueInRange(c);
    return aO.INSTANCE.navigateValueSet(t, l, c, d, n);
  }
  // ---- BEGIN foreign module support --------------------------------------------------------------------------
  loadForeignModule(e, t, n) {
    const o = {
      host: yut(n, (a, l) => this._host.fhr(a, l)),
      getMirrorModels: () => this._getModels()
    };
    return this._foreignModuleFactory ? (this._foreignModule = this._foreignModuleFactory(o, t), Promise.resolve(bI(this._foreignModule))) : Promise.reject(new Error("Unexpected usage"));
  }
  // foreign method request
  fmr(e, t) {
    if (!this._foreignModule || typeof this._foreignModule[e] != "function")
      return Promise.reject(new Error("Missing requestHandler or method: " + e));
    try {
      return Promise.resolve(this._foreignModule[e].apply(this._foreignModule, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
}
typeof importScripts == "function" && (globalThis.monaco = eDe());
const pLe = Wt("textResourceConfigurationService"), gLe = Wt("textResourcePropertiesService"), Vn = Wt("ILanguageFeaturesService");
var Tgt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Vm = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const W5e = 60 * 1e3, j5e = 5 * 60 * 1e3;
function g0(r, e) {
  const t = r.getModel(e);
  return !(!t || t.isTooLargeForSyncing());
}
let $D = class extends me {
  constructor(e, t, n, i, s) {
    super(), this._modelService = e, this._workerManager = this._register(new Ogt(this._modelService, i)), this._logService = n, this._register(s.linkProvider.register({ language: "*", hasAccessToAllModels: !0 }, {
      provideLinks: (o, a) => g0(this._modelService, o.uri) ? this._workerManager.withWorker().then((l) => l.computeLinks(o.uri)).then((l) => l && { links: l }) : Promise.resolve({ links: [] })
    })), this._register(s.completionProvider.register("*", new Igt(this._workerManager, t, this._modelService, i)));
  }
  dispose() {
    super.dispose();
  }
  canComputeUnicodeHighlights(e) {
    return g0(this._modelService, e);
  }
  computedUnicodeHighlights(e, t, n) {
    return this._workerManager.withWorker().then((i) => i.computedUnicodeHighlights(e, t, n));
  }
  async computeDiff(e, t, n, i) {
    const s = await this._workerManager.withWorker().then((l) => l.computeDiff(e, t, n, i));
    if (!s)
      return null;
    return {
      identical: s.identical,
      quitEarly: s.quitEarly,
      changes: a(s.changes),
      moves: s.moves.map((l) => new oLe(new ns(new lt(l[0], l[1]), new lt(l[2], l[3])), a(l[4])))
    };
    function a(l) {
      return l.map((c) => new Po(new lt(c[0], c[1]), new lt(c[2], c[3]), c[4]?.map((d) => new Eo(new Q(d[0], d[1], d[2], d[3]), new Q(d[4], d[5], d[6], d[7])))));
    }
  }
  computeMoreMinimalEdits(e, t, n = !1) {
    if (k7(t)) {
      if (!g0(this._modelService, e))
        return Promise.resolve(t);
      const i = jf.create(), s = this._workerManager.withWorker().then((o) => o.computeMoreMinimalEdits(e, t, n));
      return s.finally(() => this._logService.trace("FORMAT#computeMoreMinimalEdits", e.toString(!0), i.elapsed())), Promise.race([s, B3(1e3).then(() => t)]);
    } else
      return Promise.resolve(void 0);
  }
  canNavigateValueSet(e) {
    return g0(this._modelService, e);
  }
  navigateValueSet(e, t, n) {
    return this._workerManager.withWorker().then((i) => i.navigateValueSet(e, t, n));
  }
  canComputeWordRanges(e) {
    return g0(this._modelService, e);
  }
  computeWordRanges(e, t) {
    return this._workerManager.withWorker().then((n) => n.computeWordRanges(e, t));
  }
  findSectionHeaders(e, t) {
    return this._workerManager.withWorker().then((n) => n.findSectionHeaders(e, t));
  }
};
$D = Tgt([
  Vm(0, Wo),
  Vm(1, pLe),
  Vm(2, _h),
  Vm(3, xh),
  Vm(4, Vn)
], $D);
class Igt {
  constructor(e, t, n, i) {
    this.languageConfigurationService = i, this._debugDisplayName = "wordbasedCompletions", this._workerManager = e, this._configurationService = t, this._modelService = n;
  }
  async provideCompletionItems(e, t) {
    const n = this._configurationService.getValue(e.uri, t, "editor");
    if (n.wordBasedSuggestions === "off")
      return;
    const i = [];
    if (n.wordBasedSuggestions === "currentDocument")
      g0(this._modelService, e.uri) && i.push(e.uri);
    else
      for (const u of this._modelService.getModels())
        g0(this._modelService, u.uri) && (u === e ? i.unshift(u.uri) : (n.wordBasedSuggestions === "allDocuments" || u.getLanguageId() === e.getLanguageId()) && i.push(u.uri));
    if (i.length === 0)
      return;
    const s = this.languageConfigurationService.getLanguageConfiguration(e.getLanguageId()).getWordDefinition(), o = e.getWordAtPosition(t), a = o ? new Q(t.lineNumber, o.startColumn, t.lineNumber, o.endColumn) : Q.fromPositions(t), l = a.setEndPosition(t.lineNumber, t.column), d = await (await this._workerManager.withWorker()).textualSuggest(i, o?.word, s);
    if (d)
      return {
        duration: d.duration,
        suggestions: d.words.map((u) => ({
          kind: 18,
          label: u,
          insertText: u,
          range: { insert: l, replace: a }
        }))
      };
  }
}
class Ogt extends me {
  constructor(e, t) {
    super(), this.languageConfigurationService = t, this._modelService = e, this._editorWorkerClient = null, this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._register(new qI()).cancelAndSet(() => this._checkStopIdleWorker(), Math.round(j5e / 2), Sn), this._register(this._modelService.onModelRemoved((i) => this._checkStopEmptyWorker()));
  }
  dispose() {
    this._editorWorkerClient && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null), super.dispose();
  }
  /**
   * Check if the model service has no more models and stop the worker if that is the case.
   */
  _checkStopEmptyWorker() {
    if (!this._editorWorkerClient)
      return;
    this._modelService.getModels().length === 0 && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  /**
   * Check if the worker has been idle for a while and then stop it.
   */
  _checkStopIdleWorker() {
    if (!this._editorWorkerClient)
      return;
    (/* @__PURE__ */ new Date()).getTime() - this._lastWorkerUsedTime > j5e && (this._editorWorkerClient.dispose(), this._editorWorkerClient = null);
  }
  withWorker() {
    return this._lastWorkerUsedTime = (/* @__PURE__ */ new Date()).getTime(), this._editorWorkerClient || (this._editorWorkerClient = new mLe(this._modelService, !1, "editorWorkerService", this.languageConfigurationService)), Promise.resolve(this._editorWorkerClient);
  }
}
class Rgt extends me {
  constructor(e, t, n) {
    if (super(), this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), this._proxy = e, this._modelService = t, !n) {
      const i = new WI();
      i.cancelAndSet(() => this._checkStopModelSync(), Math.round(W5e / 2)), this._register(i);
    }
  }
  dispose() {
    for (const e in this._syncedModels)
      br(this._syncedModels[e]);
    this._syncedModels = /* @__PURE__ */ Object.create(null), this._syncedModelsLastUsedTime = /* @__PURE__ */ Object.create(null), super.dispose();
  }
  ensureSyncedResources(e, t) {
    for (const n of e) {
      const i = n.toString();
      this._syncedModels[i] || this._beginModelSync(n, t), this._syncedModels[i] && (this._syncedModelsLastUsedTime[i] = (/* @__PURE__ */ new Date()).getTime());
    }
  }
  _checkStopModelSync() {
    const e = (/* @__PURE__ */ new Date()).getTime(), t = [];
    for (const n in this._syncedModelsLastUsedTime)
      e - this._syncedModelsLastUsedTime[n] > W5e && t.push(n);
    for (const n of t)
      this._stopModelSync(n);
  }
  _beginModelSync(e, t) {
    const n = this._modelService.getModel(e);
    if (!n || !t && n.isTooLargeForSyncing())
      return;
    const i = e.toString();
    this._proxy.acceptNewModel({
      url: n.uri.toString(),
      lines: n.getLinesContent(),
      EOL: n.getEOL(),
      versionId: n.getVersionId()
    });
    const s = new ze();
    s.add(n.onDidChangeContent((o) => {
      this._proxy.acceptModelChanged(i.toString(), o);
    })), s.add(n.onWillDispose(() => {
      this._stopModelSync(i);
    })), s.add(ht(() => {
      this._proxy.acceptRemovedModel(i);
    })), this._syncedModels[i] = s;
  }
  _stopModelSync(e) {
    const t = this._syncedModels[e];
    delete this._syncedModels[e], delete this._syncedModelsLastUsedTime[e], br(t);
  }
}
class Z5e {
  constructor(e) {
    this._instance = e, this._proxyObj = Promise.resolve(this._instance);
  }
  dispose() {
    this._instance.dispose();
  }
  getProxyObject() {
    return this._proxyObj;
  }
}
class WE {
  constructor(e) {
    this._workerClient = e;
  }
  // foreign host request
  fhr(e, t) {
    return this._workerClient.fhr(e, t);
  }
}
class mLe extends me {
  constructor(e, t, n, i) {
    super(), this.languageConfigurationService = i, this._disposed = !1, this._modelService = e, this._keepIdleModels = t, this._workerFactory = new rO(n), this._worker = null, this._modelManager = null;
  }
  // foreign host request
  fhr(e, t) {
    throw new Error("Not implemented!");
  }
  _getOrCreateWorker() {
    if (!this._worker)
      try {
        this._worker = this._register(new T2t(this._workerFactory, "vs/editor/common/services/editorSimpleWorker", new WE(this)));
      } catch (e) {
        UD(e), this._worker = new Z5e(new yp(new WE(this), null));
      }
    return this._worker;
  }
  _getProxy() {
    return this._getOrCreateWorker().getProxyObject().then(void 0, (e) => (UD(e), this._worker = new Z5e(new yp(new WE(this), null)), this._getOrCreateWorker().getProxyObject()));
  }
  _getOrCreateModelManager(e) {
    return this._modelManager || (this._modelManager = this._register(new Rgt(e, this._modelService, this._keepIdleModels))), this._modelManager;
  }
  async _withSyncedResources(e, t = !1) {
    return this._disposed ? Promise.reject(k1t()) : this._getProxy().then((n) => (this._getOrCreateModelManager(n).ensureSyncedResources(e, t), n));
  }
  computedUnicodeHighlights(e, t, n) {
    return this._withSyncedResources([e]).then((i) => i.computeUnicodeHighlights(e.toString(), t, n));
  }
  computeDiff(e, t, n, i) {
    return this._withSyncedResources(
      [e, t],
      /* forceLargeModels */
      !0
    ).then((s) => s.computeDiff(e.toString(), t.toString(), n, i));
  }
  computeMoreMinimalEdits(e, t, n) {
    return this._withSyncedResources([e]).then((i) => i.computeMoreMinimalEdits(e.toString(), t, n));
  }
  computeLinks(e) {
    return this._withSyncedResources([e]).then((t) => t.computeLinks(e.toString()));
  }
  computeDefaultDocumentColors(e) {
    return this._withSyncedResources([e]).then((t) => t.computeDefaultDocumentColors(e.toString()));
  }
  async textualSuggest(e, t, n) {
    const i = await this._withSyncedResources(e), s = n.source, o = n.flags;
    return i.textualSuggest(e.map((a) => a.toString()), t, s, o);
  }
  computeWordRanges(e, t) {
    return this._withSyncedResources([e]).then((n) => {
      const i = this._modelService.getModel(e);
      if (!i)
        return Promise.resolve(null);
      const s = this.languageConfigurationService.getLanguageConfiguration(i.getLanguageId()).getWordDefinition(), o = s.source, a = s.flags;
      return n.computeWordRanges(e.toString(), t, o, a);
    });
  }
  navigateValueSet(e, t, n) {
    return this._withSyncedResources([e]).then((i) => {
      const s = this._modelService.getModel(e);
      if (!s)
        return null;
      const o = this.languageConfigurationService.getLanguageConfiguration(s.getLanguageId()).getWordDefinition(), a = o.source, l = o.flags;
      return i.navigateValueSet(e.toString(), t, n, a, l);
    });
  }
  findSectionHeaders(e, t) {
    return this._withSyncedResources([e]).then((n) => n.findSectionHeaders(e.toString(), t));
  }
  dispose() {
    super.dispose(), this._disposed = !0;
  }
}
function Vgt(r, e, t) {
  return new Hgt(r, e, t);
}
class Hgt extends mLe {
  constructor(e, t, n) {
    super(e, n.keepIdleModels || !1, n.label, t), this._foreignModuleId = n.moduleId, this._foreignModuleCreateData = n.createData || null, this._foreignModuleHost = n.host || null, this._foreignProxy = null;
  }
  // foreign host request
  fhr(e, t) {
    if (!this._foreignModuleHost || typeof this._foreignModuleHost[e] != "function")
      return Promise.reject(new Error("Missing method " + e + " or missing main thread foreign host."));
    try {
      return Promise.resolve(this._foreignModuleHost[e].apply(this._foreignModuleHost, t));
    } catch (n) {
      return Promise.reject(n);
    }
  }
  _getForeignProxy() {
    return this._foreignProxy || (this._foreignProxy = this._getProxy().then((e) => {
      const t = this._foreignModuleHost ? bI(this._foreignModuleHost) : [];
      return e.loadForeignModule(this._foreignModuleId, this._foreignModuleCreateData, t).then((n) => {
        this._foreignModuleCreateData = null;
        const i = (a, l) => e.fmr(a, l), s = (a, l) => function() {
          const c = Array.prototype.slice.call(arguments, 0);
          return l(a, c);
        }, o = {};
        for (const a of n)
          o[a] = s(a, i);
        return o;
      });
    })), this._foreignProxy;
  }
  getProxy() {
    return this._getForeignProxy();
  }
  withSyncedResources(e) {
    return this._withSyncedResources(e).then((t) => this.getProxy());
  }
}
const dO = {
  ICodeEditor: "vs.editor.ICodeEditor",
  IDiffEditor: "vs.editor.IDiffEditor"
}, Z3 = new class {
  clone() {
    return this;
  }
  equals(r) {
    return this === r;
  }
}();
function ALe(r, e) {
  return new TI([new V3(0, "", r)], e);
}
function uO(r, e) {
  const t = new Uint32Array(2);
  return t[0] = 0, t[1] = (r << 0 | 0 | 0 | 32768 | 2 << 24) >>> 0, new O7(t, e === null ? Z3 : e);
}
class Vl {
  static getLanguageId(e) {
    return (e & 255) >>> 0;
  }
  static getTokenType(e) {
    return (e & 768) >>> 8;
  }
  static containsBalancedBrackets(e) {
    return (e & 1024) !== 0;
  }
  static getFontStyle(e) {
    return (e & 30720) >>> 11;
  }
  static getForeground(e) {
    return (e & 16744448) >>> 15;
  }
  static getBackground(e) {
    return (e & 4278190080) >>> 24;
  }
  static getClassNameFromMetadata(e) {
    let n = "mtk" + this.getForeground(e);
    const i = this.getFontStyle(e);
    return i & 1 && (n += " mtki"), i & 2 && (n += " mtkb"), i & 4 && (n += " mtku"), i & 8 && (n += " mtks"), n;
  }
  static getInlineStyleFromMetadata(e, t) {
    const n = this.getForeground(e), i = this.getFontStyle(e);
    let s = `color: ${t[n]};`;
    i & 1 && (s += "font-style: italic;"), i & 2 && (s += "font-weight: bold;");
    let o = "";
    return i & 4 && (o += " underline"), i & 8 && (o += " line-through"), o && (s += `text-decoration:${o};`), s;
  }
  static getPresentationFromMetadata(e) {
    const t = this.getForeground(e), n = this.getFontStyle(e);
    return {
      foreground: t,
      italic: !!(n & 1),
      bold: !!(n & 2),
      underline: !!(n & 4),
      strikethrough: !!(n & 8)
    };
  }
}
class Ri {
  static {
    this.defaultTokenMetadata = (32768 | 2 << 24) >>> 0;
  }
  static createEmpty(e, t) {
    const n = Ri.defaultTokenMetadata, i = new Uint32Array(2);
    return i[0] = e.length, i[1] = n, new Ri(i, e, t);
  }
  static createFromTextAndMetadata(e, t) {
    let n = 0, i = "";
    const s = new Array();
    for (const { text: o, metadata: a } of e)
      s.push(n + o.length, a), n += o.length, i += o;
    return new Ri(new Uint32Array(s), i, t);
  }
  constructor(e, t, n) {
    this._lineTokensBrand = void 0, this._tokens = e, this._tokensCount = this._tokens.length >>> 1, this._text = t, this.languageIdCodec = n;
  }
  equals(e) {
    return e instanceof Ri ? this.slicedEquals(e, 0, this._tokensCount) : !1;
  }
  slicedEquals(e, t, n) {
    if (this._text !== e._text || this._tokensCount !== e._tokensCount)
      return !1;
    const i = t << 1, s = i + (n << 1);
    for (let o = i; o < s; o++)
      if (this._tokens[o] !== e._tokens[o])
        return !1;
    return !0;
  }
  getLineContent() {
    return this._text;
  }
  getCount() {
    return this._tokensCount;
  }
  getStartOffset(e) {
    return e > 0 ? this._tokens[e - 1 << 1] : 0;
  }
  getMetadata(e) {
    return this._tokens[(e << 1) + 1];
  }
  getLanguageId(e) {
    const t = this._tokens[(e << 1) + 1], n = Vl.getLanguageId(t);
    return this.languageIdCodec.decodeLanguageId(n);
  }
  getStandardTokenType(e) {
    const t = this._tokens[(e << 1) + 1];
    return Vl.getTokenType(t);
  }
  getForeground(e) {
    const t = this._tokens[(e << 1) + 1];
    return Vl.getForeground(t);
  }
  getClassName(e) {
    const t = this._tokens[(e << 1) + 1];
    return Vl.getClassNameFromMetadata(t);
  }
  getInlineStyle(e, t) {
    const n = this._tokens[(e << 1) + 1];
    return Vl.getInlineStyleFromMetadata(n, t);
  }
  getPresentation(e) {
    const t = this._tokens[(e << 1) + 1];
    return Vl.getPresentationFromMetadata(t);
  }
  getEndOffset(e) {
    return this._tokens[e << 1];
  }
  /**
   * Find the token containing offset `offset`.
   * @param offset The search offset
   * @return The index of the token containing the offset.
   */
  findTokenIndexAtOffset(e) {
    return Ri.findIndexInTokensArray(this._tokens, e);
  }
  inflate() {
    return this;
  }
  sliceAndInflate(e, t, n) {
    return new fO(this, e, t, n);
  }
  static convertToEndOffset(e, t) {
    const i = (e.length >>> 1) - 1;
    for (let s = 0; s < i; s++)
      e[s << 1] = e[s + 1 << 1];
    e[i << 1] = t;
  }
  static findIndexInTokensArray(e, t) {
    if (e.length <= 2)
      return 0;
    let n = 0, i = (e.length >>> 1) - 1;
    for (; n < i; ) {
      const s = n + Math.floor((i - n) / 2), o = e[s << 1];
      if (o === t)
        return s + 1;
      o < t ? n = s + 1 : o > t && (i = s);
    }
    return n;
  }
  /**
   * @pure
   * @param insertTokens Must be sorted by offset.
  */
  withInserted(e) {
    if (e.length === 0)
      return this;
    let t = 0, n = 0, i = "";
    const s = new Array();
    let o = 0;
    for (; ; ) {
      const a = t < this._tokensCount ? this._tokens[t << 1] : -1, l = n < e.length ? e[n] : null;
      if (a !== -1 && (l === null || a <= l.offset)) {
        i += this._text.substring(o, a);
        const c = this._tokens[(t << 1) + 1];
        s.push(i.length, c), t++, o = a;
      } else if (l) {
        if (l.offset > o) {
          i += this._text.substring(o, l.offset);
          const c = this._tokens[(t << 1) + 1];
          s.push(i.length, c), o = l.offset;
        }
        i += l.text, s.push(i.length, l.tokenMetadata), n++;
      } else
        break;
    }
    return new Ri(new Uint32Array(s), i, this.languageIdCodec);
  }
  getTokenText(e) {
    const t = this.getStartOffset(e), n = this.getEndOffset(e);
    return this._text.substring(t, n);
  }
  forEach(e) {
    const t = this.getCount();
    for (let n = 0; n < t; n++)
      e(n);
  }
}
class fO {
  constructor(e, t, n, i) {
    this._source = e, this._startOffset = t, this._endOffset = n, this._deltaOffset = i, this._firstTokenIndex = e.findTokenIndexAtOffset(t), this.languageIdCodec = e.languageIdCodec, this._tokensCount = 0;
    for (let s = this._firstTokenIndex, o = e.getCount(); s < o && !(e.getStartOffset(s) >= n); s++)
      this._tokensCount++;
  }
  getMetadata(e) {
    return this._source.getMetadata(this._firstTokenIndex + e);
  }
  getLanguageId(e) {
    return this._source.getLanguageId(this._firstTokenIndex + e);
  }
  getLineContent() {
    return this._source.getLineContent().substring(this._startOffset, this._endOffset);
  }
  equals(e) {
    return e instanceof fO ? this._startOffset === e._startOffset && this._endOffset === e._endOffset && this._deltaOffset === e._deltaOffset && this._source.slicedEquals(e._source, this._firstTokenIndex, this._tokensCount) : !1;
  }
  getCount() {
    return this._tokensCount;
  }
  getStandardTokenType(e) {
    return this._source.getStandardTokenType(this._firstTokenIndex + e);
  }
  getForeground(e) {
    return this._source.getForeground(this._firstTokenIndex + e);
  }
  getEndOffset(e) {
    const t = this._source.getEndOffset(this._firstTokenIndex + e);
    return Math.min(this._endOffset, t) - this._startOffset + this._deltaOffset;
  }
  getClassName(e) {
    return this._source.getClassName(this._firstTokenIndex + e);
  }
  getInlineStyle(e, t) {
    return this._source.getInlineStyle(this._firstTokenIndex + e, t);
  }
  getPresentation(e) {
    return this._source.getPresentation(this._firstTokenIndex + e);
  }
  findTokenIndexAtOffset(e) {
    return this._source.findTokenIndexAtOffset(e + this._startOffset - this._deltaOffset) - this._firstTokenIndex;
  }
  getTokenText(e) {
    const t = this._firstTokenIndex + e, n = this._source.getStartOffset(t), i = this._source.getEndOffset(t);
    let s = this._source.getTokenText(t);
    return n < this._startOffset && (s = s.substring(this._startOffset - n)), i > this._endOffset && (s = s.substring(0, s.length - (i - this._endOffset))), s;
  }
  forEach(e) {
    for (let t = 0; t < this.getCount(); t++)
      e(t);
  }
}
let bf = class fA {
  constructor(e, t, n, i) {
    this.startColumn = e, this.endColumn = t, this.className = n, this.type = i, this._lineDecorationBrand = void 0;
  }
  static _equals(e, t) {
    return e.startColumn === t.startColumn && e.endColumn === t.endColumn && e.className === t.className && e.type === t.type;
  }
  static equalsArr(e, t) {
    const n = e.length, i = t.length;
    if (n !== i)
      return !1;
    for (let s = 0; s < n; s++)
      if (!fA._equals(e[s], t[s]))
        return !1;
    return !0;
  }
  static extractWrapped(e, t, n) {
    if (e.length === 0)
      return e;
    const i = t + 1, s = n + 1, o = n - t, a = [];
    let l = 0;
    for (const c of e)
      c.endColumn <= i || c.startColumn >= s || (a[l++] = new fA(Math.max(1, c.startColumn - i + 1), Math.min(o + 1, c.endColumn - i + 1), c.className, c.type));
    return a;
  }
  static filter(e, t, n, i) {
    if (e.length === 0)
      return [];
    const s = [];
    let o = 0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a], d = c.range;
      if (d.endLineNumber < t || d.startLineNumber > t || d.isEmpty() && (c.type === 0 || c.type === 3))
        continue;
      const u = d.startLineNumber === t ? d.startColumn : n, f = d.endLineNumber === t ? d.endColumn : i;
      s[o++] = new fA(u, f, c.inlineClassName, c.type);
    }
    return s;
  }
  static _typeCompare(e, t) {
    const n = [2, 0, 1, 3];
    return n[e] - n[t];
  }
  static compare(e, t) {
    if (e.startColumn !== t.startColumn)
      return e.startColumn - t.startColumn;
    if (e.endColumn !== t.endColumn)
      return e.endColumn - t.endColumn;
    const n = fA._typeCompare(e.type, t.type);
    return n !== 0 ? n : e.className !== t.className ? e.className < t.className ? -1 : 1 : 0;
  }
};
class U5e {
  constructor(e, t, n, i) {
    this.startOffset = e, this.endOffset = t, this.className = n, this.metadata = i;
  }
}
let Bgt = class eL {
  constructor() {
    this.stopOffsets = [], this.classNames = [], this.metadata = [], this.count = 0;
  }
  static _metadata(e) {
    let t = 0;
    for (let n = 0, i = e.length; n < i; n++)
      t |= e[n];
    return t;
  }
  consumeLowerThan(e, t, n) {
    for (; this.count > 0 && this.stopOffsets[0] < e; ) {
      let i = 0;
      for (; i + 1 < this.count && this.stopOffsets[i] === this.stopOffsets[i + 1]; )
        i++;
      n.push(new U5e(t, this.stopOffsets[i], this.classNames.join(" "), eL._metadata(this.metadata))), t = this.stopOffsets[i] + 1, this.stopOffsets.splice(0, i + 1), this.classNames.splice(0, i + 1), this.metadata.splice(0, i + 1), this.count -= i + 1;
    }
    return this.count > 0 && t < e && (n.push(new U5e(t, e - 1, this.classNames.join(" "), eL._metadata(this.metadata))), t = e), t;
  }
  insert(e, t, n) {
    if (this.count === 0 || this.stopOffsets[this.count - 1] <= e)
      this.stopOffsets.push(e), this.classNames.push(t), this.metadata.push(n);
    else
      for (let i = 0; i < this.count; i++)
        if (this.stopOffsets[i] >= e) {
          this.stopOffsets.splice(i, 0, e), this.classNames.splice(i, 0, t), this.metadata.splice(i, 0, n);
          break;
        }
    this.count++;
  }
};
class Pgt {
  /**
   * Normalize line decorations. Overlapping decorations will generate multiple segments
   */
  static normalize(e, t) {
    if (t.length === 0)
      return [];
    const n = [], i = new Bgt();
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      let c = l.startColumn, d = l.endColumn;
      const u = l.className, f = l.type === 1 ? 2 : l.type === 2 ? 4 : 0;
      if (c > 1) {
        const m = e.charCodeAt(c - 2);
        Ki(m) && c--;
      }
      if (d > 1) {
        const m = e.charCodeAt(d - 2);
        Ki(m) && d--;
      }
      const p = c - 1, g = d - 2;
      s = i.consumeLowerThan(p, s, n), i.count === 0 && (s = p), i.insert(g, u, f);
    }
    return i.consumeLowerThan(1073741824, s, n), n;
  }
}
class Yi {
  constructor(e, t, n, i) {
    this.endIndex = e, this.type = t, this.metadata = n, this.containsRTL = i, this._linePartBrand = void 0;
  }
  isWhitespace() {
    return !!(this.metadata & 1);
  }
  isPseudoAfter() {
    return !!(this.metadata & 4);
  }
}
class wLe {
  constructor(e, t) {
    this.startOffset = e, this.endOffset = t;
  }
  equals(e) {
    return this.startOffset === e.startOffset && this.endOffset === e.endOffset;
  }
}
class tm {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f, p, g, m, A, w, v, y) {
    this.useMonospaceOptimizations = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.continuesWithWrappedLine = i, this.isBasicASCII = s, this.containsRTL = o, this.fauxIndentLength = a, this.lineTokens = l, this.lineDecorations = c.sort(bf.compare), this.tabSize = d, this.startVisibleColumn = u, this.spaceWidth = f, this.stopRenderingLineAfter = m, this.renderWhitespace = A === "all" ? 4 : A === "boundary" ? 1 : A === "selection" ? 2 : A === "trailing" ? 3 : 0, this.renderControlCharacters = w, this.fontLigatures = v, this.selectionsOnLine = y && y.sort((D, M) => D.startOffset < M.startOffset ? -1 : 1);
    const _ = Math.abs(g - f), S = Math.abs(p - f);
    _ < S ? (this.renderSpaceWidth = g, this.renderSpaceCharCode = 11825) : (this.renderSpaceWidth = p, this.renderSpaceCharCode = 183);
  }
  sameSelection(e) {
    if (this.selectionsOnLine === null)
      return e === null;
    if (e === null || e.length !== this.selectionsOnLine.length)
      return !1;
    for (let t = 0; t < this.selectionsOnLine.length; t++)
      if (!this.selectionsOnLine[t].equals(e[t]))
        return !1;
    return !0;
  }
  equals(e) {
    return this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineContent === e.lineContent && this.continuesWithWrappedLine === e.continuesWithWrappedLine && this.isBasicASCII === e.isBasicASCII && this.containsRTL === e.containsRTL && this.fauxIndentLength === e.fauxIndentLength && this.tabSize === e.tabSize && this.startVisibleColumn === e.startVisibleColumn && this.spaceWidth === e.spaceWidth && this.renderSpaceWidth === e.renderSpaceWidth && this.renderSpaceCharCode === e.renderSpaceCharCode && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.fontLigatures === e.fontLigatures && bf.equalsArr(this.lineDecorations, e.lineDecorations) && this.lineTokens.equals(e.lineTokens) && this.sameSelection(e.selectionsOnLine);
  }
}
class vLe {
  constructor(e, t) {
    this.partIndex = e, this.charIndex = t;
  }
}
class Zc {
  static getPartIndex(e) {
    return (e & 4294901760) >>> 16;
  }
  static getCharIndex(e) {
    return (e & 65535) >>> 0;
  }
  constructor(e, t) {
    this.length = e, this._data = new Uint32Array(this.length), this._horizontalOffset = new Uint32Array(this.length);
  }
  setColumnInfo(e, t, n, i) {
    const s = (t << 16 | n << 0) >>> 0;
    this._data[e - 1] = s, this._horizontalOffset[e - 1] = i;
  }
  getHorizontalOffset(e) {
    return this._horizontalOffset.length === 0 ? 0 : this._horizontalOffset[e - 1];
  }
  charOffsetToPartData(e) {
    return this.length === 0 ? 0 : e < 0 ? this._data[0] : e >= this.length ? this._data[this.length - 1] : this._data[e];
  }
  getDomPosition(e) {
    const t = this.charOffsetToPartData(e - 1), n = Zc.getPartIndex(t), i = Zc.getCharIndex(t);
    return new vLe(n, i);
  }
  getColumn(e, t) {
    return this.partDataToCharOffset(e.partIndex, t, e.charIndex) + 1;
  }
  partDataToCharOffset(e, t, n) {
    if (this.length === 0)
      return 0;
    const i = (e << 16 | n << 0) >>> 0;
    let s = 0, o = this.length - 1;
    for (; s + 1 < o; ) {
      const m = s + o >>> 1, A = this._data[m];
      if (A === i)
        return m;
      A > i ? o = m : s = m;
    }
    if (s === o)
      return s;
    const a = this._data[s], l = this._data[o];
    if (a === i)
      return s;
    if (l === i)
      return o;
    const c = Zc.getPartIndex(a), d = Zc.getCharIndex(a), u = Zc.getPartIndex(l);
    let f;
    c !== u ? f = t : f = Zc.getCharIndex(l);
    const p = n - d, g = f - n;
    return p <= g ? s : o;
  }
}
class tL {
  constructor(e, t, n) {
    this._renderLineOutputBrand = void 0, this.characterMapping = e, this.containsRTL = t, this.containsForeignElements = n;
  }
}
function pO(r, e) {
  if (r.lineContent.length === 0) {
    if (r.lineDecorations.length > 0) {
      e.appendString("<span>");
      let t = 0, n = 0, i = 0;
      for (const o of r.lineDecorations)
        (o.type === 1 || o.type === 2) && (e.appendString('<span class="'), e.appendString(o.className), e.appendString('"></span>'), o.type === 1 && (i |= 1, t++), o.type === 2 && (i |= 2, n++));
      e.appendString("</span>");
      const s = new Zc(1, t + n);
      return s.setColumnInfo(1, t, 0, 0), new tL(s, !1, i);
    }
    return e.appendString("<span><span></span></span>"), new tL(
      new Zc(0, 0),
      !1,
      0
      /* ForeignElementType.None */
    );
  }
  return Qgt(Wgt(r), e);
}
class Fgt {
  constructor(e, t, n, i) {
    this.characterMapping = e, this.html = t, this.containsRTL = n, this.containsForeignElements = i;
  }
}
function ny(r) {
  const e = new J7(1e4), t = pO(r, e);
  return new Fgt(t.characterMapping, e.build(), t.containsRTL, t.containsForeignElements);
}
class zgt {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f, p, g, m, A) {
    this.fontIsMonospace = e, this.canUseHalfwidthRightwardsArrow = t, this.lineContent = n, this.len = i, this.isOverflowing = s, this.overflowingCharCount = o, this.parts = a, this.containsForeignElements = l, this.fauxIndentLength = c, this.tabSize = d, this.startVisibleColumn = u, this.containsRTL = f, this.spaceWidth = p, this.renderSpaceCharCode = g, this.renderWhitespace = m, this.renderControlCharacters = A;
  }
}
function Wgt(r) {
  const e = r.lineContent;
  let t, n, i;
  r.stopRenderingLineAfter !== -1 && r.stopRenderingLineAfter < e.length ? (t = !0, n = e.length - r.stopRenderingLineAfter, i = r.stopRenderingLineAfter) : (t = !1, n = 0, i = e.length);
  let s = jgt(e, r.containsRTL, r.lineTokens, r.fauxIndentLength, i);
  r.renderControlCharacters && !r.isBasicASCII && (s = Ugt(e, s)), (r.renderWhitespace === 4 || r.renderWhitespace === 1 || r.renderWhitespace === 2 && r.selectionsOnLine || r.renderWhitespace === 3 && !r.continuesWithWrappedLine) && (s = qgt(r, e, i, s));
  let o = 0;
  if (r.lineDecorations.length > 0) {
    for (let a = 0, l = r.lineDecorations.length; a < l; a++) {
      const c = r.lineDecorations[a];
      c.type === 3 || c.type === 1 ? o |= 1 : c.type === 2 && (o |= 2);
    }
    s = Ggt(e, i, s, r.lineDecorations);
  }
  return r.containsRTL || (s = Zgt(e, s, !r.isBasicASCII || r.fontLigatures)), new zgt(r.useMonospaceOptimizations, r.canUseHalfwidthRightwardsArrow, e, i, t, n, s, o, r.fauxIndentLength, r.tabSize, r.startVisibleColumn, r.containsRTL, r.spaceWidth, r.renderSpaceCharCode, r.renderWhitespace, r.renderControlCharacters);
}
function jgt(r, e, t, n, i) {
  const s = [];
  let o = 0;
  n > 0 && (s[o++] = new Yi(n, "", 0, !1));
  let a = n;
  for (let l = 0, c = t.getCount(); l < c; l++) {
    const d = t.getEndOffset(l);
    if (d <= n)
      continue;
    const u = t.getClassName(l);
    if (d >= i) {
      const p = e ? H3(r.substring(a, i)) : !1;
      s[o++] = new Yi(i, u, 0, p);
      break;
    }
    const f = e ? H3(r.substring(a, d)) : !1;
    s[o++] = new Yi(d, u, 0, f), a = d;
  }
  return s;
}
function Zgt(r, e, t) {
  let n = 0;
  const i = [];
  let s = 0;
  if (t)
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o], c = l.endIndex;
      if (n + 50 < c) {
        const d = l.type, u = l.metadata, f = l.containsRTL;
        let p = -1, g = n;
        for (let m = n; m < c; m++)
          r.charCodeAt(m) === 32 && (p = m), p !== -1 && m - g >= 50 && (i[s++] = new Yi(p + 1, d, u, f), g = p + 1, p = -1);
        g !== c && (i[s++] = new Yi(c, d, u, f));
      } else
        i[s++] = l;
      n = c;
    }
  else
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o], c = l.endIndex, d = c - n;
      if (d > 50) {
        const u = l.type, f = l.metadata, p = l.containsRTL, g = Math.ceil(
          d / 50
          /* Constants.LongToken */
        );
        for (let m = 1; m < g; m++) {
          const A = n + m * 50;
          i[s++] = new Yi(A, u, f, p);
        }
        i[s++] = new Yi(c, u, f, p);
      } else
        i[s++] = l;
      n = c;
    }
  return i;
}
function bLe(r) {
  return r < 32 ? r !== 9 : r === 127 || r >= 8234 && r <= 8238 || r >= 8294 && r <= 8297 || r >= 8206 && r <= 8207 || r === 1564;
}
function Ugt(r, e) {
  const t = [];
  let n = new Yi(0, "", 0, !1), i = 0;
  for (const s of e) {
    const o = s.endIndex;
    for (; i < o; i++) {
      const a = r.charCodeAt(i);
      bLe(a) && (i > n.endIndex && (n = new Yi(i, s.type, s.metadata, s.containsRTL), t.push(n)), n = new Yi(i + 1, "mtkcontrol", s.metadata, !1), t.push(n));
    }
    i > n.endIndex && (n = new Yi(o, s.type, s.metadata, s.containsRTL), t.push(n));
  }
  return t;
}
function qgt(r, e, t, n) {
  const i = r.continuesWithWrappedLine, s = r.fauxIndentLength, o = r.tabSize, a = r.startVisibleColumn, l = r.useMonospaceOptimizations, c = r.selectionsOnLine, d = r.renderWhitespace === 1, u = r.renderWhitespace === 3, f = r.renderSpaceWidth !== r.spaceWidth, p = [];
  let g = 0, m = 0, A = n[m].type, w = n[m].containsRTL, v = n[m].endIndex;
  const y = n.length;
  let _ = !1, S = so(e), D;
  S === -1 ? (_ = !0, S = t, D = t) : D = Zf(e);
  let M = !1, L = 0, T = c && c[L], B = a % o;
  for (let N = s; N < t; N++) {
    const R = e.charCodeAt(N);
    T && N >= T.endOffset && (L++, T = c && c[L]);
    let H;
    if (N < S || N > D)
      H = !0;
    else if (R === 9)
      H = !0;
    else if (R === 32)
      if (d)
        if (M)
          H = !0;
        else {
          const z = N + 1 < t ? e.charCodeAt(N + 1) : 0;
          H = z === 32 || z === 9;
        }
      else
        H = !0;
    else
      H = !1;
    if (H && c && (H = !!T && T.startOffset <= N && T.endOffset > N), H && u && (H = _ || N > D), H && w && N >= S && N <= D && (H = !1), M) {
      if (!H || !l && B >= o) {
        if (f) {
          const z = g > 0 ? p[g - 1].endIndex : s;
          for (let U = z + 1; U <= N; U++)
            p[g++] = new Yi(U, "mtkw", 1, !1);
        } else
          p[g++] = new Yi(N, "mtkw", 1, !1);
        B = B % o;
      }
    } else
      (N === v || H && N > s) && (p[g++] = new Yi(N, A, 0, w), B = B % o);
    for (R === 9 ? B = o : a1(R) ? B += 2 : B++, M = H; N === v && (m++, m < y); )
      A = n[m].type, w = n[m].containsRTL, v = n[m].endIndex;
  }
  let V = !1;
  if (M)
    if (i && d) {
      const N = t > 0 ? e.charCodeAt(t - 1) : 0, R = t > 1 ? e.charCodeAt(t - 2) : 0;
      N === 32 && R !== 32 && R !== 9 || (V = !0);
    } else
      V = !0;
  if (V)
    if (f) {
      const N = g > 0 ? p[g - 1].endIndex : s;
      for (let R = N + 1; R <= t; R++)
        p[g++] = new Yi(R, "mtkw", 1, !1);
    } else
      p[g++] = new Yi(t, "mtkw", 1, !1);
  else
    p[g++] = new Yi(t, A, 0, w);
  return p;
}
function Ggt(r, e, t, n) {
  n.sort(bf.compare);
  const i = Pgt.normalize(r, n), s = i.length;
  let o = 0;
  const a = [];
  let l = 0, c = 0;
  for (let u = 0, f = t.length; u < f; u++) {
    const p = t[u], g = p.endIndex, m = p.type, A = p.metadata, w = p.containsRTL;
    for (; o < s && i[o].startOffset < g; ) {
      const v = i[o];
      if (v.startOffset > c && (c = v.startOffset, a[l++] = new Yi(c, m, A, w)), v.endOffset + 1 <= g)
        c = v.endOffset + 1, a[l++] = new Yi(c, m + " " + v.className, A | v.metadata, w), o++;
      else {
        c = g, a[l++] = new Yi(c, m + " " + v.className, A | v.metadata, w);
        break;
      }
    }
    g > c && (c = g, a[l++] = new Yi(c, m, A, w));
  }
  const d = t[t.length - 1].endIndex;
  if (o < s && i[o].startOffset === d)
    for (; o < s && i[o].startOffset === d; ) {
      const u = i[o];
      a[l++] = new Yi(c, u.className, u.metadata, !1), o++;
    }
  return a;
}
function Qgt(r, e) {
  const t = r.fontIsMonospace, n = r.canUseHalfwidthRightwardsArrow, i = r.containsForeignElements, s = r.lineContent, o = r.len, a = r.isOverflowing, l = r.overflowingCharCount, c = r.parts, d = r.fauxIndentLength, u = r.tabSize, f = r.startVisibleColumn, p = r.containsRTL, g = r.spaceWidth, m = r.renderSpaceCharCode, A = r.renderWhitespace, w = r.renderControlCharacters, v = new Zc(o + 1, c.length);
  let y = !1, _ = 0, S = f, D = 0, M = 0, L = 0;
  p ? e.appendString('<span dir="ltr">') : e.appendString("<span>");
  for (let T = 0, B = c.length; T < B; T++) {
    const V = c[T], N = V.endIndex, R = V.type, H = V.containsRTL, z = A !== 0 && V.isWhitespace(), U = z && !t && (R === "mtkw" || !i), ee = _ === N && V.isPseudoAfter();
    if (D = 0, e.appendString("<span "), H && e.appendString('style="unicode-bidi:isolate" '), e.appendString('class="'), e.appendString(U ? "mtkz" : R), e.appendASCIICharCode(
      34
      /* CharCode.DoubleQuote */
    ), z) {
      let ce = 0;
      {
        let se = _, te = S;
        for (; se < N; se++) {
          const G = (s.charCodeAt(se) === 9 ? u - te % u : 1) | 0;
          ce += G, se >= d && (te += G);
        }
      }
      for (U && (e.appendString(' style="width:'), e.appendString(String(g * ce)), e.appendString('px"')), e.appendASCIICharCode(
        62
        /* CharCode.GreaterThan */
      ); _ < N; _++) {
        v.setColumnInfo(_ + 1, T - L, D, M), L = 0;
        const se = s.charCodeAt(_);
        let te, ue;
        if (se === 9) {
          te = u - S % u | 0, ue = te, !n || ue > 1 ? e.appendCharCode(8594) : e.appendCharCode(65515);
          for (let G = 2; G <= ue; G++)
            e.appendCharCode(160);
        } else
          te = 2, ue = 1, e.appendCharCode(m), e.appendCharCode(8204);
        D += te, M += ue, _ >= d && (S += ue);
      }
    } else
      for (e.appendASCIICharCode(
        62
        /* CharCode.GreaterThan */
      ); _ < N; _++) {
        v.setColumnInfo(_ + 1, T - L, D, M), L = 0;
        const ce = s.charCodeAt(_);
        let se = 1, te = 1;
        switch (ce) {
          case 9:
            se = u - S % u, te = se;
            for (let ue = 1; ue <= se; ue++)
              e.appendCharCode(160);
            break;
          case 32:
            e.appendCharCode(160);
            break;
          case 60:
            e.appendString("&lt;");
            break;
          case 62:
            e.appendString("&gt;");
            break;
          case 38:
            e.appendString("&amp;");
            break;
          case 0:
            w ? e.appendCharCode(9216) : e.appendString("&#00;");
            break;
          case 65279:
          case 8232:
          case 8233:
          case 133:
            e.appendCharCode(65533);
            break;
          default:
            a1(ce) && te++, w && ce < 32 ? e.appendCharCode(9216 + ce) : w && ce === 127 ? e.appendCharCode(9249) : w && bLe(ce) ? (e.appendString("[U+"), e.appendString(Kgt(ce)), e.appendString("]"), se = 8, te = se) : e.appendCharCode(ce);
        }
        D += se, M += te, _ >= d && (S += te);
      }
    ee ? L++ : L = 0, _ >= o && !y && V.isPseudoAfter() && (y = !0, v.setColumnInfo(_ + 1, T, D, M)), e.appendString("</span>");
  }
  return y || v.setColumnInfo(o + 1, c.length - 1, D, M), a && (e.appendString('<span class="mtkoverflow">'), e.appendString(C("showMore", "Show more ({0})", Ygt(l))), e.appendString("</span>")), e.appendString("</span>"), new tL(v, p, i);
}
function Kgt(r) {
  return r.toString(16).toUpperCase().padStart(4, "0");
}
function Ygt(r) {
  return r < 1024 ? C("overflow.chars", "{0} chars", r) : r < 1024 * 1024 ? `${(r / 1024).toFixed(1)} KB` : `${(r / 1024 / 1024).toFixed(1)} MB`;
}
let q5e = class {
  constructor(e, t, n, i) {
    this._viewportBrand = void 0, this.top = e | 0, this.left = t | 0, this.width = n | 0, this.height = i | 0;
  }
};
class Xgt {
  constructor(e, t) {
    this.tabSize = e, this.data = t;
  }
}
class gO {
  constructor(e, t, n, i, s, o, a) {
    this._viewLineDataBrand = void 0, this.content = e, this.continuesWithWrappedLine = t, this.minColumn = n, this.maxColumn = i, this.startVisibleColumn = s, this.tokens = o, this.inlineDecorations = a;
  }
}
class zo {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    this.minColumn = e, this.maxColumn = t, this.content = n, this.continuesWithWrappedLine = i, this.isBasicASCII = zo.isBasicASCII(n, o), this.containsRTL = zo.containsRTL(n, this.isBasicASCII, s), this.tokens = a, this.inlineDecorations = l, this.tabSize = c, this.startVisibleColumn = d;
  }
  static isBasicASCII(e, t) {
    return t ? BI(e) : !0;
  }
  static containsRTL(e, t, n) {
    return !t && n ? H3(e) : !1;
  }
}
class WA {
  constructor(e, t, n) {
    this.range = e, this.inlineClassName = t, this.type = n;
  }
}
class Jgt {
  constructor(e, t, n, i) {
    this.startOffset = e, this.endOffset = t, this.inlineClassName = n, this.inlineClassNameAffectsLetterSpacing = i;
  }
  toInlineDecoration(e) {
    return new WA(
      new Q(e, this.startOffset + 1, e, this.endOffset + 1),
      this.inlineClassName,
      this.inlineClassNameAffectsLetterSpacing ? 3 : 0
      /* InlineDecorationType.Regular */
    );
  }
}
class yLe {
  constructor(e, t) {
    this._viewModelDecorationBrand = void 0, this.range = e, this.options = t;
  }
}
class U3 {
  constructor(e, t, n) {
    this.color = e, this.zIndex = t, this.data = n;
  }
  static compareByRenderingProps(e, t) {
    return e.zIndex === t.zIndex ? e.color < t.color ? -1 : e.color > t.color ? 1 : 0 : e.zIndex - t.zIndex;
  }
  static equals(e, t) {
    return e.color === t.color && e.zIndex === t.zIndex && Zi(e.data, t.data);
  }
  static equalsArr(e, t) {
    return Zi(e, t, U3.equals);
  }
}
function $gt(r) {
  return Array.isArray(r);
}
function emt(r) {
  return !$gt(r);
}
function CLe(r) {
  return typeof r == "string";
}
function G5e(r) {
  return !CLe(r);
}
function m0(r) {
  return !r;
}
function Sd(r, e) {
  return r.ignoreCase && e ? e.toLowerCase() : e;
}
function Q5e(r) {
  return r.replace(/[&<>'"_]/g, "-");
}
function tmt(r, e) {
  console.log(`${r.languageId}: ${e}`);
}
function Pn(r, e) {
  return new Error(`${r.languageId}: ${e}`);
}
function Eu(r, e, t, n, i) {
  const s = /\$((\$)|(#)|(\d\d?)|[sS](\d\d?)|@(\w+))/g;
  let o = null;
  return e.replace(s, function(a, l, c, d, u, f, p, g, m) {
    return m0(c) ? m0(d) ? !m0(u) && u < n.length ? Sd(r, n[u]) : !m0(p) && r && typeof r[p] == "string" ? r[p] : (o === null && (o = i.split("."), o.unshift(i)), !m0(f) && f < o.length ? Sd(r, o[f]) : "") : Sd(r, t) : "$";
  });
}
function nmt(r, e, t) {
  const n = /\$[sS](\d\d?)/g;
  let i = null;
  return e.replace(n, function(s, o) {
    return i === null && (i = t.split("."), i.unshift(t)), !m0(o) && o < i.length ? Sd(r, i[o]) : "";
  });
}
function Iv(r, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    const n = r.tokenizer[t];
    if (n)
      return n;
    const i = t.lastIndexOf(".");
    i < 0 ? t = null : t = t.substr(0, i);
  }
  return null;
}
function imt(r, e) {
  let t = e;
  for (; t && t.length > 0; ) {
    if (r.stateNames[t])
      return !0;
    const i = t.lastIndexOf(".");
    i < 0 ? t = null : t = t.substr(0, i);
  }
  return !1;
}
var rmt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, smt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, nL;
const ELe = 5;
class q3 {
  static {
    this._INSTANCE = new q3(ELe);
  }
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (e !== null && e.depth >= this._maxCacheDepth)
      return new Cp(e, t);
    let n = Cp.getStackElementId(e);
    n.length > 0 && (n += "|"), n += t;
    let i = this._entries[n];
    return i || (i = new Cp(e, t), this._entries[n] = i, i);
  }
}
class Cp {
  constructor(e, t) {
    this.parent = e, this.state = t, this.depth = (this.parent ? this.parent.depth : 0) + 1;
  }
  static getStackElementId(e) {
    let t = "";
    for (; e !== null; )
      t.length > 0 && (t += "|"), t += e.state, e = e.parent;
    return t;
  }
  static _equals(e, t) {
    for (; e !== null && t !== null; ) {
      if (e === t)
        return !0;
      if (e.state !== t.state)
        return !1;
      e = e.parent, t = t.parent;
    }
    return e === null && t === null;
  }
  equals(e) {
    return Cp._equals(this, e);
  }
  push(e) {
    return q3.create(this, e);
  }
  pop() {
    return this.parent;
  }
  popall() {
    let e = this;
    for (; e.parent; )
      e = e.parent;
    return e;
  }
  switchTo(e) {
    return q3.create(this.parent, e);
  }
}
class J2 {
  constructor(e, t) {
    this.languageId = e, this.state = t;
  }
  equals(e) {
    return this.languageId === e.languageId && this.state.equals(e.state);
  }
  clone() {
    return this.state.clone() === this.state ? this : new J2(this.languageId, this.state);
  }
}
class _u {
  static {
    this._INSTANCE = new _u(ELe);
  }
  static create(e, t) {
    return this._INSTANCE.create(e, t);
  }
  constructor(e) {
    this._maxCacheDepth = e, this._entries = /* @__PURE__ */ Object.create(null);
  }
  create(e, t) {
    if (t !== null)
      return new jA(e, t);
    if (e !== null && e.depth >= this._maxCacheDepth)
      return new jA(e, t);
    const n = Cp.getStackElementId(e);
    let i = this._entries[n];
    return i || (i = new jA(e, null), this._entries[n] = i, i);
  }
}
class jA {
  constructor(e, t) {
    this.stack = e, this.embeddedLanguageData = t;
  }
  clone() {
    return (this.embeddedLanguageData ? this.embeddedLanguageData.clone() : null) === this.embeddedLanguageData ? this : _u.create(this.stack, this.embeddedLanguageData);
  }
  equals(e) {
    return !(e instanceof jA) || !this.stack.equals(e.stack) ? !1 : this.embeddedLanguageData === null && e.embeddedLanguageData === null ? !0 : this.embeddedLanguageData === null || e.embeddedLanguageData === null ? !1 : this.embeddedLanguageData.equals(e.embeddedLanguageData);
  }
}
class omt {
  constructor() {
    this._tokens = [], this._languageId = null, this._lastTokenType = null, this._lastTokenLanguage = null;
  }
  enterLanguage(e) {
    this._languageId = e;
  }
  emit(e, t) {
    this._lastTokenType === t && this._lastTokenLanguage === this._languageId || (this._lastTokenType = t, this._lastTokenLanguage = this._languageId, this._tokens.push(new V3(e, t, this._languageId)));
  }
  nestedLanguageTokenize(e, t, n, i) {
    const s = n.languageId, o = n.state, a = xi.get(s);
    if (!a)
      return this.enterLanguage(s), this.emit(i, ""), o;
    const l = a.tokenize(e, t, o);
    if (i !== 0)
      for (const c of l.tokens)
        this._tokens.push(new V3(c.offset + i, c.type, c.language));
    else
      this._tokens = this._tokens.concat(l.tokens);
    return this._lastTokenType = null, this._lastTokenLanguage = null, this._languageId = null, l.endState;
  }
  finalize(e) {
    return new TI(this._tokens, e);
  }
}
class Y8 {
  constructor(e, t) {
    this._languageService = e, this._theme = t, this._prependTokens = null, this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0;
  }
  enterLanguage(e) {
    this._currentLanguageId = this._languageService.languageIdCodec.encodeLanguageId(e);
  }
  emit(e, t) {
    const n = this._theme.match(this._currentLanguageId, t) | 1024;
    this._lastTokenMetadata !== n && (this._lastTokenMetadata = n, this._tokens.push(e), this._tokens.push(n));
  }
  static _merge(e, t, n) {
    const i = e !== null ? e.length : 0, s = t.length, o = n !== null ? n.length : 0;
    if (i === 0 && s === 0 && o === 0)
      return new Uint32Array(0);
    if (i === 0 && s === 0)
      return n;
    if (s === 0 && o === 0)
      return e;
    const a = new Uint32Array(i + s + o);
    e !== null && a.set(e);
    for (let l = 0; l < s; l++)
      a[i + l] = t[l];
    return n !== null && a.set(n, i + s), a;
  }
  nestedLanguageTokenize(e, t, n, i) {
    const s = n.languageId, o = n.state, a = xi.get(s);
    if (!a)
      return this.enterLanguage(s), this.emit(i, ""), o;
    const l = a.tokenizeEncoded(e, t, o);
    if (i !== 0)
      for (let c = 0, d = l.tokens.length; c < d; c += 2)
        l.tokens[c] += i;
    return this._prependTokens = Y8._merge(this._prependTokens, this._tokens, l.tokens), this._tokens = [], this._currentLanguageId = 0, this._lastTokenMetadata = 0, l.endState;
  }
  finalize(e) {
    return new O7(Y8._merge(this._prependTokens, this._tokens, null), e);
  }
}
let G3 = nL = class extends me {
  constructor(e, t, n, i, s) {
    super(), this._configurationService = s, this._languageService = e, this._standaloneThemeService = t, this._languageId = n, this._lexer = i, this._embeddedLanguages = /* @__PURE__ */ Object.create(null), this.embeddedLoaded = Promise.resolve(void 0);
    let o = !1;
    this._register(xi.onDidChange((a) => {
      if (o)
        return;
      let l = !1;
      for (let c = 0, d = a.changedLanguages.length; c < d; c++) {
        const u = a.changedLanguages[c];
        if (this._embeddedLanguages[u]) {
          l = !0;
          break;
        }
      }
      l && (o = !0, xi.handleChange([this._languageId]), o = !1);
    })), this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
      overrideIdentifier: this._languageId
    }), this._register(this._configurationService.onDidChangeConfiguration((a) => {
      a.affectsConfiguration("editor.maxTokenizationLineLength") && (this._maxTokenizationLineLength = this._configurationService.getValue("editor.maxTokenizationLineLength", {
        overrideIdentifier: this._languageId
      }));
    }));
  }
  getLoadStatus() {
    const e = [];
    for (const t in this._embeddedLanguages) {
      const n = xi.get(t);
      if (n) {
        if (n instanceof nL) {
          const i = n.getLoadStatus();
          i.loaded === !1 && e.push(i.promise);
        }
        continue;
      }
      xi.isResolved(t) || e.push(xi.getOrCreate(t));
    }
    return e.length === 0 ? {
      loaded: !0
    } : {
      loaded: !1,
      promise: Promise.all(e).then((t) => {
      })
    };
  }
  getInitialState() {
    const e = q3.create(null, this._lexer.start);
    return _u.create(e, null);
  }
  tokenize(e, t, n) {
    if (e.length >= this._maxTokenizationLineLength)
      return ALe(this._languageId, n);
    const i = new omt(), s = this._tokenize(e, t, n, i);
    return i.finalize(s);
  }
  tokenizeEncoded(e, t, n) {
    if (e.length >= this._maxTokenizationLineLength)
      return uO(this._languageService.languageIdCodec.encodeLanguageId(this._languageId), n);
    const i = new Y8(this._languageService, this._standaloneThemeService.getColorTheme().tokenTheme), s = this._tokenize(e, t, n, i);
    return i.finalize(s);
  }
  _tokenize(e, t, n, i) {
    return n.embeddedLanguageData ? this._nestedTokenize(e, t, n, 0, i) : this._myTokenize(e, t, n, 0, i);
  }
  _findLeavingNestedLanguageOffset(e, t) {
    let n = this._lexer.tokenizer[t.stack.state];
    if (!n && (n = Iv(this._lexer, t.stack.state), !n))
      throw Pn(this._lexer, "tokenizer state is not defined: " + t.stack.state);
    let i = -1, s = !1;
    for (const o of n) {
      if (!G5e(o.action) || o.action.nextEmbedded !== "@pop")
        continue;
      s = !0;
      let a = o.resolveRegex(t.stack.state);
      const l = a.source;
      if (l.substr(0, 4) === "^(?:" && l.substr(l.length - 1, 1) === ")") {
        const d = (a.ignoreCase ? "i" : "") + (a.unicode ? "u" : "");
        a = new RegExp(l.substr(4, l.length - 5), d);
      }
      const c = e.search(a);
      c === -1 || c !== 0 && o.matchOnlyAtLineStart || (i === -1 || c < i) && (i = c);
    }
    if (!s)
      throw Pn(this._lexer, 'no rule containing nextEmbedded: "@pop" in tokenizer embedded state: ' + t.stack.state);
    return i;
  }
  _nestedTokenize(e, t, n, i, s) {
    const o = this._findLeavingNestedLanguageOffset(e, n);
    if (o === -1) {
      const c = s.nestedLanguageTokenize(e, t, n.embeddedLanguageData, i);
      return _u.create(n.stack, new J2(n.embeddedLanguageData.languageId, c));
    }
    const a = e.substring(0, o);
    a.length > 0 && s.nestedLanguageTokenize(a, !1, n.embeddedLanguageData, i);
    const l = e.substring(o);
    return this._myTokenize(l, t, n, i + o, s);
  }
  _safeRuleName(e) {
    return e ? e.name : "(unknown)";
  }
  _myTokenize(e, t, n, i, s) {
    s.enterLanguage(this._languageId);
    const o = e.length, a = t && this._lexer.includeLF ? e + `
` : e, l = a.length;
    let c = n.embeddedLanguageData, d = n.stack, u = 0, f = null, p = !0;
    for (; p || u < l; ) {
      const g = u, m = d.depth, A = f ? f.groups.length : 0, w = d.state;
      let v = null, y = null, _ = null, S = null, D = null;
      if (f) {
        v = f.matches;
        const T = f.groups.shift();
        y = T.matched, _ = T.action, S = f.rule, f.groups.length === 0 && (f = null);
      } else {
        if (!p && u >= l)
          break;
        p = !1;
        let T = this._lexer.tokenizer[w];
        if (!T && (T = Iv(this._lexer, w), !T))
          throw Pn(this._lexer, "tokenizer state is not defined: " + w);
        const B = a.substr(u);
        for (const V of T)
          if ((u === 0 || !V.matchOnlyAtLineStart) && (v = B.match(V.resolveRegex(w)), v)) {
            y = v[0], _ = V.action;
            break;
          }
      }
      if (v || (v = [""], y = ""), _ || (u < l && (v = [a.charAt(u)], y = v[0]), _ = this._lexer.defaultToken), y === null)
        break;
      for (u += y.length; emt(_) && G5e(_) && _.test; )
        _ = _.test(y, v, w, u === l);
      let M = null;
      if (typeof _ == "string" || Array.isArray(_))
        M = _;
      else if (_.group)
        M = _.group;
      else if (_.token !== null && _.token !== void 0) {
        if (_.tokenSubst ? M = Eu(this._lexer, _.token, y, v, w) : M = _.token, _.nextEmbedded)
          if (_.nextEmbedded === "@pop") {
            if (!c)
              throw Pn(this._lexer, "cannot pop embedded language if not inside one");
            c = null;
          } else {
            if (c)
              throw Pn(this._lexer, "cannot enter embedded language from within an embedded language");
            D = Eu(this._lexer, _.nextEmbedded, y, v, w);
          }
        if (_.goBack && (u = Math.max(0, u - _.goBack)), _.switchTo && typeof _.switchTo == "string") {
          let T = Eu(this._lexer, _.switchTo, y, v, w);
          if (T[0] === "@" && (T = T.substr(1)), Iv(this._lexer, T))
            d = d.switchTo(T);
          else
            throw Pn(this._lexer, "trying to switch to a state '" + T + "' that is undefined in rule: " + this._safeRuleName(S));
        } else {
          if (_.transform && typeof _.transform == "function")
            throw Pn(this._lexer, "action.transform not supported");
          if (_.next)
            if (_.next === "@push") {
              if (d.depth >= this._lexer.maxStack)
                throw Pn(this._lexer, "maximum tokenizer stack size reached: [" + d.state + "," + d.parent.state + ",...]");
              d = d.push(w);
            } else if (_.next === "@pop") {
              if (d.depth <= 1)
                throw Pn(this._lexer, "trying to pop an empty stack in rule: " + this._safeRuleName(S));
              d = d.pop();
            } else if (_.next === "@popall")
              d = d.popall();
            else {
              let T = Eu(this._lexer, _.next, y, v, w);
              if (T[0] === "@" && (T = T.substr(1)), Iv(this._lexer, T))
                d = d.push(T);
              else
                throw Pn(this._lexer, "trying to set a next state '" + T + "' that is undefined in rule: " + this._safeRuleName(S));
            }
        }
        _.log && typeof _.log == "string" && tmt(this._lexer, this._lexer.languageId + ": " + Eu(this._lexer, _.log, y, v, w));
      }
      if (M === null)
        throw Pn(this._lexer, "lexer rule has no well-defined action in rule: " + this._safeRuleName(S));
      const L = (T) => {
        const B = this._languageService.getLanguageIdByLanguageName(T) || this._languageService.getLanguageIdByMimeType(T) || T, V = this._getNestedEmbeddedLanguageData(B);
        if (u < l) {
          const N = e.substr(u);
          return this._nestedTokenize(N, t, _u.create(d, V), i + u, s);
        } else
          return _u.create(d, V);
      };
      if (Array.isArray(M)) {
        if (f && f.groups.length > 0)
          throw Pn(this._lexer, "groups cannot be nested: " + this._safeRuleName(S));
        if (v.length !== M.length + 1)
          throw Pn(this._lexer, "matched number of groups does not match the number of actions in rule: " + this._safeRuleName(S));
        let T = 0;
        for (let B = 1; B < v.length; B++)
          T += v[B].length;
        if (T !== y.length)
          throw Pn(this._lexer, "with groups, all characters should be matched in consecutive groups in rule: " + this._safeRuleName(S));
        f = {
          rule: S,
          matches: v,
          groups: []
        };
        for (let B = 0; B < M.length; B++)
          f.groups[B] = {
            action: M[B],
            matched: v[B + 1]
          };
        u -= y.length;
        continue;
      } else {
        if (M === "@rematch" && (u -= y.length, y = "", v = null, M = "", D !== null))
          return L(D);
        if (y.length === 0) {
          if (l === 0 || m !== d.depth || w !== d.state || (f ? f.groups.length : 0) !== A)
            continue;
          throw Pn(this._lexer, "no progress in tokenizer in rule: " + this._safeRuleName(S));
        }
        let T = null;
        if (CLe(M) && M.indexOf("@brackets") === 0) {
          const B = M.substr(9), V = amt(this._lexer, y);
          if (!V)
            throw Pn(this._lexer, "@brackets token returned but no bracket defined as: " + y);
          T = Q5e(V.token + B);
        } else {
          const B = M === "" ? "" : M + this._lexer.tokenPostfix;
          T = Q5e(B);
        }
        g < o && s.emit(g + i, T);
      }
      if (D !== null)
        return L(D);
    }
    return _u.create(d, c);
  }
  _getNestedEmbeddedLanguageData(e) {
    if (!this._languageService.isRegisteredLanguageId(e))
      return new J2(e, Z3);
    e !== this._languageId && (this._languageService.requestBasicLanguageFeatures(e), xi.getOrCreate(e), this._embeddedLanguages[e] = !0);
    const t = xi.get(e);
    return t ? new J2(e, t.getInitialState()) : new J2(e, Z3);
  }
};
G3 = nL = rmt([
  smt(4, Ai)
], G3);
function amt(r, e) {
  if (!e)
    return null;
  e = Sd(r, e);
  const t = r.brackets;
  for (const n of t) {
    if (n.open === e)
      return {
        token: n.token,
        bracketType: 1
        /* monarchCommon.MonarchBracket.Open */
      };
    if (n.close === e)
      return {
        token: n.token,
        bracketType: -1
        /* monarchCommon.MonarchBracket.Close */
      };
  }
  return null;
}
const lmt = Jf("standaloneColorizer", { createHTML: (r) => r });
class mO {
  static colorizeElement(e, t, n, i) {
    i = i || {};
    const s = i.theme || "vs", o = i.mimeType || n.getAttribute("lang") || n.getAttribute("data-lang");
    if (!o)
      return console.error("Mode not detected"), Promise.resolve();
    const a = t.getLanguageIdByMimeType(o) || o;
    e.setTheme(s);
    const l = n.firstChild ? n.firstChild.nodeValue : "";
    n.className += " " + s;
    const c = (d) => {
      const u = lmt?.createHTML(d) ?? d;
      n.innerHTML = u;
    };
    return this.colorize(t, l || "", a, i).then(c, (d) => console.error(d));
  }
  static async colorize(e, t, n, i) {
    const s = e.languageIdCodec;
    let o = 4;
    i && typeof i.tabSize == "number" && (o = i.tabSize), FI(t) && (t = t.substr(1));
    const a = $g(t);
    if (!e.isRegisteredLanguageId(n))
      return K5e(a, o, s);
    const l = await xi.getOrCreate(n);
    return l ? cmt(a, o, l, s) : K5e(a, o, s);
  }
  static colorizeLine(e, t, n, i, s = 4) {
    const o = zo.isBasicASCII(e, t), a = zo.containsRTL(e, o, n);
    return ny(new tm(!1, !0, e, !1, o, a, 0, i, [], s, 0, 0, 0, 0, -1, "none", !1, !1, null)).html;
  }
  static colorizeModelLine(e, t, n = 4) {
    const i = e.getLineContent(t);
    e.tokenization.forceTokenization(t);
    const o = e.tokenization.getLineTokens(t).inflate();
    return this.colorizeLine(i, e.mightContainNonBasicASCII(), e.mightContainRTL(), o, n);
  }
}
function cmt(r, e, t, n) {
  return new Promise((i, s) => {
    const o = () => {
      const a = hmt(r, e, t, n);
      if (t instanceof G3) {
        const l = t.getLoadStatus();
        if (l.loaded === !1) {
          l.promise.then(o, s);
          return;
        }
      }
      i(a);
    };
    o();
  });
}
function K5e(r, e, t) {
  let n = [];
  const s = new Uint32Array(2);
  s[0] = 0, s[1] = 33587200;
  for (let o = 0, a = r.length; o < a; o++) {
    const l = r[o];
    s[0] = l.length;
    const c = new Ri(s, l, t), d = zo.isBasicASCII(
      l,
      /* check for basic ASCII */
      !0
    ), u = zo.containsRTL(
      l,
      d,
      /* check for RTL */
      !0
    ), f = ny(new tm(!1, !0, l, !1, d, u, 0, c, [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    n = n.concat(f.html), n.push("<br/>");
  }
  return n.join("");
}
function hmt(r, e, t, n) {
  let i = [], s = t.getInitialState();
  for (let o = 0, a = r.length; o < a; o++) {
    const l = r[o], c = t.tokenizeEncoded(l, !0, s);
    Ri.convertToEndOffset(c.tokens, l.length);
    const d = new Ri(c.tokens, l, n), u = zo.isBasicASCII(
      l,
      /* check for basic ASCII */
      !0
    ), f = zo.containsRTL(
      l,
      u,
      /* check for RTL */
      !0
    ), p = ny(new tm(!1, !0, l, !1, u, f, 0, d.inflate(), [], e, 0, 0, 0, 0, -1, "none", !1, !1, null));
    i = i.concat(p.html), i.push("<br/>"), s = c.endState;
  }
  return i.join("");
}
const Y5e = 2e4;
let A0, b6, iL, y6, rL;
function dmt(r) {
  A0 = document.createElement("div"), A0.className = "monaco-aria-container";
  const e = () => {
    const n = document.createElement("div");
    return n.className = "monaco-alert", n.setAttribute("role", "alert"), n.setAttribute("aria-atomic", "true"), A0.appendChild(n), n;
  };
  b6 = e(), iL = e();
  const t = () => {
    const n = document.createElement("div");
    return n.className = "monaco-status", n.setAttribute("aria-live", "polite"), n.setAttribute("aria-atomic", "true"), A0.appendChild(n), n;
  };
  y6 = t(), rL = t(), r.appendChild(A0);
}
function X8(r) {
  A0 && (b6.textContent !== r ? (ic(iL), $8(b6, r)) : (ic(b6), $8(iL, r)));
}
function J8(r) {
  A0 && (y6.textContent !== r ? (ic(rL), $8(y6, r)) : (ic(y6), $8(rL, r)));
}
function $8(r, e) {
  ic(r), e.length > Y5e && (e = e.substr(0, Y5e)), r.textContent = e, r.style.visibility = "hidden", r.style.visibility = "visible";
}
const _Le = Wt("markerDecorationsService");
var umt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, fmt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let e9 = class {
  static {
    this.ID = "editor.contrib.markerDecorations";
  }
  constructor(e, t) {
  }
  dispose() {
  }
};
e9 = umt([
  fmt(1, _Le)
], e9);
iO(
  e9.ID,
  e9,
  0
  /* EditorContributionInstantiation.Eager */
);
class xLe extends me {
  constructor(e, t) {
    super(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._referenceDomElement = e, this._width = -1, this._height = -1, this._resizeObserver = null, this.measureReferenceDomElement(!1, t);
  }
  dispose() {
    this.stopObserving(), super.dispose();
  }
  getWidth() {
    return this._width;
  }
  getHeight() {
    return this._height;
  }
  startObserving() {
    if (!this._resizeObserver && this._referenceDomElement) {
      let e = null;
      const t = () => {
        e ? this.observe({ width: e.width, height: e.height }) : this.observe();
      };
      let n = !1, i = !1;
      const s = () => {
        if (n && !i)
          try {
            n = !1, i = !0, t();
          } finally {
            co(qe(this._referenceDomElement), () => {
              i = !1, s();
            });
          }
      };
      this._resizeObserver = new ResizeObserver((o) => {
        o && o[0] && o[0].contentRect ? e = { width: o[0].contentRect.width, height: o[0].contentRect.height } : e = null, n = !0, s();
      }), this._resizeObserver.observe(this._referenceDomElement);
    }
  }
  stopObserving() {
    this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = null);
  }
  observe(e) {
    this.measureReferenceDomElement(!0, e);
  }
  measureReferenceDomElement(e, t) {
    let n = 0, i = 0;
    t ? (n = t.width, i = t.height) : this._referenceDomElement && (n = this._referenceDomElement.clientWidth, i = this._referenceDomElement.clientHeight), n = Math.max(5, n), i = Math.max(5, i), (this._width !== n || this._height !== i) && (this._width = n, this._height = i, e && this._onDidChange.fire());
  }
}
class q0 {
  static {
    this.items = [];
  }
  constructor(e, t) {
    this.key = e, this.migrate = t;
  }
  apply(e) {
    const t = q0._read(e, this.key), n = (s) => q0._read(e, s), i = (s, o) => q0._write(e, s, o);
    this.migrate(t, n, i);
  }
  static _read(e, t) {
    if (typeof e > "u")
      return;
    const n = t.indexOf(".");
    if (n >= 0) {
      const i = t.substring(0, n);
      return this._read(e[i], t.substring(n + 1));
    }
    return e[t];
  }
  static _write(e, t, n) {
    const i = t.indexOf(".");
    if (i >= 0) {
      const s = t.substring(0, i);
      e[s] = e[s] || {}, this._write(e[s], t.substring(i + 1), n);
      return;
    }
    e[t] = n;
  }
}
function fc(r, e) {
  q0.items.push(new q0(r, e));
}
function ho(r, e) {
  fc(r, (t, n, i) => {
    if (typeof t < "u") {
      for (const [s, o] of e)
        if (t === s) {
          i(r, o);
          return;
        }
    }
  });
}
function pmt(r) {
  q0.items.forEach((e) => e.apply(r));
}
ho("wordWrap", [[!0, "on"], [!1, "off"]]);
ho("lineNumbers", [[!0, "on"], [!1, "off"]]);
ho("cursorBlinking", [["visible", "solid"]]);
ho("renderWhitespace", [[!0, "boundary"], [!1, "none"]]);
ho("renderLineHighlight", [[!0, "line"], [!1, "none"]]);
ho("acceptSuggestionOnEnter", [[!0, "on"], [!1, "off"]]);
ho("tabCompletion", [[!1, "off"], [!0, "onlySnippets"]]);
ho("hover", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]);
ho("parameterHints", [[!0, { enabled: !0 }], [!1, { enabled: !1 }]]);
ho("autoIndent", [[!1, "advanced"], [!0, "full"]]);
ho("matchBrackets", [[!0, "always"], [!1, "never"]]);
ho("renderFinalNewline", [[!0, "on"], [!1, "off"]]);
ho("cursorSmoothCaretAnimation", [[!0, "on"], [!1, "off"]]);
ho("occurrencesHighlight", [[!0, "singleFile"], [!1, "off"]]);
ho("wordBasedSuggestions", [[!0, "matchingDocuments"], [!1, "off"]]);
fc("autoClosingBrackets", (r, e, t) => {
  r === !1 && (t("autoClosingBrackets", "never"), typeof e("autoClosingQuotes") > "u" && t("autoClosingQuotes", "never"), typeof e("autoSurround") > "u" && t("autoSurround", "never"));
});
fc("renderIndentGuides", (r, e, t) => {
  typeof r < "u" && (t("renderIndentGuides", void 0), typeof e("guides.indentation") > "u" && t("guides.indentation", !!r));
});
fc("highlightActiveIndentGuide", (r, e, t) => {
  typeof r < "u" && (t("highlightActiveIndentGuide", void 0), typeof e("guides.highlightActiveIndentation") > "u" && t("guides.highlightActiveIndentation", !!r));
});
const gmt = {
  method: "showMethods",
  function: "showFunctions",
  constructor: "showConstructors",
  deprecated: "showDeprecated",
  field: "showFields",
  variable: "showVariables",
  class: "showClasses",
  struct: "showStructs",
  interface: "showInterfaces",
  module: "showModules",
  property: "showProperties",
  event: "showEvents",
  operator: "showOperators",
  unit: "showUnits",
  value: "showValues",
  constant: "showConstants",
  enum: "showEnums",
  enumMember: "showEnumMembers",
  keyword: "showKeywords",
  text: "showWords",
  color: "showColors",
  file: "showFiles",
  reference: "showReferences",
  folder: "showFolders",
  typeParameter: "showTypeParameters",
  snippet: "showSnippets"
};
fc("suggest.filteredTypes", (r, e, t) => {
  if (r && typeof r == "object") {
    for (const n of Object.entries(gmt))
      r[n[0]] === !1 && typeof e(`suggest.${n[1]}`) > "u" && t(`suggest.${n[1]}`, !1);
    t("suggest.filteredTypes", void 0);
  }
});
fc("quickSuggestions", (r, e, t) => {
  if (typeof r == "boolean") {
    const n = r ? "on" : "off";
    t("quickSuggestions", { comments: n, strings: n, other: n });
  }
});
fc("experimental.stickyScroll.enabled", (r, e, t) => {
  typeof r == "boolean" && (t("experimental.stickyScroll.enabled", void 0), typeof e("stickyScroll.enabled") > "u" && t("stickyScroll.enabled", r));
});
fc("experimental.stickyScroll.maxLineCount", (r, e, t) => {
  typeof r == "number" && (t("experimental.stickyScroll.maxLineCount", void 0), typeof e("stickyScroll.maxLineCount") > "u" && t("stickyScroll.maxLineCount", r));
});
fc("codeActionsOnSave", (r, e, t) => {
  if (r && typeof r == "object") {
    let n = !1;
    const i = {};
    for (const s of Object.entries(r))
      typeof s[1] == "boolean" ? (n = !0, i[s[0]] = s[1] ? "explicit" : "never") : i[s[0]] = s[1];
    n && t("codeActionsOnSave", i);
  }
});
fc("codeActionWidget.includeNearbyQuickfixes", (r, e, t) => {
  typeof r == "boolean" && (t("codeActionWidget.includeNearbyQuickfixes", void 0), typeof e("codeActionWidget.includeNearbyQuickFixes") > "u" && t("codeActionWidget.includeNearbyQuickFixes", r));
});
fc("lightbulb.enabled", (r, e, t) => {
  typeof r == "boolean" && t("lightbulb.enabled", r ? void 0 : "off");
});
class mmt {
  constructor() {
    this._tabFocus = !1, this._onDidChangeTabFocus = new $(), this.onDidChangeTabFocus = this._onDidChangeTabFocus.event;
  }
  getTabFocusMode() {
    return this._tabFocus;
  }
  setTabFocusMode(e) {
    this._tabFocus = e, this._onDidChangeTabFocus.fire(this._tabFocus);
  }
}
const t9 = new mmt(), pc = Wt("accessibilityService"), Amt = new Ve("accessibilityModeEnabled", !1);
var wmt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, vmt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let sL = class extends me {
  constructor(e, t, n, i, s) {
    super(), this._accessibilityService = s, this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._onDidChangeFast = this._register(new $()), this.onDidChangeFast = this._onDidChangeFast.event, this._isDominatedByLongLines = !1, this._viewLineCount = 1, this._lineNumbersDigitCount = 1, this._reservedHeight = 0, this._glyphMarginDecorationLaneCount = 1, this._computeOptionsMemory = new PMe(), this.isSimpleWidget = e, this.contextMenuId = t, this._containerObserver = this._register(new xLe(i, n.dimension)), this._targetWindowId = qe(i).vscodeWindowId, this._rawOptions = X5e(n), this._validatedOptions = xu.validateOptions(this._rawOptions), this.options = this._computeOptions(), this.options.get(
      13
      /* EditorOption.automaticLayout */
    ) && this._containerObserver.startObserving(), this._register(bu.onDidChangeZoomLevel(() => this._recomputeOptions())), this._register(t9.onDidChangeTabFocus(() => this._recomputeOptions())), this._register(this._containerObserver.onDidChange(() => this._recomputeOptions())), this._register(WD.onDidChange(() => this._recomputeOptions())), this._register(F8.getInstance(qe(i)).onDidChange(() => this._recomputeOptions())), this._register(this._accessibilityService.onDidChangeScreenReaderOptimized(() => this._recomputeOptions()));
  }
  _recomputeOptions() {
    const e = this._computeOptions(), t = xu.checkEquals(this.options, e);
    t !== null && (this.options = e, this._onDidChangeFast.fire(t), this._onDidChange.fire(t));
  }
  _computeOptions() {
    const e = this._readEnvConfiguration(), t = U0.createFromValidatedSettings(this._validatedOptions, e.pixelRatio, this.isSimpleWidget), n = this._readFontInfo(t), i = {
      memory: this._computeOptionsMemory,
      outerWidth: e.outerWidth,
      outerHeight: e.outerHeight - this._reservedHeight,
      fontInfo: n,
      extraEditorClassName: e.extraEditorClassName,
      isDominatedByLongLines: this._isDominatedByLongLines,
      viewLineCount: this._viewLineCount,
      lineNumbersDigitCount: this._lineNumbersDigitCount,
      emptySelectionClipboard: e.emptySelectionClipboard,
      pixelRatio: e.pixelRatio,
      tabFocusMode: t9.getTabFocusMode(),
      accessibilitySupport: e.accessibilitySupport,
      glyphMarginDecorationLaneCount: this._glyphMarginDecorationLaneCount
    };
    return xu.computeOptions(this._validatedOptions, i);
  }
  _readEnvConfiguration() {
    return {
      extraEditorClassName: ymt(),
      outerWidth: this._containerObserver.getWidth(),
      outerHeight: this._containerObserver.getHeight(),
      emptySelectionClipboard: V7 || pl,
      pixelRatio: F8.getInstance(Gve(this._targetWindowId, !0).window).value,
      accessibilitySupport: this._accessibilityService.isScreenReaderOptimized() ? 2 : this._accessibilityService.getAccessibilitySupport()
    };
  }
  _readFontInfo(e) {
    return WD.readFontInfo(Gve(this._targetWindowId, !0).window, e);
  }
  getRawOptions() {
    return this._rawOptions;
  }
  updateOptions(e) {
    const t = X5e(e);
    xu.applyUpdate(this._rawOptions, t) && (this._validatedOptions = xu.validateOptions(this._rawOptions), this._recomputeOptions());
  }
  observeContainer(e) {
    this._containerObserver.observe(e);
  }
  setIsDominatedByLongLines(e) {
    this._isDominatedByLongLines !== e && (this._isDominatedByLongLines = e, this._recomputeOptions());
  }
  setModelLineCount(e) {
    const t = bmt(e);
    this._lineNumbersDigitCount !== t && (this._lineNumbersDigitCount = t, this._recomputeOptions());
  }
  setViewLineCount(e) {
    this._viewLineCount !== e && (this._viewLineCount = e, this._recomputeOptions());
  }
  setReservedHeight(e) {
    this._reservedHeight !== e && (this._reservedHeight = e, this._recomputeOptions());
  }
  setGlyphMarginDecorationLaneCount(e) {
    this._glyphMarginDecorationLaneCount !== e && (this._glyphMarginDecorationLaneCount = e, this._recomputeOptions());
  }
};
sL = wmt([
  vmt(4, pc)
], sL);
function bmt(r) {
  let e = 0;
  for (; r; )
    r = Math.floor(r / 10), e++;
  return e || 1;
}
function ymt() {
  let r = "";
  return !l1 && !lDe && (r += "no-user-select "), l1 && (r += "no-minimap-shadow ", r += "enable-user-select "), zt && (r += "mac "), r;
}
class Cmt {
  constructor() {
    this._values = [];
  }
  _read(e) {
    return this._values[e];
  }
  get(e) {
    return this._values[e];
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class Emt {
  constructor() {
    this._values = [];
  }
  _read(e) {
    if (e >= this._values.length)
      throw new Error("Cannot read uninitialized value");
    return this._values[e];
  }
  get(e) {
    return this._read(e);
  }
  _write(e, t) {
    this._values[e] = t;
  }
}
class xu {
  static validateOptions(e) {
    const t = new Cmt();
    for (const n of q2) {
      const i = n.name === "_never_" ? void 0 : e[n.name];
      t._write(n.id, n.validate(i));
    }
    return t;
  }
  static computeOptions(e, t) {
    const n = new Emt();
    for (const i of q2)
      n._write(i.id, i.compute(t, n, e._read(i.id)));
    return n;
  }
  static _deepEquals(e, t) {
    if (typeof e != "object" || typeof t != "object" || !e || !t)
      return e === t;
    if (Array.isArray(e) || Array.isArray(t))
      return Array.isArray(e) && Array.isArray(t) ? Zi(e, t) : !1;
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (const n in e)
      if (!xu._deepEquals(e[n], t[n]))
        return !1;
    return !0;
  }
  static checkEquals(e, t) {
    const n = [];
    let i = !1;
    for (const s of q2) {
      const o = !xu._deepEquals(e._read(s.id), t._read(s.id));
      n[s.id] = o, o && (i = !0);
    }
    return i ? new BMe(n) : null;
  }
  /**
   * Returns true if something changed.
   * Modifies `options`.
  */
  static applyUpdate(e, t) {
    let n = !1;
    for (const i of q2)
      if (t.hasOwnProperty(i.name)) {
        const s = i.applyUpdate(e[i.name], t[i.name]);
        e[i.name] = s.newValue, n = n || s.didChange;
      }
    return n;
  }
}
function X5e(r) {
  const e = pu(r);
  return pmt(e), e;
}
var Ou;
(function(r) {
  const e = { total: 0, min: Number.MAX_VALUE, max: 0 }, t = { ...e }, n = { ...e }, i = { ...e };
  let s = 0;
  const o = {
    keydown: 0,
    input: 0,
    render: 0
  };
  function a() {
    w(), performance.mark("inputlatency/start"), performance.mark("keydown/start"), o.keydown = 1, queueMicrotask(l);
  }
  r.onKeyDown = a;
  function l() {
    o.keydown === 1 && (performance.mark("keydown/end"), o.keydown = 2);
  }
  function c() {
    performance.mark("input/start"), o.input = 1, A();
  }
  r.onBeforeInput = c;
  function d() {
    o.input === 0 && c(), queueMicrotask(u);
  }
  r.onInput = d;
  function u() {
    o.input === 1 && (performance.mark("input/end"), o.input = 2);
  }
  function f() {
    w();
  }
  r.onKeyUp = f;
  function p() {
    w();
  }
  r.onSelectionChange = p;
  function g() {
    o.keydown === 2 && o.input === 2 && o.render === 0 && (performance.mark("render/start"), o.render = 1, queueMicrotask(m), A());
  }
  r.onRenderStart = g;
  function m() {
    o.render === 1 && (performance.mark("render/end"), o.render = 2);
  }
  function A() {
    setTimeout(w);
  }
  function w() {
    o.keydown === 2 && o.input === 2 && o.render === 2 && (performance.mark("inputlatency/end"), performance.measure("keydown", "keydown/start", "keydown/end"), performance.measure("input", "input/start", "input/end"), performance.measure("render", "render/start", "render/end"), performance.measure("inputlatency", "inputlatency/start", "inputlatency/end"), v("keydown", e), v("input", t), v("render", n), v("inputlatency", i), s++, y());
  }
  function v(M, L) {
    const T = performance.getEntriesByName(M)[0].duration;
    L.total += T, L.min = Math.min(L.min, T), L.max = Math.max(L.max, T);
  }
  function y() {
    performance.clearMarks("keydown/start"), performance.clearMarks("keydown/end"), performance.clearMarks("input/start"), performance.clearMarks("input/end"), performance.clearMarks("render/start"), performance.clearMarks("render/end"), performance.clearMarks("inputlatency/start"), performance.clearMarks("inputlatency/end"), performance.clearMeasures("keydown"), performance.clearMeasures("input"), performance.clearMeasures("render"), performance.clearMeasures("inputlatency"), o.keydown = 0, o.input = 0, o.render = 0;
  }
  function _() {
    if (s === 0)
      return;
    const M = {
      keydown: S(e),
      input: S(t),
      render: S(n),
      total: S(i),
      sampleCount: s
    };
    return D(e), D(t), D(n), D(i), s = 0, M;
  }
  r.getAndClearMeasurements = _;
  function S(M) {
    return {
      average: M.total / s,
      max: M.max,
      min: M.min
    };
  }
  function D(M) {
    M.total = 0, M.min = Number.MAX_VALUE, M.max = 0;
  }
})(Ou || (Ou = {}));
class iy {
  constructor() {
    this._hooks = new ze(), this._pointerMoveCallback = null, this._onStopCallback = null;
  }
  dispose() {
    this.stopMonitoring(!1), this._hooks.dispose();
  }
  stopMonitoring(e, t) {
    if (!this.isMonitoring())
      return;
    this._hooks.clear(), this._pointerMoveCallback = null;
    const n = this._onStopCallback;
    this._onStopCallback = null, e && n && n(t);
  }
  isMonitoring() {
    return !!this._pointerMoveCallback;
  }
  startMonitoring(e, t, n, i, s) {
    this.isMonitoring() && this.stopMonitoring(!1), this._pointerMoveCallback = i, this._onStopCallback = s;
    let o = e;
    try {
      e.setPointerCapture(t), this._hooks.add(ht(() => {
        try {
          e.releasePointerCapture(t);
        } catch {
        }
      }));
    } catch {
      o = qe(e);
    }
    this._hooks.add(fe(o, Se.POINTER_MOVE, (a) => {
      if (a.buttons !== n) {
        this.stopMonitoring(!0);
        return;
      }
      a.preventDefault(), this._pointerMoveCallback(a);
    })), this._hooks.add(fe(o, Se.POINTER_UP, (a) => this.stopMonitoring(!0)));
  }
}
function AO(r) {
  return `--vscode-${r.replace(/\./g, "-")}`;
}
function _e(r) {
  return `var(${AO(r)})`;
}
function _mt(r, e) {
  return `var(${AO(r)}, ${e})`;
}
function xmt(r) {
  return r !== null && typeof r == "object" && "light" in r && "dark" in r;
}
const SLe = {
  ColorContribution: "base.contributions.colors"
}, Smt = "default";
class Mmt {
  constructor() {
    this._onDidChangeSchema = new $(), this.onDidChangeSchema = this._onDidChangeSchema.event, this.colorSchema = { type: "object", properties: {} }, this.colorReferenceSchema = { type: "string", enum: [], enumDescriptions: [] }, this.colorsById = {};
  }
  registerColor(e, t, n, i = !1, s) {
    const o = { id: e, description: n, defaults: t, needsTransparency: i, deprecationMessage: s };
    this.colorsById[e] = o;
    const a = { type: "string", description: n, format: "color-hex", defaultSnippets: [{ body: "${1:#ff0000}" }] };
    return s && (a.deprecationMessage = s), i && (a.pattern = "^#(?:(?<rgba>[0-9a-fA-f]{3}[0-9a-eA-E])|(?:[0-9a-fA-F]{6}(?:(?![fF]{2})(?:[0-9a-fA-F]{2}))))?$", a.patternErrorMessage = C("transparecyRequired", "This color must be transparent or it will obscure content")), this.colorSchema.properties[e] = {
      oneOf: [
        a,
        { type: "string", const: Smt, description: C("useDefault", "Use the default color.") }
      ]
    }, this.colorReferenceSchema.enum.push(e), this.colorReferenceSchema.enumDescriptions.push(n), this._onDidChangeSchema.fire(), e;
  }
  getColors() {
    return Object.keys(this.colorsById).map((e) => this.colorsById[e]);
  }
  resolveDefaultColor(e, t) {
    const n = this.colorsById[e];
    if (n?.defaults) {
      const i = xmt(n.defaults) ? n.defaults[t.type] : n.defaults;
      return kl(i, t);
    }
  }
  getColorSchema() {
    return this.colorSchema;
  }
  toString() {
    const e = (t, n) => {
      const i = t.indexOf(".") === -1 ? 0 : 1, s = n.indexOf(".") === -1 ? 0 : 1;
      return i !== s ? i - s : t.localeCompare(n);
    };
    return Object.keys(this.colorsById).sort(e).map((t) => `- \`${t}\`: ${this.colorsById[t].description}`).join(`
`);
  }
}
const ry = new Mmt();
Er.add(SLe.ColorContribution, ry);
function Z(r, e, t, n, i) {
  return ry.registerColor(r, e, t, n, i);
}
function Dmt(r, e) {
  switch (r.op) {
    case 0:
      return kl(r.value, e)?.darken(r.factor);
    case 1:
      return kl(r.value, e)?.lighten(r.factor);
    case 2:
      return kl(r.value, e)?.transparent(r.factor);
    case 3: {
      const t = kl(r.background, e);
      return t ? kl(r.value, e)?.makeOpaque(t) : kl(r.value, e);
    }
    case 4:
      for (const t of r.values) {
        const n = kl(t, e);
        if (n)
          return n;
      }
      return;
    case 6:
      return kl(e.defines(r.if) ? r.then : r.else, e);
    case 5: {
      const t = kl(r.value, e);
      if (!t)
        return;
      const n = kl(r.background, e);
      return n ? t.isDarkerThan(n) ? ge.getLighterColor(t, n, r.factor).transparent(r.transparency) : ge.getDarkerColor(t, n, r.factor).transparent(r.transparency) : t.transparent(r.factor * r.transparency);
    }
    default:
      throw $I();
  }
}
function e2(r, e) {
  return { op: 0, value: r, factor: e };
}
function Yl(r, e) {
  return { op: 1, value: r, factor: e };
}
function Mt(r, e) {
  return { op: 2, value: r, factor: e };
}
function J5e(...r) {
  return { op: 4, values: r };
}
function Lmt(r, e, t) {
  return { op: 6, if: r, then: e, else: t };
}
function $5e(r, e, t, n) {
  return { op: 5, value: r, background: e, factor: t, transparency: n };
}
function kl(r, e) {
  if (r !== null) {
    if (typeof r == "string")
      return r[0] === "#" ? ge.fromHex(r) : e.getColor(r);
    if (r instanceof ge)
      return r;
    if (typeof r == "object")
      return Dmt(r, e);
  }
}
const MLe = "vscode://schemas/workbench-colors", DLe = Er.as(ey.JSONContribution);
DLe.registerSchema(MLe, ry.getColorSchema());
const e6e = new Nr(() => DLe.notifySchemaChanged(MLe), 200);
ry.onDidChangeSchema(() => {
  e6e.isScheduled() || e6e.schedule();
});
const En = Z("foreground", { dark: "#CCCCCC", light: "#616161", hcDark: "#FFFFFF", hcLight: "#292929" }, C("foreground", "Overall foreground color. This color is only used if not overridden by a component."));
Z("disabledForeground", { dark: "#CCCCCC80", light: "#61616180", hcDark: "#A5A5A5", hcLight: "#7F7F7F" }, C("disabledForeground", "Overall foreground for disabled elements. This color is only used if not overridden by a component."));
Z("errorForeground", { dark: "#F48771", light: "#A1260D", hcDark: "#F48771", hcLight: "#B5200D" }, C("errorForeground", "Overall foreground color for error messages. This color is only used if not overridden by a component."));
Z("descriptionForeground", { light: "#717171", dark: Mt(En, 0.7), hcDark: Mt(En, 0.7), hcLight: Mt(En, 0.7) }, C("descriptionForeground", "Foreground color for description text providing additional information, for example for a label."));
const oL = Z("icon.foreground", { dark: "#C5C5C5", light: "#424242", hcDark: "#FFFFFF", hcLight: "#292929" }, C("iconForeground", "The default color for icons in the workbench.")), hh = Z("focusBorder", { dark: "#007FD4", light: "#0090F1", hcDark: "#F38518", hcLight: "#006BBD" }, C("focusBorder", "Overall border color for focused elements. This color is only used if not overridden by a component.")), $t = Z("contrastBorder", { light: null, dark: null, hcDark: "#6FC3DF", hcLight: "#0F4A85" }, C("contrastBorder", "An extra border around elements to separate them from others for greater contrast.")), _i = Z("contrastActiveBorder", { light: null, dark: null, hcDark: hh, hcLight: hh }, C("activeContrastBorder", "An extra border around active elements to separate them from others for greater contrast."));
Z("selection.background", null, C("selectionBackground", "The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor."));
const kmt = Z("textLink.foreground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, C("textLinkForeground", "Foreground color for links in text."));
Z("textLink.activeForeground", { light: "#006AB1", dark: "#3794FF", hcDark: "#21A6FF", hcLight: "#0F4A85" }, C("textLinkActiveForeground", "Foreground color for links in text when clicked on and on mouse hover."));
Z("textSeparator.foreground", { light: "#0000002e", dark: "#ffffff2e", hcDark: ge.black, hcLight: "#292929" }, C("textSeparatorForeground", "Color for text separators."));
Z("textPreformat.foreground", { light: "#A31515", dark: "#D7BA7D", hcDark: "#000000", hcLight: "#FFFFFF" }, C("textPreformatForeground", "Foreground color for preformatted text segments."));
Z("textPreformat.background", { light: "#0000001A", dark: "#FFFFFF1A", hcDark: "#FFFFFF", hcLight: "#09345f" }, C("textPreformatBackground", "Background color for preformatted text segments."));
Z("textBlockQuote.background", { light: "#f2f2f2", dark: "#222222", hcDark: null, hcLight: "#F2F2F2" }, C("textBlockQuoteBackground", "Background color for block quotes in text."));
Z("textBlockQuote.border", { light: "#007acc80", dark: "#007acc80", hcDark: ge.white, hcLight: "#292929" }, C("textBlockQuoteBorder", "Border color for block quotes in text."));
Z("textCodeBlock.background", { light: "#dcdcdc66", dark: "#0a0a0a66", hcDark: ge.black, hcLight: "#F2F2F2" }, C("textCodeBlockBackground", "Background color for code blocks in text."));
Z("sash.hoverBorder", hh, C("sashActiveBorder", "Border color of active sashes."));
const C6 = Z("badge.background", { dark: "#4D4D4D", light: "#C4C4C4", hcDark: ge.black, hcLight: "#0F4A85" }, C("badgeBackground", "Badge background color. Badges are small information labels, e.g. for search results count.")), Nmt = Z("badge.foreground", { dark: ge.white, light: "#333", hcDark: ge.white, hcLight: ge.white }, C("badgeForeground", "Badge foreground color. Badges are small information labels, e.g. for search results count.")), wO = Z("scrollbar.shadow", { dark: "#000000", light: "#DDDDDD", hcDark: null, hcLight: null }, C("scrollbarShadow", "Scrollbar shadow to indicate that the view is scrolled.")), LLe = Z("scrollbarSlider.background", { dark: ge.fromHex("#797979").transparent(0.4), light: ge.fromHex("#646464").transparent(0.4), hcDark: Mt($t, 0.6), hcLight: Mt($t, 0.4) }, C("scrollbarSliderBackground", "Scrollbar slider background color.")), kLe = Z("scrollbarSlider.hoverBackground", { dark: ge.fromHex("#646464").transparent(0.7), light: ge.fromHex("#646464").transparent(0.7), hcDark: Mt($t, 0.8), hcLight: Mt($t, 0.8) }, C("scrollbarSliderHoverBackground", "Scrollbar slider background color when hovering.")), NLe = Z("scrollbarSlider.activeBackground", { dark: ge.fromHex("#BFBFBF").transparent(0.4), light: ge.fromHex("#000000").transparent(0.6), hcDark: $t, hcLight: $t }, C("scrollbarSliderActiveBackground", "Scrollbar slider background color when clicked on.")), Tmt = Z("progressBar.background", { dark: ge.fromHex("#0E70C0"), light: ge.fromHex("#0E70C0"), hcDark: $t, hcLight: $t }, C("progressBarBackground", "Background color of the progress bar that can show for long running operations.")), dh = Z("editor.background", { light: "#ffffff", dark: "#1E1E1E", hcDark: ge.black, hcLight: ge.white }, C("editorBackground", "Editor background color.")), Sw = Z("editor.foreground", { light: "#333333", dark: "#BBBBBB", hcDark: ge.white, hcLight: En }, C("editorForeground", "Editor default foreground color."));
Z("editorStickyScroll.background", dh, C("editorStickyScrollBackground", "Background color of sticky scroll in the editor"));
Z("editorStickyScrollHover.background", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: null, hcLight: ge.fromHex("#0F4A85").transparent(0.1) }, C("editorStickyScrollHoverBackground", "Background color of sticky scroll on hover in the editor"));
Z("editorStickyScroll.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("editorStickyScrollBorder", "Border color of sticky scroll in the editor"));
Z("editorStickyScroll.shadow", wO, C("editorStickyScrollShadow", " Shadow color of sticky scroll in the editor"));
const Zl = Z("editorWidget.background", { dark: "#252526", light: "#F3F3F3", hcDark: "#0C141F", hcLight: ge.white }, C("editorWidgetBackground", "Background color of editor widgets, such as find/replace.")), vO = Z("editorWidget.foreground", En, C("editorWidgetForeground", "Foreground color of editor widgets, such as find/replace.")), TLe = Z("editorWidget.border", { dark: "#454545", light: "#C8C8C8", hcDark: $t, hcLight: $t }, C("editorWidgetBorder", "Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget."));
Z("editorWidget.resizeBorder", null, C("editorWidgetResizeBorder", "Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget."));
Z("editorError.background", null, C("editorError.background", "Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const bO = Z("editorError.foreground", { dark: "#F14C4C", light: "#E51400", hcDark: "#F48771", hcLight: "#B5200D" }, C("editorError.foreground", "Foreground color of error squigglies in the editor."));
Z("editorError.border", { dark: null, light: null, hcDark: ge.fromHex("#E47777").transparent(0.8), hcLight: "#B5200D" }, C("errorBorder", "If set, color of double underlines for errors in the editor."));
const Imt = Z("editorWarning.background", null, C("editorWarning.background", "Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0), d1 = Z("editorWarning.foreground", { dark: "#CCA700", light: "#BF8803", hcDark: "#FFD370", hcLight: "#895503" }, C("editorWarning.foreground", "Foreground color of warning squigglies in the editor.")), n9 = Z("editorWarning.border", { dark: null, light: null, hcDark: ge.fromHex("#FFCC00").transparent(0.8), hcLight: ge.fromHex("#FFCC00").transparent(0.8) }, C("warningBorder", "If set, color of double underlines for warnings in the editor."));
Z("editorInfo.background", null, C("editorInfo.background", "Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations."), !0);
const yf = Z("editorInfo.foreground", { dark: "#3794FF", light: "#1a85ff", hcDark: "#3794FF", hcLight: "#1a85ff" }, C("editorInfo.foreground", "Foreground color of info squigglies in the editor.")), i9 = Z("editorInfo.border", { dark: null, light: null, hcDark: ge.fromHex("#3794FF").transparent(0.8), hcLight: "#292929" }, C("infoBorder", "If set, color of double underlines for infos in the editor.")), Omt = Z("editorHint.foreground", { dark: ge.fromHex("#eeeeee").transparent(0.7), light: "#6c6c6c", hcDark: null, hcLight: null }, C("editorHint.foreground", "Foreground color of hint squigglies in the editor."));
Z("editorHint.border", { dark: null, light: null, hcDark: ge.fromHex("#eeeeee").transparent(0.8), hcLight: "#292929" }, C("hintBorder", "If set, color of double underlines for hints in the editor."));
Z("editorLink.activeForeground", { dark: "#4E94CE", light: ge.blue, hcDark: ge.cyan, hcLight: "#292929" }, C("activeLinkForeground", "Color of active links."));
const $2 = Z("editor.selectionBackground", { light: "#ADD6FF", dark: "#264F78", hcDark: "#f3f518", hcLight: "#0F4A85" }, C("editorSelectionBackground", "Color of the editor selection.")), Rmt = Z("editor.selectionForeground", { light: null, dark: null, hcDark: "#000000", hcLight: ge.white }, C("editorSelectionForeground", "Color of the selected text for high contrast.")), ILe = Z("editor.inactiveSelectionBackground", { light: Mt($2, 0.5), dark: Mt($2, 0.5), hcDark: Mt($2, 0.7), hcLight: Mt($2, 0.5) }, C("editorInactiveSelection", "Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations."), !0), OLe = Z("editor.selectionHighlightBackground", { light: $5e($2, dh, 0.3, 0.6), dark: $5e($2, dh, 0.3, 0.6), hcDark: null, hcLight: null }, C("editorSelectionHighlight", "Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editor.selectionHighlightBorder", { light: null, dark: null, hcDark: _i, hcLight: _i }, C("editorSelectionHighlightBorder", "Border color for regions with the same content as the selection."));
Z("editor.findMatchBackground", { light: "#A8AC94", dark: "#515C6A", hcDark: null, hcLight: null }, C("editorFindMatch", "Color of the current search match."));
const Vmt = Z("editor.findMatchForeground", null, C("editorFindMatchForeground", "Text color of the current search match.")), Ru = Z("editor.findMatchHighlightBackground", { light: "#EA5C0055", dark: "#EA5C0055", hcDark: null, hcLight: null }, C("findMatchHighlight", "Color of the other search matches. The color must not be opaque so as not to hide underlying decorations."), !0), Hmt = Z("editor.findMatchHighlightForeground", null, C("findMatchHighlightForeground", "Foreground color of the other search matches."), !0);
Z("editor.findRangeHighlightBackground", { dark: "#3a3d4166", light: "#b4b4b44d", hcDark: null, hcLight: null }, C("findRangeHighlight", "Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editor.findMatchBorder", { light: null, dark: null, hcDark: _i, hcLight: _i }, C("editorFindMatchBorder", "Border color of the current search match."));
const O0 = Z("editor.findMatchHighlightBorder", { light: null, dark: null, hcDark: _i, hcLight: _i }, C("findMatchHighlightBorder", "Border color of the other search matches.")), Bmt = Z("editor.findRangeHighlightBorder", { dark: null, light: null, hcDark: Mt(_i, 0.4), hcLight: Mt(_i, 0.4) }, C("findRangeHighlightBorder", "Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editor.hoverHighlightBackground", { light: "#ADD6FF26", dark: "#264f7840", hcDark: "#ADD6FF26", hcLight: null }, C("hoverHighlight", "Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations."), !0);
const t6e = Z("editorHoverWidget.background", Zl, C("hoverBackground", "Background color of the editor hover."));
Z("editorHoverWidget.foreground", vO, C("hoverForeground", "Foreground color of the editor hover."));
const Pmt = Z("editorHoverWidget.border", TLe, C("hoverBorder", "Border color of the editor hover."));
Z("editorHoverWidget.statusBarBackground", { dark: Yl(t6e, 0.2), light: e2(t6e, 0.05), hcDark: Zl, hcLight: Zl }, C("statusBarBackground", "Background color of the editor hover status bar."));
const RLe = Z("editorInlayHint.foreground", { dark: "#969696", light: "#969696", hcDark: ge.white, hcLight: ge.black }, C("editorInlayHintForeground", "Foreground color of inline hints")), VLe = Z("editorInlayHint.background", { dark: Mt(C6, 0.1), light: Mt(C6, 0.1), hcDark: Mt(ge.white, 0.1), hcLight: Mt(C6, 0.1) }, C("editorInlayHintBackground", "Background color of inline hints"));
Z("editorInlayHint.typeForeground", RLe, C("editorInlayHintForegroundTypes", "Foreground color of inline hints for types"));
Z("editorInlayHint.typeBackground", VLe, C("editorInlayHintBackgroundTypes", "Background color of inline hints for types"));
Z("editorInlayHint.parameterForeground", RLe, C("editorInlayHintForegroundParameter", "Foreground color of inline hints for parameters"));
Z("editorInlayHint.parameterBackground", VLe, C("editorInlayHintBackgroundParameter", "Background color of inline hints for parameters"));
const Fmt = Z("editorLightBulb.foreground", { dark: "#FFCC00", light: "#DDB100", hcDark: "#FFCC00", hcLight: "#007ACC" }, C("editorLightBulbForeground", "The color used for the lightbulb actions icon."));
Z("editorLightBulbAutoFix.foreground", { dark: "#75BEFF", light: "#007ACC", hcDark: "#75BEFF", hcLight: "#007ACC" }, C("editorLightBulbAutoFixForeground", "The color used for the lightbulb auto fix actions icon."));
Z("editorLightBulbAi.foreground", Fmt, C("editorLightBulbAiForeground", "The color used for the lightbulb AI icon."));
Z("editor.snippetTabstopHighlightBackground", { dark: new ge(new Zt(124, 124, 124, 0.3)), light: new ge(new Zt(10, 50, 100, 0.2)), hcDark: new ge(new Zt(124, 124, 124, 0.3)), hcLight: new ge(new Zt(10, 50, 100, 0.2)) }, C("snippetTabstopHighlightBackground", "Highlight background color of a snippet tabstop."));
Z("editor.snippetTabstopHighlightBorder", null, C("snippetTabstopHighlightBorder", "Highlight border color of a snippet tabstop."));
Z("editor.snippetFinalTabstopHighlightBackground", null, C("snippetFinalTabstopHighlightBackground", "Highlight background color of the final tabstop of a snippet."));
Z("editor.snippetFinalTabstopHighlightBorder", { dark: "#525252", light: new ge(new Zt(10, 50, 100, 0.5)), hcDark: "#525252", hcLight: "#292929" }, C("snippetFinalTabstopHighlightBorder", "Highlight border color of the final tabstop of a snippet."));
const aL = new ge(new Zt(155, 185, 85, 0.2)), lL = new ge(new Zt(255, 0, 0, 0.2)), zmt = Z("diffEditor.insertedTextBackground", { dark: "#9ccc2c33", light: "#9ccc2c40", hcDark: null, hcLight: null }, C("diffEditorInserted", "Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0), Wmt = Z("diffEditor.removedTextBackground", { dark: "#ff000033", light: "#ff000033", hcDark: null, hcLight: null }, C("diffEditorRemoved", "Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("diffEditor.insertedLineBackground", { dark: aL, light: aL, hcDark: null, hcLight: null }, C("diffEditorInsertedLines", "Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("diffEditor.removedLineBackground", { dark: lL, light: lL, hcDark: null, hcLight: null }, C("diffEditorRemovedLines", "Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("diffEditorGutter.insertedLineBackground", null, C("diffEditorInsertedLineGutter", "Background color for the margin where lines got inserted."));
Z("diffEditorGutter.removedLineBackground", null, C("diffEditorRemovedLineGutter", "Background color for the margin where lines got removed."));
const jmt = Z("diffEditorOverview.insertedForeground", null, C("diffEditorOverviewInserted", "Diff overview ruler foreground for inserted content.")), Zmt = Z("diffEditorOverview.removedForeground", null, C("diffEditorOverviewRemoved", "Diff overview ruler foreground for removed content."));
Z("diffEditor.insertedTextBorder", { dark: null, light: null, hcDark: "#33ff2eff", hcLight: "#374E06" }, C("diffEditorInsertedOutline", "Outline color for the text that got inserted."));
Z("diffEditor.removedTextBorder", { dark: null, light: null, hcDark: "#FF008F", hcLight: "#AD0707" }, C("diffEditorRemovedOutline", "Outline color for text that got removed."));
Z("diffEditor.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("diffEditorBorder", "Border color between the two text editors."));
Z("diffEditor.diagonalFill", { dark: "#cccccc33", light: "#22222233", hcDark: null, hcLight: null }, C("diffDiagonalFill", "Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views."));
Z("diffEditor.unchangedRegionBackground", "sideBar.background", C("diffEditor.unchangedRegionBackground", "The background color of unchanged blocks in the diff editor."));
Z("diffEditor.unchangedRegionForeground", "foreground", C("diffEditor.unchangedRegionForeground", "The foreground color of unchanged blocks in the diff editor."));
Z("diffEditor.unchangedCodeBackground", { dark: "#74747429", light: "#b8b8b829", hcDark: null, hcLight: null }, C("diffEditor.unchangedCodeBackground", "The background color of unchanged code in the diff editor."));
const Mw = Z("widget.shadow", { dark: Mt(ge.black, 0.36), light: Mt(ge.black, 0.16), hcDark: null, hcLight: null }, C("widgetShadow", "Shadow color of widgets such as find/replace inside the editor.")), Umt = Z("widget.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("widgetBorder", "Border color of widgets such as find/replace inside the editor.")), n6e = Z("toolbar.hoverBackground", { dark: "#5a5d5e50", light: "#b8b8b850", hcDark: null, hcLight: null }, C("toolbarHoverBackground", "Toolbar background when hovering over actions using the mouse"));
Z("toolbar.hoverOutline", { dark: null, light: null, hcDark: _i, hcLight: _i }, C("toolbarHoverOutline", "Toolbar outline when hovering over actions using the mouse"));
Z("toolbar.activeBackground", { dark: Yl(n6e, 0.1), light: e2(n6e, 0.1), hcDark: null, hcLight: null }, C("toolbarActiveBackground", "Toolbar background when holding the mouse over actions"));
const qmt = Z("breadcrumb.foreground", Mt(En, 0.8), C("breadcrumbsFocusForeground", "Color of focused breadcrumb items.")), Gmt = Z("breadcrumb.background", dh, C("breadcrumbsBackground", "Background color of breadcrumb items.")), i6e = Z("breadcrumb.focusForeground", { light: e2(En, 0.2), dark: Yl(En, 0.1), hcDark: Yl(En, 0.1), hcLight: Yl(En, 0.1) }, C("breadcrumbsFocusForeground", "Color of focused breadcrumb items.")), Qmt = Z("breadcrumb.activeSelectionForeground", { light: e2(En, 0.2), dark: Yl(En, 0.1), hcDark: Yl(En, 0.1), hcLight: Yl(En, 0.1) }, C("breadcrumbsSelectedForeground", "Color of selected breadcrumb items."));
Z("breadcrumbPicker.background", Zl, C("breadcrumbsSelectedBackground", "Background color of breadcrumb item picker."));
const HLe = 0.5, r6e = ge.fromHex("#40C8AE").transparent(HLe), s6e = ge.fromHex("#40A6FF").transparent(HLe), o6e = ge.fromHex("#606060").transparent(0.4), yO = 0.4, dg = 1, cL = Z("merge.currentHeaderBackground", { dark: r6e, light: r6e, hcDark: null, hcLight: null }, C("mergeCurrentHeaderBackground", "Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("merge.currentContentBackground", Mt(cL, yO), C("mergeCurrentContentBackground", "Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const hL = Z("merge.incomingHeaderBackground", { dark: s6e, light: s6e, hcDark: null, hcLight: null }, C("mergeIncomingHeaderBackground", "Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("merge.incomingContentBackground", Mt(hL, yO), C("mergeIncomingContentBackground", "Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const dL = Z("merge.commonHeaderBackground", { dark: o6e, light: o6e, hcDark: null, hcLight: null }, C("mergeCommonHeaderBackground", "Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("merge.commonContentBackground", Mt(dL, yO), C("mergeCommonContentBackground", "Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations."), !0);
const ug = Z("merge.border", { dark: null, light: null, hcDark: "#C3DF6F", hcLight: "#007ACC" }, C("mergeBorder", "Border color on headers and the splitter in inline merge-conflicts."));
Z("editorOverviewRuler.currentContentForeground", { dark: Mt(cL, dg), light: Mt(cL, dg), hcDark: ug, hcLight: ug }, C("overviewRulerCurrentContentForeground", "Current overview ruler foreground for inline merge-conflicts."));
Z("editorOverviewRuler.incomingContentForeground", { dark: Mt(hL, dg), light: Mt(hL, dg), hcDark: ug, hcLight: ug }, C("overviewRulerIncomingContentForeground", "Incoming overview ruler foreground for inline merge-conflicts."));
Z("editorOverviewRuler.commonContentForeground", { dark: Mt(dL, dg), light: Mt(dL, dg), hcDark: ug, hcLight: ug }, C("overviewRulerCommonContentForeground", "Common ancestor overview ruler foreground for inline merge-conflicts."));
const jE = Z("editorOverviewRuler.findMatchForeground", { dark: "#d186167e", light: "#d186167e", hcDark: "#AB5A00", hcLight: "" }, C("overviewRulerFindMatchForeground", "Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editorOverviewRuler.selectionHighlightForeground", "#A0A0A0CC", C("overviewRulerSelectionHighlightForeground", "Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations."), !0);
const Kmt = Z("problemsErrorIcon.foreground", bO, C("problemsErrorIconForeground", "The color used for the problems error icon.")), Ymt = Z("problemsWarningIcon.foreground", d1, C("problemsWarningIconForeground", "The color used for the problems warning icon.")), Xmt = Z("problemsInfoIcon.foreground", yf, C("problemsInfoIconForeground", "The color used for the problems info icon.")), uL = Z("minimap.findMatchHighlight", { light: "#d18616", dark: "#d18616", hcDark: "#AB5A00", hcLight: "#0F4A85" }, C("minimapFindMatchHighlight", "Minimap marker color for find matches."), !0);
Z("minimap.selectionOccurrenceHighlight", { light: "#c9c9c9", dark: "#676767", hcDark: "#ffffff", hcLight: "#0F4A85" }, C("minimapSelectionOccurrenceHighlight", "Minimap marker color for repeating editor selections."), !0);
const a6e = Z("minimap.selectionHighlight", { light: "#ADD6FF", dark: "#264F78", hcDark: "#ffffff", hcLight: "#0F4A85" }, C("minimapSelectionHighlight", "Minimap marker color for the editor selection."), !0), Jmt = Z("minimap.infoHighlight", { dark: yf, light: yf, hcDark: i9, hcLight: i9 }, C("minimapInfo", "Minimap marker color for infos.")), $mt = Z("minimap.warningHighlight", { dark: d1, light: d1, hcDark: n9, hcLight: n9 }, C("overviewRuleWarning", "Minimap marker color for warnings.")), eAt = Z("minimap.errorHighlight", { dark: new ge(new Zt(255, 18, 18, 0.7)), light: new ge(new Zt(255, 18, 18, 0.7)), hcDark: new ge(new Zt(255, 50, 50, 1)), hcLight: "#B5200D" }, C("minimapError", "Minimap marker color for errors.")), tAt = Z("minimap.background", null, C("minimapBackground", "Minimap background color.")), nAt = Z("minimap.foregroundOpacity", ge.fromHex("#000f"), C("minimapForegroundOpacity", 'Opacity of foreground elements rendered in the minimap. For example, "#000000c0" will render the elements with 75% opacity.'));
Z("minimapSlider.background", Mt(LLe, 0.5), C("minimapSliderBackground", "Minimap slider background color."));
Z("minimapSlider.hoverBackground", Mt(kLe, 0.5), C("minimapSliderHoverBackground", "Minimap slider background color when hovering."));
Z("minimapSlider.activeBackground", Mt(NLe, 0.5), C("minimapSliderActiveBackground", "Minimap slider background color when clicked on."));
Z("charts.foreground", En, C("chartsForeground", "The foreground color used in charts."));
Z("charts.lines", Mt(En, 0.5), C("chartsLines", "The color used for horizontal lines in charts."));
Z("charts.red", bO, C("chartsRed", "The red color used in chart visualizations."));
Z("charts.blue", yf, C("chartsBlue", "The blue color used in chart visualizations."));
Z("charts.yellow", d1, C("chartsYellow", "The yellow color used in chart visualizations."));
Z("charts.orange", uL, C("chartsOrange", "The orange color used in chart visualizations."));
Z("charts.green", { dark: "#89D185", light: "#388A34", hcDark: "#89D185", hcLight: "#374e06" }, C("chartsGreen", "The green color used in chart visualizations."));
Z("charts.purple", { dark: "#B180D7", light: "#652D90", hcDark: "#B180D7", hcLight: "#652D90" }, C("chartsPurple", "The purple color used in chart visualizations."));
const iAt = Z("input.background", { dark: "#3C3C3C", light: ge.white, hcDark: ge.black, hcLight: ge.white }, C("inputBoxBackground", "Input box background.")), rAt = Z("input.foreground", En, C("inputBoxForeground", "Input box foreground.")), sAt = Z("input.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("inputBoxBorder", "Input box border.")), sy = Z("inputOption.activeBorder", { dark: "#007ACC", light: "#007ACC", hcDark: $t, hcLight: $t }, C("inputBoxActiveOptionBorder", "Border color of activated options in input fields.")), oAt = Z("inputOption.hoverBackground", { dark: "#5a5d5e80", light: "#b8b8b850", hcDark: null, hcLight: null }, C("inputOption.hoverBackground", "Background color of activated options in input fields.")), oy = Z("inputOption.activeBackground", { dark: Mt(hh, 0.4), light: Mt(hh, 0.2), hcDark: ge.transparent, hcLight: ge.transparent }, C("inputOption.activeBackground", "Background hover color of options in input fields.")), ay = Z("inputOption.activeForeground", { dark: ge.white, light: ge.black, hcDark: En, hcLight: En }, C("inputOption.activeForeground", "Foreground color of activated options in input fields."));
Z("input.placeholderForeground", { light: Mt(En, 0.5), dark: Mt(En, 0.5), hcDark: Mt(En, 0.7), hcLight: Mt(En, 0.7) }, C("inputPlaceholderForeground", "Input box foreground color for placeholder text."));
const aAt = Z("inputValidation.infoBackground", { dark: "#063B49", light: "#D6ECF2", hcDark: ge.black, hcLight: ge.white }, C("inputValidationInfoBackground", "Input validation background color for information severity.")), lAt = Z("inputValidation.infoForeground", { dark: null, light: null, hcDark: null, hcLight: En }, C("inputValidationInfoForeground", "Input validation foreground color for information severity.")), cAt = Z("inputValidation.infoBorder", { dark: "#007acc", light: "#007acc", hcDark: $t, hcLight: $t }, C("inputValidationInfoBorder", "Input validation border color for information severity.")), hAt = Z("inputValidation.warningBackground", { dark: "#352A05", light: "#F6F5D2", hcDark: ge.black, hcLight: ge.white }, C("inputValidationWarningBackground", "Input validation background color for warning severity.")), dAt = Z("inputValidation.warningForeground", { dark: null, light: null, hcDark: null, hcLight: En }, C("inputValidationWarningForeground", "Input validation foreground color for warning severity.")), uAt = Z("inputValidation.warningBorder", { dark: "#B89500", light: "#B89500", hcDark: $t, hcLight: $t }, C("inputValidationWarningBorder", "Input validation border color for warning severity.")), fAt = Z("inputValidation.errorBackground", { dark: "#5A1D1D", light: "#F2DEDE", hcDark: ge.black, hcLight: ge.white }, C("inputValidationErrorBackground", "Input validation background color for error severity.")), pAt = Z("inputValidation.errorForeground", { dark: null, light: null, hcDark: null, hcLight: En }, C("inputValidationErrorForeground", "Input validation foreground color for error severity.")), gAt = Z("inputValidation.errorBorder", { dark: "#BE1100", light: "#BE1100", hcDark: $t, hcLight: $t }, C("inputValidationErrorBorder", "Input validation border color for error severity.")), ly = Z("dropdown.background", { dark: "#3C3C3C", light: ge.white, hcDark: ge.black, hcLight: ge.white }, C("dropdownBackground", "Dropdown background.")), mAt = Z("dropdown.listBackground", { dark: null, light: null, hcDark: ge.black, hcLight: ge.white }, C("dropdownListBackground", "Dropdown list background.")), CO = Z("dropdown.foreground", { dark: "#F0F0F0", light: En, hcDark: ge.white, hcLight: En }, C("dropdownForeground", "Dropdown foreground.")), EO = Z("dropdown.border", { dark: ly, light: "#CECECE", hcDark: $t, hcLight: $t }, C("dropdownBorder", "Dropdown border.")), BLe = Z("button.foreground", ge.white, C("buttonForeground", "Button foreground color.")), AAt = Z("button.separator", Mt(BLe, 0.4), C("buttonSeparator", "Button separator color.")), pA = Z("button.background", { dark: "#0E639C", light: "#007ACC", hcDark: null, hcLight: "#0F4A85" }, C("buttonBackground", "Button background color.")), wAt = Z("button.hoverBackground", { dark: Yl(pA, 0.2), light: e2(pA, 0.2), hcDark: pA, hcLight: pA }, C("buttonHoverBackground", "Button background color when hovering.")), vAt = Z("button.border", $t, C("buttonBorder", "Button border color.")), bAt = Z("button.secondaryForeground", { dark: ge.white, light: ge.white, hcDark: ge.white, hcLight: En }, C("buttonSecondaryForeground", "Secondary button foreground color.")), fL = Z("button.secondaryBackground", { dark: "#3A3D41", light: "#5F6A79", hcDark: null, hcLight: ge.white }, C("buttonSecondaryBackground", "Secondary button background color.")), yAt = Z("button.secondaryHoverBackground", { dark: Yl(fL, 0.2), light: e2(fL, 0.2), hcDark: null, hcLight: null }, C("buttonSecondaryHoverBackground", "Secondary button background color when hovering.")), gA = Z("radio.activeForeground", ay, C("radioActiveForeground", "Foreground color of active radio option.")), CAt = Z("radio.activeBackground", oy, C("radioBackground", "Background color of active radio option.")), EAt = Z("radio.activeBorder", sy, C("radioActiveBorder", "Border color of the active radio option.")), _At = Z("radio.inactiveForeground", null, C("radioInactiveForeground", "Foreground color of inactive radio option.")), xAt = Z("radio.inactiveBackground", null, C("radioInactiveBackground", "Background color of inactive radio option.")), SAt = Z("radio.inactiveBorder", { light: Mt(gA, 0.2), dark: Mt(gA, 0.2), hcDark: Mt(gA, 0.4), hcLight: Mt(gA, 0.2) }, C("radioInactiveBorder", "Border color of the inactive radio option.")), MAt = Z("radio.inactiveHoverBackground", oAt, C("radioHoverBackground", "Background color of inactive active radio option when hovering.")), DAt = Z("checkbox.background", ly, C("checkbox.background", "Background color of checkbox widget."));
Z("checkbox.selectBackground", Zl, C("checkbox.select.background", "Background color of checkbox widget when the element it's in is selected."));
const LAt = Z("checkbox.foreground", CO, C("checkbox.foreground", "Foreground color of checkbox widget.")), kAt = Z("checkbox.border", EO, C("checkbox.border", "Border color of checkbox widget."));
Z("checkbox.selectBorder", oL, C("checkbox.select.border", "Border color of checkbox widget when the element it's in is selected."));
const NAt = Z("keybindingLabel.background", { dark: new ge(new Zt(128, 128, 128, 0.17)), light: new ge(new Zt(221, 221, 221, 0.4)), hcDark: ge.transparent, hcLight: ge.transparent }, C("keybindingLabelBackground", "Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.")), TAt = Z("keybindingLabel.foreground", { dark: ge.fromHex("#CCCCCC"), light: ge.fromHex("#555555"), hcDark: ge.white, hcLight: En }, C("keybindingLabelForeground", "Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.")), IAt = Z("keybindingLabel.border", { dark: new ge(new Zt(51, 51, 51, 0.6)), light: new ge(new Zt(204, 204, 204, 0.4)), hcDark: new ge(new Zt(111, 195, 223)), hcLight: $t }, C("keybindingLabelBorder", "Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.")), OAt = Z("keybindingLabel.bottomBorder", { dark: new ge(new Zt(68, 68, 68, 0.6)), light: new ge(new Zt(187, 187, 187, 0.4)), hcDark: new ge(new Zt(111, 195, 223)), hcLight: En }, C("keybindingLabelBottomBorder", "Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.")), RAt = Z("list.focusBackground", null, C("listFocusBackground", "List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), VAt = Z("list.focusForeground", null, C("listFocusForeground", "List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), HAt = Z("list.focusOutline", { dark: hh, light: hh, hcDark: _i, hcLight: _i }, C("listFocusOutline", "List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), BAt = Z("list.focusAndSelectionOutline", null, C("listFocusAndSelectionOutline", "List/Tree outline color for the focused item when the list/tree is active and selected. An active list/tree has keyboard focus, an inactive does not.")), fg = Z("list.activeSelectionBackground", { dark: "#04395E", light: "#0060C0", hcDark: null, hcLight: ge.fromHex("#0F4A85").transparent(0.1) }, C("listActiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), r9 = Z("list.activeSelectionForeground", { dark: ge.white, light: ge.white, hcDark: null, hcLight: null }, C("listActiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), PLe = Z("list.activeSelectionIconForeground", null, C("listActiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.")), PAt = Z("list.inactiveSelectionBackground", { dark: "#37373D", light: "#E4E6F1", hcDark: null, hcLight: ge.fromHex("#0F4A85").transparent(0.1) }, C("listInactiveSelectionBackground", "List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), FAt = Z("list.inactiveSelectionForeground", null, C("listInactiveSelectionForeground", "List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), zAt = Z("list.inactiveSelectionIconForeground", null, C("listInactiveSelectionIconForeground", "List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), WAt = Z("list.inactiveFocusBackground", null, C("listInactiveFocusBackground", "List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), jAt = Z("list.inactiveFocusOutline", null, C("listInactiveFocusOutline", "List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.")), FLe = Z("list.hoverBackground", { dark: "#2A2D2E", light: "#F0F0F0", hcDark: ge.white.transparent(0.1), hcLight: ge.fromHex("#0F4A85").transparent(0.1) }, C("listHoverBackground", "List/Tree background when hovering over items using the mouse.")), zLe = Z("list.hoverForeground", null, C("listHoverForeground", "List/Tree foreground when hovering over items using the mouse.")), ZAt = Z("list.dropBackground", { dark: "#062F4A", light: "#D6EBFF", hcDark: null, hcLight: null }, C("listDropBackground", "List/Tree drag and drop background when moving items over other items when using the mouse.")), UAt = Z("list.dropBetweenBackground", { dark: oL, light: oL, hcDark: null, hcLight: null }, C("listDropBetweenBackground", "List/Tree drag and drop border color when moving items between items when using the mouse.")), Ov = Z("list.highlightForeground", { dark: "#2AAAFF", light: "#0066BF", hcDark: hh, hcLight: hh }, C("highlight", "List/Tree foreground color of the match highlights when searching inside the list/tree."));
Z("list.focusHighlightForeground", { dark: Ov, light: Lmt(fg, Ov, "#BBE7FF"), hcDark: Ov, hcLight: Ov }, C("listFocusHighlightForeground", "List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree."));
Z("list.invalidItemForeground", { dark: "#B89500", light: "#B89500", hcDark: "#B89500", hcLight: "#B5200D" }, C("invalidItemForeground", "List/Tree foreground color for invalid items, for example an unresolved root in explorer."));
Z("list.errorForeground", { dark: "#F88070", light: "#B01011", hcDark: null, hcLight: null }, C("listErrorForeground", "Foreground color of list items containing errors."));
Z("list.warningForeground", { dark: "#CCA700", light: "#855F00", hcDark: null, hcLight: null }, C("listWarningForeground", "Foreground color of list items containing warnings."));
const qAt = Z("listFilterWidget.background", { light: e2(Zl, 0), dark: Yl(Zl, 0), hcDark: Zl, hcLight: Zl }, C("listFilterWidgetBackground", "Background color of the type filter widget in lists and trees.")), GAt = Z("listFilterWidget.outline", { dark: ge.transparent, light: ge.transparent, hcDark: "#f38518", hcLight: "#007ACC" }, C("listFilterWidgetOutline", "Outline color of the type filter widget in lists and trees.")), QAt = Z("listFilterWidget.noMatchesOutline", { dark: "#BE1100", light: "#BE1100", hcDark: $t, hcLight: $t }, C("listFilterWidgetNoMatchesOutline", "Outline color of the type filter widget in lists and trees, when there are no matches.")), KAt = Z("listFilterWidget.shadow", Mw, C("listFilterWidgetShadow", "Shadow color of the type filter widget in lists and trees."));
Z("list.filterMatchBackground", { dark: Ru, light: Ru, hcDark: null, hcLight: null }, C("listFilterMatchHighlight", "Background color of the filtered match."));
Z("list.filterMatchBorder", { dark: O0, light: O0, hcDark: $t, hcLight: _i }, C("listFilterMatchHighlightBorder", "Border color of the filtered match."));
Z("list.deemphasizedForeground", { dark: "#8C8C8C", light: "#8E8E90", hcDark: "#A7A8A9", hcLight: "#666666" }, C("listDeemphasizedForeground", "List/Tree foreground color for items that are deemphasized."));
const WLe = Z("tree.indentGuidesStroke", { dark: "#585858", light: "#a9a9a9", hcDark: "#a9a9a9", hcLight: "#a5a5a5" }, C("treeIndentGuidesStroke", "Tree stroke color for the indentation guides.")), YAt = Z("tree.inactiveIndentGuidesStroke", Mt(WLe, 0.4), C("treeInactiveIndentGuidesStroke", "Tree stroke color for the indentation guides that are not active.")), XAt = Z("tree.tableColumnsBorder", { dark: "#CCCCCC20", light: "#61616120", hcDark: null, hcLight: null }, C("tableColumnsBorder", "Table border color between columns.")), JAt = Z("tree.tableOddRowsBackground", { dark: Mt(En, 0.04), light: Mt(En, 0.04), hcDark: null, hcLight: null }, C("tableOddRowsBackgroundColor", "Background color for odd table rows.")), $At = Z("menu.border", { dark: null, light: null, hcDark: $t, hcLight: $t }, C("menuBorder", "Border color of menus.")), e3t = Z("menu.foreground", CO, C("menuForeground", "Foreground color of menu items.")), t3t = Z("menu.background", ly, C("menuBackground", "Background color of menu items.")), n3t = Z("menu.selectionForeground", r9, C("menuSelectionForeground", "Foreground color of the selected menu item in menus.")), i3t = Z("menu.selectionBackground", fg, C("menuSelectionBackground", "Background color of the selected menu item in menus.")), r3t = Z("menu.selectionBorder", { dark: null, light: null, hcDark: _i, hcLight: _i }, C("menuSelectionBorder", "Border color of the selected menu item in menus.")), s3t = Z("menu.separatorBackground", { dark: "#606060", light: "#D4D4D4", hcDark: $t, hcLight: $t }, C("menuSeparatorBackground", "Color of a separator menu item in menus.")), l6e = Z("quickInput.background", Zl, C("pickerBackground", "Quick picker background color. The quick picker widget is the container for pickers like the command palette.")), o3t = Z("quickInput.foreground", vO, C("pickerForeground", "Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.")), a3t = Z("quickInputTitle.background", { dark: new ge(new Zt(255, 255, 255, 0.105)), light: new ge(new Zt(0, 0, 0, 0.06)), hcDark: "#000000", hcLight: ge.white }, C("pickerTitleBackground", "Quick picker title background color. The quick picker widget is the container for pickers like the command palette.")), jLe = Z("pickerGroup.foreground", { dark: "#3794FF", light: "#0066BF", hcDark: ge.white, hcLight: "#0F4A85" }, C("pickerGroupForeground", "Quick picker color for grouping labels.")), l3t = Z("pickerGroup.border", { dark: "#3F3F46", light: "#CCCEDB", hcDark: ge.white, hcLight: "#0F4A85" }, C("pickerGroupBorder", "Quick picker color for grouping borders.")), c6e = Z("quickInput.list.focusBackground", null, "", void 0, C("quickInput.list.focusBackground deprecation", "Please use quickInputList.focusBackground instead")), pL = Z("quickInputList.focusForeground", r9, C("quickInput.listFocusForeground", "Quick picker foreground color for the focused item.")), ZLe = Z("quickInputList.focusIconForeground", PLe, C("quickInput.listFocusIconForeground", "Quick picker icon foreground color for the focused item.")), gL = Z("quickInputList.focusBackground", { dark: J5e(c6e, fg), light: J5e(c6e, fg), hcDark: null, hcLight: null }, C("quickInput.listFocusBackground", "Quick picker background color for the focused item."));
Z("search.resultsInfoForeground", { light: En, dark: Mt(En, 0.65), hcDark: En, hcLight: En }, C("search.resultsInfoForeground", "Color of the text in the search viewlet's completion message."));
Z("searchEditor.findMatchBackground", { light: Mt(Ru, 0.66), dark: Mt(Ru, 0.66), hcDark: Ru, hcLight: Ru }, C("searchEditor.queryMatch", "Color of the Search Editor query matches."));
Z("searchEditor.findMatchBorder", { light: Mt(O0, 0.66), dark: Mt(O0, 0.66), hcDark: O0, hcLight: O0 }, C("searchEditor.editorFindMatchBorder", "Border color of the Search Editor query matches."));
class cy {
  constructor(e, t) {
    this.x = e, this.y = t, this._pageCoordinatesBrand = void 0;
  }
  toClientCoordinates(e) {
    return new ULe(this.x - e.scrollX, this.y - e.scrollY);
  }
}
class ULe {
  constructor(e, t) {
    this.clientX = e, this.clientY = t, this._clientCoordinatesBrand = void 0;
  }
  toPageCoordinates(e) {
    return new cy(this.clientX + e.scrollX, this.clientY + e.scrollY);
  }
}
class c3t {
  constructor(e, t, n, i) {
    this.x = e, this.y = t, this.width = n, this.height = i, this._editorPagePositionBrand = void 0;
  }
}
class h3t {
  constructor(e, t) {
    this.x = e, this.y = t, this._positionRelativeToEditorBrand = void 0;
  }
}
function _O(r) {
  const e = To(r);
  return new c3t(e.left, e.top, e.width, e.height);
}
function xO(r, e, t) {
  const n = e.width / r.offsetWidth, i = e.height / r.offsetHeight, s = (t.x - e.x) / n, o = (t.y - e.y) / i;
  return new h3t(s, o);
}
class u1 extends zl {
  constructor(e, t, n) {
    super(qe(n), e), this._editorMouseEventBrand = void 0, this.isFromPointerCapture = t, this.pos = new cy(this.posx, this.posy), this.editorPos = _O(n), this.relativePos = xO(n, this.editorPos, this.pos);
  }
}
class d3t {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new u1(e, !1, this._editorViewDomNode);
  }
  onContextMenu(e, t) {
    return fe(e, "contextmenu", (n) => {
      t(this._create(n));
    });
  }
  onMouseUp(e, t) {
    return fe(e, "mouseup", (n) => {
      t(this._create(n));
    });
  }
  onMouseDown(e, t) {
    return fe(e, Se.MOUSE_DOWN, (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return fe(e, Se.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onMouseLeave(e, t) {
    return fe(e, Se.MOUSE_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onMouseMove(e, t) {
    return fe(e, "mousemove", (n) => t(this._create(n)));
  }
}
class u3t {
  constructor(e) {
    this._editorViewDomNode = e;
  }
  _create(e) {
    return new u1(e, !1, this._editorViewDomNode);
  }
  onPointerUp(e, t) {
    return fe(e, "pointerup", (n) => {
      t(this._create(n));
    });
  }
  onPointerDown(e, t) {
    return fe(e, Se.POINTER_DOWN, (n) => {
      t(this._create(n), n.pointerId);
    });
  }
  onPointerLeave(e, t) {
    return fe(e, Se.POINTER_LEAVE, (n) => {
      t(this._create(n));
    });
  }
  onPointerMove(e, t) {
    return fe(e, "pointermove", (n) => t(this._create(n)));
  }
}
class f3t extends me {
  constructor(e) {
    super(), this._editorViewDomNode = e, this._globalPointerMoveMonitor = this._register(new iy()), this._keydownListener = null;
  }
  startMonitoring(e, t, n, i, s) {
    this._keydownListener = ir(e.ownerDocument, "keydown", (o) => {
      o.toKeyCodeChord().isModifierKey() || this._globalPointerMoveMonitor.stopMonitoring(!0, o.browserEvent);
    }, !0), this._globalPointerMoveMonitor.startMonitoring(e, t, n, (o) => {
      i(new u1(o, !0, this._editorViewDomNode));
    }, (o) => {
      this._keydownListener.dispose(), s(o);
    });
  }
  stopMonitoring() {
    this._globalPointerMoveMonitor.stopMonitoring(!0);
  }
}
class qLe {
  static {
    this._idPool = 0;
  }
  constructor(e) {
    this._editor = e, this._instanceId = ++qLe._idPool, this._counter = 0, this._rules = /* @__PURE__ */ new Map(), this._garbageCollectionScheduler = new Nr(() => this.garbageCollect(), 1e3);
  }
  createClassNameRef(e) {
    const t = this.getOrCreateRule(e);
    return t.increaseRefCount(), {
      className: t.className,
      dispose: () => {
        t.decreaseRefCount(), this._garbageCollectionScheduler.schedule();
      }
    };
  }
  getOrCreateRule(e) {
    const t = this.computeUniqueKey(e);
    let n = this._rules.get(t);
    if (!n) {
      const i = this._counter++;
      n = new p3t(t, `dyn-rule-${this._instanceId}-${i}`, B8(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : void 0, e), this._rules.set(t, n);
    }
    return n;
  }
  computeUniqueKey(e) {
    return JSON.stringify(e);
  }
  garbageCollect() {
    for (const e of this._rules.values())
      e.hasReferences() || (this._rules.delete(e.key), e.dispose());
  }
}
class p3t {
  constructor(e, t, n, i) {
    this.key = e, this.className = t, this.properties = i, this._referenceCount = 0, this._styleElementDisposables = new ze(), this._styleElement = ya(n, void 0, this._styleElementDisposables), this._styleElement.textContent = this.getCssText(this.className, this.properties);
  }
  getCssText(e, t) {
    let n = `.${e} {`;
    for (const i in t) {
      const s = t[i];
      let o;
      typeof s == "object" ? o = _e(s.id) : o = s;
      const a = g3t(i);
      n += `
	${a}: ${o};`;
    }
    return n += `
}`, n;
  }
  dispose() {
    this._styleElementDisposables.dispose(), this._styleElement = void 0;
  }
  increaseRefCount() {
    this._referenceCount++;
  }
  decreaseRefCount() {
    this._referenceCount--;
  }
  hasReferences() {
    return this._referenceCount > 0;
  }
}
function g3t(r) {
  return r.replace(/(^[A-Z])/, ([e]) => e.toLowerCase()).replace(/([A-Z])/g, ([e]) => `-${e.toLowerCase()}`);
}
class Dw extends me {
  constructor() {
    super(), this._shouldRender = !0;
  }
  shouldRender() {
    return this._shouldRender;
  }
  forceShouldRender() {
    this._shouldRender = !0;
  }
  setShouldRender() {
    this._shouldRender = !0;
  }
  onDidRender() {
    this._shouldRender = !1;
  }
  // --- begin event handlers
  onCompositionStart(e) {
    return !1;
  }
  onCompositionEnd(e) {
    return !1;
  }
  onConfigurationChanged(e) {
    return !1;
  }
  onCursorStateChanged(e) {
    return !1;
  }
  onDecorationsChanged(e) {
    return !1;
  }
  onFlushed(e) {
    return !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  onLanguageConfigurationChanged(e) {
    return !1;
  }
  onLineMappingChanged(e) {
    return !1;
  }
  onLinesChanged(e) {
    return !1;
  }
  onLinesDeleted(e) {
    return !1;
  }
  onLinesInserted(e) {
    return !1;
  }
  onRevealRangeRequest(e) {
    return !1;
  }
  onScrollChanged(e) {
    return !1;
  }
  onThemeChanged(e) {
    return !1;
  }
  onTokensChanged(e) {
    return !1;
  }
  onTokensColorsChanged(e) {
    return !1;
  }
  onZonesChanged(e) {
    return !1;
  }
  // --- end event handlers
  handleEvents(e) {
    let t = !1;
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      switch (s.type) {
        case 0:
          this.onCompositionStart(s) && (t = !0);
          break;
        case 1:
          this.onCompositionEnd(s) && (t = !0);
          break;
        case 2:
          this.onConfigurationChanged(s) && (t = !0);
          break;
        case 3:
          this.onCursorStateChanged(s) && (t = !0);
          break;
        case 4:
          this.onDecorationsChanged(s) && (t = !0);
          break;
        case 5:
          this.onFlushed(s) && (t = !0);
          break;
        case 6:
          this.onFocusChanged(s) && (t = !0);
          break;
        case 7:
          this.onLanguageConfigurationChanged(s) && (t = !0);
          break;
        case 8:
          this.onLineMappingChanged(s) && (t = !0);
          break;
        case 9:
          this.onLinesChanged(s) && (t = !0);
          break;
        case 10:
          this.onLinesDeleted(s) && (t = !0);
          break;
        case 11:
          this.onLinesInserted(s) && (t = !0);
          break;
        case 12:
          this.onRevealRangeRequest(s) && (t = !0);
          break;
        case 13:
          this.onScrollChanged(s) && (t = !0);
          break;
        case 15:
          this.onTokensChanged(s) && (t = !0);
          break;
        case 14:
          this.onThemeChanged(s) && (t = !0);
          break;
        case 16:
          this.onTokensColorsChanged(s) && (t = !0);
          break;
        case 17:
          this.onZonesChanged(s) && (t = !0);
          break;
        default:
          console.info("View received unknown event: "), console.info(s);
      }
    }
    t && (this._shouldRender = !0);
  }
}
class uo extends Dw {
  constructor(e) {
    super(), this._context = e, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
}
class rc {
  static write(e, t) {
    e.setAttribute("data-mprt", String(t));
  }
  static read(e) {
    const t = e.getAttribute("data-mprt");
    return t === null ? 0 : parseInt(t, 10);
  }
  static collect(e, t) {
    const n = [];
    let i = 0;
    for (; e && e !== e.ownerDocument.body && e !== t; )
      e.nodeType === e.ELEMENT_NODE && (n[i++] = this.read(e)), e = e.parentElement;
    const s = new Uint8Array(i);
    for (let o = 0; o < i; o++)
      s[o] = n[i - o - 1];
    return s;
  }
}
class m3t {
  constructor(e, t) {
    this._restrictedRenderingContextBrand = void 0, this._viewLayout = e, this.viewportData = t, this.scrollWidth = this._viewLayout.getScrollWidth(), this.scrollHeight = this._viewLayout.getScrollHeight(), this.visibleRange = this.viewportData.visibleRange, this.bigNumbersDelta = this.viewportData.bigNumbersDelta;
    const n = this._viewLayout.getCurrentViewport();
    this.scrollTop = n.top, this.scrollLeft = n.left, this.viewportWidth = n.width, this.viewportHeight = n.height;
  }
  getScrolledTopFromAbsoluteTop(e) {
    return e - this.scrollTop;
  }
  getVerticalOffsetForLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t) {
    return this._viewLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  getDecorationsInViewport() {
    return this.viewportData.getDecorationsInViewport();
  }
}
class A3t extends m3t {
  constructor(e, t, n) {
    super(e, t), this._renderingContextBrand = void 0, this._viewLines = n;
  }
  linesVisibleRangesForRange(e, t) {
    return this._viewLines.linesVisibleRangesForRange(e, t);
  }
  visibleRangeForPosition(e) {
    return this._viewLines.visibleRangeForPosition(e);
  }
}
class w3t {
  constructor(e, t, n, i) {
    this.outsideRenderedLine = e, this.lineNumber = t, this.ranges = n, this.continuesOnNextLine = i;
  }
}
class hy {
  static from(e) {
    const t = new Array(e.length);
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      t[n] = new hy(s.left, s.width);
    }
    return t;
  }
  constructor(e, t) {
    this._horizontalRangeBrand = void 0, this.left = Math.round(e), this.width = Math.round(t);
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
}
class G0 {
  constructor(e, t) {
    this._floatHorizontalRangeBrand = void 0, this.left = e, this.width = t;
  }
  toString() {
    return `[${this.left},${this.width}]`;
  }
  static compare(e, t) {
    return e.left - t.left;
  }
}
class v3t {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.originalLeft = t, this.left = Math.round(this.originalLeft);
  }
}
class h6e {
  constructor(e, t) {
    this.outsideRenderedLine = e, this.ranges = t;
  }
}
class E6 {
  static _createRange() {
    return this._handyReadyRange || (this._handyReadyRange = document.createRange()), this._handyReadyRange;
  }
  static _detachRange(e, t) {
    e.selectNodeContents(t);
  }
  static _readClientRects(e, t, n, i, s) {
    const o = this._createRange();
    try {
      return o.setStart(e, t), o.setEnd(n, i), o.getClientRects();
    } catch {
      return null;
    } finally {
      this._detachRange(o, s);
    }
  }
  static _mergeAdjacentRanges(e) {
    if (e.length === 1)
      return e;
    e.sort(G0.compare);
    const t = [];
    let n = 0, i = e[0];
    for (let s = 1, o = e.length; s < o; s++) {
      const a = e[s];
      i.left + i.width + 0.9 >= a.left ? i.width = Math.max(i.width, a.left + a.width - i.left) : (t[n++] = i, i = a);
    }
    return t[n++] = i, t;
  }
  static _createHorizontalRangesFromClientRects(e, t, n) {
    if (!e || e.length === 0)
      return null;
    const i = [];
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      i[s] = new G0(Math.max(0, (a.left - t) / n), a.width / n);
    }
    return this._mergeAdjacentRanges(i);
  }
  static readHorizontalRanges(e, t, n, i, s, o) {
    const l = e.children.length - 1;
    if (0 > l)
      return null;
    if (t = Math.min(l, Math.max(0, t)), i = Math.min(l, Math.max(0, i)), t === i && n === s && n === 0 && !e.children[t].firstChild) {
      const f = e.children[t].getClientRects();
      return o.markDidDomLayout(), this._createHorizontalRangesFromClientRects(f, o.clientRectDeltaLeft, o.clientRectScale);
    }
    t !== i && i > 0 && s === 0 && (i--, s = 1073741824);
    let c = e.children[t].firstChild, d = e.children[i].firstChild;
    if ((!c || !d) && (!c && n === 0 && t > 0 && (c = e.children[t - 1].firstChild, n = 1073741824), !d && s === 0 && i > 0 && (d = e.children[i - 1].firstChild, s = 1073741824)), !c || !d)
      return null;
    n = Math.min(c.textContent.length, Math.max(0, n)), s = Math.min(d.textContent.length, Math.max(0, s));
    const u = this._readClientRects(c, n, d, s, o.endNode);
    return o.markDidDomLayout(), this._createHorizontalRangesFromClientRects(u, o.clientRectDeltaLeft, o.clientRectScale);
  }
}
var ua;
(function(r) {
  r.DARK = "dark", r.LIGHT = "light", r.HIGH_CONTRAST_DARK = "hcDark", r.HIGH_CONTRAST_LIGHT = "hcLight";
})(ua || (ua = {}));
function $u(r) {
  return r === ua.HIGH_CONTRAST_DARK || r === ua.HIGH_CONTRAST_LIGHT;
}
function dy(r) {
  return r === ua.DARK || r === ua.HIGH_CONTRAST_DARK;
}
const b3t = /* @__PURE__ */ function() {
  return I3 ? !0 : !(Cs || pl || l1);
}();
let Ep = !0;
class d6e {
  constructor(e, t) {
    this.themeType = t;
    const n = e.options, i = n.get(
      50
      /* EditorOption.fontInfo */
    );
    n.get(
      38
      /* EditorOption.experimentalWhitespaceRendering */
    ) === "off" ? this.renderWhitespace = n.get(
      100
      /* EditorOption.renderWhitespace */
    ) : this.renderWhitespace = "none", this.renderControlCharacters = n.get(
      95
      /* EditorOption.renderControlCharacters */
    ), this.spaceWidth = i.spaceWidth, this.middotWidth = i.middotWidth, this.wsmiddotWidth = i.wsmiddotWidth, this.useMonospaceOptimizations = i.isMonospace && !n.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), this.canUseHalfwidthRightwardsArrow = i.canUseHalfwidthRightwardsArrow, this.lineHeight = n.get(
      67
      /* EditorOption.lineHeight */
    ), this.stopRenderingLineAfter = n.get(
      118
      /* EditorOption.stopRenderingLineAfter */
    ), this.fontLigatures = n.get(
      51
      /* EditorOption.fontLigatures */
    );
  }
  equals(e) {
    return this.themeType === e.themeType && this.renderWhitespace === e.renderWhitespace && this.renderControlCharacters === e.renderControlCharacters && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.useMonospaceOptimizations === e.useMonospaceOptimizations && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter && this.fontLigatures === e.fontLigatures;
  }
}
class cd {
  static {
    this.CLASS_NAME = "view-line";
  }
  constructor(e) {
    this._options = e, this._isMaybeInvalid = !0, this._renderedViewLine = null;
  }
  // --- begin IVisibleLineData
  getDomNode() {
    return this._renderedViewLine && this._renderedViewLine.domNode ? this._renderedViewLine.domNode.domNode : null;
  }
  setDomNode(e) {
    if (this._renderedViewLine)
      this._renderedViewLine.domNode = Yt(e);
    else
      throw new Error("I have no rendered view line to set the dom node to...");
  }
  onContentChanged() {
    this._isMaybeInvalid = !0;
  }
  onTokensChanged() {
    this._isMaybeInvalid = !0;
  }
  onDecorationsChanged() {
    this._isMaybeInvalid = !0;
  }
  onOptionsChanged(e) {
    this._isMaybeInvalid = !0, this._options = e;
  }
  onSelectionChanged() {
    return $u(this._options.themeType) || this._options.renderWhitespace === "selection" ? (this._isMaybeInvalid = !0, !0) : !1;
  }
  renderLine(e, t, n, i, s) {
    if (this._isMaybeInvalid === !1)
      return !1;
    this._isMaybeInvalid = !1;
    const o = i.getViewLineRenderingData(e), a = this._options, l = bf.filter(o.inlineDecorations, e, o.minColumn, o.maxColumn);
    let c = null;
    if ($u(a.themeType) || this._options.renderWhitespace === "selection") {
      const p = i.selections;
      for (const g of p) {
        if (g.endLineNumber < e || g.startLineNumber > e)
          continue;
        const m = g.startLineNumber === e ? g.startColumn : o.minColumn, A = g.endLineNumber === e ? g.endColumn : o.maxColumn;
        m < A && ($u(a.themeType) && l.push(new bf(
          m,
          A,
          "inline-selected-text",
          0
          /* InlineDecorationType.Regular */
        )), this._options.renderWhitespace === "selection" && (c || (c = []), c.push(new wLe(m - 1, A - 1))));
      }
    }
    const d = new tm(a.useMonospaceOptimizations, a.canUseHalfwidthRightwardsArrow, o.content, o.continuesWithWrappedLine, o.isBasicASCII, o.containsRTL, o.minColumn - 1, o.tokens, l, o.tabSize, o.startVisibleColumn, a.spaceWidth, a.middotWidth, a.wsmiddotWidth, a.stopRenderingLineAfter, a.renderWhitespace, a.renderControlCharacters, a.fontLigatures !== Bl.OFF, c);
    if (this._renderedViewLine && this._renderedViewLine.input.equals(d))
      return !1;
    s.appendString('<div style="top:'), s.appendString(String(t)), s.appendString("px;height:"), s.appendString(String(n)), s.appendString('px;" class="'), s.appendString(cd.CLASS_NAME), s.appendString('">');
    const u = pO(d, s);
    s.appendString("</div>");
    let f = null;
    return Ep && b3t && o.isBasicASCII && a.useMonospaceOptimizations && u.containsForeignElements === 0 && (f = new Rv(this._renderedViewLine ? this._renderedViewLine.domNode : null, d, u.characterMapping)), f || (f = QLe(this._renderedViewLine ? this._renderedViewLine.domNode : null, d, u.characterMapping, u.containsRTL, u.containsForeignElements)), this._renderedViewLine = f, !0;
  }
  layoutLine(e, t, n) {
    this._renderedViewLine && this._renderedViewLine.domNode && (this._renderedViewLine.domNode.setTop(t), this._renderedViewLine.domNode.setHeight(n));
  }
  // --- end IVisibleLineData
  getWidth(e) {
    return this._renderedViewLine ? this._renderedViewLine.getWidth(e) : 0;
  }
  getWidthIsFast() {
    return this._renderedViewLine ? this._renderedViewLine.getWidthIsFast() : !0;
  }
  needsMonospaceFontCheck() {
    return this._renderedViewLine ? this._renderedViewLine instanceof Rv : !1;
  }
  monospaceAssumptionsAreValid() {
    return this._renderedViewLine && this._renderedViewLine instanceof Rv ? this._renderedViewLine.monospaceAssumptionsAreValid() : Ep;
  }
  onMonospaceAssumptionsInvalidated() {
    this._renderedViewLine && this._renderedViewLine instanceof Rv && (this._renderedViewLine = this._renderedViewLine.toSlowRenderedLine());
  }
  getVisibleRangesForRange(e, t, n, i) {
    if (!this._renderedViewLine)
      return null;
    t = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, t)), n = Math.min(this._renderedViewLine.input.lineContent.length + 1, Math.max(1, n));
    const s = this._renderedViewLine.input.stopRenderingLineAfter;
    if (s !== -1 && t > s + 1 && n > s + 1)
      return new h6e(!0, [new G0(this.getWidth(i), 0)]);
    s !== -1 && t > s + 1 && (t = s + 1), s !== -1 && n > s + 1 && (n = s + 1);
    const o = this._renderedViewLine.getVisibleRangesForRange(e, t, n, i);
    return o && o.length > 0 ? new h6e(!1, o) : null;
  }
  getColumnOfNodeOffset(e, t) {
    return this._renderedViewLine ? this._renderedViewLine.getColumnOfNodeOffset(e, t) : 1;
  }
}
class Rv {
  constructor(e, t, n) {
    this._cachedWidth = -1, this.domNode = e, this.input = t;
    const i = Math.floor(
      t.lineContent.length / 300
      /* Constants.MaxMonospaceDistance */
    );
    if (i > 0) {
      this._keyColumnPixelOffsetCache = new Float32Array(i);
      for (let s = 0; s < i; s++)
        this._keyColumnPixelOffsetCache[s] = -1;
    } else
      this._keyColumnPixelOffsetCache = null;
    this._characterMapping = n, this._charWidth = t.spaceWidth;
  }
  getWidth(e) {
    if (!this.domNode || this.input.lineContent.length < 300) {
      const t = this._characterMapping.getHorizontalOffset(this._characterMapping.length);
      return Math.round(this._charWidth * t);
    }
    return this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth;
  }
  getWidthIsFast() {
    return this.input.lineContent.length < 300 || this._cachedWidth !== -1;
  }
  monospaceAssumptionsAreValid() {
    if (!this.domNode)
      return Ep;
    if (this.input.lineContent.length < 300) {
      const e = this.getWidth(null), t = this.domNode.domNode.firstChild.offsetWidth;
      Math.abs(e - t) >= 2 && (console.warn("monospace assumptions have been violated, therefore disabling monospace optimizations!"), Ep = !1);
    }
    return Ep;
  }
  toSlowRenderedLine() {
    return QLe(
      this.domNode,
      this.input,
      this._characterMapping,
      !1,
      0
      /* ForeignElementType.None */
    );
  }
  getVisibleRangesForRange(e, t, n, i) {
    const s = this._getColumnPixelOffset(e, t, i), o = this._getColumnPixelOffset(e, n, i);
    return [new G0(s, o - s)];
  }
  _getColumnPixelOffset(e, t, n) {
    if (t <= 300) {
      const c = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * c;
    }
    const i = Math.floor(
      (t - 1) / 300
      /* Constants.MaxMonospaceDistance */
    ) - 1, s = (i + 1) * 300 + 1;
    let o = -1;
    if (this._keyColumnPixelOffsetCache && (o = this._keyColumnPixelOffsetCache[i], o === -1 && (o = this._actualReadPixelOffset(e, s, n), this._keyColumnPixelOffsetCache[i] = o)), o === -1) {
      const c = this._characterMapping.getHorizontalOffset(t);
      return this._charWidth * c;
    }
    const a = this._characterMapping.getHorizontalOffset(s), l = this._characterMapping.getHorizontalOffset(t);
    return o + this._charWidth * (l - a);
  }
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  _actualReadPixelOffset(e, t, n) {
    if (!this.domNode)
      return -1;
    const i = this._characterMapping.getDomPosition(t), s = E6.readHorizontalRanges(this._getReadingTarget(this.domNode), i.partIndex, i.charIndex, i.partIndex, i.charIndex, n);
    return !s || s.length === 0 ? -1 : s[0].left;
  }
  getColumnOfNodeOffset(e, t) {
    return KLe(this._characterMapping, e, t);
  }
}
class GLe {
  constructor(e, t, n, i, s) {
    if (this.domNode = e, this.input = t, this._characterMapping = n, this._isWhitespaceOnly = /^\s*$/.test(t.lineContent), this._containsForeignElements = s, this._cachedWidth = -1, this._pixelOffsetCache = null, !i || this._characterMapping.length === 0) {
      this._pixelOffsetCache = new Float32Array(Math.max(2, this._characterMapping.length + 1));
      for (let o = 0, a = this._characterMapping.length; o <= a; o++)
        this._pixelOffsetCache[o] = -1;
    }
  }
  // --- Reading from the DOM methods
  _getReadingTarget(e) {
    return e.domNode.firstChild;
  }
  /**
   * Width of the line in pixels
   */
  getWidth(e) {
    return this.domNode ? (this._cachedWidth === -1 && (this._cachedWidth = this._getReadingTarget(this.domNode).offsetWidth, e?.markDidDomLayout()), this._cachedWidth) : 0;
  }
  getWidthIsFast() {
    return this._cachedWidth !== -1;
  }
  /**
   * Visible ranges for a model range
   */
  getVisibleRangesForRange(e, t, n, i) {
    if (!this.domNode)
      return null;
    if (this._pixelOffsetCache !== null) {
      const s = this._readPixelOffset(this.domNode, e, t, i);
      if (s === -1)
        return null;
      const o = this._readPixelOffset(this.domNode, e, n, i);
      return o === -1 ? null : [new G0(s, o - s)];
    }
    return this._readVisibleRangesForRange(this.domNode, e, t, n, i);
  }
  _readVisibleRangesForRange(e, t, n, i, s) {
    if (n === i) {
      const o = this._readPixelOffset(e, t, n, s);
      return o === -1 ? null : [new G0(o, 0)];
    } else
      return this._readRawVisibleRangesForRange(e, n, i, s);
  }
  _readPixelOffset(e, t, n, i) {
    if (this._characterMapping.length === 0) {
      if (this._containsForeignElements === 0 || this._containsForeignElements === 2)
        return 0;
      if (this._containsForeignElements === 1)
        return this.getWidth(i);
      const s = this._getReadingTarget(e);
      return s.firstChild ? (i.markDidDomLayout(), s.firstChild.offsetWidth) : 0;
    }
    if (this._pixelOffsetCache !== null) {
      const s = this._pixelOffsetCache[n];
      if (s !== -1)
        return s;
      const o = this._actualReadPixelOffset(e, t, n, i);
      return this._pixelOffsetCache[n] = o, o;
    }
    return this._actualReadPixelOffset(e, t, n, i);
  }
  _actualReadPixelOffset(e, t, n, i) {
    if (this._characterMapping.length === 0) {
      const l = E6.readHorizontalRanges(this._getReadingTarget(e), 0, 0, 0, 0, i);
      return !l || l.length === 0 ? -1 : l[0].left;
    }
    if (n === this._characterMapping.length && this._isWhitespaceOnly && this._containsForeignElements === 0)
      return this.getWidth(i);
    const s = this._characterMapping.getDomPosition(n), o = E6.readHorizontalRanges(this._getReadingTarget(e), s.partIndex, s.charIndex, s.partIndex, s.charIndex, i);
    if (!o || o.length === 0)
      return -1;
    const a = o[0].left;
    if (this.input.isBasicASCII) {
      const l = this._characterMapping.getHorizontalOffset(n), c = Math.round(this.input.spaceWidth * l);
      if (Math.abs(c - a) <= 1)
        return c;
    }
    return a;
  }
  _readRawVisibleRangesForRange(e, t, n, i) {
    if (t === 1 && n === this._characterMapping.length)
      return [new G0(0, this.getWidth(i))];
    const s = this._characterMapping.getDomPosition(t), o = this._characterMapping.getDomPosition(n);
    return E6.readHorizontalRanges(this._getReadingTarget(e), s.partIndex, s.charIndex, o.partIndex, o.charIndex, i);
  }
  /**
   * Returns the column for the text found at a specific offset inside a rendered dom node
   */
  getColumnOfNodeOffset(e, t) {
    return KLe(this._characterMapping, e, t);
  }
}
class y3t extends GLe {
  _readVisibleRangesForRange(e, t, n, i, s) {
    const o = super._readVisibleRangesForRange(e, t, n, i, s);
    if (!o || o.length === 0 || n === i || n === 1 && i === this._characterMapping.length)
      return o;
    if (!this.input.containsRTL) {
      const a = this._readPixelOffset(e, t, i, s);
      if (a !== -1) {
        const l = o[o.length - 1];
        l.left < a && (l.width = a - l.left);
      }
    }
    return o;
  }
}
const QLe = /* @__PURE__ */ function() {
  return V7 ? C3t : E3t;
}();
function C3t(r, e, t, n, i) {
  return new y3t(r, e, t, n, i);
}
function E3t(r, e, t, n, i) {
  return new GLe(r, e, t, n, i);
}
function KLe(r, e, t) {
  const n = e.textContent.length;
  let i = -1;
  for (; e; )
    e = e.previousSibling, i++;
  return r.getColumn(new vLe(i, t), n);
}
class zi {
  static _nextVisibleColumn(e, t, n) {
    return e === 9 ? zi.nextRenderTabStop(t, n) : a1(e) || PI(e) ? t + 2 : t + 1;
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  static visibleColumnFromColumn(e, t, n) {
    const i = Math.min(t - 1, e.length), s = e.substring(0, i), o = new R8(s);
    let a = 0;
    for (; !o.eol(); ) {
      const l = O8(s, i, o.offset);
      o.nextGraphemeLength(), a = this._nextVisibleColumn(l, a, n);
    }
    return a;
  }
  /**
   * Returns a column from a visible column.
   * @see {@link CursorColumns}
   */
  static columnFromVisibleColumn(e, t, n) {
    if (t <= 0)
      return 1;
    const i = e.length, s = new R8(e);
    let o = 0, a = 1;
    for (; !s.eol(); ) {
      const l = O8(e, i, s.offset);
      s.nextGraphemeLength();
      const c = this._nextVisibleColumn(l, o, n), d = s.offset + 1;
      if (c >= t) {
        const u = t - o;
        return c - t < u ? d : a;
      }
      o = c, a = d;
    }
    return i + 1;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static nextRenderTabStop(e, t) {
    return e + t - e % t;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static nextIndentTabStop(e, t) {
    return e + t - e % t;
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static prevRenderTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
  /**
   * ATTENTION: This works with 0-based columns (as opposed to the regular 1-based columns)
   * @see {@link CursorColumns}
   */
  static prevIndentTabStop(e, t) {
    return Math.max(0, e - 1 - (e - 1) % t);
  }
}
class Q3 {
  /**
   * Get the visible column at the position. If we get to a non-whitespace character first
   * or past the end of string then return -1.
   *
   * **Note** `position` and the return value are 0-based.
   */
  static whitespaceVisibleColumn(e, t, n) {
    const i = e.length;
    let s = 0, o = -1, a = -1;
    for (let l = 0; l < i; l++) {
      if (l === t)
        return [o, a, s];
      switch (s % n === 0 && (o = l, a = s), e.charCodeAt(l)) {
        case 32:
          s += 1;
          break;
        case 9:
          s = zi.nextRenderTabStop(s, n);
          break;
        default:
          return [-1, -1, -1];
      }
    }
    return t === i ? [o, a, s] : [-1, -1, -1];
  }
  /**
   * Return the position that should result from a move left, right or to the
   * nearest tab, if atomic tabs are enabled. Left and right are used for the
   * arrow key movements, nearest is used for mouse selection. It returns
   * -1 if atomic tabs are not relevant and you should fall back to normal
   * behaviour.
   *
   * **Note**: `position` and the return value are 0-based.
   */
  static atomicPosition(e, t, n, i) {
    const s = e.length, [o, a, l] = Q3.whitespaceVisibleColumn(e, t, n);
    if (l === -1)
      return -1;
    let c;
    switch (i) {
      case 0:
        c = !0;
        break;
      case 1:
        c = !1;
        break;
      case 2:
        if (l % n === 0)
          return t;
        c = l % n <= n / 2;
        break;
    }
    if (c) {
      if (o === -1)
        return -1;
      let f = a;
      for (let p = o; p < s; ++p) {
        if (f === a + n)
          return o;
        switch (e.charCodeAt(p)) {
          case 32:
            f += 1;
            break;
          case 9:
            f = zi.nextRenderTabStop(f, n);
            break;
          default:
            return -1;
        }
      }
      return f === a + n ? o : -1;
    }
    const d = zi.nextRenderTabStop(l, n);
    let u = l;
    for (let f = t; f < s; f++) {
      if (u === d)
        return f;
      switch (e.charCodeAt(f)) {
        case 32:
          u += 1;
          break;
        case 9:
          u = zi.nextRenderTabStop(u, n);
          break;
        default:
          return -1;
      }
    }
    return u === d ? s : -1;
  }
}
class uu {
  constructor(e = null) {
    this.hitTarget = e, this.type = 0;
  }
}
class YLe {
  get hitTarget() {
    return this.spanNode;
  }
  constructor(e, t, n) {
    this.position = e, this.spanNode = t, this.injectedText = n, this.type = 1;
  }
}
var w0;
(function(r) {
  function e(t, n, i) {
    const s = t.getPositionFromDOMInfo(n, i);
    return s ? new YLe(s, n, null) : new uu(n);
  }
  r.createFromDOMInfo = e;
})(w0 || (w0 = {}));
class _3t {
  constructor(e, t) {
    this.lastViewCursorsRenderData = e, this.lastTextareaPosition = t;
  }
}
class Jr {
  static _deduceRage(e, t = null) {
    return !t && e ? new Q(e.lineNumber, e.column, e.lineNumber, e.column) : t ?? null;
  }
  static createUnknown(e, t, n) {
    return { type: 0, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createTextarea(e, t) {
    return { type: 1, element: e, mouseColumn: t, position: null, range: null };
  }
  static createMargin(e, t, n, i, s, o) {
    return { type: e, element: t, mouseColumn: n, position: i, range: s, detail: o };
  }
  static createViewZone(e, t, n, i, s) {
    return { type: e, element: t, mouseColumn: n, position: i, range: this._deduceRage(i), detail: s };
  }
  static createContentText(e, t, n, i, s) {
    return { type: 6, element: e, mouseColumn: t, position: n, range: this._deduceRage(n, i), detail: s };
  }
  static createContentEmpty(e, t, n, i) {
    return { type: 7, element: e, mouseColumn: t, position: n, range: this._deduceRage(n), detail: i };
  }
  static createContentWidget(e, t, n) {
    return { type: 9, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createScrollbar(e, t, n) {
    return { type: 11, element: e, mouseColumn: t, position: n, range: this._deduceRage(n) };
  }
  static createOverlayWidget(e, t, n) {
    return { type: 12, element: e, mouseColumn: t, position: null, range: null, detail: n };
  }
  static createOutsideEditor(e, t, n, i) {
    return { type: 13, element: null, mouseColumn: e, position: t, range: this._deduceRage(t), outsidePosition: n, outsideDistance: i };
  }
  static _typeToString(e) {
    return e === 1 ? "TEXTAREA" : e === 2 ? "GUTTER_GLYPH_MARGIN" : e === 3 ? "GUTTER_LINE_NUMBERS" : e === 4 ? "GUTTER_LINE_DECORATIONS" : e === 5 ? "GUTTER_VIEW_ZONE" : e === 6 ? "CONTENT_TEXT" : e === 7 ? "CONTENT_EMPTY" : e === 8 ? "CONTENT_VIEW_ZONE" : e === 9 ? "CONTENT_WIDGET" : e === 10 ? "OVERVIEW_RULER" : e === 11 ? "SCROLLBAR" : e === 12 ? "OVERLAY_WIDGET" : "UNKNOWN";
  }
  static toString(e) {
    return this._typeToString(e.type) + ": " + e.position + " - " + e.range + " - " + JSON.stringify(e.detail);
  }
}
class as {
  static isTextArea(e) {
    return e.length === 2 && e[0] === 3 && e[1] === 7;
  }
  static isChildOfViewLines(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 8;
  }
  static isStrictChildOfViewLines(e) {
    return e.length > 4 && e[0] === 3 && e[3] === 8;
  }
  static isChildOfScrollableElement(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 6;
  }
  static isChildOfMinimap(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 9;
  }
  static isChildOfContentWidgets(e) {
    return e.length >= 4 && e[0] === 3 && e[3] === 1;
  }
  static isChildOfOverflowGuard(e) {
    return e.length >= 1 && e[0] === 3;
  }
  static isChildOfOverflowingContentWidgets(e) {
    return e.length >= 1 && e[0] === 2;
  }
  static isChildOfOverlayWidgets(e) {
    return e.length >= 2 && e[0] === 3 && e[1] === 4;
  }
  static isChildOfOverflowingOverlayWidgets(e) {
    return e.length >= 1 && e[0] === 5;
  }
}
class Cf {
  constructor(e, t, n) {
    this.viewModel = e.viewModel;
    const i = e.configuration.options;
    this.layoutInfo = i.get(
      146
      /* EditorOption.layoutInfo */
    ), this.viewDomNode = t.viewDomNode, this.overflowWidgetsDomNode = t.overflowWidgetsDomNode ?? null, this.lineHeight = i.get(
      67
      /* EditorOption.lineHeight */
    ), this.stickyTabStops = i.get(
      117
      /* EditorOption.stickyTabStops */
    ), this.typicalHalfwidthCharacterWidth = i.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this.lastRenderData = n, this._context = e, this._viewHelper = t;
  }
  getZoneAtCoord(e) {
    return Cf.getZoneAtCoord(this._context, e);
  }
  static getZoneAtCoord(e, t) {
    const n = e.viewLayout.getWhitespaceAtVerticalOffset(t);
    if (n) {
      const i = n.verticalOffset + n.height / 2, s = e.viewModel.getLineCount();
      let o = null, a, l = null;
      return n.afterLineNumber !== s && (l = new le(n.afterLineNumber + 1, 1)), n.afterLineNumber > 0 && (o = new le(n.afterLineNumber, e.viewModel.getLineMaxColumn(n.afterLineNumber))), l === null ? a = o : o === null ? a = l : t < i ? a = o : a = l, {
        viewZoneId: n.id,
        afterLineNumber: n.afterLineNumber,
        positionBefore: o,
        positionAfter: l,
        position: a
      };
    }
    return null;
  }
  getFullLineRangeAtCoord(e) {
    if (this._context.viewLayout.isAfterLines(e)) {
      const i = this._context.viewModel.getLineCount(), s = this._context.viewModel.getLineMaxColumn(i);
      return {
        range: new Q(i, s, i, s),
        isAfterLines: !0
      };
    }
    const t = this._context.viewLayout.getLineNumberAtVerticalOffset(e), n = this._context.viewModel.getLineMaxColumn(t);
    return {
      range: new Q(t, 1, t, n),
      isAfterLines: !1
    };
  }
  getLineNumberAtVerticalOffset(e) {
    return this._context.viewLayout.getLineNumberAtVerticalOffset(e);
  }
  isAfterLines(e) {
    return this._context.viewLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._context.viewLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._context.viewLayout.isInBottomPadding(e);
  }
  getVerticalOffsetForLineNumber(e) {
    return this._context.viewLayout.getVerticalOffsetForLineNumber(e);
  }
  findAttribute(e, t) {
    return Cf._findAttribute(e, t, this._viewHelper.viewDomNode);
  }
  static _findAttribute(e, t, n) {
    for (; e && e !== e.ownerDocument.body; ) {
      if (e.hasAttribute && e.hasAttribute(t))
        return e.getAttribute(t);
      if (e === n)
        return null;
      e = e.parentNode;
    }
    return null;
  }
  getLineWidth(e) {
    return this._viewHelper.getLineWidth(e);
  }
  visibleRangeForPosition(e, t) {
    return this._viewHelper.visibleRangeForPosition(e, t);
  }
  getPositionFromDOMInfo(e, t) {
    return this._viewHelper.getPositionFromDOMInfo(e, t);
  }
  getCurrentScrollTop() {
    return this._context.viewLayout.getCurrentScrollTop();
  }
  getCurrentScrollLeft() {
    return this._context.viewLayout.getCurrentScrollLeft();
  }
}
class x3t {
  constructor(e, t, n, i) {
    this.editorPos = t, this.pos = n, this.relativePos = i, this.mouseVerticalOffset = Math.max(0, e.getCurrentScrollTop() + this.relativePos.y), this.mouseContentHorizontalOffset = e.getCurrentScrollLeft() + this.relativePos.x - e.layoutInfo.contentLeft, this.isInMarginArea = this.relativePos.x < e.layoutInfo.contentLeft && this.relativePos.x >= e.layoutInfo.glyphMarginLeft, this.isInContentArea = !this.isInMarginArea, this.mouseColumn = Math.max(0, Or._getMouseColumn(this.mouseContentHorizontalOffset, e.typicalHalfwidthCharacterWidth));
  }
}
class u6e extends x3t {
  get target() {
    return this._useHitTestTarget ? this.hitTestResult.value.hitTarget : this._eventTarget;
  }
  get targetPath() {
    return this._targetPathCacheElement !== this.target && this._targetElement && (this._targetPathCacheElement = this.target, this._targetPathCacheValue = rc.collect(this.target, this._targetElement)), this._targetPathCacheValue;
  }
  constructor(e, t, n, i, s, o = null) {
    super(e, t, n, i), this.hitTestResult = new o1(() => Or.doHitTest(this._ctx, this)), this._targetPathCacheElement = null, this._targetPathCacheValue = new Uint8Array(0), this._targetElement = null, this._ctx = e, this._eventTarget = s, this._targetElement = o;
    const a = !!this._eventTarget;
    this._useHitTestTarget = !a;
  }
  toString() {
    return `pos(${this.pos.x},${this.pos.y}), editorPos(${this.editorPos.x},${this.editorPos.y}), relativePos(${this.relativePos.x},${this.relativePos.y}), mouseVerticalOffset: ${this.mouseVerticalOffset}, mouseContentHorizontalOffset: ${this.mouseContentHorizontalOffset}
	target: ${this.target ? this.target.outerHTML : null}`;
  }
  get wouldBenefitFromHitTestTargetSwitch() {
    return !this._useHitTestTarget && this.hitTestResult.value.hitTarget !== null && this.target !== this.hitTestResult.value.hitTarget;
  }
  switchToHitTestTarget() {
    this._useHitTestTarget = !0;
  }
  _getMouseColumn(e = null) {
    return e && e.column < this._ctx.viewModel.getLineMaxColumn(e.lineNumber) ? zi.visibleColumnFromColumn(this._ctx.viewModel.getLineContent(e.lineNumber), e.column, this._ctx.viewModel.model.getOptions().tabSize) + 1 : this.mouseColumn;
  }
  fulfillUnknown(e = null) {
    return Jr.createUnknown(this.target, this._getMouseColumn(e), e);
  }
  fulfillTextarea() {
    return Jr.createTextarea(this.target, this._getMouseColumn());
  }
  fulfillMargin(e, t, n, i) {
    return Jr.createMargin(e, this.target, this._getMouseColumn(t), t, n, i);
  }
  fulfillViewZone(e, t, n) {
    return Jr.createViewZone(e, this.target, this._getMouseColumn(t), t, n);
  }
  fulfillContentText(e, t, n) {
    return Jr.createContentText(this.target, this._getMouseColumn(e), e, t, n);
  }
  fulfillContentEmpty(e, t) {
    return Jr.createContentEmpty(this.target, this._getMouseColumn(e), e, t);
  }
  fulfillContentWidget(e) {
    return Jr.createContentWidget(this.target, this._getMouseColumn(), e);
  }
  fulfillScrollbar(e) {
    return Jr.createScrollbar(this.target, this._getMouseColumn(e), e);
  }
  fulfillOverlayWidget(e) {
    return Jr.createOverlayWidget(this.target, this._getMouseColumn(), e);
  }
}
const f6e = { isAfterLines: !0 };
function ZE(r) {
  return {
    isAfterLines: !1,
    horizontalDistanceToText: r
  };
}
class Or {
  constructor(e, t) {
    this._context = e, this._viewHelper = t;
  }
  mouseTargetIsWidget(e) {
    const t = e.target, n = rc.collect(t, this._viewHelper.viewDomNode);
    return !!(as.isChildOfContentWidgets(n) || as.isChildOfOverflowingContentWidgets(n) || as.isChildOfOverlayWidgets(n) || as.isChildOfOverflowingOverlayWidgets(n));
  }
  createMouseTargetForView(e, t, n, i, s) {
    const o = new Cf(this._context, this._viewHelper, e), a = new u6e(o, t, n, i, s, o.viewDomNode);
    try {
      const l = Or._createMouseTarget(o, a);
      if (l.type === 6 && o.stickyTabStops && l.position !== null) {
        const c = Or._snapToSoftTabBoundary(l.position, o.viewModel), d = Q.fromPositions(c, c).plusRange(l.range);
        return a.fulfillContentText(c, d, l.detail);
      }
      return l;
    } catch {
      return a.fulfillUnknown();
    }
  }
  createMouseTargetForOverflowWidgetsDomNode(e, t, n, i, s) {
    const o = new Cf(this._context, this._viewHelper, e), a = new u6e(o, t, n, i, s, o.overflowWidgetsDomNode);
    try {
      return Or._createMouseTarget(o, a);
    } catch {
      return a.fulfillUnknown();
    }
  }
  static _createMouseTarget(e, t) {
    if (t.target === null)
      return t.fulfillUnknown();
    const n = t;
    let i = null;
    return !as.isChildOfOverflowGuard(t.targetPath) && !as.isChildOfOverflowingContentWidgets(t.targetPath) && !as.isChildOfOverflowingOverlayWidgets(t.targetPath) && (i = i || t.fulfillUnknown()), i = i || Or._hitTestContentWidget(e, n), i = i || Or._hitTestOverlayWidget(e, n), i = i || Or._hitTestMinimap(e, n), i = i || Or._hitTestScrollbarSlider(e, n), i = i || Or._hitTestViewZone(e, n), i = i || Or._hitTestMargin(e, n), i = i || Or._hitTestViewCursor(e, n), i = i || Or._hitTestTextArea(e, n), i = i || Or._hitTestViewLines(e, n), i = i || Or._hitTestScrollbar(e, n), i || t.fulfillUnknown();
  }
  static _hitTestContentWidget(e, t) {
    if (as.isChildOfContentWidgets(t.targetPath) || as.isChildOfOverflowingContentWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillContentWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestOverlayWidget(e, t) {
    if (as.isChildOfOverlayWidgets(t.targetPath) || as.isChildOfOverflowingOverlayWidgets(t.targetPath)) {
      const n = e.findAttribute(t.target, "widgetId");
      return n ? t.fulfillOverlayWidget(n) : t.fulfillUnknown();
    }
    return null;
  }
  static _hitTestViewCursor(e, t) {
    if (t.target) {
      const n = e.lastRenderData.lastViewCursorsRenderData;
      for (const i of n)
        if (t.target === i.domNode)
          return t.fulfillContentText(i.position, null, { mightBeForeignElement: !1, injectedText: null });
    }
    if (t.isInContentArea) {
      const n = e.lastRenderData.lastViewCursorsRenderData, i = t.mouseContentHorizontalOffset, s = t.mouseVerticalOffset;
      for (const o of n) {
        if (i < o.contentLeft || i > o.contentLeft + o.width)
          continue;
        const a = e.getVerticalOffsetForLineNumber(o.position.lineNumber);
        if (a <= s && s <= a + o.height)
          return t.fulfillContentText(o.position, null, { mightBeForeignElement: !1, injectedText: null });
      }
    }
    return null;
  }
  static _hitTestViewZone(e, t) {
    const n = e.getZoneAtCoord(t.mouseVerticalOffset);
    if (n) {
      const i = t.isInContentArea ? 8 : 5;
      return t.fulfillViewZone(i, n.position, n);
    }
    return null;
  }
  static _hitTestTextArea(e, t) {
    return as.isTextArea(t.targetPath) ? e.lastRenderData.lastTextareaPosition ? t.fulfillContentText(e.lastRenderData.lastTextareaPosition, null, { mightBeForeignElement: !1, injectedText: null }) : t.fulfillTextarea() : null;
  }
  static _hitTestMargin(e, t) {
    if (t.isInMarginArea) {
      const n = e.getFullLineRangeAtCoord(t.mouseVerticalOffset), i = n.range.getStartPosition();
      let s = Math.abs(t.relativePos.x);
      const o = {
        isAfterLines: n.isAfterLines,
        glyphMarginLeft: e.layoutInfo.glyphMarginLeft,
        glyphMarginWidth: e.layoutInfo.glyphMarginWidth,
        lineNumbersWidth: e.layoutInfo.lineNumbersWidth,
        offsetX: s
      };
      if (s -= e.layoutInfo.glyphMarginLeft, s <= e.layoutInfo.glyphMarginWidth) {
        const a = e.viewModel.coordinatesConverter.convertViewPositionToModelPosition(n.range.getStartPosition()), l = e.viewModel.glyphLanes.getLanesAtLine(a.lineNumber);
        return o.glyphMarginLane = l[Math.floor(s / e.lineHeight)], t.fulfillMargin(2, i, n.range, o);
      }
      return s -= e.layoutInfo.glyphMarginWidth, s <= e.layoutInfo.lineNumbersWidth ? t.fulfillMargin(3, i, n.range, o) : (s -= e.layoutInfo.lineNumbersWidth, t.fulfillMargin(4, i, n.range, o));
    }
    return null;
  }
  static _hitTestViewLines(e, t) {
    if (!as.isChildOfViewLines(t.targetPath))
      return null;
    if (e.isInTopPadding(t.mouseVerticalOffset))
      return t.fulfillContentEmpty(new le(1, 1), f6e);
    if (e.isAfterLines(t.mouseVerticalOffset) || e.isInBottomPadding(t.mouseVerticalOffset)) {
      const i = e.viewModel.getLineCount(), s = e.viewModel.getLineMaxColumn(i);
      return t.fulfillContentEmpty(new le(i, s), f6e);
    }
    if (as.isStrictChildOfViewLines(t.targetPath)) {
      const i = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset);
      if (e.viewModel.getLineLength(i) === 0) {
        const o = e.getLineWidth(i), a = ZE(t.mouseContentHorizontalOffset - o);
        return t.fulfillContentEmpty(new le(i, 1), a);
      }
      const s = e.getLineWidth(i);
      if (t.mouseContentHorizontalOffset >= s) {
        const o = ZE(t.mouseContentHorizontalOffset - s), a = new le(i, e.viewModel.getLineMaxColumn(i));
        return t.fulfillContentEmpty(a, o);
      }
    }
    const n = t.hitTestResult.value;
    return n.type === 1 ? Or.createMouseTargetFromHitTestPosition(e, t, n.spanNode, n.position, n.injectedText) : t.wouldBenefitFromHitTestTargetSwitch ? (t.switchToHitTestTarget(), this._createMouseTarget(e, t)) : t.fulfillUnknown();
  }
  static _hitTestMinimap(e, t) {
    if (as.isChildOfMinimap(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), i = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new le(n, i));
    }
    return null;
  }
  static _hitTestScrollbarSlider(e, t) {
    if (as.isChildOfScrollableElement(t.targetPath) && t.target && t.target.nodeType === 1) {
      const n = t.target.className;
      if (n && /\b(slider|scrollbar)\b/.test(n)) {
        const i = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), s = e.viewModel.getLineMaxColumn(i);
        return t.fulfillScrollbar(new le(i, s));
      }
    }
    return null;
  }
  static _hitTestScrollbar(e, t) {
    if (as.isChildOfScrollableElement(t.targetPath)) {
      const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), i = e.viewModel.getLineMaxColumn(n);
      return t.fulfillScrollbar(new le(n, i));
    }
    return null;
  }
  getMouseColumn(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    ), i = this._context.viewLayout.getCurrentScrollLeft() + e.x - n.contentLeft;
    return Or._getMouseColumn(i, t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth);
  }
  static _getMouseColumn(e, t) {
    return e < 0 ? 1 : Math.round(e / t) + 1;
  }
  static createMouseTargetFromHitTestPosition(e, t, n, i, s) {
    const o = i.lineNumber, a = i.column, l = e.getLineWidth(o);
    if (t.mouseContentHorizontalOffset > l) {
      const w = ZE(t.mouseContentHorizontalOffset - l);
      return t.fulfillContentEmpty(i, w);
    }
    const c = e.visibleRangeForPosition(o, a);
    if (!c)
      return t.fulfillUnknown(i);
    const d = c.left;
    if (Math.abs(t.mouseContentHorizontalOffset - d) < 1)
      return t.fulfillContentText(i, null, { mightBeForeignElement: !!s, injectedText: s });
    const u = [];
    if (u.push({ offset: c.left, column: a }), a > 1) {
      const w = e.visibleRangeForPosition(o, a - 1);
      w && u.push({ offset: w.left, column: a - 1 });
    }
    const f = e.viewModel.getLineMaxColumn(o);
    if (a < f) {
      const w = e.visibleRangeForPosition(o, a + 1);
      w && u.push({ offset: w.left, column: a + 1 });
    }
    u.sort((w, v) => w.offset - v.offset);
    const p = t.pos.toClientCoordinates(qe(e.viewDomNode)), g = n.getBoundingClientRect(), m = g.left <= p.clientX && p.clientX <= g.right;
    let A = null;
    for (let w = 1; w < u.length; w++) {
      const v = u[w - 1], y = u[w];
      if (v.offset <= t.mouseContentHorizontalOffset && t.mouseContentHorizontalOffset <= y.offset) {
        A = new Q(o, v.column, o, y.column);
        const _ = Math.abs(v.offset - t.mouseContentHorizontalOffset), S = Math.abs(y.offset - t.mouseContentHorizontalOffset);
        i = _ < S ? new le(o, v.column) : new le(o, y.column);
        break;
      }
    }
    return t.fulfillContentText(i, A, { mightBeForeignElement: !m || !!s, injectedText: s });
  }
  /**
   * Most probably WebKit browsers and Edge
   */
  static _doHitTestWithCaretRangeFromPoint(e, t) {
    const n = e.getLineNumberAtVerticalOffset(t.mouseVerticalOffset), i = e.getVerticalOffsetForLineNumber(n), s = i + e.lineHeight;
    if (!(n === e.viewModel.getLineCount() && t.mouseVerticalOffset > s)) {
      const a = Math.floor((i + s) / 2);
      let l = t.pos.y + (a - t.mouseVerticalOffset);
      l <= t.editorPos.y && (l = t.editorPos.y + 1), l >= t.editorPos.y + t.editorPos.height && (l = t.editorPos.y + t.editorPos.height - 1);
      const c = new cy(t.pos.x, l), d = this._actualDoHitTestWithCaretRangeFromPoint(e, c.toClientCoordinates(qe(e.viewDomNode)));
      if (d.type === 1)
        return d;
    }
    return this._actualDoHitTestWithCaretRangeFromPoint(e, t.pos.toClientCoordinates(qe(e.viewDomNode)));
  }
  static _actualDoHitTestWithCaretRangeFromPoint(e, t) {
    const n = sg(e.viewDomNode);
    let i;
    if (n ? typeof n.caretRangeFromPoint > "u" ? i = S3t(n, t.clientX, t.clientY) : i = n.caretRangeFromPoint(t.clientX, t.clientY) : i = e.viewDomNode.ownerDocument.caretRangeFromPoint(t.clientX, t.clientY), !i || !i.startContainer)
      return new uu();
    const s = i.startContainer;
    if (s.nodeType === s.TEXT_NODE) {
      const o = s.parentNode, a = o ? o.parentNode : null, l = a ? a.parentNode : null;
      return (l && l.nodeType === l.ELEMENT_NODE ? l.className : null) === cd.CLASS_NAME ? w0.createFromDOMInfo(e, o, i.startOffset) : new uu(s.parentNode);
    } else if (s.nodeType === s.ELEMENT_NODE) {
      const o = s.parentNode, a = o ? o.parentNode : null;
      return (a && a.nodeType === a.ELEMENT_NODE ? a.className : null) === cd.CLASS_NAME ? w0.createFromDOMInfo(e, s, s.textContent.length) : new uu(s);
    }
    return new uu();
  }
  /**
   * Most probably Gecko
   */
  static _doHitTestWithCaretPositionFromPoint(e, t) {
    const n = e.viewDomNode.ownerDocument.caretPositionFromPoint(t.clientX, t.clientY);
    if (n.offsetNode.nodeType === n.offsetNode.TEXT_NODE) {
      const i = n.offsetNode.parentNode, s = i ? i.parentNode : null, o = s ? s.parentNode : null;
      return (o && o.nodeType === o.ELEMENT_NODE ? o.className : null) === cd.CLASS_NAME ? w0.createFromDOMInfo(e, n.offsetNode.parentNode, n.offset) : new uu(n.offsetNode.parentNode);
    }
    if (n.offsetNode.nodeType === n.offsetNode.ELEMENT_NODE) {
      const i = n.offsetNode.parentNode, s = i && i.nodeType === i.ELEMENT_NODE ? i.className : null, o = i ? i.parentNode : null, a = o && o.nodeType === o.ELEMENT_NODE ? o.className : null;
      if (s === cd.CLASS_NAME) {
        const l = n.offsetNode.childNodes[Math.min(n.offset, n.offsetNode.childNodes.length - 1)];
        if (l)
          return w0.createFromDOMInfo(e, l, 0);
      } else if (a === cd.CLASS_NAME)
        return w0.createFromDOMInfo(e, n.offsetNode, 0);
    }
    return new uu(n.offsetNode);
  }
  static _snapToSoftTabBoundary(e, t) {
    const n = t.getLineContent(e.lineNumber), { tabSize: i } = t.model.getOptions(), s = Q3.atomicPosition(
      n,
      e.column - 1,
      i,
      2
      /* Direction.Nearest */
    );
    return s !== -1 ? new le(e.lineNumber, s + 1) : e;
  }
  static doHitTest(e, t) {
    let n = new uu();
    if (typeof e.viewDomNode.ownerDocument.caretRangeFromPoint == "function" ? n = this._doHitTestWithCaretRangeFromPoint(e, t) : e.viewDomNode.ownerDocument.caretPositionFromPoint && (n = this._doHitTestWithCaretPositionFromPoint(e, t.pos.toClientCoordinates(qe(e.viewDomNode)))), n.type === 1) {
      const i = e.viewModel.getInjectedTextAt(n.position), s = e.viewModel.normalizePosition(
        n.position,
        2
        /* PositionAffinity.None */
      );
      (i || !s.equals(n.position)) && (n = new YLe(s, n.spanNode, i));
    }
    return n;
  }
}
function S3t(r, e, t) {
  const n = document.createRange();
  let i = r.elementFromPoint(e, t);
  if (i !== null) {
    for (; i && i.firstChild && i.firstChild.nodeType !== i.firstChild.TEXT_NODE && i.lastChild && i.lastChild.firstChild; )
      i = i.lastChild;
    const s = i.getBoundingClientRect(), o = qe(i), a = o.getComputedStyle(i, null).getPropertyValue("font-style"), l = o.getComputedStyle(i, null).getPropertyValue("font-variant"), c = o.getComputedStyle(i, null).getPropertyValue("font-weight"), d = o.getComputedStyle(i, null).getPropertyValue("font-size"), u = o.getComputedStyle(i, null).getPropertyValue("line-height"), f = o.getComputedStyle(i, null).getPropertyValue("font-family"), p = `${a} ${l} ${c} ${d}/${u} ${f}`, g = i.innerText;
    let m = s.left, A = 0, w;
    if (e > s.left + s.width)
      A = g.length;
    else {
      const v = ep.getInstance();
      for (let y = 0; y < g.length + 1; y++) {
        if (w = v.getCharWidth(g.charAt(y), p) / 2, m += w, e < m) {
          A = y;
          break;
        }
        m += w;
      }
    }
    n.setStart(i.firstChild, A), n.setEnd(i.firstChild, A);
  }
  return n;
}
class ep {
  static {
    this._INSTANCE = null;
  }
  static getInstance() {
    return ep._INSTANCE || (ep._INSTANCE = new ep()), ep._INSTANCE;
  }
  constructor() {
    this._cache = {}, this._canvas = document.createElement("canvas");
  }
  getCharWidth(e, t) {
    const n = e + t;
    if (this._cache[n])
      return this._cache[n];
    const i = this._canvas.getContext("2d");
    i.font = t;
    const o = i.measureText(e).width;
    return this._cache[n] = o, o;
  }
}
function wi(r, e, t) {
  let n = null, i = null;
  if (typeof t.value == "function" ? (n = "value", i = t.value, i.length !== 0 && console.warn("Memoize should only be used in functions with zero parameters")) : typeof t.get == "function" && (n = "get", i = t.get), !i)
    throw new Error("not supported");
  const s = `$memoize$${e}`;
  t[n] = function(...o) {
    return this.hasOwnProperty(s) || Object.defineProperty(this, s, {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: i.apply(this, o)
    }), this[s];
  };
}
var M3t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Nn;
(function(r) {
  r.Tap = "-monaco-gesturetap", r.Change = "-monaco-gesturechange", r.Start = "-monaco-gesturestart", r.End = "-monaco-gesturesend", r.Contextmenu = "-monaco-gesturecontextmenu";
})(Nn || (Nn = {}));
class Xn extends me {
  static {
    this.SCROLL_FRICTION = -5e-3;
  }
  static {
    this.HOLD_DELAY = 700;
  }
  static {
    this.CLEAR_TAP_COUNT_TIME = 400;
  }
  // ms
  constructor() {
    super(), this.dispatched = !1, this.targets = new no(), this.ignoreTargets = new no(), this.activeTouches = {}, this.handle = null, this._lastSetTapCountTime = 0, this._register(xe.runAndSubscribe(B7, ({ window: e, disposables: t }) => {
      t.add(fe(e.document, "touchstart", (n) => this.onTouchStart(n), { passive: !1 })), t.add(fe(e.document, "touchend", (n) => this.onTouchEnd(e, n))), t.add(fe(e.document, "touchmove", (n) => this.onTouchMove(n), { passive: !1 }));
    }, { window: Sn, disposables: this._store }));
  }
  static addTarget(e) {
    if (!Xn.isTouchDevice())
      return me.None;
    Xn.INSTANCE || (Xn.INSTANCE = new Xn());
    const t = Xn.INSTANCE.targets.push(e);
    return ht(t);
  }
  static ignoreTarget(e) {
    if (!Xn.isTouchDevice())
      return me.None;
    Xn.INSTANCE || (Xn.INSTANCE = new Xn());
    const t = Xn.INSTANCE.ignoreTargets.push(e);
    return ht(t);
  }
  static isTouchDevice() {
    return "ontouchstart" in Sn || navigator.maxTouchPoints > 0;
  }
  dispose() {
    this.handle && (this.handle.dispose(), this.handle = null), super.dispose();
  }
  onTouchStart(e) {
    const t = Date.now();
    this.handle && (this.handle.dispose(), this.handle = null);
    for (let n = 0, i = e.targetTouches.length; n < i; n++) {
      const s = e.targetTouches.item(n);
      this.activeTouches[s.identifier] = {
        id: s.identifier,
        initialTarget: s.target,
        initialTimeStamp: t,
        initialPageX: s.pageX,
        initialPageY: s.pageY,
        rollingTimestamps: [t],
        rollingPageX: [s.pageX],
        rollingPageY: [s.pageY]
      };
      const o = this.newGestureEvent(Nn.Start, s.target);
      o.pageX = s.pageX, o.pageY = s.pageY, this.dispatchEvent(o);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
  onTouchEnd(e, t) {
    const n = Date.now(), i = Object.keys(this.activeTouches).length;
    for (let s = 0, o = t.changedTouches.length; s < o; s++) {
      const a = t.changedTouches.item(s);
      if (!this.activeTouches.hasOwnProperty(String(a.identifier))) {
        console.warn("move of an UNKNOWN touch", a);
        continue;
      }
      const l = this.activeTouches[a.identifier], c = Date.now() - l.initialTimeStamp;
      if (c < Xn.HOLD_DELAY && Math.abs(l.initialPageX - qo(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - qo(l.rollingPageY)) < 30) {
        const d = this.newGestureEvent(Nn.Tap, l.initialTarget);
        d.pageX = qo(l.rollingPageX), d.pageY = qo(l.rollingPageY), this.dispatchEvent(d);
      } else if (c >= Xn.HOLD_DELAY && Math.abs(l.initialPageX - qo(l.rollingPageX)) < 30 && Math.abs(l.initialPageY - qo(l.rollingPageY)) < 30) {
        const d = this.newGestureEvent(Nn.Contextmenu, l.initialTarget);
        d.pageX = qo(l.rollingPageX), d.pageY = qo(l.rollingPageY), this.dispatchEvent(d);
      } else if (i === 1) {
        const d = qo(l.rollingPageX), u = qo(l.rollingPageY), f = qo(l.rollingTimestamps) - l.rollingTimestamps[0], p = d - l.rollingPageX[0], g = u - l.rollingPageY[0], m = [...this.targets].filter((A) => l.initialTarget instanceof Node && A.contains(l.initialTarget));
        this.inertia(
          e,
          m,
          n,
          // time now
          Math.abs(p) / f,
          // speed
          p > 0 ? 1 : -1,
          // x direction
          d,
          // x now
          Math.abs(g) / f,
          // y speed
          g > 0 ? 1 : -1,
          // y direction
          u
          // y now
        );
      }
      this.dispatchEvent(this.newGestureEvent(Nn.End, l.initialTarget)), delete this.activeTouches[a.identifier];
    }
    this.dispatched && (t.preventDefault(), t.stopPropagation(), this.dispatched = !1);
  }
  newGestureEvent(e, t) {
    const n = document.createEvent("CustomEvent");
    return n.initEvent(e, !1, !0), n.initialTarget = t, n.tapCount = 0, n;
  }
  dispatchEvent(e) {
    if (e.type === Nn.Tap) {
      const t = (/* @__PURE__ */ new Date()).getTime();
      let n = 0;
      t - this._lastSetTapCountTime > Xn.CLEAR_TAP_COUNT_TIME ? n = 1 : n = 2, this._lastSetTapCountTime = t, e.tapCount = n;
    } else (e.type === Nn.Change || e.type === Nn.Contextmenu) && (this._lastSetTapCountTime = 0);
    if (e.initialTarget instanceof Node) {
      for (const n of this.ignoreTargets)
        if (n.contains(e.initialTarget))
          return;
      const t = [];
      for (const n of this.targets)
        if (n.contains(e.initialTarget)) {
          let i = 0, s = e.initialTarget;
          for (; s && s !== n; )
            i++, s = s.parentElement;
          t.push([i, n]);
        }
      t.sort((n, i) => n[0] - i[0]);
      for (const [n, i] of t)
        i.dispatchEvent(e), this.dispatched = !0;
    }
  }
  inertia(e, t, n, i, s, o, a, l, c) {
    this.handle = co(e, () => {
      const d = Date.now(), u = d - n;
      let f = 0, p = 0, g = !0;
      i += Xn.SCROLL_FRICTION * u, a += Xn.SCROLL_FRICTION * u, i > 0 && (g = !1, f = s * i * u), a > 0 && (g = !1, p = l * a * u);
      const m = this.newGestureEvent(Nn.Change);
      m.translationX = f, m.translationY = p, t.forEach((A) => A.dispatchEvent(m)), g || this.inertia(e, t, d, i, s, o + f, a, l, c + p);
    });
  }
  onTouchMove(e) {
    const t = Date.now();
    for (let n = 0, i = e.changedTouches.length; n < i; n++) {
      const s = e.changedTouches.item(n);
      if (!this.activeTouches.hasOwnProperty(String(s.identifier))) {
        console.warn("end of an UNKNOWN touch", s);
        continue;
      }
      const o = this.activeTouches[s.identifier], a = this.newGestureEvent(Nn.Change, o.initialTarget);
      a.translationX = s.pageX - qo(o.rollingPageX), a.translationY = s.pageY - qo(o.rollingPageY), a.pageX = s.pageX, a.pageY = s.pageY, this.dispatchEvent(a), o.rollingPageX.length > 3 && (o.rollingPageX.shift(), o.rollingPageY.shift(), o.rollingTimestamps.shift()), o.rollingPageX.push(s.pageX), o.rollingPageY.push(s.pageY), o.rollingTimestamps.push(t);
    }
    this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
  }
}
M3t([
  wi
], Xn, "isTouchDevice", null);
let xa = class extends me {
  onclick(e, t) {
    this._register(fe(e, Se.CLICK, (n) => t(new zl(qe(e), n))));
  }
  onmousedown(e, t) {
    this._register(fe(e, Se.MOUSE_DOWN, (n) => t(new zl(qe(e), n))));
  }
  onmouseover(e, t) {
    this._register(fe(e, Se.MOUSE_OVER, (n) => t(new zl(qe(e), n))));
  }
  onmouseleave(e, t) {
    this._register(fe(e, Se.MOUSE_LEAVE, (n) => t(new zl(qe(e), n))));
  }
  onkeydown(e, t) {
    this._register(fe(e, Se.KEY_DOWN, (n) => t(new zn(n))));
  }
  onkeyup(e, t) {
    this._register(fe(e, Se.KEY_UP, (n) => t(new zn(n))));
  }
  oninput(e, t) {
    this._register(fe(e, Se.INPUT, t));
  }
  onblur(e, t) {
    this._register(fe(e, Se.BLUR, t));
  }
  onfocus(e, t) {
    this._register(fe(e, Se.FOCUS, t));
  }
  ignoreGesture(e) {
    return Xn.ignoreTarget(e);
  }
};
const pg = 11;
class D3t extends xa {
  constructor(e) {
    super(), this._onActivate = e.onActivate, this.bgDomNode = document.createElement("div"), this.bgDomNode.className = "arrow-background", this.bgDomNode.style.position = "absolute", this.bgDomNode.style.width = e.bgWidth + "px", this.bgDomNode.style.height = e.bgHeight + "px", typeof e.top < "u" && (this.bgDomNode.style.top = "0px"), typeof e.left < "u" && (this.bgDomNode.style.left = "0px"), typeof e.bottom < "u" && (this.bgDomNode.style.bottom = "0px"), typeof e.right < "u" && (this.bgDomNode.style.right = "0px"), this.domNode = document.createElement("div"), this.domNode.className = e.className, this.domNode.classList.add(...Tt.asClassNameArray(e.icon)), this.domNode.style.position = "absolute", this.domNode.style.width = pg + "px", this.domNode.style.height = pg + "px", typeof e.top < "u" && (this.domNode.style.top = e.top + "px"), typeof e.left < "u" && (this.domNode.style.left = e.left + "px"), typeof e.bottom < "u" && (this.domNode.style.bottom = e.bottom + "px"), typeof e.right < "u" && (this.domNode.style.right = e.right + "px"), this._pointerMoveMonitor = this._register(new iy()), this._register(ir(this.bgDomNode, Se.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._register(ir(this.domNode, Se.POINTER_DOWN, (t) => this._arrowPointerDown(t))), this._pointerdownRepeatTimer = this._register(new qI()), this._pointerdownScheduleRepeatTimer = this._register(new T1());
  }
  _arrowPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const t = () => {
      this._pointerdownRepeatTimer.cancelAndSet(() => this._onActivate(), 1e3 / 24, qe(e));
    };
    this._onActivate(), this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancelAndSet(t, 200), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (n) => {
    }, () => {
      this._pointerdownRepeatTimer.cancel(), this._pointerdownScheduleRepeatTimer.cancel();
    }), e.preventDefault();
  }
}
class L3t extends me {
  constructor(e, t, n) {
    super(), this._visibility = e, this._visibleClassName = t, this._invisibleClassName = n, this._domNode = null, this._isVisible = !1, this._isNeeded = !1, this._rawShouldBeVisible = !1, this._shouldBeVisible = !1, this._revealTimer = this._register(new T1());
  }
  setVisibility(e) {
    this._visibility !== e && (this._visibility = e, this._updateShouldBeVisible());
  }
  // ----------------- Hide / Reveal
  setShouldBeVisible(e) {
    this._rawShouldBeVisible = e, this._updateShouldBeVisible();
  }
  _applyVisibilitySetting() {
    return this._visibility === 2 ? !1 : this._visibility === 3 ? !0 : this._rawShouldBeVisible;
  }
  _updateShouldBeVisible() {
    const e = this._applyVisibilitySetting();
    this._shouldBeVisible !== e && (this._shouldBeVisible = e, this.ensureVisibility());
  }
  setIsNeeded(e) {
    this._isNeeded !== e && (this._isNeeded = e, this.ensureVisibility());
  }
  setDomNode(e) {
    this._domNode = e, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
  }
  ensureVisibility() {
    if (!this._isNeeded) {
      this._hide(!1);
      return;
    }
    this._shouldBeVisible ? this._reveal() : this._hide(!0);
  }
  _reveal() {
    this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet(() => {
      this._domNode?.setClassName(this._visibleClassName);
    }, 0));
  }
  _hide(e) {
    this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, this._domNode?.setClassName(this._invisibleClassName + (e ? " fade" : "")));
  }
}
const k3t = 140;
class XLe extends xa {
  constructor(e) {
    super(), this._lazyRender = e.lazyRender, this._host = e.host, this._scrollable = e.scrollable, this._scrollByPage = e.scrollByPage, this._scrollbarState = e.scrollbarState, this._visibilityController = this._register(new L3t(e.visibility, "visible scrollbar " + e.extraScrollbarClassName, "invisible scrollbar " + e.extraScrollbarClassName)), this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._pointerMoveMonitor = this._register(new iy()), this._shouldRender = !0, this.domNode = Yt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this._visibilityController.setDomNode(this.domNode), this.domNode.setPosition("absolute"), this._register(fe(this.domNode.domNode, Se.POINTER_DOWN, (t) => this._domNodePointerDown(t)));
  }
  // ----------------- creation
  /**
   * Creates the dom node for an arrow & adds it to the container
   */
  _createArrow(e) {
    const t = this._register(new D3t(e));
    this.domNode.domNode.appendChild(t.bgDomNode), this.domNode.domNode.appendChild(t.domNode);
  }
  /**
   * Creates the slider dom node, adds it to the container & hooks up the events
   */
  _createSlider(e, t, n, i) {
    this.slider = Yt(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(e), this.slider.setLeft(t), typeof n == "number" && this.slider.setWidth(n), typeof i == "number" && this.slider.setHeight(i), this.slider.setLayerHinting(!0), this.slider.setContain("strict"), this.domNode.domNode.appendChild(this.slider.domNode), this._register(fe(this.slider.domNode, Se.POINTER_DOWN, (s) => {
      s.button === 0 && (s.preventDefault(), this._sliderPointerDown(s));
    })), this.onclick(this.slider.domNode, (s) => {
      s.leftButton && s.stopPropagation();
    });
  }
  // ----------------- Update state
  _onElementSize(e) {
    return this._scrollbarState.setVisibleSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollSize(e) {
    return this._scrollbarState.setScrollSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  _onElementScrollPosition(e) {
    return this._scrollbarState.setScrollPosition(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
  }
  // ----------------- rendering
  beginReveal() {
    this._visibilityController.setShouldBeVisible(!0);
  }
  beginHide() {
    this._visibilityController.setShouldBeVisible(!1);
  }
  render() {
    this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
  }
  // ----------------- DOM events
  _domNodePointerDown(e) {
    e.target === this.domNode.domNode && this._onPointerDown(e);
  }
  delegatePointerDown(e) {
    const t = this.domNode.domNode.getClientRects()[0].top, n = t + this._scrollbarState.getSliderPosition(), i = t + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(), s = this._sliderPointerPosition(e);
    n <= s && s <= i ? e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e)) : this._onPointerDown(e);
  }
  _onPointerDown(e) {
    let t, n;
    if (e.target === this.domNode.domNode && typeof e.offsetX == "number" && typeof e.offsetY == "number")
      t = e.offsetX, n = e.offsetY;
    else {
      const s = To(this.domNode.domNode);
      t = e.pageX - s.left, n = e.pageY - s.top;
    }
    const i = this._pointerDownRelativePosition(t, n);
    this._setDesiredScrollPositionNow(this._scrollByPage ? this._scrollbarState.getDesiredScrollPositionFromOffsetPaged(i) : this._scrollbarState.getDesiredScrollPositionFromOffset(i)), e.button === 0 && (e.preventDefault(), this._sliderPointerDown(e));
  }
  _sliderPointerDown(e) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const t = this._sliderPointerPosition(e), n = this._sliderOrthogonalPointerPosition(e), i = this._scrollbarState.clone();
    this.slider.toggleClassName("active", !0), this._pointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (s) => {
      const o = this._sliderOrthogonalPointerPosition(s), a = Math.abs(o - n);
      if (zs && a > k3t) {
        this._setDesiredScrollPositionNow(i.getScrollPosition());
        return;
      }
      const c = this._sliderPointerPosition(s) - t;
      this._setDesiredScrollPositionNow(i.getDesiredScrollPositionFromDelta(c));
    }, () => {
      this.slider.toggleClassName("active", !1), this._host.onDragEnd();
    }), this._host.onDragStart();
  }
  _setDesiredScrollPositionNow(e) {
    const t = {};
    this.writeScrollPosition(t, e), this._scrollable.setScrollPositionNow(t);
  }
  updateScrollbarSize(e) {
    this._updateScrollbarSize(e), this._scrollbarState.setScrollbarSize(e), this._shouldRender = !0, this._lazyRender || this.render();
  }
  isNeeded() {
    return this._scrollbarState.isNeeded();
  }
}
const N3t = 20;
class gg {
  constructor(e, t, n, i, s, o) {
    this._scrollbarSize = Math.round(t), this._oppositeScrollbarSize = Math.round(n), this._arrowSize = Math.round(e), this._visibleSize = i, this._scrollSize = s, this._scrollPosition = o, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
  }
  clone() {
    return new gg(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize, this._visibleSize, this._scrollSize, this._scrollPosition);
  }
  setVisibleSize(e) {
    const t = Math.round(e);
    return this._visibleSize !== t ? (this._visibleSize = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollSize(e) {
    const t = Math.round(e);
    return this._scrollSize !== t ? (this._scrollSize = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollPosition(e) {
    const t = Math.round(e);
    return this._scrollPosition !== t ? (this._scrollPosition = t, this._refreshComputedValues(), !0) : !1;
  }
  setScrollbarSize(e) {
    this._scrollbarSize = Math.round(e);
  }
  setOppositeScrollbarSize(e) {
    this._oppositeScrollbarSize = Math.round(e);
  }
  static _computeValues(e, t, n, i, s) {
    const o = Math.max(0, n - e), a = Math.max(0, o - 2 * t), l = i > 0 && i > n;
    if (!l)
      return {
        computedAvailableSize: Math.round(o),
        computedIsNeeded: l,
        computedSliderSize: Math.round(a),
        computedSliderRatio: 0,
        computedSliderPosition: 0
      };
    const c = Math.round(Math.max(N3t, Math.floor(n * a / i))), d = (a - c) / (i - n), u = s * d;
    return {
      computedAvailableSize: Math.round(o),
      computedIsNeeded: l,
      computedSliderSize: Math.round(c),
      computedSliderRatio: d,
      computedSliderPosition: Math.round(u)
    };
  }
  _refreshComputedValues() {
    const e = gg._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);
    this._computedAvailableSize = e.computedAvailableSize, this._computedIsNeeded = e.computedIsNeeded, this._computedSliderSize = e.computedSliderSize, this._computedSliderRatio = e.computedSliderRatio, this._computedSliderPosition = e.computedSliderPosition;
  }
  getArrowSize() {
    return this._arrowSize;
  }
  getScrollPosition() {
    return this._scrollPosition;
  }
  getRectangleLargeSize() {
    return this._computedAvailableSize;
  }
  getRectangleSmallSize() {
    return this._scrollbarSize;
  }
  isNeeded() {
    return this._computedIsNeeded;
  }
  getSliderSize() {
    return this._computedSliderSize;
  }
  getSliderPosition() {
    return this._computedSliderPosition;
  }
  /**
   * Compute a desired `scrollPosition` such that `offset` ends up in the center of the slider.
   * `offset` is based on the same coordinate system as the `sliderPosition`.
   */
  getDesiredScrollPositionFromOffset(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = e - this._arrowSize - this._computedSliderSize / 2;
    return Math.round(t / this._computedSliderRatio);
  }
  /**
   * Compute a desired `scrollPosition` from if offset is before or after the slider position.
   * If offset is before slider, treat as a page up (or left).  If after, page down (or right).
   * `offset` and `_computedSliderPosition` are based on the same coordinate system.
   * `_visibleSize` corresponds to a "page" of lines in the returned coordinate system.
   */
  getDesiredScrollPositionFromOffsetPaged(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = e - this._arrowSize;
    let n = this._scrollPosition;
    return t < this._computedSliderPosition ? n -= this._visibleSize : n += this._visibleSize, n;
  }
  /**
   * Compute a desired `scrollPosition` such that the slider moves by `delta`.
   */
  getDesiredScrollPositionFromDelta(e) {
    if (!this._computedIsNeeded)
      return 0;
    const t = this._computedSliderPosition + e;
    return Math.round(t / this._computedSliderRatio);
  }
}
class T3t extends XLe {
  constructor(e, t, n) {
    const i = e.getScrollDimensions(), s = e.getCurrentScrollPosition();
    if (super({
      lazyRender: t.lazyRender,
      host: n,
      scrollbarState: new gg(t.horizontalHasArrows ? t.arrowSize : 0, t.horizontal === 2 ? 0 : t.horizontalScrollbarSize, t.vertical === 2 ? 0 : t.verticalScrollbarSize, i.width, i.scrollWidth, s.scrollLeft),
      visibility: t.horizontal,
      extraScrollbarClassName: "horizontal",
      scrollable: e,
      scrollByPage: t.scrollByPage
    }), t.horizontalHasArrows) {
      const o = (t.arrowSize - pg) / 2, a = (t.horizontalScrollbarSize - pg) / 2;
      this._createArrow({
        className: "scra",
        icon: ke.scrollbarButtonLeft,
        top: a,
        left: o,
        bottom: void 0,
        right: void 0,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: () => this._host.onMouseWheel(new mf(null, 1, 0))
      }), this._createArrow({
        className: "scra",
        icon: ke.scrollbarButtonRight,
        top: a,
        left: void 0,
        bottom: void 0,
        right: o,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: () => this._host.onMouseWheel(new mf(null, -1, 0))
      });
    }
    this._createSlider(Math.floor((t.horizontalScrollbarSize - t.horizontalSliderSize) / 2), 0, void 0, t.horizontalSliderSize);
  }
  _updateSlider(e, t) {
    this.slider.setWidth(e), this.slider.setLeft(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(e), this.domNode.setHeight(t), this.domNode.setLeft(0), this.domNode.setBottom(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(e.width) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return e;
  }
  _sliderPointerPosition(e) {
    return e.pageX;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageY;
  }
  _updateScrollbarSize(e) {
    this.slider.setHeight(e);
  }
  writeScrollPosition(e, t) {
    e.scrollLeft = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.horizontal === 2 ? 0 : e.horizontalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._visibilityController.setVisibility(e.horizontal), this._scrollByPage = e.scrollByPage;
  }
}
class I3t extends XLe {
  constructor(e, t, n) {
    const i = e.getScrollDimensions(), s = e.getCurrentScrollPosition();
    if (super({
      lazyRender: t.lazyRender,
      host: n,
      scrollbarState: new gg(
        t.verticalHasArrows ? t.arrowSize : 0,
        t.vertical === 2 ? 0 : t.verticalScrollbarSize,
        // give priority to vertical scroll bar over horizontal and let it scroll all the way to the bottom
        0,
        i.height,
        i.scrollHeight,
        s.scrollTop
      ),
      visibility: t.vertical,
      extraScrollbarClassName: "vertical",
      scrollable: e,
      scrollByPage: t.scrollByPage
    }), t.verticalHasArrows) {
      const o = (t.arrowSize - pg) / 2, a = (t.verticalScrollbarSize - pg) / 2;
      this._createArrow({
        className: "scra",
        icon: ke.scrollbarButtonUp,
        top: o,
        left: a,
        bottom: void 0,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: () => this._host.onMouseWheel(new mf(null, 0, 1))
      }), this._createArrow({
        className: "scra",
        icon: ke.scrollbarButtonDown,
        top: void 0,
        left: a,
        bottom: o,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: () => this._host.onMouseWheel(new mf(null, 0, -1))
      });
    }
    this._createSlider(0, Math.floor((t.verticalScrollbarSize - t.verticalSliderSize) / 2), t.verticalSliderSize, void 0);
  }
  _updateSlider(e, t) {
    this.slider.setHeight(e), this.slider.setTop(t);
  }
  _renderDomNode(e, t) {
    this.domNode.setWidth(t), this.domNode.setHeight(e), this.domNode.setRight(0), this.domNode.setTop(0);
  }
  onDidScroll(e) {
    return this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(e.height) || this._shouldRender, this._shouldRender;
  }
  _pointerDownRelativePosition(e, t) {
    return t;
  }
  _sliderPointerPosition(e) {
    return e.pageY;
  }
  _sliderOrthogonalPointerPosition(e) {
    return e.pageX;
  }
  _updateScrollbarSize(e) {
    this.slider.setWidth(e);
  }
  writeScrollPosition(e, t) {
    e.scrollTop = t;
  }
  updateOptions(e) {
    this.updateScrollbarSize(e.vertical === 2 ? 0 : e.verticalScrollbarSize), this._scrollbarState.setOppositeScrollbarSize(0), this._visibilityController.setVisibility(e.vertical), this._scrollByPage = e.scrollByPage;
  }
}
class s9 {
  constructor(e, t, n, i, s, o, a) {
    this._forceIntegerValues = e, this._scrollStateBrand = void 0, this._forceIntegerValues && (t = t | 0, n = n | 0, i = i | 0, s = s | 0, o = o | 0, a = a | 0), this.rawScrollLeft = i, this.rawScrollTop = a, t < 0 && (t = 0), i + t > n && (i = n - t), i < 0 && (i = 0), s < 0 && (s = 0), a + s > o && (a = o - s), a < 0 && (a = 0), this.width = t, this.scrollWidth = n, this.scrollLeft = i, this.height = s, this.scrollHeight = o, this.scrollTop = a;
  }
  equals(e) {
    return this.rawScrollLeft === e.rawScrollLeft && this.rawScrollTop === e.rawScrollTop && this.width === e.width && this.scrollWidth === e.scrollWidth && this.scrollLeft === e.scrollLeft && this.height === e.height && this.scrollHeight === e.scrollHeight && this.scrollTop === e.scrollTop;
  }
  withScrollDimensions(e, t) {
    return new s9(this._forceIntegerValues, typeof e.width < "u" ? e.width : this.width, typeof e.scrollWidth < "u" ? e.scrollWidth : this.scrollWidth, t ? this.rawScrollLeft : this.scrollLeft, typeof e.height < "u" ? e.height : this.height, typeof e.scrollHeight < "u" ? e.scrollHeight : this.scrollHeight, t ? this.rawScrollTop : this.scrollTop);
  }
  withScrollPosition(e) {
    return new s9(this._forceIntegerValues, this.width, this.scrollWidth, typeof e.scrollLeft < "u" ? e.scrollLeft : this.rawScrollLeft, this.height, this.scrollHeight, typeof e.scrollTop < "u" ? e.scrollTop : this.rawScrollTop);
  }
  createScrollEvent(e, t) {
    const n = this.width !== e.width, i = this.scrollWidth !== e.scrollWidth, s = this.scrollLeft !== e.scrollLeft, o = this.height !== e.height, a = this.scrollHeight !== e.scrollHeight, l = this.scrollTop !== e.scrollTop;
    return {
      inSmoothScrolling: t,
      oldWidth: e.width,
      oldScrollWidth: e.scrollWidth,
      oldScrollLeft: e.scrollLeft,
      width: this.width,
      scrollWidth: this.scrollWidth,
      scrollLeft: this.scrollLeft,
      oldHeight: e.height,
      oldScrollHeight: e.scrollHeight,
      oldScrollTop: e.scrollTop,
      height: this.height,
      scrollHeight: this.scrollHeight,
      scrollTop: this.scrollTop,
      widthChanged: n,
      scrollWidthChanged: i,
      scrollLeftChanged: s,
      heightChanged: o,
      scrollHeightChanged: a,
      scrollTopChanged: l
    };
  }
}
class nm extends me {
  constructor(e) {
    super(), this._scrollableBrand = void 0, this._onScroll = this._register(new $()), this.onScroll = this._onScroll.event, this._smoothScrollDuration = e.smoothScrollDuration, this._scheduleAtNextAnimationFrame = e.scheduleAtNextAnimationFrame, this._state = new s9(e.forceIntegerValues, 0, 0, 0, 0, 0, 0), this._smoothScrolling = null;
  }
  dispose() {
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), super.dispose();
  }
  setSmoothScrollDuration(e) {
    this._smoothScrollDuration = e;
  }
  validateScrollPosition(e) {
    return this._state.withScrollPosition(e);
  }
  getScrollDimensions() {
    return this._state;
  }
  setScrollDimensions(e, t) {
    const n = this._state.withScrollDimensions(e, t);
    this._setState(n, !!this._smoothScrolling), this._smoothScrolling?.acceptScrollDimensions(this._state);
  }
  /**
   * Returns the final scroll position that the instance will have once the smooth scroll animation concludes.
   * If no scroll animation is occurring, it will return the current scroll position instead.
   */
  getFutureScrollPosition() {
    return this._smoothScrolling ? this._smoothScrolling.to : this._state;
  }
  /**
   * Returns the current scroll position.
   * Note: This result might be an intermediate scroll position, as there might be an ongoing smooth scroll animation.
   */
  getCurrentScrollPosition() {
    return this._state;
  }
  setScrollPositionNow(e) {
    const t = this._state.withScrollPosition(e);
    this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(t, !1);
  }
  setScrollPositionSmooth(e, t) {
    if (this._smoothScrollDuration === 0)
      return this.setScrollPositionNow(e);
    if (this._smoothScrolling) {
      e = {
        scrollLeft: typeof e.scrollLeft > "u" ? this._smoothScrolling.to.scrollLeft : e.scrollLeft,
        scrollTop: typeof e.scrollTop > "u" ? this._smoothScrolling.to.scrollTop : e.scrollTop
      };
      const n = this._state.withScrollPosition(e);
      if (this._smoothScrolling.to.scrollLeft === n.scrollLeft && this._smoothScrolling.to.scrollTop === n.scrollTop)
        return;
      let i;
      t ? i = new K3(this._smoothScrolling.from, n, this._smoothScrolling.startTime, this._smoothScrolling.duration) : i = this._smoothScrolling.combine(this._state, n, this._smoothScrollDuration), this._smoothScrolling.dispose(), this._smoothScrolling = i;
    } else {
      const n = this._state.withScrollPosition(e);
      this._smoothScrolling = K3.start(this._state, n, this._smoothScrollDuration);
    }
    this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
      this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
    });
  }
  hasPendingScrollAnimation() {
    return !!this._smoothScrolling;
  }
  _performSmoothScrolling() {
    if (!this._smoothScrolling)
      return;
    const e = this._smoothScrolling.tick(), t = this._state.withScrollPosition(e);
    if (this._setState(t, !0), !!this._smoothScrolling) {
      if (e.isDone) {
        this._smoothScrolling.dispose(), this._smoothScrolling = null;
        return;
      }
      this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(() => {
        this._smoothScrolling && (this._smoothScrolling.animationFrameDisposable = null, this._performSmoothScrolling());
      });
    }
  }
  _setState(e, t) {
    const n = this._state;
    n.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(n, t)));
  }
}
class p6e {
  constructor(e, t, n) {
    this.scrollLeft = e, this.scrollTop = t, this.isDone = n;
  }
}
function UE(r, e) {
  const t = e - r;
  return function(n) {
    return r + t * V3t(n);
  };
}
function O3t(r, e, t) {
  return function(n) {
    return n < t ? r(n / t) : e((n - t) / (1 - t));
  };
}
class K3 {
  constructor(e, t, n, i) {
    this.from = e, this.to = t, this.duration = i, this.startTime = n, this.animationFrameDisposable = null, this._initAnimations();
  }
  _initAnimations() {
    this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
  }
  _initAnimation(e, t, n) {
    if (Math.abs(e - t) > 2.5 * n) {
      let s, o;
      return e < t ? (s = e + 0.75 * n, o = t - 0.75 * n) : (s = e - 0.75 * n, o = t + 0.75 * n), O3t(UE(e, s), UE(o, t), 0.33);
    }
    return UE(e, t);
  }
  dispose() {
    this.animationFrameDisposable !== null && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
  }
  acceptScrollDimensions(e) {
    this.to = e.withScrollPosition(this.to), this._initAnimations();
  }
  tick() {
    return this._tick(Date.now());
  }
  _tick(e) {
    const t = (e - this.startTime) / this.duration;
    if (t < 1) {
      const n = this.scrollLeft(t), i = this.scrollTop(t);
      return new p6e(n, i, !1);
    }
    return new p6e(this.to.scrollLeft, this.to.scrollTop, !0);
  }
  combine(e, t, n) {
    return K3.start(e, t, n);
  }
  static start(e, t, n) {
    n = n + 10;
    const i = Date.now() - 10;
    return new K3(e, t, i, n);
  }
}
function R3t(r) {
  return Math.pow(r, 3);
}
function V3t(r) {
  return 1 - R3t(1 - r);
}
const H3t = 500, g6e = 50;
class B3t {
  constructor(e, t, n) {
    this.timestamp = e, this.deltaX = t, this.deltaY = n, this.score = 0;
  }
}
class uy {
  static {
    this.INSTANCE = new uy();
  }
  constructor() {
    this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
  }
  isPhysicalMouseWheel() {
    if (this._front === -1 && this._rear === -1)
      return !1;
    let e = 1, t = 0, n = 1, i = this._rear;
    do {
      const s = i === this._front ? e : Math.pow(2, -n);
      if (e -= s, t += this._memory[i].score * s, i === this._front)
        break;
      i = (this._capacity + i - 1) % this._capacity, n++;
    } while (!0);
    return t <= 0.5;
  }
  acceptStandardWheelEvent(e) {
    if (vw) {
      const t = qe(e.browserEvent), n = V0t(t);
      this.accept(Date.now(), e.deltaX * n, e.deltaY * n);
    } else
      this.accept(Date.now(), e.deltaX, e.deltaY);
  }
  accept(e, t, n) {
    let i = null;
    const s = new B3t(e, t, n);
    this._front === -1 && this._rear === -1 ? (this._memory[0] = s, this._front = 0, this._rear = 0) : (i = this._memory[this._rear], this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = s), s.score = this._computeScore(s, i);
  }
  /**
   * A score between 0 and 1 for `item`.
   *  - a score towards 0 indicates that the source appears to be a physical mouse wheel
   *  - a score towards 1 indicates that the source appears to be a touchpad or magic mouse, etc.
   */
  _computeScore(e, t) {
    if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) > 0)
      return 1;
    let n = 0.5;
    if ((!this._isAlmostInt(e.deltaX) || !this._isAlmostInt(e.deltaY)) && (n += 0.25), t) {
      const i = Math.abs(e.deltaX), s = Math.abs(e.deltaY), o = Math.abs(t.deltaX), a = Math.abs(t.deltaY), l = Math.max(Math.min(i, o), 1), c = Math.max(Math.min(s, a), 1), d = Math.max(i, o), u = Math.max(s, a);
      d % l === 0 && u % c === 0 && (n -= 0.5);
    }
    return Math.min(Math.max(n, 0), 1);
  }
  _isAlmostInt(e) {
    return Math.abs(Math.round(e) - e) < 0.01;
  }
}
class SO extends xa {
  get options() {
    return this._options;
  }
  constructor(e, t, n) {
    super(), this._onScroll = this._register(new $()), this.onScroll = this._onScroll.event, this._onWillScroll = this._register(new $()), e.style.overflow = "hidden", this._options = F3t(t), this._scrollable = n, this._register(this._scrollable.onScroll((s) => {
      this._onWillScroll.fire(s), this._onDidScroll(s), this._onScroll.fire(s);
    }));
    const i = {
      onMouseWheel: (s) => this._onMouseWheel(s),
      onDragStart: () => this._onDragStart(),
      onDragEnd: () => this._onDragEnd()
    };
    this._verticalScrollbar = this._register(new I3t(this._scrollable, this._options, i)), this._horizontalScrollbar = this._register(new T3t(this._scrollable, this._options, i)), this._domNode = document.createElement("div"), this._domNode.className = "monaco-scrollable-element " + this._options.className, this._domNode.setAttribute("role", "presentation"), this._domNode.style.position = "relative", this._domNode.style.overflow = "hidden", this._domNode.appendChild(e), this._domNode.appendChild(this._horizontalScrollbar.domNode.domNode), this._domNode.appendChild(this._verticalScrollbar.domNode.domNode), this._options.useShadows ? (this._leftShadowDomNode = Yt(document.createElement("div")), this._leftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._leftShadowDomNode.domNode), this._topShadowDomNode = Yt(document.createElement("div")), this._topShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topShadowDomNode.domNode), this._topLeftShadowDomNode = Yt(document.createElement("div")), this._topLeftShadowDomNode.setClassName("shadow"), this._domNode.appendChild(this._topLeftShadowDomNode.domNode)) : (this._leftShadowDomNode = null, this._topShadowDomNode = null, this._topLeftShadowDomNode = null), this._listenOnDomNode = this._options.listenOnDomNode || this._domNode, this._mouseWheelToDispose = [], this._setListeningToMouseWheel(this._options.handleMouseWheel), this.onmouseover(this._listenOnDomNode, (s) => this._onMouseOver(s)), this.onmouseleave(this._listenOnDomNode, (s) => this._onMouseLeave(s)), this._hideTimeout = this._register(new T1()), this._isDragging = !1, this._mouseIsOver = !1, this._shouldRender = !0, this._revealOnScroll = !0;
  }
  dispose() {
    this._mouseWheelToDispose = br(this._mouseWheelToDispose), super.dispose();
  }
  /**
   * Get the generated 'scrollable' dom node
   */
  getDomNode() {
    return this._domNode;
  }
  getOverviewRulerLayoutInfo() {
    return {
      parent: this._domNode,
      insertBefore: this._verticalScrollbar.domNode.domNode
    };
  }
  /**
   * Delegate a pointer down event to the vertical scrollbar.
   * This is to help with clicking somewhere else and having the scrollbar react.
   */
  delegateVerticalScrollbarPointerDown(e) {
    this._verticalScrollbar.delegatePointerDown(e);
  }
  getScrollDimensions() {
    return this._scrollable.getScrollDimensions();
  }
  setScrollDimensions(e) {
    this._scrollable.setScrollDimensions(e, !1);
  }
  /**
   * Update the class name of the scrollable element.
   */
  updateClassName(e) {
    this._options.className = e, zt && (this._options.className += " mac"), this._domNode.className = "monaco-scrollable-element " + this._options.className;
  }
  /**
   * Update configuration options for the scrollbar.
   */
  updateOptions(e) {
    typeof e.handleMouseWheel < "u" && (this._options.handleMouseWheel = e.handleMouseWheel, this._setListeningToMouseWheel(this._options.handleMouseWheel)), typeof e.mouseWheelScrollSensitivity < "u" && (this._options.mouseWheelScrollSensitivity = e.mouseWheelScrollSensitivity), typeof e.fastScrollSensitivity < "u" && (this._options.fastScrollSensitivity = e.fastScrollSensitivity), typeof e.scrollPredominantAxis < "u" && (this._options.scrollPredominantAxis = e.scrollPredominantAxis), typeof e.horizontal < "u" && (this._options.horizontal = e.horizontal), typeof e.vertical < "u" && (this._options.vertical = e.vertical), typeof e.horizontalScrollbarSize < "u" && (this._options.horizontalScrollbarSize = e.horizontalScrollbarSize), typeof e.verticalScrollbarSize < "u" && (this._options.verticalScrollbarSize = e.verticalScrollbarSize), typeof e.scrollByPage < "u" && (this._options.scrollByPage = e.scrollByPage), this._horizontalScrollbar.updateOptions(this._options), this._verticalScrollbar.updateOptions(this._options), this._options.lazyRender || this._render();
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._onMouseWheel(new mf(e));
  }
  // -------------------- mouse wheel scrolling --------------------
  _setListeningToMouseWheel(e) {
    if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = br(this._mouseWheelToDispose), e)) {
      const n = (i) => {
        this._onMouseWheel(new mf(i));
      };
      this._mouseWheelToDispose.push(fe(this._listenOnDomNode, Se.MOUSE_WHEEL, n, { passive: !1 }));
    }
  }
  _onMouseWheel(e) {
    if (e.browserEvent?.defaultPrevented)
      return;
    const t = uy.INSTANCE;
    t.acceptStandardWheelEvent(e);
    let n = !1;
    if (e.deltaY || e.deltaX) {
      let s = e.deltaY * this._options.mouseWheelScrollSensitivity, o = e.deltaX * this._options.mouseWheelScrollSensitivity;
      this._options.scrollPredominantAxis && (this._options.scrollYToX && o + s === 0 ? o = s = 0 : Math.abs(s) >= Math.abs(o) ? o = 0 : s = 0), this._options.flipAxes && ([s, o] = [o, s]);
      const a = !zt && e.browserEvent && e.browserEvent.shiftKey;
      (this._options.scrollYToX || a) && !o && (o = s, s = 0), e.browserEvent && e.browserEvent.altKey && (o = o * this._options.fastScrollSensitivity, s = s * this._options.fastScrollSensitivity);
      const l = this._scrollable.getFutureScrollPosition();
      let c = {};
      if (s) {
        const d = g6e * s, u = l.scrollTop - (d < 0 ? Math.floor(d) : Math.ceil(d));
        this._verticalScrollbar.writeScrollPosition(c, u);
      }
      if (o) {
        const d = g6e * o, u = l.scrollLeft - (d < 0 ? Math.floor(d) : Math.ceil(d));
        this._horizontalScrollbar.writeScrollPosition(c, u);
      }
      c = this._scrollable.validateScrollPosition(c), (l.scrollLeft !== c.scrollLeft || l.scrollTop !== c.scrollTop) && (this._options.mouseWheelSmoothScroll && t.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(c) : this._scrollable.setScrollPositionNow(c), n = !0);
    }
    let i = n;
    !i && this._options.alwaysConsumeMouseWheel && (i = !0), !i && this._options.consumeMouseWheelIfScrollbarIsNeeded && (this._verticalScrollbar.isNeeded() || this._horizontalScrollbar.isNeeded()) && (i = !0), i && (e.preventDefault(), e.stopPropagation());
  }
  _onDidScroll(e) {
    this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
  }
  /**
   * Render / mutate the DOM now.
   * Should be used together with the ctor option `lazyRender`.
   */
  renderNow() {
    if (!this._options.lazyRender)
      throw new Error("Please use `lazyRender` together with `renderNow`!");
    this._render();
  }
  _render() {
    if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
      const e = this._scrollable.getCurrentScrollPosition(), t = e.scrollTop > 0, n = e.scrollLeft > 0, i = n ? " left" : "", s = t ? " top" : "", o = n || t ? " top-left-corner" : "";
      this._leftShadowDomNode.setClassName(`shadow${i}`), this._topShadowDomNode.setClassName(`shadow${s}`), this._topLeftShadowDomNode.setClassName(`shadow${o}${s}${i}`);
    }
  }
  // -------------------- fade in / fade out --------------------
  _onDragStart() {
    this._isDragging = !0, this._reveal();
  }
  _onDragEnd() {
    this._isDragging = !1, this._hide();
  }
  _onMouseLeave(e) {
    this._mouseIsOver = !1, this._hide();
  }
  _onMouseOver(e) {
    this._mouseIsOver = !0, this._reveal();
  }
  _reveal() {
    this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
  }
  _hide() {
    !this._mouseIsOver && !this._isDragging && (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
  }
  _scheduleHide() {
    !this._mouseIsOver && !this._isDragging && this._hideTimeout.cancelAndSet(() => this._hide(), H3t);
  }
}
class P3t extends SO {
  constructor(e, t) {
    t = t || {}, t.mouseWheelSmoothScroll = !1;
    const n = new nm({
      forceIntegerValues: !0,
      smoothScrollDuration: 0,
      scheduleAtNextAnimationFrame: (i) => co(qe(e), i)
    });
    super(e, t, n), this._register(n);
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
}
class fy extends SO {
  constructor(e, t, n) {
    super(e, t, n);
  }
  setScrollPosition(e) {
    e.reuseAnimation ? this._scrollable.setScrollPositionSmooth(e, e.reuseAnimation) : this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
}
class MO extends SO {
  constructor(e, t) {
    t = t || {}, t.mouseWheelSmoothScroll = !1;
    const n = new nm({
      forceIntegerValues: !1,
      // See https://github.com/microsoft/vscode/issues/139877
      smoothScrollDuration: 0,
      scheduleAtNextAnimationFrame: (i) => co(qe(e), i)
    });
    super(e, t, n), this._register(n), this._element = e, this._register(this.onScroll((i) => {
      i.scrollTopChanged && (this._element.scrollTop = i.scrollTop), i.scrollLeftChanged && (this._element.scrollLeft = i.scrollLeft);
    })), this.scanDomNode();
  }
  setScrollPosition(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  getScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  scanDomNode() {
    this.setScrollDimensions({
      width: this._element.clientWidth,
      scrollWidth: this._element.scrollWidth,
      height: this._element.clientHeight,
      scrollHeight: this._element.scrollHeight
    }), this.setScrollPosition({
      scrollLeft: this._element.scrollLeft,
      scrollTop: this._element.scrollTop
    });
  }
}
function F3t(r) {
  const e = {
    lazyRender: typeof r.lazyRender < "u" ? r.lazyRender : !1,
    className: typeof r.className < "u" ? r.className : "",
    useShadows: typeof r.useShadows < "u" ? r.useShadows : !0,
    handleMouseWheel: typeof r.handleMouseWheel < "u" ? r.handleMouseWheel : !0,
    flipAxes: typeof r.flipAxes < "u" ? r.flipAxes : !1,
    consumeMouseWheelIfScrollbarIsNeeded: typeof r.consumeMouseWheelIfScrollbarIsNeeded < "u" ? r.consumeMouseWheelIfScrollbarIsNeeded : !1,
    alwaysConsumeMouseWheel: typeof r.alwaysConsumeMouseWheel < "u" ? r.alwaysConsumeMouseWheel : !1,
    scrollYToX: typeof r.scrollYToX < "u" ? r.scrollYToX : !1,
    mouseWheelScrollSensitivity: typeof r.mouseWheelScrollSensitivity < "u" ? r.mouseWheelScrollSensitivity : 1,
    fastScrollSensitivity: typeof r.fastScrollSensitivity < "u" ? r.fastScrollSensitivity : 5,
    scrollPredominantAxis: typeof r.scrollPredominantAxis < "u" ? r.scrollPredominantAxis : !0,
    mouseWheelSmoothScroll: typeof r.mouseWheelSmoothScroll < "u" ? r.mouseWheelSmoothScroll : !0,
    arrowSize: typeof r.arrowSize < "u" ? r.arrowSize : 11,
    listenOnDomNode: typeof r.listenOnDomNode < "u" ? r.listenOnDomNode : null,
    horizontal: typeof r.horizontal < "u" ? r.horizontal : 1,
    horizontalScrollbarSize: typeof r.horizontalScrollbarSize < "u" ? r.horizontalScrollbarSize : 10,
    horizontalSliderSize: typeof r.horizontalSliderSize < "u" ? r.horizontalSliderSize : 0,
    horizontalHasArrows: typeof r.horizontalHasArrows < "u" ? r.horizontalHasArrows : !1,
    vertical: typeof r.vertical < "u" ? r.vertical : 1,
    verticalScrollbarSize: typeof r.verticalScrollbarSize < "u" ? r.verticalScrollbarSize : 10,
    verticalHasArrows: typeof r.verticalHasArrows < "u" ? r.verticalHasArrows : !1,
    verticalSliderSize: typeof r.verticalSliderSize < "u" ? r.verticalSliderSize : 0,
    scrollByPage: typeof r.scrollByPage < "u" ? r.scrollByPage : !1
  };
  return e.horizontalSliderSize = typeof r.horizontalSliderSize < "u" ? r.horizontalSliderSize : e.horizontalScrollbarSize, e.verticalSliderSize = typeof r.verticalSliderSize < "u" ? r.verticalSliderSize : e.verticalScrollbarSize, zt && (e.className += " mac"), e;
}
class DO extends Dw {
  constructor(e, t, n) {
    super(), this._mouseLeaveMonitor = null, this._mouseOnOverflowWidgetsDomNode = !1, this._mouseOnViewDomNode = !1, this._context = e, this.viewController = t, this.viewHelper = n, this.mouseTargetFactory = new Or(this._context, n), this._mouseDownOperation = this._register(new z3t(this._context, this.viewController, this.viewHelper, this.mouseTargetFactory, (a, l) => this._createMouseTargetForView(a, l), (a) => this._getMouseColumn(a))), this.lastMouseLeaveTime = -1, this._height = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    ).height;
    const i = new d3t(this.viewHelper.viewDomNode);
    this._register(i.onContextMenu(this.viewHelper.viewDomNode, (a) => this._onContextMenu(a, !0))), this._register(i.onMouseMove(this.viewHelper.viewDomNode, (a) => {
      this._mouseOnViewDomNode = !0, this._onMouseMoveOverView(a), this._mouseLeaveMonitor || (this._mouseLeaveMonitor = fe(this.viewHelper.viewDomNode.ownerDocument, "mousemove", (l) => {
        this.viewHelper.viewDomNode.contains(l.target) || (this._mouseOnViewDomNode = !1, setTimeout(() => {
          this._mouseOnOverflowWidgetsDomNode || this._onMouseLeave(new u1(l, !1, this.viewHelper.viewDomNode));
        }, 0));
      }));
    })), this._register(i.onMouseUp(this.viewHelper.viewDomNode, (a) => this._onMouseUp(a))), this._register(i.onMouseLeave(this.viewHelper.viewDomNode, (a) => {
      this._mouseOnViewDomNode = !1, setTimeout(() => {
        this._mouseOnOverflowWidgetsDomNode || this._onMouseLeave(a);
      }, 0);
    }));
    const s = this.viewHelper.overflowWidgetsDomNode;
    s && (this._register(i.onMouseMove(s, (a) => {
      this._mouseOnOverflowWidgetsDomNode = !0, this._mouseLeaveMonitor?.dispose(), this._mouseLeaveMonitor = null, this._onMouseMoveOverOverflowWidgetsDomNode(a);
    })), this._register(i.onMouseLeave(s, (a) => {
      this._mouseOnOverflowWidgetsDomNode = !1, setTimeout(() => {
        this._mouseOnViewDomNode || this._onMouseLeave(a);
      }, 0);
    })));
    let o = 0;
    this._register(i.onPointerDown(this.viewHelper.viewDomNode, (a, l) => {
      o = l;
    })), this._register(fe(this.viewHelper.viewDomNode, Se.POINTER_UP, (a) => {
      this._mouseDownOperation.onPointerUp();
    })), this._register(i.onMouseDown(this.viewHelper.viewDomNode, (a) => this._onMouseDown(a, o))), this._setupMouseWheelZoomListener(), this._context.addEventHandler(this);
  }
  _setupMouseWheelZoomListener() {
    const e = uy.INSTANCE;
    let t = 0, n = bu.getZoomLevel(), i = !1, s = 0;
    const o = (l) => {
      if (this.viewController.emitMouseWheel(l), !this._context.configuration.options.get(
        76
        /* EditorOption.mouseWheelZoom */
      ))
        return;
      const c = new mf(l);
      if (e.acceptStandardWheelEvent(c), e.isPhysicalMouseWheel()) {
        if (a(l)) {
          const d = bu.getZoomLevel(), u = c.deltaY > 0 ? 1 : -1;
          bu.setZoomLevel(d + u), c.preventDefault(), c.stopPropagation();
        }
      } else
        Date.now() - t > 50 && (n = bu.getZoomLevel(), i = a(l), s = 0), t = Date.now(), s += c.deltaY, i && (bu.setZoomLevel(n + s / 5), c.preventDefault(), c.stopPropagation());
    };
    this._register(fe(this.viewHelper.viewDomNode, Se.MOUSE_WHEEL, o, { capture: !0, passive: !1 }));
    function a(l) {
      return zt ? (l.metaKey || l.ctrlKey) && !l.shiftKey && !l.altKey : l.ctrlKey && !l.metaKey && !l.shiftKey && !l.altKey;
    }
  }
  dispose() {
    this._context.removeEventHandler(this), this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    if (e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    )) {
      const t = this._context.configuration.options.get(
        146
        /* EditorOption.layoutInfo */
      ).height;
      this._height !== t && (this._height = t, this._mouseDownOperation.onHeightChanged());
    }
    return !1;
  }
  onCursorStateChanged(e) {
    return this._mouseDownOperation.onCursorStateChanged(e), !1;
  }
  onFocusChanged(e) {
    return !1;
  }
  // --- end event handlers
  getTargetAtClientPoint(e, t) {
    const i = new ULe(e, t).toPageCoordinates(qe(this.viewHelper.viewDomNode)), s = _O(this.viewHelper.viewDomNode);
    if (i.y < s.y || i.y > s.y + s.height || i.x < s.x || i.x > s.x + s.width)
      return null;
    const o = xO(this.viewHelper.viewDomNode, s, i);
    return this.mouseTargetFactory.createMouseTargetForView(this.viewHelper.getLastRenderData(), s, i, o, null);
  }
  _createMouseTargetForView(e, t) {
    let n = e.target;
    if (!this.viewHelper.viewDomNode.contains(n)) {
      const i = sg(this.viewHelper.viewDomNode);
      i && (n = i.elementsFromPoint(e.posx, e.posy).find((s) => this.viewHelper.viewDomNode.contains(s)));
    }
    return this.mouseTargetFactory.createMouseTargetForView(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, t ? n : null);
  }
  _createMouseTargetForOverflowWidgetsDomNode(e) {
    return this.mouseTargetFactory.createMouseTargetForOverflowWidgetsDomNode(this.viewHelper.getLastRenderData(), e.editorPos, e.pos, e.relativePos, e.target);
  }
  _getMouseColumn(e) {
    return this.mouseTargetFactory.getMouseColumn(e.relativePos);
  }
  _onContextMenu(e, t) {
    this.viewController.emitContextMenu({
      event: e,
      target: this._createMouseTargetForView(e, t)
    });
  }
  _onMouseMoveOverView(e) {
    this._onMouseMove(e, this._createMouseTargetForView(e, !0));
  }
  _onMouseMoveOverOverflowWidgetsDomNode(e) {
    this._onMouseMove(e, this._createMouseTargetForOverflowWidgetsDomNode(e));
  }
  _onMouseMove(e, t) {
    this._shouldIgnoreMouseMoveEvent(e) || this.viewController.emitMouseMove({
      event: e,
      target: t
    });
  }
  _shouldIgnoreMouseMoveEvent(e) {
    return this.mouseTargetFactory.mouseTargetIsWidget(e) || e.preventDefault(), !!(this._mouseDownOperation.isActive() || e.timestamp < this.lastMouseLeaveTime);
  }
  _onMouseLeave(e) {
    this._mouseLeaveMonitor && (this._mouseLeaveMonitor.dispose(), this._mouseLeaveMonitor = null), this.lastMouseLeaveTime = (/* @__PURE__ */ new Date()).getTime(), this.viewController.emitMouseLeave({
      event: e,
      target: null
    });
  }
  _onMouseUp(e) {
    this.viewController.emitMouseUp({
      event: e,
      target: this._createMouseTargetForView(e, !0)
    });
  }
  _onMouseDown(e, t) {
    const n = this._createMouseTargetForView(e, !0), i = n.type === 6 || n.type === 7, s = n.type === 2 || n.type === 3 || n.type === 4, o = n.type === 3, a = this._context.configuration.options.get(
      110
      /* EditorOption.selectOnLineNumbers */
    ), l = n.type === 8 || n.type === 5, c = n.type === 9;
    let d = e.leftButton || e.middleButton;
    zt && e.leftButton && e.ctrlKey && (d = !1);
    const u = () => {
      e.preventDefault(), this.viewHelper.focusTextArea();
    };
    if (d && (i || o && a))
      u(), this._mouseDownOperation.start(n.type, e, t);
    else if (s)
      e.preventDefault();
    else if (l) {
      const f = n.detail;
      d && this.viewHelper.shouldSuppressMouseDownOnViewZone(f.viewZoneId) && (u(), this._mouseDownOperation.start(n.type, e, t), e.preventDefault());
    } else c && this.viewHelper.shouldSuppressMouseDownOnWidget(n.detail) && (u(), e.preventDefault());
    this.viewController.emitMouseDown({
      event: e,
      target: n
    });
  }
}
class z3t extends me {
  constructor(e, t, n, i, s, o) {
    super(), this._context = e, this._viewController = t, this._viewHelper = n, this._mouseTargetFactory = i, this._createMouseTarget = s, this._getMouseColumn = o, this._mouseMoveMonitor = this._register(new f3t(this._viewHelper.viewDomNode)), this._topBottomDragScrolling = this._register(new W3t(this._context, this._viewHelper, this._mouseTargetFactory, (a, l, c) => this._dispatchMouse(a, l, c))), this._mouseState = new LO(), this._currentSelection = new _n(1, 1, 1, 1), this._isActive = !1, this._lastMouseEvent = null;
  }
  dispose() {
    super.dispose();
  }
  isActive() {
    return this._isActive;
  }
  _onMouseDownThenMove(e) {
    this._lastMouseEvent = e, this._mouseState.setModifiers(e);
    const t = this._findMousePosition(e, !1);
    t && (this._mouseState.isDragAndDrop ? this._viewController.emitMouseDrag({
      event: e,
      target: t
    }) : t.type === 13 && (t.outsidePosition === "above" || t.outsidePosition === "below") ? this._topBottomDragScrolling.start(t, e) : (this._topBottomDragScrolling.stop(), this._dispatchMouse(
      t,
      !0,
      1
      /* NavigationCommandRevealType.Minimal */
    )));
  }
  start(e, t, n) {
    this._lastMouseEvent = t, this._mouseState.setStartedOnLineNumbers(
      e === 3
      /* MouseTargetType.GUTTER_LINE_NUMBERS */
    ), this._mouseState.setStartButtons(t), this._mouseState.setModifiers(t);
    const i = this._findMousePosition(t, !0);
    if (!i || !i.position)
      return;
    this._mouseState.trySetCount(t.detail, i.position), t.detail = this._mouseState.count;
    const s = this._context.configuration.options;
    if (!s.get(
      92
      /* EditorOption.readOnly */
    ) && s.get(
      35
      /* EditorOption.dragAndDrop */
    ) && !s.get(
      22
      /* EditorOption.columnSelection */
    ) && !this._mouseState.altKey && t.detail < 2 && !this._isActive && !this._currentSelection.isEmpty() && i.type === 6 && i.position && this._currentSelection.containsPosition(i.position)) {
      this._mouseState.isDragAndDrop = !0, this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (o) => this._onMouseDownThenMove(o), (o) => {
        const a = this._findMousePosition(this._lastMouseEvent, !1);
        Xh(o) ? this._viewController.emitMouseDropCanceled() : this._viewController.emitMouseDrop({
          event: this._lastMouseEvent,
          target: a ? this._createMouseTarget(this._lastMouseEvent, !0) : null
          // Ignoring because position is unknown, e.g., Content View Zone
        }), this._stop();
      });
      return;
    }
    this._mouseState.isDragAndDrop = !1, this._dispatchMouse(
      i,
      t.shiftKey,
      1
      /* NavigationCommandRevealType.Minimal */
    ), this._isActive || (this._isActive = !0, this._mouseMoveMonitor.startMonitoring(this._viewHelper.viewLinesDomNode, n, t.buttons, (o) => this._onMouseDownThenMove(o), () => this._stop()));
  }
  _stop() {
    this._isActive = !1, this._topBottomDragScrolling.stop();
  }
  onHeightChanged() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onPointerUp() {
    this._mouseMoveMonitor.stopMonitoring();
  }
  onCursorStateChanged(e) {
    this._currentSelection = e.selections[0];
  }
  _getPositionOutsideEditor(e) {
    const t = e.editorPos, n = this._context.viewModel, i = this._context.viewLayout, s = this._getMouseColumn(e);
    if (e.posy < t.y) {
      const a = t.y - e.posy, l = Math.max(i.getCurrentScrollTop() - a, 0), c = Cf.getZoneAtCoord(this._context, l);
      if (c) {
        const u = this._helpPositionJumpOverViewZone(c);
        if (u)
          return Jr.createOutsideEditor(s, u, "above", a);
      }
      const d = i.getLineNumberAtVerticalOffset(l);
      return Jr.createOutsideEditor(s, new le(d, 1), "above", a);
    }
    if (e.posy > t.y + t.height) {
      const a = e.posy - t.y - t.height, l = i.getCurrentScrollTop() + e.relativePos.y, c = Cf.getZoneAtCoord(this._context, l);
      if (c) {
        const u = this._helpPositionJumpOverViewZone(c);
        if (u)
          return Jr.createOutsideEditor(s, u, "below", a);
      }
      const d = i.getLineNumberAtVerticalOffset(l);
      return Jr.createOutsideEditor(s, new le(d, n.getLineMaxColumn(d)), "below", a);
    }
    const o = i.getLineNumberAtVerticalOffset(i.getCurrentScrollTop() + e.relativePos.y);
    if (e.posx < t.x) {
      const a = t.x - e.posx;
      return Jr.createOutsideEditor(s, new le(o, 1), "left", a);
    }
    if (e.posx > t.x + t.width) {
      const a = e.posx - t.x - t.width;
      return Jr.createOutsideEditor(s, new le(o, n.getLineMaxColumn(o)), "right", a);
    }
    return null;
  }
  _findMousePosition(e, t) {
    const n = this._getPositionOutsideEditor(e);
    if (n)
      return n;
    const i = this._createMouseTarget(e, t);
    if (!i.position)
      return null;
    if (i.type === 8 || i.type === 5) {
      const o = this._helpPositionJumpOverViewZone(i.detail);
      if (o)
        return Jr.createViewZone(i.type, i.element, i.mouseColumn, o, i.detail);
    }
    return i;
  }
  _helpPositionJumpOverViewZone(e) {
    const t = new le(this._currentSelection.selectionStartLineNumber, this._currentSelection.selectionStartColumn), n = e.positionBefore, i = e.positionAfter;
    return n && i ? n.isBefore(t) ? n : i : null;
  }
  _dispatchMouse(e, t, n) {
    e.position && this._viewController.dispatchMouse({
      position: e.position,
      mouseColumn: e.mouseColumn,
      startedOnLineNumbers: this._mouseState.startedOnLineNumbers,
      revealType: n,
      inSelectionMode: t,
      mouseDownCount: this._mouseState.count,
      altKey: this._mouseState.altKey,
      ctrlKey: this._mouseState.ctrlKey,
      metaKey: this._mouseState.metaKey,
      shiftKey: this._mouseState.shiftKey,
      leftButton: this._mouseState.leftButton,
      middleButton: this._mouseState.middleButton,
      onInjectedText: e.type === 6 && e.detail.injectedText !== null
    });
  }
}
class W3t extends me {
  constructor(e, t, n, i) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = i, this._operation = null;
  }
  dispose() {
    super.dispose(), this.stop();
  }
  start(e, t) {
    this._operation ? this._operation.setPosition(e, t) : this._operation = new j3t(this._context, this._viewHelper, this._mouseTargetFactory, this._dispatchMouse, e, t);
  }
  stop() {
    this._operation && (this._operation.dispose(), this._operation = null);
  }
}
class j3t extends me {
  constructor(e, t, n, i, s, o) {
    super(), this._context = e, this._viewHelper = t, this._mouseTargetFactory = n, this._dispatchMouse = i, this._position = s, this._mouseEvent = o, this._lastTime = Date.now(), this._animationFrameDisposable = co(qe(o.browserEvent), () => this._execute());
  }
  dispose() {
    this._animationFrameDisposable.dispose(), super.dispose();
  }
  setPosition(e, t) {
    this._position = e, this._mouseEvent = t;
  }
  /**
   * update internal state and return elapsed ms since last time
   */
  _tick() {
    const e = Date.now(), t = e - this._lastTime;
    return this._lastTime = e, t;
  }
  /**
   * get the number of lines per second to auto-scroll
   */
  _getScrollSpeed() {
    const e = this._context.configuration.options.get(
      67
      /* EditorOption.lineHeight */
    ), t = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    ).height / e, n = this._position.outsideDistance / e;
    return n <= 1.5 ? Math.max(30, t * (1 + n)) : n <= 3 ? Math.max(60, t * (2 + n)) : Math.max(200, t * (7 + n));
  }
  _execute() {
    const e = this._context.configuration.options.get(
      67
      /* EditorOption.lineHeight */
    ), t = this._getScrollSpeed(), n = this._tick(), i = t * (n / 1e3) * e, s = this._position.outsidePosition === "above" ? -i : i;
    this._context.viewModel.viewLayout.deltaScrollNow(0, s), this._viewHelper.renderNow();
    const o = this._context.viewLayout.getLinesViewportData(), a = this._position.outsidePosition === "above" ? o.startLineNumber : o.endLineNumber;
    let l;
    {
      const c = _O(this._viewHelper.viewDomNode), d = this._context.configuration.options.get(
        146
        /* EditorOption.layoutInfo */
      ).horizontalScrollbarHeight, u = new cy(this._mouseEvent.pos.x, c.y + c.height - d - 0.1), f = xO(this._viewHelper.viewDomNode, c, u);
      l = this._mouseTargetFactory.createMouseTargetForView(this._viewHelper.getLastRenderData(), c, u, f, null);
    }
    (!l.position || l.position.lineNumber !== a) && (this._position.outsidePosition === "above" ? l = Jr.createOutsideEditor(this._position.mouseColumn, new le(a, 1), "above", this._position.outsideDistance) : l = Jr.createOutsideEditor(this._position.mouseColumn, new le(a, this._context.viewModel.getLineMaxColumn(a)), "below", this._position.outsideDistance)), this._dispatchMouse(
      l,
      !0,
      2
      /* NavigationCommandRevealType.None */
    ), this._animationFrameDisposable = co(qe(l.element), () => this._execute());
  }
}
class LO {
  static {
    this.CLEAR_MOUSE_DOWN_COUNT_TIME = 400;
  }
  // ms
  get altKey() {
    return this._altKey;
  }
  get ctrlKey() {
    return this._ctrlKey;
  }
  get metaKey() {
    return this._metaKey;
  }
  get shiftKey() {
    return this._shiftKey;
  }
  get leftButton() {
    return this._leftButton;
  }
  get middleButton() {
    return this._middleButton;
  }
  get startedOnLineNumbers() {
    return this._startedOnLineNumbers;
  }
  constructor() {
    this._altKey = !1, this._ctrlKey = !1, this._metaKey = !1, this._shiftKey = !1, this._leftButton = !1, this._middleButton = !1, this._startedOnLineNumbers = !1, this._lastMouseDownPosition = null, this._lastMouseDownPositionEqualCount = 0, this._lastMouseDownCount = 0, this._lastSetMouseDownCountTime = 0, this.isDragAndDrop = !1;
  }
  get count() {
    return this._lastMouseDownCount;
  }
  setModifiers(e) {
    this._altKey = e.altKey, this._ctrlKey = e.ctrlKey, this._metaKey = e.metaKey, this._shiftKey = e.shiftKey;
  }
  setStartButtons(e) {
    this._leftButton = e.leftButton, this._middleButton = e.middleButton;
  }
  setStartedOnLineNumbers(e) {
    this._startedOnLineNumbers = e;
  }
  trySetCount(e, t) {
    const n = (/* @__PURE__ */ new Date()).getTime();
    n - this._lastSetMouseDownCountTime > LO.CLEAR_MOUSE_DOWN_COUNT_TIME && (e = 1), this._lastSetMouseDownCountTime = n, e > this._lastMouseDownCount + 1 && (e = this._lastMouseDownCount + 1), this._lastMouseDownPosition && this._lastMouseDownPosition.equals(t) ? this._lastMouseDownPositionEqualCount++ : this._lastMouseDownPositionEqualCount = 1, this._lastMouseDownPosition = t, this._lastMouseDownCount = Math.min(e, this._lastMouseDownPositionEqualCount);
  }
}
class St {
  get event() {
    return this.emitter.event;
  }
  constructor(e, t, n) {
    const i = (s) => this.emitter.fire(s);
    this.emitter = new $({
      onWillAddFirstListener: () => e.addEventListener(t, i, n),
      onDidRemoveLastListener: () => e.removeEventListener(t, i, n)
    });
  }
  dispose() {
    this.emitter.dispose();
  }
}
class Mr {
  static {
    this.EMPTY = new Mr("", 0, 0, null, void 0);
  }
  constructor(e, t, n, i, s) {
    this.value = e, this.selectionStart = t, this.selectionEnd = n, this.selection = i, this.newlineCountBeforeSelection = s;
  }
  toString() {
    return `[ <${this.value}>, selectionStart: ${this.selectionStart}, selectionEnd: ${this.selectionEnd}]`;
  }
  static readFromTextArea(e, t) {
    const n = e.getValue(), i = e.getSelectionStart(), s = e.getSelectionEnd();
    let o;
    if (t) {
      const a = n.substring(0, i), l = t.value.substring(0, t.selectionStart);
      a === l && (o = t.newlineCountBeforeSelection);
    }
    return new Mr(n, i, s, null, o);
  }
  collapseSelection() {
    return this.selectionStart === this.value.length ? this : new Mr(this.value, this.value.length, this.value.length, null, void 0);
  }
  writeToTextArea(e, t, n) {
    t.setValue(e, this.value), n && t.setSelectionRange(e, this.selectionStart, this.selectionEnd);
  }
  deduceEditorPosition(e) {
    if (e <= this.selectionStart) {
      const i = this.value.substring(e, this.selectionStart);
      return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, i, -1);
    }
    if (e >= this.selectionEnd) {
      const i = this.value.substring(this.selectionEnd, e);
      return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, i, 1);
    }
    const t = this.value.substring(this.selectionStart, e);
    if (t.indexOf("…") === -1)
      return this._finishDeduceEditorPosition(this.selection?.getStartPosition() ?? null, t, 1);
    const n = this.value.substring(e, this.selectionEnd);
    return this._finishDeduceEditorPosition(this.selection?.getEndPosition() ?? null, n, -1);
  }
  _finishDeduceEditorPosition(e, t, n) {
    let i = 0, s = -1;
    for (; (s = t.indexOf(`
`, s + 1)) !== -1; )
      i++;
    return [e, n * t.length, i];
  }
  static deduceInput(e, t, n) {
    if (!e)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    const i = Math.min(kD(e.value, t.value), e.selectionStart, t.selectionStart), s = Math.min(ND(e.value, t.value), e.value.length - e.selectionEnd, t.value.length - t.selectionEnd);
    e.value.substring(i, e.value.length - s);
    const o = t.value.substring(i, t.value.length - s), a = e.selectionStart - i, l = e.selectionEnd - i, c = t.selectionStart - i, d = t.selectionEnd - i;
    if (c === d) {
      const f = e.selectionStart - i;
      return {
        text: o,
        replacePrevCharCnt: f,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    }
    const u = l - a;
    return {
      text: o,
      replacePrevCharCnt: u,
      replaceNextCharCnt: 0,
      positionDelta: 0
    };
  }
  static deduceAndroidCompositionInput(e, t) {
    if (!e)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: 0
      };
    if (e.value === t.value)
      return {
        text: "",
        replacePrevCharCnt: 0,
        replaceNextCharCnt: 0,
        positionDelta: t.selectionEnd - e.selectionEnd
      };
    const n = Math.min(kD(e.value, t.value), e.selectionEnd), i = Math.min(ND(e.value, t.value), e.value.length - e.selectionEnd), s = e.value.substring(n, e.value.length - i), o = t.value.substring(n, t.value.length - i);
    e.selectionStart - n;
    const a = e.selectionEnd - n;
    t.selectionStart - n;
    const l = t.selectionEnd - n;
    return {
      text: o,
      replacePrevCharCnt: a,
      replaceNextCharCnt: s.length - a,
      positionDelta: l - o.length
    };
  }
}
class tp {
  static _getPageOfLine(e, t) {
    return Math.floor((e - 1) / t);
  }
  static _getRangeForPage(e, t) {
    const n = e * t, i = n + 1, s = n + t;
    return new Q(i, 1, s + 1, 1);
  }
  static fromEditorSelection(e, t, n, i) {
    const o = tp._getPageOfLine(t.startLineNumber, n), a = tp._getRangeForPage(o, n), l = tp._getPageOfLine(t.endLineNumber, n), c = tp._getRangeForPage(l, n);
    let d = a.intersectRanges(new Q(1, 1, t.startLineNumber, t.startColumn));
    if (i && e.getValueLengthInRange(
      d,
      1
      /* EndOfLinePreference.LF */
    ) > 500) {
      const w = e.modifyPosition(d.getEndPosition(), -500);
      d = Q.fromPositions(w, d.getEndPosition());
    }
    const u = e.getValueInRange(
      d,
      1
      /* EndOfLinePreference.LF */
    ), f = e.getLineCount(), p = e.getLineMaxColumn(f);
    let g = c.intersectRanges(new Q(t.endLineNumber, t.endColumn, f, p));
    if (i && e.getValueLengthInRange(
      g,
      1
      /* EndOfLinePreference.LF */
    ) > 500) {
      const w = e.modifyPosition(g.getStartPosition(), 500);
      g = Q.fromPositions(g.getStartPosition(), w);
    }
    const m = e.getValueInRange(
      g,
      1
      /* EndOfLinePreference.LF */
    );
    let A;
    if (o === l || o + 1 === l)
      A = e.getValueInRange(
        t,
        1
        /* EndOfLinePreference.LF */
      );
    else {
      const w = a.intersectRanges(t), v = c.intersectRanges(t);
      A = e.getValueInRange(
        w,
        1
        /* EndOfLinePreference.LF */
      ) + "…" + e.getValueInRange(
        v,
        1
        /* EndOfLinePreference.LF */
      );
    }
    return i && A.length > 2 * 500 && (A = A.substring(0, 500) + "…" + A.substring(A.length - 500, A.length)), new Mr(u + A + m, u.length, u.length + A.length, t, d.endLineNumber - d.startLineNumber);
  }
}
var Z3t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, m6e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, o9;
(function(r) {
  r.Tap = "-monaco-textarea-synthetic-tap";
})(o9 || (o9 = {}));
class a9 {
  static {
    this.INSTANCE = new a9();
  }
  constructor() {
    this._lastState = null;
  }
  set(e, t) {
    this._lastState = { lastCopiedValue: e, data: t };
  }
  get(e) {
    return this._lastState && this._lastState.lastCopiedValue === e ? this._lastState.data : (this._lastState = null, null);
  }
}
class U3t {
  constructor() {
    this._lastTypeTextLength = 0;
  }
  handleCompositionUpdate(e) {
    e = e || "";
    const t = {
      text: e,
      replacePrevCharCnt: this._lastTypeTextLength,
      replaceNextCharCnt: 0,
      positionDelta: 0
    };
    return this._lastTypeTextLength = e.length, t;
  }
}
let mL = class extends me {
  get textAreaState() {
    return this._textAreaState;
  }
  constructor(e, t, n, i, s, o) {
    super(), this._host = e, this._textArea = t, this._OS = n, this._browser = i, this._accessibilityService = s, this._logService = o, this._onFocus = this._register(new $()), this.onFocus = this._onFocus.event, this._onBlur = this._register(new $()), this.onBlur = this._onBlur.event, this._onKeyDown = this._register(new $()), this.onKeyDown = this._onKeyDown.event, this._onKeyUp = this._register(new $()), this.onKeyUp = this._onKeyUp.event, this._onCut = this._register(new $()), this.onCut = this._onCut.event, this._onPaste = this._register(new $()), this.onPaste = this._onPaste.event, this._onType = this._register(new $()), this.onType = this._onType.event, this._onCompositionStart = this._register(new $()), this.onCompositionStart = this._onCompositionStart.event, this._onCompositionUpdate = this._register(new $()), this.onCompositionUpdate = this._onCompositionUpdate.event, this._onCompositionEnd = this._register(new $()), this.onCompositionEnd = this._onCompositionEnd.event, this._onSelectionChangeRequest = this._register(new $()), this.onSelectionChangeRequest = this._onSelectionChangeRequest.event, this._asyncFocusGainWriteScreenReaderContent = this._register(new Bd()), this._asyncTriggerCut = this._register(new Nr(() => this._onCut.fire(), 0)), this._textAreaState = Mr.EMPTY, this._selectionChangeListener = null, this._accessibilityService.isScreenReaderOptimized() && this.writeNativeTextAreaContent("ctor"), this._register(xe.runAndSubscribe(this._accessibilityService.onDidChangeScreenReaderOptimized, () => {
      this._accessibilityService.isScreenReaderOptimized() && !this._asyncFocusGainWriteScreenReaderContent.value ? this._asyncFocusGainWriteScreenReaderContent.value = this._register(new Nr(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0)) : this._asyncFocusGainWriteScreenReaderContent.clear();
    })), this._hasFocus = !1, this._currentComposition = null;
    let a = null;
    this._register(this._textArea.onKeyDown((l) => {
      const c = new zn(l);
      (c.keyCode === 114 || this._currentComposition && c.keyCode === 1) && c.stopPropagation(), c.equals(
        9
        /* KeyCode.Escape */
      ) && c.preventDefault(), a = c, this._onKeyDown.fire(c);
    })), this._register(this._textArea.onKeyUp((l) => {
      const c = new zn(l);
      this._onKeyUp.fire(c);
    })), this._register(this._textArea.onCompositionStart((l) => {
      const c = new U3t();
      if (this._currentComposition) {
        this._currentComposition = c;
        return;
      }
      if (this._currentComposition = c, this._OS === 2 && a && a.equals(
        114
        /* KeyCode.KEY_IN_COMPOSITION */
      ) && this._textAreaState.selectionStart === this._textAreaState.selectionEnd && this._textAreaState.selectionStart > 0 && this._textAreaState.value.substr(this._textAreaState.selectionStart - 1, 1) === l.data && (a.code === "ArrowRight" || a.code === "ArrowLeft")) {
        c.handleCompositionUpdate("x"), this._onCompositionStart.fire({ data: l.data });
        return;
      }
      if (this._browser.isAndroid) {
        this._onCompositionStart.fire({ data: l.data });
        return;
      }
      this._onCompositionStart.fire({ data: l.data });
    })), this._register(this._textArea.onCompositionUpdate((l) => {
      const c = this._currentComposition;
      if (!c)
        return;
      if (this._browser.isAndroid) {
        const u = Mr.readFromTextArea(this._textArea, this._textAreaState), f = Mr.deduceAndroidCompositionInput(this._textAreaState, u);
        this._textAreaState = u, this._onType.fire(f), this._onCompositionUpdate.fire(l);
        return;
      }
      const d = c.handleCompositionUpdate(l.data);
      this._textAreaState = Mr.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionUpdate.fire(l);
    })), this._register(this._textArea.onCompositionEnd((l) => {
      const c = this._currentComposition;
      if (!c)
        return;
      if (this._currentComposition = null, this._browser.isAndroid) {
        const u = Mr.readFromTextArea(this._textArea, this._textAreaState), f = Mr.deduceAndroidCompositionInput(this._textAreaState, u);
        this._textAreaState = u, this._onType.fire(f), this._onCompositionEnd.fire();
        return;
      }
      const d = c.handleCompositionUpdate(l.data);
      this._textAreaState = Mr.readFromTextArea(this._textArea, this._textAreaState), this._onType.fire(d), this._onCompositionEnd.fire();
    })), this._register(this._textArea.onInput((l) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received input event"), this._currentComposition)
        return;
      const c = Mr.readFromTextArea(this._textArea, this._textAreaState), d = Mr.deduceInput(
        this._textAreaState,
        c,
        /*couldBeEmojiInput*/
        this._OS === 2
        /* OperatingSystem.Macintosh */
      );
      d.replacePrevCharCnt === 0 && d.text.length === 1 && (Ki(d.text.charCodeAt(0)) || d.text.charCodeAt(0) === 127) || (this._textAreaState = c, (d.text !== "" || d.replacePrevCharCnt !== 0 || d.replaceNextCharCnt !== 0 || d.positionDelta !== 0) && this._onType.fire(d));
    })), this._register(this._textArea.onCut((l) => {
      this._textArea.setIgnoreSelectionChangeTime("received cut event"), this._ensureClipboardGetsEditorSelection(l), this._asyncTriggerCut.schedule();
    })), this._register(this._textArea.onCopy((l) => {
      this._ensureClipboardGetsEditorSelection(l);
    })), this._register(this._textArea.onPaste((l) => {
      if (this._textArea.setIgnoreSelectionChangeTime("received paste event"), l.preventDefault(), !l.clipboardData)
        return;
      let [c, d] = A6e.getTextData(l.clipboardData);
      c && (d = d || a9.INSTANCE.get(c), this._onPaste.fire({
        text: c,
        metadata: d
      }));
    })), this._register(this._textArea.onFocus(() => {
      const l = this._hasFocus;
      this._setHasFocus(!0), this._accessibilityService.isScreenReaderOptimized() && this._browser.isSafari && !l && this._hasFocus && (this._asyncFocusGainWriteScreenReaderContent.value || (this._asyncFocusGainWriteScreenReaderContent.value = new Nr(() => this.writeNativeTextAreaContent("asyncFocusGain"), 0)), this._asyncFocusGainWriteScreenReaderContent.value.schedule());
    })), this._register(this._textArea.onBlur(() => {
      this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("blurWithoutCompositionEnd"), this._onCompositionEnd.fire()), this._setHasFocus(!1);
    })), this._register(this._textArea.onSyntheticTap(() => {
      this._browser.isAndroid && this._currentComposition && (this._currentComposition = null, this.writeNativeTextAreaContent("tapWithoutCompositionEnd"), this._onCompositionEnd.fire());
    }));
  }
  _installSelectionChangeListener() {
    let e = 0;
    return fe(this._textArea.ownerDocument, "selectionchange", (t) => {
      if (Ou.onSelectionChange(), !this._hasFocus || this._currentComposition || !this._browser.isChrome)
        return;
      const n = Date.now(), i = n - e;
      if (e = n, i < 5)
        return;
      const s = n - this._textArea.getIgnoreSelectionChangeTime();
      if (this._textArea.resetSelectionChangeTime(), s < 100 || !this._textAreaState.selection)
        return;
      const o = this._textArea.getValue();
      if (this._textAreaState.value !== o)
        return;
      const a = this._textArea.getSelectionStart(), l = this._textArea.getSelectionEnd();
      if (this._textAreaState.selectionStart === a && this._textAreaState.selectionEnd === l)
        return;
      const c = this._textAreaState.deduceEditorPosition(a), d = this._host.deduceModelPosition(c[0], c[1], c[2]), u = this._textAreaState.deduceEditorPosition(l), f = this._host.deduceModelPosition(u[0], u[1], u[2]), p = new _n(d.lineNumber, d.column, f.lineNumber, f.column);
      this._onSelectionChangeRequest.fire(p);
    });
  }
  dispose() {
    super.dispose(), this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null);
  }
  focusTextArea() {
    this._setHasFocus(!0), this.refreshFocusState();
  }
  isFocused() {
    return this._hasFocus;
  }
  refreshFocusState() {
    this._setHasFocus(this._textArea.hasFocus());
  }
  _setHasFocus(e) {
    this._hasFocus !== e && (this._hasFocus = e, this._selectionChangeListener && (this._selectionChangeListener.dispose(), this._selectionChangeListener = null), this._hasFocus && (this._selectionChangeListener = this._installSelectionChangeListener()), this._hasFocus && this.writeNativeTextAreaContent("focusgain"), this._hasFocus ? this._onFocus.fire() : this._onBlur.fire());
  }
  _setAndWriteTextAreaState(e, t) {
    this._hasFocus || (t = t.collapseSelection()), t.writeToTextArea(e, this._textArea, this._hasFocus), this._textAreaState = t;
  }
  writeNativeTextAreaContent(e) {
    !this._accessibilityService.isScreenReaderOptimized() && e === "render" || this._currentComposition || (this._logService.trace(`writeTextAreaState(reason: ${e})`), this._setAndWriteTextAreaState(e, this._host.getScreenReaderContent()));
  }
  _ensureClipboardGetsEditorSelection(e) {
    const t = this._host.getDataToCopy(), n = {
      version: 1,
      isFromEmptySelection: t.isFromEmptySelection,
      multicursorText: t.multicursorText,
      mode: t.mode
    };
    a9.INSTANCE.set(
      // When writing "LINE\r\n" to the clipboard and then pasting,
      // Firefox pastes "LINE\n", so let's work around this quirk
      this._browser.isFirefox ? t.text.replace(/\r\n/g, `
`) : t.text,
      n
    ), e.preventDefault(), e.clipboardData && A6e.setTextData(e.clipboardData, t.text, t.html, n);
  }
};
mL = Z3t([
  m6e(4, pc),
  m6e(5, _h)
], mL);
const A6e = {
  getTextData(r) {
    const e = r.getData(ad.text);
    let t = null;
    const n = r.getData("vscode-editor-data");
    if (typeof n == "string")
      try {
        t = JSON.parse(n), t.version !== 1 && (t = null);
      } catch {
      }
    return e.length === 0 && t === null && r.files.length > 0 ? [Array.prototype.slice.call(r.files, 0).map((s) => s.name).join(`
`), null] : [e, t];
  },
  setTextData(r, e, t, n) {
    r.setData(ad.text, e), typeof t == "string" && r.setData("text/html", t), r.setData("vscode-editor-data", JSON.stringify(n));
  }
};
class q3t extends me {
  get ownerDocument() {
    return this._actual.ownerDocument;
  }
  constructor(e) {
    super(), this._actual = e, this.onKeyDown = this._register(new St(this._actual, "keydown")).event, this.onKeyUp = this._register(new St(this._actual, "keyup")).event, this.onCompositionStart = this._register(new St(this._actual, "compositionstart")).event, this.onCompositionUpdate = this._register(new St(this._actual, "compositionupdate")).event, this.onCompositionEnd = this._register(new St(this._actual, "compositionend")).event, this.onBeforeInput = this._register(new St(this._actual, "beforeinput")).event, this.onInput = this._register(new St(this._actual, "input")).event, this.onCut = this._register(new St(this._actual, "cut")).event, this.onCopy = this._register(new St(this._actual, "copy")).event, this.onPaste = this._register(new St(this._actual, "paste")).event, this.onFocus = this._register(new St(this._actual, "focus")).event, this.onBlur = this._register(new St(this._actual, "blur")).event, this._onSyntheticTap = this._register(new $()), this.onSyntheticTap = this._onSyntheticTap.event, this._ignoreSelectionChangeTime = 0, this._register(this.onKeyDown(() => Ou.onKeyDown())), this._register(this.onBeforeInput(() => Ou.onBeforeInput())), this._register(this.onInput(() => Ou.onInput())), this._register(this.onKeyUp(() => Ou.onKeyUp())), this._register(fe(this._actual, o9.Tap, () => this._onSyntheticTap.fire()));
  }
  hasFocus() {
    const e = sg(this._actual);
    return e ? e.activeElement === this._actual : this._actual.isConnected ? ss() === this._actual : !1;
  }
  setIgnoreSelectionChangeTime(e) {
    this._ignoreSelectionChangeTime = Date.now();
  }
  getIgnoreSelectionChangeTime() {
    return this._ignoreSelectionChangeTime;
  }
  resetSelectionChangeTime() {
    this._ignoreSelectionChangeTime = 0;
  }
  getValue() {
    return this._actual.value;
  }
  setValue(e, t) {
    const n = this._actual;
    n.value !== t && (this.setIgnoreSelectionChangeTime("setValue"), n.value = t);
  }
  getSelectionStart() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionEnd : this._actual.selectionStart;
  }
  getSelectionEnd() {
    return this._actual.selectionDirection === "backward" ? this._actual.selectionStart : this._actual.selectionEnd;
  }
  setSelectionRange(e, t, n) {
    const i = this._actual;
    let s = null;
    const o = sg(i);
    o ? s = o.activeElement : s = ss();
    const a = qe(s), l = s === i, c = i.selectionStart, d = i.selectionEnd;
    if (l && c === t && d === n) {
      pl && a.parent !== a && i.focus();
      return;
    }
    if (l) {
      this.setIgnoreSelectionChangeTime("setSelectionRange"), i.setSelectionRange(t, n), pl && a.parent !== a && i.focus();
      return;
    }
    try {
      const u = Bft(i);
      this.setIgnoreSelectionChangeTime("setSelectionRange"), i.focus(), i.setSelectionRange(t, n), Pft(i, u);
    } catch {
    }
  }
}
class G3t extends DO {
  constructor(e, t, n) {
    super(e, t, n), this._register(Xn.addTarget(this.viewHelper.linesContentDomNode)), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Tap, (s) => this.onTap(s))), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Change, (s) => this.onChange(s))), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Contextmenu, (s) => this._onContextMenu(new u1(s, !1, this.viewHelper.viewDomNode), !1))), this._lastPointerType = "mouse", this._register(fe(this.viewHelper.linesContentDomNode, "pointerdown", (s) => {
      const o = s.pointerType;
      if (o === "mouse") {
        this._lastPointerType = "mouse";
        return;
      } else o === "touch" ? this._lastPointerType = "touch" : this._lastPointerType = "pen";
    }));
    const i = new u3t(this.viewHelper.viewDomNode);
    this._register(i.onPointerMove(this.viewHelper.viewDomNode, (s) => this._onMouseMoveOverView(s))), this._register(i.onPointerUp(this.viewHelper.viewDomNode, (s) => this._onMouseUp(s))), this._register(i.onPointerLeave(this.viewHelper.viewDomNode, (s) => this._onMouseLeave(s))), this._register(i.onPointerDown(this.viewHelper.viewDomNode, (s, o) => this._onMouseDown(s, o)));
  }
  onTap(e) {
    !e.initialTarget || !this.viewHelper.linesContentDomNode.contains(e.initialTarget) || (e.preventDefault(), this.viewHelper.focusTextArea(), this._dispatchGesture(
      e,
      /*inSelectionMode*/
      !1
    ));
  }
  onChange(e) {
    this._lastPointerType === "touch" && this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY), this._lastPointerType === "pen" && this._dispatchGesture(
      e,
      /*inSelectionMode*/
      !0
    );
  }
  _dispatchGesture(e, t) {
    const n = this._createMouseTargetForView(new u1(e, !1, this.viewHelper.viewDomNode), !1);
    n.position && this.viewController.dispatchMouse({
      position: n.position,
      mouseColumn: n.position.column,
      startedOnLineNumbers: !1,
      revealType: 1,
      mouseDownCount: e.tapCount,
      inSelectionMode: t,
      altKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      shiftKey: !1,
      leftButton: !1,
      middleButton: !1,
      onInjectedText: n.type === 6 && n.detail.injectedText !== null
    });
  }
  _onMouseDown(e, t) {
    e.browserEvent.pointerType !== "touch" && super._onMouseDown(e, t);
  }
}
class Q3t extends DO {
  constructor(e, t, n) {
    super(e, t, n), this._register(Xn.addTarget(this.viewHelper.linesContentDomNode)), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Tap, (i) => this.onTap(i))), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Change, (i) => this.onChange(i))), this._register(fe(this.viewHelper.linesContentDomNode, Nn.Contextmenu, (i) => this._onContextMenu(new u1(i, !1, this.viewHelper.viewDomNode), !1)));
  }
  onTap(e) {
    e.preventDefault(), this.viewHelper.focusTextArea();
    const t = this._createMouseTargetForView(new u1(e, !1, this.viewHelper.viewDomNode), !1);
    if (t.position) {
      const n = document.createEvent("CustomEvent");
      n.initEvent(o9.Tap, !1, !0), this.viewHelper.dispatchTextAreaEvent(n), this.viewController.moveTo(
        t.position,
        1
        /* NavigationCommandRevealType.Minimal */
      );
    }
  }
  onChange(e) {
    this._context.viewModel.viewLayout.deltaScrollNow(-e.translationX, -e.translationY);
  }
}
class K3t extends me {
  constructor(e, t, n) {
    super(), (pf || Rut && IMe) && cDe.pointerEvents ? this.handler = this._register(new G3t(e, t, n)) : Sn.TouchEvent ? this.handler = this._register(new Q3t(e, t, n)) : this.handler = this._register(new DO(e, t, n));
  }
  getTargetAtClientPoint(e, t) {
    return this.handler.getTargetAtClientPoint(e, t);
  }
}
class t2 extends Dw {
}
const Sa = Wt("themeService");
function Ua(r) {
  return { id: r };
}
function AL(r) {
  switch (r) {
    case ua.DARK:
      return "vs-dark";
    case ua.HIGH_CONTRAST_DARK:
      return "hc-black";
    case ua.HIGH_CONTRAST_LIGHT:
      return "hc-light";
    default:
      return "vs";
  }
}
const JLe = {
  ThemingContribution: "base.contributions.theming"
};
class Y3t {
  constructor() {
    this.themingParticipants = [], this.themingParticipants = [], this.onThemingParticipantAddedEmitter = new $();
  }
  onColorThemeChange(e) {
    return this.themingParticipants.push(e), this.onThemingParticipantAddedEmitter.fire(e), ht(() => {
      const t = this.themingParticipants.indexOf(e);
      this.themingParticipants.splice(t, 1);
    });
  }
  getThemingParticipants() {
    return this.themingParticipants;
  }
}
const $Le = new Y3t();
Er.add(JLe.ThemingContribution, $Le);
function Sh(r) {
  return $Le.onColorThemeChange(r);
}
class X3t extends me {
  constructor(e) {
    super(), this.themeService = e, this.theme = e.getColorTheme(), this._register(this.themeService.onDidColorThemeChange((t) => this.onThemeChange(t)));
  }
  onThemeChange(e) {
    this.theme = e, this.updateStyles();
  }
  updateStyles() {
  }
}
const eke = Z("editor.lineHighlightBackground", null, C("lineHighlight", "Background color for the highlight of line at the cursor position.")), w6e = Z("editor.lineHighlightBorder", { dark: "#282828", light: "#eeeeee", hcDark: "#f38518", hcLight: $t }, C("lineHighlightBorderBox", "Background color for the border around the line at the cursor position."));
Z("editor.rangeHighlightBackground", { dark: "#ffffff0b", light: "#fdff0033", hcDark: null, hcLight: null }, C("rangeHighlight", "Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editor.rangeHighlightBorder", { dark: null, light: null, hcDark: _i, hcLight: _i }, C("rangeHighlightBorder", "Background color of the border around highlighted ranges."));
Z("editor.symbolHighlightBackground", { dark: Ru, light: Ru, hcDark: null, hcLight: null }, C("symbolHighlight", "Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations."), !0);
Z("editor.symbolHighlightBorder", { dark: null, light: null, hcDark: _i, hcLight: _i }, C("symbolHighlightBorder", "Background color of the border around highlighted symbols."));
const py = Z("editorCursor.foreground", { dark: "#AEAFAD", light: ge.black, hcDark: ge.white, hcLight: "#0F4A85" }, C("caret", "Color of the editor cursor.")), kO = Z("editorCursor.background", null, C("editorCursorBackground", "The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.")), tke = Z("editorMultiCursor.primary.foreground", py, C("editorMultiCursorPrimaryForeground", "Color of the primary editor cursor when multiple cursors are present.")), J3t = Z("editorMultiCursor.primary.background", kO, C("editorMultiCursorPrimaryBackground", "The background color of the primary editor cursor when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), nke = Z("editorMultiCursor.secondary.foreground", py, C("editorMultiCursorSecondaryForeground", "Color of secondary editor cursors when multiple cursors are present.")), $3t = Z("editorMultiCursor.secondary.background", kO, C("editorMultiCursorSecondaryBackground", "The background color of secondary editor cursors when multiple cursors are present. Allows customizing the color of a character overlapped by a block cursor.")), NO = Z("editorWhitespace.foreground", { dark: "#e3e4e229", light: "#33333333", hcDark: "#e3e4e229", hcLight: "#CCCCCC" }, C("editorWhitespaces", "Color of whitespace characters in the editor.")), e4t = Z("editorLineNumber.foreground", { dark: "#858585", light: "#237893", hcDark: ge.white, hcLight: "#292929" }, C("editorLineNumbers", "Color of editor line numbers.")), t4t = Z("editorIndentGuide.background", NO, C("editorIndentGuides", "Color of the editor indentation guides."), !1, C("deprecatedEditorIndentGuides", "'editorIndentGuide.background' is deprecated. Use 'editorIndentGuide.background1' instead.")), n4t = Z("editorIndentGuide.activeBackground", NO, C("editorActiveIndentGuide", "Color of the active editor indentation guides."), !1, C("deprecatedEditorActiveIndentGuide", "'editorIndentGuide.activeBackground' is deprecated. Use 'editorIndentGuide.activeBackground1' instead.")), Lw = Z("editorIndentGuide.background1", t4t, C("editorIndentGuides1", "Color of the editor indentation guides (1).")), i4t = Z("editorIndentGuide.background2", "#00000000", C("editorIndentGuides2", "Color of the editor indentation guides (2).")), r4t = Z("editorIndentGuide.background3", "#00000000", C("editorIndentGuides3", "Color of the editor indentation guides (3).")), s4t = Z("editorIndentGuide.background4", "#00000000", C("editorIndentGuides4", "Color of the editor indentation guides (4).")), o4t = Z("editorIndentGuide.background5", "#00000000", C("editorIndentGuides5", "Color of the editor indentation guides (5).")), a4t = Z("editorIndentGuide.background6", "#00000000", C("editorIndentGuides6", "Color of the editor indentation guides (6).")), kw = Z("editorIndentGuide.activeBackground1", n4t, C("editorActiveIndentGuide1", "Color of the active editor indentation guides (1).")), l4t = Z("editorIndentGuide.activeBackground2", "#00000000", C("editorActiveIndentGuide2", "Color of the active editor indentation guides (2).")), c4t = Z("editorIndentGuide.activeBackground3", "#00000000", C("editorActiveIndentGuide3", "Color of the active editor indentation guides (3).")), h4t = Z("editorIndentGuide.activeBackground4", "#00000000", C("editorActiveIndentGuide4", "Color of the active editor indentation guides (4).")), d4t = Z("editorIndentGuide.activeBackground5", "#00000000", C("editorActiveIndentGuide5", "Color of the active editor indentation guides (5).")), u4t = Z("editorIndentGuide.activeBackground6", "#00000000", C("editorActiveIndentGuide6", "Color of the active editor indentation guides (6).")), f4t = Z("editorActiveLineNumber.foreground", { dark: "#c6c6c6", light: "#0B216F", hcDark: _i, hcLight: _i }, C("editorActiveLineNumber", "Color of editor active line number"), !1, C("deprecatedEditorActiveLineNumber", "Id is deprecated. Use 'editorLineNumber.activeForeground' instead."));
Z("editorLineNumber.activeForeground", f4t, C("editorActiveLineNumber", "Color of editor active line number"));
const p4t = Z("editorLineNumber.dimmedForeground", null, C("editorDimmedLineNumber", "Color of the final editor line when editor.renderFinalNewline is set to dimmed."));
Z("editorRuler.foreground", { dark: "#5A5A5A", light: ge.lightgrey, hcDark: ge.white, hcLight: "#292929" }, C("editorRuler", "Color of the editor rulers."));
Z("editorCodeLens.foreground", { dark: "#999999", light: "#919191", hcDark: "#999999", hcLight: "#292929" }, C("editorCodeLensForeground", "Foreground color of editor CodeLens"));
Z("editorBracketMatch.background", { dark: "#0064001a", light: "#0064001a", hcDark: "#0064001a", hcLight: "#0000" }, C("editorBracketMatchBackground", "Background color behind matching brackets"));
Z("editorBracketMatch.border", { dark: "#888", light: "#B9B9B9", hcDark: $t, hcLight: $t }, C("editorBracketMatchBorder", "Color for matching brackets boxes"));
const g4t = Z("editorOverviewRuler.border", { dark: "#7f7f7f4d", light: "#7f7f7f4d", hcDark: "#7f7f7f4d", hcLight: "#666666" }, C("editorOverviewRulerBorder", "Color of the overview ruler border.")), m4t = Z("editorOverviewRuler.background", null, C("editorOverviewRulerBackground", "Background color of the editor overview ruler."));
Z("editorGutter.background", dh, C("editorGutter", "Background color of the editor gutter. The gutter contains the glyph margins and the line numbers."));
Z("editorUnnecessaryCode.border", { dark: null, light: null, hcDark: ge.fromHex("#fff").transparent(0.8), hcLight: $t }, C("unnecessaryCodeBorder", "Border color of unnecessary (unused) source code in the editor."));
const A4t = Z("editorUnnecessaryCode.opacity", { dark: ge.fromHex("#000a"), light: ge.fromHex("#0007"), hcDark: null, hcLight: null }, C("unnecessaryCodeOpacity", `Opacity of unnecessary (unused) source code in the editor. For example, "#000000c0" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out.`));
Z("editorGhostText.border", { dark: null, light: null, hcDark: ge.fromHex("#fff").transparent(0.8), hcLight: ge.fromHex("#292929").transparent(0.8) }, C("editorGhostTextBorder", "Border color of ghost text in the editor."));
Z("editorGhostText.foreground", { dark: ge.fromHex("#ffffff56"), light: ge.fromHex("#0007"), hcDark: null, hcLight: null }, C("editorGhostTextForeground", "Foreground color of the ghost text in the editor."));
Z("editorGhostText.background", null, C("editorGhostTextBackground", "Background color of the ghost text in the editor."));
const w4t = new ge(new Zt(0, 122, 204, 0.6)), v4t = Z("editorOverviewRuler.rangeHighlightForeground", w4t, C("overviewRulerRangeHighlight", "Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations."), !0), b4t = Z("editorOverviewRuler.errorForeground", { dark: new ge(new Zt(255, 18, 18, 0.7)), light: new ge(new Zt(255, 18, 18, 0.7)), hcDark: new ge(new Zt(255, 50, 50, 1)), hcLight: "#B5200D" }, C("overviewRuleError", "Overview ruler marker color for errors.")), y4t = Z("editorOverviewRuler.warningForeground", { dark: d1, light: d1, hcDark: n9, hcLight: n9 }, C("overviewRuleWarning", "Overview ruler marker color for warnings.")), C4t = Z("editorOverviewRuler.infoForeground", { dark: yf, light: yf, hcDark: i9, hcLight: i9 }, C("overviewRuleInfo", "Overview ruler marker color for infos.")), ike = Z("editorBracketHighlight.foreground1", { dark: "#FFD700", light: "#0431FAFF", hcDark: "#FFD700", hcLight: "#0431FAFF" }, C("editorBracketHighlightForeground1", "Foreground color of brackets (1). Requires enabling bracket pair colorization.")), rke = Z("editorBracketHighlight.foreground2", { dark: "#DA70D6", light: "#319331FF", hcDark: "#DA70D6", hcLight: "#319331FF" }, C("editorBracketHighlightForeground2", "Foreground color of brackets (2). Requires enabling bracket pair colorization.")), ske = Z("editorBracketHighlight.foreground3", { dark: "#179FFF", light: "#7B3814FF", hcDark: "#87CEFA", hcLight: "#7B3814FF" }, C("editorBracketHighlightForeground3", "Foreground color of brackets (3). Requires enabling bracket pair colorization.")), oke = Z("editorBracketHighlight.foreground4", "#00000000", C("editorBracketHighlightForeground4", "Foreground color of brackets (4). Requires enabling bracket pair colorization.")), ake = Z("editorBracketHighlight.foreground5", "#00000000", C("editorBracketHighlightForeground5", "Foreground color of brackets (5). Requires enabling bracket pair colorization.")), lke = Z("editorBracketHighlight.foreground6", "#00000000", C("editorBracketHighlightForeground6", "Foreground color of brackets (6). Requires enabling bracket pair colorization.")), E4t = Z("editorBracketHighlight.unexpectedBracket.foreground", { dark: new ge(new Zt(255, 18, 18, 0.8)), light: new ge(new Zt(255, 18, 18, 0.8)), hcDark: new ge(new Zt(255, 50, 50, 1)), hcLight: "" }, C("editorBracketHighlightUnexpectedBracketForeground", "Foreground color of unexpected brackets.")), _4t = Z("editorBracketPairGuide.background1", "#00000000", C("editorBracketPairGuide.background1", "Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides.")), x4t = Z("editorBracketPairGuide.background2", "#00000000", C("editorBracketPairGuide.background2", "Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides.")), S4t = Z("editorBracketPairGuide.background3", "#00000000", C("editorBracketPairGuide.background3", "Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides.")), M4t = Z("editorBracketPairGuide.background4", "#00000000", C("editorBracketPairGuide.background4", "Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides.")), D4t = Z("editorBracketPairGuide.background5", "#00000000", C("editorBracketPairGuide.background5", "Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides.")), L4t = Z("editorBracketPairGuide.background6", "#00000000", C("editorBracketPairGuide.background6", "Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides.")), k4t = Z("editorBracketPairGuide.activeBackground1", "#00000000", C("editorBracketPairGuide.activeBackground1", "Background color of active bracket pair guides (1). Requires enabling bracket pair guides.")), N4t = Z("editorBracketPairGuide.activeBackground2", "#00000000", C("editorBracketPairGuide.activeBackground2", "Background color of active bracket pair guides (2). Requires enabling bracket pair guides.")), T4t = Z("editorBracketPairGuide.activeBackground3", "#00000000", C("editorBracketPairGuide.activeBackground3", "Background color of active bracket pair guides (3). Requires enabling bracket pair guides.")), I4t = Z("editorBracketPairGuide.activeBackground4", "#00000000", C("editorBracketPairGuide.activeBackground4", "Background color of active bracket pair guides (4). Requires enabling bracket pair guides.")), O4t = Z("editorBracketPairGuide.activeBackground5", "#00000000", C("editorBracketPairGuide.activeBackground5", "Background color of active bracket pair guides (5). Requires enabling bracket pair guides.")), R4t = Z("editorBracketPairGuide.activeBackground6", "#00000000", C("editorBracketPairGuide.activeBackground6", "Background color of active bracket pair guides (6). Requires enabling bracket pair guides."));
Z("editorUnicodeHighlight.border", d1, C("editorUnicodeHighlight.border", "Border color used to highlight unicode characters."));
Z("editorUnicodeHighlight.background", Imt, C("editorUnicodeHighlight.background", "Background color used to highlight unicode characters."));
Sh((r, e) => {
  const t = r.getColor(dh), n = r.getColor(eke), i = n && !n.isTransparent() ? n : t;
  i && e.addRule(`.monaco-editor .inputarea.ime-input { background-color: ${i}; }`);
});
class gy extends t2 {
  static {
    this.CLASS_NAME = "line-numbers";
  }
  constructor(e) {
    super(), this._context = e, this._readConfig(), this._lastCursorModelPosition = new le(1, 1), this._renderResult = null, this._activeLineNumber = 1, this._context.addEventHandler(this);
  }
  _readConfig() {
    const e = this._context.configuration.options;
    this._lineHeight = e.get(
      67
      /* EditorOption.lineHeight */
    );
    const t = e.get(
      68
      /* EditorOption.lineNumbers */
    );
    this._renderLineNumbers = t.renderType, this._renderCustomLineNumbers = t.renderFn, this._renderFinalNewline = e.get(
      96
      /* EditorOption.renderFinalNewline */
    );
    const n = e.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._lineNumbersLeft = n.lineNumbersLeft, this._lineNumbersWidth = n.lineNumbersWidth;
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return this._readConfig(), !0;
  }
  onCursorStateChanged(e) {
    const t = e.selections[0].getPosition();
    this._lastCursorModelPosition = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(t);
    let n = !1;
    return this._activeLineNumber !== t.lineNumber && (this._activeLineNumber = t.lineNumber, n = !0), (this._renderLineNumbers === 2 || this._renderLineNumbers === 3) && (n = !0), n;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return e.affectsLineNumber;
  }
  // --- end event handlers
  _getLineRenderLineNumber(e) {
    const t = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new le(e, 1));
    if (t.column !== 1)
      return "";
    const n = t.lineNumber;
    if (this._renderCustomLineNumbers)
      return this._renderCustomLineNumbers(n);
    if (this._renderLineNumbers === 2) {
      const i = Math.abs(this._lastCursorModelPosition.lineNumber - n);
      return i === 0 ? '<span class="relative-current-line-number">' + n + "</span>" : String(i);
    }
    if (this._renderLineNumbers === 3) {
      if (this._lastCursorModelPosition.lineNumber === n || n % 10 === 0)
        return String(n);
      const i = this._context.viewModel.getLineCount();
      return n === i ? String(n) : "";
    }
    return String(n);
  }
  prepareRender(e) {
    if (this._renderLineNumbers === 0) {
      this._renderResult = null;
      return;
    }
    const t = Cs ? this._lineHeight % 2 === 0 ? " lh-even" : " lh-odd" : "", n = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber, s = this._context.viewModel.getDecorationsInViewport(e.visibleRange).filter((c) => !!c.options.lineNumberClassName);
    s.sort((c, d) => Q.compareRangesUsingEnds(c.range, d.range));
    let o = 0;
    const a = this._context.viewModel.getLineCount(), l = [];
    for (let c = n; c <= i; c++) {
      const d = c - n;
      let u = this._getLineRenderLineNumber(c), f = "";
      for (; o < s.length && s[o].range.endLineNumber < c; )
        o++;
      for (let p = o; p < s.length; p++) {
        const { range: g, options: m } = s[p];
        g.startLineNumber <= c && (f += " " + m.lineNumberClassName);
      }
      if (!u && !f) {
        l[d] = "";
        continue;
      }
      c === a && this._context.viewModel.getLineLength(c) === 0 && (this._renderFinalNewline === "off" && (u = ""), this._renderFinalNewline === "dimmed" && (f += " dimmed-line-number")), c === this._activeLineNumber && (f += " active-line-number"), l[d] = `<div class="${gy.CLASS_NAME}${t}${f}" style="left:${this._lineNumbersLeft}px;width:${this._lineNumbersWidth}px;">${u}</div>`;
    }
    this._renderResult = l;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
Sh((r, e) => {
  const t = r.getColor(e4t), n = r.getColor(p4t);
  n ? e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${n}; }`) : t && e.addRule(`.monaco-editor .line-numbers.dimmed-line-number { color: ${t.transparent(0.4)}; }`);
});
class Y3 extends uo {
  static {
    this.CLASS_NAME = "glyph-margin";
  }
  static {
    this.OUTER_CLASS_NAME = "margin";
  }
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._domNode = Yt(document.createElement("div")), this._domNode.setClassName(Y3.OUTER_CLASS_NAME), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._glyphMarginBackgroundDomNode = Yt(document.createElement("div")), this._glyphMarginBackgroundDomNode.setClassName(Y3.CLASS_NAME), this._domNode.appendChild(this._glyphMarginBackgroundDomNode);
  }
  dispose() {
    super.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._contentLeft = n.contentLeft, this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollTopChanged;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setLayerHinting(this._canUseLayerHinting), this._domNode.setContain("strict");
    const t = e.scrollTop - e.bigNumbersDelta;
    this._domNode.setTop(-t);
    const n = Math.min(e.scrollHeight, 1e6);
    this._domNode.setHeight(n), this._domNode.setWidth(this._contentLeft), this._glyphMarginBackgroundDomNode.setLeft(this._glyphMarginLeft), this._glyphMarginBackgroundDomNode.setWidth(this._glyphMarginWidth), this._glyphMarginBackgroundDomNode.setHeight(n);
  }
}
const _p = "monaco-mouse-cursor-text";
class V4t {
  constructor() {
    this._onDidChange = new $(), this.onDidChange = this._onDidChange.event, this._enabled = !0;
  }
  get enabled() {
    return this._enabled;
  }
  /**
   * Enable IME
   */
  enable() {
    this._enabled = !0, this._onDidChange.fire();
  }
  /**
   * Disable IME
   */
  disable() {
    this._enabled = !1, this._onDidChange.fire();
  }
}
const ZA = new V4t(), _r = Wt("keybindingService");
var H4t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, v6e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
class B4t {
  constructor(e, t, n, i, s) {
    this._context = e, this.modelLineNumber = t, this.distanceToModelLineStart = n, this.widthOfHiddenLineTextBefore = i, this.distanceToModelLineEnd = s, this._visibleTextAreaBrand = void 0, this.startPosition = null, this.endPosition = null, this.visibleTextareaStart = null, this.visibleTextareaEnd = null, this._previousPresentation = null;
  }
  prepareRender(e) {
    const t = new le(this.modelLineNumber, this.distanceToModelLineStart + 1), n = new le(this.modelLineNumber, this._context.viewModel.model.getLineMaxColumn(this.modelLineNumber) - this.distanceToModelLineEnd);
    this.startPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t), this.endPosition = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(n), this.startPosition.lineNumber === this.endPosition.lineNumber ? (this.visibleTextareaStart = e.visibleRangeForPosition(this.startPosition), this.visibleTextareaEnd = e.visibleRangeForPosition(this.endPosition)) : (this.visibleTextareaStart = null, this.visibleTextareaEnd = null);
  }
  definePresentation(e) {
    return this._previousPresentation || (e ? this._previousPresentation = e : this._previousPresentation = {
      foreground: 1,
      italic: !1,
      bold: !1,
      underline: !1,
      strikethrough: !1
    }), this._previousPresentation;
  }
}
const qE = pl;
let wL = class extends uo {
  constructor(e, t, n, i, s) {
    super(e), this._keybindingService = i, this._instantiationService = s, this._primaryCursorPosition = new le(1, 1), this._primaryCursorVisibleRange = null, this._viewController = t, this._visibleRangeProvider = n, this._scrollLeft = 0, this._scrollTop = 0;
    const o = this._context.configuration.options, a = o.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._setAccessibilityOptions(o), this._contentLeft = a.contentLeft, this._contentWidth = a.contentWidth, this._contentHeight = a.height, this._fontInfo = o.get(
      50
      /* EditorOption.fontInfo */
    ), this._lineHeight = o.get(
      67
      /* EditorOption.lineHeight */
    ), this._emptySelectionClipboard = o.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this._copyWithSyntaxHighlighting = o.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this._visibleTextArea = null, this._selections = [new _n(1, 1, 1, 1)], this._modelSelections = [new _n(1, 1, 1, 1)], this._lastRenderPosition = null, this.textArea = Yt(document.createElement("textarea")), rc.write(
      this.textArea,
      7
      /* PartFingerprint.TextArea */
    ), this.textArea.setClassName(`inputarea ${_p}`), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: l } = this._context.viewModel.model.getOptions();
    this.textArea.domNode.style.tabSize = `${l * this._fontInfo.spaceWidth}px`, this.textArea.setAttribute("autocorrect", "off"), this.textArea.setAttribute("autocapitalize", "off"), this.textArea.setAttribute("autocomplete", "off"), this.textArea.setAttribute("spellcheck", "false"), this.textArea.setAttribute("aria-label", this._getAriaLabel(o)), this.textArea.setAttribute("aria-required", o.get(
      5
      /* EditorOption.ariaRequired */
    ) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(o.get(
      125
      /* EditorOption.tabIndex */
    ))), this.textArea.setAttribute("role", "textbox"), this.textArea.setAttribute("aria-roledescription", C("editor", "editor")), this.textArea.setAttribute("aria-multiline", "true"), this.textArea.setAttribute("aria-autocomplete", o.get(
      92
      /* EditorOption.readOnly */
    ) ? "none" : "both"), this._ensureReadOnlyAttribute(), this.textAreaCover = Yt(document.createElement("div")), this.textAreaCover.setPosition("absolute");
    const c = {
      getLineCount: () => this._context.viewModel.getLineCount(),
      getLineMaxColumn: (f) => this._context.viewModel.getLineMaxColumn(f),
      getValueInRange: (f, p) => this._context.viewModel.getValueInRange(f, p),
      getValueLengthInRange: (f, p) => this._context.viewModel.getValueLengthInRange(f, p),
      modifyPosition: (f, p) => this._context.viewModel.modifyPosition(f, p)
    }, d = {
      getDataToCopy: () => {
        const f = this._context.viewModel.getPlainTextToCopy(this._modelSelections, this._emptySelectionClipboard, zs), p = this._context.viewModel.model.getEOL(), g = this._emptySelectionClipboard && this._modelSelections.length === 1 && this._modelSelections[0].isEmpty(), m = Array.isArray(f) ? f : null, A = Array.isArray(f) ? f.join(p) : f;
        let w, v = null;
        if (this._copyWithSyntaxHighlighting && A.length < 65536) {
          const y = this._context.viewModel.getRichTextToCopy(this._modelSelections, this._emptySelectionClipboard);
          y && (w = y.html, v = y.mode);
        }
        return {
          isFromEmptySelection: g,
          multicursorText: m,
          text: A,
          html: w,
          mode: v
        };
      },
      getScreenReaderContent: () => {
        if (this._accessibilitySupport === 1) {
          const f = this._selections[0];
          if (zt && f.isEmpty()) {
            const g = f.getStartPosition();
            let m = this._getWordBeforePosition(g);
            if (m.length === 0 && (m = this._getCharacterBeforePosition(g)), m.length > 0)
              return new Mr(m, m.length, m.length, Q.fromPositions(g), 0);
          }
          if (zt && !f.isEmpty() && c.getValueLengthInRange(
            f,
            0
            /* EndOfLinePreference.TextDefined */
          ) < 500) {
            const g = c.getValueInRange(
              f,
              0
              /* EndOfLinePreference.TextDefined */
            );
            return new Mr(g, 0, g.length, f, 0);
          }
          if (l1 && !f.isEmpty()) {
            const g = "vscode-placeholder";
            return new Mr(g, 0, g.length, null, void 0);
          }
          return Mr.EMPTY;
        }
        if (Rve) {
          const f = this._selections[0];
          if (f.isEmpty()) {
            const p = f.getStartPosition(), [g, m] = this._getAndroidWordAtPosition(p);
            if (g.length > 0)
              return new Mr(g, m, m, Q.fromPositions(p), 0);
          }
          return Mr.EMPTY;
        }
        return tp.fromEditorSelection(
          c,
          this._selections[0],
          this._accessibilityPageSize,
          this._accessibilitySupport === 0
          /* AccessibilitySupport.Unknown */
        );
      },
      deduceModelPosition: (f, p, g) => this._context.viewModel.deduceModelPositionRelativeToViewPosition(f, p, g)
    }, u = this._register(new q3t(this.textArea.domNode));
    this._textAreaInput = this._register(this._instantiationService.createInstance(mL, d, u, nl, {
      isAndroid: Rve,
      isChrome: vw,
      isFirefox: pl,
      isSafari: l1
    })), this._register(this._textAreaInput.onKeyDown((f) => {
      this._viewController.emitKeyDown(f);
    })), this._register(this._textAreaInput.onKeyUp((f) => {
      this._viewController.emitKeyUp(f);
    })), this._register(this._textAreaInput.onPaste((f) => {
      let p = !1, g = null, m = null;
      f.metadata && (p = this._emptySelectionClipboard && !!f.metadata.isFromEmptySelection, g = typeof f.metadata.multicursorText < "u" ? f.metadata.multicursorText : null, m = f.metadata.mode), this._viewController.paste(f.text, p, g, m);
    })), this._register(this._textAreaInput.onCut(() => {
      this._viewController.cut();
    })), this._register(this._textAreaInput.onType((f) => {
      f.replacePrevCharCnt || f.replaceNextCharCnt || f.positionDelta ? this._viewController.compositionType(f.text, f.replacePrevCharCnt, f.replaceNextCharCnt, f.positionDelta) : this._viewController.type(f.text);
    })), this._register(this._textAreaInput.onSelectionChangeRequest((f) => {
      this._viewController.setSelection(f);
    })), this._register(this._textAreaInput.onCompositionStart((f) => {
      const p = this.textArea.domNode, g = this._modelSelections[0], { distanceToModelLineStart: m, widthOfHiddenTextBefore: A } = (() => {
        const v = p.value.substring(0, Math.min(p.selectionStart, p.selectionEnd)), y = v.lastIndexOf(`
`), _ = v.substring(y + 1), S = _.lastIndexOf("	"), D = _.length - S - 1, M = g.getStartPosition(), L = Math.min(M.column - 1, D), T = M.column - 1 - L, B = _.substring(0, _.length - L), { tabSize: V } = this._context.viewModel.model.getOptions(), N = P4t(this.textArea.domNode.ownerDocument, B, this._fontInfo, V);
        return { distanceToModelLineStart: T, widthOfHiddenTextBefore: N };
      })(), { distanceToModelLineEnd: w } = (() => {
        const v = p.value.substring(Math.max(p.selectionStart, p.selectionEnd)), y = v.indexOf(`
`), _ = y === -1 ? v : v.substring(0, y), S = _.indexOf("	"), D = S === -1 ? _.length : _.length - S - 1, M = g.getEndPosition(), L = Math.min(this._context.viewModel.model.getLineMaxColumn(M.lineNumber) - M.column, D);
        return { distanceToModelLineEnd: this._context.viewModel.model.getLineMaxColumn(M.lineNumber) - M.column - L };
      })();
      this._context.viewModel.revealRange(
        "keyboard",
        !0,
        Q.fromPositions(this._selections[0].getStartPosition()),
        0,
        1
        /* ScrollType.Immediate */
      ), this._visibleTextArea = new B4t(this._context, g.startLineNumber, m, A, w), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render(), this.textArea.setClassName(`inputarea ${_p} ime-input`), this._viewController.compositionStart(), this._context.viewModel.onCompositionStart();
    })), this._register(this._textAreaInput.onCompositionUpdate((f) => {
      this._visibleTextArea && (this._visibleTextArea.prepareRender(this._visibleRangeProvider), this._render());
    })), this._register(this._textAreaInput.onCompositionEnd(() => {
      this._visibleTextArea = null, this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off"), this._render(), this.textArea.setClassName(`inputarea ${_p}`), this._viewController.compositionEnd(), this._context.viewModel.onCompositionEnd();
    })), this._register(this._textAreaInput.onFocus(() => {
      this._context.viewModel.setHasFocus(!0);
    })), this._register(this._textAreaInput.onBlur(() => {
      this._context.viewModel.setHasFocus(!1);
    })), this._register(ZA.onDidChange(() => {
      this._ensureReadOnlyAttribute();
    }));
  }
  writeScreenReaderContent(e) {
    this._textAreaInput.writeNativeTextAreaContent(e);
  }
  dispose() {
    super.dispose();
  }
  _getAndroidWordAtPosition(e) {
    const t = '`~!@#$%^&*()-=+[{]}\\|;:",.<>/?', n = this._context.viewModel.getLineContent(e.lineNumber), i = lg(t, []);
    let s = !0, o = e.column, a = !0, l = e.column, c = 0;
    for (; c < 50 && (s || a); ) {
      if (s && o <= 1 && (s = !1), s) {
        const d = n.charCodeAt(o - 2);
        i.get(d) !== 0 ? s = !1 : o--;
      }
      if (a && l > n.length && (a = !1), a) {
        const d = n.charCodeAt(l - 1);
        i.get(d) !== 0 ? a = !1 : l++;
      }
      c++;
    }
    return [n.substring(o - 1, l - 1), e.column - o];
  }
  _getWordBeforePosition(e) {
    const t = this._context.viewModel.getLineContent(e.lineNumber), n = lg(this._context.configuration.options.get(
      132
      /* EditorOption.wordSeparators */
    ), []);
    let i = e.column, s = 0;
    for (; i > 1; ) {
      const o = t.charCodeAt(i - 2);
      if (n.get(o) !== 0 || s > 50)
        return t.substring(i - 1, e.column - 1);
      s++, i--;
    }
    return t.substring(0, e.column - 1);
  }
  _getCharacterBeforePosition(e) {
    if (e.column > 1) {
      const n = this._context.viewModel.getLineContent(e.lineNumber).charAt(e.column - 2);
      if (!Ki(n.charCodeAt(0)))
        return n;
    }
    return "";
  }
  _getAriaLabel(e) {
    if (e.get(
      2
      /* EditorOption.accessibilitySupport */
    ) === 1) {
      const n = this._keybindingService.lookupKeybinding("editor.action.toggleScreenReaderAccessibilityMode")?.getAriaLabel(), i = this._keybindingService.lookupKeybinding("workbench.action.showCommands")?.getAriaLabel(), s = this._keybindingService.lookupKeybinding("workbench.action.openGlobalKeybindings")?.getAriaLabel(), o = C("accessibilityModeOff", "The editor is not accessible at this time.");
      return n ? C("accessibilityOffAriaLabel", "{0} To enable screen reader optimized mode, use {1}", o, n) : i ? C("accessibilityOffAriaLabelNoKb", "{0} To enable screen reader optimized mode, open the quick pick with {1} and run the command Toggle Screen Reader Accessibility Mode, which is currently not triggerable via keyboard.", o, i) : s ? C("accessibilityOffAriaLabelNoKbs", "{0} Please assign a keybinding for the command Toggle Screen Reader Accessibility Mode by accessing the keybindings editor with {1} and run it.", o, s) : o;
    }
    return e.get(
      4
      /* EditorOption.ariaLabel */
    );
  }
  _setAccessibilityOptions(e) {
    this._accessibilitySupport = e.get(
      2
      /* EditorOption.accessibilitySupport */
    );
    const t = e.get(
      3
      /* EditorOption.accessibilityPageSize */
    );
    this._accessibilitySupport === 2 && t === Wf.accessibilityPageSize.defaultValue ? this._accessibilityPageSize = 500 : this._accessibilityPageSize = t;
    const i = e.get(
      146
      /* EditorOption.layoutInfo */
    ).wrappingColumn;
    if (i !== -1 && this._accessibilitySupport !== 1) {
      const s = e.get(
        50
        /* EditorOption.fontInfo */
      );
      this._textAreaWrapping = !0, this._textAreaWidth = Math.round(i * s.typicalHalfwidthCharacterWidth);
    } else
      this._textAreaWrapping = !1, this._textAreaWidth = qE ? 0 : 1;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._setAccessibilityOptions(t), this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._contentHeight = n.height, this._fontInfo = t.get(
      50
      /* EditorOption.fontInfo */
    ), this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._emptySelectionClipboard = t.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this._copyWithSyntaxHighlighting = t.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this.textArea.setAttribute("wrap", this._textAreaWrapping && !this._visibleTextArea ? "on" : "off");
    const { tabSize: i } = this._context.viewModel.model.getOptions();
    return this.textArea.domNode.style.tabSize = `${i * this._fontInfo.spaceWidth}px`, this.textArea.setAttribute("aria-label", this._getAriaLabel(t)), this.textArea.setAttribute("aria-required", t.get(
      5
      /* EditorOption.ariaRequired */
    ) ? "true" : "false"), this.textArea.setAttribute("tabindex", String(t.get(
      125
      /* EditorOption.tabIndex */
    ))), (e.hasChanged(
      34
      /* EditorOption.domReadOnly */
    ) || e.hasChanged(
      92
      /* EditorOption.readOnly */
    )) && this._ensureReadOnlyAttribute(), e.hasChanged(
      2
      /* EditorOption.accessibilitySupport */
    ) && this._textAreaInput.writeNativeTextAreaContent("strategy changed"), !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), this._modelSelections = e.modelSelections.slice(0), this._textAreaInput.writeNativeTextAreaContent("selection changed"), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return this._scrollLeft = e.scrollLeft, this._scrollTop = e.scrollTop, !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // --- begin view API
  isFocused() {
    return this._textAreaInput.isFocused();
  }
  focusTextArea() {
    this._textAreaInput.focusTextArea();
  }
  getLastRenderData() {
    return this._lastRenderPosition;
  }
  setAriaOptions(e) {
    e.activeDescendant ? (this.textArea.setAttribute("aria-haspopup", "true"), this.textArea.setAttribute("aria-autocomplete", "list"), this.textArea.setAttribute("aria-activedescendant", e.activeDescendant)) : (this.textArea.setAttribute("aria-haspopup", "false"), this.textArea.setAttribute("aria-autocomplete", "both"), this.textArea.removeAttribute("aria-activedescendant")), e.role && this.textArea.setAttribute("role", e.role);
  }
  // --- end view API
  _ensureReadOnlyAttribute() {
    const e = this._context.configuration.options;
    !ZA.enabled || e.get(
      34
      /* EditorOption.domReadOnly */
    ) && e.get(
      92
      /* EditorOption.readOnly */
    ) ? this.textArea.setAttribute("readonly", "true") : this.textArea.removeAttribute("readonly");
  }
  prepareRender(e) {
    this._primaryCursorPosition = new le(this._selections[0].positionLineNumber, this._selections[0].positionColumn), this._primaryCursorVisibleRange = e.visibleRangeForPosition(this._primaryCursorPosition), this._visibleTextArea?.prepareRender(e);
  }
  render(e) {
    this._textAreaInput.writeNativeTextAreaContent("render"), this._render();
  }
  _render() {
    if (this._visibleTextArea) {
      const n = this._visibleTextArea.visibleTextareaStart, i = this._visibleTextArea.visibleTextareaEnd, s = this._visibleTextArea.startPosition, o = this._visibleTextArea.endPosition;
      if (s && o && n && i && i.left >= this._scrollLeft && n.left <= this._scrollLeft + this._contentWidth) {
        const a = this._context.viewLayout.getVerticalOffsetForLineNumber(this._primaryCursorPosition.lineNumber) - this._scrollTop, l = this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
        let c = this._visibleTextArea.widthOfHiddenLineTextBefore, d = this._contentLeft + n.left - this._scrollLeft, u = i.left - n.left + 1;
        if (d < this._contentLeft) {
          const w = this._contentLeft - d;
          d += w, c += w, u -= w;
        }
        u > this._contentWidth && (u = this._contentWidth);
        const f = this._context.viewModel.getViewLineData(s.lineNumber), p = f.tokens.findTokenIndexAtOffset(s.column - 1), g = f.tokens.findTokenIndexAtOffset(o.column - 1), m = p === g, A = this._visibleTextArea.definePresentation(m ? f.tokens.getPresentation(p) : null);
        this.textArea.domNode.scrollTop = l * this._lineHeight, this.textArea.domNode.scrollLeft = c, this._doRender({
          lastRenderPosition: null,
          top: a,
          left: d,
          width: u,
          height: this._lineHeight,
          useCover: !1,
          color: (xi.getColorMap() || [])[A.foreground],
          italic: A.italic,
          bold: A.bold,
          underline: A.underline,
          strikethrough: A.strikethrough
        });
      }
      return;
    }
    if (!this._primaryCursorVisibleRange) {
      this._renderAtTopLeft();
      return;
    }
    const e = this._contentLeft + this._primaryCursorVisibleRange.left - this._scrollLeft;
    if (e < this._contentLeft || e > this._contentLeft + this._contentWidth) {
      this._renderAtTopLeft();
      return;
    }
    const t = this._context.viewLayout.getVerticalOffsetForLineNumber(this._selections[0].positionLineNumber) - this._scrollTop;
    if (t < 0 || t > this._contentHeight) {
      this._renderAtTopLeft();
      return;
    }
    if (zt || this._accessibilitySupport === 2) {
      this._doRender({
        lastRenderPosition: this._primaryCursorPosition,
        top: t,
        left: this._textAreaWrapping ? this._contentLeft : e,
        width: this._textAreaWidth,
        height: this._lineHeight,
        useCover: !1
      }), this.textArea.domNode.scrollLeft = this._primaryCursorVisibleRange.left;
      const n = this._textAreaInput.textAreaState.newlineCountBeforeSelection ?? this._newlinecount(this.textArea.domNode.value.substr(0, this.textArea.domNode.selectionStart));
      this.textArea.domNode.scrollTop = n * this._lineHeight;
      return;
    }
    this._doRender({
      lastRenderPosition: this._primaryCursorPosition,
      top: t,
      left: this._textAreaWrapping ? this._contentLeft : e,
      width: this._textAreaWidth,
      height: qE ? 0 : 1,
      useCover: !1
    });
  }
  _newlinecount(e) {
    let t = 0, n = -1;
    do {
      if (n = e.indexOf(`
`, n + 1), n === -1)
        break;
      t++;
    } while (!0);
    return t;
  }
  _renderAtTopLeft() {
    this._doRender({
      lastRenderPosition: null,
      top: 0,
      left: 0,
      width: this._textAreaWidth,
      height: qE ? 0 : 1,
      useCover: !0
    });
  }
  _doRender(e) {
    this._lastRenderPosition = e.lastRenderPosition;
    const t = this.textArea, n = this.textAreaCover;
    Br(t, this._fontInfo), t.setTop(e.top), t.setLeft(e.left), t.setWidth(e.width), t.setHeight(e.height), t.setColor(e.color ? ge.Format.CSS.formatHex(e.color) : ""), t.setFontStyle(e.italic ? "italic" : ""), e.bold && t.setFontWeight("bold"), t.setTextDecoration(`${e.underline ? " underline" : ""}${e.strikethrough ? " line-through" : ""}`), n.setTop(e.useCover ? e.top : 0), n.setLeft(e.useCover ? e.left : 0), n.setWidth(e.useCover ? e.width : 0), n.setHeight(e.useCover ? e.height : 0);
    const i = this._context.configuration.options;
    i.get(
      57
      /* EditorOption.glyphMargin */
    ) ? n.setClassName("monaco-editor-background textAreaCover " + Y3.OUTER_CLASS_NAME) : i.get(
      68
      /* EditorOption.lineNumbers */
    ).renderType !== 0 ? n.setClassName("monaco-editor-background textAreaCover " + gy.CLASS_NAME) : n.setClassName("monaco-editor-background textAreaCover");
  }
};
wL = H4t([
  v6e(3, _r),
  v6e(4, xn)
], wL);
function P4t(r, e, t, n) {
  if (e.length === 0)
    return 0;
  const i = r.createElement("div");
  i.style.position = "absolute", i.style.top = "-50000px", i.style.width = "50000px";
  const s = r.createElement("span");
  Br(s, t), s.style.whiteSpace = "pre", s.style.tabSize = `${n * t.spaceWidth}px`, s.append(e), i.appendChild(s), r.body.appendChild(i);
  const o = s.offsetWidth;
  return i.remove(), o;
}
function F4t(r, e, t) {
  let n = 0;
  for (let s = 0; s < r.length; s++)
    r.charAt(s) === "	" ? n = zi.nextIndentTabStop(n, e) : n++;
  let i = "";
  if (!t) {
    const s = Math.floor(n / e);
    n = n % e;
    for (let o = 0; o < s; o++)
      i += "	";
  }
  for (let s = 0; s < n; s++)
    i += " ";
  return i;
}
function cke(r, e, t) {
  let n = so(r);
  return n === -1 && (n = r.length), F4t(r.substring(0, n), e, t) + r.substring(n);
}
const z4t = () => !0, W4t = () => !1, j4t = (r) => r === " " || r === "	";
class x2 {
  static shouldRecreate(e) {
    return e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    ) || e.hasChanged(
      132
      /* EditorOption.wordSeparators */
    ) || e.hasChanged(
      37
      /* EditorOption.emptySelectionClipboard */
    ) || e.hasChanged(
      77
      /* EditorOption.multiCursorMergeOverlapping */
    ) || e.hasChanged(
      79
      /* EditorOption.multiCursorPaste */
    ) || e.hasChanged(
      80
      /* EditorOption.multiCursorLimit */
    ) || e.hasChanged(
      6
      /* EditorOption.autoClosingBrackets */
    ) || e.hasChanged(
      7
      /* EditorOption.autoClosingComments */
    ) || e.hasChanged(
      11
      /* EditorOption.autoClosingQuotes */
    ) || e.hasChanged(
      9
      /* EditorOption.autoClosingDelete */
    ) || e.hasChanged(
      10
      /* EditorOption.autoClosingOvertype */
    ) || e.hasChanged(
      14
      /* EditorOption.autoSurround */
    ) || e.hasChanged(
      129
      /* EditorOption.useTabStops */
    ) || e.hasChanged(
      50
      /* EditorOption.fontInfo */
    ) || e.hasChanged(
      92
      /* EditorOption.readOnly */
    ) || e.hasChanged(
      131
      /* EditorOption.wordSegmenterLocales */
    );
  }
  constructor(e, t, n, i) {
    this.languageConfigurationService = i, this._cursorMoveConfigurationBrand = void 0, this._languageId = e;
    const s = n.options, o = s.get(
      146
      /* EditorOption.layoutInfo */
    ), a = s.get(
      50
      /* EditorOption.fontInfo */
    );
    this.readOnly = s.get(
      92
      /* EditorOption.readOnly */
    ), this.tabSize = t.tabSize, this.indentSize = t.indentSize, this.insertSpaces = t.insertSpaces, this.stickyTabStops = s.get(
      117
      /* EditorOption.stickyTabStops */
    ), this.lineHeight = a.lineHeight, this.typicalHalfwidthCharacterWidth = a.typicalHalfwidthCharacterWidth, this.pageSize = Math.max(1, Math.floor(o.height / this.lineHeight) - 2), this.useTabStops = s.get(
      129
      /* EditorOption.useTabStops */
    ), this.wordSeparators = s.get(
      132
      /* EditorOption.wordSeparators */
    ), this.emptySelectionClipboard = s.get(
      37
      /* EditorOption.emptySelectionClipboard */
    ), this.copyWithSyntaxHighlighting = s.get(
      25
      /* EditorOption.copyWithSyntaxHighlighting */
    ), this.multiCursorMergeOverlapping = s.get(
      77
      /* EditorOption.multiCursorMergeOverlapping */
    ), this.multiCursorPaste = s.get(
      79
      /* EditorOption.multiCursorPaste */
    ), this.multiCursorLimit = s.get(
      80
      /* EditorOption.multiCursorLimit */
    ), this.autoClosingBrackets = s.get(
      6
      /* EditorOption.autoClosingBrackets */
    ), this.autoClosingComments = s.get(
      7
      /* EditorOption.autoClosingComments */
    ), this.autoClosingQuotes = s.get(
      11
      /* EditorOption.autoClosingQuotes */
    ), this.autoClosingDelete = s.get(
      9
      /* EditorOption.autoClosingDelete */
    ), this.autoClosingOvertype = s.get(
      10
      /* EditorOption.autoClosingOvertype */
    ), this.autoSurround = s.get(
      14
      /* EditorOption.autoSurround */
    ), this.autoIndent = s.get(
      12
      /* EditorOption.autoIndent */
    ), this.wordSegmenterLocales = s.get(
      131
      /* EditorOption.wordSegmenterLocales */
    ), this.surroundingPairs = {}, this._electricChars = null, this.shouldAutoCloseBefore = {
      quote: this._getShouldAutoClose(e, this.autoClosingQuotes, !0),
      comment: this._getShouldAutoClose(e, this.autoClosingComments, !1),
      bracket: this._getShouldAutoClose(e, this.autoClosingBrackets, !1)
    }, this.autoClosingPairs = this.languageConfigurationService.getLanguageConfiguration(e).getAutoClosingPairs();
    const l = this.languageConfigurationService.getLanguageConfiguration(e).getSurroundingPairs();
    if (l)
      for (const d of l)
        this.surroundingPairs[d.open] = d.close;
    const c = this.languageConfigurationService.getLanguageConfiguration(e).comments;
    this.blockCommentStartToken = c?.blockCommentStartToken ?? null;
  }
  get electricChars() {
    if (!this._electricChars) {
      this._electricChars = {};
      const e = this.languageConfigurationService.getLanguageConfiguration(this._languageId).electricCharacter?.getElectricCharacters();
      if (e)
        for (const t of e)
          this._electricChars[t] = !0;
    }
    return this._electricChars;
  }
  /**
   * Should return opening bracket type to match indentation with
   */
  onElectricCharacter(e, t, n) {
    const i = I0(t, n - 1), s = this.languageConfigurationService.getLanguageConfiguration(i.languageId).electricCharacter;
    return s ? s.onElectricCharacter(e, i, n - i.firstCharOffset) : null;
  }
  normalizeIndentation(e) {
    return cke(e, this.indentSize, this.insertSpaces);
  }
  _getShouldAutoClose(e, t, n) {
    switch (t) {
      case "beforeWhitespace":
        return j4t;
      case "languageDefined":
        return this._getLanguageDefinedShouldAutoClose(e, n);
      case "always":
        return z4t;
      case "never":
        return W4t;
    }
  }
  _getLanguageDefinedShouldAutoClose(e, t) {
    const n = this.languageConfigurationService.getLanguageConfiguration(e).getAutoCloseBeforeSet(t);
    return (i) => n.indexOf(i) !== -1;
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  visibleColumnFromColumn(e, t) {
    return zi.visibleColumnFromColumn(e.getLineContent(t.lineNumber), t.column, this.tabSize);
  }
  /**
   * Returns a visible column from a column.
   * @see {@link CursorColumns}
   */
  columnFromVisibleColumn(e, t, n) {
    const i = zi.columnFromVisibleColumn(e.getLineContent(t), n, this.tabSize), s = e.getLineMinColumn(t);
    if (i < s)
      return s;
    const o = e.getLineMaxColumn(t);
    return i > o ? o : i;
  }
}
class Dt {
  static fromModelState(e) {
    return new Z4t(e);
  }
  static fromViewState(e) {
    return new U4t(e);
  }
  static fromModelSelection(e) {
    const t = _n.liftSelection(e), n = new pr(Q.fromPositions(t.getSelectionStart()), 0, 0, t.getPosition(), 0);
    return Dt.fromModelState(n);
  }
  static fromModelSelections(e) {
    const t = [];
    for (let n = 0, i = e.length; n < i; n++)
      t[n] = this.fromModelSelection(e[n]);
    return t;
  }
  constructor(e, t) {
    this._cursorStateBrand = void 0, this.modelState = e, this.viewState = t;
  }
  equals(e) {
    return this.viewState.equals(e.viewState) && this.modelState.equals(e.modelState);
  }
}
class Z4t {
  constructor(e) {
    this.modelState = e, this.viewState = null;
  }
}
class U4t {
  constructor(e) {
    this.modelState = null, this.viewState = e;
  }
}
class pr {
  constructor(e, t, n, i, s) {
    this.selectionStart = e, this.selectionStartKind = t, this.selectionStartLeftoverVisibleColumns = n, this.position = i, this.leftoverVisibleColumns = s, this._singleCursorStateBrand = void 0, this.selection = pr._computeSelection(this.selectionStart, this.position);
  }
  equals(e) {
    return this.selectionStartLeftoverVisibleColumns === e.selectionStartLeftoverVisibleColumns && this.leftoverVisibleColumns === e.leftoverVisibleColumns && this.selectionStartKind === e.selectionStartKind && this.position.equals(e.position) && this.selectionStart.equalsRange(e.selectionStart);
  }
  hasSelection() {
    return !this.selection.isEmpty() || !this.selectionStart.isEmpty();
  }
  move(e, t, n, i) {
    return e ? new pr(this.selectionStart, this.selectionStartKind, this.selectionStartLeftoverVisibleColumns, new le(t, n), i) : new pr(new Q(t, n, t, n), 0, i, new le(t, n), i);
  }
  static _computeSelection(e, t) {
    return e.isEmpty() || !t.isBeforeOrEqual(e.getStartPosition()) ? _n.fromPositions(e.getStartPosition(), t) : _n.fromPositions(e.getEndPosition(), t);
  }
}
class js {
  constructor(e, t, n) {
    this._editOperationResultBrand = void 0, this.type = e, this.commands = t, this.shouldPushStackElementBefore = n.shouldPushStackElementBefore, this.shouldPushStackElementAfter = n.shouldPushStackElementAfter;
  }
}
function f1(r) {
  return r === "'" || r === '"' || r === "`";
}
class v0 {
  static columnSelect(e, t, n, i, s, o) {
    const a = Math.abs(s - n) + 1, l = n > s, c = i > o, d = i < o, u = [];
    for (let f = 0; f < a; f++) {
      const p = n + (l ? -f : f), g = e.columnFromVisibleColumn(t, p, i), m = e.columnFromVisibleColumn(t, p, o), A = e.visibleColumnFromColumn(t, new le(p, g)), w = e.visibleColumnFromColumn(t, new le(p, m));
      d && (A > o || w < i) || c && (w > i || A < o) || u.push(new pr(new Q(p, g, p, g), 0, 0, new le(p, m), 0));
    }
    if (u.length === 0)
      for (let f = 0; f < a; f++) {
        const p = n + (l ? -f : f), g = t.getLineMaxColumn(p);
        u.push(new pr(new Q(p, g, p, g), 0, 0, new le(p, g), 0));
      }
    return {
      viewStates: u,
      reversed: l,
      fromLineNumber: n,
      fromVisualColumn: i,
      toLineNumber: s,
      toVisualColumn: o
    };
  }
  static columnSelectLeft(e, t, n) {
    let i = n.toViewVisualColumn;
    return i > 0 && i--, v0.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, i);
  }
  static columnSelectRight(e, t, n) {
    let i = 0;
    const s = Math.min(n.fromViewLineNumber, n.toViewLineNumber), o = Math.max(n.fromViewLineNumber, n.toViewLineNumber);
    for (let l = s; l <= o; l++) {
      const c = t.getLineMaxColumn(l), d = e.visibleColumnFromColumn(t, new le(l, c));
      i = Math.max(i, d);
    }
    let a = n.toViewVisualColumn;
    return a < i && a++, this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, n.toViewLineNumber, a);
  }
  static columnSelectUp(e, t, n, i) {
    const s = i ? e.pageSize : 1, o = Math.max(1, n.toViewLineNumber - s);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, o, n.toViewVisualColumn);
  }
  static columnSelectDown(e, t, n, i) {
    const s = i ? e.pageSize : 1, o = Math.min(t.getLineCount(), n.toViewLineNumber + s);
    return this.columnSelect(e, t, n.fromViewLineNumber, n.fromViewVisualColumn, o, n.toViewVisualColumn);
  }
}
class Vs {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _n.fromPositions(i.getEndPosition());
  }
}
class _6 {
  constructor(e, t, n = !1) {
    this._range = e, this._text = t, this.insertsAutoWhitespace = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _n.fromPositions(i.getStartPosition());
  }
}
class l9 {
  constructor(e, t, n, i, s = !1) {
    this._range = e, this._text = t, this._columnDeltaOffset = i, this._lineNumberDeltaOffset = n, this.insertsAutoWhitespace = s;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return _n.fromPositions(i.getEndPosition().delta(this._lineNumberDeltaOffset, this._columnDeltaOffset));
  }
}
class hke {
  constructor(e, t, n, i = !1) {
    this._range = e, this._text = t, this._initialSelection = n, this._forceMoveMarkers = i, this._selectionId = null;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._range, this._text, this._forceMoveMarkers), this._selectionId = t.trackSelection(this._initialSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._selectionId);
  }
}
class GE {
  constructor(e, t, n) {
    this._cursorPositionBrand = void 0, this.lineNumber = e, this.column = t, this.leftoverVisibleColumns = n;
  }
}
class dn {
  static leftPosition(e, t) {
    if (t.column > e.getLineMinColumn(t.lineNumber))
      return t.delta(void 0, -iDe(e.getLineContent(t.lineNumber), t.column - 1));
    if (t.lineNumber > 1) {
      const n = t.lineNumber - 1;
      return new le(n, e.getLineMaxColumn(n));
    } else
      return t;
  }
  static leftPositionAtomicSoftTabs(e, t, n) {
    if (t.column <= e.getLineIndentColumn(t.lineNumber)) {
      const i = e.getLineMinColumn(t.lineNumber), s = e.getLineContent(t.lineNumber), o = Q3.atomicPosition(
        s,
        t.column - 1,
        n,
        0
        /* Direction.Left */
      );
      if (o !== -1 && o + 1 >= i)
        return new le(t.lineNumber, o + 1);
    }
    return this.leftPosition(e, t);
  }
  static left(e, t, n) {
    const i = e.stickyTabStops ? dn.leftPositionAtomicSoftTabs(t, n, e.tabSize) : dn.leftPosition(t, n);
    return new GE(i.lineNumber, i.column, 0);
  }
  /**
   * @param noOfColumns Must be either `1`
   * or `Math.round(viewModel.getLineContent(viewLineNumber).length / 2)` (for half lines).
  */
  static moveLeft(e, t, n, i, s) {
    let o, a;
    if (n.hasSelection() && !i)
      o = n.selection.startLineNumber, a = n.selection.startColumn;
    else {
      const l = n.position.delta(void 0, -(s - 1)), c = t.normalizePosition(
        dn.clipPositionColumn(l, t),
        0
        /* PositionAffinity.Left */
      ), d = dn.left(e, t, c);
      o = d.lineNumber, a = d.column;
    }
    return n.move(i, o, a, 0);
  }
  /**
   * Adjusts the column so that it is within min/max of the line.
  */
  static clipPositionColumn(e, t) {
    return new le(e.lineNumber, dn.clipRange(e.column, t.getLineMinColumn(e.lineNumber), t.getLineMaxColumn(e.lineNumber)));
  }
  static clipRange(e, t, n) {
    return e < t ? t : e > n ? n : e;
  }
  static rightPosition(e, t, n) {
    return n < e.getLineMaxColumn(t) ? n = n + HI(e.getLineContent(t), n - 1) : t < e.getLineCount() && (t = t + 1, n = e.getLineMinColumn(t)), new le(t, n);
  }
  static rightPositionAtomicSoftTabs(e, t, n, i, s) {
    if (n < e.getLineIndentColumn(t)) {
      const o = e.getLineContent(t), a = Q3.atomicPosition(
        o,
        n - 1,
        i,
        1
        /* Direction.Right */
      );
      if (a !== -1)
        return new le(t, a + 1);
    }
    return this.rightPosition(e, t, n);
  }
  static right(e, t, n) {
    const i = e.stickyTabStops ? dn.rightPositionAtomicSoftTabs(t, n.lineNumber, n.column, e.tabSize, e.indentSize) : dn.rightPosition(t, n.lineNumber, n.column);
    return new GE(i.lineNumber, i.column, 0);
  }
  static moveRight(e, t, n, i, s) {
    let o, a;
    if (n.hasSelection() && !i)
      o = n.selection.endLineNumber, a = n.selection.endColumn;
    else {
      const l = n.position.delta(void 0, s - 1), c = t.normalizePosition(
        dn.clipPositionColumn(l, t),
        1
        /* PositionAffinity.Right */
      ), d = dn.right(e, t, c);
      o = d.lineNumber, a = d.column;
    }
    return n.move(i, o, a, 0);
  }
  static vertical(e, t, n, i, s, o, a, l) {
    const c = zi.visibleColumnFromColumn(t.getLineContent(n), i, e.tabSize) + s, d = t.getLineCount(), u = n === 1 && i === 1, f = n === d && i === t.getLineMaxColumn(n), p = o < n ? u : f;
    if (n = o, n < 1 ? (n = 1, a ? i = t.getLineMinColumn(n) : i = Math.min(t.getLineMaxColumn(n), i)) : n > d ? (n = d, a ? i = t.getLineMaxColumn(n) : i = Math.min(t.getLineMaxColumn(n), i)) : i = e.columnFromVisibleColumn(t, n, c), p ? s = 0 : s = c - zi.visibleColumnFromColumn(t.getLineContent(n), i, e.tabSize), l !== void 0) {
      const g = new le(n, i), m = t.normalizePosition(g, l);
      s = s + (i - m.column), n = m.lineNumber, i = m.column;
    }
    return new GE(n, i, s);
  }
  static down(e, t, n, i, s, o, a) {
    return this.vertical(
      e,
      t,
      n,
      i,
      s,
      n + o,
      a,
      4
      /* PositionAffinity.RightOfInjectedText */
    );
  }
  static moveDown(e, t, n, i, s) {
    let o, a;
    n.hasSelection() && !i ? (o = n.selection.endLineNumber, a = n.selection.endColumn) : (o = n.position.lineNumber, a = n.position.column);
    let l = 0, c;
    do
      if (c = dn.down(e, t, o + l, a, n.leftoverVisibleColumns, s, !0), t.normalizePosition(
        new le(c.lineNumber, c.column),
        2
        /* PositionAffinity.None */
      ).lineNumber > o)
        break;
    while (l++ < 10 && o + l < t.getLineCount());
    return n.move(i, c.lineNumber, c.column, c.leftoverVisibleColumns);
  }
  static translateDown(e, t, n) {
    const i = n.selection, s = dn.down(e, t, i.selectionStartLineNumber, i.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), o = dn.down(e, t, i.positionLineNumber, i.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new pr(new Q(s.lineNumber, s.column, s.lineNumber, s.column), 0, s.leftoverVisibleColumns, new le(o.lineNumber, o.column), o.leftoverVisibleColumns);
  }
  static up(e, t, n, i, s, o, a) {
    return this.vertical(
      e,
      t,
      n,
      i,
      s,
      n - o,
      a,
      3
      /* PositionAffinity.LeftOfInjectedText */
    );
  }
  static moveUp(e, t, n, i, s) {
    let o, a;
    n.hasSelection() && !i ? (o = n.selection.startLineNumber, a = n.selection.startColumn) : (o = n.position.lineNumber, a = n.position.column);
    const l = dn.up(e, t, o, a, n.leftoverVisibleColumns, s, !0);
    return n.move(i, l.lineNumber, l.column, l.leftoverVisibleColumns);
  }
  static translateUp(e, t, n) {
    const i = n.selection, s = dn.up(e, t, i.selectionStartLineNumber, i.selectionStartColumn, n.selectionStartLeftoverVisibleColumns, 1, !1), o = dn.up(e, t, i.positionLineNumber, i.positionColumn, n.leftoverVisibleColumns, 1, !1);
    return new pr(new Q(s.lineNumber, s.column, s.lineNumber, s.column), 0, s.leftoverVisibleColumns, new le(o.lineNumber, o.column), o.leftoverVisibleColumns);
  }
  static _isBlankLine(e, t) {
    return e.getLineFirstNonWhitespaceColumn(t) === 0;
  }
  static moveToPrevBlankLine(e, t, n, i) {
    let s = n.position.lineNumber;
    for (; s > 1 && this._isBlankLine(t, s); )
      s--;
    for (; s > 1 && !this._isBlankLine(t, s); )
      s--;
    return n.move(i, s, t.getLineMinColumn(s), 0);
  }
  static moveToNextBlankLine(e, t, n, i) {
    const s = t.getLineCount();
    let o = n.position.lineNumber;
    for (; o < s && this._isBlankLine(t, o); )
      o++;
    for (; o < s && !this._isBlankLine(t, o); )
      o++;
    return n.move(i, o, t.getLineMinColumn(o), 0);
  }
  static moveToBeginningOfLine(e, t, n, i) {
    const s = n.position.lineNumber, o = t.getLineMinColumn(s), a = t.getLineFirstNonWhitespaceColumn(s) || o;
    let l;
    return n.position.column === a ? l = o : l = a, n.move(i, s, l, 0);
  }
  static moveToEndOfLine(e, t, n, i, s) {
    const o = n.position.lineNumber, a = t.getLineMaxColumn(o);
    return n.move(i, o, a, s ? 1073741824 - a : 0);
  }
  static moveToBeginningOfBuffer(e, t, n, i) {
    return n.move(i, 1, 1, 0);
  }
  static moveToEndOfBuffer(e, t, n, i) {
    const s = t.getLineCount(), o = t.getLineMaxColumn(s);
    return n.move(i, s, o, 0);
  }
}
class Ef {
  static deleteRight(e, t, n, i) {
    const s = [];
    let o = e !== 3;
    for (let a = 0, l = i.length; a < l; a++) {
      const c = i[a];
      let d = c;
      if (d.isEmpty()) {
        const u = c.getPosition(), f = dn.right(t, n, u);
        d = new Q(f.lineNumber, f.column, u.lineNumber, u.column);
      }
      if (d.isEmpty()) {
        s[a] = null;
        continue;
      }
      d.startLineNumber !== d.endLineNumber && (o = !0), s[a] = new Vs(d, "");
    }
    return [o, s];
  }
  static isAutoClosingPairDelete(e, t, n, i, s, o, a) {
    if (t === "never" && n === "never" || e === "never")
      return !1;
    for (let l = 0, c = o.length; l < c; l++) {
      const d = o[l], u = d.getPosition();
      if (!d.isEmpty())
        return !1;
      const f = s.getLineContent(u.lineNumber);
      if (u.column < 2 || u.column >= f.length + 1)
        return !1;
      const p = f.charAt(u.column - 2), g = i.get(p);
      if (!g)
        return !1;
      if (f1(p)) {
        if (n === "never")
          return !1;
      } else if (t === "never")
        return !1;
      const m = f.charAt(u.column - 1);
      let A = !1;
      for (const w of g)
        w.open === p && w.close === m && (A = !0);
      if (!A)
        return !1;
      if (e === "auto") {
        let w = !1;
        for (let v = 0, y = a.length; v < y; v++) {
          const _ = a[v];
          if (u.lineNumber === _.startLineNumber && u.column === _.startColumn) {
            w = !0;
            break;
          }
        }
        if (!w)
          return !1;
      }
    }
    return !0;
  }
  static _runAutoClosingPairDelete(e, t, n) {
    const i = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s].getPosition(), l = new Q(a.lineNumber, a.column - 1, a.lineNumber, a.column + 1);
      i[s] = new Vs(l, "");
    }
    return [!0, i];
  }
  static deleteLeft(e, t, n, i, s) {
    if (this.isAutoClosingPairDelete(t.autoClosingDelete, t.autoClosingBrackets, t.autoClosingQuotes, t.autoClosingPairs.autoClosingPairsOpenByEnd, n, i, s))
      return this._runAutoClosingPairDelete(t, n, i);
    const o = [];
    let a = e !== 2;
    for (let l = 0, c = i.length; l < c; l++) {
      const d = Ef.getDeleteRange(i[l], n, t);
      if (d.isEmpty()) {
        o[l] = null;
        continue;
      }
      d.startLineNumber !== d.endLineNumber && (a = !0), o[l] = new Vs(d, "");
    }
    return [a, o];
  }
  static getDeleteRange(e, t, n) {
    if (!e.isEmpty())
      return e;
    const i = e.getPosition();
    if (n.useTabStops && i.column > 1) {
      const s = t.getLineContent(i.lineNumber), o = so(s), a = o === -1 ? (
        /* entire string is whitespace */
        s.length + 1
      ) : o + 1;
      if (i.column <= a) {
        const l = n.visibleColumnFromColumn(t, i), c = zi.prevIndentTabStop(l, n.indentSize), d = n.columnFromVisibleColumn(t, i.lineNumber, c);
        return new Q(i.lineNumber, d, i.lineNumber, i.column);
      }
    }
    return Q.fromPositions(Ef.getPositionAfterDeleteLeft(i, t), i);
  }
  static getPositionAfterDeleteLeft(e, t) {
    if (e.column > 1) {
      const n = I0t(e.column - 1, t.getLineContent(e.lineNumber));
      return e.with(void 0, n + 1);
    } else if (e.lineNumber > 1) {
      const n = e.lineNumber - 1;
      return new le(n, t.getLineMaxColumn(n));
    } else
      return e;
  }
  static cut(e, t, n) {
    const i = [];
    let s = null;
    n.sort((o, a) => le.compare(o.getStartPosition(), a.getEndPosition()));
    for (let o = 0, a = n.length; o < a; o++) {
      const l = n[o];
      if (l.isEmpty())
        if (e.emptySelectionClipboard) {
          const c = l.getPosition();
          let d, u, f, p;
          c.lineNumber < t.getLineCount() ? (d = c.lineNumber, u = 1, f = c.lineNumber + 1, p = 1) : c.lineNumber > 1 && s?.endLineNumber !== c.lineNumber ? (d = c.lineNumber - 1, u = t.getLineMaxColumn(c.lineNumber - 1), f = c.lineNumber, p = t.getLineMaxColumn(c.lineNumber)) : (d = c.lineNumber, u = 1, f = c.lineNumber, p = t.getLineMaxColumn(c.lineNumber));
          const g = new Q(d, u, f, p);
          s = g, g.isEmpty() ? i[o] = null : i[o] = new Vs(g, "");
        } else
          i[o] = null;
      else
        i[o] = new Vs(l, "");
    }
    return new js(0, i, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
}
class bi {
  static _createWord(e, t, n, i, s) {
    return { start: i, end: s, wordType: t, nextCharClass: n };
  }
  static _createIntlWord(e, t) {
    return { start: e.index, end: e.index + e.segment.length, wordType: 1, nextCharClass: t };
  }
  static _findPreviousWordOnLine(e, t, n) {
    const i = t.getLineContent(n.lineNumber);
    return this._doFindPreviousWordOnLine(i, e, n);
  }
  static _doFindPreviousWordOnLine(e, t, n) {
    let i = 0;
    const s = t.findPrevIntlWordBeforeOrAtOffset(e, n.column - 2);
    for (let o = n.column - 2; o >= 0; o--) {
      const a = e.charCodeAt(o), l = t.get(a);
      if (s && o === s.index)
        return this._createIntlWord(s, l);
      if (l === 0) {
        if (i === 2)
          return this._createWord(e, i, l, o + 1, this._findEndOfWord(e, t, i, o + 1));
        i = 1;
      } else if (l === 2) {
        if (i === 1)
          return this._createWord(e, i, l, o + 1, this._findEndOfWord(e, t, i, o + 1));
        i = 2;
      } else if (l === 1 && i !== 0)
        return this._createWord(e, i, l, o + 1, this._findEndOfWord(e, t, i, o + 1));
    }
    return i !== 0 ? this._createWord(e, i, 1, 0, this._findEndOfWord(e, t, i, 0)) : null;
  }
  static _findEndOfWord(e, t, n, i) {
    const s = t.findNextIntlWordAtOrAfterOffset(e, i), o = e.length;
    for (let a = i; a < o; a++) {
      const l = e.charCodeAt(a), c = t.get(l);
      if (s && a === s.index + s.segment.length || c === 1 || n === 1 && c === 2 || n === 2 && c === 0)
        return a;
    }
    return o;
  }
  static _findNextWordOnLine(e, t, n) {
    const i = t.getLineContent(n.lineNumber);
    return this._doFindNextWordOnLine(i, e, n);
  }
  static _doFindNextWordOnLine(e, t, n) {
    let i = 0;
    const s = e.length, o = t.findNextIntlWordAtOrAfterOffset(e, n.column - 1);
    for (let a = n.column - 1; a < s; a++) {
      const l = e.charCodeAt(a), c = t.get(l);
      if (o && a === o.index)
        return this._createIntlWord(o, c);
      if (c === 0) {
        if (i === 2)
          return this._createWord(e, i, c, this._findStartOfWord(e, t, i, a - 1), a);
        i = 1;
      } else if (c === 2) {
        if (i === 1)
          return this._createWord(e, i, c, this._findStartOfWord(e, t, i, a - 1), a);
        i = 2;
      } else if (c === 1 && i !== 0)
        return this._createWord(e, i, c, this._findStartOfWord(e, t, i, a - 1), a);
    }
    return i !== 0 ? this._createWord(e, i, 1, this._findStartOfWord(e, t, i, s - 1), s) : null;
  }
  static _findStartOfWord(e, t, n, i) {
    const s = t.findPrevIntlWordBeforeOrAtOffset(e, i);
    for (let o = i; o >= 0; o--) {
      const a = e.charCodeAt(o), l = t.get(a);
      if (s && o === s.index)
        return o;
      if (l === 1 || n === 1 && l === 2 || n === 2 && l === 0)
        return o + 1;
    }
    return 0;
  }
  static moveWordLeft(e, t, n, i, s) {
    let o = n.lineNumber, a = n.column;
    a === 1 && o > 1 && (o = o - 1, a = t.getLineMaxColumn(o));
    let l = bi._findPreviousWordOnLine(e, t, new le(o, a));
    if (i === 0)
      return new le(o, l ? l.start + 1 : 1);
    if (i === 1)
      return !s && l && l.wordType === 2 && l.end - l.start === 1 && l.nextCharClass === 0 && (l = bi._findPreviousWordOnLine(e, t, new le(o, l.start + 1))), new le(o, l ? l.start + 1 : 1);
    if (i === 3) {
      for (; l && l.wordType === 2; )
        l = bi._findPreviousWordOnLine(e, t, new le(o, l.start + 1));
      return new le(o, l ? l.start + 1 : 1);
    }
    return l && a <= l.end + 1 && (l = bi._findPreviousWordOnLine(e, t, new le(o, l.start + 1))), new le(o, l ? l.end + 1 : 1);
  }
  static _moveWordPartLeft(e, t) {
    const n = t.lineNumber, i = e.getLineMaxColumn(n);
    if (t.column === 1)
      return n > 1 ? new le(n - 1, e.getLineMaxColumn(n - 1)) : t;
    const s = e.getLineContent(n);
    for (let o = t.column - 1; o > 1; o--) {
      const a = s.charCodeAt(o - 2), l = s.charCodeAt(o - 1);
      if (a === 95 && l !== 95)
        return new le(n, o);
      if (a === 45 && l !== 45)
        return new le(n, o);
      if ((G2(a) || xv(a)) && gu(l))
        return new le(n, o);
      if (gu(a) && gu(l) && o + 1 < i) {
        const c = s.charCodeAt(o);
        if (G2(c) || xv(c))
          return new le(n, o);
      }
    }
    return new le(n, 1);
  }
  static moveWordRight(e, t, n, i) {
    let s = n.lineNumber, o = n.column, a = !1;
    o === t.getLineMaxColumn(s) && s < t.getLineCount() && (a = !0, s = s + 1, o = 1);
    let l = bi._findNextWordOnLine(e, t, new le(s, o));
    if (i === 2)
      l && l.wordType === 2 && l.end - l.start === 1 && l.nextCharClass === 0 && (l = bi._findNextWordOnLine(e, t, new le(s, l.end + 1))), l ? o = l.end + 1 : o = t.getLineMaxColumn(s);
    else if (i === 3) {
      for (a && (o = 0); l && (l.wordType === 2 || l.start + 1 <= o); )
        l = bi._findNextWordOnLine(e, t, new le(s, l.end + 1));
      l ? o = l.start + 1 : o = t.getLineMaxColumn(s);
    } else
      l && !a && o >= l.start + 1 && (l = bi._findNextWordOnLine(e, t, new le(s, l.end + 1))), l ? o = l.start + 1 : o = t.getLineMaxColumn(s);
    return new le(s, o);
  }
  static _moveWordPartRight(e, t) {
    const n = t.lineNumber, i = e.getLineMaxColumn(n);
    if (t.column === i)
      return n < e.getLineCount() ? new le(n + 1, 1) : t;
    const s = e.getLineContent(n);
    for (let o = t.column + 1; o < i; o++) {
      const a = s.charCodeAt(o - 2), l = s.charCodeAt(o - 1);
      if (a !== 95 && l === 95)
        return new le(n, o);
      if (a !== 45 && l === 45)
        return new le(n, o);
      if ((G2(a) || xv(a)) && gu(l))
        return new le(n, o);
      if (gu(a) && gu(l) && o + 1 < i) {
        const c = s.charCodeAt(o);
        if (G2(c) || xv(c))
          return new le(n, o);
      }
    }
    return new le(n, i);
  }
  static _deleteWordLeftWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), i = t.column - 2, s = Zf(n, i);
    return s + 1 < i ? new Q(t.lineNumber, s + 2, t.lineNumber, t.column) : null;
  }
  static deleteWordLeft(e, t) {
    const n = e.wordSeparators, i = e.model, s = e.selection, o = e.whitespaceHeuristics;
    if (!s.isEmpty())
      return s;
    if (Ef.isAutoClosingPairDelete(e.autoClosingDelete, e.autoClosingBrackets, e.autoClosingQuotes, e.autoClosingPairs.autoClosingPairsOpenByEnd, e.model, [e.selection], e.autoClosedCharacters)) {
      const u = e.selection.getPosition();
      return new Q(u.lineNumber, u.column - 1, u.lineNumber, u.column + 1);
    }
    const a = new le(s.positionLineNumber, s.positionColumn);
    let l = a.lineNumber, c = a.column;
    if (l === 1 && c === 1)
      return null;
    if (o) {
      const u = this._deleteWordLeftWhitespace(i, a);
      if (u)
        return u;
    }
    let d = bi._findPreviousWordOnLine(n, i, a);
    return t === 0 ? d ? c = d.start + 1 : c > 1 ? c = 1 : (l--, c = i.getLineMaxColumn(l)) : (d && c <= d.end + 1 && (d = bi._findPreviousWordOnLine(n, i, new le(l, d.start + 1))), d ? c = d.end + 1 : c > 1 ? c = 1 : (l--, c = i.getLineMaxColumn(l))), new Q(l, c, a.lineNumber, a.column);
  }
  static deleteInsideWord(e, t, n) {
    if (!n.isEmpty())
      return n;
    const i = new le(n.positionLineNumber, n.positionColumn), s = this._deleteInsideWordWhitespace(t, i);
    return s || this._deleteInsideWordDetermineDeleteRange(e, t, i);
  }
  static _charAtIsWhitespace(e, t) {
    const n = e.charCodeAt(t);
    return n === 32 || n === 9;
  }
  static _deleteInsideWordWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), i = n.length;
    if (i === 0)
      return null;
    let s = Math.max(t.column - 2, 0);
    if (!this._charAtIsWhitespace(n, s))
      return null;
    let o = Math.min(t.column - 1, i - 1);
    if (!this._charAtIsWhitespace(n, o))
      return null;
    for (; s > 0 && this._charAtIsWhitespace(n, s - 1); )
      s--;
    for (; o + 1 < i && this._charAtIsWhitespace(n, o + 1); )
      o++;
    return new Q(t.lineNumber, s + 1, t.lineNumber, o + 2);
  }
  static _deleteInsideWordDetermineDeleteRange(e, t, n) {
    const i = t.getLineContent(n.lineNumber), s = i.length;
    if (s === 0)
      return n.lineNumber > 1 ? new Q(n.lineNumber - 1, t.getLineMaxColumn(n.lineNumber - 1), n.lineNumber, 1) : n.lineNumber < t.getLineCount() ? new Q(n.lineNumber, 1, n.lineNumber + 1, 1) : new Q(n.lineNumber, 1, n.lineNumber, 1);
    const o = (u) => u.start + 1 <= n.column && n.column <= u.end + 1, a = (u, f) => (u = Math.min(u, n.column), f = Math.max(f, n.column), new Q(n.lineNumber, u, n.lineNumber, f)), l = (u) => {
      let f = u.start + 1, p = u.end + 1, g = !1;
      for (; p - 1 < s && this._charAtIsWhitespace(i, p - 1); )
        g = !0, p++;
      if (!g)
        for (; f > 1 && this._charAtIsWhitespace(i, f - 2); )
          f--;
      return a(f, p);
    }, c = bi._findPreviousWordOnLine(e, t, n);
    if (c && o(c))
      return l(c);
    const d = bi._findNextWordOnLine(e, t, n);
    return d && o(d) ? l(d) : c && d ? a(c.end + 1, d.start + 1) : c ? a(c.start + 1, c.end + 1) : d ? a(d.start + 1, d.end + 1) : a(1, s + 1);
  }
  static _deleteWordPartLeft(e, t) {
    if (!t.isEmpty())
      return t;
    const n = t.getPosition(), i = bi._moveWordPartLeft(e, n);
    return new Q(n.lineNumber, n.column, i.lineNumber, i.column);
  }
  static _findFirstNonWhitespaceChar(e, t) {
    const n = e.length;
    for (let i = t; i < n; i++) {
      const s = e.charAt(i);
      if (s !== " " && s !== "	")
        return i;
    }
    return n;
  }
  static _deleteWordRightWhitespace(e, t) {
    const n = e.getLineContent(t.lineNumber), i = t.column - 1, s = this._findFirstNonWhitespaceChar(n, i);
    return i + 1 < s ? new Q(t.lineNumber, t.column, t.lineNumber, s + 1) : null;
  }
  static deleteWordRight(e, t) {
    const n = e.wordSeparators, i = e.model, s = e.selection, o = e.whitespaceHeuristics;
    if (!s.isEmpty())
      return s;
    const a = new le(s.positionLineNumber, s.positionColumn);
    let l = a.lineNumber, c = a.column;
    const d = i.getLineCount(), u = i.getLineMaxColumn(l);
    if (l === d && c === u)
      return null;
    if (o) {
      const p = this._deleteWordRightWhitespace(i, a);
      if (p)
        return p;
    }
    let f = bi._findNextWordOnLine(n, i, a);
    return t === 2 ? f ? c = f.end + 1 : c < u || l === d ? c = u : (l++, f = bi._findNextWordOnLine(n, i, new le(l, 1)), f ? c = f.start + 1 : c = i.getLineMaxColumn(l)) : (f && c >= f.start + 1 && (f = bi._findNextWordOnLine(n, i, new le(l, f.end + 1))), f ? c = f.start + 1 : c < u || l === d ? c = u : (l++, f = bi._findNextWordOnLine(n, i, new le(l, 1)), f ? c = f.start + 1 : c = i.getLineMaxColumn(l))), new Q(l, c, a.lineNumber, a.column);
  }
  static _deleteWordPartRight(e, t) {
    if (!t.isEmpty())
      return t;
    const n = t.getPosition(), i = bi._moveWordPartRight(e, n);
    return new Q(n.lineNumber, n.column, i.lineNumber, i.column);
  }
  static _createWordAtPosition(e, t, n) {
    const i = new Q(t, n.start + 1, t, n.end + 1);
    return {
      word: e.getValueInRange(i),
      startColumn: i.startColumn,
      endColumn: i.endColumn
    };
  }
  static getWordAtPosition(e, t, n, i) {
    const s = lg(t, n), o = bi._findPreviousWordOnLine(s, e, i);
    if (o && o.wordType === 1 && o.start <= i.column - 1 && i.column - 1 <= o.end)
      return bi._createWordAtPosition(e, i.lineNumber, o);
    const a = bi._findNextWordOnLine(s, e, i);
    return a && a.wordType === 1 && a.start <= i.column - 1 && i.column - 1 <= a.end ? bi._createWordAtPosition(e, i.lineNumber, a) : null;
  }
  static word(e, t, n, i, s) {
    const o = lg(e.wordSeparators, e.wordSegmenterLocales), a = bi._findPreviousWordOnLine(o, t, s), l = bi._findNextWordOnLine(o, t, s);
    if (!i) {
      let p, g;
      return a && a.wordType === 1 && a.start <= s.column - 1 && s.column - 1 <= a.end ? (p = a.start + 1, g = a.end + 1) : l && l.wordType === 1 && l.start <= s.column - 1 && s.column - 1 <= l.end ? (p = l.start + 1, g = l.end + 1) : (a ? p = a.end + 1 : p = 1, l ? g = l.start + 1 : g = t.getLineMaxColumn(s.lineNumber)), new pr(new Q(s.lineNumber, p, s.lineNumber, g), 1, 0, new le(s.lineNumber, g), 0);
    }
    let c, d;
    a && a.wordType === 1 && a.start < s.column - 1 && s.column - 1 < a.end ? (c = a.start + 1, d = a.end + 1) : l && l.wordType === 1 && l.start < s.column - 1 && s.column - 1 < l.end ? (c = l.start + 1, d = l.end + 1) : (c = s.column, d = s.column);
    const u = s.lineNumber;
    let f;
    if (n.selectionStart.containsPosition(s))
      f = n.selectionStart.endColumn;
    else if (s.isBeforeOrEqual(n.selectionStart.getStartPosition())) {
      f = c;
      const p = new le(u, f);
      n.selectionStart.containsPosition(p) && (f = n.selectionStart.endColumn);
    } else {
      f = d;
      const p = new le(u, f);
      n.selectionStart.containsPosition(p) && (f = n.selectionStart.startColumn);
    }
    return n.move(!0, u, f, 0);
  }
}
class Kr {
  static addCursorDown(e, t, n) {
    const i = [];
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      i[s++] = new Dt(l.modelState, l.viewState), n ? i[s++] = Dt.fromModelState(dn.translateDown(e.cursorConfig, e.model, l.modelState)) : i[s++] = Dt.fromViewState(dn.translateDown(e.cursorConfig, e, l.viewState));
    }
    return i;
  }
  static addCursorUp(e, t, n) {
    const i = [];
    let s = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      i[s++] = new Dt(l.modelState, l.viewState), n ? i[s++] = Dt.fromModelState(dn.translateUp(e.cursorConfig, e.model, l.modelState)) : i[s++] = Dt.fromViewState(dn.translateUp(e.cursorConfig, e, l.viewState));
    }
    return i;
  }
  static moveToBeginningOfLine(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      i[s] = this._moveToLineStart(e, a, n);
    }
    return i;
  }
  static _moveToLineStart(e, t, n) {
    const i = t.viewState.position.column, s = t.modelState.position.column, o = i === s, a = t.viewState.position.lineNumber, l = e.getLineFirstNonWhitespaceColumn(a);
    return !o && !(i === l) ? this._moveToLineStartByView(e, t, n) : this._moveToLineStartByModel(e, t, n);
  }
  static _moveToLineStartByView(e, t, n) {
    return Dt.fromViewState(dn.moveToBeginningOfLine(e.cursorConfig, e, t.viewState, n));
  }
  static _moveToLineStartByModel(e, t, n) {
    return Dt.fromModelState(dn.moveToBeginningOfLine(e.cursorConfig, e.model, t.modelState, n));
  }
  static moveToEndOfLine(e, t, n, i) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = this._moveToLineEnd(e, l, n, i);
    }
    return s;
  }
  static _moveToLineEnd(e, t, n, i) {
    const s = t.viewState.position, o = e.getLineMaxColumn(s.lineNumber), a = s.column === o, l = t.modelState.position, c = e.model.getLineMaxColumn(l.lineNumber), d = o - s.column === c - l.column;
    return a || d ? this._moveToLineEndByModel(e, t, n, i) : this._moveToLineEndByView(e, t, n, i);
  }
  static _moveToLineEndByView(e, t, n, i) {
    return Dt.fromViewState(dn.moveToEndOfLine(e.cursorConfig, e, t.viewState, n, i));
  }
  static _moveToLineEndByModel(e, t, n, i) {
    return Dt.fromModelState(dn.moveToEndOfLine(e.cursorConfig, e.model, t.modelState, n, i));
  }
  static expandLineSelection(e, t) {
    const n = [];
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i], a = o.modelState.selection.startLineNumber, l = e.model.getLineCount();
      let c = o.modelState.selection.endLineNumber, d;
      c === l ? d = e.model.getLineMaxColumn(l) : (c++, d = 1), n[i] = Dt.fromModelState(new pr(new Q(a, 1, a, 1), 0, 0, new le(c, d), 0));
    }
    return n;
  }
  static moveToBeginningOfBuffer(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      i[s] = Dt.fromModelState(dn.moveToBeginningOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return i;
  }
  static moveToEndOfBuffer(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      i[s] = Dt.fromModelState(dn.moveToEndOfBuffer(e.cursorConfig, e.model, a.modelState, n));
    }
    return i;
  }
  static selectAll(e, t) {
    const n = e.model.getLineCount(), i = e.model.getLineMaxColumn(n);
    return Dt.fromModelState(new pr(new Q(1, 1, 1, 1), 0, 0, new le(n, i), 0));
  }
  static line(e, t, n, i, s) {
    const o = e.model.validatePosition(i), a = s ? e.coordinatesConverter.validateViewPosition(new le(s.lineNumber, s.column), o) : e.coordinatesConverter.convertModelPositionToViewPosition(o);
    if (!n) {
      const c = e.model.getLineCount();
      let d = o.lineNumber + 1, u = 1;
      return d > c && (d = c, u = e.model.getLineMaxColumn(d)), Dt.fromModelState(new pr(new Q(o.lineNumber, 1, d, u), 2, 0, new le(d, u), 0));
    }
    const l = t.modelState.selectionStart.getStartPosition().lineNumber;
    if (o.lineNumber < l)
      return Dt.fromViewState(t.viewState.move(!0, a.lineNumber, 1, 0));
    if (o.lineNumber > l) {
      const c = e.getLineCount();
      let d = a.lineNumber + 1, u = 1;
      return d > c && (d = c, u = e.getLineMaxColumn(d)), Dt.fromViewState(t.viewState.move(!0, d, u, 0));
    } else {
      const c = t.modelState.selectionStart.getEndPosition();
      return Dt.fromModelState(t.modelState.move(!0, c.lineNumber, c.column, 0));
    }
  }
  static word(e, t, n, i) {
    const s = e.model.validatePosition(i);
    return Dt.fromModelState(bi.word(e.cursorConfig, e.model, t.modelState, n, s));
  }
  static cancelSelection(e, t) {
    if (!t.modelState.hasSelection())
      return new Dt(t.modelState, t.viewState);
    const n = t.viewState.position.lineNumber, i = t.viewState.position.column;
    return Dt.fromViewState(new pr(new Q(n, i, n, i), 0, 0, new le(n, i), 0));
  }
  static moveTo(e, t, n, i, s) {
    if (n) {
      if (t.modelState.selectionStartKind === 1)
        return this.word(e, t, n, i);
      if (t.modelState.selectionStartKind === 2)
        return this.line(e, t, n, i, s);
    }
    const o = e.model.validatePosition(i), a = s ? e.coordinatesConverter.validateViewPosition(new le(s.lineNumber, s.column), o) : e.coordinatesConverter.convertModelPositionToViewPosition(o);
    return Dt.fromViewState(t.viewState.move(n, a.lineNumber, a.column, 0));
  }
  static simpleMove(e, t, n, i, s, o) {
    switch (n) {
      case 0:
        return o === 4 ? this._moveHalfLineLeft(e, t, i) : this._moveLeft(e, t, i, s);
      case 1:
        return o === 4 ? this._moveHalfLineRight(e, t, i) : this._moveRight(e, t, i, s);
      case 2:
        return o === 2 ? this._moveUpByViewLines(e, t, i, s) : this._moveUpByModelLines(e, t, i, s);
      case 3:
        return o === 2 ? this._moveDownByViewLines(e, t, i, s) : this._moveDownByModelLines(e, t, i, s);
      case 4:
        return o === 2 ? t.map((a) => Dt.fromViewState(dn.moveToPrevBlankLine(e.cursorConfig, e, a.viewState, i))) : t.map((a) => Dt.fromModelState(dn.moveToPrevBlankLine(e.cursorConfig, e.model, a.modelState, i)));
      case 5:
        return o === 2 ? t.map((a) => Dt.fromViewState(dn.moveToNextBlankLine(e.cursorConfig, e, a.viewState, i))) : t.map((a) => Dt.fromModelState(dn.moveToNextBlankLine(e.cursorConfig, e.model, a.modelState, i)));
      case 6:
        return this._moveToViewMinColumn(e, t, i);
      case 7:
        return this._moveToViewFirstNonWhitespaceColumn(e, t, i);
      case 8:
        return this._moveToViewCenterColumn(e, t, i);
      case 9:
        return this._moveToViewMaxColumn(e, t, i);
      case 10:
        return this._moveToViewLastNonWhitespaceColumn(e, t, i);
      default:
        return null;
    }
  }
  static viewportMove(e, t, n, i, s) {
    const o = e.getCompletelyVisibleViewRange(), a = e.coordinatesConverter.convertViewRangeToModelRange(o);
    switch (n) {
      case 11: {
        const l = this._firstLineNumberInRange(e.model, a, s), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], i, l, c)];
      }
      case 13: {
        const l = this._lastLineNumberInRange(e.model, a, s), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], i, l, c)];
      }
      case 12: {
        const l = Math.round((a.startLineNumber + a.endLineNumber) / 2), c = e.model.getLineFirstNonWhitespaceColumn(l);
        return [this._moveToModelPosition(e, t[0], i, l, c)];
      }
      case 14: {
        const l = [];
        for (let c = 0, d = t.length; c < d; c++) {
          const u = t[c];
          l[c] = this.findPositionInViewportIfOutside(e, u, o, i);
        }
        return l;
      }
      default:
        return null;
    }
  }
  static findPositionInViewportIfOutside(e, t, n, i) {
    const s = t.viewState.position.lineNumber;
    if (n.startLineNumber <= s && s <= n.endLineNumber - 1)
      return new Dt(t.modelState, t.viewState);
    {
      let o;
      s > n.endLineNumber - 1 ? o = n.endLineNumber - 1 : s < n.startLineNumber ? o = n.startLineNumber : o = s;
      const a = dn.vertical(e.cursorConfig, e, s, t.viewState.position.column, t.viewState.leftoverVisibleColumns, o, !1);
      return Dt.fromViewState(t.viewState.move(i, a.lineNumber, a.column, a.leftoverVisibleColumns));
    }
  }
  /**
   * Find the nth line start included in the range (from the start).
   */
  static _firstLineNumberInRange(e, t, n) {
    let i = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(i) && i++, Math.min(t.endLineNumber, i + n - 1);
  }
  /**
   * Find the nth line start included in the range (from the end).
   */
  static _lastLineNumberInRange(e, t, n) {
    let i = t.startLineNumber;
    return t.startColumn !== e.getLineMinColumn(i) && i++, Math.max(i, t.endLineNumber - n + 1);
  }
  static _moveLeft(e, t, n, i) {
    return t.map((s) => Dt.fromViewState(dn.moveLeft(e.cursorConfig, e, s.viewState, n, i)));
  }
  static _moveHalfLineLeft(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round(e.getLineLength(l) / 2);
      i[s] = Dt.fromViewState(dn.moveLeft(e.cursorConfig, e, a.viewState, n, c));
    }
    return i;
  }
  static _moveRight(e, t, n, i) {
    return t.map((s) => Dt.fromViewState(dn.moveRight(e.cursorConfig, e, s.viewState, n, i)));
  }
  static _moveHalfLineRight(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round(e.getLineLength(l) / 2);
      i[s] = Dt.fromViewState(dn.moveRight(e.cursorConfig, e, a.viewState, n, c));
    }
    return i;
  }
  static _moveDownByViewLines(e, t, n, i) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = Dt.fromViewState(dn.moveDown(e.cursorConfig, e, l.viewState, n, i));
    }
    return s;
  }
  static _moveDownByModelLines(e, t, n, i) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = Dt.fromModelState(dn.moveDown(e.cursorConfig, e.model, l.modelState, n, i));
    }
    return s;
  }
  static _moveUpByViewLines(e, t, n, i) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = Dt.fromViewState(dn.moveUp(e.cursorConfig, e, l.viewState, n, i));
    }
    return s;
  }
  static _moveUpByModelLines(e, t, n, i) {
    const s = [];
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      s[o] = Dt.fromModelState(dn.moveUp(e.cursorConfig, e.model, l.modelState, n, i));
    }
    return s;
  }
  static _moveToViewPosition(e, t, n, i, s) {
    return Dt.fromViewState(t.viewState.move(n, i, s, 0));
  }
  static _moveToModelPosition(e, t, n, i, s) {
    return Dt.fromModelState(t.modelState.move(n, i, s, 0));
  }
  static _moveToViewMinColumn(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineMinColumn(l);
      i[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return i;
  }
  static _moveToViewFirstNonWhitespaceColumn(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineFirstNonWhitespaceColumn(l);
      i[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return i;
  }
  static _moveToViewCenterColumn(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = Math.round((e.getLineMaxColumn(l) + e.getLineMinColumn(l)) / 2);
      i[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return i;
  }
  static _moveToViewMaxColumn(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineMaxColumn(l);
      i[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return i;
  }
  static _moveToViewLastNonWhitespaceColumn(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.viewState.position.lineNumber, c = e.getLineLastNonWhitespaceColumn(l);
      i[s] = this._moveToViewPosition(e, a, n, l, c);
    }
    return i;
  }
}
var c9;
(function(r) {
  const e = function(n) {
    if (!Rs(n))
      return !1;
    const i = n;
    return !(!Vo(i.to) || !da(i.select) && !MMe(i.select) || !da(i.by) && !Vo(i.by) || !da(i.value) && !Kg(i.value));
  };
  r.metadata = {
    description: "Move cursor to a logical position in the view",
    args: [
      {
        name: "Cursor move argument object",
        description: `Property-value pairs that can be passed through this argument:
					* 'to': A mandatory logical position value providing where to move the cursor.
						\`\`\`
						'left', 'right', 'up', 'down', 'prevBlankLine', 'nextBlankLine',
						'wrappedLineStart', 'wrappedLineEnd', 'wrappedLineColumnCenter'
						'wrappedLineFirstNonWhitespaceCharacter', 'wrappedLineLastNonWhitespaceCharacter'
						'viewPortTop', 'viewPortCenter', 'viewPortBottom', 'viewPortIfOutside'
						\`\`\`
					* 'by': Unit to move. Default is computed based on 'to' value.
						\`\`\`
						'line', 'wrappedLine', 'character', 'halfLine'
						\`\`\`
					* 'value': Number of units to move. Default is '1'.
					* 'select': If 'true' makes the selection. Default is 'false'.
				`,
        constraint: e,
        schema: {
          type: "object",
          required: ["to"],
          properties: {
            to: {
              type: "string",
              enum: ["left", "right", "up", "down", "prevBlankLine", "nextBlankLine", "wrappedLineStart", "wrappedLineEnd", "wrappedLineColumnCenter", "wrappedLineFirstNonWhitespaceCharacter", "wrappedLineLastNonWhitespaceCharacter", "viewPortTop", "viewPortCenter", "viewPortBottom", "viewPortIfOutside"]
            },
            by: {
              type: "string",
              enum: ["line", "wrappedLine", "character", "halfLine"]
            },
            value: {
              type: "number",
              default: 1
            },
            select: {
              type: "boolean",
              default: !1
            }
          }
        }
      }
    ]
  }, r.RawDirection = {
    Left: "left",
    Right: "right",
    Up: "up",
    Down: "down",
    PrevBlankLine: "prevBlankLine",
    NextBlankLine: "nextBlankLine",
    WrappedLineStart: "wrappedLineStart",
    WrappedLineFirstNonWhitespaceCharacter: "wrappedLineFirstNonWhitespaceCharacter",
    WrappedLineColumnCenter: "wrappedLineColumnCenter",
    WrappedLineEnd: "wrappedLineEnd",
    WrappedLineLastNonWhitespaceCharacter: "wrappedLineLastNonWhitespaceCharacter",
    ViewPortTop: "viewPortTop",
    ViewPortCenter: "viewPortCenter",
    ViewPortBottom: "viewPortBottom",
    ViewPortIfOutside: "viewPortIfOutside"
  }, r.RawUnit = {
    Line: "line",
    WrappedLine: "wrappedLine",
    Character: "character",
    HalfLine: "halfLine"
  };
  function t(n) {
    if (!n.to)
      return null;
    let i;
    switch (n.to) {
      case r.RawDirection.Left:
        i = 0;
        break;
      case r.RawDirection.Right:
        i = 1;
        break;
      case r.RawDirection.Up:
        i = 2;
        break;
      case r.RawDirection.Down:
        i = 3;
        break;
      case r.RawDirection.PrevBlankLine:
        i = 4;
        break;
      case r.RawDirection.NextBlankLine:
        i = 5;
        break;
      case r.RawDirection.WrappedLineStart:
        i = 6;
        break;
      case r.RawDirection.WrappedLineFirstNonWhitespaceCharacter:
        i = 7;
        break;
      case r.RawDirection.WrappedLineColumnCenter:
        i = 8;
        break;
      case r.RawDirection.WrappedLineEnd:
        i = 9;
        break;
      case r.RawDirection.WrappedLineLastNonWhitespaceCharacter:
        i = 10;
        break;
      case r.RawDirection.ViewPortTop:
        i = 11;
        break;
      case r.RawDirection.ViewPortBottom:
        i = 13;
        break;
      case r.RawDirection.ViewPortCenter:
        i = 12;
        break;
      case r.RawDirection.ViewPortIfOutside:
        i = 14;
        break;
      default:
        return null;
    }
    let s = 0;
    switch (n.by) {
      case r.RawUnit.Line:
        s = 1;
        break;
      case r.RawUnit.WrappedLine:
        s = 2;
        break;
      case r.RawUnit.Character:
        s = 3;
        break;
      case r.RawUnit.HalfLine:
        s = 4;
        break;
    }
    return {
      direction: i,
      unit: s,
      select: !!n.select,
      value: n.value || 1
    };
  }
  r.parse = t;
})(c9 || (c9 = {}));
class q4t {
  constructor(e, t, n) {
    this._indentRulesSupport = t, this._indentationLineProcessor = new dke(e, n);
  }
  /**
   * Apply the new indentation and return whether the indentation level should be increased after the given line number
   */
  shouldIncrease(e, t) {
    const n = this._indentationLineProcessor.getProcessedLine(e, t);
    return this._indentRulesSupport.shouldIncrease(n);
  }
  /**
   * Apply the new indentation and return whether the indentation level should be decreased after the given line number
   */
  shouldDecrease(e, t) {
    const n = this._indentationLineProcessor.getProcessedLine(e, t);
    return this._indentRulesSupport.shouldDecrease(n);
  }
  /**
   * Apply the new indentation and return whether the indentation level should remain unchanged at the given line number
   */
  shouldIgnore(e, t) {
    const n = this._indentationLineProcessor.getProcessedLine(e, t);
    return this._indentRulesSupport.shouldIgnore(n);
  }
  /**
   * Apply the new indentation and return whether the indentation level should increase on the line after the given line number
   */
  shouldIndentNextLine(e, t) {
    const n = this._indentationLineProcessor.getProcessedLine(e, t);
    return this._indentRulesSupport.shouldIndentNextLine(n);
  }
}
class TO {
  constructor(e, t) {
    this.model = e, this.indentationLineProcessor = new dke(e, t);
  }
  /**
   * Returns the processed text, stripped from the language configuration brackets within the string, comment and regex tokens, around the given range
   */
  getProcessedTokenContextAroundRange(e) {
    const t = this._getProcessedTokensBeforeRange(e), n = this._getProcessedTokensAfterRange(e), i = this._getProcessedPreviousLineTokens(e);
    return { beforeRangeProcessedTokens: t, afterRangeProcessedTokens: n, previousLineProcessedTokens: i };
  }
  _getProcessedTokensBeforeRange(e) {
    this.model.tokenization.forceTokenization(e.startLineNumber);
    const t = this.model.tokenization.getLineTokens(e.startLineNumber), n = I0(t, e.startColumn - 1);
    let i;
    if (IO(this.model, e.getStartPosition())) {
      const o = e.startColumn - 1 - n.firstCharOffset, a = n.firstCharOffset, l = a + o;
      i = t.sliceAndInflate(a, l, 0);
    } else {
      const o = e.startColumn - 1;
      i = t.sliceAndInflate(0, o, 0);
    }
    return this.indentationLineProcessor.getProcessedTokens(i);
  }
  _getProcessedTokensAfterRange(e) {
    const t = e.isEmpty() ? e.getStartPosition() : e.getEndPosition();
    this.model.tokenization.forceTokenization(t.lineNumber);
    const n = this.model.tokenization.getLineTokens(t.lineNumber), i = I0(n, t.column - 1), s = t.column - 1 - i.firstCharOffset, o = i.firstCharOffset + s, a = i.firstCharOffset + i.getLineLength(), l = n.sliceAndInflate(o, a, 0);
    return this.indentationLineProcessor.getProcessedTokens(l);
  }
  _getProcessedPreviousLineTokens(e) {
    const t = (p) => {
      this.model.tokenization.forceTokenization(p);
      const g = this.model.tokenization.getLineTokens(p), m = this.model.getLineMaxColumn(p) - 1;
      return I0(g, m);
    };
    this.model.tokenization.forceTokenization(e.startLineNumber);
    const n = this.model.tokenization.getLineTokens(e.startLineNumber), i = I0(n, e.startColumn - 1), s = Ri.createEmpty("", i.languageIdCodec), o = e.startLineNumber - 1;
    if (o === 0 || !(i.firstCharOffset === 0))
      return s;
    const c = t(o);
    if (!(i.languageId === c.languageId))
      return s;
    const u = c.toIViewLineTokens();
    return this.indentationLineProcessor.getProcessedTokens(u);
  }
}
class dke {
  constructor(e, t) {
    this.model = e, this.languageConfigurationService = t;
  }
  /**
   * Get the processed line for the given line number and potentially adjust the indentation level.
   * Remove the language configuration brackets from the regex, string and comment tokens.
   */
  getProcessedLine(e, t) {
    const n = (o, a) => {
      const l = hs(o);
      return a + o.substring(l.length);
    };
    this.model.tokenization.forceTokenization?.(e);
    const i = this.model.tokenization.getLineTokens(e);
    let s = this.getProcessedTokens(i).getLineContent();
    return t !== void 0 && (s = n(s, t)), s;
  }
  /**
   * Process the line with the given tokens, remove the language configuration brackets from the regex, string and comment tokens.
   */
  getProcessedTokens(e) {
    const t = (l) => l === 2 || l === 3 || l === 1, n = e.getLanguageId(0), s = this.languageConfigurationService.getLanguageConfiguration(n).bracketsNew.getBracketRegExp({ global: !0 }), o = [];
    return e.forEach((l) => {
      const c = e.getStandardTokenType(l);
      let d = e.getTokenText(l);
      t(c) && (d = d.replace(s, ""));
      const u = e.getMetadata(l);
      o.push({ text: d, metadata: u });
    }), Ri.createFromTextAndMetadata(o, e.languageIdCodec);
  }
}
function IO(r, e) {
  r.tokenization.forceTokenization(e.lineNumber);
  const t = r.tokenization.getLineTokens(e.lineNumber), n = I0(t, e.column - 1), i = n.firstCharOffset === 0, s = t.getLanguageId(0) === n.languageId;
  return !i && !s;
}
function OO(r, e, t, n) {
  e.tokenization.forceTokenization(t.startLineNumber);
  const i = e.getLanguageIdAtPosition(t.startLineNumber, t.startColumn), s = n.getLanguageConfiguration(i);
  if (!s)
    return null;
  const a = new TO(e, n).getProcessedTokenContextAroundRange(t), l = a.previousLineProcessedTokens.getLineContent(), c = a.beforeRangeProcessedTokens.getLineContent(), d = a.afterRangeProcessedTokens.getLineContent(), u = s.onEnter(r, l, c, d);
  if (!u)
    return null;
  const f = u.indentAction;
  let p = u.appendText;
  const g = u.removeText || 0;
  p ? f === As.Indent && (p = "	" + p) : f === As.Indent || f === As.IndentOutdent ? p = "	" : p = "";
  let m = nLe(e, t.startLineNumber, t.startColumn);
  return g && (m = m.substring(0, m.length - g)), {
    indentAction: f,
    appendText: p,
    removeText: g,
    indentation: m
  };
}
var G4t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Q4t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, x6;
const QE = /* @__PURE__ */ Object.create(null);
function U1(r, e) {
  if (e <= 0)
    return "";
  QE[r] || (QE[r] = ["", r]);
  const t = QE[r];
  for (let n = t.length; n <= e; n++)
    t[n] = t[n - 1] + r;
  return t[e];
}
let _f = x6 = class {
  static unshiftIndent(e, t, n, i, s) {
    const o = zi.visibleColumnFromColumn(e, t, n);
    if (s) {
      const a = U1(" ", i), c = zi.prevIndentTabStop(o, i) / i;
      return U1(a, c);
    } else {
      const a = "	", c = zi.prevRenderTabStop(o, n) / n;
      return U1(a, c);
    }
  }
  static shiftIndent(e, t, n, i, s) {
    const o = zi.visibleColumnFromColumn(e, t, n);
    if (s) {
      const a = U1(" ", i), c = zi.nextIndentTabStop(o, i) / i;
      return U1(a, c);
    } else {
      const a = "	", c = zi.nextRenderTabStop(o, n) / n;
      return U1(a, c);
    }
  }
  constructor(e, t, n) {
    this._languageConfigurationService = n, this._opts = t, this._selection = e, this._selectionId = null, this._useLastEditRangeForCursorEndPosition = !1, this._selectionStartColumnStaysPut = !1;
  }
  _addEditOperation(e, t, n) {
    this._useLastEditRangeForCursorEndPosition ? e.addTrackedEditOperation(t, n) : e.addEditOperation(t, n);
  }
  getEditOperations(e, t) {
    const n = this._selection.startLineNumber;
    let i = this._selection.endLineNumber;
    this._selection.endColumn === 1 && n !== i && (i = i - 1);
    const { tabSize: s, indentSize: o, insertSpaces: a } = this._opts, l = n === i;
    if (this._opts.useTabStops) {
      this._selection.isEmpty() && /^\s*$/.test(e.getLineContent(n)) && (this._useLastEditRangeForCursorEndPosition = !0);
      let c = 0, d = 0;
      for (let u = n; u <= i; u++, c = d) {
        d = 0;
        const f = e.getLineContent(u);
        let p = so(f);
        if (this._opts.isUnshift && (f.length === 0 || p === 0) || !l && !this._opts.isUnshift && f.length === 0)
          continue;
        if (p === -1 && (p = f.length), u > 1 && zi.visibleColumnFromColumn(f, p + 1, s) % o !== 0 && e.tokenization.isCheapToTokenize(u - 1)) {
          const A = OO(this._opts.autoIndent, e, new Q(u - 1, e.getLineMaxColumn(u - 1), u - 1, e.getLineMaxColumn(u - 1)), this._languageConfigurationService);
          if (A) {
            if (d = c, A.appendText)
              for (let w = 0, v = A.appendText.length; w < v && d < o && A.appendText.charCodeAt(w) === 32; w++)
                d++;
            A.removeText && (d = Math.max(0, d - A.removeText));
            for (let w = 0; w < d && !(p === 0 || f.charCodeAt(p - 1) !== 32); w++)
              p--;
          }
        }
        if (this._opts.isUnshift && p === 0)
          continue;
        let g;
        this._opts.isUnshift ? g = x6.unshiftIndent(f, p + 1, s, o, a) : g = x6.shiftIndent(f, p + 1, s, o, a), this._addEditOperation(t, new Q(u, 1, u, p + 1), g), u === n && !this._selection.isEmpty() && (this._selectionStartColumnStaysPut = this._selection.startColumn <= p + 1);
      }
    } else {
      !this._opts.isUnshift && this._selection.isEmpty() && e.getLineLength(n) === 0 && (this._useLastEditRangeForCursorEndPosition = !0);
      const c = a ? U1(" ", o) : "	";
      for (let d = n; d <= i; d++) {
        const u = e.getLineContent(d);
        let f = so(u);
        if (!(this._opts.isUnshift && (u.length === 0 || f === 0)) && !(!l && !this._opts.isUnshift && u.length === 0) && (f === -1 && (f = u.length), !(this._opts.isUnshift && f === 0)))
          if (this._opts.isUnshift) {
            f = Math.min(f, o);
            for (let p = 0; p < f; p++)
              if (u.charCodeAt(p) === 9) {
                f = p + 1;
                break;
              }
            this._addEditOperation(t, new Q(d, 1, d, f + 1), "");
          } else
            this._addEditOperation(t, new Q(d, 1, d, 1), c), d === n && !this._selection.isEmpty() && (this._selectionStartColumnStaysPut = this._selection.startColumn === 1);
      }
    }
    this._selectionId = t.trackSelection(this._selection);
  }
  computeCursorState(e, t) {
    if (this._useLastEditRangeForCursorEndPosition) {
      const i = t.getInverseEditOperations()[0];
      return new _n(i.range.endLineNumber, i.range.endColumn, i.range.endLineNumber, i.range.endColumn);
    }
    const n = t.getTrackedSelection(this._selectionId);
    if (this._selectionStartColumnStaysPut) {
      const i = this._selection.startColumn;
      return n.startColumn <= i ? n : n.getDirection() === 0 ? new _n(n.startLineNumber, i, n.endLineNumber, n.endColumn) : new _n(n.endLineNumber, n.endColumn, n.startLineNumber, i);
    }
    return n;
  }
};
_f = x6 = G4t([
  Q4t(2, xh)
], _f);
class K4t {
  constructor(e, t, n) {
    this._range = e, this._charBeforeSelection = t, this._charAfterSelection = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new Q(this._range.startLineNumber, this._range.startColumn, this._range.startLineNumber, this._range.startColumn), this._charBeforeSelection), t.addTrackedEditOperation(new Q(this._range.endLineNumber, this._range.endColumn, this._range.endLineNumber, this._range.endColumn), this._charAfterSelection);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations(), i = n[0].range, s = n[1].range;
    return new _n(i.endLineNumber, i.endColumn, s.endLineNumber, s.endColumn - this._charAfterSelection.length);
  }
}
class Y4t {
  constructor(e, t, n) {
    this._position = e, this._text = t, this._charAfter = n;
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(new Q(this._position.lineNumber, this._position.column, this._position.lineNumber, this._position.column), this._text + this._charAfter);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return new _n(i.endLineNumber, i.startColumn, i.endLineNumber, i.endColumn - this._charAfter.length);
  }
}
function X4t(r, e, t) {
  const n = r.tokenization.getLanguageIdAtPosition(e, 0);
  if (e > 1) {
    let i, s = -1;
    for (i = e - 1; i >= 1; i--) {
      if (r.tokenization.getLanguageIdAtPosition(i, 0) !== n)
        return s;
      const o = r.getLineContent(i);
      if (t.shouldIgnore(i) || /^\s+$/.test(o) || o === "") {
        s = i;
        continue;
      }
      return i;
    }
  }
  return -1;
}
function h9(r, e, t, n = !0, i) {
  if (r < 4)
    return null;
  const s = i.getLanguageConfiguration(e.tokenization.getLanguageId()).indentRulesSupport;
  if (!s)
    return null;
  const o = new q4t(e, s, i);
  if (t <= 1)
    return {
      indentation: "",
      action: null
    };
  for (let l = t - 1; l > 0 && e.getLineContent(l) === ""; l--)
    if (l === 1)
      return {
        indentation: "",
        action: null
      };
  const a = X4t(e, t, o);
  if (a < 0)
    return null;
  if (a < 1)
    return {
      indentation: "",
      action: null
    };
  if (o.shouldIncrease(a) || o.shouldIndentNextLine(a)) {
    const l = e.getLineContent(a);
    return {
      indentation: hs(l),
      action: As.Indent,
      line: a
    };
  } else if (o.shouldDecrease(a)) {
    const l = e.getLineContent(a);
    return {
      indentation: hs(l),
      action: null,
      line: a
    };
  } else {
    if (a === 1)
      return {
        indentation: hs(e.getLineContent(a)),
        action: null,
        line: a
      };
    const l = a - 1, c = s.getIndentMetadata(e.getLineContent(l));
    if (!(c & 3) && c & 4) {
      let d = 0;
      for (let u = l - 1; u > 0; u--)
        if (!o.shouldIndentNextLine(u)) {
          d = u;
          break;
        }
      return {
        indentation: hs(e.getLineContent(d + 1)),
        action: null,
        line: d + 1
      };
    }
    if (n)
      return {
        indentation: hs(e.getLineContent(a)),
        action: null,
        line: a
      };
    for (let d = a; d > 0; d--) {
      if (o.shouldIncrease(d))
        return {
          indentation: hs(e.getLineContent(d)),
          action: As.Indent,
          line: d
        };
      if (o.shouldIndentNextLine(d)) {
        let u = 0;
        for (let f = d - 1; f > 0; f--)
          if (!o.shouldIndentNextLine(d)) {
            u = f;
            break;
          }
        return {
          indentation: hs(e.getLineContent(u + 1)),
          action: null,
          line: u + 1
        };
      } else if (o.shouldDecrease(d))
        return {
          indentation: hs(e.getLineContent(d)),
          action: null,
          line: d
        };
    }
    return {
      indentation: hs(e.getLineContent(1)),
      action: null,
      line: 1
    };
  }
}
function J4t(r, e, t, n, i) {
  if (r < 4)
    return null;
  const s = e.getLanguageIdAtPosition(t.startLineNumber, t.startColumn), o = i.getLanguageConfiguration(s).indentRulesSupport;
  if (!o)
    return null;
  e.tokenization.forceTokenization(t.startLineNumber);
  const l = new TO(e, i).getProcessedTokenContextAroundRange(t), c = l.afterRangeProcessedTokens, d = l.beforeRangeProcessedTokens, u = hs(d.getLineContent()), f = ewt(e, t.startLineNumber, d), p = IO(e, t.getStartPosition()), g = e.getLineContent(t.startLineNumber), m = hs(g), A = h9(r, f, t.startLineNumber + 1, void 0, i);
  if (!A) {
    const v = p ? m : u;
    return {
      beforeEnter: v,
      afterEnter: v
    };
  }
  let w = p ? m : A.indentation;
  return A.action === As.Indent && (w = n.shiftIndent(w)), o.shouldDecrease(c.getLineContent()) && (w = n.unshiftIndent(w)), {
    beforeEnter: p ? m : u,
    afterEnter: w
  };
}
function $4t(r, e, t, n, i, s) {
  const o = r.autoIndent;
  if (o < 4 || IO(e, t.getStartPosition()))
    return null;
  const l = e.getLanguageIdAtPosition(t.startLineNumber, t.startColumn), c = s.getLanguageConfiguration(l).indentRulesSupport;
  if (!c)
    return null;
  const u = new TO(e, s).getProcessedTokenContextAroundRange(t), f = u.beforeRangeProcessedTokens.getLineContent(), p = u.afterRangeProcessedTokens.getLineContent(), g = f + p, m = f + n + p;
  if (!c.shouldDecrease(g) && c.shouldDecrease(m)) {
    const w = h9(o, e, t.startLineNumber, !1, s);
    if (!w)
      return null;
    let v = w.indentation;
    return w.action !== As.Indent && (v = i.unshiftIndent(v)), v;
  }
  const A = t.startLineNumber - 1;
  if (A > 0) {
    const w = e.getLineContent(A);
    if (c.shouldIndentNextLine(w) && c.shouldIncrease(m)) {
      const y = h9(o, e, t.startLineNumber, !1, s)?.indentation;
      if (y !== void 0) {
        const _ = e.getLineContent(t.startLineNumber), S = hs(_), M = i.shiftIndent(y) === S, L = /^\s*$/.test(g), T = r.autoClosingPairs.autoClosingPairsOpenByEnd.get(n), V = T && T.length > 0 && L;
        if (M && V)
          return y;
      }
    }
  }
  return null;
}
function ewt(r, e, t) {
  return {
    tokenization: {
      getLineTokens: (i) => i === e ? t : r.tokenization.getLineTokens(i),
      getLanguageId: () => r.getLanguageId(),
      getLanguageIdAtPosition: (i, s) => r.getLanguageIdAtPosition(i, s)
    },
    getLineContent: (i) => i === e ? t.getLineContent() : r.getLineContent(i)
  };
}
class twt {
  static getEdits(e, t, n, i, s) {
    if (!s && this._isAutoIndentType(e, t, n)) {
      const o = [];
      for (const l of n) {
        const c = this._findActualIndentationForSelection(e, t, l, i);
        if (c === null)
          return;
        o.push({ selection: l, indentation: c });
      }
      const a = vL.getAutoClosingPairClose(e, t, n, i, !1);
      return this._getIndentationAndAutoClosingPairEdits(e, t, o, i, a);
    }
  }
  static _isAutoIndentType(e, t, n) {
    if (e.autoIndent < 4)
      return !1;
    for (let i = 0, s = n.length; i < s; i++)
      if (!t.tokenization.isCheapToTokenize(n[i].getEndPosition().lineNumber))
        return !1;
    return !0;
  }
  static _findActualIndentationForSelection(e, t, n, i) {
    const s = $4t(e, t, n, i, {
      shiftIndent: (a) => HO(e, a),
      unshiftIndent: (a) => d9(e, a)
    }, e.languageConfigurationService);
    if (s === null)
      return null;
    const o = nLe(t, n.startLineNumber, n.startColumn);
    return s === e.normalizeIndentation(o) ? null : s;
  }
  static _getIndentationAndAutoClosingPairEdits(e, t, n, i, s) {
    const o = n.map(({ selection: l, indentation: c }) => {
      if (s !== null) {
        const d = this._getEditFromIndentationAndSelection(e, t, c, l, i, !1);
        return new uwt(d, l, i, s);
      } else {
        const d = this._getEditFromIndentationAndSelection(e, t, c, l, i, !0);
        return s0(d.range, d.text, !1);
      }
    }), a = { shouldPushStackElementBefore: !0, shouldPushStackElementAfter: !1 };
    return new js(4, o, a);
  }
  static _getEditFromIndentationAndSelection(e, t, n, i, s, o = !0) {
    const a = i.startLineNumber, l = t.getLineFirstNonWhitespaceColumn(a);
    let c = e.normalizeIndentation(n);
    if (l !== 0) {
      const u = t.getLineContent(a);
      c += u.substring(l - 1, i.startColumn - 1);
    }
    return c += o ? s : "", { range: new Q(a, 1, i.endLineNumber, i.endColumn), text: c };
  }
}
class nwt {
  static getEdits(e, t, n, i, s, o) {
    if (fke(t, n, i, s, o))
      return this._runAutoClosingOvertype(e, i, o);
  }
  static _runAutoClosingOvertype(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const l = t[s].getPosition(), c = new Q(l.lineNumber, l.column, l.lineNumber, l.column + 1);
      i[s] = new Vs(c, n);
    }
    return new js(4, i, {
      shouldPushStackElementBefore: my(
        e,
        4
        /* EditOperationType.TypingOther */
      ),
      shouldPushStackElementAfter: !1
    });
  }
}
class iwt {
  static getEdits(e, t, n, i, s) {
    if (fke(e, t, n, i, s)) {
      const o = n.map((a) => new Vs(new Q(a.positionLineNumber, a.positionColumn, a.positionLineNumber, a.positionColumn + 1), "", !1));
      return new js(4, o, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
  }
}
class vL {
  static getEdits(e, t, n, i, s, o) {
    if (!o) {
      const a = this.getAutoClosingPairClose(e, t, n, i, s);
      if (a !== null)
        return this._runAutoClosingOpenCharType(n, i, s, a);
    }
  }
  static _runAutoClosingOpenCharType(e, t, n, i) {
    const s = [];
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o];
      s[o] = new dwt(l, t, !n, i);
    }
    return new js(4, s, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !1
    });
  }
  static getAutoClosingPairClose(e, t, n, i, s) {
    for (const g of n)
      if (!g.isEmpty())
        return null;
    const o = n.map((g) => {
      const m = g.getPosition();
      return s ? { lineNumber: m.lineNumber, beforeColumn: m.column - i.length, afterColumn: m.column } : { lineNumber: m.lineNumber, beforeColumn: m.column, afterColumn: m.column };
    }), a = this._findAutoClosingPairOpen(e, t, o.map((g) => new le(g.lineNumber, g.beforeColumn)), i);
    if (!a)
      return null;
    let l, c;
    if (f1(i) ? (l = e.autoClosingQuotes, c = e.shouldAutoCloseBefore.quote) : (e.blockCommentStartToken ? a.open.includes(e.blockCommentStartToken) : !1) ? (l = e.autoClosingComments, c = e.shouldAutoCloseBefore.comment) : (l = e.autoClosingBrackets, c = e.shouldAutoCloseBefore.bracket), l === "never")
      return null;
    const u = this._findContainedAutoClosingPair(e, a), f = u ? u.close : "";
    let p = !0;
    for (const g of o) {
      const { lineNumber: m, beforeColumn: A, afterColumn: w } = g, v = t.getLineContent(m), y = v.substring(0, A - 1), _ = v.substring(w - 1);
      if (_.startsWith(f) || (p = !1), _.length > 0) {
        const L = _.charAt(0);
        if (!this._isBeforeClosingBrace(e, _) && !c(L))
          return null;
      }
      if (a.open.length === 1 && (i === "'" || i === '"') && l !== "always") {
        const L = lg(e.wordSeparators, []);
        if (y.length > 0) {
          const T = y.charCodeAt(y.length - 1);
          if (L.get(T) === 0)
            return null;
        }
      }
      if (!t.tokenization.isCheapToTokenize(m))
        return null;
      t.tokenization.forceTokenization(m);
      const S = t.tokenization.getLineTokens(m), D = I0(S, A - 1);
      if (!a.shouldAutoClose(D, A - D.firstCharOffset))
        return null;
      const M = a.findNeutralCharacter();
      if (M) {
        const L = t.tokenization.getTokenTypeIfInsertingCharacter(m, A, M);
        if (!a.isOK(L))
          return null;
      }
    }
    return p ? a.close.substring(0, a.close.length - f.length) : a.close;
  }
  /**
   * Find another auto-closing pair that is contained by the one passed in.
   *
   * e.g. when having [(,)] and [(*,*)] as auto-closing pairs
   * this method will find [(,)] as a containment pair for [(*,*)]
   */
  static _findContainedAutoClosingPair(e, t) {
    if (t.open.length <= 1)
      return null;
    const n = t.close.charAt(t.close.length - 1), i = e.autoClosingPairs.autoClosingPairsCloseByEnd.get(n) || [];
    let s = null;
    for (const o of i)
      o.open !== t.open && t.open.includes(o.open) && t.close.endsWith(o.close) && (!s || o.open.length > s.open.length) && (s = o);
    return s;
  }
  /**
   * Determine if typing `ch` at all `positions` in the `model` results in an
   * auto closing open sequence being typed.
   *
   * Auto closing open sequences can consist of multiple characters, which
   * can lead to ambiguities. In such a case, the longest auto-closing open
   * sequence is returned.
   */
  static _findAutoClosingPairOpen(e, t, n, i) {
    const s = e.autoClosingPairs.autoClosingPairsOpenByEnd.get(i);
    if (!s)
      return null;
    let o = null;
    for (const a of s)
      if (o === null || a.open.length > o.open.length) {
        let l = !0;
        for (const c of n)
          if (t.getValueInRange(new Q(c.lineNumber, c.column - a.open.length + 1, c.lineNumber, c.column)) + i !== a.open) {
            l = !1;
            break;
          }
        l && (o = a);
      }
    return o;
  }
  static _isBeforeClosingBrace(e, t) {
    const n = t.charAt(0), i = e.autoClosingPairs.autoClosingPairsOpenByStart.get(n) || [], s = e.autoClosingPairs.autoClosingPairsCloseByStart.get(n) || [], o = i.some((l) => t.startsWith(l.open)), a = s.some((l) => t.startsWith(l.close));
    return !o && a;
  }
}
class rwt {
  static getEdits(e, t, n, i, s) {
    if (!s && this._isSurroundSelectionType(e, t, n, i))
      return this._runSurroundSelectionType(e, n, i);
  }
  static _runSurroundSelectionType(e, t, n) {
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = e.surroundingPairs[n];
      i[s] = new K4t(a, n, l);
    }
    return new js(0, i, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
  static _isSurroundSelectionType(e, t, n, i) {
    if (!pke(e, i) || !e.surroundingPairs.hasOwnProperty(i))
      return !1;
    const s = f1(i);
    for (const o of n) {
      if (o.isEmpty())
        return !1;
      let a = !0;
      for (let l = o.startLineNumber; l <= o.endLineNumber; l++) {
        const c = t.getLineContent(l), d = l === o.startLineNumber ? o.startColumn - 1 : 0, u = l === o.endLineNumber ? o.endColumn - 1 : c.length, f = c.substring(d, u);
        if (/[^ \t]/.test(f)) {
          a = !1;
          break;
        }
      }
      if (a)
        return !1;
      if (s && o.startLineNumber === o.endLineNumber && o.startColumn + 1 === o.endColumn) {
        const l = t.getValueInRange(o);
        if (f1(l))
          return !1;
      }
    }
    return !0;
  }
}
class swt {
  static getEdits(e, t, n, i, s, o) {
    if (!o && this._isTypeInterceptorElectricChar(t, n, i)) {
      const a = this._typeInterceptorElectricChar(e, t, n, i[0], s);
      if (a)
        return a;
    }
  }
  static _isTypeInterceptorElectricChar(e, t, n) {
    return !!(n.length === 1 && t.tokenization.isCheapToTokenize(n[0].getEndPosition().lineNumber));
  }
  static _typeInterceptorElectricChar(e, t, n, i, s) {
    if (!t.electricChars.hasOwnProperty(s) || !i.isEmpty())
      return null;
    const o = i.getPosition();
    n.tokenization.forceTokenization(o.lineNumber);
    const a = n.tokenization.getLineTokens(o.lineNumber);
    let l;
    try {
      l = t.onElectricCharacter(s, a, o.column);
    } catch (c) {
      return wn(c), null;
    }
    if (!l)
      return null;
    if (l.matchOpenBracket) {
      const c = (a.getLineContent() + s).lastIndexOf(l.matchOpenBracket) + 1, d = n.bracketPairs.findMatchingBracketUp(
        l.matchOpenBracket,
        {
          lineNumber: o.lineNumber,
          column: c
        },
        500
        /* give at most 500ms to compute */
      );
      if (d) {
        if (d.startLineNumber === o.lineNumber)
          return null;
        const u = n.getLineContent(d.startLineNumber), f = hs(u), p = t.normalizeIndentation(f), g = n.getLineContent(o.lineNumber), m = n.getLineFirstNonWhitespaceColumn(o.lineNumber) || o.column, A = g.substring(m - 1, o.column - 1), w = p + A + s, v = new Q(o.lineNumber, 1, o.lineNumber, o.column), y = new Vs(v, w);
        return new js(VO(w, e), [y], {
          shouldPushStackElementBefore: !1,
          shouldPushStackElementAfter: !0
        });
      }
    }
    return null;
  }
}
class owt {
  static getEdits(e, t, n) {
    const i = [];
    for (let o = 0, a = t.length; o < a; o++)
      i[o] = new Vs(t[o], n);
    const s = VO(n, e);
    return new js(s, i, {
      shouldPushStackElementBefore: my(e, s),
      shouldPushStackElementAfter: !1
    });
  }
}
class uke {
  static getEdits(e, t, n, i, s) {
    if (!s && i === `
`) {
      const o = [];
      for (let a = 0, l = n.length; a < l; a++)
        o[a] = this._enter(e, t, !1, n[a]);
      return new js(4, o, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
  }
  static _enter(e, t, n, i) {
    if (e.autoIndent === 0)
      return s0(i, `
`, n);
    if (!t.tokenization.isCheapToTokenize(i.getStartPosition().lineNumber) || e.autoIndent === 1) {
      const l = t.getLineContent(i.startLineNumber), c = hs(l).substring(0, i.startColumn - 1);
      return s0(i, `
` + e.normalizeIndentation(c), n);
    }
    const s = OO(e.autoIndent, t, i, e.languageConfigurationService);
    if (s) {
      if (s.indentAction === As.None)
        return s0(i, `
` + e.normalizeIndentation(s.indentation + s.appendText), n);
      if (s.indentAction === As.Indent)
        return s0(i, `
` + e.normalizeIndentation(s.indentation + s.appendText), n);
      if (s.indentAction === As.IndentOutdent) {
        const l = e.normalizeIndentation(s.indentation), c = e.normalizeIndentation(s.indentation + s.appendText), d = `
` + c + `
` + l;
        return n ? new _6(i, d, !0) : new l9(i, d, -1, c.length - l.length, !0);
      } else if (s.indentAction === As.Outdent) {
        const l = d9(e, s.indentation);
        return s0(i, `
` + e.normalizeIndentation(l + s.appendText), n);
      }
    }
    const o = t.getLineContent(i.startLineNumber), a = hs(o).substring(0, i.startColumn - 1);
    if (e.autoIndent >= 4) {
      const l = J4t(e.autoIndent, t, i, {
        unshiftIndent: (c) => d9(e, c),
        shiftIndent: (c) => HO(e, c),
        normalizeIndentation: (c) => e.normalizeIndentation(c)
      }, e.languageConfigurationService);
      if (l) {
        let c = e.visibleColumnFromColumn(t, i.getEndPosition());
        const d = i.endColumn, u = t.getLineContent(i.endLineNumber), f = so(u);
        if (f >= 0 ? i = i.setEndPosition(i.endLineNumber, Math.max(i.endColumn, f + 1)) : i = i.setEndPosition(i.endLineNumber, t.getLineMaxColumn(i.endLineNumber)), n)
          return new _6(i, `
` + e.normalizeIndentation(l.afterEnter), !0);
        {
          let p = 0;
          return d <= f + 1 && (e.insertSpaces || (c = Math.ceil(c / e.indentSize)), p = Math.min(c + 1 - e.normalizeIndentation(l.afterEnter).length - 1, 0)), new l9(i, `
` + e.normalizeIndentation(l.afterEnter), 0, p, !0);
        }
      }
    }
    return s0(i, `
` + e.normalizeIndentation(a), n);
  }
  static lineInsertBefore(e, t, n) {
    if (t === null || n === null)
      return [];
    const i = [];
    for (let s = 0, o = n.length; s < o; s++) {
      let a = n[s].positionLineNumber;
      if (a === 1)
        i[s] = new _6(new Q(1, 1, 1, 1), `
`);
      else {
        a--;
        const l = t.getLineMaxColumn(a);
        i[s] = this._enter(e, t, !1, new Q(a, l, a, l));
      }
    }
    return i;
  }
  static lineInsertAfter(e, t, n) {
    if (t === null || n === null)
      return [];
    const i = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s].positionLineNumber, l = t.getLineMaxColumn(a);
      i[s] = this._enter(e, t, !1, new Q(a, l, a, l));
    }
    return i;
  }
  static lineBreakInsert(e, t, n) {
    const i = [];
    for (let s = 0, o = n.length; s < o; s++)
      i[s] = this._enter(e, t, !0, n[s]);
    return i;
  }
}
class awt {
  static getEdits(e, t, n, i, s, o) {
    const a = this._distributePasteToCursors(e, n, i, s, o);
    return a ? (n = n.sort(Q.compareRangesUsingStarts), this._distributedPaste(e, t, n, a)) : this._simplePaste(e, t, n, i, s);
  }
  static _distributePasteToCursors(e, t, n, i, s) {
    if (i || t.length === 1)
      return null;
    if (s && s.length === t.length)
      return s;
    if (e.multiCursorPaste === "spread") {
      n.charCodeAt(n.length - 1) === 10 && (n = n.substring(0, n.length - 1)), n.charCodeAt(n.length - 1) === 13 && (n = n.substring(0, n.length - 1));
      const o = $g(n);
      if (o.length === t.length)
        return o;
    }
    return null;
  }
  static _distributedPaste(e, t, n, i) {
    const s = [];
    for (let o = 0, a = n.length; o < a; o++)
      s[o] = new Vs(n[o], i[o]);
    return new js(0, s, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
  static _simplePaste(e, t, n, i, s) {
    const o = [];
    for (let a = 0, l = n.length; a < l; a++) {
      const c = n[a], d = c.getPosition();
      if (s && !c.isEmpty() && (s = !1), s && i.indexOf(`
`) !== i.length - 1 && (s = !1), s) {
        const u = new Q(d.lineNumber, 1, d.lineNumber, 1);
        o[a] = new hke(u, i, c, !0);
      } else
        o[a] = new Vs(c, i);
    }
    return new js(0, o, {
      shouldPushStackElementBefore: !0,
      shouldPushStackElementAfter: !0
    });
  }
}
class lwt {
  static getEdits(e, t, n, i, s, o, a, l) {
    const c = i.map((d) => this._compositionType(n, d, s, o, a, l));
    return new js(4, c, {
      shouldPushStackElementBefore: my(
        e,
        4
        /* EditOperationType.TypingOther */
      ),
      shouldPushStackElementAfter: !1
    });
  }
  static _compositionType(e, t, n, i, s, o) {
    if (!t.isEmpty())
      return null;
    const a = t.getPosition(), l = Math.max(1, a.column - i), c = Math.min(e.getLineMaxColumn(a.lineNumber), a.column + s), d = new Q(a.lineNumber, l, a.lineNumber, c);
    return e.getValueInRange(d) === n && o === 0 ? null : new l9(d, n, 0, o);
  }
}
class cwt {
  static getEdits(e, t, n) {
    const i = [];
    for (let o = 0, a = t.length; o < a; o++)
      i[o] = new Vs(t[o], n);
    const s = VO(n, e);
    return new js(s, i, {
      shouldPushStackElementBefore: my(e, s),
      shouldPushStackElementAfter: !1
    });
  }
}
class hwt {
  static getCommands(e, t, n) {
    const i = [];
    for (let s = 0, o = n.length; s < o; s++) {
      const a = n[s];
      if (a.isEmpty()) {
        const l = t.getLineContent(a.startLineNumber);
        if (/^\s*$/.test(l) && t.tokenization.isCheapToTokenize(a.startLineNumber)) {
          let c = this._goodIndentForLine(e, t, a.startLineNumber);
          c = c || "	";
          const d = e.normalizeIndentation(c);
          if (!l.startsWith(d)) {
            i[s] = new Vs(new Q(a.startLineNumber, 1, a.startLineNumber, l.length + 1), d, !0);
            continue;
          }
        }
        i[s] = this._replaceJumpToNextIndent(e, t, a, !0);
      } else {
        if (a.startLineNumber === a.endLineNumber) {
          const l = t.getLineMaxColumn(a.startLineNumber);
          if (a.startColumn !== 1 || a.endColumn !== l) {
            i[s] = this._replaceJumpToNextIndent(e, t, a, !1);
            continue;
          }
        }
        i[s] = new _f(a, {
          isUnshift: !1,
          tabSize: e.tabSize,
          indentSize: e.indentSize,
          insertSpaces: e.insertSpaces,
          useTabStops: e.useTabStops,
          autoIndent: e.autoIndent
        }, e.languageConfigurationService);
      }
    }
    return i;
  }
  static _goodIndentForLine(e, t, n) {
    let i = null, s = "";
    const o = h9(e.autoIndent, t, n, !1, e.languageConfigurationService);
    if (o)
      i = o.action, s = o.indentation;
    else if (n > 1) {
      let a;
      for (a = n - 1; a >= 1; a--) {
        const d = t.getLineContent(a);
        if (Zf(d) >= 0)
          break;
      }
      if (a < 1)
        return null;
      const l = t.getLineMaxColumn(a), c = OO(e.autoIndent, t, new Q(a, l, a, l), e.languageConfigurationService);
      c && (s = c.indentation + c.appendText);
    }
    return i && (i === As.Indent && (s = HO(e, s)), i === As.Outdent && (s = d9(e, s)), s = e.normalizeIndentation(s)), s || null;
  }
  static _replaceJumpToNextIndent(e, t, n, i) {
    let s = "";
    const o = n.getStartPosition();
    if (e.insertSpaces) {
      const a = e.visibleColumnFromColumn(t, o), l = e.indentSize, c = l - a % l;
      for (let d = 0; d < c; d++)
        s += " ";
    } else
      s = "	";
    return new Vs(n, s, i);
  }
}
class RO extends l9 {
  constructor(e, t, n, i, s, o) {
    super(e, t, n, i), this._openCharacter = s, this._closeCharacter = o, this.closeCharacterRange = null, this.enclosingRange = null;
  }
  _computeCursorStateWithRange(e, t, n) {
    return this.closeCharacterRange = new Q(t.startLineNumber, t.endColumn - this._closeCharacter.length, t.endLineNumber, t.endColumn), this.enclosingRange = new Q(t.startLineNumber, t.endColumn - this._openCharacter.length - this._closeCharacter.length, t.endLineNumber, t.endColumn), super.computeCursorState(e, n);
  }
}
class dwt extends RO {
  constructor(e, t, n, i) {
    const s = (n ? t : "") + i, o = 0, a = -i.length;
    super(e, s, o, a, t, i);
  }
  computeCursorState(e, t) {
    const i = t.getInverseEditOperations()[0].range;
    return this._computeCursorStateWithRange(e, i, t);
  }
}
class uwt extends RO {
  constructor(e, t, n, i) {
    const s = n + i, o = 0, a = n.length;
    super(t, s, o, a, n, i), this._autoIndentationEdit = e, this._autoClosingEdit = { range: t, text: s };
  }
  getEditOperations(e, t) {
    t.addTrackedEditOperation(this._autoIndentationEdit.range, this._autoIndentationEdit.text), t.addTrackedEditOperation(this._autoClosingEdit.range, this._autoClosingEdit.text);
  }
  computeCursorState(e, t) {
    const n = t.getInverseEditOperations();
    if (n.length !== 2)
      throw new Error("There should be two inverse edit operations!");
    const i = n[0].range, s = n[1].range, o = i.plusRange(s);
    return this._computeCursorStateWithRange(e, o, t);
  }
}
function VO(r, e) {
  return r === " " ? e === 5 || e === 6 ? 6 : 5 : 4;
}
function my(r, e) {
  return y6e(r) && !y6e(e) ? !0 : r === 5 ? !1 : b6e(r) !== b6e(e);
}
function b6e(r) {
  return r === 6 || r === 5 ? "space" : r;
}
function y6e(r) {
  return r === 4 || r === 5 || r === 6;
}
function fke(r, e, t, n, i) {
  if (r.autoClosingOvertype === "never" || !r.autoClosingPairs.autoClosingPairsCloseSingleChar.has(i))
    return !1;
  for (let s = 0, o = t.length; s < o; s++) {
    const a = t[s];
    if (!a.isEmpty())
      return !1;
    const l = a.getPosition(), c = e.getLineContent(l.lineNumber);
    if (c.charAt(l.column - 1) !== i)
      return !1;
    const u = f1(i);
    if ((l.column > 2 ? c.charCodeAt(l.column - 2) : 0) === 92 && u)
      return !1;
    if (r.autoClosingOvertype === "auto") {
      let p = !1;
      for (let g = 0, m = n.length; g < m; g++) {
        const A = n[g];
        if (l.lineNumber === A.startLineNumber && l.column === A.startColumn) {
          p = !0;
          break;
        }
      }
      if (!p)
        return !1;
    }
  }
  return !0;
}
function s0(r, e, t) {
  return t ? new _6(r, e, !0) : new Vs(r, e, !0);
}
function HO(r, e, t) {
  return t = t || 1, _f.shiftIndent(e, e.length + t, r.tabSize, r.indentSize, r.insertSpaces);
}
function d9(r, e, t) {
  return t = t || 1, _f.unshiftIndent(e, e.length + t, r.tabSize, r.indentSize, r.insertSpaces);
}
function pke(r, e) {
  return f1(e) ? r.autoSurround === "quotes" || r.autoSurround === "languageDefined" : r.autoSurround === "brackets" || r.autoSurround === "languageDefined";
}
class b0 {
  static indent(e, t, n) {
    if (t === null || n === null)
      return [];
    const i = [];
    for (let s = 0, o = n.length; s < o; s++)
      i[s] = new _f(n[s], {
        isUnshift: !1,
        tabSize: e.tabSize,
        indentSize: e.indentSize,
        insertSpaces: e.insertSpaces,
        useTabStops: e.useTabStops,
        autoIndent: e.autoIndent
      }, e.languageConfigurationService);
    return i;
  }
  static outdent(e, t, n) {
    const i = [];
    for (let s = 0, o = n.length; s < o; s++)
      i[s] = new _f(n[s], {
        isUnshift: !0,
        tabSize: e.tabSize,
        indentSize: e.indentSize,
        insertSpaces: e.insertSpaces,
        useTabStops: e.useTabStops,
        autoIndent: e.autoIndent
      }, e.languageConfigurationService);
    return i;
  }
  static paste(e, t, n, i, s, o) {
    return awt.getEdits(e, t, n, i, s, o);
  }
  static tab(e, t, n) {
    return hwt.getCommands(e, t, n);
  }
  static compositionType(e, t, n, i, s, o, a, l) {
    return lwt.getEdits(e, t, n, i, s, o, a, l);
  }
  /**
   * This is very similar with typing, but the character is already in the text buffer!
   */
  static compositionEndWithInterceptors(e, t, n, i, s, o) {
    if (!i)
      return null;
    let a = null;
    for (const f of i)
      if (a === null)
        a = f.insertedText;
      else if (a !== f.insertedText)
        return null;
    if (!a || a.length !== 1)
      return null;
    const l = a;
    let c = !1;
    for (const f of i)
      if (f.deletedText.length !== 0) {
        c = !0;
        break;
      }
    if (c) {
      if (!pke(t, l) || !t.surroundingPairs.hasOwnProperty(l))
        return null;
      const f = f1(l);
      for (const m of i)
        if (m.deletedSelectionStart !== 0 || m.deletedSelectionEnd !== m.deletedText.length || /^[ \t]+$/.test(m.deletedText) || f && f1(m.deletedText))
          return null;
      const p = [];
      for (const m of s) {
        if (!m.isEmpty())
          return null;
        p.push(m.getPosition());
      }
      if (p.length !== i.length)
        return null;
      const g = [];
      for (let m = 0, A = p.length; m < A; m++)
        g.push(new Y4t(p[m], i[m].deletedText, t.surroundingPairs[l]));
      return new js(4, g, {
        shouldPushStackElementBefore: !0,
        shouldPushStackElementAfter: !1
      });
    }
    const d = iwt.getEdits(t, n, s, o, l);
    if (d !== void 0)
      return d;
    const u = vL.getEdits(t, n, s, l, !0, !1);
    return u !== void 0 ? u : null;
  }
  static typeWithInterceptors(e, t, n, i, s, o, a) {
    const l = uke.getEdits(n, i, s, a, e);
    if (l !== void 0)
      return l;
    const c = twt.getEdits(n, i, s, a, e);
    if (c !== void 0)
      return c;
    const d = nwt.getEdits(t, n, i, s, o, a);
    if (d !== void 0)
      return d;
    const u = vL.getEdits(n, i, s, a, !1, e);
    if (u !== void 0)
      return u;
    const f = rwt.getEdits(n, i, s, a, e);
    if (f !== void 0)
      return f;
    const p = swt.getEdits(t, n, i, s, a, e);
    return p !== void 0 ? p : owt.getEdits(t, s, a);
  }
  static typeWithoutInterceptors(e, t, n, i, s) {
    return cwt.getEdits(e, i, s);
  }
}
class fwt {
  constructor(e, t, n, i, s, o) {
    this.deletedText = e, this.deletedSelectionStart = t, this.deletedSelectionEnd = n, this.insertedText = i, this.insertedSelectionStart = s, this.insertedSelectionEnd = o;
  }
}
var Me;
(function(r) {
  r.editorSimpleInput = new Ve("editorSimpleInput", !1, !0), r.editorTextFocus = new Ve("editorTextFocus", !1, C("editorTextFocus", "Whether the editor text has focus (cursor is blinking)")), r.focus = new Ve("editorFocus", !1, C("editorFocus", "Whether the editor or an editor widget has focus (e.g. focus is in the find widget)")), r.textInputFocus = new Ve("textInputFocus", !1, C("textInputFocus", "Whether an editor or a rich text input has focus (cursor is blinking)")), r.readOnly = new Ve("editorReadonly", !1, C("editorReadonly", "Whether the editor is read-only")), r.inDiffEditor = new Ve("inDiffEditor", !1, C("inDiffEditor", "Whether the context is a diff editor")), r.isEmbeddedDiffEditor = new Ve("isEmbeddedDiffEditor", !1, C("isEmbeddedDiffEditor", "Whether the context is an embedded diff editor")), r.inMultiDiffEditor = new Ve("inMultiDiffEditor", !1, C("inMultiDiffEditor", "Whether the context is a multi diff editor")), r.multiDiffEditorAllCollapsed = new Ve("multiDiffEditorAllCollapsed", void 0, C("multiDiffEditorAllCollapsed", "Whether all files in multi diff editor are collapsed")), r.hasChanges = new Ve("diffEditorHasChanges", !1, C("diffEditorHasChanges", "Whether the diff editor has changes")), r.comparingMovedCode = new Ve("comparingMovedCode", !1, C("comparingMovedCode", "Whether a moved code block is selected for comparison")), r.accessibleDiffViewerVisible = new Ve("accessibleDiffViewerVisible", !1, C("accessibleDiffViewerVisible", "Whether the accessible diff viewer is visible")), r.diffEditorRenderSideBySideInlineBreakpointReached = new Ve("diffEditorRenderSideBySideInlineBreakpointReached", !1, C("diffEditorRenderSideBySideInlineBreakpointReached", "Whether the diff editor render side by side inline breakpoint is reached")), r.diffEditorInlineMode = new Ve("diffEditorInlineMode", !1, C("diffEditorInlineMode", "Whether inline mode is active")), r.diffEditorOriginalWritable = new Ve("diffEditorOriginalWritable", !1, C("diffEditorOriginalWritable", "Whether modified is writable in the diff editor")), r.diffEditorModifiedWritable = new Ve("diffEditorModifiedWritable", !1, C("diffEditorModifiedWritable", "Whether modified is writable in the diff editor")), r.diffEditorOriginalUri = new Ve("diffEditorOriginalUri", "", C("diffEditorOriginalUri", "The uri of the original document")), r.diffEditorModifiedUri = new Ve("diffEditorModifiedUri", "", C("diffEditorModifiedUri", "The uri of the modified document")), r.columnSelection = new Ve("editorColumnSelection", !1, C("editorColumnSelection", "Whether `editor.columnSelection` is enabled")), r.writable = r.readOnly.toNegated(), r.hasNonEmptySelection = new Ve("editorHasSelection", !1, C("editorHasSelection", "Whether the editor has text selected")), r.hasOnlyEmptySelection = r.hasNonEmptySelection.toNegated(), r.hasMultipleSelections = new Ve("editorHasMultipleSelections", !1, C("editorHasMultipleSelections", "Whether the editor has multiple selections")), r.hasSingleSelection = r.hasMultipleSelections.toNegated(), r.tabMovesFocus = new Ve("editorTabMovesFocus", !1, C("editorTabMovesFocus", "Whether `Tab` will move focus out of the editor")), r.tabDoesNotMoveFocus = r.tabMovesFocus.toNegated(), r.isInEmbeddedEditor = new Ve("isInEmbeddedEditor", !1, !0), r.canUndo = new Ve("canUndo", !1, !0), r.canRedo = new Ve("canRedo", !1, !0), r.hoverVisible = new Ve("editorHoverVisible", !1, C("editorHoverVisible", "Whether the editor hover is visible")), r.hoverFocused = new Ve("editorHoverFocused", !1, C("editorHoverFocused", "Whether the editor hover is focused")), r.stickyScrollFocused = new Ve("stickyScrollFocused", !1, C("stickyScrollFocused", "Whether the sticky scroll is focused")), r.stickyScrollVisible = new Ve("stickyScrollVisible", !1, C("stickyScrollVisible", "Whether the sticky scroll is visible")), r.standaloneColorPickerVisible = new Ve("standaloneColorPickerVisible", !1, C("standaloneColorPickerVisible", "Whether the standalone color picker is visible")), r.standaloneColorPickerFocused = new Ve("standaloneColorPickerFocused", !1, C("standaloneColorPickerFocused", "Whether the standalone color picker is focused")), r.inCompositeEditor = new Ve("inCompositeEditor", void 0, C("inCompositeEditor", "Whether the editor is part of a larger editor (e.g. notebooks)")), r.notInCompositeEditor = r.inCompositeEditor.toNegated(), r.languageId = new Ve("editorLangId", "", C("editorLangId", "The language identifier of the editor")), r.hasCompletionItemProvider = new Ve("editorHasCompletionItemProvider", !1, C("editorHasCompletionItemProvider", "Whether the editor has a completion item provider")), r.hasCodeActionsProvider = new Ve("editorHasCodeActionsProvider", !1, C("editorHasCodeActionsProvider", "Whether the editor has a code actions provider")), r.hasCodeLensProvider = new Ve("editorHasCodeLensProvider", !1, C("editorHasCodeLensProvider", "Whether the editor has a code lens provider")), r.hasDefinitionProvider = new Ve("editorHasDefinitionProvider", !1, C("editorHasDefinitionProvider", "Whether the editor has a definition provider")), r.hasDeclarationProvider = new Ve("editorHasDeclarationProvider", !1, C("editorHasDeclarationProvider", "Whether the editor has a declaration provider")), r.hasImplementationProvider = new Ve("editorHasImplementationProvider", !1, C("editorHasImplementationProvider", "Whether the editor has an implementation provider")), r.hasTypeDefinitionProvider = new Ve("editorHasTypeDefinitionProvider", !1, C("editorHasTypeDefinitionProvider", "Whether the editor has a type definition provider")), r.hasHoverProvider = new Ve("editorHasHoverProvider", !1, C("editorHasHoverProvider", "Whether the editor has a hover provider")), r.hasDocumentHighlightProvider = new Ve("editorHasDocumentHighlightProvider", !1, C("editorHasDocumentHighlightProvider", "Whether the editor has a document highlight provider")), r.hasDocumentSymbolProvider = new Ve("editorHasDocumentSymbolProvider", !1, C("editorHasDocumentSymbolProvider", "Whether the editor has a document symbol provider")), r.hasReferenceProvider = new Ve("editorHasReferenceProvider", !1, C("editorHasReferenceProvider", "Whether the editor has a reference provider")), r.hasRenameProvider = new Ve("editorHasRenameProvider", !1, C("editorHasRenameProvider", "Whether the editor has a rename provider")), r.hasSignatureHelpProvider = new Ve("editorHasSignatureHelpProvider", !1, C("editorHasSignatureHelpProvider", "Whether the editor has a signature help provider")), r.hasInlayHintsProvider = new Ve("editorHasInlayHintsProvider", !1, C("editorHasInlayHintsProvider", "Whether the editor has an inline hints provider")), r.hasDocumentFormattingProvider = new Ve("editorHasDocumentFormattingProvider", !1, C("editorHasDocumentFormattingProvider", "Whether the editor has a document formatting provider")), r.hasDocumentSelectionFormattingProvider = new Ve("editorHasDocumentSelectionFormattingProvider", !1, C("editorHasDocumentSelectionFormattingProvider", "Whether the editor has a document selection formatting provider")), r.hasMultipleDocumentFormattingProvider = new Ve("editorHasMultipleDocumentFormattingProvider", !1, C("editorHasMultipleDocumentFormattingProvider", "Whether the editor has multiple document formatting providers")), r.hasMultipleDocumentSelectionFormattingProvider = new Ve("editorHasMultipleDocumentSelectionFormattingProvider", !1, C("editorHasMultipleDocumentSelectionFormattingProvider", "Whether the editor has multiple document selection formatting providers"));
})(Me || (Me = {}));
const jt = 0;
class hi extends Fd {
  runEditorCommand(e, t, n) {
    const i = t._getViewModel();
    i && this.runCoreEditorCommand(i, n || {});
  }
}
var Sr;
(function(r) {
  const e = function(n) {
    if (!Rs(n))
      return !1;
    const i = n;
    return !(!Vo(i.to) || !da(i.by) && !Vo(i.by) || !da(i.value) && !Kg(i.value) || !da(i.revealCursor) && !MMe(i.revealCursor));
  };
  r.metadata = {
    description: "Scroll editor in the given direction",
    args: [
      {
        name: "Editor scroll argument object",
        description: "Property-value pairs that can be passed through this argument:\n					* 'to': A mandatory direction value.\n						```\n						'up', 'down'\n						```\n					* 'by': Unit to move. Default is computed based on 'to' value.\n						```\n						'line', 'wrappedLine', 'page', 'halfPage', 'editor'\n						```\n					* 'value': Number of units to move. Default is '1'.\n					* 'revealCursor': If 'true' reveals the cursor if it is outside view port.\n				",
        constraint: e,
        schema: {
          type: "object",
          required: ["to"],
          properties: {
            to: {
              type: "string",
              enum: ["up", "down"]
            },
            by: {
              type: "string",
              enum: ["line", "wrappedLine", "page", "halfPage", "editor"]
            },
            value: {
              type: "number",
              default: 1
            },
            revealCursor: {
              type: "boolean"
            }
          }
        }
      }
    ]
  }, r.RawDirection = {
    Up: "up",
    Right: "right",
    Down: "down",
    Left: "left"
  }, r.RawUnit = {
    Line: "line",
    WrappedLine: "wrappedLine",
    Page: "page",
    HalfPage: "halfPage",
    Editor: "editor",
    Column: "column"
  };
  function t(n) {
    let i;
    switch (n.to) {
      case r.RawDirection.Up:
        i = 1;
        break;
      case r.RawDirection.Right:
        i = 2;
        break;
      case r.RawDirection.Down:
        i = 3;
        break;
      case r.RawDirection.Left:
        i = 4;
        break;
      default:
        return null;
    }
    let s;
    switch (n.by) {
      case r.RawUnit.Line:
        s = 1;
        break;
      case r.RawUnit.WrappedLine:
        s = 2;
        break;
      case r.RawUnit.Page:
        s = 3;
        break;
      case r.RawUnit.HalfPage:
        s = 4;
        break;
      case r.RawUnit.Editor:
        s = 5;
        break;
      case r.RawUnit.Column:
        s = 6;
        break;
      default:
        s = 2;
    }
    const o = Math.floor(n.value || 1), a = !!n.revealCursor;
    return {
      direction: i,
      unit: s,
      value: o,
      revealCursor: a,
      select: !!n.select
    };
  }
  r.parse = t;
})(Sr || (Sr = {}));
var np;
(function(r) {
  const e = function(t) {
    if (!Rs(t))
      return !1;
    const n = t;
    return !(!Kg(n.lineNumber) && !Vo(n.lineNumber) || !da(n.at) && !Vo(n.at));
  };
  r.metadata = {
    description: "Reveal the given line at the given logical position",
    args: [
      {
        name: "Reveal line argument object",
        description: "Property-value pairs that can be passed through this argument:\n					* 'lineNumber': A mandatory line number value.\n					* 'at': Logical position at which line has to be revealed.\n						```\n						'top', 'center', 'bottom'\n						```\n				",
        constraint: e,
        schema: {
          type: "object",
          required: ["lineNumber"],
          properties: {
            lineNumber: {
              type: ["number", "string"]
            },
            at: {
              type: "string",
              enum: ["top", "center", "bottom"]
            }
          }
        }
      }
    ]
  }, r.RawAtArgument = {
    Top: "top",
    Center: "center",
    Bottom: "bottom"
  };
})(np || (np = {}));
class bL {
  constructor(e) {
    e.addImplementation(1e4, "code-editor", (t, n) => {
      const i = t.get(Ui).getFocusedCodeEditor();
      return i && i.hasTextFocus() ? this._runEditorCommand(t, i, n) : !1;
    }), e.addImplementation(1e3, "generic-dom-input-textarea", (t, n) => {
      const i = ss();
      return i && ["input", "textarea"].indexOf(i.tagName.toLowerCase()) >= 0 ? (this.runDOMCommand(i), !0) : !1;
    }), e.addImplementation(0, "generic-dom", (t, n) => {
      const i = t.get(Ui).getActiveCodeEditor();
      return i ? (i.focus(), this._runEditorCommand(t, i, n)) : !1;
    });
  }
  _runEditorCommand(e, t, n) {
    const i = this.runEditorCommand(e, t, n);
    return i || !0;
  }
}
var qi;
(function(r) {
  class e extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      if (!y.position)
        return;
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, [
        Kr.moveTo(v, v.getPrimaryCursorState(), this._inSelectionMode, y.position, y.viewPosition)
      ]) && y.revealType !== 2 && v.revealAllCursors(y.source, !0, !0);
    }
  }
  r.MoveTo = Je(new e({
    id: "_moveTo",
    inSelectionMode: !1,
    precondition: void 0
  })), r.MoveToSelect = Je(new e({
    id: "_moveToSelect",
    inSelectionMode: !0,
    precondition: void 0
  }));
  class t extends hi {
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement();
      const _ = this._getColumnSelectResult(v, v.getPrimaryCursorState(), v.getCursorColumnSelectData(), y);
      _ !== null && (v.setCursorStates(y.source, 3, _.viewStates.map((S) => Dt.fromViewState(S))), v.setCursorColumnSelectData({
        isReal: !0,
        fromViewLineNumber: _.fromLineNumber,
        fromViewVisualColumn: _.fromVisualColumn,
        toViewLineNumber: _.toLineNumber,
        toViewVisualColumn: _.toVisualColumn
      }), _.reversed ? v.revealTopMostCursor(y.source) : v.revealBottomMostCursor(y.source));
    }
  }
  r.ColumnSelect = Je(new class extends t {
    constructor() {
      super({
        id: "columnSelect",
        precondition: void 0
      });
    }
    _getColumnSelectResult(w, v, y, _) {
      if (typeof _.position > "u" || typeof _.viewPosition > "u" || typeof _.mouseColumn > "u")
        return null;
      const S = w.model.validatePosition(_.position), D = w.coordinatesConverter.validateViewPosition(new le(_.viewPosition.lineNumber, _.viewPosition.column), S), M = _.doColumnSelect ? y.fromViewLineNumber : D.lineNumber, L = _.doColumnSelect ? y.fromViewVisualColumn : _.mouseColumn - 1;
      return v0.columnSelect(w.cursorConfig, w, M, L, D.lineNumber, _.mouseColumn - 1);
    }
  }()), r.CursorColumnSelectLeft = Je(new class extends t {
    constructor() {
      super({
        id: "cursorColumnSelectLeft",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 3599,
          linux: { primary: 0 }
        }
      });
    }
    _getColumnSelectResult(w, v, y, _) {
      return v0.columnSelectLeft(w.cursorConfig, w, y);
    }
  }()), r.CursorColumnSelectRight = Je(new class extends t {
    constructor() {
      super({
        id: "cursorColumnSelectRight",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 3601,
          linux: { primary: 0 }
        }
      });
    }
    _getColumnSelectResult(w, v, y, _) {
      return v0.columnSelectRight(w.cursorConfig, w, y);
    }
  }());
  class n extends t {
    constructor(v) {
      super(v), this._isPaged = v.isPaged;
    }
    _getColumnSelectResult(v, y, _, S) {
      return v0.columnSelectUp(v.cursorConfig, v, _, this._isPaged);
    }
  }
  r.CursorColumnSelectUp = Je(new n({
    isPaged: !1,
    id: "cursorColumnSelectUp",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3600,
      linux: { primary: 0 }
    }
  })), r.CursorColumnSelectPageUp = Je(new n({
    isPaged: !0,
    id: "cursorColumnSelectPageUp",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3595,
      linux: { primary: 0 }
    }
  }));
  class i extends t {
    constructor(v) {
      super(v), this._isPaged = v.isPaged;
    }
    _getColumnSelectResult(v, y, _, S) {
      return v0.columnSelectDown(v.cursorConfig, v, _, this._isPaged);
    }
  }
  r.CursorColumnSelectDown = Je(new i({
    isPaged: !1,
    id: "cursorColumnSelectDown",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3602,
      linux: { primary: 0 }
    }
  })), r.CursorColumnSelectPageDown = Je(new i({
    isPaged: !0,
    id: "cursorColumnSelectPageDown",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3596,
      linux: { primary: 0 }
    }
  }));
  class s extends hi {
    constructor() {
      super({
        id: "cursorMove",
        precondition: void 0,
        metadata: c9.metadata
      });
    }
    runCoreEditorCommand(v, y) {
      const _ = c9.parse(y);
      _ && this._runCursorMove(v, y.source, _);
    }
    _runCursorMove(v, y, _) {
      v.model.pushStackElement(), v.setCursorStates(y, 3, s._move(v, v.getCursorStates(), _)), v.revealAllCursors(y, !0);
    }
    static _move(v, y, _) {
      const S = _.select, D = _.value;
      switch (_.direction) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          return Kr.simpleMove(v, y, _.direction, S, D, _.unit);
        case 11:
        case 13:
        case 12:
        case 14:
          return Kr.viewportMove(v, y, _.direction, S, D);
        default:
          return null;
      }
    }
  }
  r.CursorMoveImpl = s, r.CursorMove = Je(new s());
  class o extends hi {
    constructor(v) {
      super(v), this._staticArgs = v.args;
    }
    runCoreEditorCommand(v, y) {
      let _ = this._staticArgs;
      this._staticArgs.value === -1 && (_ = {
        direction: this._staticArgs.direction,
        unit: this._staticArgs.unit,
        select: this._staticArgs.select,
        value: y.pageSize || v.cursorConfig.pageSize
      }), v.model.pushStackElement(), v.setCursorStates(y.source, 3, Kr.simpleMove(v, v.getCursorStates(), _.direction, _.select, _.value, _.unit)), v.revealAllCursors(y.source, !0);
    }
  }
  r.CursorLeft = Je(new o({
    args: {
      direction: 0,
      unit: 0,
      select: !1,
      value: 1
    },
    id: "cursorLeft",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 15,
      mac: { primary: 15, secondary: [
        288
        /* KeyCode.KeyB */
      ] }
    }
  })), r.CursorLeftSelect = Je(new o({
    args: {
      direction: 0,
      unit: 0,
      select: !0,
      value: 1
    },
    id: "cursorLeftSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1039
      /* KeyCode.LeftArrow */
    }
  })), r.CursorRight = Je(new o({
    args: {
      direction: 1,
      unit: 0,
      select: !1,
      value: 1
    },
    id: "cursorRight",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 17,
      mac: { primary: 17, secondary: [
        292
        /* KeyCode.KeyF */
      ] }
    }
  })), r.CursorRightSelect = Je(new o({
    args: {
      direction: 1,
      unit: 0,
      select: !0,
      value: 1
    },
    id: "cursorRightSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1041
      /* KeyCode.RightArrow */
    }
  })), r.CursorUp = Je(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !1,
      value: 1
    },
    id: "cursorUp",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 16,
      mac: { primary: 16, secondary: [
        302
        /* KeyCode.KeyP */
      ] }
    }
  })), r.CursorUpSelect = Je(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !0,
      value: 1
    },
    id: "cursorUpSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1040,
      secondary: [
        3088
        /* KeyCode.UpArrow */
      ],
      mac: {
        primary: 1040
        /* KeyCode.UpArrow */
      },
      linux: {
        primary: 1040
        /* KeyCode.UpArrow */
      }
    }
  })), r.CursorPageUp = Je(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !1,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageUp",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 11
      /* KeyCode.PageUp */
    }
  })), r.CursorPageUpSelect = Je(new o({
    args: {
      direction: 2,
      unit: 2,
      select: !0,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageUpSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1035
      /* KeyCode.PageUp */
    }
  })), r.CursorDown = Je(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !1,
      value: 1
    },
    id: "cursorDown",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 18,
      mac: { primary: 18, secondary: [
        300
        /* KeyCode.KeyN */
      ] }
    }
  })), r.CursorDownSelect = Je(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !0,
      value: 1
    },
    id: "cursorDownSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1042,
      secondary: [
        3090
        /* KeyCode.DownArrow */
      ],
      mac: {
        primary: 1042
        /* KeyCode.DownArrow */
      },
      linux: {
        primary: 1042
        /* KeyCode.DownArrow */
      }
    }
  })), r.CursorPageDown = Je(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !1,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageDown",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 12
      /* KeyCode.PageDown */
    }
  })), r.CursorPageDownSelect = Je(new o({
    args: {
      direction: 3,
      unit: 2,
      select: !0,
      value: -1
      /* Constants.PAGE_SIZE_MARKER */
    },
    id: "cursorPageDownSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1036
      /* KeyCode.PageDown */
    }
  })), r.CreateCursor = Je(new class extends hi {
    constructor() {
      super({
        id: "createCursor",
        precondition: void 0
      });
    }
    runCoreEditorCommand(w, v) {
      if (!v.position)
        return;
      let y;
      v.wholeLine ? y = Kr.line(w, w.getPrimaryCursorState(), !1, v.position, v.viewPosition) : y = Kr.moveTo(w, w.getPrimaryCursorState(), !1, v.position, v.viewPosition);
      const _ = w.getCursorStates();
      if (_.length > 1) {
        const S = y.modelState ? y.modelState.position : null, D = y.viewState ? y.viewState.position : null;
        for (let M = 0, L = _.length; M < L; M++) {
          const T = _[M];
          if (!(S && !T.modelState.selection.containsPosition(S)) && !(D && !T.viewState.selection.containsPosition(D))) {
            _.splice(M, 1), w.model.pushStackElement(), w.setCursorStates(v.source, 3, _);
            return;
          }
        }
      }
      _.push(y), w.model.pushStackElement(), w.setCursorStates(v.source, 3, _);
    }
  }()), r.LastCursorMoveToSelect = Je(new class extends hi {
    constructor() {
      super({
        id: "_lastCursorMoveToSelect",
        precondition: void 0
      });
    }
    runCoreEditorCommand(w, v) {
      if (!v.position)
        return;
      const y = w.getLastAddedCursorIndex(), _ = w.getCursorStates(), S = _.slice(0);
      S[y] = Kr.moveTo(w, _[y], !0, v.position, v.viewPosition), w.model.pushStackElement(), w.setCursorStates(v.source, 3, S);
    }
  }());
  class a extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, Kr.moveToBeginningOfLine(v, v.getCursorStates(), this._inSelectionMode)), v.revealAllCursors(y.source, !0);
    }
  }
  r.CursorHome = Je(new a({
    inSelectionMode: !1,
    id: "cursorHome",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 14,
      mac: { primary: 14, secondary: [
        2063
        /* KeyCode.LeftArrow */
      ] }
    }
  })), r.CursorHomeSelect = Je(new a({
    inSelectionMode: !0,
    id: "cursorHomeSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1038,
      mac: { primary: 1038, secondary: [
        3087
        /* KeyCode.LeftArrow */
      ] }
    }
  }));
  class l extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, this._exec(v.getCursorStates())), v.revealAllCursors(y.source, !0);
    }
    _exec(v) {
      const y = [];
      for (let _ = 0, S = v.length; _ < S; _++) {
        const D = v[_], M = D.modelState.position.lineNumber;
        y[_] = Dt.fromModelState(D.modelState.move(this._inSelectionMode, M, 1, 0));
      }
      return y;
    }
  }
  r.CursorLineStart = Je(new l({
    inSelectionMode: !1,
    id: "cursorLineStart",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 0,
      mac: {
        primary: 287
        /* KeyCode.KeyA */
      }
    }
  })), r.CursorLineStartSelect = Je(new l({
    inSelectionMode: !0,
    id: "cursorLineStartSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 0,
      mac: {
        primary: 1311
        /* KeyCode.KeyA */
      }
    }
  }));
  class c extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, Kr.moveToEndOfLine(v, v.getCursorStates(), this._inSelectionMode, y.sticky || !1)), v.revealAllCursors(y.source, !0);
    }
  }
  r.CursorEnd = Je(new c({
    inSelectionMode: !1,
    id: "cursorEnd",
    precondition: void 0,
    kbOpts: {
      args: { sticky: !1 },
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 13,
      mac: { primary: 13, secondary: [
        2065
        /* KeyCode.RightArrow */
      ] }
    },
    metadata: {
      description: "Go to End",
      args: [{
        name: "args",
        schema: {
          type: "object",
          properties: {
            sticky: {
              description: C("stickydesc", "Stick to the end even when going to longer lines"),
              type: "boolean",
              default: !1
            }
          }
        }
      }]
    }
  })), r.CursorEndSelect = Je(new c({
    inSelectionMode: !0,
    id: "cursorEndSelect",
    precondition: void 0,
    kbOpts: {
      args: { sticky: !1 },
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 1037,
      mac: { primary: 1037, secondary: [
        3089
        /* KeyCode.RightArrow */
      ] }
    },
    metadata: {
      description: "Select to End",
      args: [{
        name: "args",
        schema: {
          type: "object",
          properties: {
            sticky: {
              description: C("stickydesc", "Stick to the end even when going to longer lines"),
              type: "boolean",
              default: !1
            }
          }
        }
      }]
    }
  }));
  class d extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, this._exec(v, v.getCursorStates())), v.revealAllCursors(y.source, !0);
    }
    _exec(v, y) {
      const _ = [];
      for (let S = 0, D = y.length; S < D; S++) {
        const M = y[S], L = M.modelState.position.lineNumber, T = v.model.getLineMaxColumn(L);
        _[S] = Dt.fromModelState(M.modelState.move(this._inSelectionMode, L, T, 0));
      }
      return _;
    }
  }
  r.CursorLineEnd = Je(new d({
    inSelectionMode: !1,
    id: "cursorLineEnd",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 0,
      mac: {
        primary: 291
        /* KeyCode.KeyE */
      }
    }
  })), r.CursorLineEndSelect = Je(new d({
    inSelectionMode: !0,
    id: "cursorLineEndSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 0,
      mac: {
        primary: 1315
        /* KeyCode.KeyE */
      }
    }
  }));
  class u extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, Kr.moveToBeginningOfBuffer(v, v.getCursorStates(), this._inSelectionMode)), v.revealAllCursors(y.source, !0);
    }
  }
  r.CursorTop = Je(new u({
    inSelectionMode: !1,
    id: "cursorTop",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 2062,
      mac: {
        primary: 2064
        /* KeyCode.UpArrow */
      }
    }
  })), r.CursorTopSelect = Je(new u({
    inSelectionMode: !0,
    id: "cursorTopSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3086,
      mac: {
        primary: 3088
        /* KeyCode.UpArrow */
      }
    }
  }));
  class f extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      v.model.pushStackElement(), v.setCursorStates(y.source, 3, Kr.moveToEndOfBuffer(v, v.getCursorStates(), this._inSelectionMode)), v.revealAllCursors(y.source, !0);
    }
  }
  r.CursorBottom = Je(new f({
    inSelectionMode: !1,
    id: "cursorBottom",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 2061,
      mac: {
        primary: 2066
        /* KeyCode.DownArrow */
      }
    }
  })), r.CursorBottomSelect = Je(new f({
    inSelectionMode: !0,
    id: "cursorBottomSelect",
    precondition: void 0,
    kbOpts: {
      weight: jt,
      kbExpr: Me.textInputFocus,
      primary: 3085,
      mac: {
        primary: 3090
        /* KeyCode.DownArrow */
      }
    }
  }));
  class p extends hi {
    constructor() {
      super({
        id: "editorScroll",
        precondition: void 0,
        metadata: Sr.metadata
      });
    }
    determineScrollMethod(v) {
      const y = [
        6
        /* EditorScroll_.Unit.Column */
      ], _ = [
        1,
        2,
        3,
        4,
        5,
        6
        /* EditorScroll_.Unit.Column */
      ], S = [
        4,
        2
        /* EditorScroll_.Direction.Right */
      ], D = [
        1,
        3
        /* EditorScroll_.Direction.Down */
      ];
      return y.includes(v.unit) && S.includes(v.direction) ? this._runHorizontalEditorScroll.bind(this) : _.includes(v.unit) && D.includes(v.direction) ? this._runVerticalEditorScroll.bind(this) : null;
    }
    runCoreEditorCommand(v, y) {
      const _ = Sr.parse(y);
      if (!_)
        return;
      const S = this.determineScrollMethod(_);
      S && S(v, y.source, _);
    }
    _runVerticalEditorScroll(v, y, _) {
      const S = this._computeDesiredScrollTop(v, _);
      if (_.revealCursor) {
        const D = v.getCompletelyVisibleViewRangeAtScrollTop(S);
        v.setCursorStates(y, 3, [
          Kr.findPositionInViewportIfOutside(v, v.getPrimaryCursorState(), D, _.select)
        ]);
      }
      v.viewLayout.setScrollPosition(
        { scrollTop: S },
        0
        /* ScrollType.Smooth */
      );
    }
    _computeDesiredScrollTop(v, y) {
      if (y.unit === 1) {
        const D = v.viewLayout.getFutureViewport(), M = v.getCompletelyVisibleViewRangeAtScrollTop(D.top), L = v.coordinatesConverter.convertViewRangeToModelRange(M);
        let T;
        y.direction === 1 ? T = Math.max(1, L.startLineNumber - y.value) : T = Math.min(v.model.getLineCount(), L.startLineNumber + y.value);
        const B = v.coordinatesConverter.convertModelPositionToViewPosition(new le(T, 1));
        return v.viewLayout.getVerticalOffsetForLineNumber(B.lineNumber);
      }
      if (y.unit === 5) {
        let D = 0;
        return y.direction === 3 && (D = v.model.getLineCount() - v.cursorConfig.pageSize), v.viewLayout.getVerticalOffsetForLineNumber(D);
      }
      let _;
      y.unit === 3 ? _ = v.cursorConfig.pageSize * y.value : y.unit === 4 ? _ = Math.round(v.cursorConfig.pageSize / 2) * y.value : _ = y.value;
      const S = (y.direction === 1 ? -1 : 1) * _;
      return v.viewLayout.getCurrentScrollTop() + S * v.cursorConfig.lineHeight;
    }
    _runHorizontalEditorScroll(v, y, _) {
      const S = this._computeDesiredScrollLeft(v, _);
      v.viewLayout.setScrollPosition(
        { scrollLeft: S },
        0
        /* ScrollType.Smooth */
      );
    }
    _computeDesiredScrollLeft(v, y) {
      const _ = (y.direction === 4 ? -1 : 1) * y.value;
      return v.viewLayout.getCurrentScrollLeft() + _ * v.cursorConfig.typicalHalfwidthCharacterWidth;
    }
  }
  r.EditorScrollImpl = p, r.EditorScroll = Je(new p()), r.ScrollLineUp = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollLineUp",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 2064,
          mac: {
            primary: 267
            /* KeyCode.PageUp */
          }
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Up,
        by: Sr.RawUnit.WrappedLine,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollPageUp = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollPageUp",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 2059,
          win: {
            primary: 523
            /* KeyCode.PageUp */
          },
          linux: {
            primary: 523
            /* KeyCode.PageUp */
          }
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Up,
        by: Sr.RawUnit.Page,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollEditorTop = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollEditorTop",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Up,
        by: Sr.RawUnit.Editor,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollLineDown = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollLineDown",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 2066,
          mac: {
            primary: 268
            /* KeyCode.PageDown */
          }
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Down,
        by: Sr.RawUnit.WrappedLine,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollPageDown = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollPageDown",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 2060,
          win: {
            primary: 524
            /* KeyCode.PageDown */
          },
          linux: {
            primary: 524
            /* KeyCode.PageDown */
          }
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Down,
        by: Sr.RawUnit.Page,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollEditorBottom = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollEditorBottom",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Down,
        by: Sr.RawUnit.Editor,
        value: 1,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollLeft = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollLeft",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Left,
        by: Sr.RawUnit.Column,
        value: 2,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }()), r.ScrollRight = Je(new class extends hi {
    constructor() {
      super({
        id: "scrollRight",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus
        }
      });
    }
    runCoreEditorCommand(w, v) {
      r.EditorScroll.runCoreEditorCommand(w, {
        to: Sr.RawDirection.Right,
        by: Sr.RawUnit.Column,
        value: 2,
        revealCursor: !1,
        select: !1,
        source: v.source
      });
    }
  }());
  class g extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      y.position && (v.model.pushStackElement(), v.setCursorStates(y.source, 3, [
        Kr.word(v, v.getPrimaryCursorState(), this._inSelectionMode, y.position)
      ]), y.revealType !== 2 && v.revealAllCursors(y.source, !0, !0));
    }
  }
  r.WordSelect = Je(new g({
    inSelectionMode: !1,
    id: "_wordSelect",
    precondition: void 0
  })), r.WordSelectDrag = Je(new g({
    inSelectionMode: !0,
    id: "_wordSelectDrag",
    precondition: void 0
  })), r.LastCursorWordSelect = Je(new class extends hi {
    constructor() {
      super({
        id: "lastCursorWordSelect",
        precondition: void 0
      });
    }
    runCoreEditorCommand(w, v) {
      if (!v.position)
        return;
      const y = w.getLastAddedCursorIndex(), _ = w.getCursorStates(), S = _.slice(0), D = _[y];
      S[y] = Kr.word(w, D, D.modelState.hasSelection(), v.position), w.model.pushStackElement(), w.setCursorStates(v.source, 3, S);
    }
  }());
  class m extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      y.position && (v.model.pushStackElement(), v.setCursorStates(y.source, 3, [
        Kr.line(v, v.getPrimaryCursorState(), this._inSelectionMode, y.position, y.viewPosition)
      ]), y.revealType !== 2 && v.revealAllCursors(y.source, !1, !0));
    }
  }
  r.LineSelect = Je(new m({
    inSelectionMode: !1,
    id: "_lineSelect",
    precondition: void 0
  })), r.LineSelectDrag = Je(new m({
    inSelectionMode: !0,
    id: "_lineSelectDrag",
    precondition: void 0
  }));
  class A extends hi {
    constructor(v) {
      super(v), this._inSelectionMode = v.inSelectionMode;
    }
    runCoreEditorCommand(v, y) {
      if (!y.position)
        return;
      const _ = v.getLastAddedCursorIndex(), S = v.getCursorStates(), D = S.slice(0);
      D[_] = Kr.line(v, S[_], this._inSelectionMode, y.position, y.viewPosition), v.model.pushStackElement(), v.setCursorStates(y.source, 3, D);
    }
  }
  r.LastCursorLineSelect = Je(new A({
    inSelectionMode: !1,
    id: "lastCursorLineSelect",
    precondition: void 0
  })), r.LastCursorLineSelectDrag = Je(new A({
    inSelectionMode: !0,
    id: "lastCursorLineSelectDrag",
    precondition: void 0
  })), r.CancelSelection = Je(new class extends hi {
    constructor() {
      super({
        id: "cancelSelection",
        precondition: Me.hasNonEmptySelection,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 9,
          secondary: [
            1033
            /* KeyCode.Escape */
          ]
        }
      });
    }
    runCoreEditorCommand(w, v) {
      w.model.pushStackElement(), w.setCursorStates(v.source, 3, [
        Kr.cancelSelection(w, w.getPrimaryCursorState())
      ]), w.revealAllCursors(v.source, !0);
    }
  }()), r.RemoveSecondaryCursors = Je(new class extends hi {
    constructor() {
      super({
        id: "removeSecondaryCursors",
        precondition: Me.hasMultipleSelections,
        kbOpts: {
          weight: jt + 1,
          kbExpr: Me.textInputFocus,
          primary: 9,
          secondary: [
            1033
            /* KeyCode.Escape */
          ]
        }
      });
    }
    runCoreEditorCommand(w, v) {
      w.model.pushStackElement(), w.setCursorStates(v.source, 3, [
        w.getPrimaryCursorState()
      ]), w.revealAllCursors(v.source, !0), J8(C("removedCursor", "Removed secondary cursors"));
    }
  }()), r.RevealLine = Je(new class extends hi {
    constructor() {
      super({
        id: "revealLine",
        precondition: void 0,
        metadata: np.metadata
      });
    }
    runCoreEditorCommand(w, v) {
      const y = v, _ = y.lineNumber || 0;
      let S = typeof _ == "number" ? _ + 1 : parseInt(_) + 1;
      S < 1 && (S = 1);
      const D = w.model.getLineCount();
      S > D && (S = D);
      const M = new Q(S, 1, S, w.model.getLineMaxColumn(S));
      let L = 0;
      if (y.at)
        switch (y.at) {
          case np.RawAtArgument.Top:
            L = 3;
            break;
          case np.RawAtArgument.Center:
            L = 1;
            break;
          case np.RawAtArgument.Bottom:
            L = 4;
            break;
        }
      const T = w.coordinatesConverter.convertModelRangeToViewRange(M);
      w.revealRange(
        v.source,
        !1,
        T,
        L,
        0
        /* ScrollType.Smooth */
      );
    }
  }()), r.SelectAll = new class extends bL {
    constructor() {
      super(x2t);
    }
    runDOMCommand(w) {
      pl && (w.focus(), w.select()), w.ownerDocument.execCommand("selectAll");
    }
    runEditorCommand(w, v, y) {
      const _ = v._getViewModel();
      _ && this.runCoreEditorCommand(_, y);
    }
    runCoreEditorCommand(w, v) {
      w.model.pushStackElement(), w.setCursorStates("keyboard", 3, [
        Kr.selectAll(w, w.getPrimaryCursorState())
      ]);
    }
  }(), r.SetSelection = Je(new class extends hi {
    constructor() {
      super({
        id: "setSelection",
        precondition: void 0
      });
    }
    runCoreEditorCommand(w, v) {
      v.selection && (w.model.pushStackElement(), w.setCursorStates(v.source, 3, [
        Dt.fromModelSelection(v.selection)
      ]));
    }
  }());
})(qi || (qi = {}));
const pwt = mt.and(Me.textInputFocus, Me.columnSelection);
function im(r, e) {
  Kf.registerKeybindingRule({
    id: r,
    primary: e,
    when: pwt,
    weight: jt + 1
  });
}
im(
  qi.CursorColumnSelectLeft.id,
  1039
  /* KeyCode.LeftArrow */
);
im(
  qi.CursorColumnSelectRight.id,
  1041
  /* KeyCode.RightArrow */
);
im(
  qi.CursorColumnSelectUp.id,
  1040
  /* KeyCode.UpArrow */
);
im(
  qi.CursorColumnSelectPageUp.id,
  1035
  /* KeyCode.PageUp */
);
im(
  qi.CursorColumnSelectDown.id,
  1042
  /* KeyCode.DownArrow */
);
im(
  qi.CursorColumnSelectPageDown.id,
  1036
  /* KeyCode.PageDown */
);
function C6e(r) {
  return r.register(), r;
}
var E6e;
(function(r) {
  class e extends Fd {
    runEditorCommand(n, i, s) {
      const o = i._getViewModel();
      o && this.runCoreEditingCommand(i, o, s || {});
    }
  }
  r.CoreEditingCommand = e, r.LineBreakInsert = Je(new class extends e {
    constructor() {
      super({
        id: "lineBreakInsert",
        precondition: Me.writable,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 0,
          mac: {
            primary: 301
            /* KeyCode.KeyO */
          }
        }
      });
    }
    runCoreEditingCommand(t, n, i) {
      t.pushUndoStop(), t.executeCommands(this.id, uke.lineBreakInsert(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection)));
    }
  }()), r.Outdent = Je(new class extends e {
    constructor() {
      super({
        id: "outdent",
        precondition: Me.writable,
        kbOpts: {
          weight: jt,
          kbExpr: mt.and(Me.editorTextFocus, Me.tabDoesNotMoveFocus),
          primary: 1026
          /* KeyCode.Tab */
        }
      });
    }
    runCoreEditingCommand(t, n, i) {
      t.pushUndoStop(), t.executeCommands(this.id, b0.outdent(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection))), t.pushUndoStop();
    }
  }()), r.Tab = Je(new class extends e {
    constructor() {
      super({
        id: "tab",
        precondition: Me.writable,
        kbOpts: {
          weight: jt,
          kbExpr: mt.and(Me.editorTextFocus, Me.tabDoesNotMoveFocus),
          primary: 2
          /* KeyCode.Tab */
        }
      });
    }
    runCoreEditingCommand(t, n, i) {
      t.pushUndoStop(), t.executeCommands(this.id, b0.tab(n.cursorConfig, n.model, n.getCursorStates().map((s) => s.modelState.selection))), t.pushUndoStop();
    }
  }()), r.DeleteLeft = Je(new class extends e {
    constructor() {
      super({
        id: "deleteLeft",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 1,
          secondary: [
            1025
            /* KeyCode.Backspace */
          ],
          mac: { primary: 1, secondary: [
            1025,
            294,
            257
            /* KeyCode.Backspace */
          ] }
        }
      });
    }
    runCoreEditingCommand(t, n, i) {
      const [s, o] = Ef.deleteLeft(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection), n.getCursorAutoClosedCharacters());
      s && t.pushUndoStop(), t.executeCommands(this.id, o), n.setPrevEditOperationType(
        2
        /* EditOperationType.DeletingLeft */
      );
    }
  }()), r.DeleteRight = Je(new class extends e {
    constructor() {
      super({
        id: "deleteRight",
        precondition: void 0,
        kbOpts: {
          weight: jt,
          kbExpr: Me.textInputFocus,
          primary: 20,
          mac: { primary: 20, secondary: [
            290,
            276
            /* KeyCode.Delete */
          ] }
        }
      });
    }
    runCoreEditingCommand(t, n, i) {
      const [s, o] = Ef.deleteRight(n.getPrevEditOperationType(), n.cursorConfig, n.model, n.getCursorStates().map((a) => a.modelState.selection));
      s && t.pushUndoStop(), t.executeCommands(this.id, o), n.setPrevEditOperationType(
        3
        /* EditOperationType.DeletingRight */
      );
    }
  }()), r.Undo = new class extends bL {
    constructor() {
      super(jDe);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("undo");
    }
    runEditorCommand(t, n, i) {
      if (!(!n.hasModel() || n.getOption(
        92
        /* EditorOption.readOnly */
      ) === !0))
        return n.getModel().undo();
    }
  }(), r.Redo = new class extends bL {
    constructor() {
      super(ZDe);
    }
    runDOMCommand(t) {
      t.ownerDocument.execCommand("redo");
    }
    runEditorCommand(t, n, i) {
      if (!(!n.hasModel() || n.getOption(
        92
        /* EditorOption.readOnly */
      ) === !0))
        return n.getModel().redo();
    }
  }();
})(E6e || (E6e = {}));
class _6e extends X7 {
  constructor(e, t, n) {
    super({
      id: e,
      precondition: void 0,
      metadata: n
    }), this._handlerId = t;
  }
  runCommand(e, t) {
    const n = e.get(Ui).getFocusedCodeEditor();
    n && n.trigger("keyboard", this._handlerId, t);
  }
}
function n2(r, e) {
  C6e(new _6e("default:" + r, r)), C6e(new _6e(r, r, e));
}
n2("type", {
  description: "Type",
  args: [{
    name: "args",
    schema: {
      type: "object",
      required: ["text"],
      properties: {
        text: {
          type: "string"
        }
      }
    }
  }]
});
n2(
  "replacePreviousChar"
  /* Handler.ReplacePreviousChar */
);
n2(
  "compositionType"
  /* Handler.CompositionType */
);
n2(
  "compositionStart"
  /* Handler.CompositionStart */
);
n2(
  "compositionEnd"
  /* Handler.CompositionEnd */
);
n2(
  "paste"
  /* Handler.Paste */
);
n2(
  "cut"
  /* Handler.Cut */
);
class gwt {
  constructor(e, t, n, i) {
    this.configuration = e, this.viewModel = t, this.userInputEvents = n, this.commandDelegate = i;
  }
  paste(e, t, n, i) {
    this.commandDelegate.paste(e, t, n, i);
  }
  type(e) {
    this.commandDelegate.type(e);
  }
  compositionType(e, t, n, i) {
    this.commandDelegate.compositionType(e, t, n, i);
  }
  compositionStart() {
    this.commandDelegate.startComposition();
  }
  compositionEnd() {
    this.commandDelegate.endComposition();
  }
  cut() {
    this.commandDelegate.cut();
  }
  setSelection(e) {
    qi.SetSelection.runCoreEditorCommand(this.viewModel, {
      source: "keyboard",
      selection: e
    });
  }
  _validateViewColumn(e) {
    const t = this.viewModel.getLineMinColumn(e.lineNumber);
    return e.column < t ? new le(e.lineNumber, t) : e;
  }
  _hasMulticursorModifier(e) {
    switch (this.configuration.options.get(
      78
      /* EditorOption.multiCursorModifier */
    )) {
      case "altKey":
        return e.altKey;
      case "ctrlKey":
        return e.ctrlKey;
      case "metaKey":
        return e.metaKey;
      default:
        return !1;
    }
  }
  _hasNonMulticursorModifier(e) {
    switch (this.configuration.options.get(
      78
      /* EditorOption.multiCursorModifier */
    )) {
      case "altKey":
        return e.ctrlKey || e.metaKey;
      case "ctrlKey":
        return e.altKey || e.metaKey;
      case "metaKey":
        return e.ctrlKey || e.altKey;
      default:
        return !1;
    }
  }
  dispatchMouse(e) {
    const t = this.configuration.options, n = Cs && t.get(
      108
      /* EditorOption.selectionClipboard */
    ), i = t.get(
      22
      /* EditorOption.columnSelection */
    );
    e.middleButton && !n ? this._columnSelect(e.position, e.mouseColumn, e.inSelectionMode) : e.startedOnLineNumbers ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelect(e.position, e.revealType) : this._createCursor(e.position, !0) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount >= 4 ? this._selectAll() : e.mouseDownCount === 3 ? this._hasMulticursorModifier(e) ? e.inSelectionMode ? this._lastCursorLineSelectDrag(e.position, e.revealType) : this._lastCursorLineSelect(e.position, e.revealType) : e.inSelectionMode ? this._lineSelectDrag(e.position, e.revealType) : this._lineSelect(e.position, e.revealType) : e.mouseDownCount === 2 ? e.onInjectedText || (this._hasMulticursorModifier(e) ? this._lastCursorWordSelect(e.position, e.revealType) : e.inSelectionMode ? this._wordSelectDrag(e.position, e.revealType) : this._wordSelect(e.position, e.revealType)) : this._hasMulticursorModifier(e) ? this._hasNonMulticursorModifier(e) || (e.shiftKey ? this._columnSelect(e.position, e.mouseColumn, !0) : e.inSelectionMode ? this._lastCursorMoveToSelect(e.position, e.revealType) : this._createCursor(e.position, !1)) : e.inSelectionMode ? e.altKey ? this._columnSelect(e.position, e.mouseColumn, !0) : i ? this._columnSelect(e.position, e.mouseColumn, !0) : this._moveToSelect(e.position, e.revealType) : this.moveTo(e.position, e.revealType);
  }
  _usualArgs(e, t) {
    return e = this._validateViewColumn(e), {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      revealType: t
    };
  }
  moveTo(e, t) {
    qi.MoveTo.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _moveToSelect(e, t) {
    qi.MoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _columnSelect(e, t, n) {
    e = this._validateViewColumn(e), qi.ColumnSelect.runCoreEditorCommand(this.viewModel, {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      mouseColumn: t,
      doColumnSelect: n
    });
  }
  _createCursor(e, t) {
    e = this._validateViewColumn(e), qi.CreateCursor.runCoreEditorCommand(this.viewModel, {
      source: "mouse",
      position: this._convertViewToModelPosition(e),
      viewPosition: e,
      wholeLine: t
    });
  }
  _lastCursorMoveToSelect(e, t) {
    qi.LastCursorMoveToSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelect(e, t) {
    qi.WordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _wordSelectDrag(e, t) {
    qi.WordSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorWordSelect(e, t) {
    qi.LastCursorWordSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelect(e, t) {
    qi.LineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lineSelectDrag(e, t) {
    qi.LineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelect(e, t) {
    qi.LastCursorLineSelect.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _lastCursorLineSelectDrag(e, t) {
    qi.LastCursorLineSelectDrag.runCoreEditorCommand(this.viewModel, this._usualArgs(e, t));
  }
  _selectAll() {
    qi.SelectAll.runCoreEditorCommand(this.viewModel, { source: "mouse" });
  }
  // ----------------------
  _convertViewToModelPosition(e) {
    return this.viewModel.coordinatesConverter.convertViewPositionToModelPosition(e);
  }
  emitKeyDown(e) {
    this.userInputEvents.emitKeyDown(e);
  }
  emitKeyUp(e) {
    this.userInputEvents.emitKeyUp(e);
  }
  emitContextMenu(e) {
    this.userInputEvents.emitContextMenu(e);
  }
  emitMouseMove(e) {
    this.userInputEvents.emitMouseMove(e);
  }
  emitMouseLeave(e) {
    this.userInputEvents.emitMouseLeave(e);
  }
  emitMouseUp(e) {
    this.userInputEvents.emitMouseUp(e);
  }
  emitMouseDown(e) {
    this.userInputEvents.emitMouseDown(e);
  }
  emitMouseDrag(e) {
    this.userInputEvents.emitMouseDrag(e);
  }
  emitMouseDrop(e) {
    this.userInputEvents.emitMouseDrop(e);
  }
  emitMouseDropCanceled() {
    this.userInputEvents.emitMouseDropCanceled();
  }
  emitMouseWheel(e) {
    this.userInputEvents.emitMouseWheel(e);
  }
}
class gke {
  constructor(e) {
    this._createLine = e, this._set(1, []);
  }
  flush() {
    this._set(1, []);
  }
  _set(e, t) {
    this._lines = t, this._rendLineNumberStart = e;
  }
  _get() {
    return {
      rendLineNumberStart: this._rendLineNumberStart,
      lines: this._lines
    };
  }
  /**
   * @returns Inclusive line number that is inside this collection
   */
  getStartLineNumber() {
    return this._rendLineNumberStart;
  }
  /**
   * @returns Inclusive line number that is inside this collection
   */
  getEndLineNumber() {
    return this._rendLineNumberStart + this._lines.length - 1;
  }
  getCount() {
    return this._lines.length;
  }
  getLine(e) {
    const t = e - this._rendLineNumberStart;
    if (t < 0 || t >= this._lines.length)
      throw new cn("Illegal value for lineNumber");
    return this._lines[t];
  }
  /**
   * @returns Lines that were removed from this collection
   */
  onLinesDeleted(e, t) {
    if (this.getCount() === 0)
      return null;
    const n = this.getStartLineNumber(), i = this.getEndLineNumber();
    if (t < n) {
      const l = t - e + 1;
      return this._rendLineNumberStart -= l, null;
    }
    if (e > i)
      return null;
    let s = 0, o = 0;
    for (let l = n; l <= i; l++) {
      const c = l - this._rendLineNumberStart;
      e <= l && l <= t && (o === 0 ? (s = c, o = 1) : o++);
    }
    if (e < n) {
      let l = 0;
      t < n ? l = t - e + 1 : l = n - e, this._rendLineNumberStart -= l;
    }
    return this._lines.splice(s, o);
  }
  onLinesChanged(e, t) {
    const n = e + t - 1;
    if (this.getCount() === 0)
      return !1;
    const i = this.getStartLineNumber(), s = this.getEndLineNumber();
    let o = !1;
    for (let a = e; a <= n; a++)
      a >= i && a <= s && (this._lines[a - this._rendLineNumberStart].onContentChanged(), o = !0);
    return o;
  }
  onLinesInserted(e, t) {
    if (this.getCount() === 0)
      return null;
    const n = t - e + 1, i = this.getStartLineNumber(), s = this.getEndLineNumber();
    if (e <= i)
      return this._rendLineNumberStart += n, null;
    if (e > s)
      return null;
    if (n + e > s)
      return this._lines.splice(e - this._rendLineNumberStart, s - e + 1);
    const o = [];
    for (let u = 0; u < n; u++)
      o[u] = this._createLine();
    const a = e - this._rendLineNumberStart, l = this._lines.slice(0, a), c = this._lines.slice(a, this._lines.length - n), d = this._lines.slice(this._lines.length - n, this._lines.length);
    return this._lines = l.concat(o).concat(c), d;
  }
  onTokensChanged(e) {
    if (this.getCount() === 0)
      return !1;
    const t = this.getStartLineNumber(), n = this.getEndLineNumber();
    let i = !1;
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      if (a.toLineNumber < t || a.fromLineNumber > n)
        continue;
      const l = Math.max(t, a.fromLineNumber), c = Math.min(n, a.toLineNumber);
      for (let d = l; d <= c; d++) {
        const u = d - this._rendLineNumberStart;
        this._lines[u].onTokensChanged(), i = !0;
      }
    }
    return i;
  }
}
class mke {
  constructor(e) {
    this._host = e, this.domNode = this._createDomNode(), this._linesCollection = new gke(() => this._host.createVisibleLine());
  }
  _createDomNode() {
    const e = Yt(document.createElement("div"));
    return e.setClassName("view-layer"), e.setPosition("absolute"), e.domNode.setAttribute("role", "presentation"), e.domNode.setAttribute("aria-hidden", "true"), e;
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    return !!e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    );
  }
  onFlushed(e) {
    return this._linesCollection.flush(), !0;
  }
  onLinesChanged(e) {
    return this._linesCollection.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    const t = this._linesCollection.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
    if (t)
      for (let n = 0, i = t.length; n < i; n++)
        t[n].getDomNode()?.remove();
    return !0;
  }
  onLinesInserted(e) {
    const t = this._linesCollection.onLinesInserted(e.fromLineNumber, e.toLineNumber);
    if (t)
      for (let n = 0, i = t.length; n < i; n++)
        t[n].getDomNode()?.remove();
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onTokensChanged(e) {
    return this._linesCollection.onTokensChanged(e.ranges);
  }
  onZonesChanged(e) {
    return !0;
  }
  // ---- end view event handlers
  getStartLineNumber() {
    return this._linesCollection.getStartLineNumber();
  }
  getEndLineNumber() {
    return this._linesCollection.getEndLineNumber();
  }
  getVisibleLine(e) {
    return this._linesCollection.getLine(e);
  }
  renderLines(e) {
    const t = this._linesCollection._get(), n = new y0(this.domNode.domNode, this._host, e), i = {
      rendLineNumberStart: t.rendLineNumberStart,
      lines: t.lines,
      linesLength: t.lines.length
    }, s = n.render(i, e.startLineNumber, e.endLineNumber, e.relativeVerticalOffset);
    this._linesCollection._set(s.rendLineNumberStart, s.lines);
  }
}
class y0 {
  static {
    this._ttPolicy = Jf("editorViewLayer", { createHTML: (e) => e });
  }
  constructor(e, t, n) {
    this.domNode = e, this.host = t, this.viewportData = n;
  }
  render(e, t, n, i) {
    const s = {
      rendLineNumberStart: e.rendLineNumberStart,
      lines: e.lines.slice(0),
      linesLength: e.linesLength
    };
    if (s.rendLineNumberStart + s.linesLength - 1 < t || n < s.rendLineNumberStart) {
      s.rendLineNumberStart = t, s.linesLength = n - t + 1, s.lines = [];
      for (let o = t; o <= n; o++)
        s.lines[o - t] = this.host.createVisibleLine();
      return this._finishRendering(s, !0, i), s;
    }
    if (this._renderUntouchedLines(s, Math.max(t - s.rendLineNumberStart, 0), Math.min(n - s.rendLineNumberStart, s.linesLength - 1), i, t), s.rendLineNumberStart > t) {
      const o = t, a = Math.min(n, s.rendLineNumberStart - 1);
      o <= a && (this._insertLinesBefore(s, o, a, i, t), s.linesLength += a - o + 1);
    } else if (s.rendLineNumberStart < t) {
      const o = Math.min(s.linesLength, t - s.rendLineNumberStart);
      o > 0 && (this._removeLinesBefore(s, o), s.linesLength -= o);
    }
    if (s.rendLineNumberStart = t, s.rendLineNumberStart + s.linesLength - 1 < n) {
      const o = s.rendLineNumberStart + s.linesLength, a = n;
      o <= a && (this._insertLinesAfter(s, o, a, i, t), s.linesLength += a - o + 1);
    } else if (s.rendLineNumberStart + s.linesLength - 1 > n) {
      const o = Math.max(0, n - s.rendLineNumberStart + 1), l = s.linesLength - 1 - o + 1;
      l > 0 && (this._removeLinesAfter(s, l), s.linesLength -= l);
    }
    return this._finishRendering(s, !1, i), s;
  }
  _renderUntouchedLines(e, t, n, i, s) {
    const o = e.rendLineNumberStart, a = e.lines;
    for (let l = t; l <= n; l++) {
      const c = o + l;
      a[l].layoutLine(c, i[c - s], this.viewportData.lineHeight);
    }
  }
  _insertLinesBefore(e, t, n, i, s) {
    const o = [];
    let a = 0;
    for (let l = t; l <= n; l++)
      o[a++] = this.host.createVisibleLine();
    e.lines = o.concat(e.lines);
  }
  _removeLinesBefore(e, t) {
    for (let n = 0; n < t; n++)
      e.lines[n].getDomNode()?.remove();
    e.lines.splice(0, t);
  }
  _insertLinesAfter(e, t, n, i, s) {
    const o = [];
    let a = 0;
    for (let l = t; l <= n; l++)
      o[a++] = this.host.createVisibleLine();
    e.lines = e.lines.concat(o);
  }
  _removeLinesAfter(e, t) {
    const n = e.linesLength - t;
    for (let i = 0; i < t; i++)
      e.lines[n + i].getDomNode()?.remove();
    e.lines.splice(n, t);
  }
  _finishRenderingNewLines(e, t, n, i) {
    y0._ttPolicy && (n = y0._ttPolicy.createHTML(n));
    const s = this.domNode.lastChild;
    t || !s ? this.domNode.innerHTML = n : s.insertAdjacentHTML("afterend", n);
    let o = this.domNode.lastChild;
    for (let a = e.linesLength - 1; a >= 0; a--) {
      const l = e.lines[a];
      i[a] && (l.setDomNode(o), o = o.previousSibling);
    }
  }
  _finishRenderingInvalidLines(e, t, n) {
    const i = document.createElement("div");
    y0._ttPolicy && (t = y0._ttPolicy.createHTML(t)), i.innerHTML = t;
    for (let s = 0; s < e.linesLength; s++) {
      const o = e.lines[s];
      if (n[s]) {
        const a = i.firstChild, l = o.getDomNode();
        l.parentNode.replaceChild(a, l), o.setDomNode(a);
      }
    }
  }
  static {
    this._sb = new J7(1e5);
  }
  _finishRendering(e, t, n) {
    const i = y0._sb, s = e.linesLength, o = e.lines, a = e.rendLineNumberStart, l = [];
    {
      i.reset();
      let c = !1;
      for (let d = 0; d < s; d++) {
        const u = o[d];
        l[d] = !1, !(u.getDomNode() || !u.renderLine(d + a, n[d], this.viewportData.lineHeight, this.viewportData, i)) && (l[d] = !0, c = !0);
      }
      c && this._finishRenderingNewLines(e, t, i.build(), l);
    }
    {
      i.reset();
      let c = !1;
      const d = [];
      for (let u = 0; u < s; u++) {
        const f = o[u];
        d[u] = !1, !(l[u] || !f.renderLine(u + a, n[u], this.viewportData.lineHeight, this.viewportData, i)) && (d[u] = !0, c = !0);
      }
      c && this._finishRenderingInvalidLines(e, i.build(), d);
    }
  }
}
class Ake extends uo {
  constructor(e) {
    super(e), this._visibleLines = new mke(this), this.domNode = this._visibleLines.domNode;
    const n = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    Br(this.domNode, n), this._dynamicOverlays = [], this._isFocused = !1, this.domNode.setClassName("view-overlays");
  }
  shouldRender() {
    if (super.shouldRender())
      return !0;
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      if (this._dynamicOverlays[e].shouldRender())
        return !0;
    return !1;
  }
  dispose() {
    super.dispose();
    for (let e = 0, t = this._dynamicOverlays.length; e < t; e++)
      this._dynamicOverlays[e].dispose();
    this._dynamicOverlays = [];
  }
  getDomNode() {
    return this.domNode;
  }
  // ---- begin IVisibleLinesHost
  createVisibleLine() {
    return new mwt(this._dynamicOverlays);
  }
  // ---- end IVisibleLinesHost
  addDynamicOverlay(e) {
    this._dynamicOverlays.push(e);
  }
  // ----- event handlers
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e);
    const n = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    return Br(this.domNode, n), !0;
  }
  onFlushed(e) {
    return this._visibleLines.onFlushed(e);
  }
  onFocusChanged(e) {
    return this._isFocused = e.isFocused, !0;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onScrollChanged(e) {
    return this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._visibleLines.onZonesChanged(e);
  }
  // ----- end event handlers
  prepareRender(e) {
    const t = this._dynamicOverlays.filter((n) => n.shouldRender());
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      s.prepareRender(e), s.onDidRender();
    }
  }
  render(e) {
    this._viewOverlaysRender(e), this.domNode.toggleClassName("focused", this._isFocused);
  }
  _viewOverlaysRender(e) {
    this._visibleLines.renderLines(e.viewportData);
  }
}
class mwt {
  constructor(e) {
    this._dynamicOverlays = e, this._domNode = null, this._renderedContent = null;
  }
  getDomNode() {
    return this._domNode ? this._domNode.domNode : null;
  }
  setDomNode(e) {
    this._domNode = Yt(e);
  }
  onContentChanged() {
  }
  onTokensChanged() {
  }
  renderLine(e, t, n, i, s) {
    let o = "";
    for (let a = 0, l = this._dynamicOverlays.length; a < l; a++) {
      const c = this._dynamicOverlays[a];
      o += c.render(i.startLineNumber, e);
    }
    return this._renderedContent === o ? !1 : (this._renderedContent = o, s.appendString('<div style="top:'), s.appendString(String(t)), s.appendString("px;height:"), s.appendString(String(n)), s.appendString('px;">'), s.appendString(o), s.appendString("</div>"), !0);
  }
  layoutLine(e, t, n) {
    this._domNode && (this._domNode.setTop(t), this._domNode.setHeight(n));
  }
}
class Awt extends Ake {
  constructor(e) {
    super(e);
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._contentWidth = n.contentWidth, this.domNode.setHeight(0);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._contentWidth = n.contentWidth, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollWidthChanged;
  }
  // --- end event handlers
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e), this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth));
  }
}
class wwt extends Ake {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._contentLeft = n.contentLeft, this.domNode.setClassName("margin-view-overlays"), this.domNode.setWidth(1), Br(this.domNode, t.get(
      50
      /* EditorOption.fontInfo */
    ));
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    Br(this.domNode, t.get(
      50
      /* EditorOption.fontInfo */
    ));
    const n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._contentLeft = n.contentLeft, super.onConfigurationChanged(e) || !0;
  }
  onScrollChanged(e) {
    return super.onScrollChanged(e) || e.scrollHeightChanged;
  }
  _viewOverlaysRender(e) {
    super._viewOverlaysRender(e);
    const t = Math.min(e.scrollHeight, 1e6);
    this.domNode.setHeight(t), this.domNode.setWidth(this._contentLeft);
  }
}
class Ay {
  constructor(e) {
    this.onKeyDown = null, this.onKeyUp = null, this.onContextMenu = null, this.onMouseMove = null, this.onMouseLeave = null, this.onMouseDown = null, this.onMouseUp = null, this.onMouseDrag = null, this.onMouseDrop = null, this.onMouseDropCanceled = null, this.onMouseWheel = null, this._coordinatesConverter = e;
  }
  emitKeyDown(e) {
    this.onKeyDown?.(e);
  }
  emitKeyUp(e) {
    this.onKeyUp?.(e);
  }
  emitContextMenu(e) {
    this.onContextMenu?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseMove(e) {
    this.onMouseMove?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseLeave(e) {
    this.onMouseLeave?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseDown(e) {
    this.onMouseDown?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseUp(e) {
    this.onMouseUp?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrag(e) {
    this.onMouseDrag?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseDrop(e) {
    this.onMouseDrop?.(this._convertViewToModelMouseEvent(e));
  }
  emitMouseDropCanceled() {
    this.onMouseDropCanceled?.();
  }
  emitMouseWheel(e) {
    this.onMouseWheel?.(e);
  }
  _convertViewToModelMouseEvent(e) {
    return e.target ? {
      event: e.event,
      target: this._convertViewToModelMouseTarget(e.target)
    } : e;
  }
  _convertViewToModelMouseTarget(e) {
    return Ay.convertViewToModelMouseTarget(e, this._coordinatesConverter);
  }
  static convertViewToModelMouseTarget(e, t) {
    const n = { ...e };
    return n.position && (n.position = t.convertViewPositionToModelPosition(n.position)), n.range && (n.range = t.convertViewRangeToModelRange(n.range)), (n.type === 5 || n.type === 8) && (n.detail = this.convertViewToModelViewZoneData(n.detail, t)), n;
  }
  static convertViewToModelViewZoneData(e, t) {
    return {
      viewZoneId: e.viewZoneId,
      positionBefore: e.positionBefore ? t.convertViewPositionToModelPosition(e.positionBefore) : e.positionBefore,
      positionAfter: e.positionAfter ? t.convertViewPositionToModelPosition(e.positionAfter) : e.positionAfter,
      position: t.convertViewPositionToModelPosition(e.position),
      afterLineNumber: t.convertViewPositionToModelPosition(new le(e.afterLineNumber, 1)).lineNumber
    };
  }
}
class vwt extends uo {
  constructor(e) {
    super(e), this.blocks = [], this.contentWidth = -1, this.contentLeft = 0, this.domNode = Yt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("blockDecorations-container"), this.update();
  }
  update() {
    let e = !1;
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    ), i = n.contentWidth - n.verticalScrollbarWidth;
    this.contentWidth !== i && (this.contentWidth = i, e = !0);
    const s = n.contentLeft;
    return this.contentLeft !== s && (this.contentLeft = s, e = !0), e;
  }
  dispose() {
    super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return this.update();
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollLeftChanged;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    let t = 0;
    const n = e.getDecorationsInViewport();
    for (const i of n) {
      if (!i.options.blockClassName)
        continue;
      let s = this.blocks[t];
      s || (s = this.blocks[t] = Yt(document.createElement("div")), this.domNode.appendChild(s));
      let o, a;
      i.options.blockIsAfterEnd ? (o = e.getVerticalOffsetAfterLineNumber(i.range.endLineNumber, !1), a = e.getVerticalOffsetAfterLineNumber(i.range.endLineNumber, !0)) : (o = e.getVerticalOffsetForLineNumber(i.range.startLineNumber, !0), a = i.range.isEmpty() && !i.options.blockDoesNotCollapse ? e.getVerticalOffsetForLineNumber(i.range.startLineNumber, !1) : e.getVerticalOffsetAfterLineNumber(i.range.endLineNumber, !0));
      const [l, c, d, u] = i.options.blockPadding ?? [0, 0, 0, 0];
      s.setClassName("blockDecorations-block " + i.options.blockClassName), s.setLeft(this.contentLeft - u), s.setWidth(this.contentWidth + u + c), s.setTop(o - e.scrollTop - l), s.setHeight(a - o + l + d), t++;
    }
    for (let i = t; i < this.blocks.length; i++)
      this.blocks[i].domNode.remove();
    this.blocks.length = t;
  }
}
class bwt extends uo {
  constructor(e, t) {
    super(e), this._viewDomNode = t, this._widgets = {}, this.domNode = Yt(document.createElement("div")), rc.write(
      this.domNode,
      1
      /* PartFingerprint.ContentWidgets */
    ), this.domNode.setClassName("contentWidgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this.overflowingContentWidgetsDomNode = Yt(document.createElement("div")), rc.write(
      this.overflowingContentWidgetsDomNode,
      2
      /* PartFingerprint.OverflowingContentWidgets */
    ), this.overflowingContentWidgetsDomNode.setClassName("overflowingContentWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].onConfigurationChanged(e);
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLineMappingChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesChanged(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesDeleted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onLinesInserted(e) {
    return this._updateAnchorsViewPositions(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onZonesChanged(e) {
    return !0;
  }
  // ---- end view event handlers
  _updateAnchorsViewPositions() {
    const e = Object.keys(this._widgets);
    for (const t of e)
      this._widgets[t].updateAnchorViewPosition();
  }
  addWidget(e) {
    const t = new ywt(this._context, this._viewDomNode, e);
    this._widgets[t.id] = t, t.allowEditorOverflow ? this.overflowingContentWidgetsDomNode.appendChild(t.domNode) : this.domNode.appendChild(t.domNode), this.setShouldRender();
  }
  setWidgetPosition(e, t, n, i, s) {
    this._widgets[e.getId()].setPosition(t, n, i, s), this.setShouldRender();
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const n = this._widgets[t];
      delete this._widgets[t];
      const i = n.domNode.domNode;
      i.remove(), i.removeAttribute("monaco-visible-content-widget"), this.setShouldRender();
    }
  }
  shouldSuppressMouseDownOnWidget(e) {
    return this._widgets.hasOwnProperty(e) ? this._widgets[e].suppressMouseDown : !1;
  }
  onBeforeRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].onBeforeRender(e);
  }
  prepareRender(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].prepareRender(e);
  }
  render(e) {
    const t = Object.keys(this._widgets);
    for (const n of t)
      this._widgets[n].render(e);
  }
}
class ywt {
  constructor(e, t, n) {
    this._primaryAnchor = new Hm(null, null), this._secondaryAnchor = new Hm(null, null), this._context = e, this._viewDomNode = t, this._actual = n, this.domNode = Yt(this._actual.getDomNode()), this.id = this._actual.getId(), this.allowEditorOverflow = this._actual.allowEditorOverflow || !1, this.suppressMouseDown = this._actual.suppressMouseDown || !1;
    const i = this._context.configuration.options, s = i.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._fixedOverflowWidgets = i.get(
      42
      /* EditorOption.fixedOverflowWidgets */
    ), this._contentWidth = s.contentWidth, this._contentLeft = s.contentLeft, this._lineHeight = i.get(
      67
      /* EditorOption.lineHeight */
    ), this._affinity = null, this._preference = [], this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1, this._maxWidth = this._getMaxWidth(), this._isVisible = !1, this._renderData = null, this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? "fixed" : "absolute"), this.domNode.setDisplay("none"), this.domNode.setVisibility("hidden"), this.domNode.setAttribute("widgetId", this.id), this.domNode.setMaxWidth(this._maxWidth);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    if (this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    )) {
      const n = t.get(
        146
        /* EditorOption.layoutInfo */
      );
      this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._maxWidth = this._getMaxWidth();
    }
  }
  updateAnchorViewPosition() {
    this._setPosition(this._affinity, this._primaryAnchor.modelPosition, this._secondaryAnchor.modelPosition);
  }
  _setPosition(e, t, n) {
    this._affinity = e, this._primaryAnchor = i(t, this._context.viewModel, this._affinity), this._secondaryAnchor = i(n, this._context.viewModel, this._affinity);
    function i(s, o, a) {
      if (!s)
        return new Hm(null, null);
      const l = o.model.validatePosition(s);
      if (o.coordinatesConverter.modelPositionIsVisible(l)) {
        const c = o.coordinatesConverter.convertModelPositionToViewPosition(l, a ?? void 0);
        return new Hm(s, c);
      }
      return new Hm(s, null);
    }
  }
  _getMaxWidth() {
    const e = this.domNode.domNode.ownerDocument, t = e.defaultView;
    return this.allowEditorOverflow ? t?.innerWidth || e.documentElement.offsetWidth || e.body.offsetWidth : this._contentWidth;
  }
  setPosition(e, t, n, i) {
    this._setPosition(i, e, t), this._preference = n, this._primaryAnchor.viewPosition && this._preference && this._preference.length > 0 ? this.domNode.setDisplay("block") : this.domNode.setDisplay("none"), this._cachedDomNodeOffsetWidth = -1, this._cachedDomNodeOffsetHeight = -1;
  }
  _layoutBoxInViewport(e, t, n, i) {
    const s = e.top, o = s, a = e.top + e.height, l = i.viewportHeight - a, c = s - n, d = o >= n, u = a, f = l >= n;
    let p = e.left;
    return p + t > i.scrollLeft + i.viewportWidth && (p = i.scrollLeft + i.viewportWidth - t), p < i.scrollLeft && (p = i.scrollLeft), { fitsAbove: d, aboveTop: c, fitsBelow: f, belowTop: u, left: p };
  }
  _layoutHorizontalSegmentInPage(e, t, n, i) {
    const a = Math.max(15, t.left - i), l = Math.min(t.left + t.width + i, e.width - 15), d = this._viewDomNode.domNode.ownerDocument.defaultView;
    let u = t.left + n - (d?.scrollX ?? 0);
    if (u + i > l) {
      const f = u - (l - i);
      u -= f, n -= f;
    }
    if (u < a) {
      const f = u - a;
      u -= f, n -= f;
    }
    return [n, u];
  }
  _layoutBoxInPage(e, t, n, i) {
    const s = e.top - n, o = e.top + e.height, a = To(this._viewDomNode.domNode), l = this._viewDomNode.domNode.ownerDocument, c = l.defaultView, d = a.top + s - (c?.scrollY ?? 0), u = a.top + o - (c?.scrollY ?? 0), f = BD(l.body), [p, g] = this._layoutHorizontalSegmentInPage(f, a, e.left - i.scrollLeft + this._contentLeft, t), m = 22, A = 22, w = d >= m, v = u + n <= f.height - A;
    return this._fixedOverflowWidgets ? {
      fitsAbove: w,
      aboveTop: Math.max(d, m),
      fitsBelow: v,
      belowTop: u,
      left: g
    } : { fitsAbove: w, aboveTop: s, fitsBelow: v, belowTop: o, left: p };
  }
  _prepareRenderWidgetAtExactPositionOverflowing(e) {
    return new Bm(e.top, e.left + this._contentLeft);
  }
  /**
   * Compute the coordinates above and below the primary and secondary anchors.
   * The content widget *must* touch the primary anchor.
   * The content widget should touch if possible the secondary anchor.
   */
  _getAnchorsCoordinates(e) {
    const t = s(this._primaryAnchor.viewPosition, this._affinity, this._lineHeight), n = this._secondaryAnchor.viewPosition?.lineNumber === this._primaryAnchor.viewPosition?.lineNumber ? this._secondaryAnchor.viewPosition : null, i = s(n, this._affinity, this._lineHeight);
    return { primary: t, secondary: i };
    function s(o, a, l) {
      if (!o)
        return null;
      const c = e.visibleRangeForPosition(o);
      if (!c)
        return null;
      const d = o.column === 1 && a === 3 ? 0 : c.left, u = e.getVerticalOffsetForLineNumber(o.lineNumber) - e.scrollTop;
      return new x6e(u, d, l);
    }
  }
  _reduceAnchorCoordinates(e, t, n) {
    if (!t)
      return e;
    const i = this._context.configuration.options.get(
      50
      /* EditorOption.fontInfo */
    );
    let s = t.left;
    return s < e.left ? s = Math.max(s, e.left - n + i.typicalFullwidthCharacterWidth) : s = Math.min(s, e.left + n - i.typicalFullwidthCharacterWidth), new x6e(e.top, s, e.height);
  }
  _prepareRenderWidget(e) {
    if (!this._preference || this._preference.length === 0)
      return null;
    const { primary: t, secondary: n } = this._getAnchorsCoordinates(e);
    if (!t)
      return {
        kind: "offViewport",
        preserveFocus: this.domNode.domNode.contains(this.domNode.domNode.ownerDocument.activeElement)
      };
    if (this._cachedDomNodeOffsetWidth === -1 || this._cachedDomNodeOffsetHeight === -1) {
      let o = null;
      if (typeof this._actual.beforeRender == "function" && (o = KE(this._actual.beforeRender, this._actual)), o)
        this._cachedDomNodeOffsetWidth = o.width, this._cachedDomNodeOffsetHeight = o.height;
      else {
        const l = this.domNode.domNode.getBoundingClientRect();
        this._cachedDomNodeOffsetWidth = Math.round(l.width), this._cachedDomNodeOffsetHeight = Math.round(l.height);
      }
    }
    const i = this._reduceAnchorCoordinates(t, n, this._cachedDomNodeOffsetWidth);
    let s;
    this.allowEditorOverflow ? s = this._layoutBoxInPage(i, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e) : s = this._layoutBoxInViewport(i, this._cachedDomNodeOffsetWidth, this._cachedDomNodeOffsetHeight, e);
    for (let o = 1; o <= 2; o++)
      for (const a of this._preference)
        if (a === 1) {
          if (!s)
            return null;
          if (o === 2 || s.fitsAbove)
            return {
              kind: "inViewport",
              coordinate: new Bm(s.aboveTop, s.left),
              position: 1
              /* ContentWidgetPositionPreference.ABOVE */
            };
        } else if (a === 2) {
          if (!s)
            return null;
          if (o === 2 || s.fitsBelow)
            return {
              kind: "inViewport",
              coordinate: new Bm(s.belowTop, s.left),
              position: 2
              /* ContentWidgetPositionPreference.BELOW */
            };
        } else
          return this.allowEditorOverflow ? {
            kind: "inViewport",
            coordinate: this._prepareRenderWidgetAtExactPositionOverflowing(new Bm(i.top, i.left)),
            position: 0
            /* ContentWidgetPositionPreference.EXACT */
          } : {
            kind: "inViewport",
            coordinate: new Bm(i.top, i.left),
            position: 0
            /* ContentWidgetPositionPreference.EXACT */
          };
    return null;
  }
  /**
   * On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
   */
  onBeforeRender(e) {
    !this._primaryAnchor.viewPosition || !this._preference || this._primaryAnchor.viewPosition.lineNumber < e.startLineNumber || this._primaryAnchor.viewPosition.lineNumber > e.endLineNumber || this.domNode.setMaxWidth(this._maxWidth);
  }
  prepareRender(e) {
    this._renderData = this._prepareRenderWidget(e);
  }
  render(e) {
    if (!this._renderData || this._renderData.kind === "offViewport") {
      this._isVisible && (this.domNode.removeAttribute("monaco-visible-content-widget"), this._isVisible = !1, this._renderData?.kind === "offViewport" && this._renderData.preserveFocus ? this.domNode.setTop(-1e3) : this.domNode.setVisibility("hidden")), typeof this._actual.afterRender == "function" && KE(this._actual.afterRender, this._actual, null);
      return;
    }
    this.allowEditorOverflow ? (this.domNode.setTop(this._renderData.coordinate.top), this.domNode.setLeft(this._renderData.coordinate.left)) : (this.domNode.setTop(this._renderData.coordinate.top + e.scrollTop - e.bigNumbersDelta), this.domNode.setLeft(this._renderData.coordinate.left)), this._isVisible || (this.domNode.setVisibility("inherit"), this.domNode.setAttribute("monaco-visible-content-widget", "true"), this._isVisible = !0), typeof this._actual.afterRender == "function" && KE(this._actual.afterRender, this._actual, this._renderData.position);
  }
}
class Hm {
  constructor(e, t) {
    this.modelPosition = e, this.viewPosition = t;
  }
}
class Bm {
  constructor(e, t) {
    this.top = e, this.left = t, this._coordinateBrand = void 0;
  }
}
class x6e {
  constructor(e, t, n) {
    this.top = e, this.left = t, this.height = n, this._anchorCoordinateBrand = void 0;
  }
}
function KE(r, e, ...t) {
  try {
    return r.call(e, ...t);
  } catch {
    return null;
  }
}
class wke extends t2 {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._renderLineHighlight = t.get(
      97
      /* EditorOption.renderLineHighlight */
    ), this._renderLineHighlightOnlyWhenFocus = t.get(
      98
      /* EditorOption.renderLineHighlightOnlyWhenFocus */
    ), this._wordWrap = n.isViewportWrapping, this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, this._selectionIsEmpty = !0, this._focused = !1, this._cursorLineNumbers = [1], this._selections = [new _n(1, 1, 1, 1)], this._renderData = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  _readFromSelections() {
    let e = !1;
    const t = /* @__PURE__ */ new Set();
    for (const s of this._selections)
      t.add(s.positionLineNumber);
    const n = Array.from(t);
    n.sort((s, o) => s - o), Zi(this._cursorLineNumbers, n) || (this._cursorLineNumbers = n, e = !0);
    const i = this._selections.every((s) => s.isEmpty());
    return this._selectionIsEmpty !== i && (this._selectionIsEmpty = i, e = !0), e;
  }
  // --- begin event handlers
  onThemeChanged(e) {
    return this._readFromSelections();
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._renderLineHighlight = t.get(
      97
      /* EditorOption.renderLineHighlight */
    ), this._renderLineHighlightOnlyWhenFocus = t.get(
      98
      /* EditorOption.renderLineHighlightOnlyWhenFocus */
    ), this._wordWrap = n.isViewportWrapping, this._contentLeft = n.contentLeft, this._contentWidth = n.contentWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._readFromSelections();
  }
  onFlushed(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollWidthChanged || e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._renderLineHighlightOnlyWhenFocus ? (this._focused = e.isFocused, !0) : !1;
  }
  // --- end event handlers
  prepareRender(e) {
    if (!this._shouldRenderThis()) {
      this._renderData = null;
      return;
    }
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, i = [];
    for (let o = t; o <= n; o++) {
      const a = o - t;
      i[a] = "";
    }
    if (this._wordWrap) {
      const o = this._renderOne(e, !1);
      for (const a of this._cursorLineNumbers) {
        const l = this._context.viewModel.coordinatesConverter, c = l.convertViewPositionToModelPosition(new le(a, 1)).lineNumber, d = l.convertModelPositionToViewPosition(new le(c, 1)).lineNumber, u = l.convertModelPositionToViewPosition(new le(c, this._context.viewModel.model.getLineMaxColumn(c))).lineNumber, f = Math.max(d, t), p = Math.min(u, n);
        for (let g = f; g <= p; g++) {
          const m = g - t;
          i[m] = o;
        }
      }
    }
    const s = this._renderOne(e, !0);
    for (const o of this._cursorLineNumbers) {
      if (o < t || o > n)
        continue;
      const a = o - t;
      i[a] = s;
    }
    this._renderData = i;
  }
  render(e, t) {
    if (!this._renderData)
      return "";
    const n = t - e;
    return n >= this._renderData.length ? "" : this._renderData[n];
  }
  _shouldRenderInMargin() {
    return (this._renderLineHighlight === "gutter" || this._renderLineHighlight === "all") && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
  _shouldRenderInContent() {
    return (this._renderLineHighlight === "line" || this._renderLineHighlight === "all") && this._selectionIsEmpty && (!this._renderLineHighlightOnlyWhenFocus || this._focused);
  }
}
class Cwt extends wke {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-both" : "") + (t ? " current-line-exact" : "")}" style="width:${Math.max(e.scrollWidth, this._contentWidth)}px;"></div>`;
  }
  _shouldRenderThis() {
    return this._shouldRenderInContent();
  }
  _shouldRenderOther() {
    return this._shouldRenderInMargin();
  }
}
class Ewt extends wke {
  _renderOne(e, t) {
    return `<div class="${"current-line" + (this._shouldRenderInMargin() ? " current-line-margin" : "") + (this._shouldRenderOther() ? " current-line-margin-both" : "") + (this._shouldRenderInMargin() && t ? " current-line-exact-margin" : "")}" style="width:${this._contentLeft}px"></div>`;
  }
  _shouldRenderThis() {
    return !0;
  }
  _shouldRenderOther() {
    return this._shouldRenderInContent();
  }
}
Sh((r, e) => {
  const t = r.getColor(eke);
  if (t && (e.addRule(`.monaco-editor .view-overlays .current-line { background-color: ${t}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-margin { background-color: ${t}; border: none; }`)), !t || t.isTransparent() || r.defines(w6e)) {
    const n = r.getColor(w6e);
    n && (e.addRule(`.monaco-editor .view-overlays .current-line-exact { border: 2px solid ${n}; }`), e.addRule(`.monaco-editor .margin-view-overlays .current-line-exact-margin { border: 2px solid ${n}; }`), $u(r.type) && (e.addRule(".monaco-editor .view-overlays .current-line-exact { border-width: 1px; }"), e.addRule(".monaco-editor .margin-view-overlays .current-line-exact-margin { border-width: 1px; }")));
  }
});
class _wt extends t2 {
  constructor(e) {
    super(), this._context = e;
    const t = this._context.configuration.options;
    this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    const t = e.getDecorationsInViewport();
    let n = [], i = 0;
    for (let l = 0, c = t.length; l < c; l++) {
      const d = t[l];
      d.options.className && (n[i++] = d);
    }
    n = n.sort((l, c) => {
      if (l.options.zIndex < c.options.zIndex)
        return -1;
      if (l.options.zIndex > c.options.zIndex)
        return 1;
      const d = l.options.className, u = c.options.className;
      return d < u ? -1 : d > u ? 1 : Q.compareRangesUsingStarts(l.range, c.range);
    });
    const s = e.visibleRange.startLineNumber, o = e.visibleRange.endLineNumber, a = [];
    for (let l = s; l <= o; l++) {
      const c = l - s;
      a[c] = "";
    }
    this._renderWholeLineDecorations(e, n, a), this._renderNormalDecorations(e, n, a), this._renderResult = a;
  }
  _renderWholeLineDecorations(e, t, n) {
    const i = e.visibleRange.startLineNumber, s = e.visibleRange.endLineNumber;
    for (let o = 0, a = t.length; o < a; o++) {
      const l = t[o];
      if (!l.options.isWholeLine)
        continue;
      const c = '<div class="cdr ' + l.options.className + '" style="left:0;width:100%;"></div>', d = Math.max(l.range.startLineNumber, i), u = Math.min(l.range.endLineNumber, s);
      for (let f = d; f <= u; f++) {
        const p = f - i;
        n[p] += c;
      }
    }
  }
  _renderNormalDecorations(e, t, n) {
    const i = e.visibleRange.startLineNumber;
    let s = null, o = !1, a = null, l = !1;
    for (let c = 0, d = t.length; c < d; c++) {
      const u = t[c];
      if (u.options.isWholeLine)
        continue;
      const f = u.options.className, p = !!u.options.showIfCollapsed;
      let g = u.range;
      if (p && g.endColumn === 1 && g.endLineNumber !== g.startLineNumber && (g = new Q(g.startLineNumber, g.startColumn, g.endLineNumber - 1, this._context.viewModel.getLineMaxColumn(g.endLineNumber - 1))), s === f && o === p && Q.areIntersectingOrTouching(a, g)) {
        a = Q.plusRange(a, g);
        continue;
      }
      s !== null && this._renderNormalDecoration(e, a, s, l, o, i, n), s = f, o = p, a = g, l = u.options.shouldFillLineOnLineBreak ?? !1;
    }
    s !== null && this._renderNormalDecoration(e, a, s, l, o, i, n);
  }
  _renderNormalDecoration(e, t, n, i, s, o, a) {
    const l = e.linesVisibleRangesForRange(
      t,
      /*TODO@Alex*/
      n === "findMatch"
    );
    if (l)
      for (let c = 0, d = l.length; c < d; c++) {
        const u = l[c];
        if (u.outsideRenderedLine)
          continue;
        const f = u.lineNumber - o;
        if (s && u.ranges.length === 1) {
          const p = u.ranges[0];
          if (p.width < this._typicalHalfwidthCharacterWidth) {
            const g = Math.round(p.left + p.width / 2), m = Math.max(0, Math.round(g - this._typicalHalfwidthCharacterWidth / 2));
            u.ranges[0] = new hy(m, this._typicalHalfwidthCharacterWidth);
          }
        }
        for (let p = 0, g = u.ranges.length; p < g; p++) {
          const m = i && u.continuesOnNextLine && g === 1, A = u.ranges[p], w = '<div class="cdr ' + n + '" style="left:' + String(A.left) + "px;width:" + (m ? "100%;" : String(A.width) + "px;") + '"></div>';
          a[f] += w;
        }
      }
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class xwt extends uo {
  constructor(e, t, n, i) {
    super(e);
    const s = this._context.configuration.options, o = s.get(
      104
      /* EditorOption.scrollbar */
    ), a = s.get(
      75
      /* EditorOption.mouseWheelScrollSensitivity */
    ), l = s.get(
      40
      /* EditorOption.fastScrollSensitivity */
    ), c = s.get(
      107
      /* EditorOption.scrollPredominantAxis */
    ), d = {
      listenOnDomNode: n.domNode,
      className: "editor-scrollable " + AL(e.theme.type),
      useShadows: !1,
      lazyRender: !0,
      vertical: o.vertical,
      horizontal: o.horizontal,
      verticalHasArrows: o.verticalHasArrows,
      horizontalHasArrows: o.horizontalHasArrows,
      verticalScrollbarSize: o.verticalScrollbarSize,
      verticalSliderSize: o.verticalSliderSize,
      horizontalScrollbarSize: o.horizontalScrollbarSize,
      horizontalSliderSize: o.horizontalSliderSize,
      handleMouseWheel: o.handleMouseWheel,
      alwaysConsumeMouseWheel: o.alwaysConsumeMouseWheel,
      arrowSize: o.arrowSize,
      mouseWheelScrollSensitivity: a,
      fastScrollSensitivity: l,
      scrollPredominantAxis: c,
      scrollByPage: o.scrollByPage
    };
    this.scrollbar = this._register(new fy(t.domNode, d, this._context.viewLayout.getScrollable())), rc.write(
      this.scrollbar.getDomNode(),
      6
      /* PartFingerprint.ScrollableElement */
    ), this.scrollbarDomNode = Yt(this.scrollbar.getDomNode()), this.scrollbarDomNode.setPosition("absolute"), this._setLayout();
    const u = (f, p, g) => {
      const m = {};
      {
        const A = f.scrollTop;
        A && (m.scrollTop = this._context.viewLayout.getCurrentScrollTop() + A, f.scrollTop = 0);
      }
      if (g) {
        const A = f.scrollLeft;
        A && (m.scrollLeft = this._context.viewLayout.getCurrentScrollLeft() + A, f.scrollLeft = 0);
      }
      this._context.viewModel.viewLayout.setScrollPosition(
        m,
        1
        /* ScrollType.Immediate */
      );
    };
    this._register(fe(n.domNode, "scroll", (f) => u(n.domNode, !0, !0))), this._register(fe(t.domNode, "scroll", (f) => u(t.domNode, !0, !1))), this._register(fe(i.domNode, "scroll", (f) => u(i.domNode, !0, !1))), this._register(fe(this.scrollbarDomNode.domNode, "scroll", (f) => u(this.scrollbarDomNode.domNode, !0, !1)));
  }
  dispose() {
    super.dispose();
  }
  _setLayout() {
    const e = this._context.configuration.options, t = e.get(
      146
      /* EditorOption.layoutInfo */
    );
    this.scrollbarDomNode.setLeft(t.contentLeft), e.get(
      73
      /* EditorOption.minimap */
    ).side === "right" ? this.scrollbarDomNode.setWidth(t.contentWidth + t.minimap.minimapWidth) : this.scrollbarDomNode.setWidth(t.contentWidth), this.scrollbarDomNode.setHeight(t.height);
  }
  getOverviewRulerLayoutInfo() {
    return this.scrollbar.getOverviewRulerLayoutInfo();
  }
  getDomNode() {
    return this.scrollbarDomNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    this.scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this.scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    if (e.hasChanged(
      104
      /* EditorOption.scrollbar */
    ) || e.hasChanged(
      75
      /* EditorOption.mouseWheelScrollSensitivity */
    ) || e.hasChanged(
      40
      /* EditorOption.fastScrollSensitivity */
    )) {
      const t = this._context.configuration.options, n = t.get(
        104
        /* EditorOption.scrollbar */
      ), i = t.get(
        75
        /* EditorOption.mouseWheelScrollSensitivity */
      ), s = t.get(
        40
        /* EditorOption.fastScrollSensitivity */
      ), o = t.get(
        107
        /* EditorOption.scrollPredominantAxis */
      ), a = {
        vertical: n.vertical,
        horizontal: n.horizontal,
        verticalScrollbarSize: n.verticalScrollbarSize,
        horizontalScrollbarSize: n.horizontalScrollbarSize,
        scrollByPage: n.scrollByPage,
        handleMouseWheel: n.handleMouseWheel,
        mouseWheelScrollSensitivity: i,
        fastScrollSensitivity: s,
        scrollPredominantAxis: o
      };
      this.scrollbar.updateOptions(a);
    }
    return e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    ) && this._setLayout(), !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onThemeChanged(e) {
    return this.scrollbar.updateClassName("editor-scrollable " + AL(this._context.theme.type)), !0;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this.scrollbar.renderNow();
  }
}
class yL {
  constructor(e, t, n, i, s) {
    this.startLineNumber = e, this.endLineNumber = t, this.className = n, this.tooltip = i, this._decorationToRenderBrand = void 0, this.zIndex = s ?? 0;
  }
}
class Swt {
  constructor(e, t, n) {
    this.className = e, this.zIndex = t, this.tooltip = n;
  }
}
class Mwt {
  constructor() {
    this.decorations = [];
  }
  add(e) {
    this.decorations.push(e);
  }
  getDecorations() {
    return this.decorations;
  }
}
class vke extends t2 {
  /**
   * Returns an array with an element for each visible line number.
   */
  _render(e, t, n) {
    const i = [];
    for (let a = e; a <= t; a++) {
      const l = a - e;
      i[l] = new Mwt();
    }
    if (n.length === 0)
      return i;
    n.sort((a, l) => a.className === l.className ? a.startLineNumber === l.startLineNumber ? a.endLineNumber - l.endLineNumber : a.startLineNumber - l.startLineNumber : a.className < l.className ? -1 : 1);
    let s = null, o = 0;
    for (let a = 0, l = n.length; a < l; a++) {
      const c = n[a], d = c.className, u = c.zIndex;
      let f = Math.max(c.startLineNumber, e) - e;
      const p = Math.min(c.endLineNumber, t) - e;
      s === d ? (f = Math.max(o + 1, f), o = Math.max(o, p)) : (s = d, o = p);
      for (let g = f; g <= o; g++)
        i[g].add(new Swt(d, u, c.tooltip));
    }
    return i;
  }
}
class Dwt extends uo {
  constructor(e) {
    super(e), this._widgets = {}, this._context = e;
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this.domNode = Yt(document.createElement("div")), this.domNode.setClassName("glyph-margin-widgets"), this.domNode.setPosition("absolute"), this.domNode.setTop(0), this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._glyphMargin = t.get(
      57
      /* EditorOption.glyphMargin */
    ), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, this._managedDomNodes = [], this._decorationGlyphsToRender = [];
  }
  dispose() {
    this._managedDomNodes = [], this._decorationGlyphsToRender = [], this._widgets = {}, super.dispose();
  }
  getWidgets() {
    return Object.values(this._widgets);
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._glyphMargin = t.get(
      57
      /* EditorOption.glyphMargin */
    ), this._glyphMarginLeft = n.glyphMarginLeft, this._glyphMarginWidth = n.glyphMarginWidth, this._glyphMarginDecorationLaneCount = n.glyphMarginDecorationLaneCount, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // --- begin widget management
  addWidget(e) {
    const t = Yt(e.getDomNode());
    this._widgets[e.getId()] = {
      widget: e,
      preference: e.getPosition(),
      domNode: t,
      renderInfo: null
    }, t.setPosition("absolute"), t.setDisplay("none"), t.setAttribute("widgetId", e.getId()), this.domNode.appendChild(t), this.setShouldRender();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()];
    return n.preference.lane === t.lane && n.preference.zIndex === t.zIndex && Q.equalsRange(n.preference.range, t.range) ? !1 : (n.preference = t, this.setShouldRender(), !0);
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets[t]) {
      const i = this._widgets[t].domNode.domNode;
      delete this._widgets[t], i.remove(), this.setShouldRender();
    }
  }
  // --- end widget management
  _collectDecorationBasedGlyphRenderRequest(e, t) {
    const n = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber, s = e.getDecorationsInViewport();
    for (const o of s) {
      const a = o.options.glyphMarginClassName;
      if (!a)
        continue;
      const l = Math.max(o.range.startLineNumber, n), c = Math.min(o.range.endLineNumber, i), d = o.options.glyphMargin?.position ?? h1.Center, u = o.options.zIndex ?? 0;
      for (let f = l; f <= c; f++) {
        const p = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new le(f, 0)), g = this._context.viewModel.glyphLanes.getLanesAtLine(p.lineNumber).indexOf(d);
        t.push(new Lwt(f, g, u, a));
      }
    }
  }
  _collectWidgetBasedGlyphRenderRequest(e, t) {
    const n = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber;
    for (const s of Object.values(this._widgets)) {
      const o = s.preference.range, { startLineNumber: a, endLineNumber: l } = this._context.viewModel.coordinatesConverter.convertModelRangeToViewRange(Q.lift(o));
      if (!a || !l || l < n || a > i)
        continue;
      const c = Math.max(a, n), d = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new le(c, 0)), u = this._context.viewModel.glyphLanes.getLanesAtLine(d.lineNumber).indexOf(s.preference.lane);
      t.push(new kwt(c, u, s.preference.zIndex, s));
    }
  }
  _collectSortedGlyphRenderRequests(e) {
    const t = [];
    return this._collectDecorationBasedGlyphRenderRequest(e, t), this._collectWidgetBasedGlyphRenderRequest(e, t), t.sort((n, i) => n.lineNumber === i.lineNumber ? n.laneIndex === i.laneIndex ? n.zIndex === i.zIndex ? i.type === n.type ? n.type === 0 && i.type === 0 ? n.className < i.className ? -1 : 1 : 0 : i.type - n.type : i.zIndex - n.zIndex : n.laneIndex - i.laneIndex : n.lineNumber - i.lineNumber), t;
  }
  /**
   * Will store render information in each widget's renderInfo and in `_decorationGlyphsToRender`.
   */
  prepareRender(e) {
    if (!this._glyphMargin) {
      this._decorationGlyphsToRender = [];
      return;
    }
    for (const i of Object.values(this._widgets))
      i.renderInfo = null;
    const t = new Hd(this._collectSortedGlyphRenderRequests(e)), n = [];
    for (; t.length > 0; ) {
      const i = t.peek();
      if (!i)
        break;
      const s = t.takeWhile((a) => a.lineNumber === i.lineNumber && a.laneIndex === i.laneIndex);
      if (!s || s.length === 0)
        break;
      const o = s[0];
      if (o.type === 0) {
        const a = [];
        for (const l of s) {
          if (l.zIndex !== o.zIndex || l.type !== o.type)
            break;
          (a.length === 0 || a[a.length - 1] !== l.className) && a.push(l.className);
        }
        n.push(o.accept(a.join(" ")));
      } else
        o.widget.renderInfo = {
          lineNumber: o.lineNumber,
          laneIndex: o.laneIndex
        };
    }
    this._decorationGlyphsToRender = n;
  }
  render(e) {
    if (!this._glyphMargin) {
      for (const n of Object.values(this._widgets))
        n.domNode.setDisplay("none");
      for (; this._managedDomNodes.length > 0; )
        this._managedDomNodes.pop()?.domNode.remove();
      return;
    }
    const t = Math.round(this._glyphMarginWidth / this._glyphMarginDecorationLaneCount);
    for (const n of Object.values(this._widgets))
      if (!n.renderInfo)
        n.domNode.setDisplay("none");
      else {
        const i = e.viewportData.relativeVerticalOffset[n.renderInfo.lineNumber - e.viewportData.startLineNumber], s = this._glyphMarginLeft + n.renderInfo.laneIndex * this._lineHeight;
        n.domNode.setDisplay("block"), n.domNode.setTop(i), n.domNode.setLeft(s), n.domNode.setWidth(t), n.domNode.setHeight(this._lineHeight);
      }
    for (let n = 0; n < this._decorationGlyphsToRender.length; n++) {
      const i = this._decorationGlyphsToRender[n], s = e.viewportData.relativeVerticalOffset[i.lineNumber - e.viewportData.startLineNumber], o = this._glyphMarginLeft + i.laneIndex * this._lineHeight;
      let a;
      n < this._managedDomNodes.length ? a = this._managedDomNodes[n] : (a = Yt(document.createElement("div")), this._managedDomNodes.push(a), this.domNode.appendChild(a)), a.setClassName("cgmr codicon " + i.combinedClassName), a.setPosition("absolute"), a.setTop(s), a.setLeft(o), a.setWidth(t), a.setHeight(this._lineHeight);
    }
    for (; this._managedDomNodes.length > this._decorationGlyphsToRender.length; )
      this._managedDomNodes.pop()?.domNode.remove();
  }
}
class Lwt {
  constructor(e, t, n, i) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = n, this.className = i, this.type = 0;
  }
  accept(e) {
    return new Nwt(this.lineNumber, this.laneIndex, e);
  }
}
class kwt {
  constructor(e, t, n, i) {
    this.lineNumber = e, this.laneIndex = t, this.zIndex = n, this.widget = i, this.type = 1;
  }
}
class Nwt {
  constructor(e, t, n) {
    this.lineNumber = e, this.laneIndex = t, this.combinedClassName = n;
  }
}
class bke extends me {
  constructor() {
    super(...arguments), this._isDisposed = !1;
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
  assertNotDisposed() {
    if (this._isDisposed)
      throw new Error("TextModelPart is disposed!");
  }
}
function Twt(r, e) {
  let t = 0, n = 0;
  const i = r.length;
  for (; n < i; ) {
    const s = r.charCodeAt(n);
    if (s === 32)
      t++;
    else if (s === 9)
      t = t - t % e + e;
    else
      break;
    n++;
  }
  return n === i ? -1 : t;
}
var Q0;
(function(r) {
  r[r.Disabled = 0] = "Disabled", r[r.EnabledForActive = 1] = "EnabledForActive", r[r.Enabled = 2] = "Enabled";
})(Q0 || (Q0 = {}));
class R0 {
  constructor(e, t, n, i, s, o) {
    if (this.visibleColumn = e, this.column = t, this.className = n, this.horizontalLine = i, this.forWrappedLinesAfterColumn = s, this.forWrappedLinesBeforeOrAtColumn = o, e !== -1 == (t !== -1))
      throw new Error();
  }
}
class UA {
  constructor(e, t) {
    this.top = e, this.endColumn = t;
  }
}
class Iwt extends bke {
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t;
  }
  getLanguageConfiguration(e) {
    return this.languageConfigurationService.getLanguageConfiguration(e);
  }
  _computeIndentLevel(e) {
    return Twt(this.textModel.getLineContent(e + 1), this.textModel.getOptions().tabSize);
  }
  getActiveIndentGuide(e, t, n) {
    this.assertNotDisposed();
    const i = this.textModel.getLineCount();
    if (e < 1 || e > i)
      throw new cn("Illegal value for lineNumber");
    const s = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, o = !!(s && s.offSide);
    let a = -2, l = -1, c = -2, d = -1;
    const u = (M) => {
      if (a !== -1 && (a === -2 || a > M - 1)) {
        a = -1, l = -1;
        for (let L = M - 2; L >= 0; L--) {
          const T = this._computeIndentLevel(L);
          if (T >= 0) {
            a = L, l = T;
            break;
          }
        }
      }
      if (c === -2) {
        c = -1, d = -1;
        for (let L = M; L < i; L++) {
          const T = this._computeIndentLevel(L);
          if (T >= 0) {
            c = L, d = T;
            break;
          }
        }
      }
    };
    let f = -2, p = -1, g = -2, m = -1;
    const A = (M) => {
      if (f === -2) {
        f = -1, p = -1;
        for (let L = M - 2; L >= 0; L--) {
          const T = this._computeIndentLevel(L);
          if (T >= 0) {
            f = L, p = T;
            break;
          }
        }
      }
      if (g !== -1 && (g === -2 || g < M - 1)) {
        g = -1, m = -1;
        for (let L = M; L < i; L++) {
          const T = this._computeIndentLevel(L);
          if (T >= 0) {
            g = L, m = T;
            break;
          }
        }
      }
    };
    let w = 0, v = !0, y = 0, _ = !0, S = 0, D = 0;
    for (let M = 0; v || _; M++) {
      const L = e - M, T = e + M;
      M > 1 && (L < 1 || L < t) && (v = !1), M > 1 && (T > i || T > n) && (_ = !1), M > 5e4 && (v = !1, _ = !1);
      let B = -1;
      if (v && L >= 1) {
        const N = this._computeIndentLevel(L - 1);
        N >= 0 ? (c = L - 1, d = N, B = Math.ceil(N / this.textModel.getOptions().indentSize)) : (u(L), B = this._getIndentLevelForWhitespaceLine(o, l, d));
      }
      let V = -1;
      if (_ && T <= i) {
        const N = this._computeIndentLevel(T - 1);
        N >= 0 ? (f = T - 1, p = N, V = Math.ceil(N / this.textModel.getOptions().indentSize)) : (A(T), V = this._getIndentLevelForWhitespaceLine(o, p, m));
      }
      if (M === 0) {
        D = B;
        continue;
      }
      if (M === 1) {
        if (T <= i && V >= 0 && D + 1 === V) {
          v = !1, w = T, y = T, S = V;
          continue;
        }
        if (L >= 1 && B >= 0 && B - 1 === D) {
          _ = !1, w = L, y = L, S = B;
          continue;
        }
        if (w = e, y = e, S = D, S === 0)
          return { startLineNumber: w, endLineNumber: y, indent: S };
      }
      v && (B >= S ? w = L : v = !1), _ && (V >= S ? y = T : _ = !1);
    }
    return { startLineNumber: w, endLineNumber: y, indent: S };
  }
  getLinesBracketGuides(e, t, n, i) {
    const s = [];
    for (let u = e; u <= t; u++)
      s.push([]);
    const o = !0, a = this.textModel.bracketPairs.getBracketPairsInRangeWithMinIndentation(new Q(e, 1, t, this.textModel.getLineMaxColumn(t))).toArray();
    let l;
    if (n && a.length > 0) {
      const u = (e <= n.lineNumber && n.lineNumber <= t ? a : this.textModel.bracketPairs.getBracketPairsInRange(Q.fromPositions(n)).toArray()).filter((f) => Q.strictContainsPosition(f.range, n));
      l = G8(u, (f) => o)?.range;
    }
    const c = this.textModel.getOptions().bracketPairColorizationOptions.independentColorPoolPerBracketType, d = new yke();
    for (const u of a) {
      if (!u.closingBracketRange)
        continue;
      const f = l && u.range.equalsRange(l);
      if (!f && !i.includeInactive)
        continue;
      const p = d.getInlineClassName(u.nestingLevel, u.nestingLevelOfEqualBracketType, c) + (i.highlightActive && f ? " " + d.activeClassName : ""), g = u.openingBracketRange.getStartPosition(), m = u.closingBracketRange.getStartPosition(), A = i.horizontalGuides === Q0.Enabled || i.horizontalGuides === Q0.EnabledForActive && f;
      if (u.range.startLineNumber === u.range.endLineNumber) {
        A && s[u.range.startLineNumber - e].push(new R0(-1, u.openingBracketRange.getEndPosition().column, p, new UA(!1, m.column), -1, -1));
        continue;
      }
      const w = this.getVisibleColumnFromPosition(m), v = this.getVisibleColumnFromPosition(u.openingBracketRange.getStartPosition()), y = Math.min(v, w, u.minVisibleColumnIndentation + 1);
      let _ = !1;
      so(this.textModel.getLineContent(u.closingBracketRange.startLineNumber)) < u.closingBracketRange.startColumn - 1 && (_ = !0);
      const M = Math.max(g.lineNumber, e), L = Math.min(m.lineNumber, t), T = _ ? 1 : 0;
      for (let B = M; B < L + T; B++)
        s[B - e].push(new R0(y, -1, p, null, B === g.lineNumber ? g.column : -1, B === m.lineNumber ? m.column : -1));
      A && (g.lineNumber >= e && v > y && s[g.lineNumber - e].push(new R0(y, -1, p, new UA(!1, g.column), -1, -1)), m.lineNumber <= t && w > y && s[m.lineNumber - e].push(new R0(y, -1, p, new UA(!_, m.column), -1, -1)));
    }
    for (const u of s)
      u.sort((f, p) => f.visibleColumn - p.visibleColumn);
    return s;
  }
  getVisibleColumnFromPosition(e) {
    return zi.visibleColumnFromColumn(this.textModel.getLineContent(e.lineNumber), e.column, this.textModel.getOptions().tabSize) + 1;
  }
  getLinesIndentGuides(e, t) {
    this.assertNotDisposed();
    const n = this.textModel.getLineCount();
    if (e < 1 || e > n)
      throw new Error("Illegal value for startLineNumber");
    if (t < 1 || t > n)
      throw new Error("Illegal value for endLineNumber");
    const i = this.textModel.getOptions(), s = this.getLanguageConfiguration(this.textModel.getLanguageId()).foldingRules, o = !!(s && s.offSide), a = new Array(t - e + 1);
    let l = -2, c = -1, d = -2, u = -1;
    for (let f = e; f <= t; f++) {
      const p = f - e, g = this._computeIndentLevel(f - 1);
      if (g >= 0) {
        l = f - 1, c = g, a[p] = Math.ceil(g / i.indentSize);
        continue;
      }
      if (l === -2) {
        l = -1, c = -1;
        for (let m = f - 2; m >= 0; m--) {
          const A = this._computeIndentLevel(m);
          if (A >= 0) {
            l = m, c = A;
            break;
          }
        }
      }
      if (d !== -1 && (d === -2 || d < f - 1)) {
        d = -1, u = -1;
        for (let m = f; m < n; m++) {
          const A = this._computeIndentLevel(m);
          if (A >= 0) {
            d = m, u = A;
            break;
          }
        }
      }
      a[p] = this._getIndentLevelForWhitespaceLine(o, c, u);
    }
    return a;
  }
  _getIndentLevelForWhitespaceLine(e, t, n) {
    const i = this.textModel.getOptions();
    return t === -1 || n === -1 ? 0 : t < n ? 1 + Math.floor(t / i.indentSize) : t === n || e ? Math.ceil(n / i.indentSize) : 1 + Math.floor(n / i.indentSize);
  }
}
class yke {
  constructor() {
    this.activeClassName = "indent-active";
  }
  getInlineClassName(e, t, n) {
    return this.getInlineClassNameOfLevel(n ? t : e);
  }
  getInlineClassNameOfLevel(e) {
    return `bracket-indent-guide lvl-${e % 30}`;
  }
}
class Owt extends t2 {
  constructor(e) {
    super(), this._context = e, this._primaryPosition = null;
    const t = this._context.configuration.options, n = t.get(
      147
      /* EditorOption.wrappingInfo */
    ), i = t.get(
      50
      /* EditorOption.fontInfo */
    );
    this._spaceWidth = i.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * i.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(
      16
      /* EditorOption.guides */
    ), this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      147
      /* EditorOption.wrappingInfo */
    ), i = t.get(
      50
      /* EditorOption.fontInfo */
    );
    return this._spaceWidth = i.spaceWidth, this._maxIndentLeft = n.wrappingColumn === -1 ? -1 : n.wrappingColumn * i.typicalHalfwidthCharacterWidth, this._bracketPairGuideOptions = t.get(
      16
      /* EditorOption.guides */
    ), !0;
  }
  onCursorStateChanged(e) {
    const n = e.selections[0].getPosition();
    return this._primaryPosition?.equals(n) ? !1 : (this._primaryPosition = n, !0);
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLanguageConfigurationChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    if (!this._bracketPairGuideOptions.indentation && this._bracketPairGuideOptions.bracketPairs === !1) {
      this._renderResult = null;
      return;
    }
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, i = e.scrollWidth, s = this._primaryPosition, o = this.getGuidesByLine(t, Math.min(n + 1, this._context.viewModel.getLineCount()), s), a = [];
    for (let l = t; l <= n; l++) {
      const c = l - t, d = o[c];
      let u = "";
      const f = e.visibleRangeForPosition(new le(l, 1))?.left ?? 0;
      for (const p of d) {
        const g = p.column === -1 ? f + (p.visibleColumn - 1) * this._spaceWidth : e.visibleRangeForPosition(new le(l, p.column)).left;
        if (g > i || this._maxIndentLeft > 0 && g > this._maxIndentLeft)
          break;
        const m = p.horizontalLine ? p.horizontalLine.top ? "horizontal-top" : "horizontal-bottom" : "vertical", A = p.horizontalLine ? (e.visibleRangeForPosition(new le(l, p.horizontalLine.endColumn))?.left ?? g + this._spaceWidth) - g : this._spaceWidth;
        u += `<div class="core-guide ${p.className} ${m}" style="left:${g}px;width:${A}px"></div>`;
      }
      a[c] = u;
    }
    this._renderResult = a;
  }
  getGuidesByLine(e, t, n) {
    const i = this._bracketPairGuideOptions.bracketPairs !== !1 ? this._context.viewModel.getBracketGuidesInRangeByLine(e, t, n, {
      highlightActive: this._bracketPairGuideOptions.highlightActiveBracketPair,
      horizontalGuides: this._bracketPairGuideOptions.bracketPairsHorizontal === !0 ? Q0.Enabled : this._bracketPairGuideOptions.bracketPairsHorizontal === "active" ? Q0.EnabledForActive : Q0.Disabled,
      includeInactive: this._bracketPairGuideOptions.bracketPairs === !0
    }) : null, s = this._bracketPairGuideOptions.indentation ? this._context.viewModel.getLinesIndentGuides(e, t) : null;
    let o = 0, a = 0, l = 0;
    if (this._bracketPairGuideOptions.highlightActiveIndentation !== !1 && n) {
      const u = this._context.viewModel.getActiveIndentGuide(n.lineNumber, e, t);
      o = u.startLineNumber, a = u.endLineNumber, l = u.indent;
    }
    const { indentSize: c } = this._context.viewModel.model.getOptions(), d = [];
    for (let u = e; u <= t; u++) {
      const f = new Array();
      d.push(f);
      const p = i ? i[u - e] : [], g = new Hd(p), m = s ? s[u - e] : 0;
      for (let A = 1; A <= m; A++) {
        const w = (A - 1) * c + 1, v = (
          // Disable active indent guide if there are bracket guides.
          (this._bracketPairGuideOptions.highlightActiveIndentation === "always" || p.length === 0) && o <= u && u <= a && A === l
        );
        f.push(...g.takeWhile((_) => _.visibleColumn < w) || []);
        const y = g.peek();
        (!y || y.visibleColumn !== w || y.horizontalLine) && f.push(new R0(w, -1, `core-guide-indent lvl-${(A - 1) % 30}` + (v ? " indent-active" : ""), null, -1, -1));
      }
      f.push(...g.takeWhile((A) => !0) || []);
    }
    return d;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
function S2(r) {
  if (!(r && r.isTransparent()))
    return r;
}
Sh((r, e) => {
  const t = [
    { bracketColor: ike, guideColor: _4t, guideColorActive: k4t },
    { bracketColor: rke, guideColor: x4t, guideColorActive: N4t },
    { bracketColor: ske, guideColor: S4t, guideColorActive: T4t },
    { bracketColor: oke, guideColor: M4t, guideColorActive: I4t },
    { bracketColor: ake, guideColor: D4t, guideColorActive: O4t },
    { bracketColor: lke, guideColor: L4t, guideColorActive: R4t }
  ], n = new yke(), i = [
    { indentColor: Lw, indentColorActive: kw },
    { indentColor: i4t, indentColorActive: l4t },
    { indentColor: r4t, indentColorActive: c4t },
    { indentColor: s4t, indentColorActive: h4t },
    { indentColor: o4t, indentColorActive: d4t },
    { indentColor: a4t, indentColorActive: u4t }
  ], s = t.map((a) => {
    const l = r.getColor(a.bracketColor), c = r.getColor(a.guideColor), d = r.getColor(a.guideColorActive), u = S2(S2(c) ?? l?.transparent(0.3)), f = S2(S2(d) ?? l);
    if (!(!u || !f))
      return {
        guideColor: u,
        guideColorActive: f
      };
  }).filter(tg), o = i.map((a) => {
    const l = r.getColor(a.indentColor), c = r.getColor(a.indentColorActive), d = S2(l), u = S2(c);
    if (!(!d || !u))
      return {
        indentColor: d,
        indentColorActive: u
      };
  }).filter(tg);
  if (s.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = s[a % s.length];
      e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(a).replace(/ /g, ".")} { --guide-color: ${l.guideColor}; --guide-color-active: ${l.guideColorActive}; }`);
    }
    e.addRule(".monaco-editor .vertical { box-shadow: 1px 0 0 0 var(--guide-color) inset; }"), e.addRule(".monaco-editor .horizontal-top { border-top: 1px solid var(--guide-color); }"), e.addRule(".monaco-editor .horizontal-bottom { border-bottom: 1px solid var(--guide-color); }"), e.addRule(`.monaco-editor .vertical.${n.activeClassName} { box-shadow: 1px 0 0 0 var(--guide-color-active) inset; }`), e.addRule(`.monaco-editor .horizontal-top.${n.activeClassName} { border-top: 1px solid var(--guide-color-active); }`), e.addRule(`.monaco-editor .horizontal-bottom.${n.activeClassName} { border-bottom: 1px solid var(--guide-color-active); }`);
  }
  if (o.length > 0) {
    for (let a = 0; a < 30; a++) {
      const l = o[a % o.length];
      e.addRule(`.monaco-editor .lines-content .core-guide-indent.lvl-${a} { --indent-color: ${l.indentColor}; --indent-color-active: ${l.indentColorActive}; }`);
    }
    e.addRule(".monaco-editor .lines-content .core-guide-indent { box-shadow: 1px 0 0 0 var(--indent-color) inset; }"), e.addRule(".monaco-editor .lines-content .core-guide-indent.indent-active { box-shadow: 1px 0 0 0 var(--indent-color-active) inset; }");
  }
});
class YE {
  get didDomLayout() {
    return this._didDomLayout;
  }
  readClientRect() {
    if (!this._clientRectRead) {
      this._clientRectRead = !0;
      const e = this._domNode.getBoundingClientRect();
      this.markDidDomLayout(), this._clientRectDeltaLeft = e.left, this._clientRectScale = e.width / this._domNode.offsetWidth;
    }
  }
  get clientRectDeltaLeft() {
    return this._clientRectRead || this.readClientRect(), this._clientRectDeltaLeft;
  }
  get clientRectScale() {
    return this._clientRectRead || this.readClientRect(), this._clientRectScale;
  }
  constructor(e, t) {
    this._domNode = e, this.endNode = t, this._didDomLayout = !1, this._clientRectDeltaLeft = 0, this._clientRectScale = 1, this._clientRectRead = !1;
  }
  markDidDomLayout() {
    this._didDomLayout = !0;
  }
}
class Rwt {
  constructor() {
    this._currentVisibleRange = new Q(1, 1, 1, 1);
  }
  getCurrentVisibleRange() {
    return this._currentVisibleRange;
  }
  setCurrentVisibleRange(e) {
    this._currentVisibleRange = e;
  }
}
class Vwt {
  constructor(e, t, n, i, s, o, a) {
    this.minimalReveal = e, this.lineNumber = t, this.startColumn = n, this.endColumn = i, this.startScrollTop = s, this.stopScrollTop = o, this.scrollType = a, this.type = "range", this.minLineNumber = t, this.maxLineNumber = t;
  }
}
class Hwt {
  constructor(e, t, n, i, s) {
    this.minimalReveal = e, this.selections = t, this.startScrollTop = n, this.stopScrollTop = i, this.scrollType = s, this.type = "selections";
    let o = t[0].startLineNumber, a = t[0].endLineNumber;
    for (let l = 1, c = t.length; l < c; l++) {
      const d = t[l];
      o = Math.min(o, d.startLineNumber), a = Math.max(a, d.endLineNumber);
    }
    this.minLineNumber = o, this.maxLineNumber = a;
  }
}
class BO extends uo {
  static {
    this.HORIZONTAL_EXTRA_PX = 30;
  }
  constructor(e, t) {
    super(e), this._linesContent = t, this._textRangeRestingSpot = document.createElement("div"), this._visibleLines = new mke(this), this.domNode = this._visibleLines.domNode;
    const n = this._context.configuration, i = this._context.configuration.options, s = i.get(
      50
      /* EditorOption.fontInfo */
    ), o = i.get(
      147
      /* EditorOption.wrappingInfo */
    );
    this._lineHeight = i.get(
      67
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = s.typicalHalfwidthCharacterWidth, this._isViewportWrapping = o.isViewportWrapping, this._revealHorizontalRightPadding = i.get(
      101
      /* EditorOption.revealHorizontalRightPadding */
    ), this._cursorSurroundingLines = i.get(
      29
      /* EditorOption.cursorSurroundingLines */
    ), this._cursorSurroundingLinesStyle = i.get(
      30
      /* EditorOption.cursorSurroundingLinesStyle */
    ), this._canUseLayerHinting = !i.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._viewLineOptions = new d6e(n, this._context.theme.type), rc.write(
      this.domNode,
      8
      /* PartFingerprint.ViewLines */
    ), this.domNode.setClassName(`view-lines ${_p}`), Br(this.domNode, s), this._maxLineWidth = 0, this._asyncUpdateLineWidths = new Nr(() => {
      this._updateLineWidthsSlow();
    }, 200), this._asyncCheckMonospaceFontAssumptions = new Nr(() => {
      this._checkMonospaceFontAssumptions();
    }, 2e3), this._lastRenderedData = new Rwt(), this._horizontalRevealRequest = null, this._stickyScrollEnabled = i.get(
      116
      /* EditorOption.stickyScroll */
    ).enabled, this._maxNumberStickyLines = i.get(
      116
      /* EditorOption.stickyScroll */
    ).maxLineCount;
  }
  dispose() {
    this._asyncUpdateLineWidths.dispose(), this._asyncCheckMonospaceFontAssumptions.dispose(), super.dispose();
  }
  getDomNode() {
    return this.domNode;
  }
  // ---- begin IVisibleLinesHost
  createVisibleLine() {
    return new cd(this._viewLineOptions);
  }
  // ---- end IVisibleLinesHost
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    this._visibleLines.onConfigurationChanged(e), e.hasChanged(
      147
      /* EditorOption.wrappingInfo */
    ) && (this._maxLineWidth = 0);
    const t = this._context.configuration.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    ), i = t.get(
      147
      /* EditorOption.wrappingInfo */
    );
    return this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._isViewportWrapping = i.isViewportWrapping, this._revealHorizontalRightPadding = t.get(
      101
      /* EditorOption.revealHorizontalRightPadding */
    ), this._cursorSurroundingLines = t.get(
      29
      /* EditorOption.cursorSurroundingLines */
    ), this._cursorSurroundingLinesStyle = t.get(
      30
      /* EditorOption.cursorSurroundingLinesStyle */
    ), this._canUseLayerHinting = !t.get(
      32
      /* EditorOption.disableLayerHinting */
    ), this._stickyScrollEnabled = t.get(
      116
      /* EditorOption.stickyScroll */
    ).enabled, this._maxNumberStickyLines = t.get(
      116
      /* EditorOption.stickyScroll */
    ).maxLineCount, Br(this.domNode, n), this._onOptionsMaybeChanged(), e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    ) && (this._maxLineWidth = 0), !0;
  }
  _onOptionsMaybeChanged() {
    const e = this._context.configuration, t = new d6e(e, this._context.theme.type);
    if (!this._viewLineOptions.equals(t)) {
      this._viewLineOptions = t;
      const n = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
      for (let s = n; s <= i; s++)
        this._visibleLines.getVisibleLine(s).onOptionsChanged(this._viewLineOptions);
      return !0;
    }
    return !1;
  }
  onCursorStateChanged(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let i = !1;
    for (let s = t; s <= n; s++)
      i = this._visibleLines.getVisibleLine(s).onSelectionChanged() || i;
    return i;
  }
  onDecorationsChanged(e) {
    {
      const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
      for (let i = t; i <= n; i++)
        this._visibleLines.getVisibleLine(i).onDecorationsChanged();
    }
    return !0;
  }
  onFlushed(e) {
    const t = this._visibleLines.onFlushed(e);
    return this._maxLineWidth = 0, t;
  }
  onLinesChanged(e) {
    return this._visibleLines.onLinesChanged(e);
  }
  onLinesDeleted(e) {
    return this._visibleLines.onLinesDeleted(e);
  }
  onLinesInserted(e) {
    return this._visibleLines.onLinesInserted(e);
  }
  onRevealRangeRequest(e) {
    const t = this._computeScrollTopToRevealRange(this._context.viewLayout.getFutureViewport(), e.source, e.minimalReveal, e.range, e.selections, e.verticalType);
    if (t === -1)
      return !1;
    let n = this._context.viewLayout.validateScrollPosition({ scrollTop: t });
    e.revealHorizontal ? e.range && e.range.startLineNumber !== e.range.endLineNumber ? n = {
      scrollTop: n.scrollTop,
      scrollLeft: 0
    } : e.range ? this._horizontalRevealRequest = new Vwt(e.minimalReveal, e.range.startLineNumber, e.range.startColumn, e.range.endColumn, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType) : e.selections && e.selections.length > 0 && (this._horizontalRevealRequest = new Hwt(e.minimalReveal, e.selections, this._context.viewLayout.getCurrentScrollTop(), n.scrollTop, e.scrollType)) : this._horizontalRevealRequest = null;
    const s = Math.abs(this._context.viewLayout.getCurrentScrollTop() - n.scrollTop) <= this._lineHeight ? 1 : e.scrollType;
    return this._context.viewModel.viewLayout.setScrollPosition(n, s), !0;
  }
  onScrollChanged(e) {
    if (this._horizontalRevealRequest && e.scrollLeftChanged && (this._horizontalRevealRequest = null), this._horizontalRevealRequest && e.scrollTopChanged) {
      const t = Math.min(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop), n = Math.max(this._horizontalRevealRequest.startScrollTop, this._horizontalRevealRequest.stopScrollTop);
      (e.scrollTop < t || e.scrollTop > n) && (this._horizontalRevealRequest = null);
    }
    return this.domNode.setWidth(e.scrollWidth), this._visibleLines.onScrollChanged(e) || !0;
  }
  onTokensChanged(e) {
    return this._visibleLines.onTokensChanged(e);
  }
  onZonesChanged(e) {
    return this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth), this._visibleLines.onZonesChanged(e);
  }
  onThemeChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  // ---- end view event handlers
  // ----------- HELPERS FOR OTHERS
  getPositionFromDOMInfo(e, t) {
    const n = this._getViewLineDomNode(e);
    if (n === null)
      return null;
    const i = this._getLineNumberFor(n);
    if (i === -1 || i < 1 || i > this._context.viewModel.getLineCount())
      return null;
    if (this._context.viewModel.getLineMaxColumn(i) === 1)
      return new le(i, 1);
    const s = this._visibleLines.getStartLineNumber(), o = this._visibleLines.getEndLineNumber();
    if (i < s || i > o)
      return null;
    let a = this._visibleLines.getVisibleLine(i).getColumnOfNodeOffset(e, t);
    const l = this._context.viewModel.getLineMinColumn(i);
    return a < l && (a = l), new le(i, a);
  }
  _getViewLineDomNode(e) {
    for (; e && e.nodeType === 1; ) {
      if (e.className === cd.CLASS_NAME)
        return e;
      e = e.parentElement;
    }
    return null;
  }
  /**
   * @returns the line number of this view line dom node.
   */
  _getLineNumberFor(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    for (let i = t; i <= n; i++) {
      const s = this._visibleLines.getVisibleLine(i);
      if (e === s.getDomNode())
        return i;
    }
    return -1;
  }
  getLineWidth(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    if (e < t || e > n)
      return -1;
    const i = new YE(this.domNode.domNode, this._textRangeRestingSpot), s = this._visibleLines.getVisibleLine(e).getWidth(i);
    return this._updateLineWidthsSlowIfDomDidLayout(i), s;
  }
  linesVisibleRangesForRange(e, t) {
    if (this.shouldRender())
      return null;
    const n = e.endLineNumber, i = Q.intersectRanges(e, this._lastRenderedData.getCurrentVisibleRange());
    if (!i)
      return null;
    const s = [];
    let o = 0;
    const a = new YE(this.domNode.domNode, this._textRangeRestingSpot);
    let l = 0;
    t && (l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new le(i.startLineNumber, 1)).lineNumber);
    const c = this._visibleLines.getStartLineNumber(), d = this._visibleLines.getEndLineNumber();
    for (let u = i.startLineNumber; u <= i.endLineNumber; u++) {
      if (u < c || u > d)
        continue;
      const f = u === i.startLineNumber ? i.startColumn : 1, p = u !== i.endLineNumber, g = p ? this._context.viewModel.getLineMaxColumn(u) : i.endColumn, m = this._visibleLines.getVisibleLine(u).getVisibleRangesForRange(u, f, g, a);
      if (m) {
        if (t && u < n) {
          const A = l;
          l = this._context.viewModel.coordinatesConverter.convertViewPositionToModelPosition(new le(u + 1, 1)).lineNumber, A !== l && (m.ranges[m.ranges.length - 1].width += this._typicalHalfwidthCharacterWidth);
        }
        s[o++] = new w3t(m.outsideRenderedLine, u, hy.from(m.ranges), p);
      }
    }
    return this._updateLineWidthsSlowIfDomDidLayout(a), o === 0 ? null : s;
  }
  _visibleRangesForLineRange(e, t, n) {
    if (this.shouldRender() || e < this._visibleLines.getStartLineNumber() || e > this._visibleLines.getEndLineNumber())
      return null;
    const i = new YE(this.domNode.domNode, this._textRangeRestingSpot), s = this._visibleLines.getVisibleLine(e).getVisibleRangesForRange(e, t, n, i);
    return this._updateLineWidthsSlowIfDomDidLayout(i), s;
  }
  visibleRangeForPosition(e) {
    const t = this._visibleRangesForLineRange(e.lineNumber, e.column, e.column);
    return t ? new v3t(t.outsideRenderedLine, t.ranges[0].left) : null;
  }
  /**
   * Updates the max line width if it is fast to compute.
   * Returns true if all lines were taken into account.
   * Returns false if some lines need to be reevaluated (in a slow fashion).
   */
  _updateLineWidthsFast() {
    return this._updateLineWidths(!0);
  }
  _updateLineWidthsSlow() {
    this._updateLineWidths(!1);
  }
  /**
   * Update the line widths using DOM layout information after someone else
   * has caused a synchronous layout.
   */
  _updateLineWidthsSlowIfDomDidLayout(e) {
    e.didDomLayout && (this._asyncUpdateLineWidths.isScheduled() || (this._asyncUpdateLineWidths.cancel(), this._updateLineWidthsSlow()));
  }
  _updateLineWidths(e) {
    const t = this._visibleLines.getStartLineNumber(), n = this._visibleLines.getEndLineNumber();
    let i = 1, s = !0;
    for (let o = t; o <= n; o++) {
      const a = this._visibleLines.getVisibleLine(o);
      if (e && !a.getWidthIsFast()) {
        s = !1;
        continue;
      }
      i = Math.max(i, a.getWidth(null));
    }
    return s && t === 1 && n === this._context.viewModel.getLineCount() && (this._maxLineWidth = 0), this._ensureMaxLineWidth(i), s;
  }
  _checkMonospaceFontAssumptions() {
    let e = -1, t = -1;
    const n = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
    for (let s = n; s <= i; s++) {
      const o = this._visibleLines.getVisibleLine(s);
      if (o.needsMonospaceFontCheck()) {
        const a = o.getWidth(null);
        a > t && (t = a, e = s);
      }
    }
    if (e !== -1 && !this._visibleLines.getVisibleLine(e).monospaceAssumptionsAreValid())
      for (let s = n; s <= i; s++)
        this._visibleLines.getVisibleLine(s).onMonospaceAssumptionsInvalidated();
  }
  prepareRender() {
    throw new Error("Not supported");
  }
  render() {
    throw new Error("Not supported");
  }
  renderText(e) {
    if (this._visibleLines.renderLines(e), this._lastRenderedData.setCurrentVisibleRange(e.visibleRange), this.domNode.setWidth(this._context.viewLayout.getScrollWidth()), this.domNode.setHeight(Math.min(this._context.viewLayout.getScrollHeight(), 1e6)), this._horizontalRevealRequest) {
      const n = this._horizontalRevealRequest;
      if (e.startLineNumber <= n.minLineNumber && n.maxLineNumber <= e.endLineNumber) {
        this._horizontalRevealRequest = null, this.onDidRender();
        const i = this._computeScrollLeftToReveal(n);
        i && (this._isViewportWrapping || this._ensureMaxLineWidth(i.maxHorizontalOffset), this._context.viewModel.viewLayout.setScrollPosition({
          scrollLeft: i.scrollLeft
        }, n.scrollType));
      }
    }
    if (this._updateLineWidthsFast() ? this._asyncUpdateLineWidths.cancel() : this._asyncUpdateLineWidths.schedule(), Cs && !this._asyncCheckMonospaceFontAssumptions.isScheduled()) {
      const n = this._visibleLines.getStartLineNumber(), i = this._visibleLines.getEndLineNumber();
      for (let s = n; s <= i; s++)
        if (this._visibleLines.getVisibleLine(s).needsMonospaceFontCheck()) {
          this._asyncCheckMonospaceFontAssumptions.schedule();
          break;
        }
    }
    this._linesContent.setLayerHinting(this._canUseLayerHinting), this._linesContent.setContain("strict");
    const t = this._context.viewLayout.getCurrentScrollTop() - e.bigNumbersDelta;
    this._linesContent.setTop(-t), this._linesContent.setLeft(-this._context.viewLayout.getCurrentScrollLeft());
  }
  // --- width
  _ensureMaxLineWidth(e) {
    const t = Math.ceil(e);
    this._maxLineWidth < t && (this._maxLineWidth = t, this._context.viewModel.viewLayout.setMaxLineWidth(this._maxLineWidth));
  }
  _computeScrollTopToRevealRange(e, t, n, i, s, o) {
    const a = e.top, l = e.height, c = a + l;
    let d, u, f;
    if (s && s.length > 0) {
      let w = s[0].startLineNumber, v = s[0].endLineNumber;
      for (let y = 1, _ = s.length; y < _; y++) {
        const S = s[y];
        w = Math.min(w, S.startLineNumber), v = Math.max(v, S.endLineNumber);
      }
      d = !1, u = this._context.viewLayout.getVerticalOffsetForLineNumber(w), f = this._context.viewLayout.getVerticalOffsetForLineNumber(v) + this._lineHeight;
    } else if (i)
      d = !0, u = this._context.viewLayout.getVerticalOffsetForLineNumber(i.startLineNumber), f = this._context.viewLayout.getVerticalOffsetForLineNumber(i.endLineNumber) + this._lineHeight;
    else
      return -1;
    const p = (t === "mouse" || n) && this._cursorSurroundingLinesStyle === "default";
    let g = 0, m = 0;
    if (p)
      n || (g = this._lineHeight);
    else {
      const w = Math.min(l / this._lineHeight / 2, this._cursorSurroundingLines);
      this._stickyScrollEnabled ? g = Math.max(w, this._maxNumberStickyLines) * this._lineHeight : g = w * this._lineHeight, m = Math.max(0, w - 1) * this._lineHeight;
    }
    n || (o === 0 || o === 4) && (m += this._lineHeight), u -= g, f += m;
    let A;
    if (f - u > l) {
      if (!d)
        return -1;
      A = u;
    } else if (o === 5 || o === 6)
      if (o === 6 && a <= u && f <= c)
        A = a;
      else {
        const w = Math.max(5 * this._lineHeight, l * 0.2), v = u - w, y = f - l;
        A = Math.max(y, v);
      }
    else if (o === 1 || o === 2)
      if (o === 2 && a <= u && f <= c)
        A = a;
      else {
        const w = (u + f) / 2;
        A = Math.max(0, w - l / 2);
      }
    else
      A = this._computeMinimumScrolling(
        a,
        c,
        u,
        f,
        o === 3,
        o === 4
        /* viewEvents.VerticalRevealType.Bottom */
      );
    return A;
  }
  _computeScrollLeftToReveal(e) {
    const t = this._context.viewLayout.getCurrentViewport(), n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    ), i = t.left, s = i + t.width - n.verticalScrollbarWidth;
    let o = 1073741824, a = 0;
    if (e.type === "range") {
      const c = this._visibleRangesForLineRange(e.lineNumber, e.startColumn, e.endColumn);
      if (!c)
        return null;
      for (const d of c.ranges)
        o = Math.min(o, Math.round(d.left)), a = Math.max(a, Math.round(d.left + d.width));
    } else
      for (const c of e.selections) {
        if (c.startLineNumber !== c.endLineNumber)
          return null;
        const d = this._visibleRangesForLineRange(c.startLineNumber, c.startColumn, c.endColumn);
        if (!d)
          return null;
        for (const u of d.ranges)
          o = Math.min(o, Math.round(u.left)), a = Math.max(a, Math.round(u.left + u.width));
      }
    return e.minimalReveal || (o = Math.max(0, o - BO.HORIZONTAL_EXTRA_PX), a += this._revealHorizontalRightPadding), e.type === "selections" && a - o > t.width ? null : {
      scrollLeft: this._computeMinimumScrolling(i, s, o, a),
      maxHorizontalOffset: a
    };
  }
  _computeMinimumScrolling(e, t, n, i, s, o) {
    e = e | 0, t = t | 0, n = n | 0, i = i | 0, s = !!s, o = !!o;
    const a = t - e;
    if (i - n < a) {
      if (s)
        return n;
      if (o)
        return Math.max(0, i - a);
      if (n < e)
        return n;
      if (i > t)
        return Math.max(0, i - a);
    } else
      return n;
    return e;
  }
}
class Bwt extends vke {
  constructor(e) {
    super(), this._context = e;
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._decorationsLeft = n.decorationsLeft, this._decorationsWidth = n.decorationsWidth, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._decorationsLeft = n.decorationsLeft, this._decorationsWidth = n.decorationsWidth, !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), n = [];
    let i = 0;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.options.linesDecorationsClassName, c = a.options.zIndex;
      l && (n[i++] = new yL(a.range.startLineNumber, a.range.endLineNumber, l, a.options.linesDecorationsTooltip ?? null, c));
      const d = a.options.firstLineDecorationClassName;
      d && (n[i++] = new yL(a.range.startLineNumber, a.range.startLineNumber, d, a.options.linesDecorationsTooltip ?? null, c));
    }
    return n;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, i = this._render(t, n, this._getDecorations(e)), s = this._decorationsLeft.toString(), o = this._decorationsWidth.toString(), a = '" style="left:' + s + "px;width:" + o + 'px;"></div>', l = [];
    for (let c = t; c <= n; c++) {
      const d = c - t, u = i[d].getDecorations();
      let f = "";
      for (const p of u) {
        let g = '<div class="cldr ' + p.className;
        p.tooltip !== null && (g += '" title="' + p.tooltip), g += a, f += g;
      }
      l[d] = f;
    }
    this._renderResult = l;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class Pwt extends vke {
  constructor(e) {
    super(), this._context = e, this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    return !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _getDecorations(e) {
    const t = e.getDecorationsInViewport(), n = [];
    let i = 0;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = a.options.marginClassName, c = a.options.zIndex;
      l && (n[i++] = new yL(a.range.startLineNumber, a.range.endLineNumber, l, null, c));
    }
    return n;
  }
  prepareRender(e) {
    const t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber, i = this._render(t, n, this._getDecorations(e)), s = [];
    for (let o = t; o <= n; o++) {
      const a = o - t, l = i[a].getDecorations();
      let c = "";
      for (const d of l)
        c += '<div class="cmdr ' + d.className + '" style=""></div>';
      s[a] = c;
    }
    this._renderResult = s;
  }
  render(e, t) {
    return this._renderResult ? this._renderResult[t - e] : "";
  }
}
class oa {
  static {
    this.Empty = new oa(0, 0, 0, 0);
  }
  constructor(e, t, n, i) {
    this._rgba8Brand = void 0, this.r = oa._clamp(e), this.g = oa._clamp(t), this.b = oa._clamp(n), this.a = oa._clamp(i);
  }
  equals(e) {
    return this.r === e.r && this.g === e.g && this.b === e.b && this.a === e.a;
  }
  static _clamp(e) {
    return e < 0 ? 0 : e > 255 ? 255 : e | 0;
  }
}
class wy extends me {
  static {
    this._INSTANCE = null;
  }
  static getInstance() {
    return this._INSTANCE || (this._INSTANCE = new wy()), this._INSTANCE;
  }
  constructor() {
    super(), this._onDidChange = new $(), this.onDidChange = this._onDidChange.event, this._updateColorMap(), this._register(xi.onDidChange((e) => {
      e.changedColorMap && this._updateColorMap();
    }));
  }
  _updateColorMap() {
    const e = xi.getColorMap();
    if (!e) {
      this._colors = [oa.Empty], this._backgroundIsLight = !0;
      return;
    }
    this._colors = [oa.Empty];
    for (let n = 1; n < e.length; n++) {
      const i = e[n].rgba;
      this._colors[n] = new oa(i.r, i.g, i.b, Math.round(i.a * 255));
    }
    const t = e[
      2
      /* ColorId.DefaultBackground */
    ].getRelativeLuminance();
    this._backgroundIsLight = t >= 0.5, this._onDidChange.fire(void 0);
  }
  getColor(e) {
    return (e < 1 || e >= this._colors.length) && (e = 2), this._colors[e];
  }
  backgroundIsLight() {
    return this._backgroundIsLight;
  }
}
const Fwt = (() => {
  const r = [];
  for (let e = 32; e <= 126; e++)
    r.push(e);
  return r.push(
    65533
    /* Constants.UNKNOWN_CODE */
  ), r;
})(), zwt = (r, e) => (r -= 32, r < 0 || r > 96 ? e <= 2 ? (r + 96) % 96 : 95 : r);
class X3 {
  constructor(e, t) {
    this.scale = t, this._minimapCharRendererBrand = void 0, this.charDataNormal = X3.soften(e, 12 / 15), this.charDataLight = X3.soften(e, 50 / 60);
  }
  static soften(e, t) {
    const n = new Uint8ClampedArray(e.length);
    for (let i = 0, s = e.length; i < s; i++)
      n[i] = U8(e[i] * t);
    return n;
  }
  renderChar(e, t, n, i, s, o, a, l, c, d, u) {
    const f = 1 * this.scale, p = 2 * this.scale, g = u ? 1 : p;
    if (t + f > e.width || n + g > e.height) {
      console.warn("bad render request outside image data");
      return;
    }
    const m = d ? this.charDataLight : this.charDataNormal, A = zwt(i, c), w = e.width * 4, v = a.r, y = a.g, _ = a.b, S = s.r - v, D = s.g - y, M = s.b - _, L = Math.max(o, l), T = e.data;
    let B = A * f * p, V = n * w + t * 4;
    for (let N = 0; N < g; N++) {
      let R = V;
      for (let H = 0; H < f; H++) {
        const z = m[B++] / 255 * (o / 255);
        T[R++] = v + S * z, T[R++] = y + D * z, T[R++] = _ + M * z, T[R++] = L;
      }
      V += w;
    }
  }
  blockRenderChar(e, t, n, i, s, o, a, l) {
    const c = 1 * this.scale, d = 2 * this.scale, u = l ? 1 : d;
    if (t + c > e.width || n + u > e.height) {
      console.warn("bad render request outside image data");
      return;
    }
    const f = e.width * 4, p = 0.5 * (s / 255), g = o.r, m = o.g, A = o.b, w = i.r - g, v = i.g - m, y = i.b - A, _ = g + w * p, S = m + v * p, D = A + y * p, M = Math.max(s, a), L = e.data;
    let T = n * f + t * 4;
    for (let B = 0; B < u; B++) {
      let V = T;
      for (let N = 0; N < c; N++)
        L[V++] = _, L[V++] = S, L[V++] = D, L[V++] = M;
      T += f;
    }
  }
}
const S6e = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  A: 10,
  B: 11,
  C: 12,
  D: 13,
  E: 14,
  F: 15
}, M6e = (r) => {
  const e = new Uint8ClampedArray(r.length / 2);
  for (let t = 0; t < r.length; t += 2)
    e[t >> 1] = S6e[r[t]] << 4 | S6e[r[t + 1]] & 15;
  return e;
}, D6e = {
  1: ig(() => M6e("0000511D6300CF609C709645A78432005642574171487021003C451900274D35D762755E8B629C5BA856AF57BA649530C167D1512A272A3F6038604460398526BCA2A968DB6F8957C768BE5FBE2FB467CF5D8D5B795DC7625B5DFF50DE64C466DB2FC47CD860A65E9A2EB96CB54CE06DA763AB2EA26860524D3763536601005116008177A8705E53AB738E6A982F88BAA35B5F5B626D9C636B449B737E5B7B678598869A662F6B5B8542706C704C80736A607578685B70594A49715A4522E792")),
  2: ig(() => M6e("000000000000000055394F383D2800008B8B1F210002000081B1CBCBCC820000847AAF6B9AAF2119BE08B8881AD60000A44FD07DCCF107015338130C00000000385972265F390B406E2437634B4B48031B12B8A0847000001E15B29A402F0000000000004B33460B00007A752C2A0000000000004D3900000084394B82013400ABA5CFC7AD9C0302A45A3E5A98AB000089A43382D97900008BA54AA087A70A0248A6A7AE6DBE0000BF6F94987EA40A01A06DCFA7A7A9030496C32F77891D0000A99FB1A0AFA80603B29AB9CA75930D010C0948354D3900000C0948354F37460D0028BE673D8400000000AF9D7B6E00002B007AA8933400007AA642675C2700007984CFB9C3985B768772A8A6B7B20000CAAECAAFC4B700009F94A6009F840009D09F9BA4CA9C0000CC8FC76DC87F0000C991C472A2000000A894A48CA7B501079BA2C9C69BA20000B19A5D3FA89000005CA6009DA2960901B0A7F0669FB200009D009E00B7890000DAD0F5D092820000D294D4C48BD10000B5A7A4A3B1A50402CAB6CBA6A2000000B5A7A4A3B1A8044FCDADD19D9CB00000B7778F7B8AAE0803C9AB5D3F5D3F00009EA09EA0BAB006039EA0989A8C7900009B9EF4D6B7C00000A9A7816CACA80000ABAC84705D3F000096DA635CDC8C00006F486F266F263D4784006124097B00374F6D2D6D2D6D4A3A95872322000000030000000000008D8939130000000000002E22A5C9CBC70600AB25C0B5C9B400061A2DB04CA67001082AA6BEBEBFC606002321DACBC19E03087AA08B6768380000282FBAC0B8CA7A88AD25BBA5A29900004C396C5894A6000040485A6E356E9442A32CD17EADA70000B4237923628600003E2DE9C1D7B500002F25BBA5A2990000231DB6AFB4A804023025C0B5CAB588062B2CBDBEC0C706882435A75CA20000002326BD6A82A908048B4B9A5A668000002423A09CB4BB060025259C9D8A7900001C1FCAB2C7C700002A2A9387ABA200002626A4A47D6E9D14333163A0C87500004B6F9C2D643A257049364936493647358A34438355497F1A0000A24C1D590000D38DFFBDD4CD3126"))
};
class qA {
  /**
   * Creates a new character renderer factory with the given scale.
   */
  static create(e, t) {
    if (this.lastCreated && e === this.lastCreated.scale && t === this.lastFontFamily)
      return this.lastCreated;
    let n;
    return D6e[e] ? n = new X3(D6e[e](), e) : n = qA.createFromSampleData(qA.createSampleData(t).data, e), this.lastFontFamily = t, this.lastCreated = n, n;
  }
  /**
   * Creates the font sample data, writing to a canvas.
   */
  static createSampleData(e) {
    const t = document.createElement("canvas"), n = t.getContext("2d");
    t.style.height = "16px", t.height = 16, t.width = 96 * 10, t.style.width = 96 * 10 + "px", n.fillStyle = "#ffffff", n.font = `bold 16px ${e}`, n.textBaseline = "middle";
    let i = 0;
    for (const s of Fwt)
      n.fillText(String.fromCharCode(s), i, 16 / 2), i += 10;
    return n.getImageData(
      0,
      0,
      96 * 10,
      16
      /* Constants.SAMPLED_CHAR_HEIGHT */
    );
  }
  /**
   * Creates a character renderer from the canvas sample data.
   */
  static createFromSampleData(e, t) {
    if (e.length !== 61440)
      throw new Error("Unexpected source in MinimapCharRenderer");
    const i = qA._downsample(e, t);
    return new X3(i, t);
  }
  static _downsampleChar(e, t, n, i, s) {
    const o = 1 * s, a = 2 * s;
    let l = i, c = 0;
    for (let d = 0; d < a; d++) {
      const u = d / a * 16, f = (d + 1) / a * 16;
      for (let p = 0; p < o; p++) {
        const g = p / o * 10, m = (p + 1) / o * 10;
        let A = 0, w = 0;
        for (let y = u; y < f; y++) {
          const _ = t + Math.floor(y) * 3840, S = 1 - (y - Math.floor(y));
          for (let D = g; D < m; D++) {
            const M = 1 - (D - Math.floor(D)), L = _ + Math.floor(D) * 4, T = M * S;
            w += T, A += e[L] * e[L + 3] / 255 * T;
          }
        }
        const v = A / w;
        c = Math.max(c, v), n[l++] = U8(v);
      }
    }
    return c;
  }
  static _downsample(e, t) {
    const n = 2 * t * 1 * t, i = n * 96, s = new Uint8ClampedArray(i);
    let o = 0, a = 0, l = 0;
    for (let c = 0; c < 96; c++)
      l = Math.max(l, this._downsampleChar(e, a, s, o, t)), o += n, a += 10 * 4;
    if (l > 0) {
      const c = 255 / l;
      for (let d = 0; d < i; d++)
        s[d] *= c;
    }
    return s;
  }
}
const Wwt = zs ? '"Segoe WPC", "Segoe UI", sans-serif' : zt ? "-apple-system, BlinkMacSystemFont, sans-serif" : 'system-ui, "Ubuntu", "Droid Sans", sans-serif', jwt = 140, Zwt = 2;
class xp {
  constructor(e, t, n) {
    const i = e.options, s = i.get(
      144
      /* EditorOption.pixelRatio */
    ), o = i.get(
      146
      /* EditorOption.layoutInfo */
    ), a = o.minimap, l = i.get(
      50
      /* EditorOption.fontInfo */
    ), c = i.get(
      73
      /* EditorOption.minimap */
    );
    this.renderMinimap = a.renderMinimap, this.size = c.size, this.minimapHeightIsEditorHeight = a.minimapHeightIsEditorHeight, this.scrollBeyondLastLine = i.get(
      106
      /* EditorOption.scrollBeyondLastLine */
    ), this.paddingTop = i.get(
      84
      /* EditorOption.padding */
    ).top, this.paddingBottom = i.get(
      84
      /* EditorOption.padding */
    ).bottom, this.showSlider = c.showSlider, this.autohide = c.autohide, this.pixelRatio = s, this.typicalHalfwidthCharacterWidth = l.typicalHalfwidthCharacterWidth, this.lineHeight = i.get(
      67
      /* EditorOption.lineHeight */
    ), this.minimapLeft = a.minimapLeft, this.minimapWidth = a.minimapWidth, this.minimapHeight = o.height, this.canvasInnerWidth = a.minimapCanvasInnerWidth, this.canvasInnerHeight = a.minimapCanvasInnerHeight, this.canvasOuterWidth = a.minimapCanvasOuterWidth, this.canvasOuterHeight = a.minimapCanvasOuterHeight, this.isSampling = a.minimapIsSampling, this.editorHeight = o.height, this.fontScale = a.minimapScale, this.minimapLineHeight = a.minimapLineHeight, this.minimapCharWidth = 1 * this.fontScale, this.sectionHeaderFontFamily = Wwt, this.sectionHeaderFontSize = c.sectionHeaderFontSize * s, this.sectionHeaderLetterSpacing = c.sectionHeaderLetterSpacing, this.sectionHeaderFontColor = xp._getSectionHeaderColor(t, n.getColor(
      1
      /* ColorId.DefaultForeground */
    )), this.charRenderer = ig(() => qA.create(this.fontScale, l.fontFamily)), this.defaultBackgroundColor = n.getColor(
      2
      /* ColorId.DefaultBackground */
    ), this.backgroundColor = xp._getMinimapBackground(t, this.defaultBackgroundColor), this.foregroundAlpha = xp._getMinimapForegroundOpacity(t);
  }
  static _getMinimapBackground(e, t) {
    const n = e.getColor(tAt);
    return n ? new oa(n.rgba.r, n.rgba.g, n.rgba.b, Math.round(255 * n.rgba.a)) : t;
  }
  static _getMinimapForegroundOpacity(e) {
    const t = e.getColor(nAt);
    return t ? oa._clamp(Math.round(255 * t.rgba.a)) : 255;
  }
  static _getSectionHeaderColor(e, t) {
    const n = e.getColor(Sw);
    return n ? new oa(n.rgba.r, n.rgba.g, n.rgba.b, Math.round(255 * n.rgba.a)) : t;
  }
  equals(e) {
    return this.renderMinimap === e.renderMinimap && this.size === e.size && this.minimapHeightIsEditorHeight === e.minimapHeightIsEditorHeight && this.scrollBeyondLastLine === e.scrollBeyondLastLine && this.paddingTop === e.paddingTop && this.paddingBottom === e.paddingBottom && this.showSlider === e.showSlider && this.autohide === e.autohide && this.pixelRatio === e.pixelRatio && this.typicalHalfwidthCharacterWidth === e.typicalHalfwidthCharacterWidth && this.lineHeight === e.lineHeight && this.minimapLeft === e.minimapLeft && this.minimapWidth === e.minimapWidth && this.minimapHeight === e.minimapHeight && this.canvasInnerWidth === e.canvasInnerWidth && this.canvasInnerHeight === e.canvasInnerHeight && this.canvasOuterWidth === e.canvasOuterWidth && this.canvasOuterHeight === e.canvasOuterHeight && this.isSampling === e.isSampling && this.editorHeight === e.editorHeight && this.fontScale === e.fontScale && this.minimapLineHeight === e.minimapLineHeight && this.minimapCharWidth === e.minimapCharWidth && this.sectionHeaderFontSize === e.sectionHeaderFontSize && this.sectionHeaderLetterSpacing === e.sectionHeaderLetterSpacing && this.defaultBackgroundColor && this.defaultBackgroundColor.equals(e.defaultBackgroundColor) && this.backgroundColor && this.backgroundColor.equals(e.backgroundColor) && this.foregroundAlpha === e.foregroundAlpha;
  }
}
class GA {
  constructor(e, t, n, i, s, o, a, l, c) {
    this.scrollTop = e, this.scrollHeight = t, this.sliderNeeded = n, this._computedSliderRatio = i, this.sliderTop = s, this.sliderHeight = o, this.topPaddingLineCount = a, this.startLineNumber = l, this.endLineNumber = c;
  }
  /**
   * Compute a desired `scrollPosition` such that the slider moves by `delta`.
   */
  getDesiredScrollTopFromDelta(e) {
    return Math.round(this.scrollTop + e / this._computedSliderRatio);
  }
  getDesiredScrollTopFromTouchLocation(e) {
    return Math.round((e - this.sliderHeight / 2) / this._computedSliderRatio);
  }
  /**
   * Intersect a line range with `this.startLineNumber` and `this.endLineNumber`.
   */
  intersectWithViewport(e) {
    const t = Math.max(this.startLineNumber, e.startLineNumber), n = Math.min(this.endLineNumber, e.endLineNumber);
    return t > n ? null : [t, n];
  }
  /**
   * Get the inner minimap y coordinate for a line number.
   */
  getYForLineNumber(e, t) {
    return +(e - this.startLineNumber + this.topPaddingLineCount) * t;
  }
  static create(e, t, n, i, s, o, a, l, c, d, u) {
    const f = e.pixelRatio, p = e.minimapLineHeight, g = Math.floor(e.canvasInnerHeight / p), m = e.lineHeight;
    if (e.minimapHeightIsEditorHeight) {
      let D = l * e.lineHeight + e.paddingTop + e.paddingBottom;
      e.scrollBeyondLastLine && (D += Math.max(0, s - e.lineHeight - e.paddingBottom));
      const M = Math.max(1, Math.floor(s * s / D)), L = Math.max(0, e.minimapHeight - M), T = L / (d - s), B = c * T, V = L > 0, N = Math.floor(e.canvasInnerHeight / e.minimapLineHeight), R = Math.floor(e.paddingTop / e.lineHeight);
      return new GA(c, d, V, T, B, M, R, 1, Math.min(a, N));
    }
    let A;
    if (o && n !== a) {
      const D = n - t + 1;
      A = Math.floor(D * p / f);
    } else {
      const D = s / m;
      A = Math.floor(D * p / f);
    }
    const w = Math.floor(e.paddingTop / m);
    let v = Math.floor(e.paddingBottom / m);
    if (e.scrollBeyondLastLine) {
      const D = s / m;
      v = Math.max(v, D - 1);
    }
    let y;
    if (v > 0) {
      const D = s / m;
      y = (w + a + v - D - 1) * p / f;
    } else
      y = Math.max(0, (w + a) * p / f - A);
    y = Math.min(e.minimapHeight - A, y);
    const _ = y / (d - s), S = c * _;
    if (g >= w + a + v) {
      const D = y > 0;
      return new GA(c, d, D, _, S, A, w, 1, a);
    } else {
      let D;
      t > 1 ? D = t + w : D = Math.max(1, c / m);
      let M, L = Math.max(1, Math.floor(D - S * f / p));
      L < w ? (M = w - L + 1, L = 1) : (M = 0, L = Math.max(1, L - w)), u && u.scrollHeight === d && (u.scrollTop > c && (L = Math.min(L, u.startLineNumber), M = Math.max(M, u.topPaddingLineCount)), u.scrollTop < c && (L = Math.max(L, u.startLineNumber), M = Math.min(M, u.topPaddingLineCount)));
      const T = Math.min(a, L - M + g - 1), B = (c - i) / m;
      let V;
      return c >= e.paddingTop ? V = (t - L + M + B) * p / f : V = c / e.paddingTop * (M + B) * p / f, new GA(c, d, !0, _, V, A, M, L, T);
    }
  }
}
class vy {
  static {
    this.INVALID = new vy(-1);
  }
  constructor(e) {
    this.dy = e;
  }
  onContentChanged() {
    this.dy = -1;
  }
  onTokensChanged() {
    this.dy = -1;
  }
}
class L6e {
  constructor(e, t, n) {
    this.renderedLayout = e, this._imageData = t, this._renderedLines = new gke(() => vy.INVALID), this._renderedLines._set(e.startLineNumber, n);
  }
  /**
   * Check if the current RenderData matches accurately the new desired layout and no painting is needed.
   */
  linesEquals(e) {
    if (!this.scrollEquals(e))
      return !1;
    const n = this._renderedLines._get().lines;
    for (let i = 0, s = n.length; i < s; i++)
      if (n[i].dy === -1)
        return !1;
    return !0;
  }
  /**
   * Check if the current RenderData matches the new layout's scroll position
   */
  scrollEquals(e) {
    return this.renderedLayout.startLineNumber === e.startLineNumber && this.renderedLayout.endLineNumber === e.endLineNumber;
  }
  _get() {
    const e = this._renderedLines._get();
    return {
      imageData: this._imageData,
      rendLineNumberStart: e.rendLineNumberStart,
      lines: e.lines
    };
  }
  onLinesChanged(e, t) {
    return this._renderedLines.onLinesChanged(e, t);
  }
  onLinesDeleted(e, t) {
    this._renderedLines.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._renderedLines.onLinesInserted(e, t);
  }
  onTokensChanged(e) {
    return this._renderedLines.onTokensChanged(e);
  }
}
class PO {
  constructor(e, t, n, i) {
    this._backgroundFillData = PO._createBackgroundFillData(t, n, i), this._buffers = [
      e.createImageData(t, n),
      e.createImageData(t, n)
    ], this._lastUsedBuffer = 0;
  }
  getBuffer() {
    this._lastUsedBuffer = 1 - this._lastUsedBuffer;
    const e = this._buffers[this._lastUsedBuffer];
    return e.data.set(this._backgroundFillData), e;
  }
  static _createBackgroundFillData(e, t, n) {
    const i = n.r, s = n.g, o = n.b, a = n.a, l = new Uint8ClampedArray(e * t * 4);
    let c = 0;
    for (let d = 0; d < t; d++)
      for (let u = 0; u < e; u++)
        l[c] = i, l[c + 1] = s, l[c + 2] = o, l[c + 3] = a, c += 4;
    return l;
  }
}
class J3 {
  static compute(e, t, n) {
    if (e.renderMinimap === 0 || !e.isSampling)
      return [null, []];
    const { minimapLineCount: i } = pp.computeContainedMinimapLineCount({
      viewLineCount: t,
      scrollBeyondLastLine: e.scrollBeyondLastLine,
      paddingTop: e.paddingTop,
      paddingBottom: e.paddingBottom,
      height: e.editorHeight,
      lineHeight: e.lineHeight,
      pixelRatio: e.pixelRatio
    }), s = t / i, o = s / 2;
    if (!n || n.minimapLines.length === 0) {
      const A = [];
      if (A[0] = 1, i > 1) {
        for (let w = 0, v = i - 1; w < v; w++)
          A[w] = Math.round(w * s + o);
        A[i - 1] = t;
      }
      return [new J3(s, A), []];
    }
    const a = n.minimapLines, l = a.length, c = [];
    let d = 0, u = 0, f = 1;
    const p = 10;
    let g = [], m = null;
    for (let A = 0; A < i; A++) {
      const w = Math.max(f, Math.round(A * s)), v = Math.max(w, Math.round((A + 1) * s));
      for (; d < l && a[d] < w; ) {
        if (g.length < p) {
          const _ = d + 1 + u;
          m && m.type === "deleted" && m._oldIndex === d - 1 ? m.deleteToLineNumber++ : (m = { type: "deleted", _oldIndex: d, deleteFromLineNumber: _, deleteToLineNumber: _ }, g.push(m)), u--;
        }
        d++;
      }
      let y;
      if (d < l && a[d] <= v)
        y = a[d], d++;
      else if (A === 0 ? y = 1 : A + 1 === i ? y = t : y = Math.round(A * s + o), g.length < p) {
        const _ = d + 1 + u;
        m && m.type === "inserted" && m._i === A - 1 ? m.insertToLineNumber++ : (m = { type: "inserted", _i: A, insertFromLineNumber: _, insertToLineNumber: _ }, g.push(m)), u++;
      }
      c[A] = y, f = y;
    }
    if (g.length < p)
      for (; d < l; ) {
        const A = d + 1 + u;
        m && m.type === "deleted" && m._oldIndex === d - 1 ? m.deleteToLineNumber++ : (m = { type: "deleted", _oldIndex: d, deleteFromLineNumber: A, deleteToLineNumber: A }, g.push(m)), u--, d++;
      }
    else
      g = [{ type: "flush" }];
    return [new J3(s, c), g];
  }
  constructor(e, t) {
    this.samplingRatio = e, this.minimapLines = t;
  }
  modelLineToMinimapLine(e) {
    return Math.min(this.minimapLines.length, Math.max(1, Math.round(e / this.samplingRatio)));
  }
  /**
   * Will return null if the model line ranges are not intersecting with a sampled model line.
   */
  modelLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e) - 1;
    for (; n > 0 && this.minimapLines[n - 1] >= e; )
      n--;
    let i = this.modelLineToMinimapLine(t) - 1;
    for (; i + 1 < this.minimapLines.length && this.minimapLines[i + 1] <= t; )
      i++;
    if (n === i) {
      const s = this.minimapLines[n];
      if (s < e || s > t)
        return null;
    }
    return [n + 1, i + 1];
  }
  /**
   * Will always return a range, even if it is not intersecting with a sampled model line.
   */
  decorationLineRangeToMinimapLineRange(e, t) {
    let n = this.modelLineToMinimapLine(e), i = this.modelLineToMinimapLine(t);
    return e !== t && i === n && (i === this.minimapLines.length ? n > 1 && n-- : i++), [n, i];
  }
  onLinesDeleted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    let n = this.minimapLines.length, i = 0;
    for (let s = this.minimapLines.length - 1; s >= 0 && !(this.minimapLines[s] < e.fromLineNumber); s--)
      this.minimapLines[s] <= e.toLineNumber ? (this.minimapLines[s] = Math.max(1, e.fromLineNumber - 1), n = Math.min(n, s), i = Math.max(i, s)) : this.minimapLines[s] -= t;
    return [n, i];
  }
  onLinesInserted(e) {
    const t = e.toLineNumber - e.fromLineNumber + 1;
    for (let n = this.minimapLines.length - 1; n >= 0 && !(this.minimapLines[n] < e.fromLineNumber); n--)
      this.minimapLines[n] += t;
  }
}
let Uwt = class extends uo {
  constructor(e) {
    super(e), this._sectionHeaderCache = new _w(10, 1.5), this.tokensColorTracker = wy.getInstance(), this._selections = [], this._minimapSelections = null, this.options = new xp(this._context.configuration, this._context.theme, this.tokensColorTracker);
    const [t] = J3.compute(this.options, this._context.viewModel.getLineCount(), null);
    this._samplingState = t, this._shouldCheckSampling = !1, this._actual = new ip(e.theme, this);
  }
  dispose() {
    this._actual.dispose(), super.dispose();
  }
  getDomNode() {
    return this._actual.getDomNode();
  }
  _onOptionsMaybeChanged() {
    const e = new xp(this._context.configuration, this._context.theme, this.tokensColorTracker);
    return this.options.equals(e) ? !1 : (this.options = e, this._recreateLineSampling(), this._actual.onDidChangeOptions(), !0);
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    return this._onOptionsMaybeChanged();
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, this._minimapSelections = null, this._actual.onSelectionChanged();
  }
  onDecorationsChanged(e) {
    return e.affectsMinimap ? this._actual.onDecorationsChanged() : !1;
  }
  onFlushed(e) {
    return this._samplingState && (this._shouldCheckSampling = !0), this._actual.onFlushed();
  }
  onLinesChanged(e) {
    if (this._samplingState) {
      const t = this._samplingState.modelLineRangeToMinimapLineRange(e.fromLineNumber, e.fromLineNumber + e.count - 1);
      return t ? this._actual.onLinesChanged(t[0], t[1] - t[0] + 1) : !1;
    } else
      return this._actual.onLinesChanged(e.fromLineNumber, e.count);
  }
  onLinesDeleted(e) {
    if (this._samplingState) {
      const [t, n] = this._samplingState.onLinesDeleted(e);
      return t <= n && this._actual.onLinesChanged(t + 1, n - t + 1), this._shouldCheckSampling = !0, !0;
    } else
      return this._actual.onLinesDeleted(e.fromLineNumber, e.toLineNumber);
  }
  onLinesInserted(e) {
    return this._samplingState ? (this._samplingState.onLinesInserted(e), this._shouldCheckSampling = !0, !0) : this._actual.onLinesInserted(e.fromLineNumber, e.toLineNumber);
  }
  onScrollChanged(e) {
    return this._actual.onScrollChanged();
  }
  onThemeChanged(e) {
    return this._actual.onThemeChanged(), this._onOptionsMaybeChanged(), !0;
  }
  onTokensChanged(e) {
    if (this._samplingState) {
      const t = [];
      for (const n of e.ranges) {
        const i = this._samplingState.modelLineRangeToMinimapLineRange(n.fromLineNumber, n.toLineNumber);
        i && t.push({ fromLineNumber: i[0], toLineNumber: i[1] });
      }
      return t.length ? this._actual.onTokensChanged(t) : !1;
    } else
      return this._actual.onTokensChanged(e.ranges);
  }
  onTokensColorsChanged(e) {
    return this._onOptionsMaybeChanged(), this._actual.onTokensColorsChanged();
  }
  onZonesChanged(e) {
    return this._actual.onZonesChanged();
  }
  // --- end event handlers
  prepareRender(e) {
    this._shouldCheckSampling && (this._shouldCheckSampling = !1, this._recreateLineSampling());
  }
  render(e) {
    let t = e.visibleRange.startLineNumber, n = e.visibleRange.endLineNumber;
    this._samplingState && (t = this._samplingState.modelLineToMinimapLine(t), n = this._samplingState.modelLineToMinimapLine(n));
    const i = {
      viewportContainsWhitespaceGaps: e.viewportData.whitespaceViewportData.length > 0,
      scrollWidth: e.scrollWidth,
      scrollHeight: e.scrollHeight,
      viewportStartLineNumber: t,
      viewportEndLineNumber: n,
      viewportStartLineNumberVerticalOffset: e.getVerticalOffsetForLineNumber(t),
      scrollTop: e.scrollTop,
      scrollLeft: e.scrollLeft,
      viewportWidth: e.viewportWidth,
      viewportHeight: e.viewportHeight
    };
    this._actual.render(i);
  }
  //#region IMinimapModel
  _recreateLineSampling() {
    this._minimapSelections = null;
    const e = !!this._samplingState, [t, n] = J3.compute(this.options, this._context.viewModel.getLineCount(), this._samplingState);
    if (this._samplingState = t, e && this._samplingState)
      for (const i of n)
        switch (i.type) {
          case "deleted":
            this._actual.onLinesDeleted(i.deleteFromLineNumber, i.deleteToLineNumber);
            break;
          case "inserted":
            this._actual.onLinesInserted(i.insertFromLineNumber, i.insertToLineNumber);
            break;
          case "flush":
            this._actual.onFlushed();
            break;
        }
  }
  getLineCount() {
    return this._samplingState ? this._samplingState.minimapLines.length : this._context.viewModel.getLineCount();
  }
  getRealLineCount() {
    return this._context.viewModel.getLineCount();
  }
  getLineContent(e) {
    return this._samplingState ? this._context.viewModel.getLineContent(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineContent(e);
  }
  getLineMaxColumn(e) {
    return this._samplingState ? this._context.viewModel.getLineMaxColumn(this._samplingState.minimapLines[e - 1]) : this._context.viewModel.getLineMaxColumn(e);
  }
  getMinimapLinesRenderingData(e, t, n) {
    if (this._samplingState) {
      const i = [];
      for (let s = 0, o = t - e + 1; s < o; s++)
        n[s] ? i[s] = this._context.viewModel.getViewLineData(this._samplingState.minimapLines[e + s - 1]) : i[s] = null;
      return i;
    }
    return this._context.viewModel.getMinimapLinesRenderingData(e, t, n).data;
  }
  getSelections() {
    if (this._minimapSelections === null)
      if (this._samplingState) {
        this._minimapSelections = [];
        for (const e of this._selections) {
          const [t, n] = this._samplingState.decorationLineRangeToMinimapLineRange(e.startLineNumber, e.endLineNumber);
          this._minimapSelections.push(new _n(t, e.startColumn, n, e.endColumn));
        }
      } else
        this._minimapSelections = this._selections;
    return this._minimapSelections;
  }
  getMinimapDecorationsInViewport(e, t) {
    const n = this._getMinimapDecorationsInViewport(e, t).filter((i) => !i.options.minimap?.sectionHeaderStyle);
    if (this._samplingState) {
      const i = [];
      for (const s of n) {
        if (!s.options.minimap)
          continue;
        const o = s.range, a = this._samplingState.modelLineToMinimapLine(o.startLineNumber), l = this._samplingState.modelLineToMinimapLine(o.endLineNumber);
        i.push(new yLe(new Q(a, o.startColumn, l, o.endColumn), s.options));
      }
      return i;
    }
    return n;
  }
  getSectionHeaderDecorationsInViewport(e, t) {
    const n = this.options.minimapLineHeight, s = this.options.sectionHeaderFontSize / n;
    return e = Math.floor(Math.max(1, e - s)), this._getMinimapDecorationsInViewport(e, t).filter((o) => !!o.options.minimap?.sectionHeaderStyle);
  }
  _getMinimapDecorationsInViewport(e, t) {
    let n;
    if (this._samplingState) {
      const i = this._samplingState.minimapLines[e - 1], s = this._samplingState.minimapLines[t - 1];
      n = new Q(i, 1, s, this._context.viewModel.getLineMaxColumn(s));
    } else
      n = new Q(e, 1, t, this._context.viewModel.getLineMaxColumn(t));
    return this._context.viewModel.getMinimapDecorationsInRange(n);
  }
  getSectionHeaderText(e, t) {
    const n = e.options.minimap?.sectionHeaderText;
    if (!n)
      return null;
    const i = this._sectionHeaderCache.get(n);
    if (i)
      return i;
    const s = t(n);
    return this._sectionHeaderCache.set(n, s), s;
  }
  getOptions() {
    return this._context.viewModel.model.getOptions();
  }
  revealLineNumber(e) {
    this._samplingState && (e = this._samplingState.minimapLines[e - 1]), this._context.viewModel.revealRange(
      "mouse",
      !1,
      new Q(e, 1, e, 1),
      1,
      0
      /* ScrollType.Smooth */
    );
  }
  setScrollTop(e) {
    this._context.viewModel.viewLayout.setScrollPosition(
      {
        scrollTop: e
      },
      1
      /* ScrollType.Immediate */
    );
  }
};
class ip extends me {
  constructor(e, t) {
    super(), this._renderDecorations = !1, this._gestureInProgress = !1, this._theme = e, this._model = t, this._lastRenderData = null, this._buffers = null, this._selectionColor = this._theme.getColor(a6e), this._domNode = Yt(document.createElement("div")), rc.write(
      this._domNode,
      9
      /* PartFingerprint.Minimap */
    ), this._domNode.setClassName(this._getMinimapDomNodeClassName()), this._domNode.setPosition("absolute"), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._shadow = Yt(document.createElement("div")), this._shadow.setClassName("minimap-shadow-hidden"), this._domNode.appendChild(this._shadow), this._canvas = Yt(document.createElement("canvas")), this._canvas.setPosition("absolute"), this._canvas.setLeft(0), this._domNode.appendChild(this._canvas), this._decorationsCanvas = Yt(document.createElement("canvas")), this._decorationsCanvas.setPosition("absolute"), this._decorationsCanvas.setClassName("minimap-decorations-layer"), this._decorationsCanvas.setLeft(0), this._domNode.appendChild(this._decorationsCanvas), this._slider = Yt(document.createElement("div")), this._slider.setPosition("absolute"), this._slider.setClassName("minimap-slider"), this._slider.setLayerHinting(!0), this._slider.setContain("strict"), this._domNode.appendChild(this._slider), this._sliderHorizontal = Yt(document.createElement("div")), this._sliderHorizontal.setPosition("absolute"), this._sliderHorizontal.setClassName("minimap-slider-horizontal"), this._slider.appendChild(this._sliderHorizontal), this._applyLayout(), this._pointerDownListener = ir(this._domNode.domNode, Se.POINTER_DOWN, (n) => {
      if (n.preventDefault(), this._model.options.renderMinimap === 0 || !this._lastRenderData)
        return;
      if (this._model.options.size !== "proportional") {
        if (n.button === 0 && this._lastRenderData) {
          const c = To(this._slider.domNode), d = c.top + c.height / 2;
          this._startSliderDragging(n, d, this._lastRenderData.renderedLayout);
        }
        return;
      }
      const s = this._model.options.minimapLineHeight, o = this._model.options.canvasInnerHeight / this._model.options.canvasOuterHeight * n.offsetY;
      let l = Math.floor(o / s) + this._lastRenderData.renderedLayout.startLineNumber - this._lastRenderData.renderedLayout.topPaddingLineCount;
      l = Math.min(l, this._model.getLineCount()), this._model.revealLineNumber(l);
    }), this._sliderPointerMoveMonitor = new iy(), this._sliderPointerDownListener = ir(this._slider.domNode, Se.POINTER_DOWN, (n) => {
      n.preventDefault(), n.stopPropagation(), n.button === 0 && this._lastRenderData && this._startSliderDragging(n, n.pageY, this._lastRenderData.renderedLayout);
    }), this._gestureDisposable = Xn.addTarget(this._domNode.domNode), this._sliderTouchStartListener = fe(this._domNode.domNode, Nn.Start, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && (this._slider.toggleClassName("active", !0), this._gestureInProgress = !0, this.scrollDueToTouchEvent(n));
    }, { passive: !1 }), this._sliderTouchMoveListener = fe(this._domNode.domNode, Nn.Change, (n) => {
      n.preventDefault(), n.stopPropagation(), this._lastRenderData && this._gestureInProgress && this.scrollDueToTouchEvent(n);
    }, { passive: !1 }), this._sliderTouchEndListener = ir(this._domNode.domNode, Nn.End, (n) => {
      n.preventDefault(), n.stopPropagation(), this._gestureInProgress = !1, this._slider.toggleClassName("active", !1);
    });
  }
  _startSliderDragging(e, t, n) {
    if (!e.target || !(e.target instanceof Element))
      return;
    const i = e.pageX;
    this._slider.toggleClassName("active", !0);
    const s = (o, a) => {
      const l = To(this._domNode.domNode), c = Math.min(Math.abs(a - i), Math.abs(a - l.left), Math.abs(a - l.left - l.width));
      if (zs && c > jwt) {
        this._model.setScrollTop(n.scrollTop);
        return;
      }
      const d = o - t;
      this._model.setScrollTop(n.getDesiredScrollTopFromDelta(d));
    };
    e.pageY !== t && s(e.pageY, i), this._sliderPointerMoveMonitor.startMonitoring(e.target, e.pointerId, e.buttons, (o) => s(o.pageY, o.pageX), () => {
      this._slider.toggleClassName("active", !1);
    });
  }
  scrollDueToTouchEvent(e) {
    const t = this._domNode.domNode.getBoundingClientRect().top, n = this._lastRenderData.renderedLayout.getDesiredScrollTopFromTouchLocation(e.pageY - t);
    this._model.setScrollTop(n);
  }
  dispose() {
    this._pointerDownListener.dispose(), this._sliderPointerMoveMonitor.dispose(), this._sliderPointerDownListener.dispose(), this._gestureDisposable.dispose(), this._sliderTouchStartListener.dispose(), this._sliderTouchMoveListener.dispose(), this._sliderTouchEndListener.dispose(), super.dispose();
  }
  _getMinimapDomNodeClassName() {
    const e = ["minimap"];
    return this._model.options.showSlider === "always" ? e.push("slider-always") : e.push("slider-mouseover"), this._model.options.autohide && e.push("autohide"), e.join(" ");
  }
  getDomNode() {
    return this._domNode;
  }
  _applyLayout() {
    this._domNode.setLeft(this._model.options.minimapLeft), this._domNode.setWidth(this._model.options.minimapWidth), this._domNode.setHeight(this._model.options.minimapHeight), this._shadow.setHeight(this._model.options.minimapHeight), this._canvas.setWidth(this._model.options.canvasOuterWidth), this._canvas.setHeight(this._model.options.canvasOuterHeight), this._canvas.domNode.width = this._model.options.canvasInnerWidth, this._canvas.domNode.height = this._model.options.canvasInnerHeight, this._decorationsCanvas.setWidth(this._model.options.canvasOuterWidth), this._decorationsCanvas.setHeight(this._model.options.canvasOuterHeight), this._decorationsCanvas.domNode.width = this._model.options.canvasInnerWidth, this._decorationsCanvas.domNode.height = this._model.options.canvasInnerHeight, this._slider.setWidth(this._model.options.minimapWidth);
  }
  _getBuffer() {
    return this._buffers || this._model.options.canvasInnerWidth > 0 && this._model.options.canvasInnerHeight > 0 && (this._buffers = new PO(this._canvas.domNode.getContext("2d"), this._model.options.canvasInnerWidth, this._model.options.canvasInnerHeight, this._model.options.backgroundColor)), this._buffers ? this._buffers.getBuffer() : null;
  }
  // ---- begin view event handlers
  onDidChangeOptions() {
    this._lastRenderData = null, this._buffers = null, this._applyLayout(), this._domNode.setClassName(this._getMinimapDomNodeClassName());
  }
  onSelectionChanged() {
    return this._renderDecorations = !0, !0;
  }
  onDecorationsChanged() {
    return this._renderDecorations = !0, !0;
  }
  onFlushed() {
    return this._lastRenderData = null, !0;
  }
  onLinesChanged(e, t) {
    return this._lastRenderData ? this._lastRenderData.onLinesChanged(e, t) : !1;
  }
  onLinesDeleted(e, t) {
    return this._lastRenderData?.onLinesDeleted(e, t), !0;
  }
  onLinesInserted(e, t) {
    return this._lastRenderData?.onLinesInserted(e, t), !0;
  }
  onScrollChanged() {
    return this._renderDecorations = !0, !0;
  }
  onThemeChanged() {
    return this._selectionColor = this._theme.getColor(a6e), this._renderDecorations = !0, !0;
  }
  onTokensChanged(e) {
    return this._lastRenderData ? this._lastRenderData.onTokensChanged(e) : !1;
  }
  onTokensColorsChanged() {
    return this._lastRenderData = null, this._buffers = null, !0;
  }
  onZonesChanged() {
    return this._lastRenderData = null, !0;
  }
  // --- end event handlers
  render(e) {
    if (this._model.options.renderMinimap === 0) {
      this._shadow.setClassName("minimap-shadow-hidden"), this._sliderHorizontal.setWidth(0), this._sliderHorizontal.setHeight(0);
      return;
    }
    e.scrollLeft + e.viewportWidth >= e.scrollWidth ? this._shadow.setClassName("minimap-shadow-hidden") : this._shadow.setClassName("minimap-shadow-visible");
    const n = GA.create(this._model.options, e.viewportStartLineNumber, e.viewportEndLineNumber, e.viewportStartLineNumberVerticalOffset, e.viewportHeight, e.viewportContainsWhitespaceGaps, this._model.getLineCount(), this._model.getRealLineCount(), e.scrollTop, e.scrollHeight, this._lastRenderData ? this._lastRenderData.renderedLayout : null);
    this._slider.setDisplay(n.sliderNeeded ? "block" : "none"), this._slider.setTop(n.sliderTop), this._slider.setHeight(n.sliderHeight), this._sliderHorizontal.setLeft(0), this._sliderHorizontal.setWidth(this._model.options.minimapWidth), this._sliderHorizontal.setTop(0), this._sliderHorizontal.setHeight(n.sliderHeight), this.renderDecorations(n), this._lastRenderData = this.renderLines(n);
  }
  renderDecorations(e) {
    if (this._renderDecorations) {
      this._renderDecorations = !1;
      const t = this._model.getSelections();
      t.sort(Q.compareRangesUsingStarts);
      const n = this._model.getMinimapDecorationsInViewport(e.startLineNumber, e.endLineNumber);
      n.sort((f, p) => (f.options.zIndex || 0) - (p.options.zIndex || 0));
      const { canvasInnerWidth: i, canvasInnerHeight: s } = this._model.options, o = this._model.options.minimapLineHeight, a = this._model.options.minimapCharWidth, l = this._model.getOptions().tabSize, c = this._decorationsCanvas.domNode.getContext("2d");
      c.clearRect(0, 0, i, s);
      const d = new k6e(e.startLineNumber, e.endLineNumber, !1);
      this._renderSelectionLineHighlights(c, t, d, e, o), this._renderDecorationsLineHighlights(c, n, d, e, o);
      const u = new k6e(e.startLineNumber, e.endLineNumber, null);
      this._renderSelectionsHighlights(c, t, u, e, o, l, a, i), this._renderDecorationsHighlights(c, n, u, e, o, l, a, i), this._renderSectionHeaders(e);
    }
  }
  _renderSelectionLineHighlights(e, t, n, i, s) {
    if (!this._selectionColor || this._selectionColor.isTransparent())
      return;
    e.fillStyle = this._selectionColor.transparent(0.5).toString();
    let o = 0, a = 0;
    for (const l of t) {
      const c = i.intersectWithViewport(l);
      if (!c)
        continue;
      const [d, u] = c;
      for (let g = d; g <= u; g++)
        n.set(g, !0);
      const f = i.getYForLineNumber(d, s), p = i.getYForLineNumber(u, s);
      a >= f || (a > o && e.fillRect(Rc, o, e.canvas.width, a - o), o = f), a = p;
    }
    a > o && e.fillRect(Rc, o, e.canvas.width, a - o);
  }
  _renderDecorationsLineHighlights(e, t, n, i, s) {
    const o = /* @__PURE__ */ new Map();
    for (let a = t.length - 1; a >= 0; a--) {
      const l = t[a], c = l.options.minimap;
      if (!c || c.position !== 1)
        continue;
      const d = i.intersectWithViewport(l.range);
      if (!d)
        continue;
      const [u, f] = d, p = c.getColor(this._theme.value);
      if (!p || p.isTransparent())
        continue;
      let g = o.get(p.toString());
      g || (g = p.transparent(0.5).toString(), o.set(p.toString(), g)), e.fillStyle = g;
      for (let m = u; m <= f; m++) {
        if (n.has(m))
          continue;
        n.set(m, !0);
        const A = i.getYForLineNumber(u, s);
        e.fillRect(Rc, A, e.canvas.width, s);
      }
    }
  }
  _renderSelectionsHighlights(e, t, n, i, s, o, a, l) {
    if (!(!this._selectionColor || this._selectionColor.isTransparent()))
      for (const c of t) {
        const d = i.intersectWithViewport(c);
        if (!d)
          continue;
        const [u, f] = d;
        for (let p = u; p <= f; p++)
          this.renderDecorationOnLine(e, n, c, this._selectionColor, i, p, s, s, o, a, l);
      }
  }
  _renderDecorationsHighlights(e, t, n, i, s, o, a, l) {
    for (const c of t) {
      const d = c.options.minimap;
      if (!d)
        continue;
      const u = i.intersectWithViewport(c.range);
      if (!u)
        continue;
      const [f, p] = u, g = d.getColor(this._theme.value);
      if (!(!g || g.isTransparent()))
        for (let m = f; m <= p; m++)
          switch (d.position) {
            case 1:
              this.renderDecorationOnLine(e, n, c.range, g, i, m, s, s, o, a, l);
              continue;
            case 2: {
              const A = i.getYForLineNumber(m, s);
              this.renderDecoration(e, g, 2, A, Zwt, s);
              continue;
            }
          }
    }
  }
  renderDecorationOnLine(e, t, n, i, s, o, a, l, c, d, u) {
    const f = s.getYForLineNumber(o, l);
    if (f + a < 0 || f > this._model.options.canvasInnerHeight)
      return;
    const { startLineNumber: p, endLineNumber: g } = n, m = p === o ? n.startColumn : 1, A = g === o ? n.endColumn : this._model.getLineMaxColumn(o), w = this.getXOffsetForPosition(t, o, m, c, d, u), v = this.getXOffsetForPosition(t, o, A, c, d, u);
    this.renderDecoration(e, i, w, f, v - w, a);
  }
  getXOffsetForPosition(e, t, n, i, s, o) {
    if (n === 1)
      return Rc;
    if ((n - 1) * s >= o)
      return o;
    let l = e.get(t);
    if (!l) {
      const c = this._model.getLineContent(t);
      l = [Rc];
      let d = Rc;
      for (let u = 1; u < c.length + 1; u++) {
        const f = c.charCodeAt(u - 1), p = f === 9 ? i * s : a1(f) ? 2 * s : s, g = d + p;
        if (g >= o) {
          l[u] = o;
          break;
        }
        l[u] = g, d = g;
      }
      e.set(t, l);
    }
    return n - 1 < l.length ? l[n - 1] : o;
  }
  renderDecoration(e, t, n, i, s, o) {
    e.fillStyle = t && t.toString() || "", e.fillRect(n, i, s, o);
  }
  _renderSectionHeaders(e) {
    const t = this._model.options.minimapLineHeight, n = this._model.options.sectionHeaderFontSize, i = this._model.options.sectionHeaderLetterSpacing, s = n * 1.5, { canvasInnerWidth: o } = this._model.options, a = this._model.options.backgroundColor, l = `rgb(${a.r} ${a.g} ${a.b} / .7)`, c = this._model.options.sectionHeaderFontColor, d = `rgb(${c.r} ${c.g} ${c.b})`, u = d, f = this._decorationsCanvas.domNode.getContext("2d");
    f.letterSpacing = i + "px", f.font = "500 " + n + "px " + this._model.options.sectionHeaderFontFamily, f.strokeStyle = u, f.lineWidth = 0.2;
    const p = this._model.getSectionHeaderDecorationsInViewport(e.startLineNumber, e.endLineNumber);
    p.sort((m, A) => m.range.startLineNumber - A.range.startLineNumber);
    const g = ip._fitSectionHeader.bind(null, f, o - Rc);
    for (const m of p) {
      const A = e.getYForLineNumber(m.range.startLineNumber, t) + n, w = A - n, v = w + 2, y = this._model.getSectionHeaderText(m, g);
      ip._renderSectionLabel(f, y, m.options.minimap?.sectionHeaderStyle === 2, l, d, o, w, s, A, v);
    }
  }
  static _fitSectionHeader(e, t, n) {
    if (!n)
      return n;
    const i = "…", s = e.measureText(n).width, o = e.measureText(i).width;
    if (s <= t || s <= o)
      return n;
    const a = n.length, l = s / n.length, c = Math.floor((t - o) / l) - 1;
    let d = Math.ceil(c / 2);
    for (; d > 0 && /\s/.test(n[d - 1]); )
      --d;
    return n.substring(0, d) + i + n.substring(a - (c - d));
  }
  static _renderSectionLabel(e, t, n, i, s, o, a, l, c, d) {
    t && (e.fillStyle = i, e.fillRect(0, a, o, l), e.fillStyle = s, e.fillText(t, Rc, c)), n && (e.beginPath(), e.moveTo(0, d), e.lineTo(o, d), e.closePath(), e.stroke());
  }
  renderLines(e) {
    const t = e.startLineNumber, n = e.endLineNumber, i = this._model.options.minimapLineHeight;
    if (this._lastRenderData && this._lastRenderData.linesEquals(e)) {
      const z = this._lastRenderData._get();
      return new L6e(e, z.imageData, z.lines);
    }
    const s = this._getBuffer();
    if (!s)
      return null;
    const [o, a, l] = ip._renderUntouchedLines(s, e.topPaddingLineCount, t, n, i, this._lastRenderData), c = this._model.getMinimapLinesRenderingData(t, n, l), d = this._model.getOptions().tabSize, u = this._model.options.defaultBackgroundColor, f = this._model.options.backgroundColor, p = this._model.options.foregroundAlpha, g = this._model.tokensColorTracker, m = g.backgroundIsLight(), A = this._model.options.renderMinimap, w = this._model.options.charRenderer(), v = this._model.options.fontScale, y = this._model.options.minimapCharWidth, S = (A === 1 ? 2 : 3) * v, D = i > S ? Math.floor((i - S) / 2) : 0, M = f.a / 255, L = new oa(Math.round((f.r - u.r) * M + u.r), Math.round((f.g - u.g) * M + u.g), Math.round((f.b - u.b) * M + u.b), 255);
    let T = e.topPaddingLineCount * i;
    const B = [];
    for (let z = 0, U = n - t + 1; z < U; z++)
      l[z] && ip._renderLine(s, L, f.a, m, A, y, g, p, w, T, D, d, c[z], v, i), B[z] = new vy(T), T += i;
    const V = o === -1 ? 0 : o, R = (a === -1 ? s.height : a) - V;
    return this._canvas.domNode.getContext("2d").putImageData(s, 0, 0, 0, V, s.width, R), new L6e(e, s, B);
  }
  static _renderUntouchedLines(e, t, n, i, s, o) {
    const a = [];
    if (!o) {
      for (let T = 0, B = i - n + 1; T < B; T++)
        a[T] = !0;
      return [-1, -1, a];
    }
    const l = o._get(), c = l.imageData.data, d = l.rendLineNumberStart, u = l.lines, f = u.length, p = e.width, g = e.data, m = (i - n + 1) * s * p * 4;
    let A = -1, w = -1, v = -1, y = -1, _ = -1, S = -1, D = t * s;
    for (let T = n; T <= i; T++) {
      const B = T - n, V = T - d, N = V >= 0 && V < f ? u[V].dy : -1;
      if (N === -1) {
        a[B] = !0, D += s;
        continue;
      }
      const R = N * p * 4, H = (N + s) * p * 4, z = D * p * 4, U = (D + s) * p * 4;
      y === R && S === z ? (y = H, S = U) : (v !== -1 && (g.set(c.subarray(v, y), _), A === -1 && v === 0 && v === _ && (A = y), w === -1 && y === m && v === _ && (w = v)), v = R, y = H, _ = z, S = U), a[B] = !1, D += s;
    }
    v !== -1 && (g.set(c.subarray(v, y), _), A === -1 && v === 0 && v === _ && (A = y), w === -1 && y === m && v === _ && (w = v));
    const M = A === -1 ? -1 : A / (p * 4), L = w === -1 ? -1 : w / (p * 4);
    return [M, L, a];
  }
  static _renderLine(e, t, n, i, s, o, a, l, c, d, u, f, p, g, m) {
    const A = p.content, w = p.tokens, v = e.width - o, y = m === 1;
    let _ = Rc, S = 0, D = 0;
    for (let M = 0, L = w.getCount(); M < L; M++) {
      const T = w.getEndOffset(M), B = w.getForeground(M), V = a.getColor(B);
      for (; S < T; S++) {
        if (_ > v)
          return;
        const N = A.charCodeAt(S);
        if (N === 9) {
          const R = f - (S + D) % f;
          D += R - 1, _ += R * o;
        } else if (N === 32)
          _ += o;
        else {
          const R = a1(N) ? 2 : 1;
          for (let H = 0; H < R; H++)
            if (s === 2 ? c.blockRenderChar(e, _, d + u, V, l, t, n, y) : c.renderChar(e, _, d + u, N, V, l, t, n, g, i, y), _ += o, _ > v)
              return;
        }
      }
    }
  }
}
class k6e {
  constructor(e, t, n) {
    this._startLineNumber = e, this._endLineNumber = t, this._defaultValue = n, this._values = [];
    for (let i = 0, s = this._endLineNumber - this._startLineNumber + 1; i < s; i++)
      this._values[i] = n;
  }
  has(e) {
    return this.get(e) !== this._defaultValue;
  }
  set(e, t) {
    e < this._startLineNumber || e > this._endLineNumber || (this._values[e - this._startLineNumber] = t);
  }
  get(e) {
    return e < this._startLineNumber || e > this._endLineNumber ? this._defaultValue : this._values[e - this._startLineNumber];
  }
}
class qwt extends uo {
  constructor(e, t) {
    super(e), this._viewDomNode = t;
    const i = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._widgets = {}, this._verticalScrollbarWidth = i.verticalScrollbarWidth, this._minimapWidth = i.minimap.minimapWidth, this._horizontalScrollbarHeight = i.horizontalScrollbarHeight, this._editorHeight = i.height, this._editorWidth = i.width, this._viewDomNodeRect = { top: 0, left: 0, width: 0, height: 0 }, this._domNode = Yt(document.createElement("div")), rc.write(
      this._domNode,
      4
      /* PartFingerprint.OverlayWidgets */
    ), this._domNode.setClassName("overlayWidgets"), this.overflowingOverlayWidgetsDomNode = Yt(document.createElement("div")), rc.write(
      this.overflowingOverlayWidgetsDomNode,
      5
      /* PartFingerprint.OverflowingOverlayWidgets */
    ), this.overflowingOverlayWidgetsDomNode.setClassName("overflowingOverlayWidgets");
  }
  dispose() {
    super.dispose(), this._widgets = {};
  }
  getDomNode() {
    return this._domNode;
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._verticalScrollbarWidth = n.verticalScrollbarWidth, this._minimapWidth = n.minimap.minimapWidth, this._horizontalScrollbarHeight = n.horizontalScrollbarHeight, this._editorHeight = n.height, this._editorWidth = n.width, !0;
  }
  // ---- end view event handlers
  addWidget(e) {
    const t = Yt(e.getDomNode());
    this._widgets[e.getId()] = {
      widget: e,
      preference: null,
      domNode: t
    }, t.setPosition("absolute"), t.setAttribute("widgetId", e.getId()), e.allowEditorOverflow ? this.overflowingOverlayWidgetsDomNode.appendChild(t) : this._domNode.appendChild(t), this.setShouldRender(), this._updateMaxMinWidth();
  }
  setWidgetPosition(e, t) {
    const n = this._widgets[e.getId()], i = t ? t.preference : null, s = t?.stackOridinal;
    return n.preference === i && n.stack === s ? (this._updateMaxMinWidth(), !1) : (n.preference = i, n.stack = s, this.setShouldRender(), this._updateMaxMinWidth(), !0);
  }
  removeWidget(e) {
    const t = e.getId();
    if (this._widgets.hasOwnProperty(t)) {
      const i = this._widgets[t].domNode.domNode;
      delete this._widgets[t], i.remove(), this.setShouldRender(), this._updateMaxMinWidth();
    }
  }
  _updateMaxMinWidth() {
    let e = 0;
    const t = Object.keys(this._widgets);
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n], a = this._widgets[s].widget.getMinContentWidthInPx?.();
      typeof a < "u" && (e = Math.max(e, a));
    }
    this._context.viewLayout.setOverlayWidgetsMinWidth(e);
  }
  _renderWidget(e, t) {
    const n = e.domNode;
    if (e.preference === null) {
      n.setTop("");
      return;
    }
    const i = 2 * this._verticalScrollbarWidth + this._minimapWidth;
    if (e.preference === 0 || e.preference === 1) {
      if (e.preference === 1) {
        const s = n.domNode.clientHeight;
        n.setTop(this._editorHeight - s - 2 * this._horizontalScrollbarHeight);
      } else
        n.setTop(0);
      e.stack !== void 0 ? (n.setTop(t[e.preference]), t[e.preference] += n.domNode.clientWidth) : n.setRight(i);
    } else if (e.preference === 2)
      n.domNode.style.right = "50%", e.stack !== void 0 ? (n.setTop(t[
        2
        /* OverlayWidgetPositionPreference.TOP_CENTER */
      ]), t[
        2
        /* OverlayWidgetPositionPreference.TOP_CENTER */
      ] += n.domNode.clientHeight) : n.setTop(0);
    else {
      const { top: s, left: o } = e.preference;
      if (this._context.configuration.options.get(
        42
        /* EditorOption.fixedOverflowWidgets */
      ) && e.widget.allowEditorOverflow) {
        const l = this._viewDomNodeRect;
        n.setTop(s + l.top), n.setLeft(o + l.left), n.setPosition("fixed");
      } else
        n.setTop(s), n.setLeft(o), n.setPosition("absolute");
    }
  }
  prepareRender(e) {
    this._viewDomNodeRect = To(this._viewDomNode.domNode);
  }
  render(e) {
    this._domNode.setWidth(this._editorWidth);
    const t = Object.keys(this._widgets), n = Array.from({ length: 3 }, () => 0);
    t.sort((i, s) => (this._widgets[i].stack || 0) - (this._widgets[s].stack || 0));
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i];
      this._renderWidget(this._widgets[o], n);
    }
  }
}
class Gwt {
  constructor(e, t) {
    const n = e.options;
    this.lineHeight = n.get(
      67
      /* EditorOption.lineHeight */
    ), this.pixelRatio = n.get(
      144
      /* EditorOption.pixelRatio */
    ), this.overviewRulerLanes = n.get(
      83
      /* EditorOption.overviewRulerLanes */
    ), this.renderBorder = n.get(
      82
      /* EditorOption.overviewRulerBorder */
    );
    const i = t.getColor(g4t);
    this.borderColor = i ? i.toString() : null, this.hideCursor = n.get(
      59
      /* EditorOption.hideCursorInOverviewRuler */
    );
    const s = t.getColor(py);
    this.cursorColorSingle = s ? s.transparent(0.7).toString() : null;
    const o = t.getColor(tke);
    this.cursorColorPrimary = o ? o.transparent(0.7).toString() : null;
    const a = t.getColor(nke);
    this.cursorColorSecondary = a ? a.transparent(0.7).toString() : null, this.themeType = t.type;
    const l = n.get(
      73
      /* EditorOption.minimap */
    ), c = l.enabled, d = l.side, u = t.getColor(m4t), f = xi.getDefaultBackground();
    u ? this.backgroundColor = u : c && d === "right" ? this.backgroundColor = f : this.backgroundColor = null;
    const g = n.get(
      146
      /* EditorOption.layoutInfo */
    ).overviewRuler;
    this.top = g.top, this.right = g.right, this.domWidth = g.width, this.domHeight = g.height, this.overviewRulerLanes === 0 ? (this.canvasWidth = 0, this.canvasHeight = 0) : (this.canvasWidth = this.domWidth * this.pixelRatio | 0, this.canvasHeight = this.domHeight * this.pixelRatio | 0);
    const [m, A] = this._initLanes(1, this.canvasWidth, this.overviewRulerLanes);
    this.x = m, this.w = A;
  }
  _initLanes(e, t, n) {
    const i = t - e;
    if (n >= 3) {
      const s = Math.floor(i / 3), o = Math.floor(i / 3), a = i - s - o, l = e, c = l + s, d = l + s + a;
      return [
        [
          0,
          l,
          // Left
          c,
          // Center
          l,
          // Left | Center
          d,
          // Right
          l,
          // Left | Right
          c,
          // Center | Right
          l
          // Left | Center | Right
        ],
        [
          0,
          s,
          // Left
          a,
          // Center
          s + a,
          // Left | Center
          o,
          // Right
          s + a + o,
          // Left | Right
          a + o,
          // Center | Right
          s + a + o
          // Left | Center | Right
        ]
      ];
    } else if (n === 2) {
      const s = Math.floor(i / 2), o = i - s, a = e, l = a + s;
      return [
        [
          0,
          a,
          // Left
          a,
          // Center
          a,
          // Left | Center
          l,
          // Right
          a,
          // Left | Right
          a,
          // Center | Right
          a
          // Left | Center | Right
        ],
        [
          0,
          s,
          // Left
          s,
          // Center
          s,
          // Left | Center
          o,
          // Right
          s + o,
          // Left | Right
          s + o,
          // Center | Right
          s + o
          // Left | Center | Right
        ]
      ];
    } else {
      const s = e, o = i;
      return [
        [
          0,
          s,
          // Left
          s,
          // Center
          s,
          // Left | Center
          s,
          // Right
          s,
          // Left | Right
          s,
          // Center | Right
          s
          // Left | Center | Right
        ],
        [
          0,
          o,
          // Left
          o,
          // Center
          o,
          // Left | Center
          o,
          // Right
          o,
          // Left | Right
          o,
          // Center | Right
          o
          // Left | Center | Right
        ]
      ];
    }
  }
  equals(e) {
    return this.lineHeight === e.lineHeight && this.pixelRatio === e.pixelRatio && this.overviewRulerLanes === e.overviewRulerLanes && this.renderBorder === e.renderBorder && this.borderColor === e.borderColor && this.hideCursor === e.hideCursor && this.cursorColorSingle === e.cursorColorSingle && this.cursorColorPrimary === e.cursorColorPrimary && this.cursorColorSecondary === e.cursorColorSecondary && this.themeType === e.themeType && ge.equals(this.backgroundColor, e.backgroundColor) && this.top === e.top && this.right === e.right && this.domWidth === e.domWidth && this.domHeight === e.domHeight && this.canvasWidth === e.canvasWidth && this.canvasHeight === e.canvasHeight;
  }
}
class Qwt extends uo {
  constructor(e) {
    super(e), this._actualShouldRender = 0, this._renderedDecorations = [], this._renderedCursorPositions = [], this._domNode = Yt(document.createElement("canvas")), this._domNode.setClassName("decorationsOverviewRuler"), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._domNode.setAttribute("aria-hidden", "true"), this._updateSettings(!1), this._tokensColorTrackerListener = xi.onDidChange((t) => {
      t.changedColorMap && this._updateSettings(!0);
    }), this._cursorPositions = [{ position: new le(1, 1), color: this._settings.cursorColorSingle }];
  }
  dispose() {
    super.dispose(), this._tokensColorTrackerListener.dispose();
  }
  _updateSettings(e) {
    const t = new Gwt(this._context.configuration, this._context.theme);
    return this._settings && this._settings.equals(t) ? !1 : (this._settings = t, this._domNode.setTop(this._settings.top), this._domNode.setRight(this._settings.right), this._domNode.setWidth(this._settings.domWidth), this._domNode.setHeight(this._settings.domHeight), this._domNode.domNode.width = this._settings.canvasWidth, this._domNode.domNode.height = this._settings.canvasHeight, e && this._render(), !0);
  }
  // ---- begin view event handlers
  _markRenderingIsNeeded() {
    return this._actualShouldRender = 2, !0;
  }
  _markRenderingIsMaybeNeeded() {
    return this._actualShouldRender = 1, !0;
  }
  onConfigurationChanged(e) {
    return this._updateSettings(!1) ? this._markRenderingIsNeeded() : !1;
  }
  onCursorStateChanged(e) {
    this._cursorPositions = [];
    for (let t = 0, n = e.selections.length; t < n; t++) {
      let i = this._settings.cursorColorSingle;
      n > 1 && (i = t === 0 ? this._settings.cursorColorPrimary : this._settings.cursorColorSecondary), this._cursorPositions.push({ position: e.selections[t].getPosition(), color: i });
    }
    return this._cursorPositions.sort((t, n) => le.compare(t.position, n.position)), this._markRenderingIsMaybeNeeded();
  }
  onDecorationsChanged(e) {
    return e.affectsOverviewRuler ? this._markRenderingIsMaybeNeeded() : !1;
  }
  onFlushed(e) {
    return this._markRenderingIsNeeded();
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged ? this._markRenderingIsNeeded() : !1;
  }
  onZonesChanged(e) {
    return this._markRenderingIsNeeded();
  }
  onThemeChanged(e) {
    return this._updateSettings(!1) ? this._markRenderingIsNeeded() : !1;
  }
  // ---- end view event handlers
  getDomNode() {
    return this._domNode.domNode;
  }
  prepareRender(e) {
  }
  render(e) {
    this._render(), this._actualShouldRender = 0;
  }
  _render() {
    const e = this._settings.backgroundColor;
    if (this._settings.overviewRulerLanes === 0) {
      this._domNode.setBackgroundColor(e ? ge.Format.CSS.formatHexA(e) : ""), this._domNode.setDisplay("none");
      return;
    }
    const t = this._context.viewModel.getAllOverviewRulerDecorations(this._context.theme);
    if (t.sort(U3.compareByRenderingProps), this._actualShouldRender === 1 && !U3.equalsArr(this._renderedDecorations, t) && (this._actualShouldRender = 2), this._actualShouldRender === 1 && !Zi(this._renderedCursorPositions, this._cursorPositions, (g, m) => g.position.lineNumber === m.position.lineNumber && g.color === m.color) && (this._actualShouldRender = 2), this._actualShouldRender === 1)
      return;
    this._renderedDecorations = t, this._renderedCursorPositions = this._cursorPositions, this._domNode.setDisplay("block");
    const n = this._settings.canvasWidth, i = this._settings.canvasHeight, s = this._settings.lineHeight, o = this._context.viewLayout, a = this._context.viewLayout.getScrollHeight(), l = i / a, c = 6 * this._settings.pixelRatio | 0, d = c / 2 | 0, u = this._domNode.domNode.getContext("2d");
    e ? e.isOpaque() ? (u.fillStyle = ge.Format.CSS.formatHexA(e), u.fillRect(0, 0, n, i)) : (u.clearRect(0, 0, n, i), u.fillStyle = ge.Format.CSS.formatHexA(e), u.fillRect(0, 0, n, i)) : u.clearRect(0, 0, n, i);
    const f = this._settings.x, p = this._settings.w;
    for (const g of t) {
      const m = g.color, A = g.data;
      u.fillStyle = m;
      let w = 0, v = 0, y = 0;
      for (let _ = 0, S = A.length / 3; _ < S; _++) {
        const D = A[3 * _], M = A[3 * _ + 1], L = A[3 * _ + 2];
        let T = o.getVerticalOffsetForLineNumber(M) * l | 0, B = (o.getVerticalOffsetForLineNumber(L) + s) * l | 0;
        if (B - T < c) {
          let N = (T + B) / 2 | 0;
          N < d ? N = d : N + d > i && (N = i - d), T = N - d, B = N + d;
        }
        T > y + 1 || D !== w ? (_ !== 0 && u.fillRect(f[w], v, p[w], y - v), w = D, v = T, y = B) : B > y && (y = B);
      }
      u.fillRect(f[w], v, p[w], y - v);
    }
    if (!this._settings.hideCursor) {
      const g = 2 * this._settings.pixelRatio | 0, m = g / 2 | 0, A = this._settings.x[
        7
        /* OverviewRulerLane.Full */
      ], w = this._settings.w[
        7
        /* OverviewRulerLane.Full */
      ];
      let v = -100, y = -100, _ = null;
      for (let S = 0, D = this._cursorPositions.length; S < D; S++) {
        const M = this._cursorPositions[S].color;
        if (!M)
          continue;
        const L = this._cursorPositions[S].position;
        let T = o.getVerticalOffsetForLineNumber(L.lineNumber) * l | 0;
        T < m ? T = m : T + m > i && (T = i - m);
        const B = T - m, V = B + g;
        B > y + 1 || M !== _ ? (S !== 0 && _ && u.fillRect(A, v, w, y - v), v = B, y = V) : V > y && (y = V), _ = M, u.fillStyle = M;
      }
      _ && u.fillRect(A, v, w, y - v);
    }
    this._settings.renderBorder && this._settings.borderColor && this._settings.overviewRulerLanes > 0 && (u.beginPath(), u.lineWidth = 1, u.strokeStyle = this._settings.borderColor, u.moveTo(0, 0), u.lineTo(0, i), u.moveTo(1, 0), u.lineTo(n, 0), u.stroke());
  }
}
class N6e {
  constructor(e, t, n) {
    this._colorZoneBrand = void 0, this.from = e | 0, this.to = t | 0, this.colorId = n | 0;
  }
  static compare(e, t) {
    return e.colorId === t.colorId ? e.from === t.from ? e.to - t.to : e.from - t.from : e.colorId - t.colorId;
  }
}
class Cke {
  constructor(e, t, n, i) {
    this._overviewRulerZoneBrand = void 0, this.startLineNumber = e, this.endLineNumber = t, this.heightInLines = n, this.color = i, this._colorZone = null;
  }
  static compare(e, t) {
    return e.color === t.color ? e.startLineNumber === t.startLineNumber ? e.heightInLines === t.heightInLines ? e.endLineNumber - t.endLineNumber : e.heightInLines - t.heightInLines : e.startLineNumber - t.startLineNumber : e.color < t.color ? -1 : 1;
  }
  setColorZone(e) {
    this._colorZone = e;
  }
  getColorZones() {
    return this._colorZone;
  }
}
class Kwt {
  constructor(e) {
    this._getVerticalOffsetForLine = e, this._zones = [], this._colorZonesInvalid = !1, this._lineHeight = 0, this._domWidth = 0, this._domHeight = 0, this._outerHeight = 0, this._pixelRatio = 1, this._lastAssignedId = 0, this._color2Id = /* @__PURE__ */ Object.create(null), this._id2Color = [];
  }
  getId2Color() {
    return this._id2Color;
  }
  setZones(e) {
    this._zones = e, this._zones.sort(Cke.compare);
  }
  setLineHeight(e) {
    return this._lineHeight === e ? !1 : (this._lineHeight = e, this._colorZonesInvalid = !0, !0);
  }
  setPixelRatio(e) {
    this._pixelRatio = e, this._colorZonesInvalid = !0;
  }
  getDOMWidth() {
    return this._domWidth;
  }
  getCanvasWidth() {
    return this._domWidth * this._pixelRatio;
  }
  setDOMWidth(e) {
    return this._domWidth === e ? !1 : (this._domWidth = e, this._colorZonesInvalid = !0, !0);
  }
  getDOMHeight() {
    return this._domHeight;
  }
  getCanvasHeight() {
    return this._domHeight * this._pixelRatio;
  }
  setDOMHeight(e) {
    return this._domHeight === e ? !1 : (this._domHeight = e, this._colorZonesInvalid = !0, !0);
  }
  getOuterHeight() {
    return this._outerHeight;
  }
  setOuterHeight(e) {
    return this._outerHeight === e ? !1 : (this._outerHeight = e, this._colorZonesInvalid = !0, !0);
  }
  resolveColorZones() {
    const e = this._colorZonesInvalid, t = Math.floor(this._lineHeight), n = Math.floor(this.getCanvasHeight()), i = Math.floor(this._outerHeight), s = n / i, o = Math.floor(4 * this._pixelRatio / 2), a = [];
    for (let l = 0, c = this._zones.length; l < c; l++) {
      const d = this._zones[l];
      if (!e) {
        const _ = d.getColorZones();
        if (_) {
          a.push(_);
          continue;
        }
      }
      const u = this._getVerticalOffsetForLine(d.startLineNumber), f = d.heightInLines === 0 ? this._getVerticalOffsetForLine(d.endLineNumber) + t : u + d.heightInLines * t, p = Math.floor(s * u), g = Math.floor(s * f);
      let m = Math.floor((p + g) / 2), A = g - m;
      A < o && (A = o), m - A < 0 && (m = A), m + A > n && (m = n - A);
      const w = d.color;
      let v = this._color2Id[w];
      v || (v = ++this._lastAssignedId, this._color2Id[w] = v, this._id2Color[v] = w);
      const y = new N6e(m - A, m + A, v);
      d.setColorZone(y), a.push(y);
    }
    return this._colorZonesInvalid = !1, a.sort(N6e.compare), a;
  }
}
class Ywt extends Dw {
  constructor(e, t) {
    super(), this._context = e;
    const n = this._context.configuration.options;
    this._domNode = Yt(document.createElement("canvas")), this._domNode.setClassName(t), this._domNode.setPosition("absolute"), this._domNode.setLayerHinting(!0), this._domNode.setContain("strict"), this._zoneManager = new Kwt((i) => this._context.viewLayout.getVerticalOffsetForLineNumber(i)), this._zoneManager.setDOMWidth(0), this._zoneManager.setDOMHeight(0), this._zoneManager.setOuterHeight(this._context.viewLayout.getScrollHeight()), this._zoneManager.setLineHeight(n.get(
      67
      /* EditorOption.lineHeight */
    )), this._zoneManager.setPixelRatio(n.get(
      144
      /* EditorOption.pixelRatio */
    )), this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), super.dispose();
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return e.hasChanged(
      67
      /* EditorOption.lineHeight */
    ) && (this._zoneManager.setLineHeight(t.get(
      67
      /* EditorOption.lineHeight */
    )), this._render()), e.hasChanged(
      144
      /* EditorOption.pixelRatio */
    ) && (this._zoneManager.setPixelRatio(t.get(
      144
      /* EditorOption.pixelRatio */
    )), this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render()), !0;
  }
  onFlushed(e) {
    return this._render(), !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged && (this._zoneManager.setOuterHeight(e.scrollHeight), this._render()), !0;
  }
  onZonesChanged(e) {
    return this._render(), !0;
  }
  // ---- end view event handlers
  getDomNode() {
    return this._domNode.domNode;
  }
  setLayout(e) {
    this._domNode.setTop(e.top), this._domNode.setRight(e.right);
    let t = !1;
    t = this._zoneManager.setDOMWidth(e.width) || t, t = this._zoneManager.setDOMHeight(e.height) || t, t && (this._domNode.setWidth(this._zoneManager.getDOMWidth()), this._domNode.setHeight(this._zoneManager.getDOMHeight()), this._domNode.domNode.width = this._zoneManager.getCanvasWidth(), this._domNode.domNode.height = this._zoneManager.getCanvasHeight(), this._render());
  }
  setZones(e) {
    this._zoneManager.setZones(e), this._render();
  }
  _render() {
    if (this._zoneManager.getOuterHeight() === 0)
      return !1;
    const e = this._zoneManager.getCanvasWidth(), t = this._zoneManager.getCanvasHeight(), n = this._zoneManager.resolveColorZones(), i = this._zoneManager.getId2Color(), s = this._domNode.domNode.getContext("2d");
    return s.clearRect(0, 0, e, t), n.length > 0 && this._renderOneLane(s, n, i, e), !0;
  }
  _renderOneLane(e, t, n, i) {
    let s = 0, o = 0, a = 0;
    for (const l of t) {
      const c = l.colorId, d = l.from, u = l.to;
      c !== s ? (e.fillRect(0, o, i, a - o), s = c, e.fillStyle = n[s], o = d, a = u) : a >= d ? a = Math.max(a, u) : (e.fillRect(0, o, i, a - o), o = d, a = u);
    }
    e.fillRect(0, o, i, a - o);
  }
}
class Xwt extends uo {
  constructor(e) {
    super(e), this.domNode = Yt(document.createElement("div")), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.domNode.setClassName("view-rulers"), this._renderedRulers = [];
    const t = this._context.configuration.options;
    this._rulers = t.get(
      103
      /* EditorOption.rulers */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth;
  }
  dispose() {
    super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._rulers = t.get(
      103
      /* EditorOption.rulers */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onScrollChanged(e) {
    return e.scrollHeightChanged;
  }
  // --- end event handlers
  prepareRender(e) {
  }
  _ensureRulersCount() {
    const e = this._renderedRulers.length, t = this._rulers.length;
    if (e === t)
      return;
    if (e < t) {
      const { tabSize: i } = this._context.viewModel.model.getOptions(), s = i;
      let o = t - e;
      for (; o > 0; ) {
        const a = Yt(document.createElement("div"));
        a.setClassName("view-ruler"), a.setWidth(s), this.domNode.appendChild(a), this._renderedRulers.push(a), o--;
      }
      return;
    }
    let n = e - t;
    for (; n > 0; ) {
      const i = this._renderedRulers.pop();
      this.domNode.removeChild(i), n--;
    }
  }
  render(e) {
    this._ensureRulersCount();
    for (let t = 0, n = this._rulers.length; t < n; t++) {
      const i = this._renderedRulers[t], s = this._rulers[t];
      i.setBoxShadow(s.color ? `1px 0 0 0 ${s.color} inset` : ""), i.setHeight(Math.min(e.scrollHeight, 1e6)), i.setLeft(s.column * this._typicalHalfwidthCharacterWidth);
    }
  }
}
class Jwt extends uo {
  constructor(e) {
    super(e), this._scrollTop = 0, this._width = 0, this._updateWidth(), this._shouldShow = !1;
    const n = this._context.configuration.options.get(
      104
      /* EditorOption.scrollbar */
    );
    this._useShadows = n.useShadows, this._domNode = Yt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
  }
  dispose() {
    super.dispose();
  }
  _updateShouldShow() {
    const e = this._useShadows && this._scrollTop > 0;
    return this._shouldShow !== e ? (this._shouldShow = e, !0) : !1;
  }
  getDomNode() {
    return this._domNode;
  }
  _updateWidth() {
    const t = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    t.minimap.renderMinimap === 0 || t.minimap.minimapWidth > 0 && t.minimap.minimapLeft === 0 ? this._width = t.width : this._width = t.width - t.verticalScrollbarWidth;
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const n = this._context.configuration.options.get(
      104
      /* EditorOption.scrollbar */
    );
    return this._useShadows = n.useShadows, this._updateWidth(), this._updateShouldShow(), !0;
  }
  onScrollChanged(e) {
    return this._scrollTop = e.scrollTop, this._updateShouldShow();
  }
  // --- end event handlers
  prepareRender(e) {
  }
  render(e) {
    this._domNode.setWidth(this._width), this._domNode.setClassName(this._shouldShow ? "scroll-decoration" : "");
  }
}
class $wt {
  constructor(e) {
    this.left = e.left, this.width = e.width, this.startStyle = null, this.endStyle = null;
  }
}
class evt {
  constructor(e, t) {
    this.lineNumber = e, this.ranges = t;
  }
}
function tvt(r) {
  return new $wt(r);
}
function nvt(r) {
  return new evt(r.lineNumber, r.ranges.map(tvt));
}
class lr extends t2 {
  static {
    this.SELECTION_CLASS_NAME = "selected-text";
  }
  static {
    this.SELECTION_TOP_LEFT = "top-left-radius";
  }
  static {
    this.SELECTION_BOTTOM_LEFT = "bottom-left-radius";
  }
  static {
    this.SELECTION_TOP_RIGHT = "top-right-radius";
  }
  static {
    this.SELECTION_BOTTOM_RIGHT = "bottom-right-radius";
  }
  static {
    this.EDITOR_BACKGROUND_CLASS_NAME = "monaco-editor-background";
  }
  static {
    this.ROUNDED_PIECE_WIDTH = 10;
  }
  constructor(e) {
    super(), this._previousFrameVisibleRangesWithStyle = [], this._context = e;
    const t = this._context.configuration.options;
    this._roundedSelection = t.get(
      102
      /* EditorOption.roundedSelection */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, this._selections = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    return this._roundedSelection = t.get(
      102
      /* EditorOption.roundedSelection */
    ), this._typicalHalfwidthCharacterWidth = t.get(
      50
      /* EditorOption.fontInfo */
    ).typicalHalfwidthCharacterWidth, !0;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections.slice(0), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  _visibleRangesHaveGaps(e) {
    for (let t = 0, n = e.length; t < n; t++)
      if (e[t].ranges.length > 1)
        return !0;
    return !1;
  }
  _enrichVisibleRangesWithStyle(e, t, n) {
    const i = this._typicalHalfwidthCharacterWidth / 4;
    let s = null, o = null;
    if (n && n.length > 0 && t.length > 0) {
      const a = t[0].lineNumber;
      if (a === e.startLineNumber)
        for (let c = 0; !s && c < n.length; c++)
          n[c].lineNumber === a && (s = n[c].ranges[0]);
      const l = t[t.length - 1].lineNumber;
      if (l === e.endLineNumber)
        for (let c = n.length - 1; !o && c >= 0; c--)
          n[c].lineNumber === l && (o = n[c].ranges[0]);
      s && !s.startStyle && (s = null), o && !o.startStyle && (o = null);
    }
    for (let a = 0, l = t.length; a < l; a++) {
      const c = t[a].ranges[0], d = c.left, u = c.left + c.width, f = {
        top: 0,
        bottom: 0
        /* CornerStyle.EXTERN */
      }, p = {
        top: 0,
        bottom: 0
        /* CornerStyle.EXTERN */
      };
      if (a > 0) {
        const g = t[a - 1].ranges[0].left, m = t[a - 1].ranges[0].left + t[a - 1].ranges[0].width;
        Vv(d - g) < i ? f.top = 2 : d > g && (f.top = 1), Vv(u - m) < i ? p.top = 2 : g < u && u < m && (p.top = 1);
      } else s && (f.top = s.startStyle.top, p.top = s.endStyle.top);
      if (a + 1 < l) {
        const g = t[a + 1].ranges[0].left, m = t[a + 1].ranges[0].left + t[a + 1].ranges[0].width;
        Vv(d - g) < i ? f.bottom = 2 : g < d && d < m && (f.bottom = 1), Vv(u - m) < i ? p.bottom = 2 : u < m && (p.bottom = 1);
      } else o && (f.bottom = o.startStyle.bottom, p.bottom = o.endStyle.bottom);
      c.startStyle = f, c.endStyle = p;
    }
  }
  _getVisibleRangesWithStyle(e, t, n) {
    const s = (t.linesVisibleRangesForRange(e, !0) || []).map(nvt);
    return !this._visibleRangesHaveGaps(s) && this._roundedSelection && this._enrichVisibleRangesWithStyle(t.visibleRange, s, n), s;
  }
  _createSelectionPiece(e, t, n, i, s) {
    return '<div class="cslr ' + n + '" style="top:' + e.toString() + "px;bottom:" + t.toString() + "px;left:" + i.toString() + "px;width:" + s.toString() + 'px;"></div>';
  }
  _actualRenderOneSelection(e, t, n, i) {
    if (i.length === 0)
      return;
    const s = !!i[0].ranges[0].startStyle, o = i[0].lineNumber, a = i[i.length - 1].lineNumber;
    for (let l = 0, c = i.length; l < c; l++) {
      const d = i[l], u = d.lineNumber, f = u - t, p = n && u === o ? 1 : 0, g = n && u !== o && u === a ? 1 : 0;
      let m = "", A = "";
      for (let w = 0, v = d.ranges.length; w < v; w++) {
        const y = d.ranges[w];
        if (s) {
          const S = y.startStyle, D = y.endStyle;
          if (S.top === 1 || S.bottom === 1) {
            m += this._createSelectionPiece(p, g, lr.SELECTION_CLASS_NAME, y.left - lr.ROUNDED_PIECE_WIDTH, lr.ROUNDED_PIECE_WIDTH);
            let M = lr.EDITOR_BACKGROUND_CLASS_NAME;
            S.top === 1 && (M += " " + lr.SELECTION_TOP_RIGHT), S.bottom === 1 && (M += " " + lr.SELECTION_BOTTOM_RIGHT), m += this._createSelectionPiece(p, g, M, y.left - lr.ROUNDED_PIECE_WIDTH, lr.ROUNDED_PIECE_WIDTH);
          }
          if (D.top === 1 || D.bottom === 1) {
            m += this._createSelectionPiece(p, g, lr.SELECTION_CLASS_NAME, y.left + y.width, lr.ROUNDED_PIECE_WIDTH);
            let M = lr.EDITOR_BACKGROUND_CLASS_NAME;
            D.top === 1 && (M += " " + lr.SELECTION_TOP_LEFT), D.bottom === 1 && (M += " " + lr.SELECTION_BOTTOM_LEFT), m += this._createSelectionPiece(p, g, M, y.left + y.width, lr.ROUNDED_PIECE_WIDTH);
          }
        }
        let _ = lr.SELECTION_CLASS_NAME;
        if (s) {
          const S = y.startStyle, D = y.endStyle;
          S.top === 0 && (_ += " " + lr.SELECTION_TOP_LEFT), S.bottom === 0 && (_ += " " + lr.SELECTION_BOTTOM_LEFT), D.top === 0 && (_ += " " + lr.SELECTION_TOP_RIGHT), D.bottom === 0 && (_ += " " + lr.SELECTION_BOTTOM_RIGHT);
        }
        A += this._createSelectionPiece(p, g, _, y.left, y.width);
      }
      e[f][0] += m, e[f][1] += A;
    }
  }
  prepareRender(e) {
    const t = [], n = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber;
    for (let o = n; o <= i; o++) {
      const a = o - n;
      t[a] = ["", ""];
    }
    const s = [];
    for (let o = 0, a = this._selections.length; o < a; o++) {
      const l = this._selections[o];
      if (l.isEmpty()) {
        s[o] = null;
        continue;
      }
      const c = this._getVisibleRangesWithStyle(l, e, this._previousFrameVisibleRangesWithStyle[o]);
      s[o] = c, this._actualRenderOneSelection(t, n, this._selections.length > 1, c);
    }
    this._previousFrameVisibleRangesWithStyle = s, this._renderResult = t.map(([o, a]) => o + a);
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
Sh((r, e) => {
  const t = r.getColor(Rmt);
  t && !t.isTransparent() && e.addRule(`.monaco-editor .view-line span.inline-selected-text { color: ${t}; }`);
});
function Vv(r) {
  return r < 0 ? -r : r;
}
class T6e {
  constructor(e, t, n, i, s, o, a) {
    this.top = e, this.left = t, this.paddingLeft = n, this.width = i, this.height = s, this.textContent = o, this.textContentClassName = a;
  }
}
var fd;
(function(r) {
  r[r.Single = 0] = "Single", r[r.MultiPrimary = 1] = "MultiPrimary", r[r.MultiSecondary = 2] = "MultiSecondary";
})(fd || (fd = {}));
class I6e {
  constructor(e, t) {
    this._context = e;
    const n = this._context.configuration.options, i = n.get(
      50
      /* EditorOption.fontInfo */
    );
    this._cursorStyle = n.get(
      28
      /* EditorOption.cursorStyle */
    ), this._lineHeight = n.get(
      67
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = i.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(n.get(
      31
      /* EditorOption.cursorWidth */
    ), this._typicalHalfwidthCharacterWidth), this._isVisible = !0, this._domNode = Yt(document.createElement("div")), this._domNode.setClassName(`cursor ${_p}`), this._domNode.setHeight(this._lineHeight), this._domNode.setTop(0), this._domNode.setLeft(0), Br(this._domNode, i), this._domNode.setDisplay("none"), this._position = new le(1, 1), this._pluralityClass = "", this.setPlurality(t), this._lastRenderedContent = "", this._renderData = null;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._position;
  }
  setPlurality(e) {
    switch (e) {
      default:
      case fd.Single:
        this._pluralityClass = "";
        break;
      case fd.MultiPrimary:
        this._pluralityClass = "cursor-primary";
        break;
      case fd.MultiSecondary:
        this._pluralityClass = "cursor-secondary";
        break;
    }
  }
  show() {
    this._isVisible || (this._domNode.setVisibility("inherit"), this._isVisible = !0);
  }
  hide() {
    this._isVisible && (this._domNode.setVisibility("hidden"), this._isVisible = !1);
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    );
    return this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._typicalHalfwidthCharacterWidth = n.typicalHalfwidthCharacterWidth, this._lineCursorWidth = Math.min(t.get(
      31
      /* EditorOption.cursorWidth */
    ), this._typicalHalfwidthCharacterWidth), Br(this._domNode, n), !0;
  }
  onCursorPositionChanged(e, t) {
    return t ? this._domNode.domNode.style.transitionProperty = "none" : this._domNode.domNode.style.transitionProperty = "", this._position = e, !0;
  }
  /**
   * If `this._position` is inside a grapheme, returns the position where the grapheme starts.
   * Also returns the next grapheme.
   */
  _getGraphemeAwarePosition() {
    const { lineNumber: e, column: t } = this._position, n = this._context.viewModel.getLineContent(e), [i, s] = M0t(n, t - 1);
    return [new le(e, i + 1), n.substring(i, s)];
  }
  _prepareRender(e) {
    let t = "", n = "";
    const [i, s] = this._getGraphemeAwarePosition();
    if (this._cursorStyle === gr.Line || this._cursorStyle === gr.LineThin) {
      const f = e.visibleRangeForPosition(i);
      if (!f || f.outsideRenderedLine)
        return null;
      const p = qe(this._domNode.domNode);
      let g;
      this._cursorStyle === gr.Line ? (g = Yve(p, this._lineCursorWidth > 0 ? this._lineCursorWidth : 2), g > 2 && (t = s, n = this._getTokenClassName(i))) : g = Yve(p, 1);
      let m = f.left, A = 0;
      g >= 2 && m >= 1 && (A = 1, m -= A);
      const w = e.getVerticalOffsetForLineNumber(i.lineNumber) - e.bigNumbersDelta;
      return new T6e(w, m, A, g, this._lineHeight, t, n);
    }
    const o = e.linesVisibleRangesForRange(new Q(i.lineNumber, i.column, i.lineNumber, i.column + s.length), !1);
    if (!o || o.length === 0)
      return null;
    const a = o[0];
    if (a.outsideRenderedLine || a.ranges.length === 0)
      return null;
    const l = a.ranges[0], c = s === "	" ? this._typicalHalfwidthCharacterWidth : l.width < 1 ? this._typicalHalfwidthCharacterWidth : l.width;
    this._cursorStyle === gr.Block && (t = s, n = this._getTokenClassName(i));
    let d = e.getVerticalOffsetForLineNumber(i.lineNumber) - e.bigNumbersDelta, u = this._lineHeight;
    return (this._cursorStyle === gr.Underline || this._cursorStyle === gr.UnderlineThin) && (d += this._lineHeight - 2, u = 2), new T6e(d, l.left, 0, c, u, t, n);
  }
  _getTokenClassName(e) {
    const t = this._context.viewModel.getViewLineData(e.lineNumber), n = t.tokens.findTokenIndexAtOffset(e.column - 1);
    return t.tokens.getClassName(n);
  }
  prepareRender(e) {
    this._renderData = this._prepareRender(e);
  }
  render(e) {
    return this._renderData ? (this._lastRenderedContent !== this._renderData.textContent && (this._lastRenderedContent = this._renderData.textContent, this._domNode.domNode.textContent = this._lastRenderedContent), this._domNode.setClassName(`cursor ${this._pluralityClass} ${_p} ${this._renderData.textContentClassName}`), this._domNode.setDisplay("block"), this._domNode.setTop(this._renderData.top), this._domNode.setLeft(this._renderData.left), this._domNode.setPaddingLeft(this._renderData.paddingLeft), this._domNode.setWidth(this._renderData.width), this._domNode.setLineHeight(this._renderData.height), this._domNode.setHeight(this._renderData.height), {
      domNode: this._domNode.domNode,
      position: this._position,
      contentLeft: this._renderData.left,
      height: this._renderData.height,
      width: 2
    }) : (this._domNode.setDisplay("none"), null);
  }
}
class u9 extends uo {
  static {
    this.BLINK_INTERVAL = 500;
  }
  constructor(e) {
    super(e);
    const t = this._context.configuration.options;
    this._readOnly = t.get(
      92
      /* EditorOption.readOnly */
    ), this._cursorBlinking = t.get(
      26
      /* EditorOption.cursorBlinking */
    ), this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._cursorSmoothCaretAnimation = t.get(
      27
      /* EditorOption.cursorSmoothCaretAnimation */
    ), this._selectionIsEmpty = !0, this._isComposingInput = !1, this._isVisible = !1, this._primaryCursor = new I6e(this._context, fd.Single), this._secondaryCursors = [], this._renderData = [], this._domNode = Yt(document.createElement("div")), this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true"), this._updateDomClassName(), this._domNode.appendChild(this._primaryCursor.getDomNode()), this._startCursorBlinkAnimation = new T1(), this._cursorFlatBlinkInterval = new qI(), this._blinkingEnabled = !1, this._editorHasFocus = !1, this._updateBlinking();
  }
  dispose() {
    super.dispose(), this._startCursorBlinkAnimation.dispose(), this._cursorFlatBlinkInterval.dispose();
  }
  getDomNode() {
    return this._domNode;
  }
  // --- begin event handlers
  onCompositionStart(e) {
    return this._isComposingInput = !0, this._updateBlinking(), !0;
  }
  onCompositionEnd(e) {
    return this._isComposingInput = !1, this._updateBlinking(), !0;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options;
    this._readOnly = t.get(
      92
      /* EditorOption.readOnly */
    ), this._cursorBlinking = t.get(
      26
      /* EditorOption.cursorBlinking */
    ), this._cursorStyle = t.get(
      28
      /* EditorOption.cursorStyle */
    ), this._cursorSmoothCaretAnimation = t.get(
      27
      /* EditorOption.cursorSmoothCaretAnimation */
    ), this._updateBlinking(), this._updateDomClassName(), this._primaryCursor.onConfigurationChanged(e);
    for (let n = 0, i = this._secondaryCursors.length; n < i; n++)
      this._secondaryCursors[n].onConfigurationChanged(e);
    return !0;
  }
  _onCursorPositionChanged(e, t, n) {
    const i = this._secondaryCursors.length !== t.length || this._cursorSmoothCaretAnimation === "explicit" && n !== 3;
    if (this._primaryCursor.setPlurality(t.length ? fd.MultiPrimary : fd.Single), this._primaryCursor.onCursorPositionChanged(e, i), this._updateBlinking(), this._secondaryCursors.length < t.length) {
      const s = t.length - this._secondaryCursors.length;
      for (let o = 0; o < s; o++) {
        const a = new I6e(this._context, fd.MultiSecondary);
        this._domNode.domNode.insertBefore(a.getDomNode().domNode, this._primaryCursor.getDomNode().domNode.nextSibling), this._secondaryCursors.push(a);
      }
    } else if (this._secondaryCursors.length > t.length) {
      const s = this._secondaryCursors.length - t.length;
      for (let o = 0; o < s; o++)
        this._domNode.removeChild(this._secondaryCursors[0].getDomNode()), this._secondaryCursors.splice(0, 1);
    }
    for (let s = 0; s < t.length; s++)
      this._secondaryCursors[s].onCursorPositionChanged(t[s], i);
  }
  onCursorStateChanged(e) {
    const t = [];
    for (let i = 0, s = e.selections.length; i < s; i++)
      t[i] = e.selections[i].getPosition();
    this._onCursorPositionChanged(t[0], t.slice(1), e.reason);
    const n = e.selections[0].isEmpty();
    return this._selectionIsEmpty !== n && (this._selectionIsEmpty = n, this._updateDomClassName()), !0;
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onFocusChanged(e) {
    return this._editorHasFocus = e.isFocused, this._updateBlinking(), !1;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return !0;
  }
  onTokensChanged(e) {
    const t = (n) => {
      for (let i = 0, s = e.ranges.length; i < s; i++)
        if (e.ranges[i].fromLineNumber <= n.lineNumber && n.lineNumber <= e.ranges[i].toLineNumber)
          return !0;
      return !1;
    };
    if (t(this._primaryCursor.getPosition()))
      return !0;
    for (const n of this._secondaryCursors)
      if (t(n.getPosition()))
        return !0;
    return !1;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  // ---- blinking logic
  _getCursorBlinking() {
    return this._isComposingInput || !this._editorHasFocus ? 0 : this._readOnly ? 5 : this._cursorBlinking;
  }
  _updateBlinking() {
    this._startCursorBlinkAnimation.cancel(), this._cursorFlatBlinkInterval.cancel();
    const e = this._getCursorBlinking(), t = e === 0, n = e === 5;
    t ? this._hide() : this._show(), this._blinkingEnabled = !1, this._updateDomClassName(), !t && !n && (e === 1 ? this._cursorFlatBlinkInterval.cancelAndSet(() => {
      this._isVisible ? this._hide() : this._show();
    }, u9.BLINK_INTERVAL, qe(this._domNode.domNode)) : this._startCursorBlinkAnimation.setIfNotSet(() => {
      this._blinkingEnabled = !0, this._updateDomClassName();
    }, u9.BLINK_INTERVAL));
  }
  // --- end blinking logic
  _updateDomClassName() {
    this._domNode.setClassName(this._getClassName());
  }
  _getClassName() {
    let e = "cursors-layer";
    switch (this._selectionIsEmpty || (e += " has-selection"), this._cursorStyle) {
      case gr.Line:
        e += " cursor-line-style";
        break;
      case gr.Block:
        e += " cursor-block-style";
        break;
      case gr.Underline:
        e += " cursor-underline-style";
        break;
      case gr.LineThin:
        e += " cursor-line-thin-style";
        break;
      case gr.BlockOutline:
        e += " cursor-block-outline-style";
        break;
      case gr.UnderlineThin:
        e += " cursor-underline-thin-style";
        break;
      default:
        e += " cursor-line-style";
    }
    if (this._blinkingEnabled)
      switch (this._getCursorBlinking()) {
        case 1:
          e += " cursor-blink";
          break;
        case 2:
          e += " cursor-smooth";
          break;
        case 3:
          e += " cursor-phase";
          break;
        case 4:
          e += " cursor-expand";
          break;
        case 5:
          e += " cursor-solid";
          break;
        default:
          e += " cursor-solid";
      }
    else
      e += " cursor-solid";
    return (this._cursorSmoothCaretAnimation === "on" || this._cursorSmoothCaretAnimation === "explicit") && (e += " cursor-smooth-caret-animation"), e;
  }
  _show() {
    this._primaryCursor.show();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++)
      this._secondaryCursors[e].show();
    this._isVisible = !0;
  }
  _hide() {
    this._primaryCursor.hide();
    for (let e = 0, t = this._secondaryCursors.length; e < t; e++)
      this._secondaryCursors[e].hide();
    this._isVisible = !1;
  }
  // ---- IViewPart implementation
  prepareRender(e) {
    this._primaryCursor.prepareRender(e);
    for (let t = 0, n = this._secondaryCursors.length; t < n; t++)
      this._secondaryCursors[t].prepareRender(e);
  }
  render(e) {
    const t = [];
    let n = 0;
    const i = this._primaryCursor.render(e);
    i && (t[n++] = i);
    for (let s = 0, o = this._secondaryCursors.length; s < o; s++) {
      const a = this._secondaryCursors[s].render(e);
      a && (t[n++] = a);
    }
    this._renderData = t;
  }
  getLastRenderData() {
    return this._renderData;
  }
}
Sh((r, e) => {
  const t = [
    { class: ".cursor", foreground: py, background: kO },
    { class: ".cursor-primary", foreground: tke, background: J3t },
    { class: ".cursor-secondary", foreground: nke, background: $3t }
  ];
  for (const n of t) {
    const i = r.getColor(n.foreground);
    if (i) {
      let s = r.getColor(n.background);
      s || (s = i.opposite()), e.addRule(`.monaco-editor .cursors-layer ${n.class} { background-color: ${i}; border-color: ${i}; color: ${s}; }`), $u(r.type) && e.addRule(`.monaco-editor .cursors-layer.has-selection ${n.class} { border-left: 1px solid ${s}; border-right: 1px solid ${s}; }`);
    }
  }
});
const XE = () => {
  throw new Error("Invalid change accessor");
};
class ivt extends uo {
  constructor(e) {
    super(e);
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, this.domNode = Yt(document.createElement("div")), this.domNode.setClassName("view-zones"), this.domNode.setPosition("absolute"), this.domNode.setAttribute("role", "presentation"), this.domNode.setAttribute("aria-hidden", "true"), this.marginDomNode = Yt(document.createElement("div")), this.marginDomNode.setClassName("margin-view-zones"), this.marginDomNode.setPosition("absolute"), this.marginDomNode.setAttribute("role", "presentation"), this.marginDomNode.setAttribute("aria-hidden", "true"), this._zones = {};
  }
  dispose() {
    super.dispose(), this._zones = {};
  }
  // ---- begin view event handlers
  _recomputeWhitespacesProps() {
    const e = this._context.viewLayout.getWhitespaces(), t = /* @__PURE__ */ new Map();
    for (const i of e)
      t.set(i.id, i);
    let n = !1;
    return this._context.viewModel.changeWhitespace((i) => {
      const s = Object.keys(this._zones);
      for (let o = 0, a = s.length; o < a; o++) {
        const l = s[o], c = this._zones[l], d = this._computeWhitespaceProps(c.delegate);
        c.isInHiddenArea = d.isInHiddenArea;
        const u = t.get(l);
        u && (u.afterLineNumber !== d.afterViewLineNumber || u.height !== d.heightInPx) && (i.changeOneWhitespace(l, d.afterViewLineNumber, d.heightInPx), this._safeCallOnComputedHeight(c.delegate, d.heightInPx), n = !0);
      }
    }), n;
  }
  onConfigurationChanged(e) {
    const t = this._context.configuration.options, n = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return this._lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this._contentWidth = n.contentWidth, this._contentLeft = n.contentLeft, e.hasChanged(
      67
      /* EditorOption.lineHeight */
    ) && this._recomputeWhitespacesProps(), !0;
  }
  onLineMappingChanged(e) {
    return this._recomputeWhitespacesProps();
  }
  onLinesDeleted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged || e.scrollWidthChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  // ---- end view event handlers
  _getZoneOrdinal(e) {
    return e.ordinal ?? e.afterColumn ?? 1e4;
  }
  _computeWhitespaceProps(e) {
    if (e.afterLineNumber === 0)
      return {
        isInHiddenArea: !1,
        afterViewLineNumber: 0,
        heightInPx: this._heightInPixels(e),
        minWidthInPx: this._minWidthInPixels(e)
      };
    let t;
    if (typeof e.afterColumn < "u")
      t = this._context.viewModel.model.validatePosition({
        lineNumber: e.afterLineNumber,
        column: e.afterColumn
      });
    else {
      const o = this._context.viewModel.model.validatePosition({
        lineNumber: e.afterLineNumber,
        column: 1
      }).lineNumber;
      t = new le(o, this._context.viewModel.model.getLineMaxColumn(o));
    }
    let n;
    t.column === this._context.viewModel.model.getLineMaxColumn(t.lineNumber) ? n = this._context.viewModel.model.validatePosition({
      lineNumber: t.lineNumber + 1,
      column: 1
    }) : n = this._context.viewModel.model.validatePosition({
      lineNumber: t.lineNumber,
      column: t.column + 1
    });
    const i = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(t, e.afterColumnAffinity, !0), s = e.showInHiddenAreas || this._context.viewModel.coordinatesConverter.modelPositionIsVisible(n);
    return {
      isInHiddenArea: !s,
      afterViewLineNumber: i.lineNumber,
      heightInPx: s ? this._heightInPixels(e) : 0,
      minWidthInPx: this._minWidthInPixels(e)
    };
  }
  changeViewZones(e) {
    let t = !1;
    return this._context.viewModel.changeWhitespace((n) => {
      const i = {
        addZone: (s) => (t = !0, this._addZone(n, s)),
        removeZone: (s) => {
          s && (t = this._removeZone(n, s) || t);
        },
        layoutZone: (s) => {
          s && (t = this._layoutZone(n, s) || t);
        }
      };
      rvt(e, i), i.addZone = XE, i.removeZone = XE, i.layoutZone = XE;
    }), t;
  }
  _addZone(e, t) {
    const n = this._computeWhitespaceProps(t), s = {
      whitespaceId: e.insertWhitespace(n.afterViewLineNumber, this._getZoneOrdinal(t), n.heightInPx, n.minWidthInPx),
      delegate: t,
      isInHiddenArea: n.isInHiddenArea,
      isVisible: !1,
      domNode: Yt(t.domNode),
      marginDomNode: t.marginDomNode ? Yt(t.marginDomNode) : null
    };
    return this._safeCallOnComputedHeight(s.delegate, n.heightInPx), s.domNode.setPosition("absolute"), s.domNode.domNode.style.width = "100%", s.domNode.setDisplay("none"), s.domNode.setAttribute("monaco-view-zone", s.whitespaceId), this.domNode.appendChild(s.domNode), s.marginDomNode && (s.marginDomNode.setPosition("absolute"), s.marginDomNode.domNode.style.width = "100%", s.marginDomNode.setDisplay("none"), s.marginDomNode.setAttribute("monaco-view-zone", s.whitespaceId), this.marginDomNode.appendChild(s.marginDomNode)), this._zones[s.whitespaceId] = s, this.setShouldRender(), s.whitespaceId;
  }
  _removeZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t];
      return delete this._zones[t], e.removeWhitespace(n.whitespaceId), n.domNode.removeAttribute("monaco-visible-view-zone"), n.domNode.removeAttribute("monaco-view-zone"), n.domNode.domNode.remove(), n.marginDomNode && (n.marginDomNode.removeAttribute("monaco-visible-view-zone"), n.marginDomNode.removeAttribute("monaco-view-zone"), n.marginDomNode.domNode.remove()), this.setShouldRender(), !0;
    }
    return !1;
  }
  _layoutZone(e, t) {
    if (this._zones.hasOwnProperty(t)) {
      const n = this._zones[t], i = this._computeWhitespaceProps(n.delegate);
      return n.isInHiddenArea = i.isInHiddenArea, e.changeOneWhitespace(n.whitespaceId, i.afterViewLineNumber, i.heightInPx), this._safeCallOnComputedHeight(n.delegate, i.heightInPx), this.setShouldRender(), !0;
    }
    return !1;
  }
  shouldSuppressMouseDownOnViewZone(e) {
    return this._zones.hasOwnProperty(e) ? !!this._zones[e].delegate.suppressMouseDown : !1;
  }
  _heightInPixels(e) {
    return typeof e.heightInPx == "number" ? e.heightInPx : typeof e.heightInLines == "number" ? this._lineHeight * e.heightInLines : this._lineHeight;
  }
  _minWidthInPixels(e) {
    return typeof e.minWidthInPx == "number" ? e.minWidthInPx : 0;
  }
  _safeCallOnComputedHeight(e, t) {
    if (typeof e.onComputedHeight == "function")
      try {
        e.onComputedHeight(t);
      } catch (n) {
        wn(n);
      }
  }
  _safeCallOnDomNodeTop(e, t) {
    if (typeof e.onDomNodeTop == "function")
      try {
        e.onDomNodeTop(t);
      } catch (n) {
        wn(n);
      }
  }
  prepareRender(e) {
  }
  render(e) {
    const t = e.viewportData.whitespaceViewportData, n = {};
    let i = !1;
    for (const o of t)
      this._zones[o.id].isInHiddenArea || (n[o.id] = o, i = !0);
    const s = Object.keys(this._zones);
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o], c = this._zones[l];
      let d = 0, u = 0, f = "none";
      n.hasOwnProperty(l) ? (d = n[l].verticalOffset - e.bigNumbersDelta, u = n[l].height, f = "block", c.isVisible || (c.domNode.setAttribute("monaco-visible-view-zone", "true"), c.isVisible = !0), this._safeCallOnDomNodeTop(c.delegate, e.getScrolledTopFromAbsoluteTop(n[l].verticalOffset))) : (c.isVisible && (c.domNode.removeAttribute("monaco-visible-view-zone"), c.isVisible = !1), this._safeCallOnDomNodeTop(c.delegate, e.getScrolledTopFromAbsoluteTop(-1e6))), c.domNode.setTop(d), c.domNode.setHeight(u), c.domNode.setDisplay(f), c.marginDomNode && (c.marginDomNode.setTop(d), c.marginDomNode.setHeight(u), c.marginDomNode.setDisplay(f));
    }
    i && (this.domNode.setWidth(Math.max(e.scrollWidth, this._contentWidth)), this.marginDomNode.setWidth(this._contentLeft));
  }
}
function rvt(r, e) {
  try {
    return r(e);
  } catch (t) {
    wn(t);
  }
}
class svt extends t2 {
  constructor(e) {
    super(), this._context = e, this._options = new O6e(this._context.configuration), this._selection = [], this._renderResult = null, this._context.addEventHandler(this);
  }
  dispose() {
    this._context.removeEventHandler(this), this._renderResult = null, super.dispose();
  }
  // --- begin event handlers
  onConfigurationChanged(e) {
    const t = new O6e(this._context.configuration);
    return this._options.equals(t) ? e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    ) : (this._options = t, !0);
  }
  onCursorStateChanged(e) {
    return this._selection = e.selections, this._options.renderWhitespace === "selection";
  }
  onDecorationsChanged(e) {
    return !0;
  }
  onFlushed(e) {
    return !0;
  }
  onLinesChanged(e) {
    return !0;
  }
  onLinesDeleted(e) {
    return !0;
  }
  onLinesInserted(e) {
    return !0;
  }
  onScrollChanged(e) {
    return e.scrollTopChanged;
  }
  onZonesChanged(e) {
    return !0;
  }
  // --- end event handlers
  prepareRender(e) {
    if (this._options.renderWhitespace === "none") {
      this._renderResult = null;
      return;
    }
    const t = e.visibleRange.startLineNumber, i = e.visibleRange.endLineNumber - t + 1, s = new Array(i);
    for (let a = 0; a < i; a++)
      s[a] = !0;
    const o = this._context.viewModel.getMinimapLinesRenderingData(e.viewportData.startLineNumber, e.viewportData.endLineNumber, s);
    this._renderResult = [];
    for (let a = e.viewportData.startLineNumber; a <= e.viewportData.endLineNumber; a++) {
      const l = a - e.viewportData.startLineNumber, c = o.data[l];
      let d = null;
      if (this._options.renderWhitespace === "selection") {
        const u = this._selection;
        for (const f of u) {
          if (f.endLineNumber < a || f.startLineNumber > a)
            continue;
          const p = f.startLineNumber === a ? f.startColumn : c.minColumn, g = f.endLineNumber === a ? f.endColumn : c.maxColumn;
          p < g && (d || (d = []), d.push(new wLe(p - 1, g - 1)));
        }
      }
      this._renderResult[l] = this._applyRenderWhitespace(e, a, d, c);
    }
  }
  _applyRenderWhitespace(e, t, n, i) {
    if (this._options.renderWhitespace === "selection" && !n || this._options.renderWhitespace === "trailing" && i.continuesWithWrappedLine)
      return "";
    const s = this._context.theme.getColor(NO), o = this._options.renderWithSVG, a = i.content, l = this._options.stopRenderingLineAfter === -1 ? a.length : Math.min(this._options.stopRenderingLineAfter, a.length), c = i.continuesWithWrappedLine, d = i.minColumn - 1, u = this._options.renderWhitespace === "boundary", f = this._options.renderWhitespace === "trailing", p = this._options.lineHeight, g = this._options.middotWidth, m = this._options.wsmiddotWidth, A = this._options.spaceWidth, w = Math.abs(m - A), v = Math.abs(g - A), y = w < v ? 11825 : 183, _ = this._options.canUseHalfwidthRightwardsArrow;
    let S = "", D = !1, M = so(a), L;
    M === -1 ? (D = !0, M = l, L = l) : L = Zf(a);
    let T = 0, B = n && n[T], V = 0;
    for (let N = d; N < l; N++) {
      const R = a.charCodeAt(N);
      if (B && N >= B.endOffset && (T++, B = n && n[T]), R !== 9 && R !== 32 || f && !D && N <= L)
        continue;
      if (u && N >= M && N <= L && R === 32) {
        const z = N - 1 >= 0 ? a.charCodeAt(N - 1) : 0, U = N + 1 < l ? a.charCodeAt(N + 1) : 0;
        if (z !== 32 && U !== 32)
          continue;
      }
      if (u && c && N === l - 1) {
        const z = N - 1 >= 0 ? a.charCodeAt(N - 1) : 0;
        if (R === 32 && z !== 32 && z !== 9)
          continue;
      }
      if (n && (!B || B.startOffset > N || B.endOffset <= N))
        continue;
      const H = e.visibleRangeForPosition(new le(t, N + 1));
      H && (o ? (V = Math.max(V, H.left), R === 9 ? S += this._renderArrow(p, A, H.left) : S += `<circle cx="${(H.left + A / 2).toFixed(2)}" cy="${(p / 2).toFixed(2)}" r="${(A / 7).toFixed(2)}" />`) : R === 9 ? S += `<div class="mwh" style="left:${H.left}px;height:${p}px;">${_ ? "￫" : "→"}</div>` : S += `<div class="mwh" style="left:${H.left}px;height:${p}px;">${String.fromCharCode(y)}</div>`);
    }
    return o ? (V = Math.round(V + A), `<svg style="bottom:0;position:absolute;width:${V}px;height:${p}px" viewBox="0 0 ${V} ${p}" xmlns="http://www.w3.org/2000/svg" fill="${s}">` + S + "</svg>") : S;
  }
  _renderArrow(e, t, n) {
    const i = t / 7, s = t, o = e / 2, a = n, l = { x: 0, y: i / 2 }, c = { x: 100 / 125 * s, y: l.y }, d = { x: c.x - 0.2 * c.x, y: c.y + 0.2 * c.x }, u = { x: d.x + 0.1 * c.x, y: d.y + 0.1 * c.x }, f = { x: u.x + 0.35 * c.x, y: u.y - 0.35 * c.x }, p = { x: f.x, y: -f.y }, g = { x: u.x, y: -u.y }, m = { x: d.x, y: -d.y }, A = { x: c.x, y: -c.y }, w = { x: l.x, y: -l.y };
    return `<path d="M ${[l, c, d, u, f, p, g, m, A, w].map((_) => `${(a + _.x).toFixed(2)} ${(o + _.y).toFixed(2)}`).join(" L ")}" />`;
  }
  render(e, t) {
    if (!this._renderResult)
      return "";
    const n = t - e;
    return n < 0 || n >= this._renderResult.length ? "" : this._renderResult[n];
  }
}
class O6e {
  constructor(e) {
    const t = e.options, n = t.get(
      50
      /* EditorOption.fontInfo */
    ), i = t.get(
      38
      /* EditorOption.experimentalWhitespaceRendering */
    );
    i === "off" ? (this.renderWhitespace = "none", this.renderWithSVG = !1) : i === "svg" ? (this.renderWhitespace = t.get(
      100
      /* EditorOption.renderWhitespace */
    ), this.renderWithSVG = !0) : (this.renderWhitespace = t.get(
      100
      /* EditorOption.renderWhitespace */
    ), this.renderWithSVG = !1), this.spaceWidth = n.spaceWidth, this.middotWidth = n.middotWidth, this.wsmiddotWidth = n.wsmiddotWidth, this.canUseHalfwidthRightwardsArrow = n.canUseHalfwidthRightwardsArrow, this.lineHeight = t.get(
      67
      /* EditorOption.lineHeight */
    ), this.stopRenderingLineAfter = t.get(
      118
      /* EditorOption.stopRenderingLineAfter */
    );
  }
  equals(e) {
    return this.renderWhitespace === e.renderWhitespace && this.renderWithSVG === e.renderWithSVG && this.spaceWidth === e.spaceWidth && this.middotWidth === e.middotWidth && this.wsmiddotWidth === e.wsmiddotWidth && this.canUseHalfwidthRightwardsArrow === e.canUseHalfwidthRightwardsArrow && this.lineHeight === e.lineHeight && this.stopRenderingLineAfter === e.stopRenderingLineAfter;
  }
}
class ovt {
  constructor(e, t, n, i) {
    this.selections = e, this.startLineNumber = t.startLineNumber | 0, this.endLineNumber = t.endLineNumber | 0, this.relativeVerticalOffset = t.relativeVerticalOffset, this.bigNumbersDelta = t.bigNumbersDelta | 0, this.lineHeight = t.lineHeight | 0, this.whitespaceViewportData = n, this._model = i, this.visibleRange = new Q(t.startLineNumber, this._model.getLineMinColumn(t.startLineNumber), t.endLineNumber, this._model.getLineMaxColumn(t.endLineNumber));
  }
  getViewLineRenderingData(e) {
    return this._model.getViewportViewLineRenderingData(this.visibleRange, e);
  }
  getDecorationsInViewport() {
    return this._model.getDecorationsInViewport(this.visibleRange);
  }
}
class avt {
  get type() {
    return this._theme.type;
  }
  get value() {
    return this._theme;
  }
  constructor(e) {
    this._theme = e;
  }
  update(e) {
    this._theme = e;
  }
  getColor(e) {
    return this._theme.getColor(e);
  }
}
class lvt {
  constructor(e, t, n) {
    this.configuration = e, this.theme = new avt(t), this.viewModel = n, this.viewLayout = n.viewLayout;
  }
  addEventHandler(e) {
    this.viewModel.addViewEventHandler(e);
  }
  removeEventHandler(e) {
    this.viewModel.removeViewEventHandler(e);
  }
}
var cvt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, hvt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let CL = class extends Dw {
  constructor(e, t, n, i, s, o, a) {
    super(), this._instantiationService = a, this._shouldRecomputeGlyphMarginLanes = !1, this._selections = [new _n(1, 1, 1, 1)], this._renderAnimationFrame = null, this._overflowWidgetsDomNode = o ?? null;
    const l = new gwt(t, i, s, e);
    this._context = new lvt(t, n, i), this._context.addEventHandler(this), this._viewParts = [], this._textAreaHandler = this._instantiationService.createInstance(wL, this._context, l, this._createTextAreaHandlerHelper()), this._viewParts.push(this._textAreaHandler), this._linesContent = Yt(document.createElement("div")), this._linesContent.setClassName("lines-content monaco-editor-background"), this._linesContent.setPosition("absolute"), this.domNode = Yt(document.createElement("div")), this.domNode.setClassName(this._getEditorClassName()), this.domNode.setAttribute("role", "code"), this._overflowGuardContainer = Yt(document.createElement("div")), rc.write(
      this._overflowGuardContainer,
      3
      /* PartFingerprint.OverflowGuard */
    ), this._overflowGuardContainer.setClassName("overflow-guard"), this._scrollbar = new xwt(this._context, this._linesContent, this.domNode, this._overflowGuardContainer), this._viewParts.push(this._scrollbar), this._viewLines = new BO(this._context, this._linesContent), this._viewZones = new ivt(this._context), this._viewParts.push(this._viewZones);
    const c = new Qwt(this._context);
    this._viewParts.push(c);
    const d = new Jwt(this._context);
    this._viewParts.push(d);
    const u = new Awt(this._context);
    this._viewParts.push(u), u.addDynamicOverlay(new Cwt(this._context)), u.addDynamicOverlay(new lr(this._context)), u.addDynamicOverlay(new Owt(this._context)), u.addDynamicOverlay(new _wt(this._context)), u.addDynamicOverlay(new svt(this._context));
    const f = new wwt(this._context);
    this._viewParts.push(f), f.addDynamicOverlay(new Ewt(this._context)), f.addDynamicOverlay(new Pwt(this._context)), f.addDynamicOverlay(new Bwt(this._context)), f.addDynamicOverlay(new gy(this._context)), this._glyphMarginWidgets = new Dwt(this._context), this._viewParts.push(this._glyphMarginWidgets);
    const p = new Y3(this._context);
    p.getDomNode().appendChild(this._viewZones.marginDomNode), p.getDomNode().appendChild(f.getDomNode()), p.getDomNode().appendChild(this._glyphMarginWidgets.domNode), this._viewParts.push(p), this._contentWidgets = new bwt(this._context, this.domNode), this._viewParts.push(this._contentWidgets), this._viewCursors = new u9(this._context), this._viewParts.push(this._viewCursors), this._overlayWidgets = new qwt(this._context, this.domNode), this._viewParts.push(this._overlayWidgets);
    const g = new Xwt(this._context);
    this._viewParts.push(g);
    const m = new vwt(this._context);
    this._viewParts.push(m);
    const A = new Uwt(this._context);
    if (this._viewParts.push(A), c) {
      const w = this._scrollbar.getOverviewRulerLayoutInfo();
      w.parent.insertBefore(c.getDomNode(), w.insertBefore);
    }
    this._linesContent.appendChild(u.getDomNode()), this._linesContent.appendChild(g.domNode), this._linesContent.appendChild(this._viewZones.domNode), this._linesContent.appendChild(this._viewLines.getDomNode()), this._linesContent.appendChild(this._contentWidgets.domNode), this._linesContent.appendChild(this._viewCursors.getDomNode()), this._overflowGuardContainer.appendChild(p.getDomNode()), this._overflowGuardContainer.appendChild(this._scrollbar.getDomNode()), this._overflowGuardContainer.appendChild(d.getDomNode()), this._overflowGuardContainer.appendChild(this._textAreaHandler.textArea), this._overflowGuardContainer.appendChild(this._textAreaHandler.textAreaCover), this._overflowGuardContainer.appendChild(this._overlayWidgets.getDomNode()), this._overflowGuardContainer.appendChild(A.getDomNode()), this._overflowGuardContainer.appendChild(m.domNode), this.domNode.appendChild(this._overflowGuardContainer), o ? (o.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode.domNode), o.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode.domNode)) : (this.domNode.appendChild(this._contentWidgets.overflowingContentWidgetsDomNode), this.domNode.appendChild(this._overlayWidgets.overflowingOverlayWidgetsDomNode)), this._applyLayout(), this._pointerHandler = this._register(new K3t(this._context, l, this._createPointerHandlerHelper()));
  }
  _computeGlyphMarginLanes() {
    const e = this._context.viewModel.model, t = this._context.viewModel.glyphLanes;
    let n = [], i = 0;
    n = n.concat(e.getAllMarginDecorations().map((s) => {
      const o = s.options.glyphMargin?.position ?? h1.Center;
      return i = Math.max(i, s.range.endLineNumber), { range: s.range, lane: o, persist: s.options.glyphMargin?.persistLane };
    })), n = n.concat(this._glyphMarginWidgets.getWidgets().map((s) => {
      const o = e.validateRange(s.preference.range);
      return i = Math.max(i, o.endLineNumber), { range: o, lane: s.preference.lane };
    })), n.sort((s, o) => Q.compareRangesUsingStarts(s.range, o.range)), t.reset(i);
    for (const s of n)
      t.push(s.lane, s.range, s.persist);
    return t;
  }
  _createPointerHandlerHelper() {
    return {
      viewDomNode: this.domNode.domNode,
      overflowWidgetsDomNode: this._overflowWidgetsDomNode,
      linesContentDomNode: this._linesContent.domNode,
      viewLinesDomNode: this._viewLines.getDomNode().domNode,
      focusTextArea: () => {
        this.focus();
      },
      dispatchTextAreaEvent: (e) => {
        this._textAreaHandler.textArea.domNode.dispatchEvent(e);
      },
      getLastRenderData: () => {
        const e = this._viewCursors.getLastRenderData() || [], t = this._textAreaHandler.getLastRenderData();
        return new _3t(e, t);
      },
      renderNow: () => {
        this.render(!0, !1);
      },
      shouldSuppressMouseDownOnViewZone: (e) => this._viewZones.shouldSuppressMouseDownOnViewZone(e),
      shouldSuppressMouseDownOnWidget: (e) => this._contentWidgets.shouldSuppressMouseDownOnWidget(e),
      getPositionFromDOMInfo: (e, t) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getPositionFromDOMInfo(e, t)),
      visibleRangeForPosition: (e, t) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(new le(e, t))),
      getLineWidth: (e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.getLineWidth(e))
    };
  }
  _createTextAreaHandlerHelper() {
    return {
      visibleRangeForPosition: (e) => (this._flushAccumulatedAndRenderNow(), this._viewLines.visibleRangeForPosition(e))
    };
  }
  _applyLayout() {
    const t = this._context.configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
    this.domNode.setWidth(t.width), this.domNode.setHeight(t.height), this._overflowGuardContainer.setWidth(t.width), this._overflowGuardContainer.setHeight(t.height), this._linesContent.setWidth(16777216), this._linesContent.setHeight(16777216);
  }
  _getEditorClassName() {
    const e = this._textAreaHandler.isFocused() ? " focused" : "";
    return this._context.configuration.options.get(
      143
      /* EditorOption.editorClassName */
    ) + " " + AL(this._context.theme.type) + e;
  }
  // --- begin event handlers
  handleEvents(e) {
    super.handleEvents(e), this._scheduleRender();
  }
  onConfigurationChanged(e) {
    return this.domNode.setClassName(this._getEditorClassName()), this._applyLayout(), !1;
  }
  onCursorStateChanged(e) {
    return this._selections = e.selections, !1;
  }
  onDecorationsChanged(e) {
    return e.affectsGlyphMargin && (this._shouldRecomputeGlyphMarginLanes = !0), !1;
  }
  onFocusChanged(e) {
    return this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  onThemeChanged(e) {
    return this._context.theme.update(e.theme), this.domNode.setClassName(this._getEditorClassName()), !1;
  }
  // --- end event handlers
  dispose() {
    this._renderAnimationFrame !== null && (this._renderAnimationFrame.dispose(), this._renderAnimationFrame = null), this._contentWidgets.overflowingContentWidgetsDomNode.domNode.remove(), this._context.removeEventHandler(this), this._viewLines.dispose();
    for (const e of this._viewParts)
      e.dispose();
    super.dispose();
  }
  _scheduleRender() {
    if (this._store.isDisposed)
      throw new cn();
    if (this._renderAnimationFrame === null) {
      const e = this._createCoordinatedRendering();
      this._renderAnimationFrame = FO.INSTANCE.scheduleCoordinatedRendering({
        window: qe(this.domNode.domNode),
        prepareRenderText: () => {
          if (this._store.isDisposed)
            throw new cn();
          try {
            return e.prepareRenderText();
          } finally {
            this._renderAnimationFrame = null;
          }
        },
        renderText: () => {
          if (this._store.isDisposed)
            throw new cn();
          return e.renderText();
        },
        prepareRender: (t, n) => {
          if (this._store.isDisposed)
            throw new cn();
          return e.prepareRender(t, n);
        },
        render: (t, n) => {
          if (this._store.isDisposed)
            throw new cn();
          return e.render(t, n);
        }
      });
    }
  }
  _flushAccumulatedAndRenderNow() {
    const e = this._createCoordinatedRendering();
    Vu(() => e.prepareRenderText());
    const t = Vu(() => e.renderText());
    if (t) {
      const [n, i] = t;
      Vu(() => e.prepareRender(n, i)), Vu(() => e.render(n, i));
    }
  }
  _getViewPartsToRender() {
    const e = [];
    let t = 0;
    for (const n of this._viewParts)
      n.shouldRender() && (e[t++] = n);
    return e;
  }
  _createCoordinatedRendering() {
    return {
      prepareRenderText: () => {
        if (this._shouldRecomputeGlyphMarginLanes) {
          this._shouldRecomputeGlyphMarginLanes = !1;
          const e = this._computeGlyphMarginLanes();
          this._context.configuration.setGlyphMarginDecorationLaneCount(e.requiredLanes);
        }
        Ou.onRenderStart();
      },
      renderText: () => {
        if (!this.domNode.domNode.isConnected)
          return null;
        let e = this._getViewPartsToRender();
        if (!this._viewLines.shouldRender() && e.length === 0)
          return null;
        const t = this._context.viewLayout.getLinesViewportData();
        this._context.viewModel.setViewport(t.startLineNumber, t.endLineNumber, t.centeredLineNumber);
        const n = new ovt(this._selections, t, this._context.viewLayout.getWhitespaceViewportData(), this._context.viewModel);
        return this._contentWidgets.shouldRender() && this._contentWidgets.onBeforeRender(n), this._viewLines.shouldRender() && (this._viewLines.renderText(n), this._viewLines.onDidRender(), e = this._getViewPartsToRender()), [e, new A3t(this._context.viewLayout, n, this._viewLines)];
      },
      prepareRender: (e, t) => {
        for (const n of e)
          n.prepareRender(t);
      },
      render: (e, t) => {
        for (const n of e)
          n.render(t), n.onDidRender();
      }
    };
  }
  // --- BEGIN CodeEditor helpers
  delegateVerticalScrollbarPointerDown(e) {
    this._scrollbar.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    this._scrollbar.delegateScrollFromMouseWheelEvent(e);
  }
  restoreState(e) {
    this._context.viewModel.viewLayout.setScrollPosition(
      {
        scrollTop: e.scrollTop,
        scrollLeft: e.scrollLeft
      },
      1
      /* ScrollType.Immediate */
    ), this._context.viewModel.visibleLinesStabilized();
  }
  getOffsetForColumn(e, t) {
    const n = this._context.viewModel.model.validatePosition({
      lineNumber: e,
      column: t
    }), i = this._context.viewModel.coordinatesConverter.convertModelPositionToViewPosition(n);
    this._flushAccumulatedAndRenderNow();
    const s = this._viewLines.visibleRangeForPosition(new le(i.lineNumber, i.column));
    return s ? s.left : -1;
  }
  getTargetAtClientPoint(e, t) {
    const n = this._pointerHandler.getTargetAtClientPoint(e, t);
    return n ? Ay.convertViewToModelMouseTarget(n, this._context.viewModel.coordinatesConverter) : null;
  }
  createOverviewRuler(e) {
    return new Ywt(this._context, e);
  }
  change(e) {
    this._viewZones.changeViewZones(e), this._scheduleRender();
  }
  render(e, t) {
    if (t) {
      this._viewLines.forceShouldRender();
      for (const n of this._viewParts)
        n.forceShouldRender();
    }
    e ? this._flushAccumulatedAndRenderNow() : this._scheduleRender();
  }
  writeScreenReaderContent(e) {
    this._textAreaHandler.writeScreenReaderContent(e);
  }
  focus() {
    this._textAreaHandler.focusTextArea();
  }
  isFocused() {
    return this._textAreaHandler.isFocused();
  }
  setAriaOptions(e) {
    this._textAreaHandler.setAriaOptions(e);
  }
  addContentWidget(e) {
    this._contentWidgets.addWidget(e.widget), this.layoutContentWidget(e), this._scheduleRender();
  }
  layoutContentWidget(e) {
    this._contentWidgets.setWidgetPosition(e.widget, e.position?.position ?? null, e.position?.secondaryPosition ?? null, e.position?.preference ?? null, e.position?.positionAffinity ?? null), this._scheduleRender();
  }
  removeContentWidget(e) {
    this._contentWidgets.removeWidget(e.widget), this._scheduleRender();
  }
  addOverlayWidget(e) {
    this._overlayWidgets.addWidget(e.widget), this.layoutOverlayWidget(e), this._scheduleRender();
  }
  layoutOverlayWidget(e) {
    this._overlayWidgets.setWidgetPosition(e.widget, e.position) && this._scheduleRender();
  }
  removeOverlayWidget(e) {
    this._overlayWidgets.removeWidget(e.widget), this._scheduleRender();
  }
  addGlyphMarginWidget(e) {
    this._glyphMarginWidgets.addWidget(e.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
  layoutGlyphMarginWidget(e) {
    const t = e.position;
    this._glyphMarginWidgets.setWidgetPosition(e.widget, t) && (this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender());
  }
  removeGlyphMarginWidget(e) {
    this._glyphMarginWidgets.removeWidget(e.widget), this._shouldRecomputeGlyphMarginLanes = !0, this._scheduleRender();
  }
};
CL = cvt([
  hvt(6, xn)
], CL);
function Vu(r) {
  try {
    return r();
  } catch (e) {
    return wn(e), null;
  }
}
class FO {
  static {
    this.INSTANCE = new FO();
  }
  constructor() {
    this._coordinatedRenderings = [], this._animationFrameRunners = /* @__PURE__ */ new Map();
  }
  scheduleCoordinatedRendering(e) {
    return this._coordinatedRenderings.push(e), this._scheduleRender(e.window), {
      dispose: () => {
        const t = this._coordinatedRenderings.indexOf(e);
        if (t !== -1 && (this._coordinatedRenderings.splice(t, 1), this._coordinatedRenderings.length === 0)) {
          for (const [n, i] of this._animationFrameRunners)
            i.dispose();
          this._animationFrameRunners.clear();
        }
      }
    };
  }
  _scheduleRender(e) {
    if (!this._animationFrameRunners.has(e)) {
      const t = () => {
        this._animationFrameRunners.delete(e), this._onRenderScheduled();
      };
      this._animationFrameRunners.set(e, SDe(e, t, 100));
    }
  }
  _onRenderScheduled() {
    const e = this._coordinatedRenderings.slice(0);
    this._coordinatedRenderings = [];
    for (const n of e)
      Vu(() => n.prepareRenderText());
    const t = [];
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      t[n] = Vu(() => s.renderText());
    }
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n], o = t[n];
      if (!o)
        continue;
      const [a, l] = o;
      Vu(() => s.prepareRender(a, l));
    }
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n], o = t[n];
      if (!o)
        continue;
      const [a, l] = o;
      Vu(() => s.render(a, l));
    }
  }
}
class QA {
  constructor(e, t, n, i, s) {
    this.injectionOffsets = e, this.injectionOptions = t, this.breakOffsets = n, this.breakOffsetsVisibleColumn = i, this.wrappedTextIndentLength = s;
  }
  getOutputLineCount() {
    return this.breakOffsets.length;
  }
  getMinOutputOffset(e) {
    return e > 0 ? this.wrappedTextIndentLength : 0;
  }
  getLineLength(e) {
    const t = e > 0 ? this.breakOffsets[e - 1] : 0;
    let i = this.breakOffsets[e] - t;
    return e > 0 && (i += this.wrappedTextIndentLength), i;
  }
  getMaxOutputOffset(e) {
    return this.getLineLength(e);
  }
  translateToInputOffset(e, t) {
    e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength));
    let i = e === 0 ? t : this.breakOffsets[e - 1] + t;
    if (this.injectionOffsets !== null)
      for (let s = 0; s < this.injectionOffsets.length && i > this.injectionOffsets[s]; s++)
        i < this.injectionOffsets[s] + this.injectionOptions[s].content.length ? i = this.injectionOffsets[s] : i -= this.injectionOptions[s].content.length;
    return i;
  }
  translateToOutputPosition(e, t = 2) {
    let n = e;
    if (this.injectionOffsets !== null)
      for (let i = 0; i < this.injectionOffsets.length && !(e < this.injectionOffsets[i] || t !== 1 && e === this.injectionOffsets[i]); i++)
        n += this.injectionOptions[i].content.length;
    return this.offsetInInputWithInjectionsToOutputPosition(n, t);
  }
  offsetInInputWithInjectionsToOutputPosition(e, t = 2) {
    let n = 0, i = this.breakOffsets.length - 1, s = 0, o = 0;
    for (; n <= i; ) {
      s = n + (i - n) / 2 | 0;
      const l = this.breakOffsets[s];
      if (o = s > 0 ? this.breakOffsets[s - 1] : 0, t === 0)
        if (e <= o)
          i = s - 1;
        else if (e > l)
          n = s + 1;
        else
          break;
      else if (e < o)
        i = s - 1;
      else if (e >= l)
        n = s + 1;
      else
        break;
    }
    let a = e - o;
    return s > 0 && (a += this.wrappedTextIndentLength), new Hv(s, a);
  }
  normalizeOutputPosition(e, t, n) {
    if (this.injectionOffsets !== null) {
      const i = this.outputPositionToOffsetInInputWithInjections(e, t), s = this.normalizeOffsetInInputWithInjectionsAroundInjections(i, n);
      if (s !== i)
        return this.offsetInInputWithInjectionsToOutputPosition(s, n);
    }
    if (n === 0) {
      if (e > 0 && t === this.getMinOutputOffset(e))
        return new Hv(e - 1, this.getMaxOutputOffset(e - 1));
    } else if (n === 1) {
      const i = this.getOutputLineCount() - 1;
      if (e < i && t === this.getMaxOutputOffset(e))
        return new Hv(e + 1, this.getMinOutputOffset(e + 1));
    }
    return new Hv(e, t);
  }
  outputPositionToOffsetInInputWithInjections(e, t) {
    return e > 0 && (t = Math.max(0, t - this.wrappedTextIndentLength)), (e > 0 ? this.breakOffsets[e - 1] : 0) + t;
  }
  normalizeOffsetInInputWithInjectionsAroundInjections(e, t) {
    const n = this.getInjectedTextAtOffset(e);
    if (!n)
      return e;
    if (t === 2) {
      if (e === n.offsetInInputWithInjections + n.length && R6e(this.injectionOptions[n.injectedTextIndex].cursorStops))
        return n.offsetInInputWithInjections + n.length;
      {
        let i = n.offsetInInputWithInjections;
        if (V6e(this.injectionOptions[n.injectedTextIndex].cursorStops))
          return i;
        let s = n.injectedTextIndex - 1;
        for (; s >= 0 && this.injectionOffsets[s] === this.injectionOffsets[n.injectedTextIndex] && !(R6e(this.injectionOptions[s].cursorStops) || (i -= this.injectionOptions[s].content.length, V6e(this.injectionOptions[s].cursorStops))); )
          s--;
        return i;
      }
    } else if (t === 1 || t === 4) {
      let i = n.offsetInInputWithInjections + n.length, s = n.injectedTextIndex;
      for (; s + 1 < this.injectionOffsets.length && this.injectionOffsets[s + 1] === this.injectionOffsets[s]; )
        i += this.injectionOptions[s + 1].content.length, s++;
      return i;
    } else if (t === 0 || t === 3) {
      let i = n.offsetInInputWithInjections, s = n.injectedTextIndex;
      for (; s - 1 >= 0 && this.injectionOffsets[s - 1] === this.injectionOffsets[s]; )
        i -= this.injectionOptions[s - 1].content.length, s--;
      return i;
    }
    $I();
  }
  getInjectedText(e, t) {
    const n = this.outputPositionToOffsetInInputWithInjections(e, t), i = this.getInjectedTextAtOffset(n);
    return i ? {
      options: this.injectionOptions[i.injectedTextIndex]
    } : null;
  }
  getInjectedTextAtOffset(e) {
    const t = this.injectionOffsets, n = this.injectionOptions;
    if (t !== null) {
      let i = 0;
      for (let s = 0; s < t.length; s++) {
        const o = n[s].content.length, a = t[s] + i, l = t[s] + i + o;
        if (a > e)
          break;
        if (e <= l)
          return {
            injectedTextIndex: s,
            offsetInInputWithInjections: a,
            length: o
          };
        i += o;
      }
    }
  }
}
function R6e(r) {
  return r == null ? !0 : r === cg.Right || r === cg.Both;
}
function V6e(r) {
  return r == null ? !0 : r === cg.Left || r === cg.Both;
}
class Hv {
  constructor(e, t) {
    this.outputLineIndex = e, this.outputOffset = t;
  }
  toString() {
    return `${this.outputLineIndex}:${this.outputOffset}`;
  }
  toPosition(e) {
    return new le(e + this.outputLineIndex, this.outputOffset + 1);
  }
}
class dvt {
  constructor() {
    this.changeType = 1;
  }
}
class sc {
  static applyInjectedText(e, t) {
    if (!t || t.length === 0)
      return e;
    let n = "", i = 0;
    for (const s of t)
      n += e.substring(i, s.column - 1), i = s.column - 1, n += s.options.content;
    return n += e.substring(i), n;
  }
  static fromDecorations(e) {
    const t = [];
    for (const n of e)
      n.options.before && n.options.before.content.length > 0 && t.push(new sc(n.ownerId, n.range.startLineNumber, n.range.startColumn, n.options.before, 0)), n.options.after && n.options.after.content.length > 0 && t.push(new sc(n.ownerId, n.range.endLineNumber, n.range.endColumn, n.options.after, 1));
    return t.sort((n, i) => n.lineNumber === i.lineNumber ? n.column === i.column ? n.order - i.order : n.column - i.column : n.lineNumber - i.lineNumber), t;
  }
  constructor(e, t, n, i, s) {
    this.ownerId = e, this.lineNumber = t, this.column = n, this.options = i, this.order = s;
  }
}
class H6e {
  constructor(e, t, n) {
    this.changeType = 2, this.lineNumber = e, this.detail = t, this.injectedText = n;
  }
}
class uvt {
  constructor(e, t) {
    this.changeType = 3, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class fvt {
  constructor(e, t, n, i) {
    this.changeType = 4, this.injectedTexts = i, this.fromLineNumber = e, this.toLineNumber = t, this.detail = n;
  }
}
class pvt {
  constructor() {
    this.changeType = 5;
  }
}
class Sp {
  constructor(e, t, n, i) {
    this.changes = e, this.versionId = t, this.isUndoing = n, this.isRedoing = i, this.resultingSelection = null;
  }
  containsEvent(e) {
    for (let t = 0, n = this.changes.length; t < n; t++)
      if (this.changes[t].changeType === e)
        return !0;
    return !1;
  }
  static merge(e, t) {
    const n = [].concat(e.changes).concat(t.changes), i = t.versionId, s = e.isUndoing || t.isUndoing, o = e.isRedoing || t.isRedoing;
    return new Sp(n, i, s, o);
  }
}
class Eke {
  constructor(e) {
    this.changes = e;
  }
}
class K0 {
  constructor(e, t) {
    this.rawContentChangedEvent = e, this.contentChangedEvent = t;
  }
  merge(e) {
    const t = Sp.merge(this.rawContentChangedEvent, e.rawContentChangedEvent), n = K0._mergeChangeEvents(this.contentChangedEvent, e.contentChangedEvent);
    return new K0(t, n);
  }
  static _mergeChangeEvents(e, t) {
    const n = [].concat(e.changes).concat(t.changes), i = t.eol, s = t.versionId, o = e.isUndoing || t.isUndoing, a = e.isRedoing || t.isRedoing, l = e.isFlush || t.isFlush, c = e.isEolChange && t.isEolChange;
    return {
      changes: n,
      eol: i,
      isEolChange: c,
      versionId: s,
      isUndoing: o,
      isRedoing: a,
      isFlush: l
    };
  }
}
const gvt = Jf("domLineBreaksComputer", { createHTML: (r) => r });
class zO {
  static create(e) {
    return new zO(new WeakRef(e));
  }
  constructor(e) {
    this.targetWindow = e;
  }
  createLineBreaksComputer(e, t, n, i, s) {
    const o = [], a = [];
    return {
      addRequest: (l, c, d) => {
        o.push(l), a.push(c);
      },
      finalize: () => mvt(E8(this.targetWindow.deref()), o, e, t, n, i, s, a)
    };
  }
}
function mvt(r, e, t, n, i, s, o, a) {
  function l(T) {
    const B = a[T];
    if (B) {
      const V = sc.applyInjectedText(e[T], B), N = B.map((H) => H.options), R = B.map((H) => H.column - 1);
      return new QA(R, N, [V.length], [], 0);
    } else
      return null;
  }
  if (i === -1) {
    const T = [];
    for (let B = 0, V = e.length; B < V; B++)
      T[B] = l(B);
    return T;
  }
  const c = Math.round(i * t.typicalHalfwidthCharacterWidth), u = Math.round(n * (s === 3 ? 2 : s === 2 ? 1 : 0)), f = Math.ceil(t.spaceWidth * u), p = document.createElement("div");
  Br(p, t);
  const g = new J7(1e4), m = [], A = [], w = [], v = [], y = [];
  for (let T = 0; T < e.length; T++) {
    const B = sc.applyInjectedText(e[T], a[T]);
    let V = 0, N = 0, R = c;
    if (s !== 0)
      if (V = so(B), V === -1)
        V = 0;
      else {
        for (let ee = 0; ee < V; ee++) {
          const ce = B.charCodeAt(ee) === 9 ? n - N % n : 1;
          N += ce;
        }
        const U = Math.ceil(t.spaceWidth * N);
        U + t.typicalFullwidthCharacterWidth > c ? (V = 0, N = 0) : R = c - U;
      }
    const H = B.substr(V), z = Avt(H, N, n, R, g, f);
    m[T] = V, A[T] = N, w[T] = H, v[T] = z[0], y[T] = z[1];
  }
  const _ = g.build(), S = gvt?.createHTML(_) ?? _;
  p.innerHTML = S, p.style.position = "absolute", p.style.top = "10000", o === "keepAll" ? (p.style.wordBreak = "keep-all", p.style.overflowWrap = "anywhere") : (p.style.wordBreak = "inherit", p.style.overflowWrap = "break-word"), r.document.body.appendChild(p);
  const D = document.createRange(), M = Array.prototype.slice.call(p.children, 0), L = [];
  for (let T = 0; T < e.length; T++) {
    const B = M[T], V = wvt(D, B, w[T], v[T]);
    if (V === null) {
      L[T] = l(T);
      continue;
    }
    const N = m[T], R = A[T] + u, H = y[T], z = [];
    for (let se = 0, te = V.length; se < te; se++)
      z[se] = H[V[se]];
    if (N !== 0)
      for (let se = 0, te = V.length; se < te; se++)
        V[se] += N;
    let U, ee;
    const ce = a[T];
    ce ? (U = ce.map((se) => se.options), ee = ce.map((se) => se.column - 1)) : (U = null, ee = null), L[T] = new QA(ee, U, V, z, R);
  }
  return p.remove(), L;
}
function Avt(r, e, t, n, i, s) {
  if (s !== 0) {
    const f = String(s);
    i.appendString('<div style="text-indent: -'), i.appendString(f), i.appendString("px; padding-left: "), i.appendString(f), i.appendString("px; box-sizing: border-box; width:");
  } else
    i.appendString('<div style="width:');
  i.appendString(String(n)), i.appendString('px;">');
  const o = r.length;
  let a = e, l = 0;
  const c = [], d = [];
  let u = 0 < o ? r.charCodeAt(0) : 0;
  i.appendString("<span>");
  for (let f = 0; f < o; f++) {
    f !== 0 && f % 16384 === 0 && i.appendString("</span><span>"), c[f] = l, d[f] = a;
    const p = u;
    u = f + 1 < o ? r.charCodeAt(f + 1) : 0;
    let g = 1, m = 1;
    switch (p) {
      case 9:
        g = t - a % t, m = g;
        for (let A = 1; A <= g; A++)
          A < g ? i.appendCharCode(160) : i.appendASCIICharCode(
            32
            /* CharCode.Space */
          );
        break;
      case 32:
        u === 32 ? i.appendCharCode(160) : i.appendASCIICharCode(
          32
          /* CharCode.Space */
        );
        break;
      case 60:
        i.appendString("&lt;");
        break;
      case 62:
        i.appendString("&gt;");
        break;
      case 38:
        i.appendString("&amp;");
        break;
      case 0:
        i.appendString("&#00;");
        break;
      case 65279:
      case 8232:
      case 8233:
      case 133:
        i.appendCharCode(65533);
        break;
      default:
        a1(p) && m++, p < 32 ? i.appendCharCode(9216 + p) : i.appendCharCode(p);
    }
    l += g, a += m;
  }
  return i.appendString("</span>"), c[r.length] = l, d[r.length] = a, i.appendString("</div>"), [c, d];
}
function wvt(r, e, t, n) {
  if (t.length <= 1)
    return null;
  const i = Array.prototype.slice.call(e.children, 0), s = [];
  try {
    EL(r, i, n, 0, null, t.length - 1, null, s);
  } catch (o) {
    return console.log(o), null;
  }
  return s.length === 0 ? null : (s.push(t.length), s);
}
function EL(r, e, t, n, i, s, o, a) {
  if (n === s || (i = i || JE(r, e, t[n], t[n + 1]), o = o || JE(r, e, t[s], t[s + 1]), Math.abs(i[0].top - o[0].top) <= 0.1))
    return;
  if (n + 1 === s) {
    a.push(s);
    return;
  }
  const l = n + (s - n) / 2 | 0, c = JE(r, e, t[l], t[l + 1]);
  EL(r, e, t, n, i, l, c, a), EL(r, e, t, l, c, s, o, a);
}
function JE(r, e, t, n) {
  return r.setStart(
    e[t / 16384 | 0].firstChild,
    t % 16384
    /* Constants.SPAN_MODULO_LIMIT */
  ), r.setEnd(
    e[n / 16384 | 0].firstChild,
    n % 16384
    /* Constants.SPAN_MODULO_LIMIT */
  ), r.getClientRects();
}
class vvt extends me {
  constructor() {
    super(), this._editor = null, this._instantiationService = null, this._instances = this._register(new MI()), this._pending = /* @__PURE__ */ new Map(), this._finishedInstantiation = [], this._finishedInstantiation[
      0
      /* EditorContributionInstantiation.Eager */
    ] = !1, this._finishedInstantiation[
      1
      /* EditorContributionInstantiation.AfterFirstRender */
    ] = !1, this._finishedInstantiation[
      2
      /* EditorContributionInstantiation.BeforeFirstInteraction */
    ] = !1, this._finishedInstantiation[
      3
      /* EditorContributionInstantiation.Eventually */
    ] = !1;
  }
  initialize(e, t, n) {
    this._editor = e, this._instantiationService = n;
    for (const i of t) {
      if (this._pending.has(i.id)) {
        wn(new Error(`Cannot have two contributions with the same id ${i.id}`));
        continue;
      }
      this._pending.set(i.id, i);
    }
    this._instantiateSome(
      0
      /* EditorContributionInstantiation.Eager */
    ), this._register(Lv(qe(this._editor.getDomNode()), () => {
      this._instantiateSome(
        1
        /* EditorContributionInstantiation.AfterFirstRender */
      );
    })), this._register(Lv(qe(this._editor.getDomNode()), () => {
      this._instantiateSome(
        2
        /* EditorContributionInstantiation.BeforeFirstInteraction */
      );
    })), this._register(Lv(qe(this._editor.getDomNode()), () => {
      this._instantiateSome(
        3
        /* EditorContributionInstantiation.Eventually */
      );
    }, 5e3));
  }
  saveViewState() {
    const e = {};
    for (const [t, n] of this._instances)
      typeof n.saveViewState == "function" && (e[t] = n.saveViewState());
    return e;
  }
  restoreViewState(e) {
    for (const [t, n] of this._instances)
      typeof n.restoreViewState == "function" && n.restoreViewState(e[t]);
  }
  get(e) {
    return this._instantiateById(e), this._instances.get(e) || null;
  }
  onBeforeInteractionEvent() {
    this._instantiateSome(
      2
      /* EditorContributionInstantiation.BeforeFirstInteraction */
    );
  }
  onAfterModelAttached() {
    return Lv(qe(this._editor?.getDomNode()), () => {
      this._instantiateSome(
        1
        /* EditorContributionInstantiation.AfterFirstRender */
      );
    }, 50);
  }
  _instantiateSome(e) {
    if (this._finishedInstantiation[e])
      return;
    this._finishedInstantiation[e] = !0;
    const t = this._findPendingContributionsByInstantiation(e);
    for (const n of t)
      this._instantiateById(n.id);
  }
  _findPendingContributionsByInstantiation(e) {
    const t = [];
    for (const [, n] of this._pending)
      n.instantiation === e && t.push(n);
    return t;
  }
  _instantiateById(e) {
    const t = this._pending.get(e);
    if (t) {
      if (this._pending.delete(e), !this._instantiationService || !this._editor)
        throw new Error("Cannot instantiate contributions before being initialized!");
      try {
        const n = this._instantiationService.createInstance(t.ctor, this._editor);
        this._instances.set(t.id, n), typeof n.restoreViewState == "function" && t.instantiation !== 0 && console.warn(`Editor contribution '${t.id}' should be eager instantiated because it uses saveViewState / restoreViewState.`);
      } catch (n) {
        wn(n);
      }
    }
  }
}
class _ke {
  constructor(e, t, n, i, s, o, a) {
    this.id = e, this.label = t, this.alias = n, this.metadata = i, this._precondition = s, this._run = o, this._contextKeyService = a;
  }
  isSupported() {
    return this._contextKeyService.contextMatchesRules(this._precondition);
  }
  run(e) {
    return this.isSupported() ? this._run(e) : Promise.resolve(void 0);
  }
}
function mg(r) {
  let e = 0, t = 0, n = 0, i = 0;
  for (let s = 0, o = r.length; s < o; s++) {
    const a = r.charCodeAt(s);
    a === 13 ? (e === 0 && (t = s), e++, s + 1 < o && r.charCodeAt(s + 1) === 10 ? (i |= 2, s++) : i |= 3, n = s + 1) : a === 10 && (i |= 1, e === 0 && (t = s), e++, n = s + 1);
  }
  return e === 0 && (t = r.length), [e, t, r.length - n, i];
}
class B6e {
  constructor(e, t, n, i) {
    this.range = e, this.nestingLevel = t, this.nestingLevelOfEqualBracketType = n, this.isInvalid = i;
  }
}
class bvt {
  constructor(e, t, n, i, s, o) {
    this.range = e, this.openingBracketRange = t, this.closingBracketRange = n, this.nestingLevel = i, this.nestingLevelOfEqualBracketType = s, this.bracketPairNode = o;
  }
  get openingBracketInfo() {
    return this.bracketPairNode.openingBracket.bracketInfo;
  }
}
class yvt extends bvt {
  constructor(e, t, n, i, s, o, a) {
    super(e, t, n, i, s, o), this.minVisibleColumnIndentation = a;
  }
}
function Cvt(r, e, t, n) {
  return r !== t ? yi(t - r, n) : yi(0, n - e);
}
const Bs = 0;
function f9(r) {
  return r === 0;
}
const Io = 2 ** 26;
function yi(r, e) {
  return r * Io + e;
}
function ma(r) {
  const e = r, t = Math.floor(e / Io), n = e - t * Io;
  return new Xa(t, n);
}
function Evt(r) {
  return Math.floor(r / Io);
}
function Ti(r, e) {
  let t = r + e;
  return e >= Io && (t = t - r % Io), t;
}
function _vt(r, e) {
  return r.reduce((t, n) => Ti(t, e(n)), Bs);
}
function xke(r, e) {
  return r === e;
}
function $3(r, e) {
  const t = r, n = e;
  if (n - t <= 0)
    return Bs;
  const s = Math.floor(t / Io), o = Math.floor(n / Io), a = n - o * Io;
  if (s === o) {
    const l = t - s * Io;
    return yi(0, a - l);
  } else
    return yi(o - s, a);
}
function Mp(r, e) {
  return r < e;
}
function Dp(r, e) {
  return r <= e;
}
function mA(r, e) {
  return r >= e;
}
function rp(r) {
  return yi(r.lineNumber - 1, r.column - 1);
}
function Y0(r, e) {
  const t = r, n = Math.floor(t / Io), i = t - n * Io, s = e, o = Math.floor(s / Io), a = s - o * Io;
  return new Q(n + 1, i + 1, o + 1, a + 1);
}
function xvt(r) {
  const e = $g(r);
  return yi(e.length - 1, e[e.length - 1].length);
}
class pd {
  static fromModelContentChanges(e) {
    return e.map((n) => {
      const i = Q.lift(n.range);
      return new pd(rp(i.getStartPosition()), rp(i.getEndPosition()), xvt(n.text));
    }).reverse();
  }
  constructor(e, t, n) {
    this.startOffset = e, this.endOffset = t, this.newLength = n;
  }
  toString() {
    return `[${ma(this.startOffset)}...${ma(this.endOffset)}) -> ${ma(this.newLength)}`;
  }
}
class Svt {
  /**
   * @param edits Must be sorted by offset in ascending order.
  */
  constructor(e) {
    this.nextEditIdx = 0, this.deltaOldToNewLineCount = 0, this.deltaOldToNewColumnCount = 0, this.deltaLineIdxInOld = -1, this.edits = e.map((t) => WO.from(t));
  }
  /**
   * @param offset Must be equal to or greater than the last offset this method has been called with.
  */
  getOffsetBeforeChange(e) {
    return this.adjustNextEdit(e), this.translateCurToOld(e);
  }
  /**
   * @param offset Must be equal to or greater than the last offset this method has been called with.
   * Returns null if there is no edit anymore.
  */
  getDistanceToNextChange(e) {
    this.adjustNextEdit(e);
    const t = this.edits[this.nextEditIdx], n = t ? this.translateOldToCur(t.offsetObj) : null;
    return n === null ? null : $3(e, n);
  }
  translateOldToCur(e) {
    return e.lineCount === this.deltaLineIdxInOld ? yi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount + this.deltaOldToNewColumnCount) : yi(e.lineCount + this.deltaOldToNewLineCount, e.columnCount);
  }
  translateCurToOld(e) {
    const t = ma(e);
    return t.lineCount - this.deltaOldToNewLineCount === this.deltaLineIdxInOld ? yi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount - this.deltaOldToNewColumnCount) : yi(t.lineCount - this.deltaOldToNewLineCount, t.columnCount);
  }
  adjustNextEdit(e) {
    for (; this.nextEditIdx < this.edits.length; ) {
      const t = this.edits[this.nextEditIdx], n = this.translateOldToCur(t.endOffsetAfterObj);
      if (Dp(n, e)) {
        this.nextEditIdx++;
        const i = ma(n), s = ma(this.translateOldToCur(t.endOffsetBeforeObj)), o = i.lineCount - s.lineCount;
        this.deltaOldToNewLineCount += o;
        const a = this.deltaLineIdxInOld === t.endOffsetBeforeObj.lineCount ? this.deltaOldToNewColumnCount : 0, l = i.columnCount - s.columnCount;
        this.deltaOldToNewColumnCount = a + l, this.deltaLineIdxInOld = t.endOffsetBeforeObj.lineCount;
      } else
        break;
    }
  }
}
class WO {
  static from(e) {
    return new WO(e.startOffset, e.endOffset, e.newLength);
  }
  constructor(e, t, n) {
    this.endOffsetBeforeObj = ma(t), this.endOffsetAfterObj = ma(Ti(e, n)), this.offsetObj = ma(e);
  }
}
const Bv = [];
class Pi {
  static {
    this.cache = new Array(129);
  }
  static create(e, t) {
    if (e <= 128 && t.length === 0) {
      let n = Pi.cache[e];
      return n || (n = new Pi(e, t), Pi.cache[e] = n), n;
    }
    return new Pi(e, t);
  }
  static {
    this.empty = Pi.create(0, Bv);
  }
  static getEmpty() {
    return this.empty;
  }
  constructor(e, t) {
    this.items = e, this.additionalItems = t;
  }
  add(e, t) {
    const n = t.getKey(e);
    let i = n >> 5;
    if (i === 0) {
      const o = 1 << n | this.items;
      return o === this.items ? this : Pi.create(o, this.additionalItems);
    }
    i--;
    const s = this.additionalItems.slice(0);
    for (; s.length < i; )
      s.push(0);
    return s[i] |= 1 << (n & 31), Pi.create(this.items, s);
  }
  merge(e) {
    const t = this.items | e.items;
    if (this.additionalItems === Bv && e.additionalItems === Bv)
      return t === this.items ? this : t === e.items ? e : Pi.create(t, Bv);
    const n = [];
    for (let i = 0; i < Math.max(this.additionalItems.length, e.additionalItems.length); i++) {
      const s = this.additionalItems[i] || 0, o = e.additionalItems[i] || 0;
      n.push(s | o);
    }
    return Pi.create(t, n);
  }
  intersects(e) {
    if ((this.items & e.items) !== 0)
      return !0;
    for (let t = 0; t < Math.min(this.additionalItems.length, e.additionalItems.length); t++)
      if ((this.additionalItems[t] & e.additionalItems[t]) !== 0)
        return !0;
    return !1;
  }
}
const P6e = {
  getKey(r) {
    return r;
  }
};
class Mvt {
  constructor() {
    this.items = /* @__PURE__ */ new Map();
  }
  getKey(e) {
    let t = this.items.get(e);
    return t === void 0 && (t = this.items.size, this.items.set(e, t)), t;
  }
}
class jO {
  /**
   * The length of the entire node, which should equal the sum of lengths of all children.
  */
  get length() {
    return this._length;
  }
  constructor(e) {
    this._length = e;
  }
}
class e4 extends jO {
  static create(e, t, n) {
    let i = e.length;
    return t && (i = Ti(i, t.length)), n && (i = Ti(i, n.length)), new e4(i, e, t, n, t ? t.missingOpeningBracketIds : Pi.getEmpty());
  }
  get kind() {
    return 2;
  }
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 3;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this.openingBracket;
      case 1:
        return this.child;
      case 2:
        return this.closingBracket;
    }
    throw new Error("Invalid child index");
  }
  /**
   * Avoid using this property, it allocates an array!
  */
  get children() {
    const e = [];
    return e.push(this.openingBracket), this.child && e.push(this.child), this.closingBracket && e.push(this.closingBracket), e;
  }
  constructor(e, t, n, i, s) {
    super(e), this.openingBracket = t, this.child = n, this.closingBracket = i, this.missingOpeningBracketIds = s;
  }
  canBeReused(e) {
    return !(this.closingBracket === null || e.intersects(this.missingOpeningBracketIds));
  }
  deepClone() {
    return new e4(this.length, this.openingBracket.deepClone(), this.child && this.child.deepClone(), this.closingBracket && this.closingBracket.deepClone(), this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return this.child ? this.child.computeMinIndentation(Ti(e, this.openingBracket.length), t) : Number.MAX_SAFE_INTEGER;
  }
}
class uh extends jO {
  /**
   * This method uses more memory-efficient list nodes that can only store 2 or 3 children.
  */
  static create23(e, t, n, i = !1) {
    let s = e.length, o = e.missingOpeningBracketIds;
    if (e.listHeight !== t.listHeight)
      throw new Error("Invalid list heights");
    if (s = Ti(s, t.length), o = o.merge(t.missingOpeningBracketIds), n) {
      if (e.listHeight !== n.listHeight)
        throw new Error("Invalid list heights");
      s = Ti(s, n.length), o = o.merge(n.missingOpeningBracketIds);
    }
    return i ? new Dvt(s, e.listHeight + 1, e, t, n, o) : new t4(s, e.listHeight + 1, e, t, n, o);
  }
  static getEmpty() {
    return new Lvt(Bs, 0, [], Pi.getEmpty());
  }
  get kind() {
    return 4;
  }
  get missingOpeningBracketIds() {
    return this._missingOpeningBracketIds;
  }
  /**
   * Use ListAstNode.create.
  */
  constructor(e, t, n) {
    super(e), this.listHeight = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  throwIfImmutable() {
  }
  makeLastElementMutable() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    if (e === 0)
      return;
    const t = this.getChild(e - 1), n = t.kind === 4 ? t.toMutable() : t;
    return t !== n && this.setChild(e - 1, n), n;
  }
  makeFirstElementMutable() {
    if (this.throwIfImmutable(), this.childrenLength === 0)
      return;
    const t = this.getChild(0), n = t.kind === 4 ? t.toMutable() : t;
    return t !== n && this.setChild(0, n), n;
  }
  canBeReused(e) {
    if (e.intersects(this.missingOpeningBracketIds) || this.childrenLength === 0)
      return !1;
    let t = this;
    for (; t.kind === 4; ) {
      const n = t.childrenLength;
      if (n === 0)
        throw new cn();
      t = t.getChild(n - 1);
    }
    return t.canBeReused(e);
  }
  handleChildrenChanged() {
    this.throwIfImmutable();
    const e = this.childrenLength;
    let t = this.getChild(0).length, n = this.getChild(0).missingOpeningBracketIds;
    for (let i = 1; i < e; i++) {
      const s = this.getChild(i);
      t = Ti(t, s.length), n = n.merge(s.missingOpeningBracketIds);
    }
    this._length = t, this._missingOpeningBracketIds = n, this.cachedMinIndentation = -1;
  }
  computeMinIndentation(e, t) {
    if (this.cachedMinIndentation !== -1)
      return this.cachedMinIndentation;
    let n = Number.MAX_SAFE_INTEGER, i = e;
    for (let s = 0; s < this.childrenLength; s++) {
      const o = this.getChild(s);
      o && (n = Math.min(n, o.computeMinIndentation(i, t)), i = Ti(i, o.length));
    }
    return this.cachedMinIndentation = n, n;
  }
}
class t4 extends uh {
  get childrenLength() {
    return this._item3 !== null ? 3 : 2;
  }
  getChild(e) {
    switch (e) {
      case 0:
        return this._item1;
      case 1:
        return this._item2;
      case 2:
        return this._item3;
    }
    throw new Error("Invalid child index");
  }
  setChild(e, t) {
    switch (e) {
      case 0:
        this._item1 = t;
        return;
      case 1:
        this._item2 = t;
        return;
      case 2:
        this._item3 = t;
        return;
    }
    throw new Error("Invalid child index");
  }
  get children() {
    return this._item3 ? [this._item1, this._item2, this._item3] : [this._item1, this._item2];
  }
  get item1() {
    return this._item1;
  }
  get item2() {
    return this._item2;
  }
  get item3() {
    return this._item3;
  }
  constructor(e, t, n, i, s, o) {
    super(e, t, o), this._item1 = n, this._item2 = i, this._item3 = s;
  }
  deepClone() {
    return new t4(this.length, this.listHeight, this._item1.deepClone(), this._item2.deepClone(), this._item3 ? this._item3.deepClone() : null, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    if (this._item3)
      throw new Error("Cannot append to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = e, this.handleChildrenChanged();
  }
  unappendChild() {
    if (!this._item3)
      throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item3;
    return this._item3 = null, this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    if (this._item3)
      throw new Error("Cannot prepend to a full (2,3) tree node");
    this.throwIfImmutable(), this._item3 = this._item2, this._item2 = this._item1, this._item1 = e, this.handleChildrenChanged();
  }
  unprependChild() {
    if (!this._item3)
      throw new Error("Cannot remove from a non-full (2,3) tree node");
    this.throwIfImmutable();
    const e = this._item1;
    return this._item1 = this._item2, this._item2 = this._item3, this._item3 = null, this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class Dvt extends t4 {
  toMutable() {
    return new t4(this.length, this.listHeight, this.item1, this.item2, this.item3, this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
class p9 extends uh {
  get childrenLength() {
    return this._children.length;
  }
  getChild(e) {
    return this._children[e];
  }
  setChild(e, t) {
    this._children[e] = t;
  }
  get children() {
    return this._children;
  }
  constructor(e, t, n, i) {
    super(e, t, i), this._children = n;
  }
  deepClone() {
    const e = new Array(this._children.length);
    for (let t = 0; t < this._children.length; t++)
      e[t] = this._children[t].deepClone();
    return new p9(this.length, this.listHeight, e, this.missingOpeningBracketIds);
  }
  appendChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.push(e), this.handleChildrenChanged();
  }
  unappendChild() {
    this.throwIfImmutable();
    const e = this._children.pop();
    return this.handleChildrenChanged(), e;
  }
  prependChildOfSameHeight(e) {
    this.throwIfImmutable(), this._children.unshift(e), this.handleChildrenChanged();
  }
  unprependChild() {
    this.throwIfImmutable();
    const e = this._children.shift();
    return this.handleChildrenChanged(), e;
  }
  toMutable() {
    return this;
  }
}
class Lvt extends p9 {
  toMutable() {
    return new p9(this.length, this.listHeight, [...this.children], this.missingOpeningBracketIds);
  }
  throwIfImmutable() {
    throw new Error("this instance is immutable");
  }
}
const kvt = [];
class ZO extends jO {
  get listHeight() {
    return 0;
  }
  get childrenLength() {
    return 0;
  }
  getChild(e) {
    return null;
  }
  get children() {
    return kvt;
  }
  deepClone() {
    return this;
  }
}
class C0 extends ZO {
  get kind() {
    return 0;
  }
  get missingOpeningBracketIds() {
    return Pi.getEmpty();
  }
  canBeReused(e) {
    return !0;
  }
  computeMinIndentation(e, t) {
    const n = ma(e), i = (n.columnCount === 0 ? n.lineCount : n.lineCount + 1) + 1, s = Evt(Ti(e, this.length)) + 1;
    let o = Number.MAX_SAFE_INTEGER;
    for (let a = i; a <= s; a++) {
      const l = t.getLineFirstNonWhitespaceColumn(a), c = t.getLineContent(a);
      if (l === 0)
        continue;
      const d = zi.visibleColumnFromColumn(c, l, t.getOptions().tabSize);
      o = Math.min(o, d);
    }
    return o;
  }
}
class g9 extends ZO {
  static create(e, t, n) {
    return new g9(e, t, n);
  }
  get kind() {
    return 1;
  }
  get missingOpeningBracketIds() {
    return Pi.getEmpty();
  }
  constructor(e, t, n) {
    super(e), this.bracketInfo = t, this.bracketIds = n;
  }
  get text() {
    return this.bracketInfo.bracketText;
  }
  get languageId() {
    return this.bracketInfo.languageId;
  }
  canBeReused(e) {
    return !1;
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
class Nvt extends ZO {
  get kind() {
    return 3;
  }
  constructor(e, t) {
    super(t), this.missingOpeningBracketIds = e;
  }
  canBeReused(e) {
    return !e.intersects(this.missingOpeningBracketIds);
  }
  computeMinIndentation(e, t) {
    return Number.MAX_SAFE_INTEGER;
  }
}
let Su = class {
  constructor(e, t, n, i, s) {
    this.length = e, this.kind = t, this.bracketId = n, this.bracketIds = i, this.astNode = s;
  }
};
class Tvt {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.reader = new Ivt(this.textModel, this.bracketTokens), this._offset = Bs, this.didPeek = !1, this.peeked = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  get offset() {
    return this._offset;
  }
  get length() {
    return yi(this.textBufferLineCount - 1, this.textBufferLastLineLength);
  }
  skip(e) {
    this.didPeek = !1, this._offset = Ti(this._offset, e);
    const t = ma(this._offset);
    this.reader.setPosition(t.lineCount, t.columnCount);
  }
  read() {
    let e;
    return this.peeked ? (this.didPeek = !1, e = this.peeked) : e = this.reader.read(), e && (this._offset = Ti(this._offset, e.length)), e;
  }
  peek() {
    return this.didPeek || (this.peeked = this.reader.read(), this.didPeek = !0), this.peeked;
  }
}
class Ivt {
  constructor(e, t) {
    this.textModel = e, this.bracketTokens = t, this.lineIdx = 0, this.line = null, this.lineCharOffset = 0, this.lineTokens = null, this.lineTokenOffset = 0, this.peekedToken = null, this.textBufferLineCount = e.getLineCount(), this.textBufferLastLineLength = e.getLineLength(this.textBufferLineCount);
  }
  setPosition(e, t) {
    e === this.lineIdx ? (this.lineCharOffset = t, this.line !== null && (this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset))) : (this.lineIdx = e, this.lineCharOffset = t, this.line = null), this.peekedToken = null;
  }
  read() {
    if (this.peekedToken) {
      const s = this.peekedToken;
      return this.peekedToken = null, this.lineCharOffset += s.length, s;
    }
    if (this.lineIdx > this.textBufferLineCount - 1 || this.lineIdx === this.textBufferLineCount - 1 && this.lineCharOffset >= this.textBufferLastLineLength)
      return null;
    this.line === null && (this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.line = this.lineTokens.getLineContent(), this.lineTokenOffset = this.lineCharOffset === 0 ? 0 : this.lineTokens.findTokenIndexAtOffset(this.lineCharOffset));
    const e = this.lineIdx, t = this.lineCharOffset;
    let n = 0;
    for (; ; ) {
      const s = this.lineTokens, o = s.getCount();
      let a = null;
      if (this.lineTokenOffset < o) {
        const l = s.getMetadata(this.lineTokenOffset);
        for (; this.lineTokenOffset + 1 < o && l === s.getMetadata(this.lineTokenOffset + 1); )
          this.lineTokenOffset++;
        const c = Vl.getTokenType(l) === 0, d = Vl.containsBalancedBrackets(l), u = s.getEndOffset(this.lineTokenOffset);
        if (d && c && this.lineCharOffset < u) {
          const f = s.getLanguageId(this.lineTokenOffset), p = this.line.substring(this.lineCharOffset, u), g = this.bracketTokens.getSingleLanguageBracketTokens(f), m = g.regExpGlobal;
          if (m) {
            m.lastIndex = 0;
            const A = m.exec(p);
            A && (a = g.getToken(A[0]), a && (this.lineCharOffset += A.index));
          }
        }
        if (n += u - this.lineCharOffset, a)
          if (e !== this.lineIdx || t !== this.lineCharOffset) {
            this.peekedToken = a;
            break;
          } else
            return this.lineCharOffset += a.length, a;
        else
          this.lineTokenOffset++, this.lineCharOffset = u;
      } else if (this.lineIdx === this.textBufferLineCount - 1 || (this.lineIdx++, this.lineTokens = this.textModel.tokenization.getLineTokens(this.lineIdx + 1), this.lineTokenOffset = 0, this.line = this.lineTokens.getLineContent(), this.lineCharOffset = 0, n += 33, n > 1e3))
        break;
      if (n > 1500)
        break;
    }
    const i = Cvt(e, t, this.lineIdx, this.lineCharOffset);
    return new Su(i, 0, -1, Pi.getEmpty(), new C0(i));
  }
}
class Ovt {
  constructor(e, t) {
    this.text = e, this._offset = Bs, this.idx = 0;
    const n = t.getRegExpStr(), i = n ? new RegExp(n + `|
`, "gi") : null, s = [];
    let o, a = 0, l = 0, c = 0, d = 0;
    const u = [];
    for (let g = 0; g < 60; g++)
      u.push(new Su(yi(0, g), 0, -1, Pi.getEmpty(), new C0(yi(0, g))));
    const f = [];
    for (let g = 0; g < 60; g++)
      f.push(new Su(yi(1, g), 0, -1, Pi.getEmpty(), new C0(yi(1, g))));
    if (i)
      for (i.lastIndex = 0; (o = i.exec(e)) !== null; ) {
        const g = o.index, m = o[0];
        if (m === `
`)
          a++, l = g + 1;
        else {
          if (c !== g) {
            let A;
            if (d === a) {
              const w = g - c;
              if (w < u.length)
                A = u[w];
              else {
                const v = yi(0, w);
                A = new Su(v, 0, -1, Pi.getEmpty(), new C0(v));
              }
            } else {
              const w = a - d, v = g - l;
              if (w === 1 && v < f.length)
                A = f[v];
              else {
                const y = yi(w, v);
                A = new Su(y, 0, -1, Pi.getEmpty(), new C0(y));
              }
            }
            s.push(A);
          }
          s.push(t.getToken(m)), c = g + m.length, d = a;
        }
      }
    const p = e.length;
    if (c !== p) {
      const g = d === a ? yi(0, p - c) : yi(a - d, p - l);
      s.push(new Su(g, 0, -1, Pi.getEmpty(), new C0(g)));
    }
    this.length = yi(a, p - l), this.tokens = s;
  }
  get offset() {
    return this._offset;
  }
  read() {
    return this.tokens[this.idx++] || null;
  }
  peek() {
    return this.tokens[this.idx] || null;
  }
  skip(e) {
    throw new N1t();
  }
}
class UO {
  static createFromLanguage(e, t) {
    function n(s) {
      return t.getKey(`${s.languageId}:::${s.bracketText}`);
    }
    const i = /* @__PURE__ */ new Map();
    for (const s of e.bracketsNew.openingBrackets) {
      const o = yi(0, s.bracketText.length), a = n(s), l = Pi.getEmpty().add(a, P6e);
      i.set(s.bracketText, new Su(o, 1, a, l, g9.create(o, s, l)));
    }
    for (const s of e.bracketsNew.closingBrackets) {
      const o = yi(0, s.bracketText.length);
      let a = Pi.getEmpty();
      const l = s.getOpeningBrackets();
      for (const c of l)
        a = a.add(n(c), P6e);
      i.set(s.bracketText, new Su(o, 2, n(l[0]), a, g9.create(o, s, a)));
    }
    return new UO(i);
  }
  constructor(e) {
    this.map = e, this.hasRegExp = !1, this._regExpGlobal = null;
  }
  getRegExpStr() {
    if (this.isEmpty)
      return null;
    {
      const e = [...this.map.keys()];
      return e.sort(), e.reverse(), e.map((t) => Rvt(t)).join("|");
    }
  }
  /**
   * Returns null if there is no such regexp (because there are no brackets).
  */
  get regExpGlobal() {
    if (!this.hasRegExp) {
      const e = this.getRegExpStr();
      this._regExpGlobal = e ? new RegExp(e, "gi") : null, this.hasRegExp = !0;
    }
    return this._regExpGlobal;
  }
  getToken(e) {
    return this.map.get(e.toLowerCase());
  }
  findClosingTokenText(e) {
    for (const [t, n] of this.map)
      if (n.kind === 2 && n.bracketIds.intersects(e))
        return t;
  }
  get isEmpty() {
    return this.map.size === 0;
  }
}
function Rvt(r) {
  let e = tc(r);
  return /^[\w ]+/.test(r) && (e = `\\b${e}`), /[\w ]+$/.test(r) && (e = `${e}\\b`), e;
}
class Vvt {
  constructor(e, t) {
    this.denseKeyProvider = e, this.getLanguageConfiguration = t, this.languageIdToBracketTokens = /* @__PURE__ */ new Map();
  }
  didLanguageChange(e) {
    return this.languageIdToBracketTokens.has(e);
  }
  getSingleLanguageBracketTokens(e) {
    let t = this.languageIdToBracketTokens.get(e);
    return t || (t = UO.createFromLanguage(this.getLanguageConfiguration(e), this.denseKeyProvider), this.languageIdToBracketTokens.set(e, t)), t;
  }
}
function Hvt(r) {
  if (r.length === 0)
    return null;
  if (r.length === 1)
    return r[0];
  let e = 0;
  function t() {
    if (e >= r.length)
      return null;
    const o = e, a = r[o].listHeight;
    for (e++; e < r.length && r[e].listHeight === a; )
      e++;
    return e - o >= 2 ? Ske(o === 0 && e === r.length ? r : r.slice(o, e), !1) : r[o];
  }
  let n = t(), i = t();
  if (!i)
    return n;
  for (let o = t(); o; o = t())
    F6e(n, i) <= F6e(i, o) ? (n = $E(n, i), i = o) : i = $E(i, o);
  return $E(n, i);
}
function Ske(r, e = !1) {
  if (r.length === 0)
    return null;
  if (r.length === 1)
    return r[0];
  let t = r.length;
  for (; t > 3; ) {
    const n = t >> 1;
    for (let i = 0; i < n; i++) {
      const s = i << 1;
      r[i] = uh.create23(r[s], r[s + 1], s + 3 === t ? r[s + 2] : null, e);
    }
    t = n;
  }
  return uh.create23(r[0], r[1], t >= 3 ? r[2] : null, e);
}
function F6e(r, e) {
  return Math.abs(r.listHeight - e.listHeight);
}
function $E(r, e) {
  return r.listHeight === e.listHeight ? uh.create23(r, e, null, !1) : r.listHeight > e.listHeight ? Bvt(r, e) : Pvt(e, r);
}
function Bvt(r, e) {
  r = r.toMutable();
  let t = r;
  const n = [];
  let i;
  for (; ; ) {
    if (e.listHeight === t.listHeight) {
      i = e;
      break;
    }
    if (t.kind !== 4)
      throw new Error("unexpected");
    n.push(t), t = t.makeLastElementMutable();
  }
  for (let s = n.length - 1; s >= 0; s--) {
    const o = n[s];
    i ? o.childrenLength >= 3 ? i = uh.create23(o.unappendChild(), i, null, !1) : (o.appendChildOfSameHeight(i), i = void 0) : o.handleChildrenChanged();
  }
  return i ? uh.create23(r, i, null, !1) : r;
}
function Pvt(r, e) {
  r = r.toMutable();
  let t = r;
  const n = [];
  for (; e.listHeight !== t.listHeight; ) {
    if (t.kind !== 4)
      throw new Error("unexpected");
    n.push(t), t = t.makeFirstElementMutable();
  }
  let i = e;
  for (let s = n.length - 1; s >= 0; s--) {
    const o = n[s];
    i ? o.childrenLength >= 3 ? i = uh.create23(i, o.unprependChild(), null, !1) : (o.prependChildOfSameHeight(i), i = void 0) : o.handleChildrenChanged();
  }
  return i ? uh.create23(i, r, null, !1) : r;
}
class Fvt {
  constructor(e) {
    this.lastOffset = Bs, this.nextNodes = [e], this.offsets = [Bs], this.idxs = [];
  }
  /**
   * Returns the longest node at `offset` that satisfies the predicate.
   * @param offset must be greater than or equal to the last offset this method has been called with!
  */
  readLongestNodeAt(e, t) {
    if (Mp(e, this.lastOffset))
      throw new Error("Invalid offset");
    for (this.lastOffset = e; ; ) {
      const n = Pm(this.nextNodes);
      if (!n)
        return;
      const i = Pm(this.offsets);
      if (Mp(e, i))
        return;
      if (Mp(i, e))
        if (Ti(i, n.length) <= e)
          this.nextNodeAfterCurrent();
        else {
          const s = e_(n);
          s !== -1 ? (this.nextNodes.push(n.getChild(s)), this.offsets.push(i), this.idxs.push(s)) : this.nextNodeAfterCurrent();
        }
      else {
        if (t(n))
          return this.nextNodeAfterCurrent(), n;
        {
          const s = e_(n);
          if (s === -1) {
            this.nextNodeAfterCurrent();
            return;
          } else
            this.nextNodes.push(n.getChild(s)), this.offsets.push(i), this.idxs.push(s);
        }
      }
    }
  }
  // Navigates to the longest node that continues after the current node.
  nextNodeAfterCurrent() {
    for (; ; ) {
      const e = Pm(this.offsets), t = Pm(this.nextNodes);
      if (this.nextNodes.pop(), this.offsets.pop(), this.idxs.length === 0)
        break;
      const n = Pm(this.nextNodes), i = e_(n, this.idxs[this.idxs.length - 1]);
      if (i !== -1) {
        this.nextNodes.push(n.getChild(i)), this.offsets.push(Ti(e, t.length)), this.idxs[this.idxs.length - 1] = i;
        break;
      } else
        this.idxs.pop();
    }
  }
}
function e_(r, e = -1) {
  for (; ; ) {
    if (e++, e >= r.childrenLength)
      return -1;
    if (r.getChild(e))
      return e;
  }
}
function Pm(r) {
  return r.length > 0 ? r[r.length - 1] : void 0;
}
function z6e(r, e, t, n) {
  return new zvt(r, e, t, n).parseDocument();
}
let zvt = class {
  constructor(e, t, n, i) {
    if (this.tokenizer = e, this.createImmutableLists = i, this._itemsConstructed = 0, this._itemsFromCache = 0, n && i)
      throw new Error("Not supported");
    this.oldNodeReader = n ? new Fvt(n) : void 0, this.positionMapper = new Svt(t);
  }
  parseDocument() {
    this._itemsConstructed = 0, this._itemsFromCache = 0;
    let e = this.parseList(Pi.getEmpty(), 0);
    return e || (e = uh.getEmpty()), e;
  }
  parseList(e, t) {
    const n = [];
    for (; ; ) {
      let s = this.tryReadChildFromCache(e);
      if (!s) {
        const o = this.tokenizer.peek();
        if (!o || o.kind === 2 && o.bracketIds.intersects(e))
          break;
        s = this.parseChild(e, t + 1);
      }
      s.kind === 4 && s.childrenLength === 0 || n.push(s);
    }
    return this.oldNodeReader ? Hvt(n) : Ske(n, this.createImmutableLists);
  }
  tryReadChildFromCache(e) {
    if (this.oldNodeReader) {
      const t = this.positionMapper.getDistanceToNextChange(this.tokenizer.offset);
      if (t === null || !f9(t)) {
        const n = this.oldNodeReader.readLongestNodeAt(this.positionMapper.getOffsetBeforeChange(this.tokenizer.offset), (i) => t !== null && !Mp(i.length, t) ? !1 : i.canBeReused(e));
        if (n)
          return this._itemsFromCache++, this.tokenizer.skip(n.length), n;
      }
    }
  }
  parseChild(e, t) {
    this._itemsConstructed++;
    const n = this.tokenizer.read();
    switch (n.kind) {
      case 2:
        return new Nvt(n.bracketIds, n.length);
      case 0:
        return n.astNode;
      case 1: {
        if (t > 300)
          return new C0(n.length);
        const i = e.merge(n.bracketIds), s = this.parseList(i, t + 1), o = this.tokenizer.peek();
        return o && o.kind === 2 && (o.bracketId === n.bracketId || o.bracketIds.intersects(n.bracketIds)) ? (this.tokenizer.read(), e4.create(n.astNode, s, o.astNode)) : e4.create(n.astNode, s, null);
      }
      default:
        throw new Error("unexpected");
    }
  }
};
function m9(r, e) {
  if (r.length === 0)
    return e;
  if (e.length === 0)
    return r;
  const t = new Hd(W6e(r)), n = W6e(e);
  n.push({ modified: !1, lengthBefore: void 0, lengthAfter: void 0 });
  let i = t.dequeue();
  function s(c) {
    if (c === void 0) {
      const u = t.takeWhile((f) => !0) || [];
      return i && u.unshift(i), u;
    }
    const d = [];
    for (; i && !f9(c); ) {
      const [u, f] = i.splitAt(c);
      d.push(u), c = $3(u.lengthAfter, c), i = f ?? t.dequeue();
    }
    return f9(c) || d.push(new Hu(!1, c, c)), d;
  }
  const o = [];
  function a(c, d, u) {
    if (o.length > 0 && xke(o[o.length - 1].endOffset, c)) {
      const f = o[o.length - 1];
      o[o.length - 1] = new pd(f.startOffset, d, Ti(f.newLength, u));
    } else
      o.push({ startOffset: c, endOffset: d, newLength: u });
  }
  let l = Bs;
  for (const c of n) {
    const d = s(c.lengthBefore);
    if (c.modified) {
      const u = _vt(d, (p) => p.lengthBefore), f = Ti(l, u);
      a(l, f, c.lengthAfter), l = f;
    } else
      for (const u of d) {
        const f = l;
        l = Ti(l, u.lengthBefore), u.modified && a(f, l, u.lengthAfter);
      }
  }
  return o;
}
class Hu {
  constructor(e, t, n) {
    this.modified = e, this.lengthBefore = t, this.lengthAfter = n;
  }
  splitAt(e) {
    const t = $3(e, this.lengthAfter);
    return xke(t, Bs) ? [this, void 0] : this.modified ? [
      new Hu(this.modified, this.lengthBefore, e),
      new Hu(this.modified, Bs, t)
    ] : [
      new Hu(this.modified, e, e),
      new Hu(this.modified, t, t)
    ];
  }
  toString() {
    return `${this.modified ? "M" : "U"}:${ma(this.lengthBefore)} -> ${ma(this.lengthAfter)}`;
  }
}
function W6e(r) {
  const e = [];
  let t = Bs;
  for (const n of r) {
    const i = $3(t, n.startOffset);
    f9(i) || e.push(new Hu(!1, i, i));
    const s = $3(n.startOffset, n.endOffset);
    e.push(new Hu(!0, s, n.newLength)), t = n.endOffset;
  }
  return e;
}
class Wvt extends me {
  didLanguageChange(e) {
    return this.brackets.didLanguageChange(e);
  }
  constructor(e, t) {
    if (super(), this.textModel = e, this.getLanguageConfiguration = t, this.didChangeEmitter = new $(), this.denseKeyProvider = new Mvt(), this.brackets = new Vvt(this.denseKeyProvider, this.getLanguageConfiguration), this.onDidChange = this.didChangeEmitter.event, this.queuedTextEditsForInitialAstWithoutTokens = [], this.queuedTextEdits = [], e.tokenization.hasTokens)
      e.tokenization.backgroundTokenizationState === 2 ? (this.initialAstWithoutTokens = void 0, this.astWithTokens = this.parseDocumentFromTextBuffer([], void 0, !1)) : (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer([], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens);
    else {
      const n = this.brackets.getSingleLanguageBracketTokens(this.textModel.getLanguageId()), i = new Ovt(this.textModel.getValue(), n);
      this.initialAstWithoutTokens = z6e(i, [], void 0, !0), this.astWithTokens = this.initialAstWithoutTokens;
    }
  }
  //#region TextModel events
  handleDidChangeBackgroundTokenizationState() {
    if (this.textModel.tokenization.backgroundTokenizationState === 2) {
      const e = this.initialAstWithoutTokens === void 0;
      this.initialAstWithoutTokens = void 0, e || this.didChangeEmitter.fire();
    }
  }
  handleDidChangeTokens({ ranges: e }) {
    const t = e.map((n) => new pd(yi(n.fromLineNumber - 1, 0), yi(n.toLineNumber, 0), yi(n.toLineNumber - n.fromLineNumber + 1, 0)));
    this.handleEdits(t, !0), this.initialAstWithoutTokens || this.didChangeEmitter.fire();
  }
  handleContentChanged(e) {
    const t = pd.fromModelContentChanges(e.changes);
    this.handleEdits(t, !1);
  }
  handleEdits(e, t) {
    const n = m9(this.queuedTextEdits, e);
    this.queuedTextEdits = n, this.initialAstWithoutTokens && !t && (this.queuedTextEditsForInitialAstWithoutTokens = m9(this.queuedTextEditsForInitialAstWithoutTokens, e));
  }
  //#endregion
  flushQueue() {
    this.queuedTextEdits.length > 0 && (this.astWithTokens = this.parseDocumentFromTextBuffer(this.queuedTextEdits, this.astWithTokens, !1), this.queuedTextEdits = []), this.queuedTextEditsForInitialAstWithoutTokens.length > 0 && (this.initialAstWithoutTokens && (this.initialAstWithoutTokens = this.parseDocumentFromTextBuffer(this.queuedTextEditsForInitialAstWithoutTokens, this.initialAstWithoutTokens, !1)), this.queuedTextEditsForInitialAstWithoutTokens = []);
  }
  /**
   * @pure (only if isPure = true)
  */
  parseDocumentFromTextBuffer(e, t, n) {
    const i = t, s = new Tvt(this.textModel, this.brackets);
    return z6e(s, e, i, n);
  }
  getBracketsInRange(e, t) {
    this.flushQueue();
    const n = yi(e.startLineNumber - 1, e.startColumn - 1), i = yi(e.endLineNumber - 1, e.endColumn - 1);
    return new bd((s) => {
      const o = this.initialAstWithoutTokens || this.astWithTokens;
      _L(o, Bs, o.length, n, i, s, 0, 0, /* @__PURE__ */ new Map(), t);
    });
  }
  getBracketPairsInRange(e, t) {
    this.flushQueue();
    const n = rp(e.getStartPosition()), i = rp(e.getEndPosition());
    return new bd((s) => {
      const o = this.initialAstWithoutTokens || this.astWithTokens, a = new jvt(s, t, this.textModel);
      xL(o, Bs, o.length, n, i, a, 0, /* @__PURE__ */ new Map());
    });
  }
  getFirstBracketAfter(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return Dke(t, Bs, t.length, rp(e));
  }
  getFirstBracketBefore(e) {
    this.flushQueue();
    const t = this.initialAstWithoutTokens || this.astWithTokens;
    return Mke(t, Bs, t.length, rp(e));
  }
}
function Mke(r, e, t, n) {
  if (r.kind === 4 || r.kind === 2) {
    const i = [];
    for (const s of r.children)
      t = Ti(e, s.length), i.push({ nodeOffsetStart: e, nodeOffsetEnd: t }), e = t;
    for (let s = i.length - 1; s >= 0; s--) {
      const { nodeOffsetStart: o, nodeOffsetEnd: a } = i[s];
      if (Mp(o, n)) {
        const l = Mke(r.children[s], o, a, n);
        if (l)
          return l;
      }
    }
    return null;
  } else {
    if (r.kind === 3)
      return null;
    if (r.kind === 1) {
      const i = Y0(e, t);
      return {
        bracketInfo: r.bracketInfo,
        range: i
      };
    }
  }
  return null;
}
function Dke(r, e, t, n) {
  if (r.kind === 4 || r.kind === 2) {
    for (const i of r.children) {
      if (t = Ti(e, i.length), Mp(n, t)) {
        const s = Dke(i, e, t, n);
        if (s)
          return s;
      }
      e = t;
    }
    return null;
  } else {
    if (r.kind === 3)
      return null;
    if (r.kind === 1) {
      const i = Y0(e, t);
      return {
        bracketInfo: r.bracketInfo,
        range: i
      };
    }
  }
  return null;
}
function _L(r, e, t, n, i, s, o, a, l, c, d = !1) {
  if (o > 200)
    return !0;
  e: for (; ; )
    switch (r.kind) {
      case 4: {
        const u = r.childrenLength;
        for (let f = 0; f < u; f++) {
          const p = r.getChild(f);
          if (p) {
            if (t = Ti(e, p.length), Dp(e, i) && mA(t, n)) {
              if (mA(t, i)) {
                r = p;
                continue e;
              }
              if (!_L(p, e, t, n, i, s, o, 0, l, c))
                return !1;
            }
            e = t;
          }
        }
        return !0;
      }
      case 2: {
        const u = !c || !r.closingBracket || r.closingBracket.bracketInfo.closesColorized(r.openingBracket.bracketInfo);
        let f = 0;
        if (l) {
          let g = l.get(r.openingBracket.text);
          g === void 0 && (g = 0), f = g, u && (g++, l.set(r.openingBracket.text, g));
        }
        const p = r.childrenLength;
        for (let g = 0; g < p; g++) {
          const m = r.getChild(g);
          if (m) {
            if (t = Ti(e, m.length), Dp(e, i) && mA(t, n)) {
              if (mA(t, i) && m.kind !== 1) {
                r = m, u ? (o++, a = f + 1) : a = f;
                continue e;
              }
              if ((u || m.kind !== 1 || !r.closingBracket) && !_L(m, e, t, n, i, s, u ? o + 1 : o, u ? f + 1 : f, l, c, !r.closingBracket))
                return !1;
            }
            e = t;
          }
        }
        return l?.set(r.openingBracket.text, f), !0;
      }
      case 3: {
        const u = Y0(e, t);
        return s(new B6e(u, o - 1, 0, !0));
      }
      case 1: {
        const u = Y0(e, t);
        return s(new B6e(u, o - 1, a - 1, d));
      }
      case 0:
        return !0;
    }
}
class jvt {
  constructor(e, t, n) {
    this.push = e, this.includeMinIndentation = t, this.textModel = n;
  }
}
function xL(r, e, t, n, i, s, o, a) {
  if (o > 200)
    return !0;
  let l = !0;
  if (r.kind === 2) {
    let c = 0;
    if (a) {
      let f = a.get(r.openingBracket.text);
      f === void 0 && (f = 0), c = f, f++, a.set(r.openingBracket.text, f);
    }
    const d = Ti(e, r.openingBracket.length);
    let u = -1;
    if (s.includeMinIndentation && (u = r.computeMinIndentation(e, s.textModel)), l = s.push(new yvt(Y0(e, t), Y0(e, d), r.closingBracket ? Y0(Ti(d, r.child?.length || Bs), t) : void 0, o, c, r, u)), e = d, l && r.child) {
      const f = r.child;
      if (t = Ti(e, f.length), Dp(e, i) && mA(t, n) && (l = xL(f, e, t, n, i, s, o + 1, a), !l))
        return !1;
    }
    a?.set(r.openingBracket.text, c);
  } else {
    let c = e;
    for (const d of r.children) {
      const u = c;
      if (c = Ti(c, d.length), Dp(u, i) && Dp(n, c) && (l = xL(d, u, c, n, i, s, o, a), !l))
        return !1;
    }
  }
  return l;
}
class Zvt extends me {
  get canBuildAST() {
    return this.textModel.getValueLength() <= 5e6;
  }
  constructor(e, t) {
    super(), this.textModel = e, this.languageConfigurationService = t, this.bracketPairsTree = this._register(new Bd()), this.onDidChangeEmitter = new $(), this.onDidChange = this.onDidChangeEmitter.event, this.bracketsRequested = !1;
  }
  //#region TextModel events
  handleLanguageConfigurationServiceChange(e) {
    (!e.languageId || this.bracketPairsTree.value?.object.didLanguageChange(e.languageId)) && (this.bracketPairsTree.clear(), this.updateBracketPairsTree());
  }
  handleDidChangeOptions(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeLanguage(e) {
    this.bracketPairsTree.clear(), this.updateBracketPairsTree();
  }
  handleDidChangeContent(e) {
    this.bracketPairsTree.value?.object.handleContentChanged(e);
  }
  handleDidChangeBackgroundTokenizationState() {
    this.bracketPairsTree.value?.object.handleDidChangeBackgroundTokenizationState();
  }
  handleDidChangeTokens(e) {
    this.bracketPairsTree.value?.object.handleDidChangeTokens(e);
  }
  //#endregion
  updateBracketPairsTree() {
    if (this.bracketsRequested && this.canBuildAST) {
      if (!this.bracketPairsTree.value) {
        const e = new ze();
        this.bracketPairsTree.value = Uvt(e.add(new Wvt(this.textModel, (t) => this.languageConfigurationService.getLanguageConfiguration(t))), e), e.add(this.bracketPairsTree.value.object.onDidChange((t) => this.onDidChangeEmitter.fire(t))), this.onDidChangeEmitter.fire();
      }
    } else
      this.bracketPairsTree.value && (this.bracketPairsTree.clear(), this.onDidChangeEmitter.fire());
  }
  /**
   * Returns all bracket pairs that intersect the given range.
   * The result is sorted by the start position.
  */
  getBracketPairsInRange(e) {
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), this.bracketPairsTree.value?.object.getBracketPairsInRange(e, !1) || bd.empty;
  }
  getBracketPairsInRangeWithMinIndentation(e) {
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), this.bracketPairsTree.value?.object.getBracketPairsInRange(e, !0) || bd.empty;
  }
  getBracketsInRange(e, t = !1) {
    return this.bracketsRequested = !0, this.updateBracketPairsTree(), this.bracketPairsTree.value?.object.getBracketsInRange(e, t) || bd.empty;
  }
  findMatchingBracketUp(e, t, n) {
    const i = this.textModel.validatePosition(t), s = this.textModel.getLanguageIdAtPosition(i.lineNumber, i.column);
    if (this.canBuildAST) {
      const o = this.languageConfigurationService.getLanguageConfiguration(s).bracketsNew.getClosingBracketInfo(e);
      if (!o)
        return null;
      const a = this.getBracketPairsInRange(Q.fromPositions(t, t)).findLast((l) => o.closes(l.openingBracketInfo));
      return a ? a.openingBracketRange : null;
    } else {
      const o = e.toLowerCase(), a = this.languageConfigurationService.getLanguageConfiguration(s).brackets;
      if (!a)
        return null;
      const l = a.textIsBracket[o];
      return l ? Pv(this._findMatchingBracketUp(l, i, t_(n))) : null;
    }
  }
  matchBracket(e, t) {
    if (this.canBuildAST) {
      const n = this.getBracketPairsInRange(Q.fromPositions(e, e)).filter((i) => i.closingBracketRange !== void 0 && (i.openingBracketRange.containsPosition(e) || i.closingBracketRange.containsPosition(e))).findLastMaxBy(al((i) => i.openingBracketRange.containsPosition(e) ? i.openingBracketRange : i.closingBracketRange, Q.compareRangesUsingStarts));
      return n ? [n.openingBracketRange, n.closingBracketRange] : null;
    } else {
      const n = t_(t);
      return this._matchBracket(this.textModel.validatePosition(e), n);
    }
  }
  _establishBracketSearchOffsets(e, t, n, i) {
    const s = t.getCount(), o = t.getLanguageId(i);
    let a = Math.max(0, e.column - 1 - n.maxBracketLength);
    for (let c = i - 1; c >= 0; c--) {
      const d = t.getEndOffset(c);
      if (d <= a)
        break;
      if (Vc(t.getStandardTokenType(c)) || t.getLanguageId(c) !== o) {
        a = d;
        break;
      }
    }
    let l = Math.min(t.getLineContent().length, e.column - 1 + n.maxBracketLength);
    for (let c = i + 1; c < s; c++) {
      const d = t.getStartOffset(c);
      if (d >= l)
        break;
      if (Vc(t.getStandardTokenType(c)) || t.getLanguageId(c) !== o) {
        l = d;
        break;
      }
    }
    return { searchStartOffset: a, searchEndOffset: l };
  }
  _matchBracket(e, t) {
    const n = e.lineNumber, i = this.textModel.tokenization.getLineTokens(n), s = this.textModel.getLineContent(n), o = i.findTokenIndexAtOffset(e.column - 1);
    if (o < 0)
      return null;
    const a = this.languageConfigurationService.getLanguageConfiguration(i.getLanguageId(o)).brackets;
    if (a && !Vc(i.getStandardTokenType(o))) {
      let { searchStartOffset: l, searchEndOffset: c } = this._establishBracketSearchOffsets(e, i, a, o), d = null;
      for (; ; ) {
        const u = Ha.findNextBracketInRange(a.forwardRegex, n, s, l, c);
        if (!u)
          break;
        if (u.startColumn <= e.column && e.column <= u.endColumn) {
          const f = s.substring(u.startColumn - 1, u.endColumn - 1).toLowerCase(), p = this._matchFoundBracket(u, a.textIsBracket[f], a.textIsOpenBracket[f], t);
          if (p) {
            if (p instanceof Jh)
              return null;
            d = p;
          }
        }
        l = u.endColumn - 1;
      }
      if (d)
        return d;
    }
    if (o > 0 && i.getStartOffset(o) === e.column - 1) {
      const l = o - 1, c = this.languageConfigurationService.getLanguageConfiguration(i.getLanguageId(l)).brackets;
      if (c && !Vc(i.getStandardTokenType(l))) {
        const { searchStartOffset: d, searchEndOffset: u } = this._establishBracketSearchOffsets(e, i, c, l), f = Ha.findPrevBracketInRange(c.reversedRegex, n, s, d, u);
        if (f && f.startColumn <= e.column && e.column <= f.endColumn) {
          const p = s.substring(f.startColumn - 1, f.endColumn - 1).toLowerCase(), g = this._matchFoundBracket(f, c.textIsBracket[p], c.textIsOpenBracket[p], t);
          if (g)
            return g instanceof Jh ? null : g;
        }
      }
    }
    return null;
  }
  _matchFoundBracket(e, t, n, i) {
    if (!t)
      return null;
    const s = n ? this._findMatchingBracketDown(t, e.getEndPosition(), i) : this._findMatchingBracketUp(t, e.getStartPosition(), i);
    return s ? s instanceof Jh ? s : [e, s] : null;
  }
  _findMatchingBracketUp(e, t, n) {
    const i = e.languageId, s = e.reversedRegex;
    let o = -1, a = 0;
    const l = (c, d, u, f) => {
      for (; ; ) {
        if (n && ++a % 100 === 0 && !n())
          return Jh.INSTANCE;
        const p = Ha.findPrevBracketInRange(s, c, d, u, f);
        if (!p)
          break;
        const g = d.substring(p.startColumn - 1, p.endColumn - 1).toLowerCase();
        if (e.isOpen(g) ? o++ : e.isClose(g) && o--, o === 0)
          return p;
        f = p.startColumn - 1;
      }
      return null;
    };
    for (let c = t.lineNumber; c >= 1; c--) {
      const d = this.textModel.tokenization.getLineTokens(c), u = d.getCount(), f = this.textModel.getLineContent(c);
      let p = u - 1, g = f.length, m = f.length;
      c === t.lineNumber && (p = d.findTokenIndexAtOffset(t.column - 1), g = t.column - 1, m = t.column - 1);
      let A = !0;
      for (; p >= 0; p--) {
        const w = d.getLanguageId(p) === i && !Vc(d.getStandardTokenType(p));
        if (w)
          A ? g = d.getStartOffset(p) : (g = d.getStartOffset(p), m = d.getEndOffset(p));
        else if (A && g !== m) {
          const v = l(c, f, g, m);
          if (v)
            return v;
        }
        A = w;
      }
      if (A && g !== m) {
        const w = l(c, f, g, m);
        if (w)
          return w;
      }
    }
    return null;
  }
  _findMatchingBracketDown(e, t, n) {
    const i = e.languageId, s = e.forwardRegex;
    let o = 1, a = 0;
    const l = (d, u, f, p) => {
      for (; ; ) {
        if (n && ++a % 100 === 0 && !n())
          return Jh.INSTANCE;
        const g = Ha.findNextBracketInRange(s, d, u, f, p);
        if (!g)
          break;
        const m = u.substring(g.startColumn - 1, g.endColumn - 1).toLowerCase();
        if (e.isOpen(m) ? o++ : e.isClose(m) && o--, o === 0)
          return g;
        f = g.endColumn - 1;
      }
      return null;
    }, c = this.textModel.getLineCount();
    for (let d = t.lineNumber; d <= c; d++) {
      const u = this.textModel.tokenization.getLineTokens(d), f = u.getCount(), p = this.textModel.getLineContent(d);
      let g = 0, m = 0, A = 0;
      d === t.lineNumber && (g = u.findTokenIndexAtOffset(t.column - 1), m = t.column - 1, A = t.column - 1);
      let w = !0;
      for (; g < f; g++) {
        const v = u.getLanguageId(g) === i && !Vc(u.getStandardTokenType(g));
        if (v)
          w || (m = u.getStartOffset(g)), A = u.getEndOffset(g);
        else if (w && m !== A) {
          const y = l(d, p, m, A);
          if (y)
            return y;
        }
        w = v;
      }
      if (w && m !== A) {
        const v = l(d, p, m, A);
        if (v)
          return v;
      }
    }
    return null;
  }
  findPrevBracket(e) {
    const t = this.textModel.validatePosition(e);
    if (this.canBuildAST)
      return this.bracketsRequested = !0, this.updateBracketPairsTree(), this.bracketPairsTree.value?.object.getFirstBracketBefore(t) || null;
    let n = null, i = null, s = null;
    for (let o = t.lineNumber; o >= 1; o--) {
      const a = this.textModel.tokenization.getLineTokens(o), l = a.getCount(), c = this.textModel.getLineContent(o);
      let d = l - 1, u = c.length, f = c.length;
      if (o === t.lineNumber) {
        d = a.findTokenIndexAtOffset(t.column - 1), u = t.column - 1, f = t.column - 1;
        const g = a.getLanguageId(d);
        n !== g && (n = g, i = this.languageConfigurationService.getLanguageConfiguration(n).brackets, s = this.languageConfigurationService.getLanguageConfiguration(n).bracketsNew);
      }
      let p = !0;
      for (; d >= 0; d--) {
        const g = a.getLanguageId(d);
        if (n !== g) {
          if (i && s && p && u !== f) {
            const A = Ha.findPrevBracketInRange(i.reversedRegex, o, c, u, f);
            if (A)
              return this._toFoundBracket(s, A);
            p = !1;
          }
          n = g, i = this.languageConfigurationService.getLanguageConfiguration(n).brackets, s = this.languageConfigurationService.getLanguageConfiguration(n).bracketsNew;
        }
        const m = !!i && !Vc(a.getStandardTokenType(d));
        if (m)
          p ? u = a.getStartOffset(d) : (u = a.getStartOffset(d), f = a.getEndOffset(d));
        else if (s && i && p && u !== f) {
          const A = Ha.findPrevBracketInRange(i.reversedRegex, o, c, u, f);
          if (A)
            return this._toFoundBracket(s, A);
        }
        p = m;
      }
      if (s && i && p && u !== f) {
        const g = Ha.findPrevBracketInRange(i.reversedRegex, o, c, u, f);
        if (g)
          return this._toFoundBracket(s, g);
      }
    }
    return null;
  }
  findNextBracket(e) {
    const t = this.textModel.validatePosition(e);
    if (this.canBuildAST)
      return this.bracketsRequested = !0, this.updateBracketPairsTree(), this.bracketPairsTree.value?.object.getFirstBracketAfter(t) || null;
    const n = this.textModel.getLineCount();
    let i = null, s = null, o = null;
    for (let a = t.lineNumber; a <= n; a++) {
      const l = this.textModel.tokenization.getLineTokens(a), c = l.getCount(), d = this.textModel.getLineContent(a);
      let u = 0, f = 0, p = 0;
      if (a === t.lineNumber) {
        u = l.findTokenIndexAtOffset(t.column - 1), f = t.column - 1, p = t.column - 1;
        const m = l.getLanguageId(u);
        i !== m && (i = m, s = this.languageConfigurationService.getLanguageConfiguration(i).brackets, o = this.languageConfigurationService.getLanguageConfiguration(i).bracketsNew);
      }
      let g = !0;
      for (; u < c; u++) {
        const m = l.getLanguageId(u);
        if (i !== m) {
          if (o && s && g && f !== p) {
            const w = Ha.findNextBracketInRange(s.forwardRegex, a, d, f, p);
            if (w)
              return this._toFoundBracket(o, w);
            g = !1;
          }
          i = m, s = this.languageConfigurationService.getLanguageConfiguration(i).brackets, o = this.languageConfigurationService.getLanguageConfiguration(i).bracketsNew;
        }
        const A = !!s && !Vc(l.getStandardTokenType(u));
        if (A)
          g || (f = l.getStartOffset(u)), p = l.getEndOffset(u);
        else if (o && s && g && f !== p) {
          const w = Ha.findNextBracketInRange(s.forwardRegex, a, d, f, p);
          if (w)
            return this._toFoundBracket(o, w);
        }
        g = A;
      }
      if (o && s && g && f !== p) {
        const m = Ha.findNextBracketInRange(s.forwardRegex, a, d, f, p);
        if (m)
          return this._toFoundBracket(o, m);
      }
    }
    return null;
  }
  findEnclosingBrackets(e, t) {
    const n = this.textModel.validatePosition(e);
    if (this.canBuildAST) {
      const p = Q.fromPositions(n), g = this.getBracketPairsInRange(Q.fromPositions(n, n)).findLast((m) => m.closingBracketRange !== void 0 && m.range.strictContainsRange(p));
      return g ? [g.openingBracketRange, g.closingBracketRange] : null;
    }
    const i = t_(t), s = this.textModel.getLineCount(), o = /* @__PURE__ */ new Map();
    let a = [];
    const l = (p, g) => {
      if (!o.has(p)) {
        const m = [];
        for (let A = 0, w = g ? g.brackets.length : 0; A < w; A++)
          m[A] = 0;
        o.set(p, m);
      }
      a = o.get(p);
    };
    let c = 0;
    const d = (p, g, m, A, w) => {
      for (; ; ) {
        if (i && ++c % 100 === 0 && !i())
          return Jh.INSTANCE;
        const v = Ha.findNextBracketInRange(p.forwardRegex, g, m, A, w);
        if (!v)
          break;
        const y = m.substring(v.startColumn - 1, v.endColumn - 1).toLowerCase(), _ = p.textIsBracket[y];
        if (_ && (_.isOpen(y) ? a[_.index]++ : _.isClose(y) && a[_.index]--, a[_.index] === -1))
          return this._matchFoundBracket(v, _, !1, i);
        A = v.endColumn - 1;
      }
      return null;
    };
    let u = null, f = null;
    for (let p = n.lineNumber; p <= s; p++) {
      const g = this.textModel.tokenization.getLineTokens(p), m = g.getCount(), A = this.textModel.getLineContent(p);
      let w = 0, v = 0, y = 0;
      if (p === n.lineNumber) {
        w = g.findTokenIndexAtOffset(n.column - 1), v = n.column - 1, y = n.column - 1;
        const S = g.getLanguageId(w);
        u !== S && (u = S, f = this.languageConfigurationService.getLanguageConfiguration(u).brackets, l(u, f));
      }
      let _ = !0;
      for (; w < m; w++) {
        const S = g.getLanguageId(w);
        if (u !== S) {
          if (f && _ && v !== y) {
            const M = d(f, p, A, v, y);
            if (M)
              return Pv(M);
            _ = !1;
          }
          u = S, f = this.languageConfigurationService.getLanguageConfiguration(u).brackets, l(u, f);
        }
        const D = !!f && !Vc(g.getStandardTokenType(w));
        if (D)
          _ || (v = g.getStartOffset(w)), y = g.getEndOffset(w);
        else if (f && _ && v !== y) {
          const M = d(f, p, A, v, y);
          if (M)
            return Pv(M);
        }
        _ = D;
      }
      if (f && _ && v !== y) {
        const S = d(f, p, A, v, y);
        if (S)
          return Pv(S);
      }
    }
    return null;
  }
  _toFoundBracket(e, t) {
    if (!t)
      return null;
    let n = this.textModel.getValueInRange(t);
    n = n.toLowerCase();
    const i = e.getBracketInfo(n);
    return i ? {
      range: t,
      bracketInfo: i
    } : null;
  }
}
function Uvt(r, e) {
  return {
    object: r,
    dispose: () => e?.dispose()
  };
}
function t_(r) {
  if (typeof r > "u")
    return () => !0;
  {
    const e = Date.now();
    return () => Date.now() - e <= r;
  }
}
class Jh {
  static {
    this.INSTANCE = new Jh();
  }
  constructor() {
    this._searchCanceledBrand = void 0;
  }
}
function Pv(r) {
  return r instanceof Jh ? null : r;
}
class qvt extends me {
  constructor(e) {
    super(), this.textModel = e, this.colorProvider = new Lke(), this.onDidChangeEmitter = new $(), this.onDidChange = this.onDidChangeEmitter.event, this.colorizationOptions = e.getOptions().bracketPairColorizationOptions, this._register(e.bracketPairs.onDidChange((t) => {
      this.onDidChangeEmitter.fire();
    }));
  }
  //#region TextModel events
  handleDidChangeOptions(e) {
    this.colorizationOptions = this.textModel.getOptions().bracketPairColorizationOptions;
  }
  //#endregion
  getDecorationsInRange(e, t, n, i) {
    return i ? [] : t === void 0 ? [] : this.colorizationOptions.enabled ? this.textModel.bracketPairs.getBracketsInRange(e, !0).map((o) => ({
      id: `bracket${o.range.toString()}-${o.nestingLevel}`,
      options: {
        description: "BracketPairColorization",
        inlineClassName: this.colorProvider.getInlineClassName(o, this.colorizationOptions.independentColorPoolPerBracketType)
      },
      ownerId: 0,
      range: o.range
    })).toArray() : [];
  }
  getAllDecorations(e, t) {
    return e === void 0 ? [] : this.colorizationOptions.enabled ? this.getDecorationsInRange(new Q(1, 1, this.textModel.getLineCount(), 1), e, t) : [];
  }
}
class Lke {
  constructor() {
    this.unexpectedClosingBracketClassName = "unexpected-closing-bracket";
  }
  getInlineClassName(e, t) {
    return e.isInvalid ? this.unexpectedClosingBracketClassName : this.getInlineClassNameOfLevel(t ? e.nestingLevelOfEqualBracketType : e.nestingLevel);
  }
  getInlineClassNameOfLevel(e) {
    return `bracket-highlighting-${e % 30}`;
  }
}
Sh((r, e) => {
  const t = [
    ike,
    rke,
    ske,
    oke,
    ake,
    lke
  ], n = new Lke();
  e.addRule(`.monaco-editor .${n.unexpectedClosingBracketClassName} { color: ${r.getColor(E4t)}; }`);
  const i = t.map((s) => r.getColor(s)).filter((s) => !!s).filter((s) => !s.isTransparent());
  for (let s = 0; s < 30; s++) {
    const o = i[s % i.length];
    e.addRule(`.monaco-editor .${n.getInlineClassNameOfLevel(s)} { color: ${o}; }`);
  }
});
function Fv(r) {
  return r.replace(/\n/g, "\\n").replace(/\r/g, "\\r");
}
class Dr {
  get oldLength() {
    return this.oldText.length;
  }
  get oldEnd() {
    return this.oldPosition + this.oldText.length;
  }
  get newLength() {
    return this.newText.length;
  }
  get newEnd() {
    return this.newPosition + this.newText.length;
  }
  constructor(e, t, n, i) {
    this.oldPosition = e, this.oldText = t, this.newPosition = n, this.newText = i;
  }
  toString() {
    return this.oldText.length === 0 ? `(insert@${this.oldPosition} "${Fv(this.newText)}")` : this.newText.length === 0 ? `(delete@${this.oldPosition} "${Fv(this.oldText)}")` : `(replace@${this.oldPosition} "${Fv(this.oldText)}" with "${Fv(this.newText)}")`;
  }
  static _writeStringSize(e) {
    return 4 + 2 * e.length;
  }
  static _writeString(e, t, n) {
    const i = t.length;
    Ol(e, i, n), n += 4;
    for (let s = 0; s < i; s++)
      F2t(e, t.charCodeAt(s), n), n += 2;
    return n;
  }
  static _readString(e, t) {
    const n = Il(e, t);
    return t += 4, W2t(e, t, n);
  }
  writeSize() {
    return 8 + Dr._writeStringSize(this.oldText) + Dr._writeStringSize(this.newText);
  }
  write(e, t) {
    return Ol(e, this.oldPosition, t), t += 4, Ol(e, this.newPosition, t), t += 4, t = Dr._writeString(e, this.oldText, t), t = Dr._writeString(e, this.newText, t), t;
  }
  static read(e, t, n) {
    const i = Il(e, t);
    t += 4;
    const s = Il(e, t);
    t += 4;
    const o = Dr._readString(e, t);
    t += Dr._writeStringSize(o);
    const a = Dr._readString(e, t);
    return t += Dr._writeStringSize(a), n.push(new Dr(i, o, s, a)), t;
  }
}
function Gvt(r, e) {
  return r === null || r.length === 0 ? e : new Bc(r, e).compress();
}
class Bc {
  constructor(e, t) {
    this._prevEdits = e, this._currEdits = t, this._result = [], this._resultLen = 0, this._prevLen = this._prevEdits.length, this._prevDeltaOffset = 0, this._currLen = this._currEdits.length, this._currDeltaOffset = 0;
  }
  compress() {
    let e = 0, t = 0, n = this._getPrev(e), i = this._getCurr(t);
    for (; e < this._prevLen || t < this._currLen; ) {
      if (n === null) {
        this._acceptCurr(i), i = this._getCurr(++t);
        continue;
      }
      if (i === null) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (i.oldEnd <= n.newPosition) {
        this._acceptCurr(i), i = this._getCurr(++t);
        continue;
      }
      if (n.newEnd <= i.oldPosition) {
        this._acceptPrev(n), n = this._getPrev(++e);
        continue;
      }
      if (i.oldPosition < n.newPosition) {
        const [c, d] = Bc._splitCurr(i, n.newPosition - i.oldPosition);
        this._acceptCurr(c), i = d;
        continue;
      }
      if (n.newPosition < i.oldPosition) {
        const [c, d] = Bc._splitPrev(n, i.oldPosition - n.newPosition);
        this._acceptPrev(c), n = d;
        continue;
      }
      let a, l;
      if (i.oldEnd === n.newEnd)
        a = n, l = i, n = this._getPrev(++e), i = this._getCurr(++t);
      else if (i.oldEnd < n.newEnd) {
        const [c, d] = Bc._splitPrev(n, i.oldLength);
        a = c, l = i, n = d, i = this._getCurr(++t);
      } else {
        const [c, d] = Bc._splitCurr(i, n.newLength);
        a = n, l = c, n = this._getPrev(++e), i = d;
      }
      this._result[this._resultLen++] = new Dr(a.oldPosition, a.oldText, l.newPosition, l.newText), this._prevDeltaOffset += a.newLength - a.oldLength, this._currDeltaOffset += l.newLength - l.oldLength;
    }
    const s = Bc._merge(this._result);
    return Bc._removeNoOps(s);
  }
  _acceptCurr(e) {
    this._result[this._resultLen++] = Bc._rebaseCurr(this._prevDeltaOffset, e), this._currDeltaOffset += e.newLength - e.oldLength;
  }
  _getCurr(e) {
    return e < this._currLen ? this._currEdits[e] : null;
  }
  _acceptPrev(e) {
    this._result[this._resultLen++] = Bc._rebasePrev(this._currDeltaOffset, e), this._prevDeltaOffset += e.newLength - e.oldLength;
  }
  _getPrev(e) {
    return e < this._prevLen ? this._prevEdits[e] : null;
  }
  static _rebaseCurr(e, t) {
    return new Dr(t.oldPosition - e, t.oldText, t.newPosition, t.newText);
  }
  static _rebasePrev(e, t) {
    return new Dr(t.oldPosition, t.oldText, t.newPosition + e, t.newText);
  }
  static _splitPrev(e, t) {
    const n = e.newText.substr(0, t), i = e.newText.substr(t);
    return [
      new Dr(e.oldPosition, e.oldText, e.newPosition, n),
      new Dr(e.oldEnd, "", e.newPosition + t, i)
    ];
  }
  static _splitCurr(e, t) {
    const n = e.oldText.substr(0, t), i = e.oldText.substr(t);
    return [
      new Dr(e.oldPosition, n, e.newPosition, e.newText),
      new Dr(e.oldPosition + t, i, e.newEnd, "")
    ];
  }
  static _merge(e) {
    if (e.length === 0)
      return e;
    const t = [];
    let n = 0, i = e[0];
    for (let s = 1; s < e.length; s++) {
      const o = e[s];
      i.oldEnd === o.oldPosition ? i = new Dr(i.oldPosition, i.oldText + o.oldText, i.newPosition, i.newText + o.newText) : (t[n++] = i, i = o);
    }
    return t[n++] = i, t;
  }
  static _removeNoOps(e) {
    if (e.length === 0)
      return e;
    const t = [];
    let n = 0;
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      s.oldText !== s.newText && (t[n++] = s);
    }
    return t;
  }
}
function hu(r) {
  return r === 47 || r === 92;
}
function kke(r) {
  return r.replace(/[\\/]/g, Si.sep);
}
function Qvt(r) {
  return r.indexOf("/") === -1 && (r = kke(r)), /^[a-zA-Z]:(\/|$)/.test(r) && (r = "/" + r), r;
}
function j6e(r, e = Si.sep) {
  if (!r)
    return "";
  const t = r.length, n = r.charCodeAt(0);
  if (hu(n)) {
    if (hu(r.charCodeAt(1)) && !hu(r.charCodeAt(2))) {
      let s = 3;
      const o = s;
      for (; s < t && !hu(r.charCodeAt(s)); s++)
        ;
      if (o !== s && !hu(r.charCodeAt(s + 1))) {
        for (s += 1; s < t; s++)
          if (hu(r.charCodeAt(s)))
            return r.slice(0, s + 1).replace(/[\\/]/g, e);
      }
    }
    return e;
  } else if (Kvt(n) && r.charCodeAt(1) === 58)
    return hu(r.charCodeAt(2)) ? r.slice(0, 2) + e : r.slice(0, 2);
  let i = r.indexOf("://");
  if (i !== -1) {
    for (i += 3; i < t; i++)
      if (hu(r.charCodeAt(i)))
        return r.slice(0, i + 1);
  }
  return "";
}
function SL(r, e, t, n = Yu) {
  if (r === e)
    return !0;
  if (!r || !e || e.length > r.length)
    return !1;
  if (t) {
    if (!OI(r, e))
      return !1;
    if (e.length === r.length)
      return !0;
    let s = e.length;
    return e.charAt(e.length - 1) === n && s--, r.charAt(s) === n;
  }
  return e.charAt(e.length - 1) !== n && (e += n), r.indexOf(e) === 0;
}
function Kvt(r) {
  return r >= 65 && r <= 90 || r >= 97 && r <= 122;
}
function Vh(r) {
  return T8(r, !0);
}
class Yvt {
  constructor(e) {
    this._ignorePathCasing = e;
  }
  compare(e, t, n = !1) {
    return e === t ? 0 : LD(this.getComparisonKey(e, n), this.getComparisonKey(t, n));
  }
  isEqual(e, t, n = !1) {
    return e === t ? !0 : !e || !t ? !1 : this.getComparisonKey(e, n) === this.getComparisonKey(t, n);
  }
  getComparisonKey(e, t = !1) {
    return e.with({
      path: this._ignorePathCasing(e) ? e.path.toLowerCase() : void 0,
      fragment: t ? null : void 0
    }).toString();
  }
  isEqualOrParent(e, t, n = !1) {
    if (e.scheme === t.scheme) {
      if (e.scheme === Ct.file)
        return SL(Vh(e), Vh(t), this._ignorePathCasing(e)) && e.query === t.query && (n || e.fragment === t.fragment);
      if (U6e(e.authority, t.authority))
        return SL(e.path, t.path, this._ignorePathCasing(e), "/") && e.query === t.query && (n || e.fragment === t.fragment);
    }
    return !1;
  }
  // --- path math
  joinPath(e, ...t) {
    return Pt.joinPath(e, ...t);
  }
  basenameOrAuthority(e) {
    return qO(e) || e.authority;
  }
  basename(e) {
    return Si.basename(e.path);
  }
  extname(e) {
    return Si.extname(e.path);
  }
  dirname(e) {
    if (e.path.length === 0)
      return e;
    let t;
    return e.scheme === Ct.file ? t = Pt.file(t0t(Vh(e))).path : (t = Si.dirname(e.path), e.authority && t.length && t.charCodeAt(0) !== 47 && (console.error(`dirname("${e.toString})) resulted in a relative path`), t = "/")), e.with({
      path: t
    });
  }
  normalizePath(e) {
    if (!e.path.length)
      return e;
    let t;
    return e.scheme === Ct.file ? t = Pt.file(QMe(Vh(e))).path : t = Si.normalize(e.path), e.with({
      path: t
    });
  }
  relativePath(e, t) {
    if (e.scheme !== t.scheme || !U6e(e.authority, t.authority))
      return;
    if (e.scheme === Ct.file) {
      const s = e0t(Vh(e), Vh(t));
      return zs ? kke(s) : s;
    }
    let n = e.path || "/";
    const i = t.path || "/";
    if (this._ignorePathCasing(e)) {
      let s = 0;
      for (const o = Math.min(n.length, i.length); s < o && !(n.charCodeAt(s) !== i.charCodeAt(s) && n.charAt(s).toLowerCase() !== i.charAt(s).toLowerCase()); s++)
        ;
      n = i.substr(0, s) + n.substr(s);
    }
    return Si.relative(n, i);
  }
  resolvePath(e, t) {
    if (e.scheme === Ct.file) {
      const n = Pt.file($1t(Vh(e), t));
      return e.with({
        authority: n.authority,
        path: n.path
      });
    }
    return t = Qvt(t), e.with({
      path: Si.resolve(e.path, t)
    });
  }
  // --- misc
  isAbsolutePath(e) {
    return !!e.path && e.path[0] === "/";
  }
  isEqualAuthority(e, t) {
    return e === t || e !== void 0 && t !== void 0 && Q2(e, t);
  }
  hasTrailingPathSeparator(e, t = Yu) {
    if (e.scheme === Ct.file) {
      const n = Vh(e);
      return n.length > j6e(n).length && n[n.length - 1] === t;
    } else {
      const n = e.path;
      return n.length > 1 && n.charCodeAt(n.length - 1) === 47 && !/^[a-zA-Z]:(\/$|\\$)/.test(e.fsPath);
    }
  }
  removeTrailingPathSeparator(e, t = Yu) {
    return q6e(e, t) ? e.with({ path: e.path.substr(0, e.path.length - 1) }) : e;
  }
  addTrailingPathSeparator(e, t = Yu) {
    let n = !1;
    if (e.scheme === Ct.file) {
      const i = Vh(e);
      n = i !== void 0 && i.length === j6e(i).length && i[i.length - 1] === t;
    } else {
      t = "/";
      const i = e.path;
      n = i.length === 1 && i.charCodeAt(i.length - 1) === 47;
    }
    return !n && !q6e(e, t) ? e.with({ path: e.path + "/" }) : e;
  }
}
const Kn = new Yvt(() => !1), Xvt = Kn.isEqual.bind(Kn);
Kn.isEqualOrParent.bind(Kn);
Kn.getComparisonKey.bind(Kn);
Kn.basenameOrAuthority.bind(Kn);
const qO = Kn.basename.bind(Kn);
Kn.extname.bind(Kn);
const Jvt = Kn.dirname.bind(Kn);
Kn.joinPath.bind(Kn);
const $vt = Kn.normalizePath.bind(Kn);
Kn.relativePath.bind(Kn);
const Z6e = Kn.resolvePath.bind(Kn);
Kn.isAbsolutePath.bind(Kn);
const U6e = Kn.isEqualAuthority.bind(Kn), q6e = Kn.hasTrailingPathSeparator.bind(Kn);
Kn.removeTrailingPathSeparator.bind(Kn);
Kn.addTrailingPathSeparator.bind(Kn);
var A9;
(function(r) {
  r.META_DATA_LABEL = "label", r.META_DATA_DESCRIPTION = "description", r.META_DATA_SIZE = "size", r.META_DATA_MIME = "mime";
  function e(t) {
    const n = /* @__PURE__ */ new Map();
    t.path.substring(t.path.indexOf(";") + 1, t.path.lastIndexOf(";")).split(";").forEach((o) => {
      const [a, l] = o.split(":");
      a && l && n.set(a, l);
    });
    const s = t.path.substring(0, t.path.indexOf(";"));
    return s && n.set(r.META_DATA_MIME, s), n;
  }
  r.parseMetaData = e;
})(A9 || (A9 = {}));
function M2(r) {
  return r.toString();
}
class Gi {
  static create(e, t) {
    const n = e.getAlternativeVersionId(), i = ML(e);
    return new Gi(n, n, i, i, t, t, []);
  }
  constructor(e, t, n, i, s, o, a) {
    this.beforeVersionId = e, this.afterVersionId = t, this.beforeEOL = n, this.afterEOL = i, this.beforeCursorState = s, this.afterCursorState = o, this.changes = a;
  }
  append(e, t, n, i, s) {
    t.length > 0 && (this.changes = Gvt(this.changes, t)), this.afterEOL = n, this.afterVersionId = i, this.afterCursorState = s;
  }
  static _writeSelectionsSize(e) {
    return 4 + 4 * 4 * (e ? e.length : 0);
  }
  static _writeSelections(e, t, n) {
    if (Ol(e, t ? t.length : 0, n), n += 4, t)
      for (const i of t)
        Ol(e, i.selectionStartLineNumber, n), n += 4, Ol(e, i.selectionStartColumn, n), n += 4, Ol(e, i.positionLineNumber, n), n += 4, Ol(e, i.positionColumn, n), n += 4;
    return n;
  }
  static _readSelections(e, t, n) {
    const i = Il(e, t);
    t += 4;
    for (let s = 0; s < i; s++) {
      const o = Il(e, t);
      t += 4;
      const a = Il(e, t);
      t += 4;
      const l = Il(e, t);
      t += 4;
      const c = Il(e, t);
      t += 4, n.push(new _n(o, a, l, c));
    }
    return t;
  }
  serialize() {
    let e = 10 + Gi._writeSelectionsSize(this.beforeCursorState) + Gi._writeSelectionsSize(this.afterCursorState) + 4;
    for (const i of this.changes)
      e += i.writeSize();
    const t = new Uint8Array(e);
    let n = 0;
    Ol(t, this.beforeVersionId, n), n += 4, Ol(t, this.afterVersionId, n), n += 4, a5e(t, this.beforeEOL, n), n += 1, a5e(t, this.afterEOL, n), n += 1, n = Gi._writeSelections(t, this.beforeCursorState, n), n = Gi._writeSelections(t, this.afterCursorState, n), Ol(t, this.changes.length, n), n += 4;
    for (const i of this.changes)
      n = i.write(t, n);
    return t.buffer;
  }
  static deserialize(e) {
    const t = new Uint8Array(e);
    let n = 0;
    const i = Il(t, n);
    n += 4;
    const s = Il(t, n);
    n += 4;
    const o = o5e(t, n);
    n += 1;
    const a = o5e(t, n);
    n += 1;
    const l = [];
    n = Gi._readSelections(t, n, l);
    const c = [];
    n = Gi._readSelections(t, n, c);
    const d = Il(t, n);
    n += 4;
    const u = [];
    for (let f = 0; f < d; f++)
      n = Dr.read(t, n, u);
    return new Gi(i, s, o, a, l, c, u);
  }
}
class Nke {
  get type() {
    return 0;
  }
  get resource() {
    return Pt.isUri(this.model) ? this.model : this.model.uri;
  }
  constructor(e, t, n, i) {
    this.label = e, this.code = t, this.model = n, this._data = Gi.create(n, i);
  }
  toString() {
    return (this._data instanceof Gi ? this._data : Gi.deserialize(this._data)).changes.map((t) => t.toString()).join(", ");
  }
  matchesResource(e) {
    return (Pt.isUri(this.model) ? this.model : this.model.uri).toString() === e.toString();
  }
  setModel(e) {
    this.model = e;
  }
  canAppend(e) {
    return this.model === e && this._data instanceof Gi;
  }
  append(e, t, n, i, s) {
    this._data instanceof Gi && this._data.append(e, t, n, i, s);
  }
  close() {
    this._data instanceof Gi && (this._data = this._data.serialize());
  }
  open() {
    this._data instanceof Gi || (this._data = Gi.deserialize(this._data));
  }
  undo() {
    if (Pt.isUri(this.model))
      throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof Gi && (this._data = this._data.serialize());
    const e = Gi.deserialize(this._data);
    this.model._applyUndo(e.changes, e.beforeEOL, e.beforeVersionId, e.beforeCursorState);
  }
  redo() {
    if (Pt.isUri(this.model))
      throw new Error("Invalid SingleModelEditStackElement");
    this._data instanceof Gi && (this._data = this._data.serialize());
    const e = Gi.deserialize(this._data);
    this.model._applyRedo(e.changes, e.afterEOL, e.afterVersionId, e.afterCursorState);
  }
  heapSize() {
    return this._data instanceof Gi && (this._data = this._data.serialize()), this._data.byteLength + 168;
  }
}
class e5t {
  get resources() {
    return this._editStackElementsArr.map((e) => e.resource);
  }
  constructor(e, t, n) {
    this.label = e, this.code = t, this.type = 1, this._isOpen = !0, this._editStackElementsArr = n.slice(0), this._editStackElementsMap = /* @__PURE__ */ new Map();
    for (const i of this._editStackElementsArr) {
      const s = M2(i.resource);
      this._editStackElementsMap.set(s, i);
    }
    this._delegate = null;
  }
  prepareUndoRedo() {
    if (this._delegate)
      return this._delegate.prepareUndoRedo(this);
  }
  matchesResource(e) {
    const t = M2(e);
    return this._editStackElementsMap.has(t);
  }
  setModel(e) {
    const t = M2(Pt.isUri(e) ? e : e.uri);
    this._editStackElementsMap.has(t) && this._editStackElementsMap.get(t).setModel(e);
  }
  canAppend(e) {
    if (!this._isOpen)
      return !1;
    const t = M2(e.uri);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).canAppend(e) : !1;
  }
  append(e, t, n, i, s) {
    const o = M2(e.uri);
    this._editStackElementsMap.get(o).append(e, t, n, i, s);
  }
  close() {
    this._isOpen = !1;
  }
  open() {
  }
  undo() {
    this._isOpen = !1;
    for (const e of this._editStackElementsArr)
      e.undo();
  }
  redo() {
    for (const e of this._editStackElementsArr)
      e.redo();
  }
  heapSize(e) {
    const t = M2(e);
    return this._editStackElementsMap.has(t) ? this._editStackElementsMap.get(t).heapSize() : 0;
  }
  split() {
    return this._editStackElementsArr;
  }
  toString() {
    const e = [];
    for (const t of this._editStackElementsArr)
      e.push(`${qO(t.resource)}: ${t}`);
    return `{${e.join(", ")}}`;
  }
}
function ML(r) {
  return r.getEOL() === `
` ? 0 : 1;
}
function $h(r) {
  return r ? r instanceof Nke || r instanceof e5t : !1;
}
class GO {
  constructor(e, t) {
    this._model = e, this._undoRedoService = t;
  }
  pushStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    $h(e) && e.close();
  }
  popStackElement() {
    const e = this._undoRedoService.getLastElement(this._model.uri);
    $h(e) && e.open();
  }
  clear() {
    this._undoRedoService.removeElements(this._model.uri);
  }
  _getOrCreateEditStackElement(e, t) {
    const n = this._undoRedoService.getLastElement(this._model.uri);
    if ($h(n) && n.canAppend(this._model))
      return n;
    const i = new Nke(C("edit", "Typing"), "undoredo.textBufferEdit", this._model, e);
    return this._undoRedoService.pushElement(i, t), i;
  }
  pushEOL(e) {
    const t = this._getOrCreateEditStackElement(null, void 0);
    this._model.setEOL(e), t.append(this._model, [], ML(this._model), this._model.getAlternativeVersionId(), null);
  }
  pushEditOperation(e, t, n, i) {
    const s = this._getOrCreateEditStackElement(e, i), o = this._model.applyEdits(t, !0), a = GO._computeCursorState(n, o), l = o.map((c, d) => ({ index: d, textChange: c.textChange }));
    return l.sort((c, d) => c.textChange.oldPosition === d.textChange.oldPosition ? c.index - d.index : c.textChange.oldPosition - d.textChange.oldPosition), s.append(this._model, l.map((c) => c.textChange), ML(this._model), this._model.getAlternativeVersionId(), a), a;
  }
  static _computeCursorState(e, t) {
    try {
      return e ? e(t) : null;
    } catch (n) {
      return wn(n), null;
    }
  }
}
class t5t {
  constructor() {
    this.spacesDiff = 0, this.looksLikeAlignment = !1;
  }
}
function n5t(r, e, t, n, i) {
  i.spacesDiff = 0, i.looksLikeAlignment = !1;
  let s;
  for (s = 0; s < e && s < n; s++) {
    const f = r.charCodeAt(s), p = t.charCodeAt(s);
    if (f !== p)
      break;
  }
  let o = 0, a = 0;
  for (let f = s; f < e; f++)
    r.charCodeAt(f) === 32 ? o++ : a++;
  let l = 0, c = 0;
  for (let f = s; f < n; f++)
    t.charCodeAt(f) === 32 ? l++ : c++;
  if (o > 0 && a > 0 || l > 0 && c > 0)
    return;
  const d = Math.abs(a - c), u = Math.abs(o - l);
  if (d === 0) {
    i.spacesDiff = u, u > 0 && 0 <= l - 1 && l - 1 < r.length && l < t.length && t.charCodeAt(l) !== 32 && r.charCodeAt(l - 1) === 32 && r.charCodeAt(r.length - 1) === 44 && (i.looksLikeAlignment = !0);
    return;
  }
  if (u % d === 0) {
    i.spacesDiff = u / d;
    return;
  }
}
function G6e(r, e, t) {
  const n = Math.min(r.getLineCount(), 1e4);
  let i = 0, s = 0, o = "", a = 0;
  const l = [2, 4, 6, 8, 3, 5, 7], c = 8, d = [0, 0, 0, 0, 0, 0, 0, 0, 0], u = new t5t();
  for (let g = 1; g <= n; g++) {
    const m = r.getLineLength(g), A = r.getLineContent(g), w = m <= 65536;
    let v = !1, y = 0, _ = 0, S = 0;
    for (let M = 0, L = m; M < L; M++) {
      const T = w ? A.charCodeAt(M) : r.getLineCharCode(g, M);
      if (T === 9)
        S++;
      else if (T === 32)
        _++;
      else {
        v = !0, y = M;
        break;
      }
    }
    if (!v || (S > 0 ? i++ : _ > 1 && s++, n5t(o, a, A, y, u), u.looksLikeAlignment && !(t && e === u.spacesDiff)))
      continue;
    const D = u.spacesDiff;
    D <= c && d[D]++, o = A, a = y;
  }
  let f = t;
  i !== s && (f = i < s);
  let p = e;
  if (f) {
    let g = f ? 0 : 0.1 * n;
    l.forEach((m) => {
      const A = d[m];
      A > g && (g = A, p = m);
    }), p === 4 && d[4] > 0 && d[2] > 0 && d[2] >= d[4] / 2 && (p = 2);
  }
  return {
    insertSpaces: f,
    tabSize: p
  };
}
function Ls(r) {
  return (r.metadata & 1) >>> 0;
}
function Bn(r, e) {
  r.metadata = r.metadata & 254 | e << 0;
}
function Tr(r) {
  return (r.metadata & 2) >>> 1 === 1;
}
function Tn(r, e) {
  r.metadata = r.metadata & 253 | (e ? 1 : 0) << 1;
}
function Tke(r) {
  return (r.metadata & 4) >>> 2 === 1;
}
function Q6e(r, e) {
  r.metadata = r.metadata & 251 | (e ? 1 : 0) << 2;
}
function Ike(r) {
  return (r.metadata & 64) >>> 6 === 1;
}
function K6e(r, e) {
  r.metadata = r.metadata & 191 | (e ? 1 : 0) << 6;
}
function i5t(r) {
  return (r.metadata & 24) >>> 3;
}
function Y6e(r, e) {
  r.metadata = r.metadata & 231 | e << 3;
}
function r5t(r) {
  return (r.metadata & 32) >>> 5 === 1;
}
function X6e(r, e) {
  r.metadata = r.metadata & 223 | (e ? 1 : 0) << 5;
}
class Oke {
  constructor(e, t, n) {
    this.metadata = 0, this.parent = this, this.left = this, this.right = this, Bn(
      this,
      1
      /* NodeColor.Red */
    ), this.start = t, this.end = n, this.delta = 0, this.maxEnd = n, this.id = e, this.ownerId = 0, this.options = null, Q6e(this, !1), K6e(this, !1), Y6e(
      this,
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    ), X6e(this, !1), this.cachedVersionId = 0, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = null, Tn(this, !1);
  }
  reset(e, t, n, i) {
    this.start = t, this.end = n, this.maxEnd = n, this.cachedVersionId = e, this.cachedAbsoluteStart = t, this.cachedAbsoluteEnd = n, this.range = i;
  }
  setOptions(e) {
    this.options = e;
    const t = this.options.className;
    Q6e(this, t === "squiggly-error" || t === "squiggly-warning" || t === "squiggly-info"), K6e(this, this.options.glyphMarginClassName !== null), Y6e(this, this.options.stickiness), X6e(this, this.options.collapseOnReplaceEdit);
  }
  setCachedOffsets(e, t, n) {
    this.cachedVersionId !== n && (this.range = null), this.cachedVersionId = n, this.cachedAbsoluteStart = e, this.cachedAbsoluteEnd = t;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
}
const vt = new Oke(null, 0, 0);
vt.parent = vt;
vt.left = vt;
vt.right = vt;
Bn(
  vt,
  0
  /* NodeColor.Black */
);
class n_ {
  constructor() {
    this.root = vt, this.requestNormalizeDelta = !1;
  }
  intervalSearch(e, t, n, i, s, o) {
    return this.root === vt ? [] : u5t(this, e, t, n, i, s, o);
  }
  search(e, t, n, i) {
    return this.root === vt ? [] : d5t(this, e, t, n, i);
  }
  /**
   * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
   */
  collectNodesFromOwner(e) {
    return c5t(this, e);
  }
  /**
   * Will not set `cachedAbsoluteStart` nor `cachedAbsoluteEnd` on the returned nodes!
   */
  collectNodesPostOrder() {
    return h5t(this);
  }
  insert(e) {
    J6e(this, e), this._normalizeDeltaIfNecessary();
  }
  delete(e) {
    $6e(this, e), this._normalizeDeltaIfNecessary();
  }
  resolveNode(e, t) {
    const n = e;
    let i = 0;
    for (; e !== this.root; )
      e === e.parent.right && (i += e.parent.delta), e = e.parent;
    const s = n.start + i, o = n.end + i;
    n.setCachedOffsets(s, o, t);
  }
  acceptReplace(e, t, n, i) {
    const s = a5t(this, e, e + t);
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      $6e(this, l);
    }
    this._normalizeDeltaIfNecessary(), l5t(this, e, e + t, n), this._normalizeDeltaIfNecessary();
    for (let o = 0, a = s.length; o < a; o++) {
      const l = s[o];
      l.start = l.cachedAbsoluteStart, l.end = l.cachedAbsoluteEnd, o5t(l, e, e + t, n, i), l.maxEnd = l.end, J6e(this, l);
    }
    this._normalizeDeltaIfNecessary();
  }
  _normalizeDeltaIfNecessary() {
    this.requestNormalizeDelta && (this.requestNormalizeDelta = !1, s5t(this));
  }
}
function s5t(r) {
  let e = r.root, t = 0;
  for (; e !== vt; ) {
    if (e.left !== vt && !Tr(e.left)) {
      e = e.left;
      continue;
    }
    if (e.right !== vt && !Tr(e.right)) {
      t += e.delta, e = e.right;
      continue;
    }
    e.start = t + e.start, e.end = t + e.end, e.delta = 0, p1(e), Tn(e, !0), Tn(e.left, !1), Tn(e.right, !1), e === e.parent.right && (t -= e.parent.delta), e = e.parent;
  }
  Tn(r.root, !1);
}
function D2(r, e, t, n) {
  return r < t ? !0 : r > t || n === 1 ? !1 : n === 2 ? !0 : e;
}
function o5t(r, e, t, n, i) {
  const s = i5t(r), o = s === 0 || s === 2, a = s === 1 || s === 2, l = t - e, c = n, d = Math.min(l, c), u = r.start;
  let f = !1;
  const p = r.end;
  let g = !1;
  e <= u && p <= t && r5t(r) && (r.start = e, f = !0, r.end = e, g = !0);
  {
    const A = i ? 1 : l > 0 ? 2 : 0;
    !f && D2(u, o, e, A) && (f = !0), !g && D2(p, a, e, A) && (g = !0);
  }
  if (d > 0 && !i) {
    const A = l > c ? 2 : 0;
    !f && D2(u, o, e + d, A) && (f = !0), !g && D2(p, a, e + d, A) && (g = !0);
  }
  {
    const A = i ? 1 : 0;
    !f && D2(u, o, t, A) && (r.start = e + c, f = !0), !g && D2(p, a, t, A) && (r.end = e + c, g = !0);
  }
  const m = c - l;
  f || (r.start = Math.max(0, u + m)), g || (r.end = Math.max(0, p + m)), r.start > r.end && (r.end = r.start);
}
function a5t(r, e, t) {
  let n = r.root, i = 0, s = 0, o = 0, a = 0;
  const l = [];
  let c = 0;
  for (; n !== vt; ) {
    if (Tr(n)) {
      Tn(n.left, !1), Tn(n.right, !1), n === n.parent.right && (i -= n.parent.delta), n = n.parent;
      continue;
    }
    if (!Tr(n.left)) {
      if (s = i + n.maxEnd, s < e) {
        Tn(n, !0);
        continue;
      }
      if (n.left !== vt) {
        n = n.left;
        continue;
      }
    }
    if (o = i + n.start, o > t) {
      Tn(n, !0);
      continue;
    }
    if (a = i + n.end, a >= e && (n.setCachedOffsets(o, a, 0), l[c++] = n), Tn(n, !0), n.right !== vt && !Tr(n.right)) {
      i += n.delta, n = n.right;
      continue;
    }
  }
  return Tn(r.root, !1), l;
}
function l5t(r, e, t, n) {
  let i = r.root, s = 0, o = 0, a = 0;
  const l = n - (t - e);
  for (; i !== vt; ) {
    if (Tr(i)) {
      Tn(i.left, !1), Tn(i.right, !1), i === i.parent.right && (s -= i.parent.delta), p1(i), i = i.parent;
      continue;
    }
    if (!Tr(i.left)) {
      if (o = s + i.maxEnd, o < e) {
        Tn(i, !0);
        continue;
      }
      if (i.left !== vt) {
        i = i.left;
        continue;
      }
    }
    if (a = s + i.start, a > t) {
      i.start += l, i.end += l, i.delta += l, (i.delta < -1073741824 || i.delta > 1073741824) && (r.requestNormalizeDelta = !0), Tn(i, !0);
      continue;
    }
    if (Tn(i, !0), i.right !== vt && !Tr(i.right)) {
      s += i.delta, i = i.right;
      continue;
    }
  }
  Tn(r.root, !1);
}
function c5t(r, e) {
  let t = r.root;
  const n = [];
  let i = 0;
  for (; t !== vt; ) {
    if (Tr(t)) {
      Tn(t.left, !1), Tn(t.right, !1), t = t.parent;
      continue;
    }
    if (t.left !== vt && !Tr(t.left)) {
      t = t.left;
      continue;
    }
    if (t.ownerId === e && (n[i++] = t), Tn(t, !0), t.right !== vt && !Tr(t.right)) {
      t = t.right;
      continue;
    }
  }
  return Tn(r.root, !1), n;
}
function h5t(r) {
  let e = r.root;
  const t = [];
  let n = 0;
  for (; e !== vt; ) {
    if (Tr(e)) {
      Tn(e.left, !1), Tn(e.right, !1), e = e.parent;
      continue;
    }
    if (e.left !== vt && !Tr(e.left)) {
      e = e.left;
      continue;
    }
    if (e.right !== vt && !Tr(e.right)) {
      e = e.right;
      continue;
    }
    t[n++] = e, Tn(e, !0);
  }
  return Tn(r.root, !1), t;
}
function d5t(r, e, t, n, i) {
  let s = r.root, o = 0, a = 0, l = 0;
  const c = [];
  let d = 0;
  for (; s !== vt; ) {
    if (Tr(s)) {
      Tn(s.left, !1), Tn(s.right, !1), s === s.parent.right && (o -= s.parent.delta), s = s.parent;
      continue;
    }
    if (s.left !== vt && !Tr(s.left)) {
      s = s.left;
      continue;
    }
    a = o + s.start, l = o + s.end, s.setCachedOffsets(a, l, n);
    let u = !0;
    if (e && s.ownerId && s.ownerId !== e && (u = !1), t && Tke(s) && (u = !1), i && !Ike(s) && (u = !1), u && (c[d++] = s), Tn(s, !0), s.right !== vt && !Tr(s.right)) {
      o += s.delta, s = s.right;
      continue;
    }
  }
  return Tn(r.root, !1), c;
}
function u5t(r, e, t, n, i, s, o) {
  let a = r.root, l = 0, c = 0, d = 0, u = 0;
  const f = [];
  let p = 0;
  for (; a !== vt; ) {
    if (Tr(a)) {
      Tn(a.left, !1), Tn(a.right, !1), a === a.parent.right && (l -= a.parent.delta), a = a.parent;
      continue;
    }
    if (!Tr(a.left)) {
      if (c = l + a.maxEnd, c < e) {
        Tn(a, !0);
        continue;
      }
      if (a.left !== vt) {
        a = a.left;
        continue;
      }
    }
    if (d = l + a.start, d > t) {
      Tn(a, !0);
      continue;
    }
    if (u = l + a.end, u >= e) {
      a.setCachedOffsets(d, u, s);
      let g = !0;
      n && a.ownerId && a.ownerId !== n && (g = !1), i && Tke(a) && (g = !1), o && !Ike(a) && (g = !1), g && (f[p++] = a);
    }
    if (Tn(a, !0), a.right !== vt && !Tr(a.right)) {
      l += a.delta, a = a.right;
      continue;
    }
  }
  return Tn(r.root, !1), f;
}
function J6e(r, e) {
  if (r.root === vt)
    return e.parent = vt, e.left = vt, e.right = vt, Bn(
      e,
      0
      /* NodeColor.Black */
    ), r.root = e, r.root;
  f5t(r, e), fu(e.parent);
  let t = e;
  for (; t !== r.root && Ls(t.parent) === 1; )
    if (t.parent === t.parent.parent.left) {
      const n = t.parent.parent.right;
      Ls(n) === 1 ? (Bn(
        t.parent,
        0
        /* NodeColor.Black */
      ), Bn(
        n,
        0
        /* NodeColor.Black */
      ), Bn(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), t = t.parent.parent) : (t === t.parent.right && (t = t.parent, KA(r, t)), Bn(
        t.parent,
        0
        /* NodeColor.Black */
      ), Bn(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), YA(r, t.parent.parent));
    } else {
      const n = t.parent.parent.left;
      Ls(n) === 1 ? (Bn(
        t.parent,
        0
        /* NodeColor.Black */
      ), Bn(
        n,
        0
        /* NodeColor.Black */
      ), Bn(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), t = t.parent.parent) : (t === t.parent.left && (t = t.parent, YA(r, t)), Bn(
        t.parent,
        0
        /* NodeColor.Black */
      ), Bn(
        t.parent.parent,
        1
        /* NodeColor.Red */
      ), KA(r, t.parent.parent));
    }
  return Bn(
    r.root,
    0
    /* NodeColor.Black */
  ), e;
}
function f5t(r, e) {
  let t = 0, n = r.root;
  const i = e.start, s = e.end;
  for (; ; )
    if (g5t(i, s, n.start + t, n.end + t) < 0)
      if (n.left === vt) {
        e.start -= t, e.end -= t, e.maxEnd -= t, n.left = e;
        break;
      } else
        n = n.left;
    else if (n.right === vt) {
      e.start -= t + n.delta, e.end -= t + n.delta, e.maxEnd -= t + n.delta, n.right = e;
      break;
    } else
      t += n.delta, n = n.right;
  e.parent = n, e.left = vt, e.right = vt, Bn(
    e,
    1
    /* NodeColor.Red */
  );
}
function $6e(r, e) {
  let t, n;
  if (e.left === vt ? (t = e.right, n = e, t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (r.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta) : e.right === vt ? (t = e.left, n = e) : (n = p5t(e.right), t = n.right, t.start += n.delta, t.end += n.delta, t.delta += n.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (r.requestNormalizeDelta = !0), n.start += e.delta, n.end += e.delta, n.delta = e.delta, (n.delta < -1073741824 || n.delta > 1073741824) && (r.requestNormalizeDelta = !0)), n === r.root) {
    r.root = t, Bn(
      t,
      0
      /* NodeColor.Black */
    ), e.detach(), i_(), p1(t), r.root.parent = vt;
    return;
  }
  const i = Ls(n) === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? t.parent = n.parent : (n.parent === e ? t.parent = n : t.parent = n.parent, n.left = e.left, n.right = e.right, n.parent = e.parent, Bn(n, Ls(e)), e === r.root ? r.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== vt && (n.left.parent = n), n.right !== vt && (n.right.parent = n)), e.detach(), i) {
    fu(t.parent), n !== e && (fu(n), fu(n.parent)), i_();
    return;
  }
  fu(t), fu(t.parent), n !== e && (fu(n), fu(n.parent));
  let s;
  for (; t !== r.root && Ls(t) === 0; )
    t === t.parent.left ? (s = t.parent.right, Ls(s) === 1 && (Bn(
      s,
      0
      /* NodeColor.Black */
    ), Bn(
      t.parent,
      1
      /* NodeColor.Red */
    ), KA(r, t.parent), s = t.parent.right), Ls(s.left) === 0 && Ls(s.right) === 0 ? (Bn(
      s,
      1
      /* NodeColor.Red */
    ), t = t.parent) : (Ls(s.right) === 0 && (Bn(
      s.left,
      0
      /* NodeColor.Black */
    ), Bn(
      s,
      1
      /* NodeColor.Red */
    ), YA(r, s), s = t.parent.right), Bn(s, Ls(t.parent)), Bn(
      t.parent,
      0
      /* NodeColor.Black */
    ), Bn(
      s.right,
      0
      /* NodeColor.Black */
    ), KA(r, t.parent), t = r.root)) : (s = t.parent.left, Ls(s) === 1 && (Bn(
      s,
      0
      /* NodeColor.Black */
    ), Bn(
      t.parent,
      1
      /* NodeColor.Red */
    ), YA(r, t.parent), s = t.parent.left), Ls(s.left) === 0 && Ls(s.right) === 0 ? (Bn(
      s,
      1
      /* NodeColor.Red */
    ), t = t.parent) : (Ls(s.left) === 0 && (Bn(
      s.right,
      0
      /* NodeColor.Black */
    ), Bn(
      s,
      1
      /* NodeColor.Red */
    ), KA(r, s), s = t.parent.left), Bn(s, Ls(t.parent)), Bn(
      t.parent,
      0
      /* NodeColor.Black */
    ), Bn(
      s.left,
      0
      /* NodeColor.Black */
    ), YA(r, t.parent), t = r.root));
  Bn(
    t,
    0
    /* NodeColor.Black */
  ), i_();
}
function p5t(r) {
  for (; r.left !== vt; )
    r = r.left;
  return r;
}
function i_() {
  vt.parent = vt, vt.delta = 0, vt.start = 0, vt.end = 0;
}
function KA(r, e) {
  const t = e.right;
  t.delta += e.delta, (t.delta < -1073741824 || t.delta > 1073741824) && (r.requestNormalizeDelta = !0), t.start += e.delta, t.end += e.delta, e.right = t.left, t.left !== vt && (t.left.parent = e), t.parent = e.parent, e.parent === vt ? r.root = t : e === e.parent.left ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t, p1(e), p1(t);
}
function YA(r, e) {
  const t = e.left;
  e.delta -= t.delta, (e.delta < -1073741824 || e.delta > 1073741824) && (r.requestNormalizeDelta = !0), e.start -= t.delta, e.end -= t.delta, e.left = t.right, t.right !== vt && (t.right.parent = e), t.parent = e.parent, e.parent === vt ? r.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t, p1(e), p1(t);
}
function Rke(r) {
  let e = r.end;
  if (r.left !== vt) {
    const t = r.left.maxEnd;
    t > e && (e = t);
  }
  if (r.right !== vt) {
    const t = r.right.maxEnd + r.delta;
    t > e && (e = t);
  }
  return e;
}
function p1(r) {
  r.maxEnd = Rke(r);
}
function fu(r) {
  for (; r !== vt; ) {
    const e = Rke(r);
    if (r.maxEnd === e)
      return;
    r.maxEnd = e, r = r.parent;
  }
}
function g5t(r, e, t, n) {
  return r === t ? e - n : r - t;
}
let DL = class {
  constructor(e, t) {
    this.piece = e, this.color = t, this.size_left = 0, this.lf_left = 0, this.parent = this, this.left = this, this.right = this;
  }
  next() {
    if (this.right !== at)
      return QO(this.right);
    let e = this;
    for (; e.parent !== at && e.parent.left !== e; )
      e = e.parent;
    return e.parent === at ? at : e.parent;
  }
  prev() {
    if (this.left !== at)
      return Vke(this.left);
    let e = this;
    for (; e.parent !== at && e.parent.right !== e; )
      e = e.parent;
    return e.parent === at ? at : e.parent;
  }
  detach() {
    this.parent = null, this.left = null, this.right = null;
  }
};
const at = new DL(
  null,
  0
  /* NodeColor.Black */
);
at.parent = at;
at.left = at;
at.right = at;
at.color = 0;
function QO(r) {
  for (; r.left !== at; )
    r = r.left;
  return r;
}
function Vke(r) {
  for (; r.right !== at; )
    r = r.right;
  return r;
}
function KO(r) {
  return r === at ? 0 : r.size_left + r.piece.length + KO(r.right);
}
function YO(r) {
  return r === at ? 0 : r.lf_left + r.piece.lineFeedCnt + YO(r.right);
}
function r_() {
  at.parent = at;
}
function XA(r, e) {
  const t = e.right;
  t.size_left += e.size_left + (e.piece ? e.piece.length : 0), t.lf_left += e.lf_left + (e.piece ? e.piece.lineFeedCnt : 0), e.right = t.left, t.left !== at && (t.left.parent = e), t.parent = e.parent, e.parent === at ? r.root = t : e.parent.left === e ? e.parent.left = t : e.parent.right = t, t.left = e, e.parent = t;
}
function JA(r, e) {
  const t = e.left;
  e.left = t.right, t.right !== at && (t.right.parent = e), t.parent = e.parent, e.size_left -= t.size_left + (t.piece ? t.piece.length : 0), e.lf_left -= t.lf_left + (t.piece ? t.piece.lineFeedCnt : 0), e.parent === at ? r.root = t : e === e.parent.right ? e.parent.right = t : e.parent.left = t, t.right = e, e.parent = t;
}
function zv(r, e) {
  let t, n;
  if (e.left === at ? (n = e, t = n.right) : e.right === at ? (n = e, t = n.left) : (n = QO(e.right), t = n.right), n === r.root) {
    r.root = t, t.color = 0, e.detach(), r_(), r.root.parent = at;
    return;
  }
  const i = n.color === 1;
  if (n === n.parent.left ? n.parent.left = t : n.parent.right = t, n === e ? (t.parent = n.parent, AA(r, t)) : (n.parent === e ? t.parent = n : t.parent = n.parent, AA(r, t), n.left = e.left, n.right = e.right, n.parent = e.parent, n.color = e.color, e === r.root ? r.root = n : e === e.parent.left ? e.parent.left = n : e.parent.right = n, n.left !== at && (n.left.parent = n), n.right !== at && (n.right.parent = n), n.size_left = e.size_left, n.lf_left = e.lf_left, AA(r, n)), e.detach(), t.parent.left === t) {
    const o = KO(t), a = YO(t);
    if (o !== t.parent.size_left || a !== t.parent.lf_left) {
      const l = o - t.parent.size_left, c = a - t.parent.lf_left;
      t.parent.size_left = o, t.parent.lf_left = a, Uh(r, t.parent, l, c);
    }
  }
  if (AA(r, t.parent), i) {
    r_();
    return;
  }
  let s;
  for (; t !== r.root && t.color === 0; )
    t === t.parent.left ? (s = t.parent.right, s.color === 1 && (s.color = 0, t.parent.color = 1, XA(r, t.parent), s = t.parent.right), s.left.color === 0 && s.right.color === 0 ? (s.color = 1, t = t.parent) : (s.right.color === 0 && (s.left.color = 0, s.color = 1, JA(r, s), s = t.parent.right), s.color = t.parent.color, t.parent.color = 0, s.right.color = 0, XA(r, t.parent), t = r.root)) : (s = t.parent.left, s.color === 1 && (s.color = 0, t.parent.color = 1, JA(r, t.parent), s = t.parent.left), s.left.color === 0 && s.right.color === 0 ? (s.color = 1, t = t.parent) : (s.left.color === 0 && (s.right.color = 0, s.color = 1, XA(r, s), s = t.parent.left), s.color = t.parent.color, t.parent.color = 0, s.left.color = 0, JA(r, t.parent), t = r.root));
  t.color = 0, r_();
}
function e8e(r, e) {
  for (AA(r, e); e !== r.root && e.parent.color === 1; )
    if (e.parent === e.parent.parent.left) {
      const t = e.parent.parent.right;
      t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.right && (e = e.parent, XA(r, e)), e.parent.color = 0, e.parent.parent.color = 1, JA(r, e.parent.parent));
    } else {
      const t = e.parent.parent.left;
      t.color === 1 ? (e.parent.color = 0, t.color = 0, e.parent.parent.color = 1, e = e.parent.parent) : (e === e.parent.left && (e = e.parent, JA(r, e)), e.parent.color = 0, e.parent.parent.color = 1, XA(r, e.parent.parent));
    }
  r.root.color = 0;
}
function Uh(r, e, t, n) {
  for (; e !== r.root && e !== at; )
    e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
}
function AA(r, e) {
  let t = 0, n = 0;
  if (e !== r.root) {
    for (; e !== r.root && e === e.parent.right; )
      e = e.parent;
    if (e !== r.root)
      for (e = e.parent, t = KO(e.left) - e.size_left, n = YO(e.left) - e.lf_left, e.size_left += t, e.lf_left += n; e !== r.root && (t !== 0 || n !== 0); )
        e.parent.left === e && (e.parent.size_left += t, e.parent.lf_left += n), e = e.parent;
  }
}
const Hh = 65535;
function Hke(r) {
  let e;
  return r[r.length - 1] < 65536 ? e = new Uint16Array(r.length) : e = new Uint32Array(r.length), e.set(r, 0), e;
}
class m5t {
  constructor(e, t, n, i, s) {
    this.lineStarts = e, this.cr = t, this.lf = n, this.crlf = i, this.isBasicASCII = s;
  }
}
function Qh(r, e = !0) {
  const t = [0];
  let n = 1;
  for (let i = 0, s = r.length; i < s; i++) {
    const o = r.charCodeAt(i);
    o === 13 ? i + 1 < s && r.charCodeAt(i + 1) === 10 ? (t[n++] = i + 2, i++) : t[n++] = i + 1 : o === 10 && (t[n++] = i + 1);
  }
  return e ? Hke(t) : t;
}
function A5t(r, e) {
  r.length = 0, r[0] = 0;
  let t = 1, n = 0, i = 0, s = 0, o = !0;
  for (let l = 0, c = e.length; l < c; l++) {
    const d = e.charCodeAt(l);
    d === 13 ? l + 1 < c && e.charCodeAt(l + 1) === 10 ? (s++, r[t++] = l + 2, l++) : (n++, r[t++] = l + 1) : d === 10 ? (i++, r[t++] = l + 1) : o && d !== 9 && (d < 32 || d > 126) && (o = !1);
  }
  const a = new m5t(Hke(r), n, i, s, o);
  return r.length = 0, a;
}
class Qs {
  constructor(e, t, n, i, s) {
    this.bufferIndex = e, this.start = t, this.end = n, this.lineFeedCnt = i, this.length = s;
  }
}
class E0 {
  constructor(e, t) {
    this.buffer = e, this.lineStarts = t;
  }
}
class w5t {
  constructor(e, t) {
    this._pieces = [], this._tree = e, this._BOM = t, this._index = 0, e.root !== at && e.iterate(e.root, (n) => (n !== at && this._pieces.push(n.piece), !0));
  }
  read() {
    return this._pieces.length === 0 ? this._index === 0 ? (this._index++, this._BOM) : null : this._index > this._pieces.length - 1 ? null : this._index === 0 ? this._BOM + this._tree.getPieceContent(this._pieces[this._index++]) : this._tree.getPieceContent(this._pieces[this._index++]);
  }
}
class v5t {
  constructor(e) {
    this._limit = e, this._cache = [];
  }
  get(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartOffset <= e && n.nodeStartOffset + n.node.piece.length >= e)
        return n;
    }
    return null;
  }
  get2(e) {
    for (let t = this._cache.length - 1; t >= 0; t--) {
      const n = this._cache[t];
      if (n.nodeStartLineNumber && n.nodeStartLineNumber < e && n.nodeStartLineNumber + n.node.piece.lineFeedCnt >= e)
        return n;
    }
    return null;
  }
  set(e) {
    this._cache.length >= this._limit && this._cache.shift(), this._cache.push(e);
  }
  validate(e) {
    let t = !1;
    const n = this._cache;
    for (let i = 0; i < n.length; i++) {
      const s = n[i];
      if (s.node.parent === null || s.nodeStartOffset >= e) {
        n[i] = null, t = !0;
        continue;
      }
    }
    if (t) {
      const i = [];
      for (const s of n)
        s !== null && i.push(s);
      this._cache = i;
    }
  }
}
class b5t {
  constructor(e, t, n) {
    this.create(e, t, n);
  }
  create(e, t, n) {
    this._buffers = [
      new E0("", [0])
    ], this._lastChangeBufferPos = { line: 0, column: 0 }, this.root = at, this._lineCnt = 1, this._length = 0, this._EOL = t, this._EOLLength = t.length, this._EOLNormalized = n;
    let i = null;
    for (let s = 0, o = e.length; s < o; s++)
      if (e[s].buffer.length > 0) {
        e[s].lineStarts || (e[s].lineStarts = Qh(e[s].buffer));
        const a = new Qs(s + 1, { line: 0, column: 0 }, { line: e[s].lineStarts.length - 1, column: e[s].buffer.length - e[s].lineStarts[e[s].lineStarts.length - 1] }, e[s].lineStarts.length - 1, e[s].buffer.length);
        this._buffers.push(e[s]), i = this.rbInsertRight(i, a);
      }
    this._searchCache = new v5t(1), this._lastVisitedLine = { lineNumber: 0, value: "" }, this.computeBufferMetadata();
  }
  normalizeEOL(e) {
    const t = Hh, n = t - Math.floor(t / 3), i = n * 2;
    let s = "", o = 0;
    const a = [];
    if (this.iterate(this.root, (l) => {
      const c = this.getNodeContent(l), d = c.length;
      if (o <= n || o + d < i)
        return s += c, o += d, !0;
      const u = s.replace(/\r\n|\r|\n/g, e);
      return a.push(new E0(u, Qh(u))), s = c, o = d, !0;
    }), o > 0) {
      const l = s.replace(/\r\n|\r|\n/g, e);
      a.push(new E0(l, Qh(l)));
    }
    this.create(a, e, !0);
  }
  // #region Buffer API
  getEOL() {
    return this._EOL;
  }
  setEOL(e) {
    this._EOL = e, this._EOLLength = this._EOL.length, this.normalizeEOL(e);
  }
  createSnapshot(e) {
    return new w5t(this, e);
  }
  getOffsetAt(e, t) {
    let n = 0, i = this.root;
    for (; i !== at; )
      if (i.left !== at && i.lf_left + 1 >= e)
        i = i.left;
      else if (i.lf_left + i.piece.lineFeedCnt + 1 >= e) {
        n += i.size_left;
        const s = this.getAccumulatedValue(i, e - i.lf_left - 2);
        return n += s + t - 1;
      } else
        e -= i.lf_left + i.piece.lineFeedCnt, n += i.size_left + i.piece.length, i = i.right;
    return n;
  }
  getPositionAt(e) {
    e = Math.floor(e), e = Math.max(0, e);
    let t = this.root, n = 0;
    const i = e;
    for (; t !== at; )
      if (t.size_left !== 0 && t.size_left >= e)
        t = t.left;
      else if (t.size_left + t.piece.length >= e) {
        const s = this.getIndexOf(t, e - t.size_left);
        if (n += t.lf_left + s.index, s.index === 0) {
          const o = this.getOffsetAt(n + 1, 1), a = i - o;
          return new le(n + 1, a + 1);
        }
        return new le(n + 1, s.remainder + 1);
      } else if (e -= t.size_left + t.piece.length, n += t.lf_left + t.piece.lineFeedCnt, t.right === at) {
        const s = this.getOffsetAt(n + 1, 1), o = i - e - s;
        return new le(n + 1, o + 1);
      } else
        t = t.right;
    return new le(1, 1);
  }
  getValueInRange(e, t) {
    if (e.startLineNumber === e.endLineNumber && e.startColumn === e.endColumn)
      return "";
    const n = this.nodeAt2(e.startLineNumber, e.startColumn), i = this.nodeAt2(e.endLineNumber, e.endColumn), s = this.getValueInRange2(n, i);
    return t ? t !== this._EOL || !this._EOLNormalized ? s.replace(/\r\n|\r|\n/g, t) : t === this.getEOL() && this._EOLNormalized ? s : s.replace(/\r\n|\r|\n/g, t) : s;
  }
  getValueInRange2(e, t) {
    if (e.node === t.node) {
      const a = e.node, l = this._buffers[a.piece.bufferIndex].buffer, c = this.offsetInBuffer(a.piece.bufferIndex, a.piece.start);
      return l.substring(c + e.remainder, c + t.remainder);
    }
    let n = e.node;
    const i = this._buffers[n.piece.bufferIndex].buffer, s = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
    let o = i.substring(s + e.remainder, s + n.piece.length);
    for (n = n.next(); n !== at; ) {
      const a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (n === t.node) {
        o += a.substring(l, l + t.remainder);
        break;
      } else
        o += a.substr(l, n.piece.length);
      n = n.next();
    }
    return o;
  }
  getLinesContent() {
    const e = [];
    let t = 0, n = "", i = !1;
    return this.iterate(this.root, (s) => {
      if (s === at)
        return !0;
      const o = s.piece;
      let a = o.length;
      if (a === 0)
        return !0;
      const l = this._buffers[o.bufferIndex].buffer, c = this._buffers[o.bufferIndex].lineStarts, d = o.start.line, u = o.end.line;
      let f = c[d] + o.start.column;
      if (i && (l.charCodeAt(f) === 10 && (f++, a--), e[t++] = n, n = "", i = !1, a === 0))
        return !0;
      if (d === u)
        return !this._EOLNormalized && l.charCodeAt(f + a - 1) === 13 ? (i = !0, n += l.substr(f, a - 1)) : n += l.substr(f, a), !0;
      n += this._EOLNormalized ? l.substring(f, Math.max(f, c[d + 1] - this._EOLLength)) : l.substring(f, c[d + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      for (let p = d + 1; p < u; p++)
        n = this._EOLNormalized ? l.substring(c[p], c[p + 1] - this._EOLLength) : l.substring(c[p], c[p + 1]).replace(/(\r\n|\r|\n)$/, ""), e[t++] = n;
      return !this._EOLNormalized && l.charCodeAt(c[u] + o.end.column - 1) === 13 ? (i = !0, o.end.column === 0 ? t-- : n = l.substr(c[u], o.end.column - 1)) : n = l.substr(c[u], o.end.column), !0;
    }), i && (e[t++] = n, n = ""), e[t++] = n, e;
  }
  getLength() {
    return this._length;
  }
  getLineCount() {
    return this._lineCnt;
  }
  getLineContent(e) {
    return this._lastVisitedLine.lineNumber === e ? this._lastVisitedLine.value : (this._lastVisitedLine.lineNumber = e, e === this._lineCnt ? this._lastVisitedLine.value = this.getLineRawContent(e) : this._EOLNormalized ? this._lastVisitedLine.value = this.getLineRawContent(e, this._EOLLength) : this._lastVisitedLine.value = this.getLineRawContent(e).replace(/(\r\n|\r|\n)$/, ""), this._lastVisitedLine.value);
  }
  _getCharCode(e) {
    if (e.remainder === e.node.piece.length) {
      const t = e.node.next();
      if (!t)
        return 0;
      const n = this._buffers[t.piece.bufferIndex], i = this.offsetInBuffer(t.piece.bufferIndex, t.piece.start);
      return n.buffer.charCodeAt(i);
    } else {
      const t = this._buffers[e.node.piece.bufferIndex], i = this.offsetInBuffer(e.node.piece.bufferIndex, e.node.piece.start) + e.remainder;
      return t.buffer.charCodeAt(i);
    }
  }
  getLineCharCode(e, t) {
    const n = this.nodeAt2(e, t + 1);
    return this._getCharCode(n);
  }
  getLineLength(e) {
    if (e === this.getLineCount()) {
      const t = this.getOffsetAt(e, 1);
      return this.getLength() - t;
    }
    return this.getOffsetAt(e + 1, 1) - this.getOffsetAt(e, 1) - this._EOLLength;
  }
  findMatchesInNode(e, t, n, i, s, o, a, l, c, d, u) {
    const f = this._buffers[e.piece.bufferIndex], p = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start), g = this.offsetInBuffer(e.piece.bufferIndex, s), m = this.offsetInBuffer(e.piece.bufferIndex, o);
    let A;
    const w = { line: 0, column: 0 };
    let v, y;
    t._wordSeparators ? (v = f.buffer.substring(g, m), y = (_) => _ + g, t.reset(0)) : (v = f.buffer, y = (_) => _, t.reset(g));
    do
      if (A = t.next(v), A) {
        if (y(A.index) >= m)
          return d;
        this.positionInBuffer(e, y(A.index) - p, w);
        const _ = this.getLineFeedCnt(e.piece.bufferIndex, s, w), S = w.line === s.line ? w.column - s.column + i : w.column + 1, D = S + A[0].length;
        if (u[d++] = p0(new Q(n + _, S, n + _, D), A, l), y(A.index) + A[0].length >= m || d >= c)
          return d;
      }
    while (A);
    return d;
  }
  findMatchesLineByLine(e, t, n, i) {
    const s = [];
    let o = 0;
    const a = new Y2(t.wordSeparators, t.regex);
    let l = this.nodeAt2(e.startLineNumber, e.startColumn);
    if (l === null)
      return [];
    const c = this.nodeAt2(e.endLineNumber, e.endColumn);
    if (c === null)
      return [];
    let d = this.positionInBuffer(l.node, l.remainder);
    const u = this.positionInBuffer(c.node, c.remainder);
    if (l.node === c.node)
      return this.findMatchesInNode(l.node, a, e.startLineNumber, e.startColumn, d, u, t, n, i, o, s), s;
    let f = e.startLineNumber, p = l.node;
    for (; p !== c.node; ) {
      const m = this.getLineFeedCnt(p.piece.bufferIndex, d, p.piece.end);
      if (m >= 1) {
        const w = this._buffers[p.piece.bufferIndex].lineStarts, v = this.offsetInBuffer(p.piece.bufferIndex, p.piece.start), y = w[d.line + m], _ = f === e.startLineNumber ? e.startColumn : 1;
        if (o = this.findMatchesInNode(p, a, f, _, d, this.positionInBuffer(p, y - v), t, n, i, o, s), o >= i)
          return s;
        f += m;
      }
      const A = f === e.startLineNumber ? e.startColumn - 1 : 0;
      if (f === e.endLineNumber) {
        const w = this.getLineContent(f).substring(A, e.endColumn - 1);
        return o = this._findMatchesInLine(t, a, w, e.endLineNumber, A, o, s, n, i), s;
      }
      if (o = this._findMatchesInLine(t, a, this.getLineContent(f).substr(A), f, A, o, s, n, i), o >= i)
        return s;
      f++, l = this.nodeAt2(f, 1), p = l.node, d = this.positionInBuffer(l.node, l.remainder);
    }
    if (f === e.endLineNumber) {
      const m = f === e.startLineNumber ? e.startColumn - 1 : 0, A = this.getLineContent(f).substring(m, e.endColumn - 1);
      return o = this._findMatchesInLine(t, a, A, e.endLineNumber, m, o, s, n, i), s;
    }
    const g = f === e.startLineNumber ? e.startColumn : 1;
    return o = this.findMatchesInNode(c.node, a, f, g, d, u, t, n, i, o, s), s;
  }
  _findMatchesInLine(e, t, n, i, s, o, a, l, c) {
    const d = e.wordSeparators;
    if (!l && e.simpleSearch) {
      const f = e.simpleSearch, p = f.length, g = n.length;
      let m = -p;
      for (; (m = n.indexOf(f, m + p)) !== -1; )
        if ((!d || lO(d, n, g, m, p)) && (a[o++] = new z3(new Q(i, m + 1 + s, i, m + 1 + p + s), null), o >= c))
          return o;
      return o;
    }
    let u;
    t.reset(0);
    do
      if (u = t.next(n), u && (a[o++] = p0(new Q(i, u.index + 1 + s, i, u.index + 1 + u[0].length + s), u, l), o >= c))
        return o;
    while (u);
    return o;
  }
  // #endregion
  // #region Piece Table
  insert(e, t, n = !1) {
    if (this._EOLNormalized = this._EOLNormalized && n, this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", this.root !== at) {
      const { node: i, remainder: s, nodeStartOffset: o } = this.nodeAt(e), a = i.piece, l = a.bufferIndex, c = this.positionInBuffer(i, s);
      if (i.piece.bufferIndex === 0 && a.end.line === this._lastChangeBufferPos.line && a.end.column === this._lastChangeBufferPos.column && o + a.length === e && t.length < Hh) {
        this.appendToNode(i, t), this.computeBufferMetadata();
        return;
      }
      if (o === e)
        this.insertContentToNodeLeft(t, i), this._searchCache.validate(e);
      else if (o + i.piece.length > e) {
        const d = [];
        let u = new Qs(a.bufferIndex, c, a.end, this.getLineFeedCnt(a.bufferIndex, c, a.end), this.offsetInBuffer(l, a.end) - this.offsetInBuffer(l, c));
        if (this.shouldCheckCRLF() && this.endWithCR(t) && this.nodeCharCodeAt(i, s) === 10) {
          const m = { line: u.start.line + 1, column: 0 };
          u = new Qs(u.bufferIndex, m, u.end, this.getLineFeedCnt(u.bufferIndex, m, u.end), u.length - 1), t += `
`;
        }
        if (this.shouldCheckCRLF() && this.startWithLF(t))
          if (this.nodeCharCodeAt(i, s - 1) === 13) {
            const m = this.positionInBuffer(i, s - 1);
            this.deleteNodeTail(i, m), t = "\r" + t, i.piece.length === 0 && d.push(i);
          } else
            this.deleteNodeTail(i, c);
        else
          this.deleteNodeTail(i, c);
        const f = this.createNewPieces(t);
        u.length > 0 && this.rbInsertRight(i, u);
        let p = i;
        for (let g = 0; g < f.length; g++)
          p = this.rbInsertRight(p, f[g]);
        this.deleteNodes(d);
      } else
        this.insertContentToNodeRight(t, i);
    } else {
      const i = this.createNewPieces(t);
      let s = this.rbInsertLeft(null, i[0]);
      for (let o = 1; o < i.length; o++)
        s = this.rbInsertRight(s, i[o]);
    }
    this.computeBufferMetadata();
  }
  delete(e, t) {
    if (this._lastVisitedLine.lineNumber = 0, this._lastVisitedLine.value = "", t <= 0 || this.root === at)
      return;
    const n = this.nodeAt(e), i = this.nodeAt(e + t), s = n.node, o = i.node;
    if (s === o) {
      const f = this.positionInBuffer(s, n.remainder), p = this.positionInBuffer(s, i.remainder);
      if (n.nodeStartOffset === e) {
        if (t === s.piece.length) {
          const g = s.next();
          zv(this, s), this.validateCRLFWithPrevNode(g), this.computeBufferMetadata();
          return;
        }
        this.deleteNodeHead(s, p), this._searchCache.validate(e), this.validateCRLFWithPrevNode(s), this.computeBufferMetadata();
        return;
      }
      if (n.nodeStartOffset + s.piece.length === e + t) {
        this.deleteNodeTail(s, f), this.validateCRLFWithNextNode(s), this.computeBufferMetadata();
        return;
      }
      this.shrinkNode(s, f, p), this.computeBufferMetadata();
      return;
    }
    const a = [], l = this.positionInBuffer(s, n.remainder);
    this.deleteNodeTail(s, l), this._searchCache.validate(e), s.piece.length === 0 && a.push(s);
    const c = this.positionInBuffer(o, i.remainder);
    this.deleteNodeHead(o, c), o.piece.length === 0 && a.push(o);
    const d = s.next();
    for (let f = d; f !== at && f !== o; f = f.next())
      a.push(f);
    const u = s.piece.length === 0 ? s.prev() : s;
    this.deleteNodes(a), this.validateCRLFWithNextNode(u), this.computeBufferMetadata();
  }
  insertContentToNodeLeft(e, t) {
    const n = [];
    if (this.shouldCheckCRLF() && this.endWithCR(e) && this.startWithLF(t)) {
      const o = t.piece, a = { line: o.start.line + 1, column: 0 }, l = new Qs(o.bufferIndex, a, o.end, this.getLineFeedCnt(o.bufferIndex, a, o.end), o.length - 1);
      t.piece = l, e += `
`, Uh(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    }
    const i = this.createNewPieces(e);
    let s = this.rbInsertLeft(t, i[i.length - 1]);
    for (let o = i.length - 2; o >= 0; o--)
      s = this.rbInsertLeft(s, i[o]);
    this.validateCRLFWithPrevNode(s), this.deleteNodes(n);
  }
  insertContentToNodeRight(e, t) {
    this.adjustCarriageReturnFromNext(e, t) && (e += `
`);
    const n = this.createNewPieces(e), i = this.rbInsertRight(t, n[0]);
    let s = i;
    for (let o = 1; o < n.length; o++)
      s = this.rbInsertRight(s, n[o]);
    this.validateCRLFWithPrevNode(i);
  }
  positionInBuffer(e, t, n) {
    const i = e.piece, s = e.piece.bufferIndex, o = this._buffers[s].lineStarts, l = o[i.start.line] + i.start.column + t;
    let c = i.start.line, d = i.end.line, u = 0, f = 0, p = 0;
    for (; c <= d && (u = c + (d - c) / 2 | 0, p = o[u], u !== d); )
      if (f = o[u + 1], l < p)
        d = u - 1;
      else if (l >= f)
        c = u + 1;
      else
        break;
    return n ? (n.line = u, n.column = l - p, null) : {
      line: u,
      column: l - p
    };
  }
  getLineFeedCnt(e, t, n) {
    if (n.column === 0)
      return n.line - t.line;
    const i = this._buffers[e].lineStarts;
    if (n.line === i.length - 1)
      return n.line - t.line;
    const s = i[n.line + 1], o = i[n.line] + n.column;
    if (s > o + 1)
      return n.line - t.line;
    const a = o - 1;
    return this._buffers[e].buffer.charCodeAt(a) === 13 ? n.line - t.line + 1 : n.line - t.line;
  }
  offsetInBuffer(e, t) {
    return this._buffers[e].lineStarts[t.line] + t.column;
  }
  deleteNodes(e) {
    for (let t = 0; t < e.length; t++)
      zv(this, e[t]);
  }
  createNewPieces(e) {
    if (e.length > Hh) {
      const d = [];
      for (; e.length > Hh; ) {
        const f = e.charCodeAt(Hh - 1);
        let p;
        f === 13 || f >= 55296 && f <= 56319 ? (p = e.substring(0, Hh - 1), e = e.substring(Hh - 1)) : (p = e.substring(0, Hh), e = e.substring(Hh));
        const g = Qh(p);
        d.push(new Qs(
          this._buffers.length,
          /* buffer index */
          { line: 0, column: 0 },
          { line: g.length - 1, column: p.length - g[g.length - 1] },
          g.length - 1,
          p.length
        )), this._buffers.push(new E0(p, g));
      }
      const u = Qh(e);
      return d.push(new Qs(
        this._buffers.length,
        /* buffer index */
        { line: 0, column: 0 },
        { line: u.length - 1, column: e.length - u[u.length - 1] },
        u.length - 1,
        e.length
      )), this._buffers.push(new E0(e, u)), d;
    }
    let t = this._buffers[0].buffer.length;
    const n = Qh(e, !1);
    let i = this._lastChangeBufferPos;
    if (this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 1] === t && t !== 0 && this.startWithLF(e) && this.endWithCR(this._buffers[0].buffer)) {
      this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line, column: this._lastChangeBufferPos.column + 1 }, i = this._lastChangeBufferPos;
      for (let d = 0; d < n.length; d++)
        n[d] += t + 1;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += "_" + e, t += 1;
    } else {
      if (t !== 0)
        for (let d = 0; d < n.length; d++)
          n[d] += t;
      this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(n.slice(1)), this._buffers[0].buffer += e;
    }
    const s = this._buffers[0].buffer.length, o = this._buffers[0].lineStarts.length - 1, a = s - this._buffers[0].lineStarts[o], l = { line: o, column: a }, c = new Qs(
      0,
      /** todo@peng */
      i,
      l,
      this.getLineFeedCnt(0, i, l),
      s - t
    );
    return this._lastChangeBufferPos = l, [c];
  }
  getLineRawContent(e, t = 0) {
    let n = this.root, i = "";
    const s = this._searchCache.get2(e);
    if (s) {
      n = s.node;
      const o = this.getAccumulatedValue(n, e - s.nodeStartLineNumber - 1), a = this._buffers[n.piece.bufferIndex].buffer, l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
      if (s.nodeStartLineNumber + n.piece.lineFeedCnt === e)
        i = a.substring(l + o, l + n.piece.length);
      else {
        const c = this.getAccumulatedValue(n, e - s.nodeStartLineNumber);
        return a.substring(l + o, l + c - t);
      }
    } else {
      let o = 0;
      const a = e;
      for (; n !== at; )
        if (n.left !== at && n.lf_left >= e - 1)
          n = n.left;
        else if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), c = this.getAccumulatedValue(n, e - n.lf_left - 1), d = this._buffers[n.piece.bufferIndex].buffer, u = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          return o += n.size_left, this._searchCache.set({
            node: n,
            nodeStartOffset: o,
            nodeStartLineNumber: a - (e - 1 - n.lf_left)
          }), d.substring(u + l, u + c - t);
        } else if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
          const l = this.getAccumulatedValue(n, e - n.lf_left - 2), c = this._buffers[n.piece.bufferIndex].buffer, d = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
          i = c.substring(d + l, d + n.piece.length);
          break;
        } else
          e -= n.lf_left + n.piece.lineFeedCnt, o += n.size_left + n.piece.length, n = n.right;
    }
    for (n = n.next(); n !== at; ) {
      const o = this._buffers[n.piece.bufferIndex].buffer;
      if (n.piece.lineFeedCnt > 0) {
        const a = this.getAccumulatedValue(n, 0), l = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        return i += o.substring(l, l + a - t), i;
      } else {
        const a = this.offsetInBuffer(n.piece.bufferIndex, n.piece.start);
        i += o.substr(a, n.piece.length);
      }
      n = n.next();
    }
    return i;
  }
  computeBufferMetadata() {
    let e = this.root, t = 1, n = 0;
    for (; e !== at; )
      t += e.lf_left + e.piece.lineFeedCnt, n += e.size_left + e.piece.length, e = e.right;
    this._lineCnt = t, this._length = n, this._searchCache.validate(this._length);
  }
  // #region node operations
  getIndexOf(e, t) {
    const n = e.piece, i = this.positionInBuffer(e, t), s = i.line - n.start.line;
    if (this.offsetInBuffer(n.bufferIndex, n.end) - this.offsetInBuffer(n.bufferIndex, n.start) === t) {
      const o = this.getLineFeedCnt(e.piece.bufferIndex, n.start, i);
      if (o !== s)
        return { index: o, remainder: 0 };
    }
    return { index: s, remainder: i.column };
  }
  getAccumulatedValue(e, t) {
    if (t < 0)
      return 0;
    const n = e.piece, i = this._buffers[n.bufferIndex].lineStarts, s = n.start.line + t + 1;
    return s > n.end.line ? i[n.end.line] + n.end.column - i[n.start.line] - n.start.column : i[s] - i[n.start.line] - n.start.column;
  }
  deleteNodeTail(e, t) {
    const n = e.piece, i = n.lineFeedCnt, s = this.offsetInBuffer(n.bufferIndex, n.end), o = t, a = this.offsetInBuffer(n.bufferIndex, o), l = this.getLineFeedCnt(n.bufferIndex, n.start, o), c = l - i, d = a - s, u = n.length + d;
    e.piece = new Qs(n.bufferIndex, n.start, o, l, u), Uh(this, e, d, c);
  }
  deleteNodeHead(e, t) {
    const n = e.piece, i = n.lineFeedCnt, s = this.offsetInBuffer(n.bufferIndex, n.start), o = t, a = this.getLineFeedCnt(n.bufferIndex, o, n.end), l = this.offsetInBuffer(n.bufferIndex, o), c = a - i, d = s - l, u = n.length + d;
    e.piece = new Qs(n.bufferIndex, o, n.end, a, u), Uh(this, e, d, c);
  }
  shrinkNode(e, t, n) {
    const i = e.piece, s = i.start, o = i.end, a = i.length, l = i.lineFeedCnt, c = t, d = this.getLineFeedCnt(i.bufferIndex, i.start, c), u = this.offsetInBuffer(i.bufferIndex, t) - this.offsetInBuffer(i.bufferIndex, s);
    e.piece = new Qs(i.bufferIndex, i.start, c, d, u), Uh(this, e, u - a, d - l);
    const f = new Qs(i.bufferIndex, n, o, this.getLineFeedCnt(i.bufferIndex, n, o), this.offsetInBuffer(i.bufferIndex, o) - this.offsetInBuffer(i.bufferIndex, n)), p = this.rbInsertRight(e, f);
    this.validateCRLFWithPrevNode(p);
  }
  appendToNode(e, t) {
    this.adjustCarriageReturnFromNext(t, e) && (t += `
`);
    const n = this.shouldCheckCRLF() && this.startWithLF(t) && this.endWithCR(e), i = this._buffers[0].buffer.length;
    this._buffers[0].buffer += t;
    const s = Qh(t, !1);
    for (let p = 0; p < s.length; p++)
      s[p] += i;
    if (n) {
      const p = this._buffers[0].lineStarts[this._buffers[0].lineStarts.length - 2];
      this._buffers[0].lineStarts.pop(), this._lastChangeBufferPos = { line: this._lastChangeBufferPos.line - 1, column: i - p };
    }
    this._buffers[0].lineStarts = this._buffers[0].lineStarts.concat(s.slice(1));
    const o = this._buffers[0].lineStarts.length - 1, a = this._buffers[0].buffer.length - this._buffers[0].lineStarts[o], l = { line: o, column: a }, c = e.piece.length + t.length, d = e.piece.lineFeedCnt, u = this.getLineFeedCnt(0, e.piece.start, l), f = u - d;
    e.piece = new Qs(e.piece.bufferIndex, e.piece.start, l, u, c), this._lastChangeBufferPos = l, Uh(this, e, t.length, f);
  }
  nodeAt(e) {
    let t = this.root;
    const n = this._searchCache.get(e);
    if (n)
      return {
        node: n.node,
        nodeStartOffset: n.nodeStartOffset,
        remainder: e - n.nodeStartOffset
      };
    let i = 0;
    for (; t !== at; )
      if (t.size_left > e)
        t = t.left;
      else if (t.size_left + t.piece.length >= e) {
        i += t.size_left;
        const s = {
          node: t,
          remainder: e - t.size_left,
          nodeStartOffset: i
        };
        return this._searchCache.set(s), s;
      } else
        e -= t.size_left + t.piece.length, i += t.size_left + t.piece.length, t = t.right;
    return null;
  }
  nodeAt2(e, t) {
    let n = this.root, i = 0;
    for (; n !== at; )
      if (n.left !== at && n.lf_left >= e - 1)
        n = n.left;
      else if (n.lf_left + n.piece.lineFeedCnt > e - 1) {
        const s = this.getAccumulatedValue(n, e - n.lf_left - 2), o = this.getAccumulatedValue(n, e - n.lf_left - 1);
        return i += n.size_left, {
          node: n,
          remainder: Math.min(s + t - 1, o),
          nodeStartOffset: i
        };
      } else if (n.lf_left + n.piece.lineFeedCnt === e - 1) {
        const s = this.getAccumulatedValue(n, e - n.lf_left - 2);
        if (s + t - 1 <= n.piece.length)
          return {
            node: n,
            remainder: s + t - 1,
            nodeStartOffset: i
          };
        t -= n.piece.length - s;
        break;
      } else
        e -= n.lf_left + n.piece.lineFeedCnt, i += n.size_left + n.piece.length, n = n.right;
    for (n = n.next(); n !== at; ) {
      if (n.piece.lineFeedCnt > 0) {
        const s = this.getAccumulatedValue(n, 0), o = this.offsetOfNode(n);
        return {
          node: n,
          remainder: Math.min(t - 1, s),
          nodeStartOffset: o
        };
      } else if (n.piece.length >= t - 1) {
        const s = this.offsetOfNode(n);
        return {
          node: n,
          remainder: t - 1,
          nodeStartOffset: s
        };
      } else
        t -= n.piece.length;
      n = n.next();
    }
    return null;
  }
  nodeCharCodeAt(e, t) {
    if (e.piece.lineFeedCnt < 1)
      return -1;
    const n = this._buffers[e.piece.bufferIndex], i = this.offsetInBuffer(e.piece.bufferIndex, e.piece.start) + t;
    return n.buffer.charCodeAt(i);
  }
  offsetOfNode(e) {
    if (!e)
      return 0;
    let t = e.size_left;
    for (; e !== this.root; )
      e.parent.right === e && (t += e.parent.size_left + e.parent.piece.length), e = e.parent;
    return t;
  }
  // #endregion
  // #region CRLF
  shouldCheckCRLF() {
    return !(this._EOLNormalized && this._EOL === `
`);
  }
  startWithLF(e) {
    if (typeof e == "string")
      return e.charCodeAt(0) === 10;
    if (e === at || e.piece.lineFeedCnt === 0)
      return !1;
    const t = e.piece, n = this._buffers[t.bufferIndex].lineStarts, i = t.start.line, s = n[i] + t.start.column;
    return i === n.length - 1 || n[i + 1] > s + 1 ? !1 : this._buffers[t.bufferIndex].buffer.charCodeAt(s) === 10;
  }
  endWithCR(e) {
    return typeof e == "string" ? e.charCodeAt(e.length - 1) === 13 : e === at || e.piece.lineFeedCnt === 0 ? !1 : this.nodeCharCodeAt(e, e.piece.length - 1) === 13;
  }
  validateCRLFWithPrevNode(e) {
    if (this.shouldCheckCRLF() && this.startWithLF(e)) {
      const t = e.prev();
      this.endWithCR(t) && this.fixCRLF(t, e);
    }
  }
  validateCRLFWithNextNode(e) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const t = e.next();
      this.startWithLF(t) && this.fixCRLF(e, t);
    }
  }
  fixCRLF(e, t) {
    const n = [], i = this._buffers[e.piece.bufferIndex].lineStarts;
    let s;
    e.piece.end.column === 0 ? s = { line: e.piece.end.line - 1, column: i[e.piece.end.line] - i[e.piece.end.line - 1] - 1 } : s = { line: e.piece.end.line, column: e.piece.end.column - 1 };
    const o = e.piece.length - 1, a = e.piece.lineFeedCnt - 1;
    e.piece = new Qs(e.piece.bufferIndex, e.piece.start, s, a, o), Uh(this, e, -1, -1), e.piece.length === 0 && n.push(e);
    const l = { line: t.piece.start.line + 1, column: 0 }, c = t.piece.length - 1, d = this.getLineFeedCnt(t.piece.bufferIndex, l, t.piece.end);
    t.piece = new Qs(t.piece.bufferIndex, l, t.piece.end, d, c), Uh(this, t, -1, -1), t.piece.length === 0 && n.push(t);
    const u = this.createNewPieces(`\r
`);
    this.rbInsertRight(e, u[0]);
    for (let f = 0; f < n.length; f++)
      zv(this, n[f]);
  }
  adjustCarriageReturnFromNext(e, t) {
    if (this.shouldCheckCRLF() && this.endWithCR(e)) {
      const n = t.next();
      if (this.startWithLF(n)) {
        if (e += `
`, n.piece.length === 1)
          zv(this, n);
        else {
          const i = n.piece, s = { line: i.start.line + 1, column: 0 }, o = i.length - 1, a = this.getLineFeedCnt(i.bufferIndex, s, i.end);
          n.piece = new Qs(i.bufferIndex, s, i.end, a, o), Uh(this, n, -1, -1);
        }
        return !0;
      }
    }
    return !1;
  }
  // #endregion
  // #endregion
  // #region Tree operations
  iterate(e, t) {
    if (e === at)
      return t(at);
    const n = this.iterate(e.left, t);
    return n && t(e) && this.iterate(e.right, t);
  }
  getNodeContent(e) {
    if (e === at)
      return "";
    const t = this._buffers[e.piece.bufferIndex], n = e.piece, i = this.offsetInBuffer(n.bufferIndex, n.start), s = this.offsetInBuffer(n.bufferIndex, n.end);
    return t.buffer.substring(i, s);
  }
  getPieceContent(e) {
    const t = this._buffers[e.bufferIndex], n = this.offsetInBuffer(e.bufferIndex, e.start), i = this.offsetInBuffer(e.bufferIndex, e.end);
    return t.buffer.substring(n, i);
  }
  /**
   *      node              node
   *     /  \              /  \
   *    a   b    <----   a    b
   *                         /
   *                        z
   */
  rbInsertRight(e, t) {
    const n = new DL(
      t,
      1
      /* NodeColor.Red */
    );
    if (n.left = at, n.right = at, n.parent = at, n.size_left = 0, n.lf_left = 0, this.root === at)
      this.root = n, n.color = 0;
    else if (e.right === at)
      e.right = n, n.parent = e;
    else {
      const s = QO(e.right);
      s.left = n, n.parent = s;
    }
    return e8e(this, n), n;
  }
  /**
   *      node              node
   *     /  \              /  \
   *    a   b     ---->   a    b
   *                       \
   *                        z
   */
  rbInsertLeft(e, t) {
    const n = new DL(
      t,
      1
      /* NodeColor.Red */
    );
    if (n.left = at, n.right = at, n.parent = at, n.size_left = 0, n.lf_left = 0, this.root === at)
      this.root = n, n.color = 0;
    else if (e.left === at)
      e.left = n, n.parent = e;
    else {
      const i = Vke(e.left);
      i.right = n, n.parent = i;
    }
    return e8e(this, n), n;
  }
}
class Lp extends me {
  constructor(e, t, n, i, s, o, a) {
    super(), this._onDidChangeContent = this._register(new $()), this._BOM = t, this._mightContainNonBasicASCII = !o, this._mightContainRTL = i, this._mightContainUnusualLineTerminators = s, this._pieceTree = new b5t(e, n, a);
  }
  mightContainRTL() {
    return this._mightContainRTL;
  }
  mightContainUnusualLineTerminators() {
    return this._mightContainUnusualLineTerminators;
  }
  resetMightContainUnusualLineTerminators() {
    this._mightContainUnusualLineTerminators = !1;
  }
  mightContainNonBasicASCII() {
    return this._mightContainNonBasicASCII;
  }
  getBOM() {
    return this._BOM;
  }
  getEOL() {
    return this._pieceTree.getEOL();
  }
  createSnapshot(e) {
    return this._pieceTree.createSnapshot(e ? this._BOM : "");
  }
  getOffsetAt(e, t) {
    return this._pieceTree.getOffsetAt(e, t);
  }
  getPositionAt(e) {
    return this._pieceTree.getPositionAt(e);
  }
  getRangeAt(e, t) {
    const n = e + t, i = this.getPositionAt(e), s = this.getPositionAt(n);
    return new Q(i.lineNumber, i.column, s.lineNumber, s.column);
  }
  getValueInRange(e, t = 0) {
    if (e.isEmpty())
      return "";
    const n = this._getEndOfLine(t);
    return this._pieceTree.getValueInRange(e, n);
  }
  getValueLengthInRange(e, t = 0) {
    if (e.isEmpty())
      return 0;
    if (e.startLineNumber === e.endLineNumber)
      return e.endColumn - e.startColumn;
    const n = this.getOffsetAt(e.startLineNumber, e.startColumn), i = this.getOffsetAt(e.endLineNumber, e.endColumn);
    let s = 0;
    const o = this._getEndOfLine(t), a = this.getEOL();
    if (o.length !== a.length) {
      const l = o.length - a.length, c = e.endLineNumber - e.startLineNumber;
      s = l * c;
    }
    return i - n + s;
  }
  getCharacterCountInRange(e, t = 0) {
    if (this._mightContainNonBasicASCII) {
      let n = 0;
      const i = e.startLineNumber, s = e.endLineNumber;
      for (let o = i; o <= s; o++) {
        const a = this.getLineContent(o), l = o === i ? e.startColumn - 1 : 0, c = o === s ? e.endColumn - 1 : a.length;
        for (let d = l; d < c; d++)
          Ki(a.charCodeAt(d)) ? (n = n + 1, d = d + 1) : n = n + 1;
      }
      return n += this._getEndOfLine(t).length * (s - i), n;
    }
    return this.getValueLengthInRange(e, t);
  }
  getLength() {
    return this._pieceTree.getLength();
  }
  getLineCount() {
    return this._pieceTree.getLineCount();
  }
  getLinesContent() {
    return this._pieceTree.getLinesContent();
  }
  getLineContent(e) {
    return this._pieceTree.getLineContent(e);
  }
  getLineCharCode(e, t) {
    return this._pieceTree.getLineCharCode(e, t);
  }
  getLineLength(e) {
    return this._pieceTree.getLineLength(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = so(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = Zf(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  _getEndOfLine(e) {
    switch (e) {
      case 1:
        return `
`;
      case 2:
        return `\r
`;
      case 0:
        return this.getEOL();
      default:
        throw new Error("Unknown EOL preference");
    }
  }
  setEOL(e) {
    this._pieceTree.setEOL(e);
  }
  applyEdits(e, t, n) {
    let i = this._mightContainRTL, s = this._mightContainUnusualLineTerminators, o = this._mightContainNonBasicASCII, a = !0, l = [];
    for (let m = 0; m < e.length; m++) {
      const A = e[m];
      a && A._isTracked && (a = !1);
      const w = A.range;
      if (A.text) {
        let D = !0;
        o || (D = !BI(A.text), o = D), !i && D && (i = H3(A.text)), !s && D && (s = sDe(A.text));
      }
      let v = "", y = 0, _ = 0, S = 0;
      if (A.text) {
        let D;
        [y, _, S, D] = mg(A.text);
        const M = this.getEOL();
        D === 0 || D === (M === `\r
` ? 2 : 1) ? v = A.text : v = A.text.replace(/\r\n|\r|\n/g, M);
      }
      l[m] = {
        sortIndex: m,
        identifier: A.identifier || null,
        range: w,
        rangeOffset: this.getOffsetAt(w.startLineNumber, w.startColumn),
        rangeLength: this.getValueLengthInRange(w),
        text: v,
        eolCount: y,
        firstLineLength: _,
        lastLineLength: S,
        forceMoveMarkers: !!A.forceMoveMarkers,
        isAutoWhitespaceEdit: A.isAutoWhitespaceEdit || !1
      };
    }
    l.sort(Lp._sortOpsAscending);
    let c = !1;
    for (let m = 0, A = l.length - 1; m < A; m++) {
      const w = l[m].range.getEndPosition(), v = l[m + 1].range.getStartPosition();
      if (v.isBeforeOrEqual(w)) {
        if (v.isBefore(w))
          throw new Error("Overlapping ranges are not allowed!");
        c = !0;
      }
    }
    a && (l = this._reduceOperations(l));
    const d = n || t ? Lp._getInverseEditRanges(l) : [], u = [];
    if (t)
      for (let m = 0; m < l.length; m++) {
        const A = l[m], w = d[m];
        if (A.isAutoWhitespaceEdit && A.range.isEmpty())
          for (let v = w.startLineNumber; v <= w.endLineNumber; v++) {
            let y = "";
            v === w.startLineNumber && (y = this.getLineContent(A.range.startLineNumber), so(y) !== -1) || u.push({ lineNumber: v, oldContent: y });
          }
      }
    let f = null;
    if (n) {
      let m = 0;
      f = [];
      for (let A = 0; A < l.length; A++) {
        const w = l[A], v = d[A], y = this.getValueInRange(w.range), _ = w.rangeOffset + m;
        m += w.text.length - y.length, f[A] = {
          sortIndex: w.sortIndex,
          identifier: w.identifier,
          range: v,
          text: y,
          textChange: new Dr(w.rangeOffset, y, _, w.text)
        };
      }
      c || f.sort((A, w) => A.sortIndex - w.sortIndex);
    }
    this._mightContainRTL = i, this._mightContainUnusualLineTerminators = s, this._mightContainNonBasicASCII = o;
    const p = this._doApplyEdits(l);
    let g = null;
    if (t && u.length > 0) {
      u.sort((m, A) => A.lineNumber - m.lineNumber), g = [];
      for (let m = 0, A = u.length; m < A; m++) {
        const w = u[m].lineNumber;
        if (m > 0 && u[m - 1].lineNumber === w)
          continue;
        const v = u[m].oldContent, y = this.getLineContent(w);
        y.length === 0 || y === v || so(y) !== -1 || g.push(w);
      }
    }
    return this._onDidChangeContent.fire(), new Vpt(f, p, g);
  }
  /**
   * Transform operations such that they represent the same logic edit,
   * but that they also do not cause OOM crashes.
   */
  _reduceOperations(e) {
    return e.length < 1e3 ? e : [this._toSingleEditOperation(e)];
  }
  _toSingleEditOperation(e) {
    let t = !1;
    const n = e[0].range, i = e[e.length - 1].range, s = new Q(n.startLineNumber, n.startColumn, i.endLineNumber, i.endColumn);
    let o = n.startLineNumber, a = n.startColumn;
    const l = [];
    for (let p = 0, g = e.length; p < g; p++) {
      const m = e[p], A = m.range;
      t = t || m.forceMoveMarkers, l.push(this.getValueInRange(new Q(o, a, A.startLineNumber, A.startColumn))), m.text.length > 0 && l.push(m.text), o = A.endLineNumber, a = A.endColumn;
    }
    const c = l.join(""), [d, u, f] = mg(c);
    return {
      sortIndex: 0,
      identifier: e[0].identifier,
      range: s,
      rangeOffset: this.getOffsetAt(s.startLineNumber, s.startColumn),
      rangeLength: this.getValueLengthInRange(
        s,
        0
        /* EndOfLinePreference.TextDefined */
      ),
      text: c,
      eolCount: d,
      firstLineLength: u,
      lastLineLength: f,
      forceMoveMarkers: t,
      isAutoWhitespaceEdit: !1
    };
  }
  _doApplyEdits(e) {
    e.sort(Lp._sortOpsDescending);
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n], s = i.range.startLineNumber, o = i.range.startColumn, a = i.range.endLineNumber, l = i.range.endColumn;
      if (s === a && o === l && i.text.length === 0)
        continue;
      i.text ? (this._pieceTree.delete(i.rangeOffset, i.rangeLength), this._pieceTree.insert(i.rangeOffset, i.text, !0)) : this._pieceTree.delete(i.rangeOffset, i.rangeLength);
      const c = new Q(s, o, a, l);
      t.push({
        range: c,
        rangeLength: i.rangeLength,
        text: i.text,
        rangeOffset: i.rangeOffset,
        forceMoveMarkers: i.forceMoveMarkers
      });
    }
    return t;
  }
  findMatchesLineByLine(e, t, n, i) {
    return this._pieceTree.findMatchesLineByLine(e, t, n, i);
  }
  /**
   * Assumes `operations` are validated and sorted ascending
   */
  static _getInverseEditRanges(e) {
    const t = [];
    let n = 0, i = 0, s = null;
    for (let o = 0, a = e.length; o < a; o++) {
      const l = e[o];
      let c, d;
      s ? s.range.endLineNumber === l.range.startLineNumber ? (c = n, d = i + (l.range.startColumn - s.range.endColumn)) : (c = n + (l.range.startLineNumber - s.range.endLineNumber), d = l.range.startColumn) : (c = l.range.startLineNumber, d = l.range.startColumn);
      let u;
      if (l.text.length > 0) {
        const f = l.eolCount + 1;
        f === 1 ? u = new Q(c, d, c, d + l.firstLineLength) : u = new Q(c, d, c + f - 1, l.lastLineLength + 1);
      } else
        u = new Q(c, d, c, d);
      n = u.endLineNumber, i = u.endColumn, t.push(u), s = l;
    }
    return t;
  }
  static _sortOpsAscending(e, t) {
    const n = Q.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? e.sortIndex - t.sortIndex : n;
  }
  static _sortOpsDescending(e, t) {
    const n = Q.compareRangesUsingEnds(e.range, t.range);
    return n === 0 ? t.sortIndex - e.sortIndex : -n;
  }
}
class y5t {
  constructor(e, t, n, i, s, o, a, l, c) {
    this._chunks = e, this._bom = t, this._cr = n, this._lf = i, this._crlf = s, this._containsRTL = o, this._containsUnusualLineTerminators = a, this._isBasicASCII = l, this._normalizeEOL = c;
  }
  _getEOL(e) {
    const t = this._cr + this._lf + this._crlf, n = this._cr + this._crlf;
    return t === 0 ? e === 1 ? `
` : `\r
` : n > t / 2 ? `\r
` : `
`;
  }
  create(e) {
    const t = this._getEOL(e), n = this._chunks;
    if (this._normalizeEOL && (t === `\r
` && (this._cr > 0 || this._lf > 0) || t === `
` && (this._cr > 0 || this._crlf > 0)))
      for (let s = 0, o = n.length; s < o; s++) {
        const a = n[s].buffer.replace(/\r\n|\r|\n/g, t), l = Qh(a);
        n[s] = new E0(a, l);
      }
    const i = new Lp(n, this._bom, t, this._containsRTL, this._containsUnusualLineTerminators, this._isBasicASCII, this._normalizeEOL);
    return { textBuffer: i, disposable: i };
  }
}
class Bke {
  constructor() {
    this.chunks = [], this.BOM = "", this._hasPreviousChar = !1, this._previousChar = 0, this._tmpLineStarts = [], this.cr = 0, this.lf = 0, this.crlf = 0, this.containsRTL = !1, this.containsUnusualLineTerminators = !1, this.isBasicASCII = !0;
  }
  acceptChunk(e) {
    if (e.length === 0)
      return;
    this.chunks.length === 0 && FI(e) && (this.BOM = k0t, e = e.substr(1));
    const t = e.charCodeAt(e.length - 1);
    t === 13 || t >= 55296 && t <= 56319 ? (this._acceptChunk1(e.substr(0, e.length - 1), !1), this._hasPreviousChar = !0, this._previousChar = t) : (this._acceptChunk1(e, !1), this._hasPreviousChar = !1, this._previousChar = t);
  }
  _acceptChunk1(e, t) {
    !t && e.length === 0 || (this._hasPreviousChar ? this._acceptChunk2(String.fromCharCode(this._previousChar) + e) : this._acceptChunk2(e));
  }
  _acceptChunk2(e) {
    const t = A5t(this._tmpLineStarts, e);
    this.chunks.push(new E0(e, t.lineStarts)), this.cr += t.cr, this.lf += t.lf, this.crlf += t.crlf, t.isBasicASCII || (this.isBasicASCII = !1, this.containsRTL || (this.containsRTL = H3(e)), this.containsUnusualLineTerminators || (this.containsUnusualLineTerminators = sDe(e)));
  }
  finish(e = !0) {
    return this._finish(), new y5t(this.chunks, this.BOM, this.cr, this.lf, this.crlf, this.containsRTL, this.containsUnusualLineTerminators, this.isBasicASCII, e);
  }
  _finish() {
    if (this.chunks.length === 0 && this._acceptChunk1("", !0), this._hasPreviousChar) {
      this._hasPreviousChar = !1;
      const e = this.chunks[this.chunks.length - 1];
      e.buffer += String.fromCharCode(this._previousChar);
      const t = Qh(e.buffer);
      e.lineStarts = t, this._previousChar === 13 && this.cr++;
    }
  }
}
class C5t {
  constructor(e) {
    this._default = e, this._store = [];
  }
  get(e) {
    return e < this._store.length ? this._store[e] : this._default;
  }
  set(e, t) {
    for (; e >= this._store.length; )
      this._store[this._store.length] = this._default;
    this._store[e] = t;
  }
  replace(e, t, n) {
    if (e >= this._store.length)
      return;
    if (t === 0) {
      this.insert(e, n);
      return;
    } else if (n === 0) {
      this.delete(e, t);
      return;
    }
    const i = this._store.slice(0, e), s = this._store.slice(e + t), o = E5t(n, this._default);
    this._store = i.concat(o, s);
  }
  delete(e, t) {
    t === 0 || e >= this._store.length || this._store.splice(e, t);
  }
  insert(e, t) {
    if (t === 0 || e >= this._store.length)
      return;
    const n = [];
    for (let i = 0; i < t; i++)
      n[i] = this._default;
    this._store = N7(this._store, e, n);
  }
}
function E5t(r, e) {
  const t = [];
  for (let n = 0; n < r; n++)
    t[n] = e;
  return t;
}
class _5t {
  /**
   * (Inclusive) start line number for these tokens.
   */
  get startLineNumber() {
    return this._startLineNumber;
  }
  /**
   * (Inclusive) end line number for these tokens.
   */
  get endLineNumber() {
    return this._startLineNumber + this._tokens.length - 1;
  }
  constructor(e, t) {
    this._startLineNumber = e, this._tokens = t;
  }
  /**
   * @see {@link _tokens}
   */
  getLineTokens(e) {
    return this._tokens[e - this._startLineNumber];
  }
  appendLineTokens(e) {
    this._tokens.push(e);
  }
}
class LL {
  constructor() {
    this._tokens = [];
  }
  add(e, t) {
    if (this._tokens.length > 0) {
      const n = this._tokens[this._tokens.length - 1];
      if (n.endLineNumber + 1 === e) {
        n.appendLineTokens(t);
        return;
      }
    }
    this._tokens.push(new _5t(e, [t]));
  }
  finalize() {
    return this._tokens;
  }
}
class x5t {
  constructor(e, t) {
    this.tokenizationSupport = t, this.initialState = this.tokenizationSupport.getInitialState(), this.store = new kL(e);
  }
  getStartState(e) {
    return this.store.getStartState(e, this.initialState);
  }
  getFirstInvalidLine() {
    return this.store.getFirstInvalidLine(this.initialState);
  }
}
class S5t extends x5t {
  constructor(e, t, n, i) {
    super(e, t), this._textModel = n, this._languageIdCodec = i;
  }
  updateTokensUntilLine(e, t) {
    const n = this._textModel.getLanguageId();
    for (; ; ) {
      const i = this.getFirstInvalidLine();
      if (!i || i.lineNumber > t)
        break;
      const s = this._textModel.getLineContent(i.lineNumber), o = Fm(this._languageIdCodec, n, this.tokenizationSupport, s, !0, i.startState);
      e.add(i.lineNumber, o.tokens), this.store.setEndState(i.lineNumber, o.endState);
    }
  }
  /** assumes state is up to date */
  getTokenTypeIfInsertingCharacter(e, t) {
    const n = this.getStartState(e.lineNumber);
    if (!n)
      return 0;
    const i = this._textModel.getLanguageId(), s = this._textModel.getLineContent(e.lineNumber), o = s.substring(0, e.column - 1) + t + s.substring(e.column - 1), a = Fm(this._languageIdCodec, i, this.tokenizationSupport, o, !0, n), l = new Ri(a.tokens, o, this._languageIdCodec);
    if (l.getCount() === 0)
      return 0;
    const c = l.findTokenIndexAtOffset(e.column - 1);
    return l.getStandardTokenType(c);
  }
  /** assumes state is up to date */
  tokenizeLineWithEdit(e, t, n) {
    const i = e.lineNumber, s = e.column, o = this.getStartState(i);
    if (!o)
      return null;
    const a = this._textModel.getLineContent(i), l = a.substring(0, s - 1) + n + a.substring(s - 1 + t), c = this._textModel.getLanguageIdAtPosition(i, 0), d = Fm(this._languageIdCodec, c, this.tokenizationSupport, l, !0, o);
    return new Ri(d.tokens, l, this._languageIdCodec);
  }
  hasAccurateTokensForLine(e) {
    const t = this.store.getFirstInvalidEndStateLineNumberOrMax();
    return e < t;
  }
  isCheapToTokenize(e) {
    const t = this.store.getFirstInvalidEndStateLineNumberOrMax();
    return e < t || e === t && this._textModel.getLineLength(e) < 2048;
  }
  /**
   * The result is not cached.
   */
  tokenizeHeuristically(e, t, n) {
    if (n <= this.store.getFirstInvalidEndStateLineNumberOrMax())
      return { heuristicTokens: !1 };
    if (t <= this.store.getFirstInvalidEndStateLineNumberOrMax())
      return this.updateTokensUntilLine(e, n), { heuristicTokens: !1 };
    let i = this.guessStartState(t);
    const s = this._textModel.getLanguageId();
    for (let o = t; o <= n; o++) {
      const a = this._textModel.getLineContent(o), l = Fm(this._languageIdCodec, s, this.tokenizationSupport, a, !0, i);
      e.add(o, l.tokens), i = l.endState;
    }
    return { heuristicTokens: !0 };
  }
  guessStartState(e) {
    let t = this._textModel.getLineFirstNonWhitespaceColumn(e);
    const n = [];
    let i = null;
    for (let a = e - 1; t > 1 && a >= 1; a--) {
      const l = this._textModel.getLineFirstNonWhitespaceColumn(a);
      if (l !== 0 && l < t && (n.push(this._textModel.getLineContent(a)), t = l, i = this.getStartState(a), i))
        break;
    }
    i || (i = this.tokenizationSupport.getInitialState()), n.reverse();
    const s = this._textModel.getLanguageId();
    let o = i;
    for (const a of n)
      o = Fm(this._languageIdCodec, s, this.tokenizationSupport, a, !1, o).endState;
    return o;
  }
}
class kL {
  constructor(e) {
    this.lineCount = e, this._tokenizationStateStore = new M5t(), this._invalidEndStatesLineNumbers = new D5t(), this._invalidEndStatesLineNumbers.addRange(new pt(1, e + 1));
  }
  getEndState(e) {
    return this._tokenizationStateStore.getEndState(e);
  }
  /**
   * @returns if the end state has changed.
   */
  setEndState(e, t) {
    if (!t)
      throw new cn("Cannot set null/undefined state");
    this._invalidEndStatesLineNumbers.delete(e);
    const n = this._tokenizationStateStore.setEndState(e, t);
    return n && e < this.lineCount && this._invalidEndStatesLineNumbers.addRange(new pt(e + 1, e + 2)), n;
  }
  acceptChange(e, t) {
    this.lineCount += t - e.length, this._tokenizationStateStore.acceptChange(e, t), this._invalidEndStatesLineNumbers.addRangeAndResize(new pt(e.startLineNumber, e.endLineNumberExclusive), t);
  }
  acceptChanges(e) {
    for (const t of e) {
      const [n] = mg(t.text);
      this.acceptChange(new lt(t.range.startLineNumber, t.range.endLineNumber + 1), n + 1);
    }
  }
  invalidateEndStateRange(e) {
    this._invalidEndStatesLineNumbers.addRange(new pt(e.startLineNumber, e.endLineNumberExclusive));
  }
  getFirstInvalidEndStateLineNumber() {
    return this._invalidEndStatesLineNumbers.min;
  }
  getFirstInvalidEndStateLineNumberOrMax() {
    return this.getFirstInvalidEndStateLineNumber() || Number.MAX_SAFE_INTEGER;
  }
  allStatesValid() {
    return this._invalidEndStatesLineNumbers.min === null;
  }
  getStartState(e, t) {
    return e === 1 ? t : this.getEndState(e - 1);
  }
  getFirstInvalidLine(e) {
    const t = this.getFirstInvalidEndStateLineNumber();
    if (t === null)
      return null;
    const n = this.getStartState(t, e);
    if (!n)
      throw new cn("Start state must be defined");
    return { lineNumber: t, startState: n };
  }
}
class M5t {
  constructor() {
    this._lineEndStates = new C5t(null);
  }
  getEndState(e) {
    return this._lineEndStates.get(e);
  }
  setEndState(e, t) {
    const n = this._lineEndStates.get(e);
    return n && n.equals(t) ? !1 : (this._lineEndStates.set(e, t), !0);
  }
  acceptChange(e, t) {
    let n = e.length;
    t > 0 && n > 0 && (n--, t--), this._lineEndStates.replace(e.startLineNumber, n, t);
  }
}
class D5t {
  constructor() {
    this._ranges = [];
  }
  get min() {
    return this._ranges.length === 0 ? null : this._ranges[0].start;
  }
  delete(e) {
    const t = this._ranges.findIndex((n) => n.contains(e));
    if (t !== -1) {
      const n = this._ranges[t];
      n.start === e ? n.endExclusive === e + 1 ? this._ranges.splice(t, 1) : this._ranges[t] = new pt(e + 1, n.endExclusive) : n.endExclusive === e + 1 ? this._ranges[t] = new pt(n.start, e) : this._ranges.splice(t, 1, new pt(n.start, e), new pt(e + 1, n.endExclusive));
    }
  }
  addRange(e) {
    pt.addRange(e, this._ranges);
  }
  addRangeAndResize(e, t) {
    let n = 0;
    for (; !(n >= this._ranges.length || e.start <= this._ranges[n].endExclusive); )
      n++;
    let i = n;
    for (; !(i >= this._ranges.length || e.endExclusive < this._ranges[i].start); )
      i++;
    const s = t - e.length;
    for (let o = i; o < this._ranges.length; o++)
      this._ranges[o] = this._ranges[o].delta(s);
    if (n === i) {
      const o = new pt(e.start, e.start + t);
      o.isEmpty || this._ranges.splice(n, 0, o);
    } else {
      const o = Math.min(e.start, this._ranges[n].start), a = Math.max(e.endExclusive, this._ranges[i - 1].endExclusive), l = new pt(o, a + s);
      l.isEmpty ? this._ranges.splice(n, i - n) : this._ranges.splice(n, i - n, l);
    }
  }
  toString() {
    return this._ranges.map((e) => e.toString()).join(" + ");
  }
}
function Fm(r, e, t, n, i, s) {
  let o = null;
  if (t)
    try {
      o = t.tokenizeEncoded(n, i, s.clone());
    } catch (a) {
      wn(a);
    }
  return o || (o = uO(r.encodeLanguageId(e), s)), Ri.convertToEndOffset(o.tokens, n.length), o;
}
class L5t {
  constructor(e, t) {
    this._tokenizerWithStateStore = e, this._backgroundTokenStore = t, this._isDisposed = !1, this._isScheduled = !1;
  }
  dispose() {
    this._isDisposed = !0;
  }
  handleChanges() {
    this._beginBackgroundTokenization();
  }
  _beginBackgroundTokenization() {
    this._isScheduled || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize() || (this._isScheduled = !0, fDe((e) => {
      this._isScheduled = !1, this._backgroundTokenizeWithDeadline(e);
    }));
  }
  /**
   * Tokenize until the deadline occurs, but try to yield every 1-2ms.
   */
  _backgroundTokenizeWithDeadline(e) {
    const t = Date.now() + e.timeRemaining(), n = () => {
      this._isDisposed || !this._tokenizerWithStateStore._textModel.isAttachedToEditor() || !this._hasLinesToTokenize() || (this._backgroundTokenizeForAtLeast1ms(), Date.now() < t ? OMe(n) : this._beginBackgroundTokenization());
    };
    n();
  }
  /**
   * Tokenize for at least 1ms.
   */
  _backgroundTokenizeForAtLeast1ms() {
    const e = this._tokenizerWithStateStore._textModel.getLineCount(), t = new LL(), n = jf.create(!1);
    do
      if (n.elapsed() > 1 || this._tokenizeOneInvalidLine(t) >= e)
        break;
    while (this._hasLinesToTokenize());
    this._backgroundTokenStore.setTokens(t.finalize()), this.checkFinished();
  }
  _hasLinesToTokenize() {
    return this._tokenizerWithStateStore ? !this._tokenizerWithStateStore.store.allStatesValid() : !1;
  }
  _tokenizeOneInvalidLine(e) {
    const t = this._tokenizerWithStateStore?.getFirstInvalidLine();
    return t ? (this._tokenizerWithStateStore.updateTokensUntilLine(e, t.lineNumber), t.lineNumber) : this._tokenizerWithStateStore._textModel.getLineCount() + 1;
  }
  checkFinished() {
    this._isDisposed || this._tokenizerWithStateStore.store.allStatesValid() && this._backgroundTokenStore.backgroundTokenizationFinished();
  }
  requestTokens(e, t) {
    this._tokenizerWithStateStore.store.invalidateEndStateRange(new lt(e, t));
  }
}
const Kh = new Uint32Array(0).buffer;
class Fc {
  static deleteBeginning(e, t) {
    return e === null || e === Kh ? e : Fc.delete(e, 0, t);
  }
  static deleteEnding(e, t) {
    if (e === null || e === Kh)
      return e;
    const n = hd(e), i = n[n.length - 2];
    return Fc.delete(e, t, i);
  }
  static delete(e, t, n) {
    if (e === null || e === Kh || t === n)
      return e;
    const i = hd(e), s = i.length >>> 1;
    if (t === 0 && i[i.length - 2] === n)
      return Kh;
    const o = Ri.findIndexInTokensArray(i, t), a = o > 0 ? i[o - 1 << 1] : 0, l = i[o << 1];
    if (n < l) {
      const p = n - t;
      for (let g = o; g < s; g++)
        i[g << 1] -= p;
      return e;
    }
    let c, d;
    a !== t ? (i[o << 1] = t, c = o + 1 << 1, d = t) : (c = o << 1, d = a);
    const u = n - t;
    for (let p = o + 1; p < s; p++) {
      const g = i[p << 1] - u;
      g > d && (i[c++] = g, i[c++] = i[(p << 1) + 1], d = g);
    }
    if (c === i.length)
      return e;
    const f = new Uint32Array(c);
    return f.set(i.subarray(0, c), 0), f.buffer;
  }
  static append(e, t) {
    if (t === Kh)
      return e;
    if (e === Kh)
      return t;
    if (e === null)
      return e;
    if (t === null)
      return null;
    const n = hd(e), i = hd(t), s = i.length >>> 1, o = new Uint32Array(n.length + i.length);
    o.set(n, 0);
    let a = n.length;
    const l = n[n.length - 2];
    for (let c = 0; c < s; c++)
      o[a++] = i[c << 1] + l, o[a++] = i[(c << 1) + 1];
    return o.buffer;
  }
  static insert(e, t, n) {
    if (e === null || e === Kh)
      return e;
    const i = hd(e), s = i.length >>> 1;
    let o = Ri.findIndexInTokensArray(i, t);
    o > 0 && i[o - 1 << 1] === t && o--;
    for (let a = o; a < s; a++)
      i[a << 1] += n;
    return e;
  }
}
function hd(r) {
  return r instanceof Uint32Array ? r : new Uint32Array(r);
}
class n4 {
  constructor(e) {
    this._lineTokens = [], this._len = 0, this._languageIdCodec = e;
  }
  flush() {
    this._lineTokens = [], this._len = 0;
  }
  get hasTokens() {
    return this._lineTokens.length > 0;
  }
  getTokens(e, t, n) {
    let i = null;
    if (t < this._len && (i = this._lineTokens[t]), i !== null && i !== Kh)
      return new Ri(hd(i), n, this._languageIdCodec);
    const s = new Uint32Array(2);
    return s[0] = n.length, s[1] = t8e(this._languageIdCodec.encodeLanguageId(e)), new Ri(s, n, this._languageIdCodec);
  }
  static _massageTokens(e, t, n) {
    const i = n ? hd(n) : null;
    if (t === 0) {
      let s = !1;
      if (i && i.length > 1 && (s = Vl.getLanguageId(i[1]) !== e), !s)
        return Kh;
    }
    if (!i || i.length === 0) {
      const s = new Uint32Array(2);
      return s[0] = t, s[1] = t8e(e), s.buffer;
    }
    return i[i.length - 2] = t, i.byteOffset === 0 && i.byteLength === i.buffer.byteLength ? i.buffer : i;
  }
  _ensureLine(e) {
    for (; e >= this._len; )
      this._lineTokens[this._len] = null, this._len++;
  }
  _deleteLines(e, t) {
    t !== 0 && (e + t > this._len && (t = this._len - e), this._lineTokens.splice(e, t), this._len -= t);
  }
  _insertLines(e, t) {
    if (t === 0)
      return;
    const n = [];
    for (let i = 0; i < t; i++)
      n[i] = null;
    this._lineTokens = N7(this._lineTokens, e, n), this._len += t;
  }
  setTokens(e, t, n, i, s) {
    const o = n4._massageTokens(this._languageIdCodec.encodeLanguageId(e), n, i);
    this._ensureLine(t);
    const a = this._lineTokens[t];
    return this._lineTokens[t] = o, s ? !n4._equals(a, o) : !1;
  }
  static _equals(e, t) {
    if (!e || !t)
      return !e && !t;
    const n = hd(e), i = hd(t);
    if (n.length !== i.length)
      return !1;
    for (let s = 0, o = n.length; s < o; s++)
      if (n[s] !== i[s])
        return !1;
    return !0;
  }
  //#region Editing
  acceptEdit(e, t, n) {
    this._acceptDeleteRange(e), this._acceptInsertText(new le(e.startLineNumber, e.startColumn), t, n);
  }
  _acceptDeleteRange(e) {
    const t = e.startLineNumber - 1;
    if (t >= this._len)
      return;
    if (e.startLineNumber === e.endLineNumber) {
      if (e.startColumn === e.endColumn)
        return;
      this._lineTokens[t] = Fc.delete(this._lineTokens[t], e.startColumn - 1, e.endColumn - 1);
      return;
    }
    this._lineTokens[t] = Fc.deleteEnding(this._lineTokens[t], e.startColumn - 1);
    const n = e.endLineNumber - 1;
    let i = null;
    n < this._len && (i = Fc.deleteBeginning(this._lineTokens[n], e.endColumn - 1)), this._lineTokens[t] = Fc.append(this._lineTokens[t], i), this._deleteLines(e.startLineNumber, e.endLineNumber - e.startLineNumber);
  }
  _acceptInsertText(e, t, n) {
    if (t === 0 && n === 0)
      return;
    const i = e.lineNumber - 1;
    if (!(i >= this._len)) {
      if (t === 0) {
        this._lineTokens[i] = Fc.insert(this._lineTokens[i], e.column - 1, n);
        return;
      }
      this._lineTokens[i] = Fc.deleteEnding(this._lineTokens[i], e.column - 1), this._lineTokens[i] = Fc.insert(this._lineTokens[i], e.column - 1, n), this._insertLines(e.lineNumber, t);
    }
  }
  //#endregion
  setMultilineTokens(e, t) {
    if (e.length === 0)
      return { changes: [] };
    const n = [];
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      let a = 0, l = 0, c = !1;
      for (let d = o.startLineNumber; d <= o.endLineNumber; d++)
        c ? (this.setTokens(t.getLanguageId(), d - 1, t.getLineLength(d), o.getLineTokens(d), !1), l = d) : this.setTokens(t.getLanguageId(), d - 1, t.getLineLength(d), o.getLineTokens(d), !0) && (c = !0, a = d, l = d);
      c && n.push({ fromLineNumber: a, toLineNumber: l });
    }
    return { changes: n };
  }
}
function t8e(r) {
  return (r << 0 | 0 | 0 | 32768 | 2 << 24 | 1024) >>> 0;
}
class XO {
  constructor(e) {
    this._pieces = [], this._isComplete = !1, this._languageIdCodec = e;
  }
  flush() {
    this._pieces = [], this._isComplete = !1;
  }
  isEmpty() {
    return this._pieces.length === 0;
  }
  set(e, t) {
    this._pieces = e || [], this._isComplete = t;
  }
  setPartial(e, t) {
    let n = e;
    if (t.length > 0) {
      const s = t[0].getRange(), o = t[t.length - 1].getRange();
      if (!s || !o)
        return e;
      n = e.plusRange(s).plusRange(o);
    }
    let i = null;
    for (let s = 0, o = this._pieces.length; s < o; s++) {
      const a = this._pieces[s];
      if (a.endLineNumber < n.startLineNumber)
        continue;
      if (a.startLineNumber > n.endLineNumber) {
        i = i || { index: s };
        break;
      }
      if (a.removeTokens(n), a.isEmpty()) {
        this._pieces.splice(s, 1), s--, o--;
        continue;
      }
      if (a.endLineNumber < n.startLineNumber)
        continue;
      if (a.startLineNumber > n.endLineNumber) {
        i = i || { index: s };
        continue;
      }
      const [l, c] = a.split(n);
      if (l.isEmpty()) {
        i = i || { index: s };
        continue;
      }
      c.isEmpty() || (this._pieces.splice(s, 1, l, c), s++, o++, i = i || { index: s });
    }
    return i = i || { index: this._pieces.length }, t.length > 0 && (this._pieces = N7(this._pieces, i.index, t)), n;
  }
  isComplete() {
    return this._isComplete;
  }
  addSparseTokens(e, t) {
    if (t.getLineContent().length === 0)
      return t;
    const n = this._pieces;
    if (n.length === 0)
      return t;
    const i = XO._findFirstPieceWithLine(n, e), s = n[i].getLineTokens(e);
    if (!s)
      return t;
    const o = t.getCount(), a = s.getCount();
    let l = 0;
    const c = [];
    let d = 0, u = 0;
    const f = (p, g) => {
      p !== u && (u = p, c[d++] = p, c[d++] = g);
    };
    for (let p = 0; p < a; p++) {
      const g = s.getStartCharacter(p), m = s.getEndCharacter(p), A = s.getMetadata(p), w = ((A & 1 ? 2048 : 0) | (A & 2 ? 4096 : 0) | (A & 4 ? 8192 : 0) | (A & 8 ? 16384 : 0) | (A & 16 ? 16744448 : 0) | (A & 32 ? 4278190080 : 0)) >>> 0, v = ~w >>> 0;
      for (; l < o && t.getEndOffset(l) <= g; )
        f(t.getEndOffset(l), t.getMetadata(l)), l++;
      for (l < o && t.getStartOffset(l) < g && f(g, t.getMetadata(l)); l < o && t.getEndOffset(l) < m; )
        f(t.getEndOffset(l), t.getMetadata(l) & v | A & w), l++;
      if (l < o)
        f(m, t.getMetadata(l) & v | A & w), t.getEndOffset(l) === m && l++;
      else {
        const y = Math.min(Math.max(0, l - 1), o - 1);
        f(m, t.getMetadata(y) & v | A & w);
      }
    }
    for (; l < o; )
      f(t.getEndOffset(l), t.getMetadata(l)), l++;
    return new Ri(new Uint32Array(c), t.getLineContent(), this._languageIdCodec);
  }
  static _findFirstPieceWithLine(e, t) {
    let n = 0, i = e.length - 1;
    for (; n < i; ) {
      let s = n + Math.floor((i - n) / 2);
      if (e[s].endLineNumber < t)
        n = s + 1;
      else if (e[s].startLineNumber > t)
        i = s - 1;
      else {
        for (; s > n && e[s - 1].startLineNumber <= t && t <= e[s - 1].endLineNumber; )
          s--;
        return s;
      }
    }
    return n;
  }
  acceptEdit(e, t, n, i, s) {
    for (const o of this._pieces)
      o.acceptEdit(e, t, n, i, s);
  }
}
class w9 extends bke {
  constructor(e, t, n, i, s, o) {
    super(), this._languageService = e, this._languageConfigurationService = t, this._textModel = n, this._bracketPairsTextModelPart = i, this._languageId = s, this._attachedViews = o, this._semanticTokens = new XO(this._languageService.languageIdCodec), this._onDidChangeLanguage = this._register(new $()), this.onDidChangeLanguage = this._onDidChangeLanguage.event, this._onDidChangeLanguageConfiguration = this._register(new $()), this.onDidChangeLanguageConfiguration = this._onDidChangeLanguageConfiguration.event, this._onDidChangeTokens = this._register(new $()), this.onDidChangeTokens = this._onDidChangeTokens.event, this.grammarTokens = this._register(new k5t(this._languageService.languageIdCodec, this._textModel, () => this._languageId, this._attachedViews)), this._register(this.grammarTokens.onDidChangeTokens((a) => {
      this._emitModelTokensChangedEvent(a);
    })), this._register(this.grammarTokens.onDidChangeBackgroundTokenizationState((a) => {
      this._bracketPairsTextModelPart.handleDidChangeBackgroundTokenizationState();
    }));
  }
  handleLanguageConfigurationServiceChange(e) {
    e.affects(this._languageId) && this._onDidChangeLanguageConfiguration.fire({});
  }
  handleDidChangeContent(e) {
    if (e.isFlush)
      this._semanticTokens.flush();
    else if (!e.isEolChange)
      for (const t of e.changes) {
        const [n, i, s] = mg(t.text);
        this._semanticTokens.acceptEdit(
          t.range,
          n,
          i,
          s,
          t.text.length > 0 ? t.text.charCodeAt(0) : 0
          /* CharCode.Null */
        );
      }
    this.grammarTokens.handleDidChangeContent(e);
  }
  handleDidChangeAttached() {
    this.grammarTokens.handleDidChangeAttached();
  }
  /**
   * Includes grammar and semantic tokens.
   */
  getLineTokens(e) {
    this.validateLineNumber(e);
    const t = this.grammarTokens.getLineTokens(e);
    return this._semanticTokens.addSparseTokens(e, t);
  }
  _emitModelTokensChangedEvent(e) {
    this._textModel._isDisposing() || (this._bracketPairsTextModelPart.handleDidChangeTokens(e), this._onDidChangeTokens.fire(e));
  }
  // #region Grammar Tokens
  validateLineNumber(e) {
    if (e < 1 || e > this._textModel.getLineCount())
      throw new cn("Illegal value for lineNumber");
  }
  get hasTokens() {
    return this.grammarTokens.hasTokens;
  }
  resetTokenization() {
    this.grammarTokens.resetTokenization();
  }
  get backgroundTokenizationState() {
    return this.grammarTokens.backgroundTokenizationState;
  }
  forceTokenization(e) {
    this.validateLineNumber(e), this.grammarTokens.forceTokenization(e);
  }
  hasAccurateTokensForLine(e) {
    return this.validateLineNumber(e), this.grammarTokens.hasAccurateTokensForLine(e);
  }
  isCheapToTokenize(e) {
    return this.validateLineNumber(e), this.grammarTokens.isCheapToTokenize(e);
  }
  tokenizeIfCheap(e) {
    this.validateLineNumber(e), this.grammarTokens.tokenizeIfCheap(e);
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    return this.grammarTokens.getTokenTypeIfInsertingCharacter(e, t, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    return this.grammarTokens.tokenizeLineWithEdit(e, t, n);
  }
  // #endregion
  // #region Semantic Tokens
  setSemanticTokens(e, t) {
    this._semanticTokens.set(e, t), this._emitModelTokensChangedEvent({
      semanticTokensApplied: e !== null,
      ranges: [{ fromLineNumber: 1, toLineNumber: this._textModel.getLineCount() }]
    });
  }
  hasCompleteSemanticTokens() {
    return this._semanticTokens.isComplete();
  }
  hasSomeSemanticTokens() {
    return !this._semanticTokens.isEmpty();
  }
  setPartialSemanticTokens(e, t) {
    if (this.hasCompleteSemanticTokens())
      return;
    const n = this._textModel.validateRange(this._semanticTokens.setPartial(e, t));
    this._emitModelTokensChangedEvent({
      semanticTokensApplied: !0,
      ranges: [
        {
          fromLineNumber: n.startLineNumber,
          toLineNumber: n.endLineNumber
        }
      ]
    });
  }
  // #endregion
  // #region Utility Methods
  getWordAtPosition(e) {
    this.assertNotDisposed();
    const t = this._textModel.validatePosition(e), n = this._textModel.getLineContent(t.lineNumber), i = this.getLineTokens(t.lineNumber), s = i.findTokenIndexAtOffset(t.column - 1), [o, a] = w9._findLanguageBoundaries(i, s), l = O3(t.column, this.getLanguageConfiguration(i.getLanguageId(s)).getWordDefinition(), n.substring(o, a), o);
    if (l && l.startColumn <= e.column && e.column <= l.endColumn)
      return l;
    if (s > 0 && o === t.column - 1) {
      const [c, d] = w9._findLanguageBoundaries(i, s - 1), u = O3(t.column, this.getLanguageConfiguration(i.getLanguageId(s - 1)).getWordDefinition(), n.substring(c, d), c);
      if (u && u.startColumn <= e.column && e.column <= u.endColumn)
        return u;
    }
    return null;
  }
  getLanguageConfiguration(e) {
    return this._languageConfigurationService.getLanguageConfiguration(e);
  }
  static _findLanguageBoundaries(e, t) {
    const n = e.getLanguageId(t);
    let i = 0;
    for (let o = t; o >= 0 && e.getLanguageId(o) === n; o--)
      i = e.getStartOffset(o);
    let s = e.getLineContent().length;
    for (let o = t, a = e.getCount(); o < a && e.getLanguageId(o) === n; o++)
      s = e.getEndOffset(o);
    return [i, s];
  }
  getWordUntilPosition(e) {
    const t = this.getWordAtPosition(e);
    return t ? {
      word: t.word.substr(0, e.column - t.startColumn),
      startColumn: t.startColumn,
      endColumn: e.column
    } : { word: "", startColumn: e.column, endColumn: e.column };
  }
  // #endregion
  // #region Language Id handling
  getLanguageId() {
    return this._languageId;
  }
  getLanguageIdAtPosition(e, t) {
    const n = this._textModel.validatePosition(new le(e, t)), i = this.getLineTokens(n.lineNumber);
    return i.getLanguageId(i.findTokenIndexAtOffset(n.column - 1));
  }
  setLanguageId(e, t = "api") {
    if (this._languageId === e)
      return;
    const n = {
      oldLanguage: this._languageId,
      newLanguage: e,
      source: t
    };
    this._languageId = e, this._bracketPairsTextModelPart.handleDidChangeLanguage(n), this.grammarTokens.resetTokenization(), this._onDidChangeLanguage.fire(n), this._onDidChangeLanguageConfiguration.fire({});
  }
}
class k5t extends me {
  get backgroundTokenizationState() {
    return this._backgroundTokenizationState;
  }
  constructor(e, t, n, i) {
    super(), this._languageIdCodec = e, this._textModel = t, this.getLanguageId = n, this._tokenizer = null, this._defaultBackgroundTokenizer = null, this._backgroundTokenizer = this._register(new Bd()), this._tokens = new n4(this._languageIdCodec), this._debugBackgroundTokenizer = this._register(new Bd()), this._backgroundTokenizationState = 1, this._onDidChangeBackgroundTokenizationState = this._register(new $()), this.onDidChangeBackgroundTokenizationState = this._onDidChangeBackgroundTokenizationState.event, this._onDidChangeTokens = this._register(new $()), this.onDidChangeTokens = this._onDidChangeTokens.event, this._attachedViewStates = this._register(new MI()), this._register(xi.onDidChange((s) => {
      const o = this.getLanguageId();
      s.changedLanguages.indexOf(o) !== -1 && this.resetTokenization();
    })), this.resetTokenization(), this._register(i.onDidChangeVisibleRanges(({ view: s, state: o }) => {
      if (o) {
        let a = this._attachedViewStates.get(s);
        a || (a = new N5t(() => this.refreshRanges(a.lineRanges)), this._attachedViewStates.set(s, a)), a.handleStateChange(o);
      } else
        this._attachedViewStates.deleteAndDispose(s);
    }));
  }
  resetTokenization(e = !0) {
    this._tokens.flush(), this._debugBackgroundTokens?.flush(), this._debugBackgroundStates && (this._debugBackgroundStates = new kL(this._textModel.getLineCount())), e && this._onDidChangeTokens.fire({
      semanticTokensApplied: !1,
      ranges: [
        {
          fromLineNumber: 1,
          toLineNumber: this._textModel.getLineCount()
        }
      ]
    });
    const t = () => {
      if (this._textModel.isTooLargeForTokenization())
        return [null, null];
      const s = xi.get(this.getLanguageId());
      if (!s)
        return [null, null];
      let o;
      try {
        o = s.getInitialState();
      } catch (a) {
        return wn(a), [null, null];
      }
      return [s, o];
    }, [n, i] = t();
    if (n && i ? this._tokenizer = new S5t(this._textModel.getLineCount(), n, this._textModel, this._languageIdCodec) : this._tokenizer = null, this._backgroundTokenizer.clear(), this._defaultBackgroundTokenizer = null, this._tokenizer) {
      const s = {
        setTokens: (o) => {
          this.setTokens(o);
        },
        backgroundTokenizationFinished: () => {
          if (this._backgroundTokenizationState === 2)
            return;
          const o = 2;
          this._backgroundTokenizationState = o, this._onDidChangeBackgroundTokenizationState.fire();
        },
        setEndState: (o, a) => {
          if (!this._tokenizer)
            return;
          const l = this._tokenizer.store.getFirstInvalidEndStateLineNumber();
          l !== null && o >= l && this._tokenizer?.store.setEndState(o, a);
        }
      };
      n && n.createBackgroundTokenizer && !n.backgroundTokenizerShouldOnlyVerifyTokens && (this._backgroundTokenizer.value = n.createBackgroundTokenizer(this._textModel, s)), !this._backgroundTokenizer.value && !this._textModel.isTooLargeForTokenization() && (this._backgroundTokenizer.value = this._defaultBackgroundTokenizer = new L5t(this._tokenizer, s), this._defaultBackgroundTokenizer.handleChanges()), n?.backgroundTokenizerShouldOnlyVerifyTokens && n.createBackgroundTokenizer ? (this._debugBackgroundTokens = new n4(this._languageIdCodec), this._debugBackgroundStates = new kL(this._textModel.getLineCount()), this._debugBackgroundTokenizer.clear(), this._debugBackgroundTokenizer.value = n.createBackgroundTokenizer(this._textModel, {
        setTokens: (o) => {
          this._debugBackgroundTokens?.setMultilineTokens(o, this._textModel);
        },
        backgroundTokenizationFinished() {
        },
        setEndState: (o, a) => {
          this._debugBackgroundStates?.setEndState(o, a);
        }
      })) : (this._debugBackgroundTokens = void 0, this._debugBackgroundStates = void 0, this._debugBackgroundTokenizer.value = void 0);
    }
    this.refreshAllVisibleLineTokens();
  }
  handleDidChangeAttached() {
    this._defaultBackgroundTokenizer?.handleChanges();
  }
  handleDidChangeContent(e) {
    if (e.isFlush)
      this.resetTokenization(!1);
    else if (!e.isEolChange) {
      for (const t of e.changes) {
        const [n, i] = mg(t.text);
        this._tokens.acceptEdit(t.range, n, i), this._debugBackgroundTokens?.acceptEdit(t.range, n, i);
      }
      this._debugBackgroundStates?.acceptChanges(e.changes), this._tokenizer && this._tokenizer.store.acceptChanges(e.changes), this._defaultBackgroundTokenizer?.handleChanges();
    }
  }
  setTokens(e) {
    const { changes: t } = this._tokens.setMultilineTokens(e, this._textModel);
    return t.length > 0 && this._onDidChangeTokens.fire({ semanticTokensApplied: !1, ranges: t }), { changes: t };
  }
  refreshAllVisibleLineTokens() {
    const e = lt.joinMany([...this._attachedViewStates].map(([t, n]) => n.lineRanges));
    this.refreshRanges(e);
  }
  refreshRanges(e) {
    for (const t of e)
      this.refreshRange(t.startLineNumber, t.endLineNumberExclusive - 1);
  }
  refreshRange(e, t) {
    if (!this._tokenizer)
      return;
    e = Math.max(1, Math.min(this._textModel.getLineCount(), e)), t = Math.min(this._textModel.getLineCount(), t);
    const n = new LL(), { heuristicTokens: i } = this._tokenizer.tokenizeHeuristically(n, e, t), s = this.setTokens(n.finalize());
    if (i)
      for (const o of s.changes)
        this._backgroundTokenizer.value?.requestTokens(o.fromLineNumber, o.toLineNumber + 1);
    this._defaultBackgroundTokenizer?.checkFinished();
  }
  forceTokenization(e) {
    const t = new LL();
    this._tokenizer?.updateTokensUntilLine(t, e), this.setTokens(t.finalize()), this._defaultBackgroundTokenizer?.checkFinished();
  }
  hasAccurateTokensForLine(e) {
    return this._tokenizer ? this._tokenizer.hasAccurateTokensForLine(e) : !0;
  }
  isCheapToTokenize(e) {
    return this._tokenizer ? this._tokenizer.isCheapToTokenize(e) : !0;
  }
  tokenizeIfCheap(e) {
    this.isCheapToTokenize(e) && this.forceTokenization(e);
  }
  getLineTokens(e) {
    const t = this._textModel.getLineContent(e), n = this._tokens.getTokens(this._textModel.getLanguageId(), e - 1, t);
    if (this._debugBackgroundTokens && this._debugBackgroundStates && this._tokenizer && this._debugBackgroundStates.getFirstInvalidEndStateLineNumberOrMax() > e && this._tokenizer.store.getFirstInvalidEndStateLineNumberOrMax() > e) {
      const i = this._debugBackgroundTokens.getTokens(this._textModel.getLanguageId(), e - 1, t);
      !n.equals(i) && this._debugBackgroundTokenizer.value?.reportMismatchingTokens && this._debugBackgroundTokenizer.value.reportMismatchingTokens(e);
    }
    return n;
  }
  getTokenTypeIfInsertingCharacter(e, t, n) {
    if (!this._tokenizer)
      return 0;
    const i = this._textModel.validatePosition(new le(e, t));
    return this.forceTokenization(i.lineNumber), this._tokenizer.getTokenTypeIfInsertingCharacter(i, n);
  }
  tokenizeLineWithEdit(e, t, n) {
    if (!this._tokenizer)
      return null;
    const i = this._textModel.validatePosition(e);
    return this.forceTokenization(i.lineNumber), this._tokenizer.tokenizeLineWithEdit(i, t, n);
  }
  get hasTokens() {
    return this._tokens.hasTokens;
  }
}
class N5t extends me {
  get lineRanges() {
    return this._lineRanges;
  }
  constructor(e) {
    super(), this._refreshTokens = e, this.runner = this._register(new Nr(() => this.update(), 50)), this._computedLineRanges = [], this._lineRanges = [];
  }
  update() {
    Zi(this._computedLineRanges, this._lineRanges, (e, t) => e.equals(t)) || (this._computedLineRanges = this._lineRanges, this._refreshTokens());
  }
  handleStateChange(e) {
    this._lineRanges = e.visibleLineRanges, e.stabilized ? (this.runner.cancel(), this.update()) : this.runner.schedule();
  }
}
const JO = Wt("undoRedoService");
class Pke {
  constructor(e, t) {
    this.resource = e, this.elements = t;
  }
}
class v9 {
  static {
    this._ID = 0;
  }
  constructor() {
    this.id = v9._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
  static {
    this.None = new v9();
  }
}
class Mu {
  static {
    this._ID = 0;
  }
  constructor() {
    this.id = Mu._ID++, this.order = 1;
  }
  nextOrder() {
    return this.id === 0 ? 0 : this.order++;
  }
  static {
    this.None = new Mu();
  }
}
var T5t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, s_ = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, o0;
function I5t(r) {
  const e = new Bke();
  return e.acceptChunk(r), e.finish();
}
function O5t(r) {
  const e = new Bke();
  let t;
  for (; typeof (t = r.read()) == "string"; )
    e.acceptChunk(t);
  return e.finish();
}
function n8e(r, e) {
  let t;
  return typeof r == "string" ? t = I5t(r) : Opt(r) ? t = O5t(r) : t = r, t.create(e);
}
let Wv = 0;
const R5t = 999, V5t = 1e4;
class H5t {
  constructor(e) {
    this._source = e, this._eos = !1;
  }
  read() {
    if (this._eos)
      return null;
    const e = [];
    let t = 0, n = 0;
    do {
      const i = this._source.read();
      if (i === null)
        return this._eos = !0, t === 0 ? null : e.join("");
      if (i.length > 0 && (e[t++] = i, n += i.length), n >= 64 * 1024)
        return e.join("");
    } while (!0);
  }
}
const zm = () => {
  throw new Error("Invalid change accessor");
};
let NL = class extends me {
  static {
    o0 = this;
  }
  static {
    this._MODEL_SYNC_LIMIT = 50 * 1024 * 1024;
  }
  static {
    this.LARGE_FILE_SIZE_THRESHOLD = 20 * 1024 * 1024;
  }
  static {
    this.LARGE_FILE_LINE_COUNT_THRESHOLD = 300 * 1e3;
  }
  static {
    this.LARGE_FILE_HEAP_OPERATION_THRESHOLD = 256 * 1024 * 1024;
  }
  static {
    this.DEFAULT_CREATION_OPTIONS = {
      isForSimpleWidget: !1,
      tabSize: Hr.tabSize,
      indentSize: Hr.indentSize,
      insertSpaces: Hr.insertSpaces,
      detectIndentation: !1,
      defaultEOL: 1,
      trimAutoWhitespace: Hr.trimAutoWhitespace,
      largeFileOptimizations: Hr.largeFileOptimizations,
      bracketPairColorizationOptions: Hr.bracketPairColorizationOptions
    };
  }
  static resolveOptions(e, t) {
    if (t.detectIndentation) {
      const n = G6e(e, t.tabSize, t.insertSpaces);
      return new w6({
        tabSize: n.tabSize,
        indentSize: "tabSize",
        // TODO@Alex: guess indentSize independent of tabSize
        insertSpaces: n.insertSpaces,
        trimAutoWhitespace: t.trimAutoWhitespace,
        defaultEOL: t.defaultEOL,
        bracketPairColorizationOptions: t.bracketPairColorizationOptions
      });
    }
    return new w6(t);
  }
  get onDidChangeLanguage() {
    return this._tokenizationTextModelPart.onDidChangeLanguage;
  }
  get onDidChangeLanguageConfiguration() {
    return this._tokenizationTextModelPart.onDidChangeLanguageConfiguration;
  }
  get onDidChangeTokens() {
    return this._tokenizationTextModelPart.onDidChangeTokens;
  }
  onDidChangeContent(e) {
    return this._eventEmitter.slowEvent((t) => e(t.contentChangedEvent));
  }
  onDidChangeContentOrInjectedText(e) {
    return ih(this._eventEmitter.fastEvent((t) => e(t)), this._onDidChangeInjectedText.event((t) => e(t)));
  }
  _isDisposing() {
    return this.__isDisposing;
  }
  get tokenization() {
    return this._tokenizationTextModelPart;
  }
  get bracketPairs() {
    return this._bracketPairs;
  }
  get guides() {
    return this._guidesTextModelPart;
  }
  constructor(e, t, n, i = null, s, o, a) {
    super(), this._undoRedoService = s, this._languageService = o, this._languageConfigurationService = a, this._onWillDispose = this._register(new $()), this.onWillDispose = this._onWillDispose.event, this._onDidChangeDecorations = this._register(new j5t((p) => this.handleBeforeFireDecorationsChangedEvent(p))), this.onDidChangeDecorations = this._onDidChangeDecorations.event, this._onDidChangeOptions = this._register(new $()), this.onDidChangeOptions = this._onDidChangeOptions.event, this._onDidChangeAttached = this._register(new $()), this.onDidChangeAttached = this._onDidChangeAttached.event, this._onDidChangeInjectedText = this._register(new $()), this._eventEmitter = this._register(new Z5t()), this._languageSelectionListener = this._register(new Bd()), this._deltaDecorationCallCnt = 0, this._attachedViews = new U5t(), Wv++, this.id = "$model" + Wv, this.isForSimpleWidget = n.isForSimpleWidget, typeof i > "u" || i === null ? this._associatedResource = Pt.parse("inmemory://model/" + Wv) : this._associatedResource = i, this._attachedEditorCount = 0;
    const { textBuffer: l, disposable: c } = n8e(e, n.defaultEOL);
    this._buffer = l, this._bufferDisposable = c, this._options = o0.resolveOptions(this._buffer, n);
    const d = typeof t == "string" ? t : t.languageId;
    typeof t != "string" && (this._languageSelectionListener.value = t.onDidChange(() => this._setLanguage(t.languageId))), this._bracketPairs = this._register(new Zvt(this, this._languageConfigurationService)), this._guidesTextModelPart = this._register(new Iwt(this, this._languageConfigurationService)), this._decorationProvider = this._register(new qvt(this)), this._tokenizationTextModelPart = new w9(this._languageService, this._languageConfigurationService, this, this._bracketPairs, d, this._attachedViews);
    const u = this._buffer.getLineCount(), f = this._buffer.getValueLengthInRange(
      new Q(1, 1, u, this._buffer.getLineLength(u) + 1),
      0
      /* model.EndOfLinePreference.TextDefined */
    );
    n.largeFileOptimizations ? (this._isTooLargeForTokenization = f > o0.LARGE_FILE_SIZE_THRESHOLD || u > o0.LARGE_FILE_LINE_COUNT_THRESHOLD, this._isTooLargeForHeapOperation = f > o0.LARGE_FILE_HEAP_OPERATION_THRESHOLD) : (this._isTooLargeForTokenization = !1, this._isTooLargeForHeapOperation = !1), this._isTooLargeForSyncing = f > o0._MODEL_SYNC_LIMIT, this._versionId = 1, this._alternativeVersionId = 1, this._initialUndoRedoSnapshot = null, this._isDisposed = !1, this.__isDisposing = !1, this._instanceId = oDe(Wv), this._lastDecorationId = 0, this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new i8e(), this._commandManager = new GO(this, this._undoRedoService), this._isUndoing = !1, this._isRedoing = !1, this._trimAutoWhitespaceLines = null, this._register(this._decorationProvider.onDidChange(() => {
      this._onDidChangeDecorations.beginDeferredEmit(), this._onDidChangeDecorations.fire(), this._onDidChangeDecorations.endDeferredEmit();
    })), this._languageService.requestRichLanguageFeatures(d), this._register(this._languageConfigurationService.onDidChange((p) => {
      this._bracketPairs.handleLanguageConfigurationServiceChange(p), this._tokenizationTextModelPart.handleLanguageConfigurationServiceChange(p);
    }));
  }
  dispose() {
    this.__isDisposing = !0, this._onWillDispose.fire(), this._tokenizationTextModelPart.dispose(), this._isDisposed = !0, super.dispose(), this._bufferDisposable.dispose(), this.__isDisposing = !1;
    const e = new Lp([], "", `
`, !1, !1, !0, !0);
    e.dispose(), this._buffer = e, this._bufferDisposable = me.None;
  }
  _assertNotDisposed() {
    if (this._isDisposed)
      throw new cn("Model is disposed!");
  }
  _emitContentChangedEvent(e, t) {
    this.__isDisposing || (this._tokenizationTextModelPart.handleDidChangeContent(t), this._bracketPairs.handleDidChangeContent(t), this._eventEmitter.fire(new K0(e, t)));
  }
  setValue(e) {
    if (this._assertNotDisposed(), e == null)
      throw I7();
    const { textBuffer: t, disposable: n } = n8e(e, this._options.defaultEOL);
    this._setValueFromTextBuffer(t, n);
  }
  _createContentChanged2(e, t, n, i, s, o, a, l) {
    return {
      changes: [{
        range: e,
        rangeOffset: t,
        rangeLength: n,
        text: i
      }],
      eol: this._buffer.getEOL(),
      isEolChange: l,
      versionId: this.getVersionId(),
      isUndoing: s,
      isRedoing: o,
      isFlush: a
    };
  }
  _setValueFromTextBuffer(e, t) {
    this._assertNotDisposed();
    const n = this.getFullModelRange(), i = this.getValueLengthInRange(n), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._buffer = e, this._bufferDisposable.dispose(), this._bufferDisposable = t, this._increaseVersionId(), this._decorations = /* @__PURE__ */ Object.create(null), this._decorationsTree = new i8e(), this._commandManager.clear(), this._trimAutoWhitespaceLines = null, this._emitContentChangedEvent(new Sp([
      new dvt()
    ], this._versionId, !1, !1), this._createContentChanged2(new Q(1, 1, s, o), 0, i, this.getValue(), !1, !1, !0, !1));
  }
  setEOL(e) {
    this._assertNotDisposed();
    const t = e === 1 ? `\r
` : `
`;
    if (this._buffer.getEOL() === t)
      return;
    const n = this.getFullModelRange(), i = this.getValueLengthInRange(n), s = this.getLineCount(), o = this.getLineMaxColumn(s);
    this._onBeforeEOLChange(), this._buffer.setEOL(t), this._increaseVersionId(), this._onAfterEOLChange(), this._emitContentChangedEvent(new Sp([
      new pvt()
    ], this._versionId, !1, !1), this._createContentChanged2(new Q(1, 1, s, o), 0, i, this.getValue(), !1, !1, !1, !0));
  }
  _onBeforeEOLChange() {
    this._decorationsTree.ensureAllNodesHaveRanges(this);
  }
  _onAfterEOLChange() {
    const e = this.getVersionId(), t = this._decorationsTree.collectNodesPostOrder();
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n], o = s.range, a = s.cachedAbsoluteStart - s.start, l = this._buffer.getOffsetAt(o.startLineNumber, o.startColumn), c = this._buffer.getOffsetAt(o.endLineNumber, o.endColumn);
      s.cachedAbsoluteStart = l, s.cachedAbsoluteEnd = c, s.cachedVersionId = e, s.start = l - a, s.end = c - a, p1(s);
    }
  }
  onBeforeAttached() {
    return this._attachedEditorCount++, this._attachedEditorCount === 1 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.attachView();
  }
  onBeforeDetached(e) {
    this._attachedEditorCount--, this._attachedEditorCount === 0 && (this._tokenizationTextModelPart.handleDidChangeAttached(), this._onDidChangeAttached.fire(void 0)), this._attachedViews.detachView(e);
  }
  isAttachedToEditor() {
    return this._attachedEditorCount > 0;
  }
  getAttachedEditorCount() {
    return this._attachedEditorCount;
  }
  isTooLargeForSyncing() {
    return this._isTooLargeForSyncing;
  }
  isTooLargeForTokenization() {
    return this._isTooLargeForTokenization;
  }
  isTooLargeForHeapOperation() {
    return this._isTooLargeForHeapOperation;
  }
  isDisposed() {
    return this._isDisposed;
  }
  isDominatedByLongLines() {
    if (this._assertNotDisposed(), this.isTooLargeForTokenization())
      return !1;
    let e = 0, t = 0;
    const n = this._buffer.getLineCount();
    for (let i = 1; i <= n; i++) {
      const s = this._buffer.getLineLength(i);
      s >= V5t ? t += s : e += s;
    }
    return t > e;
  }
  get uri() {
    return this._associatedResource;
  }
  //#region Options
  getOptions() {
    return this._assertNotDisposed(), this._options;
  }
  getFormattingOptions() {
    return {
      tabSize: this._options.indentSize,
      insertSpaces: this._options.insertSpaces
    };
  }
  updateOptions(e) {
    this._assertNotDisposed();
    const t = typeof e.tabSize < "u" ? e.tabSize : this._options.tabSize, n = typeof e.indentSize < "u" ? e.indentSize : this._options.originalIndentSize, i = typeof e.insertSpaces < "u" ? e.insertSpaces : this._options.insertSpaces, s = typeof e.trimAutoWhitespace < "u" ? e.trimAutoWhitespace : this._options.trimAutoWhitespace, o = typeof e.bracketColorizationOptions < "u" ? e.bracketColorizationOptions : this._options.bracketPairColorizationOptions, a = new w6({
      tabSize: t,
      indentSize: n,
      insertSpaces: i,
      defaultEOL: this._options.defaultEOL,
      trimAutoWhitespace: s,
      bracketPairColorizationOptions: o
    });
    if (this._options.equals(a))
      return;
    const l = this._options.createChangeEvent(a);
    this._options = a, this._bracketPairs.handleDidChangeOptions(l), this._decorationProvider.handleDidChangeOptions(l), this._onDidChangeOptions.fire(l);
  }
  detectIndentation(e, t) {
    this._assertNotDisposed();
    const n = G6e(this._buffer, t, e);
    this.updateOptions({
      insertSpaces: n.insertSpaces,
      tabSize: n.tabSize,
      indentSize: n.tabSize
      // TODO@Alex: guess indentSize independent of tabSize
    });
  }
  normalizeIndentation(e) {
    return this._assertNotDisposed(), cke(e, this._options.indentSize, this._options.insertSpaces);
  }
  //#endregion
  //#region Reading
  getVersionId() {
    return this._assertNotDisposed(), this._versionId;
  }
  mightContainRTL() {
    return this._buffer.mightContainRTL();
  }
  mightContainUnusualLineTerminators() {
    return this._buffer.mightContainUnusualLineTerminators();
  }
  removeUnusualLineTerminators(e = null) {
    const t = this.findMatches(
      rDe.source,
      !1,
      !0,
      !1,
      null,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    );
    this._buffer.resetMightContainUnusualLineTerminators(), this.pushEditOperations(e, t.map((n) => ({ range: n.range, text: null })), () => null);
  }
  mightContainNonBasicASCII() {
    return this._buffer.mightContainNonBasicASCII();
  }
  getAlternativeVersionId() {
    return this._assertNotDisposed(), this._alternativeVersionId;
  }
  getInitialUndoRedoSnapshot() {
    return this._assertNotDisposed(), this._initialUndoRedoSnapshot;
  }
  getOffsetAt(e) {
    this._assertNotDisposed();
    const t = this._validatePosition(
      e.lineNumber,
      e.column,
      0
      /* StringOffsetValidationType.Relaxed */
    );
    return this._buffer.getOffsetAt(t.lineNumber, t.column);
  }
  getPositionAt(e) {
    this._assertNotDisposed();
    const t = Math.min(this._buffer.getLength(), Math.max(0, e));
    return this._buffer.getPositionAt(t);
  }
  _increaseVersionId() {
    this._versionId = this._versionId + 1, this._alternativeVersionId = this._versionId;
  }
  _overwriteVersionId(e) {
    this._versionId = e;
  }
  _overwriteAlternativeVersionId(e) {
    this._alternativeVersionId = e;
  }
  _overwriteInitialUndoRedoSnapshot(e) {
    this._initialUndoRedoSnapshot = e;
  }
  getValue(e, t = !1) {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation())
      throw new cn("Operation would exceed heap memory limits");
    const n = this.getFullModelRange(), i = this.getValueInRange(n, e);
    return t ? this._buffer.getBOM() + i : i;
  }
  createSnapshot(e = !1) {
    return new H5t(this._buffer.createSnapshot(e));
  }
  getValueLength(e, t = !1) {
    this._assertNotDisposed();
    const n = this.getFullModelRange(), i = this.getValueLengthInRange(n, e);
    return t ? this._buffer.getBOM().length + i : i;
  }
  getValueInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getValueInRange(this.validateRange(e), t);
  }
  getValueLengthInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getValueLengthInRange(this.validateRange(e), t);
  }
  getCharacterCountInRange(e, t = 0) {
    return this._assertNotDisposed(), this._buffer.getCharacterCountInRange(this.validateRange(e), t);
  }
  getLineCount() {
    return this._assertNotDisposed(), this._buffer.getLineCount();
  }
  getLineContent(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new cn("Illegal value for lineNumber");
    return this._buffer.getLineContent(e);
  }
  getLineLength(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new cn("Illegal value for lineNumber");
    return this._buffer.getLineLength(e);
  }
  getLinesContent() {
    if (this._assertNotDisposed(), this.isTooLargeForHeapOperation())
      throw new cn("Operation would exceed heap memory limits");
    return this._buffer.getLinesContent();
  }
  getEOL() {
    return this._assertNotDisposed(), this._buffer.getEOL();
  }
  getEndOfLineSequence() {
    return this._assertNotDisposed(), this._buffer.getEOL() === `
` ? 0 : 1;
  }
  getLineMinColumn(e) {
    return this._assertNotDisposed(), 1;
  }
  getLineMaxColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new cn("Illegal value for lineNumber");
    return this._buffer.getLineLength(e) + 1;
  }
  getLineFirstNonWhitespaceColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new cn("Illegal value for lineNumber");
    return this._buffer.getLineFirstNonWhitespaceColumn(e);
  }
  getLineLastNonWhitespaceColumn(e) {
    if (this._assertNotDisposed(), e < 1 || e > this.getLineCount())
      throw new cn("Illegal value for lineNumber");
    return this._buffer.getLineLastNonWhitespaceColumn(e);
  }
  /**
   * Validates `range` is within buffer bounds, but allows it to sit in between surrogate pairs, etc.
   * Will try to not allocate if possible.
   */
  _validateRangeRelaxedNoAllocations(e) {
    const t = this._buffer.getLineCount(), n = e.startLineNumber, i = e.startColumn;
    let s = Math.floor(typeof n == "number" && !isNaN(n) ? n : 1), o = Math.floor(typeof i == "number" && !isNaN(i) ? i : 1);
    if (s < 1)
      s = 1, o = 1;
    else if (s > t)
      s = t, o = this.getLineMaxColumn(s);
    else if (o <= 1)
      o = 1;
    else {
      const u = this.getLineMaxColumn(s);
      o >= u && (o = u);
    }
    const a = e.endLineNumber, l = e.endColumn;
    let c = Math.floor(typeof a == "number" && !isNaN(a) ? a : 1), d = Math.floor(typeof l == "number" && !isNaN(l) ? l : 1);
    if (c < 1)
      c = 1, d = 1;
    else if (c > t)
      c = t, d = this.getLineMaxColumn(c);
    else if (d <= 1)
      d = 1;
    else {
      const u = this.getLineMaxColumn(c);
      d >= u && (d = u);
    }
    return n === s && i === o && a === c && l === d && e instanceof Q && !(e instanceof _n) ? e : new Q(s, o, c, d);
  }
  _isValidPosition(e, t, n) {
    if (typeof e != "number" || typeof t != "number" || isNaN(e) || isNaN(t) || e < 1 || t < 1 || (e | 0) !== e || (t | 0) !== t)
      return !1;
    const i = this._buffer.getLineCount();
    if (e > i)
      return !1;
    if (t === 1)
      return !0;
    const s = this.getLineMaxColumn(e);
    if (t > s)
      return !1;
    if (n === 1) {
      const o = this._buffer.getLineCharCode(e, t - 2);
      if (Ki(o))
        return !1;
    }
    return !0;
  }
  _validatePosition(e, t, n) {
    const i = Math.floor(typeof e == "number" && !isNaN(e) ? e : 1), s = Math.floor(typeof t == "number" && !isNaN(t) ? t : 1), o = this._buffer.getLineCount();
    if (i < 1)
      return new le(1, 1);
    if (i > o)
      return new le(o, this.getLineMaxColumn(o));
    if (s <= 1)
      return new le(i, 1);
    const a = this.getLineMaxColumn(i);
    if (s >= a)
      return new le(i, a);
    if (n === 1) {
      const l = this._buffer.getLineCharCode(i, s - 2);
      if (Ki(l))
        return new le(i, s - 1);
    }
    return new le(i, s);
  }
  validatePosition(e) {
    return this._assertNotDisposed(), e instanceof le && this._isValidPosition(e.lineNumber, e.column, 1) ? e : this._validatePosition(e.lineNumber, e.column, 1);
  }
  _isValidRange(e, t) {
    const n = e.startLineNumber, i = e.startColumn, s = e.endLineNumber, o = e.endColumn;
    if (!this._isValidPosition(
      n,
      i,
      0
      /* StringOffsetValidationType.Relaxed */
    ) || !this._isValidPosition(
      s,
      o,
      0
      /* StringOffsetValidationType.Relaxed */
    ))
      return !1;
    if (t === 1) {
      const a = i > 1 ? this._buffer.getLineCharCode(n, i - 2) : 0, l = o > 1 && o <= this._buffer.getLineLength(s) ? this._buffer.getLineCharCode(s, o - 2) : 0, c = Ki(a), d = Ki(l);
      return !c && !d;
    }
    return !0;
  }
  validateRange(e) {
    if (this._assertNotDisposed(), e instanceof Q && !(e instanceof _n) && this._isValidRange(e, 1))
      return e;
    const n = this._validatePosition(
      e.startLineNumber,
      e.startColumn,
      0
      /* StringOffsetValidationType.Relaxed */
    ), i = this._validatePosition(
      e.endLineNumber,
      e.endColumn,
      0
      /* StringOffsetValidationType.Relaxed */
    ), s = n.lineNumber, o = n.column, a = i.lineNumber, l = i.column;
    {
      const c = o > 1 ? this._buffer.getLineCharCode(s, o - 2) : 0, d = l > 1 && l <= this._buffer.getLineLength(a) ? this._buffer.getLineCharCode(a, l - 2) : 0, u = Ki(c), f = Ki(d);
      return !u && !f ? new Q(s, o, a, l) : s === a && o === l ? new Q(s, o - 1, a, l - 1) : u && f ? new Q(s, o - 1, a, l + 1) : u ? new Q(s, o - 1, a, l) : new Q(s, o, a, l + 1);
    }
  }
  modifyPosition(e, t) {
    this._assertNotDisposed();
    const n = this.getOffsetAt(e) + t;
    return this.getPositionAt(Math.min(this._buffer.getLength(), Math.max(0, n)));
  }
  getFullModelRange() {
    this._assertNotDisposed();
    const e = this.getLineCount();
    return new Q(1, 1, e, this.getLineMaxColumn(e));
  }
  findMatchesLineByLine(e, t, n, i) {
    return this._buffer.findMatchesLineByLine(e, t, n, i);
  }
  findMatches(e, t, n, i, s, o, a = R5t) {
    this._assertNotDisposed();
    let l = null;
    t !== null && (Array.isArray(t) || (t = [t]), t.every((u) => Q.isIRange(u)) && (l = t.map((u) => this.validateRange(u)))), l === null && (l = [this.getFullModelRange()]), l = l.sort((u, f) => u.startLineNumber - f.startLineNumber || u.startColumn - f.startColumn);
    const c = [];
    c.push(l.reduce((u, f) => Q.areIntersecting(u, f) ? u.plusRange(f) : (c.push(u), f)));
    let d;
    if (!n && e.indexOf(`
`) < 0) {
      const f = new r0(e, n, i, s).parseSearchRequest();
      if (!f)
        return [];
      d = (p) => this.findMatchesLineByLine(p, f, o, a);
    } else
      d = (u) => Tv.findMatches(this, new r0(e, n, i, s), u, o, a);
    return c.map(d).reduce((u, f) => u.concat(f), []);
  }
  findNextMatch(e, t, n, i, s, o) {
    this._assertNotDisposed();
    const a = this.validatePosition(t);
    if (!n && e.indexOf(`
`) < 0) {
      const c = new r0(e, n, i, s).parseSearchRequest();
      if (!c)
        return null;
      const d = this.getLineCount();
      let u = new Q(a.lineNumber, a.column, d, this.getLineMaxColumn(d)), f = this.findMatchesLineByLine(u, c, o, 1);
      return Tv.findNextMatch(this, new r0(e, n, i, s), a, o), f.length > 0 || (u = new Q(1, 1, a.lineNumber, this.getLineMaxColumn(a.lineNumber)), f = this.findMatchesLineByLine(u, c, o, 1), f.length > 0) ? f[0] : null;
    }
    return Tv.findNextMatch(this, new r0(e, n, i, s), a, o);
  }
  findPreviousMatch(e, t, n, i, s, o) {
    this._assertNotDisposed();
    const a = this.validatePosition(t);
    return Tv.findPreviousMatch(this, new r0(e, n, i, s), a, o);
  }
  //#endregion
  //#region Editing
  pushStackElement() {
    this._commandManager.pushStackElement();
  }
  popStackElement() {
    this._commandManager.popStackElement();
  }
  pushEOL(e) {
    if ((this.getEOL() === `
` ? 0 : 1) !== e)
      try {
        this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEOL(e);
      } finally {
        this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
      }
  }
  _validateEditOperation(e) {
    return e instanceof PE ? e : new PE(e.identifier || null, this.validateRange(e.range), e.text, e.forceMoveMarkers || !1, e.isAutoWhitespaceEdit || !1, e._isTracked || !1);
  }
  _validateEditOperations(e) {
    const t = [];
    for (let n = 0, i = e.length; n < i; n++)
      t[n] = this._validateEditOperation(e[n]);
    return t;
  }
  pushEditOperations(e, t, n, i) {
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._pushEditOperations(e, this._validateEditOperations(t), n, i);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _pushEditOperations(e, t, n, i) {
    if (this._options.trimAutoWhitespace && this._trimAutoWhitespaceLines) {
      const s = t.map((a) => ({
        range: this.validateRange(a.range),
        text: a.text
      }));
      let o = !0;
      if (e)
        for (let a = 0, l = e.length; a < l; a++) {
          const c = e[a];
          let d = !1;
          for (let u = 0, f = s.length; u < f; u++) {
            const p = s[u].range, g = p.startLineNumber > c.endLineNumber, m = c.startLineNumber > p.endLineNumber;
            if (!g && !m) {
              d = !0;
              break;
            }
          }
          if (!d) {
            o = !1;
            break;
          }
        }
      if (o)
        for (let a = 0, l = this._trimAutoWhitespaceLines.length; a < l; a++) {
          const c = this._trimAutoWhitespaceLines[a], d = this.getLineMaxColumn(c);
          let u = !0;
          for (let f = 0, p = s.length; f < p; f++) {
            const g = s[f].range, m = s[f].text;
            if (!(c < g.startLineNumber || c > g.endLineNumber) && !(c === g.startLineNumber && g.startColumn === d && g.isEmpty() && m && m.length > 0 && m.charAt(0) === `
`) && !(c === g.startLineNumber && g.startColumn === 1 && g.isEmpty() && m && m.length > 0 && m.charAt(m.length - 1) === `
`)) {
              u = !1;
              break;
            }
          }
          if (u) {
            const f = new Q(c, 1, c, d);
            t.push(new PE(null, f, null, !1, !1, !1));
          }
        }
      this._trimAutoWhitespaceLines = null;
    }
    return this._initialUndoRedoSnapshot === null && (this._initialUndoRedoSnapshot = this._undoRedoService.createSnapshot(this.uri)), this._commandManager.pushEditOperation(e, t, n, i);
  }
  _applyUndo(e, t, n, i) {
    const s = e.map((o) => {
      const a = this.getPositionAt(o.newPosition), l = this.getPositionAt(o.newEnd);
      return {
        range: new Q(a.lineNumber, a.column, l.lineNumber, l.column),
        text: o.oldText
      };
    });
    this._applyUndoRedoEdits(s, t, !0, !1, n, i);
  }
  _applyRedo(e, t, n, i) {
    const s = e.map((o) => {
      const a = this.getPositionAt(o.oldPosition), l = this.getPositionAt(o.oldEnd);
      return {
        range: new Q(a.lineNumber, a.column, l.lineNumber, l.column),
        text: o.newText
      };
    });
    this._applyUndoRedoEdits(s, t, !1, !0, n, i);
  }
  _applyUndoRedoEdits(e, t, n, i, s, o) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit(), this._isUndoing = n, this._isRedoing = i, this.applyEdits(e, !1), this.setEOL(t), this._overwriteAlternativeVersionId(s);
    } finally {
      this._isUndoing = !1, this._isRedoing = !1, this._eventEmitter.endDeferredEmit(o), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  applyEdits(e, t = !1) {
    try {
      this._onDidChangeDecorations.beginDeferredEmit(), this._eventEmitter.beginDeferredEmit();
      const n = this._validateEditOperations(e);
      return this._doApplyEdits(n, t);
    } finally {
      this._eventEmitter.endDeferredEmit(), this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _doApplyEdits(e, t) {
    const n = this._buffer.getLineCount(), i = this._buffer.applyEdits(e, this._options.trimAutoWhitespace, t), s = this._buffer.getLineCount(), o = i.changes;
    if (this._trimAutoWhitespaceLines = i.trimAutoWhitespaceLineNumbers, o.length !== 0) {
      for (let c = 0, d = o.length; c < d; c++) {
        const u = o[c];
        this._decorationsTree.acceptReplace(u.rangeOffset, u.rangeLength, u.text.length, u.forceMoveMarkers);
      }
      const a = [];
      this._increaseVersionId();
      let l = n;
      for (let c = 0, d = o.length; c < d; c++) {
        const u = o[c], [f] = mg(u.text);
        this._onDidChangeDecorations.fire();
        const p = u.range.startLineNumber, g = u.range.endLineNumber, m = g - p, A = f, w = Math.min(m, A), v = A - m, y = s - l - v + p, _ = y, S = y + A, D = this._decorationsTree.getInjectedTextInInterval(this, this.getOffsetAt(new le(_, 1)), this.getOffsetAt(new le(S, this.getLineMaxColumn(S))), 0), M = sc.fromDecorations(D), L = new Hd(M);
        for (let T = w; T >= 0; T--) {
          const B = p + T, V = y + T;
          L.takeFromEndWhile((R) => R.lineNumber > V);
          const N = L.takeFromEndWhile((R) => R.lineNumber === V);
          a.push(new H6e(B, this.getLineContent(V), N));
        }
        if (w < m) {
          const T = p + w;
          a.push(new uvt(T + 1, g));
        }
        if (w < A) {
          const T = new Hd(M), B = p + w, V = A - w, N = s - l - V + B + 1, R = [], H = [];
          for (let z = 0; z < V; z++) {
            const U = N + z;
            H[z] = this.getLineContent(U), T.takeWhile((ee) => ee.lineNumber < U), R[z] = T.takeWhile((ee) => ee.lineNumber === U);
          }
          a.push(new fvt(B + 1, p + A, H, R));
        }
        l += v;
      }
      this._emitContentChangedEvent(new Sp(a, this.getVersionId(), this._isUndoing, this._isRedoing), {
        changes: o,
        eol: this._buffer.getEOL(),
        isEolChange: !1,
        versionId: this.getVersionId(),
        isUndoing: this._isUndoing,
        isRedoing: this._isRedoing,
        isFlush: !1
      });
    }
    return i.reverseEdits === null ? void 0 : i.reverseEdits;
  }
  undo() {
    return this._undoRedoService.undo(this.uri);
  }
  canUndo() {
    return this._undoRedoService.canUndo(this.uri);
  }
  redo() {
    return this._undoRedoService.redo(this.uri);
  }
  canRedo() {
    return this._undoRedoService.canRedo(this.uri);
  }
  //#endregion
  //#region Decorations
  handleBeforeFireDecorationsChangedEvent(e) {
    if (e === null || e.size === 0)
      return;
    const n = Array.from(e).map((i) => new H6e(i, this.getLineContent(i), this._getInjectedTextInLine(i)));
    this._onDidChangeInjectedText.fire(new Eke(n));
  }
  changeDecorations(e, t = 0) {
    this._assertNotDisposed();
    try {
      return this._onDidChangeDecorations.beginDeferredEmit(), this._changeDecorations(t, e);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  _changeDecorations(e, t) {
    const n = {
      addDecoration: (s, o) => this._deltaDecorationsImpl(e, [], [{ range: s, options: o }])[0],
      changeDecoration: (s, o) => {
        this._changeDecorationImpl(s, o);
      },
      changeDecorationOptions: (s, o) => {
        this._changeDecorationOptionsImpl(s, s8e(o));
      },
      removeDecoration: (s) => {
        this._deltaDecorationsImpl(e, [s], []);
      },
      deltaDecorations: (s, o) => s.length === 0 && o.length === 0 ? [] : this._deltaDecorationsImpl(e, s, o)
    };
    let i = null;
    try {
      i = t(n);
    } catch (s) {
      wn(s);
    }
    return n.addDecoration = zm, n.changeDecoration = zm, n.changeDecorationOptions = zm, n.removeDecoration = zm, n.deltaDecorations = zm, i;
  }
  deltaDecorations(e, t, n = 0) {
    if (this._assertNotDisposed(), e || (e = []), e.length === 0 && t.length === 0)
      return [];
    try {
      return this._deltaDecorationCallCnt++, this._deltaDecorationCallCnt > 1 && (console.warn("Invoking deltaDecorations recursively could lead to leaking decorations."), wn(new Error("Invoking deltaDecorations recursively could lead to leaking decorations."))), this._onDidChangeDecorations.beginDeferredEmit(), this._deltaDecorationsImpl(n, e, t);
    } finally {
      this._onDidChangeDecorations.endDeferredEmit(), this._deltaDecorationCallCnt--;
    }
  }
  _getTrackedRange(e) {
    return this.getDecorationRange(e);
  }
  _setTrackedRange(e, t, n) {
    const i = e ? this._decorations[e] : null;
    if (!i)
      return t ? this._deltaDecorationsImpl(0, [], [{ range: t, options: r8e[n] }], !0)[0] : null;
    if (!t)
      return this._decorationsTree.delete(i), delete this._decorations[i.id], null;
    const s = this._validateRangeRelaxedNoAllocations(t), o = this._buffer.getOffsetAt(s.startLineNumber, s.startColumn), a = this._buffer.getOffsetAt(s.endLineNumber, s.endColumn);
    return this._decorationsTree.delete(i), i.reset(this.getVersionId(), o, a, s), i.setOptions(r8e[n]), this._decorationsTree.insert(i), i.id;
  }
  removeAllDecorationsWithOwnerId(e) {
    if (this._isDisposed)
      return;
    const t = this._decorationsTree.collectNodesFromOwner(e);
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      this._decorationsTree.delete(s), delete this._decorations[s.id];
    }
  }
  getDecorationOptions(e) {
    const t = this._decorations[e];
    return t ? t.options : null;
  }
  getDecorationRange(e) {
    const t = this._decorations[e];
    return t ? this._decorationsTree.getNodeRange(this, t) : null;
  }
  getLineDecorations(e, t = 0, n = !1) {
    return e < 1 || e > this.getLineCount() ? [] : this.getLinesDecorations(e, e, t, n);
  }
  getLinesDecorations(e, t, n = 0, i = !1, s = !1) {
    const o = this.getLineCount(), a = Math.min(o, Math.max(1, e)), l = Math.min(o, Math.max(1, t)), c = this.getLineMaxColumn(l), d = new Q(a, 1, l, c), u = this._getDecorationsInRange(d, n, i, s);
    return DM(u, this._decorationProvider.getDecorationsInRange(d, n, i)), u;
  }
  getDecorationsInRange(e, t = 0, n = !1, i = !1, s = !1) {
    const o = this.validateRange(e), a = this._getDecorationsInRange(o, t, n, s);
    return DM(a, this._decorationProvider.getDecorationsInRange(o, t, n, i)), a;
  }
  getOverviewRulerDecorations(e = 0, t = !1) {
    return this._decorationsTree.getAll(this, e, t, !0, !1);
  }
  getInjectedTextDecorations(e = 0) {
    return this._decorationsTree.getAllInjectedText(this, e);
  }
  _getInjectedTextInLine(e) {
    const t = this._buffer.getOffsetAt(e, 1), n = t + this._buffer.getLineLength(e), i = this._decorationsTree.getInjectedTextInInterval(this, t, n, 0);
    return sc.fromDecorations(i).filter((s) => s.lineNumber === e);
  }
  getAllDecorations(e = 0, t = !1) {
    let n = this._decorationsTree.getAll(this, e, t, !1, !1);
    return n = n.concat(this._decorationProvider.getAllDecorations(e, t)), n;
  }
  getAllMarginDecorations(e = 0) {
    return this._decorationsTree.getAll(this, e, !1, !1, !0);
  }
  _getDecorationsInRange(e, t, n, i) {
    const s = this._buffer.getOffsetAt(e.startLineNumber, e.startColumn), o = this._buffer.getOffsetAt(e.endLineNumber, e.endColumn);
    return this._decorationsTree.getAllInInterval(this, s, o, t, n, i);
  }
  getRangeAt(e, t) {
    return this._buffer.getRangeAt(e, t - e);
  }
  _changeDecorationImpl(e, t) {
    const n = this._decorations[e];
    if (!n)
      return;
    if (n.options.after) {
      const a = this.getDecorationRange(e);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.endLineNumber);
    }
    if (n.options.before) {
      const a = this.getDecorationRange(e);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(a.startLineNumber);
    }
    const i = this._validateRangeRelaxedNoAllocations(t), s = this._buffer.getOffsetAt(i.startLineNumber, i.startColumn), o = this._buffer.getOffsetAt(i.endLineNumber, i.endColumn);
    this._decorationsTree.delete(n), n.reset(this.getVersionId(), s, o, i), this._decorationsTree.insert(n), this._onDidChangeDecorations.checkAffectedAndFire(n.options), n.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(i.endLineNumber), n.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(i.startLineNumber);
  }
  _changeDecorationOptionsImpl(e, t) {
    const n = this._decorations[e];
    if (!n)
      return;
    const i = !!(n.options.overviewRuler && n.options.overviewRuler.color), s = !!(t.overviewRuler && t.overviewRuler.color);
    if (this._onDidChangeDecorations.checkAffectedAndFire(n.options), this._onDidChangeDecorations.checkAffectedAndFire(t), n.options.after || t.after) {
      const l = this._decorationsTree.getNodeRange(this, n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(l.endLineNumber);
    }
    if (n.options.before || t.before) {
      const l = this._decorationsTree.getNodeRange(this, n);
      this._onDidChangeDecorations.recordLineAffectedByInjectedText(l.startLineNumber);
    }
    const o = i !== s, a = P5t(t) !== S6(n);
    o || a ? (this._decorationsTree.delete(n), n.setOptions(t), this._decorationsTree.insert(n)) : n.setOptions(t);
  }
  _deltaDecorationsImpl(e, t, n, i = !1) {
    const s = this.getVersionId(), o = t.length;
    let a = 0;
    const l = n.length;
    let c = 0;
    this._onDidChangeDecorations.beginDeferredEmit();
    try {
      const d = new Array(l);
      for (; a < o || c < l; ) {
        let u = null;
        if (a < o) {
          do
            u = this._decorations[t[a++]];
          while (!u && a < o);
          if (u) {
            if (u.options.after) {
              const f = this._decorationsTree.getNodeRange(this, u);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(f.endLineNumber);
            }
            if (u.options.before) {
              const f = this._decorationsTree.getNodeRange(this, u);
              this._onDidChangeDecorations.recordLineAffectedByInjectedText(f.startLineNumber);
            }
            this._decorationsTree.delete(u), i || this._onDidChangeDecorations.checkAffectedAndFire(u.options);
          }
        }
        if (c < l) {
          if (!u) {
            const w = ++this._lastDecorationId, v = `${this._instanceId};${w}`;
            u = new Oke(v, 0, 0), this._decorations[v] = u;
          }
          const f = n[c], p = this._validateRangeRelaxedNoAllocations(f.range), g = s8e(f.options), m = this._buffer.getOffsetAt(p.startLineNumber, p.startColumn), A = this._buffer.getOffsetAt(p.endLineNumber, p.endColumn);
          u.ownerId = e, u.reset(s, m, A, p), u.setOptions(g), u.options.after && this._onDidChangeDecorations.recordLineAffectedByInjectedText(p.endLineNumber), u.options.before && this._onDidChangeDecorations.recordLineAffectedByInjectedText(p.startLineNumber), i || this._onDidChangeDecorations.checkAffectedAndFire(g), this._decorationsTree.insert(u), d[c] = u.id, c++;
        } else
          u && delete this._decorations[u.id];
      }
      return d;
    } finally {
      this._onDidChangeDecorations.endDeferredEmit();
    }
  }
  //#endregion
  //#region Tokenization
  // TODO move them to the tokenization part.
  getLanguageId() {
    return this.tokenization.getLanguageId();
  }
  setLanguage(e, t) {
    typeof e == "string" ? (this._languageSelectionListener.clear(), this._setLanguage(e, t)) : (this._languageSelectionListener.value = e.onDidChange(() => this._setLanguage(e.languageId, t)), this._setLanguage(e.languageId, t));
  }
  _setLanguage(e, t) {
    this.tokenization.setLanguageId(e, t), this._languageService.requestRichLanguageFeatures(e);
  }
  getLanguageIdAtPosition(e, t) {
    return this.tokenization.getLanguageIdAtPosition(e, t);
  }
  getWordAtPosition(e) {
    return this._tokenizationTextModelPart.getWordAtPosition(e);
  }
  getWordUntilPosition(e) {
    return this._tokenizationTextModelPart.getWordUntilPosition(e);
  }
  //#endregion
  normalizePosition(e, t) {
    return e;
  }
  /**
   * Gets the column at which indentation stops at a given line.
   * @internal
  */
  getLineIndentColumn(e) {
    return B5t(this.getLineContent(e)) + 1;
  }
};
NL = o0 = T5t([
  s_(4, JO),
  s_(5, sr),
  s_(6, xh)
], NL);
function B5t(r) {
  let e = 0;
  for (const t of r)
    if (t === " " || t === "	")
      e++;
    else
      break;
  return e;
}
function o_(r) {
  return !!(r.options.overviewRuler && r.options.overviewRuler.color);
}
function P5t(r) {
  return !!r.after || !!r.before;
}
function S6(r) {
  return !!r.options.after || !!r.options.before;
}
class i8e {
  constructor() {
    this._decorationsTree0 = new n_(), this._decorationsTree1 = new n_(), this._injectedTextDecorationsTree = new n_();
  }
  ensureAllNodesHaveRanges(e) {
    this.getAll(e, 0, !1, !1, !1);
  }
  _ensureNodesHaveRanges(e, t) {
    for (const n of t)
      n.range === null && (n.range = e.getRangeAt(n.cachedAbsoluteStart, n.cachedAbsoluteEnd));
    return t;
  }
  getAllInInterval(e, t, n, i, s, o) {
    const a = e.getVersionId(), l = this._intervalSearch(t, n, i, s, a, o);
    return this._ensureNodesHaveRanges(e, l);
  }
  _intervalSearch(e, t, n, i, s, o) {
    const a = this._decorationsTree0.intervalSearch(e, t, n, i, s, o), l = this._decorationsTree1.intervalSearch(e, t, n, i, s, o), c = this._injectedTextDecorationsTree.intervalSearch(e, t, n, i, s, o);
    return a.concat(l).concat(c);
  }
  getInjectedTextInInterval(e, t, n, i) {
    const s = e.getVersionId(), o = this._injectedTextDecorationsTree.intervalSearch(t, n, i, !1, s, !1);
    return this._ensureNodesHaveRanges(e, o).filter((a) => a.options.showIfCollapsed || !a.range.isEmpty());
  }
  getAllInjectedText(e, t) {
    const n = e.getVersionId(), i = this._injectedTextDecorationsTree.search(t, !1, n, !1);
    return this._ensureNodesHaveRanges(e, i).filter((s) => s.options.showIfCollapsed || !s.range.isEmpty());
  }
  getAll(e, t, n, i, s) {
    const o = e.getVersionId(), a = this._search(t, n, i, o, s);
    return this._ensureNodesHaveRanges(e, a);
  }
  _search(e, t, n, i, s) {
    if (n)
      return this._decorationsTree1.search(e, t, i, s);
    {
      const o = this._decorationsTree0.search(e, t, i, s), a = this._decorationsTree1.search(e, t, i, s), l = this._injectedTextDecorationsTree.search(e, t, i, s);
      return o.concat(a).concat(l);
    }
  }
  collectNodesFromOwner(e) {
    const t = this._decorationsTree0.collectNodesFromOwner(e), n = this._decorationsTree1.collectNodesFromOwner(e), i = this._injectedTextDecorationsTree.collectNodesFromOwner(e);
    return t.concat(n).concat(i);
  }
  collectNodesPostOrder() {
    const e = this._decorationsTree0.collectNodesPostOrder(), t = this._decorationsTree1.collectNodesPostOrder(), n = this._injectedTextDecorationsTree.collectNodesPostOrder();
    return e.concat(t).concat(n);
  }
  insert(e) {
    S6(e) ? this._injectedTextDecorationsTree.insert(e) : o_(e) ? this._decorationsTree1.insert(e) : this._decorationsTree0.insert(e);
  }
  delete(e) {
    S6(e) ? this._injectedTextDecorationsTree.delete(e) : o_(e) ? this._decorationsTree1.delete(e) : this._decorationsTree0.delete(e);
  }
  getNodeRange(e, t) {
    const n = e.getVersionId();
    return t.cachedVersionId !== n && this._resolveNode(t, n), t.range === null && (t.range = e.getRangeAt(t.cachedAbsoluteStart, t.cachedAbsoluteEnd)), t.range;
  }
  _resolveNode(e, t) {
    S6(e) ? this._injectedTextDecorationsTree.resolveNode(e, t) : o_(e) ? this._decorationsTree1.resolveNode(e, t) : this._decorationsTree0.resolveNode(e, t);
  }
  acceptReplace(e, t, n, i) {
    this._decorationsTree0.acceptReplace(e, t, n, i), this._decorationsTree1.acceptReplace(e, t, n, i), this._injectedTextDecorationsTree.acceptReplace(e, t, n, i);
  }
}
function Sc(r) {
  return r.replace(/[^a-z0-9\-_]/gi, " ");
}
class Fke {
  constructor(e) {
    this.color = e.color || "", this.darkColor = e.darkColor || "";
  }
}
class F5t extends Fke {
  constructor(e) {
    super(e), this._resolvedColor = null, this.position = typeof e.position == "number" ? e.position : Xu.Center;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = null;
  }
  _resolveColor(e, t) {
    if (typeof e == "string")
      return e;
    const n = e ? t.getColor(e.id) : null;
    return n ? n.toString() : "";
  }
}
class z5t {
  constructor(e) {
    this.position = e?.position ?? h1.Center, this.persistLane = e?.persistLane;
  }
}
class W5t extends Fke {
  constructor(e) {
    super(e), this.position = e.position, this.sectionHeaderStyle = e.sectionHeaderStyle ?? null, this.sectionHeaderText = e.sectionHeaderText ?? null;
  }
  getColor(e) {
    return this._resolvedColor || (e.type !== "light" && this.darkColor ? this._resolvedColor = this._resolveColor(this.darkColor, e) : this._resolvedColor = this._resolveColor(this.color, e)), this._resolvedColor;
  }
  invalidateCachedColor() {
    this._resolvedColor = void 0;
  }
  _resolveColor(e, t) {
    return typeof e == "string" ? ge.fromHex(e) : t.getColor(e.id);
  }
}
class i4 {
  static from(e) {
    return e instanceof i4 ? e : new i4(e);
  }
  constructor(e) {
    this.content = e.content || "", this.inlineClassName = e.inlineClassName || null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.attachedData = e.attachedData || null, this.cursorStops = e.cursorStops || null;
  }
}
class fi {
  static register(e) {
    return new fi(e);
  }
  static createDynamic(e) {
    return new fi(e);
  }
  constructor(e) {
    this.description = e.description, this.blockClassName = e.blockClassName ? Sc(e.blockClassName) : null, this.blockDoesNotCollapse = e.blockDoesNotCollapse ?? null, this.blockIsAfterEnd = e.blockIsAfterEnd ?? null, this.blockPadding = e.blockPadding ?? null, this.stickiness = e.stickiness || 0, this.zIndex = e.zIndex || 0, this.className = e.className ? Sc(e.className) : null, this.shouldFillLineOnLineBreak = e.shouldFillLineOnLineBreak ?? null, this.hoverMessage = e.hoverMessage || null, this.glyphMarginHoverMessage = e.glyphMarginHoverMessage || null, this.lineNumberHoverMessage = e.lineNumberHoverMessage || null, this.isWholeLine = e.isWholeLine || !1, this.showIfCollapsed = e.showIfCollapsed || !1, this.collapseOnReplaceEdit = e.collapseOnReplaceEdit || !1, this.overviewRuler = e.overviewRuler ? new F5t(e.overviewRuler) : null, this.minimap = e.minimap ? new W5t(e.minimap) : null, this.glyphMargin = e.glyphMarginClassName ? new z5t(e.glyphMargin) : null, this.glyphMarginClassName = e.glyphMarginClassName ? Sc(e.glyphMarginClassName) : null, this.linesDecorationsClassName = e.linesDecorationsClassName ? Sc(e.linesDecorationsClassName) : null, this.lineNumberClassName = e.lineNumberClassName ? Sc(e.lineNumberClassName) : null, this.linesDecorationsTooltip = e.linesDecorationsTooltip ? C0t(e.linesDecorationsTooltip) : null, this.firstLineDecorationClassName = e.firstLineDecorationClassName ? Sc(e.firstLineDecorationClassName) : null, this.marginClassName = e.marginClassName ? Sc(e.marginClassName) : null, this.inlineClassName = e.inlineClassName ? Sc(e.inlineClassName) : null, this.inlineClassNameAffectsLetterSpacing = e.inlineClassNameAffectsLetterSpacing || !1, this.beforeContentClassName = e.beforeContentClassName ? Sc(e.beforeContentClassName) : null, this.afterContentClassName = e.afterContentClassName ? Sc(e.afterContentClassName) : null, this.after = e.after ? i4.from(e.after) : null, this.before = e.before ? i4.from(e.before) : null, this.hideInCommentTokens = e.hideInCommentTokens ?? !1, this.hideInStringTokens = e.hideInStringTokens ?? !1;
  }
}
fi.EMPTY = fi.register({ description: "empty" });
const r8e = [
  fi.register({
    description: "tracked-range-always-grows-when-typing-at-edges",
    stickiness: 0
    /* model.TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
  }),
  fi.register({
    description: "tracked-range-never-grows-when-typing-at-edges",
    stickiness: 1
    /* model.TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
  }),
  fi.register({
    description: "tracked-range-grows-only-when-typing-before",
    stickiness: 2
    /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingBefore */
  }),
  fi.register({
    description: "tracked-range-grows-only-when-typing-after",
    stickiness: 3
    /* model.TrackedRangeStickiness.GrowsOnlyWhenTypingAfter */
  })
];
function s8e(r) {
  return r instanceof fi ? r : fi.createDynamic(r);
}
class j5t extends me {
  constructor(e) {
    super(), this.handleBeforeFire = e, this._actual = this._register(new $()), this.event = this._actual.event, this._affectedInjectedTextLines = null, this._deferredCnt = 0, this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._affectsLineNumber = !1;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit() {
    this._deferredCnt--, this._deferredCnt === 0 && (this._shouldFireDeferred && this.doFire(), this._affectedInjectedTextLines?.clear(), this._affectedInjectedTextLines = null);
  }
  recordLineAffectedByInjectedText(e) {
    this._affectedInjectedTextLines || (this._affectedInjectedTextLines = /* @__PURE__ */ new Set()), this._affectedInjectedTextLines.add(e);
  }
  checkAffectedAndFire(e) {
    this._affectsMinimap ||= !!e.minimap?.position, this._affectsOverviewRuler ||= !!e.overviewRuler?.color, this._affectsGlyphMargin ||= !!e.glyphMarginClassName, this._affectsLineNumber ||= !!e.lineNumberClassName, this.tryFire();
  }
  fire() {
    this._affectsMinimap = !0, this._affectsOverviewRuler = !0, this._affectsGlyphMargin = !0, this.tryFire();
  }
  tryFire() {
    this._deferredCnt === 0 ? this.doFire() : this._shouldFireDeferred = !0;
  }
  doFire() {
    this.handleBeforeFire(this._affectedInjectedTextLines);
    const e = {
      affectsMinimap: this._affectsMinimap,
      affectsOverviewRuler: this._affectsOverviewRuler,
      affectsGlyphMargin: this._affectsGlyphMargin,
      affectsLineNumber: this._affectsLineNumber
    };
    this._shouldFireDeferred = !1, this._affectsMinimap = !1, this._affectsOverviewRuler = !1, this._affectsGlyphMargin = !1, this._actual.fire(e);
  }
}
class Z5t extends me {
  constructor() {
    super(), this._fastEmitter = this._register(new $()), this.fastEvent = this._fastEmitter.event, this._slowEmitter = this._register(new $()), this.slowEvent = this._slowEmitter.event, this._deferredCnt = 0, this._deferredEvent = null;
  }
  beginDeferredEmit() {
    this._deferredCnt++;
  }
  endDeferredEmit(e = null) {
    if (this._deferredCnt--, this._deferredCnt === 0 && this._deferredEvent !== null) {
      this._deferredEvent.rawContentChangedEvent.resultingSelection = e;
      const t = this._deferredEvent;
      this._deferredEvent = null, this._fastEmitter.fire(t), this._slowEmitter.fire(t);
    }
  }
  fire(e) {
    if (this._deferredCnt > 0) {
      this._deferredEvent ? this._deferredEvent = this._deferredEvent.merge(e) : this._deferredEvent = e;
      return;
    }
    this._fastEmitter.fire(e), this._slowEmitter.fire(e);
  }
}
class U5t {
  constructor() {
    this._onDidChangeVisibleRanges = new $(), this.onDidChangeVisibleRanges = this._onDidChangeVisibleRanges.event, this._views = /* @__PURE__ */ new Set();
  }
  attachView() {
    const e = new q5t((t) => {
      this._onDidChangeVisibleRanges.fire({ view: e, state: t });
    });
    return this._views.add(e), e;
  }
  detachView(e) {
    this._views.delete(e), this._onDidChangeVisibleRanges.fire({ view: e, state: void 0 });
  }
}
class q5t {
  constructor(e) {
    this.handleStateChange = e;
  }
  setVisibleLines(e, t) {
    const n = e.map((i) => new lt(i.startLineNumber, i.endLineNumber + 1));
    this.handleStateChange({ visibleLineRanges: n, stabilized: t });
  }
}
class $O {
  static create(e) {
    return new $O(e.get(
      135
      /* EditorOption.wordWrapBreakBeforeCharacters */
    ), e.get(
      134
      /* EditorOption.wordWrapBreakAfterCharacters */
    ));
  }
  constructor(e, t) {
    this.classifier = new G5t(e, t);
  }
  createLineBreaksComputer(e, t, n, i, s) {
    const o = [], a = [], l = [];
    return {
      addRequest: (c, d, u) => {
        o.push(c), a.push(d), l.push(u);
      },
      finalize: () => {
        const c = e.typicalFullwidthCharacterWidth / e.typicalHalfwidthCharacterWidth, d = [];
        for (let u = 0, f = o.length; u < f; u++) {
          const p = a[u], g = l[u];
          g && !g.injectionOptions && !p ? d[u] = Q5t(this.classifier, g, o[u], t, n, c, i, s) : d[u] = K5t(this.classifier, o[u], p, t, n, c, i, s);
        }
        return TL.length = 0, IL.length = 0, d;
      }
    };
  }
}
class G5t extends Ew {
  constructor(e, t) {
    super(
      0
      /* CharacterClass.NONE */
    );
    for (let n = 0; n < e.length; n++)
      this.set(
        e.charCodeAt(n),
        1
        /* CharacterClass.BREAK_BEFORE */
      );
    for (let n = 0; n < t.length; n++)
      this.set(
        t.charCodeAt(n),
        2
        /* CharacterClass.BREAK_AFTER */
      );
  }
  get(e) {
    return e >= 0 && e < 256 ? this._asciiMap[e] : e >= 12352 && e <= 12543 || e >= 13312 && e <= 19903 || e >= 19968 && e <= 40959 ? 3 : this._map.get(e) || this._defaultValue;
  }
}
let TL = [], IL = [];
function Q5t(r, e, t, n, i, s, o, a) {
  if (i === -1)
    return null;
  const l = t.length;
  if (l <= 1)
    return null;
  const c = a === "keepAll", d = e.breakOffsets, u = e.breakOffsetsVisibleColumn, f = zke(t, n, i, s, o), p = i - f, g = TL, m = IL;
  let A = 0, w = 0, v = 0, y = i;
  const _ = d.length;
  let S = 0;
  if (S >= 0) {
    let D = Math.abs(u[S] - y);
    for (; S + 1 < _; ) {
      const M = Math.abs(u[S + 1] - y);
      if (M >= D)
        break;
      D = M, S++;
    }
  }
  for (; S < _; ) {
    let D = S < 0 ? 0 : d[S], M = S < 0 ? 0 : u[S];
    w > D && (D = w, M = v);
    let L = 0, T = 0, B = 0, V = 0;
    if (M <= y) {
      let R = M, H = D === 0 ? 0 : t.charCodeAt(D - 1), z = D === 0 ? 0 : r.get(H), U = !0;
      for (let ee = D; ee < l; ee++) {
        const ce = ee, se = t.charCodeAt(ee);
        let te, ue;
        if (Ki(se) ? (ee++, te = 0, ue = 2) : (te = r.get(se), ue = $A(se, R, n, s)), ce > w && OL(H, z, se, te, c) && (L = ce, T = R), R += ue, R > y) {
          ce > w ? (B = ce, V = R - ue) : (B = ee + 1, V = R), R - T > p && (L = 0), U = !1;
          break;
        }
        H = se, z = te;
      }
      if (U) {
        A > 0 && (g[A] = d[d.length - 1], m[A] = u[d.length - 1], A++);
        break;
      }
    }
    if (L === 0) {
      let R = M, H = t.charCodeAt(D), z = r.get(H), U = !1;
      for (let ee = D - 1; ee >= w; ee--) {
        const ce = ee + 1, se = t.charCodeAt(ee);
        if (se === 9) {
          U = !0;
          break;
        }
        let te, ue;
        if (rg(se) ? (ee--, te = 0, ue = 2) : (te = r.get(se), ue = a1(se) ? s : 1), R <= y) {
          if (B === 0 && (B = ce, V = R), R <= y - p)
            break;
          if (OL(se, te, H, z, c)) {
            L = ce, T = R;
            break;
          }
        }
        R -= ue, H = se, z = te;
      }
      if (L !== 0) {
        const ee = p - (V - T);
        if (ee <= n) {
          const ce = t.charCodeAt(B);
          let se;
          Ki(ce) ? se = 2 : se = $A(ce, V, n, s), ee - se < 0 && (L = 0);
        }
      }
      if (U) {
        S--;
        continue;
      }
    }
    if (L === 0 && (L = B, T = V), L <= w) {
      const R = t.charCodeAt(w);
      Ki(R) ? (L = w + 2, T = v + 2) : (L = w + 1, T = v + $A(R, v, n, s));
    }
    for (w = L, g[A] = L, v = T, m[A] = T, A++, y = T + p; S < 0 || S < _ && u[S] < T; )
      S++;
    let N = Math.abs(u[S] - y);
    for (; S + 1 < _; ) {
      const R = Math.abs(u[S + 1] - y);
      if (R >= N)
        break;
      N = R, S++;
    }
  }
  return A === 0 ? null : (g.length = A, m.length = A, TL = e.breakOffsets, IL = e.breakOffsetsVisibleColumn, e.breakOffsets = g, e.breakOffsetsVisibleColumn = m, e.wrappedTextIndentLength = f, e);
}
function K5t(r, e, t, n, i, s, o, a) {
  const l = sc.applyInjectedText(e, t);
  let c, d;
  if (t && t.length > 0 ? (c = t.map((T) => T.options), d = t.map((T) => T.column - 1)) : (c = null, d = null), i === -1)
    return c ? new QA(d, c, [l.length], [], 0) : null;
  const u = l.length;
  if (u <= 1)
    return c ? new QA(d, c, [l.length], [], 0) : null;
  const f = a === "keepAll", p = zke(l, n, i, s, o), g = i - p, m = [], A = [];
  let w = 0, v = 0, y = 0, _ = i, S = l.charCodeAt(0), D = r.get(S), M = $A(S, 0, n, s), L = 1;
  Ki(S) && (M += 1, S = l.charCodeAt(1), D = r.get(S), L++);
  for (let T = L; T < u; T++) {
    const B = T, V = l.charCodeAt(T);
    let N, R;
    Ki(V) ? (T++, N = 0, R = 2) : (N = r.get(V), R = $A(V, M, n, s)), OL(S, D, V, N, f) && (v = B, y = M), M += R, M > _ && ((v === 0 || M - y > g) && (v = B, y = M - R), m[w] = v, A[w] = y, w++, _ = y + g, v = 0), S = V, D = N;
  }
  return w === 0 && (!t || t.length === 0) ? null : (m[w] = u, A[w] = M, new QA(d, c, m, A, p));
}
function $A(r, e, t, n) {
  return r === 9 ? t - e % t : a1(r) || r < 32 ? n : 1;
}
function o8e(r, e) {
  return e - r % e;
}
function OL(r, e, t, n, i) {
  return t !== 32 && (e === 2 && n !== 2 || e !== 1 && n === 1 || !i && e === 3 && n !== 2 || !i && n === 3 && e !== 1);
}
function zke(r, e, t, n, i) {
  let s = 0;
  if (i !== 0) {
    const o = so(r);
    if (o !== -1) {
      for (let l = 0; l < o; l++) {
        const c = r.charCodeAt(l) === 9 ? o8e(s, e) : 1;
        s += c;
      }
      const a = i === 3 ? 2 : i === 2 ? 1 : 0;
      for (let l = 0; l < a; l++) {
        const c = o8e(s, e);
        s += c;
      }
      s + n > t && (s = 0);
    }
  }
  return s;
}
class b9 {
  constructor(e) {
    this._selTrackedRange = null, this._trackSelection = !0, this._setState(e, new pr(new Q(1, 1, 1, 1), 0, 0, new le(1, 1), 0), new pr(new Q(1, 1, 1, 1), 0, 0, new le(1, 1), 0));
  }
  dispose(e) {
    this._removeTrackedRange(e);
  }
  startTrackingSelection(e) {
    this._trackSelection = !0, this._updateTrackedRange(e);
  }
  stopTrackingSelection(e) {
    this._trackSelection = !1, this._removeTrackedRange(e);
  }
  _updateTrackedRange(e) {
    this._trackSelection && (this._selTrackedRange = e.model._setTrackedRange(
      this._selTrackedRange,
      this.modelState.selection,
      0
      /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
    ));
  }
  _removeTrackedRange(e) {
    this._selTrackedRange = e.model._setTrackedRange(
      this._selTrackedRange,
      null,
      0
      /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
    );
  }
  asCursorState() {
    return new Dt(this.modelState, this.viewState);
  }
  readSelectionFromMarkers(e) {
    const t = e.model._getTrackedRange(this._selTrackedRange);
    return this.modelState.selection.isEmpty() && !t.isEmpty() ? _n.fromRange(t.collapseToEnd(), this.modelState.selection.getDirection()) : _n.fromRange(t, this.modelState.selection.getDirection());
  }
  ensureValidState(e) {
    this._setState(e, this.modelState, this.viewState);
  }
  setState(e, t, n) {
    this._setState(e, t, n);
  }
  static _validatePositionWithCache(e, t, n, i) {
    return t.equals(n) ? i : e.normalizePosition(
      t,
      2
      /* PositionAffinity.None */
    );
  }
  static _validateViewState(e, t) {
    const n = t.position, i = t.selectionStart.getStartPosition(), s = t.selectionStart.getEndPosition(), o = e.normalizePosition(
      n,
      2
      /* PositionAffinity.None */
    ), a = this._validatePositionWithCache(e, i, n, o), l = this._validatePositionWithCache(e, s, i, a);
    return n.equals(o) && i.equals(a) && s.equals(l) ? t : new pr(Q.fromPositions(a, l), t.selectionStartKind, t.selectionStartLeftoverVisibleColumns + i.column - a.column, o, t.leftoverVisibleColumns + n.column - o.column);
  }
  _setState(e, t, n) {
    if (n && (n = b9._validateViewState(e.viewModel, n)), t) {
      const i = e.model.validateRange(t.selectionStart), s = t.selectionStart.equalsRange(i) ? t.selectionStartLeftoverVisibleColumns : 0, o = e.model.validatePosition(t.position), a = t.position.equals(o) ? t.leftoverVisibleColumns : 0;
      t = new pr(i, t.selectionStartKind, s, o, a);
    } else {
      if (!n)
        return;
      const i = e.model.validateRange(e.coordinatesConverter.convertViewRangeToModelRange(n.selectionStart)), s = e.model.validatePosition(e.coordinatesConverter.convertViewPositionToModelPosition(n.position));
      t = new pr(i, n.selectionStartKind, n.selectionStartLeftoverVisibleColumns, s, n.leftoverVisibleColumns);
    }
    if (n) {
      const i = e.coordinatesConverter.validateViewRange(n.selectionStart, t.selectionStart), s = e.coordinatesConverter.validateViewPosition(n.position, t.position);
      n = new pr(i, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, s, t.leftoverVisibleColumns);
    } else {
      const i = e.coordinatesConverter.convertModelPositionToViewPosition(new le(t.selectionStart.startLineNumber, t.selectionStart.startColumn)), s = e.coordinatesConverter.convertModelPositionToViewPosition(new le(t.selectionStart.endLineNumber, t.selectionStart.endColumn)), o = new Q(i.lineNumber, i.column, s.lineNumber, s.column), a = e.coordinatesConverter.convertModelPositionToViewPosition(t.position);
      n = new pr(o, t.selectionStartKind, t.selectionStartLeftoverVisibleColumns, a, t.leftoverVisibleColumns);
    }
    this.modelState = t, this.viewState = n, this._updateTrackedRange(e);
  }
}
class a8e {
  constructor(e) {
    this.context = e, this.cursors = [new b9(e)], this.lastAddedCursorIndex = 0;
  }
  dispose() {
    for (const e of this.cursors)
      e.dispose(this.context);
  }
  startTrackingSelections() {
    for (const e of this.cursors)
      e.startTrackingSelection(this.context);
  }
  stopTrackingSelections() {
    for (const e of this.cursors)
      e.stopTrackingSelection(this.context);
  }
  updateContext(e) {
    this.context = e;
  }
  ensureValidState() {
    for (const e of this.cursors)
      e.ensureValidState(this.context);
  }
  readSelectionFromMarkers() {
    return this.cursors.map((e) => e.readSelectionFromMarkers(this.context));
  }
  getAll() {
    return this.cursors.map((e) => e.asCursorState());
  }
  getViewPositions() {
    return this.cursors.map((e) => e.viewState.position);
  }
  getTopMostViewPosition() {
    return Gpt(this.cursors, al((e) => e.viewState.position, le.compare)).viewState.position;
  }
  getBottomMostViewPosition() {
    return qpt(this.cursors, al((e) => e.viewState.position, le.compare)).viewState.position;
  }
  getSelections() {
    return this.cursors.map((e) => e.modelState.selection);
  }
  getViewSelections() {
    return this.cursors.map((e) => e.viewState.selection);
  }
  setSelections(e) {
    this.setStates(Dt.fromModelSelections(e));
  }
  getPrimaryCursor() {
    return this.cursors[0].asCursorState();
  }
  setStates(e) {
    e !== null && (this.cursors[0].setState(this.context, e[0].modelState, e[0].viewState), this._setSecondaryStates(e.slice(1)));
  }
  /**
   * Creates or disposes secondary cursors as necessary to match the number of `secondarySelections`.
   */
  _setSecondaryStates(e) {
    const t = this.cursors.length - 1, n = e.length;
    if (t < n) {
      const i = n - t;
      for (let s = 0; s < i; s++)
        this._addSecondaryCursor();
    } else if (t > n) {
      const i = t - n;
      for (let s = 0; s < i; s++)
        this._removeSecondaryCursor(this.cursors.length - 2);
    }
    for (let i = 0; i < n; i++)
      this.cursors[i + 1].setState(this.context, e[i].modelState, e[i].viewState);
  }
  killSecondaryCursors() {
    this._setSecondaryStates([]);
  }
  _addSecondaryCursor() {
    this.cursors.push(new b9(this.context)), this.lastAddedCursorIndex = this.cursors.length - 1;
  }
  getLastAddedCursorIndex() {
    return this.cursors.length === 1 || this.lastAddedCursorIndex === 0 ? 0 : this.lastAddedCursorIndex;
  }
  _removeSecondaryCursor(e) {
    this.lastAddedCursorIndex >= e + 1 && this.lastAddedCursorIndex--, this.cursors[e + 1].dispose(this.context), this.cursors.splice(e + 1, 1);
  }
  normalize() {
    if (this.cursors.length === 1)
      return;
    const e = this.cursors.slice(0), t = [];
    for (let n = 0, i = e.length; n < i; n++)
      t.push({
        index: n,
        selection: e[n].modelState.selection
      });
    t.sort(al((n) => n.selection, Q.compareRangesUsingStarts));
    for (let n = 0; n < t.length - 1; n++) {
      const i = t[n], s = t[n + 1], o = i.selection, a = s.selection;
      if (!this.context.cursorConfig.multiCursorMergeOverlapping)
        continue;
      let l;
      if (a.isEmpty() || o.isEmpty() ? l = a.getStartPosition().isBeforeOrEqual(o.getEndPosition()) : l = a.getStartPosition().isBefore(o.getEndPosition()), l) {
        const c = i.index < s.index ? n : n + 1, d = i.index < s.index ? n + 1 : n, u = t[d].index, f = t[c].index, p = t[d].selection, g = t[c].selection;
        if (!p.equalsSelection(g)) {
          const m = p.plusRange(g), A = p.selectionStartLineNumber === p.startLineNumber && p.selectionStartColumn === p.startColumn, w = g.selectionStartLineNumber === g.startLineNumber && g.selectionStartColumn === g.startColumn;
          let v;
          u === this.lastAddedCursorIndex ? (v = A, this.lastAddedCursorIndex = f) : v = w;
          let y;
          v ? y = new _n(m.startLineNumber, m.startColumn, m.endLineNumber, m.endColumn) : y = new _n(m.endLineNumber, m.endColumn, m.startLineNumber, m.startColumn), t[c].selection = y;
          const _ = Dt.fromModelSelection(y);
          e[f].setState(this.context, _.modelState, _.viewState);
        }
        for (const m of t)
          m.index > u && m.index--;
        e.splice(u, 1), t.splice(d, 1), this._removeSecondaryCursor(u - 1), n--;
      }
    }
  }
}
class l8e {
  constructor(e, t, n, i) {
    this._cursorContextBrand = void 0, this.model = e, this.viewModel = t, this.coordinatesConverter = n, this.cursorConfig = i;
  }
}
class Y5t {
  constructor() {
    this.type = 0;
  }
}
class X5t {
  constructor() {
    this.type = 1;
  }
}
class J5t {
  constructor(e) {
    this.type = 2, this._source = e;
  }
  hasChanged(e) {
    return this._source.hasChanged(e);
  }
}
class $5t {
  constructor(e, t, n) {
    this.selections = e, this.modelSelections = t, this.reason = n, this.type = 3;
  }
}
class q1 {
  constructor(e) {
    this.type = 4, e ? (this.affectsMinimap = e.affectsMinimap, this.affectsOverviewRuler = e.affectsOverviewRuler, this.affectsGlyphMargin = e.affectsGlyphMargin, this.affectsLineNumber = e.affectsLineNumber) : (this.affectsMinimap = !0, this.affectsOverviewRuler = !0, this.affectsGlyphMargin = !0, this.affectsLineNumber = !0);
  }
}
class jv {
  constructor() {
    this.type = 5;
  }
}
class e6t {
  constructor(e) {
    this.type = 6, this.isFocused = e;
  }
}
class t6t {
  constructor() {
    this.type = 7;
  }
}
class Zv {
  constructor() {
    this.type = 8;
  }
}
class Wke {
  constructor(e, t) {
    this.fromLineNumber = e, this.count = t, this.type = 9;
  }
}
class RL {
  constructor(e, t) {
    this.type = 10, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class VL {
  constructor(e, t) {
    this.type = 11, this.fromLineNumber = e, this.toLineNumber = t;
  }
}
class e3 {
  constructor(e, t, n, i, s, o, a) {
    this.source = e, this.minimalReveal = t, this.range = n, this.selections = i, this.verticalType = s, this.revealHorizontal = o, this.scrollType = a, this.type = 12;
  }
}
class n6t {
  constructor(e) {
    this.type = 13, this.scrollWidth = e.scrollWidth, this.scrollLeft = e.scrollLeft, this.scrollHeight = e.scrollHeight, this.scrollTop = e.scrollTop, this.scrollWidthChanged = e.scrollWidthChanged, this.scrollLeftChanged = e.scrollLeftChanged, this.scrollHeightChanged = e.scrollHeightChanged, this.scrollTopChanged = e.scrollTopChanged;
  }
}
class i6t {
  constructor(e) {
    this.theme = e, this.type = 14;
  }
}
class r6t {
  constructor(e) {
    this.type = 15, this.ranges = e;
  }
}
class s6t {
  constructor() {
    this.type = 16;
  }
}
let o6t = class {
  constructor() {
    this.type = 17;
  }
};
class a6t extends me {
  constructor() {
    super(), this._onEvent = this._register(new $()), this.onEvent = this._onEvent.event, this._eventHandlers = [], this._viewEventQueue = null, this._isConsumingViewEventQueue = !1, this._collector = null, this._collectorCnt = 0, this._outgoingEvents = [];
  }
  emitOutgoingEvent(e) {
    this._addOutgoingEvent(e), this._emitOutgoingEvents();
  }
  _addOutgoingEvent(e) {
    for (let t = 0, n = this._outgoingEvents.length; t < n; t++) {
      const i = this._outgoingEvents[t].kind === e.kind ? this._outgoingEvents[t].attemptToMerge(e) : null;
      if (i) {
        this._outgoingEvents[t] = i;
        return;
      }
    }
    this._outgoingEvents.push(e);
  }
  _emitOutgoingEvents() {
    for (; this._outgoingEvents.length > 0; ) {
      if (this._collector || this._isConsumingViewEventQueue)
        return;
      const e = this._outgoingEvents.shift();
      e.isNoOp() || this._onEvent.fire(e);
    }
  }
  addViewEventHandler(e) {
    for (let t = 0, n = this._eventHandlers.length; t < n; t++)
      this._eventHandlers[t] === e && console.warn("Detected duplicate listener in ViewEventDispatcher", e);
    this._eventHandlers.push(e);
  }
  removeViewEventHandler(e) {
    for (let t = 0; t < this._eventHandlers.length; t++)
      if (this._eventHandlers[t] === e) {
        this._eventHandlers.splice(t, 1);
        break;
      }
  }
  beginEmitViewEvents() {
    return this._collectorCnt++, this._collectorCnt === 1 && (this._collector = new l6t()), this._collector;
  }
  endEmitViewEvents() {
    if (this._collectorCnt--, this._collectorCnt === 0) {
      const e = this._collector.outgoingEvents, t = this._collector.viewEvents;
      this._collector = null;
      for (const n of e)
        this._addOutgoingEvent(n);
      t.length > 0 && this._emitMany(t);
    }
    this._emitOutgoingEvents();
  }
  emitSingleViewEvent(e) {
    try {
      this.beginEmitViewEvents().emitViewEvent(e);
    } finally {
      this.endEmitViewEvents();
    }
  }
  _emitMany(e) {
    this._viewEventQueue ? this._viewEventQueue = this._viewEventQueue.concat(e) : this._viewEventQueue = e, this._isConsumingViewEventQueue || this._consumeViewEventQueue();
  }
  _consumeViewEventQueue() {
    try {
      this._isConsumingViewEventQueue = !0, this._doConsumeQueue();
    } finally {
      this._isConsumingViewEventQueue = !1;
    }
  }
  _doConsumeQueue() {
    for (; this._viewEventQueue; ) {
      const e = this._viewEventQueue;
      this._viewEventQueue = null;
      const t = this._eventHandlers.slice(0);
      for (const n of t)
        n.handleEvents(e);
    }
  }
}
class l6t {
  constructor() {
    this.viewEvents = [], this.outgoingEvents = [];
  }
  emitViewEvent(e) {
    this.viewEvents.push(e);
  }
  emitOutgoingEvent(e) {
    this.outgoingEvents.push(e);
  }
}
class eR {
  constructor(e, t, n, i) {
    this.kind = 0, this._oldContentWidth = e, this._oldContentHeight = t, this.contentWidth = n, this.contentHeight = i, this.contentWidthChanged = this._oldContentWidth !== this.contentWidth, this.contentHeightChanged = this._oldContentHeight !== this.contentHeight;
  }
  isNoOp() {
    return !this.contentWidthChanged && !this.contentHeightChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new eR(this._oldContentWidth, this._oldContentHeight, e.contentWidth, e.contentHeight);
  }
}
class tR {
  constructor(e, t) {
    this.kind = 1, this.oldHasFocus = e, this.hasFocus = t;
  }
  isNoOp() {
    return this.oldHasFocus === this.hasFocus;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new tR(this.oldHasFocus, e.hasFocus);
  }
}
class nR {
  constructor(e, t, n, i, s, o, a, l) {
    this.kind = 2, this._oldScrollWidth = e, this._oldScrollLeft = t, this._oldScrollHeight = n, this._oldScrollTop = i, this.scrollWidth = s, this.scrollLeft = o, this.scrollHeight = a, this.scrollTop = l, this.scrollWidthChanged = this._oldScrollWidth !== this.scrollWidth, this.scrollLeftChanged = this._oldScrollLeft !== this.scrollLeft, this.scrollHeightChanged = this._oldScrollHeight !== this.scrollHeight, this.scrollTopChanged = this._oldScrollTop !== this.scrollTop;
  }
  isNoOp() {
    return !this.scrollWidthChanged && !this.scrollLeftChanged && !this.scrollHeightChanged && !this.scrollTopChanged;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new nR(this._oldScrollWidth, this._oldScrollLeft, this._oldScrollHeight, this._oldScrollTop, e.scrollWidth, e.scrollLeft, e.scrollHeight, e.scrollTop);
  }
}
class c6t {
  constructor() {
    this.kind = 3;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class h6t {
  constructor() {
    this.kind = 4;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class y9 {
  constructor(e, t, n, i, s, o, a) {
    this.kind = 6, this.oldSelections = e, this.selections = t, this.oldModelVersionId = n, this.modelVersionId = i, this.source = s, this.reason = o, this.reachedMaxCursorCount = a;
  }
  static _selectionsAreEqual(e, t) {
    if (!e && !t)
      return !0;
    if (!e || !t)
      return !1;
    const n = e.length, i = t.length;
    if (n !== i)
      return !1;
    for (let s = 0; s < n; s++)
      if (!e[s].equalsSelection(t[s]))
        return !1;
    return !0;
  }
  isNoOp() {
    return y9._selectionsAreEqual(this.oldSelections, this.selections) && this.oldModelVersionId === this.modelVersionId;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : new y9(this.oldSelections, e.selections, this.oldModelVersionId, e.modelVersionId, e.source, e.reason, this.reachedMaxCursorCount || e.reachedMaxCursorCount);
  }
}
class d6t {
  constructor() {
    this.kind = 5;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return e.kind !== this.kind ? null : this;
  }
}
class u6t {
  constructor(e) {
    this.event = e, this.kind = 7;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class f6t {
  constructor(e) {
    this.event = e, this.kind = 8;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class p6t {
  constructor(e) {
    this.event = e, this.kind = 9;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class g6t {
  constructor(e) {
    this.event = e, this.kind = 10;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class m6t {
  constructor(e) {
    this.event = e, this.kind = 11;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class A6t {
  constructor(e) {
    this.event = e, this.kind = 12;
  }
  isNoOp() {
    return !1;
  }
  attemptToMerge(e) {
    return null;
  }
}
class w6t extends me {
  constructor(e, t, n, i) {
    super(), this._model = e, this._knownModelVersionId = this._model.getVersionId(), this._viewModel = t, this._coordinatesConverter = n, this.context = new l8e(this._model, this._viewModel, this._coordinatesConverter, i), this._cursors = new a8e(this.context), this._hasFocus = !1, this._isHandling = !1, this._compositionState = null, this._columnSelectData = null, this._autoClosedActions = [], this._prevEditOperationType = 0;
  }
  dispose() {
    this._cursors.dispose(), this._autoClosedActions = br(this._autoClosedActions), super.dispose();
  }
  updateConfiguration(e) {
    this.context = new l8e(this._model, this._viewModel, this._coordinatesConverter, e), this._cursors.updateContext(this.context);
  }
  onLineMappingChanged(e) {
    this._knownModelVersionId === this._model.getVersionId() && this.setStates(e, "viewModel", 0, this.getCursorStates());
  }
  setHasFocus(e) {
    this._hasFocus = e;
  }
  _validateAutoClosedActions() {
    if (this._autoClosedActions.length > 0) {
      const e = this._cursors.getSelections();
      for (let t = 0; t < this._autoClosedActions.length; t++) {
        const n = this._autoClosedActions[t];
        n.isValid(e) || (n.dispose(), this._autoClosedActions.splice(t, 1), t--);
      }
    }
  }
  // ------ some getters/setters
  getPrimaryCursorState() {
    return this._cursors.getPrimaryCursor();
  }
  getLastAddedCursorIndex() {
    return this._cursors.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursors.getAll();
  }
  setStates(e, t, n, i) {
    let s = !1;
    const o = this.context.cursorConfig.multiCursorLimit;
    i !== null && i.length > o && (i = i.slice(0, o), s = !0);
    const a = t3.from(this._model, this);
    return this._cursors.setStates(i), this._cursors.normalize(), this._columnSelectData = null, this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, t, n, a, s);
  }
  setCursorColumnSelectData(e) {
    this._columnSelectData = e;
  }
  revealAll(e, t, n, i, s, o) {
    const a = this._cursors.getViewPositions();
    let l = null, c = null;
    a.length > 1 ? c = this._cursors.getViewSelections() : l = Q.fromPositions(a[0], a[0]), e.emitViewEvent(new e3(t, n, l, c, i, s, o));
  }
  revealPrimary(e, t, n, i, s, o) {
    const l = [this._cursors.getPrimaryCursor().viewState.selection];
    e.emitViewEvent(new e3(t, n, null, l, i, s, o));
  }
  saveState() {
    const e = [], t = this._cursors.getSelections();
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      e.push({
        inSelectionMode: !s.isEmpty(),
        selectionStart: {
          lineNumber: s.selectionStartLineNumber,
          column: s.selectionStartColumn
        },
        position: {
          lineNumber: s.positionLineNumber,
          column: s.positionColumn
        }
      });
    }
    return e;
  }
  restoreState(e, t) {
    const n = [];
    for (let i = 0, s = t.length; i < s; i++) {
      const o = t[i];
      let a = 1, l = 1;
      o.position && o.position.lineNumber && (a = o.position.lineNumber), o.position && o.position.column && (l = o.position.column);
      let c = a, d = l;
      o.selectionStart && o.selectionStart.lineNumber && (c = o.selectionStart.lineNumber), o.selectionStart && o.selectionStart.column && (d = o.selectionStart.column), n.push({
        selectionStartLineNumber: c,
        selectionStartColumn: d,
        positionLineNumber: a,
        positionColumn: l
      });
    }
    this.setStates(e, "restoreState", 0, Dt.fromModelSelections(n)), this.revealAll(
      e,
      "restoreState",
      !1,
      0,
      !0,
      1
      /* editorCommon.ScrollType.Immediate */
    );
  }
  onModelContentChanged(e, t) {
    if (t instanceof Eke) {
      if (this._isHandling)
        return;
      this._isHandling = !0;
      try {
        this.setStates(e, "modelChange", 0, this.getCursorStates());
      } finally {
        this._isHandling = !1;
      }
    } else {
      const n = t.rawContentChangedEvent;
      if (this._knownModelVersionId = n.versionId, this._isHandling)
        return;
      const i = n.containsEvent(
        1
        /* RawContentChangedType.Flush */
      );
      if (this._prevEditOperationType = 0, i)
        this._cursors.dispose(), this._cursors = new a8e(this.context), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(e, "model", 1, null, !1);
      else if (this._hasFocus && n.resultingSelection && n.resultingSelection.length > 0) {
        const s = Dt.fromModelSelections(n.resultingSelection);
        this.setStates(e, "modelChange", n.isUndoing ? 5 : n.isRedoing ? 6 : 2, s) && this.revealAll(
          e,
          "modelChange",
          !1,
          0,
          !0,
          0
          /* editorCommon.ScrollType.Smooth */
        );
      } else {
        const s = this._cursors.readSelectionFromMarkers();
        this.setStates(e, "modelChange", 2, Dt.fromModelSelections(s));
      }
    }
  }
  getSelection() {
    return this._cursors.getPrimaryCursor().modelState.selection;
  }
  getTopMostViewPosition() {
    return this._cursors.getTopMostViewPosition();
  }
  getBottomMostViewPosition() {
    return this._cursors.getBottomMostViewPosition();
  }
  getCursorColumnSelectData() {
    if (this._columnSelectData)
      return this._columnSelectData;
    const e = this._cursors.getPrimaryCursor(), t = e.viewState.selectionStart.getStartPosition(), n = e.viewState.position;
    return {
      isReal: !1,
      fromViewLineNumber: t.lineNumber,
      fromViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, t),
      toViewLineNumber: n.lineNumber,
      toViewVisualColumn: this.context.cursorConfig.visibleColumnFromColumn(this._viewModel, n)
    };
  }
  getSelections() {
    return this._cursors.getSelections();
  }
  setSelections(e, t, n, i) {
    this.setStates(e, t, i, Dt.fromModelSelections(n));
  }
  getPrevEditOperationType() {
    return this._prevEditOperationType;
  }
  setPrevEditOperationType(e) {
    this._prevEditOperationType = e;
  }
  // ------ auxiliary handling logic
  _pushAutoClosedAction(e, t) {
    const n = [], i = [];
    for (let a = 0, l = e.length; a < l; a++)
      n.push({
        range: e[a],
        options: {
          description: "auto-closed-character",
          inlineClassName: "auto-closed-character",
          stickiness: 1
          /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
        }
      }), i.push({
        range: t[a],
        options: {
          description: "auto-closed-enclosing",
          stickiness: 1
          /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
        }
      });
    const s = this._model.deltaDecorations([], n), o = this._model.deltaDecorations([], i);
    this._autoClosedActions.push(new c8e(this._model, s, o));
  }
  _executeEditOperation(e) {
    if (!e)
      return;
    e.shouldPushStackElementBefore && this._model.pushStackElement();
    const t = v6t.executeCommands(this._model, this._cursors.getSelections(), e.commands);
    if (t) {
      this._interpretCommandResult(t);
      const n = [], i = [];
      for (let s = 0; s < e.commands.length; s++) {
        const o = e.commands[s];
        o instanceof RO && o.enclosingRange && o.closeCharacterRange && (n.push(o.closeCharacterRange), i.push(o.enclosingRange));
      }
      n.length > 0 && this._pushAutoClosedAction(n, i), this._prevEditOperationType = e.type;
    }
    e.shouldPushStackElementAfter && this._model.pushStackElement();
  }
  _interpretCommandResult(e) {
    (!e || e.length === 0) && (e = this._cursors.readSelectionFromMarkers()), this._columnSelectData = null, this._cursors.setSelections(e), this._cursors.normalize();
  }
  // -----------------------------------------------------------------------------------------------------------
  // ----- emitting events
  _emitStateChangedIfNecessary(e, t, n, i, s) {
    const o = t3.from(this._model, this);
    if (o.equals(i))
      return !1;
    const a = this._cursors.getSelections(), l = this._cursors.getViewSelections();
    if (e.emitViewEvent(new $5t(l, a, n)), !i || i.cursorState.length !== o.cursorState.length || o.cursorState.some((c, d) => !c.modelState.equals(i.cursorState[d].modelState))) {
      const c = i ? i.cursorState.map((u) => u.modelState.selection) : null, d = i ? i.modelVersionId : 0;
      e.emitOutgoingEvent(new y9(c, a, d, o.modelVersionId, t || "keyboard", n, s));
    }
    return !0;
  }
  // -----------------------------------------------------------------------------------------------------------
  // ----- handlers beyond this point
  _findAutoClosingPairs(e) {
    if (!e.length)
      return null;
    const t = [];
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      if (!s.text || s.text.indexOf(`
`) >= 0)
        return null;
      const o = s.text.match(/([)\]}>'"`])([^)\]}>'"`]*)$/);
      if (!o)
        return null;
      const a = o[1], l = this.context.cursorConfig.autoClosingPairs.autoClosingPairsCloseSingleChar.get(a);
      if (!l || l.length !== 1)
        return null;
      const c = l[0].open, d = s.text.length - o[2].length - 1, u = s.text.lastIndexOf(c, d - 1);
      if (u === -1)
        return null;
      t.push([u, d]);
    }
    return t;
  }
  executeEdits(e, t, n, i) {
    let s = null;
    t === "snippet" && (s = this._findAutoClosingPairs(n)), s && (n[0]._isTracked = !0);
    const o = [], a = [], l = this._model.pushEditOperations(this.getSelections(), n, (c) => {
      if (s)
        for (let u = 0, f = s.length; u < f; u++) {
          const [p, g] = s[u], m = c[u], A = m.range.startLineNumber, w = m.range.startColumn - 1 + p, v = m.range.startColumn - 1 + g;
          o.push(new Q(A, v + 1, A, v + 2)), a.push(new Q(A, w + 1, A, v + 2));
        }
      const d = i(c);
      return d && (this._isHandling = !0), d;
    });
    l && (this._isHandling = !1, this.setSelections(
      e,
      t,
      l,
      0
      /* CursorChangeReason.NotSet */
    )), o.length > 0 && this._pushAutoClosedAction(o, a);
  }
  _executeEdit(e, t, n, i = 0) {
    if (this.context.cursorConfig.readOnly)
      return;
    const s = t3.from(this._model, this);
    this._cursors.stopTrackingSelections(), this._isHandling = !0;
    try {
      this._cursors.ensureValidState(), e();
    } catch (o) {
      wn(o);
    }
    this._isHandling = !1, this._cursors.startTrackingSelections(), this._validateAutoClosedActions(), this._emitStateChangedIfNecessary(t, n, i, s, !1) && this.revealAll(
      t,
      n,
      !1,
      0,
      !0,
      0
      /* editorCommon.ScrollType.Smooth */
    );
  }
  getAutoClosedCharacters() {
    return c8e.getAllAutoClosedCharacters(this._autoClosedActions);
  }
  startComposition(e) {
    this._compositionState = new n3(this._model, this.getSelections());
  }
  endComposition(e, t) {
    const n = this._compositionState ? this._compositionState.deduceOutcome(this._model, this.getSelections()) : null;
    this._compositionState = null, this._executeEdit(() => {
      t === "keyboard" && this._executeEditOperation(b0.compositionEndWithInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, n, this.getSelections(), this.getAutoClosedCharacters()));
    }, e, t);
  }
  type(e, t, n) {
    this._executeEdit(() => {
      if (n === "keyboard") {
        const i = t.length;
        let s = 0;
        for (; s < i; ) {
          const o = HI(t, s), a = t.substr(s, o);
          this._executeEditOperation(b0.typeWithInterceptors(!!this._compositionState, this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), this.getAutoClosedCharacters(), a)), s += o;
        }
      } else
        this._executeEditOperation(b0.typeWithoutInterceptors(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t));
    }, e, n);
  }
  compositionType(e, t, n, i, s, o) {
    if (t.length === 0 && n === 0 && i === 0) {
      if (s !== 0) {
        const a = this.getSelections().map((l) => {
          const c = l.getPosition();
          return new _n(c.lineNumber, c.column + s, c.lineNumber, c.column + s);
        });
        this.setSelections(
          e,
          o,
          a,
          0
          /* CursorChangeReason.NotSet */
        );
      }
      return;
    }
    this._executeEdit(() => {
      this._executeEditOperation(b0.compositionType(this._prevEditOperationType, this.context.cursorConfig, this._model, this.getSelections(), t, n, i, s));
    }, e, o);
  }
  paste(e, t, n, i, s) {
    this._executeEdit(
      () => {
        this._executeEditOperation(b0.paste(this.context.cursorConfig, this._model, this.getSelections(), t, n, i || []));
      },
      e,
      s,
      4
      /* CursorChangeReason.Paste */
    );
  }
  cut(e, t) {
    this._executeEdit(() => {
      this._executeEditOperation(Ef.cut(this.context.cursorConfig, this._model, this.getSelections()));
    }, e, t);
  }
  executeCommand(e, t, n) {
    this._executeEdit(() => {
      this._cursors.killSecondaryCursors(), this._executeEditOperation(new js(0, [t], {
        shouldPushStackElementBefore: !1,
        shouldPushStackElementAfter: !1
      }));
    }, e, n);
  }
  executeCommands(e, t, n) {
    this._executeEdit(() => {
      this._executeEditOperation(new js(0, t, {
        shouldPushStackElementBefore: !1,
        shouldPushStackElementAfter: !1
      }));
    }, e, n);
  }
}
class t3 {
  static from(e, t) {
    return new t3(e.getVersionId(), t.getCursorStates());
  }
  constructor(e, t) {
    this.modelVersionId = e, this.cursorState = t;
  }
  equals(e) {
    if (!e || this.modelVersionId !== e.modelVersionId || this.cursorState.length !== e.cursorState.length)
      return !1;
    for (let t = 0, n = this.cursorState.length; t < n; t++)
      if (!this.cursorState[t].equals(e.cursorState[t]))
        return !1;
    return !0;
  }
}
class c8e {
  static getAllAutoClosedCharacters(e) {
    let t = [];
    for (const n of e)
      t = t.concat(n.getAutoClosedCharactersRanges());
    return t;
  }
  constructor(e, t, n) {
    this._model = e, this._autoClosedCharactersDecorations = t, this._autoClosedEnclosingDecorations = n;
  }
  dispose() {
    this._autoClosedCharactersDecorations = this._model.deltaDecorations(this._autoClosedCharactersDecorations, []), this._autoClosedEnclosingDecorations = this._model.deltaDecorations(this._autoClosedEnclosingDecorations, []);
  }
  getAutoClosedCharactersRanges() {
    const e = [];
    for (let t = 0; t < this._autoClosedCharactersDecorations.length; t++) {
      const n = this._model.getDecorationRange(this._autoClosedCharactersDecorations[t]);
      n && e.push(n);
    }
    return e;
  }
  isValid(e) {
    const t = [];
    for (let n = 0; n < this._autoClosedEnclosingDecorations.length; n++) {
      const i = this._model.getDecorationRange(this._autoClosedEnclosingDecorations[n]);
      if (i && (t.push(i), i.startLineNumber !== i.endLineNumber))
        return !1;
    }
    t.sort(Q.compareRangesUsingStarts), e.sort(Q.compareRangesUsingStarts);
    for (let n = 0; n < e.length; n++)
      if (n >= t.length || !t[n].strictContainsRange(e[n]))
        return !1;
    return !0;
  }
}
class v6t {
  static executeCommands(e, t, n) {
    const i = {
      model: e,
      selectionsBefore: t,
      trackedRanges: [],
      trackedRangesDirection: []
    }, s = this._innerExecuteCommands(i, n);
    for (let o = 0, a = i.trackedRanges.length; o < a; o++)
      i.model._setTrackedRange(
        i.trackedRanges[o],
        null,
        0
        /* TrackedRangeStickiness.AlwaysGrowsWhenTypingAtEdges */
      );
    return s;
  }
  static _innerExecuteCommands(e, t) {
    if (this._arrayIsEmpty(t))
      return null;
    const n = this._getEditOperations(e, t);
    if (n.operations.length === 0)
      return null;
    const i = n.operations, s = this._getLoserCursorMap(i);
    if (s.hasOwnProperty("0"))
      return console.warn("Ignoring commands"), null;
    const o = [];
    for (let c = 0, d = i.length; c < d; c++)
      s.hasOwnProperty(i[c].identifier.major.toString()) || o.push(i[c]);
    n.hadTrackedEditOperation && o.length > 0 && (o[0]._isTracked = !0);
    let a = e.model.pushEditOperations(e.selectionsBefore, o, (c) => {
      const d = [];
      for (let p = 0; p < e.selectionsBefore.length; p++)
        d[p] = [];
      for (const p of c)
        p.identifier && d[p.identifier.major].push(p);
      const u = (p, g) => p.identifier.minor - g.identifier.minor, f = [];
      for (let p = 0; p < e.selectionsBefore.length; p++)
        d[p].length > 0 ? (d[p].sort(u), f[p] = t[p].computeCursorState(e.model, {
          getInverseEditOperations: () => d[p],
          getTrackedSelection: (g) => {
            const m = parseInt(g, 10), A = e.model._getTrackedRange(e.trackedRanges[m]);
            return e.trackedRangesDirection[m] === 0 ? new _n(A.startLineNumber, A.startColumn, A.endLineNumber, A.endColumn) : new _n(A.endLineNumber, A.endColumn, A.startLineNumber, A.startColumn);
          }
        })) : f[p] = e.selectionsBefore[p];
      return f;
    });
    a || (a = e.selectionsBefore);
    const l = [];
    for (const c in s)
      s.hasOwnProperty(c) && l.push(parseInt(c, 10));
    l.sort((c, d) => d - c);
    for (const c of l)
      a.splice(c, 1);
    return a;
  }
  static _arrayIsEmpty(e) {
    for (let t = 0, n = e.length; t < n; t++)
      if (e[t])
        return !1;
    return !0;
  }
  static _getEditOperations(e, t) {
    let n = [], i = !1;
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s];
      if (a) {
        const l = this._getEditOperationsFromCommand(e, s, a);
        n = n.concat(l.operations), i = i || l.hadTrackedEditOperation;
      }
    }
    return {
      operations: n,
      hadTrackedEditOperation: i
    };
  }
  static _getEditOperationsFromCommand(e, t, n) {
    const i = [];
    let s = 0;
    const o = (u, f, p = !1) => {
      Q.isEmpty(u) && f === "" || i.push({
        identifier: {
          major: t,
          minor: s++
        },
        range: u,
        text: f,
        forceMoveMarkers: p,
        isAutoWhitespaceEdit: n.insertsAutoWhitespace
      });
    };
    let a = !1;
    const d = {
      addEditOperation: o,
      addTrackedEditOperation: (u, f, p) => {
        a = !0, o(u, f, p);
      },
      trackSelection: (u, f) => {
        const p = _n.liftSelection(u);
        let g;
        if (p.isEmpty())
          if (typeof f == "boolean")
            f ? g = 2 : g = 3;
          else {
            const w = e.model.getLineMaxColumn(p.startLineNumber);
            p.startColumn === w ? g = 2 : g = 3;
          }
        else
          g = 1;
        const m = e.trackedRanges.length, A = e.model._setTrackedRange(null, p, g);
        return e.trackedRanges[m] = A, e.trackedRangesDirection[m] = p.getDirection(), m.toString();
      }
    };
    try {
      n.getEditOperations(e.model, d);
    } catch (u) {
      return wn(u), {
        operations: [],
        hadTrackedEditOperation: !1
      };
    }
    return {
      operations: i,
      hadTrackedEditOperation: a
    };
  }
  static _getLoserCursorMap(e) {
    e = e.slice(0), e.sort((n, i) => -Q.compareRangesUsingEnds(n.range, i.range));
    const t = {};
    for (let n = 1; n < e.length; n++) {
      const i = e[n - 1], s = e[n];
      if (Q.getStartPosition(i.range).isBefore(Q.getEndPosition(s.range))) {
        let o;
        i.identifier.major > s.identifier.major ? o = i.identifier.major : o = s.identifier.major, t[o.toString()] = !0;
        for (let a = 0; a < e.length; a++)
          e[a].identifier.major === o && (e.splice(a, 1), a < n && n--, a--);
        n > 0 && n--;
      }
    }
    return t;
  }
}
class b6t {
  constructor(e, t, n) {
    this.text = e, this.startSelection = t, this.endSelection = n;
  }
}
class n3 {
  static _capture(e, t) {
    const n = [];
    for (const i of t) {
      if (i.startLineNumber !== i.endLineNumber)
        return null;
      n.push(new b6t(e.getLineContent(i.startLineNumber), i.startColumn - 1, i.endColumn - 1));
    }
    return n;
  }
  constructor(e, t) {
    this._original = n3._capture(e, t);
  }
  /**
   * Returns the inserted text during this composition.
   * If the composition resulted in existing text being changed (i.e. not a pure insertion) it returns null.
   */
  deduceOutcome(e, t) {
    if (!this._original)
      return null;
    const n = n3._capture(e, t);
    if (!n || this._original.length !== n.length)
      return null;
    const i = [];
    for (let s = 0, o = this._original.length; s < o; s++)
      i.push(n3._deduceOutcome(this._original[s], n[s]));
    return i;
  }
  static _deduceOutcome(e, t) {
    const n = Math.min(e.startSelection, t.startSelection, kD(e.text, t.text)), i = Math.min(e.text.length - e.endSelection, t.text.length - t.endSelection, ND(e.text, t.text)), s = e.text.substring(n, e.text.length - i), o = t.text.substring(n, t.text.length - i);
    return new fwt(s, e.startSelection - n, e.endSelection - n, o, t.startSelection - n, t.endSelection - n);
  }
}
const h8e = {
  getInitialState: () => Z3,
  tokenizeEncoded: (r, e, t) => uO(0, t)
};
async function y6t(r, e, t) {
  if (!t)
    return d8e(e, r.languageIdCodec, h8e);
  const n = await xi.getOrCreate(t);
  return d8e(e, r.languageIdCodec, n || h8e);
}
function C6t(r, e, t, n, i, s, o) {
  let a = "<div>", l = n, c = 0, d = !0;
  for (let u = 0, f = e.getCount(); u < f; u++) {
    const p = e.getEndOffset(u);
    if (p <= n)
      continue;
    let g = "";
    for (; l < p && l < i; l++) {
      const m = r.charCodeAt(l);
      switch (m) {
        case 9: {
          let A = s - (l + c) % s;
          for (c += A - 1; A > 0; )
            o && d ? (g += "&#160;", d = !1) : (g += " ", d = !0), A--;
          break;
        }
        case 60:
          g += "&lt;", d = !1;
          break;
        case 62:
          g += "&gt;", d = !1;
          break;
        case 38:
          g += "&amp;", d = !1;
          break;
        case 0:
          g += "&#00;", d = !1;
          break;
        case 65279:
        case 8232:
        case 8233:
        case 133:
          g += "�", d = !1;
          break;
        case 13:
          g += "&#8203", d = !1;
          break;
        case 32:
          o && d ? (g += "&#160;", d = !1) : (g += " ", d = !0);
          break;
        default:
          g += String.fromCharCode(m), d = !1;
      }
    }
    if (a += `<span style="${e.getInlineStyle(u, t)}">${g}</span>`, p > i || l >= i)
      break;
  }
  return a += "</div>", a;
}
function d8e(r, e, t) {
  let n = '<div class="monaco-tokenized-source">';
  const i = $g(r);
  let s = t.getInitialState();
  for (let o = 0, a = i.length; o < a; o++) {
    const l = i[o];
    o > 0 && (n += "<br/>");
    const c = t.tokenizeEncoded(l, !0, s);
    Ri.convertToEndOffset(c.tokens, l.length);
    const u = new Ri(c.tokens, l, e).inflate();
    let f = 0;
    for (let p = 0, g = u.getCount(); p < g; p++) {
      const m = u.getClassName(p), A = u.getEndOffset(p);
      n += `<span class="${m}">${VA(l.substring(f, A))}</span>`, f = A;
    }
    s = c.endState;
  }
  return n += "</div>", n;
}
class E6t {
  constructor() {
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [];
  }
  insert(e) {
    this._hasPending = !0, this._inserts.push(e);
  }
  change(e) {
    this._hasPending = !0, this._changes.push(e);
  }
  remove(e) {
    this._hasPending = !0, this._removes.push(e);
  }
  mustCommit() {
    return this._hasPending;
  }
  commit(e) {
    if (!this._hasPending)
      return;
    const t = this._inserts, n = this._changes, i = this._removes;
    this._hasPending = !1, this._inserts = [], this._changes = [], this._removes = [], e._commitPendingChanges(t, n, i);
  }
}
class _6t {
  constructor(e, t, n, i, s) {
    this.id = e, this.afterLineNumber = t, this.ordinal = n, this.height = i, this.minWidth = s, this.prefixSum = 0;
  }
}
let x6t = class HL {
  static {
    this.INSTANCE_COUNT = 0;
  }
  constructor(e, t, n, i) {
    this._instanceId = oDe(++HL.INSTANCE_COUNT), this._pendingChanges = new E6t(), this._lastWhitespaceId = 0, this._arr = [], this._prefixSumValidIndex = -1, this._minWidth = -1, this._lineCount = e, this._lineHeight = t, this._paddingTop = n, this._paddingBottom = i;
  }
  /**
   * Find the insertion index for a new value inside a sorted array of values.
   * If the value is already present in the sorted array, the insertion index will be after the already existing value.
   */
  static findInsertionIndex(e, t, n) {
    let i = 0, s = e.length;
    for (; i < s; ) {
      const o = i + s >>> 1;
      t === e[o].afterLineNumber ? n < e[o].ordinal ? s = o : i = o + 1 : t < e[o].afterLineNumber ? s = o : i = o + 1;
    }
    return i;
  }
  /**
   * Change the height of a line in pixels.
   */
  setLineHeight(e) {
    this._checkPendingChanges(), this._lineHeight = e;
  }
  /**
   * Changes the padding used to calculate vertical offsets.
   */
  setPadding(e, t) {
    this._paddingTop = e, this._paddingBottom = t;
  }
  /**
   * Set the number of lines.
   *
   * @param lineCount New number of lines.
   */
  onFlushed(e) {
    this._checkPendingChanges(), this._lineCount = e;
  }
  changeWhitespace(e) {
    let t = !1;
    try {
      e({
        insertWhitespace: (i, s, o, a) => {
          t = !0, i = i | 0, s = s | 0, o = o | 0, a = a | 0;
          const l = this._instanceId + ++this._lastWhitespaceId;
          return this._pendingChanges.insert(new _6t(l, i, s, o, a)), l;
        },
        changeOneWhitespace: (i, s, o) => {
          t = !0, s = s | 0, o = o | 0, this._pendingChanges.change({ id: i, newAfterLineNumber: s, newHeight: o });
        },
        removeWhitespace: (i) => {
          t = !0, this._pendingChanges.remove({ id: i });
        }
      });
    } finally {
      this._pendingChanges.commit(this);
    }
    return t;
  }
  _commitPendingChanges(e, t, n) {
    if ((e.length > 0 || n.length > 0) && (this._minWidth = -1), e.length + t.length + n.length <= 1) {
      for (const l of e)
        this._insertWhitespace(l);
      for (const l of t)
        this._changeOneWhitespace(l.id, l.newAfterLineNumber, l.newHeight);
      for (const l of n) {
        const c = this._findWhitespaceIndex(l.id);
        c !== -1 && this._removeWhitespace(c);
      }
      return;
    }
    const i = /* @__PURE__ */ new Set();
    for (const l of n)
      i.add(l.id);
    const s = /* @__PURE__ */ new Map();
    for (const l of t)
      s.set(l.id, l);
    const o = (l) => {
      const c = [];
      for (const d of l)
        if (!i.has(d.id)) {
          if (s.has(d.id)) {
            const u = s.get(d.id);
            d.afterLineNumber = u.newAfterLineNumber, d.height = u.newHeight;
          }
          c.push(d);
        }
      return c;
    }, a = o(this._arr).concat(o(e));
    a.sort((l, c) => l.afterLineNumber === c.afterLineNumber ? l.ordinal - c.ordinal : l.afterLineNumber - c.afterLineNumber), this._arr = a, this._prefixSumValidIndex = -1;
  }
  _checkPendingChanges() {
    this._pendingChanges.mustCommit() && this._pendingChanges.commit(this);
  }
  _insertWhitespace(e) {
    const t = HL.findInsertionIndex(this._arr, e.afterLineNumber, e.ordinal);
    this._arr.splice(t, 0, e), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, t - 1);
  }
  _findWhitespaceIndex(e) {
    const t = this._arr;
    for (let n = 0, i = t.length; n < i; n++)
      if (t[n].id === e)
        return n;
    return -1;
  }
  _changeOneWhitespace(e, t, n) {
    const i = this._findWhitespaceIndex(e);
    if (i !== -1 && (this._arr[i].height !== n && (this._arr[i].height = n, this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, i - 1)), this._arr[i].afterLineNumber !== t)) {
      const s = this._arr[i];
      this._removeWhitespace(i), s.afterLineNumber = t, this._insertWhitespace(s);
    }
  }
  _removeWhitespace(e) {
    this._arr.splice(e, 1), this._prefixSumValidIndex = Math.min(this._prefixSumValidIndex, e - 1);
  }
  /**
   * Notify the layouter that lines have been deleted (a continuous zone of lines).
   *
   * @param fromLineNumber The line number at which the deletion started, inclusive
   * @param toLineNumber The line number at which the deletion ended, inclusive
   */
  onLinesDeleted(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0, this._lineCount -= t - e + 1;
    for (let n = 0, i = this._arr.length; n < i; n++) {
      const s = this._arr[n].afterLineNumber;
      e <= s && s <= t ? this._arr[n].afterLineNumber = e - 1 : s > t && (this._arr[n].afterLineNumber -= t - e + 1);
    }
  }
  /**
   * Notify the layouter that lines have been inserted (a continuous zone of lines).
   *
   * @param fromLineNumber The line number at which the insertion started, inclusive
   * @param toLineNumber The line number at which the insertion ended, inclusive.
   */
  onLinesInserted(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0, this._lineCount += t - e + 1;
    for (let n = 0, i = this._arr.length; n < i; n++) {
      const s = this._arr[n].afterLineNumber;
      e <= s && (this._arr[n].afterLineNumber += t - e + 1);
    }
  }
  /**
   * Get the sum of all the whitespaces.
   */
  getWhitespacesTotalHeight() {
    return this._checkPendingChanges(), this._arr.length === 0 ? 0 : this.getWhitespacesAccumulatedHeight(this._arr.length - 1);
  }
  /**
   * Return the sum of the heights of the whitespaces at [0..index].
   * This includes the whitespace at `index`.
   *
   * @param index The index of the whitespace.
   * @return The sum of the heights of all whitespaces before the one at `index`, including the one at `index`.
   */
  getWhitespacesAccumulatedHeight(e) {
    this._checkPendingChanges(), e = e | 0;
    let t = Math.max(0, this._prefixSumValidIndex + 1);
    t === 0 && (this._arr[0].prefixSum = this._arr[0].height, t++);
    for (let n = t; n <= e; n++)
      this._arr[n].prefixSum = this._arr[n - 1].prefixSum + this._arr[n].height;
    return this._prefixSumValidIndex = Math.max(this._prefixSumValidIndex, e), this._arr[e].prefixSum;
  }
  /**
   * Get the sum of heights for all objects.
   *
   * @return The sum of heights for all objects.
   */
  getLinesTotalHeight() {
    this._checkPendingChanges();
    const e = this._lineHeight * this._lineCount, t = this.getWhitespacesTotalHeight();
    return e + t + this._paddingTop + this._paddingBottom;
  }
  /**
   * Returns the accumulated height of whitespaces before the given line number.
   *
   * @param lineNumber The line number
   */
  getWhitespaceAccumulatedHeightBeforeLineNumber(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this._findLastWhitespaceBeforeLineNumber(e);
    return t === -1 ? 0 : this.getWhitespacesAccumulatedHeight(t);
  }
  _findLastWhitespaceBeforeLineNumber(e) {
    e = e | 0;
    const t = this._arr;
    let n = 0, i = t.length - 1;
    for (; n <= i; ) {
      const o = (i - n | 0) / 2 | 0, a = n + o | 0;
      if (t[a].afterLineNumber < e) {
        if (a + 1 >= t.length || t[a + 1].afterLineNumber >= e)
          return a;
        n = a + 1 | 0;
      } else
        i = a - 1 | 0;
    }
    return -1;
  }
  _findFirstWhitespaceAfterLineNumber(e) {
    e = e | 0;
    const n = this._findLastWhitespaceBeforeLineNumber(e) + 1;
    return n < this._arr.length ? n : -1;
  }
  /**
   * Find the index of the first whitespace which has `afterLineNumber` >= `lineNumber`.
   * @return The index of the first whitespace with `afterLineNumber` >= `lineNumber` or -1 if no whitespace is found.
   */
  getFirstWhitespaceIndexAfterLineNumber(e) {
    return this._checkPendingChanges(), e = e | 0, this._findFirstWhitespaceAfterLineNumber(e);
  }
  /**
   * Get the vertical offset (the sum of heights for all objects above) a certain line number.
   *
   * @param lineNumber The line number
   * @return The sum of heights for all objects above `lineNumber`.
   */
  getVerticalOffsetForLineNumber(e, t = !1) {
    this._checkPendingChanges(), e = e | 0;
    let n;
    e > 1 ? n = this._lineHeight * (e - 1) : n = 0;
    const i = this.getWhitespaceAccumulatedHeightBeforeLineNumber(e - (t ? 1 : 0));
    return n + i + this._paddingTop;
  }
  /**
   * Get the vertical offset (the sum of heights for all objects above) a certain line number.
   *
   * @param lineNumber The line number
   * @return The sum of heights for all objects above `lineNumber`.
   */
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    this._checkPendingChanges(), e = e | 0;
    const n = this._lineHeight * e, i = this.getWhitespaceAccumulatedHeightBeforeLineNumber(e + (t ? 1 : 0));
    return n + i + this._paddingTop;
  }
  /**
   * The maximum min width for all whitespaces.
   */
  getWhitespaceMinWidth() {
    if (this._checkPendingChanges(), this._minWidth === -1) {
      let e = 0;
      for (let t = 0, n = this._arr.length; t < n; t++)
        e = Math.max(e, this._arr[t].minWidth);
      this._minWidth = e;
    }
    return this._minWidth;
  }
  /**
   * Check if `verticalOffset` is below all lines.
   */
  isAfterLines(e) {
    this._checkPendingChanges();
    const t = this.getLinesTotalHeight();
    return e > t;
  }
  isInTopPadding(e) {
    return this._paddingTop === 0 ? !1 : (this._checkPendingChanges(), e < this._paddingTop);
  }
  isInBottomPadding(e) {
    if (this._paddingBottom === 0)
      return !1;
    this._checkPendingChanges();
    const t = this.getLinesTotalHeight();
    return e >= t - this._paddingBottom;
  }
  /**
   * Find the first line number that is at or after vertical offset `verticalOffset`.
   * i.e. if getVerticalOffsetForLine(line) is x and getVerticalOffsetForLine(line + 1) is y, then
   * getLineNumberAtOrAfterVerticalOffset(i) = line, x <= i < y.
   *
   * @param verticalOffset The vertical offset to search at.
   * @return The line number at or after vertical offset `verticalOffset`.
   */
  getLineNumberAtOrAfterVerticalOffset(e) {
    if (this._checkPendingChanges(), e = e | 0, e < 0)
      return 1;
    const t = this._lineCount | 0, n = this._lineHeight;
    let i = 1, s = t;
    for (; i < s; ) {
      const o = (i + s) / 2 | 0, a = this.getVerticalOffsetForLineNumber(o) | 0;
      if (e >= a + n)
        i = o + 1;
      else {
        if (e >= a)
          return o;
        s = o;
      }
    }
    return i > t ? t : i;
  }
  /**
   * Get all the lines and their relative vertical offsets that are positioned between `verticalOffset1` and `verticalOffset2`.
   *
   * @param verticalOffset1 The beginning of the viewport.
   * @param verticalOffset2 The end of the viewport.
   * @return A structure describing the lines positioned between `verticalOffset1` and `verticalOffset2`.
   */
  getLinesViewportData(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0;
    const n = this._lineHeight, i = this.getLineNumberAtOrAfterVerticalOffset(e) | 0, s = this.getVerticalOffsetForLineNumber(i) | 0;
    let o = this._lineCount | 0, a = this.getFirstWhitespaceIndexAfterLineNumber(i) | 0;
    const l = this.getWhitespacesCount() | 0;
    let c, d;
    a === -1 ? (a = l, d = o + 1, c = 0) : (d = this.getAfterLineNumberForWhitespaceIndex(a) | 0, c = this.getHeightForWhitespaceIndex(a) | 0);
    let u = s, f = u;
    const p = 5e5;
    let g = 0;
    s >= p && (g = Math.floor(s / p) * p, g = Math.floor(g / n) * n, f -= g);
    const m = [], A = e + (t - e) / 2;
    let w = -1;
    for (let S = i; S <= o; S++) {
      if (w === -1) {
        const D = u, M = u + n;
        (D <= A && A < M || D > A) && (w = S);
      }
      for (u += n, m[S - i] = f, f += n; d === S; )
        f += c, u += c, a++, a >= l ? d = o + 1 : (d = this.getAfterLineNumberForWhitespaceIndex(a) | 0, c = this.getHeightForWhitespaceIndex(a) | 0);
      if (u >= t) {
        o = S;
        break;
      }
    }
    w === -1 && (w = o);
    const v = this.getVerticalOffsetForLineNumber(o) | 0;
    let y = i, _ = o;
    return y < _ && s < e && y++, y < _ && v + n > t && _--, {
      bigNumbersDelta: g,
      startLineNumber: i,
      endLineNumber: o,
      relativeVerticalOffset: m,
      centeredLineNumber: w,
      completelyVisibleStartLineNumber: y,
      completelyVisibleEndLineNumber: _,
      lineHeight: this._lineHeight
    };
  }
  getVerticalOffsetForWhitespaceIndex(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this.getAfterLineNumberForWhitespaceIndex(e);
    let n;
    t >= 1 ? n = this._lineHeight * t : n = 0;
    let i;
    return e > 0 ? i = this.getWhitespacesAccumulatedHeight(e - 1) : i = 0, n + i + this._paddingTop;
  }
  getWhitespaceIndexAtOrAfterVerticallOffset(e) {
    this._checkPendingChanges(), e = e | 0;
    let t = 0, n = this.getWhitespacesCount() - 1;
    if (n < 0)
      return -1;
    const i = this.getVerticalOffsetForWhitespaceIndex(n), s = this.getHeightForWhitespaceIndex(n);
    if (e >= i + s)
      return -1;
    for (; t < n; ) {
      const o = Math.floor((t + n) / 2), a = this.getVerticalOffsetForWhitespaceIndex(o), l = this.getHeightForWhitespaceIndex(o);
      if (e >= a + l)
        t = o + 1;
      else {
        if (e >= a)
          return o;
        n = o;
      }
    }
    return t;
  }
  /**
   * Get exactly the whitespace that is layouted at `verticalOffset`.
   *
   * @param verticalOffset The vertical offset.
   * @return Precisely the whitespace that is layouted at `verticaloffset` or null.
   */
  getWhitespaceAtVerticalOffset(e) {
    this._checkPendingChanges(), e = e | 0;
    const t = this.getWhitespaceIndexAtOrAfterVerticallOffset(e);
    if (t < 0 || t >= this.getWhitespacesCount())
      return null;
    const n = this.getVerticalOffsetForWhitespaceIndex(t);
    if (n > e)
      return null;
    const i = this.getHeightForWhitespaceIndex(t), s = this.getIdForWhitespaceIndex(t), o = this.getAfterLineNumberForWhitespaceIndex(t);
    return {
      id: s,
      afterLineNumber: o,
      verticalOffset: n,
      height: i
    };
  }
  /**
   * Get a list of whitespaces that are positioned between `verticalOffset1` and `verticalOffset2`.
   *
   * @param verticalOffset1 The beginning of the viewport.
   * @param verticalOffset2 The end of the viewport.
   * @return An array with all the whitespaces in the viewport. If no whitespace is in viewport, the array is empty.
   */
  getWhitespaceViewportData(e, t) {
    this._checkPendingChanges(), e = e | 0, t = t | 0;
    const n = this.getWhitespaceIndexAtOrAfterVerticallOffset(e), i = this.getWhitespacesCount() - 1;
    if (n < 0)
      return [];
    const s = [];
    for (let o = n; o <= i; o++) {
      const a = this.getVerticalOffsetForWhitespaceIndex(o), l = this.getHeightForWhitespaceIndex(o);
      if (a >= t)
        break;
      s.push({
        id: this.getIdForWhitespaceIndex(o),
        afterLineNumber: this.getAfterLineNumberForWhitespaceIndex(o),
        verticalOffset: a,
        height: l
      });
    }
    return s;
  }
  /**
   * Get all whitespaces.
   */
  getWhitespaces() {
    return this._checkPendingChanges(), this._arr.slice(0);
  }
  /**
   * The number of whitespaces.
   */
  getWhitespacesCount() {
    return this._checkPendingChanges(), this._arr.length;
  }
  /**
   * Get the `id` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `id` of whitespace at `index`.
   */
  getIdForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].id;
  }
  /**
   * Get the `afterLineNumber` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `afterLineNumber` of whitespace at `index`.
   */
  getAfterLineNumberForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].afterLineNumber;
  }
  /**
   * Get the `height` for whitespace at index `index`.
   *
   * @param index The index of the whitespace.
   * @return `height` of whitespace at `index`.
   */
  getHeightForWhitespaceIndex(e) {
    return this._checkPendingChanges(), e = e | 0, this._arr[e].height;
  }
};
const S6t = 125;
class wA {
  constructor(e, t, n, i) {
    e = e | 0, t = t | 0, n = n | 0, i = i | 0, e < 0 && (e = 0), t < 0 && (t = 0), n < 0 && (n = 0), i < 0 && (i = 0), this.width = e, this.contentWidth = t, this.scrollWidth = Math.max(e, t), this.height = n, this.contentHeight = i, this.scrollHeight = Math.max(n, i);
  }
  equals(e) {
    return this.width === e.width && this.contentWidth === e.contentWidth && this.height === e.height && this.contentHeight === e.contentHeight;
  }
}
class M6t extends me {
  constructor(e, t) {
    super(), this._onDidContentSizeChange = this._register(new $()), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._dimensions = new wA(0, 0, 0, 0), this._scrollable = this._register(new nm({
      forceIntegerValues: !0,
      smoothScrollDuration: e,
      scheduleAtNextAnimationFrame: t
    })), this.onDidScroll = this._scrollable.onScroll;
  }
  getScrollable() {
    return this._scrollable;
  }
  setSmoothScrollDuration(e) {
    this._scrollable.setSmoothScrollDuration(e);
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  getScrollDimensions() {
    return this._dimensions;
  }
  setScrollDimensions(e) {
    if (this._dimensions.equals(e))
      return;
    const t = this._dimensions;
    this._dimensions = e, this._scrollable.setScrollDimensions({
      width: e.width,
      scrollWidth: e.scrollWidth,
      height: e.height,
      scrollHeight: e.scrollHeight
    }, !0);
    const n = t.contentWidth !== e.contentWidth, i = t.contentHeight !== e.contentHeight;
    (n || i) && this._onDidContentSizeChange.fire(new eR(t.contentWidth, t.contentHeight, e.contentWidth, e.contentHeight));
  }
  getFutureScrollPosition() {
    return this._scrollable.getFutureScrollPosition();
  }
  getCurrentScrollPosition() {
    return this._scrollable.getCurrentScrollPosition();
  }
  setScrollPositionNow(e) {
    this._scrollable.setScrollPositionNow(e);
  }
  setScrollPositionSmooth(e) {
    this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
}
class D6t extends me {
  constructor(e, t, n) {
    super(), this._configuration = e;
    const i = this._configuration.options, s = i.get(
      146
      /* EditorOption.layoutInfo */
    ), o = i.get(
      84
      /* EditorOption.padding */
    );
    this._linesLayout = new x6t(t, i.get(
      67
      /* EditorOption.lineHeight */
    ), o.top, o.bottom), this._maxLineWidth = 0, this._overlayWidgetsMinWidth = 0, this._scrollable = this._register(new M6t(0, n)), this._configureSmoothScrollDuration(), this._scrollable.setScrollDimensions(new wA(s.contentWidth, 0, s.height, 0)), this.onDidScroll = this._scrollable.onDidScroll, this.onDidContentSizeChange = this._scrollable.onDidContentSizeChange, this._updateHeight();
  }
  dispose() {
    super.dispose();
  }
  getScrollable() {
    return this._scrollable.getScrollable();
  }
  onHeightMaybeChanged() {
    this._updateHeight();
  }
  _configureSmoothScrollDuration() {
    this._scrollable.setSmoothScrollDuration(this._configuration.options.get(
      115
      /* EditorOption.smoothScrolling */
    ) ? S6t : 0);
  }
  // ---- begin view event handlers
  onConfigurationChanged(e) {
    const t = this._configuration.options;
    if (e.hasChanged(
      67
      /* EditorOption.lineHeight */
    ) && this._linesLayout.setLineHeight(t.get(
      67
      /* EditorOption.lineHeight */
    )), e.hasChanged(
      84
      /* EditorOption.padding */
    )) {
      const n = t.get(
        84
        /* EditorOption.padding */
      );
      this._linesLayout.setPadding(n.top, n.bottom);
    }
    if (e.hasChanged(
      146
      /* EditorOption.layoutInfo */
    )) {
      const n = t.get(
        146
        /* EditorOption.layoutInfo */
      ), i = n.contentWidth, s = n.height, o = this._scrollable.getScrollDimensions(), a = o.contentWidth;
      this._scrollable.setScrollDimensions(new wA(i, o.contentWidth, s, this._getContentHeight(i, s, a)));
    } else
      this._updateHeight();
    e.hasChanged(
      115
      /* EditorOption.smoothScrolling */
    ) && this._configureSmoothScrollDuration();
  }
  onFlushed(e) {
    this._linesLayout.onFlushed(e);
  }
  onLinesDeleted(e, t) {
    this._linesLayout.onLinesDeleted(e, t);
  }
  onLinesInserted(e, t) {
    this._linesLayout.onLinesInserted(e, t);
  }
  // ---- end view event handlers
  _getHorizontalScrollbarHeight(e, t) {
    const i = this._configuration.options.get(
      104
      /* EditorOption.scrollbar */
    );
    return i.horizontal === 2 || e >= t ? 0 : i.horizontalScrollbarSize;
  }
  _getContentHeight(e, t, n) {
    const i = this._configuration.options;
    let s = this._linesLayout.getLinesTotalHeight();
    return i.get(
      106
      /* EditorOption.scrollBeyondLastLine */
    ) ? s += Math.max(0, t - i.get(
      67
      /* EditorOption.lineHeight */
    ) - i.get(
      84
      /* EditorOption.padding */
    ).bottom) : i.get(
      104
      /* EditorOption.scrollbar */
    ).ignoreHorizontalScrollbarInContentHeight || (s += this._getHorizontalScrollbarHeight(e, n)), s;
  }
  _updateHeight() {
    const e = this._scrollable.getScrollDimensions(), t = e.width, n = e.height, i = e.contentWidth;
    this._scrollable.setScrollDimensions(new wA(t, e.contentWidth, n, this._getContentHeight(t, n, i)));
  }
  // ---- Layouting logic
  getCurrentViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getCurrentScrollPosition();
    return new q5e(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  getFutureViewport() {
    const e = this._scrollable.getScrollDimensions(), t = this._scrollable.getFutureScrollPosition();
    return new q5e(t.scrollTop, t.scrollLeft, e.width, e.height);
  }
  _computeContentWidth() {
    const e = this._configuration.options, t = this._maxLineWidth, n = e.get(
      147
      /* EditorOption.wrappingInfo */
    ), i = e.get(
      50
      /* EditorOption.fontInfo */
    ), s = e.get(
      146
      /* EditorOption.layoutInfo */
    );
    if (n.isViewportWrapping) {
      const o = e.get(
        73
        /* EditorOption.minimap */
      );
      return t > s.contentWidth + i.typicalHalfwidthCharacterWidth && o.enabled && o.side === "right" ? t + s.verticalScrollbarWidth : t;
    } else {
      const o = e.get(
        105
        /* EditorOption.scrollBeyondLastColumn */
      ) * i.typicalHalfwidthCharacterWidth, a = this._linesLayout.getWhitespaceMinWidth();
      return Math.max(t + o + s.verticalScrollbarWidth, a, this._overlayWidgetsMinWidth);
    }
  }
  setMaxLineWidth(e) {
    this._maxLineWidth = e, this._updateContentWidth();
  }
  setOverlayWidgetsMinWidth(e) {
    this._overlayWidgetsMinWidth = e, this._updateContentWidth();
  }
  _updateContentWidth() {
    const e = this._scrollable.getScrollDimensions();
    this._scrollable.setScrollDimensions(new wA(e.width, this._computeContentWidth(), e.height, e.contentHeight)), this._updateHeight();
  }
  // ---- view state
  saveState() {
    const e = this._scrollable.getFutureScrollPosition(), t = e.scrollTop, n = this._linesLayout.getLineNumberAtOrAfterVerticalOffset(t), i = this._linesLayout.getWhitespaceAccumulatedHeightBeforeLineNumber(n);
    return {
      scrollTop: t,
      scrollTopWithoutViewZones: t - i,
      scrollLeft: e.scrollLeft
    };
  }
  // ----
  changeWhitespace(e) {
    const t = this._linesLayout.changeWhitespace(e);
    return t && this.onHeightMaybeChanged(), t;
  }
  getVerticalOffsetForLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetForLineNumber(e, t);
  }
  getVerticalOffsetAfterLineNumber(e, t = !1) {
    return this._linesLayout.getVerticalOffsetAfterLineNumber(e, t);
  }
  isAfterLines(e) {
    return this._linesLayout.isAfterLines(e);
  }
  isInTopPadding(e) {
    return this._linesLayout.isInTopPadding(e);
  }
  isInBottomPadding(e) {
    return this._linesLayout.isInBottomPadding(e);
  }
  getLineNumberAtVerticalOffset(e) {
    return this._linesLayout.getLineNumberAtOrAfterVerticalOffset(e);
  }
  getWhitespaceAtVerticalOffset(e) {
    return this._linesLayout.getWhitespaceAtVerticalOffset(e);
  }
  getLinesViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getLinesViewportData(e.top, e.top + e.height);
  }
  getLinesViewportDataAtScrollTop(e) {
    const t = this._scrollable.getScrollDimensions();
    return e + t.height > t.scrollHeight && (e = t.scrollHeight - t.height), e < 0 && (e = 0), this._linesLayout.getLinesViewportData(e, e + t.height);
  }
  getWhitespaceViewportData() {
    const e = this.getCurrentViewport();
    return this._linesLayout.getWhitespaceViewportData(e.top, e.top + e.height);
  }
  getWhitespaces() {
    return this._linesLayout.getWhitespaces();
  }
  // ----
  getContentWidth() {
    return this._scrollable.getScrollDimensions().contentWidth;
  }
  getScrollWidth() {
    return this._scrollable.getScrollDimensions().scrollWidth;
  }
  getContentHeight() {
    return this._scrollable.getScrollDimensions().contentHeight;
  }
  getScrollHeight() {
    return this._scrollable.getScrollDimensions().scrollHeight;
  }
  getCurrentScrollLeft() {
    return this._scrollable.getCurrentScrollPosition().scrollLeft;
  }
  getCurrentScrollTop() {
    return this._scrollable.getCurrentScrollPosition().scrollTop;
  }
  validateScrollPosition(e) {
    return this._scrollable.validateScrollPosition(e);
  }
  setScrollPosition(e, t) {
    t === 1 ? this._scrollable.setScrollPositionNow(e) : this._scrollable.setScrollPositionSmooth(e);
  }
  hasPendingScrollAnimation() {
    return this._scrollable.hasPendingScrollAnimation();
  }
  deltaScrollNow(e, t) {
    const n = this._scrollable.getCurrentScrollPosition();
    this._scrollable.setScrollPositionNow({
      scrollLeft: n.scrollLeft + e,
      scrollTop: n.scrollTop + t
    });
  }
}
class L6t {
  constructor(e, t, n, i, s) {
    this.editorId = e, this.model = t, this.configuration = n, this._linesCollection = i, this._coordinatesConverter = s, this._decorationsCache = /* @__PURE__ */ Object.create(null), this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  _clearCachedModelDecorationsResolver() {
    this._cachedModelDecorationsResolver = null, this._cachedModelDecorationsResolverViewRange = null;
  }
  dispose() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  reset() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onModelDecorationsChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  onLineMappingChanged() {
    this._decorationsCache = /* @__PURE__ */ Object.create(null), this._clearCachedModelDecorationsResolver();
  }
  _getOrCreateViewModelDecoration(e) {
    const t = e.id;
    let n = this._decorationsCache[t];
    if (!n) {
      const i = e.range, s = e.options;
      let o;
      if (s.isWholeLine) {
        const a = this._coordinatesConverter.convertModelPositionToViewPosition(new le(i.startLineNumber, 1), 0, !1, !0), l = this._coordinatesConverter.convertModelPositionToViewPosition(
          new le(i.endLineNumber, this.model.getLineMaxColumn(i.endLineNumber)),
          1
          /* PositionAffinity.Right */
        );
        o = new Q(a.lineNumber, a.column, l.lineNumber, l.column);
      } else
        o = this._coordinatesConverter.convertModelRangeToViewRange(
          i,
          1
          /* PositionAffinity.Right */
        );
      n = new yLe(o, s), this._decorationsCache[t] = n;
    }
    return n;
  }
  getMinimapDecorationsInRange(e) {
    return this._getDecorationsInRange(e, !0, !1).decorations;
  }
  getDecorationsViewportData(e) {
    let t = this._cachedModelDecorationsResolver !== null;
    return t = t && e.equalsRange(this._cachedModelDecorationsResolverViewRange), t || (this._cachedModelDecorationsResolver = this._getDecorationsInRange(e, !1, !1), this._cachedModelDecorationsResolverViewRange = e), this._cachedModelDecorationsResolver;
  }
  getInlineDecorationsOnLine(e, t = !1, n = !1) {
    const i = new Q(e, this._linesCollection.getViewLineMinColumn(e), e, this._linesCollection.getViewLineMaxColumn(e));
    return this._getDecorationsInRange(i, t, n).inlineDecorations[0];
  }
  _getDecorationsInRange(e, t, n) {
    const i = this._linesCollection.getDecorationsInRange(e, this.editorId, M8(this.configuration.options), t, n), s = e.startLineNumber, o = e.endLineNumber, a = [];
    let l = 0;
    const c = [];
    for (let d = s; d <= o; d++)
      c[d - s] = [];
    for (let d = 0, u = i.length; d < u; d++) {
      const f = i[d], p = f.options;
      if (!k6t(this.model, f))
        continue;
      const g = this._getOrCreateViewModelDecoration(f), m = g.range;
      if (a[l++] = g, p.inlineClassName) {
        const A = new WA(
          m,
          p.inlineClassName,
          p.inlineClassNameAffectsLetterSpacing ? 3 : 0
          /* InlineDecorationType.Regular */
        ), w = Math.max(s, m.startLineNumber), v = Math.min(o, m.endLineNumber);
        for (let y = w; y <= v; y++)
          c[y - s].push(A);
      }
      if (p.beforeContentClassName && s <= m.startLineNumber && m.startLineNumber <= o) {
        const A = new WA(
          new Q(m.startLineNumber, m.startColumn, m.startLineNumber, m.startColumn),
          p.beforeContentClassName,
          1
          /* InlineDecorationType.Before */
        );
        c[m.startLineNumber - s].push(A);
      }
      if (p.afterContentClassName && s <= m.endLineNumber && m.endLineNumber <= o) {
        const A = new WA(
          new Q(m.endLineNumber, m.endColumn, m.endLineNumber, m.endColumn),
          p.afterContentClassName,
          2
          /* InlineDecorationType.After */
        );
        c[m.endLineNumber - s].push(A);
      }
    }
    return {
      decorations: a,
      inlineDecorations: c
    };
  }
}
function k6t(r, e) {
  return !(e.options.hideInCommentTokens && N6t(r, e) || e.options.hideInStringTokens && T6t(r, e));
}
function N6t(r, e) {
  return jke(
    r,
    e.range,
    (t) => t === 1
    /* StandardTokenType.Comment */
  );
}
function T6t(r, e) {
  return jke(
    r,
    e.range,
    (t) => t === 2
    /* StandardTokenType.String */
  );
}
function jke(r, e, t) {
  for (let n = e.startLineNumber; n <= e.endLineNumber; n++) {
    const i = r.tokenization.getLineTokens(n), s = n === e.startLineNumber, o = n === e.endLineNumber;
    let a = s ? i.findTokenIndexAtOffset(e.startColumn - 1) : 0;
    for (; a < i.getCount() && !(o && i.getStartOffset(a) > e.endColumn - 1); ) {
      if (!t(i.getStandardTokenType(a)))
        return !1;
      a++;
    }
  }
  return !0;
}
function a_(r, e) {
  return r === null ? e ? by.INSTANCE : yy.INSTANCE : new I6t(r, e);
}
class I6t {
  constructor(e, t) {
    this._projectionData = e, this._isVisible = t;
  }
  isVisible() {
    return this._isVisible;
  }
  setVisible(e) {
    return this._isVisible = e, this;
  }
  getProjectionData() {
    return this._projectionData;
  }
  getViewLineCount() {
    return this._isVisible ? this._projectionData.getOutputLineCount() : 0;
  }
  getViewLineContent(e, t, n) {
    this._assertVisible();
    const i = n > 0 ? this._projectionData.breakOffsets[n - 1] : 0, s = this._projectionData.breakOffsets[n];
    let o;
    if (this._projectionData.injectionOffsets !== null) {
      const a = this._projectionData.injectionOffsets.map((c, d) => new sc(0, 0, c + 1, this._projectionData.injectionOptions[d], 0));
      o = sc.applyInjectedText(e.getLineContent(t), a).substring(i, s);
    } else
      o = e.getValueInRange({
        startLineNumber: t,
        startColumn: i + 1,
        endLineNumber: t,
        endColumn: s + 1
      });
    return n > 0 && (o = u8e(this._projectionData.wrappedTextIndentLength) + o), o;
  }
  getViewLineLength(e, t, n) {
    return this._assertVisible(), this._projectionData.getLineLength(n);
  }
  getViewLineMinColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMinOutputOffset(n) + 1;
  }
  getViewLineMaxColumn(e, t, n) {
    return this._assertVisible(), this._projectionData.getMaxOutputOffset(n) + 1;
  }
  /**
   * Try using {@link getViewLinesData} instead.
  */
  getViewLineData(e, t, n) {
    const i = new Array();
    return this.getViewLinesData(e, t, n, 1, 0, [!0], i), i[0];
  }
  getViewLinesData(e, t, n, i, s, o, a) {
    this._assertVisible();
    const l = this._projectionData, c = l.injectionOffsets, d = l.injectionOptions;
    let u = null;
    if (c) {
      u = [];
      let p = 0, g = 0;
      for (let m = 0; m < l.getOutputLineCount(); m++) {
        const A = new Array();
        u[m] = A;
        const w = m > 0 ? l.breakOffsets[m - 1] : 0, v = l.breakOffsets[m];
        for (; g < c.length; ) {
          const y = d[g].content.length, _ = c[g] + p, S = _ + y;
          if (_ > v)
            break;
          if (w < S) {
            const D = d[g];
            if (D.inlineClassName) {
              const M = m > 0 ? l.wrappedTextIndentLength : 0, L = M + Math.max(_ - w, 0), T = M + Math.min(S - w, v - w);
              L !== T && A.push(new Jgt(L, T, D.inlineClassName, D.inlineClassNameAffectsLetterSpacing));
            }
          }
          if (S <= v)
            p += y, g++;
          else
            break;
        }
      }
    }
    let f;
    c ? f = e.tokenization.getLineTokens(t).withInserted(c.map((p, g) => ({
      offset: p,
      text: d[g].content,
      tokenMetadata: Ri.defaultTokenMetadata
    }))) : f = e.tokenization.getLineTokens(t);
    for (let p = n; p < n + i; p++) {
      const g = s + p - n;
      if (!o[g]) {
        a[g] = null;
        continue;
      }
      a[g] = this._getViewLineData(f, u ? u[p] : null, p);
    }
  }
  _getViewLineData(e, t, n) {
    this._assertVisible();
    const i = this._projectionData, s = n > 0 ? i.wrappedTextIndentLength : 0, o = n > 0 ? i.breakOffsets[n - 1] : 0, a = i.breakOffsets[n], l = e.sliceAndInflate(o, a, s);
    let c = l.getLineContent();
    n > 0 && (c = u8e(i.wrappedTextIndentLength) + c);
    const d = this._projectionData.getMinOutputOffset(n) + 1, u = c.length + 1, f = n + 1 < this.getViewLineCount(), p = n === 0 ? 0 : i.breakOffsetsVisibleColumn[n - 1];
    return new gO(c, f, d, u, p, l, t);
  }
  getModelColumnOfViewPosition(e, t) {
    return this._assertVisible(), this._projectionData.translateToInputOffset(e, t - 1) + 1;
  }
  getViewPositionOfModelPosition(e, t, n = 2) {
    return this._assertVisible(), this._projectionData.translateToOutputPosition(t - 1, n).toPosition(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    this._assertVisible();
    const n = this._projectionData.translateToOutputPosition(t - 1);
    return e + n.outputLineIndex;
  }
  normalizePosition(e, t, n) {
    const i = t.lineNumber - e;
    return this._projectionData.normalizeOutputPosition(e, t.column - 1, n).toPosition(i);
  }
  getInjectedTextAt(e, t) {
    return this._projectionData.getInjectedText(e, t - 1);
  }
  _assertVisible() {
    if (!this._isVisible)
      throw new Error("Not supported");
  }
}
class by {
  static {
    this.INSTANCE = new by();
  }
  constructor() {
  }
  isVisible() {
    return !0;
  }
  setVisible(e) {
    return e ? this : yy.INSTANCE;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 1;
  }
  getViewLineContent(e, t, n) {
    return e.getLineContent(t);
  }
  getViewLineLength(e, t, n) {
    return e.getLineLength(t);
  }
  getViewLineMinColumn(e, t, n) {
    return e.getLineMinColumn(t);
  }
  getViewLineMaxColumn(e, t, n) {
    return e.getLineMaxColumn(t);
  }
  getViewLineData(e, t, n) {
    const i = e.tokenization.getLineTokens(t), s = i.getLineContent();
    return new gO(s, !1, 1, s.length + 1, 0, i.inflate(), null);
  }
  getViewLinesData(e, t, n, i, s, o, a) {
    if (!o[s]) {
      a[s] = null;
      return;
    }
    a[s] = this.getViewLineData(e, t, 0);
  }
  getModelColumnOfViewPosition(e, t) {
    return t;
  }
  getViewPositionOfModelPosition(e, t) {
    return new le(e, t);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
  normalizePosition(e, t, n) {
    return t;
  }
  getInjectedTextAt(e, t) {
    return null;
  }
}
class yy {
  static {
    this.INSTANCE = new yy();
  }
  constructor() {
  }
  isVisible() {
    return !1;
  }
  setVisible(e) {
    return e ? by.INSTANCE : this;
  }
  getProjectionData() {
    return null;
  }
  getViewLineCount() {
    return 0;
  }
  getViewLineContent(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineLength(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMinColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineMaxColumn(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLineData(e, t, n) {
    throw new Error("Not supported");
  }
  getViewLinesData(e, t, n, i, s, o, a) {
    throw new Error("Not supported");
  }
  getModelColumnOfViewPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewPositionOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  getViewLineNumberOfModelPosition(e, t) {
    throw new Error("Not supported");
  }
  normalizePosition(e, t, n) {
    throw new Error("Not supported");
  }
  getInjectedTextAt(e, t) {
    throw new Error("Not supported");
  }
}
const l_ = [""];
function u8e(r) {
  if (r >= l_.length)
    for (let e = 1; e <= r; e++)
      l_[e] = O6t(e);
  return l_[r];
}
function O6t(r) {
  return new Array(r + 1).join(" ");
}
class R6t {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    this._editorId = e, this.model = t, this._validModelVersionId = -1, this._domLineBreaksComputerFactory = n, this._monospaceLineBreaksComputerFactory = i, this.fontInfo = s, this.tabSize = o, this.wrappingStrategy = a, this.wrappingColumn = l, this.wrappingIndent = c, this.wordBreak = d, this._constructLines(
      /*resetHiddenAreas*/
      !0,
      null
    );
  }
  dispose() {
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []);
  }
  createCoordinatesConverter() {
    return new H6t(this);
  }
  _constructLines(e, t) {
    this.modelLineProjections = [], e && (this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, []));
    const n = this.model.getLinesContent(), i = this.model.getInjectedTextDecorations(this._editorId), s = n.length, o = this.createLineBreaksComputer(), a = new Hd(sc.fromDecorations(i));
    for (let m = 0; m < s; m++) {
      const A = a.takeWhile((w) => w.lineNumber === m + 1);
      o.addRequest(n[m], A, t ? t[m] : null);
    }
    const l = o.finalize(), c = [], d = this.hiddenAreasDecorationIds.map((m) => this.model.getDecorationRange(m)).sort(Q.compareRangesUsingStarts);
    let u = 1, f = 0, p = -1, g = p + 1 < d.length ? f + 1 : s + 2;
    for (let m = 0; m < s; m++) {
      const A = m + 1;
      A === g && (p++, u = d[p].startLineNumber, f = d[p].endLineNumber, g = p + 1 < d.length ? f + 1 : s + 2);
      const w = A >= u && A <= f, v = a_(l[m], !w);
      c[m] = v.getViewLineCount(), this.modelLineProjections[m] = v;
    }
    this._validModelVersionId = this.model.getVersionId(), this.projectedModelLineLineCounts = new ypt(c);
  }
  getHiddenAreas() {
    return this.hiddenAreasDecorationIds.map((e) => this.model.getDecorationRange(e));
  }
  setHiddenAreas(e) {
    const t = e.map((f) => this.model.validateRange(f)), n = V6t(t), i = this.hiddenAreasDecorationIds.map((f) => this.model.getDecorationRange(f)).sort(Q.compareRangesUsingStarts);
    if (n.length === i.length) {
      let f = !1;
      for (let p = 0; p < n.length; p++)
        if (!n[p].equalsRange(i[p])) {
          f = !0;
          break;
        }
      if (!f)
        return !1;
    }
    const s = n.map((f) => ({
      range: f,
      options: fi.EMPTY
    }));
    this.hiddenAreasDecorationIds = this.model.deltaDecorations(this.hiddenAreasDecorationIds, s);
    const o = n;
    let a = 1, l = 0, c = -1, d = c + 1 < o.length ? l + 1 : this.modelLineProjections.length + 2, u = !1;
    for (let f = 0; f < this.modelLineProjections.length; f++) {
      const p = f + 1;
      p === d && (c++, a = o[c].startLineNumber, l = o[c].endLineNumber, d = c + 1 < o.length ? l + 1 : this.modelLineProjections.length + 2);
      let g = !1;
      if (p >= a && p <= l ? this.modelLineProjections[f].isVisible() && (this.modelLineProjections[f] = this.modelLineProjections[f].setVisible(!1), g = !0) : (u = !0, this.modelLineProjections[f].isVisible() || (this.modelLineProjections[f] = this.modelLineProjections[f].setVisible(!0), g = !0)), g) {
        const m = this.modelLineProjections[f].getViewLineCount();
        this.projectedModelLineLineCounts.setValue(f, m);
      }
    }
    return u || this.setHiddenAreas([]), !0;
  }
  modelPositionIsVisible(e, t) {
    return e < 1 || e > this.modelLineProjections.length ? !1 : this.modelLineProjections[e - 1].isVisible();
  }
  getModelLineViewLineCount(e) {
    return e < 1 || e > this.modelLineProjections.length ? 1 : this.modelLineProjections[e - 1].getViewLineCount();
  }
  setTabSize(e) {
    return this.tabSize === e ? !1 : (this.tabSize = e, this._constructLines(
      /*resetHiddenAreas*/
      !1,
      null
    ), !0);
  }
  setWrappingSettings(e, t, n, i, s) {
    const o = this.fontInfo.equals(e), a = this.wrappingStrategy === t, l = this.wrappingColumn === n, c = this.wrappingIndent === i, d = this.wordBreak === s;
    if (o && a && l && c && d)
      return !1;
    const u = o && a && !l && c && d;
    this.fontInfo = e, this.wrappingStrategy = t, this.wrappingColumn = n, this.wrappingIndent = i, this.wordBreak = s;
    let f = null;
    if (u) {
      f = [];
      for (let p = 0, g = this.modelLineProjections.length; p < g; p++)
        f[p] = this.modelLineProjections[p].getProjectionData();
    }
    return this._constructLines(
      /*resetHiddenAreas*/
      !1,
      f
    ), !0;
  }
  createLineBreaksComputer() {
    return (this.wrappingStrategy === "advanced" ? this._domLineBreaksComputerFactory : this._monospaceLineBreaksComputerFactory).createLineBreaksComputer(this.fontInfo, this.tabSize, this.wrappingColumn, this.wrappingIndent, this.wordBreak);
  }
  onModelFlushed() {
    this._constructLines(
      /*resetHiddenAreas*/
      !0,
      null
    );
  }
  onModelLinesDeleted(e, t, n) {
    if (!e || e <= this._validModelVersionId)
      return null;
    const i = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, s = this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections.splice(t - 1, n - t + 1), this.projectedModelLineLineCounts.removeValues(t - 1, n - t + 1), new RL(i, s);
  }
  onModelLinesInserted(e, t, n, i) {
    if (!e || e <= this._validModelVersionId)
      return null;
    const s = t > 2 && !this.modelLineProjections[t - 2].isVisible(), o = t === 1 ? 1 : this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1;
    let a = 0;
    const l = [], c = [];
    for (let d = 0, u = i.length; d < u; d++) {
      const f = a_(i[d], !s);
      l.push(f);
      const p = f.getViewLineCount();
      a += p, c[d] = p;
    }
    return this.modelLineProjections = this.modelLineProjections.slice(0, t - 1).concat(l).concat(this.modelLineProjections.slice(t - 1)), this.projectedModelLineLineCounts.insertValues(t - 1, c), new VL(o, o + a - 1);
  }
  onModelLineChanged(e, t, n) {
    if (e !== null && e <= this._validModelVersionId)
      return [!1, null, null, null];
    const i = t - 1, s = this.modelLineProjections[i].getViewLineCount(), o = this.modelLineProjections[i].isVisible(), a = a_(n, o);
    this.modelLineProjections[i] = a;
    const l = this.modelLineProjections[i].getViewLineCount();
    let c = !1, d = 0, u = -1, f = 0, p = -1, g = 0, m = -1;
    s > l ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + l - 1, g = u + 1, m = g + (s - l) - 1, c = !0) : s < l ? (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + s - 1, f = u + 1, p = f + (l - s) - 1, c = !0) : (d = this.projectedModelLineLineCounts.getPrefixSum(t - 1) + 1, u = d + l - 1), this.projectedModelLineLineCounts.setValue(i, l);
    const A = d <= u ? new Wke(d, u - d + 1) : null, w = f <= p ? new VL(f, p) : null, v = g <= m ? new RL(g, m) : null;
    return [c, A, w, v];
  }
  acceptVersionId(e) {
    this._validModelVersionId = e, this.modelLineProjections.length === 1 && !this.modelLineProjections[0].isVisible() && this.setHiddenAreas([]);
  }
  getViewLineCount() {
    return this.projectedModelLineLineCounts.getTotalSum();
  }
  _toValidViewLineNumber(e) {
    if (e < 1)
      return 1;
    const t = this.getViewLineCount();
    return e > t ? t : e | 0;
  }
  getActiveIndentGuide(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t), n = this._toValidViewLineNumber(n);
    const i = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), s = this.convertViewPositionToModelPosition(t, this.getViewLineMinColumn(t)), o = this.convertViewPositionToModelPosition(n, this.getViewLineMinColumn(n)), a = this.model.guides.getActiveIndentGuide(i.lineNumber, s.lineNumber, o.lineNumber), l = this.convertModelPositionToViewPosition(a.startLineNumber, 1), c = this.convertModelPositionToViewPosition(a.endLineNumber, this.model.getLineMaxColumn(a.endLineNumber));
    return {
      startLineNumber: l.lineNumber,
      endLineNumber: c.lineNumber,
      indent: a.indent
    };
  }
  // #region ViewLineInfo
  getViewLineInfo(e) {
    e = this._toValidViewLineNumber(e);
    const t = this.projectedModelLineLineCounts.getIndexOf(e - 1), n = t.index, i = t.remainder;
    return new f8e(n + 1, i);
  }
  getMinColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getMaxColumnOfViewLine(e) {
    return this.modelLineProjections[e.modelLineNumber - 1].getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx);
  }
  getModelStartPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMinColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), i = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new le(e.modelLineNumber, i);
  }
  getModelEndPositionOfViewLine(e) {
    const t = this.modelLineProjections[e.modelLineNumber - 1], n = t.getViewLineMaxColumn(this.model, e.modelLineNumber, e.modelLineWrappedLineIdx), i = t.getModelColumnOfViewPosition(e.modelLineWrappedLineIdx, n);
    return new le(e.modelLineNumber, i);
  }
  getViewLineInfosGroupedByModelRanges(e, t) {
    const n = this.getViewLineInfo(e), i = this.getViewLineInfo(t), s = new Array();
    let o = this.getModelStartPositionOfViewLine(n), a = new Array();
    for (let l = n.modelLineNumber; l <= i.modelLineNumber; l++) {
      const c = this.modelLineProjections[l - 1];
      if (c.isVisible()) {
        const d = l === n.modelLineNumber ? n.modelLineWrappedLineIdx : 0, u = l === i.modelLineNumber ? i.modelLineWrappedLineIdx + 1 : c.getViewLineCount();
        for (let f = d; f < u; f++)
          a.push(new f8e(l, f));
      }
      if (!c.isVisible() && o) {
        const d = new le(l - 1, this.model.getLineMaxColumn(l - 1) + 1), u = Q.fromPositions(o, d);
        s.push(new p8e(u, a)), a = [], o = null;
      } else c.isVisible() && !o && (o = new le(l, 1));
    }
    if (o) {
      const l = Q.fromPositions(o, this.getModelEndPositionOfViewLine(i));
      s.push(new p8e(l, a));
    }
    return s;
  }
  // #endregion
  getViewLinesBracketGuides(e, t, n, i) {
    const s = n ? this.convertViewPositionToModelPosition(n.lineNumber, n.column) : null, o = [];
    for (const a of this.getViewLineInfosGroupedByModelRanges(e, t)) {
      const l = a.modelRange.startLineNumber, c = this.model.guides.getLinesBracketGuides(l, a.modelRange.endLineNumber, s, i);
      for (const d of a.viewLines) {
        const f = c[d.modelLineNumber - l].map((p) => {
          if (p.forWrappedLinesAfterColumn !== -1 && this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, p.forWrappedLinesAfterColumn).lineNumber >= d.modelLineWrappedLineIdx || p.forWrappedLinesBeforeOrAtColumn !== -1 && this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, p.forWrappedLinesBeforeOrAtColumn).lineNumber < d.modelLineWrappedLineIdx)
            return;
          if (!p.horizontalLine)
            return p;
          let g = -1;
          if (p.column !== -1) {
            const w = this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, p.column);
            if (w.lineNumber === d.modelLineWrappedLineIdx)
              g = w.column;
            else if (w.lineNumber < d.modelLineWrappedLineIdx)
              g = this.getMinColumnOfViewLine(d);
            else if (w.lineNumber > d.modelLineWrappedLineIdx)
              return;
          }
          const m = this.convertModelPositionToViewPosition(d.modelLineNumber, p.horizontalLine.endColumn), A = this.modelLineProjections[d.modelLineNumber - 1].getViewPositionOfModelPosition(0, p.horizontalLine.endColumn);
          return A.lineNumber === d.modelLineWrappedLineIdx ? new R0(p.visibleColumn, g, p.className, new UA(p.horizontalLine.top, m.column), -1, -1) : A.lineNumber < d.modelLineWrappedLineIdx || p.visibleColumn !== -1 ? void 0 : new R0(p.visibleColumn, g, p.className, new UA(p.horizontalLine.top, this.getMaxColumnOfViewLine(d)), -1, -1);
        });
        o.push(f.filter((p) => !!p));
      }
    }
    return o;
  }
  getViewLinesIndentGuides(e, t) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const n = this.convertViewPositionToModelPosition(e, this.getViewLineMinColumn(e)), i = this.convertViewPositionToModelPosition(t, this.getViewLineMaxColumn(t));
    let s = [];
    const o = [], a = [], l = n.lineNumber - 1, c = i.lineNumber - 1;
    let d = null;
    for (let g = l; g <= c; g++) {
      const m = this.modelLineProjections[g];
      if (m.isVisible()) {
        const A = m.getViewLineNumberOfModelPosition(0, g === l ? n.column : 1), w = m.getViewLineNumberOfModelPosition(0, this.model.getLineMaxColumn(g + 1)), v = w - A + 1;
        let y = 0;
        v > 1 && m.getViewLineMinColumn(this.model, g + 1, w) === 1 && (y = A === 0 ? 1 : 2), o.push(v), a.push(y), d === null && (d = new le(g + 1, 0));
      } else
        d !== null && (s = s.concat(this.model.guides.getLinesIndentGuides(d.lineNumber, g)), d = null);
    }
    d !== null && (s = s.concat(this.model.guides.getLinesIndentGuides(d.lineNumber, i.lineNumber)), d = null);
    const u = t - e + 1, f = new Array(u);
    let p = 0;
    for (let g = 0, m = s.length; g < m; g++) {
      let A = s[g];
      const w = Math.min(u - p, o[g]), v = a[g];
      let y;
      v === 2 ? y = 0 : v === 1 ? y = 1 : y = w;
      for (let _ = 0; _ < w; _++)
        _ === y && (A = 0), f[p++] = A;
    }
    return f;
  }
  getViewLineContent(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineContent(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineLength(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineLength(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMinColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMinColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineMaxColumn(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineMaxColumn(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLineData(e) {
    const t = this.getViewLineInfo(e);
    return this.modelLineProjections[t.modelLineNumber - 1].getViewLineData(this.model, t.modelLineNumber, t.modelLineWrappedLineIdx);
  }
  getViewLinesData(e, t, n) {
    e = this._toValidViewLineNumber(e), t = this._toValidViewLineNumber(t);
    const i = this.projectedModelLineLineCounts.getIndexOf(e - 1);
    let s = e;
    const o = i.index, a = i.remainder, l = [];
    for (let c = o, d = this.model.getLineCount(); c < d; c++) {
      const u = this.modelLineProjections[c];
      if (!u.isVisible())
        continue;
      const f = c === o ? a : 0;
      let p = u.getViewLineCount() - f, g = !1;
      if (s + p > t && (g = !0, p = t - s + 1), u.getViewLinesData(this.model, c + 1, f, p, s - e, n, l), s += p, g)
        break;
    }
    return l;
  }
  validateViewPosition(e, t, n) {
    e = this._toValidViewLineNumber(e);
    const i = this.projectedModelLineLineCounts.getIndexOf(e - 1), s = i.index, o = i.remainder, a = this.modelLineProjections[s], l = a.getViewLineMinColumn(this.model, s + 1, o), c = a.getViewLineMaxColumn(this.model, s + 1, o);
    t < l && (t = l), t > c && (t = c);
    const d = a.getModelColumnOfViewPosition(o, t);
    return this.model.validatePosition(new le(s + 1, d)).equals(n) ? new le(e, t) : this.convertModelPositionToViewPosition(n.lineNumber, n.column);
  }
  validateViewRange(e, t) {
    const n = this.validateViewPosition(e.startLineNumber, e.startColumn, t.getStartPosition()), i = this.validateViewPosition(e.endLineNumber, e.endColumn, t.getEndPosition());
    return new Q(n.lineNumber, n.column, i.lineNumber, i.column);
  }
  convertViewPositionToModelPosition(e, t) {
    const n = this.getViewLineInfo(e), i = this.modelLineProjections[n.modelLineNumber - 1].getModelColumnOfViewPosition(n.modelLineWrappedLineIdx, t);
    return this.model.validatePosition(new le(n.modelLineNumber, i));
  }
  convertViewRangeToModelRange(e) {
    const t = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), n = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    return new Q(t.lineNumber, t.column, n.lineNumber, n.column);
  }
  convertModelPositionToViewPosition(e, t, n = 2, i = !1, s = !1) {
    const o = this.model.validatePosition(new le(e, t)), a = o.lineNumber, l = o.column;
    let c = a - 1, d = !1;
    if (s)
      for (; c < this.modelLineProjections.length && !this.modelLineProjections[c].isVisible(); )
        c++, d = !0;
    else
      for (; c > 0 && !this.modelLineProjections[c].isVisible(); )
        c--, d = !0;
    if (c === 0 && !this.modelLineProjections[c].isVisible())
      return new le(i ? 0 : 1, 1);
    const u = 1 + this.projectedModelLineLineCounts.getPrefixSum(c);
    let f;
    return d ? s ? f = this.modelLineProjections[c].getViewPositionOfModelPosition(u, 1, n) : f = this.modelLineProjections[c].getViewPositionOfModelPosition(u, this.model.getLineMaxColumn(c + 1), n) : f = this.modelLineProjections[a - 1].getViewPositionOfModelPosition(u, l, n), f;
  }
  /**
   * @param affinity The affinity in case of an empty range. Has no effect for non-empty ranges.
  */
  convertModelRangeToViewRange(e, t = 0) {
    if (e.isEmpty()) {
      const n = this.convertModelPositionToViewPosition(e.startLineNumber, e.startColumn, t);
      return Q.fromPositions(n);
    } else {
      const n = this.convertModelPositionToViewPosition(
        e.startLineNumber,
        e.startColumn,
        1
        /* PositionAffinity.Right */
      ), i = this.convertModelPositionToViewPosition(
        e.endLineNumber,
        e.endColumn,
        0
        /* PositionAffinity.Left */
      );
      return new Q(n.lineNumber, n.column, i.lineNumber, i.column);
    }
  }
  getViewLineNumberOfModelPosition(e, t) {
    let n = e - 1;
    if (this.modelLineProjections[n].isVisible()) {
      const s = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
      return this.modelLineProjections[n].getViewLineNumberOfModelPosition(s, t);
    }
    for (; n > 0 && !this.modelLineProjections[n].isVisible(); )
      n--;
    if (n === 0 && !this.modelLineProjections[n].isVisible())
      return 1;
    const i = 1 + this.projectedModelLineLineCounts.getPrefixSum(n);
    return this.modelLineProjections[n].getViewLineNumberOfModelPosition(i, this.model.getLineMaxColumn(n + 1));
  }
  getDecorationsInRange(e, t, n, i, s) {
    const o = this.convertViewPositionToModelPosition(e.startLineNumber, e.startColumn), a = this.convertViewPositionToModelPosition(e.endLineNumber, e.endColumn);
    if (a.lineNumber - o.lineNumber <= e.endLineNumber - e.startLineNumber)
      return this.model.getDecorationsInRange(new Q(o.lineNumber, 1, a.lineNumber, a.column), t, n, i, s);
    let l = [];
    const c = o.lineNumber - 1, d = a.lineNumber - 1;
    let u = null;
    for (let m = c; m <= d; m++)
      if (this.modelLineProjections[m].isVisible())
        u === null && (u = new le(m + 1, m === c ? o.column : 1));
      else if (u !== null) {
        const w = this.model.getLineMaxColumn(m);
        l = l.concat(this.model.getDecorationsInRange(new Q(u.lineNumber, u.column, m, w), t, n, i)), u = null;
      }
    u !== null && (l = l.concat(this.model.getDecorationsInRange(new Q(u.lineNumber, u.column, a.lineNumber, a.column), t, n, i)), u = null), l.sort((m, A) => {
      const w = Q.compareRangesUsingStarts(m.range, A.range);
      return w === 0 ? m.id < A.id ? -1 : m.id > A.id ? 1 : 0 : w;
    });
    const f = [];
    let p = 0, g = null;
    for (const m of l) {
      const A = m.id;
      g !== A && (g = A, f[p++] = m);
    }
    return f;
  }
  getInjectedTextAt(e) {
    const t = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[t.modelLineNumber - 1].getInjectedTextAt(t.modelLineWrappedLineIdx, e.column);
  }
  normalizePosition(e, t) {
    const n = this.getViewLineInfo(e.lineNumber);
    return this.modelLineProjections[n.modelLineNumber - 1].normalizePosition(n.modelLineWrappedLineIdx, e, t);
  }
  getLineIndentColumn(e) {
    const t = this.getViewLineInfo(e);
    return t.modelLineWrappedLineIdx === 0 ? this.model.getLineIndentColumn(t.modelLineNumber) : 0;
  }
}
function V6t(r) {
  if (r.length === 0)
    return [];
  const e = r.slice();
  e.sort(Q.compareRangesUsingStarts);
  const t = [];
  let n = e[0].startLineNumber, i = e[0].endLineNumber;
  for (let s = 1, o = e.length; s < o; s++) {
    const a = e[s];
    a.startLineNumber > i + 1 ? (t.push(new Q(n, 1, i, 1)), n = a.startLineNumber, i = a.endLineNumber) : a.endLineNumber > i && (i = a.endLineNumber);
  }
  return t.push(new Q(n, 1, i, 1)), t;
}
class f8e {
  constructor(e, t) {
    this.modelLineNumber = e, this.modelLineWrappedLineIdx = t;
  }
}
class p8e {
  constructor(e, t) {
    this.modelRange = e, this.viewLines = t;
  }
}
class H6t {
  constructor(e) {
    this._lines = e;
  }
  // View -> Model conversion and related methods
  convertViewPositionToModelPosition(e) {
    return this._lines.convertViewPositionToModelPosition(e.lineNumber, e.column);
  }
  convertViewRangeToModelRange(e) {
    return this._lines.convertViewRangeToModelRange(e);
  }
  validateViewPosition(e, t) {
    return this._lines.validateViewPosition(e.lineNumber, e.column, t);
  }
  validateViewRange(e, t) {
    return this._lines.validateViewRange(e, t);
  }
  // Model -> View conversion and related methods
  convertModelPositionToViewPosition(e, t, n, i) {
    return this._lines.convertModelPositionToViewPosition(e.lineNumber, e.column, t, n, i);
  }
  convertModelRangeToViewRange(e, t) {
    return this._lines.convertModelRangeToViewRange(e, t);
  }
  modelPositionIsVisible(e) {
    return this._lines.modelPositionIsVisible(e.lineNumber, e.column);
  }
  getModelLineViewLineCount(e) {
    return this._lines.getModelLineViewLineCount(e);
  }
  getViewLineNumberOfModelPosition(e, t) {
    return this._lines.getViewLineNumberOfModelPosition(e, t);
  }
}
class B6t {
  constructor(e) {
    this.model = e;
  }
  dispose() {
  }
  createCoordinatesConverter() {
    return new P6t(this);
  }
  getHiddenAreas() {
    return [];
  }
  setHiddenAreas(e) {
    return !1;
  }
  setTabSize(e) {
    return !1;
  }
  setWrappingSettings(e, t, n, i) {
    return !1;
  }
  createLineBreaksComputer() {
    const e = [];
    return {
      addRequest: (t, n, i) => {
        e.push(null);
      },
      finalize: () => e
    };
  }
  onModelFlushed() {
  }
  onModelLinesDeleted(e, t, n) {
    return new RL(t, n);
  }
  onModelLinesInserted(e, t, n, i) {
    return new VL(t, n);
  }
  onModelLineChanged(e, t, n) {
    return [!1, new Wke(t, 1), null, null];
  }
  acceptVersionId(e) {
  }
  getViewLineCount() {
    return this.model.getLineCount();
  }
  getActiveIndentGuide(e, t, n) {
    return {
      startLineNumber: e,
      endLineNumber: e,
      indent: 0
    };
  }
  getViewLinesBracketGuides(e, t, n) {
    return new Array(t - e + 1).fill([]);
  }
  getViewLinesIndentGuides(e, t) {
    const n = t - e + 1, i = new Array(n);
    for (let s = 0; s < n; s++)
      i[s] = 0;
    return i;
  }
  getViewLineContent(e) {
    return this.model.getLineContent(e);
  }
  getViewLineLength(e) {
    return this.model.getLineLength(e);
  }
  getViewLineMinColumn(e) {
    return this.model.getLineMinColumn(e);
  }
  getViewLineMaxColumn(e) {
    return this.model.getLineMaxColumn(e);
  }
  getViewLineData(e) {
    const t = this.model.tokenization.getLineTokens(e), n = t.getLineContent();
    return new gO(n, !1, 1, n.length + 1, 0, t.inflate(), null);
  }
  getViewLinesData(e, t, n) {
    const i = this.model.getLineCount();
    e = Math.min(Math.max(1, e), i), t = Math.min(Math.max(1, t), i);
    const s = [];
    for (let o = e; o <= t; o++) {
      const a = o - e;
      s[a] = n[a] ? this.getViewLineData(o) : null;
    }
    return s;
  }
  getDecorationsInRange(e, t, n, i, s) {
    return this.model.getDecorationsInRange(e, t, n, i, s);
  }
  normalizePosition(e, t) {
    return this.model.normalizePosition(e, t);
  }
  getLineIndentColumn(e) {
    return this.model.getLineIndentColumn(e);
  }
  getInjectedTextAt(e) {
    return null;
  }
}
class P6t {
  constructor(e) {
    this._lines = e;
  }
  _validPosition(e) {
    return this._lines.model.validatePosition(e);
  }
  _validRange(e) {
    return this._lines.model.validateRange(e);
  }
  // View -> Model conversion and related methods
  convertViewPositionToModelPosition(e) {
    return this._validPosition(e);
  }
  convertViewRangeToModelRange(e) {
    return this._validRange(e);
  }
  validateViewPosition(e, t) {
    return this._validPosition(t);
  }
  validateViewRange(e, t) {
    return this._validRange(t);
  }
  // Model -> View conversion and related methods
  convertModelPositionToViewPosition(e) {
    return this._validPosition(e);
  }
  convertModelRangeToViewRange(e) {
    return this._validRange(e);
  }
  modelPositionIsVisible(e) {
    const t = this._lines.model.getLineCount();
    return !(e.lineNumber < 1 || e.lineNumber > t);
  }
  getModelLineViewLineCount(e) {
    return 1;
  }
  getViewLineNumberOfModelPosition(e, t) {
    return e;
  }
}
const G1 = h1.Right;
class F6t {
  constructor(e) {
    this.persist = 0, this._requiredLanes = 1, this.lanes = new Uint8Array(Math.ceil((e + 1) * G1 / 8));
  }
  reset(e) {
    const t = Math.ceil((e + 1) * G1 / 8);
    this.lanes.length < t ? this.lanes = new Uint8Array(t) : this.lanes.fill(0), this._requiredLanes = 1;
  }
  get requiredLanes() {
    return this._requiredLanes;
  }
  push(e, t, n) {
    n && (this.persist |= 1 << e - 1);
    for (let i = t.startLineNumber; i <= t.endLineNumber; i++) {
      const s = G1 * i + (e - 1);
      this.lanes[s >>> 3] |= 1 << s % 8, this._requiredLanes = Math.max(this._requiredLanes, this.countAtLine(i));
    }
  }
  getLanesAtLine(e) {
    const t = [];
    let n = G1 * e;
    for (let i = 0; i < G1; i++)
      (this.persist & 1 << i || this.lanes[n >>> 3] & 1 << n % 8) && t.push(i + 1), n++;
    return t.length ? t : [h1.Center];
  }
  countAtLine(e) {
    let t = G1 * e, n = 0;
    for (let i = 0; i < G1; i++)
      (this.persist & 1 << i || this.lanes[t >>> 3] & 1 << t % 8) && n++, t++;
    return n;
  }
}
let z6t = class extends me {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    if (super(), this.languageConfigurationService = a, this._themeService = l, this._attachedView = c, this._transactionalTarget = d, this.hiddenAreasModel = new j6t(), this.previousHiddenAreas = [], this._editorId = e, this._configuration = t, this.model = n, this._eventDispatcher = new a6t(), this.onEvent = this._eventDispatcher.onEvent, this.cursorConfig = new x2(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._updateConfigurationViewLineCount = this._register(new Nr(() => this._updateConfigurationViewLineCountNow(), 0)), this._hasFocus = !1, this._viewportStart = iR.create(this.model), this.glyphLanes = new F6t(0), this.model.isTooLargeForTokenization())
      this._lines = new B6t(this.model);
    else {
      const u = this._configuration.options, f = u.get(
        50
        /* EditorOption.fontInfo */
      ), p = u.get(
        140
        /* EditorOption.wrappingStrategy */
      ), g = u.get(
        147
        /* EditorOption.wrappingInfo */
      ), m = u.get(
        139
        /* EditorOption.wrappingIndent */
      ), A = u.get(
        130
        /* EditorOption.wordBreak */
      );
      this._lines = new R6t(this._editorId, this.model, i, s, f, this.model.getOptions().tabSize, p, g.wrappingColumn, m, A);
    }
    this.coordinatesConverter = this._lines.createCoordinatesConverter(), this._cursor = this._register(new w6t(n, this, this.coordinatesConverter, this.cursorConfig)), this.viewLayout = this._register(new D6t(this._configuration, this.getLineCount(), o)), this._register(this.viewLayout.onDidScroll((u) => {
      u.scrollTopChanged && this._handleVisibleLinesChanged(), u.scrollTopChanged && this._viewportStart.invalidate(), this._eventDispatcher.emitSingleViewEvent(new n6t(u)), this._eventDispatcher.emitOutgoingEvent(new nR(u.oldScrollWidth, u.oldScrollLeft, u.oldScrollHeight, u.oldScrollTop, u.scrollWidth, u.scrollLeft, u.scrollHeight, u.scrollTop));
    })), this._register(this.viewLayout.onDidContentSizeChange((u) => {
      this._eventDispatcher.emitOutgoingEvent(u);
    })), this._decorations = new L6t(this._editorId, this.model, this._configuration, this._lines, this.coordinatesConverter), this._registerModelEvents(), this._register(this._configuration.onDidChangeFast((u) => {
      try {
        const f = this._eventDispatcher.beginEmitViewEvents();
        this._onConfigurationChanged(f, u);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
    })), this._register(wy.getInstance().onDidChange(() => {
      this._eventDispatcher.emitSingleViewEvent(new s6t());
    })), this._register(this._themeService.onDidColorThemeChange((u) => {
      this._invalidateDecorationsColorCache(), this._eventDispatcher.emitSingleViewEvent(new i6t(u));
    })), this._updateConfigurationViewLineCountNow();
  }
  dispose() {
    super.dispose(), this._decorations.dispose(), this._lines.dispose(), this._viewportStart.dispose(), this._eventDispatcher.dispose();
  }
  createLineBreaksComputer() {
    return this._lines.createLineBreaksComputer();
  }
  addViewEventHandler(e) {
    this._eventDispatcher.addViewEventHandler(e);
  }
  removeViewEventHandler(e) {
    this._eventDispatcher.removeViewEventHandler(e);
  }
  _updateConfigurationViewLineCountNow() {
    this._configuration.setViewLineCount(this._lines.getViewLineCount());
  }
  getModelVisibleRanges() {
    const e = this.viewLayout.getLinesViewportData(), t = new Q(e.startLineNumber, this.getLineMinColumn(e.startLineNumber), e.endLineNumber, this.getLineMaxColumn(e.endLineNumber));
    return this._toModelVisibleRanges(t);
  }
  visibleLinesStabilized() {
    const e = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(e, !0);
  }
  _handleVisibleLinesChanged() {
    const e = this.getModelVisibleRanges();
    this._attachedView.setVisibleLines(e, !1);
  }
  setHasFocus(e) {
    this._hasFocus = e, this._cursor.setHasFocus(e), this._eventDispatcher.emitSingleViewEvent(new e6t(e)), this._eventDispatcher.emitOutgoingEvent(new tR(!e, e));
  }
  onCompositionStart() {
    this._eventDispatcher.emitSingleViewEvent(new Y5t());
  }
  onCompositionEnd() {
    this._eventDispatcher.emitSingleViewEvent(new X5t());
  }
  _captureStableViewport() {
    if (this._viewportStart.isValid && this.viewLayout.getCurrentScrollTop() > 0) {
      const e = new le(this._viewportStart.viewLineNumber, this.getLineMinColumn(this._viewportStart.viewLineNumber)), t = this.coordinatesConverter.convertViewPositionToModelPosition(e);
      return new m8e(t, this._viewportStart.startLineDelta);
    }
    return new m8e(null, 0);
  }
  _onConfigurationChanged(e, t) {
    const n = this._captureStableViewport(), i = this._configuration.options, s = i.get(
      50
      /* EditorOption.fontInfo */
    ), o = i.get(
      140
      /* EditorOption.wrappingStrategy */
    ), a = i.get(
      147
      /* EditorOption.wrappingInfo */
    ), l = i.get(
      139
      /* EditorOption.wrappingIndent */
    ), c = i.get(
      130
      /* EditorOption.wordBreak */
    );
    this._lines.setWrappingSettings(s, o, a.wrappingColumn, l, c) && (e.emitViewEvent(new jv()), e.emitViewEvent(new Zv()), e.emitViewEvent(new q1(null)), this._cursor.onLineMappingChanged(e), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this._updateConfigurationViewLineCount.schedule()), t.hasChanged(
      92
      /* EditorOption.readOnly */
    ) && (this._decorations.reset(), e.emitViewEvent(new q1(null))), t.hasChanged(
      99
      /* EditorOption.renderValidationDecorations */
    ) && (this._decorations.reset(), e.emitViewEvent(new q1(null))), e.emitViewEvent(new J5t(t)), this.viewLayout.onConfigurationChanged(t), n.recoverViewportStart(this.coordinatesConverter, this.viewLayout), x2.shouldRecreate(t) && (this.cursorConfig = new x2(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig));
  }
  _registerModelEvents() {
    this._register(this.model.onDidChangeContentOrInjectedText((e) => {
      try {
        const n = this._eventDispatcher.beginEmitViewEvents();
        let i = !1, s = !1;
        const o = e instanceof K0 ? e.rawContentChangedEvent.changes : e.changes, a = e instanceof K0 ? e.rawContentChangedEvent.versionId : null, l = this._lines.createLineBreaksComputer();
        for (const u of o)
          switch (u.changeType) {
            case 4: {
              for (let f = 0; f < u.detail.length; f++) {
                const p = u.detail[f];
                let g = u.injectedTexts[f];
                g && (g = g.filter((m) => !m.ownerId || m.ownerId === this._editorId)), l.addRequest(p, g, null);
              }
              break;
            }
            case 2: {
              let f = null;
              u.injectedText && (f = u.injectedText.filter((p) => !p.ownerId || p.ownerId === this._editorId)), l.addRequest(u.detail, f, null);
              break;
            }
          }
        const c = l.finalize(), d = new Hd(c);
        for (const u of o)
          switch (u.changeType) {
            case 1: {
              this._lines.onModelFlushed(), n.emitViewEvent(new jv()), this._decorations.reset(), this.viewLayout.onFlushed(this.getLineCount()), i = !0;
              break;
            }
            case 3: {
              const f = this._lines.onModelLinesDeleted(a, u.fromLineNumber, u.toLineNumber);
              f !== null && (n.emitViewEvent(f), this.viewLayout.onLinesDeleted(f.fromLineNumber, f.toLineNumber)), i = !0;
              break;
            }
            case 4: {
              const f = d.takeCount(u.detail.length), p = this._lines.onModelLinesInserted(a, u.fromLineNumber, u.toLineNumber, f);
              p !== null && (n.emitViewEvent(p), this.viewLayout.onLinesInserted(p.fromLineNumber, p.toLineNumber)), i = !0;
              break;
            }
            case 2: {
              const f = d.dequeue(), [p, g, m, A] = this._lines.onModelLineChanged(a, u.lineNumber, f);
              s = p, g && n.emitViewEvent(g), m && (n.emitViewEvent(m), this.viewLayout.onLinesInserted(m.fromLineNumber, m.toLineNumber)), A && (n.emitViewEvent(A), this.viewLayout.onLinesDeleted(A.fromLineNumber, A.toLineNumber));
              break;
            }
            case 5:
              break;
          }
        a !== null && this._lines.acceptVersionId(a), this.viewLayout.onHeightMaybeChanged(), !i && s && (n.emitViewEvent(new Zv()), n.emitViewEvent(new q1(null)), this._cursor.onLineMappingChanged(n), this._decorations.onLineMappingChanged());
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      const t = this._viewportStart.isValid;
      if (this._viewportStart.invalidate(), this._configuration.setModelLineCount(this.model.getLineCount()), this._updateConfigurationViewLineCountNow(), !this._hasFocus && this.model.getAttachedEditorCount() >= 2 && t) {
        const n = this.model._getTrackedRange(this._viewportStart.modelTrackedRange);
        if (n) {
          const i = this.coordinatesConverter.convertModelPositionToViewPosition(n.getStartPosition()), s = this.viewLayout.getVerticalOffsetForLineNumber(i.lineNumber);
          this.viewLayout.setScrollPosition(
            { scrollTop: s + this._viewportStart.startLineDelta },
            1
            /* ScrollType.Immediate */
          );
        }
      }
      try {
        const n = this._eventDispatcher.beginEmitViewEvents();
        e instanceof K0 && n.emitOutgoingEvent(new g6t(e.contentChangedEvent)), this._cursor.onModelContentChanged(n, e);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
      this._handleVisibleLinesChanged();
    })), this._register(this.model.onDidChangeTokens((e) => {
      const t = [];
      for (let n = 0, i = e.ranges.length; n < i; n++) {
        const s = e.ranges[n], o = this.coordinatesConverter.convertModelPositionToViewPosition(new le(s.fromLineNumber, 1)).lineNumber, a = this.coordinatesConverter.convertModelPositionToViewPosition(new le(s.toLineNumber, this.model.getLineMaxColumn(s.toLineNumber))).lineNumber;
        t[n] = {
          fromLineNumber: o,
          toLineNumber: a
        };
      }
      this._eventDispatcher.emitSingleViewEvent(new r6t(t)), this._eventDispatcher.emitOutgoingEvent(new A6t(e));
    })), this._register(this.model.onDidChangeLanguageConfiguration((e) => {
      this._eventDispatcher.emitSingleViewEvent(new t6t()), this.cursorConfig = new x2(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new p6t(e));
    })), this._register(this.model.onDidChangeLanguage((e) => {
      this.cursorConfig = new x2(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new f6t(e));
    })), this._register(this.model.onDidChangeOptions((e) => {
      if (this._lines.setTabSize(this.model.getOptions().tabSize)) {
        try {
          const t = this._eventDispatcher.beginEmitViewEvents();
          t.emitViewEvent(new jv()), t.emitViewEvent(new Zv()), t.emitViewEvent(new q1(null)), this._cursor.onLineMappingChanged(t), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount());
        } finally {
          this._eventDispatcher.endEmitViewEvents();
        }
        this._updateConfigurationViewLineCount.schedule();
      }
      this.cursorConfig = new x2(this.model.getLanguageId(), this.model.getOptions(), this._configuration, this.languageConfigurationService), this._cursor.updateConfiguration(this.cursorConfig), this._eventDispatcher.emitOutgoingEvent(new m6t(e));
    })), this._register(this.model.onDidChangeDecorations((e) => {
      this._decorations.onModelDecorationsChanged(), this._eventDispatcher.emitSingleViewEvent(new q1(e)), this._eventDispatcher.emitOutgoingEvent(new u6t(e));
    }));
  }
  setHiddenAreas(e, t) {
    this.hiddenAreasModel.setHiddenAreas(t, e);
    const n = this.hiddenAreasModel.getMergedRanges();
    if (n === this.previousHiddenAreas)
      return;
    this.previousHiddenAreas = n;
    const i = this._captureStableViewport();
    let s = !1;
    try {
      const o = this._eventDispatcher.beginEmitViewEvents();
      s = this._lines.setHiddenAreas(n), s && (o.emitViewEvent(new jv()), o.emitViewEvent(new Zv()), o.emitViewEvent(new q1(null)), this._cursor.onLineMappingChanged(o), this._decorations.onLineMappingChanged(), this.viewLayout.onFlushed(this.getLineCount()), this.viewLayout.onHeightMaybeChanged());
      const a = i.viewportStartModelPosition?.lineNumber;
      a && n.some((c) => c.startLineNumber <= a && a <= c.endLineNumber) || i.recoverViewportStart(this.coordinatesConverter, this.viewLayout);
    } finally {
      this._eventDispatcher.endEmitViewEvents();
    }
    this._updateConfigurationViewLineCount.schedule(), s && this._eventDispatcher.emitOutgoingEvent(new h6t());
  }
  getVisibleRangesPlusViewportAboveBelow() {
    const e = this._configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    ), t = this._configuration.options.get(
      67
      /* EditorOption.lineHeight */
    ), n = Math.max(20, Math.round(e.height / t)), i = this.viewLayout.getLinesViewportData(), s = Math.max(1, i.completelyVisibleStartLineNumber - n), o = Math.min(this.getLineCount(), i.completelyVisibleEndLineNumber + n);
    return this._toModelVisibleRanges(new Q(s, this.getLineMinColumn(s), o, this.getLineMaxColumn(o)));
  }
  getVisibleRanges() {
    const e = this.getCompletelyVisibleViewRange();
    return this._toModelVisibleRanges(e);
  }
  getHiddenAreas() {
    return this._lines.getHiddenAreas();
  }
  _toModelVisibleRanges(e) {
    const t = this.coordinatesConverter.convertViewRangeToModelRange(e), n = this._lines.getHiddenAreas();
    if (n.length === 0)
      return [t];
    const i = [];
    let s = 0, o = t.startLineNumber, a = t.startColumn;
    const l = t.endLineNumber, c = t.endColumn;
    for (let d = 0, u = n.length; d < u; d++) {
      const f = n[d].startLineNumber, p = n[d].endLineNumber;
      p < o || f > l || (o < f && (i[s++] = new Q(o, a, f - 1, this.model.getLineMaxColumn(f - 1))), o = p + 1, a = 1);
    }
    return (o < l || o === l && a < c) && (i[s++] = new Q(o, a, l, c)), i;
  }
  getCompletelyVisibleViewRange() {
    const e = this.viewLayout.getLinesViewportData(), t = e.completelyVisibleStartLineNumber, n = e.completelyVisibleEndLineNumber;
    return new Q(t, this.getLineMinColumn(t), n, this.getLineMaxColumn(n));
  }
  getCompletelyVisibleViewRangeAtScrollTop(e) {
    const t = this.viewLayout.getLinesViewportDataAtScrollTop(e), n = t.completelyVisibleStartLineNumber, i = t.completelyVisibleEndLineNumber;
    return new Q(n, this.getLineMinColumn(n), i, this.getLineMaxColumn(i));
  }
  saveState() {
    const e = this.viewLayout.saveState(), t = e.scrollTop, n = this.viewLayout.getLineNumberAtVerticalOffset(t), i = this.coordinatesConverter.convertViewPositionToModelPosition(new le(n, this.getLineMinColumn(n))), s = this.viewLayout.getVerticalOffsetForLineNumber(n) - t;
    return {
      scrollLeft: e.scrollLeft,
      firstPosition: i,
      firstPositionDeltaTop: s
    };
  }
  reduceRestoreState(e) {
    if (typeof e.firstPosition > "u")
      return this._reduceRestoreStateCompatibility(e);
    const t = this.model.validatePosition(e.firstPosition), n = this.coordinatesConverter.convertModelPositionToViewPosition(t), i = this.viewLayout.getVerticalOffsetForLineNumber(n.lineNumber) - e.firstPositionDeltaTop;
    return {
      scrollLeft: e.scrollLeft,
      scrollTop: i
    };
  }
  _reduceRestoreStateCompatibility(e) {
    return {
      scrollLeft: e.scrollLeft,
      scrollTop: e.scrollTopWithoutViewZones
    };
  }
  getTabSize() {
    return this.model.getOptions().tabSize;
  }
  getLineCount() {
    return this._lines.getViewLineCount();
  }
  /**
   * Gives a hint that a lot of requests are about to come in for these line numbers.
   */
  setViewport(e, t, n) {
    this._viewportStart.update(this, e);
  }
  getActiveIndentGuide(e, t, n) {
    return this._lines.getActiveIndentGuide(e, t, n);
  }
  getLinesIndentGuides(e, t) {
    return this._lines.getViewLinesIndentGuides(e, t);
  }
  getBracketGuidesInRangeByLine(e, t, n, i) {
    return this._lines.getViewLinesBracketGuides(e, t, n, i);
  }
  getLineContent(e) {
    return this._lines.getViewLineContent(e);
  }
  getLineLength(e) {
    return this._lines.getViewLineLength(e);
  }
  getLineMinColumn(e) {
    return this._lines.getViewLineMinColumn(e);
  }
  getLineMaxColumn(e) {
    return this._lines.getViewLineMaxColumn(e);
  }
  getLineFirstNonWhitespaceColumn(e) {
    const t = so(this.getLineContent(e));
    return t === -1 ? 0 : t + 1;
  }
  getLineLastNonWhitespaceColumn(e) {
    const t = Zf(this.getLineContent(e));
    return t === -1 ? 0 : t + 2;
  }
  getMinimapDecorationsInRange(e) {
    return this._decorations.getMinimapDecorationsInRange(e);
  }
  getDecorationsInViewport(e) {
    return this._decorations.getDecorationsViewportData(e).decorations;
  }
  getInjectedTextAt(e) {
    return this._lines.getInjectedTextAt(e);
  }
  getViewportViewLineRenderingData(e, t) {
    const i = this._decorations.getDecorationsViewportData(e).inlineDecorations[t - e.startLineNumber];
    return this._getViewLineRenderingData(t, i);
  }
  getViewLineRenderingData(e) {
    const t = this._decorations.getInlineDecorationsOnLine(e);
    return this._getViewLineRenderingData(e, t);
  }
  _getViewLineRenderingData(e, t) {
    const n = this.model.mightContainRTL(), i = this.model.mightContainNonBasicASCII(), s = this.getTabSize(), o = this._lines.getViewLineData(e);
    return o.inlineDecorations && (t = [
      ...t,
      ...o.inlineDecorations.map((a) => a.toInlineDecoration(e))
    ]), new zo(o.minColumn, o.maxColumn, o.content, o.continuesWithWrappedLine, n, i, o.tokens, t, s, o.startVisibleColumn);
  }
  getViewLineData(e) {
    return this._lines.getViewLineData(e);
  }
  getMinimapLinesRenderingData(e, t, n) {
    const i = this._lines.getViewLinesData(e, t, n);
    return new Xgt(this.getTabSize(), i);
  }
  getAllOverviewRulerDecorations(e) {
    const t = this.model.getOverviewRulerDecorations(this._editorId, M8(this._configuration.options)), n = new W6t();
    for (const i of t) {
      const s = i.options, o = s.overviewRuler;
      if (!o)
        continue;
      const a = o.position;
      if (a === 0)
        continue;
      const l = o.getColor(e.value), c = this.coordinatesConverter.getViewLineNumberOfModelPosition(i.range.startLineNumber, i.range.startColumn), d = this.coordinatesConverter.getViewLineNumberOfModelPosition(i.range.endLineNumber, i.range.endColumn);
      n.accept(l, s.zIndex, c, d, a);
    }
    return n.asArray;
  }
  _invalidateDecorationsColorCache() {
    const e = this.model.getOverviewRulerDecorations();
    for (const t of e)
      t.options.overviewRuler?.invalidateCachedColor(), t.options.minimap?.invalidateCachedColor();
  }
  getValueInRange(e, t) {
    const n = this.coordinatesConverter.convertViewRangeToModelRange(e);
    return this.model.getValueInRange(n, t);
  }
  getValueLengthInRange(e, t) {
    const n = this.coordinatesConverter.convertViewRangeToModelRange(e);
    return this.model.getValueLengthInRange(n, t);
  }
  modifyPosition(e, t) {
    const n = this.coordinatesConverter.convertViewPositionToModelPosition(e), i = this.model.modifyPosition(n, t);
    return this.coordinatesConverter.convertModelPositionToViewPosition(i);
  }
  deduceModelPositionRelativeToViewPosition(e, t, n) {
    const i = this.coordinatesConverter.convertViewPositionToModelPosition(e);
    this.model.getEOL().length === 2 && (t < 0 ? t -= n : t += n);
    const o = this.model.getOffsetAt(i) + t;
    return this.model.getPositionAt(o);
  }
  getPlainTextToCopy(e, t, n) {
    const i = n ? `\r
` : this.model.getEOL();
    e = e.slice(0), e.sort(Q.compareRangesUsingStarts);
    let s = !1, o = !1;
    for (const l of e)
      l.isEmpty() ? s = !0 : o = !0;
    if (!o) {
      if (!t)
        return "";
      const l = e.map((d) => d.startLineNumber);
      let c = "";
      for (let d = 0; d < l.length; d++)
        d > 0 && l[d - 1] === l[d] || (c += this.model.getLineContent(l[d]) + i);
      return c;
    }
    if (s && t) {
      const l = [];
      let c = 0;
      for (const d of e) {
        const u = d.startLineNumber;
        d.isEmpty() ? u !== c && l.push(this.model.getLineContent(u)) : l.push(this.model.getValueInRange(
          d,
          n ? 2 : 0
          /* EndOfLinePreference.TextDefined */
        )), c = u;
      }
      return l.length === 1 ? l[0] : l;
    }
    const a = [];
    for (const l of e)
      l.isEmpty() || a.push(this.model.getValueInRange(
        l,
        n ? 2 : 0
        /* EndOfLinePreference.TextDefined */
      ));
    return a.length === 1 ? a[0] : a;
  }
  getRichTextToCopy(e, t) {
    const n = this.model.getLanguageId();
    if (n === ll || e.length !== 1)
      return null;
    let i = e[0];
    if (i.isEmpty()) {
      if (!t)
        return null;
      const d = i.startLineNumber;
      i = new Q(d, this.model.getLineMinColumn(d), d, this.model.getLineMaxColumn(d));
    }
    const s = this._configuration.options.get(
      50
      /* EditorOption.fontInfo */
    ), o = this._getColorMap(), l = /[:;\\\/<>]/.test(s.fontFamily) || s.fontFamily === Bo.fontFamily;
    let c;
    return l ? c = Bo.fontFamily : (c = s.fontFamily, c = c.replace(/"/g, "'"), /[,']/.test(c) || /[+ ]/.test(c) && (c = `'${c}'`), c = `${c}, ${Bo.fontFamily}`), {
      mode: n,
      html: `<div style="color: ${o[
        1
        /* ColorId.DefaultForeground */
      ]};background-color: ${o[
        2
        /* ColorId.DefaultBackground */
      ]};font-family: ${c};font-weight: ${s.fontWeight};font-size: ${s.fontSize}px;line-height: ${s.lineHeight}px;white-space: pre;">` + this._getHTMLToCopy(i, o) + "</div>"
    };
  }
  _getHTMLToCopy(e, t) {
    const n = e.startLineNumber, i = e.startColumn, s = e.endLineNumber, o = e.endColumn, a = this.getTabSize();
    let l = "";
    for (let c = n; c <= s; c++) {
      const d = this.model.tokenization.getLineTokens(c), u = d.getLineContent(), f = c === n ? i - 1 : 0, p = c === s ? o - 1 : u.length;
      u === "" ? l += "<br>" : l += C6t(u, d.inflate(), t, f, p, a, zs);
    }
    return l;
  }
  _getColorMap() {
    const e = xi.getColorMap(), t = ["#000000"];
    if (e)
      for (let n = 1, i = e.length; n < i; n++)
        t[n] = ge.Format.CSS.formatHex(e[n]);
    return t;
  }
  //#region cursor operations
  getPrimaryCursorState() {
    return this._cursor.getPrimaryCursorState();
  }
  getLastAddedCursorIndex() {
    return this._cursor.getLastAddedCursorIndex();
  }
  getCursorStates() {
    return this._cursor.getCursorStates();
  }
  setCursorStates(e, t, n) {
    return this._withViewEventsCollector((i) => this._cursor.setStates(i, e, t, n));
  }
  getCursorColumnSelectData() {
    return this._cursor.getCursorColumnSelectData();
  }
  getCursorAutoClosedCharacters() {
    return this._cursor.getAutoClosedCharacters();
  }
  setCursorColumnSelectData(e) {
    this._cursor.setCursorColumnSelectData(e);
  }
  getPrevEditOperationType() {
    return this._cursor.getPrevEditOperationType();
  }
  setPrevEditOperationType(e) {
    this._cursor.setPrevEditOperationType(e);
  }
  getSelection() {
    return this._cursor.getSelection();
  }
  getSelections() {
    return this._cursor.getSelections();
  }
  getPosition() {
    return this._cursor.getPrimaryCursorState().modelState.position;
  }
  setSelections(e, t, n = 0) {
    this._withViewEventsCollector((i) => this._cursor.setSelections(i, e, t, n));
  }
  saveCursorState() {
    return this._cursor.saveState();
  }
  restoreCursorState(e) {
    this._withViewEventsCollector((t) => this._cursor.restoreState(t, e));
  }
  _executeCursorEdit(e) {
    if (this._cursor.context.cursorConfig.readOnly) {
      this._eventDispatcher.emitOutgoingEvent(new d6t());
      return;
    }
    this._withViewEventsCollector(e);
  }
  executeEdits(e, t, n) {
    this._executeCursorEdit((i) => this._cursor.executeEdits(i, e, t, n));
  }
  startComposition() {
    this._executeCursorEdit((e) => this._cursor.startComposition(e));
  }
  endComposition(e) {
    this._executeCursorEdit((t) => this._cursor.endComposition(t, e));
  }
  type(e, t) {
    this._executeCursorEdit((n) => this._cursor.type(n, e, t));
  }
  compositionType(e, t, n, i, s) {
    this._executeCursorEdit((o) => this._cursor.compositionType(o, e, t, n, i, s));
  }
  paste(e, t, n, i) {
    this._executeCursorEdit((s) => this._cursor.paste(s, e, t, n, i));
  }
  cut(e) {
    this._executeCursorEdit((t) => this._cursor.cut(t, e));
  }
  executeCommand(e, t) {
    this._executeCursorEdit((n) => this._cursor.executeCommand(n, e, t));
  }
  executeCommands(e, t) {
    this._executeCursorEdit((n) => this._cursor.executeCommands(n, e, t));
  }
  revealAllCursors(e, t, n = !1) {
    this._withViewEventsCollector((i) => this._cursor.revealAll(
      i,
      e,
      n,
      0,
      t,
      0
      /* ScrollType.Smooth */
    ));
  }
  revealPrimaryCursor(e, t, n = !1) {
    this._withViewEventsCollector((i) => this._cursor.revealPrimary(
      i,
      e,
      n,
      0,
      t,
      0
      /* ScrollType.Smooth */
    ));
  }
  revealTopMostCursor(e) {
    const t = this._cursor.getTopMostViewPosition(), n = new Q(t.lineNumber, t.column, t.lineNumber, t.column);
    this._withViewEventsCollector((i) => i.emitViewEvent(new e3(
      e,
      !1,
      n,
      null,
      0,
      !0,
      0
      /* ScrollType.Smooth */
    )));
  }
  revealBottomMostCursor(e) {
    const t = this._cursor.getBottomMostViewPosition(), n = new Q(t.lineNumber, t.column, t.lineNumber, t.column);
    this._withViewEventsCollector((i) => i.emitViewEvent(new e3(
      e,
      !1,
      n,
      null,
      0,
      !0,
      0
      /* ScrollType.Smooth */
    )));
  }
  revealRange(e, t, n, i, s) {
    this._withViewEventsCollector((o) => o.emitViewEvent(new e3(e, !1, n, null, i, t, s)));
  }
  //#endregion
  //#region viewLayout
  changeWhitespace(e) {
    this.viewLayout.changeWhitespace(e) && (this._eventDispatcher.emitSingleViewEvent(new o6t()), this._eventDispatcher.emitOutgoingEvent(new c6t()));
  }
  //#endregion
  _withViewEventsCollector(e) {
    return this._transactionalTarget.batchChanges(() => {
      try {
        const t = this._eventDispatcher.beginEmitViewEvents();
        return e(t);
      } finally {
        this._eventDispatcher.endEmitViewEvents();
      }
    });
  }
  batchEvents(e) {
    this._withViewEventsCollector(() => {
      e();
    });
  }
  normalizePosition(e, t) {
    return this._lines.normalizePosition(e, t);
  }
  /**
   * Gets the column at which indentation stops at a given line.
   * @internal
  */
  getLineIndentColumn(e) {
    return this._lines.getLineIndentColumn(e);
  }
};
class iR {
  static create(e) {
    const t = e._setTrackedRange(
      null,
      new Q(1, 1, 1, 1),
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    );
    return new iR(e, 1, !1, t, 0);
  }
  get viewLineNumber() {
    return this._viewLineNumber;
  }
  get isValid() {
    return this._isValid;
  }
  get modelTrackedRange() {
    return this._modelTrackedRange;
  }
  get startLineDelta() {
    return this._startLineDelta;
  }
  constructor(e, t, n, i, s) {
    this._model = e, this._viewLineNumber = t, this._isValid = n, this._modelTrackedRange = i, this._startLineDelta = s;
  }
  dispose() {
    this._model._setTrackedRange(
      this._modelTrackedRange,
      null,
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    );
  }
  update(e, t) {
    const n = e.coordinatesConverter.convertViewPositionToModelPosition(new le(t, e.getLineMinColumn(t))), i = e.model._setTrackedRange(
      this._modelTrackedRange,
      new Q(n.lineNumber, n.column, n.lineNumber, n.column),
      1
      /* TrackedRangeStickiness.NeverGrowsWhenTypingAtEdges */
    ), s = e.viewLayout.getVerticalOffsetForLineNumber(t), o = e.viewLayout.getCurrentScrollTop();
    this._viewLineNumber = t, this._isValid = !0, this._modelTrackedRange = i, this._startLineDelta = o - s;
  }
  invalidate() {
    this._isValid = !1;
  }
}
class W6t {
  constructor() {
    this._asMap = /* @__PURE__ */ Object.create(null), this.asArray = [];
  }
  accept(e, t, n, i, s) {
    const o = this._asMap[e];
    if (o) {
      const a = o.data, l = a[a.length - 3], c = a[a.length - 1];
      if (l === s && c + 1 >= n) {
        i > c && (a[a.length - 1] = i);
        return;
      }
      a.push(s, n, i);
    } else {
      const a = new U3(e, t, [s, n, i]);
      this._asMap[e] = a, this.asArray.push(a);
    }
  }
}
class j6t {
  constructor() {
    this.hiddenAreas = /* @__PURE__ */ new Map(), this.shouldRecompute = !1, this.ranges = [];
  }
  setHiddenAreas(e, t) {
    const n = this.hiddenAreas.get(e);
    n && g8e(n, t) || (this.hiddenAreas.set(e, t), this.shouldRecompute = !0);
  }
  /**
   * The returned array is immutable.
  */
  getMergedRanges() {
    if (!this.shouldRecompute)
      return this.ranges;
    this.shouldRecompute = !1;
    const e = Array.from(this.hiddenAreas.values()).reduce((t, n) => Z6t(t, n), []);
    return g8e(this.ranges, e) ? this.ranges : (this.ranges = e, this.ranges);
  }
}
function Z6t(r, e) {
  const t = [];
  let n = 0, i = 0;
  for (; n < r.length && i < e.length; ) {
    const s = r[n], o = e[i];
    if (s.endLineNumber < o.startLineNumber - 1)
      t.push(r[n++]);
    else if (o.endLineNumber < s.startLineNumber - 1)
      t.push(e[i++]);
    else {
      const a = Math.min(s.startLineNumber, o.startLineNumber), l = Math.max(s.endLineNumber, o.endLineNumber);
      t.push(new Q(a, 1, l, 1)), n++, i++;
    }
  }
  for (; n < r.length; )
    t.push(r[n++]);
  for (; i < e.length; )
    t.push(e[i++]);
  return t;
}
function g8e(r, e) {
  if (r.length !== e.length)
    return !1;
  for (let t = 0; t < r.length; t++)
    if (!r[t].equalsRange(e[t]))
      return !1;
  return !0;
}
class m8e {
  constructor(e, t) {
    this.viewportStartModelPosition = e, this.startLineDelta = t;
  }
  recoverViewportStart(e, t) {
    if (!this.viewportStartModelPosition)
      return;
    const n = e.convertModelPositionToViewPosition(this.viewportStartModelPosition), i = t.getVerticalOffsetForLineNumber(n.lineNumber);
    t.setScrollPosition(
      { scrollTop: i + this.startLineDelta },
      1
      /* ScrollType.Immediate */
    );
  }
}
class Nw {
  constructor(...e) {
    this._entries = /* @__PURE__ */ new Map();
    for (const [t, n] of e)
      this.set(t, n);
  }
  set(e, t) {
    const n = this._entries.get(e);
    return this._entries.set(e, t), n;
  }
  get(e) {
    return this._entries.get(e);
  }
}
var r4;
(function(r) {
  r[r.Ignore = 0] = "Ignore", r[r.Info = 1] = "Info", r[r.Warning = 2] = "Warning", r[r.Error = 3] = "Error";
})(r4 || (r4 = {}));
(function(r) {
  const e = "error", t = "warning", n = "warn", i = "info", s = "ignore";
  function o(l) {
    return l ? Q2(e, l) ? r.Error : Q2(t, l) || Q2(n, l) ? r.Warning : Q2(i, l) ? r.Info : r.Ignore : r.Ignore;
  }
  r.fromValue = o;
  function a(l) {
    switch (l) {
      case r.Error:
        return e;
      case r.Warning:
        return t;
      case r.Info:
        return i;
      default:
        return s;
    }
  }
  r.toString = a;
})(r4 || (r4 = {}));
const Oi = r4;
var Zke = Oi;
const Zo = Wt("notificationService");
class U6t {
}
var q6t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Bh = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, a0;
let C9 = class extends me {
  static {
    a0 = this;
  }
  static {
    this.dropIntoEditorDecorationOptions = fi.register({
      description: "workbench-dnd-target",
      className: "dnd-target"
    });
  }
  //#endregion
  get isSimpleWidget() {
    return this._configuration.isSimpleWidget;
  }
  get contextMenuId() {
    return this._configuration.contextMenuId;
  }
  constructor(e, t, n, i, s, o, a, l, c, d, u, f) {
    super(), this.languageConfigurationService = u, this._deliveryQueue = B1t(), this._contributions = this._register(new vvt()), this._onDidDispose = this._register(new $()), this.onDidDispose = this._onDidDispose.event, this._onDidChangeModelContent = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelContent = this._onDidChangeModelContent.event, this._onDidChangeModelLanguage = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguage = this._onDidChangeModelLanguage.event, this._onDidChangeModelLanguageConfiguration = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelLanguageConfiguration = this._onDidChangeModelLanguageConfiguration.event, this._onDidChangeModelOptions = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelOptions = this._onDidChangeModelOptions.event, this._onDidChangeModelDecorations = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelDecorations = this._onDidChangeModelDecorations.event, this._onDidChangeModelTokens = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModelTokens = this._onDidChangeModelTokens.event, this._onDidChangeConfiguration = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event, this._onWillChangeModel = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onWillChangeModel = this._onWillChangeModel.event, this._onDidChangeModel = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeModel = this._onDidChangeModel.event, this._onDidChangeCursorPosition = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorPosition = this._onDidChangeCursorPosition.event, this._onDidChangeCursorSelection = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeCursorSelection = this._onDidChangeCursorSelection.event, this._onDidAttemptReadOnlyEdit = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDidAttemptReadOnlyEdit = this._onDidAttemptReadOnlyEdit.event, this._onDidLayoutChange = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidLayoutChange = this._onDidLayoutChange.event, this._editorTextFocus = this._register(new A8e({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorText = this._editorTextFocus.onDidChangeToTrue, this.onDidBlurEditorText = this._editorTextFocus.onDidChangeToFalse, this._editorWidgetFocus = this._register(new A8e({ deliveryQueue: this._deliveryQueue })), this.onDidFocusEditorWidget = this._editorWidgetFocus.onDidChangeToTrue, this.onDidBlurEditorWidget = this._editorWidgetFocus.onDidChangeToFalse, this._onWillType = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onWillType = this._onWillType.event, this._onDidType = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDidType = this._onDidType.event, this._onDidCompositionStart = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDidCompositionStart = this._onDidCompositionStart.event, this._onDidCompositionEnd = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDidCompositionEnd = this._onDidCompositionEnd.event, this._onDidPaste = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDidPaste = this._onDidPaste.event, this._onMouseUp = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseUp = this._onMouseUp.event, this._onMouseDown = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseDown = this._onMouseDown.event, this._onMouseDrag = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseDrag = this._onMouseDrag.event, this._onMouseDrop = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseDrop = this._onMouseDrop.event, this._onMouseDropCanceled = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseDropCanceled = this._onMouseDropCanceled.event, this._onDropIntoEditor = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onDropIntoEditor = this._onDropIntoEditor.event, this._onContextMenu = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onContextMenu = this._onContextMenu.event, this._onMouseMove = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseMove = this._onMouseMove.event, this._onMouseLeave = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseLeave = this._onMouseLeave.event, this._onMouseWheel = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onMouseWheel = this._onMouseWheel.event, this._onKeyUp = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onKeyUp = this._onKeyUp.event, this._onKeyDown = this._register(new Yr(this._contributions, this._deliveryQueue)), this.onKeyDown = this._onKeyDown.event, this._onDidContentSizeChange = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidContentSizeChange = this._onDidContentSizeChange.event, this._onDidScrollChange = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidScrollChange = this._onDidScrollChange.event, this._onDidChangeViewZones = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeViewZones = this._onDidChangeViewZones.event, this._onDidChangeHiddenAreas = this._register(new $({ deliveryQueue: this._deliveryQueue })), this.onDidChangeHiddenAreas = this._onDidChangeHiddenAreas.event, this._updateCounter = 0, this._onBeginUpdate = this._register(new $()), this.onBeginUpdate = this._onBeginUpdate.event, this._onEndUpdate = this._register(new $()), this.onEndUpdate = this._onEndUpdate.event, this._actions = /* @__PURE__ */ new Map(), this._bannerDomNode = null, this._dropIntoEditorDecorations = this.createDecorationsCollection(), s.willCreateCodeEditor();
    const p = { ...t };
    this._domElement = e, this._overflowWidgetsDomNode = p.overflowWidgetsDomNode, delete p.overflowWidgetsDomNode, this._id = ++G6t, this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes = {}, this._telemetryData = n.telemetryData, this._configuration = this._register(this._createConfiguration(n.isSimpleWidget || !1, n.contextMenuId ?? (n.isSimpleWidget ? oe.SimpleEditorContext : oe.EditorContext), p, d)), this._register(this._configuration.onDidChange((A) => {
      this._onDidChangeConfiguration.fire(A);
      const w = this._configuration.options;
      if (A.hasChanged(
        146
        /* EditorOption.layoutInfo */
      )) {
        const v = w.get(
          146
          /* EditorOption.layoutInfo */
        );
        this._onDidLayoutChange.fire(v);
      }
    })), this._contextKeyService = this._register(a.createScoped(this._domElement)), this._notificationService = c, this._codeEditorService = s, this._commandService = o, this._themeService = l, this._register(new K6t(this, this._contextKeyService)), this._register(new Y6t(this, this._contextKeyService, f)), this._instantiationService = this._register(i.createChild(new Nw([sn, this._contextKeyService]))), this._modelData = null, this._focusTracker = new X6t(e, this._overflowWidgetsDomNode), this._register(this._focusTracker.onChange(() => {
      this._editorWidgetFocus.setValue(this._focusTracker.hasFocus());
    })), this._contentWidgets = {}, this._overlayWidgets = {}, this._glyphMarginWidgets = {};
    let g;
    Array.isArray(n.contributions) ? g = n.contributions : g = wp.getEditorContributions(), this._contributions.initialize(this, g, this._instantiationService);
    for (const A of wp.getEditorActions()) {
      if (this._actions.has(A.id)) {
        wn(new Error(`Cannot have two actions with the same id ${A.id}`));
        continue;
      }
      const w = new _ke(A.id, A.label, A.alias, A.metadata, A.precondition ?? void 0, (v) => this._instantiationService.invokeFunction((y) => Promise.resolve(A.runEditorCommand(y, this, v))), this._contextKeyService);
      this._actions.set(w.id, w);
    }
    const m = () => !this._configuration.options.get(
      92
      /* EditorOption.readOnly */
    ) && this._configuration.options.get(
      36
      /* EditorOption.dropIntoEditor */
    ).enabled;
    this._register(new Uft(this._domElement, {
      onDragOver: (A) => {
        if (!m())
          return;
        const w = this.getTargetAtClientPoint(A.clientX, A.clientY);
        w?.position && this.showDropIndicatorAt(w.position);
      },
      onDrop: async (A) => {
        if (!m() || (this.removeDropIndicator(), !A.dataTransfer))
          return;
        const w = this.getTargetAtClientPoint(A.clientX, A.clientY);
        w?.position && this._onDropIntoEditor.fire({ position: w.position, event: A });
      },
      onDragLeave: () => {
        this.removeDropIndicator();
      },
      onDragEnd: () => {
        this.removeDropIndicator();
      }
    })), this._codeEditorService.addCodeEditor(this);
  }
  writeScreenReaderContent(e) {
    this._modelData?.view.writeScreenReaderContent(e);
  }
  _createConfiguration(e, t, n, i) {
    return new sL(e, t, n, this._domElement, i);
  }
  getId() {
    return this.getEditorType() + ":" + this._id;
  }
  getEditorType() {
    return dO.ICodeEditor;
  }
  dispose() {
    this._codeEditorService.removeCodeEditor(this), this._focusTracker.dispose(), this._actions.clear(), this._contentWidgets = {}, this._overlayWidgets = {}, this._removeDecorationTypes(), this._postDetachModelCleanup(this._detachModel()), this._onDidDispose.fire(), super.dispose();
  }
  invokeWithinContext(e) {
    return this._instantiationService.invokeFunction(e);
  }
  updateOptions(e) {
    this._configuration.updateOptions(e || {});
  }
  getOptions() {
    return this._configuration.options;
  }
  getOption(e) {
    return this._configuration.options.get(e);
  }
  getRawOptions() {
    return this._configuration.getRawOptions();
  }
  getOverflowWidgetsDomNode() {
    return this._overflowWidgetsDomNode;
  }
  getConfiguredWordAtPosition(e) {
    return this._modelData ? bi.getWordAtPosition(this._modelData.model, this._configuration.options.get(
      132
      /* EditorOption.wordSeparators */
    ), this._configuration.options.get(
      131
      /* EditorOption.wordSegmenterLocales */
    ), e) : null;
  }
  getValue(e = null) {
    if (!this._modelData)
      return "";
    const t = !!(e && e.preserveBOM);
    let n = 0;
    return e && e.lineEnding && e.lineEnding === `
` ? n = 1 : e && e.lineEnding && e.lineEnding === `\r
` && (n = 2), this._modelData.model.getValue(n, t);
  }
  setValue(e) {
    try {
      if (this._beginUpdate(), !this._modelData)
        return;
      this._modelData.model.setValue(e);
    } finally {
      this._endUpdate();
    }
  }
  getModel() {
    return this._modelData ? this._modelData.model : null;
  }
  setModel(e = null) {
    try {
      this._beginUpdate();
      const t = e;
      if (this._modelData === null && t === null || this._modelData && this._modelData.model === t)
        return;
      const n = {
        oldModelUrl: this._modelData?.model.uri || null,
        newModelUrl: t?.uri || null
      };
      this._onWillChangeModel.fire(n);
      const i = this.hasTextFocus(), s = this._detachModel();
      this._attachModel(t), i && this.hasModel() && this.focus(), this._removeDecorationTypes(), this._onDidChangeModel.fire(n), this._postDetachModelCleanup(s), this._contributionsDisposable = this._contributions.onAfterModelAttached();
    } finally {
      this._endUpdate();
    }
  }
  _removeDecorationTypes() {
    if (this._decorationTypeKeysToIds = {}, this._decorationTypeSubtypes) {
      for (const e in this._decorationTypeSubtypes) {
        const t = this._decorationTypeSubtypes[e];
        for (const n in t)
          this._removeDecorationType(e + "-" + n);
      }
      this._decorationTypeSubtypes = {};
    }
  }
  getVisibleRanges() {
    return this._modelData ? this._modelData.viewModel.getVisibleRanges() : [];
  }
  getVisibleRangesPlusViewportAboveBelow() {
    return this._modelData ? this._modelData.viewModel.getVisibleRangesPlusViewportAboveBelow() : [];
  }
  getWhitespaces() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getWhitespaces() : [];
  }
  static _getVerticalOffsetAfterPosition(e, t, n, i) {
    const s = e.model.validatePosition({
      lineNumber: t,
      column: n
    }), o = e.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return e.viewModel.viewLayout.getVerticalOffsetAfterLineNumber(o.lineNumber, i);
  }
  getTopForLineNumber(e, t = !1) {
    return this._modelData ? a0._getVerticalOffsetForPosition(this._modelData, e, 1, t) : -1;
  }
  getTopForPosition(e, t) {
    return this._modelData ? a0._getVerticalOffsetForPosition(this._modelData, e, t, !1) : -1;
  }
  static _getVerticalOffsetForPosition(e, t, n, i = !1) {
    const s = e.model.validatePosition({
      lineNumber: t,
      column: n
    }), o = e.viewModel.coordinatesConverter.convertModelPositionToViewPosition(s);
    return e.viewModel.viewLayout.getVerticalOffsetForLineNumber(o.lineNumber, i);
  }
  getBottomForLineNumber(e, t = !1) {
    return this._modelData ? a0._getVerticalOffsetAfterPosition(this._modelData, e, 1, t) : -1;
  }
  setHiddenAreas(e, t) {
    this._modelData?.viewModel.setHiddenAreas(e.map((n) => Q.lift(n)), t);
  }
  getVisibleColumnFromPosition(e) {
    if (!this._modelData)
      return e.column;
    const t = this._modelData.model.validatePosition(e), n = this._modelData.model.getOptions().tabSize;
    return zi.visibleColumnFromColumn(this._modelData.model.getLineContent(t.lineNumber), t.column, n) + 1;
  }
  getPosition() {
    return this._modelData ? this._modelData.viewModel.getPosition() : null;
  }
  setPosition(e, t = "api") {
    if (this._modelData) {
      if (!le.isIPosition(e))
        throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(t, [{
        selectionStartLineNumber: e.lineNumber,
        selectionStartColumn: e.column,
        positionLineNumber: e.lineNumber,
        positionColumn: e.column
      }]);
    }
  }
  _sendRevealRange(e, t, n, i) {
    if (!this._modelData)
      return;
    if (!Q.isIRange(e))
      throw new Error("Invalid arguments");
    const s = this._modelData.model.validateRange(e), o = this._modelData.viewModel.coordinatesConverter.convertModelRangeToViewRange(s);
    this._modelData.viewModel.revealRange("api", n, o, t, i);
  }
  revealLine(e, t = 0) {
    this._revealLine(e, 0, t);
  }
  revealLineInCenter(e, t = 0) {
    this._revealLine(e, 1, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._revealLine(e, 2, t);
  }
  revealLineNearTop(e, t = 0) {
    this._revealLine(e, 5, t);
  }
  _revealLine(e, t, n) {
    if (typeof e != "number")
      throw new Error("Invalid arguments");
    this._sendRevealRange(new Q(e, 1, e, 1), t, !1, n);
  }
  revealPosition(e, t = 0) {
    this._revealPosition(e, 0, !0, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._revealPosition(e, 1, !0, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._revealPosition(e, 2, !0, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._revealPosition(e, 5, !0, t);
  }
  _revealPosition(e, t, n, i) {
    if (!le.isIPosition(e))
      throw new Error("Invalid arguments");
    this._sendRevealRange(new Q(e.lineNumber, e.column, e.lineNumber, e.column), t, n, i);
  }
  getSelection() {
    return this._modelData ? this._modelData.viewModel.getSelection() : null;
  }
  getSelections() {
    return this._modelData ? this._modelData.viewModel.getSelections() : null;
  }
  setSelection(e, t = "api") {
    const n = _n.isISelection(e), i = Q.isIRange(e);
    if (!n && !i)
      throw new Error("Invalid arguments");
    if (n)
      this._setSelectionImpl(e, t);
    else if (i) {
      const s = {
        selectionStartLineNumber: e.startLineNumber,
        selectionStartColumn: e.startColumn,
        positionLineNumber: e.endLineNumber,
        positionColumn: e.endColumn
      };
      this._setSelectionImpl(s, t);
    }
  }
  _setSelectionImpl(e, t) {
    if (!this._modelData)
      return;
    const n = new _n(e.selectionStartLineNumber, e.selectionStartColumn, e.positionLineNumber, e.positionColumn);
    this._modelData.viewModel.setSelections(t, [n]);
  }
  revealLines(e, t, n = 0) {
    this._revealLines(e, t, 0, n);
  }
  revealLinesInCenter(e, t, n = 0) {
    this._revealLines(e, t, 1, n);
  }
  revealLinesInCenterIfOutsideViewport(e, t, n = 0) {
    this._revealLines(e, t, 2, n);
  }
  revealLinesNearTop(e, t, n = 0) {
    this._revealLines(e, t, 5, n);
  }
  _revealLines(e, t, n, i) {
    if (typeof e != "number" || typeof t != "number")
      throw new Error("Invalid arguments");
    this._sendRevealRange(new Q(e, 1, t, 1), n, !1, i);
  }
  revealRange(e, t = 0, n = !1, i = !0) {
    this._revealRange(e, n ? 1 : 0, i, t);
  }
  revealRangeInCenter(e, t = 0) {
    this._revealRange(e, 1, !0, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._revealRange(e, 2, !0, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._revealRange(e, 5, !0, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._revealRange(e, 6, !0, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._revealRange(e, 3, !0, t);
  }
  _revealRange(e, t, n, i) {
    if (!Q.isIRange(e))
      throw new Error("Invalid arguments");
    this._sendRevealRange(Q.lift(e), t, n, i);
  }
  setSelections(e, t = "api", n = 0) {
    if (this._modelData) {
      if (!e || e.length === 0)
        throw new Error("Invalid arguments");
      for (let i = 0, s = e.length; i < s; i++)
        if (!_n.isISelection(e[i]))
          throw new Error("Invalid arguments");
      this._modelData.viewModel.setSelections(t, e, n);
    }
  }
  getContentWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentWidth() : -1;
  }
  getScrollWidth() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollWidth() : -1;
  }
  getScrollLeft() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollLeft() : -1;
  }
  getContentHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getContentHeight() : -1;
  }
  getScrollHeight() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getScrollHeight() : -1;
  }
  getScrollTop() {
    return this._modelData ? this._modelData.viewModel.viewLayout.getCurrentScrollTop() : -1;
  }
  setScrollLeft(e, t = 1) {
    if (this._modelData) {
      if (typeof e != "number")
        throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({
        scrollLeft: e
      }, t);
    }
  }
  setScrollTop(e, t = 1) {
    if (this._modelData) {
      if (typeof e != "number")
        throw new Error("Invalid arguments");
      this._modelData.viewModel.viewLayout.setScrollPosition({
        scrollTop: e
      }, t);
    }
  }
  setScrollPosition(e, t = 1) {
    this._modelData && this._modelData.viewModel.viewLayout.setScrollPosition(e, t);
  }
  hasPendingScrollAnimation() {
    return this._modelData ? this._modelData.viewModel.viewLayout.hasPendingScrollAnimation() : !1;
  }
  saveViewState() {
    if (!this._modelData)
      return null;
    const e = this._contributions.saveViewState(), t = this._modelData.viewModel.saveCursorState(), n = this._modelData.viewModel.saveState();
    return {
      cursorState: t,
      viewState: n,
      contributionsState: e
    };
  }
  restoreViewState(e) {
    if (!this._modelData || !this._modelData.hasRealView)
      return;
    const t = e;
    if (t && t.cursorState && t.viewState) {
      const n = t.cursorState;
      Array.isArray(n) ? n.length > 0 && this._modelData.viewModel.restoreCursorState(n) : this._modelData.viewModel.restoreCursorState([n]), this._contributions.restoreViewState(t.contributionsState || {});
      const i = this._modelData.viewModel.reduceRestoreState(t.viewState);
      this._modelData.view.restoreState(i);
    }
  }
  handleInitialized() {
    this._getViewModel()?.visibleLinesStabilized();
  }
  getContribution(e) {
    return this._contributions.get(e);
  }
  getActions() {
    return Array.from(this._actions.values());
  }
  getSupportedActions() {
    let e = this.getActions();
    return e = e.filter((t) => t.isSupported()), e;
  }
  getAction(e) {
    return this._actions.get(e) || null;
  }
  trigger(e, t, n) {
    n = n || {};
    try {
      switch (this._beginUpdate(), t) {
        case "compositionStart":
          this._startComposition();
          return;
        case "compositionEnd":
          this._endComposition(e);
          return;
        case "type": {
          const s = n;
          this._type(e, s.text || "");
          return;
        }
        case "replacePreviousChar": {
          const s = n;
          this._compositionType(e, s.text || "", s.replaceCharCnt || 0, 0, 0);
          return;
        }
        case "compositionType": {
          const s = n;
          this._compositionType(e, s.text || "", s.replacePrevCharCnt || 0, s.replaceNextCharCnt || 0, s.positionDelta || 0);
          return;
        }
        case "paste": {
          const s = n;
          this._paste(e, s.text || "", s.pasteOnNewLine || !1, s.multicursorText || null, s.mode || null, s.clipboardEvent);
          return;
        }
        case "cut":
          this._cut(e);
          return;
      }
      const i = this.getAction(t);
      if (i) {
        Promise.resolve(i.run(n)).then(void 0, wn);
        return;
      }
      if (!this._modelData || this._triggerEditorCommand(e, t, n))
        return;
      this._triggerCommand(t, n);
    } finally {
      this._endUpdate();
    }
  }
  _triggerCommand(e, t) {
    this._commandService.executeCommand(e, t);
  }
  _startComposition() {
    this._modelData && (this._modelData.viewModel.startComposition(), this._onDidCompositionStart.fire());
  }
  _endComposition(e) {
    this._modelData && (this._modelData.viewModel.endComposition(e), this._onDidCompositionEnd.fire());
  }
  _type(e, t) {
    !this._modelData || t.length === 0 || (e === "keyboard" && this._onWillType.fire(t), this._modelData.viewModel.type(t, e), e === "keyboard" && this._onDidType.fire(t));
  }
  _compositionType(e, t, n, i, s) {
    this._modelData && this._modelData.viewModel.compositionType(t, n, i, s, e);
  }
  _paste(e, t, n, i, s, o) {
    if (!this._modelData)
      return;
    const a = this._modelData.viewModel, l = a.getSelection().getStartPosition();
    a.paste(t, n, i, e);
    const c = a.getSelection().getStartPosition();
    e === "keyboard" && this._onDidPaste.fire({
      clipboardEvent: o,
      range: new Q(l.lineNumber, l.column, c.lineNumber, c.column),
      languageId: s
    });
  }
  _cut(e) {
    this._modelData && this._modelData.viewModel.cut(e);
  }
  _triggerEditorCommand(e, t, n) {
    const i = wp.getEditorCommand(t);
    return i ? (n = n || {}, n.source = e, this._instantiationService.invokeFunction((s) => {
      Promise.resolve(i.runEditorCommand(s, this, n)).then(void 0, wn);
    }), !0) : !1;
  }
  _getViewModel() {
    return this._modelData ? this._modelData.viewModel : null;
  }
  pushUndoStop() {
    return !this._modelData || this._configuration.options.get(
      92
      /* EditorOption.readOnly */
    ) ? !1 : (this._modelData.model.pushStackElement(), !0);
  }
  popUndoStop() {
    return !this._modelData || this._configuration.options.get(
      92
      /* EditorOption.readOnly */
    ) ? !1 : (this._modelData.model.popStackElement(), !0);
  }
  executeEdits(e, t, n) {
    if (!this._modelData || this._configuration.options.get(
      92
      /* EditorOption.readOnly */
    ))
      return !1;
    let i;
    return n ? Array.isArray(n) ? i = () => n : i = n : i = () => null, this._modelData.viewModel.executeEdits(e, t, i), !0;
  }
  executeCommand(e, t) {
    this._modelData && this._modelData.viewModel.executeCommand(t, e);
  }
  executeCommands(e, t) {
    this._modelData && this._modelData.viewModel.executeCommands(t, e);
  }
  createDecorationsCollection(e) {
    return new J6t(this, e);
  }
  changeDecorations(e) {
    return this._modelData ? this._modelData.model.changeDecorations(e, this._id) : null;
  }
  getLineDecorations(e) {
    return this._modelData ? this._modelData.model.getLineDecorations(e, this._id, M8(this._configuration.options)) : null;
  }
  getDecorationsInRange(e) {
    return this._modelData ? this._modelData.model.getDecorationsInRange(e, this._id, M8(this._configuration.options)) : null;
  }
  /**
   * @deprecated
   */
  deltaDecorations(e, t) {
    return this._modelData ? e.length === 0 && t.length === 0 ? e : this._modelData.model.deltaDecorations(e, t, this._id) : [];
  }
  removeDecorations(e) {
    !this._modelData || e.length === 0 || this._modelData.model.changeDecorations((t) => {
      t.deltaDecorations(e, []);
    });
  }
  removeDecorationsByType(e) {
    const t = this._decorationTypeKeysToIds[e];
    t && this.changeDecorations((n) => n.deltaDecorations(t, [])), this._decorationTypeKeysToIds.hasOwnProperty(e) && delete this._decorationTypeKeysToIds[e], this._decorationTypeSubtypes.hasOwnProperty(e) && delete this._decorationTypeSubtypes[e];
  }
  getLayoutInfo() {
    return this._configuration.options.get(
      146
      /* EditorOption.layoutInfo */
    );
  }
  createOverviewRuler(e) {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.createOverviewRuler(e);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getDomNode() {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.domNode.domNode;
  }
  delegateVerticalScrollbarPointerDown(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.delegateVerticalScrollbarPointerDown(e);
  }
  delegateScrollFromMouseWheelEvent(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.delegateScrollFromMouseWheelEvent(e);
  }
  layout(e, t = !1) {
    this._configuration.observeContainer(e), t || this.render();
  }
  focus() {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.focus();
  }
  hasTextFocus() {
    return !this._modelData || !this._modelData.hasRealView ? !1 : this._modelData.view.isFocused();
  }
  hasWidgetFocus() {
    return this._focusTracker && this._focusTracker.hasFocus();
  }
  addContentWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._contentWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting a content widget with the same id:" + e.getId()), this._contentWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addContentWidget(t);
  }
  layoutContentWidget(e) {
    const t = e.getId();
    if (this._contentWidgets.hasOwnProperty(t)) {
      const n = this._contentWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutContentWidget(n);
    }
  }
  removeContentWidget(e) {
    const t = e.getId();
    if (this._contentWidgets.hasOwnProperty(t)) {
      const n = this._contentWidgets[t];
      delete this._contentWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeContentWidget(n);
    }
  }
  addOverlayWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._overlayWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting an overlay widget with the same id."), this._overlayWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addOverlayWidget(t);
  }
  layoutOverlayWidget(e) {
    const t = e.getId();
    if (this._overlayWidgets.hasOwnProperty(t)) {
      const n = this._overlayWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutOverlayWidget(n);
    }
  }
  removeOverlayWidget(e) {
    const t = e.getId();
    if (this._overlayWidgets.hasOwnProperty(t)) {
      const n = this._overlayWidgets[t];
      delete this._overlayWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeOverlayWidget(n);
    }
  }
  addGlyphMarginWidget(e) {
    const t = {
      widget: e,
      position: e.getPosition()
    };
    this._glyphMarginWidgets.hasOwnProperty(e.getId()) && console.warn("Overwriting a glyph margin widget with the same id."), this._glyphMarginWidgets[e.getId()] = t, this._modelData && this._modelData.hasRealView && this._modelData.view.addGlyphMarginWidget(t);
  }
  layoutGlyphMarginWidget(e) {
    const t = e.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(t)) {
      const n = this._glyphMarginWidgets[t];
      n.position = e.getPosition(), this._modelData && this._modelData.hasRealView && this._modelData.view.layoutGlyphMarginWidget(n);
    }
  }
  removeGlyphMarginWidget(e) {
    const t = e.getId();
    if (this._glyphMarginWidgets.hasOwnProperty(t)) {
      const n = this._glyphMarginWidgets[t];
      delete this._glyphMarginWidgets[t], this._modelData && this._modelData.hasRealView && this._modelData.view.removeGlyphMarginWidget(n);
    }
  }
  changeViewZones(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.change(e);
  }
  getTargetAtClientPoint(e, t) {
    return !this._modelData || !this._modelData.hasRealView ? null : this._modelData.view.getTargetAtClientPoint(e, t);
  }
  getScrolledVisiblePosition(e) {
    if (!this._modelData || !this._modelData.hasRealView)
      return null;
    const t = this._modelData.model.validatePosition(e), n = this._configuration.options, i = n.get(
      146
      /* EditorOption.layoutInfo */
    ), s = a0._getVerticalOffsetForPosition(this._modelData, t.lineNumber, t.column) - this.getScrollTop(), o = this._modelData.view.getOffsetForColumn(t.lineNumber, t.column) + i.glyphMarginWidth + i.lineNumbersWidth + i.decorationsWidth - this.getScrollLeft();
    return {
      top: s,
      left: o,
      height: n.get(
        67
        /* EditorOption.lineHeight */
      )
    };
  }
  getOffsetForColumn(e, t) {
    return !this._modelData || !this._modelData.hasRealView ? -1 : this._modelData.view.getOffsetForColumn(e, t);
  }
  render(e = !1) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.viewModel.batchEvents(() => {
      this._modelData.view.render(!0, e);
    });
  }
  setAriaOptions(e) {
    !this._modelData || !this._modelData.hasRealView || this._modelData.view.setAriaOptions(e);
  }
  applyFontInfo(e) {
    Br(e, this._configuration.options.get(
      50
      /* EditorOption.fontInfo */
    ));
  }
  setBanner(e, t) {
    this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._bannerDomNode.remove(), this._bannerDomNode = e, this._configuration.setReservedHeight(e ? t : 0), this._bannerDomNode && this._domElement.prepend(this._bannerDomNode);
  }
  _attachModel(e) {
    if (!e) {
      this._modelData = null;
      return;
    }
    const t = [];
    this._domElement.setAttribute("data-mode-id", e.getLanguageId()), this._configuration.setIsDominatedByLongLines(e.isDominatedByLongLines()), this._configuration.setModelLineCount(e.getLineCount());
    const n = e.onBeforeAttached(), i = new z6t(this._id, this._configuration, e, zO.create(qe(this._domElement)), $O.create(this._configuration.options), (a) => co(qe(this._domElement), a), this.languageConfigurationService, this._themeService, n, {
      batchChanges: (a) => {
        try {
          return this._beginUpdate(), a();
        } finally {
          this._endUpdate();
        }
      }
    });
    t.push(e.onWillDispose(() => this.setModel(null))), t.push(i.onEvent((a) => {
      switch (a.kind) {
        case 0:
          this._onDidContentSizeChange.fire(a);
          break;
        case 1:
          this._editorTextFocus.setValue(a.hasFocus);
          break;
        case 2:
          this._onDidScrollChange.fire(a);
          break;
        case 3:
          this._onDidChangeViewZones.fire();
          break;
        case 4:
          this._onDidChangeHiddenAreas.fire();
          break;
        case 5:
          this._onDidAttemptReadOnlyEdit.fire();
          break;
        case 6: {
          if (a.reachedMaxCursorCount) {
            const u = this.getOption(
              80
              /* EditorOption.multiCursorLimit */
            ), f = C("cursors.maximum", "The number of cursors has been limited to {0}. Consider using [find and replace](https://code.visualstudio.com/docs/editor/codebasics#_find-and-replace) for larger changes or increase the editor multi cursor limit setting.", u);
            this._notificationService.prompt(Zke.Warning, f, [
              {
                label: "Find and Replace",
                run: () => {
                  this._commandService.executeCommand("editor.action.startFindReplaceAction");
                }
              },
              {
                label: C("goToSetting", "Increase Multi Cursor Limit"),
                run: () => {
                  this._commandService.executeCommand("workbench.action.openSettings2", {
                    query: "editor.multiCursorLimit"
                  });
                }
              }
            ]);
          }
          const l = [];
          for (let u = 0, f = a.selections.length; u < f; u++)
            l[u] = a.selections[u].getPosition();
          const c = {
            position: l[0],
            secondaryPositions: l.slice(1),
            reason: a.reason,
            source: a.source
          };
          this._onDidChangeCursorPosition.fire(c);
          const d = {
            selection: a.selections[0],
            secondarySelections: a.selections.slice(1),
            modelVersionId: a.modelVersionId,
            oldSelections: a.oldSelections,
            oldModelVersionId: a.oldModelVersionId,
            source: a.source,
            reason: a.reason
          };
          this._onDidChangeCursorSelection.fire(d);
          break;
        }
        case 7:
          this._onDidChangeModelDecorations.fire(a.event);
          break;
        case 8:
          this._domElement.setAttribute("data-mode-id", e.getLanguageId()), this._onDidChangeModelLanguage.fire(a.event);
          break;
        case 9:
          this._onDidChangeModelLanguageConfiguration.fire(a.event);
          break;
        case 10:
          this._onDidChangeModelContent.fire(a.event);
          break;
        case 11:
          this._onDidChangeModelOptions.fire(a.event);
          break;
        case 12:
          this._onDidChangeModelTokens.fire(a.event);
          break;
      }
    }));
    const [s, o] = this._createView(i);
    if (o) {
      this._domElement.appendChild(s.domNode.domNode);
      let a = Object.keys(this._contentWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addContentWidget(this._contentWidgets[d]);
      }
      a = Object.keys(this._overlayWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addOverlayWidget(this._overlayWidgets[d]);
      }
      a = Object.keys(this._glyphMarginWidgets);
      for (let l = 0, c = a.length; l < c; l++) {
        const d = a[l];
        s.addGlyphMarginWidget(this._glyphMarginWidgets[d]);
      }
      s.render(!1, !0), s.domNode.domNode.setAttribute("data-uri", e.uri.toString());
    }
    this._modelData = new Q6t(e, i, s, o, t, n);
  }
  _createView(e) {
    let t;
    this.isSimpleWidget ? t = {
      paste: (s, o, a, l) => {
        this._paste("keyboard", s, o, a, l);
      },
      type: (s) => {
        this._type("keyboard", s);
      },
      compositionType: (s, o, a, l) => {
        this._compositionType("keyboard", s, o, a, l);
      },
      startComposition: () => {
        this._startComposition();
      },
      endComposition: () => {
        this._endComposition("keyboard");
      },
      cut: () => {
        this._cut("keyboard");
      }
    } : t = {
      paste: (s, o, a, l) => {
        const c = { text: s, pasteOnNewLine: o, multicursorText: a, mode: l };
        this._commandService.executeCommand("paste", c);
      },
      type: (s) => {
        const o = { text: s };
        this._commandService.executeCommand("type", o);
      },
      compositionType: (s, o, a, l) => {
        if (a || l) {
          const c = { text: s, replacePrevCharCnt: o, replaceNextCharCnt: a, positionDelta: l };
          this._commandService.executeCommand("compositionType", c);
        } else {
          const c = { text: s, replaceCharCnt: o };
          this._commandService.executeCommand("replacePreviousChar", c);
        }
      },
      startComposition: () => {
        this._commandService.executeCommand("compositionStart", {});
      },
      endComposition: () => {
        this._commandService.executeCommand("compositionEnd", {});
      },
      cut: () => {
        this._commandService.executeCommand("cut", {});
      }
    };
    const n = new Ay(e.coordinatesConverter);
    return n.onKeyDown = (s) => this._onKeyDown.fire(s), n.onKeyUp = (s) => this._onKeyUp.fire(s), n.onContextMenu = (s) => this._onContextMenu.fire(s), n.onMouseMove = (s) => this._onMouseMove.fire(s), n.onMouseLeave = (s) => this._onMouseLeave.fire(s), n.onMouseDown = (s) => this._onMouseDown.fire(s), n.onMouseUp = (s) => this._onMouseUp.fire(s), n.onMouseDrag = (s) => this._onMouseDrag.fire(s), n.onMouseDrop = (s) => this._onMouseDrop.fire(s), n.onMouseDropCanceled = (s) => this._onMouseDropCanceled.fire(s), n.onMouseWheel = (s) => this._onMouseWheel.fire(s), [new CL(t, this._configuration, this._themeService.getColorTheme(), e, n, this._overflowWidgetsDomNode, this._instantiationService), !0];
  }
  _postDetachModelCleanup(e) {
    e?.removeAllDecorationsWithOwnerId(this._id);
  }
  _detachModel() {
    if (this._contributionsDisposable?.dispose(), this._contributionsDisposable = void 0, !this._modelData)
      return null;
    const e = this._modelData.model, t = this._modelData.hasRealView ? this._modelData.view.domNode.domNode : null;
    return this._modelData.dispose(), this._modelData = null, this._domElement.removeAttribute("data-mode-id"), t && this._domElement.contains(t) && t.remove(), this._bannerDomNode && this._domElement.contains(this._bannerDomNode) && this._bannerDomNode.remove(), e;
  }
  _removeDecorationType(e) {
    this._codeEditorService.removeDecorationType(e);
  }
  hasModel() {
    return this._modelData !== null;
  }
  showDropIndicatorAt(e) {
    const t = [{
      range: new Q(e.lineNumber, e.column, e.lineNumber, e.column),
      options: a0.dropIntoEditorDecorationOptions
    }];
    this._dropIntoEditorDecorations.set(t), this.revealPosition(
      e,
      1
      /* editorCommon.ScrollType.Immediate */
    );
  }
  removeDropIndicator() {
    this._dropIntoEditorDecorations.clear();
  }
  setContextValue(e, t) {
    this._contextKeyService.createKey(e, t);
  }
  _beginUpdate() {
    this._updateCounter++, this._updateCounter === 1 && this._onBeginUpdate.fire();
  }
  _endUpdate() {
    this._updateCounter--, this._updateCounter === 0 && this._onEndUpdate.fire();
  }
};
C9 = a0 = q6t([
  Bh(3, xn),
  Bh(4, Ui),
  Bh(5, jo),
  Bh(6, sn),
  Bh(7, Sa),
  Bh(8, Zo),
  Bh(9, pc),
  Bh(10, xh),
  Bh(11, Vn)
], C9);
let G6t = 0, Q6t = class {
  constructor(e, t, n, i, s, o) {
    this.model = e, this.viewModel = t, this.view = n, this.hasRealView = i, this.listenersToRemove = s, this.attachedView = o;
  }
  dispose() {
    br(this.listenersToRemove), this.model.onBeforeDetached(this.attachedView), this.hasRealView && this.view.dispose(), this.viewModel.dispose();
  }
};
class A8e extends me {
  constructor(e) {
    super(), this._emitterOptions = e, this._onDidChangeToTrue = this._register(new $(this._emitterOptions)), this.onDidChangeToTrue = this._onDidChangeToTrue.event, this._onDidChangeToFalse = this._register(new $(this._emitterOptions)), this.onDidChangeToFalse = this._onDidChangeToFalse.event, this._value = 0;
  }
  setValue(e) {
    const t = e ? 2 : 1;
    this._value !== t && (this._value = t, this._value === 2 ? this._onDidChangeToTrue.fire() : this._value === 1 && this._onDidChangeToFalse.fire());
  }
}
class Yr extends $ {
  constructor(e, t) {
    super({ deliveryQueue: t }), this._contributions = e;
  }
  fire(e) {
    this._contributions.onBeforeInteractionEvent(), super.fire(e);
  }
}
class K6t extends me {
  constructor(e, t) {
    super(), this._editor = e, t.createKey("editorId", e.getId()), this._editorSimpleInput = Me.editorSimpleInput.bindTo(t), this._editorFocus = Me.focus.bindTo(t), this._textInputFocus = Me.textInputFocus.bindTo(t), this._editorTextFocus = Me.editorTextFocus.bindTo(t), this._tabMovesFocus = Me.tabMovesFocus.bindTo(t), this._editorReadonly = Me.readOnly.bindTo(t), this._inDiffEditor = Me.inDiffEditor.bindTo(t), this._editorColumnSelection = Me.columnSelection.bindTo(t), this._hasMultipleSelections = Me.hasMultipleSelections.bindTo(t), this._hasNonEmptySelection = Me.hasNonEmptySelection.bindTo(t), this._canUndo = Me.canUndo.bindTo(t), this._canRedo = Me.canRedo.bindTo(t), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromConfig())), this._register(this._editor.onDidChangeCursorSelection(() => this._updateFromSelection())), this._register(this._editor.onDidFocusEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorWidget(() => this._updateFromFocus())), this._register(this._editor.onDidFocusEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidBlurEditorText(() => this._updateFromFocus())), this._register(this._editor.onDidChangeModel(() => this._updateFromModel())), this._register(this._editor.onDidChangeConfiguration(() => this._updateFromModel())), this._register(t9.onDidChangeTabFocus((n) => this._tabMovesFocus.set(n))), this._updateFromConfig(), this._updateFromSelection(), this._updateFromFocus(), this._updateFromModel(), this._editorSimpleInput.set(this._editor.isSimpleWidget);
  }
  _updateFromConfig() {
    const e = this._editor.getOptions();
    this._tabMovesFocus.set(t9.getTabFocusMode()), this._editorReadonly.set(e.get(
      92
      /* EditorOption.readOnly */
    )), this._inDiffEditor.set(e.get(
      61
      /* EditorOption.inDiffEditor */
    )), this._editorColumnSelection.set(e.get(
      22
      /* EditorOption.columnSelection */
    ));
  }
  _updateFromSelection() {
    const e = this._editor.getSelections();
    e ? (this._hasMultipleSelections.set(e.length > 1), this._hasNonEmptySelection.set(e.some((t) => !t.isEmpty()))) : (this._hasMultipleSelections.reset(), this._hasNonEmptySelection.reset());
  }
  _updateFromFocus() {
    this._editorFocus.set(this._editor.hasWidgetFocus() && !this._editor.isSimpleWidget), this._editorTextFocus.set(this._editor.hasTextFocus() && !this._editor.isSimpleWidget), this._textInputFocus.set(this._editor.hasTextFocus());
  }
  _updateFromModel() {
    const e = this._editor.getModel();
    this._canUndo.set(!!(e && e.canUndo())), this._canRedo.set(!!(e && e.canRedo()));
  }
}
class Y6t extends me {
  constructor(e, t, n) {
    super(), this._editor = e, this._contextKeyService = t, this._languageFeaturesService = n, this._langId = Me.languageId.bindTo(t), this._hasCompletionItemProvider = Me.hasCompletionItemProvider.bindTo(t), this._hasCodeActionsProvider = Me.hasCodeActionsProvider.bindTo(t), this._hasCodeLensProvider = Me.hasCodeLensProvider.bindTo(t), this._hasDefinitionProvider = Me.hasDefinitionProvider.bindTo(t), this._hasDeclarationProvider = Me.hasDeclarationProvider.bindTo(t), this._hasImplementationProvider = Me.hasImplementationProvider.bindTo(t), this._hasTypeDefinitionProvider = Me.hasTypeDefinitionProvider.bindTo(t), this._hasHoverProvider = Me.hasHoverProvider.bindTo(t), this._hasDocumentHighlightProvider = Me.hasDocumentHighlightProvider.bindTo(t), this._hasDocumentSymbolProvider = Me.hasDocumentSymbolProvider.bindTo(t), this._hasReferenceProvider = Me.hasReferenceProvider.bindTo(t), this._hasRenameProvider = Me.hasRenameProvider.bindTo(t), this._hasSignatureHelpProvider = Me.hasSignatureHelpProvider.bindTo(t), this._hasInlayHintsProvider = Me.hasInlayHintsProvider.bindTo(t), this._hasDocumentFormattingProvider = Me.hasDocumentFormattingProvider.bindTo(t), this._hasDocumentSelectionFormattingProvider = Me.hasDocumentSelectionFormattingProvider.bindTo(t), this._hasMultipleDocumentFormattingProvider = Me.hasMultipleDocumentFormattingProvider.bindTo(t), this._hasMultipleDocumentSelectionFormattingProvider = Me.hasMultipleDocumentSelectionFormattingProvider.bindTo(t), this._isInEmbeddedEditor = Me.isInEmbeddedEditor.bindTo(t);
    const i = () => this._update();
    this._register(e.onDidChangeModel(i)), this._register(e.onDidChangeModelLanguage(i)), this._register(n.completionProvider.onDidChange(i)), this._register(n.codeActionProvider.onDidChange(i)), this._register(n.codeLensProvider.onDidChange(i)), this._register(n.definitionProvider.onDidChange(i)), this._register(n.declarationProvider.onDidChange(i)), this._register(n.implementationProvider.onDidChange(i)), this._register(n.typeDefinitionProvider.onDidChange(i)), this._register(n.hoverProvider.onDidChange(i)), this._register(n.documentHighlightProvider.onDidChange(i)), this._register(n.documentSymbolProvider.onDidChange(i)), this._register(n.referenceProvider.onDidChange(i)), this._register(n.renameProvider.onDidChange(i)), this._register(n.documentFormattingEditProvider.onDidChange(i)), this._register(n.documentRangeFormattingEditProvider.onDidChange(i)), this._register(n.signatureHelpProvider.onDidChange(i)), this._register(n.inlayHintsProvider.onDidChange(i)), i();
  }
  dispose() {
    super.dispose();
  }
  reset() {
    this._contextKeyService.bufferChangeEvents(() => {
      this._langId.reset(), this._hasCompletionItemProvider.reset(), this._hasCodeActionsProvider.reset(), this._hasCodeLensProvider.reset(), this._hasDefinitionProvider.reset(), this._hasDeclarationProvider.reset(), this._hasImplementationProvider.reset(), this._hasTypeDefinitionProvider.reset(), this._hasHoverProvider.reset(), this._hasDocumentHighlightProvider.reset(), this._hasDocumentSymbolProvider.reset(), this._hasReferenceProvider.reset(), this._hasRenameProvider.reset(), this._hasDocumentFormattingProvider.reset(), this._hasDocumentSelectionFormattingProvider.reset(), this._hasSignatureHelpProvider.reset(), this._isInEmbeddedEditor.reset();
    });
  }
  _update() {
    const e = this._editor.getModel();
    if (!e) {
      this.reset();
      return;
    }
    this._contextKeyService.bufferChangeEvents(() => {
      this._langId.set(e.getLanguageId()), this._hasCompletionItemProvider.set(this._languageFeaturesService.completionProvider.has(e)), this._hasCodeActionsProvider.set(this._languageFeaturesService.codeActionProvider.has(e)), this._hasCodeLensProvider.set(this._languageFeaturesService.codeLensProvider.has(e)), this._hasDefinitionProvider.set(this._languageFeaturesService.definitionProvider.has(e)), this._hasDeclarationProvider.set(this._languageFeaturesService.declarationProvider.has(e)), this._hasImplementationProvider.set(this._languageFeaturesService.implementationProvider.has(e)), this._hasTypeDefinitionProvider.set(this._languageFeaturesService.typeDefinitionProvider.has(e)), this._hasHoverProvider.set(this._languageFeaturesService.hoverProvider.has(e)), this._hasDocumentHighlightProvider.set(this._languageFeaturesService.documentHighlightProvider.has(e)), this._hasDocumentSymbolProvider.set(this._languageFeaturesService.documentSymbolProvider.has(e)), this._hasReferenceProvider.set(this._languageFeaturesService.referenceProvider.has(e)), this._hasRenameProvider.set(this._languageFeaturesService.renameProvider.has(e)), this._hasSignatureHelpProvider.set(this._languageFeaturesService.signatureHelpProvider.has(e)), this._hasInlayHintsProvider.set(this._languageFeaturesService.inlayHintsProvider.has(e)), this._hasDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.has(e) || this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.has(e)), this._hasMultipleDocumentFormattingProvider.set(this._languageFeaturesService.documentFormattingEditProvider.all(e).length + this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._hasMultipleDocumentSelectionFormattingProvider.set(this._languageFeaturesService.documentRangeFormattingEditProvider.all(e).length > 1), this._isInEmbeddedEditor.set(e.uri.scheme === Ct.walkThroughSnippet || e.uri.scheme === Ct.vscodeChatCodeBlock);
    });
  }
}
class X6t extends me {
  constructor(e, t) {
    super(), this._onChange = this._register(new $()), this.onChange = this._onChange.event, this._hadFocus = void 0, this._hasDomElementFocus = !1, this._domFocusTracker = this._register(Af(e)), this._overflowWidgetsDomNodeHasFocus = !1, this._register(this._domFocusTracker.onDidFocus(() => {
      this._hasDomElementFocus = !0, this._update();
    })), this._register(this._domFocusTracker.onDidBlur(() => {
      this._hasDomElementFocus = !1, this._update();
    })), t && (this._overflowWidgetsDomNode = this._register(Af(t)), this._register(this._overflowWidgetsDomNode.onDidFocus(() => {
      this._overflowWidgetsDomNodeHasFocus = !0, this._update();
    })), this._register(this._overflowWidgetsDomNode.onDidBlur(() => {
      this._overflowWidgetsDomNodeHasFocus = !1, this._update();
    })));
  }
  _update() {
    const e = this._hasDomElementFocus || this._overflowWidgetsDomNodeHasFocus;
    this._hadFocus !== e && (this._hadFocus = e, this._onChange.fire(void 0));
  }
  hasFocus() {
    return this._hadFocus ?? !1;
  }
}
class J6t {
  get length() {
    return this._decorationIds.length;
  }
  constructor(e, t) {
    this._editor = e, this._decorationIds = [], this._isChangingDecorations = !1, Array.isArray(t) && t.length > 0 && this.set(t);
  }
  onDidChange(e, t, n) {
    return this._editor.onDidChangeModelDecorations((i) => {
      this._isChangingDecorations || e.call(t, i);
    }, n);
  }
  getRange(e) {
    return !this._editor.hasModel() || e >= this._decorationIds.length ? null : this._editor.getModel().getDecorationRange(this._decorationIds[e]);
  }
  getRanges() {
    if (!this._editor.hasModel())
      return [];
    const e = this._editor.getModel(), t = [];
    for (const n of this._decorationIds) {
      const i = e.getDecorationRange(n);
      i && t.push(i);
    }
    return t;
  }
  has(e) {
    return this._decorationIds.includes(e.id);
  }
  clear() {
    this._decorationIds.length !== 0 && this.set([]);
  }
  set(e) {
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations((t) => {
        this._decorationIds = t.deltaDecorations(this._decorationIds, e);
      });
    } finally {
      this._isChangingDecorations = !1;
    }
    return this._decorationIds;
  }
  append(e) {
    let t = [];
    try {
      this._isChangingDecorations = !0, this._editor.changeDecorations((n) => {
        t = n.deltaDecorations([], e), this._decorationIds = this._decorationIds.concat(t);
      });
    } finally {
      this._isChangingDecorations = !1;
    }
    return t;
  }
}
const $6t = encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' enable-background='new 0 0 6 3' height='3' width='6'><g fill='"), e8t = encodeURIComponent("'><polygon points='5.5,0 2.5,3 1.1,3 4.1,0'/><polygon points='4,0 6,2 6,0.6 5.4,0'/><polygon points='0,2 1,3 2.4,3 0,0.6'/></g></svg>");
function c_(r) {
  return $6t + encodeURIComponent(r.toString()) + e8t;
}
const t8t = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="3" width="12"><g fill="'), n8t = encodeURIComponent('"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="9" cy="1" r="1"/></g></svg>');
function i8t(r) {
  return t8t + encodeURIComponent(r.toString()) + n8t;
}
Sh((r, e) => {
  const t = r.getColor(bO);
  t && e.addRule(`.monaco-editor .squiggly-error { background: url("data:image/svg+xml,${c_(t)}") repeat-x bottom left; }`);
  const n = r.getColor(d1);
  n && e.addRule(`.monaco-editor .squiggly-warning { background: url("data:image/svg+xml,${c_(n)}") repeat-x bottom left; }`);
  const i = r.getColor(yf);
  i && e.addRule(`.monaco-editor .squiggly-info { background: url("data:image/svg+xml,${c_(i)}") repeat-x bottom left; }`);
  const s = r.getColor(Omt);
  s && e.addRule(`.monaco-editor .squiggly-hint { background: url("data:image/svg+xml,${i8t(s)}") no-repeat bottom left; }`);
  const o = r.getColor(A4t);
  o && e.addRule(`.monaco-editor.showUnused .squiggly-inline-unnecessary { opacity: ${o.rgba.a}; }`);
});
var r8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, s8t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let BL = class extends me {
  constructor(e) {
    super(), this._themeService = e, this._onWillCreateCodeEditor = this._register(new $()), this._onCodeEditorAdd = this._register(new $()), this.onCodeEditorAdd = this._onCodeEditorAdd.event, this._onCodeEditorRemove = this._register(new $()), this.onCodeEditorRemove = this._onCodeEditorRemove.event, this._onWillCreateDiffEditor = this._register(new $()), this._onDiffEditorAdd = this._register(new $()), this.onDiffEditorAdd = this._onDiffEditorAdd.event, this._onDiffEditorRemove = this._register(new $()), this.onDiffEditorRemove = this._onDiffEditorRemove.event, this._decorationOptionProviders = /* @__PURE__ */ new Map(), this._codeEditorOpenHandlers = new no(), this._modelProperties = /* @__PURE__ */ new Map(), this._codeEditors = /* @__PURE__ */ Object.create(null), this._diffEditors = /* @__PURE__ */ Object.create(null), this._globalStyleSheet = null;
  }
  willCreateCodeEditor() {
    this._onWillCreateCodeEditor.fire();
  }
  addCodeEditor(e) {
    this._codeEditors[e.getId()] = e, this._onCodeEditorAdd.fire(e);
  }
  removeCodeEditor(e) {
    delete this._codeEditors[e.getId()] && this._onCodeEditorRemove.fire(e);
  }
  listCodeEditors() {
    return Object.keys(this._codeEditors).map((e) => this._codeEditors[e]);
  }
  willCreateDiffEditor() {
    this._onWillCreateDiffEditor.fire();
  }
  addDiffEditor(e) {
    this._diffEditors[e.getId()] = e, this._onDiffEditorAdd.fire(e);
  }
  listDiffEditors() {
    return Object.keys(this._diffEditors).map((e) => this._diffEditors[e]);
  }
  getFocusedCodeEditor() {
    let e = null;
    const t = this.listCodeEditors();
    for (const n of t) {
      if (n.hasTextFocus())
        return n;
      n.hasWidgetFocus() && (e = n);
    }
    return e;
  }
  removeDecorationType(e) {
    const t = this._decorationOptionProviders.get(e);
    t && (t.refCount--, t.refCount <= 0 && (this._decorationOptionProviders.delete(e), t.dispose(), this.listCodeEditors().forEach((n) => n.removeDecorationsByType(e))));
  }
  setModelProperty(e, t, n) {
    const i = e.toString();
    let s;
    this._modelProperties.has(i) ? s = this._modelProperties.get(i) : (s = /* @__PURE__ */ new Map(), this._modelProperties.set(i, s)), s.set(t, n);
  }
  getModelProperty(e, t) {
    const n = e.toString();
    if (this._modelProperties.has(n))
      return this._modelProperties.get(n).get(t);
  }
  async openCodeEditor(e, t, n) {
    for (const i of this._codeEditorOpenHandlers) {
      const s = await i(e, t, n);
      if (s !== null)
        return s;
    }
    return null;
  }
  registerCodeEditorOpenHandler(e) {
    const t = this._codeEditorOpenHandlers.unshift(e);
    return ht(t);
  }
};
BL = r8t([
  s8t(0, Sa)
], BL);
var o8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, w8e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let E9 = class extends BL {
  constructor(e, t) {
    super(t), this._register(this.onCodeEditorAdd(() => this._checkContextKey())), this._register(this.onCodeEditorRemove(() => this._checkContextKey())), this._editorIsOpen = e.createKey("editorIsOpen", !1), this._activeCodeEditor = null, this._register(this.registerCodeEditorOpenHandler(async (n, i, s) => i ? this.doOpenEditor(i, n) : null));
  }
  _checkContextKey() {
    let e = !1;
    for (const t of this.listCodeEditors())
      if (!t.isSimpleWidget) {
        e = !0;
        break;
      }
    this._editorIsOpen.set(e);
  }
  setActiveCodeEditor(e) {
    this._activeCodeEditor = e;
  }
  getActiveCodeEditor() {
    return this._activeCodeEditor;
  }
  doOpenEditor(e, t) {
    if (!this.findModel(e, t.resource)) {
      if (t.resource) {
        const s = t.resource.scheme;
        if (s === Ct.http || s === Ct.https)
          return ODe(t.resource.toString()), e;
      }
      return null;
    }
    const i = t.options ? t.options.selection : null;
    if (i)
      if (typeof i.endLineNumber == "number" && typeof i.endColumn == "number")
        e.setSelection(i), e.revealRangeInCenter(
          i,
          1
          /* ScrollType.Immediate */
        );
      else {
        const s = {
          lineNumber: i.startLineNumber,
          column: i.startColumn
        };
        e.setPosition(s), e.revealPositionInCenter(
          s,
          1
          /* ScrollType.Immediate */
        );
      }
    return e;
  }
  findModel(e, t) {
    const n = e.getModel();
    return n && n.uri.toString() !== t.toString() ? null : n;
  }
};
E9 = o8t([
  w8e(0, sn),
  w8e(1, Sa)
], E9);
en(
  Ui,
  E9,
  0
  /* InstantiationType.Eager */
);
const R1 = Wt("layoutService");
var Uke = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, qke = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let _9 = class {
  get mainContainer() {
    return vI(this._codeEditorService.listCodeEditors())?.getContainerDomNode() ?? Sn.document.body;
  }
  get activeContainer() {
    return (this._codeEditorService.getFocusedCodeEditor() ?? this._codeEditorService.getActiveCodeEditor())?.getContainerDomNode() ?? this.mainContainer;
  }
  get mainContainerDimension() {
    return BD(this.mainContainer);
  }
  get activeContainerDimension() {
    return BD(this.activeContainer);
  }
  get containers() {
    return xMe(this._codeEditorService.listCodeEditors().map((e) => e.getContainerDomNode()));
  }
  getContainer() {
    return this.activeContainer;
  }
  whenContainerStylesLoaded() {
  }
  focus() {
    this._codeEditorService.getFocusedCodeEditor()?.focus();
  }
  constructor(e) {
    this._codeEditorService = e, this.onDidLayoutMainContainer = xe.None, this.onDidLayoutActiveContainer = xe.None, this.onDidLayoutContainer = xe.None, this.onDidChangeActiveContainer = xe.None, this.onDidAddContainer = xe.None, this.mainContainerOffset = { top: 0, quickPickTop: 0 }, this.activeContainerOffset = { top: 0, quickPickTop: 0 };
  }
};
_9 = Uke([
  qke(0, Ui)
], _9);
let PL = class extends _9 {
  get mainContainer() {
    return this._container;
  }
  constructor(e, t) {
    super(t), this._container = e;
  }
};
PL = Uke([
  qke(1, Ui)
], PL);
en(
  R1,
  _9,
  1
  /* InstantiationType.Delayed */
);
const Gke = Wt("dialogService");
var a8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, v8e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
function Uv(r) {
  return r.scheme === Ct.file ? r.fsPath : r.path;
}
let Qke = 0;
class qv {
  constructor(e, t, n, i, s, o, a) {
    this.id = ++Qke, this.type = 0, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabel = t, this.strResource = n, this.resourceLabels = [this.resourceLabel], this.strResources = [this.strResource], this.groupId = i, this.groupOrder = s, this.sourceId = o, this.sourceOrder = a, this.isValid = !0;
  }
  setValid(e) {
    this.isValid = e;
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.isValid ? "  VALID" : "INVALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class b8e {
  constructor(e, t) {
    this.resourceLabel = e, this.reason = t;
  }
}
class y8e {
  constructor() {
    this.elements = /* @__PURE__ */ new Map();
  }
  createMessage() {
    const e = [], t = [];
    for (const [, i] of this.elements)
      (i.reason === 0 ? e : t).push(i.resourceLabel);
    const n = [];
    return e.length > 0 && n.push(C({ key: "externalRemoval", comment: ["{0} is a list of filenames"] }, "The following files have been closed and modified on disk: {0}.", e.join(", "))), t.length > 0 && n.push(C({ key: "noParallelUniverses", comment: ["{0} is a list of filenames"] }, "The following files have been modified in an incompatible way: {0}.", t.join(", "))), n.join(`
`);
  }
  get size() {
    return this.elements.size;
  }
  has(e) {
    return this.elements.has(e);
  }
  set(e, t) {
    this.elements.set(e, t);
  }
  delete(e) {
    return this.elements.delete(e);
  }
}
class l8t {
  constructor(e, t, n, i, s, o, a) {
    this.id = ++Qke, this.type = 1, this.actual = e, this.label = e.label, this.confirmBeforeUndo = e.confirmBeforeUndo || !1, this.resourceLabels = t, this.strResources = n, this.groupId = i, this.groupOrder = s, this.sourceId = o, this.sourceOrder = a, this.removedResources = null, this.invalidatedResources = null;
  }
  canSplit() {
    return typeof this.actual.split == "function";
  }
  removeResource(e, t, n) {
    this.removedResources || (this.removedResources = new y8e()), this.removedResources.has(t) || this.removedResources.set(t, new b8e(e, n));
  }
  setValid(e, t, n) {
    n ? this.invalidatedResources && (this.invalidatedResources.delete(t), this.invalidatedResources.size === 0 && (this.invalidatedResources = null)) : (this.invalidatedResources || (this.invalidatedResources = new y8e()), this.invalidatedResources.has(t) || this.invalidatedResources.set(t, new b8e(
      e,
      0
      /* RemovedResourceReason.ExternalRemoval */
    )));
  }
  toString() {
    return `[id:${this.id}] [group:${this.groupId}] [${this.invalidatedResources ? "INVALID" : "  VALID"}] ${this.actual.constructor.name} - ${this.actual}`;
  }
}
class Kke {
  constructor(e, t) {
    this.resourceLabel = e, this.strResource = t, this._past = [], this._future = [], this.locked = !1, this.versionId = 1;
  }
  dispose() {
    for (const e of this._past)
      e.type === 1 && e.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    for (const e of this._future)
      e.type === 1 && e.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    this.versionId++;
  }
  toString() {
    const e = [];
    e.push(`* ${this.strResource}:`);
    for (let t = 0; t < this._past.length; t++)
      e.push(`   * [UNDO] ${this._past[t]}`);
    for (let t = this._future.length - 1; t >= 0; t--)
      e.push(`   * [REDO] ${this._future[t]}`);
    return e.join(`
`);
  }
  flushAllElements() {
    this._past = [], this._future = [], this.versionId++;
  }
  _setElementValidFlag(e, t) {
    e.type === 1 ? e.setValid(this.resourceLabel, this.strResource, t) : e.setValid(t);
  }
  setElementsValidFlag(e, t) {
    for (const n of this._past)
      t(n.actual) && this._setElementValidFlag(n, e);
    for (const n of this._future)
      t(n.actual) && this._setElementValidFlag(n, e);
  }
  pushElement(e) {
    for (const t of this._future)
      t.type === 1 && t.removeResource(
        this.resourceLabel,
        this.strResource,
        1
        /* RemovedResourceReason.NoParallelUniverses */
      );
    this._future = [], this._past.push(e), this.versionId++;
  }
  createSnapshot(e) {
    const t = [];
    for (let n = 0, i = this._past.length; n < i; n++)
      t.push(this._past[n].id);
    for (let n = this._future.length - 1; n >= 0; n--)
      t.push(this._future[n].id);
    return new Pke(e, t);
  }
  restoreSnapshot(e) {
    const t = e.elements.length;
    let n = !0, i = 0, s = -1;
    for (let a = 0, l = this._past.length; a < l; a++, i++) {
      const c = this._past[a];
      n && (i >= t || c.id !== e.elements[i]) && (n = !1, s = 0), !n && c.type === 1 && c.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    }
    let o = -1;
    for (let a = this._future.length - 1; a >= 0; a--, i++) {
      const l = this._future[a];
      n && (i >= t || l.id !== e.elements[i]) && (n = !1, o = a), !n && l.type === 1 && l.removeResource(
        this.resourceLabel,
        this.strResource,
        0
        /* RemovedResourceReason.ExternalRemoval */
      );
    }
    s !== -1 && (this._past = this._past.slice(0, s)), o !== -1 && (this._future = this._future.slice(o + 1)), this.versionId++;
  }
  getElements() {
    const e = [], t = [];
    for (const n of this._past)
      e.push(n.actual);
    for (const n of this._future)
      t.push(n.actual);
    return { past: e, future: t };
  }
  getClosestPastElement() {
    return this._past.length === 0 ? null : this._past[this._past.length - 1];
  }
  getSecondClosestPastElement() {
    return this._past.length < 2 ? null : this._past[this._past.length - 2];
  }
  getClosestFutureElement() {
    return this._future.length === 0 ? null : this._future[this._future.length - 1];
  }
  hasPastElements() {
    return this._past.length > 0;
  }
  hasFutureElements() {
    return this._future.length > 0;
  }
  splitPastWorkspaceElement(e, t) {
    for (let n = this._past.length - 1; n >= 0; n--)
      if (this._past[n] === e) {
        t.has(this.strResource) ? this._past[n] = t.get(this.strResource) : this._past.splice(n, 1);
        break;
      }
    this.versionId++;
  }
  splitFutureWorkspaceElement(e, t) {
    for (let n = this._future.length - 1; n >= 0; n--)
      if (this._future[n] === e) {
        t.has(this.strResource) ? this._future[n] = t.get(this.strResource) : this._future.splice(n, 1);
        break;
      }
    this.versionId++;
  }
  moveBackward(e) {
    this._past.pop(), this._future.push(e), this.versionId++;
  }
  moveForward(e) {
    this._future.pop(), this._past.push(e), this.versionId++;
  }
}
class h_ {
  constructor(e) {
    this.editStacks = e, this._versionIds = [];
    for (let t = 0, n = this.editStacks.length; t < n; t++)
      this._versionIds[t] = this.editStacks[t].versionId;
  }
  isValid() {
    for (let e = 0, t = this.editStacks.length; e < t; e++)
      if (this._versionIds[e] !== this.editStacks[e].versionId)
        return !1;
    return !0;
  }
}
const Yke = new Kke("", "");
Yke.locked = !0;
let FL = class {
  constructor(e, t) {
    this._dialogService = e, this._notificationService = t, this._editStacks = /* @__PURE__ */ new Map(), this._uriComparisonKeyComputers = [];
  }
  getUriComparisonKey(e) {
    for (const t of this._uriComparisonKeyComputers)
      if (t[0] === e.scheme)
        return t[1].getComparisonKey(e);
    return e.toString();
  }
  _print(e) {
    console.log("------------------------------------"), console.log(`AFTER ${e}: `);
    const t = [];
    for (const n of this._editStacks)
      t.push(n[1].toString());
    console.log(t.join(`
`));
  }
  pushElement(e, t = v9.None, n = Mu.None) {
    if (e.type === 0) {
      const i = Uv(e.resource), s = this.getUriComparisonKey(e.resource);
      this._pushElement(new qv(e, i, s, t.id, t.nextOrder(), n.id, n.nextOrder()));
    } else {
      const i = /* @__PURE__ */ new Set(), s = [], o = [];
      for (const a of e.resources) {
        const l = Uv(a), c = this.getUriComparisonKey(a);
        i.has(c) || (i.add(c), s.push(l), o.push(c));
      }
      s.length === 1 ? this._pushElement(new qv(e, s[0], o[0], t.id, t.nextOrder(), n.id, n.nextOrder())) : this._pushElement(new l8t(e, s, o, t.id, t.nextOrder(), n.id, n.nextOrder()));
    }
  }
  _pushElement(e) {
    for (let t = 0, n = e.strResources.length; t < n; t++) {
      const i = e.resourceLabels[t], s = e.strResources[t];
      let o;
      this._editStacks.has(s) ? o = this._editStacks.get(s) : (o = new Kke(i, s), this._editStacks.set(s, o)), o.pushElement(e);
    }
  }
  getLastElement(e) {
    const t = this.getUriComparisonKey(e);
    if (this._editStacks.has(t)) {
      const n = this._editStacks.get(t);
      if (n.hasFutureElements())
        return null;
      const i = n.getClosestPastElement();
      return i ? i.actual : null;
    }
    return null;
  }
  _splitPastWorkspaceElement(e, t) {
    const n = e.actual.split(), i = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = Uv(s.resource), a = this.getUriComparisonKey(s.resource), l = new qv(s, o, a, 0, 0, 0, 0);
      i.set(l.strResource, l);
    }
    for (const s of e.strResources) {
      if (t && t.has(s))
        continue;
      this._editStacks.get(s).splitPastWorkspaceElement(e, i);
    }
  }
  _splitFutureWorkspaceElement(e, t) {
    const n = e.actual.split(), i = /* @__PURE__ */ new Map();
    for (const s of n) {
      const o = Uv(s.resource), a = this.getUriComparisonKey(s.resource), l = new qv(s, o, a, 0, 0, 0, 0);
      i.set(l.strResource, l);
    }
    for (const s of e.strResources) {
      if (t && t.has(s))
        continue;
      this._editStacks.get(s).splitFutureWorkspaceElement(e, i);
    }
  }
  removeElements(e) {
    const t = typeof e == "string" ? e : this.getUriComparisonKey(e);
    this._editStacks.has(t) && (this._editStacks.get(t).dispose(), this._editStacks.delete(t));
  }
  setElementsValidFlag(e, t, n) {
    const i = this.getUriComparisonKey(e);
    this._editStacks.has(i) && this._editStacks.get(i).setElementsValidFlag(t, n);
  }
  createSnapshot(e) {
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).createSnapshot(e) : new Pke(e, []);
  }
  restoreSnapshot(e) {
    const t = this.getUriComparisonKey(e.resource);
    if (this._editStacks.has(t)) {
      const n = this._editStacks.get(t);
      n.restoreSnapshot(e), !n.hasPastElements() && !n.hasFutureElements() && (n.dispose(), this._editStacks.delete(t));
    }
  }
  getElements(e) {
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).getElements() : { past: [], future: [] };
  }
  _findClosestUndoElementWithSource(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.sourceId === e && (!t || o.sourceOrder > t.sourceOrder) && (t = o, n = i);
    }
    return [t, n];
  }
  canUndo(e) {
    if (e instanceof Mu) {
      const [, n] = this._findClosestUndoElementWithSource(e.id);
      return !!n;
    }
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).hasPastElements() : !1;
  }
  _onError(e, t) {
    wn(e);
    for (const n of t.strResources)
      this.removeElements(n);
    this._notificationService.error(e);
  }
  _acquireLocks(e) {
    for (const t of e.editStacks)
      if (t.locked)
        throw new Error("Cannot acquire edit stack lock");
    for (const t of e.editStacks)
      t.locked = !0;
    return () => {
      for (const t of e.editStacks)
        t.locked = !1;
    };
  }
  _safeInvokeWithLocks(e, t, n, i, s) {
    const o = this._acquireLocks(n);
    let a;
    try {
      a = t();
    } catch (l) {
      return o(), i.dispose(), this._onError(l, e);
    }
    return a ? a.then(() => (o(), i.dispose(), s()), (l) => (o(), i.dispose(), this._onError(l, e))) : (o(), i.dispose(), s());
  }
  async _invokeWorkspacePrepare(e) {
    if (typeof e.actual.prepareUndoRedo > "u")
      return me.None;
    const t = e.actual.prepareUndoRedo();
    return typeof t > "u" ? me.None : t;
  }
  _invokeResourcePrepare(e, t) {
    if (e.actual.type !== 1 || typeof e.actual.prepareUndoRedo > "u")
      return t(me.None);
    const n = e.actual.prepareUndoRedo();
    return n ? zMe(n) ? t(n) : n.then((i) => t(i)) : t(me.None);
  }
  _getAffectedEditStacks(e) {
    const t = [];
    for (const n of e.strResources)
      t.push(this._editStacks.get(n) || Yke);
    return new h_(t);
  }
  _tryToSplitAndUndo(e, t, n, i) {
    if (t.canSplit())
      return this._splitPastWorkspaceElement(t, n), this._notificationService.warn(i), new Gv(this._undo(e, 0, !0));
    for (const s of t.strResources)
      this.removeElements(s);
    return this._notificationService.warn(i), new Gv();
  }
  _checkWorkspaceUndo(e, t, n, i) {
    if (t.removedResources)
      return this._tryToSplitAndUndo(e, t, t.removedResources, C({ key: "cannotWorkspaceUndo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not undo '{0}' across all files. {1}", t.label, t.removedResources.createMessage()));
    if (i && t.invalidatedResources)
      return this._tryToSplitAndUndo(e, t, t.invalidatedResources, C({ key: "cannotWorkspaceUndo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not undo '{0}' across all files. {1}", t.label, t.invalidatedResources.createMessage()));
    const s = [];
    for (const a of n.editStacks)
      a.getClosestPastElement() !== t && s.push(a.resourceLabel);
    if (s.length > 0)
      return this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToChanges", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because changes were made to {1}", t.label, s.join(", ")));
    const o = [];
    for (const a of n.editStacks)
      a.locked && o.push(a.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}", t.label, o.join(", "))) : n.isValid() ? null : this._tryToSplitAndUndo(e, t, null, C({ key: "cannotWorkspaceUndoDueToInMeantimeUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime", t.label));
  }
  _workspaceUndo(e, t, n) {
    const i = this._getAffectedEditStacks(t), s = this._checkWorkspaceUndo(
      e,
      t,
      i,
      /*invalidated resources will be checked after the prepare call*/
      !1
    );
    return s ? s.returnValue : this._confirmAndExecuteWorkspaceUndo(e, t, i, n);
  }
  _isPartOfUndoGroup(e) {
    if (!e.groupId)
      return !1;
    for (const [, t] of this._editStacks) {
      const n = t.getClosestPastElement();
      if (n) {
        if (n === e) {
          const i = t.getSecondClosestPastElement();
          if (i && i.groupId === e.groupId)
            return !0;
        }
        if (n.groupId === e.groupId)
          return !0;
      }
    }
    return !1;
  }
  async _confirmAndExecuteWorkspaceUndo(e, t, n, i) {
    if (t.canSplit() && !this._isPartOfUndoGroup(t)) {
      let a;
      (function(d) {
        d[d.All = 0] = "All", d[d.This = 1] = "This", d[d.Cancel = 2] = "Cancel";
      })(a || (a = {}));
      const { result: l } = await this._dialogService.prompt({
        type: Oi.Info,
        message: C("confirmWorkspace", "Would you like to undo '{0}' across all files?", t.label),
        buttons: [
          {
            label: C({ key: "ok", comment: ["{0} denotes a number that is > 1, && denotes a mnemonic"] }, "&&Undo in {0} Files", n.editStacks.length),
            run: () => a.All
          },
          {
            label: C({ key: "nok", comment: ["&& denotes a mnemonic"] }, "Undo this &&File"),
            run: () => a.This
          }
        ],
        cancelButton: {
          run: () => a.Cancel
        }
      });
      if (l === a.Cancel)
        return;
      if (l === a.This)
        return this._splitPastWorkspaceElement(t, null), this._undo(e, 0, !0);
      const c = this._checkWorkspaceUndo(
        e,
        t,
        n,
        /*invalidated resources will be checked after the prepare call*/
        !1
      );
      if (c)
        return c.returnValue;
      i = !0;
    }
    let s;
    try {
      s = await this._invokeWorkspacePrepare(t);
    } catch (a) {
      return this._onError(a, t);
    }
    const o = this._checkWorkspaceUndo(
      e,
      t,
      n,
      /*now also check that there are no more invalidated resources*/
      !0
    );
    if (o)
      return s.dispose(), o.returnValue;
    for (const a of n.editStacks)
      a.moveBackward(t);
    return this._safeInvokeWithLocks(t, () => t.actual.undo(), n, s, () => this._continueUndoInGroup(t.groupId, i));
  }
  _resourceUndo(e, t, n) {
    if (!t.isValid) {
      e.flushAllElements();
      return;
    }
    if (e.locked) {
      const i = C({ key: "cannotResourceUndoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation."] }, "Could not undo '{0}' because there is already an undo or redo operation running.", t.label);
      this._notificationService.warn(i);
      return;
    }
    return this._invokeResourcePrepare(t, (i) => (e.moveBackward(t), this._safeInvokeWithLocks(t, () => t.actual.undo(), new h_([e]), i, () => this._continueUndoInGroup(t.groupId, n))));
  }
  _findClosestUndoElementInGroup(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestPastElement();
      o && o.groupId === e && (!t || o.groupOrder > t.groupOrder) && (t = o, n = i);
    }
    return [t, n];
  }
  _continueUndoInGroup(e, t) {
    if (!e)
      return;
    const [, n] = this._findClosestUndoElementInGroup(e);
    if (n)
      return this._undo(n, 0, t);
  }
  undo(e) {
    if (e instanceof Mu) {
      const [, t] = this._findClosestUndoElementWithSource(e.id);
      return t ? this._undo(t, e.id, !1) : void 0;
    }
    return typeof e == "string" ? this._undo(e, 0, !1) : this._undo(this.getUriComparisonKey(e), 0, !1);
  }
  _undo(e, t = 0, n) {
    if (!this._editStacks.has(e))
      return;
    const i = this._editStacks.get(e), s = i.getClosestPastElement();
    if (!s)
      return;
    if (s.groupId) {
      const [a, l] = this._findClosestUndoElementInGroup(s.groupId);
      if (s !== a && l)
        return this._undo(l, t, n);
    }
    if ((s.sourceId !== t || s.confirmBeforeUndo) && !n)
      return this._confirmAndContinueUndo(e, t, s);
    try {
      return s.type === 1 ? this._workspaceUndo(e, s, n) : this._resourceUndo(i, s, n);
    } finally {
    }
  }
  async _confirmAndContinueUndo(e, t, n) {
    if ((await this._dialogService.confirm({
      message: C("confirmDifferentSource", "Would you like to undo '{0}'?", n.label),
      primaryButton: C({ key: "confirmDifferentSource.yes", comment: ["&& denotes a mnemonic"] }, "&&Yes"),
      cancelButton: C("confirmDifferentSource.no", "No")
    })).confirmed)
      return this._undo(e, t, !0);
  }
  _findClosestRedoElementWithSource(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.sourceId === e && (!t || o.sourceOrder < t.sourceOrder) && (t = o, n = i);
    }
    return [t, n];
  }
  canRedo(e) {
    if (e instanceof Mu) {
      const [, n] = this._findClosestRedoElementWithSource(e.id);
      return !!n;
    }
    const t = this.getUriComparisonKey(e);
    return this._editStacks.has(t) ? this._editStacks.get(t).hasFutureElements() : !1;
  }
  _tryToSplitAndRedo(e, t, n, i) {
    if (t.canSplit())
      return this._splitFutureWorkspaceElement(t, n), this._notificationService.warn(i), new Gv(this._redo(e));
    for (const s of t.strResources)
      this.removeElements(s);
    return this._notificationService.warn(i), new Gv();
  }
  _checkWorkspaceRedo(e, t, n, i) {
    if (t.removedResources)
      return this._tryToSplitAndRedo(e, t, t.removedResources, C({ key: "cannotWorkspaceRedo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not redo '{0}' across all files. {1}", t.label, t.removedResources.createMessage()));
    if (i && t.invalidatedResources)
      return this._tryToSplitAndRedo(e, t, t.invalidatedResources, C({ key: "cannotWorkspaceRedo", comment: ["{0} is a label for an operation. {1} is another message."] }, "Could not redo '{0}' across all files. {1}", t.label, t.invalidatedResources.createMessage()));
    const s = [];
    for (const a of n.editStacks)
      a.getClosestFutureElement() !== t && s.push(a.resourceLabel);
    if (s.length > 0)
      return this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToChanges", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because changes were made to {1}", t.label, s.join(", ")));
    const o = [];
    for (const a of n.editStacks)
      a.locked && o.push(a.resourceLabel);
    return o.length > 0 ? this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}", t.label, o.join(", "))) : n.isValid() ? null : this._tryToSplitAndRedo(e, t, null, C({ key: "cannotWorkspaceRedoDueToInMeantimeUndoRedo", comment: ["{0} is a label for an operation. {1} is a list of filenames."] }, "Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime", t.label));
  }
  _workspaceRedo(e, t) {
    const n = this._getAffectedEditStacks(t), i = this._checkWorkspaceRedo(
      e,
      t,
      n,
      /*invalidated resources will be checked after the prepare call*/
      !1
    );
    return i ? i.returnValue : this._executeWorkspaceRedo(e, t, n);
  }
  async _executeWorkspaceRedo(e, t, n) {
    let i;
    try {
      i = await this._invokeWorkspacePrepare(t);
    } catch (o) {
      return this._onError(o, t);
    }
    const s = this._checkWorkspaceRedo(
      e,
      t,
      n,
      /*now also check that there are no more invalidated resources*/
      !0
    );
    if (s)
      return i.dispose(), s.returnValue;
    for (const o of n.editStacks)
      o.moveForward(t);
    return this._safeInvokeWithLocks(t, () => t.actual.redo(), n, i, () => this._continueRedoInGroup(t.groupId));
  }
  _resourceRedo(e, t) {
    if (!t.isValid) {
      e.flushAllElements();
      return;
    }
    if (e.locked) {
      const n = C({ key: "cannotResourceRedoDueToInProgressUndoRedo", comment: ["{0} is a label for an operation."] }, "Could not redo '{0}' because there is already an undo or redo operation running.", t.label);
      this._notificationService.warn(n);
      return;
    }
    return this._invokeResourcePrepare(t, (n) => (e.moveForward(t), this._safeInvokeWithLocks(t, () => t.actual.redo(), new h_([e]), n, () => this._continueRedoInGroup(t.groupId))));
  }
  _findClosestRedoElementInGroup(e) {
    if (!e)
      return [null, null];
    let t = null, n = null;
    for (const [i, s] of this._editStacks) {
      const o = s.getClosestFutureElement();
      o && o.groupId === e && (!t || o.groupOrder < t.groupOrder) && (t = o, n = i);
    }
    return [t, n];
  }
  _continueRedoInGroup(e) {
    if (!e)
      return;
    const [, t] = this._findClosestRedoElementInGroup(e);
    if (t)
      return this._redo(t);
  }
  redo(e) {
    if (e instanceof Mu) {
      const [, t] = this._findClosestRedoElementWithSource(e.id);
      return t ? this._redo(t) : void 0;
    }
    return typeof e == "string" ? this._redo(e) : this._redo(this.getUriComparisonKey(e));
  }
  _redo(e) {
    if (!this._editStacks.has(e))
      return;
    const t = this._editStacks.get(e), n = t.getClosestFutureElement();
    if (n) {
      if (n.groupId) {
        const [i, s] = this._findClosestRedoElementInGroup(n.groupId);
        if (n !== i && s)
          return this._redo(s);
      }
      try {
        return n.type === 1 ? this._workspaceRedo(e, n) : this._resourceRedo(t, n);
      } finally {
      }
    }
  }
};
FL = a8t([
  v8e(0, Gke),
  v8e(1, Zo)
], FL);
class Gv {
  constructor(e) {
    this.returnValue = e;
  }
}
en(
  JO,
  FL,
  1
  /* InstantiationType.Delayed */
);
function Ns(r, e, t) {
  return Math.min(Math.max(r, e), t);
}
class Xke {
  constructor() {
    this._n = 1, this._val = 0;
  }
  update(e) {
    return this._val = this._val + (e - this._val) / this._n, this._n += 1, this._val;
  }
  get value() {
    return this._val;
  }
}
class c8t {
  constructor(e) {
    this._n = 0, this._val = 0, this._values = [], this._index = 0, this._sum = 0, this._values = new Array(e), this._values.fill(0, 0, e);
  }
  update(e) {
    const t = this._values[this._index];
    return this._values[this._index] = e, this._index = (this._index + 1) % this._values.length, this._sum -= t, this._sum += e, this._n < this._values.length && (this._n += 1), this._val = this._sum / this._n, this._val;
  }
  get value() {
    return this._val;
  }
}
const Jke = Wt("environmentService");
var h8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, C8e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const d8t = Wt("ILanguageFeatureDebounceService");
var x9;
(function(r) {
  const e = /* @__PURE__ */ new WeakMap();
  let t = 0;
  function n(i) {
    let s = e.get(i);
    return s === void 0 && (s = ++t, e.set(i, s)), s;
  }
  r.of = n;
})(x9 || (x9 = {}));
class u8t {
  constructor(e) {
    this._default = e;
  }
  get(e) {
    return this._default;
  }
  update(e, t) {
    return this._default;
  }
  default() {
    return this._default;
  }
}
class f8t {
  constructor(e, t, n, i, s, o) {
    this._logService = e, this._name = t, this._registry = n, this._default = i, this._min = s, this._max = o, this._cache = new _w(50, 0.7);
  }
  _key(e) {
    return e.id + this._registry.all(e).reduce((t, n) => H7(x9.of(n), t), 0);
  }
  get(e) {
    const t = this._key(e), n = this._cache.get(t);
    return n ? Ns(n.value, this._min, this._max) : this.default();
  }
  update(e, t) {
    const n = this._key(e);
    let i = this._cache.get(n);
    i || (i = new c8t(6), this._cache.set(n, i));
    const s = Ns(i.update(t), this._min, this._max);
    return jI(e.uri, "output") || this._logService.trace(`[DEBOUNCE: ${this._name}] for ${e.uri.toString()} is ${s}ms`), s;
  }
  _overall() {
    const e = new Xke();
    for (const [, t] of this._cache)
      e.update(t.value);
    return e.value;
  }
  default() {
    const e = this._overall() | 0 || this._default;
    return Ns(e, this._min, this._max);
  }
}
let zL = class {
  constructor(e, t) {
    this._logService = e, this._data = /* @__PURE__ */ new Map(), this._isDev = t.isExtensionDevelopment || !t.isBuilt;
  }
  for(e, t, n) {
    const i = n?.min ?? 50, s = n?.max ?? i ** 2, o = n?.key ?? void 0, a = `${x9.of(e)},${i}${o ? "," + o : ""}`;
    let l = this._data.get(a);
    return l || (this._isDev ? (this._logService.debug(`[DEBOUNCE: ${t}] is disabled in developed mode`), l = new u8t(i * 1.5)) : l = new f8t(
      this._logService,
      t,
      e,
      this._overallAverage() | 0 || i * 1.5,
      // default is overall default or derived from min-value
      i,
      s
    ), this._data.set(a, l)), l;
  }
  _overallAverage() {
    const e = new Xke();
    for (const t of this._data.values())
      e.update(t.default());
    return e.value;
  }
};
zL = h8t([
  C8e(0, _h),
  C8e(1, Jke)
], zL);
en(
  d8t,
  zL,
  1
  /* InstantiationType.Delayed */
);
var p8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, d_ = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let WL = class {
  constructor(e, t, n, i) {
    this._legend = e, this._themeService = t, this._languageService = n, this._logService = i, this._hasWarnedOverlappingTokens = !1, this._hasWarnedInvalidLengthTokens = !1, this._hasWarnedInvalidEditStart = !1, this._hashTable = new mu();
  }
  getMetadata(e, t, n) {
    const i = this._languageService.languageIdCodec.encodeLanguageId(n), s = this._hashTable.get(e, t, i);
    let o;
    if (s)
      o = s.metadata;
    else {
      let a = this._legend.tokenTypes[e];
      const l = [];
      if (a) {
        let c = t;
        for (let u = 0; c > 0 && u < this._legend.tokenModifiers.length; u++)
          c & 1 && l.push(this._legend.tokenModifiers[u]), c = c >> 1;
        const d = this._themeService.getColorTheme().getTokenStyleMetadata(a, l, n);
        if (typeof d > "u")
          o = 2147483647;
        else {
          if (o = 0, typeof d.italic < "u") {
            const u = (d.italic ? 1 : 0) << 11;
            o |= u | 1;
          }
          if (typeof d.bold < "u") {
            const u = (d.bold ? 2 : 0) << 11;
            o |= u | 2;
          }
          if (typeof d.underline < "u") {
            const u = (d.underline ? 4 : 0) << 11;
            o |= u | 4;
          }
          if (typeof d.strikethrough < "u") {
            const u = (d.strikethrough ? 8 : 0) << 11;
            o |= u | 8;
          }
          if (d.foreground) {
            const u = d.foreground << 15;
            o |= u | 16;
          }
          o === 0 && (o = 2147483647);
        }
      } else
        o = 2147483647, a = "not-in-legend";
      this._hashTable.add(e, t, i, o);
    }
    return o;
  }
  warnOverlappingSemanticTokens(e, t) {
    this._hasWarnedOverlappingTokens || (this._hasWarnedOverlappingTokens = !0, this._logService.warn(`Overlapping semantic tokens detected at lineNumber ${e}, column ${t}`));
  }
  warnInvalidLengthSemanticTokens(e, t) {
    this._hasWarnedInvalidLengthTokens || (this._hasWarnedInvalidLengthTokens = !0, this._logService.warn(`Semantic token with invalid length detected at lineNumber ${e}, column ${t}`));
  }
  warnInvalidEditStart(e, t, n, i, s) {
    this._hasWarnedInvalidEditStart || (this._hasWarnedInvalidEditStart = !0, this._logService.warn(`Invalid semantic tokens edit detected (previousResultId: ${e}, resultId: ${t}) at edit #${n}: The provided start offset ${i} is outside the previous data (length ${s}).`));
  }
};
WL = p8t([
  d_(1, Sa),
  d_(2, sr),
  d_(3, _h)
], WL);
class g8t {
  constructor(e, t, n, i) {
    this.tokenTypeIndex = e, this.tokenModifierSet = t, this.languageId = n, this.metadata = i, this.next = null;
  }
}
class mu {
  static {
    this._SIZES = [3, 7, 13, 31, 61, 127, 251, 509, 1021, 2039, 4093, 8191, 16381, 32749, 65521, 131071, 262139, 524287, 1048573, 2097143];
  }
  constructor() {
    this._elementsCount = 0, this._currentLengthIndex = 0, this._currentLength = mu._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < mu._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], mu._nullOutEntries(this._elements, this._currentLength);
  }
  static _nullOutEntries(e, t) {
    for (let n = 0; n < t; n++)
      e[n] = null;
  }
  _hash2(e, t) {
    return (e << 5) - e + t | 0;
  }
  _hashFunc(e, t, n) {
    return this._hash2(this._hash2(e, t), n) % this._currentLength;
  }
  get(e, t, n) {
    const i = this._hashFunc(e, t, n);
    let s = this._elements[i];
    for (; s; ) {
      if (s.tokenTypeIndex === e && s.tokenModifierSet === t && s.languageId === n)
        return s;
      s = s.next;
    }
    return null;
  }
  add(e, t, n, i) {
    if (this._elementsCount++, this._growCount !== 0 && this._elementsCount >= this._growCount) {
      const s = this._elements;
      this._currentLengthIndex++, this._currentLength = mu._SIZES[this._currentLengthIndex], this._growCount = Math.round(this._currentLengthIndex + 1 < mu._SIZES.length ? 2 / 3 * this._currentLength : 0), this._elements = [], mu._nullOutEntries(this._elements, this._currentLength);
      for (const o of s) {
        let a = o;
        for (; a; ) {
          const l = a.next;
          a.next = null, this._add(a), a = l;
        }
      }
    }
    this._add(new g8t(e, t, n, i));
  }
  _add(e) {
    const t = this._hashFunc(e.tokenTypeIndex, e.tokenModifierSet, e.languageId);
    e.next = this._elements[t], this._elements[t] = e;
  }
}
const m8t = Wt("semanticTokensStylingService");
var A8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, u_ = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let jL = class extends me {
  constructor(e, t, n) {
    super(), this._themeService = e, this._logService = t, this._languageService = n, this._caches = /* @__PURE__ */ new WeakMap(), this._register(this._themeService.onDidColorThemeChange(() => {
      this._caches = /* @__PURE__ */ new WeakMap();
    }));
  }
  getStyling(e) {
    return this._caches.has(e) || this._caches.set(e, new WL(e.getLegend(), this._themeService, this._languageService, this._logService)), this._caches.get(e);
  }
};
jL = A8t([
  u_(0, Sa),
  u_(1, _h),
  u_(2, sr)
], jL);
en(
  m8t,
  jL,
  1
  /* InstantiationType.Delayed */
);
const Qv = "**", E8e = "/", M6 = "[/\\\\]", D6 = "[^/\\\\]", w8t = /\//g;
function _8e(r, e) {
  switch (r) {
    case 0:
      return "";
    case 1:
      return `${D6}*?`;
    // 1 star matches any number of characters except path separator (/ and \) - non greedy (?)
    default:
      return `(?:${M6}|${D6}+${M6}${e ? `|${M6}${D6}+` : ""})*?`;
  }
}
function x8e(r, e) {
  if (!r)
    return [];
  const t = [];
  let n = !1, i = !1, s = "";
  for (const o of r) {
    switch (o) {
      case e:
        if (!n && !i) {
          t.push(s), s = "";
          continue;
        }
        break;
      case "{":
        n = !0;
        break;
      case "}":
        n = !1;
        break;
      case "[":
        i = !0;
        break;
      case "]":
        i = !1;
        break;
    }
    s += o;
  }
  return s && t.push(s), t;
}
function $ke(r) {
  if (!r)
    return "";
  let e = "";
  const t = x8e(r, E8e);
  if (t.every((n) => n === Qv))
    e = ".*";
  else {
    let n = !1;
    t.forEach((i, s) => {
      if (i === Qv) {
        if (n)
          return;
        e += _8e(2, s === t.length - 1);
      } else {
        let o = !1, a = "", l = !1, c = "";
        for (const d of i) {
          if (d !== "}" && o) {
            a += d;
            continue;
          }
          if (l && (d !== "]" || !c)) {
            let u;
            d === "-" ? u = d : (d === "^" || d === "!") && !c ? u = "^" : d === E8e ? u = "" : u = tc(d), c += u;
            continue;
          }
          switch (d) {
            case "{":
              o = !0;
              continue;
            case "[":
              l = !0;
              continue;
            case "}": {
              const f = `(?:${x8e(a, ",").map((p) => $ke(p)).join("|")})`;
              e += f, o = !1, a = "";
              break;
            }
            case "]": {
              e += "[" + c + "]", l = !1, c = "";
              break;
            }
            case "?":
              e += D6;
              continue;
            case "*":
              e += _8e(1);
              continue;
            default:
              e += tc(d);
          }
        }
        s < t.length - 1 && // more segments to come after this
        (t[s + 1] !== Qv || // next segment is not **, or...
        s + 2 < t.length) && (e += M6);
      }
      n = i === Qv;
    });
  }
  return e;
}
const v8t = /^\*\*\/\*\.[\w\.-]+$/, b8t = /^\*\*\/([\w\.-]+)\/?$/, y8t = /^{\*\*\/\*?[\w\.-]+\/?(,\*\*\/\*?[\w\.-]+\/?)*}$/, C8t = /^{\*\*\/\*?[\w\.-]+(\/(\*\*)?)?(,\*\*\/\*?[\w\.-]+(\/(\*\*)?)?)*}$/, E8t = /^\*\*((\/[\w\.-]+)+)\/?$/, _8t = /^([\w\.-]+(\/[\w\.-]+)*)\/?$/, S8e = new _w(1e4), M8e = function() {
  return !1;
}, rh = function() {
  return null;
};
function rR(r, e) {
  if (!r)
    return rh;
  let t;
  typeof r != "string" ? t = r.pattern : t = r, t = t.trim();
  const n = `${t}_${!!e.trimForExclusions}`;
  let i = S8e.get(n);
  if (i)
    return D8e(i, r);
  let s;
  return v8t.test(t) ? i = x8t(t.substr(4), t) : (s = b8t.exec(f_(t, e))) ? i = S8t(s[1], t) : (e.trimForExclusions ? C8t : y8t).test(t) ? i = M8t(t, e) : (s = E8t.exec(f_(t, e))) ? i = L8e(s[1].substr(1), t, !0) : (s = _8t.exec(f_(t, e))) ? i = L8e(s[1], t, !1) : i = D8t(t), S8e.set(n, i), D8e(i, r);
}
function D8e(r, e) {
  if (typeof e == "string")
    return r;
  const t = function(n, i) {
    return SL(n, e.base, !Cs) ? r(R7(n.substr(e.base.length), Yu), i) : null;
  };
  return t.allBasenames = r.allBasenames, t.allPaths = r.allPaths, t.basenames = r.basenames, t.patterns = r.patterns, t;
}
function f_(r, e) {
  return e.trimForExclusions && r.endsWith("/**") ? r.substr(0, r.length - 2) : r;
}
function x8t(r, e) {
  return function(t, n) {
    return typeof t == "string" && t.endsWith(r) ? e : null;
  };
}
function S8t(r, e) {
  const t = `/${r}`, n = `\\${r}`, i = function(o, a) {
    return typeof o != "string" ? null : a ? a === r ? e : null : o === r || o.endsWith(t) || o.endsWith(n) ? e : null;
  }, s = [r];
  return i.basenames = s, i.patterns = [e], i.allBasenames = s, i;
}
function M8t(r, e) {
  const t = tNe(r.slice(1, -1).split(",").map((a) => rR(a, e)).filter((a) => a !== rh), r), n = t.length;
  if (!n)
    return rh;
  if (n === 1)
    return t[0];
  const i = function(a, l) {
    for (let c = 0, d = t.length; c < d; c++)
      if (t[c](a, l))
        return r;
    return null;
  }, s = t.find((a) => !!a.allBasenames);
  s && (i.allBasenames = s.allBasenames);
  const o = t.reduce((a, l) => l.allPaths ? a.concat(l.allPaths) : a, []);
  return o.length && (i.allPaths = o), i;
}
function L8e(r, e, t) {
  const n = Yu === Si.sep, i = n ? r : r.replace(w8t, Yu), s = Yu + i, o = Si.sep + r;
  let a;
  return t ? a = function(l, c) {
    return typeof l == "string" && (l === i || l.endsWith(s) || !n && (l === r || l.endsWith(o))) ? e : null;
  } : a = function(l, c) {
    return typeof l == "string" && (l === i || !n && l === r) ? e : null;
  }, a.allPaths = [(t ? "*/" : "./") + r], a;
}
function D8t(r) {
  try {
    const e = new RegExp(`^${$ke(r)}$`);
    return function(t) {
      return e.lastIndex = 0, typeof t == "string" && e.test(t) ? r : null;
    };
  } catch {
    return rh;
  }
}
function L8t(r, e, t) {
  return !r || typeof e != "string" ? !1 : eNe(r)(e, void 0, t);
}
function eNe(r, e = {}) {
  if (!r)
    return M8e;
  if (typeof r == "string" || k8t(r)) {
    const t = rR(r, e);
    if (t === rh)
      return M8e;
    const n = function(i, s) {
      return !!t(i, s);
    };
    return t.allBasenames && (n.allBasenames = t.allBasenames), t.allPaths && (n.allPaths = t.allPaths), n;
  }
  return N8t(r, e);
}
function k8t(r) {
  const e = r;
  return e ? typeof e.base == "string" && typeof e.pattern == "string" : !1;
}
function N8t(r, e) {
  const t = tNe(Object.getOwnPropertyNames(r).map((a) => T8t(a, r[a], e)).filter((a) => a !== rh)), n = t.length;
  if (!n)
    return rh;
  if (!t.some((a) => !!a.requiresSiblings)) {
    if (n === 1)
      return t[0];
    const a = function(d, u) {
      let f;
      for (let p = 0, g = t.length; p < g; p++) {
        const m = t[p](d, u);
        if (typeof m == "string")
          return m;
        ID(m) && (f || (f = []), f.push(m));
      }
      return f ? (async () => {
        for (const p of f) {
          const g = await p;
          if (typeof g == "string")
            return g;
        }
        return null;
      })() : null;
    }, l = t.find((d) => !!d.allBasenames);
    l && (a.allBasenames = l.allBasenames);
    const c = t.reduce((d, u) => u.allPaths ? d.concat(u.allPaths) : d, []);
    return c.length && (a.allPaths = c), a;
  }
  const i = function(a, l, c) {
    let d, u;
    for (let f = 0, p = t.length; f < p; f++) {
      const g = t[f];
      g.requiresSiblings && c && (l || (l = KMe(a)), d || (d = l.substr(0, l.length - n0t(a).length)));
      const m = g(a, l, d, c);
      if (typeof m == "string")
        return m;
      ID(m) && (u || (u = []), u.push(m));
    }
    return u ? (async () => {
      for (const f of u) {
        const p = await f;
        if (typeof p == "string")
          return p;
      }
      return null;
    })() : null;
  }, s = t.find((a) => !!a.allBasenames);
  s && (i.allBasenames = s.allBasenames);
  const o = t.reduce((a, l) => l.allPaths ? a.concat(l.allPaths) : a, []);
  return o.length && (i.allPaths = o), i;
}
function T8t(r, e, t) {
  if (e === !1)
    return rh;
  const n = rR(r, t);
  if (n === rh)
    return rh;
  if (typeof e == "boolean")
    return n;
  if (e) {
    const i = e.when;
    if (typeof i == "string") {
      const s = (o, a, l, c) => {
        if (!c || !n(o, a))
          return null;
        const d = i.replace("$(basename)", () => l), u = c(d);
        return ID(u) ? u.then((f) => f ? r : null) : u ? r : null;
      };
      return s.requiresSiblings = !0, s;
    }
  }
  return n;
}
function tNe(r, e) {
  const t = r.filter((a) => !!a.basenames);
  if (t.length < 2)
    return r;
  const n = t.reduce((a, l) => {
    const c = l.basenames;
    return c ? a.concat(c) : a;
  }, []);
  let i;
  if (e) {
    i = [];
    for (let a = 0, l = n.length; a < l; a++)
      i.push(e);
  } else
    i = t.reduce((a, l) => {
      const c = l.patterns;
      return c ? a.concat(c) : a;
    }, []);
  const s = function(a, l) {
    if (typeof a != "string")
      return null;
    if (!l) {
      let d;
      for (d = a.length; d > 0; d--) {
        const u = a.charCodeAt(d - 1);
        if (u === 47 || u === 92)
          break;
      }
      l = a.substr(d);
    }
    const c = n.indexOf(l);
    return c !== -1 ? i[c] : null;
  };
  s.basenames = n, s.patterns = i, s.allBasenames = n;
  const o = r.filter((a) => !a.basenames);
  return o.push(s), o;
}
function nNe(r, e, t, n, i, s) {
  if (Array.isArray(r)) {
    let o = 0;
    for (const a of r) {
      const l = nNe(a, e, t, n, i, s);
      if (l === 10)
        return l;
      l > o && (o = l);
    }
    return o;
  } else {
    if (typeof r == "string")
      return n ? r === "*" ? 5 : r === t ? 10 : 0 : 0;
    if (r) {
      const { language: o, pattern: a, scheme: l, hasAccessToAllModels: c, notebookType: d } = r;
      if (!n && !c)
        return 0;
      d && i && (e = i);
      let u = 0;
      if (l)
        if (l === e.scheme)
          u = 10;
        else if (l === "*")
          u = 5;
        else
          return 0;
      if (o)
        if (o === t)
          u = 10;
        else if (o === "*")
          u = Math.max(u, 5);
        else
          return 0;
      if (d)
        if (d === s)
          u = 10;
        else if (d === "*" && s !== void 0)
          u = Math.max(u, 5);
        else
          return 0;
      if (a) {
        let f;
        if (typeof a == "string" ? f = a : f = { ...a, base: QMe(a.base) }, f === e.fsPath || L8t(f, e.fsPath))
          u = 10;
        else
          return 0;
      }
      return u;
    } else
      return 0;
  }
}
function iNe(r) {
  return typeof r == "string" ? !1 : Array.isArray(r) ? r.every(iNe) : !!r.exclusive;
}
class k8e {
  constructor(e, t, n, i, s) {
    this.uri = e, this.languageId = t, this.notebookUri = n, this.notebookType = i, this.recursive = s;
  }
  equals(e) {
    return this.notebookType === e.notebookType && this.languageId === e.languageId && this.uri.toString() === e.uri.toString() && this.notebookUri?.toString() === e.notebookUri?.toString() && this.recursive === e.recursive;
  }
}
class Un {
  constructor(e) {
    this._notebookInfoResolver = e, this._clock = 0, this._entries = [], this._onDidChange = new $(), this.onDidChange = this._onDidChange.event;
  }
  register(e, t) {
    let n = {
      selector: e,
      provider: t,
      _score: -1,
      _time: this._clock++
    };
    return this._entries.push(n), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), ht(() => {
      if (n) {
        const i = this._entries.indexOf(n);
        i >= 0 && (this._entries.splice(i, 1), this._lastCandidate = void 0, this._onDidChange.fire(this._entries.length), n = void 0);
      }
    });
  }
  has(e) {
    return this.all(e).length > 0;
  }
  all(e) {
    if (!e)
      return [];
    this._updateScores(e, !1);
    const t = [];
    for (const n of this._entries)
      n._score > 0 && t.push(n.provider);
    return t;
  }
  ordered(e, t = !1) {
    const n = [];
    return this._orderedForEach(e, t, (i) => n.push(i.provider)), n;
  }
  orderedGroups(e) {
    const t = [];
    let n, i;
    return this._orderedForEach(e, !1, (s) => {
      n && i === s._score ? n.push(s.provider) : (i = s._score, n = [s.provider], t.push(n));
    }), t;
  }
  _orderedForEach(e, t, n) {
    this._updateScores(e, t);
    for (const i of this._entries)
      i._score > 0 && n(i);
  }
  _updateScores(e, t) {
    const n = this._notebookInfoResolver?.(e.uri), i = n ? new k8e(e.uri, e.getLanguageId(), n.uri, n.type, t) : new k8e(e.uri, e.getLanguageId(), void 0, void 0, t);
    if (!this._lastCandidate?.equals(i)) {
      this._lastCandidate = i;
      for (const s of this._entries)
        if (s._score = nNe(s.selector, i.uri, i.languageId, Hpt(e), i.notebookUri, i.notebookType), iNe(s.selector) && s._score > 0)
          if (t)
            s._score = 0;
          else {
            for (const o of this._entries)
              o._score = 0;
            s._score = 1e3;
            break;
          }
      this._entries.sort(Un._compareByScoreAndTime);
    }
  }
  static _compareByScoreAndTime(e, t) {
    return e._score < t._score ? 1 : e._score > t._score ? -1 : vA(e.selector) && !vA(t.selector) ? 1 : !vA(e.selector) && vA(t.selector) ? -1 : e._time < t._time ? 1 : e._time > t._time ? -1 : 0;
  }
}
function vA(r) {
  return typeof r == "string" ? !1 : Array.isArray(r) ? r.some(vA) : !!r.isBuiltin;
}
class I8t {
  constructor() {
    this.referenceProvider = new Un(this._score.bind(this)), this.renameProvider = new Un(this._score.bind(this)), this.newSymbolNamesProvider = new Un(this._score.bind(this)), this.codeActionProvider = new Un(this._score.bind(this)), this.definitionProvider = new Un(this._score.bind(this)), this.typeDefinitionProvider = new Un(this._score.bind(this)), this.declarationProvider = new Un(this._score.bind(this)), this.implementationProvider = new Un(this._score.bind(this)), this.documentSymbolProvider = new Un(this._score.bind(this)), this.inlayHintsProvider = new Un(this._score.bind(this)), this.colorProvider = new Un(this._score.bind(this)), this.codeLensProvider = new Un(this._score.bind(this)), this.documentFormattingEditProvider = new Un(this._score.bind(this)), this.documentRangeFormattingEditProvider = new Un(this._score.bind(this)), this.onTypeFormattingEditProvider = new Un(this._score.bind(this)), this.signatureHelpProvider = new Un(this._score.bind(this)), this.hoverProvider = new Un(this._score.bind(this)), this.documentHighlightProvider = new Un(this._score.bind(this)), this.multiDocumentHighlightProvider = new Un(this._score.bind(this)), this.selectionRangeProvider = new Un(this._score.bind(this)), this.foldingRangeProvider = new Un(this._score.bind(this)), this.linkProvider = new Un(this._score.bind(this)), this.inlineCompletionsProvider = new Un(this._score.bind(this)), this.inlineEditProvider = new Un(this._score.bind(this)), this.completionProvider = new Un(this._score.bind(this)), this.linkedEditingRangeProvider = new Un(this._score.bind(this)), this.documentRangeSemanticTokensProvider = new Un(this._score.bind(this)), this.documentSemanticTokensProvider = new Un(this._score.bind(this)), this.documentDropEditProvider = new Un(this._score.bind(this)), this.documentPasteEditProvider = new Un(this._score.bind(this));
  }
  _score(e) {
    return this._notebookTypeResolver?.(e);
  }
}
en(
  Vn,
  I8t,
  1
  /* InstantiationType.Delayed */
);
var O8t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, N8e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const i2 = Wt("hoverService");
let s4 = class extends me {
  get delay() {
    return this.isInstantlyHovering() ? 0 : this._delay;
  }
  constructor(e, t, n = {}, i, s) {
    super(), this.placement = e, this.instantHover = t, this.overrideOptions = n, this.configurationService = i, this.hoverService = s, this.lastHoverHideTime = 0, this.timeLimit = 200, this.hoverDisposables = this._register(new ze()), this._delay = this.configurationService.getValue("workbench.hover.delay"), this._register(this.configurationService.onDidChangeConfiguration((o) => {
      o.affectsConfiguration("workbench.hover.delay") && (this._delay = this.configurationService.getValue("workbench.hover.delay"));
    }));
  }
  showHover(e, t) {
    const n = typeof this.overrideOptions == "function" ? this.overrideOptions(e, t) : this.overrideOptions;
    this.hoverDisposables.clear();
    const i = wr(e.target) ? [e.target] : e.target.targetElements;
    for (const o of i)
      this.hoverDisposables.add(ir(o, "keydown", (a) => {
        a.equals(
          9
          /* KeyCode.Escape */
        ) && this.hoverService.hideHover();
      }));
    const s = wr(e.content) ? void 0 : e.content.toString();
    return this.hoverService.showHover({
      ...e,
      ...n,
      persistence: {
        hideOnKeyDown: !0,
        ...n.persistence
      },
      id: s,
      appearance: {
        ...e.appearance,
        compact: !0,
        skipFadeInAnimation: this.isInstantlyHovering(),
        ...n.appearance
      }
    }, t);
  }
  isInstantlyHovering() {
    return this.instantHover && Date.now() - this.lastHoverHideTime < this.timeLimit;
  }
  onDidHideHover() {
    this.hoverDisposables.clear(), this.instantHover && (this.lastHoverHideTime = Date.now());
  }
};
s4 = O8t([
  N8e(3, Ai),
  N8e(4, i2)
], s4);
const rm = Wt("contextViewService"), Qd = Wt("contextMenuService"), Kv = $e;
let R8t = class extends me {
  constructor() {
    super(), this.containerDomNode = document.createElement("div"), this.containerDomNode.className = "monaco-hover", this.containerDomNode.tabIndex = 0, this.containerDomNode.setAttribute("role", "tooltip"), this.contentsDomNode = document.createElement("div"), this.contentsDomNode.className = "monaco-hover-content", this.scrollbar = this._register(new MO(this.contentsDomNode, {
      consumeMouseWheelIfScrollbarIsNeeded: !0
    })), this.containerDomNode.appendChild(this.scrollbar.getDomNode());
  }
  onContentsChanged() {
    this.scrollbar.scanDomNode();
  }
};
class sR extends me {
  static render(e, t, n) {
    return new sR(e, t, n);
  }
  constructor(e, t, n) {
    super(), this.actionLabel = t.label, this.actionKeybindingLabel = n, this.actionContainer = Fe(e, Kv("div.action-container")), this.actionContainer.setAttribute("tabindex", "0"), this.action = Fe(this.actionContainer, Kv("a.action")), this.action.setAttribute("role", "button"), t.iconClass && Fe(this.action, Kv(`span.icon.${t.iconClass}`));
    const i = Fe(this.action, Kv("span"));
    i.textContent = n ? `${t.label} (${n})` : t.label, this._store.add(new H8t(this.actionContainer, t.run)), this._store.add(new B8t(this.actionContainer, t.run, [
      3,
      10
      /* KeyCode.Space */
    ])), this.setEnabled(!0);
  }
  setEnabled(e) {
    e ? (this.actionContainer.classList.remove("disabled"), this.actionContainer.removeAttribute("aria-disabled")) : (this.actionContainer.classList.add("disabled"), this.actionContainer.setAttribute("aria-disabled", "true"));
  }
}
function V8t(r, e) {
  return r && e ? C("acessibleViewHint", "Inspect this in the accessible view with {0}.", e) : r ? C("acessibleViewHintNoKbOpen", "Inspect this in the accessible view via the command Open Accessible View which is currently not triggerable via keybinding.") : "";
}
class H8t extends me {
  constructor(e, t) {
    super(), this._register(fe(e, Se.CLICK, (n) => {
      n.stopPropagation(), n.preventDefault(), t(e);
    }));
  }
}
class B8t extends me {
  constructor(e, t, n) {
    super(), this._register(fe(e, Se.KEY_DOWN, (i) => {
      const s = new zn(i);
      n.some((o) => s.equals(o)) && (i.stopPropagation(), i.preventDefault(), t(e));
    }));
  }
}
const Tw = Wt("openerService");
function P8t(r) {
  let e;
  const t = /^L?(\d+)(?:,(\d+))?(-L?(\d+)(?:,(\d+))?)?/.exec(r.fragment);
  return t && (e = {
    startLineNumber: parseInt(t[1]),
    startColumn: t[2] ? parseInt(t[2]) : 1,
    endLineNumber: t[4] ? parseInt(t[4]) : void 0,
    endColumn: t[4] ? t[5] ? parseInt(t[5]) : 1 : void 0
  }, r = r.with({ fragment: "" })), { selection: e, uri: r };
}
function F8t(r, e = {}) {
  const t = oR(e);
  return t.textContent = r, t;
}
function z8t(r, e = {}) {
  const t = oR(e);
  return rNe(t, j8t(r, !!e.renderCodeSegments), e.actionHandler, e.renderCodeSegments), t;
}
function oR(r) {
  const e = r.inline ? "span" : "div", t = document.createElement(e);
  return r.className && (t.className = r.className), t;
}
class W8t {
  constructor(e) {
    this.source = e, this.index = 0;
  }
  eos() {
    return this.index >= this.source.length;
  }
  next() {
    const e = this.peek();
    return this.advance(), e;
  }
  peek() {
    return this.source[this.index];
  }
  advance() {
    this.index++;
  }
}
function rNe(r, e, t, n) {
  let i;
  if (e.type === 2)
    i = document.createTextNode(e.content || "");
  else if (e.type === 3)
    i = document.createElement("b");
  else if (e.type === 4)
    i = document.createElement("i");
  else if (e.type === 7 && n)
    i = document.createElement("code");
  else if (e.type === 5 && t) {
    const s = document.createElement("a");
    t.disposables.add(ir(s, "click", (o) => {
      t.callback(String(e.index), o);
    })), i = s;
  } else e.type === 8 ? i = document.createElement("br") : e.type === 1 && (i = r);
  i && r !== i && r.appendChild(i), i && Array.isArray(e.children) && e.children.forEach((s) => {
    rNe(i, s, t, n);
  });
}
function j8t(r, e) {
  const t = {
    type: 1,
    children: []
  };
  let n = 0, i = t;
  const s = [], o = new W8t(r);
  for (; !o.eos(); ) {
    let a = o.next();
    const l = a === "\\" && ZL(o.peek(), e) !== 0;
    if (l && (a = o.next()), !l && Z8t(a, e) && a === o.peek()) {
      o.advance(), i.type === 2 && (i = s.pop());
      const c = ZL(a, e);
      if (i.type === c || i.type === 5 && c === 6)
        i = s.pop();
      else {
        const d = {
          type: c,
          children: []
        };
        c === 5 && (d.index = n, n++), i.children.push(d), s.push(i), i = d;
      }
    } else if (a === `
`)
      i.type === 2 && (i = s.pop()), i.children.push({
        type: 8
        /* FormatType.NewLine */
      });
    else if (i.type !== 2) {
      const c = {
        type: 2,
        content: a
      };
      i.children.push(c), s.push(i), i = c;
    } else
      i.content += a;
  }
  return i.type === 2 && (i = s.pop()), t;
}
function Z8t(r, e) {
  return ZL(r, e) !== 0;
}
function ZL(r, e) {
  switch (r) {
    case "*":
      return 3;
    case "_":
      return 4;
    case "[":
      return 5;
    case "]":
      return 6;
    case "`":
      return e ? 7 : 0;
    default:
      return 0;
  }
}
const U8t = new RegExp(`(\\\\)?\\$\\((${Tt.iconNameExpression}(?:${Tt.iconModifierExpression})?)\\)`, "g");
function X0(r) {
  const e = new Array();
  let t, n = 0, i = 0;
  for (; (t = U8t.exec(r)) !== null; ) {
    i = t.index || 0, n < i && e.push(r.substring(n, i)), n = (t.index || 0) + t[0].length;
    const [, s, o] = t;
    e.push(s ? `$(${o})` : S9({ id: o }));
  }
  return n < r.length && e.push(r.substring(n)), e;
}
function S9(r) {
  const e = $e("span");
  return e.classList.add(...Tt.asClassNameArray(r)), e;
}
function sNe(...r) {
  return function(e, t) {
    for (let n = 0, i = r.length; n < i; n++) {
      const s = r[n](e, t);
      if (s)
        return s;
    }
    return null;
  };
}
oNe.bind(void 0, !1);
const M9 = oNe.bind(void 0, !0);
function oNe(r, e, t) {
  if (!t || t.length < e.length)
    return null;
  let n;
  return r ? n = OI(t, e) : n = t.indexOf(e) === 0, n ? e.length > 0 ? [{ start: 0, end: e.length }] : [] : null;
}
function q8t(r, e) {
  const t = e.toLowerCase().indexOf(r.toLowerCase());
  return t === -1 ? null : [{ start: t, end: t + r.length }];
}
function G8t(r, e) {
  return UL(r.toLowerCase(), e.toLowerCase(), 0, 0);
}
function UL(r, e, t, n) {
  if (t === r.length)
    return [];
  if (n === e.length)
    return null;
  if (r[t] === e[n]) {
    let i = null;
    return (i = UL(r, e, t + 1, n + 1)) ? lNe({ start: n, end: n + 1 }, i) : null;
  }
  return UL(r, e, t, n + 1);
}
function aR(r) {
  return 97 <= r && r <= 122;
}
function Cy(r) {
  return 65 <= r && r <= 90;
}
function lR(r) {
  return 48 <= r && r <= 57;
}
function Q8t(r) {
  return r === 32 || r === 9 || r === 10 || r === 13;
}
const K8t = /* @__PURE__ */ new Set();
"()[]{}<>`'\"-/;:,.?!".split("").forEach((r) => K8t.add(r.charCodeAt(0)));
function aNe(r) {
  return aR(r) || Cy(r) || lR(r);
}
function lNe(r, e) {
  return e.length === 0 ? e = [r] : r.end === e[0].start ? e[0].start = r.start : e.unshift(r), e;
}
function cNe(r, e) {
  for (let t = e; t < r.length; t++) {
    const n = r.charCodeAt(t);
    if (Cy(n) || lR(n) || t > 0 && !aNe(r.charCodeAt(t - 1)))
      return t;
  }
  return r.length;
}
function qL(r, e, t, n) {
  if (t === r.length)
    return [];
  if (n === e.length)
    return null;
  if (r[t] !== e[n].toLowerCase())
    return null;
  {
    let i = null, s = n + 1;
    for (i = qL(r, e, t + 1, n + 1); !i && (s = cNe(e, s)) < e.length; )
      i = qL(r, e, t + 1, s), s++;
    return i === null ? null : lNe({ start: n, end: n + 1 }, i);
  }
}
function Y8t(r) {
  let e = 0, t = 0, n = 0, i = 0, s = 0;
  for (let d = 0; d < r.length; d++)
    s = r.charCodeAt(d), Cy(s) && e++, aR(s) && t++, aNe(s) && n++, lR(s) && i++;
  const o = e / r.length, a = t / r.length, l = n / r.length, c = i / r.length;
  return { upperPercent: o, lowerPercent: a, alphaPercent: l, numericPercent: c };
}
function X8t(r) {
  const { upperPercent: e, lowerPercent: t } = r;
  return t === 0 && e > 0.6;
}
function J8t(r) {
  const { upperPercent: e, lowerPercent: t, alphaPercent: n, numericPercent: i } = r;
  return t > 0.2 && e < 0.8 && n > 0.6 && i < 0.2;
}
function $8t(r) {
  let e = 0, t = 0, n = 0, i = 0;
  for (let s = 0; s < r.length; s++)
    n = r.charCodeAt(s), Cy(n) && e++, aR(n) && t++, Q8t(n) && i++;
  return (e === 0 || t === 0) && i === 0 ? r.length <= 30 : e <= 5;
}
function hNe(r, e) {
  if (!e || (e = e.trim(), e.length === 0) || !$8t(r))
    return null;
  e.length > 60 && (e = e.substring(0, 60));
  const t = Y8t(e);
  if (!J8t(t)) {
    if (!X8t(t))
      return null;
    e = e.toLowerCase();
  }
  let n = null, i = 0;
  for (r = r.toLowerCase(); i < e.length && (n = qL(r, e, 0, i)) === null; )
    i = cNe(e, i + 1);
  return n;
}
const e9t = sNe(M9, hNe, q8t), t9t = sNe(M9, hNe, G8t), T8e = new _w(1e4);
function I8e(r, e, t = !1) {
  if (typeof r != "string" || typeof e != "string")
    return null;
  let n = T8e.get(r);
  n || (n = new RegExp(_0t(r), "i"), T8e.set(r, n));
  const i = n.exec(e);
  return i ? [{ start: i.index, end: i.index + i[0].length }] : t ? t9t(r, e) : e9t(r, e);
}
function n9t(r, e) {
  const t = fNe(r, r.toLowerCase(), 0, e, e.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
  return t ? i9t(t) : null;
}
function i9t(r) {
  if (typeof r > "u")
    return [];
  const e = [], t = r[1];
  for (let n = r.length - 1; n > 1; n--) {
    const i = r[n] + t, s = e[e.length - 1];
    s && s.end === i ? s.end = i + 1 : e.push({ start: i, end: i + 1 });
  }
  return e;
}
const Bu = 128;
function cR() {
  const r = [], e = [];
  for (let t = 0; t <= Bu; t++)
    e[t] = 0;
  for (let t = 0; t <= Bu; t++)
    r.push(e.slice(0));
  return r;
}
function dNe(r) {
  const e = [];
  for (let t = 0; t <= r; t++)
    e[t] = 0;
  return e;
}
const uNe = dNe(2 * Bu), GL = dNe(2 * Bu), Ph = cR(), Q1 = cR(), Yv = cR();
function Xv(r, e) {
  if (e < 0 || e >= r.length)
    return !1;
  const t = r.codePointAt(e);
  switch (t) {
    case 95:
    case 45:
    case 46:
    case 32:
    case 47:
    case 92:
    case 39:
    case 34:
    case 58:
    case 36:
    case 60:
    case 62:
    case 40:
    case 41:
    case 91:
    case 93:
    case 123:
    case 125:
      return !0;
    case void 0:
      return !1;
    default:
      return !!PI(t);
  }
}
function O8e(r, e) {
  if (e < 0 || e >= r.length)
    return !1;
  switch (r.charCodeAt(e)) {
    case 32:
    case 9:
      return !0;
    default:
      return !1;
  }
}
function L6(r, e, t) {
  return e[r] !== t[r];
}
function r9t(r, e, t, n, i, s, o = !1) {
  for (; e < t && i < s; )
    r[e] === n[i] && (o && (uNe[e] = i), e += 1), i += 1;
  return e === t;
}
var kp;
(function(r) {
  r.Default = [-100, 0];
  function e(t) {
    return !t || t.length === 2 && t[0] === -100 && t[1] === 0;
  }
  r.isDefault = e;
})(kp || (kp = {}));
class s9t {
  static {
    this.default = { boostFullMatch: !0, firstMatchCanBeWeak: !1 };
  }
  constructor(e, t) {
    this.firstMatchCanBeWeak = e, this.boostFullMatch = t;
  }
}
function fNe(r, e, t, n, i, s, o = s9t.default) {
  const a = r.length > Bu ? Bu : r.length, l = n.length > Bu ? Bu : n.length;
  if (t >= a || s >= l || a - t > l - s || !r9t(e, t, a, i, s, l, !0))
    return;
  o9t(a, l, t, s, e, i);
  let c = 1, d = 1, u = t, f = s;
  const p = [!1];
  for (c = 1, u = t; u < a; c++, u++) {
    const v = uNe[u], y = GL[u], _ = u + 1 < a ? GL[u + 1] : l;
    for (d = v - s + 1, f = v; f < _; d++, f++) {
      let S = Number.MIN_SAFE_INTEGER, D = !1;
      f <= y && (S = a9t(r, e, u, t, n, i, f, l, s, Ph[c - 1][d - 1] === 0, p));
      let M = 0;
      S !== Number.MAX_SAFE_INTEGER && (D = !0, M = S + Q1[c - 1][d - 1]);
      const L = f > v, T = L ? Q1[c][d - 1] + (Ph[c][d - 1] > 0 ? -5 : 0) : 0, B = f > v + 1 && Ph[c][d - 1] > 0, V = B ? Q1[c][d - 2] + (Ph[c][d - 2] > 0 ? -5 : 0) : 0;
      if (B && (!L || V >= T) && (!D || V >= M))
        Q1[c][d] = V, Yv[c][d] = 3, Ph[c][d] = 0;
      else if (L && (!D || T >= M))
        Q1[c][d] = T, Yv[c][d] = 2, Ph[c][d] = 0;
      else if (D)
        Q1[c][d] = M, Yv[c][d] = 1, Ph[c][d] = Ph[c - 1][d - 1] + 1;
      else
        throw new Error("not possible");
    }
  }
  if (!p[0] && !o.firstMatchCanBeWeak)
    return;
  c--, d--;
  const g = [Q1[c][d], s];
  let m = 0, A = 0;
  for (; c >= 1; ) {
    let v = d;
    do {
      const y = Yv[c][v];
      if (y === 3)
        v = v - 2;
      else if (y === 2)
        v = v - 1;
      else
        break;
    } while (v >= 1);
    m > 1 && e[t + c - 1] === i[s + d - 1] && !L6(v + s - 1, n, i) && m + 1 > Ph[c][v] && (v = d), v === d ? m++ : m = 1, A || (A = v), c--, d = v - 1, g.push(d);
  }
  l - s === a && o.boostFullMatch && (g[0] += 2);
  const w = A - a;
  return g[0] -= w, g;
}
function o9t(r, e, t, n, i, s) {
  let o = r - 1, a = e - 1;
  for (; o >= t && a >= n; )
    i[o] === s[a] && (GL[o] = a, o--), a--;
}
function a9t(r, e, t, n, i, s, o, a, l, c, d) {
  if (e[t] !== s[o])
    return Number.MIN_SAFE_INTEGER;
  let u = 1, f = !1;
  return o === t - n ? u = r[t] === i[o] ? 7 : 5 : L6(o, i, s) && (o === 0 || !L6(o - 1, i, s)) ? (u = r[t] === i[o] ? 7 : 5, f = !0) : Xv(s, o) && (o === 0 || !Xv(s, o - 1)) ? u = 5 : (Xv(s, o - 1) || O8e(s, o - 1)) && (u = 5, f = !0), u > 1 && t === n && (d[0] = !0), f || (f = L6(o, i, s) || Xv(s, o - 1) || O8e(s, o - 1)), t === n ? o > l && (u -= f ? 3 : 5) : c ? u += f ? 2 : 0 : u += f ? 0 : 1, o + 1 === a && (u -= f ? 3 : 5), u;
}
const l9t = "$(", hR = new RegExp(`\\$\\(${Tt.iconNameExpression}(?:${Tt.iconModifierExpression})?\\)`, "g"), c9t = new RegExp(`(\\\\)?${hR.source}`, "g");
function h9t(r) {
  return r.replace(c9t, (e, t) => t ? e : `\\${e}`);
}
const d9t = new RegExp(`\\\\${hR.source}`, "g");
function u9t(r) {
  return r.replace(d9t, (e) => `\\${e}`);
}
const f9t = new RegExp(`(\\s)?(\\\\)?${hR.source}(\\s)?`, "g");
function pNe(r) {
  return r.indexOf(l9t) === -1 ? r : r.replace(f9t, (e, t, n, i) => n ? e : t || i || "");
}
function p9t(r) {
  return r ? r.replace(/\$\((.*?)\)/g, (e, t) => ` ${t} `).trim() : "";
}
const p_ = new RegExp(`\\$\\(${Tt.iconNameCharacter}+\\)`, "g");
function bA(r) {
  p_.lastIndex = 0;
  let e = "";
  const t = [];
  let n = 0;
  for (; ; ) {
    const i = p_.lastIndex, s = p_.exec(r), o = r.substring(i, s?.index);
    if (o.length > 0) {
      e += o;
      for (let a = 0; a < o.length; a++)
        t.push(n);
    }
    if (!s)
      break;
    n += s[0].length;
  }
  return { text: e, iconOffsets: t };
}
function g_(r, e, t = !1) {
  const { text: n, iconOffsets: i } = e;
  if (!i || i.length === 0)
    return I8e(r, n, t);
  const s = R7(n, " "), o = n.length - s.length, a = I8e(r, s, t);
  if (a)
    for (const l of a) {
      const c = i[l.start + o] + o;
      l.start += c, l.end += c;
    }
  return a;
}
class gNe {
  constructor(e = "", t = !1) {
    if (this.value = e, typeof this.value != "string")
      throw I7("value");
    typeof t == "boolean" ? (this.isTrusted = t, this.supportThemeIcons = !1, this.supportHtml = !1) : (this.isTrusted = t.isTrusted ?? void 0, this.supportThemeIcons = t.supportThemeIcons ?? !1, this.supportHtml = t.supportHtml ?? !1);
  }
  appendText(e, t = 0) {
    return this.value += m9t(this.supportThemeIcons ? h9t(e) : e).replace(/([ \t]+)/g, (n, i) => "&nbsp;".repeat(i.length)).replace(/\>/gm, "\\>").replace(/\n/g, t === 1 ? `\\
` : `

`), this;
  }
  appendMarkdown(e) {
    return this.value += e, this;
  }
  appendCodeblock(e, t) {
    return this.value += `
${A9t(t, e)}
`, this;
  }
  appendLink(e, t, n) {
    return this.value += "[", this.value += this._escape(t, "]"), this.value += "](", this.value += this._escape(String(e), ")"), n && (this.value += ` "${this._escape(this._escape(n, '"'), ")")}"`), this.value += ")", this;
  }
  _escape(e, t) {
    const n = new RegExp(tc(t), "g");
    return e.replace(n, (i, s) => e.charAt(s - 1) !== "\\" ? `\\${i}` : i);
  }
}
function Np(r) {
  return r instanceof gNe ? !0 : r && typeof r == "object" ? typeof r.value == "string" && (typeof r.isTrusted == "boolean" || typeof r.isTrusted == "object" || r.isTrusted === void 0) && (typeof r.supportThemeIcons == "boolean" || r.supportThemeIcons === void 0) : !1;
}
function g9t(r, e) {
  return r === e ? !0 : !r || !e ? !1 : r.value === e.value && r.isTrusted === e.isTrusted && r.supportThemeIcons === e.supportThemeIcons && r.supportHtml === e.supportHtml && (r.baseUri === e.baseUri || !!r.baseUri && !!e.baseUri && Xvt(Pt.from(r.baseUri), Pt.from(e.baseUri)));
}
function m9t(r) {
  return r.replace(/[\\`*_{}[\]()#+\-!~]/g, "\\$&");
}
function A9t(r, e) {
  const t = r.match(/^`+/gm)?.reduce((i, s) => i.length > s.length ? i : s).length ?? 0, n = t >= 3 ? t + 1 : 3;
  return [
    `${"`".repeat(n)}${e}`,
    r,
    `${"`".repeat(n)}`
  ].join(`
`);
}
function Jv(r) {
  return r.replace(/"/g, "&quot;");
}
function m_(r) {
  return r && r.replace(/\\([\\`*_{}[\]()#+\-.!~])/g, "$1");
}
function w9t(r) {
  const e = [], t = r.split("|").map((i) => i.trim());
  r = t[0];
  const n = t[1];
  if (n) {
    const i = /height=(\d+)/.exec(n), s = /width=(\d+)/.exec(n), o = i ? i[1] : "", a = s ? s[1] : "", l = isFinite(parseInt(a)), c = isFinite(parseInt(o));
    l && e.push(`width="${a}"`), c && e.push(`height="${o}"`);
  }
  return { href: r, dimensions: e };
}
let mNe = class {
  constructor(e) {
    this._prefix = e, this._lastId = 0;
  }
  nextId() {
    return this._prefix + ++this._lastId;
  }
};
const R8e = new mNe("id#");
let Ss = {};
(function() {
  function r(e, t) {
    t(Ss);
  }
  r.amd = !0, function(e, t) {
    typeof r == "function" && r.amd ? r(["exports"], t) : typeof exports == "object" && typeof module < "u" ? t(exports) : (e = typeof globalThis < "u" ? globalThis : e || self, t(e.marked = {}));
  }(this, function(e) {
    function t(we, de) {
      for (var he = 0; he < de.length; he++) {
        var P = de[he];
        P.enumerable = P.enumerable || !1, P.configurable = !0, "value" in P && (P.writable = !0), Object.defineProperty(we, P.key, P);
      }
    }
    function n(we, de, he) {
      return he && t(we, he), Object.defineProperty(we, "prototype", {
        writable: !1
      }), we;
    }
    function i(we, de) {
      if (we) {
        if (typeof we == "string") return s(we, de);
        var he = Object.prototype.toString.call(we).slice(8, -1);
        if (he === "Object" && we.constructor && (he = we.constructor.name), he === "Map" || he === "Set") return Array.from(we);
        if (he === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(he)) return s(we, de);
      }
    }
    function s(we, de) {
      (de == null || de > we.length) && (de = we.length);
      for (var he = 0, P = new Array(de); he < de; he++) P[he] = we[he];
      return P;
    }
    function o(we, de) {
      var he = typeof Symbol < "u" && we[Symbol.iterator] || we["@@iterator"];
      if (he) return (he = he.call(we)).next.bind(he);
      if (Array.isArray(we) || (he = i(we)) || de) {
        he && (we = he);
        var P = 0;
        return function() {
          return P >= we.length ? {
            done: !0
          } : {
            done: !1,
            value: we[P++]
          };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function a() {
      return {
        async: !1,
        baseUrl: null,
        breaks: !1,
        extensions: null,
        gfm: !0,
        headerIds: !0,
        headerPrefix: "",
        highlight: null,
        langPrefix: "language-",
        mangle: !0,
        pedantic: !1,
        renderer: null,
        sanitize: !1,
        sanitizer: null,
        silent: !1,
        smartLists: !1,
        smartypants: !1,
        tokenizer: null,
        walkTokens: null,
        xhtml: !1
      };
    }
    e.defaults = a();
    function l(we) {
      e.defaults = we;
    }
    var c = /[&<>"']/, d = /[&<>"']/g, u = /[<>"']|&(?!#?\w+;)/, f = /[<>"']|&(?!#?\w+;)/g, p = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, g = function(de) {
      return p[de];
    };
    function m(we, de) {
      if (de) {
        if (c.test(we))
          return we.replace(d, g);
      } else if (u.test(we))
        return we.replace(f, g);
      return we;
    }
    var A = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function w(we) {
      return we.replace(A, function(de, he) {
        return he = he.toLowerCase(), he === "colon" ? ":" : he.charAt(0) === "#" ? he.charAt(1) === "x" ? String.fromCharCode(parseInt(he.substring(2), 16)) : String.fromCharCode(+he.substring(1)) : "";
      });
    }
    var v = /(^|[^\[])\^/g;
    function y(we, de) {
      we = typeof we == "string" ? we : we.source, de = de || "";
      var he = {
        replace: function(W, ne) {
          return ne = ne.source || ne, ne = ne.replace(v, "$1"), we = we.replace(W, ne), he;
        },
        getRegex: function() {
          return new RegExp(we, de);
        }
      };
      return he;
    }
    var _ = /[^\w:]/g, S = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    function D(we, de, he) {
      if (we) {
        var P;
        try {
          P = decodeURIComponent(w(he)).replace(_, "").toLowerCase();
        } catch {
          return null;
        }
        if (P.indexOf("javascript:") === 0 || P.indexOf("vbscript:") === 0 || P.indexOf("data:") === 0)
          return null;
      }
      de && !S.test(he) && (he = V(de, he));
      try {
        he = encodeURI(he).replace(/%25/g, "%");
      } catch {
        return null;
      }
      return he;
    }
    var M = {}, L = /^[^:]+:\/*[^/]*$/, T = /^([^:]+:)[\s\S]*$/, B = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    function V(we, de) {
      M[" " + we] || (L.test(we) ? M[" " + we] = we + "/" : M[" " + we] = z(we, "/", !0)), we = M[" " + we];
      var he = we.indexOf(":") === -1;
      return de.substring(0, 2) === "//" ? he ? de : we.replace(T, "$1") + de : de.charAt(0) === "/" ? he ? de : we.replace(B, "$1") + de : we + de;
    }
    var N = {
      exec: function() {
      }
    };
    function R(we) {
      for (var de = 1, he, P; de < arguments.length; de++) {
        he = arguments[de];
        for (P in he)
          Object.prototype.hasOwnProperty.call(he, P) && (we[P] = he[P]);
      }
      return we;
    }
    function H(we, de) {
      var he = we.replace(/\|/g, function(ne, X, Ae) {
        for (var Le = !1, We = X; --We >= 0 && Ae[We] === "\\"; )
          Le = !Le;
        return Le ? "|" : " |";
      }), P = he.split(/ \|/), W = 0;
      if (P[0].trim() || P.shift(), P.length > 0 && !P[P.length - 1].trim() && P.pop(), P.length > de)
        P.splice(de);
      else
        for (; P.length < de; )
          P.push("");
      for (; W < P.length; W++)
        P[W] = P[W].trim().replace(/\\\|/g, "|");
      return P;
    }
    function z(we, de, he) {
      var P = we.length;
      if (P === 0)
        return "";
      for (var W = 0; W < P; ) {
        var ne = we.charAt(P - W - 1);
        if (ne === de && !he)
          W++;
        else if (ne !== de && he)
          W++;
        else
          break;
      }
      return we.slice(0, P - W);
    }
    function U(we, de) {
      if (we.indexOf(de[1]) === -1)
        return -1;
      for (var he = we.length, P = 0, W = 0; W < he; W++)
        if (we[W] === "\\")
          W++;
        else if (we[W] === de[0])
          P++;
        else if (we[W] === de[1] && (P--, P < 0))
          return W;
      return -1;
    }
    function ee(we) {
      we && we.sanitize && !we.silent && console.warn("marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options");
    }
    function ce(we, de) {
      if (de < 1)
        return "";
      for (var he = ""; de > 1; )
        de & 1 && (he += we), de >>= 1, we += we;
      return he + we;
    }
    function se(we, de, he, P) {
      var W = de.href, ne = de.title ? m(de.title) : null, X = we[1].replace(/\\([\[\]])/g, "$1");
      if (we[0].charAt(0) !== "!") {
        P.state.inLink = !0;
        var Ae = {
          type: "link",
          raw: he,
          href: W,
          title: ne,
          text: X,
          tokens: P.inlineTokens(X)
        };
        return P.state.inLink = !1, Ae;
      }
      return {
        type: "image",
        raw: he,
        href: W,
        title: ne,
        text: m(X)
      };
    }
    function te(we, de) {
      var he = we.match(/^(\s+)(?:```)/);
      if (he === null)
        return de;
      var P = he[1];
      return de.split(`
`).map(function(W) {
        var ne = W.match(/^\s+/);
        if (ne === null)
          return W;
        var X = ne[0];
        return X.length >= P.length ? W.slice(P.length) : W;
      }).join(`
`);
    }
    var ue = /* @__PURE__ */ function() {
      function we(he) {
        this.options = he || e.defaults;
      }
      var de = we.prototype;
      return de.space = function(P) {
        var W = this.rules.block.newline.exec(P);
        if (W && W[0].length > 0)
          return {
            type: "space",
            raw: W[0]
          };
      }, de.code = function(P) {
        var W = this.rules.block.code.exec(P);
        if (W) {
          var ne = W[0].replace(/^ {1,4}/gm, "");
          return {
            type: "code",
            raw: W[0],
            codeBlockStyle: "indented",
            text: this.options.pedantic ? ne : z(ne, `
`)
          };
        }
      }, de.fences = function(P) {
        var W = this.rules.block.fences.exec(P);
        if (W) {
          var ne = W[0], X = te(ne, W[3] || "");
          return {
            type: "code",
            raw: ne,
            lang: W[2] ? W[2].trim() : W[2],
            text: X
          };
        }
      }, de.heading = function(P) {
        var W = this.rules.block.heading.exec(P);
        if (W) {
          var ne = W[2].trim();
          if (/#$/.test(ne)) {
            var X = z(ne, "#");
            (this.options.pedantic || !X || / $/.test(X)) && (ne = X.trim());
          }
          return {
            type: "heading",
            raw: W[0],
            depth: W[1].length,
            text: ne,
            tokens: this.lexer.inline(ne)
          };
        }
      }, de.hr = function(P) {
        var W = this.rules.block.hr.exec(P);
        if (W)
          return {
            type: "hr",
            raw: W[0]
          };
      }, de.blockquote = function(P) {
        var W = this.rules.block.blockquote.exec(P);
        if (W) {
          var ne = W[0].replace(/^ *>[ \t]?/gm, "");
          return {
            type: "blockquote",
            raw: W[0],
            tokens: this.lexer.blockTokens(ne, []),
            text: ne
          };
        }
      }, de.list = function(P) {
        var W = this.rules.block.list.exec(P);
        if (W) {
          var ne, X, Ae, Le, We, Ue, ut, ct, yn, fn, it, ei, ti = W[1].trim(), Ds = ti.length > 1, Gt = {
            type: "list",
            raw: "",
            ordered: Ds,
            start: Ds ? +ti.slice(0, -1) : "",
            loose: !1,
            items: []
          };
          ti = Ds ? "\\d{1,9}\\" + ti.slice(-1) : "\\" + ti, this.options.pedantic && (ti = Ds ? ti : "[*+-]");
          for (var Yn = new RegExp("^( {0,3}" + ti + ")((?:[	 ][^\\n]*)?(?:\\n|$))"); P && (ei = !1, !(!(W = Yn.exec(P)) || this.rules.block.hr.test(P))); ) {
            if (ne = W[0], P = P.substring(ne.length), ct = W[2].split(`
`, 1)[0], yn = P.split(`
`, 1)[0], this.options.pedantic ? (Le = 2, it = ct.trimLeft()) : (Le = W[2].search(/[^ ]/), Le = Le > 4 ? 1 : Le, it = ct.slice(Le), Le += W[1].length), Ue = !1, !ct && /^ *$/.test(yn) && (ne += yn + `
`, P = P.substring(yn.length + 1), ei = !0), !ei)
              for (var El = new RegExp("^ {0," + Math.min(3, Le - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?: [^\\n]*)?(?:\\n|$))"), _l = new RegExp("^ {0," + Math.min(3, Le - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)"), mo = new RegExp("^ {0," + Math.min(3, Le - 1) + "}(?:```|~~~)"), Ec = new RegExp("^ {0," + Math.min(3, Le - 1) + "}#"); P && (fn = P.split(`
`, 1)[0], ct = fn, this.options.pedantic && (ct = ct.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), !(mo.test(ct) || Ec.test(ct) || El.test(ct) || _l.test(P))); ) {
                if (ct.search(/[^ ]/) >= Le || !ct.trim())
                  it += `
` + ct.slice(Le);
                else if (!Ue)
                  it += `
` + ct;
                else
                  break;
                !Ue && !ct.trim() && (Ue = !0), ne += fn + `
`, P = P.substring(fn.length + 1);
              }
            Gt.loose || (ut ? Gt.loose = !0 : /\n *\n *$/.test(ne) && (ut = !0)), this.options.gfm && (X = /^\[[ xX]\] /.exec(it), X && (Ae = X[0] !== "[ ] ", it = it.replace(/^\[[ xX]\] +/, ""))), Gt.items.push({
              type: "list_item",
              raw: ne,
              task: !!X,
              checked: Ae,
              loose: !1,
              text: it
            }), Gt.raw += ne;
          }
          Gt.items[Gt.items.length - 1].raw = ne.trimRight(), Gt.items[Gt.items.length - 1].text = it.trimRight(), Gt.raw = Gt.raw.trimRight();
          var _c = Gt.items.length;
          for (We = 0; We < _c; We++) {
            this.lexer.state.top = !1, Gt.items[We].tokens = this.lexer.blockTokens(Gt.items[We].text, []);
            var Oh = Gt.items[We].tokens.filter(function(xc) {
              return xc.type === "space";
            }), Rh = Oh.every(function(xc) {
              for (var xm = xc.raw.split(""), Ia = 0, ou = o(xm), au; !(au = ou()).done; ) {
                var m2 = au.value;
                if (m2 === `
` && (Ia += 1), Ia > 1)
                  return !0;
              }
              return !1;
            });
            !Gt.loose && Oh.length && Rh && (Gt.loose = !0, Gt.items[We].loose = !0);
          }
          return Gt;
        }
      }, de.html = function(P) {
        var W = this.rules.block.html.exec(P);
        if (W) {
          var ne = {
            type: "html",
            raw: W[0],
            pre: !this.options.sanitizer && (W[1] === "pre" || W[1] === "script" || W[1] === "style"),
            text: W[0]
          };
          if (this.options.sanitize) {
            var X = this.options.sanitizer ? this.options.sanitizer(W[0]) : m(W[0]);
            ne.type = "paragraph", ne.text = X, ne.tokens = this.lexer.inline(X);
          }
          return ne;
        }
      }, de.def = function(P) {
        var W = this.rules.block.def.exec(P);
        if (W) {
          W[3] && (W[3] = W[3].substring(1, W[3].length - 1));
          var ne = W[1].toLowerCase().replace(/\s+/g, " ");
          return {
            type: "def",
            tag: ne,
            raw: W[0],
            href: W[2],
            title: W[3]
          };
        }
      }, de.table = function(P) {
        var W = this.rules.block.table.exec(P);
        if (W) {
          var ne = {
            type: "table",
            header: H(W[1]).map(function(ut) {
              return {
                text: ut
              };
            }),
            align: W[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
            rows: W[3] && W[3].trim() ? W[3].replace(/\n[ \t]*$/, "").split(`
`) : []
          };
          if (ne.header.length === ne.align.length) {
            ne.raw = W[0];
            var X = ne.align.length, Ae, Le, We, Ue;
            for (Ae = 0; Ae < X; Ae++)
              /^ *-+: *$/.test(ne.align[Ae]) ? ne.align[Ae] = "right" : /^ *:-+: *$/.test(ne.align[Ae]) ? ne.align[Ae] = "center" : /^ *:-+ *$/.test(ne.align[Ae]) ? ne.align[Ae] = "left" : ne.align[Ae] = null;
            for (X = ne.rows.length, Ae = 0; Ae < X; Ae++)
              ne.rows[Ae] = H(ne.rows[Ae], ne.header.length).map(function(ut) {
                return {
                  text: ut
                };
              });
            for (X = ne.header.length, Le = 0; Le < X; Le++)
              ne.header[Le].tokens = this.lexer.inline(ne.header[Le].text);
            for (X = ne.rows.length, Le = 0; Le < X; Le++)
              for (Ue = ne.rows[Le], We = 0; We < Ue.length; We++)
                Ue[We].tokens = this.lexer.inline(Ue[We].text);
            return ne;
          }
        }
      }, de.lheading = function(P) {
        var W = this.rules.block.lheading.exec(P);
        if (W)
          return {
            type: "heading",
            raw: W[0],
            depth: W[2].charAt(0) === "=" ? 1 : 2,
            text: W[1],
            tokens: this.lexer.inline(W[1])
          };
      }, de.paragraph = function(P) {
        var W = this.rules.block.paragraph.exec(P);
        if (W) {
          var ne = W[1].charAt(W[1].length - 1) === `
` ? W[1].slice(0, -1) : W[1];
          return {
            type: "paragraph",
            raw: W[0],
            text: ne,
            tokens: this.lexer.inline(ne)
          };
        }
      }, de.text = function(P) {
        var W = this.rules.block.text.exec(P);
        if (W)
          return {
            type: "text",
            raw: W[0],
            text: W[0],
            tokens: this.lexer.inline(W[0])
          };
      }, de.escape = function(P) {
        var W = this.rules.inline.escape.exec(P);
        if (W)
          return {
            type: "escape",
            raw: W[0],
            text: m(W[1])
          };
      }, de.tag = function(P) {
        var W = this.rules.inline.tag.exec(P);
        if (W)
          return !this.lexer.state.inLink && /^<a /i.test(W[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(W[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(W[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(W[0]) && (this.lexer.state.inRawBlock = !1), {
            type: this.options.sanitize ? "text" : "html",
            raw: W[0],
            inLink: this.lexer.state.inLink,
            inRawBlock: this.lexer.state.inRawBlock,
            text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(W[0]) : m(W[0]) : W[0]
          };
      }, de.link = function(P) {
        var W = this.rules.inline.link.exec(P);
        if (W) {
          var ne = W[2].trim();
          if (!this.options.pedantic && /^</.test(ne)) {
            if (!/>$/.test(ne))
              return;
            var X = z(ne.slice(0, -1), "\\");
            if ((ne.length - X.length) % 2 === 0)
              return;
          } else {
            var Ae = U(W[2], "()");
            if (Ae > -1) {
              var Le = W[0].indexOf("!") === 0 ? 5 : 4, We = Le + W[1].length + Ae;
              W[2] = W[2].substring(0, Ae), W[0] = W[0].substring(0, We).trim(), W[3] = "";
            }
          }
          var Ue = W[2], ut = "";
          if (this.options.pedantic) {
            var ct = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(Ue);
            ct && (Ue = ct[1], ut = ct[3]);
          } else
            ut = W[3] ? W[3].slice(1, -1) : "";
          return Ue = Ue.trim(), /^</.test(Ue) && (this.options.pedantic && !/>$/.test(ne) ? Ue = Ue.slice(1) : Ue = Ue.slice(1, -1)), se(W, {
            href: Ue && Ue.replace(this.rules.inline._escapes, "$1"),
            title: ut && ut.replace(this.rules.inline._escapes, "$1")
          }, W[0], this.lexer);
        }
      }, de.reflink = function(P, W) {
        var ne;
        if ((ne = this.rules.inline.reflink.exec(P)) || (ne = this.rules.inline.nolink.exec(P))) {
          var X = (ne[2] || ne[1]).replace(/\s+/g, " ");
          if (X = W[X.toLowerCase()], !X || !X.href) {
            var Ae = ne[0].charAt(0);
            return {
              type: "text",
              raw: Ae,
              text: Ae
            };
          }
          return se(ne, X, ne[0], this.lexer);
        }
      }, de.emStrong = function(P, W, ne) {
        ne === void 0 && (ne = "");
        var X = this.rules.inline.emStrong.lDelim.exec(P);
        if (X && !(X[3] && ne.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/))) {
          var Ae = X[1] || X[2] || "";
          if (!Ae || Ae && (ne === "" || this.rules.inline.punctuation.exec(ne))) {
            var Le = X[0].length - 1, We, Ue, ut = Le, ct = 0, yn = X[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
            for (yn.lastIndex = 0, W = W.slice(-1 * P.length + Le); (X = yn.exec(W)) != null; )
              if (We = X[1] || X[2] || X[3] || X[4] || X[5] || X[6], !!We) {
                if (Ue = We.length, X[3] || X[4]) {
                  ut += Ue;
                  continue;
                } else if ((X[5] || X[6]) && Le % 3 && !((Le + Ue) % 3)) {
                  ct += Ue;
                  continue;
                }
                if (ut -= Ue, !(ut > 0)) {
                  if (Ue = Math.min(Ue, Ue + ut + ct), Math.min(Le, Ue) % 2) {
                    var fn = P.slice(1, Le + X.index + Ue);
                    return {
                      type: "em",
                      raw: P.slice(0, Le + X.index + Ue + 1),
                      text: fn,
                      tokens: this.lexer.inlineTokens(fn)
                    };
                  }
                  var it = P.slice(2, Le + X.index + Ue - 1);
                  return {
                    type: "strong",
                    raw: P.slice(0, Le + X.index + Ue + 1),
                    text: it,
                    tokens: this.lexer.inlineTokens(it)
                  };
                }
              }
          }
        }
      }, de.codespan = function(P) {
        var W = this.rules.inline.code.exec(P);
        if (W) {
          var ne = W[2].replace(/\n/g, " "), X = /[^ ]/.test(ne), Ae = /^ /.test(ne) && / $/.test(ne);
          return X && Ae && (ne = ne.substring(1, ne.length - 1)), ne = m(ne, !0), {
            type: "codespan",
            raw: W[0],
            text: ne
          };
        }
      }, de.br = function(P) {
        var W = this.rules.inline.br.exec(P);
        if (W)
          return {
            type: "br",
            raw: W[0]
          };
      }, de.del = function(P) {
        var W = this.rules.inline.del.exec(P);
        if (W)
          return {
            type: "del",
            raw: W[0],
            text: W[2],
            tokens: this.lexer.inlineTokens(W[2])
          };
      }, de.autolink = function(P, W) {
        var ne = this.rules.inline.autolink.exec(P);
        if (ne) {
          var X, Ae;
          return ne[2] === "@" ? (X = m(this.options.mangle ? W(ne[1]) : ne[1]), Ae = "mailto:" + X) : (X = m(ne[1]), Ae = X), {
            type: "link",
            raw: ne[0],
            text: X,
            href: Ae,
            tokens: [{
              type: "text",
              raw: X,
              text: X
            }]
          };
        }
      }, de.url = function(P, W) {
        var ne;
        if (ne = this.rules.inline.url.exec(P)) {
          var X, Ae;
          if (ne[2] === "@")
            X = m(this.options.mangle ? W(ne[0]) : ne[0]), Ae = "mailto:" + X;
          else {
            var Le;
            do
              Le = ne[0], ne[0] = this.rules.inline._backpedal.exec(ne[0])[0];
            while (Le !== ne[0]);
            X = m(ne[0]), ne[1] === "www." ? Ae = "http://" + X : Ae = X;
          }
          return {
            type: "link",
            raw: ne[0],
            text: X,
            href: Ae,
            tokens: [{
              type: "text",
              raw: X,
              text: X
            }]
          };
        }
      }, de.inlineText = function(P, W) {
        var ne = this.rules.inline.text.exec(P);
        if (ne) {
          var X;
          return this.lexer.state.inRawBlock ? X = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(ne[0]) : m(ne[0]) : ne[0] : X = m(this.options.smartypants ? W(ne[0]) : ne[0]), {
            type: "text",
            raw: ne[0],
            text: X
          };
        }
      }, we;
    }(), G = {
      newline: /^(?: *(?:\n|$))+/,
      code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
      fences: /^ {0,3}(`{3,}(?=[^`\n]*\n)|~{3,})([^\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
      hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
      heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
      blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
      list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
      html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
      def: /^ {0,3}\[(label)\]: *(?:\n *)?<?([^\s>]+)>?(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
      table: N,
      lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
      // regex template, placeholders will be replaced according to different paragraph
      // interruption rules of commonmark and the original markdown spec:
      _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
      text: /^[^\n]+/
    };
    G._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/, G._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/, G.def = y(G.def).replace("label", G._label).replace("title", G._title).getRegex(), G.bullet = /(?:[*+-]|\d{1,9}[.)])/, G.listItemStart = y(/^( *)(bull) */).replace("bull", G.bullet).getRegex(), G.list = y(G.list).replace(/bull/g, G.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + G.def.source + ")").getRegex(), G._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", G._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/, G.html = y(G.html, "i").replace("comment", G._comment).replace("tag", G._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), G.paragraph = y(G._paragraph).replace("hr", G.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", G._tag).getRegex(), G.blockquote = y(G.blockquote).replace("paragraph", G.paragraph).getRegex(), G.normal = R({}, G), G.gfm = R({}, G.normal, {
      table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)"
      // Cells
    }), G.gfm.table = y(G.gfm.table).replace("hr", G.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", G._tag).getRegex(), G.gfm.paragraph = y(G._paragraph).replace("hr", G.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "").replace("table", G.gfm.table).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", G._tag).getRegex(), G.pedantic = R({}, G.normal, {
      html: y(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", G._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
      def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
      heading: /^(#{1,6})(.*)(?:\n+|$)/,
      fences: N,
      // fences not supported
      paragraph: y(G.normal._paragraph).replace("hr", G.hr).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", G.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    });
    var j = {
      escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
      autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
      url: N,
      tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
      // CDATA section
      link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
      reflink: /^!?\[(label)\]\[(ref)\]/,
      nolink: /^!?\[(ref)\](?:\[\])?/,
      reflinkSearch: "reflink|nolink(?!\\()",
      emStrong: {
        lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
        //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
        //          () Skip orphan inside strong  () Consume to delim (1) #***                (2) a***#, a***                   (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
        rDelimAst: /^[^_*]*?\_\_[^_*]*?\*[^_*]*?(?=\_\_)|[^*]+(?=[^*])|[punct_](\*+)(?=[\s]|$)|[^punct*_\s](\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|[^punct*_\s](\*+)(?=[^punct*_\s])/,
        rDelimUnd: /^[^_*]*?\*\*[^_*]*?\_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|[punct*](\_+)(?=[\s]|$)|[^punct*_\s](\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/
        // ^- Not allowed for _
      },
      code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
      br: /^( {2,}|\\)\n(?!\s*$)/,
      del: N,
      text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
      punctuation: /^([\spunctuation])/
    };
    j._punctuation = "!\"#$%&'()+\\-.,/:;<=>?@\\[\\]`^{|}~", j.punctuation = y(j.punctuation).replace(/punctuation/g, j._punctuation).getRegex(), j.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g, j.escapedEmSt = /\\\*|\\_/g, j._comment = y(G._comment).replace("(?:-->|$)", "-->").getRegex(), j.emStrong.lDelim = y(j.emStrong.lDelim).replace(/punct/g, j._punctuation).getRegex(), j.emStrong.rDelimAst = y(j.emStrong.rDelimAst, "g").replace(/punct/g, j._punctuation).getRegex(), j.emStrong.rDelimUnd = y(j.emStrong.rDelimUnd, "g").replace(/punct/g, j._punctuation).getRegex(), j._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g, j._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/, j._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/, j.autolink = y(j.autolink).replace("scheme", j._scheme).replace("email", j._email).getRegex(), j._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/, j.tag = y(j.tag).replace("comment", j._comment).replace("attribute", j._attribute).getRegex(), j._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, j._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/, j._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/, j.link = y(j.link).replace("label", j._label).replace("href", j._href).replace("title", j._title).getRegex(), j.reflink = y(j.reflink).replace("label", j._label).replace("ref", G._label).getRegex(), j.nolink = y(j.nolink).replace("ref", G._label).getRegex(), j.reflinkSearch = y(j.reflinkSearch, "g").replace("reflink", j.reflink).replace("nolink", j.nolink).getRegex(), j.normal = R({}, j), j.pedantic = R({}, j.normal, {
      strong: {
        start: /^__|\*\*/,
        middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
        endAst: /\*\*(?!\*)/g,
        endUnd: /__(?!_)/g
      },
      em: {
        start: /^_|\*/,
        middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
        endAst: /\*(?!\*)/g,
        endUnd: /_(?!_)/g
      },
      link: y(/^!?\[(label)\]\((.*?)\)/).replace("label", j._label).getRegex(),
      reflink: y(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", j._label).getRegex()
    }), j.gfm = R({}, j.normal, {
      escape: y(j.escape).replace("])", "~|])").getRegex(),
      _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
      url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
      _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
      del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
      text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    }), j.gfm.url = y(j.gfm.url, "i").replace("email", j.gfm._extended_email).getRegex(), j.breaks = R({}, j.gfm, {
      br: y(j.br).replace("{2,}", "*").getRegex(),
      text: y(j.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    });
    function pe(we) {
      return we.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…");
    }
    function De(we) {
      var de = "", he, P, W = we.length;
      for (he = 0; he < W; he++)
        P = we.charCodeAt(he), Math.random() > 0.5 && (P = "x" + P.toString(16)), de += "&#" + P + ";";
      return de;
    }
    var Ce = /* @__PURE__ */ function() {
      function we(he) {
        this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = he || e.defaults, this.options.tokenizer = this.options.tokenizer || new ue(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
          inLink: !1,
          inRawBlock: !1,
          top: !0
        };
        var P = {
          block: G.normal,
          inline: j.normal
        };
        this.options.pedantic ? (P.block = G.pedantic, P.inline = j.pedantic) : this.options.gfm && (P.block = G.gfm, this.options.breaks ? P.inline = j.breaks : P.inline = j.gfm), this.tokenizer.rules = P;
      }
      we.lex = function(P, W) {
        var ne = new we(W);
        return ne.lex(P);
      }, we.lexInline = function(P, W) {
        var ne = new we(W);
        return ne.inlineTokens(P);
      };
      var de = we.prototype;
      return de.lex = function(P) {
        P = P.replace(/\r\n|\r/g, `
`), this.blockTokens(P, this.tokens);
        for (var W; W = this.inlineQueue.shift(); )
          this.inlineTokens(W.src, W.tokens);
        return this.tokens;
      }, de.blockTokens = function(P, W) {
        var ne = this;
        W === void 0 && (W = []), this.options.pedantic ? P = P.replace(/\t/g, "    ").replace(/^ +$/gm, "") : P = P.replace(/^( *)(\t+)/gm, function(ut, ct, yn) {
          return ct + "    ".repeat(yn.length);
        });
        for (var X, Ae, Le, We; P; )
          if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(ut) {
            return (X = ut.call({
              lexer: ne
            }, P, W)) ? (P = P.substring(X.raw.length), W.push(X), !0) : !1;
          }))) {
            if (X = this.tokenizer.space(P)) {
              P = P.substring(X.raw.length), X.raw.length === 1 && W.length > 0 ? W[W.length - 1].raw += `
` : W.push(X);
              continue;
            }
            if (X = this.tokenizer.code(P)) {
              P = P.substring(X.raw.length), Ae = W[W.length - 1], Ae && (Ae.type === "paragraph" || Ae.type === "text") ? (Ae.raw += `
` + X.raw, Ae.text += `
` + X.text, this.inlineQueue[this.inlineQueue.length - 1].src = Ae.text) : W.push(X);
              continue;
            }
            if (X = this.tokenizer.fences(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.heading(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.hr(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.blockquote(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.list(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.html(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.def(P)) {
              P = P.substring(X.raw.length), Ae = W[W.length - 1], Ae && (Ae.type === "paragraph" || Ae.type === "text") ? (Ae.raw += `
` + X.raw, Ae.text += `
` + X.raw, this.inlineQueue[this.inlineQueue.length - 1].src = Ae.text) : this.tokens.links[X.tag] || (this.tokens.links[X.tag] = {
                href: X.href,
                title: X.title
              });
              continue;
            }
            if (X = this.tokenizer.table(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.lheading(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (Le = P, this.options.extensions && this.options.extensions.startBlock && function() {
              var ut = 1 / 0, ct = P.slice(1), yn = void 0;
              ne.options.extensions.startBlock.forEach(function(fn) {
                yn = fn.call({
                  lexer: this
                }, ct), typeof yn == "number" && yn >= 0 && (ut = Math.min(ut, yn));
              }), ut < 1 / 0 && ut >= 0 && (Le = P.substring(0, ut + 1));
            }(), this.state.top && (X = this.tokenizer.paragraph(Le))) {
              Ae = W[W.length - 1], We && Ae.type === "paragraph" ? (Ae.raw += `
` + X.raw, Ae.text += `
` + X.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = Ae.text) : W.push(X), We = Le.length !== P.length, P = P.substring(X.raw.length);
              continue;
            }
            if (X = this.tokenizer.text(P)) {
              P = P.substring(X.raw.length), Ae = W[W.length - 1], Ae && Ae.type === "text" ? (Ae.raw += `
` + X.raw, Ae.text += `
` + X.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = Ae.text) : W.push(X);
              continue;
            }
            if (P) {
              var Ue = "Infinite loop on byte: " + P.charCodeAt(0);
              if (this.options.silent) {
                console.error(Ue);
                break;
              } else
                throw new Error(Ue);
            }
          }
        return this.state.top = !0, W;
      }, de.inline = function(P, W) {
        return W === void 0 && (W = []), this.inlineQueue.push({
          src: P,
          tokens: W
        }), W;
      }, de.inlineTokens = function(P, W) {
        var ne = this;
        W === void 0 && (W = []);
        var X, Ae, Le, We = P, Ue, ut, ct;
        if (this.tokens.links) {
          var yn = Object.keys(this.tokens.links);
          if (yn.length > 0)
            for (; (Ue = this.tokenizer.rules.inline.reflinkSearch.exec(We)) != null; )
              yn.includes(Ue[0].slice(Ue[0].lastIndexOf("[") + 1, -1)) && (We = We.slice(0, Ue.index) + "[" + ce("a", Ue[0].length - 2) + "]" + We.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
        }
        for (; (Ue = this.tokenizer.rules.inline.blockSkip.exec(We)) != null; )
          We = We.slice(0, Ue.index) + "[" + ce("a", Ue[0].length - 2) + "]" + We.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        for (; (Ue = this.tokenizer.rules.inline.escapedEmSt.exec(We)) != null; )
          We = We.slice(0, Ue.index) + "++" + We.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
        for (; P; )
          if (ut || (ct = ""), ut = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(it) {
            return (X = it.call({
              lexer: ne
            }, P, W)) ? (P = P.substring(X.raw.length), W.push(X), !0) : !1;
          }))) {
            if (X = this.tokenizer.escape(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.tag(P)) {
              P = P.substring(X.raw.length), Ae = W[W.length - 1], Ae && X.type === "text" && Ae.type === "text" ? (Ae.raw += X.raw, Ae.text += X.text) : W.push(X);
              continue;
            }
            if (X = this.tokenizer.link(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.reflink(P, this.tokens.links)) {
              P = P.substring(X.raw.length), Ae = W[W.length - 1], Ae && X.type === "text" && Ae.type === "text" ? (Ae.raw += X.raw, Ae.text += X.text) : W.push(X);
              continue;
            }
            if (X = this.tokenizer.emStrong(P, We, ct)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.codespan(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.br(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.del(P)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (X = this.tokenizer.autolink(P, De)) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (!this.state.inLink && (X = this.tokenizer.url(P, De))) {
              P = P.substring(X.raw.length), W.push(X);
              continue;
            }
            if (Le = P, this.options.extensions && this.options.extensions.startInline && function() {
              var it = 1 / 0, ei = P.slice(1), ti = void 0;
              ne.options.extensions.startInline.forEach(function(Ds) {
                ti = Ds.call({
                  lexer: this
                }, ei), typeof ti == "number" && ti >= 0 && (it = Math.min(it, ti));
              }), it < 1 / 0 && it >= 0 && (Le = P.substring(0, it + 1));
            }(), X = this.tokenizer.inlineText(Le, pe)) {
              P = P.substring(X.raw.length), X.raw.slice(-1) !== "_" && (ct = X.raw.slice(-1)), ut = !0, Ae = W[W.length - 1], Ae && Ae.type === "text" ? (Ae.raw += X.raw, Ae.text += X.text) : W.push(X);
              continue;
            }
            if (P) {
              var fn = "Infinite loop on byte: " + P.charCodeAt(0);
              if (this.options.silent) {
                console.error(fn);
                break;
              } else
                throw new Error(fn);
            }
          }
        return W;
      }, n(we, null, [{
        key: "rules",
        get: function() {
          return {
            block: G,
            inline: j
          };
        }
      }]), we;
    }(), F = /* @__PURE__ */ function() {
      function we(he) {
        this.options = he || e.defaults;
      }
      var de = we.prototype;
      return de.code = function(P, W, ne) {
        var X = (W || "").match(/\S*/)[0];
        if (this.options.highlight) {
          var Ae = this.options.highlight(P, X);
          Ae != null && Ae !== P && (ne = !0, P = Ae);
        }
        return P = P.replace(/\n$/, "") + `
`, X ? '<pre><code class="' + this.options.langPrefix + m(X, !0) + '">' + (ne ? P : m(P, !0)) + `</code></pre>
` : "<pre><code>" + (ne ? P : m(P, !0)) + `</code></pre>
`;
      }, de.blockquote = function(P) {
        return `<blockquote>
` + P + `</blockquote>
`;
      }, de.html = function(P) {
        return P;
      }, de.heading = function(P, W, ne, X) {
        if (this.options.headerIds) {
          var Ae = this.options.headerPrefix + X.slug(ne);
          return "<h" + W + ' id="' + Ae + '">' + P + "</h" + W + `>
`;
        }
        return "<h" + W + ">" + P + "</h" + W + `>
`;
      }, de.hr = function() {
        return this.options.xhtml ? `<hr/>
` : `<hr>
`;
      }, de.list = function(P, W, ne) {
        var X = W ? "ol" : "ul", Ae = W && ne !== 1 ? ' start="' + ne + '"' : "";
        return "<" + X + Ae + `>
` + P + "</" + X + `>
`;
      }, de.listitem = function(P) {
        return "<li>" + P + `</li>
`;
      }, de.checkbox = function(P) {
        return "<input " + (P ? 'checked="" ' : "") + 'disabled="" type="checkbox"' + (this.options.xhtml ? " /" : "") + "> ";
      }, de.paragraph = function(P) {
        return "<p>" + P + `</p>
`;
      }, de.table = function(P, W) {
        return W && (W = "<tbody>" + W + "</tbody>"), `<table>
<thead>
` + P + `</thead>
` + W + `</table>
`;
      }, de.tablerow = function(P) {
        return `<tr>
` + P + `</tr>
`;
      }, de.tablecell = function(P, W) {
        var ne = W.header ? "th" : "td", X = W.align ? "<" + ne + ' align="' + W.align + '">' : "<" + ne + ">";
        return X + P + ("</" + ne + `>
`);
      }, de.strong = function(P) {
        return "<strong>" + P + "</strong>";
      }, de.em = function(P) {
        return "<em>" + P + "</em>";
      }, de.codespan = function(P) {
        return "<code>" + P + "</code>";
      }, de.br = function() {
        return this.options.xhtml ? "<br/>" : "<br>";
      }, de.del = function(P) {
        return "<del>" + P + "</del>";
      }, de.link = function(P, W, ne) {
        if (P = D(this.options.sanitize, this.options.baseUrl, P), P === null)
          return ne;
        var X = '<a href="' + m(P) + '"';
        return W && (X += ' title="' + W + '"'), X += ">" + ne + "</a>", X;
      }, de.image = function(P, W, ne) {
        if (P = D(this.options.sanitize, this.options.baseUrl, P), P === null)
          return ne;
        var X = '<img src="' + P + '" alt="' + ne + '"';
        return W && (X += ' title="' + W + '"'), X += this.options.xhtml ? "/>" : ">", X;
      }, de.text = function(P) {
        return P;
      }, we;
    }(), I = /* @__PURE__ */ function() {
      function we() {
      }
      var de = we.prototype;
      return de.strong = function(P) {
        return P;
      }, de.em = function(P) {
        return P;
      }, de.codespan = function(P) {
        return P;
      }, de.del = function(P) {
        return P;
      }, de.html = function(P) {
        return P;
      }, de.text = function(P) {
        return P;
      }, de.link = function(P, W, ne) {
        return "" + ne;
      }, de.image = function(P, W, ne) {
        return "" + ne;
      }, de.br = function() {
        return "";
      }, we;
    }(), O = /* @__PURE__ */ function() {
      function we() {
        this.seen = {};
      }
      var de = we.prototype;
      return de.serialize = function(P) {
        return P.toLowerCase().trim().replace(/<[!\/a-z].*?>/ig, "").replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, "").replace(/\s/g, "-");
      }, de.getNextSafeSlug = function(P, W) {
        var ne = P, X = 0;
        if (this.seen.hasOwnProperty(ne)) {
          X = this.seen[P];
          do
            X++, ne = P + "-" + X;
          while (this.seen.hasOwnProperty(ne));
        }
        return W || (this.seen[P] = X, this.seen[ne] = 0), ne;
      }, de.slug = function(P, W) {
        W === void 0 && (W = {});
        var ne = this.serialize(P);
        return this.getNextSafeSlug(ne, W.dryrun);
      }, we;
    }(), Y = /* @__PURE__ */ function() {
      function we(he) {
        this.options = he || e.defaults, this.options.renderer = this.options.renderer || new F(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new I(), this.slugger = new O();
      }
      we.parse = function(P, W) {
        var ne = new we(W);
        return ne.parse(P);
      }, we.parseInline = function(P, W) {
        var ne = new we(W);
        return ne.parseInline(P);
      };
      var de = we.prototype;
      return de.parse = function(P, W) {
        W === void 0 && (W = !0);
        var ne = "", X, Ae, Le, We, Ue, ut, ct, yn, fn, it, ei, ti, Ds, Gt, Yn, El, _l, mo, Ec, _c = P.length;
        for (X = 0; X < _c; X++) {
          if (it = P[X], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[it.type] && (Ec = this.options.extensions.renderers[it.type].call({
            parser: this
          }, it), Ec !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(it.type))) {
            ne += Ec || "";
            continue;
          }
          switch (it.type) {
            case "space":
              continue;
            case "hr": {
              ne += this.renderer.hr();
              continue;
            }
            case "heading": {
              ne += this.renderer.heading(this.parseInline(it.tokens), it.depth, w(this.parseInline(it.tokens, this.textRenderer)), this.slugger);
              continue;
            }
            case "code": {
              ne += this.renderer.code(it.text, it.lang, it.escaped);
              continue;
            }
            case "table": {
              for (yn = "", ct = "", We = it.header.length, Ae = 0; Ae < We; Ae++)
                ct += this.renderer.tablecell(this.parseInline(it.header[Ae].tokens), {
                  header: !0,
                  align: it.align[Ae]
                });
              for (yn += this.renderer.tablerow(ct), fn = "", We = it.rows.length, Ae = 0; Ae < We; Ae++) {
                for (ut = it.rows[Ae], ct = "", Ue = ut.length, Le = 0; Le < Ue; Le++)
                  ct += this.renderer.tablecell(this.parseInline(ut[Le].tokens), {
                    header: !1,
                    align: it.align[Le]
                  });
                fn += this.renderer.tablerow(ct);
              }
              ne += this.renderer.table(yn, fn);
              continue;
            }
            case "blockquote": {
              fn = this.parse(it.tokens), ne += this.renderer.blockquote(fn);
              continue;
            }
            case "list": {
              for (ei = it.ordered, ti = it.start, Ds = it.loose, We = it.items.length, fn = "", Ae = 0; Ae < We; Ae++)
                Yn = it.items[Ae], El = Yn.checked, _l = Yn.task, Gt = "", Yn.task && (mo = this.renderer.checkbox(El), Ds ? Yn.tokens.length > 0 && Yn.tokens[0].type === "paragraph" ? (Yn.tokens[0].text = mo + " " + Yn.tokens[0].text, Yn.tokens[0].tokens && Yn.tokens[0].tokens.length > 0 && Yn.tokens[0].tokens[0].type === "text" && (Yn.tokens[0].tokens[0].text = mo + " " + Yn.tokens[0].tokens[0].text)) : Yn.tokens.unshift({
                  type: "text",
                  text: mo
                }) : Gt += mo), Gt += this.parse(Yn.tokens, Ds), fn += this.renderer.listitem(Gt, _l, El);
              ne += this.renderer.list(fn, ei, ti);
              continue;
            }
            case "html": {
              ne += this.renderer.html(it.text);
              continue;
            }
            case "paragraph": {
              ne += this.renderer.paragraph(this.parseInline(it.tokens));
              continue;
            }
            case "text": {
              for (fn = it.tokens ? this.parseInline(it.tokens) : it.text; X + 1 < _c && P[X + 1].type === "text"; )
                it = P[++X], fn += `
` + (it.tokens ? this.parseInline(it.tokens) : it.text);
              ne += W ? this.renderer.paragraph(fn) : fn;
              continue;
            }
            default: {
              var Oh = 'Token with "' + it.type + '" type was not found.';
              if (this.options.silent) {
                console.error(Oh);
                return;
              } else
                throw new Error(Oh);
            }
          }
        }
        return ne;
      }, de.parseInline = function(P, W) {
        W = W || this.renderer;
        var ne = "", X, Ae, Le, We = P.length;
        for (X = 0; X < We; X++) {
          if (Ae = P[X], this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[Ae.type] && (Le = this.options.extensions.renderers[Ae.type].call({
            parser: this
          }, Ae), Le !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(Ae.type))) {
            ne += Le || "";
            continue;
          }
          switch (Ae.type) {
            case "escape": {
              ne += W.text(Ae.text);
              break;
            }
            case "html": {
              ne += W.html(Ae.text);
              break;
            }
            case "link": {
              ne += W.link(Ae.href, Ae.title, this.parseInline(Ae.tokens, W));
              break;
            }
            case "image": {
              ne += W.image(Ae.href, Ae.title, Ae.text);
              break;
            }
            case "strong": {
              ne += W.strong(this.parseInline(Ae.tokens, W));
              break;
            }
            case "em": {
              ne += W.em(this.parseInline(Ae.tokens, W));
              break;
            }
            case "codespan": {
              ne += W.codespan(Ae.text);
              break;
            }
            case "br": {
              ne += W.br();
              break;
            }
            case "del": {
              ne += W.del(this.parseInline(Ae.tokens, W));
              break;
            }
            case "text": {
              ne += W.text(Ae.text);
              break;
            }
            default: {
              var Ue = 'Token with "' + Ae.type + '" type was not found.';
              if (this.options.silent) {
                console.error(Ue);
                return;
              } else
                throw new Error(Ue);
            }
          }
        }
        return ne;
      }, we;
    }();
    function K(we, de, he) {
      if (typeof we > "u" || we === null)
        throw new Error("marked(): input parameter is undefined or null");
      if (typeof we != "string")
        throw new Error("marked(): input parameter is of type " + Object.prototype.toString.call(we) + ", string expected");
      if (typeof de == "function" && (he = de, de = null), de = R({}, K.defaults, de || {}), ee(de), he) {
        var P = de.highlight, W;
        try {
          W = Ce.lex(we, de);
        } catch (We) {
          return he(We);
        }
        var ne = function(Ue) {
          var ut;
          if (!Ue)
            try {
              de.walkTokens && K.walkTokens(W, de.walkTokens), ut = Y.parse(W, de);
            } catch (ct) {
              Ue = ct;
            }
          return de.highlight = P, Ue ? he(Ue) : he(null, ut);
        };
        if (!P || P.length < 3 || (delete de.highlight, !W.length)) return ne();
        var X = 0;
        K.walkTokens(W, function(We) {
          We.type === "code" && (X++, setTimeout(function() {
            P(We.text, We.lang, function(Ue, ut) {
              if (Ue)
                return ne(Ue);
              ut != null && ut !== We.text && (We.text = ut, We.escaped = !0), X--, X === 0 && ne();
            });
          }, 0));
        }), X === 0 && ne();
        return;
      }
      function Ae(We) {
        if (We.message += `
Please report this to https://github.com/markedjs/marked.`, de.silent)
          return "<p>An error occurred:</p><pre>" + m(We.message + "", !0) + "</pre>";
        throw We;
      }
      try {
        var Le = Ce.lex(we, de);
        if (de.walkTokens) {
          if (de.async)
            return Promise.all(K.walkTokens(Le, de.walkTokens)).then(function() {
              return Y.parse(Le, de);
            }).catch(Ae);
          K.walkTokens(Le, de.walkTokens);
        }
        return Y.parse(Le, de);
      } catch (We) {
        Ae(We);
      }
    }
    K.options = K.setOptions = function(we) {
      return R(K.defaults, we), l(K.defaults), K;
    }, K.getDefaults = a, K.defaults = e.defaults, K.use = function() {
      for (var we = arguments.length, de = new Array(we), he = 0; he < we; he++)
        de[he] = arguments[he];
      var P = R.apply(void 0, [{}].concat(de)), W = K.defaults.extensions || {
        renderers: {},
        childTokens: {}
      }, ne;
      de.forEach(function(X) {
        if (X.extensions && (ne = !0, X.extensions.forEach(function(Le) {
          if (!Le.name)
            throw new Error("extension name required");
          if (Le.renderer) {
            var We = W.renderers ? W.renderers[Le.name] : null;
            We ? W.renderers[Le.name] = function() {
              for (var Ue = arguments.length, ut = new Array(Ue), ct = 0; ct < Ue; ct++)
                ut[ct] = arguments[ct];
              var yn = Le.renderer.apply(this, ut);
              return yn === !1 && (yn = We.apply(this, ut)), yn;
            } : W.renderers[Le.name] = Le.renderer;
          }
          if (Le.tokenizer) {
            if (!Le.level || Le.level !== "block" && Le.level !== "inline")
              throw new Error("extension level must be 'block' or 'inline'");
            W[Le.level] ? W[Le.level].unshift(Le.tokenizer) : W[Le.level] = [Le.tokenizer], Le.start && (Le.level === "block" ? W.startBlock ? W.startBlock.push(Le.start) : W.startBlock = [Le.start] : Le.level === "inline" && (W.startInline ? W.startInline.push(Le.start) : W.startInline = [Le.start]));
          }
          Le.childTokens && (W.childTokens[Le.name] = Le.childTokens);
        })), X.renderer && function() {
          var Le = K.defaults.renderer || new F(), We = function(ct) {
            var yn = Le[ct];
            Le[ct] = function() {
              for (var fn = arguments.length, it = new Array(fn), ei = 0; ei < fn; ei++)
                it[ei] = arguments[ei];
              var ti = X.renderer[ct].apply(Le, it);
              return ti === !1 && (ti = yn.apply(Le, it)), ti;
            };
          };
          for (var Ue in X.renderer)
            We(Ue);
          P.renderer = Le;
        }(), X.tokenizer && function() {
          var Le = K.defaults.tokenizer || new ue(), We = function(ct) {
            var yn = Le[ct];
            Le[ct] = function() {
              for (var fn = arguments.length, it = new Array(fn), ei = 0; ei < fn; ei++)
                it[ei] = arguments[ei];
              var ti = X.tokenizer[ct].apply(Le, it);
              return ti === !1 && (ti = yn.apply(Le, it)), ti;
            };
          };
          for (var Ue in X.tokenizer)
            We(Ue);
          P.tokenizer = Le;
        }(), X.walkTokens) {
          var Ae = K.defaults.walkTokens;
          P.walkTokens = function(Le) {
            var We = [];
            return We.push(X.walkTokens.call(this, Le)), Ae && (We = We.concat(Ae.call(this, Le))), We;
          };
        }
        ne && (P.extensions = W), K.setOptions(P);
      });
    }, K.walkTokens = function(we, de) {
      for (var he = [], P = function() {
        var Ae = ne.value;
        switch (he = he.concat(de.call(K, Ae)), Ae.type) {
          case "table": {
            for (var Le = o(Ae.header), We; !(We = Le()).done; ) {
              var Ue = We.value;
              he = he.concat(K.walkTokens(Ue.tokens, de));
            }
            for (var ut = o(Ae.rows), ct; !(ct = ut()).done; )
              for (var yn = ct.value, fn = o(yn), it; !(it = fn()).done; ) {
                var ei = it.value;
                he = he.concat(K.walkTokens(ei.tokens, de));
              }
            break;
          }
          case "list": {
            he = he.concat(K.walkTokens(Ae.items, de));
            break;
          }
          default:
            K.defaults.extensions && K.defaults.extensions.childTokens && K.defaults.extensions.childTokens[Ae.type] ? K.defaults.extensions.childTokens[Ae.type].forEach(function(ti) {
              he = he.concat(K.walkTokens(Ae[ti], de));
            }) : Ae.tokens && (he = he.concat(K.walkTokens(Ae.tokens, de)));
        }
      }, W = o(we), ne; !(ne = W()).done; )
        P();
      return he;
    }, K.parseInline = function(we, de) {
      if (typeof we > "u" || we === null)
        throw new Error("marked.parseInline(): input parameter is undefined or null");
      if (typeof we != "string")
        throw new Error("marked.parseInline(): input parameter is of type " + Object.prototype.toString.call(we) + ", string expected");
      de = R({}, K.defaults, de || {}), ee(de);
      try {
        var he = Ce.lexInline(we, de);
        return de.walkTokens && K.walkTokens(he, de.walkTokens), Y.parseInline(he, de);
      } catch (P) {
        if (P.message += `
Please report this to https://github.com/markedjs/marked.`, de.silent)
          return "<p>An error occurred:</p><pre>" + m(P.message + "", !0) + "</pre>";
        throw P;
      }
    }, K.Parser = Y, K.parser = Y.parse, K.Renderer = F, K.TextRenderer = I, K.Lexer = Ce, K.lexer = Ce.lex, K.Tokenizer = ue, K.Slugger = O, K.parse = K;
    var ae = K.options, Oe = K.setOptions, ot = K.use, It = K.walkTokens, Mn = K.parseInline, Ii = K, os = Y.parse, Cc = Ce.lex;
    e.Lexer = Ce, e.Parser = Y, e.Renderer = F, e.Slugger = O, e.TextRenderer = I, e.Tokenizer = ue, e.getDefaults = a, e.lexer = Cc, e.marked = K, e.options = ae, e.parse = Ii, e.parseInline = Mn, e.parser = os, e.setOptions = Oe, e.use = ot, e.walkTokens = It, Object.defineProperty(e, "__esModule", { value: !0 });
  });
})();
Ss.Lexer || exports.Lexer;
Ss.Parser || exports.Parser;
Ss.Renderer || exports.Renderer;
Ss.Slugger || exports.Slugger;
Ss.TextRenderer || exports.TextRenderer;
Ss.Tokenizer || exports.Tokenizer;
Ss.getDefaults || exports.getDefaults;
Ss.lexer || exports.lexer;
var Pl = Ss.marked || exports.marked;
Ss.options || exports.options;
Ss.parse || exports.parse;
Ss.parseInline || exports.parseInline;
Ss.parser || exports.parser;
Ss.setOptions || exports.setOptions;
Ss.use || exports.use;
Ss.walkTokens || exports.walkTokens;
function v9t(r) {
  return JSON.stringify(r, b9t);
}
function QL(r) {
  let e = JSON.parse(r);
  return e = KL(e), e;
}
function b9t(r, e) {
  return e instanceof RegExp ? {
    $mid: 2,
    source: e.source,
    flags: e.flags
  } : e;
}
function KL(r, e = 0) {
  if (!r || e > 200)
    return r;
  if (typeof r == "object") {
    switch (r.$mid) {
      case 1:
        return Pt.revive(r);
      case 2:
        return new RegExp(r.source, r.flags);
      case 17:
        return new Date(r.source);
    }
    if (r instanceof sO || r instanceof Uint8Array)
      return r;
    if (Array.isArray(r))
      for (let t = 0; t < r.length; ++t)
        r[t] = KL(r[t], e + 1);
    else
      for (const t in r)
        Object.hasOwnProperty.call(r, t) && (r[t] = KL(r[t], e + 1));
  }
  return r;
}
const A_ = Object.freeze({
  image: (r, e, t) => {
    let n = [], i = [];
    return r && ({ href: r, dimensions: n } = w9t(r), i.push(`src="${Jv(r)}"`)), t && i.push(`alt="${Jv(t)}"`), e && i.push(`title="${Jv(e)}"`), n.length && (i = i.concat(n)), "<img " + i.join(" ") + ">";
  },
  paragraph: (r) => `<p>${r}</p>`,
  link: (r, e, t) => typeof r != "string" ? "" : (r === t && (t = m_(t)), e = typeof e == "string" ? Jv(m_(e)) : "", r = m_(r), r = r.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"), `<a href="${r}" title="${e || r}" draggable="false">${t}</a>`)
});
function dR(r, e = {}, t = {}) {
  const n = new ze();
  let i = !1;
  const s = oR(e), o = function(m) {
    let A;
    try {
      A = QL(decodeURIComponent(m));
    } catch {
    }
    return A ? (A = LMe(A, (w) => {
      if (r.uris && r.uris[w])
        return Pt.revive(r.uris[w]);
    }), encodeURIComponent(JSON.stringify(A))) : m;
  }, a = function(m, A) {
    const w = r.uris && r.uris[m];
    let v = Pt.revive(w);
    return A ? m.startsWith(Ct.data + ":") ? m : (v || (v = Pt.parse(m)), EDe.uriToBrowserUri(v).toString(!0)) : !v || Pt.parse(m).toString() === v.toString() ? m : (v.query && (v = v.with({ query: o(v.query) })), v.toString());
  }, l = new Pl.Renderer();
  l.image = A_.image, l.link = A_.link, l.paragraph = A_.paragraph;
  const c = [], d = [];
  if (e.codeBlockRendererSync ? l.code = (m, A) => {
    const w = R8e.nextId(), v = e.codeBlockRendererSync(V8e(A), m);
    return d.push([w, v]), `<div class="code" data-code="${w}">${VA(m)}</div>`;
  } : e.codeBlockRenderer && (l.code = (m, A) => {
    const w = R8e.nextId(), v = e.codeBlockRenderer(V8e(A), m);
    return c.push(v.then((y) => [w, y])), `<div class="code" data-code="${w}">${VA(m)}</div>`;
  }), e.actionHandler) {
    const m = function(v) {
      let y = v.target;
      if (!(y.tagName !== "A" && (y = y.parentElement, !y || y.tagName !== "A")))
        try {
          let _ = y.dataset.href;
          _ && (r.baseUri && (_ = w_(Pt.from(r.baseUri), _)), e.actionHandler.callback(_, v));
        } catch (_) {
          wn(_);
        } finally {
          v.preventDefault();
        }
    }, A = e.actionHandler.disposables.add(new St(s, "click")), w = e.actionHandler.disposables.add(new St(s, "auxclick"));
    e.actionHandler.disposables.add(xe.any(A.event, w.event)((v) => {
      const y = new zl(qe(s), v);
      !y.leftButton && !y.middleButton || m(y);
    })), e.actionHandler.disposables.add(fe(s, "keydown", (v) => {
      const y = new zn(v);
      !y.equals(
        10
        /* KeyCode.Space */
      ) && !y.equals(
        3
        /* KeyCode.Enter */
      ) || m(y);
    }));
  }
  r.supportHtml || (t.sanitizer = (m) => e.sanitizerOptions?.replaceWithPlaintext ? VA(m) : (r.isTrusted ? m.match(/^(<span[^>]+>)|(<\/\s*span>)$/) : void 0) ? m : "", t.sanitize = !0, t.silent = !0), t.renderer = l;
  let u = r.value ?? "";
  u.length > 1e5 && (u = `${u.substr(0, 1e5)}…`), r.supportThemeIcons && (u = u9t(u));
  let f;
  if (e.fillInIncompleteTokens) {
    const m = {
      ...Pl.defaults,
      ...t
    }, A = Pl.lexer(u, m), w = I9t(A);
    f = Pl.parser(w, m);
  } else
    f = Pl.parse(u, t);
  r.supportThemeIcons && (f = X0(f).map((A) => typeof A == "string" ? A : A.outerHTML).join(""));
  const g = new DOMParser().parseFromString(YL({ isTrusted: r.isTrusted, ...e.sanitizerOptions }, f), "text/html");
  if (g.body.querySelectorAll("img, audio, video, source").forEach((m) => {
    const A = m.getAttribute("src");
    if (A) {
      let w = A;
      try {
        r.baseUri && (w = w_(Pt.from(r.baseUri), w));
      } catch {
      }
      if (m.setAttribute("src", a(w, !0)), e.remoteImageIsAllowed) {
        const v = Pt.parse(w);
        v.scheme !== Ct.file && v.scheme !== Ct.data && !e.remoteImageIsAllowed(v) && m.replaceWith($e("", void 0, m.outerHTML));
      }
    }
  }), g.body.querySelectorAll("a").forEach((m) => {
    const A = m.getAttribute("href");
    if (m.setAttribute("href", ""), !A || /^data:|javascript:/i.test(A) || /^command:/i.test(A) && !r.isTrusted || /^command:(\/\/\/)?_workbench\.downloadResource/i.test(A))
      m.replaceWith(...m.childNodes);
    else {
      let w = a(A, !1);
      r.baseUri && (w = w_(Pt.from(r.baseUri), A)), m.dataset.href = w;
    }
  }), s.innerHTML = YL({ isTrusted: r.isTrusted, ...e.sanitizerOptions }, g.body.innerHTML), c.length > 0)
    Promise.all(c).then((m) => {
      if (i)
        return;
      const A = new Map(m), w = s.querySelectorAll("div[data-code]");
      for (const v of w) {
        const y = A.get(v.dataset.code ?? "");
        y && ys(v, y);
      }
      e.asyncRenderCallback?.();
    });
  else if (d.length > 0) {
    const m = new Map(d), A = s.querySelectorAll("div[data-code]");
    for (const w of A) {
      const v = m.get(w.dataset.code ?? "");
      v && ys(w, v);
    }
  }
  if (e.asyncRenderCallback)
    for (const m of s.getElementsByTagName("img")) {
      const A = n.add(fe(m, "load", () => {
        A.dispose(), e.asyncRenderCallback();
      }));
    }
  return {
    element: s,
    dispose: () => {
      i = !0, n.dispose();
    }
  };
}
function V8e(r) {
  if (!r)
    return "";
  const e = r.split(/[\s+|:|,|\{|\?]/, 1);
  return e.length ? e[0] : r;
}
function w_(r, e) {
  return /^\w[\w\d+.-]*:/.test(e) ? e : r.path.endsWith("/") ? Z6e(r, e).toString() : Z6e(Jvt(r), e).toString();
}
const y9t = ["area", "base", "br", "col", "command", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"];
function YL(r, e) {
  const { config: t, allowedSchemes: n } = E9t(r), i = new ze();
  i.add(H8e("uponSanitizeAttribute", (s, o) => {
    if (o.attrName === "style" || o.attrName === "class") {
      if (s.tagName === "SPAN") {
        if (o.attrName === "style") {
          o.keepAttr = /^(color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(background-color\:(#[0-9a-fA-F]+|var\(--vscode(-[a-zA-Z]+)+\));)?(border-radius:[0-9]+px;)?$/.test(o.attrValue);
          return;
        } else if (o.attrName === "class") {
          o.keepAttr = /^codicon codicon-[a-z\-]+( codicon-modifier-[a-z\-]+)?$/.test(o.attrValue);
          return;
        }
      }
      o.keepAttr = !1;
      return;
    } else if (s.tagName === "INPUT" && s.attributes.getNamedItem("type")?.value === "checkbox") {
      if (o.attrName === "type" && o.attrValue === "checkbox" || o.attrName === "disabled" || o.attrName === "checked") {
        o.keepAttr = !0;
        return;
      }
      o.keepAttr = !1;
    }
  })), i.add(H8e("uponSanitizeElement", (s, o) => {
    if (o.tagName === "input" && (s.attributes.getNamedItem("type")?.value === "checkbox" ? s.setAttribute("disabled", "") : r.replaceWithPlaintext || s.remove()), r.replaceWithPlaintext && !o.allowedTags[o.tagName] && o.tagName !== "body" && s.parentElement) {
      let a, l;
      if (o.tagName === "#comment")
        a = `<!--${s.textContent}-->`;
      else {
        const f = y9t.includes(o.tagName), p = s.attributes.length ? " " + Array.from(s.attributes).map((g) => `${g.name}="${g.value}"`).join(" ") : "";
        a = `<${o.tagName}${p}>`, f || (l = `</${o.tagName}>`);
      }
      const c = document.createDocumentFragment(), d = s.parentElement.ownerDocument.createTextNode(a);
      c.appendChild(d);
      const u = l ? s.parentElement.ownerDocument.createTextNode(l) : void 0;
      for (; s.firstChild; )
        c.appendChild(s.firstChild);
      u && c.appendChild(u), s.parentElement.replaceChild(c, s);
    }
  })), i.add(jft(n));
  try {
    return vDe(e, { ...t, RETURN_TRUSTED_TYPE: !0 });
  } finally {
    i.dispose();
  }
}
const C9t = [
  "align",
  "autoplay",
  "alt",
  "checked",
  "class",
  "colspan",
  "controls",
  "data-code",
  "data-href",
  "disabled",
  "draggable",
  "height",
  "href",
  "loop",
  "muted",
  "playsinline",
  "poster",
  "rowspan",
  "src",
  "style",
  "target",
  "title",
  "type",
  "width",
  "start"
];
function E9t(r) {
  const e = [
    Ct.http,
    Ct.https,
    Ct.mailto,
    Ct.data,
    Ct.file,
    Ct.vscodeFileResource,
    Ct.vscodeRemote,
    Ct.vscodeRemoteResource
  ];
  return r.isTrusted && e.push(Ct.command), {
    config: {
      // allowedTags should included everything that markdown renders to.
      // Since we have our own sanitize function for marked, it's possible we missed some tag so let dompurify make sure.
      // HTML tags that can result from markdown are from reading https://spec.commonmark.org/0.29/
      // HTML table tags that can result from markdown are from https://github.github.com/gfm/#tables-extension-
      ALLOWED_TAGS: r.allowedTags ?? [...Zft],
      ALLOWED_ATTR: C9t,
      ALLOW_UNKNOWN_PROTOCOLS: !0
    },
    allowedSchemes: e
  };
}
function _9t(r) {
  return typeof r == "string" ? r : x9t(r);
}
function x9t(r, e) {
  let t = r.value ?? "";
  t.length > 1e5 && (t = `${t.substr(0, 1e5)}…`);
  const n = Pl.parse(t, { renderer: D9t.value }).replace(/&(#\d+|[a-zA-Z]+);/g, (i) => S9t.get(i) ?? i);
  return YL({ isTrusted: !1 }, n).toString();
}
const S9t = /* @__PURE__ */ new Map([
  ["&quot;", '"'],
  ["&nbsp;", " "],
  ["&amp;", "&"],
  ["&#39;", "'"],
  ["&lt;", "<"],
  ["&gt;", ">"]
]);
function M9t() {
  const r = new Pl.Renderer();
  return r.code = (e) => e, r.blockquote = (e) => e, r.html = (e) => "", r.heading = (e, t, n) => e + `
`, r.hr = () => "", r.list = (e, t) => e, r.listitem = (e) => e + `
`, r.paragraph = (e) => e + `
`, r.table = (e, t) => e + t + `
`, r.tablerow = (e) => e, r.tablecell = (e, t) => e + " ", r.strong = (e) => e, r.em = (e) => e, r.codespan = (e) => e, r.br = () => `
`, r.del = (e) => e, r.image = (e, t, n) => "", r.text = (e) => e, r.link = (e, t, n) => n, r;
}
const D9t = new o1((r) => M9t());
function o4(r) {
  let e = "";
  return r.forEach((t) => {
    e += t.raw;
  }), e;
}
function ANe(r) {
  if (r.tokens)
    for (let e = r.tokens.length - 1; e >= 0; e--) {
      const t = r.tokens[e];
      if (t.type === "text") {
        const n = t.raw.split(`
`), i = n[n.length - 1];
        if (i.includes("`"))
          return V9t(r);
        if (i.includes("**"))
          return W9t(r);
        if (i.match(/\*\w/))
          return H9t(r);
        if (i.match(/(^|\s)__\w/))
          return j9t(r);
        if (i.match(/(^|\s)_\w/))
          return B9t(r);
        if (
          // Text with start of link target
          L9t(i) || // This token doesn't have the link text, eg if it contains other markdown constructs that are in other subtokens.
          // But some preceding token does have an unbalanced [ at least
          k9t(i) && r.tokens.slice(0, e).some((s) => s.type === "text" && s.raw.match(/\[[^\]]*$/))
        ) {
          const s = r.tokens.slice(e + 1);
          return (
            // If the link was parsed as a link, then look for a link token and a text token with a quote
            s[0]?.type === "link" && s[1]?.type === "text" && s[1].raw.match(/^ *"[^"]*$/) || // And if the link was not parsed as a link (eg command link), just look for a single quote in this token
            i.match(/^[^"]* +"[^"]*$/) ? F9t(r) : P9t(r)
          );
        } else if (i.match(/(^|\s)\[\w*/))
          return z9t(r);
      }
    }
}
function L9t(r) {
  return !!r.match(/(^|\s)\[.*\]\(\w*/);
}
function k9t(r) {
  return !!r.match(/^[^\[]*\]\([^\)]*$/);
}
function N9t(r) {
  const e = r.items[r.items.length - 1], t = e.tokens ? e.tokens[e.tokens.length - 1] : void 0;
  let n;
  if (t?.type === "text" && !("inRawBlock" in e) && (n = ANe(t)), !n || n.type !== "paragraph")
    return;
  const i = o4(r.items.slice(0, -1)), s = e.raw.match(/^(\s*(-|\d+\.|\*) +)/)?.[0];
  if (!s)
    return;
  const o = s + o4(e.tokens.slice(0, -1)) + n.raw, a = Pl.lexer(i + o)[0];
  if (a.type === "list")
    return a;
}
const T9t = 3;
function I9t(r) {
  for (let e = 0; e < T9t; e++) {
    const t = O9t(r);
    if (t)
      r = t;
    else
      break;
  }
  return r;
}
function O9t(r) {
  let e, t;
  for (e = 0; e < r.length; e++) {
    const n = r[e];
    let i;
    if (n.type === "paragraph" && (i = n.raw.match(/(\n|^)(````*)/))) {
      const s = i[2];
      t = R9t(r.slice(e), s);
      break;
    }
    if (n.type === "paragraph" && n.raw.match(/(\n|^)\|/)) {
      t = Z9t(r.slice(e));
      break;
    }
    if (e === r.length - 1 && n.type === "list") {
      const s = N9t(n);
      if (s) {
        t = [s];
        break;
      }
    }
    if (e === r.length - 1 && n.type === "paragraph") {
      const s = ANe(n);
      if (s) {
        t = [s];
        break;
      }
    }
  }
  if (t) {
    const n = [
      ...r.slice(0, e),
      ...t
    ];
    return n.links = r.links, n;
  }
  return null;
}
function R9t(r, e) {
  const t = o4(r);
  return Pl.lexer(t + `
${e}`);
}
function V9t(r) {
  return V1(r, "`");
}
function H9t(r) {
  return V1(r, "*");
}
function B9t(r) {
  return V1(r, "_");
}
function P9t(r) {
  return V1(r, ")");
}
function F9t(r) {
  return V1(r, '")');
}
function z9t(r) {
  return V1(r, "](https://microsoft.com)");
}
function W9t(r) {
  return V1(r, "**");
}
function j9t(r) {
  return V1(r, "__");
}
function V1(r, e) {
  const t = o4(Array.isArray(r) ? r : [r]);
  return Pl.lexer(t + e)[0];
}
function Z9t(r) {
  const e = o4(r), t = e.split(`
`);
  let n, i = !1;
  for (let s = 0; s < t.length; s++) {
    const o = t[s].trim();
    if (typeof n > "u" && o.match(/^\s*\|/)) {
      const a = o.match(/(\|[^\|]+)(?=\||$)/g);
      a && (n = a.length);
    } else if (typeof n == "number")
      if (o.match(/^\s*\|/)) {
        if (s !== t.length - 1)
          return;
        i = !0;
      } else
        return;
  }
  if (typeof n == "number" && n > 0) {
    const s = i ? t.slice(0, -1).join(`
`) : e, o = !!s.match(/\|\s*$/), a = s + (o ? "" : "|") + `
|${" --- |".repeat(n)}`;
    return Pl.lexer(a);
  }
}
function H8e(r, e) {
  return bDe(r, e), ht(() => yDe(r));
}
var U9t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, B8e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, XL;
let JL = class {
  static {
    XL = this;
  }
  static {
    this._ttpTokenizer = Jf("tokenizeToString", {
      createHTML(e) {
        return e;
      }
    });
  }
  constructor(e, t, n) {
    this._options = e, this._languageService = t, this._openerService = n, this._onDidRenderAsync = new $(), this.onDidRenderAsync = this._onDidRenderAsync.event;
  }
  dispose() {
    this._onDidRenderAsync.dispose();
  }
  render(e, t, n) {
    if (!e)
      return { element: document.createElement("span"), dispose: () => {
      } };
    const i = new ze(), s = i.add(dR(e, { ...this._getRenderOptions(e, i), ...t }, n));
    return s.element.classList.add("rendered-markdown"), {
      element: s.element,
      dispose: () => i.dispose()
    };
  }
  _getRenderOptions(e, t) {
    return {
      codeBlockRenderer: async (n, i) => {
        let s;
        n ? s = this._languageService.getLanguageIdByLanguageName(n) : this._options.editor && (s = this._options.editor.getModel()?.getLanguageId()), s || (s = ll);
        const o = await y6t(this._languageService, i, s), a = document.createElement("span");
        if (a.innerHTML = XL._ttpTokenizer?.createHTML(o) ?? o, this._options.editor) {
          const l = this._options.editor.getOption(
            50
            /* EditorOption.fontInfo */
          );
          Br(a, l);
        } else this._options.codeBlockFontFamily && (a.style.fontFamily = this._options.codeBlockFontFamily);
        return this._options.codeBlockFontSize !== void 0 && (a.style.fontSize = this._options.codeBlockFontSize), a;
      },
      asyncRenderCallback: () => this._onDidRenderAsync.fire(),
      actionHandler: {
        callback: (n) => wNe(this._openerService, n, e.isTrusted),
        disposables: t
      }
    };
  }
};
JL = XL = U9t([
  B8e(1, sr),
  B8e(2, Tw)
], JL);
async function wNe(r, e, t) {
  try {
    return await r.open(e, {
      fromUserGesture: !0,
      allowContributedOpeners: !0,
      allowCommands: q9t(t)
    });
  } catch (n) {
    return wn(n), !1;
  }
}
function q9t(r) {
  return r === !0 ? !0 : r && Array.isArray(r.enabledCommands) ? r.enabledCommands : !1;
}
var G9t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Wm = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const Mc = $e;
let $L = class extends xa {
  get _targetWindow() {
    return qe(this._target.targetElements[0]);
  }
  get _targetDocumentElement() {
    return qe(this._target.targetElements[0]).document.documentElement;
  }
  get isDisposed() {
    return this._isDisposed;
  }
  get isMouseIn() {
    return this._lockMouseTracker.isMouseIn;
  }
  get domNode() {
    return this._hover.containerDomNode;
  }
  get onDispose() {
    return this._onDispose.event;
  }
  get onRequestLayout() {
    return this._onRequestLayout.event;
  }
  get anchor() {
    return this._hoverPosition === 2 ? 0 : 1;
  }
  get x() {
    return this._x;
  }
  get y() {
    return this._y;
  }
  /**
   * Whether the hover is "locked" by holding the alt/option key. When locked, the hover will not
   * hide and can be hovered regardless of whether the `hideOnHover` hover option is set.
   */
  get isLocked() {
    return this._isLocked;
  }
  set isLocked(e) {
    this._isLocked !== e && (this._isLocked = e, this._hoverContainer.classList.toggle("locked", this._isLocked));
  }
  constructor(e, t, n, i, s, o) {
    super(), this._keybindingService = t, this._configurationService = n, this._openerService = i, this._instantiationService = s, this._accessibilityService = o, this._messageListeners = new ze(), this._isDisposed = !1, this._forcePosition = !1, this._x = 0, this._y = 0, this._isLocked = !1, this._enableFocusTraps = !1, this._addedFocusTrap = !1, this._onDispose = this._register(new $()), this._onRequestLayout = this._register(new $()), this._linkHandler = e.linkHandler || ((f) => wNe(this._openerService, f, Np(e.content) ? e.content.isTrusted : void 0)), this._target = "targetElements" in e.target ? e.target : new Q9t(e.target), this._hoverPointer = e.appearance?.showPointer ? Mc("div.workbench-hover-pointer") : void 0, this._hover = this._register(new R8t()), this._hover.containerDomNode.classList.add("workbench-hover", "fadeIn"), e.appearance?.compact && this._hover.containerDomNode.classList.add("workbench-hover", "compact"), e.appearance?.skipFadeInAnimation && this._hover.containerDomNode.classList.add("skip-fade-in"), e.additionalClasses && this._hover.containerDomNode.classList.add(...e.additionalClasses), e.position?.forcePosition && (this._forcePosition = !0), e.trapFocus && (this._enableFocusTraps = !0), this._hoverPosition = e.position?.hoverPosition ?? 3, this.onmousedown(this._hover.containerDomNode, (f) => f.stopPropagation()), this.onkeydown(this._hover.containerDomNode, (f) => {
      f.equals(
        9
        /* KeyCode.Escape */
      ) && this.dispose();
    }), this._register(fe(this._targetWindow, "blur", () => this.dispose()));
    const a = Mc("div.hover-row.markdown-hover"), l = Mc("div.hover-contents");
    if (typeof e.content == "string")
      l.textContent = e.content, l.style.whiteSpace = "pre-wrap";
    else if (wr(e.content))
      l.appendChild(e.content), l.classList.add("html-hover-contents");
    else {
      const f = e.content, p = this._instantiationService.createInstance(JL, { codeBlockFontFamily: this._configurationService.getValue("editor").fontFamily || Bo.fontFamily }), { element: g } = p.render(f, {
        actionHandler: {
          callback: (m) => this._linkHandler(m),
          disposables: this._messageListeners
        },
        asyncRenderCallback: () => {
          l.classList.add("code-hover-contents"), this.layout(), this._onRequestLayout.fire();
        }
      });
      l.appendChild(g);
    }
    if (a.appendChild(l), this._hover.contentsDomNode.appendChild(a), e.actions && e.actions.length > 0) {
      const f = Mc("div.hover-row.status-bar"), p = Mc("div.actions");
      e.actions.forEach((g) => {
        const m = this._keybindingService.lookupKeybinding(g.commandId), A = m ? m.getLabel() : null;
        sR.render(p, {
          label: g.label,
          commandId: g.commandId,
          run: (w) => {
            g.run(w), this.dispose();
          },
          iconClass: g.iconClass
        }, A);
      }), f.appendChild(p), this._hover.containerDomNode.appendChild(f);
    }
    this._hoverContainer = Mc("div.workbench-hover-container"), this._hoverPointer && this._hoverContainer.appendChild(this._hoverPointer), this._hoverContainer.appendChild(this._hover.containerDomNode);
    let c;
    if (e.actions && e.actions.length > 0 ? c = !1 : e.persistence?.hideOnHover === void 0 ? c = typeof e.content == "string" || Np(e.content) && !e.content.value.includes("](") && !e.content.value.includes("</a>") : c = e.persistence.hideOnHover, c && e.appearance?.showHoverHint) {
      const f = Mc("div.hover-row.status-bar"), p = Mc("div.info");
      p.textContent = C("hoverhint", "Hold {0} key to mouse over", zt ? "Option" : "Alt"), f.appendChild(p), this._hover.containerDomNode.appendChild(f);
    }
    const d = [...this._target.targetElements];
    c || d.push(this._hoverContainer);
    const u = this._register(new P8e(d));
    if (this._register(u.onMouseOut(() => {
      this._isLocked || this.dispose();
    })), c) {
      const f = [...this._target.targetElements, this._hoverContainer];
      this._lockMouseTracker = this._register(new P8e(f)), this._register(this._lockMouseTracker.onMouseOut(() => {
        this._isLocked || this.dispose();
      }));
    } else
      this._lockMouseTracker = u;
  }
  addFocusTrap() {
    if (!this._enableFocusTraps || this._addedFocusTrap)
      return;
    this._addedFocusTrap = !0;
    const e = this._hover.containerDomNode, t = this.findLastFocusableChild(this._hover.containerDomNode);
    if (t) {
      const n = KI(this._hoverContainer, Mc("div")), i = Fe(this._hoverContainer, Mc("div"));
      n.tabIndex = 0, i.tabIndex = 0, this._register(fe(i, "focus", (s) => {
        e.focus(), s.preventDefault();
      })), this._register(fe(n, "focus", (s) => {
        t.focus(), s.preventDefault();
      }));
    }
  }
  findLastFocusableChild(e) {
    if (e.hasChildNodes())
      for (let t = 0; t < e.childNodes.length; t++) {
        const n = e.childNodes.item(e.childNodes.length - t - 1);
        if (n.nodeType === n.ELEMENT_NODE) {
          const s = n;
          if (typeof s.tabIndex == "number" && s.tabIndex >= 0)
            return s;
        }
        const i = this.findLastFocusableChild(n);
        if (i)
          return i;
      }
  }
  render(e) {
    e.appendChild(this._hoverContainer);
    const n = this._hoverContainer.contains(this._hoverContainer.ownerDocument.activeElement) && V8t(this._configurationService.getValue("accessibility.verbosity.hover") === !0 && this._accessibilityService.isScreenReaderOptimized(), this._keybindingService.lookupKeybinding("editor.action.accessibleView")?.getAriaLabel());
    n && J8(n), this.layout(), this.addFocusTrap();
  }
  layout() {
    this._hover.containerDomNode.classList.remove("right-aligned"), this._hover.contentsDomNode.style.maxHeight = "";
    const e = (d) => {
      const u = DDe(d), f = d.getBoundingClientRect();
      return {
        top: f.top * u,
        bottom: f.bottom * u,
        right: f.right * u,
        left: f.left * u
      };
    }, t = this._target.targetElements.map((d) => e(d)), { top: n, right: i, bottom: s, left: o } = t[0], a = i - o, l = s - n, c = {
      top: n,
      right: i,
      bottom: s,
      left: o,
      width: a,
      height: l,
      center: {
        x: o + a / 2,
        y: n + l / 2
      }
    };
    if (this.adjustHorizontalHoverPosition(c), this.adjustVerticalHoverPosition(c), this.adjustHoverMaxHeight(c), this._hoverContainer.style.padding = "", this._hoverContainer.style.margin = "", this._hoverPointer) {
      switch (this._hoverPosition) {
        case 1:
          c.left += 3, c.right += 3, this._hoverContainer.style.paddingLeft = "3px", this._hoverContainer.style.marginLeft = "-3px";
          break;
        case 0:
          c.left -= 3, c.right -= 3, this._hoverContainer.style.paddingRight = "3px", this._hoverContainer.style.marginRight = "-3px";
          break;
        case 2:
          c.top += 3, c.bottom += 3, this._hoverContainer.style.paddingTop = "3px", this._hoverContainer.style.marginTop = "-3px";
          break;
        case 3:
          c.top -= 3, c.bottom -= 3, this._hoverContainer.style.paddingBottom = "3px", this._hoverContainer.style.marginBottom = "-3px";
          break;
      }
      c.center.x = c.left + a / 2, c.center.y = c.top + l / 2;
    }
    this.computeXCordinate(c), this.computeYCordinate(c), this._hoverPointer && (this._hoverPointer.classList.remove("top"), this._hoverPointer.classList.remove("left"), this._hoverPointer.classList.remove("right"), this._hoverPointer.classList.remove("bottom"), this.setHoverPointerPosition(c)), this._hover.onContentsChanged();
  }
  computeXCordinate(e) {
    const t = this._hover.containerDomNode.clientWidth + 2;
    this._target.x !== void 0 ? this._x = this._target.x : this._hoverPosition === 1 ? this._x = e.right : this._hoverPosition === 0 ? this._x = e.left - t : (this._hoverPointer ? this._x = e.center.x - this._hover.containerDomNode.clientWidth / 2 : this._x = e.left, this._x + t >= this._targetDocumentElement.clientWidth && (this._hover.containerDomNode.classList.add("right-aligned"), this._x = Math.max(this._targetDocumentElement.clientWidth - t - 2, this._targetDocumentElement.clientLeft))), this._x < this._targetDocumentElement.clientLeft && (this._x = e.left + 2);
  }
  computeYCordinate(e) {
    this._target.y !== void 0 ? this._y = this._target.y : this._hoverPosition === 3 ? this._y = e.top : this._hoverPosition === 2 ? this._y = e.bottom - 2 : this._hoverPointer ? this._y = e.center.y + this._hover.containerDomNode.clientHeight / 2 : this._y = e.bottom, this._y > this._targetWindow.innerHeight && (this._y = e.bottom);
  }
  adjustHorizontalHoverPosition(e) {
    if (this._target.x !== void 0)
      return;
    const t = this._hoverPointer ? 3 : 0;
    if (this._forcePosition) {
      const n = t + 2;
      this._hoverPosition === 1 ? this._hover.containerDomNode.style.maxWidth = `${this._targetDocumentElement.clientWidth - e.right - n}px` : this._hoverPosition === 0 && (this._hover.containerDomNode.style.maxWidth = `${e.left - n}px`);
      return;
    }
    this._hoverPosition === 1 ? this._targetDocumentElement.clientWidth - e.right < this._hover.containerDomNode.clientWidth + t && (e.left >= this._hover.containerDomNode.clientWidth + t ? this._hoverPosition = 0 : this._hoverPosition = 2) : this._hoverPosition === 0 && (e.left < this._hover.containerDomNode.clientWidth + t && (this._targetDocumentElement.clientWidth - e.right >= this._hover.containerDomNode.clientWidth + t ? this._hoverPosition = 1 : this._hoverPosition = 2), e.left - this._hover.containerDomNode.clientWidth - t <= this._targetDocumentElement.clientLeft && (this._hoverPosition = 1));
  }
  adjustVerticalHoverPosition(e) {
    if (this._target.y !== void 0 || this._forcePosition)
      return;
    const t = this._hoverPointer ? 3 : 0;
    this._hoverPosition === 3 ? e.top - this._hover.containerDomNode.clientHeight - t < 0 && (this._hoverPosition = 2) : this._hoverPosition === 2 && e.bottom + this._hover.containerDomNode.clientHeight + t > this._targetWindow.innerHeight && (this._hoverPosition = 3);
  }
  adjustHoverMaxHeight(e) {
    let t = this._targetWindow.innerHeight / 2;
    if (this._forcePosition) {
      const n = (this._hoverPointer ? 3 : 0) + 2;
      this._hoverPosition === 3 ? t = Math.min(t, e.top - n) : this._hoverPosition === 2 && (t = Math.min(t, this._targetWindow.innerHeight - e.bottom - n));
    }
    if (this._hover.containerDomNode.style.maxHeight = `${t}px`, this._hover.contentsDomNode.clientHeight < this._hover.contentsDomNode.scrollHeight) {
      const n = `${this._hover.scrollbar.options.verticalScrollbarSize}px`;
      this._hover.contentsDomNode.style.paddingRight !== n && (this._hover.contentsDomNode.style.paddingRight = n);
    }
  }
  setHoverPointerPosition(e) {
    if (this._hoverPointer)
      switch (this._hoverPosition) {
        case 0:
        case 1: {
          this._hoverPointer.classList.add(this._hoverPosition === 0 ? "right" : "left");
          const t = this._hover.containerDomNode.clientHeight;
          t > e.height ? this._hoverPointer.style.top = `${e.center.y - (this._y - t) - 3}px` : this._hoverPointer.style.top = `${Math.round(t / 2) - 3}px`;
          break;
        }
        case 3:
        case 2: {
          this._hoverPointer.classList.add(this._hoverPosition === 3 ? "bottom" : "top");
          const t = this._hover.containerDomNode.clientWidth;
          let n = Math.round(t / 2) - 3;
          const i = this._x + n;
          (i < e.left || i > e.right) && (n = e.center.x - this._x - 3), this._hoverPointer.style.left = `${n}px`;
          break;
        }
      }
  }
  focus() {
    this._hover.containerDomNode.focus();
  }
  dispose() {
    this._isDisposed || (this._onDispose.fire(), this._hoverContainer.remove(), this._messageListeners.dispose(), this._target.dispose(), super.dispose()), this._isDisposed = !0;
  }
};
$L = G9t([
  Wm(1, _r),
  Wm(2, Ai),
  Wm(3, Tw),
  Wm(4, xn),
  Wm(5, pc)
], $L);
class P8e extends xa {
  get onMouseOut() {
    return this._onMouseOut.event;
  }
  get isMouseIn() {
    return this._isMouseIn;
  }
  constructor(e) {
    super(), this._elements = e, this._isMouseIn = !0, this._onMouseOut = this._register(new $()), this._elements.forEach((t) => this.onmouseover(t, () => this._onTargetMouseOver(t))), this._elements.forEach((t) => this.onmouseleave(t, () => this._onTargetMouseLeave(t)));
  }
  _onTargetMouseOver(e) {
    this._isMouseIn = !0, this._clearEvaluateMouseStateTimeout(e);
  }
  _onTargetMouseLeave(e) {
    this._isMouseIn = !1, this._evaluateMouseState(e);
  }
  _evaluateMouseState(e) {
    this._clearEvaluateMouseStateTimeout(e), this._mouseTimeout = qe(e).setTimeout(() => this._fireIfMouseOutside(), 0);
  }
  _clearEvaluateMouseStateTimeout(e) {
    this._mouseTimeout && (qe(e).clearTimeout(this._mouseTimeout), this._mouseTimeout = void 0);
  }
  _fireIfMouseOutside() {
    this._isMouseIn || this._onMouseOut.fire();
  }
}
class Q9t {
  constructor(e) {
    this._element = e, this.targetElements = [this._element];
  }
  dispose() {
  }
}
var Rr;
(function(r) {
  function e(s, o) {
    if (s.start >= o.end || o.start >= s.end)
      return { start: 0, end: 0 };
    const a = Math.max(s.start, o.start), l = Math.min(s.end, o.end);
    return l - a <= 0 ? { start: 0, end: 0 } : { start: a, end: l };
  }
  r.intersect = e;
  function t(s) {
    return s.end - s.start <= 0;
  }
  r.isEmpty = t;
  function n(s, o) {
    return !t(e(s, o));
  }
  r.intersects = n;
  function i(s, o) {
    const a = [], l = { start: s.start, end: Math.min(o.start, s.end) }, c = { start: Math.max(o.end, s.start), end: s.end };
    return t(l) || a.push(l), t(c) || a.push(c), a;
  }
  r.relativeComplement = i;
})(Rr || (Rr = {}));
function K9t(r) {
  const e = r;
  return !!e && typeof e.x == "number" && typeof e.y == "number";
}
var Pu;
(function(r) {
  r[r.AVOID = 0] = "AVOID", r[r.ALIGN = 1] = "ALIGN";
})(Pu || (Pu = {}));
function sp(r, e, t) {
  const n = t.mode === Pu.ALIGN ? t.offset : t.offset + t.size, i = t.mode === Pu.ALIGN ? t.offset + t.size : t.offset;
  return t.position === 0 ? e <= r - n ? n : e <= i ? i - e : Math.max(r - e, 0) : e <= i ? i - e : e <= r - n ? n : 0;
}
class D9 extends me {
  static {
    this.BUBBLE_UP_EVENTS = ["click", "keydown", "focus", "blur"];
  }
  static {
    this.BUBBLE_DOWN_EVENTS = ["click"];
  }
  constructor(e, t) {
    super(), this.container = null, this.useFixedPosition = !1, this.useShadowDOM = !1, this.delegate = null, this.toDisposeOnClean = me.None, this.toDisposeOnSetContainer = me.None, this.shadowRoot = null, this.shadowRootHostElement = null, this.view = $e(".context-view"), Kve(this.view), this.setContainer(e, t), this._register(ht(() => this.setContainer(
      null,
      1
      /* ContextViewDOMPosition.ABSOLUTE */
    )));
  }
  setContainer(e, t) {
    this.useFixedPosition = t !== 1;
    const n = this.useShadowDOM;
    if (this.useShadowDOM = t === 3, !(e === this.container && n === this.useShadowDOM) && (this.container && (this.toDisposeOnSetContainer.dispose(), this.view.remove(), this.shadowRoot && (this.shadowRoot = null, this.shadowRootHostElement?.remove(), this.shadowRootHostElement = null), this.container = null), e)) {
      if (this.container = e, this.useShadowDOM) {
        this.shadowRootHostElement = $e(".shadow-root-host"), this.container.appendChild(this.shadowRootHostElement), this.shadowRoot = this.shadowRootHostElement.attachShadow({ mode: "open" });
        const s = document.createElement("style");
        s.textContent = Y9t, this.shadowRoot.appendChild(s), this.shadowRoot.appendChild(this.view), this.shadowRoot.appendChild($e("slot"));
      } else
        this.container.appendChild(this.view);
      const i = new ze();
      D9.BUBBLE_UP_EVENTS.forEach((s) => {
        i.add(ir(this.container, s, (o) => {
          this.onDOMEvent(o, !1);
        }));
      }), D9.BUBBLE_DOWN_EVENTS.forEach((s) => {
        i.add(ir(this.container, s, (o) => {
          this.onDOMEvent(o, !0);
        }, !0));
      }), this.toDisposeOnSetContainer = i;
    }
  }
  show(e) {
    this.isVisible() && this.hide(), ic(this.view), this.view.className = "context-view monaco-component", this.view.style.top = "0px", this.view.style.left = "0px", this.view.style.zIndex = `${2575 + (e.layer ?? 0)}`, this.view.style.position = this.useFixedPosition ? "fixed" : "absolute", IDe(this.view), this.toDisposeOnClean = e.render(this.view) || me.None, this.delegate = e, this.doLayout(), this.delegate.focus?.();
  }
  getViewElement() {
    return this.view;
  }
  layout() {
    if (this.isVisible()) {
      if (this.delegate.canRelayout === !1 && !(pf && cDe.pointerEvents)) {
        this.hide();
        return;
      }
      this.delegate?.layout?.(), this.doLayout();
    }
  }
  doLayout() {
    if (!this.isVisible())
      return;
    const e = this.delegate.getAnchor();
    let t;
    if (wr(e)) {
      const f = To(e), p = DDe(e);
      t = {
        top: f.top * p,
        left: f.left * p,
        width: f.width * p,
        height: f.height * p
      };
    } else K9t(e) ? t = {
      top: e.y,
      left: e.x,
      width: e.width || 1,
      height: e.height || 2
    } : t = {
      top: e.posy,
      left: e.posx,
      // We are about to position the context view where the mouse
      // cursor is. To prevent the view being exactly under the mouse
      // when showing and thus potentially triggering an action within,
      // we treat the mouse location like a small sized block element.
      width: 2,
      height: 2
    };
    const n = Fa(this.view), i = PD(this.view), s = this.delegate.anchorPosition || 0, o = this.delegate.anchorAlignment || 0, a = this.delegate.anchorAxisAlignment || 0;
    let l, c;
    const d = g6();
    if (a === 0) {
      const f = {
        offset: t.top - d.pageYOffset,
        size: t.height,
        position: s === 0 ? 0 : 1
        /* LayoutAnchorPosition.After */
      }, p = { offset: t.left, size: t.width, position: o === 0 ? 0 : 1, mode: Pu.ALIGN };
      l = sp(d.innerHeight, i, f) + d.pageYOffset, Rr.intersects({ start: l, end: l + i }, { start: f.offset, end: f.offset + f.size }) && (p.mode = Pu.AVOID), c = sp(d.innerWidth, n, p);
    } else {
      const f = {
        offset: t.left,
        size: t.width,
        position: o === 0 ? 0 : 1
        /* LayoutAnchorPosition.After */
      }, p = { offset: t.top, size: t.height, position: s === 0 ? 0 : 1, mode: Pu.ALIGN };
      c = sp(d.innerWidth, n, f), Rr.intersects({ start: c, end: c + n }, { start: f.offset, end: f.offset + f.size }) && (p.mode = Pu.AVOID), l = sp(d.innerHeight, i, p) + d.pageYOffset;
    }
    this.view.classList.remove("top", "bottom", "left", "right"), this.view.classList.add(s === 0 ? "bottom" : "top"), this.view.classList.add(o === 0 ? "left" : "right"), this.view.classList.toggle("fixed", this.useFixedPosition);
    const u = To(this.container);
    this.view.style.top = `${l - (this.useFixedPosition ? To(this.view).top : u.top)}px`, this.view.style.left = `${c - (this.useFixedPosition ? To(this.view).left : u.left)}px`, this.view.style.width = "initial";
  }
  hide(e) {
    const t = this.delegate;
    this.delegate = null, t?.onHide && t.onHide(e), this.toDisposeOnClean.dispose(), Kve(this.view);
  }
  isVisible() {
    return !!this.delegate;
  }
  onDOMEvent(e, t) {
    this.delegate && (this.delegate.onDOMEvent ? this.delegate.onDOMEvent(e, qe(e).document.activeElement) : t && !Ji(e.target, this.container) && this.hide());
  }
  dispose() {
    this.hide(), super.dispose();
  }
}
const Y9t = (
  /* css */
  `
	:host {
		all: initial; /* 1st rule so subsequent properties are reset. */
	}

	.codicon[class*='codicon-'] {
		font: normal normal normal 16px/1 codicon;
		display: inline-block;
		text-decoration: none;
		text-rendering: auto;
		text-align: center;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}

	:host {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe WPC", "Segoe UI", "HelveticaNeue-Light", system-ui, "Ubuntu", "Droid Sans", sans-serif;
	}

	:host-context(.mac) { font-family: -apple-system, BlinkMacSystemFont, sans-serif; }
	:host-context(.mac:lang(zh-Hans)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", sans-serif; }
	:host-context(.mac:lang(zh-Hant)) { font-family: -apple-system, BlinkMacSystemFont, "PingFang TC", sans-serif; }
	:host-context(.mac:lang(ja)) { font-family: -apple-system, BlinkMacSystemFont, "Hiragino Kaku Gothic Pro", sans-serif; }
	:host-context(.mac:lang(ko)) { font-family: -apple-system, BlinkMacSystemFont, "Nanum Gothic", "Apple SD Gothic Neo", "AppleGothic", sans-serif; }

	:host-context(.windows) { font-family: "Segoe WPC", "Segoe UI", sans-serif; }
	:host-context(.windows:lang(zh-Hans)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft YaHei", sans-serif; }
	:host-context(.windows:lang(zh-Hant)) { font-family: "Segoe WPC", "Segoe UI", "Microsoft Jhenghei", sans-serif; }
	:host-context(.windows:lang(ja)) { font-family: "Segoe WPC", "Segoe UI", "Yu Gothic UI", "Meiryo UI", sans-serif; }
	:host-context(.windows:lang(ko)) { font-family: "Segoe WPC", "Segoe UI", "Malgun Gothic", "Dotom", sans-serif; }

	:host-context(.linux) { font-family: system-ui, "Ubuntu", "Droid Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hans)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans SC", "Source Han Sans CN", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(zh-Hant)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans TC", "Source Han Sans TW", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ja)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans J", "Source Han Sans JP", "Source Han Sans", sans-serif; }
	:host-context(.linux:lang(ko)) { font-family: system-ui, "Ubuntu", "Droid Sans", "Source Han Sans K", "Source Han Sans JR", "Source Han Sans", "UnDotum", "FBaekmuk Gulim", sans-serif; }
`
);
var X9t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, J9t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let L9 = class extends me {
  constructor(e) {
    super(), this.layoutService = e, this.contextView = this._register(new D9(
      this.layoutService.mainContainer,
      1
      /* ContextViewDOMPosition.ABSOLUTE */
    )), this.layout(), this._register(e.onDidLayoutContainer(() => this.layout()));
  }
  // ContextView
  showContextView(e, t, n) {
    let i;
    t ? t === this.layoutService.getContainer(qe(t)) ? i = 1 : n ? i = 3 : i = 2 : i = 1, this.contextView.setContainer(t ?? this.layoutService.activeContainer, i), this.contextView.show(e);
    const s = {
      close: () => {
        this.openContextView === s && this.hideContextView();
      }
    };
    return this.openContextView = s, s;
  }
  layout() {
    this.contextView.layout();
  }
  hideContextView(e) {
    this.contextView.hide(e), this.openContextView = void 0;
  }
};
L9 = X9t([
  J9t(0, R1)
], L9);
class $9t extends L9 {
  getContextViewElement() {
    return this.contextView.getViewElement();
  }
}
class ebt {
  constructor(e, t, n) {
    this.hoverDelegate = e, this.target = t, this.fadeInAnimation = n;
  }
  async update(e, t, n) {
    if (this._cancellationTokenSource && (this._cancellationTokenSource.dispose(!0), this._cancellationTokenSource = void 0), this.isDisposed)
      return;
    let i;
    if (e === void 0 || Vo(e) || wr(e))
      i = e;
    else if (!_8(e.markdown))
      i = e.markdown ?? e.markdownNotSupportedFallback;
    else {
      this._hoverWidget || this.show(C("iconLabel.loading", "Loading..."), t, n), this._cancellationTokenSource = new Jg();
      const s = this._cancellationTokenSource.token;
      if (i = await e.markdown(s), i === void 0 && (i = e.markdownNotSupportedFallback), this.isDisposed || s.isCancellationRequested)
        return;
    }
    this.show(i, t, n);
  }
  show(e, t, n) {
    const i = this._hoverWidget;
    if (this.hasContent(e)) {
      const s = {
        content: e,
        target: this.target,
        appearance: {
          showPointer: this.hoverDelegate.placement === "element",
          skipFadeInAnimation: !this.fadeInAnimation || !!i
          // do not fade in if the hover is already showing
        },
        position: {
          hoverPosition: 2
        },
        ...n
      };
      this._hoverWidget = this.hoverDelegate.showHover(s, t);
    }
    i?.dispose();
  }
  hasContent(e) {
    return e ? Np(e) ? !!e.value : !0 : !1;
  }
  get isDisposed() {
    return this._hoverWidget?.isDisposed;
  }
  dispose() {
    this._hoverWidget?.dispose(), this._cancellationTokenSource?.dispose(!0), this._cancellationTokenSource = void 0;
  }
}
var tbt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, jm = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let ek = class extends me {
  constructor(e, t, n, i, s) {
    super(), this._instantiationService = e, this._keybindingService = n, this._layoutService = i, this._accessibilityService = s, this._managedHovers = /* @__PURE__ */ new Map(), t.onDidShowContextMenu(() => this.hideHover()), this._contextViewHandler = this._register(new L9(this._layoutService));
  }
  showHover(e, t, n) {
    if (F8e(this._currentHoverOptions) === F8e(e) || this._currentHover && this._currentHoverOptions?.persistence?.sticky)
      return;
    this._currentHoverOptions = e, this._lastHoverOptions = e;
    const i = e.trapFocus || this._accessibilityService.isScreenReaderOptimized(), s = ss();
    n || (i && s ? s.classList.contains("monaco-hover") || (this._lastFocusedElementBeforeOpen = s) : this._lastFocusedElementBeforeOpen = void 0);
    const o = new ze(), a = this._instantiationService.createInstance($L, e);
    if (e.persistence?.sticky && (a.isLocked = !0), a.onDispose(() => {
      this._currentHover?.domNode && kDe(this._currentHover.domNode) && this._lastFocusedElementBeforeOpen?.focus(), this._currentHoverOptions === e && (this._currentHoverOptions = void 0), o.dispose();
    }, void 0, o), !e.container) {
      const l = wr(e.target) ? e.target : e.target.targetElements[0];
      e.container = this._layoutService.getContainer(qe(l));
    }
    if (this._contextViewHandler.showContextView(new nbt(a, t), e.container), a.onRequestLayout(() => this._contextViewHandler.layout(), void 0, o), e.persistence?.sticky)
      o.add(fe(qe(e.container).document, Se.MOUSE_DOWN, (l) => {
        Ji(l.target, a.domNode) || this.doHideHover();
      }));
    else {
      if ("targetElements" in e.target)
        for (const c of e.target.targetElements)
          o.add(fe(c, Se.CLICK, () => this.hideHover()));
      else
        o.add(fe(e.target, Se.CLICK, () => this.hideHover()));
      const l = ss();
      if (l) {
        const c = qe(l).document;
        o.add(fe(l, Se.KEY_DOWN, (d) => this._keyDown(d, a, !!e.persistence?.hideOnKeyDown))), o.add(fe(c, Se.KEY_DOWN, (d) => this._keyDown(d, a, !!e.persistence?.hideOnKeyDown))), o.add(fe(l, Se.KEY_UP, (d) => this._keyUp(d, a))), o.add(fe(c, Se.KEY_UP, (d) => this._keyUp(d, a)));
      }
    }
    if ("IntersectionObserver" in Sn) {
      const l = new IntersectionObserver((d) => this._intersectionChange(d, a), { threshold: 0 }), c = "targetElements" in e.target ? e.target.targetElements[0] : e.target;
      l.observe(c), o.add(ht(() => l.disconnect()));
    }
    return this._currentHover = a, a;
  }
  hideHover() {
    this._currentHover?.isLocked || !this._currentHoverOptions || this.doHideHover();
  }
  doHideHover() {
    this._currentHover = void 0, this._currentHoverOptions = void 0, this._contextViewHandler.hideContextView();
  }
  _intersectionChange(e, t) {
    e[e.length - 1].isIntersecting || t.dispose();
  }
  showAndFocusLastHover() {
    this._lastHoverOptions && this.showHover(this._lastHoverOptions, !0, !0);
  }
  _keyDown(e, t, n) {
    if (e.key === "Alt") {
      t.isLocked = !0;
      return;
    }
    const i = new zn(e);
    this._keybindingService.resolveKeyboardEvent(i).getSingleModifierDispatchChords().some((o) => !!o) || this._keybindingService.softDispatch(i, i.target).kind !== 0 || n && (!this._currentHoverOptions?.trapFocus || e.key !== "Tab") && (this.hideHover(), this._lastFocusedElementBeforeOpen?.focus());
  }
  _keyUp(e, t) {
    e.key === "Alt" && (t.isLocked = !1, t.isMouseIn || (this.hideHover(), this._lastFocusedElementBeforeOpen?.focus()));
  }
  // TODO: Investigate performance of this function. There seems to be a lot of content created
  //       and thrown away on start up
  setupManagedHover(e, t, n, i) {
    t.setAttribute("custom-hover", "true"), t.title !== "" && (console.warn("HTML element already has a title attribute, which will conflict with the custom hover. Please remove the title attribute."), console.trace("Stack trace:", t.title), t.title = "");
    let s, o;
    const a = (y, _) => {
      const S = o !== void 0;
      y && (o?.dispose(), o = void 0), _ && (s?.dispose(), s = void 0), S && (e.onDidHideHover?.(), o = void 0);
    }, l = (y, _, S, D) => new T1(async () => {
      (!o || o.isDisposed) && (o = new ebt(e, S || t, y > 0), await o.update(typeof n == "function" ? n() : n, _, { ...i, trapFocus: D }));
    }, y);
    let c = !1;
    const d = fe(t, Se.MOUSE_DOWN, () => {
      c = !0, a(!0, !0);
    }, !0), u = fe(t, Se.MOUSE_UP, () => {
      c = !1;
    }, !0), f = fe(t, Se.MOUSE_LEAVE, (y) => {
      c = !1, a(!1, y.fromElement === t);
    }, !0), p = (y) => {
      if (s)
        return;
      const _ = new ze(), S = {
        targetElements: [t],
        dispose: () => {
        }
      };
      if (e.placement === void 0 || e.placement === "mouse") {
        const D = (M) => {
          S.x = M.x + 10, wr(M.target) && z8e(M.target, t) !== t && a(!0, !0);
        };
        _.add(fe(t, Se.MOUSE_MOVE, D, !0));
      }
      s = _, !(wr(y.target) && z8e(y.target, t) !== t) && _.add(l(e.delay, !1, S));
    }, g = fe(t, Se.MOUSE_OVER, p, !0), m = () => {
      if (c || s)
        return;
      const y = {
        targetElements: [t],
        dispose: () => {
        }
      }, _ = new ze(), S = () => a(!0, !0);
      _.add(fe(t, Se.BLUR, S, !0)), _.add(l(e.delay, !1, y)), s = _;
    };
    let A;
    const w = t.tagName.toLowerCase();
    w !== "input" && w !== "textarea" && (A = fe(t, Se.FOCUS, m, !0));
    const v = {
      show: (y) => {
        a(!1, !0), l(0, y, void 0, y);
      },
      hide: () => {
        a(!0, !0);
      },
      update: async (y, _) => {
        n = y, await o?.update(n, void 0, _);
      },
      dispose: () => {
        this._managedHovers.delete(t), g.dispose(), f.dispose(), d.dispose(), u.dispose(), A?.dispose(), a(!0, !0);
      }
    };
    return this._managedHovers.set(t, v), v;
  }
  showManagedHover(e) {
    const t = this._managedHovers.get(e);
    t && t.show(!0);
  }
  dispose() {
    this._managedHovers.forEach((e) => e.dispose()), super.dispose();
  }
};
ek = tbt([
  jm(0, xn),
  jm(1, Qd),
  jm(2, _r),
  jm(3, R1),
  jm(4, pc)
], ek);
function F8e(r) {
  if (r !== void 0)
    return r?.id ?? r;
}
class nbt {
  get anchorPosition() {
    return this._hover.anchor;
  }
  constructor(e, t = !1) {
    this._hover = e, this._focus = t, this.layer = 1;
  }
  render(e) {
    return this._hover.render(e), this._focus && this._hover.focus(), this._hover;
  }
  getAnchor() {
    return {
      x: this._hover.x,
      y: this._hover.y
    };
  }
  layout() {
    this._hover.layout();
  }
}
function z8e(r, e) {
  for (e = e ?? qe(r).document.body; !r.hasAttribute("custom-hover") && r !== e; )
    r = r.parentElement;
  return r;
}
en(
  i2,
  ek,
  1
  /* InstantiationType.Delayed */
);
Sh((r, e) => {
  const t = r.getColor(Pmt);
  t && (e.addRule(`.monaco-workbench .workbench-hover .hover-row:not(:first-child):not(:empty) { border-top: 1px solid ${t.transparent(0.5)}; }`), e.addRule(`.monaco-workbench .workbench-hover hr { border-top: 1px solid ${t.transparent(0.5)}; }`));
});
const ibt = Wt("IWorkspaceEditService");
class uR {
  constructor(e) {
    this.metadata = e;
  }
  static convert(e) {
    return e.edits.map((t) => {
      if (J0.is(t))
        return J0.lift(t);
      if (Tp.is(t))
        return Tp.lift(t);
      throw new Error("Unsupported edit");
    });
  }
}
class J0 extends uR {
  static is(e) {
    return e instanceof J0 ? !0 : Rs(e) && Pt.isUri(e.resource) && Rs(e.textEdit);
  }
  static lift(e) {
    return e instanceof J0 ? e : new J0(e.resource, e.textEdit, e.versionId, e.metadata);
  }
  constructor(e, t, n = void 0, i) {
    super(i), this.resource = e, this.textEdit = t, this.versionId = n;
  }
}
class Tp extends uR {
  static is(e) {
    return e instanceof Tp ? !0 : Rs(e) && (!!e.newResource || !!e.oldResource);
  }
  static lift(e) {
    return e instanceof Tp ? e : new Tp(e.oldResource, e.newResource, e.options, e.metadata);
  }
  constructor(e, t, n = {}, i) {
    super(i), this.oldResource = e, this.newResource = t, this.options = n;
  }
}
const xr = {
  enableSplitViewResizing: !0,
  renderSideBySide: !0,
  renderMarginRevertIcon: !0,
  renderGutterMenu: !0,
  maxComputationTime: 5e3,
  maxFileSize: 50,
  ignoreTrimWhitespace: !0,
  renderIndicators: !0,
  originalEditable: !1,
  diffCodeLens: !1,
  renderOverviewRuler: !0,
  diffWordWrap: "inherit",
  diffAlgorithm: "advanced",
  accessibilityVerbose: !1,
  experimental: {
    showMoves: !1,
    showEmptyDecorations: !0,
    useTrueInlineView: !1
  },
  hideUnchangedRegions: {
    enabled: !1,
    contextLineCount: 3,
    minimumLineCount: 3,
    revealLineCount: 20
  },
  isInEmbeddedEditor: !1,
  onlyShowAccessibleDiffViewer: !1,
  renderSideBySideInlineBreakpoint: 900,
  useInlineViewWhenSpaceIsLimited: !0,
  compactMode: !1
}, rbt = Object.freeze({
  id: "editor",
  order: 5,
  type: "object",
  title: C("editorConfigurationTitle", "Editor"),
  scope: 5
}), k9 = {
  ...rbt,
  properties: {
    "editor.tabSize": {
      type: "number",
      default: Hr.tabSize,
      minimum: 1,
      markdownDescription: C("tabSize", "The number of spaces a tab is equal to. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
    },
    "editor.indentSize": {
      anyOf: [
        {
          type: "string",
          enum: ["tabSize"]
        },
        {
          type: "number",
          minimum: 1
        }
      ],
      default: "tabSize",
      markdownDescription: C("indentSize", 'The number of spaces used for indentation or `"tabSize"` to use the value from `#editor.tabSize#`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.')
    },
    "editor.insertSpaces": {
      type: "boolean",
      default: Hr.insertSpaces,
      markdownDescription: C("insertSpaces", "Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when {0} is on.", "`#editor.detectIndentation#`")
    },
    "editor.detectIndentation": {
      type: "boolean",
      default: Hr.detectIndentation,
      markdownDescription: C("detectIndentation", "Controls whether {0} and {1} will be automatically detected when a file is opened based on the file contents.", "`#editor.tabSize#`", "`#editor.insertSpaces#`")
    },
    "editor.trimAutoWhitespace": {
      type: "boolean",
      default: Hr.trimAutoWhitespace,
      description: C("trimAutoWhitespace", "Remove trailing auto inserted whitespace.")
    },
    "editor.largeFileOptimizations": {
      type: "boolean",
      default: Hr.largeFileOptimizations,
      description: C("largeFileOptimizations", "Special handling for large files to disable certain memory intensive features.")
    },
    "editor.wordBasedSuggestions": {
      enum: ["off", "currentDocument", "matchingDocuments", "allDocuments"],
      default: "matchingDocuments",
      enumDescriptions: [
        C("wordBasedSuggestions.off", "Turn off Word Based Suggestions."),
        C("wordBasedSuggestions.currentDocument", "Only suggest words from the active document."),
        C("wordBasedSuggestions.matchingDocuments", "Suggest words from all open documents of the same language."),
        C("wordBasedSuggestions.allDocuments", "Suggest words from all open documents.")
      ],
      description: C("wordBasedSuggestions", "Controls whether completions should be computed based on words in the document and from which documents they are computed.")
    },
    "editor.semanticHighlighting.enabled": {
      enum: [!0, !1, "configuredByTheme"],
      enumDescriptions: [
        C("semanticHighlighting.true", "Semantic highlighting enabled for all color themes."),
        C("semanticHighlighting.false", "Semantic highlighting disabled for all color themes."),
        C("semanticHighlighting.configuredByTheme", "Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.")
      ],
      default: "configuredByTheme",
      description: C("semanticHighlighting.enabled", "Controls whether the semanticHighlighting is shown for the languages that support it.")
    },
    "editor.stablePeek": {
      type: "boolean",
      default: !1,
      markdownDescription: C("stablePeek", "Keep peek editors open even when double-clicking their content or when hitting `Escape`.")
    },
    "editor.maxTokenizationLineLength": {
      type: "integer",
      default: 2e4,
      description: C("maxTokenizationLineLength", "Lines above this length will not be tokenized for performance reasons")
    },
    "editor.experimental.asyncTokenization": {
      type: "boolean",
      default: !1,
      description: C("editor.experimental.asyncTokenization", "Controls whether the tokenization should happen asynchronously on a web worker."),
      tags: ["experimental"]
    },
    "editor.experimental.asyncTokenizationLogging": {
      type: "boolean",
      default: !1,
      description: C("editor.experimental.asyncTokenizationLogging", "Controls whether async tokenization should be logged. For debugging only.")
    },
    "editor.experimental.asyncTokenizationVerification": {
      type: "boolean",
      default: !1,
      description: C("editor.experimental.asyncTokenizationVerification", "Controls whether async tokenization should be verified against legacy background tokenization. Might slow down tokenization. For debugging only."),
      tags: ["experimental"]
    },
    "editor.language.brackets": {
      type: ["array", "null"],
      default: null,
      // We want to distinguish the empty array from not configured.
      description: C("schema.brackets", "Defines the bracket symbols that increase or decrease the indentation."),
      items: {
        type: "array",
        items: [
          {
            type: "string",
            description: C("schema.openBracket", "The opening bracket character or string sequence.")
          },
          {
            type: "string",
            description: C("schema.closeBracket", "The closing bracket character or string sequence.")
          }
        ]
      }
    },
    "editor.language.colorizedBracketPairs": {
      type: ["array", "null"],
      default: null,
      // We want to distinguish the empty array from not configured.
      description: C("schema.colorizedBracketPairs", "Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled."),
      items: {
        type: "array",
        items: [
          {
            type: "string",
            description: C("schema.openBracket", "The opening bracket character or string sequence.")
          },
          {
            type: "string",
            description: C("schema.closeBracket", "The closing bracket character or string sequence.")
          }
        ]
      }
    },
    "diffEditor.maxComputationTime": {
      type: "number",
      default: xr.maxComputationTime,
      description: C("maxComputationTime", "Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.")
    },
    "diffEditor.maxFileSize": {
      type: "number",
      default: xr.maxFileSize,
      description: C("maxFileSize", "Maximum file size in MB for which to compute diffs. Use 0 for no limit.")
    },
    "diffEditor.renderSideBySide": {
      type: "boolean",
      default: xr.renderSideBySide,
      description: C("sideBySide", "Controls whether the diff editor shows the diff side by side or inline.")
    },
    "diffEditor.renderSideBySideInlineBreakpoint": {
      type: "number",
      default: xr.renderSideBySideInlineBreakpoint,
      description: C("renderSideBySideInlineBreakpoint", "If the diff editor width is smaller than this value, the inline view is used.")
    },
    "diffEditor.useInlineViewWhenSpaceIsLimited": {
      type: "boolean",
      default: xr.useInlineViewWhenSpaceIsLimited,
      description: C("useInlineViewWhenSpaceIsLimited", "If enabled and the editor width is too small, the inline view is used.")
    },
    "diffEditor.renderMarginRevertIcon": {
      type: "boolean",
      default: xr.renderMarginRevertIcon,
      description: C("renderMarginRevertIcon", "When enabled, the diff editor shows arrows in its glyph margin to revert changes.")
    },
    "diffEditor.renderGutterMenu": {
      type: "boolean",
      default: xr.renderGutterMenu,
      description: C("renderGutterMenu", "When enabled, the diff editor shows a special gutter for revert and stage actions.")
    },
    "diffEditor.ignoreTrimWhitespace": {
      type: "boolean",
      default: xr.ignoreTrimWhitespace,
      description: C("ignoreTrimWhitespace", "When enabled, the diff editor ignores changes in leading or trailing whitespace.")
    },
    "diffEditor.renderIndicators": {
      type: "boolean",
      default: xr.renderIndicators,
      description: C("renderIndicators", "Controls whether the diff editor shows +/- indicators for added/removed changes.")
    },
    "diffEditor.codeLens": {
      type: "boolean",
      default: xr.diffCodeLens,
      description: C("codeLens", "Controls whether the editor shows CodeLens.")
    },
    "diffEditor.wordWrap": {
      type: "string",
      enum: ["off", "on", "inherit"],
      default: xr.diffWordWrap,
      markdownEnumDescriptions: [
        C("wordWrap.off", "Lines will never wrap."),
        C("wordWrap.on", "Lines will wrap at the viewport width."),
        C("wordWrap.inherit", "Lines will wrap according to the {0} setting.", "`#editor.wordWrap#`")
      ]
    },
    "diffEditor.diffAlgorithm": {
      type: "string",
      enum: ["legacy", "advanced"],
      default: xr.diffAlgorithm,
      markdownEnumDescriptions: [
        C("diffAlgorithm.legacy", "Uses the legacy diffing algorithm."),
        C("diffAlgorithm.advanced", "Uses the advanced diffing algorithm.")
      ],
      tags: ["experimental"]
    },
    "diffEditor.hideUnchangedRegions.enabled": {
      type: "boolean",
      default: xr.hideUnchangedRegions.enabled,
      markdownDescription: C("hideUnchangedRegions.enabled", "Controls whether the diff editor shows unchanged regions.")
    },
    "diffEditor.hideUnchangedRegions.revealLineCount": {
      type: "integer",
      default: xr.hideUnchangedRegions.revealLineCount,
      markdownDescription: C("hideUnchangedRegions.revealLineCount", "Controls how many lines are used for unchanged regions."),
      minimum: 1
    },
    "diffEditor.hideUnchangedRegions.minimumLineCount": {
      type: "integer",
      default: xr.hideUnchangedRegions.minimumLineCount,
      markdownDescription: C("hideUnchangedRegions.minimumLineCount", "Controls how many lines are used as a minimum for unchanged regions."),
      minimum: 1
    },
    "diffEditor.hideUnchangedRegions.contextLineCount": {
      type: "integer",
      default: xr.hideUnchangedRegions.contextLineCount,
      markdownDescription: C("hideUnchangedRegions.contextLineCount", "Controls how many lines are used as context when comparing unchanged regions."),
      minimum: 1
    },
    "diffEditor.experimental.showMoves": {
      type: "boolean",
      default: xr.experimental.showMoves,
      markdownDescription: C("showMoves", "Controls whether the diff editor should show detected code moves.")
    },
    "diffEditor.experimental.showEmptyDecorations": {
      type: "boolean",
      default: xr.experimental.showEmptyDecorations,
      description: C("showEmptyDecorations", "Controls whether the diff editor shows empty decorations to see where characters got inserted or deleted.")
    },
    "diffEditor.experimental.useTrueInlineView": {
      type: "boolean",
      default: xr.experimental.useTrueInlineView,
      description: C("useTrueInlineView", "If enabled and the editor uses the inline view, word changes are rendered inline.")
    }
  }
};
function sbt(r) {
  return typeof r.type < "u" || typeof r.anyOf < "u";
}
for (const r of q2) {
  const e = r.schema;
  if (typeof e < "u")
    if (sbt(e))
      k9.properties[`editor.${r.name}`] = e;
    else
      for (const t in e)
        Object.hasOwnProperty.call(e, t) && (k9.properties[t] = e[t]);
}
let $v = null;
function vNe() {
  return $v === null && ($v = /* @__PURE__ */ Object.create(null), Object.keys(k9.properties).forEach((r) => {
    $v[r] = !0;
  })), $v;
}
function obt(r) {
  return vNe()[`editor.${r}`] || !1;
}
function abt(r) {
  return vNe()[`diffEditor.${r}`] || !1;
}
const lbt = Er.as($f.Configuration);
lbt.registerConfiguration(k9);
class cbt {
  static insert(e, t) {
    return {
      range: new Q(e.lineNumber, e.column, e.lineNumber, e.column),
      text: t,
      forceMoveMarkers: !0
    };
  }
  static delete(e) {
    return {
      range: e,
      text: null
    };
  }
  static replace(e, t) {
    return {
      range: e,
      text: t
    };
  }
  static replaceMove(e, t) {
    return {
      range: e,
      text: t,
      forceMoveMarkers: !0
    };
  }
}
function e5(r) {
  return Object.isFrozen(r) ? r : vut(r);
}
class mr {
  static createEmptyModel(e) {
    return new mr({}, [], [], void 0, e);
  }
  constructor(e, t, n, i, s) {
    this._contents = e, this._keys = t, this._overrides = n, this.raw = i, this.logService = s, this.overrideConfigurations = /* @__PURE__ */ new Map();
  }
  get rawConfiguration() {
    if (!this._rawConfiguration)
      if (this.raw?.length) {
        const e = this.raw.map((t) => {
          if (t instanceof mr)
            return t;
          const n = new hbt("", this.logService);
          return n.parseRaw(t), n.configurationModel;
        });
        this._rawConfiguration = e.reduce((t, n) => n === t ? n : t.merge(n), e[0]);
      } else
        this._rawConfiguration = this;
    return this._rawConfiguration;
  }
  get contents() {
    return this._contents;
  }
  get overrides() {
    return this._overrides;
  }
  get keys() {
    return this._keys;
  }
  isEmpty() {
    return this._keys.length === 0 && Object.keys(this._contents).length === 0 && this._overrides.length === 0;
  }
  getValue(e) {
    return e ? l5e(this.contents, e) : this.contents;
  }
  inspect(e, t) {
    const n = this;
    return {
      get value() {
        return e5(n.rawConfiguration.getValue(e));
      },
      get override() {
        return t ? e5(n.rawConfiguration.getOverrideValue(e, t)) : void 0;
      },
      get merged() {
        return e5(t ? n.rawConfiguration.override(t).getValue(e) : n.rawConfiguration.getValue(e));
      },
      get overrides() {
        const i = [];
        for (const { contents: s, identifiers: o, keys: a } of n.rawConfiguration.overrides) {
          const l = new mr(s, a, [], void 0, n.logService).getValue(e);
          l !== void 0 && i.push({ identifiers: o, value: l });
        }
        return i.length ? e5(i) : void 0;
      }
    };
  }
  getOverrideValue(e, t) {
    const n = this.getContentsForOverrideIdentifer(t);
    return n ? e ? l5e(n, e) : n : void 0;
  }
  override(e) {
    let t = this.overrideConfigurations.get(e);
    return t || (t = this.createOverrideConfigurationModel(e), this.overrideConfigurations.set(e, t)), t;
  }
  merge(...e) {
    const t = pu(this.contents), n = pu(this.overrides), i = [...this.keys], s = this.raw?.length ? [...this.raw] : [this];
    for (const o of e)
      if (s.push(...o.raw?.length ? o.raw : [o]), !o.isEmpty()) {
        this.mergeContents(t, o.contents);
        for (const a of o.overrides) {
          const [l] = n.filter((c) => Zi(c.identifiers, a.identifiers));
          l ? (this.mergeContents(l.contents, a.contents), l.keys.push(...a.keys), l.keys = ff(l.keys)) : n.push(pu(a));
        }
        for (const a of o.keys)
          i.indexOf(a) === -1 && i.push(a);
      }
    return new mr(t, i, n, s.every((o) => o instanceof mr) ? void 0 : s, this.logService);
  }
  createOverrideConfigurationModel(e) {
    const t = this.getContentsForOverrideIdentifer(e);
    if (!t || typeof t != "object" || !Object.keys(t).length)
      return this;
    const n = {};
    for (const i of ff([...Object.keys(this.contents), ...Object.keys(t)])) {
      let s = this.contents[i];
      const o = t[i];
      o && (typeof s == "object" && typeof o == "object" ? (s = pu(s), this.mergeContents(s, o)) : s = o), n[i] = s;
    }
    return new mr(n, this.keys, this.overrides, void 0, this.logService);
  }
  mergeContents(e, t) {
    for (const n of Object.keys(t)) {
      if (n in e && Rs(e[n]) && Rs(t[n])) {
        this.mergeContents(e[n], t[n]);
        continue;
      }
      e[n] = pu(t[n]);
    }
  }
  getContentsForOverrideIdentifer(e) {
    let t = null, n = null;
    const i = (s) => {
      s && (n ? this.mergeContents(n, s) : n = pu(s));
    };
    for (const s of this.overrides)
      s.identifiers.length === 1 && s.identifiers[0] === e ? t = s.contents : s.identifiers.includes(e) && i(s.contents);
    return i(t), n;
  }
  toJSON() {
    return {
      contents: this.contents,
      overrides: this.overrides,
      keys: this.keys
    };
  }
  setValue(e, t) {
    this.updateValue(e, t, !1);
  }
  removeValue(e) {
    const t = this.keys.indexOf(e);
    t !== -1 && (this.keys.splice(t, 1), $2t(this.contents, e), c1.test(e) && this.overrides.splice(this.overrides.findIndex((n) => Zi(n.identifiers, Z8(e))), 1));
  }
  updateValue(e, t, n) {
    if (XDe(this.contents, e, t, (i) => this.logService.error(i)), n = n || this.keys.indexOf(e) === -1, n && this.keys.push(e), c1.test(e)) {
      const i = Z8(e), s = {
        identifiers: i,
        keys: Object.keys(this.contents[e]),
        contents: qD(this.contents[e], (a) => this.logService.error(a))
      }, o = this.overrides.findIndex((a) => Zi(a.identifiers, i));
      o !== -1 ? this.overrides[o] = s : this.overrides.push(s);
    }
  }
}
class hbt {
  constructor(e, t) {
    this._name = e, this.logService = t, this._raw = null, this._configurationModel = null, this._restrictedConfigurations = [];
  }
  get configurationModel() {
    return this._configurationModel || mr.createEmptyModel(this.logService);
  }
  parseRaw(e, t) {
    this._raw = e;
    const { contents: n, keys: i, overrides: s, restricted: o, hasExcludedProperties: a } = this.doParseRaw(e, t);
    this._configurationModel = new mr(n, i, s, a ? [e] : void 0, this.logService), this._restrictedConfigurations = o || [];
  }
  doParseRaw(e, t) {
    const n = Er.as($f.Configuration).getConfigurationProperties(), i = this.filter(e, n, !0, t);
    e = i.raw;
    const s = qD(e, (l) => this.logService.error(`Conflict in settings file ${this._name}: ${l}`)), o = Object.keys(e), a = this.toOverrides(e, (l) => this.logService.error(`Conflict in settings file ${this._name}: ${l}`));
    return { contents: s, keys: o, overrides: a, restricted: i.restricted, hasExcludedProperties: i.hasExcludedProperties };
  }
  filter(e, t, n, i) {
    let s = !1;
    if (!i?.scopes && !i?.skipRestricted && !i?.exclude?.length)
      return { raw: e, restricted: [], hasExcludedProperties: s };
    const o = {}, a = [];
    for (const l in e)
      if (c1.test(l) && n) {
        const c = this.filter(e[l], t, !1, i);
        o[l] = c.raw, s = s || c.hasExcludedProperties, a.push(...c.restricted);
      } else {
        const c = t[l], d = c ? typeof c.scope < "u" ? c.scope : 3 : void 0;
        c?.restricted && a.push(l), !i.exclude?.includes(l) && (i.include?.includes(l) || (d === void 0 || i.scopes === void 0 || i.scopes.includes(d)) && !(i.skipRestricted && c?.restricted)) ? o[l] = e[l] : s = !0;
      }
    return { raw: o, restricted: a, hasExcludedProperties: s };
  }
  toOverrides(e, t) {
    const n = [];
    for (const i of Object.keys(e))
      if (c1.test(i)) {
        const s = {};
        for (const o in e[i])
          s[o] = e[i][o];
        n.push({
          identifiers: Z8(i),
          keys: Object.keys(s),
          contents: qD(s, t)
        });
      }
    return n;
  }
}
class dbt {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f, p) {
    this.key = e, this.overrides = t, this._value = n, this.overrideIdentifiers = i, this.defaultConfiguration = s, this.policyConfiguration = o, this.applicationConfiguration = a, this.userConfiguration = l, this.localUserConfiguration = c, this.remoteUserConfiguration = d, this.workspaceConfiguration = u, this.folderConfigurationModel = f, this.memoryConfigurationModel = p;
  }
  toInspectValue(e) {
    return e?.value !== void 0 || e?.override !== void 0 || e?.overrides !== void 0 ? e : void 0;
  }
  get userInspectValue() {
    return this._userInspectValue || (this._userInspectValue = this.userConfiguration.inspect(this.key, this.overrides.overrideIdentifier)), this._userInspectValue;
  }
  get user() {
    return this.toInspectValue(this.userInspectValue);
  }
}
let bNe = class yNe {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    this._defaultConfiguration = e, this._policyConfiguration = t, this._applicationConfiguration = n, this._localUserConfiguration = i, this._remoteUserConfiguration = s, this._workspaceConfiguration = o, this._folderConfigurations = a, this._memoryConfiguration = l, this._memoryConfigurationByResource = c, this.logService = d, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations = new ws(), this._userConfiguration = null;
  }
  getValue(e, t, n) {
    return this.getConsolidatedConfigurationModel(e, t, n).getValue(e);
  }
  updateValue(e, t, n = {}) {
    let i;
    n.resource ? (i = this._memoryConfigurationByResource.get(n.resource), i || (i = mr.createEmptyModel(this.logService), this._memoryConfigurationByResource.set(n.resource, i))) : i = this._memoryConfiguration, t === void 0 ? i.removeValue(e) : i.setValue(e, t), n.resource || (this._workspaceConsolidatedConfiguration = null);
  }
  inspect(e, t, n) {
    const i = this.getConsolidatedConfigurationModel(e, t, n), s = this.getFolderConfigurationModelForResource(t.resource, n), o = t.resource ? this._memoryConfigurationByResource.get(t.resource) || this._memoryConfiguration : this._memoryConfiguration, a = /* @__PURE__ */ new Set();
    for (const l of i.overrides)
      for (const c of l.identifiers)
        i.getOverrideValue(e, c) !== void 0 && a.add(c);
    return new dbt(e, t, i.getValue(e), a.size ? [...a] : void 0, this._defaultConfiguration, this._policyConfiguration.isEmpty() ? void 0 : this._policyConfiguration, this.applicationConfiguration.isEmpty() ? void 0 : this.applicationConfiguration, this.userConfiguration, this.localUserConfiguration, this.remoteUserConfiguration, n ? this._workspaceConfiguration : void 0, s || void 0, o);
  }
  get applicationConfiguration() {
    return this._applicationConfiguration;
  }
  get userConfiguration() {
    return this._userConfiguration || (this._userConfiguration = this._remoteUserConfiguration.isEmpty() ? this._localUserConfiguration : this._localUserConfiguration.merge(this._remoteUserConfiguration)), this._userConfiguration;
  }
  get localUserConfiguration() {
    return this._localUserConfiguration;
  }
  get remoteUserConfiguration() {
    return this._remoteUserConfiguration;
  }
  getConsolidatedConfigurationModel(e, t, n) {
    let i = this.getConsolidatedConfigurationModelForResource(t, n);
    return t.overrideIdentifier && (i = i.override(t.overrideIdentifier)), !this._policyConfiguration.isEmpty() && this._policyConfiguration.getValue(e) !== void 0 && (i = i.merge(this._policyConfiguration)), i;
  }
  getConsolidatedConfigurationModelForResource({ resource: e }, t) {
    let n = this.getWorkspaceConsolidatedConfiguration();
    if (t && e) {
      const i = t.getFolder(e);
      i && (n = this.getFolderConsolidatedConfiguration(i.uri) || n);
      const s = this._memoryConfigurationByResource.get(e);
      s && (n = n.merge(s));
    }
    return n;
  }
  getWorkspaceConsolidatedConfiguration() {
    return this._workspaceConsolidatedConfiguration || (this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this.applicationConfiguration, this.userConfiguration, this._workspaceConfiguration, this._memoryConfiguration)), this._workspaceConsolidatedConfiguration;
  }
  getFolderConsolidatedConfiguration(e) {
    let t = this._foldersConsolidatedConfigurations.get(e);
    if (!t) {
      const n = this.getWorkspaceConsolidatedConfiguration(), i = this._folderConfigurations.get(e);
      i ? (t = n.merge(i), this._foldersConsolidatedConfigurations.set(e, t)) : t = n;
    }
    return t;
  }
  getFolderConfigurationModelForResource(e, t) {
    if (t && e) {
      const n = t.getFolder(e);
      if (n)
        return this._folderConfigurations.get(n.uri);
    }
  }
  toData() {
    return {
      defaults: {
        contents: this._defaultConfiguration.contents,
        overrides: this._defaultConfiguration.overrides,
        keys: this._defaultConfiguration.keys
      },
      policy: {
        contents: this._policyConfiguration.contents,
        overrides: this._policyConfiguration.overrides,
        keys: this._policyConfiguration.keys
      },
      application: {
        contents: this.applicationConfiguration.contents,
        overrides: this.applicationConfiguration.overrides,
        keys: this.applicationConfiguration.keys
      },
      user: {
        contents: this.userConfiguration.contents,
        overrides: this.userConfiguration.overrides,
        keys: this.userConfiguration.keys
      },
      workspace: {
        contents: this._workspaceConfiguration.contents,
        overrides: this._workspaceConfiguration.overrides,
        keys: this._workspaceConfiguration.keys
      },
      folders: [...this._folderConfigurations.keys()].reduce((e, t) => {
        const { contents: n, overrides: i, keys: s } = this._folderConfigurations.get(t);
        return e.push([t, { contents: n, overrides: i, keys: s }]), e;
      }, [])
    };
  }
  static parse(e, t) {
    const n = this.parseConfigurationModel(e.defaults, t), i = this.parseConfigurationModel(e.policy, t), s = this.parseConfigurationModel(e.application, t), o = this.parseConfigurationModel(e.user, t), a = this.parseConfigurationModel(e.workspace, t), l = e.folders.reduce((c, d) => (c.set(Pt.revive(d[0]), this.parseConfigurationModel(d[1], t)), c), new ws());
    return new yNe(n, i, s, o, mr.createEmptyModel(t), a, l, mr.createEmptyModel(t), new ws(), t);
  }
  static parseConfigurationModel(e, t) {
    return new mr(e.contents, e.keys, e.overrides, void 0, t);
  }
};
class ubt {
  constructor(e, t, n, i, s) {
    this.change = e, this.previous = t, this.currentConfiguraiton = n, this.currentWorkspace = i, this.logService = s, this._marker = `
`, this._markerCode1 = this._marker.charCodeAt(0), this._markerCode2 = 46, this.affectedKeys = /* @__PURE__ */ new Set(), this._previousConfiguration = void 0;
    for (const o of e.keys)
      this.affectedKeys.add(o);
    for (const [, o] of e.overrides)
      for (const a of o)
        this.affectedKeys.add(a);
    this._affectsConfigStr = this._marker;
    for (const o of this.affectedKeys)
      this._affectsConfigStr += o + this._marker;
  }
  get previousConfiguration() {
    return !this._previousConfiguration && this.previous && (this._previousConfiguration = bNe.parse(this.previous.data, this.logService)), this._previousConfiguration;
  }
  affectsConfiguration(e, t) {
    const n = this._marker + e, i = this._affectsConfigStr.indexOf(n);
    if (i < 0)
      return !1;
    const s = i + n.length;
    if (s >= this._affectsConfigStr.length)
      return !1;
    const o = this._affectsConfigStr.charCodeAt(s);
    if (o !== this._markerCode1 && o !== this._markerCode2)
      return !1;
    if (t) {
      const a = this.previousConfiguration ? this.previousConfiguration.getValue(e, t, this.previous?.workspace) : void 0, l = this.currentConfiguraiton.getValue(e, t, this.currentWorkspace);
      return !Ho(a, l);
    }
    return !0;
  }
}
const N9 = {
  kind: 0
  /* ResultKind.NoMatchingKb */
}, fbt = {
  kind: 1
  /* ResultKind.MoreChordsNeeded */
};
function pbt(r, e, t) {
  return { kind: 2, commandId: r, commandArgs: e, isBubble: t };
}
class i3 {
  constructor(e, t, n) {
    this._log = n, this._defaultKeybindings = e, this._defaultBoundCommands = /* @__PURE__ */ new Map();
    for (const i of e) {
      const s = i.command;
      s && s.charAt(0) !== "-" && this._defaultBoundCommands.set(s, !0);
    }
    this._map = /* @__PURE__ */ new Map(), this._lookupMap = /* @__PURE__ */ new Map(), this._keybindings = i3.handleRemovals([].concat(e).concat(t));
    for (let i = 0, s = this._keybindings.length; i < s; i++) {
      const o = this._keybindings[i];
      if (o.chords.length === 0)
        continue;
      const a = o.when?.substituteConstants();
      a && a.type === 0 || this._addKeyPress(o.chords[0], o);
    }
  }
  static _isTargetedForRemoval(e, t, n) {
    if (t) {
      for (let i = 0; i < t.length; i++)
        if (t[i] !== e.chords[i])
          return !1;
    }
    return !(n && n.type !== 1 && (!e.when || !g2t(n, e.when)));
  }
  /**
   * Looks for rules containing "-commandId" and removes them.
   */
  static handleRemovals(e) {
    const t = /* @__PURE__ */ new Map();
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      if (o.command && o.command.charAt(0) === "-") {
        const a = o.command.substring(1);
        t.has(a) ? t.get(a).push(o) : t.set(a, [o]);
      }
    }
    if (t.size === 0)
      return e;
    const n = [];
    for (let i = 0, s = e.length; i < s; i++) {
      const o = e[i];
      if (!o.command || o.command.length === 0) {
        n.push(o);
        continue;
      }
      if (o.command.charAt(0) === "-")
        continue;
      const a = t.get(o.command);
      if (!a || !o.isDefault) {
        n.push(o);
        continue;
      }
      let l = !1;
      for (const c of a) {
        const d = c.when;
        if (this._isTargetedForRemoval(o, c.chords, d)) {
          l = !0;
          break;
        }
      }
      if (!l) {
        n.push(o);
        continue;
      }
    }
    return n;
  }
  _addKeyPress(e, t) {
    const n = this._map.get(e);
    if (typeof n > "u") {
      this._map.set(e, [t]), this._addToLookupMap(t);
      return;
    }
    for (let i = n.length - 1; i >= 0; i--) {
      const s = n[i];
      if (s.command === t.command)
        continue;
      let o = !0;
      for (let a = 1; a < s.chords.length && a < t.chords.length; a++)
        if (s.chords[a] !== t.chords[a]) {
          o = !1;
          break;
        }
      o && i3.whenIsEntirelyIncluded(s.when, t.when) && this._removeFromLookupMap(s);
    }
    n.push(t), this._addToLookupMap(t);
  }
  _addToLookupMap(e) {
    if (!e.command)
      return;
    let t = this._lookupMap.get(e.command);
    typeof t > "u" ? (t = [e], this._lookupMap.set(e.command, t)) : t.push(e);
  }
  _removeFromLookupMap(e) {
    if (!e.command)
      return;
    const t = this._lookupMap.get(e.command);
    if (!(typeof t > "u")) {
      for (let n = 0, i = t.length; n < i; n++)
        if (t[n] === e) {
          t.splice(n, 1);
          return;
        }
    }
  }
  /**
   * Returns true if it is provable `a` implies `b`.
   */
  static whenIsEntirelyIncluded(e, t) {
    return !t || t.type === 1 ? !0 : !e || e.type === 1 ? !1 : ZD(e, t);
  }
  getKeybindings() {
    return this._keybindings;
  }
  lookupPrimaryKeybinding(e, t) {
    const n = this._lookupMap.get(e);
    if (typeof n > "u" || n.length === 0)
      return null;
    if (n.length === 1)
      return n[0];
    for (let i = n.length - 1; i >= 0; i--) {
      const s = n[i];
      if (t.contextMatchesRules(s.when))
        return s;
    }
    return n[n.length - 1];
  }
  /**
   * Looks up a keybinding trigged as a result of pressing a sequence of chords - `[...currentChords, keypress]`
   *
   * Example: resolving 3 chords pressed sequentially - `cmd+k cmd+p cmd+i`:
   * 	`currentChords = [ 'cmd+k' , 'cmd+p' ]` and `keypress = `cmd+i` - last pressed chord
   */
  resolve(e, t, n) {
    const i = [...t, n];
    this._log(`| Resolving ${i}`);
    const s = this._map.get(i[0]);
    if (s === void 0)
      return this._log("\\ No keybinding entries."), N9;
    let o = null;
    if (i.length < 2)
      o = s;
    else {
      o = [];
      for (let l = 0, c = s.length; l < c; l++) {
        const d = s[l];
        if (i.length > d.chords.length)
          continue;
        let u = !0;
        for (let f = 1; f < i.length; f++)
          if (d.chords[f] !== i[f]) {
            u = !1;
            break;
          }
        u && o.push(d);
      }
    }
    const a = this._findCommand(e, o);
    return a ? i.length < a.chords.length ? (this._log(`\\ From ${o.length} keybinding entries, awaiting ${a.chords.length - i.length} more chord(s), when: ${W8e(a.when)}, source: ${j8e(a)}.`), fbt) : (this._log(`\\ From ${o.length} keybinding entries, matched ${a.command}, when: ${W8e(a.when)}, source: ${j8e(a)}.`), pbt(a.command, a.commandArgs, a.bubble)) : (this._log(`\\ From ${o.length} keybinding entries, no when clauses matched the context.`), N9);
  }
  _findCommand(e, t) {
    for (let n = t.length - 1; n >= 0; n--) {
      const i = t[n];
      if (i3._contextMatchesRules(e, i.when))
        return i;
    }
    return null;
  }
  static _contextMatchesRules(e, t) {
    return t ? t.evaluate(e) : !0;
  }
}
function W8e(r) {
  return r ? `${r.serialize()}` : "no when condition";
}
function j8e(r) {
  return r.extensionId ? r.isBuiltinExtension ? `built-in extension ${r.extensionId}` : `user extension ${r.extensionId}` : r.isDefault ? "built-in" : "user";
}
const gbt = /^(cursor|delete|undo|redo|tab|editor\.action\.clipboard)/;
class mbt extends me {
  get onDidUpdateKeybindings() {
    return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : xe.None;
  }
  get inChordMode() {
    return this._currentChords.length > 0;
  }
  constructor(e, t, n, i, s) {
    super(), this._contextKeyService = e, this._commandService = t, this._telemetryService = n, this._notificationService = i, this._logService = s, this._onDidUpdateKeybindings = this._register(new $()), this._currentChords = [], this._currentChordChecker = new WI(), this._currentChordStatusMessage = null, this._ignoreSingleModifiers = op.EMPTY, this._currentSingleModifier = null, this._currentSingleModifierClearTimeout = new T1(), this._currentlyDispatchingCommandId = null, this._logging = !1;
  }
  dispose() {
    super.dispose();
  }
  _log(e) {
    this._logging && this._logService.info(`[KeybindingService]: ${e}`);
  }
  getKeybindings() {
    return this._getResolver().getKeybindings();
  }
  lookupKeybinding(e, t) {
    const n = this._getResolver().lookupPrimaryKeybinding(e, t || this._contextKeyService);
    if (n)
      return n.resolvedKeybinding;
  }
  dispatchEvent(e, t) {
    return this._dispatch(e, t);
  }
  // TODO@ulugbekna: update namings to align with `_doDispatch`
  // TODO@ulugbekna: this fn doesn't seem to take into account single-modifier keybindings, eg `shift shift`
  softDispatch(e, t) {
    this._log("/ Soft dispatching keyboard event");
    const n = this.resolveKeyboardEvent(e);
    if (n.hasMultipleChords())
      return console.warn("keyboard event should not be mapped to multiple chords"), N9;
    const [i] = n.getDispatchChords();
    if (i === null)
      return this._log("\\ Keyboard event cannot be dispatched"), N9;
    const s = this._contextKeyService.getContext(t), o = this._currentChords.map(({ keypress: a }) => a);
    return this._getResolver().resolve(s, o, i);
  }
  _scheduleLeaveChordMode() {
    const e = Date.now();
    this._currentChordChecker.cancelAndSet(() => {
      if (!this._documentHasFocus()) {
        this._leaveChordMode();
        return;
      }
      Date.now() - e > 5e3 && this._leaveChordMode();
    }, 500);
  }
  _expectAnotherChord(e, t) {
    switch (this._currentChords.push({ keypress: e, label: t }), this._currentChords.length) {
      case 0:
        throw SI("impossible");
      case 1:
        this._currentChordStatusMessage = this._notificationService.status(C("first.chord", "({0}) was pressed. Waiting for second key of chord...", t));
        break;
      default: {
        const n = this._currentChords.map(({ label: i }) => i).join(", ");
        this._currentChordStatusMessage = this._notificationService.status(C("next.chord", "({0}) was pressed. Waiting for next key of chord...", n));
      }
    }
    this._scheduleLeaveChordMode(), ZA.enabled && ZA.disable();
  }
  _leaveChordMode() {
    this._currentChordStatusMessage && (this._currentChordStatusMessage.dispose(), this._currentChordStatusMessage = null), this._currentChordChecker.cancel(), this._currentChords = [], ZA.enable();
  }
  _dispatch(e, t) {
    return this._doDispatch(
      this.resolveKeyboardEvent(e),
      t,
      /*isSingleModiferChord*/
      !1
    );
  }
  _singleModifierDispatch(e, t) {
    const n = this.resolveKeyboardEvent(e), [i] = n.getSingleModifierDispatchChords();
    if (i)
      return this._ignoreSingleModifiers.has(i) ? (this._log(`+ Ignoring single modifier ${i} due to it being pressed together with other keys.`), this._ignoreSingleModifiers = op.EMPTY, this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1) : (this._ignoreSingleModifiers = op.EMPTY, this._currentSingleModifier === null ? (this._log(`+ Storing single modifier for possible chord ${i}.`), this._currentSingleModifier = i, this._currentSingleModifierClearTimeout.cancelAndSet(() => {
        this._log("+ Clearing single modifier due to 300ms elapsed."), this._currentSingleModifier = null;
      }, 300), !1) : i === this._currentSingleModifier ? (this._log(`/ Dispatching single modifier chord ${i} ${i}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, this._doDispatch(
        n,
        t,
        /*isSingleModiferChord*/
        !0
      )) : (this._log(`+ Clearing single modifier due to modifier mismatch: ${this._currentSingleModifier} ${i}`), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1));
    const [s] = n.getChords();
    return this._ignoreSingleModifiers = new op(s), this._currentSingleModifier !== null && this._log("+ Clearing single modifier due to other key up."), this._currentSingleModifierClearTimeout.cancel(), this._currentSingleModifier = null, !1;
  }
  _doDispatch(e, t, n = !1) {
    let i = !1;
    if (e.hasMultipleChords())
      return console.warn("Unexpected keyboard event mapped to multiple chords"), !1;
    let s = null, o = null;
    if (n) {
      const [d] = e.getSingleModifierDispatchChords();
      s = d, o = d ? [d] : [];
    } else
      [s] = e.getDispatchChords(), o = this._currentChords.map(({ keypress: d }) => d);
    if (s === null)
      return this._log("\\ Keyboard event cannot be dispatched in keydown phase."), i;
    const a = this._contextKeyService.getContext(t), l = e.getLabel(), c = this._getResolver().resolve(a, o, s);
    switch (c.kind) {
      case 0: {
        if (this._logService.trace("KeybindingService#dispatch", l, "[ No matching keybinding ]"), this.inChordMode) {
          const d = this._currentChords.map(({ label: u }) => u).join(", ");
          this._log(`+ Leaving multi-chord mode: Nothing bound to "${d}, ${l}".`), this._notificationService.status(C("missing.chord", "The key combination ({0}, {1}) is not a command.", d, l), {
            hideAfter: 10 * 1e3
            /* 10s */
          }), this._leaveChordMode(), i = !0;
        }
        return i;
      }
      case 1:
        return this._logService.trace("KeybindingService#dispatch", l, "[ Several keybindings match - more chords needed ]"), i = !0, this._expectAnotherChord(s, l), this._log(this._currentChords.length === 1 ? "+ Entering multi-chord mode..." : "+ Continuing multi-chord mode..."), i;
      case 2: {
        if (this._logService.trace("KeybindingService#dispatch", l, `[ Will dispatch command ${c.commandId} ]`), c.commandId === null || c.commandId === "") {
          if (this.inChordMode) {
            const d = this._currentChords.map(({ label: u }) => u).join(", ");
            this._log(`+ Leaving chord mode: Nothing bound to "${d}, ${l}".`), this._notificationService.status(C("missing.chord", "The key combination ({0}, {1}) is not a command.", d, l), {
              hideAfter: 10 * 1e3
              /* 10s */
            }), this._leaveChordMode(), i = !0;
          }
        } else {
          this.inChordMode && this._leaveChordMode(), c.isBubble || (i = !0), this._log(`+ Invoking command ${c.commandId}.`), this._currentlyDispatchingCommandId = c.commandId;
          try {
            typeof c.commandArgs > "u" ? this._commandService.executeCommand(c.commandId).then(void 0, (d) => this._notificationService.warn(d)) : this._commandService.executeCommand(c.commandId, c.commandArgs).then(void 0, (d) => this._notificationService.warn(d));
          } finally {
            this._currentlyDispatchingCommandId = null;
          }
          gbt.test(c.commandId) || this._telemetryService.publicLog2("workbenchActionExecuted", { id: c.commandId, from: "keybinding", detail: e.getUserSettingsLabel() ?? void 0 });
        }
        return i;
      }
    }
  }
  mightProducePrintableCharacter(e) {
    return e.ctrlKey || e.metaKey ? !1 : e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30;
  }
}
class op {
  static {
    this.EMPTY = new op(null);
  }
  constructor(e) {
    this._ctrlKey = e ? e.ctrlKey : !1, this._shiftKey = e ? e.shiftKey : !1, this._altKey = e ? e.altKey : !1, this._metaKey = e ? e.metaKey : !1;
  }
  has(e) {
    switch (e) {
      case "ctrl":
        return this._ctrlKey;
      case "shift":
        return this._shiftKey;
      case "alt":
        return this._altKey;
      case "meta":
        return this._metaKey;
    }
  }
}
class Z8e {
  constructor(e, t, n, i, s, o, a) {
    this._resolvedKeybindingItemBrand = void 0, this.resolvedKeybinding = e, this.chords = e ? tk(e.getDispatchChords()) : [], e && this.chords.length === 0 && (this.chords = tk(e.getSingleModifierDispatchChords())), this.bubble = t ? t.charCodeAt(0) === 94 : !1, this.command = this.bubble ? t.substr(1) : t, this.commandArgs = n, this.when = i, this.isDefault = s, this.extensionId = o, this.isBuiltinExtension = a;
  }
}
function tk(r) {
  const e = [];
  for (let t = 0, n = r.length; t < n; t++) {
    const i = r[t];
    if (!i)
      return [];
    e.push(i);
  }
  return e;
}
class Ey {
  constructor(e, t, n = t) {
    this.modifierLabels = [null], this.modifierLabels[
      2
      /* OperatingSystem.Macintosh */
    ] = e, this.modifierLabels[
      1
      /* OperatingSystem.Windows */
    ] = t, this.modifierLabels[
      3
      /* OperatingSystem.Linux */
    ] = n;
  }
  toLabel(e, t, n) {
    if (t.length === 0)
      return null;
    const i = [];
    for (let s = 0, o = t.length; s < o; s++) {
      const a = t[s], l = n(a);
      if (l === null)
        return null;
      i[s] = bbt(a, l, this.modifierLabels[e]);
    }
    return i.join(" ");
  }
}
const fR = new Ey({
  ctrlKey: "⌃",
  shiftKey: "⇧",
  altKey: "⌥",
  metaKey: "⌘",
  separator: ""
}, {
  ctrlKey: C({ key: "ctrlKey", comment: ["This is the short form for the Control key on the keyboard"] }, "Ctrl"),
  shiftKey: C({ key: "shiftKey", comment: ["This is the short form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey", comment: ["This is the short form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "windowsKey", comment: ["This is the short form for the Windows key on the keyboard"] }, "Windows"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey", comment: ["This is the short form for the Control key on the keyboard"] }, "Ctrl"),
  shiftKey: C({ key: "shiftKey", comment: ["This is the short form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey", comment: ["This is the short form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "superKey", comment: ["This is the short form for the Super key on the keyboard"] }, "Super"),
  separator: "+"
}), Abt = new Ey({
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "optKey.long", comment: ["This is the long form for the Alt/Option key on the keyboard"] }, "Option"),
  metaKey: C({ key: "cmdKey.long", comment: ["This is the long form for the Command key on the keyboard"] }, "Command"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey.long", comment: ["This is the long form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "windowsKey.long", comment: ["This is the long form for the Windows key on the keyboard"] }, "Windows"),
  separator: "+"
}, {
  ctrlKey: C({ key: "ctrlKey.long", comment: ["This is the long form for the Control key on the keyboard"] }, "Control"),
  shiftKey: C({ key: "shiftKey.long", comment: ["This is the long form for the Shift key on the keyboard"] }, "Shift"),
  altKey: C({ key: "altKey.long", comment: ["This is the long form for the Alt key on the keyboard"] }, "Alt"),
  metaKey: C({ key: "superKey.long", comment: ["This is the long form for the Super key on the keyboard"] }, "Super"),
  separator: "+"
}), wbt = new Ey({
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Cmd",
  separator: "+"
}, {
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Super",
  separator: "+"
}), vbt = new Ey({
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "cmd",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "win",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "meta",
  separator: "+"
});
function bbt(r, e, t) {
  if (e === null)
    return "";
  const n = [];
  return r.ctrlKey && n.push(t.ctrlKey), r.shiftKey && n.push(t.shiftKey), r.altKey && n.push(t.altKey), r.metaKey && n.push(t.metaKey), e !== "" && n.push(e), n.join(t.separator);
}
class ybt extends B0t {
  constructor(e, t) {
    if (super(), t.length === 0)
      throw I7("chords");
    this._os = e, this._chords = t;
  }
  getLabel() {
    return fR.toLabel(this._os, this._chords, (e) => this._getLabel(e));
  }
  getAriaLabel() {
    return Abt.toLabel(this._os, this._chords, (e) => this._getAriaLabel(e));
  }
  getElectronAccelerator() {
    return this._chords.length > 1 || this._chords[0].isDuplicateModifierCase() ? null : wbt.toLabel(this._os, this._chords, (e) => this._getElectronAccelerator(e));
  }
  getUserSettingsLabel() {
    return vbt.toLabel(this._os, this._chords, (e) => this._getUserSettingsLabel(e));
  }
  hasMultipleChords() {
    return this._chords.length > 1;
  }
  getChords() {
    return this._chords.map((e) => this._getChord(e));
  }
  _getChord(e) {
    return new H0t(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, this._getLabel(e), this._getAriaLabel(e));
  }
  getDispatchChords() {
    return this._chords.map((e) => this._getChordDispatch(e));
  }
  getSingleModifierDispatchChords() {
    return this._chords.map((e) => this._getSingleModifierChordDispatch(e));
  }
}
class a4 extends ybt {
  constructor(e, t) {
    super(t, e);
  }
  _keyCodeToUILabel(e) {
    if (this._os === 2)
      switch (e) {
        case 15:
          return "←";
        case 16:
          return "↑";
        case 17:
          return "→";
        case 18:
          return "↓";
      }
    return sd.toString(e);
  }
  _getLabel(e) {
    return e.isDuplicateModifierCase() ? "" : this._keyCodeToUILabel(e.keyCode);
  }
  _getAriaLabel(e) {
    return e.isDuplicateModifierCase() ? "" : sd.toString(e.keyCode);
  }
  _getElectronAccelerator(e) {
    return sd.toElectronAccelerator(e.keyCode);
  }
  _getUserSettingsLabel(e) {
    if (e.isDuplicateModifierCase())
      return "";
    const t = sd.toUserSettingsUS(e.keyCode);
    return t && t.toLowerCase();
  }
  _getChordDispatch(e) {
    return a4.getDispatchStr(e);
  }
  static getDispatchStr(e) {
    if (e.isModifierKey())
      return null;
    let t = "";
    return e.ctrlKey && (t += "ctrl+"), e.shiftKey && (t += "shift+"), e.altKey && (t += "alt+"), e.metaKey && (t += "meta+"), t += sd.toString(e.keyCode), t;
  }
  _getSingleModifierChordDispatch(e) {
    return e.keyCode === 5 && !e.shiftKey && !e.altKey && !e.metaKey ? "ctrl" : e.keyCode === 4 && !e.ctrlKey && !e.altKey && !e.metaKey ? "shift" : e.keyCode === 6 && !e.ctrlKey && !e.shiftKey && !e.metaKey ? "alt" : e.keyCode === 57 && !e.ctrlKey && !e.shiftKey && !e.altKey ? "meta" : null;
  }
  /**
   * *NOTE*: Check return value for `KeyCode.Unknown`.
   */
  static _scanCodeToKeyCode(e) {
    const t = NI[e];
    if (t !== -1)
      return t;
    switch (e) {
      case 10:
        return 31;
      case 11:
        return 32;
      case 12:
        return 33;
      case 13:
        return 34;
      case 14:
        return 35;
      case 15:
        return 36;
      case 16:
        return 37;
      case 17:
        return 38;
      case 18:
        return 39;
      case 19:
        return 40;
      case 20:
        return 41;
      case 21:
        return 42;
      case 22:
        return 43;
      case 23:
        return 44;
      case 24:
        return 45;
      case 25:
        return 46;
      case 26:
        return 47;
      case 27:
        return 48;
      case 28:
        return 49;
      case 29:
        return 50;
      case 30:
        return 51;
      case 31:
        return 52;
      case 32:
        return 53;
      case 33:
        return 54;
      case 34:
        return 55;
      case 35:
        return 56;
      case 36:
        return 22;
      case 37:
        return 23;
      case 38:
        return 24;
      case 39:
        return 25;
      case 40:
        return 26;
      case 41:
        return 27;
      case 42:
        return 28;
      case 43:
        return 29;
      case 44:
        return 30;
      case 45:
        return 21;
      case 51:
        return 88;
      case 52:
        return 86;
      case 53:
        return 92;
      case 54:
        return 94;
      case 55:
        return 93;
      case 56:
        return 0;
      // missing
      case 57:
        return 85;
      case 58:
        return 95;
      case 59:
        return 91;
      case 60:
        return 87;
      case 61:
        return 89;
      case 62:
        return 90;
      case 106:
        return 97;
    }
    return 0;
  }
  static _toKeyCodeChord(e) {
    if (!e)
      return null;
    if (e instanceof gf)
      return e;
    const t = this._scanCodeToKeyCode(e.scanCode);
    return t === 0 ? null : new gf(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, t);
  }
  static resolveKeybinding(e, t) {
    const n = tk(e.chords.map((i) => this._toKeyCodeChord(i)));
    return n.length > 0 ? [new a4(n, t)] : [];
  }
}
const Cbt = Wt("labelService"), Ebt = Wt("progressService");
class mtn {
  static {
    this.None = Object.freeze({ report() {
    } });
  }
  constructor(e) {
    this.callback = e;
  }
  report(e) {
    this._value = e, this.callback(this._value);
  }
}
const pR = Wt("editorProgressService");
class _bt {
  constructor() {
    this._value = "", this._pos = 0;
  }
  reset(e) {
    return this._value = e, this._pos = 0, this;
  }
  next() {
    return this._pos += 1, this;
  }
  hasNext() {
    return this._pos < this._value.length - 1;
  }
  cmp(e) {
    const t = e.charCodeAt(0), n = this._value.charCodeAt(this._pos);
    return t - n;
  }
  value() {
    return this._value[this._pos];
  }
}
class xbt {
  constructor(e = !0) {
    this._caseSensitive = e;
  }
  reset(e) {
    return this._value = e, this._from = 0, this._to = 0, this.next();
  }
  hasNext() {
    return this._to < this._value.length;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._value.length; this._to++)
      if (this._value.charCodeAt(this._to) === 46)
        if (e)
          this._from++;
        else
          break;
      else
        e = !1;
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? II(e, this._value, 0, e.length, this._from, this._to) : ww(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class Sbt {
  constructor(e = !0, t = !0) {
    this._splitOnBackslash = e, this._caseSensitive = t;
  }
  reset(e) {
    this._from = 0, this._to = 0, this._value = e, this._valueLen = e.length;
    for (let t = e.length - 1; t >= 0; t--, this._valueLen--) {
      const n = this._value.charCodeAt(t);
      if (!(n === 47 || this._splitOnBackslash && n === 92))
        break;
    }
    return this.next();
  }
  hasNext() {
    return this._to < this._valueLen;
  }
  next() {
    this._from = this._to;
    let e = !0;
    for (; this._to < this._valueLen; this._to++) {
      const t = this._value.charCodeAt(this._to);
      if (t === 47 || this._splitOnBackslash && t === 92)
        if (e)
          this._from++;
        else
          break;
      else
        e = !1;
    }
    return this;
  }
  cmp(e) {
    return this._caseSensitive ? II(e, this._value, 0, e.length, this._from, this._to) : ww(e, this._value, 0, e.length, this._from, this._to);
  }
  value() {
    return this._value.substring(this._from, this._to);
  }
}
class Mbt {
  constructor(e, t) {
    this._ignorePathCasing = e, this._ignoreQueryAndFragment = t, this._states = [], this._stateIdx = 0;
  }
  reset(e) {
    return this._value = e, this._states = [], this._value.scheme && this._states.push(
      1
      /* UriIteratorState.Scheme */
    ), this._value.authority && this._states.push(
      2
      /* UriIteratorState.Authority */
    ), this._value.path && (this._pathIterator = new Sbt(!1, !this._ignorePathCasing(e)), this._pathIterator.reset(e.path), this._pathIterator.value() && this._states.push(
      3
      /* UriIteratorState.Path */
    )), this._ignoreQueryAndFragment(e) || (this._value.query && this._states.push(
      4
      /* UriIteratorState.Query */
    ), this._value.fragment && this._states.push(
      5
      /* UriIteratorState.Fragment */
    )), this._stateIdx = 0, this;
  }
  next() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() ? this._pathIterator.next() : this._stateIdx += 1, this;
  }
  hasNext() {
    return this._states[this._stateIdx] === 3 && this._pathIterator.hasNext() || this._stateIdx < this._states.length - 1;
  }
  cmp(e) {
    if (this._states[this._stateIdx] === 1)
      return Ive(e, this._value.scheme);
    if (this._states[this._stateIdx] === 2)
      return Ive(e, this._value.authority);
    if (this._states[this._stateIdx] === 3)
      return this._pathIterator.cmp(e);
    if (this._states[this._stateIdx] === 4)
      return LD(e, this._value.query);
    if (this._states[this._stateIdx] === 5)
      return LD(e, this._value.fragment);
    throw new Error();
  }
  value() {
    if (this._states[this._stateIdx] === 1)
      return this._value.scheme;
    if (this._states[this._stateIdx] === 2)
      return this._value.authority;
    if (this._states[this._stateIdx] === 3)
      return this._pathIterator.value();
    if (this._states[this._stateIdx] === 4)
      return this._value.query;
    if (this._states[this._stateIdx] === 5)
      return this._value.fragment;
    throw new Error();
  }
}
class t5 {
  constructor() {
    this.height = 1;
  }
  rotateLeft() {
    const e = this.right;
    return this.right = e.left, e.left = this, this.updateHeight(), e.updateHeight(), e;
  }
  rotateRight() {
    const e = this.left;
    return this.left = e.right, e.right = this, this.updateHeight(), e.updateHeight(), e;
  }
  updateHeight() {
    this.height = 1 + Math.max(this.heightLeft, this.heightRight);
  }
  balanceFactor() {
    return this.heightRight - this.heightLeft;
  }
  get heightLeft() {
    return this.left?.height ?? 0;
  }
  get heightRight() {
    return this.right?.height ?? 0;
  }
}
class r3 {
  static forUris(e = () => !1, t = () => !1) {
    return new r3(new Mbt(e, t));
  }
  static forStrings() {
    return new r3(new _bt());
  }
  static forConfigKeys() {
    return new r3(new xbt());
  }
  constructor(e) {
    this._iter = e;
  }
  clear() {
    this._root = void 0;
  }
  set(e, t) {
    const n = this._iter.reset(e);
    let i;
    this._root || (this._root = new t5(), this._root.segment = n.value());
    const s = [];
    for (i = this._root; ; ) {
      const a = n.cmp(i.segment);
      if (a > 0)
        i.left || (i.left = new t5(), i.left.segment = n.value()), s.push([-1, i]), i = i.left;
      else if (a < 0)
        i.right || (i.right = new t5(), i.right.segment = n.value()), s.push([1, i]), i = i.right;
      else if (n.hasNext())
        n.next(), i.mid || (i.mid = new t5(), i.mid.segment = n.value()), s.push([0, i]), i = i.mid;
      else
        break;
    }
    const o = i.value;
    i.value = t, i.key = e;
    for (let a = s.length - 1; a >= 0; a--) {
      const l = s[a][1];
      l.updateHeight();
      const c = l.balanceFactor();
      if (c < -1 || c > 1) {
        const d = s[a][0], u = s[a + 1][0];
        if (d === 1 && u === 1)
          s[a][1] = l.rotateLeft();
        else if (d === -1 && u === -1)
          s[a][1] = l.rotateRight();
        else if (d === 1 && u === -1)
          l.right = s[a + 1][1] = s[a + 1][1].rotateRight(), s[a][1] = l.rotateLeft();
        else if (d === -1 && u === 1)
          l.left = s[a + 1][1] = s[a + 1][1].rotateLeft(), s[a][1] = l.rotateRight();
        else
          throw new Error();
        if (a > 0)
          switch (s[a - 1][0]) {
            case -1:
              s[a - 1][1].left = s[a][1];
              break;
            case 1:
              s[a - 1][1].right = s[a][1];
              break;
            case 0:
              s[a - 1][1].mid = s[a][1];
              break;
          }
        else
          this._root = s[0][1];
      }
    }
    return o;
  }
  get(e) {
    return this._getNode(e)?.value;
  }
  _getNode(e) {
    const t = this._iter.reset(e);
    let n = this._root;
    for (; n; ) {
      const i = t.cmp(n.segment);
      if (i > 0)
        n = n.left;
      else if (i < 0)
        n = n.right;
      else if (t.hasNext())
        t.next(), n = n.mid;
      else
        break;
    }
    return n;
  }
  has(e) {
    const t = this._getNode(e);
    return !(t?.value === void 0 && t?.mid === void 0);
  }
  delete(e) {
    return this._delete(e, !1);
  }
  deleteSuperstr(e) {
    return this._delete(e, !0);
  }
  _delete(e, t) {
    const n = this._iter.reset(e), i = [];
    let s = this._root;
    for (; s; ) {
      const o = n.cmp(s.segment);
      if (o > 0)
        i.push([-1, s]), s = s.left;
      else if (o < 0)
        i.push([1, s]), s = s.right;
      else if (n.hasNext())
        n.next(), i.push([0, s]), s = s.mid;
      else
        break;
    }
    if (s) {
      if (t ? (s.left = void 0, s.mid = void 0, s.right = void 0, s.height = 1) : (s.key = void 0, s.value = void 0), !s.mid && !s.value)
        if (s.left && s.right) {
          const o = this._min(s.right);
          if (o.key) {
            const { key: a, value: l, segment: c } = o;
            this._delete(o.key, !1), s.key = a, s.value = l, s.segment = c;
          }
        } else {
          const o = s.left ?? s.right;
          if (i.length > 0) {
            const [a, l] = i[i.length - 1];
            switch (a) {
              case -1:
                l.left = o;
                break;
              case 0:
                l.mid = o;
                break;
              case 1:
                l.right = o;
                break;
            }
          } else
            this._root = o;
        }
      for (let o = i.length - 1; o >= 0; o--) {
        const a = i[o][1];
        a.updateHeight();
        const l = a.balanceFactor();
        if (l > 1 ? (a.right.balanceFactor() >= 0 || (a.right = a.right.rotateRight()), i[o][1] = a.rotateLeft()) : l < -1 && (a.left.balanceFactor() <= 0 || (a.left = a.left.rotateLeft()), i[o][1] = a.rotateRight()), o > 0)
          switch (i[o - 1][0]) {
            case -1:
              i[o - 1][1].left = i[o][1];
              break;
            case 1:
              i[o - 1][1].right = i[o][1];
              break;
            case 0:
              i[o - 1][1].mid = i[o][1];
              break;
          }
        else
          this._root = i[0][1];
      }
    }
  }
  _min(e) {
    for (; e.left; )
      e = e.left;
    return e;
  }
  findSubstr(e) {
    const t = this._iter.reset(e);
    let n = this._root, i;
    for (; n; ) {
      const s = t.cmp(n.segment);
      if (s > 0)
        n = n.left;
      else if (s < 0)
        n = n.right;
      else if (t.hasNext())
        t.next(), i = n.value || i, n = n.mid;
      else
        break;
    }
    return n && n.value || i;
  }
  findSuperstr(e) {
    return this._findSuperstrOrElement(e, !1);
  }
  _findSuperstrOrElement(e, t) {
    const n = this._iter.reset(e);
    let i = this._root;
    for (; i; ) {
      const s = n.cmp(i.segment);
      if (s > 0)
        i = i.left;
      else if (s < 0)
        i = i.right;
      else if (n.hasNext())
        n.next(), i = i.mid;
      else
        return i.mid ? this._entries(i.mid) : t ? i.value : void 0;
    }
  }
  forEach(e) {
    for (const [t, n] of this)
      e(n, t);
  }
  *[Symbol.iterator]() {
    yield* this._entries(this._root);
  }
  _entries(e) {
    const t = [];
    return this._dfsEntries(e, t), t[Symbol.iterator]();
  }
  _dfsEntries(e, t) {
    e && (e.left && this._dfsEntries(e.left, t), e.value && t.push([e.key, e.value]), e.mid && this._dfsEntries(e.mid, t), e.right && this._dfsEntries(e.right, t));
  }
}
const Dbt = Wt("contextService");
class Lbt {
  constructor(e, t) {
    this.raw = t, this.uri = e.uri, this.index = e.index, this.name = e.name;
  }
  toJSON() {
    return { uri: this.uri, name: this.name, index: this.index };
  }
}
const kbt = "code-workspace";
C("codeWorkspace", "Code Workspace");
const Nbt = "4064f6ec-cb38-4ad0-af64-ee6467e63c82";
var U8e;
(function(r) {
  r.inspectTokensAction = C("inspectTokens", "Developer: Inspect Tokens");
})(U8e || (U8e = {}));
var q8e;
(function(r) {
  r.gotoLineActionLabel = C("gotoLineActionLabel", "Go to Line/Column...");
})(q8e || (q8e = {}));
var G8e;
(function(r) {
  r.helpQuickAccessActionLabel = C("helpQuickAccess", "Show all Quick Access Providers");
})(G8e || (G8e = {}));
var Q8e;
(function(r) {
  r.quickCommandActionLabel = C("quickCommandActionLabel", "Command Palette"), r.quickCommandHelp = C("quickCommandActionHelp", "Show And Run Commands");
})(Q8e || (Q8e = {}));
var K8e;
(function(r) {
  r.quickOutlineActionLabel = C("quickOutlineActionLabel", "Go to Symbol..."), r.quickOutlineByCategoryActionLabel = C("quickOutlineByCategoryActionLabel", "Go to Symbol by Category...");
})(K8e || (K8e = {}));
var T9;
(function(r) {
  r.editorViewAccessibleLabel = C("editorViewAccessibleLabel", "Editor content"), r.accessibilityHelpMessage = C("accessibilityHelpMessage", "Press Alt+F1 for Accessibility Options.");
})(T9 || (T9 = {}));
var Y8e;
(function(r) {
  r.toggleHighContrast = C("toggleHighContrast", "Toggle High Contrast Theme");
})(Y8e || (Y8e = {}));
var nk;
(function(r) {
  r.bulkEditServiceSummary = C("bulkEditServiceSummary", "Made {0} edits in {1} files");
})(nk || (nk = {}));
const Tbt = Wt("workspaceTrustManagementService");
let Ag = [], gR = [], CNe = [];
function n5(r, e = !1) {
  Ibt(r, !1, e);
}
function Ibt(r, e, t) {
  const n = Obt(r, e);
  Ag.push(n), n.userConfigured ? CNe.push(n) : gR.push(n), t && !n.userConfigured && Ag.forEach((i) => {
    i.mime === n.mime || i.userConfigured || (n.extension && i.extension === n.extension && console.warn(`Overwriting extension <<${n.extension}>> to now point to mime <<${n.mime}>>`), n.filename && i.filename === n.filename && console.warn(`Overwriting filename <<${n.filename}>> to now point to mime <<${n.mime}>>`), n.filepattern && i.filepattern === n.filepattern && console.warn(`Overwriting filepattern <<${n.filepattern}>> to now point to mime <<${n.mime}>>`), n.firstline && i.firstline === n.firstline && console.warn(`Overwriting firstline <<${n.firstline}>> to now point to mime <<${n.mime}>>`));
  });
}
function Obt(r, e) {
  return {
    id: r.id,
    mime: r.mime,
    filename: r.filename,
    extension: r.extension,
    filepattern: r.filepattern,
    firstline: r.firstline,
    userConfigured: e,
    filenameLowercase: r.filename ? r.filename.toLowerCase() : void 0,
    extensionLowercase: r.extension ? r.extension.toLowerCase() : void 0,
    filepatternLowercase: r.filepattern ? eNe(r.filepattern.toLowerCase()) : void 0,
    filepatternOnPath: r.filepattern ? r.filepattern.indexOf(Si.sep) >= 0 : !1
  };
}
function Rbt() {
  Ag = Ag.filter((r) => r.userConfigured), gR = [];
}
function Vbt(r, e) {
  return Hbt(r, e).map((t) => t.id);
}
function Hbt(r, e) {
  let t;
  if (r)
    switch (r.scheme) {
      case Ct.file:
        t = r.fsPath;
        break;
      case Ct.data: {
        t = A9.parseMetaData(r).get(A9.META_DATA_LABEL);
        break;
      }
      case Ct.vscodeNotebookCell:
        t = void 0;
        break;
      default:
        t = r.path;
    }
  if (!t)
    return [{ id: "unknown", mime: ad.unknown }];
  t = t.toLowerCase();
  const n = KMe(t), i = X8e(t, n, CNe);
  if (i)
    return [i, { id: ll, mime: ad.text }];
  const s = X8e(t, n, gR);
  if (s)
    return [s, { id: ll, mime: ad.text }];
  if (e) {
    const o = Bbt(e);
    if (o)
      return [o, { id: ll, mime: ad.text }];
  }
  return [{ id: "unknown", mime: ad.unknown }];
}
function X8e(r, e, t) {
  let n, i, s;
  for (let o = t.length - 1; o >= 0; o--) {
    const a = t[o];
    if (e === a.filenameLowercase) {
      n = a;
      break;
    }
    if (a.filepattern && (!i || a.filepattern.length > i.filepattern.length)) {
      const l = a.filepatternOnPath ? r : e;
      a.filepatternLowercase?.(l) && (i = a);
    }
    a.extension && (!s || a.extension.length > s.extension.length) && e.endsWith(a.extensionLowercase) && (s = a);
  }
  if (n)
    return n;
  if (i)
    return i;
  if (s)
    return s;
}
function Bbt(r) {
  if (FI(r) && (r = r.substr(1)), r.length > 0)
    for (let e = Ag.length - 1; e >= 0; e--) {
      const t = Ag[e];
      if (!t.firstline)
        continue;
      const n = r.match(t.firstline);
      if (n && n.length > 0)
        return t;
    }
}
const i5 = Object.prototype.hasOwnProperty, J8e = "vs.editor.nullLanguage";
class Pbt {
  constructor() {
    this._languageIdToLanguage = [], this._languageToLanguageId = /* @__PURE__ */ new Map(), this._register(
      J8e,
      0
      /* LanguageId.Null */
    ), this._register(
      ll,
      1
      /* LanguageId.PlainText */
    ), this._nextLanguageId = 2;
  }
  _register(e, t) {
    this._languageIdToLanguage[t] = e, this._languageToLanguageId.set(e, t);
  }
  register(e) {
    if (this._languageToLanguageId.has(e))
      return;
    const t = this._nextLanguageId++;
    this._register(e, t);
  }
  encodeLanguageId(e) {
    return this._languageToLanguageId.get(e) || 0;
  }
  decodeLanguageId(e) {
    return this._languageIdToLanguage[e] || J8e;
  }
}
class I9 extends me {
  static {
    this.instanceCount = 0;
  }
  constructor(e = !0, t = !1) {
    super(), this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, I9.instanceCount++, this._warnOnOverwrite = t, this.languageIdCodec = new Pbt(), this._dynamicLanguages = [], this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, e && (this._initializeFromRegistry(), this._register(ag.onDidChangeLanguages((n) => {
      this._initializeFromRegistry();
    })));
  }
  dispose() {
    I9.instanceCount--, super.dispose();
  }
  _initializeFromRegistry() {
    this._languages = {}, this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Rbt();
    const e = [].concat(ag.getLanguages()).concat(this._dynamicLanguages);
    this._registerLanguages(e);
  }
  _registerLanguages(e) {
    for (const t of e)
      this._registerLanguage(t);
    this._mimeTypesMap = {}, this._nameMap = {}, this._lowercaseNameMap = {}, Object.keys(this._languages).forEach((t) => {
      const n = this._languages[t];
      n.name && (this._nameMap[n.name] = n.identifier), n.aliases.forEach((i) => {
        this._lowercaseNameMap[i.toLowerCase()] = n.identifier;
      }), n.mimetypes.forEach((i) => {
        this._mimeTypesMap[i] = n.identifier;
      });
    }), Er.as($f.Configuration).registerOverrideIdentifiers(this.getRegisteredLanguageIds()), this._onDidChange.fire();
  }
  _registerLanguage(e) {
    const t = e.id;
    let n;
    i5.call(this._languages, t) ? n = this._languages[t] : (this.languageIdCodec.register(t), n = {
      identifier: t,
      name: null,
      mimetypes: [],
      aliases: [],
      extensions: [],
      filenames: [],
      configurationFiles: [],
      icons: []
    }, this._languages[t] = n), this._mergeLanguage(n, e);
  }
  _mergeLanguage(e, t) {
    const n = t.id;
    let i = null;
    if (Array.isArray(t.mimetypes) && t.mimetypes.length > 0 && (e.mimetypes.push(...t.mimetypes), i = t.mimetypes[0]), i || (i = `text/x-${n}`, e.mimetypes.push(i)), Array.isArray(t.extensions)) {
      t.configuration ? e.extensions = t.extensions.concat(e.extensions) : e.extensions = e.extensions.concat(t.extensions);
      for (const a of t.extensions)
        n5({ id: n, mime: i, extension: a }, this._warnOnOverwrite);
    }
    if (Array.isArray(t.filenames))
      for (const a of t.filenames)
        n5({ id: n, mime: i, filename: a }, this._warnOnOverwrite), e.filenames.push(a);
    if (Array.isArray(t.filenamePatterns))
      for (const a of t.filenamePatterns)
        n5({ id: n, mime: i, filepattern: a }, this._warnOnOverwrite);
    if (typeof t.firstLine == "string" && t.firstLine.length > 0) {
      let a = t.firstLine;
      a.charAt(0) !== "^" && (a = "^" + a);
      try {
        const l = new RegExp(a);
        x0t(l) || n5({ id: n, mime: i, firstline: l }, this._warnOnOverwrite);
      } catch (l) {
        console.warn(`[${t.id}]: Invalid regular expression \`${a}\`: `, l);
      }
    }
    e.aliases.push(n);
    let s = null;
    if (typeof t.aliases < "u" && Array.isArray(t.aliases) && (t.aliases.length === 0 ? s = [null] : s = t.aliases), s !== null)
      for (const a of s)
        !a || a.length === 0 || e.aliases.push(a);
    const o = s !== null && s.length > 0;
    if (!(o && s[0] === null)) {
      const a = (o ? s[0] : null) || n;
      (o || !e.name) && (e.name = a);
    }
    t.configuration && e.configurationFiles.push(t.configuration), t.icon && e.icons.push(t.icon);
  }
  isRegisteredLanguageId(e) {
    return e ? i5.call(this._languages, e) : !1;
  }
  getRegisteredLanguageIds() {
    return Object.keys(this._languages);
  }
  getLanguageIdByLanguageName(e) {
    const t = e.toLowerCase();
    return i5.call(this._lowercaseNameMap, t) ? this._lowercaseNameMap[t] : null;
  }
  getLanguageIdByMimeType(e) {
    return e && i5.call(this._mimeTypesMap, e) ? this._mimeTypesMap[e] : null;
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    return !e && !t ? [] : Vbt(e, t);
  }
}
class O9 extends me {
  static {
    this.instanceCount = 0;
  }
  constructor(e = !1) {
    super(), this._onDidRequestBasicLanguageFeatures = this._register(new $()), this.onDidRequestBasicLanguageFeatures = this._onDidRequestBasicLanguageFeatures.event, this._onDidRequestRichLanguageFeatures = this._register(new $()), this.onDidRequestRichLanguageFeatures = this._onDidRequestRichLanguageFeatures.event, this._onDidChange = this._register(new $({
      leakWarningThreshold: 200
      /* https://github.com/microsoft/vscode/issues/119968 */
    })), this.onDidChange = this._onDidChange.event, this._requestedBasicLanguages = /* @__PURE__ */ new Set(), this._requestedRichLanguages = /* @__PURE__ */ new Set(), O9.instanceCount++, this._registry = this._register(new I9(!0, e)), this.languageIdCodec = this._registry.languageIdCodec, this._register(this._registry.onDidChange(() => this._onDidChange.fire()));
  }
  dispose() {
    O9.instanceCount--, super.dispose();
  }
  isRegisteredLanguageId(e) {
    return this._registry.isRegisteredLanguageId(e);
  }
  getLanguageIdByLanguageName(e) {
    return this._registry.getLanguageIdByLanguageName(e);
  }
  getLanguageIdByMimeType(e) {
    return this._registry.getLanguageIdByMimeType(e);
  }
  guessLanguageIdByFilepathOrFirstLine(e, t) {
    const n = this._registry.guessLanguageIdByFilepathOrFirstLine(e, t);
    return vI(n, null);
  }
  createById(e) {
    return new $8e(this.onDidChange, () => this._createAndGetLanguageIdentifier(e));
  }
  createByFilepathOrFirstLine(e, t) {
    return new $8e(this.onDidChange, () => {
      const n = this.guessLanguageIdByFilepathOrFirstLine(e, t);
      return this._createAndGetLanguageIdentifier(n);
    });
  }
  _createAndGetLanguageIdentifier(e) {
    return (!e || !this.isRegisteredLanguageId(e)) && (e = ll), e;
  }
  requestBasicLanguageFeatures(e) {
    this._requestedBasicLanguages.has(e) || (this._requestedBasicLanguages.add(e), this._onDidRequestBasicLanguageFeatures.fire(e));
  }
  requestRichLanguageFeatures(e) {
    this._requestedRichLanguages.has(e) || (this._requestedRichLanguages.add(e), this.requestBasicLanguageFeatures(e), xi.getOrCreate(e), this._onDidRequestRichLanguageFeatures.fire(e));
  }
}
class $8e {
  constructor(e, t) {
    this._onDidChangeLanguages = e, this._selector = t, this._listener = null, this._emitter = null, this.languageId = this._selector();
  }
  _dispose() {
    this._listener && (this._listener.dispose(), this._listener = null), this._emitter && (this._emitter.dispose(), this._emitter = null);
  }
  get onDidChange() {
    return this._listener || (this._listener = this._onDidChangeLanguages(() => this._evaluate())), this._emitter || (this._emitter = new $({
      onDidRemoveLastListener: () => {
        this._dispose();
      }
    })), this._emitter.event;
  }
  _evaluate() {
    const e = this._selector();
    e !== this.languageId && (this.languageId = e, this._emitter?.fire(this.languageId));
  }
}
const ENe = {
  /**
   * Typically transfer type for copy/paste transfers.
   */
  TEXT: ad.text
}, Fbt = () => ({
  get delay() {
    return -1;
  },
  dispose: () => {
  },
  showHover: () => {
  }
});
let _y = Fbt;
const zbt = new o1(() => _y("mouse", !1)), Wbt = new o1(() => _y("element", !1));
function jbt(r) {
  _y = r;
}
function fo(r) {
  return r === "element" ? Wbt.value : zbt.value;
}
function wg() {
  return _y("element", !0);
}
let _Ne = {
  showHover: () => {
  },
  hideHover: () => {
  },
  showAndFocusLastHover: () => {
  },
  setupManagedHover: () => null,
  showManagedHover: () => {
  }
};
function Zbt(r) {
  _Ne = r;
}
function Mh() {
  return _Ne;
}
class Ubt {
  constructor(e) {
    this.spliceables = e;
  }
  splice(e, t, n) {
    this.spliceables.forEach((i) => i.splice(e, t, n));
  }
}
class K1 extends Error {
  constructor(e, t) {
    super(`ListError [${e}] ${t}`);
  }
}
function e9e(r, e) {
  const t = [];
  for (const n of e) {
    if (r.start >= n.range.end)
      continue;
    if (r.end < n.range.start)
      break;
    const i = Rr.intersect(r, n.range);
    Rr.isEmpty(i) || t.push({
      range: i,
      size: n.size
    });
  }
  return t;
}
function ik({ start: r, end: e }, t) {
  return { start: r + t, end: e + t };
}
function qbt(r) {
  const e = [];
  let t = null;
  for (const n of r) {
    const i = n.range.start, s = n.range.end, o = n.size;
    if (t && o === t.size) {
      t.range.end = s;
      continue;
    }
    t = { range: { start: i, end: s }, size: o }, e.push(t);
  }
  return e;
}
function Gbt(...r) {
  return qbt(r.reduce((e, t) => e.concat(t), []));
}
class Qbt {
  get paddingTop() {
    return this._paddingTop;
  }
  set paddingTop(e) {
    this._size = this._size + e - this._paddingTop, this._paddingTop = e;
  }
  constructor(e) {
    this.groups = [], this._size = 0, this._paddingTop = 0, this._paddingTop = e ?? 0, this._size = this._paddingTop;
  }
  splice(e, t, n = []) {
    const i = n.length - t, s = e9e({ start: 0, end: e }, this.groups), o = e9e({ start: e + t, end: Number.POSITIVE_INFINITY }, this.groups).map((l) => ({ range: ik(l.range, i), size: l.size })), a = n.map((l, c) => ({
      range: { start: e + c, end: e + c + 1 },
      size: l.size
    }));
    this.groups = Gbt(s, a, o), this._size = this._paddingTop + this.groups.reduce((l, c) => l + c.size * (c.range.end - c.range.start), 0);
  }
  /**
   * Returns the number of items in the range map.
   */
  get count() {
    const e = this.groups.length;
    return e ? this.groups[e - 1].range.end : 0;
  }
  /**
   * Returns the sum of the sizes of all items in the range map.
   */
  get size() {
    return this._size;
  }
  /**
   * Returns the index of the item at the given position.
   */
  indexAt(e) {
    if (e < 0)
      return -1;
    if (e < this._paddingTop)
      return 0;
    let t = 0, n = this._paddingTop;
    for (const i of this.groups) {
      const s = i.range.end - i.range.start, o = n + s * i.size;
      if (e < o)
        return t + Math.floor((e - n) / i.size);
      t += s, n = o;
    }
    return t;
  }
  /**
   * Returns the index of the item right after the item at the
   * index of the given position.
   */
  indexAfter(e) {
    return Math.min(this.indexAt(e) + 1, this.count);
  }
  /**
   * Returns the start position of the item at the given index.
   */
  positionAt(e) {
    if (e < 0)
      return -1;
    let t = 0, n = 0;
    for (const i of this.groups) {
      const s = i.range.end - i.range.start, o = n + s;
      if (e < o)
        return this._paddingTop + t + (e - n) * i.size;
      t += s * i.size, n = o;
    }
    return -1;
  }
}
class Kbt {
  constructor(e) {
    this.renderers = e, this.cache = /* @__PURE__ */ new Map(), this.transactionNodesPendingRemoval = /* @__PURE__ */ new Set(), this.inTransaction = !1;
  }
  /**
   * Returns a row either by creating a new one or reusing
   * a previously released row which shares the same templateId.
   *
   * @returns A row and `isReusingConnectedDomNode` if the row's node is already in the dom in a stale position.
   */
  alloc(e) {
    let t = this.getTemplateCache(e).pop(), n = !1;
    if (t)
      n = this.transactionNodesPendingRemoval.has(t.domNode), n && this.transactionNodesPendingRemoval.delete(t.domNode);
    else {
      const i = $e(".monaco-list-row"), o = this.getRenderer(e).renderTemplate(i);
      t = { domNode: i, templateId: e, templateData: o };
    }
    return { row: t, isReusingConnectedDomNode: n };
  }
  /**
   * Releases the row for eventual reuse.
   */
  release(e) {
    e && this.releaseRow(e);
  }
  /**
   * Begin a set of changes that use the cache. This lets us skip work when a row is removed and then inserted again.
   */
  transact(e) {
    if (this.inTransaction)
      throw new Error("Already in transaction");
    this.inTransaction = !0;
    try {
      e();
    } finally {
      for (const t of this.transactionNodesPendingRemoval)
        this.doRemoveNode(t);
      this.transactionNodesPendingRemoval.clear(), this.inTransaction = !1;
    }
  }
  releaseRow(e) {
    const { domNode: t, templateId: n } = e;
    t && (this.inTransaction ? this.transactionNodesPendingRemoval.add(t) : this.doRemoveNode(t)), this.getTemplateCache(n).push(e);
  }
  doRemoveNode(e) {
    e.classList.remove("scrolling"), e.remove();
  }
  getTemplateCache(e) {
    let t = this.cache.get(e);
    return t || (t = [], this.cache.set(e, t)), t;
  }
  dispose() {
    this.cache.forEach((e, t) => {
      for (const n of e)
        this.getRenderer(t).disposeTemplate(n.templateData), n.templateData = null;
    }), this.cache.clear(), this.transactionNodesPendingRemoval.clear();
  }
  getRenderer(e) {
    const t = this.renderers.get(e);
    if (!t)
      throw new Error(`No renderer found for ${e}`);
    return t;
  }
}
var Kd = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
};
const Y1 = {
  CurrentDragAndDropData: void 0
}, Dc = {
  useShadows: !0,
  verticalScrollMode: 1,
  setRowLineHeight: !0,
  setRowHeight: !0,
  supportDynamicHeights: !1,
  dnd: {
    getDragElements(r) {
      return [r];
    },
    getDragURI() {
      return null;
    },
    onDragStart() {
    },
    onDragOver() {
      return !1;
    },
    drop() {
    },
    dispose() {
    }
  },
  horizontalScrolling: !1,
  transformOptimization: !0,
  alwaysConsumeMouseWheel: !0
};
class Iw {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Ybt {
  constructor(e) {
    this.elements = e;
  }
  update() {
  }
  getData() {
    return this.elements;
  }
}
class Xbt {
  constructor() {
    this.types = [], this.files = [];
  }
  update(e) {
    if (e.types && this.types.splice(0, this.types.length, ...e.types), e.files) {
      this.files.splice(0, this.files.length);
      for (let t = 0; t < e.files.length; t++) {
        const n = e.files.item(t);
        n && (n.size || n.type) && this.files.push(n);
      }
    }
  }
  getData() {
    return {
      types: this.types,
      files: this.files
    };
  }
}
function Jbt(r, e) {
  return Array.isArray(r) && Array.isArray(e) ? Zi(r, e) : r === e;
}
class $bt {
  constructor(e) {
    e?.getSetSize ? this.getSetSize = e.getSetSize.bind(e) : this.getSetSize = (t, n, i) => i, e?.getPosInSet ? this.getPosInSet = e.getPosInSet.bind(e) : this.getPosInSet = (t, n) => n + 1, e?.getRole ? this.getRole = e.getRole.bind(e) : this.getRole = (t) => "listitem", e?.isChecked ? this.isChecked = e.isChecked.bind(e) : this.isChecked = (t) => {
    };
  }
}
class vl {
  static {
    this.InstanceCount = 0;
  }
  get contentHeight() {
    return this.rangeMap.size;
  }
  get onDidScroll() {
    return this.scrollableElement.onScroll;
  }
  get scrollableElementDomNode() {
    return this.scrollableElement.getDomNode();
  }
  get horizontalScrolling() {
    return this._horizontalScrolling;
  }
  set horizontalScrolling(e) {
    if (e !== this._horizontalScrolling) {
      if (e && this.supportDynamicHeights)
        throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
      if (this._horizontalScrolling = e, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this._horizontalScrolling) {
        for (const t of this.items)
          this.measureItemWidth(t);
        this.updateScrollWidth(), this.scrollableElement.setScrollDimensions({ width: xE(this.domNode) }), this.rowsContainer.style.width = `${Math.max(this.scrollWidth || 0, this.renderWidth)}px`;
      } else
        this.scrollableElementWidthDelayer.cancel(), this.scrollableElement.setScrollDimensions({ width: this.renderWidth, scrollWidth: this.renderWidth }), this.rowsContainer.style.width = "";
    }
  }
  constructor(e, t, n, i = Dc) {
    if (this.virtualDelegate = t, this.domId = `list_id_${++vl.InstanceCount}`, this.renderers = /* @__PURE__ */ new Map(), this.renderWidth = 0, this._scrollHeight = 0, this.scrollableElementUpdateDisposable = null, this.scrollableElementWidthDelayer = new Uf(50), this.splicing = !1, this.dragOverAnimationStopDisposable = me.None, this.dragOverMouseY = 0, this.canDrop = !1, this.currentDragFeedbackDisposable = me.None, this.onDragLeaveTimeout = me.None, this.disposables = new ze(), this._onDidChangeContentHeight = new $(), this._onDidChangeContentWidth = new $(), this.onDidChangeContentHeight = xe.latch(this._onDidChangeContentHeight.event, void 0, this.disposables), this._horizontalScrolling = !1, i.horizontalScrolling && i.supportDynamicHeights)
      throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
    this.items = [], this.itemId = 0, this.rangeMap = this.createRangeMap(i.paddingTop ?? 0);
    for (const o of n)
      this.renderers.set(o.templateId, o);
    this.cache = this.disposables.add(new Kbt(this.renderers)), this.lastRenderTop = 0, this.lastRenderHeight = 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-list", this.domNode.classList.add(this.domId), this.domNode.tabIndex = 0, this.domNode.classList.toggle("mouse-support", typeof i.mouseSupport == "boolean" ? i.mouseSupport : !0), this._horizontalScrolling = i.horizontalScrolling ?? Dc.horizontalScrolling, this.domNode.classList.toggle("horizontal-scrolling", this._horizontalScrolling), this.paddingBottom = typeof i.paddingBottom > "u" ? 0 : i.paddingBottom, this.accessibilityProvider = new $bt(i.accessibilityProvider), this.rowsContainer = document.createElement("div"), this.rowsContainer.className = "monaco-list-rows", (i.transformOptimization ?? Dc.transformOptimization) && (this.rowsContainer.style.transform = "translate3d(0px, 0px, 0px)", this.rowsContainer.style.overflow = "hidden", this.rowsContainer.style.contain = "strict"), this.disposables.add(Xn.addTarget(this.rowsContainer)), this.scrollable = this.disposables.add(new nm({
      forceIntegerValues: !0,
      smoothScrollDuration: i.smoothScrolling ?? !1 ? 125 : 0,
      scheduleAtNextAnimationFrame: (o) => co(qe(this.domNode), o)
    })), this.scrollableElement = this.disposables.add(new fy(this.rowsContainer, {
      alwaysConsumeMouseWheel: i.alwaysConsumeMouseWheel ?? Dc.alwaysConsumeMouseWheel,
      horizontal: 1,
      vertical: i.verticalScrollMode ?? Dc.verticalScrollMode,
      useShadows: i.useShadows ?? Dc.useShadows,
      mouseWheelScrollSensitivity: i.mouseWheelScrollSensitivity,
      fastScrollSensitivity: i.fastScrollSensitivity,
      scrollByPage: i.scrollByPage
    }, this.scrollable)), this.domNode.appendChild(this.scrollableElement.getDomNode()), e.appendChild(this.domNode), this.scrollableElement.onScroll(this.onScroll, this, this.disposables), this.disposables.add(fe(this.rowsContainer, Nn.Change, (o) => this.onTouchChange(o))), this.disposables.add(fe(this.scrollableElement.getDomNode(), "scroll", (o) => o.target.scrollTop = 0)), this.disposables.add(fe(this.domNode, "dragover", (o) => this.onDragOver(this.toDragEvent(o)))), this.disposables.add(fe(this.domNode, "drop", (o) => this.onDrop(this.toDragEvent(o)))), this.disposables.add(fe(this.domNode, "dragleave", (o) => this.onDragLeave(this.toDragEvent(o)))), this.disposables.add(fe(this.domNode, "dragend", (o) => this.onDragEnd(o))), this.setRowLineHeight = i.setRowLineHeight ?? Dc.setRowLineHeight, this.setRowHeight = i.setRowHeight ?? Dc.setRowHeight, this.supportDynamicHeights = i.supportDynamicHeights ?? Dc.supportDynamicHeights, this.dnd = i.dnd ?? this.disposables.add(Dc.dnd), this.layout(i.initialSize?.height, i.initialSize?.width);
  }
  updateOptions(e) {
    e.paddingBottom !== void 0 && (this.paddingBottom = e.paddingBottom, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), e.smoothScrolling !== void 0 && this.scrollable.setSmoothScrollDuration(e.smoothScrolling ? 125 : 0), e.horizontalScrolling !== void 0 && (this.horizontalScrolling = e.horizontalScrolling);
    let t;
    if (e.scrollByPage !== void 0 && (t = { ...t ?? {}, scrollByPage: e.scrollByPage }), e.mouseWheelScrollSensitivity !== void 0 && (t = { ...t ?? {}, mouseWheelScrollSensitivity: e.mouseWheelScrollSensitivity }), e.fastScrollSensitivity !== void 0 && (t = { ...t ?? {}, fastScrollSensitivity: e.fastScrollSensitivity }), t && this.scrollableElement.updateOptions(t), e.paddingTop !== void 0 && e.paddingTop !== this.rangeMap.paddingTop) {
      const n = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), i = e.paddingTop - this.rangeMap.paddingTop;
      this.rangeMap.paddingTop = e.paddingTop, this.render(n, Math.max(0, this.lastRenderTop + i), this.lastRenderHeight, void 0, void 0, !0), this.setScrollTop(this.lastRenderTop), this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  createRangeMap(e) {
    return new Qbt(e);
  }
  splice(e, t, n = []) {
    if (this.splicing)
      throw new Error("Can't run recursive splices.");
    this.splicing = !0;
    try {
      return this._splice(e, t, n);
    } finally {
      this.splicing = !1, this._onDidChangeContentHeight.fire(this.contentHeight);
    }
  }
  _splice(e, t, n = []) {
    const i = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), s = { start: e, end: e + t }, o = Rr.intersect(i, s), a = /* @__PURE__ */ new Map();
    for (let S = o.end - 1; S >= o.start; S--) {
      const D = this.items[S];
      if (D.dragStartDisposable.dispose(), D.checkedDisposable.dispose(), D.row) {
        let M = a.get(D.templateId);
        M || (M = [], a.set(D.templateId, M));
        const L = this.renderers.get(D.templateId);
        L && L.disposeElement && L.disposeElement(D.element, S, D.row.templateData, D.size), M.unshift(D.row);
      }
      D.row = null, D.stale = !0;
    }
    const l = { start: e + t, end: this.items.length }, c = Rr.intersect(l, i), d = Rr.relativeComplement(l, i), u = n.map((S) => ({
      id: String(this.itemId++),
      element: S,
      templateId: this.virtualDelegate.getTemplateId(S),
      size: this.virtualDelegate.getHeight(S),
      width: void 0,
      hasDynamicHeight: !!this.virtualDelegate.hasDynamicHeight && this.virtualDelegate.hasDynamicHeight(S),
      lastDynamicHeightWidth: void 0,
      row: null,
      uri: void 0,
      dropTarget: !1,
      dragStartDisposable: me.None,
      checkedDisposable: me.None,
      stale: !1
    }));
    let f;
    e === 0 && t >= this.items.length ? (this.rangeMap = this.createRangeMap(this.rangeMap.paddingTop), this.rangeMap.splice(0, 0, u), f = this.items, this.items = u) : (this.rangeMap.splice(e, t, u), f = this.items.splice(e, t, ...u));
    const p = n.length - t, g = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight), m = ik(c, p), A = Rr.intersect(g, m);
    for (let S = A.start; S < A.end; S++)
      this.updateItemInDOM(this.items[S], S);
    const w = Rr.relativeComplement(m, g);
    for (const S of w)
      for (let D = S.start; D < S.end; D++)
        this.removeItemFromDOM(D);
    const v = d.map((S) => ik(S, p)), _ = [{ start: e, end: e + n.length }, ...v].map((S) => Rr.intersect(g, S)).reverse();
    for (const S of _)
      for (let D = S.end - 1; D >= S.start; D--) {
        const M = this.items[D], T = a.get(M.templateId)?.pop();
        this.insertItemInDOM(D, T);
      }
    for (const S of a.values())
      for (const D of S)
        this.cache.release(D);
    return this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), f.map((S) => S.element);
  }
  eventuallyUpdateScrollDimensions() {
    this._scrollHeight = this.contentHeight, this.rowsContainer.style.height = `${this._scrollHeight}px`, this.scrollableElementUpdateDisposable || (this.scrollableElementUpdateDisposable = co(qe(this.domNode), () => {
      this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight }), this.updateScrollWidth(), this.scrollableElementUpdateDisposable = null;
    }));
  }
  eventuallyUpdateScrollWidth() {
    if (!this.horizontalScrolling) {
      this.scrollableElementWidthDelayer.cancel();
      return;
    }
    this.scrollableElementWidthDelayer.trigger(() => this.updateScrollWidth());
  }
  updateScrollWidth() {
    if (!this.horizontalScrolling)
      return;
    let e = 0;
    for (const t of this.items)
      typeof t.width < "u" && (e = Math.max(e, t.width));
    this.scrollWidth = e, this.scrollableElement.setScrollDimensions({ scrollWidth: e === 0 ? 0 : e + 10 }), this._onDidChangeContentWidth.fire(this.scrollWidth);
  }
  rerender() {
    if (this.supportDynamicHeights) {
      for (const e of this.items)
        e.lastDynamicHeightWidth = void 0;
      this._rerender(this.lastRenderTop, this.lastRenderHeight);
    }
  }
  get length() {
    return this.items.length;
  }
  get renderHeight() {
    return this.scrollableElement.getScrollDimensions().height;
  }
  get firstVisibleIndex() {
    return this.getRenderRange(this.lastRenderTop, this.lastRenderHeight).start;
  }
  element(e) {
    return this.items[e].element;
  }
  indexOf(e) {
    return this.items.findIndex((t) => t.element === e);
  }
  domElement(e) {
    const t = this.items[e].row;
    return t && t.domNode;
  }
  elementHeight(e) {
    return this.items[e].size;
  }
  elementTop(e) {
    return this.rangeMap.positionAt(e);
  }
  indexAt(e) {
    return this.rangeMap.indexAt(e);
  }
  indexAfter(e) {
    return this.rangeMap.indexAfter(e);
  }
  layout(e, t) {
    const n = {
      height: typeof e == "number" ? e : kft(this.domNode)
    };
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, n.scrollHeight = this.scrollHeight), this.scrollableElement.setScrollDimensions(n), typeof t < "u" && (this.renderWidth = t, this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight)), this.horizontalScrolling && this.scrollableElement.setScrollDimensions({
      width: typeof t == "number" ? t : xE(this.domNode)
    });
  }
  // Render
  render(e, t, n, i, s, o = !1) {
    const a = this.getRenderRange(t, n), l = Rr.relativeComplement(a, e).reverse(), c = Rr.relativeComplement(e, a);
    if (o) {
      const d = Rr.intersect(e, a);
      for (let u = d.start; u < d.end; u++)
        this.updateItemInDOM(this.items[u], u);
    }
    this.cache.transact(() => {
      for (const d of c)
        for (let u = d.start; u < d.end; u++)
          this.removeItemFromDOM(u);
      for (const d of l)
        for (let u = d.end - 1; u >= d.start; u--)
          this.insertItemInDOM(u);
    }), i !== void 0 && (this.rowsContainer.style.left = `-${i}px`), this.rowsContainer.style.top = `-${t}px`, this.horizontalScrolling && s !== void 0 && (this.rowsContainer.style.width = `${Math.max(s, this.renderWidth)}px`), this.lastRenderTop = t, this.lastRenderHeight = n;
  }
  // DOM operations
  insertItemInDOM(e, t) {
    const n = this.items[e];
    if (!n.row)
      if (t)
        n.row = t, n.stale = !0;
      else {
        const l = this.cache.alloc(n.templateId);
        n.row = l.row, n.stale ||= l.isReusingConnectedDomNode;
      }
    const i = this.accessibilityProvider.getRole(n.element) || "listitem";
    n.row.domNode.setAttribute("role", i);
    const s = this.accessibilityProvider.isChecked(n.element);
    if (typeof s == "boolean")
      n.row.domNode.setAttribute("aria-checked", String(!!s));
    else if (s) {
      const l = (c) => n.row.domNode.setAttribute("aria-checked", String(!!c));
      l(s.value), n.checkedDisposable = s.onDidChange(() => l(s.value));
    }
    if (n.stale || !n.row.domNode.parentElement) {
      const l = this.items.at(e + 1)?.row?.domNode ?? null;
      (n.row.domNode.parentElement !== this.rowsContainer || n.row.domNode.nextElementSibling !== l) && this.rowsContainer.insertBefore(n.row.domNode, l), n.stale = !1;
    }
    this.updateItemInDOM(n, e);
    const o = this.renderers.get(n.templateId);
    if (!o)
      throw new Error(`No renderer found for template id ${n.templateId}`);
    o?.renderElement(n.element, e, n.row.templateData, n.size);
    const a = this.dnd.getDragURI(n.element);
    n.dragStartDisposable.dispose(), n.row.domNode.draggable = !!a, a && (n.dragStartDisposable = fe(n.row.domNode, "dragstart", (l) => this.onDragStart(n.element, a, l))), this.horizontalScrolling && (this.measureItemWidth(n), this.eventuallyUpdateScrollWidth());
  }
  measureItemWidth(e) {
    if (!e.row || !e.row.domNode)
      return;
    e.row.domNode.style.width = "fit-content", e.width = xE(e.row.domNode);
    const t = qe(e.row.domNode).getComputedStyle(e.row.domNode);
    t.paddingLeft && (e.width += parseFloat(t.paddingLeft)), t.paddingRight && (e.width += parseFloat(t.paddingRight)), e.row.domNode.style.width = "";
  }
  updateItemInDOM(e, t) {
    e.row.domNode.style.top = `${this.elementTop(t)}px`, this.setRowHeight && (e.row.domNode.style.height = `${e.size}px`), this.setRowLineHeight && (e.row.domNode.style.lineHeight = `${e.size}px`), e.row.domNode.setAttribute("data-index", `${t}`), e.row.domNode.setAttribute("data-last-element", t === this.length - 1 ? "true" : "false"), e.row.domNode.setAttribute("data-parity", t % 2 === 0 ? "even" : "odd"), e.row.domNode.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(e.element, t, this.length))), e.row.domNode.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(e.element, t))), e.row.domNode.setAttribute("id", this.getElementDomId(t)), e.row.domNode.classList.toggle("drop-target", e.dropTarget);
  }
  removeItemFromDOM(e) {
    const t = this.items[e];
    if (t.dragStartDisposable.dispose(), t.checkedDisposable.dispose(), t.row) {
      const n = this.renderers.get(t.templateId);
      n && n.disposeElement && n.disposeElement(t.element, e, t.row.templateData, t.size), this.cache.release(t.row), t.row = null;
    }
    this.horizontalScrolling && this.eventuallyUpdateScrollWidth();
  }
  getScrollTop() {
    return this.scrollableElement.getScrollPosition().scrollTop;
  }
  setScrollTop(e, t) {
    this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, this.scrollableElement.setScrollDimensions({ scrollHeight: this.scrollHeight })), this.scrollableElement.setScrollPosition({ scrollTop: e, reuseAnimation: t });
  }
  get scrollTop() {
    return this.getScrollTop();
  }
  set scrollTop(e) {
    this.setScrollTop(e);
  }
  get scrollHeight() {
    return this._scrollHeight + (this.horizontalScrolling ? 10 : 0) + this.paddingBottom;
  }
  // Events
  get onMouseClick() {
    return xe.map(this.disposables.add(new St(this.domNode, "click")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseDblClick() {
    return xe.map(this.disposables.add(new St(this.domNode, "dblclick")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseMiddleClick() {
    return xe.filter(xe.map(this.disposables.add(new St(this.domNode, "auxclick")).event, (e) => this.toMouseEvent(e), this.disposables), (e) => e.browserEvent.button === 1, this.disposables);
  }
  get onMouseDown() {
    return xe.map(this.disposables.add(new St(this.domNode, "mousedown")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOver() {
    return xe.map(this.disposables.add(new St(this.domNode, "mouseover")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onMouseOut() {
    return xe.map(this.disposables.add(new St(this.domNode, "mouseout")).event, (e) => this.toMouseEvent(e), this.disposables);
  }
  get onContextMenu() {
    return xe.any(xe.map(this.disposables.add(new St(this.domNode, "contextmenu")).event, (e) => this.toMouseEvent(e), this.disposables), xe.map(this.disposables.add(new St(this.domNode, Nn.Contextmenu)).event, (e) => this.toGestureEvent(e), this.disposables));
  }
  get onTouchStart() {
    return xe.map(this.disposables.add(new St(this.domNode, "touchstart")).event, (e) => this.toTouchEvent(e), this.disposables);
  }
  get onTap() {
    return xe.map(this.disposables.add(new St(this.rowsContainer, Nn.Tap)).event, (e) => this.toGestureEvent(e), this.disposables);
  }
  toMouseEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], i = n && n.element;
    return { browserEvent: e, index: t, element: i };
  }
  toTouchEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], i = n && n.element;
    return { browserEvent: e, index: t, element: i };
  }
  toGestureEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.initialTarget || null), n = typeof t > "u" ? void 0 : this.items[t], i = n && n.element;
    return { browserEvent: e, index: t, element: i };
  }
  toDragEvent(e) {
    const t = this.getItemIndexFromEventTarget(e.target || null), n = typeof t > "u" ? void 0 : this.items[t], i = n && n.element, s = this.getTargetSector(e, t);
    return { browserEvent: e, index: t, element: i, sector: s };
  }
  onScroll(e) {
    try {
      const t = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight);
      this.render(t, e.scrollTop, e.height, e.scrollLeft, e.scrollWidth), this.supportDynamicHeights && this._rerender(e.scrollTop, e.height, e.inSmoothScrolling);
    } catch (t) {
      throw console.error("Got bad scroll event:", e), t;
    }
  }
  onTouchChange(e) {
    e.preventDefault(), e.stopPropagation(), this.scrollTop -= e.translationY;
  }
  // DND
  onDragStart(e, t, n) {
    if (!n.dataTransfer)
      return;
    const i = this.dnd.getDragElements(e);
    if (n.dataTransfer.effectAllowed = "copyMove", n.dataTransfer.setData(ENe.TEXT, t), n.dataTransfer.setDragImage) {
      let s;
      this.dnd.getDragLabel && (s = this.dnd.getDragLabel(i, n)), typeof s > "u" && (s = String(i.length));
      const o = $e(".monaco-drag-image");
      o.textContent = s, ((c) => {
        for (; c && !c.classList.contains("monaco-workbench"); )
          c = c.parentElement;
        return c || this.domNode.ownerDocument;
      })(this.domNode).appendChild(o), n.dataTransfer.setDragImage(o, -10, -10), setTimeout(() => o.remove(), 0);
    }
    this.domNode.classList.add("dragging"), this.currentDragData = new Iw(i), Y1.CurrentDragAndDropData = new Ybt(i), this.dnd.onDragStart?.(this.currentDragData, n);
  }
  onDragOver(e) {
    if (e.browserEvent.preventDefault(), this.onDragLeaveTimeout.dispose(), Y1.CurrentDragAndDropData && Y1.CurrentDragAndDropData.getData() === "vscode-ui" || (this.setupDragAndDropScrollTopAnimation(e.browserEvent), !e.browserEvent.dataTransfer))
      return !1;
    if (!this.currentDragData)
      if (Y1.CurrentDragAndDropData)
        this.currentDragData = Y1.CurrentDragAndDropData;
      else {
        if (!e.browserEvent.dataTransfer.types)
          return !1;
        this.currentDragData = new Xbt();
      }
    const t = this.dnd.onDragOver(this.currentDragData, e.element, e.index, e.sector, e.browserEvent);
    if (this.canDrop = typeof t == "boolean" ? t : t.accept, !this.canDrop)
      return this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), !1;
    e.browserEvent.dataTransfer.dropEffect = typeof t != "boolean" && t.effect?.type === 0 ? "copy" : "move";
    let n;
    typeof t != "boolean" && t.feedback ? n = t.feedback : typeof e.index > "u" ? n = [-1] : n = [e.index], n = ff(n).filter((s) => s >= -1 && s < this.length).sort((s, o) => s - o), n = n[0] === -1 ? [-1] : n;
    let i = typeof t != "boolean" && t.effect && t.effect.position ? t.effect.position : "drop-target";
    if (Jbt(this.currentDragFeedback, n) && this.currentDragFeedbackPosition === i)
      return !0;
    if (this.currentDragFeedback = n, this.currentDragFeedbackPosition = i, this.currentDragFeedbackDisposable.dispose(), n[0] === -1)
      this.domNode.classList.add(i), this.rowsContainer.classList.add(i), this.currentDragFeedbackDisposable = ht(() => {
        this.domNode.classList.remove(i), this.rowsContainer.classList.remove(i);
      });
    else {
      if (n.length > 1 && i !== "drop-target")
        throw new Error("Can't use multiple feedbacks with position different than 'over'");
      i === "drop-target-after" && n[0] < this.length - 1 && (n[0] += 1, i = "drop-target-before");
      for (const s of n) {
        const o = this.items[s];
        o.dropTarget = !0, o.row?.domNode.classList.add(i);
      }
      this.currentDragFeedbackDisposable = ht(() => {
        for (const s of n) {
          const o = this.items[s];
          o.dropTarget = !1, o.row?.domNode.classList.remove(i);
        }
      });
    }
    return !0;
  }
  onDragLeave(e) {
    this.onDragLeaveTimeout.dispose(), this.onDragLeaveTimeout = OD(() => this.clearDragOverFeedback(), 100, this.disposables), this.currentDragData && this.dnd.onDragLeave?.(this.currentDragData, e.element, e.index, e.browserEvent);
  }
  onDrop(e) {
    if (!this.canDrop)
      return;
    const t = this.currentDragData;
    this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Y1.CurrentDragAndDropData = void 0, !(!t || !e.browserEvent.dataTransfer) && (e.browserEvent.preventDefault(), t.update(e.browserEvent.dataTransfer), this.dnd.drop(t, e.element, e.index, e.sector, e.browserEvent));
  }
  onDragEnd(e) {
    this.canDrop = !1, this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.domNode.classList.remove("dragging"), this.currentDragData = void 0, Y1.CurrentDragAndDropData = void 0, this.dnd.onDragEnd?.(e);
  }
  clearDragOverFeedback() {
    this.currentDragFeedback = void 0, this.currentDragFeedbackPosition = void 0, this.currentDragFeedbackDisposable.dispose(), this.currentDragFeedbackDisposable = me.None;
  }
  // DND scroll top animation
  setupDragAndDropScrollTopAnimation(e) {
    if (!this.dragOverAnimationDisposable) {
      const t = MDe(this.domNode).top;
      this.dragOverAnimationDisposable = Wft(qe(this.domNode), this.animateDragAndDropScrollTop.bind(this, t));
    }
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationStopDisposable = OD(() => {
      this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
    }, 1e3, this.disposables), this.dragOverMouseY = e.pageY;
  }
  animateDragAndDropScrollTop(e) {
    if (this.dragOverMouseY === void 0)
      return;
    const t = this.dragOverMouseY - e, n = this.renderHeight - 35;
    t < 35 ? this.scrollTop += Math.max(-14, Math.floor(0.3 * (t - 35))) : t > n && (this.scrollTop += Math.min(14, Math.floor(0.3 * (t - n))));
  }
  teardownDragAndDropScrollTopAnimation() {
    this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
  }
  // Util
  getTargetSector(e, t) {
    if (t === void 0)
      return;
    const n = e.offsetY / this.items[t].size, i = Math.floor(n / 0.25);
    return Ns(i, 0, 3);
  }
  getItemIndexFromEventTarget(e) {
    const t = this.scrollableElement.getDomNode();
    let n = e;
    for (; (wr(n) || Vft(n)) && n !== this.rowsContainer && t.contains(n); ) {
      const i = n.getAttribute("data-index");
      if (i) {
        const s = Number(i);
        if (!isNaN(s))
          return s;
      }
      n = n.parentElement;
    }
  }
  getRenderRange(e, t) {
    return {
      start: this.rangeMap.indexAt(e),
      end: this.rangeMap.indexAfter(e + t - 1)
    };
  }
  /**
   * Given a stable rendered state, checks every rendered element whether it needs
   * to be probed for dynamic height. Adjusts scroll height and top if necessary.
   */
  _rerender(e, t, n) {
    const i = this.getRenderRange(e, t);
    let s, o;
    e === this.elementTop(i.start) ? (s = i.start, o = 0) : i.end - i.start > 1 && (s = i.start + 1, o = this.elementTop(s) - e);
    let a = 0;
    for (; ; ) {
      const l = this.getRenderRange(e, t);
      let c = !1;
      for (let d = l.start; d < l.end; d++) {
        const u = this.probeDynamicHeight(d);
        u !== 0 && this.rangeMap.splice(d, 1, [this.items[d]]), a += u, c = c || u !== 0;
      }
      if (!c) {
        a !== 0 && this.eventuallyUpdateScrollDimensions();
        const d = Rr.relativeComplement(i, l);
        for (const f of d)
          for (let p = f.start; p < f.end; p++)
            this.items[p].row && this.removeItemFromDOM(p);
        const u = Rr.relativeComplement(l, i).reverse();
        for (const f of u)
          for (let p = f.end - 1; p >= f.start; p--)
            this.insertItemInDOM(p);
        for (let f = l.start; f < l.end; f++)
          this.items[f].row && this.updateItemInDOM(this.items[f], f);
        if (typeof s == "number") {
          const f = this.scrollable.getFutureScrollPosition().scrollTop - e, p = this.elementTop(s) - o + f;
          this.setScrollTop(p, n);
        }
        this._onDidChangeContentHeight.fire(this.contentHeight);
        return;
      }
    }
  }
  probeDynamicHeight(e) {
    const t = this.items[e];
    if (this.virtualDelegate.getDynamicHeight) {
      const o = this.virtualDelegate.getDynamicHeight(t.element);
      if (o !== null) {
        const a = t.size;
        return t.size = o, t.lastDynamicHeightWidth = this.renderWidth, o - a;
      }
    }
    if (!t.hasDynamicHeight || t.lastDynamicHeightWidth === this.renderWidth || this.virtualDelegate.hasDynamicHeight && !this.virtualDelegate.hasDynamicHeight(t.element))
      return 0;
    const n = t.size;
    if (t.row)
      return t.row.domNode.style.height = "", t.size = t.row.domNode.offsetHeight, t.size === 0 && !Ji(t.row.domNode, qe(t.row.domNode).document.body) && console.warn("Measuring item node that is not in DOM! Add ListView to the DOM before measuring row height!"), t.lastDynamicHeightWidth = this.renderWidth, t.size - n;
    const { row: i } = this.cache.alloc(t.templateId);
    i.domNode.style.height = "", this.rowsContainer.appendChild(i.domNode);
    const s = this.renderers.get(t.templateId);
    if (!s)
      throw new cn("Missing renderer for templateId: " + t.templateId);
    return s.renderElement(t.element, e, i.templateData, void 0), t.size = i.domNode.offsetHeight, s.disposeElement?.(t.element, e, i.templateData, void 0), this.virtualDelegate.setDynamicHeight?.(t.element, t.size), t.lastDynamicHeightWidth = this.renderWidth, i.domNode.remove(), this.cache.release(i), t.size - n;
  }
  getElementDomId(e) {
    return `${this.domId}_${e}`;
  }
  // Dispose
  dispose() {
    for (const e of this.items)
      if (e.dragStartDisposable.dispose(), e.checkedDisposable.dispose(), e.row) {
        const t = this.renderers.get(e.row.templateId);
        t && (t.disposeElement?.(e.element, -1, e.row.templateData, void 0), t.disposeTemplate(e.row.templateData));
      }
    this.items = [], this.domNode?.remove(), this.dragOverAnimationDisposable?.dispose(), this.disposables.dispose();
  }
}
Kd([
  wi
], vl.prototype, "onMouseClick", null);
Kd([
  wi
], vl.prototype, "onMouseDblClick", null);
Kd([
  wi
], vl.prototype, "onMouseMiddleClick", null);
Kd([
  wi
], vl.prototype, "onMouseDown", null);
Kd([
  wi
], vl.prototype, "onMouseOver", null);
Kd([
  wi
], vl.prototype, "onMouseOut", null);
Kd([
  wi
], vl.prototype, "onContextMenu", null);
Kd([
  wi
], vl.prototype, "onTouchStart", null);
Kd([
  wi
], vl.prototype, "onTap", null);
const ml = (r, e) => r === e;
function e7t(r = ml) {
  return (e, t) => Zi(e, t, r);
}
function t9e(r, e, t) {
  {
    const n = r;
    return (i, s) => i == null || s === void 0 || s === null ? s === i : n(i, s);
  }
}
class _s {
  constructor(e, t, n) {
    this.owner = e, this.debugNameSource = t, this.referenceFn = n;
  }
  getDebugName(e) {
    return t7t(e, this);
  }
}
const n9e = /* @__PURE__ */ new Map(), rk = /* @__PURE__ */ new WeakMap();
function t7t(r, e) {
  const t = rk.get(r);
  if (t)
    return t;
  const n = n7t(r, e);
  if (n) {
    let i = n9e.get(n) ?? 0;
    i++, n9e.set(n, i);
    const s = i === 1 ? n : `${n}#${i}`;
    return rk.set(r, s), s;
  }
}
function n7t(r, e) {
  const t = rk.get(r);
  if (t)
    return t;
  const n = e.owner ? r7t(e.owner) + "." : "";
  let i;
  const s = e.debugNameSource;
  if (s !== void 0)
    if (typeof s == "function") {
      if (i = s(), i !== void 0)
        return n + i;
    } else
      return n + s;
  const o = e.referenceFn;
  if (o !== void 0 && (i = mR(o), i !== void 0))
    return n + i;
  if (e.owner !== void 0) {
    const a = i7t(e.owner, r);
    if (a !== void 0)
      return n + a;
  }
}
function i7t(r, e) {
  for (const t in r)
    if (r[t] === e)
      return t;
}
const i9e = /* @__PURE__ */ new Map(), r9e = /* @__PURE__ */ new WeakMap();
function r7t(r) {
  const e = r9e.get(r);
  if (e)
    return e;
  const t = s7t(r);
  let n = i9e.get(t) ?? 0;
  n++, i9e.set(t, n);
  const i = n === 1 ? t : `${t}#${n}`;
  return r9e.set(r, i), i;
}
function s7t(r) {
  const e = r.constructor;
  return e ? e.name : "Object";
}
function mR(r) {
  const e = r.toString(), n = /\/\*\*\s*@description\s*([^*]*)\*\//.exec(e);
  return (n ? n[1] : void 0)?.trim();
}
let o7t;
function xNe() {
  return o7t;
}
let SNe;
function a7t(r) {
  SNe = r;
}
let MNe;
function l7t(r) {
  MNe = r;
}
let sk;
function c7t(r) {
  sk = r;
}
class DNe {
  get TChange() {
    return null;
  }
  reportChanges() {
    this.get();
  }
  /** @sealed */
  read(e) {
    return e ? e.readObservable(this) : this.get();
  }
  map(e, t) {
    const n = t === void 0 ? void 0 : e, i = t === void 0 ? e : t;
    return sk({
      owner: n,
      debugName: () => {
        const s = mR(i);
        if (s !== void 0)
          return s;
        const a = /^\s*\(?\s*([a-zA-Z_$][a-zA-Z_$0-9]*)\s*\)?\s*=>\s*\1(?:\??)\.([a-zA-Z_$][a-zA-Z_$0-9]*)\s*$/.exec(i.toString());
        if (a)
          return `${this.debugName}.${a[2]}`;
        if (!n)
          return `${this.debugName} (mapped)`;
      },
      debugReferenceFn: i
    }, (s) => i(this.read(s), s));
  }
  /**
   * @sealed
   * Converts an observable of an observable value into a direct observable of the value.
  */
  flatten() {
    return sk({
      owner: void 0,
      debugName: () => `${this.debugName} (flattened)`
    }, (e) => this.read(e).read(e));
  }
  recomputeInitiallyAndOnChange(e, t) {
    return e.add(SNe(this, t)), this;
  }
  /**
   * Ensures that this observable is observed. This keeps the cache alive.
   * However, in case of deriveds, it does not force eager evaluation (only when the value is read/get).
   * Use `recomputeInitiallyAndOnChange` for eager evaluation.
   */
  keepObserved(e) {
    return e.add(MNe(this)), this;
  }
}
class sm extends DNe {
  constructor() {
    super(...arguments), this.observers = /* @__PURE__ */ new Set();
  }
  addObserver(e) {
    const t = this.observers.size;
    this.observers.add(e), t === 0 && this.onFirstObserverAdded();
  }
  removeObserver(e) {
    this.observers.delete(e) && this.observers.size === 0 && this.onLastObserverRemoved();
  }
  onFirstObserverAdded() {
  }
  onLastObserverRemoved() {
  }
}
function er(r, e) {
  const t = new Ow(r, e);
  try {
    r(t);
  } finally {
    t.finish();
  }
}
let r5;
function yA(r) {
  if (r5)
    r(r5);
  else {
    const e = new Ow(r, void 0);
    r5 = e;
    try {
      r(e);
    } finally {
      e.finish(), r5 = void 0;
    }
  }
}
function AR(r, e, t) {
  r ? e(r) : er(e, t);
}
class Ow {
  constructor(e, t) {
    this._fn = e, this._getDebugName = t, this.updatingObservers = [];
  }
  getDebugName() {
    return this._getDebugName ? this._getDebugName() : mR(this._fn);
  }
  updateObserver(e, t) {
    this.updatingObservers.push({ observer: e, observable: t }), e.beginUpdate(t);
  }
  finish() {
    const e = this.updatingObservers;
    for (let t = 0; t < e.length; t++) {
      const { observer: n, observable: i } = e[t];
      n.endUpdate(i);
    }
    this.updatingObservers = null;
  }
}
function qt(r, e) {
  let t;
  return typeof r == "string" ? t = new _s(void 0, r, void 0) : t = new _s(r, void 0, void 0), new wR(t, e, ml);
}
class wR extends sm {
  get debugName() {
    return this._debugNameData.getDebugName(this) ?? "ObservableValue";
  }
  constructor(e, t, n) {
    super(), this._debugNameData = e, this._equalityComparator = n, this._value = t;
  }
  get() {
    return this._value;
  }
  set(e, t, n) {
    if (n === void 0 && this._equalityComparator(this._value, e))
      return;
    let i;
    t || (t = i = new Ow(() => {
    }, () => `Setting ${this.debugName}`));
    try {
      const s = this._value;
      this._setValue(e), xNe()?.handleObservableChanged(this, { oldValue: s, newValue: e, change: n, didChange: !0, hadValue: !0 });
      for (const o of this.observers)
        t.updateObserver(o, this), o.handleChange(this, n);
    } finally {
      i && i.finish();
    }
  }
  toString() {
    return `${this.debugName}: ${this._value}`;
  }
  _setValue(e) {
    this._value = e;
  }
}
function LNe(r, e) {
  let t;
  return typeof r == "string" ? t = new _s(void 0, r, void 0) : t = new _s(r, void 0, void 0), new h7t(t, e, ml);
}
class h7t extends wR {
  _setValue(e) {
    this._value !== e && (this._value && this._value.dispose(), this._value = e);
  }
  dispose() {
    this._value?.dispose();
  }
}
function dt(r, e) {
  return e !== void 0 ? new vg(new _s(r, void 0, e), e, void 0, void 0, void 0, ml) : new vg(new _s(void 0, void 0, r), r, void 0, void 0, void 0, ml);
}
function vR(r, e, t) {
  return new d7t(new _s(r, void 0, e), e, void 0, void 0, void 0, ml, t);
}
function xy(r, e) {
  return new vg(new _s(r.owner, r.debugName, r.debugReferenceFn), e, void 0, void 0, r.onLastObserverRemoved, r.equalsFn ?? ml);
}
c7t(xy);
function om(r, e) {
  let t, n;
  e === void 0 ? (t = r, n = void 0) : (n = r, t = e);
  const i = new ze();
  return new vg(new _s(n, void 0, t), (s) => (i.clear(), t(s, i)), void 0, void 0, () => i.dispose(), ml);
}
function Pc(r, e) {
  let t, n;
  e === void 0 ? (t = r, n = void 0) : (n = r, t = e);
  let i;
  return new vg(new _s(n, void 0, t), (s) => {
    i ? i.clear() : i = new ze();
    const o = t(s);
    return o && i.add(o), o;
  }, void 0, void 0, () => {
    i && (i.dispose(), i = void 0);
  }, ml);
}
class vg extends sm {
  get debugName() {
    return this._debugNameData.getDebugName(this) ?? "(anonymous)";
  }
  constructor(e, t, n, i, s = void 0, o) {
    super(), this._debugNameData = e, this._computeFn = t, this.createChangeSummary = n, this._handleChange = i, this._handleLastObserverRemoved = s, this._equalityComparator = o, this.state = 0, this.value = void 0, this.updateCount = 0, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = void 0, this.changeSummary = this.createChangeSummary?.();
  }
  onLastObserverRemoved() {
    this.state = 0, this.value = void 0;
    for (const e of this.dependencies)
      e.removeObserver(this);
    this.dependencies.clear(), this._handleLastObserverRemoved?.();
  }
  get() {
    if (this.observers.size === 0) {
      const e = this._computeFn(this, this.createChangeSummary?.());
      return this.onLastObserverRemoved(), e;
    } else {
      do {
        if (this.state === 1) {
          for (const e of this.dependencies)
            if (e.reportChanges(), this.state === 2)
              break;
        }
        this.state === 1 && (this.state = 3), this._recomputeIfNeeded();
      } while (this.state !== 3);
      return this.value;
    }
  }
  _recomputeIfNeeded() {
    if (this.state === 3)
      return;
    const e = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = e;
    const t = this.state !== 0, n = this.value;
    this.state = 3;
    const i = this.changeSummary;
    this.changeSummary = this.createChangeSummary?.();
    try {
      this.value = this._computeFn(this, i);
    } finally {
      for (const o of this.dependenciesToBeRemoved)
        o.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
    if (t && !this._equalityComparator(n, this.value))
      for (const o of this.observers)
        o.handleChange(this, void 0);
  }
  toString() {
    return `LazyDerived<${this.debugName}>`;
  }
  // IObserver Implementation
  beginUpdate(e) {
    this.updateCount++;
    const t = this.updateCount === 1;
    if (this.state === 3 && (this.state = 1, !t))
      for (const n of this.observers)
        n.handlePossibleChange(this);
    if (t)
      for (const n of this.observers)
        n.beginUpdate(this);
  }
  endUpdate(e) {
    if (this.updateCount--, this.updateCount === 0) {
      const t = [...this.observers];
      for (const n of t)
        n.endUpdate(this);
    }
    vf(() => this.updateCount >= 0);
  }
  handlePossibleChange(e) {
    if (this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      this.state = 1;
      for (const t of this.observers)
        t.handlePossibleChange(this);
    }
  }
  handleChange(e, t) {
    if (this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e)) {
      const n = this._handleChange ? this._handleChange({
        changedObservable: e,
        change: t,
        didChange: (s) => s === e
      }, this.changeSummary) : !0, i = this.state === 3;
      if (n && (this.state === 1 || i) && (this.state = 2, i))
        for (const s of this.observers)
          s.handlePossibleChange(this);
    }
  }
  // IReader Implementation
  readObservable(e) {
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
  addObserver(e) {
    const t = !this.observers.has(e) && this.updateCount > 0;
    super.addObserver(e), t && e.beginUpdate(this);
  }
  removeObserver(e) {
    const t = this.observers.has(e) && this.updateCount > 0;
    super.removeObserver(e), t && e.endUpdate(this);
  }
}
class d7t extends vg {
  constructor(e, t, n, i, s = void 0, o, a) {
    super(e, t, n, i, s, o), this.set = a;
  }
}
function nn(r) {
  return new Dy(new _s(void 0, void 0, r), r, void 0, void 0);
}
function Sy(r, e) {
  return new Dy(new _s(r.owner, r.debugName, r.debugReferenceFn ?? e), e, void 0, void 0);
}
function My(r, e) {
  return new Dy(new _s(r.owner, r.debugName, r.debugReferenceFn ?? e), e, r.createEmptyChangeSummary, r.handleChange);
}
function Xl(r) {
  const e = new ze(), t = Sy({
    owner: void 0,
    debugName: void 0,
    debugReferenceFn: r
  }, (n) => {
    e.clear(), r(n, e);
  });
  return ht(() => {
    t.dispose(), e.dispose();
  });
}
class Dy {
  get debugName() {
    return this._debugNameData.getDebugName(this) ?? "(anonymous)";
  }
  constructor(e, t, n, i) {
    this._debugNameData = e, this._runFn = t, this.createChangeSummary = n, this._handleChange = i, this.state = 2, this.updateCount = 0, this.disposed = !1, this.dependencies = /* @__PURE__ */ new Set(), this.dependenciesToBeRemoved = /* @__PURE__ */ new Set(), this.changeSummary = this.createChangeSummary?.(), this._runIfNeeded();
  }
  dispose() {
    this.disposed = !0;
    for (const e of this.dependencies)
      e.removeObserver(this);
    this.dependencies.clear();
  }
  _runIfNeeded() {
    if (this.state === 3)
      return;
    const e = this.dependenciesToBeRemoved;
    this.dependenciesToBeRemoved = this.dependencies, this.dependencies = e, this.state = 3;
    const t = this.disposed;
    try {
      if (!t) {
        xNe()?.handleAutorunTriggered(this);
        const n = this.changeSummary;
        this.changeSummary = this.createChangeSummary?.(), this._runFn(this, n);
      }
    } finally {
      for (const n of this.dependenciesToBeRemoved)
        n.removeObserver(this);
      this.dependenciesToBeRemoved.clear();
    }
  }
  toString() {
    return `Autorun<${this.debugName}>`;
  }
  // IObserver implementation
  beginUpdate() {
    this.state === 3 && (this.state = 1), this.updateCount++;
  }
  endUpdate() {
    if (this.updateCount === 1)
      do {
        if (this.state === 1) {
          this.state = 3;
          for (const e of this.dependencies)
            if (e.reportChanges(), this.state === 2)
              break;
        }
        this._runIfNeeded();
      } while (this.state !== 3);
    this.updateCount--, vf(() => this.updateCount >= 0);
  }
  handlePossibleChange(e) {
    this.state === 3 && this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (this.state = 1);
  }
  handleChange(e, t) {
    this.dependencies.has(e) && !this.dependenciesToBeRemoved.has(e) && (!this._handleChange || this._handleChange({
      changedObservable: e,
      change: t,
      didChange: (i) => i === e
    }, this.changeSummary)) && (this.state = 2);
  }
  // IReader implementation
  readObservable(e) {
    if (this.disposed)
      return e.get();
    e.addObserver(this);
    const t = e.get();
    return this.dependencies.add(e), this.dependenciesToBeRemoved.delete(e), t;
  }
}
(function(r) {
  r.Observer = Dy;
})(nn || (nn = {}));
function R9(r) {
  return new u7t(r);
}
class u7t extends DNe {
  constructor(e) {
    super(), this.value = e;
  }
  get debugName() {
    return this.toString();
  }
  get() {
    return this.value;
  }
  addObserver(e) {
  }
  removeObserver(e) {
  }
  toString() {
    return `Const: ${this.value}`;
  }
}
function Ei(...r) {
  let e, t, n;
  return r.length === 3 ? [e, t, n] = r : [t, n] = r, new ap(new _s(e, void 0, n), t, n, () => ap.globalTransaction, ml);
}
class ap extends sm {
  constructor(e, t, n, i, s) {
    super(), this._debugNameData = e, this.event = t, this._getValue = n, this._getTransaction = i, this._equalityComparator = s, this.hasValue = !1, this.handleEvent = (o) => {
      const a = this._getValue(o), l = this.value;
      (!this.hasValue || !this._equalityComparator(l, a)) && (this.value = a, this.hasValue && AR(this._getTransaction(), (d) => {
        for (const u of this.observers)
          d.updateObserver(u, this), u.handleChange(this, void 0);
      }, () => {
        const d = this.getDebugName();
        return "Event fired" + (d ? `: ${d}` : "");
      }), this.hasValue = !0);
    };
  }
  getDebugName() {
    return this._debugNameData.getDebugName(this);
  }
  get debugName() {
    const e = this.getDebugName();
    return "From Event" + (e ? `: ${e}` : "");
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0, this.hasValue = !1, this.value = void 0;
  }
  get() {
    return this.subscription ? (this.hasValue || this.handleEvent(void 0), this.value) : this._getValue(void 0);
  }
}
(function(r) {
  r.Observer = ap;
  function e(t, n) {
    let i = !1;
    ap.globalTransaction === void 0 && (ap.globalTransaction = t, i = !0);
    try {
      n();
    } finally {
      i && (ap.globalTransaction = void 0);
    }
  }
  r.batchEventsGlobally = e;
})(Ei || (Ei = {}));
function aa(r, e) {
  return new f7t(r, e);
}
class f7t extends sm {
  constructor(e, t) {
    super(), this.debugName = e, this.event = t, this.handleEvent = () => {
      er((n) => {
        for (const i of this.observers)
          n.updateObserver(i, this), i.handleChange(this, void 0);
      }, () => this.debugName);
    };
  }
  onFirstObserverAdded() {
    this.subscription = this.event(this.handleEvent);
  }
  onLastObserverRemoved() {
    this.subscription.dispose(), this.subscription = void 0;
  }
  get() {
  }
}
function bR(r) {
  return typeof r == "string" ? new s9e(r) : new s9e(void 0, r);
}
class s9e extends sm {
  get debugName() {
    return new _s(this._owner, this._debugName, void 0).getDebugName(this) ?? "Observable Signal";
  }
  toString() {
    return this.debugName;
  }
  constructor(e, t) {
    super(), this._debugName = e, this._owner = t;
  }
  trigger(e, t) {
    if (!e) {
      er((n) => {
        this.trigger(n, t);
      }, () => `Trigger signal ${this.debugName}`);
      return;
    }
    for (const n of this.observers)
      e.updateObserver(n, this), n.handleChange(this, t);
  }
  get() {
  }
}
function p7t(r) {
  const e = new kNe(!1, void 0);
  return r.addObserver(e), ht(() => {
    r.removeObserver(e);
  });
}
l7t(p7t);
function Ly(r, e) {
  const t = new kNe(!0, e);
  return r.addObserver(t), e ? e(r.get()) : r.reportChanges(), ht(() => {
    r.removeObserver(t);
  });
}
a7t(Ly);
class kNe {
  constructor(e, t) {
    this._forceRecompute = e, this._handleValue = t, this._counter = 0;
  }
  beginUpdate(e) {
    this._counter++;
  }
  endUpdate(e) {
    this._counter--, this._counter === 0 && this._forceRecompute && (this._handleValue ? this._handleValue(e.get()) : e.reportChanges());
  }
  handlePossibleChange(e) {
  }
  handleChange(e, t) {
  }
}
function g7t(r, e) {
  let t;
  return xy({ owner: r, debugReferenceFn: e }, (i) => (t = e(i, t), t));
}
function m7t(r, e) {
  return g7t(r, (t, n) => n ?? e(t));
}
function A7t(r, e, t, n) {
  return e || (e = (i) => i != null), new Promise((i, s) => {
    let o = !0, a = !1;
    const l = r.map((d) => ({
      isFinished: e(d),
      error: !1,
      state: d
    })), c = nn((d) => {
      const { isFinished: u, error: f, state: p } = l.read(d);
      (u || f) && (o ? a = !0 : c.dispose(), f ? s(f === !0 ? p : f) : i(p));
    });
    o = !1, a && c.dispose();
  });
}
class w7t extends sm {
  get debugName() {
    return this._debugNameData.getDebugName(this) ?? "LazyObservableValue";
  }
  constructor(e, t, n) {
    super(), this._debugNameData = e, this._equalityComparator = n, this._isUpToDate = !0, this._deltas = [], this._updateCounter = 0, this._value = t;
  }
  get() {
    return this._update(), this._value;
  }
  _update() {
    if (!this._isUpToDate)
      if (this._isUpToDate = !0, this._deltas.length > 0) {
        for (const e of this.observers)
          for (const t of this._deltas)
            e.handleChange(this, t);
        this._deltas.length = 0;
      } else
        for (const e of this.observers)
          e.handleChange(this, void 0);
  }
  _beginUpdate() {
    if (this._updateCounter++, this._updateCounter === 1)
      for (const e of this.observers)
        e.beginUpdate(this);
  }
  _endUpdate() {
    if (this._updateCounter--, this._updateCounter === 0) {
      this._update();
      const e = [...this.observers];
      for (const t of e)
        t.endUpdate(this);
    }
  }
  addObserver(e) {
    const t = !this.observers.has(e) && this._updateCounter > 0;
    super.addObserver(e), t && e.beginUpdate(this);
  }
  removeObserver(e) {
    const t = this.observers.has(e) && this._updateCounter > 0;
    super.removeObserver(e), t && e.endUpdate(this);
  }
  set(e, t, n) {
    if (n === void 0 && this._equalityComparator(this._value, e))
      return;
    let i;
    t || (t = i = new Ow(() => {
    }, () => `Setting ${this.debugName}`));
    try {
      if (this._isUpToDate = !1, this._setValue(e), n !== void 0 && this._deltas.push(n), t.updateObserver({
        beginUpdate: () => this._beginUpdate(),
        endUpdate: () => this._endUpdate(),
        handleChange: (s, o) => {
        },
        handlePossibleChange: (s) => {
        }
      }, this), this._updateCounter > 1)
        for (const s of this.observers)
          s.handlePossibleChange(this);
    } finally {
      i && i.finish();
    }
  }
  toString() {
    return `${this.debugName}: ${this._value}`;
  }
  _setValue(e) {
    this._value = e;
  }
}
function ok(r, e) {
  return r.lazy ? new w7t(new _s(r.owner, r.debugName, void 0), e, r.equalsFn ?? ml) : new wR(new _s(r.owner, r.debugName, void 0), e, r.equalsFn ?? ml);
}
var H1 = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
};
class v7t {
  constructor(e) {
    this.trait = e, this.renderedElements = [];
  }
  get templateId() {
    return `template:${this.trait.name}`;
  }
  renderTemplate(e) {
    return e;
  }
  renderElement(e, t, n) {
    const i = this.renderedElements.findIndex((s) => s.templateData === n);
    if (i >= 0) {
      const s = this.renderedElements[i];
      this.trait.unrender(n), s.index = t;
    } else {
      const s = { index: t, templateData: n };
      this.renderedElements.push(s);
    }
    this.trait.renderIndex(t, n);
  }
  splice(e, t, n) {
    const i = [];
    for (const s of this.renderedElements)
      s.index < e ? i.push(s) : s.index >= e + t && i.push({
        index: s.index + n - t,
        templateData: s.templateData
      });
    this.renderedElements = i;
  }
  renderIndexes(e) {
    for (const { index: t, templateData: n } of this.renderedElements)
      e.indexOf(t) > -1 && this.trait.renderIndex(t, n);
  }
  disposeTemplate(e) {
    const t = this.renderedElements.findIndex((n) => n.templateData === e);
    t < 0 || this.renderedElements.splice(t, 1);
  }
}
let V9 = class {
  get name() {
    return this._trait;
  }
  get renderer() {
    return new v7t(this);
  }
  constructor(e) {
    this._trait = e, this.indexes = [], this.sortedIndexes = [], this._onChange = new $(), this.onChange = this._onChange.event;
  }
  splice(e, t, n) {
    const i = n.length - t, s = e + t, o = [];
    let a = 0;
    for (; a < this.sortedIndexes.length && this.sortedIndexes[a] < e; )
      o.push(this.sortedIndexes[a++]);
    for (let l = 0; l < n.length; l++)
      n[l] && o.push(l + e);
    for (; a < this.sortedIndexes.length && this.sortedIndexes[a] >= s; )
      o.push(this.sortedIndexes[a++] + i);
    this.renderer.splice(e, t, n.length), this._set(o, o);
  }
  renderIndex(e, t) {
    t.classList.toggle(this._trait, this.contains(e));
  }
  unrender(e) {
    e.classList.remove(this._trait);
  }
  /**
   * Sets the indexes which should have this trait.
   *
   * @param indexes Indexes which should have this trait.
   * @return The old indexes which had this trait.
   */
  set(e, t) {
    return this._set(e, [...e].sort(a9e), t);
  }
  _set(e, t, n) {
    const i = this.indexes, s = this.sortedIndexes;
    this.indexes = e, this.sortedIndexes = t;
    const o = ak(s, e);
    return this.renderer.renderIndexes(o), this._onChange.fire({ indexes: e, browserEvent: n }), i;
  }
  get() {
    return this.indexes;
  }
  contains(e) {
    return lut(this.sortedIndexes, e, a9e) >= 0;
  }
  dispose() {
    br(this._onChange);
  }
};
H1([
  wi
], V9.prototype, "renderer", null);
class b7t extends V9 {
  constructor(e) {
    super("selected"), this.setAriaSelected = e;
  }
  renderIndex(e, t) {
    super.renderIndex(e, t), this.setAriaSelected && (this.contains(e) ? t.setAttribute("aria-selected", "true") : t.setAttribute("aria-selected", "false"));
  }
}
class v_ {
  constructor(e, t, n) {
    this.trait = e, this.view = t, this.identityProvider = n;
  }
  splice(e, t, n) {
    if (!this.identityProvider)
      return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const i = this.trait.get().map((a) => this.identityProvider.getId(this.view.element(a)).toString());
    if (i.length === 0)
      return this.trait.splice(e, t, new Array(n.length).fill(!1));
    const s = new Set(i), o = n.map((a) => s.has(this.identityProvider.getId(a).toString()));
    this.trait.splice(e, t, o);
  }
}
function e1(r) {
  return r.tagName === "INPUT" || r.tagName === "TEXTAREA";
}
function Rw(r, e) {
  return r.classList.contains(e) ? !0 : r.classList.contains("monaco-list") || !r.parentElement ? !1 : Rw(r.parentElement, e);
}
function CA(r) {
  return Rw(r, "monaco-editor");
}
function y7t(r) {
  return Rw(r, "monaco-custom-toggle");
}
function C7t(r) {
  return Rw(r, "action-item");
}
function s3(r) {
  return Rw(r, "monaco-tree-sticky-row");
}
function l4(r) {
  return r.classList.contains("monaco-tree-sticky-container");
}
function NNe(r) {
  return r.tagName === "A" && r.classList.contains("monaco-button") || r.tagName === "DIV" && r.classList.contains("monaco-button-dropdown") ? !0 : r.classList.contains("monaco-list") || !r.parentElement ? !1 : NNe(r.parentElement);
}
class TNe {
  get onKeyDown() {
    return xe.chain(this.disposables.add(new St(this.view.domNode, "keydown")).event, (e) => e.filter((t) => !e1(t.target)).map((t) => new zn(t)));
  }
  constructor(e, t, n) {
    this.list = e, this.view = t, this.disposables = new ze(), this.multipleSelectionDisposables = new ze(), this.multipleSelectionSupport = n.multipleSelectionSupport, this.disposables.add(this.onKeyDown((i) => {
      switch (i.keyCode) {
        case 3:
          return this.onEnter(i);
        case 16:
          return this.onUpArrow(i);
        case 18:
          return this.onDownArrow(i);
        case 11:
          return this.onPageUpArrow(i);
        case 12:
          return this.onPageDownArrow(i);
        case 9:
          return this.onEscape(i);
        case 31:
          this.multipleSelectionSupport && (zt ? i.metaKey : i.ctrlKey) && this.onCtrlA(i);
      }
    }));
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionSupport = e.multipleSelectionSupport);
  }
  onEnter(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(this.list.getFocus(), e.browserEvent);
  }
  onUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPrevious(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNext(1, !1, e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageUpArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusPreviousPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onPageDownArrow(e) {
    e.preventDefault(), e.stopPropagation(), this.list.focusNextPage(e.browserEvent);
    const t = this.list.getFocus()[0];
    this.list.setAnchor(t), this.list.reveal(t), this.view.domNode.focus();
  }
  onCtrlA(e) {
    e.preventDefault(), e.stopPropagation(), this.list.setSelection(ks(this.list.length), e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus();
  }
  onEscape(e) {
    this.list.getSelection().length && (e.preventDefault(), e.stopPropagation(), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0), this.view.domNode.focus());
  }
  dispose() {
    this.disposables.dispose(), this.multipleSelectionDisposables.dispose();
  }
}
H1([
  wi
], TNe.prototype, "onKeyDown", null);
var Gc;
(function(r) {
  r[r.Automatic = 0] = "Automatic", r[r.Trigger = 1] = "Trigger";
})(Gc || (Gc = {}));
var lp;
(function(r) {
  r[r.Idle = 0] = "Idle", r[r.Typing = 1] = "Typing";
})(lp || (lp = {}));
const E7t = new class {
  mightProducePrintableCharacter(r) {
    return r.ctrlKey || r.metaKey || r.altKey ? !1 : r.keyCode >= 31 && r.keyCode <= 56 || r.keyCode >= 21 && r.keyCode <= 30 || r.keyCode >= 98 && r.keyCode <= 107 || r.keyCode >= 85 && r.keyCode <= 95;
  }
}();
class _7t {
  constructor(e, t, n, i, s) {
    this.list = e, this.view = t, this.keyboardNavigationLabelProvider = n, this.keyboardNavigationEventFilter = i, this.delegate = s, this.enabled = !1, this.state = lp.Idle, this.mode = Gc.Automatic, this.triggered = !1, this.previouslyFocused = -1, this.enabledDisposables = new ze(), this.disposables = new ze(), this.updateOptions(e.options);
  }
  updateOptions(e) {
    e.typeNavigationEnabled ?? !0 ? this.enable() : this.disable(), this.mode = e.typeNavigationMode ?? Gc.Automatic;
  }
  enable() {
    if (this.enabled)
      return;
    let e = !1;
    const t = xe.chain(this.enabledDisposables.add(new St(this.view.domNode, "keydown")).event, (s) => s.filter((o) => !e1(o.target)).filter(() => this.mode === Gc.Automatic || this.triggered).map((o) => new zn(o)).filter((o) => e || this.keyboardNavigationEventFilter(o)).filter((o) => this.delegate.mightProducePrintableCharacter(o)).forEach((o) => Lt.stop(o, !0)).map((o) => o.browserEvent.key)), n = xe.debounce(t, () => null, 800, void 0, void 0, void 0, this.enabledDisposables);
    xe.reduce(xe.any(t, n), (s, o) => o === null ? null : (s || "") + o, void 0, this.enabledDisposables)(this.onInput, this, this.enabledDisposables), n(this.onClear, this, this.enabledDisposables), t(() => e = !0, void 0, this.enabledDisposables), n(() => e = !1, void 0, this.enabledDisposables), this.enabled = !0, this.triggered = !1;
  }
  disable() {
    this.enabled && (this.enabledDisposables.clear(), this.enabled = !1, this.triggered = !1);
  }
  onClear() {
    const e = this.list.getFocus();
    if (e.length > 0 && e[0] === this.previouslyFocused) {
      const t = this.list.options.accessibilityProvider?.getAriaLabel(this.list.element(e[0]));
      typeof t == "string" ? X8(t) : t && X8(t.get());
    }
    this.previouslyFocused = -1;
  }
  onInput(e) {
    if (!e) {
      this.state = lp.Idle, this.triggered = !1;
      return;
    }
    const t = this.list.getFocus(), n = t.length > 0 ? t[0] : 0, i = this.state === lp.Idle ? 1 : 0;
    this.state = lp.Typing;
    for (let s = 0; s < this.list.length; s++) {
      const o = (n + s + i) % this.list.length, a = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(o)), l = a && a.toString();
      if (this.list.options.typeNavigationEnabled) {
        if (typeof l < "u") {
          if (M9(e, l)) {
            this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
            return;
          }
          const c = n9t(e, l);
          if (c && c[0].end - c[0].start > 1 && c.length === 1) {
            this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
            return;
          }
        }
      } else if (typeof l > "u" || M9(e, l)) {
        this.previouslyFocused = n, this.list.setFocus([o]), this.list.reveal(o);
        return;
      }
    }
  }
  dispose() {
    this.disable(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
}
class x7t {
  constructor(e, t) {
    this.list = e, this.view = t, this.disposables = new ze();
    const n = xe.chain(this.disposables.add(new St(t.domNode, "keydown")).event, (s) => s.filter((o) => !e1(o.target)).map((o) => new zn(o)));
    xe.chain(n, (s) => s.filter((o) => o.keyCode === 2 && !o.ctrlKey && !o.metaKey && !o.shiftKey && !o.altKey))(this.onTab, this, this.disposables);
  }
  onTab(e) {
    if (e.target !== this.view.domNode)
      return;
    const t = this.list.getFocus();
    if (t.length === 0)
      return;
    const n = this.view.domElement(t[0]);
    if (!n)
      return;
    const i = n.querySelector("[tabIndex]");
    if (!i || !wr(i) || i.tabIndex === -1)
      return;
    const s = qe(i).getComputedStyle(i);
    s.visibility === "hidden" || s.display === "none" || (e.preventDefault(), e.stopPropagation(), i.focus());
  }
  dispose() {
    this.disposables.dispose();
  }
}
function INe(r) {
  return zt ? r.browserEvent.metaKey : r.browserEvent.ctrlKey;
}
function ONe(r) {
  return r.browserEvent.shiftKey;
}
function S7t(r) {
  return QI(r) && r.button === 2;
}
const o9e = {
  isSelectionSingleChangeEvent: INe,
  isSelectionRangeChangeEvent: ONe
};
class RNe {
  constructor(e) {
    this.list = e, this.disposables = new ze(), this._onPointer = new $(), this.onPointer = this._onPointer.event, e.options.multipleSelectionSupport !== !1 && (this.multipleSelectionController = this.list.options.multipleSelectionController || o9e), this.mouseSupport = typeof e.options.mouseSupport > "u" || !!e.options.mouseSupport, this.mouseSupport && (e.onMouseDown(this.onMouseDown, this, this.disposables), e.onContextMenu(this.onContextMenu, this, this.disposables), e.onMouseDblClick(this.onDoubleClick, this, this.disposables), e.onTouchStart(this.onMouseDown, this, this.disposables), this.disposables.add(Xn.addTarget(e.getHTMLElement()))), xe.any(e.onMouseClick, e.onMouseMiddleClick, e.onTap)(this.onViewPointer, this, this.disposables);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && (this.multipleSelectionController = void 0, e.multipleSelectionSupport && (this.multipleSelectionController = this.list.options.multipleSelectionController || o9e));
  }
  isSelectionSingleChangeEvent(e) {
    return this.multipleSelectionController ? this.multipleSelectionController.isSelectionSingleChangeEvent(e) : !1;
  }
  isSelectionRangeChangeEvent(e) {
    return this.multipleSelectionController ? this.multipleSelectionController.isSelectionRangeChangeEvent(e) : !1;
  }
  isSelectionChangeEvent(e) {
    return this.isSelectionSingleChangeEvent(e) || this.isSelectionRangeChangeEvent(e);
  }
  onMouseDown(e) {
    CA(e.browserEvent.target) || ss() !== e.browserEvent.target && this.list.domFocus();
  }
  onContextMenu(e) {
    if (e1(e.browserEvent.target) || CA(e.browserEvent.target))
      return;
    const t = typeof e.index > "u" ? [] : [e.index];
    this.list.setFocus(t, e.browserEvent);
  }
  onViewPointer(e) {
    if (!this.mouseSupport || e1(e.browserEvent.target) || CA(e.browserEvent.target) || e.browserEvent.isHandledByList)
      return;
    e.browserEvent.isHandledByList = !0;
    const t = e.index;
    if (typeof t > "u") {
      this.list.setFocus([], e.browserEvent), this.list.setSelection([], e.browserEvent), this.list.setAnchor(void 0);
      return;
    }
    if (this.isSelectionChangeEvent(e))
      return this.changeSelection(e);
    this.list.setFocus([t], e.browserEvent), this.list.setAnchor(t), S7t(e.browserEvent) || this.list.setSelection([t], e.browserEvent), this._onPointer.fire(e);
  }
  onDoubleClick(e) {
    if (e1(e.browserEvent.target) || CA(e.browserEvent.target) || this.isSelectionChangeEvent(e) || e.browserEvent.isHandledByList)
      return;
    e.browserEvent.isHandledByList = !0;
    const t = this.list.getFocus();
    this.list.setSelection(t, e.browserEvent);
  }
  changeSelection(e) {
    const t = e.index;
    let n = this.list.getAnchor();
    if (this.isSelectionRangeChangeEvent(e)) {
      typeof n > "u" && (n = this.list.getFocus()[0] ?? t, this.list.setAnchor(n));
      const i = Math.min(n, t), s = Math.max(n, t), o = ks(i, s + 1), a = this.list.getSelection(), l = L7t(ak(a, [n]), n);
      if (l.length === 0)
        return;
      const c = ak(o, k7t(a, l));
      this.list.setSelection(c, e.browserEvent), this.list.setFocus([t], e.browserEvent);
    } else if (this.isSelectionSingleChangeEvent(e)) {
      const i = this.list.getSelection(), s = i.filter((o) => o !== t);
      this.list.setFocus([t]), this.list.setAnchor(t), i.length === s.length ? this.list.setSelection([...s, t], e.browserEvent) : this.list.setSelection(s, e.browserEvent);
    }
  }
  dispose() {
    this.disposables.dispose();
  }
}
class VNe {
  constructor(e, t) {
    this.styleElement = e, this.selectorSuffix = t;
  }
  style(e) {
    const t = this.selectorSuffix && `.${this.selectorSuffix}`, n = [];
    e.listBackground && n.push(`.monaco-list${t} .monaco-list-rows { background: ${e.listBackground}; }`), e.listFocusBackground && (n.push(`.monaco-list${t}:focus .monaco-list-row.focused { background-color: ${e.listFocusBackground}; }`), n.push(`.monaco-list${t}:focus .monaco-list-row.focused:hover { background-color: ${e.listFocusBackground}; }`)), e.listFocusForeground && n.push(`.monaco-list${t}:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), e.listActiveSelectionBackground && (n.push(`.monaco-list${t}:focus .monaco-list-row.selected { background-color: ${e.listActiveSelectionBackground}; }`), n.push(`.monaco-list${t}:focus .monaco-list-row.selected:hover { background-color: ${e.listActiveSelectionBackground}; }`)), e.listActiveSelectionForeground && n.push(`.monaco-list${t}:focus .monaco-list-row.selected { color: ${e.listActiveSelectionForeground}; }`), e.listActiveSelectionIconForeground && n.push(`.monaco-list${t}:focus .monaco-list-row.selected .codicon { color: ${e.listActiveSelectionIconForeground}; }`), e.listFocusAndSelectionBackground && n.push(`
				.monaco-drag-image,
				.monaco-list${t}:focus .monaco-list-row.selected.focused { background-color: ${e.listFocusAndSelectionBackground}; }
			`), e.listFocusAndSelectionForeground && n.push(`
				.monaco-drag-image,
				.monaco-list${t}:focus .monaco-list-row.selected.focused { color: ${e.listFocusAndSelectionForeground}; }
			`), e.listInactiveFocusForeground && (n.push(`.monaco-list${t} .monaco-list-row.focused { color:  ${e.listInactiveFocusForeground}; }`), n.push(`.monaco-list${t} .monaco-list-row.focused:hover { color:  ${e.listInactiveFocusForeground}; }`)), e.listInactiveSelectionIconForeground && n.push(`.monaco-list${t} .monaco-list-row.focused .codicon { color:  ${e.listInactiveSelectionIconForeground}; }`), e.listInactiveFocusBackground && (n.push(`.monaco-list${t} .monaco-list-row.focused { background-color:  ${e.listInactiveFocusBackground}; }`), n.push(`.monaco-list${t} .monaco-list-row.focused:hover { background-color:  ${e.listInactiveFocusBackground}; }`)), e.listInactiveSelectionBackground && (n.push(`.monaco-list${t} .monaco-list-row.selected { background-color:  ${e.listInactiveSelectionBackground}; }`), n.push(`.monaco-list${t} .monaco-list-row.selected:hover { background-color:  ${e.listInactiveSelectionBackground}; }`)), e.listInactiveSelectionForeground && n.push(`.monaco-list${t} .monaco-list-row.selected { color: ${e.listInactiveSelectionForeground}; }`), e.listHoverBackground && n.push(`.monaco-list${t}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { background-color: ${e.listHoverBackground}; }`), e.listHoverForeground && n.push(`.monaco-list${t}:not(.drop-target):not(.dragging) .monaco-list-row:hover:not(.selected):not(.focused) { color:  ${e.listHoverForeground}; }`);
    const i = Cd(e.listFocusAndSelectionOutline, Cd(e.listSelectionOutline, e.listFocusOutline ?? ""));
    i && n.push(`.monaco-list${t}:focus .monaco-list-row.focused.selected { outline: 1px solid ${i}; outline-offset: -1px;}`), e.listFocusOutline && n.push(`
				.monaco-drag-image,
				.monaco-list${t}:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
				.monaco-workbench.context-menu-visible .monaco-list${t}.last-focused .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }
			`);
    const s = Cd(e.listSelectionOutline, e.listInactiveFocusOutline ?? "");
    s && n.push(`.monaco-list${t} .monaco-list-row.focused.selected { outline: 1px dotted ${s}; outline-offset: -1px; }`), e.listSelectionOutline && n.push(`.monaco-list${t} .monaco-list-row.selected { outline: 1px dotted ${e.listSelectionOutline}; outline-offset: -1px; }`), e.listInactiveFocusOutline && n.push(`.monaco-list${t} .monaco-list-row.focused { outline: 1px dotted ${e.listInactiveFocusOutline}; outline-offset: -1px; }`), e.listHoverOutline && n.push(`.monaco-list${t} .monaco-list-row:hover { outline: 1px dashed ${e.listHoverOutline}; outline-offset: -1px; }`), e.listDropOverBackground && n.push(`
				.monaco-list${t}.drop-target,
				.monaco-list${t} .monaco-list-rows.drop-target,
				.monaco-list${t} .monaco-list-row.drop-target { background-color: ${e.listDropOverBackground} !important; color: inherit !important; }
			`), e.listDropBetweenBackground && (n.push(`
			.monaco-list${t} .monaco-list-rows.drop-target-before .monaco-list-row:first-child::before,
			.monaco-list${t} .monaco-list-row.drop-target-before::before {
				content: ""; position: absolute; top: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`), n.push(`
			.monaco-list${t} .monaco-list-rows.drop-target-after .monaco-list-row:last-child::after,
			.monaco-list${t} .monaco-list-row.drop-target-after::after {
				content: ""; position: absolute; bottom: 0px; left: 0px; width: 100%; height: 1px;
				background-color: ${e.listDropBetweenBackground};
			}`)), e.tableColumnsBorder && n.push(`
				.monaco-table > .monaco-split-view2,
				.monaco-table > .monaco-split-view2 .monaco-sash.vertical::before,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table:hover > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: ${e.tableColumnsBorder};
				}

				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2,
				.monaco-workbench:not(.reduce-motion) .monaco-table > .monaco-split-view2 .monaco-sash.vertical::before {
					border-color: transparent;
				}
			`), e.tableOddRowsBackgroundColor && n.push(`
				.monaco-table .monaco-list-row[data-parity=odd]:not(.focused):not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(:focus) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr,
				.monaco-table .monaco-list:not(.focused) .monaco-list-row[data-parity=odd].focused:not(.selected):not(:hover) .monaco-table-tr {
					background-color: ${e.tableOddRowsBackgroundColor};
				}
			`), this.styleElement.textContent = n.join(`
`);
  }
}
const M7t = {
  listFocusBackground: "#7FB0D0",
  listActiveSelectionBackground: "#0E639C",
  listActiveSelectionForeground: "#FFFFFF",
  listActiveSelectionIconForeground: "#FFFFFF",
  listFocusAndSelectionOutline: "#90C2F9",
  listFocusAndSelectionBackground: "#094771",
  listFocusAndSelectionForeground: "#FFFFFF",
  listInactiveSelectionBackground: "#3F3F46",
  listInactiveSelectionIconForeground: "#FFFFFF",
  listHoverBackground: "#2A2D2E",
  listDropOverBackground: "#383B3D",
  listDropBetweenBackground: "#EEEEEE",
  treeIndentGuidesStroke: "#a9a9a9",
  treeInactiveIndentGuidesStroke: ge.fromHex("#a9a9a9").transparent(0.4).toString(),
  tableColumnsBorder: ge.fromHex("#cccccc").transparent(0.2).toString(),
  tableOddRowsBackgroundColor: ge.fromHex("#cccccc").transparent(0.04).toString(),
  listBackground: void 0,
  listFocusForeground: void 0,
  listInactiveSelectionForeground: void 0,
  listInactiveFocusForeground: void 0,
  listInactiveFocusBackground: void 0,
  listHoverForeground: void 0,
  listFocusOutline: void 0,
  listInactiveFocusOutline: void 0,
  listSelectionOutline: void 0,
  listHoverOutline: void 0,
  treeStickyScrollBackground: void 0,
  treeStickyScrollBorder: void 0,
  treeStickyScrollShadow: void 0
}, D7t = {
  keyboardSupport: !0,
  mouseSupport: !0,
  multipleSelectionSupport: !0,
  dnd: {
    getDragURI() {
      return null;
    },
    onDragStart() {
    },
    onDragOver() {
      return !1;
    },
    drop() {
    },
    dispose() {
    }
  }
};
function L7t(r, e) {
  const t = r.indexOf(e);
  if (t === -1)
    return [];
  const n = [];
  let i = t - 1;
  for (; i >= 0 && r[i] === e - (t - i); )
    n.push(r[i--]);
  for (n.reverse(), i = t; i < r.length && r[i] === e + (i - t); )
    n.push(r[i++]);
  return n;
}
function ak(r, e) {
  const t = [];
  let n = 0, i = 0;
  for (; n < r.length || i < e.length; )
    if (n >= r.length)
      t.push(e[i++]);
    else if (i >= e.length)
      t.push(r[n++]);
    else if (r[n] === e[i]) {
      t.push(r[n]), n++, i++;
      continue;
    } else r[n] < e[i] ? t.push(r[n++]) : t.push(e[i++]);
  return t;
}
function k7t(r, e) {
  const t = [];
  let n = 0, i = 0;
  for (; n < r.length || i < e.length; )
    if (n >= r.length)
      t.push(e[i++]);
    else if (i >= e.length)
      t.push(r[n++]);
    else if (r[n] === e[i]) {
      n++, i++;
      continue;
    } else r[n] < e[i] ? t.push(r[n++]) : i++;
  return t;
}
const a9e = (r, e) => r - e;
class N7t {
  constructor(e, t) {
    this._templateId = e, this.renderers = t;
  }
  get templateId() {
    return this._templateId;
  }
  renderTemplate(e) {
    return this.renderers.map((t) => t.renderTemplate(e));
  }
  renderElement(e, t, n, i) {
    let s = 0;
    for (const o of this.renderers)
      o.renderElement(e, t, n[s++], i);
  }
  disposeElement(e, t, n, i) {
    let s = 0;
    for (const o of this.renderers)
      o.disposeElement?.(e, t, n[s], i), s += 1;
  }
  disposeTemplate(e) {
    let t = 0;
    for (const n of this.renderers)
      n.disposeTemplate(e[t++]);
  }
}
class T7t {
  constructor(e) {
    this.accessibilityProvider = e, this.templateId = "a18n";
  }
  renderTemplate(e) {
    return { container: e, disposables: new ze() };
  }
  renderElement(e, t, n) {
    const i = this.accessibilityProvider.getAriaLabel(e), s = i && typeof i != "string" ? i : R9(i);
    n.disposables.add(nn((a) => {
      this.setAriaLabel(a.readObservable(s), n.container);
    }));
    const o = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
    typeof o == "number" ? n.container.setAttribute("aria-level", `${o}`) : n.container.removeAttribute("aria-level");
  }
  setAriaLabel(e, t) {
    e ? t.setAttribute("aria-label", e) : t.removeAttribute("aria-label");
  }
  disposeElement(e, t, n, i) {
    n.disposables.clear();
  }
  disposeTemplate(e) {
    e.disposables.dispose();
  }
}
class I7t {
  constructor(e, t) {
    this.list = e, this.dnd = t;
  }
  getDragElements(e) {
    const t = this.list.getSelectedElements();
    return t.indexOf(e) > -1 ? t : [e];
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e, t);
  }
  onDragStart(e, t) {
    this.dnd.onDragStart?.(e, t);
  }
  onDragOver(e, t, n, i, s) {
    return this.dnd.onDragOver(e, t, n, i, s);
  }
  onDragLeave(e, t, n, i) {
    this.dnd.onDragLeave?.(e, t, n, i);
  }
  onDragEnd(e) {
    this.dnd.onDragEnd?.(e);
  }
  drop(e, t, n, i, s) {
    this.dnd.drop(e, t, n, i, s);
  }
  dispose() {
    this.dnd.dispose();
  }
}
let gc = class {
  get onDidChangeFocus() {
    return xe.map(this.eventBufferer.wrapEvent(this.focus.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get onDidChangeSelection() {
    return xe.map(this.eventBufferer.wrapEvent(this.selection.onChange), (e) => this.toListEvent(e), this.disposables);
  }
  get domId() {
    return this.view.domId;
  }
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onMouseClick() {
    return this.view.onMouseClick;
  }
  get onMouseDblClick() {
    return this.view.onMouseDblClick;
  }
  get onMouseMiddleClick() {
    return this.view.onMouseMiddleClick;
  }
  get onPointer() {
    return this.mouseController.onPointer;
  }
  get onMouseDown() {
    return this.view.onMouseDown;
  }
  get onMouseOver() {
    return this.view.onMouseOver;
  }
  get onMouseOut() {
    return this.view.onMouseOut;
  }
  get onTouchStart() {
    return this.view.onTouchStart;
  }
  get onTap() {
    return this.view.onTap;
  }
  /**
   * Possible context menu trigger events:
   * - ContextMenu key
   * - Shift F10
   * - Ctrl Option Shift M (macOS with VoiceOver)
   * - Mouse right click
   */
  get onContextMenu() {
    let e = !1;
    const t = xe.chain(this.disposables.add(new St(this.view.domNode, "keydown")).event, (s) => s.map((o) => new zn(o)).filter((o) => e = o.keyCode === 58 || o.shiftKey && o.keyCode === 68).map((o) => Lt.stop(o, !0)).filter(() => !1)), n = xe.chain(this.disposables.add(new St(this.view.domNode, "keyup")).event, (s) => s.forEach(() => e = !1).map((o) => new zn(o)).filter((o) => o.keyCode === 58 || o.shiftKey && o.keyCode === 68).map((o) => Lt.stop(o, !0)).map(({ browserEvent: o }) => {
      const a = this.getFocus(), l = a.length ? a[0] : void 0, c = typeof l < "u" ? this.view.element(l) : void 0, d = typeof l < "u" ? this.view.domElement(l) : this.view.domNode;
      return { index: l, element: c, anchor: d, browserEvent: o };
    })), i = xe.chain(this.view.onContextMenu, (s) => s.filter((o) => !e).map(({ element: o, index: a, browserEvent: l }) => ({ element: o, index: a, anchor: new zl(qe(this.view.domNode), l), browserEvent: l })));
    return xe.any(t, n, i);
  }
  get onKeyDown() {
    return this.disposables.add(new St(this.view.domNode, "keydown")).event;
  }
  get onDidFocus() {
    return xe.signal(this.disposables.add(new St(this.view.domNode, "focus", !0)).event);
  }
  get onDidBlur() {
    return xe.signal(this.disposables.add(new St(this.view.domNode, "blur", !0)).event);
  }
  constructor(e, t, n, i, s = D7t) {
    this.user = e, this._options = s, this.focus = new V9("focused"), this.anchor = new V9("anchor"), this.eventBufferer = new Aw(), this._ariaLabel = "", this.disposables = new ze(), this._onDidDispose = new $(), this.onDidDispose = this._onDidDispose.event;
    const o = this._options.accessibilityProvider && this._options.accessibilityProvider.getWidgetRole ? this._options.accessibilityProvider?.getWidgetRole() : "list";
    this.selection = new b7t(o !== "listbox");
    const a = [this.focus.renderer, this.selection.renderer];
    this.accessibilityProvider = s.accessibilityProvider, this.accessibilityProvider && (a.push(new T7t(this.accessibilityProvider)), this.accessibilityProvider.onDidChangeActiveDescendant?.(this.onDidChangeActiveDescendant, this, this.disposables)), i = i.map((c) => new N7t(c.templateId, [...a, c]));
    const l = {
      ...s,
      dnd: s.dnd && new I7t(this, s.dnd)
    };
    if (this.view = this.createListView(t, n, i, l), this.view.domNode.setAttribute("role", o), s.styleController)
      this.styleController = s.styleController(this.view.domId);
    else {
      const c = ya(this.view.domNode);
      this.styleController = new VNe(c, this.view.domId);
    }
    if (this.spliceable = new Ubt([
      new v_(this.focus, this.view, s.identityProvider),
      new v_(this.selection, this.view, s.identityProvider),
      new v_(this.anchor, this.view, s.identityProvider),
      this.view
    ]), this.disposables.add(this.focus), this.disposables.add(this.selection), this.disposables.add(this.anchor), this.disposables.add(this.view), this.disposables.add(this._onDidDispose), this.disposables.add(new x7t(this, this.view)), (typeof s.keyboardSupport != "boolean" || s.keyboardSupport) && (this.keyboardController = new TNe(this, this.view, s), this.disposables.add(this.keyboardController)), s.keyboardNavigationLabelProvider) {
      const c = s.keyboardNavigationDelegate || E7t;
      this.typeNavigationController = new _7t(this, this.view, s.keyboardNavigationLabelProvider, s.keyboardNavigationEventFilter ?? (() => !0), c), this.disposables.add(this.typeNavigationController);
    }
    this.mouseController = this.createMouseController(s), this.disposables.add(this.mouseController), this.onDidChangeFocus(this._onFocusChange, this, this.disposables), this.onDidChangeSelection(this._onSelectionChange, this, this.disposables), this.accessibilityProvider && (this.ariaLabel = this.accessibilityProvider.getWidgetAriaLabel()), this._options.multipleSelectionSupport !== !1 && this.view.domNode.setAttribute("aria-multiselectable", "true");
  }
  createListView(e, t, n, i) {
    return new vl(e, t, n, i);
  }
  createMouseController(e) {
    return new RNe(this);
  }
  updateOptions(e = {}) {
    this._options = { ...this._options, ...e }, this.typeNavigationController?.updateOptions(this._options), this._options.multipleSelectionController !== void 0 && (this._options.multipleSelectionSupport ? this.view.domNode.setAttribute("aria-multiselectable", "true") : this.view.domNode.removeAttribute("aria-multiselectable")), this.mouseController.updateOptions(e), this.keyboardController?.updateOptions(e), this.view.updateOptions(e);
  }
  get options() {
    return this._options;
  }
  splice(e, t, n = []) {
    if (e < 0 || e > this.view.length)
      throw new K1(this.user, `Invalid start index: ${e}`);
    if (t < 0)
      throw new K1(this.user, `Invalid delete count: ${t}`);
    t === 0 && n.length === 0 || this.eventBufferer.bufferEvents(() => this.spliceable.splice(e, t, n));
  }
  rerender() {
    this.view.rerender();
  }
  element(e) {
    return this.view.element(e);
  }
  indexOf(e) {
    return this.view.indexOf(e);
  }
  indexAt(e) {
    return this.view.indexAt(e);
  }
  get length() {
    return this.view.length;
  }
  get contentHeight() {
    return this.view.contentHeight;
  }
  get onDidChangeContentHeight() {
    return this.view.onDidChangeContentHeight;
  }
  get scrollTop() {
    return this.view.getScrollTop();
  }
  set scrollTop(e) {
    this.view.setScrollTop(e);
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get firstVisibleIndex() {
    return this.view.firstVisibleIndex;
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.view.domNode.setAttribute("aria-label", e);
  }
  domFocus() {
    this.view.domNode.focus({ preventScroll: !0 });
  }
  layout(e, t) {
    this.view.layout(e, t);
  }
  setSelection(e, t) {
    for (const n of e)
      if (n < 0 || n >= this.length)
        throw new K1(this.user, `Invalid index ${n}`);
    this.selection.set(e, t);
  }
  getSelection() {
    return this.selection.get();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.view.element(e));
  }
  setAnchor(e) {
    if (typeof e > "u") {
      this.anchor.set([]);
      return;
    }
    if (e < 0 || e >= this.length)
      throw new K1(this.user, `Invalid index ${e}`);
    this.anchor.set([e]);
  }
  getAnchor() {
    return vI(this.anchor.get(), void 0);
  }
  getAnchorElement() {
    const e = this.getAnchor();
    return typeof e > "u" ? void 0 : this.element(e);
  }
  setFocus(e, t) {
    for (const n of e)
      if (n < 0 || n >= this.length)
        throw new K1(this.user, `Invalid index ${n}`);
    this.focus.set(e, t);
  }
  focusNext(e = 1, t = !1, n, i) {
    if (this.length === 0)
      return;
    const s = this.focus.get(), o = this.findNextIndex(s.length > 0 ? s[0] + e : 0, t, i);
    o > -1 && this.setFocus([o], n);
  }
  focusPrevious(e = 1, t = !1, n, i) {
    if (this.length === 0)
      return;
    const s = this.focus.get(), o = this.findPreviousIndex(s.length > 0 ? s[0] - e : 0, t, i);
    o > -1 && this.setFocus([o], n);
  }
  async focusNextPage(e, t) {
    let n = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
    n = n === 0 ? 0 : n - 1;
    const i = this.getFocus()[0];
    if (i !== n && (i === void 0 || n > i)) {
      const s = this.findPreviousIndex(n, !1, t);
      s > -1 && i !== s ? this.setFocus([s], e) : this.setFocus([n], e);
    } else {
      const s = this.view.getScrollTop();
      let o = s + this.view.renderHeight;
      n > i && (o -= this.view.elementHeight(n)), this.view.setScrollTop(o), this.view.getScrollTop() !== s && (this.setFocus([]), await B3(0), await this.focusNextPage(e, t));
    }
  }
  async focusPreviousPage(e, t, n = () => 0) {
    let i;
    const s = n(), o = this.view.getScrollTop() + s;
    o === 0 ? i = this.view.indexAt(o) : i = this.view.indexAfter(o - 1);
    const a = this.getFocus()[0];
    if (a !== i && (a === void 0 || a >= i)) {
      const l = this.findNextIndex(i, !1, t);
      l > -1 && a !== l ? this.setFocus([l], e) : this.setFocus([i], e);
    } else {
      const l = o;
      this.view.setScrollTop(o - this.view.renderHeight - s), this.view.getScrollTop() + n() !== l && (this.setFocus([]), await B3(0), await this.focusPreviousPage(e, t, n));
    }
  }
  focusLast(e, t) {
    if (this.length === 0)
      return;
    const n = this.findPreviousIndex(this.length - 1, !1, t);
    n > -1 && this.setFocus([n], e);
  }
  focusFirst(e, t) {
    this.focusNth(0, e, t);
  }
  focusNth(e, t, n) {
    if (this.length === 0)
      return;
    const i = this.findNextIndex(e, !1, n);
    i > -1 && this.setFocus([i], t);
  }
  findNextIndex(e, t = !1, n) {
    for (let i = 0; i < this.length; i++) {
      if (e >= this.length && !t)
        return -1;
      if (e = e % this.length, !n || n(this.element(e)))
        return e;
      e++;
    }
    return -1;
  }
  findPreviousIndex(e, t = !1, n) {
    for (let i = 0; i < this.length; i++) {
      if (e < 0 && !t)
        return -1;
      if (e = (this.length + e % this.length) % this.length, !n || n(this.element(e)))
        return e;
      e--;
    }
    return -1;
  }
  getFocus() {
    return this.focus.get();
  }
  getFocusedElements() {
    return this.getFocus().map((e) => this.view.element(e));
  }
  reveal(e, t, n = 0) {
    if (e < 0 || e >= this.length)
      throw new K1(this.user, `Invalid index ${e}`);
    const i = this.view.getScrollTop(), s = this.view.elementTop(e), o = this.view.elementHeight(e);
    if (Kg(t)) {
      const a = o - this.view.renderHeight + n;
      this.view.setScrollTop(a * Ns(t, 0, 1) + s - n);
    } else {
      const a = s + o, l = i + this.view.renderHeight;
      s < i + n && a >= l || (s < i + n || a >= l && o >= this.view.renderHeight ? this.view.setScrollTop(s - n) : a >= l && this.view.setScrollTop(a - this.view.renderHeight));
    }
  }
  /**
   * Returns the relative position of an element rendered in the list.
   * Returns `null` if the element isn't *entirely* in the visible viewport.
   */
  getRelativeTop(e, t = 0) {
    if (e < 0 || e >= this.length)
      throw new K1(this.user, `Invalid index ${e}`);
    const n = this.view.getScrollTop(), i = this.view.elementTop(e), s = this.view.elementHeight(e);
    if (i < n + t || i + s > n + this.view.renderHeight)
      return null;
    const o = s - this.view.renderHeight + t;
    return Math.abs((n + t - i) / o);
  }
  getHTMLElement() {
    return this.view.domNode;
  }
  getScrollableElement() {
    return this.view.scrollableElementDomNode;
  }
  getElementID(e) {
    return this.view.getElementDomId(e);
  }
  getElementTop(e) {
    return this.view.elementTop(e);
  }
  style(e) {
    this.styleController.style(e);
  }
  toListEvent({ indexes: e, browserEvent: t }) {
    return { indexes: e, elements: e.map((n) => this.view.element(n)), browserEvent: t };
  }
  _onFocusChange() {
    const e = this.focus.get();
    this.view.domNode.classList.toggle("element-focused", e.length > 0), this.onDidChangeActiveDescendant();
  }
  onDidChangeActiveDescendant() {
    const e = this.focus.get();
    if (e.length > 0) {
      let t;
      this.accessibilityProvider?.getActiveDescendantId && (t = this.accessibilityProvider.getActiveDescendantId(this.view.element(e[0]))), this.view.domNode.setAttribute("aria-activedescendant", t || this.view.getElementDomId(e[0]));
    } else
      this.view.domNode.removeAttribute("aria-activedescendant");
  }
  _onSelectionChange() {
    const e = this.selection.get();
    this.view.domNode.classList.toggle("selection-none", e.length === 0), this.view.domNode.classList.toggle("selection-single", e.length === 1), this.view.domNode.classList.toggle("selection-multiple", e.length > 1);
  }
  dispose() {
    this._onDidDispose.fire(), this.disposables.dispose(), this._onDidDispose.dispose();
  }
};
H1([
  wi
], gc.prototype, "onDidChangeFocus", null);
H1([
  wi
], gc.prototype, "onDidChangeSelection", null);
H1([
  wi
], gc.prototype, "onContextMenu", null);
H1([
  wi
], gc.prototype, "onKeyDown", null);
H1([
  wi
], gc.prototype, "onDidFocus", null);
H1([
  wi
], gc.prototype, "onDidBlur", null);
const V0 = $e, HNe = "selectOption.entry.template";
class O7t {
  get templateId() {
    return HNe;
  }
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return t.root = e, t.text = Fe(e, V0(".option-text")), t.detail = Fe(e, V0(".option-detail")), t.decoratorRight = Fe(e, V0(".option-decorator-right")), t;
  }
  renderElement(e, t, n) {
    const i = n, s = e.text, o = e.detail, a = e.decoratorRight, l = e.isDisabled;
    i.text.textContent = s, i.detail.textContent = o || "", i.decoratorRight.innerText = a || "", l ? i.root.classList.add("option-disabled") : i.root.classList.remove("option-disabled");
  }
  disposeTemplate(e) {
  }
}
class _0 extends me {
  static {
    this.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN = 32;
  }
  static {
    this.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN = 2;
  }
  static {
    this.DEFAULT_MINIMUM_VISIBLE_OPTIONS = 3;
  }
  constructor(e, t, n, i, s) {
    super(), this.options = [], this._currentSelection = 0, this._hasDetails = !1, this._skipLayout = !1, this._sticky = !1, this._isVisible = !1, this.styles = i, this.selectBoxOptions = s || /* @__PURE__ */ Object.create(null), typeof this.selectBoxOptions.minBottomMargin != "number" ? this.selectBoxOptions.minBottomMargin = _0.DEFAULT_DROPDOWN_MINIMUM_BOTTOM_MARGIN : this.selectBoxOptions.minBottomMargin < 0 && (this.selectBoxOptions.minBottomMargin = 0), this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box monaco-select-box-dropdown-padding", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = new $(), this._register(this._onDidSelect), this.registerListeners(), this.constructSelectDropDown(n), this.selected = t || 0, e && this.setOptions(e, t), this.initStyleSheet();
  }
  setTitle(e) {
    !this._hover && e ? this._hover = this._register(Mh().setupManagedHover(fo("mouse"), this.selectElement, e)) : this._hover && this._hover.update(e);
  }
  // IDelegate - List renderer
  getHeight() {
    return 22;
  }
  getTemplateId() {
    return HNe;
  }
  constructSelectDropDown(e) {
    this.contextViewProvider = e, this.selectDropDownContainer = $e(".monaco-select-box-dropdown-container"), this.selectDropDownContainer.classList.add("monaco-select-box-dropdown-padding"), this.selectionDetailsPane = Fe(this.selectDropDownContainer, V0(".select-box-details-pane"));
    const t = Fe(this.selectDropDownContainer, V0(".select-box-dropdown-container-width-control")), n = Fe(t, V0(".width-control-div"));
    this.widthControlElement = document.createElement("span"), this.widthControlElement.className = "option-text-width-control", Fe(n, this.widthControlElement), this._dropDownPosition = 0, this.styleElement = ya(this.selectDropDownContainer), this.selectDropDownContainer.setAttribute("draggable", "true"), this._register(fe(this.selectDropDownContainer, Se.DRAG_START, (i) => {
      Lt.stop(i, !0);
    }));
  }
  registerListeners() {
    this._register(ir(this.selectElement, "change", (t) => {
      this.selected = t.target.selectedIndex, this._onDidSelect.fire({
        index: t.target.selectedIndex,
        selected: t.target.value
      }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
    })), this._register(fe(this.selectElement, Se.CLICK, (t) => {
      Lt.stop(t), this._isVisible ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(fe(this.selectElement, Se.MOUSE_DOWN, (t) => {
      Lt.stop(t);
    }));
    let e;
    this._register(fe(this.selectElement, "touchstart", (t) => {
      e = this._isVisible;
    })), this._register(fe(this.selectElement, "touchend", (t) => {
      Lt.stop(t), e ? this.hideSelectDropDown(!0) : this.showSelectDropDown();
    })), this._register(fe(this.selectElement, Se.KEY_DOWN, (t) => {
      const n = new zn(t);
      let i = !1;
      zt ? (n.keyCode === 18 || n.keyCode === 16 || n.keyCode === 10 || n.keyCode === 3) && (i = !0) : (n.keyCode === 18 && n.altKey || n.keyCode === 16 && n.altKey || n.keyCode === 10 || n.keyCode === 3) && (i = !0), i && (this.showSelectDropDown(), Lt.stop(t, !0));
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    Zi(this.options, e) || (this.options = e, this.selectElement.options.length = 0, this._hasDetails = !1, this._cachedMaxDetailsHeight = void 0, this.options.forEach((n, i) => {
      this.selectElement.add(this.createOption(n.text, i, n.isDisabled)), typeof n.description == "string" && (this._hasDetails = !0);
    })), t !== void 0 && (this.select(t), this._currentSelection = this.selected);
  }
  setOptionsList() {
    this.selectList?.splice(0, this.selectList.length, this.options);
  }
  select(e) {
    e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text);
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    this.container = e, e.classList.add("select-container"), e.appendChild(this.selectElement), this.styleSelectElement();
  }
  initStyleSheet() {
    const e = [];
    this.styles.listFocusBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { background-color: ${this.styles.listFocusBackground} !important; }`), this.styles.listFocusForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { color: ${this.styles.listFocusForeground} !important; }`), this.styles.decoratorRightForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.focused) .option-decorator-right { color: ${this.styles.decoratorRightForeground}; }`), this.styles.selectBackground && this.styles.selectBorder && this.styles.selectBorder !== this.styles.selectBackground ? (e.push(`.monaco-select-box-dropdown-container { border: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectBorder} } `)) : this.styles.selectListBorder && (e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-top { border-top: 1px solid ${this.styles.selectListBorder} } `), e.push(`.monaco-select-box-dropdown-container > .select-box-details-pane.border-bottom { border-bottom: 1px solid ${this.styles.selectListBorder} } `)), this.styles.listHoverForeground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { color: ${this.styles.listHoverForeground} !important; }`), this.styles.listHoverBackground && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { background-color: ${this.styles.listHoverBackground} !important; }`), this.styles.listFocusOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.focused { outline: 1.6px dotted ${this.styles.listFocusOutline} !important; outline-offset: -1.6px !important; }`), this.styles.listHoverOutline && e.push(`.monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row:not(.option-disabled):not(.focused):hover { outline: 1.6px dashed ${this.styles.listHoverOutline} !important; outline-offset: -1.6px !important; }`), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled.focused { background-color: transparent !important; color: inherit !important; outline: none !important; }"), e.push(".monaco-select-box-dropdown-container > .select-box-dropdown-list-container .monaco-list .monaco-list-row.option-disabled:hover { background-color: transparent !important; color: inherit !important; outline: none !important; }"), this.styleElement.textContent = e.join(`
`);
  }
  styleSelectElement() {
    const e = this.styles.selectBackground ?? "", t = this.styles.selectForeground ?? "", n = this.styles.selectBorder ?? "";
    this.selectElement.style.backgroundColor = e, this.selectElement.style.color = t, this.selectElement.style.borderColor = n;
  }
  styleList() {
    const e = this.styles.selectBackground ?? "", t = Cd(this.styles.selectListBackground, e);
    this.selectDropDownListContainer.style.backgroundColor = t, this.selectionDetailsPane.style.backgroundColor = t;
    const n = this.styles.focusBorder ?? "";
    this.selectDropDownContainer.style.outlineColor = n, this.selectDropDownContainer.style.outlineOffset = "-1px", this.selectList.style(this.styles);
  }
  createOption(e, t, n) {
    const i = document.createElement("option");
    return i.value = e, i.text = e, i.disabled = !!n, i;
  }
  // ContextView dropdown methods
  showSelectDropDown() {
    this.selectionDetailsPane.innerText = "", !(!this.contextViewProvider || this._isVisible) && (this.createSelectList(this.selectDropDownContainer), this.setOptionsList(), this.contextViewProvider.showContextView({
      getAnchor: () => this.selectElement,
      render: (e) => this.renderSelectDropDown(e, !0),
      layout: () => {
        this.layoutSelectDropDown();
      },
      onHide: () => {
        this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
      },
      anchorPosition: this._dropDownPosition
    }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._isVisible = !0, this.hideSelectDropDown(!1), this.contextViewProvider.showContextView({
      getAnchor: () => this.selectElement,
      render: (e) => this.renderSelectDropDown(e),
      layout: () => this.layoutSelectDropDown(),
      onHide: () => {
        this.selectDropDownContainer.classList.remove("visible"), this.selectElement.classList.remove("synthetic-focus");
      },
      anchorPosition: this._dropDownPosition
    }, this.selectBoxOptions.optionsAsChildren ? this.container : void 0), this._currentSelection = this.selected, this._isVisible = !0, this.selectElement.setAttribute("aria-expanded", "true"));
  }
  hideSelectDropDown(e) {
    !this.contextViewProvider || !this._isVisible || (this._isVisible = !1, this.selectElement.setAttribute("aria-expanded", "false"), e && this.selectElement.focus(), this.contextViewProvider.hideContextView());
  }
  renderSelectDropDown(e, t) {
    return e.appendChild(this.selectDropDownContainer), this.layoutSelectDropDown(t), {
      dispose: () => {
        this.selectDropDownContainer.remove();
      }
    };
  }
  // Iterate over detailed descriptions, find max height
  measureMaxDetailsHeight() {
    let e = 0;
    return this.options.forEach((t, n) => {
      this.updateDetail(n), this.selectionDetailsPane.offsetHeight > e && (e = this.selectionDetailsPane.offsetHeight);
    }), e;
  }
  layoutSelectDropDown(e) {
    if (this._skipLayout)
      return !1;
    if (this.selectList) {
      this.selectDropDownContainer.classList.add("visible");
      const t = qe(this.selectElement), n = To(this.selectElement), i = qe(this.selectElement).getComputedStyle(this.selectElement), s = parseFloat(i.getPropertyValue("--dropdown-padding-top")) + parseFloat(i.getPropertyValue("--dropdown-padding-bottom")), o = t.innerHeight - n.top - n.height - (this.selectBoxOptions.minBottomMargin || 0), a = n.top - _0.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN, l = this.selectElement.offsetWidth, c = this.setWidthControlElement(this.widthControlElement), d = Math.max(c, Math.round(l)).toString() + "px";
      this.selectDropDownContainer.style.width = d, this.selectList.getHTMLElement().style.height = "", this.selectList.layout();
      let u = this.selectList.contentHeight;
      this._hasDetails && this._cachedMaxDetailsHeight === void 0 && (this._cachedMaxDetailsHeight = this.measureMaxDetailsHeight());
      const f = this._hasDetails ? this._cachedMaxDetailsHeight : 0, p = u + s + f, g = Math.floor((o - s - f) / this.getHeight()), m = Math.floor((a - s - f) / this.getHeight());
      if (e)
        return n.top + n.height > t.innerHeight - 22 || n.top < _0.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || g < 1 && m < 1 ? !1 : (g < _0.DEFAULT_MINIMUM_VISIBLE_OPTIONS && m > g && this.options.length > g ? (this._dropDownPosition = 1, this.selectDropDownListContainer.remove(), this.selectionDetailsPane.remove(), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectionDetailsPane.classList.remove("border-top"), this.selectionDetailsPane.classList.add("border-bottom")) : (this._dropDownPosition = 0, this.selectDropDownListContainer.remove(), this.selectionDetailsPane.remove(), this.selectDropDownContainer.appendChild(this.selectDropDownListContainer), this.selectDropDownContainer.appendChild(this.selectionDetailsPane), this.selectionDetailsPane.classList.remove("border-bottom"), this.selectionDetailsPane.classList.add("border-top")), !0);
      if (n.top + n.height > t.innerHeight - 22 || n.top < _0.DEFAULT_DROPDOWN_MINIMUM_TOP_MARGIN || this._dropDownPosition === 0 && g < 1 || this._dropDownPosition === 1 && m < 1)
        return this.hideSelectDropDown(!0), !1;
      if (this._dropDownPosition === 0) {
        if (this._isVisible && g + m < 1)
          return this.hideSelectDropDown(!0), !1;
        p > o && (u = g * this.getHeight());
      } else
        p > a && (u = m * this.getHeight());
      return this.selectList.layout(u), this.selectList.domFocus(), this.selectList.length > 0 && (this.selectList.setFocus([this.selected || 0]), this.selectList.reveal(this.selectList.getFocus()[0] || 0)), this._hasDetails ? (this.selectList.getHTMLElement().style.height = u + s + "px", this.selectDropDownContainer.style.height = "") : this.selectDropDownContainer.style.height = u + s + "px", this.updateDetail(this.selected), this.selectDropDownContainer.style.width = d, this.selectDropDownListContainer.setAttribute("tabindex", "0"), this.selectElement.classList.add("synthetic-focus"), this.selectDropDownContainer.classList.add("synthetic-focus"), !0;
    } else
      return !1;
  }
  setWidthControlElement(e) {
    let t = 0;
    if (e) {
      let n = 0, i = 0;
      this.options.forEach((s, o) => {
        const a = s.detail ? s.detail.length : 0, l = s.decoratorRight ? s.decoratorRight.length : 0, c = s.text.length + a + l;
        c > i && (n = o, i = c);
      }), e.textContent = this.options[n].text + (this.options[n].decoratorRight ? this.options[n].decoratorRight + " " : ""), t = Fa(e);
    }
    return t;
  }
  createSelectList(e) {
    if (this.selectList)
      return;
    this.selectDropDownListContainer = Fe(e, V0(".select-box-dropdown-list-container")), this.listRenderer = new O7t(), this.selectList = this._register(new gc("SelectBoxCustom", this.selectDropDownListContainer, this, [this.listRenderer], {
      useShadows: !1,
      verticalScrollMode: 3,
      keyboardSupport: !1,
      mouseSupport: !1,
      accessibilityProvider: {
        getAriaLabel: (i) => {
          let s = i.text;
          return i.detail && (s += `. ${i.detail}`), i.decoratorRight && (s += `. ${i.decoratorRight}`), i.description && (s += `. ${i.description}`), s;
        },
        getWidgetAriaLabel: () => C({ key: "selectBox", comment: ["Behave like native select dropdown element."] }, "Select Box"),
        getRole: () => zt ? "" : "option",
        getWidgetRole: () => "listbox"
      }
    })), this.selectBoxOptions.ariaLabel && (this.selectList.ariaLabel = this.selectBoxOptions.ariaLabel);
    const t = this._register(new St(this.selectDropDownListContainer, "keydown")), n = xe.chain(t.event, (i) => i.filter(() => this.selectList.length > 0).map((s) => new zn(s)));
    this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 3
      /* KeyCode.Enter */
    ))(this.onEnter, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 2
      /* KeyCode.Tab */
    ))(this.onEnter, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 9
      /* KeyCode.Escape */
    ))(this.onEscape, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 16
      /* KeyCode.UpArrow */
    ))(this.onUpArrow, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 18
      /* KeyCode.DownArrow */
    ))(this.onDownArrow, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 12
      /* KeyCode.PageDown */
    ))(this.onPageDown, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 11
      /* KeyCode.PageUp */
    ))(this.onPageUp, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 14
      /* KeyCode.Home */
    ))(this.onHome, this)), this._register(xe.chain(n, (i) => i.filter(
      (s) => s.keyCode === 13
      /* KeyCode.End */
    ))(this.onEnd, this)), this._register(xe.chain(n, (i) => i.filter((s) => s.keyCode >= 21 && s.keyCode <= 56 || s.keyCode >= 85 && s.keyCode <= 113))(this.onCharacter, this)), this._register(fe(this.selectList.getHTMLElement(), Se.POINTER_UP, (i) => this.onPointerUp(i))), this._register(this.selectList.onMouseOver((i) => typeof i.index < "u" && this.selectList.setFocus([i.index]))), this._register(this.selectList.onDidChangeFocus((i) => this.onListFocus(i))), this._register(fe(this.selectDropDownContainer, Se.FOCUS_OUT, (i) => {
      !this._isVisible || Ji(i.relatedTarget, this.selectDropDownContainer) || this.onListBlur();
    })), this.selectList.getHTMLElement().setAttribute("aria-label", this.selectBoxOptions.ariaLabel || ""), this.selectList.getHTMLElement().setAttribute("aria-expanded", "true"), this.styleList();
  }
  // List methods
  // List mouse controller - active exit, select option, fire onDidSelect if change, return focus to parent select
  // Also takes in touchend events
  onPointerUp(e) {
    if (!this.selectList.length)
      return;
    Lt.stop(e);
    const t = e.target;
    if (!t || t.classList.contains("slider"))
      return;
    const n = t.closest(".monaco-list-row");
    if (!n)
      return;
    const i = Number(n.getAttribute("data-index")), s = n.classList.contains("option-disabled");
    i >= 0 && i < this.options.length && !s && (this.selected = i, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({
      index: this.selectElement.selectedIndex,
      selected: this.options[this.selected].text
    }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0));
  }
  // List Exit - passive - implicit no selection change, hide drop-down
  onListBlur() {
    this._sticky || (this.selected !== this._currentSelection && this.select(this._currentSelection), this.hideSelectDropDown(!1));
  }
  renderDescriptionMarkdown(e, t) {
    const n = (s) => {
      for (let o = 0; o < s.childNodes.length; o++) {
        const a = s.childNodes.item(o);
        (a.tagName && a.tagName.toLowerCase()) === "img" ? a.remove() : n(a);
      }
    }, i = dR({ value: e, supportThemeIcons: !0 }, { actionHandler: t });
    return i.element.classList.add("select-box-description-markdown"), n(i.element), i.element;
  }
  // List Focus Change - passive - update details pane with newly focused element's data
  onListFocus(e) {
    !this._isVisible || !this._hasDetails || this.updateDetail(e.indexes[0]);
  }
  updateDetail(e) {
    this.selectionDetailsPane.innerText = "";
    const t = this.options[e], n = t?.description ?? "", i = t?.descriptionIsMarkdown ?? !1;
    if (n) {
      if (i) {
        const s = t.descriptionMarkdownActionHandler;
        this.selectionDetailsPane.appendChild(this.renderDescriptionMarkdown(n, s));
      } else
        this.selectionDetailsPane.innerText = n;
      this.selectionDetailsPane.style.display = "block";
    } else
      this.selectionDetailsPane.style.display = "none";
    this._skipLayout = !0, this.contextViewProvider.layout(), this._skipLayout = !1;
  }
  // List keyboard controller
  // List exit - active - hide ContextView dropdown, reset selection, return focus to parent select
  onEscape(e) {
    Lt.stop(e), this.select(this._currentSelection), this.hideSelectDropDown(!0);
  }
  // List exit - active - hide ContextView dropdown, return focus to parent select, fire onDidSelect if change
  onEnter(e) {
    Lt.stop(e), this.selected !== this._currentSelection && (this._currentSelection = this.selected, this._onDidSelect.fire({
      index: this.selectElement.selectedIndex,
      selected: this.options[this.selected].text
    }), this.options[this.selected] && this.options[this.selected].text && this.setTitle(this.options[this.selected].text)), this.hideSelectDropDown(!0);
  }
  // List navigation - have to handle a disabled option (jump over)
  onDownArrow(e) {
    if (this.selected < this.options.length - 1) {
      Lt.stop(e, !0);
      const t = this.options[this.selected + 1].isDisabled;
      if (t && this.options.length > this.selected + 2)
        this.selected += 2;
      else {
        if (t)
          return;
        this.selected++;
      }
      this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]);
    }
  }
  onUpArrow(e) {
    this.selected > 0 && (Lt.stop(e, !0), this.options[this.selected - 1].isDisabled && this.selected > 1 ? this.selected -= 2 : this.selected--, this.select(this.selected), this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selectList.getFocus()[0]));
  }
  onPageUp(e) {
    Lt.stop(e), this.selectList.focusPreviousPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected < this.options.length - 1 && (this.selected++, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onPageDown(e) {
    Lt.stop(e), this.selectList.focusNextPage(), setTimeout(() => {
      this.selected = this.selectList.getFocus()[0], this.options[this.selected].isDisabled && this.selected > 0 && (this.selected--, this.selectList.setFocus([this.selected])), this.selectList.reveal(this.selected), this.select(this.selected);
    }, 1);
  }
  onHome(e) {
    Lt.stop(e), !(this.options.length < 2) && (this.selected = 0, this.options[this.selected].isDisabled && this.selected > 1 && this.selected++, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  onEnd(e) {
    Lt.stop(e), !(this.options.length < 2) && (this.selected = this.options.length - 1, this.options[this.selected].isDisabled && this.selected > 1 && this.selected--, this.selectList.setFocus([this.selected]), this.selectList.reveal(this.selected), this.select(this.selected));
  }
  // Mimic option first character navigation of native select
  onCharacter(e) {
    const t = sd.toString(e.keyCode);
    let n = -1;
    for (let i = 0; i < this.options.length - 1; i++)
      if (n = (i + this.selected + 1) % this.options.length, this.options[n].text.charAt(0).toUpperCase() === t && !this.options[n].isDisabled) {
        this.select(n), this.selectList.setFocus([n]), this.selectList.reveal(this.selectList.getFocus()[0]), Lt.stop(e);
        break;
      }
  }
  dispose() {
    this.hideSelectDropDown(!1), super.dispose();
  }
}
class R7t extends me {
  constructor(e, t, n, i) {
    super(), this.selected = 0, this.selectBoxOptions = i || /* @__PURE__ */ Object.create(null), this.options = [], this.selectElement = document.createElement("select"), this.selectElement.className = "monaco-select-box", typeof this.selectBoxOptions.ariaLabel == "string" && this.selectElement.setAttribute("aria-label", this.selectBoxOptions.ariaLabel), typeof this.selectBoxOptions.ariaDescription == "string" && this.selectElement.setAttribute("aria-description", this.selectBoxOptions.ariaDescription), this._onDidSelect = this._register(new $()), this.styles = n, this.registerListeners(), this.setOptions(e, t);
  }
  registerListeners() {
    this._register(Xn.addTarget(this.selectElement)), [Nn.Tap].forEach((e) => {
      this._register(fe(this.selectElement, e, (t) => {
        this.selectElement.focus();
      }));
    }), this._register(ir(this.selectElement, "click", (e) => {
      Lt.stop(e, !0);
    })), this._register(ir(this.selectElement, "change", (e) => {
      this.selectElement.title = e.target.value, this._onDidSelect.fire({
        index: e.target.selectedIndex,
        selected: e.target.value
      });
    })), this._register(ir(this.selectElement, "keydown", (e) => {
      let t = !1;
      zt ? (e.keyCode === 18 || e.keyCode === 16 || e.keyCode === 10) && (t = !0) : (e.keyCode === 18 && e.altKey || e.keyCode === 10 || e.keyCode === 3) && (t = !0), t && e.stopPropagation();
    }));
  }
  get onDidSelect() {
    return this._onDidSelect.event;
  }
  setOptions(e, t) {
    (!this.options || !Zi(this.options, e)) && (this.options = e, this.selectElement.options.length = 0, this.options.forEach((n, i) => {
      this.selectElement.add(this.createOption(n.text, i, n.isDisabled));
    })), t !== void 0 && this.select(t);
  }
  select(e) {
    this.options.length === 0 ? this.selected = 0 : e >= 0 && e < this.options.length ? this.selected = e : e > this.options.length - 1 ? this.select(this.options.length - 1) : this.selected < 0 && (this.selected = 0), this.selectElement.selectedIndex = this.selected, this.selected < this.options.length && typeof this.options[this.selected].text == "string" ? this.selectElement.title = this.options[this.selected].text : this.selectElement.title = "";
  }
  focus() {
    this.selectElement && (this.selectElement.tabIndex = 0, this.selectElement.focus());
  }
  blur() {
    this.selectElement && (this.selectElement.tabIndex = -1, this.selectElement.blur());
  }
  setFocusable(e) {
    this.selectElement.tabIndex = e ? 0 : -1;
  }
  render(e) {
    e.classList.add("select-container"), e.appendChild(this.selectElement), this.setOptions(this.options, this.selected), this.applyStyles();
  }
  applyStyles() {
    this.selectElement && (this.selectElement.style.backgroundColor = this.styles.selectBackground ?? "", this.selectElement.style.color = this.styles.selectForeground ?? "", this.selectElement.style.borderColor = this.styles.selectBorder ?? "");
  }
  createOption(e, t, n) {
    const i = document.createElement("option");
    return i.value = e, i.text = e, i.disabled = !!n, i;
  }
}
class V7t extends xa {
  constructor(e, t, n, i, s) {
    super(), zt && !s?.useCustomDrawn ? this.selectBoxDelegate = new R7t(e, t, i, s) : this.selectBoxDelegate = new _0(e, t, n, i, s), this._register(this.selectBoxDelegate);
  }
  // Public SelectBox Methods - routed through delegate interface
  get onDidSelect() {
    return this.selectBoxDelegate.onDidSelect;
  }
  setOptions(e, t) {
    this.selectBoxDelegate.setOptions(e, t);
  }
  select(e) {
    this.selectBoxDelegate.select(e);
  }
  focus() {
    this.selectBoxDelegate.focus();
  }
  blur() {
    this.selectBoxDelegate.blur();
  }
  setFocusable(e) {
    this.selectBoxDelegate.setFocusable(e);
  }
  render(e) {
    this.selectBoxDelegate.render(e);
  }
}
class Hl extends me {
  get action() {
    return this._action;
  }
  constructor(e, t, n = {}) {
    super(), this.options = n, this._context = e || this, this._action = t, t instanceof Ed && this._register(t.onDidChange((i) => {
      this.element && this.handleActionChangeEvent(i);
    }));
  }
  handleActionChangeEvent(e) {
    e.enabled !== void 0 && this.updateEnabled(), e.checked !== void 0 && this.updateChecked(), e.class !== void 0 && this.updateClass(), e.label !== void 0 && (this.updateLabel(), this.updateTooltip()), e.tooltip !== void 0 && this.updateTooltip();
  }
  get actionRunner() {
    return this._actionRunner || (this._actionRunner = this._register(new wf())), this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e;
  }
  isEnabled() {
    return this._action.enabled;
  }
  setActionContext(e) {
    this._context = e;
  }
  render(e) {
    const t = this.element = e;
    this._register(Xn.addTarget(e));
    const n = this.options && this.options.draggable;
    n && (e.draggable = !0, pl && this._register(fe(e, Se.DRAG_START, (i) => i.dataTransfer?.setData(ENe.TEXT, this._action.label)))), this._register(fe(t, Nn.Tap, (i) => this.onClick(i, !0))), this._register(fe(t, Se.MOUSE_DOWN, (i) => {
      n || Lt.stop(i, !0), this._action.enabled && i.button === 0 && t.classList.add("active");
    })), zt && this._register(fe(t, Se.CONTEXT_MENU, (i) => {
      i.button === 0 && i.ctrlKey === !0 && this.onClick(i);
    })), this._register(fe(t, Se.CLICK, (i) => {
      Lt.stop(i, !0), this.options && this.options.isMenu || this.onClick(i);
    })), this._register(fe(t, Se.DBLCLICK, (i) => {
      Lt.stop(i, !0);
    })), [Se.MOUSE_UP, Se.MOUSE_OUT].forEach((i) => {
      this._register(fe(t, i, (s) => {
        Lt.stop(s), t.classList.remove("active");
      }));
    });
  }
  onClick(e, t = !1) {
    Lt.stop(e, !0);
    const n = Mo(this._context) ? this.options?.useEventAsContext ? e : { preserveFocus: t } : this._context;
    this.actionRunner.run(this._action, n);
  }
  // Only set the tabIndex on the element once it is about to get focused
  // That way this element wont be a tab stop when it is not needed #106441
  focus() {
    this.element && (this.element.tabIndex = 0, this.element.focus(), this.element.classList.add("focused"));
  }
  blur() {
    this.element && (this.element.blur(), this.element.tabIndex = -1, this.element.classList.remove("focused"));
  }
  setFocusable(e) {
    this.element && (this.element.tabIndex = e ? 0 : -1);
  }
  get trapsArrowNavigation() {
    return !1;
  }
  updateEnabled() {
  }
  updateLabel() {
  }
  getClass() {
    return this.action.class;
  }
  getTooltip() {
    return this.action.tooltip;
  }
  updateTooltip() {
    if (!this.element)
      return;
    const e = this.getTooltip() ?? "";
    if (this.updateAriaLabel(), this.options.hoverDelegate?.showNativeHover)
      this.element.title = e;
    else if (!this.customHover && e !== "") {
      const t = this.options.hoverDelegate ?? fo("element");
      this.customHover = this._store.add(Mh().setupManagedHover(t, this.element, e));
    } else this.customHover && this.customHover.update(e);
  }
  updateAriaLabel() {
    if (this.element) {
      const e = this.getTooltip() ?? "";
      this.element.setAttribute("aria-label", e);
    }
  }
  updateClass() {
  }
  updateChecked() {
  }
  dispose() {
    this.element && (this.element.remove(), this.element = void 0), this._context = void 0, super.dispose();
  }
}
class yR extends Hl {
  constructor(e, t, n) {
    super(e, t, n), this.options = n, this.options.icon = n.icon !== void 0 ? n.icon : !1, this.options.label = n.label !== void 0 ? n.label : !0, this.cssClass = "";
  }
  render(e) {
    super.render(e), Qu(this.element);
    const t = document.createElement("a");
    if (t.classList.add("action-label"), t.setAttribute("role", this.getDefaultAriaRole()), this.label = t, this.element.appendChild(t), this.options.label && this.options.keybinding) {
      const n = document.createElement("span");
      n.classList.add("keybinding"), n.textContent = this.options.keybinding, this.element.appendChild(n);
    }
    this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked();
  }
  getDefaultAriaRole() {
    return this._action.id === Pr.ID ? "presentation" : this.options.isMenu ? "menuitem" : this.options.isTabList ? "tab" : "button";
  }
  // Only set the tabIndex on the element once it is about to get focused
  // That way this element wont be a tab stop when it is not needed #106441
  focus() {
    this.label && (this.label.tabIndex = 0, this.label.focus());
  }
  blur() {
    this.label && (this.label.tabIndex = -1);
  }
  setFocusable(e) {
    this.label && (this.label.tabIndex = e ? 0 : -1);
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this.action.label);
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : !this.options.label && this.action.label && this.options.icon && (e = this.action.label, this.options.keybinding && (e = C({ key: "titleLabel", comment: ["action title", "action keybinding"] }, "{0} ({1})", e, this.options.keybinding))), e ?? void 0;
  }
  updateClass() {
    this.cssClass && this.label && this.label.classList.remove(...this.cssClass.split(" ")), this.options.icon ? (this.cssClass = this.getClass(), this.label && (this.label.classList.add("codicon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" "))), this.updateEnabled()) : this.label?.classList.remove("codicon");
  }
  updateEnabled() {
    this.action.enabled ? (this.label && (this.label.removeAttribute("aria-disabled"), this.label.classList.remove("disabled")), this.element?.classList.remove("disabled")) : (this.label && (this.label.setAttribute("aria-disabled", "true"), this.label.classList.add("disabled")), this.element?.classList.add("disabled"));
  }
  updateAriaLabel() {
    if (this.label) {
      const e = this.getTooltip() ?? "";
      this.label.setAttribute("aria-label", e);
    }
  }
  updateChecked() {
    this.label && (this.action.checked !== void 0 ? (this.label.classList.toggle("checked", this.action.checked), this.options.isTabList ? this.label.setAttribute("aria-selected", this.action.checked ? "true" : "false") : (this.label.setAttribute("aria-checked", this.action.checked ? "true" : "false"), this.label.setAttribute("role", "checkbox"))) : (this.label.classList.remove("checked"), this.label.removeAttribute(this.options.isTabList ? "aria-selected" : "aria-checked"), this.label.setAttribute("role", this.getDefaultAriaRole())));
  }
}
class H7t extends Hl {
  constructor(e, t, n, i, s, o, a) {
    super(e, t), this.selectBox = new V7t(n, i, s, o, a), this.selectBox.setFocusable(!1), this._register(this.selectBox), this.registerListeners();
  }
  select(e) {
    this.selectBox.select(e);
  }
  registerListeners() {
    this._register(this.selectBox.onDidSelect((e) => this.runAction(e.selected, e.index)));
  }
  runAction(e, t) {
    this.actionRunner.run(this._action, this.getActionContext(e, t));
  }
  getActionContext(e, t) {
    return e;
  }
  setFocusable(e) {
    this.selectBox.setFocusable(e);
  }
  focus() {
    this.selectBox?.focus();
  }
  blur() {
    this.selectBox?.blur();
  }
  render(e) {
    this.selectBox.render(e);
  }
}
class B7t extends wf {
  constructor(e, t) {
    super(), this._onDidChangeVisibility = this._register(new $()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this._element = Fe(e, $e(".monaco-dropdown")), this._label = Fe(this._element, $e(".dropdown-label"));
    let n = t.labelRenderer;
    n || (n = (s) => (s.textContent = t.label || "", null));
    for (const s of [Se.CLICK, Se.MOUSE_DOWN, Nn.Tap])
      this._register(fe(this.element, s, (o) => Lt.stop(o, !0)));
    for (const s of [Se.MOUSE_DOWN, Nn.Tap])
      this._register(fe(this._label, s, (o) => {
        QI(o) && (o.detail > 1 || o.button !== 0) || (this.visible ? this.hide() : this.show());
      }));
    this._register(fe(this._label, Se.KEY_UP, (s) => {
      const o = new zn(s);
      (o.equals(
        3
        /* KeyCode.Enter */
      ) || o.equals(
        10
        /* KeyCode.Space */
      )) && (Lt.stop(s, !0), this.visible ? this.hide() : this.show());
    }));
    const i = n(this._label);
    i && this._register(i), this._register(Xn.addTarget(this._label));
  }
  get element() {
    return this._element;
  }
  show() {
    this.visible || (this.visible = !0, this._onDidChangeVisibility.fire(!0));
  }
  hide() {
    this.visible && (this.visible = !1, this._onDidChangeVisibility.fire(!1));
  }
  dispose() {
    super.dispose(), this.hide(), this.boxContainer && (this.boxContainer.remove(), this.boxContainer = void 0), this.contents && (this.contents.remove(), this.contents = void 0), this._label && (this._label.remove(), this._label = void 0);
  }
}
class P7t extends B7t {
  constructor(e, t) {
    super(e, t), this._options = t, this._actions = [], this.actions = t.actions || [];
  }
  set menuOptions(e) {
    this._menuOptions = e;
  }
  get menuOptions() {
    return this._menuOptions;
  }
  get actions() {
    return this._options.actionProvider ? this._options.actionProvider.getActions() : this._actions;
  }
  set actions(e) {
    this._actions = e;
  }
  show() {
    super.show(), this.element.classList.add("active"), this._options.contextMenuProvider.showContextMenu({
      getAnchor: () => this.element,
      getActions: () => this.actions,
      getActionsContext: () => this.menuOptions ? this.menuOptions.context : null,
      getActionViewItem: (e, t) => this.menuOptions && this.menuOptions.actionViewItemProvider ? this.menuOptions.actionViewItemProvider(e, t) : void 0,
      getKeyBinding: (e) => this.menuOptions && this.menuOptions.getKeyBinding ? this.menuOptions.getKeyBinding(e) : void 0,
      getMenuClassName: () => this._options.menuClassName || "",
      onHide: () => this.onHide(),
      actionRunner: this.menuOptions ? this.menuOptions.actionRunner : void 0,
      anchorAlignment: this.menuOptions ? this.menuOptions.anchorAlignment : 0,
      domForShadowRoot: this._options.menuAsChild ? this.element : void 0,
      skipTelemetry: this._options.skipTelemetry
    });
  }
  hide() {
    super.hide();
  }
  onHide() {
    this.hide(), this.element.classList.remove("active");
  }
}
class H9 extends Hl {
  constructor(e, t, n, i = /* @__PURE__ */ Object.create(null)) {
    super(null, e, i), this.actionItem = null, this._onDidChangeVisibility = this._register(new $()), this.onDidChangeVisibility = this._onDidChangeVisibility.event, this.menuActionsOrProvider = t, this.contextMenuProvider = n, this.options = i, this.options.actionRunner && (this.actionRunner = this.options.actionRunner);
  }
  render(e) {
    this.actionItem = e;
    const t = (s) => {
      this.element = Fe(s, $e("a.action-label"));
      let o = [];
      return typeof this.options.classNames == "string" ? o = this.options.classNames.split(/\s+/g).filter((a) => !!a) : this.options.classNames && (o = this.options.classNames), o.find((a) => a === "icon") || o.push("codicon"), this.element.classList.add(...o), this.element.setAttribute("role", "button"), this.element.setAttribute("aria-haspopup", "true"), this.element.setAttribute("aria-expanded", "false"), this._action.label && this._register(Mh().setupManagedHover(this.options.hoverDelegate ?? fo("mouse"), this.element, this._action.label)), this.element.ariaLabel = this._action.label || "", null;
    }, n = Array.isArray(this.menuActionsOrProvider), i = {
      contextMenuProvider: this.contextMenuProvider,
      labelRenderer: t,
      menuAsChild: this.options.menuAsChild,
      actions: n ? this.menuActionsOrProvider : void 0,
      actionProvider: n ? void 0 : this.menuActionsOrProvider,
      skipTelemetry: this.options.skipTelemetry
    };
    if (this.dropdownMenu = this._register(new P7t(e, i)), this._register(this.dropdownMenu.onDidChangeVisibility((s) => {
      this.element?.setAttribute("aria-expanded", `${s}`), this._onDidChangeVisibility.fire(s);
    })), this.dropdownMenu.menuOptions = {
      actionViewItemProvider: this.options.actionViewItemProvider,
      actionRunner: this.actionRunner,
      getKeyBinding: this.options.keybindingProvider,
      context: this._context
    }, this.options.anchorAlignmentProvider) {
      const s = this;
      this.dropdownMenu.menuOptions = {
        ...this.dropdownMenu.menuOptions,
        get anchorAlignment() {
          return s.options.anchorAlignmentProvider();
        }
      };
    }
    this.updateTooltip(), this.updateEnabled();
  }
  getTooltip() {
    let e = null;
    return this.action.tooltip ? e = this.action.tooltip : this.action.label && (e = this.action.label), e ?? void 0;
  }
  setActionContext(e) {
    super.setActionContext(e), this.dropdownMenu && (this.dropdownMenu.menuOptions ? this.dropdownMenu.menuOptions.context = e : this.dropdownMenu.menuOptions = { context: e });
  }
  show() {
    this.dropdownMenu?.show();
  }
  updateEnabled() {
    const e = !this.action.enabled;
    this.actionItem?.classList.toggle("disabled", e), this.element?.classList.toggle("disabled", e);
  }
}
function F7t(r) {
  return r ? r.condition !== void 0 : !1;
}
var Ip;
(function(r) {
  r[r.STORAGE_DOES_NOT_EXIST = 0] = "STORAGE_DOES_NOT_EXIST", r[r.STORAGE_IN_MEMORY = 1] = "STORAGE_IN_MEMORY";
})(Ip || (Ip = {}));
var cp;
(function(r) {
  r[r.None = 0] = "None", r[r.Initialized = 1] = "Initialized", r[r.Closed = 2] = "Closed";
})(cp || (cp = {}));
class o3 extends me {
  static {
    this.DEFAULT_FLUSH_DELAY = 100;
  }
  constructor(e, t = /* @__PURE__ */ Object.create(null)) {
    super(), this.database = e, this.options = t, this._onDidChangeStorage = this._register(new R3()), this.onDidChangeStorage = this._onDidChangeStorage.event, this.state = cp.None, this.cache = /* @__PURE__ */ new Map(), this.flushDelayer = this._register(new uDe(o3.DEFAULT_FLUSH_DELAY)), this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.whenFlushedCallbacks = [], this.registerListeners();
  }
  registerListeners() {
    this._register(this.database.onDidChangeItemsExternal((e) => this.onDidChangeItemsExternal(e)));
  }
  onDidChangeItemsExternal(e) {
    this._onDidChangeStorage.pause();
    try {
      e.changed?.forEach((t, n) => this.acceptExternal(n, t)), e.deleted?.forEach((t) => this.acceptExternal(t, void 0));
    } finally {
      this._onDidChangeStorage.resume();
    }
  }
  acceptExternal(e, t) {
    if (this.state === cp.Closed)
      return;
    let n = !1;
    Mo(t) ? n = this.cache.delete(e) : this.cache.get(e) !== t && (this.cache.set(e, t), n = !0), n && this._onDidChangeStorage.fire({ key: e, external: !0 });
  }
  get(e, t) {
    const n = this.cache.get(e);
    return Mo(n) ? t : n;
  }
  getBoolean(e, t) {
    const n = this.get(e);
    return Mo(n) ? t : n === "true";
  }
  getNumber(e, t) {
    const n = this.get(e);
    return Mo(n) ? t : parseInt(n, 10);
  }
  async set(e, t, n = !1) {
    if (this.state === cp.Closed)
      return;
    if (Mo(t))
      return this.delete(e, n);
    const i = Rs(t) || Array.isArray(t) ? v9t(t) : String(t);
    if (this.cache.get(e) !== i)
      return this.cache.set(e, i), this.pendingInserts.set(e, i), this.pendingDeletes.delete(e), this._onDidChangeStorage.fire({ key: e, external: n }), this.doFlush();
  }
  async delete(e, t = !1) {
    if (!(this.state === cp.Closed || !this.cache.delete(e)))
      return this.pendingDeletes.has(e) || this.pendingDeletes.add(e), this.pendingInserts.delete(e), this._onDidChangeStorage.fire({ key: e, external: t }), this.doFlush();
  }
  get hasPending() {
    return this.pendingInserts.size > 0 || this.pendingDeletes.size > 0;
  }
  async flushPending() {
    if (!this.hasPending)
      return;
    const e = { insert: this.pendingInserts, delete: this.pendingDeletes };
    return this.pendingDeletes = /* @__PURE__ */ new Set(), this.pendingInserts = /* @__PURE__ */ new Map(), this.database.updateItems(e).finally(() => {
      if (!this.hasPending)
        for (; this.whenFlushedCallbacks.length; )
          this.whenFlushedCallbacks.pop()?.();
    });
  }
  async doFlush(e) {
    return this.options.hint === Ip.STORAGE_IN_MEMORY ? this.flushPending() : this.flushDelayer.trigger(() => this.flushPending(), e);
  }
}
class b_ {
  constructor() {
    this.onDidChangeItemsExternal = xe.None, this.items = /* @__PURE__ */ new Map();
  }
  async updateItems(e) {
    e.insert?.forEach((t, n) => this.items.set(n, t)), e.delete?.forEach((t) => this.items.delete(t));
  }
}
const k6 = "__$__targetStorageMarker", am = Wt("storageService");
var l9e;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.SHUTDOWN = 1] = "SHUTDOWN";
})(l9e || (l9e = {}));
function z7t(r) {
  const e = r.get(k6);
  if (e)
    try {
      return JSON.parse(e);
    } catch {
    }
  return /* @__PURE__ */ Object.create(null);
}
class CR extends me {
  static {
    this.DEFAULT_FLUSH_INTERVAL = 60 * 1e3;
  }
  // every minute
  constructor(e = { flushInterval: CR.DEFAULT_FLUSH_INTERVAL }) {
    super(), this.options = e, this._onDidChangeValue = this._register(new R3()), this._onDidChangeTarget = this._register(new R3()), this._onWillSaveState = this._register(new $()), this.onWillSaveState = this._onWillSaveState.event, this._workspaceKeyTargets = void 0, this._profileKeyTargets = void 0, this._applicationKeyTargets = void 0;
  }
  onDidChangeValue(e, t, n) {
    return xe.filter(this._onDidChangeValue.event, (i) => i.scope === e && (t === void 0 || i.key === t), n);
  }
  emitDidChangeValue(e, t) {
    const { key: n, external: i } = t;
    if (n === k6) {
      switch (e) {
        case -1:
          this._applicationKeyTargets = void 0;
          break;
        case 0:
          this._profileKeyTargets = void 0;
          break;
        case 1:
          this._workspaceKeyTargets = void 0;
          break;
      }
      this._onDidChangeTarget.fire({ scope: e });
    } else
      this._onDidChangeValue.fire({ scope: e, key: n, target: this.getKeyTargets(e)[n], external: i });
  }
  get(e, t, n) {
    return this.getStorage(t)?.get(e, n);
  }
  getBoolean(e, t, n) {
    return this.getStorage(t)?.getBoolean(e, n);
  }
  getNumber(e, t, n) {
    return this.getStorage(t)?.getNumber(e, n);
  }
  store(e, t, n, i, s = !1) {
    if (Mo(t)) {
      this.remove(e, n, s);
      return;
    }
    this.withPausedEmitters(() => {
      this.updateKeyTarget(e, n, i), this.getStorage(n)?.set(e, t, s);
    });
  }
  remove(e, t, n = !1) {
    this.withPausedEmitters(() => {
      this.updateKeyTarget(e, t, void 0), this.getStorage(t)?.delete(e, n);
    });
  }
  withPausedEmitters(e) {
    this._onDidChangeValue.pause(), this._onDidChangeTarget.pause();
    try {
      e();
    } finally {
      this._onDidChangeValue.resume(), this._onDidChangeTarget.resume();
    }
  }
  updateKeyTarget(e, t, n, i = !1) {
    const s = this.getKeyTargets(t);
    typeof n == "number" ? s[e] !== n && (s[e] = n, this.getStorage(t)?.set(k6, JSON.stringify(s), i)) : typeof s[e] == "number" && (delete s[e], this.getStorage(t)?.set(k6, JSON.stringify(s), i));
  }
  get workspaceKeyTargets() {
    return this._workspaceKeyTargets || (this._workspaceKeyTargets = this.loadKeyTargets(
      1
      /* StorageScope.WORKSPACE */
    )), this._workspaceKeyTargets;
  }
  get profileKeyTargets() {
    return this._profileKeyTargets || (this._profileKeyTargets = this.loadKeyTargets(
      0
      /* StorageScope.PROFILE */
    )), this._profileKeyTargets;
  }
  get applicationKeyTargets() {
    return this._applicationKeyTargets || (this._applicationKeyTargets = this.loadKeyTargets(
      -1
      /* StorageScope.APPLICATION */
    )), this._applicationKeyTargets;
  }
  getKeyTargets(e) {
    switch (e) {
      case -1:
        return this.applicationKeyTargets;
      case 0:
        return this.profileKeyTargets;
      default:
        return this.workspaceKeyTargets;
    }
  }
  loadKeyTargets(e) {
    const t = this.getStorage(e);
    return t ? z7t(t) : /* @__PURE__ */ Object.create(null);
  }
}
class W7t extends CR {
  constructor() {
    super(), this.applicationStorage = this._register(new o3(new b_(), { hint: Ip.STORAGE_IN_MEMORY })), this.profileStorage = this._register(new o3(new b_(), { hint: Ip.STORAGE_IN_MEMORY })), this.workspaceStorage = this._register(new o3(new b_(), { hint: Ip.STORAGE_IN_MEMORY })), this._register(this.workspaceStorage.onDidChangeStorage((e) => this.emitDidChangeValue(1, e))), this._register(this.profileStorage.onDidChangeStorage((e) => this.emitDidChangeValue(0, e))), this._register(this.applicationStorage.onDidChangeStorage((e) => this.emitDidChangeValue(-1, e)));
  }
  getStorage(e) {
    switch (e) {
      case -1:
        return this.applicationStorage;
      case 0:
        return this.profileStorage;
      default:
        return this.workspaceStorage;
    }
  }
}
function j7t(r, e) {
  const t = { ...e };
  for (const n in r) {
    const i = r[n];
    t[n] = i !== void 0 ? _e(i) : void 0;
  }
  return t;
}
const Z7t = {
  keybindingLabelBackground: _e(NAt),
  keybindingLabelForeground: _e(TAt),
  keybindingLabelBorder: _e(IAt),
  keybindingLabelBottomBorder: _e(OAt),
  keybindingLabelShadow: _e(Mw)
}, U7t = {
  buttonForeground: _e(BLe),
  buttonSeparator: _e(AAt),
  buttonBackground: _e(pA),
  buttonHoverBackground: _e(wAt),
  buttonSecondaryForeground: _e(bAt),
  buttonSecondaryBackground: _e(fL),
  buttonSecondaryHoverBackground: _e(yAt),
  buttonBorder: _e(vAt)
}, q7t = {
  progressBarBackground: _e(Tmt)
}, B9 = {
  inputActiveOptionBorder: _e(sy),
  inputActiveOptionForeground: _e(ay),
  inputActiveOptionBackground: _e(oy)
};
_e(gA), _e(CAt), _e(EAt), _e(_At), _e(xAt), _e(SAt), _e(MAt);
_e(DAt), _e(kAt), _e(LAt);
_e(Zl), _e(vO), _e(Mw), _e($t), _e(Kmt), _e(Ymt), _e(Xmt), _e(kmt);
const P9 = {
  inputBackground: _e(iAt),
  inputForeground: _e(rAt),
  inputBorder: _e(sAt),
  inputValidationInfoBorder: _e(cAt),
  inputValidationInfoBackground: _e(aAt),
  inputValidationInfoForeground: _e(lAt),
  inputValidationWarningBorder: _e(uAt),
  inputValidationWarningBackground: _e(hAt),
  inputValidationWarningForeground: _e(dAt),
  inputValidationErrorBorder: _e(gAt),
  inputValidationErrorBackground: _e(fAt),
  inputValidationErrorForeground: _e(pAt)
}, G7t = {
  listFilterWidgetBackground: _e(qAt),
  listFilterWidgetOutline: _e(GAt),
  listFilterWidgetNoMatchesOutline: _e(QAt),
  listFilterWidgetShadow: _e(KAt),
  inputBoxStyles: P9,
  toggleStyles: B9
}, Q7t = {
  badgeBackground: _e(C6),
  badgeForeground: _e(Nmt),
  badgeBorder: _e($t)
};
_e(Gmt), _e(qmt), _e(i6e), _e(i6e), _e(Qmt);
const lm = {
  listBackground: void 0,
  listInactiveFocusForeground: void 0,
  listFocusBackground: _e(RAt),
  listFocusForeground: _e(VAt),
  listFocusOutline: _e(HAt),
  listActiveSelectionBackground: _e(fg),
  listActiveSelectionForeground: _e(r9),
  listActiveSelectionIconForeground: _e(PLe),
  listFocusAndSelectionOutline: _e(BAt),
  listFocusAndSelectionBackground: _e(fg),
  listFocusAndSelectionForeground: _e(r9),
  listInactiveSelectionBackground: _e(PAt),
  listInactiveSelectionIconForeground: _e(zAt),
  listInactiveSelectionForeground: _e(FAt),
  listInactiveFocusBackground: _e(WAt),
  listInactiveFocusOutline: _e(jAt),
  listHoverBackground: _e(FLe),
  listHoverForeground: _e(zLe),
  listDropOverBackground: _e(ZAt),
  listDropBetweenBackground: _e(UAt),
  listSelectionOutline: _e(_i),
  listHoverOutline: _e(_i),
  treeIndentGuidesStroke: _e(WLe),
  treeInactiveIndentGuidesStroke: _e(YAt),
  treeStickyScrollBackground: void 0,
  treeStickyScrollBorder: void 0,
  treeStickyScrollShadow: _e(wO),
  tableColumnsBorder: _e(XAt),
  tableOddRowsBackgroundColor: _e(JAt)
};
function Vw(r) {
  return j7t(r, lm);
}
const K7t = {
  selectBackground: _e(ly),
  selectListBackground: _e(mAt),
  selectForeground: _e(CO),
  decoratorRightForeground: _e(jLe),
  selectBorder: _e(EO),
  focusBorder: _e(hh),
  listFocusBackground: _e(gL),
  listInactiveSelectionIconForeground: _e(ZLe),
  listFocusForeground: _e(pL),
  listFocusOutline: _mt(_i, ge.transparent.toString()),
  listHoverBackground: _e(FLe),
  listHoverForeground: _e(zLe),
  listHoverOutline: _e(_i),
  selectListBorder: _e(TLe),
  listBackground: void 0,
  listActiveSelectionBackground: void 0,
  listActiveSelectionForeground: void 0,
  listActiveSelectionIconForeground: void 0,
  listFocusAndSelectionBackground: void 0,
  listDropOverBackground: void 0,
  listDropBetweenBackground: void 0,
  listInactiveSelectionBackground: void 0,
  listInactiveSelectionForeground: void 0,
  listInactiveFocusBackground: void 0,
  listInactiveFocusOutline: void 0,
  listSelectionOutline: void 0,
  listFocusAndSelectionForeground: void 0,
  listFocusAndSelectionOutline: void 0,
  listInactiveFocusForeground: void 0,
  tableColumnsBorder: void 0,
  tableOddRowsBackgroundColor: void 0,
  treeIndentGuidesStroke: void 0,
  treeInactiveIndentGuidesStroke: void 0,
  treeStickyScrollBackground: void 0,
  treeStickyScrollBorder: void 0,
  treeStickyScrollShadow: void 0
}, Y7t = {
  shadowColor: _e(Mw),
  borderColor: _e($At),
  foregroundColor: _e(e3t),
  backgroundColor: _e(t3t),
  selectionForegroundColor: _e(n3t),
  selectionBackgroundColor: _e(i3t),
  selectionBorderColor: _e(r3t),
  separatorColor: _e(s3t),
  scrollbarShadow: _e(wO),
  scrollbarSliderBackground: _e(LLe),
  scrollbarSliderHoverBackground: _e(kLe),
  scrollbarSliderActiveBackground: _e(NLe)
};
var ky = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Os = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
function X7t(r, e, t, n) {
  let i, s, o;
  if (Array.isArray(r))
    o = r, i = e, s = t;
  else {
    const c = e;
    o = r.getActions(c), i = t, s = n;
  }
  const a = Iu.getInstance(), l = a.keyStatus.altKey || (zs || Cs) && a.keyStatus.shiftKey;
  BNe(o, i, l, s ? (c) => c === s : (c) => c === "navigation");
}
function J7t(r, e, t, n, i, s) {
  let o, a, l, c, d;
  if (Array.isArray(r))
    d = r, o = e, a = t, l = n, c = i;
  else {
    const f = e;
    d = r.getActions(f), o = t, a = n, l = i, c = s;
  }
  BNe(d, o, !1, typeof a == "string" ? (f) => f === a : a, l, c);
}
function BNe(r, e, t, n = (o) => o === "navigation", i = () => !1, s = !1) {
  let o, a;
  Array.isArray(e) ? (o = e, a = e) : (o = e.primary, a = e.secondary);
  const l = /* @__PURE__ */ new Set();
  for (const [c, d] of r) {
    let u;
    n(c) ? (u = o, u.length > 0 && s && u.push(new Pr())) : (u = a, u.length > 0 && u.push(new Pr()));
    for (let f of d) {
      t && (f = f instanceof _d && f.alt ? f.alt : f);
      const p = u.push(f);
      f instanceof W7 && l.add({ group: c, action: f, index: p - 1 });
    }
  }
  for (const { group: c, action: d, index: u } of l) {
    const f = n(c) ? o : a, p = d.actions;
    i(d, c, f.length) && f.splice(u, 1, ...p);
  }
}
let c4 = class extends yR {
  constructor(e, t, n, i, s, o, a, l) {
    super(void 0, e, { icon: !!(e.class || e.item.icon), label: !e.class && !e.item.icon, draggable: t?.draggable, keybinding: t?.keybinding, hoverDelegate: t?.hoverDelegate }), this._options = t, this._keybindingService = n, this._notificationService = i, this._contextKeyService = s, this._themeService = o, this._contextMenuService = a, this._accessibilityService = l, this._wantsAltCommand = !1, this._itemClassDispose = this._register(new Bd()), this._altKey = Iu.getInstance();
  }
  get _menuItemAction() {
    return this._action;
  }
  get _commandAction() {
    return this._wantsAltCommand && this._menuItemAction.alt || this._menuItemAction;
  }
  async onClick(e) {
    e.preventDefault(), e.stopPropagation();
    try {
      await this.actionRunner.run(this._commandAction, this._context);
    } catch (t) {
      this._notificationService.error(t);
    }
  }
  render(e) {
    if (super.render(e), e.classList.add("menu-entry"), this.options.icon && this._updateItemClass(this._menuItemAction.item), this._menuItemAction.alt) {
      let t = !1;
      const n = () => {
        const i = !!this._menuItemAction.alt?.enabled && (!this._accessibilityService.isMotionReduced() || t) && (this._altKey.keyStatus.altKey || this._altKey.keyStatus.shiftKey && t);
        i !== this._wantsAltCommand && (this._wantsAltCommand = i, this.updateLabel(), this.updateTooltip(), this.updateClass());
      };
      this._register(this._altKey.event(n)), this._register(fe(e, "mouseleave", (i) => {
        t = !1, n();
      })), this._register(fe(e, "mouseenter", (i) => {
        t = !0, n();
      })), n();
    }
  }
  updateLabel() {
    this.options.label && this.label && (this.label.textContent = this._commandAction.label);
  }
  getTooltip() {
    const e = this._keybindingService.lookupKeybinding(this._commandAction.id, this._contextKeyService), t = e && e.getLabel(), n = this._commandAction.tooltip || this._commandAction.label;
    let i = t ? C("titleAndKb", "{0} ({1})", n, t) : n;
    if (!this._wantsAltCommand && this._menuItemAction.alt?.enabled) {
      const s = this._menuItemAction.alt.tooltip || this._menuItemAction.alt.label, o = this._keybindingService.lookupKeybinding(this._menuItemAction.alt.id, this._contextKeyService), a = o && o.getLabel(), l = a ? C("titleAndKb", "{0} ({1})", s, a) : s;
      i = C("titleAndKbAndAlt", `{0}
[{1}] {2}`, i, fR.modifierLabels[nl].altKey, l);
    }
    return i;
  }
  updateClass() {
    this.options.icon && (this._commandAction !== this._menuItemAction ? this._menuItemAction.alt && this._updateItemClass(this._menuItemAction.alt.item) : this._updateItemClass(this._menuItemAction.item));
  }
  _updateItemClass(e) {
    this._itemClassDispose.value = void 0;
    const { element: t, label: n } = this;
    if (!t || !n)
      return;
    const i = this._commandAction.checked && F7t(e.toggled) && e.toggled.icon ? e.toggled.icon : e.icon;
    if (i)
      if (Tt.isThemeIcon(i)) {
        const s = Tt.asClassNameArray(i);
        n.classList.add(...s), this._itemClassDispose.value = ht(() => {
          n.classList.remove(...s);
        });
      } else
        n.style.backgroundImage = dy(this._themeService.getColorTheme().type) ? Pd(i.dark) : Pd(i.light), n.classList.add("icon"), this._itemClassDispose.value = ih(ht(() => {
          n.style.backgroundImage = "", n.classList.remove("icon");
        }), this._themeService.onDidColorThemeChange(() => {
          this.updateClass();
        }));
  }
};
c4 = ky([
  Os(2, _r),
  Os(3, Zo),
  Os(4, sn),
  Os(5, Sa),
  Os(6, Qd),
  Os(7, pc)
], c4);
let lk = class extends H9 {
  constructor(e, t, n, i, s) {
    const o = {
      ...t,
      menuAsChild: t?.menuAsChild ?? !1,
      classNames: t?.classNames ?? (Tt.isThemeIcon(e.item.icon) ? Tt.asClassName(e.item.icon) : void 0),
      keybindingProvider: t?.keybindingProvider ?? ((a) => n.lookupKeybinding(a.id))
    };
    super(e, { getActions: () => e.actions }, i, o), this._keybindingService = n, this._contextMenuService = i, this._themeService = s;
  }
  render(e) {
    super.render(e), Qu(this.element), e.classList.add("menu-entry");
    const t = this._action, { icon: n } = t.item;
    if (n && !Tt.isThemeIcon(n)) {
      this.element.classList.add("icon");
      const i = () => {
        this.element && (this.element.style.backgroundImage = dy(this._themeService.getColorTheme().type) ? Pd(n.dark) : Pd(n.light));
      };
      i(), this._register(this._themeService.onDidColorThemeChange(() => {
        i();
      }));
    }
  }
};
lk = ky([
  Os(2, _r),
  Os(3, Qd),
  Os(4, Sa)
], lk);
let ck = class extends Hl {
  constructor(e, t, n, i, s, o, a, l) {
    super(null, e), this._keybindingService = n, this._notificationService = i, this._contextMenuService = s, this._menuService = o, this._instaService = a, this._storageService = l, this._container = null, this._options = t, this._storageKey = `${e.item.submenu.id}_lastActionId`;
    let c;
    const d = t?.persistLastActionId ? l.get(
      this._storageKey,
      1
      /* StorageScope.WORKSPACE */
    ) : void 0;
    d && (c = e.actions.find((f) => d === f.id)), c || (c = e.actions[0]), this._defaultAction = this._instaService.createInstance(c4, c, { keybinding: this._getDefaultActionKeybindingLabel(c) });
    const u = {
      keybindingProvider: (f) => this._keybindingService.lookupKeybinding(f.id),
      ...t,
      menuAsChild: t?.menuAsChild ?? !0,
      classNames: t?.classNames ?? ["codicon", "codicon-chevron-down"],
      actionRunner: t?.actionRunner ?? new wf()
    };
    this._dropdown = new H9(e, e.actions, this._contextMenuService, u), this._register(this._dropdown.actionRunner.onDidRun((f) => {
      f.action instanceof _d && this.update(f.action);
    }));
  }
  update(e) {
    this._options?.persistLastActionId && this._storageService.store(
      this._storageKey,
      e.id,
      1,
      1
      /* StorageTarget.MACHINE */
    ), this._defaultAction.dispose(), this._defaultAction = this._instaService.createInstance(c4, e, { keybinding: this._getDefaultActionKeybindingLabel(e) }), this._defaultAction.actionRunner = new class extends wf {
      async runAction(t, n) {
        await t.run(void 0);
      }
    }(), this._container && this._defaultAction.render(KI(this._container, $e(".action-container")));
  }
  _getDefaultActionKeybindingLabel(e) {
    let t;
    if (this._options?.renderKeybindingWithDefaultActionLabel) {
      const n = this._keybindingService.lookupKeybinding(e.id);
      n && (t = `(${n.getLabel()})`);
    }
    return t;
  }
  setActionContext(e) {
    super.setActionContext(e), this._defaultAction.setActionContext(e), this._dropdown.setActionContext(e);
  }
  render(e) {
    this._container = e, super.render(this._container), this._container.classList.add("monaco-dropdown-with-default");
    const t = $e(".action-container");
    this._defaultAction.render(Fe(this._container, t)), this._register(fe(t, Se.KEY_DOWN, (i) => {
      const s = new zn(i);
      s.equals(
        17
        /* KeyCode.RightArrow */
      ) && (this._defaultAction.element.tabIndex = -1, this._dropdown.focus(), s.stopPropagation());
    }));
    const n = $e(".dropdown-action-container");
    this._dropdown.render(Fe(this._container, n)), this._register(fe(n, Se.KEY_DOWN, (i) => {
      const s = new zn(i);
      s.equals(
        15
        /* KeyCode.LeftArrow */
      ) && (this._defaultAction.element.tabIndex = 0, this._dropdown.setFocusable(!1), this._defaultAction.element?.focus(), s.stopPropagation());
    }));
  }
  focus(e) {
    e ? this._dropdown.focus() : (this._defaultAction.element.tabIndex = 0, this._defaultAction.element.focus());
  }
  blur() {
    this._defaultAction.element.tabIndex = -1, this._dropdown.blur(), this._container.blur();
  }
  setFocusable(e) {
    e ? this._defaultAction.element.tabIndex = 0 : (this._defaultAction.element.tabIndex = -1, this._dropdown.setFocusable(!1));
  }
  dispose() {
    this._defaultAction.dispose(), this._dropdown.dispose(), super.dispose();
  }
};
ck = ky([
  Os(2, _r),
  Os(3, Zo),
  Os(4, Qd),
  Os(5, Yf),
  Os(6, xn),
  Os(7, am)
], ck);
let hk = class extends H7t {
  constructor(e, t) {
    super(null, e, e.actions.map((n) => ({
      text: n.id === Pr.ID ? "─────────" : n.label,
      isDisabled: !n.enabled
    })), 0, t, K7t, { ariaLabel: e.tooltip, optionsAsChildren: !0 }), this.select(Math.max(0, e.actions.findIndex((n) => n.checked)));
  }
  render(e) {
    super.render(e), e.style.borderColor = _e(EO);
  }
  runAction(e, t) {
    const n = this.action.actions[t];
    n && this.actionRunner.run(n);
  }
};
hk = ky([
  Os(1, rm)
], hk);
function $7t(r, e, t) {
  return e instanceof _d ? r.createInstance(c4, e, t) : e instanceof FA ? e.item.isSelection ? r.createInstance(hk, e) : e.item.rememberDefaultAction ? r.createInstance(ck, e, { ...t, persistLastActionId: !0 }) : r.createInstance(lk, e, t) : void 0;
}
class Md extends me {
  constructor(e, t = {}) {
    super(), this._actionRunnerDisposables = this._register(new ze()), this.viewItemDisposables = this._register(new MI()), this.triggerKeyDown = !1, this.focusable = !0, this._onDidBlur = this._register(new $()), this.onDidBlur = this._onDidBlur.event, this._onDidCancel = this._register(new $({ onWillAddFirstListener: () => this.cancelHasListener = !0 })), this.onDidCancel = this._onDidCancel.event, this.cancelHasListener = !1, this._onDidRun = this._register(new $()), this.onDidRun = this._onDidRun.event, this._onWillRun = this._register(new $()), this.onWillRun = this._onWillRun.event, this.options = t, this._context = t.context ?? null, this._orientation = this.options.orientation ?? 0, this._triggerKeys = {
      keyDown: this.options.triggerKeys?.keyDown ?? !1,
      keys: this.options.triggerKeys?.keys ?? [
        3,
        10
        /* KeyCode.Space */
      ]
    }, this._hoverDelegate = t.hoverDelegate ?? this._register(wg()), this.options.actionRunner ? this._actionRunner = this.options.actionRunner : (this._actionRunner = new wf(), this._actionRunnerDisposables.add(this._actionRunner)), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((s) => this._onDidRun.fire(s))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((s) => this._onWillRun.fire(s))), this.viewItems = [], this.focusedItem = void 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-action-bar";
    let n, i;
    switch (this._orientation) {
      case 0:
        n = [
          15
          /* KeyCode.LeftArrow */
        ], i = [
          17
          /* KeyCode.RightArrow */
        ];
        break;
      case 1:
        n = [
          16
          /* KeyCode.UpArrow */
        ], i = [
          18
          /* KeyCode.DownArrow */
        ], this.domNode.className += " vertical";
        break;
    }
    this._register(fe(this.domNode, Se.KEY_DOWN, (s) => {
      const o = new zn(s);
      let a = !0;
      const l = typeof this.focusedItem == "number" ? this.viewItems[this.focusedItem] : void 0;
      n && (o.equals(n[0]) || o.equals(n[1])) ? a = this.focusPrevious() : i && (o.equals(i[0]) || o.equals(i[1])) ? a = this.focusNext() : o.equals(
        9
        /* KeyCode.Escape */
      ) && this.cancelHasListener ? this._onDidCancel.fire() : o.equals(
        14
        /* KeyCode.Home */
      ) ? a = this.focusFirst() : o.equals(
        13
        /* KeyCode.End */
      ) ? a = this.focusLast() : o.equals(
        2
        /* KeyCode.Tab */
      ) && l instanceof Hl && l.trapsArrowNavigation ? a = this.focusNext() : this.isTriggerKeyEvent(o) ? this._triggerKeys.keyDown ? this.doTrigger(o) : this.triggerKeyDown = !0 : a = !1, a && (o.preventDefault(), o.stopPropagation());
    })), this._register(fe(this.domNode, Se.KEY_UP, (s) => {
      const o = new zn(s);
      this.isTriggerKeyEvent(o) ? (!this._triggerKeys.keyDown && this.triggerKeyDown && (this.triggerKeyDown = !1, this.doTrigger(o)), o.preventDefault(), o.stopPropagation()) : (o.equals(
        2
        /* KeyCode.Tab */
      ) || o.equals(
        1026
        /* KeyCode.Tab */
      ) || o.equals(
        16
        /* KeyCode.UpArrow */
      ) || o.equals(
        18
        /* KeyCode.DownArrow */
      ) || o.equals(
        15
        /* KeyCode.LeftArrow */
      ) || o.equals(
        17
        /* KeyCode.RightArrow */
      )) && this.updateFocusedItem();
    })), this.focusTracker = this._register(Af(this.domNode)), this._register(this.focusTracker.onDidBlur(() => {
      (ss() === this.domNode || !Ji(ss(), this.domNode)) && (this._onDidBlur.fire(), this.previouslyFocusedItem = this.focusedItem, this.focusedItem = void 0, this.triggerKeyDown = !1);
    })), this._register(this.focusTracker.onDidFocus(() => this.updateFocusedItem())), this.actionsList = document.createElement("ul"), this.actionsList.className = "actions-container", this.options.highlightToggledItems && this.actionsList.classList.add("highlight-toggled"), this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar"), this.options.ariaLabel && this.actionsList.setAttribute("aria-label", this.options.ariaLabel), this.domNode.appendChild(this.actionsList), e.appendChild(this.domNode);
  }
  refreshRole() {
    this.length() >= 1 ? this.actionsList.setAttribute("role", this.options.ariaRole || "toolbar") : this.actionsList.setAttribute("role", "presentation");
  }
  // Some action bars should not be focusable at times
  // When an action bar is not focusable make sure to make all the elements inside it not focusable
  // When an action bar is focusable again, make sure the first item can be focused
  setFocusable(e) {
    if (this.focusable = e, this.focusable) {
      const t = this.viewItems.find((n) => n instanceof Hl && n.isEnabled());
      t instanceof Hl && t.setFocusable(!0);
    } else
      this.viewItems.forEach((t) => {
        t instanceof Hl && t.setFocusable(!1);
      });
  }
  isTriggerKeyEvent(e) {
    let t = !1;
    return this._triggerKeys.keys.forEach((n) => {
      t = t || e.equals(n);
    }), t;
  }
  updateFocusedItem() {
    for (let e = 0; e < this.actionsList.children.length; e++) {
      const t = this.actionsList.children[e];
      if (Ji(ss(), t)) {
        this.focusedItem = e, this.viewItems[this.focusedItem]?.showHover?.();
        break;
      }
    }
  }
  get context() {
    return this._context;
  }
  set context(e) {
    this._context = e, this.viewItems.forEach((t) => t.setActionContext(e));
  }
  get actionRunner() {
    return this._actionRunner;
  }
  set actionRunner(e) {
    this._actionRunner = e, this._actionRunnerDisposables.clear(), this._actionRunnerDisposables.add(this._actionRunner.onDidRun((t) => this._onDidRun.fire(t))), this._actionRunnerDisposables.add(this._actionRunner.onWillRun((t) => this._onWillRun.fire(t))), this.viewItems.forEach((t) => t.actionRunner = e);
  }
  getContainer() {
    return this.domNode;
  }
  getAction(e) {
    if (typeof e == "number")
      return this.viewItems[e]?.action;
    if (wr(e)) {
      for (; e.parentElement !== this.actionsList; ) {
        if (!e.parentElement)
          return;
        e = e.parentElement;
      }
      for (let t = 0; t < this.actionsList.childNodes.length; t++)
        if (this.actionsList.childNodes[t] === e)
          return this.viewItems[t].action;
    }
  }
  push(e, t = {}) {
    const n = Array.isArray(e) ? e : [e];
    let i = Kg(t.index) ? t.index : null;
    n.forEach((s) => {
      const o = document.createElement("li");
      o.className = "action-item", o.setAttribute("role", "presentation");
      let a;
      const l = { hoverDelegate: this._hoverDelegate, ...t, isTabList: this.options.ariaRole === "tablist" };
      this.options.actionViewItemProvider && (a = this.options.actionViewItemProvider(s, l)), a || (a = new yR(this.context, s, l)), this.options.allowContextMenu || this.viewItemDisposables.set(a, fe(o, Se.CONTEXT_MENU, (c) => {
        Lt.stop(c, !0);
      })), a.actionRunner = this._actionRunner, a.setActionContext(this.context), a.render(o), this.focusable && a instanceof Hl && this.viewItems.length === 0 && a.setFocusable(!0), i === null || i < 0 || i >= this.actionsList.children.length ? (this.actionsList.appendChild(o), this.viewItems.push(a)) : (this.actionsList.insertBefore(o, this.actionsList.children[i]), this.viewItems.splice(i, 0, a), i++);
    }), typeof this.focusedItem == "number" && this.focus(this.focusedItem), this.refreshRole();
  }
  clear() {
    this.isEmpty() || (this.viewItems = br(this.viewItems), this.viewItemDisposables.clearAndDisposeAll(), ic(this.actionsList), this.refreshRole());
  }
  length() {
    return this.viewItems.length;
  }
  isEmpty() {
    return this.viewItems.length === 0;
  }
  focus(e) {
    let t = !1, n;
    if (e === void 0 ? t = !0 : typeof e == "number" ? n = e : typeof e == "boolean" && (t = e), t && typeof this.focusedItem > "u") {
      const i = this.viewItems.findIndex((s) => s.isEnabled());
      this.focusedItem = i === -1 ? void 0 : i, this.updateFocus(void 0, void 0, !0);
    } else
      n !== void 0 && (this.focusedItem = n), this.updateFocus(void 0, void 0, !0);
  }
  focusFirst() {
    return this.focusedItem = this.length() - 1, this.focusNext(!0);
  }
  focusLast() {
    return this.focusedItem = 0, this.focusPrevious(!0);
  }
  focusNext(e) {
    if (typeof this.focusedItem > "u")
      this.focusedItem = this.viewItems.length - 1;
    else if (this.viewItems.length <= 1)
      return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (!e && this.options.preventLoopNavigation && this.focusedItem + 1 >= this.viewItems.length)
        return this.focusedItem = t, !1;
      this.focusedItem = (this.focusedItem + 1) % this.viewItems.length, n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Pr.ID));
    return this.updateFocus(), !0;
  }
  focusPrevious(e) {
    if (typeof this.focusedItem > "u")
      this.focusedItem = 0;
    else if (this.viewItems.length <= 1)
      return !1;
    const t = this.focusedItem;
    let n;
    do {
      if (this.focusedItem = this.focusedItem - 1, this.focusedItem < 0) {
        if (!e && this.options.preventLoopNavigation)
          return this.focusedItem = t, !1;
        this.focusedItem = this.viewItems.length - 1;
      }
      n = this.viewItems[this.focusedItem];
    } while (this.focusedItem !== t && (this.options.focusOnlyEnabledItems && !n.isEnabled() || n.action.id === Pr.ID));
    return this.updateFocus(!0), !0;
  }
  updateFocus(e, t, n = !1) {
    typeof this.focusedItem > "u" && this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem !== void 0 && this.previouslyFocusedItem !== this.focusedItem && this.viewItems[this.previouslyFocusedItem]?.blur();
    const i = this.focusedItem !== void 0 ? this.viewItems[this.focusedItem] : void 0;
    if (i) {
      let s = !0;
      _8(i.focus) || (s = !1), this.options.focusOnlyEnabledItems && _8(i.isEnabled) && !i.isEnabled() && (s = !1), i.action.id === Pr.ID && (s = !1), s ? (n || this.previouslyFocusedItem !== this.focusedItem) && (i.focus(e), this.previouslyFocusedItem = this.focusedItem) : (this.actionsList.focus({ preventScroll: t }), this.previouslyFocusedItem = void 0), s && i.showHover?.();
    }
  }
  doTrigger(e) {
    if (typeof this.focusedItem > "u")
      return;
    const t = this.viewItems[this.focusedItem];
    if (t instanceof Hl) {
      const n = t._context === null || t._context === void 0 ? e : t._context;
      this.run(t._action, n);
    }
  }
  async run(e, t) {
    await this._actionRunner.run(e, t);
  }
  dispose() {
    this._context = void 0, this.viewItems = br(this.viewItems), this.getContainer().remove(), super.dispose();
  }
}
const dk = /\(&([^\s&])\)|(^|[^&])&([^\s&])/, y_ = /(&amp;)?(&amp;)([^\s&])/g;
var F9;
(function(r) {
  r[r.Right = 0] = "Right", r[r.Left = 1] = "Left";
})(F9 || (F9 = {}));
var uk;
(function(r) {
  r[r.Above = 0] = "Above", r[r.Below = 1] = "Below";
})(uk || (uk = {}));
class Op extends Md {
  constructor(e, t, n, i) {
    e.classList.add("monaco-menu-container"), e.setAttribute("role", "presentation");
    const s = document.createElement("div");
    s.classList.add("monaco-menu"), s.setAttribute("role", "presentation"), super(s, {
      orientation: 1,
      actionViewItemProvider: (c) => this.doGetActionViewItem(c, n, o),
      context: n.context,
      actionRunner: n.actionRunner,
      ariaLabel: n.ariaLabel,
      ariaRole: "menu",
      focusOnlyEnabledItems: !0,
      triggerKeys: { keys: [3, ...zt || Cs ? [
        10
        /* KeyCode.Space */
      ] : []], keyDown: !0 }
    }), this.menuStyles = i, this.menuElement = s, this.actionsList.tabIndex = 0, this.initializeOrUpdateStyleSheet(e, i), this._register(Xn.addTarget(s)), this._register(fe(s, Se.KEY_DOWN, (c) => {
      new zn(c).equals(
        2
        /* KeyCode.Tab */
      ) && c.preventDefault();
    })), n.enableMnemonics && this._register(fe(s, Se.KEY_DOWN, (c) => {
      const d = c.key.toLocaleLowerCase();
      if (this.mnemonics.has(d)) {
        Lt.stop(c, !0);
        const u = this.mnemonics.get(d);
        if (u.length === 1 && (u[0] instanceof c9e && u[0].container && this.focusItemByElement(u[0].container), u[0].onClick(c)), u.length > 1) {
          const f = u.shift();
          f && f.container && (this.focusItemByElement(f.container), u.push(f)), this.mnemonics.set(d, u);
        }
      }
    })), Cs && this._register(fe(s, Se.KEY_DOWN, (c) => {
      const d = new zn(c);
      d.equals(
        14
        /* KeyCode.Home */
      ) || d.equals(
        11
        /* KeyCode.PageUp */
      ) ? (this.focusedItem = this.viewItems.length - 1, this.focusNext(), Lt.stop(c, !0)) : (d.equals(
        13
        /* KeyCode.End */
      ) || d.equals(
        12
        /* KeyCode.PageDown */
      )) && (this.focusedItem = 0, this.focusPrevious(), Lt.stop(c, !0));
    })), this._register(fe(this.domNode, Se.MOUSE_OUT, (c) => {
      const d = c.relatedTarget;
      Ji(d, this.domNode) || (this.focusedItem = void 0, this.updateFocus(), c.stopPropagation());
    })), this._register(fe(this.actionsList, Se.MOUSE_OVER, (c) => {
      let d = c.target;
      if (!(!d || !Ji(d, this.actionsList) || d === this.actionsList)) {
        for (; d.parentElement !== this.actionsList && d.parentElement !== null; )
          d = d.parentElement;
        if (d.classList.contains("action-item")) {
          const u = this.focusedItem;
          this.setFocusedItem(d), u !== this.focusedItem && this.updateFocus();
        }
      }
    })), this._register(Xn.addTarget(this.actionsList)), this._register(fe(this.actionsList, Nn.Tap, (c) => {
      let d = c.initialTarget;
      if (!(!d || !Ji(d, this.actionsList) || d === this.actionsList)) {
        for (; d.parentElement !== this.actionsList && d.parentElement !== null; )
          d = d.parentElement;
        if (d.classList.contains("action-item")) {
          const u = this.focusedItem;
          this.setFocusedItem(d), u !== this.focusedItem && this.updateFocus();
        }
      }
    }));
    const o = {
      parent: this
    };
    this.mnemonics = /* @__PURE__ */ new Map(), this.scrollableElement = this._register(new MO(s, {
      alwaysConsumeMouseWheel: !0,
      horizontal: 2,
      vertical: 3,
      verticalScrollbarSize: 7,
      handleMouseWheel: !0,
      useShadows: !0
    }));
    const a = this.scrollableElement.getDomNode();
    a.style.position = "", this.styleScrollElement(a, i), this._register(fe(s, Nn.Change, (c) => {
      Lt.stop(c, !0);
      const d = this.scrollableElement.getScrollPosition().scrollTop;
      this.scrollableElement.setScrollPosition({ scrollTop: d - c.translationY });
    })), this._register(fe(a, Se.MOUSE_UP, (c) => {
      c.preventDefault();
    }));
    const l = qe(e);
    s.style.maxHeight = `${Math.max(10, l.innerHeight - e.getBoundingClientRect().top - 35)}px`, t = t.filter((c, d) => n.submenuIds?.has(c.id) ? (console.warn(`Found submenu cycle: ${c.id}`), !1) : !(c instanceof Pr && (d === t.length - 1 || d === 0 || t[d - 1] instanceof Pr))), this.push(t, { icon: !0, label: !0, isMenu: !0 }), e.appendChild(this.scrollableElement.getDomNode()), this.scrollableElement.scanDomNode(), this.viewItems.filter((c) => !(c instanceof h9e)).forEach((c, d, u) => {
      c.updatePositionInSet(d + 1, u.length);
    });
  }
  initializeOrUpdateStyleSheet(e, t) {
    this.styleSheet || (B8(e) ? this.styleSheet = ya(e) : (Op.globalStyleSheet || (Op.globalStyleSheet = ya()), this.styleSheet = Op.globalStyleSheet)), this.styleSheet.textContent = tyt(t, B8(e));
  }
  styleScrollElement(e, t) {
    const n = t.foregroundColor ?? "", i = t.backgroundColor ?? "", s = t.borderColor ? `1px solid ${t.borderColor}` : "", o = "5px", a = t.shadowColor ? `0 2px 8px ${t.shadowColor}` : "";
    e.style.outline = s, e.style.borderRadius = o, e.style.color = n, e.style.backgroundColor = i, e.style.boxShadow = a;
  }
  getContainer() {
    return this.scrollableElement.getDomNode();
  }
  get onScroll() {
    return this.scrollableElement.onScroll;
  }
  focusItemByElement(e) {
    const t = this.focusedItem;
    this.setFocusedItem(e), t !== this.focusedItem && this.updateFocus();
  }
  setFocusedItem(e) {
    for (let t = 0; t < this.actionsList.children.length; t++) {
      const n = this.actionsList.children[t];
      if (e === n) {
        this.focusedItem = t;
        break;
      }
    }
  }
  updateFocus(e) {
    super.updateFocus(e, !0, !0), typeof this.focusedItem < "u" && this.scrollableElement.setScrollPosition({
      scrollTop: Math.round(this.menuElement.scrollTop)
    });
  }
  doGetActionViewItem(e, t, n) {
    if (e instanceof Pr)
      return new h9e(t.context, e, { icon: !0 }, this.menuStyles);
    if (e instanceof W7) {
      const i = new c9e(e, e.actions, n, { ...t, submenuIds: /* @__PURE__ */ new Set([...t.submenuIds || [], e.id]) }, this.menuStyles);
      if (t.enableMnemonics) {
        const s = i.getMnemonic();
        if (s && i.isEnabled()) {
          let o = [];
          this.mnemonics.has(s) && (o = this.mnemonics.get(s)), o.push(i), this.mnemonics.set(s, o);
        }
      }
      return i;
    } else {
      const i = { enableMnemonics: t.enableMnemonics, useEventAsContext: t.useEventAsContext };
      if (t.getKeyBinding) {
        const o = t.getKeyBinding(e);
        if (o) {
          const a = o.getLabel();
          a && (i.keybinding = a);
        }
      }
      const s = new PNe(t.context, e, i, this.menuStyles);
      if (t.enableMnemonics) {
        const o = s.getMnemonic();
        if (o && s.isEnabled()) {
          let a = [];
          this.mnemonics.has(o) && (a = this.mnemonics.get(o)), a.push(s), this.mnemonics.set(o, a);
        }
      }
      return s;
    }
  }
}
class PNe extends Hl {
  constructor(e, t, n, i) {
    if (n.isMenu = !0, super(t, t, n), this.menuStyle = i, this.options = n, this.options.icon = n.icon !== void 0 ? n.icon : !1, this.options.label = n.label !== void 0 ? n.label : !0, this.cssClass = "", this.options.label && n.enableMnemonics) {
      const s = this.action.label;
      if (s) {
        const o = dk.exec(s);
        o && (this.mnemonic = (o[1] ? o[1] : o[3]).toLocaleLowerCase());
      }
    }
    this.runOnceToEnableMouseUp = new Nr(() => {
      this.element && (this._register(fe(this.element, Se.MOUSE_UP, (s) => {
        if (Lt.stop(s, !0), pl) {
          if (new zl(qe(this.element), s).rightButton)
            return;
          this.onClick(s);
        } else
          setTimeout(() => {
            this.onClick(s);
          }, 0);
      })), this._register(fe(this.element, Se.CONTEXT_MENU, (s) => {
        Lt.stop(s, !0);
      })));
    }, 100), this._register(this.runOnceToEnableMouseUp);
  }
  render(e) {
    super.render(e), this.element && (this.container = e, this.item = Fe(this.element, $e("a.action-menu-item")), this._action.id === Pr.ID ? this.item.setAttribute("role", "presentation") : (this.item.setAttribute("role", "menuitem"), this.mnemonic && this.item.setAttribute("aria-keyshortcuts", `${this.mnemonic}`)), this.check = Fe(this.item, $e("span.menu-item-check" + Tt.asCSSSelector(ke.menuSelection))), this.check.setAttribute("role", "none"), this.label = Fe(this.item, $e("span.action-label")), this.options.label && this.options.keybinding && (Fe(this.item, $e("span.keybinding")).textContent = this.options.keybinding), this.runOnceToEnableMouseUp.schedule(), this.updateClass(), this.updateLabel(), this.updateTooltip(), this.updateEnabled(), this.updateChecked(), this.applyStyle());
  }
  blur() {
    super.blur(), this.applyStyle();
  }
  focus() {
    super.focus(), this.item?.focus(), this.applyStyle();
  }
  updatePositionInSet(e, t) {
    this.item && (this.item.setAttribute("aria-posinset", `${e}`), this.item.setAttribute("aria-setsize", `${t}`));
  }
  updateLabel() {
    if (this.label && this.options.label) {
      ic(this.label);
      let e = pNe(this.action.label);
      if (e) {
        const t = eyt(e);
        this.options.enableMnemonics || (e = t), this.label.setAttribute("aria-label", t.replace(/&&/g, "&"));
        const n = dk.exec(e);
        if (n) {
          e = VA(e), y_.lastIndex = 0;
          let i = y_.exec(e);
          for (; i && i[1]; )
            i = y_.exec(e);
          const s = (o) => o.replace(/&amp;&amp;/g, "&amp;");
          i ? this.label.append(R7(s(e.substr(0, i.index)), " "), $e("u", { "aria-hidden": "true" }, i[3]), E0t(s(e.substr(i.index + i[0].length)), " ")) : this.label.innerText = s(e).trim(), this.item?.setAttribute("aria-keyshortcuts", (n[1] ? n[1] : n[3]).toLocaleLowerCase());
        } else
          this.label.innerText = e.replace(/&&/g, "&").trim();
      }
    }
  }
  updateTooltip() {
  }
  updateClass() {
    this.cssClass && this.item && this.item.classList.remove(...this.cssClass.split(" ")), this.options.icon && this.label ? (this.cssClass = this.action.class || "", this.label.classList.add("icon"), this.cssClass && this.label.classList.add(...this.cssClass.split(" ")), this.updateEnabled()) : this.label && this.label.classList.remove("icon");
  }
  updateEnabled() {
    this.action.enabled ? (this.element && (this.element.classList.remove("disabled"), this.element.removeAttribute("aria-disabled")), this.item && (this.item.classList.remove("disabled"), this.item.removeAttribute("aria-disabled"), this.item.tabIndex = 0)) : (this.element && (this.element.classList.add("disabled"), this.element.setAttribute("aria-disabled", "true")), this.item && (this.item.classList.add("disabled"), this.item.setAttribute("aria-disabled", "true")));
  }
  updateChecked() {
    if (!this.item)
      return;
    const e = this.action.checked;
    this.item.classList.toggle("checked", !!e), e !== void 0 ? (this.item.setAttribute("role", "menuitemcheckbox"), this.item.setAttribute("aria-checked", e ? "true" : "false")) : (this.item.setAttribute("role", "menuitem"), this.item.setAttribute("aria-checked", ""));
  }
  getMnemonic() {
    return this.mnemonic;
  }
  applyStyle() {
    const e = this.element && this.element.classList.contains("focused"), t = e && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor, n = e && this.menuStyle.selectionBackgroundColor ? this.menuStyle.selectionBackgroundColor : void 0, i = e && this.menuStyle.selectionBorderColor ? `1px solid ${this.menuStyle.selectionBorderColor}` : "", s = e && this.menuStyle.selectionBorderColor ? "-1px" : "";
    this.item && (this.item.style.color = t ?? "", this.item.style.backgroundColor = n ?? "", this.item.style.outline = i, this.item.style.outlineOffset = s), this.check && (this.check.style.color = t ?? "");
  }
}
class c9e extends PNe {
  constructor(e, t, n, i, s) {
    super(e, e, i, s), this.submenuActions = t, this.parentData = n, this.submenuOptions = i, this.mysubmenu = null, this.submenuDisposables = this._register(new ze()), this.mouseOver = !1, this.expandDirection = i && i.expandDirection !== void 0 ? i.expandDirection : { horizontal: F9.Right, vertical: uk.Below }, this.showScheduler = new Nr(() => {
      this.mouseOver && (this.cleanupExistingSubmenu(!1), this.createSubmenu(!1));
    }, 250), this.hideScheduler = new Nr(() => {
      this.element && !Ji(ss(), this.element) && this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    }, 750);
  }
  render(e) {
    super.render(e), this.element && (this.item && (this.item.classList.add("monaco-submenu-item"), this.item.tabIndex = 0, this.item.setAttribute("aria-haspopup", "true"), this.updateAriaExpanded("false"), this.submenuIndicator = Fe(this.item, $e("span.submenu-indicator" + Tt.asCSSSelector(ke.menuSubmenu))), this.submenuIndicator.setAttribute("aria-hidden", "true")), this._register(fe(this.element, Se.KEY_UP, (t) => {
      const n = new zn(t);
      (n.equals(
        17
        /* KeyCode.RightArrow */
      ) || n.equals(
        3
        /* KeyCode.Enter */
      )) && (Lt.stop(t, !0), this.createSubmenu(!0));
    })), this._register(fe(this.element, Se.KEY_DOWN, (t) => {
      const n = new zn(t);
      ss() === this.item && (n.equals(
        17
        /* KeyCode.RightArrow */
      ) || n.equals(
        3
        /* KeyCode.Enter */
      )) && Lt.stop(t, !0);
    })), this._register(fe(this.element, Se.MOUSE_OVER, (t) => {
      this.mouseOver || (this.mouseOver = !0, this.showScheduler.schedule());
    })), this._register(fe(this.element, Se.MOUSE_LEAVE, (t) => {
      this.mouseOver = !1;
    })), this._register(fe(this.element, Se.FOCUS_OUT, (t) => {
      this.element && !Ji(ss(), this.element) && this.hideScheduler.schedule();
    })), this._register(this.parentData.parent.onScroll(() => {
      this.parentData.submenu === this.mysubmenu && (this.parentData.parent.focus(!1), this.cleanupExistingSubmenu(!0));
    })));
  }
  updateEnabled() {
  }
  onClick(e) {
    Lt.stop(e, !0), this.cleanupExistingSubmenu(!1), this.createSubmenu(!0);
  }
  cleanupExistingSubmenu(e) {
    if (this.parentData.submenu && (e || this.parentData.submenu !== this.mysubmenu)) {
      try {
        this.parentData.submenu.dispose();
      } catch {
      }
      this.parentData.submenu = void 0, this.updateAriaExpanded("false"), this.submenuContainer && (this.submenuDisposables.clear(), this.submenuContainer = void 0);
    }
  }
  calculateSubmenuMenuLayout(e, t, n, i) {
    const s = { top: 0, left: 0 };
    return s.left = sp(e.width, t.width, { position: i.horizontal === F9.Right ? 0 : 1, offset: n.left, size: n.width }), s.left >= n.left && s.left < n.left + n.width && (n.left + 10 + t.width <= e.width && (s.left = n.left + 10), n.top += 10, n.height = 0), s.top = sp(e.height, t.height, { position: 0, offset: n.top, size: 0 }), s.top + t.height === n.top && s.top + n.height + t.height <= e.height && (s.top += n.height), s;
  }
  createSubmenu(e = !0) {
    if (this.element)
      if (this.parentData.submenu)
        this.parentData.submenu.focus(!1);
      else {
        this.updateAriaExpanded("true"), this.submenuContainer = Fe(this.element, $e("div.monaco-submenu")), this.submenuContainer.classList.add("menubar-menu-items-holder", "context-view");
        const t = qe(this.parentData.parent.domNode).getComputedStyle(this.parentData.parent.domNode), n = parseFloat(t.paddingTop || "0") || 0;
        this.submenuContainer.style.zIndex = "1", this.submenuContainer.style.position = "fixed", this.submenuContainer.style.top = "0", this.submenuContainer.style.left = "0", this.parentData.submenu = new Op(this.submenuContainer, this.submenuActions.length ? this.submenuActions : [new XI()], this.submenuOptions, this.menuStyle);
        const i = this.element.getBoundingClientRect(), s = {
          top: i.top - n,
          left: i.left,
          height: i.height + 2 * n,
          width: i.width
        }, o = this.submenuContainer.getBoundingClientRect(), a = qe(this.element), { top: l, left: c } = this.calculateSubmenuMenuLayout(new Ka(a.innerWidth, a.innerHeight), Ka.lift(o), s, this.expandDirection);
        this.submenuContainer.style.left = `${c - o.left}px`, this.submenuContainer.style.top = `${l - o.top}px`, this.submenuDisposables.add(fe(this.submenuContainer, Se.KEY_UP, (d) => {
          new zn(d).equals(
            15
            /* KeyCode.LeftArrow */
          ) && (Lt.stop(d, !0), this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0));
        })), this.submenuDisposables.add(fe(this.submenuContainer, Se.KEY_DOWN, (d) => {
          new zn(d).equals(
            15
            /* KeyCode.LeftArrow */
          ) && Lt.stop(d, !0);
        })), this.submenuDisposables.add(this.parentData.submenu.onDidCancel(() => {
          this.parentData.parent.focus(), this.cleanupExistingSubmenu(!0);
        })), this.parentData.submenu.focus(e), this.mysubmenu = this.parentData.submenu;
      }
  }
  updateAriaExpanded(e) {
    this.item && this.item?.setAttribute("aria-expanded", e);
  }
  applyStyle() {
    super.applyStyle();
    const t = this.element && this.element.classList.contains("focused") && this.menuStyle.selectionForegroundColor ? this.menuStyle.selectionForegroundColor : this.menuStyle.foregroundColor;
    this.submenuIndicator && (this.submenuIndicator.style.color = t ?? "");
  }
  dispose() {
    super.dispose(), this.hideScheduler.dispose(), this.mysubmenu && (this.mysubmenu.dispose(), this.mysubmenu = null), this.submenuContainer && (this.submenuContainer = void 0);
  }
}
class h9e extends yR {
  constructor(e, t, n, i) {
    super(e, t, n), this.menuStyles = i;
  }
  render(e) {
    super.render(e), this.label && (this.label.style.borderBottomColor = this.menuStyles.separatorColor ? `${this.menuStyles.separatorColor}` : "");
  }
}
function eyt(r) {
  const e = dk, t = e.exec(r);
  if (!t)
    return r;
  const n = !t[1];
  return r.replace(e, n ? "$2$3" : "").trim();
}
function d9e(r) {
  const e = $Me()[r.id];
  return `.codicon-${r.id}:before { content: '\\${e.toString(16)}'; }`;
}
function tyt(r, e) {
  let t = (
    /* css */
    `
.monaco-menu {
	font-size: 13px;
	border-radius: 5px;
	min-width: 160px;
}

${d9e(ke.menuSelection)}
${d9e(ke.menuSubmenu)}

.monaco-menu .monaco-action-bar {
	text-align: right;
	overflow: hidden;
	white-space: nowrap;
}

.monaco-menu .monaco-action-bar .actions-container {
	display: flex;
	margin: 0 auto;
	padding: 0;
	width: 100%;
	justify-content: flex-end;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: inline-block;
}

.monaco-menu .monaco-action-bar.reverse .actions-container {
	flex-direction: row-reverse;
}

.monaco-menu .monaco-action-bar .action-item {
	cursor: pointer;
	display: inline-block;
	transition: transform 50ms ease;
	position: relative;  /* DO NOT REMOVE - this is the key to preventing the ghosting icon bug in Chrome 42 */
}

.monaco-menu .monaco-action-bar .action-item.disabled {
	cursor: default;
}

.monaco-menu .monaco-action-bar .action-item .icon,
.monaco-menu .monaco-action-bar .action-item .codicon {
	display: inline-block;
}

.monaco-menu .monaco-action-bar .action-item .codicon {
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar .action-label {
	font-size: 11px;
	margin-right: 4px;
}

.monaco-menu .monaco-action-bar .action-item.disabled .action-label,
.monaco-menu .monaco-action-bar .action-item.disabled .action-label:hover {
	color: var(--vscode-disabledForeground);
}

/* Vertical actions */

.monaco-menu .monaco-action-bar.vertical {
	text-align: left;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	display: block;
	border-bottom: 1px solid var(--vscode-menu-separatorBackground);
	padding-top: 1px;
	padding: 30px;
}

.monaco-menu .secondary-actions .monaco-action-bar .action-label {
	margin-left: 6px;
}

/* Action Items */
.monaco-menu .monaco-action-bar .action-item.select-container {
	overflow: hidden; /* somehow the dropdown overflows its container, we prevent it here to not push */
	flex: 1;
	max-width: 170px;
	min-width: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 10px;
}

.monaco-menu .monaco-action-bar.vertical {
	margin-left: 0;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .actions-container {
	display: block;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	padding: 0;
	transform: none;
	display: flex;
}

.monaco-menu .monaco-action-bar.vertical .action-item.active {
	transform: none;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	flex: 1 1 auto;
	display: flex;
	height: 2em;
	align-items: center;
	position: relative;
	margin: 0 4px;
	border-radius: 4px;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item:hover .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-menu-item:focus .keybinding {
	opacity: unset;
}

.monaco-menu .monaco-action-bar.vertical .action-label {
	flex: 1 1 auto;
	text-decoration: none;
	padding: 0 1em;
	background: none;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .keybinding,
.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	display: inline-block;
	flex: 2 1 auto;
	padding: 0 1em;
	text-align: right;
	font-size: 12px;
	line-height: 1;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon {
	font-size: 16px !important;
	display: flex;
	align-items: center;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator.codicon::before {
	margin-left: auto;
	margin-right: -20px;
}

.monaco-menu .monaco-action-bar.vertical .action-item.disabled .keybinding,
.monaco-menu .monaco-action-bar.vertical .action-item.disabled .submenu-indicator {
	opacity: 0.4;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator) {
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
}

.monaco-menu .monaco-action-bar.vertical .action-item {
	position: static;
	overflow: visible;
}

.monaco-menu .monaco-action-bar.vertical .action-item .monaco-submenu {
	position: absolute;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	width: 100%;
	height: 0px !important;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator.text {
	padding: 0.7em 1em 0.1em 1em;
	font-weight: bold;
	opacity: 1;
}

.monaco-menu .monaco-action-bar.vertical .action-label:hover {
	color: inherit;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	position: absolute;
	visibility: hidden;
	width: 1em;
	height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item.checked .menu-item-check {
	visibility: visible;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Context Menu */

.context-view.monaco-menu-container {
	outline: 0;
	border: none;
	animation: fadeIn 0.083s linear;
	-webkit-app-region: no-drag;
}

.context-view.monaco-menu-container :focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical:focus,
.context-view.monaco-menu-container .monaco-action-bar.vertical :focus {
	outline: 0;
}

.hc-black .context-view.monaco-menu-container,
.hc-light .context-view.monaco-menu-container,
:host-context(.hc-black) .context-view.monaco-menu-container,
:host-context(.hc-light) .context-view.monaco-menu-container {
	box-shadow: none;
}

.hc-black .monaco-menu .monaco-action-bar.vertical .action-item.focused,
.hc-light .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-black) .monaco-menu .monaco-action-bar.vertical .action-item.focused,
:host-context(.hc-light) .monaco-menu .monaco-action-bar.vertical .action-item.focused {
	background: none;
}

/* Vertical Action Bar Styles */

.monaco-menu .monaco-action-bar.vertical {
	padding: 4px 0;
}

.monaco-menu .monaco-action-bar.vertical .action-menu-item {
	height: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label:not(.separator),
.monaco-menu .monaco-action-bar.vertical .keybinding {
	font-size: inherit;
	padding: 0 2em;
	max-height: 100%;
}

.monaco-menu .monaco-action-bar.vertical .menu-item-check {
	font-size: inherit;
	width: 2em;
}

.monaco-menu .monaco-action-bar.vertical .action-label.separator {
	font-size: inherit;
	margin: 5px 0 !important;
	padding: 0;
	border-radius: 0;
}

.linux .monaco-menu .monaco-action-bar.vertical .action-label.separator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .action-label.separator {
	margin-left: 0;
	margin-right: 0;
}

.monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	font-size: 60%;
	padding: 0 1.8em;
}

.linux .monaco-menu .monaco-action-bar.vertical .submenu-indicator,
:host-context(.linux) .monaco-menu .monaco-action-bar.vertical .submenu-indicator {
	height: 100%;
	mask-size: 10px 10px;
	-webkit-mask-size: 10px 10px;
}

.monaco-menu .action-item {
	cursor: default;
}`
  );
  if (e) {
    t += `
			/* Arrows */
			.monaco-scrollable-element > .scrollbar > .scra {
				cursor: pointer;
				font-size: 11px !important;
			}

			.monaco-scrollable-element > .visible {
				opacity: 1;

				/* Background rule added for IE9 - to allow clicks on dom node */
				background:rgba(0,0,0,0);

				transition: opacity 100ms linear;
			}
			.monaco-scrollable-element > .invisible {
				opacity: 0;
				pointer-events: none;
			}
			.monaco-scrollable-element > .invisible.fade {
				transition: opacity 800ms linear;
			}

			/* Scrollable Content Inset Shadow */
			.monaco-scrollable-element > .shadow {
				position: absolute;
				display: none;
			}
			.monaco-scrollable-element > .shadow.top {
				display: block;
				top: 0;
				left: 3px;
				height: 3px;
				width: 100%;
			}
			.monaco-scrollable-element > .shadow.left {
				display: block;
				top: 3px;
				left: 0;
				height: 100%;
				width: 3px;
			}
			.monaco-scrollable-element > .shadow.top-left-corner {
				display: block;
				top: 0;
				left: 0;
				height: 3px;
				width: 3px;
			}
		`;
    const n = r.scrollbarShadow;
    n && (t += `
				.monaco-scrollable-element > .shadow.top {
					box-shadow: ${n} 0 6px 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.left {
					box-shadow: ${n} 6px 0 6px -6px inset;
				}

				.monaco-scrollable-element > .shadow.top.left {
					box-shadow: ${n} 6px 6px 6px -6px inset;
				}
			`);
    const i = r.scrollbarSliderBackground;
    i && (t += `
				.monaco-scrollable-element > .scrollbar > .slider {
					background: ${i};
				}
			`);
    const s = r.scrollbarSliderHoverBackground;
    s && (t += `
				.monaco-scrollable-element > .scrollbar > .slider:hover {
					background: ${s};
				}
			`);
    const o = r.scrollbarSliderActiveBackground;
    o && (t += `
				.monaco-scrollable-element > .scrollbar > .slider.active {
					background: ${o};
				}
			`);
  }
  return t;
}
class nyt {
  constructor(e, t, n, i) {
    this.contextViewService = e, this.telemetryService = t, this.notificationService = n, this.keybindingService = i, this.focusToReturn = null, this.lastContainer = null, this.block = null, this.blockDisposable = null, this.options = { blockMouse: !0 };
  }
  configure(e) {
    this.options = e;
  }
  showContextMenu(e) {
    const t = e.getActions();
    if (!t.length)
      return;
    this.focusToReturn = ss();
    let n;
    const i = wr(e.domForShadowRoot) ? e.domForShadowRoot : void 0;
    this.contextViewService.showContextView({
      getAnchor: () => e.getAnchor(),
      canRelayout: !1,
      anchorAlignment: e.anchorAlignment,
      anchorAxisAlignment: e.anchorAxisAlignment,
      render: (s) => {
        this.lastContainer = s;
        const o = e.getMenuClassName ? e.getMenuClassName() : "";
        o && (s.className += " " + o), this.options.blockMouse && (this.block = s.appendChild($e(".context-view-block")), this.block.style.position = "fixed", this.block.style.cursor = "initial", this.block.style.left = "0", this.block.style.top = "0", this.block.style.width = "100%", this.block.style.height = "100%", this.block.style.zIndex = "-1", this.blockDisposable?.dispose(), this.blockDisposable = fe(this.block, Se.MOUSE_DOWN, (d) => d.stopPropagation()));
        const a = new ze(), l = e.actionRunner || new wf();
        l.onWillRun((d) => this.onActionRun(d, !e.skipTelemetry), this, a), l.onDidRun(this.onDidActionRun, this, a), n = new Op(s, t, {
          actionViewItemProvider: e.getActionViewItem,
          context: e.getActionsContext ? e.getActionsContext() : null,
          actionRunner: l,
          getKeyBinding: e.getKeyBinding ? e.getKeyBinding : (d) => this.keybindingService.lookupKeybinding(d.id)
        }, Y7t), n.onDidCancel(() => this.contextViewService.hideContextView(!0), null, a), n.onDidBlur(() => this.contextViewService.hideContextView(!0), null, a);
        const c = qe(s);
        return a.add(fe(c, Se.BLUR, () => this.contextViewService.hideContextView(!0))), a.add(fe(c, Se.MOUSE_DOWN, (d) => {
          if (d.defaultPrevented)
            return;
          const u = new zl(c, d);
          let f = u.target;
          if (!u.rightButton) {
            for (; f; ) {
              if (f === s)
                return;
              f = f.parentElement;
            }
            this.contextViewService.hideContextView(!0);
          }
        })), ih(a, n);
      },
      focus: () => {
        n?.focus(!!e.autoSelectFirstItem);
      },
      onHide: (s) => {
        e.onHide?.(!!s), this.block && (this.block.remove(), this.block = null), this.blockDisposable?.dispose(), this.blockDisposable = null, this.lastContainer && (ss() === this.lastContainer || Ji(ss(), this.lastContainer)) && this.focusToReturn?.focus(), this.lastContainer = null;
      }
    }, i, !!i);
  }
  onActionRun(e, t) {
    t && this.telemetryService.publicLog2("workbenchActionExecuted", { id: e.action.id, from: "contextMenu" }), this.contextViewService.hideContextView(!1);
  }
  onDidActionRun(e) {
    e.error && !gw(e.error) && this.notificationService.error(e.error);
  }
}
var iyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, L2 = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let fk = class extends me {
  get contextMenuHandler() {
    return this._contextMenuHandler || (this._contextMenuHandler = new nyt(this.contextViewService, this.telemetryService, this.notificationService, this.keybindingService)), this._contextMenuHandler;
  }
  constructor(e, t, n, i, s, o) {
    super(), this.telemetryService = e, this.notificationService = t, this.contextViewService = n, this.keybindingService = i, this.menuService = s, this.contextKeyService = o, this._contextMenuHandler = void 0, this._onDidShowContextMenu = this._store.add(new $()), this.onDidShowContextMenu = this._onDidShowContextMenu.event, this._onDidHideContextMenu = this._store.add(new $());
  }
  configure(e) {
    this.contextMenuHandler.configure(e);
  }
  // ContextMenu
  showContextMenu(e) {
    e = pk.transform(e, this.menuService, this.contextKeyService), this.contextMenuHandler.showContextMenu({
      ...e,
      onHide: (t) => {
        e.onHide?.(t), this._onDidHideContextMenu.fire();
      }
    }), Iu.getInstance().resetKeyStatus(), this._onDidShowContextMenu.fire();
  }
};
fk = iyt([
  L2(0, I1),
  L2(1, Zo),
  L2(2, rm),
  L2(3, _r),
  L2(4, Yf),
  L2(5, sn)
], fk);
var pk;
(function(r) {
  function e(n) {
    return n && n.menuId instanceof oe;
  }
  function t(n, i, s) {
    if (!e(n))
      return n;
    const { menuId: o, menuActionOptions: a, contextKeyService: l } = n;
    return {
      ...n,
      getActions: () => {
        const c = [];
        if (o) {
          const d = i.getMenuActions(o, l ?? s, a);
          X7t(d, c);
        }
        return n.getActions ? Pr.join(n.getActions(), c) : c;
      }
    };
  }
  r.transform = t;
})(pk || (pk = {}));
var z9;
(function(r) {
  r[r.API = 0] = "API", r[r.USER = 1] = "USER";
})(z9 || (z9 = {}));
var ER = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, W9 = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let gk = class {
  constructor(e) {
    this._commandService = e;
  }
  async open(e, t) {
    if (!jI(e, Ct.command))
      return !1;
    if (!t?.allowCommands || (typeof e == "string" && (e = Pt.parse(e)), Array.isArray(t.allowCommands) && !t.allowCommands.includes(e.path)))
      return !0;
    let n = [];
    try {
      n = QL(decodeURIComponent(e.query));
    } catch {
      try {
        n = QL(e.query);
      } catch {
      }
    }
    return Array.isArray(n) || (n = [n]), await this._commandService.executeCommand(e.path, ...n), !0;
  }
};
gk = ER([
  W9(0, jo)
], gk);
let mk = class {
  constructor(e) {
    this._editorService = e;
  }
  async open(e, t) {
    typeof e == "string" && (e = Pt.parse(e));
    const { selection: n, uri: i } = P8t(e);
    return e = i, e.scheme === Ct.file && (e = $vt(e)), await this._editorService.openCodeEditor({
      resource: e,
      options: {
        selection: n,
        source: t?.fromUserGesture ? z9.USER : z9.API,
        ...t?.editorOptions
      }
    }, this._editorService.getFocusedCodeEditor(), t?.openToSide), !0;
  }
};
mk = ER([
  W9(0, Ui)
], mk);
let Ak = class {
  constructor(e, t) {
    this._openers = new no(), this._validators = new no(), this._resolvers = new no(), this._resolvedUriTargets = new ws((n) => n.with({ path: null, fragment: null, query: null }).toString()), this._externalOpeners = new no(), this._defaultExternalOpener = {
      openExternal: async (n) => (Zve(n, Ct.http, Ct.https) ? ODe(n) : Sn.location.href = n, !0)
    }, this._openers.push({
      open: async (n, i) => i?.openExternal || Zve(n, Ct.mailto, Ct.http, Ct.https, Ct.vsls) ? (await this._doOpenExternal(n, i), !0) : !1
    }), this._openers.push(new gk(t)), this._openers.push(new mk(e));
  }
  registerOpener(e) {
    return { dispose: this._openers.unshift(e) };
  }
  async open(e, t) {
    const n = typeof e == "string" ? Pt.parse(e) : e, i = this._resolvedUriTargets.get(n) ?? e;
    for (const s of this._validators)
      if (!await s.shouldOpen(i, t))
        return !1;
    for (const s of this._openers)
      if (await s.open(e, t))
        return !0;
    return !1;
  }
  async resolveExternalUri(e, t) {
    for (const n of this._resolvers)
      try {
        const i = await n.resolveExternalUri(e, t);
        if (i)
          return this._resolvedUriTargets.has(i.resolved) || this._resolvedUriTargets.set(i.resolved, e), i;
      } catch {
      }
    throw new Error("Could not resolve external URI: " + e.toString());
  }
  async _doOpenExternal(e, t) {
    const n = typeof e == "string" ? Pt.parse(e) : e;
    let i;
    try {
      i = (await this.resolveExternalUri(n, t)).resolved;
    } catch {
      i = n;
    }
    let s;
    if (typeof e == "string" && n.toString() === i.toString() ? s = e : s = encodeURI(i.toString(!0)), t?.allowContributedOpeners) {
      const o = typeof t?.allowContributedOpeners == "string" ? t?.allowContributedOpeners : void 0;
      for (const a of this._externalOpeners)
        if (await a.openExternal(s, {
          sourceUri: n,
          preferredOpenerId: o
        }, fl.None))
          return !0;
    }
    return this._defaultExternalOpener.openExternal(s, { sourceUri: n }, fl.None);
  }
  dispose() {
    this._validators.clear();
  }
};
Ak = ER([
  W9(0, Ui),
  W9(1, jo)
], Ak);
const Hw = Wt("editorWorkerService");
var la;
(function(r) {
  r[r.Hint = 1] = "Hint", r[r.Info = 2] = "Info", r[r.Warning = 4] = "Warning", r[r.Error = 8] = "Error";
})(la || (la = {}));
(function(r) {
  function e(o, a) {
    return a - o;
  }
  r.compare = e;
  const t = /* @__PURE__ */ Object.create(null);
  t[r.Error] = C("sev.error", "Error"), t[r.Warning] = C("sev.warning", "Warning"), t[r.Info] = C("sev.info", "Info");
  function n(o) {
    return t[o] || "";
  }
  r.toString = n;
  function i(o) {
    switch (o) {
      case Oi.Error:
        return r.Error;
      case Oi.Warning:
        return r.Warning;
      case Oi.Info:
        return r.Info;
      case Oi.Ignore:
        return r.Hint;
    }
  }
  r.fromSeverity = i;
  function s(o) {
    switch (o) {
      case r.Error:
        return Oi.Error;
      case r.Warning:
        return Oi.Warning;
      case r.Info:
        return Oi.Info;
      case r.Hint:
        return Oi.Ignore;
    }
  }
  r.toSeverity = s;
})(la || (la = {}));
var u9e;
(function(r) {
  const e = "";
  function t(i) {
    return n(i, !0);
  }
  r.makeKey = t;
  function n(i, s) {
    const o = [e];
    return i.source ? o.push(i.source.replace("¦", "\\¦")) : o.push(e), i.code ? typeof i.code == "string" ? o.push(i.code.replace("¦", "\\¦")) : o.push(i.code.value.replace("¦", "\\¦")) : o.push(e), i.severity !== void 0 && i.severity !== null ? o.push(la.toString(i.severity)) : o.push(e), i.message && s ? o.push(i.message.replace("¦", "\\¦")) : o.push(e), i.startLineNumber !== void 0 && i.startLineNumber !== null ? o.push(i.startLineNumber.toString()) : o.push(e), i.startColumn !== void 0 && i.startColumn !== null ? o.push(i.startColumn.toString()) : o.push(e), i.endLineNumber !== void 0 && i.endLineNumber !== null ? o.push(i.endLineNumber.toString()) : o.push(e), i.endColumn !== void 0 && i.endColumn !== null ? o.push(i.endColumn.toString()) : o.push(e), o.push(e), o.join("¦");
  }
  r.makeKeyOptionalMessage = n;
})(u9e || (u9e = {}));
const r2 = Wt("markerService");
function ryt(r, e) {
  const t = [], n = [];
  for (const i of r)
    e.has(i) || t.push(i);
  for (const i of e)
    r.has(i) || n.push(i);
  return { removed: t, added: n };
}
function syt(r, e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    r.has(n) && t.add(n);
  return t;
}
var oyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, f9e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let wk = class extends me {
  constructor(e, t) {
    super(), this._markerService = t, this._onDidChangeMarker = this._register(new $()), this._markerDecorations = new ws(), e.getModels().forEach((n) => this._onModelAdded(n)), this._register(e.onModelAdded(this._onModelAdded, this)), this._register(e.onModelRemoved(this._onModelRemoved, this)), this._register(this._markerService.onMarkerChanged(this._handleMarkerChange, this));
  }
  dispose() {
    super.dispose(), this._markerDecorations.forEach((e) => e.dispose()), this._markerDecorations.clear();
  }
  getMarker(e, t) {
    const n = this._markerDecorations.get(e);
    return n && n.getMarker(t) || null;
  }
  _handleMarkerChange(e) {
    e.forEach((t) => {
      const n = this._markerDecorations.get(t);
      n && this._updateDecorations(n);
    });
  }
  _onModelAdded(e) {
    const t = new ayt(e);
    this._markerDecorations.set(e.uri, t), this._updateDecorations(t);
  }
  _onModelRemoved(e) {
    const t = this._markerDecorations.get(e.uri);
    t && (t.dispose(), this._markerDecorations.delete(e.uri)), (e.uri.scheme === Ct.inMemory || e.uri.scheme === Ct.internal || e.uri.scheme === Ct.vscode) && this._markerService?.read({ resource: e.uri }).map((n) => n.owner).forEach((n) => this._markerService.remove(n, [e.uri]));
  }
  _updateDecorations(e) {
    const t = this._markerService.read({ resource: e.model.uri, take: 500 });
    e.update(t) && this._onDidChangeMarker.fire(e.model);
  }
};
wk = oyt([
  f9e(0, Wo),
  f9e(1, r2)
], wk);
class ayt extends me {
  constructor(e) {
    super(), this.model = e, this._map = new Tpt(), this._register(ht(() => {
      this.model.deltaDecorations([...this._map.values()], []), this._map.clear();
    }));
  }
  update(e) {
    const { added: t, removed: n } = ryt(new Set(this._map.keys()), new Set(e));
    if (t.length === 0 && n.length === 0)
      return !1;
    const i = n.map((a) => this._map.get(a)), s = t.map((a) => ({
      range: this._createDecorationRange(this.model, a),
      options: this._createDecorationOption(a)
    })), o = this.model.deltaDecorations(i, s);
    for (const a of n)
      this._map.delete(a);
    for (let a = 0; a < o.length; a++)
      this._map.set(t[a], o[a]);
    return !0;
  }
  getMarker(e) {
    return this._map.getKey(e.id);
  }
  _createDecorationRange(e, t) {
    let n = Q.lift(t);
    if (t.severity === la.Hint && !this._hasMarkerTag(
      t,
      1
      /* MarkerTag.Unnecessary */
    ) && !this._hasMarkerTag(
      t,
      2
      /* MarkerTag.Deprecated */
    ) && (n = n.setEndPosition(n.startLineNumber, n.startColumn + 2)), n = e.validateRange(n), n.isEmpty()) {
      const i = e.getLineLastNonWhitespaceColumn(n.startLineNumber) || e.getLineMaxColumn(n.startLineNumber);
      if (i === 1 || n.endColumn >= i)
        return n;
      const s = e.getWordAtPosition(n.getStartPosition());
      s && (n = new Q(n.startLineNumber, s.startColumn, n.endLineNumber, s.endColumn));
    } else if (t.endColumn === Number.MAX_VALUE && t.startColumn === 1 && n.startLineNumber === n.endLineNumber) {
      const i = e.getLineFirstNonWhitespaceColumn(t.startLineNumber);
      i < n.endColumn && (n = new Q(n.startLineNumber, i, n.endLineNumber, n.endColumn), t.startColumn = i);
    }
    return n;
  }
  _createDecorationOption(e) {
    let t, n, i, s, o;
    switch (e.severity) {
      case la.Hint:
        this._hasMarkerTag(
          e,
          2
          /* MarkerTag.Deprecated */
        ) ? t = void 0 : this._hasMarkerTag(
          e,
          1
          /* MarkerTag.Unnecessary */
        ) ? t = "squiggly-unnecessary" : t = "squiggly-hint", i = 0;
        break;
      case la.Info:
        t = "squiggly-info", n = Ua(C4t), i = 10, o = {
          color: Ua(Jmt),
          position: 1
          /* MinimapPosition.Inline */
        };
        break;
      case la.Warning:
        t = "squiggly-warning", n = Ua(y4t), i = 20, o = {
          color: Ua($mt),
          position: 1
          /* MinimapPosition.Inline */
        };
        break;
      case la.Error:
      default:
        t = "squiggly-error", n = Ua(b4t), i = 30, o = {
          color: Ua(eAt),
          position: 1
          /* MinimapPosition.Inline */
        };
        break;
    }
    return e.tags && (e.tags.indexOf(
      1
      /* MarkerTag.Unnecessary */
    ) !== -1 && (s = "squiggly-inline-unnecessary"), e.tags.indexOf(
      2
      /* MarkerTag.Deprecated */
    ) !== -1 && (s = "squiggly-inline-deprecated")), {
      description: "marker-decoration",
      stickiness: 1,
      className: t,
      showIfCollapsed: !0,
      overviewRuler: {
        color: n,
        position: Xu.Right
      },
      minimap: o,
      zIndex: i,
      inlineClassName: s
    };
  }
  _hasMarkerTag(e, t) {
    return e.tags ? e.tags.indexOf(t) >= 0 : !1;
  }
}
var lyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Zm = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, H2;
function X1(r) {
  return r.toString();
}
class cyt {
  constructor(e, t, n) {
    this.model = e, this._modelEventListeners = new ze(), this.model = e, this._modelEventListeners.add(e.onWillDispose(() => t(e))), this._modelEventListeners.add(e.onDidChangeLanguage((i) => n(e, i)));
  }
  dispose() {
    this._modelEventListeners.dispose();
  }
}
const hyt = Cs || zt ? 1 : 2;
class dyt {
  constructor(e, t, n, i, s, o, a, l) {
    this.uri = e, this.initialUndoRedoSnapshot = t, this.time = n, this.sharesUndoRedoStack = i, this.heapSize = s, this.sha1 = o, this.versionId = a, this.alternativeVersionId = l;
  }
}
let vk = class extends me {
  static {
    H2 = this;
  }
  static {
    this.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK = 20 * 1024 * 1024;
  }
  constructor(e, t, n, i, s) {
    super(), this._configurationService = e, this._resourcePropertiesService = t, this._undoRedoService = n, this._languageService = i, this._languageConfigurationService = s, this._onModelAdded = this._register(new $()), this.onModelAdded = this._onModelAdded.event, this._onModelRemoved = this._register(new $()), this.onModelRemoved = this._onModelRemoved.event, this._onModelModeChanged = this._register(new $()), this.onModelLanguageChanged = this._onModelModeChanged.event, this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null), this._models = {}, this._disposedModels = /* @__PURE__ */ new Map(), this._disposedModelsHeapSize = 0, this._register(this._configurationService.onDidChangeConfiguration((o) => this._updateModelOptions(o))), this._updateModelOptions(void 0);
  }
  static _readModelOptions(e, t) {
    let n = Hr.tabSize;
    if (e.editor && typeof e.editor.tabSize < "u") {
      const f = parseInt(e.editor.tabSize, 10);
      isNaN(f) || (n = f), n < 1 && (n = 1);
    }
    let i = "tabSize";
    if (e.editor && typeof e.editor.indentSize < "u" && e.editor.indentSize !== "tabSize") {
      const f = parseInt(e.editor.indentSize, 10);
      isNaN(f) || (i = Math.max(f, 1));
    }
    let s = Hr.insertSpaces;
    e.editor && typeof e.editor.insertSpaces < "u" && (s = e.editor.insertSpaces === "false" ? !1 : !!e.editor.insertSpaces);
    let o = hyt;
    const a = e.eol;
    a === `\r
` ? o = 2 : a === `
` && (o = 1);
    let l = Hr.trimAutoWhitespace;
    e.editor && typeof e.editor.trimAutoWhitespace < "u" && (l = e.editor.trimAutoWhitespace === "false" ? !1 : !!e.editor.trimAutoWhitespace);
    let c = Hr.detectIndentation;
    e.editor && typeof e.editor.detectIndentation < "u" && (c = e.editor.detectIndentation === "false" ? !1 : !!e.editor.detectIndentation);
    let d = Hr.largeFileOptimizations;
    e.editor && typeof e.editor.largeFileOptimizations < "u" && (d = e.editor.largeFileOptimizations === "false" ? !1 : !!e.editor.largeFileOptimizations);
    let u = Hr.bracketPairColorizationOptions;
    return e.editor?.bracketPairColorization && typeof e.editor.bracketPairColorization == "object" && (u = {
      enabled: !!e.editor.bracketPairColorization.enabled,
      independentColorPoolPerBracketType: !!e.editor.bracketPairColorization.independentColorPoolPerBracketType
    }), {
      isForSimpleWidget: t,
      tabSize: n,
      indentSize: i,
      insertSpaces: s,
      detectIndentation: c,
      defaultEOL: o,
      trimAutoWhitespace: l,
      largeFileOptimizations: d,
      bracketPairColorizationOptions: u
    };
  }
  _getEOL(e, t) {
    if (e)
      return this._resourcePropertiesService.getEOL(e, t);
    const n = this._configurationService.getValue("files.eol", { overrideIdentifier: t });
    return n && typeof n == "string" && n !== "auto" ? n : nl === 3 || nl === 2 ? `
` : `\r
`;
  }
  _shouldRestoreUndoStack() {
    const e = this._configurationService.getValue("files.restoreUndoStack");
    return typeof e == "boolean" ? e : !0;
  }
  getCreationOptions(e, t, n) {
    const i = typeof e == "string" ? e : e.languageId;
    let s = this._modelCreationOptionsByLanguageAndResource[i + t];
    if (!s) {
      const o = this._configurationService.getValue("editor", { overrideIdentifier: i, resource: t }), a = this._getEOL(t, i);
      s = H2._readModelOptions({ editor: o, eol: a }, n), this._modelCreationOptionsByLanguageAndResource[i + t] = s;
    }
    return s;
  }
  _updateModelOptions(e) {
    const t = this._modelCreationOptionsByLanguageAndResource;
    this._modelCreationOptionsByLanguageAndResource = /* @__PURE__ */ Object.create(null);
    const n = Object.keys(this._models);
    for (let i = 0, s = n.length; i < s; i++) {
      const o = n[i], a = this._models[o], l = a.model.getLanguageId(), c = a.model.uri;
      if (e && !e.affectsConfiguration("editor", { overrideIdentifier: l, resource: c }) && !e.affectsConfiguration("files.eol", { overrideIdentifier: l, resource: c }))
        continue;
      const d = t[l + c], u = this.getCreationOptions(l, c, a.model.isForSimpleWidget);
      H2._setModelOptionsForModel(a.model, u, d);
    }
  }
  static _setModelOptionsForModel(e, t, n) {
    n && n.defaultEOL !== t.defaultEOL && e.getLineCount() === 1 && e.setEOL(
      t.defaultEOL === 1 ? 0 : 1
      /* EndOfLineSequence.CRLF */
    ), !(n && n.detectIndentation === t.detectIndentation && n.insertSpaces === t.insertSpaces && n.tabSize === t.tabSize && n.indentSize === t.indentSize && n.trimAutoWhitespace === t.trimAutoWhitespace && Ho(n.bracketPairColorizationOptions, t.bracketPairColorizationOptions)) && (t.detectIndentation ? (e.detectIndentation(t.insertSpaces, t.tabSize), e.updateOptions({
      trimAutoWhitespace: t.trimAutoWhitespace,
      bracketColorizationOptions: t.bracketPairColorizationOptions
    })) : e.updateOptions({
      insertSpaces: t.insertSpaces,
      tabSize: t.tabSize,
      indentSize: t.indentSize,
      trimAutoWhitespace: t.trimAutoWhitespace,
      bracketColorizationOptions: t.bracketPairColorizationOptions
    }));
  }
  // --- begin IModelService
  _insertDisposedModel(e) {
    this._disposedModels.set(X1(e.uri), e), this._disposedModelsHeapSize += e.heapSize;
  }
  _removeDisposedModel(e) {
    const t = this._disposedModels.get(X1(e));
    return t && (this._disposedModelsHeapSize -= t.heapSize), this._disposedModels.delete(X1(e)), t;
  }
  _ensureDisposedModelsHeapSize(e) {
    if (this._disposedModelsHeapSize > e) {
      const t = [];
      for (this._disposedModels.forEach((n) => {
        n.sharesUndoRedoStack || t.push(n);
      }), t.sort((n, i) => n.time - i.time); t.length > 0 && this._disposedModelsHeapSize > e; ) {
        const n = t.shift();
        this._removeDisposedModel(n.uri), n.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(n.initialUndoRedoSnapshot);
      }
    }
  }
  _createModelData(e, t, n, i) {
    const s = this.getCreationOptions(t, n, i), o = new NL(e, t, s, n, this._undoRedoService, this._languageService, this._languageConfigurationService);
    if (n && this._disposedModels.has(X1(n))) {
      const c = this._removeDisposedModel(n), d = this._undoRedoService.getElements(n), u = this._getSHA1Computer(), f = u.canComputeSHA1(o) ? u.computeSHA1(o) === c.sha1 : !1;
      if (f || c.sharesUndoRedoStack) {
        for (const p of d.past)
          $h(p) && p.matchesResource(n) && p.setModel(o);
        for (const p of d.future)
          $h(p) && p.matchesResource(n) && p.setModel(o);
        this._undoRedoService.setElementsValidFlag(n, !0, (p) => $h(p) && p.matchesResource(n)), f && (o._overwriteVersionId(c.versionId), o._overwriteAlternativeVersionId(c.alternativeVersionId), o._overwriteInitialUndoRedoSnapshot(c.initialUndoRedoSnapshot));
      } else
        c.initialUndoRedoSnapshot !== null && this._undoRedoService.restoreSnapshot(c.initialUndoRedoSnapshot);
    }
    const a = X1(o.uri);
    if (this._models[a])
      throw new Error("ModelService: Cannot add model because it already exists!");
    const l = new cyt(o, (c) => this._onWillDispose(c), (c, d) => this._onDidChangeLanguage(c, d));
    return this._models[a] = l, l;
  }
  createModel(e, t, n, i = !1) {
    let s;
    return t ? s = this._createModelData(e, t, n, i) : s = this._createModelData(e, ll, n, i), this._onModelAdded.fire(s.model), s.model;
  }
  getModels() {
    const e = [], t = Object.keys(this._models);
    for (let n = 0, i = t.length; n < i; n++) {
      const s = t[n];
      e.push(this._models[s].model);
    }
    return e;
  }
  getModel(e) {
    const t = X1(e), n = this._models[t];
    return n ? n.model : null;
  }
  // --- end IModelService
  _schemaShouldMaintainUndoRedoElements(e) {
    return e.scheme === Ct.file || e.scheme === Ct.vscodeRemote || e.scheme === Ct.vscodeUserData || e.scheme === Ct.vscodeNotebookCell || e.scheme === "fake-fs";
  }
  _onWillDispose(e) {
    const t = X1(e.uri), n = this._models[t], i = this._undoRedoService.getUriComparisonKey(e.uri) !== e.uri.toString();
    let s = !1, o = 0;
    if (i || this._shouldRestoreUndoStack() && this._schemaShouldMaintainUndoRedoElements(e.uri)) {
      const c = this._undoRedoService.getElements(e.uri);
      if (c.past.length > 0 || c.future.length > 0) {
        for (const d of c.past)
          $h(d) && d.matchesResource(e.uri) && (s = !0, o += d.heapSize(e.uri), d.setModel(e.uri));
        for (const d of c.future)
          $h(d) && d.matchesResource(e.uri) && (s = !0, o += d.heapSize(e.uri), d.setModel(e.uri));
      }
    }
    const a = H2.MAX_MEMORY_FOR_CLOSED_FILES_UNDO_STACK, l = this._getSHA1Computer();
    if (s)
      if (!i && (o > a || !l.canComputeSHA1(e))) {
        const c = n.model.getInitialUndoRedoSnapshot();
        c !== null && this._undoRedoService.restoreSnapshot(c);
      } else
        this._ensureDisposedModelsHeapSize(a - o), this._undoRedoService.setElementsValidFlag(e.uri, !1, (c) => $h(c) && c.matchesResource(e.uri)), this._insertDisposedModel(new dyt(e.uri, n.model.getInitialUndoRedoSnapshot(), Date.now(), i, o, l.computeSHA1(e), e.getVersionId(), e.getAlternativeVersionId()));
    else if (!i) {
      const c = n.model.getInitialUndoRedoSnapshot();
      c !== null && this._undoRedoService.restoreSnapshot(c);
    }
    delete this._models[t], n.dispose(), delete this._modelCreationOptionsByLanguageAndResource[e.getLanguageId() + e.uri], this._onModelRemoved.fire(e);
  }
  _onDidChangeLanguage(e, t) {
    const n = t.oldLanguage, i = e.getLanguageId(), s = this.getCreationOptions(n, e.uri, e.isForSimpleWidget), o = this.getCreationOptions(i, e.uri, e.isForSimpleWidget);
    H2._setModelOptionsForModel(e, o, s), this._onModelModeChanged.fire({ model: e, oldLanguageId: n });
  }
  _getSHA1Computer() {
    return new _R();
  }
};
vk = H2 = lyt([
  Zm(0, Ai),
  Zm(1, gLe),
  Zm(2, JO),
  Zm(3, sr),
  Zm(4, xh)
], vk);
class _R {
  static {
    this.MAX_MODEL_SIZE = 10 * 1024 * 1024;
  }
  // takes 200ms to compute a sha1 on a 10MB model on a new machine
  canComputeSHA1(e) {
    return e.getValueLength() <= _R.MAX_MODEL_SIZE;
  }
  computeSHA1(e) {
    const t = new UI(), n = e.createSnapshot();
    let i;
    for (; i = n.read(); )
      t.update(i);
    return t.digest();
  }
}
var bk;
(function(r) {
  r[r.PRESERVE = 0] = "PRESERVE", r[r.LAST = 1] = "LAST";
})(bk || (bk = {}));
const FNe = {
  Quickaccess: "workbench.contributions.quickaccess"
};
class uyt {
  constructor() {
    this.providers = [], this.defaultProvider = void 0;
  }
  registerQuickAccessProvider(e) {
    return e.prefix.length === 0 ? this.defaultProvider = e : this.providers.push(e), this.providers.sort((t, n) => n.prefix.length - t.prefix.length), ht(() => {
      this.providers.splice(this.providers.indexOf(e), 1), this.defaultProvider === e && (this.defaultProvider = void 0);
    });
  }
  getQuickAccessProviders() {
    return xMe([this.defaultProvider, ...this.providers]);
  }
  getQuickAccessProvider(e) {
    return e && this.providers.find((n) => e.startsWith(n.prefix)) || void 0 || this.defaultProvider;
  }
}
Er.add(FNe.Quickaccess, new uyt());
const fyt = { ctrlCmd: !1, alt: !1 };
var bg;
(function(r) {
  r[r.Blur = 1] = "Blur", r[r.Gesture = 2] = "Gesture", r[r.Other = 3] = "Other";
})(bg || (bg = {}));
var zc;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.FIRST = 1] = "FIRST", r[r.SECOND = 2] = "SECOND", r[r.LAST = 3] = "LAST";
})(zc || (zc = {}));
var Ln;
(function(r) {
  r[r.First = 1] = "First", r[r.Second = 2] = "Second", r[r.Last = 3] = "Last", r[r.Next = 4] = "Next", r[r.Previous = 5] = "Previous", r[r.NextPage = 6] = "NextPage", r[r.PreviousPage = 7] = "PreviousPage", r[r.NextSeparator = 8] = "NextSeparator", r[r.PreviousSeparator = 9] = "PreviousSeparator";
})(Ln || (Ln = {}));
var j9;
(function(r) {
  r[r.Title = 1] = "Title", r[r.Inline = 2] = "Inline";
})(j9 || (j9 = {}));
const Bw = Wt("quickInputService");
var pyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, p9e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let yk = class extends me {
  constructor(e, t) {
    super(), this.quickInputService = e, this.instantiationService = t, this.registry = Er.as(FNe.Quickaccess), this.mapProviderToDescriptor = /* @__PURE__ */ new Map(), this.lastAcceptedPickerValues = /* @__PURE__ */ new Map(), this.visibleQuickAccess = void 0;
  }
  show(e = "", t) {
    this.doShowOrPick(e, !1, t);
  }
  doShowOrPick(e, t, n) {
    const [i, s] = this.getOrInstantiateProvider(e, n?.enabledProviderPrefixes), o = this.visibleQuickAccess, a = o?.descriptor;
    if (o && s && a === s) {
      e !== s.prefix && !n?.preserveValue && (o.picker.value = e), this.adjustValueSelection(o.picker, s, n);
      return;
    }
    if (s && !n?.preserveValue) {
      let g;
      if (o && a && a !== s) {
        const m = o.value.substr(a.prefix.length);
        m && (g = `${s.prefix}${m}`);
      }
      if (!g) {
        const m = i?.defaultFilterValue;
        m === bk.LAST ? g = this.lastAcceptedPickerValues.get(s) : typeof m == "string" && (g = `${s.prefix}${m}`);
      }
      typeof g == "string" && (e = g);
    }
    const l = o?.picker?.valueSelection, c = o?.picker?.value, d = new ze(), u = d.add(this.quickInputService.createQuickPick());
    u.value = e, this.adjustValueSelection(u, s, n), u.placeholder = n?.placeholder ?? s?.placeholder, u.quickNavigate = n?.quickNavigateConfiguration, u.hideInput = !!u.quickNavigate && !o, (typeof n?.itemActivation == "number" || n?.quickNavigateConfiguration) && (u.itemActivation = n?.itemActivation ?? zc.SECOND), u.contextKey = s?.contextKey, u.filterValue = (g) => g.substring(s ? s.prefix.length : 0);
    let f;
    t && (f = new pDe(), d.add(xe.once(u.onWillAccept)((g) => {
      g.veto(), u.hide();
    }))), d.add(this.registerPickerListeners(u, i, s, e, n));
    const p = d.add(new Jg());
    if (i && d.add(i.provide(u, p.token, n?.providerOptions)), xe.once(u.onDidHide)(() => {
      u.selectedItems.length === 0 && p.cancel(), d.dispose(), f?.complete(u.selectedItems.slice(0));
    }), u.show(), l && c === e && (u.valueSelection = l), t)
      return f?.p;
  }
  adjustValueSelection(e, t, n) {
    let i;
    n?.preserveValue ? i = [e.value.length, e.value.length] : i = [t?.prefix.length ?? 0, e.value.length], e.valueSelection = i;
  }
  registerPickerListeners(e, t, n, i, s) {
    const o = new ze(), a = this.visibleQuickAccess = { picker: e, descriptor: n, value: i };
    return o.add(ht(() => {
      a === this.visibleQuickAccess && (this.visibleQuickAccess = void 0);
    })), o.add(e.onDidChangeValue((l) => {
      const [c] = this.getOrInstantiateProvider(l, s?.enabledProviderPrefixes);
      c !== t ? this.show(l, {
        enabledProviderPrefixes: s?.enabledProviderPrefixes,
        // do not rewrite value from user typing!
        preserveValue: !0,
        // persist the value of the providerOptions from the original showing
        providerOptions: s?.providerOptions
      }) : a.value = l;
    })), n && o.add(e.onDidAccept(() => {
      this.lastAcceptedPickerValues.set(n, e.value);
    })), o;
  }
  getOrInstantiateProvider(e, t) {
    const n = this.registry.getQuickAccessProvider(e);
    if (!n || t && !t?.includes(n.prefix))
      return [void 0, void 0];
    let i = this.mapProviderToDescriptor.get(n);
    return i || (i = this.instantiationService.createInstance(n.ctor), this.mapProviderToDescriptor.set(n, i)), [i, n];
  }
};
yk = pyt([
  p9e(0, Bw),
  p9e(1, xn)
], yk);
class cm extends xa {
  constructor(e) {
    super(), this._onChange = this._register(new $()), this.onChange = this._onChange.event, this._onKeyDown = this._register(new $()), this.onKeyDown = this._onKeyDown.event, this._opts = e, this._checked = this._opts.isChecked;
    const t = ["monaco-custom-toggle"];
    this._opts.icon && (this._icon = this._opts.icon, t.push(...Tt.asClassNameArray(this._icon))), this._opts.actionClassName && t.push(...this._opts.actionClassName.split(" ")), this._checked && t.push("checked"), this.domNode = document.createElement("div"), this._hover = this._register(Mh().setupManagedHover(e.hoverDelegate ?? fo("mouse"), this.domNode, this._opts.title)), this.domNode.classList.add(...t), this._opts.notFocusable || (this.domNode.tabIndex = 0), this.domNode.setAttribute("role", "checkbox"), this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.setAttribute("aria-label", this._opts.title), this.applyStyles(), this.onclick(this.domNode, (n) => {
      this.enabled && (this.checked = !this._checked, this._onChange.fire(!1), n.preventDefault());
    }), this._register(this.ignoreGesture(this.domNode)), this.onkeydown(this.domNode, (n) => {
      if (n.keyCode === 10 || n.keyCode === 3) {
        this.checked = !this._checked, this._onChange.fire(!0), n.preventDefault(), n.stopPropagation();
        return;
      }
      this._onKeyDown.fire(n);
    });
  }
  get enabled() {
    return this.domNode.getAttribute("aria-disabled") !== "true";
  }
  focus() {
    this.domNode.focus();
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    this._checked = e, this.domNode.setAttribute("aria-checked", String(this._checked)), this.domNode.classList.toggle("checked", this._checked), this.applyStyles();
  }
  width() {
    return 22;
  }
  applyStyles() {
    this.domNode && (this.domNode.style.borderColor = this._checked && this._opts.inputActiveOptionBorder || "", this.domNode.style.color = this._checked && this._opts.inputActiveOptionForeground || "inherit", this.domNode.style.backgroundColor = this._checked && this._opts.inputActiveOptionBackground || "");
  }
  enable() {
    this.domNode.setAttribute("aria-disabled", String(!1));
  }
  disable() {
    this.domNode.setAttribute("aria-disabled", String(!0));
  }
}
var gyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
};
class zNe {
  constructor(e) {
    this.nodes = e;
  }
  toString() {
    return this.nodes.map((e) => typeof e == "string" ? e : e.label).join("");
  }
}
gyt([
  wi
], zNe.prototype, "toString", null);
const myt = /\[([^\]]+)\]\(((?:https?:\/\/|command:|file:)[^\)\s]+)(?: (["'])(.+?)(\3))?\)/gi;
function Ayt(r) {
  const e = [];
  let t = 0, n;
  for (; n = myt.exec(r); ) {
    n.index - t > 0 && e.push(r.substring(t, n.index));
    const [, i, s, , o] = n;
    o ? e.push({ label: i, href: s, title: o }) : e.push({ label: i, href: s }), t = n.index + n[0].length;
  }
  return t < r.length && e.push(r.substring(t)), new zNe(e);
}
const C_ = {}, wyt = new mNe("quick-input-button-icon-");
function vyt(r) {
  if (!r)
    return;
  let e;
  const t = r.dark.toString();
  return C_[t] ? e = C_[t] : (e = wyt.nextId(), FD(`.${e}, .hc-light .${e}`, `background-image: ${Pd(r.light || r.dark)}`), FD(`.vs-dark .${e}, .hc-black .${e}`, `background-image: ${Pd(r.dark)}`), C_[t] = e), e;
}
function a3(r, e, t) {
  let n = r.iconClass || vyt(r.iconPath);
  return r.alwaysVisible && (n = n ? `${n} always-visible` : "always-visible"), {
    id: e,
    label: "",
    tooltip: r.tooltip || "",
    class: n,
    enabled: !0,
    run: t
  };
}
function byt(r, e, t) {
  ys(e);
  const n = Ayt(r);
  let i = 0;
  for (const s of n.nodes)
    if (typeof s == "string")
      e.append(...X0(s));
    else {
      let o = s.title;
      !o && s.href.startsWith("command:") ? o = C("executeCommand", "Click to execute command '{0}'", s.href.substring(8)) : o || (o = s.href);
      const a = $e("a", { href: s.href, title: o, tabIndex: i++ }, s.label);
      a.style.textDecoration = "underline";
      const l = (p) => {
        Hft(p) && Lt.stop(p, !0), t.callback(s.href);
      }, c = t.disposables.add(new St(a, Se.CLICK)).event, d = t.disposables.add(new St(a, Se.KEY_DOWN)).event, u = xe.chain(d, (p) => p.filter((g) => {
        const m = new zn(g);
        return m.equals(
          10
          /* KeyCode.Space */
        ) || m.equals(
          3
          /* KeyCode.Enter */
        );
      }));
      t.disposables.add(Xn.addTarget(a));
      const f = t.disposables.add(new St(a, Nn.Tap)).event;
      xe.any(c, f, u)(l, null, t.disposables), e.appendChild(a);
    }
}
var yyt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, g9e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const WNe = "inQuickInput", Cyt = new Ve(WNe, !1, C("inQuickInput", "Whether keyboard focus is inside the quick input control")), Eyt = mt.has(WNe), jNe = "quickInputType", _yt = new Ve(jNe, void 0, C("quickInputType", "The type of the currently visible quick input")), ZNe = "cursorAtEndOfQuickInputBox", xyt = new Ve(ZNe, !1, C("cursorAtEndOfQuickInputBox", "Whether the cursor in the quick input is at the end of the input box")), Syt = mt.has(ZNe), Ck = {
  iconClass: Tt.asClassName(ke.quickInputBack),
  tooltip: C("quickInput.back", "Back")
};
class Ny extends me {
  static {
    this.noPromptMessage = C("inputModeEntry", "Press 'Enter' to confirm your input or 'Escape' to cancel");
  }
  constructor(e) {
    super(), this.ui = e, this._widgetUpdated = !1, this.visible = !1, this._enabled = !0, this._busy = !1, this._ignoreFocusOut = !1, this._leftButtons = [], this._rightButtons = [], this._inlineButtons = [], this.buttonsUpdated = !1, this._toggles = [], this.togglesUpdated = !1, this.noValidationMessage = Ny.noPromptMessage, this._severity = Oi.Ignore, this.onDidTriggerButtonEmitter = this._register(new $()), this.onDidHideEmitter = this._register(new $()), this.onWillHideEmitter = this._register(new $()), this.onDisposeEmitter = this._register(new $()), this.visibleDisposables = this._register(new ze()), this.onDidHide = this.onDidHideEmitter.event;
  }
  get title() {
    return this._title;
  }
  set title(e) {
    this._title = e, this.update();
  }
  get description() {
    return this._description;
  }
  set description(e) {
    this._description = e, this.update();
  }
  get step() {
    return this._steps;
  }
  set step(e) {
    this._steps = e, this.update();
  }
  get totalSteps() {
    return this._totalSteps;
  }
  set totalSteps(e) {
    this._totalSteps = e, this.update();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(e) {
    this._enabled = e, this.update();
  }
  get contextKey() {
    return this._contextKey;
  }
  set contextKey(e) {
    this._contextKey = e, this.update();
  }
  get busy() {
    return this._busy;
  }
  set busy(e) {
    this._busy = e, this.update();
  }
  get ignoreFocusOut() {
    return this._ignoreFocusOut;
  }
  set ignoreFocusOut(e) {
    const t = this._ignoreFocusOut !== e && !pf;
    this._ignoreFocusOut = e && !pf, t && this.update();
  }
  get titleButtons() {
    return this._leftButtons.length ? [...this._leftButtons, this._rightButtons] : this._rightButtons;
  }
  get buttons() {
    return [
      ...this._leftButtons,
      ...this._rightButtons,
      ...this._inlineButtons
    ];
  }
  set buttons(e) {
    this._leftButtons = e.filter((t) => t === Ck), this._rightButtons = e.filter((t) => t !== Ck && t.location !== j9.Inline), this._inlineButtons = e.filter((t) => t.location === j9.Inline), this.buttonsUpdated = !0, this.update();
  }
  get toggles() {
    return this._toggles;
  }
  set toggles(e) {
    this._toggles = e ?? [], this.togglesUpdated = !0, this.update();
  }
  get validationMessage() {
    return this._validationMessage;
  }
  set validationMessage(e) {
    this._validationMessage = e, this.update();
  }
  get severity() {
    return this._severity;
  }
  set severity(e) {
    this._severity = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.onDidTriggerButton((e) => {
      this.buttons.indexOf(e) !== -1 && this.onDidTriggerButtonEmitter.fire(e);
    })), this.ui.show(this), this.visible = !0, this._lastValidationMessage = void 0, this._lastSeverity = void 0, this.buttons.length && (this.buttonsUpdated = !0), this.toggles.length && (this.togglesUpdated = !0), this.update());
  }
  hide() {
    this.visible && this.ui.hide();
  }
  didHide(e = bg.Other) {
    this.visible = !1, this.visibleDisposables.clear(), this.onDidHideEmitter.fire({ reason: e });
  }
  willHide(e = bg.Other) {
    this.onWillHideEmitter.fire({ reason: e });
  }
  update() {
    if (!this.visible)
      return;
    const e = this.getTitle();
    e && this.ui.title.textContent !== e ? this.ui.title.textContent = e : !e && this.ui.title.innerHTML !== "&nbsp;" && (this.ui.title.innerText = " ");
    const t = this.getDescription();
    if (this.ui.description1.textContent !== t && (this.ui.description1.textContent = t), this.ui.description2.textContent !== t && (this.ui.description2.textContent = t), this._widgetUpdated && (this._widgetUpdated = !1, this._widget ? ys(this.ui.widget, this._widget) : ys(this.ui.widget)), this.busy && !this.busyDelay && (this.busyDelay = new T1(), this.busyDelay.setIfNotSet(() => {
      this.visible && this.ui.progressBar.infinite();
    }, 800)), !this.busy && this.busyDelay && (this.ui.progressBar.stop(), this.busyDelay.cancel(), this.busyDelay = void 0), this.buttonsUpdated) {
      this.buttonsUpdated = !1, this.ui.leftActionBar.clear();
      const i = this._leftButtons.map((a, l) => a3(a, `id-${l}`, async () => this.onDidTriggerButtonEmitter.fire(a)));
      this.ui.leftActionBar.push(i, { icon: !0, label: !1 }), this.ui.rightActionBar.clear();
      const s = this._rightButtons.map((a, l) => a3(a, `id-${l}`, async () => this.onDidTriggerButtonEmitter.fire(a)));
      this.ui.rightActionBar.push(s, { icon: !0, label: !1 }), this.ui.inlineActionBar.clear();
      const o = this._inlineButtons.map((a, l) => a3(a, `id-${l}`, async () => this.onDidTriggerButtonEmitter.fire(a)));
      this.ui.inlineActionBar.push(o, { icon: !0, label: !1 });
    }
    if (this.togglesUpdated) {
      this.togglesUpdated = !1;
      const i = this.toggles?.filter((s) => s instanceof cm) ?? [];
      this.ui.inputBox.toggles = i;
    }
    this.ui.ignoreFocusOut = this.ignoreFocusOut, this.ui.setEnabled(this.enabled), this.ui.setContextKey(this.contextKey);
    const n = this.validationMessage || this.noValidationMessage;
    this._lastValidationMessage !== n && (this._lastValidationMessage = n, ys(this.ui.message), byt(n, this.ui.message, {
      callback: (i) => {
        this.ui.linkOpenerDelegate(i);
      },
      disposables: this.visibleDisposables
    })), this._lastSeverity !== this.severity && (this._lastSeverity = this.severity, this.showMessageDecoration(this.severity));
  }
  getTitle() {
    return this.title && this.step ? `${this.title} (${this.getSteps()})` : this.title ? this.title : this.step ? this.getSteps() : "";
  }
  getDescription() {
    return this.description || "";
  }
  getSteps() {
    return this.step && this.totalSteps ? C("quickInput.steps", "{0}/{1}", this.step, this.totalSteps) : this.step ? String(this.step) : "";
  }
  showMessageDecoration(e) {
    if (this.ui.inputBox.showDecoration(e), e !== Oi.Ignore) {
      const t = this.ui.inputBox.stylesForType(e);
      this.ui.message.style.color = t.foreground ? `${t.foreground}` : "", this.ui.message.style.backgroundColor = t.background ? `${t.background}` : "", this.ui.message.style.border = t.border ? `1px solid ${t.border}` : "", this.ui.message.style.marginBottom = "-2px";
    } else
      this.ui.message.style.color = "", this.ui.message.style.backgroundColor = "", this.ui.message.style.border = "", this.ui.message.style.marginBottom = "";
  }
  dispose() {
    this.hide(), this.onDisposeEmitter.fire(), super.dispose();
  }
}
class Z9 extends Ny {
  constructor() {
    super(...arguments), this._value = "", this.onDidChangeValueEmitter = this._register(new $()), this.onWillAcceptEmitter = this._register(new $()), this.onDidAcceptEmitter = this._register(new $()), this.onDidCustomEmitter = this._register(new $()), this._items = [], this.itemsUpdated = !1, this._canSelectMany = !1, this._canAcceptInBackground = !1, this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._keepScrollPosition = !1, this._itemActivation = zc.FIRST, this._activeItems = [], this.activeItemsUpdated = !1, this.activeItemsToConfirm = [], this.onDidChangeActiveEmitter = this._register(new $()), this._selectedItems = [], this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = [], this.onDidChangeSelectionEmitter = this._register(new $()), this.onDidTriggerItemButtonEmitter = this._register(new $()), this.onDidTriggerSeparatorButtonEmitter = this._register(new $()), this.valueSelectionUpdated = !0, this._ok = "default", this._customButton = !1, this._focusEventBufferer = new Aw(), this.type = "quickPick", this.filterValue = (e) => e, this.onDidChangeValue = this.onDidChangeValueEmitter.event, this.onWillAccept = this.onWillAcceptEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event, this.onDidChangeActive = this.onDidChangeActiveEmitter.event, this.onDidChangeSelection = this.onDidChangeSelectionEmitter.event, this.onDidTriggerItemButton = this.onDidTriggerItemButtonEmitter.event, this.onDidTriggerSeparatorButton = this.onDidTriggerSeparatorButtonEmitter.event;
  }
  static {
    this.DEFAULT_ARIA_LABEL = C("quickInputBox.ariaLabel", "Type to narrow down results.");
  }
  get quickNavigate() {
    return this._quickNavigate;
  }
  set quickNavigate(e) {
    this._quickNavigate = e, this.update();
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.doSetValue(e);
  }
  doSetValue(e, t) {
    this._value !== e && (this._value = e, t || this.update(), this.visible && this.ui.list.filter(this.filterValue(this._value)) && this.trySelectFirst(), this.onDidChangeValueEmitter.fire(this._value));
  }
  set ariaLabel(e) {
    this._ariaLabel = e, this.update();
  }
  get ariaLabel() {
    return this._ariaLabel;
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get items() {
    return this._items;
  }
  get scrollTop() {
    return this.ui.list.scrollTop;
  }
  set scrollTop(e) {
    this.ui.list.scrollTop = e;
  }
  set items(e) {
    this._items = e, this.itemsUpdated = !0, this.update();
  }
  get canSelectMany() {
    return this._canSelectMany;
  }
  set canSelectMany(e) {
    this._canSelectMany = e, this.update();
  }
  get canAcceptInBackground() {
    return this._canAcceptInBackground;
  }
  set canAcceptInBackground(e) {
    this._canAcceptInBackground = e;
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(e) {
    this._matchOnDescription = e, this.update();
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(e) {
    this._matchOnDetail = e, this.update();
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(e) {
    this._matchOnLabel = e, this.update();
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(e) {
    this._matchOnLabelMode = e, this.update();
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(e) {
    this._sortByLabel = e, this.update();
  }
  get keepScrollPosition() {
    return this._keepScrollPosition;
  }
  set keepScrollPosition(e) {
    this._keepScrollPosition = e;
  }
  get itemActivation() {
    return this._itemActivation;
  }
  set itemActivation(e) {
    this._itemActivation = e;
  }
  get activeItems() {
    return this._activeItems;
  }
  set activeItems(e) {
    this._activeItems = e, this.activeItemsUpdated = !0, this.update();
  }
  get selectedItems() {
    return this._selectedItems;
  }
  set selectedItems(e) {
    this._selectedItems = e, this.selectedItemsUpdated = !0, this.update();
  }
  get keyMods() {
    return this._quickNavigate ? fyt : this.ui.keyMods;
  }
  get valueSelection() {
    const e = this.ui.inputBox.getSelection();
    if (e)
      return [e.start, e.end];
  }
  set valueSelection(e) {
    this._valueSelection = e, this.valueSelectionUpdated = !0, this.update();
  }
  get customButton() {
    return this._customButton;
  }
  set customButton(e) {
    this._customButton = e, this.update();
  }
  get customLabel() {
    return this._customButtonLabel;
  }
  set customLabel(e) {
    this._customButtonLabel = e, this.update();
  }
  get customHover() {
    return this._customButtonHover;
  }
  set customHover(e) {
    this._customButtonHover = e, this.update();
  }
  get ok() {
    return this._ok;
  }
  set ok(e) {
    this._ok = e, this.update();
  }
  get hideInput() {
    return !!this._hideInput;
  }
  set hideInput(e) {
    this._hideInput = e, this.update();
  }
  trySelectFirst() {
    this.canSelectMany || this.ui.list.focus(Ln.First);
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      this.doSetValue(
        e,
        !0
        /* skip update since this originates from the UI */
      );
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => {
      this.canSelectMany ? this.ui.list.getCheckedElements().length || (this._selectedItems = [], this.onDidChangeSelectionEmitter.fire(this.selectedItems)) : this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems)), this.handleAccept(!1);
    })), this.visibleDisposables.add(this.ui.onDidCustom(() => {
      this.onDidCustomEmitter.fire();
    })), this.visibleDisposables.add(this._focusEventBufferer.wrapEvent(
      this.ui.list.onDidChangeFocus,
      // Only fire the last event
      (e, t) => t
    )((e) => {
      this.activeItemsUpdated || this.activeItemsToConfirm !== this._activeItems && Zi(e, this._activeItems, (t, n) => t === n) || (this._activeItems = e, this.onDidChangeActiveEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.list.onDidChangeSelection(({ items: e, event: t }) => {
      if (this.canSelectMany) {
        e.length && this.ui.list.setSelectedElements([]);
        return;
      }
      this.selectedItemsToConfirm !== this._selectedItems && Zi(e, this._selectedItems, (n, i) => n === i) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e), e.length && this.handleAccept(
        QI(t) && t.button === 1
        /* mouse middle click */
      ));
    })), this.visibleDisposables.add(this.ui.list.onChangedCheckedElements((e) => {
      !this.canSelectMany || !this.visible || this.selectedItemsToConfirm !== this._selectedItems && Zi(e, this._selectedItems, (t, n) => t === n) || (this._selectedItems = e, this.onDidChangeSelectionEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.list.onButtonTriggered((e) => this.onDidTriggerItemButtonEmitter.fire(e))), this.visibleDisposables.add(this.ui.list.onSeparatorButtonTriggered((e) => this.onDidTriggerSeparatorButtonEmitter.fire(e))), this.visibleDisposables.add(this.registerQuickNavigation()), this.valueSelectionUpdated = !0), super.show();
  }
  handleAccept(e) {
    let t = !1;
    this.onWillAcceptEmitter.fire({ veto: () => t = !0 }), t || this.onDidAcceptEmitter.fire({ inBackground: e });
  }
  registerQuickNavigation() {
    return fe(this.ui.container, Se.KEY_UP, (e) => {
      if (this.canSelectMany || !this._quickNavigate)
        return;
      const t = new zn(e), n = t.keyCode;
      this._quickNavigate.keybindings.some((o) => {
        const a = o.getChords();
        return a.length > 1 ? !1 : a[0].shiftKey && n === 4 ? !(t.ctrlKey || t.altKey || t.metaKey) : !!(a[0].altKey && n === 6 || a[0].ctrlKey && n === 5 || a[0].metaKey && n === 57);
      }) && (this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(!1)), this._quickNavigate = void 0);
    });
  }
  update() {
    if (!this.visible)
      return;
    const e = this.keepScrollPosition ? this.scrollTop : 0, t = !!this.description, n = {
      title: !!this.title || !!this.step || !!this.titleButtons.length,
      description: t,
      checkAll: this.canSelectMany && !this._hideCheckAll,
      checkBox: this.canSelectMany,
      inputBox: !this._hideInput,
      progressBar: !this._hideInput || t,
      visibleCount: !0,
      count: this.canSelectMany && !this._hideCountBadge,
      ok: this.ok === "default" ? this.canSelectMany : this.ok,
      list: !0,
      message: !!this.validationMessage,
      customButton: this.customButton
    };
    this.ui.setVisibilities(n), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || "");
    let i = this.ariaLabel;
    !i && n.inputBox && (i = this.placeholder || Z9.DEFAULT_ARIA_LABEL, this.title && (i += ` - ${this.title}`)), this.ui.list.ariaLabel !== i && (this.ui.list.ariaLabel = i ?? null), this.ui.list.matchOnDescription = this.matchOnDescription, this.ui.list.matchOnDetail = this.matchOnDetail, this.ui.list.matchOnLabel = this.matchOnLabel, this.ui.list.matchOnLabelMode = this.matchOnLabelMode, this.ui.list.sortByLabel = this.sortByLabel, this.itemsUpdated && (this.itemsUpdated = !1, this._focusEventBufferer.bufferEvents(() => {
      switch (this.ui.list.setElements(this.items), this.ui.list.shouldLoop = !this.canSelectMany, this.ui.list.filter(this.filterValue(this.ui.inputBox.value)), this._itemActivation) {
        case zc.NONE:
          this._itemActivation = zc.FIRST;
          break;
        case zc.SECOND:
          this.ui.list.focus(Ln.Second), this._itemActivation = zc.FIRST;
          break;
        case zc.LAST:
          this.ui.list.focus(Ln.Last), this._itemActivation = zc.FIRST;
          break;
        default:
          this.trySelectFirst();
          break;
      }
    })), this.ui.container.classList.contains("show-checkboxes") !== !!this.canSelectMany && (this.canSelectMany ? this.ui.list.clearFocus() : this.trySelectFirst()), this.activeItemsUpdated && (this.activeItemsUpdated = !1, this.activeItemsToConfirm = this._activeItems, this.ui.list.setFocusedElements(this.activeItems), this.activeItemsToConfirm === this._activeItems && (this.activeItemsToConfirm = null)), this.selectedItemsUpdated && (this.selectedItemsUpdated = !1, this.selectedItemsToConfirm = this._selectedItems, this.canSelectMany ? this.ui.list.setCheckedElements(this.selectedItems) : this.ui.list.setSelectedElements(this.selectedItems), this.selectedItemsToConfirm === this._selectedItems && (this.selectedItemsToConfirm = null)), this.ui.customButton.label = this.customLabel || "", this.ui.customButton.element.title = this.customHover || "", n.inputBox || (this.ui.list.domFocus(), this.canSelectMany && this.ui.list.focus(Ln.First)), this.keepScrollPosition && (this.scrollTop = e);
  }
  focus(e) {
    this.ui.list.focus(e), this.canSelectMany && this.ui.list.domFocus();
  }
  accept(e) {
    e && !this._canAcceptInBackground || this.activeItems[0] && (this._selectedItems = [this.activeItems[0]], this.onDidChangeSelectionEmitter.fire(this.selectedItems), this.handleAccept(e ?? !1));
  }
}
let Myt = class extends Ny {
  constructor() {
    super(...arguments), this._value = "", this.valueSelectionUpdated = !0, this._password = !1, this.onDidValueChangeEmitter = this._register(new $()), this.onDidAcceptEmitter = this._register(new $()), this.type = "inputBox", this.onDidChangeValue = this.onDidValueChangeEmitter.event, this.onDidAccept = this.onDidAcceptEmitter.event;
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this._value = e || "", this.update();
  }
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(e) {
    this._placeholder = e, this.update();
  }
  get password() {
    return this._password;
  }
  set password(e) {
    this._password = e, this.update();
  }
  show() {
    this.visible || (this.visibleDisposables.add(this.ui.inputBox.onDidChange((e) => {
      e !== this.value && (this._value = e, this.onDidValueChangeEmitter.fire(e));
    })), this.visibleDisposables.add(this.ui.onDidAccept(() => this.onDidAcceptEmitter.fire())), this.valueSelectionUpdated = !0), super.show();
  }
  update() {
    if (!this.visible)
      return;
    this.ui.container.classList.remove("hidden-input");
    const e = {
      title: !!this.title || !!this.step || !!this.titleButtons.length,
      description: !!this.description || !!this.step,
      inputBox: !0,
      message: !0,
      progressBar: !0
    };
    this.ui.setVisibilities(e), super.update(), this.ui.inputBox.value !== this.value && (this.ui.inputBox.value = this.value), this.valueSelectionUpdated && (this.valueSelectionUpdated = !1, this.ui.inputBox.select(this._valueSelection && { start: this._valueSelection[0], end: this._valueSelection[1] })), this.ui.inputBox.placeholder !== (this.placeholder || "") && (this.ui.inputBox.placeholder = this.placeholder || ""), this.ui.inputBox.password !== this.password && (this.ui.inputBox.password = this.password);
  }
}, Ek = class extends s4 {
  constructor(e, t) {
    super("element", !1, (n) => this.getOverrideOptions(n), e, t);
  }
  getOverrideOptions(e) {
    const t = (wr(e.content) ? e.content.textContent ?? "" : typeof e.content == "string" ? e.content : e.content.value).includes(`
`);
    return {
      persistence: {
        hideOnKeyDown: !1
      },
      appearance: {
        showHoverHint: t,
        skipFadeInAnimation: !0
      }
    };
  }
};
Ek = yyt([
  g9e(0, Ai),
  g9e(1, i2)
], Ek);
ge.white.toString(), ge.white.toString();
let _k = class extends me {
  get onDidClick() {
    return this._onDidClick.event;
  }
  constructor(e, t) {
    super(), this._label = "", this._onDidClick = this._register(new $()), this._onDidEscape = this._register(new $()), this.options = t, this._element = document.createElement("a"), this._element.classList.add("monaco-button"), this._element.tabIndex = 0, this._element.setAttribute("role", "button"), this._element.classList.toggle("secondary", !!t.secondary);
    const n = t.secondary ? t.buttonSecondaryBackground : t.buttonBackground, i = t.secondary ? t.buttonSecondaryForeground : t.buttonForeground;
    this._element.style.color = i || "", this._element.style.backgroundColor = n || "", t.supportShortLabel && (this._labelShortElement = document.createElement("div"), this._labelShortElement.classList.add("monaco-button-label-short"), this._element.appendChild(this._labelShortElement), this._labelElement = document.createElement("div"), this._labelElement.classList.add("monaco-button-label"), this._element.appendChild(this._labelElement), this._element.classList.add("monaco-text-button-with-short-label")), typeof t.title == "string" && this.setTitle(t.title), typeof t.ariaLabel == "string" && this._element.setAttribute("aria-label", t.ariaLabel), e.appendChild(this._element), this._register(Xn.addTarget(this._element)), [Se.CLICK, Nn.Tap].forEach((s) => {
      this._register(fe(this._element, s, (o) => {
        if (!this.enabled) {
          Lt.stop(o);
          return;
        }
        this._onDidClick.fire(o);
      }));
    }), this._register(fe(this._element, Se.KEY_DOWN, (s) => {
      const o = new zn(s);
      let a = !1;
      this.enabled && (o.equals(
        3
        /* KeyCode.Enter */
      ) || o.equals(
        10
        /* KeyCode.Space */
      )) ? (this._onDidClick.fire(s), a = !0) : o.equals(
        9
        /* KeyCode.Escape */
      ) && (this._onDidEscape.fire(s), this._element.blur(), a = !0), a && Lt.stop(o, !0);
    })), this._register(fe(this._element, Se.MOUSE_OVER, (s) => {
      this._element.classList.contains("disabled") || this.updateBackground(!0);
    })), this._register(fe(this._element, Se.MOUSE_OUT, (s) => {
      this.updateBackground(!1);
    })), this.focusTracker = this._register(Af(this._element)), this._register(this.focusTracker.onDidFocus(() => {
      this.enabled && this.updateBackground(!0);
    })), this._register(this.focusTracker.onDidBlur(() => {
      this.enabled && this.updateBackground(!1);
    }));
  }
  dispose() {
    super.dispose(), this._element.remove();
  }
  getContentElements(e) {
    const t = [];
    for (let n of X0(e))
      if (typeof n == "string") {
        if (n = n.trim(), n === "")
          continue;
        const i = document.createElement("span");
        i.textContent = n, t.push(i);
      } else
        t.push(n);
    return t;
  }
  updateBackground(e) {
    let t;
    this.options.secondary ? t = e ? this.options.buttonSecondaryHoverBackground : this.options.buttonSecondaryBackground : t = e ? this.options.buttonHoverBackground : this.options.buttonBackground, t && (this._element.style.backgroundColor = t);
  }
  get element() {
    return this._element;
  }
  set label(e) {
    if (this._label === e || Np(this._label) && Np(e) && g9t(this._label, e))
      return;
    this._element.classList.add("monaco-text-button");
    const t = this.options.supportShortLabel ? this._labelElement : this._element;
    if (Np(e)) {
      const i = dR(e, { inline: !0 });
      i.dispose();
      const s = i.element.querySelector("p")?.innerHTML;
      if (s) {
        const o = vDe(s, { ADD_TAGS: ["b", "i", "u", "code", "span"], ALLOWED_ATTR: ["class"], RETURN_TRUSTED_TYPE: !0 });
        t.innerHTML = o;
      } else
        ys(t);
    } else
      this.options.supportIcons ? ys(t, ...this.getContentElements(e)) : t.textContent = e;
    let n = "";
    typeof this.options.title == "string" ? n = this.options.title : this.options.title && (n = _9t(e)), this.setTitle(n), typeof this.options.ariaLabel == "string" ? this._element.setAttribute("aria-label", this.options.ariaLabel) : this.options.ariaLabel && this._element.setAttribute("aria-label", n), this._label = e;
  }
  get label() {
    return this._label;
  }
  set icon(e) {
    this._element.classList.add(...Tt.asClassNameArray(e));
  }
  set enabled(e) {
    e ? (this._element.classList.remove("disabled"), this._element.setAttribute("aria-disabled", String(!1)), this._element.tabIndex = 0) : (this._element.classList.add("disabled"), this._element.setAttribute("aria-disabled", String(!0)));
  }
  get enabled() {
    return !this._element.classList.contains("disabled");
  }
  setTitle(e) {
    !this._hover && e !== "" ? this._hover = this._register(Mh().setupManagedHover(this.options.hoverDelegate ?? fo("mouse"), this._element, e)) : this._hover && this._hover.update(e);
  }
};
class m9e {
  constructor(e, t, n) {
    this.options = t, this.styles = n, this.count = 0, this.element = Fe(e, $e(".monaco-count-badge")), this.countFormat = this.options.countFormat || "{0}", this.titleFormat = this.options.titleFormat || "", this.setCount(this.options.count || 0);
  }
  setCount(e) {
    this.count = e, this.render();
  }
  setTitleFormat(e) {
    this.titleFormat = e, this.render();
  }
  render() {
    this.element.textContent = I8(this.countFormat, this.count), this.element.title = I8(this.titleFormat, this.count), this.element.style.backgroundColor = this.styles.badgeBackground ?? "", this.element.style.color = this.styles.badgeForeground ?? "", this.styles.badgeBorder && (this.element.style.border = `1px solid ${this.styles.badgeBorder}`);
  }
}
const A9e = "done", w9e = "active", E_ = "infinite", __ = "infinite-long-running", v9e = "discrete";
class xR extends me {
  static {
    this.LONG_RUNNING_INFINITE_THRESHOLD = 1e4;
  }
  constructor(e, t) {
    super(), this.progressSignal = this._register(new Bd()), this.workedVal = 0, this.showDelayedScheduler = this._register(new Nr(() => IDe(this.element), 0)), this.longRunningScheduler = this._register(new Nr(() => this.infiniteLongRunning(), xR.LONG_RUNNING_INFINITE_THRESHOLD)), this.create(e, t);
  }
  create(e, t) {
    this.element = document.createElement("div"), this.element.classList.add("monaco-progress-container"), this.element.setAttribute("role", "progressbar"), this.element.setAttribute("aria-valuemin", "0"), e.appendChild(this.element), this.bit = document.createElement("div"), this.bit.classList.add("progress-bit"), this.bit.style.backgroundColor = t?.progressBarBackground || "#0E70C0", this.element.appendChild(this.bit);
  }
  off() {
    this.bit.style.width = "inherit", this.bit.style.opacity = "1", this.element.classList.remove(w9e, E_, __, v9e), this.workedVal = 0, this.totalWork = void 0, this.longRunningScheduler.cancel(), this.progressSignal.clear();
  }
  /**
   * Stops the progressbar from showing any progress instantly without fading out.
   */
  stop() {
    return this.doDone(!1);
  }
  doDone(e) {
    return this.element.classList.add(A9e), this.element.classList.contains(E_) ? (this.bit.style.opacity = "0", e ? setTimeout(() => this.off(), 200) : this.off()) : (this.bit.style.width = "inherit", e ? setTimeout(() => this.off(), 200) : this.off()), this;
  }
  /**
   * Use this mode to indicate progress that has no total number of work units.
   */
  infinite() {
    return this.bit.style.width = "2%", this.bit.style.opacity = "1", this.element.classList.remove(v9e, A9e, __), this.element.classList.add(w9e, E_), this.longRunningScheduler.schedule(), this;
  }
  infiniteLongRunning() {
    this.element.classList.add(__);
  }
  getContainer() {
    return this.element;
  }
}
const Dyt = C("caseDescription", "Match Case"), Lyt = C("wordsDescription", "Match Whole Word"), kyt = C("regexDescription", "Use Regular Expression");
class UNe extends cm {
  constructor(e) {
    super({
      icon: ke.caseSensitive,
      title: Dyt + e.appendTitle,
      isChecked: e.isChecked,
      hoverDelegate: e.hoverDelegate ?? fo("element"),
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class qNe extends cm {
  constructor(e) {
    super({
      icon: ke.wholeWord,
      title: Lyt + e.appendTitle,
      isChecked: e.isChecked,
      hoverDelegate: e.hoverDelegate ?? fo("element"),
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class GNe extends cm {
  constructor(e) {
    super({
      icon: ke.regex,
      title: kyt + e.appendTitle,
      isChecked: e.isChecked,
      hoverDelegate: e.hoverDelegate ?? fo("element"),
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class Nyt {
  constructor(e, t = 0, n = e.length, i = t - 1) {
    this.items = e, this.start = t, this.end = n, this.index = i;
  }
  current() {
    return this.index === this.start - 1 || this.index === this.end ? null : this.items[this.index];
  }
  next() {
    return this.index = Math.min(this.index + 1, this.end), this.current();
  }
  previous() {
    return this.index = Math.max(this.index - 1, this.start - 1), this.current();
  }
  first() {
    return this.index = this.start, this.current();
  }
  last() {
    return this.index = this.end - 1, this.current();
  }
}
class Tyt {
  constructor(e = [], t = 10) {
    this._initialize(e), this._limit = t, this._onChange();
  }
  getHistory() {
    return this._elements;
  }
  add(e) {
    this._history.delete(e), this._history.add(e), this._onChange();
  }
  next() {
    return this._navigator.next();
  }
  previous() {
    return this._currentPosition() !== 0 ? this._navigator.previous() : null;
  }
  current() {
    return this._navigator.current();
  }
  first() {
    return this._navigator.first();
  }
  last() {
    return this._navigator.last();
  }
  isLast() {
    return this._currentPosition() >= this._elements.length - 1;
  }
  isNowhere() {
    return this._navigator.current() === null;
  }
  has(e) {
    return this._history.has(e);
  }
  _onChange() {
    this._reduceToLimit();
    const e = this._elements;
    this._navigator = new Nyt(e, 0, e.length, e.length);
  }
  _reduceToLimit() {
    const e = this._elements;
    e.length > this._limit && this._initialize(e.slice(e.length - this._limit));
  }
  _currentPosition() {
    const e = this._navigator.current();
    return e ? this._elements.indexOf(e) : -1;
  }
  _initialize(e) {
    this._history = /* @__PURE__ */ new Set();
    for (const t of e)
      this._history.add(t);
  }
  get _elements() {
    const e = [];
    return this._history.forEach((t) => e.push(t)), e;
  }
}
const Um = $e;
class Iyt extends xa {
  constructor(e, t, n) {
    super(), this.state = "idle", this.maxHeight = Number.POSITIVE_INFINITY, this._onDidChange = this._register(new $()), this.onDidChange = this._onDidChange.event, this._onDidHeightChange = this._register(new $()), this.onDidHeightChange = this._onDidHeightChange.event, this.contextViewProvider = t, this.options = n, this.message = null, this.placeholder = this.options.placeholder || "", this.tooltip = this.options.tooltip ?? (this.placeholder || ""), this.ariaLabel = this.options.ariaLabel || "", this.options.validationOptions && (this.validation = this.options.validationOptions.validation), this.element = Fe(e, Um(".monaco-inputbox.idle"));
    const i = this.options.flexibleHeight ? "textarea" : "input", s = Fe(this.element, Um(".ibwrapper"));
    if (this.input = Fe(s, Um(i + ".input.empty")), this.input.setAttribute("autocorrect", "off"), this.input.setAttribute("autocapitalize", "off"), this.input.setAttribute("spellcheck", "false"), this.onfocus(this.input, () => this.element.classList.add("synthetic-focus")), this.onblur(this.input, () => this.element.classList.remove("synthetic-focus")), this.options.flexibleHeight) {
      this.maxHeight = typeof this.options.flexibleMaxHeight == "number" ? this.options.flexibleMaxHeight : Number.POSITIVE_INFINITY, this.mirror = Fe(s, Um("div.mirror")), this.mirror.innerText = " ", this.scrollableElement = new P3t(this.element, {
        vertical: 1
        /* ScrollbarVisibility.Auto */
      }), this.options.flexibleWidth && (this.input.setAttribute("wrap", "off"), this.mirror.style.whiteSpace = "pre", this.mirror.style.wordWrap = "initial"), Fe(e, this.scrollableElement.getDomNode()), this._register(this.scrollableElement), this._register(this.scrollableElement.onScroll((l) => this.input.scrollTop = l.scrollTop));
      const o = this._register(new St(e.ownerDocument, "selectionchange")), a = xe.filter(o.event, () => e.ownerDocument.getSelection()?.anchorNode === s);
      this._register(a(this.updateScrollDimensions, this)), this._register(this.onDidHeightChange(this.updateScrollDimensions, this));
    } else
      this.input.type = this.options.type || "text", this.input.setAttribute("wrap", "off");
    this.ariaLabel && this.input.setAttribute("aria-label", this.ariaLabel), this.placeholder && !this.options.showPlaceholderOnFocus && this.setPlaceHolder(this.placeholder), this.tooltip && this.setTooltip(this.tooltip), this.oninput(this.input, () => this.onValueChange()), this.onblur(this.input, () => this.onBlur()), this.onfocus(this.input, () => this.onFocus()), this._register(this.ignoreGesture(this.input)), setTimeout(() => this.updateMirror(), 0), this.options.actions && (this.actionbar = this._register(new Md(this.element)), this.actionbar.push(this.options.actions, { icon: !0, label: !1 })), this.applyStyles();
  }
  onBlur() {
    this._hideMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", "");
  }
  onFocus() {
    this._showMessage(), this.options.showPlaceholderOnFocus && this.input.setAttribute("placeholder", this.placeholder || "");
  }
  setPlaceHolder(e) {
    this.placeholder = e, this.input.setAttribute("placeholder", e);
  }
  setTooltip(e) {
    this.tooltip = e, this.hover ? this.hover.update(e) : this.hover = this._register(Mh().setupManagedHover(fo("mouse"), this.input, e));
  }
  get inputElement() {
    return this.input;
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value !== e && (this.input.value = e, this.onValueChange());
  }
  get height() {
    return typeof this.cachedHeight == "number" ? this.cachedHeight : PD(this.element);
  }
  focus() {
    this.input.focus();
  }
  blur() {
    this.input.blur();
  }
  hasFocus() {
    return F7(this.input);
  }
  select(e = null) {
    this.input.select(), e && (this.input.setSelectionRange(e.start, e.end), e.end === this.input.value.length && (this.input.scrollLeft = this.input.scrollWidth));
  }
  isSelectionAtEnd() {
    return this.input.selectionEnd === this.input.value.length && this.input.selectionStart === this.input.selectionEnd;
  }
  getSelection() {
    const e = this.input.selectionStart;
    if (e === null)
      return null;
    const t = this.input.selectionEnd ?? e;
    return {
      start: e,
      end: t
    };
  }
  enable() {
    this.input.removeAttribute("disabled");
  }
  disable() {
    this.blur(), this.input.disabled = !0, this._hideMessage();
  }
  set paddingRight(e) {
    this.input.style.width = `calc(100% - ${e}px)`, this.mirror && (this.mirror.style.paddingRight = e + "px");
  }
  updateScrollDimensions() {
    if (typeof this.cachedContentHeight != "number" || typeof this.cachedHeight != "number" || !this.scrollableElement)
      return;
    const e = this.cachedContentHeight, t = this.cachedHeight, n = this.input.scrollTop;
    this.scrollableElement.setScrollDimensions({ scrollHeight: e, height: t }), this.scrollableElement.setScrollPosition({ scrollTop: n });
  }
  showMessage(e, t) {
    if (this.state === "open" && Ho(this.message, e))
      return;
    this.message = e, this.element.classList.remove("idle"), this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add(this.classForType(e.type));
    const n = this.stylesForType(this.message.type);
    this.element.style.border = `1px solid ${Cd(n.border, "transparent")}`, this.message.content && (this.hasFocus() || t) && this._showMessage();
  }
  hideMessage() {
    this.message = null, this.element.classList.remove("info"), this.element.classList.remove("warning"), this.element.classList.remove("error"), this.element.classList.add("idle"), this._hideMessage(), this.applyStyles();
  }
  validate() {
    let e = null;
    return this.validation && (e = this.validation(this.value), e ? (this.inputElement.setAttribute("aria-invalid", "true"), this.showMessage(e)) : this.inputElement.hasAttribute("aria-invalid") && (this.inputElement.removeAttribute("aria-invalid"), this.hideMessage())), e?.type;
  }
  stylesForType(e) {
    const t = this.options.inputBoxStyles;
    switch (e) {
      case 1:
        return { border: t.inputValidationInfoBorder, background: t.inputValidationInfoBackground, foreground: t.inputValidationInfoForeground };
      case 2:
        return { border: t.inputValidationWarningBorder, background: t.inputValidationWarningBackground, foreground: t.inputValidationWarningForeground };
      default:
        return { border: t.inputValidationErrorBorder, background: t.inputValidationErrorBackground, foreground: t.inputValidationErrorForeground };
    }
  }
  classForType(e) {
    switch (e) {
      case 1:
        return "info";
      case 2:
        return "warning";
      default:
        return "error";
    }
  }
  _showMessage() {
    if (!this.contextViewProvider || !this.message)
      return;
    let e;
    const t = () => e.style.width = Fa(this.element) + "px";
    this.contextViewProvider.showContextView({
      getAnchor: () => this.element,
      anchorAlignment: 1,
      render: (i) => {
        if (!this.message)
          return null;
        e = Fe(i, Um(".monaco-inputbox-container")), t();
        const s = {
          inline: !0,
          className: "monaco-inputbox-message"
        }, o = this.message.formatContent ? z8t(this.message.content, s) : F8t(this.message.content, s);
        o.classList.add(this.classForType(this.message.type));
        const a = this.stylesForType(this.message.type);
        return o.style.backgroundColor = a.background ?? "", o.style.color = a.foreground ?? "", o.style.border = a.border ? `1px solid ${a.border}` : "", Fe(e, o), null;
      },
      onHide: () => {
        this.state = "closed";
      },
      layout: t
    });
    let n;
    this.message.type === 3 ? n = C("alertErrorMessage", "Error: {0}", this.message.content) : this.message.type === 2 ? n = C("alertWarningMessage", "Warning: {0}", this.message.content) : n = C("alertInfoMessage", "Info: {0}", this.message.content), X8(n), this.state = "open";
  }
  _hideMessage() {
    this.contextViewProvider && (this.state === "open" && this.contextViewProvider.hideContextView(), this.state = "idle");
  }
  onValueChange() {
    this._onDidChange.fire(this.value), this.validate(), this.updateMirror(), this.input.classList.toggle("empty", !this.value), this.state === "open" && this.contextViewProvider && this.contextViewProvider.layout();
  }
  updateMirror() {
    if (!this.mirror)
      return;
    const e = this.value, n = e.charCodeAt(e.length - 1) === 10 ? " " : "";
    (e + n).replace(/\u000c/g, "") ? this.mirror.textContent = e + n : this.mirror.innerText = " ", this.layout();
  }
  applyStyles() {
    const e = this.options.inputBoxStyles, t = e.inputBackground ?? "", n = e.inputForeground ?? "", i = e.inputBorder ?? "";
    this.element.style.backgroundColor = t, this.element.style.color = n, this.input.style.backgroundColor = "inherit", this.input.style.color = n, this.element.style.border = `1px solid ${Cd(i, "transparent")}`;
  }
  layout() {
    if (!this.mirror)
      return;
    const e = this.cachedContentHeight;
    this.cachedContentHeight = PD(this.mirror), e !== this.cachedContentHeight && (this.cachedHeight = Math.min(this.cachedContentHeight, this.maxHeight), this.input.style.height = this.cachedHeight + "px", this._onDidHeightChange.fire(this.cachedContentHeight));
  }
  insertAtCursor(e) {
    const t = this.inputElement, n = t.selectionStart, i = t.selectionEnd, s = t.value;
    n !== null && i !== null && (this.value = s.substr(0, n) + e + s.substr(i), t.setSelectionRange(n + 1, n + 1), this.layout());
  }
  dispose() {
    this._hideMessage(), this.message = null, this.actionbar?.dispose(), super.dispose();
  }
}
class QNe extends Iyt {
  constructor(e, t, n) {
    const i = C({
      key: "history.inputbox.hint.suffix.noparens",
      comment: ['Text is the suffix of an input field placeholder coming after the action the input field performs, this will be used when the input field ends in a closing parenthesis ")", for example "Filter (e.g. text, !exclude)". The character inserted into the final string is ⇅ to represent the up and down arrow keys.']
    }, " or {0} for history", "⇅"), s = C({
      key: "history.inputbox.hint.suffix.inparens",
      comment: ['Text is the suffix of an input field placeholder coming after the action the input field performs, this will be used when the input field does NOT end in a closing parenthesis (eg. "Find"). The character inserted into the final string is ⇅ to represent the up and down arrow keys.']
    }, " ({0} for history)", "⇅");
    super(e, t, n), this._onDidFocus = this._register(new $()), this.onDidFocus = this._onDidFocus.event, this._onDidBlur = this._register(new $()), this.onDidBlur = this._onDidBlur.event, this.history = new Tyt(n.history, 100);
    const o = () => {
      if (n.showHistoryHint && n.showHistoryHint() && !this.placeholder.endsWith(i) && !this.placeholder.endsWith(s) && this.history.getHistory().length) {
        const a = this.placeholder.endsWith(")") ? i : s, l = this.placeholder + a;
        n.showPlaceholderOnFocus && !F7(this.input) ? this.placeholder = l : this.setPlaceHolder(l);
      }
    };
    this.observer = new MutationObserver((a, l) => {
      a.forEach((c) => {
        c.target.textContent || o();
      });
    }), this.observer.observe(this.input, { attributeFilter: ["class"] }), this.onfocus(this.input, () => o()), this.onblur(this.input, () => {
      const a = (l) => {
        if (this.placeholder.endsWith(l)) {
          const c = this.placeholder.slice(0, this.placeholder.length - l.length);
          return n.showPlaceholderOnFocus ? this.placeholder = c : this.setPlaceHolder(c), !0;
        } else
          return !1;
      };
      a(s) || a(i);
    });
  }
  dispose() {
    super.dispose(), this.observer && (this.observer.disconnect(), this.observer = void 0);
  }
  addToHistory(e) {
    this.value && (e || this.value !== this.getCurrentValue()) && this.history.add(this.value);
  }
  isAtLastInHistory() {
    return this.history.isLast();
  }
  isNowhereInHistory() {
    return this.history.isNowhere();
  }
  showNextValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getNextValue();
    e && (e = e === this.value ? this.getNextValue() : e), this.value = e ?? "", J8(this.value ? this.value : C("clearedInput", "Cleared Input"));
  }
  showPreviousValue() {
    this.history.has(this.value) || this.addToHistory();
    let e = this.getPreviousValue();
    e && (e = e === this.value ? this.getPreviousValue() : e), e && (this.value = e, J8(this.value));
  }
  setPlaceHolder(e) {
    super.setPlaceHolder(e), this.setTooltip(e);
  }
  onBlur() {
    super.onBlur(), this._onDidBlur.fire();
  }
  onFocus() {
    super.onFocus(), this._onDidFocus.fire();
  }
  getCurrentValue() {
    let e = this.history.current();
    return e || (e = this.history.last(), this.history.next()), e;
  }
  getPreviousValue() {
    return this.history.previous() || this.history.first();
  }
  getNextValue() {
    return this.history.next();
  }
}
const Oyt = C("defaultLabel", "input");
class KNe extends xa {
  constructor(e, t, n) {
    super(), this.fixFocusOnOptionClickEnabled = !0, this.imeSessionInProgress = !1, this.additionalTogglesDisposables = this._register(new Bd()), this.additionalToggles = [], this._onDidOptionChange = this._register(new $()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new $()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new $()), this.onMouseDown = this._onMouseDown.event, this._onInput = this._register(new $()), this._onKeyUp = this._register(new $()), this._onCaseSensitiveKeyDown = this._register(new $()), this.onCaseSensitiveKeyDown = this._onCaseSensitiveKeyDown.event, this._onRegexKeyDown = this._register(new $()), this.onRegexKeyDown = this._onRegexKeyDown.event, this._lastHighlightFindOptions = 0, this.placeholder = n.placeholder || "", this.validation = n.validation, this.label = n.label || Oyt, this.showCommonFindToggles = !!n.showCommonFindToggles;
    const i = n.appendCaseSensitiveLabel || "", s = n.appendWholeWordsLabel || "", o = n.appendRegexLabel || "", a = n.history || [], l = !!n.flexibleHeight, c = !!n.flexibleWidth, d = n.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new QNe(this.domNode, t, {
      placeholder: this.placeholder || "",
      ariaLabel: this.label || "",
      validationOptions: {
        validation: this.validation
      },
      history: a,
      showHistoryHint: n.showHistoryHint,
      flexibleHeight: l,
      flexibleWidth: c,
      flexibleMaxHeight: d,
      inputBoxStyles: n.inputBoxStyles
    }));
    const u = this._register(wg());
    if (this.showCommonFindToggles) {
      this.regex = this._register(new GNe({
        appendTitle: o,
        isChecked: !1,
        hoverDelegate: u,
        ...n.toggleStyles
      })), this._register(this.regex.onChange((p) => {
        this._onDidOptionChange.fire(p), !p && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.regex.onKeyDown((p) => {
        this._onRegexKeyDown.fire(p);
      })), this.wholeWords = this._register(new qNe({
        appendTitle: s,
        isChecked: !1,
        hoverDelegate: u,
        ...n.toggleStyles
      })), this._register(this.wholeWords.onChange((p) => {
        this._onDidOptionChange.fire(p), !p && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this.caseSensitive = this._register(new UNe({
        appendTitle: i,
        isChecked: !1,
        hoverDelegate: u,
        ...n.toggleStyles
      })), this._register(this.caseSensitive.onChange((p) => {
        this._onDidOptionChange.fire(p), !p && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
      })), this._register(this.caseSensitive.onKeyDown((p) => {
        this._onCaseSensitiveKeyDown.fire(p);
      }));
      const f = [this.caseSensitive.domNode, this.wholeWords.domNode, this.regex.domNode];
      this.onkeydown(this.domNode, (p) => {
        if (p.equals(
          15
          /* KeyCode.LeftArrow */
        ) || p.equals(
          17
          /* KeyCode.RightArrow */
        ) || p.equals(
          9
          /* KeyCode.Escape */
        )) {
          const g = f.indexOf(this.domNode.ownerDocument.activeElement);
          if (g >= 0) {
            let m = -1;
            p.equals(
              17
              /* KeyCode.RightArrow */
            ) ? m = (g + 1) % f.length : p.equals(
              15
              /* KeyCode.LeftArrow */
            ) && (g === 0 ? m = f.length - 1 : m = g - 1), p.equals(
              9
              /* KeyCode.Escape */
            ) ? (f[g].blur(), this.inputBox.focus()) : m >= 0 && f[m].focus(), Lt.stop(p, !0);
          }
        }
      });
    }
    this.controls = document.createElement("div"), this.controls.className = "controls", this.controls.style.display = this.showCommonFindToggles ? "" : "none", this.caseSensitive && this.controls.append(this.caseSensitive.domNode), this.wholeWords && this.controls.appendChild(this.wholeWords.domNode), this.regex && this.controls.appendChild(this.regex.domNode), this.setAdditionalToggles(n?.additionalToggles), this.controls && this.domNode.appendChild(this.controls), e?.appendChild(this.domNode), this._register(fe(this.inputBox.inputElement, "compositionstart", (f) => {
      this.imeSessionInProgress = !0;
    })), this._register(fe(this.inputBox.inputElement, "compositionend", (f) => {
      this.imeSessionInProgress = !1, this._onInput.fire();
    })), this.onkeydown(this.inputBox.inputElement, (f) => this._onKeyDown.fire(f)), this.onkeyup(this.inputBox.inputElement, (f) => this._onKeyUp.fire(f)), this.oninput(this.inputBox.inputElement, (f) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (f) => this._onMouseDown.fire(f));
  }
  get onDidChange() {
    return this.inputBox.onDidChange;
  }
  layout(e) {
    this.inputBox.layout(), this.updateInputBoxPadding(e.collapsedFindWidget);
  }
  enable() {
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), this.regex?.enable(), this.wholeWords?.enable(), this.caseSensitive?.enable();
    for (const e of this.additionalToggles)
      e.enable();
  }
  disable() {
    this.domNode.classList.add("disabled"), this.inputBox.disable(), this.regex?.disable(), this.wholeWords?.disable(), this.caseSensitive?.disable();
    for (const e of this.additionalToggles)
      e.disable();
  }
  setFocusInputOnOptionClick(e) {
    this.fixFocusOnOptionClickEnabled = e;
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  setAdditionalToggles(e) {
    for (const t of this.additionalToggles)
      t.domNode.remove();
    this.additionalToggles = [], this.additionalTogglesDisposables.value = new ze();
    for (const t of e ?? [])
      this.additionalTogglesDisposables.value.add(t), this.controls.appendChild(t.domNode), this.additionalTogglesDisposables.value.add(t.onChange((n) => {
        this._onDidOptionChange.fire(n), !n && this.fixFocusOnOptionClickEnabled && this.inputBox.focus();
      })), this.additionalToggles.push(t);
    this.additionalToggles.length > 0 && (this.controls.style.display = ""), this.updateInputBoxPadding();
  }
  updateInputBoxPadding(e = !1) {
    e ? this.inputBox.paddingRight = 0 : this.inputBox.paddingRight = (this.caseSensitive?.width() ?? 0) + (this.wholeWords?.width() ?? 0) + (this.regex?.width() ?? 0) + this.additionalToggles.reduce((t, n) => t + n.width(), 0);
  }
  getValue() {
    return this.inputBox.value;
  }
  setValue(e) {
    this.inputBox.value !== e && (this.inputBox.value = e);
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getCaseSensitive() {
    return this.caseSensitive?.checked ?? !1;
  }
  setCaseSensitive(e) {
    this.caseSensitive && (this.caseSensitive.checked = e);
  }
  getWholeWords() {
    return this.wholeWords?.checked ?? !1;
  }
  setWholeWords(e) {
    this.wholeWords && (this.wholeWords.checked = e);
  }
  getRegex() {
    return this.regex?.checked ?? !1;
  }
  setRegex(e) {
    this.regex && (this.regex.checked = e, this.validate());
  }
  focusOnCaseSensitive() {
    this.caseSensitive?.focus();
  }
  highlightFindOptions() {
    this.domNode.classList.remove("highlight-" + this._lastHighlightFindOptions), this._lastHighlightFindOptions = 1 - this._lastHighlightFindOptions, this.domNode.classList.add("highlight-" + this._lastHighlightFindOptions);
  }
  validate() {
    this.inputBox.validate();
  }
  showMessage(e) {
    this.inputBox.showMessage(e);
  }
  clearMessage() {
    this.inputBox.hideMessage();
  }
}
const Ryt = $e;
class Vyt extends me {
  constructor(e, t, n) {
    super(), this.parent = e, this.onKeyDown = (s) => ir(this.findInput.inputBox.inputElement, Se.KEY_DOWN, s), this.onDidChange = (s) => this.findInput.onDidChange(s), this.container = Fe(this.parent, Ryt(".quick-input-box")), this.findInput = this._register(new KNe(this.container, void 0, { label: "", inputBoxStyles: t, toggleStyles: n }));
    const i = this.findInput.inputBox.inputElement;
    i.role = "combobox", i.ariaHasPopup = "menu", i.ariaAutoComplete = "list", i.ariaExpanded = "true";
  }
  get value() {
    return this.findInput.getValue();
  }
  set value(e) {
    this.findInput.setValue(e);
  }
  select(e = null) {
    this.findInput.inputBox.select(e);
  }
  getSelection() {
    return this.findInput.inputBox.getSelection();
  }
  isSelectionAtEnd() {
    return this.findInput.inputBox.isSelectionAtEnd();
  }
  get placeholder() {
    return this.findInput.inputBox.inputElement.getAttribute("placeholder") || "";
  }
  set placeholder(e) {
    this.findInput.inputBox.setPlaceHolder(e);
  }
  get password() {
    return this.findInput.inputBox.inputElement.type === "password";
  }
  set password(e) {
    this.findInput.inputBox.inputElement.type = e ? "password" : "text";
  }
  set enabled(e) {
    this.findInput.inputBox.inputElement.toggleAttribute("readonly", !e);
  }
  set toggles(e) {
    this.findInput.setAdditionalToggles(e);
  }
  setAttribute(e, t) {
    this.findInput.inputBox.inputElement.setAttribute(e, t);
  }
  showDecoration(e) {
    e === Oi.Ignore ? this.findInput.clearMessage() : this.findInput.showMessage({ type: e === Oi.Info ? 1 : e === Oi.Warning ? 2 : 3, content: "" });
  }
  stylesForType(e) {
    return this.findInput.inputBox.stylesForType(
      e === Oi.Info ? 1 : e === Oi.Warning ? 2 : 3
      /* MessageType.ERROR */
    );
  }
  setFocus() {
    this.findInput.focus();
  }
  layout() {
    this.findInput.inputBox.layout();
  }
}
class Hyt {
  get templateId() {
    return this.renderer.templateId;
  }
  constructor(e, t) {
    this.renderer = e, this.modelProvider = t;
  }
  renderTemplate(e) {
    return { data: this.renderer.renderTemplate(e), disposable: me.None };
  }
  renderElement(e, t, n, i) {
    if (n.disposable?.dispose(), !n.data)
      return;
    const s = this.modelProvider();
    if (s.isResolved(e))
      return this.renderer.renderElement(s.get(e), e, n.data, i);
    const o = new Jg(), a = s.resolve(e, o.token);
    n.disposable = { dispose: () => o.cancel() }, this.renderer.renderPlaceholder(e, n.data), a.then((l) => this.renderer.renderElement(l, e, n.data, i));
  }
  disposeTemplate(e) {
    e.disposable && (e.disposable.dispose(), e.disposable = void 0), e.data && (this.renderer.disposeTemplate(e.data), e.data = void 0);
  }
}
class Byt {
  constructor(e, t) {
    this.modelProvider = e, this.accessibilityProvider = t;
  }
  getWidgetAriaLabel() {
    return this.accessibilityProvider.getWidgetAriaLabel();
  }
  getAriaLabel(e) {
    const t = this.modelProvider();
    return t.isResolved(e) ? this.accessibilityProvider.getAriaLabel(t.get(e)) : null;
  }
}
function Pyt(r, e) {
  return {
    ...e,
    accessibilityProvider: e.accessibilityProvider && new Byt(r, e.accessibilityProvider)
  };
}
class Fyt {
  constructor(e, t, n, i, s = {}) {
    const o = () => this.model, a = i.map((l) => new Hyt(l, o));
    this.list = new gc(e, t, n, a, Pyt(o, s));
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  getHTMLElement() {
    return this.list.getHTMLElement();
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get widget() {
    return this.list;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  get onMouseDblClick() {
    return xe.map(this.list.onMouseDblClick, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onPointer() {
    return xe.map(this.list.onPointer, ({ element: e, index: t, browserEvent: n }) => ({ element: e === void 0 ? void 0 : this._model.get(e), index: t, browserEvent: n }));
  }
  get onDidChangeSelection() {
    return xe.map(this.list.onDidChangeSelection, ({ elements: e, indexes: t, browserEvent: n }) => ({ elements: e.map((i) => this._model.get(i)), indexes: t, browserEvent: n }));
  }
  get model() {
    return this._model;
  }
  set model(e) {
    this._model = e, this.list.splice(0, this.list.length, ks(e.length));
  }
  getFocus() {
    return this.list.getFocus();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getSelectedElements() {
    return this.getSelection().map((e) => this.model.get(e));
  }
  style(e) {
    this.list.style(e);
  }
  dispose() {
    this.list.dispose();
  }
}
var hm = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
};
const zyt = !1;
var b9e;
(function(r) {
  r.North = "north", r.South = "south", r.East = "east", r.West = "west";
})(b9e || (b9e = {}));
let Wyt = 4;
const jyt = new $();
let Zyt = 300;
const Uyt = new $();
class SR {
  constructor(e) {
    this.el = e, this.disposables = new ze();
  }
  get onPointerMove() {
    return this.disposables.add(new St(qe(this.el), "mousemove")).event;
  }
  get onPointerUp() {
    return this.disposables.add(new St(qe(this.el), "mouseup")).event;
  }
  dispose() {
    this.disposables.dispose();
  }
}
hm([
  wi
], SR.prototype, "onPointerMove", null);
hm([
  wi
], SR.prototype, "onPointerUp", null);
class MR {
  get onPointerMove() {
    return this.disposables.add(new St(this.el, Nn.Change)).event;
  }
  get onPointerUp() {
    return this.disposables.add(new St(this.el, Nn.End)).event;
  }
  constructor(e) {
    this.el = e, this.disposables = new ze();
  }
  dispose() {
    this.disposables.dispose();
  }
}
hm([
  wi
], MR.prototype, "onPointerMove", null);
hm([
  wi
], MR.prototype, "onPointerUp", null);
class U9 {
  get onPointerMove() {
    return this.factory.onPointerMove;
  }
  get onPointerUp() {
    return this.factory.onPointerUp;
  }
  constructor(e) {
    this.factory = e;
  }
  dispose() {
  }
}
hm([
  wi
], U9.prototype, "onPointerMove", null);
hm([
  wi
], U9.prototype, "onPointerUp", null);
const y9e = "pointer-events-disabled";
class bo extends me {
  get state() {
    return this._state;
  }
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  /**
   * The state of a sash defines whether it can be interacted with by the user
   * as well as what mouse cursor to use, when hovered.
   */
  set state(e) {
    this._state !== e && (this.el.classList.toggle(
      "disabled",
      e === 0
      /* SashState.Disabled */
    ), this.el.classList.toggle(
      "minimum",
      e === 1
      /* SashState.AtMinimum */
    ), this.el.classList.toggle(
      "maximum",
      e === 2
      /* SashState.AtMaximum */
    ), this._state = e, this.onDidEnablementChange.fire(e));
  }
  /**
   * A reference to another sash, perpendicular to this one, which
   * aligns at the start of this one. A corner sash will be created
   * automatically at that location.
   *
   * The start of a horizontal sash is its left-most position.
   * The start of a vertical sash is its top-most position.
   */
  set orthogonalStartSash(e) {
    if (this._orthogonalStartSash !== e) {
      if (this.orthogonalStartDragHandleDisposables.clear(), this.orthogonalStartSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalStartDragHandleDisposables.clear(), n !== 0 && (this._orthogonalStartDragHandle = Fe(this.el, $e(".orthogonal-drag-handle.start")), this.orthogonalStartDragHandleDisposables.add(ht(() => this._orthogonalStartDragHandle.remove())), this.orthogonalStartDragHandleDisposables.add(new St(this._orthogonalStartDragHandle, "mouseenter")).event(() => bo.onMouseEnter(e), void 0, this.orthogonalStartDragHandleDisposables), this.orthogonalStartDragHandleDisposables.add(new St(this._orthogonalStartDragHandle, "mouseleave")).event(() => bo.onMouseLeave(e), void 0, this.orthogonalStartDragHandleDisposables));
        };
        this.orthogonalStartSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalStartSash = e;
    }
  }
  /**
   * A reference to another sash, perpendicular to this one, which
   * aligns at the end of this one. A corner sash will be created
   * automatically at that location.
   *
   * The end of a horizontal sash is its right-most position.
   * The end of a vertical sash is its bottom-most position.
   */
  set orthogonalEndSash(e) {
    if (this._orthogonalEndSash !== e) {
      if (this.orthogonalEndDragHandleDisposables.clear(), this.orthogonalEndSashDisposables.clear(), e) {
        const t = (n) => {
          this.orthogonalEndDragHandleDisposables.clear(), n !== 0 && (this._orthogonalEndDragHandle = Fe(this.el, $e(".orthogonal-drag-handle.end")), this.orthogonalEndDragHandleDisposables.add(ht(() => this._orthogonalEndDragHandle.remove())), this.orthogonalEndDragHandleDisposables.add(new St(this._orthogonalEndDragHandle, "mouseenter")).event(() => bo.onMouseEnter(e), void 0, this.orthogonalEndDragHandleDisposables), this.orthogonalEndDragHandleDisposables.add(new St(this._orthogonalEndDragHandle, "mouseleave")).event(() => bo.onMouseLeave(e), void 0, this.orthogonalEndDragHandleDisposables));
        };
        this.orthogonalEndSashDisposables.add(e.onDidEnablementChange.event(t, this)), t(e.state);
      }
      this._orthogonalEndSash = e;
    }
  }
  constructor(e, t, n) {
    super(), this.hoverDelay = Zyt, this.hoverDelayer = this._register(new Uf(this.hoverDelay)), this._state = 3, this.onDidEnablementChange = this._register(new $()), this._onDidStart = this._register(new $()), this._onDidChange = this._register(new $()), this._onDidReset = this._register(new $()), this._onDidEnd = this._register(new $()), this.orthogonalStartSashDisposables = this._register(new ze()), this.orthogonalStartDragHandleDisposables = this._register(new ze()), this.orthogonalEndSashDisposables = this._register(new ze()), this.orthogonalEndDragHandleDisposables = this._register(new ze()), this.onDidStart = this._onDidStart.event, this.onDidChange = this._onDidChange.event, this.onDidReset = this._onDidReset.event, this.onDidEnd = this._onDidEnd.event, this.linkedSash = void 0, this.el = Fe(e, $e(".monaco-sash")), n.orthogonalEdge && this.el.classList.add(`orthogonal-edge-${n.orthogonalEdge}`), zt && this.el.classList.add("mac");
    const i = this._register(new St(this.el, "mousedown")).event;
    this._register(i((u) => this.onPointerStart(u, new SR(e)), this));
    const s = this._register(new St(this.el, "dblclick")).event;
    this._register(s(this.onPointerDoublePress, this));
    const o = this._register(new St(this.el, "mouseenter")).event;
    this._register(o(() => bo.onMouseEnter(this)));
    const a = this._register(new St(this.el, "mouseleave")).event;
    this._register(a(() => bo.onMouseLeave(this))), this._register(Xn.addTarget(this.el));
    const l = this._register(new St(this.el, Nn.Start)).event;
    this._register(l((u) => this.onPointerStart(u, new MR(this.el)), this));
    const c = this._register(new St(this.el, Nn.Tap)).event;
    let d;
    this._register(c((u) => {
      if (d) {
        clearTimeout(d), d = void 0, this.onPointerDoublePress(u);
        return;
      }
      clearTimeout(d), d = setTimeout(() => d = void 0, 250);
    }, this)), typeof n.size == "number" ? (this.size = n.size, n.orientation === 0 ? this.el.style.width = `${this.size}px` : this.el.style.height = `${this.size}px`) : (this.size = Wyt, this._register(jyt.event((u) => {
      this.size = u, this.layout();
    }))), this._register(Uyt.event((u) => this.hoverDelay = u)), this.layoutProvider = t, this.orthogonalStartSash = n.orthogonalStartSash, this.orthogonalEndSash = n.orthogonalEndSash, this.orientation = n.orientation || 0, this.orientation === 1 ? (this.el.classList.add("horizontal"), this.el.classList.remove("vertical")) : (this.el.classList.remove("horizontal"), this.el.classList.add("vertical")), this.el.classList.toggle("debug", zyt), this.layout();
  }
  onPointerStart(e, t) {
    Lt.stop(e);
    let n = !1;
    if (!e.__orthogonalSashEvent) {
      const g = this.getOrthogonalSash(e);
      g && (n = !0, e.__orthogonalSashEvent = !0, g.onPointerStart(e, new U9(t)));
    }
    if (this.linkedSash && !e.__linkedSashEvent && (e.__linkedSashEvent = !0, this.linkedSash.onPointerStart(e, new U9(t))), !this.state)
      return;
    const i = this.el.ownerDocument.getElementsByTagName("iframe");
    for (const g of i)
      g.classList.add(y9e);
    const s = e.pageX, o = e.pageY, a = e.altKey, l = { startX: s, currentX: s, startY: o, currentY: o, altKey: a };
    this.el.classList.add("active"), this._onDidStart.fire(l);
    const c = ya(this.el), d = () => {
      let g = "";
      n ? g = "all-scroll" : this.orientation === 1 ? this.state === 1 ? g = "s-resize" : this.state === 2 ? g = "n-resize" : g = zt ? "row-resize" : "ns-resize" : this.state === 1 ? g = "e-resize" : this.state === 2 ? g = "w-resize" : g = zt ? "col-resize" : "ew-resize", c.textContent = `* { cursor: ${g} !important; }`;
    }, u = new ze();
    d(), n || this.onDidEnablementChange.event(d, null, u);
    const f = (g) => {
      Lt.stop(g, !1);
      const m = { startX: s, currentX: g.pageX, startY: o, currentY: g.pageY, altKey: a };
      this._onDidChange.fire(m);
    }, p = (g) => {
      Lt.stop(g, !1), c.remove(), this.el.classList.remove("active"), this._onDidEnd.fire(), u.dispose();
      for (const m of i)
        m.classList.remove(y9e);
    };
    t.onPointerMove(f, null, u), t.onPointerUp(p, null, u), u.add(t);
  }
  onPointerDoublePress(e) {
    const t = this.getOrthogonalSash(e);
    t && t._onDidReset.fire(), this.linkedSash && this.linkedSash._onDidReset.fire(), this._onDidReset.fire();
  }
  static onMouseEnter(e, t = !1) {
    e.el.classList.contains("active") ? (e.hoverDelayer.cancel(), e.el.classList.add("hover")) : e.hoverDelayer.trigger(() => e.el.classList.add("hover"), e.hoverDelay).then(void 0, () => {
    }), !t && e.linkedSash && bo.onMouseEnter(e.linkedSash, !0);
  }
  static onMouseLeave(e, t = !1) {
    e.hoverDelayer.cancel(), e.el.classList.remove("hover"), !t && e.linkedSash && bo.onMouseLeave(e.linkedSash, !0);
  }
  /**
   * Forcefully stop any user interactions with this sash.
   * Useful when hiding a parent component, while the user is still
   * interacting with the sash.
   */
  clearSashHoverState() {
    bo.onMouseLeave(this);
  }
  /**
   * Layout the sash. The sash will size and position itself
   * based on its provided {@link ISashLayoutProvider layout provider}.
   */
  layout() {
    if (this.orientation === 0) {
      const e = this.layoutProvider;
      this.el.style.left = e.getVerticalSashLeft(this) - this.size / 2 + "px", e.getVerticalSashTop && (this.el.style.top = e.getVerticalSashTop(this) + "px"), e.getVerticalSashHeight && (this.el.style.height = e.getVerticalSashHeight(this) + "px");
    } else {
      const e = this.layoutProvider;
      this.el.style.top = e.getHorizontalSashTop(this) - this.size / 2 + "px", e.getHorizontalSashLeft && (this.el.style.left = e.getHorizontalSashLeft(this) + "px"), e.getHorizontalSashWidth && (this.el.style.width = e.getHorizontalSashWidth(this) + "px");
    }
  }
  getOrthogonalSash(e) {
    const t = e.initialTarget ?? e.target;
    if (!(!t || !wr(t)) && t.classList.contains("orthogonal-drag-handle"))
      return t.classList.contains("start") ? this.orthogonalStartSash : this.orthogonalEndSash;
  }
  dispose() {
    super.dispose(), this.el.remove();
  }
}
const qyt = {
  separatorBorder: ge.transparent
};
class YNe {
  set size(e) {
    this._size = e;
  }
  get size() {
    return this._size;
  }
  get visible() {
    return typeof this._cachedVisibleSize > "u";
  }
  setVisible(e, t) {
    if (e !== this.visible) {
      e ? (this.size = Ns(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = typeof t == "number" ? t : this.size, this.size = 0), this.container.classList.toggle("visible", e);
      try {
        this.view.setVisible?.(e);
      } catch (n) {
        console.error("Splitview: Failed to set visible view"), console.error(n);
      }
    }
  }
  get minimumSize() {
    return this.visible ? this.view.minimumSize : 0;
  }
  get viewMinimumSize() {
    return this.view.minimumSize;
  }
  get maximumSize() {
    return this.visible ? this.view.maximumSize : 0;
  }
  get viewMaximumSize() {
    return this.view.maximumSize;
  }
  get priority() {
    return this.view.priority;
  }
  get proportionalLayout() {
    return this.view.proportionalLayout ?? !0;
  }
  get snap() {
    return !!this.view.snap;
  }
  set enabled(e) {
    this.container.style.pointerEvents = e ? "" : "none";
  }
  constructor(e, t, n, i) {
    this.container = e, this.view = t, this.disposable = i, this._cachedVisibleSize = void 0, typeof n == "number" ? (this._size = n, this._cachedVisibleSize = void 0, e.classList.add("visible")) : (this._size = 0, this._cachedVisibleSize = n.cachedVisibleSize);
  }
  layout(e, t) {
    this.layoutContainer(e);
    try {
      this.view.layout(this.size, e, t);
    } catch (n) {
      console.error("Splitview: Failed to layout view"), console.error(n);
    }
  }
  dispose() {
    this.disposable.dispose();
  }
}
class Gyt extends YNe {
  layoutContainer(e) {
    this.container.style.top = `${e}px`, this.container.style.height = `${this.size}px`;
  }
}
class Qyt extends YNe {
  layoutContainer(e) {
    this.container.style.left = `${e}px`, this.container.style.width = `${this.size}px`;
  }
}
var Yh;
(function(r) {
  r[r.Idle = 0] = "Idle", r[r.Busy = 1] = "Busy";
})(Yh || (Yh = {}));
var C9e;
(function(r) {
  r.Distribute = { type: "distribute" };
  function e(i) {
    return { type: "split", index: i };
  }
  r.Split = e;
  function t(i) {
    return { type: "auto", index: i };
  }
  r.Auto = t;
  function n(i) {
    return { type: "invisible", cachedVisibleSize: i };
  }
  r.Invisible = n;
})(C9e || (C9e = {}));
class Kyt extends me {
  get orthogonalStartSash() {
    return this._orthogonalStartSash;
  }
  get orthogonalEndSash() {
    return this._orthogonalEndSash;
  }
  get startSnappingEnabled() {
    return this._startSnappingEnabled;
  }
  get endSnappingEnabled() {
    return this._endSnappingEnabled;
  }
  /**
   * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
   * located at the left- or top-most side of the SplitView.
   * Corner sashes will be created automatically at the intersections.
   */
  set orthogonalStartSash(e) {
    for (const t of this.sashItems)
      t.sash.orthogonalStartSash = e;
    this._orthogonalStartSash = e;
  }
  /**
   * A reference to a sash, perpendicular to all sashes in this {@link SplitView},
   * located at the right- or bottom-most side of the SplitView.
   * Corner sashes will be created automatically at the intersections.
   */
  set orthogonalEndSash(e) {
    for (const t of this.sashItems)
      t.sash.orthogonalEndSash = e;
    this._orthogonalEndSash = e;
  }
  /**
   * Enable/disable snapping at the beginning of this {@link SplitView}.
   */
  set startSnappingEnabled(e) {
    this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
  }
  /**
   * Enable/disable snapping at the end of this {@link SplitView}.
   */
  set endSnappingEnabled(e) {
    this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
  }
  /**
   * Create a new {@link SplitView} instance.
   */
  constructor(e, t = {}) {
    super(), this.size = 0, this._contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.state = Yh.Idle, this._onDidSashChange = this._register(new $()), this._onDidSashReset = this._register(new $()), this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onDidSashChange = this._onDidSashChange.event, this.onDidSashReset = this._onDidSashReset.event, this.orientation = t.orientation ?? 0, this.inverseAltBehavior = t.inverseAltBehavior ?? !1, this.proportionalLayout = t.proportionalLayout ?? !0, this.getSashOrthogonalSize = t.getSashOrthogonalSize, this.el = document.createElement("div"), this.el.classList.add("monaco-split-view2"), this.el.classList.add(this.orientation === 0 ? "vertical" : "horizontal"), e.appendChild(this.el), this.sashContainer = Fe(this.el, $e(".sash-container")), this.viewContainer = $e(".split-view-container"), this.scrollable = this._register(new nm({
      forceIntegerValues: !0,
      smoothScrollDuration: 125,
      scheduleAtNextAnimationFrame: (i) => co(qe(this.el), i)
    })), this.scrollableElement = this._register(new fy(this.viewContainer, {
      vertical: this.orientation === 0 ? t.scrollbarVisibility ?? 1 : 2,
      horizontal: this.orientation === 1 ? t.scrollbarVisibility ?? 1 : 2
      /* ScrollbarVisibility.Hidden */
    }, this.scrollable));
    const n = this._register(new St(this.viewContainer, "scroll")).event;
    this._register(n((i) => {
      const s = this.scrollableElement.getScrollPosition(), o = Math.abs(this.viewContainer.scrollLeft - s.scrollLeft) <= 1 ? void 0 : this.viewContainer.scrollLeft, a = Math.abs(this.viewContainer.scrollTop - s.scrollTop) <= 1 ? void 0 : this.viewContainer.scrollTop;
      (o !== void 0 || a !== void 0) && this.scrollableElement.setScrollPosition({ scrollLeft: o, scrollTop: a });
    })), this.onDidScroll = this.scrollableElement.onScroll, this._register(this.onDidScroll((i) => {
      i.scrollTopChanged && (this.viewContainer.scrollTop = i.scrollTop), i.scrollLeftChanged && (this.viewContainer.scrollLeft = i.scrollLeft);
    })), Fe(this.el, this.scrollableElement.getDomNode()), this.style(t.styles || qyt), t.descriptor && (this.size = t.descriptor.size, t.descriptor.views.forEach((i, s) => {
      const o = da(i.visible) || i.visible ? i.size : { type: "invisible", cachedVisibleSize: i.size }, a = i.view;
      this.doAddView(a, o, s, !0);
    }), this._contentSize = this.viewItems.reduce((i, s) => i + s.size, 0), this.saveProportions());
  }
  style(e) {
    e.separatorBorder.isTransparent() ? (this.el.classList.remove("separator-border"), this.el.style.removeProperty("--separator-border")) : (this.el.classList.add("separator-border"), this.el.style.setProperty("--separator-border", e.separatorBorder.toString()));
  }
  /**
   * Add a {@link IView view} to this {@link SplitView}.
   *
   * @param view The view to add.
   * @param size Either a fixed size, or a dynamic {@link Sizing} strategy.
   * @param index The index to insert the view on.
   * @param skipLayout Whether layout should be skipped.
   */
  addView(e, t, n = this.viewItems.length, i) {
    this.doAddView(e, t, n, i);
  }
  /**
   * Layout the {@link SplitView}.
   *
   * @param size The entire size of the {@link SplitView}.
   * @param layoutContext An optional layout context to pass along to {@link IView views}.
   */
  layout(e, t) {
    const n = Math.max(this.size, this._contentSize);
    if (this.size = e, this.layoutContext = t, this.proportions) {
      let i = 0;
      for (let s = 0; s < this.viewItems.length; s++) {
        const o = this.viewItems[s], a = this.proportions[s];
        typeof a == "number" ? i += a : e -= o.size;
      }
      for (let s = 0; s < this.viewItems.length; s++) {
        const o = this.viewItems[s], a = this.proportions[s];
        typeof a == "number" && i > 0 && (o.size = Ns(Math.round(a * e / i), o.minimumSize, o.maximumSize));
      }
    } else {
      const i = ks(this.viewItems.length), s = i.filter(
        (a) => this.viewItems[a].priority === 1
        /* LayoutPriority.Low */
      ), o = i.filter(
        (a) => this.viewItems[a].priority === 2
        /* LayoutPriority.High */
      );
      this.resize(this.viewItems.length - 1, e - n, void 0, s, o);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  saveProportions() {
    this.proportionalLayout && this._contentSize > 0 && (this.proportions = this.viewItems.map((e) => e.proportionalLayout && e.visible ? e.size / this._contentSize : void 0));
  }
  onSashStart({ sash: e, start: t, alt: n }) {
    for (const a of this.viewItems)
      a.enabled = !1;
    const i = this.sashItems.findIndex((a) => a.sash === e), s = ih(fe(this.el.ownerDocument.body, "keydown", (a) => o(this.sashDragState.current, a.altKey)), fe(this.el.ownerDocument.body, "keyup", () => o(this.sashDragState.current, !1))), o = (a, l) => {
      const c = this.viewItems.map((g) => g.size);
      let d = Number.NEGATIVE_INFINITY, u = Number.POSITIVE_INFINITY;
      if (this.inverseAltBehavior && (l = !l), l)
        if (i === this.sashItems.length - 1) {
          const m = this.viewItems[i];
          d = (m.minimumSize - m.size) / 2, u = (m.maximumSize - m.size) / 2;
        } else {
          const m = this.viewItems[i + 1];
          d = (m.size - m.maximumSize) / 2, u = (m.size - m.minimumSize) / 2;
        }
      let f, p;
      if (!l) {
        const g = ks(i, -1), m = ks(i + 1, this.viewItems.length), A = g.reduce((L, T) => L + (this.viewItems[T].minimumSize - c[T]), 0), w = g.reduce((L, T) => L + (this.viewItems[T].viewMaximumSize - c[T]), 0), v = m.length === 0 ? Number.POSITIVE_INFINITY : m.reduce((L, T) => L + (c[T] - this.viewItems[T].minimumSize), 0), y = m.length === 0 ? Number.NEGATIVE_INFINITY : m.reduce((L, T) => L + (c[T] - this.viewItems[T].viewMaximumSize), 0), _ = Math.max(A, y), S = Math.min(v, w), D = this.findFirstSnapIndex(g), M = this.findFirstSnapIndex(m);
        if (typeof D == "number") {
          const L = this.viewItems[D], T = Math.floor(L.viewMinimumSize / 2);
          f = {
            index: D,
            limitDelta: L.visible ? _ - T : _ + T,
            size: L.size
          };
        }
        if (typeof M == "number") {
          const L = this.viewItems[M], T = Math.floor(L.viewMinimumSize / 2);
          p = {
            index: M,
            limitDelta: L.visible ? S + T : S - T,
            size: L.size
          };
        }
      }
      this.sashDragState = { start: a, current: a, index: i, sizes: c, minDelta: d, maxDelta: u, alt: l, snapBefore: f, snapAfter: p, disposable: s };
    };
    o(t, n);
  }
  onSashChange({ current: e }) {
    const { index: t, start: n, sizes: i, alt: s, minDelta: o, maxDelta: a, snapBefore: l, snapAfter: c } = this.sashDragState;
    this.sashDragState.current = e;
    const d = e - n, u = this.resize(t, d, i, void 0, void 0, o, a, l, c);
    if (s) {
      const f = t === this.sashItems.length - 1, p = this.viewItems.map((y) => y.size), g = f ? t : t + 1, m = this.viewItems[g], A = m.size - m.maximumSize, w = m.size - m.minimumSize, v = f ? t - 1 : t + 1;
      this.resize(v, -u, p, void 0, void 0, A, w);
    }
    this.distributeEmptySpace(), this.layoutViews();
  }
  onSashEnd(e) {
    this._onDidSashChange.fire(e), this.sashDragState.disposable.dispose(), this.saveProportions();
    for (const t of this.viewItems)
      t.enabled = !0;
  }
  onViewChange(e, t) {
    const n = this.viewItems.indexOf(e);
    n < 0 || n >= this.viewItems.length || (t = typeof t == "number" ? t : e.size, t = Ns(t, e.minimumSize, e.maximumSize), this.inverseAltBehavior && n > 0 ? (this.resize(n - 1, Math.floor((e.size - t) / 2)), this.distributeEmptySpace(), this.layoutViews()) : (e.size = t, this.relayout([n], void 0)));
  }
  /**
   * Resize a {@link IView view} within the {@link SplitView}.
   *
   * @param index The {@link IView view} index.
   * @param size The {@link IView view} size.
   */
  resizeView(e, t) {
    if (!(e < 0 || e >= this.viewItems.length)) {
      if (this.state !== Yh.Idle)
        throw new Error("Cant modify splitview");
      this.state = Yh.Busy;
      try {
        const n = ks(this.viewItems.length).filter((a) => a !== e), i = [...n.filter(
          (a) => this.viewItems[a].priority === 1
          /* LayoutPriority.Low */
        ), e], s = n.filter(
          (a) => this.viewItems[a].priority === 2
          /* LayoutPriority.High */
        ), o = this.viewItems[e];
        t = Math.round(t), t = Ns(t, o.minimumSize, Math.min(o.maximumSize, this.size)), o.size = t, this.relayout(i, s);
      } finally {
        this.state = Yh.Idle;
      }
    }
  }
  /**
   * Distribute the entire {@link SplitView} size among all {@link IView views}.
   */
  distributeViewSizes() {
    const e = [];
    let t = 0;
    for (const a of this.viewItems)
      a.maximumSize - a.minimumSize > 0 && (e.push(a), t += a.size);
    const n = Math.floor(t / e.length);
    for (const a of e)
      a.size = Ns(n, a.minimumSize, a.maximumSize);
    const i = ks(this.viewItems.length), s = i.filter(
      (a) => this.viewItems[a].priority === 1
      /* LayoutPriority.Low */
    ), o = i.filter(
      (a) => this.viewItems[a].priority === 2
      /* LayoutPriority.High */
    );
    this.relayout(s, o);
  }
  /**
   * Returns the size of a {@link IView view}.
   */
  getViewSize(e) {
    return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
  }
  doAddView(e, t, n = this.viewItems.length, i) {
    if (this.state !== Yh.Idle)
      throw new Error("Cant modify splitview");
    this.state = Yh.Busy;
    try {
      const s = $e(".split-view-view");
      n === this.viewItems.length ? this.viewContainer.appendChild(s) : this.viewContainer.insertBefore(s, this.viewContainer.children.item(n));
      const o = e.onDidChange((f) => this.onViewChange(d, f)), a = ht(() => s.remove()), l = ih(o, a);
      let c;
      typeof t == "number" ? c = t : (t.type === "auto" && (this.areViewsDistributed() ? t = { type: "distribute" } : t = { type: "split", index: t.index }), t.type === "split" ? c = this.getViewSize(t.index) / 2 : t.type === "invisible" ? c = { cachedVisibleSize: t.cachedVisibleSize } : c = e.minimumSize);
      const d = this.orientation === 0 ? new Gyt(s, e, c, l) : new Qyt(s, e, c, l);
      if (this.viewItems.splice(n, 0, d), this.viewItems.length > 1) {
        const f = { orthogonalStartSash: this.orthogonalStartSash, orthogonalEndSash: this.orthogonalEndSash }, p = this.orientation === 0 ? new bo(this.sashContainer, { getHorizontalSashTop: (L) => this.getSashPosition(L), getHorizontalSashWidth: this.getSashOrthogonalSize }, {
          ...f,
          orientation: 1
          /* Orientation.HORIZONTAL */
        }) : new bo(this.sashContainer, { getVerticalSashLeft: (L) => this.getSashPosition(L), getVerticalSashHeight: this.getSashOrthogonalSize }, {
          ...f,
          orientation: 0
          /* Orientation.VERTICAL */
        }), g = this.orientation === 0 ? (L) => ({ sash: p, start: L.startY, current: L.currentY, alt: L.altKey }) : (L) => ({ sash: p, start: L.startX, current: L.currentX, alt: L.altKey }), A = xe.map(p.onDidStart, g)(this.onSashStart, this), v = xe.map(p.onDidChange, g)(this.onSashChange, this), _ = xe.map(p.onDidEnd, () => this.sashItems.findIndex((L) => L.sash === p))(this.onSashEnd, this), S = p.onDidReset(() => {
          const L = this.sashItems.findIndex((R) => R.sash === p), T = ks(L, -1), B = ks(L + 1, this.viewItems.length), V = this.findFirstSnapIndex(T), N = this.findFirstSnapIndex(B);
          typeof V == "number" && !this.viewItems[V].visible || typeof N == "number" && !this.viewItems[N].visible || this._onDidSashReset.fire(L);
        }), D = ih(A, v, _, S, p), M = { sash: p, disposable: D };
        this.sashItems.splice(n - 1, 0, M);
      }
      s.appendChild(e.element);
      let u;
      typeof t != "number" && t.type === "split" && (u = [t.index]), i || this.relayout([n], u), !i && typeof t != "number" && t.type === "distribute" && this.distributeViewSizes();
    } finally {
      this.state = Yh.Idle;
    }
  }
  relayout(e, t) {
    const n = this.viewItems.reduce((i, s) => i + s.size, 0);
    this.resize(this.viewItems.length - 1, this.size - n, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
  }
  resize(e, t, n = this.viewItems.map((d) => d.size), i, s, o = Number.NEGATIVE_INFINITY, a = Number.POSITIVE_INFINITY, l, c) {
    if (e < 0 || e >= this.viewItems.length)
      return 0;
    const d = ks(e, -1), u = ks(e + 1, this.viewItems.length);
    if (s)
      for (const M of s)
        dE(d, M), dE(u, M);
    if (i)
      for (const M of i)
        yv(d, M), yv(u, M);
    const f = d.map((M) => this.viewItems[M]), p = d.map((M) => n[M]), g = u.map((M) => this.viewItems[M]), m = u.map((M) => n[M]), A = d.reduce((M, L) => M + (this.viewItems[L].minimumSize - n[L]), 0), w = d.reduce((M, L) => M + (this.viewItems[L].maximumSize - n[L]), 0), v = u.length === 0 ? Number.POSITIVE_INFINITY : u.reduce((M, L) => M + (n[L] - this.viewItems[L].minimumSize), 0), y = u.length === 0 ? Number.NEGATIVE_INFINITY : u.reduce((M, L) => M + (n[L] - this.viewItems[L].maximumSize), 0), _ = Math.max(A, y, o), S = Math.min(v, w, a);
    let D = !1;
    if (l) {
      const M = this.viewItems[l.index], L = t >= l.limitDelta;
      D = L !== M.visible, M.setVisible(L, l.size);
    }
    if (!D && c) {
      const M = this.viewItems[c.index], L = t < c.limitDelta;
      D = L !== M.visible, M.setVisible(L, c.size);
    }
    if (D)
      return this.resize(e, t, n, i, s, o, a);
    t = Ns(t, _, S);
    for (let M = 0, L = t; M < f.length; M++) {
      const T = f[M], B = Ns(p[M] + L, T.minimumSize, T.maximumSize), V = B - p[M];
      L -= V, T.size = B;
    }
    for (let M = 0, L = t; M < g.length; M++) {
      const T = g[M], B = Ns(m[M] - L, T.minimumSize, T.maximumSize), V = B - m[M];
      L += V, T.size = B;
    }
    return t;
  }
  distributeEmptySpace(e) {
    const t = this.viewItems.reduce((a, l) => a + l.size, 0);
    let n = this.size - t;
    const i = ks(this.viewItems.length - 1, -1), s = i.filter(
      (a) => this.viewItems[a].priority === 1
      /* LayoutPriority.Low */
    ), o = i.filter(
      (a) => this.viewItems[a].priority === 2
      /* LayoutPriority.High */
    );
    for (const a of o)
      dE(i, a);
    for (const a of s)
      yv(i, a);
    typeof e == "number" && yv(i, e);
    for (let a = 0; n !== 0 && a < i.length; a++) {
      const l = this.viewItems[i[a]], c = Ns(l.size + n, l.minimumSize, l.maximumSize), d = c - l.size;
      n -= d, l.size = c;
    }
  }
  layoutViews() {
    this._contentSize = this.viewItems.reduce((t, n) => t + n.size, 0);
    let e = 0;
    for (const t of this.viewItems)
      t.layout(e, this.layoutContext), e += t.size;
    this.sashItems.forEach((t) => t.sash.layout()), this.updateSashEnablement(), this.updateScrollableElement();
  }
  updateScrollableElement() {
    this.orientation === 0 ? this.scrollableElement.setScrollDimensions({
      height: this.size,
      scrollHeight: this._contentSize
    }) : this.scrollableElement.setScrollDimensions({
      width: this.size,
      scrollWidth: this._contentSize
    });
  }
  updateSashEnablement() {
    let e = !1;
    const t = this.viewItems.map((l) => e = l.size - l.minimumSize > 0 || e);
    e = !1;
    const n = this.viewItems.map((l) => e = l.maximumSize - l.size > 0 || e), i = [...this.viewItems].reverse();
    e = !1;
    const s = i.map((l) => e = l.size - l.minimumSize > 0 || e).reverse();
    e = !1;
    const o = i.map((l) => e = l.maximumSize - l.size > 0 || e).reverse();
    let a = 0;
    for (let l = 0; l < this.sashItems.length; l++) {
      const { sash: c } = this.sashItems[l], d = this.viewItems[l];
      a += d.size;
      const u = !(t[l] && o[l + 1]), f = !(n[l] && s[l + 1]);
      if (u && f) {
        const p = ks(l, -1), g = ks(l + 1, this.viewItems.length), m = this.findFirstSnapIndex(p), A = this.findFirstSnapIndex(g), w = typeof m == "number" && !this.viewItems[m].visible, v = typeof A == "number" && !this.viewItems[A].visible;
        w && s[l] && (a > 0 || this.startSnappingEnabled) ? c.state = 1 : v && t[l] && (a < this._contentSize || this.endSnappingEnabled) ? c.state = 2 : c.state = 0;
      } else u && !f ? c.state = 1 : !u && f ? c.state = 2 : c.state = 3;
    }
  }
  getSashPosition(e) {
    let t = 0;
    for (let n = 0; n < this.sashItems.length; n++)
      if (t += this.viewItems[n].size, this.sashItems[n].sash === e)
        return t;
    return 0;
  }
  findFirstSnapIndex(e) {
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.snap)
        return t;
    }
    for (const t of e) {
      const n = this.viewItems[t];
      if (n.visible && n.maximumSize - n.minimumSize > 0)
        return;
      if (!n.visible && n.snap)
        return t;
    }
  }
  areViewsDistributed() {
    let e, t;
    for (const n of this.viewItems)
      if (e = e === void 0 ? n.size : Math.min(e, n.size), t = t === void 0 ? n.size : Math.max(t, n.size), t - e > 2)
        return !1;
    return !0;
  }
  dispose() {
    this.sashDragState?.disposable.dispose(), br(this.viewItems), this.viewItems = [], this.sashItems.forEach((e) => e.disposable.dispose()), this.sashItems = [], super.dispose();
  }
}
class Ty {
  static {
    this.TemplateId = "row";
  }
  constructor(e, t, n) {
    this.columns = e, this.getColumnSize = n, this.templateId = Ty.TemplateId, this.renderedTemplates = /* @__PURE__ */ new Set();
    const i = new Map(t.map((s) => [s.templateId, s]));
    this.renderers = [];
    for (const s of e) {
      const o = i.get(s.templateId);
      if (!o)
        throw new Error(`Table cell renderer for template id ${s.templateId} not found.`);
      this.renderers.push(o);
    }
  }
  renderTemplate(e) {
    const t = Fe(e, $e(".monaco-table-tr")), n = [], i = [];
    for (let o = 0; o < this.columns.length; o++) {
      const a = this.renderers[o], l = Fe(t, $e(".monaco-table-td", { "data-col-index": o }));
      l.style.width = `${this.getColumnSize(o)}px`, n.push(l), i.push(a.renderTemplate(l));
    }
    const s = { container: e, cellContainers: n, cellTemplateData: i };
    return this.renderedTemplates.add(s), s;
  }
  renderElement(e, t, n, i) {
    for (let s = 0; s < this.columns.length; s++) {
      const a = this.columns[s].project(e);
      this.renderers[s].renderElement(a, t, n.cellTemplateData[s], i);
    }
  }
  disposeElement(e, t, n, i) {
    for (let s = 0; s < this.columns.length; s++) {
      const o = this.renderers[s];
      if (o.disposeElement) {
        const l = this.columns[s].project(e);
        o.disposeElement(l, t, n.cellTemplateData[s], i);
      }
    }
  }
  disposeTemplate(e) {
    for (let t = 0; t < this.columns.length; t++)
      this.renderers[t].disposeTemplate(e.cellTemplateData[t]);
    ic(e.container), this.renderedTemplates.delete(e);
  }
  layoutColumn(e, t) {
    for (const { cellContainers: n } of this.renderedTemplates)
      n[e].style.width = `${t}px`;
  }
}
function Yyt(r) {
  return {
    getHeight(e) {
      return r.getHeight(e);
    },
    getTemplateId() {
      return Ty.TemplateId;
    }
  };
}
class Xyt extends me {
  get minimumSize() {
    return this.column.minimumWidth ?? 120;
  }
  get maximumSize() {
    return this.column.maximumWidth ?? Number.POSITIVE_INFINITY;
  }
  get onDidChange() {
    return this.column.onDidChangeWidthConstraints ?? xe.None;
  }
  constructor(e, t) {
    super(), this.column = e, this.index = t, this._onDidLayout = new $(), this.onDidLayout = this._onDidLayout.event, this.element = $e(".monaco-table-th", { "data-col-index": t }, e.label), e.tooltip && this._register(Mh().setupManagedHover(fo("mouse"), this.element, e.tooltip));
  }
  layout(e) {
    this._onDidLayout.fire([this.index, e]);
  }
}
let Jyt = class XNe {
  static {
    this.InstanceCount = 0;
  }
  get onDidChangeFocus() {
    return this.list.onDidChangeFocus;
  }
  get onDidChangeSelection() {
    return this.list.onDidChangeSelection;
  }
  get onDidScroll() {
    return this.list.onDidScroll;
  }
  get onMouseDblClick() {
    return this.list.onMouseDblClick;
  }
  get onPointer() {
    return this.list.onPointer;
  }
  get onDidFocus() {
    return this.list.onDidFocus;
  }
  get scrollTop() {
    return this.list.scrollTop;
  }
  set scrollTop(e) {
    this.list.scrollTop = e;
  }
  get scrollHeight() {
    return this.list.scrollHeight;
  }
  get renderHeight() {
    return this.list.renderHeight;
  }
  get onDidDispose() {
    return this.list.onDidDispose;
  }
  constructor(e, t, n, i, s, o) {
    this.virtualDelegate = n, this.domId = `table_id_${++XNe.InstanceCount}`, this.disposables = new ze(), this.cachedWidth = 0, this.cachedHeight = 0, this.domNode = Fe(t, $e(`.monaco-table.${this.domId}`));
    const a = i.map((d, u) => this.disposables.add(new Xyt(d, u))), l = {
      size: a.reduce((d, u) => d + u.column.weight, 0),
      views: a.map((d) => ({ size: d.column.weight, view: d }))
    };
    this.splitview = this.disposables.add(new Kyt(this.domNode, {
      orientation: 1,
      scrollbarVisibility: 2,
      getSashOrthogonalSize: () => this.cachedHeight,
      descriptor: l
    })), this.splitview.el.style.height = `${n.headerRowHeight}px`, this.splitview.el.style.lineHeight = `${n.headerRowHeight}px`;
    const c = new Ty(i, s, (d) => this.splitview.getViewSize(d));
    this.list = this.disposables.add(new gc(e, this.domNode, Yyt(n), [c], o)), xe.any(...a.map((d) => d.onDidLayout))(([d, u]) => c.layoutColumn(d, u), null, this.disposables), this.splitview.onDidSashReset((d) => {
      const u = i.reduce((p, g) => p + g.weight, 0), f = i[d].weight / u * this.cachedWidth;
      this.splitview.resizeView(d, f);
    }, null, this.disposables), this.styleElement = ya(this.domNode), this.style(M7t);
  }
  updateOptions(e) {
    this.list.updateOptions(e);
  }
  splice(e, t, n = []) {
    this.list.splice(e, t, n);
  }
  getHTMLElement() {
    return this.domNode;
  }
  style(e) {
    const t = [];
    t.push(`.monaco-table.${this.domId} > .monaco-split-view2 .monaco-sash.vertical::before {
			top: ${this.virtualDelegate.headerRowHeight + 1}px;
			height: calc(100% - ${this.virtualDelegate.headerRowHeight}px);
		}`), this.styleElement.textContent = t.join(`
`), this.list.style(e);
  }
  getSelectedElements() {
    return this.list.getSelectedElements();
  }
  getSelection() {
    return this.list.getSelection();
  }
  getFocus() {
    return this.list.getFocus();
  }
  dispose() {
    this.disposables.dispose();
  }
};
var yo;
(function(r) {
  r[r.Expanded = 0] = "Expanded", r[r.Collapsed = 1] = "Collapsed", r[r.PreserveOrExpanded = 2] = "PreserveOrExpanded", r[r.PreserveOrCollapsed = 3] = "PreserveOrCollapsed";
})(yo || (yo = {}));
var H0;
(function(r) {
  r[r.Unknown = 0] = "Unknown", r[r.Twistie = 1] = "Twistie", r[r.Element = 2] = "Element", r[r.Filter = 3] = "Filter";
})(H0 || (H0 = {}));
class Do extends Error {
  constructor(e, t) {
    super(`TreeError [${e}] ${t}`);
  }
}
class DR {
  constructor(e) {
    this.fn = e, this._map = /* @__PURE__ */ new WeakMap();
  }
  map(e) {
    let t = this._map.get(e);
    return t || (t = this.fn(e), this._map.set(e, t)), t;
  }
}
function LR(r) {
  return typeof r == "object" && "visibility" in r && "data" in r;
}
function h4(r) {
  switch (r) {
    case !0:
      return 1;
    case !1:
      return 0;
    default:
      return r;
  }
}
function x_(r) {
  return typeof r.collapsible == "boolean";
}
class $yt {
  constructor(e, t, n, i = {}) {
    this.user = e, this.list = t, this.rootRef = [], this.eventBufferer = new Aw(), this._onDidChangeCollapseState = new $(), this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event), this._onDidChangeRenderNodeCount = new $(), this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event), this._onDidSplice = new $(), this.onDidSplice = this._onDidSplice.event, this.refilterDelayer = new Uf(hDe), this.collapseByDefault = typeof i.collapseByDefault > "u" ? !1 : i.collapseByDefault, this.allowNonCollapsibleParents = i.allowNonCollapsibleParents ?? !1, this.filter = i.filter, this.autoExpandSingleChildren = typeof i.autoExpandSingleChildren > "u" ? !1 : i.autoExpandSingleChildren, this.root = {
      parent: void 0,
      element: n,
      children: [],
      depth: 0,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: !1,
      collapsed: !1,
      renderNodeCount: 0,
      visibility: 1,
      visible: !0,
      filterData: void 0
    };
  }
  splice(e, t, n = Jt.empty(), i = {}) {
    if (e.length === 0)
      throw new Do(this.user, "Invalid tree location");
    i.diffIdentityProvider ? this.spliceSmart(i.diffIdentityProvider, e, t, n, i) : this.spliceSimple(e, t, n, i);
  }
  spliceSmart(e, t, n, i = Jt.empty(), s, o = s.diffDepth ?? 0) {
    const { parentNode: a } = this.getParentNodeWithListIndex(t);
    if (!a.lastDiffIds)
      return this.spliceSimple(t, n, i, s);
    const l = [...i], c = t[t.length - 1], d = new ld({ getElements: () => a.lastDiffIds }, {
      getElements: () => [
        ...a.children.slice(0, c),
        ...l,
        ...a.children.slice(c + n)
      ].map((m) => e.getId(m.element).toString())
    }).ComputeDiff(!1);
    if (d.quitEarly)
      return a.lastDiffIds = void 0, this.spliceSimple(t, n, l, s);
    const u = t.slice(0, -1), f = (m, A, w) => {
      if (o > 0)
        for (let v = 0; v < w; v++)
          m--, A--, this.spliceSmart(e, [...u, m, 0], Number.MAX_SAFE_INTEGER, l[A].children, s, o - 1);
    };
    let p = Math.min(a.children.length, c + n), g = l.length;
    for (const m of d.changes.sort((A, w) => w.originalStart - A.originalStart))
      f(p, g, p - (m.originalStart + m.originalLength)), p = m.originalStart, g = m.modifiedStart - c, this.spliceSimple([...u, p], m.originalLength, Jt.slice(l, g, g + m.modifiedLength), s);
    f(p, g, p);
  }
  spliceSimple(e, t, n = Jt.empty(), { onDidCreateNode: i, onDidDeleteNode: s, diffIdentityProvider: o }) {
    const { parentNode: a, listIndex: l, revealed: c, visible: d } = this.getParentNodeWithListIndex(e), u = [], f = Jt.map(n, (S) => this.createTreeNode(S, a, a.visible ? 1 : 0, c, u, i)), p = e[e.length - 1];
    let g = 0;
    for (let S = p; S >= 0 && S < a.children.length; S--) {
      const D = a.children[S];
      if (D.visible) {
        g = D.visibleChildIndex;
        break;
      }
    }
    const m = [];
    let A = 0, w = 0;
    for (const S of f)
      m.push(S), w += S.renderNodeCount, S.visible && (S.visibleChildIndex = g + A++);
    const v = hve(a.children, p, t, m);
    o ? a.lastDiffIds ? hve(a.lastDiffIds, p, t, m.map((S) => o.getId(S.element).toString())) : a.lastDiffIds = a.children.map((S) => o.getId(S.element).toString()) : a.lastDiffIds = void 0;
    let y = 0;
    for (const S of v)
      S.visible && y++;
    if (y !== 0)
      for (let S = p + m.length; S < a.children.length; S++) {
        const D = a.children[S];
        D.visible && (D.visibleChildIndex -= y);
      }
    if (a.visibleChildrenCount += A - y, c && d) {
      const S = v.reduce((D, M) => D + (M.visible ? M.renderNodeCount : 0), 0);
      this._updateAncestorsRenderNodeCount(a, w - S), this.list.splice(l, S, u);
    }
    if (v.length > 0 && s) {
      const S = (D) => {
        s(D), D.children.forEach(S);
      };
      v.forEach(S);
    }
    this._onDidSplice.fire({ insertedNodes: m, deletedNodes: v });
    let _ = a;
    for (; _; ) {
      if (_.visibility === 2) {
        this.refilterDelayer.trigger(() => this.refilter());
        break;
      }
      _ = _.parent;
    }
  }
  rerender(e) {
    if (e.length === 0)
      throw new Do(this.user, "Invalid tree location");
    const { node: t, listIndex: n, revealed: i } = this.getTreeNodeWithListIndex(e);
    t.visible && i && this.list.splice(n, 1, [t]);
  }
  has(e) {
    return this.hasTreeNode(e);
  }
  getListIndex(e) {
    const { listIndex: t, visible: n, revealed: i } = this.getTreeNodeWithListIndex(e);
    return n && i ? t : -1;
  }
  getListRenderCount(e) {
    return this.getTreeNode(e).renderNodeCount;
  }
  isCollapsible(e) {
    return this.getTreeNode(e).collapsible;
  }
  setCollapsible(e, t) {
    const n = this.getTreeNode(e);
    typeof t > "u" && (t = !n.collapsible);
    const i = { collapsible: t };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, i));
  }
  isCollapsed(e) {
    return this.getTreeNode(e).collapsed;
  }
  setCollapsed(e, t, n) {
    const i = this.getTreeNode(e);
    typeof t > "u" && (t = !i.collapsed);
    const s = { collapsed: t, recursive: n || !1 };
    return this.eventBufferer.bufferEvents(() => this._setCollapseState(e, s));
  }
  _setCollapseState(e, t) {
    const { node: n, listIndex: i, revealed: s } = this.getTreeNodeWithListIndex(e), o = this._setListNodeCollapseState(n, i, s, t);
    if (n !== this.root && this.autoExpandSingleChildren && o && !x_(t) && n.collapsible && !n.collapsed && !t.recursive) {
      let a = -1;
      for (let l = 0; l < n.children.length; l++)
        if (n.children[l].visible)
          if (a > -1) {
            a = -1;
            break;
          } else
            a = l;
      a > -1 && this._setCollapseState([...e, a], t);
    }
    return o;
  }
  _setListNodeCollapseState(e, t, n, i) {
    const s = this._setNodeCollapseState(e, i, !1);
    if (!n || !e.visible || !s)
      return s;
    const o = e.renderNodeCount, a = this.updateNodeAfterCollapseChange(e), l = o - (t === -1 ? 0 : 1);
    return this.list.splice(t + 1, l, a.slice(1)), s;
  }
  _setNodeCollapseState(e, t, n) {
    let i;
    if (e === this.root ? i = !1 : (x_(t) ? (i = e.collapsible !== t.collapsible, e.collapsible = t.collapsible) : e.collapsible ? (i = e.collapsed !== t.collapsed, e.collapsed = t.collapsed) : i = !1, i && this._onDidChangeCollapseState.fire({ node: e, deep: n })), !x_(t) && t.recursive)
      for (const s of e.children)
        i = this._setNodeCollapseState(s, t, !0) || i;
    return i;
  }
  expandTo(e) {
    this.eventBufferer.bufferEvents(() => {
      let t = this.getTreeNode(e);
      for (; t.parent; )
        t = t.parent, e = e.slice(0, e.length - 1), t.collapsed && this._setCollapseState(e, { collapsed: !1, recursive: !1 });
    });
  }
  refilter() {
    const e = this.root.renderNodeCount, t = this.updateNodeAfterFilterChange(this.root);
    this.list.splice(0, e, t), this.refilterDelayer.cancel();
  }
  createTreeNode(e, t, n, i, s, o) {
    const a = {
      parent: t,
      element: e.element,
      children: [],
      depth: t.depth + 1,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: typeof e.collapsible == "boolean" ? e.collapsible : typeof e.collapsed < "u",
      collapsed: typeof e.collapsed > "u" ? this.collapseByDefault : e.collapsed,
      renderNodeCount: 1,
      visibility: 1,
      visible: !0,
      filterData: void 0
    }, l = this._filterNode(a, n);
    a.visibility = l, i && s.push(a);
    const c = e.children || Jt.empty(), d = i && l !== 0 && !a.collapsed;
    let u = 0, f = 1;
    for (const p of c) {
      const g = this.createTreeNode(p, a, l, d, s, o);
      a.children.push(g), f += g.renderNodeCount, g.visible && (g.visibleChildIndex = u++);
    }
    return this.allowNonCollapsibleParents || (a.collapsible = a.collapsible || a.children.length > 0), a.visibleChildrenCount = u, a.visible = l === 2 ? u > 0 : l === 1, a.visible ? a.collapsed || (a.renderNodeCount = f) : (a.renderNodeCount = 0, i && s.pop()), o?.(a), a;
  }
  updateNodeAfterCollapseChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterCollapseChange(e, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterCollapseChange(e, t) {
    if (e.visible === !1)
      return 0;
    if (t.push(e), e.renderNodeCount = 1, !e.collapsed)
      for (const n of e.children)
        e.renderNodeCount += this._updateNodeAfterCollapseChange(n, t);
    return this._onDidChangeRenderNodeCount.fire(e), e.renderNodeCount;
  }
  updateNodeAfterFilterChange(e) {
    const t = e.renderNodeCount, n = [];
    return this._updateNodeAfterFilterChange(e, e.visible ? 1 : 0, n), this._updateAncestorsRenderNodeCount(e.parent, n.length - t), n;
  }
  _updateNodeAfterFilterChange(e, t, n, i = !0) {
    let s;
    if (e !== this.root) {
      if (s = this._filterNode(e, t), s === 0)
        return e.visible = !1, e.renderNodeCount = 0, !1;
      i && n.push(e);
    }
    const o = n.length;
    e.renderNodeCount = e === this.root ? 0 : 1;
    let a = !1;
    if (!e.collapsed || s !== 0) {
      let l = 0;
      for (const c of e.children)
        a = this._updateNodeAfterFilterChange(c, s, n, i && !e.collapsed) || a, c.visible && (c.visibleChildIndex = l++);
      e.visibleChildrenCount = l;
    } else
      e.visibleChildrenCount = 0;
    return e !== this.root && (e.visible = s === 2 ? a : s === 1, e.visibility = s), e.visible ? e.collapsed || (e.renderNodeCount += n.length - o) : (e.renderNodeCount = 0, i && n.pop()), this._onDidChangeRenderNodeCount.fire(e), e.visible;
  }
  _updateAncestorsRenderNodeCount(e, t) {
    if (t !== 0)
      for (; e; )
        e.renderNodeCount += t, this._onDidChangeRenderNodeCount.fire(e), e = e.parent;
  }
  _filterNode(e, t) {
    const n = this.filter ? this.filter.filter(e.element, t) : 1;
    return typeof n == "boolean" ? (e.filterData = void 0, n ? 1 : 0) : LR(n) ? (e.filterData = n.data, h4(n.visibility)) : (e.filterData = void 0, h4(n));
  }
  // cheap
  hasTreeNode(e, t = this.root) {
    if (!e || e.length === 0)
      return !0;
    const [n, ...i] = e;
    return n < 0 || n > t.children.length ? !1 : this.hasTreeNode(i, t.children[n]);
  }
  // cheap
  getTreeNode(e, t = this.root) {
    if (!e || e.length === 0)
      return t;
    const [n, ...i] = e;
    if (n < 0 || n > t.children.length)
      throw new Do(this.user, "Invalid tree location");
    return this.getTreeNode(i, t.children[n]);
  }
  // expensive
  getTreeNodeWithListIndex(e) {
    if (e.length === 0)
      return { node: this.root, listIndex: -1, revealed: !0, visible: !1 };
    const { parentNode: t, listIndex: n, revealed: i, visible: s } = this.getParentNodeWithListIndex(e), o = e[e.length - 1];
    if (o < 0 || o > t.children.length)
      throw new Do(this.user, "Invalid tree location");
    const a = t.children[o];
    return { node: a, listIndex: n, revealed: i, visible: s && a.visible };
  }
  getParentNodeWithListIndex(e, t = this.root, n = 0, i = !0, s = !0) {
    const [o, ...a] = e;
    if (o < 0 || o > t.children.length)
      throw new Do(this.user, "Invalid tree location");
    for (let l = 0; l < o; l++)
      n += t.children[l].renderNodeCount;
    return i = i && !t.collapsed, s = s && t.visible, a.length === 0 ? { parentNode: t, listIndex: n, revealed: i, visible: s } : this.getParentNodeWithListIndex(a, t.children[o], n + 1, i, s);
  }
  getNode(e = []) {
    return this.getTreeNode(e);
  }
  // TODO@joao perf!
  getNodeLocation(e) {
    const t = [];
    let n = e;
    for (; n.parent; )
      t.push(n.parent.children.indexOf(n)), n = n.parent;
    return t.reverse();
  }
  getParentNodeLocation(e) {
    if (e.length !== 0)
      return e.length === 1 ? [] : out(e)[0];
  }
  getFirstElementChild(e) {
    const t = this.getTreeNode(e);
    if (t.children.length !== 0)
      return t.children[0].element;
  }
}
class eCt extends Iw {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function S_(r) {
  return r instanceof Iw ? new eCt(r) : r;
}
class tCt {
  constructor(e, t) {
    this.modelProvider = e, this.dnd = t, this.autoExpandDisposable = me.None, this.disposables = new ze();
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    this.dnd.onDragStart?.(S_(e), t);
  }
  onDragOver(e, t, n, i, s, o = !0) {
    const a = this.dnd.onDragOver(S_(e), t && t.element, n, i, s), l = this.autoExpandNode !== t;
    if (l && (this.autoExpandDisposable.dispose(), this.autoExpandNode = t), typeof t > "u")
      return a;
    if (l && typeof a != "boolean" && a.autoExpand && (this.autoExpandDisposable = OD(() => {
      const p = this.modelProvider(), g = p.getNodeLocation(t);
      p.isCollapsed(g) && p.setCollapsed(g, !1), this.autoExpandNode = void 0;
    }, 500, this.disposables)), typeof a == "boolean" || !a.accept || typeof a.bubble > "u" || a.feedback) {
      if (!o) {
        const p = typeof a == "boolean" ? a : a.accept, g = typeof a == "boolean" ? void 0 : a.effect;
        return { accept: p, effect: g, feedback: [n] };
      }
      return a;
    }
    if (a.bubble === 1) {
      const p = this.modelProvider(), g = p.getNodeLocation(t), m = p.getParentNodeLocation(g), A = p.getNode(m), w = m && p.getListIndex(m);
      return this.onDragOver(e, A, w, i, s, !1);
    }
    const c = this.modelProvider(), d = c.getNodeLocation(t), u = c.getListIndex(d), f = c.getListRenderCount(d);
    return { ...a, feedback: ks(u, u + f) };
  }
  drop(e, t, n, i, s) {
    this.autoExpandDisposable.dispose(), this.autoExpandNode = void 0, this.dnd.drop(S_(e), t && t.element, n, i, s);
  }
  onDragEnd(e) {
    this.dnd.onDragEnd?.(e);
  }
  dispose() {
    this.disposables.dispose(), this.dnd.dispose();
  }
}
function nCt(r, e) {
  return e && {
    ...e,
    identityProvider: e.identityProvider && {
      getId(t) {
        return e.identityProvider.getId(t.element);
      }
    },
    dnd: e.dnd && new tCt(r, e.dnd),
    multipleSelectionController: e.multipleSelectionController && {
      isSelectionSingleChangeEvent(t) {
        return e.multipleSelectionController.isSelectionSingleChangeEvent({ ...t, element: t.element });
      },
      isSelectionRangeChangeEvent(t) {
        return e.multipleSelectionController.isSelectionRangeChangeEvent({ ...t, element: t.element });
      }
    },
    accessibilityProvider: e.accessibilityProvider && {
      ...e.accessibilityProvider,
      getSetSize(t) {
        const n = r(), i = n.getNodeLocation(t), s = n.getParentNodeLocation(i);
        return n.getNode(s).visibleChildrenCount;
      },
      getPosInSet(t) {
        return t.visibleChildIndex + 1;
      },
      isChecked: e.accessibilityProvider && e.accessibilityProvider.isChecked ? (t) => e.accessibilityProvider.isChecked(t.element) : void 0,
      getRole: e.accessibilityProvider && e.accessibilityProvider.getRole ? (t) => e.accessibilityProvider.getRole(t.element) : () => "treeitem",
      getAriaLabel(t) {
        return e.accessibilityProvider.getAriaLabel(t.element);
      },
      getWidgetAriaLabel() {
        return e.accessibilityProvider.getWidgetAriaLabel();
      },
      getWidgetRole: e.accessibilityProvider && e.accessibilityProvider.getWidgetRole ? () => e.accessibilityProvider.getWidgetRole() : () => "tree",
      getAriaLevel: e.accessibilityProvider && e.accessibilityProvider.getAriaLevel ? (t) => e.accessibilityProvider.getAriaLevel(t.element) : (t) => t.depth,
      getActiveDescendantId: e.accessibilityProvider.getActiveDescendantId && ((t) => e.accessibilityProvider.getActiveDescendantId(t.element))
    },
    keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && {
      ...e.keyboardNavigationLabelProvider,
      getKeyboardNavigationLabel(t) {
        return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t.element);
      }
    }
  };
}
class kR {
  constructor(e) {
    this.delegate = e;
  }
  getHeight(e) {
    return this.delegate.getHeight(e.element);
  }
  getTemplateId(e) {
    return this.delegate.getTemplateId(e.element);
  }
  hasDynamicHeight(e) {
    return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(e.element);
  }
  setDynamicHeight(e, t) {
    this.delegate.setDynamicHeight?.(e.element, t);
  }
}
var yg;
(function(r) {
  r.None = "none", r.OnHover = "onHover", r.Always = "always";
})(yg || (yg = {}));
class iCt {
  get elements() {
    return this._elements;
  }
  constructor(e, t = []) {
    this._elements = t, this.disposables = new ze(), this.onDidChange = xe.forEach(e, (n) => this._elements = n, this.disposables);
  }
  dispose() {
    this.disposables.dispose();
  }
}
class q9 {
  static {
    this.DefaultIndent = 8;
  }
  constructor(e, t, n, i, s, o = {}) {
    this.renderer = e, this.modelProvider = t, this.activeNodes = i, this.renderedIndentGuides = s, this.renderedElements = /* @__PURE__ */ new Map(), this.renderedNodes = /* @__PURE__ */ new Map(), this.indent = q9.DefaultIndent, this.hideTwistiesOfChildlessElements = !1, this.shouldRenderIndentGuides = !1, this.activeIndentNodes = /* @__PURE__ */ new Set(), this.indentGuidesDisposable = me.None, this.disposables = new ze(), this.templateId = e.templateId, this.updateOptions(o), xe.map(n, (a) => a.node)(this.onDidChangeNodeTwistieState, this, this.disposables), e.onDidChangeTwistieState?.(this.onDidChangeTwistieState, this, this.disposables);
  }
  updateOptions(e = {}) {
    if (typeof e.indent < "u") {
      const t = Ns(e.indent, 0, 40);
      if (t !== this.indent) {
        this.indent = t;
        for (const [n, i] of this.renderedNodes)
          this.renderTreeElement(n, i);
      }
    }
    if (typeof e.renderIndentGuides < "u") {
      const t = e.renderIndentGuides !== yg.None;
      if (t !== this.shouldRenderIndentGuides) {
        this.shouldRenderIndentGuides = t;
        for (const [n, i] of this.renderedNodes)
          this._renderIndentGuides(n, i);
        if (this.indentGuidesDisposable.dispose(), t) {
          const n = new ze();
          this.activeNodes.onDidChange(this._onDidChangeActiveNodes, this, n), this.indentGuidesDisposable = n, this._onDidChangeActiveNodes(this.activeNodes.elements);
        }
      }
    }
    typeof e.hideTwistiesOfChildlessElements < "u" && (this.hideTwistiesOfChildlessElements = e.hideTwistiesOfChildlessElements);
  }
  renderTemplate(e) {
    const t = Fe(e, $e(".monaco-tl-row")), n = Fe(t, $e(".monaco-tl-indent")), i = Fe(t, $e(".monaco-tl-twistie")), s = Fe(t, $e(".monaco-tl-contents")), o = this.renderer.renderTemplate(s);
    return { container: e, indent: n, twistie: i, indentGuidesDisposable: me.None, templateData: o };
  }
  renderElement(e, t, n, i) {
    this.renderedNodes.set(e, n), this.renderedElements.set(e.element, e), this.renderTreeElement(e, n), this.renderer.renderElement(e, t, n.templateData, i);
  }
  disposeElement(e, t, n, i) {
    n.indentGuidesDisposable.dispose(), this.renderer.disposeElement?.(e, t, n.templateData, i), typeof i == "number" && (this.renderedNodes.delete(e), this.renderedElements.delete(e.element));
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  onDidChangeTwistieState(e) {
    const t = this.renderedElements.get(e);
    t && this.onDidChangeNodeTwistieState(t);
  }
  onDidChangeNodeTwistieState(e) {
    const t = this.renderedNodes.get(e);
    t && (this._onDidChangeActiveNodes(this.activeNodes.elements), this.renderTreeElement(e, t));
  }
  renderTreeElement(e, t) {
    const n = q9.DefaultIndent + (e.depth - 1) * this.indent;
    t.twistie.style.paddingLeft = `${n}px`, t.indent.style.width = `${n + this.indent - 16}px`, e.collapsible ? t.container.setAttribute("aria-expanded", String(!e.collapsed)) : t.container.removeAttribute("aria-expanded"), t.twistie.classList.remove(...Tt.asClassNameArray(ke.treeItemExpanded));
    let i = !1;
    this.renderer.renderTwistie && (i = this.renderer.renderTwistie(e.element, t.twistie)), e.collapsible && (!this.hideTwistiesOfChildlessElements || e.visibleChildrenCount > 0) ? (i || t.twistie.classList.add(...Tt.asClassNameArray(ke.treeItemExpanded)), t.twistie.classList.add("collapsible"), t.twistie.classList.toggle("collapsed", e.collapsed)) : t.twistie.classList.remove("collapsible", "collapsed"), this._renderIndentGuides(e, t);
  }
  _renderIndentGuides(e, t) {
    if (ic(t.indent), t.indentGuidesDisposable.dispose(), !this.shouldRenderIndentGuides)
      return;
    const n = new ze(), i = this.modelProvider();
    for (; ; ) {
      const s = i.getNodeLocation(e), o = i.getParentNodeLocation(s);
      if (!o)
        break;
      const a = i.getNode(o), l = $e(".indent-guide", { style: `width: ${this.indent}px` });
      this.activeIndentNodes.has(a) && l.classList.add("active"), t.indent.childElementCount === 0 ? t.indent.appendChild(l) : t.indent.insertBefore(l, t.indent.firstElementChild), this.renderedIndentGuides.add(a, l), n.add(ht(() => this.renderedIndentGuides.delete(a, l))), e = a;
    }
    t.indentGuidesDisposable = n;
  }
  _onDidChangeActiveNodes(e) {
    if (!this.shouldRenderIndentGuides)
      return;
    const t = /* @__PURE__ */ new Set(), n = this.modelProvider();
    e.forEach((i) => {
      const s = n.getNodeLocation(i);
      try {
        const o = n.getParentNodeLocation(s);
        i.collapsible && i.children.length > 0 && !i.collapsed ? t.add(i) : o && t.add(n.getNode(o));
      } catch {
      }
    }), this.activeIndentNodes.forEach((i) => {
      t.has(i) || this.renderedIndentGuides.forEach(i, (s) => s.classList.remove("active"));
    }), t.forEach((i) => {
      this.activeIndentNodes.has(i) || this.renderedIndentGuides.forEach(i, (s) => s.classList.add("active"));
    }), this.activeIndentNodes = t;
  }
  dispose() {
    this.renderedNodes.clear(), this.renderedElements.clear(), this.indentGuidesDisposable.dispose(), br(this.disposables);
  }
}
class rCt {
  get totalCount() {
    return this._totalCount;
  }
  get matchCount() {
    return this._matchCount;
  }
  constructor(e, t, n) {
    this.tree = e, this.keyboardNavigationLabelProvider = t, this._filter = n, this._totalCount = 0, this._matchCount = 0, this._pattern = "", this._lowercasePattern = "", this.disposables = new ze(), e.onWillRefilter(this.reset, this, this.disposables);
  }
  filter(e, t) {
    let n = 1;
    if (this._filter) {
      const o = this._filter.filter(e, t);
      if (typeof o == "boolean" ? n = o ? 1 : 0 : LR(o) ? n = h4(o.visibility) : n = o, n === 0)
        return !1;
    }
    if (this._totalCount++, !this._pattern)
      return this._matchCount++, { data: kp.Default, visibility: n };
    const i = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e), s = Array.isArray(i) ? i : [i];
    for (const o of s) {
      const a = o && o.toString();
      if (typeof a > "u")
        return { data: kp.Default, visibility: n };
      let l;
      if (this.tree.findMatchType === xf.Contiguous) {
        const c = a.toLowerCase().indexOf(this._lowercasePattern);
        if (c > -1) {
          l = [Number.MAX_SAFE_INTEGER, 0];
          for (let d = this._lowercasePattern.length; d > 0; d--)
            l.push(c + d - 1);
        }
      } else
        l = fNe(this._pattern, this._lowercasePattern, 0, a, a.toLowerCase(), 0, { firstMatchCanBeWeak: !0, boostFullMatch: !0 });
      if (l)
        return this._matchCount++, s.length === 1 ? { data: l, visibility: n } : { data: { label: a, score: l }, visibility: n };
    }
    return this.tree.findMode === gd.Filter ? typeof this.tree.options.defaultFindVisibility == "number" ? this.tree.options.defaultFindVisibility : this.tree.options.defaultFindVisibility ? this.tree.options.defaultFindVisibility(e) : 2 : { data: kp.Default, visibility: n };
  }
  reset() {
    this._totalCount = 0, this._matchCount = 0;
  }
  dispose() {
    br(this.disposables);
  }
}
var gd;
(function(r) {
  r[r.Highlight = 0] = "Highlight", r[r.Filter = 1] = "Filter";
})(gd || (gd = {}));
var xf;
(function(r) {
  r[r.Fuzzy = 0] = "Fuzzy", r[r.Contiguous = 1] = "Contiguous";
})(xf || (xf = {}));
let sCt = class {
  get pattern() {
    return this._pattern;
  }
  get mode() {
    return this._mode;
  }
  set mode(e) {
    e !== this._mode && (this._mode = e, this.widget && (this.widget.mode = this._mode), this.tree.refilter(), this.render(), this._onDidChangeMode.fire(e));
  }
  get matchType() {
    return this._matchType;
  }
  set matchType(e) {
    e !== this._matchType && (this._matchType = e, this.widget && (this.widget.matchType = this._matchType), this.tree.refilter(), this.render(), this._onDidChangeMatchType.fire(e));
  }
  constructor(e, t, n, i, s, o = {}) {
    this.tree = e, this.view = n, this.filter = i, this.contextViewProvider = s, this.options = o, this._pattern = "", this.width = 0, this._onDidChangeMode = new $(), this.onDidChangeMode = this._onDidChangeMode.event, this._onDidChangeMatchType = new $(), this.onDidChangeMatchType = this._onDidChangeMatchType.event, this._onDidChangePattern = new $(), this._onDidChangeOpenState = new $(), this.onDidChangeOpenState = this._onDidChangeOpenState.event, this.enabledDisposables = new ze(), this.disposables = new ze(), this._mode = e.options.defaultFindMode ?? gd.Highlight, this._matchType = e.options.defaultFindMatchType ?? xf.Fuzzy, t.onDidSplice(this.onDidSpliceModel, this, this.disposables);
  }
  updateOptions(e = {}) {
    e.defaultFindMode !== void 0 && (this.mode = e.defaultFindMode), e.defaultFindMatchType !== void 0 && (this.matchType = e.defaultFindMatchType);
  }
  onDidSpliceModel() {
    !this.widget || this.pattern.length === 0 || (this.tree.refilter(), this.render());
  }
  render() {
    const e = this.filter.totalCount > 0 && this.filter.matchCount === 0;
    this.pattern && e ? this.tree.options.showNotFoundMessage ?? !0 ? this.widget?.showMessage({ type: 2, content: C("not found", "No elements found.") }) : this.widget?.showMessage({
      type: 2
      /* MessageType.WARNING */
    }) : this.widget?.clearMessage();
  }
  shouldAllowFocus(e) {
    return !this.widget || !this.pattern || this.filter.totalCount > 0 && this.filter.matchCount <= 1 ? !0 : !kp.isDefault(e.filterData);
  }
  layout(e) {
    this.width = e, this.widget?.layout(e);
  }
  dispose() {
    this._history = void 0, this._onDidChangePattern.dispose(), this.enabledDisposables.dispose(), this.disposables.dispose();
  }
};
function oCt(r, e) {
  return r.position === e.position && JNe(r, e);
}
function JNe(r, e) {
  return r.node.element === e.node.element && r.startIndex === e.startIndex && r.height === e.height && r.endIndex === e.endIndex;
}
class aCt {
  constructor(e = []) {
    this.stickyNodes = e;
  }
  get count() {
    return this.stickyNodes.length;
  }
  equal(e) {
    return Zi(this.stickyNodes, e.stickyNodes, oCt);
  }
  lastNodePartiallyVisible() {
    if (this.count === 0)
      return !1;
    const e = this.stickyNodes[this.count - 1];
    if (this.count === 1)
      return e.position !== 0;
    const t = this.stickyNodes[this.count - 2];
    return t.position + t.height !== e.position;
  }
  animationStateChanged(e) {
    if (!Zi(this.stickyNodes, e.stickyNodes, JNe) || this.count === 0)
      return !1;
    const t = this.stickyNodes[this.count - 1], n = e.stickyNodes[e.count - 1];
    return t.position !== n.position;
  }
}
class lCt {
  constrainStickyScrollNodes(e, t, n) {
    for (let i = 0; i < e.length; i++) {
      const s = e[i];
      if (s.position + s.height > n || i >= t)
        return e.slice(0, i);
    }
    return e;
  }
}
class E9e extends me {
  constructor(e, t, n, i, s, o = {}) {
    super(), this.tree = e, this.model = t, this.view = n, this.treeDelegate = s, this.maxWidgetViewRatio = 0.4;
    const a = this.validateStickySettings(o);
    this.stickyScrollMaxItemCount = a.stickyScrollMaxItemCount, this.stickyScrollDelegate = o.stickyScrollDelegate ?? new lCt(), this._widget = this._register(new cCt(n.getScrollableElement(), n, e, i, s, o.accessibilityProvider)), this.onDidChangeHasFocus = this._widget.onDidChangeHasFocus, this.onContextMenu = this._widget.onContextMenu, this._register(n.onDidScroll(() => this.update())), this._register(n.onDidChangeContentHeight(() => this.update())), this._register(e.onDidChangeCollapseState(() => this.update())), this.update();
  }
  get height() {
    return this._widget.height;
  }
  getNodeAtHeight(e) {
    let t;
    if (e === 0 ? t = this.view.firstVisibleIndex : t = this.view.indexAt(e + this.view.scrollTop), !(t < 0 || t >= this.view.length))
      return this.view.element(t);
  }
  update() {
    const e = this.getNodeAtHeight(0);
    if (!e || this.tree.scrollTop === 0) {
      this._widget.setState(void 0);
      return;
    }
    const t = this.findStickyState(e);
    this._widget.setState(t);
  }
  findStickyState(e) {
    const t = [];
    let n = e, i = 0, s = this.getNextStickyNode(n, void 0, i);
    for (; s && (t.push(s), i += s.height, !(t.length <= this.stickyScrollMaxItemCount && (n = this.getNextVisibleNode(s), !n))); )
      s = this.getNextStickyNode(n, s.node, i);
    const o = this.constrainStickyNodes(t);
    return o.length ? new aCt(o) : void 0;
  }
  getNextVisibleNode(e) {
    return this.getNodeAtHeight(e.position + e.height);
  }
  getNextStickyNode(e, t, n) {
    const i = this.getAncestorUnderPrevious(e, t);
    if (i && !(i === e && (!this.nodeIsUncollapsedParent(e) || this.nodeTopAlignsWithStickyNodesBottom(e, n))))
      return this.createStickyScrollNode(i, n);
  }
  nodeTopAlignsWithStickyNodesBottom(e, t) {
    const n = this.getNodeIndex(e), i = this.view.getElementTop(n), s = t;
    return this.view.scrollTop === i - s;
  }
  createStickyScrollNode(e, t) {
    const n = this.treeDelegate.getHeight(e), { startIndex: i, endIndex: s } = this.getNodeRange(e), o = this.calculateStickyNodePosition(s, t, n);
    return { node: e, position: o, height: n, startIndex: i, endIndex: s };
  }
  getAncestorUnderPrevious(e, t = void 0) {
    let n = e, i = this.getParentNode(n);
    for (; i; ) {
      if (i === t)
        return n;
      n = i, i = this.getParentNode(n);
    }
    if (t === void 0)
      return n;
  }
  calculateStickyNodePosition(e, t, n) {
    let i = this.view.getRelativeTop(e);
    if (i === null && this.view.firstVisibleIndex === e && e + 1 < this.view.length) {
      const c = this.treeDelegate.getHeight(this.view.element(e)), d = this.view.getRelativeTop(e + 1);
      i = d ? d - c / this.view.renderHeight : null;
    }
    if (i === null)
      return t;
    const s = this.view.element(e), o = this.treeDelegate.getHeight(s), l = i * this.view.renderHeight + o;
    return t + n > l && t <= l ? l - n : t;
  }
  constrainStickyNodes(e) {
    if (e.length === 0)
      return [];
    const t = this.view.renderHeight * this.maxWidgetViewRatio, n = e[e.length - 1];
    if (e.length <= this.stickyScrollMaxItemCount && n.position + n.height <= t)
      return e;
    const i = this.stickyScrollDelegate.constrainStickyScrollNodes(e, this.stickyScrollMaxItemCount, t);
    if (!i.length)
      return [];
    const s = i[i.length - 1];
    if (i.length > this.stickyScrollMaxItemCount || s.position + s.height > t)
      throw new Error("stickyScrollDelegate violates constraints");
    return i;
  }
  getParentNode(e) {
    const t = this.model.getNodeLocation(e), n = this.model.getParentNodeLocation(t);
    return n ? this.model.getNode(n) : void 0;
  }
  nodeIsUncollapsedParent(e) {
    const t = this.model.getNodeLocation(e);
    return this.model.getListRenderCount(t) > 1;
  }
  getNodeIndex(e) {
    const t = this.model.getNodeLocation(e);
    return this.model.getListIndex(t);
  }
  getNodeRange(e) {
    const t = this.model.getNodeLocation(e), n = this.model.getListIndex(t);
    if (n < 0)
      throw new Error("Node not found in tree");
    const i = this.model.getListRenderCount(t), s = n + i - 1;
    return { startIndex: n, endIndex: s };
  }
  nodePositionTopBelowWidget(e) {
    const t = [];
    let n = this.getParentNode(e);
    for (; n; )
      t.push(n), n = this.getParentNode(n);
    let i = 0;
    for (let s = 0; s < t.length && s < this.stickyScrollMaxItemCount; s++)
      i += this.treeDelegate.getHeight(t[s]);
    return i;
  }
  domFocus() {
    this._widget.domFocus();
  }
  // Whether sticky scroll was the last focused part in the tree or not
  focusedLast() {
    return this._widget.focusedLast();
  }
  updateOptions(e = {}) {
    if (!e.stickyScrollMaxItemCount)
      return;
    const t = this.validateStickySettings(e);
    this.stickyScrollMaxItemCount !== t.stickyScrollMaxItemCount && (this.stickyScrollMaxItemCount = t.stickyScrollMaxItemCount, this.update());
  }
  validateStickySettings(e) {
    let t = 7;
    return typeof e.stickyScrollMaxItemCount == "number" && (t = Math.max(e.stickyScrollMaxItemCount, 1)), { stickyScrollMaxItemCount: t };
  }
}
class cCt {
  constructor(e, t, n, i, s, o) {
    this.view = t, this.tree = n, this.treeRenderers = i, this.treeDelegate = s, this.accessibilityProvider = o, this._previousElements = [], this._previousStateDisposables = new ze(), this._rootDomNode = $e(".monaco-tree-sticky-container.empty"), e.appendChild(this._rootDomNode);
    const a = $e(".monaco-tree-sticky-container-shadow");
    this._rootDomNode.appendChild(a), this.stickyScrollFocus = new hCt(this._rootDomNode, t), this.onDidChangeHasFocus = this.stickyScrollFocus.onDidChangeHasFocus, this.onContextMenu = this.stickyScrollFocus.onContextMenu;
  }
  get height() {
    if (!this._previousState)
      return 0;
    const e = this._previousState.stickyNodes[this._previousState.count - 1];
    return e.position + e.height;
  }
  setState(e) {
    const t = !!this._previousState && this._previousState.count > 0, n = !!e && e.count > 0;
    if (!t && !n || t && n && this._previousState.equal(e))
      return;
    if (t !== n && this.setVisible(n), !n) {
      this._previousState = void 0, this._previousElements = [], this._previousStateDisposables.clear();
      return;
    }
    const i = e.stickyNodes[e.count - 1];
    if (this._previousState && e.animationStateChanged(this._previousState))
      this._previousElements[this._previousState.count - 1].style.top = `${i.position}px`;
    else {
      this._previousStateDisposables.clear();
      const s = Array(e.count);
      for (let o = e.count - 1; o >= 0; o--) {
        const a = e.stickyNodes[o], { element: l, disposable: c } = this.createElement(a, o, e.count);
        s[o] = l, this._rootDomNode.appendChild(l), this._previousStateDisposables.add(c);
      }
      this.stickyScrollFocus.updateElements(s, e), this._previousElements = s;
    }
    this._previousState = e, this._rootDomNode.style.height = `${i.position + i.height}px`;
  }
  createElement(e, t, n) {
    const i = e.startIndex, s = document.createElement("div");
    s.style.top = `${e.position}px`, this.tree.options.setRowHeight !== !1 && (s.style.height = `${e.height}px`), this.tree.options.setRowLineHeight !== !1 && (s.style.lineHeight = `${e.height}px`), s.classList.add("monaco-tree-sticky-row"), s.classList.add("monaco-list-row"), s.setAttribute("data-index", `${i}`), s.setAttribute("data-parity", i % 2 === 0 ? "even" : "odd"), s.setAttribute("id", this.view.getElementID(i));
    const o = this.setAccessibilityAttributes(s, e.node.element, t, n), a = this.treeDelegate.getTemplateId(e.node), l = this.treeRenderers.find((f) => f.templateId === a);
    if (!l)
      throw new Error(`No renderer found for template id ${a}`);
    let c = e.node;
    c === this.tree.getNode(this.tree.getNodeLocation(e.node)) && (c = new Proxy(e.node, {}));
    const d = l.renderTemplate(s);
    l.renderElement(c, e.startIndex, d, e.height);
    const u = ht(() => {
      o.dispose(), l.disposeElement(c, e.startIndex, d, e.height), l.disposeTemplate(d), s.remove();
    });
    return { element: s, disposable: u };
  }
  setAccessibilityAttributes(e, t, n, i) {
    if (!this.accessibilityProvider)
      return me.None;
    this.accessibilityProvider.getSetSize && e.setAttribute("aria-setsize", String(this.accessibilityProvider.getSetSize(t, n, i))), this.accessibilityProvider.getPosInSet && e.setAttribute("aria-posinset", String(this.accessibilityProvider.getPosInSet(t, n))), this.accessibilityProvider.getRole && e.setAttribute("role", this.accessibilityProvider.getRole(t) ?? "treeitem");
    const s = this.accessibilityProvider.getAriaLabel(t), o = s && typeof s != "string" ? s : R9(s), a = nn((c) => {
      const d = c.readObservable(o);
      d ? e.setAttribute("aria-label", d) : e.removeAttribute("aria-label");
    });
    typeof s == "string" || s && e.setAttribute("aria-label", s.get());
    const l = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(t);
    return typeof l == "number" && e.setAttribute("aria-level", `${l}`), e.setAttribute("aria-selected", String(!1)), a;
  }
  setVisible(e) {
    this._rootDomNode.classList.toggle("empty", !e), e || this.stickyScrollFocus.updateElements([], void 0);
  }
  domFocus() {
    this.stickyScrollFocus.domFocus();
  }
  focusedLast() {
    return this.stickyScrollFocus.focusedLast();
  }
  dispose() {
    this.stickyScrollFocus.dispose(), this._previousStateDisposables.dispose(), this._rootDomNode.remove();
  }
}
class hCt extends me {
  get domHasFocus() {
    return this._domHasFocus;
  }
  set domHasFocus(e) {
    e !== this._domHasFocus && (this._onDidChangeHasFocus.fire(e), this._domHasFocus = e);
  }
  constructor(e, t) {
    super(), this.container = e, this.view = t, this.focusedIndex = -1, this.elements = [], this._onDidChangeHasFocus = new $(), this.onDidChangeHasFocus = this._onDidChangeHasFocus.event, this._onContextMenu = new $(), this.onContextMenu = this._onContextMenu.event, this._domHasFocus = !1, this._register(fe(this.container, "focus", () => this.onFocus())), this._register(fe(this.container, "blur", () => this.onBlur())), this._register(this.view.onDidFocus(() => this.toggleStickyScrollFocused(!1))), this._register(this.view.onKeyDown((n) => this.onKeyDown(n))), this._register(this.view.onMouseDown((n) => this.onMouseDown(n))), this._register(this.view.onContextMenu((n) => this.handleContextMenu(n)));
  }
  handleContextMenu(e) {
    const t = e.browserEvent.target;
    if (!l4(t) && !s3(t)) {
      this.focusedLast() && this.view.domFocus();
      return;
    }
    if (!Xh(e.browserEvent)) {
      if (!this.state)
        throw new Error("Context menu should not be triggered when state is undefined");
      const o = this.state.stickyNodes.findIndex((a) => a.node.element === e.element?.element);
      if (o === -1)
        throw new Error("Context menu should not be triggered when element is not in sticky scroll widget");
      this.container.focus(), this.setFocus(o);
      return;
    }
    if (!this.state || this.focusedIndex < 0)
      throw new Error("Context menu key should not be triggered when focus is not in sticky scroll widget");
    const i = this.state.stickyNodes[this.focusedIndex].node.element, s = this.elements[this.focusedIndex];
    this._onContextMenu.fire({ element: i, anchor: s, browserEvent: e.browserEvent, isStickyScroll: !0 });
  }
  onKeyDown(e) {
    if (this.domHasFocus && this.state) {
      if (e.key === "ArrowUp")
        this.setFocusedElement(Math.max(0, this.focusedIndex - 1)), e.preventDefault(), e.stopPropagation();
      else if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        if (this.focusedIndex >= this.state.count - 1) {
          const t = this.state.stickyNodes[this.state.count - 1].startIndex + 1;
          this.view.domFocus(), this.view.setFocus([t]), this.scrollNodeUnderWidget(t, this.state);
        } else
          this.setFocusedElement(this.focusedIndex + 1);
        e.preventDefault(), e.stopPropagation();
      }
    }
  }
  onMouseDown(e) {
    const t = e.browserEvent.target;
    !l4(t) && !s3(t) || (e.browserEvent.preventDefault(), e.browserEvent.stopPropagation());
  }
  updateElements(e, t) {
    if (t && t.count === 0)
      throw new Error("Sticky scroll state must be undefined when there are no sticky nodes");
    if (t && t.count !== e.length)
      throw new Error("Sticky scroll focus received illigel state");
    const n = this.focusedIndex;
    if (this.removeFocus(), this.elements = e, this.state = t, t) {
      const i = Ns(n, 0, t.count - 1);
      this.setFocus(i);
    } else
      this.domHasFocus && this.view.domFocus();
    this.container.tabIndex = t ? 0 : -1;
  }
  setFocusedElement(e) {
    const t = this.state;
    if (!t)
      throw new Error("Cannot set focus when state is undefined");
    if (this.setFocus(e), !(e < t.count - 1) && t.lastNodePartiallyVisible()) {
      const n = t.stickyNodes[e];
      this.scrollNodeUnderWidget(n.endIndex + 1, t);
    }
  }
  scrollNodeUnderWidget(e, t) {
    const n = t.stickyNodes[t.count - 1], i = t.count > 1 ? t.stickyNodes[t.count - 2] : void 0, s = this.view.getElementTop(e), o = i ? i.position + i.height + n.height : n.height;
    this.view.scrollTop = s - o;
  }
  domFocus() {
    if (!this.state)
      throw new Error("Cannot focus when state is undefined");
    this.container.focus();
  }
  focusedLast() {
    return this.state ? this.view.getHTMLElement().classList.contains("sticky-scroll-focused") : !1;
  }
  removeFocus() {
    this.focusedIndex !== -1 && (this.toggleElementFocus(this.elements[this.focusedIndex], !1), this.focusedIndex = -1);
  }
  setFocus(e) {
    if (0 > e)
      throw new Error("addFocus() can not remove focus");
    if (!this.state && e >= 0)
      throw new Error("Cannot set focus index when state is undefined");
    if (this.state && e >= this.state.count)
      throw new Error("Cannot set focus index to an index that does not exist");
    const t = this.focusedIndex;
    t >= 0 && this.toggleElementFocus(this.elements[t], !1), e >= 0 && this.toggleElementFocus(this.elements[e], !0), this.focusedIndex = e;
  }
  toggleElementFocus(e, t) {
    this.toggleElementActiveFocus(e, t && this.domHasFocus), this.toggleElementPassiveFocus(e, t);
  }
  toggleCurrentElementActiveFocus(e) {
    this.focusedIndex !== -1 && this.toggleElementActiveFocus(this.elements[this.focusedIndex], e);
  }
  toggleElementActiveFocus(e, t) {
    e.classList.toggle("focused", t);
  }
  toggleElementPassiveFocus(e, t) {
    e.classList.toggle("passive-focused", t);
  }
  toggleStickyScrollFocused(e) {
    this.view.getHTMLElement().classList.toggle("sticky-scroll-focused", e);
  }
  onFocus() {
    if (!this.state || this.elements.length === 0)
      throw new Error("Cannot focus when state is undefined or elements are empty");
    this.domHasFocus = !0, this.toggleStickyScrollFocused(!0), this.toggleCurrentElementActiveFocus(!0), this.focusedIndex === -1 && this.setFocus(0);
  }
  onBlur() {
    this.domHasFocus = !1, this.toggleCurrentElementActiveFocus(!1);
  }
  dispose() {
    this.toggleStickyScrollFocused(!1), this._onDidChangeHasFocus.fire(!1), super.dispose();
  }
}
function s5(r) {
  let e = H0.Unknown;
  return SE(r.browserEvent.target, "monaco-tl-twistie", "monaco-tl-row") ? e = H0.Twistie : SE(r.browserEvent.target, "monaco-tl-contents", "monaco-tl-row") ? e = H0.Element : SE(r.browserEvent.target, "monaco-tree-type-filter", "monaco-list") && (e = H0.Filter), {
    browserEvent: r.browserEvent,
    element: r.element ? r.element.element : null,
    target: e
  };
}
function dCt(r) {
  const e = l4(r.browserEvent.target);
  return {
    element: r.element ? r.element.element : null,
    browserEvent: r.browserEvent,
    anchor: r.anchor,
    isStickyScroll: e
  };
}
function N6(r, e) {
  e(r), r.children.forEach((t) => N6(t, e));
}
class M_ {
  get nodeSet() {
    return this._nodeSet || (this._nodeSet = this.createNodeSet()), this._nodeSet;
  }
  constructor(e, t) {
    this.getFirstViewElementWithTrait = e, this.identityProvider = t, this.nodes = [], this._onDidChange = new $(), this.onDidChange = this._onDidChange.event;
  }
  set(e, t) {
    !t?.__forceEvent && Zi(this.nodes, e) || this._set(e, !1, t);
  }
  _set(e, t, n) {
    if (this.nodes = [...e], this.elements = void 0, this._nodeSet = void 0, !t) {
      const i = this;
      this._onDidChange.fire({ get elements() {
        return i.get();
      }, browserEvent: n });
    }
  }
  get() {
    return this.elements || (this.elements = this.nodes.map((e) => e.element)), [...this.elements];
  }
  getNodes() {
    return this.nodes;
  }
  has(e) {
    return this.nodeSet.has(e);
  }
  onDidModelSplice({ insertedNodes: e, deletedNodes: t }) {
    if (!this.identityProvider) {
      const l = this.createNodeSet(), c = (d) => l.delete(d);
      t.forEach((d) => N6(d, c)), this.set([...l.values()]);
      return;
    }
    const n = /* @__PURE__ */ new Set(), i = (l) => n.add(this.identityProvider.getId(l.element).toString());
    t.forEach((l) => N6(l, i));
    const s = /* @__PURE__ */ new Map(), o = (l) => s.set(this.identityProvider.getId(l.element).toString(), l);
    e.forEach((l) => N6(l, o));
    const a = [];
    for (const l of this.nodes) {
      const c = this.identityProvider.getId(l.element).toString();
      if (!n.has(c))
        a.push(l);
      else {
        const u = s.get(c);
        u && u.visible && a.push(u);
      }
    }
    if (this.nodes.length > 0 && a.length === 0) {
      const l = this.getFirstViewElementWithTrait();
      l && a.push(l);
    }
    this._set(a, !0);
  }
  createNodeSet() {
    const e = /* @__PURE__ */ new Set();
    for (const t of this.nodes)
      e.add(t);
    return e;
  }
}
class uCt extends RNe {
  constructor(e, t, n) {
    super(e), this.tree = t, this.stickyScrollProvider = n;
  }
  onViewPointer(e) {
    if (NNe(e.browserEvent.target) || e1(e.browserEvent.target) || CA(e.browserEvent.target) || e.browserEvent.isHandledByList)
      return;
    const t = e.element;
    if (!t)
      return super.onViewPointer(e);
    if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e))
      return super.onViewPointer(e);
    const n = e.browserEvent.target, i = n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && e.browserEvent.offsetX < 16, s = s3(e.browserEvent.target);
    let o = !1;
    if (s ? o = !0 : typeof this.tree.expandOnlyOnTwistieClick == "function" ? o = this.tree.expandOnlyOnTwistieClick(t.element) : o = !!this.tree.expandOnlyOnTwistieClick, s)
      this.handleStickyScrollMouseEvent(e, t);
    else {
      if (o && !i && e.browserEvent.detail !== 2)
        return super.onViewPointer(e);
      if (!this.tree.expandOnDoubleClick && e.browserEvent.detail === 2)
        return super.onViewPointer(e);
    }
    if (t.collapsible && (!s || i)) {
      const a = this.tree.getNodeLocation(t), l = e.browserEvent.altKey;
      if (this.tree.setFocus([a]), this.tree.toggleCollapsed(a, l), i) {
        e.browserEvent.isHandledByList = !0;
        return;
      }
    }
    s || super.onViewPointer(e);
  }
  handleStickyScrollMouseEvent(e, t) {
    if (y7t(e.browserEvent.target) || C7t(e.browserEvent.target))
      return;
    const n = this.stickyScrollProvider();
    if (!n)
      throw new Error("Sticky scroll controller not found");
    const i = this.list.indexOf(t), s = this.list.getElementTop(i), o = n.nodePositionTopBelowWidget(t);
    this.tree.scrollTop = s - o, this.list.domFocus(), this.list.setFocus([i]), this.list.setSelection([i]);
  }
  onDoubleClick(e) {
    e.browserEvent.target.classList.contains("monaco-tl-twistie") || !this.tree.expandOnDoubleClick || e.browserEvent.isHandledByList || super.onDoubleClick(e);
  }
  // to make sure dom focus is not stolen (for example with context menu)
  onMouseDown(e) {
    const t = e.browserEvent.target;
    if (!l4(t) && !s3(t)) {
      super.onMouseDown(e);
      return;
    }
  }
  onContextMenu(e) {
    const t = e.browserEvent.target;
    if (!l4(t) && !s3(t)) {
      super.onContextMenu(e);
      return;
    }
  }
}
class fCt extends gc {
  constructor(e, t, n, i, s, o, a, l) {
    super(e, t, n, i, l), this.focusTrait = s, this.selectionTrait = o, this.anchorTrait = a;
  }
  createMouseController(e) {
    return new uCt(this, e.tree, e.stickyScrollProvider);
  }
  splice(e, t, n = []) {
    if (super.splice(e, t, n), n.length === 0)
      return;
    const i = [], s = [];
    let o;
    n.forEach((a, l) => {
      this.focusTrait.has(a) && i.push(e + l), this.selectionTrait.has(a) && s.push(e + l), this.anchorTrait.has(a) && (o = e + l);
    }), i.length > 0 && super.setFocus(ff([...super.getFocus(), ...i])), s.length > 0 && super.setSelection(ff([...super.getSelection(), ...s])), typeof o == "number" && super.setAnchor(o);
  }
  setFocus(e, t, n = !1) {
    super.setFocus(e, t), n || this.focusTrait.set(e.map((i) => this.element(i)), t);
  }
  setSelection(e, t, n = !1) {
    super.setSelection(e, t), n || this.selectionTrait.set(e.map((i) => this.element(i)), t);
  }
  setAnchor(e, t = !1) {
    super.setAnchor(e), t || (typeof e > "u" ? this.anchorTrait.set([]) : this.anchorTrait.set([this.element(e)]));
  }
}
class $Ne {
  get onDidScroll() {
    return this.view.onDidScroll;
  }
  get onDidChangeFocus() {
    return this.eventBufferer.wrapEvent(this.focus.onDidChange);
  }
  get onDidChangeSelection() {
    return this.eventBufferer.wrapEvent(this.selection.onDidChange);
  }
  get onMouseDblClick() {
    return xe.filter(xe.map(this.view.onMouseDblClick, s5), (e) => e.target !== H0.Filter);
  }
  get onMouseOver() {
    return xe.map(this.view.onMouseOver, s5);
  }
  get onMouseOut() {
    return xe.map(this.view.onMouseOut, s5);
  }
  get onContextMenu() {
    return xe.any(xe.filter(xe.map(this.view.onContextMenu, dCt), (e) => !e.isStickyScroll), this.stickyScrollController?.onContextMenu ?? xe.None);
  }
  get onPointer() {
    return xe.map(this.view.onPointer, s5);
  }
  get onKeyDown() {
    return this.view.onKeyDown;
  }
  get onDidFocus() {
    return this.view.onDidFocus;
  }
  get onDidChangeModel() {
    return xe.signal(this.model.onDidSplice);
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get findMode() {
    return this.findController?.mode ?? gd.Highlight;
  }
  set findMode(e) {
    this.findController && (this.findController.mode = e);
  }
  get findMatchType() {
    return this.findController?.matchType ?? xf.Fuzzy;
  }
  set findMatchType(e) {
    this.findController && (this.findController.matchType = e);
  }
  get expandOnDoubleClick() {
    return typeof this._options.expandOnDoubleClick > "u" ? !0 : this._options.expandOnDoubleClick;
  }
  get expandOnlyOnTwistieClick() {
    return typeof this._options.expandOnlyOnTwistieClick > "u" ? !0 : this._options.expandOnlyOnTwistieClick;
  }
  get onDidDispose() {
    return this.view.onDidDispose;
  }
  constructor(e, t, n, i, s = {}) {
    this._user = e, this._options = s, this.eventBufferer = new Aw(), this.onDidChangeFindOpenState = xe.None, this.onDidChangeStickyScrollFocused = xe.None, this.disposables = new ze(), this._onWillRefilter = new $(), this.onWillRefilter = this._onWillRefilter.event, this._onDidUpdateOptions = new $(), this.treeDelegate = new kR(n);
    const o = new wve(), a = new wve(), l = this.disposables.add(new iCt(a.event)), c = new sLe();
    this.renderers = i.map((g) => new q9(g, () => this.model, o.event, l, c, s));
    for (const g of this.renderers)
      this.disposables.add(g);
    let d;
    s.keyboardNavigationLabelProvider && (d = new rCt(this, s.keyboardNavigationLabelProvider, s.filter), s = { ...s, filter: d }, this.disposables.add(d)), this.focus = new M_(() => this.view.getFocusedElements()[0], s.identityProvider), this.selection = new M_(() => this.view.getSelectedElements()[0], s.identityProvider), this.anchor = new M_(() => this.view.getAnchorElement(), s.identityProvider), this.view = new fCt(e, t, this.treeDelegate, this.renderers, this.focus, this.selection, this.anchor, { ...nCt(() => this.model, s), tree: this, stickyScrollProvider: () => this.stickyScrollController }), this.model = this.createModel(e, this.view, s), o.input = this.model.onDidChangeCollapseState;
    const u = xe.forEach(this.model.onDidSplice, (g) => {
      this.eventBufferer.bufferEvents(() => {
        this.focus.onDidModelSplice(g), this.selection.onDidModelSplice(g);
      });
    }, this.disposables);
    u(() => null, null, this.disposables);
    const f = this.disposables.add(new $()), p = this.disposables.add(new Uf(0));
    if (this.disposables.add(xe.any(u, this.focus.onDidChange, this.selection.onDidChange)(() => {
      p.trigger(() => {
        const g = /* @__PURE__ */ new Set();
        for (const m of this.focus.getNodes())
          g.add(m);
        for (const m of this.selection.getNodes())
          g.add(m);
        f.fire([...g.values()]);
      });
    })), a.input = f.event, s.keyboardSupport !== !1) {
      const g = xe.chain(this.view.onKeyDown, (m) => m.filter((A) => !e1(A.target)).map((A) => new zn(A)));
      xe.chain(g, (m) => m.filter(
        (A) => A.keyCode === 15
        /* KeyCode.LeftArrow */
      ))(this.onLeftArrow, this, this.disposables), xe.chain(g, (m) => m.filter(
        (A) => A.keyCode === 17
        /* KeyCode.RightArrow */
      ))(this.onRightArrow, this, this.disposables), xe.chain(g, (m) => m.filter(
        (A) => A.keyCode === 10
        /* KeyCode.Space */
      ))(this.onSpace, this, this.disposables);
    }
    if ((s.findWidgetEnabled ?? !0) && s.keyboardNavigationLabelProvider && s.contextViewProvider) {
      const g = this.options.findWidgetStyles ? { styles: this.options.findWidgetStyles } : void 0;
      this.findController = new sCt(this, this.model, this.view, d, s.contextViewProvider, g), this.focusNavigationFilter = (m) => this.findController.shouldAllowFocus(m), this.onDidChangeFindOpenState = this.findController.onDidChangeOpenState, this.disposables.add(this.findController), this.onDidChangeFindMode = this.findController.onDidChangeMode, this.onDidChangeFindMatchType = this.findController.onDidChangeMatchType;
    } else
      this.onDidChangeFindMode = xe.None, this.onDidChangeFindMatchType = xe.None;
    s.enableStickyScroll && (this.stickyScrollController = new E9e(this, this.model, this.view, this.renderers, this.treeDelegate, s), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus), this.styleElement = ya(this.view.getHTMLElement()), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === yg.Always);
  }
  updateOptions(e = {}) {
    this._options = { ...this._options, ...e };
    for (const t of this.renderers)
      t.updateOptions(e);
    this.view.updateOptions(this._options), this.findController?.updateOptions(e), this.updateStickyScroll(e), this._onDidUpdateOptions.fire(this._options), this.getHTMLElement().classList.toggle("always", this._options.renderIndentGuides === yg.Always);
  }
  get options() {
    return this._options;
  }
  updateStickyScroll(e) {
    !this.stickyScrollController && this._options.enableStickyScroll ? (this.stickyScrollController = new E9e(this, this.model, this.view, this.renderers, this.treeDelegate, this._options), this.onDidChangeStickyScrollFocused = this.stickyScrollController.onDidChangeHasFocus) : this.stickyScrollController && !this._options.enableStickyScroll && (this.onDidChangeStickyScrollFocused = xe.None, this.stickyScrollController.dispose(), this.stickyScrollController = void 0), this.stickyScrollController?.updateOptions(e);
  }
  // Widget
  getHTMLElement() {
    return this.view.getHTMLElement();
  }
  get scrollTop() {
    return this.view.scrollTop;
  }
  set scrollTop(e) {
    this.view.scrollTop = e;
  }
  get scrollHeight() {
    return this.view.scrollHeight;
  }
  get renderHeight() {
    return this.view.renderHeight;
  }
  get ariaLabel() {
    return this.view.ariaLabel;
  }
  set ariaLabel(e) {
    this.view.ariaLabel = e;
  }
  domFocus() {
    this.stickyScrollController?.focusedLast() ? this.stickyScrollController.domFocus() : this.view.domFocus();
  }
  layout(e, t) {
    this.view.layout(e, t), Kg(t) && this.findController?.layout(t);
  }
  style(e) {
    const t = `.${this.view.domId}`, n = [];
    e.treeIndentGuidesStroke && (n.push(`.monaco-list${t}:hover .monaco-tl-indent > .indent-guide, .monaco-list${t}.always .monaco-tl-indent > .indent-guide  { border-color: ${e.treeInactiveIndentGuidesStroke}; }`), n.push(`.monaco-list${t} .monaco-tl-indent > .indent-guide.active { border-color: ${e.treeIndentGuidesStroke}; }`));
    const i = e.treeStickyScrollBackground ?? e.listBackground;
    i && (n.push(`.monaco-list${t} .monaco-scrollable-element .monaco-tree-sticky-container { background-color: ${i}; }`), n.push(`.monaco-list${t} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-row { background-color: ${i}; }`)), e.treeStickyScrollBorder && n.push(`.monaco-list${t} .monaco-scrollable-element .monaco-tree-sticky-container { border-bottom: 1px solid ${e.treeStickyScrollBorder}; }`), e.treeStickyScrollShadow && n.push(`.monaco-list${t} .monaco-scrollable-element .monaco-tree-sticky-container .monaco-tree-sticky-container-shadow { box-shadow: ${e.treeStickyScrollShadow} 0 6px 6px -6px inset; height: 3px; }`), e.listFocusForeground && (n.push(`.monaco-list${t}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { color: ${e.listFocusForeground}; }`), n.push(`.monaco-list${t}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { color: inherit; }`));
    const s = Cd(e.listFocusAndSelectionOutline, Cd(e.listSelectionOutline, e.listFocusOutline ?? ""));
    s && (n.push(`.monaco-list${t}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused.selected { outline: 1px solid ${s}; outline-offset: -1px;}`), n.push(`.monaco-list${t}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused.selected { outline: inherit;}`)), e.listFocusOutline && (n.push(`.monaco-list${t}.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container:focus .monaco-list-row.focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), n.push(`.monaco-list${t}:not(.sticky-scroll-focused) .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.focused { outline: inherit; }`), n.push(`.monaco-workbench.context-menu-visible .monaco-list${t}.last-focused.sticky-scroll-focused .monaco-scrollable-element .monaco-tree-sticky-container .monaco-list-row.passive-focused { outline: 1px solid ${e.listFocusOutline}; outline-offset: -1px; }`), n.push(`.monaco-workbench.context-menu-visible .monaco-list${t}.last-focused.sticky-scroll-focused .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`), n.push(`.monaco-workbench.context-menu-visible .monaco-list${t}.last-focused:not(.sticky-scroll-focused) .monaco-tree-sticky-container .monaco-list-rows .monaco-list-row.focused { outline: inherit; }`)), this.styleElement.textContent = n.join(`
`), this.view.style(e);
  }
  // Tree navigation
  getParentElement(e) {
    const t = this.model.getParentNodeLocation(e);
    return this.model.getNode(t).element;
  }
  getFirstElementChild(e) {
    return this.model.getFirstElementChild(e);
  }
  // Tree
  getNode(e) {
    return this.model.getNode(e);
  }
  getNodeLocation(e) {
    return this.model.getNodeLocation(e);
  }
  collapse(e, t = !1) {
    return this.model.setCollapsed(e, !0, t);
  }
  expand(e, t = !1) {
    return this.model.setCollapsed(e, !1, t);
  }
  toggleCollapsed(e, t = !1) {
    return this.model.setCollapsed(e, void 0, t);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  refilter() {
    this._onWillRefilter.fire(void 0), this.model.refilter();
  }
  setSelection(e, t) {
    this.eventBufferer.bufferEvents(() => {
      const n = e.map((s) => this.model.getNode(s));
      this.selection.set(n, t);
      const i = e.map((s) => this.model.getListIndex(s)).filter((s) => s > -1);
      this.view.setSelection(i, t, !0);
    });
  }
  getSelection() {
    return this.selection.get();
  }
  setFocus(e, t) {
    this.eventBufferer.bufferEvents(() => {
      const n = e.map((s) => this.model.getNode(s));
      this.focus.set(n, t);
      const i = e.map((s) => this.model.getListIndex(s)).filter((s) => s > -1);
      this.view.setFocus(i, t, !0);
    });
  }
  focusNext(e = 1, t = !1, n, i = Xh(n) && n.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusNext(e, t, n, i);
  }
  focusPrevious(e = 1, t = !1, n, i = Xh(n) && n.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusPrevious(e, t, n, i);
  }
  focusNextPage(e, t = Xh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusNextPage(e, t);
  }
  focusPreviousPage(e, t = Xh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    return this.view.focusPreviousPage(e, t, () => this.stickyScrollController?.height ?? 0);
  }
  focusLast(e, t = Xh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusLast(e, t);
  }
  focusFirst(e, t = Xh(e) && e.altKey ? void 0 : this.focusNavigationFilter) {
    this.view.focusFirst(e, t);
  }
  getFocus() {
    return this.focus.get();
  }
  reveal(e, t) {
    this.model.expandTo(e);
    const n = this.model.getListIndex(e);
    if (n !== -1)
      if (!this.stickyScrollController)
        this.view.reveal(n, t);
      else {
        const i = this.stickyScrollController.nodePositionTopBelowWidget(this.getNode(e));
        this.view.reveal(n, t, i);
      }
  }
  // List
  onLeftArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], i = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(i, !0)) {
      const o = this.model.getParentNodeLocation(i);
      if (!o)
        return;
      const a = this.model.getListIndex(o);
      this.view.reveal(a), this.view.setFocus([a]);
    }
  }
  onRightArrow(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], i = this.model.getNodeLocation(n);
    if (!this.model.setCollapsed(i, !1)) {
      if (!n.children.some((l) => l.visible))
        return;
      const [o] = this.view.getFocus(), a = o + 1;
      this.view.reveal(a), this.view.setFocus([a]);
    }
  }
  onSpace(e) {
    e.preventDefault(), e.stopPropagation();
    const t = this.view.getFocusedElements();
    if (t.length === 0)
      return;
    const n = t[0], i = this.model.getNodeLocation(n), s = e.browserEvent.altKey;
    this.model.setCollapsed(i, void 0, s);
  }
  dispose() {
    br(this.disposables), this.stickyScrollController?.dispose(), this.view.dispose();
  }
}
class NR {
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.nodesByIdentity = /* @__PURE__ */ new Map(), this.model = new $yt(e, t, null, n), this.onDidSplice = this.model.onDidSplice, this.onDidChangeCollapseState = this.model.onDidChangeCollapseState, this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount, n.sorter && (this.sorter = {
      compare(i, s) {
        return n.sorter.compare(i.element, s.element);
      }
    }), this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = Jt.empty(), n = {}) {
    const i = this.getElementLocation(e);
    this._setChildren(i, this.preserveCollapseState(t), n);
  }
  _setChildren(e, t = Jt.empty(), n) {
    const i = /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set(), o = (l) => {
      if (l.element === null)
        return;
      const c = l;
      if (i.add(c.element), this.nodes.set(c.element, c), this.identityProvider) {
        const d = this.identityProvider.getId(c.element).toString();
        s.add(d), this.nodesByIdentity.set(d, c);
      }
      n.onDidCreateNode?.(c);
    }, a = (l) => {
      if (l.element === null)
        return;
      const c = l;
      if (i.has(c.element) || this.nodes.delete(c.element), this.identityProvider) {
        const d = this.identityProvider.getId(c.element).toString();
        s.has(d) || this.nodesByIdentity.delete(d);
      }
      n.onDidDeleteNode?.(c);
    };
    this.model.splice([...e, 0], Number.MAX_VALUE, t, { ...n, onDidCreateNode: o, onDidDeleteNode: a });
  }
  preserveCollapseState(e = Jt.empty()) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), Jt.map(e, (t) => {
      let n = this.nodes.get(t.element);
      if (!n && this.identityProvider) {
        const o = this.identityProvider.getId(t.element).toString();
        n = this.nodesByIdentity.get(o);
      }
      if (!n) {
        let o;
        return typeof t.collapsed > "u" ? o = void 0 : t.collapsed === yo.Collapsed || t.collapsed === yo.PreserveOrCollapsed ? o = !0 : t.collapsed === yo.Expanded || t.collapsed === yo.PreserveOrExpanded ? o = !1 : o = !!t.collapsed, {
          ...t,
          children: this.preserveCollapseState(t.children),
          collapsed: o
        };
      }
      const i = typeof t.collapsible == "boolean" ? t.collapsible : n.collapsible;
      let s;
      return typeof t.collapsed > "u" || t.collapsed === yo.PreserveOrCollapsed || t.collapsed === yo.PreserveOrExpanded ? s = n.collapsed : t.collapsed === yo.Collapsed ? s = !0 : t.collapsed === yo.Expanded ? s = !1 : s = !!t.collapsed, {
        ...t,
        collapsible: i,
        collapsed: s,
        children: this.preserveCollapseState(t.children)
      };
    });
  }
  rerender(e) {
    const t = this.getElementLocation(e);
    this.model.rerender(t);
  }
  getFirstElementChild(e = null) {
    const t = this.getElementLocation(e);
    return this.model.getFirstElementChild(t);
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getElementLocation(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getElementLocation(e);
    return this.model.getListRenderCount(t);
  }
  isCollapsible(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getElementLocation(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getElementLocation(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const i = this.getElementLocation(e);
    return this.model.setCollapsed(i, t, n);
  }
  expandTo(e) {
    const t = this.getElementLocation(e);
    this.model.expandTo(t);
  }
  refilter() {
    this.model.refilter();
  }
  getNode(e = null) {
    if (e === null)
      return this.model.getNode(this.model.rootRef);
    const t = this.nodes.get(e);
    if (!t)
      throw new Do(this.user, `Tree element not found: ${e}`);
    return t;
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    if (e === null)
      throw new Do(this.user, "Invalid getParentNodeLocation call");
    const t = this.nodes.get(e);
    if (!t)
      throw new Do(this.user, `Tree element not found: ${e}`);
    const n = this.model.getNodeLocation(t), i = this.model.getParentNodeLocation(n);
    return this.model.getNode(i).element;
  }
  getElementLocation(e) {
    if (e === null)
      return [];
    const t = this.nodes.get(e);
    if (!t)
      throw new Do(this.user, `Tree element not found: ${e}`);
    return this.model.getNodeLocation(t);
  }
}
function T6(r) {
  const e = [r.element], t = r.incompressible || !1;
  return {
    element: { elements: e, incompressible: t },
    children: Jt.map(Jt.from(r.children), T6),
    collapsible: r.collapsible,
    collapsed: r.collapsed
  };
}
function I6(r) {
  const e = [r.element], t = r.incompressible || !1;
  let n, i;
  for (; [i, n] = Jt.consume(Jt.from(r.children), 2), !(i.length !== 1 || i[0].incompressible); )
    r = i[0], e.push(r.element);
  return {
    element: { elements: e, incompressible: t },
    children: Jt.map(Jt.concat(i, n), I6),
    collapsible: r.collapsible,
    collapsed: r.collapsed
  };
}
function xk(r, e = 0) {
  let t;
  return e < r.element.elements.length - 1 ? t = [xk(r, e + 1)] : t = Jt.map(Jt.from(r.children), (n) => xk(n, 0)), e === 0 && r.element.incompressible ? {
    element: r.element.elements[e],
    children: t,
    incompressible: !0,
    collapsible: r.collapsible,
    collapsed: r.collapsed
  } : {
    element: r.element.elements[e],
    children: t,
    collapsible: r.collapsible,
    collapsed: r.collapsed
  };
}
function _9e(r) {
  return xk(r, 0);
}
function eTe(r, e, t) {
  return r.element === e ? { ...r, children: t } : { ...r, children: Jt.map(Jt.from(r.children), (n) => eTe(n, e, t)) };
}
const pCt = (r) => ({
  getId(e) {
    return e.elements.map((t) => r.getId(t).toString()).join("\0");
  }
});
class gCt {
  get onDidSplice() {
    return this.model.onDidSplice;
  }
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  get onDidChangeRenderNodeCount() {
    return this.model.onDidChangeRenderNodeCount;
  }
  constructor(e, t, n = {}) {
    this.user = e, this.rootRef = null, this.nodes = /* @__PURE__ */ new Map(), this.model = new NR(e, t, n), this.enabled = typeof n.compressionEnabled > "u" ? !0 : n.compressionEnabled, this.identityProvider = n.identityProvider;
  }
  setChildren(e, t = Jt.empty(), n) {
    const i = n.diffIdentityProvider && pCt(n.diffIdentityProvider);
    if (e === null) {
      const g = Jt.map(t, this.enabled ? I6 : T6);
      this._setChildren(null, g, { diffIdentityProvider: i, diffDepth: 1 / 0 });
      return;
    }
    const s = this.nodes.get(e);
    if (!s)
      throw new Do(this.user, "Unknown compressed tree node");
    const o = this.model.getNode(s), a = this.model.getParentNodeLocation(s), l = this.model.getNode(a), c = _9e(o), d = eTe(c, e, t), u = (this.enabled ? I6 : T6)(d), f = n.diffIdentityProvider ? (g, m) => n.diffIdentityProvider.getId(g) === n.diffIdentityProvider.getId(m) : void 0;
    if (Zi(u.element.elements, o.element.elements, f)) {
      this._setChildren(s, u.children || Jt.empty(), { diffIdentityProvider: i, diffDepth: 1 });
      return;
    }
    const p = l.children.map((g) => g === o ? u : g);
    this._setChildren(l.element, p, {
      diffIdentityProvider: i,
      diffDepth: o.depth - l.depth
    });
  }
  isCompressionEnabled() {
    return this.enabled;
  }
  setCompressionEnabled(e) {
    if (e === this.enabled)
      return;
    this.enabled = e;
    const n = this.model.getNode().children, i = Jt.map(n, _9e), s = Jt.map(i, e ? I6 : T6);
    this._setChildren(null, s, {
      diffIdentityProvider: this.identityProvider,
      diffDepth: 1 / 0
    });
  }
  _setChildren(e, t, n) {
    const i = /* @__PURE__ */ new Set(), s = (a) => {
      for (const l of a.element.elements)
        i.add(l), this.nodes.set(l, a.element);
    }, o = (a) => {
      for (const l of a.element.elements)
        i.has(l) || this.nodes.delete(l);
    };
    this.model.setChildren(e, t, { ...n, onDidCreateNode: s, onDidDeleteNode: o });
  }
  has(e) {
    return this.nodes.has(e);
  }
  getListIndex(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListIndex(t);
  }
  getListRenderCount(e) {
    const t = this.getCompressedNode(e);
    return this.model.getListRenderCount(t);
  }
  getNode(e) {
    if (typeof e > "u")
      return this.model.getNode();
    const t = this.getCompressedNode(e);
    return this.model.getNode(t);
  }
  // TODO: review this
  getNodeLocation(e) {
    const t = this.model.getNodeLocation(e);
    return t === null ? null : t.elements[t.elements.length - 1];
  }
  // TODO: review this
  getParentNodeLocation(e) {
    const t = this.getCompressedNode(e), n = this.model.getParentNodeLocation(t);
    return n === null ? null : n.elements[n.elements.length - 1];
  }
  getFirstElementChild(e) {
    const t = this.getCompressedNode(e);
    return this.model.getFirstElementChild(t);
  }
  isCollapsible(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsible(t);
  }
  setCollapsible(e, t) {
    const n = this.getCompressedNode(e);
    return this.model.setCollapsible(n, t);
  }
  isCollapsed(e) {
    const t = this.getCompressedNode(e);
    return this.model.isCollapsed(t);
  }
  setCollapsed(e, t, n) {
    const i = this.getCompressedNode(e);
    return this.model.setCollapsed(i, t, n);
  }
  expandTo(e) {
    const t = this.getCompressedNode(e);
    this.model.expandTo(t);
  }
  rerender(e) {
    const t = this.getCompressedNode(e);
    this.model.rerender(t);
  }
  refilter() {
    this.model.refilter();
  }
  getCompressedNode(e) {
    if (e === null)
      return null;
    const t = this.nodes.get(e);
    if (!t)
      throw new Do(this.user, `Tree element not found: ${e}`);
    return t;
  }
}
const mCt = (r) => r[r.length - 1];
class TR {
  get element() {
    return this.node.element === null ? null : this.unwrapper(this.node.element);
  }
  get children() {
    return this.node.children.map((e) => new TR(this.unwrapper, e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e, t) {
    this.unwrapper = e, this.node = t;
  }
}
function ACt(r, e) {
  return {
    splice(t, n, i) {
      e.splice(t, n, i.map((s) => r.map(s)));
    },
    updateElementHeight(t, n) {
      e.updateElementHeight(t, n);
    }
  };
}
function wCt(r, e) {
  return {
    ...e,
    identityProvider: e.identityProvider && {
      getId(t) {
        return e.identityProvider.getId(r(t));
      }
    },
    sorter: e.sorter && {
      compare(t, n) {
        return e.sorter.compare(t.elements[0], n.elements[0]);
      }
    },
    filter: e.filter && {
      filter(t, n) {
        return e.filter.filter(r(t), n);
      }
    }
  };
}
class vCt {
  get onDidSplice() {
    return xe.map(this.model.onDidSplice, ({ insertedNodes: e, deletedNodes: t }) => ({
      insertedNodes: e.map((n) => this.nodeMapper.map(n)),
      deletedNodes: t.map((n) => this.nodeMapper.map(n))
    }));
  }
  get onDidChangeCollapseState() {
    return xe.map(this.model.onDidChangeCollapseState, ({ node: e, deep: t }) => ({
      node: this.nodeMapper.map(e),
      deep: t
    }));
  }
  get onDidChangeRenderNodeCount() {
    return xe.map(this.model.onDidChangeRenderNodeCount, (e) => this.nodeMapper.map(e));
  }
  constructor(e, t, n = {}) {
    this.rootRef = null, this.elementMapper = n.elementMapper || mCt;
    const i = (s) => this.elementMapper(s.elements);
    this.nodeMapper = new DR((s) => new TR(i, s)), this.model = new gCt(e, ACt(this.nodeMapper, t), wCt(i, n));
  }
  setChildren(e, t = Jt.empty(), n = {}) {
    this.model.setChildren(e, t, n);
  }
  isCompressionEnabled() {
    return this.model.isCompressionEnabled();
  }
  setCompressionEnabled(e) {
    this.model.setCompressionEnabled(e);
  }
  has(e) {
    return this.model.has(e);
  }
  getListIndex(e) {
    return this.model.getListIndex(e);
  }
  getListRenderCount(e) {
    return this.model.getListRenderCount(e);
  }
  getNode(e) {
    return this.nodeMapper.map(this.model.getNode(e));
  }
  getNodeLocation(e) {
    return e.element;
  }
  getParentNodeLocation(e) {
    return this.model.getParentNodeLocation(e);
  }
  getFirstElementChild(e) {
    const t = this.model.getFirstElementChild(e);
    return t === null || typeof t > "u" ? t : this.elementMapper(t.elements);
  }
  isCollapsible(e) {
    return this.model.isCollapsible(e);
  }
  setCollapsible(e, t) {
    return this.model.setCollapsible(e, t);
  }
  isCollapsed(e) {
    return this.model.isCollapsed(e);
  }
  setCollapsed(e, t, n) {
    return this.model.setCollapsed(e, t, n);
  }
  expandTo(e) {
    return this.model.expandTo(e);
  }
  rerender(e) {
    return this.model.rerender(e);
  }
  refilter() {
    return this.model.refilter();
  }
  getCompressedTreeNode(e = null) {
    return this.model.getNode(e);
  }
}
var bCt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
};
class IR extends $Ne {
  get onDidChangeCollapseState() {
    return this.model.onDidChangeCollapseState;
  }
  constructor(e, t, n, i, s = {}) {
    super(e, t, n, i, s), this.user = e;
  }
  setChildren(e, t = Jt.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  rerender(e) {
    if (e === void 0) {
      this.view.rerender();
      return;
    }
    this.model.rerender(e);
  }
  hasElement(e) {
    return this.model.has(e);
  }
  createModel(e, t, n) {
    return new NR(e, t, n);
  }
}
class tTe {
  get compressedTreeNodeProvider() {
    return this._compressedTreeNodeProvider();
  }
  constructor(e, t, n) {
    this._compressedTreeNodeProvider = e, this.stickyScrollDelegate = t, this.renderer = n, this.templateId = n.templateId, n.onDidChangeTwistieState && (this.onDidChangeTwistieState = n.onDidChangeTwistieState);
  }
  renderTemplate(e) {
    return { compressedTreeNode: void 0, data: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, i) {
    let s = this.stickyScrollDelegate.getCompressedNode(e);
    s || (s = this.compressedTreeNodeProvider.getCompressedTreeNode(e.element)), s.element.elements.length === 1 ? (n.compressedTreeNode = void 0, this.renderer.renderElement(e, t, n.data, i)) : (n.compressedTreeNode = s, this.renderer.renderCompressedElements(s, t, n.data, i));
  }
  disposeElement(e, t, n, i) {
    n.compressedTreeNode ? this.renderer.disposeCompressedElements?.(n.compressedTreeNode, t, n.data, i) : this.renderer.disposeElement?.(e, t, n.data, i);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.data);
  }
  renderTwistie(e, t) {
    return this.renderer.renderTwistie ? this.renderer.renderTwistie(e, t) : !1;
  }
}
bCt([
  wi
], tTe.prototype, "compressedTreeNodeProvider", null);
class yCt {
  constructor(e) {
    this.modelProvider = e, this.compressedStickyNodes = /* @__PURE__ */ new Map();
  }
  getCompressedNode(e) {
    return this.compressedStickyNodes.get(e);
  }
  constrainStickyScrollNodes(e, t, n) {
    if (this.compressedStickyNodes.clear(), e.length === 0)
      return [];
    for (let i = 0; i < e.length; i++) {
      const s = e[i], o = s.position + s.height;
      if (i + 1 < e.length && o + e[i + 1].height > n || i >= t - 1 && t < e.length) {
        const l = e.slice(0, i), c = e.slice(i), d = this.compressStickyNodes(c);
        return [...l, d];
      }
    }
    return e;
  }
  compressStickyNodes(e) {
    if (e.length === 0)
      throw new Error("Can't compress empty sticky nodes");
    const t = this.modelProvider();
    if (!t.isCompressionEnabled())
      return e[0];
    const n = [];
    for (let c = 0; c < e.length; c++) {
      const d = e[c], u = t.getCompressedTreeNode(d.node.element);
      if (u.element) {
        if (c !== 0 && u.element.incompressible)
          break;
        n.push(...u.element.elements);
      }
    }
    if (n.length < 2)
      return e[0];
    const i = e[e.length - 1], s = { elements: n, incompressible: !1 }, o = { ...i.node, children: [], element: s }, a = new Proxy(e[0].node, {}), l = {
      node: a,
      startIndex: e[0].startIndex,
      endIndex: i.endIndex,
      position: e[0].position,
      height: e[0].height
    };
    return this.compressedStickyNodes.set(a, o), l;
  }
}
function CCt(r, e) {
  return e && {
    ...e,
    keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && {
      getKeyboardNavigationLabel(t) {
        let n;
        try {
          n = r().getCompressedTreeNode(t);
        } catch {
          return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t);
        }
        return n.element.elements.length === 1 ? e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t) : e.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(n.element.elements);
      }
    }
  };
}
class nTe extends IR {
  constructor(e, t, n, i, s = {}) {
    const o = () => this, a = new yCt(() => this.model), l = i.map((c) => new tTe(o, a, c));
    super(e, t, n, l, { ...CCt(o, s), stickyScrollDelegate: a });
  }
  setChildren(e, t = Jt.empty(), n) {
    this.model.setChildren(e, t, n);
  }
  createModel(e, t, n) {
    return new vCt(e, t, n);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), typeof e.compressionEnabled < "u" && this.model.setCompressionEnabled(e.compressionEnabled);
  }
  getCompressedTreeNode(e = null) {
    return this.model.getCompressedTreeNode(e);
  }
}
function D_(r) {
  return {
    ...r,
    children: [],
    refreshPromise: void 0,
    stale: !0,
    slow: !1,
    forceExpanded: !1
  };
}
function Sk(r, e) {
  return e.parent ? e.parent === r ? !0 : Sk(r, e.parent) : !1;
}
function ECt(r, e) {
  return r === e || Sk(r, e) || Sk(e, r);
}
class OR {
  get element() {
    return this.node.element.element;
  }
  get children() {
    return this.node.children.map((e) => new OR(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class _Ct {
  constructor(e, t, n) {
    this.renderer = e, this.nodeMapper = t, this.onDidChangeTwistieState = n, this.renderedNodes = /* @__PURE__ */ new Map(), this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, i) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, i);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Tt.asClassNameArray(ke.treeItemLoading)), !0) : (t.classList.remove(...Tt.asClassNameArray(ke.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, i) {
    this.renderer.disposeElement?.(this.nodeMapper.map(e), t, n.templateData, i);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear();
  }
}
function x9e(r) {
  return {
    browserEvent: r.browserEvent,
    elements: r.elements.map((e) => e.element)
  };
}
function S9e(r) {
  return {
    browserEvent: r.browserEvent,
    element: r.element && r.element.element,
    target: r.target
  };
}
class xCt extends Iw {
  constructor(e) {
    super(e.elements.map((t) => t.element)), this.data = e;
  }
}
function L_(r) {
  return r instanceof Iw ? new xCt(r) : r;
}
class SCt {
  constructor(e) {
    this.dnd = e;
  }
  getDragURI(e) {
    return this.dnd.getDragURI(e.element);
  }
  getDragLabel(e, t) {
    if (this.dnd.getDragLabel)
      return this.dnd.getDragLabel(e.map((n) => n.element), t);
  }
  onDragStart(e, t) {
    this.dnd.onDragStart?.(L_(e), t);
  }
  onDragOver(e, t, n, i, s, o = !0) {
    return this.dnd.onDragOver(L_(e), t && t.element, n, i, s);
  }
  drop(e, t, n, i, s) {
    this.dnd.drop(L_(e), t && t.element, n, i, s);
  }
  onDragEnd(e) {
    this.dnd.onDragEnd?.(e);
  }
  dispose() {
    this.dnd.dispose();
  }
}
function iTe(r) {
  return r && {
    ...r,
    collapseByDefault: !0,
    identityProvider: r.identityProvider && {
      getId(e) {
        return r.identityProvider.getId(e.element);
      }
    },
    dnd: r.dnd && new SCt(r.dnd),
    multipleSelectionController: r.multipleSelectionController && {
      isSelectionSingleChangeEvent(e) {
        return r.multipleSelectionController.isSelectionSingleChangeEvent({ ...e, element: e.element });
      },
      isSelectionRangeChangeEvent(e) {
        return r.multipleSelectionController.isSelectionRangeChangeEvent({ ...e, element: e.element });
      }
    },
    accessibilityProvider: r.accessibilityProvider && {
      ...r.accessibilityProvider,
      getPosInSet: void 0,
      getSetSize: void 0,
      getRole: r.accessibilityProvider.getRole ? (e) => r.accessibilityProvider.getRole(e.element) : () => "treeitem",
      isChecked: r.accessibilityProvider.isChecked ? (e) => !!r.accessibilityProvider?.isChecked(e.element) : void 0,
      getAriaLabel(e) {
        return r.accessibilityProvider.getAriaLabel(e.element);
      },
      getWidgetAriaLabel() {
        return r.accessibilityProvider.getWidgetAriaLabel();
      },
      getWidgetRole: r.accessibilityProvider.getWidgetRole ? () => r.accessibilityProvider.getWidgetRole() : () => "tree",
      getAriaLevel: r.accessibilityProvider.getAriaLevel && ((e) => r.accessibilityProvider.getAriaLevel(e.element)),
      getActiveDescendantId: r.accessibilityProvider.getActiveDescendantId && ((e) => r.accessibilityProvider.getActiveDescendantId(e.element))
    },
    filter: r.filter && {
      filter(e, t) {
        return r.filter.filter(e.element, t);
      }
    },
    keyboardNavigationLabelProvider: r.keyboardNavigationLabelProvider && {
      ...r.keyboardNavigationLabelProvider,
      getKeyboardNavigationLabel(e) {
        return r.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
      }
    },
    sorter: void 0,
    expandOnlyOnTwistieClick: typeof r.expandOnlyOnTwistieClick > "u" ? void 0 : typeof r.expandOnlyOnTwistieClick != "function" ? r.expandOnlyOnTwistieClick : (e) => r.expandOnlyOnTwistieClick(e.element),
    defaultFindVisibility: (e) => e.hasChildren && e.stale ? 1 : typeof r.defaultFindVisibility == "number" ? r.defaultFindVisibility : typeof r.defaultFindVisibility > "u" ? 2 : r.defaultFindVisibility(e.element)
  };
}
function Mk(r, e) {
  e(r), r.children.forEach((t) => Mk(t, e));
}
class rTe {
  get onDidScroll() {
    return this.tree.onDidScroll;
  }
  get onDidChangeFocus() {
    return xe.map(this.tree.onDidChangeFocus, x9e);
  }
  get onDidChangeSelection() {
    return xe.map(this.tree.onDidChangeSelection, x9e);
  }
  get onMouseDblClick() {
    return xe.map(this.tree.onMouseDblClick, S9e);
  }
  get onPointer() {
    return xe.map(this.tree.onPointer, S9e);
  }
  get onDidFocus() {
    return this.tree.onDidFocus;
  }
  /**
   * To be used internally only!
   * @deprecated
   */
  get onDidChangeModel() {
    return this.tree.onDidChangeModel;
  }
  get onDidChangeCollapseState() {
    return this.tree.onDidChangeCollapseState;
  }
  get onDidChangeFindOpenState() {
    return this.tree.onDidChangeFindOpenState;
  }
  get onDidChangeStickyScrollFocused() {
    return this.tree.onDidChangeStickyScrollFocused;
  }
  get onDidDispose() {
    return this.tree.onDidDispose;
  }
  constructor(e, t, n, i, s, o = {}) {
    this.user = e, this.dataSource = s, this.nodes = /* @__PURE__ */ new Map(), this.subTreeRefreshPromises = /* @__PURE__ */ new Map(), this.refreshPromises = /* @__PURE__ */ new Map(), this._onDidRender = new $(), this._onDidChangeNodeSlowState = new $(), this.nodeMapper = new DR((a) => new OR(a)), this.disposables = new ze(), this.identityProvider = o.identityProvider, this.autoExpandSingleChildren = typeof o.autoExpandSingleChildren > "u" ? !1 : o.autoExpandSingleChildren, this.sorter = o.sorter, this.getDefaultCollapseState = (a) => o.collapseByDefault ? o.collapseByDefault(a) ? yo.PreserveOrCollapsed : yo.PreserveOrExpanded : void 0, this.tree = this.createTree(e, t, n, i, o), this.onDidChangeFindMode = this.tree.onDidChangeFindMode, this.onDidChangeFindMatchType = this.tree.onDidChangeFindMatchType, this.root = D_({
      element: void 0,
      parent: null,
      hasChildren: !0,
      defaultCollapseState: void 0
    }), this.identityProvider && (this.root = {
      ...this.root,
      id: null
    }), this.nodes.set(null, this.root), this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }
  createTree(e, t, n, i, s) {
    const o = new kR(n), a = i.map((c) => new _Ct(c, this.nodeMapper, this._onDidChangeNodeSlowState.event)), l = iTe(s) || {};
    return new IR(e, t, o, a, l);
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  // Widget
  getHTMLElement() {
    return this.tree.getHTMLElement();
  }
  get scrollTop() {
    return this.tree.scrollTop;
  }
  set scrollTop(e) {
    this.tree.scrollTop = e;
  }
  get scrollHeight() {
    return this.tree.scrollHeight;
  }
  get renderHeight() {
    return this.tree.renderHeight;
  }
  domFocus() {
    this.tree.domFocus();
  }
  layout(e, t) {
    this.tree.layout(e, t);
  }
  style(e) {
    this.tree.style(e);
  }
  // Model
  getInput() {
    return this.root.element;
  }
  async setInput(e, t) {
    this.refreshPromises.forEach((i) => i.cancel()), this.refreshPromises.clear(), this.root.element = e;
    const n = t && { viewState: t, focus: [], selection: [] };
    await this._updateChildren(e, !0, !1, n), n && (this.tree.setFocus(n.focus), this.tree.setSelection(n.selection)), t && typeof t.scrollTop == "number" && (this.scrollTop = t.scrollTop);
  }
  async _updateChildren(e = this.root.element, t = !0, n = !1, i, s) {
    if (typeof this.root.element > "u")
      throw new Do(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await xe.toPromise(this._onDidRender.event));
    const o = this.getDataNode(e);
    if (await this.refreshAndRenderNode(o, t, i, s), n)
      try {
        this.tree.rerender(o);
      } catch {
      }
  }
  // View
  rerender(e) {
    if (e === void 0 || e === this.root.element) {
      this.tree.rerender();
      return;
    }
    const t = this.getDataNode(e);
    this.tree.rerender(t);
  }
  // Tree
  getNode(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getNode(t === this.root ? null : t);
    return this.nodeMapper.map(n);
  }
  collapse(e, t = !1) {
    const n = this.getDataNode(e);
    return this.tree.collapse(n === this.root ? null : n, t);
  }
  async expand(e, t = !1) {
    if (typeof this.root.element > "u")
      throw new Do(this.user, "Tree input not set");
    this.root.refreshPromise && (await this.root.refreshPromise, await xe.toPromise(this._onDidRender.event));
    const n = this.getDataNode(e);
    if (this.tree.hasElement(n) && !this.tree.isCollapsible(n) || (n.refreshPromise && (await this.root.refreshPromise, await xe.toPromise(this._onDidRender.event)), n !== this.root && !n.refreshPromise && !this.tree.isCollapsed(n)))
      return !1;
    const i = this.tree.expand(n === this.root ? null : n, t);
    return n.refreshPromise && (await this.root.refreshPromise, await xe.toPromise(this._onDidRender.event)), i;
  }
  setSelection(e, t) {
    const n = e.map((i) => this.getDataNode(i));
    this.tree.setSelection(n, t);
  }
  getSelection() {
    return this.tree.getSelection().map((t) => t.element);
  }
  setFocus(e, t) {
    const n = e.map((i) => this.getDataNode(i));
    this.tree.setFocus(n, t);
  }
  getFocus() {
    return this.tree.getFocus().map((t) => t.element);
  }
  reveal(e, t) {
    this.tree.reveal(this.getDataNode(e), t);
  }
  // Tree navigation
  getParentElement(e) {
    const t = this.tree.getParentElement(this.getDataNode(e));
    return t && t.element;
  }
  getFirstElementChild(e = this.root.element) {
    const t = this.getDataNode(e), n = this.tree.getFirstElementChild(t === this.root ? null : t);
    return n && n.element;
  }
  // Implementation
  getDataNode(e) {
    const t = this.nodes.get(e === this.root.element ? null : e);
    if (!t)
      throw new Do(this.user, `Data tree node not found: ${e}`);
    return t;
  }
  async refreshAndRenderNode(e, t, n, i) {
    await this.refreshNode(e, t, n), !this.disposables.isDisposed && this.render(e, n, i);
  }
  async refreshNode(e, t, n) {
    let i;
    if (this.subTreeRefreshPromises.forEach((s, o) => {
      !i && ECt(o, e) && (i = s.then(() => this.refreshNode(e, t, n)));
    }), i)
      return i;
    if (e !== this.root && this.tree.getNode(e).collapsed) {
      e.hasChildren = !!this.dataSource.hasChildren(e.element), e.stale = !0, this.setChildren(e, [], t, n);
      return;
    }
    return this.doRefreshSubTree(e, t, n);
  }
  async doRefreshSubTree(e, t, n) {
    let i;
    e.refreshPromise = new Promise((s) => i = s), this.subTreeRefreshPromises.set(e, e.refreshPromise), e.refreshPromise.finally(() => {
      e.refreshPromise = void 0, this.subTreeRefreshPromises.delete(e);
    });
    try {
      const s = await this.doRefreshNode(e, t, n);
      e.stale = !1, await RD.settled(s.map((o) => this.doRefreshSubTree(o, t, n)));
    } finally {
      i();
    }
  }
  async doRefreshNode(e, t, n) {
    e.hasChildren = !!this.dataSource.hasChildren(e.element);
    let i;
    if (!e.hasChildren)
      i = Promise.resolve(Jt.empty());
    else {
      const s = this.doGetChildren(e);
      if (dve(s))
        i = Promise.resolve(s);
      else {
        const o = B3(800);
        o.then(() => {
          e.slow = !0, this._onDidChangeNodeSlowState.fire(e);
        }, (a) => null), i = s.finally(() => o.cancel());
      }
    }
    try {
      const s = await i;
      return this.setChildren(e, s, t, n);
    } catch (s) {
      if (e !== this.root && this.tree.hasElement(e) && this.tree.collapse(e), gw(s))
        return [];
      throw s;
    } finally {
      e.slow && (e.slow = !1, this._onDidChangeNodeSlowState.fire(e));
    }
  }
  doGetChildren(e) {
    let t = this.refreshPromises.get(e);
    if (t)
      return t;
    const n = this.dataSource.getChildren(e.element);
    return dve(n) ? this.processChildren(n) : (t = dDe(async () => this.processChildren(await n)), this.refreshPromises.set(e, t), t.finally(() => {
      this.refreshPromises.delete(e);
    }));
  }
  _onDidChangeCollapseState({ node: e, deep: t }) {
    e.element !== null && !e.collapsed && e.element.stale && (t ? this.collapse(e.element.element) : this.refreshAndRenderNode(e.element, !1).catch(wn));
  }
  setChildren(e, t, n, i) {
    const s = [...t];
    if (e.children.length === 0 && s.length === 0)
      return [];
    const o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
    for (const d of e.children)
      o.set(d.element, d), this.identityProvider && a.set(d.id, { node: d, collapsed: this.tree.hasElement(d) && this.tree.isCollapsed(d) });
    const l = [], c = s.map((d) => {
      const u = !!this.dataSource.hasChildren(d);
      if (!this.identityProvider) {
        const m = D_({ element: d, parent: e, hasChildren: u, defaultCollapseState: this.getDefaultCollapseState(d) });
        return u && m.defaultCollapseState === yo.PreserveOrExpanded && l.push(m), m;
      }
      const f = this.identityProvider.getId(d).toString(), p = a.get(f);
      if (p) {
        const m = p.node;
        return o.delete(m.element), this.nodes.delete(m.element), this.nodes.set(d, m), m.element = d, m.hasChildren = u, n ? p.collapsed ? (m.children.forEach((A) => Mk(A, (w) => this.nodes.delete(w.element))), m.children.splice(0, m.children.length), m.stale = !0) : l.push(m) : u && !p.collapsed && l.push(m), m;
      }
      const g = D_({ element: d, parent: e, id: f, hasChildren: u, defaultCollapseState: this.getDefaultCollapseState(d) });
      return i && i.viewState.focus && i.viewState.focus.indexOf(f) > -1 && i.focus.push(g), i && i.viewState.selection && i.viewState.selection.indexOf(f) > -1 && i.selection.push(g), (i && i.viewState.expanded && i.viewState.expanded.indexOf(f) > -1 || u && g.defaultCollapseState === yo.PreserveOrExpanded) && l.push(g), g;
    });
    for (const d of o.values())
      Mk(d, (u) => this.nodes.delete(u.element));
    for (const d of c)
      this.nodes.set(d.element, d);
    return e.children.splice(0, e.children.length, ...c), e !== this.root && this.autoExpandSingleChildren && c.length === 1 && l.length === 0 && (c[0].forceExpanded = !0, l.push(c[0])), l;
  }
  render(e, t, n) {
    const i = e.children.map((o) => this.asTreeElement(o, t)), s = n && {
      ...n,
      diffIdentityProvider: n.diffIdentityProvider && {
        getId(o) {
          return n.diffIdentityProvider.getId(o.element);
        }
      }
    };
    this.tree.setChildren(e === this.root ? null : e, i, s), e !== this.root && this.tree.setCollapsible(e, e.hasChildren), this._onDidRender.fire();
  }
  asTreeElement(e, t) {
    if (e.stale)
      return {
        element: e,
        collapsible: e.hasChildren,
        collapsed: !0
      };
    let n;
    return t && t.viewState.expanded && e.id && t.viewState.expanded.indexOf(e.id) > -1 ? n = !1 : e.forceExpanded ? (n = !1, e.forceExpanded = !1) : n = e.defaultCollapseState, {
      element: e,
      children: e.hasChildren ? Jt.map(e.children, (i) => this.asTreeElement(i, t)) : [],
      collapsible: e.hasChildren,
      collapsed: n
    };
  }
  processChildren(e) {
    return this.sorter && (e = [...e].sort(this.sorter.compare.bind(this.sorter))), e;
  }
  dispose() {
    this.disposables.dispose(), this.tree.dispose();
  }
}
class RR {
  get element() {
    return {
      elements: this.node.element.elements.map((e) => e.element),
      incompressible: this.node.element.incompressible
    };
  }
  get children() {
    return this.node.children.map((e) => new RR(e));
  }
  get depth() {
    return this.node.depth;
  }
  get visibleChildrenCount() {
    return this.node.visibleChildrenCount;
  }
  get visibleChildIndex() {
    return this.node.visibleChildIndex;
  }
  get collapsible() {
    return this.node.collapsible;
  }
  get collapsed() {
    return this.node.collapsed;
  }
  get visible() {
    return this.node.visible;
  }
  get filterData() {
    return this.node.filterData;
  }
  constructor(e) {
    this.node = e;
  }
}
class MCt {
  constructor(e, t, n, i) {
    this.renderer = e, this.nodeMapper = t, this.compressibleNodeMapperProvider = n, this.onDidChangeTwistieState = i, this.renderedNodes = /* @__PURE__ */ new Map(), this.disposables = [], this.templateId = e.templateId;
  }
  renderTemplate(e) {
    return { templateData: this.renderer.renderTemplate(e) };
  }
  renderElement(e, t, n, i) {
    this.renderer.renderElement(this.nodeMapper.map(e), t, n.templateData, i);
  }
  renderCompressedElements(e, t, n, i) {
    this.renderer.renderCompressedElements(this.compressibleNodeMapperProvider().map(e), t, n.templateData, i);
  }
  renderTwistie(e, t) {
    return e.slow ? (t.classList.add(...Tt.asClassNameArray(ke.treeItemLoading)), !0) : (t.classList.remove(...Tt.asClassNameArray(ke.treeItemLoading)), !1);
  }
  disposeElement(e, t, n, i) {
    this.renderer.disposeElement?.(this.nodeMapper.map(e), t, n.templateData, i);
  }
  disposeCompressedElements(e, t, n, i) {
    this.renderer.disposeCompressedElements?.(this.compressibleNodeMapperProvider().map(e), t, n.templateData, i);
  }
  disposeTemplate(e) {
    this.renderer.disposeTemplate(e.templateData);
  }
  dispose() {
    this.renderedNodes.clear(), this.disposables = br(this.disposables);
  }
}
function DCt(r) {
  const e = r && iTe(r);
  return e && {
    ...e,
    keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && {
      ...e.keyboardNavigationLabelProvider,
      getCompressedNodeKeyboardNavigationLabel(t) {
        return r.keyboardNavigationLabelProvider.getCompressedNodeKeyboardNavigationLabel(t.map((n) => n.element));
      }
    }
  };
}
class LCt extends rTe {
  constructor(e, t, n, i, s, o, a = {}) {
    super(e, t, n, s, o, a), this.compressionDelegate = i, this.compressibleNodeMapper = new DR((l) => new RR(l)), this.filter = a.filter;
  }
  createTree(e, t, n, i, s) {
    const o = new kR(n), a = i.map((c) => new MCt(c, this.nodeMapper, () => this.compressibleNodeMapper, this._onDidChangeNodeSlowState.event)), l = DCt(s) || {};
    return new nTe(e, t, o, a, l);
  }
  asTreeElement(e, t) {
    return {
      incompressible: this.compressionDelegate.isIncompressible(e.element),
      ...super.asTreeElement(e, t)
    };
  }
  updateOptions(e = {}) {
    this.tree.updateOptions(e);
  }
  render(e, t, n) {
    if (!this.identityProvider)
      return super.render(e, t);
    const i = (p) => this.identityProvider.getId(p).toString(), s = (p) => {
      const g = /* @__PURE__ */ new Set();
      for (const m of p) {
        const A = this.tree.getCompressedTreeNode(m === this.root ? null : m);
        if (A.element)
          for (const w of A.element.elements)
            g.add(i(w.element));
      }
      return g;
    }, o = s(this.tree.getSelection()), a = s(this.tree.getFocus());
    super.render(e, t, n);
    const l = this.getSelection();
    let c = !1;
    const d = this.getFocus();
    let u = !1;
    const f = (p) => {
      const g = p.element;
      if (g)
        for (let m = 0; m < g.elements.length; m++) {
          const A = i(g.elements[m].element), w = g.elements[g.elements.length - 1].element;
          o.has(A) && l.indexOf(w) === -1 && (l.push(w), c = !0), a.has(A) && d.indexOf(w) === -1 && (d.push(w), u = !0);
        }
      p.children.forEach(f);
    };
    f(this.tree.getCompressedTreeNode(e === this.root ? null : e)), c && this.setSelection(l), u && this.setFocus(d);
  }
  // For compressed async data trees, `TreeVisibility.Recurse` doesn't currently work
  // and we have to filter everything beforehand
  // Related to #85193 and #85835
  processChildren(e) {
    return this.filter && (e = Jt.filter(e, (t) => {
      const n = this.filter.filter(
        t,
        1
        /* TreeVisibility.Visible */
      ), i = kCt(n);
      if (i === 2)
        throw new Error("Recursive tree visibility not supported in async data compressed trees");
      return i === 1;
    })), super.processChildren(e);
  }
}
function kCt(r) {
  return typeof r == "boolean" ? r ? 1 : 0 : LR(r) ? h4(r.visibility) : h4(r);
}
class NCt extends $Ne {
  constructor(e, t, n, i, s, o = {}) {
    super(e, t, n, i, o), this.user = e, this.dataSource = s, this.identityProvider = o.identityProvider;
  }
  createModel(e, t, n) {
    return new NR(e, t, n);
  }
}
new Ve("isMac", zt, C("isMac", "Whether the operating system is macOS"));
new Ve("isLinux", Cs, C("isLinux", "Whether the operating system is Linux"));
new Ve("isWindows", zs, C("isWindows", "Whether the operating system is Windows"));
new Ve("isWeb", Yg, C("isWeb", "Whether the platform is a web browser"));
new Ve("isMacNative", zt && !Yg, C("isMacNative", "Whether the operating system is macOS on a non-browser platform"));
new Ve("isIOS", pf, C("isIOS", "Whether the operating system is iOS"));
new Ve("isMobile", IMe, C("isMobile", "Whether the platform is a mobile web browser"));
new Ve("isDevelopment", !1, !0);
new Ve("productQualityType", "", C("productQualityType", "Quality type of VS Code"));
const sTe = "inputFocus", TCt = new Ve(sTe, !1, C("inputFocus", "Whether keyboard focus is inside an input box"));
var Yd = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, On = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const Dh = Wt("listService");
class ICt {
  get lastFocusedList() {
    return this._lastFocusedWidget;
  }
  constructor() {
    this.disposables = new ze(), this.lists = [], this._lastFocusedWidget = void 0, this._hasCreatedStyleController = !1;
  }
  setLastFocusedList(e) {
    e !== this._lastFocusedWidget && (this._lastFocusedWidget?.getHTMLElement().classList.remove("last-focused"), this._lastFocusedWidget = e, this._lastFocusedWidget?.getHTMLElement().classList.add("last-focused"));
  }
  register(e, t) {
    if (this._hasCreatedStyleController || (this._hasCreatedStyleController = !0, new VNe(ya(), "").style(lm)), this.lists.some((i) => i.widget === e))
      throw new Error("Cannot register the same widget multiple times");
    const n = { widget: e, extraContextKeys: t };
    return this.lists.push(n), F7(e.getHTMLElement()) && this.setLastFocusedList(e), ih(e.onDidFocus(() => this.setLastFocusedList(e)), ht(() => this.lists.splice(this.lists.indexOf(n), 1)), e.onDidDispose(() => {
      this.lists = this.lists.filter((i) => i !== n), this._lastFocusedWidget === e && this.setLastFocusedList(void 0);
    }));
  }
  dispose() {
    this.disposables.dispose();
  }
}
const d4 = new Ve("listScrollAtBoundary", "none");
mt.or(d4.isEqualTo("top"), d4.isEqualTo("both"));
mt.or(d4.isEqualTo("bottom"), d4.isEqualTo("both"));
const oTe = new Ve("listFocus", !0), aTe = new Ve("treestickyScrollFocused", !1), Iy = new Ve("listSupportsMultiselect", !0);
mt.and(oTe, mt.not(sTe), aTe.negate());
const VR = new Ve("listHasSelectionOrFocus", !1), HR = new Ve("listDoubleSelection", !1), BR = new Ve("listMultiSelection", !1), Oy = new Ve("listSelectionNavigation", !1), OCt = new Ve("listSupportsFind", !0), RCt = new Ve("treeElementCanCollapse", !1), VCt = new Ve("treeElementHasParent", !1), HCt = new Ve("treeElementCanExpand", !1), BCt = new Ve("treeElementHasChild", !1), PCt = new Ve("treeFindOpen", !1), lTe = "listTypeNavigationMode", cTe = "listAutomaticKeyboardNavigation";
function Ry(r, e) {
  const t = r.createScoped(e.getHTMLElement());
  return oTe.bindTo(t), t;
}
function Vy(r, e) {
  const t = d4.bindTo(r), n = () => {
    const i = e.scrollTop === 0, s = e.scrollHeight - e.renderHeight - e.scrollTop < 1;
    i && s ? t.set("both") : i ? t.set("top") : s ? t.set("bottom") : t.set("none");
  };
  return n(), e.onDidScroll(n);
}
const s2 = "workbench.list.multiSelectModifier", O6 = "workbench.list.openMode", Aa = "workbench.list.horizontalScrolling", PR = "workbench.list.defaultFindMode", FR = "workbench.list.typeNavigationMode", G9 = "workbench.list.keyboardNavigation", oc = "workbench.list.scrollByPage", zR = "workbench.list.defaultFindMatchType", u4 = "workbench.tree.indent", Q9 = "workbench.tree.renderIndentGuides", ac = "workbench.list.smoothScrolling", fh = "workbench.list.mouseWheelScrollSensitivity", ph = "workbench.list.fastScrollSensitivity", K9 = "workbench.tree.expandMode", Y9 = "workbench.tree.enableStickyScroll", X9 = "workbench.tree.stickyScrollMaxItemCount";
function gh(r) {
  return r.getValue(s2) === "alt";
}
class FCt extends me {
  constructor(e) {
    super(), this.configurationService = e, this.useAltAsMultipleSelectionModifier = gh(e), this.registerListeners();
  }
  registerListeners() {
    this._register(this.configurationService.onDidChangeConfiguration((e) => {
      e.affectsConfiguration(s2) && (this.useAltAsMultipleSelectionModifier = gh(this.configurationService));
    }));
  }
  isSelectionSingleChangeEvent(e) {
    return this.useAltAsMultipleSelectionModifier ? e.browserEvent.altKey : INe(e);
  }
  isSelectionRangeChangeEvent(e) {
    return ONe(e);
  }
}
function Hy(r, e) {
  const t = r.get(Ai), n = r.get(_r), i = new ze();
  return [{
    ...e,
    keyboardNavigationDelegate: { mightProducePrintableCharacter(o) {
      return n.mightProducePrintableCharacter(o);
    } },
    smoothScrolling: !!t.getValue(ac),
    mouseWheelScrollSensitivity: t.getValue(fh),
    fastScrollSensitivity: t.getValue(ph),
    multipleSelectionController: e.multipleSelectionController ?? i.add(new FCt(t)),
    keyboardNavigationEventFilter: jCt(n),
    scrollByPage: !!t.getValue(oc)
  }, i];
}
let M9e = class extends gc {
  constructor(e, t, n, i, s, o, a, l, c) {
    const d = typeof s.horizontalScrolling < "u" ? s.horizontalScrolling : !!l.getValue(Aa), [u, f] = c.invokeFunction(Hy, s);
    super(e, t, n, i, {
      keyboardSupport: !1,
      ...u,
      horizontalScrolling: d
    }), this.disposables.add(f), this.contextKeyService = Ry(o, this), this.disposables.add(Vy(this.contextKeyService, this)), this.listSupportsMultiSelect = Iy.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), Oy.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this.listHasSelectionOrFocus = VR.bindTo(this.contextKeyService), this.listDoubleSelection = HR.bindTo(this.contextKeyService), this.listMultiSelection = BR.bindTo(this.contextKeyService), this.horizontalScrolling = s.horizontalScrolling, this._useAltAsMultipleSelectionModifier = gh(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const g = this.getSelection(), m = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(g.length > 0 || m.length > 0), this.listMultiSelection.set(g.length > 1), this.listDoubleSelection.set(g.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const g = this.getSelection(), m = this.getFocus();
      this.listHasSelectionOrFocus.set(g.length > 0 || m.length > 0);
    })), this.disposables.add(l.onDidChangeConfiguration((g) => {
      g.affectsConfiguration(s2) && (this._useAltAsMultipleSelectionModifier = gh(l));
      let m = {};
      if (g.affectsConfiguration(Aa) && this.horizontalScrolling === void 0) {
        const A = !!l.getValue(Aa);
        m = { ...m, horizontalScrolling: A };
      }
      if (g.affectsConfiguration(oc)) {
        const A = !!l.getValue(oc);
        m = { ...m, scrollByPage: A };
      }
      if (g.affectsConfiguration(ac)) {
        const A = !!l.getValue(ac);
        m = { ...m, smoothScrolling: A };
      }
      if (g.affectsConfiguration(fh)) {
        const A = l.getValue(fh);
        m = { ...m, mouseWheelScrollSensitivity: A };
      }
      if (g.affectsConfiguration(ph)) {
        const A = l.getValue(ph);
        m = { ...m, fastScrollSensitivity: A };
      }
      Object.keys(m).length > 0 && this.updateOptions(m);
    })), this.navigator = new hTe(this, { configurationService: l, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Vw(e) : lm);
  }
};
M9e = Yd([
  On(5, sn),
  On(6, Dh),
  On(7, Ai),
  On(8, xn)
], M9e);
let D9e = class extends Fyt {
  constructor(e, t, n, i, s, o, a, l, c) {
    const d = typeof s.horizontalScrolling < "u" ? s.horizontalScrolling : !!l.getValue(Aa), [u, f] = c.invokeFunction(Hy, s);
    super(e, t, n, i, {
      keyboardSupport: !1,
      ...u,
      horizontalScrolling: d
    }), this.disposables = new ze(), this.disposables.add(f), this.contextKeyService = Ry(o, this), this.disposables.add(Vy(this.contextKeyService, this.widget)), this.horizontalScrolling = s.horizontalScrolling, this.listSupportsMultiSelect = Iy.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(s.multipleSelectionSupport !== !1), Oy.bindTo(this.contextKeyService).set(!!s.selectionNavigation), this._useAltAsMultipleSelectionModifier = gh(l), this.disposables.add(this.contextKeyService), this.disposables.add(a.register(this)), this.updateStyles(s.overrideStyles), this.disposables.add(l.onDidChangeConfiguration((g) => {
      g.affectsConfiguration(s2) && (this._useAltAsMultipleSelectionModifier = gh(l));
      let m = {};
      if (g.affectsConfiguration(Aa) && this.horizontalScrolling === void 0) {
        const A = !!l.getValue(Aa);
        m = { ...m, horizontalScrolling: A };
      }
      if (g.affectsConfiguration(oc)) {
        const A = !!l.getValue(oc);
        m = { ...m, scrollByPage: A };
      }
      if (g.affectsConfiguration(ac)) {
        const A = !!l.getValue(ac);
        m = { ...m, smoothScrolling: A };
      }
      if (g.affectsConfiguration(fh)) {
        const A = l.getValue(fh);
        m = { ...m, mouseWheelScrollSensitivity: A };
      }
      if (g.affectsConfiguration(ph)) {
        const A = l.getValue(ph);
        m = { ...m, fastScrollSensitivity: A };
      }
      Object.keys(m).length > 0 && this.updateOptions(m);
    })), this.navigator = new hTe(this, { configurationService: l, ...s }), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Vw(e) : lm);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
D9e = Yd([
  On(5, sn),
  On(6, Dh),
  On(7, Ai),
  On(8, xn)
], D9e);
let L9e = class extends Jyt {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    const u = typeof o.horizontalScrolling < "u" ? o.horizontalScrolling : !!c.getValue(Aa), [f, p] = d.invokeFunction(Hy, o);
    super(e, t, n, i, s, {
      keyboardSupport: !1,
      ...f,
      horizontalScrolling: u
    }), this.disposables.add(p), this.contextKeyService = Ry(a, this), this.disposables.add(Vy(this.contextKeyService, this)), this.listSupportsMultiSelect = Iy.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(o.multipleSelectionSupport !== !1), Oy.bindTo(this.contextKeyService).set(!!o.selectionNavigation), this.listHasSelectionOrFocus = VR.bindTo(this.contextKeyService), this.listDoubleSelection = HR.bindTo(this.contextKeyService), this.listMultiSelection = BR.bindTo(this.contextKeyService), this.horizontalScrolling = o.horizontalScrolling, this._useAltAsMultipleSelectionModifier = gh(c), this.disposables.add(this.contextKeyService), this.disposables.add(l.register(this)), this.updateStyles(o.overrideStyles), this.disposables.add(this.onDidChangeSelection(() => {
      const m = this.getSelection(), A = this.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.listHasSelectionOrFocus.set(m.length > 0 || A.length > 0), this.listMultiSelection.set(m.length > 1), this.listDoubleSelection.set(m.length === 2);
      });
    })), this.disposables.add(this.onDidChangeFocus(() => {
      const m = this.getSelection(), A = this.getFocus();
      this.listHasSelectionOrFocus.set(m.length > 0 || A.length > 0);
    })), this.disposables.add(c.onDidChangeConfiguration((m) => {
      m.affectsConfiguration(s2) && (this._useAltAsMultipleSelectionModifier = gh(c));
      let A = {};
      if (m.affectsConfiguration(Aa) && this.horizontalScrolling === void 0) {
        const w = !!c.getValue(Aa);
        A = { ...A, horizontalScrolling: w };
      }
      if (m.affectsConfiguration(oc)) {
        const w = !!c.getValue(oc);
        A = { ...A, scrollByPage: w };
      }
      if (m.affectsConfiguration(ac)) {
        const w = !!c.getValue(ac);
        A = { ...A, smoothScrolling: w };
      }
      if (m.affectsConfiguration(fh)) {
        const w = c.getValue(fh);
        A = { ...A, mouseWheelScrollSensitivity: w };
      }
      if (m.affectsConfiguration(ph)) {
        const w = c.getValue(ph);
        A = { ...A, fastScrollSensitivity: w };
      }
      Object.keys(A).length > 0 && this.updateOptions(A);
    })), this.navigator = new zCt(this, { configurationService: c, ...o }), this.disposables.add(this.navigator);
  }
  updateOptions(e) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.updateStyles(e.overrideStyles), e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyles(e) {
    this.style(e ? Vw(e) : lm);
  }
  dispose() {
    this.disposables.dispose(), super.dispose();
  }
};
L9e = Yd([
  On(6, sn),
  On(7, Dh),
  On(8, Ai),
  On(9, xn)
], L9e);
class WR extends me {
  constructor(e, t) {
    super(), this.widget = e, this._onDidOpen = this._register(new $()), this.onDidOpen = this._onDidOpen.event, this._register(xe.filter(this.widget.onDidChangeSelection, (n) => Xh(n.browserEvent))((n) => this.onSelectionFromKeyboard(n))), this._register(this.widget.onPointer((n) => this.onPointer(n.element, n.browserEvent))), this._register(this.widget.onMouseDblClick((n) => this.onMouseDblClick(n.element, n.browserEvent))), typeof t?.openOnSingleClick != "boolean" && t?.configurationService ? (this.openOnSingleClick = t?.configurationService.getValue(O6) !== "doubleClick", this._register(t?.configurationService.onDidChangeConfiguration((n) => {
      n.affectsConfiguration(O6) && (this.openOnSingleClick = t?.configurationService.getValue(O6) !== "doubleClick");
    }))) : this.openOnSingleClick = t?.openOnSingleClick ?? !0;
  }
  onSelectionFromKeyboard(e) {
    if (e.elements.length !== 1)
      return;
    const t = e.browserEvent, n = typeof t.preserveFocus == "boolean" ? t.preserveFocus : !0, i = typeof t.pinned == "boolean" ? t.pinned : !n;
    this._open(this.getSelectedElement(), n, i, !1, e.browserEvent);
  }
  onPointer(e, t) {
    if (!this.openOnSingleClick || t.detail === 2)
      return;
    const i = t.button === 1, s = !0, o = i, a = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, s, o, a, t);
  }
  onMouseDblClick(e, t) {
    if (!t)
      return;
    const n = t.target;
    if (n.classList.contains("monaco-tl-twistie") || n.classList.contains("monaco-icon-label") && n.classList.contains("folder-icon") && t.offsetX < 16)
      return;
    const s = !1, o = !0, a = t.ctrlKey || t.metaKey || t.altKey;
    this._open(e, s, o, a, t);
  }
  _open(e, t, n, i, s) {
    e && this._onDidOpen.fire({
      editorOptions: {
        preserveFocus: t,
        pinned: n,
        revealIfVisible: !0
      },
      sideBySide: i,
      element: e,
      browserEvent: s
    });
  }
}
class hTe extends WR {
  constructor(e, t) {
    super(e, t), this.widget = e;
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class zCt extends WR {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    return this.widget.getSelectedElements()[0];
  }
}
class WCt extends WR {
  constructor(e, t) {
    super(e, t);
  }
  getSelectedElement() {
    return this.widget.getSelection()[0] ?? void 0;
  }
}
function jCt(r) {
  let e = !1;
  return (t) => {
    if (t.toKeyCodeChord().isModifierKey())
      return !1;
    if (e)
      return e = !1, !1;
    const n = r.softDispatch(t, t.target);
    return n.kind === 1 ? (e = !0, !1) : (e = !1, n.kind === 0);
  };
}
let Dk = class extends IR {
  constructor(e, t, n, i, s, o, a, l, c) {
    const { options: d, getTypeNavigationMode: u, disposable: f } = o.invokeFunction(Pw, s);
    super(e, t, n, i, d), this.disposables.add(f), this.internals = new Sf(this, s, u, s.overrideStyles, a, l, c), this.disposables.add(this.internals);
  }
  updateOptions(e) {
    super.updateOptions(e), this.internals.updateOptions(e);
  }
};
Dk = Yd([
  On(5, xn),
  On(6, sn),
  On(7, Dh),
  On(8, Ai)
], Dk);
let k9e = class extends nTe {
  constructor(e, t, n, i, s, o, a, l, c) {
    const { options: d, getTypeNavigationMode: u, disposable: f } = o.invokeFunction(Pw, s);
    super(e, t, n, i, d), this.disposables.add(f), this.internals = new Sf(this, s, u, s.overrideStyles, a, l, c), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
k9e = Yd([
  On(5, xn),
  On(6, sn),
  On(7, Dh),
  On(8, Ai)
], k9e);
let N9e = class extends NCt {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    const { options: u, getTypeNavigationMode: f, disposable: p } = a.invokeFunction(Pw, o);
    super(e, t, n, i, s, u), this.disposables.add(p), this.internals = new Sf(this, o, f, o.overrideStyles, l, c, d), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles !== void 0 && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
N9e = Yd([
  On(6, xn),
  On(7, sn),
  On(8, Dh),
  On(9, Ai)
], N9e);
let T9e = class extends rTe {
  get onDidOpen() {
    return this.internals.onDidOpen;
  }
  constructor(e, t, n, i, s, o, a, l, c, d) {
    const { options: u, getTypeNavigationMode: f, disposable: p } = a.invokeFunction(Pw, o);
    super(e, t, n, i, s, u), this.disposables.add(p), this.internals = new Sf(this, o, f, o.overrideStyles, l, c, d), this.disposables.add(this.internals);
  }
  updateOptions(e = {}) {
    super.updateOptions(e), e.overrideStyles && this.internals.updateStyleOverrides(e.overrideStyles), this.internals.updateOptions(e);
  }
};
T9e = Yd([
  On(6, xn),
  On(7, sn),
  On(8, Dh),
  On(9, Ai)
], T9e);
let I9e = class extends LCt {
  constructor(e, t, n, i, s, o, a, l, c, d, u) {
    const { options: f, getTypeNavigationMode: p, disposable: g } = l.invokeFunction(Pw, a);
    super(e, t, n, i, s, o, f), this.disposables.add(g), this.internals = new Sf(this, a, p, a.overrideStyles, c, d, u), this.disposables.add(this.internals);
  }
  updateOptions(e) {
    super.updateOptions(e), this.internals.updateOptions(e);
  }
};
I9e = Yd([
  On(7, xn),
  On(8, sn),
  On(9, Dh),
  On(10, Ai)
], I9e);
function dTe(r) {
  const e = r.getValue(PR);
  if (e === "highlight")
    return gd.Highlight;
  if (e === "filter")
    return gd.Filter;
  const t = r.getValue(G9);
  if (t === "simple" || t === "highlight")
    return gd.Highlight;
  if (t === "filter")
    return gd.Filter;
}
function uTe(r) {
  const e = r.getValue(zR);
  if (e === "fuzzy")
    return xf.Fuzzy;
  if (e === "contiguous")
    return xf.Contiguous;
}
function Pw(r, e) {
  const t = r.get(Ai), n = r.get(rm), i = r.get(sn), s = r.get(xn), o = () => {
    const f = i.getContextKeyValue(lTe);
    if (f === "automatic")
      return Gc.Automatic;
    if (f === "trigger" || i.getContextKeyValue(cTe) === !1)
      return Gc.Trigger;
    const g = t.getValue(FR);
    if (g === "automatic")
      return Gc.Automatic;
    if (g === "trigger")
      return Gc.Trigger;
  }, a = e.horizontalScrolling !== void 0 ? e.horizontalScrolling : !!t.getValue(Aa), [l, c] = s.invokeFunction(Hy, e), d = e.paddingBottom, u = e.renderIndentGuides !== void 0 ? e.renderIndentGuides : t.getValue(Q9);
  return {
    getTypeNavigationMode: o,
    disposable: c,
    options: {
      // ...options, // TODO@Joao why is this not splatted here?
      keyboardSupport: !1,
      ...l,
      indent: typeof t.getValue(u4) == "number" ? t.getValue(u4) : void 0,
      renderIndentGuides: u,
      smoothScrolling: !!t.getValue(ac),
      defaultFindMode: dTe(t),
      defaultFindMatchType: uTe(t),
      horizontalScrolling: a,
      scrollByPage: !!t.getValue(oc),
      paddingBottom: d,
      hideTwistiesOfChildlessElements: e.hideTwistiesOfChildlessElements,
      expandOnlyOnTwistieClick: e.expandOnlyOnTwistieClick ?? t.getValue(K9) === "doubleClick",
      contextViewProvider: n,
      findWidgetStyles: G7t,
      enableStickyScroll: !!t.getValue(Y9),
      stickyScrollMaxItemCount: Number(t.getValue(X9))
    }
  };
}
let Sf = class {
  get onDidOpen() {
    return this.navigator.onDidOpen;
  }
  constructor(e, t, n, i, s, o, a) {
    this.tree = e, this.disposables = [], this.contextKeyService = Ry(s, e), this.disposables.push(Vy(this.contextKeyService, e)), this.listSupportsMultiSelect = Iy.bindTo(this.contextKeyService), this.listSupportsMultiSelect.set(t.multipleSelectionSupport !== !1), Oy.bindTo(this.contextKeyService).set(!!t.selectionNavigation), this.listSupportFindWidget = OCt.bindTo(this.contextKeyService), this.listSupportFindWidget.set(t.findWidgetEnabled ?? !0), this.hasSelectionOrFocus = VR.bindTo(this.contextKeyService), this.hasDoubleSelection = HR.bindTo(this.contextKeyService), this.hasMultiSelection = BR.bindTo(this.contextKeyService), this.treeElementCanCollapse = RCt.bindTo(this.contextKeyService), this.treeElementHasParent = VCt.bindTo(this.contextKeyService), this.treeElementCanExpand = HCt.bindTo(this.contextKeyService), this.treeElementHasChild = BCt.bindTo(this.contextKeyService), this.treeFindOpen = PCt.bindTo(this.contextKeyService), this.treeStickyScrollFocused = aTe.bindTo(this.contextKeyService), this._useAltAsMultipleSelectionModifier = gh(a), this.updateStyleOverrides(i);
    const c = () => {
      const u = e.getFocus()[0];
      if (!u)
        return;
      const f = e.getNode(u);
      this.treeElementCanCollapse.set(f.collapsible && !f.collapsed), this.treeElementHasParent.set(!!e.getParentElement(u)), this.treeElementCanExpand.set(f.collapsible && f.collapsed), this.treeElementHasChild.set(!!e.getFirstElementChild(u));
    }, d = /* @__PURE__ */ new Set();
    d.add(lTe), d.add(cTe), this.disposables.push(this.contextKeyService, o.register(e), e.onDidChangeSelection(() => {
      const u = e.getSelection(), f = e.getFocus();
      this.contextKeyService.bufferChangeEvents(() => {
        this.hasSelectionOrFocus.set(u.length > 0 || f.length > 0), this.hasMultiSelection.set(u.length > 1), this.hasDoubleSelection.set(u.length === 2);
      });
    }), e.onDidChangeFocus(() => {
      const u = e.getSelection(), f = e.getFocus();
      this.hasSelectionOrFocus.set(u.length > 0 || f.length > 0), c();
    }), e.onDidChangeCollapseState(c), e.onDidChangeModel(c), e.onDidChangeFindOpenState((u) => this.treeFindOpen.set(u)), e.onDidChangeStickyScrollFocused((u) => this.treeStickyScrollFocused.set(u)), a.onDidChangeConfiguration((u) => {
      let f = {};
      if (u.affectsConfiguration(s2) && (this._useAltAsMultipleSelectionModifier = gh(a)), u.affectsConfiguration(u4)) {
        const p = a.getValue(u4);
        f = { ...f, indent: p };
      }
      if (u.affectsConfiguration(Q9) && t.renderIndentGuides === void 0) {
        const p = a.getValue(Q9);
        f = { ...f, renderIndentGuides: p };
      }
      if (u.affectsConfiguration(ac)) {
        const p = !!a.getValue(ac);
        f = { ...f, smoothScrolling: p };
      }
      if (u.affectsConfiguration(PR) || u.affectsConfiguration(G9)) {
        const p = dTe(a);
        f = { ...f, defaultFindMode: p };
      }
      if (u.affectsConfiguration(FR) || u.affectsConfiguration(G9)) {
        const p = n();
        f = { ...f, typeNavigationMode: p };
      }
      if (u.affectsConfiguration(zR)) {
        const p = uTe(a);
        f = { ...f, defaultFindMatchType: p };
      }
      if (u.affectsConfiguration(Aa) && t.horizontalScrolling === void 0) {
        const p = !!a.getValue(Aa);
        f = { ...f, horizontalScrolling: p };
      }
      if (u.affectsConfiguration(oc)) {
        const p = !!a.getValue(oc);
        f = { ...f, scrollByPage: p };
      }
      if (u.affectsConfiguration(K9) && t.expandOnlyOnTwistieClick === void 0 && (f = { ...f, expandOnlyOnTwistieClick: a.getValue(K9) === "doubleClick" }), u.affectsConfiguration(Y9)) {
        const p = a.getValue(Y9);
        f = { ...f, enableStickyScroll: p };
      }
      if (u.affectsConfiguration(X9)) {
        const p = Math.max(1, a.getValue(X9));
        f = { ...f, stickyScrollMaxItemCount: p };
      }
      if (u.affectsConfiguration(fh)) {
        const p = a.getValue(fh);
        f = { ...f, mouseWheelScrollSensitivity: p };
      }
      if (u.affectsConfiguration(ph)) {
        const p = a.getValue(ph);
        f = { ...f, fastScrollSensitivity: p };
      }
      Object.keys(f).length > 0 && e.updateOptions(f);
    }), this.contextKeyService.onDidChangeContext((u) => {
      u.affectsSome(d) && e.updateOptions({ typeNavigationMode: n() });
    })), this.navigator = new WCt(e, { configurationService: a, ...t }), this.disposables.push(this.navigator);
  }
  updateOptions(e) {
    e.multipleSelectionSupport !== void 0 && this.listSupportsMultiSelect.set(!!e.multipleSelectionSupport);
  }
  updateStyleOverrides(e) {
    this.tree.style(e ? Vw(e) : lm);
  }
  dispose() {
    this.disposables = br(this.disposables);
  }
};
Sf = Yd([
  On(4, sn),
  On(5, Dh),
  On(6, Ai)
], Sf);
const ZCt = Er.as($f.Configuration);
ZCt.registerConfiguration({
  id: "workbench",
  order: 7,
  title: C("workbenchConfigurationTitle", "Workbench"),
  type: "object",
  properties: {
    [s2]: {
      type: "string",
      enum: ["ctrlCmd", "alt"],
      markdownEnumDescriptions: [
        C("multiSelectModifier.ctrlCmd", "Maps to `Control` on Windows and Linux and to `Command` on macOS."),
        C("multiSelectModifier.alt", "Maps to `Alt` on Windows and Linux and to `Option` on macOS.")
      ],
      default: "ctrlCmd",
      description: C({
        key: "multiSelectModifier",
        comment: [
          "- `ctrlCmd` refers to a value the setting can take and should not be localized.",
          "- `Control` and `Command` refer to the modifier keys Ctrl or Cmd on the keyboard and can be localized."
        ]
      }, "The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.")
    },
    [O6]: {
      type: "string",
      enum: ["singleClick", "doubleClick"],
      default: "singleClick",
      description: C({
        key: "openModeModifier",
        comment: ["`singleClick` and `doubleClick` refers to a value the setting can take and should not be localized."]
      }, "Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.")
    },
    [Aa]: {
      type: "boolean",
      default: !1,
      description: C("horizontalScrolling setting", "Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.")
    },
    [oc]: {
      type: "boolean",
      default: !1,
      description: C("list.scrollByPage", "Controls whether clicks in the scrollbar scroll page by page.")
    },
    [u4]: {
      type: "number",
      default: 8,
      minimum: 4,
      maximum: 40,
      description: C("tree indent setting", "Controls tree indentation in pixels.")
    },
    [Q9]: {
      type: "string",
      enum: ["none", "onHover", "always"],
      default: "onHover",
      description: C("render tree indent guides", "Controls whether the tree should render indent guides.")
    },
    [ac]: {
      type: "boolean",
      default: !1,
      description: C("list smoothScrolling setting", "Controls whether lists and trees have smooth scrolling.")
    },
    [fh]: {
      type: "number",
      default: 1,
      markdownDescription: C("Mouse Wheel Scroll Sensitivity", "A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.")
    },
    [ph]: {
      type: "number",
      default: 5,
      markdownDescription: C("Fast Scroll Sensitivity", "Scrolling speed multiplier when pressing `Alt`.")
    },
    [PR]: {
      type: "string",
      enum: ["highlight", "filter"],
      enumDescriptions: [
        C("defaultFindModeSettingKey.highlight", "Highlight elements when searching. Further up and down navigation will traverse only the highlighted elements."),
        C("defaultFindModeSettingKey.filter", "Filter elements when searching.")
      ],
      default: "highlight",
      description: C("defaultFindModeSettingKey", "Controls the default find mode for lists and trees in the workbench.")
    },
    [G9]: {
      type: "string",
      enum: ["simple", "highlight", "filter"],
      enumDescriptions: [
        C("keyboardNavigationSettingKey.simple", "Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes."),
        C("keyboardNavigationSettingKey.highlight", "Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements."),
        C("keyboardNavigationSettingKey.filter", "Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.")
      ],
      default: "highlight",
      description: C("keyboardNavigationSettingKey", "Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter."),
      deprecated: !0,
      deprecationMessage: C("keyboardNavigationSettingKeyDeprecated", "Please use 'workbench.list.defaultFindMode' and	'workbench.list.typeNavigationMode' instead.")
    },
    [zR]: {
      type: "string",
      enum: ["fuzzy", "contiguous"],
      enumDescriptions: [
        C("defaultFindMatchTypeSettingKey.fuzzy", "Use fuzzy matching when searching."),
        C("defaultFindMatchTypeSettingKey.contiguous", "Use contiguous matching when searching.")
      ],
      default: "fuzzy",
      description: C("defaultFindMatchTypeSettingKey", "Controls the type of matching used when searching lists and trees in the workbench.")
    },
    [K9]: {
      type: "string",
      enum: ["singleClick", "doubleClick"],
      default: "singleClick",
      description: C("expand mode", "Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable.")
    },
    [Y9]: {
      type: "boolean",
      default: !0,
      description: C("sticky scroll", "Controls whether sticky scrolling is enabled in trees.")
    },
    [X9]: {
      type: "number",
      minimum: 1,
      default: 7,
      markdownDescription: C("sticky scroll maximum items", "Controls the number of sticky elements displayed in the tree when {0} is enabled.", "`#workbench.tree.enableStickyScroll#`")
    },
    [FR]: {
      type: "string",
      enum: ["automatic", "trigger"],
      default: "automatic",
      markdownDescription: C("typeNavigationMode2", "Controls how type navigation works in lists and trees in the workbench. When set to `trigger`, type navigation begins once the `list.triggerTypeNavigation` command is run.")
    }
  }
});
class $0 extends me {
  /**
   * Create a new {@link HighlightedLabel}.
   *
   * @param container The parent container to append to.
   */
  constructor(e, t) {
    super(), this.options = t, this.text = "", this.title = "", this.highlights = [], this.didEverRender = !1, this.supportIcons = t?.supportIcons ?? !1, this.domNode = Fe(e, $e("span.monaco-highlighted-label"));
  }
  /**
   * The label's DOM node.
   */
  get element() {
    return this.domNode;
  }
  /**
   * Set the label and highlights.
   *
   * @param text The label to display.
   * @param highlights The ranges to highlight.
   * @param title An optional title for the hover tooltip.
   * @param escapeNewLines Whether to escape new lines.
   * @returns
   */
  set(e, t = [], n = "", i) {
    e || (e = ""), i && (e = $0.escapeNewLines(e, t)), !(this.didEverRender && this.text === e && this.title === n && Ho(this.highlights, t)) && (this.text = e, this.title = n, this.highlights = t, this.render());
  }
  render() {
    const e = [];
    let t = 0;
    for (const n of this.highlights) {
      if (n.end === n.start)
        continue;
      if (t < n.start) {
        const o = this.text.substring(t, n.start);
        this.supportIcons ? e.push(...X0(o)) : e.push(o), t = n.start;
      }
      const i = this.text.substring(t, n.end), s = $e("span.highlight", void 0, ...this.supportIcons ? X0(i) : [i]);
      n.extraClasses && s.classList.add(...n.extraClasses), e.push(s), t = n.end;
    }
    if (t < this.text.length) {
      const n = this.text.substring(t);
      this.supportIcons ? e.push(...X0(n)) : e.push(n);
    }
    if (ys(this.domNode, ...e), this.options?.hoverDelegate?.showNativeHover)
      this.domNode.title = this.title;
    else if (!this.customHover && this.title !== "") {
      const n = this.options?.hoverDelegate ?? fo("mouse");
      this.customHover = this._register(Mh().setupManagedHover(n, this.domNode, this.title));
    } else this.customHover && this.customHover.update(this.title);
    this.didEverRender = !0;
  }
  static escapeNewLines(e, t) {
    let n = 0, i = 0;
    return e.replace(/\r\n|\r|\n/g, (s, o) => {
      i = s === `\r
` ? -1 : 0, o += n;
      for (const a of t)
        a.end <= o || (a.start >= o && (a.start += i), a.end >= o && (a.end += i));
      return n += i, "⏎";
    });
  }
}
class qm {
  constructor(e) {
    this._element = e;
  }
  get element() {
    return this._element;
  }
  set textContent(e) {
    this.disposed || e === this._textContent || (this._textContent = e, this._element.textContent = e);
  }
  set className(e) {
    this.disposed || e === this._className || (this._className = e, this._element.className = e);
  }
  set empty(e) {
    this.disposed || e === this._empty || (this._empty = e, this._element.style.marginLeft = e ? "0" : "");
  }
  dispose() {
    this.disposed = !0;
  }
}
class O9e extends me {
  constructor(e, t) {
    super(), this.customHovers = /* @__PURE__ */ new Map(), this.creationOptions = t, this.domNode = this._register(new qm(Fe(e, $e(".monaco-icon-label")))), this.labelContainer = Fe(this.domNode.element, $e(".monaco-icon-label-container")), this.nameContainer = Fe(this.labelContainer, $e("span.monaco-icon-name-container")), t?.supportHighlights || t?.supportIcons ? this.nameNode = this._register(new GCt(this.nameContainer, !!t.supportIcons)) : this.nameNode = new UCt(this.nameContainer), this.hoverDelegate = t?.hoverDelegate ?? fo("mouse");
  }
  get element() {
    return this.domNode.element;
  }
  setLabel(e, t, n) {
    const i = ["monaco-icon-label"], s = ["monaco-icon-label-container"];
    let o = "";
    n && (n.extraClasses && i.push(...n.extraClasses), n.italic && i.push("italic"), n.strikethrough && i.push("strikethrough"), n.disabledCommand && s.push("disabled"), n.title && (typeof n.title == "string" ? o += n.title : o += e));
    const a = this.domNode.element.querySelector(".monaco-icon-label-iconpath");
    if (n?.iconPath) {
      let l;
      !a || !wr(a) ? (l = $e(".monaco-icon-label-iconpath"), this.domNode.element.prepend(l)) : l = a, l.style.backgroundImage = Pd(n?.iconPath);
    } else a && a.remove();
    if (this.domNode.className = i.join(" "), this.domNode.element.setAttribute("aria-label", o), this.labelContainer.className = s.join(" "), this.setupHover(n?.descriptionTitle ? this.labelContainer : this.element, n?.title), this.nameNode.setLabel(e, n), t || this.descriptionNode) {
      const l = this.getOrCreateDescriptionNode();
      l instanceof $0 ? (l.set(t || "", n ? n.descriptionMatches : void 0, void 0, n?.labelEscapeNewLines), this.setupHover(l.element, n?.descriptionTitle)) : (l.textContent = t && n?.labelEscapeNewLines ? $0.escapeNewLines(t, []) : t || "", this.setupHover(l.element, n?.descriptionTitle || ""), l.empty = !t);
    }
    if (n?.suffix || this.suffixNode) {
      const l = this.getOrCreateSuffixNode();
      l.textContent = n?.suffix ?? "";
    }
  }
  setupHover(e, t) {
    const n = this.customHovers.get(e);
    if (n && (n.dispose(), this.customHovers.delete(e)), !t) {
      e.removeAttribute("title");
      return;
    }
    if (this.hoverDelegate.showNativeHover)
      (function(s, o) {
        Vo(o) ? s.title = pNe(o) : o?.markdownNotSupportedFallback ? s.title = o.markdownNotSupportedFallback : s.removeAttribute("title");
      })(e, t);
    else {
      const i = Mh().setupManagedHover(this.hoverDelegate, e, t);
      i && this.customHovers.set(e, i);
    }
  }
  dispose() {
    super.dispose();
    for (const e of this.customHovers.values())
      e.dispose();
    this.customHovers.clear();
  }
  getOrCreateSuffixNode() {
    if (!this.suffixNode) {
      const e = this._register(new qm(Fft(this.nameContainer, $e("span.monaco-icon-suffix-container"))));
      this.suffixNode = this._register(new qm(Fe(e.element, $e("span.label-suffix"))));
    }
    return this.suffixNode;
  }
  getOrCreateDescriptionNode() {
    if (!this.descriptionNode) {
      const e = this._register(new qm(Fe(this.labelContainer, $e("span.monaco-icon-description-container"))));
      this.creationOptions?.supportDescriptionHighlights ? this.descriptionNode = this._register(new $0(Fe(e.element, $e("span.label-description")), { supportIcons: !!this.creationOptions.supportIcons })) : this.descriptionNode = this._register(new qm(Fe(e.element, $e("span.label-description"))));
    }
    return this.descriptionNode;
  }
}
class UCt {
  constructor(e) {
    this.container = e, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (!(this.label === e && Ho(this.options, t)))
      if (this.label = e, this.options = t, typeof e == "string")
        this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = Fe(this.container, $e("a.label-name", { id: t?.domId }))), this.singleLabel.textContent = e;
      else {
        this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
        for (let n = 0; n < e.length; n++) {
          const i = e[n], s = t?.domId && `${t?.domId}_${n}`;
          Fe(this.container, $e("a.label-name", { id: s, "data-icon-label-count": e.length, "data-icon-label-index": n, role: "treeitem" }, i)), n < e.length - 1 && Fe(this.container, $e("span.label-separator", void 0, t?.separator || "/"));
        }
      }
  }
}
function qCt(r, e, t) {
  if (!t)
    return;
  let n = 0;
  return r.map((i) => {
    const s = { start: n, end: n + i.length }, o = t.map((a) => Rr.intersect(s, a)).filter((a) => !Rr.isEmpty(a)).map(({ start: a, end: l }) => ({ start: a - n, end: l - n }));
    return n = s.end + e.length, o;
  });
}
class GCt extends me {
  constructor(e, t) {
    super(), this.container = e, this.supportIcons = t, this.label = void 0, this.singleLabel = void 0;
  }
  setLabel(e, t) {
    if (!(this.label === e && Ho(this.options, t)))
      if (this.label = e, this.options = t, typeof e == "string")
        this.singleLabel || (this.container.innerText = "", this.container.classList.remove("multiple"), this.singleLabel = this._register(new $0(Fe(this.container, $e("a.label-name", { id: t?.domId })), { supportIcons: this.supportIcons }))), this.singleLabel.set(e, t?.matches, void 0, t?.labelEscapeNewLines);
      else {
        this.container.innerText = "", this.container.classList.add("multiple"), this.singleLabel = void 0;
        const n = t?.separator || "/", i = qCt(e, n, t?.matches);
        for (let s = 0; s < e.length; s++) {
          const o = e[s], a = i ? i[s] : void 0, l = t?.domId && `${t?.domId}_${s}`, c = $e("a.label-name", { id: l, "data-icon-label-count": e.length, "data-icon-label-index": s, role: "treeitem" });
          this._register(new $0(Fe(this.container, c), { supportIcons: this.supportIcons })).set(o, a, void 0, t?.labelEscapeNewLines), s < e.length - 1 && Fe(c, $e("span.label-separator", void 0, n));
        }
      }
  }
}
const o5 = $e;
class jR extends me {
  constructor(e, t, n) {
    super(), this.os = t, this.keyElements = /* @__PURE__ */ new Set(), this.options = n || /* @__PURE__ */ Object.create(null);
    const i = this.options.keybindingLabelForeground;
    this.domNode = Fe(e, o5(".monaco-keybinding")), i && (this.domNode.style.color = i), this.hover = this._register(Mh().setupManagedHover(fo("mouse"), this.domNode, "")), this.didEverRender = !1, e.appendChild(this.domNode);
  }
  get element() {
    return this.domNode;
  }
  set(e, t) {
    this.didEverRender && this.keybinding === e && jR.areSame(this.matches, t) || (this.keybinding = e, this.matches = t, this.render());
  }
  render() {
    if (this.clear(), this.keybinding) {
      const e = this.keybinding.getChords();
      e[0] && this.renderChord(this.domNode, e[0], this.matches ? this.matches.firstPart : null);
      for (let n = 1; n < e.length; n++)
        Fe(this.domNode, o5("span.monaco-keybinding-key-chord-separator", void 0, " ")), this.renderChord(this.domNode, e[n], this.matches ? this.matches.chordPart : null);
      const t = this.options.disableTitle ?? !1 ? void 0 : this.keybinding.getAriaLabel() || void 0;
      this.hover.update(t), this.domNode.setAttribute("aria-label", t || "");
    } else this.options && this.options.renderUnboundKeybindings && this.renderUnbound(this.domNode);
    this.didEverRender = !0;
  }
  clear() {
    ic(this.domNode), this.keyElements.clear();
  }
  renderChord(e, t, n) {
    const i = fR.modifierLabels[this.os];
    t.ctrlKey && this.renderKey(e, i.ctrlKey, !!n?.ctrlKey, i.separator), t.shiftKey && this.renderKey(e, i.shiftKey, !!n?.shiftKey, i.separator), t.altKey && this.renderKey(e, i.altKey, !!n?.altKey, i.separator), t.metaKey && this.renderKey(e, i.metaKey, !!n?.metaKey, i.separator);
    const s = t.keyLabel;
    s && this.renderKey(e, s, !!n?.keyCode, "");
  }
  renderKey(e, t, n, i) {
    Fe(e, this.createKeyElement(t, n ? ".highlight" : "")), i && Fe(e, o5("span.monaco-keybinding-key-separator", void 0, i));
  }
  renderUnbound(e) {
    Fe(e, this.createKeyElement(C("unbound", "Unbound")));
  }
  createKeyElement(e, t = "") {
    const n = o5("span.monaco-keybinding-key" + t, void 0, e);
    return this.keyElements.add(n), this.options.keybindingLabelBackground && (n.style.backgroundColor = this.options.keybindingLabelBackground), this.options.keybindingLabelBorder && (n.style.borderColor = this.options.keybindingLabelBorder), this.options.keybindingLabelBottomBorder && (n.style.borderBottomColor = this.options.keybindingLabelBottomBorder), this.options.keybindingLabelShadow && (n.style.boxShadow = `inset 0 -1px 0 ${this.options.keybindingLabelShadow}`), n;
  }
  static areSame(e, t) {
    return e === t || !e && !t ? !0 : !!e && !!t && Ho(e.firstPart, t.firstPart) && Ho(e.chordPart, t.chordPart);
  }
}
const R9e = new o1(() => {
  const r = new Intl.Collator(void 0, { numeric: !0, sensitivity: "base" });
  return {
    collator: r,
    collatorIsNumeric: r.resolvedOptions().numeric
  };
});
function QCt(r, e, t = !1) {
  const n = r || "", i = e || "", s = R9e.value.collator.compare(n, i);
  return R9e.value.collatorIsNumeric && s === 0 && n !== i ? n < i ? -1 : 1 : s;
}
function KCt(r, e, t) {
  const n = r.toLowerCase(), i = e.toLowerCase(), s = YCt(r, e, t);
  if (s)
    return s;
  const o = n.endsWith(t), a = i.endsWith(t);
  if (o !== a)
    return o ? -1 : 1;
  const l = QCt(n, i);
  return l !== 0 ? l : n.localeCompare(i);
}
function YCt(r, e, t) {
  const n = r.toLowerCase(), i = e.toLowerCase(), s = n.startsWith(t), o = i.startsWith(t);
  if (s !== o)
    return s ? -1 : 1;
  if (s && o) {
    if (n.length < i.length)
      return -1;
    if (n.length > i.length)
      return 1;
  }
  return 0;
}
var By = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Lk = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, kk;
const Nl = $e;
class fTe {
  constructor(e, t, n) {
    this.index = e, this.hasCheckbox = t, this._hidden = !1, this._init = new o1(() => {
      const i = n.label ?? "", s = bA(i).text.trim(), o = n.ariaLabel || [i, this.saneDescription, this.saneDetail].map((a) => p9t(a)).filter((a) => !!a).join(", ");
      return {
        saneLabel: i,
        saneSortLabel: s,
        saneAriaLabel: o
      };
    }), this._saneDescription = n.description, this._saneTooltip = n.tooltip;
  }
  // #region Lazy Getters
  get saneLabel() {
    return this._init.value.saneLabel;
  }
  get saneSortLabel() {
    return this._init.value.saneSortLabel;
  }
  get saneAriaLabel() {
    return this._init.value.saneAriaLabel;
  }
  get element() {
    return this._element;
  }
  set element(e) {
    this._element = e;
  }
  get hidden() {
    return this._hidden;
  }
  set hidden(e) {
    this._hidden = e;
  }
  get saneDescription() {
    return this._saneDescription;
  }
  set saneDescription(e) {
    this._saneDescription = e;
  }
  get saneDetail() {
    return this._saneDetail;
  }
  set saneDetail(e) {
    this._saneDetail = e;
  }
  get saneTooltip() {
    return this._saneTooltip;
  }
  set saneTooltip(e) {
    this._saneTooltip = e;
  }
  get labelHighlights() {
    return this._labelHighlights;
  }
  set labelHighlights(e) {
    this._labelHighlights = e;
  }
  get descriptionHighlights() {
    return this._descriptionHighlights;
  }
  set descriptionHighlights(e) {
    this._descriptionHighlights = e;
  }
  get detailHighlights() {
    return this._detailHighlights;
  }
  set detailHighlights(e) {
    this._detailHighlights = e;
  }
}
class cr extends fTe {
  constructor(e, t, n, i, s, o) {
    super(e, t, s), this.fireButtonTriggered = n, this._onChecked = i, this.item = s, this._separator = o, this._checked = !1, this.onChecked = t ? xe.map(xe.filter(this._onChecked.event, (a) => a.element === this), (a) => a.checked) : xe.None, this._saneDetail = s.detail, this._labelHighlights = s.highlights?.label, this._descriptionHighlights = s.highlights?.description, this._detailHighlights = s.highlights?.detail;
  }
  get separator() {
    return this._separator;
  }
  set separator(e) {
    this._separator = e;
  }
  get checked() {
    return this._checked;
  }
  set checked(e) {
    e !== this._checked && (this._checked = e, this._onChecked.fire({ element: this, checked: e }));
  }
  get checkboxDisabled() {
    return !!this.item.disabled;
  }
}
var Wc;
(function(r) {
  r[r.NONE = 0] = "NONE", r[r.MOUSE_HOVER = 1] = "MOUSE_HOVER", r[r.ACTIVE_ITEM = 2] = "ACTIVE_ITEM";
})(Wc || (Wc = {}));
class l0 extends fTe {
  constructor(e, t, n) {
    super(e, !1, n), this.fireSeparatorButtonTriggered = t, this.separator = n, this.children = new Array(), this.focusInsideSeparator = Wc.NONE;
  }
}
class XCt {
  getHeight(e) {
    return e instanceof l0 ? 30 : e.saneDetail ? 44 : 22;
  }
  getTemplateId(e) {
    return e instanceof cr ? J9.ID : Py.ID;
  }
}
class JCt {
  getWidgetAriaLabel() {
    return C("quickInput", "Quick Input");
  }
  getAriaLabel(e) {
    return e.separator?.label ? `${e.saneAriaLabel}, ${e.separator.label}` : e.saneAriaLabel;
  }
  getWidgetRole() {
    return "listbox";
  }
  getRole(e) {
    return e.hasCheckbox ? "checkbox" : "option";
  }
  isChecked(e) {
    if (!(!e.hasCheckbox || !(e instanceof cr)))
      return {
        get value() {
          return e.checked;
        },
        onDidChange: (t) => e.onChecked(() => t())
      };
  }
}
class pTe {
  constructor(e) {
    this.hoverDelegate = e;
  }
  // TODO: only do the common stuff here and have a subclass handle their specific stuff
  renderTemplate(e) {
    const t = /* @__PURE__ */ Object.create(null);
    t.toDisposeElement = new ze(), t.toDisposeTemplate = new ze(), t.entry = Fe(e, Nl(".quick-input-list-entry"));
    const n = Fe(t.entry, Nl("label.quick-input-list-label"));
    t.toDisposeTemplate.add(ir(n, Se.CLICK, (c) => {
      t.checkbox.offsetParent || c.preventDefault();
    })), t.checkbox = Fe(n, Nl("input.quick-input-list-checkbox")), t.checkbox.type = "checkbox";
    const i = Fe(n, Nl(".quick-input-list-rows")), s = Fe(i, Nl(".quick-input-list-row")), o = Fe(i, Nl(".quick-input-list-row"));
    t.label = new O9e(s, { supportHighlights: !0, supportDescriptionHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.label), t.icon = KI(t.label.element, Nl(".quick-input-list-icon"));
    const a = Fe(s, Nl(".quick-input-list-entry-keybinding"));
    t.keybinding = new jR(a, nl), t.toDisposeTemplate.add(t.keybinding);
    const l = Fe(o, Nl(".quick-input-list-label-meta"));
    return t.detail = new O9e(l, { supportHighlights: !0, supportIcons: !0, hoverDelegate: this.hoverDelegate }), t.toDisposeTemplate.add(t.detail), t.separator = Fe(t.entry, Nl(".quick-input-list-separator")), t.actionBar = new Md(t.entry, this.hoverDelegate ? { hoverDelegate: this.hoverDelegate } : void 0), t.actionBar.domNode.classList.add("quick-input-list-entry-action-bar"), t.toDisposeTemplate.add(t.actionBar), t;
  }
  disposeTemplate(e) {
    e.toDisposeElement.dispose(), e.toDisposeTemplate.dispose();
  }
  disposeElement(e, t, n) {
    n.toDisposeElement.clear(), n.actionBar.clear();
  }
}
let J9 = class extends pTe {
  static {
    kk = this;
  }
  static {
    this.ID = "quickpickitem";
  }
  constructor(e, t) {
    super(e), this.themeService = t, this._itemsWithSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  get templateId() {
    return kk.ID;
  }
  renderTemplate(e) {
    const t = super.renderTemplate(e);
    return t.toDisposeTemplate.add(ir(t.checkbox, Se.CHANGE, (n) => {
      t.element.checked = t.checkbox.checked;
    })), t;
  }
  renderElement(e, t, n) {
    const i = e.element;
    n.element = i, i.element = n.entry ?? void 0;
    const s = i.item;
    n.checkbox.checked = i.checked, n.toDisposeElement.add(i.onChecked((f) => n.checkbox.checked = f)), n.checkbox.disabled = i.checkboxDisabled;
    const { labelHighlights: o, descriptionHighlights: a, detailHighlights: l } = i;
    if (s.iconPath) {
      const f = dy(this.themeService.getColorTheme().type) ? s.iconPath.dark : s.iconPath.light ?? s.iconPath.dark, p = Pt.revive(f);
      n.icon.className = "quick-input-list-icon", n.icon.style.backgroundImage = Pd(p);
    } else
      n.icon.style.backgroundImage = "", n.icon.className = s.iconClass ? `quick-input-list-icon ${s.iconClass}` : "";
    let c;
    !i.saneTooltip && i.saneDescription && (c = {
      markdown: {
        value: i.saneDescription,
        supportThemeIcons: !0
      },
      markdownNotSupportedFallback: i.saneDescription
    });
    const d = {
      matches: o || [],
      // If we have a tooltip, we want that to be shown and not any other hover
      descriptionTitle: c,
      descriptionMatches: a || [],
      labelEscapeNewLines: !0
    };
    if (d.extraClasses = s.iconClasses, d.italic = s.italic, d.strikethrough = s.strikethrough, n.entry.classList.remove("quick-input-list-separator-as-item"), n.label.setLabel(i.saneLabel, i.saneDescription, d), n.keybinding.set(s.keybinding), i.saneDetail) {
      let f;
      i.saneTooltip || (f = {
        markdown: {
          value: i.saneDetail,
          supportThemeIcons: !0
        },
        markdownNotSupportedFallback: i.saneDetail
      }), n.detail.element.style.display = "", n.detail.setLabel(i.saneDetail, void 0, {
        matches: l,
        title: f,
        labelEscapeNewLines: !0
      });
    } else
      n.detail.element.style.display = "none";
    i.separator?.label ? (n.separator.textContent = i.separator.label, n.separator.style.display = "", this.addItemWithSeparator(i)) : n.separator.style.display = "none", n.entry.classList.toggle("quick-input-list-separator-border", !!i.separator);
    const u = s.buttons;
    u && u.length ? (n.actionBar.push(u.map((f, p) => a3(f, `id-${p}`, () => i.fireButtonTriggered({ button: f, item: i.item }))), { icon: !0, label: !1 }), n.entry.classList.add("has-actions")) : n.entry.classList.remove("has-actions");
  }
  disposeElement(e, t, n) {
    this.removeItemWithSeparator(e.element), super.disposeElement(e, t, n);
  }
  isItemWithSeparatorVisible(e) {
    return this._itemsWithSeparatorsFrequency.has(e);
  }
  addItemWithSeparator(e) {
    this._itemsWithSeparatorsFrequency.set(e, (this._itemsWithSeparatorsFrequency.get(e) || 0) + 1);
  }
  removeItemWithSeparator(e) {
    const t = this._itemsWithSeparatorsFrequency.get(e) || 0;
    t > 1 ? this._itemsWithSeparatorsFrequency.set(e, t - 1) : this._itemsWithSeparatorsFrequency.delete(e);
  }
};
J9 = kk = By([
  Lk(1, Sa)
], J9);
class Py extends pTe {
  constructor() {
    super(...arguments), this._visibleSeparatorsFrequency = /* @__PURE__ */ new Map();
  }
  static {
    this.ID = "quickpickseparator";
  }
  get templateId() {
    return Py.ID;
  }
  get visibleSeparators() {
    return [...this._visibleSeparatorsFrequency.keys()];
  }
  isSeparatorVisible(e) {
    return this._visibleSeparatorsFrequency.has(e);
  }
  renderElement(e, t, n) {
    const i = e.element;
    n.element = i, i.element = n.entry ?? void 0, i.element.classList.toggle("focus-inside", !!i.focusInsideSeparator);
    const s = i.separator, { labelHighlights: o, descriptionHighlights: a, detailHighlights: l } = i;
    n.icon.style.backgroundImage = "", n.icon.className = "";
    let c;
    !i.saneTooltip && i.saneDescription && (c = {
      markdown: {
        value: i.saneDescription,
        supportThemeIcons: !0
      },
      markdownNotSupportedFallback: i.saneDescription
    });
    const d = {
      matches: o || [],
      // If we have a tooltip, we want that to be shown and not any other hover
      descriptionTitle: c,
      descriptionMatches: a || [],
      labelEscapeNewLines: !0
    };
    if (n.entry.classList.add("quick-input-list-separator-as-item"), n.label.setLabel(i.saneLabel, i.saneDescription, d), i.saneDetail) {
      let f;
      i.saneTooltip || (f = {
        markdown: {
          value: i.saneDetail,
          supportThemeIcons: !0
        },
        markdownNotSupportedFallback: i.saneDetail
      }), n.detail.element.style.display = "", n.detail.setLabel(i.saneDetail, void 0, {
        matches: l,
        title: f,
        labelEscapeNewLines: !0
      });
    } else
      n.detail.element.style.display = "none";
    n.separator.style.display = "none", n.entry.classList.add("quick-input-list-separator-border");
    const u = s.buttons;
    u && u.length ? (n.actionBar.push(u.map((f, p) => a3(f, `id-${p}`, () => i.fireSeparatorButtonTriggered({ button: f, separator: i.separator }))), { icon: !0, label: !1 }), n.entry.classList.add("has-actions")) : n.entry.classList.remove("has-actions"), this.addSeparator(i);
  }
  disposeElement(e, t, n) {
    this.removeSeparator(e.element), this.isSeparatorVisible(e.element) || e.element.element?.classList.remove("focus-inside"), super.disposeElement(e, t, n);
  }
  addSeparator(e) {
    this._visibleSeparatorsFrequency.set(e, (this._visibleSeparatorsFrequency.get(e) || 0) + 1);
  }
  removeSeparator(e) {
    const t = this._visibleSeparatorsFrequency.get(e) || 0;
    t > 1 ? this._visibleSeparatorsFrequency.set(e, t - 1) : this._visibleSeparatorsFrequency.delete(e);
  }
}
let f4 = class extends me {
  constructor(e, t, n, i, s, o) {
    super(), this.parent = e, this.hoverDelegate = t, this.linkOpenerDelegate = n, this.accessibilityService = o, this._onKeyDown = new $(), this._onLeave = new $(), this.onLeave = this._onLeave.event, this._visibleCountObservable = qt("VisibleCount", 0), this.onChangedVisibleCount = xe.fromObservable(this._visibleCountObservable, this._store), this._allVisibleCheckedObservable = qt("AllVisibleChecked", !1), this.onChangedAllVisibleChecked = xe.fromObservable(this._allVisibleCheckedObservable, this._store), this._checkedCountObservable = qt("CheckedCount", 0), this.onChangedCheckedCount = xe.fromObservable(this._checkedCountObservable, this._store), this._checkedElementsObservable = ok({ equalsFn: Zi }, new Array()), this.onChangedCheckedElements = xe.fromObservable(this._checkedElementsObservable, this._store), this._onButtonTriggered = new $(), this.onButtonTriggered = this._onButtonTriggered.event, this._onSeparatorButtonTriggered = new $(), this.onSeparatorButtonTriggered = this._onSeparatorButtonTriggered.event, this._elementChecked = new $(), this._elementCheckedEventBufferer = new Aw(), this._hasCheckboxes = !1, this._inputElements = new Array(), this._elementTree = new Array(), this._itemElements = new Array(), this._elementDisposable = this._register(new ze()), this._matchOnDescription = !1, this._matchOnDetail = !1, this._matchOnLabel = !0, this._matchOnLabelMode = "fuzzy", this._sortByLabel = !0, this._shouldLoop = !0, this._container = Fe(this.parent, Nl(".quick-input-list")), this._separatorRenderer = new Py(t), this._itemRenderer = s.createInstance(J9, t), this._tree = this._register(s.createInstance(Dk, "QuickInput", this._container, new XCt(), [this._itemRenderer, this._separatorRenderer], {
      accessibilityProvider: new JCt(),
      setRowLineHeight: !1,
      multipleSelectionSupport: !1,
      hideTwistiesOfChildlessElements: !0,
      renderIndentGuides: yg.None,
      findWidgetEnabled: !1,
      indent: 0,
      horizontalScrolling: !1,
      allowNonCollapsibleParents: !0,
      alwaysConsumeMouseWheel: !0
    })), this._tree.getHTMLElement().id = i, this._registerListeners();
  }
  //#region public getters/setters
  get onDidChangeFocus() {
    return xe.map(this._tree.onDidChangeFocus, (e) => e.elements.filter((t) => t instanceof cr).map((t) => t.item), this._store);
  }
  get onDidChangeSelection() {
    return xe.map(this._tree.onDidChangeSelection, (e) => ({
      items: e.elements.filter((t) => t instanceof cr).map((t) => t.item),
      event: e.browserEvent
    }), this._store);
  }
  get displayed() {
    return this._container.style.display !== "none";
  }
  set displayed(e) {
    this._container.style.display = e ? "" : "none";
  }
  get scrollTop() {
    return this._tree.scrollTop;
  }
  set scrollTop(e) {
    this._tree.scrollTop = e;
  }
  get ariaLabel() {
    return this._tree.ariaLabel;
  }
  set ariaLabel(e) {
    this._tree.ariaLabel = e ?? "";
  }
  set enabled(e) {
    this._tree.getHTMLElement().style.pointerEvents = e ? "" : "none";
  }
  get matchOnDescription() {
    return this._matchOnDescription;
  }
  set matchOnDescription(e) {
    this._matchOnDescription = e;
  }
  get matchOnDetail() {
    return this._matchOnDetail;
  }
  set matchOnDetail(e) {
    this._matchOnDetail = e;
  }
  get matchOnLabel() {
    return this._matchOnLabel;
  }
  set matchOnLabel(e) {
    this._matchOnLabel = e;
  }
  get matchOnLabelMode() {
    return this._matchOnLabelMode;
  }
  set matchOnLabelMode(e) {
    this._matchOnLabelMode = e;
  }
  get sortByLabel() {
    return this._sortByLabel;
  }
  set sortByLabel(e) {
    this._sortByLabel = e;
  }
  get shouldLoop() {
    return this._shouldLoop;
  }
  set shouldLoop(e) {
    this._shouldLoop = e;
  }
  //#endregion
  //#region register listeners
  _registerListeners() {
    this._registerOnKeyDown(), this._registerOnContainerClick(), this._registerOnMouseMiddleClick(), this._registerOnTreeModelChanged(), this._registerOnElementChecked(), this._registerOnContextMenu(), this._registerHoverListeners(), this._registerSelectionChangeListener(), this._registerSeparatorActionShowingListeners();
  }
  _registerOnKeyDown() {
    this._register(this._tree.onKeyDown((e) => {
      const t = new zn(e);
      switch (t.keyCode) {
        case 10:
          this.toggleCheckbox();
          break;
      }
      this._onKeyDown.fire(t);
    }));
  }
  _registerOnContainerClick() {
    this._register(fe(this._container, Se.CLICK, (e) => {
      (e.x || e.y) && this._onLeave.fire();
    }));
  }
  _registerOnMouseMiddleClick() {
    this._register(fe(this._container, Se.AUXCLICK, (e) => {
      e.button === 1 && this._onLeave.fire();
    }));
  }
  _registerOnTreeModelChanged() {
    this._register(this._tree.onDidChangeModel(() => {
      const e = this._itemElements.filter((t) => !t.hidden).length;
      this._visibleCountObservable.set(e, void 0), this._hasCheckboxes && this._updateCheckedObservables();
    }));
  }
  _registerOnElementChecked() {
    this._register(this._elementCheckedEventBufferer.wrapEvent(this._elementChecked.event, (e, t) => t)((e) => this._updateCheckedObservables()));
  }
  _registerOnContextMenu() {
    this._register(this._tree.onContextMenu((e) => {
      e.element && (e.browserEvent.preventDefault(), this._tree.setSelection([e.element]));
    }));
  }
  _registerHoverListeners() {
    const e = this._register(new uDe(this.hoverDelegate.delay));
    this._register(this._tree.onMouseOver(async (t) => {
      if (Qve(t.browserEvent.target)) {
        e.cancel();
        return;
      }
      if (
        // anchors are an exception as called out above so we skip them here
        !(!Qve(t.browserEvent.relatedTarget) && // check if the mouse is still over the same element
        Ji(t.browserEvent.relatedTarget, t.element?.element))
      )
        try {
          await e.trigger(async () => {
            t.element instanceof cr && this.showHover(t.element);
          });
        } catch (n) {
          if (!gw(n))
            throw n;
        }
    })), this._register(this._tree.onMouseOut((t) => {
      Ji(t.browserEvent.relatedTarget, t.element?.element) || e.cancel();
    }));
  }
  /**
   * Register's focus change and mouse events so that we can track when items inside of a
   * separator's section are focused or hovered so that we can display the separator's actions
   */
  _registerSeparatorActionShowingListeners() {
    this._register(this._tree.onDidChangeFocus((e) => {
      const t = e.elements[0] ? this._tree.getParentElement(e.elements[0]) : null;
      for (const n of this._separatorRenderer.visibleSeparators) {
        const i = n === t;
        !!(n.focusInsideSeparator & Wc.ACTIVE_ITEM) !== i && (i ? n.focusInsideSeparator |= Wc.ACTIVE_ITEM : n.focusInsideSeparator &= ~Wc.ACTIVE_ITEM, this._tree.rerender(n));
      }
    })), this._register(this._tree.onMouseOver((e) => {
      const t = e.element ? this._tree.getParentElement(e.element) : null;
      for (const n of this._separatorRenderer.visibleSeparators) {
        if (n !== t)
          continue;
        !!(n.focusInsideSeparator & Wc.MOUSE_HOVER) || (n.focusInsideSeparator |= Wc.MOUSE_HOVER, this._tree.rerender(n));
      }
    })), this._register(this._tree.onMouseOut((e) => {
      const t = e.element ? this._tree.getParentElement(e.element) : null;
      for (const n of this._separatorRenderer.visibleSeparators) {
        if (n !== t)
          continue;
        !!(n.focusInsideSeparator & Wc.MOUSE_HOVER) && (n.focusInsideSeparator &= ~Wc.MOUSE_HOVER, this._tree.rerender(n));
      }
    }));
  }
  _registerSelectionChangeListener() {
    this._register(this._tree.onDidChangeSelection((e) => {
      const t = e.elements.filter((n) => n instanceof cr);
      t.length !== e.elements.length && (e.elements.length === 1 && e.elements[0] instanceof l0 && (this._tree.setFocus([e.elements[0].children[0]]), this._tree.reveal(e.elements[0], 0)), this._tree.setSelection(t));
    }));
  }
  //#endregion
  //#region public methods
  setAllVisibleChecked(e) {
    this._elementCheckedEventBufferer.bufferEvents(() => {
      this._itemElements.forEach((t) => {
        !t.hidden && !t.checkboxDisabled && (t.checked = e);
      });
    });
  }
  setElements(e) {
    this._elementDisposable.clear(), this._inputElements = e, this._hasCheckboxes = this.parent.classList.contains("show-checkboxes");
    let t;
    this._itemElements = new Array(), this._elementTree = e.reduce((n, i, s) => {
      let o;
      if (i.type === "separator") {
        if (!i.buttons)
          return n;
        t = new l0(s, (a) => this._onSeparatorButtonTriggered.fire(a), i), o = t;
      } else {
        const a = s > 0 ? e[s - 1] : void 0;
        let l;
        a && a.type === "separator" && !a.buttons && (t = void 0, l = a);
        const c = new cr(s, this._hasCheckboxes, (d) => this._onButtonTriggered.fire(d), this._elementChecked, i, l);
        if (this._itemElements.push(c), t)
          return t.children.push(c), n;
        o = c;
      }
      return n.push(o), n;
    }, new Array()), this._setElementsToTree(this._elementTree), this.accessibilityService.isScreenReaderOptimized() && setTimeout(() => {
      const n = this._tree.getHTMLElement().querySelector(".monaco-list-row.focused"), i = n?.parentNode;
      if (n && i) {
        const s = n.nextSibling;
        n.remove(), i.insertBefore(n, s);
      }
    }, 0);
  }
  setFocusedElements(e) {
    const t = e.map((n) => this._itemElements.find((i) => i.item === n)).filter((n) => !!n).filter((n) => !n.hidden);
    if (this._tree.setFocus(t), e.length > 0) {
      const n = this._tree.getFocus()[0];
      n && this._tree.reveal(n);
    }
  }
  getActiveDescendant() {
    return this._tree.getHTMLElement().getAttribute("aria-activedescendant");
  }
  setSelectedElements(e) {
    const t = e.map((n) => this._itemElements.find((i) => i.item === n)).filter((n) => !!n);
    this._tree.setSelection(t);
  }
  getCheckedElements() {
    return this._itemElements.filter((e) => e.checked).map((e) => e.item);
  }
  setCheckedElements(e) {
    this._elementCheckedEventBufferer.bufferEvents(() => {
      const t = /* @__PURE__ */ new Set();
      for (const n of e)
        t.add(n);
      for (const n of this._itemElements)
        n.checked = t.has(n.item);
    });
  }
  focus(e) {
    if (this._itemElements.length)
      switch (e === Ln.Second && this._itemElements.length < 2 && (e = Ln.First), e) {
        case Ln.First:
          this._tree.scrollTop = 0, this._tree.focusFirst(void 0, (t) => t.element instanceof cr);
          break;
        case Ln.Second: {
          this._tree.scrollTop = 0;
          let t = !1;
          this._tree.focusFirst(void 0, (n) => n.element instanceof cr ? t ? !0 : (t = !t, !1) : !1);
          break;
        }
        case Ln.Last:
          this._tree.scrollTop = this._tree.scrollHeight, this._tree.focusLast(void 0, (t) => t.element instanceof cr);
          break;
        case Ln.Next: {
          const t = this._tree.getFocus();
          this._tree.focusNext(void 0, this._shouldLoop, void 0, (i) => i.element instanceof cr ? (this._tree.reveal(i.element), !0) : !1);
          const n = this._tree.getFocus();
          t.length && t[0] === n[0] && t[0] === this._itemElements[this._itemElements.length - 1] && this._onLeave.fire();
          break;
        }
        case Ln.Previous: {
          const t = this._tree.getFocus();
          this._tree.focusPrevious(void 0, this._shouldLoop, void 0, (i) => {
            if (!(i.element instanceof cr))
              return !1;
            const s = this._tree.getParentElement(i.element);
            return s === null || s.children[0] !== i.element ? this._tree.reveal(i.element) : this._tree.reveal(s), !0;
          });
          const n = this._tree.getFocus();
          t.length && t[0] === n[0] && t[0] === this._itemElements[0] && this._onLeave.fire();
          break;
        }
        case Ln.NextPage:
          this._tree.focusNextPage(void 0, (t) => t.element instanceof cr ? (this._tree.reveal(t.element), !0) : !1);
          break;
        case Ln.PreviousPage:
          this._tree.focusPreviousPage(void 0, (t) => {
            if (!(t.element instanceof cr))
              return !1;
            const n = this._tree.getParentElement(t.element);
            return n === null || n.children[0] !== t.element ? this._tree.reveal(t.element) : this._tree.reveal(n), !0;
          });
          break;
        case Ln.NextSeparator: {
          let t = !1;
          const n = this._tree.getFocus()[0];
          this._tree.focusNext(void 0, !0, void 0, (s) => {
            if (t)
              return !0;
            if (s.element instanceof l0)
              t = !0, this._separatorRenderer.isSeparatorVisible(s.element) ? this._tree.reveal(s.element.children[0]) : this._tree.reveal(s.element, 0);
            else if (s.element instanceof cr) {
              if (s.element.separator)
                return this._itemRenderer.isItemWithSeparatorVisible(s.element) ? this._tree.reveal(s.element) : this._tree.reveal(s.element, 0), !0;
              if (s.element === this._elementTree[0])
                return this._tree.reveal(s.element, 0), !0;
            }
            return !1;
          });
          const i = this._tree.getFocus()[0];
          n === i && (this._tree.scrollTop = this._tree.scrollHeight, this._tree.focusLast(void 0, (s) => s.element instanceof cr));
          break;
        }
        case Ln.PreviousSeparator: {
          let t, n = !!this._tree.getFocus()[0]?.separator;
          this._tree.focusPrevious(void 0, !0, void 0, (i) => {
            if (i.element instanceof l0)
              n ? t || (this._separatorRenderer.isSeparatorVisible(i.element) ? this._tree.reveal(i.element) : this._tree.reveal(i.element, 0), t = i.element.children[0]) : n = !0;
            else if (i.element instanceof cr && !t) {
              if (i.element.separator)
                this._itemRenderer.isItemWithSeparatorVisible(i.element) ? this._tree.reveal(i.element) : this._tree.reveal(i.element, 0), t = i.element;
              else if (i.element === this._elementTree[0])
                return this._tree.reveal(i.element, 0), !0;
            }
            return !1;
          }), t && this._tree.setFocus([t]);
          break;
        }
      }
  }
  clearFocus() {
    this._tree.setFocus([]);
  }
  domFocus() {
    this._tree.domFocus();
  }
  layout(e) {
    this._tree.getHTMLElement().style.maxHeight = e ? `${// Make sure height aligns with list item heights
    Math.floor(e / 44) * 44 + 6}px` : "", this._tree.layout();
  }
  filter(e) {
    if (!(this._sortByLabel || this._matchOnLabel || this._matchOnDescription || this._matchOnDetail))
      return this._tree.layout(), !1;
    const t = e;
    if (e = e.trim(), !e || !(this.matchOnLabel || this.matchOnDescription || this.matchOnDetail))
      this._itemElements.forEach((o) => {
        o.labelHighlights = void 0, o.descriptionHighlights = void 0, o.detailHighlights = void 0, o.hidden = !1;
        const a = o.index && this._inputElements[o.index - 1];
        o.item && (o.separator = a && a.type === "separator" && !a.buttons ? a : void 0);
      });
    else {
      let o;
      this._elementTree.forEach((a) => {
        let l;
        this.matchOnLabelMode === "fuzzy" ? l = this.matchOnLabel ? g_(e, bA(a.saneLabel)) ?? void 0 : void 0 : l = this.matchOnLabel ? $Ct(t, bA(a.saneLabel)) ?? void 0 : void 0;
        const c = this.matchOnDescription ? g_(e, bA(a.saneDescription || "")) ?? void 0 : void 0, d = this.matchOnDetail ? g_(e, bA(a.saneDetail || "")) ?? void 0 : void 0;
        if (l || c || d ? (a.labelHighlights = l, a.descriptionHighlights = c, a.detailHighlights = d, a.hidden = !1) : (a.labelHighlights = void 0, a.descriptionHighlights = void 0, a.detailHighlights = void 0, a.hidden = a.item ? !a.item.alwaysShow : !0), a.item ? a.separator = void 0 : a.separator && (a.hidden = !0), !this.sortByLabel) {
          const u = a.index && this._inputElements[a.index - 1];
          o = u && u.type === "separator" ? u : o, o && !a.hidden && (a.separator = o, o = void 0);
        }
      });
    }
    const n = this._elementTree.filter((o) => !o.hidden);
    if (this.sortByLabel && e) {
      const o = e.toLowerCase();
      n.sort((a, l) => eEt(a, l, o));
    }
    let i;
    const s = n.reduce((o, a, l) => (a instanceof cr ? i ? i.children.push(a) : o.push(a) : a instanceof l0 && (a.children = [], i = a, o.push(a)), o), new Array());
    return this._setElementsToTree(s), this._tree.layout(), !0;
  }
  toggleCheckbox() {
    this._elementCheckedEventBufferer.bufferEvents(() => {
      const e = this._tree.getFocus().filter((n) => n instanceof cr), t = this._allVisibleChecked(e);
      for (const n of e)
        n.checkboxDisabled || (n.checked = !t);
    });
  }
  style(e) {
    this._tree.style(e);
  }
  toggleHover() {
    const e = this._tree.getFocus()[0];
    if (!e?.saneTooltip || !(e instanceof cr))
      return;
    if (this._lastHover && !this._lastHover.isDisposed) {
      this._lastHover.dispose();
      return;
    }
    this.showHover(e);
    const t = new ze();
    t.add(this._tree.onDidChangeFocus((n) => {
      n.elements[0] instanceof cr && this.showHover(n.elements[0]);
    })), this._lastHover && t.add(this._lastHover), this._elementDisposable.add(t);
  }
  //#endregion
  //#region private methods
  _setElementsToTree(e) {
    const t = new Array();
    for (const n of e)
      n instanceof l0 ? t.push({
        element: n,
        collapsible: !1,
        collapsed: !1,
        children: n.children.map((i) => ({
          element: i,
          collapsible: !1,
          collapsed: !1
        }))
      }) : t.push({
        element: n,
        collapsible: !1,
        collapsed: !1
      });
    this._tree.setChildren(null, t);
  }
  _allVisibleChecked(e, t = !0) {
    for (let n = 0, i = e.length; n < i; n++) {
      const s = e[n];
      if (!s.hidden)
        if (s.checked)
          t = !0;
        else
          return !1;
    }
    return t;
  }
  _updateCheckedObservables() {
    this._allVisibleCheckedObservable.set(this._allVisibleChecked(this._itemElements, !1), void 0);
    const e = this._itemElements.filter((t) => t.checked).length;
    this._checkedCountObservable.set(e, void 0), this._checkedElementsObservable.set(this.getCheckedElements(), void 0);
  }
  /**
   * Disposes of the hover and shows a new one for the given index if it has a tooltip.
   * @param element The element to show the hover for
   */
  showHover(e) {
    this._lastHover && !this._lastHover.isDisposed && (this.hoverDelegate.onDidHideHover?.(), this._lastHover?.dispose()), !(!e.element || !e.saneTooltip) && (this._lastHover = this.hoverDelegate.showHover({
      content: e.saneTooltip,
      target: e.element,
      linkHandler: (t) => {
        this.linkOpenerDelegate(t);
      },
      appearance: {
        showPointer: !0
      },
      container: this._container,
      position: {
        hoverPosition: 1
        /* HoverPosition.RIGHT */
      }
    }, !1));
  }
};
By([
  wi
], f4.prototype, "onDidChangeFocus", null);
By([
  wi
], f4.prototype, "onDidChangeSelection", null);
f4 = By([
  Lk(4, xn),
  Lk(5, pc)
], f4);
function $Ct(r, e) {
  const { text: t, iconOffsets: n } = e;
  if (!n || n.length === 0)
    return V9e(r, t);
  const i = R7(t, " "), s = t.length - i.length, o = V9e(r, i);
  if (o)
    for (const a of o) {
      const l = n[a.start + s] + s;
      a.start += l, a.end += l;
    }
  return o;
}
function V9e(r, e) {
  const t = e.toLowerCase().indexOf(r.toLowerCase());
  return t !== -1 ? [{ start: t, end: t + r.length }] : null;
}
function eEt(r, e, t) {
  const n = r.labelHighlights || [], i = e.labelHighlights || [];
  return n.length && !i.length ? -1 : !n.length && i.length ? 1 : n.length === 0 && i.length === 0 ? 0 : KCt(r.saneSortLabel, e.saneSortLabel, t);
}
const gTe = {
  weight: 200,
  when: mt.and(mt.equals(
    jNe,
    "quickPick"
    /* QuickInputType.QuickPick */
  ), Eyt),
  metadata: { description: C("quickPick", "Used while in the context of the quick pick. If you change one keybinding for this command, you should change all of the other keybindings (modifier variants) of this command as well.") }
};
function Js(r, e = {}) {
  Kf.registerCommandAndKeybindingRule({
    ...gTe,
    ...r,
    secondary: tEt(r.primary, r.secondary ?? [], e)
  });
}
const $9 = zt ? 256 : 2048;
function tEt(r, e, t = {}) {
  return t.withAltMod && e.push(512 + r), t.withCtrlMod && (e.push($9 + r), t.withAltMod && e.push(512 + $9 + r)), t.withCmdMod && zt && (e.push(2048 + r), t.withCtrlMod && e.push(2304 + r), t.withAltMod && (e.push(2560 + r), t.withCtrlMod && e.push(2816 + r))), e;
}
function Co(r, e) {
  return (t) => {
    const n = t.get(Bw).currentQuickInput;
    if (n)
      return e && n.quickNavigate ? n.focus(e) : n.focus(r);
  };
}
Js({ id: "quickInput.pageNext", primary: 12, handler: Co(Ln.NextPage) }, { withAltMod: !0, withCtrlMod: !0, withCmdMod: !0 });
Js({ id: "quickInput.pagePrevious", primary: 11, handler: Co(Ln.PreviousPage) }, { withAltMod: !0, withCtrlMod: !0, withCmdMod: !0 });
Js({ id: "quickInput.first", primary: $9 + 14, handler: Co(Ln.First) }, { withAltMod: !0, withCmdMod: !0 });
Js({ id: "quickInput.last", primary: $9 + 13, handler: Co(Ln.Last) }, { withAltMod: !0, withCmdMod: !0 });
Js({ id: "quickInput.next", primary: 18, handler: Co(Ln.Next) }, { withCtrlMod: !0 });
Js({ id: "quickInput.previous", primary: 16, handler: Co(Ln.Previous) }, { withCtrlMod: !0 });
const H9e = C("quickInput.nextSeparatorWithQuickAccessFallback", "If we're in quick access mode, this will navigate to the next item. If we are not in quick access mode, this will navigate to the next separator."), B9e = C("quickInput.previousSeparatorWithQuickAccessFallback", "If we're in quick access mode, this will navigate to the previous item. If we are not in quick access mode, this will navigate to the previous separator.");
zt ? (Js({
  id: "quickInput.nextSeparatorWithQuickAccessFallback",
  primary: 2066,
  handler: Co(Ln.NextSeparator, Ln.Next),
  metadata: { description: H9e }
}), Js({
  id: "quickInput.nextSeparator",
  primary: 2578,
  // Since macOS has the cmd key as the primary modifier, we need to add this additional
  // keybinding to capture cmd+ctrl+upArrow
  secondary: [
    2322
    /* KeyCode.DownArrow */
  ],
  handler: Co(Ln.NextSeparator)
}, { withCtrlMod: !0 }), Js({
  id: "quickInput.previousSeparatorWithQuickAccessFallback",
  primary: 2064,
  handler: Co(Ln.PreviousSeparator, Ln.Previous),
  metadata: { description: B9e }
}), Js({
  id: "quickInput.previousSeparator",
  primary: 2576,
  // Since macOS has the cmd key as the primary modifier, we need to add this additional
  // keybinding to capture cmd+ctrl+upArrow
  secondary: [
    2320
    /* KeyCode.UpArrow */
  ],
  handler: Co(Ln.PreviousSeparator)
}, { withCtrlMod: !0 })) : (Js({
  id: "quickInput.nextSeparatorWithQuickAccessFallback",
  primary: 530,
  handler: Co(Ln.NextSeparator, Ln.Next),
  metadata: { description: H9e }
}), Js({
  id: "quickInput.nextSeparator",
  primary: 2578,
  handler: Co(Ln.NextSeparator)
}), Js({
  id: "quickInput.previousSeparatorWithQuickAccessFallback",
  primary: 528,
  handler: Co(Ln.PreviousSeparator, Ln.Previous),
  metadata: { description: B9e }
}), Js({
  id: "quickInput.previousSeparator",
  primary: 2576,
  handler: Co(Ln.PreviousSeparator)
}));
Js({
  id: "quickInput.acceptInBackground",
  // If we are in the quick pick but the input box is not focused or our cursor is at the end of the input box
  when: mt.and(gTe.when, mt.or(TCt.negate(), Syt)),
  primary: 17,
  // Need a little extra weight to ensure this keybinding is preferred over the default cmd+alt+right arrow keybinding
  // https://github.com/microsoft/vscode/blob/1451e4fbbbf074a4355cc537c35b547b80ce1c52/src/vs/workbench/browser/parts/editor/editorActions.ts#L1178-L1195
  weight: 250,
  handler: (r) => {
    r.get(Bw).currentQuickInput?.accept(!0);
  }
}, { withAltMod: !0, withCtrlMod: !0, withCmdMod: !0 });
var nEt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, k_ = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, Nk;
const Ks = $e;
let Tk = class extends me {
  static {
    Nk = this;
  }
  static {
    this.MAX_WIDTH = 600;
  }
  // Max total width of quick input widget
  get currentQuickInput() {
    return this.controller ?? void 0;
  }
  get container() {
    return this._container;
  }
  constructor(e, t, n, i) {
    super(), this.options = e, this.layoutService = t, this.instantiationService = n, this.contextKeyService = i, this.enabled = !0, this.onDidAcceptEmitter = this._register(new $()), this.onDidCustomEmitter = this._register(new $()), this.onDidTriggerButtonEmitter = this._register(new $()), this.keyMods = { ctrlCmd: !1, alt: !1 }, this.controller = null, this.onShowEmitter = this._register(new $()), this.onShow = this.onShowEmitter.event, this.onHideEmitter = this._register(new $()), this.onHide = this.onHideEmitter.event, this.inQuickInputContext = Cyt.bindTo(this.contextKeyService), this.quickInputTypeContext = _yt.bindTo(this.contextKeyService), this.endOfQuickInputBoxContext = xyt.bindTo(this.contextKeyService), this.idPrefix = e.idPrefix, this._container = e.container, this.styles = e.styles, this._register(xe.runAndSubscribe(B7, ({ window: s, disposables: o }) => this.registerKeyModsListeners(s, o), { window: Sn, disposables: this._store })), this._register(xft((s) => {
      this.ui && qe(this.ui.container) === s && (this.reparentUI(this.layoutService.mainContainer), this.layout(this.layoutService.mainContainerDimension, this.layoutService.mainContainerOffset.quickPickTop));
    }));
  }
  registerKeyModsListeners(e, t) {
    const n = (i) => {
      this.keyMods.ctrlCmd = i.ctrlKey || i.metaKey, this.keyMods.alt = i.altKey;
    };
    for (const i of [Se.KEY_DOWN, Se.KEY_UP, Se.MOUSE_DOWN])
      t.add(fe(e, i, n, !0));
  }
  getUI(e) {
    if (this.ui)
      return e && qe(this._container) !== qe(this.layoutService.activeContainer) && (this.reparentUI(this.layoutService.activeContainer), this.layout(this.layoutService.activeContainerDimension, this.layoutService.activeContainerOffset.quickPickTop)), this.ui;
    const t = Fe(this._container, Ks(".quick-input-widget.show-file-icons"));
    t.tabIndex = -1, t.style.display = "none";
    const n = ya(t), i = Fe(t, Ks(".quick-input-titlebar")), s = this._register(new Md(i, { hoverDelegate: this.options.hoverDelegate }));
    s.domNode.classList.add("quick-input-left-action-bar");
    const o = Fe(i, Ks(".quick-input-title")), a = this._register(new Md(i, { hoverDelegate: this.options.hoverDelegate }));
    a.domNode.classList.add("quick-input-right-action-bar");
    const l = Fe(t, Ks(".quick-input-header")), c = Fe(l, Ks("input.quick-input-check-all"));
    c.type = "checkbox", c.setAttribute("aria-label", C("quickInput.checkAll", "Toggle all checkboxes")), this._register(ir(c, Se.CHANGE, (H) => {
      const z = c.checked;
      N.setAllVisibleChecked(z);
    })), this._register(fe(c, Se.CLICK, (H) => {
      (H.x || H.y) && p.setFocus();
    }));
    const d = Fe(l, Ks(".quick-input-description")), u = Fe(l, Ks(".quick-input-and-message")), f = Fe(u, Ks(".quick-input-filter")), p = this._register(new Vyt(f, this.styles.inputBox, this.styles.toggle));
    p.setAttribute("aria-describedby", `${this.idPrefix}message`);
    const g = Fe(f, Ks(".quick-input-visible-count"));
    g.setAttribute("aria-live", "polite"), g.setAttribute("aria-atomic", "true");
    const m = new m9e(g, { countFormat: C({ key: "quickInput.visibleCount", comment: ["This tells the user how many items are shown in a list of items to select from. The items can be anything. Currently not visible, but read by screen readers."] }, "{0} Results") }, this.styles.countBadge), A = Fe(f, Ks(".quick-input-count"));
    A.setAttribute("aria-live", "polite");
    const w = new m9e(A, { countFormat: C({ key: "quickInput.countSelected", comment: ["This tells the user how many items are selected in a list of items to select from. The items can be anything."] }, "{0} Selected") }, this.styles.countBadge), v = this._register(new Md(l, { hoverDelegate: this.options.hoverDelegate }));
    v.domNode.classList.add("quick-input-inline-action-bar");
    const y = Fe(l, Ks(".quick-input-action")), _ = this._register(new _k(y, this.styles.button));
    _.label = C("ok", "OK"), this._register(_.onDidClick((H) => {
      this.onDidAcceptEmitter.fire();
    }));
    const S = Fe(l, Ks(".quick-input-action")), D = this._register(new _k(S, { ...this.styles.button, supportIcons: !0 }));
    D.label = C("custom", "Custom"), this._register(D.onDidClick((H) => {
      this.onDidCustomEmitter.fire();
    }));
    const M = Fe(u, Ks(`#${this.idPrefix}message.quick-input-message`)), L = this._register(new xR(t, this.styles.progressBar));
    L.getContainer().classList.add("quick-input-progress");
    const T = Fe(t, Ks(".quick-input-html-widget"));
    T.tabIndex = -1;
    const B = Fe(t, Ks(".quick-input-description")), V = this.idPrefix + "list", N = this._register(this.instantiationService.createInstance(f4, t, this.options.hoverDelegate, this.options.linkOpenerDelegate, V));
    p.setAttribute("aria-controls", V), this._register(N.onDidChangeFocus(() => {
      p.setAttribute("aria-activedescendant", N.getActiveDescendant() ?? "");
    })), this._register(N.onChangedAllVisibleChecked((H) => {
      c.checked = H;
    })), this._register(N.onChangedVisibleCount((H) => {
      m.setCount(H);
    })), this._register(N.onChangedCheckedCount((H) => {
      w.setCount(H);
    })), this._register(N.onLeave(() => {
      setTimeout(() => {
        this.controller && (p.setFocus(), this.controller instanceof Z9 && this.controller.canSelectMany && N.clearFocus());
      }, 0);
    }));
    const R = Af(t);
    return this._register(R), this._register(fe(t, Se.FOCUS, (H) => {
      const z = this.getUI();
      if (Ji(H.relatedTarget, z.inputContainer)) {
        const U = z.inputBox.isSelectionAtEnd();
        this.endOfQuickInputBoxContext.get() !== U && this.endOfQuickInputBoxContext.set(U);
      }
      Ji(H.relatedTarget, z.container) || (this.inQuickInputContext.set(!0), this.previousFocusElement = wr(H.relatedTarget) ? H.relatedTarget : void 0);
    }, !0)), this._register(R.onDidBlur(() => {
      !this.getUI().ignoreFocusOut && !this.options.ignoreFocusOut() && this.hide(bg.Blur), this.inQuickInputContext.set(!1), this.endOfQuickInputBoxContext.set(!1), this.previousFocusElement = void 0;
    })), this._register(p.onKeyDown((H) => {
      const z = this.getUI().inputBox.isSelectionAtEnd();
      this.endOfQuickInputBoxContext.get() !== z && this.endOfQuickInputBoxContext.set(z);
    })), this._register(fe(t, Se.FOCUS, (H) => {
      p.setFocus();
    })), this._register(ir(t, Se.KEY_DOWN, (H) => {
      if (!Ji(H.target, T))
        switch (H.keyCode) {
          case 3:
            Lt.stop(H, !0), this.enabled && this.onDidAcceptEmitter.fire();
            break;
          case 9:
            Lt.stop(H, !0), this.hide(bg.Gesture);
            break;
          case 2:
            if (!H.altKey && !H.ctrlKey && !H.metaKey) {
              const z = [
                ".quick-input-list .monaco-action-bar .always-visible",
                ".quick-input-list-entry:hover .monaco-action-bar",
                ".monaco-list-row.focused .monaco-action-bar"
              ];
              if (t.classList.contains("show-checkboxes") ? z.push("input") : z.push("input[type=text]"), this.getUI().list.displayed && z.push(".monaco-list"), this.getUI().message && z.push(".quick-input-message a"), this.getUI().widget) {
                if (Ji(H.target, this.getUI().widget))
                  break;
                z.push(".quick-input-html-widget");
              }
              const U = t.querySelectorAll(z.join(", "));
              H.shiftKey && H.target === U[0] ? (Lt.stop(H, !0), N.clearFocus()) : !H.shiftKey && Ji(H.target, U[U.length - 1]) && (Lt.stop(H, !0), U[0].focus());
            }
            break;
          case 10:
            H.ctrlKey && (Lt.stop(H, !0), this.getUI().list.toggleHover());
            break;
        }
    })), this.ui = {
      container: t,
      styleSheet: n,
      leftActionBar: s,
      titleBar: i,
      title: o,
      description1: B,
      description2: d,
      widget: T,
      rightActionBar: a,
      inlineActionBar: v,
      checkAll: c,
      inputContainer: u,
      filterContainer: f,
      inputBox: p,
      visibleCountContainer: g,
      visibleCount: m,
      countContainer: A,
      count: w,
      okContainer: y,
      ok: _,
      message: M,
      customButtonContainer: S,
      customButton: D,
      list: N,
      progressBar: L,
      onDidAccept: this.onDidAcceptEmitter.event,
      onDidCustom: this.onDidCustomEmitter.event,
      onDidTriggerButton: this.onDidTriggerButtonEmitter.event,
      ignoreFocusOut: !1,
      keyMods: this.keyMods,
      show: (H) => this.show(H),
      hide: () => this.hide(),
      setVisibilities: (H) => this.setVisibilities(H),
      setEnabled: (H) => this.setEnabled(H),
      setContextKey: (H) => this.options.setContextKey(H),
      linkOpenerDelegate: (H) => this.options.linkOpenerDelegate(H)
    }, this.updateStyles(), this.ui;
  }
  reparentUI(e) {
    this.ui && (this._container = e, Fe(this._container, this.ui.container));
  }
  pick(e, t = {}, n = fl.None) {
    return new Promise((i, s) => {
      let o = (d) => {
        o = i, t.onKeyMods?.(a.keyMods), i(d);
      };
      if (n.isCancellationRequested) {
        o(void 0);
        return;
      }
      const a = this.createQuickPick();
      let l;
      const c = [
        a,
        a.onDidAccept(() => {
          if (a.canSelectMany)
            o(a.selectedItems.slice()), a.hide();
          else {
            const d = a.activeItems[0];
            d && (o(d), a.hide());
          }
        }),
        a.onDidChangeActive((d) => {
          const u = d[0];
          u && t.onDidFocus && t.onDidFocus(u);
        }),
        a.onDidChangeSelection((d) => {
          if (!a.canSelectMany) {
            const u = d[0];
            u && (o(u), a.hide());
          }
        }),
        a.onDidTriggerItemButton((d) => t.onDidTriggerItemButton && t.onDidTriggerItemButton({
          ...d,
          removeItem: () => {
            const u = a.items.indexOf(d.item);
            if (u !== -1) {
              const f = a.items.slice(), p = f.splice(u, 1), g = a.activeItems.filter((A) => A !== p[0]), m = a.keepScrollPosition;
              a.keepScrollPosition = !0, a.items = f, g && (a.activeItems = g), a.keepScrollPosition = m;
            }
          }
        })),
        a.onDidTriggerSeparatorButton((d) => t.onDidTriggerSeparatorButton?.(d)),
        a.onDidChangeValue((d) => {
          l && !d && (a.activeItems.length !== 1 || a.activeItems[0] !== l) && (a.activeItems = [l]);
        }),
        n.onCancellationRequested(() => {
          a.hide();
        }),
        a.onDidHide(() => {
          br(c), o(void 0);
        })
      ];
      a.title = t.title, a.canSelectMany = !!t.canPickMany, a.placeholder = t.placeHolder, a.ignoreFocusOut = !!t.ignoreFocusLost, a.matchOnDescription = !!t.matchOnDescription, a.matchOnDetail = !!t.matchOnDetail, a.matchOnLabel = t.matchOnLabel === void 0 || t.matchOnLabel, a.quickNavigate = t.quickNavigate, a.hideInput = !!t.hideInput, a.contextKey = t.contextKey, a.busy = !0, Promise.all([e, t.activeItem]).then(([d, u]) => {
        l = u, a.busy = !1, a.items = d, a.canSelectMany && (a.selectedItems = d.filter((f) => f.type !== "separator" && f.picked)), l && (a.activeItems = [l]);
      }), a.show(), Promise.resolve(e).then(void 0, (d) => {
        s(d), a.hide();
      });
    });
  }
  createQuickPick() {
    const e = this.getUI(!0);
    return new Z9(e);
  }
  createInputBox() {
    const e = this.getUI(!0);
    return new Myt(e);
  }
  show(e) {
    const t = this.getUI(!0);
    this.onShowEmitter.fire();
    const n = this.controller;
    this.controller = e, n?.didHide(), this.setEnabled(!0), t.leftActionBar.clear(), t.title.textContent = "", t.description1.textContent = "", t.description2.textContent = "", ys(t.widget), t.rightActionBar.clear(), t.inlineActionBar.clear(), t.checkAll.checked = !1, t.inputBox.placeholder = "", t.inputBox.password = !1, t.inputBox.showDecoration(Oi.Ignore), t.visibleCount.setCount(0), t.count.setCount(0), ys(t.message), t.progressBar.stop(), t.list.setElements([]), t.list.matchOnDescription = !1, t.list.matchOnDetail = !1, t.list.matchOnLabel = !0, t.list.sortByLabel = !0, t.ignoreFocusOut = !1, t.inputBox.toggles = void 0;
    const i = this.options.backKeybindingLabel();
    Ck.tooltip = i ? C("quickInput.backWithKeybinding", "Back ({0})", i) : C("quickInput.back", "Back"), t.container.style.display = "", this.updateLayout(), t.inputBox.setFocus(), this.quickInputTypeContext.set(e.type);
  }
  isVisible() {
    return !!this.ui && this.ui.container.style.display !== "none";
  }
  setVisibilities(e) {
    const t = this.getUI();
    t.title.style.display = e.title ? "" : "none", t.description1.style.display = e.description && (e.inputBox || e.checkAll) ? "" : "none", t.description2.style.display = e.description && !(e.inputBox || e.checkAll) ? "" : "none", t.checkAll.style.display = e.checkAll ? "" : "none", t.inputContainer.style.display = e.inputBox ? "" : "none", t.filterContainer.style.display = e.inputBox ? "" : "none", t.visibleCountContainer.style.display = e.visibleCount ? "" : "none", t.countContainer.style.display = e.count ? "" : "none", t.okContainer.style.display = e.ok ? "" : "none", t.customButtonContainer.style.display = e.customButton ? "" : "none", t.message.style.display = e.message ? "" : "none", t.progressBar.getContainer().style.display = e.progressBar ? "" : "none", t.list.displayed = !!e.list, t.container.classList.toggle("show-checkboxes", !!e.checkBox), t.container.classList.toggle("hidden-input", !e.inputBox && !e.description), this.updateLayout();
  }
  setEnabled(e) {
    if (e !== this.enabled) {
      this.enabled = e;
      for (const t of this.getUI().leftActionBar.viewItems)
        t.action.enabled = e;
      for (const t of this.getUI().rightActionBar.viewItems)
        t.action.enabled = e;
      this.getUI().checkAll.disabled = !e, this.getUI().inputBox.enabled = e, this.getUI().ok.enabled = e, this.getUI().list.enabled = e;
    }
  }
  hide(e) {
    const t = this.controller;
    if (!t)
      return;
    t.willHide(e);
    const n = this.ui?.container, i = n && !kDe(n);
    if (this.controller = null, this.onHideEmitter.fire(), n && (n.style.display = "none"), !i) {
      let s = this.previousFocusElement;
      for (; s && !s.offsetParent; )
        s = s.parentElement ?? void 0;
      s?.offsetParent ? (s.focus(), this.previousFocusElement = void 0) : this.options.returnFocus();
    }
    t.didHide(e);
  }
  layout(e, t) {
    this.dimension = e, this.titleBarOffset = t, this.updateLayout();
  }
  updateLayout() {
    if (this.ui && this.isVisible()) {
      this.ui.container.style.top = `${this.titleBarOffset}px`;
      const e = this.ui.container.style, t = Math.min(this.dimension.width * 0.62, Nk.MAX_WIDTH);
      e.width = t + "px", e.marginLeft = "-" + t / 2 + "px", this.ui.inputBox.layout(), this.ui.list.layout(this.dimension && this.dimension.height * 0.4);
    }
  }
  applyStyles(e) {
    this.styles = e, this.updateStyles();
  }
  updateStyles() {
    if (this.ui) {
      const { quickInputTitleBackground: e, quickInputBackground: t, quickInputForeground: n, widgetBorder: i, widgetShadow: s } = this.styles.widget;
      this.ui.titleBar.style.backgroundColor = e ?? "", this.ui.container.style.backgroundColor = t ?? "", this.ui.container.style.color = n ?? "", this.ui.container.style.border = i ? `1px solid ${i}` : "", this.ui.container.style.boxShadow = s ? `0 0 8px 2px ${s}` : "", this.ui.list.style(this.styles.list);
      const o = [];
      this.styles.pickerGroup.pickerGroupBorder && o.push(`.quick-input-list .quick-input-list-entry { border-top-color:  ${this.styles.pickerGroup.pickerGroupBorder}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(`.quick-input-list .quick-input-list-separator { color:  ${this.styles.pickerGroup.pickerGroupForeground}; }`), this.styles.pickerGroup.pickerGroupForeground && o.push(".quick-input-list .quick-input-list-separator-as-item { color: var(--vscode-descriptionForeground); }"), (this.styles.keybindingLabel.keybindingLabelBackground || this.styles.keybindingLabel.keybindingLabelBorder || this.styles.keybindingLabel.keybindingLabelBottomBorder || this.styles.keybindingLabel.keybindingLabelShadow || this.styles.keybindingLabel.keybindingLabelForeground) && (o.push(".quick-input-list .monaco-keybinding > .monaco-keybinding-key {"), this.styles.keybindingLabel.keybindingLabelBackground && o.push(`background-color: ${this.styles.keybindingLabel.keybindingLabelBackground};`), this.styles.keybindingLabel.keybindingLabelBorder && o.push(`border-color: ${this.styles.keybindingLabel.keybindingLabelBorder};`), this.styles.keybindingLabel.keybindingLabelBottomBorder && o.push(`border-bottom-color: ${this.styles.keybindingLabel.keybindingLabelBottomBorder};`), this.styles.keybindingLabel.keybindingLabelShadow && o.push(`box-shadow: inset 0 -1px 0 ${this.styles.keybindingLabel.keybindingLabelShadow};`), this.styles.keybindingLabel.keybindingLabelForeground && o.push(`color: ${this.styles.keybindingLabel.keybindingLabelForeground};`), o.push("}"));
      const a = o.join(`
`);
      a !== this.ui.styleSheet.textContent && (this.ui.styleSheet.textContent = a);
    }
  }
};
Tk = Nk = nEt([
  k_(1, R1),
  k_(2, xn),
  k_(3, sn)
], Tk);
var iEt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Gm = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let Ik = class extends X3t {
  get controller() {
    return this._controller || (this._controller = this._register(this.createController())), this._controller;
  }
  get hasController() {
    return !!this._controller;
  }
  get currentQuickInput() {
    return this.controller.currentQuickInput;
  }
  get quickAccess() {
    return this._quickAccess || (this._quickAccess = this._register(this.instantiationService.createInstance(yk))), this._quickAccess;
  }
  constructor(e, t, n, i, s) {
    super(n), this.instantiationService = e, this.contextKeyService = t, this.layoutService = i, this.configurationService = s, this._onShow = this._register(new $()), this._onHide = this._register(new $()), this.contexts = /* @__PURE__ */ new Map();
  }
  createController(e = this.layoutService, t) {
    const n = {
      idPrefix: "quickInput_",
      container: e.activeContainer,
      ignoreFocusOut: () => !1,
      backKeybindingLabel: () => {
      },
      setContextKey: (s) => this.setContextKey(s),
      linkOpenerDelegate: (s) => {
        this.instantiationService.invokeFunction((o) => {
          o.get(Tw).open(s, { allowCommands: !0, fromUserGesture: !0 });
        });
      },
      returnFocus: () => e.focus(),
      styles: this.computeStyles(),
      hoverDelegate: this._register(this.instantiationService.createInstance(Ek))
    }, i = this._register(this.instantiationService.createInstance(Tk, {
      ...n,
      ...t
    }));
    return i.layout(e.activeContainerDimension, e.activeContainerOffset.quickPickTop), this._register(e.onDidLayoutActiveContainer((s) => {
      qe(e.activeContainer) === qe(i.container) && i.layout(s, e.activeContainerOffset.quickPickTop);
    })), this._register(e.onDidChangeActiveContainer(() => {
      i.isVisible() || i.layout(e.activeContainerDimension, e.activeContainerOffset.quickPickTop);
    })), this._register(i.onShow(() => {
      this.resetContextKeys(), this._onShow.fire();
    })), this._register(i.onHide(() => {
      this.resetContextKeys(), this._onHide.fire();
    })), i;
  }
  setContextKey(e) {
    let t;
    e && (t = this.contexts.get(e), t || (t = new Ve(e, !1).bindTo(this.contextKeyService), this.contexts.set(e, t))), !(t && t.get()) && (this.resetContextKeys(), t?.set(!0));
  }
  resetContextKeys() {
    this.contexts.forEach((e) => {
      e.get() && e.reset();
    });
  }
  pick(e, t = {}, n = fl.None) {
    return this.controller.pick(e, t, n);
  }
  createQuickPick() {
    return this.controller.createQuickPick();
  }
  createInputBox() {
    return this.controller.createInputBox();
  }
  updateStyles() {
    this.hasController && this.controller.applyStyles(this.computeStyles());
  }
  computeStyles() {
    return {
      widget: {
        quickInputBackground: _e(l6e),
        quickInputForeground: _e(o3t),
        quickInputTitleBackground: _e(a3t),
        widgetBorder: _e(Umt),
        widgetShadow: _e(Mw)
      },
      inputBox: P9,
      toggle: B9,
      countBadge: Q7t,
      button: U7t,
      progressBar: q7t,
      keybindingLabel: Z7t,
      list: Vw({
        listBackground: l6e,
        listFocusBackground: gL,
        listFocusForeground: pL,
        // Look like focused when inactive.
        listInactiveFocusForeground: pL,
        listInactiveSelectionIconForeground: ZLe,
        listInactiveFocusBackground: gL,
        listFocusOutline: _i,
        listInactiveFocusOutline: _i
      }),
      pickerGroup: {
        pickerGroupBorder: _e(l3t),
        pickerGroupForeground: _e(jLe)
      }
    };
  }
};
Ik = iEt([
  Gm(0, xn),
  Gm(1, sn),
  Gm(2, Sa),
  Gm(3, R1),
  Gm(4, Ai)
], Ik);
var mTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, x0 = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let Ok = class extends Ik {
  constructor(e, t, n, i, s, o) {
    super(t, n, i, new PL(e.getContainerDomNode(), s), o), this.host = void 0;
    const a = p4.get(e);
    if (a) {
      const l = a.widget;
      this.host = {
        _serviceBrand: void 0,
        get mainContainer() {
          return l.getDomNode();
        },
        getContainer() {
          return l.getDomNode();
        },
        whenContainerStylesLoaded() {
        },
        get containers() {
          return [l.getDomNode()];
        },
        get activeContainer() {
          return l.getDomNode();
        },
        get mainContainerDimension() {
          return e.getLayoutInfo();
        },
        get activeContainerDimension() {
          return e.getLayoutInfo();
        },
        get onDidLayoutMainContainer() {
          return e.onDidLayoutChange;
        },
        get onDidLayoutActiveContainer() {
          return e.onDidLayoutChange;
        },
        get onDidLayoutContainer() {
          return xe.map(e.onDidLayoutChange, (c) => ({ container: l.getDomNode(), dimension: c }));
        },
        get onDidChangeActiveContainer() {
          return xe.None;
        },
        get onDidAddContainer() {
          return xe.None;
        },
        get mainContainerOffset() {
          return { top: 0, quickPickTop: 0 };
        },
        get activeContainerOffset() {
          return { top: 0, quickPickTop: 0 };
        },
        focus: () => e.focus()
      };
    } else
      this.host = void 0;
  }
  createController() {
    return super.createController(this.host);
  }
};
Ok = mTe([
  x0(1, xn),
  x0(2, sn),
  x0(3, Sa),
  x0(4, Ui),
  x0(5, Ai)
], Ok);
let Rk = class {
  get activeService() {
    const e = this.codeEditorService.getFocusedCodeEditor();
    if (!e)
      throw new Error("Quick input service needs a focused editor to work.");
    let t = this.mapEditorToService.get(e);
    if (!t) {
      const n = t = this.instantiationService.createInstance(Ok, e);
      this.mapEditorToService.set(e, t), ig(e.onDidDispose)(() => {
        n.dispose(), this.mapEditorToService.delete(e);
      });
    }
    return t;
  }
  get currentQuickInput() {
    return this.activeService.currentQuickInput;
  }
  get quickAccess() {
    return this.activeService.quickAccess;
  }
  constructor(e, t) {
    this.instantiationService = e, this.codeEditorService = t, this.mapEditorToService = /* @__PURE__ */ new Map();
  }
  pick(e, t = {}, n = fl.None) {
    return this.activeService.pick(e, t, n);
  }
  createQuickPick() {
    return this.activeService.createQuickPick();
  }
  createInputBox() {
    return this.activeService.createInputBox();
  }
};
Rk = mTe([
  x0(0, xn),
  x0(1, Ui)
], Rk);
class p4 {
  static {
    this.ID = "editor.controller.quickInput";
  }
  static get(e) {
    return e.getContribution(p4.ID);
  }
  constructor(e) {
    this.editor = e, this.widget = new ZR(this.editor);
  }
  dispose() {
    this.widget.dispose();
  }
}
class ZR {
  static {
    this.ID = "editor.contrib.quickInputWidget";
  }
  constructor(e) {
    this.codeEditor = e, this.domNode = document.createElement("div"), this.codeEditor.addOverlayWidget(this);
  }
  getId() {
    return ZR.ID;
  }
  getDomNode() {
    return this.domNode;
  }
  getPosition() {
    return {
      preference: 2
      /* OverlayWidgetPositionPreference.TOP_CENTER */
    };
  }
  dispose() {
    this.codeEditor.removeOverlayWidget(this);
  }
}
iO(
  p4.ID,
  p4,
  4
  /* EditorContributionInstantiation.Lazy */
);
class rEt {
  constructor(e, t, n, i, s) {
    this._parsedThemeRuleBrand = void 0, this.token = e, this.index = t, this.fontStyle = n, this.foreground = i, this.background = s;
  }
}
function sEt(r) {
  if (!r || !Array.isArray(r))
    return [];
  const e = [];
  let t = 0;
  for (let n = 0, i = r.length; n < i; n++) {
    const s = r[n];
    let o = -1;
    if (typeof s.fontStyle == "string") {
      o = 0;
      const c = s.fontStyle.split(" ");
      for (let d = 0, u = c.length; d < u; d++)
        switch (c[d]) {
          case "italic":
            o = o | 1;
            break;
          case "bold":
            o = o | 2;
            break;
          case "underline":
            o = o | 4;
            break;
          case "strikethrough":
            o = o | 8;
            break;
        }
    }
    let a = null;
    typeof s.foreground == "string" && (a = s.foreground);
    let l = null;
    typeof s.background == "string" && (l = s.background), e[t++] = new rEt(s.token || "", n, o, a, l);
  }
  return e;
}
function oEt(r, e) {
  r.sort((d, u) => {
    const f = dEt(d.token, u.token);
    return f !== 0 ? f : d.index - u.index;
  });
  let t = 0, n = "000000", i = "ffffff";
  for (; r.length >= 1 && r[0].token === ""; ) {
    const d = r.shift();
    d.fontStyle !== -1 && (t = d.fontStyle), d.foreground !== null && (n = d.foreground), d.background !== null && (i = d.background);
  }
  const s = new lEt();
  for (const d of e)
    s.getId(d);
  const o = s.getId(n), a = s.getId(i), l = new UR(t, o, a), c = new qR(l);
  for (let d = 0, u = r.length; d < u; d++) {
    const f = r[d];
    c.insert(f.token, f.fontStyle, s.getId(f.foreground), s.getId(f.background));
  }
  return new ATe(s, c);
}
const aEt = /^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})?$/;
class lEt {
  constructor() {
    this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ new Map();
  }
  getId(e) {
    if (e === null)
      return 0;
    const t = e.match(aEt);
    if (!t)
      throw new Error("Illegal value for token color: " + e);
    e = t[1].toUpperCase();
    let n = this._color2id.get(e);
    return n || (n = ++this._lastColorId, this._color2id.set(e, n), this._id2color[n] = ge.fromHex("#" + e), n);
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}
class ATe {
  static createFromRawTokenTheme(e, t) {
    return this.createFromParsedTokenTheme(sEt(e), t);
  }
  static createFromParsedTokenTheme(e, t) {
    return oEt(e, t);
  }
  constructor(e, t) {
    this._colorMap = e, this._root = t, this._cache = /* @__PURE__ */ new Map();
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  _match(e) {
    return this._root.match(e);
  }
  match(e, t) {
    let n = this._cache.get(t);
    if (typeof n > "u") {
      const i = this._match(t), s = hEt(t);
      n = (i.metadata | s << 8) >>> 0, this._cache.set(t, n);
    }
    return (n | e << 0) >>> 0;
  }
}
const cEt = /\b(comment|string|regex|regexp)\b/;
function hEt(r) {
  const e = r.match(cEt);
  if (!e)
    return 0;
  switch (e[1]) {
    case "comment":
      return 1;
    case "string":
      return 2;
    case "regex":
      return 3;
    case "regexp":
      return 3;
  }
  throw new Error("Unexpected match for standard token type!");
}
function dEt(r, e) {
  return r < e ? -1 : r > e ? 1 : 0;
}
class UR {
  constructor(e, t, n) {
    this._themeTrieElementRuleBrand = void 0, this._fontStyle = e, this._foreground = t, this._background = n, this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
  clone() {
    return new UR(this._fontStyle, this._foreground, this._background);
  }
  acceptOverwrite(e, t, n) {
    e !== -1 && (this._fontStyle = e), t !== 0 && (this._foreground = t), n !== 0 && (this._background = n), this.metadata = (this._fontStyle << 11 | this._foreground << 15 | this._background << 24) >>> 0;
  }
}
class qR {
  constructor(e) {
    this._themeTrieElementBrand = void 0, this._mainRule = e, this._children = /* @__PURE__ */ new Map();
  }
  match(e) {
    if (e === "")
      return this._mainRule;
    const t = e.indexOf(".");
    let n, i;
    t === -1 ? (n = e, i = "") : (n = e.substring(0, t), i = e.substring(t + 1));
    const s = this._children.get(n);
    return typeof s < "u" ? s.match(i) : this._mainRule;
  }
  insert(e, t, n, i) {
    if (e === "") {
      this._mainRule.acceptOverwrite(t, n, i);
      return;
    }
    const s = e.indexOf(".");
    let o, a;
    s === -1 ? (o = e, a = "") : (o = e.substring(0, s), a = e.substring(s + 1));
    let l = this._children.get(o);
    typeof l > "u" && (l = new qR(this._mainRule.clone()), this._children.set(o, l)), l.insert(a, t, n, i);
  }
}
function uEt(r) {
  const e = [];
  for (let t = 1, n = r.length; t < n; t++) {
    const i = r[t];
    e[t] = `.mtk${t} { color: ${i}; }`;
  }
  return e.push(".mtki { font-style: italic; }"), e.push(".mtkb { font-weight: bold; }"), e.push(".mtku { text-decoration: underline; text-underline-position: under; }"), e.push(".mtks { text-decoration: line-through; }"), e.push(".mtks.mtku { text-decoration: underline line-through; text-underline-position: under; }"), e.join(`
`);
}
const fEt = {
  base: "vs",
  inherit: !1,
  rules: [
    { token: "", foreground: "000000", background: "fffffe" },
    { token: "invalid", foreground: "cd3131" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "001188" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "constant", foreground: "dd0000" },
    { token: "comment", foreground: "008000" },
    { token: "number", foreground: "098658" },
    { token: "number.hex", foreground: "3030c0" },
    { token: "regexp", foreground: "800000" },
    { token: "annotation", foreground: "808080" },
    { token: "type", foreground: "008080" },
    { token: "delimiter", foreground: "000000" },
    { token: "delimiter.html", foreground: "383838" },
    { token: "delimiter.xml", foreground: "0000FF" },
    { token: "tag", foreground: "800000" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "800000" },
    { token: "metatag", foreground: "e00000" },
    { token: "metatag.content.html", foreground: "FF0000" },
    { token: "metatag.html", foreground: "808080" },
    { token: "metatag.xml", foreground: "808080" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "863B00" },
    { token: "string.key.json", foreground: "A31515" },
    { token: "string.value.json", foreground: "0451A5" },
    { token: "attribute.name", foreground: "FF0000" },
    { token: "attribute.value", foreground: "0451A5" },
    { token: "attribute.value.number", foreground: "098658" },
    { token: "attribute.value.unit", foreground: "098658" },
    { token: "attribute.value.html", foreground: "0000FF" },
    { token: "attribute.value.xml", foreground: "0000FF" },
    { token: "string", foreground: "A31515" },
    { token: "string.html", foreground: "0000FF" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "string.yaml", foreground: "0451A5" },
    { token: "keyword", foreground: "0000FF" },
    { token: "keyword.json", foreground: "0451A5" },
    { token: "keyword.flow", foreground: "AF00DB" },
    { token: "keyword.flow.scss", foreground: "0000FF" },
    { token: "operator.scss", foreground: "666666" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "666666" },
    { token: "predefined.sql", foreground: "C700C7" }
  ],
  colors: {
    [dh]: "#FFFFFE",
    [Sw]: "#000000",
    [ILe]: "#E5EBF1",
    [Lw]: "#D3D3D3",
    [kw]: "#939393",
    [OLe]: "#ADD6FF4D"
  }
}, pEt = {
  base: "vs-dark",
  inherit: !1,
  rules: [
    { token: "", foreground: "D4D4D4", background: "1E1E1E" },
    { token: "invalid", foreground: "f44747" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "74B0DF" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "variable.parameter", foreground: "9CDCFE" },
    { token: "constant", foreground: "569CD6" },
    { token: "comment", foreground: "608B4E" },
    { token: "number", foreground: "B5CEA8" },
    { token: "number.hex", foreground: "5BB498" },
    { token: "regexp", foreground: "B46695" },
    { token: "annotation", foreground: "cc6666" },
    { token: "type", foreground: "3DC9B0" },
    { token: "delimiter", foreground: "DCDCDC" },
    { token: "delimiter.html", foreground: "808080" },
    { token: "delimiter.xml", foreground: "808080" },
    { token: "tag", foreground: "569CD6" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "A79873" },
    { token: "meta.tag", foreground: "CE9178" },
    { token: "metatag", foreground: "DD6A6F" },
    { token: "metatag.content.html", foreground: "9CDCFE" },
    { token: "metatag.html", foreground: "569CD6" },
    { token: "metatag.xml", foreground: "569CD6" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "9CDCFE" },
    { token: "string.key.json", foreground: "9CDCFE" },
    { token: "string.value.json", foreground: "CE9178" },
    { token: "attribute.name", foreground: "9CDCFE" },
    { token: "attribute.value", foreground: "CE9178" },
    { token: "attribute.value.number.css", foreground: "B5CEA8" },
    { token: "attribute.value.unit.css", foreground: "B5CEA8" },
    { token: "attribute.value.hex.css", foreground: "D4D4D4" },
    { token: "string", foreground: "CE9178" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "keyword", foreground: "569CD6" },
    { token: "keyword.flow", foreground: "C586C0" },
    { token: "keyword.json", foreground: "CE9178" },
    { token: "keyword.flow.scss", foreground: "569CD6" },
    { token: "operator.scss", foreground: "909090" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "909090" },
    { token: "predefined.sql", foreground: "FF00FF" }
  ],
  colors: {
    [dh]: "#1E1E1E",
    [Sw]: "#D4D4D4",
    [ILe]: "#3A3D41",
    [Lw]: "#404040",
    [kw]: "#707070",
    [OLe]: "#ADD6FF26"
  }
}, gEt = {
  base: "hc-black",
  inherit: !1,
  rules: [
    { token: "", foreground: "FFFFFF", background: "000000" },
    { token: "invalid", foreground: "f44747" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "1AEBFF" },
    { token: "variable.parameter", foreground: "9CDCFE" },
    { token: "constant", foreground: "569CD6" },
    { token: "comment", foreground: "608B4E" },
    { token: "number", foreground: "FFFFFF" },
    { token: "regexp", foreground: "C0C0C0" },
    { token: "annotation", foreground: "569CD6" },
    { token: "type", foreground: "3DC9B0" },
    { token: "delimiter", foreground: "FFFF00" },
    { token: "delimiter.html", foreground: "FFFF00" },
    { token: "tag", foreground: "569CD6" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta", foreground: "D4D4D4" },
    { token: "meta.tag", foreground: "CE9178" },
    { token: "metatag", foreground: "569CD6" },
    { token: "metatag.content.html", foreground: "1AEBFF" },
    { token: "metatag.html", foreground: "569CD6" },
    { token: "metatag.xml", foreground: "569CD6" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "9CDCFE" },
    { token: "string.key", foreground: "9CDCFE" },
    { token: "string.value", foreground: "CE9178" },
    { token: "attribute.name", foreground: "569CD6" },
    { token: "attribute.value", foreground: "3FF23F" },
    { token: "string", foreground: "CE9178" },
    { token: "string.sql", foreground: "FF0000" },
    { token: "keyword", foreground: "569CD6" },
    { token: "keyword.flow", foreground: "C586C0" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "909090" },
    { token: "predefined.sql", foreground: "FF00FF" }
  ],
  colors: {
    [dh]: "#000000",
    [Sw]: "#FFFFFF",
    [Lw]: "#FFFFFF",
    [kw]: "#FFFFFF"
  }
}, mEt = {
  base: "hc-light",
  inherit: !1,
  rules: [
    { token: "", foreground: "292929", background: "FFFFFF" },
    { token: "invalid", foreground: "B5200D" },
    { token: "emphasis", fontStyle: "italic" },
    { token: "strong", fontStyle: "bold" },
    { token: "variable", foreground: "264F70" },
    { token: "variable.predefined", foreground: "4864AA" },
    { token: "constant", foreground: "dd0000" },
    { token: "comment", foreground: "008000" },
    { token: "number", foreground: "098658" },
    { token: "number.hex", foreground: "3030c0" },
    { token: "regexp", foreground: "800000" },
    { token: "annotation", foreground: "808080" },
    { token: "type", foreground: "008080" },
    { token: "delimiter", foreground: "000000" },
    { token: "delimiter.html", foreground: "383838" },
    { token: "tag", foreground: "800000" },
    { token: "tag.id.pug", foreground: "4F76AC" },
    { token: "tag.class.pug", foreground: "4F76AC" },
    { token: "meta.scss", foreground: "800000" },
    { token: "metatag", foreground: "e00000" },
    { token: "metatag.content.html", foreground: "B5200D" },
    { token: "metatag.html", foreground: "808080" },
    { token: "metatag.xml", foreground: "808080" },
    { token: "metatag.php", fontStyle: "bold" },
    { token: "key", foreground: "863B00" },
    { token: "string.key.json", foreground: "A31515" },
    { token: "string.value.json", foreground: "0451A5" },
    { token: "attribute.name", foreground: "264F78" },
    { token: "attribute.value", foreground: "0451A5" },
    { token: "string", foreground: "A31515" },
    { token: "string.sql", foreground: "B5200D" },
    { token: "keyword", foreground: "0000FF" },
    { token: "keyword.flow", foreground: "AF00DB" },
    { token: "operator.sql", foreground: "778899" },
    { token: "operator.swift", foreground: "666666" },
    { token: "predefined.sql", foreground: "C700C7" }
  ],
  colors: {
    [dh]: "#FFFFFF",
    [Sw]: "#292929",
    [Lw]: "#292929",
    [kw]: "#292929"
  }
}, AEt = {
  IconContribution: "base.contributions.icons"
};
var P9e;
(function(r) {
  function e(t, n) {
    let i = t.defaults;
    for (; Tt.isThemeIcon(i); ) {
      const s = o2.getIcon(i.id);
      if (!s)
        return;
      i = s.defaults;
    }
    return i;
  }
  r.getDefinition = e;
})(P9e || (P9e = {}));
var F9e;
(function(r) {
  function e(n) {
    return {
      weight: n.weight,
      style: n.style,
      src: n.src.map((i) => ({ format: i.format, location: i.location.toString() }))
    };
  }
  r.toJSONObject = e;
  function t(n) {
    const i = (s) => Vo(s) ? s : void 0;
    if (n && Array.isArray(n.src) && n.src.every((s) => Vo(s.format) && Vo(s.location)))
      return {
        weight: i(n.weight),
        style: i(n.style),
        src: n.src.map((s) => ({ format: s.format, location: Pt.parse(s.location) }))
      };
  }
  r.fromJSONObject = t;
})(F9e || (F9e = {}));
class wEt {
  constructor() {
    this._onDidChange = new $(), this.onDidChange = this._onDidChange.event, this.iconSchema = {
      definitions: {
        icons: {
          type: "object",
          properties: {
            fontId: { type: "string", description: C("iconDefinition.fontId", "The id of the font to use. If not set, the font that is defined first is used.") },
            fontCharacter: { type: "string", description: C("iconDefinition.fontCharacter", "The font character associated with the icon definition.") }
          },
          additionalProperties: !1,
          defaultSnippets: [{ body: { fontCharacter: "\\\\e030" } }]
        }
      },
      type: "object",
      properties: {}
    }, this.iconReferenceSchema = { type: "string", pattern: `^${Tt.iconNameExpression}$`, enum: [], enumDescriptions: [] }, this.iconsById = {}, this.iconFontsById = {};
  }
  registerIcon(e, t, n, i) {
    const s = this.iconsById[e];
    if (s) {
      if (n && !s.description) {
        s.description = n, this.iconSchema.properties[e].markdownDescription = `${n} $(${e})`;
        const l = this.iconReferenceSchema.enum.indexOf(e);
        l !== -1 && (this.iconReferenceSchema.enumDescriptions[l] = n), this._onDidChange.fire();
      }
      return s;
    }
    const o = { id: e, description: n, defaults: t, deprecationMessage: i };
    this.iconsById[e] = o;
    const a = { $ref: "#/definitions/icons" };
    return i && (a.deprecationMessage = i), n && (a.markdownDescription = `${n}: $(${e})`), this.iconSchema.properties[e] = a, this.iconReferenceSchema.enum.push(e), this.iconReferenceSchema.enumDescriptions.push(n || ""), this._onDidChange.fire(), { id: e };
  }
  getIcons() {
    return Object.keys(this.iconsById).map((e) => this.iconsById[e]);
  }
  getIcon(e) {
    return this.iconsById[e];
  }
  getIconSchema() {
    return this.iconSchema;
  }
  toString() {
    const e = (s, o) => s.id.localeCompare(o.id), t = (s) => {
      for (; Tt.isThemeIcon(s.defaults); )
        s = this.iconsById[s.defaults.id];
      return `codicon codicon-${s ? s.id : ""}`;
    }, n = [];
    n.push("| preview     | identifier                        | default codicon ID                | description"), n.push("| ----------- | --------------------------------- | --------------------------------- | --------------------------------- |");
    const i = Object.keys(this.iconsById).map((s) => this.iconsById[s]);
    for (const s of i.filter((o) => !!o.description).sort(e))
      n.push(`|<i class="${t(s)}"></i>|${s.id}|${Tt.isThemeIcon(s.defaults) ? s.defaults.id : s.id}|${s.description || ""}|`);
    n.push("| preview     | identifier                        "), n.push("| ----------- | --------------------------------- |");
    for (const s of i.filter((o) => !Tt.isThemeIcon(o.defaults)).sort(e))
      n.push(`|<i class="${t(s)}"></i>|${s.id}|`);
    return n.join(`
`);
  }
}
const o2 = new wEt();
Er.add(AEt.IconContribution, o2);
function po(r, e, t, n) {
  return o2.registerIcon(r, e, t, n);
}
function wTe() {
  return o2;
}
function vEt() {
  const r = $Me();
  for (const e in r) {
    const t = "\\" + r[e].toString(16);
    o2.registerIcon(e, { fontCharacter: t });
  }
}
vEt();
const vTe = "vscode://schemas/icons", bTe = Er.as(ey.JSONContribution);
bTe.registerSchema(vTe, o2.getIconSchema());
const z9e = new Nr(() => bTe.notifySchemaChanged(vTe), 200);
o2.onDidChange(() => {
  z9e.isScheduled() || z9e.schedule();
});
const bEt = po("widget-close", ke.close, C("widgetClose", "Icon for the close action in widgets."));
po("goto-previous-location", ke.arrowUp, C("previousChangeIcon", "Icon for goto previous editor location."));
po("goto-next-location", ke.arrowDown, C("nextChangeIcon", "Icon for goto next editor location."));
Tt.modify(ke.sync, "spin");
Tt.modify(ke.loading, "spin");
function yEt(r) {
  const e = new ze(), t = e.add(new $()), n = wTe();
  return e.add(n.onDidChange(() => t.fire())), r && e.add(r.onDidProductIconThemeChange(() => t.fire())), {
    dispose: () => e.dispose(),
    onDidChange: t.event,
    getCSS() {
      const i = r ? r.getProductIconTheme() : new yTe(), s = {}, o = [], a = [];
      for (const l of n.getIcons()) {
        const c = i.getIcon(l);
        if (!c)
          continue;
        const d = c.font, u = `--vscode-icon-${l.id}-font-family`, f = `--vscode-icon-${l.id}-content`;
        d ? (s[d.id] = d.definition, a.push(`${u}: ${DE(d.id)};`, `${f}: '${c.fontCharacter}';`), o.push(`.codicon-${l.id}:before { content: '${c.fontCharacter}'; font-family: ${DE(d.id)}; }`)) : (a.push(`${f}: '${c.fontCharacter}'; ${u}: 'codicon';`), o.push(`.codicon-${l.id}:before { content: '${c.fontCharacter}'; }`));
      }
      for (const l in s) {
        const c = s[l], d = c.weight ? `font-weight: ${c.weight};` : "", u = c.style ? `font-style: ${c.style};` : "", f = c.src.map((p) => `${Pd(p.location)} format('${p.format}')`).join(", ");
        o.push(`@font-face { src: ${f}; font-family: ${DE(l)};${d}${u} font-display: block; }`);
      }
      return o.push(`:root { ${a.join(" ")} }`), o.join(`
`);
    }
  };
}
class yTe {
  getIcon(e) {
    const t = wTe();
    let n = e.defaults;
    for (; Tt.isThemeIcon(n); ) {
      const i = t.getIcon(n.id);
      if (!i)
        return;
      n = i.defaults;
    }
    return n;
  }
}
const Du = "vs", l3 = "vs-dark", Rp = "hc-black", Vp = "hc-light", CTe = Er.as(SLe.ColorContribution), CEt = Er.as(JLe.ThemingContribution);
class ETe {
  constructor(e, t) {
    this.semanticHighlighting = !1, this.themeData = t;
    const n = t.base;
    e.length > 0 ? (R6(e) ? this.id = e : this.id = n + " " + e, this.themeName = e) : (this.id = n, this.themeName = n), this.colors = null, this.defaultColors = /* @__PURE__ */ Object.create(null), this._tokenTheme = null;
  }
  get base() {
    return this.themeData.base;
  }
  notifyBaseUpdated() {
    this.themeData.inherit && (this.colors = null, this._tokenTheme = null);
  }
  getColors() {
    if (!this.colors) {
      const e = /* @__PURE__ */ new Map();
      for (const t in this.themeData.colors)
        e.set(t, ge.fromHex(this.themeData.colors[t]));
      if (this.themeData.inherit) {
        const t = Vk(this.themeData.base);
        for (const n in t.colors)
          e.has(n) || e.set(n, ge.fromHex(t.colors[n]));
      }
      this.colors = e;
    }
    return this.colors;
  }
  getColor(e, t) {
    const n = this.getColors().get(e);
    if (n)
      return n;
    if (t !== !1)
      return this.getDefault(e);
  }
  getDefault(e) {
    let t = this.defaultColors[e];
    return t || (t = CTe.resolveDefaultColor(e, this), this.defaultColors[e] = t, t);
  }
  defines(e) {
    return this.getColors().has(e);
  }
  get type() {
    switch (this.base) {
      case Du:
        return ua.LIGHT;
      case Rp:
        return ua.HIGH_CONTRAST_DARK;
      case Vp:
        return ua.HIGH_CONTRAST_LIGHT;
      default:
        return ua.DARK;
    }
  }
  get tokenTheme() {
    if (!this._tokenTheme) {
      let e = [], t = [];
      if (this.themeData.inherit) {
        const s = Vk(this.themeData.base);
        e = s.rules, s.encodedTokensColors && (t = s.encodedTokensColors);
      }
      const n = this.themeData.colors["editor.foreground"], i = this.themeData.colors["editor.background"];
      if (n || i) {
        const s = { token: "" };
        n && (s.foreground = n), i && (s.background = i), e.push(s);
      }
      e = e.concat(this.themeData.rules), this.themeData.encodedTokensColors && (t = this.themeData.encodedTokensColors), this._tokenTheme = ATe.createFromRawTokenTheme(e, t);
    }
    return this._tokenTheme;
  }
  getTokenStyleMetadata(e, t, n) {
    const s = this.tokenTheme._match([e].concat(t).join(".")).metadata, o = Vl.getForeground(s), a = Vl.getFontStyle(s);
    return {
      foreground: o,
      italic: !!(a & 1),
      bold: !!(a & 2),
      underline: !!(a & 4),
      strikethrough: !!(a & 8)
    };
  }
}
function R6(r) {
  return r === Du || r === l3 || r === Rp || r === Vp;
}
function Vk(r) {
  switch (r) {
    case Du:
      return fEt;
    case l3:
      return pEt;
    case Rp:
      return gEt;
    case Vp:
      return mEt;
  }
}
function a5(r) {
  const e = Vk(r);
  return new ETe(r, e);
}
class EEt extends me {
  constructor() {
    super(), this._onColorThemeChange = this._register(new $()), this.onDidColorThemeChange = this._onColorThemeChange.event, this._onProductIconThemeChange = this._register(new $()), this.onDidProductIconThemeChange = this._onProductIconThemeChange.event, this._environment = /* @__PURE__ */ Object.create(null), this._builtInProductIconTheme = new yTe(), this._autoDetectHighContrast = !0, this._knownThemes = /* @__PURE__ */ new Map(), this._knownThemes.set(Du, a5(Du)), this._knownThemes.set(l3, a5(l3)), this._knownThemes.set(Rp, a5(Rp)), this._knownThemes.set(Vp, a5(Vp));
    const e = this._register(yEt(this));
    this._codiconCSS = e.getCSS(), this._themeCSS = "", this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._globalStyleElement = null, this._styleElements = [], this._colorMapOverride = null, this.setTheme(Du), this._onOSSchemeChanged(), this._register(e.onDidChange(() => {
      this._codiconCSS = e.getCSS(), this._updateCSS();
    })), aDe(Sn, "(forced-colors: active)", () => {
      this._onOSSchemeChanged();
    });
  }
  registerEditorContainer(e) {
    return B8(e) ? this._registerShadowDomContainer(e) : this._registerRegularEditorContainer();
  }
  _registerRegularEditorContainer() {
    return this._globalStyleElement || (this._globalStyleElement = ya(void 0, (e) => {
      e.className = "monaco-colors", e.textContent = this._allCSS;
    }), this._styleElements.push(this._globalStyleElement)), me.None;
  }
  _registerShadowDomContainer(e) {
    const t = ya(e, (n) => {
      n.className = "monaco-colors", n.textContent = this._allCSS;
    });
    return this._styleElements.push(t), {
      dispose: () => {
        for (let n = 0; n < this._styleElements.length; n++)
          if (this._styleElements[n] === t) {
            this._styleElements.splice(n, 1);
            return;
          }
      }
    };
  }
  defineTheme(e, t) {
    if (!/^[a-z0-9\-]+$/i.test(e))
      throw new Error("Illegal theme name!");
    if (!R6(t.base) && !R6(e))
      throw new Error("Illegal theme base!");
    this._knownThemes.set(e, new ETe(e, t)), R6(e) && this._knownThemes.forEach((n) => {
      n.base === e && n.notifyBaseUpdated();
    }), this._theme.themeName === e && this.setTheme(e);
  }
  getColorTheme() {
    return this._theme;
  }
  setColorMapOverride(e) {
    this._colorMapOverride = e, this._updateThemeOrColorMap();
  }
  setTheme(e) {
    let t;
    this._knownThemes.has(e) ? t = this._knownThemes.get(e) : t = this._knownThemes.get(Du), this._updateActualTheme(t);
  }
  _updateActualTheme(e) {
    !e || this._theme === e || (this._theme = e, this._updateThemeOrColorMap());
  }
  _onOSSchemeChanged() {
    if (this._autoDetectHighContrast) {
      const e = Sn.matchMedia("(forced-colors: active)").matches;
      if (e !== $u(this._theme.type)) {
        let t;
        dy(this._theme.type) ? t = e ? Rp : l3 : t = e ? Vp : Du, this._updateActualTheme(this._knownThemes.get(t));
      }
    }
  }
  setAutoDetectHighContrast(e) {
    this._autoDetectHighContrast = e, this._onOSSchemeChanged();
  }
  _updateThemeOrColorMap() {
    const e = [], t = {}, n = {
      addRule: (o) => {
        t[o] || (e.push(o), t[o] = !0);
      }
    };
    CEt.getThemingParticipants().forEach((o) => o(this._theme, n, this._environment));
    const i = [];
    for (const o of CTe.getColors()) {
      const a = this._theme.getColor(o.id, !0);
      a && i.push(`${AO(o.id)}: ${a.toString()};`);
    }
    n.addRule(`.monaco-editor, .monaco-diff-editor, .monaco-component { ${i.join(`
`)} }`);
    const s = this._colorMapOverride || this._theme.tokenTheme.getColorMap();
    n.addRule(uEt(s)), this._themeCSS = e.join(`
`), this._updateCSS(), xi.setColorMap(s), this._onColorThemeChange.fire(this._theme);
  }
  _updateCSS() {
    this._allCSS = `${this._codiconCSS}
${this._themeCSS}`, this._styleElements.forEach((e) => e.textContent = this._allCSS);
  }
  getFileIconTheme() {
    return {
      hasFileIcons: !1,
      hasFolderIcons: !1,
      hidesExplorerArrows: !1
    };
  }
  getProductIconTheme() {
    return this._builtInProductIconTheme;
  }
}
const bl = Wt("themeService");
var _Et = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, N_ = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let Hk = class extends me {
  constructor(e, t, n) {
    super(), this._contextKeyService = e, this._layoutService = t, this._configurationService = n, this._accessibilitySupport = 0, this._onDidChangeScreenReaderOptimized = new $(), this._onDidChangeReducedMotion = new $(), this._onDidChangeLinkUnderline = new $(), this._accessibilityModeEnabledContext = Amt.bindTo(this._contextKeyService);
    const i = () => this._accessibilityModeEnabledContext.set(this.isScreenReaderOptimized());
    this._register(this._configurationService.onDidChangeConfiguration((o) => {
      o.affectsConfiguration("editor.accessibilitySupport") && (i(), this._onDidChangeScreenReaderOptimized.fire()), o.affectsConfiguration("workbench.reduceMotion") && (this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this._onDidChangeReducedMotion.fire());
    })), i(), this._register(this.onDidChangeScreenReaderOptimized(() => i()));
    const s = Sn.matchMedia("(prefers-reduced-motion: reduce)");
    this._systemMotionReduced = s.matches, this._configMotionReduced = this._configurationService.getValue("workbench.reduceMotion"), this._linkUnderlinesEnabled = this._configurationService.getValue("accessibility.underlineLinks"), this.initReducedMotionListeners(s), this.initLinkUnderlineListeners();
  }
  initReducedMotionListeners(e) {
    this._register(fe(e, "change", () => {
      this._systemMotionReduced = e.matches, this._configMotionReduced === "auto" && this._onDidChangeReducedMotion.fire();
    }));
    const t = () => {
      const n = this.isMotionReduced();
      this._layoutService.mainContainer.classList.toggle("reduce-motion", n), this._layoutService.mainContainer.classList.toggle("enable-motion", !n);
    };
    t(), this._register(this.onDidChangeReducedMotion(() => t()));
  }
  initLinkUnderlineListeners() {
    this._register(this._configurationService.onDidChangeConfiguration((t) => {
      if (t.affectsConfiguration("accessibility.underlineLinks")) {
        const n = this._configurationService.getValue("accessibility.underlineLinks");
        this._linkUnderlinesEnabled = n, this._onDidChangeLinkUnderline.fire();
      }
    }));
    const e = () => {
      const t = this._linkUnderlinesEnabled;
      this._layoutService.mainContainer.classList.toggle("underline-links", t);
    };
    e(), this._register(this.onDidChangeLinkUnderlines(() => e()));
  }
  onDidChangeLinkUnderlines(e) {
    return this._onDidChangeLinkUnderline.event(e);
  }
  get onDidChangeScreenReaderOptimized() {
    return this._onDidChangeScreenReaderOptimized.event;
  }
  isScreenReaderOptimized() {
    const e = this._configurationService.getValue("editor.accessibilitySupport");
    return e === "on" || e === "auto" && this._accessibilitySupport === 2;
  }
  get onDidChangeReducedMotion() {
    return this._onDidChangeReducedMotion.event;
  }
  isMotionReduced() {
    const e = this._configMotionReduced;
    return e === "on" || e === "auto" && this._systemMotionReduced;
  }
  getAccessibilitySupport() {
    return this._accessibilitySupport;
  }
};
Hk = _Et([
  N_(0, sn),
  N_(1, R1),
  N_(2, Ai)
], Hk);
var Fy = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, sh = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, B2, EA;
let Bk = class {
  constructor(e, t, n) {
    this._commandService = e, this._keybindingService = t, this._hiddenStates = new Pk(n);
  }
  createMenu(e, t, n) {
    return new eb(e, this._hiddenStates, { emitEventsForSubmenuChanges: !1, eventDebounceDelay: 50, ...n }, this._commandService, this._keybindingService, t);
  }
  getMenuActions(e, t, n) {
    const i = new eb(e, this._hiddenStates, { emitEventsForSubmenuChanges: !1, eventDebounceDelay: 50, ...n }, this._commandService, this._keybindingService, t), s = i.getActions(n);
    return i.dispose(), s;
  }
  resetHiddenStates(e) {
    this._hiddenStates.reset(e);
  }
};
Bk = Fy([
  sh(0, jo),
  sh(1, _r),
  sh(2, am)
], Bk);
let Pk = class {
  static {
    B2 = this;
  }
  static {
    this._key = "menu.hiddenCommands";
  }
  constructor(e) {
    this._storageService = e, this._disposables = new ze(), this._onDidChange = new $(), this.onDidChange = this._onDidChange.event, this._ignoreChangeEvent = !1, this._hiddenByDefaultCache = /* @__PURE__ */ new Map();
    try {
      const t = e.get(B2._key, 0, "{}");
      this._data = JSON.parse(t);
    } catch {
      this._data = /* @__PURE__ */ Object.create(null);
    }
    this._disposables.add(e.onDidChangeValue(0, B2._key, this._disposables)(() => {
      if (!this._ignoreChangeEvent)
        try {
          const t = e.get(B2._key, 0, "{}");
          this._data = JSON.parse(t);
        } catch (t) {
          console.log("FAILED to read storage after UPDATE", t);
        }
      this._onDidChange.fire();
    }));
  }
  dispose() {
    this._onDidChange.dispose(), this._disposables.dispose();
  }
  _isHiddenByDefault(e, t) {
    return this._hiddenByDefaultCache.get(`${e.id}/${t}`) ?? !1;
  }
  setDefaultState(e, t, n) {
    this._hiddenByDefaultCache.set(`${e.id}/${t}`, n);
  }
  isHidden(e, t) {
    const n = this._isHiddenByDefault(e, t), i = this._data[e.id]?.includes(t) ?? !1;
    return n ? !i : i;
  }
  updateHidden(e, t, n) {
    this._isHiddenByDefault(e, t) && (n = !n);
    const s = this._data[e.id];
    if (n)
      s ? s.indexOf(t) < 0 && s.push(t) : this._data[e.id] = [t];
    else if (s) {
      const o = s.indexOf(t);
      o >= 0 && aut(s, o), s.length === 0 && delete this._data[e.id];
    }
    this._persist();
  }
  reset(e) {
    if (e === void 0)
      this._data = /* @__PURE__ */ Object.create(null), this._persist();
    else {
      for (const { id: t } of e)
        this._data[t] && delete this._data[t];
      this._persist();
    }
  }
  _persist() {
    try {
      this._ignoreChangeEvent = !0;
      const e = JSON.stringify(this._data);
      this._storageService.store(
        B2._key,
        e,
        0,
        0
        /* StorageTarget.USER */
      );
    } finally {
      this._ignoreChangeEvent = !1;
    }
  }
};
Pk = B2 = Fy([
  sh(0, am)
], Pk);
class c3 {
  constructor(e, t) {
    this._id = e, this._collectContextKeysForSubmenus = t, this._menuGroups = [], this._structureContextKeys = /* @__PURE__ */ new Set(), this._preconditionContextKeys = /* @__PURE__ */ new Set(), this._toggledContextKeys = /* @__PURE__ */ new Set(), this.refresh();
  }
  get structureContextKeys() {
    return this._structureContextKeys;
  }
  get preconditionContextKeys() {
    return this._preconditionContextKeys;
  }
  get toggledContextKeys() {
    return this._toggledContextKeys;
  }
  refresh() {
    this._menuGroups.length = 0, this._structureContextKeys.clear(), this._preconditionContextKeys.clear(), this._toggledContextKeys.clear();
    const e = this._sort(og.getMenuItems(this._id));
    let t;
    for (const n of e) {
      const i = n.group || "";
      (!t || t[0] !== i) && (t = [i, []], this._menuGroups.push(t)), t[1].push(n), this._collectContextKeys(n);
    }
  }
  _sort(e) {
    return e;
  }
  _collectContextKeys(e) {
    if (c3._fillInKbExprKeys(e.when, this._structureContextKeys), PA(e)) {
      if (e.command.precondition && c3._fillInKbExprKeys(e.command.precondition, this._preconditionContextKeys), e.command.toggled) {
        const t = e.command.toggled.condition || e.command.toggled;
        c3._fillInKbExprKeys(t, this._toggledContextKeys);
      }
    } else this._collectContextKeysForSubmenus && og.getMenuItems(e.submenu).forEach(this._collectContextKeys, this);
  }
  static _fillInKbExprKeys(e, t) {
    if (e)
      for (const n of e.keys())
        t.add(n);
  }
}
let Fk = EA = class extends c3 {
  constructor(e, t, n, i, s, o) {
    super(e, n), this._hiddenStates = t, this._commandService = i, this._keybindingService = s, this._contextKeyService = o, this.refresh();
  }
  createActionGroups(e) {
    const t = [];
    for (const n of this._menuGroups) {
      const [i, s] = n;
      let o;
      for (const a of s)
        if (this._contextKeyService.contextMatchesRules(a.when)) {
          const l = PA(a);
          l && this._hiddenStates.setDefaultState(this._id, a.command.id, !!a.isHiddenByDefault);
          const c = xEt(this._id, l ? a.command : a, this._hiddenStates);
          if (l) {
            const d = _Te(this._commandService, this._keybindingService, a.command.id, a.when);
            (o ??= []).push(new _d(a.command, a.alt, e, c, d, this._contextKeyService, this._commandService));
          } else {
            const d = new EA(a.submenu, this._hiddenStates, this._collectContextKeysForSubmenus, this._commandService, this._keybindingService, this._contextKeyService).createActionGroups(e), u = Pr.join(...d.map((f) => f[1]));
            u.length > 0 && (o ??= []).push(new FA(a, c, u));
          }
        }
      o && o.length > 0 && t.push([i, o]);
    }
    return t;
  }
  _sort(e) {
    return e.sort(EA._compareMenuItems);
  }
  static _compareMenuItems(e, t) {
    const n = e.group, i = t.group;
    if (n !== i) {
      if (n) {
        if (!i)
          return -1;
      } else return 1;
      if (n === "navigation")
        return -1;
      if (i === "navigation")
        return 1;
      const a = n.localeCompare(i);
      if (a !== 0)
        return a;
    }
    const s = e.order || 0, o = t.order || 0;
    return s < o ? -1 : s > o ? 1 : EA._compareTitles(PA(e) ? e.command.title : e.title, PA(t) ? t.command.title : t.title);
  }
  static _compareTitles(e, t) {
    const n = typeof e == "string" ? e : e.original, i = typeof t == "string" ? t : t.original;
    return n.localeCompare(i);
  }
};
Fk = EA = Fy([
  sh(3, jo),
  sh(4, _r),
  sh(5, sn)
], Fk);
let eb = class {
  constructor(e, t, n, i, s, o) {
    this._disposables = new ze(), this._menuInfo = new Fk(e, t, n.emitEventsForSubmenuChanges, i, s, o);
    const a = new Nr(() => {
      this._menuInfo.refresh(), this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !0, isToggleChange: !0 });
    }, n.eventDebounceDelay);
    this._disposables.add(a), this._disposables.add(og.onDidChangeMenu((u) => {
      u.has(e) && a.schedule();
    }));
    const l = this._disposables.add(new ze()), c = (u) => {
      let f = !1, p = !1, g = !1;
      for (const m of u)
        if (f = f || m.isStructuralChange, p = p || m.isEnablementChange, g = g || m.isToggleChange, f && p && g)
          break;
      return { menu: this, isStructuralChange: f, isEnablementChange: p, isToggleChange: g };
    }, d = () => {
      l.add(o.onDidChangeContext((u) => {
        const f = u.affectsSome(this._menuInfo.structureContextKeys), p = u.affectsSome(this._menuInfo.preconditionContextKeys), g = u.affectsSome(this._menuInfo.toggledContextKeys);
        (f || p || g) && this._onDidChange.fire({ menu: this, isStructuralChange: f, isEnablementChange: p, isToggleChange: g });
      })), l.add(t.onDidChange((u) => {
        this._onDidChange.fire({ menu: this, isStructuralChange: !0, isEnablementChange: !1, isToggleChange: !1 });
      }));
    };
    this._onDidChange = new jMe({
      // start/stop context key listener
      onWillAddFirstListener: d,
      onDidRemoveLastListener: l.clear.bind(l),
      delay: n.eventDebounceDelay,
      merge: c
    }), this.onDidChange = this._onDidChange.event;
  }
  getActions(e) {
    return this._menuInfo.createActionGroups(e);
  }
  dispose() {
    this._disposables.dispose(), this._onDidChange.dispose();
  }
};
eb = Fy([
  sh(3, jo),
  sh(4, _r),
  sh(5, sn)
], eb);
function xEt(r, e, t) {
  const n = b2t(e) ? e.submenu.id : e.id, i = typeof e.title == "string" ? e.title : e.title.value, s = Ap({
    id: `hide/${r.id}/${n}`,
    label: C("hide.label", "Hide '{0}'", i),
    run() {
      t.updateHidden(r, n, !0);
    }
  }), o = Ap({
    id: `toggle/${r.id}/${n}`,
    label: i,
    get checked() {
      return !t.isHidden(r, n);
    },
    run() {
      t.updateHidden(r, n, !!this.checked);
    }
  });
  return {
    hide: s,
    toggle: o,
    get isHidden() {
      return !o.checked;
    }
  };
}
function _Te(r, e, t, n = void 0, i = !0) {
  return Ap({
    id: `configureKeybinding/${t}`,
    label: C("configure keybinding", "Configure Keybinding"),
    enabled: i,
    run() {
      const o = !!!e.lookupKeybinding(t) && n ? n.serialize() : void 0;
      r.executeCommand("workbench.action.openGlobalKeybindings", `@command:${t}` + (o ? ` +when:${o}` : ""));
    }
  });
}
var SEt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, W9e = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, zk;
let Wk = class extends me {
  static {
    zk = this;
  }
  constructor(e, t) {
    super(), this.layoutService = e, this.logService = t, this.mapTextToType = /* @__PURE__ */ new Map(), this.findText = "", this.resources = [], this.resourcesStateHash = void 0, (l1 || lDe) && this.installWebKitWriteTextWorkaround(), this._register(xe.runAndSubscribe(B7, ({ window: n, disposables: i }) => {
      i.add(fe(n.document, "copy", () => this.clearResources()));
    }, { window: Sn, disposables: this._store }));
  }
  // In Safari, it has the following note:
  //
  // "The request to write to the clipboard must be triggered during a user gesture.
  // A call to clipboard.write or clipboard.writeText outside the scope of a user
  // gesture(such as "click" or "touch" event handlers) will result in the immediate
  // rejection of the promise returned by the API call."
  // From: https://webkit.org/blog/10855/async-clipboard-api/
  //
  // Since extensions run in a web worker, and handle gestures in an asynchronous way,
  // they are not classified by Safari as "in response to a user gesture" and will reject.
  //
  // This function sets up some handlers to work around that behavior.
  installWebKitWriteTextWorkaround() {
    const e = () => {
      const t = new pDe();
      this.webKitPendingClipboardWritePromise && !this.webKitPendingClipboardWritePromise.isSettled && this.webKitPendingClipboardWritePromise.cancel(), this.webKitPendingClipboardWritePromise = t, g6().navigator.clipboard.write([new ClipboardItem({
        "text/plain": t.p
      })]).catch(async (n) => {
        (!(n instanceof Error) || n.name !== "NotAllowedError" || !t.isRejected) && this.logService.error(n);
      });
    };
    this._register(xe.runAndSubscribe(this.layoutService.onDidAddContainer, ({ container: t, disposables: n }) => {
      n.add(fe(t, "click", e)), n.add(fe(t, "keydown", e));
    }, { container: this.layoutService.mainContainer, disposables: this._store }));
  }
  async writeText(e, t) {
    if (this.writeResources([]), t) {
      this.mapTextToType.set(t, e);
      return;
    }
    if (this.webKitPendingClipboardWritePromise)
      return this.webKitPendingClipboardWritePromise.complete(e);
    try {
      return await g6().navigator.clipboard.writeText(e);
    } catch (n) {
      console.error(n);
    }
    this.fallbackWriteText(e);
  }
  fallbackWriteText(e) {
    const t = GI(), n = t.activeElement, i = t.body.appendChild($e("textarea", { "aria-hidden": !0 }));
    i.style.height = "1px", i.style.width = "1px", i.style.position = "absolute", i.value = e, i.focus(), i.select(), t.execCommand("copy"), wr(n) && n.focus(), i.remove();
  }
  async readText(e) {
    if (e)
      return this.mapTextToType.get(e) || "";
    try {
      return await g6().navigator.clipboard.readText();
    } catch (t) {
      console.error(t);
    }
    return "";
  }
  async readFindText() {
    return this.findText;
  }
  async writeFindText(e) {
    this.findText = e;
  }
  static {
    this.MAX_RESOURCE_STATE_SOURCE_LENGTH = 1e3;
  }
  async writeResources(e) {
    e.length === 0 ? this.clearResources() : (this.resources = e, this.resourcesStateHash = await this.computeResourcesStateHash());
  }
  async readResources() {
    const e = await this.computeResourcesStateHash();
    return this.resourcesStateHash !== e && this.clearResources(), this.resources;
  }
  async computeResourcesStateHash() {
    if (this.resources.length === 0)
      return;
    const e = await this.readText();
    return _De(e.substring(0, zk.MAX_RESOURCE_STATE_SOURCE_LENGTH));
  }
  clearResources() {
    this.resources = [], this.resourcesStateHash = void 0;
  }
};
Wk = zk = SEt([
  W9e(0, R1),
  W9e(1, _h)
], Wk);
const Fw = Wt("clipboardService");
var MEt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, DEt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const h3 = "data-keybinding-context";
let GR = class {
  constructor(e, t) {
    this._id = e, this._parent = t, this._value = /* @__PURE__ */ Object.create(null), this._value._contextId = e;
  }
  get value() {
    return { ...this._value };
  }
  setValue(e, t) {
    return this._value[e] !== t ? (this._value[e] = t, !0) : !1;
  }
  removeValue(e) {
    return e in this._value ? (delete this._value[e], !0) : !1;
  }
  getValue(e) {
    const t = this._value[e];
    return typeof t > "u" && this._parent ? this._parent.getValue(e) : t;
  }
};
class Cg extends GR {
  static {
    this.INSTANCE = new Cg();
  }
  constructor() {
    super(-1, null);
  }
  setValue(e, t) {
    return !1;
  }
  removeValue(e) {
    return !1;
  }
  getValue(e) {
  }
}
class tb extends GR {
  static {
    this._keyPrefix = "config.";
  }
  constructor(e, t, n) {
    super(e, null), this._configurationService = t, this._values = r3.forConfigKeys(), this._listener = this._configurationService.onDidChangeConfiguration((i) => {
      if (i.source === 7) {
        const s = Array.from(this._values, ([o]) => o);
        this._values.clear(), n.fire(new Z9e(s));
      } else {
        const s = [];
        for (const o of i.affectedKeys) {
          const a = `config.${o}`, l = this._values.findSuperstr(a);
          l !== void 0 && (s.push(...Jt.map(l, ([c]) => c)), this._values.deleteSuperstr(a)), this._values.has(a) && (s.push(a), this._values.delete(a));
        }
        n.fire(new Z9e(s));
      }
    });
  }
  dispose() {
    this._listener.dispose();
  }
  getValue(e) {
    if (e.indexOf(tb._keyPrefix) !== 0)
      return super.getValue(e);
    if (this._values.has(e))
      return this._values.get(e);
    const t = e.substr(tb._keyPrefix.length), n = this._configurationService.getValue(t);
    let i;
    switch (typeof n) {
      case "number":
      case "boolean":
      case "string":
        i = n;
        break;
      default:
        Array.isArray(n) ? i = JSON.stringify(n) : i = n;
    }
    return this._values.set(e, i), i;
  }
  setValue(e, t) {
    return super.setValue(e, t);
  }
  removeValue(e) {
    return super.removeValue(e);
  }
}
class LEt {
  constructor(e, t, n) {
    this._service = e, this._key = t, this._defaultValue = n, this.reset();
  }
  set(e) {
    this._service.setContext(this._key, e);
  }
  reset() {
    typeof this._defaultValue > "u" ? this._service.removeContext(this._key) : this._service.setContext(this._key, this._defaultValue);
  }
  get() {
    return this._service.getContextKeyValue(this._key);
  }
}
class j9e {
  constructor(e) {
    this.key = e;
  }
  affectsSome(e) {
    return e.has(this.key);
  }
  allKeysContainedIn(e) {
    return this.affectsSome(e);
  }
}
class Z9e {
  constructor(e) {
    this.keys = e;
  }
  affectsSome(e) {
    for (const t of this.keys)
      if (e.has(t))
        return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.keys.every((t) => e.has(t));
  }
}
class kEt {
  constructor(e) {
    this.events = e;
  }
  affectsSome(e) {
    for (const t of this.events)
      if (t.affectsSome(e))
        return !0;
    return !1;
  }
  allKeysContainedIn(e) {
    return this.events.every((t) => t.allKeysContainedIn(e));
  }
}
function NEt(r, e) {
  return r.allKeysContainedIn(new Set(Object.keys(e)));
}
class xTe extends me {
  constructor(e) {
    super(), this._onDidChangeContext = this._register(new R3({ merge: (t) => new kEt(t) })), this.onDidChangeContext = this._onDidChangeContext.event, this._isDisposed = !1, this._myContextId = e;
  }
  createKey(e, t) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    return new LEt(this, e, t);
  }
  bufferChangeEvents(e) {
    this._onDidChangeContext.pause();
    try {
      e();
    } finally {
      this._onDidChangeContext.resume();
    }
  }
  createScoped(e) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    return new TEt(this, e);
  }
  contextMatchesRules(e) {
    if (this._isDisposed)
      throw new Error("AbstractContextKeyService has been disposed");
    const t = this.getContextValuesContainer(this._myContextId);
    return e ? e.evaluate(t) : !0;
  }
  getContextKeyValue(e) {
    if (!this._isDisposed)
      return this.getContextValuesContainer(this._myContextId).getValue(e);
  }
  setContext(e, t) {
    if (this._isDisposed)
      return;
    const n = this.getContextValuesContainer(this._myContextId);
    n && n.setValue(e, t) && this._onDidChangeContext.fire(new j9e(e));
  }
  removeContext(e) {
    this._isDisposed || this.getContextValuesContainer(this._myContextId).removeValue(e) && this._onDidChangeContext.fire(new j9e(e));
  }
  getContext(e) {
    return this._isDisposed ? Cg.INSTANCE : this.getContextValuesContainer(IEt(e));
  }
  dispose() {
    super.dispose(), this._isDisposed = !0;
  }
}
let jk = class extends xTe {
  constructor(e) {
    super(0), this._contexts = /* @__PURE__ */ new Map(), this._lastContextId = 0;
    const t = this._register(new tb(this._myContextId, e, this._onDidChangeContext));
    this._contexts.set(this._myContextId, t);
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? Cg.INSTANCE : this._contexts.get(e) || Cg.INSTANCE;
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed)
      throw new Error("ContextKeyService has been disposed");
    const t = ++this._lastContextId;
    return this._contexts.set(t, new GR(t, this.getContextValuesContainer(e))), t;
  }
  disposeContext(e) {
    this._isDisposed || this._contexts.delete(e);
  }
};
jk = MEt([
  DEt(0, Ai)
], jk);
class TEt extends xTe {
  constructor(e, t) {
    if (super(e.createChildContext()), this._parentChangeListener = this._register(new Bd()), this._parent = e, this._updateParentChangeListener(), this._domNode = t, this._domNode.hasAttribute(h3)) {
      let n = "";
      this._domNode.classList && (n = Array.from(this._domNode.classList.values()).join(", ")), console.error(`Element already has context attribute${n ? ": " + n : ""}`);
    }
    this._domNode.setAttribute(h3, String(this._myContextId));
  }
  _updateParentChangeListener() {
    this._parentChangeListener.value = this._parent.onDidChangeContext((e) => {
      const n = this._parent.getContextValuesContainer(this._myContextId).value;
      NEt(e, n) || this._onDidChangeContext.fire(e);
    });
  }
  dispose() {
    this._isDisposed || (this._parent.disposeContext(this._myContextId), this._domNode.removeAttribute(h3), super.dispose());
  }
  getContextValuesContainer(e) {
    return this._isDisposed ? Cg.INSTANCE : this._parent.getContextValuesContainer(e);
  }
  createChildContext(e = this._myContextId) {
    if (this._isDisposed)
      throw new Error("ScopedContextKeyService has been disposed");
    return this._parent.createChildContext(e);
  }
  disposeContext(e) {
    this._isDisposed || this._parent.disposeContext(e);
  }
}
function IEt(r) {
  for (; r; ) {
    if (r.hasAttribute(h3)) {
      const e = r.getAttribute(h3);
      return e ? parseInt(e, 10) : NaN;
    }
    r = r.parentElement;
  }
  return 0;
}
function OEt(r, e, t) {
  r.get(sn).createKey(String(e), REt(t));
}
function REt(r) {
  return LMe(r, (e) => {
    if (typeof e == "object" && e.$mid === 1)
      return Pt.revive(e).toString();
    if (e instanceof Pt)
      return e.toString();
  });
}
Zs.registerCommand("_setContext", OEt);
Zs.registerCommand({
  id: "getContextKeyInfo",
  handler() {
    return [...Ve.all()].sort((r, e) => r.key.localeCompare(e.key));
  },
  metadata: {
    description: C("getContextKeyInfo", "A command that returns information about context keys"),
    args: []
  }
});
Zs.registerCommand("_generateContextKeyInfo", function() {
  const r = [], e = /* @__PURE__ */ new Set();
  for (const t of Ve.all())
    e.has(t.key) || (e.add(t.key), r.push(t));
  r.sort((t, n) => t.key.localeCompare(n.key)), console.log(JSON.stringify(r, void 0, 2));
});
let VEt = class {
  constructor(e, t) {
    this.key = e, this.data = t, this.incoming = /* @__PURE__ */ new Map(), this.outgoing = /* @__PURE__ */ new Map();
  }
};
class U9e {
  constructor(e) {
    this._hashFn = e, this._nodes = /* @__PURE__ */ new Map();
  }
  roots() {
    const e = [];
    for (const t of this._nodes.values())
      t.outgoing.size === 0 && e.push(t);
    return e;
  }
  insertEdge(e, t) {
    const n = this.lookupOrInsertNode(e), i = this.lookupOrInsertNode(t);
    n.outgoing.set(i.key, i), i.incoming.set(n.key, n);
  }
  removeNode(e) {
    const t = this._hashFn(e);
    this._nodes.delete(t);
    for (const n of this._nodes.values())
      n.outgoing.delete(t), n.incoming.delete(t);
  }
  lookupOrInsertNode(e) {
    const t = this._hashFn(e);
    let n = this._nodes.get(t);
    return n || (n = new VEt(t, e), this._nodes.set(t, n)), n;
  }
  isEmpty() {
    return this._nodes.size === 0;
  }
  toString() {
    const e = [];
    for (const [t, n] of this._nodes)
      e.push(`${t}
	(-> incoming)[${[...n.incoming.keys()].join(", ")}]
	(outgoing ->)[${[...n.outgoing.keys()].join(",")}]
`);
    return e.join(`
`);
  }
  /**
   * This is brute force and slow and **only** be used
   * to trouble shoot.
   */
  findCycleSlow() {
    for (const [e, t] of this._nodes) {
      const n = /* @__PURE__ */ new Set([e]), i = this._findCycle(t, n);
      if (i)
        return i;
    }
  }
  _findCycle(e, t) {
    for (const [n, i] of e.outgoing) {
      if (t.has(n))
        return [...t, n].join(" -> ");
      t.add(n);
      const s = this._findCycle(i, t);
      if (s)
        return s;
      t.delete(n);
    }
  }
}
const HEt = !1;
class q9e extends Error {
  constructor(e) {
    super("cyclic dependency between services"), this.message = e.findCycleSlow() ?? `UNABLE to detect cycle, dumping graph: 
${e.toString()}`;
  }
}
class nb {
  constructor(e = new Nw(), t = !1, n, i = HEt) {
    this._services = e, this._strict = t, this._parent = n, this._enableTracing = i, this._isDisposed = !1, this._servicesToMaybeDispose = /* @__PURE__ */ new Set(), this._children = /* @__PURE__ */ new Set(), this._activeInstantiations = /* @__PURE__ */ new Set(), this._services.set(xn, this), this._globalGraph = i ? n?._globalGraph ?? new U9e((s) => s) : void 0;
  }
  dispose() {
    if (!this._isDisposed) {
      this._isDisposed = !0, br(this._children), this._children.clear();
      for (const e of this._servicesToMaybeDispose)
        zMe(e) && e.dispose();
      this._servicesToMaybeDispose.clear();
    }
  }
  _throwIfDisposed() {
    if (this._isDisposed)
      throw new Error("InstantiationService has been disposed");
  }
  createChild(e, t) {
    this._throwIfDisposed();
    const n = this, i = new class extends nb {
      dispose() {
        n._children.delete(i), super.dispose();
      }
    }(e, this._strict, this, this._enableTracing);
    return this._children.add(i), t?.add(i), i;
  }
  invokeFunction(e, ...t) {
    this._throwIfDisposed();
    const n = Jo.traceInvocation(this._enableTracing, e);
    let i = !1;
    try {
      return e({
        get: (o) => {
          if (i)
            throw SI("service accessor is only valid during the invocation of its target method");
          const a = this._getOrCreateServiceInstance(o, n);
          if (!a)
            throw new Error(`[invokeFunction] unknown service '${o}'`);
          return a;
        }
      }, ...t);
    } finally {
      i = !0, n.stop();
    }
  }
  createInstance(e, ...t) {
    this._throwIfDisposed();
    let n, i;
    return e instanceof jc ? (n = Jo.traceCreation(this._enableTracing, e.ctor), i = this._createInstance(e.ctor, e.staticArguments.concat(t), n)) : (n = Jo.traceCreation(this._enableTracing, e), i = this._createInstance(e, t, n)), n.stop(), i;
  }
  _createInstance(e, t = [], n) {
    const i = Wl.getServiceDependencies(e).sort((a, l) => a.index - l.index), s = [];
    for (const a of i) {
      const l = this._getOrCreateServiceInstance(a.id, n);
      l || this._throwIfStrict(`[createInstance] ${e.name} depends on UNKNOWN service ${a.id}.`, !1), s.push(l);
    }
    const o = i.length > 0 ? i[0].index : t.length;
    if (t.length !== o) {
      console.trace(`[createInstance] First service dependency of ${e.name} at position ${o + 1} conflicts with ${t.length} static arguments`);
      const a = o - t.length;
      a > 0 ? t = t.concat(new Array(a)) : t = t.slice(0, o);
    }
    return Reflect.construct(e, t.concat(s));
  }
  _setCreatedServiceInstance(e, t) {
    if (this._services.get(e) instanceof jc)
      this._services.set(e, t);
    else if (this._parent)
      this._parent._setCreatedServiceInstance(e, t);
    else
      throw new Error("illegalState - setting UNKNOWN service instance");
  }
  _getServiceInstanceOrDescriptor(e) {
    const t = this._services.get(e);
    return !t && this._parent ? this._parent._getServiceInstanceOrDescriptor(e) : t;
  }
  _getOrCreateServiceInstance(e, t) {
    this._globalGraph && this._globalGraphImplicitDependency && this._globalGraph.insertEdge(this._globalGraphImplicitDependency, String(e));
    const n = this._getServiceInstanceOrDescriptor(e);
    return n instanceof jc ? this._safeCreateAndCacheServiceInstance(e, n, t.branch(e, !0)) : (t.branch(e, !1), n);
  }
  _safeCreateAndCacheServiceInstance(e, t, n) {
    if (this._activeInstantiations.has(e))
      throw new Error(`illegal state - RECURSIVELY instantiating service '${e}'`);
    this._activeInstantiations.add(e);
    try {
      return this._createAndCacheServiceInstance(e, t, n);
    } finally {
      this._activeInstantiations.delete(e);
    }
  }
  _createAndCacheServiceInstance(e, t, n) {
    const i = new U9e((l) => l.id.toString());
    let s = 0;
    const o = [{ id: e, desc: t, _trace: n }], a = /* @__PURE__ */ new Set();
    for (; o.length; ) {
      const l = o.pop();
      if (!a.has(String(l.id))) {
        if (a.add(String(l.id)), i.lookupOrInsertNode(l), s++ > 1e3)
          throw new q9e(i);
        for (const c of Wl.getServiceDependencies(l.desc.ctor)) {
          const d = this._getServiceInstanceOrDescriptor(c.id);
          if (d || this._throwIfStrict(`[createInstance] ${e} depends on ${c.id} which is NOT registered.`, !0), this._globalGraph?.insertEdge(String(l.id), String(c.id)), d instanceof jc) {
            const u = { id: c.id, desc: d, _trace: l._trace.branch(c.id, !0) };
            i.insertEdge(l, u), o.push(u);
          }
        }
      }
    }
    for (; ; ) {
      const l = i.roots();
      if (l.length === 0) {
        if (!i.isEmpty())
          throw new q9e(i);
        break;
      }
      for (const { data: c } of l) {
        if (this._getServiceInstanceOrDescriptor(c.id) instanceof jc) {
          const u = this._createServiceInstanceWithOwner(c.id, c.desc.ctor, c.desc.staticArguments, c.desc.supportsDelayedInstantiation, c._trace);
          this._setCreatedServiceInstance(c.id, u);
        }
        i.removeNode(c);
      }
    }
    return this._getServiceInstanceOrDescriptor(e);
  }
  _createServiceInstanceWithOwner(e, t, n = [], i, s) {
    if (this._services.get(e) instanceof jc)
      return this._createServiceInstance(e, t, n, i, s, this._servicesToMaybeDispose);
    if (this._parent)
      return this._parent._createServiceInstanceWithOwner(e, t, n, i, s);
    throw new Error(`illegalState - creating UNKNOWN service instance ${t.name}`);
  }
  _createServiceInstance(e, t, n = [], i, s, o) {
    if (i) {
      const a = new nb(void 0, this._strict, this, this._enableTracing);
      a._globalGraphImplicitDependency = String(e);
      const l = /* @__PURE__ */ new Map(), c = new Y0t(() => {
        const d = a._createInstance(t, n, s);
        for (const [u, f] of l) {
          const p = d[u];
          if (typeof p == "function")
            for (const g of f)
              g.disposable = p.apply(d, g.listener);
        }
        return l.clear(), o.add(d), d;
      });
      return new Proxy(/* @__PURE__ */ Object.create(null), {
        get(d, u) {
          if (!c.isInitialized && typeof u == "string" && (u.startsWith("onDid") || u.startsWith("onWill"))) {
            let g = l.get(u);
            return g || (g = new no(), l.set(u, g)), (A, w, v) => {
              if (c.isInitialized)
                return c.value[u](A, w, v);
              {
                const y = { listener: [A, w, v], disposable: void 0 }, _ = g.push(y);
                return ht(() => {
                  _(), y.disposable?.dispose();
                });
              }
            };
          }
          if (u in d)
            return d[u];
          const f = c.value;
          let p = f[u];
          return typeof p != "function" || (p = p.bind(f), d[u] = p), p;
        },
        set(d, u, f) {
          return c.value[u] = f, !0;
        },
        getPrototypeOf(d) {
          return t.prototype;
        }
      });
    } else {
      const a = this._createInstance(t, n, s);
      return o.add(a), a;
    }
  }
  _throwIfStrict(e, t) {
    if (t && console.warn(e), this._strict)
      throw new Error(e);
  }
}
class Jo {
  static {
    this.all = /* @__PURE__ */ new Set();
  }
  static {
    this._None = new class extends Jo {
      constructor() {
        super(0, null);
      }
      stop() {
      }
      branch() {
        return this;
      }
    }();
  }
  static traceInvocation(e, t) {
    return e ? new Jo(2, t.name || new Error().stack.split(`
`).slice(3, 4).join(`
`)) : Jo._None;
  }
  static traceCreation(e, t) {
    return e ? new Jo(1, t.name) : Jo._None;
  }
  static {
    this._totals = 0;
  }
  constructor(e, t) {
    this.type = e, this.name = t, this._start = Date.now(), this._dep = [];
  }
  branch(e, t) {
    const n = new Jo(3, e.toString());
    return this._dep.push([e, t, n]), n;
  }
  stop() {
    const e = Date.now() - this._start;
    Jo._totals += e;
    let t = !1;
    function n(s, o) {
      const a = [], l = new Array(s + 1).join("	");
      for (const [c, d, u] of o._dep)
        if (d && u) {
          t = !0, a.push(`${l}CREATES -> ${c}`);
          const f = n(s + 1, u);
          f && a.push(f);
        } else
          a.push(`${l}uses -> ${c}`);
      return a.join(`
`);
    }
    const i = [
      `${this.type === 1 ? "CREATE" : "CALL"} ${this.name}`,
      `${n(1, this)}`,
      `DONE, took ${e.toFixed(2)}ms (grand total ${Jo._totals.toFixed(2)}ms)`
    ];
    (e > 2 || t) && Jo.all.add(i.join(`
`));
  }
}
const BEt = /* @__PURE__ */ new Set([
  Ct.inMemory,
  Ct.vscodeSourceControl,
  Ct.walkThrough,
  Ct.walkThroughSnippet,
  Ct.vscodeChatCodeBlock,
  Ct.vscodeCopilotBackingChatCodeBlock
]);
class PEt {
  constructor() {
    this._byResource = new ws(), this._byOwner = /* @__PURE__ */ new Map();
  }
  set(e, t, n) {
    let i = this._byResource.get(e);
    i || (i = /* @__PURE__ */ new Map(), this._byResource.set(e, i)), i.set(t, n);
    let s = this._byOwner.get(t);
    s || (s = new ws(), this._byOwner.set(t, s)), s.set(e, n);
  }
  get(e, t) {
    return this._byResource.get(e)?.get(t);
  }
  delete(e, t) {
    let n = !1, i = !1;
    const s = this._byResource.get(e);
    s && (n = s.delete(t));
    const o = this._byOwner.get(t);
    if (o && (i = o.delete(e)), n !== i)
      throw new Error("illegal state");
    return n && i;
  }
  values(e) {
    return typeof e == "string" ? this._byOwner.get(e)?.values() ?? Jt.empty() : Pt.isUri(e) ? this._byResource.get(e)?.values() ?? Jt.empty() : Jt.map(Jt.concat(...this._byOwner.values()), (t) => t[1]);
  }
}
class FEt {
  constructor(e) {
    this.errors = 0, this.infos = 0, this.warnings = 0, this.unknowns = 0, this._data = new ws(), this._service = e, this._subscription = e.onMarkerChanged(this._update, this);
  }
  dispose() {
    this._subscription.dispose();
  }
  _update(e) {
    for (const t of e) {
      const n = this._data.get(t);
      n && this._substract(n);
      const i = this._resourceStats(t);
      this._add(i), this._data.set(t, i);
    }
  }
  _resourceStats(e) {
    const t = { errors: 0, warnings: 0, infos: 0, unknowns: 0 };
    if (BEt.has(e.scheme))
      return t;
    for (const { severity: n } of this._service.read({ resource: e }))
      n === la.Error ? t.errors += 1 : n === la.Warning ? t.warnings += 1 : n === la.Info ? t.infos += 1 : t.unknowns += 1;
    return t;
  }
  _substract(e) {
    this.errors -= e.errors, this.warnings -= e.warnings, this.infos -= e.infos, this.unknowns -= e.unknowns;
  }
  _add(e) {
    this.errors += e.errors, this.warnings += e.warnings, this.infos += e.infos, this.unknowns += e.unknowns;
  }
}
class Au {
  constructor() {
    this._onMarkerChanged = new jMe({
      delay: 0,
      merge: Au._merge
    }), this.onMarkerChanged = this._onMarkerChanged.event, this._data = new PEt(), this._stats = new FEt(this);
  }
  dispose() {
    this._stats.dispose(), this._onMarkerChanged.dispose();
  }
  remove(e, t) {
    for (const n of t || [])
      this.changeOne(e, n, []);
  }
  changeOne(e, t, n) {
    if (dut(n))
      this._data.delete(t, e) && this._onMarkerChanged.fire([t]);
    else {
      const i = [];
      for (const s of n) {
        const o = Au._toMarker(e, t, s);
        o && i.push(o);
      }
      this._data.set(t, e, i), this._onMarkerChanged.fire([t]);
    }
  }
  static _toMarker(e, t, n) {
    let { code: i, severity: s, message: o, source: a, startLineNumber: l, startColumn: c, endLineNumber: d, endColumn: u, relatedInformation: f, tags: p } = n;
    if (o)
      return l = l > 0 ? l : 1, c = c > 0 ? c : 1, d = d >= l ? d : l, u = u > 0 ? u : c, {
        resource: t,
        owner: e,
        code: i,
        severity: s,
        message: o,
        source: a,
        startLineNumber: l,
        startColumn: c,
        endLineNumber: d,
        endColumn: u,
        relatedInformation: f,
        tags: p
      };
  }
  changeAll(e, t) {
    const n = [], i = this._data.values(e);
    if (i)
      for (const s of i) {
        const o = Jt.first(s);
        o && (n.push(o.resource), this._data.delete(o.resource, e));
      }
    if (k7(t)) {
      const s = new ws();
      for (const { resource: o, marker: a } of t) {
        const l = Au._toMarker(e, o, a);
        if (!l)
          continue;
        const c = s.get(o);
        c ? c.push(l) : (s.set(o, [l]), n.push(o));
      }
      for (const [o, a] of s)
        this._data.set(o, e, a);
    }
    n.length > 0 && this._onMarkerChanged.fire(n);
  }
  read(e = /* @__PURE__ */ Object.create(null)) {
    let { owner: t, resource: n, severities: i, take: s } = e;
    if ((!s || s < 0) && (s = -1), t && n) {
      const o = this._data.get(n, t);
      if (o) {
        const a = [];
        for (const l of o)
          if (Au._accept(l, i)) {
            const c = a.push(l);
            if (s > 0 && c === s)
              break;
          }
        return a;
      } else
        return [];
    } else if (!t && !n) {
      const o = [];
      for (const a of this._data.values())
        for (const l of a)
          if (Au._accept(l, i)) {
            const c = o.push(l);
            if (s > 0 && c === s)
              return o;
          }
      return o;
    } else {
      const o = this._data.values(n ?? t), a = [];
      for (const l of o)
        for (const c of l)
          if (Au._accept(c, i)) {
            const d = a.push(c);
            if (s > 0 && d === s)
              return a;
          }
      return a;
    }
  }
  static _accept(e, t) {
    return t === void 0 || (t & e.severity) === e.severity;
  }
  // --- event debounce logic
  static _merge(e) {
    const t = new ws();
    for (const n of e)
      for (const i of n)
        t.set(i, !0);
    return Array.from(t.keys());
  }
}
class zEt extends me {
  get configurationModel() {
    return this._configurationModel;
  }
  constructor(e) {
    super(), this.logService = e, this._configurationModel = mr.createEmptyModel(this.logService);
  }
  reload() {
    return this.resetConfigurationModel(), this.configurationModel;
  }
  getConfigurationDefaultOverrides() {
    return {};
  }
  resetConfigurationModel() {
    this._configurationModel = mr.createEmptyModel(this.logService);
    const e = Er.as($f.Configuration).getConfigurationProperties();
    this.updateConfigurationModel(Object.keys(e), e);
  }
  updateConfigurationModel(e, t) {
    const n = this.getConfigurationDefaultOverrides();
    for (const i of e) {
      const s = n[i], o = t[i];
      s !== void 0 ? this._configurationModel.setValue(i, s) : o ? this._configurationModel.setValue(i, o.default) : this._configurationModel.removeValue(i);
    }
  }
}
const zy = Wt("accessibilitySignalService");
class yt {
  static register(e) {
    return new yt(e.fileName);
  }
  static {
    this.error = yt.register({ fileName: "error.mp3" });
  }
  static {
    this.warning = yt.register({ fileName: "warning.mp3" });
  }
  static {
    this.success = yt.register({ fileName: "success.mp3" });
  }
  static {
    this.foldedArea = yt.register({ fileName: "foldedAreas.mp3" });
  }
  static {
    this.break = yt.register({ fileName: "break.mp3" });
  }
  static {
    this.quickFixes = yt.register({ fileName: "quickFixes.mp3" });
  }
  static {
    this.taskCompleted = yt.register({ fileName: "taskCompleted.mp3" });
  }
  static {
    this.taskFailed = yt.register({ fileName: "taskFailed.mp3" });
  }
  static {
    this.terminalBell = yt.register({ fileName: "terminalBell.mp3" });
  }
  static {
    this.diffLineInserted = yt.register({ fileName: "diffLineInserted.mp3" });
  }
  static {
    this.diffLineDeleted = yt.register({ fileName: "diffLineDeleted.mp3" });
  }
  static {
    this.diffLineModified = yt.register({ fileName: "diffLineModified.mp3" });
  }
  static {
    this.chatRequestSent = yt.register({ fileName: "chatRequestSent.mp3" });
  }
  static {
    this.chatResponseReceived1 = yt.register({ fileName: "chatResponseReceived1.mp3" });
  }
  static {
    this.chatResponseReceived2 = yt.register({ fileName: "chatResponseReceived2.mp3" });
  }
  static {
    this.chatResponseReceived3 = yt.register({ fileName: "chatResponseReceived3.mp3" });
  }
  static {
    this.chatResponseReceived4 = yt.register({ fileName: "chatResponseReceived4.mp3" });
  }
  static {
    this.clear = yt.register({ fileName: "clear.mp3" });
  }
  static {
    this.save = yt.register({ fileName: "save.mp3" });
  }
  static {
    this.format = yt.register({ fileName: "format.mp3" });
  }
  static {
    this.voiceRecordingStarted = yt.register({ fileName: "voiceRecordingStarted.mp3" });
  }
  static {
    this.voiceRecordingStopped = yt.register({ fileName: "voiceRecordingStopped.mp3" });
  }
  static {
    this.progress = yt.register({ fileName: "progress.mp3" });
  }
  constructor(e) {
    this.fileName = e;
  }
}
class WEt {
  constructor(e) {
    this.randomOneOf = e;
  }
}
class mn {
  constructor(e, t, n, i, s, o) {
    this.sound = e, this.name = t, this.legacySoundSettingsKey = n, this.settingsKey = i, this.legacyAnnouncementSettingsKey = s, this.announcementMessage = o;
  }
  static {
    this._signals = /* @__PURE__ */ new Set();
  }
  static register(e) {
    const t = new WEt("randomOneOf" in e.sound ? e.sound.randomOneOf : [e.sound]), n = new mn(t, e.name, e.legacySoundSettingsKey, e.settingsKey, e.legacyAnnouncementSettingsKey, e.announcementMessage);
    return mn._signals.add(n), n;
  }
  static {
    this.errorAtPosition = mn.register({
      name: C("accessibilitySignals.positionHasError.name", "Error at Position"),
      sound: yt.error,
      announcementMessage: C("accessibility.signals.positionHasError", "Error"),
      settingsKey: "accessibility.signals.positionHasError",
      delaySettingsKey: "accessibility.signalOptions.delays.errorAtPosition"
    });
  }
  static {
    this.warningAtPosition = mn.register({
      name: C("accessibilitySignals.positionHasWarning.name", "Warning at Position"),
      sound: yt.warning,
      announcementMessage: C("accessibility.signals.positionHasWarning", "Warning"),
      settingsKey: "accessibility.signals.positionHasWarning",
      delaySettingsKey: "accessibility.signalOptions.delays.warningAtPosition"
    });
  }
  static {
    this.errorOnLine = mn.register({
      name: C("accessibilitySignals.lineHasError.name", "Error on Line"),
      sound: yt.error,
      legacySoundSettingsKey: "audioCues.lineHasError",
      legacyAnnouncementSettingsKey: "accessibility.alert.error",
      announcementMessage: C("accessibility.signals.lineHasError", "Error on Line"),
      settingsKey: "accessibility.signals.lineHasError"
    });
  }
  static {
    this.warningOnLine = mn.register({
      name: C("accessibilitySignals.lineHasWarning.name", "Warning on Line"),
      sound: yt.warning,
      legacySoundSettingsKey: "audioCues.lineHasWarning",
      legacyAnnouncementSettingsKey: "accessibility.alert.warning",
      announcementMessage: C("accessibility.signals.lineHasWarning", "Warning on Line"),
      settingsKey: "accessibility.signals.lineHasWarning"
    });
  }
  static {
    this.foldedArea = mn.register({
      name: C("accessibilitySignals.lineHasFoldedArea.name", "Folded Area on Line"),
      sound: yt.foldedArea,
      legacySoundSettingsKey: "audioCues.lineHasFoldedArea",
      legacyAnnouncementSettingsKey: "accessibility.alert.foldedArea",
      announcementMessage: C("accessibility.signals.lineHasFoldedArea", "Folded"),
      settingsKey: "accessibility.signals.lineHasFoldedArea"
    });
  }
  static {
    this.break = mn.register({
      name: C("accessibilitySignals.lineHasBreakpoint.name", "Breakpoint on Line"),
      sound: yt.break,
      legacySoundSettingsKey: "audioCues.lineHasBreakpoint",
      legacyAnnouncementSettingsKey: "accessibility.alert.breakpoint",
      announcementMessage: C("accessibility.signals.lineHasBreakpoint", "Breakpoint"),
      settingsKey: "accessibility.signals.lineHasBreakpoint"
    });
  }
  static {
    this.inlineSuggestion = mn.register({
      name: C("accessibilitySignals.lineHasInlineSuggestion.name", "Inline Suggestion on Line"),
      sound: yt.quickFixes,
      legacySoundSettingsKey: "audioCues.lineHasInlineSuggestion",
      settingsKey: "accessibility.signals.lineHasInlineSuggestion"
    });
  }
  static {
    this.terminalQuickFix = mn.register({
      name: C("accessibilitySignals.terminalQuickFix.name", "Terminal Quick Fix"),
      sound: yt.quickFixes,
      legacySoundSettingsKey: "audioCues.terminalQuickFix",
      legacyAnnouncementSettingsKey: "accessibility.alert.terminalQuickFix",
      announcementMessage: C("accessibility.signals.terminalQuickFix", "Quick Fix"),
      settingsKey: "accessibility.signals.terminalQuickFix"
    });
  }
  static {
    this.onDebugBreak = mn.register({
      name: C("accessibilitySignals.onDebugBreak.name", "Debugger Stopped on Breakpoint"),
      sound: yt.break,
      legacySoundSettingsKey: "audioCues.onDebugBreak",
      legacyAnnouncementSettingsKey: "accessibility.alert.onDebugBreak",
      announcementMessage: C("accessibility.signals.onDebugBreak", "Breakpoint"),
      settingsKey: "accessibility.signals.onDebugBreak"
    });
  }
  static {
    this.noInlayHints = mn.register({
      name: C("accessibilitySignals.noInlayHints", "No Inlay Hints on Line"),
      sound: yt.error,
      legacySoundSettingsKey: "audioCues.noInlayHints",
      legacyAnnouncementSettingsKey: "accessibility.alert.noInlayHints",
      announcementMessage: C("accessibility.signals.noInlayHints", "No Inlay Hints"),
      settingsKey: "accessibility.signals.noInlayHints"
    });
  }
  static {
    this.taskCompleted = mn.register({
      name: C("accessibilitySignals.taskCompleted", "Task Completed"),
      sound: yt.taskCompleted,
      legacySoundSettingsKey: "audioCues.taskCompleted",
      legacyAnnouncementSettingsKey: "accessibility.alert.taskCompleted",
      announcementMessage: C("accessibility.signals.taskCompleted", "Task Completed"),
      settingsKey: "accessibility.signals.taskCompleted"
    });
  }
  static {
    this.taskFailed = mn.register({
      name: C("accessibilitySignals.taskFailed", "Task Failed"),
      sound: yt.taskFailed,
      legacySoundSettingsKey: "audioCues.taskFailed",
      legacyAnnouncementSettingsKey: "accessibility.alert.taskFailed",
      announcementMessage: C("accessibility.signals.taskFailed", "Task Failed"),
      settingsKey: "accessibility.signals.taskFailed"
    });
  }
  static {
    this.terminalCommandFailed = mn.register({
      name: C("accessibilitySignals.terminalCommandFailed", "Terminal Command Failed"),
      sound: yt.error,
      legacySoundSettingsKey: "audioCues.terminalCommandFailed",
      legacyAnnouncementSettingsKey: "accessibility.alert.terminalCommandFailed",
      announcementMessage: C("accessibility.signals.terminalCommandFailed", "Command Failed"),
      settingsKey: "accessibility.signals.terminalCommandFailed"
    });
  }
  static {
    this.terminalCommandSucceeded = mn.register({
      name: C("accessibilitySignals.terminalCommandSucceeded", "Terminal Command Succeeded"),
      sound: yt.success,
      announcementMessage: C("accessibility.signals.terminalCommandSucceeded", "Command Succeeded"),
      settingsKey: "accessibility.signals.terminalCommandSucceeded"
    });
  }
  static {
    this.terminalBell = mn.register({
      name: C("accessibilitySignals.terminalBell", "Terminal Bell"),
      sound: yt.terminalBell,
      legacySoundSettingsKey: "audioCues.terminalBell",
      legacyAnnouncementSettingsKey: "accessibility.alert.terminalBell",
      announcementMessage: C("accessibility.signals.terminalBell", "Terminal Bell"),
      settingsKey: "accessibility.signals.terminalBell"
    });
  }
  static {
    this.notebookCellCompleted = mn.register({
      name: C("accessibilitySignals.notebookCellCompleted", "Notebook Cell Completed"),
      sound: yt.taskCompleted,
      legacySoundSettingsKey: "audioCues.notebookCellCompleted",
      legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellCompleted",
      announcementMessage: C("accessibility.signals.notebookCellCompleted", "Notebook Cell Completed"),
      settingsKey: "accessibility.signals.notebookCellCompleted"
    });
  }
  static {
    this.notebookCellFailed = mn.register({
      name: C("accessibilitySignals.notebookCellFailed", "Notebook Cell Failed"),
      sound: yt.taskFailed,
      legacySoundSettingsKey: "audioCues.notebookCellFailed",
      legacyAnnouncementSettingsKey: "accessibility.alert.notebookCellFailed",
      announcementMessage: C("accessibility.signals.notebookCellFailed", "Notebook Cell Failed"),
      settingsKey: "accessibility.signals.notebookCellFailed"
    });
  }
  static {
    this.diffLineInserted = mn.register({
      name: C("accessibilitySignals.diffLineInserted", "Diff Line Inserted"),
      sound: yt.diffLineInserted,
      legacySoundSettingsKey: "audioCues.diffLineInserted",
      settingsKey: "accessibility.signals.diffLineInserted"
    });
  }
  static {
    this.diffLineDeleted = mn.register({
      name: C("accessibilitySignals.diffLineDeleted", "Diff Line Deleted"),
      sound: yt.diffLineDeleted,
      legacySoundSettingsKey: "audioCues.diffLineDeleted",
      settingsKey: "accessibility.signals.diffLineDeleted"
    });
  }
  static {
    this.diffLineModified = mn.register({
      name: C("accessibilitySignals.diffLineModified", "Diff Line Modified"),
      sound: yt.diffLineModified,
      legacySoundSettingsKey: "audioCues.diffLineModified",
      settingsKey: "accessibility.signals.diffLineModified"
    });
  }
  static {
    this.chatRequestSent = mn.register({
      name: C("accessibilitySignals.chatRequestSent", "Chat Request Sent"),
      sound: yt.chatRequestSent,
      legacySoundSettingsKey: "audioCues.chatRequestSent",
      legacyAnnouncementSettingsKey: "accessibility.alert.chatRequestSent",
      announcementMessage: C("accessibility.signals.chatRequestSent", "Chat Request Sent"),
      settingsKey: "accessibility.signals.chatRequestSent"
    });
  }
  static {
    this.chatResponseReceived = mn.register({
      name: C("accessibilitySignals.chatResponseReceived", "Chat Response Received"),
      legacySoundSettingsKey: "audioCues.chatResponseReceived",
      sound: {
        randomOneOf: [
          yt.chatResponseReceived1,
          yt.chatResponseReceived2,
          yt.chatResponseReceived3,
          yt.chatResponseReceived4
        ]
      },
      settingsKey: "accessibility.signals.chatResponseReceived"
    });
  }
  static {
    this.progress = mn.register({
      name: C("accessibilitySignals.progress", "Progress"),
      sound: yt.progress,
      legacySoundSettingsKey: "audioCues.chatResponsePending",
      legacyAnnouncementSettingsKey: "accessibility.alert.progress",
      announcementMessage: C("accessibility.signals.progress", "Progress"),
      settingsKey: "accessibility.signals.progress"
    });
  }
  static {
    this.clear = mn.register({
      name: C("accessibilitySignals.clear", "Clear"),
      sound: yt.clear,
      legacySoundSettingsKey: "audioCues.clear",
      legacyAnnouncementSettingsKey: "accessibility.alert.clear",
      announcementMessage: C("accessibility.signals.clear", "Clear"),
      settingsKey: "accessibility.signals.clear"
    });
  }
  static {
    this.save = mn.register({
      name: C("accessibilitySignals.save", "Save"),
      sound: yt.save,
      legacySoundSettingsKey: "audioCues.save",
      legacyAnnouncementSettingsKey: "accessibility.alert.save",
      announcementMessage: C("accessibility.signals.save", "Save"),
      settingsKey: "accessibility.signals.save"
    });
  }
  static {
    this.format = mn.register({
      name: C("accessibilitySignals.format", "Format"),
      sound: yt.format,
      legacySoundSettingsKey: "audioCues.format",
      legacyAnnouncementSettingsKey: "accessibility.alert.format",
      announcementMessage: C("accessibility.signals.format", "Format"),
      settingsKey: "accessibility.signals.format"
    });
  }
  static {
    this.voiceRecordingStarted = mn.register({
      name: C("accessibilitySignals.voiceRecordingStarted", "Voice Recording Started"),
      sound: yt.voiceRecordingStarted,
      legacySoundSettingsKey: "audioCues.voiceRecordingStarted",
      settingsKey: "accessibility.signals.voiceRecordingStarted"
    });
  }
  static {
    this.voiceRecordingStopped = mn.register({
      name: C("accessibilitySignals.voiceRecordingStopped", "Voice Recording Stopped"),
      sound: yt.voiceRecordingStopped,
      legacySoundSettingsKey: "audioCues.voiceRecordingStopped",
      settingsKey: "accessibility.signals.voiceRecordingStopped"
    });
  }
}
class jEt extends me {
  constructor(e, t = []) {
    super(), this.logger = new C2t([e, ...t]), this._register(e.onDidChangeLogLevel((n) => this.setLevel(n)));
  }
  get onDidChangeLogLevel() {
    return this.logger.onDidChangeLogLevel;
  }
  setLevel(e) {
    this.logger.setLevel(e);
  }
  getLevel() {
    return this.logger.getLevel();
  }
  trace(e, ...t) {
    this.logger.trace(e, ...t);
  }
  debug(e, ...t) {
    this.logger.debug(e, ...t);
  }
  info(e, ...t) {
    this.logger.info(e, ...t);
  }
  warn(e, ...t) {
    this.logger.warn(e, ...t);
  }
  error(e, ...t) {
    this.logger.error(e, ...t);
  }
}
const ZEt = [];
function UEt() {
  return ZEt.slice(0);
}
var Xd = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Xi = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
class qEt {
  constructor(e) {
    this.disposed = !1, this.model = e, this._onWillDispose = new $();
  }
  get textEditorModel() {
    return this.model;
  }
  dispose() {
    this.disposed = !0, this._onWillDispose.fire();
  }
}
let Zk = class {
  constructor(e) {
    this.modelService = e;
  }
  createModelReference(e) {
    const t = this.modelService.getModel(e);
    return t ? Promise.resolve(new T1t(new qEt(t))) : Promise.reject(new Error("Model not found"));
  }
};
Zk = Xd([
  Xi(0, Wo)
], Zk);
class QR {
  static {
    this.NULL_PROGRESS_RUNNER = {
      done: () => {
      },
      total: () => {
      },
      worked: () => {
      }
    };
  }
  show() {
    return QR.NULL_PROGRESS_RUNNER;
  }
  async showWhile(e, t) {
    await e;
  }
}
class GEt {
  withProgress(e, t, n) {
    return t({
      report: () => {
      }
    });
  }
}
class QEt {
  constructor() {
    this.isExtensionDevelopment = !1, this.isBuilt = !1;
  }
}
class KEt {
  async confirm(e) {
    return {
      confirmed: this.doConfirm(e.message, e.detail),
      checkboxChecked: !1
      // unsupported
    };
  }
  doConfirm(e, t) {
    let n = e;
    return t && (n = n + `

` + t), Sn.confirm(n);
  }
  async prompt(e) {
    let t;
    if (this.doConfirm(e.message, e.detail)) {
      const i = [...e.buttons ?? []];
      e.cancelButton && typeof e.cancelButton != "string" && typeof e.cancelButton != "boolean" && i.push(e.cancelButton), t = await i[0]?.run({ checkboxChecked: !1 });
    }
    return { result: t };
  }
  async error(e, t) {
    await this.prompt({ type: Oi.Error, message: e, detail: t });
  }
}
class ib {
  static {
    this.NO_OP = new U6t();
  }
  info(e) {
    return this.notify({ severity: Oi.Info, message: e });
  }
  warn(e) {
    return this.notify({ severity: Oi.Warning, message: e });
  }
  error(e) {
    return this.notify({ severity: Oi.Error, message: e });
  }
  notify(e) {
    switch (e.severity) {
      case Oi.Error:
        console.error(e.message);
        break;
      case Oi.Warning:
        console.warn(e.message);
        break;
      default:
        console.log(e.message);
        break;
    }
    return ib.NO_OP;
  }
  prompt(e, t, n, i) {
    return ib.NO_OP;
  }
  status(e, t) {
    return me.None;
  }
}
let Uk = class {
  constructor(e) {
    this._onWillExecuteCommand = new $(), this._onDidExecuteCommand = new $(), this.onDidExecuteCommand = this._onDidExecuteCommand.event, this._instantiationService = e;
  }
  executeCommand(e, ...t) {
    const n = Zs.getCommand(e);
    if (!n)
      return Promise.reject(new Error(`command '${e}' not found`));
    try {
      this._onWillExecuteCommand.fire({ commandId: e, args: t });
      const i = this._instantiationService.invokeFunction.apply(this._instantiationService, [n.handler, ...t]);
      return this._onDidExecuteCommand.fire({ commandId: e, args: t }), Promise.resolve(i);
    } catch (i) {
      return Promise.reject(i);
    }
  }
};
Uk = Xd([
  Xi(0, xn)
], Uk);
let Eg = class extends mbt {
  constructor(e, t, n, i, s, o) {
    super(e, t, n, i, s), this._cachedResolver = null, this._dynamicKeybindings = [], this._domNodeListeners = [];
    const a = (p) => {
      const g = new ze();
      g.add(fe(p, Se.KEY_DOWN, (m) => {
        const A = new zn(m);
        this._dispatch(A, A.target) && (A.preventDefault(), A.stopPropagation());
      })), g.add(fe(p, Se.KEY_UP, (m) => {
        const A = new zn(m);
        this._singleModifierDispatch(A, A.target) && A.preventDefault();
      })), this._domNodeListeners.push(new YEt(p, g));
    }, l = (p) => {
      for (let g = 0; g < this._domNodeListeners.length; g++) {
        const m = this._domNodeListeners[g];
        m.domNode === p && (this._domNodeListeners.splice(g, 1), m.dispose());
      }
    }, c = (p) => {
      p.getOption(
        61
        /* EditorOption.inDiffEditor */
      ) || a(p.getContainerDomNode());
    }, d = (p) => {
      p.getOption(
        61
        /* EditorOption.inDiffEditor */
      ) || l(p.getContainerDomNode());
    };
    this._register(o.onCodeEditorAdd(c)), this._register(o.onCodeEditorRemove(d)), o.listCodeEditors().forEach(c);
    const u = (p) => {
      a(p.getContainerDomNode());
    }, f = (p) => {
      l(p.getContainerDomNode());
    };
    this._register(o.onDiffEditorAdd(u)), this._register(o.onDiffEditorRemove(f)), o.listDiffEditors().forEach(u);
  }
  addDynamicKeybinding(e, t, n, i) {
    return ih(Zs.registerCommand(e, n), this.addDynamicKeybindings([{
      keybinding: t,
      command: e,
      when: i
    }]));
  }
  addDynamicKeybindings(e) {
    const t = e.map((n) => ({
      keybinding: TD(n.keybinding, nl),
      command: n.command ?? null,
      commandArgs: n.commandArgs,
      when: n.when,
      weight1: 1e3,
      weight2: 0,
      extensionId: null,
      isBuiltinExtension: !1
    }));
    return this._dynamicKeybindings = this._dynamicKeybindings.concat(t), this.updateResolver(), ht(() => {
      for (let n = 0; n < this._dynamicKeybindings.length; n++)
        if (this._dynamicKeybindings[n] === t[0]) {
          this._dynamicKeybindings.splice(n, t.length), this.updateResolver();
          return;
        }
    });
  }
  updateResolver() {
    this._cachedResolver = null, this._onDidUpdateKeybindings.fire();
  }
  _getResolver() {
    if (!this._cachedResolver) {
      const e = this._toNormalizedKeybindingItems(Kf.getDefaultKeybindings(), !0), t = this._toNormalizedKeybindingItems(this._dynamicKeybindings, !1);
      this._cachedResolver = new i3(e, t, (n) => this._log(n));
    }
    return this._cachedResolver;
  }
  _documentHasFocus() {
    return Sn.document.hasFocus();
  }
  _toNormalizedKeybindingItems(e, t) {
    const n = [];
    let i = 0;
    for (const s of e) {
      const o = s.when || void 0, a = s.keybinding;
      if (!a)
        n[i++] = new Z8e(void 0, s.command, s.commandArgs, o, t, null, !1);
      else {
        const l = a4.resolveKeybinding(a, nl);
        for (const c of l)
          n[i++] = new Z8e(c, s.command, s.commandArgs, o, t, null, !1);
      }
    }
    return n;
  }
  resolveKeyboardEvent(e) {
    const t = new gf(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, e.keyCode);
    return new a4([t], nl);
  }
};
Eg = Xd([
  Xi(0, sn),
  Xi(1, jo),
  Xi(2, I1),
  Xi(3, Zo),
  Xi(4, _h),
  Xi(5, Ui)
], Eg);
class YEt extends me {
  constructor(e, t) {
    super(), this.domNode = e, this._register(t);
  }
}
function G9e(r) {
  return r && typeof r == "object" && (!r.overrideIdentifier || typeof r.overrideIdentifier == "string") && (!r.resource || r.resource instanceof Pt);
}
let rb = class {
  constructor(e) {
    this.logService = e, this._onDidChangeConfiguration = new $(), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event;
    const t = new zEt(e);
    this._configuration = new bNe(t.reload(), mr.createEmptyModel(e), mr.createEmptyModel(e), mr.createEmptyModel(e), mr.createEmptyModel(e), mr.createEmptyModel(e), new ws(), mr.createEmptyModel(e), new ws(), e), t.dispose();
  }
  getValue(e, t) {
    const n = typeof e == "string" ? e : void 0, i = G9e(e) ? e : G9e(t) ? t : {};
    return this._configuration.getValue(n, i, void 0);
  }
  updateValues(e) {
    const t = { data: this._configuration.toData() }, n = [];
    for (const i of e) {
      const [s, o] = i;
      this.getValue(s) !== o && (this._configuration.updateValue(s, o), n.push(s));
    }
    if (n.length > 0) {
      const i = new ubt({ keys: n, overrides: [] }, t, this._configuration, void 0, this.logService);
      i.source = 8, this._onDidChangeConfiguration.fire(i);
    }
    return Promise.resolve();
  }
  updateValue(e, t, n, i) {
    return this.updateValues([[e, t]]);
  }
  inspect(e, t = {}) {
    return this._configuration.inspect(e, t, void 0);
  }
};
rb = Xd([
  Xi(0, _h)
], rb);
let qk = class {
  constructor(e, t, n) {
    this.configurationService = e, this.modelService = t, this.languageService = n, this._onDidChangeConfiguration = new $(), this.configurationService.onDidChangeConfiguration((i) => {
      this._onDidChangeConfiguration.fire({ affectedKeys: i.affectedKeys, affectsConfiguration: (s, o) => i.affectsConfiguration(o) });
    });
  }
  getValue(e, t, n) {
    const i = le.isIPosition(t) ? t : null, s = i ? typeof n == "string" ? n : void 0 : typeof t == "string" ? t : void 0, o = e ? this.getLanguage(e, i) : void 0;
    return typeof s > "u" ? this.configurationService.getValue({
      resource: e,
      overrideIdentifier: o
    }) : this.configurationService.getValue(s, {
      resource: e,
      overrideIdentifier: o
    });
  }
  getLanguage(e, t) {
    const n = this.modelService.getModel(e);
    return n ? t ? n.getLanguageIdAtPosition(t.lineNumber, t.column) : n.getLanguageId() : this.languageService.guessLanguageIdByFilepathOrFirstLine(e);
  }
};
qk = Xd([
  Xi(0, Ai),
  Xi(1, Wo),
  Xi(2, sr)
], qk);
let Gk = class {
  constructor(e) {
    this.configurationService = e;
  }
  getEOL(e, t) {
    const n = this.configurationService.getValue("files.eol", { overrideIdentifier: t, resource: e });
    return n && typeof n == "string" && n !== "auto" ? n : Cs || zt ? `
` : `\r
`;
  }
};
Gk = Xd([
  Xi(0, Ai)
], Gk);
class XEt {
  publicLog2() {
  }
}
class sb {
  static {
    this.SCHEME = "inmemory";
  }
  constructor() {
    const e = Pt.from({ scheme: sb.SCHEME, authority: "model", path: "/" });
    this.workspace = { id: Nbt, folders: [new Lbt({ uri: e, name: "", index: 0 })] };
  }
  getWorkspace() {
    return this.workspace;
  }
  getWorkspaceFolder(e) {
    return e && e.scheme === sb.SCHEME ? this.workspace.folders[0] : null;
  }
}
function ob(r, e, t) {
  if (!e || !(r instanceof rb))
    return;
  const n = [];
  Object.keys(e).forEach((i) => {
    obt(i) && n.push([`editor.${i}`, e[i]]), t && abt(i) && n.push([`diffEditor.${i}`, e[i]]);
  }), n.length > 0 && r.updateValues(n);
}
let Qk = class {
  constructor(e) {
    this._modelService = e;
  }
  hasPreviewHandler() {
    return !1;
  }
  async apply(e, t) {
    const n = Array.isArray(e) ? e : uR.convert(e), i = /* @__PURE__ */ new Map();
    for (const a of n) {
      if (!(a instanceof J0))
        throw new Error("bad edit - only text edits are supported");
      const l = this._modelService.getModel(a.resource);
      if (!l)
        throw new Error("bad edit - model not found");
      if (typeof a.versionId == "number" && l.getVersionId() !== a.versionId)
        throw new Error("bad state - model changed in the meantime");
      let c = i.get(l);
      c || (c = [], i.set(l, c)), c.push(cbt.replaceMove(Q.lift(a.textEdit.range), a.textEdit.text));
    }
    let s = 0, o = 0;
    for (const [a, l] of i)
      a.pushStackElement(), a.pushEditOperations([], l, () => []), a.pushStackElement(), o += 1, s += l.length;
    return {
      ariaSummary: I8(nk.bulkEditServiceSummary, s, o),
      isApplied: s > 0
    };
  }
};
Qk = Xd([
  Xi(0, Wo)
], Qk);
class JEt {
  getUriLabel(e, t) {
    return e.scheme === "file" ? e.fsPath : e.path;
  }
  getUriBasenameLabel(e) {
    return qO(e);
  }
}
let Kk = class extends $9t {
  constructor(e, t) {
    super(e), this._codeEditorService = t;
  }
  showContextView(e, t, n) {
    if (!t) {
      const i = this._codeEditorService.getFocusedCodeEditor() || this._codeEditorService.getActiveCodeEditor();
      i && (t = i.getContainerDomNode());
    }
    return super.showContextView(e, t, n);
  }
};
Kk = Xd([
  Xi(0, R1),
  Xi(1, Ui)
], Kk);
class $Et {
  constructor() {
    this._neverEmitter = new $(), this.onDidChangeTrust = this._neverEmitter.event;
  }
  isWorkspaceTrusted() {
    return !0;
  }
}
class e_t extends O9 {
  constructor() {
    super();
  }
}
class t_t extends jEt {
  constructor() {
    super(new y2t());
  }
}
let Yk = class extends fk {
  constructor(e, t, n, i, s, o) {
    super(e, t, n, i, s, o), this.configure({ blockMouse: !1 });
  }
};
Yk = Xd([
  Xi(0, I1),
  Xi(1, Zo),
  Xi(2, rm),
  Xi(3, _r),
  Xi(4, Yf),
  Xi(5, sn)
], Yk);
class n_t {
  async playSignal(e, t) {
  }
}
en(
  _h,
  t_t,
  0
  /* InstantiationType.Eager */
);
en(
  Ai,
  rb,
  0
  /* InstantiationType.Eager */
);
en(
  pLe,
  qk,
  0
  /* InstantiationType.Eager */
);
en(
  gLe,
  Gk,
  0
  /* InstantiationType.Eager */
);
en(
  Dbt,
  sb,
  0
  /* InstantiationType.Eager */
);
en(
  Cbt,
  JEt,
  0
  /* InstantiationType.Eager */
);
en(
  I1,
  XEt,
  0
  /* InstantiationType.Eager */
);
en(
  Gke,
  KEt,
  0
  /* InstantiationType.Eager */
);
en(
  Jke,
  QEt,
  0
  /* InstantiationType.Eager */
);
en(
  Zo,
  ib,
  0
  /* InstantiationType.Eager */
);
en(
  r2,
  Au,
  0
  /* InstantiationType.Eager */
);
en(
  sr,
  e_t,
  0
  /* InstantiationType.Eager */
);
en(
  bl,
  EEt,
  0
  /* InstantiationType.Eager */
);
en(
  Wo,
  vk,
  0
  /* InstantiationType.Eager */
);
en(
  _Le,
  wk,
  0
  /* InstantiationType.Eager */
);
en(
  sn,
  jk,
  0
  /* InstantiationType.Eager */
);
en(
  Ebt,
  GEt,
  0
  /* InstantiationType.Eager */
);
en(
  pR,
  QR,
  0
  /* InstantiationType.Eager */
);
en(
  am,
  W7t,
  0
  /* InstantiationType.Eager */
);
en(
  Hw,
  $D,
  0
  /* InstantiationType.Eager */
);
en(
  ibt,
  Qk,
  0
  /* InstantiationType.Eager */
);
en(
  Tbt,
  $Et,
  0
  /* InstantiationType.Eager */
);
en(
  z7,
  Zk,
  0
  /* InstantiationType.Eager */
);
en(
  pc,
  Hk,
  0
  /* InstantiationType.Eager */
);
en(
  Dh,
  ICt,
  0
  /* InstantiationType.Eager */
);
en(
  jo,
  Uk,
  0
  /* InstantiationType.Eager */
);
en(
  _r,
  Eg,
  0
  /* InstantiationType.Eager */
);
en(
  Bw,
  Rk,
  0
  /* InstantiationType.Eager */
);
en(
  rm,
  Kk,
  0
  /* InstantiationType.Eager */
);
en(
  Tw,
  Ak,
  0
  /* InstantiationType.Eager */
);
en(
  Fw,
  Wk,
  0
  /* InstantiationType.Eager */
);
en(
  Qd,
  Yk,
  0
  /* InstantiationType.Eager */
);
en(
  Yf,
  Bk,
  0
  /* InstantiationType.Eager */
);
en(
  zy,
  n_t,
  0
  /* InstantiationType.Eager */
);
var Qe;
(function(r) {
  const e = new Nw();
  for (const [l, c] of c5e())
    e.set(l, c);
  const t = new nb(e, !0);
  e.set(xn, t);
  function n(l) {
    i || o({});
    const c = e.get(l);
    if (!c)
      throw new Error("Missing service " + l);
    return c instanceof jc ? t.invokeFunction((d) => d.get(l)) : c;
  }
  r.get = n;
  let i = !1;
  const s = new $();
  function o(l) {
    if (i)
      return t;
    i = !0;
    for (const [d, u] of c5e())
      e.get(d) || e.set(d, u);
    for (const d in l)
      if (l.hasOwnProperty(d)) {
        const u = Wt(d);
        e.get(u) instanceof jc && e.set(u, l[d]);
      }
    const c = UEt();
    for (const d of c)
      try {
        t.createInstance(d);
      } catch (u) {
        wn(u);
      }
    return s.fire(), t;
  }
  r.initialize = o;
  function a(l) {
    if (i)
      return l();
    const c = new ze(), d = c.add(s.event(() => {
      d.dispose(), c.add(l());
    }));
    return c;
  }
  r.withServices = a;
})(Qe || (Qe = {}));
class ab {
  static capture(e) {
    if (e.getScrollTop() === 0 || e.hasPendingScrollAnimation())
      return new ab(e.getScrollTop(), e.getContentHeight(), null, 0, null);
    let t = null, n = 0;
    const i = e.getVisibleRanges();
    if (i.length > 0) {
      t = i[0].getStartPosition();
      const s = e.getTopForPosition(t.lineNumber, t.column);
      n = e.getScrollTop() - s;
    }
    return new ab(e.getScrollTop(), e.getContentHeight(), t, n, e.getPosition());
  }
  constructor(e, t, n, i, s) {
    this._initialScrollTop = e, this._initialContentHeight = t, this._visiblePosition = n, this._visiblePositionScrollDelta = i, this._cursorPosition = s;
  }
  restore(e) {
    if (!(this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop()) && this._visiblePosition) {
      const t = e.getTopForPosition(this._visiblePosition.lineNumber, this._visiblePosition.column);
      e.setScrollTop(t + this._visiblePositionScrollDelta);
    }
  }
  restoreRelativeVerticalPositionOfCursor(e) {
    if (this._initialContentHeight === e.getContentHeight() && this._initialScrollTop === e.getScrollTop())
      return;
    const t = e.getPosition();
    if (!this._cursorPosition || !t)
      return;
    const n = e.getTopForLineNumber(t.lineNumber) - e.getTopForLineNumber(this._cursorPosition.lineNumber);
    e.setScrollTop(
      e.getScrollTop() + n,
      1
      /* ScrollType.Immediate */
    );
  }
}
function i_t(r, e, t, n) {
  if (r.length === 0)
    return e;
  if (e.length === 0)
    return r;
  const i = [];
  let s = 0, o = 0;
  for (; s < r.length && o < e.length; ) {
    const a = r[s], l = e[o], c = t(a), d = t(l);
    c < d ? (i.push(a), s++) : c > d ? (i.push(l), o++) : (i.push(n(a, l)), s++, o++);
  }
  for (; s < r.length; )
    i.push(r[s]), s++;
  for (; o < e.length; )
    i.push(e[o]), o++;
  return i;
}
function lb(r, e) {
  const t = new ze(), n = r.createDecorationsCollection();
  return t.add(Sy({ debugName: () => `Apply decorations from ${e.debugName}` }, (i) => {
    const s = e.read(i);
    n.set(s);
  })), t.add({
    dispose: () => {
      n.clear();
    }
  }), t;
}
function _A(r, e) {
  return r.appendChild(e), ht(() => {
    e.remove();
  });
}
function r_t(r, e) {
  return r.prepend(e), ht(() => {
    e.remove();
  });
}
class STe extends me {
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  get automaticLayout() {
    return this._automaticLayout;
  }
  constructor(e, t) {
    super(), this._automaticLayout = !1, this.elementSizeObserver = this._register(new xLe(e, t)), this._width = qt(this, this.elementSizeObserver.getWidth()), this._height = qt(this, this.elementSizeObserver.getHeight()), this._register(this.elementSizeObserver.onDidChange((n) => er((i) => {
      this._width.set(this.elementSizeObserver.getWidth(), i), this._height.set(this.elementSizeObserver.getHeight(), i);
    })));
  }
  observe(e) {
    this.elementSizeObserver.observe(e);
  }
  setAutomaticLayout(e) {
    this._automaticLayout = e, e ? this.elementSizeObserver.startObserving() : this.elementSizeObserver.stopObserving();
  }
}
function Q9e(r, e, t) {
  let n = e.get(), i = n, s = n;
  const o = qt("animatedValue", n);
  let a = -1;
  const l = 300;
  let c;
  t.add(My({
    createEmptyChangeSummary: () => ({ animate: !1 }),
    handleChange: (u, f) => (u.didChange(e) && (f.animate = f.animate || u.change), !0)
  }, (u, f) => {
    c !== void 0 && (r.cancelAnimationFrame(c), c = void 0), i = s, n = e.read(u), a = Date.now() - (f.animate ? 0 : l), d();
  }));
  function d() {
    const u = Date.now() - a;
    s = Math.floor(s_t(u, i, n - i, l)), u < l ? c = r.requestAnimationFrame(d) : s = n, o.set(s, void 0);
  }
  return o;
}
function s_t(r, e, t, n) {
  return r === n ? e + t : t * (-Math.pow(2, -10 * r / n) + 1) + e;
}
class KR extends me {
  constructor(e, t, n) {
    super(), this._register(new YR(e, n)), this._register(g1(n, {
      height: t.actualHeight,
      top: t.actualTop
    }));
  }
}
class hp {
  get afterLineNumber() {
    return this._afterLineNumber.get();
  }
  constructor(e, t) {
    this._afterLineNumber = e, this.heightInPx = t, this.domNode = document.createElement("div"), this._actualTop = qt(this, void 0), this._actualHeight = qt(this, void 0), this.actualTop = this._actualTop, this.actualHeight = this._actualHeight, this.showInHiddenAreas = !0, this.onChange = this._afterLineNumber, this.onDomNodeTop = (n) => {
      this._actualTop.set(n, void 0);
    }, this.onComputedHeight = (n) => {
      this._actualHeight.set(n, void 0);
    };
  }
}
class YR {
  static {
    this._counter = 0;
  }
  constructor(e, t) {
    this._editor = e, this._domElement = t, this._overlayWidgetId = `managedOverlayWidget-${YR._counter++}`, this._overlayWidget = {
      getId: () => this._overlayWidgetId,
      getDomNode: () => this._domElement,
      getPosition: () => null
    }, this._editor.addOverlayWidget(this._overlayWidget);
  }
  dispose() {
    this._editor.removeOverlayWidget(this._overlayWidget);
  }
}
function g1(r, e) {
  return nn((t) => {
    for (let [n, i] of Object.entries(e))
      i && typeof i == "object" && "read" in i && (i = i.read(t)), typeof i == "number" && (i = `${i}px`), n = n.replace(/[A-Z]/g, (s) => "-" + s.toLowerCase()), r.style[n] = i;
  });
}
function cb(r, e, t, n) {
  const i = new ze(), s = [];
  return i.add(Xl((o, a) => {
    const l = e.read(o), c = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map();
    t && t(!0), r.changeViewZones((u) => {
      for (const f of s)
        u.removeZone(f), n?.delete(f);
      s.length = 0;
      for (const f of l) {
        const p = u.addZone(f);
        f.setZoneId && f.setZoneId(p), s.push(p), n?.add(p), c.set(f, p);
      }
    }), t && t(!1), a.add(My({
      createEmptyChangeSummary() {
        return { zoneIds: [] };
      },
      handleChange(u, f) {
        const p = d.get(u.changedObservable);
        return p !== void 0 && f.zoneIds.push(p), !0;
      }
    }, (u, f) => {
      for (const p of l)
        p.onChange && (d.set(p.onChange, c.get(p)), p.onChange.read(u));
      t && t(!0), r.changeViewZones((p) => {
        for (const g of f.zoneIds)
          p.layoutZone(g);
      }), t && t(!1);
    }));
  })), i.add({
    dispose() {
      t && t(!0), r.changeViewZones((o) => {
        for (const a of s)
          o.removeZone(a);
      }), n?.clear(), t && t(!1);
    }
  }), i;
}
function K9e(r, e) {
  const t = G8(e, (i) => i.original.startLineNumber <= r.lineNumber);
  if (!t)
    return Q.fromPositions(r);
  if (t.original.endLineNumberExclusive <= r.lineNumber) {
    const i = r.lineNumber - t.original.endLineNumberExclusive + t.modified.endLineNumberExclusive;
    return Q.fromPositions(new le(i, r.column));
  }
  if (!t.innerChanges)
    return Q.fromPositions(new le(t.modified.startLineNumber, 1));
  const n = G8(t.innerChanges, (i) => i.originalRange.getStartPosition().isBeforeOrEqual(r));
  if (!n) {
    const i = r.lineNumber - t.original.startLineNumber + t.modified.startLineNumber;
    return Q.fromPositions(new le(i, r.column));
  }
  if (n.originalRange.containsPosition(r))
    return n.modifiedRange;
  {
    const i = o_t(n.originalRange.getEndPosition(), r);
    return Q.fromPositions(i.addToPosition(n.modifiedRange.getEndPosition()));
  }
}
function o_t(r, e) {
  return r.lineNumber === e.lineNumber ? new Xa(0, e.column - r.column) : new Xa(e.lineNumber - r.lineNumber, e.column - 1);
}
function a_t(r, e) {
  let t;
  return r.filter((n) => {
    const i = e(n, t);
    return t = n, i;
  });
}
class hb {
  static create(e, t = void 0) {
    return new Y9e(e, e, t);
  }
  static createWithDisposable(e, t, n = void 0) {
    const i = new ze();
    return i.add(t), i.add(e), new Y9e(e, i, n);
  }
}
class Y9e extends hb {
  constructor(e, t, n) {
    super(), this.object = e, this._disposable = t, this._debugOwner = n, this._refCount = 1, this._isDisposed = !1, this._owners = [], n && this._addOwner(n);
  }
  _addOwner(e) {
    e && this._owners.push(e);
  }
  createNewRef(e) {
    return this._refCount++, e && this._addOwner(e), new l_t(this, e);
  }
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this._decreaseRefCount(this._debugOwner));
  }
  _decreaseRefCount(e) {
    if (this._refCount--, this._refCount === 0 && this._disposable.dispose(), e) {
      const t = this._owners.indexOf(e);
      t !== -1 && this._owners.splice(t, 1);
    }
  }
}
class l_t extends hb {
  constructor(e, t) {
    super(), this._base = e, this._debugOwner = t, this._isDisposed = !1;
  }
  get object() {
    return this._base.object;
  }
  createNewRef(e) {
    return this._base.createNewRef(e);
  }
  dispose() {
    this._isDisposed || (this._isDisposed = !0, this._base._decreaseRefCount(this._debugOwner));
  }
}
var XR = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, JR = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const c_t = po("diff-review-insert", ke.add, C("accessibleDiffViewerInsertIcon", "Icon for 'Insert' in accessible diff viewer.")), h_t = po("diff-review-remove", ke.remove, C("accessibleDiffViewerRemoveIcon", "Icon for 'Remove' in accessible diff viewer.")), d_t = po("diff-review-close", ke.close, C("accessibleDiffViewerCloseIcon", "Icon for 'Close' in accessible diff viewer."));
let B0 = class extends me {
  static {
    this._ttPolicy = Jf("diffReview", { createHTML: (e) => e });
  }
  constructor(e, t, n, i, s, o, a, l, c) {
    super(), this._parentNode = e, this._visible = t, this._setVisible = n, this._canClose = i, this._width = s, this._height = o, this._diffs = a, this._models = l, this._instantiationService = c, this._state = om(this, (d, u) => {
      const f = this._visible.read(d);
      if (this._parentNode.style.visibility = f ? "visible" : "hidden", !f)
        return null;
      const p = u.add(this._instantiationService.createInstance(Xk, this._diffs, this._models, this._setVisible, this._canClose)), g = u.add(this._instantiationService.createInstance(Jk, this._parentNode, p, this._width, this._height, this._models));
      return { model: p, view: g };
    }).recomputeInitiallyAndOnChange(this._store);
  }
  next() {
    er((e) => {
      const t = this._visible.get();
      this._setVisible(!0, e), t && this._state.get().model.nextGroup(e);
    });
  }
  prev() {
    er((e) => {
      this._setVisible(!0, e), this._state.get().model.previousGroup(e);
    });
  }
  close() {
    er((e) => {
      this._setVisible(!1, e);
    });
  }
};
B0 = XR([
  JR(8, xn)
], B0);
let Xk = class extends me {
  constructor(e, t, n, i, s) {
    super(), this._diffs = e, this._models = t, this._setVisible = n, this.canClose = i, this._accessibilitySignalService = s, this._groups = qt(this, []), this._currentGroupIdx = qt(this, 0), this._currentElementIdx = qt(this, 0), this.groups = this._groups, this.currentGroup = this._currentGroupIdx.map((o, a) => this._groups.read(a)[o]), this.currentGroupIndex = this._currentGroupIdx, this.currentElement = this._currentElementIdx.map((o, a) => this.currentGroup.read(a)?.lines[o]), this._register(nn((o) => {
      const a = this._diffs.read(o);
      if (!a) {
        this._groups.set([], void 0);
        return;
      }
      const l = u_t(a, this._models.getOriginalModel().getLineCount(), this._models.getModifiedModel().getLineCount());
      er((c) => {
        const d = this._models.getModifiedPosition();
        if (d) {
          const u = l.findIndex((f) => d?.lineNumber < f.range.modified.endLineNumberExclusive);
          u !== -1 && this._currentGroupIdx.set(u, c);
        }
        this._groups.set(l, c);
      });
    })), this._register(nn((o) => {
      const a = this.currentElement.read(o);
      a?.type === us.Deleted ? this._accessibilitySignalService.playSignal(mn.diffLineDeleted, { source: "accessibleDiffViewer.currentElementChanged" }) : a?.type === us.Added && this._accessibilitySignalService.playSignal(mn.diffLineInserted, { source: "accessibleDiffViewer.currentElementChanged" });
    })), this._register(nn((o) => {
      const a = this.currentElement.read(o);
      if (a && a.type !== us.Header) {
        const l = a.modifiedLineNumber ?? a.diff.modified.startLineNumber;
        this._models.modifiedSetSelection(Q.fromPositions(new le(l, 1)));
      }
    }));
  }
  _goToGroupDelta(e, t) {
    const n = this.groups.get();
    !n || n.length <= 1 || AR(t, (i) => {
      this._currentGroupIdx.set(pt.ofLength(n.length).clipCyclic(this._currentGroupIdx.get() + e), i), this._currentElementIdx.set(0, i);
    });
  }
  nextGroup(e) {
    this._goToGroupDelta(1, e);
  }
  previousGroup(e) {
    this._goToGroupDelta(-1, e);
  }
  _goToLineDelta(e) {
    const t = this.currentGroup.get();
    !t || t.lines.length <= 1 || er((n) => {
      this._currentElementIdx.set(pt.ofLength(t.lines.length).clip(this._currentElementIdx.get() + e), n);
    });
  }
  goToNextLine() {
    this._goToLineDelta(1);
  }
  goToPreviousLine() {
    this._goToLineDelta(-1);
  }
  goToLine(e) {
    const t = this.currentGroup.get();
    if (!t)
      return;
    const n = t.lines.indexOf(e);
    n !== -1 && er((i) => {
      this._currentElementIdx.set(n, i);
    });
  }
  revealCurrentElementInEditor() {
    if (!this.canClose.get())
      return;
    this._setVisible(!1, void 0);
    const e = this.currentElement.get();
    e && (e.type === us.Deleted ? this._models.originalReveal(Q.fromPositions(new le(e.originalLineNumber, 1))) : this._models.modifiedReveal(e.type !== us.Header ? Q.fromPositions(new le(e.modifiedLineNumber, 1)) : void 0));
  }
  close() {
    this.canClose.get() && (this._setVisible(!1, void 0), this._models.modifiedFocus());
  }
};
Xk = XR([
  JR(4, zy)
], Xk);
const Qm = 3;
function u_t(r, e, t) {
  const n = [];
  for (const i of wI(r, (s, o) => o.modified.startLineNumber - s.modified.endLineNumberExclusive < 2 * Qm)) {
    const s = [];
    s.push(new p_t());
    const o = new lt(Math.max(1, i[0].original.startLineNumber - Qm), Math.min(i[i.length - 1].original.endLineNumberExclusive + Qm, e + 1)), a = new lt(Math.max(1, i[0].modified.startLineNumber - Qm), Math.min(i[i.length - 1].modified.endLineNumberExclusive + Qm, t + 1));
    _Me(i, (d, u) => {
      const f = new lt(d ? d.original.endLineNumberExclusive : o.startLineNumber, u ? u.original.startLineNumber : o.endLineNumberExclusive), p = new lt(d ? d.modified.endLineNumberExclusive : a.startLineNumber, u ? u.modified.startLineNumber : a.endLineNumberExclusive);
      f.forEach((g) => {
        s.push(new A_t(g, p.startLineNumber + (g - f.startLineNumber)));
      }), u && (u.original.forEach((g) => {
        s.push(new g_t(u, g));
      }), u.modified.forEach((g) => {
        s.push(new m_t(u, g));
      }));
    });
    const l = i[0].modified.join(i[i.length - 1].modified), c = i[0].original.join(i[i.length - 1].original);
    n.push(new f_t(new ns(l, c), s));
  }
  return n;
}
var us;
(function(r) {
  r[r.Header = 0] = "Header", r[r.Unchanged = 1] = "Unchanged", r[r.Deleted = 2] = "Deleted", r[r.Added = 3] = "Added";
})(us || (us = {}));
class f_t {
  constructor(e, t) {
    this.range = e, this.lines = t;
  }
}
class p_t {
  constructor() {
    this.type = us.Header;
  }
}
class g_t {
  constructor(e, t) {
    this.diff = e, this.originalLineNumber = t, this.type = us.Deleted, this.modifiedLineNumber = void 0;
  }
}
class m_t {
  constructor(e, t) {
    this.diff = e, this.modifiedLineNumber = t, this.type = us.Added, this.originalLineNumber = void 0;
  }
}
class A_t {
  constructor(e, t) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.type = us.Unchanged;
  }
}
let Jk = class extends me {
  constructor(e, t, n, i, s, o) {
    super(), this._element = e, this._model = t, this._width = n, this._height = i, this._models = s, this._languageService = o, this.domNode = this._element, this.domNode.className = "monaco-component diff-review monaco-editor-background";
    const a = document.createElement("div");
    a.className = "diff-review-actions", this._actionBar = this._register(new Md(a)), this._register(nn((l) => {
      this._actionBar.clear(), this._model.canClose.read(l) && this._actionBar.push(new Ed("diffreview.close", C("label.close", "Close"), "close-diff-review " + Tt.asClassName(d_t), !0, async () => t.close()), { label: !1, icon: !0 });
    })), this._content = document.createElement("div"), this._content.className = "diff-review-content", this._content.setAttribute("role", "code"), this._scrollbar = this._register(new MO(this._content, {})), ys(this.domNode, this._scrollbar.getDomNode(), a), this._register(nn((l) => {
      this._height.read(l), this._width.read(l), this._scrollbar.scanDomNode();
    })), this._register(ht(() => {
      ys(this.domNode);
    })), this._register(g1(this.domNode, { width: this._width, height: this._height })), this._register(g1(this._content, { width: this._width, height: this._height })), this._register(Xl((l, c) => {
      this._model.currentGroup.read(l), this._render(c);
    })), this._register(ir(this.domNode, "keydown", (l) => {
      (l.equals(
        18
        /* KeyCode.DownArrow */
      ) || l.equals(
        2066
        /* KeyCode.DownArrow */
      ) || l.equals(
        530
        /* KeyCode.DownArrow */
      )) && (l.preventDefault(), this._model.goToNextLine()), (l.equals(
        16
        /* KeyCode.UpArrow */
      ) || l.equals(
        2064
        /* KeyCode.UpArrow */
      ) || l.equals(
        528
        /* KeyCode.UpArrow */
      )) && (l.preventDefault(), this._model.goToPreviousLine()), (l.equals(
        9
        /* KeyCode.Escape */
      ) || l.equals(
        2057
        /* KeyCode.Escape */
      ) || l.equals(
        521
        /* KeyCode.Escape */
      ) || l.equals(
        1033
        /* KeyCode.Escape */
      )) && (l.preventDefault(), this._model.close()), (l.equals(
        10
        /* KeyCode.Space */
      ) || l.equals(
        3
        /* KeyCode.Enter */
      )) && (l.preventDefault(), this._model.revealCurrentElementInEditor());
    }));
  }
  _render(e) {
    const t = this._models.getOriginalOptions(), n = this._models.getModifiedOptions(), i = document.createElement("div");
    i.className = "diff-review-table", i.setAttribute("role", "list"), i.setAttribute("aria-label", C("ariaLabel", "Accessible Diff Viewer. Use arrow up and down to navigate.")), Br(i, n.get(
      50
      /* EditorOption.fontInfo */
    )), ys(this._content, i);
    const s = this._models.getOriginalModel(), o = this._models.getModifiedModel();
    if (!s || !o)
      return;
    const a = s.getOptions(), l = o.getOptions(), c = n.get(
      67
      /* EditorOption.lineHeight */
    ), d = this._model.currentGroup.get();
    for (const u of d?.lines || []) {
      if (!d)
        break;
      let f;
      if (u.type === us.Header) {
        const g = document.createElement("div");
        g.className = "diff-review-row", g.setAttribute("role", "listitem");
        const m = d.range, A = this._model.currentGroupIndex.get(), w = this._model.groups.get().length, v = (D) => D === 0 ? C("no_lines_changed", "no lines changed") : D === 1 ? C("one_line_changed", "1 line changed") : C("more_lines_changed", "{0} lines changed", D), y = v(m.original.length), _ = v(m.modified.length);
        g.setAttribute("aria-label", C({
          key: "header",
          comment: [
            "This is the ARIA label for a git diff header.",
            "A git diff header looks like this: @@ -154,12 +159,39 @@.",
            "That encodes that at original line 154 (which is now line 159), 12 lines were removed/changed with 39 lines.",
            "Variables 0 and 1 refer to the diff index out of total number of diffs.",
            "Variables 2 and 4 will be numbers (a line number).",
            'Variables 3 and 5 will be "no lines changed", "1 line changed" or "X lines changed", localized separately.'
          ]
        }, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", A + 1, w, m.original.startLineNumber, y, m.modified.startLineNumber, _));
        const S = document.createElement("div");
        S.className = "diff-review-cell diff-review-summary", S.appendChild(document.createTextNode(`${A + 1}/${w}: @@ -${m.original.startLineNumber},${m.original.length} +${m.modified.startLineNumber},${m.modified.length} @@`)), g.appendChild(S), f = g;
      } else
        f = this._createRow(u, c, this._width.get(), t, s, a, n, o, l);
      i.appendChild(f);
      const p = dt((g) => (
        /** @description isSelected */
        this._model.currentElement.read(g) === u
      ));
      e.add(nn((g) => {
        const m = p.read(g);
        f.tabIndex = m ? 0 : -1, m && f.focus();
      })), e.add(fe(f, "focus", () => {
        this._model.goToLine(u);
      }));
    }
    this._scrollbar.scanDomNode();
  }
  _createRow(e, t, n, i, s, o, a, l, c) {
    const d = i.get(
      146
      /* EditorOption.layoutInfo */
    ), u = d.glyphMarginWidth + d.lineNumbersWidth, f = a.get(
      146
      /* EditorOption.layoutInfo */
    ), p = 10 + f.glyphMarginWidth + f.lineNumbersWidth;
    let g = "diff-review-row", m = "";
    const A = "diff-review-spacer";
    let w = null;
    switch (e.type) {
      case us.Added:
        g = "diff-review-row line-insert", m = " char-insert", w = c_t;
        break;
      case us.Deleted:
        g = "diff-review-row line-delete", m = " char-delete", w = h_t;
        break;
    }
    const v = document.createElement("div");
    v.style.minWidth = n + "px", v.className = g, v.setAttribute("role", "listitem"), v.ariaLevel = "";
    const y = document.createElement("div");
    y.className = "diff-review-cell", y.style.height = `${t}px`, v.appendChild(y);
    const _ = document.createElement("span");
    _.style.width = u + "px", _.style.minWidth = u + "px", _.className = "diff-review-line-number" + m, e.originalLineNumber !== void 0 ? _.appendChild(document.createTextNode(String(e.originalLineNumber))) : _.innerText = " ", y.appendChild(_);
    const S = document.createElement("span");
    S.style.width = p + "px", S.style.minWidth = p + "px", S.style.paddingRight = "10px", S.className = "diff-review-line-number" + m, e.modifiedLineNumber !== void 0 ? S.appendChild(document.createTextNode(String(e.modifiedLineNumber))) : S.innerText = " ", y.appendChild(S);
    const D = document.createElement("span");
    if (D.className = A, w) {
      const T = document.createElement("span");
      T.className = Tt.asClassName(w), T.innerText = "  ", D.appendChild(T);
    } else
      D.innerText = "  ";
    y.appendChild(D);
    let M;
    if (e.modifiedLineNumber !== void 0) {
      let T = this._getLineHtml(l, a, c.tabSize, e.modifiedLineNumber, this._languageService.languageIdCodec);
      B0._ttPolicy && (T = B0._ttPolicy.createHTML(T)), y.insertAdjacentHTML("beforeend", T), M = l.getLineContent(e.modifiedLineNumber);
    } else {
      let T = this._getLineHtml(s, i, o.tabSize, e.originalLineNumber, this._languageService.languageIdCodec);
      B0._ttPolicy && (T = B0._ttPolicy.createHTML(T)), y.insertAdjacentHTML("beforeend", T), M = s.getLineContent(e.originalLineNumber);
    }
    M.length === 0 && (M = C("blankLine", "blank"));
    let L = "";
    switch (e.type) {
      case us.Unchanged:
        e.originalLineNumber === e.modifiedLineNumber ? L = C({ key: "unchangedLine", comment: ["The placeholders are contents of the line and should not be translated."] }, "{0} unchanged line {1}", M, e.originalLineNumber) : L = C("equalLine", "{0} original line {1} modified line {2}", M, e.originalLineNumber, e.modifiedLineNumber);
        break;
      case us.Added:
        L = C("insertLine", "+ {0} modified line {1}", M, e.modifiedLineNumber);
        break;
      case us.Deleted:
        L = C("deleteLine", "- {0} original line {1}", M, e.originalLineNumber);
        break;
    }
    return v.setAttribute("aria-label", L), v;
  }
  _getLineHtml(e, t, n, i, s) {
    const o = e.getLineContent(i), a = t.get(
      50
      /* EditorOption.fontInfo */
    ), l = Ri.createEmpty(o, s), c = zo.isBasicASCII(o, e.mightContainNonBasicASCII()), d = zo.containsRTL(o, c, e.mightContainRTL());
    return ny(new tm(a.isMonospace && !t.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), a.canUseHalfwidthRightwardsArrow, o, !1, c, d, 0, l, [], n, 0, a.spaceWidth, a.middotWidth, a.wsmiddotWidth, t.get(
      118
      /* EditorOption.stopRenderingLineAfter */
    ), t.get(
      100
      /* EditorOption.renderWhitespace */
    ), t.get(
      95
      /* EditorOption.renderControlCharacters */
    ), t.get(
      51
      /* EditorOption.fontLigatures */
    ) !== Bl.OFF, null)).html;
  }
};
Jk = XR([
  JR(5, sr)
], Jk);
class w_t {
  constructor(e) {
    this.editors = e;
  }
  getOriginalModel() {
    return this.editors.original.getModel();
  }
  getOriginalOptions() {
    return this.editors.original.getOptions();
  }
  originalReveal(e) {
    this.editors.original.revealRange(e), this.editors.original.setSelection(e), this.editors.original.focus();
  }
  getModifiedModel() {
    return this.editors.modified.getModel();
  }
  getModifiedOptions() {
    return this.editors.modified.getOptions();
  }
  modifiedReveal(e) {
    e && (this.editors.modified.revealRange(e), this.editors.modified.setSelection(e)), this.editors.modified.focus();
  }
  modifiedSetSelection(e) {
    this.editors.modified.setSelection(e);
  }
  modifiedFocus() {
    this.editors.modified.focus();
  }
  getModifiedPosition() {
    return this.editors.modified.getPosition() ?? void 0;
  }
}
Z("diffEditor.move.border", "#8b8b8b9c", C("diffEditor.move.border", "The border color for text that got moved in the diff editor."));
Z("diffEditor.moveActive.border", "#FFA500", C("diffEditor.moveActive.border", "The active border color for text that got moved in the diff editor."));
Z("diffEditor.unchangedRegionShadow", { dark: "#000000", light: "#737373BF", hcDark: "#000000", hcLight: "#737373BF" }, C("diffEditor.unchangedRegionShadow", "The color of the shadow around unchanged region widgets."));
const v_t = po("diff-insert", ke.add, C("diffInsertIcon", "Line decoration for inserts in the diff editor.")), MTe = po("diff-remove", ke.remove, C("diffRemoveIcon", "Line decoration for removals in the diff editor.")), X9e = fi.register({
  className: "line-insert",
  description: "line-insert",
  isWholeLine: !0,
  linesDecorationsClassName: "insert-sign " + Tt.asClassName(v_t),
  marginClassName: "gutter-insert"
}), J9e = fi.register({
  className: "line-delete",
  description: "line-delete",
  isWholeLine: !0,
  linesDecorationsClassName: "delete-sign " + Tt.asClassName(MTe),
  marginClassName: "gutter-delete"
}), $9e = fi.register({
  className: "line-insert",
  description: "line-insert",
  isWholeLine: !0,
  marginClassName: "gutter-insert"
}), ebe = fi.register({
  className: "line-delete",
  description: "line-delete",
  isWholeLine: !0,
  marginClassName: "gutter-delete"
}), tbe = fi.register({
  className: "char-insert",
  description: "char-insert",
  shouldFillLineOnLineBreak: !0
}), b_t = fi.register({
  className: "char-insert",
  description: "char-insert",
  isWholeLine: !0
}), y_t = fi.register({
  className: "char-insert diff-range-empty",
  description: "char-insert diff-range-empty"
}), $k = fi.register({
  className: "char-delete",
  description: "char-delete",
  shouldFillLineOnLineBreak: !0
}), C_t = fi.register({
  className: "char-delete",
  description: "char-delete",
  isWholeLine: !0
}), E_t = fi.register({
  className: "char-delete diff-range-empty",
  description: "char-delete diff-range-empty"
});
var DTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, eN = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, c0;
const LTe = Wt("diffProviderFactoryService");
let tN = class {
  constructor(e) {
    this.instantiationService = e;
  }
  createDiffProvider(e) {
    return this.instantiationService.createInstance(nN, e);
  }
};
tN = DTe([
  eN(0, xn)
], tN);
en(
  LTe,
  tN,
  1
  /* InstantiationType.Delayed */
);
let nN = class {
  static {
    c0 = this;
  }
  static {
    this.diffCache = /* @__PURE__ */ new Map();
  }
  constructor(e, t, n) {
    this.editorWorkerService = t, this.telemetryService = n, this.onDidChangeEventEmitter = new $(), this.onDidChange = this.onDidChangeEventEmitter.event, this.diffAlgorithm = "advanced", this.diffAlgorithmOnDidChangeSubscription = void 0, this.setOptions(e);
  }
  dispose() {
    this.diffAlgorithmOnDidChangeSubscription?.dispose();
  }
  async computeDiff(e, t, n, i) {
    if (typeof this.diffAlgorithm != "string")
      return this.diffAlgorithm.computeDiff(e, t, n, i);
    if (e.isDisposed() || t.isDisposed())
      return {
        changes: [],
        identical: !0,
        quitEarly: !1,
        moves: []
      };
    if (e.getLineCount() === 1 && e.getLineMaxColumn(1) === 1)
      return t.getLineCount() === 1 && t.getLineMaxColumn(1) === 1 ? {
        changes: [],
        identical: !0,
        quitEarly: !1,
        moves: []
      } : {
        changes: [
          new Po(new lt(1, 2), new lt(1, t.getLineCount() + 1), [
            new Eo(e.getFullModelRange(), t.getFullModelRange())
          ])
        ],
        identical: !1,
        quitEarly: !1,
        moves: []
      };
    const s = JSON.stringify([e.uri.toString(), t.uri.toString()]), o = JSON.stringify([e.id, t.id, e.getAlternativeVersionId(), t.getAlternativeVersionId(), JSON.stringify(n)]), a = c0.diffCache.get(s);
    if (a && a.context === o)
      return a.result;
    const l = jf.create(), c = await this.editorWorkerService.computeDiff(e.uri, t.uri, n, this.diffAlgorithm), d = l.elapsed();
    if (this.telemetryService.publicLog2("diffEditor.computeDiff", {
      timeMs: d,
      timedOut: c?.quitEarly ?? !0,
      detectedMoves: n.computeMoves ? c?.moves.length ?? 0 : -1
    }), i.isCancellationRequested)
      return {
        changes: [],
        identical: !1,
        quitEarly: !0,
        moves: []
      };
    if (!c)
      throw new Error("no diff result available");
    return c0.diffCache.size > 10 && c0.diffCache.delete(c0.diffCache.keys().next().value), c0.diffCache.set(s, { result: c, context: o }), c;
  }
  setOptions(e) {
    let t = !1;
    e.diffAlgorithm && this.diffAlgorithm !== e.diffAlgorithm && (this.diffAlgorithmOnDidChangeSubscription?.dispose(), this.diffAlgorithmOnDidChangeSubscription = void 0, this.diffAlgorithm = e.diffAlgorithm, typeof e.diffAlgorithm != "string" && (this.diffAlgorithmOnDidChangeSubscription = e.diffAlgorithm.onDidChange(() => this.onDidChangeEventEmitter.fire())), t = !0), t && this.onDidChangeEventEmitter.fire();
  }
};
nN = c0 = DTe([
  eN(1, Hw),
  eN(2, I1)
], nN);
function $R() {
  return TM && !!TM.VSCODE_DEV;
}
function kTe(r) {
  if ($R()) {
    const e = __t();
    return e.add(r), {
      dispose() {
        e.delete(r);
      }
    };
  } else
    return { dispose() {
    } };
}
function __t() {
  l5 || (l5 = /* @__PURE__ */ new Set());
  const r = globalThis;
  return r.$hotReload_applyNewExports || (r.$hotReload_applyNewExports = (e) => {
    const t = { config: { mode: void 0 }, ...e }, n = [];
    for (const i of l5) {
      const s = i(t);
      s && n.push(s);
    }
    if (n.length > 0)
      return (i) => {
        let s = !1;
        for (const o of n)
          o(i) && (s = !0);
        return s;
      };
  }), l5;
}
let l5;
$R() && kTe(({ oldExports: r, newSrc: e, config: t }) => {
  if (t.mode === "patch-prototype")
    return (n) => {
      for (const i in n) {
        const s = n[i];
        if (console.log(`[hot-reload] Patching prototype methods of '${i}'`, { exportedItem: s }), typeof s == "function" && s.prototype) {
          const o = r[i];
          if (o) {
            for (const a of Object.getOwnPropertyNames(s.prototype)) {
              const l = Object.getOwnPropertyDescriptor(s.prototype, a), c = Object.getOwnPropertyDescriptor(o.prototype, a);
              l?.value?.toString() !== c?.value?.toString() && console.log(`[hot-reload] Patching prototype method '${i}.${a}'`), Object.defineProperty(o.prototype, a, l);
            }
            n[i] = o;
          }
        }
      }
      return !0;
    };
});
function za(r, e) {
  return x_t([r], e), r;
}
function x_t(r, e) {
  $R() && aa("reload", (n) => kTe(({ oldExports: i }) => {
    if ([...Object.values(i)].some((s) => r.includes(s)))
      return (s) => (n(void 0), !0);
  })).read(e);
}
var S_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, M_t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let iN = class extends me {
  setActiveMovedText(e) {
    this._activeMovedText.set(e, void 0);
  }
  constructor(e, t, n) {
    super(), this.model = e, this._options = t, this._diffProviderFactoryService = n, this._isDiffUpToDate = qt(this, !1), this.isDiffUpToDate = this._isDiffUpToDate, this._diff = qt(this, void 0), this.diff = this._diff, this._unchangedRegions = qt(this, void 0), this.unchangedRegions = dt(this, (a) => this._options.hideUnchangedRegions.read(a) ? this._unchangedRegions.read(a)?.regions ?? [] : (er((l) => {
      for (const c of this._unchangedRegions.get()?.regions || [])
        c.collapseAll(l);
    }), [])), this.movedTextToCompare = qt(this, void 0), this._activeMovedText = qt(this, void 0), this._hoveredMovedText = qt(this, void 0), this.activeMovedText = dt(this, (a) => this.movedTextToCompare.read(a) ?? this._hoveredMovedText.read(a) ?? this._activeMovedText.read(a)), this._cancellationTokenSource = new Jg(), this._diffProvider = dt(this, (a) => {
      const l = this._diffProviderFactoryService.createDiffProvider({
        diffAlgorithm: this._options.diffAlgorithm.read(a)
      }), c = aa("onDidChange", l.onDidChange);
      return {
        diffProvider: l,
        onChangeSignal: c
      };
    }), this._register(ht(() => this._cancellationTokenSource.cancel()));
    const i = bR("contentChangedSignal"), s = this._register(new Nr(() => i.trigger(void 0), 200));
    this._register(nn((a) => {
      const l = this._unchangedRegions.read(a);
      if (!l || l.regions.some((g) => g.isDragged.read(a)))
        return;
      const c = l.originalDecorationIds.map((g) => e.original.getDecorationRange(g)).map((g) => g ? lt.fromRangeInclusive(g) : void 0), d = l.modifiedDecorationIds.map((g) => e.modified.getDecorationRange(g)).map((g) => g ? lt.fromRangeInclusive(g) : void 0), u = l.regions.map((g, m) => !c[m] || !d[m] ? void 0 : new Fu(c[m].startLineNumber, d[m].startLineNumber, c[m].length, g.visibleLineCountTop.read(a), g.visibleLineCountBottom.read(a))).filter(tg), f = [];
      let p = !1;
      for (const g of wI(u, (m, A) => m.getHiddenModifiedRange(a).endLineNumberExclusive === A.getHiddenModifiedRange(a).startLineNumber))
        if (g.length > 1) {
          p = !0;
          const m = g.reduce((w, v) => w + v.lineCount, 0), A = new Fu(g[0].originalLineNumber, g[0].modifiedLineNumber, m, g[0].visibleLineCountTop.get(), g[g.length - 1].visibleLineCountBottom.get());
          f.push(A);
        } else
          f.push(g[0]);
      if (p) {
        const g = e.original.deltaDecorations(l.originalDecorationIds, f.map((A) => ({ range: A.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))), m = e.modified.deltaDecorations(l.modifiedDecorationIds, f.map((A) => ({ range: A.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })));
        er((A) => {
          this._unchangedRegions.set({
            regions: f,
            originalDecorationIds: g,
            modifiedDecorationIds: m
          }, A);
        });
      }
    }));
    const o = (a, l, c) => {
      const d = Fu.fromDiffs(a.changes, e.original.getLineCount(), e.modified.getLineCount(), this._options.hideUnchangedRegionsMinimumLineCount.read(c), this._options.hideUnchangedRegionsContextLineCount.read(c));
      let u;
      const f = this._unchangedRegions.get();
      if (f) {
        const A = f.originalDecorationIds.map((_) => e.original.getDecorationRange(_)).map((_) => _ ? lt.fromRangeInclusive(_) : void 0), w = f.modifiedDecorationIds.map((_) => e.modified.getDecorationRange(_)).map((_) => _ ? lt.fromRangeInclusive(_) : void 0);
        let y = a_t(f.regions.map((_, S) => {
          if (!A[S] || !w[S])
            return;
          const D = A[S].length;
          return new Fu(
            A[S].startLineNumber,
            w[S].startLineNumber,
            D,
            // The visible area can shrink by edits -> we have to account for this
            Math.min(_.visibleLineCountTop.get(), D),
            Math.min(_.visibleLineCountBottom.get(), D - _.visibleLineCountTop.get())
          );
        }).filter(tg), (_, S) => !S || _.modifiedLineNumber >= S.modifiedLineNumber + S.lineCount && _.originalLineNumber >= S.originalLineNumber + S.lineCount).map((_) => new ns(_.getHiddenOriginalRange(c), _.getHiddenModifiedRange(c)));
        y = ns.clip(y, lt.ofLength(1, e.original.getLineCount()), lt.ofLength(1, e.modified.getLineCount())), u = ns.inverse(y, e.original.getLineCount(), e.modified.getLineCount());
      }
      const p = [];
      if (u)
        for (const A of d) {
          const w = u.filter((v) => v.original.intersectsStrict(A.originalUnchangedRange) && v.modified.intersectsStrict(A.modifiedUnchangedRange));
          p.push(...A.setVisibleRanges(w, l));
        }
      else
        p.push(...d);
      const g = e.original.deltaDecorations(f?.originalDecorationIds || [], p.map((A) => ({ range: A.originalUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } }))), m = e.modified.deltaDecorations(f?.modifiedDecorationIds || [], p.map((A) => ({ range: A.modifiedUnchangedRange.toInclusiveRange(), options: { description: "unchanged" } })));
      this._unchangedRegions.set({
        regions: p,
        originalDecorationIds: g,
        modifiedDecorationIds: m
      }, l);
    };
    this._register(e.modified.onDidChangeContent((a) => {
      if (this._diff.get()) {
        const c = pd.fromModelContentChanges(a.changes);
        this._lastDiff, e.original, e.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    })), this._register(e.original.onDidChangeContent((a) => {
      if (this._diff.get()) {
        const c = pd.fromModelContentChanges(a.changes);
        this._lastDiff, e.original, e.modified;
      }
      this._isDiffUpToDate.set(!1, void 0), s.schedule();
    })), this._register(Xl(async (a, l) => {
      this._options.hideUnchangedRegionsMinimumLineCount.read(a), this._options.hideUnchangedRegionsContextLineCount.read(a), s.cancel(), i.read(a);
      const c = this._diffProvider.read(a);
      c.onChangeSignal.read(a), za(dLe, a), za(JD, a), this._isDiffUpToDate.set(!1, void 0);
      let d = [];
      l.add(e.original.onDidChangeContent((p) => {
        const g = pd.fromModelContentChanges(p.changes);
        d = m9(d, g);
      }));
      let u = [];
      l.add(e.modified.onDidChangeContent((p) => {
        const g = pd.fromModelContentChanges(p.changes);
        u = m9(u, g);
      }));
      let f = await c.diffProvider.computeDiff(e.original, e.modified, {
        ignoreTrimWhitespace: this._options.ignoreTrimWhitespace.read(a),
        maxComputationTimeMs: this._options.maxComputationTimeMs.read(a),
        computeMoves: this._options.showMoves.read(a)
      }, this._cancellationTokenSource.token);
      this._cancellationTokenSource.token.isCancellationRequested || e.original.isDisposed() || e.modified.isDisposed() || (f = D_t(f, e.original, e.modified), f = (e.original, e.modified, void 0) ?? f, f = (e.original, e.modified, void 0) ?? f, er((p) => {
        o(f, p), this._lastDiff = f;
        const g = eV.fromDiffResult(f);
        this._diff.set(g, p), this._isDiffUpToDate.set(!0, p);
        const m = this.movedTextToCompare.get();
        this.movedTextToCompare.set(m ? this._lastDiff.moves.find((A) => A.lineRangeMapping.modified.intersect(m.lineRangeMapping.modified)) : void 0, p);
      }));
    }));
  }
  ensureModifiedLineIsVisible(e, t, n) {
    if (this.diff.get()?.mappings.length === 0)
      return;
    const i = this._unchangedRegions.get()?.regions || [];
    for (const s of i)
      if (s.getHiddenModifiedRange(void 0).contains(e)) {
        s.showModifiedLine(e, t, n);
        return;
      }
  }
  ensureOriginalLineIsVisible(e, t, n) {
    if (this.diff.get()?.mappings.length === 0)
      return;
    const i = this._unchangedRegions.get()?.regions || [];
    for (const s of i)
      if (s.getHiddenOriginalRange(void 0).contains(e)) {
        s.showOriginalLine(e, t, n);
        return;
      }
  }
  async waitForDiff() {
    await A7t(this.isDiffUpToDate, (e) => e);
  }
  serializeState() {
    return {
      collapsedRegions: this._unchangedRegions.get()?.regions.map((t) => ({ range: t.getHiddenModifiedRange(void 0).serialize() }))
    };
  }
  restoreSerializedState(e) {
    const t = e.collapsedRegions?.map((i) => lt.deserialize(i.range)), n = this._unchangedRegions.get();
    !n || !t || er((i) => {
      for (const s of n.regions)
        for (const o of t)
          if (s.modifiedUnchangedRange.intersect(o)) {
            s.setHiddenModifiedRange(o, i);
            break;
          }
    });
  }
};
iN = S_t([
  M_t(2, LTe)
], iN);
function D_t(r, e, t) {
  return {
    changes: r.changes.map((n) => new Po(n.original, n.modified, n.innerChanges ? n.innerChanges.map((i) => L_t(i, e, t)) : void 0)),
    moves: r.moves,
    identical: r.identical,
    quitEarly: r.quitEarly
  };
}
function L_t(r, e, t) {
  let n = r.originalRange, i = r.modifiedRange;
  return n.startColumn === 1 && i.startColumn === 1 && (n.endColumn !== 1 || i.endColumn !== 1) && n.endColumn === e.getLineMaxColumn(n.endLineNumber) && i.endColumn === t.getLineMaxColumn(i.endLineNumber) && n.endLineNumber < e.getLineCount() && i.endLineNumber < t.getLineCount() && (n = n.setEndPosition(n.endLineNumber + 1, 1), i = i.setEndPosition(i.endLineNumber + 1, 1)), new Eo(n, i);
}
class eV {
  static fromDiffResult(e) {
    return new eV(e.changes.map((t) => new NTe(t)), e.moves || [], e.identical, e.quitEarly);
  }
  constructor(e, t, n, i) {
    this.mappings = e, this.movedTexts = t, this.identical = n, this.quitEarly = i;
  }
}
class NTe {
  constructor(e) {
    this.lineRangeMapping = e;
  }
}
class Fu {
  static fromDiffs(e, t, n, i, s) {
    const o = Po.inverse(e, t, n), a = [];
    for (const l of o) {
      let c = l.original.startLineNumber, d = l.modified.startLineNumber, u = l.original.length;
      const f = c === 1 && d === 1, p = c + u === t + 1 && d + u === n + 1;
      (f || p) && u >= s + i ? (f && !p && (u -= s), p && !f && (c += s, d += s, u -= s), a.push(new Fu(c, d, u, 0, 0))) : u >= s * 2 + i && (c += s, d += s, u -= s * 2, a.push(new Fu(c, d, u, 0, 0)));
    }
    return a;
  }
  get originalUnchangedRange() {
    return lt.ofLength(this.originalLineNumber, this.lineCount);
  }
  get modifiedUnchangedRange() {
    return lt.ofLength(this.modifiedLineNumber, this.lineCount);
  }
  constructor(e, t, n, i, s) {
    this.originalLineNumber = e, this.modifiedLineNumber = t, this.lineCount = n, this._visibleLineCountTop = qt(this, 0), this.visibleLineCountTop = this._visibleLineCountTop, this._visibleLineCountBottom = qt(this, 0), this.visibleLineCountBottom = this._visibleLineCountBottom, this._shouldHideControls = dt(this, (l) => (
      /** @description isVisible */
      this.visibleLineCountTop.read(l) + this.visibleLineCountBottom.read(l) === this.lineCount && !this.isDragged.read(l)
    )), this.isDragged = qt(this, void 0);
    const o = Math.max(Math.min(i, this.lineCount), 0), a = Math.max(Math.min(s, this.lineCount - i), 0);
    t5e(i === o), t5e(s === a), this._visibleLineCountTop.set(o, void 0), this._visibleLineCountBottom.set(a, void 0);
  }
  setVisibleRanges(e, t) {
    const n = [], i = new sa(e.map((l) => l.modified)).subtractFrom(this.modifiedUnchangedRange);
    let s = this.originalLineNumber, o = this.modifiedLineNumber;
    const a = this.modifiedLineNumber + this.lineCount;
    if (i.ranges.length === 0)
      this.showAll(t), n.push(this);
    else {
      let l = 0;
      for (const c of i.ranges) {
        const d = l === i.ranges.length - 1;
        l++;
        const u = (d ? a : c.endLineNumberExclusive) - o, f = new Fu(s, o, u, 0, 0);
        f.setHiddenModifiedRange(c, t), n.push(f), s = f.originalUnchangedRange.endLineNumberExclusive, o = f.modifiedUnchangedRange.endLineNumberExclusive;
      }
    }
    return n;
  }
  shouldHideControls(e) {
    return this._shouldHideControls.read(e);
  }
  getHiddenOriginalRange(e) {
    return lt.ofLength(this.originalLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  getHiddenModifiedRange(e) {
    return lt.ofLength(this.modifiedLineNumber + this._visibleLineCountTop.read(e), this.lineCount - this._visibleLineCountTop.read(e) - this._visibleLineCountBottom.read(e));
  }
  setHiddenModifiedRange(e, t) {
    const n = e.startLineNumber - this.modifiedLineNumber, i = this.modifiedLineNumber + this.lineCount - e.endLineNumberExclusive;
    this.setState(n, i, t);
  }
  getMaxVisibleLineCountTop() {
    return this.lineCount - this._visibleLineCountBottom.get();
  }
  getMaxVisibleLineCountBottom() {
    return this.lineCount - this._visibleLineCountTop.get();
  }
  showMoreAbove(e = 10, t) {
    const n = this.getMaxVisibleLineCountTop();
    this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + e, n), t);
  }
  showMoreBelow(e = 10, t) {
    const n = this.lineCount - this._visibleLineCountTop.get();
    this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + e, n), t);
  }
  showAll(e) {
    this._visibleLineCountBottom.set(this.lineCount - this._visibleLineCountTop.get(), e);
  }
  showModifiedLine(e, t, n) {
    const i = e + 1 - (this.modifiedLineNumber + this._visibleLineCountTop.get()), s = this.modifiedLineNumber - this._visibleLineCountBottom.get() + this.lineCount - e;
    t === 0 && i < s || t === 1 ? this._visibleLineCountTop.set(this._visibleLineCountTop.get() + i, n) : this._visibleLineCountBottom.set(this._visibleLineCountBottom.get() + s, n);
  }
  showOriginalLine(e, t, n) {
    const i = e - this.originalLineNumber, s = this.originalLineNumber + this.lineCount - e;
    t === 0 && i < s || t === 1 ? this._visibleLineCountTop.set(Math.min(this._visibleLineCountTop.get() + s - i, this.getMaxVisibleLineCountTop()), n) : this._visibleLineCountBottom.set(Math.min(this._visibleLineCountBottom.get() + i - s, this.getMaxVisibleLineCountBottom()), n);
  }
  collapseAll(e) {
    this._visibleLineCountTop.set(0, e), this._visibleLineCountBottom.set(0, e);
  }
  setState(e, t, n) {
    e = Math.max(Math.min(e, this.lineCount), 0), t = Math.max(Math.min(t, this.lineCount - e), 0), this._visibleLineCountTop.set(e, n), this._visibleLineCountBottom.set(t, n);
  }
}
class k_t extends me {
  get visibility() {
    return this._visibility;
  }
  set visibility(e) {
    this._visibility !== e && (this._visibility = e, this._diffActions.style.visibility = e ? "visible" : "hidden");
  }
  constructor(e, t, n, i, s, o, a, l, c) {
    super(), this._getViewZoneId = e, this._marginDomNode = t, this._modifiedEditor = n, this._diff = i, this._editor = s, this._viewLineCounts = o, this._originalTextModel = a, this._contextMenuService = l, this._clipboardService = c, this._visibility = !1, this._marginDomNode.style.zIndex = "10", this._diffActions = document.createElement("div"), this._diffActions.className = Tt.asClassName(ke.lightBulb) + " lightbulb-glyph", this._diffActions.style.position = "absolute";
    const d = this._modifiedEditor.getOption(
      67
      /* EditorOption.lineHeight */
    );
    this._diffActions.style.right = "0px", this._diffActions.style.visibility = "hidden", this._diffActions.style.height = `${d}px`, this._diffActions.style.lineHeight = `${d}px`, this._marginDomNode.appendChild(this._diffActions);
    let u = 0;
    const f = n.getOption(
      128
      /* EditorOption.useShadowDOM */
    ) && !pf, p = (g, m) => {
      this._contextMenuService.showContextMenu({
        domForShadowRoot: f ? n.getDomNode() ?? void 0 : void 0,
        getAnchor: () => ({ x: g, y: m }),
        getActions: () => {
          const A = [], w = i.modified.isEmpty;
          return A.push(new Ed("diff.clipboard.copyDeletedContent", w ? i.original.length > 1 ? C("diff.clipboard.copyDeletedLinesContent.label", "Copy deleted lines") : C("diff.clipboard.copyDeletedLinesContent.single.label", "Copy deleted line") : i.original.length > 1 ? C("diff.clipboard.copyChangedLinesContent.label", "Copy changed lines") : C("diff.clipboard.copyChangedLinesContent.single.label", "Copy changed line"), void 0, !0, async () => {
            const y = this._originalTextModel.getValueInRange(i.original.toExclusiveRange());
            await this._clipboardService.writeText(y);
          })), i.original.length > 1 && A.push(new Ed("diff.clipboard.copyDeletedLineContent", w ? C("diff.clipboard.copyDeletedLineContent.label", "Copy deleted line ({0})", i.original.startLineNumber + u) : C("diff.clipboard.copyChangedLineContent.label", "Copy changed line ({0})", i.original.startLineNumber + u), void 0, !0, async () => {
            let y = this._originalTextModel.getLineContent(i.original.startLineNumber + u);
            y === "" && (y = this._originalTextModel.getEndOfLineSequence() === 0 ? `
` : `\r
`), await this._clipboardService.writeText(y);
          })), n.getOption(
            92
            /* EditorOption.readOnly */
          ) || A.push(new Ed("diff.inline.revertChange", C("diff.inline.revertChange.label", "Revert this change"), void 0, !0, async () => {
            this._editor.revert(this._diff);
          })), A;
        },
        autoSelectFirstItem: !0
      });
    };
    this._register(ir(this._diffActions, "mousedown", (g) => {
      if (!g.leftButton)
        return;
      const { top: m, height: A } = To(this._diffActions), w = Math.floor(d / 3);
      g.preventDefault(), p(g.posx, m + A + w);
    })), this._register(n.onMouseMove((g) => {
      (g.target.type === 8 || g.target.type === 5) && g.target.detail.viewZoneId === this._getViewZoneId() ? (u = this._updateLightBulbPosition(this._marginDomNode, g.event.browserEvent.y, d), this.visibility = !0) : this.visibility = !1;
    })), this._register(n.onMouseDown((g) => {
      g.event.leftButton && (g.target.type === 8 || g.target.type === 5) && g.target.detail.viewZoneId === this._getViewZoneId() && (g.event.preventDefault(), u = this._updateLightBulbPosition(this._marginDomNode, g.event.browserEvent.y, d), p(g.event.posx, g.event.posy + d));
    }));
  }
  _updateLightBulbPosition(e, t, n) {
    const { top: i } = To(e), s = t - i, o = Math.floor(s / n), a = o * n;
    if (this._diffActions.style.top = `${a}px`, this._viewLineCounts) {
      let l = 0;
      for (let c = 0; c < this._viewLineCounts.length; c++)
        if (l += this._viewLineCounts[c], o < l)
          return c;
    }
    return o;
  }
}
const nbe = Jf("diffEditorWidget", { createHTML: (r) => r });
function N_t(r, e, t, n) {
  Br(n, e.fontInfo);
  const i = t.length > 0, s = new J7(1e4);
  let o = 0, a = 0;
  const l = [];
  for (let f = 0; f < r.lineTokens.length; f++) {
    const p = f + 1, g = r.lineTokens[f], m = r.lineBreakData[f], A = bf.filter(t, p, 1, Number.MAX_SAFE_INTEGER);
    if (m) {
      let w = 0;
      for (const v of m.breakOffsets) {
        const y = g.sliceAndInflate(w, v, 0);
        o = Math.max(o, ibe(a, y, bf.extractWrapped(A, w, v), i, r.mightContainNonBasicASCII, r.mightContainRTL, e, s)), a++, w = v;
      }
      l.push(m.breakOffsets.length);
    } else
      l.push(1), o = Math.max(o, ibe(a, g, A, i, r.mightContainNonBasicASCII, r.mightContainRTL, e, s)), a++;
  }
  o += e.scrollBeyondLastColumn;
  const c = s.build(), d = nbe ? nbe.createHTML(c) : c;
  n.innerHTML = d;
  const u = o * e.typicalHalfwidthCharacterWidth;
  return {
    heightInLines: a,
    minWidthInPx: u,
    viewLineCounts: l
  };
}
class T_t {
  constructor(e, t, n, i) {
    this.lineTokens = e, this.lineBreakData = t, this.mightContainNonBasicASCII = n, this.mightContainRTL = i;
  }
}
class tV {
  static fromEditor(e) {
    const t = e.getOptions(), n = t.get(
      50
      /* EditorOption.fontInfo */
    ), i = t.get(
      146
      /* EditorOption.layoutInfo */
    );
    return new tV(e.getModel()?.getOptions().tabSize || 0, n, t.get(
      33
      /* EditorOption.disableMonospaceOptimizations */
    ), n.typicalHalfwidthCharacterWidth, t.get(
      105
      /* EditorOption.scrollBeyondLastColumn */
    ), t.get(
      67
      /* EditorOption.lineHeight */
    ), i.decorationsWidth, t.get(
      118
      /* EditorOption.stopRenderingLineAfter */
    ), t.get(
      100
      /* EditorOption.renderWhitespace */
    ), t.get(
      95
      /* EditorOption.renderControlCharacters */
    ), t.get(
      51
      /* EditorOption.fontLigatures */
    ));
  }
  constructor(e, t, n, i, s, o, a, l, c, d, u) {
    this.tabSize = e, this.fontInfo = t, this.disableMonospaceOptimizations = n, this.typicalHalfwidthCharacterWidth = i, this.scrollBeyondLastColumn = s, this.lineHeight = o, this.lineDecorationsWidth = a, this.stopRenderingLineAfter = l, this.renderWhitespace = c, this.renderControlCharacters = d, this.fontLigatures = u;
  }
}
function ibe(r, e, t, n, i, s, o, a) {
  a.appendString('<div class="view-line'), n || a.appendString(" char-delete"), a.appendString('" style="top:'), a.appendString(String(r * o.lineHeight)), a.appendString('px;width:1000000px;">');
  const l = e.getLineContent(), c = zo.isBasicASCII(l, i), d = zo.containsRTL(l, c, s), u = pO(new tm(
    o.fontInfo.isMonospace && !o.disableMonospaceOptimizations,
    o.fontInfo.canUseHalfwidthRightwardsArrow,
    l,
    !1,
    c,
    d,
    0,
    e,
    t,
    o.tabSize,
    0,
    o.fontInfo.spaceWidth,
    o.fontInfo.middotWidth,
    o.fontInfo.wsmiddotWidth,
    o.stopRenderingLineAfter,
    o.renderWhitespace,
    o.renderControlCharacters,
    o.fontLigatures !== Bl.OFF,
    null
    // Send no selections, original line cannot be selected
  ), a);
  return a.appendString("</div>"), u.characterMapping.getHorizontalOffset(u.characterMapping.length);
}
var I_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, rbe = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let rN = class extends me {
  constructor(e, t, n, i, s, o, a, l, c, d) {
    super(), this._targetWindow = e, this._editors = t, this._diffModel = n, this._options = i, this._diffEditorWidget = s, this._canIgnoreViewZoneUpdateEvent = o, this._origViewZonesToIgnore = a, this._modViewZonesToIgnore = l, this._clipboardService = c, this._contextMenuService = d, this._originalTopPadding = qt(this, 0), this._originalScrollOffset = qt(this, 0), this._originalScrollOffsetAnimated = Q9e(this._targetWindow, this._originalScrollOffset, this._store), this._modifiedTopPadding = qt(this, 0), this._modifiedScrollOffset = qt(this, 0), this._modifiedScrollOffsetAnimated = Q9e(this._targetWindow, this._modifiedScrollOffset, this._store);
    const u = qt("invalidateAlignmentsState", 0), f = this._register(new Nr(() => {
      u.set(u.get() + 1, void 0);
    }, 0));
    this._register(this._editors.original.onDidChangeViewZones((y) => {
      this._canIgnoreViewZoneUpdateEvent() || f.schedule();
    })), this._register(this._editors.modified.onDidChangeViewZones((y) => {
      this._canIgnoreViewZoneUpdateEvent() || f.schedule();
    })), this._register(this._editors.original.onDidChangeConfiguration((y) => {
      (y.hasChanged(
        147
        /* EditorOption.wrappingInfo */
      ) || y.hasChanged(
        67
        /* EditorOption.lineHeight */
      )) && f.schedule();
    })), this._register(this._editors.modified.onDidChangeConfiguration((y) => {
      (y.hasChanged(
        147
        /* EditorOption.wrappingInfo */
      ) || y.hasChanged(
        67
        /* EditorOption.lineHeight */
      )) && f.schedule();
    }));
    const p = this._diffModel.map((y) => y ? Ei(
      this,
      y.model.original.onDidChangeTokens,
      () => y.model.original.tokenization.backgroundTokenizationState === 2
      /* BackgroundTokenizationState.Completed */
    ) : void 0).map((y, _) => y?.read(_)), g = dt((y) => {
      const _ = this._diffModel.read(y), S = _?.diff.read(y);
      if (!_ || !S)
        return null;
      u.read(y);
      const M = this._options.renderSideBySide.read(y);
      return sbe(this._editors.original, this._editors.modified, S.mappings, this._origViewZonesToIgnore, this._modViewZonesToIgnore, M);
    }), m = dt((y) => {
      const _ = this._diffModel.read(y)?.movedTextToCompare.read(y);
      if (!_)
        return null;
      u.read(y);
      const S = _.changes.map((D) => new NTe(D));
      return sbe(this._editors.original, this._editors.modified, S, this._origViewZonesToIgnore, this._modViewZonesToIgnore, !0);
    });
    function A() {
      const y = document.createElement("div");
      return y.className = "diagonal-fill", y;
    }
    const w = this._register(new ze());
    this.viewZones = om(this, (y, _) => {
      w.clear();
      const S = g.read(y) || [], D = [], M = [], L = this._modifiedTopPadding.read(y);
      L > 0 && M.push({
        afterLineNumber: 0,
        domNode: document.createElement("div"),
        heightInPx: L,
        showInHiddenAreas: !0,
        suppressMouseDown: !0
      });
      const T = this._originalTopPadding.read(y);
      T > 0 && D.push({
        afterLineNumber: 0,
        domNode: document.createElement("div"),
        heightInPx: T,
        showInHiddenAreas: !0,
        suppressMouseDown: !0
      });
      const B = this._options.renderSideBySide.read(y), V = B ? void 0 : this._editors.modified._getViewModel()?.createLineBreaksComputer();
      if (V) {
        const se = this._editors.original.getModel();
        for (const te of S)
          if (te.diff)
            for (let ue = te.originalRange.startLineNumber; ue < te.originalRange.endLineNumberExclusive; ue++) {
              if (ue > se.getLineCount())
                return { orig: D, mod: M };
              V?.addRequest(se.getLineContent(ue), null, null);
            }
      }
      const N = V?.finalize() ?? [];
      let R = 0;
      const H = this._editors.modified.getOption(
        67
        /* EditorOption.lineHeight */
      ), z = this._diffModel.read(y)?.movedTextToCompare.read(y), U = this._editors.original.getModel()?.mightContainNonBasicASCII() ?? !1, ee = this._editors.original.getModel()?.mightContainRTL() ?? !1, ce = tV.fromEditor(this._editors.modified);
      for (const se of S)
        if (se.diff && !B && (!this._options.useTrueInlineDiffRendering.read(y) || !nV(se.diff))) {
          if (!se.originalRange.isEmpty) {
            p.read(y);
            const ue = document.createElement("div");
            ue.classList.add("view-lines", "line-delete", "monaco-mouse-cursor-text");
            const G = this._editors.original.getModel();
            if (se.originalRange.endLineNumberExclusive - 1 > G.getLineCount())
              return { orig: D, mod: M };
            const j = new T_t(se.originalRange.mapToLineArray((I) => G.tokenization.getLineTokens(I)), se.originalRange.mapToLineArray((I) => N[R++]), U, ee), pe = [];
            for (const I of se.diff.innerChanges || [])
              pe.push(new WA(
                I.originalRange.delta(-(se.diff.original.startLineNumber - 1)),
                $k.className,
                0
                /* InlineDecorationType.Regular */
              ));
            const De = N_t(j, ce, pe, ue), Ce = document.createElement("div");
            if (Ce.className = "inline-deleted-margin-view-zone", Br(Ce, ce.fontInfo), this._options.renderIndicators.read(y))
              for (let I = 0; I < De.heightInLines; I++) {
                const O = document.createElement("div");
                O.className = `delete-sign ${Tt.asClassName(MTe)}`, O.setAttribute("style", `position:absolute;top:${I * H}px;width:${ce.lineDecorationsWidth}px;height:${H}px;right:0;`), Ce.appendChild(O);
              }
            let F;
            w.add(new k_t(() => E8(F), Ce, this._editors.modified, se.diff, this._diffEditorWidget, De.viewLineCounts, this._editors.original.getModel(), this._contextMenuService, this._clipboardService));
            for (let I = 0; I < De.viewLineCounts.length; I++) {
              const O = De.viewLineCounts[I];
              O > 1 && D.push({
                afterLineNumber: se.originalRange.startLineNumber + I,
                domNode: A(),
                heightInPx: (O - 1) * H,
                showInHiddenAreas: !0,
                suppressMouseDown: !0
              });
            }
            M.push({
              afterLineNumber: se.modifiedRange.startLineNumber - 1,
              domNode: ue,
              heightInPx: De.heightInLines * H,
              minWidthInPx: De.minWidthInPx,
              marginDomNode: Ce,
              setZoneId(I) {
                F = I;
              },
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          }
          const te = document.createElement("div");
          te.className = "gutter-delete", D.push({
            afterLineNumber: se.originalRange.endLineNumberExclusive - 1,
            domNode: A(),
            heightInPx: se.modifiedHeightInPx,
            marginDomNode: te,
            showInHiddenAreas: !0,
            suppressMouseDown: !0
          });
        } else {
          const te = se.modifiedHeightInPx - se.originalHeightInPx;
          if (te > 0) {
            if (z?.lineRangeMapping.original.delta(-1).deltaLength(2).contains(se.originalRange.endLineNumberExclusive - 1))
              continue;
            D.push({
              afterLineNumber: se.originalRange.endLineNumberExclusive - 1,
              domNode: A(),
              heightInPx: te,
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          } else {
            let ue = function() {
              const j = document.createElement("div");
              return j.className = "arrow-revert-change " + Tt.asClassName(ke.arrowRight), _.add(fe(j, "mousedown", (pe) => pe.stopPropagation())), _.add(fe(j, "click", (pe) => {
                pe.stopPropagation(), s.revert(se.diff);
              })), $e("div", {}, j);
            };
            if (z?.lineRangeMapping.modified.delta(-1).deltaLength(2).contains(se.modifiedRange.endLineNumberExclusive - 1))
              continue;
            let G;
            se.diff && se.diff.modified.isEmpty && this._options.shouldRenderOldRevertArrows.read(y) && (G = ue()), M.push({
              afterLineNumber: se.modifiedRange.endLineNumberExclusive - 1,
              domNode: A(),
              heightInPx: -te,
              marginDomNode: G,
              showInHiddenAreas: !0,
              suppressMouseDown: !0
            });
          }
        }
      for (const se of m.read(y) ?? []) {
        if (!z?.lineRangeMapping.original.intersect(se.originalRange) || !z?.lineRangeMapping.modified.intersect(se.modifiedRange))
          continue;
        const te = se.modifiedHeightInPx - se.originalHeightInPx;
        te > 0 ? D.push({
          afterLineNumber: se.originalRange.endLineNumberExclusive - 1,
          domNode: A(),
          heightInPx: te,
          showInHiddenAreas: !0,
          suppressMouseDown: !0
        }) : M.push({
          afterLineNumber: se.modifiedRange.endLineNumberExclusive - 1,
          domNode: A(),
          heightInPx: -te,
          showInHiddenAreas: !0,
          suppressMouseDown: !0
        });
      }
      return { orig: D, mod: M };
    });
    let v = !1;
    this._register(this._editors.original.onDidScrollChange((y) => {
      y.scrollLeftChanged && !v && (v = !0, this._editors.modified.setScrollLeft(y.scrollLeft), v = !1);
    })), this._register(this._editors.modified.onDidScrollChange((y) => {
      y.scrollLeftChanged && !v && (v = !0, this._editors.original.setScrollLeft(y.scrollLeft), v = !1);
    })), this._originalScrollTop = Ei(this._editors.original.onDidScrollChange, () => (
      /** @description original.getScrollTop */
      this._editors.original.getScrollTop()
    )), this._modifiedScrollTop = Ei(this._editors.modified.onDidScrollChange, () => (
      /** @description modified.getScrollTop */
      this._editors.modified.getScrollTop()
    )), this._register(nn((y) => {
      const _ = this._originalScrollTop.read(y) - (this._originalScrollOffsetAnimated.get() - this._modifiedScrollOffsetAnimated.read(y)) - (this._originalTopPadding.get() - this._modifiedTopPadding.read(y));
      _ !== this._editors.modified.getScrollTop() && this._editors.modified.setScrollTop(
        _,
        1
        /* ScrollType.Immediate */
      );
    })), this._register(nn((y) => {
      const _ = this._modifiedScrollTop.read(y) - (this._modifiedScrollOffsetAnimated.get() - this._originalScrollOffsetAnimated.read(y)) - (this._modifiedTopPadding.get() - this._originalTopPadding.read(y));
      _ !== this._editors.original.getScrollTop() && this._editors.original.setScrollTop(
        _,
        1
        /* ScrollType.Immediate */
      );
    })), this._register(nn((y) => {
      const _ = this._diffModel.read(y)?.movedTextToCompare.read(y);
      let S = 0;
      if (_) {
        const D = this._editors.original.getTopForLineNumber(_.lineRangeMapping.original.startLineNumber, !0) - this._originalTopPadding.get();
        S = this._editors.modified.getTopForLineNumber(_.lineRangeMapping.modified.startLineNumber, !0) - this._modifiedTopPadding.get() - D;
      }
      S > 0 ? (this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(S, void 0)) : S < 0 ? (this._modifiedTopPadding.set(-S, void 0), this._originalTopPadding.set(0, void 0)) : setTimeout(() => {
        this._modifiedTopPadding.set(0, void 0), this._originalTopPadding.set(0, void 0);
      }, 400), this._editors.modified.hasTextFocus() ? this._originalScrollOffset.set(this._modifiedScrollOffset.get() - S, void 0, !0) : this._modifiedScrollOffset.set(this._originalScrollOffset.get() + S, void 0, !0);
    }));
  }
};
rN = I_t([
  rbe(8, Fw),
  rbe(9, Qd)
], rN);
function sbe(r, e, t, n, i, s) {
  const o = new Hd(obe(r, n)), a = new Hd(obe(e, i)), l = r.getOption(
    67
    /* EditorOption.lineHeight */
  ), c = e.getOption(
    67
    /* EditorOption.lineHeight */
  ), d = [];
  let u = 0, f = 0;
  function p(g, m) {
    for (; ; ) {
      let A = o.peek(), w = a.peek();
      if (A && A.lineNumber >= g && (A = void 0), w && w.lineNumber >= m && (w = void 0), !A && !w)
        break;
      const v = A ? A.lineNumber - u : Number.MAX_VALUE, y = w ? w.lineNumber - f : Number.MAX_VALUE;
      v < y ? (o.dequeue(), w = {
        lineNumber: A.lineNumber - u + f,
        heightInPx: 0
      }) : v > y ? (a.dequeue(), A = {
        lineNumber: w.lineNumber - f + u,
        heightInPx: 0
      }) : (o.dequeue(), a.dequeue()), d.push({
        originalRange: lt.ofLength(A.lineNumber, 1),
        modifiedRange: lt.ofLength(w.lineNumber, 1),
        originalHeightInPx: l + A.heightInPx,
        modifiedHeightInPx: c + w.heightInPx,
        diff: void 0
      });
    }
  }
  for (const g of t) {
    let y = function(_, S, D = !1) {
      if (_ < v || S < w)
        return;
      if (A)
        A = !1;
      else if (!D && (_ === v || S === w))
        return;
      const M = new lt(v, _), L = new lt(w, S);
      if (M.isEmpty && L.isEmpty)
        return;
      const T = o.takeWhile((V) => V.lineNumber < _)?.reduce((V, N) => V + N.heightInPx, 0) ?? 0, B = a.takeWhile((V) => V.lineNumber < S)?.reduce((V, N) => V + N.heightInPx, 0) ?? 0;
      d.push({
        originalRange: M,
        modifiedRange: L,
        originalHeightInPx: M.length * l + T,
        modifiedHeightInPx: L.length * c + B,
        diff: g.lineRangeMapping
      }), v = _, w = S;
    };
    const m = g.lineRangeMapping;
    p(m.original.startLineNumber, m.modified.startLineNumber);
    let A = !0, w = m.modified.startLineNumber, v = m.original.startLineNumber;
    if (s)
      for (const _ of m.innerChanges || []) {
        _.originalRange.startColumn > 1 && _.modifiedRange.startColumn > 1 && y(_.originalRange.startLineNumber, _.modifiedRange.startLineNumber);
        const S = r.getModel(), D = _.originalRange.endLineNumber <= S.getLineCount() ? S.getLineMaxColumn(_.originalRange.endLineNumber) : Number.MAX_SAFE_INTEGER;
        _.originalRange.endColumn < D && y(_.originalRange.endLineNumber, _.modifiedRange.endLineNumber);
      }
    y(m.original.endLineNumberExclusive, m.modified.endLineNumberExclusive, !0), u = m.original.endLineNumberExclusive, f = m.modified.endLineNumberExclusive;
  }
  return p(Number.MAX_VALUE, Number.MAX_VALUE), d;
}
function obe(r, e) {
  const t = [], n = [], i = r.getOption(
    147
    /* EditorOption.wrappingInfo */
  ).wrappingColumn !== -1, s = r._getViewModel().coordinatesConverter, o = r.getOption(
    67
    /* EditorOption.lineHeight */
  );
  if (i)
    for (let l = 1; l <= r.getModel().getLineCount(); l++) {
      const c = s.getModelLineViewLineCount(l);
      c > 1 && n.push({ lineNumber: l, heightInPx: o * (c - 1) });
    }
  for (const l of r.getWhitespaces()) {
    if (e.has(l.id))
      continue;
    const c = l.afterLineNumber === 0 ? 0 : s.convertViewPositionToModelPosition(new le(l.afterLineNumber, 1)).lineNumber;
    t.push({ lineNumber: c, heightInPx: l.height });
  }
  return i_t(t, n, (l) => l.lineNumber, (l, c) => ({ lineNumber: l.lineNumber, heightInPx: l.heightInPx + c.heightInPx }));
}
function nV(r) {
  return r.innerChanges ? r.innerChanges.every((e) => abe(e.modifiedRange) && abe(e.originalRange)) : !1;
}
function abe(r) {
  return r.startLineNumber === r.endLineNumber;
}
class ef extends me {
  static {
    this.movedCodeBlockPadding = 4;
  }
  constructor(e, t, n, i, s) {
    super(), this._rootElement = e, this._diffModel = t, this._originalEditorLayoutInfo = n, this._modifiedEditorLayoutInfo = i, this._editors = s, this._originalScrollTop = Ei(this, this._editors.original.onDidScrollChange, () => this._editors.original.getScrollTop()), this._modifiedScrollTop = Ei(this, this._editors.modified.onDidScrollChange, () => this._editors.modified.getScrollTop()), this._viewZonesChanged = aa("onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this.width = qt(this, 0), this._modifiedViewZonesChangedSignal = aa("modified.onDidChangeViewZones", this._editors.modified.onDidChangeViewZones), this._originalViewZonesChangedSignal = aa("original.onDidChangeViewZones", this._editors.original.onDidChangeViewZones), this._state = om(this, (d, u) => {
      this._element.replaceChildren();
      const f = this._diffModel.read(d), p = f?.diff.read(d)?.movedTexts;
      if (!p || p.length === 0) {
        this.width.set(0, void 0);
        return;
      }
      this._viewZonesChanged.read(d);
      const g = this._originalEditorLayoutInfo.read(d), m = this._modifiedEditorLayoutInfo.read(d);
      if (!g || !m) {
        this.width.set(0, void 0);
        return;
      }
      this._modifiedViewZonesChangedSignal.read(d), this._originalViewZonesChangedSignal.read(d);
      const A = p.map((M) => {
        function L(ee, ce) {
          const se = ce.getTopForLineNumber(ee.startLineNumber, !0), te = ce.getTopForLineNumber(ee.endLineNumberExclusive, !0);
          return (se + te) / 2;
        }
        const T = L(M.lineRangeMapping.original, this._editors.original), B = this._originalScrollTop.read(d), V = L(M.lineRangeMapping.modified, this._editors.modified), N = this._modifiedScrollTop.read(d), R = T - B, H = V - N, z = Math.min(T, V), U = Math.max(T, V);
        return { range: new pt(z, U), from: R, to: H, fromWithoutScroll: T, toWithoutScroll: V, move: M };
      });
      A.sort(fut(al((M) => M.fromWithoutScroll > M.toWithoutScroll, put), al((M) => M.fromWithoutScroll > M.toWithoutScroll ? M.fromWithoutScroll : -M.toWithoutScroll, Gu)));
      const w = iV.compute(A.map((M) => M.range)), v = 10, y = g.verticalScrollbarWidth, _ = (w.getTrackCount() - 1) * 10 + v * 2, S = y + _ + (m.contentLeft - ef.movedCodeBlockPadding);
      let D = 0;
      for (const M of A) {
        const L = w.getTrack(D), T = y + v + L * 10, B = 15, V = 15, N = S, R = m.glyphMarginWidth + m.lineNumbersWidth, H = 18, z = document.createElementNS("http://www.w3.org/2000/svg", "rect");
        z.classList.add("arrow-rectangle"), z.setAttribute("x", `${N - R}`), z.setAttribute("y", `${M.to - H / 2}`), z.setAttribute("width", `${R}`), z.setAttribute("height", `${H}`), this._element.appendChild(z);
        const U = document.createElementNS("http://www.w3.org/2000/svg", "g"), ee = document.createElementNS("http://www.w3.org/2000/svg", "path");
        ee.setAttribute("d", `M 0 ${M.from} L ${T} ${M.from} L ${T} ${M.to} L ${N - V} ${M.to}`), ee.setAttribute("fill", "none"), U.appendChild(ee);
        const ce = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
        ce.classList.add("arrow"), u.add(nn((se) => {
          ee.classList.toggle("currentMove", M.move === f.activeMovedText.read(se)), ce.classList.toggle("currentMove", M.move === f.activeMovedText.read(se));
        })), ce.setAttribute("points", `${N - V},${M.to - B / 2} ${N},${M.to} ${N - V},${M.to + B / 2}`), U.appendChild(ce), this._element.appendChild(U), D++;
      }
      this.width.set(_, void 0);
    }), this._element = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this._element.setAttribute("class", "moved-blocks-lines"), this._rootElement.appendChild(this._element), this._register(ht(() => this._element.remove())), this._register(nn((d) => {
      const u = this._originalEditorLayoutInfo.read(d), f = this._modifiedEditorLayoutInfo.read(d);
      !u || !f || (this._element.style.left = `${u.width - u.verticalScrollbarWidth}px`, this._element.style.height = `${u.height}px`, this._element.style.width = `${u.verticalScrollbarWidth + u.contentLeft - ef.movedCodeBlockPadding + this.width.read(d)}px`);
    })), this._register(Ly(this._state));
    const o = dt((d) => {
      const f = this._diffModel.read(d)?.diff.read(d);
      return f ? f.movedTexts.map((p) => ({
        move: p,
        original: new hp(R9(p.lineRangeMapping.original.startLineNumber - 1), 18),
        modified: new hp(R9(p.lineRangeMapping.modified.startLineNumber - 1), 18)
      })) : [];
    });
    this._register(cb(this._editors.original, o.map((d) => (
      /** @description movedBlockViewZones.original */
      d.map((u) => u.original)
    )))), this._register(cb(this._editors.modified, o.map((d) => (
      /** @description movedBlockViewZones.modified */
      d.map((u) => u.modified)
    )))), this._register(Xl((d, u) => {
      const f = o.read(d);
      for (const p of f)
        u.add(new lbe(this._editors.original, p.original, p.move, "original", this._diffModel.get())), u.add(new lbe(this._editors.modified, p.modified, p.move, "modified", this._diffModel.get()));
    }));
    const a = aa("original.onDidFocusEditorWidget", (d) => this._editors.original.onDidFocusEditorWidget(() => setTimeout(() => d(void 0), 0))), l = aa("modified.onDidFocusEditorWidget", (d) => this._editors.modified.onDidFocusEditorWidget(() => setTimeout(() => d(void 0), 0)));
    let c = "modified";
    this._register(My({
      createEmptyChangeSummary: () => {
      },
      handleChange: (d, u) => (d.didChange(a) && (c = "original"), d.didChange(l) && (c = "modified"), !0)
    }, (d) => {
      a.read(d), l.read(d);
      const u = this._diffModel.read(d);
      if (!u)
        return;
      const f = u.diff.read(d);
      let p;
      if (f && c === "original") {
        const g = this._editors.originalCursor.read(d);
        g && (p = f.movedTexts.find((m) => m.lineRangeMapping.original.contains(g.lineNumber)));
      }
      if (f && c === "modified") {
        const g = this._editors.modifiedCursor.read(d);
        g && (p = f.movedTexts.find((m) => m.lineRangeMapping.modified.contains(g.lineNumber)));
      }
      p !== u.movedTextToCompare.get() && u.movedTextToCompare.set(void 0, void 0), u.setActiveMovedText(p);
    }));
  }
}
class iV {
  static compute(e) {
    const t = [], n = [];
    for (const i of e) {
      let s = t.findIndex((o) => !o.intersectsStrict(i));
      s === -1 && (t.length >= 6 ? s = Qpt(t, al((a) => a.intersectWithRangeLength(i), Gu)) : (s = t.length, t.push(new cO()))), t[s].addRange(i), n.push(s);
    }
    return new iV(t.length, n);
  }
  constructor(e, t) {
    this._trackCount = e, this.trackPerLineIdx = t;
  }
  getTrack(e) {
    return this.trackPerLineIdx[e];
  }
  getTrackCount() {
    return this._trackCount;
  }
}
class lbe extends KR {
  constructor(e, t, n, i, s) {
    const o = Ut("div.diff-hidden-lines-widget");
    super(e, t, o.root), this._editor = e, this._move = n, this._kind = i, this._diffModel = s, this._nodes = Ut("div.diff-moved-code-block", { style: { marginRight: "4px" } }, [
      Ut("div.text-content@textContent"),
      Ut("div.action-bar@actionBar")
    ]), o.root.appendChild(this._nodes.root);
    const a = Ei(this._editor.onDidLayoutChange, () => this._editor.getLayoutInfo());
    this._register(g1(this._nodes.root, {
      paddingRight: a.map((f) => f.verticalScrollbarWidth)
    }));
    let l;
    n.changes.length > 0 ? l = this._kind === "original" ? C("codeMovedToWithChanges", "Code moved with changes to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : C("codeMovedFromWithChanges", "Code moved with changes from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1) : l = this._kind === "original" ? C("codeMovedTo", "Code moved to line {0}-{1}", this._move.lineRangeMapping.modified.startLineNumber, this._move.lineRangeMapping.modified.endLineNumberExclusive - 1) : C("codeMovedFrom", "Code moved from line {0}-{1}", this._move.lineRangeMapping.original.startLineNumber, this._move.lineRangeMapping.original.endLineNumberExclusive - 1);
    const c = this._register(new Md(this._nodes.actionBar, {
      highlightToggledItems: !0
    })), d = new Ed("", l, "", !1);
    c.push(d, { icon: !1, label: !0 });
    const u = new Ed("", "Compare", Tt.asClassName(ke.compareChanges), !0, () => {
      this._editor.focus(), this._diffModel.movedTextToCompare.set(this._diffModel.movedTextToCompare.get() === n ? void 0 : this._move, void 0);
    });
    this._register(nn((f) => {
      const p = this._diffModel.movedTextToCompare.read(f) === n;
      u.checked = p;
    })), c.push(u, { icon: !1, label: !0 });
  }
}
class O_t extends me {
  constructor(e, t, n, i) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._decorations = dt(this, (s) => {
      const o = this._diffModel.read(s), a = o?.diff.read(s);
      if (!a)
        return null;
      const l = this._diffModel.read(s).movedTextToCompare.read(s), c = this._options.renderIndicators.read(s), d = this._options.showEmptyDecorations.read(s), u = [], f = [];
      if (!l)
        for (const g of a.mappings)
          if (g.lineRangeMapping.original.isEmpty || u.push({ range: g.lineRangeMapping.original.toInclusiveRange(), options: c ? J9e : ebe }), g.lineRangeMapping.modified.isEmpty || f.push({ range: g.lineRangeMapping.modified.toInclusiveRange(), options: c ? X9e : $9e }), g.lineRangeMapping.modified.isEmpty || g.lineRangeMapping.original.isEmpty)
            g.lineRangeMapping.original.isEmpty || u.push({ range: g.lineRangeMapping.original.toInclusiveRange(), options: C_t }), g.lineRangeMapping.modified.isEmpty || f.push({ range: g.lineRangeMapping.modified.toInclusiveRange(), options: b_t });
          else {
            const m = this._options.useTrueInlineDiffRendering.read(s) && nV(g.lineRangeMapping);
            for (const A of g.lineRangeMapping.innerChanges || [])
              if (g.lineRangeMapping.original.contains(A.originalRange.startLineNumber) && u.push({ range: A.originalRange, options: A.originalRange.isEmpty() && d ? E_t : $k }), g.lineRangeMapping.modified.contains(A.modifiedRange.startLineNumber) && f.push({ range: A.modifiedRange, options: A.modifiedRange.isEmpty() && d && !m ? y_t : tbe }), m) {
                const w = o.model.original.getValueInRange(A.originalRange);
                f.push({
                  range: A.modifiedRange,
                  options: {
                    description: "deleted-text",
                    before: {
                      content: w,
                      inlineClassName: "inline-deleted-text"
                    },
                    zIndex: 1e5,
                    showIfCollapsed: !0
                  }
                });
              }
          }
      if (l)
        for (const g of l.changes) {
          const m = g.original.toInclusiveRange();
          m && u.push({ range: m, options: c ? J9e : ebe });
          const A = g.modified.toInclusiveRange();
          A && f.push({ range: A, options: c ? X9e : $9e });
          for (const w of g.innerChanges || [])
            u.push({ range: w.originalRange, options: $k }), f.push({ range: w.modifiedRange, options: tbe });
        }
      const p = this._diffModel.read(s).activeMovedText.read(s);
      for (const g of a.movedTexts)
        u.push({
          range: g.lineRangeMapping.original.toInclusiveRange(),
          options: {
            description: "moved",
            blockClassName: "movedOriginal" + (g === p ? " currentMove" : ""),
            blockPadding: [ef.movedCodeBlockPadding, 0, ef.movedCodeBlockPadding, ef.movedCodeBlockPadding]
          }
        }), f.push({
          range: g.lineRangeMapping.modified.toInclusiveRange(),
          options: {
            description: "moved",
            blockClassName: "movedModified" + (g === p ? " currentMove" : ""),
            blockPadding: [4, 0, 4, 4]
          }
        });
      return { originalDecorations: u, modifiedDecorations: f };
    }), this._register(lb(this._editors.original, this._decorations.map((s) => s?.originalDecorations || []))), this._register(lb(this._editors.modified, this._decorations.map((s) => s?.modifiedDecorations || [])));
  }
}
class R_t {
  resetSash() {
    this._sashRatio.set(void 0, void 0);
  }
  constructor(e, t) {
    this._options = e, this.dimensions = t, this.sashLeft = vR(this, (n) => {
      const i = this._sashRatio.read(n) ?? this._options.splitViewDefaultRatio.read(n);
      return this._computeSashLeft(i, n);
    }, (n, i) => {
      const s = this.dimensions.width.get();
      this._sashRatio.set(n / s, i);
    }), this._sashRatio = qt(this, void 0);
  }
  /** @pure */
  _computeSashLeft(e, t) {
    const n = this.dimensions.width.read(t), i = Math.floor(this._options.splitViewDefaultRatio.read(t) * n), s = this._options.enableSplitViewResizing.read(t) ? Math.floor(e * n) : i, o = 100;
    return n <= o * 2 ? i : s < o ? o : s > n - o ? n - o : s;
  }
}
class TTe extends me {
  constructor(e, t, n, i, s, o) {
    super(), this._domNode = e, this._dimensions = t, this._enabled = n, this._boundarySashes = i, this.sashLeft = s, this._resetSash = o, this._sash = this._register(new bo(this._domNode, {
      getVerticalSashTop: (a) => 0,
      getVerticalSashLeft: (a) => this.sashLeft.get(),
      getVerticalSashHeight: (a) => this._dimensions.height.get()
    }, {
      orientation: 0
      /* Orientation.VERTICAL */
    })), this._startSashPosition = void 0, this._register(this._sash.onDidStart(() => {
      this._startSashPosition = this.sashLeft.get();
    })), this._register(this._sash.onDidChange((a) => {
      this.sashLeft.set(this._startSashPosition + (a.currentX - a.startX), void 0);
    })), this._register(this._sash.onDidEnd(() => this._sash.layout())), this._register(this._sash.onDidReset(() => this._resetSash())), this._register(nn((a) => {
      const l = this._boundarySashes.read(a);
      l && (this._sash.orthogonalEndSash = l.bottom);
    })), this._register(nn((a) => {
      const l = this._enabled.read(a);
      this._sash.state = l ? 3 : 0, this.sashLeft.read(a), this._dimensions.height.read(a), this._sash.layout();
    }));
  }
}
class V_t extends me {
  constructor(e, t, n) {
    super(), this._editor = e, this._domNode = t, this.itemProvider = n, this.scrollTop = Ei(this, this._editor.onDidScrollChange, (o) => (
      /** @description editor.onDidScrollChange */
      this._editor.getScrollTop()
    )), this.isScrollTopZero = this.scrollTop.map((o) => (
      /** @description isScrollTopZero */
      o === 0
    )), this.modelAttached = Ei(this, this._editor.onDidChangeModel, (o) => (
      /** @description editor.onDidChangeModel */
      this._editor.hasModel()
    )), this.editorOnDidChangeViewZones = aa("onDidChangeViewZones", this._editor.onDidChangeViewZones), this.editorOnDidContentSizeChange = aa("onDidContentSizeChange", this._editor.onDidContentSizeChange), this.domNodeSizeChanged = bR("domNodeSizeChanged"), this.views = /* @__PURE__ */ new Map(), this._domNode.className = "gutter monaco-editor";
    const i = this._domNode.appendChild(Ut("div.scroll-decoration", { role: "presentation", ariaHidden: "true", style: { width: "100%" } }).root), s = new ResizeObserver(() => {
      er((o) => {
        this.domNodeSizeChanged.trigger(o);
      });
    });
    s.observe(this._domNode), this._register(ht(() => s.disconnect())), this._register(nn((o) => {
      i.className = this.isScrollTopZero.read(o) ? "" : "scroll-decoration";
    })), this._register(nn((o) => (
      /** @description EditorGutter.Render */
      this.render(o)
    )));
  }
  dispose() {
    super.dispose(), ys(this._domNode);
  }
  render(e) {
    if (!this.modelAttached.read(e))
      return;
    this.domNodeSizeChanged.read(e), this.editorOnDidChangeViewZones.read(e), this.editorOnDidContentSizeChange.read(e);
    const t = this.scrollTop.read(e), n = this._editor.getVisibleRanges(), i = new Set(this.views.keys()), s = pt.ofStartAndLength(0, this._domNode.clientHeight);
    if (!s.isEmpty)
      for (const o of n) {
        const a = new lt(o.startLineNumber, o.endLineNumber + 1), l = this.itemProvider.getIntersectingGutterItems(a, e);
        er((c) => {
          for (const d of l) {
            if (!d.range.intersect(a))
              continue;
            i.delete(d.id);
            let u = this.views.get(d.id);
            if (u)
              u.item.set(d, c);
            else {
              const m = document.createElement("div");
              this._domNode.appendChild(m);
              const A = qt("item", d), w = this.itemProvider.createView(A, m);
              u = new H_t(A, w, m), this.views.set(d.id, u);
            }
            const f = d.range.startLineNumber <= this._editor.getModel().getLineCount() ? this._editor.getTopForLineNumber(d.range.startLineNumber, !0) - t : this._editor.getBottomForLineNumber(d.range.startLineNumber - 1, !1) - t, g = (d.range.isEmpty ? f : this._editor.getBottomForLineNumber(d.range.endLineNumberExclusive - 1, !0) - t) - f;
            u.domNode.style.top = `${f}px`, u.domNode.style.height = `${g}px`, u.gutterItemView.layout(pt.ofStartAndLength(f, g), s);
          }
        });
      }
    for (const o of i) {
      const a = this.views.get(o);
      a.gutterItemView.dispose(), a.domNode.remove(), this.views.delete(o);
    }
  }
}
class H_t {
  constructor(e, t, n) {
    this.item = e, this.gutterItemView = t, this.domNode = n;
  }
}
class ITe extends wf {
  constructor(e) {
    super(), this._getContext = e;
  }
  runAction(e, t) {
    const n = this._getContext();
    return super.runAction(e, n);
  }
}
class cbe extends lLe {
  constructor(e) {
    super(), this._textModel = e;
  }
  getValueOfRange(e) {
    return this._textModel.getValueInRange(e);
  }
  get length() {
    const e = this._textModel.getLineCount(), t = this._textModel.getLineLength(e);
    return new Xa(e - 1, t);
  }
}
class B_t extends me {
  constructor(e, t, n = {
    orientation: 0
    /* ActionsOrientation.HORIZONTAL */
  }) {
    super(), this.submenuActionViewItems = [], this.hasSecondaryActions = !1, this._onDidChangeDropdownVisibility = this._register(new F1t()), this.onDidChangeDropdownVisibility = this._onDidChangeDropdownVisibility.event, this.disposables = this._register(new ze()), n.hoverDelegate = n.hoverDelegate ?? this._register(wg()), this.options = n, this.toggleMenuAction = this._register(new g4(() => this.toggleMenuActionViewItem?.show(), n.toggleMenuTitle)), this.element = document.createElement("div"), this.element.className = "monaco-toolbar", e.appendChild(this.element), this.actionBar = this._register(new Md(this.element, {
      orientation: n.orientation,
      ariaLabel: n.ariaLabel,
      actionRunner: n.actionRunner,
      allowContextMenu: n.allowContextMenu,
      highlightToggledItems: n.highlightToggledItems,
      hoverDelegate: n.hoverDelegate,
      actionViewItemProvider: (i, s) => {
        if (i.id === g4.ID)
          return this.toggleMenuActionViewItem = new H9(i, i.menuActions, t, {
            actionViewItemProvider: this.options.actionViewItemProvider,
            actionRunner: this.actionRunner,
            keybindingProvider: this.options.getKeyBinding,
            classNames: Tt.asClassNameArray(n.moreIcon ?? ke.toolBarMore),
            anchorAlignmentProvider: this.options.anchorAlignmentProvider,
            menuAsChild: !!this.options.renderDropdownAsChildElement,
            skipTelemetry: this.options.skipTelemetry,
            isMenu: !0,
            hoverDelegate: this.options.hoverDelegate
          }), this.toggleMenuActionViewItem.setActionContext(this.actionBar.context), this.disposables.add(this._onDidChangeDropdownVisibility.add(this.toggleMenuActionViewItem.onDidChangeVisibility)), this.toggleMenuActionViewItem;
        if (n.actionViewItemProvider) {
          const o = n.actionViewItemProvider(i, s);
          if (o)
            return o;
        }
        if (i instanceof W7) {
          const o = new H9(i, i.actions, t, {
            actionViewItemProvider: this.options.actionViewItemProvider,
            actionRunner: this.actionRunner,
            keybindingProvider: this.options.getKeyBinding,
            classNames: i.class,
            anchorAlignmentProvider: this.options.anchorAlignmentProvider,
            menuAsChild: !!this.options.renderDropdownAsChildElement,
            skipTelemetry: this.options.skipTelemetry,
            hoverDelegate: this.options.hoverDelegate
          });
          return o.setActionContext(this.actionBar.context), this.submenuActionViewItems.push(o), this.disposables.add(this._onDidChangeDropdownVisibility.add(o.onDidChangeVisibility)), o;
        }
      }
    }));
  }
  set actionRunner(e) {
    this.actionBar.actionRunner = e;
  }
  get actionRunner() {
    return this.actionBar.actionRunner;
  }
  getElement() {
    return this.element;
  }
  getItemAction(e) {
    return this.actionBar.getAction(e);
  }
  setActions(e, t) {
    this.clear();
    const n = e ? e.slice(0) : [];
    this.hasSecondaryActions = !!(t && t.length > 0), this.hasSecondaryActions && t && (this.toggleMenuAction.menuActions = t.slice(0), n.push(this.toggleMenuAction)), n.forEach((i) => {
      this.actionBar.push(i, { icon: this.options.icon ?? !0, label: this.options.label ?? !1, keybinding: this.getKeybindingLabel(i) });
    });
  }
  getKeybindingLabel(e) {
    return this.options.getKeyBinding?.(e)?.getLabel() ?? void 0;
  }
  clear() {
    this.submenuActionViewItems = [], this.disposables.clear(), this.actionBar.clear();
  }
  dispose() {
    this.clear(), this.disposables.dispose(), super.dispose();
  }
}
class g4 extends Ed {
  static {
    this.ID = "toolbar.toggle.more";
  }
  constructor(e, t) {
    t = t || C("moreActions", "More Actions..."), super(g4.ID, t, void 0, !0), this._menuActions = [], this.toggleDropdownMenu = e;
  }
  async run() {
    this.toggleDropdownMenu();
  }
  get menuActions() {
    return this._menuActions;
  }
  set menuActions(e) {
    this._menuActions = e;
  }
}
var OTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, qa = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let sN = class extends B_t {
  constructor(e, t, n, i, s, o, a, l) {
    super(e, s, {
      // defaults
      getKeyBinding: (d) => o.lookupKeybinding(d.id) ?? void 0,
      // options (override defaults)
      ...t,
      // mandatory (overide options)
      allowContextMenu: !0,
      skipTelemetry: typeof t?.telemetrySource == "string"
    }), this._options = t, this._menuService = n, this._contextKeyService = i, this._contextMenuService = s, this._keybindingService = o, this._commandService = a, this._sessionDisposables = this._store.add(new ze());
    const c = t?.telemetrySource;
    c && this._store.add(this.actionBar.onDidRun((d) => l.publicLog2("workbenchActionExecuted", { id: d.action.id, from: c })));
  }
  setActions(e, t = [], n) {
    this._sessionDisposables.clear();
    const i = e.slice(), s = t.slice(), o = [];
    let a = 0;
    const l = [];
    let c = !1;
    if (this._options?.hiddenItemStrategy !== -1)
      for (let d = 0; d < i.length; d++) {
        const u = i[d];
        !(u instanceof _d) && !(u instanceof FA) || u.hideActions && (o.push(u.hideActions.toggle), u.hideActions.toggle.checked && a++, u.hideActions.isHidden && (c = !0, i[d] = void 0, this._options?.hiddenItemStrategy !== 0 && (l[d] = u)));
      }
    if (this._options?.overflowBehavior !== void 0) {
      const d = syt(new Set(this._options.overflowBehavior.exempted), Jt.map(i, (p) => p?.id)), u = this._options.overflowBehavior.maxItems - d.size;
      let f = 0;
      for (let p = 0; p < i.length; p++) {
        const g = i[p];
        g && (f++, !d.has(g.id) && f >= u && (i[p] = void 0, l[p] = g));
      }
    }
    cve(i), cve(l), super.setActions(i, Pr.join(l, s)), (o.length > 0 || i.length > 0) && this._sessionDisposables.add(fe(this.getElement(), "contextmenu", (d) => {
      const u = new zl(qe(this.getElement()), d), f = this.getItemAction(u.target);
      if (!f)
        return;
      u.preventDefault(), u.stopPropagation();
      const p = [];
      if (f instanceof _d && f.menuKeybinding)
        p.push(f.menuKeybinding);
      else if (!(f instanceof FA || f instanceof g4)) {
        const m = !!this._keybindingService.lookupKeybinding(f.id);
        p.push(_Te(this._commandService, this._keybindingService, f.id, void 0, m));
      }
      if (o.length > 0) {
        let m = !1;
        if (a === 1 && this._options?.hiddenItemStrategy === 0) {
          m = !0;
          for (let A = 0; A < o.length; A++)
            if (o[A].checked) {
              o[A] = Ap({
                id: f.id,
                label: f.label,
                checked: !0,
                enabled: !1,
                run() {
                }
              });
              break;
            }
        }
        if (!m && (f instanceof _d || f instanceof FA)) {
          if (!f.hideActions)
            return;
          p.push(f.hideActions.hide);
        } else
          p.push(Ap({
            id: "label",
            label: C("hide", "Hide"),
            enabled: !1,
            run() {
            }
          }));
      }
      const g = Pr.join(p, o);
      this._options?.resetMenu && !n && (n = [this._options.resetMenu]), c && n && (g.push(new Pr()), g.push(Ap({
        id: "resetThisMenu",
        label: C("resetThisMenu", "Reset Menu"),
        run: () => this._menuService.resetHiddenStates(n)
      }))), g.length !== 0 && this._contextMenuService.showContextMenu({
        getAnchor: () => u,
        getActions: () => g,
        // add context menu actions (iff appicable)
        menuId: this._options?.contextMenu,
        menuActionOptions: { renderShortTitle: !0, ...this._options?.menuOptions },
        skipTelemetry: typeof this._options?.telemetrySource == "string",
        contextKeyService: this._contextKeyService
      });
    }));
  }
};
sN = OTe([
  qa(2, Yf),
  qa(3, sn),
  qa(4, Qd),
  qa(5, _r),
  qa(6, jo),
  qa(7, I1)
], sN);
let db = class extends sN {
  constructor(e, t, n, i, s, o, a, l, c) {
    super(e, { resetMenu: t, ...n }, i, s, o, a, l, c), this._onDidChangeMenuItems = this._store.add(new $()), this.onDidChangeMenuItems = this._onDidChangeMenuItems.event;
    const d = this._store.add(i.createMenu(t, s, { emitEventsForSubmenuChanges: !0 })), u = () => {
      const f = [], p = [];
      J7t(d, n?.menuOptions, { primary: f, secondary: p }, n?.toolbarOptions?.primaryGroup, n?.toolbarOptions?.shouldInlineSubmenu, n?.toolbarOptions?.useSeparatorsInPrimaryActions), e.classList.toggle("has-no-actions", f.length === 0 && p.length === 0), super.setActions(f, p);
    };
    this._store.add(d.onDidChange(() => {
      u(), this._onDidChangeMenuItems.fire(this);
    })), u();
  }
  /**
   * @deprecated The WorkbenchToolBar does not support this method because it works with menus.
   */
  setActions() {
    throw new cn("This toolbar is populated from a menu.");
  }
};
db = OTe([
  qa(3, Yf),
  qa(4, sn),
  qa(5, Qd),
  qa(6, _r),
  qa(7, jo),
  qa(8, I1)
], db);
var RTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, V6 = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const T_ = [], c5 = 35;
let oN = class extends me {
  constructor(e, t, n, i, s, o, a, l, c) {
    super(), this._diffModel = t, this._editors = n, this._options = i, this._sashLayout = s, this._boundarySashes = o, this._instantiationService = a, this._contextKeyService = l, this._menuService = c, this._menu = this._register(this._menuService.createMenu(oe.DiffEditorHunkToolbar, this._contextKeyService)), this._actions = Ei(this, this._menu.onDidChange, () => this._menu.getActions()), this._hasActions = this._actions.map((d) => d.length > 0), this._showSash = dt(this, (d) => this._options.renderSideBySide.read(d) && this._hasActions.read(d)), this.width = dt(this, (d) => this._hasActions.read(d) ? c5 : 0), this.elements = Ut("div.gutter@gutter", { style: { position: "absolute", height: "100%", width: c5 + "px" } }, []), this._currentDiff = dt(this, (d) => {
      const u = this._diffModel.read(d);
      if (!u)
        return;
      const f = u.diff.read(d)?.mappings, p = this._editors.modifiedCursor.read(d);
      if (p)
        return f?.find((g) => g.lineRangeMapping.modified.contains(p.lineNumber));
    }), this._selectedDiffs = dt(this, (d) => {
      const f = this._diffModel.read(d)?.diff.read(d);
      if (!f)
        return T_;
      const p = this._editors.modifiedSelections.read(d);
      if (p.every((w) => w.isEmpty()))
        return T_;
      const g = new sa(p.map((w) => lt.fromRangeInclusive(w))), A = f.mappings.filter((w) => w.lineRangeMapping.innerChanges && g.intersects(w.lineRangeMapping.modified)).map((w) => ({
        mapping: w,
        rangeMappings: w.lineRangeMapping.innerChanges.filter((v) => p.some((y) => Q.areIntersecting(v.modifiedRange, y)))
      }));
      return A.length === 0 || A.every((w) => w.rangeMappings.length === 0) ? T_ : A;
    }), this._register(r_t(e, this.elements.root)), this._register(fe(this.elements.root, "click", () => {
      this._editors.modified.focus();
    })), this._register(g1(this.elements.root, { display: this._hasActions.map((d) => d ? "block" : "none") })), Pc(this, (d) => this._showSash.read(d) ? new TTe(e, this._sashLayout.dimensions, this._options.enableSplitViewResizing, this._boundarySashes, vR(this, (f) => this._sashLayout.sashLeft.read(f) - c5, (f, p) => this._sashLayout.sashLeft.set(f + c5, p)), () => this._sashLayout.resetSash()) : void 0).recomputeInitiallyAndOnChange(this._store), this._register(new V_t(this._editors.modified, this.elements.root, {
      getIntersectingGutterItems: (d, u) => {
        const f = this._diffModel.read(u);
        if (!f)
          return [];
        const p = f.diff.read(u);
        if (!p)
          return [];
        const g = this._selectedDiffs.read(u);
        if (g.length > 0) {
          const A = Po.fromRangeMappings(g.flatMap((w) => w.rangeMappings));
          return [
            new hbe(A, !0, oe.DiffEditorSelectionToolbar, void 0, f.model.original.uri, f.model.modified.uri)
          ];
        }
        const m = this._currentDiff.read(u);
        return p.mappings.map((A) => new hbe(A.lineRangeMapping.withInnerChangesFromLineRanges(), A.lineRangeMapping === m?.lineRangeMapping, oe.DiffEditorHunkToolbar, void 0, f.model.original.uri, f.model.modified.uri));
      },
      createView: (d, u) => this._instantiationService.createInstance(aN, d, u, this)
    })), this._register(fe(this.elements.gutter, Se.MOUSE_WHEEL, (d) => {
      this._editors.modified.getOption(
        104
        /* EditorOption.scrollbar */
      ).handleMouseWheel && this._editors.modified.delegateScrollFromMouseWheelEvent(d);
    }, { passive: !1 }));
  }
  computeStagedValue(e) {
    const t = e.innerChanges ?? [], n = new cbe(this._editors.modifiedModel.get()), i = new cbe(this._editors.original.getModel());
    return new Ypt(t.map((a) => a.toTextEdit(n))).apply(i);
  }
  layout(e) {
    this.elements.gutter.style.left = e + "px";
  }
};
oN = RTe([
  V6(6, xn),
  V6(7, sn),
  V6(8, Yf)
], oN);
class hbe {
  constructor(e, t, n, i, s, o) {
    this.mapping = e, this.showAlways = t, this.menuId = n, this.rangeOverride = i, this.originalUri = s, this.modifiedUri = o;
  }
  get id() {
    return this.mapping.modified.toString();
  }
  get range() {
    return this.rangeOverride ?? this.mapping.modified;
  }
}
let aN = class extends me {
  constructor(e, t, n, i) {
    super(), this._item = e, this._elements = Ut("div.gutterItem", { style: { height: "20px", width: "34px" } }, [
      Ut("div.background@background", {}, []),
      Ut("div.buttons@buttons", {}, [])
    ]), this._showAlways = this._item.map(this, (o) => o.showAlways), this._menuId = this._item.map(this, (o) => o.menuId), this._isSmall = qt(this, !1), this._lastItemRange = void 0, this._lastViewRange = void 0;
    const s = this._register(i.createInstance(s4, "element", !0, { position: {
      hoverPosition: 1
      /* HoverPosition.RIGHT */
    } }));
    this._register(_A(t, this._elements.root)), this._register(nn((o) => {
      const a = this._showAlways.read(o);
      this._elements.root.classList.toggle("noTransition", !0), this._elements.root.classList.toggle("showAlways", a), setTimeout(() => {
        this._elements.root.classList.toggle("noTransition", !1);
      }, 0);
    })), this._register(Xl((o, a) => {
      this._elements.buttons.replaceChildren();
      const l = a.add(i.createInstance(db, this._elements.buttons, this._menuId.read(o), {
        orientation: 1,
        hoverDelegate: s,
        toolbarOptions: {
          primaryGroup: (c) => c.startsWith("primary")
        },
        overflowBehavior: { maxItems: this._isSmall.read(o) ? 1 : 3 },
        hiddenItemStrategy: 0,
        actionRunner: new ITe(() => {
          const c = this._item.get(), d = c.mapping;
          return {
            mapping: d,
            originalWithModifiedChanges: n.computeStagedValue(d),
            originalUri: c.originalUri,
            modifiedUri: c.modifiedUri
          };
        }),
        menuOptions: {
          shouldForwardArgs: !0
        }
      }));
      a.add(l.onDidChangeMenuItems(() => {
        this._lastItemRange && this.layout(this._lastItemRange, this._lastViewRange);
      }));
    }));
  }
  layout(e, t) {
    this._lastItemRange = e, this._lastViewRange = t;
    let n = this._elements.buttons.clientHeight;
    this._isSmall.set(this._item.get().mapping.original.startLineNumber === 1 && e.length < 30, void 0), n = this._elements.buttons.clientHeight;
    const i = e.length / 2 - n / 2, s = n;
    let o = e.start + i;
    const a = pt.tryCreate(s, t.endExclusive - s - n), l = pt.tryCreate(e.start + s, e.endExclusive - n - s);
    l && a && l.start < l.endExclusive && (o = a.clip(o), o = l.clip(o)), this._elements.buttons.style.top = `${o - e.start}px`;
  }
};
aN = RTe([
  V6(3, xn)
], aN);
function m4(r) {
  return S0.get(r);
}
class S0 extends me {
  static {
    this._map = /* @__PURE__ */ new Map();
  }
  /**
   * Make sure that editor is not disposed yet!
  */
  static get(e) {
    let t = S0._map.get(e);
    if (!t) {
      t = new S0(e), S0._map.set(e, t);
      const n = e.onDidDispose(() => {
        const i = S0._map.get(e);
        i && (S0._map.delete(e), i.dispose(), n.dispose());
      });
    }
    return t;
  }
  _beginUpdate() {
    this._updateCounter++, this._updateCounter === 1 && (this._currentTransaction = new Ow(() => {
    }));
  }
  _endUpdate() {
    if (this._updateCounter--, this._updateCounter === 0) {
      const e = this._currentTransaction;
      this._currentTransaction = void 0, e.finish();
    }
  }
  constructor(e) {
    super(), this.editor = e, this._updateCounter = 0, this._currentTransaction = void 0, this._model = qt(this, this.editor.getModel()), this.model = this._model, this.isReadonly = Ei(this, this.editor.onDidChangeConfiguration, () => this.editor.getOption(
      92
      /* EditorOption.readOnly */
    )), this._versionId = ok({ owner: this, lazy: !0 }, this.editor.getModel()?.getVersionId() ?? null), this.versionId = this._versionId, this._selections = ok({ owner: this, equalsFn: t9e(e7t(_n.selectionsEqual)), lazy: !0 }, this.editor.getSelections() ?? null), this.selections = this._selections, this.isFocused = Ei(this, (t) => {
      const n = this.editor.onDidFocusEditorWidget(t), i = this.editor.onDidBlurEditorWidget(t);
      return {
        dispose() {
          n.dispose(), i.dispose();
        }
      };
    }, () => this.editor.hasWidgetFocus()), this.value = vR(this, (t) => (this.versionId.read(t), this.model.read(t)?.getValue() ?? ""), (t, n) => {
      const i = this.model.get();
      i !== null && t !== i.getValue() && i.setValue(t);
    }), this.valueIsEmpty = dt(this, (t) => (this.versionId.read(t), this.editor.getModel()?.getValueLength() === 0)), this.cursorSelection = xy({ owner: this, equalsFn: t9e(_n.selectionsEqual) }, (t) => this.selections.read(t)?.[0] ?? null), this.onDidType = bR(this), this.scrollTop = Ei(this.editor.onDidScrollChange, () => this.editor.getScrollTop()), this.scrollLeft = Ei(this.editor.onDidScrollChange, () => this.editor.getScrollLeft()), this.layoutInfo = Ei(this.editor.onDidLayoutChange, () => this.editor.getLayoutInfo()), this.layoutInfoContentLeft = this.layoutInfo.map((t) => t.contentLeft), this.layoutInfoDecorationsLeft = this.layoutInfo.map((t) => t.decorationsLeft), this.contentWidth = Ei(this.editor.onDidContentSizeChange, () => this.editor.getContentWidth()), this._overlayWidgetCounter = 0, this._register(this.editor.onBeginUpdate(() => this._beginUpdate())), this._register(this.editor.onEndUpdate(() => this._endUpdate())), this._register(this.editor.onDidChangeModel(() => {
      this._beginUpdate();
      try {
        this._model.set(this.editor.getModel(), this._currentTransaction), this._forceUpdate();
      } finally {
        this._endUpdate();
      }
    })), this._register(this.editor.onDidType((t) => {
      this._beginUpdate();
      try {
        this._forceUpdate(), this.onDidType.trigger(this._currentTransaction, t);
      } finally {
        this._endUpdate();
      }
    })), this._register(this.editor.onDidChangeModelContent((t) => {
      this._beginUpdate();
      try {
        this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, t), this._forceUpdate();
      } finally {
        this._endUpdate();
      }
    })), this._register(this.editor.onDidChangeCursorSelection((t) => {
      this._beginUpdate();
      try {
        this._selections.set(this.editor.getSelections(), this._currentTransaction, t), this._forceUpdate();
      } finally {
        this._endUpdate();
      }
    }));
  }
  forceUpdate(e) {
    this._beginUpdate();
    try {
      return this._forceUpdate(), e ? e(this._currentTransaction) : void 0;
    } finally {
      this._endUpdate();
    }
  }
  _forceUpdate() {
    this._beginUpdate();
    try {
      this._model.set(this.editor.getModel(), this._currentTransaction), this._versionId.set(this.editor.getModel()?.getVersionId() ?? null, this._currentTransaction, void 0), this._selections.set(this.editor.getSelections(), this._currentTransaction, void 0);
    } finally {
      this._endUpdate();
    }
  }
  getOption(e) {
    return Ei(this, (t) => this.editor.onDidChangeConfiguration((n) => {
      n.hasChanged(e) && t(void 0);
    }), () => this.editor.getOption(e));
  }
  setDecorations(e) {
    const t = new ze(), n = this.editor.createDecorationsCollection();
    return t.add(Sy({ owner: this, debugName: () => `Apply decorations from ${e.debugName}` }, (i) => {
      const s = e.read(i);
      n.set(s);
    })), t.add({
      dispose: () => {
        n.clear();
      }
    }), t;
  }
  createOverlayWidget(e) {
    const t = "observableOverlayWidget" + this._overlayWidgetCounter++, n = {
      getDomNode: () => e.domNode,
      getPosition: () => e.position.get(),
      getId: () => t,
      allowEditorOverflow: e.allowEditorOverflow,
      getMinContentWidthInPx: () => e.minContentWidthInPx.get()
    };
    this.editor.addOverlayWidget(n);
    const i = nn((s) => {
      e.position.read(s), e.minContentWidthInPx.read(s), this.editor.layoutOverlayWidget(n);
    });
    return ht(() => {
      i.dispose(), this.editor.removeOverlayWidget(n);
    });
  }
}
var P_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, F_t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, H6;
let lN = class extends me {
  static {
    H6 = this;
  }
  static {
    this._breadcrumbsSourceFactory = qt(H6, () => ({
      dispose() {
      },
      getBreadcrumbItems(e, t) {
        return [];
      }
    }));
  }
  static setBreadcrumbsSourceFactory(e) {
    this._breadcrumbsSourceFactory.set(e, void 0);
  }
  get isUpdatingHiddenAreas() {
    return this._isUpdatingHiddenAreas;
  }
  constructor(e, t, n, i) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._instantiationService = i, this._modifiedOutlineSource = Pc(this, (l) => {
      const c = this._editors.modifiedModel.read(l), d = H6._breadcrumbsSourceFactory.read(l);
      return !c || !d ? void 0 : d(c, this._instantiationService);
    }), this._isUpdatingHiddenAreas = !1, this._register(this._editors.original.onDidChangeCursorPosition((l) => {
      if (l.reason === 1)
        return;
      const c = this._diffModel.get();
      er((d) => {
        for (const u of this._editors.original.getSelections() || [])
          c?.ensureOriginalLineIsVisible(u.getStartPosition().lineNumber, 0, d), c?.ensureOriginalLineIsVisible(u.getEndPosition().lineNumber, 0, d);
      });
    })), this._register(this._editors.modified.onDidChangeCursorPosition((l) => {
      if (l.reason === 1)
        return;
      const c = this._diffModel.get();
      er((d) => {
        for (const u of this._editors.modified.getSelections() || [])
          c?.ensureModifiedLineIsVisible(u.getStartPosition().lineNumber, 0, d), c?.ensureModifiedLineIsVisible(u.getEndPosition().lineNumber, 0, d);
      });
    }));
    const s = this._diffModel.map((l, c) => {
      const d = l?.unchangedRegions.read(c) ?? [];
      return d.length === 1 && d[0].modifiedLineNumber === 1 && d[0].lineCount === this._editors.modifiedModel.read(c)?.getLineCount() ? [] : d;
    });
    this.viewZones = om(this, (l, c) => {
      const d = this._modifiedOutlineSource.read(l);
      if (!d)
        return { origViewZones: [], modViewZones: [] };
      const u = [], f = [], p = this._options.renderSideBySide.read(l), g = this._options.compactMode.read(l), m = s.read(l);
      for (let A = 0; A < m.length; A++) {
        const w = m[A];
        if (!w.shouldHideControls(l) && !(g && (A === 0 || A === m.length - 1)))
          if (g) {
            {
              const v = dt(this, (_) => (
                /** @description hiddenOriginalRangeStart */
                w.getHiddenOriginalRange(_).startLineNumber - 1
              )), y = new hp(v, 12);
              u.push(y), c.add(new dbe(this._editors.original, y, w, !p));
            }
            {
              const v = dt(this, (_) => (
                /** @description hiddenModifiedRangeStart */
                w.getHiddenModifiedRange(_).startLineNumber - 1
              )), y = new hp(v, 12);
              f.push(y), c.add(new dbe(this._editors.modified, y, w));
            }
          } else {
            {
              const v = dt(this, (_) => (
                /** @description hiddenOriginalRangeStart */
                w.getHiddenOriginalRange(_).startLineNumber - 1
              )), y = new hp(v, 24);
              u.push(y), c.add(new ube(this._editors.original, y, w, w.originalUnchangedRange, !p, d, (_) => this._diffModel.get().ensureModifiedLineIsVisible(_, 2, void 0), this._options));
            }
            {
              const v = dt(this, (_) => (
                /** @description hiddenModifiedRangeStart */
                w.getHiddenModifiedRange(_).startLineNumber - 1
              )), y = new hp(v, 24);
              f.push(y), c.add(new ube(this._editors.modified, y, w, w.modifiedUnchangedRange, !1, d, (_) => this._diffModel.get().ensureModifiedLineIsVisible(_, 2, void 0), this._options));
            }
          }
      }
      return { origViewZones: u, modViewZones: f };
    });
    const o = {
      description: "unchanged lines",
      className: "diff-unchanged-lines",
      isWholeLine: !0
    }, a = {
      description: "Fold Unchanged",
      glyphMarginHoverMessage: new gNe(void 0, { isTrusted: !0, supportThemeIcons: !0 }).appendMarkdown(C("foldUnchanged", "Fold Unchanged Region")),
      glyphMarginClassName: "fold-unchanged " + Tt.asClassName(ke.fold),
      zIndex: 10001
    };
    this._register(lb(this._editors.original, dt(this, (l) => {
      const c = s.read(l), d = c.map((u) => ({
        range: u.originalUnchangedRange.toInclusiveRange(),
        options: o
      }));
      for (const u of c)
        u.shouldHideControls(l) && d.push({
          range: Q.fromPositions(new le(u.originalLineNumber, 1)),
          options: a
        });
      return d;
    }))), this._register(lb(this._editors.modified, dt(this, (l) => {
      const c = s.read(l), d = c.map((u) => ({
        range: u.modifiedUnchangedRange.toInclusiveRange(),
        options: o
      }));
      for (const u of c)
        u.shouldHideControls(l) && d.push({
          range: lt.ofLength(u.modifiedLineNumber, 1).toInclusiveRange(),
          options: a
        });
      return d;
    }))), this._register(nn((l) => {
      const c = s.read(l);
      this._isUpdatingHiddenAreas = !0;
      try {
        this._editors.original.setHiddenAreas(c.map((d) => d.getHiddenOriginalRange(l).toInclusiveRange()).filter(tg)), this._editors.modified.setHiddenAreas(c.map((d) => d.getHiddenModifiedRange(l).toInclusiveRange()).filter(tg));
      } finally {
        this._isUpdatingHiddenAreas = !1;
      }
    })), this._register(this._editors.modified.onMouseUp((l) => {
      if (!l.event.rightButton && l.target.position && l.target.element?.className.includes("fold-unchanged")) {
        const c = l.target.position.lineNumber, d = this._diffModel.get();
        if (!d)
          return;
        const u = d.unchangedRegions.get().find((f) => f.modifiedUnchangedRange.includes(c));
        if (!u)
          return;
        u.collapseAll(void 0), l.event.stopPropagation(), l.event.preventDefault();
      }
    })), this._register(this._editors.original.onMouseUp((l) => {
      if (!l.event.rightButton && l.target.position && l.target.element?.className.includes("fold-unchanged")) {
        const c = l.target.position.lineNumber, d = this._diffModel.get();
        if (!d)
          return;
        const u = d.unchangedRegions.get().find((f) => f.originalUnchangedRange.includes(c));
        if (!u)
          return;
        u.collapseAll(void 0), l.event.stopPropagation(), l.event.preventDefault();
      }
    }));
  }
};
lN = H6 = P_t([
  F_t(3, xn)
], lN);
class dbe extends KR {
  constructor(e, t, n, i = !1) {
    const s = Ut("div.diff-hidden-lines-widget");
    super(e, t, s.root), this._unchangedRegion = n, this._hide = i, this._nodes = Ut("div.diff-hidden-lines-compact", [
      Ut("div.line-left", []),
      Ut("div.text@text", []),
      Ut("div.line-right", [])
    ]), s.root.appendChild(this._nodes.root), this._hide && this._nodes.root.replaceChildren(), this._register(nn((o) => {
      if (!this._hide) {
        const a = this._unchangedRegion.getHiddenModifiedRange(o).length, l = C("hiddenLines", "{0} hidden lines", a);
        this._nodes.text.innerText = l;
      }
    }));
  }
}
class ube extends KR {
  constructor(e, t, n, i, s, o, a, l) {
    const c = Ut("div.diff-hidden-lines-widget");
    super(e, t, c.root), this._editor = e, this._unchangedRegion = n, this._unchangedRegionRange = i, this._hide = s, this._modifiedOutlineSource = o, this._revealModifiedHiddenLine = a, this._options = l, this._nodes = Ut("div.diff-hidden-lines", [
      Ut("div.top@top", { title: C("diff.hiddenLines.top", "Click or drag to show more above") }),
      Ut("div.center@content", { style: { display: "flex" } }, [
        Ut("div@first", { style: { display: "flex", justifyContent: "center", alignItems: "center", flexShrink: "0" } }, [$e("a", { title: C("showUnchangedRegion", "Show Unchanged Region"), role: "button", onclick: () => {
          this._unchangedRegion.showAll(void 0);
        } }, ...X0("$(unfold)"))]),
        Ut("div@others", { style: { display: "flex", justifyContent: "center", alignItems: "center" } })
      ]),
      Ut("div.bottom@bottom", { title: C("diff.bottom", "Click or drag to show more below"), role: "button" })
    ]), c.root.appendChild(this._nodes.root), this._hide ? ys(this._nodes.first) : this._register(g1(this._nodes.first, { width: m4(this._editor).layoutInfoContentLeft })), this._register(nn((u) => {
      const f = this._unchangedRegion.visibleLineCountTop.read(u) + this._unchangedRegion.visibleLineCountBottom.read(u) === this._unchangedRegion.lineCount;
      this._nodes.bottom.classList.toggle("canMoveTop", !f), this._nodes.bottom.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0), this._nodes.top.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), this._nodes.top.classList.toggle("canMoveBottom", !f);
      const p = this._unchangedRegion.isDragged.read(u), g = this._editor.getDomNode();
      g && (g.classList.toggle("draggingUnchangedRegion", !!p), p === "top" ? (g.classList.toggle("canMoveTop", this._unchangedRegion.visibleLineCountTop.read(u) > 0), g.classList.toggle("canMoveBottom", !f)) : p === "bottom" ? (g.classList.toggle("canMoveTop", !f), g.classList.toggle("canMoveBottom", this._unchangedRegion.visibleLineCountBottom.read(u) > 0)) : (g.classList.toggle("canMoveTop", !1), g.classList.toggle("canMoveBottom", !1)));
    }));
    const d = this._editor;
    this._register(fe(this._nodes.top, "mousedown", (u) => {
      if (u.button !== 0)
        return;
      this._nodes.top.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const f = u.clientY;
      let p = !1;
      const g = this._unchangedRegion.visibleLineCountTop.get();
      this._unchangedRegion.isDragged.set("top", void 0);
      const m = qe(this._nodes.top), A = fe(m, "mousemove", (v) => {
        const _ = v.clientY - f;
        p = p || Math.abs(_) > 2;
        const S = Math.round(_ / d.getOption(
          67
          /* EditorOption.lineHeight */
        )), D = Math.max(0, Math.min(g + S, this._unchangedRegion.getMaxVisibleLineCountTop()));
        this._unchangedRegion.visibleLineCountTop.set(D, void 0);
      }), w = fe(m, "mouseup", (v) => {
        p || this._unchangedRegion.showMoreAbove(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0), this._nodes.top.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), this._unchangedRegion.isDragged.set(void 0, void 0), A.dispose(), w.dispose();
      });
    })), this._register(fe(this._nodes.bottom, "mousedown", (u) => {
      if (u.button !== 0)
        return;
      this._nodes.bottom.classList.toggle("dragging", !0), this._nodes.root.classList.toggle("dragging", !0), u.preventDefault();
      const f = u.clientY;
      let p = !1;
      const g = this._unchangedRegion.visibleLineCountBottom.get();
      this._unchangedRegion.isDragged.set("bottom", void 0);
      const m = qe(this._nodes.bottom), A = fe(m, "mousemove", (v) => {
        const _ = v.clientY - f;
        p = p || Math.abs(_) > 2;
        const S = Math.round(_ / d.getOption(
          67
          /* EditorOption.lineHeight */
        )), D = Math.max(0, Math.min(g - S, this._unchangedRegion.getMaxVisibleLineCountBottom())), M = this._unchangedRegionRange.endLineNumberExclusive > d.getModel().getLineCount() ? d.getContentHeight() : d.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        this._unchangedRegion.visibleLineCountBottom.set(D, void 0);
        const L = this._unchangedRegionRange.endLineNumberExclusive > d.getModel().getLineCount() ? d.getContentHeight() : d.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
        d.setScrollTop(d.getScrollTop() + (L - M));
      }), w = fe(m, "mouseup", (v) => {
        if (this._unchangedRegion.isDragged.set(void 0, void 0), !p) {
          const y = d.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          this._unchangedRegion.showMoreBelow(this._options.hideUnchangedRegionsRevealLineCount.get(), void 0);
          const _ = d.getTopForLineNumber(this._unchangedRegionRange.endLineNumberExclusive);
          d.setScrollTop(d.getScrollTop() + (_ - y));
        }
        this._nodes.bottom.classList.toggle("dragging", !1), this._nodes.root.classList.toggle("dragging", !1), A.dispose(), w.dispose();
      });
    })), this._register(nn((u) => {
      const f = [];
      if (!this._hide) {
        const p = n.getHiddenModifiedRange(u).length, g = C("hiddenLines", "{0} hidden lines", p), m = $e("span", { title: C("diff.hiddenLines.expandAll", "Double click to unfold") }, g);
        m.addEventListener("dblclick", (v) => {
          v.button === 0 && (v.preventDefault(), this._unchangedRegion.showAll(void 0));
        }), f.push(m);
        const A = this._unchangedRegion.getHiddenModifiedRange(u), w = this._modifiedOutlineSource.getBreadcrumbItems(A, u);
        if (w.length > 0) {
          f.push($e("span", void 0, "  |  "));
          for (let v = 0; v < w.length; v++) {
            const y = w[v], _ = VM.toIcon(y.kind), S = Ut("div.breadcrumb-item", {
              style: { display: "flex", alignItems: "center" }
            }, [
              S9(_),
              " ",
              y.name,
              ...v === w.length - 1 ? [] : [S9(ke.chevronRight)]
            ]).root;
            f.push(S), S.onclick = () => {
              this._revealModifiedHiddenLine(y.startLineNumber);
            };
          }
        }
      }
      ys(this._nodes.others, ...f);
    }));
  }
}
var z_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, W_t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, Tl;
let A4 = class extends me {
  static {
    Tl = this;
  }
  static {
    this.ONE_OVERVIEW_WIDTH = 15;
  }
  static {
    this.ENTIRE_DIFF_OVERVIEW_WIDTH = this.ONE_OVERVIEW_WIDTH * 2;
  }
  constructor(e, t, n, i, s, o, a) {
    super(), this._editors = e, this._rootElement = t, this._diffModel = n, this._rootWidth = i, this._rootHeight = s, this._modifiedEditorLayoutInfo = o, this._themeService = a, this.width = Tl.ENTIRE_DIFF_OVERVIEW_WIDTH;
    const l = Ei(this._themeService.onDidColorThemeChange, () => this._themeService.getColorTheme()), c = dt((f) => {
      const p = l.read(f), g = p.getColor(jmt) || (p.getColor(zmt) || aL).transparent(2), m = p.getColor(Zmt) || (p.getColor(Wmt) || lL).transparent(2);
      return { insertColor: g, removeColor: m };
    }), d = Yt(document.createElement("div"));
    d.setClassName("diffViewport"), d.setPosition("absolute");
    const u = Ut("div.diffOverview", {
      style: { position: "absolute", top: "0px", width: Tl.ENTIRE_DIFF_OVERVIEW_WIDTH + "px" }
    }).root;
    this._register(_A(u, d.domNode)), this._register(ir(u, Se.POINTER_DOWN, (f) => {
      this._editors.modified.delegateVerticalScrollbarPointerDown(f);
    })), this._register(fe(u, Se.MOUSE_WHEEL, (f) => {
      this._editors.modified.delegateScrollFromMouseWheelEvent(f);
    }, { passive: !1 })), this._register(_A(this._rootElement, u)), this._register(Xl((f, p) => {
      const g = this._diffModel.read(f), m = this._editors.original.createOverviewRuler("original diffOverviewRuler");
      m && (p.add(m), p.add(_A(u, m.getDomNode())));
      const A = this._editors.modified.createOverviewRuler("modified diffOverviewRuler");
      if (A && (p.add(A), p.add(_A(u, A.getDomNode()))), !m || !A)
        return;
      const w = aa("viewZoneChanged", this._editors.original.onDidChangeViewZones), v = aa("viewZoneChanged", this._editors.modified.onDidChangeViewZones), y = aa("hiddenRangesChanged", this._editors.original.onDidChangeHiddenAreas), _ = aa("hiddenRangesChanged", this._editors.modified.onDidChangeHiddenAreas);
      p.add(nn((S) => {
        w.read(S), v.read(S), y.read(S), _.read(S);
        const D = c.read(S), M = g?.diff.read(S)?.mappings;
        function L(V, N, R) {
          const H = R._getViewModel();
          return H ? V.filter((z) => z.length > 0).map((z) => {
            const U = H.coordinatesConverter.convertModelPositionToViewPosition(new le(z.startLineNumber, 1)), ee = H.coordinatesConverter.convertModelPositionToViewPosition(new le(z.endLineNumberExclusive, 1)), ce = ee.lineNumber - U.lineNumber;
            return new Cke(U.lineNumber, ee.lineNumber, ce, N.toString());
          }) : [];
        }
        const T = L((M || []).map((V) => V.lineRangeMapping.original), D.removeColor, this._editors.original), B = L((M || []).map((V) => V.lineRangeMapping.modified), D.insertColor, this._editors.modified);
        m?.setZones(T), A?.setZones(B);
      })), p.add(nn((S) => {
        const D = this._rootHeight.read(S), M = this._rootWidth.read(S), L = this._modifiedEditorLayoutInfo.read(S);
        if (L) {
          const T = Tl.ENTIRE_DIFF_OVERVIEW_WIDTH - 2 * Tl.ONE_OVERVIEW_WIDTH;
          m.setLayout({
            top: 0,
            height: D,
            right: T + Tl.ONE_OVERVIEW_WIDTH,
            width: Tl.ONE_OVERVIEW_WIDTH
          }), A.setLayout({
            top: 0,
            height: D,
            right: 0,
            width: Tl.ONE_OVERVIEW_WIDTH
          });
          const B = this._editors.modifiedScrollTop.read(S), V = this._editors.modifiedScrollHeight.read(S), N = this._editors.modified.getOption(
            104
            /* EditorOption.scrollbar */
          ), R = new gg(N.verticalHasArrows ? N.arrowSize : 0, N.verticalScrollbarSize, 0, L.height, V, B);
          d.setTop(R.getSliderPosition()), d.setHeight(R.getSliderSize());
        } else
          d.setTop(0), d.setHeight(0);
        u.style.height = D + "px", u.style.left = M - Tl.ENTIRE_DIFF_OVERVIEW_WIDTH + "px", d.setWidth(Tl.ENTIRE_DIFF_OVERVIEW_WIDTH);
      }));
    }));
  }
};
A4 = Tl = z_t([
  W_t(6, Sa)
], A4);
const I_ = [];
class j_t extends me {
  constructor(e, t, n, i) {
    super(), this._editors = e, this._diffModel = t, this._options = n, this._widget = i, this._selectedDiffs = dt(this, (s) => {
      const a = this._diffModel.read(s)?.diff.read(s);
      if (!a)
        return I_;
      const l = this._editors.modifiedSelections.read(s);
      if (l.every((f) => f.isEmpty()))
        return I_;
      const c = new sa(l.map((f) => lt.fromRangeInclusive(f))), u = a.mappings.filter((f) => f.lineRangeMapping.innerChanges && c.intersects(f.lineRangeMapping.modified)).map((f) => ({
        mapping: f,
        rangeMappings: f.lineRangeMapping.innerChanges.filter((p) => l.some((g) => Q.areIntersecting(p.modifiedRange, g)))
      }));
      return u.length === 0 || u.every((f) => f.rangeMappings.length === 0) ? I_ : u;
    }), this._register(Xl((s, o) => {
      if (!this._options.shouldRenderOldRevertArrows.read(s))
        return;
      const a = this._diffModel.read(s), l = a?.diff.read(s);
      if (!a || !l || a.movedTextToCompare.read(s))
        return;
      const c = [], d = this._selectedDiffs.read(s), u = new Set(d.map((f) => f.mapping));
      if (d.length > 0) {
        const f = this._editors.modifiedSelections.read(s), p = o.add(new ub(f[f.length - 1].positionLineNumber, this._widget, d.flatMap((g) => g.rangeMappings), !0));
        this._editors.modified.addGlyphMarginWidget(p), c.push(p);
      }
      for (const f of l.mappings)
        if (!u.has(f) && !f.lineRangeMapping.modified.isEmpty && f.lineRangeMapping.innerChanges) {
          const p = o.add(new ub(f.lineRangeMapping.modified.startLineNumber, this._widget, f.lineRangeMapping, !1));
          this._editors.modified.addGlyphMarginWidget(p), c.push(p);
        }
      o.add(ht(() => {
        for (const f of c)
          this._editors.modified.removeGlyphMarginWidget(f);
      }));
    }));
  }
}
class ub extends me {
  static {
    this.counter = 0;
  }
  getId() {
    return this._id;
  }
  constructor(e, t, n, i) {
    super(), this._lineNumber = e, this._widget = t, this._diffs = n, this._revertSelection = i, this._id = `revertButton${ub.counter++}`, this._domNode = Ut("div.revertButton", {
      title: this._revertSelection ? C("revertSelectedChanges", "Revert Selected Changes") : C("revertChange", "Revert Change")
    }, [S9(ke.arrowRight)]).root, this._register(fe(this._domNode, Se.MOUSE_DOWN, (s) => {
      s.button !== 2 && (s.stopPropagation(), s.preventDefault());
    })), this._register(fe(this._domNode, Se.MOUSE_UP, (s) => {
      s.stopPropagation(), s.preventDefault();
    })), this._register(fe(this._domNode, Se.CLICK, (s) => {
      this._diffs instanceof ns ? this._widget.revert(this._diffs) : this._widget.revertRangeMappings(this._diffs), s.stopPropagation(), s.preventDefault();
    }));
  }
  /**
   * Get the dom node of the glyph widget.
   */
  getDomNode() {
    return this._domNode;
  }
  /**
   * Get the placement of the glyph widget.
   */
  getPosition() {
    return {
      lane: h1.Right,
      range: {
        startColumn: 1,
        startLineNumber: this._lineNumber,
        endColumn: 1,
        endLineNumber: this._lineNumber
      },
      zIndex: 10001
    };
  }
}
function Fh(r, e, t) {
  const n = r.bindTo(e);
  return Sy({ debugName: () => `Set Context Key "${r.key}"` }, (i) => {
    n.set(t(i));
  });
}
var Z_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, fbe = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let cN = class extends me {
  get onDidContentSizeChange() {
    return this._onDidContentSizeChange.event;
  }
  constructor(e, t, n, i, s, o, a) {
    super(), this.originalEditorElement = e, this.modifiedEditorElement = t, this._options = n, this._argCodeEditorWidgetOptions = i, this._createInnerEditor = s, this._instantiationService = o, this._keybindingService = a, this.original = this._register(this._createLeftHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.originalEditor || {})), this.modified = this._register(this._createRightHandSideEditor(this._options.editorOptions.get(), this._argCodeEditorWidgetOptions.modifiedEditor || {})), this._onDidContentSizeChange = this._register(new $()), this.modifiedScrollTop = Ei(this, this.modified.onDidScrollChange, () => (
      /** @description modified.getScrollTop */
      this.modified.getScrollTop()
    )), this.modifiedScrollHeight = Ei(this, this.modified.onDidScrollChange, () => (
      /** @description modified.getScrollHeight */
      this.modified.getScrollHeight()
    )), this.modifiedObs = m4(this.modified), this.originalObs = m4(this.original), this.modifiedModel = this.modifiedObs.model, this.modifiedSelections = Ei(this, this.modified.onDidChangeCursorSelection, () => this.modified.getSelections() ?? []), this.modifiedCursor = xy({ owner: this, equalsFn: le.equals }, (l) => this.modifiedSelections.read(l)[0]?.getPosition() ?? new le(1, 1)), this.originalCursor = Ei(this, this.original.onDidChangeCursorPosition, () => this.original.getPosition() ?? new le(1, 1)), this._argCodeEditorWidgetOptions = null, this._register(My({
      createEmptyChangeSummary: () => ({}),
      handleChange: (l, c) => (l.didChange(n.editorOptions) && Object.assign(c, l.change.changedOptions), !0)
    }, (l, c) => {
      n.editorOptions.read(l), this._options.renderSideBySide.read(l), this.modified.updateOptions(this._adjustOptionsForRightHandSide(l, c)), this.original.updateOptions(this._adjustOptionsForLeftHandSide(l, c));
    }));
  }
  _createLeftHandSideEditor(e, t) {
    const n = this._adjustOptionsForLeftHandSide(void 0, e), i = this._constructInnerEditor(this._instantiationService, this.originalEditorElement, n, t);
    return i.setContextValue("isInDiffLeftEditor", !0), i;
  }
  _createRightHandSideEditor(e, t) {
    const n = this._adjustOptionsForRightHandSide(void 0, e), i = this._constructInnerEditor(this._instantiationService, this.modifiedEditorElement, n, t);
    return i.setContextValue("isInDiffRightEditor", !0), i;
  }
  _constructInnerEditor(e, t, n, i) {
    const s = this._createInnerEditor(e, t, n, i);
    return this._register(s.onDidContentSizeChange((o) => {
      const a = this.original.getContentWidth() + this.modified.getContentWidth() + A4.ENTIRE_DIFF_OVERVIEW_WIDTH, l = Math.max(this.modified.getContentHeight(), this.original.getContentHeight());
      this._onDidContentSizeChange.fire({
        contentHeight: l,
        contentWidth: a,
        contentHeightChanged: o.contentHeightChanged,
        contentWidthChanged: o.contentWidthChanged
      });
    })), s;
  }
  _adjustOptionsForLeftHandSide(e, t) {
    const n = this._adjustOptionsForSubEditor(t);
    return this._options.renderSideBySide.get() ? (n.unicodeHighlight = this._options.editorOptions.get().unicodeHighlight || {}, n.wordWrapOverride1 = this._options.diffWordWrap.get()) : (n.wordWrapOverride1 = "off", n.wordWrapOverride2 = "off", n.stickyScroll = { enabled: !1 }, n.unicodeHighlight = { nonBasicASCII: !1, ambiguousCharacters: !1, invisibleCharacters: !1 }), n.glyphMargin = this._options.renderSideBySide.get(), t.originalAriaLabel && (n.ariaLabel = t.originalAriaLabel), n.ariaLabel = this._updateAriaLabel(n.ariaLabel), n.readOnly = !this._options.originalEditable.get(), n.dropIntoEditor = { enabled: !n.readOnly }, n.extraEditorClassName = "original-in-monaco-diff-editor", n;
  }
  _adjustOptionsForRightHandSide(e, t) {
    const n = this._adjustOptionsForSubEditor(t);
    return t.modifiedAriaLabel && (n.ariaLabel = t.modifiedAriaLabel), n.ariaLabel = this._updateAriaLabel(n.ariaLabel), n.wordWrapOverride1 = this._options.diffWordWrap.get(), n.revealHorizontalRightPadding = Wf.revealHorizontalRightPadding.defaultValue + A4.ENTIRE_DIFF_OVERVIEW_WIDTH, n.scrollbar.verticalHasArrows = !1, n.extraEditorClassName = "modified-in-monaco-diff-editor", n;
  }
  _adjustOptionsForSubEditor(e) {
    const t = {
      ...e,
      dimension: {
        height: 0,
        width: 0
      }
    };
    return t.inDiffEditor = !0, t.automaticLayout = !1, t.scrollbar = { ...t.scrollbar || {} }, t.folding = !1, t.codeLens = this._options.diffCodeLens.get(), t.fixedOverflowWidgets = !0, t.minimap = { ...t.minimap || {} }, t.minimap.enabled = !1, this._options.hideUnchangedRegions.get() ? t.stickyScroll = { enabled: !1 } : t.stickyScroll = this._options.editorOptions.get().stickyScroll, t;
  }
  _updateAriaLabel(e) {
    e || (e = "");
    const t = C("diff-aria-navigation-tip", " use {0} to open the accessibility help.", this._keybindingService.lookupKeybinding("editor.action.accessibilityHelp")?.getAriaLabel());
    return this._options.accessibilityVerbose.get() ? e + t : e ? e.replaceAll(t, "") : "";
  }
};
cN = Z_t([
  fbe(5, xn),
  fbe(6, _r)
], cN);
class rV extends me {
  constructor() {
    super(...arguments), this._id = ++rV.idCounter, this._onDidDispose = this._register(new $()), this.onDidDispose = this._onDidDispose.event;
  }
  static {
    this.idCounter = 0;
  }
  getId() {
    return this.getEditorType() + ":v2:" + this._id;
  }
  // #region editorBrowser.IDiffEditor: Delegating to modified Editor
  getVisibleColumnFromPosition(e) {
    return this._targetEditor.getVisibleColumnFromPosition(e);
  }
  getPosition() {
    return this._targetEditor.getPosition();
  }
  setPosition(e, t = "api") {
    this._targetEditor.setPosition(e, t);
  }
  revealLine(e, t = 0) {
    this._targetEditor.revealLine(e, t);
  }
  revealLineInCenter(e, t = 0) {
    this._targetEditor.revealLineInCenter(e, t);
  }
  revealLineInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealLineInCenterIfOutsideViewport(e, t);
  }
  revealLineNearTop(e, t = 0) {
    this._targetEditor.revealLineNearTop(e, t);
  }
  revealPosition(e, t = 0) {
    this._targetEditor.revealPosition(e, t);
  }
  revealPositionInCenter(e, t = 0) {
    this._targetEditor.revealPositionInCenter(e, t);
  }
  revealPositionInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealPositionInCenterIfOutsideViewport(e, t);
  }
  revealPositionNearTop(e, t = 0) {
    this._targetEditor.revealPositionNearTop(e, t);
  }
  getSelection() {
    return this._targetEditor.getSelection();
  }
  getSelections() {
    return this._targetEditor.getSelections();
  }
  setSelection(e, t = "api") {
    this._targetEditor.setSelection(e, t);
  }
  setSelections(e, t = "api") {
    this._targetEditor.setSelections(e, t);
  }
  revealLines(e, t, n = 0) {
    this._targetEditor.revealLines(e, t, n);
  }
  revealLinesInCenter(e, t, n = 0) {
    this._targetEditor.revealLinesInCenter(e, t, n);
  }
  revealLinesInCenterIfOutsideViewport(e, t, n = 0) {
    this._targetEditor.revealLinesInCenterIfOutsideViewport(e, t, n);
  }
  revealLinesNearTop(e, t, n = 0) {
    this._targetEditor.revealLinesNearTop(e, t, n);
  }
  revealRange(e, t = 0, n = !1, i = !0) {
    this._targetEditor.revealRange(e, t, n, i);
  }
  revealRangeInCenter(e, t = 0) {
    this._targetEditor.revealRangeInCenter(e, t);
  }
  revealRangeInCenterIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeInCenterIfOutsideViewport(e, t);
  }
  revealRangeNearTop(e, t = 0) {
    this._targetEditor.revealRangeNearTop(e, t);
  }
  revealRangeNearTopIfOutsideViewport(e, t = 0) {
    this._targetEditor.revealRangeNearTopIfOutsideViewport(e, t);
  }
  revealRangeAtTop(e, t = 0) {
    this._targetEditor.revealRangeAtTop(e, t);
  }
  getSupportedActions() {
    return this._targetEditor.getSupportedActions();
  }
  focus() {
    this._targetEditor.focus();
  }
  trigger(e, t, n) {
    this._targetEditor.trigger(e, t, n);
  }
  createDecorationsCollection(e) {
    return this._targetEditor.createDecorationsCollection(e);
  }
  changeDecorations(e) {
    return this._targetEditor.changeDecorations(e);
  }
}
var U_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, q_t = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let hN = class {
  get editorOptions() {
    return this._options;
  }
  constructor(e, t) {
    this._accessibilityService = t, this._diffEditorWidth = qt(this, 0), this._screenReaderMode = Ei(this, this._accessibilityService.onDidChangeScreenReaderOptimized, () => this._accessibilityService.isScreenReaderOptimized()), this.couldShowInlineViewBecauseOfSize = dt(this, (i) => this._options.read(i).renderSideBySide && this._diffEditorWidth.read(i) <= this._options.read(i).renderSideBySideInlineBreakpoint), this.renderOverviewRuler = dt(this, (i) => this._options.read(i).renderOverviewRuler), this.renderSideBySide = dt(this, (i) => this.compactMode.read(i) && this.shouldRenderInlineViewInSmartMode.read(i) ? !1 : this._options.read(i).renderSideBySide && !(this._options.read(i).useInlineViewWhenSpaceIsLimited && this.couldShowInlineViewBecauseOfSize.read(i) && !this._screenReaderMode.read(i))), this.readOnly = dt(this, (i) => this._options.read(i).readOnly), this.shouldRenderOldRevertArrows = dt(this, (i) => !(!this._options.read(i).renderMarginRevertIcon || !this.renderSideBySide.read(i) || this.readOnly.read(i) || this.shouldRenderGutterMenu.read(i))), this.shouldRenderGutterMenu = dt(this, (i) => this._options.read(i).renderGutterMenu), this.renderIndicators = dt(this, (i) => this._options.read(i).renderIndicators), this.enableSplitViewResizing = dt(this, (i) => this._options.read(i).enableSplitViewResizing), this.splitViewDefaultRatio = dt(this, (i) => this._options.read(i).splitViewDefaultRatio), this.ignoreTrimWhitespace = dt(this, (i) => this._options.read(i).ignoreTrimWhitespace), this.maxComputationTimeMs = dt(this, (i) => this._options.read(i).maxComputationTime), this.showMoves = dt(this, (i) => this._options.read(i).experimental.showMoves && this.renderSideBySide.read(i)), this.isInEmbeddedEditor = dt(this, (i) => this._options.read(i).isInEmbeddedEditor), this.diffWordWrap = dt(this, (i) => this._options.read(i).diffWordWrap), this.originalEditable = dt(this, (i) => this._options.read(i).originalEditable), this.diffCodeLens = dt(this, (i) => this._options.read(i).diffCodeLens), this.accessibilityVerbose = dt(this, (i) => this._options.read(i).accessibilityVerbose), this.diffAlgorithm = dt(this, (i) => this._options.read(i).diffAlgorithm), this.showEmptyDecorations = dt(this, (i) => this._options.read(i).experimental.showEmptyDecorations), this.onlyShowAccessibleDiffViewer = dt(this, (i) => this._options.read(i).onlyShowAccessibleDiffViewer), this.compactMode = dt(this, (i) => this._options.read(i).compactMode), this.trueInlineDiffRenderingEnabled = dt(this, (i) => this._options.read(i).experimental.useTrueInlineView), this.useTrueInlineDiffRendering = dt(this, (i) => !this.renderSideBySide.read(i) && this.trueInlineDiffRenderingEnabled.read(i)), this.hideUnchangedRegions = dt(this, (i) => this._options.read(i).hideUnchangedRegions.enabled), this.hideUnchangedRegionsRevealLineCount = dt(this, (i) => this._options.read(i).hideUnchangedRegions.revealLineCount), this.hideUnchangedRegionsContextLineCount = dt(this, (i) => this._options.read(i).hideUnchangedRegions.contextLineCount), this.hideUnchangedRegionsMinimumLineCount = dt(this, (i) => this._options.read(i).hideUnchangedRegions.minimumLineCount), this._model = qt(this, void 0), this.shouldRenderInlineViewInSmartMode = this._model.map(this, (i) => m7t(this, (s) => {
      const o = i?.diff.read(s);
      return o ? G_t(o, this.trueInlineDiffRenderingEnabled.read(s)) : void 0;
    })).flatten().map(this, (i) => !!i), this.inlineViewHideOriginalLineNumbers = this.compactMode;
    const n = { ...e, ...pbe(e, xr) };
    this._options = qt(this, n);
  }
  updateOptions(e) {
    const t = pbe(e, this._options.get()), n = { ...this._options.get(), ...e, ...t };
    this._options.set(n, void 0, { changedOptions: e });
  }
  setWidth(e) {
    this._diffEditorWidth.set(e, void 0);
  }
  setModel(e) {
    this._model.set(e, void 0);
  }
};
hN = U_t([
  q_t(1, pc)
], hN);
function G_t(r, e) {
  return r.mappings.every((t) => Q_t(t.lineRangeMapping) || K_t(t.lineRangeMapping) || e && nV(t.lineRangeMapping));
}
function Q_t(r) {
  return r.original.length === 0;
}
function K_t(r) {
  return r.modified.length === 0;
}
function pbe(r, e) {
  return {
    enableSplitViewResizing: Re(r.enableSplitViewResizing, e.enableSplitViewResizing),
    splitViewDefaultRatio: But(r.splitViewDefaultRatio, 0.5, 0.1, 0.9),
    renderSideBySide: Re(r.renderSideBySide, e.renderSideBySide),
    renderMarginRevertIcon: Re(r.renderMarginRevertIcon, e.renderMarginRevertIcon),
    maxComputationTime: n0(
      r.maxComputationTime,
      e.maxComputationTime,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    maxFileSize: n0(
      r.maxFileSize,
      e.maxFileSize,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    ignoreTrimWhitespace: Re(r.ignoreTrimWhitespace, e.ignoreTrimWhitespace),
    renderIndicators: Re(r.renderIndicators, e.renderIndicators),
    originalEditable: Re(r.originalEditable, e.originalEditable),
    diffCodeLens: Re(r.diffCodeLens, e.diffCodeLens),
    renderOverviewRuler: Re(r.renderOverviewRuler, e.renderOverviewRuler),
    diffWordWrap: ai(r.diffWordWrap, e.diffWordWrap, ["off", "on", "inherit"]),
    diffAlgorithm: ai(r.diffAlgorithm, e.diffAlgorithm, ["legacy", "advanced"], { smart: "legacy", experimental: "advanced" }),
    accessibilityVerbose: Re(r.accessibilityVerbose, e.accessibilityVerbose),
    experimental: {
      showMoves: Re(r.experimental?.showMoves, e.experimental.showMoves),
      showEmptyDecorations: Re(r.experimental?.showEmptyDecorations, e.experimental.showEmptyDecorations),
      useTrueInlineView: Re(r.experimental?.useTrueInlineView, e.experimental.useTrueInlineView)
    },
    hideUnchangedRegions: {
      enabled: Re(r.hideUnchangedRegions?.enabled ?? r.experimental?.collapseUnchangedRegions, e.hideUnchangedRegions.enabled),
      contextLineCount: n0(
        r.hideUnchangedRegions?.contextLineCount,
        e.hideUnchangedRegions.contextLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      ),
      minimumLineCount: n0(
        r.hideUnchangedRegions?.minimumLineCount,
        e.hideUnchangedRegions.minimumLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      ),
      revealLineCount: n0(
        r.hideUnchangedRegions?.revealLineCount,
        e.hideUnchangedRegions.revealLineCount,
        0,
        1073741824
        /* Constants.MAX_SAFE_SMALL_INTEGER */
      )
    },
    isInEmbeddedEditor: Re(r.isInEmbeddedEditor, e.isInEmbeddedEditor),
    onlyShowAccessibleDiffViewer: Re(r.onlyShowAccessibleDiffViewer, e.onlyShowAccessibleDiffViewer),
    renderSideBySideInlineBreakpoint: n0(
      r.renderSideBySideInlineBreakpoint,
      e.renderSideBySideInlineBreakpoint,
      0,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ),
    useInlineViewWhenSpaceIsLimited: Re(r.useInlineViewWhenSpaceIsLimited, e.useInlineViewWhenSpaceIsLimited),
    renderGutterMenu: Re(r.renderGutterMenu, e.renderGutterMenu),
    compactMode: Re(r.compactMode, e.compactMode)
  };
}
var Y_t = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Km = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let fb = class extends rV {
  get onDidContentSizeChange() {
    return this._editors.onDidContentSizeChange;
  }
  constructor(e, t, n, i, s, o, a, l) {
    super(), this._domElement = e, this._parentContextKeyService = i, this._parentInstantiationService = s, this._accessibilitySignalService = a, this._editorProgressService = l, this.elements = Ut("div.monaco-diff-editor.side-by-side", { style: { position: "relative", height: "100%" } }, [
      Ut("div.editor.original@original", { style: { position: "absolute", height: "100%" } }),
      Ut("div.editor.modified@modified", { style: { position: "absolute", height: "100%" } }),
      Ut("div.accessibleDiffViewer@accessibleDiffViewer", { style: { position: "absolute", height: "100%" } })
    ]), this._diffModelSrc = this._register(LNe(this, void 0)), this._diffModel = dt(this, (_) => this._diffModelSrc.read(_)?.object), this.onDidChangeModel = xe.fromObservableLight(this._diffModel), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._domElement)), this._instantiationService = this._register(this._parentInstantiationService.createChild(new Nw([sn, this._contextKeyService]))), this._boundarySashes = qt(this, void 0), this._accessibleDiffViewerShouldBeVisible = qt(this, !1), this._accessibleDiffViewerVisible = dt(this, (_) => this._options.onlyShowAccessibleDiffViewer.read(_) ? !0 : this._accessibleDiffViewerShouldBeVisible.read(_)), this._movedBlocksLinesPart = qt(this, void 0), this._layoutInfo = dt(this, (_) => {
      const S = this._rootSizeObserver.width.read(_), D = this._rootSizeObserver.height.read(_);
      this._rootSizeObserver.automaticLayout ? this.elements.root.style.height = "100%" : this.elements.root.style.height = D + "px";
      const M = this._sash.read(_), L = this._gutter.read(_), T = L?.width.read(_) ?? 0, B = this._overviewRulerPart.read(_)?.width ?? 0;
      let V, N, R, H, z;
      if (!!M) {
        const ee = M.sashLeft.read(_), ce = this._movedBlocksLinesPart.read(_)?.width.read(_) ?? 0;
        V = 0, N = ee - T - ce, z = ee - T, R = ee, H = S - R - B;
      } else {
        z = 0;
        const ee = this._options.inlineViewHideOriginalLineNumbers.read(_);
        V = T, ee ? N = 0 : N = Math.max(5, this._editors.originalObs.layoutInfoDecorationsLeft.read(_)), R = T + N, H = S - R - B;
      }
      return this.elements.original.style.left = V + "px", this.elements.original.style.width = N + "px", this._editors.original.layout({ width: N, height: D }, !0), L?.layout(z), this.elements.modified.style.left = R + "px", this.elements.modified.style.width = H + "px", this._editors.modified.layout({ width: H, height: D }, !0), {
        modifiedEditor: this._editors.modified.getLayoutInfo(),
        originalEditor: this._editors.original.getLayoutInfo()
      };
    }), this._diffValue = this._diffModel.map((_, S) => _?.diff.read(S)), this.onDidUpdateDiff = xe.fromObservableLight(this._diffValue), o.willCreateDiffEditor(), this._contextKeyService.createKey("isInDiffEditor", !0), this._domElement.appendChild(this.elements.root), this._register(ht(() => this.elements.root.remove())), this._rootSizeObserver = this._register(new STe(this.elements.root, t.dimension)), this._rootSizeObserver.setAutomaticLayout(t.automaticLayout ?? !1), this._options = this._instantiationService.createInstance(hN, t), this._register(nn((_) => {
      this._options.setWidth(this._rootSizeObserver.width.read(_));
    })), this._contextKeyService.createKey(Me.isEmbeddedDiffEditor.key, !1), this._register(Fh(Me.isEmbeddedDiffEditor, this._contextKeyService, (_) => this._options.isInEmbeddedEditor.read(_))), this._register(Fh(Me.comparingMovedCode, this._contextKeyService, (_) => !!this._diffModel.read(_)?.movedTextToCompare.read(_))), this._register(Fh(Me.diffEditorRenderSideBySideInlineBreakpointReached, this._contextKeyService, (_) => this._options.couldShowInlineViewBecauseOfSize.read(_))), this._register(Fh(Me.diffEditorInlineMode, this._contextKeyService, (_) => !this._options.renderSideBySide.read(_))), this._register(Fh(Me.hasChanges, this._contextKeyService, (_) => (this._diffModel.read(_)?.diff.read(_)?.mappings.length ?? 0) > 0)), this._editors = this._register(this._instantiationService.createInstance(cN, this.elements.original, this.elements.modified, this._options, n, (_, S, D, M) => this._createInnerEditor(_, S, D, M))), this._register(Fh(Me.diffEditorOriginalWritable, this._contextKeyService, (_) => this._options.originalEditable.read(_))), this._register(Fh(Me.diffEditorModifiedWritable, this._contextKeyService, (_) => !this._options.readOnly.read(_))), this._register(Fh(Me.diffEditorOriginalUri, this._contextKeyService, (_) => this._diffModel.read(_)?.model.original.uri.toString() ?? "")), this._register(Fh(Me.diffEditorModifiedUri, this._contextKeyService, (_) => this._diffModel.read(_)?.model.modified.uri.toString() ?? "")), this._overviewRulerPart = Pc(this, (_) => this._options.renderOverviewRuler.read(_) ? this._instantiationService.createInstance(za(A4, _), this._editors, this.elements.root, this._diffModel, this._rootSizeObserver.width, this._rootSizeObserver.height, this._layoutInfo.map((S) => S.modifiedEditor)) : void 0).recomputeInitiallyAndOnChange(this._store);
    const c = {
      height: this._rootSizeObserver.height,
      width: this._rootSizeObserver.width.map((_, S) => _ - (this._overviewRulerPart.read(S)?.width ?? 0))
    };
    this._sashLayout = new R_t(this._options, c), this._sash = Pc(this, (_) => {
      const S = this._options.renderSideBySide.read(_);
      return this.elements.root.classList.toggle("side-by-side", S), S ? new TTe(this.elements.root, c, this._options.enableSplitViewResizing, this._boundarySashes, this._sashLayout.sashLeft, () => this._sashLayout.resetSash()) : void 0;
    }).recomputeInitiallyAndOnChange(this._store);
    const d = Pc(this, (_) => (
      /** @description UnchangedRangesFeature */
      this._instantiationService.createInstance(za(lN, _), this._editors, this._diffModel, this._options)
    )).recomputeInitiallyAndOnChange(this._store);
    Pc(this, (_) => (
      /** @description DiffEditorDecorations */
      this._instantiationService.createInstance(za(O_t, _), this._editors, this._diffModel, this._options, this)
    )).recomputeInitiallyAndOnChange(this._store);
    const u = /* @__PURE__ */ new Set(), f = /* @__PURE__ */ new Set();
    let p = !1;
    const g = Pc(this, (_) => (
      /** @description ViewZoneManager */
      this._instantiationService.createInstance(za(rN, _), qe(this._domElement), this._editors, this._diffModel, this._options, this, () => p || d.get().isUpdatingHiddenAreas, u, f)
    )).recomputeInitiallyAndOnChange(this._store), m = dt(this, (_) => {
      const S = g.read(_).viewZones.read(_).orig, D = d.read(_).viewZones.read(_).origViewZones;
      return S.concat(D);
    }), A = dt(this, (_) => {
      const S = g.read(_).viewZones.read(_).mod, D = d.read(_).viewZones.read(_).modViewZones;
      return S.concat(D);
    });
    this._register(cb(this._editors.original, m, (_) => {
      p = _;
    }, u));
    let w;
    this._register(cb(this._editors.modified, A, (_) => {
      p = _, p ? w = ab.capture(this._editors.modified) : (w?.restore(this._editors.modified), w = void 0);
    }, f)), this._accessibleDiffViewer = Pc(this, (_) => this._instantiationService.createInstance(za(B0, _), this.elements.accessibleDiffViewer, this._accessibleDiffViewerVisible, (S, D) => this._accessibleDiffViewerShouldBeVisible.set(S, D), this._options.onlyShowAccessibleDiffViewer.map((S) => !S), this._rootSizeObserver.width, this._rootSizeObserver.height, this._diffModel.map((S, D) => S?.diff.read(D)?.mappings.map((M) => M.lineRangeMapping)), new w_t(this._editors))).recomputeInitiallyAndOnChange(this._store);
    const v = this._accessibleDiffViewerVisible.map((_) => _ ? "hidden" : "visible");
    this._register(g1(this.elements.modified, { visibility: v })), this._register(g1(this.elements.original, { visibility: v })), this._createDiffEditorContributions(), o.addDiffEditor(this), this._gutter = Pc(this, (_) => this._options.shouldRenderGutterMenu.read(_) ? this._instantiationService.createInstance(za(oN, _), this.elements.root, this._diffModel, this._editors, this._options, this._sashLayout, this._boundarySashes) : void 0), this._register(Ly(this._layoutInfo)), Pc(this, (_) => (
      /** @description MovedBlocksLinesPart */
      new (za(ef, _))(this.elements.root, this._diffModel, this._layoutInfo.map((S) => S.originalEditor), this._layoutInfo.map((S) => S.modifiedEditor), this._editors)
    )).recomputeInitiallyAndOnChange(this._store, (_) => {
      this._movedBlocksLinesPart.set(_, void 0);
    }), this._register(xe.runAndSubscribe(this._editors.modified.onDidChangeCursorPosition, (_) => this._handleCursorPositionChange(_, !0))), this._register(xe.runAndSubscribe(this._editors.original.onDidChangeCursorPosition, (_) => this._handleCursorPositionChange(_, !1)));
    const y = this._diffModel.map(this, (_, S) => {
      if (_)
        return _.diff.read(S) === void 0 && !_.isDiffUpToDate.read(S);
    });
    this._register(Xl((_, S) => {
      if (y.read(_) === !0) {
        const D = this._editorProgressService.show(!0, 1e3);
        S.add(ht(() => D.done()));
      }
    })), this._register(Xl((_, S) => {
      S.add(new (za(j_t, _))(this._editors, this._diffModel, this._options, this));
    })), this._register(Xl((_, S) => {
      const D = this._diffModel.read(_);
      if (D)
        for (const M of [D.model.original, D.model.modified])
          S.add(M.onWillDispose((L) => {
            wn(new cn("TextModel got disposed before DiffEditorWidget model got reset")), this.setModel(null);
          }));
    })), this._register(nn((_) => {
      this._options.setModel(this._diffModel.read(_));
    }));
  }
  _createInnerEditor(e, t, n, i) {
    return e.createInstance(C9, t, n, i);
  }
  _createDiffEditorContributions() {
    const e = wp.getDiffEditorContributions();
    for (const t of e)
      try {
        this._register(this._instantiationService.createInstance(t.ctor, this));
      } catch (n) {
        wn(n);
      }
  }
  get _targetEditor() {
    return this._editors.modified;
  }
  getEditorType() {
    return dO.IDiffEditor;
  }
  layout(e) {
    this._rootSizeObserver.observe(e);
  }
  hasTextFocus() {
    return this._editors.original.hasTextFocus() || this._editors.modified.hasTextFocus();
  }
  saveViewState() {
    const e = this._editors.original.saveViewState(), t = this._editors.modified.saveViewState();
    return {
      original: e,
      modified: t,
      modelState: this._diffModel.get()?.serializeState()
    };
  }
  restoreViewState(e) {
    if (e && e.original && e.modified) {
      const t = e;
      this._editors.original.restoreViewState(t.original), this._editors.modified.restoreViewState(t.modified), t.modelState && this._diffModel.get()?.restoreSerializedState(t.modelState);
    }
  }
  handleInitialized() {
    this._editors.original.handleInitialized(), this._editors.modified.handleInitialized();
  }
  createViewModel(e) {
    return this._instantiationService.createInstance(iN, e, this._options);
  }
  getModel() {
    return this._diffModel.get()?.model ?? null;
  }
  setModel(e) {
    const t = e ? "model" in e ? hb.create(e).createNewRef(this) : hb.create(this.createViewModel(e), this) : null;
    this.setDiffModel(t);
  }
  setDiffModel(e, t) {
    const n = this._diffModel.get();
    !e && n && this._accessibleDiffViewer.get().close(), this._diffModel.get() !== e?.object && AR(t, (i) => {
      const s = e?.object;
      Ei.batchEventsGlobally(i, () => {
        this._editors.original.setModel(s ? s.model.original : null), this._editors.modified.setModel(s ? s.model.modified : null);
      });
      const o = this._diffModelSrc.get()?.createNewRef(this);
      this._diffModelSrc.set(e?.createNewRef(this), i), setTimeout(() => {
        o?.dispose();
      }, 0);
    });
  }
  /**
   * @param changedOptions Only has values for top-level options that have actually changed.
   */
  updateOptions(e) {
    this._options.updateOptions(e);
  }
  getContainerDomNode() {
    return this._domElement;
  }
  getOriginalEditor() {
    return this._editors.original;
  }
  getModifiedEditor() {
    return this._editors.modified;
  }
  /**
   * @deprecated Use `this.getDiffComputationResult().changes2` instead.
   */
  getLineChanges() {
    const e = this._diffModel.get()?.diff.get();
    return e ? X_t(e) : null;
  }
  revert(e) {
    const t = this._diffModel.get();
    !t || !t.isDiffUpToDate.get() || this._editors.modified.executeEdits("diffEditor", [
      {
        range: e.modified.toExclusiveRange(),
        text: t.model.original.getValueInRange(e.original.toExclusiveRange())
      }
    ]);
  }
  revertRangeMappings(e) {
    const t = this._diffModel.get();
    if (!t || !t.isDiffUpToDate.get())
      return;
    const n = e.map((i) => ({
      range: i.modifiedRange,
      text: t.model.original.getValueInRange(i.originalRange)
    }));
    this._editors.modified.executeEdits("diffEditor", n);
  }
  _goTo(e) {
    this._editors.modified.setPosition(new le(e.lineRangeMapping.modified.startLineNumber, 1)), this._editors.modified.revealRangeInCenter(e.lineRangeMapping.modified.toExclusiveRange());
  }
  goToDiff(e) {
    const t = this._diffModel.get()?.diff.get()?.mappings;
    if (!t || t.length === 0)
      return;
    const n = this._editors.modified.getPosition().lineNumber;
    let i;
    e === "next" ? i = t.find((s) => s.lineRangeMapping.modified.startLineNumber > n) ?? t[0] : i = G8(t, (s) => s.lineRangeMapping.modified.startLineNumber < n) ?? t[t.length - 1], this._goTo(i), i.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(mn.diffLineDeleted, { source: "diffEditor.goToDiff" }) : i.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(mn.diffLineInserted, { source: "diffEditor.goToDiff" }) : i && this._accessibilitySignalService.playSignal(mn.diffLineModified, { source: "diffEditor.goToDiff" });
  }
  revealFirstDiff() {
    const e = this._diffModel.get();
    e && this.waitForDiff().then(() => {
      const t = e.diff.get()?.mappings;
      !t || t.length === 0 || this._goTo(t[0]);
    });
  }
  accessibleDiffViewerNext() {
    this._accessibleDiffViewer.get().next();
  }
  accessibleDiffViewerPrev() {
    this._accessibleDiffViewer.get().prev();
  }
  async waitForDiff() {
    const e = this._diffModel.get();
    e && await e.waitForDiff();
  }
  mapToOtherSide() {
    const e = this._editors.modified.hasWidgetFocus(), t = e ? this._editors.modified : this._editors.original, n = e ? this._editors.original : this._editors.modified;
    let i;
    const s = t.getSelection();
    if (s) {
      const o = this._diffModel.get()?.diff.get()?.mappings.map((a) => e ? a.lineRangeMapping.flip() : a.lineRangeMapping);
      if (o) {
        const a = K9e(s.getStartPosition(), o), l = K9e(s.getEndPosition(), o);
        i = Q.plusRange(a, l);
      }
    }
    return { destination: n, destinationSelection: i };
  }
  switchSide() {
    const { destination: e, destinationSelection: t } = this.mapToOtherSide();
    e.focus(), t && e.setSelection(t);
  }
  exitCompareMove() {
    const e = this._diffModel.get();
    e && e.movedTextToCompare.set(void 0, void 0);
  }
  collapseAllUnchangedRegions() {
    const e = this._diffModel.get()?.unchangedRegions.get();
    e && er((t) => {
      for (const n of e)
        n.collapseAll(t);
    });
  }
  showAllUnchangedRegions() {
    const e = this._diffModel.get()?.unchangedRegions.get();
    e && er((t) => {
      for (const n of e)
        n.showAll(t);
    });
  }
  _handleCursorPositionChange(e, t) {
    if (e?.reason === 3) {
      const n = this._diffModel.get()?.diff.get()?.mappings.find((i) => t ? i.lineRangeMapping.modified.contains(e.position.lineNumber) : i.lineRangeMapping.original.contains(e.position.lineNumber));
      n?.lineRangeMapping.modified.isEmpty ? this._accessibilitySignalService.playSignal(mn.diffLineDeleted, { source: "diffEditor.cursorPositionChanged" }) : n?.lineRangeMapping.original.isEmpty ? this._accessibilitySignalService.playSignal(mn.diffLineInserted, { source: "diffEditor.cursorPositionChanged" }) : n && this._accessibilitySignalService.playSignal(mn.diffLineModified, { source: "diffEditor.cursorPositionChanged" });
    }
  }
};
fb = Y_t([
  Km(3, sn),
  Km(4, xn),
  Km(5, Ui),
  Km(6, zy),
  Km(7, pR)
], fb);
function X_t(r) {
  return r.mappings.map((e) => {
    const t = e.lineRangeMapping;
    let n, i, s, o, a = t.innerChanges;
    return t.original.isEmpty ? (n = t.original.startLineNumber - 1, i = 0, a = void 0) : (n = t.original.startLineNumber, i = t.original.endLineNumberExclusive - 1), t.modified.isEmpty ? (s = t.modified.startLineNumber - 1, o = 0, a = void 0) : (s = t.modified.startLineNumber, o = t.modified.endLineNumberExclusive - 1), {
      originalStartLineNumber: n,
      originalEndLineNumber: i,
      modifiedStartLineNumber: s,
      modifiedEndLineNumber: o,
      charChanges: a?.map((l) => ({
        originalStartLineNumber: l.originalRange.startLineNumber,
        originalStartColumn: l.originalRange.startColumn,
        originalEndLineNumber: l.originalRange.endLineNumber,
        originalEndColumn: l.originalRange.endColumn,
        modifiedStartLineNumber: l.modifiedRange.startLineNumber,
        modifiedStartColumn: l.modifiedRange.startColumn,
        modifiedEndLineNumber: l.modifiedRange.endLineNumber,
        modifiedEndColumn: l.modifiedRange.endColumn
      }))
    };
  });
}
var sV = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Dn = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let J_t = 0, gbe = !1;
function $_t(r) {
  if (!r) {
    if (gbe)
      return;
    gbe = !0;
  }
  dmt(r || Sn.document.body);
}
let pb = class extends C9 {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f, p) {
    const g = { ...t };
    g.ariaLabel = g.ariaLabel || T9.editorViewAccessibleLabel, g.ariaLabel = g.ariaLabel + ";" + T9.accessibilityHelpMessage, super(e, g, {}, n, i, s, o, c, d, u, f, p), l instanceof Eg ? this._standaloneKeybindingService = l : this._standaloneKeybindingService = null, $_t(g.ariaContainerElement), jbt((m, A) => n.createInstance(s4, m, A, {})), Zbt(a);
  }
  addCommand(e, t, n) {
    if (!this._standaloneKeybindingService)
      return console.warn("Cannot add command because the editor is configured with an unrecognized KeybindingService"), null;
    const i = "DYNAMIC_" + ++J_t, s = mt.deserialize(n);
    return this._standaloneKeybindingService.addDynamicKeybinding(i, e, t, s), i;
  }
  createContextKey(e, t) {
    return this._contextKeyService.createKey(e, t);
  }
  addAction(e) {
    if (typeof e.id != "string" || typeof e.label != "string" || typeof e.run != "function")
      throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
    if (!this._standaloneKeybindingService)
      return console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), me.None;
    const t = e.id, n = e.label, i = mt.and(mt.equals("editorId", this.getId()), mt.deserialize(e.precondition)), s = e.keybindings, o = mt.and(i, mt.deserialize(e.keybindingContext)), a = e.contextMenuGroupId || null, l = e.contextMenuOrder || 0, c = (p, ...g) => Promise.resolve(e.run(this, ...g)), d = new ze(), u = this.getId() + ":" + t;
    if (d.add(Zs.registerCommand(u, c)), a) {
      const p = {
        command: {
          id: u,
          title: n
        },
        when: i,
        group: a,
        order: l
      };
      d.add(og.appendMenuItem(oe.EditorContext, p));
    }
    if (Array.isArray(s))
      for (const p of s)
        d.add(this._standaloneKeybindingService.addDynamicKeybinding(u, p, c, o));
    const f = new _ke(u, n, n, void 0, i, (...p) => Promise.resolve(e.run(this, ...p)), this._contextKeyService);
    return this._actions.set(t, f), d.add(ht(() => {
      this._actions.delete(t);
    })), d;
  }
  _triggerCommand(e, t) {
    if (this._codeEditorService instanceof E9)
      try {
        this._codeEditorService.setActiveCodeEditor(this), super._triggerCommand(e, t);
      } finally {
        this._codeEditorService.setActiveCodeEditor(null);
      }
    else
      super._triggerCommand(e, t);
  }
};
pb = sV([
  Dn(2, xn),
  Dn(3, Ui),
  Dn(4, jo),
  Dn(5, sn),
  Dn(6, i2),
  Dn(7, _r),
  Dn(8, Sa),
  Dn(9, Zo),
  Dn(10, pc),
  Dn(11, xh),
  Dn(12, Vn)
], pb);
let dN = class extends pb {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f, p, g, m, A) {
    const w = { ...t };
    ob(u, w, !1);
    const v = c.registerEditorContainer(e);
    typeof w.theme == "string" && c.setTheme(w.theme), typeof w.autoDetectHighContrast < "u" && c.setAutoDetectHighContrast(!!w.autoDetectHighContrast);
    const y = w.model;
    delete w.model, super(e, w, n, i, s, o, a, l, c, d, f, m, A), this._configurationService = u, this._standaloneThemeService = c, this._register(v);
    let _;
    if (typeof y > "u") {
      const S = g.getLanguageIdByMimeType(w.language) || w.language || ll;
      _ = VTe(p, g, w.value || "", S, void 0), this._ownsModel = !0;
    } else
      _ = y, this._ownsModel = !1;
    if (this._attachModel(_), _) {
      const S = {
        oldModelUrl: null,
        newModelUrl: _.uri
      };
      this._onDidChangeModel.fire(S);
    }
  }
  dispose() {
    super.dispose();
  }
  updateOptions(e) {
    ob(this._configurationService, e, !1), typeof e.theme == "string" && this._standaloneThemeService.setTheme(e.theme), typeof e.autoDetectHighContrast < "u" && this._standaloneThemeService.setAutoDetectHighContrast(!!e.autoDetectHighContrast), super.updateOptions(e);
  }
  _postDetachModelCleanup(e) {
    super._postDetachModelCleanup(e), e && this._ownsModel && (e.dispose(), this._ownsModel = !1);
  }
};
dN = sV([
  Dn(2, xn),
  Dn(3, Ui),
  Dn(4, jo),
  Dn(5, sn),
  Dn(6, i2),
  Dn(7, _r),
  Dn(8, bl),
  Dn(9, Zo),
  Dn(10, Ai),
  Dn(11, pc),
  Dn(12, Wo),
  Dn(13, sr),
  Dn(14, xh),
  Dn(15, Vn)
], dN);
let uN = class extends fb {
  constructor(e, t, n, i, s, o, a, l, c, d, u, f) {
    const p = { ...t };
    ob(l, p, !0);
    const g = o.registerEditorContainer(e);
    typeof p.theme == "string" && o.setTheme(p.theme), typeof p.autoDetectHighContrast < "u" && o.setAutoDetectHighContrast(!!p.autoDetectHighContrast), super(e, p, {}, i, n, s, f, d), this._configurationService = l, this._standaloneThemeService = o, this._register(g);
  }
  dispose() {
    super.dispose();
  }
  updateOptions(e) {
    ob(this._configurationService, e, !0), typeof e.theme == "string" && this._standaloneThemeService.setTheme(e.theme), typeof e.autoDetectHighContrast < "u" && this._standaloneThemeService.setAutoDetectHighContrast(!!e.autoDetectHighContrast), super.updateOptions(e);
  }
  _createInnerEditor(e, t, n) {
    return e.createInstance(pb, t, n);
  }
  getOriginalEditor() {
    return super.getOriginalEditor();
  }
  getModifiedEditor() {
    return super.getModifiedEditor();
  }
  addCommand(e, t, n) {
    return this.getModifiedEditor().addCommand(e, t, n);
  }
  createContextKey(e, t) {
    return this.getModifiedEditor().createContextKey(e, t);
  }
  addAction(e) {
    return this.getModifiedEditor().addAction(e);
  }
};
uN = sV([
  Dn(2, xn),
  Dn(3, sn),
  Dn(4, Ui),
  Dn(5, bl),
  Dn(6, Zo),
  Dn(7, Ai),
  Dn(8, Qd),
  Dn(9, pR),
  Dn(10, Fw),
  Dn(11, zy)
], uN);
function VTe(r, e, t, n, i) {
  if (t = t || "", !n) {
    const s = t.indexOf(`
`);
    let o = t;
    return s !== -1 && (o = t.substring(0, s)), mbe(r, t, e.createByFilepathOrFirstLine(i || null, o), i);
  }
  return mbe(r, t, e.createById(n), i);
}
function mbe(r, e, t, n) {
  return r.createModel(e, t, n);
}
var ext = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, txt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
class nxt {
  constructor(e, t) {
    this.viewModel = e, this.deltaScrollVertical = t;
  }
  getId() {
    return this.viewModel;
  }
}
let gb = class extends me {
  constructor(e, t, n, i) {
    super(), this._container = e, this._overflowWidgetsDomNode = t, this._workbenchUIElementFactory = n, this._instantiationService = i, this._viewModel = qt(this, void 0), this._collapsed = dt(this, (o) => this._viewModel.read(o)?.collapsed.read(o)), this._editorContentHeight = qt(this, 500), this.contentHeight = dt(this, (o) => (this._collapsed.read(o) ? 0 : this._editorContentHeight.read(o)) + this._outerEditorHeight), this._modifiedContentWidth = qt(this, 0), this._modifiedWidth = qt(this, 0), this._originalContentWidth = qt(this, 0), this._originalWidth = qt(this, 0), this.maxScroll = dt(this, (o) => {
      const a = this._modifiedContentWidth.read(o) - this._modifiedWidth.read(o), l = this._originalContentWidth.read(o) - this._originalWidth.read(o);
      return a > l ? { maxScroll: a, width: this._modifiedWidth.read(o) } : { maxScroll: l, width: this._originalWidth.read(o) };
    }), this._elements = Ut("div.multiDiffEntry", [
      Ut("div.header@header", [
        Ut("div.header-content", [
          Ut("div.collapse-button@collapseButton"),
          Ut("div.file-path", [
            Ut("div.title.modified.show-file-icons@primaryPath", []),
            Ut("div.status.deleted@status", ["R"]),
            Ut("div.title.original.show-file-icons@secondaryPath", [])
          ]),
          Ut("div.actions@actions")
        ])
      ]),
      Ut("div.editorParent", [
        Ut("div.editorContainer@editor")
      ])
    ]), this.editor = this._register(this._instantiationService.createInstance(fb, this._elements.editor, {
      overflowWidgetsDomNode: this._overflowWidgetsDomNode
    }, {})), this.isModifedFocused = m4(this.editor.getModifiedEditor()).isFocused, this.isOriginalFocused = m4(this.editor.getOriginalEditor()).isFocused, this.isFocused = dt(this, (o) => this.isModifedFocused.read(o) || this.isOriginalFocused.read(o)), this._resourceLabel = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.primaryPath)) : void 0, this._resourceLabel2 = this._workbenchUIElementFactory.createResourceLabel ? this._register(this._workbenchUIElementFactory.createResourceLabel(this._elements.secondaryPath)) : void 0, this._dataStore = new ze(), this._headerHeight = 40, this._lastScrollTop = -1, this._isSettingScrollTop = !1;
    const s = new _k(this._elements.collapseButton, {});
    this._register(nn((o) => {
      s.element.className = "", s.icon = this._collapsed.read(o) ? ke.chevronRight : ke.chevronDown;
    })), this._register(s.onDidClick(() => {
      this._viewModel.get()?.collapsed.set(!this._collapsed.get(), void 0);
    })), this._register(nn((o) => {
      this._elements.editor.style.display = this._collapsed.read(o) ? "none" : "block";
    })), this._register(this.editor.getModifiedEditor().onDidLayoutChange((o) => {
      const a = this.editor.getModifiedEditor().getLayoutInfo().contentWidth;
      this._modifiedWidth.set(a, void 0);
    })), this._register(this.editor.getOriginalEditor().onDidLayoutChange((o) => {
      const a = this.editor.getOriginalEditor().getLayoutInfo().contentWidth;
      this._originalWidth.set(a, void 0);
    })), this._register(this.editor.onDidContentSizeChange((o) => {
      yA((a) => {
        this._editorContentHeight.set(o.contentHeight, a), this._modifiedContentWidth.set(this.editor.getModifiedEditor().getContentWidth(), a), this._originalContentWidth.set(this.editor.getOriginalEditor().getContentWidth(), a);
      });
    })), this._register(this.editor.getOriginalEditor().onDidScrollChange((o) => {
      if (this._isSettingScrollTop || !o.scrollTopChanged || !this._data)
        return;
      const a = o.scrollTop - this._lastScrollTop;
      this._data.deltaScrollVertical(a);
    })), this._register(nn((o) => {
      const a = this._viewModel.read(o)?.isActive.read(o);
      this._elements.root.classList.toggle("active", a);
    })), this._container.appendChild(this._elements.root), this._outerEditorHeight = this._headerHeight, this._register(this._instantiationService.createInstance(db, this._elements.actions, oe.MultiDiffEditorFileToolbar, {
      actionRunner: this._register(new ITe(() => this._viewModel.get()?.modifiedUri)),
      menuOptions: {
        shouldForwardArgs: !0
      },
      toolbarOptions: { primaryGroup: (o) => o.startsWith("navigation") },
      actionViewItemProvider: (o, a) => $7t(i, o, a)
    }));
  }
  setScrollLeft(e) {
    this._modifiedContentWidth.get() - this._modifiedWidth.get() > this._originalContentWidth.get() - this._originalWidth.get() ? this.editor.getModifiedEditor().setScrollLeft(e) : this.editor.getOriginalEditor().setScrollLeft(e);
  }
  setData(e) {
    this._data = e;
    function t(i) {
      return {
        ...i,
        scrollBeyondLastLine: !1,
        hideUnchangedRegions: {
          enabled: !0
        },
        scrollbar: {
          vertical: "hidden",
          horizontal: "hidden",
          handleMouseWheel: !1,
          useShadows: !1
        },
        renderOverviewRuler: !1,
        fixedOverflowWidgets: !0,
        overviewRulerBorder: !1
      };
    }
    if (!e) {
      yA((i) => {
        this._viewModel.set(void 0, i), this.editor.setDiffModel(null, i), this._dataStore.clear();
      });
      return;
    }
    const n = e.viewModel.documentDiffItem;
    yA((i) => {
      this._resourceLabel?.setUri(e.viewModel.modifiedUri ?? e.viewModel.originalUri, { strikethrough: e.viewModel.modifiedUri === void 0 });
      let s = !1, o = !1, a = !1, l = "";
      e.viewModel.modifiedUri && e.viewModel.originalUri && e.viewModel.modifiedUri.path !== e.viewModel.originalUri.path ? (l = "R", s = !0) : e.viewModel.modifiedUri ? e.viewModel.originalUri || (l = "A", a = !0) : (l = "D", o = !0), this._elements.status.classList.toggle("renamed", s), this._elements.status.classList.toggle("deleted", o), this._elements.status.classList.toggle("added", a), this._elements.status.innerText = l, this._resourceLabel2?.setUri(s ? e.viewModel.originalUri : void 0, { strikethrough: !0 }), this._dataStore.clear(), this._viewModel.set(e.viewModel, i), this.editor.setDiffModel(e.viewModel.diffEditorViewModelRef, i), this.editor.updateOptions(t(n.options ?? {}));
    }), n.onOptionsDidChange && this._dataStore.add(n.onOptionsDidChange(() => {
      this.editor.updateOptions(t(n.options ?? {}));
    })), e.viewModel.isAlive.recomputeInitiallyAndOnChange(this._dataStore, (i) => {
      i || this.setData(void 0);
    });
  }
  render(e, t, n, i) {
    this._elements.root.style.visibility = "visible", this._elements.root.style.top = `${e.start}px`, this._elements.root.style.height = `${e.length}px`, this._elements.root.style.width = `${t}px`, this._elements.root.style.position = "absolute";
    const s = e.length - this._headerHeight, o = Math.max(0, Math.min(i.start - e.start, s));
    this._elements.header.style.transform = `translateY(${o}px)`, yA((a) => {
      this.editor.layout({
        width: t - 2 * 8 - 2 * 1,
        height: e.length - this._outerEditorHeight
      });
    });
    try {
      this._isSettingScrollTop = !0, this._lastScrollTop = n, this.editor.getOriginalEditor().setScrollTop(n);
    } finally {
      this._isSettingScrollTop = !1;
    }
    this._elements.header.classList.toggle("shadow", o > 0 || n > 0), this._elements.header.classList.toggle("collapsed", o === s);
  }
  hide() {
    this._elements.root.style.top = "-100000px", this._elements.root.style.visibility = "hidden";
  }
};
gb = ext([
  txt(3, xn)
], gb);
class ixt {
  constructor(e) {
    this._create = e, this._unused = /* @__PURE__ */ new Set(), this._used = /* @__PURE__ */ new Set(), this._itemData = /* @__PURE__ */ new Map();
  }
  getUnusedObj(e) {
    let t;
    if (this._unused.size === 0)
      t = this._create(e), this._itemData.set(t, e);
    else {
      const n = [...this._unused.values()];
      t = n.find((i) => this._itemData.get(i).getId() === e.getId()) ?? n[0], this._unused.delete(t), this._itemData.set(t, e), t.setData(e);
    }
    return this._used.add(t), {
      object: t,
      dispose: () => {
        this._used.delete(t), this._unused.size > 5 ? t.dispose() : this._unused.add(t);
      }
    };
  }
  dispose() {
    for (const e of this._used)
      e.dispose();
    for (const e of this._unused)
      e.dispose();
    this._used.clear(), this._unused.clear();
  }
}
var rxt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, Abe = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let fN = class extends me {
  constructor(e, t, n, i, s, o) {
    super(), this._element = e, this._dimension = t, this._viewModel = n, this._workbenchUIElementFactory = i, this._parentContextKeyService = s, this._parentInstantiationService = o, this._scrollableElements = Ut("div.scrollContent", [
      Ut("div@content", {
        style: {
          overflow: "hidden"
        }
      }),
      Ut("div.monaco-editor@overflowWidgetsDomNode", {})
    ]), this._scrollable = this._register(new nm({
      forceIntegerValues: !1,
      scheduleAtNextAnimationFrame: (l) => co(qe(this._element), l),
      smoothScrollDuration: 100
    })), this._scrollableElement = this._register(new fy(this._scrollableElements.root, {
      vertical: 1,
      horizontal: 1,
      useShadows: !1
    }, this._scrollable)), this._elements = Ut("div.monaco-component.multiDiffEditor", {}, [
      Ut("div", {}, [this._scrollableElement.getDomNode()]),
      Ut("div.placeholder@placeholder", {}, [Ut("div", [C("noChangedFiles", "No Changed Files")])])
    ]), this._sizeObserver = this._register(new STe(this._element, void 0)), this._objectPool = this._register(new ixt((l) => {
      const c = this._instantiationService.createInstance(gb, this._scrollableElements.content, this._scrollableElements.overflowWidgetsDomNode, this._workbenchUIElementFactory);
      return c.setData(l), c;
    })), this.scrollTop = Ei(this, this._scrollableElement.onScroll, () => (
      /** @description scrollTop */
      this._scrollableElement.getScrollPosition().scrollTop
    )), this.scrollLeft = Ei(this, this._scrollableElement.onScroll, () => (
      /** @description scrollLeft */
      this._scrollableElement.getScrollPosition().scrollLeft
    )), this._viewItemsInfo = om(this, (l, c) => {
      const d = this._viewModel.read(l);
      if (!d)
        return { items: [], getItem: (g) => {
          throw new cn();
        } };
      const u = d.items.read(l), f = /* @__PURE__ */ new Map();
      return { items: u.map((g) => {
        const m = c.add(new sxt(g, this._objectPool, this.scrollLeft, (w) => {
          this._scrollableElement.setScrollPosition({ scrollTop: this._scrollableElement.getScrollPosition().scrollTop + w });
        })), A = this._lastDocStates?.[m.getKey()];
        return A && er((w) => {
          m.setViewState(A, w);
        }), f.set(g, m), m;
      }), getItem: (g) => f.get(g) };
    }), this._viewItems = this._viewItemsInfo.map(this, (l) => l.items), this._spaceBetweenPx = 0, this._totalHeight = this._viewItems.map(this, (l, c) => l.reduce((d, u) => d + u.contentHeight.read(c) + this._spaceBetweenPx, 0)), this._contextKeyService = this._register(this._parentContextKeyService.createScoped(this._element)), this._instantiationService = this._register(this._parentInstantiationService.createChild(new Nw([sn, this._contextKeyService]))), this._lastDocStates = {}, this._contextKeyService.createKey(Me.inMultiDiffEditor.key, !0), this._register(Xl((l, c) => {
      const d = this._viewModel.read(l);
      if (d && d.contextKeys)
        for (const [u, f] of Object.entries(d.contextKeys)) {
          const p = this._contextKeyService.createKey(u, void 0);
          p.set(f), c.add(ht(() => p.reset()));
        }
    }));
    const a = this._parentContextKeyService.createKey(Me.multiDiffEditorAllCollapsed.key, !1);
    this._register(nn((l) => {
      const c = this._viewModel.read(l);
      if (c) {
        const d = c.items.read(l).every((u) => u.collapsed.read(l));
        a.set(d);
      }
    })), this._register(nn((l) => {
      const c = this._dimension.read(l);
      this._sizeObserver.observe(c);
    })), this._register(nn((l) => {
      const c = this._viewItems.read(l);
      this._elements.placeholder.classList.toggle("visible", c.length === 0);
    })), this._scrollableElements.content.style.position = "relative", this._register(nn((l) => {
      const c = this._sizeObserver.height.read(l);
      this._scrollableElements.root.style.height = `${c}px`;
      const d = this._totalHeight.read(l);
      this._scrollableElements.content.style.height = `${d}px`;
      const u = this._sizeObserver.width.read(l);
      let f = u;
      const p = this._viewItems.read(l), g = aLe(p, al((m) => m.maxScroll.read(l).maxScroll, Gu));
      if (g) {
        const m = g.maxScroll.read(l);
        f = u + m.maxScroll;
      }
      this._scrollableElement.setScrollDimensions({
        width: u,
        height: c,
        scrollHeight: d,
        scrollWidth: f
      });
    })), e.replaceChildren(this._elements.root), this._register(ht(() => {
      e.replaceChildren();
    })), this._register(this._register(nn((l) => {
      yA((c) => {
        this.render(l);
      });
    })));
  }
  render(e) {
    const t = this.scrollTop.read(e);
    let n = 0, i = 0, s = 0;
    const o = this._sizeObserver.height.read(e), a = pt.ofStartAndLength(t, o), l = this._sizeObserver.width.read(e);
    for (const c of this._viewItems.read(e)) {
      const d = c.contentHeight.read(e), u = Math.min(d, o), f = pt.ofStartAndLength(i, u), p = pt.ofStartAndLength(s, d);
      if (p.isBefore(a))
        n -= d - u, c.hide();
      else if (p.isAfter(a))
        c.hide();
      else {
        const g = Math.max(0, Math.min(a.start - p.start, d - u));
        n -= g;
        const m = pt.ofStartAndLength(t + n, o);
        c.render(f, g, l, m);
      }
      i += u + this._spaceBetweenPx, s += d + this._spaceBetweenPx;
    }
    this._scrollableElements.content.style.transform = `translateY(${-(t + n)}px)`;
  }
};
fN = rxt([
  Abe(4, sn),
  Abe(5, xn)
], fN);
class sxt extends me {
  constructor(e, t, n, i) {
    super(), this.viewModel = e, this._objectPool = t, this._scrollLeft = n, this._deltaScrollVertical = i, this._templateRef = this._register(LNe(this, void 0)), this.contentHeight = dt(this, (s) => this._templateRef.read(s)?.object.contentHeight?.read(s) ?? this.viewModel.lastTemplateData.read(s).contentHeight), this.maxScroll = dt(this, (s) => this._templateRef.read(s)?.object.maxScroll.read(s) ?? { maxScroll: 0, scrollWidth: 0 }), this.template = dt(this, (s) => this._templateRef.read(s)?.object), this._isHidden = qt(this, !1), this._isFocused = dt(this, (s) => this.template.read(s)?.isFocused.read(s) ?? !1), this.viewModel.setIsFocused(this._isFocused, void 0), this._register(nn((s) => {
      const o = this._scrollLeft.read(s);
      this._templateRef.read(s)?.object.setScrollLeft(o);
    })), this._register(nn((s) => {
      const o = this._templateRef.read(s);
      !o || !this._isHidden.read(s) || o.object.isFocused.read(s) || this._clear();
    }));
  }
  dispose() {
    this._clear(), super.dispose();
  }
  toString() {
    return `VirtualViewItem(${this.viewModel.documentDiffItem.modified?.uri.toString()})`;
  }
  getKey() {
    return this.viewModel.getKey();
  }
  setViewState(e, t) {
    this.viewModel.collapsed.set(e.collapsed, t), this._updateTemplateData(t);
    const n = this.viewModel.lastTemplateData.get(), i = e.selections?.map(_n.liftSelection);
    this.viewModel.lastTemplateData.set({
      ...n,
      selections: i
    }, t);
    const s = this._templateRef.get();
    s && i && s.object.editor.setSelections(i);
  }
  _updateTemplateData(e) {
    const t = this._templateRef.get();
    t && this.viewModel.lastTemplateData.set({
      contentHeight: t.object.contentHeight.get(),
      selections: t.object.editor.getSelections() ?? void 0
    }, e);
  }
  _clear() {
    const e = this._templateRef.get();
    e && er((t) => {
      this._updateTemplateData(t), e.object.hide(), this._templateRef.set(void 0, t);
    });
  }
  hide() {
    this._isHidden.set(!0, void 0);
  }
  render(e, t, n, i) {
    this._isHidden.set(!1, void 0);
    let s = this._templateRef.get();
    if (!s) {
      s = this._objectPool.getUnusedObj(new nxt(this.viewModel, this._deltaScrollVertical)), this._templateRef.set(s, void 0);
      const o = this.viewModel.lastTemplateData.get().selections;
      o && s.object.editor.setSelections(o);
    }
    s.object.render(e, n, t, i);
  }
}
Z("multiDiffEditor.headerBackground", { dark: "#262626", light: "tab.inactiveBackground", hcDark: "tab.inactiveBackground", hcLight: "tab.inactiveBackground" }, C("multiDiffEditor.headerBackground", "The background color of the diff editor's header"));
Z("multiDiffEditor.background", "editorBackground", C("multiDiffEditor.background", "The background color of the multi file diff editor"));
Z("multiDiffEditor.border", { dark: "sideBarSectionHeader.border", light: "#cccccc", hcDark: "sideBarSectionHeader.border", hcLight: "#cccccc" }, C("multiDiffEditor.border", "The border color of the multi file diff editor"));
var oxt = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, axt = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
let pN = class extends me {
  constructor(e, t, n) {
    super(), this._element = e, this._workbenchUIElementFactory = t, this._instantiationService = n, this._dimension = qt(this, void 0), this._viewModel = qt(this, void 0), this._widgetImpl = om(this, (i, s) => (za(gb, i), s.add(this._instantiationService.createInstance(za(fN, i), this._element, this._dimension, this._viewModel, this._workbenchUIElementFactory)))), this._register(Ly(this._widgetImpl));
  }
};
pN = oxt([
  axt(2, xn)
], pN);
function lxt(r, e, t) {
  return Qe.initialize(t || {}).createInstance(dN, r, e);
}
function cxt(r) {
  return Qe.get(Ui).onCodeEditorAdd((t) => {
    r(t);
  });
}
function hxt(r) {
  return Qe.get(Ui).onDiffEditorAdd((t) => {
    r(t);
  });
}
function dxt() {
  return Qe.get(Ui).listCodeEditors();
}
function uxt() {
  return Qe.get(Ui).listDiffEditors();
}
function fxt(r, e, t) {
  return Qe.initialize(t || {}).createInstance(uN, r, e);
}
function pxt(r, e) {
  const t = Qe.initialize(e || {});
  return new pN(r, {}, t);
}
function gxt(r) {
  if (typeof r.id != "string" || typeof r.run != "function")
    throw new Error("Invalid command descriptor, `id` and `run` are required properties!");
  return Zs.registerCommand(r.id, r.run);
}
function mxt(r) {
  if (typeof r.id != "string" || typeof r.label != "string" || typeof r.run != "function")
    throw new Error("Invalid action descriptor, `id`, `label` and `run` are required properties!");
  const e = mt.deserialize(r.precondition), t = (i, ...s) => Fd.runEditorCommand(i, s, e, (o, a, l) => Promise.resolve(r.run(a, ...l))), n = new ze();
  if (n.add(Zs.registerCommand(r.id, t)), r.contextMenuGroupId) {
    const i = {
      command: {
        id: r.id,
        title: r.label
      },
      when: e,
      group: r.contextMenuGroupId,
      order: r.contextMenuOrder || 0
    };
    n.add(og.appendMenuItem(oe.EditorContext, i));
  }
  if (Array.isArray(r.keybindings)) {
    const i = Qe.get(_r);
    if (!(i instanceof Eg))
      console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService");
    else {
      const s = mt.and(e, mt.deserialize(r.keybindingContext));
      n.add(i.addDynamicKeybindings(r.keybindings.map((o) => ({
        keybinding: o,
        command: r.id,
        when: s
      }))));
    }
  }
  return n;
}
function Axt(r) {
  return HTe([r]);
}
function HTe(r) {
  const e = Qe.get(_r);
  return e instanceof Eg ? e.addDynamicKeybindings(r.map((t) => ({
    keybinding: t.keybinding,
    command: t.command,
    commandArgs: t.commandArgs,
    when: mt.deserialize(t.when)
  }))) : (console.warn("Cannot add keybinding because the editor is configured with an unrecognized KeybindingService"), me.None);
}
function wxt(r, e, t) {
  const n = Qe.get(sr), i = n.getLanguageIdByMimeType(e) || e;
  return VTe(Qe.get(Wo), n, r, i, t);
}
function vxt(r, e) {
  const t = Qe.get(sr), n = t.getLanguageIdByMimeType(e) || e || ll;
  r.setLanguage(t.createById(n));
}
function bxt(r, e, t) {
  r && Qe.get(r2).changeOne(e, r.uri, t);
}
function yxt(r) {
  Qe.get(r2).changeAll(r, []);
}
function Cxt(r) {
  return Qe.get(r2).read(r);
}
function Ext(r) {
  return Qe.get(r2).onMarkerChanged(r);
}
function _xt(r) {
  return Qe.get(Wo).getModel(r);
}
function xxt() {
  return Qe.get(Wo).getModels();
}
function Sxt(r) {
  return Qe.get(Wo).onModelAdded(r);
}
function Mxt(r) {
  return Qe.get(Wo).onModelRemoved(r);
}
function Dxt(r) {
  return Qe.get(Wo).onModelLanguageChanged((t) => {
    r({
      model: t.model,
      oldLanguage: t.oldLanguageId
    });
  });
}
function Lxt(r) {
  return Vgt(Qe.get(Wo), Qe.get(xh), r);
}
function kxt(r, e) {
  const t = Qe.get(sr), n = Qe.get(bl);
  return mO.colorizeElement(n, t, r, e).then(() => {
    n.registerEditorContainer(r);
  });
}
function Nxt(r, e, t) {
  const n = Qe.get(sr);
  return Qe.get(bl).registerEditorContainer(Sn.document.body), mO.colorize(n, r, e, t);
}
function Txt(r, e, t = 4) {
  return Qe.get(bl).registerEditorContainer(Sn.document.body), mO.colorizeModelLine(r, e, t);
}
function Ixt(r) {
  const e = xi.get(r);
  return e || {
    getInitialState: () => Z3,
    tokenize: (t, n, i) => ALe(r, i)
  };
}
function Oxt(r, e) {
  xi.getOrCreate(e);
  const t = Ixt(e), n = $g(r), i = [];
  let s = t.getInitialState();
  for (let o = 0, a = n.length; o < a; o++) {
    const l = n[o], c = t.tokenize(l, !0, s);
    i[o] = c.tokens, s = c.endState;
  }
  return i;
}
function Rxt(r, e) {
  Qe.get(bl).defineTheme(r, e);
}
function Vxt(r) {
  Qe.get(bl).setTheme(r);
}
function Hxt() {
  WD.clearAllFontInfos();
}
function Bxt(r, e) {
  return Zs.registerCommand({ id: r, handler: e });
}
function Pxt(r) {
  return Qe.get(Tw).registerOpener({
    async open(t) {
      return typeof t == "string" && (t = Pt.parse(t)), r.open(t);
    }
  });
}
function Fxt(r) {
  return Qe.get(Ui).registerCodeEditorOpenHandler(async (t, n, i) => {
    if (!n)
      return null;
    const s = t.options?.selection;
    let o;
    return s && typeof s.endLineNumber == "number" && typeof s.endColumn == "number" ? o = s : s && (o = { lineNumber: s.startLineNumber, column: s.startColumn }), await r.openCodeEditor(n, t.resource, o) ? n : null;
  });
}
function zxt() {
  return {
    // methods
    create: lxt,
    getEditors: dxt,
    getDiffEditors: uxt,
    onDidCreateEditor: cxt,
    onDidCreateDiffEditor: hxt,
    createDiffEditor: fxt,
    addCommand: gxt,
    addEditorAction: mxt,
    addKeybindingRule: Axt,
    addKeybindingRules: HTe,
    createModel: wxt,
    setModelLanguage: vxt,
    setModelMarkers: bxt,
    getModelMarkers: Cxt,
    removeAllMarkers: yxt,
    onDidChangeMarkers: Ext,
    getModels: xxt,
    getModel: _xt,
    onDidCreateModel: Sxt,
    onWillDisposeModel: Mxt,
    onDidChangeModelLanguage: Dxt,
    createWebWorker: Lxt,
    colorizeElement: kxt,
    colorize: Nxt,
    colorizeModelLine: Txt,
    tokenize: Oxt,
    defineTheme: Rxt,
    setTheme: Vxt,
    remeasureFonts: Hxt,
    registerCommand: Bxt,
    registerLinkOpener: Pxt,
    registerEditorOpener: Fxt,
    // enums
    AccessibilitySupport: HM,
    ContentWidgetPositionPreference: jM,
    CursorChangeReason: ZM,
    DefaultEndOfLine: UM,
    EditorAutoIndentStrategy: GM,
    EditorOption: QM,
    EndOfLinePreference: KM,
    EndOfLineSequence: YM,
    MinimapPosition: aD,
    MinimapSectionHeaderStyle: lD,
    MouseTargetType: cD,
    OverlayWidgetPositionPreference: uD,
    OverviewRulerLane: fD,
    GlyphMarginLane: XM,
    RenderLineNumbersType: mD,
    RenderMinimap: AD,
    ScrollbarVisibility: vD,
    ScrollType: wD,
    TextEditorCursorBlinkingStyle: xD,
    TextEditorCursorStyle: SD,
    TrackedRangeStickiness: MD,
    WrappingIndent: DD,
    InjectedTextCursorStops: eD,
    PositionAffinity: gD,
    ShowLightbulbIconMode: yD,
    // classes
    ConfigurationChangedEvent: BMe,
    BareFontInfo: U0,
    FontInfo: zD,
    TextModelResolvedOptions: w6,
    FindMatch: z3,
    ApplyUpdateResult: RA,
    EditorZoom: bu,
    createMultiFileDiffEditor: pxt,
    // vars
    EditorType: dO,
    EditorOptions: Wf
  };
}
function Wxt(r, e) {
  if (!e || !Array.isArray(e))
    return !1;
  for (const t of e)
    if (!r(t))
      return !1;
  return !0;
}
function h5(r, e) {
  return typeof r == "boolean" ? r : e;
}
function wbe(r, e) {
  return typeof r == "string" ? r : e;
}
function jxt(r) {
  const e = {};
  for (const t of r)
    e[t] = !0;
  return e;
}
function vbe(r, e = !1) {
  e && (r = r.map(function(n) {
    return n.toLowerCase();
  }));
  const t = jxt(r);
  return e ? function(n) {
    return t[n.toLowerCase()] !== void 0 && t.hasOwnProperty(n.toLowerCase());
  } : function(n) {
    return t[n] !== void 0 && t.hasOwnProperty(n);
  };
}
function gN(r, e, t) {
  e = e.replace(/@@/g, "");
  let n = 0, i;
  do
    i = !1, e = e.replace(/@(\w+)/g, function(o, a) {
      i = !0;
      let l = "";
      if (typeof r[a] == "string")
        l = r[a];
      else if (r[a] && r[a] instanceof RegExp)
        l = r[a].source;
      else
        throw r[a] === void 0 ? Pn(r, "language definition does not contain attribute '" + a + "', used at: " + e) : Pn(r, "attribute reference '" + a + "' must be a string, used at: " + e);
      return m0(l) ? "" : "(?:" + l + ")";
    }), n++;
  while (i && n < 5);
  e = e.replace(/\x01/g, "@");
  const s = (r.ignoreCase ? "i" : "") + (r.unicode ? "u" : "");
  if (t && e.match(/\$[sS](\d\d?)/g)) {
    let a = null, l = null;
    return (c) => (l && a === c || (a = c, l = new RegExp(nmt(r, e, c), s)), l);
  }
  return new RegExp(e, s);
}
function Zxt(r, e, t, n) {
  if (n < 0)
    return r;
  if (n < e.length)
    return e[n];
  if (n >= 100) {
    n = n - 100;
    const i = t.split(".");
    if (i.unshift(t), n < i.length)
      return i[n];
  }
  return null;
}
function Uxt(r, e, t, n) {
  let i = -1, s = t, o = t.match(/^\$(([sS]?)(\d\d?)|#)(.*)$/);
  o && (o[3] && (i = parseInt(o[3]), o[2] && (i = i + 100)), s = o[4]);
  let a = "~", l = s;
  !s || s.length === 0 ? (a = "!=", l = "") : /^\w*$/.test(l) ? a = "==" : (o = s.match(/^(@|!@|~|!~|==|!=)(.*)$/), o && (a = o[1], l = o[2]));
  let c;
  if ((a === "~" || a === "!~") && /^(\w|\|)*$/.test(l)) {
    const d = vbe(l.split("|"), r.ignoreCase);
    c = function(u) {
      return a === "~" ? d(u) : !d(u);
    };
  } else if (a === "@" || a === "!@") {
    const d = r[l];
    if (!d)
      throw Pn(r, "the @ match target '" + l + "' is not defined, in rule: " + e);
    if (!Wxt(function(f) {
      return typeof f == "string";
    }, d))
      throw Pn(r, "the @ match target '" + l + "' must be an array of strings, in rule: " + e);
    const u = vbe(d, r.ignoreCase);
    c = function(f) {
      return a === "@" ? u(f) : !u(f);
    };
  } else if (a === "~" || a === "!~")
    if (l.indexOf("$") < 0) {
      const d = gN(r, "^" + l + "$", !1);
      c = function(u) {
        return a === "~" ? d.test(u) : !d.test(u);
      };
    } else
      c = function(d, u, f, p) {
        return gN(r, "^" + Eu(r, l, u, f, p) + "$", !1).test(d);
      };
  else if (l.indexOf("$") < 0) {
    const d = Sd(r, l);
    c = function(u) {
      return a === "==" ? u === d : u !== d;
    };
  } else {
    const d = Sd(r, l);
    c = function(u, f, p, g, m) {
      const A = Eu(r, d, f, p, g);
      return a === "==" ? u === A : u !== A;
    };
  }
  return i === -1 ? {
    name: t,
    value: n,
    test: function(d, u, f, p) {
      return c(d, d, u, f, p);
    }
  } : {
    name: t,
    value: n,
    test: function(d, u, f, p) {
      const g = Zxt(d, u, f, i);
      return c(g || "", d, u, f, p);
    }
  };
}
function mN(r, e, t) {
  if (t) {
    if (typeof t == "string")
      return t;
    if (t.token || t.token === "") {
      if (typeof t.token != "string")
        throw Pn(r, "a 'token' attribute must be of type string, in rule: " + e);
      {
        const n = { token: t.token };
        if (t.token.indexOf("$") >= 0 && (n.tokenSubst = !0), typeof t.bracket == "string")
          if (t.bracket === "@open")
            n.bracket = 1;
          else if (t.bracket === "@close")
            n.bracket = -1;
          else
            throw Pn(r, "a 'bracket' attribute must be either '@open' or '@close', in rule: " + e);
        if (t.next) {
          if (typeof t.next != "string")
            throw Pn(r, "the next state must be a string value in rule: " + e);
          {
            let i = t.next;
            if (!/^(@pop|@push|@popall)$/.test(i) && (i[0] === "@" && (i = i.substr(1)), i.indexOf("$") < 0 && !imt(r, Eu(r, i, "", [], ""))))
              throw Pn(r, "the next state '" + t.next + "' is not defined in rule: " + e);
            n.next = i;
          }
        }
        return typeof t.goBack == "number" && (n.goBack = t.goBack), typeof t.switchTo == "string" && (n.switchTo = t.switchTo), typeof t.log == "string" && (n.log = t.log), typeof t.nextEmbedded == "string" && (n.nextEmbedded = t.nextEmbedded, r.usesEmbedded = !0), n;
      }
    } else if (Array.isArray(t)) {
      const n = [];
      for (let i = 0, s = t.length; i < s; i++)
        n[i] = mN(r, e, t[i]);
      return { group: n };
    } else if (t.cases) {
      const n = [];
      for (const s in t.cases)
        if (t.cases.hasOwnProperty(s)) {
          const o = mN(r, e, t.cases[s]);
          s === "@default" || s === "@" || s === "" ? n.push({ test: void 0, value: o, name: s }) : s === "@eos" ? n.push({ test: function(a, l, c, d) {
            return d;
          }, value: o, name: s }) : n.push(Uxt(r, e, s, o));
        }
      const i = r.defaultToken;
      return {
        test: function(s, o, a, l) {
          for (const c of n)
            if (!c.test || c.test(s, o, a, l))
              return c.value;
          return i;
        }
      };
    } else
      throw Pn(r, "an action must be a string, an object with a 'token' or 'cases' attribute, or an array of actions; in rule: " + e);
  } else return { token: "" };
}
let qxt = class {
  constructor(e) {
    this.regex = new RegExp(""), this.action = { token: "" }, this.matchOnlyAtLineStart = !1, this.name = "", this.name = e;
  }
  setRegex(e, t) {
    let n;
    if (typeof t == "string")
      n = t;
    else if (t instanceof RegExp)
      n = t.source;
    else
      throw Pn(e, "rules must start with a match string or regular expression: " + this.name);
    this.matchOnlyAtLineStart = n.length > 0 && n[0] === "^", this.name = this.name + ": " + n, this.regex = gN(e, "^(?:" + (this.matchOnlyAtLineStart ? n.substr(1) : n) + ")", !0);
  }
  setAction(e, t) {
    this.action = mN(e, this.name, t);
  }
  resolveRegex(e) {
    return this.regex instanceof RegExp ? this.regex : this.regex(e);
  }
};
function BTe(r, e) {
  if (!e || typeof e != "object")
    throw new Error("Monarch: expecting a language definition object");
  const t = {
    languageId: r,
    includeLF: h5(e.includeLF, !1),
    noThrow: !1,
    // raise exceptions during compilation
    maxStack: 100,
    start: typeof e.start == "string" ? e.start : null,
    ignoreCase: h5(e.ignoreCase, !1),
    unicode: h5(e.unicode, !1),
    tokenPostfix: wbe(e.tokenPostfix, "." + r),
    defaultToken: wbe(e.defaultToken, "source"),
    usesEmbedded: !1,
    // becomes true if we find a nextEmbedded action
    stateNames: {},
    tokenizer: {},
    brackets: []
  }, n = e;
  n.languageId = r, n.includeLF = t.includeLF, n.ignoreCase = t.ignoreCase, n.unicode = t.unicode, n.noThrow = t.noThrow, n.usesEmbedded = t.usesEmbedded, n.stateNames = e.tokenizer, n.defaultToken = t.defaultToken;
  function i(o, a, l) {
    for (const c of l) {
      let d = c.include;
      if (d) {
        if (typeof d != "string")
          throw Pn(t, "an 'include' attribute must be a string at: " + o);
        if (d[0] === "@" && (d = d.substr(1)), !e.tokenizer[d])
          throw Pn(t, "include target '" + d + "' is not defined at: " + o);
        i(o + "." + d, a, e.tokenizer[d]);
      } else {
        const u = new qxt(o);
        if (Array.isArray(c) && c.length >= 1 && c.length <= 3)
          if (u.setRegex(n, c[0]), c.length >= 3)
            if (typeof c[1] == "string")
              u.setAction(n, { token: c[1], next: c[2] });
            else if (typeof c[1] == "object") {
              const f = c[1];
              f.next = c[2], u.setAction(n, f);
            } else
              throw Pn(t, "a next state as the last element of a rule can only be given if the action is either an object or a string, at: " + o);
          else
            u.setAction(n, c[1]);
        else {
          if (!c.regex)
            throw Pn(t, "a rule must either be an array, or an object with a 'regex' or 'include' field at: " + o);
          c.name && typeof c.name == "string" && (u.name = c.name), c.matchOnlyAtStart && (u.matchOnlyAtLineStart = h5(c.matchOnlyAtLineStart, !1)), u.setRegex(n, c.regex), u.setAction(n, c.action);
        }
        a.push(u);
      }
    }
  }
  if (!e.tokenizer || typeof e.tokenizer != "object")
    throw Pn(t, "a language definition must define the 'tokenizer' attribute as an object");
  t.tokenizer = [];
  for (const o in e.tokenizer)
    if (e.tokenizer.hasOwnProperty(o)) {
      t.start || (t.start = o);
      const a = e.tokenizer[o];
      t.tokenizer[o] = new Array(), i("tokenizer." + o, t.tokenizer[o], a);
    }
  if (t.usesEmbedded = n.usesEmbedded, e.brackets) {
    if (!Array.isArray(e.brackets))
      throw Pn(t, "the 'brackets' attribute must be defined as an array");
  } else
    e.brackets = [
      { open: "{", close: "}", token: "delimiter.curly" },
      { open: "[", close: "]", token: "delimiter.square" },
      { open: "(", close: ")", token: "delimiter.parenthesis" },
      { open: "<", close: ">", token: "delimiter.angle" }
    ];
  const s = [];
  for (const o of e.brackets) {
    let a = o;
    if (a && Array.isArray(a) && a.length === 3 && (a = { token: a[2], open: a[0], close: a[1] }), a.open === a.close)
      throw Pn(t, "open and close brackets in a 'brackets' attribute must be different: " + a.open + `
 hint: use the 'bracket' attribute if matching on equal brackets is required.`);
    if (typeof a.open == "string" && typeof a.token == "string" && typeof a.close == "string")
      s.push({
        token: a.token + t.tokenPostfix,
        open: Sd(t, a.open),
        close: Sd(t, a.close)
      });
    else
      throw Pn(t, "every element in the 'brackets' array must be a '{open,close,token}' object or array");
  }
  return t.brackets = s, t.noThrow = !0, t;
}
function Gxt(r) {
  ag.registerLanguage(r);
}
function Qxt() {
  let r = [];
  return r = r.concat(ag.getLanguages()), r;
}
function Kxt(r) {
  return Qe.get(sr).languageIdCodec.encodeLanguageId(r);
}
function Yxt(r, e) {
  return Qe.withServices(() => {
    const n = Qe.get(sr).onDidRequestRichLanguageFeatures((i) => {
      i === r && (n.dispose(), e());
    });
    return n;
  });
}
function Xxt(r, e) {
  return Qe.withServices(() => {
    const n = Qe.get(sr).onDidRequestBasicLanguageFeatures((i) => {
      i === r && (n.dispose(), e());
    });
    return n;
  });
}
function Jxt(r, e) {
  if (!Qe.get(sr).isRegisteredLanguageId(r))
    throw new Error(`Cannot set configuration for unknown language ${r}`);
  return Qe.get(xh).register(r, e, 100);
}
class $xt {
  constructor(e, t) {
    this._languageId = e, this._actual = t;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  tokenize(e, t, n) {
    if (typeof this._actual.tokenize == "function")
      return w4.adaptTokenize(this._languageId, this._actual, e, n);
    throw new Error("Not supported!");
  }
  tokenizeEncoded(e, t, n) {
    const i = this._actual.tokenizeEncoded(e, n);
    return new O7(i.tokens, i.endState);
  }
}
class w4 {
  constructor(e, t, n, i) {
    this._languageId = e, this._actual = t, this._languageService = n, this._standaloneThemeService = i;
  }
  dispose() {
  }
  getInitialState() {
    return this._actual.getInitialState();
  }
  static _toClassicTokens(e, t) {
    const n = [];
    let i = 0;
    for (let s = 0, o = e.length; s < o; s++) {
      const a = e[s];
      let l = a.startIndex;
      s === 0 ? l = 0 : l < i && (l = i), n[s] = new V3(l, a.scopes, t), i = l;
    }
    return n;
  }
  static adaptTokenize(e, t, n, i) {
    const s = t.tokenize(n, i), o = w4._toClassicTokens(s.tokens, e);
    let a;
    return s.endState.equals(i) ? a = i : a = s.endState, new TI(o, a);
  }
  tokenize(e, t, n) {
    return w4.adaptTokenize(this._languageId, this._actual, e, n);
  }
  _toBinaryTokens(e, t) {
    const n = e.encodeLanguageId(this._languageId), i = this._standaloneThemeService.getColorTheme().tokenTheme, s = [];
    let o = 0, a = 0;
    for (let c = 0, d = t.length; c < d; c++) {
      const u = t[c], f = i.match(n, u.scopes) | 1024;
      if (o > 0 && s[o - 1] === f)
        continue;
      let p = u.startIndex;
      c === 0 ? p = 0 : p < a && (p = a), s[o++] = p, s[o++] = f, a = p;
    }
    const l = new Uint32Array(o);
    for (let c = 0; c < o; c++)
      l[c] = s[c];
    return l;
  }
  tokenizeEncoded(e, t, n) {
    const i = this._actual.tokenize(e, n), s = this._toBinaryTokens(this._languageService.languageIdCodec, i.tokens);
    let o;
    return i.endState.equals(n) ? o = n : o = i.endState, new O7(s, o);
  }
}
function eSt(r) {
  return typeof r.getInitialState == "function";
}
function tSt(r) {
  return "tokenizeEncoded" in r;
}
function PTe(r) {
  return r && typeof r.then == "function";
}
function nSt(r) {
  const e = Qe.get(bl);
  if (r) {
    const t = [null];
    for (let n = 1, i = r.length; n < i; n++)
      t[n] = ge.fromHex(r[n]);
    e.setColorMapOverride(t);
  } else
    e.setColorMapOverride(null);
}
function FTe(r, e) {
  return tSt(e) ? new $xt(r, e) : new w4(r, e, Qe.get(sr), Qe.get(bl));
}
function oV(r, e) {
  const t = new m0t(async () => {
    const n = await Promise.resolve(e.create());
    return n ? eSt(n) ? FTe(r, n) : new G3(Qe.get(sr), Qe.get(bl), r, BTe(r, n), Qe.get(Ai)) : null;
  });
  return xi.registerFactory(r, t);
}
function iSt(r, e) {
  if (!Qe.get(sr).isRegisteredLanguageId(r))
    throw new Error(`Cannot set tokens provider for unknown language ${r}`);
  return PTe(e) ? oV(r, { create: () => e }) : xi.register(r, FTe(r, e));
}
function rSt(r, e) {
  const t = (n) => new G3(Qe.get(sr), Qe.get(bl), r, BTe(r, n), Qe.get(Ai));
  return PTe(e) ? oV(r, { create: () => e }) : xi.register(r, t(e));
}
function sSt(r, e) {
  return Qe.get(Vn).referenceProvider.register(r, e);
}
function oSt(r, e) {
  return Qe.get(Vn).renameProvider.register(r, e);
}
function aSt(r, e) {
  return Qe.get(Vn).newSymbolNamesProvider.register(r, e);
}
function lSt(r, e) {
  return Qe.get(Vn).signatureHelpProvider.register(r, e);
}
function cSt(r, e) {
  return Qe.get(Vn).hoverProvider.register(r, {
    provideHover: async (n, i, s, o) => {
      const a = n.getWordAtPosition(i);
      return Promise.resolve(e.provideHover(n, i, s, o)).then((l) => {
        if (l)
          return !l.range && a && (l.range = new Q(i.lineNumber, a.startColumn, i.lineNumber, a.endColumn)), l.range || (l.range = new Q(i.lineNumber, i.column, i.lineNumber, i.column)), l;
      });
    }
  });
}
function hSt(r, e) {
  return Qe.get(Vn).documentSymbolProvider.register(r, e);
}
function dSt(r, e) {
  return Qe.get(Vn).documentHighlightProvider.register(r, e);
}
function uSt(r, e) {
  return Qe.get(Vn).linkedEditingRangeProvider.register(r, e);
}
function fSt(r, e) {
  return Qe.get(Vn).definitionProvider.register(r, e);
}
function pSt(r, e) {
  return Qe.get(Vn).implementationProvider.register(r, e);
}
function gSt(r, e) {
  return Qe.get(Vn).typeDefinitionProvider.register(r, e);
}
function mSt(r, e) {
  return Qe.get(Vn).codeLensProvider.register(r, e);
}
function ASt(r, e, t) {
  return Qe.get(Vn).codeActionProvider.register(r, {
    providedCodeActionKinds: t?.providedCodeActionKinds,
    documentation: t?.documentation,
    provideCodeActions: (i, s, o, a) => {
      const c = Qe.get(r2).read({ resource: i.uri }).filter((d) => Q.areIntersectingOrTouching(d, s));
      return e.provideCodeActions(i, s, { markers: c, only: o.only, trigger: o.trigger }, a);
    },
    resolveCodeAction: e.resolveCodeAction
  });
}
function wSt(r, e) {
  return Qe.get(Vn).documentFormattingEditProvider.register(r, e);
}
function vSt(r, e) {
  return Qe.get(Vn).documentRangeFormattingEditProvider.register(r, e);
}
function bSt(r, e) {
  return Qe.get(Vn).onTypeFormattingEditProvider.register(r, e);
}
function ySt(r, e) {
  return Qe.get(Vn).linkProvider.register(r, e);
}
function CSt(r, e) {
  return Qe.get(Vn).completionProvider.register(r, e);
}
function ESt(r, e) {
  return Qe.get(Vn).colorProvider.register(r, e);
}
function _St(r, e) {
  return Qe.get(Vn).foldingRangeProvider.register(r, e);
}
function xSt(r, e) {
  return Qe.get(Vn).declarationProvider.register(r, e);
}
function SSt(r, e) {
  return Qe.get(Vn).selectionRangeProvider.register(r, e);
}
function MSt(r, e) {
  return Qe.get(Vn).documentSemanticTokensProvider.register(r, e);
}
function DSt(r, e) {
  return Qe.get(Vn).documentRangeSemanticTokensProvider.register(r, e);
}
function LSt(r, e) {
  return Qe.get(Vn).inlineCompletionsProvider.register(r, e);
}
function kSt(r, e) {
  return Qe.get(Vn).inlineEditProvider.register(r, e);
}
function NSt(r, e) {
  return Qe.get(Vn).inlayHintsProvider.register(r, e);
}
function TSt() {
  return {
    register: Gxt,
    getLanguages: Qxt,
    onLanguage: Yxt,
    onLanguageEncountered: Xxt,
    getEncodedLanguageId: Kxt,
    // provider methods
    setLanguageConfiguration: Jxt,
    setColorMap: nSt,
    registerTokensProviderFactory: oV,
    setTokensProvider: iSt,
    setMonarchTokensProvider: rSt,
    registerReferenceProvider: sSt,
    registerRenameProvider: oSt,
    registerNewSymbolNameProvider: aSt,
    registerCompletionItemProvider: CSt,
    registerSignatureHelpProvider: lSt,
    registerHoverProvider: cSt,
    registerDocumentSymbolProvider: hSt,
    registerDocumentHighlightProvider: dSt,
    registerLinkedEditingRangeProvider: uSt,
    registerDefinitionProvider: fSt,
    registerImplementationProvider: pSt,
    registerTypeDefinitionProvider: gSt,
    registerCodeLensProvider: mSt,
    registerCodeActionProvider: ASt,
    registerDocumentFormattingEditProvider: wSt,
    registerDocumentRangeFormattingEditProvider: vSt,
    registerOnTypeFormattingEditProvider: bSt,
    registerLinkProvider: ySt,
    registerColorProvider: ESt,
    registerFoldingRangeProvider: _St,
    registerDeclarationProvider: xSt,
    registerSelectionRangeProvider: SSt,
    registerDocumentSemanticTokensProvider: MSt,
    registerDocumentRangeSemanticTokensProvider: DSt,
    registerInlineCompletionsProvider: LSt,
    registerInlineEditProvider: kSt,
    registerInlayHintsProvider: NSt,
    // enums
    DocumentHighlightKind: qM,
    CompletionItemKind: FM,
    CompletionItemTag: zM,
    CompletionItemInsertTextRule: PM,
    SymbolKind: ED,
    SymbolTag: _D,
    IndentAction: $M,
    CompletionTriggerKind: WM,
    SignatureHelpTriggerKind: CD,
    InlayHintKind: tD,
    InlineCompletionTriggerKind: nD,
    InlineEditTriggerKind: iD,
    CodeActionTriggerType: BM,
    NewSymbolNameTag: hD,
    NewSymbolNameTriggerKind: dD,
    PartialAcceptTriggerKind: pD,
    HoverVerbosityAction: JM,
    // classes
    FoldingRangeKind: Gh,
    SelectedSuggestionInfo: g0t
  };
}
const zTe = Wt("IEditorCancelService"), WTe = new Ve("cancellableOperation", !1, C("cancellableOperation", "Whether the editor runs a cancellable operation, e.g. like 'Peek References'"));
en(
  zTe,
  class {
    constructor() {
      this._tokens = /* @__PURE__ */ new WeakMap();
    }
    add(r, e) {
      let t = this._tokens.get(r);
      t || (t = r.invokeWithinContext((i) => {
        const s = WTe.bindTo(i.get(sn)), o = new no();
        return { key: s, tokens: o };
      }), this._tokens.set(r, t));
      let n;
      return t.key.set(!0), n = t.tokens.push(e), () => {
        n && (n(), t.key.set(!t.tokens.isEmpty()), n = void 0);
      };
    }
    cancel(r) {
      const e = this._tokens.get(r);
      if (!e)
        return;
      const t = e.tokens.pop();
      t && (t.cancel(), e.key.set(!e.tokens.isEmpty()));
    }
  },
  1
  /* InstantiationType.Delayed */
);
Je(new class extends Fd {
  constructor() {
    super({
      id: "editor.cancelOperation",
      kbOpts: {
        weight: 100,
        primary: 9
        /* KeyCode.Escape */
      },
      precondition: WTe
    });
  }
  runEditorCommand(r, e) {
    r.get(zTe).cancel(e);
  }
}());
class bbe {
  constructor(e) {
    this.value = e, this._lower = e.toLowerCase();
  }
  /**
   * Gives the value by which to index (for equality).
   */
  static toKey(e) {
    return typeof e == "string" ? e.toLowerCase() : e._lower;
  }
}
class ISt {
  constructor(e) {
    if (this._set = /* @__PURE__ */ new Set(), e)
      for (const t of e)
        this.add(t);
  }
  add(e) {
    this._set.add(bbe.toKey(e));
  }
  has(e) {
    return this._set.has(bbe.toKey(e));
  }
}
function OSt(r, e, t) {
  const n = [], i = new ISt(), s = r.ordered(t);
  for (const a of s)
    n.push(a), a.extensionId && i.add(a.extensionId);
  const o = e.ordered(t);
  for (const a of o) {
    if (a.extensionId) {
      if (i.has(a.extensionId))
        continue;
      i.add(a.extensionId);
    }
    n.push({
      displayName: a.displayName,
      extensionId: a.extensionId,
      provideDocumentFormattingEdits(l, c, d) {
        return a.provideDocumentRangeFormattingEdits(l, l.getFullModelRange(), c, d);
      }
    });
  }
  return n;
}
class mb {
  static {
    this._selectors = new no();
  }
  static setFormatterSelector(e) {
    return { dispose: mb._selectors.unshift(e) };
  }
  static async select(e, t, n, i) {
    if (e.length === 0)
      return;
    const s = Jt.first(mb._selectors);
    if (s)
      return await s(e, t, n, i);
  }
}
async function RSt(r, e, t, n, i, s) {
  const o = e.documentRangeFormattingEditProvider.ordered(t);
  for (const a of o) {
    const l = await Promise.resolve(a.provideDocumentRangeFormattingEdits(t, n, i, s)).catch(xI);
    if (k7(l))
      return await r.computeMoreMinimalEdits(t.uri, l);
  }
}
async function VSt(r, e, t, n, i) {
  const s = OSt(e.documentFormattingEditProvider, e.documentRangeFormattingEditProvider, t);
  for (const o of s) {
    const a = await Promise.resolve(o.provideDocumentFormattingEdits(t, n, i)).catch(xI);
    if (k7(a))
      return await r.computeMoreMinimalEdits(t.uri, a);
  }
}
function HSt(r, e, t, n, i, s, o) {
  const a = e.onTypeFormattingEditProvider.ordered(t);
  return a.length === 0 || a[0].autoFormatTriggerCharacters.indexOf(i) < 0 ? Promise.resolve(void 0) : Promise.resolve(a[0].provideOnTypeFormattingEdits(t, n, i, s, o)).catch(xI).then((l) => r.computeMoreMinimalEdits(t.uri, l));
}
Zs.registerCommand("_executeFormatRangeProvider", async function(r, ...e) {
  const [t, n, i] = e;
  Qu(Pt.isUri(t)), Qu(Q.isIRange(n));
  const s = r.get(z7), o = r.get(Hw), a = r.get(Vn), l = await s.createModelReference(t);
  try {
    return RSt(o, a, l.object.textEditorModel, Q.lift(n), i, fl.None);
  } finally {
    l.dispose();
  }
});
Zs.registerCommand("_executeFormatDocumentProvider", async function(r, ...e) {
  const [t, n] = e;
  Qu(Pt.isUri(t));
  const i = r.get(z7), s = r.get(Hw), o = r.get(Vn), a = await i.createModelReference(t);
  try {
    return VSt(s, o, a.object.textEditorModel, n, fl.None);
  } finally {
    a.dispose();
  }
});
Zs.registerCommand("_executeFormatOnTypeProvider", async function(r, ...e) {
  const [t, n, i, s] = e;
  Qu(Pt.isUri(t)), Qu(le.isIPosition(n)), Qu(typeof i == "string");
  const o = r.get(z7), a = r.get(Hw), l = r.get(Vn), c = await o.createModelReference(t);
  try {
    return HSt(a, l, c.object.textEditorModel, le.lift(n), i, s, fl.None);
  } finally {
    c.dispose();
  }
});
Wf.wrappingIndent.defaultValue = 0;
Wf.glyphMargin.defaultValue = !1;
Wf.autoIndent.defaultValue = 3;
Wf.overviewRulerLanes.defaultValue = 2;
mb.setFormatterSelector((r, e, t) => Promise.resolve(r[0]));
const Ms = eDe();
Ms.editor = zxt();
Ms.languages = TSt();
const BSt = Ms.CancellationTokenSource, PSt = Ms.Emitter, FSt = Ms.KeyCode, zSt = Ms.KeyMod, WSt = Ms.Position, jSt = Ms.Range, ZSt = Ms.Selection, USt = Ms.SelectionDirection, qSt = Ms.MarkerSeverity, GSt = Ms.MarkerTag, QSt = Ms.Uri, KSt = Ms.Token, YSt = Ms.editor, XSt = Ms.languages, JSt = globalThis.MonacoEnvironment;
(JSt?.globalAPI || typeof define == "function" && define.amd) && (globalThis.monaco = Ms);
typeof globalThis.require < "u" && typeof globalThis.require.config == "function" && globalThis.require.config({
  ignoreDuplicateModules: [
    "vscode-languageserver-types",
    "vscode-languageserver-types/main",
    "vscode-languageserver-textdocument",
    "vscode-languageserver-textdocument/main",
    "vscode-nls",
    "vscode-nls/vscode-nls",
    "jsonc-parser",
    "jsonc-parser/main",
    "vscode-uri",
    "vscode-uri/index",
    "vs/basic-languages/typescript/typescript"
  ]
});
const $St = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CancellationTokenSource: BSt,
  Emitter: PSt,
  KeyCode: FSt,
  KeyMod: zSt,
  MarkerSeverity: qSt,
  MarkerTag: GSt,
  Position: WSt,
  Range: jSt,
  Selection: ZSt,
  SelectionDirection: USt,
  Token: KSt,
  Uri: QSt,
  editor: YSt,
  languages: XSt
}, Symbol.toStringTag, { value: "Module" }));
/*!-----------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.51.0(67d664a32968e19e2eb08b696a92463804182ae4)
 * Released under the MIT license
 * https://github.com/microsoft/monaco-editor/blob/main/LICENSE.txt
 *-----------------------------------------------------------------------------*/
var eMt = Object.defineProperty, tMt = Object.getOwnPropertyDescriptor, nMt = Object.getOwnPropertyNames, iMt = Object.prototype.hasOwnProperty, rMt = (r, e, t, n) => {
  if (e && typeof e == "object" || typeof e == "function")
    for (let i of nMt(e))
      !iMt.call(r, i) && i !== t && eMt(r, i, { get: () => e[i], enumerable: !(n = tMt(e, i)) || n.enumerable });
  return r;
}, sMt = (r, e, t) => (rMt(r, e, "default"), t), zw = {};
sMt(zw, $St);
var oMt = class {
  constructor(r, e, t) {
    this._onDidChange = new zw.Emitter(), this._languageId = r, this.setDiagnosticsOptions(e), this.setModeConfiguration(t);
  }
  get onDidChange() {
    return this._onDidChange.event;
  }
  get languageId() {
    return this._languageId;
  }
  get modeConfiguration() {
    return this._modeConfiguration;
  }
  get diagnosticsOptions() {
    return this._diagnosticsOptions;
  }
  setDiagnosticsOptions(r) {
    this._diagnosticsOptions = r || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
  setModeConfiguration(r) {
    this._modeConfiguration = r || /* @__PURE__ */ Object.create(null), this._onDidChange.fire(this);
  }
}, aMt = {
  validate: !0,
  allowComments: !0,
  schemas: [],
  enableSchemaRequest: !1,
  schemaRequest: "warning",
  schemaValidation: "warning",
  comments: "error",
  trailingCommas: "error"
}, lMt = {
  documentFormattingEdits: !0,
  documentRangeFormattingEdits: !0,
  completionItems: !0,
  hovers: !0,
  documentSymbols: !0,
  tokens: !0,
  colors: !0,
  foldingRanges: !0,
  diagnostics: !0,
  selectionRanges: !0
}, jTe = new oMt(
  "json",
  aMt,
  lMt
), cMt = () => ZTe().then((r) => r.getWorker());
zw.languages.json = { jsonDefaults: jTe, getWorker: cMt };
function ZTe() {
  return import("./jsonMode.js");
}
zw.languages.register({
  id: "json",
  extensions: [".json", ".bowerrc", ".jshintrc", ".jscsrc", ".eslintrc", ".babelrc", ".har"],
  aliases: ["JSON", "json"],
  mimetypes: ["application/json"]
});
zw.languages.onLanguage("json", () => {
  ZTe().then((r) => r.setupMode(jTe));
});
class Pa {
  constructor(e) {
    this._editor = e, this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null, this._startPosition = this._editor.getPosition();
  }
  dispose() {
    this._editor.removeDecorations(this._allDecorations()), this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  reset() {
    this._decorations = [], this._overviewRulerApproximateDecorations = [], this._findScopeDecorationIds = [], this._rangeHighlightDecorationId = null, this._highlightedDecorationId = null;
  }
  getCount() {
    return this._decorations.length;
  }
  /** @deprecated use getFindScopes to support multiple selections */
  getFindScope() {
    return this._findScopeDecorationIds[0] ? this._editor.getModel().getDecorationRange(this._findScopeDecorationIds[0]) : null;
  }
  getFindScopes() {
    if (this._findScopeDecorationIds.length) {
      const e = this._findScopeDecorationIds.map((t) => this._editor.getModel().getDecorationRange(t)).filter((t) => !!t);
      if (e.length)
        return e;
    }
    return null;
  }
  getStartPosition() {
    return this._startPosition;
  }
  setStartPosition(e) {
    this._startPosition = e, this.setCurrentFindMatch(null);
  }
  _getDecorationIndex(e) {
    const t = this._decorations.indexOf(e);
    return t >= 0 ? t + 1 : 1;
  }
  getDecorationRangeAt(e) {
    const t = e < this._decorations.length ? this._decorations[e] : null;
    return t ? this._editor.getModel().getDecorationRange(t) : null;
  }
  getCurrentMatchesPosition(e) {
    const t = this._editor.getModel().getDecorationsInRange(e);
    for (const n of t) {
      const i = n.options;
      if (i === Pa._FIND_MATCH_DECORATION || i === Pa._CURRENT_FIND_MATCH_DECORATION)
        return this._getDecorationIndex(n.id);
    }
    return 0;
  }
  setCurrentFindMatch(e) {
    let t = null, n = 0;
    if (e)
      for (let i = 0, s = this._decorations.length; i < s; i++) {
        const o = this._editor.getModel().getDecorationRange(this._decorations[i]);
        if (e.equalsRange(o)) {
          t = this._decorations[i], n = i + 1;
          break;
        }
      }
    return (this._highlightedDecorationId !== null || t !== null) && this._editor.changeDecorations((i) => {
      if (this._highlightedDecorationId !== null && (i.changeDecorationOptions(this._highlightedDecorationId, Pa._FIND_MATCH_DECORATION), this._highlightedDecorationId = null), t !== null && (this._highlightedDecorationId = t, i.changeDecorationOptions(this._highlightedDecorationId, Pa._CURRENT_FIND_MATCH_DECORATION)), this._rangeHighlightDecorationId !== null && (i.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), t !== null) {
        let s = this._editor.getModel().getDecorationRange(t);
        if (s.startLineNumber !== s.endLineNumber && s.endColumn === 1) {
          const o = s.endLineNumber - 1, a = this._editor.getModel().getLineMaxColumn(o);
          s = new Q(s.startLineNumber, s.startColumn, o, a);
        }
        this._rangeHighlightDecorationId = i.addDecoration(s, Pa._RANGE_HIGHLIGHT_DECORATION);
      }
    }), n;
  }
  set(e, t) {
    this._editor.changeDecorations((n) => {
      let i = Pa._FIND_MATCH_DECORATION;
      const s = [];
      if (e.length > 1e3) {
        i = Pa._FIND_MATCH_NO_OVERVIEW_DECORATION;
        const a = this._editor.getModel().getLineCount(), c = this._editor.getLayoutInfo().height / a, d = Math.max(2, Math.ceil(3 / c));
        let u = e[0].range.startLineNumber, f = e[0].range.endLineNumber;
        for (let p = 1, g = e.length; p < g; p++) {
          const m = e[p].range;
          f + d >= m.startLineNumber ? m.endLineNumber > f && (f = m.endLineNumber) : (s.push({
            range: new Q(u, 1, f, 1),
            options: Pa._FIND_MATCH_ONLY_OVERVIEW_DECORATION
          }), u = m.startLineNumber, f = m.endLineNumber);
        }
        s.push({
          range: new Q(u, 1, f, 1),
          options: Pa._FIND_MATCH_ONLY_OVERVIEW_DECORATION
        });
      }
      const o = new Array(e.length);
      for (let a = 0, l = e.length; a < l; a++)
        o[a] = {
          range: e[a].range,
          options: i
        };
      this._decorations = n.deltaDecorations(this._decorations, o), this._overviewRulerApproximateDecorations = n.deltaDecorations(this._overviewRulerApproximateDecorations, s), this._rangeHighlightDecorationId && (n.removeDecoration(this._rangeHighlightDecorationId), this._rangeHighlightDecorationId = null), this._findScopeDecorationIds.length && (this._findScopeDecorationIds.forEach((a) => n.removeDecoration(a)), this._findScopeDecorationIds = []), t?.length && (this._findScopeDecorationIds = t.map((a) => n.addDecoration(a, Pa._FIND_SCOPE_DECORATION)));
    });
  }
  matchBeforePosition(e) {
    if (this._decorations.length === 0)
      return null;
    for (let t = this._decorations.length - 1; t >= 0; t--) {
      const n = this._decorations[t], i = this._editor.getModel().getDecorationRange(n);
      if (!(!i || i.endLineNumber > e.lineNumber)) {
        if (i.endLineNumber < e.lineNumber)
          return i;
        if (!(i.endColumn > e.column))
          return i;
      }
    }
    return this._editor.getModel().getDecorationRange(this._decorations[this._decorations.length - 1]);
  }
  matchAfterPosition(e) {
    if (this._decorations.length === 0)
      return null;
    for (let t = 0, n = this._decorations.length; t < n; t++) {
      const i = this._decorations[t], s = this._editor.getModel().getDecorationRange(i);
      if (!(!s || s.startLineNumber < e.lineNumber)) {
        if (s.startLineNumber > e.lineNumber)
          return s;
        if (!(s.startColumn < e.column))
          return s;
      }
    }
    return this._editor.getModel().getDecorationRange(this._decorations[0]);
  }
  _allDecorations() {
    let e = [];
    return e = e.concat(this._decorations), e = e.concat(this._overviewRulerApproximateDecorations), this._findScopeDecorationIds.length && e.push(...this._findScopeDecorationIds), this._rangeHighlightDecorationId && e.push(this._rangeHighlightDecorationId), e;
  }
  static {
    this._CURRENT_FIND_MATCH_DECORATION = fi.register({
      description: "current-find-match",
      stickiness: 1,
      zIndex: 13,
      className: "currentFindMatch",
      inlineClassName: "currentFindMatchInline",
      showIfCollapsed: !0,
      overviewRuler: {
        color: Ua(jE),
        position: Xu.Center
      },
      minimap: {
        color: Ua(uL),
        position: 1
        /* MinimapPosition.Inline */
      }
    });
  }
  static {
    this._FIND_MATCH_DECORATION = fi.register({
      description: "find-match",
      stickiness: 1,
      zIndex: 10,
      className: "findMatch",
      inlineClassName: "findMatchInline",
      showIfCollapsed: !0,
      overviewRuler: {
        color: Ua(jE),
        position: Xu.Center
      },
      minimap: {
        color: Ua(uL),
        position: 1
        /* MinimapPosition.Inline */
      }
    });
  }
  static {
    this._FIND_MATCH_NO_OVERVIEW_DECORATION = fi.register({
      description: "find-match-no-overview",
      stickiness: 1,
      className: "findMatch",
      showIfCollapsed: !0
    });
  }
  static {
    this._FIND_MATCH_ONLY_OVERVIEW_DECORATION = fi.register({
      description: "find-match-only-overview",
      stickiness: 1,
      overviewRuler: {
        color: Ua(jE),
        position: Xu.Center
      }
    });
  }
  static {
    this._RANGE_HIGHLIGHT_DECORATION = fi.register({
      description: "find-range-highlight",
      stickiness: 1,
      className: "rangeHighlight",
      isWholeLine: !0
    });
  }
  static {
    this._FIND_SCOPE_DECORATION = fi.register({
      description: "find-scope",
      className: "findScope",
      isWholeLine: !0
    });
  }
}
class hMt {
  constructor(e, t, n) {
    this._editorSelection = e, this._ranges = t, this._replaceStrings = n, this._trackedEditorSelectionId = null;
  }
  getEditOperations(e, t) {
    if (this._ranges.length > 0) {
      const n = [];
      for (let o = 0; o < this._ranges.length; o++)
        n.push({
          range: this._ranges[o],
          text: this._replaceStrings[o]
        });
      n.sort((o, a) => Q.compareRangesUsingStarts(o.range, a.range));
      const i = [];
      let s = n[0];
      for (let o = 1; o < n.length; o++)
        s.range.endLineNumber === n[o].range.startLineNumber && s.range.endColumn === n[o].range.startColumn ? (s.range = s.range.plusRange(n[o].range), s.text = s.text + n[o].text) : (i.push(s), s = n[o]);
      i.push(s);
      for (const o of i)
        t.addEditOperation(o.range, o.text);
    }
    this._trackedEditorSelectionId = t.trackSelection(this._editorSelection);
  }
  computeCursorState(e, t) {
    return t.getTrackedSelection(this._trackedEditorSelectionId);
  }
}
function UTe(r, e) {
  if (r && r[0] !== "") {
    const t = ybe(r, e, "-"), n = ybe(r, e, "_");
    return t && !n ? Cbe(r, e, "-") : !t && n ? Cbe(r, e, "_") : r[0].toUpperCase() === r[0] ? e.toUpperCase() : r[0].toLowerCase() === r[0] ? e.toLowerCase() : N0t(r[0][0]) && e.length > 0 ? e[0].toUpperCase() + e.substr(1) : r[0][0].toUpperCase() !== r[0][0] && e.length > 0 ? e[0].toLowerCase() + e.substr(1) : e;
  } else
    return e;
}
function ybe(r, e, t) {
  return r[0].indexOf(t) !== -1 && e.indexOf(t) !== -1 && r[0].split(t).length === e.split(t).length;
}
function Cbe(r, e, t) {
  const n = e.split(t), i = r[0].split(t);
  let s = "";
  return n.forEach((o, a) => {
    s += UTe([i[a]], o) + t;
  }), s.slice(0, -1);
}
class Ebe {
  constructor(e) {
    this.staticValue = e, this.kind = 0;
  }
}
class dMt {
  constructor(e) {
    this.pieces = e, this.kind = 1;
  }
}
class _g {
  static fromStaticValue(e) {
    return new _g([tf.staticValue(e)]);
  }
  get hasReplacementPatterns() {
    return this._state.kind === 1;
  }
  constructor(e) {
    !e || e.length === 0 ? this._state = new Ebe("") : e.length === 1 && e[0].staticValue !== null ? this._state = new Ebe(e[0].staticValue) : this._state = new dMt(e);
  }
  buildReplaceString(e, t) {
    if (this._state.kind === 0)
      return t ? UTe(e, this._state.staticValue) : this._state.staticValue;
    let n = "";
    for (let i = 0, s = this._state.pieces.length; i < s; i++) {
      const o = this._state.pieces[i];
      if (o.staticValue !== null) {
        n += o.staticValue;
        continue;
      }
      let a = _g._substitute(o.matchIndex, e);
      if (o.caseOps !== null && o.caseOps.length > 0) {
        const l = [], c = o.caseOps.length;
        let d = 0;
        for (let u = 0, f = a.length; u < f; u++) {
          if (d >= c) {
            l.push(a.slice(u));
            break;
          }
          switch (o.caseOps[d]) {
            case "U":
              l.push(a[u].toUpperCase());
              break;
            case "u":
              l.push(a[u].toUpperCase()), d++;
              break;
            case "L":
              l.push(a[u].toLowerCase());
              break;
            case "l":
              l.push(a[u].toLowerCase()), d++;
              break;
            default:
              l.push(a[u]);
          }
        }
        a = l.join("");
      }
      n += a;
    }
    return n;
  }
  static _substitute(e, t) {
    if (t === null)
      return "";
    if (e === 0)
      return t[0];
    let n = "";
    for (; e > 0; ) {
      if (e < t.length)
        return (t[e] || "") + n;
      n = String(e % 10) + n, e = Math.floor(e / 10);
    }
    return "$" + n;
  }
}
class tf {
  static staticValue(e) {
    return new tf(e, -1, null);
  }
  static caseOps(e, t) {
    return new tf(null, e, t);
  }
  constructor(e, t, n) {
    this.staticValue = e, this.matchIndex = t, !n || n.length === 0 ? this.caseOps = null : this.caseOps = n.slice(0);
  }
}
class uMt {
  constructor(e) {
    this._source = e, this._lastCharIndex = 0, this._result = [], this._resultLen = 0, this._currentStaticPiece = "";
  }
  emitUnchanged(e) {
    this._emitStatic(this._source.substring(this._lastCharIndex, e)), this._lastCharIndex = e;
  }
  emitStatic(e, t) {
    this._emitStatic(e), this._lastCharIndex = t;
  }
  _emitStatic(e) {
    e.length !== 0 && (this._currentStaticPiece += e);
  }
  emitMatchIndex(e, t, n) {
    this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = tf.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), this._result[this._resultLen++] = tf.caseOps(e, n), this._lastCharIndex = t;
  }
  finalize() {
    return this.emitUnchanged(this._source.length), this._currentStaticPiece.length !== 0 && (this._result[this._resultLen++] = tf.staticValue(this._currentStaticPiece), this._currentStaticPiece = ""), new _g(this._result);
  }
}
function fMt(r) {
  if (!r || r.length === 0)
    return new _g(null);
  const e = [], t = new uMt(r);
  for (let n = 0, i = r.length; n < i; n++) {
    const s = r.charCodeAt(n);
    if (s === 92) {
      if (n++, n >= i)
        break;
      const o = r.charCodeAt(n);
      switch (o) {
        case 92:
          t.emitUnchanged(n - 1), t.emitStatic("\\", n + 1);
          break;
        case 110:
          t.emitUnchanged(n - 1), t.emitStatic(`
`, n + 1);
          break;
        case 116:
          t.emitUnchanged(n - 1), t.emitStatic("	", n + 1);
          break;
        // Case modification of string replacements, patterned after Boost, but only applied
        // to the replacement text, not subsequent content.
        case 117:
        // \u => upper-cases one character.
        case 85:
        // \U => upper-cases ALL following characters.
        case 108:
        // \l => lower-cases one character.
        case 76:
          t.emitUnchanged(n - 1), t.emitStatic("", n + 1), e.push(String.fromCharCode(o));
          break;
      }
      continue;
    }
    if (s === 36) {
      if (n++, n >= i)
        break;
      const o = r.charCodeAt(n);
      if (o === 36) {
        t.emitUnchanged(n - 1), t.emitStatic("$", n + 1);
        continue;
      }
      if (o === 48 || o === 38) {
        t.emitUnchanged(n - 1), t.emitMatchIndex(0, n + 1, e), e.length = 0;
        continue;
      }
      if (49 <= o && o <= 57) {
        let a = o - 48;
        if (n + 1 < i) {
          const l = r.charCodeAt(n + 1);
          if (48 <= l && l <= 57) {
            n++, a = a * 10 + (l - 48), t.emitUnchanged(n - 2), t.emitMatchIndex(a, n + 1, e), e.length = 0;
            continue;
          }
        }
        t.emitUnchanged(n - 1), t.emitMatchIndex(a, n + 1, e), e.length = 0;
        continue;
      }
    }
  }
  return t.finalize();
}
const Jd = new Ve("findWidgetVisible", !1);
Jd.toNegated();
const Wy = new Ve("findInputFocussed", !1), aV = new Ve("replaceInputFocussed", !1), d5 = {
  primary: 545,
  mac: {
    primary: 2593
    /* KeyCode.KeyC */
  }
}, u5 = {
  primary: 565,
  mac: {
    primary: 2613
    /* KeyCode.KeyW */
  }
}, f5 = {
  primary: 560,
  mac: {
    primary: 2608
    /* KeyCode.KeyR */
  }
}, p5 = {
  primary: 554,
  mac: {
    primary: 2602
    /* KeyCode.KeyL */
  }
}, g5 = {
  primary: 558,
  mac: {
    primary: 2606
    /* KeyCode.KeyP */
  }
}, kn = {
  StartFindAction: "actions.find",
  StartFindWithSelection: "actions.findWithSelection",
  StartFindWithArgs: "editor.actions.findWithArgs",
  NextMatchFindAction: "editor.action.nextMatchFindAction",
  PreviousMatchFindAction: "editor.action.previousMatchFindAction",
  GoToMatchFindAction: "editor.action.goToMatchFindAction",
  NextSelectionMatchFindAction: "editor.action.nextSelectionMatchFindAction",
  PreviousSelectionMatchFindAction: "editor.action.previousSelectionMatchFindAction",
  StartFindReplaceAction: "editor.action.startFindReplaceAction",
  CloseFindWidgetCommand: "closeFindWidget",
  ToggleCaseSensitiveCommand: "toggleFindCaseSensitive",
  ToggleWholeWordCommand: "toggleFindWholeWord",
  ToggleRegexCommand: "toggleFindRegex",
  ToggleSearchScopeCommand: "toggleFindInSelection",
  TogglePreserveCaseCommand: "togglePreserveCase",
  ReplaceOneAction: "editor.action.replaceOne",
  ReplaceAllAction: "editor.action.replaceAll",
  SelectAllMatchesAction: "editor.action.selectAllMatches"
}, zu = 19999, pMt = 240;
class d3 {
  constructor(e, t) {
    this._toDispose = new ze(), this._editor = e, this._state = t, this._isDisposed = !1, this._startSearchingTimer = new T1(), this._decorations = new Pa(e), this._toDispose.add(this._decorations), this._updateDecorationsScheduler = new Nr(() => {
      if (this._editor.hasModel())
        return this.research(!1);
    }, 100), this._toDispose.add(this._updateDecorationsScheduler), this._toDispose.add(this._editor.onDidChangeCursorPosition((n) => {
      (n.reason === 3 || n.reason === 5 || n.reason === 6) && this._decorations.setStartPosition(this._editor.getPosition());
    })), this._ignoreModelContentChanged = !1, this._toDispose.add(this._editor.onDidChangeModelContent((n) => {
      this._ignoreModelContentChanged || (n.isFlush && this._decorations.reset(), this._decorations.setStartPosition(this._editor.getPosition()), this._updateDecorationsScheduler.schedule());
    })), this._toDispose.add(this._state.onFindReplaceStateChange((n) => this._onStateChanged(n))), this.research(!1, this._state.searchScope);
  }
  dispose() {
    this._isDisposed = !0, br(this._startSearchingTimer), this._toDispose.dispose();
  }
  _onStateChanged(e) {
    this._isDisposed || this._editor.hasModel() && (e.searchString || e.isReplaceRevealed || e.isRegex || e.wholeWord || e.matchCase || e.searchScope) && (this._editor.getModel().isTooLargeForSyncing() ? (this._startSearchingTimer.cancel(), this._startSearchingTimer.setIfNotSet(() => {
      e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor);
    }, pMt)) : e.searchScope ? this.research(e.moveCursor, this._state.searchScope) : this.research(e.moveCursor));
  }
  static _getSearchRange(e, t) {
    return t || e.getFullModelRange();
  }
  research(e, t) {
    let n = null;
    typeof t < "u" ? t !== null && (Array.isArray(t) ? n = t : n = [t]) : n = this._decorations.getFindScopes(), n !== null && (n = n.map((a) => {
      if (a.startLineNumber !== a.endLineNumber) {
        let l = a.endLineNumber;
        return a.endColumn === 1 && (l = l - 1), new Q(a.startLineNumber, 1, l, this._editor.getModel().getLineMaxColumn(l));
      }
      return a;
    }));
    const i = this._findMatches(n, !1, zu);
    this._decorations.set(i, n);
    const s = this._editor.getSelection();
    let o = this._decorations.getCurrentMatchesPosition(s);
    if (o === 0 && i.length > 0) {
      const a = Q8(i.map((l) => l.range), (l) => Q.compareRangesUsingStarts(l, s) >= 0);
      o = a > 0 ? a - 1 + 1 : o;
    }
    this._state.changeMatchInfo(o, this._decorations.getCount(), void 0), e && this._editor.getOption(
      41
      /* EditorOption.find */
    ).cursorMoveOnType && this._moveToNextMatch(this._decorations.getStartPosition());
  }
  _hasMatches() {
    return this._state.matchesCount > 0;
  }
  _cannotFind() {
    if (!this._hasMatches()) {
      const e = this._decorations.getFindScope();
      return e && this._editor.revealRangeInCenterIfOutsideViewport(
        e,
        0
        /* ScrollType.Smooth */
      ), !0;
    }
    return !1;
  }
  _setCurrentFindMatch(e) {
    const t = this._decorations.setCurrentFindMatch(e);
    this._state.changeMatchInfo(t, this._decorations.getCount(), e), this._editor.setSelection(e), this._editor.revealRangeInCenterIfOutsideViewport(
      e,
      0
      /* ScrollType.Smooth */
    );
  }
  _prevSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: i } = e;
    const s = this._editor.getModel();
    return t || i === 1 ? (n === 1 ? n = s.getLineCount() : n--, i = s.getLineMaxColumn(n)) : i--, new le(n, i);
  }
  _moveToPrevMatch(e, t = !1) {
    if (!this._state.canNavigateBack()) {
      const d = this._decorations.matchAfterPosition(e);
      d && this._setCurrentFindMatch(d);
      return;
    }
    if (this._decorations.getCount() < zu) {
      let d = this._decorations.matchBeforePosition(e);
      d && d.isEmpty() && d.getStartPosition().equals(e) && (e = this._prevSearchPosition(e), d = this._decorations.matchBeforePosition(e)), d && this._setCurrentFindMatch(d);
      return;
    }
    if (this._cannotFind())
      return;
    const n = this._decorations.getFindScope(), i = d3._getSearchRange(this._editor.getModel(), n);
    i.getEndPosition().isBefore(e) && (e = i.getEndPosition()), e.isBefore(i.getStartPosition()) && (e = i.getEndPosition());
    const { lineNumber: s, column: o } = e, a = this._editor.getModel();
    let l = new le(s, o), c = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null, !1);
    if (c && c.range.isEmpty() && c.range.getStartPosition().equals(l) && (l = this._prevSearchPosition(l), c = a.findPreviousMatch(this._state.searchString, l, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null, !1)), !!c) {
      if (!t && !i.containsRange(c.range))
        return this._moveToPrevMatch(c.range.getStartPosition(), !0);
      this._setCurrentFindMatch(c.range);
    }
  }
  moveToPrevMatch() {
    this._moveToPrevMatch(this._editor.getSelection().getStartPosition());
  }
  _nextSearchPosition(e) {
    const t = this._state.isRegex && (this._state.searchString.indexOf("^") >= 0 || this._state.searchString.indexOf("$") >= 0);
    let { lineNumber: n, column: i } = e;
    const s = this._editor.getModel();
    return t || i === s.getLineMaxColumn(n) ? (n === s.getLineCount() ? n = 1 : n++, i = 1) : i++, new le(n, i);
  }
  _moveToNextMatch(e) {
    if (!this._state.canNavigateForward()) {
      const n = this._decorations.matchBeforePosition(e);
      n && this._setCurrentFindMatch(n);
      return;
    }
    if (this._decorations.getCount() < zu) {
      let n = this._decorations.matchAfterPosition(e);
      n && n.isEmpty() && n.getStartPosition().equals(e) && (e = this._nextSearchPosition(e), n = this._decorations.matchAfterPosition(e)), n && this._setCurrentFindMatch(n);
      return;
    }
    const t = this._getNextMatch(e, !1, !0);
    t && this._setCurrentFindMatch(t.range);
  }
  _getNextMatch(e, t, n, i = !1) {
    if (this._cannotFind())
      return null;
    const s = this._decorations.getFindScope(), o = d3._getSearchRange(this._editor.getModel(), s);
    o.getEndPosition().isBefore(e) && (e = o.getStartPosition()), e.isBefore(o.getStartPosition()) && (e = o.getStartPosition());
    const { lineNumber: a, column: l } = e, c = this._editor.getModel();
    let d = new le(a, l), u = c.findNextMatch(this._state.searchString, d, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null, t);
    return n && u && u.range.isEmpty() && u.range.getStartPosition().equals(d) && (d = this._nextSearchPosition(d), u = c.findNextMatch(this._state.searchString, d, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null, t)), u ? !i && !o.containsRange(u.range) ? this._getNextMatch(u.range.getEndPosition(), t, n, !0) : u : null;
  }
  moveToNextMatch() {
    this._moveToNextMatch(this._editor.getSelection().getEndPosition());
  }
  _moveToMatch(e) {
    const t = this._decorations.getDecorationRangeAt(e);
    t && this._setCurrentFindMatch(t);
  }
  moveToMatch(e) {
    this._moveToMatch(e);
  }
  _getReplacePattern() {
    return this._state.isRegex ? fMt(this._state.replaceString) : _g.fromStaticValue(this._state.replaceString);
  }
  replace() {
    if (!this._hasMatches())
      return;
    const e = this._getReplacePattern(), t = this._editor.getSelection(), n = this._getNextMatch(t.getStartPosition(), !0, !1);
    if (n)
      if (t.equalsRange(n.range)) {
        const i = e.buildReplaceString(n.matches, this._state.preserveCase), s = new Vs(t, i);
        this._executeEditorCommand("replace", s), this._decorations.setStartPosition(new le(t.startLineNumber, t.startColumn + i.length)), this.research(!0);
      } else
        this._decorations.setStartPosition(this._editor.getPosition()), this._setCurrentFindMatch(n.range);
  }
  _findMatches(e, t, n) {
    const i = (e || [null]).map((s) => d3._getSearchRange(this._editor.getModel(), s));
    return this._editor.getModel().findMatches(this._state.searchString, i, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null, t, n);
  }
  replaceAll() {
    if (!this._hasMatches())
      return;
    const e = this._decorations.getFindScopes();
    e === null && this._state.matchesCount >= zu ? this._largeReplaceAll() : this._regularReplaceAll(e), this.research(!1);
  }
  _largeReplaceAll() {
    const t = new r0(this._state.searchString, this._state.isRegex, this._state.matchCase, this._state.wholeWord ? this._editor.getOption(
      132
      /* EditorOption.wordSeparators */
    ) : null).parseSearchRequest();
    if (!t)
      return;
    let n = t.regex;
    if (!n.multiline) {
      let u = "mu";
      n.ignoreCase && (u += "i"), n.global && (u += "g"), n = new RegExp(n.source, u);
    }
    const i = this._editor.getModel(), s = i.getValue(
      1
      /* EndOfLinePreference.LF */
    ), o = i.getFullModelRange(), a = this._getReplacePattern();
    let l;
    const c = this._state.preserveCase;
    a.hasReplacementPatterns || c ? l = s.replace(n, function() {
      return a.buildReplaceString(arguments, c);
    }) : l = s.replace(n, a.buildReplaceString(null, c));
    const d = new hke(o, l, this._editor.getSelection());
    this._executeEditorCommand("replaceAll", d);
  }
  _regularReplaceAll(e) {
    const t = this._getReplacePattern(), n = this._findMatches(
      e,
      t.hasReplacementPatterns || this._state.preserveCase,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ), i = [];
    for (let o = 0, a = n.length; o < a; o++)
      i[o] = t.buildReplaceString(n[o].matches, this._state.preserveCase);
    const s = new hMt(this._editor.getSelection(), n.map((o) => o.range), i);
    this._executeEditorCommand("replaceAll", s);
  }
  selectAllMatches() {
    if (!this._hasMatches())
      return;
    const e = this._decorations.getFindScopes();
    let n = this._findMatches(
      e,
      !1,
      1073741824
      /* Constants.MAX_SAFE_SMALL_INTEGER */
    ).map((s) => new _n(s.range.startLineNumber, s.range.startColumn, s.range.endLineNumber, s.range.endColumn));
    const i = this._editor.getSelection();
    for (let s = 0, o = n.length; s < o; s++)
      if (n[s].equalsRange(i)) {
        n = [i].concat(n.slice(0, s)).concat(n.slice(s + 1));
        break;
      }
    this._editor.setSelections(n);
  }
  _executeEditorCommand(e, t) {
    try {
      this._ignoreModelContentChanged = !0, this._editor.pushUndoStop(), this._editor.executeCommand(e, t), this._editor.pushUndoStop();
    } finally {
      this._ignoreModelContentChanged = !1;
    }
  }
}
class lV extends xa {
  static {
    this.ID = "editor.contrib.findOptionsWidget";
  }
  constructor(e, t, n) {
    super(), this._hideSoon = this._register(new Nr(() => this._hide(), 2e3)), this._isVisible = !1, this._editor = e, this._state = t, this._keybindingService = n, this._domNode = document.createElement("div"), this._domNode.className = "findOptionsWidget", this._domNode.style.display = "none", this._domNode.style.top = "10px", this._domNode.style.zIndex = "12", this._domNode.setAttribute("role", "presentation"), this._domNode.setAttribute("aria-hidden", "true");
    const i = {
      inputActiveOptionBorder: _e(sy),
      inputActiveOptionForeground: _e(ay),
      inputActiveOptionBackground: _e(oy)
    }, s = this._register(wg());
    this.caseSensitive = this._register(new UNe({
      appendTitle: this._keybindingLabelFor(kn.ToggleCaseSensitiveCommand),
      isChecked: this._state.matchCase,
      hoverDelegate: s,
      ...i
    })), this._domNode.appendChild(this.caseSensitive.domNode), this._register(this.caseSensitive.onChange(() => {
      this._state.change({
        matchCase: this.caseSensitive.checked
      }, !1);
    })), this.wholeWords = this._register(new qNe({
      appendTitle: this._keybindingLabelFor(kn.ToggleWholeWordCommand),
      isChecked: this._state.wholeWord,
      hoverDelegate: s,
      ...i
    })), this._domNode.appendChild(this.wholeWords.domNode), this._register(this.wholeWords.onChange(() => {
      this._state.change({
        wholeWord: this.wholeWords.checked
      }, !1);
    })), this.regex = this._register(new GNe({
      appendTitle: this._keybindingLabelFor(kn.ToggleRegexCommand),
      isChecked: this._state.isRegex,
      hoverDelegate: s,
      ...i
    })), this._domNode.appendChild(this.regex.domNode), this._register(this.regex.onChange(() => {
      this._state.change({
        isRegex: this.regex.checked
      }, !1);
    })), this._editor.addOverlayWidget(this), this._register(this._state.onFindReplaceStateChange((o) => {
      let a = !1;
      o.isRegex && (this.regex.checked = this._state.isRegex, a = !0), o.wholeWord && (this.wholeWords.checked = this._state.wholeWord, a = !0), o.matchCase && (this.caseSensitive.checked = this._state.matchCase, a = !0), !this._state.isRevealed && a && this._revealTemporarily();
    })), this._register(fe(this._domNode, Se.MOUSE_LEAVE, (o) => this._onMouseLeave())), this._register(fe(this._domNode, "mouseover", (o) => this._onMouseOver()));
  }
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  dispose() {
    this._editor.removeOverlayWidget(this), super.dispose();
  }
  // ----- IOverlayWidget API
  getId() {
    return lV.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return {
      preference: 0
      /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */
    };
  }
  highlightFindOptions() {
    this._revealTemporarily();
  }
  _revealTemporarily() {
    this._show(), this._hideSoon.schedule();
  }
  _onMouseLeave() {
    this._hideSoon.schedule();
  }
  _onMouseOver() {
    this._hideSoon.cancel();
  }
  _show() {
    this._isVisible || (this._isVisible = !0, this._domNode.style.display = "block");
  }
  _hide() {
    this._isVisible && (this._isVisible = !1, this._domNode.style.display = "none");
  }
}
function m5(r, e) {
  return r === 1 ? !0 : r === 2 ? !1 : e;
}
class gMt extends me {
  get searchString() {
    return this._searchString;
  }
  get replaceString() {
    return this._replaceString;
  }
  get isRevealed() {
    return this._isRevealed;
  }
  get isReplaceRevealed() {
    return this._isReplaceRevealed;
  }
  get isRegex() {
    return m5(this._isRegexOverride, this._isRegex);
  }
  get wholeWord() {
    return m5(this._wholeWordOverride, this._wholeWord);
  }
  get matchCase() {
    return m5(this._matchCaseOverride, this._matchCase);
  }
  get preserveCase() {
    return m5(this._preserveCaseOverride, this._preserveCase);
  }
  get actualIsRegex() {
    return this._isRegex;
  }
  get actualWholeWord() {
    return this._wholeWord;
  }
  get actualMatchCase() {
    return this._matchCase;
  }
  get actualPreserveCase() {
    return this._preserveCase;
  }
  get searchScope() {
    return this._searchScope;
  }
  get matchesPosition() {
    return this._matchesPosition;
  }
  get matchesCount() {
    return this._matchesCount;
  }
  get currentMatch() {
    return this._currentMatch;
  }
  constructor() {
    super(), this._onFindReplaceStateChange = this._register(new $()), this.onFindReplaceStateChange = this._onFindReplaceStateChange.event, this._searchString = "", this._replaceString = "", this._isRevealed = !1, this._isReplaceRevealed = !1, this._isRegex = !1, this._isRegexOverride = 0, this._wholeWord = !1, this._wholeWordOverride = 0, this._matchCase = !1, this._matchCaseOverride = 0, this._preserveCase = !1, this._preserveCaseOverride = 0, this._searchScope = null, this._matchesPosition = 0, this._matchesCount = 0, this._currentMatch = null, this._loop = !0, this._isSearching = !1, this._filters = null;
  }
  changeMatchInfo(e, t, n) {
    const i = {
      moveCursor: !1,
      updateHistory: !1,
      searchString: !1,
      replaceString: !1,
      isRevealed: !1,
      isReplaceRevealed: !1,
      isRegex: !1,
      wholeWord: !1,
      matchCase: !1,
      preserveCase: !1,
      searchScope: !1,
      matchesPosition: !1,
      matchesCount: !1,
      currentMatch: !1,
      loop: !1,
      isSearching: !1,
      filters: !1
    };
    let s = !1;
    t === 0 && (e = 0), e > t && (e = t), this._matchesPosition !== e && (this._matchesPosition = e, i.matchesPosition = !0, s = !0), this._matchesCount !== t && (this._matchesCount = t, i.matchesCount = !0, s = !0), typeof n < "u" && (Q.equalsRange(this._currentMatch, n) || (this._currentMatch = n, i.currentMatch = !0, s = !0)), s && this._onFindReplaceStateChange.fire(i);
  }
  change(e, t, n = !0) {
    const i = {
      moveCursor: t,
      updateHistory: n,
      searchString: !1,
      replaceString: !1,
      isRevealed: !1,
      isReplaceRevealed: !1,
      isRegex: !1,
      wholeWord: !1,
      matchCase: !1,
      preserveCase: !1,
      searchScope: !1,
      matchesPosition: !1,
      matchesCount: !1,
      currentMatch: !1,
      loop: !1,
      isSearching: !1,
      filters: !1
    };
    let s = !1;
    const o = this.isRegex, a = this.wholeWord, l = this.matchCase, c = this.preserveCase;
    typeof e.searchString < "u" && this._searchString !== e.searchString && (this._searchString = e.searchString, i.searchString = !0, s = !0), typeof e.replaceString < "u" && this._replaceString !== e.replaceString && (this._replaceString = e.replaceString, i.replaceString = !0, s = !0), typeof e.isRevealed < "u" && this._isRevealed !== e.isRevealed && (this._isRevealed = e.isRevealed, i.isRevealed = !0, s = !0), typeof e.isReplaceRevealed < "u" && this._isReplaceRevealed !== e.isReplaceRevealed && (this._isReplaceRevealed = e.isReplaceRevealed, i.isReplaceRevealed = !0, s = !0), typeof e.isRegex < "u" && (this._isRegex = e.isRegex), typeof e.wholeWord < "u" && (this._wholeWord = e.wholeWord), typeof e.matchCase < "u" && (this._matchCase = e.matchCase), typeof e.preserveCase < "u" && (this._preserveCase = e.preserveCase), typeof e.searchScope < "u" && (e.searchScope?.every((d) => this._searchScope?.some((u) => !Q.equalsRange(u, d))) || (this._searchScope = e.searchScope, i.searchScope = !0, s = !0)), typeof e.loop < "u" && this._loop !== e.loop && (this._loop = e.loop, i.loop = !0, s = !0), typeof e.isSearching < "u" && this._isSearching !== e.isSearching && (this._isSearching = e.isSearching, i.isSearching = !0, s = !0), typeof e.filters < "u" && (this._filters ? this._filters.update(e.filters) : this._filters = e.filters, i.filters = !0, s = !0), this._isRegexOverride = typeof e.isRegexOverride < "u" ? e.isRegexOverride : 0, this._wholeWordOverride = typeof e.wholeWordOverride < "u" ? e.wholeWordOverride : 0, this._matchCaseOverride = typeof e.matchCaseOverride < "u" ? e.matchCaseOverride : 0, this._preserveCaseOverride = typeof e.preserveCaseOverride < "u" ? e.preserveCaseOverride : 0, o !== this.isRegex && (s = !0, i.isRegex = !0), a !== this.wholeWord && (s = !0, i.wholeWord = !0), l !== this.matchCase && (s = !0, i.matchCase = !0), c !== this.preserveCase && (s = !0, i.preserveCase = !0), s && this._onFindReplaceStateChange.fire(i);
  }
  canNavigateBack() {
    return this.canNavigateInLoop() || this.matchesPosition !== 1;
  }
  canNavigateForward() {
    return this.canNavigateInLoop() || this.matchesPosition < this.matchesCount;
  }
  canNavigateInLoop() {
    return this._loop || this.matchesCount >= zu;
  }
}
const mMt = C("defaultLabel", "input"), AMt = C("label.preserveCaseToggle", "Preserve Case");
class wMt extends cm {
  constructor(e) {
    super({
      // TODO: does this need its own icon?
      icon: ke.preserveCase,
      title: AMt + e.appendTitle,
      isChecked: e.isChecked,
      hoverDelegate: e.hoverDelegate ?? fo("element"),
      inputActiveOptionBorder: e.inputActiveOptionBorder,
      inputActiveOptionForeground: e.inputActiveOptionForeground,
      inputActiveOptionBackground: e.inputActiveOptionBackground
    });
  }
}
class vMt extends xa {
  constructor(e, t, n, i) {
    super(), this._showOptionButtons = n, this.fixFocusOnOptionClickEnabled = !0, this.cachedOptionsWidth = 0, this._onDidOptionChange = this._register(new $()), this.onDidOptionChange = this._onDidOptionChange.event, this._onKeyDown = this._register(new $()), this.onKeyDown = this._onKeyDown.event, this._onMouseDown = this._register(new $()), this._onInput = this._register(new $()), this._onKeyUp = this._register(new $()), this._onPreserveCaseKeyDown = this._register(new $()), this.onPreserveCaseKeyDown = this._onPreserveCaseKeyDown.event, this.contextViewProvider = t, this.placeholder = i.placeholder || "", this.validation = i.validation, this.label = i.label || mMt;
    const s = i.appendPreserveCaseLabel || "", o = i.history || [], a = !!i.flexibleHeight, l = !!i.flexibleWidth, c = i.flexibleMaxHeight;
    this.domNode = document.createElement("div"), this.domNode.classList.add("monaco-findInput"), this.inputBox = this._register(new QNe(this.domNode, this.contextViewProvider, {
      ariaLabel: this.label || "",
      placeholder: this.placeholder || "",
      validationOptions: {
        validation: this.validation
      },
      history: o,
      showHistoryHint: i.showHistoryHint,
      flexibleHeight: a,
      flexibleWidth: l,
      flexibleMaxHeight: c,
      inputBoxStyles: i.inputBoxStyles
    })), this.preserveCase = this._register(new wMt({
      appendTitle: s,
      isChecked: !1,
      ...i.toggleStyles
    })), this._register(this.preserveCase.onChange((f) => {
      this._onDidOptionChange.fire(f), !f && this.fixFocusOnOptionClickEnabled && this.inputBox.focus(), this.validate();
    })), this._register(this.preserveCase.onKeyDown((f) => {
      this._onPreserveCaseKeyDown.fire(f);
    })), this._showOptionButtons ? this.cachedOptionsWidth = this.preserveCase.width() : this.cachedOptionsWidth = 0;
    const d = [this.preserveCase.domNode];
    this.onkeydown(this.domNode, (f) => {
      if (f.equals(
        15
        /* KeyCode.LeftArrow */
      ) || f.equals(
        17
        /* KeyCode.RightArrow */
      ) || f.equals(
        9
        /* KeyCode.Escape */
      )) {
        const p = d.indexOf(this.domNode.ownerDocument.activeElement);
        if (p >= 0) {
          let g = -1;
          f.equals(
            17
            /* KeyCode.RightArrow */
          ) ? g = (p + 1) % d.length : f.equals(
            15
            /* KeyCode.LeftArrow */
          ) && (p === 0 ? g = d.length - 1 : g = p - 1), f.equals(
            9
            /* KeyCode.Escape */
          ) ? (d[p].blur(), this.inputBox.focus()) : g >= 0 && d[g].focus(), Lt.stop(f, !0);
        }
      }
    });
    const u = document.createElement("div");
    u.className = "controls", u.style.display = this._showOptionButtons ? "block" : "none", u.appendChild(this.preserveCase.domNode), this.domNode.appendChild(u), e?.appendChild(this.domNode), this.onkeydown(this.inputBox.inputElement, (f) => this._onKeyDown.fire(f)), this.onkeyup(this.inputBox.inputElement, (f) => this._onKeyUp.fire(f)), this.oninput(this.inputBox.inputElement, (f) => this._onInput.fire()), this.onmousedown(this.inputBox.inputElement, (f) => this._onMouseDown.fire(f));
  }
  enable() {
    this.domNode.classList.remove("disabled"), this.inputBox.enable(), this.preserveCase.enable();
  }
  disable() {
    this.domNode.classList.add("disabled"), this.inputBox.disable(), this.preserveCase.disable();
  }
  setEnabled(e) {
    e ? this.enable() : this.disable();
  }
  select() {
    this.inputBox.select();
  }
  focus() {
    this.inputBox.focus();
  }
  getPreserveCase() {
    return this.preserveCase.checked;
  }
  setPreserveCase(e) {
    this.preserveCase.checked = e;
  }
  focusOnPreserve() {
    this.preserveCase.focus();
  }
  validate() {
    this.inputBox?.validate();
  }
  set width(e) {
    this.inputBox.paddingRight = this.cachedOptionsWidth, this.domNode.style.width = e + "px";
  }
  dispose() {
    super.dispose();
  }
}
var qTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, GTe = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
};
const QTe = new Ve("suggestWidgetVisible", !1, C("suggestWidgetVisible", "Whether suggestion are visible")), cV = "historyNavigationWidgetFocus", KTe = "historyNavigationForwardsEnabled", YTe = "historyNavigationBackwardsEnabled";
let u3;
const A5 = [];
function XTe(r, e) {
  if (A5.includes(e))
    throw new Error("Cannot register the same widget multiple times");
  A5.push(e);
  const t = new ze(), n = new Ve(cV, !1).bindTo(r), i = new Ve(KTe, !0).bindTo(r), s = new Ve(YTe, !0).bindTo(r), o = () => {
    n.set(!0), u3 = e;
  }, a = () => {
    n.set(!1), u3 === e && (u3 = void 0);
  };
  return F7(e.element) && o(), t.add(e.onDidFocus(() => o())), t.add(e.onDidBlur(() => a())), t.add(ht(() => {
    A5.splice(A5.indexOf(e), 1), a();
  })), {
    historyNavigationForwardsEnablement: i,
    historyNavigationBackwardsEnablement: s,
    dispose() {
      t.dispose();
    }
  };
}
let AN = class extends KNe {
  constructor(e, t, n, i) {
    super(e, t, n);
    const s = this._register(i.createScoped(this.inputBox.element));
    this._register(XTe(s, this.inputBox));
  }
};
AN = qTe([
  GTe(3, sn)
], AN);
let wN = class extends vMt {
  constructor(e, t, n, i, s = !1) {
    super(e, t, s, n);
    const o = this._register(i.createScoped(this.inputBox.element));
    this._register(XTe(o, this.inputBox));
  }
};
wN = qTe([
  GTe(3, sn)
], wN);
Kf.registerCommandAndKeybindingRule({
  id: "history.showPrevious",
  weight: 200,
  when: mt.and(mt.has(cV), mt.equals(YTe, !0), mt.not("isComposing"), QTe.isEqualTo(!1)),
  primary: 16,
  secondary: [
    528
    /* KeyCode.UpArrow */
  ],
  handler: (r) => {
    u3?.showPreviousValue();
  }
});
Kf.registerCommandAndKeybindingRule({
  id: "history.showNext",
  weight: 200,
  when: mt.and(mt.has(cV), mt.equals(KTe, !0), mt.not("isComposing"), QTe.isEqualTo(!1)),
  primary: 18,
  secondary: [
    530
    /* KeyCode.DownArrow */
  ],
  handler: (r) => {
    u3?.showNextValue();
  }
});
function _be(r) {
  return r.lookupKeybinding("history.showPrevious")?.getElectronAccelerator() === "Up" && r.lookupKeybinding("history.showNext")?.getElectronAccelerator() === "Down";
}
const xbe = po("find-collapsed", ke.chevronRight, C("findCollapsedIcon", "Icon to indicate that the editor find widget is collapsed.")), Sbe = po("find-expanded", ke.chevronDown, C("findExpandedIcon", "Icon to indicate that the editor find widget is expanded.")), bMt = po("find-selection", ke.selection, C("findSelectionIcon", "Icon for 'Find in Selection' in the editor find widget.")), yMt = po("find-replace", ke.replace, C("findReplaceIcon", "Icon for 'Replace' in the editor find widget.")), CMt = po("find-replace-all", ke.replaceAll, C("findReplaceAllIcon", "Icon for 'Replace All' in the editor find widget.")), EMt = po("find-previous-match", ke.arrowUp, C("findPreviousMatchIcon", "Icon for 'Find Previous' in the editor find widget.")), _Mt = po("find-next-match", ke.arrowDown, C("findNextMatchIcon", "Icon for 'Find Next' in the editor find widget.")), xMt = C("label.findDialog", "Find / Replace"), SMt = C("label.find", "Find"), MMt = C("placeholder.find", "Find"), DMt = C("label.previousMatchButton", "Previous Match"), LMt = C("label.nextMatchButton", "Next Match"), kMt = C("label.toggleSelectionFind", "Find in Selection"), NMt = C("label.closeButton", "Close"), TMt = C("label.replace", "Replace"), IMt = C("placeholder.replace", "Replace"), OMt = C("label.replaceButton", "Replace"), RMt = C("label.replaceAllButton", "Replace All"), VMt = C("label.toggleReplaceButton", "Toggle Replace"), HMt = C("title.matchesCountLimit", "Only the first {0} results are highlighted, but all find operations work on the entire text.", zu), BMt = C("label.matchesLocation", "{0} of {1}"), Mbe = C("label.noResults", "No results"), Lc = 419, PMt = 275, FMt = PMt - 54;
let Ym = 69;
const zMt = 33, Dbe = "ctrlEnterReplaceAll.windows.donotask", Lbe = zt ? 256 : 2048;
class O_ {
  constructor(e) {
    this.afterLineNumber = e, this.heightInPx = zMt, this.suppressMouseDown = !1, this.domNode = document.createElement("div"), this.domNode.className = "dock-find-viewzone";
  }
}
function kbe(r, e, t) {
  const n = !!e.match(/\n/);
  if (t && n && t.selectionStart > 0) {
    r.stopPropagation();
    return;
  }
}
function Nbe(r, e, t) {
  const n = !!e.match(/\n/);
  if (t && n && t.selectionEnd < t.value.length) {
    r.stopPropagation();
    return;
  }
}
class hV extends xa {
  static {
    this.ID = "editor.contrib.findWidget";
  }
  constructor(e, t, n, i, s, o, a, l, c, d) {
    super(), this._hoverService = d, this._cachedHeight = null, this._revealTimeouts = [], this._codeEditor = e, this._controller = t, this._state = n, this._contextViewProvider = i, this._keybindingService = s, this._contextKeyService = o, this._storageService = l, this._notificationService = c, this._ctrlEnterReplaceAllWarningPrompted = !!l.getBoolean(
      Dbe,
      0
      /* StorageScope.PROFILE */
    ), this._isVisible = !1, this._isReplaceVisible = !1, this._ignoreChangeEvent = !1, this._updateHistoryDelayer = new Uf(500), this._register(ht(() => this._updateHistoryDelayer.cancel())), this._register(this._state.onFindReplaceStateChange((u) => this._onStateChanged(u))), this._buildDomNode(), this._updateButtons(), this._tryUpdateWidgetWidth(), this._findInput.inputBox.layout(), this._register(this._codeEditor.onDidChangeConfiguration((u) => {
      if (u.hasChanged(
        92
        /* EditorOption.readOnly */
      ) && (this._codeEditor.getOption(
        92
        /* EditorOption.readOnly */
      ) && this._state.change({ isReplaceRevealed: !1 }, !1), this._updateButtons()), u.hasChanged(
        146
        /* EditorOption.layoutInfo */
      ) && this._tryUpdateWidgetWidth(), u.hasChanged(
        2
        /* EditorOption.accessibilitySupport */
      ) && this.updateAccessibilitySupport(), u.hasChanged(
        41
        /* EditorOption.find */
      )) {
        const f = this._codeEditor.getOption(
          41
          /* EditorOption.find */
        ).loop;
        this._state.change({ loop: f }, !1);
        const p = this._codeEditor.getOption(
          41
          /* EditorOption.find */
        ).addExtraSpaceOnTop;
        p && !this._viewZone && (this._viewZone = new O_(0), this._showViewZone()), !p && this._viewZone && this._removeViewZone();
      }
    })), this.updateAccessibilitySupport(), this._register(this._codeEditor.onDidChangeCursorSelection(() => {
      this._isVisible && this._updateToggleSelectionFindButton();
    })), this._register(this._codeEditor.onDidFocusEditorWidget(async () => {
      if (this._isVisible) {
        const u = await this._controller.getGlobalBufferTerm();
        u && u !== this._state.searchString && (this._state.change({ searchString: u }, !1), this._findInput.select());
      }
    })), this._findInputFocused = Wy.bindTo(o), this._findFocusTracker = this._register(Af(this._findInput.inputBox.inputElement)), this._register(this._findFocusTracker.onDidFocus(() => {
      this._findInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._findFocusTracker.onDidBlur(() => {
      this._findInputFocused.set(!1);
    })), this._replaceInputFocused = aV.bindTo(o), this._replaceFocusTracker = this._register(Af(this._replaceInput.inputBox.inputElement)), this._register(this._replaceFocusTracker.onDidFocus(() => {
      this._replaceInputFocused.set(!0), this._updateSearchScope();
    })), this._register(this._replaceFocusTracker.onDidBlur(() => {
      this._replaceInputFocused.set(!1);
    })), this._codeEditor.addOverlayWidget(this), this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop && (this._viewZone = new O_(0)), this._register(this._codeEditor.onDidChangeModel(() => {
      this._isVisible && (this._viewZoneId = void 0);
    })), this._register(this._codeEditor.onDidScrollChange((u) => {
      if (u.scrollTopChanged) {
        this._layoutViewZone();
        return;
      }
      setTimeout(() => {
        this._layoutViewZone();
      }, 0);
    }));
  }
  // ----- IOverlayWidget API
  getId() {
    return hV.ID;
  }
  getDomNode() {
    return this._domNode;
  }
  getPosition() {
    return this._isVisible ? {
      preference: 0
      /* OverlayWidgetPositionPreference.TOP_RIGHT_CORNER */
    } : null;
  }
  // ----- React to state changes
  _onStateChanged(e) {
    if (e.searchString) {
      try {
        this._ignoreChangeEvent = !0, this._findInput.setValue(this._state.searchString);
      } finally {
        this._ignoreChangeEvent = !1;
      }
      this._updateButtons();
    }
    if (e.replaceString && (this._replaceInput.inputBox.value = this._state.replaceString), e.isRevealed && (this._state.isRevealed ? this._reveal() : this._hide(!0)), e.isReplaceRevealed && (this._state.isReplaceRevealed ? !this._codeEditor.getOption(
      92
      /* EditorOption.readOnly */
    ) && !this._isReplaceVisible && (this._isReplaceVisible = !0, this._replaceInput.width = Fa(this._findInput.domNode), this._updateButtons(), this._replaceInput.inputBox.layout()) : this._isReplaceVisible && (this._isReplaceVisible = !1, this._updateButtons())), (e.isRevealed || e.isReplaceRevealed) && (this._state.isRevealed || this._state.isReplaceRevealed) && this._tryUpdateHeight() && this._showViewZone(), e.isRegex && this._findInput.setRegex(this._state.isRegex), e.wholeWord && this._findInput.setWholeWords(this._state.wholeWord), e.matchCase && this._findInput.setCaseSensitive(this._state.matchCase), e.preserveCase && this._replaceInput.setPreserveCase(this._state.preserveCase), e.searchScope && (this._state.searchScope ? this._toggleSelectionFind.checked = !0 : this._toggleSelectionFind.checked = !1, this._updateToggleSelectionFindButton()), e.searchString || e.matchesCount || e.matchesPosition) {
      const t = this._state.searchString.length > 0 && this._state.matchesCount === 0;
      this._domNode.classList.toggle("no-results", t), this._updateMatchesCount(), this._updateButtons();
    }
    (e.searchString || e.currentMatch) && this._layoutViewZone(), e.updateHistory && this._delayedUpdateHistory(), e.loop && this._updateButtons();
  }
  _delayedUpdateHistory() {
    this._updateHistoryDelayer.trigger(this._updateHistory.bind(this)).then(void 0, wn);
  }
  _updateHistory() {
    this._state.searchString && this._findInput.inputBox.addToHistory(), this._state.replaceString && this._replaceInput.inputBox.addToHistory();
  }
  _updateMatchesCount() {
    this._matchesCount.style.minWidth = Ym + "px", this._state.matchesCount >= zu ? this._matchesCount.title = HMt : this._matchesCount.title = "", this._matchesCount.firstChild?.remove();
    let e;
    if (this._state.matchesCount > 0) {
      let t = String(this._state.matchesCount);
      this._state.matchesCount >= zu && (t += "+");
      let n = String(this._state.matchesPosition);
      n === "0" && (n = "?"), e = I8(BMt, n, t);
    } else
      e = Mbe;
    this._matchesCount.appendChild(document.createTextNode(e)), X8(this._getAriaLabel(e, this._state.currentMatch, this._state.searchString)), Ym = Math.max(Ym, this._matchesCount.clientWidth);
  }
  // ----- actions
  _getAriaLabel(e, t, n) {
    if (e === Mbe)
      return n === "" ? C("ariaSearchNoResultEmpty", "{0} found", e) : C("ariaSearchNoResult", "{0} found for '{1}'", e, n);
    if (t) {
      const i = C("ariaSearchNoResultWithLineNum", "{0} found for '{1}', at {2}", e, n, t.startLineNumber + ":" + t.startColumn), s = this._codeEditor.getModel();
      return s && t.startLineNumber <= s.getLineCount() && t.startLineNumber >= 1 ? `${s.getLineContent(t.startLineNumber)}, ${i}` : i;
    }
    return C("ariaSearchNoResultWithLineNumNoCurrentMatch", "{0} found for '{1}'", e, n);
  }
  /**
   * If 'selection find' is ON we should not disable the button (its function is to cancel 'selection find').
   * If 'selection find' is OFF we enable the button only if there is a selection.
   */
  _updateToggleSelectionFindButton() {
    const e = this._codeEditor.getSelection(), t = e ? e.startLineNumber !== e.endLineNumber || e.startColumn !== e.endColumn : !1, n = this._toggleSelectionFind.checked;
    this._isVisible && (n || t) ? this._toggleSelectionFind.enable() : this._toggleSelectionFind.disable();
  }
  _updateButtons() {
    this._findInput.setEnabled(this._isVisible), this._replaceInput.setEnabled(this._isVisible && this._isReplaceVisible), this._updateToggleSelectionFindButton(), this._closeBtn.setEnabled(this._isVisible);
    const e = this._state.searchString.length > 0, t = !!this._state.matchesCount;
    this._prevBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateBack()), this._nextBtn.setEnabled(this._isVisible && e && t && this._state.canNavigateForward()), this._replaceBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._replaceAllBtn.setEnabled(this._isVisible && this._isReplaceVisible && e), this._domNode.classList.toggle("replaceToggled", this._isReplaceVisible), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible);
    const n = !this._codeEditor.getOption(
      92
      /* EditorOption.readOnly */
    );
    this._toggleReplaceBtn.setEnabled(this._isVisible && n);
  }
  _reveal() {
    if (this._revealTimeouts.forEach((e) => {
      clearTimeout(e);
    }), this._revealTimeouts = [], !this._isVisible) {
      this._isVisible = !0;
      const e = this._codeEditor.getSelection();
      switch (this._codeEditor.getOption(
        41
        /* EditorOption.find */
      ).autoFindInSelection) {
        case "always":
          this._toggleSelectionFind.checked = !0;
          break;
        case "never":
          this._toggleSelectionFind.checked = !1;
          break;
        case "multiline": {
          const n = !!e && e.startLineNumber !== e.endLineNumber;
          this._toggleSelectionFind.checked = n;
          break;
        }
      }
      this._tryUpdateWidgetWidth(), this._updateButtons(), this._revealTimeouts.push(setTimeout(() => {
        this._domNode.classList.add("visible"), this._domNode.setAttribute("aria-hidden", "false");
      }, 0)), this._revealTimeouts.push(setTimeout(() => {
        this._findInput.validate();
      }, 200)), this._codeEditor.layoutOverlayWidget(this);
      let t = !0;
      if (this._codeEditor.getOption(
        41
        /* EditorOption.find */
      ).seedSearchStringFromSelection && e) {
        const n = this._codeEditor.getDomNode();
        if (n) {
          const i = To(n), s = this._codeEditor.getScrolledVisiblePosition(e.getStartPosition()), o = i.left + (s ? s.left : 0), a = s ? s.top : 0;
          if (this._viewZone && a < this._viewZone.heightInPx) {
            e.endLineNumber > e.startLineNumber && (t = !1);
            const l = MDe(this._domNode).left;
            o > l && (t = !1);
            const c = this._codeEditor.getScrolledVisiblePosition(e.getEndPosition());
            i.left + (c ? c.left : 0) > l && (t = !1);
          }
        }
      }
      this._showViewZone(t);
    }
  }
  _hide(e) {
    this._revealTimeouts.forEach((t) => {
      clearTimeout(t);
    }), this._revealTimeouts = [], this._isVisible && (this._isVisible = !1, this._updateButtons(), this._domNode.classList.remove("visible"), this._domNode.setAttribute("aria-hidden", "true"), this._findInput.clearMessage(), e && this._codeEditor.focus(), this._codeEditor.layoutOverlayWidget(this), this._removeViewZone());
  }
  _layoutViewZone(e) {
    if (!this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop) {
      this._removeViewZone();
      return;
    }
    if (!this._isVisible)
      return;
    const n = this._viewZone;
    this._viewZoneId !== void 0 || !n || this._codeEditor.changeViewZones((i) => {
      n.heightInPx = this._getHeight(), this._viewZoneId = i.addZone(n), this._codeEditor.setScrollTop(e || this._codeEditor.getScrollTop() + n.heightInPx);
    });
  }
  _showViewZone(e = !0) {
    if (!this._isVisible || !this._codeEditor.getOption(
      41
      /* EditorOption.find */
    ).addExtraSpaceOnTop)
      return;
    this._viewZone === void 0 && (this._viewZone = new O_(0));
    const n = this._viewZone;
    this._codeEditor.changeViewZones((i) => {
      if (this._viewZoneId !== void 0) {
        const s = this._getHeight();
        if (s === n.heightInPx)
          return;
        const o = s - n.heightInPx;
        n.heightInPx = s, i.layoutZone(this._viewZoneId), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + o);
        return;
      } else {
        let s = this._getHeight();
        if (s -= this._codeEditor.getOption(
          84
          /* EditorOption.padding */
        ).top, s <= 0)
          return;
        n.heightInPx = s, this._viewZoneId = i.addZone(n), e && this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() + s);
      }
    });
  }
  _removeViewZone() {
    this._codeEditor.changeViewZones((e) => {
      this._viewZoneId !== void 0 && (e.removeZone(this._viewZoneId), this._viewZoneId = void 0, this._viewZone && (this._codeEditor.setScrollTop(this._codeEditor.getScrollTop() - this._viewZone.heightInPx), this._viewZone = void 0));
    });
  }
  _tryUpdateWidgetWidth() {
    if (!this._isVisible || !this._domNode.isConnected)
      return;
    const e = this._codeEditor.getLayoutInfo();
    if (e.contentWidth <= 0) {
      this._domNode.classList.add("hiddenEditor");
      return;
    } else this._domNode.classList.contains("hiddenEditor") && this._domNode.classList.remove("hiddenEditor");
    const n = e.width, i = e.minimap.minimapWidth;
    let s = !1, o = !1, a = !1;
    if (this._resized && Fa(this._domNode) > Lc) {
      this._domNode.style.maxWidth = `${n - 28 - i - 15}px`, this._replaceInput.width = Fa(this._findInput.domNode);
      return;
    }
    if (Lc + 28 + i >= n && (o = !0), Lc + 28 + i - Ym >= n && (a = !0), Lc + 28 + i - Ym >= n + 50 && (s = !0), this._domNode.classList.toggle("collapsed-find-widget", s), this._domNode.classList.toggle("narrow-find-widget", a), this._domNode.classList.toggle("reduced-find-widget", o), !a && !s && (this._domNode.style.maxWidth = `${n - 28 - i - 15}px`), this._findInput.layout({ collapsedFindWidget: s, narrowFindWidget: a, reducedFindWidget: o }), this._resized) {
      const l = this._findInput.inputBox.element.clientWidth;
      l > 0 && (this._replaceInput.width = l);
    } else this._isReplaceVisible && (this._replaceInput.width = Fa(this._findInput.domNode));
  }
  _getHeight() {
    let e = 0;
    return e += 4, e += this._findInput.inputBox.height + 2, this._isReplaceVisible && (e += 4, e += this._replaceInput.inputBox.height + 2), e += 4, e;
  }
  _tryUpdateHeight() {
    const e = this._getHeight();
    return this._cachedHeight !== null && this._cachedHeight === e ? !1 : (this._cachedHeight = e, this._domNode.style.height = `${e}px`, !0);
  }
  // ----- Public
  focusFindInput() {
    this._findInput.select(), this._findInput.focus();
  }
  focusReplaceInput() {
    this._replaceInput.select(), this._replaceInput.focus();
  }
  highlightFindOptions() {
    this._findInput.highlightFindOptions();
  }
  _updateSearchScope() {
    if (this._codeEditor.hasModel() && this._toggleSelectionFind.checked) {
      const e = this._codeEditor.getSelections();
      e.map((t) => {
        t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(t.endLineNumber - 1)));
        const n = this._state.currentMatch;
        return t.startLineNumber !== t.endLineNumber && !Q.equalsRange(t, n) ? t : null;
      }).filter((t) => !!t), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  _onFindInputMouseDown(e) {
    e.middleButton && e.stopPropagation();
  }
  _onFindInputKeyDown(e) {
    if (e.equals(
      Lbe | 3
      /* KeyCode.Enter */
    ))
      if (this._keybindingService.dispatchEvent(e, e.target)) {
        e.preventDefault();
        return;
      } else {
        this._findInput.inputBox.insertAtCursor(`
`), e.preventDefault();
        return;
      }
    if (e.equals(
      2
      /* KeyCode.Tab */
    )) {
      this._isReplaceVisible ? this._replaceInput.focus() : this._findInput.focusOnCaseSensitive(), e.preventDefault();
      return;
    }
    if (e.equals(
      2066
      /* KeyCode.DownArrow */
    )) {
      this._codeEditor.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      16
      /* KeyCode.UpArrow */
    ))
      return kbe(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
    if (e.equals(
      18
      /* KeyCode.DownArrow */
    ))
      return Nbe(e, this._findInput.getValue(), this._findInput.domNode.querySelector("textarea"));
  }
  _onReplaceInputKeyDown(e) {
    if (e.equals(
      Lbe | 3
      /* KeyCode.Enter */
    ))
      if (this._keybindingService.dispatchEvent(e, e.target)) {
        e.preventDefault();
        return;
      } else {
        zs && I3 && !this._ctrlEnterReplaceAllWarningPrompted && (this._notificationService.info(C("ctrlEnter.keybindingChanged", "Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior.")), this._ctrlEnterReplaceAllWarningPrompted = !0, this._storageService.store(
          Dbe,
          !0,
          0,
          0
          /* StorageTarget.USER */
        )), this._replaceInput.inputBox.insertAtCursor(`
`), e.preventDefault();
        return;
      }
    if (e.equals(
      2
      /* KeyCode.Tab */
    )) {
      this._findInput.focusOnCaseSensitive(), e.preventDefault();
      return;
    }
    if (e.equals(
      1026
      /* KeyCode.Tab */
    )) {
      this._findInput.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      2066
      /* KeyCode.DownArrow */
    )) {
      this._codeEditor.focus(), e.preventDefault();
      return;
    }
    if (e.equals(
      16
      /* KeyCode.UpArrow */
    ))
      return kbe(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
    if (e.equals(
      18
      /* KeyCode.DownArrow */
    ))
      return Nbe(e, this._replaceInput.inputBox.value, this._replaceInput.inputBox.element.querySelector("textarea"));
  }
  // ----- sash
  getVerticalSashLeft(e) {
    return 0;
  }
  // ----- initialization
  _keybindingLabelFor(e) {
    const t = this._keybindingService.lookupKeybinding(e);
    return t ? ` (${t.getLabel()})` : "";
  }
  _buildDomNode() {
    this._findInput = this._register(new AN(null, this._contextViewProvider, {
      width: FMt,
      label: SMt,
      placeholder: MMt,
      appendCaseSensitiveLabel: this._keybindingLabelFor(kn.ToggleCaseSensitiveCommand),
      appendWholeWordsLabel: this._keybindingLabelFor(kn.ToggleWholeWordCommand),
      appendRegexLabel: this._keybindingLabelFor(kn.ToggleRegexCommand),
      validation: (d) => {
        if (d.length === 0 || !this._findInput.getRegex())
          return null;
        try {
          return new RegExp(d, "gu"), null;
        } catch (u) {
          return { content: u.message };
        }
      },
      flexibleHeight: !0,
      flexibleWidth: !0,
      flexibleMaxHeight: 118,
      showCommonFindToggles: !0,
      showHistoryHint: () => _be(this._keybindingService),
      inputBoxStyles: P9,
      toggleStyles: B9
    }, this._contextKeyService)), this._findInput.setRegex(!!this._state.isRegex), this._findInput.setCaseSensitive(!!this._state.matchCase), this._findInput.setWholeWords(!!this._state.wholeWord), this._register(this._findInput.onKeyDown((d) => this._onFindInputKeyDown(d))), this._register(this._findInput.inputBox.onDidChange(() => {
      this._ignoreChangeEvent || this._state.change({ searchString: this._findInput.getValue() }, !0);
    })), this._register(this._findInput.onDidOptionChange(() => {
      this._state.change({
        isRegex: this._findInput.getRegex(),
        wholeWord: this._findInput.getWholeWords(),
        matchCase: this._findInput.getCaseSensitive()
      }, !0);
    })), this._register(this._findInput.onCaseSensitiveKeyDown((d) => {
      d.equals(
        1026
        /* KeyCode.Tab */
      ) && this._isReplaceVisible && (this._replaceInput.focus(), d.preventDefault());
    })), this._register(this._findInput.onRegexKeyDown((d) => {
      d.equals(
        2
        /* KeyCode.Tab */
      ) && this._isReplaceVisible && (this._replaceInput.focusOnPreserve(), d.preventDefault());
    })), this._register(this._findInput.inputBox.onDidHeightChange((d) => {
      this._tryUpdateHeight() && this._showViewZone();
    })), Cs && this._register(this._findInput.onMouseDown((d) => this._onFindInputMouseDown(d))), this._matchesCount = document.createElement("div"), this._matchesCount.className = "matchesCount", this._updateMatchesCount();
    const n = this._register(wg());
    this._prevBtn = this._register(new k2({
      label: DMt + this._keybindingLabelFor(kn.PreviousMatchFindAction),
      icon: EMt,
      hoverDelegate: n,
      onTrigger: () => {
        E8(this._codeEditor.getAction(kn.PreviousMatchFindAction)).run().then(void 0, wn);
      }
    }, this._hoverService)), this._nextBtn = this._register(new k2({
      label: LMt + this._keybindingLabelFor(kn.NextMatchFindAction),
      icon: _Mt,
      hoverDelegate: n,
      onTrigger: () => {
        E8(this._codeEditor.getAction(kn.NextMatchFindAction)).run().then(void 0, wn);
      }
    }, this._hoverService));
    const i = document.createElement("div");
    i.className = "find-part", i.appendChild(this._findInput.domNode);
    const s = document.createElement("div");
    s.className = "find-actions", i.appendChild(s), s.appendChild(this._matchesCount), s.appendChild(this._prevBtn.domNode), s.appendChild(this._nextBtn.domNode), this._toggleSelectionFind = this._register(new cm({
      icon: bMt,
      title: kMt + this._keybindingLabelFor(kn.ToggleSearchScopeCommand),
      isChecked: !1,
      hoverDelegate: n,
      inputActiveOptionBackground: _e(oy),
      inputActiveOptionBorder: _e(sy),
      inputActiveOptionForeground: _e(ay)
    })), this._register(this._toggleSelectionFind.onChange(() => {
      if (this._toggleSelectionFind.checked) {
        if (this._codeEditor.hasModel()) {
          let d = this._codeEditor.getSelections();
          d = d.map((u) => (u.endColumn === 1 && u.endLineNumber > u.startLineNumber && (u = u.setEndPosition(u.endLineNumber - 1, this._codeEditor.getModel().getLineMaxColumn(u.endLineNumber - 1))), u.isEmpty() ? null : u)).filter((u) => !!u), d.length && this._state.change({ searchScope: d }, !0);
        }
      } else
        this._state.change({ searchScope: null }, !0);
    })), s.appendChild(this._toggleSelectionFind.domNode), this._closeBtn = this._register(new k2({
      label: NMt + this._keybindingLabelFor(kn.CloseFindWidgetCommand),
      icon: bEt,
      hoverDelegate: n,
      onTrigger: () => {
        this._state.change({ isRevealed: !1, searchScope: null }, !1);
      },
      onKeyDown: (d) => {
        d.equals(
          2
          /* KeyCode.Tab */
        ) && this._isReplaceVisible && (this._replaceBtn.isEnabled() ? this._replaceBtn.focus() : this._codeEditor.focus(), d.preventDefault());
      }
    }, this._hoverService)), this._replaceInput = this._register(new wN(null, void 0, {
      label: TMt,
      placeholder: IMt,
      appendPreserveCaseLabel: this._keybindingLabelFor(kn.TogglePreserveCaseCommand),
      history: [],
      flexibleHeight: !0,
      flexibleWidth: !0,
      flexibleMaxHeight: 118,
      showHistoryHint: () => _be(this._keybindingService),
      inputBoxStyles: P9,
      toggleStyles: B9
    }, this._contextKeyService, !0)), this._replaceInput.setPreserveCase(!!this._state.preserveCase), this._register(this._replaceInput.onKeyDown((d) => this._onReplaceInputKeyDown(d))), this._register(this._replaceInput.inputBox.onDidChange(() => {
      this._state.change({ replaceString: this._replaceInput.inputBox.value }, !1);
    })), this._register(this._replaceInput.inputBox.onDidHeightChange((d) => {
      this._isReplaceVisible && this._tryUpdateHeight() && this._showViewZone();
    })), this._register(this._replaceInput.onDidOptionChange(() => {
      this._state.change({
        preserveCase: this._replaceInput.getPreserveCase()
      }, !0);
    })), this._register(this._replaceInput.onPreserveCaseKeyDown((d) => {
      d.equals(
        2
        /* KeyCode.Tab */
      ) && (this._prevBtn.isEnabled() ? this._prevBtn.focus() : this._nextBtn.isEnabled() ? this._nextBtn.focus() : this._toggleSelectionFind.enabled ? this._toggleSelectionFind.focus() : this._closeBtn.isEnabled() && this._closeBtn.focus(), d.preventDefault());
    }));
    const o = this._register(wg());
    this._replaceBtn = this._register(new k2({
      label: OMt + this._keybindingLabelFor(kn.ReplaceOneAction),
      icon: yMt,
      hoverDelegate: o,
      onTrigger: () => {
        this._controller.replace();
      },
      onKeyDown: (d) => {
        d.equals(
          1026
          /* KeyCode.Tab */
        ) && (this._closeBtn.focus(), d.preventDefault());
      }
    }, this._hoverService)), this._replaceAllBtn = this._register(new k2({
      label: RMt + this._keybindingLabelFor(kn.ReplaceAllAction),
      icon: CMt,
      hoverDelegate: o,
      onTrigger: () => {
        this._controller.replaceAll();
      }
    }, this._hoverService));
    const a = document.createElement("div");
    a.className = "replace-part", a.appendChild(this._replaceInput.domNode);
    const l = document.createElement("div");
    l.className = "replace-actions", a.appendChild(l), l.appendChild(this._replaceBtn.domNode), l.appendChild(this._replaceAllBtn.domNode), this._toggleReplaceBtn = this._register(new k2({
      label: VMt,
      className: "codicon toggle left",
      onTrigger: () => {
        this._state.change({ isReplaceRevealed: !this._isReplaceVisible }, !1), this._isReplaceVisible && (this._replaceInput.width = Fa(this._findInput.domNode), this._replaceInput.inputBox.layout()), this._showViewZone();
      }
    }, this._hoverService)), this._toggleReplaceBtn.setExpanded(this._isReplaceVisible), this._domNode = document.createElement("div"), this._domNode.className = "editor-widget find-widget", this._domNode.setAttribute("aria-hidden", "true"), this._domNode.ariaLabel = xMt, this._domNode.role = "dialog", this._domNode.style.width = `${Lc}px`, this._domNode.appendChild(this._toggleReplaceBtn.domNode), this._domNode.appendChild(i), this._domNode.appendChild(this._closeBtn.domNode), this._domNode.appendChild(a), this._resizeSash = this._register(new bo(this._domNode, this, { orientation: 0, size: 2 })), this._resized = !1;
    let c = Lc;
    this._register(this._resizeSash.onDidStart(() => {
      c = Fa(this._domNode);
    })), this._register(this._resizeSash.onDidChange((d) => {
      this._resized = !0;
      const u = c + d.startX - d.currentX;
      if (u < Lc)
        return;
      const f = parseFloat(P7(this._domNode).maxWidth) || 0;
      u > f || (this._domNode.style.width = `${u}px`, this._isReplaceVisible && (this._replaceInput.width = Fa(this._findInput.domNode)), this._findInput.inputBox.layout(), this._tryUpdateHeight());
    })), this._register(this._resizeSash.onDidReset(() => {
      const d = Fa(this._domNode);
      if (d < Lc)
        return;
      let u = Lc;
      if (!this._resized || d === Lc) {
        const f = this._codeEditor.getLayoutInfo();
        u = f.width - 28 - f.minimap.minimapWidth - 15, this._resized = !0;
      }
      this._domNode.style.width = `${u}px`, this._isReplaceVisible && (this._replaceInput.width = Fa(this._findInput.domNode)), this._findInput.inputBox.layout();
    }));
  }
  updateAccessibilitySupport() {
    const e = this._codeEditor.getOption(
      2
      /* EditorOption.accessibilitySupport */
    );
    this._findInput.setFocusInputOnOptionClick(
      e !== 2
      /* AccessibilitySupport.Enabled */
    );
  }
}
class k2 extends xa {
  constructor(e, t) {
    super(), this._opts = e;
    let n = "button";
    this._opts.className && (n = n + " " + this._opts.className), this._opts.icon && (n = n + " " + Tt.asClassName(this._opts.icon)), this._domNode = document.createElement("div"), this._domNode.tabIndex = 0, this._domNode.className = n, this._domNode.setAttribute("role", "button"), this._domNode.setAttribute("aria-label", this._opts.label), this._register(t.setupManagedHover(e.hoverDelegate ?? fo("element"), this._domNode, this._opts.label)), this.onclick(this._domNode, (i) => {
      this._opts.onTrigger(), i.preventDefault();
    }), this.onkeydown(this._domNode, (i) => {
      if (i.equals(
        10
        /* KeyCode.Space */
      ) || i.equals(
        3
        /* KeyCode.Enter */
      )) {
        this._opts.onTrigger(), i.preventDefault();
        return;
      }
      this._opts.onKeyDown?.(i);
    });
  }
  get domNode() {
    return this._domNode;
  }
  isEnabled() {
    return this._domNode.tabIndex >= 0;
  }
  focus() {
    this._domNode.focus();
  }
  setEnabled(e) {
    this._domNode.classList.toggle("disabled", !e), this._domNode.setAttribute("aria-disabled", String(!e)), this._domNode.tabIndex = e ? 0 : -1;
  }
  setExpanded(e) {
    this._domNode.setAttribute("aria-expanded", String(!!e)), e ? (this._domNode.classList.remove(...Tt.asClassNameArray(xbe)), this._domNode.classList.add(...Tt.asClassNameArray(Sbe))) : (this._domNode.classList.remove(...Tt.asClassNameArray(Sbe)), this._domNode.classList.add(...Tt.asClassNameArray(xbe)));
  }
}
Sh((r, e) => {
  const t = r.getColor(O0);
  t && e.addRule(`.monaco-editor .findMatch { border: 1px ${$u(r.type) ? "dotted" : "solid"} ${t}; box-sizing: border-box; }`);
  const n = r.getColor(Bmt);
  n && e.addRule(`.monaco-editor .findScope { border: 1px ${$u(r.type) ? "dashed" : "solid"} ${n}; }`);
  const i = r.getColor($t);
  i && e.addRule(`.monaco-editor .find-widget { border: 1px solid ${i}; }`);
  const s = r.getColor(Vmt);
  s && e.addRule(`.monaco-editor .findMatchInline { color: ${s}; }`);
  const o = r.getColor(Hmt);
  o && e.addRule(`.monaco-editor .currentFindMatchInline { color: ${o}; }`);
});
var JTe = function(r, e, t, n) {
  var i = arguments.length, s = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n, o;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(r, e, t, n);
  else for (var a = r.length - 1; a >= 0; a--) (o = r[a]) && (s = (i < 3 ? o(s) : i > 3 ? o(e, t, s) : o(e, t)) || s);
  return i > 3 && s && Object.defineProperty(e, t, s), s;
}, $o = function(r, e) {
  return function(t, n) {
    e(t, n, r);
  };
}, vN;
const WMt = 524288;
function bN(r, e = "single", t = !1) {
  if (!r.hasModel())
    return null;
  const n = r.getSelection();
  if (e === "single" && n.startLineNumber === n.endLineNumber || e === "multiple") {
    if (n.isEmpty()) {
      const i = r.getConfiguredWordAtPosition(n.getStartPosition());
      if (i && t === !1)
        return i.word;
    } else if (r.getModel().getValueLengthInRange(n) < WMt)
      return r.getModel().getValueInRange(n);
  }
  return null;
}
let Al = class extends me {
  static {
    vN = this;
  }
  static {
    this.ID = "editor.contrib.findController";
  }
  get editor() {
    return this._editor;
  }
  static get(e) {
    return e.getContribution(vN.ID);
  }
  constructor(e, t, n, i, s, o) {
    super(), this._editor = e, this._findWidgetVisible = Jd.bindTo(t), this._contextKeyService = t, this._storageService = n, this._clipboardService = i, this._notificationService = s, this._hoverService = o, this._updateHistoryDelayer = new Uf(500), this._state = this._register(new gMt()), this.loadQueryState(), this._register(this._state.onFindReplaceStateChange((a) => this._onStateChanged(a))), this._model = null, this._register(this._editor.onDidChangeModel(() => {
      const a = this._editor.getModel() && this._state.isRevealed;
      this.disposeModel(), this._state.change({
        searchScope: null,
        matchCase: this._storageService.getBoolean("editor.matchCase", 1, !1),
        wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, !1),
        isRegex: this._storageService.getBoolean("editor.isRegex", 1, !1),
        preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, !1)
      }, !1), a && this._start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: "none",
        seedSearchStringFromNonEmptySelection: !1,
        seedSearchStringFromGlobalClipboard: !1,
        shouldFocus: 0,
        shouldAnimate: !1,
        updateSearchScope: !1,
        loop: this._editor.getOption(
          41
          /* EditorOption.find */
        ).loop
      });
    }));
  }
  dispose() {
    this.disposeModel(), super.dispose();
  }
  disposeModel() {
    this._model && (this._model.dispose(), this._model = null);
  }
  _onStateChanged(e) {
    this.saveQueryState(e), e.isRevealed && (this._state.isRevealed ? this._findWidgetVisible.set(!0) : (this._findWidgetVisible.reset(), this.disposeModel())), e.searchString && this.setGlobalBufferTerm(this._state.searchString);
  }
  saveQueryState(e) {
    e.isRegex && this._storageService.store(
      "editor.isRegex",
      this._state.actualIsRegex,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.wholeWord && this._storageService.store(
      "editor.wholeWord",
      this._state.actualWholeWord,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.matchCase && this._storageService.store(
      "editor.matchCase",
      this._state.actualMatchCase,
      1,
      1
      /* StorageTarget.MACHINE */
    ), e.preserveCase && this._storageService.store(
      "editor.preserveCase",
      this._state.actualPreserveCase,
      1,
      1
      /* StorageTarget.MACHINE */
    );
  }
  loadQueryState() {
    this._state.change({
      matchCase: this._storageService.getBoolean("editor.matchCase", 1, this._state.matchCase),
      wholeWord: this._storageService.getBoolean("editor.wholeWord", 1, this._state.wholeWord),
      isRegex: this._storageService.getBoolean("editor.isRegex", 1, this._state.isRegex),
      preserveCase: this._storageService.getBoolean("editor.preserveCase", 1, this._state.preserveCase)
    }, !1);
  }
  isFindInputFocused() {
    return !!Wy.getValue(this._contextKeyService);
  }
  getState() {
    return this._state;
  }
  closeFindWidget() {
    this._state.change({
      isRevealed: !1,
      searchScope: null
    }, !1), this._editor.focus();
  }
  toggleCaseSensitive() {
    this._state.change({ matchCase: !this._state.matchCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleWholeWords() {
    this._state.change({ wholeWord: !this._state.wholeWord }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleRegex() {
    this._state.change({ isRegex: !this._state.isRegex }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  togglePreserveCase() {
    this._state.change({ preserveCase: !this._state.preserveCase }, !1), this._state.isRevealed || this.highlightFindOptions();
  }
  toggleSearchScope() {
    if (this._state.searchScope)
      this._state.change({ searchScope: null }, !0);
    else if (this._editor.hasModel()) {
      let e = this._editor.getSelections();
      e = e.map((t) => (t.endColumn === 1 && t.endLineNumber > t.startLineNumber && (t = t.setEndPosition(t.endLineNumber - 1, this._editor.getModel().getLineMaxColumn(t.endLineNumber - 1))), t.isEmpty() ? null : t)).filter((t) => !!t), e.length && this._state.change({ searchScope: e }, !0);
    }
  }
  setSearchString(e) {
    this._state.isRegex && (e = tc(e)), this._state.change({ searchString: e }, !1);
  }
  highlightFindOptions(e = !1) {
  }
  async _start(e, t) {
    if (this.disposeModel(), !this._editor.hasModel())
      return;
    const n = {
      ...t,
      isRevealed: !0
    };
    if (e.seedSearchStringFromSelection === "single") {
      const i = bN(this._editor, e.seedSearchStringFromSelection, e.seedSearchStringFromNonEmptySelection);
      i && (this._state.isRegex ? n.searchString = tc(i) : n.searchString = i);
    } else if (e.seedSearchStringFromSelection === "multiple" && !e.updateSearchScope) {
      const i = bN(this._editor, e.seedSearchStringFromSelection);
      i && (n.searchString = i);
    }
    if (!n.searchString && e.seedSearchStringFromGlobalClipboard) {
      const i = await this.getGlobalBufferTerm();
      if (!this._editor.hasModel())
        return;
      i && (n.searchString = i);
    }
    if (e.forceRevealReplace || n.isReplaceRevealed ? n.isReplaceRevealed = !0 : this._findWidgetVisible.get() || (n.isReplaceRevealed = !1), e.updateSearchScope) {
      const i = this._editor.getSelections();
      i.some((s) => !s.isEmpty()) && (n.searchScope = i);
    }
    n.loop = e.loop, this._state.change(n, !1), this._model || (this._model = new d3(this._editor, this._state));
  }
  start(e, t) {
    return this._start(e, t);
  }
  moveToNextMatch() {
    return this._model ? (this._model.moveToNextMatch(), !0) : !1;
  }
  moveToPrevMatch() {
    return this._model ? (this._model.moveToPrevMatch(), !0) : !1;
  }
  goToMatch(e) {
    return this._model ? (this._model.moveToMatch(e), !0) : !1;
  }
  replace() {
    return this._model ? (this._model.replace(), !0) : !1;
  }
  replaceAll() {
    return this._model ? this._editor.getModel()?.isTooLargeForHeapOperation() ? (this._notificationService.warn(C("too.large.for.replaceall", "The file is too large to perform a replace all operation.")), !1) : (this._model.replaceAll(), !0) : !1;
  }
  selectAllMatches() {
    return this._model ? (this._model.selectAllMatches(), this._editor.focus(), !0) : !1;
  }
  async getGlobalBufferTerm() {
    return this._editor.getOption(
      41
      /* EditorOption.find */
    ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() ? this._clipboardService.readFindText() : "";
  }
  setGlobalBufferTerm(e) {
    this._editor.getOption(
      41
      /* EditorOption.find */
    ).globalFindClipboard && this._editor.hasModel() && !this._editor.getModel().isTooLargeForSyncing() && this._clipboardService.writeFindText(e);
  }
};
Al = vN = JTe([
  $o(1, sn),
  $o(2, am),
  $o(3, Fw),
  $o(4, Zo),
  $o(5, i2)
], Al);
let yN = class extends Al {
  constructor(e, t, n, i, s, o, a, l, c) {
    super(e, n, a, l, o, c), this._contextViewService = t, this._keybindingService = i, this._themeService = s, this._widget = null, this._findOptionsWidget = null;
  }
  async _start(e, t) {
    this._widget || this._createFindWidget();
    const n = this._editor.getSelection();
    let i = !1;
    switch (this._editor.getOption(
      41
      /* EditorOption.find */
    ).autoFindInSelection) {
      case "always":
        i = !0;
        break;
      case "never":
        i = !1;
        break;
      case "multiline": {
        i = !!n && n.startLineNumber !== n.endLineNumber;
        break;
      }
    }
    e.updateSearchScope = e.updateSearchScope || i, await super._start(e, t), this._widget && (e.shouldFocus === 2 ? this._widget.focusReplaceInput() : e.shouldFocus === 1 && this._widget.focusFindInput());
  }
  highlightFindOptions(e = !1) {
    this._widget || this._createFindWidget(), this._state.isRevealed && !e ? this._widget.highlightFindOptions() : this._findOptionsWidget.highlightFindOptions();
  }
  _createFindWidget() {
    this._widget = this._register(new hV(this._editor, this, this._state, this._contextViewService, this._keybindingService, this._contextKeyService, this._themeService, this._storageService, this._notificationService, this._hoverService)), this._findOptionsWidget = this._register(new lV(this._editor, this._state, this._keybindingService));
  }
};
yN = JTe([
  $o(1, rm),
  $o(2, sn),
  $o(3, _r),
  $o(4, Sa),
  $o(5, Zo),
  $o(6, am),
  $o(7, Fw),
  $o(8, i2)
], yN);
const jMt = WDe(new zDe({
  id: kn.StartFindAction,
  label: C("startFindAction", "Find"),
  alias: "Find",
  precondition: mt.or(Me.focus, mt.has("editorIsOpen")),
  kbOpts: {
    kbExpr: null,
    primary: 2084,
    weight: 100
    /* KeybindingWeight.EditorContrib */
  },
  menuOpts: {
    menuId: oe.MenubarEditMenu,
    group: "3_find",
    title: C({ key: "miFind", comment: ["&& denotes a mnemonic"] }, "&&Find"),
    order: 1
  }
}));
jMt.addImplementation(0, (r, e, t) => {
  const n = Al.get(e);
  return n ? n.start({
    forceRevealReplace: !1,
    seedSearchStringFromSelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection !== "never" ? "single" : "none",
    seedSearchStringFromNonEmptySelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection === "selection",
    seedSearchStringFromGlobalClipboard: e.getOption(
      41
      /* EditorOption.find */
    ).globalFindClipboard,
    shouldFocus: 1,
    shouldAnimate: !0,
    updateSearchScope: !1,
    loop: e.getOption(
      41
      /* EditorOption.find */
    ).loop
  }) : !1;
});
const ZMt = {
  description: "Open a new In-Editor Find Widget.",
  args: [{
    name: "Open a new In-Editor Find Widget args",
    schema: {
      properties: {
        searchString: { type: "string" },
        replaceString: { type: "string" },
        isRegex: { type: "boolean" },
        matchWholeWord: { type: "boolean" },
        isCaseSensitive: { type: "boolean" },
        preserveCase: { type: "boolean" },
        findInSelection: { type: "boolean" }
      }
    }
  }]
};
class UMt extends O1 {
  constructor() {
    super({
      id: kn.StartFindWithArgs,
      label: C("startFindWithArgsAction", "Find With Arguments"),
      alias: "Find With Arguments",
      precondition: void 0,
      kbOpts: {
        kbExpr: null,
        primary: 0,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      },
      metadata: ZMt
    });
  }
  async run(e, t, n) {
    const i = Al.get(t);
    if (i) {
      const s = n ? {
        searchString: n.searchString,
        replaceString: n.replaceString,
        isReplaceRevealed: n.replaceString !== void 0,
        isRegex: n.isRegex,
        // isRegexOverride: args.regexOverride,
        wholeWord: n.matchWholeWord,
        // wholeWordOverride: args.wholeWordOverride,
        matchCase: n.isCaseSensitive,
        // matchCaseOverride: args.matchCaseOverride,
        preserveCase: n.preserveCase
        // preserveCaseOverride: args.preserveCaseOverride,
      } : {};
      await i.start({
        forceRevealReplace: !1,
        seedSearchStringFromSelection: i.getState().searchString.length === 0 && t.getOption(
          41
          /* EditorOption.find */
        ).seedSearchStringFromSelection !== "never" ? "single" : "none",
        seedSearchStringFromNonEmptySelection: t.getOption(
          41
          /* EditorOption.find */
        ).seedSearchStringFromSelection === "selection",
        seedSearchStringFromGlobalClipboard: !0,
        shouldFocus: 1,
        shouldAnimate: !0,
        updateSearchScope: n?.findInSelection || !1,
        loop: t.getOption(
          41
          /* EditorOption.find */
        ).loop
      }, s), i.setGlobalBufferTerm(i.getState().searchString);
    }
  }
}
class qMt extends O1 {
  constructor() {
    super({
      id: kn.StartFindWithSelection,
      label: C("startFindWithSelectionAction", "Find With Selection"),
      alias: "Find With Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: null,
        primary: 0,
        mac: {
          primary: 2083
        },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  async run(e, t) {
    const n = Al.get(t);
    n && (await n.start({
      forceRevealReplace: !1,
      seedSearchStringFromSelection: "multiple",
      seedSearchStringFromNonEmptySelection: !1,
      seedSearchStringFromGlobalClipboard: !1,
      shouldFocus: 0,
      shouldAnimate: !0,
      updateSearchScope: !1,
      loop: t.getOption(
        41
        /* EditorOption.find */
      ).loop
    }), n.setGlobalBufferTerm(n.getState().searchString));
  }
}
class $Te extends O1 {
  async run(e, t) {
    const n = Al.get(t);
    n && !this._run(n) && (await n.start({
      forceRevealReplace: !1,
      seedSearchStringFromSelection: n.getState().searchString.length === 0 && t.getOption(
        41
        /* EditorOption.find */
      ).seedSearchStringFromSelection !== "never" ? "single" : "none",
      seedSearchStringFromNonEmptySelection: t.getOption(
        41
        /* EditorOption.find */
      ).seedSearchStringFromSelection === "selection",
      seedSearchStringFromGlobalClipboard: !0,
      shouldFocus: 0,
      shouldAnimate: !0,
      updateSearchScope: !1,
      loop: t.getOption(
        41
        /* EditorOption.find */
      ).loop
    }), this._run(n));
  }
}
class GMt extends $Te {
  constructor() {
    super({
      id: kn.NextMatchFindAction,
      label: C("findNextMatchAction", "Find Next"),
      alias: "Find Next",
      precondition: void 0,
      kbOpts: [{
        kbExpr: Me.focus,
        primary: 61,
        mac: { primary: 2085, secondary: [
          61
          /* KeyCode.F3 */
        ] },
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }, {
        kbExpr: mt.and(Me.focus, Wy),
        primary: 3,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }]
    });
  }
  _run(e) {
    return e.moveToNextMatch() ? (e.editor.pushUndoStop(), !0) : !1;
  }
}
class QMt extends $Te {
  constructor() {
    super({
      id: kn.PreviousMatchFindAction,
      label: C("findPreviousMatchAction", "Find Previous"),
      alias: "Find Previous",
      precondition: void 0,
      kbOpts: [
        {
          kbExpr: Me.focus,
          primary: 1085,
          mac: { primary: 3109, secondary: [
            1085
            /* KeyCode.F3 */
          ] },
          weight: 100
          /* KeybindingWeight.EditorContrib */
        },
        {
          kbExpr: mt.and(Me.focus, Wy),
          primary: 1027,
          weight: 100
          /* KeybindingWeight.EditorContrib */
        }
      ]
    });
  }
  _run(e) {
    return e.moveToPrevMatch();
  }
}
class KMt extends O1 {
  constructor() {
    super({
      id: kn.GoToMatchFindAction,
      label: C("findMatchAction.goToMatch", "Go to Match..."),
      alias: "Go to Match...",
      precondition: Jd
    }), this._highlightDecorations = [];
  }
  run(e, t, n) {
    const i = Al.get(t);
    if (!i)
      return;
    const s = i.getState().matchesCount;
    if (s < 1) {
      e.get(Zo).notify({
        severity: Zke.Warning,
        message: C("findMatchAction.noResults", "No matches. Try searching for something else.")
      });
      return;
    }
    const a = e.get(Bw).createInputBox();
    a.placeholder = C("findMatchAction.inputPlaceHolder", "Type a number to go to a specific match (between 1 and {0})", s);
    const l = (d) => {
      const u = parseInt(d);
      if (isNaN(u))
        return;
      const f = i.getState().matchesCount;
      if (u > 0 && u <= f)
        return u - 1;
      if (u < 0 && u >= -f)
        return f + u;
    }, c = (d) => {
      const u = l(d);
      if (typeof u == "number") {
        a.validationMessage = void 0, i.goToMatch(u);
        const f = i.getState().currentMatch;
        f && this.addDecorations(t, f);
      } else
        a.validationMessage = C("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", i.getState().matchesCount), this.clearDecorations(t);
    };
    a.onDidChangeValue((d) => {
      c(d);
    }), a.onDidAccept(() => {
      const d = l(a.value);
      typeof d == "number" ? (i.goToMatch(d), a.hide()) : a.validationMessage = C("findMatchAction.inputValidationMessage", "Please type a number between 1 and {0}", i.getState().matchesCount);
    }), a.onDidHide(() => {
      this.clearDecorations(t), a.dispose();
    }), a.show();
  }
  clearDecorations(e) {
    e.changeDecorations((t) => {
      this._highlightDecorations = t.deltaDecorations(this._highlightDecorations, []);
    });
  }
  addDecorations(e, t) {
    e.changeDecorations((n) => {
      this._highlightDecorations = n.deltaDecorations(this._highlightDecorations, [
        {
          range: t,
          options: {
            description: "find-match-quick-access-range-highlight",
            className: "rangeHighlight",
            isWholeLine: !0
          }
        },
        {
          range: t,
          options: {
            description: "find-match-quick-access-range-highlight-overview",
            overviewRuler: {
              color: Ua(v4t),
              position: Xu.Full
            }
          }
        }
      ]);
    });
  }
}
class eIe extends O1 {
  async run(e, t) {
    const n = Al.get(t);
    if (!n)
      return;
    const i = bN(t, "single", !1);
    i && n.setSearchString(i), this._run(n) || (await n.start({
      forceRevealReplace: !1,
      seedSearchStringFromSelection: "none",
      seedSearchStringFromNonEmptySelection: !1,
      seedSearchStringFromGlobalClipboard: !1,
      shouldFocus: 0,
      shouldAnimate: !0,
      updateSearchScope: !1,
      loop: t.getOption(
        41
        /* EditorOption.find */
      ).loop
    }), this._run(n));
  }
}
class YMt extends eIe {
  constructor() {
    super({
      id: kn.NextSelectionMatchFindAction,
      label: C("nextSelectionMatchFindAction", "Find Next Selection"),
      alias: "Find Next Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: Me.focus,
        primary: 2109,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _run(e) {
    return e.moveToNextMatch();
  }
}
class XMt extends eIe {
  constructor() {
    super({
      id: kn.PreviousSelectionMatchFindAction,
      label: C("previousSelectionMatchFindAction", "Find Previous Selection"),
      alias: "Find Previous Selection",
      precondition: void 0,
      kbOpts: {
        kbExpr: Me.focus,
        primary: 3133,
        weight: 100
        /* KeybindingWeight.EditorContrib */
      }
    });
  }
  _run(e) {
    return e.moveToPrevMatch();
  }
}
const JMt = WDe(new zDe({
  id: kn.StartFindReplaceAction,
  label: C("startReplace", "Replace"),
  alias: "Replace",
  precondition: mt.or(Me.focus, mt.has("editorIsOpen")),
  kbOpts: {
    kbExpr: null,
    primary: 2086,
    mac: {
      primary: 2596
      /* KeyCode.KeyF */
    },
    weight: 100
    /* KeybindingWeight.EditorContrib */
  },
  menuOpts: {
    menuId: oe.MenubarEditMenu,
    group: "3_find",
    title: C({ key: "miReplace", comment: ["&& denotes a mnemonic"] }, "&&Replace"),
    order: 2
  }
}));
JMt.addImplementation(0, (r, e, t) => {
  if (!e.hasModel() || e.getOption(
    92
    /* EditorOption.readOnly */
  ))
    return !1;
  const n = Al.get(e);
  if (!n)
    return !1;
  const i = e.getSelection(), s = n.isFindInputFocused(), o = !i.isEmpty() && i.startLineNumber === i.endLineNumber && e.getOption(
    41
    /* EditorOption.find */
  ).seedSearchStringFromSelection !== "never" && !s, a = s || o ? 2 : 1;
  return n.start({
    forceRevealReplace: !0,
    seedSearchStringFromSelection: o ? "single" : "none",
    seedSearchStringFromNonEmptySelection: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection === "selection",
    seedSearchStringFromGlobalClipboard: e.getOption(
      41
      /* EditorOption.find */
    ).seedSearchStringFromSelection !== "never",
    shouldFocus: a,
    shouldAnimate: !0,
    updateSearchScope: !1,
    loop: e.getOption(
      41
      /* EditorOption.find */
    ).loop
  });
});
iO(
  Al.ID,
  yN,
  0
  /* EditorContributionInstantiation.Eager */
);
Xf(UMt);
Xf(qMt);
Xf(GMt);
Xf(QMt);
Xf(KMt);
Xf(YMt);
Xf(XMt);
const mc = Fd.bindToContribution(Al.get);
Je(new mc({
  id: kn.CloseFindWidgetCommand,
  precondition: Jd,
  handler: (r) => r.closeFindWidget(),
  kbOpts: {
    weight: 105,
    kbExpr: mt.and(Me.focus, mt.not("isComposing")),
    primary: 9,
    secondary: [
      1033
      /* KeyCode.Escape */
    ]
  }
}));
Je(new mc({
  id: kn.ToggleCaseSensitiveCommand,
  precondition: void 0,
  handler: (r) => r.toggleCaseSensitive(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: d5.primary,
    mac: d5.mac,
    win: d5.win,
    linux: d5.linux
  }
}));
Je(new mc({
  id: kn.ToggleWholeWordCommand,
  precondition: void 0,
  handler: (r) => r.toggleWholeWords(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: u5.primary,
    mac: u5.mac,
    win: u5.win,
    linux: u5.linux
  }
}));
Je(new mc({
  id: kn.ToggleRegexCommand,
  precondition: void 0,
  handler: (r) => r.toggleRegex(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: f5.primary,
    mac: f5.mac,
    win: f5.win,
    linux: f5.linux
  }
}));
Je(new mc({
  id: kn.ToggleSearchScopeCommand,
  precondition: void 0,
  handler: (r) => r.toggleSearchScope(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: p5.primary,
    mac: p5.mac,
    win: p5.win,
    linux: p5.linux
  }
}));
Je(new mc({
  id: kn.TogglePreserveCaseCommand,
  precondition: void 0,
  handler: (r) => r.togglePreserveCase(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: g5.primary,
    mac: g5.mac,
    win: g5.win,
    linux: g5.linux
  }
}));
Je(new mc({
  id: kn.ReplaceOneAction,
  precondition: Jd,
  handler: (r) => r.replace(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: 3094
    /* KeyCode.Digit1 */
  }
}));
Je(new mc({
  id: kn.ReplaceOneAction,
  precondition: Jd,
  handler: (r) => r.replace(),
  kbOpts: {
    weight: 105,
    kbExpr: mt.and(Me.focus, aV),
    primary: 3
    /* KeyCode.Enter */
  }
}));
Je(new mc({
  id: kn.ReplaceAllAction,
  precondition: Jd,
  handler: (r) => r.replaceAll(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: 2563
    /* KeyCode.Enter */
  }
}));
Je(new mc({
  id: kn.ReplaceAllAction,
  precondition: Jd,
  handler: (r) => r.replaceAll(),
  kbOpts: {
    weight: 105,
    kbExpr: mt.and(Me.focus, aV),
    primary: void 0,
    mac: {
      primary: 2051
    }
  }
}));
Je(new mc({
  id: kn.SelectAllMatchesAction,
  precondition: Jd,
  handler: (r) => r.selectAllMatches(),
  kbOpts: {
    weight: 105,
    kbExpr: Me.focus,
    primary: 515
    /* KeyCode.Enter */
  }
}));
function tIe(r) {
  return new Worker(
    "" + new URL("assets/json.worker-CPVxyQ8I.js", import.meta.url).href,
    {
      name: r?.name
    }
  );
}
function $Mt(r) {
  return self.MonacoEnvironment = {
    getWorker() {
      return new tIe();
    }
  }, l8.config(r ?? { paths: { vs: "/min/vs" } }), l8.init();
}
const eDt = q.div`
  position: absolute;
  white-space: pre-wrap;
  top: 0px;
  left: 64px;
  font-family:
    IBM Plex Mono,
    monospace;
  font-size: 13px;
  font-weight: 400;
  color: #a8a8a8;
  pointer-events: none;
  user-select: none;
`, tDt = q(eSe)`
  .monaco-editor {
    .margin {
      background-color: #f4f4f4;
    }
    .monaco-editor-background {
      background-color: #f4f4f4;
    }
  }
`, nDt = q.section`
  position: relative;
  min-width: 0; // https://github.com/microsoft/monaco-editor/issues/3393
`, iDt = {
  minimap: {
    enabled: !1
  },
  fontSize: 13,
  lineHeight: 20,
  fontFamily: '"IBM Plex Mono", "Droid Sans Mono", "monospace", monospace, "Droid Sans Fallback"',
  formatOnPaste: !0,
  formatOnType: !0,
  tabSize: 2,
  wordWrap: "on",
  scrollBeyondLastLine: !1,
  overviewRulerBorder: !1
}, dV = ({
  value: r,
  isVisible: e,
  placeholder: t,
  onChange: n,
  readOnly: i = !1,
  onValidate: s = () => {
  },
  onMount: o = () => {
  },
  height: a = "30vh",
  width: l = "100%",
  hasJSONObjectValidation: c = !1,
  dataTestId: d
}) => {
  const f = bn(Cr).monacoLoaderConfig, [p, g] = ye(null), m = r === "" && t !== void 0;
  return Pe(() => {
    $Mt(f).then((A) => {
      g(A);
    });
  }, [f]), Fg(() => {
    e && c ? p?.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemaValidation: "error",
      schemaRequest: "error",
      validate: !0,
      schemas: [
        {
          uri: "",
          fileMatch: ["*"],
          schema: {
            type: "object"
          }
        }
      ]
    }) : p?.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemaValidation: "error",
      schemaRequest: "error"
    });
  }, [p, c, e]), p === null ? null : /* @__PURE__ */ x.jsxs(nDt, { children: [
    /* @__PURE__ */ x.jsx(
      tDt,
      {
        "data-testid": d,
        options: { ...iDt, readOnly: i },
        language: "json",
        value: r,
        height: a,
        width: l,
        theme: "light",
        onChange: (A) => {
          n?.(A ?? "");
        },
        onMount: (A) => {
          A.focus(), o({
            showMarkers: () => {
              A.trigger("", "editor.action.marker.next", void 0), A.trigger("", "editor.action.marker.prev", void 0);
            },
            hideMarkers: () => {
              A.trigger("", "closeMarkersNavigation", void 0);
            }
          });
        },
        onValidate: (A) => {
          s(A.length === 0);
        }
      }
    ),
    m && /* @__PURE__ */ x.jsx(eDt, { className: "monaco-placeholder", children: t })
  ] });
}, rDt = q(M1)`
  h3 {
    font-weight: 400;
  }
`, sDt = q.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, oDt = ({
  isVisible: r,
  onClose: e,
  onSubmit: t,
  validateVariableName: n
}) => {
  const [i, s] = ye(
    null
  ), [o, a] = ye(!0), [l, c] = ye(""), [d, u] = ye(""), f = An(null);
  return Pe(() => {
    r || (c(""), u(""), s(null), a(!0));
  }, [r]), Pe(() => {
    o && f.current?.hideMarkers();
  }, [o]), /* @__PURE__ */ x.jsx(
    rDt,
    {
      open: r,
      size: "md",
      modalHeading: "Add variable",
      primaryButtonText: "Add",
      secondaryButtonText: "Cancel",
      onRequestClose: e,
      onRequestSubmit: () => {
        o ? t?.(
          l,
          d === "" ? void 0 : d
        ) : f.current?.showMarkers();
      },
      primaryButtonDisabled: i !== null || !o,
      preventCloseOnClickOutside: !0,
      children: /* @__PURE__ */ x.jsxs(sDt, { children: [
        /* @__PURE__ */ x.jsx(
          ha,
          {
            id: "variable-name",
            size: "md",
            labelText: "Variable name",
            autoFocus: !0,
            invalid: i !== null,
            invalidText: i,
            value: l,
            onBlur: (p) => {
              const g = n(p.target.value);
              g.isValid ? s(null) : s(g.error);
            },
            onChange: (p) => {
              c(p.target.value);
            }
          }
        ),
        /* @__PURE__ */ x.jsx(K4, { children: "Variable value" }),
        /* @__PURE__ */ x.jsx(
          dV,
          {
            dataTestId: "new-variable-value",
            value: d,
            isVisible: r,
            height: "10vh",
            onChange: (p) => {
              const g = p ?? "";
              u(g), a(v8(g));
            },
            onValidate: a,
            onMount: (p) => {
              f.current = p;
            }
          }
        )
      ] })
    }
  );
}, aDt = q(Fxe)`
  h3 {
    font-weight: 400;
  }
`, lDt = q(zxe)`
  ${({ $enableContentOverflow: r }) => r && rs`
      overflow: unset;
    `}
`, cDt = q(Rn)`
  ${({ $hasIcon: r }) => r && rs`
      padding-right: 15px;
    `}
`, jy = ({
  title: r,
  size: e = "md",
  readOnly: t = !1,
  isVisible: n,
  isPrimaryButtonDisabled: i = !1,
  enableContentOverflow: s = !1,
  primaryButtonLabel: o,
  secondaryButton: a,
  ghostButton: l,
  onClose: c,
  onSubmit: d,
  modalBody: u
}) => un(
  /* @__PURE__ */ x.jsxs(
    Wxe,
    {
      open: n,
      preventCloseOnClickOutside: !t,
      onClose: c,
      size: e,
      "aria-label": r,
      children: [
        /* @__PURE__ */ x.jsx(aDt, { title: r, closeModal: c }),
        /* @__PURE__ */ x.jsx(lDt, { tabIndex: 0, $enableContentOverflow: s, children: u }),
        !t && /* @__PURE__ */ x.jsxs(jxe, { children: [
          l !== void 0 && /* @__PURE__ */ x.jsx(Rn, { kind: "ghost", onClick: l.onClick, children: l.label }),
          a !== void 0 && /* @__PURE__ */ x.jsx(
            cDt,
            {
              kind: "secondary",
              onClick: a.onClick,
              renderIcon: () => a.icon,
              id: a.id,
              $hasIcon: a.icon !== void 0,
              disabled: a.disabled,
              title: a.title,
              children: a.label
            }
          ),
          /* @__PURE__ */ x.jsx(
            Rn,
            {
              kind: "primary",
              disabled: i,
              onClick: d,
              children: o
            }
          )
        ] })
      ]
    }
  ),
  document.querySelector("[data-test='zeebe-play']") ?? document.body
), Ww = ({
  title: r,
  isValidInput: e,
  isVisible: t,
  primaryButtonLabel: n,
  secondaryButtonLabel: i,
  hasResetButton: s,
  value: o = "",
  placeholder: a,
  size: l = "md",
  onClose: c,
  onReset: d,
  onSubmit: u,
  readOnly: f = !1,
  hasJSONObjectValidation: p = !1,
  editorTopContent: g = !1,
  onChange: m,
  clearOnReset: A = !0
}) => {
  const [w, v] = ye(o), [y, _] = ye(!0), S = An(null);
  return Pe(() => {
    t ? v(o) : (v(""), _(!0));
  }, [t, o]), Pe(() => {
    y && S.current?.hideMarkers();
  }, [y]), /* @__PURE__ */ x.jsx(
    jy,
    {
      title: r,
      readOnly: f,
      size: l,
      isVisible: t,
      isPrimaryButtonDisabled: !y,
      primaryButtonLabel: n,
      secondaryButton: {
        label: i,
        onClick: () => {
          c?.();
        }
      },
      ghostButton: s ? {
        label: "Reset",
        onClick: () => {
          d?.(), A && v("");
        }
      } : void 0,
      onClose: c,
      onSubmit: () => {
        y ? u?.(w === "" ? void 0 : w) : S.current?.showMarkers();
      },
      modalBody: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
        g,
        /* @__PURE__ */ x.jsx(
          dV,
          {
            value: w,
            isVisible: t,
            placeholder: a,
            onChange: (D) => {
              const M = D ?? "";
              v(M), _(e(M)), m?.(M);
            },
            readOnly: f,
            onValidate: _,
            onMount: (D) => {
              S.current = D;
            },
            hasJSONObjectValidation: p
          }
        )
      ] })
    }
  );
}, hDt = rt(({ selectedScope: r, isActive: e }) => {
  const t = bn(Cr), [n, i] = ye(null), [s, o] = ye(""), [a, l] = ye(!1), [c, d] = ye(!1), [u, f] = ye(!1), p = tl.state.isUpdatingVariable, { instanceKey: g, processInstance: m } = Kt.state, A = tl.state.variables.filter(
    (w) => w.scope.key === r
  );
  return Pe(() => {
    e || i(null);
  }, [e]), Pe(() => {
    p || i(null);
  }, [p]), Pe(() => {
    i(null);
  }, [r]), /* @__PURE__ */ x.jsxs(Zdt, { children: [
    /* @__PURE__ */ x.jsx(Zxe, { children: /* @__PURE__ */ x.jsx(Uxe, { "aria-label": "Variables", children: /* @__PURE__ */ x.jsx(qxe, { children: "Variables" }) }) }),
    /* @__PURE__ */ x.jsxs(Udt, { $isEmpty: A.length === 0, children: [
      A.length === 0 && /* @__PURE__ */ x.jsx(qdt, { children: nh.isRootNodeSelected ? "This process instance has no variables" : "The flow node has no variables" }),
      A.length > 0 && /* @__PURE__ */ x.jsxs(Gdt, { children: [
        /* @__PURE__ */ x.jsx(Qdt, { children: /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(Ydt, { children: "Name" }),
          /* @__PURE__ */ x.jsx(Xdt, { children: "Value" }),
          /* @__PURE__ */ x.jsx(Jdt, {})
        ] }) }),
        /* @__PURE__ */ x.jsx(Kdt, { children: A.map((w) => /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(eut, { title: w.name, children: w.name }),
          /* @__PURE__ */ x.jsx(tut, { children: /* @__PURE__ */ x.jsx(Wg, { children: /* @__PURE__ */ x.jsx(
            iut,
            {
              type: "multi",
              wrapText: !0,
              maxCollapsedNumberOfRows: 3,
              maxExpandedNumberOfRows: 3,
              minExpandedNumberOfRows: 0,
              minCollapsedNumberOfRows: 0,
              children: EMe(w.value, "  ")
            }
          ) }) }),
          /* @__PURE__ */ x.jsx($dt, { children: n?.name === w.name && (p || a) ? /* @__PURE__ */ x.jsx(nut, {}) : /* @__PURE__ */ x.jsx(x.Fragment, { children: e ? /* @__PURE__ */ x.jsx(
            lve,
            {
              onClick: () => {
                o(`Edit "${w.name}" variable`), d(!0), i(w);
              },
              hasIconOnly: !0,
              renderIcon: hI,
              iconDescription: "Edit",
              size: "sm",
              kind: "ghost"
            }
          ) : /* @__PURE__ */ x.jsx(
            lve,
            {
              onClick: () => {
                o(`View "${w.name}" variable`), d(!0), i(w);
              },
              hasIconOnly: !0,
              renderIcon: M7,
              iconDescription: "View",
              size: "sm",
              kind: "ghost"
            }
          ) }) })
        ] }, w.name)) })
      ] })
    ] }),
    /* @__PURE__ */ x.jsx(
      Rn,
      {
        onClick: () => {
          f(!0);
        },
        renderIcon: E7,
        iconDescription: "Add variable",
        size: "md",
        kind: "ghost",
        disabled: !e || n !== null,
        children: "Add variable"
      }
    ),
    /* @__PURE__ */ x.jsx(
      Ww,
      {
        isVisible: c,
        value: n?.value ?? void 0,
        title: s,
        primaryButtonLabel: "Apply",
        secondaryButtonLabel: "Cancel",
        readOnly: !e,
        onSubmit: async (w) => {
          if (d(!1), n === null || w === void 0)
            return;
          l(!0);
          const v = JSON.stringify({
            [n.name]: JSON.parse(w)
          }), y = await tl.setVariables({
            instanceKey: g,
            scope: r,
            variablesString: v
          });
          y && m !== void 0 && is(Lr(m.key), {
            action: "setVariables",
            variables: v
          }), y || t.displayNotification?.error(Mi), l(!1), i(null);
        },
        onClose: () => {
          d(!1), i(null);
        },
        isValidInput: v8
      }
    ),
    /* @__PURE__ */ x.jsx(
      oDt,
      {
        isVisible: u,
        validateVariableName: (w) => w === "" ? {
          isValid: !1,
          error: "Enter a variable name"
        } : w.includes('"') || w.includes(" ") ? {
          isValid: !1,
          error: "Variable contains invalid characters. Use only alphabets, numbers and dashes (-)"
        } : A.some(({ name: v }) => v === w) ? {
          isValid: !1,
          error: "A variable with this name already exists. Please enter another name."
        } : { isValid: !0 },
        onSubmit: async (w, v) => {
          if (f(!1), v === void 0)
            return;
          l(!0);
          const y = JSON.stringify({
            [w]: JSON.parse(v)
          }), _ = await tl.setVariables({
            instanceKey: g,
            scope: r,
            variablesString: y
          });
          _ && m !== void 0 && is(Lr(m.key), {
            action: "setVariables",
            variables: y
          }), _ || t.displayNotification?.error(Mi), l(!1), i(null);
        },
        onClose: () => {
          f(!1), i(null);
        }
      }
    )
  ] });
}), dDt = q.div`
  display: flex;
  flex-direction: row;

  position: relative;
`, uDt = q.div`
  position: absolute;
  top: -3px;
  height: 6px;
  width: 100%;
  z-index: 1;

  cursor: ns-resize;
  transition: background-color 0.2s;

  ${({ $isResizing: r }) => r && "background-color: var(--cm-color-blue-base, #4d90ff);"};

  &:hover {
    background-color: var(--cm-color-blue-base, #4d90ff);
  }
`, fDt = q.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--cds-layer);
  border-right: 1px solid rgb(216, 220, 227);
  border-top: 1px solid rgb(216, 220, 227);
`, pDt = q.div`
  padding: 11px 16px;
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.16px;
  border-bottom: solid 1px var(--cds-border-subtle-01);
`, gDt = q.div`
  overflow: auto;

  .cds--tree-parent-node > .cds--tree-node__label {
    margin-inline-start: -1rem;
    padding-inline-start: 1rem;
  }

  .cds--tree-node__label {
    position: relative;

    margin-inline-start: -3.5rem;
    padding-inline-start: 3.5rem;

    > span:first-child {
      margin-inline-start: 30px;
    }
    > .cds--tree-parent-node__toggle:first-child {
      margin-inline-start: 22px;
    }
  }
`, mDt = q(Gxe)`
  .cds--tree-node__label__details {
    width: 100%;
  }
`, ADt = q.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0 16px 0 12px;
`, wDt = q.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  position: absolute;
  left: 16px;
  padding-top: 1px;
`, vDt = q.span`
  font-size: 16px;
  margin-top: -3px;
  transform: translateY(1px);
`;
function bDt({ type: r }) {
  switch (r) {
    case "PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-participant" });
    case "START_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-start-event-none" });
    case "SEQUENCE_FLOW":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-connection" });
    case "SERVICE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-service-task" });
    case "EXCLUSIVE_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-xor" });
    case "INCLUSIVE_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-or" });
    case "PARALLEL_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-parallel" });
    case "EVENT_BASED_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-eventbased" });
    case "SUB_PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-subprocess-expanded" });
    case "EVENT_SUB_PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-event-subprocess-expanded" });
    case "INTERMEDIATE_CATCH_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "INTERMEDIATE_THROW_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "BOUNDARY_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "END_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-end-event-none" });
    case "RECEIVE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-receive-task" });
    case "USER_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-user-task" });
    case "MANUAL_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-manual-task" });
    case "MULTI_INSTANCE_BODY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-parallel-mi-marker" });
    case "CALL_ACTIVITY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-subprocess-collapsed" });
    case "BUSINESS_RULE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-business-rule-task" });
    case "SCRIPT_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-script-task" });
    case "SEND_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-send-task" });
    default:
      return "?";
  }
}
const yDt = q(o7)`
  ${({ $isVisible: r }) => rs`
    min-width: 118px;
    transition: opacity 0.2s ease-in-out;
    opacity: ${r ? "1" : "0"};
    margin-top: 0;
    margin-bottom: 0;
  `}
`, CDt = ({ scopeKey: r }) => {
  const [e, t] = ye(!1), n = An(null);
  return Pe(() => {
    const i = ms(
      () => tl.state.variables,
      (s, o) => {
        [
          ...s.filter(
            ({ key: l }) => !o.some(({ key: c }) => c === l)
          ),
          ...s.filter((l) => {
            const c = o.find(
              ({ key: d }) => d === l.key
            );
            return c === void 0 ? !1 : c.updates.length < l.updates.length;
          })
        ].map((l) => l.scope.key).includes(r) && (t(!0), n.current !== null && clearTimeout(n.current), n.current = setTimeout(() => {
          t(!1);
        }, 3e3));
      }
    );
    return () => {
      i();
    };
  }, [e, r]), /* @__PURE__ */ x.jsx(yDt, { size: "sm", type: "green", $isVisible: e, children: "Variable modified" });
}, nIe = rt(
  ({ instance: r, hasIncident: e, childNodes: t, isSelected: n, ...i }) => {
    const s = r.key === Kt.state.processInstance?.key;
    return /* @__PURE__ */ Hxe(
      mDt,
      {
        ...i,
        key: r.key,
        id: r.key,
        value: r.key,
        selected: n ? [r.key] : [],
        active: n ? r.key : void 0,
        renderIcon: () => /* @__PURE__ */ x.jsx(vDt, { children: /* @__PURE__ */ x.jsx(bDt, { type: r.element.bpmnElementType }) }),
        onSelect: () => {
          nh.selectFlowNode({
            flowNodeId: s ? void 0 : r.element.elementId,
            flowNodeInstanceId: r.key,
            isMultiInstance: r.element.bpmnElementType === "MULTI_INSTANCE_BODY"
          });
        },
        label: /* @__PURE__ */ x.jsxs(ADt, { children: [
          /* @__PURE__ */ x.jsx(wDt, { children: /* @__PURE__ */ x.jsx(
            AI,
            {
              state: e ? "INCIDENT" : r.state,
              size: 16
            }
          ) }),
          r.element.elementName || r.element.elementId,
          /* @__PURE__ */ x.jsx(CDt, { scopeKey: r.key })
        ] }),
        isExpanded: !0
      },
      t.length > 0 && t.map((o) => /* @__PURE__ */ x.jsx(
        nIe,
        {
          instance: o.instance,
          hasIncident: o.hasIncident,
          childNodes: o.childNodes,
          isSelected: o.isSelected
        },
        o.instance.key
      ))
    );
  }
), EDt = rt(({ flowNodeInstances: r }) => {
  const [e, t] = ye(
    () => +(localStorage.getItem("play-bottom-bar-height") ?? 0) || 255
  ), [n, i] = ye(!1), s = An();
  Pe(() => {
    localStorage.setItem("play-bottom-bar-height", e.toString());
  }, [e]);
  const o = {}, a = [], l = uf.state.incidents, c = Kt.state.processInstance;
  for (let u = 0; u < r.length; u++) {
    const f = r[u], p = {
      instance: f,
      childNodes: [],
      hasIncident: (f.element.bpmnElementType === "PROCESS" && (c?.incidents.length ?? 0) > 0 || l?.some(
        (g) => g.elementInstance.key === f.key && g.state === "CREATED"
      )) ?? !1,
      isSelected: nh.isSelected({
        flowNodeInstanceId: f.key,
        flowNodeId: f.element.elementId,
        isMultiInstance: f.element.bpmnElementType === "MULTI_INSTANCE_BODY"
      })
    };
    o[f.key] = p, f.scope?.key ? o[f.scope.key].childNodes.push(p) : a.push(p);
  }
  function d(u) {
    u.preventDefault(), i(!0);
    const p = u.target.parentNode;
    s.current = {
      originalSize: p.clientHeight,
      dragStart: u.pageY
    };
    const g = (A) => {
      t(
        Math.max(
          10,
          (s.current?.originalSize ?? 0) + (s.current?.dragStart ?? 0) - A.pageY
        )
      );
    }, m = () => {
      i(!1), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", m);
    };
    document.addEventListener("mousemove", g), document.addEventListener("mouseup", m);
  }
  return /* @__PURE__ */ x.jsxs(dDt, { style: { height: e + "px" }, children: [
    /* @__PURE__ */ x.jsx(uDt, { $isResizing: n, onMouseDown: d }),
    /* @__PURE__ */ x.jsxs(fDt, { children: [
      /* @__PURE__ */ x.jsx(pDt, { children: "Instance History" }),
      /* @__PURE__ */ x.jsx(gDt, { children: /* @__PURE__ */ x.jsx(Qxe, { hideLabel: !0, label: "Instance History", children: a.map((u) => /* @__PURE__ */ x.jsx(
        nIe,
        {
          instance: u.instance,
          hasIncident: u.hasIncident,
          childNodes: u.childNodes,
          isSelected: u.isSelected
        },
        u.instance.key
      )) }) })
    ] }),
    /* @__PURE__ */ x.jsx(
      hDt,
      {
        isActive: tl.scopeId === null ? !1 : o[tl.scopeId]?.instance.state === "ACTIVATED",
        selectedScope: tl.scopeId
      }
    )
  ] });
}), _Dt = q.div``, xDt = q.div`
  background: var(--silver-base-97, hsl(0, 0%, 97%));
  border-top: 1px solid var(--silver-darken-80, hsl(0, 0%, 80%));
  border-bottom: 1px solid var(--silver-darken-80, hsl(0, 0%, 80%));
  cursor: pointer;
`;
q.span`
  svg {
    vertical-align: middle;
  }
  margin-right: var(--spacing-small, 10px);
`;
const Tbe = q.span`
  vertical-align: middle;
`, SDt = q.div`
  padding: 32px;
`, MDt = q.div`
  color: var(--text-text-primary, #161616);
  /* Fixed heading styles/heading-03 */
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */

  margin-bottom: 8px;
`, DDt = q.div`
  color: var(--text-text-secondary, #525252);
  /* Utility styles/helper-text-02 */
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.16px;
`;
q.span`
  float: right;
  cursor: pointer;
  ${({ isCollapsed: r }) => r && " svg { transform: rotate(180deg); } "}
  padding: 7px 10px;
  height: 36px;

  border-radius: 4px;
  :hover {
    background: var(--silver-darken-87, hsl(0, 0%, 87%));
  }
`;
const Ibe = q.div`
  display: inline-block;
  cursor: pointer;
  padding: 6px 18px 4px 18px;
  font-weight: ${(r) => r.$isActive && !r.isErrorPanelCollapsed ? "500" : ""};
  border-bottom: ${(r) => r.$isActive && !r.isErrorPanelCollapsed ? "2px solid var(--cds-blue-60, #0f62fe)" : ""};
  margin-left: 12px;
  height: 38px;
`;
q.span`
  background-color: var(--grey-base-40, hsl(0, 0%, 40%));
  border-radius: 10px;
  font-weight: bold;
  font-size: 10px;
  color: white;
  display: inline-block;
  margin-left: 6px;
  padding: 1px 6px;

  @media (max-width: 2000px) {
    font-size: 10px;
  }
`;
q.div`
  float: right;
`;
const LDt = q.div`
  height: 200px;
  width: 100%;
  overflow-y: auto;
  background: white;
`, kDt = q.div`
  display: inline-block;
  margin-right: 16px;
  margin-top: -10px;
  transform: translateY(4px);
`, NDt = q(ji)`
  color: #0f62fe;
  font-size: 14px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  height: 20px;
`, TDt = q(o7)`
  min-inline-size: 24px;
`, IDt = (r = "", e = "new-diagram") => {
  const t = r?.normalize().replace(/[^_0-9\p{Letter}\p{Mark}]+/gu, "-").replace(/-+/g, "-").replace(/(^-|-$)/g, "").toLowerCase();
  return t === "" ? e : t;
}, ODt = "--", iIe = (r, e) => r + ODt + IDt(e);
q.div`
  color: var(--text-text-secondary, #525252);

  /* Utility styles/label-01 */
  font-family: IBM Plex Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.32px;
`;
const RDt = q.div`
  color: var(--text-text-primary, #161616);

  /* Fixed heading styles/heading-03 */
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */

  margin-bottom: 16px;
`;
function VDt(r) {
  const e = [];
  return r.forEach((t) => {
    const i = an(t).extensionElements.values.filter((s) => s.$type === "zeebe:IoMapping").reduce(
      (s, o) => {
        const a = o?.inputParameters.flatMap((l) => {
          let c;
          const d = [], u = /(\{\{\s*secrets\.(?<newSyntax>\S+?\s*)}})|(secrets\.(?<oldSyntax>([a-zA-Z0-9]+[\\/._-])*[a-zA-Z0-9]+))/g;
          for (; (c = u.exec(
            l?.source ?? ""
          )) !== null; )
            c.groups?.newSyntax ? d.push(c.groups.newSyntax.trim()) : c.groups?.oldSyntax && d.push(c.groups.oldSyntax);
          return d;
        })?.filter(
          (l) => l !== void 0
        ) ?? [];
        return s.push(...a), s;
      },
      []
    );
    i.length && e.push({
      element: t,
      secrets: [...new Set(i)]
    });
  }), e;
}
const Obe = {
  existingSecrets: [],
  connectorElements: [],
  connectorElementsWithSecrets: [],
  isReady: !1
};
let HDt = class {
  state = { ...Obe };
  constructor() {
    Hi(this);
  }
  setupConnectors = async () => {
    this.setIsReady(!1);
    const e = mi.elements?.filter((n) => {
      const i = an(n);
      return Object.hasOwn(i, "modelerTemplate") || Object.hasOwn(i?.$attrs, "zeebe:modelerTemplate");
    }) ?? [], t = VDt(e);
    this.setConnectorElements(e), this.setConnectorElementsWithSecrets(t), await this.fetchAndSetConnectorSecrets(), await this.setMissingSecretsFromCache(), this.setIsReady(!0);
  };
  setIsReady = (e) => {
    this.state.isReady = e;
  };
  setExistingSecrets = (e) => {
    this.state.existingSecrets = e;
  };
  setConnectorElements = (e) => {
    this.state.connectorElements = e;
  };
  setConnectorElementsWithSecrets = (e) => {
    this.state.connectorElementsWithSecrets = e;
  };
  fetchAndSetConnectorSecrets = async () => {
    const { secrets: e } = await _t.getConnectorSecrets();
    this.setExistingSecrets(e);
  };
  get missingSecrets() {
    return new Set(
      ...this.connectorElementsWithMissingSecrets.flatMap(
        ({ missingSecrets: e }) => e
      )
    );
  }
  setMissingSecretsFromCache = async () => {
    const e = [...this.missingSecrets].flatMap((t) => {
      const n = cMe(t);
      return n ? [{ secretName: t, secretValue: n }] : [];
    });
    for (const { secretName: t, secretValue: n } of e)
      await this.setConnectorSecret(t, n);
  };
  get connectorElementsWithMissingSecrets() {
    const e = [];
    return this.state.connectorElementsWithSecrets.forEach(({ element: t, secrets: n }) => {
      const i = n.filter(
        (s) => !this.state.existingSecrets.some(
          ({ name: o, value: a }) => o === s && a.trim() !== ""
        )
      );
      i.length > 0 && e.push({ element: t, missingSecrets: i });
    }), e;
  }
  setConnectorSecret = async (e, t) => {
    if ((await _t.setConnectorSecret({ name: e, value: t }))?.success === !1)
      return !1;
    const i = [
      ...this.state.existingSecrets?.filter(
        (s) => s.name !== e
      ) ?? [],
      { name: e, value: t }
    ];
    return this.setExistingSecrets(i), !0;
  };
  addConnectorSecrets = async (e) => {
    if ((await Promise.all(
      e.map((i) => _t.setConnectorSecret({
        name: i.name,
        value: i.value
      }))
    )).some((i) => !i.success))
      return !1;
    const n = [
      ...this.state.existingSecrets?.filter(
        (i) => !e.some((s) => s.name === i.name)
      ) ?? [],
      ...e
    ];
    return this.setExistingSecrets(n), !0;
  };
  reset = () => {
    this.state = { ...Obe };
  };
};
const mh = new HDt(), uV = rt(({ children: r, secrets: e }) => {
  const t = bn(Cr), [n, i] = ye(!1), [s, o] = ye(!1), a = An(null), {
    state: { existingSecrets: l }
  } = mh, c = ds(
    () => e.reduce(
      (f, p) => ({
        ...f,
        [p]: l.find(({ name: g }) => g === p)?.value ?? cMe(p) ?? ""
      }),
      {}
    ),
    [e, l]
  ), [d, u] = ye(c);
  return Pe(() => {
    u(c);
  }, [c]), Pe(() => {
    n && (a.current?.focus(), o(!1));
  }, [n]), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx("div", { onClick: () => i(!0), children: r }),
    /* @__PURE__ */ x.jsxs(
      tn,
      {
        open: n,
        onClose: () => i(!1),
        maxWidth: 640,
        children: [
          /* @__PURE__ */ x.jsxs(tn.Content, { children: [
            /* @__PURE__ */ x.jsx(RDt, { children: "Update Connector Secrets" }),
            /* @__PURE__ */ x.jsx(In, { gap: 6, children: e.map((f, p) => (
              /* @ts-expect-error Property 'PasswordInput' does not exist on type 'ForwardRefExoticComponent<TextInputProps & RefAttributes<unknown>>'.ts(2339) */
              /* @__PURE__ */ x.jsx(
                ha.PasswordInput,
                {
                  id: `secret-${f}`,
                  value: d[f],
                  labelText: `Set value for "${f}"`,
                  autoComplete: "false",
                  disabled: s,
                  onChange: (g) => {
                    u((m) => ({
                      ...m,
                      [f]: g.target.value
                    }));
                  },
                  ref: p === 0 ? a : null
                },
                f
              )
            )) })
          ] }),
          /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
            /* @__PURE__ */ x.jsx(ji, { onClick: () => i(!1), variant: "secondary", children: "Cancel" }),
            /* @__PURE__ */ x.jsx(
              ji,
              {
                disabled: s,
                onClick: async () => {
                  o(!0);
                  const f = Object.entries(d).map(
                    ([g, m]) => ({ name: g, value: m })
                  );
                  await mh.addConnectorSecrets(f) || t.displayNotification?.error(Mi), o(!1), i(!1);
                },
                variant: "primary",
                children: "Update"
              }
            )
          ] })
        ]
      }
    )
  ] });
});
uV.displayName = "EditConnectorModal";
const BDt = q.div`
  height: 30px;
  margin: 5px 10px;
`, PDt = q($ht)`
  width: 20px;
  vertical-align: middle;
`, FDt = q.span`
  margin-left: 5px;
  vertical-align: middle;
`, zDt = q(wMe)`
  margin-right: 16px;
  fill: #da1e28;
  float: left;
`, WDt = q(dI)`
  margin-right: 16px;
  fill: #da1e28;
  float: left;
`, jDt = q.div`
  margin-right: 16px;
  width: 16px;
  height: 16px;
  background-color: #da1e28;
  float: left;
  padding: 1px;
`, ZDt = q(x7)`
  fill: white;
  width: 14px;
  height: 14px;
`, UDt = q(ji)`
  height: 18px;
  color: var(--link-link-primary, #0f62fe);
  font-weight: 400;
`, qDt = rt(() => {
  const { fileProblems: r } = kt, e = mh.connectorElementsWithMissingSecrets.flatMap(
    ({ element: t, missingSecrets: n }) => n.map((i) => ({ element: t, missingSecret: i }))
  ) ?? [];
  return r.length === 0 && e.length === 0 ? /* @__PURE__ */ x.jsxs(BDt, { children: [
    /* @__PURE__ */ x.jsx(PDt, {}),
    /* @__PURE__ */ x.jsx(FDt, { children: "No problems found." })
  ] }) : /* @__PURE__ */ x.jsxs(Y4, { size: "sm", children: [
    /* @__PURE__ */ x.jsx(X4, { children: /* @__PURE__ */ x.jsxs(ko, { children: [
      /* @__PURE__ */ x.jsx(to, { children: "Element Name" }),
      /* @__PURE__ */ x.jsx(to, { children: "Error Message" }),
      /* @__PURE__ */ x.jsx(to, { children: "File Name" }),
      /* @__PURE__ */ x.jsx(to, { children: "Actionable Solutions" })
    ] }) }),
    /* @__PURE__ */ x.jsxs(J4, { children: [
      r.map((t) => /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsxs(di, { children: [
          t.status === "not found" && /* @__PURE__ */ x.jsx(zDt, {}),
          t.status === "deployment error" && /* @__PURE__ */ x.jsx(WDt, {}),
          /* @__PURE__ */ x.jsx("b", { children: t.element.businessObject.name || t.element.businessObject.id })
        ] }),
        /* @__PURE__ */ x.jsxs(di, { children: [
          t.status === "not found" && "File not found",
          t.status === "deployment error" && "Deployment error"
        ] }),
        /* @__PURE__ */ x.jsx(di, { children: t.filename || t.id }),
        /* @__PURE__ */ x.jsxs(di, { children: [
          t.status === "not found" && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            "Verify file path or check file permissions.",
            " ",
            /* @__PURE__ */ x.jsx(
              "a",
              {
                href: `https://docs.camunda.io/docs/components/modeler/web-modeler/advanced-modeling/${t.type === "decision" ? "business-rule-task" : "call-activity"}-linking/`,
                target: "_blank",
                rel: "noreferrer",
                children: "See how"
              }
            )
          ] }),
          t.status === "deployment error" && /* @__PURE__ */ x.jsx(
            Cdt,
            {
              href: `/diagrams/${iIe(
                t.fileId,
                t.filename
              )}`,
              target: "_blank",
              children: "Go to file and fix problems"
            }
          )
        ] })
      ] }, t.id + Math.random().toString())),
      e.map((t) => /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsxs(di, { children: [
          /* @__PURE__ */ x.jsx(jDt, { children: /* @__PURE__ */ x.jsx(ZDt, {}) }),
          /* @__PURE__ */ x.jsx("b", { children: t.element.businessObject.name || t.element.businessObject.id })
        ] }),
        /* @__PURE__ */ x.jsx(di, { children: `Secret "${t.missingSecret}" missing` }),
        /* @__PURE__ */ x.jsx(di, { children: "-" }),
        /* @__PURE__ */ x.jsx(di, { children: /* @__PURE__ */ x.jsx(uV, { secrets: [t.missingSecret], children: /* @__PURE__ */ x.jsx(UDt, { variant: "text", children: "Update connector secret" }) }) })
      ] }, Math.random().toString()))
    ] })
  ] });
}), GDt = rt(() => {
  const {
    state: { playId: r },
    fileProblems: e
  } = kt, t = mh.connectorElementsWithMissingSecrets.flatMap(
    ({ missingSecrets: c }) => c
  ), n = e.length + t.length, [i, s] = ye(
    n > 0 ? "problems" : "instances"
  ), { instanceKey: o } = Kt.state;
  Pe(() => {
    !o && r && MM.fetchInstances({
      id: r
    });
  }, [o, r]);
  const a = Ro.state.elementInstances?.elementInstances?.filter(
    (c) => c.element.bpmnElementType !== "SEQUENCE_FLOW"
  ), l = MM.state.process;
  return o && a ? /* @__PURE__ */ x.jsx(EDt, { flowNodeInstances: a }) : /* @__PURE__ */ x.jsxs(_Dt, { children: [
    /* @__PURE__ */ x.jsxs(xDt, { children: [
      /* @__PURE__ */ x.jsx(
        Ibe,
        {
          $isActive: i === "instances",
          onClick: () => s("instances"),
          children: /* @__PURE__ */ x.jsx(Tbe, { children: "Process Instances" })
        }
      ),
      /* @__PURE__ */ x.jsx(
        Ibe,
        {
          $isActive: i === "problems",
          onClick: () => s("problems"),
          children: /* @__PURE__ */ x.jsxs(Tbe, { children: [
            "Problems",
            " ",
            n > 0 && /* @__PURE__ */ x.jsx(
              TDt,
              {
                type: "red",
                title: n.toString(),
                size: "sm",
                children: n.toString()
              }
            )
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ x.jsx(LDt, { children: i === "instances" ? (l?.length ?? 0) > 0 ? /* @__PURE__ */ x.jsxs(Y4, { size: "sm", children: [
      /* @__PURE__ */ x.jsx(X4, { children: /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsx(to, { width: "300", children: "Instance Key" }),
        /* @__PURE__ */ x.jsx(to, { children: "Started at" }),
        /* @__PURE__ */ x.jsx(to, { children: "Operations" })
      ] }) }),
      /* @__PURE__ */ x.jsx(J4, { children: l?.map(({ key: c, startTime: d, state: u, incidents: f }) => {
        const p = f.length > 0;
        return /* @__PURE__ */ x.jsxs(ko, { children: [
          /* @__PURE__ */ x.jsxs(di, { children: [
            /* @__PURE__ */ x.jsx(kDt, { children: /* @__PURE__ */ x.jsx(
              AI,
              {
                state: p ? "INCIDENT" : u,
                size: 20
              }
            ) }),
            /* @__PURE__ */ x.jsx(
              NDt,
              {
                variant: "text",
                onClick: () => {
                  Kt.setInstanceDetails({
                    instanceKey: c,
                    instanceType: "EXISTING_INSTANCE"
                  });
                },
                children: c
              }
            )
          ] }),
          /* @__PURE__ */ x.jsx(di, { children: bMe(d) }),
          /* @__PURE__ */ x.jsx(di, { children: "-" })
        ] }, c);
      }) ?? /* @__PURE__ */ x.jsx(ko, { children: /* @__PURE__ */ x.jsx(di, { children: "No Content" }) }) })
    ] }) : /* @__PURE__ */ x.jsxs(SDt, { children: [
      /* @__PURE__ */ x.jsx(MDt, { children: "Start by activating a process instance" }),
      /* @__PURE__ */ x.jsx(DDt, { children: "To activate an instance, click the Play button on the canvas" })
    ] }) : /* @__PURE__ */ x.jsx(qDt, {}) })
  ] });
}), QDt = "data:video/mp4;base64,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", Rbe = q.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: rgba(22, 22, 22, 0.5);
  z-index: 1;
`, KDt = q(In)`
  background-color: #f4f4f4;
  width: 100%;
  padding: 88px;
`, YDt = q.h4`
  color: var(--cds-text-secondary, #161616);

  /* Fixed heading styles/heading-03 */
  font-family: IBM Plex Sans;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 28px !important; /* 140% */
`, XDt = q.div`
  color: var(--cds-text-secondary, #525252);

  /* Fixed Body styles/body-01 */
  font-family: IBM Plex Sans;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 20px !important; /* 142.857% */
  letter-spacing: 0.16px !important;
`, Vbe = q.div`
  background-color: white;
  width: 640px;
  margin: 100px auto;

  .cds--progress-bar__label-text {
    visibility: hidden;
  }
`, Hbe = q.div`
  padding: 16px;
`, Bbe = q.div`
  text-align: right;
`, w5 = q(Rn)`
  width: 320px;
`;
q.div`
  background: #f6f8f5;
  height: 253px;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #000;

  text-align: center;
  /* Body styles/body-02 */
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  margin-bottom: 8px;
`;
const JDt = q.video`
  width: 100%;
  height: 100%;
`;
function $Dt({
  isClusterReady: r,
  isDeployingFiles: e,
  hasDiagramError: t,
  hasProblems: n
}) {
  return r ? e ? "Auto-deploying supporting files..." : t ? `The diagram failed to deploy.
Please check the Output tab in the Implement mode for more details.` : n ? "Some parts of your process will not work. Please check the problems tab for actionable solutions." : "Play environment is ready" : "Setting up a temporary cluster...";
}
/*! @vimeo/player v2.27.1 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function Pbe(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function Fbe(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pbe(Object(t), !0).forEach(function(n) {
      B6(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Pbe(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function Xs() {
  Xs = function() {
    return r;
  };
  var r = {}, e = Object.prototype, t = e.hasOwnProperty, n = Object.defineProperty || function(N, R, H) {
    N[R] = H.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
  function l(N, R, H) {
    return Object.defineProperty(N, R, {
      value: H,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), N[R];
  }
  try {
    l({}, "");
  } catch {
    l = function(R, H, z) {
      return R[H] = z;
    };
  }
  function c(N, R, H, z) {
    var U = R && R.prototype instanceof f ? R : f, ee = Object.create(U.prototype), ce = new T(z || []);
    return n(ee, "_invoke", {
      value: S(N, H, ce)
    }), ee;
  }
  function d(N, R, H) {
    try {
      return {
        type: "normal",
        arg: N.call(R, H)
      };
    } catch (z) {
      return {
        type: "throw",
        arg: z
      };
    }
  }
  r.wrap = c;
  var u = {};
  function f() {
  }
  function p() {
  }
  function g() {
  }
  var m = {};
  l(m, s, function() {
    return this;
  });
  var A = Object.getPrototypeOf, w = A && A(A(B([])));
  w && w !== e && t.call(w, s) && (m = w);
  var v = g.prototype = f.prototype = Object.create(m);
  function y(N) {
    ["next", "throw", "return"].forEach(function(R) {
      l(N, R, function(H) {
        return this._invoke(R, H);
      });
    });
  }
  function _(N, R) {
    function H(U, ee, ce, se) {
      var te = d(N[U], N, ee);
      if (te.type !== "throw") {
        var ue = te.arg, G = ue.value;
        return G && typeof G == "object" && t.call(G, "__await") ? R.resolve(G.__await).then(function(j) {
          H("next", j, ce, se);
        }, function(j) {
          H("throw", j, ce, se);
        }) : R.resolve(G).then(function(j) {
          ue.value = j, ce(ue);
        }, function(j) {
          return H("throw", j, ce, se);
        });
      }
      se(te.arg);
    }
    var z;
    n(this, "_invoke", {
      value: function(U, ee) {
        function ce() {
          return new R(function(se, te) {
            H(U, ee, se, te);
          });
        }
        return z = z ? z.then(ce, ce) : ce();
      }
    });
  }
  function S(N, R, H) {
    var z = "suspendedStart";
    return function(U, ee) {
      if (z === "executing") throw new Error("Generator is already running");
      if (z === "completed") {
        if (U === "throw") throw ee;
        return V();
      }
      for (H.method = U, H.arg = ee; ; ) {
        var ce = H.delegate;
        if (ce) {
          var se = D(ce, H);
          if (se) {
            if (se === u) continue;
            return se;
          }
        }
        if (H.method === "next") H.sent = H._sent = H.arg;
        else if (H.method === "throw") {
          if (z === "suspendedStart") throw z = "completed", H.arg;
          H.dispatchException(H.arg);
        } else H.method === "return" && H.abrupt("return", H.arg);
        z = "executing";
        var te = d(N, R, H);
        if (te.type === "normal") {
          if (z = H.done ? "completed" : "suspendedYield", te.arg === u) continue;
          return {
            value: te.arg,
            done: H.done
          };
        }
        te.type === "throw" && (z = "completed", H.method = "throw", H.arg = te.arg);
      }
    };
  }
  function D(N, R) {
    var H = R.method, z = N.iterator[H];
    if (z === void 0) return R.delegate = null, H === "throw" && N.iterator.return && (R.method = "return", R.arg = void 0, D(N, R), R.method === "throw") || H !== "return" && (R.method = "throw", R.arg = new TypeError("The iterator does not provide a '" + H + "' method")), u;
    var U = d(z, N.iterator, R.arg);
    if (U.type === "throw") return R.method = "throw", R.arg = U.arg, R.delegate = null, u;
    var ee = U.arg;
    return ee ? ee.done ? (R[N.resultName] = ee.value, R.next = N.nextLoc, R.method !== "return" && (R.method = "next", R.arg = void 0), R.delegate = null, u) : ee : (R.method = "throw", R.arg = new TypeError("iterator result is not an object"), R.delegate = null, u);
  }
  function M(N) {
    var R = {
      tryLoc: N[0]
    };
    1 in N && (R.catchLoc = N[1]), 2 in N && (R.finallyLoc = N[2], R.afterLoc = N[3]), this.tryEntries.push(R);
  }
  function L(N) {
    var R = N.completion || {};
    R.type = "normal", delete R.arg, N.completion = R;
  }
  function T(N) {
    this.tryEntries = [{
      tryLoc: "root"
    }], N.forEach(M, this), this.reset(!0);
  }
  function B(N) {
    if (N) {
      var R = N[s];
      if (R) return R.call(N);
      if (typeof N.next == "function") return N;
      if (!isNaN(N.length)) {
        var H = -1, z = function U() {
          for (; ++H < N.length; ) if (t.call(N, H)) return U.value = N[H], U.done = !1, U;
          return U.value = void 0, U.done = !0, U;
        };
        return z.next = z;
      }
    }
    return {
      next: V
    };
  }
  function V() {
    return {
      value: void 0,
      done: !0
    };
  }
  return p.prototype = g, n(v, "constructor", {
    value: g,
    configurable: !0
  }), n(g, "constructor", {
    value: p,
    configurable: !0
  }), p.displayName = l(g, a, "GeneratorFunction"), r.isGeneratorFunction = function(N) {
    var R = typeof N == "function" && N.constructor;
    return !!R && (R === p || (R.displayName || R.name) === "GeneratorFunction");
  }, r.mark = function(N) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(N, g) : (N.__proto__ = g, l(N, a, "GeneratorFunction")), N.prototype = Object.create(v), N;
  }, r.awrap = function(N) {
    return {
      __await: N
    };
  }, y(_.prototype), l(_.prototype, o, function() {
    return this;
  }), r.AsyncIterator = _, r.async = function(N, R, H, z, U) {
    U === void 0 && (U = Promise);
    var ee = new _(c(N, R, H, z), U);
    return r.isGeneratorFunction(R) ? ee : ee.next().then(function(ce) {
      return ce.done ? ce.value : ee.next();
    });
  }, y(v), l(v, a, "Generator"), l(v, s, function() {
    return this;
  }), l(v, "toString", function() {
    return "[object Generator]";
  }), r.keys = function(N) {
    var R = Object(N), H = [];
    for (var z in R) H.push(z);
    return H.reverse(), function U() {
      for (; H.length; ) {
        var ee = H.pop();
        if (ee in R) return U.value = ee, U.done = !1, U;
      }
      return U.done = !0, U;
    };
  }, r.values = B, T.prototype = {
    constructor: T,
    reset: function(N) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(L), !N) for (var R in this) R.charAt(0) === "t" && t.call(this, R) && !isNaN(+R.slice(1)) && (this[R] = void 0);
    },
    stop: function() {
      this.done = !0;
      var N = this.tryEntries[0].completion;
      if (N.type === "throw") throw N.arg;
      return this.rval;
    },
    dispatchException: function(N) {
      if (this.done) throw N;
      var R = this;
      function H(te, ue) {
        return ee.type = "throw", ee.arg = N, R.next = te, ue && (R.method = "next", R.arg = void 0), !!ue;
      }
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var U = this.tryEntries[z], ee = U.completion;
        if (U.tryLoc === "root") return H("end");
        if (U.tryLoc <= this.prev) {
          var ce = t.call(U, "catchLoc"), se = t.call(U, "finallyLoc");
          if (ce && se) {
            if (this.prev < U.catchLoc) return H(U.catchLoc, !0);
            if (this.prev < U.finallyLoc) return H(U.finallyLoc);
          } else if (ce) {
            if (this.prev < U.catchLoc) return H(U.catchLoc, !0);
          } else {
            if (!se) throw new Error("try statement without catch or finally");
            if (this.prev < U.finallyLoc) return H(U.finallyLoc);
          }
        }
      }
    },
    abrupt: function(N, R) {
      for (var H = this.tryEntries.length - 1; H >= 0; --H) {
        var z = this.tryEntries[H];
        if (z.tryLoc <= this.prev && t.call(z, "finallyLoc") && this.prev < z.finallyLoc) {
          var U = z;
          break;
        }
      }
      U && (N === "break" || N === "continue") && U.tryLoc <= R && R <= U.finallyLoc && (U = null);
      var ee = U ? U.completion : {};
      return ee.type = N, ee.arg = R, U ? (this.method = "next", this.next = U.finallyLoc, u) : this.complete(ee);
    },
    complete: function(N, R) {
      if (N.type === "throw") throw N.arg;
      return N.type === "break" || N.type === "continue" ? this.next = N.arg : N.type === "return" ? (this.rval = this.arg = N.arg, this.method = "return", this.next = "end") : N.type === "normal" && R && (this.next = R), u;
    },
    finish: function(N) {
      for (var R = this.tryEntries.length - 1; R >= 0; --R) {
        var H = this.tryEntries[R];
        if (H.finallyLoc === N) return this.complete(H.completion, H.afterLoc), L(H), u;
      }
    },
    catch: function(N) {
      for (var R = this.tryEntries.length - 1; R >= 0; --R) {
        var H = this.tryEntries[R];
        if (H.tryLoc === N) {
          var z = H.completion;
          if (z.type === "throw") {
            var U = z.arg;
            L(H);
          }
          return U;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(N, R, H) {
      return this.delegate = {
        iterator: B(N),
        resultName: R,
        nextLoc: H
      }, this.method === "next" && (this.arg = void 0), u;
    }
  }, r;
}
function zbe(r, e, t, n, i, s, o) {
  try {
    var a = r[s](o), l = a.value;
  } catch (c) {
    t(c);
    return;
  }
  a.done ? e(l) : Promise.resolve(l).then(n, i);
}
function h0(r) {
  return function() {
    var e = this, t = arguments;
    return new Promise(function(n, i) {
      var s = r.apply(e, t);
      function o(l) {
        zbe(s, n, i, o, a, "next", l);
      }
      function a(l) {
        zbe(s, n, i, o, a, "throw", l);
      }
      o(void 0);
    });
  };
}
function rIe(r, e) {
  if (!(r instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function eLt(r, e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(r, aIe(n.key), n);
  }
}
function sIe(r, e, t) {
  return e && eLt(r.prototype, e), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
function B6(r, e, t) {
  return e = aIe(e), e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function tLt(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  r.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: r,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(r, "prototype", {
    writable: !1
  }), e && b4(r, e);
}
function v4(r) {
  return v4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, v4(r);
}
function b4(r, e) {
  return b4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, b4(r, e);
}
function oIe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function P6(r, e, t) {
  return oIe() ? P6 = Reflect.construct.bind() : P6 = function(i, s, o) {
    var a = [null];
    a.push.apply(a, s);
    var l = Function.bind.apply(i, a), c = new l();
    return o && b4(c, o.prototype), c;
  }, P6.apply(null, arguments);
}
function nLt(r) {
  return Function.toString.call(r).indexOf("[native code]") !== -1;
}
function CN(r) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return CN = function(n) {
    if (n === null || !nLt(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, i);
    }
    function i() {
      return P6(n, arguments, v4(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), b4(i, n);
  }, CN(r);
}
function F6(r) {
  if (r === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r;
}
function iLt(r, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return F6(r);
}
function rLt(r) {
  var e = oIe();
  return function() {
    var n = v4(r), i;
    if (e) {
      var s = v4(this).constructor;
      i = Reflect.construct(n, arguments, s);
    } else
      i = n.apply(this, arguments);
    return iLt(this, i);
  };
}
function sLt(r, e) {
  if (typeof r != "object" || r === null) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(r);
}
function aIe(r) {
  var e = sLt(r, "string");
  return typeof e == "symbol" ? e : String(e);
}
var lIe = typeof global < "u" && {}.toString.call(global) === "[object global]";
function Wbe(r, e) {
  return r.indexOf(e.toLowerCase()) === 0 ? r : "".concat(e.toLowerCase()).concat(r.substr(0, 1).toUpperCase()).concat(r.substr(1));
}
function oLt(r) {
  return !!(r && r.nodeType === 1 && "nodeName" in r && r.ownerDocument && r.ownerDocument.defaultView);
}
function aLt(r) {
  return !isNaN(parseFloat(r)) && isFinite(r) && Math.floor(r) == r;
}
function Mf(r) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(r);
}
function cIe(r) {
  var e = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return e.test(r);
}
function lLt(r) {
  for (var e = (r || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), t = (e && e[1] || "").replace("player.", ""), n = [".videoji.hk", ".vimeo.work", ".videoji.cn"], i = 0, s = n; i < s.length; i++) {
    var o = s[i];
    if (t.endsWith(o))
      return t;
  }
  return "vimeo.com";
}
function hIe() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = r.id, t = r.url, n = e || t;
  if (!n)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (aLt(n))
    return "https://vimeo.com/".concat(n);
  if (Mf(n))
    return n.replace("http:", "https:");
  throw e ? new TypeError("“".concat(e, "” is not a valid video id.")) : new TypeError("“".concat(n, "” is not a vimeo.com url."));
}
var jbe = function(e, t, n) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", o = typeof t == "string" ? [t] : t;
  return o.forEach(function(a) {
    e[i](a, n);
  }), {
    cancel: function() {
      return o.forEach(function(l) {
        return e[s](l, n);
      });
    }
  };
}, cLt = typeof Array.prototype.indexOf < "u", hLt = typeof window < "u" && typeof window.postMessage < "u";
if (!lIe && (!cLt || !hLt))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var Hp = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function dLt(r, e) {
  return e = { exports: {} }, r(e, e.exports), e.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(r) {
  if (r.WeakMap)
    return;
  var e = Object.prototype.hasOwnProperty, t = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  }(), n = function(s, o, a) {
    t ? Object.defineProperty(s, o, {
      configurable: !0,
      writable: !0,
      value: a
    }) : s[o] = a;
  };
  r.WeakMap = function() {
    function s() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (n(this, "_id", a("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    n(s.prototype, "delete", function(c) {
      if (o(this, "delete"), !i(c))
        return !1;
      var d = c[this._id];
      return d && d[0] === c ? (delete c[this._id], !0) : !1;
    }), n(s.prototype, "get", function(c) {
      if (o(this, "get"), !!i(c)) {
        var d = c[this._id];
        if (d && d[0] === c)
          return d[1];
      }
    }), n(s.prototype, "has", function(c) {
      if (o(this, "has"), !i(c))
        return !1;
      var d = c[this._id];
      return !!(d && d[0] === c);
    }), n(s.prototype, "set", function(c, d) {
      if (o(this, "set"), !i(c))
        throw new TypeError("Invalid value used as weak map key");
      var u = c[this._id];
      return u && u[0] === c ? (u[1] = d, this) : (n(c, this._id, [c, d]), this);
    });
    function o(c, d) {
      if (!i(c) || !e.call(c, "_id"))
        throw new TypeError(d + " method called on incompatible receiver " + typeof c);
    }
    function a(c) {
      return c + "_" + l() + "." + l();
    }
    function l() {
      return Math.random().toString().substring(2);
    }
    return n(s, "_polyfill", !0), s;
  }();
  function i(s) {
    return Object(s) === s;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Hp);
var Ra = dLt(function(r) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(t, n, i) {
    n[t] = n[t] || i(), r.exports && (r.exports = n[t]);
  })("Promise", Hp, function() {
    var t, n, i, s = Object.prototype.toString, o = typeof setImmediate < "u" ? function(y) {
      return setImmediate(y);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), t = function(y, _, S, D) {
        return Object.defineProperty(y, _, {
          value: S,
          writable: !0,
          configurable: D !== !1
        });
      };
    } catch {
      t = function(_, S, D) {
        return _[S] = D, _;
      };
    }
    i = /* @__PURE__ */ function() {
      var y, _, S;
      function D(M, L) {
        this.fn = M, this.self = L, this.next = void 0;
      }
      return {
        add: function(L, T) {
          S = new D(L, T), _ ? _.next = S : y = S, _ = S, S = void 0;
        },
        drain: function() {
          var L = y;
          for (y = _ = n = void 0; L; )
            L.fn.call(L.self), L = L.next;
        }
      };
    }();
    function a(v, y) {
      i.add(v, y), n || (n = o(i.drain));
    }
    function l(v) {
      var y, _ = typeof v;
      return v != null && (_ == "object" || _ == "function") && (y = v.then), typeof y == "function" ? y : !1;
    }
    function c() {
      for (var v = 0; v < this.chain.length; v++)
        d(this, this.state === 1 ? this.chain[v].success : this.chain[v].failure, this.chain[v]);
      this.chain.length = 0;
    }
    function d(v, y, _) {
      var S, D;
      try {
        y === !1 ? _.reject(v.msg) : (y === !0 ? S = v.msg : S = y.call(void 0, v.msg), S === _.promise ? _.reject(TypeError("Promise-chain cycle")) : (D = l(S)) ? D.call(S, _.resolve, _.reject) : _.resolve(S));
      } catch (M) {
        _.reject(M);
      }
    }
    function u(v) {
      var y, _ = this;
      if (!_.triggered) {
        _.triggered = !0, _.def && (_ = _.def);
        try {
          (y = l(v)) ? a(function() {
            var S = new g(_);
            try {
              y.call(v, function() {
                u.apply(S, arguments);
              }, function() {
                f.apply(S, arguments);
              });
            } catch (D) {
              f.call(S, D);
            }
          }) : (_.msg = v, _.state = 1, _.chain.length > 0 && a(c, _));
        } catch (S) {
          f.call(new g(_), S);
        }
      }
    }
    function f(v) {
      var y = this;
      y.triggered || (y.triggered = !0, y.def && (y = y.def), y.msg = v, y.state = 2, y.chain.length > 0 && a(c, y));
    }
    function p(v, y, _, S) {
      for (var D = 0; D < y.length; D++)
        (function(L) {
          v.resolve(y[L]).then(function(B) {
            _(L, B);
          }, S);
        })(D);
    }
    function g(v) {
      this.def = v, this.triggered = !1;
    }
    function m(v) {
      this.promise = v, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function A(v) {
      if (typeof v != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var y = new m(this);
      this.then = function(S, D) {
        var M = {
          success: typeof S == "function" ? S : !0,
          failure: typeof D == "function" ? D : !1
        };
        return M.promise = new this.constructor(function(T, B) {
          if (typeof T != "function" || typeof B != "function")
            throw TypeError("Not a function");
          M.resolve = T, M.reject = B;
        }), y.chain.push(M), y.state !== 0 && a(c, y), M.promise;
      }, this.catch = function(S) {
        return this.then(void 0, S);
      };
      try {
        v.call(void 0, function(S) {
          u.call(y, S);
        }, function(S) {
          f.call(y, S);
        });
      } catch (_) {
        f.call(y, _);
      }
    }
    var w = t(
      {},
      "constructor",
      A,
      /*configurable=*/
      !1
    );
    return A.prototype = w, t(
      w,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), t(A, "resolve", function(y) {
      var _ = this;
      return y && typeof y == "object" && y.__NPO__ === 1 ? y : new _(function(D, M) {
        if (typeof D != "function" || typeof M != "function")
          throw TypeError("Not a function");
        D(y);
      });
    }), t(A, "reject", function(y) {
      return new this(function(S, D) {
        if (typeof S != "function" || typeof D != "function")
          throw TypeError("Not a function");
        D(y);
      });
    }), t(A, "all", function(y) {
      var _ = this;
      return s.call(y) != "[object Array]" ? _.reject(TypeError("Not an array")) : y.length === 0 ? _.resolve([]) : new _(function(D, M) {
        if (typeof D != "function" || typeof M != "function")
          throw TypeError("Not a function");
        var L = y.length, T = Array(L), B = 0;
        p(_, y, function(N, R) {
          T[N] = R, ++B === L && D(T);
        }, M);
      });
    }), t(A, "race", function(y) {
      var _ = this;
      return s.call(y) != "[object Array]" ? _.reject(TypeError("Not an array")) : new _(function(D, M) {
        if (typeof D != "function" || typeof M != "function")
          throw TypeError("Not a function");
        p(_, y, function(T, B) {
          D(B);
        }, M);
      });
    }), A;
  });
}), Dd = /* @__PURE__ */ new WeakMap();
function Xm(r, e, t) {
  var n = Dd.get(r.element) || {};
  e in n || (n[e] = []), n[e].push(t), Dd.set(r.element, n);
}
function Ab(r, e) {
  var t = Dd.get(r.element) || {};
  return t[e] || [];
}
function wb(r, e, t) {
  var n = Dd.get(r.element) || {};
  if (!n[e])
    return !0;
  if (!t)
    return n[e] = [], Dd.set(r.element, n), !0;
  var i = n[e].indexOf(t);
  return i !== -1 && n[e].splice(i, 1), Dd.set(r.element, n), n[e] && n[e].length === 0;
}
function uLt(r, e) {
  var t = Ab(r, e);
  if (t.length < 1)
    return !1;
  var n = t.shift();
  return wb(r, e, n), n;
}
function fLt(r, e) {
  var t = Dd.get(r);
  Dd.set(e, t), Dd.delete(r);
}
function Zy(r) {
  if (typeof r == "string")
    try {
      r = JSON.parse(r);
    } catch (e) {
      return console.warn(e), {};
    }
  return r;
}
function J1(r, e, t) {
  if (!(!r.element.contentWindow || !r.element.contentWindow.postMessage)) {
    var n = {
      method: e
    };
    t !== void 0 && (n.value = t);
    var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    i >= 8 && i < 10 && (n = JSON.stringify(n)), r.element.contentWindow.postMessage(n, r.origin);
  }
}
function pLt(r, e) {
  e = Zy(e);
  var t = [], n;
  if (e.event) {
    if (e.event === "error") {
      var i = Ab(r, e.data.method);
      i.forEach(function(o) {
        var a = new Error(e.data.message);
        a.name = e.data.name, o.reject(a), wb(r, e.data.method, o);
      });
    }
    t = Ab(r, "event:".concat(e.event)), n = e.data;
  } else if (e.method) {
    var s = uLt(r, e.method);
    s && (t.push(s), n = e.value);
  }
  t.forEach(function(o) {
    try {
      if (typeof o == "function") {
        o.call(r, n);
        return;
      }
      o.resolve(n);
    } catch {
    }
  });
}
var gLt = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "initial_quality", "interactive_params", "keyboard", "loop", "maxheight", "max_quality", "maxwidth", "min_quality", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality", "quality_selector", "responsive", "skipping_forward", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function dIe(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return gLt.reduce(function(t, n) {
    var i = r.getAttribute("data-vimeo-".concat(n));
    return (i || i === "") && (t[n] = i === "" ? 1 : i), t;
  }, e);
}
function fV(r, e) {
  var t = r.html;
  if (!e)
    throw new TypeError("An element must be provided");
  if (e.getAttribute("data-vimeo-initialized") !== null)
    return e.querySelector("iframe");
  var n = document.createElement("div");
  return n.innerHTML = t, e.appendChild(n.firstChild), e.setAttribute("data-vimeo-initialized", "true"), e.querySelector("iframe");
}
function uIe(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(n, i) {
    if (!Mf(r))
      throw new TypeError("“".concat(r, "” is not a vimeo.com url."));
    var s = lLt(r), o = "https://".concat(s, "/api/oembed.json?url=").concat(encodeURIComponent(r));
    for (var a in e)
      e.hasOwnProperty(a) && (o += "&".concat(a, "=").concat(encodeURIComponent(e[a])));
    var l = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    l.open("GET", o, !0), l.onload = function() {
      if (l.status === 404) {
        i(new Error("“".concat(r, "” was not found.")));
        return;
      }
      if (l.status === 403) {
        i(new Error("“".concat(r, "” is not embeddable.")));
        return;
      }
      try {
        var c = JSON.parse(l.responseText);
        if (c.domain_status_code === 403) {
          fV(c, t), i(new Error("“".concat(r, "” is not embeddable.")));
          return;
        }
        n(c);
      } catch (d) {
        i(d);
      }
    }, l.onerror = function() {
      var c = l.status ? " (".concat(l.status, ")") : "";
      i(new Error("There was an error fetching the embed code from Vimeo".concat(c, ".")));
    }, l.send();
  });
}
function mLt() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, e = [].slice.call(r.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), t = function(i) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(i));
  };
  e.forEach(function(n) {
    try {
      if (n.getAttribute("data-vimeo-defer") !== null)
        return;
      var i = dIe(n), s = hIe(i);
      uIe(s, i, n).then(function(o) {
        return fV(o, n);
      }).catch(t);
    } catch (o) {
      t(o);
    }
  });
}
function ALt() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var e = function(n) {
      if (Mf(n.origin) && !(!n.data || n.data.event !== "spacechange")) {
        for (var i = r.querySelectorAll("iframe"), s = 0; s < i.length; s++)
          if (i[s].contentWindow === n.source) {
            var o = i[s].parentElement;
            o.style.paddingBottom = "".concat(n.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", e);
  }
}
function wLt() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var e = function(n) {
      if (Mf(n.origin)) {
        var i = Zy(n.data);
        if (!(!i || i.event !== "ready"))
          for (var s = r.querySelectorAll("iframe"), o = 0; o < s.length; o++) {
            var a = s[o], l = a.contentWindow === n.source;
            if (cIe(a.src) && l) {
              var c = new pV(a);
              c.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", e);
  }
}
function vLt() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var e = function(i) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(i));
    }, t = function(i) {
      if (Mf(i.origin)) {
        var s = Zy(i.data);
        if (!(!s || s.event !== "ready"))
          for (var o = r.querySelectorAll("iframe"), a = function() {
            var d = o[l], u = d.contentWindow === i.source;
            if (cIe(d.src) && u) {
              var f = new pV(d);
              f.getVideoId().then(function(p) {
                var g = new RegExp("[?&]vimeo_t_".concat(p, "=([^&#]*)")).exec(window.location.href);
                if (g && g[1]) {
                  var m = decodeURI(g[1]);
                  f.setCurrentTime(m);
                }
              }).catch(e);
            }
          }, l = 0; l < o.length; l++)
            a();
      }
    };
    window.addEventListener("message", t);
  }
}
function bLt() {
  var r = function() {
    for (var n, i = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], s = 0, o = i.length, a = {}; s < o; s++)
      if (n = i[s], n && n[1] in document) {
        for (s = 0; s < n.length; s++)
          a[i[0][s]] = n[s];
        return a;
      }
    return !1;
  }(), e = {
    fullscreenchange: r.fullscreenchange,
    fullscreenerror: r.fullscreenerror
  }, t = {
    request: function(i) {
      return new Promise(function(s, o) {
        var a = function c() {
          t.off("fullscreenchange", c), s();
        };
        t.on("fullscreenchange", a), i = i || document.documentElement;
        var l = i[r.requestFullscreen]();
        l instanceof Promise && l.then(a).catch(o);
      });
    },
    exit: function() {
      return new Promise(function(i, s) {
        if (!t.isFullscreen) {
          i();
          return;
        }
        var o = function l() {
          t.off("fullscreenchange", l), i();
        };
        t.on("fullscreenchange", o);
        var a = document[r.exitFullscreen]();
        a instanceof Promise && a.then(o).catch(s);
      });
    },
    on: function(i, s) {
      var o = e[i];
      o && document.addEventListener(o, s);
    },
    off: function(i, s) {
      var o = e[i];
      o && document.removeEventListener(o, s);
    }
  };
  return Object.defineProperties(t, {
    isFullscreen: {
      get: function() {
        return !!document[r.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[r.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[r.fullscreenEnabled];
      }
    }
  }), t;
}
var yLt = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, CLt = /* @__PURE__ */ function(r) {
  tLt(t, r);
  var e = rLt(t);
  function t(n, i) {
    var s, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = arguments.length > 3 ? arguments[3] : void 0;
    return rIe(this, t), s = e.call(this), B6(F6(s), "logger", void 0), B6(F6(s), "speedAdjustment", 0), B6(F6(s), "adjustSpeed", /* @__PURE__ */ function() {
      var l = h0(/* @__PURE__ */ Xs().mark(function c(d, u) {
        var f;
        return Xs().wrap(function(g) {
          for (; ; ) switch (g.prev = g.next) {
            case 0:
              if (s.speedAdjustment !== u) {
                g.next = 2;
                break;
              }
              return g.abrupt("return");
            case 2:
              return g.next = 4, d.getPlaybackRate();
            case 4:
              return g.t0 = g.sent, g.t1 = s.speedAdjustment, g.t2 = g.t0 - g.t1, g.t3 = u, f = g.t2 + g.t3, s.log("New playbackRate:  ".concat(f)), g.next = 12, d.setPlaybackRate(f);
            case 12:
              s.speedAdjustment = u;
            case 13:
            case "end":
              return g.stop();
          }
        }, c);
      }));
      return function(c, d) {
        return l.apply(this, arguments);
      };
    }()), s.logger = a, s.init(i, n, Fbe(Fbe({}, yLt), o)), s;
  }
  return sIe(t, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var n = h0(/* @__PURE__ */ Xs().mark(function s(o, a, l) {
        var c = this, d, u, f;
        return Xs().wrap(function(g) {
          for (; ; ) switch (g.prev = g.next) {
            case 0:
              return g.next = 2, this.waitForTOReadyState(o, "open");
            case 2:
              if (l.role !== "viewer") {
                g.next = 10;
                break;
              }
              return g.next = 5, this.updatePlayer(o, a, l);
            case 5:
              d = jbe(o, "change", function() {
                return c.updatePlayer(o, a, l);
              }), u = this.maintainPlaybackPosition(o, a, l), this.addEventListener("disconnect", function() {
                u.cancel(), d.cancel();
              }), g.next = 14;
              break;
            case 10:
              return g.next = 12, this.updateTimingObject(o, a);
            case 12:
              f = jbe(a, ["seeked", "play", "pause", "ratechange"], function() {
                return c.updateTimingObject(o, a);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return f.cancel();
              });
            case 14:
            case "end":
              return g.stop();
          }
        }, s, this);
      }));
      function i(s, o, a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var n = h0(/* @__PURE__ */ Xs().mark(function s(o, a) {
        return Xs().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              return c.t0 = o, c.next = 3, a.getCurrentTime();
            case 3:
              return c.t1 = c.sent, c.next = 6, a.getPaused();
            case 6:
              if (!c.sent) {
                c.next = 10;
                break;
              }
              c.t2 = 0, c.next = 13;
              break;
            case 10:
              return c.next = 12, a.getPlaybackRate();
            case 12:
              c.t2 = c.sent;
            case 13:
              c.t3 = c.t2, c.t4 = {
                position: c.t1,
                velocity: c.t3
              }, c.t0.update.call(c.t0, c.t4);
            case 16:
            case "end":
              return c.stop();
          }
        }, s);
      }));
      function i(s, o) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var n = h0(/* @__PURE__ */ Xs().mark(function s(o, a, l) {
        var c, d, u;
        return Xs().wrap(function(p) {
          for (; ; ) switch (p.prev = p.next) {
            case 0:
              if (c = o.query(), d = c.position, u = c.velocity, typeof d == "number" && a.setCurrentTime(d), typeof u != "number") {
                p.next = 25;
                break;
              }
              if (u !== 0) {
                p.next = 11;
                break;
              }
              return p.next = 6, a.getPaused();
            case 6:
              if (p.t0 = p.sent, p.t0 !== !1) {
                p.next = 9;
                break;
              }
              a.pause();
            case 9:
              p.next = 25;
              break;
            case 11:
              if (!(u > 0)) {
                p.next = 25;
                break;
              }
              return p.next = 14, a.getPaused();
            case 14:
              if (p.t1 = p.sent, p.t1 !== !0) {
                p.next = 19;
                break;
              }
              return p.next = 18, a.play().catch(/* @__PURE__ */ function() {
                var g = h0(/* @__PURE__ */ Xs().mark(function m(A) {
                  return Xs().wrap(function(v) {
                    for (; ; ) switch (v.prev = v.next) {
                      case 0:
                        if (!(A.name === "NotAllowedError" && l.autoPlayMuted)) {
                          v.next = 5;
                          break;
                        }
                        return v.next = 3, a.setMuted(!0);
                      case 3:
                        return v.next = 5, a.play().catch(function(y) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", y);
                        });
                      case 5:
                      case "end":
                        return v.stop();
                    }
                  }, m);
                }));
                return function(m) {
                  return g.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(o, a, l);
            case 19:
              return p.next = 21, a.getPlaybackRate();
            case 21:
              if (p.t2 = p.sent, p.t3 = u, p.t2 === p.t3) {
                p.next = 25;
                break;
              }
              a.setPlaybackRate(u);
            case 25:
            case "end":
              return p.stop();
          }
        }, s, this);
      }));
      function i(s, o, a) {
        return n.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(i, s, o) {
      var a = this, l = o.allowedDrift, c = o.maxAllowedDrift, d = o.minCheckInterval, u = o.maxRateAdjustment, f = o.maxTimeToCatchUp, p = Math.min(f, Math.max(d, c)) * 1e3, g = /* @__PURE__ */ function() {
        var A = h0(/* @__PURE__ */ Xs().mark(function w() {
          var v, y, _, S, D;
          return Xs().wrap(function(L) {
            for (; ; ) switch (L.prev = L.next) {
              case 0:
                if (L.t0 = i.query().velocity === 0, L.t0) {
                  L.next = 6;
                  break;
                }
                return L.next = 4, s.getPaused();
              case 4:
                L.t1 = L.sent, L.t0 = L.t1 === !0;
              case 6:
                if (!L.t0) {
                  L.next = 8;
                  break;
                }
                return L.abrupt("return");
              case 8:
                return L.t2 = i.query().position, L.next = 11, s.getCurrentTime();
              case 11:
                if (L.t3 = L.sent, v = L.t2 - L.t3, y = Math.abs(v), a.log("Drift: ".concat(v)), !(y > c)) {
                  L.next = 22;
                  break;
                }
                return L.next = 18, a.adjustSpeed(s, 0);
              case 18:
                s.setCurrentTime(i.query().position), a.log("Resync by currentTime"), L.next = 29;
                break;
              case 22:
                if (!(y > l)) {
                  L.next = 29;
                  break;
                }
                return _ = y / f, S = u, D = _ < S ? (S - _) / 2 : S, L.next = 28, a.adjustSpeed(s, D * Math.sign(v));
              case 28:
                a.log("Resync by playbackRate");
              case 29:
              case "end":
                return L.stop();
            }
          }, w);
        }));
        return function() {
          return A.apply(this, arguments);
        };
      }(), m = setInterval(function() {
        return g();
      }, p);
      return {
        cancel: function() {
          return clearInterval(m);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(i) {
      var s;
      (s = this.logger) === null || s === void 0 || s.call(this, "TimingSrcConnector: ".concat(i));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(i, s) {
        return new Promise(function(o) {
          var a = function l() {
            i.readyState === s ? o() : i.addEventListener("readystatechange", l, {
              once: !0
            });
          };
          a();
        });
      }
    )
  }]), t;
}(/* @__PURE__ */ CN(EventTarget)), N2 = /* @__PURE__ */ new WeakMap(), R_ = /* @__PURE__ */ new WeakMap(), wo = {}, pV = /* @__PURE__ */ function() {
  function r(e) {
    var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (rIe(this, r), window.jQuery && e instanceof jQuery && (e.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), e = e[0]), typeof document < "u" && typeof e == "string" && (e = document.getElementById(e)), !oLt(e))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (e.nodeName !== "IFRAME") {
      var i = e.querySelector("iframe");
      i && (e = i);
    }
    if (e.nodeName === "IFRAME" && !Mf(e.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (N2.has(e))
      return N2.get(e);
    this._window = e.ownerDocument.defaultView, this.element = e, this.origin = "*";
    var s = new Ra(function(a, l) {
      if (t._onMessage = function(u) {
        if (!(!Mf(u.origin) || t.element.contentWindow !== u.source)) {
          t.origin === "*" && (t.origin = u.origin);
          var f = Zy(u.data), p = f && f.event === "error", g = p && f.data && f.data.method === "ready";
          if (g) {
            var m = new Error(f.data.message);
            m.name = f.data.name, l(m);
            return;
          }
          var A = f && f.event === "ready", w = f && f.method === "ping";
          if (A || w) {
            t.element.setAttribute("data-ready", "true"), a();
            return;
          }
          pLt(t, f);
        }
      }, t._window.addEventListener("message", t._onMessage), t.element.nodeName !== "IFRAME") {
        var c = dIe(e, n), d = hIe(c);
        uIe(d, c, e).then(function(u) {
          var f = fV(u, e);
          return t.element = f, t._originalElement = e, fLt(e, f), N2.set(t.element, t), u;
        }).catch(l);
      }
    });
    if (R_.set(this, s), N2.set(this.element, this), this.element.nodeName === "IFRAME" && J1(this, "ping"), wo.isEnabled) {
      var o = function() {
        return wo.exit();
      };
      this.fullscreenchangeHandler = function() {
        wo.isFullscreen ? Xm(t, "event:exitFullscreen", o) : wb(t, "event:exitFullscreen", o), t.ready().then(function() {
          J1(t, "fullscreenchange", wo.isFullscreen);
        });
      }, wo.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return sIe(r, [{
    key: "callMethod",
    value: function(t) {
      for (var n = this, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)
        s[o - 1] = arguments[o];
      if (t == null)
        throw new TypeError("You must pass a method name.");
      return new Ra(function(a, l) {
        return n.ready().then(function() {
          Xm(n, t, {
            resolve: a,
            reject: l
          }), J1(n, t, s);
        }).catch(l);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(t) {
      var n = this;
      return new Ra(function(i, s) {
        return t = Wbe(t, "get"), n.ready().then(function() {
          Xm(n, t, {
            resolve: i,
            reject: s
          }), J1(n, t);
        }).catch(s);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(t, n) {
      var i = this;
      return new Ra(function(s, o) {
        if (t = Wbe(t, "set"), n == null)
          throw new TypeError("There must be a value to set.");
        return i.ready().then(function() {
          Xm(i, t, {
            resolve: s,
            reject: o
          }), J1(i, t, n);
        }).catch(o);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(t, n) {
      if (!t)
        throw new TypeError("You must pass an event name.");
      if (!n)
        throw new TypeError("You must pass a callback function.");
      if (typeof n != "function")
        throw new TypeError("The callback must be a function.");
      var i = Ab(this, "event:".concat(t));
      i.length === 0 && this.callMethod("addEventListener", t).catch(function() {
      }), Xm(this, "event:".concat(t), n);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(t, n) {
      if (!t)
        throw new TypeError("You must pass an event name.");
      if (n && typeof n != "function")
        throw new TypeError("The callback must be a function.");
      var i = wb(this, "event:".concat(t), n);
      i && this.callMethod("removeEventListener", t).catch(function(s) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(t) {
      return this.callMethod("loadVideo", t);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var t = R_.get(this) || new Ra(function(n, i) {
        i(new Error("Unknown player. Probably unloaded."));
      });
      return Ra.resolve(t);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: t,
        data: n
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(t) {
      return this.callMethod("removeCuePoint", t);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(t, n) {
      if (!t)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: t,
        kind: n
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return wo.isEnabled ? wo.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return wo.isEnabled ? wo.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return wo.isEnabled ? Ra.resolve(wo.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var t = this;
      return new Ra(function(n) {
        if (R_.delete(t), N2.delete(t.element), t._originalElement && (N2.delete(t._originalElement), t._originalElement.removeAttribute("data-vimeo-initialized")), t.element && t.element.nodeName === "IFRAME" && t.element.parentNode && (t.element.parentNode.parentNode && t._originalElement && t._originalElement !== t.element.parentNode ? t.element.parentNode.parentNode.removeChild(t.element.parentNode) : t.element.parentNode.removeChild(t.element)), t.element && t.element.nodeName === "DIV" && t.element.parentNode) {
          t.element.removeAttribute("data-vimeo-initialized");
          var i = t.element.querySelector("iframe");
          i && i.parentNode && (i.parentNode.parentNode && t._originalElement && t._originalElement !== i.parentNode ? i.parentNode.parentNode.removeChild(i.parentNode) : i.parentNode.removeChild(i));
        }
        t._window.removeEventListener("message", t._onMessage), wo.isEnabled && wo.off("fullscreenchange", t.fullscreenchangeHandler), n();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(t) {
      return this.set("autopause", t);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(t) {
      return this.set("cameraProps", t);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Ra.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(t) {
      return this.set("color", t);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(t) {
      if (!Array.isArray(t))
        return new Ra(function(s, o) {
          return o(new TypeError("Argument must be an array."));
        });
      var n = new Ra(function(s) {
        return s(null);
      }), i = [t[0] ? this.set("colorOne", t[0]) : n, t[1] ? this.set("colorTwo", t[1]) : n, t[2] ? this.set("colorThree", t[2]) : n, t[3] ? this.set("colorFour", t[3]) : n];
      return Ra.all(i);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(t) {
      return this.set("currentTime", t);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(t) {
      return this.set("loop", t);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(t) {
      return this.set("muted", t);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(t) {
      return this.set("playbackRate", t);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(t) {
      return this.set("quality", t);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(t) {
      return this.set("volume", t);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var e = h0(/* @__PURE__ */ Xs().mark(function n(i, s) {
        var o = this, a;
        return Xs().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              if (i) {
                c.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return c.next = 4, this.ready();
            case 4:
              return a = new CLt(this, i, s), J1(this, "notifyTimingObjectConnect"), a.addEventListener("disconnect", function() {
                return J1(o, "notifyTimingObjectDisconnect");
              }), c.abrupt("return", a);
            case 8:
            case "end":
              return c.stop();
          }
        }, n, this);
      }));
      function t(n, i) {
        return e.apply(this, arguments);
      }
      return t;
    }()
  }]), r;
}();
lIe || (wo = bLt(), mLt(), ALt(), wLt(), vLt());
const ELt = () => (localStorage.getItem("play-firstTime") ?? "true").toLowerCase() === "true", _Lt = () => {
  localStorage.setItem("play-firstTime", "false");
}, fIe = r1((r, e) => {
  const [t, n] = ye(null), [i, s] = ye(!1);
  return Pe(() => {
    const o = document.getElementById("academyTutorialVideo");
    if (!o) return;
    const a = new pV(o);
    return n(a), a.ready().then(function() {
      s(!0);
    }), () => {
      _Lt();
    };
  }, []), uFe(e, () => ({
    async trackPlaybackPosition() {
      if (t && i) {
        const o = await t.getCurrentTime();
        $i.trackTutorialVideoStopped(o);
      }
    }
  }), [t, i]), /* @__PURE__ */ x.jsx("div", { style: { padding: "56.25% 0 0 0", position: "relative" }, children: /* @__PURE__ */ x.jsx(
    "iframe",
    {
      id: "academyTutorialVideo",
      src: "https://player.vimeo.com/video/825101633?badge=0&autopause=0&player_id=0&app_id=58479",
      frameBorder: "0",
      allow: "autoplay; fullscreen;",
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
      },
      title: "Camunda 8 - How To - Validate Processes with Play"
    }
  ) });
}), xLt = rt(
  ({ close: r, switchToImplementMode: e, isAcademyVideoExperiment: t = !1 }) => {
    const n = An(null), i = An(null), s = t && ELt(), {
      state: { status: o, isRedeployment: a },
      isClusterReady: l
    } = kt, {
      connectorElementsWithMissingSecrets: c,
      state: { isReady: d }
    } = mh, u = kt.fileProblems.length > 0 || c.length > 0 || kt.hasDiagramError || kt.hasServerError, f = kt.isEnvironmentCreated && d, { isLoaded: p } = mi.state, g = async () => {
      await i.current?.trackPlaybackPosition(), r();
    };
    return Pe(() => {
      !p || !l || mh.setupConnectors();
    }, [p, l]), Pe(() => {
      p && kt.setupEnvironment();
    }, [p]), Pe(() => {
      a && f && !u && r?.();
    }, [a, f, u, r]), kt.hasServerError ? /* @__PURE__ */ x.jsx(Rbe, { children: /* @__PURE__ */ x.jsxs(Vbe, { children: [
      /* @__PURE__ */ x.jsx(Hbe, { children: /* @__PURE__ */ x.jsxs(KDt, { orientation: "horizontal", gap: 6, children: [
        /* @__PURE__ */ x.jsx(Jht, {}),
        /* @__PURE__ */ x.jsxs(In, { orientation: "vertical", gap: 3, children: [
          /* @__PURE__ */ x.jsx(YDt, { children: "Something went wrong" }),
          /* @__PURE__ */ x.jsxs(XDt, { children: [
            /* @__PURE__ */ x.jsx("div", { children: "We were unable to process your request." }),
            /* @__PURE__ */ x.jsx("div", { children: "Click Retry or refresh this browser tab to try again." })
          ] })
        ] })
      ] }) }),
      /* @__PURE__ */ x.jsx(Bbe, { children: /* @__PURE__ */ x.jsx(
        w5,
        {
          size: "xl",
          onClick: () => {
            kt.reset(), kt.setupEnvironment();
          },
          children: "Retry"
        }
      ) })
    ] }) }) : /* @__PURE__ */ x.jsx(Rbe, { children: /* @__PURE__ */ x.jsxs(Vbe, { children: [
      /* @__PURE__ */ x.jsxs(Hbe, { children: [
        s ? /* @__PURE__ */ x.jsx(fIe, { ref: i }) : /* @__PURE__ */ x.jsx(
          JDt,
          {
            ref: n,
            autoPlay: !0,
            onEnded: () => {
              n.current !== null && (n.current.currentTime = 0, n.current.play());
            },
            children: /* @__PURE__ */ x.jsx("source", { src: QDt, type: "video/mp4" })
          }
        ),
        /* @__PURE__ */ x.jsx(Wg, { children: /* @__PURE__ */ x.jsx(
          Kxe,
          {
            label: "Progress",
            helperText: $Dt({
              isClusterReady: kt.isClusterReady,
              isDeployingFiles: o === "deploying-files",
              hasDiagramError: kt.hasDiagramError,
              hasProblems: u
            }),
            value: SLt(
              kt.isClusterReady,
              f
            ),
            status: MLt(f, u)
          }
        ) })
      ] }),
      /* @__PURE__ */ x.jsx(Bbe, { children: /* @__PURE__ */ x.jsx(x.Fragment, { children: (() => {
        if (f) {
          if (kt.hasDiagramError)
            return /* @__PURE__ */ x.jsx(
              w5,
              {
                size: "xl",
                onClick: () => e?.(!0),
                children: "View errors in Implement mode"
              }
            );
          if (u)
            return /* @__PURE__ */ x.jsx(w5, { size: "xl", onClick: g, children: "View errors" });
          if (!a)
            return /* @__PURE__ */ x.jsx(
              w5,
              {
                id: "appCuesTargetStartButton",
                size: "xl",
                onClick: g,
                children: "Start a process instance"
              }
            );
        }
      })() }) })
    ] }) });
  }
);
function SLt(r, e) {
  return r ? e ? 100 : 50 : 25;
}
function MLt(r, e) {
  return r ? e ? "error" : "finished" : "active";
}
const DLt = ({ onRefresh: r }) => {
  const e = bn(Cr);
  return /* @__PURE__ */ x.jsxs(tn, { open: !0, maxWidth: 480, children: [
    /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Play session expired" }) }),
    /* @__PURE__ */ x.jsxs(tn.Content, { children: [
      "This Play session has expired due to inactivity.",
      /* @__PURE__ */ x.jsx("br", {}),
      "Click ",
      /* @__PURE__ */ x.jsx("b", { children: "Re-launch session" }),
      " to start a new session."
    ] }),
    /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
      /* @__PURE__ */ x.jsx(
        ji,
        {
          onClick: () => {
            e.switchToImplementMode?.();
          },
          variant: "secondary",
          children: "Exit"
        }
      ),
      /* @__PURE__ */ x.jsx(ji, { onClick: r, variant: "primary", children: "Re-launch session" })
    ] })
  ] });
}, LLt = 0, pIe = 1, kLt = 10, gIe = pIe + LLt, NLt = pIe + kLt;
var TLt = 16;
function et(r) {
  return "".concat(r / TLt, "rem");
}
function Fr(r) {
  return "".concat(r, "px");
}
var Uy = {
  mono: "'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace",
  serif: "'IBM Plex Serif', 'Georgia', Times, serif"
}, rn = {
  light: 300,
  regular: 400,
  semibold: 600
}, tt = [12, 14, 16, 18, 20, 24, 28, 32, 36, 42, 48, 54, 60, 68, 76, 84, 92, 102, 112, 122, 132, 144, 156];
function ILt(r, e, t) {
  return (e = RLt(e)) in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function Zbe(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function vb(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Zbe(Object(t), !0).forEach(function(n) {
      ILt(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Zbe(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function OLt(r, e) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function RLt(r) {
  var e = OLt(r, "string");
  return typeof e == "symbol" ? e : e + "";
}
var VLt = {
  fontSize: et(tt[0]),
  fontWeight: rn.regular,
  lineHeight: 1.33333,
  letterSpacing: Fr(0.32)
}, HLt = {
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: Fr(0.32)
}, BLt = {
  fontSize: et(tt[0]),
  fontWeight: rn.regular,
  lineHeight: 1.33333,
  letterSpacing: Fr(0.32)
}, PLt = {
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: Fr(0.16)
}, FLt = {
  fontSize: et(tt[0]),
  lineHeight: 1.33333,
  letterSpacing: Fr(0.32)
}, zLt = {
  fontSize: et(tt[1]),
  lineHeight: 1.28572,
  letterSpacing: Fr(0.16)
}, mIe = {
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: Fr(0.16)
}, AIe = {
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.42857,
  letterSpacing: Fr(0.16)
}, wIe = {
  fontSize: et(tt[2]),
  fontWeight: rn.regular,
  lineHeight: 1.375,
  letterSpacing: 0
}, vIe = {
  fontSize: et(tt[2]),
  fontWeight: rn.regular,
  lineHeight: 1.5,
  letterSpacing: 0
}, WLt = {
  fontFamily: Uy.mono,
  fontSize: et(tt[0]),
  fontWeight: rn.regular,
  lineHeight: 1.33333,
  letterSpacing: Fr(0.32)
}, jLt = {
  fontFamily: Uy.mono,
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.42857,
  letterSpacing: Fr(0.32)
}, bIe = {
  fontSize: et(tt[1]),
  fontWeight: rn.semibold,
  lineHeight: 1.42857,
  letterSpacing: Fr(0.16)
}, yIe = {
  fontSize: et(tt[1]),
  fontWeight: rn.semibold,
  lineHeight: 1.28572,
  letterSpacing: Fr(0.16)
}, CIe = {
  fontSize: et(tt[2]),
  fontWeight: rn.semibold,
  lineHeight: 1.5,
  letterSpacing: 0
}, EIe = {
  fontSize: et(tt[2]),
  fontWeight: rn.semibold,
  lineHeight: 1.375,
  letterSpacing: 0
}, _Ie = {
  fontSize: et(tt[4]),
  fontWeight: rn.regular,
  lineHeight: 1.4,
  letterSpacing: 0
}, xIe = {
  fontSize: et(tt[6]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: 0
}, SIe = {
  fontSize: et(tt[7]),
  fontWeight: rn.regular,
  lineHeight: 1.25,
  letterSpacing: 0
}, MIe = {
  fontSize: et(tt[9]),
  fontWeight: rn.light,
  lineHeight: 1.199,
  letterSpacing: 0
}, DIe = {
  fontSize: et(tt[11]),
  fontWeight: rn.light,
  lineHeight: 1.199,
  letterSpacing: 0
}, ZLt = vb(vb({}, bIe), {}, {
  lineHeight: 1.25
}), ULt = vb(vb({}, CIe), {}, {
  lineHeight: 1.5
}), LIe = {
  fontSize: et(tt[4]),
  fontWeight: rn.regular,
  lineHeight: 1.4,
  letterSpacing: 0,
  breakpoints: {
    xlg: {
      fontSize: et(tt[4]),
      lineHeight: 1.4
    },
    max: {
      fontSize: et(tt[5]),
      lineHeight: 1.334
    }
  }
}, kIe = {
  fontSize: et(tt[6]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: 0,
  breakpoints: {
    xlg: {
      fontSize: et(tt[7]),
      fontWeight: rn.regular,
      lineHeight: 1.25
    },
    max: {
      fontSize: et(tt[7]),
      fontWeight: rn.regular
    }
  }
}, NIe = {
  fontSize: et(tt[7]),
  fontWeight: rn.regular,
  lineHeight: 1.25,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[8]),
      fontWeight: rn.light,
      lineHeight: 1.22,
      letterSpacing: 0
    },
    lg: {
      fontSize: et(tt[9]),
      lineHeight: 1.19,
      letterSpacing: 0
    },
    xlg: {
      fontSize: et(tt[10]),
      lineHeight: 1.17,
      letterSpacing: 0
    },
    max: {
      fontSize: et(tt[12]),
      letterSpacing: 0
    }
  }
}, TIe = {
  fontSize: et(tt[7]),
  fontWeight: rn.semibold,
  lineHeight: 1.25,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[8]),
      fontWeight: rn.semibold,
      lineHeight: 1.22,
      letterSpacing: 0
    },
    lg: {
      fontSize: et(tt[9]),
      fontWeight: rn.semibold,
      lineHeight: 1.19,
      letterSpacing: 0
    },
    xlg: {
      fontSize: et(tt[10]),
      fontWeight: rn.semibold,
      lineHeight: 1.17,
      letterSpacing: 0
    },
    max: {
      fontSize: et(tt[12]),
      fontWeight: rn.semibold,
      letterSpacing: 0
    }
  }
}, IIe = {
  fontSize: et(tt[5]),
  fontWeight: rn.light,
  lineHeight: 1.334,
  letterSpacing: 0,
  breakpoints: {
    lg: {
      fontSize: et(tt[6]),
      lineHeight: 1.28572
    },
    max: {
      fontSize: et(tt[7]),
      lineHeight: 1.25
    }
  }
}, OIe = {
  fontFamily: Uy.serif,
  fontSize: et(tt[4]),
  fontWeight: rn.regular,
  lineHeight: 1.3,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[4]),
      fontWeight: rn.regular,
      letterSpacing: 0
    },
    lg: {
      fontSize: et(tt[5]),
      fontWeight: rn.regular,
      lineHeight: 1.334,
      letterSpacing: 0
    },
    xlg: {
      fontSize: et(tt[6]),
      fontWeight: rn.regular,
      lineHeight: 1.28572,
      letterSpacing: 0
    },
    max: {
      fontSize: et(tt[7]),
      fontWeight: rn.regular,
      lineHeight: 1.25,
      letterSpacing: 0
    }
  }
}, RIe = {
  fontFamily: Uy.serif,
  fontSize: et(tt[7]),
  fontWeight: rn.light,
  lineHeight: 1.25,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[8]),
      lineHeight: 1.22
    },
    lg: {
      fontSize: et(tt[9]),
      lineHeight: 1.19
    },
    xlg: {
      fontSize: et(tt[10]),
      lineHeight: 1.17
    },
    max: {
      fontSize: et(tt[12])
    }
  }
}, VIe = {
  fontSize: et(tt[9]),
  fontWeight: rn.light,
  lineHeight: 1.19,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[9])
    },
    lg: {
      fontSize: et(tt[11])
    },
    xlg: {
      fontSize: et(tt[12]),
      lineHeight: 1.17
    },
    max: {
      fontSize: et(tt[14]),
      lineHeight: 1.13
    }
  }
}, HIe = {
  fontSize: et(tt[9]),
  fontWeight: rn.semibold,
  lineHeight: 1.19,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[9])
    },
    lg: {
      fontSize: et(tt[11])
    },
    xlg: {
      fontSize: et(tt[12]),
      lineHeight: 1.16
    },
    max: {
      fontSize: et(tt[14]),
      lineHeight: 1.13
    }
  }
}, BIe = {
  fontSize: et(tt[9]),
  fontWeight: rn.light,
  lineHeight: 1.19,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[11]),
      lineHeight: 1.18
    },
    lg: {
      fontSize: et(tt[12]),
      lineHeight: 1.16,
      letterSpacing: Fr(-0.64)
    },
    xlg: {
      fontSize: et(tt[14]),
      lineHeight: 1.13
    },
    max: {
      fontSize: et(tt[15]),
      lineHeight: 1.11,
      letterSpacing: Fr(-0.96)
    }
  }
}, PIe = {
  fontSize: et(tt[9]),
  fontWeight: rn.light,
  lineHeight: 1.19,
  letterSpacing: 0,
  breakpoints: {
    md: {
      fontSize: et(tt[13]),
      lineHeight: 1.15
    },
    lg: {
      fontSize: et(tt[16]),
      lineHeight: 1.11,
      letterSpacing: Fr(-0.64)
    },
    xlg: {
      fontSize: et(tt[19]),
      lineHeight: 1.07,
      letterSpacing: Fr(-0.64)
    },
    max: {
      fontSize: et(tt[22]),
      lineHeight: 1.05,
      letterSpacing: Fr(-0.96)
    }
  }
}, qLt = {
  fontSize: et(tt[0]),
  fontWeight: rn.regular,
  lineHeight: 1.33333,
  letterSpacing: Fr(0.32)
}, GLt = {
  fontSize: et(tt[1]),
  fontWeight: rn.regular,
  lineHeight: 1.28572,
  letterSpacing: Fr(0.16)
}, QLt = mIe, KLt = wIe, YLt = AIe, XLt = vIe, JLt = yIe, $Lt = EIe, ekt = _Ie, tkt = xIe, nkt = SIe, ikt = MIe, rkt = DIe, skt = LIe, okt = kIe, akt = NIe, lkt = TIe, ckt = IIe, hkt = OIe, dkt = RIe, ukt = VIe, fkt = HIe, pkt = BIe, gkt = PIe, yl = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  caption01: VLt,
  caption02: HLt,
  label01: BLt,
  label02: PLt,
  helperText01: FLt,
  helperText02: zLt,
  bodyShort01: mIe,
  bodyLong01: AIe,
  bodyShort02: wIe,
  bodyLong02: vIe,
  code01: WLt,
  code02: jLt,
  heading01: bIe,
  productiveHeading01: yIe,
  heading02: CIe,
  productiveHeading02: EIe,
  productiveHeading03: _Ie,
  productiveHeading04: xIe,
  productiveHeading05: SIe,
  productiveHeading06: MIe,
  productiveHeading07: DIe,
  expressiveHeading01: ZLt,
  expressiveHeading02: ULt,
  expressiveHeading03: LIe,
  expressiveHeading04: kIe,
  expressiveHeading05: NIe,
  expressiveHeading06: TIe,
  expressiveParagraph01: IIe,
  quotation01: OIe,
  quotation02: RIe,
  display01: VIe,
  display02: HIe,
  display03: BIe,
  display04: PIe,
  legal01: qLt,
  legal02: GLt,
  bodyCompact01: QLt,
  bodyCompact02: KLt,
  body01: YLt,
  body02: XLt,
  headingCompact01: JLt,
  headingCompact02: $Lt,
  heading03: ekt,
  heading04: tkt,
  heading05: nkt,
  heading06: ikt,
  heading07: rkt,
  fluidHeading03: skt,
  fluidHeading04: okt,
  fluidHeading05: akt,
  fluidHeading06: lkt,
  fluidParagraph01: ckt,
  fluidQuotation01: hkt,
  fluidQuotation02: dkt,
  fluidDisplay01: ukt,
  fluidDisplay02: fkt,
  fluidDisplay03: pkt,
  fluidDisplay04: gkt
});
const mkt = q.div`
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: rgba(22, 22, 22, 0.5);
  color: white;
  z-index: ${NLt};
  display: flex;
  align-items: center;
  justify-content: center;
  ${yl.heading04};
`;
function Ma(r, e) {
  e && (r.super_ = e, r.prototype = Object.create(e.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }));
}
var Akt = 1e3;
function Ac(r, e) {
  var t = this;
  e = e || Akt, r.on(["render.shape", "render.connection"], e, function(n, i) {
    var s = n.type, o = i.element, a = i.gfx, l = i.attrs;
    if (t.canRender(o))
      return s === "render.shape" ? t.drawShape(a, o, l) : t.drawConnection(a, o, l);
  }), r.on(["render.getShapePath", "render.getConnectionPath"], e, function(n, i) {
    if (t.canRender(i))
      return n.type === "render.getShapePath" ? t.getShapePath(i) : t.getConnectionPath(i);
  });
}
Ac.prototype.canRender = function(r) {
};
Ac.prototype.drawShape = function(r, e) {
};
Ac.prototype.drawConnection = function(r, e) {
};
Ac.prototype.getShapePath = function(r) {
};
Ac.prototype.getConnectionPath = function(r) {
};
function wkt(r) {
  return Od(r) && qg(r, "waypoints");
}
function FIe(r) {
  return Od(r) && qg(r, "labelTarget");
}
var bb = {
  width: 90,
  height: 20
}, Ube = 15;
function vkt(r) {
  return He(r, "bpmn:Event") || He(r, "bpmn:Gateway") || He(r, "bpmn:DataStoreReference") || He(r, "bpmn:DataObjectReference") || He(r, "bpmn:DataInput") || He(r, "bpmn:DataOutput") || He(r, "bpmn:SequenceFlow") || He(r, "bpmn:MessageFlow") || He(r, "bpmn:Group");
}
function bkt(r) {
  var e = r.length / 2 - 1, t = r[Math.floor(e)], n = r[Math.ceil(e + 0.01)], i = ykt(r), s = Math.atan((n.y - t.y) / (n.x - t.x)), o = i.x, a = i.y;
  return Math.abs(s) < Math.PI / 2 ? a -= Ube : o += Ube, { x: o, y: a };
}
function ykt(r) {
  var e = r.length / 2 - 1, t = r[Math.floor(e)], n = r[Math.ceil(e + 0.01)];
  return {
    x: t.x + (n.x - t.x) / 2,
    y: t.y + (n.y - t.y) / 2
  };
}
function Ckt(r) {
  return r.waypoints ? bkt(r.waypoints) : He(r, "bpmn:Group") ? {
    x: r.x + r.width / 2,
    y: r.y + bb.height / 2
  } : {
    x: r.x + r.width / 2,
    y: r.y + r.height + bb.height / 2
  };
}
function Ekt(r, e) {
  var t, n, i, s = r.label;
  return s && s.bounds ? (i = s.bounds, n = {
    width: Math.max(bb.width, i.width),
    height: i.height
  }, t = {
    x: i.x + i.width / 2,
    y: i.y + i.height / 2
  }) : (t = Ckt(e), n = bb), Ft({
    x: t.x - n.width / 2,
    y: t.y - n.height / 2
  }, n);
}
function _kt(r) {
  if (He(r, "bpmn:FlowElement") || He(r, "bpmn:Participant") || He(r, "bpmn:Lane") || He(r, "bpmn:SequenceFlow") || He(r, "bpmn:MessageFlow") || He(r, "bpmn:DataInput") || He(r, "bpmn:DataOutput"))
    return "name";
  if (He(r, "bpmn:TextAnnotation"))
    return "text";
  if (He(r, "bpmn:Group"))
    return "categoryValueRef";
}
function xkt(r) {
  var e = r.categoryValueRef;
  return e && e.value || "";
}
function yb(r) {
  var e = r.businessObject, t = _kt(e);
  if (t)
    return t === "categoryValueRef" ? xkt(e) : e[t] || "";
}
function Skt(r, e) {
  if (r.ownerDocument !== e.ownerDocument)
    try {
      return e.ownerDocument.importNode(r, !0);
    } catch {
    }
  return r;
}
function Mkt(r, e) {
  return e.appendChild(Skt(r, e));
}
function Ld(r, e) {
  return Mkt(e, r), r;
}
var EN = 2, zIe = {
  "alignment-baseline": 1,
  "baseline-shift": 1,
  clip: 1,
  "clip-path": 1,
  "clip-rule": 1,
  color: 1,
  "color-interpolation": 1,
  "color-interpolation-filters": 1,
  "color-profile": 1,
  "color-rendering": 1,
  cursor: 1,
  direction: 1,
  display: 1,
  "dominant-baseline": 1,
  "enable-background": 1,
  fill: 1,
  "fill-opacity": 1,
  "fill-rule": 1,
  filter: 1,
  "flood-color": 1,
  "flood-opacity": 1,
  font: 1,
  "font-family": 1,
  "font-size": EN,
  "font-size-adjust": 1,
  "font-stretch": 1,
  "font-style": 1,
  "font-variant": 1,
  "font-weight": 1,
  "glyph-orientation-horizontal": 1,
  "glyph-orientation-vertical": 1,
  "image-rendering": 1,
  kerning: 1,
  "letter-spacing": 1,
  "lighting-color": 1,
  marker: 1,
  "marker-end": 1,
  "marker-mid": 1,
  "marker-start": 1,
  mask: 1,
  opacity: 1,
  overflow: 1,
  "pointer-events": 1,
  "shape-rendering": 1,
  "stop-color": 1,
  "stop-opacity": 1,
  stroke: 1,
  "stroke-dasharray": 1,
  "stroke-dashoffset": 1,
  "stroke-linecap": 1,
  "stroke-linejoin": 1,
  "stroke-miterlimit": 1,
  "stroke-opacity": 1,
  "stroke-width": EN,
  "text-anchor": 1,
  "text-decoration": 1,
  "text-rendering": 1,
  "unicode-bidi": 1,
  visibility: 1,
  "word-spacing": 1,
  "writing-mode": 1
};
function Dkt(r, e) {
  return zIe[e] ? r.style[e] : r.getAttributeNS(null, e);
}
function Lkt(r, e, t) {
  var n = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = zIe[n];
  i ? (i === EN && typeof t == "number" && (t = String(t) + "px"), r.style[n] = t) : r.setAttributeNS(null, e, t);
}
function kkt(r, e) {
  var t = Object.keys(e), n, i;
  for (n = 0, i; i = t[n]; n++)
    Lkt(r, i, e[i]);
}
function kd(r, e, t) {
  return typeof e == "string" ? Dkt(r, e) : (kkt(r, e), r);
}
function Nkt(r) {
  var e = r.parentNode;
  return e && e.removeChild(r), r;
}
function WIe(r) {
  for (var e; e = r.firstChild; )
    Nkt(e);
  return r;
}
var gV = {
  svg: "http://www.w3.org/2000/svg"
}, qbe = '<svg xmlns="' + gV.svg + '"';
function Tkt(r) {
  var e = !1;
  r.substring(0, 4) === "<svg" ? r.indexOf(gV.svg) === -1 && (r = qbe + r.substring(4)) : (r = qbe + ">" + r + "</svg>", e = !0);
  var t = Ikt(r);
  if (!e)
    return t;
  for (var n = document.createDocumentFragment(), i = t.firstChild; i.firstChild; )
    n.appendChild(i.firstChild);
  return n;
}
function Ikt(r) {
  var e;
  return e = new DOMParser(), e.async = !1, e.parseFromString(r, "text/xml");
}
function md(r, e) {
  var t;
  return r.charAt(0) === "<" ? (t = Tkt(r).firstChild, t = document.importNode(t, !0)) : t = document.createElementNS(gV.svg, r), t;
}
function Okt(r, e) {
  return e = e || "zeebe:modelerTemplateIcon", an(r).get(e);
}
var Rkt = 1250;
function dm(r, e, t) {
  this._bpmnRenderer = e, this._iconProperty = r && r.iconProperty, Ac.call(this, t, Rkt);
}
Ma(dm, Ac);
dm.prototype.canRender = function(r) {
  return FIe(r) ? !1 : !!(XSe(r, ["bpmn:Activity", "bpmn:Event"]) && this._getIcon(r));
};
dm.prototype._getIcon = function(r) {
  return Okt(r, this._iconProperty);
};
dm.prototype.drawShape = function(r, e, t = {}) {
  var n = this._bpmnRenderer.handlers[[
    "bpmn:BoundaryEvent",
    "bpmn:CallActivity",
    "bpmn:EndEvent",
    "bpmn:IntermediateCatchEvent",
    "bpmn:IntermediateThrowEvent",
    "bpmn:StartEvent",
    "bpmn:Task",
    // specialized subprocess before general
    "bpmn:AdHocSubProcess",
    "bpmn:Transaction",
    "bpmn:SubProcess"
  ].find((c) => He(e, c))], i = n(r, e, { ...t, renderIcon: !1 }), s = this._getIcon(e), o = 18, a = He(e, "bpmn:Activity") ? {
    x: 5,
    y: 5
  } : {
    x: (e.width - o) / 2,
    y: (e.height - o) / 2
  }, l = md("image");
  return kd(l, {
    href: s,
    width: o,
    height: o,
    ...a
  }), Ld(r, l), i;
};
dm.$inject = [
  "config.elementTemplateIconRenderer",
  "bpmnRenderer",
  "eventBus"
];
const mV = {
  __init__: ["elementTemplateIconRenderer"],
  elementTemplateIconRenderer: ["type", dm]
};
function Vkt(r, e) {
  if (r.ownerDocument !== e.ownerDocument)
    try {
      return e.ownerDocument.importNode(r, !0);
    } catch {
    }
  return r;
}
function Hkt(r, e) {
  return e.appendChild(Vkt(r, e));
}
function oh(r, e) {
  return Hkt(e, r), r;
}
var _N = 2, jIe = {
  "alignment-baseline": 1,
  "baseline-shift": 1,
  clip: 1,
  "clip-path": 1,
  "clip-rule": 1,
  color: 1,
  "color-interpolation": 1,
  "color-interpolation-filters": 1,
  "color-profile": 1,
  "color-rendering": 1,
  cursor: 1,
  direction: 1,
  display: 1,
  "dominant-baseline": 1,
  "enable-background": 1,
  fill: 1,
  "fill-opacity": 1,
  "fill-rule": 1,
  filter: 1,
  "flood-color": 1,
  "flood-opacity": 1,
  font: 1,
  "font-family": 1,
  "font-size": _N,
  "font-size-adjust": 1,
  "font-stretch": 1,
  "font-style": 1,
  "font-variant": 1,
  "font-weight": 1,
  "glyph-orientation-horizontal": 1,
  "glyph-orientation-vertical": 1,
  "image-rendering": 1,
  kerning: 1,
  "letter-spacing": 1,
  "lighting-color": 1,
  marker: 1,
  "marker-end": 1,
  "marker-mid": 1,
  "marker-start": 1,
  mask: 1,
  opacity: 1,
  overflow: 1,
  "pointer-events": 1,
  "shape-rendering": 1,
  "stop-color": 1,
  "stop-opacity": 1,
  stroke: 1,
  "stroke-dasharray": 1,
  "stroke-dashoffset": 1,
  "stroke-linecap": 1,
  "stroke-linejoin": 1,
  "stroke-miterlimit": 1,
  "stroke-opacity": 1,
  "stroke-width": _N,
  "text-anchor": 1,
  "text-decoration": 1,
  "text-rendering": 1,
  "unicode-bidi": 1,
  visibility: 1,
  "word-spacing": 1,
  "writing-mode": 1
};
function Bkt(r, e) {
  return jIe[e] ? r.style[e] : r.getAttributeNS(null, e);
}
function ZIe(r, e, t) {
  var n = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = jIe[n];
  i ? (i === _N && typeof t == "number" && (t = String(t) + "px"), r.style[n] = t) : r.setAttributeNS(null, e, t);
}
function Pkt(r, e) {
  var t = Object.keys(e), n, i;
  for (n = 0, i; i = t[n]; n++)
    ZIe(r, i, e[i]);
}
function tr(r, e, t) {
  if (typeof e == "string")
    if (t !== void 0)
      ZIe(r, e, t);
    else
      return Bkt(r, e);
  else
    Pkt(r, e);
  return r;
}
const Fkt = Object.prototype.toString;
function dd(r) {
  return new m1(r);
}
function m1(r) {
  if (!r || !r.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = r, this.list = r.classList;
}
m1.prototype.add = function(r) {
  return this.list.add(r), this;
};
m1.prototype.remove = function(r) {
  return Fkt.call(r) == "[object RegExp]" ? this.removeMatching(r) : (this.list.remove(r), this);
};
m1.prototype.removeMatching = function(r) {
  const e = this.array();
  for (let t = 0; t < e.length; t++)
    r.test(e[t]) && this.remove(e[t]);
  return this;
};
m1.prototype.toggle = function(r, e) {
  return typeof e < "u" ? e !== this.list.toggle(r, e) && this.list.toggle(r) : this.list.toggle(r), this;
};
m1.prototype.array = function() {
  return Array.from(this.list);
};
m1.prototype.has = m1.prototype.contains = function(r) {
  return this.list.contains(r);
};
var AV = {
  svg: "http://www.w3.org/2000/svg"
}, Gbe = '<svg xmlns="' + AV.svg + '"';
function zkt(r) {
  var e = !1;
  r.substring(0, 4) === "<svg" ? r.indexOf(AV.svg) === -1 && (r = Gbe + r.substring(4)) : (r = Gbe + ">" + r + "</svg>", e = !0);
  var t = Wkt(r);
  if (!e)
    return t;
  for (var n = document.createDocumentFragment(), i = t.firstChild; i.firstChild; )
    n.appendChild(i.firstChild);
  return n;
}
function Wkt(r) {
  var e;
  return e = new DOMParser(), e.async = !1, e.parseFromString(r, "text/xml");
}
function Fo(r, e) {
  var t;
  return r = r.trim(), r.charAt(0) === "<" ? (t = zkt(r).firstChild, t = document.importNode(t, !0)) : t = document.createElementNS(AV.svg, r), e && tr(t, e), t;
}
var V_ = null;
function UIe() {
  return V_ === null && (V_ = Fo("svg")), V_;
}
function Qbe(r, e) {
  var t, n, i = Object.keys(e);
  for (t = 0; n = i[t]; t++)
    r[n] = e[n];
  return r;
}
function jkt(r, e, t, n, i, s) {
  var o = UIe().createSVGMatrix();
  switch (arguments.length) {
    case 0:
      return o;
    case 1:
      return Qbe(o, r);
    case 6:
      return Qbe(o, {
        a: r,
        b: e,
        c: t,
        d: n,
        e: i,
        f: s
      });
  }
}
function f3(r) {
  return UIe().createSVGTransform();
}
function jw(r) {
  var e = r.parentNode;
  return e && e.removeChild(r), r;
}
function Zkt(r, e) {
  return e instanceof SVGMatrix ? r.createSVGTransformFromMatrix(e) : e;
}
function Ukt(r, e) {
  var t, n;
  for (r.clear(), t = 0; n = e[t]; t++)
    r.appendItem(Zkt(r, n));
}
function y4(r, e) {
  var t = r.transform.baseVal;
  return e && (Array.isArray(e) || (e = [e]), Ukt(t, e)), t.consolidate();
}
function a2(r) {
  return r.flat().join(",").replace(/,?([A-Za-z]),?/g, "$1");
}
function qkt(r) {
  return ["M", r.x, r.y];
}
function H_(r) {
  return ["L", r.x, r.y];
}
function Gkt(r, e, t) {
  return ["C", r.x, r.y, e.x, e.y, t.x, t.y];
}
function Qkt(r, e) {
  const t = r.length, n = [qkt(r[0])];
  for (let i = 1; i < t; i++) {
    const s = r[i - 1], o = r[i], a = r[i + 1];
    if (!a || !e) {
      n.push(H_(o));
      continue;
    }
    const l = Math.min(
      e,
      xN(o.x - s.x, o.y - s.y),
      xN(a.x - o.x, a.y - o.y)
    );
    if (!l) {
      n.push(H_(o));
      continue;
    }
    const c = v5(o, s, l), d = v5(o, s, l * 0.5), u = v5(o, a, l), f = v5(o, a, l * 0.5);
    n.push(H_(c)), n.push(Gkt(d, f, u));
  }
  return n;
}
function v5(r, e, t) {
  const n = e.x - r.x, i = e.y - r.y, s = xN(n, i), o = t / s;
  return {
    x: r.x + n * o,
    y: r.y + i * o
  };
}
function xN(r, e) {
  return Math.sqrt(Math.pow(r, 2) + Math.pow(e, 2));
}
function wV(r, e, t) {
  ec(e) && (t = e, e = null), e || (e = {});
  const n = Fo("path", e);
  return ec(t) && (n.dataset.cornerRadius = String(t)), qIe(n, r);
}
function qIe(r, e) {
  const t = parseInt(r.dataset.cornerRadius, 10) || 0;
  return tr(r, {
    d: a2(Qkt(e, t))
  }), r;
}
var SN = "hsl(225, 10%, 15%)", Kkt = "white";
function kc(r, e) {
  return b7(r.eventDefinitions, function(t) {
    return t.$type === e;
  });
}
function Ykt(r) {
  return r.$type === "bpmn:IntermediateThrowEvent" || r.$type === "bpmn:EndEvent";
}
function Xkt(r) {
  var e = r.dataObjectRef;
  return r.isCollection || e && e.isCollection;
}
function Qt(r, e, t) {
  var n = df(r);
  return t || n.get("color:background-color") || n.get("bioc:fill") || e || Kkt;
}
function Ke(r, e, t) {
  var n = df(r);
  return t || n.get("color:border-color") || n.get("bioc:stroke") || e || SN;
}
function Jm(r, e, t, n) {
  var i = df(r), s = i.get("label");
  return n || s && s.get("color:color") || e || Ke(r, t);
}
function Jkt(r) {
  var e = r.x + r.width / 2, t = r.y + r.height / 2, n = r.width / 2, i = [
    ["M", e, t],
    ["m", 0, -n],
    ["a", n, n, 0, 1, 1, 0, 2 * n],
    ["a", n, n, 0, 1, 1, 0, -2 * n],
    ["z"]
  ];
  return a2(i);
}
function $kt(r, e) {
  var t = r.x, n = r.y, i = r.width, s = r.height, o = [
    ["M", t + e, n],
    ["l", i - e * 2, 0],
    ["a", e, e, 0, 0, 1, e, e],
    ["l", 0, s - e * 2],
    ["a", e, e, 0, 0, 1, -10, e],
    ["l", e * 2 - i, 0],
    ["a", e, e, 0, 0, 1, -10, -10],
    ["l", 0, e * 2 - s],
    ["a", e, e, 0, 0, 1, e, -10],
    ["z"]
  ];
  return a2(o);
}
function eNt(r) {
  var e = r.width, t = r.height, n = r.x, i = r.y, s = e / 2, o = t / 2, a = [
    ["M", n + s, i],
    ["l", s, o],
    ["l", -s, o],
    ["l", -s, -o],
    ["z"]
  ];
  return a2(a);
}
function tNt(r) {
  var e = r.x, t = r.y, n = r.width, i = r.height, s = [
    ["M", e, t],
    ["l", n, 0],
    ["l", 0, i],
    ["l", -n, 0],
    ["z"]
  ];
  return a2(s);
}
function $m(r, e = {}) {
  return {
    width: Ba(r, e),
    height: vo(r, e)
  };
}
function Ba(r, e = {}) {
  return qg(e, "width") ? e.width : r.width;
}
function vo(r, e = {}) {
  return qg(e, "height") ? e.height : r.height;
}
function nNt(r, e) {
  return e.forEach(function(t) {
    t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
      if (n !== "default" && !(n in r)) {
        var i = Object.getOwnPropertyDescriptor(t, n);
        Object.defineProperty(r, n, i.get ? i : {
          enumerable: !0,
          get: function() {
            return t[n];
          }
        });
      }
    });
  }), Object.freeze(r);
}
const iNt = Object.prototype.toString, rNt = Object.prototype.hasOwnProperty;
function sNt(r) {
  return r === void 0;
}
function oNt(r) {
  return iNt.call(r) === "[object Array]";
}
function aNt(r, e) {
  return rNt.call(r, e);
}
function Kbe(r, e) {
  let t, n;
  if (sNt(r))
    return;
  const i = oNt(r) ? cNt : lNt;
  for (let s in r)
    if (aNt(r, s) && (t = r[s], n = e(t, i(s)), n === !1))
      return t;
}
function lNt(r) {
  return r;
}
function cNt(r) {
  return Number(r);
}
function Lo(r, ...e) {
  const t = r.style;
  return Kbe(e, function(n) {
    n && Kbe(n, function(i, s) {
      t[s] = i;
    });
  }), r;
}
function qy(r, e, t) {
  return arguments.length == 2 ? r.getAttribute(e) : t === null ? r.removeAttribute(e) : (r.setAttribute(e, t), r);
}
const hNt = Object.prototype.toString;
function Ja(r) {
  return new A1(r);
}
function A1(r) {
  if (!r || !r.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = r, this.list = r.classList;
}
A1.prototype.add = function(r) {
  return this.list.add(r), this;
};
A1.prototype.remove = function(r) {
  return hNt.call(r) == "[object RegExp]" ? this.removeMatching(r) : (this.list.remove(r), this);
};
A1.prototype.removeMatching = function(r) {
  const e = this.array();
  for (let t = 0; t < e.length; t++)
    r.test(e[t]) && this.remove(e[t]);
  return this;
};
A1.prototype.toggle = function(r, e) {
  return typeof e < "u" ? e !== this.list.toggle(r, e) && this.list.toggle(r) : this.list.toggle(r), this;
};
A1.prototype.array = function() {
  return Array.from(this.list);
};
A1.prototype.has = A1.prototype.contains = function(r) {
  return this.list.contains(r);
};
function GIe(r) {
  for (var e; e = r.firstChild; )
    r.removeChild(e);
  return r;
}
function QIe(r, e, t) {
  var n = t ? r : r.parentNode;
  return n && typeof n.closest == "function" && n.closest(e) || null;
}
var Cb = {}, Eb, MN, vV;
function KIe() {
  Eb = window.addEventListener ? "addEventListener" : "attachEvent", MN = window.removeEventListener ? "removeEventListener" : "detachEvent", vV = Eb !== "addEventListener" ? "on" : "";
}
var dNt = Cb.bind = function(r, e, t, n) {
  return Eb || KIe(), r[Eb](vV + e, t, n || !1), t;
}, uNt = Cb.unbind = function(r, e, t, n) {
  return MN || KIe(), r[MN](vV + e, t, n || !1), t;
}, fr = /* @__PURE__ */ nNt({
  __proto__: null,
  bind: dNt,
  unbind: uNt,
  default: Cb
}, [Cb]), YIe = ["focus", "blur"];
function fNt(r, e, t, n, i) {
  return YIe.indexOf(t) !== -1 && (i = !0), fr.bind(r, t, function(s) {
    var o = s.target || s.srcElement;
    s.delegateTarget = QIe(o, e, !0), s.delegateTarget && n.call(r, s);
  }, i);
}
function pNt(r, e, t, n) {
  return YIe.indexOf(e) !== -1 && (n = !0), fr.unbind(r, e, t, n);
}
var DN = {
  bind: fNt,
  unbind: pNt
}, gNt = mNt, XIe = !1, b5;
typeof document < "u" && (b5 = document.createElement("div"), b5.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>', XIe = !b5.getElementsByTagName("link").length, b5 = void 0);
var hr = {
  legend: [1, "<fieldset>", "</fieldset>"],
  tr: [2, "<table><tbody>", "</tbody></table>"],
  col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
  // for script/link/style tags to work in IE6-8, you have to wrap
  // in a div with a non-whitespace character in front, ha!
  _default: XIe ? [1, "X<div>", "</div>"] : [0, "", ""]
};
hr.td = hr.th = [3, "<table><tbody><tr>", "</tr></tbody></table>"];
hr.option = hr.optgroup = [1, '<select multiple="multiple">', "</select>"];
hr.thead = hr.tbody = hr.colgroup = hr.caption = hr.tfoot = [1, "<table>", "</table>"];
hr.polyline = hr.ellipse = hr.polygon = hr.circle = hr.text = hr.line = hr.path = hr.rect = hr.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">', "</svg>"];
function mNt(r, e) {
  if (typeof r != "string") throw new TypeError("String expected");
  e || (e = document);
  var t = /<([\w:]+)/.exec(r);
  if (!t) return e.createTextNode(r);
  r = r.replace(/^\s+|\s+$/g, "");
  var n = t[1];
  if (n == "body") {
    var l = e.createElement("html");
    return l.innerHTML = r, l.removeChild(l.lastChild);
  }
  var i = Object.prototype.hasOwnProperty.call(hr, n) ? hr[n] : hr._default, s = i[0], o = i[1], a = i[2], l = e.createElement("div");
  for (l.innerHTML = o + r + a; s--; ) l = l.lastChild;
  if (l.firstChild == l.lastChild)
    return l.removeChild(l.firstChild);
  for (var c = e.createDocumentFragment(); l.firstChild; )
    c.appendChild(l.removeChild(l.firstChild));
  return c;
}
var Ah = gNt;
function Ps(r, e) {
  return e = e || document, e.querySelector(r);
}
function JIe(r, e) {
  return e = e || document, e.querySelectorAll(r);
}
function _b(r) {
  r.parentNode && r.parentNode.removeChild(r);
}
function ANt(r, e) {
  if (r.ownerDocument !== e.ownerDocument)
    try {
      return e.ownerDocument.importNode(r, !0);
    } catch {
    }
  return r;
}
function wNt(r, e) {
  return e.appendChild(ANt(r, e));
}
function zh(r, e) {
  return wNt(e, r), r;
}
var LN = 2, $Ie = {
  "alignment-baseline": 1,
  "baseline-shift": 1,
  clip: 1,
  "clip-path": 1,
  "clip-rule": 1,
  color: 1,
  "color-interpolation": 1,
  "color-interpolation-filters": 1,
  "color-profile": 1,
  "color-rendering": 1,
  cursor: 1,
  direction: 1,
  display: 1,
  "dominant-baseline": 1,
  "enable-background": 1,
  fill: 1,
  "fill-opacity": 1,
  "fill-rule": 1,
  filter: 1,
  "flood-color": 1,
  "flood-opacity": 1,
  font: 1,
  "font-family": 1,
  "font-size": LN,
  "font-size-adjust": 1,
  "font-stretch": 1,
  "font-style": 1,
  "font-variant": 1,
  "font-weight": 1,
  "glyph-orientation-horizontal": 1,
  "glyph-orientation-vertical": 1,
  "image-rendering": 1,
  kerning: 1,
  "letter-spacing": 1,
  "lighting-color": 1,
  marker: 1,
  "marker-end": 1,
  "marker-mid": 1,
  "marker-start": 1,
  mask: 1,
  opacity: 1,
  overflow: 1,
  "pointer-events": 1,
  "shape-rendering": 1,
  "stop-color": 1,
  "stop-opacity": 1,
  stroke: 1,
  "stroke-dasharray": 1,
  "stroke-dashoffset": 1,
  "stroke-linecap": 1,
  "stroke-linejoin": 1,
  "stroke-miterlimit": 1,
  "stroke-opacity": 1,
  "stroke-width": LN,
  "text-anchor": 1,
  "text-decoration": 1,
  "text-rendering": 1,
  "unicode-bidi": 1,
  visibility: 1,
  "word-spacing": 1,
  "writing-mode": 1
};
function vNt(r, e) {
  return $Ie[e] ? r.style[e] : r.getAttributeNS(null, e);
}
function bNt(r, e, t) {
  var n = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = $Ie[n];
  i ? (i === LN && typeof t == "number" && (t = String(t) + "px"), r.style[n] = t) : r.setAttributeNS(null, e, t);
}
function yNt(r, e) {
  var t = Object.keys(e), n, i;
  for (n = 0, i; i = t[n]; n++)
    bNt(r, i, e[i]);
}
function P2(r, e, t) {
  return typeof e == "string" ? vNt(r, e) : (yNt(r, e), r);
}
const CNt = Object.prototype.toString;
function ENt(r) {
  return new w1(r);
}
function w1(r) {
  if (!r || !r.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = r, this.list = r.classList;
}
w1.prototype.add = function(r) {
  return this.list.add(r), this;
};
w1.prototype.remove = function(r) {
  return CNt.call(r) == "[object RegExp]" ? this.removeMatching(r) : (this.list.remove(r), this);
};
w1.prototype.removeMatching = function(r) {
  const e = this.array();
  for (let t = 0; t < e.length; t++)
    r.test(e[t]) && this.remove(e[t]);
  return this;
};
w1.prototype.toggle = function(r, e) {
  return typeof e < "u" ? e !== this.list.toggle(r, e) && this.list.toggle(r) : this.list.toggle(r), this;
};
w1.prototype.array = function() {
  return Array.from(this.list);
};
w1.prototype.has = w1.prototype.contains = function(r) {
  return this.list.contains(r);
};
var bV = {
  svg: "http://www.w3.org/2000/svg"
}, Ybe = '<svg xmlns="' + bV.svg + '"';
function _Nt(r) {
  var e = !1;
  r.substring(0, 4) === "<svg" ? r.indexOf(bV.svg) === -1 && (r = Ybe + r.substring(4)) : (r = Ybe + ">" + r + "</svg>", e = !0);
  var t = xNt(r);
  if (!e)
    return t;
  for (var n = document.createDocumentFragment(), i = t.firstChild; i.firstChild; )
    n.appendChild(i.firstChild);
  return n;
}
function xNt(r) {
  var e;
  return e = new DOMParser(), e.async = !1, e.parseFromString(r, "text/xml");
}
function Qo(r, e) {
  var t;
  return r = r.trim(), r.charAt(0) === "<" ? (t = _Nt(r).firstChild, t = document.importNode(t, !0)) : t = document.createElementNS(bV.svg, r), e && P2(t, e), t;
}
var Xbe = /([&<>]{1})/g, SNt = /([\n\r"]{1})/g, MNt = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "'"
};
function B_(r, e) {
  function t(n, i) {
    return MNt[i] || i;
  }
  return r.replace(e, t);
}
function eOe(r, e) {
  var t, n, i, s, o;
  switch (r.nodeType) {
    // TEXT
    case 3:
      e.push(B_(r.textContent, Xbe));
      break;
    // ELEMENT
    case 1:
      if (e.push("<", r.tagName), r.hasAttributes())
        for (i = r.attributes, t = 0, n = i.length; t < n; ++t)
          s = i.item(t), e.push(" ", s.name, '="', B_(s.value, SNt), '"');
      if (r.hasChildNodes()) {
        for (e.push(">"), o = r.childNodes, t = 0, n = o.length; t < n; ++t)
          eOe(o.item(t), e);
        e.push("</", r.tagName, ">");
      } else
        e.push("/>");
      break;
    // COMMENT
    case 8:
      e.push("<!--", B_(r.nodeValue, Xbe), "-->");
      break;
    // CDATA
    case 4:
      e.push("<![CDATA[", r.nodeValue, "]]>");
      break;
    default:
      throw new Error("unable to handle node " + r.nodeType);
  }
  return e;
}
function DNt(r) {
  for (var e = r.firstChild, t = []; e; )
    eOe(e, t), e = e.nextSibling;
  return t.join("");
}
function Jbe(r, e) {
  return DNt(r);
}
function P_(r, e, t, n, i) {
  var s = f3();
  s.setTranslate(e, t);
  var o = f3();
  o.setRotate(n || 0, 0, 0);
  var a = f3();
  a.setScale(1, 1), y4(r, [s, o, a]);
}
function tOe(r, e, t) {
  var n = f3();
  n.setTranslate(e, t), y4(r, n);
}
function LNt(r, e) {
  var t = f3();
  t.setRotate(e, 0, 0), y4(r, t);
}
function kNt(r, e) {
  return e = { exports: {} }, r(e, e.exports), e.exports;
}
var NNt = kNt(function(r) {
  var e = r.exports = function(t, n) {
    if (n || (n = 16), t === void 0 && (t = 128), t <= 0) return "0";
    for (var i = Math.log(Math.pow(2, t)) / Math.log(n), s = 2; i === 1 / 0; s *= 2)
      i = Math.log(Math.pow(2, t / s)) / Math.log(n) * s;
    for (var o = i - Math.floor(i), a = "", s = 0; s < Math.floor(i); s++) {
      var l = Math.floor(Math.random() * n).toString(n);
      a = l + a;
    }
    if (o) {
      var c = Math.pow(n, o), l = Math.floor(Math.random() * c).toString(n);
      a = l + a;
    }
    var d = parseInt(a, n);
    return d !== 1 / 0 && d >= Math.pow(2, t) ? e(t, n) : a;
  };
  e.rack = function(t, n, i) {
    var s = function(a) {
      var l = 0;
      do {
        if (l++ > 10)
          if (i) t += i;
          else throw new Error("too many ID collisions, use more bits");
        var c = e(t, n);
      } while (Object.hasOwnProperty.call(o, c));
      return o[c] = a, c;
    }, o = s.hats = {};
    return s.get = function(a) {
      return s.hats[a];
    }, s.set = function(a, l) {
      return s.hats[a] = l, s;
    }, s.bits = t || 128, s.base = n || 16, s;
  };
});
function zd(r) {
  if (!(this instanceof zd))
    return new zd(r);
  r = r || [128, 36, 1], this._seed = r.length ? NNt.rack(r[0], r[1], r[2]) : r;
}
zd.prototype.next = function(r) {
  return this._seed(r || !0);
};
zd.prototype.nextPrefixed = function(r, e) {
  var t;
  do
    t = r + this.next(!0);
  while (this.assigned(t));
  return this.claim(t, e), t;
};
zd.prototype.claim = function(r, e) {
  this._seed.set(r, e || !0);
};
zd.prototype.assigned = function(r) {
  return this._seed.get(r) || !1;
};
zd.prototype.unclaim = function(r) {
  delete this._seed.hats[r];
};
zd.prototype.clear = function() {
  var r = this._seed.hats, e;
  for (e in r)
    this.unclaim(e);
};
var TNt = new zd(), INt = 10, y5 = 3, ONt = 1.5, z6 = 10, T2 = 0.95, RNt = 1, VNt = 0.25;
function l2(r, e, t, n, i, s, o) {
  Ac.call(this, e, o);
  var a = r && r.defaultFillColor, l = r && r.defaultStrokeColor, c = r && r.defaultLabelColor;
  function d(F) {
    return t.computeStyle(F, {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: SN,
      strokeWidth: 2,
      fill: "white"
    });
  }
  function u(F) {
    return t.computeStyle(F, ["no-fill"], {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: SN,
      strokeWidth: 2
    });
  }
  function f(F, I) {
    var {
      ref: O = { x: 0, y: 0 },
      scale: Y = 1,
      element: K,
      parentGfx: ae = i._svg
    } = I, Oe = Qo("marker", {
      id: F,
      viewBox: "0 0 20 20",
      refX: O.x,
      refY: O.y,
      markerWidth: 20 * Y,
      markerHeight: 20 * Y,
      orient: "auto"
    });
    zh(Oe, K);
    var ot = Ps(":scope > defs", ae);
    ot || (ot = Qo("defs"), zh(ae, ot)), zh(ot, Oe);
  }
  function p(F, I, O, Y) {
    var K = TNt.nextPrefixed("marker-");
    return g(F, K, I, O, Y), "url(#" + K + ")";
  }
  function g(F, I, O, Y, K) {
    if (O === "sequenceflow-end") {
      var ae = Qo("path", {
        d: "M 1 5 L 11 10 L 1 15 Z",
        ...d({
          fill: K,
          stroke: K,
          strokeWidth: 1
        })
      });
      f(I, {
        element: ae,
        ref: { x: 11, y: 10 },
        scale: 0.5,
        parentGfx: F
      });
    }
    if (O === "messageflow-start") {
      var Oe = Qo("circle", {
        cx: 6,
        cy: 6,
        r: 3.5,
        ...d({
          fill: Y,
          stroke: K,
          strokeWidth: 1,
          // fix for safari / chrome / firefox bug not correctly
          // resetting stroke dash array
          strokeDasharray: [1e4, 1]
        })
      });
      f(I, {
        element: Oe,
        ref: { x: 6, y: 6 },
        parentGfx: F
      });
    }
    if (O === "messageflow-end") {
      var ot = Qo("path", {
        d: "m 1 5 l 0 -3 l 7 3 l -7 3 z",
        ...d({
          fill: Y,
          stroke: K,
          strokeWidth: 1,
          // fix for safari / chrome / firefox bug not correctly
          // resetting stroke dash array
          strokeDasharray: [1e4, 1]
        })
      });
      f(I, {
        element: ot,
        ref: { x: 8.5, y: 5 },
        parentGfx: F
      });
    }
    if (O === "association-start") {
      var It = Qo("path", {
        d: "M 11 5 L 1 10 L 11 15",
        ...u({
          fill: "none",
          stroke: K,
          strokeWidth: 1.5,
          // fix for safari / chrome / firefox bug not correctly
          // resetting stroke dash array
          strokeDasharray: [1e4, 1]
        })
      });
      f(I, {
        element: It,
        ref: { x: 1, y: 10 },
        scale: 0.5,
        parentGfx: F
      });
    }
    if (O === "association-end") {
      var Mn = Qo("path", {
        d: "M 1 5 L 11 10 L 1 15",
        ...u({
          fill: "none",
          stroke: K,
          strokeWidth: 1.5,
          // fix for safari / chrome / firefox bug not correctly
          // resetting stroke dash array
          strokeDasharray: [1e4, 1]
        })
      });
      f(I, {
        element: Mn,
        ref: { x: 11, y: 10 },
        scale: 0.5,
        parentGfx: F
      });
    }
    if (O === "conditional-flow-marker") {
      var Ii = Qo("path", {
        d: "M 0 10 L 8 6 L 16 10 L 8 14 Z",
        ...d({
          fill: Y,
          stroke: K
        })
      });
      f(I, {
        element: Ii,
        ref: { x: -1, y: 10 },
        scale: 0.5,
        parentGfx: F
      });
    }
    if (O === "conditional-default-flow-marker") {
      var os = Qo("path", {
        d: "M 6 4 L 10 16",
        ...d({
          stroke: K,
          fill: "none"
        })
      });
      f(I, {
        element: os,
        ref: { x: 0, y: 10 },
        scale: 0.5,
        parentGfx: F
      });
    }
  }
  function m(F, I, O, Y, K = {}) {
    Od(Y) && (K = Y, Y = 0), Y = Y || 0, K = d(K);
    var ae = I / 2, Oe = O / 2, ot = Qo("circle", {
      cx: ae,
      cy: Oe,
      r: Math.round((I + O) / 4 - Y),
      ...K
    });
    return zh(F, ot), ot;
  }
  function A(F, I, O, Y, K, ae) {
    Od(K) && (ae = K, K = 0), K = K || 0, ae = d(ae);
    var Oe = Qo("rect", {
      x: K,
      y: K,
      width: I - K * 2,
      height: O - K * 2,
      rx: Y,
      ry: Y,
      ...ae
    });
    return zh(F, Oe), Oe;
  }
  function w(F, I, O, Y) {
    var K = I / 2, ae = O / 2, Oe = [
      { x: K, y: 0 },
      { x: I, y: ae },
      { x: K, y: O },
      { x: 0, y: ae }
    ], ot = Oe.map(function(Mn) {
      return Mn.x + "," + Mn.y;
    }).join(" ");
    Y = d(Y);
    var It = Qo("polygon", {
      ...Y,
      points: ot
    });
    return zh(F, It), It;
  }
  function v(F, I, O, Y) {
    O = u(O);
    var K = wV(I, O, Y);
    return zh(F, K), K;
  }
  function y(F, I, O) {
    return v(F, I, O, 5);
  }
  function _(F, I, O) {
    O = u(O);
    var Y = Qo("path", {
      ...O,
      d: I
    });
    return zh(F, Y), Y;
  }
  function S(F, I, O, Y) {
    return _(I, O, Ft({ "data-marker": F }, Y));
  }
  function D(F) {
    return Ce[F];
  }
  function M(F) {
    return function(I, O, Y) {
      return D(F)(I, O, Y);
    };
  }
  var L = {
    "bpmn:MessageEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_MESSAGE", {
        xScaleFactor: 0.9,
        yScaleFactor: 0.9,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.235,
          my: 0.315
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill), Oe = Y ? Qt(I, a, O.fill) : Ke(I, l, O.stroke), ot = _(F, K, {
        fill: ae,
        stroke: Oe,
        strokeWidth: 1
      });
      return ot;
    },
    "bpmn:TimerEventDefinition": function(F, I, O = {}) {
      var Y = O.width || I.width, K = O.height || I.height, ae = O.width ? 1 : 2, Oe = m(F, Y, K, 0.2 * K, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: ae
      }), ot = n.getScaledPath("EVENT_TIMER_WH", {
        xScaleFactor: 0.75,
        yScaleFactor: 0.75,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: 0.5,
          my: 0.5
        }
      });
      _(F, ot, {
        stroke: Ke(I, l, O.stroke),
        strokeWidth: ae
      });
      for (var It = 0; It < 12; It++) {
        var Mn = n.getScaledPath("EVENT_TIMER_LINE", {
          xScaleFactor: 0.75,
          yScaleFactor: 0.75,
          containerWidth: Y,
          containerHeight: K,
          position: {
            mx: 0.5,
            my: 0.5
          }
        }), Ii = Y / 2, os = K / 2;
        _(F, Mn, {
          strokeWidth: 1,
          stroke: Ke(I, l, O.stroke),
          transform: "rotate(" + It * 30 + "," + os + "," + Ii + ")"
        });
      }
      return Oe;
    },
    "bpmn:EscalationEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_ESCALATION", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.5,
          my: 0.2
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:ConditionalEventDefinition": function(F, I, O = {}) {
      var Y = n.getScaledPath("EVENT_CONDITIONAL", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.5,
          my: 0.222
        }
      });
      return _(F, Y, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:LinkEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_LINK", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.57,
          my: 0.263
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:ErrorEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_ERROR", {
        xScaleFactor: 1.1,
        yScaleFactor: 1.1,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.2,
          my: 0.722
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:CancelEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_CANCEL_45", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.638,
          my: -0.055
        }
      }), ae = Y ? Ke(I, l, O.stroke) : "none", Oe = _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
      return LNt(Oe, 45), Oe;
    },
    "bpmn:CompensateEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_COMPENSATION", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.22,
          my: 0.5
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:SignalEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_SIGNAL", {
        xScaleFactor: 0.9,
        yScaleFactor: 0.9,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.5,
          my: 0.2
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        strokeWidth: 1,
        fill: ae,
        stroke: Ke(I, l, O.stroke)
      });
    },
    "bpmn:MultipleEventDefinition": function(F, I, O = {}, Y) {
      var K = n.getScaledPath("EVENT_MULTIPLE", {
        xScaleFactor: 1.1,
        yScaleFactor: 1.1,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.211,
          my: 0.36
        }
      }), ae = Y ? Ke(I, l, O.stroke) : Qt(I, a, O.fill);
      return _(F, K, {
        fill: ae,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:ParallelMultipleEventDefinition": function(F, I, O = {}) {
      var Y = n.getScaledPath("EVENT_PARALLEL_MULTIPLE", {
        xScaleFactor: 1.2,
        yScaleFactor: 1.2,
        containerWidth: O.width || I.width,
        containerHeight: O.height || I.height,
        position: {
          mx: 0.458,
          my: 0.194
        }
      });
      return _(F, Y, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
    },
    "bpmn:TerminateEventDefinition": function(F, I, O = {}) {
      var Y = m(F, I.width, I.height, 8, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 4
      });
      return Y;
    }
  };
  function T(F, I, O = {}, Y) {
    var K = an(F), ae = Ykt(K), Oe = Y || F;
    return K.get("eventDefinitions") && K.get("eventDefinitions").length > 1 ? K.get("parallelMultiple") ? L["bpmn:ParallelMultipleEventDefinition"](I, Oe, O, ae) : L["bpmn:MultipleEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:MessageEventDefinition") ? L["bpmn:MessageEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:TimerEventDefinition") ? L["bpmn:TimerEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:ConditionalEventDefinition") ? L["bpmn:ConditionalEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:SignalEventDefinition") ? L["bpmn:SignalEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:EscalationEventDefinition") ? L["bpmn:EscalationEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:LinkEventDefinition") ? L["bpmn:LinkEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:ErrorEventDefinition") ? L["bpmn:ErrorEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:CancelEventDefinition") ? L["bpmn:CancelEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:CompensateEventDefinition") ? L["bpmn:CompensateEventDefinition"](I, Oe, O, ae) : kc(K, "bpmn:TerminateEventDefinition") ? L["bpmn:TerminateEventDefinition"](I, Oe, O, ae) : null;
  }
  var B = {
    ParticipantMultiplicityMarker: function(F, I, O = {}) {
      var Y = Ba(I, O), K = vo(I, O), ae = n.getScaledPath("MARKER_PARALLEL", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: (Y / 2 - 6) / Y,
          my: (K - 15) / K
        }
      });
      S("participant-multiplicity", F, ae, {
        strokeWidth: 2,
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
    },
    SubProcessMarker: function(F, I, O = {}) {
      var Y = A(F, 14, 14, 0, {
        strokeWidth: 1,
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
      tOe(Y, I.width / 2 - 7.5, I.height - 20);
      var K = n.getScaledPath("MARKER_SUB_PROCESS", {
        xScaleFactor: 1.5,
        yScaleFactor: 1.5,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: (I.width / 2 - 7.5) / I.width,
          my: (I.height - 20) / I.height
        }
      });
      S("sub-process", F, K, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
    },
    ParallelMarker: function(F, I, O) {
      var Y = Ba(I, O), K = vo(I, O), ae = n.getScaledPath("MARKER_PARALLEL", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: (Y / 2 + O.parallel) / Y,
          my: (K - 20) / K
        }
      });
      S("parallel", F, ae, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
    },
    SequentialMarker: function(F, I, O) {
      var Y = n.getScaledPath("MARKER_SEQUENTIAL", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: (I.width / 2 + O.seq) / I.width,
          my: (I.height - 19) / I.height
        }
      });
      S("sequential", F, Y, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
    },
    CompensationMarker: function(F, I, O) {
      var Y = n.getScaledPath("MARKER_COMPENSATION", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: (I.width / 2 + O.compensation) / I.width,
          my: (I.height - 13) / I.height
        }
      });
      S("compensation", F, Y, {
        strokeWidth: 1,
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      });
    },
    LoopMarker: function(F, I, O) {
      var Y = Ba(I, O), K = vo(I, O), ae = n.getScaledPath("MARKER_LOOP", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: (Y / 2 + O.loop) / Y,
          my: (K - 7) / K
        }
      });
      S("loop", F, ae, {
        strokeWidth: 1.5,
        fill: "none",
        stroke: Ke(I, l, O.stroke),
        strokeMiterlimit: 0.5
      });
    },
    AdhocMarker: function(F, I, O) {
      var Y = Ba(I, O), K = vo(I, O), ae = n.getScaledPath("MARKER_ADHOC", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: (Y / 2 + O.adhoc) / Y,
          my: (K - 15) / K
        }
      });
      S("adhoc", F, ae, {
        strokeWidth: 1,
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke)
      });
    }
  };
  function V(F, I, O, Y) {
    B[F](I, O, Y);
  }
  function N(F, I, O = [], Y = {}) {
    Y = {
      fill: Y.fill,
      stroke: Y.stroke,
      width: Ba(I, Y),
      height: vo(I, Y)
    };
    var K = an(I), ae = O.includes("SubProcessMarker");
    ae ? Y = {
      ...Y,
      seq: -21,
      parallel: -22,
      compensation: -25,
      loop: -18,
      adhoc: 10
    } : Y = {
      ...Y,
      seq: -5,
      parallel: -6,
      compensation: -7,
      loop: 0,
      adhoc: -8
    }, K.get("isForCompensation") && O.push("CompensationMarker"), He(K, "bpmn:AdHocSubProcess") && (O.push("AdhocMarker"), ae || Ft(Y, { compensation: Y.compensation - 18 }));
    var Oe = K.get("loopCharacteristics"), ot = Oe && Oe.get("isSequential");
    Oe && (Ft(Y, {
      compensation: Y.compensation - 18
    }), O.includes("AdhocMarker") && Ft(Y, {
      seq: -23,
      loop: -18,
      parallel: -24
    }), ot === void 0 && O.push("LoopMarker"), ot === !1 && O.push("ParallelMarker"), ot === !0 && O.push("SequentialMarker")), O.includes("CompensationMarker") && O.length === 1 && Ft(Y, {
      compensation: -8
    }), vn(O, function(It) {
      V(It, F, I, Y);
    });
  }
  function R(F, I, O = {}) {
    O = Ft({
      size: {
        width: 100
      }
    }, O);
    var Y = s.createText(I || "", O);
    return ENt(Y).add("djs-label"), zh(F, Y), Y;
  }
  function H(F, I, O, Y = {}) {
    var K = an(I), ae = $m({
      x: I.x,
      y: I.y,
      width: I.width,
      height: I.height
    }, Y);
    return R(F, K.name, {
      align: O,
      box: ae,
      padding: 7,
      style: {
        fill: Jm(I, c, l, Y.stroke)
      }
    });
  }
  function z(F, I, O = {}) {
    var Y = {
      width: 90,
      height: 30,
      x: I.width / 2 + I.x,
      y: I.height / 2 + I.y
    };
    return R(F, yb(I), {
      box: Y,
      fitBox: !0,
      style: Ft(
        {},
        s.getExternalStyle(),
        {
          fill: Jm(I, c, l, O.stroke)
        }
      )
    });
  }
  function U(F, I, O, Y = {}) {
    var K = IB(O), ae = R(F, I, {
      box: {
        height: 30,
        width: K ? vo(O, Y) : Ba(O, Y)
      },
      align: "center-middle",
      style: {
        fill: Jm(O, c, l, Y.stroke)
      }
    });
    if (K) {
      var Oe = -1 * vo(O, Y);
      P_(ae, 0, -Oe, 270);
    }
  }
  function ee(F, I, O = {}) {
    var {
      width: Y,
      height: K
    } = $m(I, O);
    return A(F, Y, K, z6, {
      ...O,
      fill: Qt(I, a, O.fill),
      fillOpacity: T2,
      stroke: Ke(I, l, O.stroke)
    });
  }
  function ce(F, I, O = {}) {
    var Y = an(I), K = Qt(I, a, O.fill), ae = Ke(I, l, O.stroke);
    return (Y.get("associationDirection") === "One" || Y.get("associationDirection") === "Both") && (O.markerEnd = p(F, "association-end", K, ae)), Y.get("associationDirection") === "Both" && (O.markerStart = p(F, "association-start", K, ae)), O = gn(O, [
      "markerStart",
      "markerEnd"
    ]), y(F, I.waypoints, {
      ...O,
      stroke: ae,
      strokeDasharray: "0, 5"
    });
  }
  function se(F, I, O = {}) {
    var Y = Qt(I, a, O.fill), K = Ke(I, l, O.stroke), ae = n.getScaledPath("DATA_OBJECT_PATH", {
      xScaleFactor: 1,
      yScaleFactor: 1,
      containerWidth: I.width,
      containerHeight: I.height,
      position: {
        mx: 0.474,
        my: 0.296
      }
    }), Oe = _(F, ae, {
      fill: Y,
      fillOpacity: T2,
      stroke: K
    }), ot = an(I);
    if (Xkt(ot)) {
      var It = n.getScaledPath("DATA_OBJECT_COLLECTION_PATH", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.33,
          my: (I.height - 18) / I.height
        }
      });
      _(F, It, {
        strokeWidth: 2,
        fill: Y,
        stroke: K
      });
    }
    return Oe;
  }
  function te(F, I, O = {}) {
    return m(F, I.width, I.height, {
      fillOpacity: T2,
      ...O,
      fill: Qt(I, a, O.fill),
      stroke: Ke(I, l, O.stroke)
    });
  }
  function ue(F, I, O = {}) {
    return w(F, I.width, I.height, {
      fill: Qt(I, a, O.fill),
      fillOpacity: T2,
      stroke: Ke(I, l, O.stroke)
    });
  }
  function G(F, I, O = {}) {
    var Y = A(F, Ba(I, O), vo(I, O), 0, {
      fill: Qt(I, a, O.fill),
      fillOpacity: O.fillOpacity || T2,
      stroke: Ke(I, l, O.stroke),
      strokeWidth: 1.5
    }), K = an(I);
    if (He(K, "bpmn:Lane")) {
      var ae = K.get("name");
      U(F, ae, I, O);
    }
    return Y;
  }
  function j(F, I, O = {}) {
    var Y = ee(F, I, O), K = t0(I);
    if (aI(I) && (P2(Y, {
      strokeDasharray: "0, 5.5",
      strokeWidth: 2.5
    }), !K)) {
      var ae = an(I).flowElements || [], Oe = ae.filter((ot) => He(ot, "bpmn:StartEvent"));
      Oe.length === 1 && pe(Oe[0], F, O, I);
    }
    return H(F, I, K ? "center-top" : "center-middle", O), K ? N(F, I, void 0, O) : N(F, I, ["SubProcessMarker"], O), Y;
  }
  function pe(F, I, O, Y) {
    var K = 22, ae = {
      fill: Qt(Y, a, O.fill),
      stroke: Ke(Y, l, O.stroke),
      width: K,
      height: K
    }, Oe = an(F).isInterrupting, ot = Oe ? 0 : 3, It = Oe ? 1 : 1.2, Mn = 20, Ii = (K - Mn) / 2, os = "translate(" + Ii + "," + Ii + ")";
    m(I, Mn, Mn, {
      fill: ae.fill,
      stroke: ae.stroke,
      strokeWidth: It,
      strokeDasharray: ot,
      transform: os
    }), T(F, I, ae, Y);
  }
  function De(F, I, O = {}) {
    var Y = ee(F, I, O);
    return H(F, I, "center-middle", O), N(F, I, void 0, O), Y;
  }
  var Ce = this.handlers = {
    "bpmn:AdHocSubProcess": function(F, I, O = {}) {
      return t0(I) ? O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]) : O = gn(O, [
        "fill",
        "stroke"
      ]), j(F, I, O);
    },
    "bpmn:Association": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), ce(F, I, O);
    },
    "bpmn:BoundaryEvent": function(F, I, O = {}) {
      var { renderIcon: Y = !0 } = O;
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var K = an(I), ae = K.get("cancelActivity");
      O = {
        strokeWidth: 1.5,
        fill: Qt(I, a, O.fill),
        fillOpacity: RNt,
        stroke: Ke(I, l, O.stroke)
      }, ae || (O.strokeDasharray = "6");
      var Oe = te(F, I, O);
      return m(F, I.width, I.height, y5, {
        ...O,
        fill: "none"
      }), Y && T(I, F, O), Oe;
    },
    "bpmn:BusinessRuleTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O), K = n.getScaledPath("TASK_TYPE_BUSINESS_RULE_MAIN", {
        abspos: {
          x: 8,
          y: 8
        }
      }), ae = _(F, K);
      P2(ae, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
      var Oe = n.getScaledPath("TASK_TYPE_BUSINESS_RULE_HEADER", {
        abspos: {
          x: 8,
          y: 8
        }
      }), ot = _(F, Oe);
      return P2(ot, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:CallActivity": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), j(F, I, {
        strokeWidth: 5,
        ...O
      });
    },
    "bpmn:ComplexGateway": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = ue(F, I, O), K = n.getScaledPath("GATEWAY_COMPLEX", {
        xScaleFactor: 0.5,
        yScaleFactor: 0.5,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.46,
          my: 0.26
        }
      });
      return _(F, K, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:DataInput": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = n.getRawPath("DATA_ARROW"), K = se(F, I, O);
      return _(F, Y, {
        fill: "none",
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), K;
    },
    "bpmn:DataInputAssociation": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), ce(F, I, {
        ...O,
        markerEnd: p(F, "association-end", Qt(I, a, O.fill), Ke(I, l, O.stroke))
      });
    },
    "bpmn:DataObject": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), se(F, I, O);
    },
    "bpmn:DataObjectReference": M("bpmn:DataObject"),
    "bpmn:DataOutput": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = n.getRawPath("DATA_ARROW"), K = se(F, I, O);
      return _(F, Y, {
        strokeWidth: 1,
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke)
      }), K;
    },
    "bpmn:DataOutputAssociation": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), ce(F, I, {
        ...O,
        markerEnd: p(F, "association-end", Qt(I, a, O.fill), Ke(I, l, O.stroke))
      });
    },
    "bpmn:DataStoreReference": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = n.getScaledPath("DATA_STORE", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0,
          my: 0.133
        }
      });
      return _(F, Y, {
        fill: Qt(I, a, O.fill),
        fillOpacity: T2,
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 2
      });
    },
    "bpmn:EndEvent": function(F, I, O = {}) {
      var { renderIcon: Y = !0 } = O;
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var K = te(F, I, {
        ...O,
        strokeWidth: 4
      });
      return Y && T(I, F, O), K;
    },
    "bpmn:EventBasedGateway": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = an(I), K = ue(F, I, O);
      m(F, I.width, I.height, I.height * 0.2, {
        fill: Qt(I, "none", O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      });
      var ae = Y.get("eventGatewayType"), Oe = !!Y.get("instantiate");
      function ot() {
        var Mn = n.getScaledPath("GATEWAY_EVENT_BASED", {
          xScaleFactor: 0.18,
          yScaleFactor: 0.18,
          containerWidth: I.width,
          containerHeight: I.height,
          position: {
            mx: 0.36,
            my: 0.44
          }
        });
        _(F, Mn, {
          fill: "none",
          stroke: Ke(I, l, O.stroke),
          strokeWidth: 2
        });
      }
      if (ae === "Parallel") {
        var It = n.getScaledPath("GATEWAY_PARALLEL", {
          xScaleFactor: 0.4,
          yScaleFactor: 0.4,
          containerWidth: I.width,
          containerHeight: I.height,
          position: {
            mx: 0.474,
            my: 0.296
          }
        });
        _(F, It, {
          fill: "none",
          stroke: Ke(I, l, O.stroke),
          strokeWidth: 1
        });
      } else ae === "Exclusive" && (Oe || m(F, I.width, I.height, I.height * 0.26, {
        fill: "none",
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), ot());
      return K;
    },
    "bpmn:ExclusiveGateway": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = ue(F, I, O), K = n.getScaledPath("GATEWAY_EXCLUSIVE", {
        xScaleFactor: 0.4,
        yScaleFactor: 0.4,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.32,
          my: 0.3
        }
      }), ae = df(I);
      return ae.get("isMarkerVisible") && _(F, K, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:Gateway": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), ue(F, I, O);
    },
    "bpmn:Group": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]), A(F, I.width, I.height, z6, {
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1.5,
        strokeDasharray: "10, 6, 0, 6",
        fill: "none",
        pointerEvents: "none",
        width: Ba(I, O),
        height: vo(I, O)
      });
    },
    "bpmn:InclusiveGateway": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = ue(F, I, O);
      return m(F, I.width, I.height, I.height * 0.24, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 2.5
      }), Y;
    },
    "bpmn:IntermediateEvent": function(F, I, O = {}) {
      var { renderIcon: Y = !0 } = O;
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var K = te(F, I, {
        ...O,
        strokeWidth: 1.5
      });
      return m(F, I.width, I.height, y5, {
        fill: "none",
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1.5
      }), Y && T(I, F, O), K;
    },
    "bpmn:IntermediateCatchEvent": M("bpmn:IntermediateEvent"),
    "bpmn:IntermediateThrowEvent": M("bpmn:IntermediateEvent"),
    "bpmn:Lane": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]), G(F, I, {
        ...O,
        fillOpacity: VNt
      });
    },
    "bpmn:ManualTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O), K = n.getScaledPath("TASK_TYPE_MANUAL", {
        abspos: {
          x: 17,
          y: 15
        }
      });
      return _(F, K, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 0.5
      }), Y;
    },
    "bpmn:MessageFlow": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = an(I), K = df(I), ae = Qt(I, a, O.fill), Oe = Ke(I, l, O.stroke), ot = y(F, I.waypoints, {
        markerEnd: p(F, "messageflow-end", ae, Oe),
        markerStart: p(F, "messageflow-start", ae, Oe),
        stroke: Oe,
        strokeDasharray: "10, 11",
        strokeWidth: 1.5
      });
      if (Y.get("messageRef")) {
        var It = ot.getPointAtLength(ot.getTotalLength() / 2), Mn = n.getScaledPath("MESSAGE_FLOW_MARKER", {
          abspos: {
            x: It.x,
            y: It.y
          }
        }), Ii = {
          strokeWidth: 1
        };
        K.get("messageVisibleKind") === "initiating" ? (Ii.fill = ae, Ii.stroke = Oe) : (Ii.fill = Oe, Ii.stroke = ae);
        var os = _(F, Mn, Ii), Cc = Y.get("messageRef"), we = Cc.get("name"), de = R(F, we, {
          align: "center-top",
          fitBox: !0,
          style: {
            fill: Oe
          }
        }), he = os.getBBox(), P = de.getBBox(), W = It.x - P.width / 2, ne = It.y + he.height / 2 + INt;
        P_(de, W, ne, 0);
      }
      return ot;
    },
    "bpmn:ParallelGateway": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = ue(F, I, O), K = n.getScaledPath("GATEWAY_PARALLEL", {
        xScaleFactor: 0.6,
        yScaleFactor: 0.6,
        containerWidth: I.width,
        containerHeight: I.height,
        position: {
          mx: 0.46,
          my: 0.2
        }
      });
      return _(F, K, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:Participant": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]);
      var Y = G(F, I, O), K = t0(I), ae = IB(I), Oe = an(I), ot = Oe.get("name");
      if (K) {
        var It = ae ? [
          {
            x: 30,
            y: 0
          },
          {
            x: 30,
            y: vo(I, O)
          }
        ] : [
          {
            x: 0,
            y: 30
          },
          {
            x: Ba(I, O),
            y: 30
          }
        ];
        v(F, It, {
          stroke: Ke(I, l, O.stroke),
          strokeWidth: ONt
        }), U(F, ot, I, O);
      } else {
        var Mn = $m(I, O);
        ae || (Mn.height = Ba(I, O), Mn.width = vo(I, O));
        var Ii = R(F, ot, {
          box: Mn,
          align: "center-middle",
          style: {
            fill: Jm(I, c, l, O.stroke)
          }
        });
        if (!ae) {
          var os = -1 * vo(I, O);
          P_(Ii, 0, -os, 270);
        }
      }
      return Oe.get("participantMultiplicity") && V("ParticipantMultiplicityMarker", F, I, O), Y;
    },
    "bpmn:ReceiveTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = an(I), K = De(F, I, O), ae;
      return Y.get("instantiate") ? (m(F, 28, 28, 20 * 0.22, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), ae = n.getScaledPath("TASK_TYPE_INSTANTIATING_SEND", {
        abspos: {
          x: 7.77,
          y: 9.52
        }
      })) : ae = n.getScaledPath("TASK_TYPE_SEND", {
        xScaleFactor: 0.9,
        yScaleFactor: 0.9,
        containerWidth: 21,
        containerHeight: 14,
        position: {
          mx: 0.3,
          my: 0.4
        }
      }), _(F, ae, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), K;
    },
    "bpmn:ScriptTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O), K = n.getScaledPath("TASK_TYPE_SCRIPT", {
        abspos: {
          x: 15,
          y: 20
        }
      });
      return _(F, K, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:SendTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O), K = n.getScaledPath("TASK_TYPE_SEND", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: 21,
        containerHeight: 14,
        position: {
          mx: 0.285,
          my: 0.357
        }
      });
      return _(F, K, {
        fill: Ke(I, l, O.stroke),
        stroke: Qt(I, a, O.fill),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:SequenceFlow": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = Qt(I, a, O.fill), K = Ke(I, l, O.stroke), ae = y(F, I.waypoints, {
        markerEnd: p(F, "sequenceflow-end", Y, K),
        stroke: K
      }), Oe = an(I), { source: ot } = I;
      if (ot) {
        var It = an(ot);
        Oe.get("conditionExpression") && He(It, "bpmn:Activity") && P2(ae, {
          markerStart: p(F, "conditional-flow-marker", Y, K)
        }), It.get("default") && (He(It, "bpmn:Gateway") || He(It, "bpmn:Activity")) && It.get("default") === Oe && P2(ae, {
          markerStart: p(F, "conditional-default-flow-marker", Y, K)
        });
      }
      return ae;
    },
    "bpmn:ServiceTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O);
      m(F, 10, 10, {
        fill: Qt(I, a, O.fill),
        stroke: "none",
        transform: "translate(6, 6)"
      });
      var K = n.getScaledPath("TASK_TYPE_SERVICE", {
        abspos: {
          x: 12,
          y: 18
        }
      });
      _(F, K, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), m(F, 10, 10, {
        fill: Qt(I, a, O.fill),
        stroke: "none",
        transform: "translate(11, 10)"
      });
      var ae = n.getScaledPath("TASK_TYPE_SERVICE", {
        abspos: {
          x: 17,
          y: 22
        }
      });
      return _(F, ae, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1
      }), Y;
    },
    "bpmn:StartEvent": function(F, I, O = {}) {
      var { renderIcon: Y = !0 } = O;
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var K = an(I);
      K.get("isInterrupting") || (O = {
        ...O,
        strokeDasharray: "6"
      });
      var ae = te(F, I, O);
      return Y && T(I, F, O), ae;
    },
    "bpmn:SubProcess": function(F, I, O = {}) {
      return t0(I) ? O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]) : O = gn(O, [
        "fill",
        "stroke"
      ]), j(F, I, O);
    },
    "bpmn:Task": function(F, I, O = {}) {
      return O = gn(O, [
        "fill",
        "stroke"
      ]), De(F, I, O);
    },
    "bpmn:TextAnnotation": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]);
      var {
        width: Y,
        height: K
      } = $m(I, O), ae = A(F, Y, K, 0, 0, {
        fill: "none",
        stroke: "none"
      }), Oe = n.getScaledPath("TEXT_ANNOTATION", {
        xScaleFactor: 1,
        yScaleFactor: 1,
        containerWidth: Y,
        containerHeight: K,
        position: {
          mx: 0,
          my: 0
        }
      });
      _(F, Oe, {
        stroke: Ke(I, l, O.stroke)
      });
      var ot = an(I), It = ot.get("text") || "";
      return R(F, It, {
        align: "left-top",
        box: $m(I, O),
        padding: 7,
        style: {
          fill: Jm(I, c, l, O.stroke)
        }
      }), ae;
    },
    "bpmn:Transaction": function(F, I, O = {}) {
      t0(I) ? O = gn(O, [
        "fill",
        "stroke",
        "width",
        "height"
      ]) : O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = j(F, I, {
        strokeWidth: 1.5,
        ...O
      }), K = t.style(["no-fill", "no-events"], {
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 1.5
      }), ae = t0(I);
      return ae || (O = {}), A(
        F,
        Ba(I, O),
        vo(I, O),
        z6 - y5,
        y5,
        K
      ), Y;
    },
    "bpmn:UserTask": function(F, I, O = {}) {
      O = gn(O, [
        "fill",
        "stroke"
      ]);
      var Y = De(F, I, O), K = 15, ae = 12, Oe = n.getScaledPath("TASK_TYPE_USER_1", {
        abspos: {
          x: K,
          y: ae
        }
      });
      _(F, Oe, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 0.5
      });
      var ot = n.getScaledPath("TASK_TYPE_USER_2", {
        abspos: {
          x: K,
          y: ae
        }
      });
      _(F, ot, {
        fill: Qt(I, a, O.fill),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 0.5
      });
      var It = n.getScaledPath("TASK_TYPE_USER_3", {
        abspos: {
          x: K,
          y: ae
        }
      });
      return _(F, It, {
        fill: Ke(I, l, O.stroke),
        stroke: Ke(I, l, O.stroke),
        strokeWidth: 0.5
      }), Y;
    },
    label: function(F, I, O = {}) {
      return z(F, I, O);
    }
  };
  this._drawPath = _, this._renderer = D;
}
Ma(l2, Ac);
l2.$inject = [
  "config.bpmnRenderer",
  "eventBus",
  "styles",
  "pathMap",
  "canvas",
  "textRenderer"
];
l2.prototype.canRender = function(r) {
  return He(r, "bpmn:BaseElement");
};
l2.prototype.drawShape = function(r, e, t = {}) {
  var { type: n } = e, i = this._renderer(n);
  return i(r, e, t);
};
l2.prototype.drawConnection = function(r, e, t = {}) {
  var { type: n } = e, i = this._renderer(n);
  return i(r, e, t);
};
l2.prototype.getShapePath = function(r) {
  return He(r, "bpmn:Event") ? Jkt(r) : He(r, "bpmn:Activity") ? $kt(r, z6) : He(r, "bpmn:Gateway") ? eNt(r) : tNt(r);
};
function gn(r, e = []) {
  return e.reduce((t, n) => (r[n] && (t[n] = r[n]), t), {});
}
var HNt = 0, BNt = {
  width: 150,
  height: 50
};
function PNt(r) {
  var e = r.split("-");
  return {
    horizontal: e[0] || "center",
    vertical: e[1] || "top"
  };
}
function FNt(r) {
  return Od(r) ? Ft({ top: 0, left: 0, right: 0, bottom: 0 }, r) : {
    top: r,
    left: r,
    right: r,
    bottom: r
  };
}
function zNt(r, e) {
  e.textContent = r;
  var t;
  try {
    var n, i = r === "";
    return e.textContent = i ? "dummy" : r, t = e.getBBox(), n = {
      width: t.width + t.x * 2,
      height: t.height
    }, i && (n.width = 0), n;
  } catch (s) {
    return console.log(s), { width: 0, height: 0 };
  }
}
function WNt(r, e, t) {
  for (var n = r.shift(), i = n, s; ; ) {
    if (s = zNt(i, t), s.width = i ? s.width : 0, i === " " || i === "" || s.width < Math.round(e) || i.length < 2)
      return jNt(r, i, n, s);
    i = UNt(i, s.width, e);
  }
}
function jNt(r, e, t, n) {
  if (e.length < t.length) {
    var i = t.slice(e.length).trim();
    r.unshift(i);
  }
  return {
    width: n.width,
    height: n.height,
    text: e
  };
}
var $be = "­";
function ZNt(r, e) {
  var t = r.split(/(\s|-|\u00AD)/g), n, i = [], s = 0;
  if (t.length > 1)
    for (; n = t.shift(); )
      if (n.length + s < e)
        i.push(n), s += n.length;
      else {
        (n === "-" || n === $be) && i.pop();
        break;
      }
  var o = i[i.length - 1];
  return o && o === $be && (i[i.length - 1] = "-"), i.join("");
}
function UNt(r, e, t) {
  var n = Math.max(r.length * (t / e), 1), i = ZNt(r, n);
  return i || (i = r.slice(0, Math.max(Math.round(n - 1), 1))), i;
}
function qNt() {
  var r = document.getElementById("helper-svg");
  return r || (r = Fo("svg"), tr(r, {
    id: "helper-svg"
  }), Lo(r, {
    visibility: "hidden",
    position: "fixed",
    width: 0,
    height: 0
  }), document.body.appendChild(r)), r;
}
function Gy(r) {
  this._config = Ft({}, {
    size: BNt,
    padding: HNt,
    style: {},
    align: "center-top"
  }, r || {});
}
Gy.prototype.createText = function(r, e) {
  return this.layoutText(r, e).element;
};
Gy.prototype.getDimensions = function(r, e) {
  return this.layoutText(r, e).dimensions;
};
Gy.prototype.layoutText = function(r, e) {
  var t = Ft({}, this._config.size, e.box), n = Ft({}, this._config.style, e.style), i = PNt(e.align || this._config.align), s = FNt(e.padding !== void 0 ? e.padding : this._config.padding), o = e.fitBox || !1, a = GNt(n), l = r.split(/\u00AD?\r?\n/), c = [], d = t.width - s.left - s.right, u = Fo("text");
  tr(u, { x: 0, y: 0 }), tr(u, n);
  var f = qNt();
  for (oh(f, u); l.length; )
    c.push(WNt(l, d, u));
  i.vertical === "middle" && (s.top = s.bottom = 0);
  var p = $p(c, function(v, y, _) {
    return v + (a || y.height);
  }, 0) + s.top + s.bottom, g = $p(c, function(v, y, _) {
    return y.width > v ? y.width : v;
  }, 0), m = s.top;
  i.vertical === "middle" && (m += (t.height - p) / 2), m -= (a || c[0].height) / 4;
  var A = Fo("text");
  tr(A, n), vn(c, function(v) {
    var y;
    switch (m += a || v.height, i.horizontal) {
      case "left":
        y = s.left;
        break;
      case "right":
        y = (o ? g : d) - s.right - v.width;
        break;
      default:
        y = Math.max(((o ? g : d) - v.width) / 2 + s.left, 0);
    }
    var _ = Fo("tspan");
    tr(_, { x: y, y: m }), _.textContent = v.text, oh(A, _);
  }), jw(u);
  var w = {
    width: g,
    height: p
  };
  return {
    dimensions: w,
    element: A
  };
};
function GNt(r) {
  if ("fontSize" in r && "lineHeight" in r)
    return r.lineHeight * parseInt(r.fontSize, 10);
}
var QNt = 12, KNt = 1.2, YNt = 30;
function nOe(r) {
  var e = Ft({
    fontFamily: "Arial, sans-serif",
    fontSize: QNt,
    fontWeight: "normal",
    lineHeight: KNt
  }, r && r.defaultStyle || {}), t = parseInt(e.fontSize, 10) - 1, n = Ft({}, e, {
    fontSize: t
  }, r && r.externalStyle || {}), i = new Gy({
    style: e
  });
  this.getExternalLabelBounds = function(s, o) {
    var a = i.getDimensions(o, {
      box: {
        width: 90,
        height: 30
      },
      style: n
    });
    return {
      x: Math.round(s.x + s.width / 2 - a.width / 2),
      y: Math.round(s.y),
      width: Math.ceil(a.width),
      height: Math.ceil(a.height)
    };
  }, this.getTextAnnotationBounds = function(s, o) {
    var a = i.getDimensions(o, {
      box: s,
      style: e,
      align: "left-top",
      padding: 5
    });
    return {
      x: s.x,
      y: s.y,
      width: s.width,
      height: Math.max(YNt, Math.round(a.height))
    };
  }, this.createText = function(s, o) {
    return i.createText(s, o || {});
  }, this.getDefaultStyle = function() {
    return e;
  }, this.getExternalStyle = function() {
    return n;
  };
}
nOe.$inject = [
  "config.textRenderer"
];
function XNt() {
  this.pathMap = {
    EVENT_MESSAGE: {
      d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
      height: 36,
      width: 36,
      heightElements: [6, 14],
      widthElements: [10.5, 21]
    },
    EVENT_SIGNAL: {
      d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x1},0 Z",
      height: 36,
      width: 36,
      heightElements: [18],
      widthElements: [10, 20]
    },
    EVENT_ESCALATION: {
      d: "M {mx},{my} l {e.x0},{e.y0} l -{e.x0},-{e.y1} l -{e.x0},{e.y1} Z",
      height: 36,
      width: 36,
      heightElements: [20, 7],
      widthElements: [8]
    },
    EVENT_CONDITIONAL: {
      d: "M {e.x0},{e.y0} l {e.x1},0 l 0,{e.y2} l -{e.x1},0 Z M {e.x2},{e.y3} l {e.x0},0 M {e.x2},{e.y4} l {e.x0},0 M {e.x2},{e.y5} l {e.x0},0 M {e.x2},{e.y6} l {e.x0},0 M {e.x2},{e.y7} l {e.x0},0 M {e.x2},{e.y8} l {e.x0},0 ",
      height: 36,
      width: 36,
      heightElements: [8.5, 14.5, 18, 11.5, 14.5, 17.5, 20.5, 23.5, 26.5],
      widthElements: [10.5, 14.5, 12.5]
    },
    EVENT_LINK: {
      d: "m {mx},{my} 0,{e.y0} -{e.x1},0 0,{e.y1} {e.x1},0 0,{e.y0} {e.x0},-{e.y2} -{e.x0},-{e.y2} z",
      height: 36,
      width: 36,
      heightElements: [4.4375, 6.75, 7.8125],
      widthElements: [9.84375, 13.5]
    },
    EVENT_ERROR: {
      d: "m {mx},{my} {e.x0},-{e.y0} {e.x1},-{e.y1} {e.x2},{e.y2} {e.x3},-{e.y3} -{e.x4},{e.y4} -{e.x5},-{e.y5} z",
      height: 36,
      width: 36,
      heightElements: [0.023, 8.737, 8.151, 16.564, 10.591, 8.714],
      widthElements: [0.085, 6.672, 6.97, 4.273, 5.337, 6.636]
    },
    EVENT_CANCEL_45: {
      d: "m {mx},{my} -{e.x1},0 0,{e.x0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
      height: 36,
      width: 36,
      heightElements: [4.75, 8.5],
      widthElements: [4.75, 8.5]
    },
    EVENT_COMPENSATION: {
      d: "m {mx},{my} {e.x0},-{e.y0} 0,{e.y1} z m {e.x1},-{e.y2} {e.x2},-{e.y3} 0,{e.y1} -{e.x2},-{e.y3} z",
      height: 36,
      width: 36,
      heightElements: [6.5, 13, 0.4, 6.1],
      widthElements: [9, 9.3, 8.7]
    },
    EVENT_TIMER_WH: {
      d: "M {mx},{my} l {e.x0},-{e.y0} m -{e.x0},{e.y0} l {e.x1},{e.y1} ",
      height: 36,
      width: 36,
      heightElements: [10, 2],
      widthElements: [3, 7]
    },
    EVENT_TIMER_LINE: {
      d: "M {mx},{my} m {e.x0},{e.y0} l -{e.x1},{e.y1} ",
      height: 36,
      width: 36,
      heightElements: [10, 3],
      widthElements: [0, 0]
    },
    EVENT_MULTIPLE: {
      d: "m {mx},{my} {e.x1},-{e.y0} {e.x1},{e.y0} -{e.x0},{e.y1} -{e.x2},0 z",
      height: 36,
      width: 36,
      heightElements: [6.28099, 12.56199],
      widthElements: [3.1405, 9.42149, 12.56198]
    },
    EVENT_PARALLEL_MULTIPLE: {
      d: "m {mx},{my} {e.x0},0 0,{e.y1} {e.x1},0 0,{e.y0} -{e.x1},0 0,{e.y1} -{e.x0},0 0,-{e.y1} -{e.x1},0 0,-{e.y0} {e.x1},0 z",
      height: 36,
      width: 36,
      heightElements: [2.56228, 7.68683],
      widthElements: [2.56228, 7.68683]
    },
    GATEWAY_EXCLUSIVE: {
      d: "m {mx},{my} {e.x0},{e.y0} {e.x1},{e.y0} {e.x2},0 {e.x4},{e.y2} {e.x4},{e.y1} {e.x2},0 {e.x1},{e.y3} {e.x0},{e.y3} {e.x3},0 {e.x5},{e.y1} {e.x5},{e.y2} {e.x3},0 z",
      height: 17.5,
      width: 17.5,
      heightElements: [8.5, 6.5312, -6.5312, -8.5],
      widthElements: [6.5, -6.5, 3, -3, 5, -5]
    },
    GATEWAY_PARALLEL: {
      d: "m {mx},{my} 0,{e.y1} -{e.x1},0 0,{e.y0} {e.x1},0 0,{e.y1} {e.x0},0 0,-{e.y1} {e.x1},0 0,-{e.y0} -{e.x1},0 0,-{e.y1} -{e.x0},0 z",
      height: 30,
      width: 30,
      heightElements: [5, 12.5],
      widthElements: [5, 12.5]
    },
    GATEWAY_EVENT_BASED: {
      d: "m {mx},{my} {e.x0},{e.y0} {e.x0},{e.y1} {e.x1},{e.y2} {e.x2},0 z",
      height: 11,
      width: 11,
      heightElements: [-6, 6, 12, -12],
      widthElements: [9, -3, -12]
    },
    GATEWAY_COMPLEX: {
      d: "m {mx},{my} 0,{e.y0} -{e.x0},-{e.y1} -{e.x1},{e.y2} {e.x0},{e.y1} -{e.x2},0 0,{e.y3} {e.x2},0  -{e.x0},{e.y1} l {e.x1},{e.y2} {e.x0},-{e.y1} 0,{e.y0} {e.x3},0 0,-{e.y0} {e.x0},{e.y1} {e.x1},-{e.y2} -{e.x0},-{e.y1} {e.x2},0 0,-{e.y3} -{e.x2},0 {e.x0},-{e.y1} -{e.x1},-{e.y2} -{e.x0},{e.y1} 0,-{e.y0} -{e.x3},0 z",
      height: 17.125,
      width: 17.125,
      heightElements: [4.875, 3.4375, 2.125, 3],
      widthElements: [3.4375, 2.125, 4.875, 3]
    },
    DATA_OBJECT_PATH: {
      d: "m 0,0 {e.x1},0 {e.x0},{e.y0} 0,{e.y1} -{e.x2},0 0,-{e.y2} {e.x1},0 0,{e.y0} {e.x0},0",
      height: 61,
      width: 51,
      heightElements: [10, 50, 60],
      widthElements: [10, 40, 50, 60]
    },
    DATA_OBJECT_COLLECTION_PATH: {
      d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
      height: 10,
      width: 10,
      heightElements: [],
      widthElements: []
    },
    DATA_ARROW: {
      d: "m 5,9 9,0 0,-3 5,5 -5,5 0,-3 -9,0 z",
      height: 61,
      width: 51,
      heightElements: [],
      widthElements: []
    },
    DATA_STORE: {
      d: "m  {mx},{my} l  0,{e.y2} c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 l  0,-{e.y2} c -{e.x0},-{e.y1} -{e.x1},-{e.y1} -{e.x2},0c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0 m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1} {e.x2},0m  -{e.x2},{e.y0}c  {e.x0},{e.y1} {e.x1},{e.y1}  {e.x2},0",
      height: 61,
      width: 61,
      heightElements: [7, 10, 45],
      widthElements: [2, 58, 60]
    },
    TEXT_ANNOTATION: {
      d: "m {mx}, {my} m 10,0 l -10,0 l 0,{e.y0} l 10,0",
      height: 30,
      width: 10,
      heightElements: [30],
      widthElements: [10]
    },
    MARKER_SUB_PROCESS: {
      d: "m{mx},{my} m 7,2 l 0,10 m -5,-5 l 10,0",
      height: 10,
      width: 10,
      heightElements: [],
      widthElements: []
    },
    MARKER_PARALLEL: {
      d: "m{mx},{my} m 3,2 l 0,10 m 3,-10 l 0,10 m 3,-10 l 0,10",
      height: 10,
      width: 10,
      heightElements: [],
      widthElements: []
    },
    MARKER_SEQUENTIAL: {
      d: "m{mx},{my} m 0,3 l 10,0 m -10,3 l 10,0 m -10,3 l 10,0",
      height: 10,
      width: 10,
      heightElements: [],
      widthElements: []
    },
    MARKER_COMPENSATION: {
      d: "m {mx},{my} 7,-5 0,10 z m 7.1,-0.3 6.9,-4.7 0,10 -6.9,-4.7 z",
      height: 10,
      width: 21,
      heightElements: [],
      widthElements: []
    },
    MARKER_LOOP: {
      d: "m {mx},{my} c 3.526979,0 6.386161,-2.829858 6.386161,-6.320661 0,-3.490806 -2.859182,-6.320661 -6.386161,-6.320661 -3.526978,0 -6.38616,2.829855 -6.38616,6.320661 0,1.745402 0.714797,3.325567 1.870463,4.469381 0.577834,0.571908 1.265885,1.034728 2.029916,1.35457 l -0.718163,-3.909793 m 0.718163,3.909793 -3.885211,0.802902",
      height: 13.9,
      width: 13.7,
      heightElements: [],
      widthElements: []
    },
    MARKER_ADHOC: {
      d: "m {mx},{my} m 0.84461,2.64411 c 1.05533,-1.23780996 2.64337,-2.07882 4.29653,-1.97997996 2.05163,0.0805 3.85579,1.15803 5.76082,1.79107 1.06385,0.34139996 2.24454,0.1438 3.18759,-0.43767 0.61743,-0.33642 1.2775,-0.64078 1.7542,-1.17511 0,0.56023 0,1.12046 0,1.6807 -0.98706,0.96237996 -2.29792,1.62393996 -3.6918,1.66181996 -1.24459,0.0927 -2.46671,-0.2491 -3.59505,-0.74812 -1.35789,-0.55965 -2.75133,-1.33436996 -4.27027,-1.18121996 -1.37741,0.14601 -2.41842,1.13685996 -3.44288,1.96782996 z",
      height: 4,
      width: 15,
      heightElements: [],
      widthElements: []
    },
    TASK_TYPE_SEND: {
      d: "m {mx},{my} l 0,{e.y1} l {e.x1},0 l 0,-{e.y1} z l {e.x0},{e.y0} l {e.x0},-{e.y0}",
      height: 14,
      width: 21,
      heightElements: [6, 14],
      widthElements: [10.5, 21]
    },
    TASK_TYPE_SCRIPT: {
      d: "m {mx},{my} c 9.966553,-6.27276 -8.000926,-7.91932 2.968968,-14.938 l -8.802728,0 c -10.969894,7.01868 6.997585,8.66524 -2.968967,14.938 z m -7,-12 l 5,0 m -4.5,3 l 4.5,0 m -3,3 l 5,0m -4,3 l 5,0",
      height: 15,
      width: 12.6,
      heightElements: [6, 14],
      widthElements: [10.5, 21]
    },
    TASK_TYPE_USER_1: {
      d: "m {mx},{my} c 0.909,-0.845 1.594,-2.049 1.594,-3.385 0,-2.554 -1.805,-4.62199999 -4.357,-4.62199999 -2.55199998,0 -4.28799998,2.06799999 -4.28799998,4.62199999 0,1.348 0.974,2.562 1.89599998,3.405 -0.52899998,0.187 -5.669,2.097 -5.794,4.7560005 v 6.718 h 17 v -6.718 c 0,-2.2980005 -5.5279996,-4.5950005 -6.0509996,-4.7760005 zm -8,6 l 0,5.5 m 11,0 l 0,-5"
    },
    TASK_TYPE_USER_2: {
      d: "m {mx},{my} m 2.162,1.009 c 0,2.4470005 -2.158,4.4310005 -4.821,4.4310005 -2.66499998,0 -4.822,-1.981 -4.822,-4.4310005 "
    },
    TASK_TYPE_USER_3: {
      d: "m {mx},{my} m -6.9,-3.80 c 0,0 2.25099998,-2.358 4.27399998,-1.177 2.024,1.181 4.221,1.537 4.124,0.965 -0.098,-0.57 -0.117,-3.79099999 -4.191,-4.13599999 -3.57499998,0.001 -4.20799998,3.36699999 -4.20699998,4.34799999 z"
    },
    TASK_TYPE_MANUAL: {
      d: "m {mx},{my} c 0.234,-0.01 5.604,0.008 8.029,0.004 0.808,0 1.271,-0.172 1.417,-0.752 0.227,-0.898 -0.334,-1.314 -1.338,-1.316 -2.467,-0.01 -7.886,-0.004 -8.108,-0.004 -0.014,-0.079 0.016,-0.533 0,-0.61 0.195,-0.042 8.507,0.006 9.616,0.002 0.877,-0.007 1.35,-0.438 1.353,-1.208 0.003,-0.768 -0.479,-1.09 -1.35,-1.091 -2.968,-0.002 -9.619,-0.013 -9.619,-0.013 v -0.591 c 0,0 5.052,-0.016 7.225,-0.016 0.888,-0.002 1.354,-0.416 1.351,-1.193 -0.006,-0.761 -0.492,-1.196 -1.361,-1.196 -3.473,-0.005 -10.86,-0.003 -11.0829995,-0.003 -0.022,-0.047 -0.045,-0.094 -0.069,-0.139 0.3939995,-0.319 2.0409995,-1.626 2.4149995,-2.017 0.469,-0.4870005 0.519,-1.1650005 0.162,-1.6040005 -0.414,-0.511 -0.973,-0.5 -1.48,-0.236 -1.4609995,0.764 -6.5999995,3.6430005 -7.7329995,4.2710005 -0.9,0.499 -1.516,1.253 -1.882,2.19 -0.37000002,0.95 -0.17,2.01 -0.166,2.979 0.004,0.718 -0.27300002,1.345 -0.055,2.063 0.629,2.087 2.425,3.312 4.859,3.318 4.6179995,0.014 9.2379995,-0.139 13.8569995,-0.158 0.755,-0.004 1.171,-0.301 1.182,-1.033 0.012,-0.754 -0.423,-0.969 -1.183,-0.973 -1.778,-0.01 -5.824,-0.004 -6.04,-0.004 10e-4,-0.084 0.003,-0.586 10e-4,-0.67 z"
    },
    TASK_TYPE_INSTANTIATING_SEND: {
      d: "m {mx},{my} l 0,8.4 l 12.6,0 l 0,-8.4 z l 6.3,3.6 l 6.3,-3.6"
    },
    TASK_TYPE_SERVICE: {
      d: "m {mx},{my} v -1.71335 c 0.352326,-0.0705 0.703932,-0.17838 1.047628,-0.32133 0.344416,-0.14465 0.665822,-0.32133 0.966377,-0.52145 l 1.19431,1.18005 1.567487,-1.57688 -1.195028,-1.18014 c 0.403376,-0.61394 0.683079,-1.29908 0.825447,-2.01824 l 1.622133,-0.01 v -2.2196 l -1.636514,0.01 c -0.07333,-0.35153 -0.178319,-0.70024 -0.323564,-1.04372 -0.145244,-0.34406 -0.321407,-0.6644 -0.522735,-0.96217 l 1.131035,-1.13631 -1.583305,-1.56293 -1.129598,1.13589 c -0.614052,-0.40108 -1.302883,-0.68093 -2.022633,-0.82247 l 0.0093,-1.61852 h -2.241173 l 0.0042,1.63124 c -0.353763,0.0736 -0.705369,0.17977 -1.049785,0.32371 -0.344415,0.14437 -0.665102,0.32092 -0.9635006,0.52046 l -1.1698628,-1.15823 -1.5667691,1.5792 1.1684265,1.15669 c -0.4026573,0.61283 -0.68308,1.29797 -0.8247287,2.01713 l -1.6588041,0.003 v 2.22174 l 1.6724648,-0.006 c 0.073327,0.35077 0.1797598,0.70243 0.3242851,1.04472 0.1452428,0.34448 0.3214064,0.6644 0.5227339,0.96066 l -1.1993431,1.19723 1.5840256,1.56011 1.1964668,-1.19348 c 0.6140517,0.40346 1.3028827,0.68232 2.0233517,0.82331 l 7.19e-4,1.69892 h 2.226848 z m 0.221462,-3.9957 c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z"
    },
    TASK_TYPE_SERVICE_FILL: {
      d: "m {mx},{my} c -1.788948,0.7502 -3.8576,-0.0928 -4.6097055,-1.87438 -0.7521065,-1.78321 0.090598,-3.84627 1.8802645,-4.59604 1.78823,-0.74936 3.856881,0.0929 4.608987,1.87437 0.752106,1.78165 -0.0906,3.84612 -1.879546,4.59605 z"
    },
    TASK_TYPE_BUSINESS_RULE_HEADER: {
      d: "m {mx},{my} 0,4 20,0 0,-4 z"
    },
    TASK_TYPE_BUSINESS_RULE_MAIN: {
      d: "m {mx},{my} 0,12 20,0 0,-12 zm 0,8 l 20,0 m -13,-4 l 0,8"
    },
    MESSAGE_FLOW_MARKER: {
      d: "m {mx},{my} m -10.5 ,-7 l 0,14 l 21,0 l 0,-14 z l 10.5,6 l 10.5,-6"
    }
  }, this.getRawPath = function(e) {
    return this.pathMap[e].d;
  }, this.getScaledPath = function(e, t) {
    var n = this.pathMap[e], i, s;
    t.abspos ? (i = t.abspos.x, s = t.abspos.y) : (i = t.containerWidth * t.position.mx, s = t.containerHeight * t.position.my);
    var o = {};
    if (t.position) {
      for (var a = t.containerHeight / n.height * t.yScaleFactor, l = t.containerWidth / n.width * t.xScaleFactor, c = 0; c < n.heightElements.length; c++)
        o["y" + c] = n.heightElements[c] * a;
      for (var d = 0; d < n.widthElements.length; d++)
        o["x" + d] = n.widthElements[d] * l;
    }
    var u = tTt(
      n.d,
      {
        mx: i,
        my: s,
        e: o
      }
    );
    return u;
  };
}
var JNt = /\{([^{}]+)\}/g, $Nt = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g;
function eTt(r, e, t) {
  var n = t;
  return e.replace($Nt, function(i, s, o, a, l) {
    s = s || a, n && (s in n && (n = n[s]), typeof n == "function" && l && (n = n()));
  }), n = (n == null || n == t ? r : n) + "", n;
}
function tTt(r, e) {
  return String(r).replace(JNt, function(t, n) {
    return eTt(t, n, e);
  });
}
const nTt = {
  __init__: ["bpmnRenderer"],
  bpmnRenderer: ["type", l2],
  textRenderer: ["type", nOe],
  pathMap: ["type", XNt]
};
function iTt(r, e) {
  return e = e || {}, r.replace(/{([^}]+)}/g, function(t, n) {
    return e[n] || "{" + n + "}";
  });
}
const iOe = {
  translate: ["value", iTt]
};
function rTt(r) {
  return {
    x: Math.round(r.x),
    y: Math.round(r.y)
  };
}
function kN(r) {
  return {
    top: r.y,
    right: r.x + (r.width || 0),
    bottom: r.y + (r.height || 0),
    left: r.x
  };
}
function sTt(r) {
  return {
    x: r.left,
    y: r.top,
    width: r.right - r.left,
    height: r.bottom - r.top
  };
}
function oTt(r) {
  return rTt({
    x: r.x + (r.width || 0) / 2,
    y: r.y + (r.height || 0) / 2
  });
}
function aTt(r) {
  for (var e = r.waypoints, t = e.reduce(function(c, d, u) {
    var f = e[u - 1];
    if (f) {
      var p = c[c.length - 1], g = p && p.endLength || 0, m = lTt(f, d);
      c.push({
        start: f,
        end: d,
        startLength: g,
        endLength: g + m,
        length: m
      });
    }
    return c;
  }, []), n = t.reduce(function(c, d) {
    return c + d.length;
  }, 0), i = n / 2, s = 0, o = t[s]; o.endLength < i; )
    o = t[++s];
  var a = (i - o.startLength) / o.length, l = {
    x: o.start.x + (o.end.x - o.start.x) * a,
    y: o.start.y + (o.end.y - o.start.y) * a
  };
  return l;
}
function C4(r) {
  return wkt(r) ? aTt(r) : oTt(r);
}
function lTt(r, e) {
  return Math.sqrt(Math.pow(r.x - e.x, 2) + Math.pow(r.y - e.y, 2));
}
function ls(r) {
  return r ? "<" + r.$type + (r.id ? ' id="' + r.id : "") + '" />' : "<null>";
}
function W6(r, e, t) {
  return Ft({
    id: r.id,
    type: r.$type,
    businessObject: r,
    di: e
  }, t);
}
function cTt(r, e, t) {
  var n = r.waypoint;
  return !n || n.length < 2 ? [C4(e), C4(t)] : n.map(function(i) {
    return { x: i.x, y: i.y };
  });
}
function rOe(r, e, t) {
  return new Error(
    `element ${ls(e)} referenced by ${ls(r)}#${t} not yet drawn`
  );
}
function $d(r, e, t, n, i) {
  this._eventBus = r, this._canvas = e, this._elementFactory = t, this._elementRegistry = n, this._textRenderer = i;
}
$d.$inject = [
  "eventBus",
  "canvas",
  "elementFactory",
  "elementRegistry",
  "textRenderer"
];
$d.prototype.add = function(r, e, t) {
  var n, i, s;
  if (He(e, "bpmndi:BPMNPlane")) {
    var o = He(r, "bpmn:SubProcess") ? { id: r.id + "_plane" } : {};
    n = this._elementFactory.createRoot(W6(r, e, o)), this._canvas.addRootElement(n);
  } else if (He(e, "bpmndi:BPMNShape")) {
    var a = !t0(r, e), l = dTt(r);
    i = t && (t.hidden || t.collapsed);
    var c = e.bounds;
    n = this._elementFactory.createShape(W6(r, e, {
      collapsed: a,
      hidden: i,
      x: Math.round(c.x),
      y: Math.round(c.y),
      width: Math.round(c.width),
      height: Math.round(c.height),
      isFrame: l
    })), He(r, "bpmn:BoundaryEvent") && this._attachBoundary(r, n), He(r, "bpmn:Lane") && (s = 0), He(r, "bpmn:DataStoreReference") && (hTt(t, C4(c)) || (t = this._canvas.findRoot(t))), this._canvas.addShape(n, t, s);
  } else if (He(e, "bpmndi:BPMNEdge")) {
    var d = this._getSource(r), u = this._getTarget(r);
    i = t && (t.hidden || t.collapsed), n = this._elementFactory.createConnection(W6(r, e, {
      hidden: i,
      source: d,
      target: u,
      waypoints: cTt(e, d, u)
    })), He(r, "bpmn:DataAssociation") && (t = this._canvas.findRoot(t)), this._canvas.addConnection(n, t, s);
  } else
    throw new Error(
      `unknown di ${ls(e)} for element ${ls(r)}`
    );
  return vkt(r) && yb(n) && this.addLabel(r, e, n), this._eventBus.fire("bpmnElement.added", { element: n }), n;
};
$d.prototype._attachBoundary = function(r, e) {
  var t = r.attachedToRef;
  if (!t)
    throw new Error(
      `missing ${ls(r)}#attachedToRef`
    );
  var n = this._elementRegistry.get(t.id), i = n && n.attachers;
  if (!n)
    throw rOe(r, t, "attachedToRef");
  e.host = n, i || (n.attachers = i = []), i.indexOf(e) === -1 && i.push(e);
};
$d.prototype.addLabel = function(r, e, t) {
  var n, i, s;
  return n = Ekt(e, t), i = yb(t), i && (n = this._textRenderer.getExternalLabelBounds(n, i)), s = this._elementFactory.createLabel(W6(r, e, {
    id: r.id + "_label",
    labelTarget: t,
    type: "label",
    hidden: t.hidden || !yb(t),
    x: Math.round(n.x),
    y: Math.round(n.y),
    width: Math.round(n.width),
    height: Math.round(n.height)
  })), this._canvas.addShape(s, t.parent);
};
$d.prototype._getConnectedElement = function(r, e) {
  var t, n, i = r.$type;
  if (n = r[e + "Ref"], e === "source" && i === "bpmn:DataInputAssociation" && (n = n && n[0]), (e === "source" && i === "bpmn:DataOutputAssociation" || e === "target" && i === "bpmn:DataInputAssociation") && (n = r.$parent), t = n && this._getElement(n), t)
    return t;
  throw n ? rOe(r, n, e + "Ref") : new Error(
    `${ls(r)}#${e} Ref not specified`
  );
};
$d.prototype._getSource = function(r) {
  return this._getConnectedElement(r, "source");
};
$d.prototype._getTarget = function(r) {
  return this._getConnectedElement(r, "target");
};
$d.prototype._getElement = function(r) {
  return this._elementRegistry.get(r.id);
};
function hTt(r, e) {
  var t = e.x, n = e.y;
  return t >= r.x && t <= r.x + r.width && n >= r.y && n <= r.y + r.height;
}
function dTt(r) {
  return He(r, "bpmn:Group");
}
const uTt = {
  __depends__: [
    iOe
  ],
  bpmnImporter: ["type", $d]
}, fTt = {
  __depends__: [
    nTt,
    uTt
  ]
};
function E4(r, e) {
  e = !!e, ul(r) || (r = [r]);
  var t, n, i, s;
  return vn(r, function(o) {
    var a = o;
    o.waypoints && !e && (a = E4(o.waypoints, !0));
    var l = a.x, c = a.y, d = a.height || 0, u = a.width || 0;
    (l < t || t === void 0) && (t = l), (c < n || n === void 0) && (n = c), (l + u > i || i === void 0) && (i = l + u), (c + d > s || s === void 0) && (s = c + d);
  }), {
    x: t,
    y: n,
    height: s - n,
    width: i - t
  };
}
function sOe(r) {
  return "waypoints" in r ? "connection" : "x" in r ? "shape" : "root";
}
function oOe(r) {
  return !!(r && r.isFrame);
}
function yV(r) {
  this._counter = 0, this._prefix = (r ? r + "-" : "") + Math.floor(Math.random() * 1e9) + "-";
}
yV.prototype.next = function() {
  return this._prefix + ++this._counter;
};
var pTt = new yV("ov"), gTt = 500;
function Ur(r, e, t, n) {
  this._eventBus = e, this._canvas = t, this._elementRegistry = n, this._ids = pTt, this._overlayDefaults = Ft({
    // no show constraints
    show: null,
    // always scale
    scale: !0
  }, r && r.defaults), this._overlays = {}, this._overlayContainers = [], this._overlayRoot = mTt(t.getContainer()), this._init();
}
Ur.$inject = [
  "config.overlays",
  "eventBus",
  "canvas",
  "elementRegistry"
];
Ur.prototype.get = function(r) {
  if (EM(r) && (r = { id: r }), EM(r.element) && (r.element = this._elementRegistry.get(r.element)), r.element) {
    var e = this._getOverlayContainer(r.element, !0);
    return e ? r.type ? _M(e.overlays, kB({ type: r.type })) : e.overlays.slice() : [];
  } else return r.type ? _M(this._overlays, kB({ type: r.type })) : r.id ? this._overlays[r.id] : null;
};
Ur.prototype.add = function(r, e, t) {
  if (Od(e) && (t = e, e = null), r.id || (r = this._elementRegistry.get(r)), !t.position)
    throw new Error("must specifiy overlay position");
  if (!t.html)
    throw new Error("must specifiy overlay html");
  if (!r)
    throw new Error("invalid element specified");
  var n = this._ids.next();
  return t = Ft({}, this._overlayDefaults, t, {
    id: n,
    type: e,
    element: r,
    html: t.html
  }), this._addOverlay(t), n;
};
Ur.prototype.remove = function(r) {
  var e = this.get(r) || [];
  ul(e) || (e = [e]);
  var t = this;
  vn(e, function(n) {
    var i = t._getOverlayContainer(n.element, !0);
    if (n && (_b(n.html), _b(n.htmlContainer), delete n.htmlContainer, delete n.element, delete t._overlays[n.id]), i) {
      var s = i.overlays.indexOf(n);
      s !== -1 && i.overlays.splice(s, 1);
    }
  });
};
Ur.prototype.isShown = function() {
  return this._overlayRoot.style.display !== "none";
};
Ur.prototype.show = function() {
  Qy(this._overlayRoot);
};
Ur.prototype.hide = function() {
  Qy(this._overlayRoot, !1);
};
Ur.prototype.clear = function() {
  this._overlays = {}, this._overlayContainers = [], GIe(this._overlayRoot);
};
Ur.prototype._updateOverlayContainer = function(r) {
  var e = r.element, t = r.html, n = e.x, i = e.y;
  if (e.waypoints) {
    var s = E4(e);
    n = s.x, i = s.y;
  }
  aOe(t, n, i), qy(r.html, "data-container-id", e.id);
};
Ur.prototype._updateOverlay = function(r) {
  var e = r.position, t = r.htmlContainer, n = r.element, i = e.left, s = e.top;
  if (e.right !== void 0) {
    var o;
    n.waypoints ? o = E4(n).width : o = n.width, i = e.right * -1 + o;
  }
  if (e.bottom !== void 0) {
    var a;
    n.waypoints ? a = E4(n).height : a = n.height, s = e.bottom * -1 + a;
  }
  aOe(t, i || 0, s || 0), this._updateOverlayVisibilty(r, this._canvas.viewbox());
};
Ur.prototype._createOverlayContainer = function(r) {
  var e = Ah('<div class="djs-overlays" />');
  Lo(e, { position: "absolute" }), this._overlayRoot.appendChild(e);
  var t = {
    html: e,
    element: r,
    overlays: []
  };
  return this._updateOverlayContainer(t), this._overlayContainers.push(t), t;
};
Ur.prototype._updateRoot = function(r) {
  var e = r.scale || 1, t = "matrix(" + [
    e,
    0,
    0,
    e,
    -1 * r.x * e,
    -1 * r.y * e
  ].join(",") + ")";
  lOe(this._overlayRoot, t);
};
Ur.prototype._getOverlayContainer = function(r, e) {
  var t = Rd(this._overlayContainers, function(n) {
    return n.element === r;
  });
  return !t && !e ? this._createOverlayContainer(r) : t;
};
Ur.prototype._addOverlay = function(r) {
  var e = r.id, t = r.element, n = r.html, i, s;
  n.get && n.constructor.prototype.jquery && (n = n.get(0)), EM(n) && (n = Ah(n)), s = this._getOverlayContainer(t), i = Ah('<div class="djs-overlay" data-overlay-id="' + e + '">'), Lo(i, { position: "absolute" }), i.appendChild(n), r.type && Ja(i).add("djs-overlay-" + r.type);
  var o = this._canvas.findRoot(t), a = this._canvas.getRootElement();
  Qy(i, o === a), r.htmlContainer = i, s.overlays.push(r), s.html.appendChild(i), this._overlays[e] = r, this._updateOverlay(r), this._updateOverlayVisibilty(r, this._canvas.viewbox());
};
Ur.prototype._updateOverlayVisibilty = function(r, e) {
  var t = r.show, n = this._canvas.findRoot(r.element), i = t && t.minZoom, s = t && t.maxZoom, o = r.htmlContainer, a = this._canvas.getRootElement(), l = !0;
  (n !== a || t && (OA(i) && i > e.scale || OA(s) && s < e.scale)) && (l = !1), Qy(o, l), this._updateOverlayScale(r, e);
};
Ur.prototype._updateOverlayScale = function(r, e) {
  var t = r.scale, n, i, s = r.htmlContainer, o, a = "";
  t !== !0 && (t === !1 ? (n = 1, i = 1) : (n = t.min, i = t.max), OA(n) && e.scale < n && (o = (1 / e.scale || 1) * n), OA(i) && e.scale > i && (o = (1 / e.scale || 1) * i)), OA(o) && (a = "scale(" + o + "," + o + ")"), lOe(s, a);
};
Ur.prototype._updateOverlaysVisibilty = function(r) {
  var e = this;
  vn(this._overlays, function(t) {
    e._updateOverlayVisibilty(t, r);
  });
};
Ur.prototype._init = function() {
  var r = this._eventBus, e = this;
  function t(n) {
    e._updateRoot(n), e._updateOverlaysVisibilty(n), e.show();
  }
  r.on("canvas.viewbox.changing", function(n) {
    e.hide();
  }), r.on("canvas.viewbox.changed", function(n) {
    t(n.viewbox);
  }), r.on(["shape.remove", "connection.remove"], function(n) {
    var i = n.element, s = e.get({ element: i });
    vn(s, function(l) {
      e.remove(l.id);
    });
    var o = e._getOverlayContainer(i);
    if (o) {
      _b(o.html);
      var a = e._overlayContainers.indexOf(o);
      a !== -1 && e._overlayContainers.splice(a, 1);
    }
  }), r.on("element.changed", gTt, function(n) {
    var i = n.element, s = e._getOverlayContainer(i, !0);
    s && (vn(s.overlays, function(o) {
      e._updateOverlay(o);
    }), e._updateOverlayContainer(s));
  }), r.on("element.marker.update", function(n) {
    var i = e._getOverlayContainer(n.element, !0);
    i && Ja(i.html)[n.add ? "add" : "remove"](n.marker);
  }), r.on("root.set", function() {
    e._updateOverlaysVisibilty(e._canvas.viewbox());
  }), r.on("diagram.clear", this.clear, this);
};
function mTt(r) {
  var e = Ah(
    '<div class="djs-overlay-container" />'
  );
  return Lo(e, {
    position: "absolute",
    width: 0,
    height: 0
  }), r.insertBefore(e, r.firstChild), e;
}
function aOe(r, e, t) {
  Lo(r, { left: e + "px", top: t + "px" });
}
function Qy(r, e) {
  r.style.display = e === !1 ? "none" : "";
}
function lOe(r, e) {
  r.style["transform-origin"] = "top left", ["", "-ms-", "-webkit-"].forEach(function(t) {
    r.style[t + "transform"] = e;
  });
}
const cOe = {
  __init__: ["overlays"],
  overlays: ["type", Ur]
};
function hOe(r, e, t, n) {
  r.on("element.changed", function(i) {
    var s = i.element;
    (s.parent || s === e.getRootElement()) && (i.gfx = t.getGraphics(s)), i.gfx && r.fire(sOe(s) + ".changed", i);
  }), r.on("elements.changed", function(i) {
    var s = i.elements;
    s.forEach(function(o) {
      r.fire("element.changed", { element: o });
    }), n.updateContainments(s);
  }), r.on("shape.changed", function(i) {
    n.update("shape", i.element, i.gfx);
  }), r.on("connection.changed", function(i) {
    n.update("connection", i.element, i.gfx);
  });
}
hOe.$inject = [
  "eventBus",
  "canvas",
  "elementRegistry",
  "graphicsFactory"
];
const ATt = {
  __init__: ["changeSupport"],
  changeSupport: ["type", hOe]
};
var wTt = 1e3;
function go(r) {
  this._eventBus = r;
}
go.$inject = ["eventBus"];
function vTt(r, e) {
  return function(t) {
    return r.call(e || null, t.context, t.command, t);
  };
}
go.prototype.on = function(r, e, t, n, i, s) {
  if ((ol(e) || ec(e)) && (s = i, i = n, n = t, t = e, e = null), ol(t) && (s = i, i = n, n = t, t = wTt), Od(i) && (s = i, i = !1), !ol(n))
    throw new Error("handlerFn must be a function");
  ul(r) || (r = [r]);
  var o = this._eventBus;
  vn(r, function(a) {
    var l = ["commandStack", a, e].filter(function(c) {
      return c;
    }).join(".");
    o.on(l, t, i ? vTt(n, s) : n, s);
  });
};
go.prototype.canExecute = eu("canExecute");
go.prototype.preExecute = eu("preExecute");
go.prototype.preExecuted = eu("preExecuted");
go.prototype.execute = eu("execute");
go.prototype.executed = eu("executed");
go.prototype.postExecute = eu("postExecute");
go.prototype.postExecuted = eu("postExecuted");
go.prototype.revert = eu("revert");
go.prototype.reverted = eu("reverted");
function eu(r) {
  return function(t, n, i, s, o) {
    (ol(t) || ec(t)) && (o = s, s = i, i = n, n = t, t = null), this.on(t, r, n, i, s, o);
  };
}
function CV(r, e) {
  e.invoke(go, this), this.executed(function(t) {
    var n = t.context;
    n.rootElement ? r.setRootElement(n.rootElement) : n.rootElement = r.getRootElement();
  }), this.revert(function(t) {
    var n = t.context;
    n.rootElement && r.setRootElement(n.rootElement);
  });
}
Ma(CV, go);
CV.$inject = ["canvas", "injector"];
const bTt = {
  __init__: ["rootElementsBehavior"],
  rootElementsBehavior: ["type", CV]
};
function dOe(r) {
  return CSS.escape(r);
}
var yTt = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function CTt(r) {
  return r = "" + r, r && r.replace(/[&<>"']/g, function(e) {
    return yTt[e];
  });
}
var ETt = "_plane";
function EV(r) {
  var e = r.id;
  return He(r, "bpmn:SubProcess") ? _Tt(e) : e;
}
function _Tt(r) {
  return r + ETt;
}
var xTt = "bjs-breadcrumbs-shown";
function uOe(r, e, t) {
  var n = Ah('<ul class="bjs-breadcrumbs"></ul>'), i = t.getContainer(), s = Ja(i);
  i.appendChild(n);
  var o = [];
  r.on("element.changed", function(l) {
    var c = l.element, d = an(c), u = Rd(o, function(f) {
      return f === d;
    });
    u && a();
  });
  function a(l) {
    l && (o = STt(l));
    var c = o.flatMap(function(u) {
      var f = t.findRoot(EV(u)) || t.findRoot(u.id);
      if (!f && He(u, "bpmn:Process")) {
        var p = e.find(function(A) {
          var w = an(A);
          return w && w.get("processRef") === u;
        });
        f = p && t.findRoot(p.id);
      }
      if (!f)
        return [];
      var g = CTt(u.name || u.id), m = Ah('<li><span class="bjs-crumb"><a title="' + g + '">' + g + "</a></span></li>");
      return m.addEventListener("click", function() {
        t.setRootElement(f);
      }), m;
    });
    n.innerHTML = "";
    var d = c.length > 1;
    s.toggle(xTt, d), c.forEach(function(u) {
      n.appendChild(u);
    });
  }
  r.on("root.set", function(l) {
    a(l.element);
  });
}
uOe.$inject = ["eventBus", "elementRegistry", "canvas"];
function STt(r) {
  for (var e = an(r), t = [], n = e; n; n = n.$parent)
    (He(n, "bpmn:SubProcess") || He(n, "bpmn:Process")) && t.push(n);
  return t.reverse();
}
function fOe(r, e) {
  var t = null, n = new MTt();
  r.on("root.set", function(i) {
    var s = i.element, o = e.viewbox(), a = n.get(s);
    if (n.set(t, {
      x: o.x,
      y: o.y,
      zoom: o.scale
    }), t = s, !(!He(s, "bpmn:SubProcess") && !a)) {
      a = a || { x: 0, y: 0, zoom: 1 };
      var l = (o.x - a.x) * o.scale, c = (o.y - a.y) * o.scale;
      (l !== 0 || c !== 0) && e.scroll({
        dx: l,
        dy: c
      }), a.zoom !== o.scale && e.zoom(a.zoom, { x: 0, y: 0 });
    }
  }), r.on("diagram.clear", function() {
    n.clear(), t = null;
  });
}
fOe.$inject = ["eventBus", "canvas"];
function MTt() {
  this._entries = [], this.set = function(r, e) {
    var t = !1;
    for (var n in this._entries)
      if (this._entries[n][0] === r) {
        this._entries[n][1] = e, t = !0;
        break;
      }
    t || this._entries.push([r, e]);
  }, this.get = function(r) {
    for (var e in this._entries)
      if (this._entries[e][0] === r)
        return this._entries[e][1];
    return null;
  }, this.clear = function() {
    this._entries.length = 0;
  }, this.remove = function(r) {
    var e = -1;
    for (var t in this._entries)
      if (this._entries[t][0] === r) {
        e = t;
        break;
      }
    e !== -1 && this._entries.splice(e, 1);
  };
}
var e7e = {
  x: 180,
  y: 160
};
function c2(r, e) {
  this._eventBus = r, this._moddle = e;
  var t = this;
  r.on("import.render.start", 1500, function(n, i) {
    t._handleImport(i.definitions);
  });
}
c2.prototype._handleImport = function(r) {
  if (r.diagrams) {
    var e = this;
    this._definitions = r, this._processToDiagramMap = {}, r.diagrams.forEach(function(n) {
      !n.plane || !n.plane.bpmnElement || (e._processToDiagramMap[n.plane.bpmnElement.id] = n);
    });
    var t = r.diagrams.filter((n) => n.plane).flatMap((n) => e._createNewDiagrams(n.plane));
    t.forEach(function(n) {
      e._movePlaneElementsToOrigin(n.plane);
    });
  }
};
c2.prototype._createNewDiagrams = function(r) {
  var e = this, t = [], n = [];
  r.get("planeElement").forEach(function(s) {
    var o = s.bpmnElement;
    if (o) {
      var a = o.$parent;
      He(o, "bpmn:SubProcess") && !s.isExpanded && t.push(o), LTt(o, r) && n.push({ diElement: s, parent: a });
    }
  });
  var i = [];
  return t.forEach(function(s) {
    if (!e._processToDiagramMap[s.id]) {
      var o = e._createDiagram(s);
      e._processToDiagramMap[s.id] = o, i.push(o);
    }
  }), n.forEach(function(s) {
    for (var o = s.diElement, a = s.parent; a && t.indexOf(a) === -1; )
      a = a.$parent;
    if (a) {
      var l = e._processToDiagramMap[a.id];
      e._moveToDiPlane(o, l.plane);
    }
  }), i;
};
c2.prototype._movePlaneElementsToOrigin = function(r) {
  var e = r.get("planeElement"), t = DTt(r), n = {
    x: t.x - e7e.x,
    y: t.y - e7e.y
  };
  e.forEach(function(i) {
    i.waypoint ? i.waypoint.forEach(function(s) {
      s.x = s.x - n.x, s.y = s.y - n.y;
    }) : i.bounds && (i.bounds.x = i.bounds.x - n.x, i.bounds.y = i.bounds.y - n.y);
  });
};
c2.prototype._moveToDiPlane = function(r, e) {
  var t = pOe(r), n = t.plane.get("planeElement");
  n.splice(n.indexOf(r), 1), e.get("planeElement").push(r);
};
c2.prototype._createDiagram = function(r) {
  var e = this._moddle.create("bpmndi:BPMNPlane", {
    bpmnElement: r
  }), t = this._moddle.create("bpmndi:BPMNDiagram", {
    plane: e
  });
  return e.$parent = t, e.bpmnElement = r, t.$parent = this._definitions, this._definitions.diagrams.push(t), t;
};
c2.$inject = ["eventBus", "moddle"];
function pOe(r) {
  return He(r, "bpmndi:BPMNDiagram") ? r : pOe(r.$parent);
}
function DTt(r) {
  var e = {
    top: 1 / 0,
    right: -1 / 0,
    bottom: -1 / 0,
    left: 1 / 0
  };
  return r.planeElement.forEach(function(t) {
    if (t.bounds) {
      var n = kN(t.bounds);
      e.top = Math.min(n.top, e.top), e.left = Math.min(n.left, e.left);
    }
  }), sTt(e);
}
function LTt(r, e) {
  var t = r.$parent;
  return !(!He(t, "bpmn:SubProcess") || t === e.bpmnElement || XSe(r, ["bpmn:DataInputAssociation", "bpmn:DataOutputAssociation"]));
}
var C5 = 250, kTt = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.81801948,3.50735931 L10.4996894,9.1896894 L10.5,4 L12,4 L12,12 L4,12 L4,10.5 L9.6896894,10.4996894 L3.75735931,4.56801948 C3.46446609,4.27512627 3.46446609,3.80025253 3.75735931,3.50735931 C4.05025253,3.21446609 4.52512627,3.21446609 4.81801948,3.50735931 Z"/></svg>', NTt = "bjs-drilldown-empty";
function B1(r, e, t, n, i) {
  go.call(this, e), this._canvas = r, this._eventBus = e, this._elementRegistry = t, this._overlays = n, this._translate = i;
  var s = this;
  this.executed("shape.toggleCollapse", C5, function(o) {
    var a = o.shape;
    s._canDrillDown(a) ? s._addOverlay(a) : s._removeOverlay(a);
  }, !0), this.reverted("shape.toggleCollapse", C5, function(o) {
    var a = o.shape;
    s._canDrillDown(a) ? s._addOverlay(a) : s._removeOverlay(a);
  }, !0), this.executed(
    ["shape.create", "shape.move", "shape.delete"],
    C5,
    function(o) {
      var a = o.oldParent, l = o.newParent || o.parent, c = o.shape;
      s._canDrillDown(c) && s._addOverlay(c), s._updateDrilldownOverlay(a), s._updateDrilldownOverlay(l), s._updateDrilldownOverlay(c);
    },
    !0
  ), this.reverted(
    ["shape.create", "shape.move", "shape.delete"],
    C5,
    function(o) {
      var a = o.oldParent, l = o.newParent || o.parent, c = o.shape;
      s._canDrillDown(c) && s._addOverlay(c), s._updateDrilldownOverlay(a), s._updateDrilldownOverlay(l), s._updateDrilldownOverlay(c);
    },
    !0
  ), e.on("import.render.complete", function() {
    t.filter(function(o) {
      return s._canDrillDown(o);
    }).map(function(o) {
      s._addOverlay(o);
    });
  });
}
Ma(B1, go);
B1.prototype._updateDrilldownOverlay = function(r) {
  var e = this._canvas;
  if (r) {
    var t = e.findRoot(r);
    t && this._updateOverlayVisibility(t);
  }
};
B1.prototype._canDrillDown = function(r) {
  var e = this._canvas;
  return He(r, "bpmn:SubProcess") && e.findRoot(EV(r));
};
B1.prototype._updateOverlayVisibility = function(r) {
  var e = this._overlays, t = an(r), n = e.get({ element: t.id, type: "drilldown" })[0];
  if (n) {
    var i = t && t.get("flowElements") && t.get("flowElements").length;
    Ja(n.html).toggle(NTt, !i);
  }
};
B1.prototype._addOverlay = function(r) {
  var e = this._canvas, t = this._overlays, n = an(r), i = t.get({ element: r, type: "drilldown" });
  i.length && this._removeOverlay(r);
  var s = Ah('<button type="button" class="bjs-drilldown">' + kTt + "</button>"), o = n.get("name") || n.get("id"), a = this._translate("Open {element}", { element: o });
  s.setAttribute("title", a), s.addEventListener("click", function() {
    e.setRootElement(e.findRoot(EV(r)));
  }), t.add(r, "drilldown", {
    position: {
      bottom: -7,
      right: -8
    },
    html: s
  }), this._updateOverlayVisibility(r);
};
B1.prototype._removeOverlay = function(r) {
  var e = this._overlays;
  e.remove({
    element: r,
    type: "drilldown"
  });
};
B1.$inject = [
  "canvas",
  "eventBus",
  "elementRegistry",
  "overlays",
  "translate"
];
const TTt = {
  __depends__: [cOe, ATt, bTt],
  __init__: ["drilldownBreadcrumbs", "drilldownOverlayBehavior", "drilldownCentering", "subprocessCompatibility"],
  drilldownBreadcrumbs: ["type", uOe],
  drilldownCentering: ["type", fOe],
  drilldownOverlayBehavior: ["type", B1],
  subprocessCompatibility: ["type", c2]
};
function gOe(r) {
  return r.originalEvent || r.srcEvent;
}
function t7e(r) {
  return r.pointers && r.pointers.length && (r = r.pointers[0]), r.touches && r.touches.length && (r = r.touches[0]), r ? {
    x: r.clientX,
    y: r.clientY
  } : null;
}
function ITt() {
  return /mac/i.test(navigator.platform);
}
function mOe(r, e) {
  return (gOe(r) || r).button === e;
}
function Ky(r) {
  return mOe(r, 0);
}
function OTt(r) {
  return mOe(r, 1);
}
function RTt(r) {
  var e = gOe(r) || r;
  return Ky(r) && e.shiftKey;
}
function VTt(r) {
  return !0;
}
function E5(r) {
  return Ky(r) || OTt(r);
}
var n7e = 500;
function AOe(r, e, t) {
  var n = this;
  function i(L, T, B) {
    if (!a(L, T)) {
      var V, N, R;
      B ? N = e.getGraphics(B) : (V = T.delegateTarget || T.target, V && (N = V, B = e.get(N))), !(!N || !B) && (R = r.fire(L, {
        element: B,
        gfx: N,
        originalEvent: T
      }), R === !1 && (T.stopPropagation(), T.preventDefault()));
    }
  }
  var s = {};
  function o(L) {
    return s[L];
  }
  function a(L, T) {
    var B = c[L] || Ky;
    return !B(T);
  }
  var l = {
    click: "element.click",
    contextmenu: "element.contextmenu",
    dblclick: "element.dblclick",
    mousedown: "element.mousedown",
    mousemove: "element.mousemove",
    mouseover: "element.hover",
    mouseout: "element.out",
    mouseup: "element.mouseup"
  }, c = {
    "element.contextmenu": VTt,
    "element.mousedown": E5,
    "element.mouseup": E5,
    "element.click": E5,
    "element.dblclick": E5
  };
  function d(L, T, B) {
    var V = l[L];
    if (!V)
      throw new Error("unmapped DOM event name <" + L + ">");
    return i(V, T, B);
  }
  var u = "svg, .djs-element";
  function f(L, T, B, V) {
    var N = s[B] = function(R) {
      i(B, R);
    };
    V && (c[B] = V), N.$delegate = DN.bind(L, u, T, N);
  }
  function p(L, T, B) {
    var V = o(B);
    V && DN.unbind(L, T, V.$delegate);
  }
  function g(L) {
    vn(l, function(T, B) {
      f(L, B, T);
    });
  }
  function m(L) {
    vn(l, function(T, B) {
      p(L, B, T);
    });
  }
  r.on("canvas.destroy", function(L) {
    m(L.svg);
  }), r.on("canvas.init", function(L) {
    g(L.svg);
  }), r.on(["shape.added", "connection.added"], function(L) {
    var T = L.element, B = L.gfx;
    r.fire("interactionEvents.createHit", { element: T, gfx: B });
  }), r.on([
    "shape.changed",
    "connection.changed"
  ], n7e, function(L) {
    var T = L.element, B = L.gfx;
    r.fire("interactionEvents.updateHit", { element: T, gfx: B });
  }), r.on("interactionEvents.createHit", n7e, function(L) {
    var T = L.element, B = L.gfx;
    n.createDefaultHit(T, B);
  }), r.on("interactionEvents.updateHit", function(L) {
    var T = L.element, B = L.gfx;
    n.updateDefaultHit(T, B);
  });
  var A = S("djs-hit djs-hit-stroke"), w = S("djs-hit djs-hit-click-stroke"), v = S("djs-hit djs-hit-all"), y = S("djs-hit djs-hit-no-move"), _ = {
    all: v,
    "click-stroke": w,
    stroke: A,
    "no-move": y
  };
  function S(L, T) {
    return T = Ft({
      stroke: "white",
      strokeWidth: 15
    }, T || {}), t.cls(L, ["no-fill", "no-border"], T);
  }
  function D(L, T) {
    var B = _[T];
    if (!B)
      throw new Error("invalid hit type <" + T + ">");
    return tr(L, B), L;
  }
  function M(L, T) {
    oh(L, T);
  }
  this.removeHits = function(L) {
    var T = JIe(".djs-hit", L);
    vn(T, jw);
  }, this.createDefaultHit = function(L, T) {
    var B = L.waypoints, V = L.isFrame, N;
    return B ? this.createWaypointsHit(T, B) : (N = V ? "stroke" : "all", this.createBoxHit(T, N, {
      width: L.width,
      height: L.height
    }));
  }, this.createWaypointsHit = function(L, T) {
    var B = wV(T);
    return D(B, "stroke"), M(L, B), B;
  }, this.createBoxHit = function(L, T, B) {
    B = Ft({
      x: 0,
      y: 0
    }, B);
    var V = Fo("rect");
    return D(V, T), tr(V, B), M(L, V), V;
  }, this.updateDefaultHit = function(L, T) {
    var B = Ps(".djs-hit", T);
    if (B)
      return L.waypoints ? qIe(B, L.waypoints) : tr(B, {
        width: L.width,
        height: L.height
      }), B;
  }, this.fire = i, this.triggerMouseEvent = d, this.mouseHandler = o, this.registerEvent = f, this.unregisterEvent = p;
}
AOe.$inject = [
  "eventBus",
  "elementRegistry",
  "styles"
];
const HTt = {
  __init__: ["interactionEvents"],
  interactionEvents: ["type", AOe]
};
function um(r, e) {
  this._eventBus = r, this._canvas = e, this._selectedElements = [];
  var t = this;
  r.on(["shape.remove", "connection.remove"], function(n) {
    var i = n.element;
    t.deselect(i);
  }), r.on(["diagram.clear", "root.set"], function(n) {
    t.select(null);
  });
}
um.$inject = ["eventBus", "canvas"];
um.prototype.deselect = function(r) {
  var e = this._selectedElements, t = e.indexOf(r);
  if (t !== -1) {
    var n = e.slice();
    e.splice(t, 1), this._eventBus.fire("selection.changed", { oldSelection: n, newSelection: e });
  }
};
um.prototype.get = function() {
  return this._selectedElements;
};
um.prototype.isSelected = function(r) {
  return this._selectedElements.indexOf(r) !== -1;
};
um.prototype.select = function(r, e) {
  var t = this._selectedElements, n = t.slice();
  ul(r) || (r = r ? [r] : []);
  var i = this._canvas, s = i.getRootElement();
  r = r.filter(function(o) {
    var a = i.findRoot(o);
    return s === a;
  }), e ? vn(r, function(o) {
    t.indexOf(o) === -1 && t.push(o);
  }) : this._selectedElements = t = r.slice(), this._eventBus.fire("selection.changed", { oldSelection: n, newSelection: t });
};
var i7e = "hover", r7e = "selected";
function wOe(r, e) {
  this._canvas = r;
  function t(i, s) {
    r.addMarker(i, s);
  }
  function n(i, s) {
    r.removeMarker(i, s);
  }
  e.on("element.hover", function(i) {
    t(i.element, i7e);
  }), e.on("element.out", function(i) {
    n(i.element, i7e);
  }), e.on("selection.changed", function(i) {
    function s(c) {
      n(c, r7e);
    }
    function o(c) {
      t(c, r7e);
    }
    var a = i.oldSelection, l = i.newSelection;
    vn(a, function(c) {
      l.indexOf(c) === -1 && s(c);
    }), vn(l, function(c) {
      a.indexOf(c) === -1 && o(c);
    });
  });
}
wOe.$inject = [
  "canvas",
  "eventBus"
];
function vOe(r, e, t, n) {
  r.on("create.end", 500, function(i) {
    var s = i.context, o = s.canExecute, a = s.elements, l = s.hints || {}, c = l.autoSelect;
    if (o) {
      if (c === !1)
        return;
      ul(c) ? e.select(c) : e.select(a.filter(BTt));
    }
  }), r.on("connect.end", 500, function(i) {
    var s = i.context, o = s.connection;
    o && e.select(o);
  }), r.on("shape.move.end", 500, function(i) {
    var s = i.previousSelection || [], o = n.get(i.context.shape.id), a = Rd(s, function(l) {
      return o.id === l.id;
    });
    a || e.select(o);
  }), r.on("element.click", function(i) {
    if (Ky(i)) {
      var s = i.element;
      s === t.getRootElement() && (s = null);
      var o = e.isSelected(s), a = e.get().length > 1, l = RTt(i);
      if (o && a)
        return l ? e.deselect(s) : e.select(s);
      o ? e.deselect(s) : e.select(s, l);
    }
  });
}
vOe.$inject = [
  "eventBus",
  "selection",
  "canvas",
  "elementRegistry"
];
function BTt(r) {
  return !r.hidden;
}
const PTt = {
  __init__: ["selectionVisuals", "selectionBehavior"],
  __depends__: [
    HTt
  ],
  selection: ["type", um],
  selectionVisuals: ["type", wOe],
  selectionBehavior: ["type", vOe]
}, FTt = /^class[ {]/;
function zTt(r) {
  return FTt.test(r.toString());
}
function _V(r) {
  return Array.isArray(r);
}
function F_(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
function j6(...r) {
  r.length === 1 && _V(r[0]) && (r = r[0]), r = [...r];
  const e = r.pop();
  return e.$inject = r, e;
}
const WTt = /constructor\s*[^(]*\(\s*([^)]*)\)/m, jTt = /^(?:async\s+)?(?:function\s*[^(]*)?(?:\(\s*([^)]*)\)|(\w+))/m, ZTt = /\/\*([^*]*)\*\//m;
function UTt(r) {
  if (typeof r != "function")
    throw new Error(`Cannot annotate "${r}". Expected a function!`);
  const e = r.toString().match(zTt(r) ? WTt : jTt);
  if (!e)
    return [];
  const t = e[1] || e[2];
  return t && t.split(",").map((n) => {
    const i = n.match(ZTt);
    return (i && i[1] || n).trim();
  }) || [];
}
function bOe(r, e) {
  const t = e || /** @type InjectorContext */
  {
    get: function(y, _) {
      if (n.push(y), _ === !1)
        return null;
      throw a(`No provider for "${y}"!`);
    }
  }, n = [], i = this._providers = Object.create(t._providers || null), s = this._instances = /* @__PURE__ */ Object.create(null), o = s.injector = this, a = function(y) {
    const _ = n.join(" -> ");
    return n.length = 0, new Error(_ ? `${y} (Resolving: ${_})` : y);
  };
  function l(y, _) {
    if (!i[y] && y.includes(".")) {
      const S = y.split(".");
      let D = l(
        /** @type { string } */
        S.shift()
      );
      for (; S.length; )
        D = D[
          /** @type { string } */
          S.shift()
        ];
      return D;
    }
    if (F_(s, y))
      return s[y];
    if (F_(i, y)) {
      if (n.indexOf(y) !== -1)
        throw n.push(y), a("Cannot resolve circular dependency!");
      return n.push(y), s[y] = i[y][0](i[y][1]), n.pop(), s[y];
    }
    return t.get(y, _);
  }
  function c(y, _) {
    if (typeof _ > "u" && (_ = {}), typeof y != "function")
      if (_V(y))
        y = j6(y.slice());
      else
        throw a(`Cannot invoke "${y}". Expected a function!`);
    const D = (y.$inject || UTt(y)).map((M) => F_(_, M) ? _[M] : l(M));
    return {
      fn: y,
      dependencies: D
    };
  }
  function d(y) {
    const {
      fn: _,
      dependencies: S
    } = c(y), D = Function.prototype.bind.call(_, null, ...S);
    return new D();
  }
  function u(y, _, S) {
    const {
      fn: D,
      dependencies: M
    } = c(y, S);
    return D.apply(_, M);
  }
  function f(y) {
    return j6((_) => y.get(_));
  }
  function p(y, _) {
    if (_ && _.length) {
      const S = /* @__PURE__ */ Object.create(null), D = /* @__PURE__ */ Object.create(null), M = [], L = [], T = [];
      let B, V, N, R;
      for (let H in i)
        B = i[H], _.indexOf(H) !== -1 && (B[2] === "private" ? (V = M.indexOf(B[3]), V === -1 ? (N = B[3].createChild([], _), R = f(N), M.push(B[3]), L.push(N), T.push(R), S[H] = [R, H, "private", N]) : S[H] = [T[V], H, "private", L[V]]) : S[H] = [B[2], B[1]], D[H] = !0), (B[2] === "factory" || B[2] === "type") && B[1].$scope && _.forEach((z) => {
          B[1].$scope.indexOf(z) !== -1 && (S[H] = [B[2], B[1]], D[z] = !0);
        });
      _.forEach((H) => {
        if (!D[H])
          throw new Error('No provider for "' + H + '". Cannot use provider from the parent!');
      }), y.unshift(S);
    }
    return new bOe(y, o);
  }
  const g = {
    factory: u,
    type: d,
    value: function(y) {
      return y;
    }
  };
  function m(y, _) {
    const S = y.__init__ || [];
    return function() {
      S.forEach((D) => {
        typeof D == "string" ? _.get(D) : _.invoke(D);
      });
    };
  }
  function A(y) {
    const _ = y.__exports__;
    if (_) {
      const S = y.__modules__, D = Object.keys(y).reduce((V, N) => (N !== "__exports__" && N !== "__modules__" && N !== "__init__" && N !== "__depends__" && (V[N] = y[N]), V), /* @__PURE__ */ Object.create(null)), M = (S || []).concat(D), L = p(M), T = j6(function(V) {
        return L.get(V);
      });
      _.forEach(function(V) {
        i[V] = [T, V, "private", L];
      });
      const B = (y.__init__ || []).slice();
      return B.unshift(function() {
        L.init();
      }), y = Object.assign({}, y, {
        __init__: B
      }), m(y, L);
    }
    return Object.keys(y).forEach(function(S) {
      if (S === "__init__" || S === "__depends__")
        return;
      const D = (
        /** @type { TypedDeclaration } */
        y[S]
      );
      if (D[2] === "private") {
        i[S] = D;
        return;
      }
      const M = D[0], L = D[1];
      i[S] = [g[M], qTt(M, L), M];
    }), m(y, o);
  }
  function w(y, _) {
    return y.indexOf(_) !== -1 || (y = (_.__depends__ || []).reduce(w, y), y.indexOf(_) !== -1) ? y : y.concat(_);
  }
  function v(y) {
    const _ = y.reduce(w, []).map(A);
    let S = !1;
    return function() {
      S || (S = !0, _.forEach((D) => D()));
    };
  }
  this.get = l, this.invoke = u, this.instantiate = d, this.createChild = p, this.init = v(r);
}
function qTt(r, e) {
  return r !== "value" && _V(e) && (e = j6(e.slice())), e;
}
var GTt = 1;
function P1(r, e) {
  Ac.call(this, r, GTt), this.CONNECTION_STYLE = e.style(["no-fill"], { strokeWidth: 5, stroke: "fuchsia" }), this.SHAPE_STYLE = e.style({ fill: "white", stroke: "fuchsia", strokeWidth: 2 }), this.FRAME_STYLE = e.style(["no-fill"], { stroke: "fuchsia", strokeDasharray: 4, strokeWidth: 2 });
}
Ma(P1, Ac);
P1.prototype.canRender = function() {
  return !0;
};
P1.prototype.drawShape = function(e, t, n) {
  var i = Fo("rect");
  return tr(i, {
    x: 0,
    y: 0,
    width: t.width || 0,
    height: t.height || 0
  }), oOe(t) ? tr(i, Ft({}, this.FRAME_STYLE, n || {})) : tr(i, Ft({}, this.SHAPE_STYLE, n || {})), oh(e, i), i;
};
P1.prototype.drawConnection = function(e, t, n) {
  var i = wV(t.waypoints, Ft({}, this.CONNECTION_STYLE, n || {}));
  return oh(e, i), i;
};
P1.prototype.getShapePath = function(e) {
  var t = e.x, n = e.y, i = e.width, s = e.height, o = [
    ["M", t, n],
    ["l", i, 0],
    ["l", 0, s],
    ["l", -i, 0],
    ["z"]
  ];
  return a2(o);
};
P1.prototype.getConnectionPath = function(e) {
  var t = e.waypoints, n, i, s = [];
  for (n = 0; i = t[n]; n++)
    i = i.original || i, s.push([n === 0 ? "M" : "L", i.x, i.y]);
  return a2(s);
};
P1.$inject = ["eventBus", "styles"];
function QTt() {
  var r = {
    "no-fill": {
      fill: "none"
    },
    "no-border": {
      strokeOpacity: 0
    },
    "no-events": {
      pointerEvents: "none"
    }
  }, e = this;
  this.cls = function(t, n, i) {
    var s = this.style(n, i);
    return Ft(s, { class: t });
  }, this.style = function(t, n) {
    !ul(t) && !n && (n = t, t = []);
    var i = $p(t, function(s, o) {
      return Ft(s, r[o] || {});
    }, {});
    return n ? Ft(i, n) : i;
  }, this.computeStyle = function(t, n, i) {
    return ul(n) || (i = n, n = []), e.style(n || [], Ft({}, i, t || {}));
  };
}
const KTt = {
  __init__: ["defaultRenderer"],
  defaultRenderer: ["type", P1],
  styles: ["type", QTt]
};
function YTt(r, e) {
  if (!r || !e)
    return -1;
  var t = r.indexOf(e);
  return t !== -1 && r.splice(t, 1), t;
}
function XTt(r, e, t) {
  if (!(!r || !e)) {
    typeof t != "number" && (t = -1);
    var n = r.indexOf(e);
    if (n !== -1) {
      if (n === t)
        return;
      if (t !== -1)
        r.splice(n, 1);
      else
        return;
    }
    t !== -1 ? r.splice(t, 0, e) : r.push(e);
  }
}
function Z6(r, e) {
  return Math.round(r * e) / e;
}
function s7e(r) {
  return ec(r) ? r + "px" : r;
}
function JTt(r) {
  for (; r.parent; )
    r = r.parent;
  return r;
}
function $Tt(r) {
  r = Ft({}, { width: "100%", height: "100%" }, r);
  const e = r.container || document.body, t = document.createElement("div");
  return t.setAttribute("class", "djs-container djs-parent"), Lo(t, {
    position: "relative",
    overflow: "hidden",
    width: s7e(r.width),
    height: s7e(r.height)
  }), e.appendChild(t), t;
}
function yOe(r, e, t) {
  const n = Fo("g");
  dd(n).add(e);
  const i = t !== void 0 ? t : r.childNodes.length - 1;
  return r.insertBefore(n, r.childNodes[i] || null), n;
}
const eIt = "base", COe = 0, tIt = 1, nIt = {
  shape: ["x", "y", "width", "height"],
  connection: ["waypoints"]
};
function xt(r, e, t, n) {
  this._eventBus = e, this._elementRegistry = n, this._graphicsFactory = t, this._rootsIdx = 0, this._layers = {}, this._planes = [], this._rootElement = null, this._focused = !1, this._init(r || {});
}
xt.$inject = [
  "config.canvas",
  "eventBus",
  "graphicsFactory",
  "elementRegistry"
];
xt.prototype._init = function(r) {
  const e = this._eventBus, t = this._container = $Tt(r), n = this._svg = Fo("svg");
  tr(n, {
    width: "100%",
    height: "100%"
  }), qy(n, "tabindex", 0), r.autoFocus && e.on("element.hover", () => {
    this.restoreFocus();
  }), e.on("element.mousedown", 500, (s) => {
    this.focus();
  }), n.addEventListener("focusin", () => {
    this._setFocused(!0);
  }), n.addEventListener("focusout", () => {
    this._setFocused(!1);
  }), oh(t, n);
  const i = this._viewport = yOe(n, "viewport");
  r.deferUpdate && (this._viewboxChanged = HWe(oI(this._viewboxChanged, this), 300)), e.on("diagram.init", () => {
    e.fire("canvas.init", {
      svg: n,
      viewport: i
    });
  }), e.on([
    "shape.added",
    "connection.added",
    "shape.removed",
    "connection.removed",
    "elements.changed",
    "root.set"
  ], () => {
    delete this._cachedViewbox;
  }), e.on("diagram.destroy", 500, this._destroy, this), e.on("diagram.clear", 500, this._clear, this);
};
xt.prototype._destroy = function() {
  this._eventBus.fire("canvas.destroy", {
    svg: this._svg,
    viewport: this._viewport
  });
  const r = this._container.parentNode;
  r && r.removeChild(this._container), delete this._svg, delete this._container, delete this._layers, delete this._planes, delete this._rootElement, delete this._viewport;
};
xt.prototype._setFocused = function(r) {
  r != this._focused && (this._focused = r, this._eventBus.fire("canvas.focus.changed", { focused: r }));
};
xt.prototype._clear = function() {
  this._elementRegistry.getAll().forEach((e) => {
    const t = sOe(e);
    t === "root" ? this.removeRootElement(e) : this._removeElement(e, t);
  }), this._planes = [], this._rootElement = null, delete this._cachedViewbox;
};
xt.prototype.focus = function() {
  this._svg.focus({ preventScroll: !0 }), this._setFocused(!0);
};
xt.prototype.restoreFocus = function() {
  document.activeElement === document.body && this.focus();
};
xt.prototype.isFocused = function() {
  return this._focused;
};
xt.prototype.getDefaultLayer = function() {
  return this.getLayer(eIt, COe);
};
xt.prototype.getLayer = function(r, e) {
  if (!r)
    throw new Error("must specify a name");
  let t = this._layers[r];
  if (t || (t = this._layers[r] = this._createLayer(r, e)), typeof e < "u" && t.index !== e)
    throw new Error("layer <" + r + "> already created at index <" + e + ">");
  return t.group;
};
xt.prototype._getChildIndex = function(r) {
  return $p(this._layers, function(e, t) {
    return t.visible && r >= t.index && e++, e;
  }, 0);
};
xt.prototype._createLayer = function(r, e) {
  typeof e > "u" && (e = tIt);
  const t = this._getChildIndex(e);
  return {
    group: yOe(this._viewport, "layer-" + r, t),
    index: e,
    visible: !0
  };
};
xt.prototype.showLayer = function(r) {
  if (!r)
    throw new Error("must specify a name");
  const e = this._layers[r];
  if (!e)
    throw new Error("layer <" + r + "> does not exist");
  const t = this._viewport, n = e.group, i = e.index;
  if (e.visible)
    return n;
  const s = this._getChildIndex(i);
  return t.insertBefore(n, t.childNodes[s] || null), e.visible = !0, n;
};
xt.prototype.hideLayer = function(r) {
  if (!r)
    throw new Error("must specify a name");
  const e = this._layers[r];
  if (!e)
    throw new Error("layer <" + r + "> does not exist");
  const t = e.group;
  return e.visible && (jw(t), e.visible = !1), t;
};
xt.prototype._removeLayer = function(r) {
  const e = this._layers[r];
  e && (delete this._layers[r], jw(e.group));
};
xt.prototype.getActiveLayer = function() {
  const r = this._findPlaneForRoot(this.getRootElement());
  return r ? r.layer : null;
};
xt.prototype.findRoot = function(r) {
  return typeof r == "string" && (r = this._elementRegistry.get(r)), r ? (this._findPlaneForRoot(
    JTt(r)
  ) || {}).rootElement : void 0;
};
xt.prototype.getRootElements = function() {
  return this._planes.map(function(r) {
    return r.rootElement;
  });
};
xt.prototype._findPlaneForRoot = function(r) {
  return Rd(this._planes, function(e) {
    return e.rootElement === r;
  });
};
xt.prototype.getContainer = function() {
  return this._container;
};
xt.prototype._updateMarker = function(r, e, t) {
  let n;
  r.id || (r = this._elementRegistry.get(r)), r.markers = r.markers || /* @__PURE__ */ new Set(), n = this._elementRegistry._elements[r.id], n && (vn([n.gfx, n.secondaryGfx], function(i) {
    i && (t ? (r.markers.add(e), dd(i).add(e)) : (r.markers.delete(e), dd(i).remove(e)));
  }), this._eventBus.fire("element.marker.update", { element: r, gfx: n.gfx, marker: e, add: !!t }));
};
xt.prototype.addMarker = function(r, e) {
  this._updateMarker(r, e, !0);
};
xt.prototype.removeMarker = function(r, e) {
  this._updateMarker(r, e, !1);
};
xt.prototype.hasMarker = function(r, e) {
  return r.id || (r = this._elementRegistry.get(r)), r.markers ? r.markers.has(e) : !1;
};
xt.prototype.toggleMarker = function(r, e) {
  this.hasMarker(r, e) ? this.removeMarker(r, e) : this.addMarker(r, e);
};
xt.prototype.getRootElement = function() {
  const r = this._rootElement;
  return r || this._planes.length ? r : this.setRootElement(this.addRootElement(null));
};
xt.prototype.addRootElement = function(r) {
  const e = this._rootsIdx++;
  r || (r = {
    id: "__implicitroot_" + e,
    children: [],
    isImplicit: !0
  });
  const t = r.layer = "root-" + e;
  this._ensureValid("root", r);
  const n = this.getLayer(t, COe);
  return this.hideLayer(t), this._addRoot(r, n), this._planes.push({
    rootElement: r,
    layer: n
  }), r;
};
xt.prototype.removeRootElement = function(r) {
  if (typeof r == "string" && (r = this._elementRegistry.get(r)), !!this._findPlaneForRoot(r))
    return this._removeRoot(r), this._removeLayer(r.layer), this._planes = this._planes.filter(function(t) {
      return t.rootElement !== r;
    }), this._rootElement === r && (this._rootElement = null), r;
};
xt.prototype.setRootElement = function(r) {
  if (r === this._rootElement)
    return r;
  let e;
  if (!r)
    throw new Error("rootElement required");
  return e = this._findPlaneForRoot(r), e || (r = this.addRootElement(r)), this._setRoot(r), r;
};
xt.prototype._removeRoot = function(r) {
  const e = this._elementRegistry, t = this._eventBus;
  t.fire("root.remove", { element: r }), t.fire("root.removed", { element: r }), e.remove(r);
};
xt.prototype._addRoot = function(r, e) {
  const t = this._elementRegistry, n = this._eventBus;
  n.fire("root.add", { element: r }), t.add(r, e), n.fire("root.added", { element: r, gfx: e });
};
xt.prototype._setRoot = function(r, e) {
  const t = this._rootElement;
  t && (this._elementRegistry.updateGraphics(t, null, !0), this.hideLayer(t.layer)), r && (e || (e = this._findPlaneForRoot(r).layer), this._elementRegistry.updateGraphics(r, this._svg, !0), this.showLayer(r.layer)), this._rootElement = r, this._eventBus.fire("root.set", { element: r });
};
xt.prototype._ensureValid = function(r, e) {
  if (!e.id)
    throw new Error("element must have an id");
  if (this._elementRegistry.get(e.id))
    throw new Error("element <" + e.id + "> already exists");
  const t = nIt[r];
  if (!sI(t, function(i) {
    return typeof e[i] < "u";
  }))
    throw new Error(
      "must supply { " + t.join(", ") + " } with " + r
    );
};
xt.prototype._setParent = function(r, e, t) {
  XTt(e.children, r, t), r.parent = e;
};
xt.prototype._addElement = function(r, e, t, n) {
  t = t || this.getRootElement();
  const i = this._eventBus, s = this._graphicsFactory;
  this._ensureValid(r, e), i.fire(r + ".add", { element: e, parent: t }), this._setParent(e, t, n);
  const o = s.create(r, e, n);
  return this._elementRegistry.add(e, o), s.update(r, e, o), i.fire(r + ".added", { element: e, gfx: o }), e;
};
xt.prototype.addShape = function(r, e, t) {
  return this._addElement("shape", r, e, t);
};
xt.prototype.addConnection = function(r, e, t) {
  return this._addElement("connection", r, e, t);
};
xt.prototype._removeElement = function(r, e) {
  const t = this._elementRegistry, n = this._graphicsFactory, i = this._eventBus;
  if (r = t.get(r.id || r), !!r)
    return i.fire(e + ".remove", { element: r }), n.remove(r), YTt(r.parent && r.parent.children, r), r.parent = null, i.fire(e + ".removed", { element: r }), t.remove(r), r;
};
xt.prototype.removeShape = function(r) {
  return this._removeElement(r, "shape");
};
xt.prototype.removeConnection = function(r) {
  return this._removeElement(r, "connection");
};
xt.prototype.getGraphics = function(r, e) {
  return this._elementRegistry.getGraphics(r, e);
};
xt.prototype._changeViewbox = function(r) {
  this._eventBus.fire("canvas.viewbox.changing"), r.apply(this), this._cachedViewbox = null, this._viewboxChanged();
};
xt.prototype._viewboxChanged = function() {
  this._eventBus.fire("canvas.viewbox.changed", { viewbox: this.viewbox() });
};
xt.prototype.viewbox = function(r) {
  if (r === void 0 && this._cachedViewbox)
    return structuredClone(this._cachedViewbox);
  const e = this._viewport, t = this.getSize();
  let n, i, s, o, a, l, c;
  if (r)
    this._changeViewbox(function() {
      a = Math.min(t.width / r.width, t.height / r.height);
      const d = this._svg.createSVGMatrix().scale(a).translate(-r.x, -r.y);
      y4(e, d);
    });
  else
    return s = this._rootElement ? this.getActiveLayer() : null, n = s && s.getBBox() || {}, o = y4(e), i = o ? o.matrix : jkt(), a = Z6(i.a, 1e3), l = Z6(-i.e || 0, 1e3), c = Z6(-i.f || 0, 1e3), r = this._cachedViewbox = {
      x: l ? l / a : 0,
      y: c ? c / a : 0,
      width: t.width / a,
      height: t.height / a,
      scale: a,
      inner: {
        width: n.width || 0,
        height: n.height || 0,
        x: n.x || 0,
        y: n.y || 0
      },
      outer: t
    }, r;
  return r;
};
xt.prototype.scroll = function(r) {
  const e = this._viewport;
  let t = e.getCTM();
  return r && this._changeViewbox(function() {
    r = Ft({ dx: 0, dy: 0 }, r || {}), t = this._svg.createSVGMatrix().translate(r.dx, r.dy).multiply(t), EOe(e, t);
  }), { x: t.e, y: t.f };
};
xt.prototype.scrollToElement = function(r, e) {
  let t = 100;
  typeof r == "string" && (r = this._elementRegistry.get(r));
  const n = this.findRoot(r);
  if (n !== this.getRootElement() && this.setRootElement(n), n === r)
    return;
  e || (e = {}), typeof e == "number" && (t = e), e = {
    top: e.top || t,
    right: e.right || t,
    bottom: e.bottom || t,
    left: e.left || t
  };
  const i = E4(r), s = kN(i), o = this.viewbox(), a = this.zoom();
  let l, c;
  o.y += e.top / a, o.x += e.left / a, o.width -= (e.right + e.left) / a, o.height -= (e.bottom + e.top) / a;
  const d = kN(o);
  if (!(i.width < o.width && i.height < o.height))
    l = i.x - o.x, c = i.y - o.y;
  else {
    const f = Math.max(0, s.right - d.right), p = Math.min(0, s.left - d.left), g = Math.max(0, s.bottom - d.bottom), m = Math.min(0, s.top - d.top);
    l = f || p, c = g || m;
  }
  this.scroll({ dx: -l * a, dy: -c * a });
};
xt.prototype.zoom = function(r, e) {
  if (!r)
    return this.viewbox(r).scale;
  if (r === "fit-viewport")
    return this._fitViewport(e);
  let t, n;
  return this._changeViewbox(function() {
    typeof e != "object" && (t = this.viewbox().outer, e = {
      x: t.width / 2,
      y: t.height / 2
    }), n = this._setZoom(r, e);
  }), Z6(n.a, 1e3);
};
function EOe(r, e) {
  const t = "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")";
  r.setAttribute("transform", t);
}
xt.prototype._fitViewport = function(r) {
  const e = this.viewbox(), t = e.outer, n = e.inner;
  let i, s;
  return n.x >= 0 && n.y >= 0 && n.x + n.width <= t.width && n.y + n.height <= t.height && !r ? s = {
    x: 0,
    y: 0,
    width: Math.max(n.width + n.x, t.width),
    height: Math.max(n.height + n.y, t.height)
  } : (i = Math.min(1, t.width / n.width, t.height / n.height), s = {
    x: n.x + (r ? n.width / 2 - t.width / i / 2 : 0),
    y: n.y + (r ? n.height / 2 - t.height / i / 2 : 0),
    width: t.width / i,
    height: t.height / i
  }), this.viewbox(s), this.viewbox(!1).scale;
};
xt.prototype._setZoom = function(r, e) {
  const t = this._svg, n = this._viewport, i = t.createSVGMatrix(), s = t.createSVGPoint();
  let o, a, l, c, d;
  l = n.getCTM();
  const u = l.a;
  return e ? (o = Ft(s, e), a = o.matrixTransform(l.inverse()), c = i.translate(a.x, a.y).scale(1 / u * r).translate(-a.x, -a.y), d = l.multiply(c)) : d = i.scale(r), EOe(this._viewport, d), d;
};
xt.prototype.getSize = function() {
  return {
    width: this._container.clientWidth,
    height: this._container.clientHeight
  };
};
xt.prototype.getAbsoluteBBox = function(r) {
  const e = this.viewbox();
  let t;
  r.waypoints ? t = this.getGraphics(r).getBBox() : t = r;
  const n = t.x * e.scale - e.x * e.scale, i = t.y * e.scale - e.y * e.scale, s = t.width * e.scale, o = t.height * e.scale;
  return {
    x: n,
    y: i,
    width: s,
    height: o
  };
};
xt.prototype.resized = function() {
  delete this._cachedViewbox, this._eventBus.fire("canvas.resized");
};
var xg = "data-element-id";
function Da(r) {
  this._elements = {}, this._eventBus = r;
}
Da.$inject = ["eventBus"];
Da.prototype.add = function(r, e, t) {
  var n = r.id;
  this._validateId(n), tr(e, xg, n), t && tr(t, xg, n), this._elements[n] = { element: r, gfx: e, secondaryGfx: t };
};
Da.prototype.remove = function(r) {
  var e = this._elements, t = r.id || r, n = t && e[t];
  n && (tr(n.gfx, xg, ""), n.secondaryGfx && tr(n.secondaryGfx, xg, ""), delete e[t]);
};
Da.prototype.updateId = function(r, e) {
  this._validateId(e), typeof r == "string" && (r = this.get(r)), this._eventBus.fire("element.updateId", {
    element: r,
    newId: e
  });
  var t = this.getGraphics(r), n = this.getGraphics(r, !0);
  this.remove(r), r.id = e, this.add(r, t, n);
};
Da.prototype.updateGraphics = function(r, e, t) {
  var n = r.id || r, i = this._elements[n];
  return t ? i.secondaryGfx = e : i.gfx = e, e && tr(e, xg, n), e;
};
Da.prototype.get = function(r) {
  var e;
  typeof r == "string" ? e = r : e = r && tr(r, xg);
  var t = this._elements[e];
  return t && t.element;
};
Da.prototype.filter = function(r) {
  var e = [];
  return this.forEach(function(t, n) {
    r(t, n) && e.push(t);
  }), e;
};
Da.prototype.find = function(r) {
  for (var e = this._elements, t = Object.keys(e), n = 0; n < t.length; n++) {
    var i = t[n], s = e[i], o = s.element, a = s.gfx;
    if (r(o, a))
      return o;
  }
};
Da.prototype.getAll = function() {
  return this.filter(function(r) {
    return r;
  });
};
Da.prototype.forEach = function(r) {
  var e = this._elements;
  Object.keys(e).forEach(function(t) {
    var n = e[t], i = n.element, s = n.gfx;
    return r(i, s);
  });
};
Da.prototype.getGraphics = function(r, e) {
  var t = r.id || r, n = this._elements[t];
  return n && (e ? n.secondaryGfx : n.gfx);
};
Da.prototype._validateId = function(r) {
  if (!r)
    throw new Error("element must have an id");
  if (this._elements[r])
    throw new Error("element with id " + r + " already added");
};
function iIt(r, e, t, n) {
  var i = t.inverse;
  return Object.defineProperty(r, "remove", {
    value: function(s) {
      var o = this.indexOf(s);
      return o !== -1 && (this.splice(o, 1), e.unset(s, i, n)), s;
    }
  }), Object.defineProperty(r, "contains", {
    value: function(s) {
      return this.indexOf(s) !== -1;
    }
  }), Object.defineProperty(r, "add", {
    value: function(s, o) {
      var a = this.indexOf(s);
      if (typeof o > "u") {
        if (a !== -1)
          return;
        o = this.length;
      }
      a !== -1 && this.splice(a, 1), this.splice(o, 0, s), a === -1 && e.set(s, i, n);
    }
  }), Object.defineProperty(r, "__refs_collection", {
    value: !0
  }), r;
}
function rIt(r) {
  return r.__refs_collection === !0;
}
function sIt(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e.name || e);
}
function _Oe(r, e, t) {
  var n = iIt(t[e.name] || [], r, e, t);
  Object.defineProperty(t, e.name, {
    enumerable: e.enumerable,
    value: n
  }), n.length && n.forEach(function(i) {
    r.set(i, e.inverse, t);
  });
}
function oIt(r, e, t) {
  var n = e.inverse, i = t[e.name];
  Object.defineProperty(t, e.name, {
    configurable: e.configurable,
    enumerable: e.enumerable,
    get: function() {
      return i;
    },
    set: function(s) {
      if (s !== i) {
        var o = i;
        i = null, o && r.unset(o, n, t), i = s, r.set(i, n, t);
      }
    }
  });
}
function wl(r, e) {
  if (!(this instanceof wl))
    return new wl(r, e);
  r.inverse = e, e.inverse = r, this.props = {}, this.props[r.name] = r, this.props[e.name] = e;
}
wl.prototype.bind = function(r, e) {
  if (typeof e == "string") {
    if (!this.props[e])
      throw new Error("no property <" + e + "> in ref");
    e = this.props[e];
  }
  e.collection ? _Oe(this, e, r) : oIt(this, e, r);
};
wl.prototype.ensureRefsCollection = function(r, e) {
  var t = r[e.name];
  return rIt(t) || _Oe(this, e, r), t;
};
wl.prototype.ensureBound = function(r, e) {
  sIt(r, e) || this.bind(r, e);
};
wl.prototype.unset = function(r, e, t) {
  r && (this.ensureBound(r, e), e.collection ? this.ensureRefsCollection(r, e).remove(t) : r[e.name] = void 0);
};
wl.prototype.set = function(r, e, t) {
  r && (this.ensureBound(r, e), e.collection ? this.ensureRefsCollection(r, e).add(t) : r[e.name] = t);
};
var xV = new wl({ name: "children", enumerable: !0, collection: !0 }, { name: "parent" }), xOe = new wl({ name: "labels", enumerable: !0, collection: !0 }, { name: "labelTarget" }), o7e = new wl({ name: "attachers", collection: !0 }, { name: "host" }), SOe = new wl({ name: "outgoing", collection: !0 }, { name: "source" }), MOe = new wl({ name: "incoming", collection: !0 }, { name: "target" });
function Zw() {
  Object.defineProperty(this, "businessObject", {
    writable: !0
  }), Object.defineProperty(this, "label", {
    get: function() {
      return this.labels[0];
    },
    set: function(r) {
      var e = this.label, t = this.labels;
      !r && e ? t.remove(e) : t.add(r, 0);
    }
  }), xV.bind(this, "parent"), xOe.bind(this, "labels"), SOe.bind(this, "outgoing"), MOe.bind(this, "incoming");
}
function Uw() {
  Zw.call(this), xV.bind(this, "children"), o7e.bind(this, "host"), o7e.bind(this, "attachers");
}
Ma(Uw, Zw);
function DOe() {
  Zw.call(this), xV.bind(this, "children");
}
Ma(DOe, Uw);
function LOe() {
  Uw.call(this), xOe.bind(this, "labelTarget");
}
Ma(LOe, Uw);
function kOe() {
  Zw.call(this), SOe.bind(this, "source"), MOe.bind(this, "target");
}
Ma(kOe, Zw);
var aIt = {
  connection: kOe,
  shape: Uw,
  label: LOe,
  root: DOe
};
function lIt(r, e) {
  var t = aIt[r];
  if (!t)
    throw new Error("unknown type: <" + r + ">");
  return Ft(new t(), e);
}
function fm() {
  this._uid = 12;
}
fm.prototype.createRoot = function(r) {
  return this.create("root", r);
};
fm.prototype.createLabel = function(r) {
  return this.create("label", r);
};
fm.prototype.createShape = function(r) {
  return this.create("shape", r);
};
fm.prototype.createConnection = function(r) {
  return this.create("connection", r);
};
fm.prototype.create = function(r, e) {
  return e = Ft({}, e || {}), e.id || (e.id = r + "_" + this._uid++), lIt(r, e);
};
var xb = "__fn", NOe = 1e3, cIt = Array.prototype.slice;
function Uo() {
  this._listeners = {}, this.on("diagram.destroy", 1, this._destroy, this);
}
Uo.prototype.on = function(r, e, t, n) {
  if (r = ul(r) ? r : [r], ol(e) && (n = t, t = e, e = NOe), !ec(e))
    throw new Error("priority must be a number");
  var i = t;
  n && (i = oI(t, n), i[xb] = t[xb] || t);
  var s = this;
  r.forEach(function(o) {
    s._addListener(o, {
      priority: e,
      callback: i,
      next: null
    });
  });
};
Uo.prototype.once = function(r, e, t, n) {
  var i = this;
  if (ol(e) && (n = t, t = e, e = NOe), !ec(e))
    throw new Error("priority must be a number");
  function s() {
    s.__isTomb = !0;
    var o = t.apply(n, arguments);
    return i.off(r, s), o;
  }
  s[xb] = t, this.on(r, e, s);
};
Uo.prototype.off = function(r, e) {
  r = ul(r) ? r : [r];
  var t = this;
  r.forEach(function(n) {
    t._removeListener(n, e);
  });
};
Uo.prototype.createEvent = function(r) {
  var e = new qw();
  return e.init(r), e;
};
Uo.prototype.fire = function(r, e) {
  var t, n, i, s;
  if (s = cIt.call(arguments), typeof r == "object" && (e = r, r = e.type), !r)
    throw new Error("no event type specified");
  if (n = this._listeners[r], !!n) {
    e instanceof qw ? t = e : t = this.createEvent(e), s[0] = t;
    var o = t.type;
    r !== o && (t.type = r);
    try {
      i = this._invokeListeners(t, s, n);
    } finally {
      r !== o && (t.type = o);
    }
    return i === void 0 && t.defaultPrevented && (i = !1), i;
  }
};
Uo.prototype.handleError = function(r) {
  return this.fire("error", { error: r }) === !1;
};
Uo.prototype._destroy = function() {
  this._listeners = {};
};
Uo.prototype._invokeListeners = function(r, e, t) {
  for (var n; t && !r.cancelBubble; )
    n = this._invokeListener(r, e, t), t = t.next;
  return n;
};
Uo.prototype._invokeListener = function(r, e, t) {
  var n;
  if (t.callback.__isTomb)
    return n;
  try {
    n = hIt(t.callback, e), n !== void 0 && (r.returnValue = n, r.stopPropagation()), n === !1 && r.preventDefault();
  } catch (i) {
    if (!this.handleError(i))
      throw console.error("unhandled error in event listener", i), i;
  }
  return n;
};
Uo.prototype._addListener = function(r, e) {
  var t = this._getListeners(r), n;
  if (!t) {
    this._setListeners(r, e);
    return;
  }
  for (; t; ) {
    if (t.priority < e.priority) {
      e.next = t, n ? n.next = e : this._setListeners(r, e);
      return;
    }
    n = t, t = t.next;
  }
  n.next = e;
};
Uo.prototype._getListeners = function(r) {
  return this._listeners[r];
};
Uo.prototype._setListeners = function(r, e) {
  this._listeners[r] = e;
};
Uo.prototype._removeListener = function(r, e) {
  var t = this._getListeners(r), n, i, s;
  if (!e) {
    this._setListeners(r, null);
    return;
  }
  for (; t; )
    n = t.next, s = t.callback, (s === e || s[xb] === e) && (i ? i.next = n : this._setListeners(r, n)), i = t, t = n;
};
function qw() {
}
qw.prototype.stopPropagation = function() {
  this.cancelBubble = !0;
};
qw.prototype.preventDefault = function() {
  this.defaultPrevented = !0;
};
qw.prototype.init = function(r) {
  Ft(this, r || {});
};
function hIt(r, e) {
  return r.apply(null, e);
}
function TOe(r) {
  return r.childNodes[0];
}
function dIt(r) {
  return r.parentNode.childNodes[1];
}
function La(r, e) {
  this._eventBus = r, this._elementRegistry = e;
}
La.$inject = ["eventBus", "elementRegistry"];
La.prototype._getChildrenContainer = function(r) {
  var e = this._elementRegistry.getGraphics(r), t;
  return r.parent ? (t = dIt(e), t || (t = Fo("g"), dd(t).add("djs-children"), oh(e.parentNode, t))) : t = e, t;
};
La.prototype._clear = function(r) {
  var e = TOe(r);
  return GIe(e), e;
};
La.prototype._createContainer = function(r, e, t, n) {
  var i = Fo("g");
  dd(i).add("djs-group"), typeof t < "u" ? IOe(i, e, e.childNodes[t]) : oh(e, i);
  var s = Fo("g");
  dd(s).add("djs-element"), dd(s).add("djs-" + r), n && dd(s).add("djs-frame"), oh(i, s);
  var o = Fo("g");
  return dd(o).add("djs-visual"), oh(s, o), s;
};
La.prototype.create = function(r, e, t) {
  var n = this._getChildrenContainer(e.parent);
  return this._createContainer(r, n, t, oOe(e));
};
La.prototype.updateContainments = function(r) {
  var e = this, t = this._elementRegistry, n;
  n = $p(r, function(i, s) {
    return s.parent && (i[s.parent.id] = s.parent), i;
  }, {}), vn(n, function(i) {
    var s = i.children;
    if (s) {
      var o = e._getChildrenContainer(i);
      vn(s.slice().reverse(), function(a) {
        var l = t.getGraphics(a);
        IOe(l.parentNode, o);
      });
    }
  });
};
La.prototype.drawShape = function(r, e, t = {}) {
  var n = this._eventBus;
  return n.fire("render.shape", { gfx: r, element: e, attrs: t });
};
La.prototype.getShapePath = function(r) {
  var e = this._eventBus;
  return e.fire("render.getShapePath", r);
};
La.prototype.drawConnection = function(r, e, t = {}) {
  var n = this._eventBus;
  return n.fire("render.connection", { gfx: r, element: e, attrs: t });
};
La.prototype.getConnectionPath = function(r) {
  var e = this._eventBus;
  return e.fire("render.getConnectionPath", r);
};
La.prototype.update = function(r, e, t) {
  if (e.parent) {
    var n = this._clear(t);
    if (r === "shape")
      this.drawShape(n, e), tOe(t, e.x, e.y);
    else if (r === "connection")
      this.drawConnection(n, e);
    else
      throw new Error("unknown type: " + r);
    e.hidden ? tr(t, "display", "none") : tr(t, "display", "block");
  }
};
La.prototype.remove = function(r) {
  var e = this._elementRegistry.getGraphics(r);
  jw(e.parentNode);
};
function IOe(r, e, t) {
  var n = t || e.firstChild;
  r !== n && e.insertBefore(r, n);
}
const uIt = {
  __depends__: [KTt],
  __init__: ["canvas"],
  canvas: ["type", xt],
  elementRegistry: ["type", Da],
  elementFactory: ["type", fm],
  eventBus: ["type", Uo],
  graphicsFactory: ["type", La]
};
function fIt(r) {
  var e = new bOe(r);
  return e.init(), e;
}
function pIt(r) {
  r = r || {};
  var e = {
    config: ["value", r]
  }, t = [e, uIt].concat(r.modules || []);
  return fIt(t);
}
function F1(r, e) {
  this._injector = e || pIt(r), this.get("eventBus").fire("diagram.init");
}
F1.prototype.get = function(r, e) {
  return this._injector.get(r, e);
};
F1.prototype.invoke = function(r, e, t) {
  return this._injector.invoke(r, e, t);
};
F1.prototype.destroy = function() {
  this.get("eventBus").fire("diagram.destroy");
};
F1.prototype.clear = function() {
  this.get("eventBus").fire("diagram.clear");
};
var gIt = "Tried to access di from the businessObject. The di is available through the diagram element only. For more information, see https://github.com/bpmn-io/bpmn-js/issues/1472";
function mIt(r) {
  qg(r, "di") || Object.defineProperty(r, "di", {
    enumerable: !1,
    get: function() {
      throw new Error(gIt);
    }
  });
}
function Ys(r, e) {
  return r.$instanceOf(e);
}
function AIt(r) {
  return Rd(r.rootElements, function(e) {
    return Ys(e, "bpmn:Process") || Ys(e, "bpmn:Collaboration");
  });
}
function wIt(r) {
  var e = {}, t = [], n = {};
  function i(G, j) {
    return function(pe) {
      G(pe, j);
    };
  }
  function s(G) {
    e[G.id] = G;
  }
  function o(G) {
    return e[G.id];
  }
  function a(G, j) {
    var pe = G.gfx;
    if (pe)
      throw new Error(
        `already rendered ${ls(G)}`
      );
    return r.element(G, n[G.id], j);
  }
  function l(G, j) {
    return r.root(G, n[G.id], j);
  }
  function c(G, j) {
    try {
      var pe = n[G.id] && a(G, j);
      return s(G), pe;
    } catch (De) {
      d(De.message, { element: G, error: De }), console.error(`failed to import ${ls(G)}`, De);
    }
  }
  function d(G, j) {
    r.error(G, j);
  }
  var u = this.registerDi = function(j) {
    var pe = j.bpmnElement;
    pe ? n[pe.id] ? d(
      `multiple DI elements defined for ${ls(pe)}`,
      { element: pe }
    ) : (n[pe.id] = j, mIt(pe)) : d(
      `no bpmnElement referenced in ${ls(j)}`,
      { element: j }
    );
  };
  function f(G) {
    p(G.plane);
  }
  function p(G) {
    u(G), vn(G.planeElement, g);
  }
  function g(G) {
    u(G);
  }
  this.handleDefinitions = function(j, pe) {
    var De = j.diagrams;
    if (pe && De.indexOf(pe) === -1)
      throw new Error("diagram not part of <bpmn:Definitions />");
    if (!pe && De && De.length && (pe = De[0]), !pe)
      throw new Error("no diagram to display");
    n = {}, f(pe);
    var Ce = pe.plane;
    if (!Ce)
      throw new Error(
        `no plane for ${ls(pe)}`
      );
    var F = Ce.bpmnElement;
    if (!F)
      if (F = AIt(j), F)
        d(
          `correcting missing bpmnElement on ${ls(Ce)} to ${ls(F)}`
        ), Ce.bpmnElement = F, u(Ce);
      else
        throw new Error("no process or collaboration to display");
    var I = l(F, Ce);
    if (Ys(F, "bpmn:Process") || Ys(F, "bpmn:SubProcess"))
      A(F, I);
    else if (Ys(F, "bpmn:Collaboration"))
      te(F, I), w(j.rootElements, I);
    else
      throw new Error(
        `unsupported bpmnElement for ${ls(Ce)}: ${ls(F)}`
      );
    m(t);
  };
  var m = this.handleDeferred = function() {
    for (var j; t.length; )
      j = t.shift(), j();
  };
  function A(G, j) {
    ee(G, j), T(G.ioSpecification, j), L(G.artifacts, j), s(G);
  }
  function w(G, j) {
    var pe = _M(G, function(De) {
      return !o(De) && Ys(De, "bpmn:Process") && De.laneSets;
    });
    pe.forEach(i(A, j));
  }
  function v(G, j) {
    c(G, j);
  }
  function y(G, j) {
    vn(G, i(v, j));
  }
  function _(G, j) {
    c(G, j);
  }
  function S(G, j) {
    c(G, j);
  }
  function D(G, j) {
    c(G, j);
  }
  function M(G, j) {
    c(G, j);
  }
  function L(G, j) {
    vn(G, function(pe) {
      Ys(pe, "bpmn:Association") ? t.push(function() {
        M(pe, j);
      }) : M(pe, j);
    });
  }
  function T(G, j) {
    G && (vn(G.dataInputs, i(S, j)), vn(G.dataOutputs, i(D, j)));
  }
  var B = this.handleSubProcess = function(j, pe) {
    ee(j, pe), L(j.artifacts, pe);
  };
  function V(G, j) {
    var pe = c(G, j);
    Ys(G, "bpmn:SubProcess") && B(G, pe || j), Ys(G, "bpmn:Activity") && T(G.ioSpecification, j), t.push(function() {
      vn(G.dataInputAssociations, i(_, j)), vn(G.dataOutputAssociations, i(_, j));
    });
  }
  function N(G, j) {
    c(G, j);
  }
  function R(G, j) {
    c(G, j);
  }
  function H(G, j) {
    t.push(function() {
      var pe = c(G, j);
      G.childLaneSet && z(G.childLaneSet, pe || j), ue(G);
    });
  }
  function z(G, j) {
    vn(G.lanes, i(H, j));
  }
  function U(G, j) {
    vn(G, i(z, j));
  }
  function ee(G, j) {
    ce(G.flowElements, j), G.laneSets && U(G.laneSets, j);
  }
  function ce(G, j) {
    vn(G, function(pe) {
      Ys(pe, "bpmn:SequenceFlow") ? t.push(function() {
        N(pe, j);
      }) : Ys(pe, "bpmn:BoundaryEvent") ? t.unshift(function() {
        V(pe, j);
      }) : Ys(pe, "bpmn:FlowNode") ? V(pe, j) : Ys(pe, "bpmn:DataObject") || (Ys(pe, "bpmn:DataStoreReference") || Ys(pe, "bpmn:DataObjectReference") ? R(pe, j) : d(
        `unrecognized flowElement ${ls(pe)} in context ${ls(j && j.businessObject)}`,
        {
          element: pe,
          context: j
        }
      ));
    });
  }
  function se(G, j) {
    var pe = c(G, j), De = G.processRef;
    De && A(De, pe || j);
  }
  function te(G, j) {
    vn(G.participants, i(se, j)), t.push(function() {
      y(G.messageFlows, j);
    }), L(G.artifacts, j);
  }
  function ue(G) {
    vn(G.flowNodeRef, function(j) {
      var pe = j.get("lanes");
      pe && pe.push(G);
    });
  }
}
function vIt(r, e, t) {
  var n, i, s, o, a = [];
  function l(c, d) {
    var u = {
      root: function(m, A) {
        return n.add(m, A);
      },
      element: function(m, A, w) {
        return n.add(m, A, w);
      },
      error: function(m, A) {
        a.push({ message: m, context: A });
      }
    }, f = new wIt(u);
    d = d || c.diagrams && c.diagrams[0];
    var p = bIt(c, d);
    if (!p)
      throw new Error("no diagram to display");
    vn(p, function(m) {
      f.handleDefinitions(c, m);
    });
    var g = d.plane.bpmnElement.id;
    s.setRootElement(
      s.findRoot(g + "_plane") || s.findRoot(g)
    );
  }
  return new Promise(function(c, d) {
    try {
      return n = r.get("bpmnImporter"), i = r.get("eventBus"), s = r.get("canvas"), i.fire("import.render.start", { definitions: e }), l(e, t), i.fire("import.render.complete", {
        error: o,
        warnings: a
      }), c({ warnings: a });
    } catch (u) {
      return u.warnings = a, d(u);
    }
  });
}
function bIt(r, e) {
  if (!(!e || !e.plane)) {
    var t = e.plane.bpmnElement, n = t;
    !He(t, "bpmn:Process") && !He(t, "bpmn:Collaboration") && (n = yIt(t));
    var i;
    He(n, "bpmn:Collaboration") ? i = n : i = Rd(r.rootElements, function(c) {
      if (He(c, "bpmn:Collaboration"))
        return Rd(c.participants, function(d) {
          return d.processRef === n;
        });
    });
    var s = [n];
    i && (s = OWe(i.participants, function(c) {
      return c.processRef;
    }), s.push(i));
    var o = OOe(s), a = [e], l = [t];
    return vn(r.diagrams, function(c) {
      if (c.plane) {
        var d = c.plane.bpmnElement;
        o.indexOf(d) !== -1 && l.indexOf(d) === -1 && (a.push(c), l.push(d));
      }
    }), a;
  }
}
function OOe(r) {
  var e = [];
  return vn(r, function(t) {
    t && (e.push(t), e = e.concat(OOe(t.flowElements)));
  }), e;
}
function yIt(r) {
  for (var e = r; e; ) {
    if (He(e, "bpmn:Process"))
      return e;
    e = e.$parent;
  }
}
var CIt = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.02 5.57" width="53" height="21"><path fill="currentColor" d="M1.88.92v.14c0 .41-.13.68-.4.8.33.14.46.44.46.86v.33c0 .61-.33.95-.95.95H0V0h.95c.65 0 .93.3.93.92zM.63.57v1.06h.24c.24 0 .38-.1.38-.43V.98c0-.28-.1-.4-.32-.4zm0 1.63v1.22h.36c.2 0 .32-.1.32-.39v-.35c0-.37-.12-.48-.4-.48H.63zM4.18.99v.52c0 .64-.31.98-.94.98h-.3V4h-.62V0h.92c.63 0 .94.35.94.99zM2.94.57v1.35h.3c.2 0 .3-.09.3-.37v-.6c0-.29-.1-.38-.3-.38h-.3zm2.89 2.27L6.25 0h.88v4h-.6V1.12L6.1 3.99h-.6l-.46-2.82v2.82h-.55V0h.87zM8.14 1.1V4h-.56V0h.79L9 2.4V0h.56v4h-.64zm2.49 2.29v.6h-.6v-.6zM12.12 1c0-.63.33-1 .95-1 .61 0 .95.37.95 1v2.04c0 .64-.34 1-.95 1-.62 0-.95-.37-.95-1zm.62 2.08c0 .28.13.39.33.39s.32-.1.32-.4V.98c0-.29-.12-.4-.32-.4s-.33.11-.33.4z"/><path fill="currentColor" d="M0 4.53h14.02v1.04H0zM11.08 0h.63v.62h-.63zm.63 4V1h-.63v2.98z"/></svg>', ROe = CIt, VOe = {
  verticalAlign: "middle"
}, HOe = {
  color: "#404040"
}, EIt = {
  zIndex: "1001",
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
  bottom: "0"
}, _It = {
  width: "100%",
  height: "100%",
  background: "rgba(40,40,40,0.2)"
}, xIt = {
  position: "absolute",
  left: "50%",
  top: "40%",
  transform: "translate(-50%)",
  width: "260px",
  padding: "10px",
  background: "white",
  boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: "14px",
  display: "flex",
  lineHeight: "1.3"
}, SIt = '<div class="bjs-powered-by-lightbox"><div class="backdrop"></div><div class="notice"><a href="https://bpmn.io" target="_blank" rel="noopener" class="link">' + ROe + '</a><span>Web-based tooling for BPMN, DMN and forms powered by <a href="https://bpmn.io" target="_blank" rel="noopener">bpmn.io</a>.</span></div></div>', Uc;
function MIt() {
  Uc = Ah(SIt), Lo(Uc, EIt), Lo(Ps("svg", Uc), VOe), Lo(Ps(".backdrop", Uc), _It), Lo(Ps(".notice", Uc), xIt), Lo(Ps(".link", Uc), HOe, {
    margin: "15px 20px 15px 10px",
    alignSelf: "center"
  });
}
function DIt() {
  Uc || (MIt(), DN.bind(Uc, ".backdrop", "click", function(r) {
    document.body.removeChild(Uc);
  })), document.body.appendChild(Uc);
}
function or(r) {
  r = Ft({}, kIt, r), this._moddle = this._createModdle(r), this._container = this._createContainer(r), this._init(this._container, this._moddle, r), TIt(this._container);
}
Ma(or, F1);
or.prototype.importXML = async function(e, t) {
  const n = this;
  function i(o) {
    return n.get("eventBus").createEvent(o);
  }
  let s = [];
  try {
    e = this._emit("import.parse.start", { xml: e }) || e;
    let o;
    try {
      o = await this._moddle.fromXML(e, "bpmn:Definitions");
    } catch (f) {
      throw this._emit("import.parse.complete", {
        error: f
      }), f;
    }
    let a = o.rootElement;
    const l = o.references, c = o.warnings, d = o.elementsById;
    s = s.concat(c), a = this._emit("import.parse.complete", i({
      error: null,
      definitions: a,
      elementsById: d,
      references: l,
      warnings: s
    })) || a;
    const u = await this.importDefinitions(a, t);
    return s = s.concat(u.warnings), this._emit("import.done", { error: null, warnings: s }), { warnings: s };
  } catch (o) {
    let a = o;
    throw s = s.concat(a.warnings || []), U6(a, s), a = LIt(a), this._emit("import.done", { error: a, warnings: a.warnings }), a;
  }
};
or.prototype.importDefinitions = async function(e, t) {
  return this._setDefinitions(e), { warnings: (await this.open(t)).warnings };
};
or.prototype.open = async function(e) {
  const t = this._definitions;
  let n = e;
  if (!t) {
    const s = new Error("no XML imported");
    throw U6(s, []), s;
  }
  if (typeof e == "string" && (n = NIt(t, e), !n)) {
    const s = new Error("BPMNDiagram <" + e + "> not found");
    throw U6(s, []), s;
  }
  try {
    this.clear();
  } catch (s) {
    throw U6(s, []), s;
  }
  const { warnings: i } = await vIt(this, t, n);
  return { warnings: i };
};
or.prototype.saveXML = async function(e) {
  e = e || {};
  let t = this._definitions, n, i;
  try {
    if (!t)
      throw new Error("no definitions loaded");
    t = this._emit("saveXML.start", {
      definitions: t
    }) || t, i = (await this._moddle.toXML(t, e)).xml, i = this._emit("saveXML.serialized", {
      xml: i
    }) || i;
  } catch (o) {
    n = o;
  }
  const s = n ? { error: n } : { xml: i };
  if (this._emit("saveXML.done", s), n)
    throw n;
  return s;
};
or.prototype.saveSVG = async function() {
  this._emit("saveSVG.start");
  let e, t;
  try {
    const n = this.get("canvas"), i = n.getActiveLayer(), s = Ps(":scope > defs", n._svg), o = Jbe(i), a = s ? "<defs>" + Jbe(s) + "</defs>" : "", l = i.getBBox();
    e = `<?xml version="1.0" encoding="utf-8"?>
<!-- created with bpmn-js / http://bpmn.io -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="` + l.width + '" height="' + l.height + '" viewBox="' + l.x + " " + l.y + " " + l.width + " " + l.height + '" version="1.1">' + a + o + "</svg>";
  } catch (n) {
    t = n;
  }
  if (this._emit("saveSVG.done", {
    error: t,
    svg: e
  }), t)
    throw t;
  return { svg: e };
};
or.prototype._setDefinitions = function(r) {
  this._definitions = r;
};
or.prototype.getModules = function() {
  return this._modules;
};
or.prototype.clear = function() {
  this.getDefinitions() && F1.prototype.clear.call(this);
};
or.prototype.destroy = function() {
  F1.prototype.destroy.call(this), _b(this._container);
};
or.prototype.on = function(r, e, t, n) {
  return this.get("eventBus").on(r, e, t, n);
};
or.prototype.off = function(r, e) {
  this.get("eventBus").off(r, e);
};
or.prototype.attachTo = function(r) {
  if (!r)
    throw new Error("parentNode required");
  this.detach(), r.get && r.constructor.prototype.jquery && (r = r.get(0)), typeof r == "string" && (r = Ps(r)), r.appendChild(this._container), this._emit("attach", {}), this.get("canvas").resized();
};
or.prototype.getDefinitions = function() {
  return this._definitions;
};
or.prototype.detach = function() {
  const r = this._container, e = r.parentNode;
  e && (this._emit("detach", {}), e.removeChild(r));
};
or.prototype._init = function(r, e, t) {
  const n = t.modules || this.getModules(t), i = t.additionalModules || [], s = [
    {
      bpmnjs: ["value", this],
      moddle: ["value", e]
    }
  ], o = [].concat(s, n, i), a = Ft(BWe(t, ["additionalModules"]), {
    canvas: Ft({}, t.canvas, { container: r }),
    modules: o
  });
  F1.call(this, a), t && t.container && this.attachTo(t.container);
};
or.prototype._emit = function(r, e) {
  return this.get("eventBus").fire(r, e);
};
or.prototype._createContainer = function(r) {
  const e = Ah('<div class="bjs-container"></div>');
  return Lo(e, {
    width: a7e(r.width),
    height: a7e(r.height),
    position: r.position
  }), e;
};
or.prototype._createModdle = function(r) {
  const e = Ft({}, this._moddleExtensions, r.moddleExtensions);
  return new Q4(e);
};
or.prototype._modules = [];
function U6(r, e) {
  return r.warnings = e, r;
}
function LIt(r) {
  const t = /unparsable content <([^>]+)> detected([\s\S]*)$/.exec(r.message);
  return t && (r.message = "unparsable content <" + t[1] + "> detected; this may indicate an invalid BPMN 2.0 diagram file" + t[2]), r;
}
const kIt = {
  width: "100%",
  height: "100%",
  position: "relative"
};
function a7e(r) {
  return r + (ec(r) ? "px" : "");
}
function NIt(r, e) {
  return e && Rd(r.diagrams, function(t) {
    return t.id === e;
  }) || null;
}
function TIt(r) {
  const t = '<a href="http://bpmn.io" target="_blank" class="bjs-powered-by" title="Powered by bpmn.io" >' + ROe + "</a>", n = Ah(t);
  Lo(Ps("svg", n), VOe), Lo(n, HOe, {
    position: "absolute",
    bottom: "15px",
    right: "15px",
    zIndex: "100"
  }), r.appendChild(n), fr.bind(n, "click", function(i) {
    DIt(), i.preventDefault();
  });
}
function pm(r) {
  or.call(this, r);
}
Ma(pm, or);
pm.prototype._modules = [
  fTt,
  TTt,
  cOe,
  PTt,
  iOe
];
pm.prototype._moddleExtensions = {};
var IIt = ["c", "C"], OIt = ["v", "V"], RIt = ["y", "Y"], BOe = ["z", "Z"];
function VIt(r) {
  return r.ctrlKey || r.metaKey || r.shiftKey || r.altKey;
}
function t1(r) {
  return r.altKey ? !1 : r.ctrlKey || r.metaKey;
}
function $c(r, e) {
  return r = ul(r) ? r : [r], r.indexOf(e.key) !== -1 || r.indexOf(e.code) !== -1;
}
function SV(r) {
  return r.shiftKey;
}
function HIt(r) {
  return t1(r) && $c(IIt, r);
}
function BIt(r) {
  return t1(r) && $c(OIt, r);
}
function PIt(r) {
  return t1(r) && !SV(r) && $c(BOe, r);
}
function FIt(r) {
  return t1(r) && ($c(RIt, r) || $c(BOe, r) && SV(r));
}
var Yy = "keyboard.keydown", zIt = "keyboard.keyup", WIt = 1e3, POe = "Keyboard binding is now implicit; explicit binding to an element got removed. For more information, see https://github.com/bpmn-io/diagram-js/issues/661";
function Us(r, e) {
  var t = this;
  this._config = r = r || {}, this._eventBus = e, this._keydownHandler = this._keydownHandler.bind(this), this._keyupHandler = this._keyupHandler.bind(this), e.on("diagram.destroy", function() {
    t._fire("destroy"), t.unbind();
  }), r.bindTo && console.error("unsupported configuration <keyboard.bindTo>", new Error(POe));
  var n = r && r.bind !== !1;
  e.on("canvas.init", function(i) {
    t._target = i.svg, n && t.bind(), t._fire("init");
  });
}
Us.$inject = [
  "config.keyboard",
  "eventBus"
];
Us.prototype._keydownHandler = function(r) {
  this._keyHandler(r, Yy);
};
Us.prototype._keyupHandler = function(r) {
  this._keyHandler(r, zIt);
};
Us.prototype._keyHandler = function(r, e) {
  var t;
  if (!this._isEventIgnored(r)) {
    var n = {
      keyEvent: r
    };
    t = this._eventBus.fire(e || Yy, n), t && r.preventDefault();
  }
};
Us.prototype._isEventIgnored = function(r) {
  return !1;
};
Us.prototype.bind = function(r) {
  r && console.error("unsupported argument <node>", new Error(POe)), this.unbind(), r = this._node = this._target, fr.bind(r, "keydown", this._keydownHandler), fr.bind(r, "keyup", this._keyupHandler), this._fire("bind");
};
Us.prototype.getBinding = function() {
  return this._node;
};
Us.prototype.unbind = function() {
  var r = this._node;
  r && (this._fire("unbind"), fr.unbind(r, "keydown", this._keydownHandler), fr.unbind(r, "keyup", this._keyupHandler)), this._node = null;
};
Us.prototype._fire = function(r) {
  this._eventBus.fire("keyboard." + r, { node: this._node });
};
Us.prototype.addListener = function(r, e, t) {
  ol(r) && (t = e, e = r, r = WIt), this._eventBus.on(t || Yy, r, e);
};
Us.prototype.removeListener = function(r, e) {
  this._eventBus.off(e || Yy, r);
};
Us.prototype.hasModifier = VIt;
Us.prototype.isCmd = t1;
Us.prototype.isShift = SV;
Us.prototype.isKey = $c;
var jIt = 500;
function MV(r, e) {
  var t = this;
  r.on("editorActions.init", jIt, function(n) {
    var i = n.editorActions;
    t.registerBindings(e, i);
  });
}
MV.$inject = [
  "eventBus",
  "keyboard"
];
MV.prototype.registerBindings = function(r, e) {
  function t(n, i) {
    e.isRegistered(n) && r.addListener(i);
  }
  t("undo", function(n) {
    var i = n.keyEvent;
    if (PIt(i))
      return e.trigger("undo"), !0;
  }), t("redo", function(n) {
    var i = n.keyEvent;
    if (FIt(i))
      return e.trigger("redo"), !0;
  }), t("copy", function(n) {
    var i = n.keyEvent;
    if (HIt(i))
      return e.trigger("copy"), !0;
  }), t("paste", function(n) {
    var i = n.keyEvent;
    if (BIt(i))
      return e.trigger("paste"), !0;
  }), t("stepZoom", function(n) {
    var i = n.keyEvent;
    if ($c(["+", "Add", "="], i) && t1(i))
      return e.trigger("stepZoom", { value: 1 }), !0;
  }), t("stepZoom", function(n) {
    var i = n.keyEvent;
    if ($c(["-", "Subtract"], i) && t1(i))
      return e.trigger("stepZoom", { value: -1 }), !0;
  }), t("zoom", function(n) {
    var i = n.keyEvent;
    if ($c("0", i) && t1(i))
      return e.trigger("zoom", { value: 1 }), !0;
  }), t("removeSelection", function(n) {
    var i = n.keyEvent;
    if ($c(["Backspace", "Delete", "Del"], i))
      return e.trigger("removeSelection"), !0;
  });
};
const ZIt = {
  __init__: ["keyboard", "keyboardBindings"],
  keyboard: ["type", Us],
  keyboardBindings: ["type", MV]
};
var UIt = {
  moveSpeed: 50,
  moveSpeedAccelerated: 200
};
function FOe(r, e, t) {
  var n = this;
  this._config = Ft({}, UIt, r || {}), e.addListener(i);
  function i(s) {
    var o = s.keyEvent, a = n._config;
    if (e.isCmd(o) && e.isKey([
      "ArrowLeft",
      "Left",
      "ArrowUp",
      "Up",
      "ArrowDown",
      "Down",
      "ArrowRight",
      "Right"
    ], o)) {
      var l = e.isShift(o) ? a.moveSpeedAccelerated : a.moveSpeed, c;
      switch (o.key) {
        case "ArrowLeft":
        case "Left":
          c = "left";
          break;
        case "ArrowUp":
        case "Up":
          c = "up";
          break;
        case "ArrowRight":
        case "Right":
          c = "right";
          break;
        case "ArrowDown":
        case "Down":
          c = "down";
          break;
      }
      return n.moveCanvas({
        speed: l,
        direction: c
      }), !0;
    }
  }
  this.moveCanvas = function(s) {
    var o = 0, a = 0, l = s.speed, c = l / Math.min(Math.sqrt(t.viewbox().scale), 1);
    switch (s.direction) {
      case "left":
        o = c;
        break;
      case "up":
        a = c;
        break;
      case "right":
        o = -c;
        break;
      case "down":
        a = -c;
        break;
    }
    t.scroll({
      dx: o,
      dy: a
    });
  };
}
FOe.$inject = [
  "config.keyboardMove",
  "keyboard",
  "canvas"
];
const qIt = {
  __depends__: [
    ZIt
  ],
  __init__: ["keyboardMove"],
  keyboardMove: ["type", FOe]
};
var GIt = /^djs-cursor-.*$/;
function zOe(r) {
  var e = Ja(document.body);
  e.removeMatching(GIt), r && e.add("djs-cursor-" + r);
}
function QIt() {
  zOe(null);
}
var KIt = 5e3;
function YIt(r, e) {
  e = e || "element.click";
  function t() {
    return !1;
  }
  return r.once(e, KIt, t), function() {
    r.off(e, t);
  };
}
function l7e(r, e) {
  return {
    x: r.x - e.x,
    y: r.y - e.y
  };
}
var XIt = 15;
function WOe(r, e) {
  var t;
  function n(a) {
    return o(a.originalEvent);
  }
  r.on("canvas.focus.changed", function(a) {
    a.focused ? r.on("element.mousedown", 500, n) : r.off("element.mousedown", n);
  });
  function i(a) {
    var l = t.start, c = t.button, d = t7e(a), u = l7e(d, l);
    if (!t.dragging && JIt(u) > XIt && (t.dragging = !0, c === 0 && YIt(r), zOe("grab")), t.dragging) {
      var f = t.last || t.start;
      u = l7e(d, f), e.scroll({
        dx: u.x,
        dy: u.y
      }), t.last = d;
    }
    a.preventDefault();
  }
  function s(a) {
    fr.unbind(document, "mousemove", i), fr.unbind(document, "mouseup", s), t = null, QIt();
  }
  function o(a) {
    if (!QIe(a.target, ".djs-draggable")) {
      var l = a.button;
      if (!(l >= 2 || a.ctrlKey || a.shiftKey || a.altKey))
        return t = {
          button: l,
          start: t7e(a)
        }, fr.bind(document, "mousemove", i), fr.bind(document, "mouseup", s), !0;
    }
  }
  this.isActive = function() {
    return !!t;
  };
}
WOe.$inject = [
  "eventBus",
  "canvas"
];
function JIt(r) {
  return Math.sqrt(Math.pow(r.x, 2) + Math.pow(r.y, 2));
}
const $It = {
  __init__: ["moveCanvas"],
  moveCanvas: ["type", WOe]
};
function NN(r) {
  return Math.log(r) / Math.log(10);
}
function jOe(r, e) {
  var t = NN(r.min), n = NN(r.max), i = Math.abs(t) + Math.abs(n);
  return i / e;
}
function eOt(r, e) {
  return Math.max(r.min, Math.min(r.max, e));
}
var tOt = Math.sign || function(r) {
  return r >= 0 ? 1 : -1;
}, DV = { min: 0.2, max: 4 }, ZOe = 10, nOt = 0.1, iOt = 0.75;
function Lh(r, e, t) {
  r = r || {}, this._enabled = !1, this._canvas = t, this._container = t._container, this._handleWheel = oI(this._handleWheel, this), this._totalDelta = 0, this._scale = r.scale || iOt;
  var n = this;
  e.on("canvas.focus.changed", function(i) {
    n._init(i.focused && r.enabled !== !1);
  });
}
Lh.$inject = [
  "config.zoomScroll",
  "eventBus",
  "canvas"
];
Lh.prototype.scroll = function(e) {
  this._canvas.scroll(e);
};
Lh.prototype.reset = function() {
  this._canvas.zoom("fit-viewport");
};
Lh.prototype.zoom = function(e, t) {
  var n = jOe(DV, ZOe * 2);
  this._totalDelta += e, Math.abs(this._totalDelta) > nOt && (this._zoom(e, t, n), this._totalDelta = 0);
};
Lh.prototype._handleWheel = function(e) {
  if (this._canvas.isFocused()) {
    var t = this._container;
    e.preventDefault();
    var n = e.ctrlKey || ITt() && e.metaKey, i = e.shiftKey, s = -1 * this._scale, o;
    if (n ? s *= e.deltaMode === 0 ? 0.02 : 0.32 : s *= e.deltaMode === 0 ? 1 : 16, n) {
      var a = t.getBoundingClientRect(), l = {
        x: e.clientX - a.left,
        y: e.clientY - a.top
      };
      o = Math.sqrt(
        Math.pow(e.deltaY, 2) + Math.pow(e.deltaX, 2)
      ) * tOt(e.deltaY) * s, this.zoom(o, l);
    } else
      i ? o = {
        dx: s * e.deltaY,
        dy: 0
      } : o = {
        dx: s * e.deltaX,
        dy: s * e.deltaY
      }, this.scroll(o);
  }
};
Lh.prototype.stepZoom = function(e, t) {
  var n = jOe(DV, ZOe);
  this._zoom(e, t, n);
};
Lh.prototype._zoom = function(r, e, t) {
  var n = this._canvas, i = r > 0 ? 1 : -1, s = NN(n.zoom()), o = Math.round(s / t) * t;
  o += t * i;
  var a = Math.pow(10, o);
  n.zoom(eOt(DV, a), e);
};
Lh.prototype.toggle = function(e) {
  var t = this._container, n = this._handleWheel, i = this._enabled;
  return typeof e > "u" && (e = !i), i !== e && fr[e ? "bind" : "unbind"](t, "wheel", n, !1), this._enabled = e, e;
};
Lh.prototype._init = function(r) {
  this.toggle(r);
};
const rOt = {
  __init__: ["zoomScroll"],
  zoomScroll: ["type", Lh]
};
function Df(r) {
  pm.call(this, r);
}
Ma(Df, pm);
Df.prototype._navigationModules = [
  qIt,
  $It,
  rOt
];
Df.prototype._modules = [].concat(
  pm.prototype._modules,
  Df.prototype._navigationModules
);
const sOt = "zeebe", oOt = "zeebe", aOt = "http://camunda.org/schema/zeebe/1.0", lOt = { tagAlias: "lowerCase" }, cOt = [], hOt = [{ name: "ZeebeServiceTask", extends: ["bpmn:ServiceTask", "bpmn:BusinessRuleTask", "bpmn:ScriptTask", "bpmn:SendTask", "bpmn:EndEvent", "bpmn:IntermediateThrowEvent"], properties: [{ name: "retryCounter", type: "String", isAttr: !0 }] }, { name: "IoMapping", superClass: ["Element"], properties: [{ name: "ioMapping", type: "IoMapping" }, { name: "inputParameters", isMany: !0, type: "Input" }, { name: "outputParameters", isMany: !0, type: "Output" }], meta: { allowedIn: ["bpmn:CallActivity", "bpmn:Event", "bpmn:ReceiveTask", "zeebe:ZeebeServiceTask", "bpmn:SubProcess", "bpmn:UserTask"] } }, { name: "InputOutputParameter", properties: [{ name: "source", isAttr: !0, type: "String" }, { name: "target", isAttr: !0, type: "String" }] }, { name: "Subscription", superClass: ["Element"], properties: [{ name: "correlationKey", isAttr: !0, type: "String" }] }, { name: "Input", superClass: ["InputOutputParameter"], meta: { allowedIn: ["bpmn:CallActivity", "zeebe:ZeebeServiceTask", "bpmn:SubProcess", "bpmn:UserTask"] } }, { name: "Output", superClass: ["InputOutputParameter"], meta: { allowedIn: ["bpmn:CallActivity", "bpmn:Event", "bpmn:ReceiveTask", "zeebe:ZeebeServiceTask", "bpmn:SubProcess", "bpmn:UserTask"] } }, { name: "TaskHeaders", superClass: ["Element"], meta: { allowedIn: ["zeebe:ZeebeServiceTask", "bpmn:UserTask"] }, properties: [{ name: "values", type: "Header", isMany: !0 }] }, { name: "Header", superClass: ["Element"], properties: [{ name: "id", type: "String", isAttr: !0 }, { name: "key", type: "String", isAttr: !0 }, { name: "value", type: "String", isAttr: !0 }] }, { name: "TaskDefinition", superClass: ["Element"], meta: { allowedIn: ["zeebe:ZeebeServiceTask"] }, properties: [{ name: "type", type: "String", isAttr: !0 }, { name: "retries", type: "String", isAttr: !0 }] }, { name: "LoopCharacteristics", superClass: ["Element"], meta: { allowedIn: ["bpmn:MultiInstanceLoopCharacteristics"] }, properties: [{ name: "inputCollection", type: "String", isAttr: !0 }, { name: "inputElement", type: "String", isAttr: !0 }, { name: "outputCollection", type: "String", isAttr: !0 }, { name: "outputElement", type: "String", isAttr: !0 }] }, { name: "CalledElement", superClass: ["Element"], meta: { allowedIn: ["bpmn:CallActivity"] }, properties: [{ name: "processId", type: "String", isAttr: !0 }, { name: "processIdExpression", type: "String", isAttr: !0 }, { name: "propagateAllChildVariables", isAttr: !0, type: "Boolean" }, { name: "propagateAllParentVariables", isAttr: !0, type: "Boolean", default: !0 }] }, { name: "UserTaskForm", superClass: ["Element"], meta: { allowedIn: ["bpmn:Process"] }, properties: [{ name: "id", type: "String", isAttr: !0 }, { name: "body", type: "String", isBody: !0 }] }, { name: "FormDefinition", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [{ name: "formKey", type: "String", isAttr: !0 }, { name: "formId", type: "String", isAttr: !0 }, { name: "externalReference", type: "String", isAttr: !0 }] }, { name: "LinkedResource", superClass: ["Element"], meta: { allowedIn: ["bpmn:ServiceTask"] }, properties: [{ name: "resourceId", type: "String", isAttr: !0 }, { name: "resourceType", type: "String", isAttr: !0 }, { name: "linkName", type: "String", isAttr: !0 }] }, { name: "LinkedResources", superClass: ["Element"], meta: { allowedIn: ["bpmn:ServiceTask"] }, properties: [{ name: "values", type: "LinkedResource", isMany: !0 }] }, { name: "UserTask", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [] }, { name: "CalledDecision", superClass: ["Element"], meta: { allowedIn: ["bpmn:BusinessRuleTask"] }, properties: [{ name: "decisionId", type: "String", isAttr: !0 }, { name: "resultVariable", type: "String", isAttr: !0 }] }, { name: "AssignmentDefinition", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [{ name: "assignee", type: "String", isAttr: !0 }, { name: "candidateGroups", type: "String", isAttr: !0 }, { name: "candidateUsers", type: "String", isAttr: !0 }] }, { name: "PriorityDefinition", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [{ name: "priority", type: "String", isAttr: !0 }] }, { name: "TaskSchedule", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [{ name: "dueDate", type: "String", isAttr: !0 }, { name: "followUpDate", type: "String", isAttr: !0 }] }, { name: "Properties", superClass: ["Element"], properties: [{ name: "properties", type: "Property", isMany: !0 }] }, { name: "Property", properties: [{ name: "name", type: "String", isAttr: !0 }, { name: "value", type: "String", isAttr: !0 }] }, { name: "TemplateSupported", isAbstract: !0, extends: ["bpmn:Collaboration", "bpmn:Process", "bpmn:FlowElement"], properties: [{ name: "modelerTemplate", isAttr: !0, type: "String" }, { name: "modelerTemplateVersion", isAttr: !0, type: "Integer" }, { name: "modelerTemplateIcon", isAttr: !0, type: "String" }] }, { name: "TemplatedRootElement", isAbstract: !0, extends: ["bpmn:Error", "bpmn:Escalation", "bpmn:Message", "bpmn:Signal"], properties: [{ name: "modelerTemplate", isAttr: !0, type: "String" }] }, { name: "Script", superClass: ["Element"], meta: { allowedIn: ["bpmn:ScriptTask"] }, properties: [{ name: "expression", type: "String", isAttr: !0 }, { name: "resultVariable", type: "String", isAttr: !0 }] }, { name: "ExecutionListeners", superClass: ["Element"], meta: { allowedIn: ["bpmn:Event", "bpmn:Activity", "bpmn:Process", "bpmn:ExclusiveGateway", "bpmn:InclusiveGateway", "bpmn:ParallelGateway", "bpmn:EventBasedGateway"] }, properties: [{ name: "listeners", type: "ExecutionListener", isMany: !0 }] }, { name: "ExecutionListener", superClass: ["Element"], meta: { allowedIn: ["zeebe:ExecutionListeners"] }, properties: [{ name: "eventType", type: "String", isAttr: !0 }, { name: "retries", type: "String", isAttr: !0 }, { name: "type", type: "String", isAttr: !0 }] }, { name: "TaskListeners", superClass: ["Element"], meta: { allowedIn: ["bpmn:UserTask"] }, properties: [{ name: "listeners", type: "TaskListener", isMany: !0 }] }, { name: "TaskListener", superClass: ["Element"], meta: { allowedIn: ["zeebe:TaskListeners"] }, properties: [{ name: "eventType", type: "String", isAttr: !0 }, { name: "retries", type: "String", isAttr: !0 }, { name: "type", type: "String", isAttr: !0 }] }, { name: "VersionTag", superClass: ["Element"], meta: { allowedIn: ["bpmn:Process"] }, properties: [{ name: "value", type: "String", isAttr: !0 }] }, { name: "BindingTypeSupported", isAbstract: !0, extends: ["zeebe:CalledDecision", "zeebe:CalledElement", "zeebe:FormDefinition", "zeebe:LinkedResource"], properties: [{ name: "bindingType", isAttr: !0, type: "String", default: "latest" }, { name: "versionTag", isAttr: !0, type: "String" }] }, { name: "AdHoc", superClass: ["Element"], meta: { allowedIn: ["bpmn:AdHocSubProcess"] }, properties: [{ name: "activeElementsCollection", isAttr: !0, type: "String" }] }], dOt = {
  name: sOt,
  prefix: oOt,
  uri: aOt,
  xml: lOt,
  associations: cOt,
  types: hOt
}, uOt = [
  mV
], fOt = {
  zeebe: dOt
};
function Sg(r = {}) {
  r = {
    ...r,
    moddleExtensions: {
      ...fOt,
      ...r.moddleExtensions
    }
  }, Df.call(this, r);
}
Ma(Sg, Df);
Sg.prototype._camundaCloudModules = [
  ...uOt
];
Sg.prototype._modules = [].concat(
  Df.prototype._modules,
  Sg.prototype._camundaCloudModules
);
const pOt = {
  outline: {
    fill: "var(--cds-highlight, #d0e2ff)"
  },
  defaultFillColor: "var(--cds-layer-01, #fff)",
  defaultStrokeColor: "var(--cds-icon-secondary, #525252)",
  element: {
    text: "var(--cds-text-primary, #161616)",
    background: {
      default: "var(--cds-layer-01, #fff)"
    }
  }
};
var v1 = 10;
function Sb(r, e, t) {
  return t || (t = "round"), Math[t](r / e) * e;
}
var gOt = "#ccc", mOt = "djs-grid", c7e = {
  width: 1e5,
  height: 1e5
};
function h2(r, e) {
  this._canvas = r;
  var t = this;
  e.on("diagram.init", function() {
    t._init(), t.toggle(!0);
  }), e.on("gridSnapping.toggle", function(n) {
    var i = n.active;
    t.toggle(i), t._centerGridAroundViewbox();
  }), e.on("canvas.viewbox.changed", function(n) {
    var i = n.viewbox;
    t._centerGridAroundViewbox(i);
  });
}
h2.prototype._init = function() {
  var r = Ps("defs", this._canvas._svg);
  r || (r = md("defs"), Ld(this._canvas._svg, r));
  var e = this._pattern = md("pattern"), t = "djs-grid-pattern-" + AOt();
  kd(e, {
    id: t,
    width: v1,
    height: v1,
    patternUnits: "userSpaceOnUse"
  });
  var n = this._circle = md("circle");
  kd(n, {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fill: gOt
  }), Ld(e, n), Ld(r, e);
  var i = this._gfx = md("rect");
  kd(i, {
    x: -5e4,
    y: -5e4,
    width: c7e.width,
    height: c7e.height,
    fill: `url(#${t})`
  });
};
h2.prototype._centerGridAroundViewbox = function(r) {
  r || (r = this._canvas.viewbox());
  var e = C4(r);
  kd(this._gfx, {
    x: -5e4 + Sb(e.x, v1),
    y: -5e4 + Sb(e.y, v1)
  });
};
h2.prototype.isVisible = function() {
  return this._visible;
};
h2.prototype.toggle = function(r) {
  if (typeof r > "u" && (r = !this._visible), r !== this._visible) {
    var e = this._getParent();
    r ? Ld(e, this._gfx) : WIe(e), this._visible = r;
  }
};
h2.prototype._getParent = function() {
  return this._canvas.getLayer(mOt, -2);
};
h2.$inject = [
  "canvas",
  "eventBus"
];
function AOt() {
  return Math.trunc(Math.random() * 1e6);
}
var UOe = {
  __init__: ["grid"],
  grid: ["type", h2]
};
function wOt(r, e) {
  if (r.ownerDocument !== e.ownerDocument)
    try {
      return e.ownerDocument.importNode(r, !0);
    } catch {
    }
  return r;
}
function vOt(r, e) {
  return e.appendChild(wOt(r, e));
}
function xA(r, e) {
  return vOt(e, r), r;
}
var TN = 2, qOe = {
  "alignment-baseline": 1,
  "baseline-shift": 1,
  clip: 1,
  "clip-path": 1,
  "clip-rule": 1,
  color: 1,
  "color-interpolation": 1,
  "color-interpolation-filters": 1,
  "color-profile": 1,
  "color-rendering": 1,
  cursor: 1,
  direction: 1,
  display: 1,
  "dominant-baseline": 1,
  "enable-background": 1,
  fill: 1,
  "fill-opacity": 1,
  "fill-rule": 1,
  filter: 1,
  "flood-color": 1,
  "flood-opacity": 1,
  font: 1,
  "font-family": 1,
  "font-size": TN,
  "font-size-adjust": 1,
  "font-stretch": 1,
  "font-style": 1,
  "font-variant": 1,
  "font-weight": 1,
  "glyph-orientation-horizontal": 1,
  "glyph-orientation-vertical": 1,
  "image-rendering": 1,
  kerning: 1,
  "letter-spacing": 1,
  "lighting-color": 1,
  marker: 1,
  "marker-end": 1,
  "marker-mid": 1,
  "marker-start": 1,
  mask: 1,
  opacity: 1,
  overflow: 1,
  "pointer-events": 1,
  "shape-rendering": 1,
  "stop-color": 1,
  "stop-opacity": 1,
  stroke: 1,
  "stroke-dasharray": 1,
  "stroke-dashoffset": 1,
  "stroke-linecap": 1,
  "stroke-linejoin": 1,
  "stroke-miterlimit": 1,
  "stroke-opacity": 1,
  "stroke-width": TN,
  "text-anchor": 1,
  "text-decoration": 1,
  "text-rendering": 1,
  "unicode-bidi": 1,
  visibility: 1,
  "word-spacing": 1,
  "writing-mode": 1
};
function bOt(r, e) {
  return qOe[e] ? r.style[e] : r.getAttributeNS(null, e);
}
function yOt(r, e, t) {
  var n = e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = qOe[n];
  i ? (i === TN && typeof t == "number" && (t = String(t) + "px"), r.style[n] = t) : r.setAttributeNS(null, e, t);
}
function COt(r, e) {
  var t = Object.keys(e), n, i;
  for (n = 0, i; i = t[n]; n++)
    yOt(r, i, e[i]);
}
function Lf(r, e, t) {
  return typeof e == "string" ? bOt(r, e) : (COt(r, e), r);
}
const EOt = Object.prototype.toString;
function _Ot(r) {
  return new b1(r);
}
function b1(r) {
  if (!r || !r.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = r, this.list = r.classList;
}
b1.prototype.add = function(r) {
  return this.list.add(r), this;
};
b1.prototype.remove = function(r) {
  return EOt.call(r) == "[object RegExp]" ? this.removeMatching(r) : (this.list.remove(r), this);
};
b1.prototype.removeMatching = function(r) {
  const e = this.array();
  for (let t = 0; t < e.length; t++)
    r.test(e[t]) && this.remove(e[t]);
  return this;
};
b1.prototype.toggle = function(r, e) {
  return typeof e < "u" ? e !== this.list.toggle(r, e) && this.list.toggle(r) : this.list.toggle(r), this;
};
b1.prototype.array = function() {
  return Array.from(this.list);
};
b1.prototype.has = b1.prototype.contains = function(r) {
  return this.list.contains(r);
};
function xOt(r) {
  for (var e; e = r.firstChild; )
    r.removeChild(e);
  return r;
}
function SOt(r) {
  return r.cloneNode(!0);
}
var LV = {
  svg: "http://www.w3.org/2000/svg"
}, h7e = '<svg xmlns="' + LV.svg + '"';
function MOt(r) {
  var e = !1;
  r.substring(0, 4) === "<svg" ? r.indexOf(LV.svg) === -1 && (r = h7e + r.substring(4)) : (r = h7e + ">" + r + "</svg>", e = !0);
  var t = DOt(r);
  if (!e)
    return t;
  for (var n = document.createDocumentFragment(), i = t.firstChild; i.firstChild; )
    n.appendChild(i.firstChild);
  return n;
}
function DOt(r) {
  var e;
  return e = new DOMParser(), e.async = !1, e.parseFromString(r, "text/xml");
}
function SA(r, e) {
  var t;
  return r = r.trim(), r.charAt(0) === "<" ? (t = MOt(r).firstChild, t = document.importNode(t, !0)) : t = document.createElementNS(LV.svg, r), e && Lf(t, e), t;
}
function LOt(r) {
  var e = r.parentNode;
  return e && e.removeChild(r), r;
}
var _5 = 50, kOt = new yV(), d7e = { min: 0.2, max: 4 }, NOt = 10, TOt = 0.1, IOt = 250;
function qs(r, e, t, n, i) {
  var s = this;
  this._canvas = n, this._elementRegistry = i, this._eventBus = t, this._injector = e, this._state = {
    isOpen: void 0,
    isDragging: !1,
    initialDragPosition: null,
    offsetViewport: null,
    cachedViewbox: null,
    dragger: null,
    svgClientRect: null,
    parentClientRect: null,
    zoomDelta: 0
  }, this._minimapId = kOt.next(), this._init(), this.toggle(r && r.open || !1);
  function o(d) {
    (!s._state._svgClientRect || S5(s._state._svgClientRect)) && (s._state._svgClientRect = s._svg.getBoundingClientRect());
    var u = x5({
      x: d.x - s._state._svgClientRect.left,
      y: d.y - s._state._svgClientRect.top
    }, s._svg, s._lastViewbox);
    z_(u, s._canvas), s._update();
  }
  function a(d) {
    return function(f) {
      var p = W_(f);
      (!s._state._svgClientRect || S5(s._state._svgClientRect)) && (s._state._svgClientRect = s._svg.getBoundingClientRect()), d && o(p);
      var g = x5({
        x: p.x - s._state._svgClientRect.left,
        y: p.y - s._state._svgClientRect.top
      }, s._svg, s._lastViewbox), m = n.viewbox(), A = ROt(g, m), w = s._viewportDom.getBoundingClientRect(), v = {
        x: p.x - w.left + 1,
        y: p.y - w.top + 1
      };
      Ft(s._state, {
        cachedViewbox: m,
        initialDragPosition: {
          x: p.x,
          y: p.y
        },
        isDragging: !0,
        offsetViewport: A,
        offsetViewportDom: v,
        viewportClientRect: s._viewport.getBoundingClientRect(),
        parentClientRect: s._parent.getBoundingClientRect()
      }), fr.bind(document, "mousemove", l), fr.bind(document, "mouseup", c);
    };
  }
  function l(d) {
    var u = W_(d);
    if (s._state.isDragging) {
      (!s._state._svgClientRect || S5(s._state._svgClientRect)) && (s._state._svgClientRect = s._svg.getBoundingClientRect());
      var f = s._state.offsetViewportDom, p = s._state.viewportClientRect, g = s._state.parentClientRect;
      Ft(s._viewportDom.style, {
        top: u.y - f.y - g.top + "px",
        left: u.x - f.x - g.left + "px"
      });
      var m = GOe(g, {
        top: u.y - f.y - g.top,
        left: u.x - f.x - g.left,
        width: p.width,
        height: p.height
      });
      Ft(s._overlay.style, {
        clipPath: m
      });
      var A = x5({
        x: u.x - s._state._svgClientRect.left,
        y: u.y - s._state._svgClientRect.top
      }, s._svg, s._lastViewbox);
      z_({
        x: A.x - s._state.offsetViewport.x,
        y: A.y - s._state.offsetViewport.y
      }, s._canvas);
    }
  }
  function c(d) {
    var u = W_(d);
    s._state.isDragging && (s._state.initialDragPosition.x === u.x && s._state.initialDragPosition.y === u.y && o(d), s._update(), Ft(s._state, {
      cachedViewbox: null,
      initialDragPosition: null,
      isDragging: !1,
      offsetViewport: null,
      offsetViewportDom: null
    }), fr.unbind(document, "mousemove", l), fr.unbind(document, "mouseup", c));
  }
  fr.bind(this._viewportDom, "mousedown", a(!1)), fr.bind(this._svg, "mousedown", a(!0)), fr.bind(this._parent, "wheel", function(d) {
    if (d.preventDefault(), d.stopPropagation(), !!d.ctrlKey && ((!s._state._svgClientRect || S5(s._state._svgClientRect)) && (s._state._svgClientRect = s._svg.getBoundingClientRect()), !!POt(d, s._state._svgClientRect))) {
      var u = d.deltaMode === 0 ? 0.02 : 0.32, f = Math.sqrt(
        Math.pow(d.deltaY, 2) + Math.pow(d.deltaX, 2)
      ) * FOt(d.deltaY) * -u;
      if (s._state.zoomDelta += f, Math.abs(s._state.zoomDelta) > TOt) {
        var p = f > 0 ? 1 : -1, g = Math.log(n.zoom()) / Math.log(10), m = zOt(d7e, NOt * 2), A = Math.round(g / m) * m;
        A += m * p;
        var w = Math.pow(10, A);
        n.zoom(WOt(d7e, w), v), s._state.zoomDelta = 0;
        var v = x5({
          x: d.clientX - s._state._svgClientRect.left,
          y: d.clientY - s._state._svgClientRect.top
        }, s._svg, s._lastViewbox);
        z_(v, s._canvas), s._update();
      }
    }
  }), fr.bind(this._toggle, "click", function(d) {
    d.preventDefault(), d.stopPropagation(), s.toggle();
  }), t.on(["shape.added", "connection.added"], function(d) {
    var u = d.element;
    s._addElement(u), s._update();
  }), t.on(["shape.removed", "connection.removed"], function(d) {
    var u = d.element;
    s._removeElement(u), s._update();
  }), t.on("elements.changed", IOt, function(d) {
    var u = d.elements;
    u.forEach(function(f) {
      s._updateElement(f);
    }), s._update();
  }), t.on("element.updateId", function(d) {
    var u = d.element, f = d.newId;
    s._updateElementId(u, f);
  }), t.on("canvas.viewbox.changed", function() {
    s._state.isDragging || s._update();
  }), t.on("canvas.resized", function() {
    document.body.contains(s._parent) && (s._state.isDragging || s._update(), s._state._svgClientRect = s._svg.getBoundingClientRect());
  }), t.on(["root.set", "plane.set"], function(d) {
    s._clear();
    var u = d.element || d.plane.rootElement;
    u.children.forEach(function(f) {
      s._addElement(f);
    }), s._update();
  });
}
qs.$inject = [
  "config.minimap",
  "injector",
  "eventBus",
  "canvas",
  "elementRegistry"
];
qs.prototype._init = function() {
  var r = this._canvas, e = r.getContainer(), t = this._parent = document.createElement("div");
  Ja(t).add("djs-minimap"), e.appendChild(t);
  var n = this._toggle = document.createElement("div");
  Ja(n).add("toggle"), t.appendChild(n);
  var i = this._map = document.createElement("div");
  Ja(i).add("map"), t.appendChild(i);
  var s = this._svg = SA("svg");
  Lf(s, { width: "100%", height: "100%" }), xA(i, s);
  var o = this._elementsGroup = SA("g");
  xA(s, o);
  var a = this._viewportGroup = SA("g");
  xA(s, a);
  var l = this._viewport = SA("rect");
  _Ot(l).add("viewport"), xA(a, l), fr.bind(t, "mousedown", function(u) {
    u.stopPropagation();
  });
  var c = this._viewportDom = document.createElement("div");
  Ja(c).add("viewport-dom"), this._parent.appendChild(c);
  var d = this._overlay = document.createElement("div");
  Ja(d).add("overlay"), this._parent.appendChild(d);
};
qs.prototype._update = function() {
  var r = this._canvas.viewbox(), e = r.inner, t = r.outer;
  if (QOe(r)) {
    var n, i, s, o, a = t.width - e.width, l = t.height - e.height;
    e.width < t.width ? (n = e.x - a / 2, s = t.width, e.x + e.width < t.width && (n = Math.min(0, e.x))) : (n = e.x, s = e.width), e.height < t.height ? (i = e.y - l / 2, o = t.height, e.y + e.height < t.height && (i = Math.min(0, e.y))) : (i = e.y, o = e.height), n = n - _5, i = i - _5, s = s + _5 * 2, o = o + _5 * 2, this._lastViewbox = {
      x: n,
      y: i,
      width: s,
      height: o
    }, Lf(this._svg, {
      viewBox: n + ", " + i + ", " + s + ", " + o
    }), Lf(this._viewport, {
      x: r.x,
      y: r.y,
      width: r.width,
      height: r.height
    });
    var c = this._state._parentClientRect = this._parent.getBoundingClientRect(), d = this._viewport.getBoundingClientRect(), u = {
      top: d.top - c.top,
      left: d.left - c.left,
      width: d.width,
      height: d.height
    };
    Ft(this._viewportDom.style, {
      top: u.top + "px",
      left: u.left + "px",
      width: u.width + "px",
      height: u.height + "px"
    });
    var f = GOe(c, u);
    Ft(this._overlay.style, {
      clipPath: f
    });
  }
};
qs.prototype.open = function() {
  Ft(this._state, { isOpen: !0 }), Ja(this._parent).add("open");
  var r = this._injector.get("translate", !1) || function(e) {
    return e;
  };
  qy(this._toggle, "title", r("Close minimap")), this._update(), this._eventBus.fire("minimap.toggle", { open: !0 });
};
qs.prototype.close = function() {
  Ft(this._state, { isOpen: !1 }), Ja(this._parent).remove("open");
  var r = this._injector.get("translate", !1) || function(e) {
    return e;
  };
  qy(this._toggle, "title", r("Open minimap")), this._eventBus.fire("minimap.toggle", { open: !1 });
};
qs.prototype.toggle = function(r) {
  var e = this.isOpen();
  typeof r > "u" && (r = !e), r != e && (r ? this.open() : this.close());
};
qs.prototype.isOpen = function() {
  return this._state.isOpen;
};
qs.prototype._updateElement = function(r) {
  try {
    r.parent !== void 0 && r.parent !== null && (this._removeElement(r), this._addElement(r));
  } catch (e) {
    console.warn("Minimap#_updateElement errored", e);
  }
};
qs.prototype._updateElementId = function(r, e) {
  try {
    var t = Ps("#" + dOe(this._prefixId(r.id)), this._elementsGroup);
    t && (t.id = this._prefixId(e));
  } catch (n) {
    console.warn("Minimap#_updateElementId errored", n);
  }
};
qs.prototype.isOnActivePlane = function(r) {
  var e = this._canvas;
  return e.findRoot ? e.findRoot(r) === e.getRootElement() : e.findPlane ? e.findPlane(r) === e.getActivePlane() : !0;
};
qs.prototype._addElement = function(r) {
  var e = this;
  if (this._removeElement(r), !!this.isOnActivePlane(r)) {
    var t, n, i, s = this._createElement(r), o = Ps("#" + dOe(this._prefixId(r.parent.id)), this._elementsGroup);
    if (s) {
      var a = this._elementRegistry.getGraphics(r), l = this._elementRegistry.getGraphics(r.parent), c = HOt(a, l);
      return c !== "undefined" ? o ? o.childNodes.length > c ? f7e(s, o, c) : f7e(s, o, o.childNodes.length - 1) : this._elementsGroup.appendChild(s) : this._elementsGroup.appendChild(s), OOt(r) ? (t = r.parent, n = 0, i = 0, typeof t.x < "u" && typeof t.y < "u" && (n = -t.x, i = -t.y), Lf(s, { transform: "translate(" + n + " " + i + ")" })) : (n = r.x, i = r.y, o && (t = r.parent, n -= t.x, i -= t.y), Lf(s, { transform: "translate(" + n + " " + i + ")" })), r.children && r.children.length && r.children.forEach(function(d) {
        e._addElement(d);
      }), s;
    }
  }
};
qs.prototype._removeElement = function(r) {
  var e = this._svg.getElementById(this._prefixId(r.id));
  e && LOt(e);
};
qs.prototype._createElement = function(r) {
  var e = this._elementRegistry.getGraphics(r), t;
  if (e && (t = TOe(e), t)) {
    var n = jOt(SOt(t));
    return Lf(n, { id: this._prefixId(r.id) }), n;
  }
};
qs.prototype._clear = function() {
  xOt(this._elementsGroup);
};
qs.prototype._prefixId = function(r) {
  return "djs-minimap-" + r + "-" + this._minimapId;
};
function OOt(r) {
  return r.waypoints;
}
function ROt(r, e) {
  var t = {
    x: e.x + e.width / 2,
    y: e.y + e.height / 2
  };
  return {
    x: r.x - t.x,
    y: r.y - t.y
  };
}
function x5(r, e, t) {
  var n = e.getBoundingClientRect(), i = VOt(t, n.width / n.height), s = u7e(r.x, 0, n.width, i.x, i.x + i.width), o = u7e(r.y, 0, n.height, i.y, i.y + i.height);
  return {
    x: s,
    y: o
  };
}
function z_(r, e) {
  var t = e.viewbox(), n = t.width, i = t.height;
  e.viewbox({
    x: r.x - n / 2,
    y: r.y - i / 2,
    width: n,
    height: i
  });
}
function VOt(r, e) {
  var t = r.width / r.height, n = Ft({}, {
    x: r.x,
    y: r.y,
    width: r.width,
    height: r.height
  });
  if (t > e) {
    var i = n.width * (1 / e), s = n.y - (i - n.height) / 2;
    Ft(n, {
      y: s,
      height: i
    });
  } else if (t < e) {
    var o = n.height * e, a = n.x - (o - n.width) / 2;
    Ft(n, {
      x: a,
      width: o
    });
  }
  return n;
}
function u7e(r, e, t, n, i) {
  var s = t - e, o = i - n;
  return (r - e) * o / s + n;
}
function HOt(r, e) {
  var t = Ps(".djs-children", e.parentNode);
  if (t) {
    var n = [].slice.call(t.childNodes), i = -1;
    return n.forEach(function(s, o) {
      Ps(".djs-element", s) === r && (i = o);
    }), i;
  }
}
function f7e(r, e, t) {
  var n = BOt(e), i = [].slice.call(n.childNodes), s = i[t];
  s ? e.insertBefore(r, s.nextSibling) : e.appendChild(r);
}
function BOt(r) {
  var e = Ps(".children", r);
  return e || (e = SA("g", { class: "children" }), xA(r, e)), e;
}
function S5(r) {
  return r.width === 0 && r.height === 0;
}
function POt(r, e) {
  return r.x > e.left && r.x < e.left + e.width && r.y > e.top && r.y < e.top + e.height;
}
var FOt = Math.sign || function(r) {
  return r >= 0 ? 1 : -1;
};
function zOt(r, e) {
  var t = Math.log(r.min) / Math.log(10), n = Math.log(r.max) / Math.log(10), i = Math.abs(t) + Math.abs(n);
  return i / e;
}
function WOt(r, e) {
  return Math.max(r.min, Math.min(r.max, e));
}
function GOe(r, e) {
  var t = [
    Nc(e.left, e.top),
    Nc(e.left + e.width, e.top),
    Nc(e.left + e.width, e.top + e.height),
    Nc(e.left, e.top + e.height),
    Nc(e.left, r.height),
    Nc(r.width, r.height),
    Nc(r.width, 0),
    Nc(0, 0),
    Nc(0, r.height),
    Nc(e.left, r.height)
  ].join(", ");
  return "polygon(" + t + ")";
}
function Nc(r, e) {
  return r + "px " + e + "px";
}
function QOe(r) {
  return sI(r, function(e) {
    return Od(e) ? QOe(e) : ec(e) && isFinite(e);
  });
}
function W_(r) {
  return r.center ? r.center : {
    x: r.clientX,
    y: r.clientY
  };
}
function jOt(r) {
  return JIe("[id]", r).forEach(function(e) {
    e.remove();
  }), r;
}
var KOe = {
  __init__: ["minimap"],
  minimap: ["type", qs]
}, j_, p7e;
function ZOt() {
  if (p7e) return j_;
  p7e = 1;
  function r() {
    this.__data__ = [], this.size = 0;
  }
  return j_ = r, j_;
}
var Z_, g7e;
function YOe() {
  if (g7e) return Z_;
  g7e = 1;
  function r(e, t) {
    return e === t || e !== e && t !== t;
  }
  return Z_ = r, Z_;
}
var U_, m7e;
function Xy() {
  if (m7e) return U_;
  m7e = 1;
  var r = YOe();
  function e(t, n) {
    for (var i = t.length; i--; )
      if (r(t[i][0], n))
        return i;
    return -1;
  }
  return U_ = e, U_;
}
var q_, A7e;
function UOt() {
  if (A7e) return q_;
  A7e = 1;
  var r = Xy(), e = Array.prototype, t = e.splice;
  function n(i) {
    var s = this.__data__, o = r(s, i);
    if (o < 0)
      return !1;
    var a = s.length - 1;
    return o == a ? s.pop() : t.call(s, o, 1), --this.size, !0;
  }
  return q_ = n, q_;
}
var G_, w7e;
function qOt() {
  if (w7e) return G_;
  w7e = 1;
  var r = Xy();
  function e(t) {
    var n = this.__data__, i = r(n, t);
    return i < 0 ? void 0 : n[i][1];
  }
  return G_ = e, G_;
}
var Q_, v7e;
function GOt() {
  if (v7e) return Q_;
  v7e = 1;
  var r = Xy();
  function e(t) {
    return r(this.__data__, t) > -1;
  }
  return Q_ = e, Q_;
}
var K_, b7e;
function QOt() {
  if (b7e) return K_;
  b7e = 1;
  var r = Xy();
  function e(t, n) {
    var i = this.__data__, s = r(i, t);
    return s < 0 ? (++this.size, i.push([t, n])) : i[s][1] = n, this;
  }
  return K_ = e, K_;
}
var Y_, y7e;
function Jy() {
  if (y7e) return Y_;
  y7e = 1;
  var r = ZOt(), e = UOt(), t = qOt(), n = GOt(), i = QOt();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = n, s.prototype.set = i, Y_ = s, Y_;
}
var X_, C7e;
function KOt() {
  if (C7e) return X_;
  C7e = 1;
  var r = Jy();
  function e() {
    this.__data__ = new r(), this.size = 0;
  }
  return X_ = e, X_;
}
var J_, E7e;
function YOt() {
  if (E7e) return J_;
  E7e = 1;
  function r(e) {
    var t = this.__data__, n = t.delete(e);
    return this.size = t.size, n;
  }
  return J_ = r, J_;
}
var $_, _7e;
function XOt() {
  if (_7e) return $_;
  _7e = 1;
  function r(e) {
    return this.__data__.get(e);
  }
  return $_ = r, $_;
}
var ex, x7e;
function JOt() {
  if (x7e) return ex;
  x7e = 1;
  function r(e) {
    return this.__data__.has(e);
  }
  return ex = r, ex;
}
var tx, S7e;
function XOe() {
  if (S7e) return tx;
  S7e = 1;
  var r = cw(), e = v7(), t = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", s = "[object Proxy]";
  function o(a) {
    if (!e(a))
      return !1;
    var l = r(a);
    return l == n || l == i || l == t || l == s;
  }
  return tx = o, tx;
}
var nx, M7e;
function $Ot() {
  if (M7e) return nx;
  M7e = 1;
  var r = Ch(), e = r["__core-js_shared__"];
  return nx = e, nx;
}
var ix, D7e;
function eRt() {
  if (D7e) return ix;
  D7e = 1;
  var r = $Ot(), e = function() {
    var n = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function t(n) {
    return !!e && e in n;
  }
  return ix = t, ix;
}
var rx, L7e;
function JOe() {
  if (L7e) return rx;
  L7e = 1;
  var r = Function.prototype, e = r.toString;
  function t(n) {
    if (n != null) {
      try {
        return e.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return rx = t, rx;
}
var sx, k7e;
function tRt() {
  if (k7e) return sx;
  k7e = 1;
  var r = XOe(), e = eRt(), t = v7(), n = JOe(), i = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, o = Function.prototype, a = Object.prototype, l = o.toString, c = a.hasOwnProperty, d = RegExp(
    "^" + l.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function u(f) {
    if (!t(f) || e(f))
      return !1;
    var p = r(f) ? d : s;
    return p.test(n(f));
  }
  return sx = u, sx;
}
var ox, N7e;
function nRt() {
  if (N7e) return ox;
  N7e = 1;
  function r(e, t) {
    return e?.[t];
  }
  return ox = r, ox;
}
var ax, T7e;
function gm() {
  if (T7e) return ax;
  T7e = 1;
  var r = tRt(), e = nRt();
  function t(n, i) {
    var s = e(n, i);
    return r(s) ? s : void 0;
  }
  return ax = t, ax;
}
var lx, I7e;
function kV() {
  if (I7e) return lx;
  I7e = 1;
  var r = gm(), e = Ch(), t = r(e, "Map");
  return lx = t, lx;
}
var cx, O7e;
function $y() {
  if (O7e) return cx;
  O7e = 1;
  var r = gm(), e = r(Object, "create");
  return cx = e, cx;
}
var hx, R7e;
function iRt() {
  if (R7e) return hx;
  R7e = 1;
  var r = $y();
  function e() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  return hx = e, hx;
}
var dx, V7e;
function rRt() {
  if (V7e) return dx;
  V7e = 1;
  function r(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return dx = r, dx;
}
var ux, H7e;
function sRt() {
  if (H7e) return ux;
  H7e = 1;
  var r = $y(), e = "__lodash_hash_undefined__", t = Object.prototype, n = t.hasOwnProperty;
  function i(s) {
    var o = this.__data__;
    if (r) {
      var a = o[s];
      return a === e ? void 0 : a;
    }
    return n.call(o, s) ? o[s] : void 0;
  }
  return ux = i, ux;
}
var fx, B7e;
function oRt() {
  if (B7e) return fx;
  B7e = 1;
  var r = $y(), e = Object.prototype, t = e.hasOwnProperty;
  function n(i) {
    var s = this.__data__;
    return r ? s[i] !== void 0 : t.call(s, i);
  }
  return fx = n, fx;
}
var px, P7e;
function aRt() {
  if (P7e) return px;
  P7e = 1;
  var r = $y(), e = "__lodash_hash_undefined__";
  function t(n, i) {
    var s = this.__data__;
    return this.size += this.has(n) ? 0 : 1, s[n] = r && i === void 0 ? e : i, this;
  }
  return px = t, px;
}
var gx, F7e;
function lRt() {
  if (F7e) return gx;
  F7e = 1;
  var r = iRt(), e = rRt(), t = sRt(), n = oRt(), i = aRt();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = n, s.prototype.set = i, gx = s, gx;
}
var mx, z7e;
function cRt() {
  if (z7e) return mx;
  z7e = 1;
  var r = lRt(), e = Jy(), t = kV();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new r(),
      map: new (t || e)(),
      string: new r()
    };
  }
  return mx = n, mx;
}
var Ax, W7e;
function hRt() {
  if (W7e) return Ax;
  W7e = 1;
  function r(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return Ax = r, Ax;
}
var wx, j7e;
function eC() {
  if (j7e) return wx;
  j7e = 1;
  var r = hRt();
  function e(t, n) {
    var i = t.__data__;
    return r(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return wx = e, wx;
}
var vx, Z7e;
function dRt() {
  if (Z7e) return vx;
  Z7e = 1;
  var r = eC();
  function e(t) {
    var n = r(this, t).delete(t);
    return this.size -= n ? 1 : 0, n;
  }
  return vx = e, vx;
}
var bx, U7e;
function uRt() {
  if (U7e) return bx;
  U7e = 1;
  var r = eC();
  function e(t) {
    return r(this, t).get(t);
  }
  return bx = e, bx;
}
var yx, q7e;
function fRt() {
  if (q7e) return yx;
  q7e = 1;
  var r = eC();
  function e(t) {
    return r(this, t).has(t);
  }
  return yx = e, yx;
}
var Cx, G7e;
function pRt() {
  if (G7e) return Cx;
  G7e = 1;
  var r = eC();
  function e(t, n) {
    var i = r(this, t), s = i.size;
    return i.set(t, n), this.size += i.size == s ? 0 : 1, this;
  }
  return Cx = e, Cx;
}
var Ex, Q7e;
function $Oe() {
  if (Q7e) return Ex;
  Q7e = 1;
  var r = cRt(), e = dRt(), t = uRt(), n = fRt(), i = pRt();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = r, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = n, s.prototype.set = i, Ex = s, Ex;
}
var _x, K7e;
function gRt() {
  if (K7e) return _x;
  K7e = 1;
  var r = Jy(), e = kV(), t = $Oe(), n = 200;
  function i(s, o) {
    var a = this.__data__;
    if (a instanceof r) {
      var l = a.__data__;
      if (!e || l.length < n - 1)
        return l.push([s, o]), this.size = ++a.size, this;
      a = this.__data__ = new t(l);
    }
    return a.set(s, o), this.size = a.size, this;
  }
  return _x = i, _x;
}
var xx, Y7e;
function mRt() {
  if (Y7e) return xx;
  Y7e = 1;
  var r = Jy(), e = KOt(), t = YOt(), n = XOt(), i = JOt(), s = gRt();
  function o(a) {
    var l = this.__data__ = new r(a);
    this.size = l.size;
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = n, o.prototype.has = i, o.prototype.set = s, xx = o, xx;
}
var Sx, X7e;
function ARt() {
  if (X7e) return Sx;
  X7e = 1;
  var r = "__lodash_hash_undefined__";
  function e(t) {
    return this.__data__.set(t, r), this;
  }
  return Sx = e, Sx;
}
var Mx, J7e;
function wRt() {
  if (J7e) return Mx;
  J7e = 1;
  function r(e) {
    return this.__data__.has(e);
  }
  return Mx = r, Mx;
}
var Dx, $7e;
function vRt() {
  if ($7e) return Dx;
  $7e = 1;
  var r = $Oe(), e = ARt(), t = wRt();
  function n(i) {
    var s = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new r(); ++s < o; )
      this.add(i[s]);
  }
  return n.prototype.add = n.prototype.push = e, n.prototype.has = t, Dx = n, Dx;
}
var Lx, eye;
function bRt() {
  if (eye) return Lx;
  eye = 1;
  function r(e, t) {
    for (var n = -1, i = e == null ? 0 : e.length; ++n < i; )
      if (t(e[n], n, e))
        return !0;
    return !1;
  }
  return Lx = r, Lx;
}
var kx, tye;
function yRt() {
  if (tye) return kx;
  tye = 1;
  function r(e, t) {
    return e.has(t);
  }
  return kx = r, kx;
}
var Nx, nye;
function eRe() {
  if (nye) return Nx;
  nye = 1;
  var r = vRt(), e = bRt(), t = yRt(), n = 1, i = 2;
  function s(o, a, l, c, d, u) {
    var f = l & n, p = o.length, g = a.length;
    if (p != g && !(f && g > p))
      return !1;
    var m = u.get(o), A = u.get(a);
    if (m && A)
      return m == a && A == o;
    var w = -1, v = !0, y = l & i ? new r() : void 0;
    for (u.set(o, a), u.set(a, o); ++w < p; ) {
      var _ = o[w], S = a[w];
      if (c)
        var D = f ? c(S, _, w, a, o, u) : c(_, S, w, o, a, u);
      if (D !== void 0) {
        if (D)
          continue;
        v = !1;
        break;
      }
      if (y) {
        if (!e(a, function(M, L) {
          if (!t(y, L) && (_ === M || d(_, M, l, c, u)))
            return y.push(L);
        })) {
          v = !1;
          break;
        }
      } else if (!(_ === S || d(_, S, l, c, u))) {
        v = !1;
        break;
      }
    }
    return u.delete(o), u.delete(a), v;
  }
  return Nx = s, Nx;
}
var Tx, iye;
function CRt() {
  if (iye) return Tx;
  iye = 1;
  var r = Ch(), e = r.Uint8Array;
  return Tx = e, Tx;
}
var Ix, rye;
function ERt() {
  if (rye) return Ix;
  rye = 1;
  function r(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(i, s) {
      n[++t] = [s, i];
    }), n;
  }
  return Ix = r, Ix;
}
var Ox, sye;
function _Rt() {
  if (sye) return Ox;
  sye = 1;
  function r(e) {
    var t = -1, n = Array(e.size);
    return e.forEach(function(i) {
      n[++t] = i;
    }), n;
  }
  return Ox = r, Ox;
}
var Rx, oye;
function xRt() {
  if (oye) return Rx;
  oye = 1;
  var r = rI(), e = CRt(), t = YOe(), n = eRe(), i = ERt(), s = _Rt(), o = 1, a = 2, l = "[object Boolean]", c = "[object Date]", d = "[object Error]", u = "[object Map]", f = "[object Number]", p = "[object RegExp]", g = "[object Set]", m = "[object String]", A = "[object Symbol]", w = "[object ArrayBuffer]", v = "[object DataView]", y = r ? r.prototype : void 0, _ = y ? y.valueOf : void 0;
  function S(D, M, L, T, B, V, N) {
    switch (L) {
      case v:
        if (D.byteLength != M.byteLength || D.byteOffset != M.byteOffset)
          return !1;
        D = D.buffer, M = M.buffer;
      case w:
        return !(D.byteLength != M.byteLength || !V(new e(D), new e(M)));
      case l:
      case c:
      case f:
        return t(+D, +M);
      case d:
        return D.name == M.name && D.message == M.message;
      case p:
      case m:
        return D == M + "";
      case u:
        var R = i;
      case g:
        var H = T & o;
        if (R || (R = s), D.size != M.size && !H)
          return !1;
        var z = N.get(D);
        if (z)
          return z == M;
        T |= a, N.set(D, M);
        var U = n(R(D), R(M), T, B, V, N);
        return N.delete(D), U;
      case A:
        if (_)
          return _.call(D) == _.call(M);
    }
    return !1;
  }
  return Rx = S, Rx;
}
var Vx, aye;
function SRt() {
  if (aye) return Vx;
  aye = 1;
  function r(e, t) {
    for (var n = -1, i = t.length, s = e.length; ++n < i; )
      e[s + n] = t[n];
    return e;
  }
  return Vx = r, Vx;
}
var Hx, lye;
function NV() {
  if (lye) return Hx;
  lye = 1;
  var r = Array.isArray;
  return Hx = r, Hx;
}
var Bx, cye;
function MRt() {
  if (cye) return Bx;
  cye = 1;
  var r = SRt(), e = NV();
  function t(n, i, s) {
    var o = i(n);
    return e(n) ? o : r(o, s(n));
  }
  return Bx = t, Bx;
}
var Px, hye;
function DRt() {
  if (hye) return Px;
  hye = 1;
  function r(e, t) {
    for (var n = -1, i = e == null ? 0 : e.length, s = 0, o = []; ++n < i; ) {
      var a = e[n];
      t(a, n, e) && (o[s++] = a);
    }
    return o;
  }
  return Px = r, Px;
}
var Fx, dye;
function LRt() {
  if (dye) return Fx;
  dye = 1;
  function r() {
    return [];
  }
  return Fx = r, Fx;
}
var zx, uye;
function kRt() {
  if (uye) return zx;
  uye = 1;
  var r = DRt(), e = LRt(), t = Object.prototype, n = t.propertyIsEnumerable, i = Object.getOwnPropertySymbols, s = i ? function(o) {
    return o == null ? [] : (o = Object(o), r(i(o), function(a) {
      return n.call(o, a);
    }));
  } : e;
  return zx = s, zx;
}
var Wx, fye;
function NRt() {
  if (fye) return Wx;
  fye = 1;
  function r(e, t) {
    for (var n = -1, i = Array(e); ++n < e; )
      i[n] = t(n);
    return i;
  }
  return Wx = r, Wx;
}
var jx, pye;
function TRt() {
  if (pye) return jx;
  pye = 1;
  var r = cw(), e = hw(), t = "[object Arguments]";
  function n(i) {
    return e(i) && r(i) == t;
  }
  return jx = n, jx;
}
var Zx, gye;
function IRt() {
  if (gye) return Zx;
  gye = 1;
  var r = TRt(), e = hw(), t = Object.prototype, n = t.hasOwnProperty, i = t.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(o) {
    return e(o) && n.call(o, "callee") && !i.call(o, "callee");
  };
  return Zx = s, Zx;
}
var MA = { exports: {} }, Ux, mye;
function ORt() {
  if (mye) return Ux;
  mye = 1;
  function r() {
    return !1;
  }
  return Ux = r, Ux;
}
MA.exports;
var Aye;
function tRe() {
  return Aye || (Aye = 1, function(r, e) {
    var t = Ch(), n = ORt(), i = e && !e.nodeType && e, s = i && !0 && r && !r.nodeType && r, o = s && s.exports === i, a = o ? t.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || n;
    r.exports = c;
  }(MA, MA.exports)), MA.exports;
}
var qx, wye;
function RRt() {
  if (wye) return qx;
  wye = 1;
  var r = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function t(n, i) {
    var s = typeof n;
    return i = i ?? r, !!i && (s == "number" || s != "symbol" && e.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return qx = t, qx;
}
var Gx, vye;
function nRe() {
  if (vye) return Gx;
  vye = 1;
  var r = 9007199254740991;
  function e(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= r;
  }
  return Gx = e, Gx;
}
var Qx, bye;
function VRt() {
  if (bye) return Qx;
  bye = 1;
  var r = cw(), e = nRe(), t = hw(), n = "[object Arguments]", i = "[object Array]", s = "[object Boolean]", o = "[object Date]", a = "[object Error]", l = "[object Function]", c = "[object Map]", d = "[object Number]", u = "[object Object]", f = "[object RegExp]", p = "[object Set]", g = "[object String]", m = "[object WeakMap]", A = "[object ArrayBuffer]", w = "[object DataView]", v = "[object Float32Array]", y = "[object Float64Array]", _ = "[object Int8Array]", S = "[object Int16Array]", D = "[object Int32Array]", M = "[object Uint8Array]", L = "[object Uint8ClampedArray]", T = "[object Uint16Array]", B = "[object Uint32Array]", V = {};
  V[v] = V[y] = V[_] = V[S] = V[D] = V[M] = V[L] = V[T] = V[B] = !0, V[n] = V[i] = V[A] = V[s] = V[w] = V[o] = V[a] = V[l] = V[c] = V[d] = V[u] = V[f] = V[p] = V[g] = V[m] = !1;
  function N(R) {
    return t(R) && e(R.length) && !!V[r(R)];
  }
  return Qx = N, Qx;
}
var Kx, yye;
function HRt() {
  if (yye) return Kx;
  yye = 1;
  function r(e) {
    return function(t) {
      return e(t);
    };
  }
  return Kx = r, Kx;
}
var DA = { exports: {} };
DA.exports;
var Cye;
function BRt() {
  return Cye || (Cye = 1, function(r, e) {
    var t = KSe(), n = e && !e.nodeType && e, i = n && !0 && r && !r.nodeType && r, s = i && i.exports === n, o = s && t.process, a = function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    r.exports = a;
  }(DA, DA.exports)), DA.exports;
}
var Yx, Eye;
function iRe() {
  if (Eye) return Yx;
  Eye = 1;
  var r = VRt(), e = HRt(), t = BRt(), n = t && t.isTypedArray, i = n ? e(n) : r;
  return Yx = i, Yx;
}
var Xx, _ye;
function PRt() {
  if (_ye) return Xx;
  _ye = 1;
  var r = NRt(), e = IRt(), t = NV(), n = tRe(), i = RRt(), s = iRe(), o = Object.prototype, a = o.hasOwnProperty;
  function l(c, d) {
    var u = t(c), f = !u && e(c), p = !u && !f && n(c), g = !u && !f && !p && s(c), m = u || f || p || g, A = m ? r(c.length, String) : [], w = A.length;
    for (var v in c)
      (d || a.call(c, v)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
      i(v, w))) && A.push(v);
    return A;
  }
  return Xx = l, Xx;
}
var Jx, xye;
function FRt() {
  if (xye) return Jx;
  xye = 1;
  var r = Object.prototype;
  function e(t) {
    var n = t && t.constructor, i = typeof n == "function" && n.prototype || r;
    return t === i;
  }
  return Jx = e, Jx;
}
var $x, Sye;
function zRt() {
  if (Sye) return $x;
  Sye = 1;
  function r(e, t) {
    return function(n) {
      return e(t(n));
    };
  }
  return $x = r, $x;
}
var eS, Mye;
function WRt() {
  if (Mye) return eS;
  Mye = 1;
  var r = zRt(), e = r(Object.keys, Object);
  return eS = e, eS;
}
var tS, Dye;
function jRt() {
  if (Dye) return tS;
  Dye = 1;
  var r = FRt(), e = WRt(), t = Object.prototype, n = t.hasOwnProperty;
  function i(s) {
    if (!r(s))
      return e(s);
    var o = [];
    for (var a in Object(s))
      n.call(s, a) && a != "constructor" && o.push(a);
    return o;
  }
  return tS = i, tS;
}
var nS, Lye;
function ZRt() {
  if (Lye) return nS;
  Lye = 1;
  var r = XOe(), e = nRe();
  function t(n) {
    return n != null && e(n.length) && !r(n);
  }
  return nS = t, nS;
}
var iS, kye;
function URt() {
  if (kye) return iS;
  kye = 1;
  var r = PRt(), e = jRt(), t = ZRt();
  function n(i) {
    return t(i) ? r(i) : e(i);
  }
  return iS = n, iS;
}
var rS, Nye;
function qRt() {
  if (Nye) return rS;
  Nye = 1;
  var r = MRt(), e = kRt(), t = URt();
  function n(i) {
    return r(i, t, e);
  }
  return rS = n, rS;
}
var sS, Tye;
function GRt() {
  if (Tye) return sS;
  Tye = 1;
  var r = qRt(), e = 1, t = Object.prototype, n = t.hasOwnProperty;
  function i(s, o, a, l, c, d) {
    var u = a & e, f = r(s), p = f.length, g = r(o), m = g.length;
    if (p != m && !u)
      return !1;
    for (var A = p; A--; ) {
      var w = f[A];
      if (!(u ? w in o : n.call(o, w)))
        return !1;
    }
    var v = d.get(s), y = d.get(o);
    if (v && y)
      return v == o && y == s;
    var _ = !0;
    d.set(s, o), d.set(o, s);
    for (var S = u; ++A < p; ) {
      w = f[A];
      var D = s[w], M = o[w];
      if (l)
        var L = u ? l(M, D, w, o, s, d) : l(D, M, w, s, o, d);
      if (!(L === void 0 ? D === M || c(D, M, a, l, d) : L)) {
        _ = !1;
        break;
      }
      S || (S = w == "constructor");
    }
    if (_ && !S) {
      var T = s.constructor, B = o.constructor;
      T != B && "constructor" in s && "constructor" in o && !(typeof T == "function" && T instanceof T && typeof B == "function" && B instanceof B) && (_ = !1);
    }
    return d.delete(s), d.delete(o), _;
  }
  return sS = i, sS;
}
var oS, Iye;
function QRt() {
  if (Iye) return oS;
  Iye = 1;
  var r = gm(), e = Ch(), t = r(e, "DataView");
  return oS = t, oS;
}
var aS, Oye;
function KRt() {
  if (Oye) return aS;
  Oye = 1;
  var r = gm(), e = Ch(), t = r(e, "Promise");
  return aS = t, aS;
}
var lS, Rye;
function YRt() {
  if (Rye) return lS;
  Rye = 1;
  var r = gm(), e = Ch(), t = r(e, "Set");
  return lS = t, lS;
}
var cS, Vye;
function XRt() {
  if (Vye) return cS;
  Vye = 1;
  var r = gm(), e = Ch(), t = r(e, "WeakMap");
  return cS = t, cS;
}
var hS, Hye;
function JRt() {
  if (Hye) return hS;
  Hye = 1;
  var r = QRt(), e = kV(), t = KRt(), n = YRt(), i = XRt(), s = cw(), o = JOe(), a = "[object Map]", l = "[object Object]", c = "[object Promise]", d = "[object Set]", u = "[object WeakMap]", f = "[object DataView]", p = o(r), g = o(e), m = o(t), A = o(n), w = o(i), v = s;
  return (r && v(new r(new ArrayBuffer(1))) != f || e && v(new e()) != a || t && v(t.resolve()) != c || n && v(new n()) != d || i && v(new i()) != u) && (v = function(y) {
    var _ = s(y), S = _ == l ? y.constructor : void 0, D = S ? o(S) : "";
    if (D)
      switch (D) {
        case p:
          return f;
        case g:
          return a;
        case m:
          return c;
        case A:
          return d;
        case w:
          return u;
      }
    return _;
  }), hS = v, hS;
}
var dS, Bye;
function $Rt() {
  if (Bye) return dS;
  Bye = 1;
  var r = mRt(), e = eRe(), t = xRt(), n = GRt(), i = JRt(), s = NV(), o = tRe(), a = iRe(), l = 1, c = "[object Arguments]", d = "[object Array]", u = "[object Object]", f = Object.prototype, p = f.hasOwnProperty;
  function g(m, A, w, v, y, _) {
    var S = s(m), D = s(A), M = S ? d : i(m), L = D ? d : i(A);
    M = M == c ? u : M, L = L == c ? u : L;
    var T = M == u, B = L == u, V = M == L;
    if (V && o(m)) {
      if (!o(A))
        return !1;
      S = !0, T = !1;
    }
    if (V && !T)
      return _ || (_ = new r()), S || a(m) ? e(m, A, w, v, y, _) : t(m, A, M, w, v, y, _);
    if (!(w & l)) {
      var N = T && p.call(m, "__wrapped__"), R = B && p.call(A, "__wrapped__");
      if (N || R) {
        var H = N ? m.value() : m, z = R ? A.value() : A;
        return _ || (_ = new r()), y(H, z, w, v, _);
      }
    }
    return V ? (_ || (_ = new r()), n(m, A, w, v, y, _)) : !1;
  }
  return dS = g, dS;
}
var uS, Pye;
function eVt() {
  if (Pye) return uS;
  Pye = 1;
  var r = $Rt(), e = hw();
  function t(n, i, s, o, a) {
    return n === i ? !0 : n == null || i == null || !e(n) && !e(i) ? n !== n && i !== i : r(n, i, s, o, t, a);
  }
  return uS = t, uS;
}
var fS, Fye;
function tVt() {
  if (Fye) return fS;
  Fye = 1;
  var r = eVt();
  function e(t, n) {
    return r(t, n);
  }
  return fS = e, fS;
}
var nVt = tVt();
const Ar = /* @__PURE__ */ a7(nVt);
function zye(r, e) {
  return e !== void 0 && !e.includes(r.businessObject.id) && r.type !== "label" && sMe(r.businessObject);
}
function Wye(r) {
  return r?.loopCharacteristics?.$type === "bpmn:MultiInstanceLoopCharacteristics";
}
var iVt = "#ccc", rVt = "djs-grid", jye = {
  width: 1e5,
  height: 1e5
};
function d2(r, e) {
  this._canvas = r;
  var t = this;
  e.on("diagram.init", function() {
    t._init(), t.toggle(!0);
  }), e.on("gridSnapping.toggle", function(n) {
    var i = n.active;
    t.toggle(i), t._centerGridAroundViewbox();
  }), e.on("canvas.viewbox.changed", function(n) {
    var i = n.viewbox;
    t._centerGridAroundViewbox(i);
  });
}
d2.prototype._init = function() {
  var r = Ps("defs", this._canvas._svg);
  r || (r = md("defs"), Ld(this._canvas._svg, r));
  var e = this._pattern = md("pattern"), t = "djs-grid-pattern-" + sVt();
  kd(e, {
    id: t,
    width: v1,
    height: v1,
    patternUnits: "userSpaceOnUse"
  });
  var n = this._circle = md("circle");
  kd(n, {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    fill: iVt
  }), Ld(e, n), Ld(r, e);
  var i = this._gfx = md("rect");
  kd(i, {
    x: -5e4,
    y: -5e4,
    width: jye.width,
    height: jye.height,
    fill: `url(#${t})`
  });
};
d2.prototype._centerGridAroundViewbox = function(r) {
  r || (r = this._canvas.viewbox());
  var e = C4(r);
  kd(this._gfx, {
    x: -5e4 + Sb(e.x, v1),
    y: -5e4 + Sb(e.y, v1)
  });
};
d2.prototype.isVisible = function() {
  return this._visible;
};
d2.prototype.toggle = function(r) {
  if (typeof r > "u" && (r = !this._visible), r !== this._visible) {
    var e = this._getParent();
    r ? Ld(e, this._gfx) : WIe(e), this._visible = r;
  }
};
d2.prototype._getParent = function() {
  return this._canvas.getLayer(rVt, -2);
};
d2.$inject = [
  "canvas",
  "eventBus"
];
function sVt() {
  return Math.trunc(Math.random() * 1e6);
}
var oVt = {
  __init__: ["grid"],
  grid: ["type", d2]
};
function Zye(r, e) {
  const t = `bio-improved-canvas-${r}`;
  if (!document.querySelector(`[data-css-file="${t}"]`)) {
    var n = document.head || document.getElementsByTagName("head")[0], i = document.createElement("style");
    i.setAttribute("data-css-file", t), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(document.createTextNode(e)), n.appendChild(i);
  }
}
var aVt = `.bio-improved-canvas {
  --gray-10: #f4f4f4;
  --gray-20: #e0e0e0;
  --gray-30: #c6c6c6;
  --gray-40: #a8a8a8;
  --gray-50: #878d96;
  --gray-60: #697077;
  --gray-80: #393939;
  --gray-100: #161616;

  --blue-60: #0f62fe;
  --blue-70: #0043ce;
}`, lVt = `/* Canvas */
.bio-improved-canvas {
  --palette-background-color: white;
  --palette-separator-color: var(--gray-20);
  --palette-entry-color: var(--gray-100);
  --palette-border-color: var(--gray-20);
  
  --context-pad-entry-background-color: var(--gray-10);
}

.djs-container.bio-improved-canvas,
.dmn-drd-container.bio-improved-canvas {
  background-color: var(--gray-10);
}

.dmn-drd-container.bio-improved-canvas {
  --dmn-definitions-background-color: white;
  --dmn-definitions-border-color: var(--gray-20);
}

/* Grid */
.bio-improved-canvas defs pattern circle {
  fill: hsl(0, 0%, 87%) !important;
  fill: var(--gray-40) !important;
}
`;
function cVt() {
  Zye("base", aVt), Zye("high-contrast-canvas", lVt);
}
function rRe(r, e) {
  e.on("diagram.init", () => r.getContainer().classList.add("bio-improved-canvas"));
}
rRe.$inject = ["canvas", "eventBus"];
var hVt = {
  __init__: [
    "improvedCanvas"
  ],
  improvedCanvas: ["type", rRe]
}, sRe = {
  __init__: [
    "highContrastCanvas"
  ],
  __depends__: [
    oVt,
    hVt
  ],
  highContrastCanvas: ["type", cVt]
}, dVt = uVt, oRe = !1, M5;
typeof document < "u" && (M5 = document.createElement("div"), M5.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>', oRe = !M5.getElementsByTagName("link").length, M5 = void 0);
var dr = {
  legend: [1, "<fieldset>", "</fieldset>"],
  tr: [2, "<table><tbody>", "</tbody></table>"],
  col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
  // for script/link/style tags to work in IE6-8, you have to wrap
  // in a div with a non-whitespace character in front, ha!
  _default: oRe ? [1, "X<div>", "</div>"] : [0, "", ""]
};
dr.td = dr.th = [3, "<table><tbody><tr>", "</tr></tbody></table>"];
dr.option = dr.optgroup = [1, '<select multiple="multiple">', "</select>"];
dr.thead = dr.tbody = dr.colgroup = dr.caption = dr.tfoot = [1, "<table>", "</table>"];
dr.polyline = dr.ellipse = dr.polygon = dr.circle = dr.text = dr.line = dr.path = dr.rect = dr.g = [1, '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">', "</svg>"];
function uVt(r, e) {
  if (typeof r != "string") throw new TypeError("String expected");
  e || (e = document);
  var t = /<([\w:]+)/.exec(r);
  if (!t) return e.createTextNode(r);
  r = r.replace(/^\s+|\s+$/g, "");
  var n = t[1];
  if (n == "body") {
    var l = e.createElement("html");
    return l.innerHTML = r, l.removeChild(l.lastChild);
  }
  var i = Object.prototype.hasOwnProperty.call(dr, n) ? dr[n] : dr._default, s = i[0], o = i[1], a = i[2], l = e.createElement("div");
  for (l.innerHTML = o + r + a; s--; ) l = l.lastChild;
  if (l.firstChild == l.lastChild)
    return l.removeChild(l.firstChild);
  for (var c = e.createDocumentFragment(); l.firstChild; )
    c.appendChild(l.removeChild(l.firstChild));
  return c;
}
var aRe = dVt;
function fVt(r, e) {
  return e = e || document, e.querySelector(r);
}
var tC, wt, lRe, M0, Uye, cRe, IN, hRe, _4 = {}, dRe = [], pVt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, nC = Array.isArray;
function Wu(r, e) {
  for (var t in e) r[t] = e[t];
  return r;
}
function uRe(r) {
  var e = r.parentNode;
  e && e.removeChild(r);
}
function Mg(r, e, t) {
  var n, i, s, o = {};
  for (s in e) s == "key" ? n = e[s] : s == "ref" ? i = e[s] : o[s] = e[s];
  if (arguments.length > 2 && (o.children = arguments.length > 3 ? tC.call(arguments, 2) : t), typeof r == "function" && r.defaultProps != null) for (s in r.defaultProps) o[s] === void 0 && (o[s] = r.defaultProps[s]);
  return q6(r, o, n, i, null);
}
function q6(r, e, t, n, i) {
  var s = { type: r, props: e, key: t, ref: n, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: i ?? ++lRe, __i: -1, __u: 0 };
  return i == null && wt.vnode != null && wt.vnode(s), s;
}
function kf(r) {
  return r.children;
}
function Nd(r, e) {
  this.props = r, this.context = e;
}
function Dg(r, e) {
  if (e == null) return r.__ ? Dg(r.__, r.__i + 1) : null;
  for (var t; e < r.__k.length; e++) if ((t = r.__k[e]) != null && t.__e != null) return t.__e;
  return typeof r.type == "function" ? Dg(r) : null;
}
function fRe(r) {
  var e, t;
  if ((r = r.__) != null && r.__c != null) {
    for (r.__e = r.__c.base = null, e = 0; e < r.__k.length; e++) if ((t = r.__k[e]) != null && t.__e != null) {
      r.__e = r.__c.base = t.__e;
      break;
    }
    return fRe(r);
  }
}
function ON(r) {
  (!r.__d && (r.__d = !0) && M0.push(r) && !Mb.__r++ || Uye !== wt.debounceRendering) && ((Uye = wt.debounceRendering) || cRe)(Mb);
}
function Mb() {
  var r, e, t, n, i, s, o, a, l;
  for (M0.sort(IN); r = M0.shift(); ) r.__d && (e = M0.length, n = void 0, s = (i = (t = r).__v).__e, a = [], l = [], (o = t.__P) && ((n = Wu({}, i)).__v = i.__v + 1, wt.vnode && wt.vnode(n), TV(o, n, i, t.__n, o.ownerSVGElement !== void 0, 32 & i.__u ? [s] : null, a, s ?? Dg(i), !!(32 & i.__u), l), n.__.__k[n.__i] = n, mRe(a, n, l), n.__e != s && fRe(n)), M0.length > e && M0.sort(IN));
  Mb.__r = 0;
}
function pRe(r, e, t, n, i, s, o, a, l, c, d) {
  var u, f, p, g, m, A = n && n.__k || dRe, w = e.length;
  for (t.__d = l, gVt(t, e, A), l = t.__d, u = 0; u < w; u++) (p = t.__k[u]) != null && typeof p != "boolean" && typeof p != "function" && (f = p.__i === -1 ? _4 : A[p.__i] || _4, p.__i = u, TV(r, p, f, i, s, o, a, l, c, d), g = p.__e, p.ref && f.ref != p.ref && (f.ref && IV(f.ref, null, p), d.push(p.ref, p.__c || g, p)), m == null && g != null && (m = g), 65536 & p.__u || f.__k === p.__k ? l = gRe(p, l, r) : typeof p.type == "function" && p.__d !== void 0 ? l = p.__d : g && (l = g.nextSibling), p.__d = void 0, p.__u &= -196609);
  t.__d = l, t.__e = m;
}
function gVt(r, e, t) {
  var n, i, s, o, a, l = e.length, c = t.length, d = c, u = 0;
  for (r.__k = [], n = 0; n < l; n++) (i = r.__k[n] = (i = e[n]) == null || typeof i == "boolean" || typeof i == "function" ? null : typeof i == "string" || typeof i == "number" || typeof i == "bigint" || i.constructor == String ? q6(null, i, null, null, i) : nC(i) ? q6(kf, { children: i }, null, null, null) : i.constructor === void 0 && i.__b > 0 ? q6(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) != null ? (i.__ = r, i.__b = r.__b + 1, a = mVt(i, t, o = n + u, d), i.__i = a, s = null, a !== -1 && (d--, (s = t[a]) && (s.__u |= 131072)), s == null || s.__v === null ? (a == -1 && u--, typeof i.type != "function" && (i.__u |= 65536)) : a !== o && (a === o + 1 ? u++ : a > o ? d > l - o ? u += a - o : u-- : u = a < o && a == o - 1 ? a - o : 0, a !== n + u && (i.__u |= 65536))) : (s = t[n]) && s.key == null && s.__e && (s.__e == r.__d && (r.__d = Dg(s)), RN(s, s, !1), t[n] = null, d--);
  if (d) for (n = 0; n < c; n++) (s = t[n]) != null && (131072 & s.__u) == 0 && (s.__e == r.__d && (r.__d = Dg(s)), RN(s, s));
}
function gRe(r, e, t) {
  var n, i;
  if (typeof r.type == "function") {
    for (n = r.__k, i = 0; n && i < n.length; i++) n[i] && (n[i].__ = r, e = gRe(n[i], e, t));
    return e;
  }
  return r.__e != e && (t.insertBefore(r.__e, e || null), e = r.__e), e && e.nextSibling;
}
function Db(r, e) {
  return e = e || [], r == null || typeof r == "boolean" || (nC(r) ? r.some(function(t) {
    Db(t, e);
  }) : e.push(r)), e;
}
function mVt(r, e, t, n) {
  var i = r.key, s = r.type, o = t - 1, a = t + 1, l = e[t];
  if (l === null || l && i == l.key && s === l.type) return t;
  if (n > (l != null && (131072 & l.__u) == 0 ? 1 : 0)) for (; o >= 0 || a < e.length; ) {
    if (o >= 0) {
      if ((l = e[o]) && (131072 & l.__u) == 0 && i == l.key && s === l.type) return o;
      o--;
    }
    if (a < e.length) {
      if ((l = e[a]) && (131072 & l.__u) == 0 && i == l.key && s === l.type) return a;
      a++;
    }
  }
  return -1;
}
function qye(r, e, t) {
  e[0] === "-" ? r.setProperty(e, t ?? "") : r[e] = t == null ? "" : typeof t != "number" || pVt.test(e) ? t : t + "px";
}
function D5(r, e, t, n, i) {
  var s;
  e: if (e === "style") if (typeof t == "string") r.style.cssText = t;
  else {
    if (typeof n == "string" && (r.style.cssText = n = ""), n) for (e in n) t && e in t || qye(r.style, e, "");
    if (t) for (e in t) n && t[e] === n[e] || qye(r.style, e, t[e]);
  }
  else if (e[0] === "o" && e[1] === "n") s = e !== (e = e.replace(/(PointerCapture)$|Capture$/, "$1")), e = e.toLowerCase() in r ? e.toLowerCase().slice(2) : e.slice(2), r.l || (r.l = {}), r.l[e + s] = t, t ? n ? t.u = n.u : (t.u = Date.now(), r.addEventListener(e, s ? Qye : Gye, s)) : r.removeEventListener(e, s ? Qye : Gye, s);
  else {
    if (i) e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
    else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e !== "rowSpan" && e !== "colSpan" && e !== "role" && e in r) try {
      r[e] = t ?? "";
      break e;
    } catch {
    }
    typeof t == "function" || (t == null || t === !1 && e[4] !== "-" ? r.removeAttribute(e) : r.setAttribute(e, t));
  }
}
function Gye(r) {
  var e = this.l[r.type + !1];
  if (r.t) {
    if (r.t <= e.u) return;
  } else r.t = Date.now();
  return e(wt.event ? wt.event(r) : r);
}
function Qye(r) {
  return this.l[r.type + !0](wt.event ? wt.event(r) : r);
}
function TV(r, e, t, n, i, s, o, a, l, c) {
  var d, u, f, p, g, m, A, w, v, y, _, S, D, M, L, T = e.type;
  if (e.constructor !== void 0) return null;
  128 & t.__u && (l = !!(32 & t.__u), s = [a = e.__e = t.__e]), (d = wt.__b) && d(e);
  e: if (typeof T == "function") try {
    if (w = e.props, v = (d = T.contextType) && n[d.__c], y = d ? v ? v.props.value : d.__ : n, t.__c ? A = (u = e.__c = t.__c).__ = u.__E : ("prototype" in T && T.prototype.render ? e.__c = u = new T(w, y) : (e.__c = u = new Nd(w, y), u.constructor = T, u.render = wVt), v && v.sub(u), u.props = w, u.state || (u.state = {}), u.context = y, u.__n = n, f = u.__d = !0, u.__h = [], u._sb = []), u.__s == null && (u.__s = u.state), T.getDerivedStateFromProps != null && (u.__s == u.state && (u.__s = Wu({}, u.__s)), Wu(u.__s, T.getDerivedStateFromProps(w, u.__s))), p = u.props, g = u.state, u.__v = e, f) T.getDerivedStateFromProps == null && u.componentWillMount != null && u.componentWillMount(), u.componentDidMount != null && u.__h.push(u.componentDidMount);
    else {
      if (T.getDerivedStateFromProps == null && w !== p && u.componentWillReceiveProps != null && u.componentWillReceiveProps(w, y), !u.__e && (u.shouldComponentUpdate != null && u.shouldComponentUpdate(w, u.__s, y) === !1 || e.__v === t.__v)) {
        for (e.__v !== t.__v && (u.props = w, u.state = u.__s, u.__d = !1), e.__e = t.__e, e.__k = t.__k, e.__k.forEach(function(B) {
          B && (B.__ = e);
        }), _ = 0; _ < u._sb.length; _++) u.__h.push(u._sb[_]);
        u._sb = [], u.__h.length && o.push(u);
        break e;
      }
      u.componentWillUpdate != null && u.componentWillUpdate(w, u.__s, y), u.componentDidUpdate != null && u.__h.push(function() {
        u.componentDidUpdate(p, g, m);
      });
    }
    if (u.context = y, u.props = w, u.__P = r, u.__e = !1, S = wt.__r, D = 0, "prototype" in T && T.prototype.render) {
      for (u.state = u.__s, u.__d = !1, S && S(e), d = u.render(u.props, u.state, u.context), M = 0; M < u._sb.length; M++) u.__h.push(u._sb[M]);
      u._sb = [];
    } else do
      u.__d = !1, S && S(e), d = u.render(u.props, u.state, u.context), u.state = u.__s;
    while (u.__d && ++D < 25);
    u.state = u.__s, u.getChildContext != null && (n = Wu(Wu({}, n), u.getChildContext())), f || u.getSnapshotBeforeUpdate == null || (m = u.getSnapshotBeforeUpdate(p, g)), pRe(r, nC(L = d != null && d.type === kf && d.key == null ? d.props.children : d) ? L : [L], e, t, n, i, s, o, a, l, c), u.base = e.__e, e.__u &= -161, u.__h.length && o.push(u), A && (u.__E = u.__ = null);
  } catch (B) {
    e.__v = null, l || s != null ? (e.__e = a, e.__u |= l ? 160 : 32, s[s.indexOf(a)] = null) : (e.__e = t.__e, e.__k = t.__k), wt.__e(B, e, t);
  }
  else s == null && e.__v === t.__v ? (e.__k = t.__k, e.__e = t.__e) : e.__e = AVt(t.__e, e, t, n, i, s, o, l, c);
  (d = wt.diffed) && d(e);
}
function mRe(r, e, t) {
  e.__d = void 0;
  for (var n = 0; n < t.length; n++) IV(t[n], t[++n], t[++n]);
  wt.__c && wt.__c(e, r), r.some(function(i) {
    try {
      r = i.__h, i.__h = [], r.some(function(s) {
        s.call(i);
      });
    } catch (s) {
      wt.__e(s, i.__v);
    }
  });
}
function AVt(r, e, t, n, i, s, o, a, l) {
  var c, d, u, f, p, g, m, A = t.props, w = e.props, v = e.type;
  if (v === "svg" && (i = !0), s != null) {
    for (c = 0; c < s.length; c++) if ((p = s[c]) && "setAttribute" in p == !!v && (v ? p.localName === v : p.nodeType === 3)) {
      r = p, s[c] = null;
      break;
    }
  }
  if (r == null) {
    if (v === null) return document.createTextNode(w);
    r = i ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, w.is && w), s = null, a = !1;
  }
  if (v === null) A === w || a && r.data === w || (r.data = w);
  else {
    if (s = s && tC.call(r.childNodes), A = t.props || _4, !a && s != null) for (A = {}, c = 0; c < r.attributes.length; c++) A[(p = r.attributes[c]).name] = p.value;
    for (c in A) p = A[c], c == "children" || (c == "dangerouslySetInnerHTML" ? u = p : c === "key" || c in w || D5(r, c, null, p, i));
    for (c in w) p = w[c], c == "children" ? f = p : c == "dangerouslySetInnerHTML" ? d = p : c == "value" ? g = p : c == "checked" ? m = p : c === "key" || a && typeof p != "function" || A[c] === p || D5(r, c, p, A[c], i);
    if (d) a || u && (d.__html === u.__html || d.__html === r.innerHTML) || (r.innerHTML = d.__html), e.__k = [];
    else if (u && (r.innerHTML = ""), pRe(r, nC(f) ? f : [f], e, t, n, i && v !== "foreignObject", s, o, s ? s[0] : t.__k && Dg(t, 0), a, l), s != null) for (c = s.length; c--; ) s[c] != null && uRe(s[c]);
    a || (c = "value", g !== void 0 && (g !== r[c] || v === "progress" && !g || v === "option" && g !== A[c]) && D5(r, c, g, A[c], !1), c = "checked", m !== void 0 && m !== r[c] && D5(r, c, m, A[c], !1));
  }
  return r;
}
function IV(r, e, t) {
  try {
    typeof r == "function" ? r(e) : r.current = e;
  } catch (n) {
    wt.__e(n, t);
  }
}
function RN(r, e, t) {
  var n, i;
  if (wt.unmount && wt.unmount(r), (n = r.ref) && (n.current && n.current !== r.__e || IV(n, null, e)), (n = r.__c) != null) {
    if (n.componentWillUnmount) try {
      n.componentWillUnmount();
    } catch (s) {
      wt.__e(s, e);
    }
    n.base = n.__P = null, r.__c = void 0;
  }
  if (n = r.__k) for (i = 0; i < n.length; i++) n[i] && RN(n[i], e, t || typeof r.type != "function");
  t || r.__e == null || uRe(r.__e), r.__ = r.__e = r.__d = void 0;
}
function wVt(r, e, t) {
  return this.constructor(r, t);
}
function Kye(r, e, t) {
  var n, i, s, o;
  wt.__ && wt.__(r, e), i = (n = !1) ? null : e.__k, s = [], o = [], TV(e, r = e.__k = Mg(kf, null, [r]), i || _4, _4, e.ownerSVGElement !== void 0, i ? null : e.firstChild ? tC.call(e.childNodes) : null, s, i ? i.__e : e.firstChild, n, o), mRe(s, r, o);
}
function mm(r, e) {
  var t = { __c: e = "__cC" + hRe++, __: r, Consumer: function(n, i) {
    return n.children(i);
  }, Provider: function(n) {
    var i, s;
    return this.getChildContext || (i = [], (s = {})[e] = this, this.getChildContext = function() {
      return s;
    }, this.shouldComponentUpdate = function(o) {
      this.props.value !== o.value && i.some(function(a) {
        a.__e = !0, ON(a);
      });
    }, this.sub = function(o) {
      i.push(o);
      var a = o.componentWillUnmount;
      o.componentWillUnmount = function() {
        i.splice(i.indexOf(o), 1), a && a.call(o);
      };
    }), n.children;
  } };
  return t.Provider.__ = t.Consumer.contextType = t;
}
tC = dRe.slice, wt = { __e: function(r, e, t, n) {
  for (var i, s, o; e = e.__; ) if ((i = e.__c) && !i.__) try {
    if ((s = i.constructor) && s.getDerivedStateFromError != null && (i.setState(s.getDerivedStateFromError(r)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(r, n || {}), o = i.__d), o) return i.__E = i;
  } catch (a) {
    r = a;
  }
  throw r;
} }, lRe = 0, Nd.prototype.setState = function(r, e) {
  var t;
  t = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Wu({}, this.state), typeof r == "function" && (r = r(Wu({}, t), this.props)), r && Wu(t, r), r != null && this.__v && (e && this._sb.push(e), ON(this));
}, Nd.prototype.forceUpdate = function(r) {
  this.__v && (this.__e = !0, r && this.__h.push(r), ON(this));
}, Nd.prototype.render = kf, M0 = [], cRe = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, IN = function(r, e) {
  return r.__v.__b - e.__v.__b;
}, Mb.__r = 0, hRe = 0;
var Lg, Wi, pS, Yye, x4 = 0, ARe = [], G6 = [], Xye = wt.__b, Jye = wt.__r, $ye = wt.diffed, eCe = wt.__c, tCe = wt.unmount;
function iC(r, e) {
  wt.__h && wt.__h(Wi, r, x4 || e), x4 = 0;
  var t = Wi.__H || (Wi.__H = { __: [], __h: [] });
  return r >= t.__.length && t.__.push({ __V: G6 }), t.__[r];
}
function wh(r) {
  return x4 = 1, vVt(bRe, r);
}
function vVt(r, e, t) {
  var n = iC(Lg++, 2);
  if (n.t = r, !n.__c && (n.__ = [bRe(void 0, e), function(a) {
    var l = n.__N ? n.__N[0] : n.__[0], c = n.t(l, a);
    l !== c && (n.__N = [c, n.__[1]], n.__c.setState({}));
  }], n.__c = Wi, !Wi.u)) {
    var i = function(a, l, c) {
      if (!n.__c.__H) return !0;
      var d = n.__c.__H.__.filter(function(f) {
        return f.__c;
      });
      if (d.every(function(f) {
        return !f.__N;
      })) return !s || s.call(this, a, l, c);
      var u = !1;
      return d.forEach(function(f) {
        if (f.__N) {
          var p = f.__[0];
          f.__ = f.__N, f.__N = void 0, p !== f.__[0] && (u = !0);
        }
      }), !(!u && n.__c.props === a) && (!s || s.call(this, a, l, c));
    };
    Wi.u = !0;
    var s = Wi.shouldComponentUpdate, o = Wi.componentWillUpdate;
    Wi.componentWillUpdate = function(a, l, c) {
      if (this.__e) {
        var d = s;
        s = void 0, i(a, l, c), s = d;
      }
      o && o.call(this, a, l, c);
    }, Wi.shouldComponentUpdate = i;
  }
  return n.__N || n.__;
}
function wa(r, e) {
  var t = iC(Lg++, 3);
  !wt.__s && vRe(t.__H, e) && (t.__ = r, t.i = e, Wi.__H.__h.push(t));
}
function Fs(r) {
  return x4 = 5, Am(function() {
    return { current: r };
  }, []);
}
function Am(r, e) {
  var t = iC(Lg++, 7);
  return vRe(t.__H, e) ? (t.__V = r(), t.i = e, t.__h = r, t.__V) : t.__;
}
function bVt(r, e) {
  return x4 = 8, Am(function() {
    return r;
  }, e);
}
function wRe(r) {
  var e = Wi.context[r.__c], t = iC(Lg++, 9);
  return t.c = r, e ? (t.__ == null && (t.__ = !0, e.sub(Wi)), e.props.value) : r.__;
}
function yVt() {
  for (var r; r = ARe.shift(); ) if (r.__P && r.__H) try {
    r.__H.__h.forEach(Q6), r.__H.__h.forEach(VN), r.__H.__h = [];
  } catch (e) {
    r.__H.__h = [], wt.__e(e, r.__v);
  }
}
wt.__b = function(r) {
  Wi = null, Xye && Xye(r);
}, wt.__r = function(r) {
  Jye && Jye(r), Lg = 0;
  var e = (Wi = r.__c).__H;
  e && (pS === Wi ? (e.__h = [], Wi.__h = [], e.__.forEach(function(t) {
    t.__N && (t.__ = t.__N), t.__V = G6, t.__N = t.i = void 0;
  })) : (e.__h.forEach(Q6), e.__h.forEach(VN), e.__h = [], Lg = 0)), pS = Wi;
}, wt.diffed = function(r) {
  $ye && $ye(r);
  var e = r.__c;
  e && e.__H && (e.__H.__h.length && (ARe.push(e) !== 1 && Yye === wt.requestAnimationFrame || ((Yye = wt.requestAnimationFrame) || CVt)(yVt)), e.__H.__.forEach(function(t) {
    t.i && (t.__H = t.i), t.__V !== G6 && (t.__ = t.__V), t.i = void 0, t.__V = G6;
  })), pS = Wi = null;
}, wt.__c = function(r, e) {
  e.some(function(t) {
    try {
      t.__h.forEach(Q6), t.__h = t.__h.filter(function(n) {
        return !n.__ || VN(n);
      });
    } catch (n) {
      e.some(function(i) {
        i.__h && (i.__h = []);
      }), e = [], wt.__e(n, t.__v);
    }
  }), eCe && eCe(r, e);
}, wt.unmount = function(r) {
  tCe && tCe(r);
  var e, t = r.__c;
  t && t.__H && (t.__H.__.forEach(function(n) {
    try {
      Q6(n);
    } catch (i) {
      e = i;
    }
  }), t.__H = void 0, e && wt.__e(e, t.__v));
};
var nCe = typeof requestAnimationFrame == "function";
function CVt(r) {
  var e, t = function() {
    clearTimeout(n), nCe && cancelAnimationFrame(e), setTimeout(r);
  }, n = setTimeout(t, 100);
  nCe && (e = requestAnimationFrame(t));
}
function Q6(r) {
  var e = Wi, t = r.__c;
  typeof t == "function" && (r.__c = void 0, t()), Wi = e;
}
function VN(r) {
  var e = Wi;
  r.__c = r.__(), Wi = e;
}
function vRe(r, e) {
  return !r || r.length !== e.length || e.some(function(t, n) {
    return t !== r[n];
  });
}
function bRe(r, e) {
  return typeof e == "function" ? e(r) : e;
}
function yRe(r, e) {
  for (var t in e) r[t] = e[t];
  return r;
}
function iCe(r, e) {
  for (var t in r) if (t !== "__source" && !(t in e)) return !0;
  for (var n in e) if (n !== "__source" && r[n] !== e[n]) return !0;
  return !1;
}
function rCe(r) {
  this.props = r;
}
(rCe.prototype = new Nd()).isPureReactComponent = !0, rCe.prototype.shouldComponentUpdate = function(r, e) {
  return iCe(this.props, r) || iCe(this.state, e);
};
var sCe = wt.__b;
wt.__b = function(r) {
  r.type && r.type.__f && r.ref && (r.props.ref = r.ref, r.ref = null), sCe && sCe(r);
};
var EVt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function z1(r) {
  function e(t) {
    var n = yRe({}, t);
    return delete n.ref, r(n, t.ref || null);
  }
  return e.$$typeof = EVt, e.render = e, e.prototype.isReactComponent = e.__f = !0, e.displayName = "ForwardRef(" + (r.displayName || r.name) + ")", e;
}
var _Vt = wt.__e;
wt.__e = function(r, e, t, n) {
  if (r.then) {
    for (var i, s = e; s = s.__; ) if ((i = s.__c) && i.__c) return e.__e == null && (e.__e = t.__e, e.__k = t.__k), i.__c(r, e);
  }
  _Vt(r, e, t, n);
};
var oCe = wt.unmount;
function CRe(r, e, t) {
  return r && (r.__c && r.__c.__H && (r.__c.__H.__.forEach(function(n) {
    typeof n.__c == "function" && n.__c();
  }), r.__c.__H = null), (r = yRe({}, r)).__c != null && (r.__c.__P === t && (r.__c.__P = e), r.__c = null), r.__k = r.__k && r.__k.map(function(n) {
    return CRe(n, e, t);
  })), r;
}
function ERe(r, e, t) {
  return r && t && (r.__v = null, r.__k = r.__k && r.__k.map(function(n) {
    return ERe(n, e, t);
  }), r.__c && r.__c.__P === e && (r.__e && t.appendChild(r.__e), r.__c.__e = !0, r.__c.__P = t)), r;
}
function gS() {
  this.__u = 0, this.t = null, this.__b = null;
}
function _Re(r) {
  var e = r.__.__c;
  return e && e.__a && e.__a(r);
}
function L5() {
  this.u = null, this.o = null;
}
wt.unmount = function(r) {
  var e = r.__c;
  e && e.__R && e.__R(), e && 32 & r.__u && (r.type = null), oCe && oCe(r);
}, (gS.prototype = new Nd()).__c = function(r, e) {
  var t = e.__c, n = this;
  n.t == null && (n.t = []), n.t.push(t);
  var i = _Re(n.__v), s = !1, o = function() {
    s || (s = !0, t.__R = null, i ? i(a) : a());
  };
  t.__R = o;
  var a = function() {
    if (!--n.__u) {
      if (n.state.__a) {
        var l = n.state.__a;
        n.__v.__k[0] = ERe(l, l.__c.__P, l.__c.__O);
      }
      var c;
      for (n.setState({ __a: n.__b = null }); c = n.t.pop(); ) c.forceUpdate();
    }
  };
  n.__u++ || 32 & e.__u || n.setState({ __a: n.__b = n.__v.__k[0] }), r.then(o, o);
}, gS.prototype.componentWillUnmount = function() {
  this.t = [];
}, gS.prototype.render = function(r, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var t = document.createElement("div"), n = this.__v.__k[0].__c;
      this.__v.__k[0] = CRe(this.__b, t, n.__O = n.__P);
    }
    this.__b = null;
  }
  var i = e.__a && Mg(kf, null, r.fallback);
  return i && (i.__u &= -33), [Mg(kf, null, e.__a ? null : r.children), i];
};
var aCe = function(r, e, t) {
  if (++t[1] === t[0] && r.o.delete(e), r.props.revealOrder && (r.props.revealOrder[0] !== "t" || !r.o.size)) for (t = r.u; t; ) {
    for (; t.length > 3; ) t.pop()();
    if (t[1] < t[0]) break;
    r.u = t = t[2];
  }
};
function xVt(r) {
  return this.getChildContext = function() {
    return r.context;
  }, r.children;
}
function SVt(r) {
  var e = this, t = r.i;
  e.componentWillUnmount = function() {
    Kye(null, e.l), e.l = null, e.i = null;
  }, e.i && e.i !== t && e.componentWillUnmount(), e.l || (e.i = t, e.l = { nodeType: 1, parentNode: t, childNodes: [], appendChild: function(n) {
    this.childNodes.push(n), e.i.appendChild(n);
  }, insertBefore: function(n, i) {
    this.childNodes.push(n), e.i.appendChild(n);
  }, removeChild: function(n) {
    this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
  } }), Kye(Mg(xVt, { context: e.context }, r.__v), e.l);
}
function xRe(r, e) {
  var t = Mg(SVt, { __v: r, i: e });
  return t.containerInfo = e, t;
}
(L5.prototype = new Nd()).__a = function(r) {
  var e = this, t = _Re(e.__v), n = e.o.get(r);
  return n[0]++, function(i) {
    var s = function() {
      e.props.revealOrder ? (n.push(i), aCe(e, r, n)) : i();
    };
    t ? t(s) : s();
  };
}, L5.prototype.render = function(r) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = Db(r.children);
  r.revealOrder && r.revealOrder[0] === "b" && e.reverse();
  for (var t = e.length; t--; ) this.o.set(e[t], this.u = [1, 0, this.u]);
  return r.children;
}, L5.prototype.componentDidUpdate = L5.prototype.componentDidMount = function() {
  var r = this;
  this.o.forEach(function(e, t) {
    aCe(r, t, e);
  });
};
var MVt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, DVt = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, LVt = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, kVt = /[A-Z0-9]/g, NVt = typeof document < "u", TVt = function(r) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(r);
};
Nd.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(r) {
  Object.defineProperty(Nd.prototype, r, { configurable: !0, get: function() {
    return this["UNSAFE_" + r];
  }, set: function(e) {
    Object.defineProperty(this, r, { configurable: !0, writable: !0, value: e });
  } });
});
var lCe = wt.event;
function IVt() {
}
function OVt() {
  return this.cancelBubble;
}
function RVt() {
  return this.defaultPrevented;
}
wt.event = function(r) {
  return lCe && (r = lCe(r)), r.persist = IVt, r.isPropagationStopped = OVt, r.isDefaultPrevented = RVt, r.nativeEvent = r;
};
var VVt = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, cCe = wt.vnode;
wt.vnode = function(r) {
  typeof r.type == "string" && function(e) {
    var t = e.props, n = e.type, i = {};
    for (var s in t) {
      var o = t[s];
      if (!(s === "value" && "defaultValue" in t && o == null || NVt && s === "children" && n === "noscript" || s === "class" || s === "className")) {
        var a = s.toLowerCase();
        s === "defaultValue" && "value" in t && t.value == null ? s = "value" : s === "download" && o === !0 ? o = "" : a === "ondoubleclick" ? s = "ondblclick" : a !== "onchange" || n !== "input" && n !== "textarea" || TVt(t.type) ? a === "onfocus" ? s = "onfocusin" : a === "onblur" ? s = "onfocusout" : LVt.test(s) ? s = a : n.indexOf("-") === -1 && DVt.test(s) ? s = s.replace(kVt, "-$&").toLowerCase() : o === null && (o = void 0) : a = s = "oninput", a === "oninput" && i[s = a] && (s = "oninputCapture"), i[s] = o;
      }
    }
    n == "select" && i.multiple && Array.isArray(i.value) && (i.value = Db(t.children).forEach(function(l) {
      l.props.selected = i.value.indexOf(l.props.value) != -1;
    })), n == "select" && i.defaultValue != null && (i.value = Db(t.children).forEach(function(l) {
      l.props.selected = i.multiple ? i.defaultValue.indexOf(l.props.value) != -1 : i.defaultValue == l.props.value;
    })), t.class && !t.className ? (i.class = t.class, Object.defineProperty(i, "className", VVt)) : (t.className && !t.class || t.class && t.className) && (i.class = i.className = t.className), e.props = i;
  }(r), r.$$typeof = MVt, cCe && cCe(r);
};
var hCe = wt.__r;
wt.__r = function(r) {
  hCe && hCe(r), r.__c;
};
var dCe = wt.diffed;
wt.diffed = function(r) {
  dCe && dCe(r);
  var e = r.props, t = r.__e;
  t != null && r.type === "textarea" && "value" in e && e.value !== t.value && (t.value = e.value == null ? "" : e.value);
};
var HVt = 0;
function Ht(r, e, t, n, i, s) {
  var o, a, l = {};
  for (a in e) a == "ref" ? o = e[a] : l[a] = e[a];
  var c = { type: r, props: l, key: t, ref: o, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: --HVt, __i: -1, __u: 0, __source: i, __self: s };
  if (typeof r == "function" && (o = r.defaultProps)) for (a in o) l[a] === void 0 && (l[a] = o[a]);
  return wt.vnode && wt.vnode(c), c;
}
function BVt(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var SRe = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(r) {
  (function() {
    var e = {}.hasOwnProperty;
    function t() {
      for (var n = [], i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        if (s) {
          var o = typeof s;
          if (o === "string" || o === "number")
            n.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var a = t.apply(null, s);
              a && n.push(a);
            }
          } else if (o === "object") {
            if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]")) {
              n.push(s.toString());
              continue;
            }
            for (var l in s)
              e.call(s, l) && s[l] && n.push(l);
          }
        }
      }
      return n.join(" ");
    }
    r.exports ? (t.default = t, r.exports = t) : window.classNames = t;
  })();
})(SRe);
var PVt = SRe.exports, Wd = /* @__PURE__ */ BVt(PVt);
const MRe = 1024;
let FVt = 0, il = class {
  constructor(e, t) {
    this.from = e, this.to = t;
  }
};
class Xt {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = FVt++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = jr.match(e)), (t) => {
      let n = e(t);
      return n === void 0 ? null : [this, n];
    };
  }
}
Xt.closedBy = new Xt({ deserialize: (r) => r.split(" ") });
Xt.openedBy = new Xt({ deserialize: (r) => r.split(" ") });
Xt.group = new Xt({ deserialize: (r) => r.split(" ") });
Xt.isolate = new Xt({ deserialize: (r) => {
  if (r && r != "rtl" && r != "ltr" && r != "auto")
    throw new RangeError("Invalid value for isolate: " + r);
  return r || "auto";
} });
Xt.contextHash = new Xt({ perNode: !0 });
Xt.lookAhead = new Xt({ perNode: !0 });
Xt.mounted = new Xt({ perNode: !0 });
class S4 {
  constructor(e, t, n) {
    this.tree = e, this.overlay = t, this.parser = n;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[Xt.mounted.id];
  }
}
const zVt = /* @__PURE__ */ Object.create(null);
class jr {
  /**
  @internal
  */
  constructor(e, t, n, i = 0) {
    this.name = e, this.props = t, this.id = n, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let t = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : zVt, n = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new jr(e.name || "", t, e.id, n);
    if (e.props) {
      for (let s of e.props)
        if (Array.isArray(s) || (s = s(i)), s) {
          if (s[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          t[s[0].id] = s[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let t = this.prop(Xt.group);
      return t ? t.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let n in e)
      for (let i of n.split(" "))
        t[i] = e[n];
    return (n) => {
      for (let i = n.prop(Xt.group), s = -1; s < (i ? i.length : 0); s++) {
        let o = t[s < 0 ? n.name : i[s]];
        if (o)
          return o;
      }
    };
  }
}
jr.none = new jr(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class Gw {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].id != t)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let t = [];
    for (let n of this.types) {
      let i = null;
      for (let s of e) {
        let o = s(n);
        o && (i || (i = Object.assign({}, n.props)), i[o[0].id] = o[1]);
      }
      t.push(i ? new jr(n.name, i, n.id, n.flags) : n);
    }
    return new Gw(t);
  }
}
const k5 = /* @__PURE__ */ new WeakMap(), uCe = /* @__PURE__ */ new WeakMap();
var Vi;
(function(r) {
  r[r.ExcludeBuffers = 1] = "ExcludeBuffers", r[r.IncludeAnonymous = 2] = "IncludeAnonymous", r[r.IgnoreMounts = 4] = "IgnoreMounts", r[r.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Vi || (Vi = {}));
class ci {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, t, n, i, s) {
    if (this.type = e, this.children = t, this.positions = n, this.length = i, this.props = null, s && s.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, a] of s)
        this.props[typeof o == "number" ? o : o.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = S4.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let t = "";
    for (let n of this.children) {
      let i = n.toString();
      i && (t && (t += ","), t += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (t.length ? "(" + t + ")" : "") : t;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new Lb(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, t = 0, n = 0) {
    let i = k5.get(this) || this.topNode, s = new Lb(i);
    return s.moveTo(e, t), k5.set(this, s._tree), s;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new vh(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, t = 0) {
    let n = M4(k5.get(this) || this.topNode, e, t, !1);
    return k5.set(this, n), n;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, t = 0) {
    let n = M4(uCe.get(this) || this.topNode, e, t, !0);
    return uCe.set(this, n), n;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, t = 0) {
    return ZVt(this, e, t);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: t, leave: n, from: i = 0, to: s = this.length } = e, o = e.mode || 0, a = (o & Vi.IncludeAnonymous) > 0;
    for (let l = this.cursor(o | Vi.IncludeAnonymous); ; ) {
      let c = !1;
      if (l.from <= s && l.to >= i && (!a && l.type.isAnonymous || t(l) !== !1)) {
        if (l.firstChild())
          continue;
        c = !0;
      }
      for (; c && n && (a || !l.type.isAnonymous) && n(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let t in this.props)
        e.push([+t, this.props[t]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : VV(jr.none, this.children, this.positions, 0, this.children.length, 0, this.length, (t, n, i) => new ci(this.type, t, n, i, this.propValues), e.makeTree || ((t, n, i) => new ci(jr.none, t, n, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return UVt(e);
  }
}
ci.empty = new ci(jr.none, [], [], 0);
class OV {
  constructor(e, t) {
    this.buffer = e, this.index = t;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new OV(this.buffer, this.index);
  }
}
class y1 {
  /**
  Create a tree buffer.
  */
  constructor(e, t, n) {
    this.buffer = e, this.length = t, this.set = n;
  }
  /**
  @internal
  */
  get type() {
    return jr.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let t = 0; t < this.buffer.length; )
      e.push(this.childString(t)), t = this.buffer[t + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let t = this.buffer[e], n = this.buffer[e + 3], i = this.set.types[t], s = i.name;
    if (/\W/.test(s) && !i.isError && (s = JSON.stringify(s)), e += 4, n == e)
      return s;
    let o = [];
    for (; e < n; )
      o.push(this.childString(e)), e = this.buffer[e + 3];
    return s + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, t, n, i, s) {
    let { buffer: o } = this, a = -1;
    for (let l = e; l != t && !(DRe(s, i, o[l + 1], o[l + 2]) && (a = l, n > 0)); l = o[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, t, n) {
    let i = this.buffer, s = new Uint16Array(t - e), o = 0;
    for (let a = e, l = 0; a < t; ) {
      s[l++] = i[a++], s[l++] = i[a++] - n;
      let c = s[l++] = i[a++] - n;
      s[l++] = i[a++] - e, o = Math.max(o, c);
    }
    return new y1(s, o, this.set);
  }
}
function DRe(r, e, t, n) {
  switch (r) {
    case -2:
      return t < e;
    case -1:
      return n >= e && t < e;
    case 0:
      return t < e && n > e;
    case 1:
      return t <= e && n > e;
    case 2:
      return n > e;
    case 4:
      return !0;
  }
}
function M4(r, e, t, n) {
  for (var i; r.from == r.to || (t < 1 ? r.from >= e : r.from > e) || (t > -1 ? r.to <= e : r.to < e); ) {
    let o = !n && r instanceof vh && r.index < 0 ? null : r.parent;
    if (!o)
      return r;
    r = o;
  }
  let s = n ? 0 : Vi.IgnoreOverlays;
  if (n)
    for (let o = r, a = o.parent; a; o = a, a = o.parent)
      o instanceof vh && o.index < 0 && ((i = a.enter(e, t, s)) === null || i === void 0 ? void 0 : i.from) != o.from && (r = a);
  for (; ; ) {
    let o = r.enter(e, t, s);
    if (!o)
      return r;
    r = o;
  }
}
class LRe {
  cursor(e = 0) {
    return new Lb(this, e);
  }
  getChild(e, t = null, n = null) {
    let i = fCe(this, e, t, n);
    return i.length ? i[0] : null;
  }
  getChildren(e, t = null, n = null) {
    return fCe(this, e, t, n);
  }
  resolve(e, t = 0) {
    return M4(this, e, t, !1);
  }
  resolveInner(e, t = 0) {
    return M4(this, e, t, !0);
  }
  matchContext(e) {
    return HN(this, e);
  }
  enterUnfinishedNodesBefore(e) {
    let t = this.childBefore(e), n = this;
    for (; t; ) {
      let i = t.lastChild;
      if (!i || i.to != t.to)
        break;
      i.type.isError && i.from == i.to ? (n = t, t = i.prevSibling) : t = i;
    }
    return n;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
let vh = class K6 extends LRe {
  constructor(e, t, n, i) {
    super(), this._tree = e, this.from = t, this.index = n, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, t, n, i, s = 0) {
    for (let o = this; ; ) {
      for (let { children: a, positions: l } = o._tree, c = t > 0 ? a.length : -1; e != c; e += t) {
        let d = a[e], u = l[e] + o.from;
        if (DRe(i, n, u, u + d.length)) {
          if (d instanceof y1) {
            if (s & Vi.ExcludeBuffers)
              continue;
            let f = d.findChild(0, d.buffer.length, t, n - u, i);
            if (f > -1)
              return new ju(new WVt(o, d, e, u), null, f);
          } else if (s & Vi.IncludeAnonymous || !d.type.isAnonymous || RV(d)) {
            let f;
            if (!(s & Vi.IgnoreMounts) && (f = S4.get(d)) && !f.overlay)
              return new K6(f.tree, u, e, o);
            let p = new K6(d, u, e, o);
            return s & Vi.IncludeAnonymous || !p.type.isAnonymous ? p : p.nextChild(t < 0 ? d.children.length - 1 : 0, t, n, i);
          }
        }
      }
      if (s & Vi.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? e = o.index + t : e = t < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, n = 0) {
    let i;
    if (!(n & Vi.IgnoreOverlays) && (i = S4.get(this._tree)) && i.overlay) {
      let s = e - this.from;
      for (let { from: o, to: a } of i.overlay)
        if ((t > 0 ? o <= s : o < s) && (t < 0 ? a >= s : a > s))
          return new K6(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, t, n);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
};
function fCe(r, e, t, n) {
  let i = r.cursor(), s = [];
  if (!i.firstChild())
    return s;
  if (t != null) {
    for (; !i.type.is(t); )
      if (!i.nextSibling())
        return s;
  }
  for (; ; ) {
    if (n != null && i.type.is(n))
      return s;
    if (i.type.is(e) && s.push(i.node), !i.nextSibling())
      return n == null ? s : [];
  }
}
function HN(r, e, t = e.length - 1) {
  for (let n = r.parent; t >= 0; n = n.parent) {
    if (!n)
      return !1;
    if (!n.type.isAnonymous) {
      if (e[t] && e[t] != n.name)
        return !1;
      t--;
    }
  }
  return !0;
}
class WVt {
  constructor(e, t, n, i) {
    this.parent = e, this.buffer = t, this.index = n, this.start = i;
  }
}
class ju extends LRe {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, t, n) {
    super(), this.context = e, this._parent = t, this.index = n, this.type = e.buffer.set.types[e.buffer.buffer[n]];
  }
  child(e, t, n) {
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.context.start, n);
    return s < 0 ? null : new ju(this.context, this, s);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, n = 0) {
    if (n & Vi.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], t > 0 ? 1 : -1, e - this.context.start, t);
    return s < 0 ? null : new ju(this.context, this, s);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, t = e.buffer[this.index + 3];
    return t < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new ju(this.context, this._parent, t) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, t = this._parent ? this._parent.index + 4 : 0;
    return this.index == t ? this.externalSibling(-1) : new ju(this.context, this._parent, e.findChild(
      t,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], t = [], { buffer: n } = this.context, i = this.index + 4, s = n.buffer[this.index + 3];
    if (s > i) {
      let o = n.buffer[this.index + 1];
      e.push(n.slice(i, s, o)), t.push(0);
    }
    return new ci(this.type, e, t, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function kRe(r) {
  if (!r.length)
    return null;
  let e = 0, t = r[0];
  for (let s = 1; s < r.length; s++) {
    let o = r[s];
    (o.from > t.from || o.to < t.to) && (t = o, e = s);
  }
  let n = t instanceof vh && t.index < 0 ? null : t.parent, i = r.slice();
  return n ? i[e] = n : i.splice(e, 1), new jVt(i, t);
}
class jVt {
  constructor(e, t) {
    this.heads = e, this.node = t;
  }
  get next() {
    return kRe(this.heads);
  }
}
function ZVt(r, e, t) {
  let n = r.resolveInner(e, t), i = null;
  for (let s = n instanceof vh ? n : n.context.parent; s; s = s.parent)
    if (s.index < 0) {
      let o = s.parent;
      (i || (i = [n])).push(o.resolve(e, t)), s = o;
    } else {
      let o = S4.get(s.tree);
      if (o && o.overlay && o.overlay[0].from <= e && o.overlay[o.overlay.length - 1].to >= e) {
        let a = new vh(o.tree, o.overlay[0].from + s.from, -1, s);
        (i || (i = [n])).push(M4(a, e, t, !1));
      }
    }
  return i ? kRe(i) : n;
}
class Lb {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, t = 0) {
    if (this.mode = t, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof vh)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let n = e._parent; n; n = n._parent)
        this.stack.unshift(n.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, t) {
    this.index = e;
    let { start: n, buffer: i } = this.buffer;
    return this.type = t || i.set.types[i.buffer[e]], this.from = n + i.buffer[e + 1], this.to = n + i.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof vh ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, t, n) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, n, this.mode));
    let { buffer: i } = this.buffer, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.buffer.start, n);
    return s < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(s));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, t, n = this.mode) {
    return this.buffer ? n & Vi.ExcludeBuffers ? !1 : this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, n));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Vi.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & Vi.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: t } = this.buffer, n = this.stack.length - 1;
    if (e < 0) {
      let i = n < 0 ? 0 : this.stack[n] + 4;
      if (this.index != i)
        return this.yieldBuf(t.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = t.buffer[this.index + 3];
      if (i < (n < 0 ? t.buffer.length : t.buffer[this.stack[n] + 3]))
        return this.yieldBuf(i);
    }
    return n < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let t, n, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let s = 0; s < this.index; s++)
          if (i.buffer.buffer[s + 3] < this.index)
            return !1;
      ({ index: t, parent: n } = i);
    } else
      ({ index: t, _parent: n } = this._tree);
    for (; n; { index: t, _parent: n } = n)
      if (t > -1)
        for (let s = t + e, o = e < 0 ? -1 : n._tree.children.length; s != o; s += e) {
          let a = n._tree.children[s];
          if (this.mode & Vi.IncludeAnonymous || a instanceof y1 || !a.type.isAnonymous || RV(a))
            return !1;
        }
    return !0;
  }
  move(e, t) {
    if (t && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traveral. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, t = 0) {
    for (; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, t); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, t = null, n = 0;
    if (e && e.context == this.buffer)
      e: for (let i = this.index, s = this.stack.length; s >= 0; ) {
        for (let o = e; o; o = o._parent)
          if (o.index == i) {
            if (i == this.index)
              return o;
            t = o, n = s + 1;
            break e;
          }
        i = this.stack[--s];
      }
    for (let i = n; i < this.stack.length; i++)
      t = new ju(this.buffer, t, this.stack[i]);
    return this.bufferNode = new ju(this.buffer, t, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, t) {
    for (let n = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          n++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; i && t && t(this), i = this.type.isAnonymous, !this.nextSibling(); ) {
        if (!n)
          return;
        this.parent(), n--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return HN(this.node, e);
    let { buffer: t } = this.buffer, { types: n } = t.set;
    for (let i = e.length - 1, s = this.stack.length - 1; i >= 0; s--) {
      if (s < 0)
        return HN(this.node, e, i);
      let o = n[t.buffer[this.stack[s]]];
      if (!o.isAnonymous) {
        if (e[i] && e[i] != o.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function RV(r) {
  return r.children.some((e) => e instanceof y1 || !e.type.isAnonymous || RV(e));
}
function UVt(r) {
  var e;
  let { buffer: t, nodeSet: n, maxBufferLength: i = MRe, reused: s = [], minRepeatType: o = n.types.length } = r, a = Array.isArray(t) ? new OV(t, t.length) : t, l = n.types, c = 0, d = 0;
  function u(S, D, M, L, T, B) {
    let { id: V, start: N, end: R, size: H } = a, z = d;
    for (; H < 0; )
      if (a.next(), H == -1) {
        let te = s[V];
        M.push(te), L.push(N - S);
        return;
      } else if (H == -3) {
        c = V;
        return;
      } else if (H == -4) {
        d = V;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${H}`);
    let U = l[V], ee, ce, se = N - S;
    if (R - N <= i && (ce = A(a.pos - D, T))) {
      let te = new Uint16Array(ce.size - ce.skip), ue = a.pos - ce.size, G = te.length;
      for (; a.pos > ue; )
        G = w(ce.start, te, G);
      ee = new y1(te, R - ce.start, n), se = ce.start - S;
    } else {
      let te = a.pos - H;
      a.next();
      let ue = [], G = [], j = V >= o ? V : -1, pe = 0, De = R;
      for (; a.pos > te; )
        j >= 0 && a.id == j && a.size >= 0 ? (a.end <= De - i && (g(ue, G, N, pe, a.end, De, j, z), pe = ue.length, De = a.end), a.next()) : B > 2500 ? f(N, te, ue, G) : u(N, te, ue, G, j, B + 1);
      if (j >= 0 && pe > 0 && pe < ue.length && g(ue, G, N, pe, N, De, j, z), ue.reverse(), G.reverse(), j > -1 && pe > 0) {
        let Ce = p(U);
        ee = VV(U, ue, G, 0, ue.length, 0, R - N, Ce, Ce);
      } else
        ee = m(U, ue, G, R - N, z - R);
    }
    M.push(ee), L.push(se);
  }
  function f(S, D, M, L) {
    let T = [], B = 0, V = -1;
    for (; a.pos > D; ) {
      let { id: N, start: R, end: H, size: z } = a;
      if (z > 4)
        a.next();
      else {
        if (V > -1 && R < V)
          break;
        V < 0 && (V = H - i), T.push(N, R, H), B++, a.next();
      }
    }
    if (B) {
      let N = new Uint16Array(B * 4), R = T[T.length - 2];
      for (let H = T.length - 3, z = 0; H >= 0; H -= 3)
        N[z++] = T[H], N[z++] = T[H + 1] - R, N[z++] = T[H + 2] - R, N[z++] = z;
      M.push(new y1(N, T[2] - R, n)), L.push(R - S);
    }
  }
  function p(S) {
    return (D, M, L) => {
      let T = 0, B = D.length - 1, V, N;
      if (B >= 0 && (V = D[B]) instanceof ci) {
        if (!B && V.type == S && V.length == L)
          return V;
        (N = V.prop(Xt.lookAhead)) && (T = M[B] + V.length + N);
      }
      return m(S, D, M, L, T);
    };
  }
  function g(S, D, M, L, T, B, V, N) {
    let R = [], H = [];
    for (; S.length > L; )
      R.push(S.pop()), H.push(D.pop() + M - T);
    S.push(m(n.types[V], R, H, B - T, N - B)), D.push(T - M);
  }
  function m(S, D, M, L, T = 0, B) {
    if (c) {
      let V = [Xt.contextHash, c];
      B = B ? [V].concat(B) : [V];
    }
    if (T > 25) {
      let V = [Xt.lookAhead, T];
      B = B ? [V].concat(B) : [V];
    }
    return new ci(S, D, M, L, B);
  }
  function A(S, D) {
    let M = a.fork(), L = 0, T = 0, B = 0, V = M.end - i, N = { size: 0, start: 0, skip: 0 };
    e: for (let R = M.pos - S; M.pos > R; ) {
      let H = M.size;
      if (M.id == D && H >= 0) {
        N.size = L, N.start = T, N.skip = B, B += 4, L += 4, M.next();
        continue;
      }
      let z = M.pos - H;
      if (H < 0 || z < R || M.start < V)
        break;
      let U = M.id >= o ? 4 : 0, ee = M.start;
      for (M.next(); M.pos > z; ) {
        if (M.size < 0)
          if (M.size == -3)
            U += 4;
          else
            break e;
        else M.id >= o && (U += 4);
        M.next();
      }
      T = ee, L += H, B += U;
    }
    return (D < 0 || L == S) && (N.size = L, N.start = T, N.skip = B), N.size > 4 ? N : void 0;
  }
  function w(S, D, M) {
    let { id: L, start: T, end: B, size: V } = a;
    if (a.next(), V >= 0 && L < o) {
      let N = M;
      if (V > 4) {
        let R = a.pos - (V - 4);
        for (; a.pos > R; )
          M = w(S, D, M);
      }
      D[--M] = N, D[--M] = B - S, D[--M] = T - S, D[--M] = L;
    } else V == -3 ? c = L : V == -4 && (d = L);
    return M;
  }
  let v = [], y = [];
  for (; a.pos > 0; )
    u(r.start || 0, r.bufferStart || 0, v, y, -1, 0);
  let _ = (e = r.length) !== null && e !== void 0 ? e : v.length ? y[0] + v[0].length : 0;
  return new ci(l[r.topID], v.reverse(), y.reverse(), _);
}
const pCe = /* @__PURE__ */ new WeakMap();
function Y6(r, e) {
  if (!r.isAnonymous || e instanceof y1 || e.type != r)
    return 1;
  let t = pCe.get(e);
  if (t == null) {
    t = 1;
    for (let n of e.children) {
      if (n.type != r || !(n instanceof ci)) {
        t = 1;
        break;
      }
      t += Y6(r, n);
    }
    pCe.set(e, t);
  }
  return t;
}
function VV(r, e, t, n, i, s, o, a, l) {
  let c = 0;
  for (let g = n; g < i; g++)
    c += Y6(r, e[g]);
  let d = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), u = [], f = [];
  function p(g, m, A, w, v) {
    for (let y = A; y < w; ) {
      let _ = y, S = m[y], D = Y6(r, g[y]);
      for (y++; y < w; y++) {
        let M = Y6(r, g[y]);
        if (D + M >= d)
          break;
        D += M;
      }
      if (y == _ + 1) {
        if (D > d) {
          let M = g[_];
          p(M.children, M.positions, 0, M.children.length, m[_] + v);
          continue;
        }
        u.push(g[_]);
      } else {
        let M = m[y - 1] + g[y - 1].length - S;
        u.push(VV(r, g, m, _, y, S, M, null, l));
      }
      f.push(S + v - s);
    }
  }
  return p(e, t, n, i, 0), (a || l)(u, f, o);
}
class Td {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, t, n, i, s = !1, o = !1) {
    this.from = e, this.to = t, this.tree = n, this.offset = i, this.open = (s ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, t = [], n = !1) {
    let i = [new Td(0, e.length, e, 0, !1, n)];
    for (let s of t)
      s.to > e.length && i.push(s);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, t, n = 128) {
    if (!t.length)
      return e;
    let i = [], s = 1, o = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0; ; a++) {
      let d = a < t.length ? t[a] : null, u = d ? d.fromA : 1e9;
      if (u - l >= n)
        for (; o && o.from < u; ) {
          let f = o;
          if (l >= f.from || u <= f.to || c) {
            let p = Math.max(f.from, l) - c, g = Math.min(f.to, u) - c;
            f = p >= g ? null : new Td(p, g, f.tree, f.offset + c, a > 0, !!d);
          }
          if (f && i.push(f), o.to > u)
            break;
          o = s < e.length ? e[s++] : null;
        }
      if (!d)
        break;
      l = d.toA, c = d.toA - d.toB;
    }
    return i;
  }
}
class HV {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, t, n) {
    return typeof e == "string" && (e = new qVt(e)), n = n ? n.length ? n.map((i) => new il(i.from, i.to)) : [new il(0, 0)] : [new il(0, e.length)], this.createParse(e, t || [], n);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, t, n) {
    let i = this.startParse(e, t, n);
    for (; ; ) {
      let s = i.advance();
      if (s)
        return s;
    }
  }
}
class qVt {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, t) {
    return this.string.slice(e, t);
  }
}
function GVt(r) {
  return (e, t, n, i) => new KVt(e, r, t, n, i);
}
class gCe {
  constructor(e, t, n, i, s) {
    this.parser = e, this.parse = t, this.overlay = n, this.target = i, this.from = s;
  }
}
function mCe(r) {
  if (!r.length || r.some((e) => e.from >= e.to))
    throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(r));
}
class QVt {
  constructor(e, t, n, i, s, o, a) {
    this.parser = e, this.predicate = t, this.mounts = n, this.index = i, this.start = s, this.target = o, this.prev = a, this.depth = 0, this.ranges = [];
  }
}
const BN = new Xt({ perNode: !0 });
class KVt {
  constructor(e, t, n, i, s) {
    this.nest = t, this.input = n, this.fragments = i, this.ranges = s, this.inner = [], this.innerDone = 0, this.baseTree = null, this.stoppedAt = null, this.baseParse = e;
  }
  advance() {
    if (this.baseParse) {
      let n = this.baseParse.advance();
      if (!n)
        return null;
      if (this.baseParse = null, this.baseTree = n, this.startInner(), this.stoppedAt != null)
        for (let i of this.inner)
          i.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let n = this.baseTree;
      return this.stoppedAt != null && (n = new ci(n.type, n.children, n.positions, n.length, n.propValues.concat([[BN, this.stoppedAt]]))), n;
    }
    let e = this.inner[this.innerDone], t = e.parse.advance();
    if (t) {
      this.innerDone++;
      let n = Object.assign(/* @__PURE__ */ Object.create(null), e.target.props);
      n[Xt.mounted.id] = new S4(t, e.overlay, e.parser), e.target.props = n;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let e = this.input.length;
    for (let t = this.innerDone; t < this.inner.length; t++)
      this.inner[t].from < e && (e = Math.min(e, this.inner[t].parse.parsedPos));
    return e;
  }
  stopAt(e) {
    if (this.stoppedAt = e, this.baseParse)
      this.baseParse.stopAt(e);
    else
      for (let t = this.innerDone; t < this.inner.length; t++)
        this.inner[t].parse.stopAt(e);
  }
  startInner() {
    let e = new JVt(this.fragments), t = null, n = null, i = new Lb(new vh(this.baseTree, this.ranges[0].from, 0, null), Vi.IncludeAnonymous | Vi.IgnoreMounts);
    e: for (let s, o; ; ) {
      let a = !0, l;
      if (this.stoppedAt != null && i.from >= this.stoppedAt)
        a = !1;
      else if (e.hasNode(i)) {
        if (t) {
          let c = t.mounts.find((d) => d.frag.from <= i.from && d.frag.to >= i.to && d.mount.overlay);
          if (c)
            for (let d of c.mount.overlay) {
              let u = d.from + c.pos, f = d.to + c.pos;
              u >= i.from && f <= i.to && !t.ranges.some((p) => p.from < f && p.to > u) && t.ranges.push({ from: u, to: f });
            }
        }
        a = !1;
      } else if (n && (o = YVt(n.ranges, i.from, i.to)))
        a = o != 2;
      else if (!i.type.isAnonymous && (s = this.nest(i, this.input)) && (i.from < i.to || !s.overlay)) {
        i.tree || XVt(i);
        let c = e.findMounts(i.from, s.parser);
        if (typeof s.overlay == "function")
          t = new QVt(s.parser, s.overlay, c, this.inner.length, i.from, i.tree, t);
        else {
          let d = vCe(this.ranges, s.overlay || (i.from < i.to ? [new il(i.from, i.to)] : []));
          d.length && mCe(d), (d.length || !s.overlay) && this.inner.push(new gCe(s.parser, d.length ? s.parser.startParse(this.input, bCe(c, d), d) : s.parser.startParse(""), s.overlay ? s.overlay.map((u) => new il(u.from - i.from, u.to - i.from)) : null, i.tree, d.length ? d[0].from : i.from)), s.overlay ? d.length && (n = { ranges: d, depth: 0, prev: n }) : a = !1;
        }
      } else t && (l = t.predicate(i)) && (l === !0 && (l = new il(i.from, i.to)), l.from < l.to && t.ranges.push(l));
      if (a && i.firstChild())
        t && t.depth++, n && n.depth++;
      else
        for (; !i.nextSibling(); ) {
          if (!i.parent())
            break e;
          if (t && !--t.depth) {
            let c = vCe(this.ranges, t.ranges);
            c.length && (mCe(c), this.inner.splice(t.index, 0, new gCe(t.parser, t.parser.startParse(this.input, bCe(t.mounts, c), c), t.ranges.map((d) => new il(d.from - t.start, d.to - t.start)), t.target, c[0].from))), t = t.prev;
          }
          n && !--n.depth && (n = n.prev);
        }
    }
  }
}
function YVt(r, e, t) {
  for (let n of r) {
    if (n.from >= t)
      break;
    if (n.to > e)
      return n.from <= e && n.to >= t ? 2 : 1;
  }
  return 0;
}
function ACe(r, e, t, n, i, s) {
  if (e < t) {
    let o = r.buffer[e + 1];
    n.push(r.slice(e, t, o)), i.push(o - s);
  }
}
function XVt(r) {
  let { node: e } = r, t = [], n = e.context.buffer;
  do
    t.push(r.index), r.parent();
  while (!r.tree);
  let i = r.tree, s = i.children.indexOf(n), o = i.children[s], a = o.buffer, l = [s];
  function c(d, u, f, p, g, m) {
    let A = t[m], w = [], v = [];
    ACe(o, d, A, w, v, p);
    let y = a[A + 1], _ = a[A + 2];
    l.push(w.length);
    let S = m ? c(A + 4, a[A + 3], o.set.types[a[A]], y, _ - y, m - 1) : e.toTree();
    return w.push(S), v.push(y - p), ACe(o, a[A + 3], u, w, v, p), new ci(f, w, v, g);
  }
  i.children[s] = c(0, a.length, jr.none, 0, o.length, t.length - 1);
  for (let d of l) {
    let u = r.tree.children[d], f = r.tree.positions[d];
    r.yield(new vh(u, f + r.from, d, r._tree));
  }
}
class wCe {
  constructor(e, t) {
    this.offset = t, this.done = !1, this.cursor = e.cursor(Vi.IncludeAnonymous | Vi.IgnoreMounts);
  }
  // Move to the first node (in pre-order) that starts at or after `pos`.
  moveTo(e) {
    let { cursor: t } = this, n = e - this.offset;
    for (; !this.done && t.from < n; )
      t.to >= e && t.enter(n, 1, Vi.IgnoreOverlays | Vi.ExcludeBuffers) || t.next(!1) || (this.done = !0);
  }
  hasNode(e) {
    if (this.moveTo(e.from), !this.done && this.cursor.from + this.offset == e.from && this.cursor.tree)
      for (let t = this.cursor.tree; ; ) {
        if (t == e.tree)
          return !0;
        if (t.children.length && t.positions[0] == 0 && t.children[0] instanceof ci)
          t = t.children[0];
        else
          break;
      }
    return !1;
  }
}
let JVt = class {
  constructor(e) {
    var t;
    if (this.fragments = e, this.curTo = 0, this.fragI = 0, e.length) {
      let n = this.curFrag = e[0];
      this.curTo = (t = n.tree.prop(BN)) !== null && t !== void 0 ? t : n.to, this.inner = new wCe(n.tree, -n.offset);
    } else
      this.curFrag = this.inner = null;
  }
  hasNode(e) {
    for (; this.curFrag && e.from >= this.curTo; )
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= e.from && this.curTo >= e.to && this.inner.hasNode(e);
  }
  nextFrag() {
    var e;
    if (this.fragI++, this.fragI == this.fragments.length)
      this.curFrag = this.inner = null;
    else {
      let t = this.curFrag = this.fragments[this.fragI];
      this.curTo = (e = t.tree.prop(BN)) !== null && e !== void 0 ? e : t.to, this.inner = new wCe(t.tree, -t.offset);
    }
  }
  findMounts(e, t) {
    var n;
    let i = [];
    if (this.inner) {
      this.inner.cursor.moveTo(e, 1);
      for (let s = this.inner.cursor.node; s; s = s.parent) {
        let o = (n = s.tree) === null || n === void 0 ? void 0 : n.prop(Xt.mounted);
        if (o && o.parser == t)
          for (let a = this.fragI; a < this.fragments.length; a++) {
            let l = this.fragments[a];
            if (l.from >= s.to)
              break;
            l.tree == this.curFrag.tree && i.push({
              frag: l,
              pos: s.from - l.offset,
              mount: o
            });
          }
      }
    }
    return i;
  }
};
function vCe(r, e) {
  let t = null, n = e;
  for (let i = 1, s = 0; i < r.length; i++) {
    let o = r[i - 1].to, a = r[i].from;
    for (; s < n.length; s++) {
      let l = n[s];
      if (l.from >= a)
        break;
      l.to <= o || (t || (n = t = e.slice()), l.from < o ? (t[s] = new il(l.from, o), l.to > a && t.splice(s + 1, 0, new il(a, l.to))) : l.to > a ? t[s--] = new il(a, l.to) : t.splice(s--, 1));
    }
  }
  return n;
}
function $Vt(r, e, t, n) {
  let i = 0, s = 0, o = !1, a = !1, l = -1e9, c = [];
  for (; ; ) {
    let d = i == r.length ? 1e9 : o ? r[i].to : r[i].from, u = s == e.length ? 1e9 : a ? e[s].to : e[s].from;
    if (o != a) {
      let f = Math.max(l, t), p = Math.min(d, u, n);
      f < p && c.push(new il(f, p));
    }
    if (l = Math.min(d, u), l == 1e9)
      break;
    d == l && (o ? (o = !1, i++) : o = !0), u == l && (a ? (a = !1, s++) : a = !0);
  }
  return c;
}
function bCe(r, e) {
  let t = [];
  for (let { pos: n, mount: i, frag: s } of r) {
    let o = n + (i.overlay ? i.overlay[0].from : 0), a = o + i.tree.length, l = Math.max(s.from, o), c = Math.min(s.to, a);
    if (i.overlay) {
      let d = i.overlay.map((f) => new il(f.from + n, f.to + n)), u = $Vt(e, d, l, c);
      for (let f = 0, p = l; ; f++) {
        let g = f == u.length, m = g ? c : u[f].from;
        if (m > p && t.push(new Td(p, m, i.tree, -o, s.from >= p || s.openStart, s.to <= m || s.openEnd)), g)
          break;
        p = u[f].to;
      }
    } else
      t.push(new Td(l, c, i.tree, -o, s.from >= o || s.openStart, s.to <= a || s.openEnd));
  }
  return t;
}
let eHt = class PN {
  /**
  @internal
  */
  constructor(e, t, n, i, s, o, a, l, c, d = 0, u) {
    this.p = e, this.stack = t, this.state = n, this.reducePos = i, this.pos = s, this.score = o, this.buffer = a, this.bufferBase = l, this.curContext = c, this.lookAhead = d, this.parent = u;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, t) => t % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, t, n = 0) {
    let i = e.parser.context;
    return new PN(e, [], t, n, n, 0, [], 0, i ? new yCe(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, t) {
    this.stack.push(this.state, t, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var t;
    let n = e >> 19, i = e & 65535, { parser: s } = this.p, o = s.dynamicPrecedence(i);
    if (o && (this.score += o), n == 0) {
      this.pushState(s.getGoto(this.state, i, !0), this.reducePos), i < s.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let a = this.stack.length - (n - 1) * 3 - (e & 262144 ? 6 : 0), l = a ? this.stack[a - 2] : this.p.ranges[0].from, c = this.reducePos - l;
    c >= 2e3 && !(!((t = this.p.parser.nodeSet.types[i]) === null || t === void 0) && t.isAnonymous) && (l == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = c) : this.p.lastBigReductionSize < c && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = l, this.p.lastBigReductionSize = c));
    let d = a ? this.stack[a - 1] : 0, u = this.bufferBase + this.buffer.length - d;
    if (i < s.minRepeatTerm || e & 131072) {
      let f = s.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, l, f, u + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[a];
    else {
      let f = this.stack[a - 3];
      this.state = s.getGoto(f, i, !0);
    }
    for (; this.stack.length > a; )
      this.stack.pop();
    this.reduceContext(i, l);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, t, n, i = 4, s = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this, a = this.buffer.length;
      if (a == 0 && o.parent && (a = o.bufferBase - o.parent.bufferBase, o = o.parent), a > 0 && o.buffer[a - 4] == 0 && o.buffer[a - 1] > -1) {
        if (t == n)
          return;
        if (o.buffer[a - 2] >= t) {
          o.buffer[a - 2] = n;
          return;
        }
      }
    }
    if (!s || this.pos == n)
      this.buffer.push(e, t, n, i);
    else {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] != 0)
        for (; o > 0 && this.buffer[o - 2] > n; )
          this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, i > 4 && (i -= 4);
      this.buffer[o] = e, this.buffer[o + 1] = t, this.buffer[o + 2] = n, this.buffer[o + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, t, n, i) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if ((e & 262144) == 0) {
      let s = e, { parser: o } = this.p;
      (i > this.pos || t <= o.maxNode) && (this.pos = i, o.stateFlag(
        s,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(s, n), this.shiftContext(t, n), t <= o.maxNode && this.buffer.push(t, n, i, 4);
    } else
      this.pos = i, this.shiftContext(t, n), t <= this.p.parser.maxNode && this.buffer.push(t, n, i, 4);
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, t, n, i) {
    e & 65536 ? this.reduce(e) : this.shift(e, t, n, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, t) {
    let n = this.p.reused.length - 1;
    (n < 0 || this.p.reused[n] != e) && (this.p.reused.push(e), n++);
    let i = this.pos;
    this.reducePos = this.pos = i + e.length, this.pushState(t, i), this.buffer.push(
      n,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, t = e.buffer.length;
    for (; t > 0 && e.buffer[t - 2] > e.reducePos; )
      t -= 4;
    let n = e.buffer.slice(t), i = e.bufferBase + t;
    for (; e && i == e.bufferBase; )
      e = e.parent;
    return new PN(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, n, i, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, t) {
    let n = e <= this.p.parser.maxNode;
    n && this.storeNode(e, this.pos, t, 4), this.storeNode(0, this.pos, t, n ? 8 : 4), this.pos = this.reducePos = t, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let t = new tHt(this); ; ) {
      let n = this.p.parser.stateSlot(
        t.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(t.state, e);
      if (n == 0)
        return !1;
      if ((n & 65536) == 0)
        return !0;
      t.reduce(n);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let t = this.p.parser.nextStates(this.state);
    if (t.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let s = 0, o; s < t.length; s += 2)
        (o = t[s + 1]) != this.state && this.p.parser.hasAction(o, e) && i.push(t[s], o);
      if (this.stack.length < 120)
        for (let s = 0; i.length < 8 && s < t.length; s += 2) {
          let o = t[s + 1];
          i.some((a, l) => l & 1 && a == o) || i.push(t[s], o);
        }
      t = i;
    }
    let n = [];
    for (let i = 0; i < t.length && n.length < 4; i += 2) {
      let s = t[i + 1];
      if (s == this.state)
        continue;
      let o = this.split();
      o.pushState(s, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(t[i], this.pos), o.reducePos = this.pos, o.score -= 200, n.push(o);
    }
    return n;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, t = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((t & 65536) == 0)
      return !1;
    if (!e.validAction(this.state, t)) {
      let n = t >> 19, i = t & 65535, s = this.stack.length - n * 3;
      if (s < 0 || e.getGoto(this.stack[s], i, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null)
          return !1;
        t = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(t), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, t = [], n = (i, s) => {
      if (!t.includes(i))
        return t.push(i), e.allActions(i, (o) => {
          if (!(o & 393216)) if (o & 65536) {
            let a = (o >> 19) - s;
            if (a > 1) {
              let l = o & 65535, c = this.stack.length - a * 3;
              if (c >= 0 && e.getGoto(this.stack[c], l, !1) >= 0)
                return a << 19 | 65536 | l;
            }
          } else {
            let a = n(o, s + 1);
            if (a != null)
              return a;
          }
        });
    };
    return n(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let t = 0; t < this.stack.length; t += 3)
      if (this.stack[t] != e.stack[t])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, t) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)));
  }
  reduceContext(e, t) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let t = new yCe(this.curContext.tracker, e);
      t.hash != this.curContext.hash && this.emitContext(), this.curContext = t;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
};
class yCe {
  constructor(e, t) {
    this.tracker = e, this.context = t, this.hash = e.strict ? e.hash(t) : 0;
  }
}
class tHt {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let t = e & 65535, n = e >> 19;
    n == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (n - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
    this.state = i;
  }
}
class kb {
  constructor(e, t, n) {
    this.stack = e, this.pos = t, this.index = n, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, t = e.bufferBase + e.buffer.length) {
    return new kb(e, t, t - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new kb(this.stack, this.pos, this.index);
  }
}
function N5(r, e = Uint16Array) {
  if (typeof r != "string")
    return r;
  let t = null;
  for (let n = 0, i = 0; n < r.length; ) {
    let s = 0;
    for (; ; ) {
      let o = r.charCodeAt(n++), a = !1;
      if (o == 126) {
        s = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let l = o - 32;
      if (l >= 46 && (l -= 46, a = !0), s += l, a)
        break;
      s *= 46;
    }
    t ? t[i++] = s : t = new e(s);
  }
  return t;
}
class X6 {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const CCe = new X6();
class nHt {
  /**
  @internal
  */
  constructor(e, t) {
    this.input = e, this.ranges = t, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = CCe, this.rangeIndex = 0, this.pos = this.chunkPos = t[0].from, this.range = t[0], this.end = t[t.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, t) {
    let n = this.range, i = this.rangeIndex, s = this.pos + e;
    for (; s < n.from; ) {
      if (!i)
        return null;
      let o = this.ranges[--i];
      s -= n.from - o.to, n = o;
    }
    for (; t < 0 ? s > n.to : s >= n.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let o = this.ranges[++i];
      s += o.from - n.to, n = o;
    }
    return s;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let t of this.ranges)
      if (t.to > e)
        return Math.max(e, t.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let t = this.chunkOff + e, n, i;
    if (t >= 0 && t < this.chunk.length)
      n = this.pos + e, i = this.chunk.charCodeAt(t);
    else {
      let s = this.resolveOffset(e, 1);
      if (s == null)
        return -1;
      if (n = s, n >= this.chunk2Pos && n < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(n - this.chunk2Pos);
      else {
        let o = this.rangeIndex, a = this.range;
        for (; a.to <= n; )
          a = this.ranges[++o];
        this.chunk2 = this.input.chunk(this.chunk2Pos = n), n + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - n)), i = this.chunk2.charCodeAt(0);
      }
    }
    return n >= this.token.lookAhead && (this.token.lookAhead = n + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, t = 0) {
    let n = t ? this.resolveOffset(t, -1) : this.pos;
    if (n == null || n < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = n;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(e, t) {
    this.token.value = e, this.token.end = t;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: t } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = t, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), t = this.pos + e.length;
      this.chunk = t > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, t) {
    if (t ? (this.token = t, t.start = e, t.lookAhead = e + 1, t.value = t.extended = -1) : this.token = CCe, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, t) {
    if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
    if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
    if (e >= this.range.from && t <= this.range.to)
      return this.input.read(e, t);
    let n = "";
    for (let i of this.ranges) {
      if (i.from >= t)
        break;
      i.to > e && (n += this.input.read(Math.max(i.from, e), Math.min(i.to, t)));
    }
    return n;
  }
}
class Bp {
  constructor(e, t) {
    this.data = e, this.id = t;
  }
  token(e, t) {
    let { parser: n } = t.p;
    iHt(this.data, e, t, this.id, n.data, n.tokenPrecTable);
  }
}
Bp.prototype.contextual = Bp.prototype.fallback = Bp.prototype.extend = !1;
Bp.prototype.fallback = Bp.prototype.extend = !1;
class wm {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(e, t = {}) {
    this.token = e, this.contextual = !!t.contextual, this.fallback = !!t.fallback, this.extend = !!t.extend;
  }
}
function iHt(r, e, t, n, i, s) {
  let o = 0, a = 1 << n, { dialect: l } = t.p.parser;
  e: for (; (a & r[o]) != 0; ) {
    let c = r[o + 1];
    for (let p = o + 3; p < c; p += 2)
      if ((r[p + 1] & a) > 0) {
        let g = r[p];
        if (l.allows(g) && (e.token.value == -1 || e.token.value == g || rHt(g, e.token.value, i, s))) {
          e.acceptToken(g);
          break;
        }
      }
    let d = e.next, u = 0, f = r[o + 2];
    if (e.next < 0 && f > u && r[c + f * 3 - 3] == 65535) {
      o = r[c + f * 3 - 1];
      continue e;
    }
    for (; u < f; ) {
      let p = u + f >> 1, g = c + p + (p << 1), m = r[g], A = r[g + 1] || 65536;
      if (d < m)
        f = p;
      else if (d >= A)
        u = p + 1;
      else {
        o = r[g + 2], e.advance();
        continue e;
      }
    }
    break;
  }
}
function ECe(r, e, t) {
  for (let n = e, i; (i = r[n]) != 65535; n++)
    if (i == t)
      return n - e;
  return -1;
}
function rHt(r, e, t, n) {
  let i = ECe(t, n, e);
  return i < 0 || ECe(t, n, r) < i;
}
const Ko = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let mS = null;
function _Ce(r, e, t) {
  let n = r.cursor(Vi.IncludeAnonymous);
  for (n.moveTo(e); ; )
    if (!(t < 0 ? n.childBefore(e) : n.childAfter(e)))
      for (; ; ) {
        if ((t < 0 ? n.to < e : n.from > e) && !n.type.isError)
          return t < 0 ? Math.max(0, Math.min(
            n.to - 1,
            e - 25
            /* Safety.Margin */
          )) : Math.min(r.length, Math.max(
            n.from + 1,
            e + 25
            /* Safety.Margin */
          ));
        if (t < 0 ? n.prevSibling() : n.nextSibling())
          break;
        if (!n.parent())
          return t < 0 ? 0 : r.length;
      }
}
let sHt = class {
  constructor(e, t) {
    this.fragments = e, this.nodeSet = t, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? _Ce(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? _Ce(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let t = this.trees.length - 1;
      if (t < 0)
        return this.nextFragment(), null;
      let n = this.trees[t], i = this.index[t];
      if (i == n.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let s = n.children[i], o = this.start[t] + n.positions[i];
      if (o > e)
        return this.nextStart = o, null;
      if (s instanceof ci) {
        if (o == e) {
          if (o < this.safeFrom)
            return null;
          let a = o + s.length;
          if (a <= this.safeTo) {
            let l = s.prop(Xt.lookAhead);
            if (!l || a + l < this.fragment.to)
              return s;
          }
        }
        this.index[t]++, o + s.length >= Math.max(this.safeFrom, e) && (this.trees.push(s), this.start.push(o), this.index.push(0));
      } else
        this.index[t]++, this.nextStart = o + s.length;
    }
  }
};
class oHt {
  constructor(e, t) {
    this.stream = t, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((n) => new X6());
  }
  getActions(e) {
    let t = 0, n = null, { parser: i } = e.p, { tokenizers: s } = i, o = i.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let c = 0; c < s.length; c++) {
      if ((1 << c & o) == 0)
        continue;
      let d = s[c], u = this.tokens[c];
      if (!(n && !d.fallback) && ((d.contextual || u.start != e.pos || u.mask != o || u.context != a) && (this.updateCachedToken(u, d, e), u.mask = o, u.context = a), u.lookAhead > u.end + 25 && (l = Math.max(u.lookAhead, l)), u.value != 0)) {
        let f = t;
        if (u.extended > -1 && (t = this.addActions(e, u.extended, u.end, t)), t = this.addActions(e, u.value, u.end, t), !d.extend && (n = u, t > f))
          break;
      }
    }
    for (; this.actions.length > t; )
      this.actions.pop();
    return l && e.setLookAhead(l), !n && e.pos == this.stream.end && (n = new X6(), n.value = e.p.parser.eofTerm, n.start = n.end = e.pos, t = this.addActions(e, n.value, n.end, t)), this.mainToken = n, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let t = new X6(), { pos: n, p: i } = e;
    return t.start = n, t.end = Math.min(n + 1, i.stream.end), t.value = n == i.stream.end ? i.parser.eofTerm : 0, t;
  }
  updateCachedToken(e, t, n) {
    let i = this.stream.clipPos(n.pos);
    if (t.token(this.stream.reset(i, e), n), e.value > -1) {
      let { parser: s } = n.p;
      for (let o = 0; o < s.specialized.length; o++)
        if (s.specialized[o] == e.value) {
          let a = s.specializers[o](this.stream.read(e.start, e.end), n);
          if (a >= 0 && n.p.parser.dialect.allows(a >> 1)) {
            (a & 1) == 0 ? e.value = a >> 1 : e.extended = a >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(i + 1);
  }
  putAction(e, t, n, i) {
    for (let s = 0; s < i; s += 3)
      if (this.actions[s] == e)
        return i;
    return this.actions[i++] = e, this.actions[i++] = t, this.actions[i++] = n, i;
  }
  addActions(e, t, n, i) {
    let { state: s } = e, { parser: o } = e.p, { data: a } = o;
    for (let l = 0; l < 2; l++)
      for (let c = o.stateSlot(
        s,
        l ? 2 : 1
        /* ParseState.Actions */
      ); ; c += 3) {
        if (a[c] == 65535)
          if (a[c + 1] == 1)
            c = ed(a, c + 2);
          else {
            i == 0 && a[c + 1] == 2 && (i = this.putAction(ed(a, c + 2), t, n, i));
            break;
          }
        a[c] == t && (i = this.putAction(ed(a, c + 1), t, n, i));
      }
    return i;
  }
}
class aHt {
  constructor(e, t, n, i) {
    this.parser = e, this.input = t, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new nHt(t, i), this.tokens = new oHt(e, this.stream), this.topTerm = e.top[1];
    let { from: s } = i[0];
    this.stacks = [eHt.start(this, e.top[0], s)], this.fragments = n.length && this.stream.end - s > e.bufferLength * 4 ? new sHt(n, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, t = this.minStackPos, n = this.stacks = [], i, s;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [o] = e;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > t)
          n.push(a);
        else {
          if (this.advanceStack(a, n, e))
            continue;
          {
            i || (i = [], s = []), i.push(a);
            let l = this.tokens.getMainToken(a);
            s.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!n.length) {
      let o = i && hHt(i);
      if (o)
        return Ko && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      if (this.parser.strict)
        throw Ko && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + t);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let o = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, s, n);
      if (o)
        return Ko && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (n.length > o)
        for (n.sort((a, l) => l.score - a.score); n.length > o; )
          n.pop();
      n.some((a) => a.reducePos > t) && this.recovering--;
    } else if (n.length > 1) {
      e: for (let o = 0; o < n.length - 1; o++) {
        let a = n[o];
        for (let l = o + 1; l < n.length; l++) {
          let c = n[l];
          if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500)
            if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0)
              n.splice(l--, 1);
            else {
              n.splice(o--, 1);
              continue e;
            }
        }
      }
      n.length > 12 && n.splice(
        12,
        n.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = n[0].pos;
    for (let o = 1; o < n.length; o++)
      n[o].pos < this.minStackPos && (this.minStackPos = n[o].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, t, n) {
    let i = e.pos, { parser: s } = this, o = Ko ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let c = e.curContext && e.curContext.tracker.strict, d = c ? e.curContext.hash : 0;
      for (let u = this.fragments.nodeAt(i); u; ) {
        let f = this.parser.nodeSet.types[u.type.id] == u.type ? s.getGoto(e.state, u.type.id) : -1;
        if (f > -1 && u.length && (!c || (u.prop(Xt.contextHash) || 0) == d))
          return e.useNode(u, f), Ko && console.log(o + this.stackID(e) + ` (via reuse of ${s.getName(u.type.id)})`), !0;
        if (!(u instanceof ci) || u.children.length == 0 || u.positions[0] > 0)
          break;
        let p = u.children[0];
        if (p instanceof ci && u.positions[0] == 0)
          u = p;
        else
          break;
      }
    }
    let a = s.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return e.reduce(a), Ko && console.log(o + this.stackID(e) + ` (via always-reduce ${s.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let l = this.tokens.getActions(e);
    for (let c = 0; c < l.length; ) {
      let d = l[c++], u = l[c++], f = l[c++], p = c == l.length || !n, g = p ? e : e.split(), m = this.tokens.mainToken;
      if (g.apply(d, u, m ? m.start : g.pos, f), Ko && console.log(o + this.stackID(g) + ` (via ${(d & 65536) == 0 ? "shift" : `reduce of ${s.getName(
        d & 65535
        /* Action.ValueMask */
      )}`} for ${s.getName(u)} @ ${i}${g == e ? "" : ", split"})`), p)
        return !0;
      g.pos > i ? t.push(g) : n.push(g);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, t) {
    let n = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > n)
        return xCe(e, t), !0;
    }
  }
  runRecovery(e, t, n) {
    let i = null, s = !1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = t[o << 1], c = t[(o << 1) + 1], d = Ko ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (s || (s = !0, a.restart(), Ko && console.log(d + this.stackID(a) + " (restarted)"), this.advanceFully(a, n))))
        continue;
      let u = a.split(), f = d;
      for (let p = 0; u.forceReduce() && p < 10 && (Ko && console.log(f + this.stackID(u) + " (via force-reduce)"), !this.advanceFully(u, n)); p++)
        Ko && (f = this.stackID(u) + " -> ");
      for (let p of a.recoverByInsert(l))
        Ko && console.log(d + this.stackID(p) + " (via recover-insert)"), this.advanceFully(p, n);
      this.stream.end > a.pos ? (c == a.pos && (c++, l = 0), a.recoverByDelete(l, c), Ko && console.log(d + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), xCe(a, n)) : (!i || i.score < a.score) && (i = a);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), ci.build({
      buffer: kb.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let t = (mS || (mS = /* @__PURE__ */ new WeakMap())).get(e);
    return t || mS.set(e, t = String.fromCodePoint(this.nextStackID++)), t + e;
  }
}
function xCe(r, e) {
  for (let t = 0; t < e.length; t++) {
    let n = e[t];
    if (n.pos == r.pos && n.sameState(r)) {
      e[t].score < r.score && (e[t] = r);
      return;
    }
  }
  e.push(r);
}
class lHt {
  constructor(e, t, n) {
    this.source = e, this.flags = t, this.disabled = n;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
const AS = (r) => r;
class cHt {
  /**
  Define a context tracker.
  */
  constructor(e) {
    this.start = e.start, this.shift = e.shift || AS, this.reduce = e.reduce || AS, this.reuse = e.reuse || AS, this.hash = e.hash || (() => 0), this.strict = e.strict !== !1;
  }
}
class D4 extends HV {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let t = e.nodeNames.split(" ");
    this.minRepeatTerm = t.length;
    for (let a = 0; a < e.repeatNodeCount; a++)
      t.push("");
    let n = Object.keys(e.topRules).map((a) => e.topRules[a][1]), i = [];
    for (let a = 0; a < t.length; a++)
      i.push([]);
    function s(a, l, c) {
      i[a].push([l, l.deserialize(String(c))]);
    }
    if (e.nodeProps)
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = Xt[l]);
        for (let c = 1; c < a.length; ) {
          let d = a[c++];
          if (d >= 0)
            s(d, l, a[c++]);
          else {
            let u = a[c + -d];
            for (let f = -d; f > 0; f--)
              s(a[c++], l, u);
            c++;
          }
        }
      }
    this.nodeSet = new Gw(t.map((a, l) => jr.define({
      name: l >= this.minRepeatTerm ? void 0 : a,
      id: l,
      props: i[l],
      top: n.indexOf(l) > -1,
      error: l == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(l) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = MRe;
    let o = N5(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(SCe), this.states = N5(e.states, Uint32Array), this.data = N5(e.stateData), this.goto = N5(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((a) => typeof a == "number" ? new Bp(o, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, t, n) {
    let i = new aHt(this, e, t, n);
    for (let s of this.wrappers)
      i = s(i, e, t, n);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, t, n = !1) {
    let i = this.goto;
    if (t >= i[0])
      return -1;
    for (let s = i[t + 1]; ; ) {
      let o = i[s++], a = o & 1, l = i[s++];
      if (a && n)
        return l;
      for (let c = s + (o >> 1); s < c; s++)
        if (i[s] == e)
          return l;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, t) {
    let n = this.data;
    for (let i = 0; i < 2; i++)
      for (let s = this.stateSlot(
        e,
        i ? 2 : 1
        /* ParseState.Actions */
      ), o; ; s += 3) {
        if ((o = n[s]) == 65535)
          if (n[s + 1] == 1)
            o = n[s = ed(n, s + 2)];
          else {
            if (n[s + 1] == 2)
              return ed(n, s + 2);
            break;
          }
        if (o == t || o == 0)
          return ed(n, s + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, t) {
    return this.states[e * 6 + t];
  }
  /**
  @internal
  */
  stateFlag(e, t) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & t) > 0;
  }
  /**
  @internal
  */
  validAction(e, t) {
    return !!this.allActions(e, (n) => n == t ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, t) {
    let n = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), i = n ? t(n) : void 0;
    for (let s = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); i == null; s += 3) {
      if (this.data[s] == 65535)
        if (this.data[s + 1] == 1)
          s = ed(this.data, s + 2);
        else
          break;
      i = t(ed(this.data, s + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let t = [];
    for (let n = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; n += 3) {
      if (this.data[n] == 65535)
        if (this.data[n + 1] == 1)
          n = ed(this.data, n + 2);
        else
          break;
      if ((this.data[n + 2] & 1) == 0) {
        let i = this.data[n + 1];
        t.some((s, o) => o & 1 && s == i) || t.push(this.data[n], i);
      }
    }
    return t;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let t = Object.assign(Object.create(D4.prototype), this);
    if (e.props && (t.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let n = this.topRules[e.top];
      if (!n)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      t.top = n;
    }
    return e.tokenizers && (t.tokenizers = this.tokenizers.map((n) => {
      let i = e.tokenizers.find((s) => s.from == n);
      return i ? i.to : n;
    })), e.specializers && (t.specializers = this.specializers.slice(), t.specializerSpecs = this.specializerSpecs.map((n, i) => {
      let s = e.specializers.find((a) => a.from == n.external);
      if (!s)
        return n;
      let o = Object.assign(Object.assign({}, n), { external: s.to });
      return t.specializers[i] = SCe(o), o;
    })), e.contextTracker && (t.context = e.contextTracker), e.dialect && (t.dialect = this.parseDialect(e.dialect)), e.strict != null && (t.strict = e.strict), e.wrap && (t.wrappers = t.wrappers.concat(e.wrap)), e.bufferLength != null && (t.bufferLength = e.bufferLength), t;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let t = this.dynamicPrecedences;
    return t == null ? 0 : t[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let t = Object.keys(this.dialects), n = t.map(() => !1);
    if (e)
      for (let s of e.split(" ")) {
        let o = t.indexOf(s);
        o >= 0 && (n[o] = !0);
      }
    let i = null;
    for (let s = 0; s < t.length; s++)
      if (!n[s])
        for (let o = this.dialects[t[s]], a; (a = this.data[o++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new lHt(e, n, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new D4(e);
  }
}
function ed(r, e) {
  return r[e] | r[e + 1] << 16;
}
function hHt(r) {
  let e = null;
  for (let t of r) {
    let n = t.p.stoppedAt;
    (t.pos == t.p.stream.end || n != null && t.pos > n) && t.p.parser.stateFlag(
      t.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < t.score) && (e = t);
  }
  return e;
}
function SCe(r) {
  if (r.external) {
    let e = r.extend ? 1 : 0;
    return (t, n) => r.external(t, n) << 1 | e;
  }
  return r.get;
}
let dHt = 0, td = class NRe {
  /**
  @internal
  */
  constructor(e, t, n) {
    this.set = e, this.base = t, this.modified = n, this.id = dHt++;
  }
  /**
  Define a new tag. If `parent` is given, the tag is treated as a
  sub-tag of that parent, and
  [highlighters](#highlight.tagHighlighter) that don't mention
  this tag will try to fall back to the parent tag (or grandparent
  tag, etc).
  */
  static define(e) {
    if (e?.base)
      throw new Error("Can not derive from a modified tag");
    let t = new NRe([], null, []);
    if (t.set.push(t), e)
      for (let n of e.set)
        t.set.push(n);
    return t;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier() {
    let e = new Nb();
    return (t) => t.modified.indexOf(e) > -1 ? t : Nb.get(t.base || t, t.modified.concat(e).sort((n, i) => n.id - i.id));
  }
}, uHt = 0;
class Nb {
  constructor() {
    this.instances = [], this.id = uHt++;
  }
  static get(e, t) {
    if (!t.length)
      return e;
    let n = t[0].instances.find((a) => a.base == e && fHt(t, a.modified));
    if (n)
      return n;
    let i = [], s = new td(i, e, t);
    for (let a of t)
      a.instances.push(s);
    let o = pHt(t);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of o)
          i.push(Nb.get(a, l));
    return s;
  }
}
function fHt(r, e) {
  return r.length == e.length && r.every((t, n) => t == e[n]);
}
function pHt(r) {
  let e = [[]];
  for (let t = 0; t < r.length; t++)
    for (let n = 0, i = e.length; n < i; n++)
      e.push(e[n].concat(r[t]));
  return e.sort((t, n) => n.length - t.length);
}
function Qw(r) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in r) {
    let n = r[t];
    Array.isArray(n) || (n = [n]);
    for (let i of t.split(" "))
      if (i) {
        let s = [], o = 2, a = i;
        for (let u = 0; ; ) {
          if (a == "..." && u > 0 && u + 3 == i.length) {
            o = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!f)
            throw new RangeError("Invalid path: " + i);
          if (s.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), u += f[0].length, u == i.length)
            break;
          let p = i[u++];
          if (u == i.length && p == "!") {
            o = 0;
            break;
          }
          if (p != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(u);
        }
        let l = s.length - 1, c = s[l];
        if (!c)
          throw new RangeError("Invalid path: " + i);
        let d = new Tb(n, o, l > 0 ? s.slice(0, l) : null);
        e[c] = d.sort(e[c]);
      }
  }
  return TRe.add(e);
}
const TRe = new Xt();
class Tb {
  constructor(e, t, n, i) {
    this.tags = e, this.mode = t, this.context = n, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Tb.empty = new Tb([], 2, null);
function IRe(r, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let s of r)
    if (!Array.isArray(s.tag))
      t[s.tag.id] = s.class;
    else
      for (let o of s.tag)
        t[o.id] = s.class;
  let { scope: n, all: i = null } = e || {};
  return {
    style: (s) => {
      let o = i;
      for (let a of s)
        for (let l of a.set) {
          let c = t[l.id];
          if (c) {
            o = o ? o + " " + c : c;
            break;
          }
        }
      return o;
    },
    scope: n
  };
}
function gHt(r, e) {
  let t = null;
  for (let n of r) {
    let i = n.style(e);
    i && (t = t ? t + " " + i : i);
  }
  return t;
}
function mHt(r, e, t, n = 0, i = r.length) {
  let s = new AHt(n, Array.isArray(e) ? e : [e], t);
  s.highlightRange(r.cursor(), n, i, "", s.highlighters), s.flush(i);
}
class AHt {
  constructor(e, t, n) {
    this.at = e, this.highlighters = t, this.span = n, this.class = "";
  }
  startSpan(e, t) {
    t != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = t);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, t, n, i, s) {
    let { type: o, from: a, to: l } = e;
    if (a >= n || l <= t)
      return;
    o.isTop && (s = this.highlighters.filter((p) => !p.scope || p.scope(o)));
    let c = i, d = wHt(e) || Tb.empty, u = gHt(s, d.tags);
    if (u && (c && (c += " "), c += u, d.mode == 1 && (i += (i ? " " : "") + u)), this.startSpan(Math.max(t, a), c), d.opaque)
      return;
    let f = e.tree && e.tree.prop(Xt.mounted);
    if (f && f.overlay) {
      let p = e.node.enter(f.overlay[0].from + a, 1), g = this.highlighters.filter((A) => !A.scope || A.scope(f.tree.type)), m = e.firstChild();
      for (let A = 0, w = a; ; A++) {
        let v = A < f.overlay.length ? f.overlay[A] : null, y = v ? v.from + a : l, _ = Math.max(t, w), S = Math.min(n, y);
        if (_ < S && m)
          for (; e.from < S && (this.highlightRange(e, _, S, i, s), this.startSpan(Math.min(S, e.to), c), !(e.to >= y || !e.nextSibling())); )
            ;
        if (!v || y > n)
          break;
        w = v.to + a, w > t && (this.highlightRange(p.cursor(), Math.max(t, v.from + a), Math.min(n, w), "", g), this.startSpan(Math.min(n, w), c));
      }
      m && e.parent();
    } else if (e.firstChild()) {
      f && (i = "");
      do
        if (!(e.to <= t)) {
          if (e.from >= n)
            break;
          this.highlightRange(e, t, n, i, s), this.startSpan(Math.min(n, e.to), c);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function wHt(r) {
  let e = r.type.prop(TRe);
  for (; e && e.context && !r.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const Ye = td.define, T5 = Ye(), wu = Ye(), MCe = Ye(wu), DCe = Ye(wu), vu = Ye(), I5 = Ye(vu), wS = Ye(vu), Hc = Ye(), $1 = Ye(Hc), Tc = Ye(), Ic = Ye(), FN = Ye(), eA = Ye(FN), O5 = Ye(), J = {
  /**
  A comment.
  */
  comment: T5,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Ye(T5),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Ye(T5),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Ye(T5),
  /**
  Any kind of identifier.
  */
  name: wu,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Ye(wu),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: MCe,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Ye(MCe),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: DCe,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Ye(DCe),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Ye(wu),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Ye(wu),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Ye(wu),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Ye(wu),
  /**
  A literal value.
  */
  literal: vu,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: I5,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Ye(I5),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Ye(I5),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Ye(I5),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: wS,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Ye(wS),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Ye(wS),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Ye(vu),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Ye(vu),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Ye(vu),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Ye(vu),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Ye(vu),
  /**
  A language keyword.
  */
  keyword: Tc,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Ye(Tc),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Ye(Tc),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Ye(Tc),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Ye(Tc),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Ye(Tc),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Ye(Tc),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Ye(Tc),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Ye(Tc),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Ye(Tc),
  /**
  An operator.
  */
  operator: Ic,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Ye(Ic),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Ye(Ic),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Ye(Ic),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Ye(Ic),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Ye(Ic),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Ye(Ic),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Ye(Ic),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Ye(Ic),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Ye(Ic),
  /**
  Program or markup punctuation.
  */
  punctuation: FN,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Ye(FN),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: eA,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Ye(eA),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Ye(eA),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Ye(eA),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Ye(eA),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Hc,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: $1,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Ye($1),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Ye($1),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Ye($1),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Ye($1),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Ye($1),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Ye($1),
  /**
  A prose separator (such as a horizontal rule).
  */
  contentSeparator: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Ye(Hc),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Ye(Hc),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Ye(),
  /**
  Deleted text.
  */
  deleted: Ye(),
  /**
  Changed text.
  */
  changed: Ye(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Ye(),
  /**
  Metadata or meta-instruction.
  */
  meta: O5,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Ye(O5),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Ye(O5),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Ye(O5),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: td.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: td.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: td.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: td.defineModifier(),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: td.defineModifier(),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: td.defineModifier()
};
IRe([
  { tag: J.link, class: "tok-link" },
  { tag: J.heading, class: "tok-heading" },
  { tag: J.emphasis, class: "tok-emphasis" },
  { tag: J.strong, class: "tok-strong" },
  { tag: J.keyword, class: "tok-keyword" },
  { tag: J.atom, class: "tok-atom" },
  { tag: J.bool, class: "tok-bool" },
  { tag: J.url, class: "tok-url" },
  { tag: J.labelName, class: "tok-labelName" },
  { tag: J.inserted, class: "tok-inserted" },
  { tag: J.deleted, class: "tok-deleted" },
  { tag: J.literal, class: "tok-literal" },
  { tag: J.string, class: "tok-string" },
  { tag: J.number, class: "tok-number" },
  { tag: [J.regexp, J.escape, J.special(J.string)], class: "tok-string2" },
  { tag: J.variableName, class: "tok-variableName" },
  { tag: J.local(J.variableName), class: "tok-variableName tok-local" },
  { tag: J.definition(J.variableName), class: "tok-variableName tok-definition" },
  { tag: J.special(J.variableName), class: "tok-variableName2" },
  { tag: J.definition(J.propertyName), class: "tok-propertyName tok-definition" },
  { tag: J.typeName, class: "tok-typeName" },
  { tag: J.namespace, class: "tok-namespace" },
  { tag: J.className, class: "tok-className" },
  { tag: J.macroName, class: "tok-macroName" },
  { tag: J.propertyName, class: "tok-propertyName" },
  { tag: J.operator, class: "tok-operator" },
  { tag: J.comment, class: "tok-comment" },
  { tag: J.meta, class: "tok-meta" },
  { tag: J.invalid, class: "tok-invalid" },
  { tag: J.punctuation, class: "tok-punctuation" }
]);
const vHt = 120, BV = 121, ORe = 122, bHt = 123, LCe = 127, yHt = 4, CHt = 130, EHt = 7, _Ht = 8, xHt = 9, SHt = 10, MHt = 138, RRe = 19, DHt = 139, LHt = 23, kHt = 140, NHt = 27, THt = 37, IHt = 41, OHt = 144, RHt = 145, VHt = 146, HHt = 147, BHt = 47, PHt = 67, VRe = 152, HRe = 69, BRe = 153, PRe = 71, FHt = 154, zHt = 75, WHt = 159, jHt = 78, ZHt = 79, UHt = 80, qHt = 165, FRe = 88, GHt = 89, QHt = 167, KHt = 96, YHt = 169, XHt = 97, JHt = 99, $Ht = 100, PV = typeof process < "u" && process.env && /\bfparse(:dbg)?\b/.test(process.env.LOG), FV = typeof process < "u" && process.env && /\bfparse:dbg\b/.test(process.env.LOG), Wh = typeof process < "u" && process.env && /\bcontext\b/.test(process.env.LOG), zRe = [
  9,
  11,
  12,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
], eBt = WRe(`
\r`), kCe = 42, tBt = WRe("'./-+*^");
function WRe(r) {
  return Array.from(r).map((e) => e.charCodeAt(0));
}
function nBt(r) {
  return r === 63 || r >= 65 && r <= 90 || r === 95 || r >= 97 && r <= 122 || r >= 192 && r <= 214 || r >= 216 && r <= 246 || r >= 248 && r <= 767 || r >= 880 && r <= 893 || r >= 895 && r <= 8191 || r >= 8204 && r <= 8205 || r >= 8304 && r <= 8591 || r >= 11264 && r <= 12271 || r >= 12289 && r <= 55295 || r >= 63744 && r <= 64975 || r >= 65008 && r <= 65533 || r >= 55296 && r <= 56319 || r >= 56320 && r <= 57343;
}
function iBt(r) {
  return tBt.includes(r);
}
function rBt(r) {
  return r >= 48 && r <= 57 || r === 183 || r >= 768 && r <= 879 || r >= 8255 && r <= 8256;
}
function sBt(r) {
  return zRe.includes(r);
}
function NCe(r, e) {
  return e.concat(
    r.split(/\n/g).join(`
` + e)
  );
}
function oBt(r, e = 0) {
  const t = r.peek(e);
  return t === kCe && r.peek(e + 1) === kCe ? {
    offset: 2,
    token: "**"
  } : iBt(t) ? {
    offset: 1,
    token: String.fromCharCode(t)
  } : null;
}
function rC(r, e = 0, t = !1) {
  for (let n = !1, i = [], s = 0; ; s++) {
    const o = r.peek(e + s);
    if (nBt(o) || (n || t) && rBt(o))
      n || (n = !0), i.push(o);
    else
      return i.length ? {
        token: String.fromCharCode(...i),
        offset: s
      } : null;
  }
}
function jRe(r, e) {
  for (let t = !1, n = 0; ; n++) {
    let i = r.peek(e + n);
    if (sBt(i))
      t || (t = !0);
    else
      return t ? {
        token: " ",
        offset: n
      } : null;
  }
}
function aBt(r, e) {
  const t = e.contextKeys(), n = e.tokens;
  for (let i = 0, s = [], o = null; ; ) {
    const a = n.length + s.length > 0, l = s.length > 0, c = rC(r, i, a) || a && oBt(r, i) || l && jRe(r, i);
    if (!c)
      return o;
    const {
      token: d,
      offset: u
    } = c;
    if (i += u, d === " ")
      continue;
    s = [...s, d];
    const f = [...n, ...s].join(" ");
    if (t.some((p) => p === f)) {
      const p = s[0];
      o = {
        token: p,
        offset: p.length,
        term: ORe
      };
    }
    if (!t.some((p) => p.startsWith(f))) {
      if (TCe.some((p) => p === f)) {
        const p = s[0];
        o = {
          token: p,
          offset: p.length,
          term: BV
        };
      }
      if (!TCe.some((p) => p.startsWith(f)))
        return o;
    }
  }
}
const lBt = {
  [BV]: "identifier",
  [ORe]: "nameIdentifier"
}, cBt = new wm((r, e) => {
  FV && console.log("%s: T <identifier | nameIdentifier>", r.pos);
  const t = aBt(r, e.context), n = e.context.tokens, i = t || rC(r, 0, n.length > 0);
  i && (r.advance(i.offset), r.acceptToken(t ? t.term : BV), PV && console.log("%s: MATCH <%s> <%s>", r.pos, t ? lBt[t.term] : "identifier", i.token));
}, { contextual: !0 }), hBt = new wm((r, e) => {
  FV && console.log("%s: T <propertyIdentifier>", r.pos);
  const t = e.context.tokens, n = rC(r, 0, t.length > 0);
  n && (r.advance(n.offset), r.acceptToken(vHt), PV && console.log("%s: MATCH <propertyIdentifier> <%s>", r.pos, n.token));
}), dBt = new wm((r, e) => {
  FV && console.log("%s: T <insertSemi>", r.pos);
  let t, n = !1;
  for (t = 0; ; t++) {
    const i = r.peek(t);
    if (!zRe.includes(i)) {
      eBt.includes(i) && (n = !0);
      break;
    }
  }
  if (n) {
    const i = rC(r, t + 1);
    if (jRe(r, t + 1) || i && /^(then|else|return|satisfies)$/.test(i.token))
      return;
    PV && console.log("%s: MATCH <insertSemi>", r.pos), r.acceptToken(bHt);
  }
}), uBt = {
  [FHt]: "FunctionInvocation",
  [BRe]: "FilterExpression",
  [VRe]: "PathExpression"
}, fBt = {
  [YHt]: "Context",
  [QHt]: "FunctionDefinition",
  [CHt]: "ForExpression",
  [qHt]: "List",
  [DHt]: "IfExpression",
  [kHt]: "QuantifiedExpression"
}, pBt = {
  [KHt]: "Context",
  [GHt]: "FunctionDefinition",
  [yHt]: "ForExpression",
  [FRe]: "List",
  [RRe]: "IfExpression",
  [LHt]: "QuantifiedExpression",
  [PHt]: "PathExpression",
  [PRe]: "FunctionInvocation",
  [HRe]: "FilterExpression",
  [IHt]: "ArithmeticExpression"
};
class Kw {
  /**
   * @param { Function } fn
   */
  constructor(e) {
    this.fn = e;
  }
  get(e) {
    return this.fn(e);
  }
  /**
   * @param { Function } fn
   *
   * @return { ValueProducer }
   */
  static of(e) {
    return new Kw(e);
  }
}
const gBt = {
  "date and time": 1,
  date: 1,
  time: 1,
  duration: 1
}, TCe = Object.keys(gBt);
class mBt {
  /**
   * Creates a new context from a JavaScript object.
   *
   * @param {any} value
   */
  constructor(e = {}) {
    this.value = e;
  }
  /**
   * Return all defined keys of the context.
   *
   * @returns {Array<string>} the keys of the context
   */
  getKeys() {
    return Object.keys(this.value);
  }
  /**
   * Returns the value of the given key.
   *
   * If the value represents a context itself, it should be wrapped in a
   * context class.
   *
   * @param {String} key
   * @returns {VariableContext|ValueProducer|null}
   */
  get(e) {
    const t = this.value[e], n = (
      /** @type { typeof VariableContext } */
      this.constructor
    );
    return n.isAtomic(t) ? t : n.of(t);
  }
  /**
   * Creates a new context with the given key added.
   *
   * @param {String} key
   * @param {any} value
   *
   * @returns {VariableContext} new context with the given key added
   */
  set(e, t) {
    return /** @type { typeof VariableContext } */ this.constructor.of({
      ...this.value,
      [e]: t
    });
  }
  /**
   * Wether the given value is atomic. Non-atomic values need to be wrapped in a
   * context Class.
   *
   * @param {any} value
   * @returns {Boolean}
   */
  static isAtomic(e) {
    return !e || e instanceof this || e instanceof Kw || typeof e != "object";
  }
  /**
   * Takes any number of Contexts and merges them into a single Context.
   *
   * @param  {...Context} contexts
   * @returns {VariableContext}
   */
  static of(...e) {
    const t = (i) => !i || typeof i != "object" ? {} : i instanceof this ? i.value : { ...i }, n = e.reduce((i, s) => ({
      ...i,
      ...t(s)
    }), {});
    return new this(n);
  }
}
let ABt = class J6 {
  constructor({
    name: e = "Expressions",
    tokens: t = [],
    children: n = [],
    parent: i = null,
    context: s = null,
    value: o = null,
    raw: a = null
  } = {}) {
    this.name = e, this.tokens = t, this.children = n, this.parent = i, this.context = s, this.value = o, this.raw = a;
  }
  enterScope(e) {
    const t = this.of({
      name: e,
      parent: this
    });
    return Wh && console.log("[%s] enter", t.path, t.context), t;
  }
  exitScope(e) {
    return this.parent ? (Wh && console.log(`[%s] exit %o
%s`, this.path, this.context, NCe(e, "  ")), this.parent.pushChild(this)) : (Wh && console.log(`[%s] NO exit %o
%s`, this.path, this.context, NCe(e, "  ")), this);
  }
  token(e) {
    return Wh && console.log("[%s] token <%s> + <%s>", this.path, this.tokens.join(" "), e), this.assign({
      tokens: [...this.tokens, e]
    });
  }
  literal(e) {
    return Wh && console.log("[%s] literal %o", this.path, e), this.pushChild(this.of({
      name: "Literal",
      value: e
    }));
  }
  /**
   * Return computed scope value
   *
   * @return {any}
   */
  computedValue() {
    for (let e = this; ; e = F2(e.children)) {
      if (!e)
        return null;
      if (e.value)
        return e.value;
    }
  }
  contextKeys() {
    return this.context.getKeys().map($6);
  }
  get path() {
    return this.parent?.path?.concat(" > ", this.name) || this.name;
  }
  /**
   * Return value of variable.
   *
   * @param { string } variable
   * @return { any } value
   */
  get(e) {
    const t = [e, e && $6(e)], n = this.context.getKeys().find(
      (s) => t.includes($6(s))
    );
    if (typeof n > "u")
      return;
    const i = this.context.get(n);
    return i instanceof Kw ? i.get(this) : i;
  }
  resolveName() {
    const e = this.tokens.join(" "), t = [], n = this.assign({
      tokens: t
    }), i = this.of({
      name: "VariableName",
      parent: n,
      value: this.get(e),
      raw: e
    });
    return Wh && console.log("[%s] resolve name <%s=%s>", i.path, e, this.get(e)), n.pushChild(i);
  }
  pushChild(e) {
    if (!e)
      return this;
    const t = this.assign({
      children: [...this.children, e]
    });
    return e.parent = t, t;
  }
  pushChildren(e) {
    let t = this;
    for (const n of e)
      t = t.pushChild(n);
    return t;
  }
  declareName() {
    if (this.tokens.length === 0)
      throw Error("no tokens to declare name");
    const e = this.tokens.join(" ");
    return Wh && console.log("[%s] declareName <%s>", this.path, e), this.assign({
      tokens: []
    }).pushChild(
      this.of({
        name: "Name",
        value: e
      })
    );
  }
  define(e, t) {
    if (typeof e != "string")
      return Wh && console.log("[%s] no define <%s=%s>", this.path, e, t), this;
    Wh && console.log("[%s] define <%s=%s>", this.path, e, t);
    const n = this.context.set(e, t);
    return this.assign({
      context: n
    });
  }
  /**
   * @param { Record<string, any> } [options]
   *
   * @return { Variables }
   */
  assign(e = {}) {
    return J6.of({
      ...this,
      ...e
    });
  }
  /**
   * @param { Record<string, any> } [options]
   *
   * @return { Variables }
   */
  of(e = {}) {
    const t = {
      context: this.context,
      parent: this.parent
    };
    return J6.of({
      ...t,
      ...e
    });
  }
  static of(e) {
    const {
      name: t,
      tokens: n = [],
      children: i = [],
      parent: s = null,
      context: o,
      value: a,
      raw: l
    } = e;
    if (!o)
      throw new Error("must provide <context>");
    return new J6({
      name: t,
      tokens: [...n],
      children: [...i],
      context: o,
      parent: s,
      value: a,
      raw: l
    });
  }
};
function $6(r) {
  return r.replace(/\s*([./\-'+]|\*\*?)\s*/g, " $1 ").replace(/\s{2,}/g, " ").trim();
}
function ICe(r, e, t) {
  const n = r.children.filter((c) => c.name !== e), i = r.children.filter((c) => c.name === e), s = n[0], o = n[Math.max(1, n.length - 1)], a = s?.computedValue(), l = o?.computedValue() || null;
  return r.assign({
    children: i
  }).enterScope(e).pushChildren(n).exitScope(t).define(a, l);
}
function wBt(r = {}, e = mBt) {
  const t = ABt.of({
    context: e.of(r)
  });
  return new cHt({
    start: t,
    reduce(n, i, s, o) {
      if (i === RRe) {
        const [u, f] = n.children.slice(-2);
        n = n.assign({
          value: e.of(
            u?.computedValue(),
            f?.computedValue()
          )
        });
      }
      if (i === FRe && (n = n.assign({
        value: e.of(
          ...n.children.map(
            (u) => u?.computedValue()
          )
        )
      })), i === HRe) {
        const [u, f] = n.children.slice(-2);
        n = n.assign({
          value: u?.computedValue()
        });
      }
      if (i === PRe) {
        const [
          u,
          ...f
        ] = n.children;
        u?.raw === "get value" && (n = bBt(n, f));
      }
      const a = fBt[i];
      if (a)
        return n.enterScope(a);
      const l = uBt[i];
      if (l) {
        const {
          children: u,
          context: f
        } = n, p = u.slice(0, -1), g = F2(u);
        let m = null;
        return i === VRe && (m = e.of(g?.computedValue())), i === BRe && (m = e.of(
          f,
          g?.computedValue()
        ).set("item", g?.computedValue())), n.assign({ children: p }).enterScope(l).pushChild(g).assign({ context: m || f });
      }
      const c = o.read(o.pos, s.pos);
      if (pBt[i])
        return n.exitScope(c);
      if (i === XHt) {
        const u = n.children.filter((g) => g.name !== "ContextEntry"), f = u[0], p = F2(u);
        return ICe(n, "ContextEntry", c).assign(
          {
            value: e.of(n.value).set(f?.computedValue(), p?.computedValue())
          }
        );
      }
      if (i === EHt || i === NHt)
        return ICe(n, "InExpression", c);
      if (i === MHt)
        return n.define(
          "partial",
          Kw.of((u) => F2(u.children)?.computedValue())
        );
      if (i === zHt) {
        const u = F2(n.children).computedValue();
        return n.define(u, 1);
      }
      if (i === OHt || i === RHt || i === VHt) {
        const u = n.children.slice(0, -1), f = F2(n.children);
        return n.assign({
          children: u
        }).enterScope("ArithmeticExpression").pushChild(f);
      }
      if (i === HHt)
        return n.enterScope("ArithmeticExpression");
      if (i === xHt || i === SHt || i === $Ht)
        return n.token(c);
      if (i === ZHt)
        return n.literal(c.replace(/^"|"$/g, ""));
      if (i === UHt)
        return n.literal(c === "true");
      if (i === jHt)
        return n.literal(parseFloat(c));
      if (i === WHt)
        return n.literal(null);
      if (i === BHt)
        return n.resolveName();
      if (i === _Ht || i === JHt)
        return n.declareName();
      if ((i === LCe || i === THt) && n.tokens.length > 0)
        throw new Error("uncleared name");
      if (i === LCe) {
        let u = n;
        for (; u.parent; )
          u = u.exitScope(c);
        return u;
      }
      return n;
    }
  });
}
const vBt = wBt({});
function bBt(r, e) {
  if (!e.length)
    return r.assign({
      value: null
    });
  if (e[0].name === "Name" && (e = yBt(e, ["m", "key"])), e.length !== 2)
    return r.assign({
      value: null
    });
  const [
    t,
    n
  ] = e, i = n?.computedValue(), s = t?.computedValue();
  return !s || typeof s != "object" || typeof i != "string" ? r.assign({
    value: null
  }) : r.assign({
    value: [$6(i), i].reduce((o, a) => s.get(a) || o, null)
  });
}
function yBt(r, e) {
  const t = {};
  for (let n = 0; n < r.length; n += 2) {
    const [i, s] = r.slice(n, n + 2);
    t[i.value] = s;
  }
  return e.map((n) => t[n]);
}
function F2(r) {
  return r[r.length - 1];
}
const CBt = Qw({
  StringLiteral: J.string,
  NumericLiteral: J.number,
  BooleanLiteral: J.bool,
  "AtLiteral!": J.special(J.string),
  CompareOp: J.compareOperator,
  ArithOp: J.arithmeticOperator,
  "for if then else some every satisfies between return": J.controlKeyword,
  "in instance of and or": J.operatorKeyword,
  function: J.definitionKeyword,
  as: J.keyword,
  "Type/...": J.typeName,
  Wildcard: J.special(J.variableName),
  null: J.null,
  LineComment: J.lineComment,
  BlockComment: J.blockComment,
  'VariableName! "?"': J.variableName,
  "DateTimeConstructor! SpecialFunctionName!": J.function(J.special(J.variableName)),
  "List Interval": J.list,
  Context: J.definition(J.literal),
  "Name!": J.definition(J.variableName),
  "Key/Name! ContextEntryType/Name!": J.definition(J.propertyName),
  "PathExpression/VariableName!": J.function(J.propertyName),
  "FormalParameter/ParameterName!": J.function(J.definition(J.variableName)),
  "( )": J.paren,
  "[ ]": J.squareBracket,
  "{ }": J.brace,
  ".": J.derefOperator,
  ", ;": J.separator,
  "..": J.punctuation
}), EBt = { __proto__: null, for: 10, in: 32, return: 36, if: 40, then: 42, else: 44, some: 48, every: 50, satisfies: 56, or: 60, and: 64, between: 72, instance: 86, of: 89, days: 99, time: 101, duration: 103, years: 105, months: 107, date: 109, list: 115, context: 121, function: 128, null: 154, true: 326, false: 326, "?": 168, external: 184, not: 209 }, ZRe = D4.deserialize({
  version: 14,
  states: "CpO`QYOOO`QYOOO$gQYOOOOQU'#Ce'#CeO$qQYO'#C`O%zQYO'#FPOOQQ'#Fe'#FeO&UQYO'#FeO`QYO'#DVOOQU'#Em'#EmO'rQ^O'#D]OOQO'#Fl'#FlO)oQWO'#DuOOQQ'#D|'#D|OOQQ'#D}'#D}OOQQ'#EO'#EOO)tOWO'#ERO)oQWO'#EPOOQQ'#EP'#EPOOQQ'#Fr'#FrOOQQ'#Fp'#FpOOQQ'#Fw'#FwOOQQ'#ET'#ETO`QYO'#EVOOQQ'#FR'#FRO)yQ^O'#FRO+pQYO'#EWO+wQWO'#EXOOQP'#F{'#F{O+|QXO'#E`OOQQ'#Fx'#FxOOQQ'#FQ'#FQQOQWOOOOQQ'#FS'#FSOOQQ'#F]'#F]O`QYO'#CoOOQQ'#F^'#F^O$qQYO'#CsO,XQYO'#DvOOQQ'#Fq'#FqO,^QYO'#EQOOQO'#EQ'#EQO`QYO'#EUO`QYO'#ETOOQO'#Fy'#FyQ,fQWOOO,kQYO'#DRO-bQWO'#FaOOQO'#DT'#DTO-mQYO'#FeO-tQWOOO.kQYO'#CdO.xQYO'#FUOOQQ'#Cc'#CcO.}QYO'#FTOOQQ'#Cb'#CbO/VQYO,58zO`QYO,59iOOQQ'#Fb'#FbOOQQ'#Fc'#FcOOQQ'#Fd'#FdO`QYO,59qO`QYO,59qO`QYO,59qOOQQ'#Fj'#FjO$qQYO,5:]OOQQ'#Fk'#FkO`QYO,5:_O`QYO,59eO`QYO,59gO`QYO,59iO0uQYO,59iO0|QYO,59rOOQQ,5:h,5:hO1RQYO,59qOOQU-E8k-E8kO2uQYO'#FmOOQQ,5:a,5:aOOQQ,5:m,5:mOOQQ,5:k,5:kO2|QYO,5:qOOQQ,5;m,5;mO3WQYO,5:pO3eQWO,5:rO3jQYO,5:sOOQP'#Ed'#EdO4aQXO'#EcOOQO'#Eb'#EbO4hQWO'#EaO4mQWO'#F|O4uQWO,5:zO4zQYO,59ZO.xQYO'#F`OOQQ'#Cw'#CwO5RQYO'#F_OOQQ'#Cv'#CvO5ZQYO,59_O5`QYO,5:bO5eQYO,5:lO3PQYO,5:pO5jQYO,5:oO`QYO'#EvQ,fQWOOO`QYO'#ElO6aQWO,5;{O`QYOOOOQR'#Cf'#CfOOQQ'#Ei'#EiO7ZQYO,59OO`QYO,5;pOOQQ'#FX'#FXO$qQYO'#EjO7kQYO,5;oO`QYO1G.fOOQQ'#F['#F[O8bQYO1G/TO;XQYO1G/]O;cQYO1G/]O;mQYO1G/]OOQQ1G/w1G/wO=aQYO1G/yO=hQYO1G/PO>qQYO1G/RO?zQYO1G/TO`QYO1G/TOOQQ1G/T1G/TO@bQYO1G/^O@|Q^O'#CdOB`QYO'#FoOOQO'#Dy'#DyOBjQWO'#DxOBoQWO'#FnOOQO'#Dw'#DwOOQO'#Dz'#DzOBwQWO,5<XOOQQ1G0]1G0]O`QYO1G0[O`QYO'#ErOB|QWO,5<ZOOQQ1G0^1G0^OCXQWO'#EZOCdQWO'#FzOOQO'#EY'#EYOClQWO1G0_OOQP'#Et'#EtOCqQXO,5:}O`QYO,5:{OCxQXO'#EuODQQWO,5<hOOQQ1G0f1G0fO`QYO1G.uO`QYO,5;zO$qQYO'#EkODYQYO,5;yO`QYO1G.yODbQYO1G/|OOQO1G0W1G0WOOQO,5;b,5;bOOQO-E8t-E8tOOQO,5;W,5;WOOQO-E8j-E8jODgQWOOOOQQ-E8g-E8gODlQYO'#CmOOQQ1G1[1G1[OOQQ,5;U,5;UOOQQ-E8h-E8hODyQYO7+$QOOQQ7+%e7+%eO`QYO7+$oOEpQYO,5:qOE}QWO7+$oOFSQYO'#D[OOQQ'#DZ'#DZOGvQYO'#D^OG{QYO'#D^OHQQYO'#D^OHVQ`O'#DfOH[Q`O'#DiOHaQ`O'#DmOOQQ7+$x7+$xO`QYO,5:dO$qQYO'#EqOHfQWO,5<YOOQQ1G1s1G1sOIlQYO7+%vOIyQYO,5;^OOQO-E8p-E8pO@bQYO,5:uO$qQYO'#EsOJWQWO,5<fOJ`QYO7+%yOOQP-E8r-E8rOJgQYO1G0gOOQO,5;a,5;aOOQO-E8s-E8sOJqQYO7+$aOJxQYO1G1fOOQQ,5;V,5;VOOQQ-E8i-E8iOKSQYO7+$eOOQO7+%h7+%hO`QYO,59XOKyQYO<<HZOOQQ<<HZ<<HZO$qQYO'#EnOMSQYO,59vONvQYO,59xON{QYO,59xO! QQYO,59xO! VQYO,5:QO$qQYO,5:TO! qQbO,5:XO! xQYO1G0OOOQO,5;],5;]OOQO-E8o-E8oO!!SQYO<<IbOOQQ<<Ib<<IbOOQO1G0a1G0aOOQO,5;_,5;_OOQO-E8q-E8qO!%OQYO'#E]OOQQ<<Ie<<IeO`QYO<<IeO`QYO<<G{O!%uQYO1G.sOOQQ,5;Y,5;YOOQQ-E8l-E8lO!&PQYO1G/dOOQQ1G/d1G/dO!&UQbO'#D]O!&gQ`O'#D[O!&rQ`O1G/lO!&wQWO'#DlO!&|Q`O'#FfOOQO'#Dk'#DkO!'UQ`O1G/oOOQO'#Dp'#DpO!'ZQ`O'#FhOOQO'#Do'#DoO!'cQ`O1G/sOOQQAN?PAN?PO!'hQYOAN=gOOQQ7+%O7+%OO!(_Q`O,59vOOQQ7+%W7+%WO! VQYO,5:WO$qQYO'#EoO!(jQ`O,5<QOOQQ7+%Z7+%ZO! VQYO'#EpO!(rQ`O,5<SO!(zQ`O7+%_OOQO1G/r1G/rOOQO,5;Z,5;ZOOQO-E8m-E8mOOQO,5;[,5;[OOQO-E8n-E8nO@bQYO<<HyOOQQAN>eAN>eO$qQYO'#EnO! VQYO<<HyO!)PQ`O7+%_O!)UQ`O1G/sO! qQbO,5:XO!)ZQ`O'#Dm",
  stateData: "!)h~O#qOS#rOSPOSQOS~OTqOZVO[UOdrOhtOitOs{OvgO!SyO!TyO!UvO!WxO!b|O!fzO!heO!owO!vhO#RlO#mRO#nRO$g]O$h^O$i_O$j`O~OTqO[UOdrOhtOitOs{OvgO!SyO!TyO!UvO!WxO!b|O!fzO!heO!owO!vhO#RlO#mRO#nRO$g]O$h^O$i_O$j`O~OZ!RO#[!SO~P!|O#mRO#nRO~OZ![O[![O]!]O^!]O_!^O`!iOn!fOp!gOr!ZOs!ZOt!hO{!jO!h!dO#y!bOv$`X~O#k#sX$q#sX~P$yO$g!kOT$XXZ$XX[$XXd$XXh$XXi$XXs$XXv$XX!S$XX!T$XX!U$XX!W$XX!b$XX!f$XX!h$XX!o$XX!v$XX#R$XX#m$XX#n$XX$h$XX$i$XX$j$XX~O#mRO#nROZ!PX[!PX]!PX^!PX_!PX`!PXn!PXp!PXr!PXs!PXt!PXv!PX{!PX!h!PX#k!PX#o!PX#y!PX$q!PX#}!PXx!PX#|!PX!f!PXe!PXb!PX#Q!PXf!PXl!PX~Ov!nO~O$h^O~O#o!sOZ#uX[#uX]#uX^#uX_#uX`#uXn#uXp#uXr#uXs#uXt#uXv#uX{#uX!h#uX#k#uX#y#uX$q#uX#}#uXx#uX#|#uX!f#uXe#uXb#uX#Q#uXf#uXl#uX~O!f$cP~P`Ov!vO~O#l!wO$h^O#Q$pP~Op#TO~Op#UOv!tX~O$q#XO~O#kuX#}uX$quXxuX#|uX!fuXeuXbuX#QuXfuXluX~P$yO#}#ZO#k$TXx$TX~O#k#ZX~P&UOv#]O~OZ#^O[#^O]#^O^#^O_#^O#mRO#nRO#y#^O#z#^O$ZWX~O`WXxWX#}WX~P-yO`#bO~O#}#cOb#wX~Ob#fO~OTqOZVO[UOdrOhtOitOs{O!SyO!TyO!UvO!WxO!b|O!fzO!heO!owO!vhO#RlO#mRO#nRO$g]O$h^O$i_O$j`O~Ov#pO~P/[O|#rO~O{!jO!h!dO#y!bOZya[ya]ya^ya_ya`yanyapyaryasyatyav$`X#kya$qya#}yaxya#|ya!fyaeyabya#Qyafyalya~Ox$cP~P`Ox#{O#|#|O~P$yO#|#|O#}#}O!f$cX~P$yO!f$PO~O#mRO#nROx$nP~OZ#^O[#^O]#^O^#^O_#^O#l!wO#y#^O#z#^O~O$Z#VX~P3uO$Z$WO~O#}$XO#Q$pX~O#Q$ZO~Oe$[O~P$yO#}$^Ol$RX~Ol$`O~O!V$aO~O!S$bO~O#k!wa$q!wa#}!wax!wa#|!wa!f!wae!wab!wa#Q!waf!wal!wa~P$yO#}#ZO#k$Tax$Ta~OZ#^O[#^O]#^O^#^O_#^O#mRO#nRO#y#^O#z#^O~O`Wa$ZWaxWa#}Wa~P6lO#}#cOb#wa~OZ![O[![O]!]O^!]O_!^O{!jO!h!dO#y!bOv$`X~O`qinqipqirqisqitqi#kqi$qqi#}qixqi#|qi!fqieqibqi#Qqifqilqi~P7sO_!^O{!jO!h!dO#y!bOZyi[yi`yinyipyiryisyityiv$`X#kyi$qyi#}yixyi#|yi!fyieyibyi#Qyifyilyi~O]!]O^!]O~P9kO]yi^yi~P9kO{!jO!h!dO#y!bOZyi[yi]yi^yi_yi`yinyipyiryisyityiv$`X#kyi$qyi#}yixyi#|yi!fyieyibyi#Qyifyilyi~O!f$nO~P$yO`!iOp!gOr!ZOs!ZOt!hOnmi#kmi$qmi#}mixmi#|mi!fmiemibmi#Qmifmilmi~P7sO`!iOr!ZOs!ZOt!hOnoipoi#koi$qoi#}oixoi#|oi!foieoiboi#Qoifoiloi~P7sO`!iOn!fOp$oOr!ZOs!ZOt!hO~P7sO!R$tO!U$uO!W$vO!Z$wO!^$xO!b$yO#mRO#nRO~OZ#aX[#aX]#aX^#aX_#aX`#aXn#aXp#aXr#aXs#aXt#aXv#aXx#aX{#aX!h#aX#m#aX#n#aX#o#aX#y#aX#}#aX~P-yO#}#}Ox$cX~P$yO$Z${O~O#}$|Ox$bX~Ox%OO~O#}#}O!f$cax$ca~O$Z%SOx!}X#}!}X~O#}%TOx$nX~Ox%VO~O$Z#Va~P3uO#l!wO$h^O~O#}$XO#Q$pa~O#}$^Ol$Ra~O!T%aO~OxpO~O#|%bObaX#}aX~P$yO#kSq$qSq#}SqxSq#|Sq!fSqeSqbSq#QSqfSqlSq~P$yOx#{O#|#|O#}uX~P$yOx%dO~O#y%eOZ!OX[!OX]!OX^!OX_!OX`!OXn!OXp!OXr!OXs!OXt!OXv!OX{!OX!h!OX#k!OX$q!OX#}!OXx!OX#|!OX!f!OXe!OXb!OX#Q!OXf!OXl!OX~Op%gO~Op%hO~Op%iO~O![%jO~O![%kO~O![%lO~O#}$|Ox$ba~OZ![O[![O]!]O^!]O_!^O`!iOn!fOp!gOr!ZOs!ZOt!hO{!jO#y!bOv$`X~Ox%qO!f%qO!h%pO~PHnO!f#fa#}#fax#fa~P$yO#}%TOx$na~O#O%wO~P`O#Q#Ti#}#Ti~P$yOf%xO~P$yOl$Si#}$Si~P$yO#kgq$qgq#}gqxgq#|gq!fgqegqbgq#Qgqfgqlgq~P$yO`qynqypqyrqysqytqy#kqy$qqy#}qyxqy#|qy!fqyeqybqy#Qqyfqylqy~P7sO#y%eOZ!Oa[!Oa]!Oa^!Oa_!Oa`!Oan!Oap!Oar!Oas!Oat!Oav!Oa{!Oa!h!Oa#k!Oa$q!Oa#}!Oax!Oa#|!Oa!f!Oae!Oab!Oa#Q!Oaf!Oal!Oa~O!S%|O~O!V%|O~O!S%}O~O!R$tO!U$uO!W$vO!Z$wO!^$xO!b&sO#mRO#nRO~O!X$[P~P! VOx!li#}!li~P$yOT$_XZ$_X[$_X]!xy^!xy_!xy`!xyd$_Xh$_Xi$_Xn!xyp!xyr!xys$_Xt!xyv$_X{!xy!S$_X!T$_X!U$_X!W$_X!b$_X!f$_X!h$_X!o$_X!v$_X#R$_X#k!xy#m$_X#n$_X#y!xy$g$_X$h$_X$i$_X$j$_X$q!xy#}!xyx!xy#|!xye!xyb!xy#Q!xyf!xyl!xy~O#k#PX$q#PX#}#PXx#PX#|#PX!f#PXe#PXb#PX#Q#PXf#PXl#PX~P$yObai#}ai~P$yO!T&]O~O#mRO#nRO!X!PX#y!PX#}!PX~O#y&nO!X!OX#}!OX~O!X&_O~O$Z&`O~O#}&aO!X$YX~O!X&cO~O#}&dO!X$[X~O!X&fO~O#kc!R$qc!R#}c!Rxc!R#|c!R!fc!Rec!Rbc!R#Qc!Rfc!Rlc!R~P$yO#y&nO!X!Oa#}!Oa~O#}&aO!X$Ya~O#}&dO!X$[a~O$]&lO~O$]&oO~O!X&pO~O![&rO~OQP_^$g]#y~",
  goto: "Du$qPPPP$rP%k%n%t&W'qPPPPPP'zP$rPPP$rPP'}(QP$rP$rP$rPPP(WP(cP$r$rPP(l)R)^)RPPPPPPP)RPP)RP*k*n)RP*t*z$rP$rP$r+R+z+},T+zP,]-U,],].U.}P$r/v$r0o0o1h1kP1qPP0o1w1}.Q2RPP2ZP2^2e2k2q2w4S4^4d4j4p4w4}5T5ZPPPPPPPP5a5j7q8j9c9fPP9jPP9p9s:l;e;h;l;q<`=O=o>hP>kP>o?b@T@|ASAV$rA]A]PPPPBU7qB}CvCyDr!mhOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR!YSQ!WSR$k#cS!US#cS#Ou$^W#u!n!v$|%TT&R%k&a#WXOPQWYgjsz{!Z!_!`!a!c!e!f!g!h!i#X#Z#]#a#e#p#r#|#}$W$[$]$`$o${%S%V%b%e%j%l%w%x&O&`&d&l&n&o&rb!TSu!v#c$^$|%T%k&aU#_!T#`#sR#s!nU#_!T#`#sT$U!x$VR$j#aR#SuQ#QuR%^$^U!PQ#]#pQ#q!iR$e#ZQpQQ$g#]R$q#pQ$z#rQ%r%SQ&Q%jU&V%l&d&rQ&g&`T&m&l&oc$s#r%S%j%l&`&d&l&o&r!liOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xQ#k!cU$r#r%S&lS%z%e&n]&P%j%l&`&d&o&rR&U%kQ&S%kR&h&aQ&Y%lR&q&rS&W%l&rR&j&d!mZOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR#z!nQ#w!nR%n$|S#v!n$|T$Q!v%T!mcOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!lcOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xQ!p`T!ym$X!maOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mbOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mfOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mnOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR$T!vQ$R!vR%s%TQ%v%VR&Z%wQ!{mR%Y$XT!zm$XS!xm$XT$U!x$VRpQS#`!T#sR$h#`Q#d!WR$l#dQ$_#QR%_$_Q#[!PR$f#[!vYOPQWgjsz{!Z!_!`!a!c!e!f!g!h!i!n#X#Z#]#a#e#p#r#|#}$W$[$]$`$o${%S%V%b%e%w%x&lS!mY&O_&O%j%l&`&d&n&o&rQ%f$rS%{%f&^R&^&PQ&b&SR&i&bQ&e&WR&k&eQ$}#wR%o$}S$O!t#tR%R$OQ%U$RR%t%UQ$V!xR%W$VQ$Y!{R%Z$YQ#Y}R$d#YQpOQ}PR$c#XUTOP#XW!OQ!i#Z#]Q!lWQ!rgQ!tjQ!}sQ#VzQ#W{Q#g!ZQ#h!_Q#i!`Q#j!aQ#l!eQ#m!fQ#n!gQ#o!hQ#t!nQ$i#aQ$m#eQ$p#pQ%P#|Q%Q#}Q%X$WQ%[$[Q%]$]Q%`$`Q%c$oQ%m${S%u%V%wQ%y%bR&[%x!moOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mSOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR!XST!VS#cQ#a!UR$]#OR#e!Y!msOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!muOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR#RuT#Pu$^V!QQ#]#p!X!_T!O!r!t!}#V#W#g#l#m#n#o#t$i$m$p%P%Q%X%[%]%`%c%m%u%y&[!Z!`T!O!r!t!}#V#W#g#h#l#m#n#o#t$i$m$p%P%Q%X%[%]%`%c%m%u%y&[!]!aT!O!r!t!}#V#W#g#h#i#l#m#n#o#t$i$m$p%P%Q%X%[%]%`%c%m%u%y&[!mWOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR&T%kT&X%l&r!a!cT!O!l!r!t!}#V#W#g#h#i#j#l#m#n#o#t$i$m$p%P%Q%X%[%]%`%c%m%u%y&[!a!eT!O!l!r!t!}#V#W#g#h#i#j#l#m#n#o#t$i$m$p%P%Q%X%[%]%`%c%m%u%y&[!m[OPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xQ!o[R!qaR#x!nQ!ujR#y!n!mdOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mjOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%x!mkOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR$S!v!mmOPQWgjsz{!Z!_!`!a!e!f!g!h!i!n#X#Z#]#a#e#p#|#}$W$[$]$`$o${%V%b%w%xR!|m",
  nodeNames: "⚠ LineComment BlockComment Expression ForExpression for InExpressions InExpression Name Identifier Identifier ArithOp ArithOp ArithOp ArithOp ArithOp in IterationContext return IfExpression if then else QuantifiedExpression some every InExpressions InExpression satisfies Disjunction or Conjunction and Comparison CompareOp CompareOp between PositiveUnaryTest ( PositiveUnaryTests ) ArithmeticExpression InstanceOfExpression instance of Type QualifiedName VariableName SpecialType days time duration years months date > ListType list < ContextType context ContextEntryTypes ContextEntryType FunctionType function ArgumentTypes ArgumentType PathExpression ] FilterExpression [ FunctionInvocation SpecialFunctionName NamedParameters NamedParameter ParameterName PositionalParameters null NumericLiteral StringLiteral BooleanLiteral DateTimeLiteral DateTimeConstructor AtLiteral ? SimplePositiveUnaryTest Interval ParenthesizedExpression List FunctionDefinition FormalParameters FormalParameter external FunctionBody } { Context ContextEntry Key Name Identifier Expressions UnaryTests Wildcard not",
  maxTerm: 171,
  context: vBt,
  nodeProps: [
    ["closedBy", 38, ")", 70, "]", 95, "}"],
    ["openedBy", 40, "(", 68, "[", 94, "{"],
    ["group", -5, 77, 78, 79, 80, 81, "Literal"]
  ],
  propSources: [CBt],
  skippedNodes: [0, 1, 2],
  repeatNodeCount: 14,
  tokenData: "+l~RuXY#fYZ$ZZ[#f]^$Zpq#fqr$`rs$kwx&cxy&hyz&mz{&r{|'P|}'U}!O'Z!O!P'h!P!Q(Q!Q![){![!]*^!]!^*c!^!_*h!_!`$f!`!a*w!b!c+R!}#O+W#P#Q+]#Q#R&z#o#p+b#q#r+g$f$g#f#BY#BZ#f$IS$I_#f$I|$I}$Z$I}$JO$Z$JT$JU#f$KV$KW#f&FU&FV#f?HT?HU#f~#kY#q~XY#fZ[#fpq#f$f$g#f#BY#BZ#f$IS$I_#f$JT$JU#f$KV$KW#f&FU&FV#f?HT?HU#f~$`O#r~~$cP!_!`$f~$kOr~~$pW$h~OY$kZr$krs%Ys#O$k#O#P%_#P;'S$k;'S;=`&]<%lO$k~%_O$h~~%bRO;'S$k;'S;=`%k;=`O$k~%pX$h~OY$kZr$krs%Ys#O$k#O#P%_#P;'S$k;'S;=`&];=`<%l$k<%lO$k~&`P;=`<%l$k~&hO#z~~&mOv~~&rOx~~&wP^~z{&z~'PO_~~'UO[~~'ZO#}~R'`PZP!`!a'cQ'hO$]Q~'mQ#y~!O!P's!Q!['x~'xO#|~~'}P$g~!Q!['x~(VQ]~z{(]!P!Q)d~(`TOz(]z{(o{;'S(];'S;=`)^<%lO(]~(rVOz(]z{(o{!P(]!P!Q)X!Q;'S(];'S;=`)^<%lO(]~)^OQ~~)aP;=`<%l(]~)iSP~OY)dZ;'S)d;'S;=`)u<%lO)d~)xP;=`<%l)d~*QQ$g~!O!P*W!Q![){~*ZP!Q!['x~*cO$Z~~*hO$q~R*oP![QsP!_!`*rP*wOsPR+OP!XQsP!_!`*r~+WO$j~~+]O!h~~+bO!f~~+gO#R~~+lO#Q~",
  tokenizers: [hBt, cBt, dBt, 0, 1],
  topRules: { Expression: [0, 3], Expressions: [1, 101], UnaryTests: [2, 102] },
  dynamicPrecedences: { 31: -1, 71: -1, 73: -1 },
  specialized: [{ term: 121, get: (r) => EBt[r] || -1 }],
  tokenPrec: 2500
});
let li = class URe {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, t, n) {
    [e, t] = kg(this, e, t);
    let i = [];
    return this.decompose(
      0,
      e,
      i,
      2
      /* Open.To */
    ), n.length && n.decompose(
      0,
      n.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      t,
      this.length,
      i,
      1
      /* Open.From */
    ), Qc.from(i, this.length - (t - e) + n.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, t = this.length) {
    [e, t] = kg(this, e, t);
    let n = [];
    return this.decompose(e, t, n, 0), Qc.from(n, t - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let t = this.scanIdentical(e, 1), n = this.length - this.scanIdentical(e, -1), i = new p3(this), s = new p3(e);
    for (let o = t, a = t; ; ) {
      if (i.next(o), s.next(o), o = 0, i.lineBreak != s.lineBreak || i.done != s.done || i.value != s.value)
        return !1;
      if (a += i.value.length, i.done || a >= n)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new p3(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, t = this.length) {
    return new qRe(this, e, t);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, t) {
    let n;
    if (e == null)
      n = this.iter();
    else {
      t == null && (t = this.lines + 1);
      let i = this.line(e).from;
      n = this.iterRange(i, Math.max(i, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to));
    }
    return new GRe(n);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? URe.empty : e.length <= 32 ? new ur(e) : Qc.from(ur.split(e, []));
  }
};
class ur extends li {
  constructor(e, t = _Bt(e)) {
    super(), this.text = e, this.length = t;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, t, n, i) {
    for (let s = 0; ; s++) {
      let o = this.text[s], a = i + o.length;
      if ((t ? n : a) >= e)
        return new xBt(i, a, n, o);
      i = a + 1, n++;
    }
  }
  decompose(e, t, n, i) {
    let s = e <= 0 && t >= this.length ? this : new ur(OCe(this.text, e, t), Math.min(t, this.length) - Math.max(0, e));
    if (i & 1) {
      let o = n.pop(), a = e8(s.text, o.text.slice(), 0, s.length);
      if (a.length <= 32)
        n.push(new ur(a, o.length + s.length));
      else {
        let l = a.length >> 1;
        n.push(new ur(a.slice(0, l)), new ur(a.slice(l)));
      }
    } else
      n.push(s);
  }
  replace(e, t, n) {
    if (!(n instanceof ur))
      return super.replace(e, t, n);
    [e, t] = kg(this, e, t);
    let i = e8(this.text, e8(n.text, OCe(this.text, 0, e)), t), s = this.length + n.length - (t - e);
    return i.length <= 32 ? new ur(i, s) : Qc.from(ur.split(i, []), s);
  }
  sliceString(e, t = this.length, n = `
`) {
    [e, t] = kg(this, e, t);
    let i = "";
    for (let s = 0, o = 0; s <= t && o < this.text.length; o++) {
      let a = this.text[o], l = s + a.length;
      s > e && o && (i += n), e < l && t > s && (i += a.slice(Math.max(0, e - s), t - s)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let t of this.text)
      e.push(t);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, t) {
    let n = [], i = -1;
    for (let s of e)
      n.push(s), i += s.length + 1, n.length == 32 && (t.push(new ur(n, i)), n = [], i = -1);
    return i > -1 && t.push(new ur(n, i)), t;
  }
}
class Qc extends li {
  constructor(e, t) {
    super(), this.children = e, this.length = t, this.lines = 0;
    for (let n of e)
      this.lines += n.lines;
  }
  lineInner(e, t, n, i) {
    for (let s = 0; ; s++) {
      let o = this.children[s], a = i + o.length, l = n + o.lines - 1;
      if ((t ? l : a) >= e)
        return o.lineInner(e, t, n, i);
      i = a + 1, n = l + 1;
    }
  }
  decompose(e, t, n, i) {
    for (let s = 0, o = 0; o <= t && s < this.children.length; s++) {
      let a = this.children[s], l = o + a.length;
      if (e <= l && t >= o) {
        let c = i & ((o <= e ? 1 : 0) | (l >= t ? 2 : 0));
        o >= e && l <= t && !c ? n.push(a) : a.decompose(e - o, t - o, n, c);
      }
      o = l + 1;
    }
  }
  replace(e, t, n) {
    if ([e, t] = kg(this, e, t), n.lines < this.lines)
      for (let i = 0, s = 0; i < this.children.length; i++) {
        let o = this.children[i], a = s + o.length;
        if (e >= s && t <= a) {
          let l = o.replace(e - s, t - s, n), c = this.lines - o.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let d = this.children.slice();
            return d[i] = l, new Qc(d, this.length - (t - e) + n.length);
          }
          return super.replace(s, a, l);
        }
        s = a + 1;
      }
    return super.replace(e, t, n);
  }
  sliceString(e, t = this.length, n = `
`) {
    [e, t] = kg(this, e, t);
    let i = "";
    for (let s = 0, o = 0; s < this.children.length && o <= t; s++) {
      let a = this.children[s], l = o + a.length;
      o > e && s && (i += n), e < l && t > o && (i += a.sliceString(e - o, t - o, n)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let t of this.children)
      t.flatten(e);
  }
  scanIdentical(e, t) {
    if (!(e instanceof Qc))
      return 0;
    let n = 0, [i, s, o, a] = t > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; i += t, s += t) {
      if (i == o || s == a)
        return n;
      let l = this.children[i], c = e.children[s];
      if (l != c)
        return n + l.scanIdentical(c, t);
      n += l.length + 1;
    }
  }
  static from(e, t = e.reduce((n, i) => n + i.length + 1, -1)) {
    let n = 0;
    for (let p of e)
      n += p.lines;
    if (n < 32) {
      let p = [];
      for (let g of e)
        g.flatten(p);
      return new ur(p, t);
    }
    let i = Math.max(
      32,
      n >> 5
      /* Tree.BranchShift */
    ), s = i << 1, o = i >> 1, a = [], l = 0, c = -1, d = [];
    function u(p) {
      let g;
      if (p.lines > s && p instanceof Qc)
        for (let m of p.children)
          u(m);
      else p.lines > o && (l > o || !l) ? (f(), a.push(p)) : p instanceof ur && l && (g = d[d.length - 1]) instanceof ur && p.lines + g.lines <= 32 ? (l += p.lines, c += p.length + 1, d[d.length - 1] = new ur(g.text.concat(p.text), g.length + 1 + p.length)) : (l + p.lines > i && f(), l += p.lines, c += p.length + 1, d.push(p));
    }
    function f() {
      l != 0 && (a.push(d.length == 1 ? d[0] : Qc.from(d, c)), c = -1, l = d.length = 0);
    }
    for (let p of e)
      u(p);
    return f(), a.length == 1 ? a[0] : new Qc(a, t);
  }
}
li.empty = /* @__PURE__ */ new ur([""], 0);
function _Bt(r) {
  let e = -1;
  for (let t of r)
    e += t.length + 1;
  return e;
}
function e8(r, e, t = 0, n = 1e9) {
  for (let i = 0, s = 0, o = !0; s < r.length && i <= n; s++) {
    let a = r[s], l = i + a.length;
    l >= t && (l > n && (a = a.slice(0, n - i)), i < t && (a = a.slice(t - i)), o ? (e[e.length - 1] += a, o = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function OCe(r, e, t) {
  return e8(r, [""], e, t);
}
class p3 {
  constructor(e, t = 1) {
    this.dir = t, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [t > 0 ? 1 : (e instanceof ur ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, t) {
    for (this.done = this.lineBreak = !1; ; ) {
      let n = this.nodes.length - 1, i = this.nodes[n], s = this.offsets[n], o = s >> 1, a = i instanceof ur ? i.text.length : i.children.length;
      if (o == (t > 0 ? a : 0)) {
        if (n == 0)
          return this.done = !0, this.value = "", this;
        t > 0 && this.offsets[n - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((s & 1) == (t > 0 ? 0 : 1)) {
        if (this.offsets[n] += t, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (i instanceof ur) {
        let l = i.text[o + (t < 0 ? -1 : 0)];
        if (this.offsets[n] += t, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : t > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = i.children[o + (t < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[n] += t) : (t < 0 && this.offsets[n]--, this.nodes.push(l), this.offsets.push(t > 0 ? 1 : (l instanceof ur ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class qRe {
  constructor(e, t, n) {
    this.value = "", this.done = !1, this.cursor = new p3(e, t > n ? -1 : 1), this.pos = t > n ? e.length : 0, this.from = Math.min(t, n), this.to = Math.max(t, n);
  }
  nextInner(e, t) {
    if (t < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
    let n = t < 0 ? this.pos - this.from : this.to - this.pos;
    e > n && (e = n), n -= e;
    let { value: i } = this.cursor.next(e);
    return this.pos += (i.length + e) * t, this.value = i.length <= n ? i : t < 0 ? i.slice(i.length - n) : i.slice(0, n), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class GRe {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: t, lineBreak: n, value: i } = this.inner.next(e);
    return t && this.afterBreak ? (this.value = "", this.afterBreak = !1) : t ? (this.done = !0, this.value = "") : n ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (li.prototype[Symbol.iterator] = function() {
  return this.iter();
}, p3.prototype[Symbol.iterator] = qRe.prototype[Symbol.iterator] = GRe.prototype[Symbol.iterator] = function() {
  return this;
});
let xBt = class {
  /**
  @internal
  */
  constructor(e, t, n, i) {
    this.from = e, this.to = t, this.number = n, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
};
function kg(r, e, t) {
  return e = Math.max(0, Math.min(r.length, e)), [e, Math.max(e, Math.min(r.length, t))];
}
let Pp = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((r) => r ? parseInt(r, 36) : 1);
for (let r = 1; r < Pp.length; r++)
  Pp[r] += Pp[r - 1];
function SBt(r) {
  for (let e = 1; e < Pp.length; e += 2)
    if (Pp[e] > r)
      return Pp[e - 1] <= r;
  return !1;
}
function RCe(r) {
  return r >= 127462 && r <= 127487;
}
const VCe = 8205;
function ro(r, e, t = !0, n = !0) {
  return (t ? QRe : MBt)(r, e, n);
}
function QRe(r, e, t) {
  if (e == r.length)
    return e;
  e && KRe(r.charCodeAt(e)) && YRe(r.charCodeAt(e - 1)) && e--;
  let n = ta(r, e);
  for (e += Kc(n); e < r.length; ) {
    let i = ta(r, e);
    if (n == VCe || i == VCe || t && SBt(i))
      e += Kc(i), n = i;
    else if (RCe(i)) {
      let s = 0, o = e - 2;
      for (; o >= 0 && RCe(ta(r, o)); )
        s++, o -= 2;
      if (s % 2 == 0)
        break;
      e += 2;
    } else
      break;
  }
  return e;
}
function MBt(r, e, t) {
  for (; e > 0; ) {
    let n = QRe(r, e - 2, t);
    if (n < e)
      return n;
    e--;
  }
  return 0;
}
function KRe(r) {
  return r >= 56320 && r < 57344;
}
function YRe(r) {
  return r >= 55296 && r < 56320;
}
function ta(r, e) {
  let t = r.charCodeAt(e);
  if (!YRe(t) || e + 1 == r.length)
    return t;
  let n = r.charCodeAt(e + 1);
  return KRe(n) ? (t - 55296 << 10) + (n - 56320) + 65536 : t;
}
function XRe(r) {
  return r <= 65535 ? String.fromCharCode(r) : (r -= 65536, String.fromCharCode((r >> 10) + 55296, (r & 1023) + 56320));
}
function Kc(r) {
  return r < 65536 ? 1 : 2;
}
const zN = /\r\n?|\n/;
var ps = /* @__PURE__ */ function(r) {
  return r[r.Simple = 0] = "Simple", r[r.TrackDel = 1] = "TrackDel", r[r.TrackBefore = 2] = "TrackBefore", r[r.TrackAfter = 3] = "TrackAfter", r;
}(ps || (ps = {}));
class Id {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let t = 0; t < this.sections.length; t += 2)
      e += this.sections[t];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let t = 0; t < this.sections.length; t += 2) {
      let n = this.sections[t + 1];
      e += n < 0 ? this.sections[t] : n;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let t = 0, n = 0, i = 0; t < this.sections.length; ) {
      let s = this.sections[t++], o = this.sections[t++];
      o < 0 ? (e(n, i, s), i += s) : i += o, n += s;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, t = !1) {
    WN(this, e, t);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let t = 0; t < this.sections.length; ) {
      let n = this.sections[t++], i = this.sections[t++];
      i < 0 ? e.push(n, i) : e.push(i, n);
    }
    return new Id(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : JRe(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `other` happened before the ones in `this`.
  */
  mapDesc(e, t = !1) {
    return e.empty ? this : jN(this, e, t);
  }
  mapPos(e, t = -1, n = ps.Simple) {
    let i = 0, s = 0;
    for (let o = 0; o < this.sections.length; ) {
      let a = this.sections[o++], l = this.sections[o++], c = i + a;
      if (l < 0) {
        if (c > e)
          return s + (e - i);
        s += a;
      } else {
        if (n != ps.Simple && c >= e && (n == ps.TrackDel && i < e && c > e || n == ps.TrackBefore && i < e || n == ps.TrackAfter && c > e))
          return null;
        if (c > e || c == e && t < 0 && !a)
          return e == i || t < 0 ? s : s + l;
        s += l;
      }
      i = c;
    }
    if (e > i)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    return s;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, t = e) {
    for (let n = 0, i = 0; n < this.sections.length && i <= t; ) {
      let s = this.sections[n++], o = this.sections[n++], a = i + s;
      if (o >= 0 && i <= t && a >= e)
        return i < e && a > t ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 0; t < this.sections.length; ) {
      let n = this.sections[t++], i = this.sections[t++];
      e += (e ? " " : "") + n + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((t) => typeof t != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new Id(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new Id(e);
  }
}
class es extends Id {
  constructor(e, t) {
    super(e), this.inserted = t;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return WN(this, (t, n, i, s, o) => e = e.replace(i, i + (n - t), o), !1), e;
  }
  mapDesc(e, t = !1) {
    return jN(this, e, t, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let t = this.sections.slice(), n = [];
    for (let i = 0, s = 0; i < t.length; i += 2) {
      let o = t[i], a = t[i + 1];
      if (a >= 0) {
        t[i] = a, t[i + 1] = o;
        let l = i >> 1;
        for (; n.length < l; )
          n.push(li.empty);
        n.push(o ? e.slice(s, s + o) : li.empty);
      }
      s += o;
    }
    return new es(t, n);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : JRe(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, t = !1) {
    return e.empty ? this : jN(this, e, t, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, t = !1) {
    WN(this, e, t);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return Id.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let t = [], n = [], i = [], s = new L4(this);
    e: for (let o = 0, a = 0; ; ) {
      let l = o == e.length ? 1e9 : e[o++];
      for (; a < l || a == l && s.len == 0; ) {
        if (s.done)
          break e;
        let d = Math.min(s.len, l - a);
        Ts(i, d, -1);
        let u = s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0;
        Ts(t, d, u), u > 0 && Zu(n, t, s.text), s.forward(d), a += d;
      }
      let c = e[o++];
      for (; a < c; ) {
        if (s.done)
          break e;
        let d = Math.min(s.len, c - a);
        Ts(t, d, -1), Ts(i, d, s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0), s.forward(d), a += d;
      }
    }
    return {
      changes: new es(t, n),
      filtered: Id.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let t = 0; t < this.sections.length; t += 2) {
      let n = this.sections[t], i = this.sections[t + 1];
      i < 0 ? e.push(n) : i == 0 ? e.push([n]) : e.push([n].concat(this.inserted[t >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, t, n) {
    let i = [], s = [], o = 0, a = null;
    function l(d = !1) {
      if (!d && !i.length)
        return;
      o < t && Ts(i, t - o, -1);
      let u = new es(i, s);
      a = a ? a.compose(u.map(a)) : u, i = [], s = [], o = 0;
    }
    function c(d) {
      if (Array.isArray(d))
        for (let u of d)
          c(u);
      else if (d instanceof es) {
        if (d.length != t)
          throw new RangeError(`Mismatched change set length (got ${d.length}, expected ${t})`);
        l(), a = a ? a.compose(d.map(a)) : d;
      } else {
        let { from: u, to: f = u, insert: p } = d;
        if (u > f || u < 0 || f > t)
          throw new RangeError(`Invalid change range ${u} to ${f} (in doc of length ${t})`);
        let g = p ? typeof p == "string" ? li.of(p.split(n || zN)) : p : li.empty, m = g.length;
        if (u == f && m == 0)
          return;
        u < o && l(), u > o && Ts(i, u - o, -1), Ts(i, f - u, m), Zu(s, i, g), o = f;
      }
    }
    return c(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new es(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let t = [], n = [];
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (typeof s == "number")
        t.push(s, -1);
      else {
        if (!Array.isArray(s) || typeof s[0] != "number" || s.some((o, a) => a && typeof o != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (s.length == 1)
          t.push(s[0], 0);
        else {
          for (; n.length < i; )
            n.push(li.empty);
          n[i] = li.of(s.slice(1)), t.push(s[0], n[i].length);
        }
      }
    }
    return new es(t, n);
  }
  /**
  @internal
  */
  static createSet(e, t) {
    return new es(e, t);
  }
}
function Ts(r, e, t, n = !1) {
  if (e == 0 && t <= 0)
    return;
  let i = r.length - 2;
  i >= 0 && t <= 0 && t == r[i + 1] ? r[i] += e : e == 0 && r[i] == 0 ? r[i + 1] += t : n ? (r[i] += e, r[i + 1] += t) : r.push(e, t);
}
function Zu(r, e, t) {
  if (t.length == 0)
    return;
  let n = e.length - 2 >> 1;
  if (n < r.length)
    r[r.length - 1] = r[r.length - 1].append(t);
  else {
    for (; r.length < n; )
      r.push(li.empty);
    r.push(t);
  }
}
function WN(r, e, t) {
  let n = r.inserted;
  for (let i = 0, s = 0, o = 0; o < r.sections.length; ) {
    let a = r.sections[o++], l = r.sections[o++];
    if (l < 0)
      i += a, s += a;
    else {
      let c = i, d = s, u = li.empty;
      for (; c += a, d += l, l && n && (u = u.append(n[o - 2 >> 1])), !(t || o == r.sections.length || r.sections[o + 1] < 0); )
        a = r.sections[o++], l = r.sections[o++];
      e(i, c, s, d, u), i = c, s = d;
    }
  }
}
function jN(r, e, t, n = !1) {
  let i = [], s = n ? [] : null, o = new L4(r), a = new L4(e);
  for (let l = -1; ; )
    if (o.ins == -1 && a.ins == -1) {
      let c = Math.min(o.len, a.len);
      Ts(i, c, -1), o.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (o.ins < 0 || l == o.i || o.off == 0 && (a.len < o.len || a.len == o.len && !t))) {
      let c = a.len;
      for (Ts(i, a.ins, -1); c; ) {
        let d = Math.min(o.len, c);
        o.ins >= 0 && l < o.i && o.len <= d && (Ts(i, 0, o.ins), s && Zu(s, i, o.text), l = o.i), o.forward(d), c -= d;
      }
      a.next();
    } else if (o.ins >= 0) {
      let c = 0, d = o.len;
      for (; d; )
        if (a.ins == -1) {
          let u = Math.min(d, a.len);
          c += u, d -= u, a.forward(u);
        } else if (a.ins == 0 && a.len < d)
          d -= a.len, a.next();
        else
          break;
      Ts(i, c, l < o.i ? o.ins : 0), s && l < o.i && Zu(s, i, o.text), l = o.i, o.forward(o.len - d);
    } else {
      if (o.done && a.done)
        return s ? es.createSet(i, s) : Id.create(i);
      throw new Error("Mismatched change set lengths");
    }
}
function JRe(r, e, t = !1) {
  let n = [], i = t ? [] : null, s = new L4(r), o = new L4(e);
  for (let a = !1; ; ) {
    if (s.done && o.done)
      return i ? es.createSet(n, i) : Id.create(n);
    if (s.ins == 0)
      Ts(n, s.len, 0, a), s.next();
    else if (o.len == 0 && !o.done)
      Ts(n, 0, o.ins, a), i && Zu(i, n, o.text), o.next();
    else {
      if (s.done || o.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(s.len2, o.len), c = n.length;
        if (s.ins == -1) {
          let d = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          Ts(n, l, d, a), i && d && Zu(i, n, o.text);
        } else o.ins == -1 ? (Ts(n, s.off ? 0 : s.len, l, a), i && Zu(i, n, s.textBit(l))) : (Ts(n, s.off ? 0 : s.len, o.off ? 0 : o.ins, a), i && !o.off && Zu(i, n, o.text));
        a = (s.ins > l || o.ins >= 0 && o.len > l) && (a || n.length > c), s.forward2(l), o.forward(l);
      }
    }
  }
}
class L4 {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, t = this.i - 2 >> 1;
    return t >= e.length ? li.empty : e[t];
  }
  textBit(e) {
    let { inserted: t } = this.set, n = this.i - 2 >> 1;
    return n >= t.length && !e ? li.empty : t[n].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class P0 {
  constructor(e, t, n) {
    this.from = e, this.to = t, this.flags = n;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, t = -1) {
    let n, i;
    return this.empty ? n = i = e.mapPos(this.from, t) : (n = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), n == this.from && i == this.to ? this : new P0(n, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, t = e) {
    if (e <= this.anchor && t >= this.anchor)
      return Be.range(e, t);
    let n = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
    return Be.range(this.anchor, n);
  }
  /**
  Compare this range to another range.
  */
  eq(e, t = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!t || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return Be.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, t, n) {
    return new P0(e, t, n);
  }
}
class Be {
  constructor(e, t) {
    this.ranges = e, this.mainIndex = t;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, t = -1) {
    return e.empty ? this : Be.create(this.ranges.map((n) => n.map(e, t)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, t = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let n = 0; n < this.ranges.length; n++)
      if (!this.ranges[n].eq(e.ranges[n], t))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new Be([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, t = !0) {
    return Be.create([e].concat(this.ranges), t ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, t = this.mainIndex) {
    let n = this.ranges.slice();
    return n[t] = e, Be.create(n, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new Be(e.ranges.map((t) => P0.fromJSON(t)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, t = e) {
    return new Be([Be.range(e, t)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, t = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let n = 0, i = 0; i < e.length; i++) {
      let s = e[i];
      if (s.empty ? s.from <= n : s.from < n)
        return Be.normalized(e.slice(), t);
      n = s.to;
    }
    return new Be(e, t);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, t = 0, n, i) {
    return P0.create(e, e, (t == 0 ? 0 : t < 0 ? 8 : 16) | (n == null ? 7 : Math.min(6, n)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, t, n, i) {
    let s = (n ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return t < e ? P0.create(t, e, 48 | s) : P0.create(e, t, (t > e ? 8 : 0) | s);
  }
  /**
  @internal
  */
  static normalized(e, t = 0) {
    let n = e[t];
    e.sort((i, s) => i.from - s.from), t = e.indexOf(n);
    for (let i = 1; i < e.length; i++) {
      let s = e[i], o = e[i - 1];
      if (s.empty ? s.from <= o.to : s.from < o.to) {
        let a = o.from, l = Math.max(s.to, o.to);
        i <= t && t--, e.splice(--i, 2, s.anchor > s.head ? Be.range(l, a) : Be.range(a, l));
      }
    }
    return new Be(e, t);
  }
}
function $Re(r, e) {
  for (let t of r.ranges)
    if (t.to > e)
      throw new RangeError("Selection points outside of document");
}
let zV = 0;
class bt {
  constructor(e, t, n, i, s) {
    this.combine = e, this.compareInput = t, this.compare = n, this.isStatic = i, this.id = zV++, this.default = e([]), this.extensions = typeof s == "function" ? s(this) : s;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new bt(e.combine || ((t) => t), e.compareInput || ((t, n) => t === n), e.compare || (e.combine ? (t, n) => t === n : WV), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new t8([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, t) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new t8(e, this, 1, t);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, t) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new t8(e, this, 2, t);
  }
  from(e, t) {
    return t || (t = (n) => n), this.compute([e], (n) => t(n.field(e)));
  }
}
function WV(r, e) {
  return r == e || r.length == e.length && r.every((t, n) => t === e[n]);
}
class t8 {
  constructor(e, t, n, i) {
    this.dependencies = e, this.facet = t, this.type = n, this.value = i, this.id = zV++;
  }
  dynamicSlot(e) {
    var t;
    let n = this.value, i = this.facet.compareInput, s = this.id, o = e[s] >> 1, a = this.type == 2, l = !1, c = !1, d = [];
    for (let u of this.dependencies)
      u == "doc" ? l = !0 : u == "selection" ? c = !0 : (((t = e[u.id]) !== null && t !== void 0 ? t : 1) & 1) == 0 && d.push(e[u.id]);
    return {
      create(u) {
        return u.values[o] = n(u), 1;
      },
      update(u, f) {
        if (l && f.docChanged || c && (f.docChanged || f.selection) || ZN(u, d)) {
          let p = n(u);
          if (a ? !HCe(p, u.values[o], i) : !i(p, u.values[o]))
            return u.values[o] = p, 1;
        }
        return 0;
      },
      reconfigure: (u, f) => {
        let p, g = f.config.address[s];
        if (g != null) {
          let m = Ob(f, g);
          if (this.dependencies.every((A) => A instanceof bt ? f.facet(A) === u.facet(A) : A instanceof ka ? f.field(A, !1) == u.field(A, !1) : !0) || (a ? HCe(p = n(u), m, i) : i(p = n(u), m)))
            return u.values[o] = m, 0;
        } else
          p = n(u);
        return u.values[o] = p, 1;
      }
    };
  }
}
function HCe(r, e, t) {
  if (r.length != e.length)
    return !1;
  for (let n = 0; n < r.length; n++)
    if (!t(r[n], e[n]))
      return !1;
  return !0;
}
function ZN(r, e) {
  let t = !1;
  for (let n of e)
    g3(r, n) & 1 && (t = !0);
  return t;
}
function DBt(r, e, t) {
  let n = t.map((l) => r[l.id]), i = t.map((l) => l.type), s = n.filter((l) => !(l & 1)), o = r[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let d = 0; d < n.length; d++) {
      let u = Ob(l, n[d]);
      if (i[d] == 2)
        for (let f of u)
          c.push(f);
      else
        c.push(u);
    }
    return e.combine(c);
  }
  return {
    create(l) {
      for (let c of n)
        g3(l, c);
      return l.values[o] = a(l), 1;
    },
    update(l, c) {
      if (!ZN(l, s))
        return 0;
      let d = a(l);
      return e.compare(d, l.values[o]) ? 0 : (l.values[o] = d, 1);
    },
    reconfigure(l, c) {
      let d = ZN(l, n), u = c.config.facets[e.id], f = c.facet(e);
      if (u && !d && WV(t, u))
        return l.values[o] = f, 0;
      let p = a(l);
      return e.compare(p, f) ? (l.values[o] = f, 0) : (l.values[o] = p, 1);
    }
  };
}
const BCe = /* @__PURE__ */ bt.define({ static: !0 });
class ka {
  constructor(e, t, n, i, s) {
    this.id = e, this.createF = t, this.updateF = n, this.compareF = i, this.spec = s, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let t = new ka(zV++, e.create, e.update, e.compare || ((n, i) => n === i), e);
    return e.provide && (t.provides = e.provide(t)), t;
  }
  create(e) {
    let t = e.facet(BCe).find((n) => n.field == this);
    return (t?.create || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let t = e[this.id] >> 1;
    return {
      create: (n) => (n.values[t] = this.create(n), 1),
      update: (n, i) => {
        let s = n.values[t], o = this.updateF(s, i);
        return this.compareF(s, o) ? 0 : (n.values[t] = o, 1);
      },
      reconfigure: (n, i) => i.config.address[this.id] != null ? (n.values[t] = i.field(this), 0) : (n.values[t] = this.create(n), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, BCe.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const D0 = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function tA(r) {
  return (e) => new eVe(e, r);
}
const vm = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ tA(D0.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ tA(D0.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ tA(D0.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ tA(D0.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ tA(D0.lowest)
};
class eVe {
  constructor(e, t) {
    this.inner = e, this.prec = t;
  }
}
class Yw {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new UN(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return Yw.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class UN {
  constructor(e, t) {
    this.compartment = e, this.inner = t;
  }
}
class Ib {
  constructor(e, t, n, i, s, o) {
    for (this.base = e, this.compartments = t, this.dynamicSlots = n, this.address = i, this.staticValues = s, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < n.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let t = this.address[e.id];
    return t == null ? e.default : this.staticValues[t >> 1];
  }
  static resolve(e, t, n) {
    let i = [], s = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Map();
    for (let f of LBt(e, t, o))
      f instanceof ka ? i.push(f) : (s[f.facet.id] || (s[f.facet.id] = [])).push(f);
    let a = /* @__PURE__ */ Object.create(null), l = [], c = [];
    for (let f of i)
      a[f.id] = c.length << 1, c.push((p) => f.slot(p));
    let d = n?.config.facets;
    for (let f in s) {
      let p = s[f], g = p[0].facet, m = d && d[f] || [];
      if (p.every(
        (A) => A.type == 0
        /* Provider.Static */
      ))
        if (a[g.id] = l.length << 1 | 1, WV(m, p))
          l.push(n.facet(g));
        else {
          let A = g.combine(p.map((w) => w.value));
          l.push(n && g.compare(A, n.facet(g)) ? n.facet(g) : A);
        }
      else {
        for (let A of p)
          A.type == 0 ? (a[A.id] = l.length << 1 | 1, l.push(A.value)) : (a[A.id] = c.length << 1, c.push((w) => A.dynamicSlot(w)));
        a[g.id] = c.length << 1, c.push((A) => DBt(A, g, p));
      }
    }
    let u = c.map((f) => f(a));
    return new Ib(e, o, u, a, l, s);
  }
}
function LBt(r, e, t) {
  let n = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function s(o, a) {
    let l = i.get(o);
    if (l != null) {
      if (l <= a)
        return;
      let c = n[l].indexOf(o);
      c > -1 && n[l].splice(c, 1), o instanceof UN && t.delete(o.compartment);
    }
    if (i.set(o, a), Array.isArray(o))
      for (let c of o)
        s(c, a);
    else if (o instanceof UN) {
      if (t.has(o.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = e.get(o.compartment) || o.inner;
      t.set(o.compartment, c), s(c, a);
    } else if (o instanceof eVe)
      s(o.inner, o.prec);
    else if (o instanceof ka)
      n[a].push(o), o.provides && s(o.provides, a);
    else if (o instanceof t8)
      n[a].push(o), o.facet.extensions && s(o.facet.extensions, D0.default);
    else {
      let c = o.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      s(c, a);
    }
  }
  return s(r, D0.default), n.reduce((o, a) => o.concat(a));
}
function g3(r, e) {
  if (e & 1)
    return 2;
  let t = e >> 1, n = r.status[t];
  if (n == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (n & 2)
    return n;
  r.status[t] = 4;
  let i = r.computeSlot(r, r.config.dynamicSlots[t]);
  return r.status[t] = 2 | i;
}
function Ob(r, e) {
  return e & 1 ? r.config.staticValues[e >> 1] : r.values[e >> 1];
}
const tVe = /* @__PURE__ */ bt.define(), qN = /* @__PURE__ */ bt.define({
  combine: (r) => r.some((e) => e),
  static: !0
}), nVe = /* @__PURE__ */ bt.define({
  combine: (r) => r.length ? r[0] : void 0,
  static: !0
}), iVe = /* @__PURE__ */ bt.define(), rVe = /* @__PURE__ */ bt.define(), sVe = /* @__PURE__ */ bt.define(), oVe = /* @__PURE__ */ bt.define({
  combine: (r) => r.length ? r[0] : !1
});
class u2 {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.value = t;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new kBt();
  }
}
class kBt {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new u2(this, e);
  }
}
class NBt {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new Qn(this, e);
  }
}
class Qn {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.value = t;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let t = this.type.map(this.value, e);
    return t === void 0 ? void 0 : t == this.value ? this : new Qn(this.type, t);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new NBt(e.map || ((t) => t));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, t) {
    if (!e.length)
      return e;
    let n = [];
    for (let i of e) {
      let s = i.map(t);
      s && n.push(s);
    }
    return n;
  }
}
Qn.reconfigure = /* @__PURE__ */ Qn.define();
Qn.appendConfig = /* @__PURE__ */ Qn.define();
class vs {
  constructor(e, t, n, i, s, o) {
    this.startState = e, this.changes = t, this.selection = n, this.effects = i, this.annotations = s, this.scrollIntoView = o, this._doc = null, this._state = null, n && $Re(n, t.newLength), s.some((a) => a.type == vs.time) || (this.annotations = s.concat(vs.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, t, n, i, s, o) {
    return new vs(e, t, n, i, s, o);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let t of this.annotations)
      if (t.type == e)
        return t.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let t = this.annotation(vs.userEvent);
    return !!(t && (t == e || t.length > e.length && t.slice(0, e.length) == e && t[e.length] == "."));
  }
}
vs.time = /* @__PURE__ */ u2.define();
vs.userEvent = /* @__PURE__ */ u2.define();
vs.addToHistory = /* @__PURE__ */ u2.define();
vs.remote = /* @__PURE__ */ u2.define();
function TBt(r, e) {
  let t = [];
  for (let n = 0, i = 0; ; ) {
    let s, o;
    if (n < r.length && (i == e.length || e[i] >= r[n]))
      s = r[n++], o = r[n++];
    else if (i < e.length)
      s = e[i++], o = e[i++];
    else
      return t;
    !t.length || t[t.length - 1] < s ? t.push(s, o) : t[t.length - 1] < o && (t[t.length - 1] = o);
  }
}
function aVe(r, e, t) {
  var n;
  let i, s, o;
  return t ? (i = e.changes, s = es.empty(e.changes.length), o = r.changes.compose(e.changes)) : (i = e.changes.map(r.changes), s = r.changes.mapDesc(e.changes, !0), o = r.changes.compose(i)), {
    changes: o,
    selection: e.selection ? e.selection.map(s) : (n = r.selection) === null || n === void 0 ? void 0 : n.map(i),
    effects: Qn.mapEffects(r.effects, i).concat(Qn.mapEffects(e.effects, s)),
    annotations: r.annotations.length ? r.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: r.scrollIntoView || e.scrollIntoView
  };
}
function GN(r, e, t) {
  let n = e.selection, i = Fp(e.annotations);
  return e.userEvent && (i = i.concat(vs.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof es ? e.changes : es.of(e.changes || [], t, r.facet(nVe)),
    selection: n && (n instanceof Be ? n : Be.single(n.anchor, n.head)),
    effects: Fp(e.effects),
    annotations: i,
    scrollIntoView: !!e.scrollIntoView
  };
}
function lVe(r, e, t) {
  let n = GN(r, e.length ? e[0] : {}, r.doc.length);
  e.length && e[0].filter === !1 && (t = !1);
  for (let s = 1; s < e.length; s++) {
    e[s].filter === !1 && (t = !1);
    let o = !!e[s].sequential;
    n = aVe(n, GN(r, e[s], o ? n.changes.newLength : r.doc.length), o);
  }
  let i = vs.create(r, n.changes, n.selection, n.effects, n.annotations, n.scrollIntoView);
  return OBt(t ? IBt(i) : i);
}
function IBt(r) {
  let e = r.startState, t = !0;
  for (let i of e.facet(iVe)) {
    let s = i(r);
    if (s === !1) {
      t = !1;
      break;
    }
    Array.isArray(s) && (t = t === !0 ? s : TBt(t, s));
  }
  if (t !== !0) {
    let i, s;
    if (t === !1)
      s = r.changes.invertedDesc, i = es.empty(e.doc.length);
    else {
      let o = r.changes.filter(t);
      i = o.changes, s = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    r = vs.create(e, i, r.selection && r.selection.map(s), Qn.mapEffects(r.effects, s), r.annotations, r.scrollIntoView);
  }
  let n = e.facet(rVe);
  for (let i = n.length - 1; i >= 0; i--) {
    let s = n[i](r);
    s instanceof vs ? r = s : Array.isArray(s) && s.length == 1 && s[0] instanceof vs ? r = s[0] : r = lVe(e, Fp(s), !1);
  }
  return r;
}
function OBt(r) {
  let e = r.startState, t = e.facet(sVe), n = r;
  for (let i = t.length - 1; i >= 0; i--) {
    let s = t[i](r);
    s && Object.keys(s).length && (n = aVe(n, GN(e, s, r.changes.newLength), !0));
  }
  return n == r ? r : vs.create(e, r.changes, r.selection, n.effects, n.annotations, n.scrollIntoView);
}
const RBt = [];
function Fp(r) {
  return r == null ? RBt : Array.isArray(r) ? r : [r];
}
var rl = /* @__PURE__ */ function(r) {
  return r[r.Word = 0] = "Word", r[r.Space = 1] = "Space", r[r.Other = 2] = "Other", r;
}(rl || (rl = {}));
const VBt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let QN;
try {
  QN = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function HBt(r) {
  if (QN)
    return QN.test(r);
  for (let e = 0; e < r.length; e++) {
    let t = r[e];
    if (/\w/.test(t) || t > "" && (t.toUpperCase() != t.toLowerCase() || VBt.test(t)))
      return !0;
  }
  return !1;
}
function BBt(r) {
  return (e) => {
    if (!/\S/.test(e))
      return rl.Space;
    if (HBt(e))
      return rl.Word;
    for (let t = 0; t < r.length; t++)
      if (e.indexOf(r[t]) > -1)
        return rl.Word;
    return rl.Other;
  };
}
class jn {
  constructor(e, t, n, i, s, o) {
    this.config = e, this.doc = t, this.selection = n, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = s, o && (o._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      g3(this, a << 1);
    this.computeSlot = null;
  }
  field(e, t = !0) {
    let n = this.config.address[e.id];
    if (n == null) {
      if (t)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return g3(this, n), Ob(this, n);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return lVe(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let t = this.config, { base: n, compartments: i } = t;
    for (let a of e.effects)
      a.is(Yw.reconfigure) ? (t && (i = /* @__PURE__ */ new Map(), t.compartments.forEach((l, c) => i.set(c, l)), t = null), i.set(a.value.compartment, a.value.extension)) : a.is(Qn.reconfigure) ? (t = null, n = a.value) : a.is(Qn.appendConfig) && (t = null, n = Fp(n).concat(a.value));
    let s;
    t ? s = e.startState.values.slice() : (t = Ib.resolve(n, i, this), s = new jn(t, this.doc, this.selection, t.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null).values);
    let o = e.startState.facet(qN) ? e.newSelection : e.newSelection.asSingle();
    new jn(t, e.newDoc, o, s, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((t) => ({
      changes: { from: t.from, to: t.to, insert: e },
      range: Be.cursor(t.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let t = this.selection, n = e(t.ranges[0]), i = this.changes(n.changes), s = [n.range], o = Fp(n.effects);
    for (let a = 1; a < t.ranges.length; a++) {
      let l = e(t.ranges[a]), c = this.changes(l.changes), d = c.map(i);
      for (let f = 0; f < a; f++)
        s[f] = s[f].map(d);
      let u = i.mapDesc(c, !0);
      s.push(l.range.map(u)), i = i.compose(d), o = Qn.mapEffects(o, d).concat(Qn.mapEffects(Fp(l.effects), u));
    }
    return {
      changes: i,
      selection: Be.create(s, t.mainIndex),
      effects: o
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof es ? e : es.of(e, this.doc.length, this.facet(jn.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return li.of(e.split(this.facet(jn.lineSeparator) || zN));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, t = this.doc.length) {
    return this.doc.sliceString(e, t, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let t = this.config.address[e.id];
    return t == null ? e.default : (g3(this, t), Ob(this, t));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let t = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let n in e) {
        let i = e[n];
        i instanceof ka && this.config.address[i.id] != null && (t[n] = i.spec.toJSON(this.field(e[n]), this));
      }
    return t;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, t = {}, n) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (n) {
      for (let s in n)
        if (Object.prototype.hasOwnProperty.call(e, s)) {
          let o = n[s], a = e[s];
          i.push(o.init((l) => o.spec.fromJSON(a, l)));
        }
    }
    return jn.create({
      doc: e.doc,
      selection: Be.fromJSON(e.selection),
      extensions: t.extensions ? i.concat([t.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let t = Ib.resolve(e.extensions || [], /* @__PURE__ */ new Map()), n = e.doc instanceof li ? e.doc : li.of((e.doc || "").split(t.staticFacet(jn.lineSeparator) || zN)), i = e.selection ? e.selection instanceof Be ? e.selection : Be.single(e.selection.anchor, e.selection.head) : Be.single(0);
    return $Re(i, n.length), t.staticFacet(qN) || (i = i.asSingle()), new jn(t, n, i, t.dynamicSlots.map(() => null), (s, o) => o.create(s), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(jn.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(jn.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(oVe);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...t) {
    for (let n of this.facet(jn.phrases))
      if (Object.prototype.hasOwnProperty.call(n, e)) {
        e = n[e];
        break;
      }
    return t.length && (e = e.replace(/\$(\$|\d*)/g, (n, i) => {
      if (i == "$")
        return "$";
      let s = +(i || 1);
      return !s || s > t.length ? n : t[s - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, t, n = -1) {
    let i = [];
    for (let s of this.facet(tVe))
      for (let o of s(this, t, n))
        Object.prototype.hasOwnProperty.call(o, e) && i.push(o[e]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return BBt(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: t, from: n, length: i } = this.doc.lineAt(e), s = this.charCategorizer(e), o = e - n, a = e - n;
    for (; o > 0; ) {
      let l = ro(t, o, !1);
      if (s(t.slice(l, o)) != rl.Word)
        break;
      o = l;
    }
    for (; a < i; ) {
      let l = ro(t, a);
      if (s(t.slice(a, l)) != rl.Word)
        break;
      a = l;
    }
    return o == a ? null : Be.range(o + n, a + n);
  }
}
jn.allowMultipleSelections = qN;
jn.tabSize = /* @__PURE__ */ bt.define({
  combine: (r) => r.length ? r[0] : 4
});
jn.lineSeparator = nVe;
jn.readOnly = oVe;
jn.phrases = /* @__PURE__ */ bt.define({
  compare(r, e) {
    let t = Object.keys(r), n = Object.keys(e);
    return t.length == n.length && t.every((i) => r[i] == e[i]);
  }
});
jn.languageData = tVe;
jn.changeFilter = iVe;
jn.transactionFilter = rVe;
jn.transactionExtender = sVe;
Yw.reconfigure = /* @__PURE__ */ Qn.define();
function sC(r, e, t = {}) {
  let n = {};
  for (let i of r)
    for (let s of Object.keys(i)) {
      let o = i[s], a = n[s];
      if (a === void 0)
        n[s] = o;
      else if (!(a === o || o === void 0)) if (Object.hasOwnProperty.call(t, s))
        n[s] = t[s](a, o);
      else
        throw new Error("Config merge conflict for field " + s);
    }
  for (let i in e)
    n[i] === void 0 && (n[i] = e[i]);
  return n;
}
class Nf {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, t = e) {
    return k4.create(e, t, this);
  }
}
Nf.prototype.startSide = Nf.prototype.endSide = 0;
Nf.prototype.point = !1;
Nf.prototype.mapMode = ps.TrackDel;
class k4 {
  constructor(e, t, n) {
    this.from = e, this.to = t, this.value = n;
  }
  /**
  @internal
  */
  static create(e, t, n) {
    return new k4(e, t, n);
  }
}
function KN(r, e) {
  return r.from - e.from || r.value.startSide - e.value.startSide;
}
class jV {
  constructor(e, t, n, i) {
    this.from = e, this.to = t, this.value = n, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, t, n, i = 0) {
    let s = n ? this.to : this.from;
    for (let o = i, a = s.length; ; ) {
      if (o == a)
        return o;
      let l = o + a >> 1, c = s[l] - e || (n ? this.value[l].endSide : this.value[l].startSide) - t;
      if (l == o)
        return c >= 0 ? o : a;
      c >= 0 ? a = l : o = l + 1;
    }
  }
  between(e, t, n, i) {
    for (let s = this.findIndex(t, -1e9, !0), o = this.findIndex(n, 1e9, !1, s); s < o; s++)
      if (i(this.from[s] + e, this.to[s] + e, this.value[s]) === !1)
        return !1;
  }
  map(e, t) {
    let n = [], i = [], s = [], o = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], d = this.from[l] + e, u = this.to[l] + e, f, p;
      if (d == u) {
        let g = t.mapPos(d, c.startSide, c.mapMode);
        if (g == null || (f = p = g, c.startSide != c.endSide && (p = t.mapPos(d, c.endSide), p < f)))
          continue;
      } else if (f = t.mapPos(d, c.startSide), p = t.mapPos(u, c.endSide), f > p || f == p && c.startSide > 0 && c.endSide <= 0)
        continue;
      (p - f || c.endSide - c.startSide) < 0 || (o < 0 && (o = f), c.point && (a = Math.max(a, p - f)), n.push(c), i.push(f - o), s.push(p - o));
    }
    return { mapped: n.length ? new jV(i, s, n, a) : null, pos: o };
  }
}
class oi {
  constructor(e, t, n, i) {
    this.chunkPos = e, this.chunk = t, this.nextLayer = n, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(e, t, n, i) {
    return new oi(e, t, n, i);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let t of this.chunk)
      e += t.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: t = [], sort: n = !1, filterFrom: i = 0, filterTo: s = this.length } = e, o = e.filter;
    if (t.length == 0 && !o)
      return this;
    if (n && (t = t.slice().sort(KN)), this.isEmpty)
      return t.length ? oi.of(t) : this;
    let a = new cVe(this, null, -1).goto(0), l = 0, c = [], d = new N4();
    for (; a.value || l < t.length; )
      if (l < t.length && (a.from - t[l].from || a.startSide - t[l].value.startSide) >= 0) {
        let u = t[l++];
        d.addInner(u.from, u.to, u.value) || c.push(u);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == t.length || this.chunkEnd(a.chunkIndex) < t[l].from) && (!o || i > this.chunkEnd(a.chunkIndex) || s < this.chunkPos[a.chunkIndex]) && d.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!o || i > a.to || s < a.from || o(a.from, a.to, a.value)) && (d.addInner(a.from, a.to, a.value) || c.push(k4.create(a.from, a.to, a.value))), a.next());
    return d.finishInner(this.nextLayer.isEmpty && !c.length ? oi.empty : this.nextLayer.update({ add: c, filter: o, filterFrom: i, filterTo: s }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let t = [], n = [], i = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let a = this.chunkPos[o], l = this.chunk[o], c = e.touchesRange(a, a + l.length);
      if (c === !1)
        i = Math.max(i, l.maxPoint), t.push(l), n.push(e.mapPos(a));
      else if (c === !0) {
        let { mapped: d, pos: u } = l.map(a, e);
        d && (i = Math.max(i, d.maxPoint), t.push(d), n.push(u));
      }
    }
    let s = this.nextLayer.map(e);
    return t.length == 0 ? s : new oi(n, t, s || oi.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, t, n) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let s = this.chunkPos[i], o = this.chunk[i];
        if (t >= s && e <= s + o.length && o.between(s, e - s, t - s, n) === !1)
          return;
      }
      this.nextLayer.between(e, t, n);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return T4.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, t = 0) {
    return T4.from(e).goto(t);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, t, n, i, s = -1) {
    let o = e.filter((u) => u.maxPoint > 0 || !u.isEmpty && u.maxPoint >= s), a = t.filter((u) => u.maxPoint > 0 || !u.isEmpty && u.maxPoint >= s), l = PCe(o, a, n), c = new nA(o, l, s), d = new nA(a, l, s);
    n.iterGaps((u, f, p) => FCe(c, u, d, f, p, i)), n.empty && n.length == 0 && FCe(c, 0, d, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, t, n = 0, i) {
    i == null && (i = 999999999);
    let s = e.filter((d) => !d.isEmpty && t.indexOf(d) < 0), o = t.filter((d) => !d.isEmpty && e.indexOf(d) < 0);
    if (s.length != o.length)
      return !1;
    if (!s.length)
      return !0;
    let a = PCe(s, o), l = new nA(s, a, 0).goto(n), c = new nA(o, a, 0).goto(n);
    for (; ; ) {
      if (l.to != c.to || !YN(l.active, c.active) || l.point && (!c.point || !l.point.eq(c.point)))
        return !1;
      if (l.to > i)
        return !0;
      l.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, t, n, i, s = -1) {
    let o = new nA(e, null, s).goto(t), a = t, l = o.openStart;
    for (; ; ) {
      let c = Math.min(o.to, n);
      if (o.point) {
        let d = o.activeForPoint(o.to), u = o.pointFrom < t ? d.length + 1 : Math.min(d.length, l);
        i.point(a, c, o.point, d, u, o.pointRank), l = Math.min(o.openEnd(c), d.length);
      } else c > a && (i.span(a, c, o.active, l), l = o.openEnd(c));
      if (o.to > n)
        return l + (o.point && o.to > n ? 1 : 0);
      a = o.to, o.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, t = !1) {
    let n = new N4();
    for (let i of e instanceof k4 ? [e] : t ? PBt(e) : e)
      n.add(i.from, i.to, i.value);
    return n.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return oi.empty;
    let t = e[e.length - 1];
    for (let n = e.length - 2; n >= 0; n--)
      for (let i = e[n]; i != oi.empty; i = i.nextLayer)
        t = new oi(i.chunkPos, i.chunk, t, Math.max(i.maxPoint, t.maxPoint));
    return t;
  }
}
oi.empty = /* @__PURE__ */ new oi([], [], null, -1);
function PBt(r) {
  if (r.length > 1)
    for (let e = r[0], t = 1; t < r.length; t++) {
      let n = r[t];
      if (KN(e, n) > 0)
        return r.slice().sort(KN);
      e = n;
    }
  return r;
}
oi.empty.nextLayer = oi.empty;
class N4 {
  finishChunk(e) {
    this.chunks.push(new jV(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, t, n) {
    this.addInner(e, t, n) || (this.nextLayer || (this.nextLayer = new N4())).add(e, t, n);
  }
  /**
  @internal
  */
  addInner(e, t, n) {
    let i = e - this.lastTo || n.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || n.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(t - this.chunkStart), this.last = n, this.lastFrom = e, this.lastTo = t, this.value.push(n), n.point && (this.maxPoint = Math.max(this.maxPoint, t - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, t) {
    if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint), this.chunks.push(t), this.chunkPos.push(e);
    let n = t.value.length - 1;
    return this.last = t.value[n], this.lastFrom = t.from[n] + e, this.lastTo = t.to[n] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(oi.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let t = oi.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, t;
  }
}
function PCe(r, e, t) {
  let n = /* @__PURE__ */ new Map();
  for (let s of r)
    for (let o = 0; o < s.chunk.length; o++)
      s.chunk[o].maxPoint <= 0 && n.set(s.chunk[o], s.chunkPos[o]);
  let i = /* @__PURE__ */ new Set();
  for (let s of e)
    for (let o = 0; o < s.chunk.length; o++) {
      let a = n.get(s.chunk[o]);
      a != null && (t ? t.mapPos(a) : a) == s.chunkPos[o] && !t?.touchesRange(a, a + s.chunk[o].length) && i.add(s.chunk[o]);
    }
  return i;
}
class cVe {
  constructor(e, t, n, i = 0) {
    this.layer = e, this.skip = t, this.minPoint = n, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, t = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, t, !1), this;
  }
  gotoInner(e, t, n) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, n = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], t, !0);
      (!n || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, t) {
    (this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], t = this.layer.chunk[this.chunkIndex], n = e + t.from[this.rangeIndex];
        if (this.from = n, this.to = e + t.to[this.rangeIndex], this.value = t.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class T4 {
  constructor(e) {
    this.heap = e;
  }
  static from(e, t = null, n = -1) {
    let i = [];
    for (let s = 0; s < e.length; s++)
      for (let o = e[s]; !o.isEmpty; o = o.nextLayer)
        o.maxPoint >= n && i.push(new cVe(o, t, n, s));
    return i.length == 1 ? i[0] : new T4(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, t = -1e9) {
    for (let n of this.heap)
      n.goto(e, t);
    for (let n = this.heap.length >> 1; n >= 0; n--)
      vS(this.heap, n);
    return this.next(), this;
  }
  forward(e, t) {
    for (let n of this.heap)
      n.forward(e, t);
    for (let n = this.heap.length >> 1; n >= 0; n--)
      vS(this.heap, n);
    (this.to - e || this.value.endSide - t) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), vS(this.heap, 0);
    }
  }
}
function vS(r, e) {
  for (let t = r[e]; ; ) {
    let n = (e << 1) + 1;
    if (n >= r.length)
      break;
    let i = r[n];
    if (n + 1 < r.length && i.compare(r[n + 1]) >= 0 && (i = r[n + 1], n++), t.compare(i) < 0)
      break;
    r[n] = t, r[e] = i, e = n;
  }
}
class nA {
  constructor(e, t, n) {
    this.minPoint = n, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = T4.from(e, t, n);
  }
  goto(e, t = -1e9) {
    return this.cursor.goto(e, t), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = t, this.openStart = -1, this.next(), this;
  }
  forward(e, t) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, t);
  }
  removeActive(e) {
    R5(this.active, e), R5(this.activeTo, e), R5(this.activeRank, e), this.minActive = zCe(this.active, this.activeTo);
  }
  addActive(e) {
    let t = 0, { value: n, to: i, rank: s } = this.cursor;
    for (; t < this.activeRank.length && (s - this.activeRank[t] || i - this.activeTo[t]) > 0; )
      t++;
    V5(this.active, t, n), V5(this.activeTo, t, i), V5(this.activeRank, t, s), e && V5(e, t, this.cursor.from), this.minActive = zCe(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, t = this.point;
    this.point = null;
    let n = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), n && R5(n, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let s = this.cursor.value;
          if (!s.point)
            this.addActive(n), this.cursor.next();
          else if (t && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = s, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = s.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (n) {
      this.openStart = 0;
      for (let i = n.length - 1; i >= 0 && n[i] < e; i--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let t = [];
    for (let n = this.active.length - 1; n >= 0 && !(this.activeRank[n] < this.pointRank); n--)
      (this.activeTo[n] > e || this.activeTo[n] == e && this.active[n].endSide >= this.point.endSide) && t.push(this.active[n]);
    return t.reverse();
  }
  openEnd(e) {
    let t = 0;
    for (let n = this.activeTo.length - 1; n >= 0 && this.activeTo[n] > e; n--)
      t++;
    return t;
  }
}
function FCe(r, e, t, n, i, s) {
  r.goto(e), t.goto(n);
  let o = n + i, a = n, l = n - e;
  for (; ; ) {
    let c = r.to + l - t.to || r.endSide - t.endSide, d = c < 0 ? r.to + l : t.to, u = Math.min(d, o);
    if (r.point || t.point ? r.point && t.point && (r.point == t.point || r.point.eq(t.point)) && YN(r.activeForPoint(r.to), t.activeForPoint(t.to)) || s.comparePoint(a, u, r.point, t.point) : u > a && !YN(r.active, t.active) && s.compareRange(a, u, r.active, t.active), d > o)
      break;
    a = d, c <= 0 && r.next(), c >= 0 && t.next();
  }
}
function YN(r, e) {
  if (r.length != e.length)
    return !1;
  for (let t = 0; t < r.length; t++)
    if (r[t] != e[t] && !r[t].eq(e[t]))
      return !1;
  return !0;
}
function R5(r, e) {
  for (let t = e, n = r.length - 1; t < n; t++)
    r[t] = r[t + 1];
  r.pop();
}
function V5(r, e, t) {
  for (let n = r.length - 1; n >= e; n--)
    r[n + 1] = r[n];
  r[e] = t;
}
function zCe(r, e) {
  let t = -1, n = 1e9;
  for (let i = 0; i < e.length; i++)
    (e[i] - n || r[i].endSide - r[t].endSide) < 0 && (t = i, n = e[i]);
  return t;
}
function oC(r, e, t = r.length) {
  let n = 0;
  for (let i = 0; i < t; )
    r.charCodeAt(i) == 9 ? (n += e - n % e, i++) : (n++, i = ro(r, i));
  return n;
}
function FBt(r, e, t, n) {
  for (let i = 0, s = 0; ; ) {
    if (s >= e)
      return i;
    if (i == r.length)
      break;
    s += r.charCodeAt(i) == 9 ? t - s % t : 1, i = ro(r, i);
  }
  return r.length;
}
const XN = "ͼ", WCe = typeof Symbol > "u" ? "__" + XN : Symbol.for(XN), JN = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), jCe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class C1 {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, t) {
    this.rules = [];
    let { finish: n } = t || {};
    function i(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function s(o, a, l, c) {
      let d = [], u = /^@(\w+)\b/.exec(o[0]), f = u && u[1] == "keyframes";
      if (u && a == null) return l.push(o[0] + ";");
      for (let p in a) {
        let g = a[p];
        if (/&/.test(p))
          s(
            p.split(/,\s*/).map((m) => o.map((A) => m.replace(/&/, A))).reduce((m, A) => m.concat(A)),
            g,
            l
          );
        else if (g && typeof g == "object") {
          if (!u) throw new RangeError("The value of a property (" + p + ") should be a primitive value.");
          s(i(p), g, d, f);
        } else g != null && d.push(p.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + g + ";");
      }
      (d.length || f) && l.push((n && !u && !c ? o.map(n) : o).join(", ") + " {" + d.join(" ") + "}");
    }
    for (let o in e) s(i(o), e[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = jCe[WCe] || 1;
    return jCe[WCe] = e + 1, XN + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, t, n) {
    let i = e[JN], s = n && n.nonce;
    i ? s && i.setNonce(s) : i = new zBt(e, s), i.mount(Array.isArray(t) ? t : [t]);
  }
}
let ZCe = /* @__PURE__ */ new Map();
class zBt {
  constructor(e, t) {
    let n = e.ownerDocument || e, i = n.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let s = ZCe.get(n);
      if (s)
        return e.adoptedStyleSheets = [s.sheet, ...e.adoptedStyleSheets], e[JN] = s;
      this.sheet = new i.CSSStyleSheet(), e.adoptedStyleSheets = [this.sheet, ...e.adoptedStyleSheets], ZCe.set(n, this);
    } else {
      this.styleTag = n.createElement("style"), t && this.styleTag.setAttribute("nonce", t);
      let s = e.head || e;
      s.insertBefore(this.styleTag, s.firstChild);
    }
    this.modules = [], e[JN] = this;
  }
  mount(e) {
    let t = this.sheet, n = 0, i = 0;
    for (let s = 0; s < e.length; s++) {
      let o = e[s], a = this.modules.indexOf(o);
      if (a < i && a > -1 && (this.modules.splice(a, 1), i--, a = -1), a == -1) {
        if (this.modules.splice(i++, 0, o), t) for (let l = 0; l < o.rules.length; l++)
          t.insertRule(o.rules[l], n++);
      } else {
        for (; i < a; ) n += this.modules[i++].rules.length;
        n += o.rules.length, i++;
      }
    }
    if (!t) {
      let s = "";
      for (let o = 0; o < this.modules.length; o++)
        s += this.modules[o].getRules() + `
`;
      this.styleTag.textContent = s;
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var E1 = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, I4 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, WBt = typeof navigator < "u" && /Mac/.test(navigator.platform), jBt = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var fs = 0; fs < 10; fs++) E1[48 + fs] = E1[96 + fs] = String(fs);
for (var fs = 1; fs <= 24; fs++) E1[fs + 111] = "F" + fs;
for (var fs = 65; fs <= 90; fs++)
  E1[fs] = String.fromCharCode(fs + 32), I4[fs] = String.fromCharCode(fs);
for (var bS in E1) I4.hasOwnProperty(bS) || (I4[bS] = E1[bS]);
function ZBt(r) {
  var e = WBt && r.metaKey && r.shiftKey && !r.ctrlKey && !r.altKey || jBt && r.shiftKey && r.key && r.key.length == 1 || r.key == "Unidentified", t = !e && r.key || (r.shiftKey ? I4 : E1)[r.keyCode] || r.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
function Rb(r) {
  let e;
  return r.nodeType == 11 ? e = r.getSelection ? r : r.ownerDocument : e = r, e.getSelection();
}
function $N(r, e) {
  return e ? r == e || r.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function UBt(r) {
  let e = r.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function n8(r, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return $N(r, e.anchorNode);
  } catch {
    return !1;
  }
}
function O4(r) {
  return r.nodeType == 3 ? Tf(r, 0, r.nodeValue.length).getClientRects() : r.nodeType == 1 ? r.getClientRects() : [];
}
function m3(r, e, t, n) {
  return t ? UCe(r, e, t, n, -1) || UCe(r, e, t, n, 1) : !1;
}
function R4(r) {
  for (var e = 0; ; e++)
    if (r = r.previousSibling, !r)
      return e;
}
function UCe(r, e, t, n, i) {
  for (; ; ) {
    if (r == t && e == n)
      return !0;
    if (e == (i < 0 ? 0 : jd(r))) {
      if (r.nodeName == "DIV")
        return !1;
      let s = r.parentNode;
      if (!s || s.nodeType != 1)
        return !1;
      e = R4(r) + (i < 0 ? 0 : 1), r = s;
    } else if (r.nodeType == 1) {
      if (r = r.childNodes[e + (i < 0 ? -1 : 0)], r.nodeType == 1 && r.contentEditable == "false")
        return !1;
      e = i < 0 ? jd(r) : 0;
    } else
      return !1;
  }
}
function jd(r) {
  return r.nodeType == 3 ? r.nodeValue.length : r.childNodes.length;
}
function ZV(r, e) {
  let t = e ? r.left : r.right;
  return { left: t, right: t, top: r.top, bottom: r.bottom };
}
function qBt(r) {
  return {
    left: 0,
    right: r.innerWidth,
    top: 0,
    bottom: r.innerHeight
  };
}
function hVe(r, e) {
  let t = e.width / r.offsetWidth, n = e.height / r.offsetHeight;
  return (t > 0.995 && t < 1.005 || !isFinite(t) || Math.abs(e.width - r.offsetWidth) < 1) && (t = 1), (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.height - r.offsetHeight) < 1) && (n = 1), { scaleX: t, scaleY: n };
}
function GBt(r, e, t, n, i, s, o, a) {
  let l = r.ownerDocument, c = l.defaultView || window;
  for (let d = r, u = !1; d && !u; )
    if (d.nodeType == 1) {
      let f, p = d == l.body, g = 1, m = 1;
      if (p)
        f = qBt(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(d).position) && (u = !0), d.scrollHeight <= d.clientHeight && d.scrollWidth <= d.clientWidth) {
          d = d.assignedSlot || d.parentNode;
          continue;
        }
        let v = d.getBoundingClientRect();
        ({ scaleX: g, scaleY: m } = hVe(d, v)), f = {
          left: v.left,
          right: v.left + d.clientWidth * g,
          top: v.top,
          bottom: v.top + d.clientHeight * m
        };
      }
      let A = 0, w = 0;
      if (i == "nearest")
        e.top < f.top ? (w = -(f.top - e.top + o), t > 0 && e.bottom > f.bottom + w && (w = e.bottom - f.bottom + w + o)) : e.bottom > f.bottom && (w = e.bottom - f.bottom + o, t < 0 && e.top - w < f.top && (w = -(f.top + w - e.top + o)));
      else {
        let v = e.bottom - e.top, y = f.bottom - f.top;
        w = (i == "center" && v <= y ? e.top + v / 2 - y / 2 : i == "start" || i == "center" && t < 0 ? e.top - o : e.bottom - y + o) - f.top;
      }
      if (n == "nearest" ? e.left < f.left ? (A = -(f.left - e.left + s), t > 0 && e.right > f.right + A && (A = e.right - f.right + A + s)) : e.right > f.right && (A = e.right - f.right + s, t < 0 && e.left < f.left + A && (A = -(f.left + A - e.left + s))) : A = (n == "center" ? e.left + (e.right - e.left) / 2 - (f.right - f.left) / 2 : n == "start" == a ? e.left - s : e.right - (f.right - f.left) + s) - f.left, A || w)
        if (p)
          c.scrollBy(A, w);
        else {
          let v = 0, y = 0;
          if (w) {
            let _ = d.scrollTop;
            d.scrollTop += w / m, y = (d.scrollTop - _) * m;
          }
          if (A) {
            let _ = d.scrollLeft;
            d.scrollLeft += A / g, v = (d.scrollLeft - _) * g;
          }
          e = {
            left: e.left - v,
            top: e.top - y,
            right: e.right - v,
            bottom: e.bottom - y
          }, v && Math.abs(v - A) < 1 && (n = "nearest"), y && Math.abs(y - w) < 1 && (i = "nearest");
        }
      if (p)
        break;
      d = d.assignedSlot || d.parentNode;
    } else if (d.nodeType == 11)
      d = d.host;
    else
      break;
}
function QBt(r) {
  let e = r.ownerDocument;
  for (let t = r.parentNode; t && t != e.body; )
    if (t.nodeType == 1) {
      if (t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth)
        return t;
      t = t.assignedSlot || t.parentNode;
    } else if (t.nodeType == 11)
      t = t.host;
    else
      break;
  return null;
}
class KBt {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: t, focusNode: n } = e;
    this.set(t, Math.min(e.anchorOffset, t ? jd(t) : 0), n, Math.min(e.focusOffset, n ? jd(n) : 0));
  }
  set(e, t, n, i) {
    this.anchorNode = e, this.anchorOffset = t, this.focusNode = n, this.focusOffset = i;
  }
}
let I2 = null;
function dVe(r) {
  if (r.setActive)
    return r.setActive();
  if (I2)
    return r.focus(I2);
  let e = [];
  for (let t = r; t && (e.push(t, t.scrollTop, t.scrollLeft), t != t.ownerDocument); t = t.parentNode)
    ;
  if (r.focus(I2 == null ? {
    get preventScroll() {
      return I2 = { preventScroll: !0 }, !0;
    }
  } : void 0), !I2) {
    I2 = !1;
    for (let t = 0; t < e.length; ) {
      let n = e[t++], i = e[t++], s = e[t++];
      n.scrollTop != i && (n.scrollTop = i), n.scrollLeft != s && (n.scrollLeft = s);
    }
  }
}
let qCe;
function Tf(r, e, t = e) {
  let n = qCe || (qCe = document.createRange());
  return n.setEnd(r, t), n.setStart(r, e), n;
}
function zp(r, e, t) {
  let n = { key: e, code: e, keyCode: t, which: t, cancelable: !0 }, i = new KeyboardEvent("keydown", n);
  i.synthetic = !0, r.dispatchEvent(i);
  let s = new KeyboardEvent("keyup", n);
  return s.synthetic = !0, r.dispatchEvent(s), i.defaultPrevented || s.defaultPrevented;
}
function YBt(r) {
  for (; r; ) {
    if (r && (r.nodeType == 9 || r.nodeType == 11 && r.host))
      return r;
    r = r.assignedSlot || r.parentNode;
  }
  return null;
}
function uVe(r) {
  for (; r.attributes.length; )
    r.removeAttributeNode(r.attributes[0]);
}
function XBt(r, e) {
  let t = e.focusNode, n = e.focusOffset;
  if (!t || e.anchorNode != t || e.anchorOffset != n)
    return !1;
  for (n = Math.min(n, jd(t)); ; )
    if (n) {
      if (t.nodeType != 1)
        return !1;
      let i = t.childNodes[n - 1];
      i.contentEditable == "false" ? n-- : (t = i, n = jd(t));
    } else {
      if (t == r)
        return !0;
      n = R4(t), t = t.parentNode;
    }
}
function fVe(r) {
  return r.scrollTop > Math.max(1, r.scrollHeight - r.clientHeight - 4);
}
class Hs {
  constructor(e, t, n = !0) {
    this.node = e, this.offset = t, this.precise = n;
  }
  static before(e, t) {
    return new Hs(e.parentNode, R4(e), t);
  }
  static after(e, t) {
    return new Hs(e.parentNode, R4(e) + 1, t);
  }
}
const UV = [];
class Ni {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let t = this.posAtStart;
    for (let n of this.children) {
      if (n == e)
        return t;
      t += n.length + n.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, t) {
    if (this.flags & 2) {
      let n = this.dom, i = null, s;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (s = i ? i.nextSibling : n.firstChild)) {
            let a = Ni.get(s);
            (!a || !a.parent && a.canReuseDOM(o)) && o.reuseDOM(s);
          }
          o.sync(e, t), o.flags &= -8;
        }
        if (s = i ? i.nextSibling : n.firstChild, t && !t.written && t.node == n && s != o.dom && (t.written = !0), o.dom.parentNode == n)
          for (; s && s != o.dom; )
            s = GCe(s);
        else
          n.insertBefore(o.dom, s);
        i = o.dom;
      }
      for (s = i ? i.nextSibling : n.firstChild, s && t && t.node == n && (t.written = !0); s; )
        s = GCe(s);
    } else if (this.flags & 1)
      for (let n of this.children)
        n.flags & 7 && (n.sync(e, t), n.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, t) {
    let n;
    if (e == this.dom)
      n = this.dom.childNodes[t];
    else {
      let i = jd(e) == 0 ? 0 : t == 0 ? -1 : 1;
      for (; ; ) {
        let s = e.parentNode;
        if (s == this.dom)
          break;
        i == 0 && s.firstChild != s.lastChild && (e == s.firstChild ? i = -1 : i = 1), e = s;
      }
      i < 0 ? n = e : n = e.nextSibling;
    }
    if (n == this.dom.firstChild)
      return 0;
    for (; n && !Ni.get(n); )
      n = n.nextSibling;
    if (!n)
      return this.length;
    for (let i = 0, s = 0; ; i++) {
      let o = this.children[i];
      if (o.dom == n)
        return s;
      s += o.length + o.breakAfter;
    }
  }
  domBoundsAround(e, t, n = 0) {
    let i = -1, s = -1, o = -1, a = -1;
    for (let l = 0, c = n, d = n; l < this.children.length; l++) {
      let u = this.children[l], f = c + u.length;
      if (c < e && f > t)
        return u.domBoundsAround(e, t, c);
      if (f >= e && i == -1 && (i = l, s = c), c > t && u.dom.parentNode == this.dom) {
        o = l, a = d;
        break;
      }
      d = f, c = f + u.breakAfter;
    }
    return {
      from: s,
      to: a < 0 ? n + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let t = this.parent; t; t = t.parent) {
      if (e && (t.flags |= 2), t.flags & 1)
        return;
      t.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let t = e.parent;
      if (!t)
        return e;
      e = t;
    }
  }
  replaceChildren(e, t, n = UV) {
    this.markDirty();
    for (let i = e; i < t; i++) {
      let s = this.children[i];
      s.parent == this && n.indexOf(s) < 0 && s.destroy();
    }
    this.children.splice(e, t - e, ...n);
    for (let i = 0; i < n.length; i++)
      n[i].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new pVe(this.children, e, this.children.length);
  }
  childPos(e, t = 1) {
    return this.childCursor().findPos(e, t);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, t, n, i, s, o) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
}
Ni.prototype.breakAfter = 0;
function GCe(r) {
  let e = r.nextSibling;
  return r.parentNode.removeChild(r), e;
}
class pVe {
  constructor(e, t, n) {
    this.children = e, this.pos = t, this.i = n, this.off = 0;
  }
  findPos(e, t = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (t > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let n = this.children[--this.i];
      this.pos -= n.length + n.breakAfter;
    }
  }
}
function gVe(r, e, t, n, i, s, o, a, l) {
  let { children: c } = r, d = c.length ? c[e] : null, u = s.length ? s[s.length - 1] : null, f = u ? u.breakAfter : o;
  if (!(e == n && d && !o && !f && s.length < 2 && d.merge(t, i, s.length ? u : null, t == 0, a, l))) {
    if (n < c.length) {
      let p = c[n];
      p && (i < p.length || p.breakAfter && u?.breakAfter) ? (e == n && (p = p.split(i), i = 0), !f && u && p.merge(0, i, u, !0, 0, l) ? s[s.length - 1] = p : ((i || p.children.length && !p.children[0].length) && p.merge(0, i, null, !1, 0, l), s.push(p))) : p?.breakAfter && (u ? u.breakAfter = 1 : o = 1), n++;
    }
    for (d && (d.breakAfter = o, t > 0 && (!o && s.length && d.merge(t, d.length, s[0], !1, a, 0) ? d.breakAfter = s.shift().breakAfter : (t < d.length || d.children.length && d.children[d.children.length - 1].length == 0) && d.merge(t, d.length, null, !1, a, 0), e++)); e < n && s.length; )
      if (c[n - 1].become(s[s.length - 1]))
        n--, s.pop(), l = s.length ? 0 : a;
      else if (c[e].become(s[0]))
        e++, s.shift(), a = s.length ? 0 : l;
      else
        break;
    !s.length && e && n < c.length && !c[e - 1].breakAfter && c[n].merge(0, 0, c[e - 1], !1, a, l) && e--, (e < n || s.length) && r.replaceChildren(e, n, s);
  }
}
function mVe(r, e, t, n, i, s) {
  let o = r.childCursor(), { i: a, off: l } = o.findPos(t, 1), { i: c, off: d } = o.findPos(e, -1), u = e - t;
  for (let f of n)
    u += f.length;
  r.length += u, gVe(r, c, d, a, l, n, 0, i, s);
}
let ca = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, eT = typeof document < "u" ? document : { documentElement: { style: {} } };
const tT = /* @__PURE__ */ /Edge\/(\d+)/.exec(ca.userAgent), AVe = /* @__PURE__ */ /MSIE \d/.test(ca.userAgent), nT = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(ca.userAgent), aC = !!(AVe || nT || tT), QCe = !aC && /* @__PURE__ */ /gecko\/(\d+)/i.test(ca.userAgent), yS = !aC && /* @__PURE__ */ /Chrome\/(\d+)/.exec(ca.userAgent), JBt = "webkitFontSmoothing" in eT.documentElement.style, wVe = !aC && /* @__PURE__ */ /Apple Computer/.test(ca.vendor), KCe = wVe && (/* @__PURE__ */ /Mobile\/\w+/.test(ca.userAgent) || ca.maxTouchPoints > 2);
var ft = {
  mac: KCe || /* @__PURE__ */ /Mac/.test(ca.platform),
  windows: /* @__PURE__ */ /Win/.test(ca.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(ca.platform),
  ie: aC,
  ie_version: AVe ? eT.documentMode || 6 : nT ? +nT[1] : tT ? +tT[1] : 0,
  gecko: QCe,
  gecko_version: QCe ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(ca.userAgent) || [0, 0])[1] : 0,
  chrome: !!yS,
  chrome_version: yS ? +yS[1] : 0,
  ios: KCe,
  android: /* @__PURE__ */ /Android\b/.test(ca.userAgent),
  safari: wVe,
  webkit_version: JBt ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: eT.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const $Bt = 256;
class Zd extends Ni {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, t) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (t && t.node == this.dom && (t.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, t, n) {
    return this.flags & 8 || n && (!(n instanceof Zd) || this.length - (t - e) + n.length > $Bt || n.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (n ? n.text : "") + this.text.slice(t), this.markDirty(), !0);
  }
  split(e) {
    let t = new Zd(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), t.flags |= this.flags & 8, t;
  }
  localPosFromDOM(e, t) {
    return e == this.dom ? t : t ? this.text.length : 0;
  }
  domAtPos(e) {
    return new Hs(this.dom, e);
  }
  domBoundsAround(e, t, n) {
    return { from: n, to: n + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, t) {
    return ePt(this.dom, e, t);
  }
}
class Ud extends Ni {
  constructor(e, t = [], n = 0) {
    super(), this.mark = e, this.children = t, this.length = n;
    for (let i of t)
      i.setParent(this);
  }
  setAttrs(e) {
    if (uVe(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let t in this.mark.attrs)
        e.setAttribute(t, this.mark.attrs[t]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, t) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, t);
  }
  merge(e, t, n, i, s, o) {
    return n && (!(n instanceof Ud && n.mark.eq(this.mark)) || e && s <= 0 || t < this.length && o <= 0) ? !1 : (mVe(this, e, t, n ? n.children.slice() : [], s - 1, o - 1), this.markDirty(), !0);
  }
  split(e) {
    let t = [], n = 0, i = -1, s = 0;
    for (let a of this.children) {
      let l = n + a.length;
      l > e && t.push(n < e ? a.split(e - n) : a), i < 0 && n >= e && (i = s), n = l, s++;
    }
    let o = this.length - e;
    return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new Ud(this.mark, t, o);
  }
  domAtPos(e) {
    return vVe(this, e);
  }
  coordsAt(e, t) {
    return yVe(this, e, t);
  }
}
function ePt(r, e, t) {
  let n = r.nodeValue.length;
  e > n && (e = n);
  let i = e, s = e, o = 0;
  e == 0 && t < 0 || e == n && t >= 0 ? ft.chrome || ft.gecko || (e ? (i--, o = 1) : s < n && (s++, o = -1)) : t < 0 ? i-- : s < n && s++;
  let a = Tf(r, i, s).getClientRects();
  if (!a.length)
    return null;
  let l = a[(o ? o < 0 : t >= 0) ? 0 : a.length - 1];
  return ft.safari && !o && l.width == 0 && (l = Array.prototype.find.call(a, (c) => c.width) || l), o ? ZV(l, o < 0) : l || null;
}
class Uu extends Ni {
  static create(e, t, n) {
    return new Uu(e, t, n);
  }
  constructor(e, t, n) {
    super(), this.widget = e, this.length = t, this.side = n, this.prevWidget = null;
  }
  split(e) {
    let t = Uu.create(this.widget, this.length - e, this.side);
    return this.length -= e, t;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, t, n, i, s, o) {
    return n && (!(n instanceof Uu) || !this.widget.compare(n.widget) || e > 0 && s <= 0 || t < this.length && o <= 0) ? !1 : (this.length = e + (n ? n.length : 0) + (this.length - t), !0);
  }
  become(e) {
    return e instanceof Uu && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return li.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: t } = e, n = t && t.state.doc, i = this.posAtStart;
    return n ? n.slice(i, i + this.length) : li.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? Hs.before(this.dom) : Hs.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, t) {
    let n = this.widget.coordsAt(this.dom, e, t);
    if (n)
      return n;
    let i = this.dom.getClientRects(), s = null;
    if (!i.length)
      return null;
    let o = this.side ? this.side < 0 : e > 0;
    for (let a = o ? i.length - 1 : 0; s = i[a], !(e > 0 ? a == 0 : a == i.length - 1 || s.top < s.bottom); a += o ? -1 : 1)
      ;
    return ZV(s, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class Ng extends Ni {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof Ng && e.side == this.side;
  }
  split() {
    return new Ng(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? Hs.before(this.dom) : Hs.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return li.empty;
  }
  get isHidden() {
    return !0;
  }
}
Zd.prototype.children = Uu.prototype.children = Ng.prototype.children = UV;
function vVe(r, e) {
  let t = r.dom, { children: n } = r, i = 0;
  for (let s = 0; i < n.length; i++) {
    let o = n[i], a = s + o.length;
    if (!(a == s && o.getSide() <= 0)) {
      if (e > s && e < a && o.dom.parentNode == t)
        return o.domAtPos(e - s);
      if (e <= s)
        break;
      s = a;
    }
  }
  for (let s = i; s > 0; s--) {
    let o = n[s - 1];
    if (o.dom.parentNode == t)
      return o.domAtPos(o.length);
  }
  for (let s = i; s < n.length; s++) {
    let o = n[s];
    if (o.dom.parentNode == t)
      return o.domAtPos(0);
  }
  return new Hs(t, 0);
}
function bVe(r, e, t) {
  let n, { children: i } = r;
  t > 0 && e instanceof Ud && i.length && (n = i[i.length - 1]) instanceof Ud && n.mark.eq(e.mark) ? bVe(n, e.children[0], t - 1) : (i.push(e), e.setParent(r)), r.length += e.length;
}
function yVe(r, e, t) {
  let n = null, i = -1, s = null, o = -1;
  function a(c, d) {
    for (let u = 0, f = 0; u < c.children.length && f <= d; u++) {
      let p = c.children[u], g = f + p.length;
      g >= d && (p.children.length ? a(p, d - f) : (!s || s.isHidden && t > 0) && (g > d || f == g && p.getSide() > 0) ? (s = p, o = d - f) : (f < d || f == g && p.getSide() < 0 && !p.isHidden) && (n = p, i = d - f)), f = g;
    }
  }
  a(r, e);
  let l = (t < 0 ? n : s) || n || s;
  return l ? l.coordsAt(Math.max(0, l == n ? i : o), t) : tPt(r);
}
function tPt(r) {
  let e = r.dom.lastChild;
  if (!e)
    return r.dom.getBoundingClientRect();
  let t = O4(e);
  return t[t.length - 1] || null;
}
function iT(r, e) {
  for (let t in r)
    t == "class" && e.class ? e.class += " " + r.class : t == "style" && e.style ? e.style += ";" + r.style : e[t] = r[t];
  return e;
}
const YCe = /* @__PURE__ */ Object.create(null);
function qV(r, e, t) {
  if (r == e)
    return !0;
  r || (r = YCe), e || (e = YCe);
  let n = Object.keys(r), i = Object.keys(e);
  if (n.length - (t && n.indexOf(t) > -1 ? 1 : 0) != i.length - (t && i.indexOf(t) > -1 ? 1 : 0))
    return !1;
  for (let s of n)
    if (s != t && (i.indexOf(s) == -1 || r[s] !== e[s]))
      return !1;
  return !0;
}
function rT(r, e, t) {
  let n = !1;
  if (e)
    for (let i in e)
      t && i in t || (n = !0, i == "style" ? r.style.cssText = "" : r.removeAttribute(i));
  if (t)
    for (let i in t)
      e && e[i] == t[i] || (n = !0, i == "style" ? r.style.cssText = t[i] : r.setAttribute(i, t[i]));
  return n;
}
function nPt(r) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t = 0; t < r.attributes.length; t++) {
    let n = r.attributes[t];
    e[n.name] = n.value;
  }
  return e;
}
class Vr extends Ni {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, t, n, i, s, o) {
    if (n) {
      if (!(n instanceof Vr))
        return !1;
      this.dom || n.transferDOM(this);
    }
    return i && this.setDeco(n ? n.attrs : null), mVe(this, e, t, n ? n.children.slice() : [], s, o), !0;
  }
  split(e) {
    let t = new Vr();
    if (t.breakAfter = this.breakAfter, this.length == 0)
      return t;
    let { i: n, off: i } = this.childPos(e);
    i && (t.append(this.children[n].split(i), 0), this.children[n].merge(i, this.children[n].length, null, !1, 0, 0), n++);
    for (let s = n; s < this.children.length; s++)
      t.append(this.children[s], 0);
    for (; n > 0 && this.children[n - 1].length == 0; )
      this.children[--n].destroy();
    return this.children.length = n, this.markDirty(), this.length = e, t;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    qV(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, t) {
    bVe(this, e, t);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let t = e.spec.attributes, n = e.spec.class;
    t && (this.attrs = iT(t, this.attrs || {})), n && (this.attrs = iT({ class: n }, this.attrs || {}));
  }
  domAtPos(e) {
    return vVe(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, t) {
    var n;
    this.dom ? this.flags & 4 && (uVe(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (rT(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, t);
    let i = this.dom.lastChild;
    for (; i && Ni.get(i) instanceof Ud; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((n = Ni.get(i)) === null || n === void 0 ? void 0 : n.isEditable) == !1 && (!ft.ios || !this.children.some((s) => s instanceof Zd))) {
      let s = document.createElement("BR");
      s.cmIgnore = !0, this.dom.appendChild(s);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, t;
    for (let n of this.children) {
      if (!(n instanceof Zd) || /[^ -~]/.test(n.text))
        return null;
      let i = O4(n.dom);
      if (i.length != 1)
        return null;
      e += i[0].width, t = i[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: t
    } : null;
  }
  coordsAt(e, t) {
    let n = yVe(this, e, t);
    if (!this.children.length && n && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, s = n.bottom - n.top;
      if (Math.abs(s - i.lineHeight) < 2 && i.textHeight < s) {
        let o = (s - i.textHeight) / 2;
        return { top: n.top + o, bottom: n.bottom - o, left: n.left, right: n.left };
      }
    }
    return n;
  }
  become(e) {
    return !1;
  }
  covers() {
    return !0;
  }
  static find(e, t) {
    for (let n = 0, i = 0; n < e.children.length; n++) {
      let s = e.children[n], o = i + s.length;
      if (o >= t) {
        if (s instanceof Vr)
          return s;
        if (o > t)
          break;
      }
      i = o + s.breakAfter;
    }
    return null;
  }
}
class n1 extends Ni {
  constructor(e, t, n) {
    super(), this.widget = e, this.length = t, this.deco = n, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, t, n, i, s, o) {
    return n && (!(n instanceof n1) || !this.widget.compare(n.widget) || e > 0 && s <= 0 || t < this.length && o <= 0) ? !1 : (this.length = e + (n ? n.length : 0) + (this.length - t), !0);
  }
  domAtPos(e) {
    return e == 0 ? Hs.before(this.dom) : Hs.after(this.dom, e == this.length);
  }
  split(e) {
    let t = this.length - e;
    this.length = e;
    let n = new n1(this.widget, t, this.deco);
    return n.breakAfter = this.breakAfter, n;
  }
  get children() {
    return UV;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : li.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof n1 && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, t) {
    return this.widget.coordsAt(this.dom, e, t);
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: t, endSide: n } = this.deco;
    return t == n ? !1 : e < 0 ? t < 0 : n > 0;
  }
}
class Xw {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, t) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, t, n) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var Jl = /* @__PURE__ */ function(r) {
  return r[r.Text = 0] = "Text", r[r.WidgetBefore = 1] = "WidgetBefore", r[r.WidgetAfter = 2] = "WidgetAfter", r[r.WidgetRange = 3] = "WidgetRange", r;
}(Jl || (Jl = {}));
class pi extends Nf {
  constructor(e, t, n, i) {
    super(), this.startSide = e, this.endSide = t, this.widget = n, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new Jw(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let t = Math.max(-1e4, Math.min(1e4, e.side || 0)), n = !!e.block;
    return t += n && !e.inlineOrder ? t > 0 ? 3e8 : -4e8 : t > 0 ? 1e8 : -1e8, new _1(e, t, t, n, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let t = !!e.block, n, i;
    if (e.isBlockGap)
      n = -5e8, i = 4e8;
    else {
      let { start: s, end: o } = CVe(e, t);
      n = (s ? t ? -3e8 : -1 : 5e8) - 1, i = (o ? t ? 2e8 : 1 : -6e8) + 1;
    }
    return new _1(e, n, i, t, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new $w(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, t = !1) {
    return oi.of(e, t);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
pi.none = oi.empty;
class Jw extends pi {
  constructor(e) {
    let { start: t, end: n } = CVe(e);
    super(t ? -1 : 5e8, n ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var t, n;
    return this == e || e instanceof Jw && this.tagName == e.tagName && (this.class || ((t = this.attrs) === null || t === void 0 ? void 0 : t.class)) == (e.class || ((n = e.attrs) === null || n === void 0 ? void 0 : n.class)) && qV(this.attrs, e.attrs, "class");
  }
  range(e, t = e) {
    if (e >= t)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, t);
  }
}
Jw.prototype.point = !1;
class $w extends pi {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof $w && this.spec.class == e.spec.class && qV(this.spec.attributes, e.spec.attributes);
  }
  range(e, t = e) {
    if (t != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, t);
  }
}
$w.prototype.mapMode = ps.TrackBefore;
$w.prototype.point = !0;
class _1 extends pi {
  constructor(e, t, n, i, s, o) {
    super(t, n, s, e), this.block = i, this.isReplace = o, this.mapMode = i ? t <= 0 ? ps.TrackBefore : ps.TrackAfter : ps.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? Jl.WidgetRange : this.startSide <= 0 ? Jl.WidgetBefore : Jl.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof _1 && iPt(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, t = e) {
    if (this.isReplace && (e > t || e == t && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && t != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, t);
  }
}
_1.prototype.point = !0;
function CVe(r, e = !1) {
  let { inclusiveStart: t, inclusiveEnd: n } = r;
  return t == null && (t = r.inclusive), n == null && (n = r.inclusive), { start: t ?? e, end: n ?? e };
}
function iPt(r, e) {
  return r == e || !!(r && e && r.compare(e));
}
function sT(r, e, t, n = 0) {
  let i = t.length - 1;
  i >= 0 && t[i] + n >= r ? t[i] = Math.max(t[i], e) : t.push(r, e);
}
class A3 {
  constructor(e, t, n, i) {
    this.doc = e, this.pos = t, this.end = n, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = t;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof n1 && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new Vr()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(H5(new Ng(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof n1) && this.getLine();
  }
  buildText(e, t, n) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: s, lineBreak: o, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (o) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = s, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(t.slice(t.length - n)), this.getLine().append(H5(new Zd(this.text.slice(this.textOff, this.textOff + i)), t), n), this.atCursorPos = !0, this.textOff += i, e -= i, n = 0;
    }
  }
  span(e, t, n, i) {
    this.buildText(t - e, n, i), this.pos = t, this.openStart < 0 && (this.openStart = i);
  }
  point(e, t, n, i, s, o) {
    if (this.disallowBlockEffectsFor[o] && n instanceof _1) {
      if (n.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (t > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = t - e;
    if (n instanceof _1)
      if (n.block)
        n.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new n1(n.widget || new XCe("div"), a, n));
      else {
        let l = Uu.create(n.widget || new XCe("span"), a, a ? 0 : n.startSide), c = this.atCursorPos && !l.isEditable && s <= i.length && (e < t || n.startSide > 0), d = !l.isEditable && (e < t || s > i.length || n.startSide <= 0), u = this.getLine();
        this.pendingBuffer == 2 && !c && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), c && (u.append(H5(new Ng(1), i), s), s = i.length + Math.max(0, s - i.length)), u.append(H5(l, i), s), this.atCursorPos = d, this.pendingBuffer = d ? e < t || s > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(n);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = t), this.openStart < 0 && (this.openStart = s);
  }
  static build(e, t, n, i, s) {
    let o = new A3(e, t, n, s);
    return o.openEnd = oi.spans(i, t, n, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}
function H5(r, e) {
  for (let t of e)
    r = new Ud(t, [r], r.length);
  return r;
}
class XCe extends Xw {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
var nr = /* @__PURE__ */ function(r) {
  return r[r.LTR = 0] = "LTR", r[r.RTL = 1] = "RTL", r;
}(nr || (nr = {}));
const If = nr.LTR, GV = nr.RTL;
function EVe(r) {
  let e = [];
  for (let t = 0; t < r.length; t++)
    e.push(1 << +r[t]);
  return e;
}
const rPt = /* @__PURE__ */ EVe("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), sPt = /* @__PURE__ */ EVe("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), oT = /* @__PURE__ */ Object.create(null), Oc = [];
for (let r of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ r.charCodeAt(0), t = /* @__PURE__ */ r.charCodeAt(1);
  oT[e] = t, oT[t] = -e;
}
function _Ve(r) {
  return r <= 247 ? rPt[r] : 1424 <= r && r <= 1524 ? 2 : 1536 <= r && r <= 1785 ? sPt[r - 1536] : 1774 <= r && r <= 2220 ? 4 : 8192 <= r && r <= 8204 ? 256 : 64336 <= r && r <= 65023 ? 4 : 1;
}
const oPt = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class qu {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? GV : If;
  }
  /**
  @internal
  */
  constructor(e, t, n) {
    this.from = e, this.to = t, this.level = n;
  }
  /**
  @internal
  */
  side(e, t) {
    return this.dir == t == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, t) {
    return e == (this.dir == t);
  }
  /**
  @internal
  */
  static find(e, t, n, i) {
    let s = -1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.from <= t && a.to >= t) {
        if (a.level == n)
          return o;
        (s < 0 || (i != 0 ? i < 0 ? a.from < t : a.to > t : e[s].level > a.level)) && (s = o);
      }
    }
    if (s < 0)
      throw new RangeError("Index out of range");
    return s;
  }
}
function xVe(r, e) {
  if (r.length != e.length)
    return !1;
  for (let t = 0; t < r.length; t++) {
    let n = r[t], i = e[t];
    if (n.from != i.from || n.to != i.to || n.direction != i.direction || !xVe(n.inner, i.inner))
      return !1;
  }
  return !0;
}
const Ci = [];
function aPt(r, e, t, n, i) {
  for (let s = 0; s <= n.length; s++) {
    let o = s ? n[s - 1].to : e, a = s < n.length ? n[s].from : t, l = s ? 256 : i;
    for (let c = o, d = l, u = l; c < a; c++) {
      let f = _Ve(r.charCodeAt(c));
      f == 512 ? f = d : f == 8 && u == 4 && (f = 16), Ci[c] = f == 4 ? 2 : f, f & 7 && (u = f), d = f;
    }
    for (let c = o, d = l, u = l; c < a; c++) {
      let f = Ci[c];
      if (f == 128)
        c < a - 1 && d == Ci[c + 1] && d & 24 ? f = Ci[c] = d : Ci[c] = 256;
      else if (f == 64) {
        let p = c + 1;
        for (; p < a && Ci[p] == 64; )
          p++;
        let g = c && d == 8 || p < t && Ci[p] == 8 ? u == 1 ? 1 : 8 : 256;
        for (let m = c; m < p; m++)
          Ci[m] = g;
        c = p - 1;
      } else f == 8 && u == 1 && (Ci[c] = 1);
      d = f, f & 7 && (u = f);
    }
  }
}
function lPt(r, e, t, n, i) {
  let s = i == 1 ? 2 : 1;
  for (let o = 0, a = 0, l = 0; o <= n.length; o++) {
    let c = o ? n[o - 1].to : e, d = o < n.length ? n[o].from : t;
    for (let u = c, f, p, g; u < d; u++)
      if (p = oT[f = r.charCodeAt(u)])
        if (p < 0) {
          for (let m = a - 3; m >= 0; m -= 3)
            if (Oc[m + 1] == -p) {
              let A = Oc[m + 2], w = A & 2 ? i : A & 4 ? A & 1 ? s : i : 0;
              w && (Ci[u] = Ci[Oc[m]] = w), a = m;
              break;
            }
        } else {
          if (Oc.length == 189)
            break;
          Oc[a++] = u, Oc[a++] = f, Oc[a++] = l;
        }
      else if ((g = Ci[u]) == 2 || g == 1) {
        let m = g == i;
        l = m ? 0 : 1;
        for (let A = a - 3; A >= 0; A -= 3) {
          let w = Oc[A + 2];
          if (w & 2)
            break;
          if (m)
            Oc[A + 2] |= 2;
          else {
            if (w & 4)
              break;
            Oc[A + 2] |= 4;
          }
        }
      }
  }
}
function cPt(r, e, t, n) {
  for (let i = 0, s = n; i <= t.length; i++) {
    let o = i ? t[i - 1].to : r, a = i < t.length ? t[i].from : e;
    for (let l = o; l < a; ) {
      let c = Ci[l];
      if (c == 256) {
        let d = l + 1;
        for (; ; )
          if (d == a) {
            if (i == t.length)
              break;
            d = t[i++].to, a = i < t.length ? t[i].from : e;
          } else if (Ci[d] == 256)
            d++;
          else
            break;
        let u = s == 1, f = (d < e ? Ci[d] : n) == 1, p = u == f ? u ? 1 : 2 : n;
        for (let g = d, m = i, A = m ? t[m - 1].to : r; g > l; )
          g == A && (g = t[--m].from, A = m ? t[m - 1].to : r), Ci[--g] = p;
        l = d;
      } else
        s = c, l++;
    }
  }
}
function aT(r, e, t, n, i, s, o) {
  let a = n % 2 ? 2 : 1;
  if (n % 2 == i % 2)
    for (let l = e, c = 0; l < t; ) {
      let d = !0, u = !1;
      if (c == s.length || l < s[c].from) {
        let m = Ci[l];
        m != a && (d = !1, u = m == 16);
      }
      let f = !d && a == 1 ? [] : null, p = d ? n : n + 1, g = l;
      e: for (; ; )
        if (c < s.length && g == s[c].from) {
          if (u)
            break e;
          let m = s[c];
          if (!d)
            for (let A = m.to, w = c + 1; ; ) {
              if (A == t)
                break e;
              if (w < s.length && s[w].from == A)
                A = s[w++].to;
              else {
                if (Ci[A] == a)
                  break e;
                break;
              }
            }
          if (c++, f)
            f.push(m);
          else {
            m.from > l && o.push(new qu(l, m.from, p));
            let A = m.direction == If != !(p % 2);
            lT(r, A ? n + 1 : n, i, m.inner, m.from, m.to, o), l = m.to;
          }
          g = m.to;
        } else {
          if (g == t || (d ? Ci[g] != a : Ci[g] == a))
            break;
          g++;
        }
      f ? aT(r, l, g, n + 1, i, f, o) : l < g && o.push(new qu(l, g, p)), l = g;
    }
  else
    for (let l = t, c = s.length; l > e; ) {
      let d = !0, u = !1;
      if (!c || l > s[c - 1].to) {
        let m = Ci[l - 1];
        m != a && (d = !1, u = m == 16);
      }
      let f = !d && a == 1 ? [] : null, p = d ? n : n + 1, g = l;
      e: for (; ; )
        if (c && g == s[c - 1].to) {
          if (u)
            break e;
          let m = s[--c];
          if (!d)
            for (let A = m.from, w = c; ; ) {
              if (A == e)
                break e;
              if (w && s[w - 1].to == A)
                A = s[--w].from;
              else {
                if (Ci[A - 1] == a)
                  break e;
                break;
              }
            }
          if (f)
            f.push(m);
          else {
            m.to < l && o.push(new qu(m.to, l, p));
            let A = m.direction == If != !(p % 2);
            lT(r, A ? n + 1 : n, i, m.inner, m.from, m.to, o), l = m.from;
          }
          g = m.from;
        } else {
          if (g == e || (d ? Ci[g - 1] != a : Ci[g - 1] == a))
            break;
          g--;
        }
      f ? aT(r, g, l, n + 1, i, f, o) : g < l && o.push(new qu(g, l, p)), l = g;
    }
}
function lT(r, e, t, n, i, s, o) {
  let a = e % 2 ? 2 : 1;
  aPt(r, i, s, n, a), lPt(r, i, s, n, a), cPt(i, s, n, a), aT(r, i, s, e, t, n, o);
}
function hPt(r, e, t) {
  if (!r)
    return [new qu(0, 0, e == GV ? 1 : 0)];
  if (e == If && !t.length && !oPt.test(r))
    return SVe(r.length);
  if (t.length)
    for (; r.length > Ci.length; )
      Ci[Ci.length] = 256;
  let n = [], i = e == If ? 0 : 1;
  return lT(r, i, i, t, 0, r.length, n), n;
}
function SVe(r) {
  return [new qu(0, r, 0)];
}
let MVe = "";
function dPt(r, e, t, n, i) {
  var s;
  let o = n.head - r.from, a = qu.find(e, o, (s = n.bidiLevel) !== null && s !== void 0 ? s : -1, n.assoc), l = e[a], c = l.side(i, t);
  if (o == c) {
    let f = a += i ? 1 : -1;
    if (f < 0 || f >= e.length)
      return null;
    l = e[a = f], o = l.side(!i, t), c = l.side(i, t);
  }
  let d = ro(r.text, o, l.forward(i, t));
  (d < l.from || d > l.to) && (d = c), MVe = r.text.slice(Math.min(o, d), Math.max(o, d));
  let u = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return u && d == c && u.level + (i ? 0 : 1) < l.level ? Be.cursor(u.side(!i, t) + r.from, u.forward(i, t) ? 1 : -1, u.level) : Be.cursor(d + r.from, l.forward(i, t) ? -1 : 1, l.level);
}
function uPt(r, e, t) {
  for (let n = e; n < t; n++) {
    let i = _Ve(r.charCodeAt(n));
    if (i == 1)
      return If;
    if (i == 2 || i == 4)
      return GV;
  }
  return If;
}
const DVe = /* @__PURE__ */ bt.define(), LVe = /* @__PURE__ */ bt.define(), kVe = /* @__PURE__ */ bt.define(), NVe = /* @__PURE__ */ bt.define(), cT = /* @__PURE__ */ bt.define(), TVe = /* @__PURE__ */ bt.define(), IVe = /* @__PURE__ */ bt.define(), OVe = /* @__PURE__ */ bt.define({
  combine: (r) => r.some((e) => e)
}), fPt = /* @__PURE__ */ bt.define({
  combine: (r) => r.some((e) => e)
});
class Wp {
  constructor(e, t = "nearest", n = "nearest", i = 5, s = 5, o = !1) {
    this.range = e, this.y = t, this.x = n, this.yMargin = i, this.xMargin = s, this.isSnapshot = o;
  }
  map(e) {
    return e.empty ? this : new Wp(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new Wp(Be.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const B5 = /* @__PURE__ */ Qn.define({ map: (r, e) => r.map(e) });
function va(r, e, t) {
  let n = r.facet(NVe);
  n.length ? n[0](e) : window.onerror ? window.onerror(String(e), t, void 0, void 0, e) : t ? console.error(t + ":", e) : console.error(e);
}
const lC = /* @__PURE__ */ bt.define({ combine: (r) => r.length ? r[0] : !0 });
let pPt = 0;
const LA = /* @__PURE__ */ bt.define();
class Ca {
  constructor(e, t, n, i, s) {
    this.id = e, this.create = t, this.domEventHandlers = n, this.domEventObservers = i, this.extension = s(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, t) {
    const { eventHandlers: n, eventObservers: i, provide: s, decorations: o } = t || {};
    return new Ca(pPt++, e, n, i, (a) => {
      let l = [LA.of(a)];
      return o && l.push(V4.of((c) => {
        let d = c.plugin(a);
        return d ? o(d) : pi.none;
      })), s && l.push(s(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, t) {
    return Ca.define((n) => new e(n), t);
  }
}
class CS {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let t = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(t);
          } catch (n) {
            if (va(t.state, n, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (t) {
        va(e.state, t, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var t;
    if (!((t = this.value) === null || t === void 0) && t.destroy)
      try {
        this.value.destroy();
      } catch (n) {
        va(e.state, n, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const RVe = /* @__PURE__ */ bt.define(), QV = /* @__PURE__ */ bt.define(), V4 = /* @__PURE__ */ bt.define(), VVe = /* @__PURE__ */ bt.define(), KV = /* @__PURE__ */ bt.define(), HVe = /* @__PURE__ */ bt.define();
function JCe(r, e) {
  let t = r.state.facet(HVe);
  if (!t.length)
    return t;
  let n = t.map((s) => s instanceof Function ? s(r) : s), i = [];
  return oi.spans(n, e.from, e.to, {
    point() {
    },
    span(s, o, a, l) {
      let c = s - e.from, d = o - e.from, u = i;
      for (let f = a.length - 1; f >= 0; f--, l--) {
        let p = a[f].spec.bidiIsolate, g;
        if (p == null && (p = uPt(e.text, c, d)), l > 0 && u.length && (g = u[u.length - 1]).to == c && g.direction == p)
          g.to = d, u = g.inner;
        else {
          let m = { from: c, to: d, direction: p, inner: [] };
          u.push(m), u = m.inner;
        }
      }
    }
  }), i;
}
const BVe = /* @__PURE__ */ bt.define();
function PVe(r) {
  let e = 0, t = 0, n = 0, i = 0;
  for (let s of r.state.facet(BVe)) {
    let o = s(r);
    o && (o.left != null && (e = Math.max(e, o.left)), o.right != null && (t = Math.max(t, o.right)), o.top != null && (n = Math.max(n, o.top)), o.bottom != null && (i = Math.max(i, o.bottom)));
  }
  return { left: e, right: t, top: n, bottom: i };
}
const kA = /* @__PURE__ */ bt.define();
class cl {
  constructor(e, t, n, i) {
    this.fromA = e, this.toA = t, this.fromB = n, this.toB = i;
  }
  join(e) {
    return new cl(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let t = e.length, n = this;
    for (; t > 0; t--) {
      let i = e[t - 1];
      if (!(i.fromA > n.toA)) {
        if (i.toA < n.fromA)
          break;
        n = n.join(i), e.splice(t - 1, 1);
      }
    }
    return e.splice(t, 0, n), e;
  }
  static extendWithRanges(e, t) {
    if (t.length == 0)
      return e;
    let n = [];
    for (let i = 0, s = 0, o = 0, a = 0; ; i++) {
      let l = i == e.length ? null : e[i], c = o - a, d = l ? l.fromB : 1e9;
      for (; s < t.length && t[s] < d; ) {
        let u = t[s], f = t[s + 1], p = Math.max(a, u), g = Math.min(d, f);
        if (p <= g && new cl(p + c, g + c, p, g).addToSet(n), f > d)
          break;
        s += 2;
      }
      if (!l)
        return n;
      new cl(l.fromA, l.toA, l.fromB, l.toB).addToSet(n), o = l.toA, a = l.toB;
    }
  }
}
class Vb {
  constructor(e, t, n) {
    this.view = e, this.state = t, this.transactions = n, this.flags = 0, this.startState = e.state, this.changes = es.empty(this.startState.doc.length);
    for (let s of n)
      this.changes = this.changes.compose(s.changes);
    let i = [];
    this.changes.iterChangedRanges((s, o, a, l) => i.push(new cl(s, o, a, l))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(e, t, n) {
    return new Vb(e, t, n);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 10) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class $Ce extends Ni {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new Vr()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new cl(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var t;
    let n = e.changedRanges;
    this.minWidth > 0 && n.length && (n.every(({ fromA: c, toA: d }) => d < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
    let i = -1;
    this.view.inputState.composing >= 0 && (!((t = this.domChanged) === null || t === void 0) && t.newSel ? i = this.domChanged.newSel.head : !yPt(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let s = i > -1 ? mPt(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: d } = this.hasComposition;
      n = new cl(c, d, e.changes.mapPos(c, -1), e.changes.mapPos(d, 1)).addToSet(n.slice());
    }
    this.hasComposition = s ? { from: s.range.fromB, to: s.range.toB } : null, (ft.ie || ft.chrome) && !s && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, a = this.updateDeco(), l = vPt(o, a, e.changes);
    return n = cl.extendWithRanges(n, l), !(this.flags & 7) && n.length == 0 ? !1 : (this.updateInner(n, e.startState.doc.length, s), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, t, n) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, t, n);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = ft.chrome || ft.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || i.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let s = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof n1 && o.widget instanceof eEe && s.push(o.dom);
    i.updateGaps(s);
  }
  updateChildren(e, t, n) {
    let i = n ? n.range.addToSet(e.slice()) : e, s = this.childCursor(t);
    for (let o = i.length - 1; ; o--) {
      let a = o >= 0 ? i[o] : null;
      if (!a)
        break;
      let { fromA: l, toA: c, fromB: d, toB: u } = a, f, p, g, m;
      if (n && n.range.fromB < u && n.range.toB > d) {
        let _ = A3.build(this.view.state.doc, d, n.range.fromB, this.decorations, this.dynamicDecorationMap), S = A3.build(this.view.state.doc, n.range.toB, u, this.decorations, this.dynamicDecorationMap);
        p = _.breakAtStart, g = _.openStart, m = S.openEnd;
        let D = this.compositionView(n);
        S.breakAtStart ? D.breakAfter = 1 : S.content.length && D.merge(D.length, D.length, S.content[0], !1, S.openStart, 0) && (D.breakAfter = S.content[0].breakAfter, S.content.shift()), _.content.length && D.merge(0, 0, _.content[_.content.length - 1], !0, 0, _.openEnd) && _.content.pop(), f = _.content.concat(D).concat(S.content);
      } else
        ({ content: f, breakAtStart: p, openStart: g, openEnd: m } = A3.build(this.view.state.doc, d, u, this.decorations, this.dynamicDecorationMap));
      let { i: A, off: w } = s.findPos(c, 1), { i: v, off: y } = s.findPos(l, -1);
      gVe(this, v, y, A, w, f, p, g, m);
    }
    n && this.fixCompositionDOM(n);
  }
  compositionView(e) {
    let t = new Zd(e.text.nodeValue);
    t.flags |= 8;
    for (let { deco: i } of e.marks)
      t = new Ud(i, [t], t.length);
    let n = new Vr();
    return n.append(t, 0), n;
  }
  fixCompositionDOM(e) {
    let t = (s, o) => {
      o.flags |= 8 | (o.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let a = Ni.get(s);
      a && a != o && (a.dom = null), o.setDOM(s);
    }, n = this.childPos(e.range.fromB, 1), i = this.children[n.i];
    t(e.line, i);
    for (let s = e.marks.length - 1; s >= -1; s--)
      n = i.childPos(n.off, 1), i = i.children[n.i], t(s >= 0 ? e.marks[s].node : e.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, t = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let n = this.view.root.activeElement, i = n == this.dom, s = !i && n8(this.dom, this.view.observer.selectionRange) && !(n && this.dom.contains(n));
    if (!(i || t || s))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (ft.gecko && a.empty && !this.hasComposition && gPt(l)) {
      let u = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(u, l.node.childNodes[l.offset] || null)), l = c = new Hs(u, 0), o = !0;
    }
    let d = this.view.observer.selectionRange;
    (o || !d.focusNode || (!m3(l.node, l.offset, d.anchorNode, d.anchorOffset) || !m3(c.node, c.offset, d.focusNode, d.focusOffset)) && !this.suppressWidgetCursorChange(d, a)) && (this.view.observer.ignore(() => {
      ft.android && ft.chrome && this.dom.contains(d.focusNode) && bPt(d.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let u = Rb(this.view.root);
      if (u) if (a.empty) {
        if (ft.gecko) {
          let f = APt(l.node, l.offset);
          if (f && f != 3) {
            let p = zVe(l.node, l.offset, f == 1 ? 1 : -1);
            p && (l = new Hs(p.node, p.offset));
          }
        }
        u.collapse(l.node, l.offset), a.bidiLevel != null && u.caretBidiLevel !== void 0 && (u.caretBidiLevel = a.bidiLevel);
      } else if (u.extend) {
        u.collapse(l.node, l.offset);
        try {
          u.extend(c.node, c.offset);
        } catch {
        }
      } else {
        let f = document.createRange();
        a.anchor > a.head && ([l, c] = [c, l]), f.setEnd(c.node, c.offset), f.setStart(l.node, l.offset), u.removeAllRanges(), u.addRange(f);
      }
      s && this.view.root.activeElement == this.dom && (this.dom.blur(), n && n.focus());
    }), this.view.observer.setSelectionRange(l, c)), this.impreciseAnchor = l.precise ? null : new Hs(d.anchorNode, d.anchorOffset), this.impreciseHead = c.precise ? null : new Hs(d.focusNode, d.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, t) {
    return this.hasComposition && t.empty && m3(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == t.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, t = e.state.selection.main, n = Rb(e.root), { anchorNode: i, anchorOffset: s } = e.observer.selectionRange;
    if (!n || !t.empty || !t.assoc || !n.modify)
      return;
    let o = Vr.find(this, t.head);
    if (!o)
      return;
    let a = o.posAtStart;
    if (t.head == a || t.head == a + o.length)
      return;
    let l = this.coordsAt(t.head, -1), c = this.coordsAt(t.head, 1);
    if (!l || !c || l.bottom > c.top)
      return;
    let d = this.domAtPos(t.head + t.assoc);
    n.collapse(d.node, d.offset), n.modify("move", t.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let u = e.observer.selectionRange;
    e.docView.posFromDOM(u.anchorNode, u.anchorOffset) != t.from && n.collapse(i, s);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let t = this.dom, n;
    if (e.node != t)
      return e;
    for (let i = e.offset; !n && i < t.childNodes.length; i++) {
      let s = Ni.get(t.childNodes[i]);
      s instanceof Vr && (n = s.domAtPos(0));
    }
    for (let i = e.offset - 1; !n && i >= 0; i--) {
      let s = Ni.get(t.childNodes[i]);
      s instanceof Vr && (n = s.domAtPos(s.length));
    }
    return n ? new Hs(n.node, n.offset, !0) : e;
  }
  nearest(e) {
    for (let t = e; t; ) {
      let n = Ni.get(t);
      if (n && n.rootView == this)
        return n;
      t = t.parentNode;
    }
    return null;
  }
  posFromDOM(e, t) {
    let n = this.nearest(e);
    if (!n)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return n.localPosFromDOM(e, t) + n.posAtStart;
  }
  domAtPos(e) {
    let { i: t, off: n } = this.childCursor().findPos(e, -1);
    for (; t < this.children.length - 1; ) {
      let i = this.children[t];
      if (n < i.length || i instanceof Vr)
        break;
      t++, n = 0;
    }
    return this.children[t].domAtPos(n);
  }
  coordsAt(e, t) {
    let n = null, i = 0;
    for (let s = this.length, o = this.children.length - 1; o >= 0; o--) {
      let a = this.children[o], l = s - a.breakAfter, c = l - a.length;
      if (l < e)
        break;
      c <= e && (c < e || a.covers(-1)) && (l > e || a.covers(1)) && (!n || a instanceof Vr && !(n instanceof Vr && t >= 0)) && (n = a, i = c), s = c;
    }
    return n ? n.coordsAt(e - i, t) : null;
  }
  coordsForChar(e) {
    let { i: t, off: n } = this.childPos(e, 1), i = this.children[t];
    if (!(i instanceof Vr))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: l } = i.childPos(n, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      n = l;
    }
    if (!(i instanceof Zd))
      return null;
    let s = ro(i.text, n);
    if (s == n)
      return null;
    let o = Tf(i.dom, n, s).getClientRects();
    for (let a = 0; a < o.length; a++) {
      let l = o[a];
      if (a == o.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let t = [], { from: n, to: i } = e, s = this.view.contentDOM.clientWidth, o = s > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == nr.LTR;
    for (let c = 0, d = 0; d < this.children.length; d++) {
      let u = this.children[d], f = c + u.length;
      if (f > i)
        break;
      if (c >= n) {
        let p = u.dom.getBoundingClientRect();
        if (t.push(p.height), o) {
          let g = u.dom.lastChild, m = g ? O4(g) : [];
          if (m.length) {
            let A = m[m.length - 1], w = l ? A.right - p.left : p.right - A.left;
            w > a && (a = w, this.minWidth = s, this.minWidthFrom = c, this.minWidthTo = f);
          }
        }
      }
      c = f + u.breakAfter;
    }
    return t;
  }
  textDirectionAt(e) {
    let { i: t } = this.childPos(e, 1);
    return getComputedStyle(this.children[t].dom).direction == "rtl" ? nr.RTL : nr.LTR;
  }
  measureTextSize() {
    for (let s of this.children)
      if (s instanceof Vr) {
        let o = s.measureTextSize();
        if (o)
          return o;
      }
    let e = document.createElement("div"), t, n, i;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let s = O4(e.firstChild)[0];
      t = e.getBoundingClientRect().height, n = s ? s.width / 27 : 7, i = s ? s.height : t, e.remove();
    }), { lineHeight: t, charWidth: n, textHeight: i };
  }
  childCursor(e = this.length) {
    let t = this.children.length;
    return t && (e -= this.children[--t].length), new pVe(this.children, e, t);
  }
  computeBlockGapDeco() {
    let e = [], t = this.view.viewState;
    for (let n = 0, i = 0; ; i++) {
      let s = i == t.viewports.length ? null : t.viewports[i], o = s ? s.from - 1 : this.length;
      if (o > n) {
        let a = (t.lineBlockAt(o).bottom - t.lineBlockAt(n).top) / this.view.scaleY;
        e.push(pi.replace({
          widget: new eEe(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(n, o));
      }
      if (!s)
        break;
      n = s.to + 1;
    }
    return pi.set(e);
  }
  updateDeco() {
    let e = this.view.state.facet(V4).map((i, s) => (this.dynamicDecorationMap[s] = typeof i == "function") ? i(this.view) : i), t = !1, n = this.view.state.facet(VVe).map((i, s) => {
      let o = typeof i == "function";
      return o && (t = !0), o ? i(this.view) : i;
    });
    n.length && (this.dynamicDecorationMap[e.length] = t, e.push(oi.join(n)));
    for (let i = e.length; i < e.length + 3; i++)
      this.dynamicDecorationMap[i] = !1;
    return this.decorations = [
      ...e,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = c.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    let { range: t } = e, n = this.coordsAt(t.head, t.empty ? t.assoc : t.head > t.anchor ? -1 : 1), i;
    if (!n)
      return;
    !t.empty && (i = this.coordsAt(t.anchor, t.anchor > t.head ? -1 : 1)) && (n = {
      left: Math.min(n.left, i.left),
      top: Math.min(n.top, i.top),
      right: Math.max(n.right, i.right),
      bottom: Math.max(n.bottom, i.bottom)
    });
    let s = PVe(this.view), o = {
      left: n.left - s.left,
      top: n.top - s.top,
      right: n.right + s.right,
      bottom: n.bottom + s.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    GBt(this.view.scrollDOM, o, t.head < t.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == nr.LTR);
  }
}
function gPt(r) {
  return r.node.nodeType == 1 && r.node.firstChild && (r.offset == 0 || r.node.childNodes[r.offset - 1].contentEditable == "false") && (r.offset == r.node.childNodes.length || r.node.childNodes[r.offset].contentEditable == "false");
}
class eEe extends Xw {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
}
function FVe(r, e) {
  let t = r.observer.selectionRange, n = t.focusNode && zVe(t.focusNode, t.focusOffset, 0);
  if (!n)
    return null;
  let i = e - n.offset;
  return { from: i, to: i + n.node.nodeValue.length, node: n.node };
}
function mPt(r, e, t) {
  let n = FVe(r, t);
  if (!n)
    return null;
  let { node: i, from: s, to: o } = n, a = i.nodeValue;
  if (/[\n\r]/.test(a) || r.state.doc.sliceString(n.from, n.to) != a)
    return null;
  let l = e.invertedDesc, c = new cl(l.mapPos(s), l.mapPos(o), s, o), d = [];
  for (let u = i.parentNode; ; u = u.parentNode) {
    let f = Ni.get(u);
    if (f instanceof Ud)
      d.push({ node: u, deco: f.mark });
    else {
      if (f instanceof Vr || u.nodeName == "DIV" && u.parentNode == r.contentDOM)
        return { range: c, text: i, marks: d, line: u };
      if (u != r.contentDOM)
        d.push({ node: u, deco: new Jw({
          inclusive: !0,
          attributes: nPt(u),
          tagName: u.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function zVe(r, e, t) {
  if (t <= 0)
    for (let n = r, i = e; ; ) {
      if (n.nodeType == 3)
        return { node: n, offset: i };
      if (n.nodeType == 1 && i > 0)
        n = n.childNodes[i - 1], i = jd(n);
      else
        break;
    }
  if (t >= 0)
    for (let n = r, i = e; ; ) {
      if (n.nodeType == 3)
        return { node: n, offset: i };
      if (n.nodeType == 1 && i < n.childNodes.length && t >= 0)
        n = n.childNodes[i], i = 0;
      else
        break;
    }
  return null;
}
function APt(r, e) {
  return r.nodeType != 1 ? 0 : (e && r.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < r.childNodes.length && r.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let wPt = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, t) {
    sT(e, t, this.changes);
  }
  comparePoint(e, t) {
    sT(e, t, this.changes);
  }
};
function vPt(r, e, t) {
  let n = new wPt();
  return oi.compare(r, e, t, n), n.changes;
}
function bPt(r, e) {
  for (let t = r; t && t != e; t = t.assignedSlot || t.parentNode)
    if (t.nodeType == 1 && t.contentEditable == "false")
      return !0;
  return !1;
}
function yPt(r, e) {
  let t = !1;
  return e && r.iterChangedRanges((n, i) => {
    n < e.to && i > e.from && (t = !0);
  }), t;
}
function CPt(r, e, t = 1) {
  let n = r.charCategorizer(e), i = r.doc.lineAt(e), s = e - i.from;
  if (i.length == 0)
    return Be.cursor(e);
  s == 0 ? t = 1 : s == i.length && (t = -1);
  let o = s, a = s;
  t < 0 ? o = ro(i.text, s, !1) : a = ro(i.text, s);
  let l = n(i.text.slice(o, a));
  for (; o > 0; ) {
    let c = ro(i.text, o, !1);
    if (n(i.text.slice(c, o)) != l)
      break;
    o = c;
  }
  for (; a < i.length; ) {
    let c = ro(i.text, a);
    if (n(i.text.slice(a, c)) != l)
      break;
    a = c;
  }
  return Be.range(o + i.from, a + i.from);
}
function EPt(r, e) {
  return e.left > r ? e.left - r : Math.max(0, r - e.right);
}
function _Pt(r, e) {
  return e.top > r ? e.top - r : Math.max(0, r - e.bottom);
}
function ES(r, e) {
  return r.top < e.bottom - 1 && r.bottom > e.top + 1;
}
function tEe(r, e) {
  return e < r.top ? { top: e, left: r.left, right: r.right, bottom: r.bottom } : r;
}
function nEe(r, e) {
  return e > r.bottom ? { top: r.top, left: r.left, right: r.right, bottom: e } : r;
}
function hT(r, e, t) {
  let n, i, s, o, a = !1, l, c, d, u;
  for (let g = r.firstChild; g; g = g.nextSibling) {
    let m = O4(g);
    for (let A = 0; A < m.length; A++) {
      let w = m[A];
      i && ES(i, w) && (w = tEe(nEe(w, i.bottom), i.top));
      let v = EPt(e, w), y = _Pt(t, w);
      if (v == 0 && y == 0)
        return g.nodeType == 3 ? iEe(g, e, t) : hT(g, e, t);
      if (!n || o > y || o == y && s > v) {
        n = g, i = w, s = v, o = y;
        let _ = y ? t < w.top ? -1 : 1 : v ? e < w.left ? -1 : 1 : 0;
        a = !_ || (_ > 0 ? A < m.length - 1 : A > 0);
      }
      v == 0 ? t > w.bottom && (!d || d.bottom < w.bottom) ? (l = g, d = w) : t < w.top && (!u || u.top > w.top) && (c = g, u = w) : d && ES(d, w) ? d = nEe(d, w.bottom) : u && ES(u, w) && (u = tEe(u, w.top));
    }
  }
  if (d && d.bottom >= t ? (n = l, i = d) : u && u.top <= t && (n = c, i = u), !n)
    return { node: r, offset: 0 };
  let f = Math.max(i.left, Math.min(i.right, e));
  if (n.nodeType == 3)
    return iEe(n, f, t);
  if (a && n.contentEditable != "false")
    return hT(n, f, t);
  let p = Array.prototype.indexOf.call(r.childNodes, n) + (e >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: r, offset: p };
}
function iEe(r, e, t) {
  let n = r.nodeValue.length, i = -1, s = 1e9, o = 0;
  for (let a = 0; a < n; a++) {
    let l = Tf(r, a, a + 1).getClientRects();
    for (let c = 0; c < l.length; c++) {
      let d = l[c];
      if (d.top == d.bottom)
        continue;
      o || (o = e - d.left);
      let u = (d.top > t ? d.top - t : t - d.bottom) - 1;
      if (d.left - 1 <= e && d.right + 1 >= e && u < s) {
        let f = e >= (d.left + d.right) / 2, p = f;
        if ((ft.chrome || ft.gecko) && Tf(r, a).getBoundingClientRect().left == d.right && (p = !f), u <= 0)
          return { node: r, offset: a + (p ? 1 : 0) };
        i = a + (p ? 1 : 0), s = u;
      }
    }
  }
  return { node: r, offset: i > -1 ? i : o > 0 ? r.nodeValue.length : 0 };
}
function WVe(r, e, t, n = -1) {
  var i, s;
  let o = r.contentDOM.getBoundingClientRect(), a = o.top + r.viewState.paddingTop, l, { docHeight: c } = r.viewState, { x: d, y: u } = e, f = u - a;
  if (f < 0)
    return 0;
  if (f > c)
    return r.state.doc.length;
  for (let _ = r.viewState.heightOracle.textHeight / 2, S = !1; l = r.elementAtHeight(f), l.type != Jl.Text; )
    for (; f = n > 0 ? l.bottom + _ : l.top - _, !(f >= 0 && f <= c); ) {
      if (S)
        return t ? null : 0;
      S = !0, n = -n;
    }
  u = a + f;
  let p = l.from;
  if (p < r.viewport.from)
    return r.viewport.from == 0 ? 0 : t ? null : rEe(r, o, l, d, u);
  if (p > r.viewport.to)
    return r.viewport.to == r.state.doc.length ? r.state.doc.length : t ? null : rEe(r, o, l, d, u);
  let g = r.dom.ownerDocument, m = r.root.elementFromPoint ? r.root : g, A = m.elementFromPoint(d, u);
  A && !r.contentDOM.contains(A) && (A = null), A || (d = Math.max(o.left + 1, Math.min(o.right - 1, d)), A = m.elementFromPoint(d, u), A && !r.contentDOM.contains(A) && (A = null));
  let w, v = -1;
  if (A && ((i = r.docView.nearest(A)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (g.caretPositionFromPoint) {
      let _ = g.caretPositionFromPoint(d, u);
      _ && ({ offsetNode: w, offset: v } = _);
    } else if (g.caretRangeFromPoint) {
      let _ = g.caretRangeFromPoint(d, u);
      _ && ({ startContainer: w, startOffset: v } = _, (!r.contentDOM.contains(w) || ft.safari && xPt(w, v, d) || ft.chrome && SPt(w, v, d)) && (w = void 0));
    }
  }
  if (!w || !r.docView.dom.contains(w)) {
    let _ = Vr.find(r.docView, p);
    if (!_)
      return f > l.top + l.height / 2 ? l.to : l.from;
    ({ node: w, offset: v } = hT(_.dom, d, u));
  }
  let y = r.docView.nearest(w);
  if (!y)
    return null;
  if (y.isWidget && ((s = y.dom) === null || s === void 0 ? void 0 : s.nodeType) == 1) {
    let _ = y.dom.getBoundingClientRect();
    return e.y < _.top || e.y <= _.bottom && e.x <= (_.left + _.right) / 2 ? y.posAtStart : y.posAtEnd;
  } else
    return y.localPosFromDOM(w, v) + y.posAtStart;
}
function rEe(r, e, t, n, i) {
  let s = Math.round((n - e.left) * r.defaultCharacterWidth);
  if (r.lineWrapping && t.height > r.defaultLineHeight * 1.5) {
    let a = r.viewState.heightOracle.textHeight, l = Math.floor((i - t.top - (r.defaultLineHeight - a) * 0.5) / a);
    s += l * r.viewState.heightOracle.lineLength;
  }
  let o = r.state.sliceDoc(t.from, t.to);
  return t.from + FBt(o, s, r.state.tabSize);
}
function xPt(r, e, t) {
  let n;
  if (r.nodeType != 3 || e != (n = r.nodeValue.length))
    return !1;
  for (let i = r.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return Tf(r, n - 1, n).getBoundingClientRect().left > t;
}
function SPt(r, e, t) {
  if (e != 0)
    return !1;
  for (let i = r; ; ) {
    let s = i.parentNode;
    if (!s || s.nodeType != 1 || s.firstChild != i)
      return !1;
    if (s.classList.contains("cm-line"))
      break;
    i = s;
  }
  let n = r.nodeType == 1 ? r.getBoundingClientRect() : Tf(r, 0, Math.max(r.nodeValue.length, 1)).getBoundingClientRect();
  return t - n.left > 5;
}
function MPt(r, e) {
  let t = r.lineBlockAt(e);
  if (Array.isArray(t.type)) {
    for (let n of t.type)
      if (n.to > e || n.to == e && (n.to == t.to || n.type == Jl.Text))
        return n;
  }
  return t;
}
function DPt(r, e, t, n) {
  let i = MPt(r, e.head), s = !n || i.type != Jl.Text || !(r.lineWrapping || i.widgetLineBreaks) ? null : r.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (s) {
    let o = r.dom.getBoundingClientRect(), a = r.textDirectionAt(i.from), l = r.posAtCoords({
      x: t == (a == nr.LTR) ? o.right - 1 : o.left + 1,
      y: (s.top + s.bottom) / 2
    });
    if (l != null)
      return Be.cursor(l, t ? -1 : 1);
  }
  return Be.cursor(t ? i.to : i.from, t ? -1 : 1);
}
function sEe(r, e, t, n) {
  let i = r.state.doc.lineAt(e.head), s = r.bidiSpans(i), o = r.textDirectionAt(i.from);
  for (let a = e, l = null; ; ) {
    let c = dPt(i, s, o, a, t), d = MVe;
    if (!c) {
      if (i.number == (t ? r.state.doc.lines : 1))
        return a;
      d = `
`, i = r.state.doc.line(i.number + (t ? 1 : -1)), s = r.bidiSpans(i), c = r.visualLineSide(i, !t);
    }
    if (l) {
      if (!l(d))
        return a;
    } else {
      if (!n)
        return c;
      l = n(d);
    }
    a = c;
  }
}
function LPt(r, e, t) {
  let n = r.state.charCategorizer(e), i = n(t);
  return (s) => {
    let o = n(s);
    return i == rl.Space && (i = o), i == o;
  };
}
function kPt(r, e, t, n) {
  let i = e.head, s = t ? 1 : -1;
  if (i == (t ? r.state.doc.length : 0))
    return Be.cursor(i, e.assoc);
  let o = e.goalColumn, a, l = r.contentDOM.getBoundingClientRect(), c = r.coordsAtPos(i, e.assoc || -1), d = r.documentTop;
  if (c)
    o == null && (o = c.left - l.left), a = s < 0 ? c.top : c.bottom;
  else {
    let p = r.viewState.lineBlockAt(i);
    o == null && (o = Math.min(l.right - l.left, r.defaultCharacterWidth * (i - p.from))), a = (s < 0 ? p.top : p.bottom) + d;
  }
  let u = l.left + o, f = n ?? r.viewState.heightOracle.textHeight >> 1;
  for (let p = 0; ; p += 10) {
    let g = a + (f + p) * s, m = WVe(r, { x: u, y: g }, !1, s);
    if (g < l.top || g > l.bottom || (s < 0 ? m < i : m > i)) {
      let A = r.docView.coordsForChar(m), w = !A || g < A.top ? -1 : 1;
      return Be.cursor(m, w, void 0, o);
    }
  }
}
function i8(r, e, t) {
  for (; ; ) {
    let n = 0;
    for (let i of r)
      i.between(e - 1, e + 1, (s, o, a) => {
        if (e > s && e < o) {
          let l = n || t || (e - s < o - e ? -1 : 1);
          e = l < 0 ? s : o, n = l;
        }
      });
    if (!n)
      return e;
  }
}
function _S(r, e, t) {
  let n = i8(r.state.facet(KV).map((i) => i(r)), t.from, e.head > t.from ? -1 : 1);
  return n == t.from ? t : Be.cursor(n, n < t.from ? 1 : -1);
}
class NPt {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastEscPress = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, ft.safari && e.contentDOM.addEventListener("input", () => null), ft.gecko && GPt(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !PPt(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || this.runHandlers(e.type, e);
  }
  runHandlers(e, t) {
    let n = this.handlers[e];
    if (n) {
      for (let i of n.observers)
        i(this.view, t);
      for (let i of n.handlers) {
        if (t.defaultPrevented)
          break;
        if (i(this.view, t)) {
          t.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let t = TPt(e), n = this.handlers, i = this.view.contentDOM;
    for (let s in t)
      if (s != "scroll") {
        let o = !t[s].handlers.length, a = n[s];
        a && o != !a.handlers.length && (i.removeEventListener(s, this.handleEvent), a = null), a || i.addEventListener(s, this.handleEvent, { passive: o });
      }
    for (let s in n)
      s != "scroll" && !t[s] && i.removeEventListener(s, this.handleEvent);
    this.handlers = t;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return !0;
    if (e.keyCode != 27 && ZVe.indexOf(e.keyCode) < 0 && (this.view.inputState.lastEscPress = 0), ft.android && ft.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let t;
    return ft.ios && !e.synthetic && !e.altKey && !e.metaKey && ((t = jVe.find((n) => n.keyCode == e.keyCode)) && !e.ctrlKey || IPt.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = t || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey() {
    let e = this.pendingIOSKey;
    return e ? (this.pendingIOSKey = void 0, zp(this.view.contentDOM, e.key, e.keyCode)) : !1;
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : ft.safari && !ft.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function oEe(r, e) {
  return (t, n) => {
    try {
      return e.call(r, n, t);
    } catch (i) {
      va(t.state, i);
    }
  };
}
function TPt(r) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(n) {
    return e[n] || (e[n] = { observers: [], handlers: [] });
  }
  for (let n of r) {
    let i = n.spec;
    if (i && i.domEventHandlers)
      for (let s in i.domEventHandlers) {
        let o = i.domEventHandlers[s];
        o && t(s).handlers.push(oEe(n.value, o));
      }
    if (i && i.domEventObservers)
      for (let s in i.domEventObservers) {
        let o = i.domEventObservers[s];
        o && t(s).observers.push(oEe(n.value, o));
      }
  }
  for (let n in lc)
    t(n).handlers.push(lc[n]);
  for (let n in cc)
    t(n).observers.push(cc[n]);
  return e;
}
const jVe = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], IPt = "dthko", ZVe = [16, 17, 18, 20, 91, 92, 224, 225], P5 = 6;
function F5(r) {
  return Math.max(0, r) * 0.7 + 8;
}
function OPt(r, e) {
  return Math.max(Math.abs(r.clientX - e.clientX), Math.abs(r.clientY - e.clientY));
}
class RPt {
  constructor(e, t, n, i) {
    this.view = e, this.startEvent = t, this.style = n, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = t, this.scrollParent = QBt(e.contentDOM), this.atoms = e.state.facet(KV).map((o) => o(e));
    let s = e.contentDOM.ownerDocument;
    s.addEventListener("mousemove", this.move = this.move.bind(this)), s.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = t.shiftKey, this.multiple = e.state.facet(jn.allowMultipleSelections) && VPt(e, t), this.dragging = BPt(e, t) && QVe(t) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    var t;
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && OPt(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let n = 0, i = 0, s = ((t = this.scrollParent) === null || t === void 0 ? void 0 : t.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight }, o = PVe(this.view);
    e.clientX - o.left <= s.left + P5 ? n = -F5(s.left - e.clientX) : e.clientX + o.right >= s.right - P5 && (n = F5(e.clientX - s.right)), e.clientY - o.top <= s.top + P5 ? i = -F5(s.top - e.clientY) : e.clientY + o.bottom >= s.bottom - P5 && (i = F5(e.clientY - s.bottom)), this.setScrollSpeed(n, i);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, t) {
    this.scrollSpeed = { x: e, y: t }, e || t ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let t = null;
    for (let n = 0; n < e.ranges.length; n++) {
      let i = e.ranges[n], s = null;
      if (i.empty) {
        let o = i8(this.atoms, i.from, 0);
        o != i.from && (s = Be.cursor(o, -1));
      } else {
        let o = i8(this.atoms, i.from, -1), a = i8(this.atoms, i.to, 1);
        (o != i.from || a != i.to) && (s = Be.range(i.from == i.anchor ? o : a, i.from == i.head ? o : a));
      }
      s && (t || (t = e.ranges.slice()), t[n] = s);
    }
    return t ? Be.create(t, e.mainIndex) : e;
  }
  select(e) {
    let { view: t } = this, n = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !n.eq(t.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: n,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function VPt(r, e) {
  let t = r.state.facet(DVe);
  return t.length ? t[0](e) : ft.mac ? e.metaKey : e.ctrlKey;
}
function HPt(r, e) {
  let t = r.state.facet(LVe);
  return t.length ? t[0](e) : ft.mac ? !e.altKey : !e.ctrlKey;
}
function BPt(r, e) {
  let { main: t } = r.state.selection;
  if (t.empty)
    return !1;
  let n = Rb(r.root);
  if (!n || n.rangeCount == 0)
    return !0;
  let i = n.getRangeAt(0).getClientRects();
  for (let s = 0; s < i.length; s++) {
    let o = i[s];
    if (o.left <= e.clientX && o.right >= e.clientX && o.top <= e.clientY && o.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function PPt(r, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target, n; t != r.contentDOM; t = t.parentNode)
    if (!t || t.nodeType == 11 || (n = Ni.get(t)) && n.ignoreEvent(e))
      return !1;
  return !0;
}
const lc = /* @__PURE__ */ Object.create(null), cc = /* @__PURE__ */ Object.create(null), UVe = ft.ie && ft.ie_version < 15 || ft.ios && ft.webkit_version < 604;
function FPt(r) {
  let e = r.dom.parentNode;
  if (!e)
    return;
  let t = e.appendChild(document.createElement("textarea"));
  t.style.cssText = "position: fixed; left: -10000px; top: 10px", t.focus(), setTimeout(() => {
    r.focus(), t.remove(), qVe(r, t.value);
  }, 50);
}
function qVe(r, e) {
  let { state: t } = r, n, i = 1, s = t.toText(e), o = s.lines == t.selection.ranges.length;
  if (dT != null && t.selection.ranges.every((l) => l.empty) && dT == s.toString()) {
    let l = -1;
    n = t.changeByRange((c) => {
      let d = t.doc.lineAt(c.from);
      if (d.from == l)
        return { range: c };
      l = d.from;
      let u = t.toText((o ? s.line(i++).text : e) + t.lineBreak);
      return {
        changes: { from: d.from, insert: u },
        range: Be.cursor(c.from + u.length)
      };
    });
  } else o ? n = t.changeByRange((l) => {
    let c = s.line(i++);
    return {
      changes: { from: l.from, to: l.to, insert: c.text },
      range: Be.cursor(l.from + c.length)
    };
  }) : n = t.replaceSelection(s);
  r.dispatch(n, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
cc.scroll = (r) => {
  r.inputState.lastScrollTop = r.scrollDOM.scrollTop, r.inputState.lastScrollLeft = r.scrollDOM.scrollLeft;
};
lc.keydown = (r, e) => (r.inputState.setSelectionOrigin("select"), e.keyCode == 27 && (r.inputState.lastEscPress = Date.now()), !1);
cc.touchstart = (r, e) => {
  r.inputState.lastTouchTime = Date.now(), r.inputState.setSelectionOrigin("select.pointer");
};
cc.touchmove = (r) => {
  r.inputState.setSelectionOrigin("select.pointer");
};
lc.mousedown = (r, e) => {
  if (r.observer.flush(), r.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let t = null;
  for (let n of r.state.facet(kVe))
    if (t = n(r, e), t)
      break;
  if (!t && e.button == 0 && (t = jPt(r, e)), t) {
    let n = !r.hasFocus;
    r.inputState.startMouseSelection(new RPt(r, e, t, n)), n && r.observer.ignore(() => dVe(r.contentDOM));
    let i = r.inputState.mouseSelection;
    if (i)
      return i.start(e), i.dragging === !1;
  }
  return !1;
};
function aEe(r, e, t, n) {
  if (n == 1)
    return Be.cursor(e, t);
  if (n == 2)
    return CPt(r.state, e, t);
  {
    let i = Vr.find(r.docView, e), s = r.state.doc.lineAt(i ? i.posAtEnd : e), o = i ? i.posAtStart : s.from, a = i ? i.posAtEnd : s.to;
    return a < r.state.doc.length && a == s.to && a++, Be.range(o, a);
  }
}
let GVe = (r, e) => r >= e.top && r <= e.bottom, lEe = (r, e, t) => GVe(e, t) && r >= t.left && r <= t.right;
function zPt(r, e, t, n) {
  let i = Vr.find(r.docView, e);
  if (!i)
    return 1;
  let s = e - i.posAtStart;
  if (s == 0)
    return 1;
  if (s == i.length)
    return -1;
  let o = i.coordsAt(s, -1);
  if (o && lEe(t, n, o))
    return -1;
  let a = i.coordsAt(s, 1);
  return a && lEe(t, n, a) ? 1 : o && GVe(n, o) ? -1 : 1;
}
function cEe(r, e) {
  let t = r.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: t, bias: zPt(r, t, e.clientX, e.clientY) };
}
const WPt = ft.ie && ft.ie_version <= 11;
let hEe = null, dEe = 0, uEe = 0;
function QVe(r) {
  if (!WPt)
    return r.detail;
  let e = hEe, t = uEe;
  return hEe = r, uEe = Date.now(), dEe = !e || t > Date.now() - 400 && Math.abs(e.clientX - r.clientX) < 2 && Math.abs(e.clientY - r.clientY) < 2 ? (dEe + 1) % 3 : 1;
}
function jPt(r, e) {
  let t = cEe(r, e), n = QVe(e), i = r.state.selection;
  return {
    update(s) {
      s.docChanged && (t.pos = s.changes.mapPos(t.pos), i = i.map(s.changes));
    },
    get(s, o, a) {
      let l = cEe(r, s), c, d = aEe(r, l.pos, l.bias, n);
      if (t.pos != l.pos && !o) {
        let u = aEe(r, t.pos, t.bias, n), f = Math.min(u.from, d.from), p = Math.max(u.to, d.to);
        d = f < d.from ? Be.range(f, p) : Be.range(p, f);
      }
      return o ? i.replaceRange(i.main.extend(d.from, d.to)) : a && n == 1 && i.ranges.length > 1 && (c = ZPt(i, l.pos)) ? c : a ? i.addRange(d) : Be.create([d]);
    }
  };
}
function ZPt(r, e) {
  for (let t = 0; t < r.ranges.length; t++) {
    let { from: n, to: i } = r.ranges[t];
    if (n <= e && i >= e)
      return Be.create(r.ranges.slice(0, t).concat(r.ranges.slice(t + 1)), r.mainIndex == t ? 0 : r.mainIndex - (r.mainIndex > t ? 1 : 0));
  }
  return null;
}
lc.dragstart = (r, e) => {
  let { selection: { main: t } } = r.state;
  if (e.target.draggable) {
    let i = r.docView.nearest(e.target);
    if (i && i.isWidget) {
      let s = i.posAtStart, o = s + i.length;
      (s >= t.to || o <= t.from) && (t = Be.range(s, o));
    }
  }
  let { inputState: n } = r;
  return n.mouseSelection && (n.mouseSelection.dragging = !0), n.draggedContent = t, e.dataTransfer && (e.dataTransfer.setData("Text", r.state.sliceDoc(t.from, t.to)), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
lc.dragend = (r) => (r.inputState.draggedContent = null, !1);
function fEe(r, e, t, n) {
  if (!t)
    return;
  let i = r.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: s } = r.inputState, o = n && s && HPt(r, e) ? { from: s.from, to: s.to } : null, a = { from: i, insert: t }, l = r.state.changes(o ? [o, a] : a);
  r.focus(), r.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(i, -1), head: l.mapPos(i, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  }), r.inputState.draggedContent = null;
}
lc.drop = (r, e) => {
  if (!e.dataTransfer)
    return !1;
  if (r.state.readOnly)
    return !0;
  let t = e.dataTransfer.files;
  if (t && t.length) {
    let n = Array(t.length), i = 0, s = () => {
      ++i == t.length && fEe(r, e, n.filter((o) => o != null).join(r.state.lineBreak), !1);
    };
    for (let o = 0; o < t.length; o++) {
      let a = new FileReader();
      a.onerror = s, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (n[o] = a.result), s();
      }, a.readAsText(t[o]);
    }
    return !0;
  } else {
    let n = e.dataTransfer.getData("Text");
    if (n)
      return fEe(r, e, n, !0), !0;
  }
  return !1;
};
lc.paste = (r, e) => {
  if (r.state.readOnly)
    return !0;
  r.observer.flush();
  let t = UVe ? null : e.clipboardData;
  return t ? (qVe(r, t.getData("text/plain") || t.getData("text/uri-text")), !0) : (FPt(r), !1);
};
function UPt(r, e) {
  let t = r.dom.parentNode;
  if (!t)
    return;
  let n = t.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.value = e, n.focus(), n.selectionEnd = e.length, n.selectionStart = 0, setTimeout(() => {
    n.remove(), r.focus();
  }, 50);
}
function qPt(r) {
  let e = [], t = [], n = !1;
  for (let i of r.selection.ranges)
    i.empty || (e.push(r.sliceDoc(i.from, i.to)), t.push(i));
  if (!e.length) {
    let i = -1;
    for (let { from: s } of r.selection.ranges) {
      let o = r.doc.lineAt(s);
      o.number > i && (e.push(o.text), t.push({ from: o.from, to: Math.min(r.doc.length, o.to + 1) })), i = o.number;
    }
    n = !0;
  }
  return { text: e.join(r.lineBreak), ranges: t, linewise: n };
}
let dT = null;
lc.copy = lc.cut = (r, e) => {
  let { text: t, ranges: n, linewise: i } = qPt(r.state);
  if (!t && !i)
    return !1;
  dT = i ? t : null, e.type == "cut" && !r.state.readOnly && r.dispatch({
    changes: n,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let s = UVe ? null : e.clipboardData;
  return s ? (s.clearData(), s.setData("text/plain", t), !0) : (UPt(r, t), !1);
};
const KVe = /* @__PURE__ */ u2.define();
function YVe(r, e) {
  let t = [];
  for (let n of r.facet(IVe)) {
    let i = n(r, e);
    i && t.push(i);
  }
  return t ? r.update({ effects: t, annotations: KVe.of(!0) }) : null;
}
function XVe(r) {
  setTimeout(() => {
    let e = r.hasFocus;
    if (e != r.inputState.notifiedFocused) {
      let t = YVe(r.state, e);
      t ? r.dispatch(t) : r.update([]);
    }
  }, 10);
}
cc.focus = (r) => {
  r.inputState.lastFocusTime = Date.now(), !r.scrollDOM.scrollTop && (r.inputState.lastScrollTop || r.inputState.lastScrollLeft) && (r.scrollDOM.scrollTop = r.inputState.lastScrollTop, r.scrollDOM.scrollLeft = r.inputState.lastScrollLeft), XVe(r);
};
cc.blur = (r) => {
  r.observer.clearSelectionRange(), XVe(r);
};
cc.compositionstart = cc.compositionupdate = (r) => {
  r.inputState.compositionFirstChange == null && (r.inputState.compositionFirstChange = !0), r.inputState.composing < 0 && (r.inputState.composing = 0);
};
cc.compositionend = (r) => {
  r.inputState.composing = -1, r.inputState.compositionEndedAt = Date.now(), r.inputState.compositionPendingKey = !0, r.inputState.compositionPendingChange = r.observer.pendingRecords().length > 0, r.inputState.compositionFirstChange = null, ft.chrome && ft.android ? r.observer.flushSoon() : r.inputState.compositionPendingChange ? Promise.resolve().then(() => r.observer.flush()) : setTimeout(() => {
    r.inputState.composing < 0 && r.docView.hasComposition && r.update([]);
  }, 50);
};
cc.contextmenu = (r) => {
  r.inputState.lastContextMenu = Date.now();
};
lc.beforeinput = (r, e) => {
  var t;
  let n;
  if (ft.chrome && ft.android && (n = jVe.find((i) => i.inputType == e.inputType)) && (r.observer.delayAndroidKey(n.key, n.keyCode), n.key == "Backspace" || n.key == "Delete")) {
    let i = ((t = window.visualViewport) === null || t === void 0 ? void 0 : t.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > i + 10 && r.hasFocus && (r.contentDOM.blur(), r.focus());
    }, 100);
  }
  return !1;
};
const pEe = /* @__PURE__ */ new Set();
function GPt(r) {
  pEe.has(r) || (pEe.add(r), r.addEventListener("copy", () => {
  }), r.addEventListener("cut", () => {
  }));
}
const gEe = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class QPt {
  constructor(e) {
    this.lineWrapping = e, this.doc = li.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
  }
  heightForGap(e, t) {
    let n = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (n += Math.max(0, Math.ceil((t - e - n * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * n;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return gEe.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let t = !1;
    for (let n = 0; n < e.length; n++) {
      let i = e[n];
      i < 0 ? n++ : this.heightSamples[Math.floor(i * 10)] || (t = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return t;
  }
  refresh(e, t, n, i, s, o) {
    let a = gEe.indexOf(e) > -1, l = Math.round(t) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = t, this.charWidth = n, this.textHeight = i, this.lineLength = s, l) {
      this.heightSamples = {};
      for (let c = 0; c < o.length; c++) {
        let d = o[c];
        d < 0 ? c++ : this.heightSamples[Math.floor(d * 10)] = !0;
      }
    }
    return l;
  }
}
class KPt {
  constructor(e, t) {
    this.from = e, this.heights = t, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class Yc {
  /**
  @internal
  */
  constructor(e, t, n, i, s) {
    this.from = e, this.length = t, this.top = n, this.height = i, this._content = s;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? Jl.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof _1 ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let t = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new Yc(this.from, this.length + e.length, this.top, this.height + e.height, t);
  }
}
var ki = /* @__PURE__ */ function(r) {
  return r[r.ByPos = 0] = "ByPos", r[r.ByHeight = 1] = "ByHeight", r[r.ByPosNoHeight = 2] = "ByPosNoHeight", r;
}(ki || (ki = {}));
const r8 = 1e-3;
class oo {
  constructor(e, t, n = 2) {
    this.length = e, this.height = t, this.flags = n;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e, t) {
    this.height != t && (Math.abs(this.height - t) > r8 && (e.heightChanged = !0), this.height = t);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, t, n) {
    return oo.of(n);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, t) {
    t.push(this);
  }
  decomposeRight(e, t) {
    t.push(this);
  }
  applyChanges(e, t, n, i) {
    let s = this, o = n.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: l, toA: c, fromB: d, toB: u } = i[a], f = s.lineAt(l, ki.ByPosNoHeight, n.setDoc(t), 0, 0), p = f.to >= c ? f : s.lineAt(c, ki.ByPosNoHeight, n, 0, 0);
      for (u += p.to - c, c = p.to; a > 0 && f.from <= i[a - 1].toA; )
        l = i[a - 1].fromA, d = i[a - 1].fromB, a--, l < f.from && (f = s.lineAt(l, ki.ByPosNoHeight, n, 0, 0));
      d += f.from - l, l = f.from;
      let g = YV.build(n.setDoc(o), e, d, u);
      s = s.replace(l, c, g);
    }
    return s.updateHeight(n, 0);
  }
  static empty() {
    return new ea(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let t = 0, n = e.length, i = 0, s = 0;
    for (; ; )
      if (t == n)
        if (i > s * 2) {
          let a = e[t - 1];
          a.break ? e.splice(--t, 1, a.left, null, a.right) : e.splice(--t, 1, a.left, a.right), n += 1 + a.break, i -= a.size;
        } else if (s > i * 2) {
          let a = e[n];
          a.break ? e.splice(n, 1, a.left, null, a.right) : e.splice(n, 1, a.left, a.right), n += 2 + a.break, s -= a.size;
        } else
          break;
      else if (i < s) {
        let a = e[t++];
        a && (i += a.size);
      } else {
        let a = e[--n];
        a && (s += a.size);
      }
    let o = 0;
    return e[t - 1] == null ? (o = 1, t--) : e[t] == null && (o = 1, n++), new YPt(oo.of(e.slice(0, t)), o, oo.of(e.slice(n)));
  }
}
oo.prototype.size = 1;
class JVe extends oo {
  constructor(e, t, n) {
    super(e, t), this.deco = n;
  }
  blockAt(e, t, n, i) {
    return new Yc(i, this.length, n, this.height, this.deco || 0);
  }
  lineAt(e, t, n, i, s) {
    return this.blockAt(0, n, i, s);
  }
  forEachLine(e, t, n, i, s, o) {
    e <= s + this.length && t >= s && o(this.blockAt(0, n, i, s));
  }
  updateHeight(e, t = 0, n = !1, i) {
    return i && i.from <= t && i.more && this.setHeight(e, i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class ea extends JVe {
  constructor(e, t) {
    super(e, t, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, t, n, i) {
    return new Yc(i, this.length, n, this.height, this.breaks);
  }
  replace(e, t, n) {
    let i = n[0];
    return n.length == 1 && (i instanceof ea || i instanceof cs && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof cs ? i = new ea(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : oo.of(n);
  }
  updateHeight(e, t = 0, n = !1, i) {
    return i && i.from <= t && i.more ? this.setHeight(e, i.heights[i.index++]) : (n || this.outdated) && this.setHeight(e, Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class cs extends oo {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, t) {
    let n = e.doc.lineAt(t).number, i = e.doc.lineAt(t + this.length).number, s = i - n + 1, o, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * s);
      o = l / s, this.length > s + 1 && (a = (this.height - l) / (this.length - s - 1));
    } else
      o = this.height / s;
    return { firstLine: n, lastLine: i, perLine: o, perChar: a };
  }
  blockAt(e, t, n, i) {
    let { firstLine: s, lastLine: o, perLine: a, perChar: l } = this.heightMetrics(t, i);
    if (t.lineWrapping) {
      let c = i + Math.round(Math.max(0, Math.min(1, (e - n) / this.height)) * this.length), d = t.doc.lineAt(c), u = a + d.length * l, f = Math.max(n, e - u / 2);
      return new Yc(d.from, d.length, f, u, 0);
    } else {
      let c = Math.max(0, Math.min(o - s, Math.floor((e - n) / a))), { from: d, length: u } = t.doc.line(s + c);
      return new Yc(d, u, n + a * c, a, 0);
    }
  }
  lineAt(e, t, n, i, s) {
    if (t == ki.ByHeight)
      return this.blockAt(e, n, i, s);
    if (t == ki.ByPosNoHeight) {
      let { from: p, to: g } = n.doc.lineAt(e);
      return new Yc(p, g - p, 0, 0, 0);
    }
    let { firstLine: o, perLine: a, perChar: l } = this.heightMetrics(n, s), c = n.doc.lineAt(e), d = a + c.length * l, u = c.number - o, f = i + a * u + l * (c.from - s - u);
    return new Yc(c.from, c.length, Math.max(i, Math.min(f, i + this.height - d)), d, 0);
  }
  forEachLine(e, t, n, i, s, o) {
    e = Math.max(e, s), t = Math.min(t, s + this.length);
    let { firstLine: a, perLine: l, perChar: c } = this.heightMetrics(n, s);
    for (let d = e, u = i; d <= t; ) {
      let f = n.doc.lineAt(d);
      if (d == e) {
        let g = f.number - a;
        u += l * g + c * (e - s - g);
      }
      let p = l + c * f.length;
      o(new Yc(f.from, f.length, u, p, 0)), u += p, d = f.to + 1;
    }
  }
  replace(e, t, n) {
    let i = this.length - t;
    if (i > 0) {
      let s = n[n.length - 1];
      s instanceof cs ? n[n.length - 1] = new cs(s.length + i) : n.push(null, new cs(i - 1));
    }
    if (e > 0) {
      let s = n[0];
      s instanceof cs ? n[0] = new cs(e + s.length) : n.unshift(new cs(e - 1), null);
    }
    return oo.of(n);
  }
  decomposeLeft(e, t) {
    t.push(new cs(e - 1), null);
  }
  decomposeRight(e, t) {
    t.push(null, new cs(this.length - e - 1));
  }
  updateHeight(e, t = 0, n = !1, i) {
    let s = t + this.length;
    if (i && i.from <= t + this.length && i.more) {
      let o = [], a = Math.max(t, i.from), l = -1;
      for (i.from > t && o.push(new cs(i.from - t - 1).updateHeight(e, t)); a <= s && i.more; ) {
        let d = e.doc.lineAt(a).length;
        o.length && o.push(null);
        let u = i.heights[i.index++];
        l == -1 ? l = u : Math.abs(u - l) >= r8 && (l = -2);
        let f = new ea(d, u);
        f.outdated = !1, o.push(f), a += d + 1;
      }
      a <= s && o.push(null, new cs(s - a).updateHeight(e, a));
      let c = oo.of(o);
      return (l < 0 || Math.abs(c.height - this.height) >= r8 || Math.abs(l - this.heightMetrics(e, t).perLine) >= r8) && (e.heightChanged = !0), c;
    } else (n || this.outdated) && (this.setHeight(e, e.heightForGap(t, t + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class YPt extends oo {
  constructor(e, t, n) {
    super(e.length + t + n.length, e.height + n.height, t | (e.outdated || n.outdated ? 2 : 0)), this.left = e, this.right = n, this.size = e.size + n.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, t, n, i) {
    let s = n + this.left.height;
    return e < s ? this.left.blockAt(e, t, n, i) : this.right.blockAt(e, t, s, i + this.left.length + this.break);
  }
  lineAt(e, t, n, i, s) {
    let o = i + this.left.height, a = s + this.left.length + this.break, l = t == ki.ByHeight ? e < o : e < a, c = l ? this.left.lineAt(e, t, n, i, s) : this.right.lineAt(e, t, n, o, a);
    if (this.break || (l ? c.to < a : c.from > a))
      return c;
    let d = t == ki.ByPosNoHeight ? ki.ByPosNoHeight : ki.ByPos;
    return l ? c.join(this.right.lineAt(a, d, n, o, a)) : this.left.lineAt(a, d, n, i, s).join(c);
  }
  forEachLine(e, t, n, i, s, o) {
    let a = i + this.left.height, l = s + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, t, n, i, s, o), t >= l && this.right.forEachLine(e, t, n, a, l, o);
    else {
      let c = this.lineAt(l, ki.ByPos, n, i, s);
      e < c.from && this.left.forEachLine(e, c.from - 1, n, i, s, o), c.to >= e && c.from <= t && o(c), t > c.to && this.right.forEachLine(c.to + 1, t, n, a, l, o);
    }
  }
  replace(e, t, n) {
    let i = this.left.length + this.break;
    if (t < i)
      return this.balanced(this.left.replace(e, t, n), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - i, t - i, n));
    let s = [];
    e > 0 && this.decomposeLeft(e, s);
    let o = s.length;
    for (let a of n)
      s.push(a);
    if (e > 0 && mEe(s, o - 1), t < this.length) {
      let a = s.length;
      this.decomposeRight(t, s), mEe(s, a);
    }
    return oo.of(s);
  }
  decomposeLeft(e, t) {
    let n = this.left.length;
    if (e <= n)
      return this.left.decomposeLeft(e, t);
    t.push(this.left), this.break && (n++, e >= n && t.push(null)), e > n && this.right.decomposeLeft(e - n, t);
  }
  decomposeRight(e, t) {
    let n = this.left.length, i = n + this.break;
    if (e >= i)
      return this.right.decomposeRight(e - i, t);
    e < n && this.left.decomposeRight(e, t), this.break && e < i && t.push(null), t.push(this.right);
  }
  balanced(e, t) {
    return e.size > 2 * t.size || t.size > 2 * e.size ? oo.of(this.break ? [e, null, t] : [e, t]) : (this.left = e, this.right = t, this.height = e.height + t.height, this.outdated = e.outdated || t.outdated, this.size = e.size + t.size, this.length = e.length + this.break + t.length, this);
  }
  updateHeight(e, t = 0, n = !1, i) {
    let { left: s, right: o } = this, a = t + s.length + this.break, l = null;
    return i && i.from <= t + s.length && i.more ? l = s = s.updateHeight(e, t, n, i) : s.updateHeight(e, t, n), i && i.from <= a + o.length && i.more ? l = o = o.updateHeight(e, a, n, i) : o.updateHeight(e, a, n), l ? this.balanced(s, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function mEe(r, e) {
  let t, n;
  r[e] == null && (t = r[e - 1]) instanceof cs && (n = r[e + 1]) instanceof cs && r.splice(e - 1, 3, new cs(t.length + 1 + n.length));
}
const XPt = 5;
class YV {
  constructor(e, t) {
    this.pos = e, this.oracle = t, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, t) {
    if (this.lineStart > -1) {
      let n = Math.min(t, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof ea ? i.length += n - this.pos : (n > this.pos || !this.isCovered) && this.nodes.push(new ea(n - this.pos, -1)), this.writtenTo = n, t > n && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = t;
  }
  point(e, t, n) {
    if (e < t || n.heightRelevant) {
      let i = n.widget ? n.widget.estimatedHeight : 0, s = n.widget ? n.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let o = t - e;
      n.block ? this.addBlock(new JVe(o, i, n)) : (o || s || i >= XPt) && this.addLineDeco(i, s, o);
    } else t > e && this.span(e, t);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: t } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = t, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new ea(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, t) {
    let n = new cs(t - e);
    return this.oracle.doc.lineAt(e).to == t && (n.flags |= 4), n;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof ea)
      return e;
    let t = new ea(0, -1);
    return this.nodes.push(t), t;
  }
  addBlock(e) {
    this.enterLine();
    let t = e.deco;
    t && t.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, t && t.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, t, n) {
    let i = this.ensureLine();
    i.length += n, i.collapsed += n, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += t, this.writtenTo = this.pos = this.pos + n;
  }
  finish(e) {
    let t = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(t instanceof ea) && !this.isCovered ? this.nodes.push(new ea(0, -1)) : (this.writtenTo < this.pos || t == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let n = e;
    for (let i of this.nodes)
      i instanceof ea && i.updateHeight(this.oracle, n), n += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, t, n, i) {
    let s = new YV(n, e);
    return oi.spans(t, n, i, s, 0), s.finish(n);
  }
}
function JPt(r, e, t) {
  let n = new $Pt();
  return oi.compare(r, e, t, n, 0), n.changes;
}
class $Pt {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, t, n, i) {
    (e < t || n && n.heightRelevant || i && i.heightRelevant) && sT(e, t, this.changes, 5);
  }
}
function eFt(r, e) {
  let t = r.getBoundingClientRect(), n = r.ownerDocument, i = n.defaultView || window, s = Math.max(0, t.left), o = Math.min(i.innerWidth, t.right), a = Math.max(0, t.top), l = Math.min(i.innerHeight, t.bottom);
  for (let c = r.parentNode; c && c != n.body; )
    if (c.nodeType == 1) {
      let d = c, u = window.getComputedStyle(d);
      if ((d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth) && u.overflow != "visible") {
        let f = d.getBoundingClientRect();
        s = Math.max(s, f.left), o = Math.min(o, f.right), a = Math.max(a, f.top), l = c == r.parentNode ? f.bottom : Math.min(l, f.bottom);
      }
      c = u.position == "absolute" || u.position == "fixed" ? d.offsetParent : d.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: s - t.left,
    right: Math.max(s, o) - t.left,
    top: a - (t.top + e),
    bottom: Math.max(a, l) - (t.top + e)
  };
}
function tFt(r, e) {
  let t = r.getBoundingClientRect();
  return {
    left: 0,
    right: t.right - t.left,
    top: e,
    bottom: t.bottom - (t.top + e)
  };
}
class xS {
  constructor(e, t, n) {
    this.from = e, this.to = t, this.size = n;
  }
  static same(e, t) {
    if (e.length != t.length)
      return !1;
    for (let n = 0; n < e.length; n++) {
      let i = e[n], s = t[n];
      if (i.from != s.from || i.to != s.to || i.size != s.size)
        return !1;
    }
    return !0;
  }
  draw(e, t) {
    return pi.replace({
      widget: new nFt(this.size * (t ? e.scaleY : e.scaleX), t)
    }).range(this.from, this.to);
  }
}
class nFt extends Xw {
  constructor(e, t) {
    super(), this.size = e, this.vertical = t;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class AEe {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !0, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = wEe, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = nr.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let t = e.facet(QV).some((n) => typeof n != "function" && n.class == "cm-lineWrapping");
    this.heightOracle = new QPt(t), this.stateDeco = e.facet(V4).filter((n) => typeof n != "function"), this.heightMap = oo.empty().applyChanges(this.stateDeco, li.empty, this.heightOracle.setDoc(e.doc), [new cl(0, 0, 0, e.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = pi.set(this.lineGaps.map((n) => n.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: t } = this.state.selection;
    for (let n = 0; n <= 1; n++) {
      let i = n ? t.head : t.anchor;
      if (!e.some(({ from: s, to: o }) => i >= s && i <= o)) {
        let { from: s, to: o } = this.lineBlockAt(i);
        e.push(new z5(s, o));
      }
    }
    this.viewports = e.sort((n, i) => n.from - i.from), this.scaler = this.heightMap.height <= 7e6 ? wEe : new sFt(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(this.scaler.scale == 1 ? e : NA(e, this.scaler));
    });
  }
  update(e, t = null) {
    this.state = e.state;
    let n = this.stateDeco;
    this.stateDeco = this.state.facet(V4).filter((d) => typeof d != "function");
    let i = e.changedRanges, s = cl.extendWithRanges(i, JPt(n, this.stateDeco, e ? e.changes : es.empty(this.state.doc.length))), o = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), s), this.heightMap.height != o && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let l = s.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (t && (t.range.head < l.from || t.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, t));
    let c = !e.changes.empty || e.flags & 2 || l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, this.updateForViewport(), c && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(), t && (this.scrollTarget = t), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(fPt) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let t = e.contentDOM, n = window.getComputedStyle(t), i = this.heightOracle, s = n.whiteSpace;
    this.defaultTextDirection = n.direction == "rtl" ? nr.RTL : nr.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(s), a = t.getBoundingClientRect(), l = o || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, d = 0;
    if (a.width && a.height) {
      let { scaleX: _, scaleY: S } = hVe(t, a);
      (this.scaleX != _ || this.scaleY != S) && (this.scaleX = _, this.scaleY = S, c |= 8, o = l = !0);
    }
    let u = (parseInt(n.paddingTop) || 0) * this.scaleY, f = (parseInt(n.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != u || this.paddingBottom != f) && (this.paddingTop = u, this.paddingBottom = f, c |= 10), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 8);
    let p = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != p && (this.scrollAnchorHeight = -1, this.scrollTop = p), this.scrolledToBottom = fVe(e.scrollDOM);
    let g = (this.printing ? tFt : eFt)(t, this.paddingTop), m = g.top - this.pixelViewport.top, A = g.bottom - this.pixelViewport.bottom;
    this.pixelViewport = g;
    let w = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (w != this.inView && (this.inView = w, w && (l = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let v = a.width;
    if ((this.contentDOMWidth != v || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 8), l) {
      let _ = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(_) && (o = !0), o || i.lineWrapping && Math.abs(v - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: S, charWidth: D, textHeight: M } = e.docView.measureTextSize();
        o = S > 0 && i.refresh(s, S, D, M, v / D, _), o && (e.docView.minWidth = 0, c |= 8);
      }
      m > 0 && A > 0 ? d = Math.max(m, A) : m < 0 && A < 0 && (d = Math.min(m, A)), i.heightChanged = !1;
      for (let S of this.viewports) {
        let D = S.from == this.viewport.from ? _ : e.docView.measureVisibleLineHeights(S);
        this.heightMap = (o ? oo.empty().applyChanges(this.stateDeco, li.empty, this.heightOracle, [new cl(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, o, new KPt(S.from, D));
      }
      i.heightChanged && (c |= 2);
    }
    let y = !this.viewportIsAppropriate(this.viewport, d) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return y && (this.viewport = this.getViewport(d, this.scrollTarget)), this.updateForViewport(), (c & 2 || y) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, t) {
    let n = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, s = this.heightOracle, { visibleTop: o, visibleBottom: a } = this, l = new z5(i.lineAt(o - n * 1e3, ki.ByHeight, s, 0, 0).from, i.lineAt(a + (1 - n) * 1e3, ki.ByHeight, s, 0, 0).to);
    if (t) {
      let { head: c } = t.range;
      if (c < l.from || c > l.to) {
        let d = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), u = i.lineAt(c, ki.ByPos, s, 0, 0), f;
        t.y == "center" ? f = (u.top + u.bottom) / 2 - d / 2 : t.y == "start" || t.y == "nearest" && c < l.from ? f = u.top : f = u.bottom - d, l = new z5(i.lineAt(f - 1e3 / 2, ki.ByHeight, s, 0, 0).from, i.lineAt(f + d + 1e3 / 2, ki.ByHeight, s, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, t) {
    let n = t.mapPos(e.from, -1), i = t.mapPos(e.to, 1);
    return new z5(this.heightMap.lineAt(n, ki.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, ki.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: t }, n = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(e, ki.ByPos, this.heightOracle, 0, 0), { bottom: s } = this.heightMap.lineAt(t, ki.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: a } = this;
    return (e == 0 || i <= o - Math.max(10, Math.min(
      -n,
      250
      /* VP.MaxCoverMargin */
    ))) && (t == this.state.doc.length || s >= a + Math.max(10, Math.min(
      n,
      250
      /* VP.MaxCoverMargin */
    ))) && i > o - 2 * 1e3 && s < a + 2 * 1e3;
  }
  mapLineGaps(e, t) {
    if (!e.length || t.empty)
      return e;
    let n = [];
    for (let i of e)
      t.touchesRange(i.from, i.to) || n.push(new xS(t.mapPos(i.from), t.mapPos(i.to), i.size));
    return n;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, t) {
    let n = this.heightOracle.lineWrapping, i = n ? 1e4 : 2e3, s = i >> 1, o = i << 1;
    if (this.defaultTextDirection != nr.LTR && !n)
      return [];
    let a = [], l = (c, d, u, f) => {
      if (d - c < s)
        return;
      let p = this.state.selection.main, g = [p.from];
      p.empty || g.push(p.to);
      for (let A of g)
        if (A > c && A < d) {
          l(c, A - 10, u, f), l(A + 10, d, u, f);
          return;
        }
      let m = rFt(e, (A) => A.from >= u.from && A.to <= u.to && Math.abs(A.from - c) < s && Math.abs(A.to - d) < s && !g.some((w) => A.from < w && A.to > w));
      if (!m) {
        if (d < u.to && t && n && t.visibleRanges.some((A) => A.from <= d && A.to >= d)) {
          let A = t.moveToLineBoundary(Be.cursor(d), !1, !0).head;
          A > c && (d = A);
        }
        m = new xS(c, d, this.gapSize(u, c, d, f));
      }
      a.push(m);
    };
    for (let c of this.viewportLines) {
      if (c.length < o)
        continue;
      let d = iFt(c.from, c.to, this.stateDeco);
      if (d.total < o)
        continue;
      let u = this.scrollTarget ? this.scrollTarget.range.head : null, f, p;
      if (n) {
        let g = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, m, A;
        if (u != null) {
          let w = j5(d, u), v = ((this.visibleBottom - this.visibleTop) / 2 + g) / c.height;
          m = w - v, A = w + v;
        } else
          m = (this.visibleTop - c.top - g) / c.height, A = (this.visibleBottom - c.top + g) / c.height;
        f = W5(d, m), p = W5(d, A);
      } else {
        let g = d.total * this.heightOracle.charWidth, m = i * this.heightOracle.charWidth, A, w;
        if (u != null) {
          let v = j5(d, u), y = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + m) / g;
          A = v - y, w = v + y;
        } else
          A = (this.pixelViewport.left - m) / g, w = (this.pixelViewport.right + m) / g;
        f = W5(d, A), p = W5(d, w);
      }
      f > c.from && l(c.from, f, c, d), p < c.to && l(p, c.to, c, d);
    }
    return a;
  }
  gapSize(e, t, n, i) {
    let s = j5(i, n) - j5(i, t);
    return this.heightOracle.lineWrapping ? e.height * s : i.total * this.heightOracle.charWidth * s;
  }
  updateLineGaps(e) {
    xS.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = pi.set(e.map((t) => t.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges() {
    let e = this.stateDeco;
    this.lineGaps.length && (e = e.concat(this.lineGapDeco));
    let t = [];
    oi.spans(e, this.viewport.from, this.viewport.to, {
      span(i, s) {
        t.push({ from: i, to: s });
      },
      point() {
      }
    }, 20);
    let n = t.length != this.visibleRanges.length || this.visibleRanges.some((i, s) => i.from != t[s].from || i.to != t[s].to);
    return this.visibleRanges = t, n ? 4 : 0;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((t) => t.from <= e && t.to >= e) || NA(this.heightMap.lineAt(e, ki.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return NA(this.heightMap.lineAt(this.scaler.fromDOM(e), ki.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let t = this.lineBlockAtHeight(e + 8);
    return t.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? t : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return NA(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class z5 {
  constructor(e, t) {
    this.from = e, this.to = t;
  }
}
function iFt(r, e, t) {
  let n = [], i = r, s = 0;
  return oi.spans(t, r, e, {
    span() {
    },
    point(o, a) {
      o > i && (n.push({ from: i, to: o }), s += o - i), i = a;
    }
  }, 20), i < e && (n.push({ from: i, to: e }), s += e - i), { total: s, ranges: n };
}
function W5({ total: r, ranges: e }, t) {
  if (t <= 0)
    return e[0].from;
  if (t >= 1)
    return e[e.length - 1].to;
  let n = Math.floor(r * t);
  for (let i = 0; ; i++) {
    let { from: s, to: o } = e[i], a = o - s;
    if (n <= a)
      return s + n;
    n -= a;
  }
}
function j5(r, e) {
  let t = 0;
  for (let { from: n, to: i } of r.ranges) {
    if (e <= i) {
      t += e - n;
      break;
    }
    t += i - n;
  }
  return t / r.total;
}
function rFt(r, e) {
  for (let t of r)
    if (e(t))
      return t;
}
const wEe = {
  toDOM(r) {
    return r;
  },
  fromDOM(r) {
    return r;
  },
  scale: 1
};
class sFt {
  constructor(e, t, n) {
    let i = 0, s = 0, o = 0;
    this.viewports = n.map(({ from: a, to: l }) => {
      let c = t.lineAt(a, ki.ByPos, e, 0, 0).top, d = t.lineAt(l, ki.ByPos, e, 0, 0).bottom;
      return i += d - c, { from: a, to: l, top: c, bottom: d, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (t.height - i);
    for (let a of this.viewports)
      a.domTop = o + (a.top - s) * this.scale, o = a.domBottom = a.domTop + (a.bottom - a.top), s = a.bottom;
  }
  toDOM(e) {
    for (let t = 0, n = 0, i = 0; ; t++) {
      let s = t < this.viewports.length ? this.viewports[t] : null;
      if (!s || e < s.top)
        return i + (e - n) * this.scale;
      if (e <= s.bottom)
        return s.domTop + (e - s.top);
      n = s.bottom, i = s.domBottom;
    }
  }
  fromDOM(e) {
    for (let t = 0, n = 0, i = 0; ; t++) {
      let s = t < this.viewports.length ? this.viewports[t] : null;
      if (!s || e < s.domTop)
        return n + (e - i) / this.scale;
      if (e <= s.domBottom)
        return s.top + (e - s.domTop);
      n = s.bottom, i = s.domBottom;
    }
  }
}
function NA(r, e) {
  if (e.scale == 1)
    return r;
  let t = e.toDOM(r.top), n = e.toDOM(r.bottom);
  return new Yc(r.from, r.length, t, n - t, Array.isArray(r._content) ? r._content.map((i) => NA(i, e)) : r._content);
}
const Z5 = /* @__PURE__ */ bt.define({ combine: (r) => r.join(" ") }), uT = /* @__PURE__ */ bt.define({ combine: (r) => r.indexOf(!0) > -1 }), fT = /* @__PURE__ */ C1.newName(), $Ve = /* @__PURE__ */ C1.newName(), eHe = /* @__PURE__ */ C1.newName(), tHe = { "&light": "." + $Ve, "&dark": "." + eHe };
function pT(r, e, t) {
  return new C1(e, {
    finish(n) {
      return /&/.test(n) ? n.replace(/&\w*/, (i) => {
        if (i == "&")
          return r;
        if (!t || !t[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return t[i];
      }) : r + " " + n;
    }
  });
}
const oFt = /* @__PURE__ */ pT("." + fT, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, tHe), TA = "￿";
class aFt {
  constructor(e, t) {
    this.points = e, this.text = "", this.lineSeparator = t.facet(jn.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += TA;
  }
  readRange(e, t) {
    if (!e)
      return this;
    let n = e.parentNode;
    for (let i = e; ; ) {
      this.findPointBefore(n, i);
      let s = this.text.length;
      this.readNode(i);
      let o = i.nextSibling;
      if (o == t)
        break;
      let a = Ni.get(i), l = Ni.get(o);
      (a && l ? a.breakAfter : (a ? a.breakAfter : vEe(i)) || vEe(o) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > s) && this.lineBreak(), i = o;
    }
    return this.findPointBefore(n, t), this;
  }
  readTextNode(e) {
    let t = e.nodeValue;
    for (let n of this.points)
      n.node == e && (n.pos = this.text.length + Math.min(n.offset, t.length));
    for (let n = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let s = -1, o = 1, a;
      if (this.lineSeparator ? (s = t.indexOf(this.lineSeparator, n), o = this.lineSeparator.length) : (a = i.exec(t)) && (s = a.index, o = a[0].length), this.append(t.slice(n, s < 0 ? t.length : s)), s < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= o - 1);
      n = s + o;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let t = Ni.get(e), n = t && t.overrideDOMText;
    if (n != null) {
      this.findPointInside(e, n.length);
      for (let i = n.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, t) {
    for (let n of this.points)
      n.node == e && e.childNodes[n.offset] == t && (n.pos = this.text.length);
  }
  findPointInside(e, t) {
    for (let n of this.points)
      (e.nodeType == 3 ? n.node == e : e.contains(n.node)) && (n.pos = this.text.length + (lFt(e, n.node, n.offset) ? t : 0));
  }
}
function lFt(r, e, t) {
  for (; ; ) {
    if (!e || t < jd(e))
      return !1;
    if (e == r)
      return !0;
    t = R4(e) + 1, e = e.parentNode;
  }
}
function vEe(r) {
  return r.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(r.nodeName);
}
class bEe {
  constructor(e, t) {
    this.node = e, this.offset = t, this.pos = -1;
  }
}
class cFt {
  constructor(e, t, n, i) {
    this.typeOver = i, this.bounds = null, this.text = "";
    let { impreciseHead: s, impreciseAnchor: o } = e.docView;
    if (e.state.readOnly && t > -1)
      this.newSel = null;
    else if (t > -1 && (this.bounds = e.docView.domBoundsAround(t, n, 0))) {
      let a = s || o ? [] : uFt(e), l = new aFt(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = fFt(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = s && s.node == a.focusNode && s.offset == a.focusOffset || !$N(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), c = o && o.node == a.anchorNode && o.offset == a.anchorOffset || !$N(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset), d = e.viewport;
      if (ft.ios && e.state.selection.main.empty && l != c && (d.from > 0 || d.to < e.state.doc.length)) {
        let u = d.from - Math.min(l, c), f = d.to - Math.max(l, c);
        (u == 0 || u == 1) && (f == 0 || f == -1) && (l = 0, c = e.state.doc.length);
      }
      this.newSel = Be.single(c, l);
    }
  }
}
function nHe(r, e) {
  let t, { newSel: n } = e, i = r.state.selection.main, s = r.inputState.lastKeyTime > Date.now() - 100 ? r.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: o, to: a } = e.bounds, l = i.from, c = null;
    (s === 8 || ft.android && e.text.length < a - o) && (l = i.to, c = "end");
    let d = dFt(r.state.doc.sliceString(o, a, TA), e.text, l - o, c);
    d && (ft.chrome && s == 13 && d.toB == d.from + 2 && e.text.slice(d.from, d.toB) == TA + TA && d.toB--, t = {
      from: o + d.from,
      to: o + d.toA,
      insert: li.of(e.text.slice(d.from, d.toB).split(TA))
    });
  } else n && (!r.hasFocus && r.state.facet(lC) || n.main.eq(i)) && (n = null);
  if (!t && !n)
    return !1;
  if (!t && e.typeOver && !i.empty && n && n.main.empty ? t = { from: i.from, to: i.to, insert: r.state.doc.slice(i.from, i.to) } : t && t.from >= i.from && t.to <= i.to && (t.from != i.from || t.to != i.to) && i.to - i.from - (t.to - t.from) <= 4 ? t = {
    from: i.from,
    to: i.to,
    insert: r.state.doc.slice(i.from, t.from).append(t.insert).append(r.state.doc.slice(t.to, i.to))
  } : (ft.mac || ft.android) && t && t.from == t.to && t.from == i.head - 1 && /^\. ?$/.test(t.insert.toString()) && r.contentDOM.getAttribute("autocorrect") == "off" ? (n && t.insert.length == 2 && (n = Be.single(n.main.anchor - 1, n.main.head - 1)), t = { from: i.from, to: i.to, insert: li.of([" "]) }) : ft.chrome && t && t.from == t.to && t.from == i.head && t.insert.toString() == `
 ` && r.lineWrapping && (n && (n = Be.single(n.main.anchor - 1, n.main.head - 1)), t = { from: i.from, to: i.to, insert: li.of([" "]) }), t) {
    if (ft.ios && r.inputState.flushIOSKey() || ft.android && (t.from == i.from && t.to == i.to && t.insert.length == 1 && t.insert.lines == 2 && zp(r.contentDOM, "Enter", 13) || (t.from == i.from - 1 && t.to == i.to && t.insert.length == 0 || s == 8 && t.insert.length < t.to - t.from && t.to > i.head) && zp(r.contentDOM, "Backspace", 8) || t.from == i.from && t.to == i.to + 1 && t.insert.length == 0 && zp(r.contentDOM, "Delete", 46)))
      return !0;
    let o = t.insert.toString();
    r.inputState.composing >= 0 && r.inputState.composing++;
    let a, l = () => a || (a = hFt(r, t, n));
    return r.state.facet(TVe).some((c) => c(r, t.from, t.to, o, l)) || r.dispatch(l()), !0;
  } else if (n && !n.main.eq(i)) {
    let o = !1, a = "select";
    return r.inputState.lastSelectionTime > Date.now() - 50 && (r.inputState.lastSelectionOrigin == "select" && (o = !0), a = r.inputState.lastSelectionOrigin), r.dispatch({ selection: n, scrollIntoView: o, userEvent: a }), !0;
  } else
    return !1;
}
function hFt(r, e, t) {
  let n, i = r.state, s = i.selection.main;
  if (e.from >= s.from && e.to <= s.to && e.to - e.from >= (s.to - s.from) / 3 && (!t || t.main.empty && t.main.from == e.from + e.insert.length) && r.inputState.composing < 0) {
    let a = s.from < e.from ? i.sliceDoc(s.from, e.from) : "", l = s.to > e.to ? i.sliceDoc(e.to, s.to) : "";
    n = i.replaceSelection(r.state.toText(a + e.insert.sliceString(0, void 0, r.state.lineBreak) + l));
  } else {
    let a = i.changes(e), l = t && t.main.to <= a.newLength ? t.main : void 0;
    if (i.selection.ranges.length > 1 && r.inputState.composing >= 0 && e.to <= s.to && e.to >= s.to - 10) {
      let c = r.state.sliceDoc(e.from, e.to), d, u = t && FVe(r, t.main.head);
      if (u) {
        let g = e.insert.length - (e.to - e.from);
        d = { from: u.from, to: u.to - g };
      } else
        d = r.state.doc.lineAt(s.head);
      let f = s.to - e.to, p = s.to - s.from;
      n = i.changeByRange((g) => {
        if (g.from == s.from && g.to == s.to)
          return { changes: a, range: l || g.map(a) };
        let m = g.to - f, A = m - c.length;
        if (g.to - g.from != p || r.state.sliceDoc(A, m) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        g.to >= d.from && g.from <= d.to)
          return { range: g };
        let w = i.changes({ from: A, to: m, insert: e.insert }), v = g.to - s.to;
        return {
          changes: w,
          range: l ? Be.range(Math.max(0, l.anchor + v), Math.max(0, l.head + v)) : g.map(w)
        };
      });
    } else
      n = {
        changes: a,
        selection: l && i.selection.replaceRange(l)
      };
  }
  let o = "input.type";
  return (r.composing || r.inputState.compositionPendingChange && r.inputState.compositionEndedAt > Date.now() - 50) && (r.inputState.compositionPendingChange = !1, o += ".compose", r.inputState.compositionFirstChange && (o += ".start", r.inputState.compositionFirstChange = !1)), i.update(n, { userEvent: o, scrollIntoView: !0 });
}
function dFt(r, e, t, n) {
  let i = Math.min(r.length, e.length), s = 0;
  for (; s < i && r.charCodeAt(s) == e.charCodeAt(s); )
    s++;
  if (s == i && r.length == e.length)
    return null;
  let o = r.length, a = e.length;
  for (; o > 0 && a > 0 && r.charCodeAt(o - 1) == e.charCodeAt(a - 1); )
    o--, a--;
  if (n == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    t -= o + l - s;
  }
  if (o < s && r.length < e.length) {
    let l = t <= s && t >= o ? s - t : 0;
    s -= l, a = s + (a - o), o = s;
  } else if (a < s) {
    let l = t <= s && t >= a ? s - t : 0;
    s -= l, o = s + (o - a), a = s;
  }
  return { from: s, toA: o, toB: a };
}
function uFt(r) {
  let e = [];
  if (r.root.activeElement != r.contentDOM)
    return e;
  let { anchorNode: t, anchorOffset: n, focusNode: i, focusOffset: s } = r.observer.selectionRange;
  return t && (e.push(new bEe(t, n)), (i != t || s != n) && e.push(new bEe(i, s))), e;
}
function fFt(r, e) {
  if (r.length == 0)
    return null;
  let t = r[0].pos, n = r.length == 2 ? r[1].pos : t;
  return t > -1 && n > -1 ? Be.single(t + e, n + e) : null;
}
const pFt = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, SS = ft.ie && ft.ie_version <= 11;
class gFt {
  constructor(e) {
    this.view = e, this.active = !1, this.selectionRange = new KBt(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((t) => {
      for (let n of t)
        this.queue.push(n);
      (ft.ie && ft.ie_version <= 11 || ft.ios && e.composing) && t.some((n) => n.type == "childList" && n.removedNodes.length || n.type == "characterData" && n.oldValue.length > n.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), SS && (this.onCharData = (t) => {
      this.queue.push({
        target: t.target,
        type: "characterData",
        oldValue: t.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var t;
      ((t = this.view.docView) === null || t === void 0 ? void 0 : t.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((t) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), t.length > 0 && t[t.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((t) => {
      t.length > 0 && t[t.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint() {
    this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500);
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((t, n) => t != e[n]))) {
      this.gapIntersection.disconnect();
      for (let t of e)
        this.gapIntersection.observe(t);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let t = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: n } = this, i = this.selectionRange;
    if (n.state.facet(lC) ? n.root.activeElement != this.dom : !n8(n.dom, i))
      return;
    let s = i.anchorNode && n.docView.nearest(i.anchorNode);
    if (s && s.ignoreEvent(e)) {
      t || (this.selectionChanged = !1);
      return;
    }
    (ft.ie && ft.ie_version <= 11 || ft.android && ft.chrome) && !n.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && m3(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, t = ft.safari && e.root.nodeType == 11 && UBt(this.dom.ownerDocument) == this.dom && mFt(this.view) || Rb(e.root);
    if (!t || this.selectionRange.eq(t))
      return !1;
    let n = n8(this.dom, t);
    return n && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && XBt(this.dom, t) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(t), n && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, t) {
    this.selectionRange.set(e.node, e.offset, t.node, t.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, t = null;
    for (let n = this.dom; n; )
      if (n.nodeType == 1)
        !t && e < this.scrollTargets.length && this.scrollTargets[e] == n ? e++ : t || (t = this.scrollTargets.slice(0, e)), t && t.push(n), n = n.assignedSlot || n.parentNode;
      else if (n.nodeType == 11)
        n = n.host;
      else
        break;
    if (e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t) {
      for (let n of this.scrollTargets)
        n.removeEventListener("scroll", this.onScroll);
      for (let n of this.scrollTargets = t)
        n.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, pFt), SS && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), SS && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, t) {
    var n;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let s = this.delayedAndroidKey;
        s && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = s.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && s.force && zp(this.dom, s.key, s.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: t,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((n = this.delayedAndroidKey) === null || n === void 0) && n.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let t = -1, n = -1, i = !1;
    for (let s of e) {
      let o = this.readMutation(s);
      o && (o.typeOver && (i = !0), t == -1 ? { from: t, to: n } = o : (t = Math.min(o.from, t), n = Math.max(o.to, n)));
    }
    return { from: t, to: n, typeOver: i };
  }
  readChange() {
    let { from: e, to: t, typeOver: n } = this.processRecords(), i = this.selectionChanged && n8(this.dom, this.selectionRange);
    if (e < 0 && !i)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let s = new cFt(this.view, e, t, n);
    return this.view.docView.domChanged = { newSel: s.newSel ? s.newSel.main : null }, s;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let t = this.readChange();
    if (!t)
      return this.view.requestMeasure(), !1;
    let n = this.view.state, i = nHe(this.view, t);
    return this.view.state == n && this.view.update([]), i;
  }
  readMutation(e) {
    let t = this.view.docView.nearest(e.target);
    if (!t || t.ignoreMutation(e))
      return null;
    if (t.markDirty(e.type == "attributes"), e.type == "attributes" && (t.flags |= 4), e.type == "childList") {
      let n = yEe(t, e.previousSibling || e.target.previousSibling, -1), i = yEe(t, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: n ? t.posAfter(n) : t.posAtStart,
        to: i ? t.posBefore(i) : t.posAtEnd,
        typeOver: !1
      };
    } else return e.type == "characterData" ? { from: t.posAtStart, to: t.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var e, t, n;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (t = this.gapIntersection) === null || t === void 0 || t.disconnect(), (n = this.resizeScroll) === null || n === void 0 || n.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function yEe(r, e, t) {
  for (; e; ) {
    let n = Ni.get(e);
    if (n && n.parent == r)
      return n;
    let i = e.parentNode;
    e = i != r.dom ? i : t > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function mFt(r) {
  let e = null;
  function t(l) {
    l.preventDefault(), l.stopImmediatePropagation(), e = l.getTargetRanges()[0];
  }
  if (r.contentDOM.addEventListener("beforeinput", t, !0), r.dom.ownerDocument.execCommand("indent"), r.contentDOM.removeEventListener("beforeinput", t, !0), !e)
    return null;
  let n = e.startContainer, i = e.startOffset, s = e.endContainer, o = e.endOffset, a = r.docView.domAtPos(r.state.selection.main.anchor);
  return m3(a.node, a.offset, s, o) && ([n, i, s, o] = [s, o, n, i]), { anchorNode: n, anchorOffset: i, focusNode: s, focusOffset: o };
}
class st {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: t } = e;
    this.dispatchTransactions = e.dispatchTransactions || t && ((n) => n.forEach((i) => t(i, this))) || ((n) => this.update(n)), this.dispatch = this.dispatch.bind(this), this._root = e.root || YBt(e.parent) || document, this.viewState = new AEe(e.state || jn.create(e)), e.scrollTo && e.scrollTo.is(B5) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(LA).map((n) => new CS(n));
    for (let n of this.plugins)
      n.update(this);
    this.observer = new gFt(this), this.inputState = new NPt(this), this.inputState.ensureHandlers(this.plugins), this.docView = new $Ce(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure();
  }
  dispatch(...e) {
    let t = e.length == 1 && e[0] instanceof vs ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(t, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let t = !1, n = !1, i, s = this.state;
    for (let f of e) {
      if (f.startState != s)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      s = f.state;
    }
    if (this.destroyed) {
      this.viewState.state = s;
      return;
    }
    let o = this.hasFocus, a = 0, l = null;
    e.some((f) => f.annotation(KVe)) ? (this.inputState.notifiedFocused = o, a = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, l = YVe(s, o), l || (a = 1));
    let c = this.observer.delayedAndroidKey, d = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), d = this.observer.readChange(), (d && !this.state.doc.eq(s.doc) || !this.state.selection.eq(s.selection)) && (d = null)) : this.observer.clear(), s.facet(jn.phrases) != this.state.facet(jn.phrases))
      return this.setState(s);
    i = Vb.create(this, s, e), i.flags |= a;
    let u = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let f of e) {
        if (u && (u = u.map(f.changes)), f.scrollIntoView) {
          let { main: p } = f.state.selection;
          u = new Wp(p.empty ? p : Be.cursor(p.head, p.head > p.anchor ? -1 : 1));
        }
        for (let p of f.effects)
          p.is(B5) && (u = p.value.clip(this.state));
      }
      this.viewState.update(i, u), this.bidiCache = Hb.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), t = this.docView.update(i), this.state.facet(kA) != this.styleModules && this.mountStyles(), n = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(t, e.some((f) => f.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(Z5) != i.state.facet(Z5) && (this.viewState.mustMeasureContent = !0), (t || n || u || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !i.empty)
      for (let f of this.state.facet(cT))
        try {
          f(i);
        } catch (p) {
          va(this.state, p, "update listener");
        }
    (l || d) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), d && !nHe(this, d) && c.force && zp(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let t = this.hasFocus;
    try {
      for (let n of this.plugins)
        n.destroy(this);
      this.viewState = new AEe(e), this.plugins = e.facet(LA).map((n) => new CS(n)), this.pluginMap.clear();
      for (let n of this.plugins)
        n.update(this);
      this.docView.destroy(), this.docView = new $Ce(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    t && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let t = e.startState.facet(LA), n = e.state.facet(LA);
    if (t != n) {
      let i = [];
      for (let s of n) {
        let o = t.indexOf(s);
        if (o < 0)
          i.push(new CS(s));
        else {
          let a = this.plugins[o];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let s of this.plugins)
        s.mustUpdate != e && s.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = e;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    t != n && this.inputState.ensureHandlers(this.plugins);
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let t = null, n = this.scrollDOM, i = n.scrollTop * this.scaleY, { scrollAnchorPos: s, scrollAnchorHeight: o } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (o < 0)
          if (fVe(n))
            s = -1, o = this.viewState.heightMap.height;
          else {
            let p = this.viewState.scrollAnchorAt(i);
            s = p.from, o = p.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let d = c.map((p) => {
          try {
            return p.read(this);
          } catch (g) {
            return va(this.state, g), CEe;
          }
        }), u = Vb.create(this, this.state, []), f = !1;
        u.flags |= l, t ? t.flags |= l : t = u, this.updateState = 2, u.empty || (this.updatePlugins(u), this.inputState.update(u), this.updateAttrs(), f = this.docView.update(u));
        for (let p = 0; p < c.length; p++)
          if (d[p] != CEe)
            try {
              let g = c[p];
              g.write && g.write(d[p], this);
            } catch (g) {
              va(this.state, g);
            }
        if (f && this.docView.updateSelection(!0), !u.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let g = (s < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(s).top) - o;
              if (g > 1 || g < -1) {
                i = i + g, n.scrollTop = i / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (t && !t.empty)
      for (let a of this.state.facet(cT))
        a(t);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return fT + " " + (this.state.facet(uT) ? eHe : $Ve) + " " + this.state.facet(Z5);
  }
  updateAttrs() {
    let e = EEe(this, RVe, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), t = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: this.state.facet(lC) ? "true" : "false",
      class: "cm-content",
      style: `${ft.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (t["aria-readonly"] = "true"), EEe(this, QV, t);
    let n = this.observer.ignore(() => {
      let i = rT(this.contentDOM, this.contentAttrs, t), s = rT(this.dom, this.editorAttrs, e);
      return i || s;
    });
    return this.editorAttrs = e, this.contentAttrs = t, n;
  }
  showAnnouncements(e) {
    let t = !0;
    for (let n of e)
      for (let i of n.effects)
        if (i.is(st.announce)) {
          t && (this.announceDOM.textContent = ""), t = !1;
          let s = this.announceDOM.appendChild(document.createElement("div"));
          s.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(kA);
    let e = this.state.facet(st.cspNonce);
    C1.mount(this.root, this.styleModules.concat(oFt).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let t = 0; t < this.measureRequests.length; t++)
          if (this.measureRequests[t].key === e.key) {
            this.measureRequests[t] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let t = this.pluginMap.get(e);
    return (t === void 0 || t && t.spec != e) && this.pluginMap.set(e, t = this.plugins.find((n) => n.spec == e) || null), t && t.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line breaks, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, t, n) {
    return _S(this, e, sEe(this, e, t, n));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, t) {
    return _S(this, e, sEe(this, e, t, (n) => LPt(this, e.head, n)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, t) {
    let n = this.bidiSpans(e), i = this.textDirectionAt(e.from), s = n[t ? n.length - 1 : 0];
    return Be.cursor(s.side(t, i) + e.from, s.forward(!t, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, t, n = !0) {
    return DPt(this, e, t, n);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, t, n) {
    return _S(this, e, kPt(this, e, t, n));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, t = 0) {
    return this.docView.posFromDOM(e, t);
  }
  posAtCoords(e, t = !0) {
    return this.readMeasured(), WVe(this, e, t);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, t = 1) {
    this.readMeasured();
    let n = this.docView.coordsAt(e, t);
    if (!n || n.left == n.right)
      return n;
    let i = this.state.doc.lineAt(e), s = this.bidiSpans(i), o = s[qu.find(s, e - i.from, -1, t)];
    return ZV(n, o.dir == nr.LTR == t > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(OVe) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > AFt)
      return SVe(e.length);
    let t = this.textDirectionAt(e.from), n;
    for (let s of this.bidiCache)
      if (s.from == e.from && s.dir == t && (s.fresh || xVe(s.isolates, n = JCe(this, e))))
        return s.order;
    n || (n = JCe(this, e));
    let i = hPt(e.text, t, n);
    return this.bidiCache.push(new Hb(e.from, e.to, t, n, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || ft.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      dVe(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, t = {}) {
    return B5.of(new Wp(typeof e == "number" ? Be.cursor(e) : e, t.y, t.x, t.yMargin, t.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: t } = this.scrollDOM, n = this.viewState.scrollAnchorAt(e);
    return B5.of(new Wp(Be.cursor(n.from), "start", "start", n.top - e, t, !0));
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return Ca.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return Ca.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, t) {
    let n = C1.newName(), i = [Z5.of(n), kA.of(pT(`.${n}`, e))];
    return t && t.dark && i.push(uT.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return vm.lowest(kA.of(pT("." + fT, e, tHe)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var t;
    let n = e.querySelector(".cm-content"), i = n && Ni.get(n) || Ni.get(e);
    return ((t = i?.rootView) === null || t === void 0 ? void 0 : t.view) || null;
  }
}
st.styleModule = kA;
st.inputHandler = TVe;
st.focusChangeEffect = IVe;
st.perLineTextDirection = OVe;
st.exceptionSink = NVe;
st.updateListener = cT;
st.editable = lC;
st.mouseSelectionStyle = kVe;
st.dragMovesSelection = LVe;
st.clickAddsSelectionRange = DVe;
st.decorations = V4;
st.outerDecorations = VVe;
st.atomicRanges = KV;
st.bidiIsolatedRanges = HVe;
st.scrollMargins = BVe;
st.darkTheme = uT;
st.cspNonce = /* @__PURE__ */ bt.define({ combine: (r) => r.length ? r[0] : "" });
st.contentAttributes = QV;
st.editorAttributes = RVe;
st.lineWrapping = /* @__PURE__ */ st.contentAttributes.of({ class: "cm-lineWrapping" });
st.announce = /* @__PURE__ */ Qn.define();
const AFt = 4096, CEe = {};
class Hb {
  constructor(e, t, n, i, s, o) {
    this.from = e, this.to = t, this.dir = n, this.isolates = i, this.fresh = s, this.order = o;
  }
  static update(e, t) {
    if (t.empty && !e.some((s) => s.fresh))
      return e;
    let n = [], i = e.length ? e[e.length - 1].dir : nr.LTR;
    for (let s = Math.max(0, e.length - 10); s < e.length; s++) {
      let o = e[s];
      o.dir == i && !t.touchesRange(o.from, o.to) && n.push(new Hb(t.mapPos(o.from, 1), t.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return n;
  }
}
function EEe(r, e, t) {
  for (let n = r.state.facet(e), i = n.length - 1; i >= 0; i--) {
    let s = n[i], o = typeof s == "function" ? s(r) : s;
    o && iT(o, t);
  }
  return t;
}
const wFt = ft.mac ? "mac" : ft.windows ? "win" : ft.linux ? "linux" : "key";
function vFt(r, e) {
  const t = r.split(/-(?!$)/);
  let n = t[t.length - 1];
  n == "Space" && (n = " ");
  let i, s, o, a;
  for (let l = 0; l < t.length - 1; ++l) {
    const c = t[l];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      s = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      e == "mac" ? a = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return i && (n = "Alt-" + n), s && (n = "Ctrl-" + n), a && (n = "Meta-" + n), o && (n = "Shift-" + n), n;
}
function U5(r, e, t) {
  return e.altKey && (r = "Alt-" + r), e.ctrlKey && (r = "Ctrl-" + r), e.metaKey && (r = "Meta-" + r), t !== !1 && e.shiftKey && (r = "Shift-" + r), r;
}
const bFt = /* @__PURE__ */ vm.default(/* @__PURE__ */ st.domEventHandlers({
  keydown(r, e) {
    return _Ft(yFt(e.state), r, e, "editor");
  }
})), ev = /* @__PURE__ */ bt.define({ enables: bFt }), _Ee = /* @__PURE__ */ new WeakMap();
function yFt(r) {
  let e = r.facet(ev), t = _Ee.get(e);
  return t || _Ee.set(e, t = EFt(e.reduce((n, i) => n.concat(i), []))), t;
}
let Lu = null;
const CFt = 4e3;
function EFt(r, e = wFt) {
  let t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), i = (o, a) => {
    let l = n[o];
    if (l == null)
      n[o] = a;
    else if (l != a)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, s = (o, a, l, c, d) => {
    var u, f;
    let p = t[o] || (t[o] = /* @__PURE__ */ Object.create(null)), g = a.split(/ (?!$)/).map((w) => vFt(w, e));
    for (let w = 1; w < g.length; w++) {
      let v = g.slice(0, w).join(" ");
      i(v, !0), p[v] || (p[v] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(y) => {
          let _ = Lu = { view: y, prefix: v, scope: o };
          return setTimeout(() => {
            Lu == _ && (Lu = null);
          }, CFt), !0;
        }]
      });
    }
    let m = g.join(" ");
    i(m, !1);
    let A = p[m] || (p[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((f = (u = p._any) === null || u === void 0 ? void 0 : u.run) === null || f === void 0 ? void 0 : f.slice()) || []
    });
    l && A.run.push(l), c && (A.preventDefault = !0), d && (A.stopPropagation = !0);
  };
  for (let o of r) {
    let a = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let c of a) {
        let d = t[c] || (t[c] = /* @__PURE__ */ Object.create(null));
        d._any || (d._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        for (let u in d)
          d[u].run.push(o.any);
      }
    let l = o[e] || o.key;
    if (l)
      for (let c of a)
        s(c, l, o.run, o.preventDefault, o.stopPropagation), o.shift && s(c, "Shift-" + l, o.shift, o.preventDefault, o.stopPropagation);
  }
  return t;
}
function _Ft(r, e, t, n) {
  let i = ZBt(e), s = ta(i, 0), o = Kc(s) == i.length && i != " ", a = "", l = !1, c = !1, d = !1;
  Lu && Lu.view == t && Lu.scope == n && (a = Lu.prefix + " ", ZVe.indexOf(e.keyCode) < 0 && (c = !0, Lu = null));
  let u = /* @__PURE__ */ new Set(), f = (A) => {
    if (A) {
      for (let w of A.run)
        if (!u.has(w) && (u.add(w), w(t, e)))
          return A.stopPropagation && (d = !0), !0;
      A.preventDefault && (A.stopPropagation && (d = !0), c = !0);
    }
    return !1;
  }, p = r[n], g, m;
  return p && (f(p[a + U5(i, e, !o)]) ? l = !0 : o && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(ft.windows && e.ctrlKey && e.altKey) && (g = E1[e.keyCode]) && g != i ? (f(p[a + U5(g, e, !0)]) || e.shiftKey && (m = I4[e.keyCode]) != i && m != g && f(p[a + U5(m, e, !1)])) && (l = !0) : o && e.shiftKey && f(p[a + U5(i, e, !0)]) && (l = !0), !l && f(p._any) && (l = !0)), c && (l = !0), l && d && e.stopPropagation(), l;
}
const iA = "-10000px";
class iHe {
  constructor(e, t, n) {
    this.facet = t, this.createTooltipView = n, this.input = e.state.facet(t), this.tooltips = this.input.filter((i) => i), this.tooltipViews = this.tooltips.map(n);
  }
  update(e, t) {
    var n;
    let i = e.state.facet(this.facet), s = i.filter((l) => l);
    if (i === this.input) {
      for (let l of this.tooltipViews)
        l.update && l.update(e);
      return !1;
    }
    let o = [], a = t ? [] : null;
    for (let l = 0; l < s.length; l++) {
      let c = s[l], d = -1;
      if (c) {
        for (let u = 0; u < this.tooltips.length; u++) {
          let f = this.tooltips[u];
          f && f.create == c.create && (d = u);
        }
        if (d < 0)
          o[l] = this.createTooltipView(c), a && (a[l] = !!c.above);
        else {
          let u = o[l] = this.tooltipViews[d];
          a && (a[l] = t[d]), u.update && u.update(e);
        }
      }
    }
    for (let l of this.tooltipViews)
      o.indexOf(l) < 0 && (l.dom.remove(), (n = l.destroy) === null || n === void 0 || n.call(l));
    return t && (a.forEach((l, c) => t[c] = l), t.length = a.length), this.input = i, this.tooltips = s, this.tooltipViews = o, !0;
  }
}
function rHe(r = {}) {
  return s8.of(r);
}
function xFt(r) {
  let { win: e } = r;
  return { top: 0, left: 0, bottom: e.innerHeight, right: e.innerWidth };
}
const s8 = /* @__PURE__ */ bt.define({
  combine: (r) => {
    var e, t, n;
    return {
      position: ft.ios ? "absolute" : ((e = r.find((i) => i.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((t = r.find((i) => i.parent)) === null || t === void 0 ? void 0 : t.parent) || null,
      tooltipSpace: ((n = r.find((i) => i.tooltipSpace)) === null || n === void 0 ? void 0 : n.tooltipSpace) || xFt
    };
  }
}), xEe = /* @__PURE__ */ new WeakMap(), XV = /* @__PURE__ */ Ca.fromClass(class {
  constructor(r) {
    this.view = r, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = r.state.facet(s8);
    this.position = e.position, this.parent = e.parent, this.classes = r.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.manager = new iHe(r, JV, (t) => this.createTooltip(t)), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((t) => {
      Date.now() > this.lastTransaction - 50 && t.length > 0 && t[t.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), r.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let r of this.manager.tooltipViews)
        this.intersectionObserver.observe(r.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(r) {
    r.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(r, this.above);
    e && this.observeIntersection();
    let t = e || r.geometryChanged, n = r.state.facet(s8);
    if (n.position != this.position && !this.madeAbsolute) {
      this.position = n.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      t = !0;
    }
    if (n.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = n.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      t = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    t && this.maybeMeasure();
  }
  createTooltip(r) {
    let e = r.create(this.view);
    if (e.dom.classList.add("cm-tooltip"), r.arrow && !e.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let t = document.createElement("div");
      t.className = "cm-tooltip-arrow", e.dom.appendChild(t);
    }
    return e.dom.style.position = this.position, e.dom.style.top = iA, e.dom.style.left = "0px", this.container.appendChild(e.dom), e.mount && e.mount(this.view), e;
  }
  destroy() {
    var r, e;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let t of this.manager.tooltipViews)
      t.dom.remove(), (r = t.destroy) === null || r === void 0 || r.call(t);
    this.parent && this.container.remove(), (e = this.intersectionObserver) === null || e === void 0 || e.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let r = this.view.dom.getBoundingClientRect(), e = 1, t = 1, n = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: i } = this.manager.tooltipViews[0];
      if (ft.gecko)
        n = i.offsetParent != this.container.ownerDocument.body;
      else if (i.style.top == iA && i.style.left == "0px") {
        let s = i.getBoundingClientRect();
        n = Math.abs(s.top + 1e4) > 1 || Math.abs(s.left) > 1;
      }
    }
    if (n || this.position == "absolute")
      if (this.parent) {
        let i = this.parent.getBoundingClientRect();
        i.width && i.height && (e = i.width / this.parent.offsetWidth, t = i.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: t } = this.view.viewState);
    return {
      editor: r,
      parent: this.parent ? this.container.getBoundingClientRect() : r,
      pos: this.manager.tooltips.map((i, s) => {
        let o = this.manager.tooltipViews[s];
        return o.getCoords ? o.getCoords(i.pos) : this.view.coordsAtPos(i.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: i }) => i.getBoundingClientRect()),
      space: this.view.state.facet(s8).tooltipSpace(this.view),
      scaleX: e,
      scaleY: t,
      makeAbsolute: n
    };
  }
  writeMeasure(r) {
    var e;
    if (r.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { editor: t, space: n, scaleX: i, scaleY: s } = r, o = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: d } = c, u = r.pos[a], f = r.size[a];
      if (!u || u.bottom <= Math.max(t.top, n.top) || u.top >= Math.min(t.bottom, n.bottom) || u.right < Math.max(t.left, n.left) - 0.1 || u.left > Math.min(t.right, n.right) + 0.1) {
        d.style.top = iA;
        continue;
      }
      let p = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, g = p ? 7 : 0, m = f.right - f.left, A = (e = xEe.get(c)) !== null && e !== void 0 ? e : f.bottom - f.top, w = c.offset || MFt, v = this.view.textDirection == nr.LTR, y = f.width > n.right - n.left ? v ? n.left : n.right - f.width : v ? Math.min(u.left - (p ? 14 : 0) + w.x, n.right - m) : Math.max(n.left, u.left - m + (p ? 14 : 0) - w.x), _ = this.above[a];
      !l.strictSide && (_ ? u.top - (f.bottom - f.top) - w.y < n.top : u.bottom + (f.bottom - f.top) + w.y > n.bottom) && _ == n.bottom - u.bottom > u.top - n.top && (_ = this.above[a] = !_);
      let S = (_ ? u.top - n.top : n.bottom - u.bottom) - g;
      if (S < A && c.resize !== !1) {
        if (S < this.view.defaultLineHeight) {
          d.style.top = iA;
          continue;
        }
        xEe.set(c, A), d.style.height = (A = S) / s + "px";
      } else d.style.height && (d.style.height = "");
      let D = _ ? u.top - A - g - w.y : u.bottom + g + w.y, M = y + m;
      if (c.overlap !== !0)
        for (let L of o)
          L.left < M && L.right > y && L.top < D + A && L.bottom > D && (D = _ ? L.top - A - 2 - g : L.bottom + g + 2);
      if (this.position == "absolute" ? (d.style.top = (D - r.parent.top) / s + "px", d.style.left = (y - r.parent.left) / i + "px") : (d.style.top = D / s + "px", d.style.left = y / i + "px"), p) {
        let L = u.left + (v ? w.x : -w.x) - (y + 14 - 7);
        p.style.left = L / i + "px";
      }
      c.overlap !== !0 && o.push({ left: y, top: D, right: M, bottom: D + A }), d.classList.toggle("cm-tooltip-above", _), d.classList.toggle("cm-tooltip-below", !_), c.positioned && c.positioned(r.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let r of this.manager.tooltipViews)
        r.dom.style.top = iA;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
}), SFt = /* @__PURE__ */ st.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), MFt = { x: 0, y: 0 }, JV = /* @__PURE__ */ bt.define({
  enables: [XV, SFt]
}), Bb = /* @__PURE__ */ bt.define();
class cC {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new cC(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new iHe(e, Bb, (t) => this.createHostedView(t));
  }
  createHostedView(e) {
    let t = e.create(this.view);
    return t.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(t.dom), this.mounted && t.mount && t.mount(this.view), t;
  }
  mount(e) {
    for (let t of this.manager.tooltipViews)
      t.mount && t.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let t of this.manager.tooltipViews)
      t.positioned && t.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let t of this.manager.tooltipViews)
      (e = t.destroy) === null || e === void 0 || e.call(t);
  }
  passProp(e) {
    let t;
    for (let n of this.manager.tooltipViews) {
      let i = n[e];
      if (i !== void 0) {
        if (t === void 0)
          t = i;
        else if (t !== i)
          return;
      }
    }
    return t;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const DFt = /* @__PURE__ */ JV.compute([Bb], (r) => {
  let e = r.facet(Bb).filter((t) => t);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((t) => t.pos)),
    end: Math.max(...e.map((t) => {
      var n;
      return (n = t.end) !== null && n !== void 0 ? n : t.pos;
    })),
    create: cC.create,
    above: e[0].above,
    arrow: e.some((t) => t.arrow)
  };
});
class LFt {
  constructor(e, t, n, i, s) {
    this.view = e, this.source = t, this.field = n, this.setHover = i, this.hoverTime = s, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: t } = this, n = e.docView.nearest(t.target);
    if (!n)
      return;
    let i, s = 1;
    if (n instanceof Uu)
      i = n.posAtStart;
    else {
      if (i = e.posAtCoords(t), i == null)
        return;
      let a = e.coordsAtPos(i);
      if (!a || t.y < a.top || t.y > a.bottom || t.x < a.left - e.defaultCharacterWidth || t.x > a.right + e.defaultCharacterWidth)
        return;
      let l = e.bidiSpans(e.state.doc.lineAt(i)).find((d) => d.from <= i && d.to >= i), c = l && l.dir == nr.RTL ? -1 : 1;
      s = t.x < a.left ? -c : c;
    }
    let o = this.source(e, i, s);
    if (o?.then) {
      let a = this.pending = { pos: i };
      o.then((l) => {
        this.pending == a && (this.pending = null, l && e.dispatch({ effects: this.setHover.of(l) }));
      }, (l) => va(e.state, l, "hover tooltip"));
    } else o && e.dispatch({ effects: this.setHover.of(o) });
  }
  get tooltip() {
    let e = this.view.plugin(XV), t = e ? e.manager.tooltips.findIndex((n) => n.create == cC.create) : -1;
    return t > -1 ? e.manager.tooltipViews[t] : null;
  }
  mousemove(e) {
    var t;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: n, tooltip: i } = this;
    if (n && i && !kFt(i.dom, e) || this.pending) {
      let { pos: s } = n || this.pending, o = (t = n?.end) !== null && t !== void 0 ? t : s;
      (s == o ? this.view.posAtCoords(this.lastMove) != s : !NFt(this.view, s, o, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: t } = this;
    if (t) {
      let { tooltip: n } = this;
      n && n.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(n.dom) : this.view.dispatch({ effects: this.setHover.of(null) });
    }
  }
  watchTooltipLeave(e) {
    let t = (n) => {
      e.removeEventListener("mouseleave", t), this.active && !this.view.dom.contains(n.relatedTarget) && this.view.dispatch({ effects: this.setHover.of(null) });
    };
    e.addEventListener("mouseleave", t);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const q5 = 4;
function kFt(r, e) {
  let t = r.getBoundingClientRect();
  return e.clientX >= t.left - q5 && e.clientX <= t.right + q5 && e.clientY >= t.top - q5 && e.clientY <= t.bottom + q5;
}
function NFt(r, e, t, n, i, s) {
  let o = r.scrollDOM.getBoundingClientRect(), a = r.documentTop + r.documentPadding.top + r.contentHeight;
  if (o.left > n || o.right < n || o.top > i || Math.min(o.bottom, a) < i)
    return !1;
  let l = r.posAtCoords({ x: n, y: i }, !1);
  return l >= e && l <= t;
}
function TFt(r, e = {}) {
  let t = Qn.define(), n = ka.define({
    create() {
      return null;
    },
    update(i, s) {
      if (i && (e.hideOnChange && (s.docChanged || s.selection) || e.hideOn && e.hideOn(s, i)))
        return null;
      if (i && s.docChanged) {
        let o = s.changes.mapPos(i.pos, -1, ps.TrackDel);
        if (o == null)
          return null;
        let a = Object.assign(/* @__PURE__ */ Object.create(null), i);
        a.pos = o, i.end != null && (a.end = s.changes.mapPos(i.end)), i = a;
      }
      for (let o of s.effects)
        o.is(t) && (i = o.value), o.is(IFt) && (i = null);
      return i;
    },
    provide: (i) => Bb.from(i)
  });
  return [
    n,
    Ca.define((i) => new LFt(
      i,
      r,
      n,
      t,
      e.hoverTime || 300
      /* Hover.Time */
    )),
    DFt
  ];
}
function sHe(r, e) {
  let t = r.plugin(XV);
  if (!t)
    return null;
  let n = t.manager.tooltips.indexOf(e);
  return n < 0 ? null : t.manager.tooltipViews[n];
}
const IFt = /* @__PURE__ */ Qn.define(), SEe = /* @__PURE__ */ bt.define({
  combine(r) {
    let e, t;
    for (let n of r)
      e = e || n.topContainer, t = t || n.bottomContainer;
    return { topContainer: e, bottomContainer: t };
  }
}), OFt = /* @__PURE__ */ Ca.fromClass(class {
  constructor(r) {
    this.input = r.state.facet(gT), this.specs = this.input.filter((t) => t), this.panels = this.specs.map((t) => t(r));
    let e = r.state.facet(SEe);
    this.top = new G5(r, !0, e.topContainer), this.bottom = new G5(r, !1, e.bottomContainer), this.top.sync(this.panels.filter((t) => t.top)), this.bottom.sync(this.panels.filter((t) => !t.top));
    for (let t of this.panels)
      t.dom.classList.add("cm-panel"), t.mount && t.mount();
  }
  update(r) {
    let e = r.state.facet(SEe);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new G5(r.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new G5(r.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let t = r.state.facet(gT);
    if (t != this.input) {
      let n = t.filter((l) => l), i = [], s = [], o = [], a = [];
      for (let l of n) {
        let c = this.specs.indexOf(l), d;
        c < 0 ? (d = l(r.view), a.push(d)) : (d = this.panels[c], d.update && d.update(r)), i.push(d), (d.top ? s : o).push(d);
      }
      this.specs = n, this.panels = i, this.top.sync(s), this.bottom.sync(o);
      for (let l of a)
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
    } else
      for (let n of this.panels)
        n.update && n.update(r);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (r) => st.scrollMargins.of((e) => {
    let t = e.plugin(r);
    return t && { top: t.top.scrollMargin(), bottom: t.bottom.scrollMargin() };
  })
});
class G5 {
  constructor(e, t, n) {
    this.view = e, this.top = t, this.container = n, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let t of this.panels)
      t.destroy && e.indexOf(t) < 0 && t.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let t = this.container || this.view.dom;
      t.insertBefore(this.dom, this.top ? t.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let t of this.panels)
      if (t.dom.parentNode == this.dom) {
        for (; e != t.dom; )
          e = MEe(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(t.dom, e);
    for (; e; )
      e = MEe(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function MEe(r) {
  let e = r.nextSibling;
  return r.remove(), e;
}
const gT = /* @__PURE__ */ bt.define({
  enables: OFt
});
class Of extends Nf {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
Of.prototype.elementClass = "";
Of.prototype.toDOM = void 0;
Of.prototype.mapMode = ps.TrackBefore;
Of.prototype.startSide = Of.prototype.endSide = -1;
Of.prototype.point = !0;
const MS = /* @__PURE__ */ bt.define(), o8 = /* @__PURE__ */ bt.define(), DEe = /* @__PURE__ */ bt.define({
  combine: (r) => r.some((e) => e)
});
function RFt(r) {
  return [
    VFt
  ];
}
const VFt = /* @__PURE__ */ Ca.fromClass(class {
  constructor(r) {
    this.view = r, this.prevViewport = r.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = r.state.facet(o8).map((e) => new kEe(r, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !r.state.facet(DEe), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), r.scrollDOM.insertBefore(this.dom, r.contentDOM);
  }
  update(r) {
    if (this.updateGutters(r)) {
      let e = this.prevViewport, t = r.view.viewport, n = Math.min(e.to, t.to) - Math.max(e.from, t.from);
      this.syncGutters(n < (t.to - t.from) * 0.8);
    }
    r.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(DEe) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = r.view.viewport;
  }
  syncGutters(r) {
    let e = this.dom.nextSibling;
    r && this.dom.remove();
    let t = oi.iter(this.view.state.facet(MS), this.view.viewport.from), n = [], i = this.gutters.map((s) => new HFt(s, this.view.viewport, -this.view.documentPadding.top));
    for (let s of this.view.viewportLineBlocks)
      if (n.length && (n = []), Array.isArray(s.type)) {
        let o = !0;
        for (let a of s.type)
          if (a.type == Jl.Text && o) {
            mT(t, n, a.from);
            for (let l of i)
              l.line(this.view, a, n);
            o = !1;
          } else if (a.widget)
            for (let l of i)
              l.widget(this.view, a);
      } else if (s.type == Jl.Text) {
        mT(t, n, s.from);
        for (let o of i)
          o.line(this.view, s, n);
      } else if (s.widget)
        for (let o of i)
          o.widget(this.view, s);
    for (let s of i)
      s.finish();
    r && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(r) {
    let e = r.startState.facet(o8), t = r.state.facet(o8), n = r.docChanged || r.heightChanged || r.viewportChanged || !oi.eq(r.startState.facet(MS), r.state.facet(MS), r.view.viewport.from, r.view.viewport.to);
    if (e == t)
      for (let i of this.gutters)
        i.update(r) && (n = !0);
    else {
      n = !0;
      let i = [];
      for (let s of t) {
        let o = e.indexOf(s);
        o < 0 ? i.push(new kEe(this.view, s)) : (this.gutters[o].update(r), i.push(this.gutters[o]));
      }
      for (let s of this.gutters)
        s.dom.remove(), i.indexOf(s) < 0 && s.destroy();
      for (let s of i)
        this.dom.appendChild(s.dom);
      this.gutters = i;
    }
    return n;
  }
  destroy() {
    for (let r of this.gutters)
      r.destroy();
    this.dom.remove();
  }
}, {
  provide: (r) => st.scrollMargins.of((e) => {
    let t = e.plugin(r);
    return !t || t.gutters.length == 0 || !t.fixed ? null : e.textDirection == nr.LTR ? { left: t.dom.offsetWidth * e.scaleX } : { right: t.dom.offsetWidth * e.scaleX };
  })
});
function LEe(r) {
  return Array.isArray(r) ? r : [r];
}
function mT(r, e, t) {
  for (; r.value && r.from <= t; )
    r.from == t && e.push(r.value), r.next();
}
class HFt {
  constructor(e, t, n) {
    this.gutter = e, this.height = n, this.i = 0, this.cursor = oi.iter(e.markers, t.from);
  }
  addElement(e, t, n) {
    let { gutter: i } = this, s = (t.top - this.height) / e.scaleY, o = t.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new oHe(e, o, s, n);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(e, o, s, n);
    this.height = t.bottom, this.i++;
  }
  line(e, t, n) {
    let i = [];
    mT(this.cursor, i, t.from), n.length && (i = i.concat(n));
    let s = this.gutter.config.lineMarker(e, t, i);
    s && i.unshift(s);
    let o = this.gutter;
    i.length == 0 && !o.config.renderEmptyElements || this.addElement(e, t, i);
  }
  widget(e, t) {
    let n = this.gutter.config.widgetMarker(e, t.widget, t);
    n && this.addElement(e, t, [n]);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let t = e.elements.pop();
      e.dom.removeChild(t.dom), t.destroy();
    }
  }
}
class kEe {
  constructor(e, t) {
    this.view = e, this.config = t, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let n in t.domEventHandlers)
      this.dom.addEventListener(n, (i) => {
        let s = i.target, o;
        if (s != this.dom && this.dom.contains(s)) {
          for (; s.parentNode != this.dom; )
            s = s.parentNode;
          let l = s.getBoundingClientRect();
          o = (l.top + l.bottom) / 2;
        } else
          o = i.clientY;
        let a = e.lineBlockAtHeight(o - e.documentTop);
        t.domEventHandlers[n](e, a, i) && i.preventDefault();
      });
    this.markers = LEe(t.markers(e)), t.initialSpacer && (this.spacer = new oHe(e, 0, 0, [t.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let t = this.markers;
    if (this.markers = LEe(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let n = e.view.viewport;
    return !oi.eq(this.markers, t, n.from, n.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class oHe {
  constructor(e, t, n, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, t, n, i);
  }
  update(e, t, n, i) {
    this.height != t && (this.height = t, this.dom.style.height = t + "px"), this.above != n && (this.dom.style.marginTop = (this.above = n) ? n + "px" : ""), BFt(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, t) {
    let n = "cm-gutterElement", i = this.dom.firstChild;
    for (let s = 0, o = 0; ; ) {
      let a = o, l = s < t.length ? t[s++] : null, c = !1;
      if (l) {
        let d = l.elementClass;
        d && (n += " " + d);
        for (let u = o; u < this.markers.length; u++)
          if (this.markers[u].compare(l)) {
            a = u, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; o < a; ) {
        let d = this.markers[o++];
        if (d.toDOM) {
          d.destroy(i);
          let u = i.nextSibling;
          i.remove(), i = u;
        }
      }
      if (!l)
        break;
      l.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), c && o++;
    }
    this.dom.className = n, this.markers = t;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function BFt(r, e) {
  if (r.length != e.length)
    return !1;
  for (let t = 0; t < r.length; t++)
    if (!r[t].compare(e[t]))
      return !1;
  return !0;
}
const PFt = /* @__PURE__ */ bt.define(), dp = /* @__PURE__ */ bt.define({
  combine(r) {
    return sC(r, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, t) {
        let n = Object.assign({}, e);
        for (let i in t) {
          let s = n[i], o = t[i];
          n[i] = s ? (a, l, c) => s(a, l, c) || o(a, l, c) : o;
        }
        return n;
      }
    });
  }
});
class DS extends Of {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function LS(r, e) {
  return r.state.facet(dp).formatNumber(e, r.state);
}
const FFt = /* @__PURE__ */ o8.compute([dp], (r) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(PFt);
  },
  lineMarker(e, t, n) {
    return n.some((i) => i.toDOM) ? null : new DS(LS(e, e.state.doc.lineAt(t.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (e) => e.startState.facet(dp) != e.state.facet(dp),
  initialSpacer(e) {
    return new DS(LS(e, NEe(e.state.doc.lines)));
  },
  updateSpacer(e, t) {
    let n = LS(t.view, NEe(t.view.state.doc.lines));
    return n == e.number ? e : new DS(n);
  },
  domEventHandlers: r.facet(dp).domEventHandlers
}));
function aHe(r = {}) {
  return [
    dp.of(r),
    RFt(),
    FFt
  ];
}
function NEe(r) {
  let e = 9;
  for (; e < r; )
    e = e * 10 + 9;
  return e;
}
var kS;
const up = /* @__PURE__ */ new Xt();
function zFt(r) {
  return bt.define({
    combine: r ? (e) => e.concat(r) : void 0
  });
}
const WFt = /* @__PURE__ */ new Xt();
class Ul {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, t, n = [], i = "") {
    this.data = e, this.name = i, jn.prototype.hasOwnProperty("tree") || Object.defineProperty(jn.prototype, "tree", { get() {
      return Zr(this);
    } }), this.parser = t, this.extension = [
      Ig.of(this),
      jn.languageData.of((s, o, a) => {
        let l = TEe(s, o, a), c = l.type.prop(up);
        if (!c)
          return [];
        let d = s.facet(c), u = l.type.prop(WFt);
        if (u) {
          let f = l.resolve(o - l.from, a);
          for (let p of u)
            if (p.test(f, s)) {
              let g = s.facet(p.facet);
              return p.type == "replace" ? g : g.concat(d);
            }
        }
        return d;
      })
    ].concat(n);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, t, n = -1) {
    return TEe(e, t, n).type.prop(up) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let t = e.facet(Ig);
    if (t?.data == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!t || !t.allowsNesting)
      return [];
    let n = [], i = (s, o) => {
      if (s.prop(up) == this.data) {
        n.push({ from: o, to: o + s.length });
        return;
      }
      let a = s.prop(Xt.mounted);
      if (a) {
        if (a.tree.prop(up) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              n.push({ from: l.from + o, to: l.to + o });
          else
            n.push({ from: o, to: o + s.length });
          return;
        } else if (a.overlay) {
          let l = n.length;
          if (i(a.tree, a.overlay[0].from + o), n.length > l)
            return;
        }
      }
      for (let l = 0; l < s.children.length; l++) {
        let c = s.children[l];
        c instanceof ci && i(c, s.positions[l] + o);
      }
    };
    return i(Zr(e), 0), n;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
Ul.setState = /* @__PURE__ */ Qn.define();
function TEe(r, e, t) {
  let n = r.facet(Ig), i = Zr(r).topNode;
  if (!n || n.allowsNesting)
    for (let s = i; s; s = s.enter(e, t, Vi.ExcludeBuffers))
      s.type.isTop && (i = s);
  return i;
}
class H4 extends Ul {
  constructor(e, t, n) {
    super(e, t, [], n), this.parser = t;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let t = zFt(e.languageData);
    return new H4(t, e.parser.configure({
      props: [up.add((n) => n.isTop ? t : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, t) {
    return new H4(this.data, this.parser.configure(e), t || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function Zr(r) {
  let e = r.field(Ul.state, !1);
  return e ? e.tree : ci.empty;
}
class jFt {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, t) {
    let n = this.cursorPos - this.string.length;
    return e < n || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - n, t - n);
  }
}
let rA = null;
class Pb {
  constructor(e, t, n = [], i, s, o, a, l) {
    this.parser = e, this.state = t, this.fragments = n, this.tree = i, this.treeLen = s, this.viewport = o, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, t, n) {
    return new Pb(e, t, [], ci.empty, 0, n, [], null);
  }
  startParse() {
    return this.parser.startParse(new jFt(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, t) {
    return t != null && t >= this.state.doc.length && (t = void 0), this.tree != ci.empty && this.isDone(t ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var n;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), t != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > t) && t < this.state.doc.length && this.parse.stopAt(t); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(Td.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (n = this.parse.stoppedAt) !== null && n !== void 0 ? n : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (t ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, t;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(t = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(Td.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let t = rA;
    rA = this;
    try {
      return e();
    } finally {
      rA = t;
    }
  }
  withoutTempSkipped(e) {
    for (let t; t = this.tempSkipped.pop(); )
      e = IEe(e, t.from, t.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, t) {
    let { fragments: n, tree: i, treeLen: s, viewport: o, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, d, u, f) => l.push({ fromA: c, toA: d, fromB: u, toB: f })), n = Td.applyChanges(n, l), i = ci.empty, s = 0, o = { from: e.mapPos(o.from, -1), to: e.mapPos(o.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let d = e.mapPos(c.from, 1), u = e.mapPos(c.to, -1);
          d < u && a.push({ from: d, to: u });
        }
      }
    }
    return new Pb(this.parser, t, n, i, s, o, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let t = this.skipped.length;
    for (let n = 0; n < this.skipped.length; n++) {
      let { from: i, to: s } = this.skipped[n];
      i < e.to && s > e.from && (this.fragments = IEe(this.fragments, i, s), this.skipped.splice(n--, 1));
    }
    return this.skipped.length >= t ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, t) {
    this.skipped.push({ from: e, to: t });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends HV {
      createParse(t, n, i) {
        let s = i[0].from, o = i[i.length - 1].to;
        return {
          parsedPos: s,
          advance() {
            let l = rA;
            if (l) {
              for (let c of i)
                l.tempSkipped.push(c);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = o, new ci(jr.none, [], [], o - s);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let t = this.fragments;
    return this.treeLen >= e && t.length && t[0].from == 0 && t[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return rA;
  }
}
function IEe(r, e, t) {
  return Td.applyChanges(r, [{ fromA: e, toA: t, fromB: e, toB: t }]);
}
class Tg {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let t = this.context.changes(e.changes, e.state), n = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), t.viewport.to);
    return t.work(20, n) || t.takeTree(), new Tg(t);
  }
  static init(e) {
    let t = Math.min(3e3, e.doc.length), n = Pb.create(e.facet(Ig).parser, e, { from: 0, to: t });
    return n.work(20, t) || n.takeTree(), new Tg(n);
  }
}
Ul.state = /* @__PURE__ */ ka.define({
  create: Tg.init,
  update(r, e) {
    for (let t of e.effects)
      if (t.is(Ul.setState))
        return t.value;
    return e.startState.facet(Ig) != e.state.facet(Ig) ? Tg.init(e.state) : r.apply(e);
  }
});
let lHe = (r) => {
  let e = setTimeout(
    () => r(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (lHe = (r) => {
  let e = -1, t = setTimeout(
    () => {
      e = requestIdleCallback(r, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(t) : cancelIdleCallback(e);
});
const NS = typeof navigator < "u" && (!((kS = navigator.scheduling) === null || kS === void 0) && kS.isInputPending) ? () => navigator.scheduling.isInputPending() : null, ZFt = /* @__PURE__ */ Ca.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let t = this.view.state.field(Ul.state).context;
    (t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, t = e.field(Ul.state);
    (t.tree != t.context.tree || !t.context.isDone(e.doc.length)) && (this.working = lHe(this.work));
  }
  work(e) {
    this.working = null;
    let t = Date.now();
    if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: n, viewport: { to: i } } = this.view, s = n.field(Ul.state);
    if (s.tree == s.context.tree && s.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !NS ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = s.context.treeLen < i && n.doc.length > i + 1e3, l = s.context.work(() => NS && NS() || Date.now() > o, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - t, (l || this.chunkBudget <= 0) && (s.context.takeTree(), this.view.dispatch({ effects: Ul.setState.of(new Tg(s.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(s.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((t) => va(this.view.state, t)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), Ig = /* @__PURE__ */ bt.define({
  combine(r) {
    return r.length ? r[0] : null;
  },
  enables: (r) => [
    Ul.state,
    ZFt,
    st.contentAttributes.compute([r], (e) => {
      let t = e.facet(r);
      return t && t.name ? { "data-language": t.name } : {};
    })
  ]
});
class cHe {
  /**
  Create a language support object.
  */
  constructor(e, t = []) {
    this.language = e, this.support = t, this.extension = [e, t];
  }
}
const UFt = /* @__PURE__ */ bt.define(), hC = /* @__PURE__ */ bt.define({
  combine: (r) => {
    if (!r.length)
      return "  ";
    let e = r[0];
    if (!e || /\S/.test(e) || Array.from(e).some((t) => t != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(r[0]));
    return e;
  }
});
function Fb(r) {
  let e = r.facet(hC);
  return e.charCodeAt(0) == 9 ? r.tabSize * e.length : e.length;
}
function B4(r, e) {
  let t = "", n = r.tabSize, i = r.facet(hC)[0];
  if (i == "	") {
    for (; e >= n; )
      t += "	", e -= n;
    i = " ";
  }
  for (let s = 0; s < e; s++)
    t += i;
  return t;
}
function $V(r, e) {
  r instanceof jn && (r = new dC(r));
  for (let n of r.state.facet(UFt)) {
    let i = n(r, e);
    if (i !== void 0)
      return i;
  }
  let t = Zr(r.state);
  return t.length >= e ? qFt(r, t, e) : null;
}
class dC {
  /**
  Create an indent context.
  */
  constructor(e, t = {}) {
    this.state = e, this.options = t, this.unit = Fb(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, t = 1) {
    let n = this.state.doc.lineAt(e), { simulateBreak: i, simulateDoubleBreak: s } = this.options;
    return i != null && i >= n.from && i <= n.to ? s && i == e ? { text: "", from: e } : (t < 0 ? i < e : i <= e) ? { text: n.text.slice(i - n.from), from: i } : { text: n.text.slice(0, i - n.from), from: n.from } : n;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, t = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: n, from: i } = this.lineAt(e, t);
    return n.slice(e - i, Math.min(n.length, e + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(e, t = 1) {
    let { text: n, from: i } = this.lineAt(e, t), s = this.countColumn(n, e - i), o = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o > -1 && (s += o - this.countColumn(n, n.search(/\S|$/))), s;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, t = e.length) {
    return oC(e, this.state.tabSize, t);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, t = 1) {
    let { text: n, from: i } = this.lineAt(e, t), s = this.options.overrideIndentation;
    if (s) {
      let o = s(i);
      if (o > -1)
        return o;
    }
    return this.countColumn(n, n.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const hHe = /* @__PURE__ */ new Xt();
function qFt(r, e, t) {
  let n = e.resolveStack(t), i = n.node.enterUnfinishedNodesBefore(t);
  if (i != n.node) {
    let s = [];
    for (let o = i; o != n.node; o = o.parent)
      s.push(o);
    for (let o = s.length - 1; o >= 0; o--)
      n = { node: s[o], next: n };
  }
  return dHe(n, r, t);
}
function dHe(r, e, t) {
  for (let n = r; n; n = n.next) {
    let i = QFt(n.node);
    if (i)
      return i(eH.create(e, t, n));
  }
  return 0;
}
function GFt(r) {
  return r.pos == r.options.simulateBreak && r.options.simulateDoubleBreak;
}
function QFt(r) {
  let e = r.type.prop(hHe);
  if (e)
    return e;
  let t = r.firstChild, n;
  if (t && (n = t.type.prop(Xt.closedBy))) {
    let i = r.lastChild, s = i && n.indexOf(i.name) > -1;
    return (o) => uHe(o, !0, 1, void 0, s && !GFt(o) ? i.from : void 0);
  }
  return r.parent == null ? KFt : null;
}
function KFt() {
  return 0;
}
class eH extends dC {
  constructor(e, t, n) {
    super(e.state, e.options), this.base = e, this.pos = t, this.context = n;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, t, n) {
    return new eH(e, t, n);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let t = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let n = e.resolve(t.from);
      for (; n.parent && n.parent.from == n.from; )
        n = n.parent;
      if (YFt(n, e))
        break;
      t = this.state.doc.lineAt(n.from);
    }
    return this.lineIndent(t.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return dHe(this.context.next, this.base, this.pos);
  }
}
function YFt(r, e) {
  for (let t = e; t; t = t.parent)
    if (r == t)
      return !0;
  return !1;
}
function XFt(r) {
  let e = r.node, t = e.childAfter(e.from), n = e.lastChild;
  if (!t)
    return null;
  let i = r.options.simulateBreak, s = r.state.doc.lineAt(t.from), o = i == null || i <= s.from ? s.to : Math.min(s.to, i);
  for (let a = t.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == n)
      return null;
    if (!l.type.isSkipped)
      return l.from < o ? t : null;
    a = l.to;
  }
}
function OEe({ closing: r, align: e = !0, units: t = 1 }) {
  return (n) => uHe(n, e, t, r);
}
function uHe(r, e, t, n, i) {
  let s = r.textAfter, o = s.match(/^\s*/)[0].length, a = n && s.slice(o, o + n.length) == n || i == r.pos + o, l = e ? XFt(r) : null;
  return l ? a ? r.column(l.from) : r.column(l.to) : r.baseIndent + (a ? 0 : r.unit * t);
}
function TS({ except: r, units: e = 1 } = {}) {
  return (t) => {
    let n = r && r.test(t.textAfter);
    return t.baseIndent + (n ? 0 : e * t.unit);
  };
}
const JFt = 200;
function fHe() {
  return jn.transactionFilter.of((r) => {
    if (!r.docChanged || !r.isUserEvent("input.type") && !r.isUserEvent("input.complete"))
      return r;
    let e = r.startState.languageDataAt("indentOnInput", r.startState.selection.main.head);
    if (!e.length)
      return r;
    let t = r.newDoc, { head: n } = r.newSelection.main, i = t.lineAt(n);
    if (n > i.from + JFt)
      return r;
    let s = t.sliceString(i.from, n);
    if (!e.some((c) => c.test(s)))
      return r;
    let { state: o } = r, a = -1, l = [];
    for (let { head: c } of o.selection.ranges) {
      let d = o.doc.lineAt(c);
      if (d.from == a)
        continue;
      a = d.from;
      let u = $V(o, d.from);
      if (u == null)
        continue;
      let f = /^\s*/.exec(d.text)[0], p = B4(o, u);
      f != p && l.push({ from: d.from, to: d.from + f.length, insert: p });
    }
    return l.length ? [r, { changes: l, sequential: !0 }] : r;
  });
}
const pHe = /* @__PURE__ */ new Xt();
function w3(r) {
  let e = r.firstChild, t = r.lastChild;
  return e && e.to < t.from ? { from: e.to, to: t.type.isError ? r.to : t.from } : null;
}
class f2 {
  constructor(e, t) {
    this.specs = e;
    let n;
    function i(a) {
      let l = C1.newName();
      return (n || (n = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const s = typeof t.all == "string" ? t.all : t.all ? i(t.all) : void 0, o = t.scope;
    this.scope = o instanceof Ul ? (a) => a.prop(up) == o.data : o ? (a) => a == o : void 0, this.style = IRe(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: s
    }).style, this.module = n ? new C1(n) : null, this.themeType = t.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, t) {
    return new f2(e, t || {});
  }
}
const AT = /* @__PURE__ */ bt.define(), $Ft = /* @__PURE__ */ bt.define({
  combine(r) {
    return r.length ? [r[0]] : null;
  }
});
function IS(r) {
  let e = r.facet(AT);
  return e.length ? e : r.facet($Ft);
}
function uC(r, e) {
  let t = [tzt], n;
  return r instanceof f2 && (r.module && t.push(st.styleModule.of(r.module)), n = r.themeType), n ? t.push(AT.computeN([st.darkTheme], (i) => i.facet(st.darkTheme) == (n == "dark") ? [r] : [])) : t.push(AT.of(r)), t;
}
class ezt {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Zr(e.state), this.decorations = this.buildDeco(e, IS(e.state));
  }
  update(e) {
    let t = Zr(e.state), n = IS(e.state), i = n != IS(e.startState);
    t.length < e.view.viewport.to && !i && t.type == this.tree.type ? this.decorations = this.decorations.map(e.changes) : (t != this.tree || e.viewportChanged || i) && (this.tree = t, this.decorations = this.buildDeco(e.view, n));
  }
  buildDeco(e, t) {
    if (!t || !this.tree.length)
      return pi.none;
    let n = new N4();
    for (let { from: i, to: s } of e.visibleRanges)
      mHt(this.tree, t, (o, a, l) => {
        n.add(o, a, this.markCache[l] || (this.markCache[l] = pi.mark({ class: l })));
      }, i, s);
    return n.finish();
  }
}
const tzt = /* @__PURE__ */ vm.high(/* @__PURE__ */ Ca.fromClass(ezt, {
  decorations: (r) => r.decorations
})), nzt = /* @__PURE__ */ st.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), gHe = 1e4, mHe = "()[]{}", AHe = /* @__PURE__ */ bt.define({
  combine(r) {
    return sC(r, {
      afterCursor: !0,
      brackets: mHe,
      maxScanDistance: gHe,
      renderMatch: szt
    });
  }
}), izt = /* @__PURE__ */ pi.mark({ class: "cm-matchingBracket" }), rzt = /* @__PURE__ */ pi.mark({ class: "cm-nonmatchingBracket" });
function szt(r) {
  let e = [], t = r.matched ? izt : rzt;
  return e.push(t.range(r.start.from, r.start.to)), r.end && e.push(t.range(r.end.from, r.end.to)), e;
}
const ozt = /* @__PURE__ */ ka.define({
  create() {
    return pi.none;
  },
  update(r, e) {
    if (!e.docChanged && !e.selection)
      return r;
    let t = [], n = e.state.facet(AHe);
    for (let i of e.state.selection.ranges) {
      if (!i.empty)
        continue;
      let s = eh(e.state, i.head, -1, n) || i.head > 0 && eh(e.state, i.head - 1, 1, n) || n.afterCursor && (eh(e.state, i.head, 1, n) || i.head < e.state.doc.length && eh(e.state, i.head + 1, -1, n));
      s && (t = t.concat(n.renderMatch(s, e.state)));
    }
    return pi.set(t, !0);
  },
  provide: (r) => st.decorations.from(r)
}), azt = [
  ozt,
  nzt
];
function wHe(r = {}) {
  return [AHe.of(r), azt];
}
const lzt = /* @__PURE__ */ new Xt();
function wT(r, e, t) {
  let n = r.prop(e < 0 ? Xt.openedBy : Xt.closedBy);
  if (n)
    return n;
  if (r.name.length == 1) {
    let i = t.indexOf(r.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0))
      return [t[i + e]];
  }
  return null;
}
function vT(r) {
  let e = r.type.prop(lzt);
  return e ? e(r.node) : r;
}
function eh(r, e, t, n = {}) {
  let i = n.maxScanDistance || gHe, s = n.brackets || mHe, o = Zr(r), a = o.resolveInner(e, t);
  for (let l = a; l; l = l.parent) {
    let c = wT(l.type, t, s);
    if (c && l.from < l.to) {
      let d = vT(l);
      if (d && (t > 0 ? e >= d.from && e < d.to : e > d.from && e <= d.to))
        return czt(r, e, t, l, d, c, s);
    }
  }
  return hzt(r, e, t, o, a.type, i, s);
}
function czt(r, e, t, n, i, s, o) {
  let a = n.parent, l = { from: i.from, to: i.to }, c = 0, d = a?.cursor();
  if (d && (t < 0 ? d.childBefore(n.from) : d.childAfter(n.to)))
    do
      if (t < 0 ? d.to <= n.from : d.from >= n.to) {
        if (c == 0 && s.indexOf(d.type.name) > -1 && d.from < d.to) {
          let u = vT(d);
          return { start: l, end: u ? { from: u.from, to: u.to } : void 0, matched: !0 };
        } else if (wT(d.type, t, o))
          c++;
        else if (wT(d.type, -t, o)) {
          if (c == 0) {
            let u = vT(d);
            return {
              start: l,
              end: u && u.from < u.to ? { from: u.from, to: u.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (t < 0 ? d.prevSibling() : d.nextSibling());
  return { start: l, matched: !1 };
}
function hzt(r, e, t, n, i, s, o) {
  let a = t < 0 ? r.sliceDoc(e - 1, e) : r.sliceDoc(e, e + 1), l = o.indexOf(a);
  if (l < 0 || l % 2 == 0 != t > 0)
    return null;
  let c = { from: t < 0 ? e - 1 : e, to: t > 0 ? e + 1 : e }, d = r.doc.iterRange(e, t > 0 ? r.doc.length : 0), u = 0;
  for (let f = 0; !d.next().done && f <= s; ) {
    let p = d.value;
    t < 0 && (f += p.length);
    let g = e + f * t;
    for (let m = t > 0 ? 0 : p.length - 1, A = t > 0 ? p.length : -1; m != A; m += t) {
      let w = o.indexOf(p[m]);
      if (!(w < 0 || n.resolveInner(g + m, 1).type != i))
        if (w % 2 == 0 == t > 0)
          u++;
        else {
          if (u == 1)
            return { start: c, end: { from: g + m, to: g + m + 1 }, matched: w >> 1 == l >> 1 };
          u--;
        }
    }
    t > 0 && (f += p.length);
  }
  return d.done ? { start: c, matched: !1 } : null;
}
const dzt = /* @__PURE__ */ Object.create(null), REe = [jr.none], VEe = [], HEe = /* @__PURE__ */ Object.create(null), uzt = /* @__PURE__ */ Object.create(null);
for (let [r, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  uzt[r] = /* @__PURE__ */ fzt(dzt, e);
function OS(r, e) {
  VEe.indexOf(r) > -1 || (VEe.push(r), console.warn(e));
}
function fzt(r, e) {
  let t = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let d = r[c] || J[c];
      d ? typeof d == "function" ? l.length ? l = l.map(d) : OS(c, `Modifier ${c} used at start of tag`) : l.length ? OS(c, `Tag ${c} used as modifier`) : l = Array.isArray(d) ? d : [d] : OS(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l)
      t.push(c);
  }
  if (!t.length)
    return 0;
  let n = e.replace(/ /g, "_"), i = n + " " + t.map((a) => a.id), s = HEe[i];
  if (s)
    return s.id;
  let o = HEe[i] = jr.define({
    id: REe.length,
    name: n,
    props: [Qw({ [n]: t })]
  });
  return REe.push(o), o.id;
}
nr.RTL, nr.LTR;
class vHe {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, t, n) {
    this.state = e, this.pos = t, this.explicit = n, this.abortListeners = [];
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let t = Zr(this.state).resolveInner(this.pos, -1);
    for (; t && e.indexOf(t.name) < 0; )
      t = t.parent;
    return t ? {
      from: t.from,
      to: this.pos,
      text: this.state.sliceDoc(t.from, this.pos),
      type: t.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let t = this.state.doc.lineAt(this.pos), n = Math.max(t.from, this.pos - 250), i = t.text.slice(n - t.from, this.pos - t.from), s = i.search(bHe(e, !1));
    return s < 0 ? null : { from: n + s, to: this.pos, text: i.slice(s) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  */
  addEventListener(e, t) {
    e == "abort" && this.abortListeners && this.abortListeners.push(t);
  }
}
function BEe(r) {
  let e = Object.keys(r).join(""), t = /\w/.test(e);
  return t && (e = e.replace(/\w/g, "")), `[${t ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function pzt(r) {
  let e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of r) {
    e[i[0]] = !0;
    for (let s = 1; s < i.length; s++)
      t[i[s]] = !0;
  }
  let n = BEe(e) + BEe(t) + "*$";
  return [new RegExp("^" + n), new RegExp(n)];
}
function tH(r) {
  let e = r.map((i) => typeof i == "string" ? { label: i } : i), [t, n] = e.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : pzt(e);
  return (i) => {
    let s = i.matchBefore(n);
    return s || i.explicit ? { from: s ? s.from : i.pos, options: e, validFor: t } : null;
  };
}
class PEe {
  constructor(e, t, n, i) {
    this.completion = e, this.source = t, this.match = n, this.score = i;
  }
}
function i1(r) {
  return r.selection.main.from;
}
function bHe(r, e) {
  var t;
  let { source: n } = r, i = e && n[0] != "^", s = n[n.length - 1] != "$";
  return !i && !s ? r : new RegExp(`${i ? "^" : ""}(?:${n})${s ? "$" : ""}`, (t = r.flags) !== null && t !== void 0 ? t : r.ignoreCase ? "i" : "");
}
const nH = /* @__PURE__ */ u2.define();
function gzt(r, e, t, n) {
  let { main: i } = r.selection, s = t - i.from, o = n - i.from;
  return Object.assign(Object.assign({}, r.changeByRange((a) => a != i && t != n && r.sliceDoc(a.from + s, a.from + o) != r.sliceDoc(t, n) ? { range: a } : {
    changes: { from: a.from + s, to: n == i.from ? a.to : a.from + o, insert: e },
    range: Be.cursor(a.from + s + e.length)
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const FEe = /* @__PURE__ */ new WeakMap();
function mzt(r) {
  if (!Array.isArray(r))
    return r;
  let e = FEe.get(r);
  return e || FEe.set(r, e = tH(r)), e;
}
const zb = /* @__PURE__ */ Qn.define(), P4 = /* @__PURE__ */ Qn.define();
class Azt {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let t = 0; t < e.length; ) {
      let n = ta(e, t), i = Kc(n);
      this.chars.push(n);
      let s = e.slice(t, t + i), o = s.toUpperCase();
      this.folded.push(ta(o == s ? s.toLowerCase() : o, 0)), t += i;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, t) {
    return this.score = e, this.matched = t, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return null;
    let { chars: t, folded: n, any: i, precise: s, byWord: o } = this;
    if (t.length == 1) {
      let v = ta(e, 0), y = Kc(v), _ = y == e.length ? 0 : -100;
      if (v != t[0]) if (v == n[0])
        _ += -200;
      else
        return null;
      return this.ret(_, [0, y]);
    }
    let a = e.indexOf(this.pattern);
    if (a == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let l = t.length, c = 0;
    if (a < 0) {
      for (let v = 0, y = Math.min(e.length, 200); v < y && c < l; ) {
        let _ = ta(e, v);
        (_ == t[c] || _ == n[c]) && (i[c++] = v), v += Kc(_);
      }
      if (c < l)
        return null;
    }
    let d = 0, u = 0, f = !1, p = 0, g = -1, m = -1, A = /[a-z]/.test(e), w = !0;
    for (let v = 0, y = Math.min(e.length, 200), _ = 0; v < y && u < l; ) {
      let S = ta(e, v);
      a < 0 && (d < l && S == t[d] && (s[d++] = v), p < l && (S == t[p] || S == n[p] ? (p == 0 && (g = v), m = v + 1, p++) : p = 0));
      let D, M = S < 255 ? S >= 48 && S <= 57 || S >= 97 && S <= 122 ? 2 : S >= 65 && S <= 90 ? 1 : 0 : (D = XRe(S)) != D.toLowerCase() ? 1 : D != D.toUpperCase() ? 2 : 0;
      (!v || M == 1 && A || _ == 0 && M != 0) && (t[u] == S || n[u] == S && (f = !0) ? o[u++] = v : o.length && (w = !1)), _ = M, v += Kc(S);
    }
    return u == l && o[0] == 0 && w ? this.result(-100 + (f ? -200 : 0), o, e) : p == l && g == 0 ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m]) : a > -1 ? this.ret(-700 - e.length, [a, a + this.pattern.length]) : p == l ? this.ret(-900 - e.length, [g, m]) : u == l ? this.result(-100 + (f ? -200 : 0) + -700 + (w ? 0 : -1100), o, e) : t.length == 2 ? null : this.result((i[0] ? -700 : 0) + -200 + -1100, i, e);
  }
  result(e, t, n) {
    let i = [], s = 0;
    for (let o of t) {
      let a = o + (this.astral ? Kc(ta(n, o)) : 1);
      s && i[s - 1] == o ? i[s - 1] = a : (i[s++] = o, i[s++] = a);
    }
    return this.ret(e - n.length, i);
  }
}
class wzt {
  constructor(e) {
    this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
  }
  match(e) {
    if (e.length < this.pattern.length)
      return null;
    let t = e.slice(0, this.pattern.length), n = t == this.pattern ? 0 : t.toLowerCase() == this.folded ? -200 : null;
    return n == null ? null : (this.matched = [0, t.length], this.score = n + (e.length == this.pattern.length ? 0 : -100), this);
  }
}
const gs = /* @__PURE__ */ bt.define({
  combine(r) {
    return sC(r, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: vzt,
      filterStrict: !1,
      compareCompletions: (e, t) => e.label.localeCompare(t.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, t) => e && t,
      closeOnBlur: (e, t) => e && t,
      icons: (e, t) => e && t,
      tooltipClass: (e, t) => (n) => zEe(e(n), t(n)),
      optionClass: (e, t) => (n) => zEe(e(n), t(n)),
      addToOptions: (e, t) => e.concat(t),
      filterStrict: (e, t) => e || t
    });
  }
});
function zEe(r, e) {
  return r ? e ? r + " " + e : r : e;
}
function vzt(r, e, t, n, i, s) {
  let o = r.textDirection == nr.RTL, a = o, l = !1, c = "top", d, u, f = e.left - i.left, p = i.right - e.right, g = n.right - n.left, m = n.bottom - n.top;
  if (a && f < Math.min(g, p) ? a = !1 : !a && p < Math.min(g, f) && (a = !0), g <= (a ? f : p))
    d = Math.max(i.top, Math.min(t.top, i.bottom - m)) - e.top, u = Math.min(400, a ? f : p);
  else {
    l = !0, u = Math.min(
      400,
      (o ? e.right : i.right - e.left) - 30
      /* Info.Margin */
    );
    let v = i.bottom - e.bottom;
    v >= m || v > e.top ? d = t.bottom - e.top : (c = "bottom", d = e.bottom - t.top);
  }
  let A = (e.bottom - e.top) / s.offsetHeight, w = (e.right - e.left) / s.offsetWidth;
  return {
    style: `${c}: ${d / A}px; max-width: ${u / w}px`,
    class: "cm-completionInfo-" + (l ? o ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function bzt(r) {
  let e = r.addToOptions.slice();
  return r.icons && e.push({
    render(t) {
      let n = document.createElement("div");
      return n.classList.add("cm-completionIcon"), t.type && n.classList.add(...t.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), n.setAttribute("aria-hidden", "true"), n;
    },
    position: 20
  }), e.push({
    render(t, n, i, s) {
      let o = document.createElement("span");
      o.className = "cm-completionLabel";
      let a = t.displayLabel || t.label, l = 0;
      for (let c = 0; c < s.length; ) {
        let d = s[c++], u = s[c++];
        d > l && o.appendChild(document.createTextNode(a.slice(l, d)));
        let f = o.appendChild(document.createElement("span"));
        f.appendChild(document.createTextNode(a.slice(d, u))), f.className = "cm-completionMatchedText", l = u;
      }
      return l < a.length && o.appendChild(document.createTextNode(a.slice(l))), o;
    },
    position: 50
  }, {
    render(t) {
      if (!t.detail)
        return null;
      let n = document.createElement("span");
      return n.className = "cm-completionDetail", n.textContent = t.detail, n;
    },
    position: 80
  }), e.sort((t, n) => t.position - n.position).map((t) => t.render);
}
function RS(r, e, t) {
  if (r <= t)
    return { from: 0, to: r };
  if (e < 0 && (e = 0), e <= r >> 1) {
    let i = Math.floor(e / t);
    return { from: i * t, to: (i + 1) * t };
  }
  let n = Math.floor((r - e) / t);
  return { from: r - (n + 1) * t, to: r - n * t };
}
class yzt {
  constructor(e, t, n) {
    this.view = e, this.stateField = t, this.applyCompletion = n, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (l) => this.placeInfo(l),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = e.state.field(t), { options: s, selected: o } = i.open, a = e.state.facet(gs);
    this.optionContent = bzt(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = RS(s.length, o, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (l) => {
      let { options: c } = e.state.field(t).open;
      for (let d = l.target, u; d && d != this.dom; d = d.parentNode)
        if (d.nodeName == "LI" && (u = /-(\d+)$/.exec(d.id)) && +u[1] < c.length) {
          this.applyCompletion(e, c[+u[1]]), l.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (l) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(gs).closeOnBlur && l.relatedTarget != e.contentDOM && e.dispatch({ effects: P4.of(null) });
    }), this.showOptions(s, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, t) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var t;
    let n = e.state.field(this.stateField), i = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), n != i) {
      let { options: s, selected: o, disabled: a } = n.open;
      (!i.open || i.open.options != s) && (this.range = RS(s.length, o, e.state.facet(gs).maxRenderedOptions), this.showOptions(s, n.id)), this.updateSel(), a != ((t = i.open) === null || t === void 0 ? void 0 : t.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(e) {
    let t = this.tooltipClass(e);
    if (t != this.currentClass) {
      for (let n of this.currentClass.split(" "))
        n && this.dom.classList.remove(n);
      for (let n of t.split(" "))
        n && this.dom.classList.add(n);
      this.currentClass = t;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), t = e.open;
    if ((t.selected > -1 && t.selected < this.range.from || t.selected >= this.range.to) && (this.range = RS(t.options.length, t.selected, this.view.state.facet(gs).maxRenderedOptions), this.showOptions(t.options, e.id)), this.updateSelectedOption(t.selected)) {
      this.destroyInfo();
      let { completion: n } = t.options[t.selected], { info: i } = n;
      if (!i)
        return;
      let s = typeof i == "string" ? document.createTextNode(i) : i(n);
      if (!s)
        return;
      "then" in s ? s.then((o) => {
        o && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(o, n);
      }).catch((o) => va(this.view.state, o, "completion info")) : this.addInfoPane(s, n);
    }
  }
  addInfoPane(e, t) {
    this.destroyInfo();
    let n = this.info = document.createElement("div");
    if (n.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      n.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: i, destroy: s } = e;
      n.appendChild(i), this.infoDestroy = s || null;
    }
    this.dom.appendChild(n), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let t = null;
    for (let n = this.list.firstChild, i = this.range.from; n; n = n.nextSibling, i++)
      n.nodeName != "LI" || !n.id ? i-- : i == e ? n.hasAttribute("aria-selected") || (n.setAttribute("aria-selected", "true"), t = n) : n.hasAttribute("aria-selected") && n.removeAttribute("aria-selected");
    return t && Ezt(this.list, t), t;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let t = this.dom.getBoundingClientRect(), n = this.info.getBoundingClientRect(), i = e.getBoundingClientRect(), s = this.space;
    if (!s) {
      let o = this.dom.ownerDocument.defaultView || window;
      s = { left: 0, top: 0, right: o.innerWidth, bottom: o.innerHeight };
    }
    return i.top > Math.min(s.bottom, t.bottom) - 10 || i.bottom < Math.max(s.top, t.top) + 10 ? null : this.view.state.facet(gs).positionInfo(this.view, t, i, n, s, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, t, n) {
    const i = document.createElement("ul");
    i.id = t, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let s = null;
    for (let o = n.from; o < n.to; o++) {
      let { completion: a, match: l } = e[o], { section: c } = a;
      if (c) {
        let f = typeof c == "string" ? c : c.name;
        if (f != s && (o > n.from || n.from == 0))
          if (s = f, typeof c != "string" && c.header)
            i.appendChild(c.header(c));
          else {
            let p = i.appendChild(document.createElement("completion-section"));
            p.textContent = f;
          }
      }
      const d = i.appendChild(document.createElement("li"));
      d.id = t + "-" + o, d.setAttribute("role", "option");
      let u = this.optionClass(a);
      u && (d.className = u);
      for (let f of this.optionContent) {
        let p = f(a, this.view.state, this.view, l);
        p && d.appendChild(p);
      }
    }
    return n.from && i.classList.add("cm-completionListIncompleteTop"), n.to < e.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function Czt(r, e) {
  return (t) => new yzt(t, r, e);
}
function Ezt(r, e) {
  let t = r.getBoundingClientRect(), n = e.getBoundingClientRect(), i = t.height / r.offsetHeight;
  n.top < t.top ? r.scrollTop -= (t.top - n.top) / i : n.bottom > t.bottom && (r.scrollTop += (n.bottom - t.bottom) / i);
}
function WEe(r) {
  return (r.boost || 0) * 100 + (r.apply ? 10 : 0) + (r.info ? 5 : 0) + (r.type ? 1 : 0);
}
function _zt(r, e) {
  let t = [], n = null, i = (c) => {
    t.push(c);
    let { section: d } = c.completion;
    if (d) {
      n || (n = []);
      let u = typeof d == "string" ? d : d.name;
      n.some((f) => f.name == u) || n.push(typeof d == "string" ? { name: u } : d);
    }
  }, s = e.facet(gs);
  for (let c of r)
    if (c.hasResult()) {
      let d = c.result.getMatch;
      if (c.result.filter === !1)
        for (let u of c.result.options)
          i(new PEe(u, c.source, d ? d(u) : [], 1e9 - t.length));
      else {
        let u = e.sliceDoc(c.from, c.to), f, p = s.filterStrict ? new wzt(u) : new Azt(u);
        for (let g of c.result.options)
          if (f = p.match(g.label)) {
            let m = g.displayLabel ? d ? d(g, f.matched) : [] : f.matched;
            i(new PEe(g, c.source, m, f.score + (g.boost || 0)));
          }
      }
    }
  if (n) {
    let c = /* @__PURE__ */ Object.create(null), d = 0, u = (f, p) => {
      var g, m;
      return ((g = f.rank) !== null && g !== void 0 ? g : 1e9) - ((m = p.rank) !== null && m !== void 0 ? m : 1e9) || (f.name < p.name ? -1 : 1);
    };
    for (let f of n.sort(u))
      d -= 1e5, c[f.name] = d;
    for (let f of t) {
      let { section: p } = f.completion;
      p && (f.score += c[typeof p == "string" ? p : p.name]);
    }
  }
  let o = [], a = null, l = s.compareCompletions;
  for (let c of t.sort((d, u) => u.score - d.score || l(d.completion, u.completion))) {
    let d = c.completion;
    !a || a.label != d.label || a.detail != d.detail || a.type != null && d.type != null && a.type != d.type || a.apply != d.apply || a.boost != d.boost ? o.push(c) : WEe(c.completion) > WEe(a) && (o[o.length - 1] = c), a = c.completion;
  }
  return o;
}
class fp {
  constructor(e, t, n, i, s, o) {
    this.options = e, this.attrs = t, this.tooltip = n, this.timestamp = i, this.selected = s, this.disabled = o;
  }
  setSelected(e, t) {
    return e == this.selected || e >= this.options.length ? this : new fp(this.options, jEe(t, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, t, n, i, s) {
    let o = _zt(e, t);
    if (!o.length)
      return i && e.some(
        (l) => l.state == 1
        /* State.Pending */
      ) ? new fp(i.options, i.attrs, i.tooltip, i.timestamp, i.selected, !0) : null;
    let a = t.facet(gs).selectOnOpen ? 0 : -1;
    if (i && i.selected != a && i.selected != -1) {
      let l = i.options[i.selected].completion;
      for (let c = 0; c < o.length; c++)
        if (o[c].completion == l) {
          a = c;
          break;
        }
    }
    return new fp(o, jEe(n, a), {
      pos: e.reduce((l, c) => c.hasResult() ? Math.min(l, c.from) : l, 1e8),
      create: Lzt,
      above: s.aboveCursor
    }, i ? i.timestamp : Date.now(), a, !1);
  }
  map(e) {
    return new fp(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class Wb {
  constructor(e, t, n) {
    this.active = e, this.id = t, this.open = n;
  }
  static start() {
    return new Wb(Mzt, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: t } = e, n = t.facet(gs), s = (n.override || t.languageDataAt("autocomplete", i1(t)).map(mzt)).map((a) => (this.active.find((c) => c.source == a) || new $s(
      a,
      this.active.some(
        (c) => c.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, n));
    s.length == this.active.length && s.every((a, l) => a == this.active[l]) && (s = this.active);
    let o = this.open;
    o && e.docChanged && (o = o.map(e.changes)), e.selection || s.some((a) => a.hasResult() && e.changes.touchesRange(a.from, a.to)) || !xzt(s, this.active) ? o = fp.build(s, t, this.id, o, n) : o && o.disabled && !s.some(
      (a) => a.state == 1
      /* State.Pending */
    ) && (o = null), !o && s.every(
      (a) => a.state != 1
      /* State.Pending */
    ) && s.some((a) => a.hasResult()) && (s = s.map((a) => a.hasResult() ? new $s(
      a.source,
      0
      /* State.Inactive */
    ) : a));
    for (let a of e.effects)
      a.is(CHe) && (o = o && o.setSelected(a.value, this.id));
    return s == this.active && o == this.open ? this : new Wb(s, this.id, o);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : Szt;
  }
}
function xzt(r, e) {
  if (r == e)
    return !0;
  for (let t = 0, n = 0; ; ) {
    for (; t < r.length && !r[t].hasResult; )
      t++;
    for (; n < e.length && !e[n].hasResult; )
      n++;
    let i = t == r.length, s = n == e.length;
    if (i || s)
      return i == s;
    if (r[t++].result != e[n++].result)
      return !1;
  }
}
const Szt = {
  "aria-autocomplete": "list"
};
function jEe(r, e) {
  let t = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": r
  };
  return e > -1 && (t["aria-activedescendant"] = r + "-" + e), t;
}
const Mzt = [];
function bT(r, e) {
  if (r.isUserEvent("input.complete")) {
    let t = r.annotation(nH);
    if (t && e.activateOnCompletion(t))
      return "input";
  }
  return r.isUserEvent("input.type") ? "input" : r.isUserEvent("delete.backward") ? "delete" : null;
}
class $s {
  constructor(e, t, n = -1) {
    this.source = e, this.state = t, this.explicitPos = n;
  }
  hasResult() {
    return !1;
  }
  update(e, t) {
    let n = bT(e, t), i = this;
    n ? i = i.handleUserEvent(e, n, t) : e.docChanged ? i = i.handleChange(e) : e.selection && i.state != 0 && (i = new $s(
      i.source,
      0
      /* State.Inactive */
    ));
    for (let s of e.effects)
      if (s.is(zb))
        i = new $s(i.source, 1, s.value ? i1(e.state) : -1);
      else if (s.is(P4))
        i = new $s(
          i.source,
          0
          /* State.Inactive */
        );
      else if (s.is(yHe))
        for (let o of s.value)
          o.source == i.source && (i = o);
    return i;
  }
  handleUserEvent(e, t, n) {
    return t == "delete" || !n.activateOnTyping ? this.map(e.changes) : new $s(
      this.source,
      1
      /* State.Pending */
    );
  }
  handleChange(e) {
    return e.changes.touchesRange(i1(e.startState)) ? new $s(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty || this.explicitPos < 0 ? this : new $s(this.source, this.state, e.mapPos(this.explicitPos));
  }
}
class jp extends $s {
  constructor(e, t, n, i, s) {
    super(e, 2, t), this.result = n, this.from = i, this.to = s;
  }
  hasResult() {
    return !0;
  }
  handleUserEvent(e, t, n) {
    var i;
    let s = this.result;
    s.map && !e.changes.empty && (s = s.map(s, e.changes));
    let o = e.changes.mapPos(this.from), a = e.changes.mapPos(this.to, 1), l = i1(e.state);
    if ((this.explicitPos < 0 ? l <= o : l < this.from) || l > a || !s || t == "delete" && i1(e.startState) == this.from)
      return new $s(
        this.source,
        t == "input" && n.activateOnTyping ? 1 : 0
        /* State.Inactive */
      );
    let c = this.explicitPos < 0 ? -1 : e.changes.mapPos(this.explicitPos);
    return Dzt(s.validFor, e.state, o, a) ? new jp(this.source, c, s, o, a) : s.update && (s = s.update(s, o, a, new vHe(e.state, l, c >= 0))) ? new jp(this.source, c, s, s.from, (i = s.to) !== null && i !== void 0 ? i : i1(e.state)) : new $s(this.source, 1, c);
  }
  handleChange(e) {
    return e.changes.touchesRange(this.from, this.to) ? new $s(
      this.source,
      0
      /* State.Inactive */
    ) : this.map(e.changes);
  }
  map(e) {
    return e.empty ? this : (this.result.map ? this.result.map(this.result, e) : this.result) ? new jp(this.source, this.explicitPos < 0 ? -1 : e.mapPos(this.explicitPos), this.result, e.mapPos(this.from), e.mapPos(this.to, 1)) : new $s(
      this.source,
      0
      /* State.Inactive */
    );
  }
}
function Dzt(r, e, t, n) {
  if (!r)
    return !1;
  let i = e.sliceDoc(t, n);
  return typeof r == "function" ? r(i, t, n, e) : bHe(r, !0).test(i);
}
const yHe = /* @__PURE__ */ Qn.define({
  map(r, e) {
    return r.map((t) => t.map(e));
  }
}), CHe = /* @__PURE__ */ Qn.define(), _o = /* @__PURE__ */ ka.define({
  create() {
    return Wb.start();
  },
  update(r, e) {
    return r.update(e);
  },
  provide: (r) => [
    JV.from(r, (e) => e.tooltip),
    st.contentAttributes.from(r, (e) => e.attrs)
  ]
});
function iH(r, e) {
  const t = e.completion.apply || e.completion.label;
  let n = r.state.field(_o).active.find((i) => i.source == e.source);
  return n instanceof jp ? (typeof t == "string" ? r.dispatch(Object.assign(Object.assign({}, gzt(r.state, t, n.from, n.to)), { annotations: nH.of(e.completion) })) : t(r, e.completion, n.from, n.to), !0) : !1;
}
const Lzt = /* @__PURE__ */ Czt(_o, iH);
function Q5(r, e = "option") {
  return (t) => {
    let n = t.state.field(_o, !1);
    if (!n || !n.open || n.open.disabled || Date.now() - n.open.timestamp < t.state.facet(gs).interactionDelay)
      return !1;
    let i = 1, s;
    e == "page" && (s = sHe(t, n.open.tooltip)) && (i = Math.max(2, Math.floor(s.dom.offsetHeight / s.dom.querySelector("li").offsetHeight) - 1));
    let { length: o } = n.open.options, a = n.open.selected > -1 ? n.open.selected + i * (r ? 1 : -1) : r ? 0 : o - 1;
    return a < 0 ? a = e == "page" ? 0 : o - 1 : a >= o && (a = e == "page" ? o - 1 : 0), t.dispatch({ effects: CHe.of(a) }), !0;
  };
}
const kzt = (r) => {
  let e = r.state.field(_o, !1);
  return r.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < r.state.facet(gs).interactionDelay ? !1 : iH(r, e.open.options[e.open.selected]);
}, Nzt = (r) => r.state.field(_o, !1) ? (r.dispatch({ effects: zb.of(!0) }), !0) : !1, Tzt = (r) => {
  let e = r.state.field(_o, !1);
  return !e || !e.active.some(
    (t) => t.state != 0
    /* State.Inactive */
  ) ? !1 : (r.dispatch({ effects: P4.of(null) }), !0);
};
class Izt {
  constructor(e, t) {
    this.active = e, this.context = t, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const Ozt = 50, Rzt = 1e3, Vzt = /* @__PURE__ */ Ca.fromClass(class {
  constructor(r) {
    this.view = r, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let e of r.state.field(_o).active)
      e.state == 1 && this.startQuery(e);
  }
  update(r) {
    let e = r.state.field(_o), t = r.state.facet(gs);
    if (!r.selectionSet && !r.docChanged && r.startState.field(_o) == e)
      return;
    let n = r.transactions.some((s) => (s.selection || s.docChanged) && !bT(s, t));
    for (let s = 0; s < this.running.length; s++) {
      let o = this.running[s];
      if (n || o.updates.length + r.transactions.length > Ozt && Date.now() - o.time > Rzt) {
        for (let a of o.context.abortListeners)
          try {
            a();
          } catch (l) {
            va(this.view.state, l);
          }
        o.context.abortListeners = null, this.running.splice(s--, 1);
      } else
        o.updates.push(...r.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), r.transactions.some((s) => s.effects.some((o) => o.is(zb))) && (this.pendingStart = !0);
    let i = this.pendingStart ? 50 : t.activateOnTypingDelay;
    if (this.debounceUpdate = e.active.some((s) => s.state == 1 && !this.running.some((o) => o.active.source == s.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0)
      for (let s of r.transactions)
        bT(s, t) == "input" ? this.composing = 2 : this.composing == 2 && s.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: r } = this.view, e = r.field(_o);
    for (let t of e.active)
      t.state == 1 && !this.running.some((n) => n.active.source == t.source) && this.startQuery(t);
  }
  startQuery(r) {
    let { state: e } = this.view, t = i1(e), n = new vHe(e, t, r.explicitPos == t), i = new Izt(r, n);
    this.running.push(i), Promise.resolve(r.source(n)).then((s) => {
      i.context.aborted || (i.done = s || null, this.scheduleAccept());
    }, (s) => {
      this.view.dispatch({ effects: P4.of(null) }), va(this.view.state, s);
    });
  }
  scheduleAccept() {
    this.running.every((r) => r.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(gs).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var r;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], t = this.view.state.facet(gs);
    for (let n = 0; n < this.running.length; n++) {
      let i = this.running[n];
      if (i.done === void 0)
        continue;
      if (this.running.splice(n--, 1), i.done) {
        let o = new jp(i.active.source, i.active.explicitPos, i.done, i.done.from, (r = i.done.to) !== null && r !== void 0 ? r : i1(i.updates.length ? i.updates[0].startState : this.view.state));
        for (let a of i.updates)
          o = o.update(a, t);
        if (o.hasResult()) {
          e.push(o);
          continue;
        }
      }
      let s = this.view.state.field(_o).active.find((o) => o.source == i.active.source);
      if (s && s.state == 1)
        if (i.done == null) {
          let o = new $s(
            i.active.source,
            0
            /* State.Inactive */
          );
          for (let a of i.updates)
            o = o.update(a, t);
          o.state != 1 && e.push(o);
        } else
          this.startQuery(s);
    }
    e.length && this.view.dispatch({ effects: yHe.of(e) });
  }
}, {
  eventHandlers: {
    blur(r) {
      let e = this.view.state.field(_o, !1);
      if (e && e.tooltip && this.view.state.facet(gs).closeOnBlur) {
        let t = e.open && sHe(this.view, e.open.tooltip);
        (!t || !t.dom.contains(r.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: P4.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: zb.of(!1) }), 20), this.composing = 0;
    }
  }
}), Hzt = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), Bzt = /* @__PURE__ */ vm.highest(/* @__PURE__ */ st.domEventHandlers({
  keydown(r, e) {
    let t = e.state.field(_o, !1);
    if (!t || !t.open || t.open.disabled || t.open.selected < 0 || r.key.length > 1 || r.ctrlKey && !(Hzt && r.altKey) || r.metaKey)
      return !1;
    let n = t.open.options[t.open.selected], i = t.active.find((o) => o.source == n.source), s = n.completion.commitCharacters || i.result.commitCharacters;
    return s && s.indexOf(r.key) > -1 && iH(e, n), !1;
  }
})), EHe = /* @__PURE__ */ st.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class Pzt {
  constructor(e, t, n, i) {
    this.field = e, this.line = t, this.from = n, this.to = i;
  }
}
class rH {
  constructor(e, t, n) {
    this.field = e, this.from = t, this.to = n;
  }
  map(e) {
    let t = e.mapPos(this.from, -1, ps.TrackDel), n = e.mapPos(this.to, 1, ps.TrackDel);
    return t == null || n == null ? null : new rH(this.field, t, n);
  }
}
class sH {
  constructor(e, t) {
    this.lines = e, this.fieldPositions = t;
  }
  instantiate(e, t) {
    let n = [], i = [t], s = e.doc.lineAt(t), o = /^\s*/.exec(s.text)[0];
    for (let l of this.lines) {
      if (n.length) {
        let c = o, d = /^\t*/.exec(l)[0].length;
        for (let u = 0; u < d; u++)
          c += e.facet(hC);
        i.push(t + c.length - d), l = c + l.slice(d);
      }
      n.push(l), t += l.length + 1;
    }
    let a = this.fieldPositions.map((l) => new rH(l.field, i[l.line] + l.from, i[l.line] + l.to));
    return { text: n, ranges: a };
  }
  static parse(e) {
    let t = [], n = [], i = [], s;
    for (let o of e.split(/\r\n?|\n/)) {
      for (; s = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(o); ) {
        let a = s[1] ? +s[1] : null, l = s[2] || s[3] || "", c = -1;
        for (let d = 0; d < t.length; d++)
          (a != null ? t[d].seq == a : l && t[d].name == l) && (c = d);
        if (c < 0) {
          let d = 0;
          for (; d < t.length && (a == null || t[d].seq != null && t[d].seq < a); )
            d++;
          t.splice(d, 0, { seq: a, name: l }), c = d;
          for (let u of i)
            u.field >= c && u.field++;
        }
        i.push(new Pzt(c, n.length, s.index, s.index + l.length)), o = o.slice(0, s.index) + l + o.slice(s.index + s[0].length);
      }
      for (let a; a = /\\([{}])/.exec(o); ) {
        o = o.slice(0, a.index) + a[1] + o.slice(a.index + a[0].length);
        for (let l of i)
          l.line == n.length && l.from > a.index && (l.from--, l.to--);
      }
      n.push(o);
    }
    return new sH(n, i);
  }
}
let Fzt = /* @__PURE__ */ pi.widget({ widget: /* @__PURE__ */ new class extends Xw {
  toDOM() {
    let r = document.createElement("span");
    return r.className = "cm-snippetFieldPosition", r;
  }
  ignoreEvent() {
    return !1;
  }
}() }), zzt = /* @__PURE__ */ pi.mark({ class: "cm-snippetField" });
class bm {
  constructor(e, t) {
    this.ranges = e, this.active = t, this.deco = pi.set(e.map((n) => (n.from == n.to ? Fzt : zzt).range(n.from, n.to)));
  }
  map(e) {
    let t = [];
    for (let n of this.ranges) {
      let i = n.map(e);
      if (!i)
        return null;
      t.push(i);
    }
    return new bm(t, this.active);
  }
  selectionInsideField(e) {
    return e.ranges.every((t) => this.ranges.some((n) => n.field == this.active && n.from <= t.from && n.to >= t.to));
  }
}
const tv = /* @__PURE__ */ Qn.define({
  map(r, e) {
    return r && r.map(e);
  }
}), Wzt = /* @__PURE__ */ Qn.define(), F4 = /* @__PURE__ */ ka.define({
  create() {
    return null;
  },
  update(r, e) {
    for (let t of e.effects) {
      if (t.is(tv))
        return t.value;
      if (t.is(Wzt) && r)
        return new bm(r.ranges, t.value);
    }
    return r && e.docChanged && (r = r.map(e.changes)), r && e.selection && !r.selectionInsideField(e.selection) && (r = null), r;
  },
  provide: (r) => st.decorations.from(r, (e) => e ? e.deco : pi.none)
});
function oH(r, e) {
  return Be.create(r.filter((t) => t.field == e).map((t) => Be.range(t.from, t.to)));
}
function jzt(r) {
  let e = sH.parse(r);
  return (t, n, i, s) => {
    let { text: o, ranges: a } = e.instantiate(t.state, i), l = {
      changes: { from: i, to: s, insert: li.of(o) },
      scrollIntoView: !0,
      annotations: n ? [nH.of(n), vs.userEvent.of("input.complete")] : void 0
    };
    if (a.length && (l.selection = oH(a, 0)), a.some((c) => c.field > 0)) {
      let c = new bm(a, 0), d = l.effects = [tv.of(c)];
      t.state.field(F4, !1) === void 0 && d.push(Qn.appendConfig.of([F4, Qzt, Kzt, EHe]));
    }
    t.dispatch(t.state.update(l));
  };
}
function _He(r) {
  return ({ state: e, dispatch: t }) => {
    let n = e.field(F4, !1);
    if (!n || r < 0 && n.active == 0)
      return !1;
    let i = n.active + r, s = r > 0 && !n.ranges.some((o) => o.field == i + r);
    return t(e.update({
      selection: oH(n.ranges, i),
      effects: tv.of(s ? null : new bm(n.ranges, i)),
      scrollIntoView: !0
    })), !0;
  };
}
const Zzt = ({ state: r, dispatch: e }) => r.field(F4, !1) ? (e(r.update({ effects: tv.of(null) })), !0) : !1, Uzt = /* @__PURE__ */ _He(1), qzt = /* @__PURE__ */ _He(-1), Gzt = [
  { key: "Tab", run: Uzt, shift: qzt },
  { key: "Escape", run: Zzt }
], ZEe = /* @__PURE__ */ bt.define({
  combine(r) {
    return r.length ? r[0] : Gzt;
  }
}), Qzt = /* @__PURE__ */ vm.highest(/* @__PURE__ */ ev.compute([ZEe], (r) => r.facet(ZEe)));
function d0(r, e) {
  return Object.assign(Object.assign({}, e), { apply: jzt(r) });
}
const Kzt = /* @__PURE__ */ st.domEventHandlers({
  mousedown(r, e) {
    let t = e.state.field(F4, !1), n;
    if (!t || (n = e.posAtCoords({ x: r.clientX, y: r.clientY })) == null)
      return !1;
    let i = t.ranges.find((s) => s.from <= n && s.to >= n);
    return !i || i.field == t.active ? !1 : (e.dispatch({
      selection: oH(t.ranges, i.field),
      effects: tv.of(t.ranges.some((s) => s.field > i.field) ? new bm(t.ranges, i.field) : null),
      scrollIntoView: !0
    }), !0);
  }
}), jb = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, F0 = /* @__PURE__ */ Qn.define({
  map(r, e) {
    let t = e.mapPos(r, -1, ps.TrackAfter);
    return t ?? void 0;
  }
}), aH = /* @__PURE__ */ new class extends Nf {
}();
aH.startSide = 1;
aH.endSide = -1;
const xHe = /* @__PURE__ */ ka.define({
  create() {
    return oi.empty;
  },
  update(r, e) {
    if (r = r.map(e.changes), e.selection) {
      let t = e.state.doc.lineAt(e.selection.main.head);
      r = r.update({ filter: (n) => n >= t.from && n <= t.to });
    }
    for (let t of e.effects)
      t.is(F0) && (r = r.update({ add: [aH.range(t.value, t.value + 1)] }));
    return r;
  }
});
function SHe() {
  return [$zt, xHe];
}
const VS = "()[]{}<>";
function Yzt(r) {
  for (let e = 0; e < VS.length; e += 2)
    if (VS.charCodeAt(e) == r)
      return VS.charAt(e + 1);
  return XRe(r < 128 ? r : r + 1);
}
function Xzt(r, e) {
  return r.languageDataAt("closeBrackets", e)[0] || jb;
}
const Jzt = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), $zt = /* @__PURE__ */ st.inputHandler.of((r, e, t, n) => {
  if ((Jzt ? r.composing : r.compositionStarted) || r.state.readOnly)
    return !1;
  let i = r.state.selection.main;
  if (n.length > 2 || n.length == 2 && Kc(ta(n, 0)) == 1 || e != i.from || t != i.to)
    return !1;
  let s = eWt(r.state, n);
  return s ? (r.dispatch(s), !0) : !1;
});
function eWt(r, e) {
  let t = Xzt(r, r.selection.main.head), n = t.brackets || jb.brackets;
  for (let i of n) {
    let s = Yzt(ta(i, 0));
    if (e == i)
      return s == i ? iWt(r, i, n.indexOf(i + i + i) > -1, t) : tWt(r, i, s, t.before || jb.before);
    if (e == s && MHe(r, r.selection.main.from))
      return nWt(r, i, s);
  }
  return null;
}
function MHe(r, e) {
  let t = !1;
  return r.field(xHe).between(0, r.doc.length, (n) => {
    n == e && (t = !0);
  }), t;
}
function lH(r, e) {
  let t = r.sliceString(e, e + 2);
  return t.slice(0, Kc(ta(t, 0)));
}
function tWt(r, e, t, n) {
  let i = null, s = r.changeByRange((o) => {
    if (!o.empty)
      return {
        changes: [{ insert: e, from: o.from }, { insert: t, from: o.to }],
        effects: F0.of(o.to + e.length),
        range: Be.range(o.anchor + e.length, o.head + e.length)
      };
    let a = lH(r.doc, o.head);
    return !a || /\s/.test(a) || n.indexOf(a) > -1 ? {
      changes: { insert: e + t, from: o.head },
      effects: F0.of(o.head + e.length),
      range: Be.cursor(o.head + e.length)
    } : { range: i = o };
  });
  return i ? null : r.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function nWt(r, e, t) {
  let n = null, i = r.changeByRange((s) => s.empty && lH(r.doc, s.head) == t ? {
    changes: { from: s.head, to: s.head + t.length, insert: t },
    range: Be.cursor(s.head + t.length)
  } : n = { range: s });
  return n ? null : r.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function iWt(r, e, t, n) {
  let i = n.stringPrefixes || jb.stringPrefixes, s = null, o = r.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: e, from: a.from }, { insert: e, from: a.to }],
        effects: F0.of(a.to + e.length),
        range: Be.range(a.anchor + e.length, a.head + e.length)
      };
    let l = a.head, c = lH(r.doc, l), d;
    if (c == e) {
      if (UEe(r, l))
        return {
          changes: { insert: e + e, from: l },
          effects: F0.of(l + e.length),
          range: Be.cursor(l + e.length)
        };
      if (MHe(r, l)) {
        let f = t && r.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: l, to: l + f.length, insert: f },
          range: Be.cursor(l + f.length)
        };
      }
    } else {
      if (t && r.sliceDoc(l - 2 * e.length, l) == e + e && (d = qEe(r, l - 2 * e.length, i)) > -1 && UEe(r, d))
        return {
          changes: { insert: e + e + e + e, from: l },
          effects: F0.of(l + e.length),
          range: Be.cursor(l + e.length)
        };
      if (r.charCategorizer(l)(c) != rl.Word && qEe(r, l, i) > -1 && !rWt(r, l, e, i))
        return {
          changes: { insert: e + e, from: l },
          effects: F0.of(l + e.length),
          range: Be.cursor(l + e.length)
        };
    }
    return { range: s = a };
  });
  return s ? null : r.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function UEe(r, e) {
  let t = Zr(r).resolveInner(e + 1);
  return t.parent && t.from == e;
}
function rWt(r, e, t, n) {
  let i = Zr(r).resolveInner(e, -1), s = n.reduce((o, a) => Math.max(o, a.length), 0);
  for (let o = 0; o < 5; o++) {
    let a = r.sliceDoc(i.from, Math.min(i.to, i.from + t.length + s)), l = a.indexOf(t);
    if (!l || l > -1 && n.indexOf(a.slice(0, l)) > -1) {
      let d = i.firstChild;
      for (; d && d.from == i.from && d.to - d.from > t.length + l; ) {
        if (r.sliceDoc(d.to - t.length, d.to) == t)
          return !1;
        d = d.firstChild;
      }
      return !0;
    }
    let c = i.to == e && i.parent;
    if (!c)
      break;
    i = c;
  }
  return !1;
}
function qEe(r, e, t) {
  let n = r.charCategorizer(e);
  if (n(r.sliceDoc(e - 1, e)) != rl.Word)
    return e;
  for (let i of t) {
    let s = e - i.length;
    if (r.sliceDoc(s, e) == i && n(r.sliceDoc(s - 1, s)) != rl.Word)
      return s;
  }
  return -1;
}
function sWt(r = {}) {
  return [
    Bzt,
    _o,
    gs.of(r),
    Vzt,
    aWt,
    EHe
  ];
}
const oWt = [
  { key: "Ctrl-Space", run: Nzt },
  { key: "Escape", run: Tzt },
  { key: "ArrowDown", run: /* @__PURE__ */ Q5(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ Q5(!1) },
  { key: "PageDown", run: /* @__PURE__ */ Q5(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ Q5(!1, "page") },
  { key: "Enter", run: kzt }
], aWt = /* @__PURE__ */ vm.highest(/* @__PURE__ */ ev.computeN([gs], (r) => r.facet(gs).defaultKeymap ? [oWt] : [])), lWt = (r) => {
  let { state: e } = r, t = e.doc.lineAt(e.selection.main.from), n = hH(r.state, t.from);
  return n.line ? cWt(r) : n.block ? dWt(r) : !1;
};
function cH(r, e) {
  return ({ state: t, dispatch: n }) => {
    if (t.readOnly)
      return !1;
    let i = r(e, t);
    return i ? (n(t.update(i)), !0) : !1;
  };
}
const cWt = /* @__PURE__ */ cH(
  pWt,
  0
  /* CommentOption.Toggle */
), hWt = /* @__PURE__ */ cH(
  DHe,
  0
  /* CommentOption.Toggle */
), dWt = /* @__PURE__ */ cH(
  (r, e) => DHe(r, e, fWt(e)),
  0
  /* CommentOption.Toggle */
);
function hH(r, e) {
  let t = r.languageDataAt("commentTokens", e);
  return t.length ? t[0] : {};
}
const sA = 50;
function uWt(r, { open: e, close: t }, n, i) {
  let s = r.sliceDoc(n - sA, n), o = r.sliceDoc(i, i + sA), a = /\s*$/.exec(s)[0].length, l = /^\s*/.exec(o)[0].length, c = s.length - a;
  if (s.slice(c - e.length, c) == e && o.slice(l, l + t.length) == t)
    return {
      open: { pos: n - a, margin: a && 1 },
      close: { pos: i + l, margin: l && 1 }
    };
  let d, u;
  i - n <= 2 * sA ? d = u = r.sliceDoc(n, i) : (d = r.sliceDoc(n, n + sA), u = r.sliceDoc(i - sA, i));
  let f = /^\s*/.exec(d)[0].length, p = /\s*$/.exec(u)[0].length, g = u.length - p - t.length;
  return d.slice(f, f + e.length) == e && u.slice(g, g + t.length) == t ? {
    open: {
      pos: n + f + e.length,
      margin: /\s/.test(d.charAt(f + e.length)) ? 1 : 0
    },
    close: {
      pos: i - p - t.length,
      margin: /\s/.test(u.charAt(g - 1)) ? 1 : 0
    }
  } : null;
}
function fWt(r) {
  let e = [];
  for (let t of r.selection.ranges) {
    let n = r.doc.lineAt(t.from), i = t.to <= n.to ? n : r.doc.lineAt(t.to), s = e.length - 1;
    s >= 0 && e[s].to > n.from ? e[s].to = i.to : e.push({ from: n.from + /^\s*/.exec(n.text)[0].length, to: i.to });
  }
  return e;
}
function DHe(r, e, t = e.selection.ranges) {
  let n = t.map((s) => hH(e, s.from).block);
  if (!n.every((s) => s))
    return null;
  let i = t.map((s, o) => uWt(e, n[o], s.from, s.to));
  if (r != 2 && !i.every((s) => s))
    return { changes: e.changes(t.map((s, o) => i[o] ? [] : [{ from: s.from, insert: n[o].open + " " }, { from: s.to, insert: " " + n[o].close }])) };
  if (r != 1 && i.some((s) => s)) {
    let s = [];
    for (let o = 0, a; o < i.length; o++)
      if (a = i[o]) {
        let l = n[o], { open: c, close: d } = a;
        s.push({ from: c.pos - l.open.length, to: c.pos + c.margin }, { from: d.pos - d.margin, to: d.pos + l.close.length });
      }
    return { changes: s };
  }
  return null;
}
function pWt(r, e, t = e.selection.ranges) {
  let n = [], i = -1;
  for (let { from: s, to: o } of t) {
    let a = n.length, l = 1e9, c = hH(e, s).line;
    if (c) {
      for (let d = s; d <= o; ) {
        let u = e.doc.lineAt(d);
        if (u.from > i && (s == o || o > u.from)) {
          i = u.from;
          let f = /^\s*/.exec(u.text)[0].length, p = f == u.length, g = u.text.slice(f, f + c.length) == c ? f : -1;
          f < u.text.length && f < l && (l = f), n.push({ line: u, comment: g, token: c, indent: f, empty: p, single: !1 });
        }
        d = u.to + 1;
      }
      if (l < 1e9)
        for (let d = a; d < n.length; d++)
          n[d].indent < n[d].line.text.length && (n[d].indent = l);
      n.length == a + 1 && (n[a].single = !0);
    }
  }
  if (r != 2 && n.some((s) => s.comment < 0 && (!s.empty || s.single))) {
    let s = [];
    for (let { line: a, token: l, indent: c, empty: d, single: u } of n)
      (u || !d) && s.push({ from: a.from + c, insert: l + " " });
    let o = e.changes(s);
    return { changes: o, selection: e.selection.map(o, 1) };
  } else if (r != 1 && n.some((s) => s.comment >= 0)) {
    let s = [];
    for (let { line: o, comment: a, token: l } of n)
      if (a >= 0) {
        let c = o.from + a, d = c + l.length;
        o.text[d - o.from] == " " && d++, s.push({ from: c, to: d });
      }
    return { changes: s };
  }
  return null;
}
function ym(r, e) {
  return Be.create(r.ranges.map(e), r.mainIndex);
}
function kh(r, e) {
  return r.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function wc({ state: r, dispatch: e }, t) {
  let n = ym(r.selection, t);
  return n.eq(r.selection, !0) ? !1 : (e(kh(r, n)), !0);
}
function fC(r, e) {
  return Be.cursor(e ? r.to : r.from);
}
function LHe(r, e) {
  return wc(r, (t) => t.empty ? r.moveByChar(t, e) : fC(t, e));
}
function Gs(r) {
  return r.textDirectionAt(r.state.selection.main.head) == nr.LTR;
}
const kHe = (r) => LHe(r, !Gs(r)), NHe = (r) => LHe(r, Gs(r));
function THe(r, e) {
  return wc(r, (t) => t.empty ? r.moveByGroup(t, e) : fC(t, e));
}
const gWt = (r) => THe(r, !Gs(r)), mWt = (r) => THe(r, Gs(r));
function AWt(r, e, t) {
  if (e.type.prop(t))
    return !0;
  let n = e.to - e.from;
  return n && (n > 2 || /[^\s,.;:]/.test(r.sliceDoc(e.from, e.to))) || e.firstChild;
}
function pC(r, e, t) {
  let n = Zr(r).resolveInner(e.head), i = t ? Xt.closedBy : Xt.openedBy;
  for (let l = e.head; ; ) {
    let c = t ? n.childAfter(l) : n.childBefore(l);
    if (!c)
      break;
    AWt(r, c, i) ? n = c : l = t ? c.to : c.from;
  }
  let s = n.type.prop(i), o, a;
  return s && (o = t ? eh(r, n.from, 1) : eh(r, n.to, -1)) && o.matched ? a = t ? o.end.to : o.end.from : a = t ? n.to : n.from, Be.cursor(a, t ? -1 : 1);
}
const wWt = (r) => wc(r, (e) => pC(r.state, e, !Gs(r))), vWt = (r) => wc(r, (e) => pC(r.state, e, Gs(r)));
function IHe(r, e) {
  return wc(r, (t) => {
    if (!t.empty)
      return fC(t, e);
    let n = r.moveVertically(t, e);
    return n.head != t.head ? n : r.moveToLineBoundary(t, e);
  });
}
const OHe = (r) => IHe(r, !1), RHe = (r) => IHe(r, !0);
function VHe(r) {
  let e = r.scrollDOM.clientHeight < r.scrollDOM.scrollHeight - 2, t = 0, n = 0, i;
  if (e) {
    for (let s of r.state.facet(st.scrollMargins)) {
      let o = s(r);
      o?.top && (t = Math.max(o?.top, t)), o?.bottom && (n = Math.max(o?.bottom, n));
    }
    i = r.scrollDOM.clientHeight - t - n;
  } else
    i = (r.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: t,
    marginBottom: n,
    selfScroll: e,
    height: Math.max(r.defaultLineHeight, i - 5)
  };
}
function HHe(r, e) {
  let t = VHe(r), { state: n } = r, i = ym(n.selection, (o) => o.empty ? r.moveVertically(o, e, t.height) : fC(o, e));
  if (i.eq(n.selection))
    return !1;
  let s;
  if (t.selfScroll) {
    let o = r.coordsAtPos(n.selection.main.head), a = r.scrollDOM.getBoundingClientRect(), l = a.top + t.marginTop, c = a.bottom - t.marginBottom;
    o && o.top > l && o.bottom < c && (s = st.scrollIntoView(i.main.head, { y: "start", yMargin: o.top - l }));
  }
  return r.dispatch(kh(n, i), { effects: s }), !0;
}
const GEe = (r) => HHe(r, !1), yT = (r) => HHe(r, !0);
function W1(r, e, t) {
  let n = r.lineBlockAt(e.head), i = r.moveToLineBoundary(e, t);
  if (i.head == e.head && i.head != (t ? n.to : n.from) && (i = r.moveToLineBoundary(e, t, !1)), !t && i.head == n.from && n.length) {
    let s = /^\s*/.exec(r.state.sliceDoc(n.from, Math.min(n.from + 100, n.to)))[0].length;
    s && e.head != n.from + s && (i = Be.cursor(n.from + s));
  }
  return i;
}
const bWt = (r) => wc(r, (e) => W1(r, e, !0)), yWt = (r) => wc(r, (e) => W1(r, e, !1)), CWt = (r) => wc(r, (e) => W1(r, e, !Gs(r))), EWt = (r) => wc(r, (e) => W1(r, e, Gs(r))), _Wt = (r) => wc(r, (e) => Be.cursor(r.lineBlockAt(e.head).from, 1)), xWt = (r) => wc(r, (e) => Be.cursor(r.lineBlockAt(e.head).to, -1));
function SWt(r, e, t) {
  let n = !1, i = ym(r.selection, (s) => {
    let o = eh(r, s.head, -1) || eh(r, s.head, 1) || s.head > 0 && eh(r, s.head - 1, 1) || s.head < r.doc.length && eh(r, s.head + 1, -1);
    if (!o || !o.end)
      return s;
    n = !0;
    let a = o.start.from == s.head ? o.end.to : o.end.from;
    return Be.cursor(a);
  });
  return n ? (e(kh(r, i)), !0) : !1;
}
const MWt = ({ state: r, dispatch: e }) => SWt(r, e);
function Cl(r, e) {
  let t = ym(r.state.selection, (n) => {
    let i = e(n);
    return Be.range(n.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return t.eq(r.state.selection) ? !1 : (r.dispatch(kh(r.state, t)), !0);
}
function BHe(r, e) {
  return Cl(r, (t) => r.moveByChar(t, e));
}
const PHe = (r) => BHe(r, !Gs(r)), FHe = (r) => BHe(r, Gs(r));
function zHe(r, e) {
  return Cl(r, (t) => r.moveByGroup(t, e));
}
const DWt = (r) => zHe(r, !Gs(r)), LWt = (r) => zHe(r, Gs(r)), kWt = (r) => Cl(r, (e) => pC(r.state, e, !Gs(r))), NWt = (r) => Cl(r, (e) => pC(r.state, e, Gs(r)));
function WHe(r, e) {
  return Cl(r, (t) => r.moveVertically(t, e));
}
const jHe = (r) => WHe(r, !1), ZHe = (r) => WHe(r, !0);
function UHe(r, e) {
  return Cl(r, (t) => r.moveVertically(t, e, VHe(r).height));
}
const QEe = (r) => UHe(r, !1), KEe = (r) => UHe(r, !0), TWt = (r) => Cl(r, (e) => W1(r, e, !0)), IWt = (r) => Cl(r, (e) => W1(r, e, !1)), OWt = (r) => Cl(r, (e) => W1(r, e, !Gs(r))), RWt = (r) => Cl(r, (e) => W1(r, e, Gs(r))), VWt = (r) => Cl(r, (e) => Be.cursor(r.lineBlockAt(e.head).from)), HWt = (r) => Cl(r, (e) => Be.cursor(r.lineBlockAt(e.head).to)), YEe = ({ state: r, dispatch: e }) => (e(kh(r, { anchor: 0 })), !0), XEe = ({ state: r, dispatch: e }) => (e(kh(r, { anchor: r.doc.length })), !0), JEe = ({ state: r, dispatch: e }) => (e(kh(r, { anchor: r.selection.main.anchor, head: 0 })), !0), $Ee = ({ state: r, dispatch: e }) => (e(kh(r, { anchor: r.selection.main.anchor, head: r.doc.length })), !0), BWt = ({ state: r, dispatch: e }) => (e(r.update({ selection: { anchor: 0, head: r.doc.length }, userEvent: "select" })), !0), PWt = ({ state: r, dispatch: e }) => {
  let t = gC(r).map(({ from: n, to: i }) => Be.range(n, Math.min(i + 1, r.doc.length)));
  return e(r.update({ selection: Be.create(t), userEvent: "select" })), !0;
}, FWt = ({ state: r, dispatch: e }) => {
  let t = ym(r.selection, (n) => {
    var i;
    let s = Zr(r).resolveStack(n.from, 1);
    for (let o = s; o; o = o.next) {
      let { node: a } = o;
      if ((a.from < n.from && a.to >= n.to || a.to > n.to && a.from <= n.from) && (!((i = a.parent) === null || i === void 0) && i.parent))
        return Be.range(a.to, a.from);
    }
    return n;
  });
  return e(kh(r, t)), !0;
}, zWt = ({ state: r, dispatch: e }) => {
  let t = r.selection, n = null;
  return t.ranges.length > 1 ? n = Be.create([t.main]) : t.main.empty || (n = Be.create([Be.cursor(t.main.head)])), n ? (e(kh(r, n)), !0) : !1;
};
function nv(r, e) {
  if (r.state.readOnly)
    return !1;
  let t = "delete.selection", { state: n } = r, i = n.changeByRange((s) => {
    let { from: o, to: a } = s;
    if (o == a) {
      let l = e(s);
      l < o ? (t = "delete.backward", l = K5(r, l, !1)) : l > o && (t = "delete.forward", l = K5(r, l, !0)), o = Math.min(o, l), a = Math.max(a, l);
    } else
      o = K5(r, o, !1), a = K5(r, a, !0);
    return o == a ? { range: s } : { changes: { from: o, to: a }, range: Be.cursor(o, o < s.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (r.dispatch(n.update(i, {
    scrollIntoView: !0,
    userEvent: t,
    effects: t == "delete.selection" ? st.announce.of(n.phrase("Selection deleted")) : void 0
  })), !0);
}
function K5(r, e, t) {
  if (r instanceof st)
    for (let n of r.state.facet(st.atomicRanges).map((i) => i(r)))
      n.between(e, e, (i, s) => {
        i < e && s > e && (e = t ? s : i);
      });
  return e;
}
const qHe = (r, e) => nv(r, (t) => {
  let n = t.from, { state: i } = r, s = i.doc.lineAt(n), o, a;
  if (!e && n > s.from && n < s.from + 200 && !/[^ \t]/.test(o = s.text.slice(0, n - s.from))) {
    if (o[o.length - 1] == "	")
      return n - 1;
    let l = oC(o, i.tabSize), c = l % Fb(i) || Fb(i);
    for (let d = 0; d < c && o[o.length - 1 - d] == " "; d++)
      n--;
    a = n;
  } else
    a = ro(s.text, n - s.from, e, e) + s.from, a == n && s.number != (e ? i.doc.lines : 1) ? a += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(s.text.slice(a - s.from, n - s.from)) && (a = ro(s.text, a - s.from, !1, !1) + s.from);
  return a;
}), CT = (r) => qHe(r, !1), GHe = (r) => qHe(r, !0), QHe = (r, e) => nv(r, (t) => {
  let n = t.head, { state: i } = r, s = i.doc.lineAt(n), o = i.charCategorizer(n);
  for (let a = null; ; ) {
    if (n == (e ? s.to : s.from)) {
      n == t.head && s.number != (e ? i.doc.lines : 1) && (n += e ? 1 : -1);
      break;
    }
    let l = ro(s.text, n - s.from, e) + s.from, c = s.text.slice(Math.min(n, l) - s.from, Math.max(n, l) - s.from), d = o(c);
    if (a != null && d != a)
      break;
    (c != " " || n != t.head) && (a = d), n = l;
  }
  return n;
}), KHe = (r) => QHe(r, !1), WWt = (r) => QHe(r, !0), jWt = (r) => nv(r, (e) => {
  let t = r.lineBlockAt(e.head).to;
  return e.head < t ? t : Math.min(r.state.doc.length, e.head + 1);
}), ZWt = (r) => nv(r, (e) => {
  let t = r.moveToLineBoundary(e, !1).head;
  return e.head > t ? t : Math.max(0, e.head - 1);
}), UWt = (r) => nv(r, (e) => {
  let t = r.moveToLineBoundary(e, !0).head;
  return e.head < t ? t : Math.min(r.state.doc.length, e.head + 1);
}), qWt = ({ state: r, dispatch: e }) => {
  if (r.readOnly)
    return !1;
  let t = r.changeByRange((n) => ({
    changes: { from: n.from, to: n.to, insert: li.of(["", ""]) },
    range: Be.cursor(n.from)
  }));
  return e(r.update(t, { scrollIntoView: !0, userEvent: "input" })), !0;
}, GWt = ({ state: r, dispatch: e }) => {
  if (r.readOnly)
    return !1;
  let t = r.changeByRange((n) => {
    if (!n.empty || n.from == 0 || n.from == r.doc.length)
      return { range: n };
    let i = n.from, s = r.doc.lineAt(i), o = i == s.from ? i - 1 : ro(s.text, i - s.from, !1) + s.from, a = i == s.to ? i + 1 : ro(s.text, i - s.from, !0) + s.from;
    return {
      changes: { from: o, to: a, insert: r.doc.slice(i, a).append(r.doc.slice(o, i)) },
      range: Be.cursor(a)
    };
  });
  return t.changes.empty ? !1 : (e(r.update(t, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function gC(r) {
  let e = [], t = -1;
  for (let n of r.selection.ranges) {
    let i = r.doc.lineAt(n.from), s = r.doc.lineAt(n.to);
    if (!n.empty && n.to == s.from && (s = r.doc.lineAt(n.to - 1)), t >= i.number) {
      let o = e[e.length - 1];
      o.to = s.to, o.ranges.push(n);
    } else
      e.push({ from: i.from, to: s.to, ranges: [n] });
    t = s.number + 1;
  }
  return e;
}
function YHe(r, e, t) {
  if (r.readOnly)
    return !1;
  let n = [], i = [];
  for (let s of gC(r)) {
    if (t ? s.to == r.doc.length : s.from == 0)
      continue;
    let o = r.doc.lineAt(t ? s.to + 1 : s.from - 1), a = o.length + 1;
    if (t) {
      n.push({ from: s.to, to: o.to }, { from: s.from, insert: o.text + r.lineBreak });
      for (let l of s.ranges)
        i.push(Be.range(Math.min(r.doc.length, l.anchor + a), Math.min(r.doc.length, l.head + a)));
    } else {
      n.push({ from: o.from, to: s.from }, { from: s.to, insert: r.lineBreak + o.text });
      for (let l of s.ranges)
        i.push(Be.range(l.anchor - a, l.head - a));
    }
  }
  return n.length ? (e(r.update({
    changes: n,
    scrollIntoView: !0,
    selection: Be.create(i, r.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const QWt = ({ state: r, dispatch: e }) => YHe(r, e, !1), KWt = ({ state: r, dispatch: e }) => YHe(r, e, !0);
function XHe(r, e, t) {
  if (r.readOnly)
    return !1;
  let n = [];
  for (let i of gC(r))
    t ? n.push({ from: i.from, insert: r.doc.slice(i.from, i.to) + r.lineBreak }) : n.push({ from: i.to, insert: r.lineBreak + r.doc.slice(i.from, i.to) });
  return e(r.update({ changes: n, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const YWt = ({ state: r, dispatch: e }) => XHe(r, e, !1), XWt = ({ state: r, dispatch: e }) => XHe(r, e, !0), JWt = (r) => {
  if (r.state.readOnly)
    return !1;
  let { state: e } = r, t = e.changes(gC(e).map(({ from: i, to: s }) => (i > 0 ? i-- : s < e.doc.length && s++, { from: i, to: s }))), n = ym(e.selection, (i) => r.moveVertically(i, !0)).map(t);
  return r.dispatch({ changes: t, selection: n, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function $Wt(r, e) {
  if (/\(\)|\[\]|\{\}/.test(r.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let t = Zr(r).resolveInner(e), n = t.childBefore(e), i = t.childAfter(e), s;
  return n && i && n.to <= e && i.from >= e && (s = n.type.prop(Xt.closedBy)) && s.indexOf(i.name) > -1 && r.doc.lineAt(n.to).from == r.doc.lineAt(i.from).from && !/\S/.test(r.sliceDoc(n.to, i.from)) ? { from: n.to, to: i.from } : null;
}
const ejt = /* @__PURE__ */ JHe(!1), tjt = /* @__PURE__ */ JHe(!0);
function JHe(r) {
  return ({ state: e, dispatch: t }) => {
    if (e.readOnly)
      return !1;
    let n = e.changeByRange((i) => {
      let { from: s, to: o } = i, a = e.doc.lineAt(s), l = !r && s == o && $Wt(e, s);
      r && (s = o = (o <= a.to ? a : e.doc.lineAt(o)).to);
      let c = new dC(e, { simulateBreak: s, simulateDoubleBreak: !!l }), d = $V(c, s);
      for (d == null && (d = oC(/^\s*/.exec(e.doc.lineAt(s).text)[0], e.tabSize)); o < a.to && /\s/.test(a.text[o - a.from]); )
        o++;
      l ? { from: s, to: o } = l : s > a.from && s < a.from + 100 && !/\S/.test(a.text.slice(0, s)) && (s = a.from);
      let u = ["", B4(e, d)];
      return l && u.push(B4(e, c.lineIndent(a.from, -1))), {
        changes: { from: s, to: o, insert: li.of(u) },
        range: Be.cursor(s + 1 + u[1].length)
      };
    });
    return t(e.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function dH(r, e) {
  let t = -1;
  return r.changeByRange((n) => {
    let i = [];
    for (let o = n.from; o <= n.to; ) {
      let a = r.doc.lineAt(o);
      a.number > t && (n.empty || n.to > a.from) && (e(a, i, n), t = a.number), o = a.to + 1;
    }
    let s = r.changes(i);
    return {
      changes: i,
      range: Be.range(s.mapPos(n.anchor, 1), s.mapPos(n.head, 1))
    };
  });
}
const njt = ({ state: r, dispatch: e }) => {
  if (r.readOnly)
    return !1;
  let t = /* @__PURE__ */ Object.create(null), n = new dC(r, { overrideIndentation: (s) => {
    let o = t[s];
    return o ?? -1;
  } }), i = dH(r, (s, o, a) => {
    let l = $V(n, s.from);
    if (l == null)
      return;
    /\S/.test(s.text) || (l = 0);
    let c = /^\s*/.exec(s.text)[0], d = B4(r, l);
    (c != d || a.from < s.from + c.length) && (t[s.from] = l, o.push({ from: s.from, to: s.from + c.length, insert: d }));
  });
  return i.changes.empty || e(r.update(i, { userEvent: "indent" })), !0;
}, ijt = ({ state: r, dispatch: e }) => r.readOnly ? !1 : (e(r.update(dH(r, (t, n) => {
  n.push({ from: t.from, insert: r.facet(hC) });
}), { userEvent: "input.indent" })), !0), rjt = ({ state: r, dispatch: e }) => r.readOnly ? !1 : (e(r.update(dH(r, (t, n) => {
  let i = /^\s*/.exec(t.text)[0];
  if (!i)
    return;
  let s = oC(i, r.tabSize), o = 0, a = B4(r, Math.max(0, s - Fb(r)));
  for (; o < i.length && o < a.length && i.charCodeAt(o) == a.charCodeAt(o); )
    o++;
  n.push({ from: t.from + o, to: t.from + i.length, insert: a.slice(o) });
}), { userEvent: "delete.dedent" })), !0), sjt = [
  { key: "Ctrl-b", run: kHe, shift: PHe, preventDefault: !0 },
  { key: "Ctrl-f", run: NHe, shift: FHe },
  { key: "Ctrl-p", run: OHe, shift: jHe },
  { key: "Ctrl-n", run: RHe, shift: ZHe },
  { key: "Ctrl-a", run: _Wt, shift: VWt },
  { key: "Ctrl-e", run: xWt, shift: HWt },
  { key: "Ctrl-d", run: GHe },
  { key: "Ctrl-h", run: CT },
  { key: "Ctrl-k", run: jWt },
  { key: "Ctrl-Alt-h", run: KHe },
  { key: "Ctrl-o", run: qWt },
  { key: "Ctrl-t", run: GWt },
  { key: "Ctrl-v", run: yT }
], ojt = /* @__PURE__ */ [
  { key: "ArrowLeft", run: kHe, shift: PHe, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: gWt, shift: DWt, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: CWt, shift: OWt, preventDefault: !0 },
  { key: "ArrowRight", run: NHe, shift: FHe, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: mWt, shift: LWt, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: EWt, shift: RWt, preventDefault: !0 },
  { key: "ArrowUp", run: OHe, shift: jHe, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: YEe, shift: JEe },
  { mac: "Ctrl-ArrowUp", run: GEe, shift: QEe },
  { key: "ArrowDown", run: RHe, shift: ZHe, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: XEe, shift: $Ee },
  { mac: "Ctrl-ArrowDown", run: yT, shift: KEe },
  { key: "PageUp", run: GEe, shift: QEe },
  { key: "PageDown", run: yT, shift: KEe },
  { key: "Home", run: yWt, shift: IWt, preventDefault: !0 },
  { key: "Mod-Home", run: YEe, shift: JEe },
  { key: "End", run: bWt, shift: TWt, preventDefault: !0 },
  { key: "Mod-End", run: XEe, shift: $Ee },
  { key: "Enter", run: ejt },
  { key: "Mod-a", run: BWt },
  { key: "Backspace", run: CT, shift: CT },
  { key: "Delete", run: GHe },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: KHe },
  { key: "Mod-Delete", mac: "Alt-Delete", run: WWt },
  { mac: "Mod-Backspace", run: ZWt },
  { mac: "Mod-Delete", run: UWt }
].concat(/* @__PURE__ */ sjt.map((r) => ({ mac: r.key, run: r.run, shift: r.shift }))), $He = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: wWt, shift: kWt },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: vWt, shift: NWt },
  { key: "Alt-ArrowUp", run: QWt },
  { key: "Shift-Alt-ArrowUp", run: YWt },
  { key: "Alt-ArrowDown", run: KWt },
  { key: "Shift-Alt-ArrowDown", run: XWt },
  { key: "Escape", run: zWt },
  { key: "Mod-Enter", run: tjt },
  { key: "Alt-l", mac: "Ctrl-l", run: PWt },
  { key: "Mod-i", run: FWt, preventDefault: !0 },
  { key: "Mod-[", run: rjt },
  { key: "Mod-]", run: ijt },
  { key: "Mod-Alt-\\", run: njt },
  { key: "Shift-Mod-k", run: JWt },
  { key: "Shift-Mod-\\", run: MWt },
  { key: "Mod-/", run: lWt },
  { key: "Alt-A", run: hWt }
].concat(ojt);
function Xc() {
  var r = arguments[0];
  typeof r == "string" && (r = document.createElement(r));
  var e = 1, t = arguments[1];
  if (t && typeof t == "object" && t.nodeType == null && !Array.isArray(t)) {
    for (var n in t) if (Object.prototype.hasOwnProperty.call(t, n)) {
      var i = t[n];
      typeof i == "string" ? r.setAttribute(n, i) : i != null && (r[n] = i);
    }
    e++;
  }
  for (; e < arguments.length; e++) eBe(r, arguments[e]);
  return r;
}
function eBe(r, e) {
  if (typeof e == "string")
    r.appendChild(document.createTextNode(e));
  else if (e != null) if (e.nodeType != null)
    r.appendChild(e);
  else if (Array.isArray(e))
    for (var t = 0; t < e.length; t++) eBe(r, e[t]);
  else
    throw new RangeError("Unsupported child node: " + e);
}
class ajt {
  constructor(e, t, n) {
    this.from = e, this.to = t, this.diagnostic = n;
  }
}
class L0 {
  constructor(e, t, n) {
    this.diagnostics = e, this.panel = t, this.selected = n;
  }
  static init(e, t, n) {
    let i = e, s = n.facet(z0).markerFilter;
    s && (i = s(i));
    let o = pi.set(i.map((a) => a.from == a.to || a.from == a.to - 1 && n.doc.lineAt(a.from).to == a.from ? pi.widget({
      widget: new gjt(a),
      diagnostic: a
    }).range(a.from) : pi.mark({
      attributes: { class: "cm-lintRange cm-lintRange-" + a.severity + (a.markClass ? " " + a.markClass : "") },
      diagnostic: a
    }).range(a.from, a.to)), !0);
    return new L0(o, t, Og(o));
  }
}
function Og(r, e = null, t = 0) {
  let n = null;
  return r.between(t, 1e9, (i, s, { spec: o }) => {
    if (!(e && o.diagnostic != e))
      return n = new ajt(i, s, o.diagnostic), !1;
  }), n;
}
function ljt(r, e) {
  let t = r.startState.doc.lineAt(e.pos);
  return !!(r.effects.some((n) => n.is(iv)) || r.changes.touchesRange(t.from, t.to));
}
function cjt(r, e) {
  return r.field(ql, !1) ? e : e.concat(Qn.appendConfig.of(oBe));
}
function hjt(r, e) {
  return {
    effects: cjt(r, [iv.of(e)])
  };
}
const iv = /* @__PURE__ */ Qn.define(), tBe = /* @__PURE__ */ Qn.define(), nBe = /* @__PURE__ */ Qn.define(), ql = /* @__PURE__ */ ka.define({
  create() {
    return new L0(pi.none, null, null);
  },
  update(r, e) {
    if (e.docChanged) {
      let t = r.diagnostics.map(e.changes), n = null;
      if (r.selected) {
        let i = e.changes.mapPos(r.selected.from, 1);
        n = Og(t, r.selected.diagnostic, i) || Og(t, null, i);
      }
      r = new L0(t, r.panel, n);
    }
    for (let t of e.effects)
      t.is(iv) ? r = L0.init(t.value, r.panel, e.state) : t.is(tBe) ? r = new L0(r.diagnostics, t.value ? uH.open : null, r.selected) : t.is(nBe) && (r = new L0(r.diagnostics, r.panel, t.value));
    return r;
  },
  provide: (r) => [
    gT.from(r, (e) => e.panel),
    st.decorations.from(r, (e) => e.diagnostics)
  ]
}), djt = /* @__PURE__ */ pi.mark({ class: "cm-lintRange cm-lintRange-active" });
function ujt(r, e, t) {
  let { diagnostics: n } = r.state.field(ql), i = [], s = 2e8, o = 0;
  n.between(e - (t < 0 ? 1 : 0), e + (t > 0 ? 1 : 0), (l, c, { spec: d }) => {
    e >= l && e <= c && (l == c || (e > l || t > 0) && (e < c || t < 0)) && (i.push(d.diagnostic), s = Math.min(l, s), o = Math.max(c, o));
  });
  let a = r.state.facet(z0).tooltipFilter;
  return a && (i = a(i)), i.length ? {
    pos: s,
    end: o,
    above: r.state.doc.lineAt(s).to < o,
    create() {
      return { dom: fjt(r, i) };
    }
  } : null;
}
function fjt(r, e) {
  return Xc("ul", { class: "cm-tooltip-lint" }, e.map((t) => sBe(r, t, !1)));
}
const e_e = (r) => {
  let e = r.state.field(ql, !1);
  return !e || !e.panel ? !1 : (r.dispatch({ effects: tBe.of(!1) }), !0);
}, pjt = /* @__PURE__ */ Ca.fromClass(class {
  constructor(r) {
    this.view = r, this.timeout = -1, this.set = !0;
    let { delay: e } = r.state.facet(z0);
    this.lintTime = Date.now() + e, this.run = this.run.bind(this), this.timeout = setTimeout(this.run, e);
  }
  run() {
    let r = Date.now();
    if (r < this.lintTime - 10)
      this.timeout = setTimeout(this.run, this.lintTime - r);
    else {
      this.set = !1;
      let { state: e } = this.view, { sources: t } = e.facet(z0);
      Promise.all(t.map((n) => Promise.resolve(n(this.view)))).then((n) => {
        let i = n.reduce((s, o) => s.concat(o));
        this.view.state.doc == e.doc && this.view.dispatch(hjt(this.view.state, i));
      }, (n) => {
        va(this.view.state, n);
      });
    }
  }
  update(r) {
    let e = r.state.facet(z0);
    (r.docChanged || e != r.startState.facet(z0) || e.needsRefresh && e.needsRefresh(r)) && (this.lintTime = Date.now() + e.delay, this.set || (this.set = !0, this.timeout = setTimeout(this.run, e.delay)));
  }
  force() {
    this.set && (this.lintTime = Date.now(), this.run());
  }
  destroy() {
    clearTimeout(this.timeout);
  }
}), z0 = /* @__PURE__ */ bt.define({
  combine(r) {
    return Object.assign({ sources: r.map((e) => e.source) }, sC(r.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null
    }, {
      needsRefresh: (e, t) => e ? t ? (n) => e(n) || t(n) : e : t
    }));
  }
});
function iBe(r, e = {}) {
  return [
    z0.of({ source: r, config: e }),
    pjt,
    oBe
  ];
}
function rBe(r) {
  let e = [];
  if (r)
    e: for (let { name: t } of r) {
      for (let n = 0; n < t.length; n++) {
        let i = t[n];
        if (/[a-zA-Z]/.test(i) && !e.some((s) => s.toLowerCase() == i.toLowerCase())) {
          e.push(i);
          continue e;
        }
      }
      e.push("");
    }
  return e;
}
function sBe(r, e, t) {
  var n;
  let i = t ? rBe(e.actions) : [];
  return Xc("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, Xc("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage() : e.message), (n = e.actions) === null || n === void 0 ? void 0 : n.map((s, o) => {
    let a = !1, l = (f) => {
      if (f.preventDefault(), a)
        return;
      a = !0;
      let p = Og(r.state.field(ql).diagnostics, e);
      p && s.apply(r, p.from, p.to);
    }, { name: c } = s, d = i[o] ? c.indexOf(i[o]) : -1, u = d < 0 ? c : [
      c.slice(0, d),
      Xc("u", c.slice(d, d + 1)),
      c.slice(d + 1)
    ];
    return Xc("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: l,
      onmousedown: l,
      "aria-label": ` Action: ${c}${d < 0 ? "" : ` (access key "${i[o]})"`}.`
    }, u);
  }), e.source && Xc("div", { class: "cm-diagnosticSource" }, e.source));
}
class gjt extends Xw {
  constructor(e) {
    super(), this.diagnostic = e;
  }
  eq(e) {
    return e.diagnostic == this.diagnostic;
  }
  toDOM() {
    return Xc("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class t_e {
  constructor(e, t) {
    this.diagnostic = t, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = sBe(e, t, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class uH {
  constructor(e) {
    this.view = e, this.items = [];
    let t = (i) => {
      if (i.keyCode == 27)
        e_e(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: s } = this.items[this.selectedIndex], o = rBe(s.actions);
        for (let a = 0; a < o.length; a++)
          if (o[a].toUpperCase().charCodeAt(0) == i.keyCode) {
            let l = Og(this.view.state.field(ql).diagnostics, s);
            l && s.actions[a].apply(e, l.from, l.to);
          }
      } else
        return;
      i.preventDefault();
    }, n = (i) => {
      for (let s = 0; s < this.items.length; s++)
        this.items[s].dom.contains(i.target) && this.moveSelection(s);
    };
    this.list = Xc("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: t,
      onclick: n
    }), this.dom = Xc("div", { class: "cm-panel-lint" }, this.list, Xc("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => e_e(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(ql).selected;
    if (!e)
      return -1;
    for (let t = 0; t < this.items.length; t++)
      if (this.items[t].diagnostic == e.diagnostic)
        return t;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: t } = this.view.state.field(ql), n = 0, i = !1, s = null;
    for (e.between(0, this.view.state.doc.length, (o, a, { spec: l }) => {
      let c = -1, d;
      for (let u = n; u < this.items.length; u++)
        if (this.items[u].diagnostic == l.diagnostic) {
          c = u;
          break;
        }
      c < 0 ? (d = new t_e(this.view, l.diagnostic), this.items.splice(n, 0, d), i = !0) : (d = this.items[c], c > n && (this.items.splice(n, c - n), i = !0)), t && d.diagnostic == t.diagnostic ? d.dom.hasAttribute("aria-selected") || (d.dom.setAttribute("aria-selected", "true"), s = d) : d.dom.hasAttribute("aria-selected") && d.dom.removeAttribute("aria-selected"), n++;
    }); n < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new t_e(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: s.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: o, panel: a }) => {
        let l = a.height / this.list.offsetHeight;
        o.top < a.top ? this.list.scrollTop -= (a.top - o.top) / l : o.bottom > a.bottom && (this.list.scrollTop += (o.bottom - a.bottom) / l);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function t() {
      let n = e;
      e = n.nextSibling, n.remove();
    }
    for (let n of this.items)
      if (n.dom.parentNode == this.list) {
        for (; e != n.dom; )
          t();
        e = n.dom.nextSibling;
      } else
        this.list.insertBefore(n.dom, e);
    for (; e; )
      t();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let t = this.view.state.field(ql), n = Og(t.diagnostics, this.items[e].diagnostic);
    n && this.view.dispatch({
      selection: { anchor: n.from, head: n.to },
      scrollIntoView: !0,
      effects: nBe.of(n)
    });
  }
  static open(e) {
    return new uH(e);
  }
}
function mjt(r, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(r)}</svg>')`;
}
function Y5(r) {
  return mjt(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${r}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const Ajt = /* @__PURE__ */ st.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ Y5("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ Y5("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ Y5("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ Y5("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
}), oBe = [
  ql,
  /* @__PURE__ */ st.decorations.compute([ql], (r) => {
    let { selected: e, panel: t } = r.field(ql);
    return !e || !t || e.from == e.to ? pi.none : pi.set([
      djt.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ TFt(ujt, { hideOn: ljt }),
  Ajt
];
class Zb {
  static create(e, t, n, i, s) {
    let o = i + (i << 8) + e + (t << 4) | 0;
    return new Zb(e, t, n, o, s, [], []);
  }
  constructor(e, t, n, i, s, o, a) {
    this.type = e, this.value = t, this.from = n, this.hash = i, this.end = s, this.children = o, this.positions = a, this.hashProp = [[Xt.contextHash, i]];
  }
  addChild(e, t) {
    e.prop(Xt.contextHash) != this.hash && (e = new ci(e.type, e.children, e.positions, e.length, this.hashProp)), this.children.push(e), this.positions.push(t);
  }
  toTree(e, t = this.end) {
    let n = this.children.length - 1;
    return n >= 0 && (t = Math.max(t, this.positions[n] + this.children[n].length + this.from)), new ci(e.types[this.type], this.children, this.positions, t - this.from).balance({
      makeTree: (i, s, o) => new ci(jr.none, i, s, o, this.hashProp)
    });
  }
}
var Ge;
(function(r) {
  r[r.Document = 1] = "Document", r[r.CodeBlock = 2] = "CodeBlock", r[r.FencedCode = 3] = "FencedCode", r[r.Blockquote = 4] = "Blockquote", r[r.HorizontalRule = 5] = "HorizontalRule", r[r.BulletList = 6] = "BulletList", r[r.OrderedList = 7] = "OrderedList", r[r.ListItem = 8] = "ListItem", r[r.ATXHeading1 = 9] = "ATXHeading1", r[r.ATXHeading2 = 10] = "ATXHeading2", r[r.ATXHeading3 = 11] = "ATXHeading3", r[r.ATXHeading4 = 12] = "ATXHeading4", r[r.ATXHeading5 = 13] = "ATXHeading5", r[r.ATXHeading6 = 14] = "ATXHeading6", r[r.SetextHeading1 = 15] = "SetextHeading1", r[r.SetextHeading2 = 16] = "SetextHeading2", r[r.HTMLBlock = 17] = "HTMLBlock", r[r.LinkReference = 18] = "LinkReference", r[r.Paragraph = 19] = "Paragraph", r[r.CommentBlock = 20] = "CommentBlock", r[r.ProcessingInstructionBlock = 21] = "ProcessingInstructionBlock", r[r.Escape = 22] = "Escape", r[r.Entity = 23] = "Entity", r[r.HardBreak = 24] = "HardBreak", r[r.Emphasis = 25] = "Emphasis", r[r.StrongEmphasis = 26] = "StrongEmphasis", r[r.Link = 27] = "Link", r[r.Image = 28] = "Image", r[r.InlineCode = 29] = "InlineCode", r[r.HTMLTag = 30] = "HTMLTag", r[r.Comment = 31] = "Comment", r[r.ProcessingInstruction = 32] = "ProcessingInstruction", r[r.Autolink = 33] = "Autolink", r[r.HeaderMark = 34] = "HeaderMark", r[r.QuoteMark = 35] = "QuoteMark", r[r.ListMark = 36] = "ListMark", r[r.LinkMark = 37] = "LinkMark", r[r.EmphasisMark = 38] = "EmphasisMark", r[r.CodeMark = 39] = "CodeMark", r[r.CodeText = 40] = "CodeText", r[r.CodeInfo = 41] = "CodeInfo", r[r.LinkTitle = 42] = "LinkTitle", r[r.LinkLabel = 43] = "LinkLabel", r[r.URL = 44] = "URL";
})(Ge || (Ge = {}));
class wjt {
  /// @internal
  constructor(e, t) {
    this.start = e, this.content = t, this.marks = [], this.parsers = [];
  }
}
class vjt {
  constructor() {
    this.text = "", this.baseIndent = 0, this.basePos = 0, this.depth = 0, this.markers = [], this.pos = 0, this.indent = 0, this.next = -1;
  }
  /// @internal
  forward() {
    this.basePos > this.pos && this.forwardInner();
  }
  /// @internal
  forwardInner() {
    let e = this.skipSpace(this.basePos);
    this.indent = this.countIndent(e, this.pos, this.indent), this.pos = e, this.next = e == this.text.length ? -1 : this.text.charCodeAt(e);
  }
  /// Skip whitespace after the given position, return the position of
  /// the next non-space character or the end of the line if there's
  /// only space after `from`.
  skipSpace(e) {
    return v3(this.text, e);
  }
  /// @internal
  reset(e) {
    for (this.text = e, this.baseIndent = this.basePos = this.pos = this.indent = 0, this.forwardInner(), this.depth = 1; this.markers.length; )
      this.markers.pop();
  }
  /// Move the line's base position forward to the given position.
  /// This should only be called by composite [block
  /// parsers](#BlockParser.parse) or [markup skipping
  /// functions](#NodeSpec.composite).
  moveBase(e) {
    this.basePos = e, this.baseIndent = this.countIndent(e, this.pos, this.indent);
  }
  /// Move the line's base position forward to the given _column_.
  moveBaseColumn(e) {
    this.baseIndent = e, this.basePos = this.findColumn(e);
  }
  /// Store a composite-block-level marker. Should be called from
  /// [markup skipping functions](#NodeSpec.composite) when they
  /// consume any non-whitespace characters.
  addMarker(e) {
    this.markers.push(e);
  }
  /// Find the column position at `to`, optionally starting at a given
  /// position and column.
  countIndent(e, t = 0, n = 0) {
    for (let i = t; i < e; i++)
      n += this.text.charCodeAt(i) == 9 ? 4 - n % 4 : 1;
    return n;
  }
  /// Find the position corresponding to the given column.
  findColumn(e) {
    let t = 0;
    for (let n = 0; t < this.text.length && n < e; t++)
      n += this.text.charCodeAt(t) == 9 ? 4 - n % 4 : 1;
    return t;
  }
  /// @internal
  scrub() {
    if (!this.baseIndent)
      return this.text;
    let e = "";
    for (let t = 0; t < this.basePos; t++)
      e += " ";
    return e + this.text.slice(this.basePos);
  }
}
function n_e(r, e, t) {
  if (t.pos == t.text.length || r != e.block && t.indent >= e.stack[t.depth + 1].value + t.baseIndent)
    return !0;
  if (t.indent >= t.baseIndent + 4)
    return !1;
  let n = (r.type == Ge.OrderedList ? gH : pH)(t, e, !1);
  return n > 0 && (r.type != Ge.BulletList || fH(t, e, !1) < 0) && t.text.charCodeAt(t.pos + n - 1) == r.value;
}
const aBe = {
  [Ge.Blockquote](r, e, t) {
    return t.next != 62 ? !1 : (t.markers.push(Fn(Ge.QuoteMark, e.lineStart + t.pos, e.lineStart + t.pos + 1)), t.moveBase(t.pos + (vc(t.text.charCodeAt(t.pos + 1)) ? 2 : 1)), r.end = e.lineStart + t.text.length, !0);
  },
  [Ge.ListItem](r, e, t) {
    return t.indent < t.baseIndent + r.value && t.next > -1 ? !1 : (t.moveBaseColumn(t.baseIndent + r.value), !0);
  },
  [Ge.OrderedList]: n_e,
  [Ge.BulletList]: n_e,
  [Ge.Document]() {
    return !0;
  }
};
function vc(r) {
  return r == 32 || r == 9 || r == 10 || r == 13;
}
function v3(r, e = 0) {
  for (; e < r.length && vc(r.charCodeAt(e)); )
    e++;
  return e;
}
function i_e(r, e, t) {
  for (; e > t && vc(r.charCodeAt(e - 1)); )
    e--;
  return e;
}
function lBe(r) {
  if (r.next != 96 && r.next != 126)
    return -1;
  let e = r.pos + 1;
  for (; e < r.text.length && r.text.charCodeAt(e) == r.next; )
    e++;
  if (e < r.pos + 3)
    return -1;
  if (r.next == 96) {
    for (let t = e; t < r.text.length; t++)
      if (r.text.charCodeAt(t) == 96)
        return -1;
  }
  return e;
}
function cBe(r) {
  return r.next != 62 ? -1 : r.text.charCodeAt(r.pos + 1) == 32 ? 2 : 1;
}
function fH(r, e, t) {
  if (r.next != 42 && r.next != 45 && r.next != 95)
    return -1;
  let n = 1;
  for (let i = r.pos + 1; i < r.text.length; i++) {
    let s = r.text.charCodeAt(i);
    if (s == r.next)
      n++;
    else if (!vc(s))
      return -1;
  }
  return t && r.next == 45 && uBe(r) > -1 && r.depth == e.stack.length || n < 3 ? -1 : 1;
}
function hBe(r, e) {
  for (let t = r.stack.length - 1; t >= 0; t--)
    if (r.stack[t].type == e)
      return !0;
  return !1;
}
function pH(r, e, t) {
  return (r.next == 45 || r.next == 43 || r.next == 42) && (r.pos == r.text.length - 1 || vc(r.text.charCodeAt(r.pos + 1))) && (!t || hBe(e, Ge.BulletList) || r.skipSpace(r.pos + 2) < r.text.length) ? 1 : -1;
}
function gH(r, e, t) {
  let n = r.pos, i = r.next;
  for (; i >= 48 && i <= 57; ) {
    n++;
    if (n == r.text.length)
      return -1;
    i = r.text.charCodeAt(n);
  }
  return n == r.pos || n > r.pos + 9 || i != 46 && i != 41 || n < r.text.length - 1 && !vc(r.text.charCodeAt(n + 1)) || t && !hBe(e, Ge.OrderedList) && (r.skipSpace(n + 1) == r.text.length || n > r.pos + 1 || r.next != 49) ? -1 : n + 1 - r.pos;
}
function dBe(r) {
  if (r.next != 35)
    return -1;
  let e = r.pos + 1;
  for (; e < r.text.length && r.text.charCodeAt(e) == 35; )
    e++;
  if (e < r.text.length && r.text.charCodeAt(e) != 32)
    return -1;
  let t = e - r.pos;
  return t > 6 ? -1 : t;
}
function uBe(r) {
  if (r.next != 45 && r.next != 61 || r.indent >= r.baseIndent + 4)
    return -1;
  let e = r.pos + 1;
  for (; e < r.text.length && r.text.charCodeAt(e) == r.next; )
    e++;
  let t = e;
  for (; e < r.text.length && vc(r.text.charCodeAt(e)); )
    e++;
  return e == r.text.length ? t : -1;
}
const ET = /^[ \t]*$/, fBe = /-->/, pBe = /\?>/, _T = [
  [/^<(?:script|pre|style)(?:\s|>|$)/i, /<\/(?:script|pre|style)>/i],
  [/^\s*<!--/, fBe],
  [/^\s*<\?/, pBe],
  [/^\s*<![A-Z]/, />/],
  [/^\s*<!\[CDATA\[/, /\]\]>/],
  [/^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i, ET],
  [/^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i, ET]
];
function gBe(r, e, t) {
  if (r.next != 60)
    return -1;
  let n = r.text.slice(r.pos);
  for (let i = 0, s = _T.length - (t ? 1 : 0); i < s; i++)
    if (_T[i][0].test(n))
      return i;
  return -1;
}
function r_e(r, e) {
  let t = r.countIndent(e, r.pos, r.indent), n = r.countIndent(r.skipSpace(e), e, t);
  return n >= t + 5 ? t + 1 : n;
}
function e0(r, e, t) {
  let n = r.length - 1;
  n >= 0 && r[n].to == e && r[n].type == Ge.CodeText ? r[n].to = t : r.push(Fn(Ge.CodeText, e, t));
}
const X5 = {
  LinkReference: void 0,
  IndentedCode(r, e) {
    let t = e.baseIndent + 4;
    if (e.indent < t)
      return !1;
    let n = e.findColumn(t), i = r.lineStart + n, s = r.lineStart + e.text.length, o = [], a = [];
    for (e0(o, i, s); r.nextLine() && e.depth >= r.stack.length; )
      if (e.pos == e.text.length) {
        e0(a, r.lineStart - 1, r.lineStart);
        for (let l of e.markers)
          a.push(l);
      } else {
        if (e.indent < t)
          break;
        {
          if (a.length) {
            for (let c of a)
              c.type == Ge.CodeText ? e0(o, c.from, c.to) : o.push(c);
            a = [];
          }
          e0(o, r.lineStart - 1, r.lineStart);
          for (let c of e.markers)
            o.push(c);
          s = r.lineStart + e.text.length;
          let l = r.lineStart + e.findColumn(e.baseIndent + 4);
          l < s && e0(o, l, s);
        }
      }
    return a.length && (a = a.filter((l) => l.type != Ge.CodeText), a.length && (e.markers = a.concat(e.markers))), r.addNode(r.buffer.writeElements(o, -i).finish(Ge.CodeBlock, s - i), i), !0;
  },
  FencedCode(r, e) {
    let t = lBe(e);
    if (t < 0)
      return !1;
    let n = r.lineStart + e.pos, i = e.next, s = t - e.pos, o = e.skipSpace(t), a = i_e(e.text, e.text.length, o), l = [Fn(Ge.CodeMark, n, n + s)];
    o < a && l.push(Fn(Ge.CodeInfo, r.lineStart + o, r.lineStart + a));
    for (let c = !0; r.nextLine() && e.depth >= r.stack.length; c = !1) {
      let d = e.pos;
      if (e.indent - e.baseIndent < 4)
        for (; d < e.text.length && e.text.charCodeAt(d) == i; )
          d++;
      if (d - e.pos >= s && e.skipSpace(d) == e.text.length) {
        for (let u of e.markers)
          l.push(u);
        l.push(Fn(Ge.CodeMark, r.lineStart + e.pos, r.lineStart + d)), r.nextLine();
        break;
      } else {
        c || e0(l, r.lineStart - 1, r.lineStart);
        for (let p of e.markers)
          l.push(p);
        let u = r.lineStart + e.basePos, f = r.lineStart + e.text.length;
        u < f && e0(l, u, f);
      }
    }
    return r.addNode(r.buffer.writeElements(l, -n).finish(Ge.FencedCode, r.prevLineEnd() - n), n), !0;
  },
  Blockquote(r, e) {
    let t = cBe(e);
    return t < 0 ? !1 : (r.startContext(Ge.Blockquote, e.pos), r.addNode(Ge.QuoteMark, r.lineStart + e.pos, r.lineStart + e.pos + 1), e.moveBase(e.pos + t), null);
  },
  HorizontalRule(r, e) {
    if (fH(e, r, !1) < 0)
      return !1;
    let t = r.lineStart + e.pos;
    return r.nextLine(), r.addNode(Ge.HorizontalRule, t), !0;
  },
  BulletList(r, e) {
    let t = pH(e, r, !1);
    if (t < 0)
      return !1;
    r.block.type != Ge.BulletList && r.startContext(Ge.BulletList, e.basePos, e.next);
    let n = r_e(e, e.pos + 1);
    return r.startContext(Ge.ListItem, e.basePos, n - e.baseIndent), r.addNode(Ge.ListMark, r.lineStart + e.pos, r.lineStart + e.pos + t), e.moveBaseColumn(n), null;
  },
  OrderedList(r, e) {
    let t = gH(e, r, !1);
    if (t < 0)
      return !1;
    r.block.type != Ge.OrderedList && r.startContext(Ge.OrderedList, e.basePos, e.text.charCodeAt(e.pos + t - 1));
    let n = r_e(e, e.pos + t);
    return r.startContext(Ge.ListItem, e.basePos, n - e.baseIndent), r.addNode(Ge.ListMark, r.lineStart + e.pos, r.lineStart + e.pos + t), e.moveBaseColumn(n), null;
  },
  ATXHeading(r, e) {
    let t = dBe(e);
    if (t < 0)
      return !1;
    let n = e.pos, i = r.lineStart + n, s = i_e(e.text, e.text.length, n), o = s;
    for (; o > n && e.text.charCodeAt(o - 1) == e.next; )
      o--;
    (o == s || o == n || !vc(e.text.charCodeAt(o - 1))) && (o = e.text.length);
    let a = r.buffer.write(Ge.HeaderMark, 0, t).writeElements(r.parser.parseInline(e.text.slice(n + t + 1, o), i + t + 1), -i);
    o < e.text.length && a.write(Ge.HeaderMark, o - n, s - n);
    let l = a.finish(Ge.ATXHeading1 - 1 + t, e.text.length - n);
    return r.nextLine(), r.addNode(l, i), !0;
  },
  HTMLBlock(r, e) {
    let t = gBe(e, r, !1);
    if (t < 0)
      return !1;
    let n = r.lineStart + e.pos, i = _T[t][1], s = [], o = i != ET;
    for (; !i.test(e.text) && r.nextLine(); ) {
      if (e.depth < r.stack.length) {
        o = !1;
        break;
      }
      for (let c of e.markers)
        s.push(c);
    }
    o && r.nextLine();
    let a = i == fBe ? Ge.CommentBlock : i == pBe ? Ge.ProcessingInstructionBlock : Ge.HTMLBlock, l = r.prevLineEnd();
    return r.addNode(r.buffer.writeElements(s, -n).finish(a, l - n), n), !0;
  },
  SetextHeading: void 0
  // Specifies relative precedence for block-continue function
};
class bjt {
  constructor(e) {
    this.stage = 0, this.elts = [], this.pos = 0, this.start = e.start, this.advance(e.content);
  }
  nextLine(e, t, n) {
    if (this.stage == -1)
      return !1;
    let i = n.content + `
` + t.scrub(), s = this.advance(i);
    return s > -1 && s < i.length ? this.complete(e, n, s) : !1;
  }
  finish(e, t) {
    return (this.stage == 2 || this.stage == 3) && v3(t.content, this.pos) == t.content.length ? this.complete(e, t, t.content.length) : !1;
  }
  complete(e, t, n) {
    return e.addLeafElement(t, Fn(Ge.LinkReference, this.start, this.start + n, this.elts)), !0;
  }
  nextStage(e) {
    return e ? (this.pos = e.to - this.start, this.elts.push(e), this.stage++, !0) : (e === !1 && (this.stage = -1), !1);
  }
  advance(e) {
    for (; ; ) {
      if (this.stage == -1)
        return -1;
      if (this.stage == 0) {
        if (!this.nextStage(_Be(e, this.pos, this.start, !0)))
          return -1;
        if (e.charCodeAt(this.pos) != 58)
          return this.stage = -1;
        this.elts.push(Fn(Ge.LinkMark, this.pos + this.start, this.pos + this.start + 1)), this.pos++;
      } else if (this.stage == 1) {
        if (!this.nextStage(CBe(e, v3(e, this.pos), this.start)))
          return -1;
      } else if (this.stage == 2) {
        let t = v3(e, this.pos), n = 0;
        if (t > this.pos) {
          let i = EBe(e, t, this.start);
          if (i) {
            let s = HS(e, i.to - this.start);
            s > 0 && (this.nextStage(i), n = s);
          }
        }
        return n || (n = HS(e, this.pos)), n > 0 && n < e.length ? n : -1;
      } else
        return HS(e, this.pos);
    }
  }
}
function HS(r, e) {
  for (; e < r.length; e++) {
    let t = r.charCodeAt(e);
    if (t == 10)
      break;
    if (!vc(t))
      return -1;
  }
  return e;
}
class yjt {
  nextLine(e, t, n) {
    let i = t.depth < e.stack.length ? -1 : uBe(t), s = t.next;
    if (i < 0)
      return !1;
    let o = Fn(Ge.HeaderMark, e.lineStart + t.pos, e.lineStart + i);
    return e.nextLine(), e.addLeafElement(n, Fn(s == 61 ? Ge.SetextHeading1 : Ge.SetextHeading2, n.start, e.prevLineEnd(), [
      ...e.parser.parseInline(n.content, n.start),
      o
    ])), !0;
  }
  finish() {
    return !1;
  }
}
const Cjt = {
  LinkReference(r, e) {
    return e.content.charCodeAt(0) == 91 ? new bjt(e) : null;
  },
  SetextHeading() {
    return new yjt();
  }
}, Ejt = [
  (r, e) => dBe(e) >= 0,
  (r, e) => lBe(e) >= 0,
  (r, e) => cBe(e) >= 0,
  (r, e) => pH(e, r, !0) >= 0,
  (r, e) => gH(e, r, !0) >= 0,
  (r, e) => fH(e, r, !0) >= 0,
  (r, e) => gBe(e, r, !0) >= 0
], _jt = { text: "", end: 0 };
class xjt {
  /// @internal
  constructor(e, t, n, i) {
    this.parser = e, this.input = t, this.ranges = i, this.line = new vjt(), this.atEnd = !1, this.reusePlaceholders = /* @__PURE__ */ new Map(), this.stoppedAt = null, this.rangeI = 0, this.to = i[i.length - 1].to, this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = i[0].from, this.block = Zb.create(Ge.Document, 0, this.lineStart, 0, 0), this.stack = [this.block], this.fragments = n.length ? new Ljt(n, t) : null, this.readLine();
  }
  get parsedPos() {
    return this.absoluteLineStart;
  }
  advance() {
    if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt)
      return this.finish();
    let { line: e } = this;
    for (; ; ) {
      for (let n = 0; ; ) {
        let i = e.depth < this.stack.length ? this.stack[this.stack.length - 1] : null;
        for (; n < e.markers.length && (!i || e.markers[n].from < i.end); ) {
          let s = e.markers[n++];
          this.addNode(s.type, s.from, s.to);
        }
        if (!i)
          break;
        this.finishContext();
      }
      if (e.pos < e.text.length)
        break;
      if (!this.nextLine())
        return this.finish();
    }
    if (this.fragments && this.reuseFragment(e.basePos))
      return null;
    e: for (; ; ) {
      for (let n of this.parser.blockParsers)
        if (n) {
          let i = n(this, e);
          if (i != !1) {
            if (i == !0)
              return null;
            e.forward();
            continue e;
          }
        }
      break;
    }
    let t = new wjt(this.lineStart + e.pos, e.text.slice(e.pos));
    for (let n of this.parser.leafBlockParsers)
      if (n) {
        let i = n(this, t);
        i && t.parsers.push(i);
      }
    e: for (; this.nextLine() && e.pos != e.text.length; ) {
      if (e.indent < e.baseIndent + 4) {
        for (let n of this.parser.endLeafBlock)
          if (n(this, e, t))
            break e;
      }
      for (let n of t.parsers)
        if (n.nextLine(this, e, t))
          return null;
      t.content += `
` + e.scrub();
      for (let n of e.markers)
        t.marks.push(n);
    }
    return this.finishLeaf(t), null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  reuseFragment(e) {
    if (!this.fragments.moveTo(this.absoluteLineStart + e, this.absoluteLineStart) || !this.fragments.matches(this.block.hash))
      return !1;
    let t = this.fragments.takeNodes(this);
    return t ? (this.absoluteLineStart += t, this.lineStart = xBe(this.absoluteLineStart, this.ranges), this.moveRangeI(), this.absoluteLineStart < this.to ? (this.lineStart++, this.absoluteLineStart++, this.readLine()) : (this.atEnd = !0, this.readLine()), !0) : !1;
  }
  /// The number of parent blocks surrounding the current block.
  get depth() {
    return this.stack.length;
  }
  /// Get the type of the parent block at the given depth. When no
  /// depth is passed, return the type of the innermost parent.
  parentType(e = this.depth - 1) {
    return this.parser.nodeSet.types[this.stack[e].type];
  }
  /// Move to the next input line. This should only be called by
  /// (non-composite) [block parsers](#BlockParser.parse) that consume
  /// the line directly, or leaf block parser
  /// [`nextLine`](#LeafBlockParser.nextLine) methods when they
  /// consume the current line (and return true).
  nextLine() {
    return this.lineStart += this.line.text.length, this.absoluteLineEnd >= this.to ? (this.absoluteLineStart = this.absoluteLineEnd, this.atEnd = !0, this.readLine(), !1) : (this.lineStart++, this.absoluteLineStart = this.absoluteLineEnd + 1, this.moveRangeI(), this.readLine(), !0);
  }
  moveRangeI() {
    for (; this.rangeI < this.ranges.length - 1 && this.absoluteLineStart >= this.ranges[this.rangeI].to; )
      this.rangeI++, this.absoluteLineStart = Math.max(this.absoluteLineStart, this.ranges[this.rangeI].from);
  }
  /// @internal
  scanLine(e) {
    let t = _jt;
    if (t.end = e, e >= this.to)
      t.text = "";
    else if (t.text = this.lineChunkAt(e), t.end += t.text.length, this.ranges.length > 1) {
      let n = this.absoluteLineStart, i = this.rangeI;
      for (; this.ranges[i].to < t.end; ) {
        i++;
        let s = this.ranges[i].from, o = this.lineChunkAt(s);
        t.end = s + o.length, t.text = t.text.slice(0, this.ranges[i - 1].to - n) + o, n = t.end - t.text.length;
      }
    }
    return t;
  }
  /// @internal
  readLine() {
    let { line: e } = this, { text: t, end: n } = this.scanLine(this.absoluteLineStart);
    for (this.absoluteLineEnd = n, e.reset(t); e.depth < this.stack.length; e.depth++) {
      let i = this.stack[e.depth], s = this.parser.skipContextMarkup[i.type];
      if (!s)
        throw new Error("Unhandled block context " + Ge[i.type]);
      if (!s(i, this, e))
        break;
      e.forward();
    }
  }
  lineChunkAt(e) {
    let t = this.input.chunk(e), n;
    if (this.input.lineChunks)
      n = t == `
` ? "" : t;
    else {
      let i = t.indexOf(`
`);
      n = i < 0 ? t : t.slice(0, i);
    }
    return e + n.length > this.to ? n.slice(0, this.to - e) : n;
  }
  /// The end position of the previous line.
  prevLineEnd() {
    return this.atEnd ? this.lineStart : this.lineStart - 1;
  }
  /// @internal
  startContext(e, t, n = 0) {
    this.block = Zb.create(e, n, this.lineStart + t, this.block.hash, this.lineStart + this.line.text.length), this.stack.push(this.block);
  }
  /// Start a composite block. Should only be called from [block
  /// parser functions](#BlockParser.parse) that return null.
  startComposite(e, t, n = 0) {
    this.startContext(this.parser.getNodeType(e), t, n);
  }
  /// @internal
  addNode(e, t, n) {
    typeof e == "number" && (e = new ci(this.parser.nodeSet.types[e], Rg, Rg, (n ?? this.prevLineEnd()) - t)), this.block.addChild(e, t - this.block.from);
  }
  /// Add a block element. Can be called by [block
  /// parsers](#BlockParser.parse).
  addElement(e) {
    this.block.addChild(e.toTree(this.parser.nodeSet), e.from - this.block.from);
  }
  /// Add a block element from a [leaf parser](#LeafBlockParser). This
  /// makes sure any extra composite block markup (such as blockquote
  /// markers) inside the block are also added to the syntax tree.
  addLeafElement(e, t) {
    this.addNode(this.buffer.writeElements(DT(t.children, e.marks), -t.from).finish(t.type, t.to - t.from), t.from);
  }
  /// @internal
  finishContext() {
    let e = this.stack.pop(), t = this.stack[this.stack.length - 1];
    t.addChild(e.toTree(this.parser.nodeSet), e.from - t.from), this.block = t;
  }
  finish() {
    for (; this.stack.length > 1; )
      this.finishContext();
    return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
  }
  addGaps(e) {
    return this.ranges.length > 1 ? mBe(this.ranges, 0, e.topNode, this.ranges[0].from, this.reusePlaceholders) : e;
  }
  /// @internal
  finishLeaf(e) {
    for (let n of e.parsers)
      if (n.finish(this, e))
        return;
    let t = DT(this.parser.parseInline(e.content, e.start), e.marks);
    this.addNode(this.buffer.writeElements(t, -e.start).finish(Ge.Paragraph, e.content.length), e.start);
  }
  elt(e, t, n, i) {
    return typeof e == "string" ? Fn(this.parser.getNodeType(e), t, n, i) : new vBe(e, t);
  }
  /// @internal
  get buffer() {
    return new wBe(this.parser.nodeSet);
  }
}
function mBe(r, e, t, n, i) {
  let s = r[e].to, o = [], a = [], l = t.from + n;
  function c(d, u) {
    for (; u ? d >= s : d > s; ) {
      let f = r[e + 1].from - s;
      n += f, d += f, e++, s = r[e].to;
    }
  }
  for (let d = t.firstChild; d; d = d.nextSibling) {
    c(d.from + n, !0);
    let u = d.from + n, f, p = i.get(d.tree);
    p ? f = p : d.to + n > s ? (f = mBe(r, e, d, n, i), c(d.to + n, !1)) : f = d.toTree(), o.push(f), a.push(u - l);
  }
  return c(t.to + n, !1), new ci(t.type, o, a, t.to + n - l, t.tree ? t.tree.propValues : void 0);
}
class mH extends HV {
  /// @internal
  constructor(e, t, n, i, s, o, a, l, c) {
    super(), this.nodeSet = e, this.blockParsers = t, this.leafBlockParsers = n, this.blockNames = i, this.endLeafBlock = s, this.skipContextMarkup = o, this.inlineParsers = a, this.inlineNames = l, this.wrappers = c, this.nodeTypes = /* @__PURE__ */ Object.create(null);
    for (let d of e.types)
      this.nodeTypes[d.name] = d.id;
  }
  createParse(e, t, n) {
    let i = new xjt(this, e, t, n);
    for (let s of this.wrappers)
      i = s(i, e, t, n);
    return i;
  }
  /// Reconfigure the parser.
  configure(e) {
    let t = xT(e);
    if (!t)
      return this;
    let { nodeSet: n, skipContextMarkup: i } = this, s = this.blockParsers.slice(), o = this.leafBlockParsers.slice(), a = this.blockNames.slice(), l = this.inlineParsers.slice(), c = this.inlineNames.slice(), d = this.endLeafBlock.slice(), u = this.wrappers;
    if (oA(t.defineNodes)) {
      i = Object.assign({}, i);
      let f = n.types.slice(), p;
      for (let g of t.defineNodes) {
        let { name: m, block: A, composite: w, style: v } = typeof g == "string" ? { name: g } : g;
        if (f.some((S) => S.name == m))
          continue;
        w && (i[f.length] = (S, D, M) => w(D, M, S.value));
        let y = f.length, _ = w ? ["Block", "BlockContext"] : A ? y >= Ge.ATXHeading1 && y <= Ge.SetextHeading2 ? ["Block", "LeafBlock", "Heading"] : ["Block", "LeafBlock"] : void 0;
        f.push(jr.define({
          id: y,
          name: m,
          props: _ && [[Xt.group, _]]
        })), v && (p || (p = {}), Array.isArray(v) || v instanceof td ? p[m] = v : Object.assign(p, v));
      }
      n = new Gw(f), p && (n = n.extend(Qw(p)));
    }
    if (oA(t.props) && (n = n.extend(...t.props)), oA(t.remove))
      for (let f of t.remove) {
        let p = this.blockNames.indexOf(f), g = this.inlineNames.indexOf(f);
        p > -1 && (s[p] = o[p] = void 0), g > -1 && (l[g] = void 0);
      }
    if (oA(t.parseBlock))
      for (let f of t.parseBlock) {
        let p = a.indexOf(f.name);
        if (p > -1)
          s[p] = f.parse, o[p] = f.leaf;
        else {
          let g = f.before ? J5(a, f.before) : f.after ? J5(a, f.after) + 1 : a.length - 1;
          s.splice(g, 0, f.parse), o.splice(g, 0, f.leaf), a.splice(g, 0, f.name);
        }
        f.endLeaf && d.push(f.endLeaf);
      }
    if (oA(t.parseInline))
      for (let f of t.parseInline) {
        let p = c.indexOf(f.name);
        if (p > -1)
          l[p] = f.parse;
        else {
          let g = f.before ? J5(c, f.before) : f.after ? J5(c, f.after) + 1 : c.length - 1;
          l.splice(g, 0, f.parse), c.splice(g, 0, f.name);
        }
      }
    return t.wrap && (u = u.concat(t.wrap)), new mH(n, s, o, a, d, i, l, c, u);
  }
  /// @internal
  getNodeType(e) {
    let t = this.nodeTypes[e];
    if (t == null)
      throw new RangeError(`Unknown node type '${e}'`);
    return t;
  }
  /// Parse the given piece of inline text at the given offset,
  /// returning an array of [`Element`](#Element) objects representing
  /// the inline content.
  parseInline(e, t) {
    let n = new Mjt(this, e, t);
    e: for (let i = t; i < n.end; ) {
      let s = n.char(i);
      for (let o of this.inlineParsers)
        if (o) {
          let a = o(n, s, i);
          if (a >= 0) {
            i = a;
            continue e;
          }
        }
      i++;
    }
    return n.resolveMarkers(0);
  }
}
function oA(r) {
  return r != null && r.length > 0;
}
function xT(r) {
  if (!Array.isArray(r))
    return r;
  if (r.length == 0)
    return null;
  let e = xT(r[0]);
  if (r.length == 1)
    return e;
  let t = xT(r.slice(1));
  if (!t || !e)
    return e || t;
  let n = (o, a) => (o || Rg).concat(a || Rg), i = e.wrap, s = t.wrap;
  return {
    props: n(e.props, t.props),
    defineNodes: n(e.defineNodes, t.defineNodes),
    parseBlock: n(e.parseBlock, t.parseBlock),
    parseInline: n(e.parseInline, t.parseInline),
    remove: n(e.remove, t.remove),
    wrap: i ? s ? (o, a, l, c) => i(s(o, a, l, c), a, l, c) : i : s
  };
}
function J5(r, e) {
  let t = r.indexOf(e);
  if (t < 0)
    throw new RangeError(`Position specified relative to unknown parser ${e}`);
  return t;
}
let ABe = [jr.none];
for (let r = 1, e; e = Ge[r]; r++)
  ABe[r] = jr.define({
    id: r,
    name: e,
    props: r >= Ge.Escape ? [] : [[Xt.group, r in aBe ? ["Block", "BlockContext"] : ["Block", "LeafBlock"]]],
    top: e == "Document"
  });
const Rg = [];
let wBe = class {
  constructor(e) {
    this.nodeSet = e, this.content = [], this.nodes = [];
  }
  write(e, t, n, i = 0) {
    return this.content.push(e, t, n, 4 + i * 4), this;
  }
  writeElements(e, t = 0) {
    for (let n of e)
      n.writeTo(this, t);
    return this;
  }
  finish(e, t) {
    return ci.build({
      buffer: this.content,
      nodeSet: this.nodeSet,
      reused: this.nodes,
      topID: e,
      length: t
    });
  }
}, z4 = class {
  /// @internal
  constructor(e, t, n, i = Rg) {
    this.type = e, this.from = t, this.to = n, this.children = i;
  }
  /// @internal
  writeTo(e, t) {
    let n = e.content.length;
    e.writeElements(this.children, t), e.content.push(this.type, this.from + t, this.to + t, e.content.length + 4 - n);
  }
  /// @internal
  toTree(e) {
    return new wBe(e).writeElements(this.children, -this.from).finish(this.type, this.to - this.from);
  }
};
class vBe {
  constructor(e, t) {
    this.tree = e, this.from = t;
  }
  get to() {
    return this.from + this.tree.length;
  }
  get type() {
    return this.tree.type.id;
  }
  get children() {
    return Rg;
  }
  writeTo(e, t) {
    e.nodes.push(this.tree), e.content.push(e.nodes.length - 1, this.from + t, this.to + t, -1);
  }
  toTree() {
    return this.tree;
  }
}
function Fn(r, e, t, n) {
  return new z4(r, e, t, n);
}
const bBe = { resolve: "Emphasis", mark: "EmphasisMark" }, yBe = { resolve: "Emphasis", mark: "EmphasisMark" }, z2 = {}, ST = {};
class Wa {
  constructor(e, t, n, i) {
    this.type = e, this.from = t, this.to = n, this.side = i;
  }
}
const s_e = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
let MT = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
try {
  MT = new RegExp("[\\p{Pc}|\\p{Pd}|\\p{Pe}|\\p{Pf}|\\p{Pi}|\\p{Po}|\\p{Ps}]", "u");
} catch {
}
const BS = {
  Escape(r, e, t) {
    if (e != 92 || t == r.end - 1)
      return -1;
    let n = r.char(t + 1);
    for (let i = 0; i < s_e.length; i++)
      if (s_e.charCodeAt(i) == n)
        return r.append(Fn(Ge.Escape, t, t + 2));
    return -1;
  },
  Entity(r, e, t) {
    if (e != 38)
      return -1;
    let n = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(r.slice(t + 1, t + 31));
    return n ? r.append(Fn(Ge.Entity, t, t + 1 + n[0].length)) : -1;
  },
  InlineCode(r, e, t) {
    if (e != 96 || t && r.char(t - 1) == 96)
      return -1;
    let n = t + 1;
    for (; n < r.end && r.char(n) == 96; )
      n++;
    let i = n - t, s = 0;
    for (; n < r.end; n++)
      if (r.char(n) == 96) {
        if (s++, s == i && r.char(n + 1) != 96)
          return r.append(Fn(Ge.InlineCode, t, n + 1, [
            Fn(Ge.CodeMark, t, t + i),
            Fn(Ge.CodeMark, n + 1 - i, n + 1)
          ]));
      } else
        s = 0;
    return -1;
  },
  HTMLTag(r, e, t) {
    if (e != 60 || t == r.end - 1)
      return -1;
    let n = r.slice(t + 1, r.end), i = /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(n);
    if (i)
      return r.append(Fn(Ge.Autolink, t, t + 1 + i[0].length, [
        Fn(Ge.LinkMark, t, t + 1),
        // url[0] includes the closing bracket, so exclude it from this slice
        Fn(Ge.URL, t + 1, t + i[0].length),
        Fn(Ge.LinkMark, t + i[0].length, t + 1 + i[0].length)
      ]));
    let s = /^!--[^>](?:-[^-]|[^-])*?-->/i.exec(n);
    if (s)
      return r.append(Fn(Ge.Comment, t, t + 1 + s[0].length));
    let o = /^\?[^]*?\?>/.exec(n);
    if (o)
      return r.append(Fn(Ge.ProcessingInstruction, t, t + 1 + o[0].length));
    let a = /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(n);
    return a ? r.append(Fn(Ge.HTMLTag, t, t + 1 + a[0].length)) : -1;
  },
  Emphasis(r, e, t) {
    if (e != 95 && e != 42)
      return -1;
    let n = t + 1;
    for (; r.char(n) == e; )
      n++;
    let i = r.slice(t - 1, t), s = r.slice(n, n + 1), o = MT.test(i), a = MT.test(s), l = /\s|^$/.test(i), c = /\s|^$/.test(s), d = !c && (!a || l || o), u = !l && (!o || c || a), f = d && (e == 42 || !u || o), p = u && (e == 42 || !d || a);
    return r.append(new Wa(e == 95 ? bBe : yBe, t, n, (f ? 1 : 0) | (p ? 2 : 0)));
  },
  HardBreak(r, e, t) {
    if (e == 92 && r.char(t + 1) == 10)
      return r.append(Fn(Ge.HardBreak, t, t + 2));
    if (e == 32) {
      let n = t + 1;
      for (; r.char(n) == 32; )
        n++;
      if (r.char(n) == 10 && n >= t + 2)
        return r.append(Fn(Ge.HardBreak, t, n + 1));
    }
    return -1;
  },
  Link(r, e, t) {
    return e == 91 ? r.append(new Wa(
      z2,
      t,
      t + 1,
      1
      /* Mark.Open */
    )) : -1;
  },
  Image(r, e, t) {
    return e == 33 && r.char(t + 1) == 91 ? r.append(new Wa(
      ST,
      t,
      t + 2,
      1
      /* Mark.Open */
    )) : -1;
  },
  LinkEnd(r, e, t) {
    if (e != 93)
      return -1;
    for (let n = r.parts.length - 1; n >= 0; n--) {
      let i = r.parts[n];
      if (i instanceof Wa && (i.type == z2 || i.type == ST)) {
        if (!i.side || r.skipSpace(i.to) == t && !/[(\[]/.test(r.slice(t + 1, t + 2)))
          return r.parts[n] = null, -1;
        let s = r.takeContent(n), o = r.parts[n] = Sjt(r, s, i.type == z2 ? Ge.Link : Ge.Image, i.from, t + 1);
        if (i.type == z2)
          for (let a = 0; a < n; a++) {
            let l = r.parts[a];
            l instanceof Wa && l.type == z2 && (l.side = 0);
          }
        return o.to;
      }
    }
    return -1;
  }
};
function Sjt(r, e, t, n, i) {
  let { text: s } = r, o = r.char(i), a = i;
  if (e.unshift(Fn(Ge.LinkMark, n, n + (t == Ge.Image ? 2 : 1))), e.push(Fn(Ge.LinkMark, i - 1, i)), o == 40) {
    let l = r.skipSpace(i + 1), c = CBe(s, l - r.offset, r.offset), d;
    c && (l = r.skipSpace(c.to), l != c.to && (d = EBe(s, l - r.offset, r.offset), d && (l = r.skipSpace(d.to)))), r.char(l) == 41 && (e.push(Fn(Ge.LinkMark, i, i + 1)), a = l + 1, c && e.push(c), d && e.push(d), e.push(Fn(Ge.LinkMark, l, a)));
  } else if (o == 91) {
    let l = _Be(s, i - r.offset, r.offset, !1);
    l && (e.push(l), a = l.to);
  }
  return Fn(t, n, a, e);
}
function CBe(r, e, t) {
  if (r.charCodeAt(e) == 60) {
    for (let i = e + 1; i < r.length; i++) {
      let s = r.charCodeAt(i);
      if (s == 62)
        return Fn(Ge.URL, e + t, i + 1 + t);
      if (s == 60 || s == 10)
        return !1;
    }
    return null;
  } else {
    let i = 0, s = e;
    for (let o = !1; s < r.length; s++) {
      let a = r.charCodeAt(s);
      if (vc(a))
        break;
      if (o)
        o = !1;
      else if (a == 40)
        i++;
      else if (a == 41) {
        if (!i)
          break;
        i--;
      } else a == 92 && (o = !0);
    }
    return s > e ? Fn(Ge.URL, e + t, s + t) : s == r.length ? null : !1;
  }
}
function EBe(r, e, t) {
  let n = r.charCodeAt(e);
  if (n != 39 && n != 34 && n != 40)
    return !1;
  let i = n == 40 ? 41 : n;
  for (let s = e + 1, o = !1; s < r.length; s++) {
    let a = r.charCodeAt(s);
    if (o)
      o = !1;
    else {
      if (a == i)
        return Fn(Ge.LinkTitle, e + t, s + 1 + t);
      a == 92 && (o = !0);
    }
  }
  return null;
}
function _Be(r, e, t, n) {
  for (let i = !1, s = e + 1, o = Math.min(r.length, s + 999); s < o; s++) {
    let a = r.charCodeAt(s);
    if (i)
      i = !1;
    else {
      if (a == 93)
        return n ? !1 : Fn(Ge.LinkLabel, e + t, s + 1 + t);
      if (n && !vc(a) && (n = !1), a == 91)
        return !1;
      a == 92 && (i = !0);
    }
  }
  return null;
}
class Mjt {
  /// @internal
  constructor(e, t, n) {
    this.parser = e, this.text = t, this.offset = n, this.parts = [];
  }
  /// Get the character code at the given (document-relative)
  /// position.
  char(e) {
    return e >= this.end ? -1 : this.text.charCodeAt(e - this.offset);
  }
  /// The position of the end of this inline section.
  get end() {
    return this.offset + this.text.length;
  }
  /// Get a substring of this inline section. Again uses
  /// document-relative positions.
  slice(e, t) {
    return this.text.slice(e - this.offset, t - this.offset);
  }
  /// @internal
  append(e) {
    return this.parts.push(e), e.to;
  }
  /// Add a [delimiter](#DelimiterType) at this given position. `open`
  /// and `close` indicate whether this delimiter is opening, closing,
  /// or both. Returns the end of the delimiter, for convenient
  /// returning from [parse functions](#InlineParser.parse).
  addDelimiter(e, t, n, i, s) {
    return this.append(new Wa(e, t, n, (i ? 1 : 0) | (s ? 2 : 0)));
  }
  /// Returns true when there is an unmatched link or image opening
  /// token before the current position.
  get hasOpenLink() {
    for (let e = this.parts.length - 1; e >= 0; e--) {
      let t = this.parts[e];
      if (t instanceof Wa && (t.type == z2 || t.type == ST))
        return !0;
    }
    return !1;
  }
  /// Add an inline element. Returns the end of the element.
  addElement(e) {
    return this.append(e);
  }
  /// Resolve markers between this.parts.length and from, wrapping matched markers in the
  /// appropriate node and updating the content of this.parts. @internal
  resolveMarkers(e) {
    for (let n = e; n < this.parts.length; n++) {
      let i = this.parts[n];
      if (!(i instanceof Wa && i.type.resolve && i.side & 2))
        continue;
      let s = i.type == bBe || i.type == yBe, o = i.to - i.from, a, l = n - 1;
      for (; l >= e; l--) {
        let m = this.parts[l];
        if (m instanceof Wa && m.side & 1 && m.type == i.type && // Ignore emphasis delimiters where the character count doesn't match
        !(s && (i.side & 1 || m.side & 2) && (m.to - m.from + o) % 3 == 0 && ((m.to - m.from) % 3 || o % 3))) {
          a = m;
          break;
        }
      }
      if (!a)
        continue;
      let c = i.type.resolve, d = [], u = a.from, f = i.to;
      if (s) {
        let m = Math.min(2, a.to - a.from, o);
        u = a.to - m, f = i.from + m, c = m == 1 ? "Emphasis" : "StrongEmphasis";
      }
      a.type.mark && d.push(this.elt(a.type.mark, u, a.to));
      for (let m = l + 1; m < n; m++)
        this.parts[m] instanceof z4 && d.push(this.parts[m]), this.parts[m] = null;
      i.type.mark && d.push(this.elt(i.type.mark, i.from, f));
      let p = this.elt(c, u, f, d);
      this.parts[l] = s && a.from != u ? new Wa(a.type, a.from, u, a.side) : null, (this.parts[n] = s && i.to != f ? new Wa(i.type, f, i.to, i.side) : null) ? this.parts.splice(n, 0, p) : this.parts[n] = p;
    }
    let t = [];
    for (let n = e; n < this.parts.length; n++) {
      let i = this.parts[n];
      i instanceof z4 && t.push(i);
    }
    return t;
  }
  /// Find an opening delimiter of the given type. Returns `null` if
  /// no delimiter is found, or an index that can be passed to
  /// [`takeContent`](#InlineContext.takeContent) otherwise.
  findOpeningDelimiter(e) {
    for (let t = this.parts.length - 1; t >= 0; t--) {
      let n = this.parts[t];
      if (n instanceof Wa && n.type == e)
        return t;
    }
    return null;
  }
  /// Remove all inline elements and delimiters starting from the
  /// given index (which you should get from
  /// [`findOpeningDelimiter`](#InlineContext.findOpeningDelimiter),
  /// resolve delimiters inside of them, and return them as an array
  /// of elements.
  takeContent(e) {
    let t = this.resolveMarkers(e);
    return this.parts.length = e, t;
  }
  /// Skip space after the given (document) position, returning either
  /// the position of the next non-space character or the end of the
  /// section.
  skipSpace(e) {
    return v3(this.text, e - this.offset) + this.offset;
  }
  elt(e, t, n, i) {
    return typeof e == "string" ? Fn(this.parser.getNodeType(e), t, n, i) : new vBe(e, t);
  }
}
function DT(r, e) {
  if (!e.length)
    return r;
  if (!r.length)
    return e;
  let t = r.slice(), n = 0;
  for (let i of e) {
    for (; n < t.length && t[n].to < i.to; )
      n++;
    if (n < t.length && t[n].from < i.from) {
      let s = t[n];
      s instanceof z4 && (t[n] = new z4(s.type, s.from, s.to, DT(s.children, [i])));
    } else
      t.splice(n++, 0, i);
  }
  return t;
}
const Djt = [Ge.CodeBlock, Ge.ListItem, Ge.OrderedList, Ge.BulletList];
class Ljt {
  constructor(e, t) {
    this.fragments = e, this.input = t, this.i = 0, this.fragment = null, this.fragmentEnd = -1, this.cursor = null, e.length && (this.fragment = e[this.i++]);
  }
  nextFragment() {
    this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null, this.cursor = null, this.fragmentEnd = -1;
  }
  moveTo(e, t) {
    for (; this.fragment && this.fragment.to <= e; )
      this.nextFragment();
    if (!this.fragment || this.fragment.from > (e ? e - 1 : 0))
      return !1;
    if (this.fragmentEnd < 0) {
      let s = this.fragment.to;
      for (; s > 0 && this.input.read(s - 1, s) != `
`; )
        s--;
      this.fragmentEnd = s ? s - 1 : 0;
    }
    let n = this.cursor;
    n || (n = this.cursor = this.fragment.tree.cursor(), n.firstChild());
    let i = e + this.fragment.offset;
    for (; n.to <= i; )
      if (!n.parent())
        return !1;
    for (; ; ) {
      if (n.from >= i)
        return this.fragment.from <= t;
      if (!n.childAfter(i))
        return !1;
    }
  }
  matches(e) {
    let t = this.cursor.tree;
    return t && t.prop(Xt.contextHash) == e;
  }
  takeNodes(e) {
    let t = this.cursor, n = this.fragment.offset, i = this.fragmentEnd - (this.fragment.openEnd ? 1 : 0), s = e.absoluteLineStart, o = s, a = e.block.children.length, l = o, c = a;
    for (; ; ) {
      if (t.to - n > i) {
        if (t.type.isAnonymous && t.firstChild())
          continue;
        break;
      }
      let d = xBe(t.from - n, e.ranges);
      if (t.to - n <= e.ranges[e.rangeI].to)
        e.addNode(t.tree, d);
      else {
        let u = new ci(e.parser.nodeSet.types[Ge.Paragraph], [], [], 0, e.block.hashProp);
        e.reusePlaceholders.set(u, t.tree), e.addNode(u, d);
      }
      if (t.type.is("Block") && (Djt.indexOf(t.type.id) < 0 ? (o = t.to - n, a = e.block.children.length) : (o = l, a = c, l = t.to - n, c = e.block.children.length)), !t.nextSibling())
        break;
    }
    for (; e.block.children.length > a; )
      e.block.children.pop(), e.block.positions.pop();
    return o - s;
  }
}
function xBe(r, e) {
  let t = r;
  for (let n = 1; n < e.length; n++) {
    let i = e[n - 1].to, s = e[n].from;
    i < r && (t -= s - i);
  }
  return t;
}
const kjt = Qw({
  "Blockquote/...": J.quote,
  HorizontalRule: J.contentSeparator,
  "ATXHeading1/... SetextHeading1/...": J.heading1,
  "ATXHeading2/... SetextHeading2/...": J.heading2,
  "ATXHeading3/...": J.heading3,
  "ATXHeading4/...": J.heading4,
  "ATXHeading5/...": J.heading5,
  "ATXHeading6/...": J.heading6,
  "Comment CommentBlock": J.comment,
  Escape: J.escape,
  Entity: J.character,
  "Emphasis/...": J.emphasis,
  "StrongEmphasis/...": J.strong,
  "Link/... Image/...": J.link,
  "OrderedList/... BulletList/...": J.list,
  "BlockQuote/...": J.quote,
  "InlineCode CodeText": J.monospace,
  "URL Autolink": J.url,
  "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark": J.processingInstruction,
  "CodeInfo LinkLabel": J.labelName,
  LinkTitle: J.string,
  Paragraph: J.content
}), Njt = new mH(new Gw(ABe).extend(kjt), Object.keys(X5).map((r) => X5[r]), Object.keys(X5).map((r) => Cjt[r]), Object.keys(X5), Ejt, aBe, Object.keys(BS).map((r) => BS[r]), Object.keys(BS), []);
J.special(J.content), J.processingInstruction;
J.special(J.content), J.processingInstruction;
function Tjt(r) {
  const e = [];
  return r.iterate({
    enter: (t) => {
      const n = t.node;
      if (!n.type.isError)
        return;
      const i = n.parent, s = SBe(n), o = {
        from: n.from,
        to: n.to,
        severity: "error",
        type: "Syntax Error"
      };
      if (n.from !== n.to)
        o.message = `Unrecognized token in <${i.name}>`;
      else if (s)
        o.message = `Unrecognized token <${s.name}> in <${i.name}>`, o.to = s.to;
      else {
        const a = i.enterUnfinishedNodesBefore(n.to);
        o.message = `Incomplete <${(a || i).name}>`;
      }
      e.push(o);
    }
  }), e;
}
function SBe(r) {
  return r ? r.nextSibling || SBe(r.parent) : null;
}
function Ijt(r) {
  return [
    ...Tjt(r)
  ];
}
const MBe = () => (r) => {
  if (r.state.doc.length === 0)
    return [];
  const e = Zr(r.state);
  return Ijt(e).map((n) => ({
    ...n,
    source: n.type
  }));
}, Ojt = uC(f2.define([
  { tag: J.strong, fontWeight: "bold" },
  { tag: J.emphasis, fontStyle: "italic" }
])), Rjt = st.theme({
  "& .cm-lintRange": {
    position: "relative"
  },
  "& .cm-lintRange::after": {
    content: '""',
    width: "100%",
    position: "absolute",
    left: "0px",
    bottom: "-2px",
    height: "3px",
    backgroundRepeat: "repeat-x"
  },
  "& .cm-lintRange.cm-lintRange-warning, & .cm-lintRange.cm-lintRange-error": {
    backgroundImage: "none"
  },
  "& .cm-lintPoint::after": {
    bottom: "-2px"
  }
});
var DBe = [
  Rjt,
  Ojt
];
const o_e = (r) => `%23${r.slice(1)}`, on = {
  black: "#1f2b36",
  darkGrey: "#2f3d58",
  grey: "#404a5c",
  midGrey: "#576071",
  offWhite: "#d9e0f5",
  snowWhite: "#eaf1ff",
  white: "#ffffff",
  mossGreen: "#7ab6aa",
  iceBlue: "#6cbfd8",
  waterBlue: "#065aaa",
  brightBlue: "#0a56b9",
  deepBlue: "#355472",
  red: "#9f1c15",
  orangeBrown: "#b4502f",
  yellow: "#debd71",
  lila: "#9a4890",
  purple: "#5b2c83"
}, Ir = {
  lightBackground: on.white,
  darkBackground: on.snowWhite,
  selection: on.snowWhite,
  tooltipBackground: on.offWhite,
  error: on.red,
  warning: on.yellow,
  invalid: "#b40000"
}, Vjt = st.theme(
  {
    "&": { color: on.black, backgroundColor: Ir.lightBackground },
    ".cm-content": { caretColor: on.darkGrey },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: on.darkGrey },
    "&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: Ir.selection },
    ".cm-panels": { backgroundColor: Ir.darkBackground, color: on.grey },
    ".cm-panels.cm-panels-top": { borderBottom: `2px solid ${on.black}` },
    ".cm-panels.cm-panels-bottom": { borderTop: `2px solid ${on.black}` },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: `1px solid ${on.midGrey}`
    },
    ".cm-searchMatch.cm-searchMatch-selected": { backgroundColor: on.offWhite },
    ".cm-activeLine": { backgroundColor: Ir.selection },
    ".cm-selectionMatch": { backgroundColor: on.offWhite },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      outline: `1px solid ${on.grey}`
    },
    "&.cm-focused .cm-matchingBracket": {
      backgroundColor: on.snowWhite
    },
    ".cm-gutters": {
      backgroundColor: "#f3f7fe",
      color: "#52668d",
      border: "none",
      padding: "0 5px"
    },
    ".cm-activeLineGutter": {
      backgroundColor: Ir.selection
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "none",
      backgroundColor: Ir.tooltipBackground
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: Ir.tooltipBackground,
      borderBottomColor: Ir.tooltipBackground
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        backgroundColor: Ir.darkBackground,
        color: on.midGrey
      }
    },
    "& .cm-lintRange.cm-lintRange-warning::after": {
      backgroundImage: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='3'><path d='m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0' stroke='${o_e(Ir.warning)}' fill='none' stroke-width='1.2'/></svg>")`
    },
    "& .cm-lintRange.cm-lintRange-error::after": {
      backgroundImage: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='3'><path d='m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0' stroke='${o_e(Ir.error)}' fill='none' stroke-width='1.2'/></svg>")`
    },
    "& .cm-diagnostic-warning": {
      border: `1px solid ${Ir.warning}`,
      borderLeft: `5px solid ${Ir.warning}`,
      background: Ir.lightBackground
    },
    "& .cm-diagnostic-error": {
      border: `1px solid ${Ir.error}`,
      borderLeft: `5px solid ${Ir.error}`,
      background: Ir.lightBackground
    },
    "& .cm-diagnostic": {
      padding: "3px 8px"
    }
  },
  { dark: !1 }
), Hjt = uC(f2.define([
  {
    tag: [J.macroName, J.variableName],
    color: on.waterBlue
  },
  {
    tag: [J.special(J.bracket)],
    color: on.waterBlue,
    fontWeight: "bold"
  },
  {
    tag: [J.color, J.name, J.definition(J.name), J.constant(J.name), J.standard(J.name), J.propertyName],
    color: on.deepBlue
  },
  {
    tag: [J.definition(J.variableName), J.function(J.variableName), J.function(J.propertyName)],
    color: on.brightBlue
  },
  { tag: [J.labelName], color: on.orangeBrown },
  {
    tag: [J.annotation],
    color: Ir.invalid
  },
  {
    tag: [J.number, J.changed, J.annotation, J.modifier, J.self, J.namespace, J.atom, J.bool, J.special(J.variableName)],
    color: on.red
  },
  {
    tag: [J.typeName, J.className, J.attributeName],
    color: on.lila
  },
  {
    tag: [J.operator, J.operatorKeyword, J.tagName, J.keyword],
    color: on.purple
  },
  {
    tag: [J.angleBracket, J.squareBracket, J.brace, J.separator, J.punctuation],
    color: on.midGrey
  },
  {
    tag: [J.regexp],
    color: on.deepBlue
  },
  {
    tag: [J.quote],
    color: on.darkGrey
  },
  { tag: [J.string, J.character, J.deleted], color: on.orangeBrown },
  {
    tag: J.link,
    color: on.mossGreen,
    textDecoration: "underline",
    textUnderlinePosition: "under"
  },
  {
    tag: [J.url, J.escape, J.special(J.string)],
    color: on.red
  },
  { tag: [J.meta], color: on.iceBlue },
  { tag: [J.comment], color: on.midGrey, fontStyle: "italic" },
  { tag: J.strong, fontWeight: "bold", color: on.deepBlue },
  { tag: J.emphasis, fontStyle: "italic", color: on.deepBlue },
  { tag: J.strikethrough, textDecoration: "line-through" },
  { tag: J.heading, fontWeight: "bold", color: on.midGray },
  { tag: J.special(J.heading1), fontWeight: "bold", color: on.darkGrey },
  {
    tag: [J.heading1, J.heading2, J.heading3, J.heading4],
    fontWeight: "bold",
    color: on.midGrey
  },
  { tag: [J.heading5, J.heading6, J.processingInstruction, J.inserted], color: on.grey },
  {
    tag: [J.contentSeparator],
    color: on.yellow
  },
  { tag: J.invalid, color: on.midGrey, borderBottom: `1px dotted ${Ir.invalid}` }
]));
var Bjt = [
  Vjt,
  Hjt
];
const Pjt = "#abb2bf", PS = "#f07178", Fjt = "#7d8799", zjt = "#ffffff", O2 = "#fffce1", FS = "#ec9e6f", Wjt = "#21252b", zS = "rgba(0, 0, 0, 0.5)", jjt = "#292d3e", WS = "#353a42", Zjt = "rgba(128, 203, 196, 0.2)", a_e = "#ffcc00", Ujt = "%23", l_e = "fff890", c_e = "red", qjt = "#281e16", Gjt = "#281616", Qjt = st.theme(
  {
    "&": {
      color: "#ffffff",
      backgroundColor: jjt
    },
    ".cm-content": {
      caretColor: a_e
    },
    "&.cm-focused .cm-cursor": {
      borderLeftColor: a_e
    },
    "&.cm-focused .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: Zjt },
    ".cm-panels": { backgroundColor: Wjt, color: "#ffffff" },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: zS },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847",
      outline: "1px solid #515a6b"
    },
    ".cm-gutters": {
      background: "#292d3e",
      color: "#676e95",
      border: "none",
      padding: "0 5px"
    },
    ".cm-activeLineGutter": {
      backgroundColor: zS
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "none",
      backgroundColor: WS
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: WS,
      borderBottomColor: WS
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        backgroundColor: zS,
        color: Pjt
      }
    },
    "& .cm-lintRange.cm-lintRange-warning::after": {
      backgroundImage: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='3'><path d='m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0' stroke='${Ujt + l_e}' fill='none' stroke-width='1.2'/></svg>")`
    },
    "& .cm-lintRange.cm-lintRange-error::after": {
      backgroundImage: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='3'><path d='m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0' stroke='${c_e}' fill='none' stroke-width='1.2'/></svg>")`
    },
    "& .cm-diagnostic-warning": {
      borderLeft: `5px solid #${l_e}`,
      background: qjt
    },
    "& .cm-diagnostic-error": {
      borderLeft: `5px solid ${c_e}`,
      background: Gjt
    },
    "& .cm-diagnostic": {
      borderRadius: "2px",
      padding: "3px 8px"
    }
  },
  { dark: !0 }
), Kjt = uC(f2.define([
  // Markdown headings
  { tag: J.heading1, color: O2 },
  { tag: J.heading2, color: O2 },
  { tag: J.heading3, color: O2 },
  { tag: J.heading4, color: O2 },
  { tag: J.heading5, color: O2 },
  { tag: J.heading6, color: O2 },
  // Feelers
  { tag: J.special(J.bracket), color: FS, fontWeight: "bold" },
  // Everything else
  { tag: J.keyword, color: "#c792ea" },
  { tag: J.operator, color: "#89ddff" },
  { tag: J.special(J.variableName), color: "#eeffff" },
  { tag: J.typeName, color: "#f07178" },
  { tag: J.atom, color: "#f78c6c" },
  { tag: J.number, color: "#ff5370" },
  { tag: J.bool, color: "#ff5370" },
  { tag: J.definition(J.variableName), color: "#82aaff" },
  { tag: J.string, color: "#c3e88d" },
  { tag: J.comment, color: Fjt },
  { tag: J.tagName, color: "#ff5370" },
  { tag: J.bracket, color: "#a2a1a4" },
  { tag: J.meta, color: "#ffcb6b" },
  { tag: J.special(J.string), color: PS },
  { tag: J.propertyName, color: FS },
  { tag: J.variableName, color: FS },
  { tag: J.attributeName, color: PS },
  { tag: J.className, color: PS },
  { tag: J.invalid, color: zjt }
]));
var Yjt = [
  Qjt,
  Kjt
];
const Xjt = [...DBe, ...Bjt], Jjt = [...DBe, ...Yjt], $jt = 1, eZt = 2, tZt = 3, Ub = {
  "{": 123,
  "}": 125
}, nZt = (r, e = 0) => {
  const t = r.peek(e) === Ub["}"], n = r.peek(e + 1) === Ub["}"];
  return t && n || r.peek(e) === -1;
}, iZt = new wm((r, e) => {
  let t = 0;
  for (; !nZt(r, t); )
    t++;
  t > 0 && (r.advance(t), r.acceptToken(eZt));
}), rZt = (r, e = 0) => {
  const t = r.peek(e) === Ub["{"], n = r.peek(e + 1) === Ub["{"];
  return t && n || r.peek(e) === -1;
}, sZt = new wm((r, e) => {
  let t = 0;
  for (; !rZt(r, t); )
    t++;
  t > 0 && (r.advance(t), r.acceptToken(tZt));
}), oZt = new wm((r, e) => {
  let t = 0;
  for (; r.peek(t) !== -1; )
    t++;
  t > 0 && (r.advance(t), r.acceptToken($jt));
}), aZt = Qw({
  ConditionalSpanner: J.special(J.bracket),
  ConditionalSpannerClose: J.special(J.bracket),
  ConditionalSpannerCloseNl: J.special(J.bracket),
  LoopSpanner: J.special(J.bracket),
  LoopSpannerClose: J.special(J.bracket),
  LoopSpannerCloseNl: J.special(J.bracket),
  EmptyInsert: J.special(J.bracket),
  Insert: J.special(J.bracket)
}), lZt = D4.deserialize({
  version: 14,
  states: "$bOQOaOOOfOXO'#CbOOO`'#Cm'#CmOqOWO'#CcOvOWO'#CfOOO`'#Cp'#CpOOO`'#Ci'#CiO{OaO'#ClO!jOSOOQOOOOOO!oOPO,58{O!tOXO,58|OOO`,58|,58|O!|OQO,58}O#ROQO,59QOOO`-E6g-E6gOOO`1G.g1G.gO#WOPO1G.gOOO`1G.h1G.hO#]OaO1G.iO#qOaO1G.lOOO`7+$R7+$RO$VOPO7+$TO$_OPO7+$WOOO`<<Go<<GoOOO`<<Gr<<Gr",
  stateData: "$g~ORUO_WObPOeROgSO^`P~OQYO_ZOc[O~OQ]O~OQ^O~ORUObPOeROgSO^`XW`XX`XZ`X[`X~OPXO~Oc`O~OQaOcbO~OfcO~OfdO~OceO~ORUObPOeROgSOW`PX`P~ORUObPOeROgSOZ`P[`P~OWhOXhO~OZiO[iO~O",
  goto: "!ZePPPPPfflPPlPPrPPz!TPP!TXQOVcdXTOVcdUVOcdR_VQXOQfcRgdXUOVcd",
  nodeNames: "⚠ Feel FeelBlock SimpleTextBlock Feelers Insert EmptyInsert ConditionalSpanner ConditionalSpannerClose ConditionalSpannerCloseNl LoopSpanner LoopSpannerClose LoopSpannerCloseNl",
  maxTerm: 23,
  propSources: [aZt],
  skippedNodes: [0],
  repeatNodeCount: 1,
  tokenData: "%X~RR!_!`[#o#pa#q#r$r~aO_~~dP#o#pg~lQb~str!P!Q!{~uQ#]#^{#`#a!^~!OP#Y#Z!R~!UPpq!X~!^Oe~~!aP#c#d!d~!gP#c#d!j~!mP#d#e!p~!sPpq!v~!{Og~~#OQ#]#^#U#`#a#u~#XP#Y#Z#[~#_P#q#r#b~#eP#q#r#h~#mPW~YZ#p~#uOX~~#xP#c#d#{~$OP#c#d$R~$UP#d#e$X~$[P#q#r$_~$bP#q#r$e~$jPZ~YZ$m~$rO[~R$uP#q#r$xR%PPcPfQYZ%SQ%XOfQ",
  tokenizers: [0, 1, oZt, iZt, sZt],
  topRules: { Feelers: [0, 4] },
  tokenPrec: 0
}), cZt = {
  ConditionalSpanner: w3,
  LoopSpanner: w3
};
function hZt(r = null) {
  const e = lZt.configure({
    wrap: GVt((t) => t.name == "Feel" || t.name == "FeelBlock" ? { parser: ZRe } : r && t.name == "SimpleTextBlock" ? { parser: r } : null),
    props: [
      pHe.add(cZt)
    ]
  });
  return H4.define({ parser: e });
}
const dZt = (r) => new cHe(hZt(r), []);
function uZt(r) {
  const e = [];
  return r.iterate({
    enter: (t) => {
      t.type.name === "EmptyInsert" && e.push(
        {
          from: t.from,
          to: t.to,
          severity: "warning",
          message: "this insert is empty and will be ignored",
          type: "emptyInsert"
        }
      );
    }
  }), e;
}
function fZt(r) {
  return [
    ...uZt(r)
  ];
}
function pZt() {
  const r = MBe();
  return (e) => {
    const t = r(e);
    if (e.state.doc.length === 0)
      return [];
    const n = Zr(e.state), i = fZt(n);
    return [
      ...t,
      ...i.map((s) => ({
        ...s,
        source: "feelers linter"
      }))
    ];
  };
}
var gZt = iBe(pZt());
function mC({
  container: r,
  tooltipContainer: e,
  hostLanguage: t,
  hostLanguageParser: n,
  onChange: i = () => {
  },
  onKeyDown: s = () => {
  },
  onLint: o = () => {
  },
  contentAttributes: a = {},
  readOnly: l = !1,
  value: c = "",
  enableGutters: d = !1,
  singleLine: u = !1,
  darkMode: f = !1
}) {
  const p = st.updateListener.of((S) => {
    S.docChanged && i(S.state.doc.toString());
  }), g = st.updateListener.of((S) => {
    const D = S.transactions.flatMap((L) => L.effects).filter((L) => L.is(iv));
    if (!D.length)
      return;
    const M = D.flatMap((L) => L.value);
    o(M);
  }), m = st.contentAttributes.of(a), A = st.domEventHandlers(
    {
      keydown: s
    }
  );
  typeof e == "string" && (e = document.querySelector(e));
  const w = e ? rHe({
    tooltipSpace: function() {
      return e.getBoundingClientRect();
    }
  }) : [], y = dZt(n || t && ((S) => {
    switch (S) {
      case "markdown":
        return Njt;
      default:
        return null;
    }
  })(t)), _ = [
    wHe(),
    p,
    m,
    SHe(),
    fHe(),
    A,
    ev.of([
      ...$He
    ]),
    y,
    gZt,
    g,
    w,
    f ? Jjt : Xjt,
    ...d ? [
      // todo: adjust folding boundaries first foldGutter(),
      aHe()
    ] : [],
    ...u ? [
      jn.transactionFilter.of((S) => S.newDoc.lines > 1 ? [] : S)
    ] : []
  ];
  return l && _.push(st.editable.of(!1)), u && c && (c = c.toString().split(`
`)[0]), this._cmEditor = new st({
    state: jn.create({
      doc: c,
      extensions: _
    }),
    parent: r
  }), this;
}
mC.prototype.setValue = function(r) {
  this._cmEditor.dispatch({
    changes: {
      from: 0,
      to: this._cmEditor.state.doc.length,
      insert: r
    }
  });
};
mC.prototype.focus = function(r) {
  const e = this._cmEditor;
  if (e.contentDOM.focus(), e.focus(), typeof r == "number") {
    const t = e.state.doc.length;
    e.dispatch({ selection: { anchor: r <= t ? r : t } });
  }
};
mC.prototype.getSelection = function() {
  return this._cmEditor.state.selection;
};
const mZt = [d0("function(${params}) ${body}", {
  label: "function",
  detail: "definition",
  type: "keyword"
}), d0("for ${var} in ${collection} return ${value}", {
  label: "for",
  detail: "expression",
  type: "keyword"
}), d0("every ${var} in ${collection} satisfies ${condition}", {
  label: "every",
  detail: "quantified expression",
  type: "keyword"
}), d0("some ${var} in ${collection} satisfies ${condition}", {
  label: "some",
  detail: "quantified expression",
  type: "keyword"
}), d0("if ${condition} then ${value} else ${other value}", {
  label: "if",
  detail: "block",
  type: "keyword"
}), d0("{ ${key}: ${value} }", {
  label: "context",
  detail: "block",
  type: "keyword"
})];
function aA(r) {
  const {
    context: e,
    after: t,
    before: n,
    keyword: i
  } = r;
  return bZt({
    nodes: e,
    before: n,
    after: t,
    keyword: i
  }, tH([{
    label: i,
    type: "keyword",
    boost: 10
  }]));
}
const AZt = [aA({
  context: "InExpression",
  keyword: "in"
}), aA({
  context: "IfExpression",
  keyword: "then",
  after: "if",
  before: "else"
}), aA({
  context: "IfExpression",
  keyword: "else",
  after: "then"
}), aA({
  context: "QuantifiedExpression",
  keyword: "satisfies"
}), aA({
  context: "ForExpression",
  after: "InExpressions",
  keyword: "return"
})];
function h_e(r, e, t) {
  return LBe(r, e, t, -1);
}
function wZt(r, e, t) {
  return LBe(r, e, t, 1);
}
function LBe(r, e, t, n) {
  let i = r[n > 0 ? "childAfter" : "childBefore"](e);
  for (; i; ) {
    if (t.includes(i.name))
      return i;
    if (i.type.isError && i.firstChild && t.includes(i.firstChild.name))
      return i.firstChild;
    i = i[n > 0 ? "nextSibling" : "prevSibling"];
  }
  return null;
}
function vZt(r, e) {
  for (Array.isArray(e) || (e = [e]); r; r = r.parent) {
    if (e.includes(r.name))
      return r;
    if (r.type.isTop)
      break;
  }
  return null;
}
function bZt(r, e) {
  const {
    nodes: t,
    before: n,
    after: i,
    keyword: s
  } = r;
  return (o) => {
    const {
      state: a,
      pos: l
    } = o, c = vZt(Zr(a).resolveInner(l, -1), t);
    return !c || h_e(c, l, [s, n]) || wZt(c, l, [s, i]) || i && !h_e(c, l, [i]) ? null : e(o);
  };
}
const AH = H4.define({
  parser: ZRe.configure({
    props: [hHe.add({
      Context: OEe({
        closing: "}"
      }),
      "List FilterExpression": OEe({
        closing: "]"
      }),
      "ParenthesizedExpression FunctionInvocation": TS({
        except: /^\s*\)/
      }),
      "ForExpression QuantifiedExpression IfExpression": TS({
        except: /^\s*(then|else|return|satisfies)\b/
      }),
      FunctionDefinition: TS({
        except: /^\s*(\(|\))/
      })
    }), pHe.add({
      Context: w3,
      List: w3,
      ParenthesizedExpression: w3,
      FunctionDefinition(r) {
        const e = r.getChild(")");
        return e ? {
          from: e.to,
          to: r.to
        } : null;
      }
    })]
  }),
  languageData: {
    indentOnInput: /^\s*(\)|\}|\]|then|else|return|satisfies)$/,
    commentTokens: {
      line: "//",
      block: {
        open: "/*",
        close: "*/"
      }
    }
  }
});
AH.configure({
  top: "UnaryTests"
});
AH.configure({
  top: "Expression"
});
function qb(r) {
  return r.from === r.to;
}
function AC(r) {
  return r ? r.name === "PathExpression" ? !0 : AC(r.parent) : !1;
}
var yZt = [
  {
    name: "not(negand)",
    description: `<p>Returns the logical negation of the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">not(negand: boolean): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">not(true)
// false

not(null)
// null
</code></pre>
`
  },
  {
    name: "is defined(value)",
    description: `<p><em>Camunda Extension</em></p>
<p>Checks if a given value is not <code>null</code>. If the value is <code>null</code> then the function returns <code>false</code>.
Otherwise, the function returns <code>true</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">is defined(value: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">is defined(1)
// true

is defined(null)
// false

is defined(x)
// false - if no variable &quot;x&quot; exists

is defined(x.y)
// false - if no variable &quot;x&quot; exists or it doesn&#39;t have a property &quot;y&quot;
</code></pre>
<p>:::caution Breaking change</p>
<p>This function worked differently in previous versions. It returned <code>true</code> if the value was <code>null</code>.
Since this version, the function returns <code>false</code> if the value is <code>null</code>.</p>
<p>:::</p>
`
  },
  {
    name: "get or else(value, default)",
    description: `<p><em>Camunda Extension</em></p>
<p>Return the provided value parameter if not <code>null</code>, otherwise return the default parameter</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">get or else(value: Any, default: Any): Any
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">get or else(&quot;this&quot;, &quot;default&quot;)
// &quot;this&quot;

get or else(null, &quot;default&quot;)
// &quot;default&quot;

get or else(null, null)
// null
</code></pre>
`
  },
  {
    name: "assert(value, condition)",
    description: `<p><em>Camunda Extension</em></p>
<p>Verify that the given condition is met. If the condition is <code>true</code>, the function returns the value.
Otherwise, the evaluation fails with an error.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">assert(value: Any, condition: Any)
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">assert(x, x != null)
// &quot;value&quot; - if x is &quot;value&quot;
// error - if x is null or doesn&#39;t exist

assert(x, x &gt;= 0)
// 4 - if x is 4
// error - if x is less than zero
</code></pre>
`
  },
  {
    name: "assert(value, condition, cause)",
    description: `<p><em>Camunda Extension</em></p>
<p>Verify that the given condition is met. If the condition is <code>true</code>, the function returns the value.
Otherwise, the evaluation fails with an error containing the given message.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">assert(value: Any, condition: Any, cause: String)
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">assert(x, x != null, &quot;&#39;x&#39; should not be null&quot;)
// &quot;value&quot; - if x is &quot;value&quot;
// error(&#39;x&#39; should not be null) - if x is null or doesn&#39;t exist

assert(x, x &gt;= 0, &quot;&#39;x&#39; should be positive&quot;)
// 4 - if x is 4
// error(&#39;x&#39; should be positive) - if x is less than zero
</code></pre>
`
  },
  {
    name: "get value(context, key)",
    description: `<p>Returns the value of the context entry with the given key.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">get value(context: context, key: string): Any
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">get value({foo: 123}, &quot;foo&quot;)
// 123

get value({a: 1}, &quot;b&quot;)
// null
</code></pre>
`
  },
  {
    name: "get value(context, keys)",
    description: `<p><em>Camunda Extension</em></p>
<p>Returns the value of the context entry for a context path defined by the given keys.</p>
<p>If <code>keys</code> contains the keys <code>[k1, k2]</code> then it returns the value at the nested entry <code>k1.k2</code> of the context.</p>
<p>If <code>keys</code> are empty or the nested entry defined by the keys doesn&#39;t exist in the context, it returns <code>null</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">get value(context: context, keys: list&lt;string&gt;): Any
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">get value({x:1, y: {z:0}}, [&quot;y&quot;, &quot;z&quot;])
// 0

get value({x: {y: {z:0}}}, [&quot;x&quot;, &quot;y&quot;])
// {z:0}

get value({a: {b: 3}}, [&quot;b&quot;])
// null
</code></pre>
`
  },
  {
    name: "get entries(context)",
    description: `<p>Returns the entries of the context as a list of key-value-pairs.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">get entries(context: context): list&lt;context&gt;
</code></pre>
<p>The return value is a list of contexts. Each context contains two entries for &quot;key&quot; and &quot;value&quot;.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">get entries({foo: 123})
// [{key: &quot;foo&quot;, value: 123}]
</code></pre>
`
  },
  {
    name: "context put(context, key, value)",
    description: `<p>Adds a new entry with the given key and value to the context. Returns a new context that includes the entry.</p>
<p>If an entry for the same key already exists in the context, it overrides the value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">context put(context: context, key: string, value: Any): context
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">context put({x:1}, &quot;y&quot;, 2)
// {x:1, y:2}
</code></pre>
<p>:::info
The function <code>context put()</code> replaced the previous function <code>put()</code> (Camunda Extension). The
previous function is deprecated and should not be used anymore.
:::</p>
`
  },
  {
    name: "context put(context, keys, value)",
    description: `<p>Adds a new entry with the given value to the context. The path of the entry is defined by the keys. Returns a new context that includes the entry.</p>
<p>If <code>keys</code> contains the keys <code>[k1, k2]</code> then it adds the nested entry <code>k1.k2 = value</code> to the context.</p>
<p>If an entry for the same keys already exists in the context, it overrides the value.</p>
<p>If <code>keys</code> are empty, it returns <code>null</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">context put(context: context, keys: list&lt;string&gt;, value: Any): context
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">context put({x:1}, [&quot;y&quot;], 2)
// {x:1, y:2}

context put({x:1, y: {z:0}}, [&quot;y&quot;, &quot;z&quot;], 2)
// {x:1, y: {z:2}}

context put({x:1}, [&quot;y&quot;, &quot;z&quot;], 2)
// {x:1, y: {z:2}}
</code></pre>
`
  },
  {
    name: "context merge(contexts)",
    description: `<p>Union the given contexts. Returns a new context that includes all entries of the given contexts.</p>
<p>If an entry for the same key already exists in a context, it overrides the value. The entries are overridden in the same order as in the list of contexts.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">context merge(contexts: list&lt;context&gt;): context
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">context merge([{x:1}, {y:2}])
// {x:1, y:2}

context merge([{x:1, y: 0}, {y:2}])
// {x:1, y:2}
</code></pre>
<p>:::info
The function <code>context merge()</code> replaced the previous function <code>put all()</code> (Camunda Extension). The
previous function is deprecated and should not be used anymore.
:::</p>
`
  },
  {
    name: "string(from)",
    description: `<p>Returns the given value as a string representation.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">string(from: Any): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">string(1.1)
// &quot;1.1&quot;

string(date(&quot;2012-12-25&quot;))
// &quot;2012-12-25&quot;
</code></pre>
`
  },
  {
    name: "number(from)",
    description: `<p>Parses the given string to a number.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">number(from: string): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">number(&quot;1500.5&quot;)
// 1500.5
</code></pre>
`
  },
  {
    name: "context(entries)",
    description: `<p>Constructs a context of the given list of key-value pairs. It is the reverse function to <a href="feel-built-in-functions-context.md#get-entriescontext">get entries()</a>.</p>
<p>Each key-value pair must be a context with two entries: <code>key</code> and <code>value</code>. The entry with name <code>key</code> must have a value of the type <code>string</code>.</p>
<p>It might override context entries if the keys are equal. The entries are overridden in the same order as the contexts in the given list.</p>
<p>Returns <code>null</code> if one of the entries is not a context or if a context doesn&#39;t contain the required entries.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">context(entries: list&lt;context&gt;): context
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">context([{&quot;key&quot;:&quot;a&quot;, &quot;value&quot;:1}, {&quot;key&quot;:&quot;b&quot;, &quot;value&quot;:2}])
// {a:1, b:2}
</code></pre>
`
  },
  {
    name: "date(from)",
    description: `<p>Returns a date from the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">date(from: string): date
</code></pre>
<p>Parses the given string into a date.</p>
<pre><code class="language-feel">date(from: date and time): date
</code></pre>
<p>Extracts the date component from the given date and time.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">date(&quot;2018-04-29&quot;)
// date(&quot;2018-04-29&quot;)

date(date and time(&quot;2012-12-25T11:00:00&quot;))
// date(&quot;2012-12-25&quot;)
</code></pre>
`
  },
  {
    name: "date(year, month, day)",
    description: `<p>Returns a date from the given components.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">date(year: number, month: number, day: number): date
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">date(2012, 12, 25)
// date(&quot;2012-12-25&quot;)
</code></pre>
`
  },
  {
    name: "time(from)",
    description: `<p>Returns a time from the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">time(from: string): time
</code></pre>
<p>Parses the given string into a time.</p>
<pre><code class="language-feel">time(from: date and time): time
</code></pre>
<p>Extracts the time component from the given date and time.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">time(&quot;12:00:00&quot;)
// time(&quot;12:00:00&quot;)

time(date and time(&quot;2012-12-25T11:00:00&quot;))
// time(&quot;11:00:00&quot;)
</code></pre>
`
  },
  {
    name: "time(hour, minute, second)",
    description: `<p>Returns a time from the given components.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">time(hour: number, minute: number, second: number): time
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">time(23, 59, 0)
// time(&quot;23:59:00&quot;)
</code></pre>
`
  },
  {
    name: "time(hour, minute, second, offset)",
    description: `<p>Returns a time from the given components, including a timezone offset.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">time(hour: number, minute: number, second: number, offset: days and time duration): time
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">time(14, 30, 0, duration(&quot;PT1H&quot;))
// time(&quot;14:30:00+01:00&quot;)
</code></pre>
`
  },
  {
    name: "date and time(from)",
    description: `<p>Parses the given string into a date and time.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">date and time(from: string): date and time
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">date and time(&quot;2018-04-29T009:30:00&quot;)
// date and time(&quot;2018-04-29T009:30:00&quot;)
</code></pre>
`
  },
  {
    name: "date and time(date, time)",
    description: `<p>Returns a date and time from the given components.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">date and time(date: date, time: time): date and time
</code></pre>
<pre><code class="language-feel">date and time(date: date and time, time: time): date and time
</code></pre>
<p>Returns a date and time value that consists of the date component of <code>date</code> combined with <code>time</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">date and time(date(&quot;2012-12-24&quot;),time(&quot;T23:59:00&quot;))
// date and time(&quot;2012-12-24T23:59:00&quot;)

date and time(date and time(&quot;2012-12-25T11:00:00&quot;),time(&quot;T23:59:00&quot;))
// date and time(&quot;2012-12-25T23:59:00&quot;)
</code></pre>
`
  },
  {
    name: "date and time(date, timezone)",
    description: `<p><em>Camunda Extension</em></p>
<p>Returns the given date and time value at the given timezone.</p>
<p>If <code>date</code> has a different timezone than <code>timezone</code> then it adjusts the time to match the local time of <code>timezone</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">date and time(date: date and time, timezone: string): date and time
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">date and time(@&quot;2020-07-31T14:27:30@Europe/Berlin&quot;, &quot;America/Los_Angeles&quot;)
// date and time(&quot;2020-07-31T05:27:30@America/Los_Angeles&quot;)

date and time(@&quot;2020-07-31T14:27:30&quot;, &quot;Z&quot;)
// date and time(&quot;2020-07-31T12:27:30Z&quot;)
</code></pre>
`
  },
  {
    name: "duration(from)",
    description: `<p>Parses the given string into a duration. The duration is either a days and time duration or a years and months duration.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">duration(from: string): days and time duration
</code></pre>
<pre><code class="language-feel">duration(from: string): years and months duration
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">duration(&quot;P5D&quot;)
// duration(&quot;P5D&quot;)

duration(&quot;P32Y&quot;)
// duration(&quot;P32Y&quot;)
</code></pre>
`
  },
  {
    name: "years and months duration(from, to)",
    description: `<p>Returns the years and months duration between <code>from</code> and <code>to</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">years and months duration(from: date, to: date): years and months duration
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">years and months duration(date(&quot;2011-12-22&quot;), date(&quot;2013-08-24&quot;))
// duration(&quot;P1Y8M&quot;)
</code></pre>
`
  },
  {
    name: "list contains(list, element)",
    description: `<p>Returns <code>true</code> if the given list contains the element. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">list contains(list: list, element: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">list contains([1,2,3], 2)
// true
</code></pre>
`
  },
  {
    name: "count(list)",
    description: `<p>Returns the number of elements of the given list.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">count(list: list): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">count([1,2,3])
// 3
</code></pre>
`
  },
  {
    name: "min(list)",
    description: `<p>Returns the minimum of the given list.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">min(list: list): Any
</code></pre>
<p>All elements in <code>list</code> should have the same type and be comparable.</p>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">min([1,2,3])
// 1

min(1,2,3)
// 1
</code></pre>
`
  },
  {
    name: "max(list)",
    description: `<p>Returns the maximum of the given list.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">max(list: list): Any
</code></pre>
<p>All elements in <code>list</code> should have the same type and be comparable.</p>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">max([1,2,3])
// 3

max(1,2,3)
// 3
</code></pre>
`
  },
  {
    name: "sum(list)",
    description: `<p>Returns the sum of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">sum(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">sum([1,2,3])
// 6

sum(1,2,3)
// 6
</code></pre>
`
  },
  {
    name: "product(list)",
    description: `<p>Returns the product of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">product(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">product([2, 3, 4])
// 24

product(2, 3, 4)
// 24
</code></pre>
`
  },
  {
    name: "mean(list)",
    description: `<p>Returns the arithmetic mean (i.e. average) of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">mean(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">mean([1,2,3])
// 2

mean(1,2,3)
// 2
</code></pre>
`
  },
  {
    name: "median(list)",
    description: `<p>Returns the median element of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">median(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">median(8, 2, 5, 3, 4)
// 4

median([6, 1, 2, 3])
// 2.5
</code></pre>
`
  },
  {
    name: "stddev(list)",
    description: `<p>Returns the standard deviation of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">stddev(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">stddev(2, 4, 7, 5)
// 2.0816659994661326

stddev([2, 4, 7, 5])
// 2.0816659994661326
</code></pre>
`
  },
  {
    name: "mode(list)",
    description: `<p>Returns the mode of the given list of numbers.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">mode(list: list&lt;number&gt;): number
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">mode(6, 3, 9, 6, 6)
// [6]

mode([6, 1, 9, 6, 1])
// [1, 6]
</code></pre>
`
  },
  {
    name: "all(list)",
    description: `<p>Returns <code>false</code> if any element of the given list is <code>false</code>. Otherwise, returns <code>true</code>.</p>
<p>If the given list is empty, it returns <code>true</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">all(list: list&lt;boolean&gt;): boolean
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">all([true,false])
// false

all(false,null,true)
// false
</code></pre>
<p>:::info
The function <code>all()</code> replaced the previous function <code>and()</code>. The previous function is deprecated and
should not be used anymore.
:::</p>
`
  },
  {
    name: "any(list)",
    description: `<p>Returns <code>true</code> if any element of the given list is <code>true</code>. Otherwise, returns <code>false</code>.</p>
<p>If the given list is empty, it returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">any(list: list&lt;boolean&gt;): boolean
</code></pre>
<p>The parameter <code>list</code> can be passed as a list or as a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">any([false,true])
// true

any(false,null,true)
// true
</code></pre>
<p>:::info
The function <code>any()</code> replaced the previous function <code>or()</code>. The previous function is deprecated and
should not be used anymore.
:::</p>
`
  },
  {
    name: "sublist(list, start position)",
    description: `<p>Returns a partial list of the given value starting at <code>start position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">sublist(list: list, start position: number): list
</code></pre>
<p>The <code>start position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">sublist([1,2,3], 2)
// [2,3]
</code></pre>
`
  },
  {
    name: "sublist(list, start position, length)",
    description: `<p>Returns a partial list of the given value starting at <code>start position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">sublist(list: list, start position: number, length: number): list
</code></pre>
<p>The <code>start position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">sublist([1,2,3], 1, 2)
// [1,2]
</code></pre>
`
  },
  {
    name: "append(list, items)",
    description: `<p>Returns the given list with all <code>items</code> appended.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">append(list: list, items: Any): list
</code></pre>
<p>The parameter <code>items</code> can be a single element or a sequence of elements.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">append([1], 2, 3)
// [1,2,3]
</code></pre>
`
  },
  {
    name: "concatenate(lists)",
    description: `<p>Returns a list that includes all elements of the given lists.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">concatenate(lists: list): list
</code></pre>
<p>The parameter <code>lists</code> is a sequence of lists.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">concatenate([1,2],[3])
// [1,2,3]

concatenate([1],[2],[3])
// [1,2,3]
</code></pre>
`
  },
  {
    name: "insert before(list, position, newItem)",
    description: `<p>Returns the given list with <code>newItem</code> inserted at <code>position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">insert before(list: list, position: number, newItem: Any): list
</code></pre>
<p>The <code>position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">insert before([1,3],1,2)
// [2,1,3]
</code></pre>
`
  },
  {
    name: "remove(list, position)",
    description: `<p>Returns the given list without the element at <code>position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">remove(list: list, position: number): list
</code></pre>
<p>The <code>position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">remove([1,2,3], 2)
// [1,3]
</code></pre>
`
  },
  {
    name: "reverse(list)",
    description: `<p>Returns the given list in revered order.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">reverse(list: list): list
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">reverse([1,2,3])
// [3,2,1]
</code></pre>
`
  },
  {
    name: "index of(list, match)",
    description: `<p>Returns an ascending list of positions containing <code>match</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">index of(list: list, match: Any): list&lt;number&gt;
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">index of([1,2,3,2],2)
// [2,4]
</code></pre>
`
  },
  {
    name: "union(list)",
    description: `<p>Returns a list that includes all elements of the given lists without duplicates.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">union(list: list): list
</code></pre>
<p>The parameter <code>list</code> is a sequence of lists.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">union([1,2],[2,3])
// [1,2,3]
</code></pre>
`
  },
  {
    name: "distinct values(list)",
    description: `<p>Returns the given list without duplicates.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">distinct values(list: list): list
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">distinct values([1,2,3,2,1])
// [1,2,3]
</code></pre>
`
  },
  {
    name: "duplicate values(list)",
    description: `<p><em>Camunda Extension</em></p>
<p>Returns all duplicate values of the given list.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">duplicate values(list: list): list
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">duplicate values([1,2,3,2,1])
// [1,2]
</code></pre>
`
  },
  {
    name: "flatten(list)",
    description: `<p>Returns a list that includes all elements of the given list without nested lists.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">flatten(list: list): list
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">flatten([[1,2],[[3]], 4])
// [1,2,3,4]
</code></pre>
`
  },
  {
    name: "sort(list, precedes)",
    description: `<p>Returns the given list sorted by the <code>precedes</code> function.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">sort(list: list, precedes: function&lt;(Any, Any) -&gt; boolean&gt;): list
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">sort(list: [3,1,4,5,2], precedes: function(x,y) x &lt; y)
// [1,2,3,4,5]
</code></pre>
`
  },
  {
    name: "string join(list)",
    description: `<p>Joins a list of strings into a single string. This is similar to
Java&#39;s <a href="https://docs.oracle.com/en/java/javase/11/docs/api/java.base/java/util/stream/Collectors.html#joining(java.lang.CharSequence,java.lang.CharSequence,java.lang.CharSequence)">joining</a>
function.</p>
<p>If an item of the list is <code>null</code>, the item is ignored for the result string. If an item is
neither a string nor <code>null</code>, the function returns <code>null</code> instead of a string.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">string join(list: list&lt;string&gt;): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">string join([&quot;a&quot;,&quot;b&quot;,&quot;c&quot;])
// &quot;abc&quot;

string join([&quot;a&quot;,null,&quot;c&quot;])
// &quot;ac&quot;

string join([])
// &quot;&quot;
</code></pre>
`
  },
  {
    name: "string join(list, delimiter)",
    description: `<p>Joins a list of strings into a single string. This is similar to
Java&#39;s <a href="https://docs.oracle.com/en/java/javase/11/docs/api/java.base/java/util/stream/Collectors.html#joining(java.lang.CharSequence,java.lang.CharSequence,java.lang.CharSequence)">joining</a>
function.</p>
<p>If an item of the list is <code>null</code>, the item is ignored for the result string. If an item is
neither a string nor <code>null</code>, the function returns <code>null</code> instead of a string.</p>
<p>The resulting string contains a <code>delimiter</code> between each element.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">string join(list: list&lt;string&gt;, delimiter: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">string join([&quot;a&quot;], &quot;X&quot;)
// &quot;a&quot;

string join([&quot;a&quot;,&quot;b&quot;,&quot;c&quot;], &quot;, &quot;)
// &quot;a, b, c&quot;
</code></pre>
`
  },
  {
    name: "string join(list, delimiter, prefix, suffix)",
    description: `<p><em>Camunda Extension</em></p>
<p>Joins a list of strings into a single string. This is similar to
Java&#39;s <a href="https://docs.oracle.com/en/java/javase/11/docs/api/java.base/java/util/stream/Collectors.html#joining(java.lang.CharSequence,java.lang.CharSequence,java.lang.CharSequence)">joining</a>
function.</p>
<p>If an item of the list is <code>null</code>, the item is ignored for the result string. If an item is
neither a string nor <code>null</code>, the function returns <code>null</code> instead of a string.</p>
<p>The resulting string starts with <code>prefix</code>, contains a <code>delimiter</code> between each element, and ends
with <code>suffix</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">string join(list: list&lt;string&gt;, delimiter: string, prefix: string, suffix: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">string join([&quot;a&quot;,&quot;b&quot;,&quot;c&quot;], &quot;, &quot;, &quot;[&quot;, &quot;]&quot;)
// &quot;[a, b, c]&quot;
</code></pre>
`
  },
  {
    name: "decimal(n, scale)",
    description: `<p>Rounds the given value at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">decimal(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">decimal(1/3, 2)
// .33

decimal(1.5, 0)
// 2
</code></pre>
`
  },
  {
    name: "floor(n)",
    description: `<p>Rounds the given value with rounding mode flooring.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">floor(n: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">floor(1.5)
// 1

floor(-1.5)
// -2
</code></pre>
`
  },
  {
    name: "floor(n, scale)",
    description: `<p>Rounds the given value with rounding mode flooring at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">floor(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">floor(-1.56, 1)
// -1.6
</code></pre>
`
  },
  {
    name: "ceiling(n)",
    description: `<p>Rounds the given value with rounding mode ceiling.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">ceiling(n: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">ceiling(1.5)
// 2

ceiling(-1.5)
// -1
</code></pre>
`
  },
  {
    name: "ceiling(n, scale)",
    description: `<p>Rounds the given value with rounding mode ceiling at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">ceiling(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">ceiling(-1.56, 1)
// -1.5
</code></pre>
`
  },
  {
    name: "round up(n, scale)",
    description: `<p>Rounds the given value with the rounding mode round-up at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">round up(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">round up(5.5)
// 6

round up(-5.5)
// -6

round up(1.121, 2)
// 1.13

round up(-1.126, 2)
// -1.13
</code></pre>
`
  },
  {
    name: "round down(n, scale)",
    description: `<p>Rounds the given value with the rounding mode round-down at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">round down(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">round down(5.5, 0)
// 5

round down (-5.5, 0)
// -5

round down (1.121, 2)
// 1.12

round down (-1.126, 2)
// -1.12
</code></pre>
`
  },
  {
    name: "round half up(n, scale)",
    description: `<p>Rounds the given value with the rounding mode round-half-up at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">round half up(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">round half up(5.5, 0)
// 6

round half up(-5.5, 0)
// -6

round half up(1.121, 2)
// 1.12

round half up(-1.126, 2)
// -1.13
</code></pre>
`
  },
  {
    name: "round half down(n, scale)",
    description: `<p>Rounds the given value with the rounding mode round-half-down at the given scale.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">round half down(n: number, scale: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">round half down (5.5, 0)
// 5

round half down (-5.5, 0)
// -5

round half down (1.121, 2)
// 1.12

round half down (-1.126, 2)
// -1.13
</code></pre>
`
  },
  {
    name: "abs(number)",
    description: `<p>Returns the absolute value of the given numeric value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">abs(number: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">abs(10)
// 10

abs(-10)
// 10
</code></pre>
`
  },
  {
    name: "modulo(dividend, divisor)",
    description: `<p>Returns the remainder of the division of dividend by divisor.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">modulo(dividend: number, divisor: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">modulo(12, 5)
// 2
</code></pre>
`
  },
  {
    name: "sqrt(number)",
    description: `<p>Returns the square root of the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">sqrt(number: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">sqrt(16)
// 4
</code></pre>
`
  },
  {
    name: "log(number)",
    description: `<p>Returns the natural logarithm (base e) of the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">log(number: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">log(10)
// 2.302585092994046
</code></pre>
`
  },
  {
    name: "exp(number)",
    description: `<p>Returns the Euler’s number e raised to the power of the given number .</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">exp(number: number): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">exp(5)
// 148.4131591025766
</code></pre>
`
  },
  {
    name: "odd(number)",
    description: `<p>Returns <code>true</code> if the given value is odd. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">odd(number: number): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">odd(5)
// true

odd(2)
// false
</code></pre>
`
  },
  {
    name: "even(number)",
    description: `<p>Returns <code>true</code> if the given is even. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">even(number: number): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">even(5)
// false

even(2)
// true
</code></pre>
`
  },
  {
    name: "random number()",
    description: `<p><em>Camunda Extension</em></p>
<p>Returns a random number between <code>0</code> and <code>1</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">random number(): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">random number()
// 0.9701618132579795
</code></pre>
`
  },
  {
    name: "before(point1, point2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">before(point1: Any, point2: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">before(1, 10)
// true

before(10, 1)
// false
</code></pre>
`
  },
  {
    name: "before(range, point)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">before(range: range, point: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">before([1..5], 10)
// true
</code></pre>
`
  },
  {
    name: "before(point, range)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">before(point: Any, range: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">before(1, [2..5])
// true
</code></pre>
`
  },
  {
    name: "before(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">before(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">before([1..5], [6..10])
// true

before([1..5),[5..10])
// true
</code></pre>
`
  },
  {
    name: "after(point1, point2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">after(point1: Any, point2: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">after(10, 1)
// true

after(1, 10)
// false
</code></pre>
`
  },
  {
    name: "after(range, point)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">after(range: range, point: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">after([1..5], 10)
// false
</code></pre>
`
  },
  {
    name: "after(point, range)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">after(point: Any, range: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">after(12, [2..5])
// true
</code></pre>
`
  },
  {
    name: "after(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">after(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">after([6..10], [1..5])
// true

after([5..10], [1..5))
// true
</code></pre>
`
  },
  {
    name: "meets(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">meets(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">meets([1..5], [5..10])
// true

meets([1..3], [4..6])
// false

meets([1..3], [3..5])
// true

meets([1..5], (5..8])
// false
</code></pre>
`
  },
  {
    name: "met by(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">met by(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">met by([5..10], [1..5])
// true

met by([3..4], [1..2])
// false

met by([3..5], [1..3])
// true

met by((5..8], [1..5))
// false

met by([5..10], [1..5))
// false
</code></pre>
`
  },
  {
    name: "overlaps(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">overlaps(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">overlaps([5..10], [1..6])
// true

overlaps((3..7], [1..4])
// true

overlaps([1..3], (3..6])
// false

overlaps((5..8], [1..5))
// false

overlaps([4..10], [1..5))
// true
</code></pre>
`
  },
  {
    name: "overlaps before(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">overlaps before(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">overlaps before([1..5], [4..10])
// true

overlaps before([3..4], [1..2])
// false

overlaps before([1..3], (3..5])
// false

overlaps before([1..5), (3..8])
// true

overlaps before([1..5), [5..10])
// false
</code></pre>
`
  },
  {
    name: "overlaps after(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">overlaps after(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">overlaps after([4..10], [1..5])
// true

overlaps after([3..4], [1..2])
// false

overlaps after([3..5], [1..3))
// false

overlaps after((5..8], [1..5))
// false

overlaps after([4..10], [1..5))
// true
</code></pre>
`
  },
  {
    name: "finishes(point, range)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">finishes(point: Any, range: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">finishes(5, [1..5])
// true

finishes(10, [1..7])
// false
</code></pre>
`
  },
  {
    name: "finishes(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">finishes(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">finishes([3..5], [1..5])
// true

finishes((1..5], [1..5))
// false

finishes([5..10], [1..10))
// false
</code></pre>
`
  },
  {
    name: "finished by(range, point)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">finished by(range: range, point: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">finished by([5..10], 10)
// true

finished by([3..4], 2)
// false
</code></pre>
`
  },
  {
    name: "finished by(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">finished by(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">finished by([1..5], [3..5])
// true

finished by((5..8], [1..5))
// false

finished by([5..10], (1..10))
// false
</code></pre>
`
  },
  {
    name: "includes(range, point)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">includes(range: range, point: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">includes([5..10], 6)
// true

includes([3..4], 5)
// false
</code></pre>
`
  },
  {
    name: "includes(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">includes(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">includes([1..10], [4..6])
// true

includes((5..8], [1..5))
// false

includes([1..10], [1..5))
// true
</code></pre>
`
  },
  {
    name: "during(point, range)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">during(point: Any, range: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">during(5, [1..10])
// true

during(12, [1..10])
// false

during(1, (1..10])
// false
</code></pre>
`
  },
  {
    name: "during(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">during(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">during([4..6], [1..10))
// true

during((1..5], (1..10])
// true
</code></pre>
`
  },
  {
    name: "starts(point, range)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">starts(point: Any, range: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">starts(1, [1..5])
// true

starts(1, (1..8])
// false
</code></pre>
`
  },
  {
    name: "starts(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">starts(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">starts((1..5], [1..5])
// false

starts([1..10], [1..5])
// false

starts((1..5), (1..10))
// true
</code></pre>
`
  },
  {
    name: "started by(range, point)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">started by(range: range, point: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">started by([1..10], 1)
// true

started by((1..10], 1)
// false
</code></pre>
`
  },
  {
    name: "started by(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">started by(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">started by([1..10], [1..5])
// true

started by((1..10], [1..5))
// false

started by([1..10], [1..10))
// true
</code></pre>
`
  },
  {
    name: "coincides(point1, point2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">coincides(point1: Any, point2: Any): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">coincides(5, 5)
// true

coincides(3, 4)
// false
</code></pre>
`
  },
  {
    name: "coincides(range1, range2)",
    description: `<p><strong>Function signature</strong></p>
<pre><code class="language-feel">coincides(range1: range, range2: range): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">coincides([1..5], [1..5])
// true

coincides((1..5], [1..5))
// false

coincides([1..5], [2..6])
// false
</code></pre>
`
  },
  {
    name: "substring(string, start position)",
    description: `<p>Returns a substring of the given value starting at <code>start position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">substring(string: string, start position: number): string
</code></pre>
<p>The <code>start position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">substring(&quot;foobar&quot;, 3)
// &quot;obar&quot;
</code></pre>
`
  },
  {
    name: "substring(string, start position, length)",
    description: `<p>Returns a substring of the given value starting at <code>start position</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">substring(string: string, start position: number, length: number): string
</code></pre>
<p>The <code>start position</code> starts at the index <code>1</code>. The last position is <code>-1</code>.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">substring(&quot;foobar&quot;, 3, 3)
// &quot;oba&quot;
</code></pre>
`
  },
  {
    name: "string length(string)",
    description: `<p>Returns the number of characters in the given value.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">string length(string: string): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">string length(&quot;foo&quot;)
// 3
</code></pre>
`
  },
  {
    name: "upper case(string)",
    description: `<p>Returns the given value with all characters are uppercase.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">upper case(string: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">upper case(&quot;aBc4&quot;)
// &quot;ABC4&quot;
</code></pre>
`
  },
  {
    name: "lower case(string)",
    description: `<p>Returns the given value with all characters are lowercase.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">lower case(string: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">lower case(&quot;aBc4&quot;)
// &quot;abc4&quot;
</code></pre>
`
  },
  {
    name: "substring before(string, match)",
    description: `<p>Returns a substring of the given value that contains all characters before <code>match</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">substring before(string: string, match: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">substring before(&quot;foobar&quot;, &quot;bar&quot;)
// &quot;foo&quot;
</code></pre>
`
  },
  {
    name: "substring after(string, match)",
    description: `<p>Returns a substring of the given value that contains all characters after <code>match</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">substring after(string: string, match: string): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">substring after(&quot;foobar&quot;, &quot;ob&quot;)
// &quot;ar&quot;
</code></pre>
`
  },
  {
    name: "contains(string, match)",
    description: `<p>Returns <code>true</code> if the given value contains the substring <code>match</code>. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">contains(string: string, match: string): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">contains(&quot;foobar&quot;, &quot;of&quot;)
// false
</code></pre>
`
  },
  {
    name: "starts with(string, match)",
    description: `<p>Returns <code>true</code> if the given value starts with the substring <code>match</code>. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">starts with(string: string, match: string): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">starts with(&quot;foobar&quot;, &quot;fo&quot;)
// true
</code></pre>
`
  },
  {
    name: "ends with(string, match)",
    description: `<p>Returns <code>true</code> if the given value ends with the substring <code>match</code>. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">ends with(string: string, match: string): boolean
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">ends with(&quot;foobar&quot;, &quot;r&quot;)
// true
</code></pre>
`
  },
  {
    name: "matches(input, pattern)",
    description: `<p>Returns <code>true</code> if the given value matches the <code>pattern</code>. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">matches(input: string, pattern: string): boolean
</code></pre>
<p>The <code>pattern</code> is a string that contains a regular expression.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">matches(&quot;foobar&quot;, &quot;^fo*bar&quot;)
// true
</code></pre>
`
  },
  {
    name: "matches(input, pattern, flags)",
    description: `<p>Returns <code>true</code> if the given value matches the <code>pattern</code>. Otherwise, returns <code>false</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">matches(input: string, pattern: string, flags: string): boolean
</code></pre>
<p>The <code>pattern</code> is a string that contains a regular expression.</p>
<p>The <code>flags</code> can contain one or more of the following characters:</p>
<ul>
<li><code>s</code> (dot-all)</li>
<li><code>m</code> (multi-line)</li>
<li><code>i</code> (case insensitive)</li>
<li><code>x</code> (comments)</li>
</ul>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">matches(&quot;FooBar&quot;, &quot;foo&quot;, &quot;i&quot;)
// true
</code></pre>
`
  },
  {
    name: "replace(input, pattern, replacement)",
    description: `<p>Returns the resulting string after replacing all occurrences of <code>pattern</code> with <code>replacement</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">replace(input: string, pattern: string, replacement: string): string
</code></pre>
<p>The <code>pattern</code> is a string that contains a regular expression.</p>
<p>The <code>replacement</code> can access the match groups by using <code>$</code> and the number of the group, for example,
<code>$1</code> to access the first group.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">replace(&quot;abcd&quot;, &quot;(ab)|(a)&quot;, &quot;[1=$1][2=$2]&quot;)
// &quot;[1=ab][2=]cd&quot;

replace(&quot;0123456789&quot;, &quot;(\\d{3})(\\d{3})(\\d{4})&quot;, &quot;($1) $2-$3&quot;)
// &quot;(012) 345-6789&quot;
</code></pre>
`
  },
  {
    name: "replace(input, pattern, replacement, flags)",
    description: `<p>Returns the resulting string after replacing all occurrences of <code>pattern</code> with <code>replacement</code>.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">replace(input: string, pattern: string, replacement: string, flags: string): string
</code></pre>
<p>The <code>pattern</code> is a string that contains a regular expression.</p>
<p>The <code>replacement</code> can access the match groups by using <code>$</code> and the number of the group, for example,
<code>$1</code> to access the first group.</p>
<p>The <code>flags</code> can contain one or more of the following characters:</p>
<ul>
<li><code>s</code> (dot-all)</li>
<li><code>m</code> (multi-line)</li>
<li><code>i</code> (case insensitive)</li>
<li><code>x</code> (comments)</li>
</ul>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">replace(&quot;How do you feel?&quot;, &quot;Feel&quot;, &quot;FEEL&quot;, &quot;i&quot;)
// &quot;How do you FEEL?&quot;
</code></pre>
`
  },
  {
    name: "split(string, delimiter)",
    description: `<p>Splits the given value into a list of substrings, breaking at each occurrence of the <code>delimiter</code> pattern.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">split(string: string, delimiter: string): list&lt;string&gt;
</code></pre>
<p>The <code>delimiter</code> is a string that contains a regular expression.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">split(&quot;John Doe&quot;, &quot;\\s&quot; )
// [&quot;John&quot;, &quot;Doe&quot;]

split(&quot;a;b;c;;&quot;, &quot;;&quot;)
// [&quot;a&quot;, &quot;b&quot;, &quot;c&quot;, &quot;&quot;, &quot;&quot;]
</code></pre>
`
  },
  {
    name: "extract(string, pattern)",
    description: `<p><em>Camunda Extension</em></p>
<p>Returns all matches of the pattern in the given string. Returns an empty list if the pattern doesn&#39;t
match.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">extract(string: string, pattern: string): list&lt;string&gt;
</code></pre>
<p>The <code>pattern</code> is a string that contains a regular expression.</p>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">extract(&quot;references are 1234, 1256, 1378&quot;, &quot;12[0-9]*&quot;)
// [&quot;1234&quot;,&quot;1256&quot;]
</code></pre>
`
  },
  {
    name: "now()",
    description: `<p>Returns the current date and time including the timezone.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">now(): date and time
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">now()
// date and time(&quot;2020-07-31T14:27:30@Europe/Berlin&quot;)
</code></pre>
`
  },
  {
    name: "today()",
    description: `<p>Returns the current date.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">today(): date
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">today()
// date(&quot;2020-07-31&quot;)
</code></pre>
`
  },
  {
    name: "day of week(date)",
    description: `<p>Returns the day of the week according to the Gregorian calendar. Note that it always returns the English name of the day.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">day of week(date: date): string
</code></pre>
<pre><code class="language-feel">day of week(date: date and time): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">day of week(date(&quot;2019-09-17&quot;))
// &quot;Tuesday&quot;

day of week(date and time(&quot;2019-09-17T12:00:00&quot;))
// &quot;Tuesday&quot;
</code></pre>
`
  },
  {
    name: "day of year(date)",
    description: `<p>Returns the Gregorian number of the day within the year.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">day of year(date: date): number
</code></pre>
<pre><code class="language-feel">day of year(date: date and time): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">day of year(date(&quot;2019-09-17&quot;))
// 260

day of year(date and time(&quot;2019-09-17T12:00:00&quot;))
// 260
</code></pre>
`
  },
  {
    name: "week of year(date)",
    description: `<p>Returns the Gregorian number of the week within the year, according to ISO 8601.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">week of year(date: date): number
</code></pre>
<pre><code class="language-feel">week of year(date: date and time): number
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">week of year(date(&quot;2019-09-17&quot;))
// 38

week of year(date and time(&quot;2019-09-17T12:00:00&quot;))
// 38
</code></pre>
`
  },
  {
    name: "month of year(date)",
    description: `<p>Returns the month of the year according to the Gregorian calendar. Note that it always returns the English name of the month.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">month of year(date: date): string
</code></pre>
<pre><code class="language-feel">month of year(date: date and time): string
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">month of year(date(&quot;2019-09-17&quot;))
// &quot;September&quot;

month of year(date and time(&quot;2019-09-17T12:00:00&quot;))
// &quot;September&quot;
</code></pre>
`
  },
  {
    name: "abs(n)",
    description: `<p>Returns the absolute value of a given duration.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">abs(n: days and time duration): days and time duration
</code></pre>
<pre><code class="language-feel">abs(n: years and months duration): years and months duration
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">abs(duration(&quot;-PT5H&quot;))
// &quot;duration(&quot;PT5H&quot;)&quot;

abs(duration(&quot;PT5H&quot;))
// &quot;duration(&quot;PT5H&quot;)&quot;

abs(duration(&quot;-P2M&quot;))
// duration(&quot;P2M&quot;)
</code></pre>
`
  },
  {
    name: "last day of month(date)",
    description: `<p><em>Camunda Extension</em></p>
<p>Takes the month of the given date or date-time value and returns the last day of this month.</p>
<p><strong>Function signature</strong></p>
<pre><code class="language-feel">last day of month(date: date): date
</code></pre>
<pre><code class="language-feel">last day of month(date: date and time): date
</code></pre>
<p><strong>Examples</strong></p>
<pre><code class="language-feel">last day of month(date(&quot;2022-10-01&quot;))
// date(&quot;2022-10-31&quot;))

last day of month(date and time(&quot;2022-10-16T12:00:00&quot;))
// date(&quot;2022-10-31&quot;))
</code></pre>
`
  }
];
const d_e = yZt.map((r) => {
  const e = r.name.match(/^([\w\s]+)\((.*)\)$/), t = e[1], i = e[2].split(", ").map((s) => `\${${s}}`).join(", ");
  return d0(
    `${t}(${i})`,
    {
      label: r.name,
      type: "function",
      info: () => aRe(`<div class="description">${r.description}<div>`),
      boost: -1
    }
  );
});
var CZt = (r) => {
  let e = Zr(r.state).resolve(r.pos, -1), t = e.nextSibling;
  return qb(e) || t && t.from === r.pos && qb(t) ? r.explicit ? {
    from: r.pos,
    options: d_e
  } : null : e.parent && e.parent.name !== "VariableName" || AC(e) ? null : {
    from: e.from,
    options: d_e
  };
};
const wC = bt.define();
var EZt = (r) => {
  const e = r.state.facet(wC)[0], t = Zr(r.state).resolve(r.pos, -1);
  if (!AC(t))
    return;
  const n = _Zt(t), i = t === n ? r.pos : t.from, s = wH(n, r);
  let o = e;
  for (var a = 0; a < s.length - 1; a++) {
    var l = o.find((d) => d.name === s[a].name);
    if (!l)
      return null;
    if (l.isList !== "optional" && !!l.isList !== s[a].isList)
      return;
    o = l.entries;
  }
  return o ? (o = o.map((d) => ({
    label: d.name,
    type: "variable",
    info: d.info,
    detail: d.detail
  })), {
    from: i,
    options: o
  }) : void 0;
};
function _Zt(r) {
  for (; r; ) {
    if (r.name === "PathExpression")
      return r;
    r = r.parent;
  }
}
function wH(r, e) {
  let t = [];
  for (let n = r.firstChild; n; n = n.nextSibling)
    n.name === "PathExpression" ? t.push(...wH(n, e)) : n.name === "FilterExpression" ? t.push(...xZt(n, e)) : t.push({
      name: kBe(n, e),
      isList: !1
    });
  return t;
}
function xZt(r, e) {
  const t = r.firstChild;
  if (t.name === "PathExpression") {
    const n = wH(t, e), i = n[n.length - 1];
    return i.isList = !0, n;
  }
  return [{
    name: kBe(t, e),
    isList: !0
  }];
}
function kBe(r, e) {
  return e.state.sliceDoc(r.from, r.to);
}
var SZt = (r) => {
  const t = r.state.facet(wC)[0].map((a) => ({
    label: a.name,
    type: "variable",
    info: a.info,
    detail: a.detail
  }));
  let n = Zr(r.state).resolve(r.pos, -1), i = n.nextSibling;
  if (qb(n) || i && i.from === r.pos && qb(i))
    return r.explicit ? {
      from: r.pos,
      options: t
    } : null;
  const o = {
    from: n.from,
    options: t
  };
  return n.parent && n.parent.name !== "VariableName" || AC(n) ? null : o;
};
function MZt() {
  return [
    sWt({
      override: [
        SZt,
        CZt,
        tH(mZt.map((r) => ({ ...r, boost: -1 }))),
        EZt,
        ...AZt
      ]
    })
  ];
}
function DZt() {
  return new cHe(AH, []);
}
var LZt = [iBe(MBe())];
const kZt = st.theme({
  "& .cm-content": {
    padding: "0px"
  },
  "& .cm-line": {
    padding: "0px"
  },
  "&.cm-editor.cm-focused": {
    outline: "none"
  },
  "& .cm-completionInfo": {
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  // Don't wrap whitespace for custom HTML
  "& .cm-completionInfo > *": {
    whiteSpace: "normal"
  },
  "& .cm-completionInfo ul": {
    margin: 0,
    paddingLeft: "15px"
  },
  "& .cm-completionInfo pre": {
    marginBottom: 0,
    whiteSpace: "pre-wrap"
  },
  "& .cm-completionInfo p": {
    marginTop: 0
  },
  "& .cm-completionInfo p:not(:last-of-type)": {
    marginBottom: 0
  }
}), NZt = st.baseTheme({
  "& .variableName": {
    color: "#10f"
  },
  "& .number": {
    color: "#164"
  },
  "& .string": {
    color: "#a11"
  },
  "& .bool": {
    color: "#219"
  },
  "& .function": {
    color: "#aa3731",
    fontWeight: "bold"
  },
  "& .control": {
    color: "#708"
  }
}), TZt = uC(
  f2.define([
    { tag: J.variableName, class: "variableName" },
    { tag: J.name, class: "variableName" },
    { tag: J.number, class: "number" },
    { tag: J.string, class: "string" },
    { tag: J.bool, class: "bool" },
    { tag: J.function(J.variableName), class: "function" },
    { tag: J.function(J.special(J.variableName)), class: "function" },
    { tag: J.controlKeyword, class: "control" },
    { tag: J.operatorKeyword, class: "control" }
  ])
);
var IZt = [kZt, NZt, TZt];
const NBe = new Yw();
function rv({
  extensions: r = [],
  container: e,
  contentAttributes: t = {},
  tooltipContainer: n,
  onChange: i = () => {
  },
  onKeyDown: s = () => {
  },
  onLint: o = () => {
  },
  readOnly: a = !1,
  value: l = "",
  variables: c = []
}) {
  const d = st.updateListener.of((m) => {
    m.docChanged && i(m.state.doc.toString());
  }), u = st.updateListener.of((m) => {
    const A = m.transactions.flatMap((v) => v.effects).filter((v) => v.is(iv));
    if (!A.length)
      return;
    const w = A.flatMap((v) => v.value);
    o(w);
  }), f = st.domEventHandlers(
    {
      keydown: s
    }
  );
  typeof n == "string" && (n = document.querySelector(n));
  const p = n ? rHe({
    tooltipSpace: function() {
      return n.getBoundingClientRect();
    }
  }) : [], g = [
    NBe.of(wC.of(c)),
    MZt(),
    wHe(),
    d,
    SHe(),
    st.contentAttributes.of(t),
    fHe(),
    f,
    ev.of([
      ...$He
    ]),
    DZt(),
    LZt,
    u,
    p,
    IZt,
    ...r
  ];
  return a && g.push(st.editable.of(!1)), this._cmEditor = new st({
    state: jn.create({
      doc: l,
      extensions: g
    }),
    parent: e
  }), this;
}
rv.prototype.setValue = function(r) {
  this._cmEditor.dispatch({
    changes: {
      from: 0,
      to: this._cmEditor.state.doc.length,
      insert: r
    }
  });
};
rv.prototype.focus = function(r) {
  const e = this._cmEditor;
  if (e.contentDOM.focus(), e.focus(), typeof r == "number") {
    const t = e.state.doc.length;
    e.dispatch({ selection: { anchor: r <= t ? r : t } });
  }
};
rv.prototype.getSelection = function() {
  return this._cmEditor.state.selection;
};
rv.prototype.setVariables = function(r) {
  this._cmEditor.dispatch({
    effects: NBe.reconfigure(wC.of(r))
  });
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var TBe = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Gb = /* @__PURE__ */ TBe.join(","), IBe = typeof Element > "u", Rf = IBe ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Qb = !IBe && Element.prototype.getRootNode ? function(r) {
  var e;
  return r == null || (e = r.getRootNode) === null || e === void 0 ? void 0 : e.call(r);
} : function(r) {
  return r?.ownerDocument;
}, Kb = function r(e, t) {
  var n;
  t === void 0 && (t = !0);
  var i = e == null || (n = e.getAttribute) === null || n === void 0 ? void 0 : n.call(e, "inert"), s = i === "" || i === "true", o = s || t && e && r(e.parentNode);
  return o;
}, OZt = function(e) {
  var t, n = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return n === "" || n === "true";
}, OBe = function(e, t, n) {
  if (Kb(e))
    return [];
  var i = Array.prototype.slice.apply(e.querySelectorAll(Gb));
  return t && Rf.call(e, Gb) && i.unshift(e), i = i.filter(n), i;
}, RBe = function r(e, t, n) {
  for (var i = [], s = Array.from(e); s.length; ) {
    var o = s.shift();
    if (!Kb(o, !1))
      if (o.tagName === "SLOT") {
        var a = o.assignedElements(), l = a.length ? a : o.children, c = r(l, !0, n);
        n.flatten ? i.push.apply(i, c) : i.push({
          scopeParent: o,
          candidates: c
        });
      } else {
        var d = Rf.call(o, Gb);
        d && n.filter(o) && (t || !e.includes(o)) && i.push(o);
        var u = o.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(o), f = !Kb(u, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
        if (u && f) {
          var p = r(u === !0 ? o.children : u.children, !0, n);
          n.flatten ? i.push.apply(i, p) : i.push({
            scopeParent: o,
            candidates: p
          });
        } else
          s.unshift.apply(s, o.children);
      }
  }
  return i;
}, VBe = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, k0 = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || OZt(e)) && !VBe(e) ? 0 : e.tabIndex;
}, RZt = function(e, t) {
  var n = k0(e);
  return n < 0 && t && !VBe(e) ? 0 : n;
}, VZt = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, HBe = function(e) {
  return e.tagName === "INPUT";
}, HZt = function(e) {
  return HBe(e) && e.type === "hidden";
}, BZt = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return t;
}, PZt = function(e, t) {
  for (var n = 0; n < e.length; n++)
    if (e[n].checked && e[n].form === t)
      return e[n];
}, FZt = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || Qb(e), n = function(a) {
    return t.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = n(window.CSS.escape(e.name));
  else
    try {
      i = n(e.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var s = PZt(i, e.form);
  return !s || s === e;
}, zZt = function(e) {
  return HBe(e) && e.type === "radio";
}, WZt = function(e) {
  return zZt(e) && !FZt(e);
}, jZt = function(e) {
  var t, n = e && Qb(e), i = (t = n) === null || t === void 0 ? void 0 : t.host, s = !1;
  if (n && n !== e) {
    var o, a, l;
    for (s = !!((o = i) !== null && o !== void 0 && (a = o.ownerDocument) !== null && a !== void 0 && a.contains(i) || e != null && (l = e.ownerDocument) !== null && l !== void 0 && l.contains(e)); !s && i; ) {
      var c, d, u;
      n = Qb(i), i = (c = n) === null || c === void 0 ? void 0 : c.host, s = !!((d = i) !== null && d !== void 0 && (u = d.ownerDocument) !== null && u !== void 0 && u.contains(i));
    }
  }
  return s;
}, u_e = function(e) {
  var t = e.getBoundingClientRect(), n = t.width, i = t.height;
  return n === 0 && i === 0;
}, ZZt = function(e, t) {
  var n = t.displayCheck, i = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var s = Rf.call(e, "details>summary:first-of-type"), o = s ? e.parentElement : e;
  if (Rf.call(o, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof i == "function") {
      for (var a = e; e; ) {
        var l = e.parentElement, c = Qb(e);
        if (l && !l.shadowRoot && i(l) === !0)
          return u_e(e);
        e.assignedSlot ? e = e.assignedSlot : !l && c !== e.ownerDocument ? e = c.host : e = l;
      }
      e = a;
    }
    if (jZt(e))
      return !e.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return u_e(e);
  return !1;
}, UZt = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var n = 0; n < t.children.length; n++) {
          var i = t.children.item(n);
          if (i.tagName === "LEGEND")
            return Rf.call(t, "fieldset[disabled] *") ? !0 : !i.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, Yb = function(e, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Kb(t) || HZt(t) || ZZt(t, e) || // For a details element with a summary, the summary element gets the focus
  BZt(t) || UZt(t));
}, LT = function(e, t) {
  return !(WZt(t) || k0(t) < 0 || !Yb(e, t));
}, qZt = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, GZt = function r(e) {
  var t = [], n = [];
  return e.forEach(function(i, s) {
    var o = !!i.scopeParent, a = o ? i.scopeParent : i, l = RZt(a, o), c = o ? r(i.candidates) : a;
    l === 0 ? o ? t.push.apply(t, c) : t.push(a) : n.push({
      documentOrder: s,
      tabIndex: l,
      item: i,
      isScope: o,
      content: c
    });
  }), n.sort(VZt).reduce(function(i, s) {
    return s.isScope ? i.push.apply(i, s.content) : i.push(s.content), i;
  }, []).concat(t);
}, QZt = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = RBe([e], t.includeContainer, {
    filter: LT.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: qZt
  }) : n = OBe(e, t.includeContainer, LT.bind(null, t)), GZt(n);
}, KZt = function(e, t) {
  t = t || {};
  var n;
  return t.getShadowRoot ? n = RBe([e], t.includeContainer, {
    filter: Yb.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : n = OBe(e, t.includeContainer, Yb.bind(null, t)), n;
}, R2 = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return Rf.call(e, Gb) === !1 ? !1 : LT(t, e);
}, YZt = /* @__PURE__ */ TBe.concat("iframe").join(","), jS = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return Rf.call(e, YZt) === !1 ? !1 : Yb(t, e);
};
/*!
* focus-trap 7.5.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function f_e(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function p_e(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? f_e(Object(t), !0).forEach(function(n) {
      XZt(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : f_e(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function XZt(r, e, t) {
  return e = $Zt(e), e in r ? Object.defineProperty(r, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[e] = t, r;
}
function JZt(r, e) {
  if (typeof r != "object" || r === null) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(r, e);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(r);
}
function $Zt(r) {
  var e = JZt(r, "string");
  return typeof e == "symbol" ? e : String(e);
}
var g_e = {
  activateTrap: function(e, t) {
    if (e.length > 0) {
      var n = e[e.length - 1];
      n !== t && n.pause();
    }
    var i = e.indexOf(t);
    i === -1 || e.splice(i, 1), e.push(t);
  },
  deactivateTrap: function(e, t) {
    var n = e.indexOf(t);
    n !== -1 && e.splice(n, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, eUt = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, tUt = function(e) {
  return e?.key === "Escape" || e?.key === "Esc" || e?.keyCode === 27;
}, b3 = function(e) {
  return e?.key === "Tab" || e?.keyCode === 9;
}, nUt = function(e) {
  return b3(e) && !e.shiftKey;
}, iUt = function(e) {
  return b3(e) && e.shiftKey;
}, m_e = function(e) {
  return setTimeout(e, 0);
}, A_e = function(e, t) {
  var n = -1;
  return e.every(function(i, s) {
    return t(i) ? (n = s, !1) : !0;
  }), n;
}, lA = function(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)
    n[i - 1] = arguments[i];
  return typeof e == "function" ? e.apply(void 0, n) : e;
}, $5 = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, rUt = [], sUt = function(e, t) {
  var n = t?.document || document, i = t?.trapStack || rUt, s = p_e({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: nUt,
    isKeyBackward: iUt
  }, t), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, a, l = function(V, N, R) {
    return V && V[N] !== void 0 ? V[N] : s[R || N];
  }, c = function(V, N) {
    var R = typeof N?.composedPath == "function" ? N.composedPath() : void 0;
    return o.containerGroups.findIndex(function(H) {
      var z = H.container, U = H.tabbableNodes;
      return z.contains(V) || R?.includes(z) || U.find(function(ee) {
        return ee === V;
      });
    });
  }, d = function(V) {
    var N = s[V];
    if (typeof N == "function") {
      for (var R = arguments.length, H = new Array(R > 1 ? R - 1 : 0), z = 1; z < R; z++)
        H[z - 1] = arguments[z];
      N = N.apply(void 0, H);
    }
    if (N === !0 && (N = void 0), !N) {
      if (N === void 0 || N === !1)
        return N;
      throw new Error("`".concat(V, "` was specified but was not a node, or did not return a node"));
    }
    var U = N;
    if (typeof N == "string" && (U = n.querySelector(N), !U))
      throw new Error("`".concat(V, "` as selector refers to no known node"));
    return U;
  }, u = function() {
    var V = d("initialFocus");
    if (V === !1)
      return !1;
    if (V === void 0 || !jS(V, s.tabbableOptions))
      if (c(n.activeElement) >= 0)
        V = n.activeElement;
      else {
        var N = o.tabbableGroups[0], R = N && N.firstTabbableNode;
        V = R || d("fallbackFocus");
      }
    if (!V)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return V;
  }, f = function() {
    if (o.containerGroups = o.containers.map(function(V) {
      var N = QZt(V, s.tabbableOptions), R = KZt(V, s.tabbableOptions), H = N.length > 0 ? N[0] : void 0, z = N.length > 0 ? N[N.length - 1] : void 0, U = R.find(function(se) {
        return R2(se);
      }), ee = R.slice().reverse().find(function(se) {
        return R2(se);
      }), ce = !!N.find(function(se) {
        return k0(se) > 0;
      });
      return {
        container: V,
        tabbableNodes: N,
        focusableNodes: R,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ce,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: H,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: z,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: U,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ee,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(te) {
          var ue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, G = N.indexOf(te);
          return G < 0 ? ue ? R.slice(R.indexOf(te) + 1).find(function(j) {
            return R2(j);
          }) : R.slice(0, R.indexOf(te)).reverse().find(function(j) {
            return R2(j);
          }) : N[G + (ue ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(V) {
      return V.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(V) {
      return V.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, p = function B(V) {
    if (V !== !1 && V !== n.activeElement) {
      if (!V || !V.focus) {
        B(u());
        return;
      }
      V.focus({
        preventScroll: !!s.preventScroll
      }), o.mostRecentlyFocusedNode = V, eUt(V) && V.select();
    }
  }, g = function(V) {
    var N = d("setReturnFocus", V);
    return N || (N === !1 ? !1 : V);
  }, m = function(V) {
    var N = V.target, R = V.event, H = V.isBackward, z = H === void 0 ? !1 : H;
    N = N || $5(R), f();
    var U = null;
    if (o.tabbableGroups.length > 0) {
      var ee = c(N, R), ce = ee >= 0 ? o.containerGroups[ee] : void 0;
      if (ee < 0)
        z ? U = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : U = o.tabbableGroups[0].firstTabbableNode;
      else if (z) {
        var se = A_e(o.tabbableGroups, function(De) {
          var Ce = De.firstTabbableNode;
          return N === Ce;
        });
        if (se < 0 && (ce.container === N || jS(N, s.tabbableOptions) && !R2(N, s.tabbableOptions) && !ce.nextTabbableNode(N, !1)) && (se = ee), se >= 0) {
          var te = se === 0 ? o.tabbableGroups.length - 1 : se - 1, ue = o.tabbableGroups[te];
          U = k0(N) >= 0 ? ue.lastTabbableNode : ue.lastDomTabbableNode;
        } else b3(R) || (U = ce.nextTabbableNode(N, !1));
      } else {
        var G = A_e(o.tabbableGroups, function(De) {
          var Ce = De.lastTabbableNode;
          return N === Ce;
        });
        if (G < 0 && (ce.container === N || jS(N, s.tabbableOptions) && !R2(N, s.tabbableOptions) && !ce.nextTabbableNode(N)) && (G = ee), G >= 0) {
          var j = G === o.tabbableGroups.length - 1 ? 0 : G + 1, pe = o.tabbableGroups[j];
          U = k0(N) >= 0 ? pe.firstTabbableNode : pe.firstDomTabbableNode;
        } else b3(R) || (U = ce.nextTabbableNode(N));
      }
    } else
      U = d("fallbackFocus");
    return U;
  }, A = function(V) {
    var N = $5(V);
    if (!(c(N, V) >= 0)) {
      if (lA(s.clickOutsideDeactivates, V)) {
        a.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: s.returnFocusOnDeactivate
        });
        return;
      }
      lA(s.allowOutsideClick, V) || V.preventDefault();
    }
  }, w = function(V) {
    var N = $5(V), R = c(N, V) >= 0;
    if (R || N instanceof Document)
      R && (o.mostRecentlyFocusedNode = N);
    else {
      V.stopImmediatePropagation();
      var H, z = !0;
      if (o.mostRecentlyFocusedNode)
        if (k0(o.mostRecentlyFocusedNode) > 0) {
          var U = c(o.mostRecentlyFocusedNode), ee = o.containerGroups[U].tabbableNodes;
          if (ee.length > 0) {
            var ce = ee.findIndex(function(se) {
              return se === o.mostRecentlyFocusedNode;
            });
            ce >= 0 && (s.isKeyForward(o.recentNavEvent) ? ce + 1 < ee.length && (H = ee[ce + 1], z = !1) : ce - 1 >= 0 && (H = ee[ce - 1], z = !1));
          }
        } else
          o.containerGroups.some(function(se) {
            return se.tabbableNodes.some(function(te) {
              return k0(te) > 0;
            });
          }) || (z = !1);
      else
        z = !1;
      z && (H = m({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(o.recentNavEvent)
      })), p(H || o.mostRecentlyFocusedNode || u());
    }
    o.recentNavEvent = void 0;
  }, v = function(V) {
    var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = V;
    var R = m({
      event: V,
      isBackward: N
    });
    R && (b3(V) && V.preventDefault(), p(R));
  }, y = function(V) {
    if (tUt(V) && lA(s.escapeDeactivates, V) !== !1) {
      V.preventDefault(), a.deactivate();
      return;
    }
    (s.isKeyForward(V) || s.isKeyBackward(V)) && v(V, s.isKeyBackward(V));
  }, _ = function(V) {
    var N = $5(V);
    c(N, V) >= 0 || lA(s.clickOutsideDeactivates, V) || lA(s.allowOutsideClick, V) || (V.preventDefault(), V.stopImmediatePropagation());
  }, S = function() {
    if (o.active)
      return g_e.activateTrap(i, a), o.delayInitialFocusTimer = s.delayInitialFocus ? m_e(function() {
        p(u());
      }) : p(u()), n.addEventListener("focusin", w, !0), n.addEventListener("mousedown", A, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", A, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", _, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", y, {
        capture: !0,
        passive: !1
      }), a;
  }, D = function() {
    if (o.active)
      return n.removeEventListener("focusin", w, !0), n.removeEventListener("mousedown", A, !0), n.removeEventListener("touchstart", A, !0), n.removeEventListener("click", _, !0), n.removeEventListener("keydown", y, !0), a;
  }, M = function(V) {
    var N = V.some(function(R) {
      var H = Array.from(R.removedNodes);
      return H.some(function(z) {
        return z === o.mostRecentlyFocusedNode;
      });
    });
    N && p(u());
  }, L = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(M) : void 0, T = function() {
    L && (L.disconnect(), o.active && !o.paused && o.containers.map(function(V) {
      L.observe(V, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return a = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(V) {
      if (o.active)
        return this;
      var N = l(V, "onActivate"), R = l(V, "onPostActivate"), H = l(V, "checkCanFocusTrap");
      H || f(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = n.activeElement, N?.();
      var z = function() {
        H && f(), S(), T(), R?.();
      };
      return H ? (H(o.containers.concat()).then(z, z), this) : (z(), this);
    },
    deactivate: function(V) {
      if (!o.active)
        return this;
      var N = p_e({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, V);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, D(), o.active = !1, o.paused = !1, T(), g_e.deactivateTrap(i, a);
      var R = l(N, "onDeactivate"), H = l(N, "onPostDeactivate"), z = l(N, "checkCanReturnFocus"), U = l(N, "returnFocus", "returnFocusOnDeactivate");
      R?.();
      var ee = function() {
        m_e(function() {
          U && p(g(o.nodeFocusedBeforeActivation)), H?.();
        });
      };
      return U && z ? (z(g(o.nodeFocusedBeforeActivation)).then(ee, ee), this) : (ee(), this);
    },
    pause: function(V) {
      if (o.paused || !o.active)
        return this;
      var N = l(V, "onPause"), R = l(V, "onPostPause");
      return o.paused = !0, N?.(), D(), T(), R?.(), this;
    },
    unpause: function(V) {
      if (!o.paused || !o.active)
        return this;
      var N = l(V, "onUnpause"), R = l(V, "onPostUnpause");
      return o.paused = !1, N?.(), f(), S(), T(), R?.(), this;
    },
    updateContainerElements: function(V) {
      var N = [].concat(V).filter(Boolean);
      return o.containers = N.map(function(R) {
        return typeof R == "string" ? n.querySelector(R) : R;
      }), o.active && f(), T(), this;
    }
  }, a.updateContainerElements(e), a;
}, BBe = function(e) {
  return Ht("svg", {
    ...e,
    children: [Ht("path", {
      fill: "#fff",
      style: {
        mixBlendMode: "multiply"
      },
      d: "M0 0h16v16H0z"
    }), Ht("path", {
      fill: "#fff",
      style: {
        mixBlendMode: "multiply"
      },
      d: "M0 0h16v16H0z"
    }), Ht("path", {
      d: "M7 3H5v2h2V3zm4 0H9v2h2V3zM7 7H5v2h2V7zm4 0H9v2h2V7zm-4 4H5v2h2v-2zm4 0H9v2h2v-2z",
      fill: "#161616"
    })]
  });
};
BBe.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var PBe = function(e) {
  return Ht("svg", {
    ...e,
    children: Ht("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.637 12.637v-4.72h1.362v4.721c0 .36-.137.676-.411.95-.275.275-.591.412-.95.412H3.362c-.38 0-.703-.132-.967-.396A1.315 1.315 0 0 1 2 12.638V3.362c0-.38.132-.703.396-.967S2.982 2 3.363 2h4.553v1.363H3.363v9.274h9.274ZM14 2H9.28l-.001 1.362h2.408L5.065 9.984l.95.95 6.622-6.622v2.409H14V2Z",
      fill: "currentcolor"
    })
  });
};
PBe.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var FBe = function(e) {
  return Ht("svg", {
    ...e,
    children: [Ht("path", {
      fill: "currentColor",
      d: "M28 4H10a2.006 2.006 0 0 0-2 2v14a2.006 2.006 0 0 0 2 2h18a2.006 2.006 0 0 0 2-2V6a2.006 2.006 0 0 0-2-2Zm0 16H10V6h18Z"
    }), Ht("path", {
      fill: "currentColor",
      d: "M18 26H4V16h2v-2H4a2.006 2.006 0 0 0-2 2v10a2.006 2.006 0 0 0 2 2h14a2.006 2.006 0 0 0 2-2v-2h-2Z"
    })]
  });
};
FBe.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 32 32"
};
mm({
  description: {},
  getDescriptionForId: () => {
  }
});
mm({
  errors: {}
});
const oUt = mm({
  eventBus: null
});
mm({
  layout: {},
  setLayout: () => {
  },
  getLayoutForKey: () => {
  },
  setLayoutForKey: () => {
  }
});
const aUt = mm({
  tooltip: {},
  getTooltipForId: () => {
  }
});
function lUt(r, e) {
  const {
    getTooltipForId: t
  } = wRe(aUt);
  return t(r, e);
}
function cUt(r) {
  const {
    forId: e,
    element: t
  } = r, n = lUt(e, t), i = r.value || n;
  return i ? Ht(hUt, {
    ...r,
    value: i,
    forId: fUt(e)
  }) : r.children;
}
function hUt(r) {
  const {
    forId: e,
    value: t,
    parent: n,
    direction: i = "right",
    position: s
  } = r, [o, a] = wh(!1), [l, c] = wh(!1);
  let d = null;
  const u = Fs(null), f = Fs(null), p = async (v) => {
    const y = () => a(!0);
    !o && !d && (v instanceof MouseEvent ? d = setTimeout(y, 200) : (y(), c(!0)));
  }, g = () => {
    a(!1), c(!1);
  }, m = (v) => {
    v.code === "Escape" && g();
  }, A = ({
    x: v,
    y
  }) => {
    const _ = f.current, S = u.current;
    return _ && (w_e(v, y, S.getBoundingClientRect()) || w_e(v, y, _.getBoundingClientRect()));
  };
  wa(() => {
    const {
      current: v
    } = u;
    if (!v)
      return;
    const y = (S) => {
      const D = document.activeElement === u.current || document.activeElement.closest(".bio-properties-panel-tooltip");
      o && !A({
        x: S.x,
        y: S.y
      }) && !(D && l) && g();
    }, _ = (S) => {
      const {
        relatedTarget: D
      } = S, M = (L) => !!L.closest(".bio-properties-panel-tooltip");
      o && !uUt(u.current) && D && !M(D) && g();
    };
    return document.addEventListener("wheel", y), document.addEventListener("focusout", _), document.addEventListener("mousemove", y), () => {
      document.removeEventListener("wheel", y), document.removeEventListener("mousemove", y), document.removeEventListener("focusout", _);
    };
  }, [u.current, o, l]);
  const w = () => Ht("div", {
    class: `bio-properties-panel-tooltip ${i}`,
    role: "tooltip",
    id: "bio-properties-panel-tooltip",
    "aria-labelledby": e,
    style: s || dUt(u.current),
    ref: f,
    onClick: (v) => v.stopPropagation(),
    children: [Ht("div", {
      class: "bio-properties-panel-tooltip-content",
      children: t
    }), Ht("div", {
      class: "bio-properties-panel-tooltip-arrow"
    })]
  });
  return Ht("div", {
    class: "bio-properties-panel-tooltip-wrapper",
    tabIndex: "0",
    ref: u,
    onMouseEnter: p,
    onMouseLeave: () => {
      clearTimeout(d), d = null;
    },
    onFocus: p,
    onKeyDown: m,
    children: [r.children, o ? n ? xRe(w(), n.current) : w() : null]
  });
}
function w_e(r, e, t) {
  const {
    top: n,
    right: i,
    bottom: s,
    left: o
  } = t;
  return r >= o && r <= i && e >= n && e <= s;
}
function dUt(r) {
  const e = r.getBoundingClientRect(), t = `calc(100% - ${e.x}px)`, n = `${e.top - 10}px`;
  return `right: ${t}; top: ${n};`;
}
function uUt(r) {
  return r.matches(":hover");
}
function fUt(r) {
  return `bio-properties-panel-${r}`;
}
function pUt(r, e, t) {
  const n = wRe(oUt);
  t || ({
    eventBus: t
  } = n);
  const i = Fs(!1);
  t && !i.current && t.on(r, e), wa(() => (t && i.current && t.on(r, e), i.current = !0, () => {
    t && t.off(r, e);
  }), [e, r, t]);
}
function zBe(r) {
  const e = Fs(r);
  return e.current = r, bVt((...t) => e.current(...t), []);
}
const v_e = () => {
}, gUt = function(r, e) {
  const [t, n] = wh(void 0);
  e.current = Am(() => ({
    focus: (i) => {
      r ? r.focus(i) : (typeof i > "u" && (i = 1 / 0), n(i));
    }
  }), [r]), wa(() => {
    typeof t < "u" && r && (r.focus(t), n(!1));
  }, [r, t]);
};
z1((r, e) => {
  const {
    onInput: t,
    disabled: n,
    tooltipContainer: i,
    enableGutters: s,
    value: o,
    onLint: a = v_e,
    onPopupOpen: l = v_e,
    popupOpen: c,
    contentAttributes: d = {},
    hostLanguage: u = null,
    singleLine: f = !1
  } = r, p = Fs(), [g, m] = wh(), [A, w] = wh(o || "");
  gUt(g, e);
  const v = zBe((_) => {
    t(_), w(_);
  });
  wa(() => {
    let _;
    return _ = new mC({
      container: p.current,
      onChange: v,
      value: A,
      onLint: a,
      contentAttributes: d,
      tooltipContainer: i,
      enableGutters: s,
      hostLanguage: u,
      singleLine: f
    }), m(_), () => {
      a([]), p.current.innerHTML = "", m(null);
    };
  }, []), wa(() => {
    g && o !== A && (g.setValue(o), w(o));
  }, [o]);
  const y = () => {
    e.current.focus();
  };
  return Ht("div", {
    class: Wd("bio-properties-panel-feelers-editor-container", c ? "popupOpen" : null),
    children: [Ht("div", {
      class: "bio-properties-panel-feelers-editor__open-popup-placeholder",
      children: "Opened in editor"
    }), Ht("div", {
      name: r.name,
      class: Wd("bio-properties-panel-feelers-editor bio-properties-panel-input", A ? "edited" : null, n ? "disabled" : null),
      ref: p,
      onClick: y
    }), Ht("button", {
      type: "button",
      title: "Open pop-up editor",
      class: "bio-properties-panel-open-feel-popup",
      onClick: () => l("feelers"),
      children: Ht(PBe, {})
    })]
  });
});
const ZS = () => {
}, mUt = function(r, e) {
  const [t, n] = wh(void 0);
  e.current = Am(() => ({
    focus: (i) => {
      r ? r.focus(i) : (typeof i > "u" && (i = 1 / 0), n(i));
    }
  }), [r]), wa(() => {
    typeof t < "u" && r && (r.focus(t), n(!1));
  }, [r, t]);
};
z1((r, e) => {
  const {
    contentAttributes: t,
    enableGutters: n,
    value: i,
    onInput: s,
    onFeelToggle: o = ZS,
    onLint: a = ZS,
    onPopupOpen: l = ZS,
    popupOpen: c,
    disabled: d,
    tooltipContainer: u,
    variables: f
  } = r, p = Fs(), [g, m] = wh(), [A, w] = wh(i || "");
  mUt(g, e);
  const v = zBe((_) => {
    s(_), w(_);
  });
  wa(() => {
    let _;
    const S = (D) => {
      if (D.key !== "Backspace" || !_)
        return;
      const M = _.getSelection(), L = M.ranges[M.mainIndex];
      L.from === 0 && L.to === 0 && o();
    };
    return _ = new rv({
      container: p.current,
      onChange: v,
      onKeyDown: S,
      onLint: a,
      tooltipContainer: u,
      value: A,
      variables: f,
      extensions: [...n ? [aHe()] : [], st.lineWrapping],
      contentAttributes: t
    }), m(_), () => {
      a([]), p.current.innerHTML = "", m(null);
    };
  }, []), wa(() => {
    g && i !== A && (g.setValue(i), w(i));
  }, [i]), wa(() => {
    g && g.setVariables(f);
  }, [f]);
  const y = () => {
    e.current.focus();
  };
  return Ht("div", {
    class: Wd("bio-properties-panel-feel-editor-container", d ? "disabled" : null, c ? "popupOpen" : null),
    children: [Ht("div", {
      class: "bio-properties-panel-feel-editor__open-popup-placeholder",
      children: "Opened in editor"
    }), Ht("div", {
      name: r.name,
      class: Wd("bio-properties-panel-input", A ? "edited" : null),
      ref: p,
      onClick: y
    }), Ht("button", {
      type: "button",
      title: "Open pop-up editor",
      class: "bio-properties-panel-open-feel-popup",
      onClick: () => l(),
      children: Ht(FBe, {})
    })]
  });
});
mm({
  open: () => {
  },
  close: () => {
  },
  source: null
});
function AUt(r, e) {
  let t, n, i;
  function s(l) {
    t = this, n = l.clientX, i = l.clientY, l.dataTransfer && l.dataTransfer.setDragImage(e || wUt(), 0, 0), document.addEventListener("dragover", o, !0), document.addEventListener("dragenter", e6, !0), document.addEventListener("dragend", a), document.addEventListener("drop", e6);
  }
  function o(l) {
    const c = {
      x: l.clientX - n,
      y: l.clientY - i
    };
    return r.call(t, l, c);
  }
  function a() {
    document.removeEventListener("dragover", o, !0), document.removeEventListener("dragenter", e6, !0), document.removeEventListener("dragend", a), document.removeEventListener("drop", e6);
  }
  return s;
}
function e6(r) {
  r.preventDefault(), r.stopPropagation();
}
function wUt() {
  return aRe('<canvas width="0" height="0" />');
}
const b_e = () => {
};
function vUt(r, e) {
  const {
    container: t,
    className: n,
    delayInitialFocus: i,
    position: s,
    width: o,
    height: a,
    onClose: l,
    onPostActivate: c = b_e,
    onPostDeactivate: d = b_e,
    returnFocus: u = !0,
    closeOnEscape: f = !0,
    title: p
  } = r, g = Fs(null), m = Fs(null), A = e || m, w = Am(() => _Ut(t), [t]), v = (S) => {
    S.stopPropagation(), f && S.key === "Escape" && l();
  }, y = () => {
    g.current && g.current.activate();
  };
  let _ = {};
  return s && (_ = {
    ..._,
    top: s.top + "px",
    left: s.left + "px"
  }), o && (_.width = o + "px"), a && (_.height = a + "px"), wa(() => (A.current && A.current.addEventListener("focusin", y), () => {
    A.current.removeEventListener("focusin", y);
  }), [A]), wa(() => (A.current && (g.current = sUt(A.current, {
    clickOutsideDeactivates: !0,
    delayInitialFocus: i,
    fallbackFocus: A.current,
    onPostActivate: c,
    onPostDeactivate: d,
    returnFocusOnDeactivate: u
  }), g.current.activate()), () => g.current && g.current.deactivate()), [A]), pUt("propertiesPanel.detach", l), xRe(Ht("div", {
    "aria-label": p,
    tabIndex: -1,
    ref: A,
    onKeyDown: v,
    role: "dialog",
    class: Wd("bio-properties-panel-popup", n),
    style: _,
    children: r.children
  }), w || document.body);
}
const vH = z1(vUt);
vH.Title = bUt;
vH.Body = yUt;
vH.Footer = CUt;
function bUt(r) {
  const {
    children: e,
    className: t,
    draggable: n,
    emit: i = () => {
    },
    title: s,
    ...o
  } = r, a = Fs({
    startPosition: null,
    newPosition: null
  }), l = Fs(), c = Fs(), d = (p, g) => {
    EUt(p);
    const {
      x: m,
      y: A
    } = g, w = {
      x: a.current.startPosition.x + m,
      y: a.current.startPosition.y + A
    }, v = y_e(c.current);
    v.style.top = w.y + "px", v.style.left = w.x + "px", i("dragover", {
      newPosition: w,
      delta: g
    });
  }, u = (p) => {
    AUt(d, l.current)(p), p.stopPropagation();
    const A = y_e(c.current).getBoundingClientRect();
    a.current.startPosition = {
      x: A.left,
      y: A.top
    }, i("dragstart");
  }, f = () => {
    a.current.newPosition = null, i("dragend");
  };
  return Ht("div", {
    class: Wd("bio-properties-panel-popup__header", n && "draggable", t),
    ref: c,
    draggable: n,
    onDragStart: u,
    onDragEnd: f,
    ...o,
    children: [n && Ht(kf, {
      children: [Ht("div", {
        ref: l,
        class: "bio-properties-panel-popup__drag-preview"
      }), Ht("div", {
        class: "bio-properties-panel-popup__drag-handle",
        children: Ht(BBe, {})
      })]
    }), Ht("div", {
      class: "bio-properties-panel-popup__title",
      children: s
    }), e]
  });
}
function yUt(r) {
  const {
    children: e,
    className: t,
    ...n
  } = r;
  return Ht("div", {
    class: Wd("bio-properties-panel-popup__body", t),
    ...n,
    children: e
  });
}
function CUt(r) {
  const {
    children: e,
    className: t,
    ...n
  } = r;
  return Ht("div", {
    class: Wd("bio-properties-panel-popup__footer", t),
    ...n,
    children: r.children
  });
}
function y_e(r) {
  return r.closest(".bio-properties-panel-popup");
}
function EUt(r) {
  r.preventDefault(), r.stopPropagation();
}
function _Ut(r) {
  return typeof r == "string" ? fVt(r) : r;
}
function xUt(r) {
  const {
    id: e,
    label: t,
    onInput: n,
    value: i,
    switcherLabel: s,
    inline: o,
    onFocus: a,
    onBlur: l,
    inputRef: c,
    tooltip: d
  } = r, [u, f] = wh(i), p = async () => {
    n(!i);
  }, g = (m) => {
    p(), f(m.target.value);
  };
  return wa(() => {
    i !== u && f(i);
  }, [i]), Ht("div", {
    class: Wd("bio-properties-panel-toggle-switch", {
      inline: o
    }),
    children: [Ht("label", {
      class: "bio-properties-panel-label",
      for: C_e(e),
      children: Ht(cUt, {
        value: d,
        forId: e,
        element: r.element,
        children: t
      })
    }), Ht("div", {
      class: "bio-properties-panel-field-wrapper",
      children: [Ht("label", {
        class: "bio-properties-panel-toggle-switch__switcher",
        children: [Ht("input", {
          ref: c,
          id: C_e(e),
          class: "bio-properties-panel-input",
          type: "checkbox",
          onFocus: a,
          onBlur: l,
          name: e,
          onInput: g,
          checked: !!u
        }), Ht("span", {
          class: "bio-properties-panel-toggle-switch__slider"
        })]
      }), s && Ht("p", {
        class: "bio-properties-panel-toggle-switch__label",
        children: s
      })]
    })]
  });
}
function C_e(r) {
  return `bio-properties-panel-${r}`;
}
function SUt(r) {
  const {
    debounce: e,
    disabled: t,
    displayLabel: n = !0,
    id: i,
    inputRef: s,
    label: o,
    max: a,
    min: l,
    onInput: c,
    step: d,
    value: u = "",
    onFocus: f,
    onBlur: p
  } = r, [g, m] = wh(u), A = Am(() => e((v) => {
    v.validity.valid && c(v.value ? parseFloat(v.value) : void 0);
  }), [c, e]), w = (v) => {
    A(v.target), m(v.target.value);
  };
  return wa(() => {
    u !== g && m(u);
  }, [u]), Ht("div", {
    class: "bio-properties-panel-numberfield",
    children: [n && Ht("label", {
      for: E_e(i),
      class: "bio-properties-panel-label",
      children: o
    }), Ht("input", {
      id: E_e(i),
      ref: s,
      type: "number",
      name: i,
      spellCheck: "false",
      autoComplete: "off",
      disabled: t,
      class: "bio-properties-panel-input",
      max: a,
      min: l,
      onInput: w,
      onFocus: f,
      onBlur: p,
      step: d,
      value: g
    })]
  });
}
function E_e(r) {
  return `bio-properties-panel-${r}`;
}
z1((r, e) => {
  const {
    id: t,
    disabled: n,
    onInput: i,
    value: s,
    onFocus: o,
    onBlur: a
  } = r, l = Fs();
  return e.current = {
    focus: (c) => {
      const d = l.current;
      d && (d.focus(), typeof c == "number" && (c > s.length && (c = s.length), d.setSelectionRange(c, c)));
    }
  }, Ht("input", {
    id: bH(t),
    type: "text",
    ref: l,
    name: t,
    spellCheck: "false",
    autoComplete: "off",
    disabled: n,
    class: "bio-properties-panel-input",
    onInput: (c) => i(c.target.value),
    onFocus: o,
    onBlur: a,
    value: s || ""
  });
});
z1((r, e) => {
  const {
    id: t,
    debounce: n,
    disabled: i,
    onInput: s,
    value: o,
    min: a,
    max: l,
    step: c,
    onFocus: d,
    onBlur: u
  } = r, f = Fs();
  return e.current = {
    focus: (p) => {
      const g = f.current;
      g && (g.focus(), typeof p == "number" && p !== 1 / 0 && (p > o.length && (p = o.length), g.setSelectionRange(p, p)));
    }
  }, Ht(SUt, {
    id: t,
    debounce: n,
    disabled: i,
    displayLabel: !1,
    inputRef: f,
    max: l,
    min: a,
    onInput: s,
    step: c,
    value: o,
    onFocus: d,
    onBlur: u
  });
});
z1((r, e) => {
  const {
    id: t,
    disabled: n,
    onInput: i,
    value: s,
    onFocus: o,
    onBlur: a
  } = r, l = Fs();
  return e.current = {
    focus: () => {
      const c = l.current;
      c && (c.focus(), c.setSelectionRange(0, 0));
    }
  }, Ht("textarea", {
    id: bH(t),
    type: "text",
    ref: l,
    name: t,
    spellCheck: "false",
    autoComplete: "off",
    disabled: n,
    class: "bio-properties-panel-input",
    onInput: (c) => i(c.target.value),
    onFocus: o,
    onBlur: a,
    value: s || "",
    "data-gramm": "false"
  });
});
z1((r, e) => {
  const {
    id: t,
    onInput: n,
    value: i,
    onFocus: s,
    onBlur: o,
    switcherLabel: a
  } = r, l = Fs();
  return e.current = {
    focus: () => {
      const c = l.current;
      c && c.focus();
    }
  }, Ht(xUt, {
    id: t,
    value: i,
    inputRef: l,
    onInput: n,
    onFocus: s,
    onBlur: o,
    switcherLabel: a
  });
});
z1((r, e) => {
  const {
    id: t,
    disabled: n,
    onInput: i,
    value: s,
    onFocus: o,
    onBlur: a
  } = r, l = Fs(), c = ({
    target: d
  }) => {
    i(d.checked);
  };
  return e.current = {
    focus: () => {
      const d = l.current;
      d && d.focus();
    }
  }, Ht("input", {
    ref: l,
    id: bH(t),
    name: t,
    onFocus: o,
    onBlur: a,
    type: "checkbox",
    class: "bio-properties-panel-input",
    onChange: c,
    checked: s,
    disabled: n
  });
});
function bH(r) {
  return `bio-properties-panel-${r}`;
}
var WBe = function(r, e, t, n) {
  var i;
  e[0] = 0;
  for (var s = 1; s < e.length; s++) {
    var o = e[s++], a = e[s] ? (e[0] |= o ? 1 : 2, t[e[s++]]) : e[++s];
    o === 3 ? n[0] = a : o === 4 ? n[1] = Object.assign(n[1] || {}, a) : o === 5 ? (n[1] = n[1] || {})[e[++s]] = a : o === 6 ? n[1][e[++s]] += a + "" : o ? (i = r.apply(a, WBe(r, a, t, ["", null])), n.push(i), a[0] ? e[0] |= 2 : (e[s - 2] = 0, e[s] = i)) : n.push(a);
  }
  return n;
}, __e = /* @__PURE__ */ new Map();
function MUt(r) {
  var e = __e.get(this);
  return e || (e = /* @__PURE__ */ new Map(), __e.set(this, e)), (e = WBe(this, e.get(r) || (e.set(r, e = function(t) {
    for (var n, i, s = 1, o = "", a = "", l = [0], c = function(f) {
      s === 1 && (f || (o = o.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? l.push(0, f, o) : s === 3 && (f || o) ? (l.push(3, f, o), s = 2) : s === 2 && o === "..." && f ? l.push(4, f, 0) : s === 2 && o && !f ? l.push(5, 0, !0, o) : s >= 5 && ((o || !f && s === 5) && (l.push(s, 0, o, i), s = 6), f && (l.push(s, f, 0, i), s = 6)), o = "";
    }, d = 0; d < t.length; d++) {
      d && (s === 1 && c(), c(d));
      for (var u = 0; u < t[d].length; u++) n = t[d][u], s === 1 ? n === "<" ? (c(), l = [l], s = 3) : o += n : s === 4 ? o === "--" && n === ">" ? (s = 1, o = "") : o = n + o[0] : a ? n === a ? a = "" : o += n : n === '"' || n === "'" ? a = n : n === ">" ? (c(), s = 1) : s && (n === "=" ? (s = 5, i = o, o = "") : n === "/" && (s < 5 || t[d][u + 1] === ">") ? (c(), s === 3 && (l = l[0]), s = l, (l = l[0]).push(2, 0, s), s = 0) : n === " " || n === "	" || n === `
` || n === "\r" ? (c(), s = 2) : o += n), s === 3 && o === "!--" && (s = 4, l = l[0]);
    }
    return c(), l;
  }(r)), e), arguments, [])).length > 1 ? e : e[0];
}
MUt.bind(Mg);
function y3(r, e) {
  var t = W4(r);
  return t && typeof t.$instanceOf == "function" && t.$instanceOf(e);
}
function DUt(r, e) {
  return b7(e, function(t) {
    return y3(r, t);
  });
}
function W4(r) {
  return r && r.businessObject || r;
}
function LUt(r, e) {
  e && (r.super_ = e, r.prototype = Object.create(e.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }));
}
var kUt = 1e3;
function Na(r) {
  this._eventBus = r;
}
Na.$inject = ["eventBus"];
function NUt(r, e) {
  return function(t) {
    return r.call(e || null, t.context, t.command, t);
  };
}
Na.prototype.on = function(r, e, t, n, i, s) {
  if ((ol(e) || ec(e)) && (s = i, i = n, n = t, t = e, e = null), ol(t) && (s = i, i = n, n = t, t = kUt), Od(i) && (s = i, i = !1), !ol(n))
    throw new Error("handlerFn must be a function");
  ul(r) || (r = [r]);
  var o = this._eventBus;
  vn(r, function(a) {
    var l = ["commandStack", a, e].filter(function(c) {
      return c;
    }).join(".");
    o.on(l, t, i ? NUt(n, s) : n, s);
  });
};
Na.prototype.canExecute = tu("canExecute");
Na.prototype.preExecute = tu("preExecute");
Na.prototype.preExecuted = tu("preExecuted");
Na.prototype.execute = tu("execute");
Na.prototype.executed = tu("executed");
Na.prototype.postExecute = tu("postExecute");
Na.prototype.postExecuted = tu("postExecuted");
Na.prototype.revert = tu("revert");
Na.prototype.reverted = tu("reverted");
function tu(r) {
  return function(t, n, i, s, o) {
    (ol(t) || ec(t)) && (o = s, s = i, i = n, n = t, t = null), this.on(t, r, n, i, s, o);
  };
}
function sv(r) {
  Na.call(this, r), this.init();
}
sv.$inject = ["eventBus"];
LUt(sv, Na);
sv.prototype.addRule = function(r, e, t) {
  var n = this;
  typeof r == "string" && (r = [r]), r.forEach(function(i) {
    n.canExecute(i, e, function(s, o, a) {
      return t(s);
    }, !0);
  });
};
sv.prototype.init = function() {
};
class TUt extends sv {
  constructor(e, t, n) {
    super(n), t !== !1 && this.addRule("resourceLinking.linkResource", ({ element: i }) => IUt(i) ? !1 : !!(DUt(i, ["bpmn:BusinessRuleTask", "bpmn:CallActivity", "bpmn:UserTask"]) || OUt(i) && RUt(t) && VUt(i.parent, e.getRootElement())));
  }
}
TUt.$inject = ["canvas", "config.resourceLinking", "eventBus"];
function IUt(r) {
  return W4(r).get("zeebe:modelerTemplate");
}
function OUt(r) {
  const e = W4(r).get("eventDefinitions");
  return y3(r, "bpmn:StartEvent") && (!e || !e.length);
}
function RUt(r = {}) {
  const { noneStartEvent: e = !0 } = r;
  return e;
}
function VUt(r, e) {
  if (y3(e, "bpmn:Process") && r === e)
    return W4(r).get("isExecutable");
  if (y3(e, "bpmn:Collaboration")) {
    const t = e.children.filter((n) => {
      if (!y3(n, "bpmn:Participant"))
        return !1;
      const i = W4(n).get("processRef");
      return i && i.get("isExecutable");
    });
    return t.length === 1 && t[0] === r;
  }
  return !1;
}
const vC = Object.prototype.toString, HUt = Object.prototype.hasOwnProperty;
function BUt(r) {
  return r === void 0;
}
function PUt(r) {
  return r == null;
}
function yH(r) {
  return vC.call(r) === "[object Array]";
}
function jBe(r) {
  return vC.call(r) === "[object Object]";
}
function ZBe(r) {
  return vC.call(r) === "[object Number]";
}
function C3(r) {
  const e = vC.call(r);
  return e === "[object Function]" || e === "[object AsyncFunction]" || e === "[object GeneratorFunction]" || e === "[object AsyncGeneratorFunction]" || e === "[object Proxy]";
}
function UBe(r, e) {
  return !PUt(r) && HUt.call(r, e);
}
function qBe(r, e) {
  const t = zUt(e);
  let n;
  return GBe(r, function(i, s) {
    if (t(i, s))
      return n = i, !1;
  }), n;
}
function GBe(r, e) {
  let t, n;
  if (BUt(r))
    return;
  const i = yH(r) ? jUt : WUt;
  for (let s in r)
    if (UBe(r, s) && (t = r[s], n = e(t, i(s)), n === !1))
      return t;
}
function FUt(r, e) {
  return !!qBe(r, e);
}
function zUt(r) {
  return C3(r) ? r : (e) => e === r;
}
function WUt(r) {
  return r;
}
function jUt(r) {
  return Number(r);
}
const ov = {
  id: "events",
  name: "Events"
}, ZUt = {
  id: "tasks",
  name: "Tasks"
}, UUt = {
  id: "data",
  name: "Data"
}, qUt = {
  id: "participants",
  name: "Participants"
}, GUt = {
  id: "subprocess",
  name: "Sub-processes"
}, QUt = {
  id: "gateways",
  name: "Gateways"
};
[
  {
    label: "Start event",
    actionName: "none-start-event",
    className: "bpmn-icon-start-event-none",
    target: {
      type: "bpmn:StartEvent"
    }
  },
  {
    label: "Intermediate throw event",
    actionName: "none-intermediate-throwing",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:IntermediateThrowEvent"
    }
  },
  {
    label: "Boundary event",
    actionName: "none-boundary-event",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:BoundaryEvent"
    }
  },
  {
    label: "End event",
    actionName: "none-end-event",
    className: "bpmn-icon-end-event-none",
    target: {
      type: "bpmn:EndEvent"
    }
  }
].map((r) => ({ ...r, group: ov }));
[
  {
    label: "Message start event",
    actionName: "message-start",
    className: "bpmn-icon-start-event-message",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Timer start event",
    actionName: "timer-start",
    className: "bpmn-icon-start-event-timer",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition"
    }
  },
  {
    label: "Conditional start event",
    actionName: "conditional-start",
    className: "bpmn-icon-start-event-condition",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition"
    }
  },
  {
    label: "Signal start event",
    actionName: "signal-start",
    className: "bpmn-icon-start-event-signal",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  }
].map((r) => ({ ...r, group: ov }));
[
  {
    label: "Message intermediate catch event",
    actionName: "message-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-message",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Message intermediate throw event",
    actionName: "message-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-message",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Timer intermediate catch event",
    actionName: "timer-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-timer",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition"
    }
  },
  {
    label: "Escalation intermediate throw event",
    actionName: "escalation-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-escalation",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition"
    }
  },
  {
    label: "Conditional intermediate catch event",
    actionName: "conditional-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-condition",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition"
    }
  },
  {
    label: "Link intermediate catch event",
    actionName: "link-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-link",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:LinkEventDefinition",
      eventDefinitionAttrs: {
        name: ""
      }
    }
  },
  {
    label: "Link intermediate throw event",
    actionName: "link-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-link",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:LinkEventDefinition",
      eventDefinitionAttrs: {
        name: ""
      }
    }
  },
  {
    label: "Compensation intermediate throw event",
    actionName: "compensation-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-compensation",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition"
    }
  },
  {
    label: "Signal intermediate catch event",
    actionName: "signal-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-signal",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  },
  {
    label: "Signal intermediate throw event",
    actionName: "signal-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-signal",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  }
].map((r) => ({ ...r, group: ov }));
[
  {
    label: "Message boundary event",
    actionName: "message-boundary",
    className: "bpmn-icon-intermediate-event-catch-message",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Timer boundary event",
    actionName: "timer-boundary",
    className: "bpmn-icon-intermediate-event-catch-timer",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition"
    }
  },
  {
    label: "Escalation boundary event",
    actionName: "escalation-boundary",
    className: "bpmn-icon-intermediate-event-catch-escalation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition"
    }
  },
  {
    label: "Conditional boundary event",
    actionName: "conditional-boundary",
    className: "bpmn-icon-intermediate-event-catch-condition",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition"
    }
  },
  {
    label: "Error boundary event",
    actionName: "error-boundary",
    className: "bpmn-icon-intermediate-event-catch-error",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ErrorEventDefinition"
    }
  },
  {
    label: "Cancel boundary event",
    actionName: "cancel-boundary",
    className: "bpmn-icon-intermediate-event-catch-cancel",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:CancelEventDefinition"
    }
  },
  {
    label: "Signal boundary event",
    actionName: "signal-boundary",
    className: "bpmn-icon-intermediate-event-catch-signal",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  },
  {
    label: "Compensation boundary event",
    actionName: "compensation-boundary",
    className: "bpmn-icon-intermediate-event-catch-compensation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition"
    }
  },
  {
    label: "Message boundary event (non-interrupting)",
    actionName: "non-interrupting-message-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-message",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Timer boundary event (non-interrupting)",
    actionName: "non-interrupting-timer-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-timer",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Escalation boundary event (non-interrupting)",
    actionName: "non-interrupting-escalation-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-escalation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Conditional boundary event (non-interrupting)",
    actionName: "non-interrupting-conditional-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-condition",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Signal boundary event (non-interrupting)",
    actionName: "non-interrupting-signal-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-signal",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition",
      cancelActivity: !1
    }
  }
].map((r) => ({ ...r, group: ov }));
[
  {
    label: "Message end event",
    actionName: "message-end",
    className: "bpmn-icon-end-event-message",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Escalation end event",
    actionName: "escalation-end",
    className: "bpmn-icon-end-event-escalation",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition"
    }
  },
  {
    label: "Error end event",
    actionName: "error-end",
    className: "bpmn-icon-end-event-error",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:ErrorEventDefinition"
    }
  },
  {
    label: "Cancel end event",
    actionName: "cancel-end",
    className: "bpmn-icon-end-event-cancel",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:CancelEventDefinition"
    }
  },
  {
    label: "Compensation end event",
    actionName: "compensation-end",
    className: "bpmn-icon-end-event-compensation",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition"
    }
  },
  {
    label: "Signal end event",
    actionName: "signal-end",
    className: "bpmn-icon-end-event-signal",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  },
  {
    label: "Terminate end event",
    actionName: "terminate-end",
    className: "bpmn-icon-end-event-terminate",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:TerminateEventDefinition"
    }
  }
].map((r) => ({ ...r, group: ov }));
[
  {
    label: "Exclusive gateway",
    actionName: "exclusive-gateway",
    className: "bpmn-icon-gateway-xor",
    target: {
      type: "bpmn:ExclusiveGateway"
    }
  },
  {
    label: "Parallel gateway",
    actionName: "parallel-gateway",
    className: "bpmn-icon-gateway-parallel",
    target: {
      type: "bpmn:ParallelGateway"
    }
  },
  {
    label: "Inclusive gateway",
    search: "or",
    actionName: "inclusive-gateway",
    className: "bpmn-icon-gateway-or",
    target: {
      type: "bpmn:InclusiveGateway"
    },
    rank: -1
  },
  {
    label: "Complex gateway",
    actionName: "complex-gateway",
    className: "bpmn-icon-gateway-complex",
    target: {
      type: "bpmn:ComplexGateway"
    },
    rank: -1
  },
  {
    label: "Event-based gateway",
    actionName: "event-based-gateway",
    className: "bpmn-icon-gateway-eventbased",
    target: {
      type: "bpmn:EventBasedGateway",
      instantiate: !1,
      eventGatewayType: "Exclusive"
    }
  }
].map((r) => ({ ...r, group: QUt }));
[
  {
    label: "Call activity",
    actionName: "call-activity",
    className: "bpmn-icon-call-activity",
    target: {
      type: "bpmn:CallActivity"
    }
  },
  {
    label: "Transaction",
    actionName: "transaction",
    className: "bpmn-icon-transaction",
    target: {
      type: "bpmn:Transaction",
      isExpanded: !0
    }
  },
  {
    label: "Event sub-process",
    search: "subprocess",
    actionName: "event-subprocess",
    className: "bpmn-icon-event-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      triggeredByEvent: !0,
      isExpanded: !0
    }
  },
  {
    label: "Sub-process (collapsed)",
    search: "subprocess",
    actionName: "collapsed-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !1
    }
  },
  {
    label: "Sub-process (expanded)",
    search: "subprocess",
    actionName: "expanded-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Ad-hoc sub-process (collapsed)",
    search: "adhoc subprocess",
    actionName: "collapsed-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !1
    }
  },
  {
    label: "Ad-hoc sub-process (expanded)",
    search: "adhoc subprocess",
    actionName: "expanded-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !0
    }
  }
].map((r) => ({ ...r, group: GUt }));
[
  {
    label: "Task",
    actionName: "task",
    className: "bpmn-icon-task",
    target: {
      type: "bpmn:Task"
    }
  },
  {
    label: "User task",
    actionName: "user-task",
    className: "bpmn-icon-user",
    target: {
      type: "bpmn:UserTask"
    }
  },
  {
    label: "Service task",
    actionName: "service-task",
    className: "bpmn-icon-service",
    target: {
      type: "bpmn:ServiceTask"
    }
  },
  {
    label: "Send task",
    actionName: "send-task",
    className: "bpmn-icon-send",
    target: {
      type: "bpmn:SendTask"
    },
    rank: -1
  },
  {
    label: "Receive task",
    actionName: "receive-task",
    className: "bpmn-icon-receive",
    target: {
      type: "bpmn:ReceiveTask"
    },
    rank: -1
  },
  {
    label: "Manual task",
    actionName: "manual-task",
    className: "bpmn-icon-manual",
    target: {
      type: "bpmn:ManualTask"
    },
    rank: -1
  },
  {
    label: "Business rule task",
    actionName: "rule-task",
    className: "bpmn-icon-business-rule",
    target: {
      type: "bpmn:BusinessRuleTask"
    }
  },
  {
    label: "Script task",
    actionName: "script-task",
    className: "bpmn-icon-script",
    target: {
      type: "bpmn:ScriptTask"
    }
  }
].map((r) => ({ ...r, group: ZUt }));
[
  {
    label: "Data store reference",
    actionName: "data-store-reference",
    className: "bpmn-icon-data-store",
    target: {
      type: "bpmn:DataStoreReference"
    }
  },
  {
    label: "Data object reference",
    actionName: "data-object-reference",
    className: "bpmn-icon-data-object",
    target: {
      type: "bpmn:DataObjectReference"
    }
  }
].map((r) => ({ ...r, group: UUt }));
[
  {
    label: "Expanded pool/participant",
    search: "Non-empty pool/participant",
    actionName: "expanded-pool",
    className: "bpmn-icon-participant",
    target: {
      type: "bpmn:Participant",
      isExpanded: !0
    }
  },
  {
    label: "Empty pool/participant",
    search: "Collapsed pool/participant",
    actionName: "collapsed-pool",
    className: "bpmn-icon-lane",
    target: {
      type: "bpmn:Participant",
      isExpanded: !1
    }
  }
].map((r) => ({ ...r, group: qUt }));
function CH(r, e) {
  e && (r.super_ = e, r.prototype = Object.create(e.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }));
}
function Xb(r, e) {
  var t = EH(r);
  return t && typeof t.$instanceOf == "function" && t.$instanceOf(e);
}
function KUt(r, e) {
  return FUt(e, function(t) {
    return Xb(r, t);
  });
}
function EH(r) {
  return r && r.businessObject || r;
}
function YUt(r) {
  return jBe(r) && UBe(r, "labelTarget");
}
var XUt = 1e3;
function Ta(r) {
  this._eventBus = r;
}
Ta.$inject = ["eventBus"];
function JUt(r, e) {
  return function(t) {
    return r.call(e || null, t.context, t.command, t);
  };
}
Ta.prototype.on = function(r, e, t, n, i, s) {
  if ((C3(e) || ZBe(e)) && (s = i, i = n, n = t, t = e, e = null), C3(t) && (s = i, i = n, n = t, t = XUt), jBe(i) && (s = i, i = !1), !C3(n))
    throw new Error("handlerFn must be a function");
  yH(r) || (r = [r]);
  var o = this._eventBus;
  GBe(r, function(a) {
    var l = ["commandStack", a, e].filter(function(c) {
      return c;
    }).join(".");
    o.on(l, t, i ? JUt(n, s) : n, s);
  });
};
Ta.prototype.canExecute = nu("canExecute");
Ta.prototype.preExecute = nu("preExecute");
Ta.prototype.preExecuted = nu("preExecuted");
Ta.prototype.execute = nu("execute");
Ta.prototype.executed = nu("executed");
Ta.prototype.postExecute = nu("postExecute");
Ta.prototype.postExecuted = nu("postExecuted");
Ta.prototype.revert = nu("revert");
Ta.prototype.reverted = nu("reverted");
function nu(r) {
  return function(t, n, i, s, o) {
    (C3(t) || ZBe(t)) && (o = s, s = i, i = n, n = t, t = null), this.on(t, r, n, i, s, o);
  };
}
function Cm(r) {
  Ta.call(this, r), this.init();
}
Cm.$inject = ["eventBus"];
CH(Cm, Ta);
Cm.prototype.addRule = function(r, e, t) {
  var n = this;
  typeof r == "string" && (r = [r]), r.forEach(function(i) {
    n.canExecute(i, e, function(s, o, a) {
      return t(s);
    }, !0);
  });
};
Cm.prototype.init = function() {
};
function _H(r) {
  Cm.call(this, r);
}
CH(_H, Cm);
_H.$inject = [
  "eventBus"
];
_H.prototype.init = function() {
  this.addRule("shape.append", function(r) {
    const e = r.element, t = EH(e);
    if (YUt(e) || KUt(e, [
      "bpmn:EndEvent",
      "bpmn:Group",
      "bpmn:TextAnnotation",
      "bpmn:Lane",
      "bpmn:Participant",
      "bpmn:DataStoreReference",
      "bpmn:DataObjectReference"
    ]) || eqt(e) || Xb(e, "bpmn:IntermediateThrowEvent") && $Ut(e, "bpmn:LinkEventDefinition") || Xb(e, "bpmn:SubProcess") && t.triggeredByEvent)
      return !1;
  });
};
function $Ut(r, e) {
  const t = EH(r);
  return !!qBe(t.eventDefinitions || [], function(n) {
    return Xb(n, e);
  });
}
function eqt(r) {
  return r.waypoints;
}
var t6;
typeof document < "u" && (t6 = document.createElement("div"), t6.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>', t6.getElementsByTagName("link").length, t6 = void 0);
var tqt = ["c", "C"], nqt = ["v", "V"], iqt = ["y", "Y"], QBe = ["z", "Z"];
function nf(r) {
  return r.altKey ? !1 : r.ctrlKey || r.metaKey;
}
function Ad(r, e) {
  return r = yH(r) ? r : [r], r.indexOf(e.key) !== -1 || r.indexOf(e.code) !== -1;
}
function KBe(r) {
  return r.shiftKey;
}
function rqt(r) {
  return nf(r) && Ad(tqt, r);
}
function sqt(r) {
  return nf(r) && Ad(nqt, r);
}
function oqt(r) {
  return nf(r) && !KBe(r) && Ad(QBe, r);
}
function aqt(r) {
  return nf(r) && (Ad(iqt, r) || Ad(QBe, r) && KBe(r));
}
var lqt = 500;
function av(r, e) {
  var t = this;
  r.on("editorActions.init", lqt, function(n) {
    var i = n.editorActions;
    t.registerBindings(e, i);
  });
}
av.$inject = [
  "eventBus",
  "keyboard"
];
av.prototype.registerBindings = function(r, e) {
  function t(n, i) {
    e.isRegistered(n) && r.addListener(i);
  }
  t("undo", function(n) {
    var i = n.keyEvent;
    if (oqt(i))
      return e.trigger("undo"), !0;
  }), t("redo", function(n) {
    var i = n.keyEvent;
    if (aqt(i))
      return e.trigger("redo"), !0;
  }), t("copy", function(n) {
    var i = n.keyEvent;
    if (rqt(i))
      return e.trigger("copy"), !0;
  }), t("paste", function(n) {
    var i = n.keyEvent;
    if (sqt(i))
      return e.trigger("paste"), !0;
  }), t("stepZoom", function(n) {
    var i = n.keyEvent;
    if (Ad(["+", "Add", "="], i) && nf(i))
      return e.trigger("stepZoom", { value: 1 }), !0;
  }), t("stepZoom", function(n) {
    var i = n.keyEvent;
    if (Ad(["-", "Subtract"], i) && nf(i))
      return e.trigger("stepZoom", { value: -1 }), !0;
  }), t("zoom", function(n) {
    var i = n.keyEvent;
    if (Ad("0", i) && nf(i))
      return e.trigger("zoom", { value: 1 }), !0;
  }), t("removeSelection", function(n) {
    var i = n.keyEvent;
    if (Ad(["Backspace", "Delete", "Del"], i))
      return e.trigger("removeSelection"), !0;
  });
};
function xH(r) {
  this._injector = r, this._keyboard = this._injector.get("keyboard", !1), this._editorActions = this._injector.get("editorActions", !1), this._keyboard && this._injector.invoke(av, this);
}
CH(xH, av);
xH.$inject = [
  "injector"
];
xH.prototype.registerBindings = function() {
  const r = this._keyboard, e = this._editorActions;
  av.prototype.registerBindings.call(this, r, e);
  function t(n, i) {
    e && e.isRegistered(n) && r && r.addListener(i);
  }
  t("appendElement", function(n) {
    const i = n.keyEvent;
    if (!(r && r.hasModifier(i)) && r && r.isKey(["a", "A"], i))
      return e && e.trigger("appendElement", i), !0;
  }), t("createElement", function(n) {
    const i = n.keyEvent;
    if (!(r && r.hasModifier(i)) && r && r.isKey(["n", "N"], i))
      return e && e.trigger("createElement", i), !0;
  });
};
var cqt = [
  {
    label: "Start event",
    actionName: "replace-with-none-start",
    className: "bpmn-icon-start-event-none",
    target: {
      type: "bpmn:StartEvent"
    }
  },
  {
    label: "Intermediate throw event",
    actionName: "replace-with-none-intermediate-throwing",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:IntermediateThrowEvent"
    }
  },
  {
    label: "End event",
    actionName: "replace-with-none-end",
    className: "bpmn-icon-end-event-none",
    target: {
      type: "bpmn:EndEvent"
    }
  },
  {
    label: "Message start event",
    actionName: "replace-with-message-start",
    className: "bpmn-icon-start-event-message",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Timer start event",
    actionName: "replace-with-timer-start",
    className: "bpmn-icon-start-event-timer",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition"
    }
  },
  {
    label: "Conditional start event",
    actionName: "replace-with-conditional-start",
    className: "bpmn-icon-start-event-condition",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition"
    }
  },
  {
    label: "Signal start event",
    actionName: "replace-with-signal-start",
    className: "bpmn-icon-start-event-signal",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  }
], hqt = [
  {
    label: "Start event",
    actionName: "replace-with-none-start",
    className: "bpmn-icon-start-event-none",
    target: {
      type: "bpmn:StartEvent"
    }
  },
  {
    label: "Intermediate throw event",
    actionName: "replace-with-none-intermediate-throwing",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:IntermediateThrowEvent"
    }
  },
  {
    label: "End event",
    actionName: "replace-with-none-end",
    className: "bpmn-icon-end-event-none",
    target: {
      type: "bpmn:EndEvent"
    }
  }
], dqt = [
  {
    label: "Start event",
    actionName: "replace-with-none-start",
    className: "bpmn-icon-start-event-none",
    target: {
      type: "bpmn:StartEvent"
    }
  },
  {
    label: "Intermediate throw event",
    actionName: "replace-with-none-intermediate-throw",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:IntermediateThrowEvent"
    }
  },
  {
    label: "End event",
    actionName: "replace-with-none-end",
    className: "bpmn-icon-end-event-none",
    target: {
      type: "bpmn:EndEvent"
    }
  },
  {
    label: "Message intermediate catch event",
    actionName: "replace-with-message-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-message",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Message intermediate throw event",
    actionName: "replace-with-message-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-message",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Timer intermediate catch event",
    actionName: "replace-with-timer-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-timer",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition"
    }
  },
  {
    label: "Escalation intermediate throw event",
    actionName: "replace-with-escalation-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-escalation",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition"
    }
  },
  {
    label: "Conditional intermediate catch event",
    actionName: "replace-with-conditional-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-condition",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition"
    }
  },
  {
    label: "Link intermediate catch event",
    actionName: "replace-with-link-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-link",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:LinkEventDefinition",
      eventDefinitionAttrs: {
        name: ""
      }
    }
  },
  {
    label: "Link intermediate throw event",
    actionName: "replace-with-link-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-link",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:LinkEventDefinition",
      eventDefinitionAttrs: {
        name: ""
      }
    }
  },
  {
    label: "Compensation intermediate throw event",
    actionName: "replace-with-compensation-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-compensation",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition"
    }
  },
  {
    label: "Signal intermediate catch event",
    actionName: "replace-with-signal-intermediate-catch",
    className: "bpmn-icon-intermediate-event-catch-signal",
    target: {
      type: "bpmn:IntermediateCatchEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  },
  {
    label: "Signal intermediate throw event",
    actionName: "replace-with-signal-intermediate-throw",
    className: "bpmn-icon-intermediate-event-throw-signal",
    target: {
      type: "bpmn:IntermediateThrowEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  }
], uqt = [
  {
    label: "Start event",
    actionName: "replace-with-none-start",
    className: "bpmn-icon-start-event-none",
    target: {
      type: "bpmn:StartEvent"
    }
  },
  {
    label: "Intermediate throw event",
    actionName: "replace-with-none-intermediate-throw",
    className: "bpmn-icon-intermediate-event-none",
    target: {
      type: "bpmn:IntermediateThrowEvent"
    }
  },
  {
    label: "End event",
    actionName: "replace-with-none-end",
    className: "bpmn-icon-end-event-none",
    target: {
      type: "bpmn:EndEvent"
    }
  },
  {
    label: "Message end event",
    actionName: "replace-with-message-end",
    className: "bpmn-icon-end-event-message",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition"
    }
  },
  {
    label: "Escalation end event",
    actionName: "replace-with-escalation-end",
    className: "bpmn-icon-end-event-escalation",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition"
    }
  },
  {
    label: "Error end event",
    actionName: "replace-with-error-end",
    className: "bpmn-icon-end-event-error",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:ErrorEventDefinition"
    }
  },
  {
    label: "Cancel end event",
    actionName: "replace-with-cancel-end",
    className: "bpmn-icon-end-event-cancel",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:CancelEventDefinition"
    }
  },
  {
    label: "Compensation end event",
    actionName: "replace-with-compensation-end",
    className: "bpmn-icon-end-event-compensation",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition"
    }
  },
  {
    label: "Signal end event",
    actionName: "replace-with-signal-end",
    className: "bpmn-icon-end-event-signal",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition"
    }
  },
  {
    label: "Terminate end event",
    actionName: "replace-with-terminate-end",
    className: "bpmn-icon-end-event-terminate",
    target: {
      type: "bpmn:EndEvent",
      eventDefinitionType: "bpmn:TerminateEventDefinition"
    }
  }
], fqt = [
  {
    label: "Exclusive gateway",
    actionName: "replace-with-exclusive-gateway",
    className: "bpmn-icon-gateway-xor",
    target: {
      type: "bpmn:ExclusiveGateway"
    }
  },
  {
    label: "Parallel gateway",
    actionName: "replace-with-parallel-gateway",
    className: "bpmn-icon-gateway-parallel",
    target: {
      type: "bpmn:ParallelGateway"
    }
  },
  {
    label: "Inclusive gateway",
    actionName: "replace-with-inclusive-gateway",
    className: "bpmn-icon-gateway-or",
    target: {
      type: "bpmn:InclusiveGateway"
    }
  },
  {
    label: "Complex gateway",
    actionName: "replace-with-complex-gateway",
    className: "bpmn-icon-gateway-complex",
    target: {
      type: "bpmn:ComplexGateway"
    }
  },
  {
    label: "Event-based gateway",
    actionName: "replace-with-event-based-gateway",
    className: "bpmn-icon-gateway-eventbased",
    target: {
      type: "bpmn:EventBasedGateway",
      instantiate: !1,
      eventGatewayType: "Exclusive"
    }
  }
  // Gateways deactivated until https://github.com/bpmn-io/bpmn-js/issues/194
  // {
  //   label: 'Event based instantiating Gateway',
  //   actionName: 'replace-with-exclusive-event-based-gateway',
  //   className: 'bpmn-icon-exclusive-event-based',
  //   target: {
  //     type: 'bpmn:EventBasedGateway'
  //   },
  //   options: {
  //     businessObject: { instantiate: true, eventGatewayType: 'Exclusive' }
  //   }
  // },
  // {
  //   label: 'Parallel Event based instantiating Gateway',
  //   actionName: 'replace-with-parallel-event-based-instantiate-gateway',
  //   className: 'bpmn-icon-parallel-event-based-instantiate-gateway',
  //   target: {
  //     type: 'bpmn:EventBasedGateway'
  //   },
  //   options: {
  //     businessObject: { instantiate: true, eventGatewayType: 'Parallel' }
  //   }
  // }
], pqt = [
  {
    label: "Transaction",
    actionName: "replace-with-transaction",
    className: "bpmn-icon-transaction",
    target: {
      type: "bpmn:Transaction",
      isExpanded: !0
    }
  },
  {
    label: "Event sub-process",
    actionName: "replace-with-event-subprocess",
    className: "bpmn-icon-event-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      triggeredByEvent: !0,
      isExpanded: !0
    }
  },
  {
    label: "Ad-hoc sub-process",
    actionName: "replace-with-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Sub-process (collapsed)",
    actionName: "replace-with-collapsed-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !1
    }
  }
], gqt = [
  {
    label: "Sub-process",
    actionName: "replace-with-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Transaction",
    actionName: "replace-with-transaction",
    className: "bpmn-icon-transaction",
    target: {
      type: "bpmn:Transaction",
      isExpanded: !0
    }
  },
  {
    label: "Event sub-process",
    actionName: "replace-with-event-subprocess",
    className: "bpmn-icon-event-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      triggeredByEvent: !0,
      isExpanded: !0
    }
  },
  {
    label: "Ad-hoc sub-process (collapsed)",
    actionName: "replace-with-collapsed-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !1
    }
  }
], YBe = [
  {
    label: "Transaction",
    actionName: "replace-with-transaction",
    className: "bpmn-icon-transaction",
    target: {
      type: "bpmn:Transaction",
      isExpanded: !0
    }
  },
  {
    label: "Sub-process",
    actionName: "replace-with-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Ad-hoc sub-process",
    actionName: "replace-with-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Event sub-process",
    actionName: "replace-with-event-subprocess",
    className: "bpmn-icon-event-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      triggeredByEvent: !0,
      isExpanded: !0
    }
  }
], mqt = YBe, Aqt = [
  {
    label: "Task",
    actionName: "replace-with-task",
    className: "bpmn-icon-task",
    target: {
      type: "bpmn:Task"
    }
  },
  {
    label: "User task",
    actionName: "replace-with-user-task",
    className: "bpmn-icon-user",
    target: {
      type: "bpmn:UserTask"
    }
  },
  {
    label: "Service task",
    actionName: "replace-with-service-task",
    className: "bpmn-icon-service",
    target: {
      type: "bpmn:ServiceTask"
    }
  },
  {
    label: "Send task",
    actionName: "replace-with-send-task",
    className: "bpmn-icon-send",
    target: {
      type: "bpmn:SendTask"
    }
  },
  {
    label: "Receive task",
    actionName: "replace-with-receive-task",
    className: "bpmn-icon-receive",
    target: {
      type: "bpmn:ReceiveTask"
    }
  },
  {
    label: "Manual task",
    actionName: "replace-with-manual-task",
    className: "bpmn-icon-manual",
    target: {
      type: "bpmn:ManualTask"
    }
  },
  {
    label: "Business rule task",
    actionName: "replace-with-rule-task",
    className: "bpmn-icon-business-rule",
    target: {
      type: "bpmn:BusinessRuleTask"
    }
  },
  {
    label: "Script task",
    actionName: "replace-with-script-task",
    className: "bpmn-icon-script",
    target: {
      type: "bpmn:ScriptTask"
    }
  },
  {
    label: "Call activity",
    actionName: "replace-with-call-activity",
    className: "bpmn-icon-call-activity",
    target: {
      type: "bpmn:CallActivity"
    }
  },
  {
    label: "Sub-process (collapsed)",
    actionName: "replace-with-collapsed-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !1
    }
  },
  {
    label: "Sub-process (expanded)",
    actionName: "replace-with-expanded-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:SubProcess",
      isExpanded: !0
    }
  },
  {
    label: "Ad-hoc sub-process (collapsed)",
    actionName: "replace-with-collapsed-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-collapsed",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !1
    }
  },
  {
    label: "Ad-hoc sub-process (expanded)",
    actionName: "replace-with-ad-hoc-subprocess",
    className: "bpmn-icon-subprocess-expanded",
    target: {
      type: "bpmn:AdHocSubProcess",
      isExpanded: !0
    }
  }
], wqt = [
  {
    label: "Data store reference",
    actionName: "replace-with-data-store-reference",
    className: "bpmn-icon-data-store",
    target: {
      type: "bpmn:DataStoreReference"
    }
  }
], vqt = [
  {
    label: "Data object reference",
    actionName: "replace-with-data-object-reference",
    className: "bpmn-icon-data-object",
    target: {
      type: "bpmn:DataObjectReference"
    }
  }
], bqt = [
  {
    label: "Message boundary event",
    actionName: "replace-with-message-boundary",
    className: "bpmn-icon-intermediate-event-catch-message",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Timer boundary event",
    actionName: "replace-with-timer-boundary",
    className: "bpmn-icon-intermediate-event-catch-timer",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Escalation boundary event",
    actionName: "replace-with-escalation-boundary",
    className: "bpmn-icon-intermediate-event-catch-escalation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Conditional boundary event",
    actionName: "replace-with-conditional-boundary",
    className: "bpmn-icon-intermediate-event-catch-condition",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Error boundary event",
    actionName: "replace-with-error-boundary",
    className: "bpmn-icon-intermediate-event-catch-error",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ErrorEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Cancel boundary event",
    actionName: "replace-with-cancel-boundary",
    className: "bpmn-icon-intermediate-event-catch-cancel",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:CancelEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Signal boundary event",
    actionName: "replace-with-signal-boundary",
    className: "bpmn-icon-intermediate-event-catch-signal",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Compensation boundary event",
    actionName: "replace-with-compensation-boundary",
    className: "bpmn-icon-intermediate-event-catch-compensation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition",
      cancelActivity: !0
    }
  },
  {
    label: "Message boundary event (non-interrupting)",
    actionName: "replace-with-non-interrupting-message-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-message",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Timer boundary event (non-interrupting)",
    actionName: "replace-with-non-interrupting-timer-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-timer",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Escalation boundary event (non-interrupting)",
    actionName: "replace-with-non-interrupting-escalation-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-escalation",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Conditional boundary event (non-interrupting)",
    actionName: "replace-with-non-interrupting-conditional-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-condition",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition",
      cancelActivity: !1
    }
  },
  {
    label: "Signal boundary event (non-interrupting)",
    actionName: "replace-with-non-interrupting-signal-boundary",
    className: "bpmn-icon-intermediate-event-catch-non-interrupting-signal",
    target: {
      type: "bpmn:BoundaryEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition",
      cancelActivity: !1
    }
  }
], yqt = [
  {
    label: "Message start event",
    actionName: "replace-with-message-start",
    className: "bpmn-icon-start-event-message",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Timer start event",
    actionName: "replace-with-timer-start",
    className: "bpmn-icon-start-event-timer",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Conditional start event",
    actionName: "replace-with-conditional-start",
    className: "bpmn-icon-start-event-condition",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Signal start event",
    actionName: "replace-with-signal-start",
    className: "bpmn-icon-start-event-signal",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Error start event",
    actionName: "replace-with-error-start",
    className: "bpmn-icon-start-event-error",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:ErrorEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Escalation start event",
    actionName: "replace-with-escalation-start",
    className: "bpmn-icon-start-event-escalation",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Compensation start event",
    actionName: "replace-with-compensation-start",
    className: "bpmn-icon-start-event-compensation",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:CompensateEventDefinition",
      isInterrupting: !0
    }
  },
  {
    label: "Message start event (non-interrupting)",
    actionName: "replace-with-non-interrupting-message-start",
    className: "bpmn-icon-start-event-non-interrupting-message",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:MessageEventDefinition",
      isInterrupting: !1
    }
  },
  {
    label: "Timer start event (non-interrupting)",
    actionName: "replace-with-non-interrupting-timer-start",
    className: "bpmn-icon-start-event-non-interrupting-timer",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:TimerEventDefinition",
      isInterrupting: !1
    }
  },
  {
    label: "Conditional start event (non-interrupting)",
    actionName: "replace-with-non-interrupting-conditional-start",
    className: "bpmn-icon-start-event-non-interrupting-condition",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:ConditionalEventDefinition",
      isInterrupting: !1
    }
  },
  {
    label: "Signal start event (non-interrupting)",
    actionName: "replace-with-non-interrupting-signal-start",
    className: "bpmn-icon-start-event-non-interrupting-signal",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:SignalEventDefinition",
      isInterrupting: !1
    }
  },
  {
    label: "Escalation start event (non-interrupting)",
    actionName: "replace-with-non-interrupting-escalation-start",
    className: "bpmn-icon-start-event-non-interrupting-escalation",
    target: {
      type: "bpmn:StartEvent",
      eventDefinitionType: "bpmn:EscalationEventDefinition",
      isInterrupting: !1
    }
  }
], Cqt = [
  {
    label: "Sequence flow",
    actionName: "replace-with-sequence-flow",
    className: "bpmn-icon-connection"
  },
  {
    label: "Default flow",
    actionName: "replace-with-default-flow",
    className: "bpmn-icon-default-flow"
  },
  {
    label: "Conditional flow",
    actionName: "replace-with-conditional-flow",
    className: "bpmn-icon-conditional-flow"
  }
], Eqt = [
  {
    label: "Expanded pool/participant",
    actionName: "replace-with-expanded-pool",
    className: "bpmn-icon-participant",
    target: {
      type: "bpmn:Participant",
      isExpanded: !0
    }
  },
  {
    label: function(r) {
      var e = "Empty pool/participant";
      return r.children && r.children.length && (e += " (removes content)"), e;
    },
    actionName: "replace-with-collapsed-pool",
    // TODO(@janstuemmel): maybe design new icon
    className: "bpmn-icon-lane",
    target: {
      type: "bpmn:Participant",
      isExpanded: !1
    }
  }
], _qt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AD_HOC_SUBPROCESS_EXPANDED: gqt,
  BOUNDARY_EVENT: bqt,
  DATA_OBJECT_REFERENCE: wqt,
  DATA_STORE_REFERENCE: vqt,
  END_EVENT: uqt,
  EVENT_SUB_PROCESS: mqt,
  EVENT_SUB_PROCESS_START_EVENT: yqt,
  GATEWAY: fqt,
  INTERMEDIATE_EVENT: dqt,
  PARTICIPANT: Eqt,
  SEQUENCE_FLOW: Cqt,
  START_EVENT: cqt,
  START_EVENT_SUB_PROCESS: hqt,
  SUBPROCESS_EXPANDED: pqt,
  TASK: Aqt,
  TRANSACTION: YBe
});
Object.values(_qt);
let xqt = class {
  navigatedViewer = null;
  #n = null;
  selectedFlowNode;
  #t = [];
  #e;
  #i = [];
  import = async (e) => {
    this.navigatedViewer.off("element.click", this.#r), this.#t = [], this.#e = void 0, await this.navigatedViewer.importXML(e), this.navigatedViewer.on("element.click", this.#r);
  };
  render = async (e) => {
    const { container: t, xml: n, selectableFlowNodeIds: i, selectedFlowNodeIds: s } = e;
    if (this.navigatedViewer === null && this.#s(t), this.#n !== n && (this.#n = n, await this.import(n)), !Ar(this.#t, i)) {
      this.#t.forEach((l) => {
        this.removeMarker(l, "play-selectable");
      }), i.forEach((l) => {
        this.addMarker(l, "play-selectable");
      }), this.#t = i;
      const o = this.navigatedViewer?.get("elementRegistry");
      this.#i.forEach((l) => {
        this.removeMarker(l, "play-non-selectable");
      });
      const a = o?.filter(
        (l) => zye(l, i)
      );
      a?.forEach(({ id: l }) => {
        this.addMarker(l, "play-non-selectable");
      }), this.#i = a ? a.map(({ id: l }) => l) : [];
    }
    Ar(this.#e?.sort(), s?.sort()) || (this.#e !== void 0 && (this.#e.forEach((o) => {
      this.removeMarker(o, "play-selected"), this.removeMarker(o, "play-selected-frame");
    }), this.selectedFlowNode = void 0), s !== void 0 && s.forEach((o) => {
      this.addMarker(o, "play-selected"), this.addMarker(o, "play-selected-frame");
    }), this.#e = s);
  };
  addMarker = (e, t) => {
    const n = this.navigatedViewer?.get("canvas");
    this.navigatedViewer?.get("elementRegistry")?.get(e) !== void 0 && n?.addMarker(e, t);
  };
  removeMarker = (e, t) => {
    const n = this.navigatedViewer?.get("canvas");
    this.navigatedViewer?.get("elementRegistry")?.get(e) !== void 0 && n?.removeMarker(e, t);
  };
  #r = (e) => {
    const t = e.element;
    zye(t, this.#t) || this.#t.length === 0 || (this.#t.includes(t.id) && (this.#e === void 0 || !this.#e.includes(t.id)) ? nh.selectFlowNode({
      flowNodeId: t.id,
      isMultiInstance: Wye(t.businessObject)
    }) : this.#e !== void 0 && nh.clearSelection());
  };
  #a = (e, t) => {
    this.navigatedViewer?.get("overlays")?.remove({ type: e, element: t });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addOverlay = (e, t, n) => {
    this.#a(t, e);
    const i = document.createElement("div");
    return this.navigatedViewer?.get("overlays")?.add(e.id, t, {
      html: i,
      position: n
    }), i;
  };
  #s = (e) => {
    this.#o(), this.navigatedViewer = new Sg({
      container: e,
      bpmnRenderer: pOt,
      additionalModules: [
        mV,
        UOe,
        KOe,
        sRe
      ]
    });
  };
  zoom = (e) => {
    this.navigatedViewer?.get("zoomScroll")?.stepZoom(e);
  };
  zoomIn = () => {
    this.zoom(0.1);
  };
  zoomOut = () => {
    this.zoom(-0.1);
  };
  toggleMinimap = () => {
    mi.toggleMinimap(), this.navigatedViewer?.get("minimap").toggle();
  };
  zoomReset = () => {
    const e = this.navigatedViewer?.get("canvas");
    e != null && (e.resized(), e.zoom("fit-viewport", "auto"));
  };
  #o = () => {
    this.navigatedViewer?.destroy();
  };
  getElementRegistry = () => this.navigatedViewer?.get("elementRegistry");
  getDefinitions = () => this.navigatedViewer?.getDefinitions();
  focusOnElement = (e) => {
    if (this.navigatedViewer === null)
      return;
    this.navigatedViewer.get("zoomScroll").reset();
    const t = this.navigatedViewer.get("elementRegistry").get(e);
    t !== void 0 && (this.navigatedViewer.get("canvas").scrollToElement(t), nh.selectFlowNode({
      flowNodeId: t.id,
      isMultiInstance: Wye(t.businessObject)
    }));
  };
  saveXML = async () => this.navigatedViewer?.saveXML({ format: !0 });
  reset = () => {
    this.#o();
  };
};
const Sqt = q.div`
  width: 100%;
  position: relative;
  background-color: white;
  display: flex;
  flex: 1;
`, Mqt = q.div`
  ${({ $isSelectionAllowed: r }) => rs`
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      .play-sequence-flow-taken .djs-visual path {
        stroke: #52b415 !important;
      }
      .play-sequence-flow-taken marker path {
        fill: #52b415 !important;
      }

      ${r ? rs`
            .play-selectable:hover {
              cursor: pointer;

              .djs-hit-all {
                cursor: pointer !important;
              }
            }

            .djs-outline {
              visibility: initial !important;
            }

            .play-selectable:hover .djs-outline,
            .play-selected-frame .djs-outline {
              stroke-width: 2px;
              stroke: var(--cds-link-inverse, #78a9ff);
            }

            .play-non-selectable {
              cursor: not-allowed;

              .djs-hit-all {
                cursor: not-allowed !important;
              }
              .djs-hit {
                pointer-events: none;
              }
            }

            .play-selected .djs-visual {
              rect,
              circle,
              polygon {
                fill: var(--cds-highlight, #d0e2ff) !important;
              }
            }
          ` : rs`
            .djs-hit {
              pointer-events: none;
            }
          `}
    `}
`, Dqt = q.div`
  display: flex;
`, Lqt = q(Rn)`
  width: 42px;
`, kqt = q(Rn)`
  width: 16px;

  > :first-child {
    min-width: 0;
    margin-top: 3px;
  }
`, bc = ({ actions: r, disabled: e }) => {
  const [t, n] = ye(null), [i, ...s] = r;
  return /* @__PURE__ */ x.jsxs(Dqt, { children: [
    /* @__PURE__ */ x.jsx(
      Lqt,
      {
        hasIconOnly: !0,
        iconDescription: i.label,
        size: "sm",
        kind: i.kind ?? "primary",
        disabled: e || i.disabled,
        renderIcon: i.renderIcon,
        onClick: i.onClick
      }
    ),
    s.length > 0 && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        kqt,
        {
          hasIconOnly: !0,
          kind: "secondary",
          iconDescription: "Additional actions",
          size: "sm",
          disabled: e,
          onClick: (o) => {
            n(o.currentTarget);
          },
          renderIcon: () => /* @__PURE__ */ x.jsx(Yht, { color: "white" })
        }
      ),
      /* @__PURE__ */ x.jsx(
        j0,
        {
          align: "left",
          anchorEl: t,
          open: !!t,
          onClose: () => n(null),
          children: s.map((o) => o.type === "divider" ? /* @__PURE__ */ x.jsx(j0.ListItemDivider, {}, o.label) : (
            //@ts-expect-error Property 'ListItem' does not exist on type 'typeof Dropdown'.ts(2339)
            /* @__PURE__ */ x.jsx(
              j0.ListItem,
              {
                onClick: (...a) => (n(null), o?.onClick?.(...a)),
                children: o.label
              },
              o.label
            )
          ))
        }
      )
    ] })
  ] });
}, Nqt = q(K4)`
  margin-bottom: var(--cds-spacing-03, 8px);
`;
q(Hf)`
  margin-top: var(--cds-spacing-06, 16px);
  max-width: unset;
`;
const Tqt = q.div`
  min-width: 0; // https://github.com/microsoft/monaco-editor/issues/3393
`, Em = (r) => {
  try {
    return typeof JSON.parse(r) == "object";
  } catch {
    return !1;
  }
}, Iqt = q(Hf)`
  ${({ $hideTopMargin: r }) => !r && rs`
      margin-top: var(--cds-spacing-05, 16px);
    `};

  max-width: unset;
`, Oqt = ({
  hasExampleData: r,
  hasCachedData: e,
  showPrefilledData: t
}) => t ? r ? {
  title: "Variables prefilled from the BPMN’s example data"
} : e ? {
  title: "Variables prefilled from a previous session",
  subtitle: "Save as example data for collaborative reuse"
} : {
  title: "Save these variables as example data for collaborative reuse"
} : {
  title: "Save these variables as example data for collaborative reuse"
}, j4 = rt(
  ({
    hasCachedData: r,
    hasExampleData: e,
    showPrefilledData: t = !0,
    hideTopMargin: n = !1
  }) => /* @__PURE__ */ x.jsx(
    Iqt,
    {
      kind: "info",
      inline: !0,
      hideCloseButton: !0,
      lowContrast: !0,
      actionButtonLabel: "Learn more",
      onActionButtonClick: () => {
        window.open(
          "https://docs.camunda.io/docs/components/modeler/data-handling/",
          "_blank"
        );
      },
      $hideTopMargin: n,
      ...Oqt({
        hasCachedData: r,
        hasExampleData: e,
        showPrefilledData: t
      })
    }
  )
), Rqt = rt(
  ({
    isOpen: r,
    initialMessageName: e,
    initialCorrelationKey: t,
    onClose: n,
    elementId: i,
    isStartEvent: s,
    exampleData: o,
    element: a
  }) => {
    const l = bn(Cr), c = Kt.state.processInstance, d = oMe(a), [u, f] = ye(
      o ? EMe(o) : ""
    ), [p, g] = ye(!0), [m, A] = ye(e), [w, v] = ye(t), [y, _] = ye(""), [S, D] = ye(""), [M, L] = ye(!0), T = An(null);
    return Pe(() => {
      r || L(!0);
    }, [r]), Pe(() => {
      p && T.current?.hideMarkers();
    }, [p]), /* @__PURE__ */ x.jsx(
      jy,
      {
        title: "Publish message",
        isVisible: r,
        primaryButtonLabel: "Publish",
        secondaryButton: { label: "Cancel", onClick: n },
        ghostButton: {
          label: "Reset",
          onClick: () => {
            L(!1), f(""), A(""), v(""), _(""), D("");
          }
        },
        onClose: n,
        onSubmit: async () => {
          n();
          const B = await l.publishMessage?.({
            messageName: m,
            correlationKey: w,
            variables: u,
            timeToLive: y,
            messageId: S,
            isStartEvent: s
          });
          B?.success ? (B?.success && c !== void 0 && is(Lr(c.key), {
            action: "publishMessage",
            elementId: i,
            messageName: m,
            messageCorrelationKey: w,
            variables: u,
            timeToLive: y,
            messageId: S
          }), s && (l.displayNotification?.success({
            title: vd
          }), l.displayNotification?.success({
            title: `Message "${m}" published`
          }))) : l.displayNotification?.error(Mi);
        },
        modalBody: /* @__PURE__ */ x.jsx($4, { children: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
          !d && /* @__PURE__ */ x.jsx(
            j4,
            {
              hasExampleData: o != null,
              showPrefilledData: M
            }
          ),
          /* @__PURE__ */ x.jsxs(Tqt, { children: [
            /* @__PURE__ */ x.jsx(Nqt, { children: "Variables" }),
            /* @__PURE__ */ x.jsx(
              dV,
              {
                height: "10vh",
                value: u,
                isVisible: r,
                placeholder: fw,
                onChange: (B) => {
                  const V = B ?? "";
                  f(V), g(Em(V));
                },
                onValidate: g,
                onMount: (B) => {
                  T.current = B;
                },
                hasJSONObjectValidation: !0
              }
            )
          ] }),
          /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", children: [
            /* @__PURE__ */ x.jsx(
              ha,
              {
                id: "message_name",
                labelText: "Message name",
                placeholder: "new order",
                value: m,
                onChange: (B) => {
                  A(B.target.value);
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              ha,
              {
                id: "correlation_key",
                labelText: "Message correlation key",
                placeholder: "order-key-123",
                value: w,
                onChange: (B) => {
                  v(B.target.value);
                }
              }
            )
          ] }),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "message_id",
              labelText: "Message ID",
              placeholder: "tracking-id-123",
              value: S,
              onChange: (B) => {
                D(B.target.value);
              }
            }
          ),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "ttl",
              labelText: "Message time-to-live (TTL)",
              placeholder: "PT5M",
              value: y,
              onChange: (B) => {
                _(B.target.value);
              },
              helperText: "Time duration defined as ISO 8601 durations format"
            }
          )
        ] }) })
      }
    );
  }
), x_e = rt(
  ({
    messageSubscription: r,
    isRestartMode: e = !1,
    element: t,
    isStartEvent: n = !1
  }) => {
    const i = bn(Cr), s = Kt.state.processInstance, [o, a] = ye(!1), l = e ? L7 : Xht;
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        bc,
        {
          actions: [
            {
              label: e ? "Restart process" : "Publish Message",
              //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
              renderIcon: () => /* @__PURE__ */ x.jsx(l, { color: "white" }),
              onClick: async () => {
                const c = await i.publishMessage?.({
                  messageName: r.messageName,
                  correlationKey: r.messageCorrelationKey,
                  isStartEvent: n
                });
                c?.success ? (c?.success && s !== void 0 && is(
                  Lr(s.key),
                  {
                    action: "publishMessage",
                    elementId: t.id,
                    messageName: r.messageName,
                    messageCorrelationKey: r.messageCorrelationKey
                  }
                ), n && (i.displayNotification?.success({
                  title: vd
                }), i.displayNotification?.success({
                  title: `Message "${r.messageName}" published`
                }))) : i.displayNotification?.error(Mi);
              }
            },
            {
              label: "Publish Message with Variables",
              onClick: () => {
                a(!0);
              }
            }
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        Rqt,
        {
          isOpen: o,
          onClose: () => a(!1),
          initialMessageName: r.messageName,
          initialCorrelationKey: r.messageCorrelationKey,
          elementId: t.id,
          isStartEvent: n,
          exampleData: lh(t),
          element: t
        }
      )
    ] });
  }
), S_e = rt(
  ({
    element: r,
    timer: e,
    isRestartMode: t,
    shouldWaitForInstanceCreation: n,
    isStartEvent: i
  }) => {
    const s = bn(Cr), [o, a] = ye(!1), l = t ? L7 : Qht, c = Kt.state.processInstance;
    return /* @__PURE__ */ x.jsx(
      bc,
      {
        disabled: o,
        actions: [
          {
            label: t ? "Restart process" : "Trigger Timer",
            //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
            renderIcon: () => /* @__PURE__ */ x.jsx(l, { color: "white" }),
            onClick: async () => {
              a(!0);
              const d = await s.timeTravel?.(
                e.dueDate,
                n
              );
              d ? (d && c !== void 0 && is(
                Lr(c.key),
                {
                  action: "timeTravel",
                  elementId: r.id,
                  timeDefinition: e.dueDate
                }
              ), (t || i) && s.displayNotification?.success({
                title: vd
              }), s.displayNotification?.success({
                title: "Timer completed manually",
                subtitle: /* @__PURE__ */ x.jsxs("div", { children: [
                  "Process advanced ahead to",
                  /* @__PURE__ */ x.jsx("br", {}),
                  " ",
                  e.dueDate
                ] })
              })) : s.displayNotification?.error(Mi), a(!1);
            }
          }
        ]
      }
    );
  }
), SH = { top: -20, left: -30 }, Nh = { top: -38, left: 0 }, Vqt = SH, Hqt = SH, Bqt = Nh, Pqt = Nh, M_e = Nh, D_e = Nh, Fqt = Nh, zqt = Nh, Wqt = Nh, jqt = Nh, Zqt = Nh, Uqt = { ...SH, top: -40 }, qqt = Nh, Gqt = q.div`
  border-radius: 12px;
  ${({ $hasMissingSecret: r }) => r ? "border: 2px solid var(--support-support-error, #da1e28);" : "border: 2px solid transparent;"}

  margin-top: 15px;
  margin-left: 25px;

  position: relative;
`, Qqt = q.button`
  position: absolute;
  width: 24px;
  height: 24px;

  cursor: pointer;
  border: none;

  top: -8px;
  right: -9px;

  ${({ $hasMissingSecret: r }) => r ? "background-color: var(--support-support-error, #da1e28);" : "background-color: #78A9FF;"}

  color: white;
  padding: 4px;
`, Kqt = rt(
  ({ element: r, connector: e }) => {
    const { connectorElementsWithMissingSecrets: t } = mh;
    if (!mh.state.isReady)
      return;
    const n = t.find(
      (a) => a.element.id === r.id
    )?.missingSecrets ?? [], i = e.secrets, s = n.length > 0, o = s ? n : i;
    return /* @__PURE__ */ x.jsx(
      Gqt,
      {
        $hasMissingSecret: s,
        style: {
          height: r.height + 10 + "px",
          width: r.width + 10 + "px"
        },
        children: /* @__PURE__ */ x.jsx(uV, { secrets: o, children: /* @__PURE__ */ x.jsx(
          Qqt,
          {
            $hasMissingSecret: s,
            "data-testid": `${s ? "missing" : "existing"}-connector-secret-icon`,
            children: /* @__PURE__ */ x.jsx(x7, {})
          }
        ) })
      }
    );
  }
), Yqt = q.div`
  border-radius: 12px;
  border: 2px solid var(--support-support-error, #da1e28);

  margin-top: 15px;
  margin-left: 25px;

  position: relative;
`, Xqt = q.div`
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 12px;

  bottom: -8px;
  left: -8px;

  background-color: var(--support-support-error, #da1e28);
  color: white;
  padding: 4px;
`, Jqt = ({ element: r, problem: e }) => /* @__PURE__ */ x.jsx(
  Yqt,
  {
    style: {
      height: r.height + 10 + "px",
      width: r.width + 10 + "px"
    },
    children: /* @__PURE__ */ x.jsxs(Xqt, { children: [
      e.status === "not found" && /* @__PURE__ */ x.jsx(AMe, { "data-testid": "not-found-icon" }),
      e.status === "deployment error" && /* @__PURE__ */ x.jsx(Vd, { "data-testid": "deployment-error-icon" })
    ] })
  }
), $qt = rt(
  ({ element: r, isRestartMode: e }) => {
    const t = bn(Cr), { definitions: n, elementsById: i } = mi.state, [s, o] = ye(!1), a = An(), l = An(), c = An(), [d, u] = ye(!1), [f, p] = ye(!1), [g, m] = ye(!0), A = lh(r), w = localStorage.getItem(
      `jobCompletion ${kt.processId} ${r.id}`
    );
    Pe(() => {
      !f && !s && m(!0);
    }, [f, s]);
    async function v(V, { data: N, errors: R }) {
      if (Object.keys(R).length === 0) {
        u(!0), localStorage.setItem(
          `jobCompletion ${kt.processId} ${r.id}`,
          JSON.stringify(N)
        );
        const H = await t.startInstance?.(JSON.stringify(N));
        o(!1), H ? t.displayNotification?.success({
          title: vd
        }) : t.displayNotification?.error(Mi);
      }
    }
    if (Pe(() => {
      a.current && (async () => {
        const V = JSON.parse(A || "{}"), N = JSON.parse(w || "{}"), R = JSON.parse(T), H = new nw();
        l.current = H, H.attachTo(a.current), H.importSchema(R, {
          ...N,
          ...V
        }), H.on("submit", v), c.current = () => {
          l.current.importSchema(R, {});
        };
      })();
    }, [s, A, w]), i === void 0)
      return;
    const D = i[r.id]?.get("extensionElements")?.get("values")?.find((V) => V.$type === "zeebe:formDefinition")?.formKey, T = tMe(n)?.get("extensionElements")?.get("values")?.find(
      //@ts-expect-error Parameter 'elem' implicitly has an 'any' type.ts(7006)
      (V) => V.$type === "zeebe:userTaskForm" && D?.includes(V.id)
    )?.$body, B = e ? L7 : T ? D7 : yMe;
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        bc,
        {
          disabled: d,
          actions: [
            {
              label: e ? "Restart process" : T ? "Open Start Form" : "Start Instance",
              //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
              renderIcon: () => /* @__PURE__ */ x.jsx(B, { color: "white" }),
              onClick: async () => {
                if (T)
                  o(!0);
                else {
                  if (u(!0), !await t.startInstance?.()) {
                    t.displayNotification?.error(Mi), u(!1);
                    return;
                  }
                  t.displayNotification?.success({
                    title: vd
                  });
                }
              }
            },
            {
              label: "Start instance with variables",
              onClick: () => {
                p(!0);
              }
            }
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        Ww,
        {
          title: "Start instance with variables",
          editorTopContent: /* @__PURE__ */ x.jsx(
            j4,
            {
              hasExampleData: A != null,
              showPrefilledData: g
            }
          ),
          isVisible: f,
          primaryButtonLabel: "Create new instance",
          secondaryButtonLabel: "Cancel",
          hasResetButton: !0,
          onReset: () => {
            m(!1);
          },
          hasJSONObjectValidation: !0,
          value: A,
          isValidInput: Em,
          onClose: () => p(!1),
          onSubmit: async (V) => {
            if (p(!1), u(!0), !await t.startInstance?.(V)) {
              t.displayNotification?.error(Mi), u(!1);
              return;
            }
            t.displayNotification?.success({
              title: vd
            });
          },
          placeholder: fw
        }
      ),
      /* @__PURE__ */ x.jsxs(
        tn,
        {
          open: s,
          onClose: () => o(!1),
          children: [
            /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Start Form" }) }),
            /* @__PURE__ */ x.jsxs(tn.Content, { children: [
              /* @__PURE__ */ x.jsx(
                j4,
                {
                  hasExampleData: A != null,
                  hasCachedData: w != null,
                  showPrefilledData: g,
                  hideTopMargin: !0
                }
              ),
              /* @__PURE__ */ x.jsx("div", { ref: a })
            ] }),
            /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: () => {
                    m(!1), c.current?.();
                  },
                  variant: "text",
                  style: { marginRight: "auto" },
                  children: "Reset"
                }
              ),
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: () => o(!1),
                  variant: "secondary",
                  children: "Close"
                }
              ),
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: () => l.current?.submit(),
                  variant: "primary",
                  children: "Start Instance"
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
), eGt = q.div`
  display: flex;
  min-height: var(--cds-layout-size-height-md);
  justify-content: space-between;
`, tGt = q.div`
  display: flex;
  flex-direction: column;
`, nGt = q(ja)`
  display: flex;
  width: fit-content;
`, iGt = q.div`
  width: 40%;
  min-width: fit-content;
  margin-left: var(--cds-spacing-05);
  display: flex;
  justify-content: end;
  align-items: start;
  > * {
    width: max-content;
  }
`, L_e = "camundaModeler:exampleOutputJson";
function rGt(r, e) {
  if (!Em(e))
    return !1;
  const t = an(r);
  if (lh(t) === e)
    return !1;
  const n = sGt(t), i = oGt(n), s = i.properties.find(
    (o) => o.name === L_e
  );
  if (s)
    s.value = e;
  else {
    const o = i.$model.create("zeebe:Property", {
      name: L_e,
      value: e
    });
    o.$parent = i, i.properties.push(o);
  }
  return !0;
}
function sGt(r) {
  let e = r.get("extensionElements");
  return e === void 0 && (e = r.$model.create("bpmn:ExtensionElements", {
    values: []
  }), e.$parent = r, r.extensionElements = e), e;
}
function oGt(r) {
  let e = r.get("values").find((t) => t.$type === "zeebe:Properties");
  return e || (e = r.$model.create("zeebe:Properties", {
    properties: []
  }), e.$parent = r, r.values.push(e)), e;
}
const MH = rt(
  ({
    isValid: r,
    editedValue: e,
    element: t,
    onSuccess: n,
    tooltipTextForInvalid: i = "Please enter valid JSON to save"
  }) => {
    const [s, o] = ye("initial"), a = bn(Cr)?.switchToImplementMode, l = lh(t), c = !r || e === "" || e === l, d = l !== void 0 ? "Update example data" : "Save example data";
    let u;
    r ? c && (u = "Please make changes to the example data to save") : u = i;
    const f = async () => {
      const p = rGt(t, e), g = await kt.updateFile();
      p && g.success ? (o("success"), n()) : p && !g.success && g.reason === "conflict" ? o("conflict") : o("error");
    };
    return kt.canUserSaveExampleData ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsxs(eGt, { children: [
        /* @__PURE__ */ x.jsxs(tGt, { children: [
          /* @__PURE__ */ x.jsx("div", { children: "Save these variables as example data in the BPMN file for collaborative reuse" }),
          /* @__PURE__ */ x.jsx(
            nGt,
            {
              href: "https://docs.camunda.io/docs/components/modeler/data-handling/",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Learn more"
            }
          )
        ] }),
        /* @__PURE__ */ x.jsx(iGt, { children: s === "success" ? /* @__PURE__ */ x.jsx(
          UT,
          {
            description: "Saved successfully",
            status: "finished",
            onSuccess: () => {
              o("initial");
            }
          }
        ) : c ? /* @__PURE__ */ x.jsx(ew, { align: "bottom-right", label: u, children: /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(
          Rn,
          {
            kind: "tertiary",
            size: "md",
            onClick: f,
            disabled: c,
            children: d
          }
        ) }) }) : /* @__PURE__ */ x.jsx(Rn, { kind: "tertiary", size: "md", onClick: f, children: d }) })
      ] }),
      s === "conflict" && /* @__PURE__ */ x.jsx(
        Hf,
        {
          inline: !0,
          kind: "error",
          lowContrast: !0,
          hideCloseButton: !0,
          statusIconDescription: "notification",
          subtitle: "Example data could not be saved. The diagram has been updated by another user. Got to Implement tab to see the latest version.",
          title: "File Conflict:",
          onActionButtonClick: () => {
            a?.(!1);
          },
          actionButtonLabel: "Go to Implement"
        }
      ),
      s === "error" && /* @__PURE__ */ x.jsx(
        qT,
        {
          kind: "error",
          lowContrast: !0,
          hideCloseButton: !0,
          statusIconDescription: "notification",
          subtitle: "An unknown error occurred. Please try again later",
          title: "Unknown Error:"
        }
      )
    ] }) : null;
  }
), aGt = q.div`
  display: flex;
  align-items: center;
  color: var(
    --cds-text-secondary,
    #525252
  ); // revisit after https://github.com/camunda/play/issues/143
  min-height: var(
    --cds-spacing-06,
    1.5rem
  ); // revisit after https://github.com/camunda/play/issues/143

  svg {
    fill: var(--cds-icon-secondary);
    margin-right: var(
      --cds-spacing-02,
      0.25rem
    ); // revisit after https://github.com/camunda/play/issues/143
  }
`, DH = ({
  originalSource: r,
  isDescriptionVisible: e
}) => {
  if (r === "none")
    return null;
  let t = "";
  return r === "bpmn" ? t = "Prefilled from the BPMN’s example data" : r === "cache" && (t = "Prefilled from a previous session"), /* @__PURE__ */ x.jsx(aGt, { children: e ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(uI, {}),
    t
  ] }) : null });
}, k_e = (r) => Em(r) || r === "", XBe = ({
  title: r,
  isVisible: e,
  primaryButtonLabel: t,
  onClose: n,
  onSubmit: i,
  element: s
}) => {
  const [o, a] = ye(!0), { prefillData: l, originalDataSource: c } = S3(
    s,
    o
  ), [d, u] = ye(l), [f, p] = ye(c), g = k_e(d), [m, A] = ye(!1), w = oMe(s);
  return Pe(() => {
    u(l), p(c);
  }, [c, l]), /* @__PURE__ */ x.jsx(
    Ww,
    {
      hasResetButton: !0,
      placeholder: fw,
      title: r,
      isVisible: e,
      onClose: n,
      onSubmit: i,
      clearOnReset: !1,
      onReset: () => {
        a(!1);
        const { prefillData: v, originalDataSource: y } = S3(
          s,
          !1
        );
        u(v), p(y), A(!1);
      },
      value: d,
      primaryButtonLabel: t,
      secondaryButtonLabel: "Cancel",
      isValidInput: (v) => k_e(v),
      onChange: (v) => {
        u(v), A(!0);
      },
      editorTopContent: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        !w && /* @__PURE__ */ x.jsx(
          MH,
          {
            isValid: g,
            editedValue: d,
            element: s,
            onSuccess: () => {
              p("bpmn"), A(!1);
            }
          }
        ),
        /* @__PURE__ */ x.jsx(
          DH,
          {
            originalSource: f,
            isDescriptionVisible: !m
          }
        )
      ] }),
      hasJSONObjectValidation: !0
    }
  );
}, lGt = rt(
  ({ element: r, isRestartMode: e }) => {
    const t = bn(Cr), { definitions: n, elementsById: i } = mi.state, [s, o] = ye(!1), a = An(), l = An(), [c, d] = ye(!1), [u, f] = ye(!1), [p, g] = ye(!1), [m, A] = ye(""), [w, v] = ye(!1), [y, _] = ye("none");
    async function S(j) {
      const { data: pe, errors: De } = j ?? { data: {}, errors: {} };
      if (Object.keys(De).length === 0) {
        d(!0), localStorage.setItem(
          `jobCompletion ${kt.processId} ${r.id}`,
          JSON.stringify(pe)
        );
        const Ce = await t.startInstance?.(JSON.stringify(pe));
        o(!1), Ce ? (t.displayNotification?.success({
          title: vd
        }), $i.trackUserCompletesElement(
          r,
          JSON.stringify(pe)
        )) : t.displayNotification?.error(Mi);
      }
    }
    const T = i?.[r.id]?.get("extensionElements")?.get("values")?.find((j) => j.$type === "zeebe:formDefinition")?.formKey, N = (n ? tMe(n) : void 0)?.get("extensionElements")?.get("values")?.find(
      //@ts-expect-error Parameter 'elem' implicitly has an 'any' type.ts(7006)
      (j) => j.$type === "zeebe:userTaskForm" && T?.includes(j.id)
    )?.$body, R = Bxe(() => {
      let j = {};
      if (!N)
        return j;
      try {
        j = JSON.parse(N ?? "");
      } catch (pe) {
        console.error("Failed to parse form:", pe);
      }
      return j;
    }, [N]), H = e ? L7 : N ? D7 : yMe, z = ds(async () => {
      const j = lh(r), pe = localStorage.getItem(
        `jobCompletion ${kt.processId} ${r.id}`
      ), De = JSON.parse(pe || "{}");
      return {
        variablesFromExampleData: JSON.parse(j || "{}"),
        cachedVariables: De
      };
    }, [r]), U = ds(async () => {
      let j;
      try {
        j = await z();
      } catch (Y) {
        console.error("Failed to parse variables:", Y);
      }
      if (!j)
        return;
      const { variablesFromExampleData: pe, cachedVariables: De } = j, Ce = {
        ...pe,
        ...De
      };
      let F = "none";
      Ar(Ce, pe) ? F = "bpmn" : Ar(Ce, De) && (F = "cache"), _(F);
      const I = new nw();
      l.current = I, I.attachTo(a.current);
      const { warnings: O } = await I.importSchema(
        R,
        Ce
      );
      v(O.length === 0), A(JSON.stringify(Ce)), I.on(
        "changed",
        ({ data: Y, errors: K }) => {
          const ae = localStorage.getItem(
            `jobCompletion ${kt.processId} ${r.id}`
          ), Oe = !Ar(Y, JSON.parse(lh(r) || "{}")) && !Ar(Y, JSON.parse(ae || "{}"));
          g(Oe), A(JSON.stringify(Y)), v(Object.keys(K).length === 0);
        }
      );
    }, [r, R, z]), ee = async () => {
      if (!l.current)
        return;
      let j;
      try {
        j = await z();
      } catch (F) {
        console.error("Failed to parse variables:", F);
      }
      if (!j)
        return;
      const { variablesFromExampleData: pe } = j, De = {
        ...pe
      };
      _(De ? "bpmn" : "none");
      const { warnings: Ce } = await l.current?.importSchema(
        R,
        De
      ) ?? { warnings: [] };
      g(!1), A(JSON.stringify(De)), v(Ce.length === 0);
    };
    Pe(() => {
      a.current && (async () => await U())();
    }, [s, U]);
    const { prefillData: ce, originalDataSource: se } = S3(r, !0), te = se === "bpmn" ? "Start instance with example data" : se === "cache" ? "Start instance with cached data" : "Start instance";
    let ue = "Restart process";
    se === "bpmn" && !N ? ue = "Restart process with example data" : se === "cache" && !N && (ue = "Restart process with cached data");
    const G = [
      {
        label: e ? ue : N ? "Open Start Form" : te,
        //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
        renderIcon: () => /* @__PURE__ */ x.jsx(H, { color: "white" }),
        onClick: async () => {
          if (N)
            o(!0);
          else {
            if (d(!0), !(await t.startInstance?.(ce || "{}") ?? !1)) {
              t.displayNotification?.error(Mi), d(!1);
              return;
            }
            $i.trackUserCompletesElement(r, ce);
            let pe;
            se === "bpmn" ? pe = " with example data" : se === "cache" && (pe = " with cached data"), t.displayNotification?.success({
              title: vd,
              subtitle: pe
            });
          }
        }
      },
      {
        label: "Edit variables and start instance",
        onClick: () => {
          f(!0);
        }
      }
    ];
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(bc, { disabled: c, actions: G }),
      /* @__PURE__ */ x.jsx(
        XBe,
        {
          title: "Start instance with variables",
          isVisible: u,
          primaryButtonLabel: "Create new instance",
          onClose: () => f(!1),
          onSubmit: async (j) => {
            if (f(!1), d(!0), !await t.startInstance?.(j)) {
              t.displayNotification?.error(Mi), d(!1);
              return;
            }
            $i.trackUserCompletesElement(
              r,
              j
            ), localStorage.setItem(
              `jobCompletion ${kt.processId} ${r.id}`,
              j ?? ""
            ), t.displayNotification?.success({
              title: vd
            });
          },
          element: r
        }
      ),
      /* @__PURE__ */ x.jsxs(
        tn,
        {
          open: s,
          onClose: () => o(!1),
          "data-testid": "start-form-dialog",
          children: [
            /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Start Form" }) }),
            /* @__PURE__ */ x.jsx(tn.Content, { children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
              /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
                /* @__PURE__ */ x.jsx(
                  MH,
                  {
                    isValid: w,
                    editedValue: m,
                    element: r,
                    onSuccess: () => {
                      g(!1), _("bpmn");
                    },
                    tooltipTextForInvalid: "Please enter valid data to save"
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  DH,
                  {
                    originalSource: y,
                    isDescriptionVisible: !p
                  }
                )
              ] }),
              /* @__PURE__ */ x.jsx("div", { ref: a })
            ] }) }),
            /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: ee,
                  variant: "text",
                  style: { marginRight: "auto" },
                  children: "Reset"
                }
              ),
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: () => o(!1),
                  variant: "secondary",
                  children: "Close"
                }
              ),
              /* @__PURE__ */ x.jsx(
                ji,
                {
                  onClick: () => S(l.current?.submit()),
                  variant: "primary",
                  children: "Start Instance"
                }
              )
            ] })
          ]
        }
      )
    ] });
  }
), cGt = rt(({ childInstance: r }) => {
  const { deployedFiles: e, endpoint: t } = kt.state;
  return /* @__PURE__ */ x.jsx(
    bc,
    {
      actions: [
        {
          kind: r.state === "COMPLETED" ? "secondary" : "primary",
          label: "View called process",
          renderIcon: () => /* @__PURE__ */ x.jsx(S7, { color: "white" }),
          onClick: () => {
            const n = r.process.bpmnProcessId, i = e?.find(
              (c) => c.id === n
            );
            if (i === void 0)
              return;
            const { fileId: s, filename: o, playId: a } = i, l = window.location.origin + "/diagrams/" + iIe(s, o);
            if (localStorage.setItem(
              "play-directAccess",
              JSON.stringify({
                endpoint: t,
                deployedFiles: e,
                definition: a,
                instance: r.key
              })
            ), r.state !== "COMPLETED") {
              const c = JSON.parse(
                localStorage.getItem("play-calledProcesses") || "[]"
              );
              c.push(r.key), localStorage.setItem(
                "play-calledProcesses",
                JSON.stringify(c)
              );
            }
            window.open(l, "_blank").focus();
          }
        }
      ]
    }
  );
}), N_e = q(In)`
  /* background-inverse */
  background-color: #393939;
  /* text-on-color */
  color: #fff;
  padding: 4px 8px 4px 4px;
  border-radius: 24px;
  align-items: center;
`, T_e = q(_7)`
  /* support-success */
  fill: #24a148;
`, hGt = q(Yxe)`
  justify-content: flex-end;
`, dGt = q.div`
  /* Body styles/body-01 */
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.16px;

  font-weight: 700;
`, uGt = q.div`
  /* Body styles/body-01 */
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.16px;
`, fGt = rt(() => {
  const { isCalledProcess: r, processInstance: e } = Kt.state, t = e?.key;
  return Pe(() => {
    if (r) {
      const n = JSON.parse(
        localStorage.getItem("play-calledProcesses") || "[]"
      );
      localStorage.setItem(
        "play-calledProcesses",
        JSON.stringify(
          n.filter((i) => i !== t)
        )
      );
    }
  }, [r, t]), r ? /* @__PURE__ */ x.jsxs(Xxe, { defaultOpen: r, align: "left", children: [
    /* @__PURE__ */ x.jsxs(N_e, { orientation: "horizontal", gap: 2, children: [
      /* @__PURE__ */ x.jsx(T_e, {}),
      /* @__PURE__ */ x.jsx("div", { children: "Completed" })
    ] }),
    /* @__PURE__ */ x.jsxs(Jxe, { children: [
      /* @__PURE__ */ x.jsx(dGt, { children: "Called process completed" }),
      /* @__PURE__ */ x.jsx(uGt, { children: "You may close this browser tab and return to the previous process instance" }),
      /* @__PURE__ */ x.jsx(hGt, { children: /* @__PURE__ */ x.jsx(
        Rn,
        {
          size: "sm",
          onClick: () => {
            window.close();
          },
          children: "Close tab"
        }
      ) })
    ] })
  ] }) : /* @__PURE__ */ x.jsxs(N_e, { orientation: "horizontal", gap: 2, children: [
    /* @__PURE__ */ x.jsx(T_e, {}),
    /* @__PURE__ */ x.jsx("div", { children: "Completed" })
  ] });
}), pGt = rt(({ element: r, incident: e }) => {
  const t = bn(Cr), [n, i] = ye(!1), { processInstance: s } = Kt.state, o = t.featureFlags.areAIFeaturesEnabled, a = o, l = a || t.isUserOrgOwnerOrAdmin;
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      bc,
      {
        actions: [
          {
            label: "View Incident",
            kind: "danger",
            renderIcon: () => /* @__PURE__ */ x.jsx(gI, {}),
            onClick: () => {
              i(!0);
            }
          }
        ]
      }
    ),
    /* @__PURE__ */ x.jsx(
      jy,
      {
        title: "View incident",
        isVisible: n,
        primaryButtonLabel: "Retry incident",
        secondaryButton: {
          label: a ? "Copy and ask AI" : "Enable incident copilot",
          id: o ? "camunda-ai-button" : void 0,
          icon: /* @__PURE__ */ x.jsx(cdt, {}),
          disabled: !l,
          title: l ? void 0 : "Contact your admin to enable this feature",
          onClick: () => {
            o ? (navigator.clipboard.writeText(
              `I got this incident. What does it mean, what is the root cause, and how do I fix it in Play? 
Error type: ${e.errorType} 
Error message: ${e.errorMessage}`
            ), t.displayNotification?.info({
              title: "AI prompt copied. Paste in the text area to continue."
            }), i(!1)) : window.open(`${t.organizationManagementPageUrl}/settings`), $i.trackIncidentAIModalOpened({
              areAIFeaturesEnabled: o
            });
          }
        },
        ghostButton: {
          label: "Cancel",
          onClick: () => i(!1)
        },
        onClose: () => i(!1),
        onSubmit: async () => {
          if (i(!1), e.job?.key && !await uf.updateRetries({
            jobKey: e.job.key
          })) {
            t.displayNotification?.error(Mi);
            return;
          }
          $i.trackResolveIncident(kt.processId), (await uf.resolveIncident({
            incidentKey: e.key
          }))?.success === !1 ? t.displayNotification?.error(Mi) : s !== void 0 && is(Lr(s.key), {
            action: "resolveIncident",
            elementId: r.id,
            hasJob: !!e.job?.key
          });
        },
        modalBody: /* @__PURE__ */ x.jsx(Wg, { children: /* @__PURE__ */ x.jsx(s7, { copyButtonDescription: "Copy", type: "multi", wrapText: !0, children: e.errorMessage }) })
      }
    )
  ] });
}), gGt = rt(({ element: r }) => {
  const e = bn(Cr), [t, n] = ye(!1), [i, s] = ye(!1), { instanceKey: o, processInstance: a } = Kt.state, l = ts.state.jobs.find(
    (c) => c.elementInstance.element.elementId === r.id && c.state === "ACTIVATABLE"
  );
  return Pe(() => {
    s(!1);
  }, [l]), !o || !l ? null : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      bc,
      {
        disabled: i,
        actions: [
          {
            label: "Invoke connector",
            renderIcon: () => /* @__PURE__ */ x.jsx(x7, { color: "white" }),
            onClick: async () => {
              s(!0);
              const c = await e.invokeConnector?.(
                l.jobType,
                l.key
              );
              c && a !== void 0 && is(
                Lr(a.key),
                {
                  action: "invokeConnector",
                  elementId: r.id
                }
              ), c || (e.displayNotification?.error(Mi), s(!1));
            }
          },
          {
            label: "Complete job with variables",
            onClick: () => {
              n(!0);
            }
          }
        ]
      }
    ),
    /* @__PURE__ */ x.jsx(
      Ww,
      {
        title: "Complete job with variables",
        isVisible: t,
        primaryButtonLabel: "Complete job",
        secondaryButtonLabel: "Cancel",
        hasResetButton: !0,
        hasJSONObjectValidation: !0,
        isValidInput: Em,
        onClose: () => n(!1),
        onSubmit: async (c) => {
          n(!1), s(!0);
          const d = await ts.completeJob({
            jobKey: l.key,
            variables: c
          });
          d && a !== void 0 && is(Lr(a.key), {
            action: "completeJob",
            type: "serviceTask",
            elementId: r.id,
            variables: c ?? void 0
          }), d || e.displayNotification?.error(Mi);
        },
        placeholder: fw
      }
    )
  ] });
}), mGt = rt(({ element: r }) => {
  const { takenSequenceFlows: e, completedElementInstances: t } = Ro, { elementRegistry: n } = mi.state;
  return Pe(() => {
    if (n !== void 0)
      return e.some((i) => i.element.elementId === r.id) || r?.di?.bpmnElement?.sourceRef?.$type === "bpmn:EventBasedGateway" && t.some(
        (i) => i.element.elementId === r.di.bpmnElement.targetRef.id
      ) ? mi.state.viewer?.addMarker(
        r.id,
        "play-sequence-flow-taken"
      ) : mi.state.viewer?.removeMarker(
        r.id,
        "play-sequence-flow-taken"
      ), () => {
        mi.state.viewer?.removeMarker(
          r.id,
          "play-sequence-flow-taken"
        );
      };
  }, [e, n, r, t]), null;
}), AGt = q.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff1f1;
  border: 1px solid #da1e28;
  height: 3rem;
  padding: 1rem;
  width: 100%;
  gap: 1rem;
`;
function wGt(r) {
  const e = r.businessObject.$type;
  return e === "bpmn:IntermediateThrowEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message throw event" : e === "bpmn:EndEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message end event" : e.split(":")[1].split(/(?=[A-Z])/).map((i) => i.toLowerCase()).join(" ");
}
function US(r, e) {
  const t = wGt(r), n = {
    title: `"${r.businessObject.name || r.businessObject.id}" ${t} completed manually`
  };
  e.displayNotification?.success(n);
}
const vGt = rt(({ element: r }) => {
  const e = bn(Cr), [t, n] = ye(!1), [i, s] = ye(!1), o = An(), a = An(), l = An(), [c, d] = ye(!1), [u, f] = ye(""), [p, g] = ye(!1), [m, A] = ye(!1), [w, v] = ye(!0), { instanceKey: y, processInstance: _ } = Kt.state, S = ts.state.jobs.find(
    (U) => U.elementInstance.element.elementId === r.id && U.state === "ACTIVATABLE"
  ), D = D3.state.userTasks?.find(
    (U) => U.elementInstance.element.elementId === r.id && U.state === "CREATED"
  ), M = S || D;
  Pe(() => {
    g(!1);
  }, [M]), Pe(() => {
    !i && !t && v(!0);
  }, [i, t]);
  const L = D?.form?.resource, T = L ? D7 : Qg, B = lh(r), V = localStorage.getItem(
    `jobCompletion ${kt.processId} ${r.id}`
  );
  async function N(U, { data: ee, errors: ce }) {
    if (Object.keys(ce).length === 0) {
      g(!0), n(!1);
      const se = await ts.completeJob({
        jobKey: M?.key,
        variables: JSON.stringify(ee)
      });
      se && _ !== void 0 && is(Lr(_.key), {
        action: "completeJob",
        type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
        elementId: r.id,
        variables: JSON.stringify(ee)
      }), se ? US(r, e) : e.displayNotification?.error(Mi), localStorage.setItem(
        `jobCompletion ${kt.processId} ${r.id}`,
        JSON.stringify(ee)
      );
    }
  }
  const R = async () => {
    const { variables: U } = await _t.fetchVariablesByUserTask({
      userTask: M?.key
    });
    if (U === void 0) {
      A(!0);
      return;
    }
    const ee = U.reduce(
      (j, { name: pe, value: De }) => (j[pe] = JSON.parse(De), j),
      {}
    ), ce = JSON.parse(V || "{}"), se = JSON.parse(B || "{}"), te = {
      ...ee,
      ...ce,
      ...se
    }, ue = JSON.parse(L ?? ""), G = new nw();
    a.current = G, G.attachTo(o.current), G.importSchema(ue, te), G.on("submit", N), l.current = () => {
      a.current.importSchema(ue, ee);
    };
  };
  if (Pe(() => {
    o.current && R();
  }, [t]), !y || !M)
    return null;
  const H = mi.getAvailableErrorEvents(r), z = [
    {
      label: L ? "Open Task Form" : "Complete Job",
      renderIcon: () => /* @__PURE__ */ x.jsx(T, { color: "white" }),
      onClick: async () => {
        if (L)
          n(!0);
        else {
          g(!0);
          const U = await ts.completeJob({
            jobKey: M.key
          });
          U && _ !== void 0 && is(Lr(_.key), {
            action: "completeJob",
            type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
            elementId: r.id
          }), U ? US(r, e) : e.displayNotification?.error(Mi);
        }
      }
    },
    {
      label: "Complete job with variables",
      onClick: () => {
        s(!0);
      }
    }
  ];
  return S && z.push(
    {
      //@ts-expect-error Object literal may only specify known properties, and 'type' does not exist in type '{ label: string; renderIcon: () => Element; onClick: () => Promise<void>; } | { label: string; onClick: () => void; renderIcon?: undefined; }'.ts(2353)
      type: "divider",
      label: "divider"
    },
    {
      label: "Throw Error",
      onClick: () => {
        f(""), d(!0);
      }
    }
  ), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(bc, { disabled: p, actions: z }),
    /* @__PURE__ */ x.jsx(
      Ww,
      {
        title: "Complete job with variables",
        editorTopContent: /* @__PURE__ */ x.jsx(
          j4,
          {
            hasExampleData: B != null,
            showPrefilledData: w
          }
        ),
        isVisible: i,
        primaryButtonLabel: "Complete job",
        secondaryButtonLabel: "Cancel",
        hasResetButton: !0,
        hasJSONObjectValidation: !0,
        isValidInput: Em,
        onClose: () => s(!1),
        value: B,
        onReset: () => {
          v(!1);
        },
        onSubmit: async (U) => {
          s(!1), g(!0);
          const ee = await ts.completeJob({
            jobKey: M.key,
            variables: U
          });
          ee && _ !== void 0 && is(Lr(_.key), {
            action: "completeJob",
            type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
            elementId: r.id,
            variables: U ?? void 0
          }), ee ? US(r, e) : e.displayNotification?.error(Mi);
        },
        placeholder: fw
      }
    ),
    /* @__PURE__ */ x.jsxs(
      tn,
      {
        open: c,
        onClose: () => d(!1),
        children: [
          /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Throw Error" }) }),
          /* @__PURE__ */ x.jsx(tn.Content, { children: /* @__PURE__ */ x.jsx($4, { children: /* @__PURE__ */ x.jsx(In, { gap: 7, children: /* @__PURE__ */ x.jsx(
            tw,
            {
              titleText: "Error",
              id: "error",
              "aria-label": "Select an Error",
              items: H.map(({ errorCode: U, errorName: ee }) => ({
                id: U,
                label: ee
              })),
              onChange: ({ selectedItem: U }) => {
                f(U?.id);
              }
            }
          ) }) }) }),
          /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: () => d(!1),
                variant: "secondary",
                children: "Close"
              }
            ),
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: async () => {
                  d(!1), g(!0);
                  const U = await ts.throwError({
                    jobKey: M.key,
                    errorCode: u
                  });
                  if (U && _ !== void 0) {
                    is(
                      Lr(_.key),
                      {
                        action: "throwJob",
                        elementId: r.id,
                        errorCode: u
                      }
                    );
                    const ee = H.find(
                      (ce) => ce.errorCode === u
                    )?.errorElementId;
                    e.displayNotification?.success(
                      {
                        title: `"${ee}" manually triggered with error code "${u}"`
                      },
                      {
                        action: {
                          label: "Learn more",
                          onClick: () => {
                            window.open(
                              "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
                              "_blank"
                            );
                          }
                        }
                      }
                    );
                  }
                  U || e.displayNotification?.error(Mi);
                },
                variant: "primary",
                children: "Fail"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ x.jsxs(tn, { open: t, onClose: () => n(!1), children: [
      /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Task Form" }) }),
      /* @__PURE__ */ x.jsx(tn.Content, { children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(
          j4,
          {
            hasExampleData: B != null,
            hasCachedData: V != null,
            showPrefilledData: w,
            hideTopMargin: !0
          }
        ),
        m && /* @__PURE__ */ x.jsxs(AGt, { children: [
          "We were unable to load the form",
          /* @__PURE__ */ x.jsx(
            Rn,
            {
              kind: "tertiary",
              size: "sm",
              renderIcon: uw,
              onClick: () => {
                A(!1), R();
              },
              children: "Retry"
            }
          )
        ] }),
        /* @__PURE__ */ x.jsx("div", { ref: o })
      ] }) }),
      /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
        /* @__PURE__ */ x.jsx(
          ji,
          {
            onClick: () => {
              v(!1), l.current?.();
            },
            variant: "text",
            style: { marginRight: "auto" },
            children: "Reset"
          }
        ),
        /* @__PURE__ */ x.jsx(ji, { onClick: () => n(!1), variant: "secondary", children: "Close" }),
        /* @__PURE__ */ x.jsx(ji, { onClick: () => a.current?.submit(), variant: "primary", children: "Complete" })
      ] })
    ] })
  ] });
}), bGt = q.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff1f1;
  border: 1px solid #da1e28;
  height: 3rem;
  padding: 1rem;
  width: 100%;
  gap: 1rem;
`;
function yGt(r) {
  const e = r.businessObject.$type;
  return e === "bpmn:IntermediateThrowEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message throw event" : e === "bpmn:EndEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message end event" : e.split(":")[1].split(/(?=[A-Z])/).map((i) => i.toLowerCase()).join(" ");
}
function qS(r, e, t) {
  const n = yGt(r), i = {
    title: `"${r.businessObject.name || r.businessObject.id}" ${n} completed manually`,
    subtitle: t
  };
  e.displayNotification?.success(i);
}
const CGt = rt(({ element: r }) => {
  const e = bn(Cr), [t, n] = ye(!1), [i, s] = ye(!1), o = An(), a = An(), [l, c] = ye(!1), [d, u] = ye(""), [f, p] = ye(!1), [g, m] = ye(!1), { instanceKey: A, processInstance: w } = Kt.state, [v, y] = ye(!1), [_, S] = ye(!1), [D, M] = ye("none"), [L, T] = ye(""), B = ts.state.jobs.find(
    (Ce) => Ce.elementInstance.element.elementId === r.id && Ce.state === "ACTIVATABLE"
  ), V = D3.state.userTasks?.find(
    (Ce) => Ce.elementInstance.element.elementId === r.id && Ce.state === "CREATED"
  ), N = B || V;
  Pe(() => {
    p(!1);
  }, [N]), Pe(() => {
    const Ce = lh(r), F = localStorage.getItem(
      `jobCompletion ${kt.processId} ${r.id}`
    ), I = JSON.parse(F || "{}"), O = JSON.parse(Ce || "{}"), Y = D === "bpmn" && Ar(JSON.parse(L), O), K = D === "cache" && Ar(JSON.parse(L), I);
    y(!Y && !K);
  }, [L, r, D]);
  const R = V?.form?.resource, H = Bxe(() => {
    let Ce = {};
    if (!R)
      return Ce;
    try {
      Ce = JSON.parse(R ?? "");
    } catch (F) {
      console.error("Failed to parse form:", F);
    }
    return Ce;
  }, [R]), z = R ? D7 : Qg;
  async function U(Ce) {
    const { data: F, errors: I } = Ce ?? { data: {}, errors: {} };
    if (Object.keys(I).length === 0) {
      p(!0), n(!1);
      const O = await ts.completeJob({
        jobKey: N?.key,
        variables: JSON.stringify(F)
      });
      O && w !== void 0 && (is(Lr(w.key), {
        action: "completeJob",
        type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
        elementId: r.id,
        variables: JSON.stringify(F)
      }), $i.trackUserCompletesElement(
        r,
        JSON.stringify(F)
      )), O ? qS(r, e) : e.displayNotification?.error(Mi), localStorage.setItem(
        `jobCompletion ${kt.processId} ${r.id}`,
        JSON.stringify(F)
      );
    }
  }
  const ee = ds(async () => {
    const { variables: Ce } = await _t.fetchVariablesByUserTask({
      userTask: N?.key
    });
    if (Ce === void 0) {
      m(!0);
      return;
    }
    const F = Ce.reduce(
      (ae, { name: Oe, value: ot }) => (ae[Oe] = JSON.parse(ot), ae),
      {}
    ), I = lh(r), O = localStorage.getItem(
      `jobCompletion ${kt.processId} ${r.id}`
    ), Y = JSON.parse(O || "{}");
    return {
      variablesFromExampleData: JSON.parse(I || "{}"),
      cachedVariables: Y,
      processVariables: F
    };
  }, [r, N]), ce = ds(async () => {
    let Ce;
    try {
      Ce = await ee();
    } catch (Mn) {
      console.error("could not fetch variables", Mn), m(!0);
      return;
    }
    if (!Ce)
      return;
    const { variablesFromExampleData: F, cachedVariables: I, processVariables: O } = Ce, Y = {
      ...F,
      ...I,
      ...O
    }, K = dM(H), ae = se(Y, K);
    let Oe = "none";
    Ar(ae, F) ? Oe = "bpmn" : Ar(ae, I) && (Oe = "cache"), M(Oe), T(JSON.stringify(ae)), y(!1);
    const ot = new nw();
    a.current = ot;
    const { warnings: It } = await ot.importSchema(H, ae);
    ot.attachTo(o.current), S(It.length === 0), ot.on(
      "changed",
      ({ data: Mn, errors: Ii }) => {
        T(JSON.stringify(Mn)), S(Object.keys(Ii).length === 0);
      }
    );
  }, [ee, H]), se = (Ce, F) => F.reduce((I, O) => (O in Ce && (I[O] = Ce[O]), I), {}), te = async () => {
    if (!a.current)
      return;
    let Ce;
    try {
      Ce = await ee();
    } catch (Oe) {
      console.error("could not fetch variables", Oe), m(!0);
      return;
    }
    if (!Ce)
      return;
    const { variablesFromExampleData: F, processVariables: I } = Ce, O = dM(H), Y = {
      ...F,
      ...I
    }, K = se(Y, O);
    F && Ar(K, F) ? M("bpmn") : M("none"), y(!1), T(JSON.stringify(K));
    const { warnings: ae } = await a.current?.importSchema(
      H,
      K
    ) ?? { warnings: [] };
    S(ae.length === 0);
  };
  if (Pe(() => {
    o.current && ce();
  }, [ce, t]), !A || !N)
    return null;
  const ue = mi.getAvailableErrorEvents(r), { prefillData: G, originalDataSource: j } = S3(r, !0), De = [
    {
      label: R ? "Open Task Form" : j === "bpmn" ? "Complete job with example data" : j === "cache" ? "Complete job with cached data" : "Complete job",
      renderIcon: () => /* @__PURE__ */ x.jsx(z, { color: "white" }),
      onClick: async () => {
        if (R)
          n(!0);
        else {
          p(!0);
          const Ce = await ts.completeJob({
            jobKey: N.key,
            variables: G
          });
          if (Ce && w !== void 0 && (is(Lr(w.key), {
            action: "completeJob",
            type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
            elementId: r.id,
            variables: G ?? void 0
          }), $i.trackUserCompletesElement(r, G)), !Ce)
            e.displayNotification?.error(Mi);
          else {
            let F;
            j === "bpmn" && (F = "with example data"), j === "cache" && (F = "with cached data"), qS(r, e, F);
          }
        }
      }
    },
    {
      label: "Edit variables and complete job",
      onClick: () => {
        s(!0);
      }
    }
  ];
  return B && De.push(
    {
      //@ts-expect-error Object literal may only specify known properties, and 'type' does not exist in type '{ label: string; renderIcon: () => Element; onClick: () => Promise<void>; } | { label: string; onClick: () => void; renderIcon?: undefined; }'.ts(2353)
      type: "divider",
      label: "divider"
    },
    {
      label: "Throw Error",
      onClick: () => {
        u(""), c(!0);
      }
    }
  ), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(bc, { disabled: f, actions: De }),
    /* @__PURE__ */ x.jsx(
      XBe,
      {
        title: "Complete job with variables",
        isVisible: i,
        primaryButtonLabel: "Complete job",
        onClose: () => s(!1),
        element: r,
        onSubmit: async (Ce) => {
          s(!1), p(!0);
          const F = await ts.completeJob({
            jobKey: N.key,
            variables: Ce
          });
          F && w !== void 0 && (is(Lr(w.key), {
            action: "completeJob",
            type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
            elementId: r.id,
            variables: Ce ?? void 0
          }), $i.trackUserCompletesElement(
            r,
            Ce
          ), localStorage.setItem(
            `jobCompletion ${kt.processId} ${r.id}`,
            Ce ?? ""
          )), F ? qS(r, e) : e.displayNotification?.error(Mi);
        }
      }
    ),
    /* @__PURE__ */ x.jsxs(
      tn,
      {
        open: l,
        onClose: () => c(!1),
        children: [
          /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Throw Error" }) }),
          /* @__PURE__ */ x.jsx(tn.Content, { children: /* @__PURE__ */ x.jsx($4, { children: /* @__PURE__ */ x.jsx(In, { gap: 7, children: /* @__PURE__ */ x.jsx(
            tw,
            {
              titleText: "Error",
              id: "error",
              "aria-label": "Select an Error",
              items: ue.map(({ errorCode: Ce, errorName: F }) => ({
                id: Ce,
                label: F
              })),
              onChange: ({ selectedItem: Ce }) => {
                u(Ce?.id);
              }
            }
          ) }) }) }),
          /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: () => c(!1),
                variant: "secondary",
                children: "Close"
              }
            ),
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: async () => {
                  c(!1), p(!0);
                  const Ce = await ts.throwError({
                    jobKey: N.key,
                    errorCode: d
                  });
                  if (Ce && w !== void 0) {
                    is(
                      Lr(w.key),
                      {
                        action: "throwJob",
                        elementId: r.id,
                        errorCode: d
                      }
                    );
                    const F = ue.find(
                      (I) => I.errorCode === d
                    )?.errorElementId;
                    e.displayNotification?.success(
                      {
                        title: `"${F}" manually triggered with error code "${d}"`
                      },
                      {
                        action: {
                          label: "Learn more",
                          onClick: () => {
                            window.open(
                              "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
                              "_blank"
                            );
                          }
                        }
                      }
                    );
                  }
                  Ce || e.displayNotification?.error(Mi);
                },
                variant: "primary",
                children: "Fail"
              }
            )
          ] })
        ]
      }
    ),
    /* @__PURE__ */ x.jsxs(
      tn,
      {
        open: t,
        onClose: () => n(!1),
        "data-testid": "user-task-form-modal",
        children: [
          /* @__PURE__ */ x.jsx(tn.Header, { children: /* @__PURE__ */ x.jsx(tn.Title, { children: "Task Form" }) }),
          /* @__PURE__ */ x.jsx(tn.Content, { children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
              /* @__PURE__ */ x.jsx(
                MH,
                {
                  isValid: _,
                  editedValue: L,
                  element: r,
                  onSuccess: () => {
                    y(!1), M("bpmn");
                  },
                  tooltipTextForInvalid: "Please enter valid data to save"
                }
              ),
              /* @__PURE__ */ x.jsx(
                DH,
                {
                  originalSource: D,
                  isDescriptionVisible: !v
                }
              )
            ] }),
            g && /* @__PURE__ */ x.jsxs(bGt, { children: [
              "We were unable to load the form",
              /* @__PURE__ */ x.jsx(
                Rn,
                {
                  kind: "tertiary",
                  size: "sm",
                  renderIcon: uw,
                  onClick: () => {
                    m(!1), ce();
                  },
                  children: "Retry"
                }
              )
            ] }),
            /* @__PURE__ */ x.jsx("div", { ref: o })
          ] }) }),
          /* @__PURE__ */ x.jsxs(tn.Footer, { children: [
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: te,
                variant: "text",
                style: { marginRight: "auto" },
                children: "Reset"
              }
            ),
            /* @__PURE__ */ x.jsx(ji, { onClick: () => n(!1), variant: "secondary", children: "Close" }),
            /* @__PURE__ */ x.jsx(
              ji,
              {
                onClick: () => U(a.current?.submit()),
                variant: "primary",
                children: "Complete"
              }
            )
          ] })
        ]
      }
    )
  ] });
}), EGt = q(edt)`
  fill: currentColor;
`, _Gt = rt(({ element: r }) => {
  const e = bn(Cr), t = y7.state.definitionMessageSubscriptions, n = (t?.length ?? 0) > 0, i = (C7.state.timers?.length ?? 0) > 0, s = Ro.completedElementInstances.map(
    ({ element: l }) => l
  ) ?? [], { instanceKey: o, processInstance: a } = Kt.state;
  return /* @__PURE__ */ x.jsx(x.Fragment, { children: /* @__PURE__ */ x.jsx(
    bc,
    {
      actions: [
        {
          label: "Rewind",
          kind: "tertiary",
          renderIcon: () => /* @__PURE__ */ x.jsx(EGt, {}),
          onClick: async () => {
            if (e?.rewindProcess === void 0 || a === void 0)
              return;
            e.rewindProcess.startRewinding();
            const {
              handleMessageEvent: l,
              handleTimerEvent: c,
              handleUserTask: d,
              handleConnector: u,
              handleServiceTask: f,
              handleThrowError: p,
              handleFailJob: g,
              handleResolveIncident: m,
              handleSetVariables: A
            } = e.rewindProcess;
            let w;
            if (!n && !i)
              w = await e.rewindProcess.startNewInstance(
                a.startTime
              );
            else if (n) {
              const M = s.find(
                ({ bpmnElementType: T }) => T === "START_EVENT"
              ), L = t?.find(
                ({ element: T }) => T.elementId === M?.elementId
              );
              if (L === void 0)
                w = await e.rewindProcess.startNewInstance(
                  a.startTime
                );
              else {
                const T = await e?.rewindProcess.getScopeVariables({
                  scopeId: M?.elementId,
                  relativeTimestamp: a.startTime
                });
                w = (await e?.publishMessage?.({
                  messageName: L?.messageName,
                  variables: T,
                  isStartEvent: !0
                }))?.instanceId;
              }
            } else if (i) {
              const { timers: M } = await _t.fetchProcessTimers({
                playId: kt.state.playId
              }), L = s.find(
                ({ bpmnElementType: B }) => B === "START_EVENT"
              ), T = M?.find(
                (B) => B.state === "CREATED" && B.element.elementId === L?.elementId
              );
              T === void 0 ? w = await e.rewindProcess.startNewInstance(
                a.startTime
              ) : w = await e?.startNewInstanceWithTimer?.(
                T.dueDate
              );
            }
            if (w === void 0) {
              e.rewindProcess.endRewinding(), e.displayNotification?.error({
                title: "Rewind failed",
                subtitle: "Please try again"
              });
              return;
            }
            $i.trackRewindedInstanceStart(w);
            const v = sut(
              Lr(a.key)
            ), y = [];
            for (const M of v) {
              if (M.action !== "setVariables" && M.elementId === r.id)
                break;
              switch (M.action) {
                case "completeJob": {
                  M.type === "userTask" ? await d({
                    elementId: M.elementId,
                    instanceKey: w,
                    variables: M.variables
                  }) : await f({
                    elementId: M.elementId,
                    instanceKey: w,
                    variables: M.variables
                  });
                  break;
                }
                case "invokeConnector": {
                  await u({
                    elementId: M.elementId,
                    instanceKey: w
                  });
                  break;
                }
                case "publishMessage": {
                  await l({
                    messageName: M.messageName,
                    messageId: M.messageId,
                    variables: M.variables,
                    timeToLive: M.timeToLive,
                    instanceKey: w,
                    elementId: M.elementId
                  });
                  break;
                }
                case "timeTravel": {
                  await c({
                    elementId: M.elementId,
                    instanceKey: w
                  });
                  break;
                }
                case "throwJob": {
                  await p({
                    elementId: M.elementId,
                    instanceKey: w,
                    errorCode: M.errorCode,
                    errorMessage: M.errorMessage
                  });
                  break;
                }
                case "failJob": {
                  await g({
                    elementId: M.elementId,
                    instanceKey: w,
                    retries: M.retries,
                    errorMessage: M.errorMessage
                  });
                  break;
                }
                case "resolveIncident": {
                  await m({
                    elementId: M.elementId,
                    instanceKey: w,
                    hasJob: M.hasJob
                  });
                  break;
                }
                case "setVariables": {
                  await A({
                    instanceKey: w,
                    scope: w,
                    variables: M.variables
                  });
                  break;
                }
              }
              y.push(M);
            }
            const { elementInstances: _ } = await _t.fetchElementInstances({
              instanceKey: w
            }), D = (_?.activeElementInstances.map(
              ({ element: M }) => M.elementId
            ) ?? []).includes(
              r.id
            );
            e.rewindProcess.endRewinding(), rut(
              Lr(w),
              y
            ), a.state === "ACTIVATED" && _t.terminateProcessInstance(o), Kt.setInstanceDetails({
              instanceKey: w,
              instanceType: "REWOUND_INSTANCE"
            }), D ? e.displayNotification?.success({
              title: "Rewind successful"
            }) : e.displayNotification?.warning(
              {
                title: "Rewind partially successful",
                content: "Some BPMN elements cannot be rewound"
              },
              {
                action: {
                  label: "Read docs",
                  onClick: () => {
                    window.open(
                      "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#rewind-a-process",
                      "_blank"
                    );
                  }
                }
              }
            );
          }
        }
      ]
    }
  ) });
}), xGt = rt(({ element: r }) => {
  const [e, t] = ye(!1), [n, i] = ye(""), { processInstance: s } = Kt.state, o = bn(Cr), a = ts.errorThrowableJobsByErrorId[r.id];
  if (a === void 0)
    return null;
  const l = [
    {
      label: "Throw Error",
      renderIcon: () => /* @__PURE__ */ x.jsx(Qg, {}),
      onClick: async () => {
        if (a.length === 1) {
          const { errorCode: c, job: d } = a[0], u = d.key, f = await ts.throwError({
            jobKey: u,
            errorCode: c
          });
          f && s !== void 0 && (is(Lr(s.key), {
            action: "throwJob",
            elementId: d.elementId,
            errorCode: c
          }), o.displayNotification?.success(
            {
              title: `"${r.id}" manually triggered with error code "${c}"`
            },
            {
              action: {
                label: "Learn more",
                onClick: () => {
                  window.open(
                    "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
                    "_blank"
                  );
                }
              }
            }
          )), f || o.displayNotification?.error(Mi);
        } else
          t(!0);
      }
    }
  ];
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(bc, { actions: l }),
    /* @__PURE__ */ x.jsx(
      jy,
      {
        isVisible: e,
        title: "Throw Error",
        primaryButtonLabel: "Throw Error",
        isPrimaryButtonDisabled: n === "",
        secondaryButton: {
          label: "Close",
          onClick: () => t(!1)
        },
        onClose: () => t(!1),
        enableContentOverflow: !0,
        onSubmit: async () => {
          const c = a.find(
            ({ job: u }) => u.key === n
          );
          if (c === void 0)
            return;
          t(!1);
          const d = await ts.throwError({
            jobKey: c.job.key,
            errorCode: c.errorCode
          });
          d && s !== void 0 && (is(Lr(s.key), {
            action: "throwJob",
            elementId: c.job.elementId,
            errorCode: c.errorCode
          }), o.displayNotification?.success(
            {
              title: `"${r.id}" manually triggered with error code "${c.errorCode}"`
            },
            {
              action: {
                label: "Learn more",
                onClick: () => {
                  window.open(
                    "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
                    "_blank"
                  );
                }
              }
            }
          )), d || o.displayNotification?.error(Mi);
        },
        modalBody: /* @__PURE__ */ x.jsx(
          tw,
          {
            id: "job",
            "aria-label": "Select a Job",
            titleText: "Select a job to throw this error",
            items: a.map(({ job: c }) => ({
              id: c.key,
              label: c.elementName
            })),
            onChange: ({ selectedItem: c }) => {
              i(c?.id ?? "");
            }
          }
        )
      }
    )
  ] });
}), SGt = rt(({ element: r, addOverlay: e }) => {
  const { instanceKey: t } = Kt.state, { fileProblems: n } = kt, i = bn(Cr).featureFlags.isSaveExampleDataEnabled, s = !t && n?.find((M) => M.element.id === r.id);
  if (s) {
    const M = e(r, "PROBLEM", Vqt);
    return un(
      /* @__PURE__ */ x.jsx(Jqt, { element: r, problem: s }),
      M
    );
  }
  const {
    state: { connectorElementsWithSecrets: o, connectorElements: a }
  } = mh, l = !t && o?.find(
    (M) => M.element.id === r.id
  );
  if (l) {
    const M = e(r, "CONNECTOR", Hqt);
    return un(
      /* @__PURE__ */ x.jsx(Kqt, { element: r, connector: l }),
      M
    );
  }
  const c = uf.state.incidents?.find(
    (M) => M.elementInstance?.element?.elementId === r.id && M.state === "CREATED"
  );
  if (c) {
    const M = e(r, "INCIDENT_BUTTON", Bqt);
    return un(
      /* @__PURE__ */ x.jsx(pGt, { element: r, incident: c }),
      M
    );
  }
  if (r.type === "bpmn:StartEvent" && ["bpmn:Process", "bpmn:Participant"].includes(r.parent?.type) && (!r.businessObject.eventDefinitions || r.businessObject.eventDefinitions.length === 0)) {
    const M = e(
      r,
      "START_INSTANCE_BUTTON",
      Pqt
    );
    return un(
      i ? /* @__PURE__ */ x.jsx(
        lGt,
        {
          element: r,
          isRestartMode: t !== void 0
        }
      ) : /* @__PURE__ */ x.jsx(
        $qt,
        {
          element: r,
          isRestartMode: t !== void 0
        }
      ),
      M
    );
  }
  const d = Ro.completedElementInstances.map(
    ({ element: M }) => M.elementId
  );
  if (r.type === "bpmn:EndEvent" && Kt.state.processInstance?.state === "COMPLETED" && ["bpmn:Process", "bpmn:Participant"].includes(r.parent?.type) && d.includes(r.id)) {
    const M = e(r, "FINISHED_OVERLAY", Uqt);
    return un(/* @__PURE__ */ x.jsx(fGt, {}), M);
  }
  const u = Ro.state.elementInstances?.activeElementInstances.map(
    ({ element: M }) => M.elementId
  ) || [], f = Ro.completedElementInstances.find(
    (M) => M.element.elementId === r.id
  )?.element;
  if (f !== void 0 && _dt.includes(f.bpmnElementType) && !u.includes(r.id)) {
    const M = e(r, "REWIND_OVERLAY", qqt);
    return un(/* @__PURE__ */ x.jsx(_Gt, { element: r }), M);
  }
  const g = b8.state.timers?.find(
    (M) => M.element.elementId === r.id && M.state === "CREATED"
  );
  if (g) {
    const M = e(
      r,
      "TRIGGER_TIMER_BUTTON",
      M_e
    );
    return un(
      /* @__PURE__ */ x.jsx(S_e, { element: r, timer: g }),
      M
    );
  }
  const m = C7.state.timers?.find(
    (M) => M.element.elementId === r.id && M.state === "CREATED"
  );
  if (m) {
    const M = e(
      r,
      "TRIGGER_TIMER_BUTTON",
      M_e
    );
    return un(
      /* @__PURE__ */ x.jsx(
        S_e,
        {
          element: r,
          timer: m,
          isRestartMode: t !== void 0,
          shouldWaitForInstanceCreation: !0,
          isStartEvent: !0
        }
      ),
      M
    );
  }
  const w = M3.state.messageSubscriptions?.find((M) => M.element.elementId !== r.id ? !1 : t ? M.state === "CREATED" || M.state === "CORRELATED" && M.elementInstance?.state === "ACTIVATED" : !0);
  if (w) {
    const M = e(
      r,
      "TRIGGER_MESSAGE_SUBSCRIPTION_BUTTON",
      D_e
    );
    return un(
      /* @__PURE__ */ x.jsx(
        x_e,
        {
          element: r,
          messageSubscription: w
        }
      ),
      M
    );
  }
  const y = y7.state.definitionMessageSubscriptions?.find(
    (M) => M.element.elementId === r.id
  );
  if (y) {
    const M = e(
      r,
      "TRIGGER_MESSAGE_SUBSCRIPTION_BUTTON",
      D_e
    );
    return un(
      /* @__PURE__ */ x.jsx(
        x_e,
        {
          element: r,
          messageSubscription: y,
          isRestartMode: t !== void 0,
          isStartEvent: !0
        }
      ),
      M
    );
  }
  if (r.type === "bpmn:SequenceFlow") {
    const M = e(
      r,
      "SEQUENCE_FLOW_HIGHLIGHTER",
      Fqt
    );
    return un(/* @__PURE__ */ x.jsx(mGt, { element: r }), M);
  }
  if (t && a?.find((M) => M.id === r.id)) {
    const M = e(
      r,
      "INVOKE_CONNECTOR_BUTTON",
      zqt
    );
    return un(/* @__PURE__ */ x.jsx(gGt, { element: r }), M);
  }
  const S = t && y8.state.childInstances.find(
    (M) => M.parentElementInstance.element.elementId === r.id
  );
  if (S) {
    const M = e(
      r,
      "CHILD_INSTANCE_BUTTON",
      Wqt
    );
    return un(
      /* @__PURE__ */ x.jsx(cGt, { childInstance: S }),
      M
    );
  }
  if (Gg(r.businessObject) && ["bpmn:StartEvent", "bpmn:BoundaryEvent"].includes(r.type)) {
    const M = e(r, "THROW_ERROR_BUTTON", Zqt);
    return un(/* @__PURE__ */ x.jsx(xGt, { element: r }), M);
  }
  const D = e(r, "JOB_COMPLETE_BUTTON", jqt);
  return un(
    i ? /* @__PURE__ */ x.jsx(CGt, { element: r }) : /* @__PURE__ */ x.jsx(vGt, { element: r }),
    D
  );
}), MGt = q.div`
  position: absolute;
  bottom: var(--spacing-medium, 20px);
  right: var(--spacing-medium, 20px);
  z-index: ${gIe};
`, DGt = q.div`
  display: flex;
  justify-content: center;
  color: var(--grey-darken-33);
  padding: 5px;
  background-color: var(--silver-base-97, hsl(0, 0%, 97%));
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  border-radius: 2px;
`, cA = q.button`
  margin: 0px 5px;
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
  height: 20px;
  width: 20px;
  cursor: pointer;
  outline: none;
`, LGt = rt(
  ({ handleZoomReset: r, handleZoomIn: e, handleZoomOut: t, handleMinimap: n }) => {
    const { handleFullscreenToggle: i } = mi, { isFullscreenActive: s, isMinimapActive: o } = mi.state;
    return /* @__PURE__ */ x.jsx(MGt, { children: /* @__PURE__ */ x.jsxs(DGt, { children: [
      /* @__PURE__ */ x.jsx(
        V2,
        {
          title: s ? "Disable fullscreen" : "Enable fullscreen",
          align: "top",
          showOnlyOnOverflow: !1,
          children: /* @__PURE__ */ x.jsx(
            cA,
            {
              "data-test": "toggle-fullscreen",
              onClick: i,
              title: "Toggle fullscreen mode",
              children: s ? (
                //@ts-expect-error Property 'width' does not exist on type 'IntrinsicAttributes'.ts(2322)
                /* @__PURE__ */ x.jsx(odt, { width: "14", height: "14" })
              ) : (
                //@ts-expect-error Property 'width' does not exist on type 'IntrinsicAttributes'.ts(2322)
                /* @__PURE__ */ x.jsx(adt, { width: "14", height: "14" })
              )
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsx(
        V2,
        {
          title: "Toggle minimap",
          align: "top",
          showOnlyOnOverflow: !1,
          children: /* @__PURE__ */ x.jsx(
            cA,
            {
              "data-selector": "minimap-container",
              "data-test": "toggle-minimap",
              onClick: n,
              title: "Toggle minimap",
              children: /* @__PURE__ */ x.jsx(
                sdt,
                {
                  height: "18",
                  style: {
                    color: o && "var(--orange-base-60, hsl(34, 100%, 60%))"
                  }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsx(
        V2,
        {
          title: "Reset viewport",
          align: "top",
          showOnlyOnOverflow: !1,
          children: /* @__PURE__ */ x.jsx(
            cA,
            {
              onClick: r,
              "data-test": "viewport-reset",
              title: "Reset viewport",
              children: /* @__PURE__ */ x.jsx(rdt, { width: "15", height: "15" })
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsx(V2, { title: "Zoom out", align: "top", showOnlyOnOverflow: !1, children: /* @__PURE__ */ x.jsx(
        cA,
        {
          onClick: t,
          "data-test": "zoom-out",
          title: "Zoom out",
          children: /* @__PURE__ */ x.jsx(idt, { width: "12", height: "12" })
        }
      ) }),
      /* @__PURE__ */ x.jsx(V2, { title: "Zoom in", align: "top", showOnlyOnOverflow: !1, children: /* @__PURE__ */ x.jsx(
        cA,
        {
          onClick: e,
          "data-test": "zoom-in",
          title: "Zoom in",
          children: /* @__PURE__ */ x.jsx(ndt, { width: "20", height: "20" })
        }
      ) })
    ] }) });
  }
), kGt = q.div`
  position: absolute;
  top: var(--cds-spacing-04, 12px);
  right: var(--cds-spacing-04, 12px);
  z-index: ${gIe};
`, NGt = q(M1)`
  .cds--modal-header__heading {
    font-weight: 400;
  }
`, TGt = q.section`
  padding: var(--cds-spacing-03, 8px) 0;
  ${yl.helperText01};
  color: var(--cds-text-secondary, #525252);
`, IGt = rt(() => {
  const [r, e] = ye(!1), t = An(null);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(kGt, { children: /* @__PURE__ */ x.jsx(
      hM,
      {
        onClick: () => {
          $i.trackAcademyHatClicked(), e(!0);
        },
        label: "Learn how to use Play",
        align: "left",
        kind: "ghost",
        id: "appCuesTargetTutorialButton",
        children: /* @__PURE__ */ x.jsx(ldt, {})
      }
    ) }),
    r && /* @__PURE__ */ x.jsx(
      NGt,
      {
        passiveModal: !0,
        selectorPrimaryFocus: "#academyTutorialVideo",
        size: "lg",
        open: r,
        onRequestClose: async () => {
          await t.current?.trackPlaybackPosition(), e(!1);
        },
        modalHeading: "How to validate processes using Play",
        children: r && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(fIe, { ref: t }),
          /* @__PURE__ */ x.jsx(TGt, { children: "This how-to video is based on an earlier version of Play. Some features within Play may have been updated in recent releases and may not be fully consistent with the content in the video." })
        ] })
      }
    )
  ] });
}), OGt = rt(({ xml: r }) => {
  const e = bn(Cr), t = An(null), n = An(null), i = mi.selectableFlowNodeIds, s = nh.state.selection?.flowNodeId, o = Kt.state.instanceKey, a = e.featureFlags.isAcademyVideoExperiment;
  function l() {
    return n.current === null && (n.current = new xqt()), n.current;
  }
  const c = l();
  return Fg(() => {
    async function d() {
      if (t.current) {
        const u = s ? [s] : void 0;
        mi.startLoading(), await c.render({
          container: t.current,
          xml: r,
          selectableFlowNodeIds: i,
          selectedFlowNodeIds: u
        }), mi.finishLoading(c);
      }
    }
    d();
  }, [r, c, i, s]), Pe(() => () => {
    c.reset();
  }, [c]), /* @__PURE__ */ x.jsxs(Sqt, { "data-testid": "diagram", children: [
    /* @__PURE__ */ x.jsx(
      Mqt,
      {
        ref: t,
        $isSelectionAllowed: o !== void 0
      }
    ),
    mi.state.isLoaded && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        LGt,
        {
          handleZoomIn: c.zoomIn,
          handleZoomOut: c.zoomOut,
          handleZoomReset: c.zoomReset,
          handleMinimap: c.toggleMinimap
        }
      ),
      a && /* @__PURE__ */ x.jsx(IGt, {}),
      mi.elements?.map((d) => /* @__PURE__ */ x.jsx(
        SGt,
        {
          element: d,
          addOverlay: c.addOverlay
        },
        d.id
      ))
    ] })
  ] });
});
function lv(r) {
  return new Promise((e) => {
    let t = 0;
    const n = 5, i = setInterval(async () => {
      const s = await r();
      s !== null && (clearInterval(i), e(s)), t++, t >= n && (clearInterval(i), e(null));
    }, 250);
  });
}
const RGt = ({
  instanceKey: r,
  messageName: e,
  elementId: t
}) => lv(async () => {
  const { messageSubscriptions: n } = await _t.fetchMessageSubscriptions({
    instanceKey: r
  }), i = n?.find(
    (s) => s.element.elementId === t && s.messageName === e
  );
  return i !== void 0 ? i : null;
}), VGt = ({
  instanceKey: r,
  elementId: e
}) => lv(async () => {
  const { timers: t } = await _t.fetchTimers({
    instanceKey: r
  }), n = t?.find(
    (i) => i.element.elementId === e
  );
  return n !== void 0 ? n : null;
}), HGt = ({
  instanceKey: r,
  elementId: e
}) => lv(async () => {
  const { userTasks: t } = await _t.fetchUserTasks({
    instanceKey: r
  }), n = t?.find(
    ({ elementInstance: i, state: s }) => i.element.elementId === e && s !== "COMPLETED"
  );
  return n !== void 0 ? n : null;
}), hA = ({
  instanceKey: r,
  elementId: e
}) => lv(async () => {
  const { jobs: t } = await _t.fetchJobs({
    instanceKey: r
  }), n = t?.find(
    ({ elementInstance: i, state: s }) => i.element.elementId === e && s !== "COMPLETED"
  );
  return n !== void 0 ? n : null;
}), BGt = ({
  instanceKey: r,
  elementId: e
}) => lv(async () => {
  const { incidents: t } = await _t.fetchIncidents({
    instanceKey: r
  }), n = t?.find(
    ({ elementInstance: i, state: s }) => i.element.elementId === e && s !== "RESOLVED"
  )?.key;
  return n !== void 0 ? n : null;
});
function PGt({ processId: r }) {
  const [e, t] = ye(!1), n = () => {
    t(!0);
  }, i = () => {
    t(!1);
  }, s = ({
    scopeId: A,
    relativeTimestamp: w
  }) => {
    const v = tl.state.variables?.filter(
      ({ scope: y, timestamp: _ }) => [A, r].includes(y.element.elementId) && (w === void 0 || _ <= w)
    ).reduce((y, _) => (y[_.name] = JSON.parse(_.value), y), {});
    return v === void 0 ? "{}" : JSON.stringify(v);
  };
  return {
    isRewinding: e,
    startRewinding: n,
    endRewinding: i,
    handleMessageEvent: async function({
      instanceKey: w,
      messageName: v,
      messageId: y,
      variables: _,
      timeToLive: S,
      elementId: D
    }) {
      const M = await RGt({
        instanceKey: w,
        messageName: v,
        elementId: D
      });
      M !== null && await _t.publishMessage({
        messageName: v,
        correlationKey: M.messageCorrelationKey,
        variables: _,
        timeToLive: S,
        messageId: y
      });
    },
    handleTimerEvent: async function({
      elementId: w,
      instanceKey: v
    }) {
      const y = await VGt({
        instanceKey: v,
        elementId: w
      });
      y !== null && await _t.timeTravel({
        dateTime: y.dueDate
      });
    },
    startNewInstance: async function(w) {
      const v = s({
        scopeId: r,
        relativeTimestamp: w
      });
      return (await _t.startInstance({
        playId: kt.state.playId,
        variables: v
      })).instanceId;
    },
    handleUserTask: async function({
      elementId: w,
      instanceKey: v,
      variables: y = "{}"
    }) {
      const _ = await HGt({
        instanceKey: v,
        elementId: w
      });
      _ !== null && await _t.completeJob({
        jobKey: _.key,
        variables: y
      });
    },
    handleServiceTask: async function({
      elementId: w,
      instanceKey: v,
      variables: y = "{}"
    }) {
      const _ = await hA({
        instanceKey: v,
        elementId: w
      });
      _ !== null && await _t.completeJob({
        jobKey: _.key,
        variables: y
      });
    },
    handleThrowError: async function({
      elementId: w,
      instanceKey: v,
      errorCode: y = ""
    }) {
      const _ = await hA({
        instanceKey: v,
        elementId: w
      });
      _ !== null && await _t.throwError({
        jobKey: _.key,
        errorCode: y
      });
    },
    handleFailJob: async function({
      elementId: w,
      instanceKey: v,
      retries: y = 0,
      errorMessage: _ = ""
    }) {
      const S = await hA({
        instanceKey: v,
        elementId: w
      });
      S !== null && await _t.failJob({
        jobKey: S.key,
        retries: y,
        errorMessage: _
      });
    },
    handleConnector: async function({
      elementId: w,
      instanceKey: v
    }) {
      const y = await hA({
        instanceKey: v,
        elementId: w
      });
      y !== null && await _t.invokeConnector({
        jobType: y.jobType,
        jobKey: y.key
      });
    },
    getScopeVariables: s,
    handleResolveIncident: async function({
      elementId: w,
      instanceKey: v,
      hasJob: y
    }) {
      if (y) {
        const S = await hA({
          instanceKey: v,
          elementId: w
        });
        if (S === null)
          return;
        await _t.updateRetries({
          jobKey: S.key,
          retries: 1
        });
      }
      const _ = await BGt({
        instanceKey: v,
        elementId: w
      });
      _ !== null && await _t.resolveIncident({ incidentKey: _ });
    },
    handleSetVariables: async function({
      instanceKey: w,
      scope: v,
      variables: y
    }) {
      await _t.setVariables({
        instanceKey: w,
        scope: v,
        variablesString: y
      });
    }
  };
}
const FGt = q.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-border-subtle-selected-01, #c6c6c6);
  margin-bottom: var(--cds-spacing-05, 16px);
`, zGt = q(tdt)`
  width: 45px;
  height: 45px;
  animation: grow 1200ms forwards;

  @keyframes grow {
    from {
      width: 45px;
      height: 45px;
    }
    to {
      width: 180px;
      height: 180px;
    }
  }
`, WGt = rt(() => {
  const r = bn(Cr);
  return !Kt.state.isProcessManuallyCompleted || SM() || Kt.state.isCalledProcess ? null : (SM() || wje(), /* @__PURE__ */ x.jsxs(
    M1,
    {
      open: Kt.state.isProcessManuallyCompleted,
      size: "md",
      modalHeading: "Congratulations, you did it!",
      primaryButtonText: "Go to Implement mode",
      onRequestClose: () => {
        Kt.setIsProcessManuallyCompleted(!1);
      },
      onRequestSubmit: () => {
        r.switchToImplementMode?.();
      },
      preventCloseOnClickOutside: !0,
      children: [
        /* @__PURE__ */ x.jsx(FGt, { children: /* @__PURE__ */ x.jsx(zGt, {}) }),
        /* @__PURE__ */ x.jsx("p", { children: "You’ve successfully completed your process in Play." }),
        /* @__PURE__ */ x.jsx("br", {}),
        /* @__PURE__ */ x.jsx("p", { children: "Let’s make your work even more efficient!" }),
        /* @__PURE__ */ x.jsxs("p", { children: [
          /* @__PURE__ */ x.jsx("b", { children: "Deploy" }),
          " your process to a live cluster from Implement mode to see it in action."
        ] })
      ]
    }
  ));
});
function jGt(r) {
  return ms(
    () => Ro.elementInstances,
    (e, t) => {
      if (t.length === 0 && Kt.state.instanceType !== "NEW_INSTANCE")
        return;
      const n = e.filter(
        (o) => o.element.bpmnElementType === "BUSINESS_RULE_TASK" && o.state === "COMPLETED"
      ), i = t.filter(
        (o) => o.element.bpmnElementType === "BUSINESS_RULE_TASK" && o.state === "COMPLETED"
      ).map(({ key: o }) => o);
      n.filter(
        ({ key: o }) => !i.includes(o)
      ).forEach(({ element: o }) => {
        r?.success({
          title: `"${o.elementName || o.elementId}" business rule task completed`
        });
      });
    }
  );
}
function ZGt(r) {
  return ms(
    () => M3.state.messageSubscriptions,
    (e, t) => {
      if (t.length === 0 && Kt.state.instanceType !== "NEW_INSTANCE")
        return;
      const n = t.filter(
        ({ state: o }) => o === "CORRELATED"
      ), i = e.filter(
        ({ state: o }) => o === "CORRELATED"
      );
      [
        ...i.filter(
          ({ key: o }) => !n.some(({ key: a }) => a === o)
        ),
        // We need to inspect the messageCorrelations array for existing message correlations
        // as non-interrupting message events have an updated messageCorrelations array for new correlations,
        // but their status is set to CORRELATED already after the first correlation.
        // Non-interrupting message events can stay active for a longer time and have multiple message correlations.
        ...i.filter((o) => {
          const a = n.find(
            ({ key: l }) => l === o.key
          );
          return a === void 0 ? !1 : a.messageCorrelations.length < o.messageCorrelations.length;
        })
      ].forEach(
        ({ messageName: o, messageCorrelationKey: a }) => {
          const l = `Message "${o}" correlated with key "${a}"`;
          r?.success({
            title: l
          });
        }
      );
    }
  );
}
function UGt(r) {
  return ms(
    () => Ro.elementInstances,
    (e, t) => {
      if (t.length === 0 && Kt.state.instanceType !== "NEW_INSTANCE")
        return;
      const n = e.filter(
        (o) => o.element.bpmnElementType === "EVENT_SUB_PROCESS"
      ), i = t.filter(
        (o) => o.element.bpmnElementType === "EVENT_SUB_PROCESS"
      ).map(({ key: o }) => o);
      n.filter(
        ({ key: o }) => !i.includes(o)
      ).forEach(({ element: o }) => {
        r?.success(
          {
            title: `"${o.elementName || o.elementId}" event sub-process started`
          },
          {
            action: {
              label: "Go to sub-process",
              onClick: () => {
                mi.focusOnElement(o.elementId);
              }
            }
          }
        );
      });
    }
  );
}
const Ynn = ({
  monacoLoaderConfig: r,
  xml: e,
  switchToImplementMode: t,
  onDeploymentError: n,
  projectId: i,
  processId: s,
  setExecutionPlatformVersion: o,
  diagramId: a,
  displayNotification: l,
  mixpanelTrack: c,
  handlePostRequest: d,
  fetchFilesByProcessId: u,
  fetchFilesByDecisionId: f,
  fetchFileById: p,
  convertLinkedFormsToEmbeddedForms: g,
  featureFlags: m,
  currentDiagramRevision: A,
  updateFileById: w,
  originAppInstanceId: v,
  canUserSaveExampleData: y,
  isUserOrgOwnerOrAdmin: _,
  organizationManagementPageUrl: S
}) => {
  const D = localStorage.getItem("play-directAccess");
  if (D) {
    localStorage.removeItem("play-directAccess");
    const z = JSON.parse(D);
    _t.setEndpoint(z.endpoint), kt.setEndpoint(z.endpoint), kt.setPlayId(z.definition), Kt.setInstanceDetails({
      instanceKey: z.instance,
      instanceType: "EXISTING_INSTANCE"
    }), kt.setDeployedFiles(z.deployedFiles);
  }
  const [M, L] = ye(!D), [T, B] = ye(!1);
  Pe(() => () => {
    Kt.reset(), mh.reset(), kt.reset();
  }, []), Pe(() => {
    _t.init({
      handlePostRequest: d
    }), $i.init(c), B(!0);
  }, []), Pe(() => {
    kt.init({
      projectId: i,
      processId: s,
      diagramId: a,
      fetchFilesByProcessId: u,
      fetchFilesByDecisionId: f,
      fetchFileById: p,
      onDeploymentError: n,
      convertLinkedFormsToEmbeddedForms: g,
      setExecutionPlatformVersion: o,
      xml: e,
      currentDiagramRevision: A,
      updateFileById: w,
      originAppInstanceId: v,
      canUserSaveExampleData: y
    });
  }, [
    s,
    i,
    a,
    u,
    f,
    p,
    n,
    g,
    o,
    e,
    A,
    w,
    v,
    y
  ]);
  const V = Mje({
    processId: s
  }), N = PGt({
    processId: s
  });
  Pe(() => {
    if (!N.isRewinding) {
      const z = jGt(l), U = ZGt(l), ee = UGt(l);
      return () => {
        z(), U(), ee();
      };
    }
  }, [l, N.isRewinding]);
  function R(z) {
    return new Promise((U, ee) => {
      let ce = 6;
      const se = setInterval(() => {
        _t.fetchInstances({ id: z }).then(({ process: te }) => {
          ce--;
          const ue = te?.processInstances?.nodes?.[0];
          if (ue)
            return clearInterval(se), U(ue.key);
          if (ce === 0)
            return clearInterval(se), ee();
        });
      }, 250);
    });
  }
  const H = {
    startInstance: async (z = "{}") => {
      const U = await _t.startInstance({
        playId: kt.state.playId,
        variables: z
      });
      return Kt.reset(), U?.success && (Kt.setInstanceDetails({
        instanceKey: U.instanceId,
        instanceType: "NEW_INSTANCE"
      }), $i.trackInstanceStart(s)), U?.success !== !1;
    },
    invokeConnector: async (z, U) => (await _t.invokeConnector({
      jobType: z,
      jobKey: U
    }))?.success !== !1,
    timeTravel: async (z, U) => {
      if ((await _t.timeTravel({ dateTime: z }))?.success === !1)
        return !1;
      if (U)
        try {
          const ce = await R(
            kt.state.playId
          );
          Kt.reset(), Kt.setInstanceDetails({
            instanceKey: ce,
            instanceType: "NEW_INSTANCE"
          }), $i.trackInstanceStart(s);
        } catch {
          return console.error("Could not get new instance"), !1;
        }
      return !0;
    },
    startNewInstanceWithTimer: async (z) => {
      if ((await _t.timeTravel({ dateTime: z }))?.success !== !1)
        try {
          return await R(
            kt.state.playId
          );
        } catch {
          console.error("Could not get new instance");
          return;
        }
    },
    publishMessage: async ({
      messageName: z,
      correlationKey: U,
      variables: ee,
      timeToLive: ce,
      messageId: se,
      isStartEvent: te
    }) => {
      if ((await _t.publishMessage({
        messageName: z,
        correlationKey: U,
        variables: ee,
        timeToLive: ce,
        messageId: se
      }))?.success === !1)
        return { success: !1, instanceId: void 0 };
      let G;
      try {
        return te && (G = await R(
          kt.state.playId
        ), Kt.reset(), Kt.setInstanceDetails({
          instanceKey: G,
          instanceType: "NEW_INSTANCE"
        }), $i.trackInstanceStart(s)), { success: !0, instanceId: G };
      } catch {
        return console.error("Could not get new instance"), { success: !1, instanceId: void 0 };
      }
    },
    ...V,
    switchToImplementMode: t,
    displayNotification: l,
    rewindProcess: N,
    monacoLoaderConfig: r,
    featureFlags: {
      isAcademyVideoExperiment: m?.isAcademyVideoExperiment ?? !1,
      areAIFeaturesEnabled: m?.areAIFeaturesEnabled ?? !1,
      isSaveExampleDataEnabled: m?.isSaveExampleDataEnabled ?? !1
    },
    isUserOrgOwnerOrAdmin: _,
    organizationManagementPageUrl: S
  };
  return /* @__PURE__ */ x.jsxs(Cr.Provider, { value: H, children: [
    N.isRewinding && /* @__PURE__ */ x.jsx(mkt, { children: "Rewinding..." }),
    /* @__PURE__ */ x.jsx(jdt, {}),
    /* @__PURE__ */ x.jsx(OGt, { xml: e }),
    M && T && /* @__PURE__ */ x.jsx(
      xLt,
      {
        close: () => {
          L(!1);
        },
        switchToImplementMode: t,
        isAcademyVideoExperiment: m?.isAcademyVideoExperiment || !1
      }
    ),
    !M && /* @__PURE__ */ x.jsx(GDt, {}),
    /* @__PURE__ */ x.jsx(WGt, {}),
    V.isConnectionDead && !M && /* @__PURE__ */ x.jsx(
      DLt,
      {
        onRefresh: () => {
          Kt.reset(), kt.reset(), L(!0);
        }
      }
    )
  ] });
}, kT = (r, e) => {
  const t = an(r);
  let n = [];
  const i = t.get("extensionElements");
  if (i !== void 0) {
    const s = i.get("values");
    s !== void 0 && (n = s.filter((o) => He(o, e)));
  }
  return n;
}, p2 = (r, e) => {
  const t = kT(r, e);
  if (t.length !== 0)
    return t[0];
}, qGt = "camundaModeler:exampleOutputJson", bC = (r) => {
  const e = GGt(r, qGt);
  if (e)
    return e.get("value");
}, GGt = (r, e) => p2(r, "zeebe:Properties")?.get("properties")?.find((i) => i.get("name") === e), rf = (r) => {
  if (!r)
    return !1;
  try {
    return typeof JSON.parse(r) == "object";
  } catch {
    return !1;
  }
};
function JBe({
  processId: r,
  elementId: e
}) {
  return `jobCompletion ${r} ${e}`;
}
function cv({
  processId: r,
  elementId: e,
  variables: t
}) {
  localStorage.setItem(JBe({ processId: r, elementId: e }), t);
}
function $Be({
  processId: r,
  elementId: e
}) {
  return localStorage.getItem(JBe({ processId: r, elementId: e }));
}
function qd({
  element: r,
  useCache: e,
  processId: t
}) {
  const n = bC(r), i = $Be({
    processId: t,
    elementId: r.id
  }), s = rf(i) ? i : null, o = s && e, a = n && !o;
  return o ? {
    prefillData: s,
    prefillSource: s === n ? "bpmn" : "cache"
  } : a ? {
    prefillData: n,
    prefillSource: "bpmn"
  } : { prefillData: "", prefillSource: "none" };
}
class QGt {
  mixpanelTrack = void 0;
  processId = void 0;
  diagramId = void 0;
  init = ({
    mixpanelTrack: e,
    processId: t,
    diagramId: n
  }) => {
    this.mixpanelTrack = e, this.processId = t, this.diagramId = n;
  };
  trackDeployment({
    success: e,
    errorMessage: t,
    fileId: n,
    fileType: i
  }) {
    return this.mixpanelTrack?.("modeler:deploy:confirm", {
      success: e,
      fileId: n,
      fileType: i.toLowerCase(),
      errorMessage: t,
      from: "play"
    });
  }
  trackDiagramErrors({
    fileId: e,
    fileType: t,
    count: n
  }) {
    this.mixpanelTrack?.("modeler:diagramErrors:count", {
      from: "play",
      type: "DEPLOY",
      count: n,
      fileId: e,
      fileType: t.toUpperCase()
    });
  }
  trackResolveIncident(e) {
    return this.mixpanelTrack?.("single-operation", {
      operationType: "RESOLVE_INCIDENT",
      process_id: e,
      from: "play"
    });
  }
  trackIncident(e, t) {
    const n = JSON.parse(
      localStorage.getItem("play-incidentTracking") || "{}"
    );
    n[e.key] || (this.mixpanelTrack?.("incident:trigger", {
      error: e.message,
      process_id: t,
      from: "play"
    }), n[e.key] = !0, localStorage.setItem(
      "play-incidentTracking",
      JSON.stringify(n)
    ));
  }
  trackRewindedInstanceStart() {
    return this.mixpanelTrack?.("bpmnelement:completed", {
      elementType: "START_EVENT",
      from: "play",
      is_from_rewind: !0,
      fileId: this.diagramId,
      processId: this.processId
    });
  }
  trackAPIError(e, t) {
    return this.mixpanelTrack?.("apiError", {
      from: "play",
      path: e,
      status_code: t
    });
  }
  trackIncidentAIModalOpened({
    areAIFeaturesEnabled: e
  }) {
    return this.mixpanelTrack?.("docsAI:open", {
      enabled: e,
      from: "play"
    });
  }
  trackUserCompletesElement(e, t) {
    const { prefillData: n, prefillSource: i } = qd({
      element: e,
      useCache: !0,
      processId: this.processId
    }), s = t === n ? i : "manual", o = an(e).$type;
    this.mixpanelTrack?.("bpmnelement:completed", {
      fileId: this.diagramId,
      processId: this.processId,
      elementType: o,
      exampleDataUsed: s,
      from: "play"
    });
  }
  trackDiagramUpdated() {
    const e = {
      fileId: this.diagramId,
      from: "play",
      fileType: "bpmn"
    };
    return this.mixpanelTrack?.("modeler:edit:file", e);
  }
  openOperate(e) {
    return this.mixpanelTrack?.("operate:open", {
      from: "play",
      url: e
    });
  }
  saveScenario({
    newTotalCoverage: e,
    coverageIncrease: t
  }) {
    return this.mixpanelTrack?.("save-scenario", {
      from: "play",
      newTotalCoverage: e,
      coverageIncrease: t
    });
  }
  runScenarios(e) {
    return this.mixpanelTrack?.("run-scenarios", {
      from: "play",
      count: e
    });
  }
  applyModifictation(e) {
    return this.mixpanelTrack?.(e, {
      from: "play"
    });
  }
}
const Jn = new QGt();
class KGt {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handlePostRequest = void 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleGetRequest = void 0;
  authConfig = void 0;
  init = ({
    authConfig: e,
    handlePostRequest: t,
    handleGetRequest: n
  }) => {
    this.authConfig = e, this.handlePostRequest = t, this.handleGetRequest = n;
  };
  async postWithErrorHandling(e, t) {
    try {
      return { success: !0, response: await this.handlePostRequest(e, {
        payload: {
          ...t,
          authType: this.authConfig?.type,
          ...this.authConfig?.config
        }
      }) };
    } catch (n) {
      return Jn.trackAPIError(e, n.status), { success: !1, response: n, status: n.status };
    }
  }
  async getWithErrorHandling(e) {
    try {
      return { success: !0, response: await this.handleGetRequest(e) };
    } catch (t) {
      return Jn.trackAPIError(e, t.status), { success: !1, response: t };
    }
  }
  async getConnectorSecrets() {
    if (this.authConfig?.type === "sm")
      return { success: !0, secrets: [] };
    const { success: e, response: t } = await this.getWithErrorHandling(
      `/cloud/console/organizations/${this.authConfig?.config.organizationId}/clusters/${this.authConfig?.config.clusterId}/connectorSecrets`
    ), n = Object.entries(t).map(
      ([i, s]) => ({ name: i, value: s })
    );
    return { success: e, secrets: n };
  }
  async getClusterDetails() {
    if (this.authConfig === void 0 || this.authConfig.type === "sm")
      return { success: !1 };
    const { success: e, response: t } = await this.getWithErrorHandling(
      `/cloud/console/organizations/${this.authConfig.config.organizationId}/clusters?useCache=false`
    ), n = this.authConfig.config.clusterId;
    return e ? {
      success: !0,
      cluster: t.find(({ uuid: i }) => i === n)
    } : { success: !1 };
  }
  async setConnectorSecret({ name: e, value: t }) {
    return { success: !1 };
  }
  async terminateProcessInstance(e) {
    return { success: !1 };
  }
  async deploy({ name: e, content: t }) {
    const { response: n, success: i } = await this.postWithErrorHandling("/play/deploy", {
      name: e,
      content: t
    });
    return {
      response: n,
      success: i
    };
  }
  async deployResources(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/deploy-resources", { resources: e });
    return {
      response: t,
      success: n
    };
  }
  async startInstance({
    bpmnProcessId: e,
    variables: t
  }) {
    const { success: n, response: i } = await this.postWithErrorHandling("/play/start-instance", {
      bpmnProcessId: e,
      variables: JSON.parse(t)
    });
    return { instanceId: i.processInstanceKey, success: n };
  }
  async fetchJobs({ instanceKey: e }) {
    return { jobs: [], success: !1 };
  }
  async fetchFlowNodeInstances(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-flownode-instances", {
      processInstanceKey: e
    });
    return {
      flowNodeInstances: t.items,
      success: n
    };
  }
  async fetchChildInstances({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-child-instances", {
      parentProcessInstanceKey: e
    });
    return {
      childInstances: t.items,
      success: n
    };
  }
  async fetchInstances(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-process-instances", {
      processDefinitionKey: e
    });
    return {
      processInstances: t?.items ?? [],
      totalCount: t?.total ?? 0,
      success: n
    };
  }
  async fetchMessageSubscriptions({ instanceKey: e }) {
    return {
      messageSubscriptions: [],
      success: !1
    };
  }
  async fetchProcessMessageSubscriptions() {
    return {
      messageSubscriptions: [],
      success: !1
    };
  }
  async fetchUserTasks(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-user-tasks", {
      instanceId: e
    });
    return {
      userTasks: n ? t : [],
      success: n
    };
  }
  async fetchUserTaskForm(e, t) {
    const { response: n, success: i } = await this.postWithErrorHandling("/play/get-user-task-form", {
      formId: e,
      processDefinitionKey: t
    });
    return {
      schema: n.schema,
      success: i
    };
  }
  async completeJob({
    processInstanceKey: e,
    taskDefinitionType: t,
    variables: n,
    elementId: i
  }) {
    const { success: s } = await this.postWithErrorHandling("/play/complete-job", {
      processInstanceKey: e,
      taskDefinitionType: t,
      variables: n,
      elementId: i
    });
    return {
      success: s
    };
  }
  async completeUserTask({
    taskId: e,
    variables: t,
    isZeebeUserTask: n
  }) {
    const i = rf(t) ? JSON.parse(t) : {}, { success: s } = await this.postWithErrorHandling(
      n ? "/play/complete-zeebe-user-task" : "/play/complete-user-task",
      {
        variables: i,
        taskId: e
      }
    );
    return { success: s };
  }
  async throwError({
    taskDefinitionType: e,
    processInstanceKey: t,
    errorCode: n,
    elementId: i
  }) {
    const { success: s } = await this.postWithErrorHandling("/play/throw-error", {
      errorCode: n,
      errorMessage: "",
      processInstanceKey: t,
      taskDefinitionType: e,
      elementId: i
    });
    return { success: s };
  }
  async publishMessage({
    messageName: e,
    correlationKey: t,
    variables: n,
    timeToLive: i,
    messageId: s
  }) {
    const { success: o } = await this.postWithErrorHandling(
      "/play/publish-message",
      {
        messageName: e,
        correlationKey: t || void 0,
        variables: rf(n) ? JSON.parse(n) : {},
        timeToLive: i || void 0,
        messageId: s || void 0
      }
    );
    return { success: o };
  }
  async fetchVariablesByUserTask(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-user-task-variables", {
      taskId: e
    });
    return {
      variables: n ? t : [],
      success: n
    };
  }
  async fetchInstanceDetails(e) {
    const { response: t, success: n, status: i } = await this.postWithErrorHandling(
      "/play/get-process-instance",
      {
        instanceId: e
      }
    );
    return {
      statusCode: i,
      processInstance: t,
      success: n
    };
  }
  async fetchIncidents(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-incidents", {
      processInstanceKey: e
    });
    return {
      incidents: t.items,
      success: n
    };
  }
  async fetchVariables({ instanceKey: e }) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-variables", {
      processInstanceKey: e
    });
    return {
      variables: t.items,
      success: n
    };
  }
  async fetchVariable(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-variable", {
      variableKey: e
    });
    return {
      variable: t,
      success: n
    };
  }
  async setVariables({
    elementInstanceKey: e,
    variablesString: t
  }) {
    const { success: n } = await this.postWithErrorHandling("/play/set-variables", {
      elementInstanceKey: e,
      variables: JSON.parse(t)
    });
    return { success: n };
  }
  async updateRetries({ jobKey: e, retries: t }) {
    const { success: n } = await this.postWithErrorHandling(
      "/play/update-job-retries",
      {
        jobKey: e,
        retries: t
      }
    );
    return { success: n };
  }
  async resolveIncident(e) {
    const { success: t } = await this.postWithErrorHandling(
      "/play/resolve-incident",
      {
        incidentKey: e
      }
    );
    return { success: t };
  }
  async fetchSequenceFlows(e) {
    const { response: t, success: n } = await this.postWithErrorHandling(
      "/play/get-sequence-flows",
      {
        processInstanceKey: e
      }
    );
    return {
      sequenceFlows: Array.isArray(t) ? t : [],
      success: n
    };
  }
  async fetchStatistics(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-process-instance-statistics", {
      processInstanceKey: e
    });
    return {
      statistics: Array.isArray(t) ? t : [],
      success: n
    };
  }
  async fetchDecisionInstances(e) {
    const { response: t, success: n } = await this.postWithErrorHandling("/play/get-decision-instances", {
      processInstanceKey: e
    });
    return {
      items: t.items,
      success: n
    };
  }
  async modify({
    processInstanceKey: e,
    activateInstructions: t,
    terminateInstructions: n
  }) {
    const { success: i } = await this.postWithErrorHandling("/play/modify", {
      processInstanceKey: e,
      activateInstructions: t,
      terminateInstructions: n
    });
    return {
      success: i
    };
  }
  async broadcastSignal({
    signalName: e,
    variables: t = "{}"
  }) {
    const n = rf(t) ? JSON.parse(t) : {}, { success: i } = await this.postWithErrorHandling(
      "/play/broadcast-signal",
      {
        signalName: e,
        variables: n
      }
    );
    return {
      success: i
    };
  }
}
const At = new KGt(), zr = {
  title: "Unable to process request",
  subtitle: "Please try again"
}, YGt = 255, ePe = "var(--cds-spacing-08)", hv = "Instance started", XGt = [
  "bpmn:ServiceTask",
  "bpmn:UserTask",
  "bpmn:ReceiveTask",
  "bpmn:IntermediateCatchEvent",
  "bpmn:SendTask"
], tPe = [
  "bpmn:ServiceTask",
  "bpmn:SendTask",
  "bpmn:ScriptTask",
  "bpmn:BusinessRuleTask",
  "bpmn:IntermediateThrowEvent",
  "bpmn:EndEvent"
], LH = `{
  "variableName": "variableValue"
}`, Jb = 1e3, JGt = "New BPMN Diagram", I_e = 18, kH = "latest", GS = {
  status: "initial",
  cluster: void 0
}, $Gt = 3e3;
class eQt {
  state = { ...GS };
  organizationId = void 0;
  clusterId = void 0;
  pollingDisposer = null;
  intervalId = null;
  isPollRequestRunning = !1;
  constructor() {
    xs(this, {
      state: $n,
      handleSuccess: Et,
      isClusterHealthy: qn,
      reset: Et
    });
  }
  init() {
    this.state = { ...GS }, this.pollingDisposer = A7(() => {
      this.intervalId === null && this.startPolling();
    });
  }
  startPolling() {
    this.intervalId = setInterval(() => {
      this.poll();
    }, $Gt);
  }
  async poll() {
    if (!this.isPollRequestRunning) {
      this.isPollRequestRunning = !0;
      const { success: e, cluster: t } = await At.getClusterDetails();
      e && this.handleSuccess(t), this.isPollRequestRunning = !1;
    }
  }
  handleSuccess = (e) => {
    this.state.status = "fetched", this.state.cluster = e;
  };
  stopPolling() {
    const { intervalId: e } = this;
    e !== null && (clearInterval(e), this.intervalId = null);
  }
  get isClusterHealthy() {
    const { cluster: e, status: t } = this.state;
    if (t === "initial")
      return !0;
    if (e === void 0)
      return !1;
    const { operate: n, tasklist: i, zeebe: s } = e.status;
    return n === "Healthy" && i === "Healthy" && s === "Healthy";
  }
  reset() {
    this.state = { ...GS }, this.pollingDisposer?.(), this.stopPolling();
  }
}
const Zp = new eQt();
class Th {
  boundCallback;
  intervalId = null;
  isPollRequestRunning = !1;
  pollingDisposer = null;
  fetchDataDisposer = null;
  constructor() {
    xs(this, {
      reset: Et.bound
    });
  }
  init() {
    this.fetchDataDisposer = Xp(this.initialDataFetchCondition, () => {
      this.fetchData();
    }), this.pollingDisposer = A7(() => {
      this.pollDataCondition() && Zp.isClusterHealthy ? this.intervalId === null && this.startPolling(this.pollData) : this.stopPolling();
    });
  }
  startPolling(e) {
    this.intervalId = setInterval(() => {
      this.boundCallback = e.bind(this), this.poll();
    }, Jb);
  }
  stopPolling() {
    const { intervalId: e } = this;
    e !== null && (clearInterval(e), this.intervalId = null, this.shouldRefreshDataAfterPollingStops && setTimeout(() => {
      this.boundCallback?.();
    }, Jb));
  }
  async poll() {
    this.isPollRequestRunning || (this.isPollRequestRunning = !0, this.boundCallback && await this.boundCallback(), this.isPollRequestRunning = !1);
  }
  reset() {
    this.stopPolling(), this.pollingDisposer?.(), this.fetchDataDisposer?.();
  }
}
const NT = () => (localStorage.getItem("play-firstProcessCompleted") ?? "false").toLowerCase() === "true", tQt = () => {
  localStorage.setItem("play-firstProcessCompleted", "true");
};
function yC(r) {
  return JSON.parse(
    localStorage.getItem(`${r} scenarios`) || "[]"
  );
}
function nQt(r, e) {
  const n = JSON.parse(
    localStorage.getItem(`${r} scenarios`) || "[]"
  ).filter(
    ({ key: i }) => i !== e
  );
  localStorage.setItem(
    `${r} scenarios`,
    JSON.stringify(n)
  );
}
function nPe({
  bpmnProcessId: r,
  processInstanceId: e,
  name: t,
  actions: n,
  coveredFlowNodes: i,
  coveredSequenceFlows: s
}) {
  const o = yC(r);
  o.push({
    key: `${r}-${t}`,
    processInstanceId: e,
    name: t,
    actions: n,
    coveredFlowNodes: i,
    coveredSequenceFlows: s
  }), localStorage.setItem(
    `${r} scenarios`,
    JSON.stringify(o)
  );
}
function iQt({
  bpmnProcessId: r,
  processInstanceId: e,
  name: t,
  actions: n,
  coveredFlowNodes: i,
  coveredSequenceFlows: s
}) {
  const o = yC(r), a = o.find(
    (l) => l.name === t
  );
  if (a !== void 0) {
    const l = o.filter(
      (c) => c.name !== t
    );
    localStorage.setItem(
      `${r} scenarios`,
      JSON.stringify([
        {
          ...a,
          processInstanceId: e,
          actions: n,
          coveredFlowNodes: i,
          coveredSequenceFlows: s
        },
        ...l
      ])
    );
  }
}
const iu = ({
  requestedProcessInstanceKey: r,
  currentProcessInstanceKey: e
}) => r === e, iPe = "Not saved", O_e = {
  instanceKey: void 0,
  processInstance: void 0,
  status: "initial",
  isProcessManuallyCompleted: !1,
  isCalledProcess: !1,
  instanceType: void 0,
  scenarioName: iPe
};
class rQt extends Th {
  state = { ...O_e };
  processManuallyCompletedDisposer = null;
  calledProcessDisposer = null;
  scenarioNameDisposer = null;
  refetchTimeout = null;
  constructor() {
    super(), xs(this, {
      state: $n,
      setIsProcessManuallyCompleted: Et,
      setIsCalledProcess: Et,
      setInstanceDetails: Et,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      setScenarioName: Et,
      reset: yh,
      isRunning: qn,
      hasError: qn,
      isInstanceDetailPageVisible: qn
    });
  }
  shouldRefreshDataAfterPollingStops = !1;
  initialDataFetchCondition = () => Ne.state.instanceKey !== void 0;
  pollDataCondition = () => this.state.processInstance !== void 0 && this.state.processInstance.state !== "COMPLETED" && this.state.processInstance.state !== "CANCELED" && this.state.instanceKey !== void 0;
  fetchData = () => this.fetchInstanceDetails({ refetchWhenNotFound: !0 });
  pollData = () => this.fetchInstanceDetails({ ignoreFailure: !0 });
  init = () => {
    super.init(), this.calledProcessDisposer = Xp(
      () => this.state.processInstance !== void 0,
      () => {
        const e = JSON.parse(
          localStorage.getItem("play-calledProcesses") || "[]"
        ), t = this.state.processInstance?.key !== void 0 && e.includes(this.state.processInstance?.key);
        this.setIsCalledProcess(t);
      }
    ), this.processManuallyCompletedDisposer = ms(
      () => this.state.processInstance?.state,
      (e, t) => {
        t !== void 0 && t !== "COMPLETED" && e === "COMPLETED" && !NT() && this.setIsProcessManuallyCompleted(!0);
      }
    ), this.scenarioNameDisposer = Xp(
      () => this.state.instanceKey !== void 0 && this.state.processInstance?.bpmnProcessId !== void 0,
      () => {
        const t = yC(
          this.state.processInstance.bpmnProcessId
        ).find(
          ({ processInstanceId: n }) => n === this.state.instanceKey
        );
        this.setScenarioName(
          t === void 0 ? "Not saved" : t.name
        );
      }
    );
  };
  setScenarioName = (e) => {
    this.state.scenarioName = e;
  };
  setIsProcessManuallyCompleted = (e) => {
    this.state.isProcessManuallyCompleted = e;
  };
  setIsCalledProcess = (e) => {
    this.state.isCalledProcess = e;
  };
  fetchInstanceDetails = async ({
    refetchWhenNotFound: e = !1,
    ignoreFailure: t = !1
  }) => {
    const n = this.state.instanceKey;
    this.startFetching();
    const { statusCode: i, success: s, processInstance: o } = await At.fetchInstanceDetails(n);
    iu({
      requestedProcessInstanceKey: n,
      currentProcessInstanceKey: this.state.instanceKey
    }) && (s ? (this.handleSuccess(o), this.resetRefetch()) : i === 404 && e ? this.handleRefetch() : t || this.handleError());
  };
  handleRefetch = () => {
    this.refetchTimeout = setTimeout(() => {
      this.fetchInstanceDetails({ refetchWhenNotFound: !0 });
    }, Jb);
  };
  resetRefetch = () => {
    this.refetchTimeout !== null && clearTimeout(this.refetchTimeout);
  };
  setInstanceDetails = ({
    instanceKey: e,
    instanceType: t
  }) => {
    this.state.instanceKey = e, this.state.instanceType = t;
  };
  handleSuccess = (e) => {
    Ar(this.state.processInstance, e) || (this.state.processInstance = e), this.state.status = "fetched";
  };
  startFetching = () => {
    ["initial", "first-fetch"].includes(this.state.status) ? this.state.status = "first-fetch" : this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get hasError() {
    return this.state.status === "error";
  }
  handlePolling = async (e) => {
    this.isPollRequestRunning = !0;
    const { success: t, processInstance: n } = await At.fetchInstanceDetails(e);
    this.intervalId !== null && t && n !== void 0 && this.handleSuccess(n), this.isPollRequestRunning = !1;
  };
  get isRunning() {
    const { processInstance: e } = this.state;
    return e === void 0 ? !1 : ["ACTIVE", "INCIDENT"].includes(e.state);
  }
  get isCompleted() {
    const { processInstance: e } = this.state;
    return e === void 0 ? !1 : e.state === "COMPLETED";
  }
  get isInstanceDetailPageVisible() {
    return this.state.instanceKey !== void 0;
  }
  reset() {
    super.reset(), this.processManuallyCompletedDisposer?.(), this.calledProcessDisposer?.(), this.scenarioNameDisposer?.(), this.state = { ...O_e };
  }
}
const Ne = new rQt();
function TT(r) {
  return r?.loopCharacteristics?.$type === "bpmn:MultiInstanceLoopCharacteristics";
}
function NH(r) {
  const e = an(r);
  return p2(e, "zeebe:TaskDefinition")?.type;
}
function sQt(r) {
  const e = an(r), t = p2(
    e,
    "zeebe:ExecutionListeners"
  );
  if (t === void 0 || t.listeners === void 0)
    return;
  const { eventType: n, type: i } = t.listeners[0];
  return { type: i, eventType: n };
}
function rPe(r) {
  return He(r, "bpmn:FlowNode");
}
function oQt(r) {
  return He(r, "bpmn:Error");
}
function aQt(r) {
  return He(r, "bpmn:BoundaryEvent") && Gg(r);
}
function lQt(r) {
  return He(r, "bpmn:StartEvent") && Gg(r);
}
function cQt(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => rPe(e));
}
function hQt(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => oQt(e));
}
function dQt(r) {
  return r === void 0 ? [] : r.filter(
    (e) => tPe.includes(e.type) && NH(e) !== void 0
  );
}
function uQt(r) {
  return r === void 0 ? [] : r.filter(
    (e) => sQt(e) !== void 0
  );
}
const fQt = (r) => aQt(r) || lQt(r);
function pQt(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => fQt(e));
}
function TH(r) {
  return He(r, "bpmn:StartEvent");
}
function IH(r) {
  return TH(r) && zf(r, "bpmn:MessageEventDefinition");
}
function OH(r) {
  return TH(r) && zf(r, "bpmn:SignalEventDefinition");
}
function gQt(r) {
  return He(r, "bpmn:ReceiveTask");
}
function mQt(r) {
  return He(r, "bpmn:BoundaryEvent") && zf(r, "bpmn:MessageEventDefinition");
}
function AQt(r) {
  return He(r, "bpmn:BoundaryEvent") && zf(r, "bpmn:SignalEventDefinition");
}
function wQt(r) {
  return IH(r) || mQt(r) || sPe(r);
}
function vQt(r) {
  return OH(r) || AQt(r) || oPe(r);
}
function sPe(r) {
  return He(r, "bpmn:IntermediateCatchEvent") && zf(r, "bpmn:MessageEventDefinition");
}
function oPe(r) {
  return He(r, "bpmn:IntermediateCatchEvent") && zf(r, "bpmn:SignalEventDefinition");
}
function aPe(r) {
  return IH(r) && r.$parent?.triggeredByEvent;
}
function lPe(r) {
  return OH(r) && r.$parent?.triggeredByEvent;
}
function bQt(r) {
  return r.eventDefinitions?.find(
    (e) => He(e, "bpmn:MessageEventDefinition")
  )?.messageRef;
}
function yQt(r) {
  return r.eventDefinitions?.find(
    (e) => He(e, "bpmn:SignalEventDefinition")
  )?.signalRef;
}
function CQt(r) {
  return r?.extensionElements?.values?.find(
    (e) => He(e, "zeebe:subscription")
  )?.correlationKey;
}
function EQt(r) {
  return r === void 0 ? [] : Object.values(r).filter(
    (e) => wQt(e) || gQt(e)
  ).map((e) => {
    const t = e.messageRef ?? bQt(e);
    let n;
    if (sPe(e)) {
      const i = e.incoming?.at(0)?.sourceRef;
      n = He(i, "bpmn:EventBasedGateway") ? i?.id : void 0;
    }
    return {
      elementId: e.id,
      element: e,
      messageName: t?.name,
      messageCorrelationKey: CQt(t),
      attachedToElementId: e.attachedToRef?.id ?? n,
      isSubProcessStartEvent: aPe(e)
    };
  });
}
function _Qt(r) {
  return r === void 0 ? [] : Object.values(r).filter((e) => vQt(e)).map((e) => {
    const t = e.signalRef ?? yQt(e);
    let n;
    if (oPe(e)) {
      const i = e.incoming?.at(0)?.sourceRef;
      n = He(i, "bpmn:EventBasedGateway") ? i?.id : void 0;
    }
    return {
      elementId: e.id,
      element: e,
      signalName: t.name,
      attachedToElementId: e.attachedToRef?.id ?? n,
      isSubProcessStartEvent: lPe(e)
    };
  });
}
function xQt(r) {
  return an(r).modelerTemplate !== void 0;
}
function SQt(r) {
  return (r.incoming ?? []).some((t) => He(t.sourceRef, "bpmn:EventBasedGateway"));
}
function MQt(r) {
  return TT(r.$parent);
}
function DQt(r) {
  return !tSe(r) && !He(r, "bpmn:StartEvent") && !He(r, "bpmn:BoundaryEvent") && !SQt(r) && !MQt(r);
}
class LQt {
  constructor() {
    this.browser = {}, this.unsupportedBrowsers = {
      Chrome: 61,
      Firefox: 55,
      IE: 11,
      Edge: 15,
      Opera: 50,
      Safari: 10
    }, this._detectBrowser();
  }
  /**
   * Detects the current browser and its version number.
   *
   * @returns {Object} An object with keys for browser `name` and `version`.
   */
  _detectBrowser() {
    this.browser = function() {
      if (typeof navigator > "u") return;
      let e = navigator.userAgent, t, n = e.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
      return /trident/i.test(n[1]) ? (t = /\brv[ :]+(\d+)/g.exec(e) || [], { name: "IE", version: t[1] || "" }) : n[1] === "Chrome" && (t = e.match(/\b(OPR|Edge)\/(\d+)/), t != null) ? { name: t[1].replace("OPR", "Opera"), version: t[2] } : (n = n[2] ? [n[1], n[2]] : [navigator.appName, navigator.appVersion, "-?"], (t = e.match(/version\/(\d+)/i)) != null && n.splice(1, 1, t[1]), { name: n[0], version: n[1] });
    }();
  }
  /**
   * Checks if the current browser is Internet Explorer.
   *
   * @returns {Boolean}
   */
  get isIE() {
    return this.browser.name === "IE";
  }
  /**
   * Checks if the current browser is Edge.
   *
   * @returns {Boolean}
   */
  get isEdge() {
    return this.browser.name === "Edge";
  }
  /**
   * Checks if the current browser is from Microsoft (Edge
   * or Internet Explorer).
   *
   * @returns {Boolean}
   */
  get isMicrosoft() {
    return this.isIE || this.isEdge;
  }
  /**
   * Checks if the current browser is Firefox.
   *
   * @returns {Boolean}
   */
  get isFirefox() {
    return this.browser.name === "Firefox";
  }
  /**
   * Checks if the current browser is Chrome.
   *
   * @returns {Boolean}
   */
  get isChrome() {
    return this.browser.name === "Chrome";
  }
  /**
   * Checks if the current browser is Safari.
   *
   * @returns {Boolean}
   */
  get isSafari() {
    return this.browser.name === "Safari";
  }
  /**
   * Checks if the current browser is from an Android device.
   *
   * @returns {Boolean}
   */
  get isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is from a BlackBerry device.
   *
   * @returns {Boolean}
   */
  get isBlackBerry() {
    return /BlackBerry/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is from a Windows Mobile device.
   *
   * @returns {Boolean}
   */
  get isWindowsMobile() {
    return /IEMobile/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is Mobile Safari.
   *
   * @returns {Boolean}
   */
  get isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }
  /**
   * Checks if the current browser is a mobile browser.
   *
   * @returns {Boolean}
   */
  get isMobile() {
    return this.isAndroid || this.isBlackBerry || this.isWindowsMobile || this.isIOS;
  }
  /**
   * Checks if the current browser is supported by
   * our environment.
   *
   * @returns {Boolean}
   */
  isSupported() {
    return !!(Object.prototype.hasOwnProperty.call(
      //@ts-expect-error Property 'unsupportedBrowsers' does not exist on type 'BrowserDetector'.ts(2339)
      this.unsupportedBrowsers,
      //@ts-expect-error Property 'browser' does not exist on type 'BrowserDetector'.ts(2339)
      this.browser.name
    ) && +this.browser.version > this.unsupportedBrowsers[this.browser.name]);
  }
}
const kQt = new Q4();
function NQt(r) {
  return kQt.fromXML(r);
}
function R_e(r) {
  return an(r).get("extensionElements")?.get("values")?.find((i) => He(i, "zeebe:FormDefinition"));
}
const TQt = (r) => He(r, "bpmn:BusinessRuleTask"), IQt = (r) => r?.get("values").filter((e) => e.$type === "zeebe:CalledDecision" || e.$type === "zeebe:calledDecision")[0], OQt = (r) => {
  const e = IQt(r);
  return {
    decisionId: e?.decisionId?.trim(),
    bindingType: e?.bindingType ?? kH
  };
}, RQt = (r) => r?.trim()?.startsWith("="), VQt = "bpmn:Process";
function HQt(r) {
  if (!r)
    throw new Error(
      "You need to pass modeler definitions to get the processId of the executable process"
    );
  let e, t;
  const n = r.rootElements;
  if (n)
    return n.forEach((i) => {
      i.$type === VQt && (t || (t = i), e || i.isExecutable && (e = i));
    }), e || (e = t), e;
}
const BQt = (r) => r === "zeebe:CalledElement" || r === "zeebe:calledElement", PQt = (r) => r?.get("values").filter((e) => BQt(e.$type))[0], FQt = (r) => {
  const e = PQt(r);
  return {
    processId: e?.processId?.trim(),
    bindingType: e?.bindingType ?? kH
  };
};
function zQt(r) {
  const e = p2(r, "zeebe:formDefinition");
  return {
    formId: e?.get("formId") ?? null,
    bindingType: e?.bindingType ?? kH
  };
}
function cPe({
  projectId: r,
  elementBusinessObjects: e,
  fetchFilesByDecisionId: t,
  fetchFilesByProcessId: n,
  fetchFilesByFormId: i,
  fetchFileById: s,
  relatedFiles: o = {}
}) {
  const a = e.reduce((l, c) => {
    const { formId: d, bindingType: u } = zQt(c);
    if (d !== null && l.push({
      id: d,
      elementBusinessObject: c,
      type: "form",
      bindingType: u
    }), TQt(c)) {
      const { decisionId: f, bindingType: p } = OQt(
        c?.get("extensionElements")
      );
      f && !RQt(f) && l.push({
        elementBusinessObject: c,
        id: f,
        type: "decision",
        bindingType: p
      });
    }
    if (He(c, "bpmn:CallActivity")) {
      const { processId: f, bindingType: p } = FQt(
        c?.get("extensionElements")
      );
      f && l.push({
        elementBusinessObject: c,
        id: f,
        type: "process",
        bindingType: p
      });
    }
    return l;
  }, []).map(
    ({ id: l, elementBusinessObject: c, bindingType: d, type: u }) => jQt({
      projectId: r,
      type: u,
      bindingType: d,
      id: l,
      relatedFiles: o,
      elementBusinessObject: c,
      fetchFilesByDecisionId: t,
      fetchFilesByProcessId: n,
      fetchFilesByFormId: i,
      fetchFileById: s
    })
  ) ?? [];
  return Promise.all(a);
}
async function WQt({
  projectId: r,
  elementBusinessObjects: e,
  fetchFilesByDecisionId: t,
  fetchFilesByProcessId: n,
  fetchFilesByFormId: i,
  fetchFileById: s,
  relatedFiles: o = {}
}) {
  return await cPe({
    projectId: r,
    elementBusinessObjects: e,
    fetchFilesByDecisionId: t,
    fetchFilesByProcessId: n,
    fetchFilesByFormId: i,
    fetchFileById: s,
    relatedFiles: o
  }), Promise.all(Object.values(o));
}
function jQt({
  projectId: r,
  type: e,
  bindingType: t,
  id: n,
  relatedFiles: i,
  elementBusinessObject: s,
  fetchFilesByDecisionId: o,
  fetchFilesByProcessId: a,
  fetchFilesByFormId: l,
  fetchFileById: c
}) {
  const d = e + "_" + n;
  if (i[d] === void 0)
    return i[d] = new Promise((u) => {
      (async () => {
        let f = [];
        try {
          e === "decision" ? f = await o(r, n) : e === "form" ? f = await l(r, n) : f = await a(r, n);
        } catch (g) {
          console.error("Error fetching file", g);
        }
        let p = null;
        if (f?.[0]?.id && (p = await c(f[0].id)), e === "process" && p?.content) {
          const m = await new Q4().fromXML(p.content), A = Object.values(
            m.elementsById
          );
          await cPe({
            projectId: r,
            elementBusinessObjects: A,
            fetchFilesByDecisionId: o,
            fetchFilesByProcessId: a,
            fetchFilesByFormId: l,
            fetchFileById: c,
            relatedFiles: i
          });
        }
        u({
          type: e,
          bindingType: t,
          id: n,
          elementBusinessObject: s,
          filename: f?.[0]?.name ?? null,
          fileId: f?.[0]?.id ?? null,
          fileType: f?.[0]?.type ?? null,
          content: p?.content ?? null,
          status: "waiting"
        });
      })();
    }), i[d];
}
const ZQt = (r) => hPe()[r], hPe = () => JSON.parse(localStorage.getItem("zeebePlayDeployments") || "{}"), UQt = (r, e) => {
  const t = hPe();
  t[r] = e, localStorage.setItem("zeebePlayDeployments", JSON.stringify(t));
};
function qQt(r) {
  switch (r) {
    case "decision":
      return "dmn";
    case "form":
      return "form";
    case "process":
    default:
      return "bpmn";
  }
}
function V_e(r, e) {
  return `${r}.${qQt(e)}`;
}
const H_e = (r) => {
  const e = [];
  if (r) {
    const t = r.indexOf("Element:");
    if (t !== -1) {
      const i = r.substring(t).split(`
`);
      if (Array.isArray(i)) {
        let s = 0;
        for (; s < i.length; ) {
          const o = i[s];
          if (o?.includes("Element: ") && o.split("Element: ").length === 2) {
            const a = o.split("Element: ")[1];
            for (s++; i[s]?.includes("ERROR: "); ) {
              const l = i[s];
              if (l.split("ERROR: ").length === 2) {
                const c = l.split("ERROR: ")[1];
                e.push({ category: "error", id: a, message: c }), s++;
              }
            }
          } else
            s++;
        }
      }
    } else {
      const i = r.split(`
`);
      Array.isArray(i) && (i.length === 2 ? e.push({ category: "error", id: "", message: i[1] }) : i.length === 1 && e.push({ category: "error", id: "", message: i[0] }));
    }
  }
  return e;
};
function dPe(r) {
  return r.replaceAll(/ bioc:([^"]+")([^"]+")/gm, "");
}
const B_e = {
  status: "initial",
  isRedeployment: !1,
  processedFiles: void 0,
  deployedProcess: void 0,
  processDefinitionKey: void 0
};
class GQt {
  state = { ...B_e };
  disposer = null;
  xml;
  projectId;
  processId;
  processName;
  fetchFilesByProcessId;
  fetchFilesByDecisionId;
  fetchFilesByFormId;
  fetchFileById;
  onDeploymentError;
  consoleSecretsUrl;
  consoleDashboardPageUrl;
  updateFileById;
  currentDiagramRevision = 0;
  originAppInstanceId;
  canUserSaveExampleData = !1;
  diagramId;
  authType;
  operateBaseUrl;
  constructor() {
    Hi(this);
  }
  init({
    xml: e,
    projectId: t,
    processId: n,
    processName: i,
    fetchFilesByProcessId: s,
    fetchFilesByDecisionId: o,
    fetchFileById: a,
    fetchFilesByFormId: l,
    onDeploymentError: c,
    consoleDashboardPageUrl: d,
    clusterId: u,
    currentDiagramRevision: f,
    updateFileById: p,
    originAppInstanceId: g,
    canUserSaveExampleData: m,
    diagramId: A,
    authType: w,
    operateBaseUrl: v
  }) {
    this.xml = e, this.processId = n, this.projectId = t, this.processName = i, this.fetchFilesByProcessId = s, this.fetchFilesByDecisionId = o, this.fetchFileById = a, this.fetchFilesByFormId = l, this.onDeploymentError = c, this.consoleSecretsUrl = `${d}/cluster/${u}/secrets`, this.consoleDashboardPageUrl = d, this.currentDiagramRevision = f, this.updateFileById = p, this.originAppInstanceId = g, this.canUserSaveExampleData = m, this.diagramId = A, this.authType = w, this.operateBaseUrl = v;
  }
  get isEnvironmentCreated() {
    return this.state.status === "environment-created";
  }
  get hasDiagramError() {
    return this.state.deployedProcess?.status === "diagram-error";
  }
  setIsRedeployment = (e) => {
    this.state.isRedeployment = e;
  };
  setDeployedProcess = (e) => {
    this.state.deployedProcess = e;
  };
  setProcessedFiles = (e) => {
    this.state.processedFiles = e;
  };
  setStatus = (e) => {
    this.state.status = e;
  };
  setProcessDefinitionKey = (e) => {
    this.state.processDefinitionKey = e;
  };
  setupEnvironment = async () => {
    this.setStatus("deploying-files");
    const e = dPe(this.xml);
    try {
      const t = await WQt({
        projectId: this.projectId,
        elementBusinessObjects: Nt.state.elementsById === void 0 ? [] : Object.values(Nt.state.elementsById),
        fetchFilesByDecisionId: this.fetchFilesByDecisionId,
        fetchFilesByProcessId: this.fetchFilesByProcessId,
        fetchFilesByFormId: this.fetchFilesByFormId,
        fetchFileById: this.fetchFileById
      }), n = t.filter(({ content: o }) => o === null).map((o) => ({
        ...o,
        status: "not found"
      })), i = await this.deployFiles({
        filesInfo: t.filter(
          ({ content: o }) => o !== null
        )
      }), s = await this.deployProcess(
        e,
        t.filter(
          ({ bindingType: o, content: a }) => o === "deployment" && a !== null
        )
      );
      this.setDeployedProcess(s), this.setProcessedFiles([...n, ...i]), await Nt.fetchLinkedStartForm(), this.setStatus("environment-created");
    } catch (t) {
      console.error("Uncaught file deployment error", t);
    }
  };
  updateFile = async () => {
    const e = await Nt.toXml?.();
    if (e?.error)
      return { success: !1, reason: "serialization" };
    const t = e?.xml;
    if (this.xml === t)
      return { success: !1, reason: "unchanged" };
    const n = Nt.state.viewer?.getDefinitions(), i = n.$attrs["camunda:diagramRelationId"] ?? n.diagramRelationId, s = {
      content: t,
      revision: this.currentDiagramRevision,
      relationId: i,
      originAppInstanceId: this.originAppInstanceId
    };
    try {
      const o = await this.updateFileById?.(this.diagramId, s);
      return Jn.trackDiagramUpdated(), this.currentDiagramRevision = o.revision, this.xml = t, { success: !0 };
    } catch (o) {
      return o?.status === 409 ? { success: !1, reason: "conflict" } : { success: !1, reason: "unknown" };
    }
  };
  deployFiles = async ({
    filesInfo: e = []
  }) => Promise.all(
    e.map(async (t) => {
      if (t.bindingType === "versionTag")
        return {
          ...t,
          status: "unsupported binding"
        };
      if (t.bindingType === "deployment")
        return {
          ...t,
          status: "success"
        };
      const { response: n, success: i } = await At.deploy({
        content: t.content,
        name: V_e(t.filename, t.type)
      });
      if (i)
        Jn.trackDeployment({
          success: !0,
          fileId: t.fileId ?? void 0,
          fileType: t.fileType
        });
      else {
        const s = n;
        Jn.trackDeployment({
          success: !1,
          errorMessage: s.detail,
          fileId: t.fileId ?? void 0,
          fileType: t.fileType
        }), Jn.trackDiagramErrors({
          count: H_e(s.detail).length,
          fileId: t.fileId ?? void 0,
          fileType: t.fileType
        });
      }
      return {
        ...t,
        status: i ? "success" : "deployment error"
      };
    })
  );
  deployProcess = async (e, t) => {
    const n = !!ZQt(this.processId);
    this.setIsRedeployment(n);
    const { response: i, success: s } = await At.deployResources([
      {
        content: e,
        name: `${this.processName ?? JGt}.bpmn`
      },
      ...t.map((o) => ({
        content: o.content,
        name: V_e(o.filename, o.type)
      }))
    ]);
    if (s) {
      const a = i.deployments[0].process.processDefinitionKey;
      return UQt(this.processId, a), Jn.trackDeployment({
        success: !0,
        fileId: this.diagramId,
        fileType: "bpmn"
      }), this.setProcessDefinitionKey(a), { status: "success" };
    } else {
      const o = i;
      Jn.trackDeployment({
        success: !1,
        errorMessage: o.detail,
        fileId: this.diagramId,
        fileType: "bpmn"
      }), Jn.trackDiagramErrors({
        count: H_e(o.detail).length,
        fileId: this.diagramId,
        fileType: "bpmn"
      });
      const a = [
        {
          detail: o.detail ?? "Unknown error"
        }
      ];
      return this.onDeploymentError?.(a), { status: "diagram-error" };
    }
  };
  get fileProblems() {
    return this.state.processedFiles?.filter((e) => e.status !== "success") ?? [];
  }
  get sanitizedOperateBaseUrl() {
    if (this.operateBaseUrl !== void 0)
      return this.operateBaseUrl.endsWith("/") ? this.operateBaseUrl.slice(0, -1) : this.operateBaseUrl;
  }
  get hasLinkToOperate() {
    return this.authType === "saas" && this.sanitizedOperateBaseUrl !== void 0;
  }
  reset = () => {
    this.state = { ...B_e };
  };
}
const gt = new GQt(), P_e = { selection: null };
class QQt {
  state = { ...P_e };
  rootNodeSelectionDisposer = null;
  constructor() {
    Hi(this, { init: !1 });
  }
  init = () => {
    this.rootNodeSelectionDisposer = Xp(
      () => Ne.state.processInstance?.key !== void 0,
      () => this.clearSelection()
    );
  };
  setSelection = (e) => {
    this.state.selection = e;
  };
  clearSelection = () => {
    this.setSelection(this.rootNode);
  };
  selectFlowNode = (e) => {
    e.flowNodeId === void 0 || !this.areMultipleInstancesSelected && this.isSelected(e) ? this.clearSelection() : this.setSelection(e);
  };
  get selectedFlowNodeId() {
    return this.state.selection?.flowNodeId;
  }
  get areMultipleInstancesSelected() {
    if (this.state.selection === null)
      return !1;
    const { flowNodeInstanceId: e, flowNodeId: t } = this.state.selection;
    return t !== void 0 && e === void 0;
  }
  get rootNode() {
    return {
      flowNodeInstanceId: Ne.state.processInstance?.key,
      isMultiInstance: !1
    };
  }
  get isRootNodeSelected() {
    return this.state.selection?.flowNodeInstanceId === Ne.state.processInstance?.key;
  }
  get isFlowNodeInstanceSelected() {
    return this.state.selection?.flowNodeInstanceId !== void 0 && !this.isRootNodeSelected;
  }
  isSelected = ({
    flowNodeId: e,
    flowNodeInstanceId: t,
    isMultiInstance: n
  }) => {
    const { selection: i } = this.state;
    if (i === null || i.isMultiInstance !== n)
      return !1;
    if (i.flowNodeInstanceId === void 0) {
      const s = yr.elementInstances.filter(
        ({ flowNodeId: o }) => o === i.flowNodeId
      );
      return s.length > 1 ? s[s.length - 1].key === t : i.flowNodeId === e;
    }
    return i.flowNodeInstanceId === t;
  };
  reset = () => {
    this.state = { ...P_e };
  };
}
const kr = new QQt(), uPe = (r, e) => Math.abs(r) === 1 ? `${e}` : `${e}s`, F_e = {
  status: "initial",
  sourceFlowNodeIdForMoveOperation: null,
  sourceFlowNodeInstanceKeyForMoveOperation: null
};
class KQt {
  state = { ...F_e };
  #n = void 0;
  constructor() {
    Hi(this);
  }
  init = (e) => {
    this.#n = e;
  };
  get isMovingToken() {
    return this.state.status === "moving-token";
  }
  get cancellableFlowNodes() {
    return yr.activeElementInstances.map(
      ({ flowNodeId: e }) => e
    );
  }
  get activatableFlowNodes() {
    return Nt.flowNodes.filter((e) => e.isActivatable).map(({ id: e }) => e);
  }
  get modifiableFlowNodes() {
    return kr.isFlowNodeInstanceSelected ? [] : this.isMovingToken ? this.activatableFlowNodes.filter(
      (e) => e !== this.state.sourceFlowNodeIdForMoveOperation
    ) : Array.from(
      /* @__PURE__ */ new Set([...this.activatableFlowNodes, ...this.cancellableFlowNodes])
    );
  }
  get canSelectedFlowNodeBeModified() {
    return kr.selectedFlowNodeId === void 0 ? !1 : this.modifiableFlowNodes.includes(
      kr.selectedFlowNodeId
    );
  }
  get availableModifications() {
    const e = [], {
      selectedFlowNodeId: t,
      state: { selection: n }
    } = kr;
    return t === void 0 || !this.canSelectedFlowNodeBeModified || (this.activatableFlowNodes.includes(t) && n?.flowNodeInstanceId === void 0 && e.push("add"), !this.cancellableFlowNodes.includes(t)) || (e.push("cancel-all"), e.push("move-all")), e;
  }
  startMovingToken = (e, t) => {
    this.state.status = "moving-token", this.state.sourceFlowNodeIdForMoveOperation = e, this.state.sourceFlowNodeInstanceKeyForMoveOperation = t ?? null;
  };
  moveToken = async (e, t) => {
    if (e !== void 0) {
      const n = yr.state.elementInstances.filter(
        ({ state: s, flowNodeId: o }) => !["COMPLETED", "TERMINATED"].includes(s) && o === this.state.sourceFlowNodeIdForMoveOperation
      ).map(({ key: s }) => ({
        elementInstanceKey: s
      })), { success: i } = await At.modify({
        processInstanceKey: Ne.state.processInstance?.key,
        terminateInstructions: n,
        activateInstructions: [
          {
            elementId: e,
            ancestorElementInstanceKey: -1,
            variableInstructions: []
          }
        ]
      });
      i ? (this.#n?.info({
        title: `Moving ${uPe(n.length, "token")} to ${t}`
      }), Jn.applyModifictation("move-token")) : this.#n?.error(zr);
    }
    this.finishMovingToken();
  };
  finishMovingToken = () => {
    this.state.status = "initial", this.state.sourceFlowNodeIdForMoveOperation = null, this.state.sourceFlowNodeInstanceKeyForMoveOperation = null;
  };
  reset = () => {
    this.state = { ...F_e };
  };
}
const hl = new KQt(), fPe = (r) => {
  const e = r.parent;
  return e == null ? !1 : aI(e.businessObject) ? !0 : fPe(e);
}, z_e = new LQt(), W_e = {
  definitions: void 0,
  elementsById: void 0,
  isMinimapActive: !1,
  isFullscreenActive: !1,
  isLoaded: !1,
  linkedStartForm: void 0,
  viewer: void 0,
  elementRegistry: void 0,
  graphicsFactory: void 0
};
let YQt = class {
  state = { ...W_e };
  constructor() {
    Hi(this);
  }
  setDiagramDetails = async (e) => {
    try {
      const { rootElement: t, elementsById: n } = await NQt(e);
      this.setDefinitions(t, n);
    } catch (t) {
      console.error("Error parsing diagram XML", t);
    }
  };
  setDefinitions(e, t) {
    ku(this.state.definitions, e) || (this.state.definitions = e), ku(this.state.elementsById, t) || (this.state.elementsById = t);
  }
  get flowNodes() {
    return cQt(this.state.elementsById).map((e) => ({
      ...e,
      isActivatable: DQt(e)
    }));
  }
  get messageSubscriptionCandidates() {
    return EQt(this.state.elementsById);
  }
  get signalCandidates() {
    return _Qt(this.state.elementsById);
  }
  get errorEventDefinitions() {
    return hQt(this.state.elementsById);
  }
  get elementsWithJobWorker() {
    return dQt(this.elements);
  }
  get elementsWithExecutionListeners() {
    return uQt(this.elements);
  }
  get diagramProblemCount() {
    return this.elementsWithExecutionListeners.length;
  }
  get errorEvents() {
    return pQt(this.state.elementsById).map(
      ({ attachedToRef: e, eventDefinitions: t, id: n }) => {
        const i = t?.[0]?.errorRef?.id, s = this.errorEventDefinitions.find(
          ({ id: o }) => o === i
        );
        return {
          attachedElementId: e?.id ?? null,
          errorId: i,
          errorElementId: n,
          errorCode: s?.errorCode,
          errorName: s?.name
        };
      }
    );
  }
  get errorBoundaryEvents() {
    return this.errorEvents.filter(
      ({ attachedElementId: e }) => e !== null
    );
  }
  get errorStartEvents() {
    return this.errorEvents.filter(
      ({ attachedElementId: e }) => e === null
    );
  }
  get startEventWithLinkedForm() {
    return this.state.elementRegistry?.filter((e) => TH(e) && !FIe(e))?.find((e) => R_e(e)?.formId !== void 0);
  }
  get processName() {
    return this.state.definitions?.rootElements?.find(
      ({ $type: e }) => e === "bpmn:Process"
    )?.name;
  }
  fetchLinkedStartForm = async () => {
    if (this.startEventWithLinkedForm === void 0)
      return;
    const e = R_e(this.startEventWithLinkedForm)?.formId, n = (await gt.fetchFilesByFormId?.(
      gt.projectId,
      e
    ))?.at(0)?.id;
    if (!n)
      return;
    const i = await gt.fetchFileById?.(n);
    this.state.linkedStartForm = i?.content ?? "{}";
  };
  getErrorBoundaryEventsForElement = (e, t = []) => {
    if (e === void 0)
      return t;
    const n = this.errorBoundaryEvents.find(
      ({ attachedElementId: i }) => i === e.id
    );
    return n !== void 0 && t.push(n.errorId), this.getErrorBoundaryEventsForElement(
      e.parent,
      t
    );
  };
  getAvailableErrorEvents = (e) => e == null ? [] : [
    ...this.errorBoundaryEvents.filter(({ errorId: t }) => this.getErrorBoundaryEventsForElement(e).includes(t)),
    ...fPe(e) ? [] : this.errorStartEvents
  ].map(({ errorCode: t, errorName: n, errorElementId: i }) => ({
    errorElementId: i,
    errorCode: t,
    errorName: n
  }));
  get elements() {
    return this.state.elementRegistry?.getAll();
  }
  get flowNodeIds() {
    return this.flowNodes.map(({ id: e }) => e);
  }
  get selectableFlowNodeIds() {
    return Array.from(
      new Set(
        hl.isMovingToken ? hl.modifiableFlowNodes : yr.elementIds.filter((e) => this.flowNodeIds.includes(e)).concat(hl.modifiableFlowNodes)
      )
    );
  }
  get viewer() {
    return this.state.viewer;
  }
  toggleMinimap = () => {
    this.state.isMinimapActive = !this.state.isMinimapActive;
  };
  /**
   * Forces a recalculation of the root container which
   * most of the times fixes a Safari viewport height bug.
   *
   * Shall only be used in Safari
   */
  forceRootResize = () => {
    const e = document.querySelector("#root");
    e.style.height = "99.9vh", requestAnimationFrame(() => {
      e.style.height = "100vh";
    });
  };
  exitFullscreen() {
    this.state.isFullscreenActive = !1, z_e.isSafari && this.forceRootResize();
  }
  startLoading = () => {
    this.state.isLoaded = !1;
  };
  finishLoading = (e) => {
    this.state.elementRegistry = e.getElementRegistry(), this.state.viewer = e, this.state.graphicsFactory = e.getGraphicsFactory(), this.state.isLoaded = !0;
  };
  toXml = async () => this.state.viewer?.saveXML();
  setIsLoaded = (e = !0) => {
    this.state.isLoaded = e;
  };
  handleFullscreenToggle = () => {
    z_e.isSafari ? document.webkitFullscreenEnabled && (document.webkitRequestFullscreen ? (document.webkitExitFullscreen(), this.exitFullscreen()) : (document.documentElement.webkitRequestFullscreen(), this.state.isFullscreenActive = !0)) : document.fullscreenEnabled && (document.fullscreenElement ? (document.exitFullscreen(), this.exitFullscreen()) : (document.documentElement.requestFullscreen(), this.state.isFullscreenActive = !0));
  };
  focusOnElement = (e) => {
    this.state.viewer?.focusOnElement(e);
  };
  reset = () => {
    this.state = { ...W_e };
  };
};
const Nt = new YQt(), j_e = {
  elementInstances: [],
  status: "initial"
};
class XQt extends Th {
  state = { ...j_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh,
      completedElementInstances: qn,
      activeElementInstances: qn,
      elementInstances: qn,
      elementIds: qn,
      isInitialLoadComplete: qn,
      elementInstancesWithType: qn
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchFlowNodeInstances({});
  pollData = () => this.fetchFlowNodeInstances({
    ignoreFailure: !0
  });
  fetchFlowNodeInstances = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, flowNodeInstances: i } = await At.fetchFlowNodeInstances(t);
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    const { processInstance: t } = Ne.state;
    if (t === void 0)
      return;
    const n = e.map((i) => ({
      ...i,
      scopeKey: i.processInstanceKey
    }));
    Ar(n, this.state.elementInstances) || (this.state.elementInstances = n), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status === "initial" ? this.state.status = "first-fetch" : this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get isInitialLoadComplete() {
    return !["initial", "first-fetch"].includes(this.state.status);
  }
  get completedElementInstances() {
    return this.state.elementInstances?.filter(
      (e) => e.state === "COMPLETED"
    ) ?? [];
  }
  get activeElementInstances() {
    return this.state.elementInstances?.filter(
      (e) => e.state === "ACTIVE"
    ) ?? [];
  }
  get elementInstances() {
    return this.state.elementInstances ?? [];
  }
  get elementIds() {
    return this.elementInstances.map(({ flowNodeId: e }) => e);
  }
  get elementInstancesWithType() {
    return this.elementInstances.map(({ flowNodeId: e }) => ({
      flowNodeId: e,
      elementType: Nt.flowNodes.find(({ id: t }) => t === e)?.$type
    }));
  }
  reset() {
    super.reset(), this.state = { ...j_e };
  }
}
const yr = new XQt(), Z_e = {
  incidents: [],
  status: "initial"
};
class JQt extends Th {
  state = { ...Z_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      handleError: Et,
      startFetching: Et,
      reset: yh,
      incidents: qn
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.incident ?? !1;
  pollDataCondition = () => Ne.state.processInstance?.incident ?? !1;
  fetchData = () => this.fetchIncidents({
    instanceKey: Ne.state.instanceKey
  });
  pollData = () => this.fetchIncidents({
    instanceKey: Ne.state.instanceKey,
    ignoreFailure: !0
  });
  get incidents() {
    return this.state.incidents.map((t) => {
      const n = yr.state.elementInstances?.find(({ incidentKey: i }) => i !== void 0 && i === t.key);
      return {
        ...t,
        elementInstance: n === void 0 ? void 0 : {
          key: n.incidentKey ?? 0,
          element: {
            elementId: n.flowNodeId,
            elementName: n.flowNodeName,
            bpmnElementType: n.type
          }
        }
      };
    });
  }
  fetchIncidents = async ({
    instanceKey: e,
    ignoreFailure: t = !1
  }) => {
    this.startFetching();
    const { success: n, incidents: i } = await At.fetchIncidents(e);
    iu({
      requestedProcessInstanceKey: e,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? (this.handleSuccess(i), i?.forEach(
      (s) => Jn.trackIncident(
        s,
        Ne.state.processInstance?.bpmnProcessId
      )
    )) : t || this.handleError());
  };
  handleSuccess = (e) => {
    Ar(e, this.state.incidents) || (this.state.incidents = e ?? []), this.state.status = "fetched";
  };
  updateRetries = async ({
    jobKey: e,
    numberOfRetries: t = 1
  }) => (await At.updateRetries({
    jobKey: e,
    retries: t
  }))?.success !== !1;
  resolveIncident = async (e) => At.resolveIncident(e);
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  refreshIncidents = async ({ instanceKey: e }) => {
    const { success: t, incidents: n } = await At.fetchIncidents(e);
    t && this.handleSuccess(n);
  };
  reset() {
    super.reset(), this.state = { ...Z_e };
  }
}
const Z4 = new JQt(), U_e = {
  userTasks: [],
  status: "initial"
};
class $Qt extends Th {
  state = { ...U_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchUserTasks({});
  pollData = () => this.fetchUserTasks({
    ignoreFailure: !0
  });
  fetchUserTasks = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, userTasks: i } = await At.fetchUserTasks(t);
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    Ar(e, this.state.userTasks) || (this.state.userTasks = e ?? []), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset() {
    super.reset(), this.state = { ...U_e };
  }
}
const $b = new $Qt(), q_e = {
  variables: [],
  isUpdatingVariable: !1,
  status: "initial"
};
let eKt = class extends Th {
  state = { ...q_e };
  isPollRequestRunning = !1;
  intervalId = null;
  pollingDisposer = null;
  fetchVariablesDisposer = null;
  constructor() {
    super(), xs(this, {
      state: $n,
      variables: qn,
      handleSuccess: Et,
      handleError: Et,
      setIsUpdatingVariable: Et,
      startFetching: Et,
      scopeId: qn,
      isInitialLoadComplete: qn,
      reset: yh
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchVariables({});
  pollData = () => this.fetchVariables({
    ignoreFailure: !0
  });
  fetchVariables = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, variables: i } = await At.fetchVariables({
      instanceKey: t
    });
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  fetchVariable = async (e) => {
    const { variable: t } = await At.fetchVariable(e);
    return t;
  };
  handleSuccess = (e) => {
    Ar(e, this.state.variables) || (this.state.variables = e ?? []), this.state.status = "fetched";
  };
  setVariables = async ({
    instanceKey: e,
    scope: t,
    variablesString: n
  }) => {
    this.setIsUpdatingVariable(!0);
    const i = await At.setVariables({
      elementInstanceKey: t ?? e ?? 0,
      variablesString: n
    });
    return this.setIsUpdatingVariable(!1), i?.success !== !1;
  };
  setIsUpdatingVariable = (e) => {
    this.state.isUpdatingVariable = e;
  };
  startFetching = () => {
    this.state.status === "initial" ? this.state.status = "first-fetch" : this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get isInitialLoadComplete() {
    return !["initial", "first-fetch"].includes(this.state.status);
  }
  get variables() {
    return this.state.variables.map((t) => {
      const n = yr.state.elementInstances?.find(
        (s) => s.key === t.scopeKey
      );
      let i;
      return n !== void 0 ? i = {
        elementId: n.flowNodeId,
        elementName: n.flowNodeName ?? null,
        bpmnElementType: n.type
      } : t.scopeKey === t.processInstanceKey && (i = {
        elementId: gt.processId,
        elementName: null,
        bpmnElementType: "PROCESS"
      }), {
        ...t,
        scope: i
      };
    });
  }
  get scopeId() {
    const { selection: e } = kr.state;
    if (e?.flowNodeInstanceId !== void 0)
      return e.flowNodeInstanceId;
    const { elementInstances: t } = yr.state, n = t?.filter(
      (i) => i.flowNodeId === e?.flowNodeId
    );
    return n === void 0 || n.length === 0 ? null : n.length > 1 ? n[n.length - 1].key : n[0].key;
  }
  reset() {
    super.reset(), this.state = { ...q_e };
  }
};
const xo = new eKt(), CC = (r) => {
  if (r == null)
    return !1;
  try {
    return JSON.parse(r), !0;
  } catch {
    return !1;
  }
}, G_e = {
  statistics: [],
  status: "initial"
};
class tKt extends Th {
  state = { ...G_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh,
      completedElementIds: qn,
      activeElementIds: qn,
      activeElementIdsWithoutIncident: qn
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchStatistics({});
  pollData = () => this.fetchStatistics({
    ignoreFailure: !0
  });
  fetchStatistics = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, statistics: i } = await At.fetchStatistics(t);
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    ku(e, this.state.statistics) || (this.state.statistics = e ?? []), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  get completedElementIds() {
    return this.state.statistics.filter(({ completed: e }) => Number(e) > 0).map(({ activityId: e }) => e);
  }
  isElementProcessed = (e) => na.state.statistics.some(
    ({ activityId: t }) => t === e
  );
  get activeElementIds() {
    return this.state.statistics.filter(
      ({ active: e, incidents: t }) => Number(e) > 0 || Number(t) > 0
    ).map(({ activityId: e }) => e);
  }
  get activeElementIdsWithoutIncident() {
    return this.state.statistics.filter(
      ({ active: e, incidents: t }) => Number(e) > 0 && Number(t) === 0
    ).map(({ activityId: e }) => e);
  }
  reset() {
    super.reset(), this.state = { ...G_e };
  }
}
const na = new tKt(), Q_e = {
  status: "initial"
};
class nKt {
  state = { ...Q_e };
  constructor() {
    Hi(this);
  }
  completeJob = async ({
    taskDefinitionType: e,
    processInstanceKey: t,
    variables: n,
    elementId: i
  }) => (await At.completeJob({
    taskDefinitionType: e,
    processInstanceKey: t,
    variables: CC(n) ? n : "{}",
    elementId: i
  }))?.success !== !1;
  throwError = async ({
    taskDefinitionType: e,
    processInstanceKey: t,
    errorCode: n,
    elementId: i
  }) => (await At.throwError({
    taskDefinitionType: e,
    processInstanceKey: t,
    errorCode: n,
    elementId: i
  }))?.success !== !1;
  get activeElementsWithJobWorker() {
    return Nt.elementsWithJobWorker.filter(
      ({ id: e }) => na.activeElementIdsWithoutIncident.includes(e)
    );
  }
  get errorThrowableJobsByErrorId() {
    return this.activeElementsWithJobWorker.reduce((e, t) => (Nt.getAvailableErrorEvents(t).forEach(({ errorCode: n, errorName: i, errorElementId: s }) => {
      const o = t.businessObject, a = {
        errorCode: n,
        errorName: i,
        elementId: o.id,
        elementName: o.name ?? o.id,
        taskDefinitionType: NH(t)
      };
      e[s] === void 0 ? e[s] = [a] : e[s].push(a);
    }), e), {});
  }
  reset = () => {
    this.state = { ...Q_e };
  };
}
const Up = new nKt(), K_e = {
  childInstances: [],
  status: "initial"
};
class iKt extends Th {
  state = { ...K_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchChildInstances({});
  pollData = () => this.fetchChildInstances({
    ignoreFailure: !0
  });
  fetchChildInstances = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, childInstances: i } = await At.fetchChildInstances({
      instanceKey: t
    });
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    Ar(e, this.state.childInstances) || (this.state.childInstances = e ?? []), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset() {
    super.reset(), this.state = { ...K_e };
  }
}
const IT = new iKt(), Y_e = {
  sequenceFlows: [],
  status: "initial"
};
class rKt extends Th {
  state = { ...Y_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchSequenceFlows({});
  pollData = () => this.fetchSequenceFlows({
    ignoreFailure: !0
  });
  fetchSequenceFlows = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, sequenceFlows: i } = await At.fetchSequenceFlows(t);
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    Ar(this.state.sequenceFlows, e) || (this.state.sequenceFlows = e), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset() {
    super.reset(), this.state = { ...Y_e };
  }
}
const Vg = new rKt(), X_e = {
  processInstances: [],
  status: "initial"
};
class sKt extends Th {
  state = { ...X_e };
  processDefinitionKey = void 0;
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      handleError: Et,
      startFetching: Et,
      reset: yh
    });
  }
  init(e) {
    super.init(), this.processDefinitionKey = e;
  }
  shouldRefreshDataAfterPollingStops = !1;
  initialDataFetchCondition = () => !0;
  pollDataCondition = () => !0;
  fetchData = () => this.fetchInstances({});
  pollData = () => this.fetchInstances({
    ignoreFailure: !0
  });
  fetchInstances = async ({
    ignoreFailure: e = !1
  }) => {
    if (this.processDefinitionKey === void 0)
      return;
    this.startFetching();
    const { success: t, processInstances: n } = await At.fetchInstances(
      this.processDefinitionKey
    );
    t ? this.handleSuccess(n) : e || this.handleError();
  };
  handleSuccess = (e) => {
    Ar(e, this.state.processInstances) || (this.state.processInstances = e), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset() {
    super.reset(), this.state = { ...X_e };
  }
}
const OT = new sKt(), J_e = {
  decisionInstances: [],
  status: "initial"
};
class oKt extends Th {
  state = { ...J_e };
  constructor() {
    super(), xs(this, {
      state: $n,
      handleSuccess: Et,
      startFetching: Et,
      handleError: Et,
      reset: yh
    });
  }
  shouldRefreshDataAfterPollingStops = !0;
  initialDataFetchCondition = () => Ne.state.processInstance?.key !== void 0;
  pollDataCondition = () => Ne.isRunning;
  fetchData = () => this.fetchDecisionInstances({});
  pollData = () => this.fetchDecisionInstances({
    ignoreFailure: !0
  });
  fetchDecisionInstances = async ({
    ignoreFailure: e = !1
  }) => {
    const t = Ne.state.processInstance?.key;
    if (t === void 0)
      return;
    this.startFetching();
    const { success: n, items: i } = await At.fetchDecisionInstances(t);
    iu({
      requestedProcessInstanceKey: t,
      currentProcessInstanceKey: Ne.state.instanceKey
    }) && (n ? this.handleSuccess(i) : e || this.handleError());
  };
  handleSuccess = (e) => {
    ku(e, this.state.decisionInstances) || (this.state.decisionInstances = e ?? []), this.state.status = "fetched";
  };
  startFetching = () => {
    this.state.status = "fetching";
  };
  handleError = () => {
    this.state.status = "error";
  };
  reset() {
    super.reset(), this.state = { ...J_e };
  }
}
const RT = new oKt();
function aKt(r, e) {
  const [t, n] = ye(
    () => Ne.state.instanceKey
  ), [i, s] = ye(
    () => gt.state.processDefinitionKey
  );
  return Pe(
    () => ms(
      () => Ne.state.instanceKey,
      (o) => n(o)
    ),
    []
  ), Pe(
    () => ms(
      () => gt.state.processDefinitionKey,
      (o) => s(o)
    ),
    []
  ), Pe(() => {
    if (!(r === "saas" && e === void 0))
      return t ? (Ne.init(), kr.init(), Vg.init(), na.init(), RT.init(), $b.init(), yr.init(), xo.init(), IT.init(), Z4.init()) : OT.init(i), () => {
        Up.reset(), Z4.reset(), $b.reset(), xo.reset(), IT.reset(), yr.reset(), kr.reset(), Vg.reset(), na.reset(), RT.reset(), OT.reset(), hl.reset();
      };
  }, [r, e, t, i]), {};
}
const qr = Nxe({
  featureFlags: {
    areAIFeaturesEnabled: !1,
    isSaveExampleDataEnabled: !1,
    isReplayScenariosEnabled: !1
  }
}), lKt = q(mI)`
  fill: #da1e28;
`, cKt = q(cI)`
  fill: #525252;
`, hKt = q(pI)`
  fill: #24a148;
`, dKt = {
  ACTIVE: hKt,
  COMPLETED: cKt,
  INCIDENT: lKt,
  CANCELED: Vd,
  TERMINATED: Vd
}, RH = ({ state: r, ...e }) => {
  const t = dKt[r] || Vd;
  return /* @__PURE__ */ x.jsx(t, { ...e, "data-testid": `state-${r}` });
}, pPe = (r) => {
  try {
    return new Intl.DateTimeFormat("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: !0
    }).format(new Date(r));
  } catch {
    return r;
  }
}, QS = (r = "white") => `'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon fill="${r}" points="12.5 16.45 7.55 11.5 8.964 10.086 12.5 13.621 16.036 10.086 17.45 11.5"/></svg>'`, uKt = q.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: inherit;
  font-size: 14px;
  padding: 0 21px;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  color: inherit;
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
  border-radius: 0;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;

  .cds--btn::-moz-focus-inner {
    padding: 0;
    border: 0;
  }

  &[disabled] {
    box-shadow: none;
    cursor: not-allowed;
    pointer-events: none;
  }

  .loader {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  ${({ $variant: r, $isDropdown: e }) => {
  if (r === "primary")
    return `
        background-color: var(--cds-blue-60, #0f62fe);
        ${e ? `background-image: url(${QS()}); padding-right: 40px;` : ""};
        color: white;
        font-weight: bold;

        &:not([disabled]):hover {
          background-color: var(--cds-blue-70, #0043ce);
        }

        &:not([disabled]):focus {
          border-color: var(--cds-blue-60);
          box-shadow: inset 0 0 0 1px var(--cds-blue-60, #0f62fe),inset 0 0 0 2px white
        }

        &:not([disabled]):active {
          background-color: var(--cds-blue-80, #002d9c)
        }

        &[disabled] {
          background-color: var(--cds-blue-40, #78a9ff);
        }
      `;
  if (r === "danger-primary")
    return `
        border-size: 1px;
        border-color: var(--cm-color-button-red3, #ff0a0a);
        background-color: var(--cm-color-red-base, #ff3d3d);
        color: white;
        font-weight: bold;
      `;
  if (r === "secondary")
    return `
        background-color: var(--silver-base-97);
        ${e ? `background-image: url(${QS(
      "hsl(0,0%,33%)"
    )}); padding-right: 40px;` : ""};
        color: var(--grey-darken-30);
        border: 1px solid var(--silver-darken-80);
        font-weight: bold;

        &:not([disabled]):hover, &:not([disabled]):focus {
          background-color: var(--silver-darken-94);
          border-color: var(--silver-darken-80);
        }

        &:not([disabled]):active {
          background-color: var(--silver-darken-87);
          border-color: var(--silver-darken-80);
        }

        &[disabled] {
          background-color: var(--silver-base-97);
          border-color: var(--silver-darken-87);
          color: var(--grey-lighten-56);
        }
      `;
  if (r === "text")
    return `
        font-weight: 500;
        background-color: transparent;
        ${e ? `background-image: url(${QS("hsl(0,0%,33%)")});` : ""};
        border: none;
        padding: ${e ? "0 35px 0 0" : "0"};
        margin: 0;
      `;
}}
  ${({ $size: r }) => r == "small" ? `
        height: 30px;
        border-radius: 2px;
        line-height: 26px;
        font-size: 13px;
        ` : `
      height: 36px;
      line-height: 32px;
      border-radius: 3px;
    `}
`, fKt = q.div`
  display: flex;
  align-items: center;

  &.is-loading {
    opacity: 0.35;
  }
`, gPe = r1(
  ({
    children: r,
    component: e = "button",
    dropdown: t = !1,
    disabled: n = !1,
    loading: i = !1,
    lightLoader: s = !1,
    loaderSize: o = "normal",
    size: a = "normal",
    variant: l = "primary",
    ...c
  }, d) => /* @__PURE__ */ x.jsx(
    uKt,
    {
      as: e,
      ref: d,
      $isDropdown: t,
      disabled: i || n,
      $size: a,
      $variant: l,
      ...c,
      children: i ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(mKt, { className: "loader", light: s, size: o }),
        /* @__PURE__ */ x.jsx(fKt, { className: "is-loading", children: r })
      ] }) : r
    }
  )
), pKt = zg`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`, gKt = q.span`
  display: inline-block;
  width: ${({ size: r = "small" }) => r == "small" ? "20px" : "40px"};
  height: ${({ size: r = "small" }) => r == "small" ? "20px" : "40px"};
  border-radius: 50%;
  border: ${({ size: r = "small" }) => r == "small" ? "2px" : "4px"} solid
    ${({ light: r = !1 }) => r ? "white" : "var(--cds-blue-60)"};
  border-bottom-color: transparent;
  animation: ${pKt} 1.2s linear infinite;
`, mKt = gKt;
q.button`
  border-radius: ${({ noRadius: r }) => r ? "inherit" : "50%"};
  cursor: pointer;
  border: none;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
  color: inherit;

  &::-moz-focus-inner {
    border: 0;
  }

  &:not([disabled]):hover {
    background-color: rgba(0, 0, 0, 0.07);
  }

  &:not([disabled]):active {
    background-color: rgba(0, 0, 0, 0.16);
  }

  &[disabled] {
    color: var(--grey-lighten-56);
    cursor: not-allowed;
  }

  ${({ isActive: r, isHover: e }) => {
  if (r)
    return `
      background-color: rgba(0, 0, 0, 0.16);
      opacity: 1 !important;

      &:hover {
        background-color: rgba(0, 0, 0, 0.16);
      }
    `;
  if (e) return "background-color: rgba(0, 0, 0, 0.07);";
}}

  ${({ size: r = "normal" }) => r == "small" ? `
        height: 30px;
        width: 30px;
      ` : `
      height: 36px;
      width: 36px;
    `}
`;
const AKt = q.input`
  font: inherit;
  color: var(--grey-darken-33);
  width: 100%;

  border: 1px solid
    ${({
  //@ts-expect-error Property 'error' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, never>'.ts(2339)
  error: r
}) => r ? "var(--red-base-62)" : "var(--silver-darken-80)"};
  margin: 0;
  height: 36px;
  padding: 8px 15px;
  background-color: white;
  transition: border 0.15s linear;
  border-radius: 3px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-sizing: border-box;

  &:disabled {
    background-color: var(--silver-base-97);
    cursor: not-allowed;
  }

  &:focus {
    border-color: var(--cds-blue-60);
  }

  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }
`, wKt = q.textarea`
  font: inherit;
  color: var(--grey-darken-33);
  width: 100%;
  border: 1px solid
    ${({
  //@ts-expect-error Property 'error' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, never>'.ts(2339)
  error: r
}) => r ? "var(--red-base-62)" : "var(--silver-darken-80)"};
  margin: 0;
  padding: 8px 15px;
  min-height: 36px;
  ${({
  //@ts-expect-error Property 'grow' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, never>'.ts(2339)
  grow: r
}) => r ? "max-height: 100px" : ""};
  background-color: white;
  line-height: 1.3;
  transition: border 0.15s linear;
  border-radius: 3px;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  box-sizing: border-box;

  &:disabled {
    background-color: var(--silver-base-97);
    cursor: not-allowed;
  }

  &:focus {
    border-color: var(--cds-blue-60);
  }
`, vKt = q.label`
  display: block;
  margin-bottom: var(--spacing-tiny);
`;
q.p`
  margin: 3px 0 0 0;
  font-size: 12px;
  color: var(--red-darken-52);
`;
const bKt = q.div`
  width: 100%;
  position: relative;

  ${({
  //@ts-expect-error Property 'hasMarginBottom' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, never>'.ts(2339)
  hasMarginBottom: r
}) => r && "margin-bottom: 15px"};
`;
r1(
  ({
    label: r,
    error: e = !1,
    multiline: t = !1,
    grow: n = !1,
    type: i = "text",
    hasMarginBottom: s = !1,
    ...o
  }, a) => {
    const l = r?.toLowerCase() + "-" + Math.random().toString(36).replace(/[^a-z]+/g, "").substr(2, 10), c = (u) => {
      const f = u ? u.target : a.current;
      f.style.height = "initial";
      const p = window.getComputedStyle(f), g = parseInt(p.getPropertyValue("border-top-width"), 10) + f.scrollHeight + parseInt(p.getPropertyValue("border-bottom-width"), 10);
      f.style.height = g + "px";
    }, d = (u) => {
      u.key == "Enter" && c();
    };
    return Pe(() => {
      if (t && a && a.current) {
        const u = a.current;
        return u.addEventListener("input", c), u.addEventListener("keyup", d), c(), () => {
          u.removeEventListener("input", c), u.removeEventListener("keyup", d);
        };
      }
    }, []), //@ts-expect-error Property 'hasMarginBottom' does not exist on type 'IntrinsicAttributes & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, never>'.ts(2769)
    /* @__PURE__ */ x.jsxs(bKt, { hasMarginBottom: s, children: [
      r && /* @__PURE__ */ x.jsx(vKt, { htmlFor: l, children: r }),
      t ? (
        //@ts-expect-error Type 'ForwardedRef<HTMLDivElement>' is not assignable to type 'LegacyRef<HTMLTextAreaElement> | undefined'.ts(2769)
        /* @__PURE__ */ x.jsx(
          wKt,
          {
            ...o,
            grow: n,
            id: r ? l : null,
            error: e,
            ref: a
          }
        )
      ) : (
        //@ts-expect-error Type 'ForwardedRef<HTMLDivElement>' is not assignable to type 'LegacyRef<HTMLInputElement> | undefined'.ts(2769)
        /* @__PURE__ */ x.jsx(
          AKt,
          {
            type: i,
            maxLength: YGt,
            ...o,
            id: r ? l : null,
            error: e,
            ref: a
          }
        )
      )
    ] });
  }
);
const $_e = 5, yKt = zg`
  from { opacity: 0; }
  to { opacity: 1; }
`, CKt = q.div`
  position: fixed;
  top: ${({ $position: r }) => `${r.top}px`};
  left: ${({ $position: r }) => `${r.left}px`};
  border-radius: 4px;
  color: white;
  z-index: var(--z-tooltip);
  padding: 6px 8px;
  max-width: 380px;
  font-weight: 500;
  word-break: break-word;
  animation: ${yKt} 0.2s ease-out forwards;

  ${({ color: r }) => `
      background-color: ${KS(r)};
    `}

  &::after {
    content: '';
    position: absolute;
    pointer-events: none;
    width: 0;
    height: 0;
    border: 5px solid transparent;

    ${({ $align: r, color: e }) => {
  switch (r) {
    case "bottom":
      return `
            border-bottom-color: ${KS(e)};
            bottom: 100%;
          `;
    default:
      return `
            border-top-color: ${KS(e)};
            top: 100%;
          `;
  }
}}

    ${({ $justify: r }) => {
  switch (r) {
    case "left":
      return `left: ${$_e}px;`;
    case "right":
      return `right: ${$_e}px;`;
    default:
      return `
            left: 50%;
            transform: translateX(-50%);
          `;
  }
}}
  }
`, KS = (r) => r === "blue" ? "var(--cds-blue-60)" : "var(--grey-darken-33)", YS = 5, EKt = (r) => {
  const e = ({
    //@ts-expect-error Binding element 'children' implicitly has an 'any' type.ts(7031)
    children: t,
    showOnlyOnOverflow: n = !1,
    interactive: i = !1,
    ...s
  }) => {
    const [o, a] = ye(), [l, c] = ye();
    Pe(() => () => {
    }, []), t = Ixe.map(t, (u) => Oxe(u, {
      //@ts-expect-error Argument of type 'EventTarget & HTMLElement' is not assignable to parameter of type 'SetStateAction<undefined>'.ts(2345)
      onMouseEnter: (f) => a(f.currentTarget),
      onMouseLeave: () => {
        i ? c(setTimeout(a, 200)) : a();
      }
    }));
    let d = !1;
    return d = !!o, n && (d = //@ts-expect-error 'anchorEl' is possibly 'undefined'.ts(18048)
    !!o && o.scrollWidth > o.clientWidth), /* @__PURE__ */ x.jsxs(Rxe, { children: [
      t,
      d && /* @__PURE__ */ x.jsx(
        r,
        {
          anchorEl: o,
          setAnchorEl: a,
          timer: l,
          ...s
        }
      )
    ] });
  };
  return e.propTypes = {
    interactive: N3.PropTypes.bool,
    showOnlyOnOverflow: N3.PropTypes.bool
  }, e;
}, _Kt = ({
  //@ts-expect-error Binding element 'timer' implicitly has an 'any' type.ts(7031)
  timer: r,
  //@ts-expect-error Binding element 'setAnchorEl' implicitly has an 'any' type.ts(7031)
  setAnchorEl: e,
  //@ts-expect-error Binding element 'anchorEl' implicitly has an 'any' type.ts(7031)
  anchorEl: t,
  title: n,
  align: i = "bottom",
  justify: s = "center",
  controlledByTimer: o = !1,
  color: a = "grey",
  onClose: l,
  keepOpen: c = !1
}) => {
  const [d, u] = ye({ top: 0, left: 0 }), [f, p] = ye(i), g = An();
  return Pe(() => {
    const { top: m, bottom: A, left: w, width: v } = t.getBoundingClientRect(), y = (
      //@ts-expect-error 'tooltip.current' is possibly 'undefined'.ts(18048)
      A + g.current.offsetHeight + YS > window.innerHeight
    ), _ = () => {
      switch (s) {
        case "left":
          return w;
        case "right":
          return w + v - g.current.offsetWidth;
        default:
          return w - g.current.offsetWidth / 2 + v / 2;
      }
    }, S = () => f == "top" || y ? m - g.current.offsetHeight - YS - 5 : A + YS + 5;
    y && p("top"), u({
      top: S(),
      left: _()
    });
  }, [t, t?.getBoundingClientRect().top]), Pe(() => {
    if (o) {
      const m = (A) => {
        g.current.contains(A.target) || c || e();
      };
      return document.addEventListener("mousedown", m), () => {
        document.removeEventListener("mousedown", m);
      };
    }
  }, []), Pe(() => {
    if (o && l)
      return () => {
        l();
      };
  }, []), un(
    /* @__PURE__ */ x.jsx(
      CKt,
      {
        onMouseEnter: () => clearTimeout(r),
        onMouseLeave: () => !o && e(),
        $position: d,
        $justify: s,
        $align: f,
        ref: g,
        color: a,
        role: "tooltip",
        "aria-hidden": !t,
        children: n
      }
    ),
    document.body
  );
}, W2 = EKt(_Kt), xKt = q.ul`
  list-style: none;
  margin: 4px 0 0 0;
  position: fixed;
  z-index: var(--z-dropdown);
  border-radius: 3px;
  padding: 5px 0;
  min-width: 70px;
  max-width: 350px;

  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 10px 0px;
  background: var(--silver-base-98);

  ${({
  //@ts-expect-error Property 'size' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>, never>'.ts(2339)
  size: r
}) => {
  if (r == "small")
    return `
        font-size: 13px;

        li {
          padding: 5px 10px;
        }

        a {
          padding: 0;
        }
      `;
}}

  ${({
  //@ts-expect-error Property 'width' does not exist on type 'ExecutionContext & FastOmit<DetailedHTMLProps<HTMLAttributes<HTMLUListElement>, HTMLUListElement>, never>'.ts(2339)
  width: r
}) => {
  if (r)
    return `
        min-width: ${r}px;
      `;
}}

  hr {
    margin: 5px 0;
    height: 1px;
    border: none;
    background-color: var(--silver-darken-87);
  }
`, SKt = q.li`
  display: flex;
  align-items: center;
  padding: ${({ $noPadding: r }) => r ? "0" : "7px 20px"};
  position: relative;
  color: var(--grey-darken-23);
  white-space: nowrap;
  outline: none;
  font-size: 14px;
  transition: all 150ms linear 0s;
  border-radius: 3px;

  ${({ $isDangerous: r }) => r && "color: var(--red-darken-42);"}

  ${({ $isDisabled: r }) => r ? `
        color: var(--grey-lighten-56);
        pointer-events: none;
        ` : `
        cursor: pointer;

        &:hover,
        &:focus {
          background-color: var(--silver-darken-94);
        }

        &:active {
          background-color: var(--silver-darken-80);
        }
      `}

  &::-moz-focus-inner {
    border: 0;
  }

  ${({ $isActive: r, $isHover: e }) => {
  if (r)
    return `
        background-color: var(--silver-darken-94);

        &:hover, &:focus {
          background-color: var(--silver-darken-94);
        }
      `;
  if (e) return "background-color: var(--silver-darken-94);";
}}

  &[disabled] {
    opacity: 0.5;
    pointer-events: none;
  }
`, MKt = rs`
  display: flex;
  align-items: center;
  padding: 7px 20px;
  color: inherit;
  white-space: nowrap;
  outline: none;
  text-decoration: none;
`;
q.a`
  ${MKt}
`;
q.div`
  padding: var(--spacing-tiny) var(--spacing-medium, 20px) 0px;
  color: var(--cm-color-ui-light6);
  font-family: var(--cm-font-text);
  font-size: 11px;
`;
const DKt = q(Pxe)`
  &.cds--menu-item-divider {
    padding: 0;
  }
`;
function LKt({
  //@ts-expect-error Binding element 'children' implicitly has an 'any' type.ts(7031)
  children: r,
  //@ts-expect-error Binding element 'noPadding' implicitly has an 'any' type.ts(7031)
  noPadding: e,
  //@ts-expect-error Binding element 'disabled' implicitly has an 'any' type.ts(7031)
  disabled: t,
  ...n
}) {
  return /* @__PURE__ */ x.jsx(
    SKt,
    {
      disabled: t,
      tabIndex: "0",
      role: "menuitem",
      $noPadding: e,
      ...n,
      children: /* @__PURE__ */ x.jsx(W2, { title: r, showOnlyOnOverflow: !0, children: /* @__PURE__ */ x.jsx("div", { className: "overflow-ellipsis", children: r }) })
    }
  );
}
let sf = class extends r7 {
  state = {};
  ref = Vxe();
  //@ts-expect-error type-error
  componentDidUpdate(e) {
    e.open != this.props.open && (this.props.open ? this.init() : this.reset());
  }
  componentWillUnmount() {
    this.reset();
  }
  init() {
    document.body.addEventListener("click", this.handleBodyClick, !0), window.addEventListener("keydown", this.handleKeyPress), window.addEventListener("scroll", this.handleClose), this.setState(this.position);
  }
  reset() {
    document.body.removeEventListener("click", this.handleBodyClick, !0), window.removeEventListener("keydown", this.handleKeyPress), window.removeEventListener("scroll", this.handleClose);
  }
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleBodyClick = (e) => {
    e.target.id !== "runtime-download" && !e.target.closest("[data-dropdown]") && this.handleClose(e);
  };
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleKeyPress = (e) => {
    e.key == "Escape" && this.handleClose(e);
  };
  //@ts-expect-error Parameter 'evt' implicitly has an 'any' type.ts(7006)
  handleClose = (e) => {
    e.preventDefault(), typeof this.props.onClose == "function" && (e.stopPropagation(), this.props.onClose(e));
  };
  get position() {
    const e = {};
    if (this.props.anchorEl && this.props.open && this.ref.current) {
      const t = this.props.anchorEl.getBoundingClientRect();
      this.props.align == "left" ? document.body.offsetWidth - t.right > this.props.width ? e.left = t.left : e.right = document.body.offsetWidth - t.right : t.right < this.props.width ? e.left = t.left : e.right = document.body.offsetWidth - t.right, document.body.offsetHeight - t.bottom > //@ts-expect-error Property 'offsetHeight' does not exist on type '{}'.ts(2339)
      this.ref.current.offsetHeight ? e.top = t.bottom : e.top = t.top - this.ref.current.offsetHeight;
    }
    return e;
  }
  render() {
    return this.props.open ? un(
      /* @__PURE__ */ x.jsx(
        xKt,
        {
          size: this.props.size,
          role: "menu",
          "data-dropdown": !0,
          style: this.state,
          "data-test": this.props["data-test"],
          width: this.props.width,
          ref: this.ref,
          children: this.props.children
        }
      ),
      document.body
    ) : null;
  }
};
sf.propTypes = {
  onClose: Hn.func,
  anchorEl: Hn.object,
  align: Hn.string,
  open: Hn.bool.isRequired,
  size: Hn.string,
  width: Hn.number
};
sf.defaultProps = {
  open: !1,
  size: "normal",
  align: "right",
  width: 200
};
sf.ListItem = LKt;
sf.ListItemDivider = DKt;
const kKt = q.header`
  width: 100%;
  background: white;

  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--cds-border-subtle-01, #e0e0e0);
`, NKt = q.div`
  display: flex;
  align-items: center;
  padding: 6px 10px 6px 20px;
`, TKt = q.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  margin-left: 14px;
  width: 768px;
`, n6 = q.th`
  color: #525252;
  font-size: 12px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.32px;
  word-wrap: break-word;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 256px;
`, i6 = q.td`
  color: #525252;
  font-size: 14px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 256px;
`, exe = q(gPe)`
  color: #0f62fe;
  font-size: 14px;
  font-family: IBM Plex Sans;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.16px;
  word-wrap: break-word;
  height: 20px;
`, IKt = q.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
`, OKt = q.div`
  display: flex;
  align-items: center;
  padding: var(--cds-spacing-03);
  gap: var(--cds-spacing-02);
`, RKt = q.div`
  display: flex;
  justify-content: center;
  ${yl.helperText01};
  background-color: var(--cds-notification-background-warning);
  border: 1px solid var(--cds-support-warning);
  box-shadow: 0 2px 6px var(--cds-shadow);
`, VKt = q.div`
  padding: var(--cds-spacing-03);
`, HKt = ({ text: r, button: e }) => /* @__PURE__ */ x.jsxs(RKt, { children: [
  /* @__PURE__ */ x.jsx(VKt, { children: r }),
  e && /* @__PURE__ */ x.jsx(Rn, { kind: "ghost", size: "sm", onClick: e.onClick, children: e.label })
] }), txe = {
  activeTab: "instances"
};
let BKt = class {
  state = { ...txe };
  constructor() {
    Hi(this);
  }
  init(e) {
    e && eo.setActiveTab("scenarios");
  }
  setActiveTab = (e) => {
    this.state.activeTab = e;
  };
  reset() {
    this.state = { ...txe };
  }
};
const eo = new BKt(), mPe = (r) => {
  const { children: e, text: t, align: n, isDisabled: i } = r;
  return r.text !== void 0 ? /* @__PURE__ */ x.jsx(ew, { align: n, label: t, description: t, children: /* @__PURE__ */ x.jsx("div", { children: h.isValidElement(e) ? h.cloneElement(e, { disabled: i }) : e }) }) : r.children;
};
function rr(r) {
  const e = JSON.parse(
    localStorage.getItem("historyEntries") || "[]"
  );
  for (e.includes(r) || e.push(r); e.length > 20; ) {
    const n = e.shift();
    localStorage.removeItem("history " + n);
  }
  return localStorage.setItem("historyEntries", JSON.stringify(e)), `history ${r}`;
}
function ao(r, e) {
  const t = localStorage.getItem(r) || "[]", n = JSON.parse(t);
  localStorage.setItem(r, JSON.stringify([...n, e]));
}
function nxe(r, e) {
  localStorage.setItem(r, JSON.stringify(e));
}
function U4(r) {
  return JSON.parse(localStorage.getItem(r) || "[]");
}
function PKt(r) {
  const e = U4(r);
  return e.length > 0 && e[0].action === "startInstance";
}
const FKt = ({
  processInstanceKey: r,
  isCompleted: e,
  isScenarioSaved: t
}) => t ? {
  isDisabled: !0,
  text: "Current scenario has been saved"
} : PKt(
  rr(r)
) ? e ? {
  isDisabled: !1,
  text: "Save a scenario to replay this instance later to detect regressions."
} : {
  isDisabled: !0,
  text: "Complete the instance to save a scenario and replay this instance later to detect regressions."
} : {
  isDisabled: !0,
  text: "Not enough data to save a scenario. Re-run your instance and try again."
}, zKt = q.span`
  font-weight: bold;
  ${({ $isGreen: r, $hasPrecedingPlusIcon: e }) => rs`
      ${r && "color: var(--cds-support-success);"}
      ${e && rs`
        &:before {
          content: '+';
        }
      `}
    `}
`, VT = ({
  isGreen: r,
  hasPrecedingPlusIcon: e,
  children: t
}) => /* @__PURE__ */ x.jsx(zKt, { $isGreen: r, $hasPrecedingPlusIcon: e, children: t });
function ru(r) {
  return new Promise((e) => {
    let t = 0;
    const n = 10, i = setInterval(async () => {
      const s = await r();
      s !== null && (clearInterval(i), e(s)), t++, t >= n && (clearInterval(i), e(null));
    }, Jb);
  });
}
const WKt = ({
  instanceKey: r,
  elementId: e
}) => ru(async () => {
  const { userTasks: t } = await At.fetchUserTasks(r), n = t?.find(
    ({ taskDefinitionId: i, taskState: s }) => i === e && s !== "COMPLETED"
  );
  return n !== void 0 ? n : null;
}), ixe = ({
  instanceKey: r,
  elementId: e
}) => ru(async () => {
  const { flowNodeInstances: t } = await At.fetchFlowNodeInstances(r), n = t?.find(
    ({ flowNodeId: i, state: s }) => i === e && s !== "COMPLETED"
  );
  return n !== void 0 ? n : null;
}), jKt = ({
  instanceKey: r,
  elementId: e
}) => ru(async () => {
  const { incidents: t } = await At.fetchIncidents(r), { flowNodeInstances: n } = await At.fetchFlowNodeInstances(r);
  return t.find((s) => {
    const o = n?.find(
      ({ incidentKey: a, flowNodeId: l }) => a !== void 0 && a === s.key && l === e
    );
    return ["ACTIVE", "MIGRATED"].includes(s.state) && o !== void 0;
  }) ?? null;
});
function rxe(r) {
  return ru(async () => {
    const { processInstances: e, success: t } = await At.fetchInstances(
      gt.state.processDefinitionKey
    );
    if (t) {
      const n = e[0];
      return n && n.key !== r[0]?.key ? n.key : null;
    } else
      return null;
  });
}
const ZKt = ({
  processId: r,
  element: e,
  isSubProcessStartEvent: t,
  activeElementIds: n,
  isProcessRunning: i
}) => {
  if (!i || !t)
    return !1;
  const s = e.$parent.id, o = e.$parent?.$parent?.id, a = n.includes(s) || s === r, l = n.includes(o) || o === r;
  return e.isInterrupting ? l && !a : l;
}, VH = ({
  processId: r,
  isProcessRunning: e,
  candidate: t,
  activeElementIds: n
}) => n.includes(t.elementId) || t.attachedToElementId && n.includes(t.attachedToElementId) || ZKt({
  element: t.element,
  activeElementIds: n,
  isProcessRunning: e,
  isSubProcessStartEvent: t.isSubProcessStartEvent,
  processId: r
}), UKt = (r, e) => {
  if (r && r.startsWith("=")) {
    const t = r.substring(1), n = e.find(
      (i) => i.name === t
    );
    return n?.value && CC(n?.value) ? JSON.parse(n.value) : r.substring(1);
  }
};
class qKt {
  constructor() {
    xs(this, {
      startMessageSubscriptionCandidates: qn.struct,
      activeMessageSubscriptionCandidates: qn.struct
    });
  }
  get activeMessageSubscriptionCandidates() {
    const { messageSubscriptionCandidates: e } = Nt, { activeElementIdsWithoutIncident: t } = na, { variables: n } = xo.state, i = Ne.state.processInstance?.state === "ACTIVE";
    return e.filter(
      (s) => VH({
        processId: gt.processId,
        activeElementIds: t,
        candidate: s,
        isProcessRunning: i
      })
    ).map((s) => ({
      ...s,
      keyCandidate: UKt(
        s.messageCorrelationKey,
        n
      )
    }));
  }
  get startMessageSubscriptionCandidates() {
    return Nt.messageSubscriptionCandidates.filter(
      (e) => IH(e.element) && !aPe(e.element)
    );
  }
}
const HT = new qKt();
class GKt {
  constructor() {
    xs(this, {
      activeSignalCandidates: qn.struct,
      startSignalCandidates: qn.struct
    });
  }
  get activeSignalCandidates() {
    const { signalCandidates: e } = Nt, { activeElementIdsWithoutIncident: t } = na, n = Ne.state.processInstance?.state === "ACTIVE";
    return e.filter(
      (i) => VH({
        processId: gt.processId,
        activeElementIds: t,
        candidate: i,
        isProcessRunning: n
      })
    );
  }
  get startSignalCandidates() {
    return Nt.signalCandidates.filter(
      (e) => OH(e.element) && !lPe(e.element)
    );
  }
}
const BT = new GKt(), sxe = ({
  instanceKey: r,
  elementId: e,
  candidates: t
}) => ru(async () => {
  const { statistics: n } = await At.fetchStatistics(r), { processInstance: i } = await At.fetchInstanceDetails(r);
  return t.filter(
    (o) => VH({
      processId: gt.processId,
      activeElementIds: n.filter(
        ({ active: a, incidents: l }) => Number(a) > 0 && Number(l) === 0
      ).map(({ activityId: a }) => a),
      candidate: o,
      isProcessRunning: i.state === "ACTIVE"
    })
  ).some((o) => o.elementId === e) ? !0 : null;
});
class APe {
  startNewInstance = async function(t, n = "{}") {
    return (await At.startInstance({
      bpmnProcessId: t,
      variables: n
    })).instanceId;
  };
  handleMessageEvent = async function({
    messageName: t,
    messageId: n,
    variables: i,
    messageCorrelationKey: s,
    timeToLive: o,
    elementId: a,
    isStartEvent: l,
    instanceKey: c
  }) {
    if (!l && !await sxe({
      instanceKey: c,
      elementId: a,
      candidates: Nt.messageSubscriptionCandidates
    }))
      return console.error("could not find active message subscription"), { success: !1 };
    await At.publishMessage({
      messageName: t,
      correlationKey: s,
      variables: i,
      timeToLive: o,
      messageId: n
    });
  };
  handleSignalEvent = async function({
    signalName: t,
    variables: n,
    elementId: i,
    isStartEvent: s,
    instanceKey: o
  }) {
    if (!s && !await sxe({
      instanceKey: o,
      elementId: i,
      candidates: Nt.signalCandidates
    }))
      return console.error("could not find active signal candidate"), { success: !1 };
    await At.broadcastSignal({
      signalName: t,
      variables: n
    });
  };
  handleUserTask = async function({
    elementId: t,
    instanceKey: n,
    variables: i = "{}"
  }) {
    const s = await WKt({
      instanceKey: n,
      elementId: t
    });
    return s === null ? { success: !1 } : At.completeUserTask({
      taskId: s?.id,
      variables: i,
      isZeebeUserTask: s?.implementation === "ZEEBE_USER_TASK"
    });
  };
  handleServiceTask = async function({
    elementId: t,
    instanceKey: n,
    taskDefinitionType: i,
    variables: s = "{}"
  }) {
    return await ixe({
      instanceKey: n,
      elementId: t
    }) === null ? { success: !1 } : At.completeJob({
      processInstanceKey: n,
      taskDefinitionType: i,
      variables: s,
      elementId: t
    });
  };
  handleThrowError = async function({
    elementId: t,
    instanceKey: n,
    taskDefinitionType: i,
    errorCode: s = ""
  }) {
    return await ixe({
      instanceKey: n,
      elementId: t
    }) === null ? { success: !1 } : At.throwError({
      taskDefinitionType: i,
      processInstanceKey: n,
      errorCode: s,
      elementId: t
    });
  };
  handleResolveIncident = async function({
    elementId: t,
    instanceKey: n,
    hasJob: i
  }) {
    const s = await jKt({
      instanceKey: n,
      elementId: t
    });
    return s === null ? { success: !1 } : (i && await At.updateRetries({
      jobKey: s.jobKey,
      retries: 1
    }), At.resolveIncident(s.key));
  };
  handleSetVariables = async function({
    instanceKey: t,
    scope: n,
    variables: i
  }) {
    return At.setVariables({
      elementInstanceKey: n ?? t ?? 0,
      variablesString: i
    });
  };
  createNewInstance = async ({
    startActionType: e,
    bpmnProcessId: t,
    variables: n
  }) => {
    const { processInstances: i, success: s } = await At.fetchInstances(
      gt.state.processDefinitionKey
    );
    if (!s)
      return;
    let o;
    if (e === "start-event")
      o = await this.startNewInstance(t, n);
    else if (e === "message-start-event") {
      const a = yr.completedElementInstances.find(
        ({ type: c }) => c === "START_EVENT"
      ), l = HT.startMessageSubscriptionCandidates?.find(
        ({ elementId: c }) => c === a?.flowNodeId
      );
      l === void 0 ? o = await this.startNewInstance(t, n) : (await this.handleMessageEvent({
        messageName: l?.messageName,
        variables: n,
        isStartEvent: !0,
        elementId: l.elementId
      }), o = await rxe(i) ?? void 0);
    } else if (e == "broadcast-signal-event") {
      const a = yr.completedElementInstances.find(
        ({ type: c }) => c === "START_EVENT"
      ), l = BT.startSignalCandidates?.find(
        ({ elementId: c }) => c === a?.flowNodeId
      );
      l === void 0 ? o = await this.startNewInstance(t, n) : (await this.handleSignalEvent({
        signalName: l?.signalName,
        variables: n,
        isStartEvent: !0,
        elementId: l.elementId
      }), o = await rxe(i) ?? void 0);
    }
    return o;
  };
  repeatUserActions = async ({
    newInstanceKey: e,
    actions: t,
    untilElementId: n,
    breakOnFailure: i
  }) => {
    let s = { success: !0 };
    const o = [];
    for (const a of t) {
      if (a.action === "startInstance") {
        o.push(a);
        continue;
      }
      if (n !== void 0 && a.action !== "setVariables" && a.elementId === n)
        break;
      switch (a.action) {
        case "completeJob": {
          a.type === "userTask" ? s = await this.handleUserTask({
            elementId: a.elementId,
            instanceKey: e,
            variables: a.variables
          }) : s = await this.handleServiceTask({
            elementId: a.elementId,
            taskDefinitionType: a.taskDefinitionType,
            instanceKey: e,
            variables: a.variables
          });
          break;
        }
        case "publishMessage": {
          await this.handleMessageEvent({
            messageName: a.messageName,
            messageId: a.messageId,
            variables: a.variables,
            timeToLive: a.timeToLive,
            elementId: a.elementId,
            messageCorrelationKey: a.messageCorrelationKey,
            isStartEvent: !1,
            instanceKey: e
          });
          break;
        }
        case "broadcastSignal": {
          await this.handleSignalEvent({
            signalName: a.signalName,
            variables: a.variables,
            isStartEvent: !1,
            elementId: a.elementId,
            instanceKey: e
          });
          break;
        }
        case "throwJob": {
          s = await this.handleThrowError({
            elementId: a.elementId,
            taskDefinitionType: a.taskDefinitionType,
            instanceKey: e,
            errorCode: a.errorCode
          });
          break;
        }
        case "resolveIncident": {
          s = await this.handleResolveIncident({
            elementId: a.elementId,
            instanceKey: e,
            hasJob: a.hasJob
          });
          break;
        }
        case "setVariables": {
          await this.handleSetVariables({
            instanceKey: e,
            scope: e,
            variables: a.variables
          });
          break;
        }
      }
      if (i && !s.success)
        return nxe(rr(e), o), { success: !1 };
      o.push(a);
    }
    return nxe(rr(e), o), { success: !0 };
  };
}
const oxe = {
  scenarios: [],
  scenarioRuns: {},
  selectedScenario: void 0
};
let QKt = class extends APe {
  state = { ...oxe };
  constructor() {
    super(), xs(this, {
      state: $n,
      loadScenarios: Et,
      allCoveredFlowNodes: qn,
      currentTotalCoverage: qn,
      coverageIncrease: qn,
      newTotalCoverage: qn,
      isAnyScenarioRunning: qn,
      coveredFlowNodeIdsForSelectedScenario: qn,
      isSingleScenarioSelected: qn,
      startRunningSingleScenario: Et,
      updateSingleScenarioRun: Et,
      deleteScenario: Et,
      setSelectedScenario: Et,
      clearSelectedScenario: Et,
      reset: Et
    });
  }
  loadScenarios = (e) => {
    this.state.scenarios = yC(e);
  };
  get allCoveredFlowNodes() {
    return Nt.flowNodes.filter((e) => this.state.scenarios.some(
      ({ coveredFlowNodes: t }) => t?.some((n) => n.flowNodeId === e.id && n.elementType === e.$type)
    )).map((e) => ({
      flowNodeId: e.id,
      elementType: e.$type
    }));
  }
  get allCoveredSequenceFlows() {
    return this.state.scenarios.flatMap(
      ({ coveredSequenceFlows: e }) => e
    );
  }
  get currentTotalCoverage() {
    return this.allCoveredFlowNodes.length / Nt.flowNodes.length * 100;
  }
  get newTotalCoverage() {
    const e = yr.elementIds;
    return Array.from(
      /* @__PURE__ */ new Set([
        ...this.allCoveredFlowNodes.map(({ flowNodeId: n }) => n),
        ...e
      ])
    ).length / Nt.flowNodeIds.length * 100;
  }
  get coverageIncrease() {
    return Math.max(0, this.newTotalCoverage - this.currentTotalCoverage);
  }
  replay = async ({
    processId: e,
    actions: t
  }) => {
    const n = t.find(
      ({ action: a }) => a === "startInstance"
    );
    if (n === void 0)
      return { isCompleted: !1 };
    const i = await this.createNewInstance({
      startActionType: n.type,
      variables: n.variables,
      bpmnProcessId: e
    });
    if (i === void 0)
      return { isCompleted: !1 };
    const { success: s } = await this.repeatUserActions({
      newInstanceKey: i,
      actions: t,
      breakOnFailure: !0
    });
    return s ? { isCompleted: await this.isScenarioCompleted({
      instanceKey: i
    }), processInstanceKeyForScenarioRun: i } : {
      isCompleted: !1,
      processInstanceKeyForScenarioRun: i
    };
  };
  startRunningSingleScenario = (e) => {
    if (this.state.scenarioRuns[e] === void 0) {
      this.state.scenarioRuns[e] = {
        status: "Running"
      };
      return;
    }
    this.state.scenarioRuns[e] = {
      ...this.state.scenarioRuns[e],
      status: "Running"
    };
  };
  runSingleScenario = async ({
    name: e,
    processId: t,
    actions: n
  }) => {
    this.startRunningSingleScenario(e);
    const { isCompleted: i, processInstanceKeyForScenarioRun: s } = await this.replay({
      processId: t,
      actions: n
    });
    this.updateSingleScenarioRun(e, {
      status: i ? "Completed" : "Failed",
      instanceKey: s
    });
  };
  updateSingleScenarioRun = (e, t) => {
    this.state.scenarioRuns[e] = t;
  };
  getScenarioRun = (e) => ui.state.scenarioRuns[e];
  isScenarioCompleted = ({
    instanceKey: e
  }) => ru(async () => {
    const { processInstance: t } = await At.fetchInstanceDetails(e);
    return t.state === "COMPLETED" ? !0 : null;
  });
  get isAnyScenarioRunning() {
    return Object.values(this.state.scenarioRuns).some(
      (e) => e.status === "Running"
    );
  }
  setSelectedScenario = (e) => {
    this.state.selectedScenario = e;
  };
  clearSelectedScenario = () => {
    this.state.selectedScenario = void 0;
  };
  get coveredFlowNodeIdsForSelectedScenario() {
    return Nt.flowNodes.filter((e) => this.state.selectedScenario?.coveredFlowNodes?.some(
      ({ flowNodeId: t, elementType: n }) => t === e.id && n === e.$type
    )).map(({ id: e }) => e);
  }
  get isSingleScenarioSelected() {
    return this.state.selectedScenario !== void 0;
  }
  deleteScenario = ({
    scenario: e,
    processId: t
  }) => {
    nQt(t, e.key), delete this.state.scenarioRuns[e.name];
  };
  reset = () => {
    this.state = { ...oxe };
  };
};
const ui = new QKt(), axe = q.p`
  ${yl.body01};
`, wPe = rt(
  ({ title: r, isOpen: e, onScenarioSaved: t, onClose: n, topContent: i }) => {
    const [s, o] = ye(""), [a, l] = ye(null);
    return /* @__PURE__ */ x.jsx(
      M1,
      {
        "data-testid": "save-scenario-modal",
        open: e,
        modalHeading: r,
        secondaryButtonText: "Cancel",
        primaryButtonText: "Save",
        onRequestSubmit: () => {
          t(s), n();
        },
        onRequestClose: n,
        preventCloseOnClickOutside: !0,
        primaryButtonDisabled: a !== null || s === "",
        children: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
          i,
          /* @__PURE__ */ x.jsx(axe, { children: "Save scenario to replay this instance later to detect regressions." }),
          /* @__PURE__ */ x.jsxs(axe, { children: [
            "This scenario increases the BPMN coverage of your scenario suite from",
            " ",
            /* @__PURE__ */ x.jsx(VT, { children: `${ui.currentTotalCoverage.toFixed(0)}%` }),
            " ",
            "to",
            " ",
            /* @__PURE__ */ x.jsx(
              VT,
              {
                isGreen: !0,
                children: `${ui.newTotalCoverage.toFixed(0)}%`
              }
            ),
            ". ",
            /* @__PURE__ */ x.jsx("br", {}),
            /* @__PURE__ */ x.jsx(
              ja,
              {
                href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#scenario-coverage",
                target: "_blank",
                children: "Learn more"
              }
            ),
            "."
          ] }),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "scenario-name",
              labelText: "Scenario name",
              placeholder: "My first scenario",
              invalid: a !== null,
              invalidText: a,
              onChange: (c) => {
                const d = c.target.value;
                if (o(d), ui.state.scenarios.some(
                  (f) => f.name === d
                )) {
                  l(
                    "Scenario name is already in use. Please choose a new unique name"
                  );
                  return;
                }
                if (!/^[a-zA-Z0-9 _-]+$/.test(d) || d.trim() === "") {
                  l(
                    "Scenario name can only contain letters, numbers, spaces or underscores/hyphens"
                  );
                  return;
                }
                l(null);
              }
            }
          ),
          /* @__PURE__ */ x.jsx(
            gFe,
            {
              titleId: "scenarios-usage",
              kind: "info",
              lowContrast: !0,
              actionButtonLabel: "Learn more",
              onActionButtonClick: () => {
                window.open(
                  "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#scenarios-limitations",
                  "_blank"
                );
              },
              subtitle: "Scenarios will be saved to your browser's local storage and cannot be run locally or in a pipeline."
            }
          )
        ] })
      }
    );
  }
), KKt = rt(
  ({ onScenarioSaved: r, isScenarioSaved: e = !1 }) => {
    const {
      isCompleted: t,
      state: { processInstance: n }
    } = Ne;
    if (n === void 0)
      return null;
    const [i, s] = ye(!1), { isDisabled: o, text: a } = FKt({
      processInstanceKey: n.key,
      isCompleted: t,
      isScenarioSaved: e
    });
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(mPe, { align: "bottom-end", isDisabled: o, text: a, children: /* @__PURE__ */ x.jsx(
        Rn,
        {
          size: "sm",
          onClick: () => {
            s(!0);
          },
          children: "Save scenario"
        }
      ) }),
      /* @__PURE__ */ x.jsx(
        wPe,
        {
          title: "Save scenario",
          isOpen: i,
          onScenarioSaved: r,
          onClose: () => {
            s(!1);
          }
        }
      )
    ] });
  }
), HH = q(mFe)`
  .cds--definition-tooltip {
    max-inline-size: 18rem;
  }
`, vPe = q(ja)`
  color: var(--cds-link-inverse) !important;
`, YKt = ({
  isCompleted: r,
  isScenarioUpdated: e
}) => e ? {
  isDisabled: !0,
  text: "Current scenario has been updated"
} : r ? {
  isDisabled: !1,
  text: "Update the scenario to reflect recent process changes."
} : {
  isDisabled: !0,
  text: "Complete the instance to update the scenario."
}, XKt = rt(
  ({ title: r, scenarioName: e, isOpen: t, onScenarioUpdated: n, onClose: i }) => /* @__PURE__ */ x.jsx(
    M1,
    {
      size: "sm",
      "data-testid": "update-scenario-modal",
      open: t,
      modalHeading: r,
      secondaryButtonText: "Cancel",
      primaryButtonText: "Update",
      onRequestSubmit: () => {
        n(), i();
      },
      onRequestClose: i,
      preventCloseOnClickOutside: !0,
      children: /* @__PURE__ */ x.jsx(
        qT,
        {
          kind: "warning",
          lowContrast: !0,
          hideCloseButton: !0,
          title: "This change cannot be undone.",
          subtitle: `You are about to update the scenario '${e}'.`
        }
      )
    }
  )
), JKt = rt(
  ({ onScenarioUpdated: r, scenarioName: e, isScenarioUpdated: t = !1 }) => {
    const [n, i] = ye(!1), { isDisabled: s, text: o } = YKt({
      isCompleted: Ne.isCompleted,
      isScenarioUpdated: t
    });
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(mPe, { align: "bottom-end", isDisabled: s, text: o, children: /* @__PURE__ */ x.jsx(
        Rn,
        {
          size: "sm",
          onClick: () => {
            i(!0);
          },
          children: "Update scenario"
        }
      ) }),
      /* @__PURE__ */ x.jsx(
        XKt,
        {
          title: "Update scenario",
          scenarioName: e,
          isOpen: n,
          onScenarioUpdated: r,
          onClose: () => {
            i(!1);
          }
        }
      )
    ] });
  }
), bPe = rt(() => {
  const r = bn(qr), { isReplayScenariosEnabled: e } = r.featureFlags, { instanceKey: t, processInstance: n, scenarioName: i, isCalledProcess: s } = Ne.state, { scenarioRuns: o } = ui.state, { sanitizedOperateBaseUrl: a, hasLinkToOperate: l } = gt, c = n?.bpmnProcessId;
  if (Pe(() => {
    c !== void 0 && ui.loadScenarios(c);
  }, [t, c]), !t || !n || !c)
    return null;
  const d = n.incident ? "INCIDENT" : n.state, u = `${a}/processes/${t}`, f = i !== iPe, p = Object.keys(o).find((g) => {
    const m = o[g];
    return m !== void 0 && m.instanceKey === t && m.status === "Failed";
  });
  return /* @__PURE__ */ x.jsxs(kKt, { "data-testid": "instance-header", children: [
    /* @__PURE__ */ x.jsxs(NKt, { children: [
      /* @__PURE__ */ x.jsx(RH, { state: d, size: 24 }),
      /* @__PURE__ */ x.jsxs(TKt, { children: [
        /* @__PURE__ */ x.jsx("thead", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(n6, { children: "Process Instance Key" }),
          /* @__PURE__ */ x.jsx(n6, { children: "Started at" }),
          /* @__PURE__ */ x.jsx(n6, { children: "Process Instances" }),
          e && /* @__PURE__ */ x.jsx(n6, { children: "Scenario" })
        ] }) }),
        /* @__PURE__ */ x.jsx("tbody", { children: /* @__PURE__ */ x.jsxs("tr", { children: [
          /* @__PURE__ */ x.jsx(i6, { style: { overflow: "visible" }, children: l ? /* @__PURE__ */ x.jsx(
            ew,
            {
              label: "View process instance in Operate",
              align: "bottom",
              closeOnActivation: !0,
              children: /* @__PURE__ */ x.jsx(
                ja,
                {
                  href: u,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  renderIcon: () => /* @__PURE__ */ x.jsx(S7, {}),
                  onClick: () => {
                    Jn.openOperate(u);
                  },
                  children: t
                }
              )
            }
          ) : t }),
          /* @__PURE__ */ x.jsx(i6, { children: pPe(n.startDate) }),
          /* @__PURE__ */ x.jsx(i6, { children: /* @__PURE__ */ x.jsx(
            exe,
            {
              variant: "text",
              onClick: () => {
                eo.setActiveTab("instances"), Ne.reset();
              },
              children: "View all"
            }
          ) }),
          e && /* @__PURE__ */ x.jsxs(i6, { children: [
            /* @__PURE__ */ x.jsx("span", { children: p ?? i }),
            " ",
            /* @__PURE__ */ x.jsx(
              exe,
              {
                variant: "text",
                onClick: () => {
                  eo.setActiveTab("scenarios"), Ne.reset();
                },
                children: "(View all)"
              }
            )
          ] })
        ] }) })
      ] }),
      r.featureFlags.isReplayScenariosEnabled && !s && /* @__PURE__ */ x.jsxs(IKt, { children: [
        Ne.state.processInstance?.state === "COMPLETED" && !f && /* @__PURE__ */ x.jsxs(OKt, { "data-testid": "scenario-coverage", children: [
          /* @__PURE__ */ x.jsx(
            VT,
            {
              isGreen: ui.coverageIncrease > 0,
              hasPrecedingPlusIcon: !0,
              children: `${ui.coverageIncrease.toFixed(0)}% `
            }
          ),
          /* @__PURE__ */ x.jsx(
            HH,
            {
              align: "bottom-end",
              definition: /* @__PURE__ */ x.jsxs(In, { gap: 3, children: [
                "This percentage indicates how much of your process scenario coverage will be increased with this scenario.",
                /* @__PURE__ */ x.jsx(
                  vPe,
                  {
                    href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#scenario-coverage",
                    target: "_blank",
                    children: "Learn more"
                  }
                )
              ] }),
              openOnHover: !0,
              children: "Coverage"
            }
          )
        ] }),
        p ? /* @__PURE__ */ x.jsx(
          JKt,
          {
            scenarioName: p,
            onScenarioUpdated: () => {
              try {
                iQt({
                  bpmnProcessId: c,
                  name: p,
                  processInstanceId: t,
                  actions: U4(
                    rr(t)
                  ),
                  coveredFlowNodes: yr.elementInstancesWithType,
                  coveredSequenceFlows: Vg.state.sequenceFlows
                });
              } catch {
                r.displayNotification?.error(zr);
                return;
              }
              Ne.setScenarioName(p), r.displayNotification?.success(
                {
                  title: "Scenario updated",
                  subtitle: `${p} was successfully updated.`
                },
                {
                  action: {
                    label: "View scenario",
                    onClick: () => {
                      eo.setActiveTab("scenarios"), Ne.reset();
                    }
                  }
                }
              );
            },
            isScenarioUpdated: f
          }
        ) : /* @__PURE__ */ x.jsx(
          KKt,
          {
            onScenarioSaved: (g) => {
              try {
                nPe({
                  bpmnProcessId: c,
                  name: g,
                  processInstanceId: t,
                  actions: U4(
                    rr(t)
                  ),
                  coveredFlowNodes: yr.elementInstancesWithType,
                  coveredSequenceFlows: Vg.state.sequenceFlows
                });
              } catch {
                r.displayNotification?.error(zr);
                return;
              }
              Ne.setScenarioName(g), r.displayNotification?.success(
                {
                  title: "Scenario saved",
                  subtitle: `${g} was successfully saved.`
                },
                {
                  action: {
                    label: "View scenario",
                    onClick: () => {
                      eo.setActiveTab("scenarios"), Ne.reset();
                    }
                  }
                }
              ), Jn.saveScenario({
                newTotalCoverage: `${ui.newTotalCoverage.toFixed(0)}%`,
                coverageIncrease: `${ui.coverageIncrease.toFixed(0)}%`
              });
            },
            isScenarioSaved: f
          }
        )
      ] })
    ] }),
    hl.isMovingToken && /* @__PURE__ */ x.jsx(
      HKt,
      {
        text: "Select the target flow node in the diagram",
        button: {
          onClick: () => hl.finishMovingToken(),
          label: "Discard"
        }
      }
    )
  ] });
});
bPe.displayName = "InstanceHeader";
const $Kt = q.div`
  background: var(--silver-base-97, hsl(0, 0%, 97%));
  border-top: 1px solid var(--silver-darken-80, hsl(0, 0%, 80%));
  border-bottom: 1px solid var(--silver-darken-80, hsl(0, 0%, 80%));
  cursor: pointer;
`, XS = q.span`
  vertical-align: middle;
`, JS = q.div`
  display: inline-block;
  cursor: pointer;
  padding: 6px 18px 4px 18px;
  font-weight: ${(r) => r.$isActive && !r.isErrorPanelCollapsed ? "500" : ""};
  border-bottom: ${(r) => r.$isActive && !r.isErrorPanelCollapsed ? "2px solid var(--cds-blue-60, #0f62fe)" : ""};
  margin-left: 12px;
  height: 38px;
`, eYt = q.div`
  height: 200px;
  width: 100%;
  overflow-y: auto;
  background: white;
`, tYt = q(o7)`
  min-inline-size: 24px;
  background-color: var(
    --grey-base-40
  ); // to match the badge color in implement tab
  color: white;
`, nYt = q.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--cds-layer);
  border-right: 1px solid rgb(216, 220, 227);
  border-top: 1px solid rgb(216, 220, 227);
`, iYt = q.div`
  flex: 1;
  overflow: auto;

  ${({ $isEmpty: r }) => r && `
    display: flex;
    align-items: center;
    
  `}
`, rYt = q.div`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  flex: 1;
  text-align: center;
`, sYt = q.table`
  border-collapse: separate;
  border-spacing: 8px;
  width: calc(100% - 16px);
  margin: 8px;
`, oYt = q.thead`
  text-align: left;
  color: var(--text-text-secondary, #525252);

  font-family: IBM Plex Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.32px;
`, aYt = q.tbody`
  color: var(--text-text-primary, #161616);

  font-family: IBM Plex Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.16px;

  td {
    height: 32px;
    vertical-align: top;
  }
`, lYt = q.th`
  width: 15%;
`, cYt = q.th`
  width: 80%;
`, hYt = q.th`
  width: 5%;
`, dYt = q.td`
  display: flex;
  align-items: center;
  text-align: right;
  width: 5%;
`, uYt = q(Rn)`
  margin-top: -15px;
  transform: translateY(9px);
`, fYt = q.td`
  width: 15%;
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, pYt = q.td`
  width: 80%;
`, gYt = zg`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
q.span`
  display: inline-block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 8px 15px;
  border: 3px solid var(--cds-blue-60, #0f62fe);
  border-bottom-color: transparent;
  animation: ${gYt} 1.2s linear infinite;
`;
const mYt = q(s7)`
  .cds--snippet-container {
    width: 100%;
  }
`, AYt = q(Uxe)`
  border-bottom: 1px solid var(--cds-border-subtle-01);
`, wYt = q.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`, vYt = q(AFe)`
  padding: 0;
  height: 100%;
  overflow: auto;
`, bYt = q(UT)`
  margin-left: var(--cds-spacing-03);
`;
function yYt(r) {
  return self.MonacoEnvironment = {
    getWorker() {
      return new tIe();
    }
  }, l8.config(r ?? { paths: { vs: "/min/vs" } }), l8.init();
}
const CYt = q.div`
  position: absolute;
  white-space: pre-wrap;
  top: 0px;
  left: 64px;
  font-family:
    IBM Plex Mono,
    monospace;
  font-size: 13px;
  font-weight: 400;
  color: #a8a8a8;
  pointer-events: none;
  user-select: none;
`, EYt = q(eSe)`
  .monaco-editor {
    .margin {
      background-color: #f4f4f4;
    }
    .monaco-editor-background {
      background-color: #f4f4f4;
    }
  }
`, _Yt = q.section`
  position: relative;
  min-width: 0; // https://github.com/microsoft/monaco-editor/issues/3393
`, xYt = {
  minimap: {
    enabled: !1
  },
  fontSize: 13,
  lineHeight: 20,
  fontFamily: '"IBM Plex Mono", "Droid Sans Mono", "monospace", monospace, "Droid Sans Fallback"',
  formatOnPaste: !0,
  formatOnType: !0,
  tabSize: 2,
  wordWrap: "on",
  scrollBeyondLastLine: !1,
  overviewRulerBorder: !1,
  stickyScroll: { enabled: !1 }
}, EC = ({
  value: r,
  isVisible: e,
  placeholder: t,
  onChange: n,
  readOnly: i = !1,
  onValidate: s = () => {
  },
  onMount: o = () => {
  },
  height: a = "30vh",
  width: l = "100%",
  hasJSONObjectValidation: c = !1,
  dataTestId: d
}) => {
  const f = bn(qr).monacoLoaderConfig, [p, g] = ye(null), m = r === "" && t !== void 0;
  return Pe(() => {
    yYt(f).then((A) => {
      g(A);
    });
  }, [f]), Fg(() => {
    e && c ? p?.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemaValidation: "error",
      schemaRequest: "error",
      validate: !0,
      schemas: [
        {
          uri: "",
          fileMatch: ["*"],
          schema: {
            type: "object"
          }
        }
      ]
    }) : p?.languages.json.jsonDefaults.setDiagnosticsOptions({
      schemaValidation: "error",
      schemaRequest: "error"
    });
  }, [p, c, e]), p === null ? null : /* @__PURE__ */ x.jsxs(_Yt, { children: [
    /* @__PURE__ */ x.jsx(
      EYt,
      {
        "data-testid": d,
        options: { ...xYt, readOnly: i },
        language: "json",
        value: r,
        height: a,
        width: l,
        theme: "light",
        onChange: (A) => {
          n?.(A ?? "");
        },
        onMount: (A) => {
          A.focus(), o({
            showMarkers: () => {
              A.trigger("", "editor.action.marker.next", void 0), A.trigger("", "editor.action.marker.prev", void 0);
            },
            hideMarkers: () => {
              A.trigger("", "closeMarkersNavigation", void 0);
            }
          });
        },
        onValidate: (A) => {
          s(A.length === 0);
        }
      }
    ),
    m && /* @__PURE__ */ x.jsx(CYt, { className: "monaco-placeholder", children: t })
  ] });
}, SYt = q(Fxe)`
  h3 {
    font-weight: 400;
  }
`, MYt = q(zxe)`
  ${({ $enableContentOverflow: r }) => r && rs`
      overflow: unset;
    `}
`, DYt = q(Rn)`
  ${({ $hasIcon: r }) => r && rs`
      padding-right: 15px;
    `}
`, g2 = ({
  title: r,
  size: e = "md",
  readOnly: t = !1,
  isVisible: n,
  isPrimaryButtonDisabled: i = !1,
  enableContentOverflow: s = !1,
  primaryButtonLabel: o,
  secondaryButton: a,
  ghostButton: l,
  onClose: c,
  onSubmit: d,
  modalBody: u,
  dataTestId: f
}) => un(
  /* @__PURE__ */ x.jsxs(
    Wxe,
    {
      open: n,
      preventCloseOnClickOutside: !t,
      onClose: c,
      size: e,
      "aria-label": r,
      "data-testid": f,
      children: [
        /* @__PURE__ */ x.jsx(SYt, { title: r, closeModal: c }),
        /* @__PURE__ */ x.jsx(MYt, { tabIndex: 0, $enableContentOverflow: s, children: u }),
        !t && /* @__PURE__ */ x.jsxs(jxe, { children: [
          l !== void 0 && /* @__PURE__ */ x.jsx(Rn, { kind: "ghost", onClick: l.onClick, children: l.label }),
          a !== void 0 && /* @__PURE__ */ x.jsx(
            DYt,
            {
              kind: "secondary",
              onClick: a.onClick,
              renderIcon: () => a.icon,
              id: a.id,
              $hasIcon: a.icon !== void 0,
              disabled: a.disabled,
              title: a.title,
              children: a.label
            }
          ),
          /* @__PURE__ */ x.jsx(
            Rn,
            {
              kind: "primary",
              disabled: i,
              onClick: d,
              children: o
            }
          )
        ] })
      ]
    }
  ),
  document.querySelector("[data-test='zeebe-play']") ?? document.body
), yPe = ({
  title: r,
  isValidInput: e,
  isVisible: t,
  primaryButtonLabel: n,
  secondaryButtonLabel: i,
  hasResetButton: s,
  value: o = "",
  placeholder: a,
  size: l = "md",
  onClose: c,
  onReset: d,
  onSubmit: u,
  readOnly: f = !1,
  hasJSONObjectValidation: p = !1,
  editorTopContent: g = !1,
  onChange: m,
  clearOnReset: A = !0
}) => {
  const [w, v] = ye(o), [y, _] = ye(!0), S = An(null);
  return Pe(() => {
    t ? v(o) : (v(""), _(!0));
  }, [t, o]), Pe(() => {
    y && S.current?.hideMarkers();
  }, [y]), /* @__PURE__ */ x.jsx(
    g2,
    {
      title: r,
      readOnly: f,
      size: l,
      isVisible: t,
      isPrimaryButtonDisabled: !y,
      primaryButtonLabel: n,
      secondaryButton: {
        label: i,
        onClick: () => {
          c?.();
        }
      },
      ghostButton: s ? {
        label: "Reset",
        onClick: () => {
          d?.(), A && v("");
        }
      } : void 0,
      onClose: c,
      onSubmit: () => {
        y ? u?.(w === "" ? void 0 : w) : S.current?.showMarkers();
      },
      modalBody: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
        g,
        /* @__PURE__ */ x.jsx(
          EC,
          {
            value: w,
            isVisible: t,
            placeholder: a,
            onChange: (D) => {
              const M = D ?? "";
              v(M), _(e(M)), m?.(M);
            },
            readOnly: f,
            onValidate: _,
            onMount: (D) => {
              S.current = D;
            },
            hasJSONObjectValidation: p
          }
        )
      ] })
    }
  );
};
function $S(r, e = "	") {
  try {
    const t = JSON.parse(r);
    return JSON.stringify(t, null, e);
  } catch {
    return r;
  }
}
const LYt = q(M1)`
  h3 {
    font-weight: 400;
  }
`, kYt = q.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, NYt = ({
  isVisible: r,
  onClose: e,
  onSubmit: t,
  validateVariableName: n
}) => {
  const [i, s] = ye(
    null
  ), [o, a] = ye(!0), [l, c] = ye(""), [d, u] = ye(""), f = An(null);
  return Pe(() => {
    r || (c(""), u(""), s(null), a(!0));
  }, [r]), Pe(() => {
    o && f.current?.hideMarkers();
  }, [o]), /* @__PURE__ */ x.jsx(
    LYt,
    {
      open: r,
      size: "md",
      modalHeading: "Add variable",
      primaryButtonText: "Add",
      secondaryButtonText: "Cancel",
      onRequestClose: e,
      onRequestSubmit: () => {
        o ? t?.(
          l,
          d === "" ? void 0 : d
        ) : f.current?.showMarkers();
      },
      primaryButtonDisabled: i !== null || !o,
      preventCloseOnClickOutside: !0,
      children: /* @__PURE__ */ x.jsxs(kYt, { children: [
        /* @__PURE__ */ x.jsx(
          ha,
          {
            id: "variable-name",
            size: "md",
            labelText: "Variable name",
            autoFocus: !0,
            invalid: i !== null,
            invalidText: i,
            value: l,
            onBlur: (p) => {
              const g = n(p.target.value);
              g.isValid ? s(null) : s(g.error);
            },
            onChange: (p) => {
              c(p.target.value);
            }
          }
        ),
        /* @__PURE__ */ x.jsx(K4, { children: "Variable value" }),
        /* @__PURE__ */ x.jsx(
          EC,
          {
            dataTestId: "new-variable-value",
            value: d,
            isVisible: r,
            height: "10vh",
            onChange: (p) => {
              const g = p ?? "";
              u(g), a(CC(g));
            },
            onValidate: a,
            onMount: (p) => {
              f.current = p;
            }
          }
        )
      ] })
    }
  );
}, TYt = q.ul`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
`, IYt = q.li`
  margin: var(--cds-spacing-05);
  display: flex;
  gap: var(--cds-spacing-05);
`, lxe = q($xe)`
  margin: 0;
`, OYt = () => /* @__PURE__ */ x.jsxs(IYt, { children: [
  /* @__PURE__ */ x.jsx(lxe, { width: "276px" }),
  /* @__PURE__ */ x.jsx(lxe, { width: "384px" })
] }), RYt = () => /* @__PURE__ */ x.jsx(TYt, { "data-testid": "variables-skeleton", children: [...Array(20)].map((r, e) => /* @__PURE__ */ x.jsx(OYt, {}, e)) }), CPe = rt(({ selectedScope: r, isActive: e }) => {
  const t = bn(qr), [n, i] = ye(null), [s, o] = ye(""), [a, l] = ye(!1), [c, d] = ye(!1), [u, f] = ye(!1), p = xo.state.isUpdatingVariable, { instanceKey: g, processInstance: m } = Ne.state, A = xo.state.variables.filter(
    (w) => w.scopeKey === r
  );
  return Pe(() => {
    e || i(null);
  }, [e]), Pe(() => {
    p || i(null);
  }, [p]), Pe(() => {
    i(null);
  }, [r]), /* @__PURE__ */ x.jsx(nYt, { children: /* @__PURE__ */ x.jsxs(Zxe, { children: [
    /* @__PURE__ */ x.jsx(AYt, { "aria-label": "Variables", children: /* @__PURE__ */ x.jsx(qxe, { children: "Variables" }) }),
    /* @__PURE__ */ x.jsx(vYt, { children: /* @__PURE__ */ x.jsx(wYt, { children: xo.isInitialLoadComplete ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsxs(iYt, { $isEmpty: A.length === 0, children: [
        A.length === 0 && /* @__PURE__ */ x.jsx(rYt, { children: kr.isRootNodeSelected ? "This process instance has no variables" : "The flow node has no variables" }),
        A.length > 0 && /* @__PURE__ */ x.jsxs(sYt, { children: [
          /* @__PURE__ */ x.jsx(oYt, { children: /* @__PURE__ */ x.jsxs("tr", { children: [
            /* @__PURE__ */ x.jsx(lYt, { children: "Name" }),
            /* @__PURE__ */ x.jsx(cYt, { children: "Value" }),
            /* @__PURE__ */ x.jsx(hYt, {})
          ] }) }),
          /* @__PURE__ */ x.jsx(aYt, { children: A.map((w) => /* @__PURE__ */ x.jsxs("tr", { children: [
            /* @__PURE__ */ x.jsx(fYt, { title: w.name, children: w.name }),
            /* @__PURE__ */ x.jsx(pYt, { children: /* @__PURE__ */ x.jsx(Wg, { children: /* @__PURE__ */ x.jsx(
              mYt,
              {
                type: "multi",
                wrapText: !0,
                maxCollapsedNumberOfRows: 3,
                maxExpandedNumberOfRows: 3,
                minExpandedNumberOfRows: 0,
                minCollapsedNumberOfRows: 0,
                children: $S(w.value, "  ")
              }
            ) }) }),
            /* @__PURE__ */ x.jsx(dYt, { children: n?.name === w.name && (p || a) ? /* @__PURE__ */ x.jsx(bYt, {}) : /* @__PURE__ */ x.jsx(
              uYt,
              {
                onClick: async () => {
                  if (o(
                    `${e ? "Edit" : "View"} "${w.name}" variable`
                  ), i({
                    ...w,
                    value: $S(w.value)
                  }), w.truncated) {
                    l(!0);
                    const v = await xo.fetchVariable(
                      w.key
                    );
                    if (l(!1), v?.value === void 0) {
                      t.displayNotification?.error({
                        title: "Variable could not be fetched"
                      }), i(null);
                      return;
                    }
                    i({
                      ...w,
                      value: $S(
                        v.value
                      )
                    });
                  }
                  d(!0);
                },
                hasIconOnly: !0,
                renderIcon: e ? hI : M7,
                iconDescription: e ? "Edit" : "View",
                size: "sm",
                kind: "ghost"
              }
            ) })
          ] }, w.name)) })
        ] })
      ] }),
      /* @__PURE__ */ x.jsx(
        Rn,
        {
          onClick: () => {
            f(!0);
          },
          renderIcon: E7,
          iconDescription: "Add variable",
          size: "md",
          kind: "ghost",
          disabled: !e || n !== null,
          children: "Add variable"
        }
      ),
      /* @__PURE__ */ x.jsx(
        yPe,
        {
          isVisible: c,
          value: n?.value ?? void 0,
          title: s,
          primaryButtonLabel: "Apply",
          secondaryButtonLabel: "Cancel",
          readOnly: !e,
          onSubmit: async (w) => {
            if (d(!1), n === null || w === void 0)
              return;
            l(!0);
            const v = JSON.stringify({
              [n.name]: JSON.parse(w)
            }), y = await xo.setVariables({
              instanceKey: g,
              scope: r,
              variablesString: v
            });
            y && m !== void 0 && ao(
              rr(m.key),
              {
                action: "setVariables",
                variables: v
              }
            ), y || t.displayNotification?.error(zr), l(!1), i(null);
          },
          onClose: () => {
            d(!1), i(null);
          },
          isValidInput: CC
        }
      ),
      /* @__PURE__ */ x.jsx(
        NYt,
        {
          isVisible: u,
          validateVariableName: (w) => w === "" ? {
            isValid: !1,
            error: "Enter a variable name"
          } : w.includes('"') || w.includes(" ") ? {
            isValid: !1,
            error: "Variable contains invalid characters. Use only alphabets, numbers and dashes (-)"
          } : A.some(
            ({ name: v }) => v === w
          ) ? {
            isValid: !1,
            error: "A variable with this name already exists. Please enter another name."
          } : { isValid: !0 },
          onSubmit: async (w, v) => {
            if (f(!1), v === void 0)
              return;
            l(!0);
            const y = JSON.stringify({
              [w]: JSON.parse(v)
            }), _ = await xo.setVariables({
              instanceKey: g,
              scope: r,
              variablesString: y
            });
            _ && m !== void 0 && ao(
              rr(m.key),
              {
                action: "setVariables",
                variables: y
              }
            ), _ || t.displayNotification?.error(zr), l(!1), i(null);
          },
          onClose: () => {
            f(!1), i(null);
          }
        }
      )
    ] }) : /* @__PURE__ */ x.jsx(RYt, {}) }) })
  ] }) });
});
CPe.displayName = "Variables";
const VYt = q.div`
  display: flex;
  flex-direction: row;

  position: relative;
`, HYt = q.div`
  position: absolute;
  top: -3px;
  height: 6px;
  width: 100%;
  z-index: 1;

  cursor: ns-resize;
  transition: background-color 0.2s;

  ${({ $isResizing: r }) => r && "background-color: var(--cm-color-blue-base, #4d90ff);"};

  &:hover {
    background-color: var(--cm-color-blue-base, #4d90ff);
  }
`, BYt = q.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--cds-layer);
  border-right: 1px solid var(--cds-border-subtle-01);
  border-top: 1px solid var(--cds-border-subtle-01);
`, PYt = q.div`
  padding: 11px 16px;
  font-family: IBM Plex Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.16px;
  border-bottom: 1px solid var(--cds-border-subtle-01);
  height: ${ePe};
`, FYt = q.div`
  overflow: auto;

  .cds--tree-parent-node > .cds--tree-node__label {
    margin-inline-start: -1rem;
    padding-inline-start: 1rem;
  }
  .cds--tree-node__label {
    position: relative;

    margin-inline-start: -3.5rem;
    padding-inline-start: 3.5rem;

    > span:first-child {
      margin-inline-start: 30px;
    }
    > .cds--tree-parent-node__toggle:first-child {
      margin-inline-start: 22px;
    }
  }
`, zYt = q(Gxe)`
  .cds--tree-node__label__details {
    width: 100%;
  }
`, WYt = q.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 0 16px 0 12px;
`, jYt = q.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  position: absolute;
  left: 16px;
  padding-top: 1px;
`, ZYt = q.span`
  font-size: 16px;
  margin-top: -3px;
  transform: translateY(1px);
`;
function UYt({ type: r }) {
  switch (r) {
    case "PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-participant" });
    case "START_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-start-event-none" });
    case "SEQUENCE_FLOW":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-connection" });
    case "SERVICE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-service-task" });
    case "EXCLUSIVE_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-xor" });
    case "INCLUSIVE_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-or" });
    case "PARALLEL_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-parallel" });
    case "EVENT_BASED_GATEWAY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-gateway-eventbased" });
    case "SUB_PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-subprocess-expanded" });
    case "EVENT_SUB_PROCESS":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-event-subprocess-expanded" });
    case "INTERMEDIATE_CATCH_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "INTERMEDIATE_THROW_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "BOUNDARY_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-intermediate-event-none" });
    case "END_EVENT":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-end-event-none" });
    case "RECEIVE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-receive-task" });
    case "USER_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-user-task" });
    case "MANUAL_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-manual-task" });
    case "MULTI_INSTANCE_BODY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-parallel-mi-marker" });
    case "CALL_ACTIVITY":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-subprocess-collapsed" });
    case "BUSINESS_RULE_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-business-rule-task" });
    case "SCRIPT_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-script-task" });
    case "SEND_TASK":
      return /* @__PURE__ */ x.jsx("span", { className: "bpmn-icon-send-task" });
    default:
      return "?";
  }
}
const qYt = q(o7)`
  ${({ $isVisible: r }) => rs`
    min-width: 118px;
    transition: opacity 0.2s ease-in-out;
    opacity: ${r ? "1" : "0"};
    margin-top: 0;
    margin-bottom: 0;
  `}
`, GYt = ({ scopeKey: r }) => {
  const [e, t] = ye(!1), n = An(null);
  return Pe(() => {
    const i = ms(
      () => xo.state.variables,
      (s, o) => {
        [
          ...s.filter(
            ({ key: l }) => !o.some(({ key: c }) => c === l)
          ),
          ...s.filter((l) => {
            const c = o.find(
              ({ key: d }) => d === l.key
            );
            return c === void 0 ? !1 : c.value !== l.value;
          })
        ].map((l) => l.scopeKey).includes(r) && (t(!0), n.current !== null && clearTimeout(n.current), n.current = setTimeout(() => {
          t(!1);
        }, 3e3));
      }
    );
    return () => {
      i();
    };
  }, [e, r]), /* @__PURE__ */ x.jsx(qYt, { size: "sm", type: "green", $isVisible: e, children: "Variable modified" });
}, BH = rt(
  ({ instance: r, childNodes: e, isSelected: t, ...n }) => {
    const i = r.key === Ne.state.processInstance?.key;
    return /* @__PURE__ */ Hxe(
      zYt,
      {
        ...n,
        key: r.key,
        id: r.key.toString(),
        value: r.key.toString(),
        selected: t ? [r.key] : [],
        active: t ? r.key : void 0,
        renderIcon: () => /* @__PURE__ */ x.jsx(ZYt, { children: /* @__PURE__ */ x.jsx(UYt, { type: r.type }) }),
        onSelect: () => {
          kr.selectFlowNode({
            flowNodeId: i ? void 0 : r.flowNodeId,
            flowNodeName: i ? void 0 : r.flowNodeName ?? r.flowNodeId,
            flowNodeInstanceId: r.key,
            isMultiInstance: r.type === "MULTI_INSTANCE_BODY"
          });
        },
        label: /* @__PURE__ */ x.jsxs(WYt, { children: [
          /* @__PURE__ */ x.jsx(jYt, { children: /* @__PURE__ */ x.jsx(
            RH,
            {
              state: r.incident ? "INCIDENT" : r.state,
              size: 16
            }
          ) }),
          r.flowNodeName || r.flowNodeId,
          xo.isInitialLoadComplete && /* @__PURE__ */ x.jsx(GYt, { scopeKey: r.key })
        ] }),
        isExpanded: !0
      },
      e.length > 0 && e.map((s) => /* @__PURE__ */ x.jsx(
        BH,
        {
          instance: s.instance,
          childNodes: s.childNodes,
          isSelected: s.isSelected
        },
        s.instance.key
      ))
    );
  }
);
BH.displayName = "InstanceTreeNode";
const QYt = q.ul`
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  padding-top: ${ePe};
`, KYt = q.li`
  margin: var(--cds-spacing-05);
  display: flex;
  gap: var(--cds-spacing-05);
`, YYt = q($xe)`
  margin: 0;
`, XYt = () => /* @__PURE__ */ x.jsxs(KYt, { children: [
  /* @__PURE__ */ x.jsx(wFe, {}),
  /* @__PURE__ */ x.jsx(YYt, { width: "143px" })
] }), JYt = () => /* @__PURE__ */ x.jsx(QYt, { "data-testid": "instance-history-skeleton", children: [...Array(20)].map((r, e) => /* @__PURE__ */ x.jsx(XYt, {}, e)) }), EPe = rt(({ flowNodeInstances: r }) => {
  const [e, t] = ye(
    () => +(localStorage.getItem("play-bottom-bar-height") ?? 0) || 255
  ), [n, i] = ye(!1), s = An();
  Pe(() => {
    localStorage.setItem("play-bottom-bar-height", e.toString());
  }, [e]);
  const o = {}, a = [], { processInstance: l } = Ne.state;
  if (l === void 0)
    return null;
  const c = {
    instance: {
      key: l.key,
      flowNodeId: Nt.processName ?? gt.processId ?? "process",
      type: "PROCESS",
      startDate: l.startDate,
      endDate: l.endDate ?? null,
      scopeKey: null,
      state: l.state === "CANCELED" ? "TERMINATED" : l.state,
      processDefinitionKey: l.processDefinitionKey,
      incident: l.incident
    },
    childNodes: [],
    isSelected: kr.isSelected({
      flowNodeInstanceId: Ne.state.instanceKey,
      flowNodeId: gt.processId
    })
  };
  o[l.key] = c, a.push(c);
  for (let u = 0; u < r.length; u++) {
    const f = r[u], p = {
      instance: f,
      childNodes: [],
      isSelected: kr.isSelected({
        flowNodeInstanceId: f.key,
        flowNodeId: f.flowNodeId,
        isMultiInstance: f.type === "MULTI_INSTANCE_BODY"
      })
    };
    o[f.key] = p, f.scopeKey !== null && o[f.scopeKey] !== void 0 && o[f.scopeKey].childNodes.push(p);
  }
  function d(u) {
    u.preventDefault(), i(!0);
    const p = u.target.parentNode;
    s.current = {
      originalSize: p.clientHeight,
      dragStart: u.pageY
    };
    const g = (A) => {
      t(
        Math.max(
          10,
          (s.current?.originalSize ?? 0) + (s.current?.dragStart ?? 0) - A.pageY
        )
      );
    }, m = () => {
      i(!1), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", m);
    };
    document.addEventListener("mousemove", g), document.addEventListener("mouseup", m);
  }
  return /* @__PURE__ */ x.jsxs(VYt, { style: { height: e + "px" }, children: [
    /* @__PURE__ */ x.jsx(HYt, { $isResizing: n, onMouseDown: d }),
    /* @__PURE__ */ x.jsxs(BYt, { children: [
      /* @__PURE__ */ x.jsx(PYt, { children: "Instance History" }),
      yr.isInitialLoadComplete ? /* @__PURE__ */ x.jsx(FYt, { "data-testid": "instance-history", children: /* @__PURE__ */ x.jsx(Qxe, { hideLabel: !0, label: "Instance History", children: a.map((u) => /* @__PURE__ */ x.jsx(
        BH,
        {
          instance: u.instance,
          childNodes: u.childNodes,
          isSelected: u.isSelected
        },
        u.instance.key
      )) }) }) : /* @__PURE__ */ x.jsx(JYt, {})
    ] }),
    /* @__PURE__ */ x.jsx(
      CPe,
      {
        isActive: xo.scopeId === null ? !1 : o[xo.scopeId]?.instance.state === "ACTIVE",
        selectedScope: xo.scopeId
      }
    )
  ] });
});
EPe.displayName = "InstanceHistory";
const $Yt = (r = "", e = "new-diagram") => {
  const t = r?.normalize().replace(/[^_0-9\p{Letter}\p{Mark}]+/gu, "-").replace(/-+/g, "-").replace(/(^-|-$)/g, "").toLowerCase();
  return t === "" ? e : t;
}, eXt = "--", _Pe = (r, e) => r + eXt + $Yt(e), tXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 2, height: 10, viewBox: "0 0 2 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z", fill: "white" }), /* @__PURE__ */ be.createElement("path", { d: "M1 6C1.55228 6 2 5.55228 2 5C2 4.44772 1.55228 4 1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6Z", fill: "white" }), /* @__PURE__ */ be.createElement("path", { d: "M1 10C1.55228 10 2 9.55228 2 9C2 8.44771 1.55228 8 1 8C0.447715 8 0 8.44771 0 9C0 9.55228 0.447715 10 1 10Z", fill: "white" })), xPe = (r) => /* @__PURE__ */ be.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M14.7685 5.87999L13.12 4.23149C12.9713 4.08325 12.7699 4 12.56 4C12.3501 4 12.1487 4.08325 12 4.23149L5 11.2337V14H7.7663L14.7685 6.99999C14.9167 6.85132 15 6.64994 15 6.43999C15 6.23004 14.9167 6.02866 14.7685 5.87999ZM7.3521 13H6V11.6479L10.7205 6.92744L12.0725 8.27954L7.3521 13ZM12.7795 7.57249L11.4275 6.22044L12.5611 5.08684L13.9132 6.43894L12.7795 7.57249Z", fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 2, width: 10, height: 1, fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 5, width: 7, height: 1, fill: "white" }), /* @__PURE__ */ be.createElement("rect", { x: 1, y: 8, width: 4, height: 1, fill: "white" })), nXt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-envelope", viewBox: "0 0 16 16", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" })), iXt = (r) => /* @__PURE__ */ be.createElement("svg", { style: {
  paddingLeft: 4
}, width: 11, height: 12, viewBox: "0 0 11 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M0.5 12C0.367392 12 0.240215 11.9473 0.146447 11.8535C0.0526785 11.7598 1.36127e-09 11.6326 1.36127e-09 11.5V0.499976C-6.40951e-06 0.413085 0.0226312 0.327692 0.065681 0.252216C0.108731 0.176739 0.170707 0.113784 0.245499 0.0695563C0.320292 0.0253287 0.405319 0.00135537 0.4922 -1.73655e-07C0.57908 -0.00135572 0.664814 0.0199533 0.74095 0.0618261L10.7409 5.56183C10.8194 5.60497 10.8848 5.66839 10.9304 5.74546C10.976 5.82252 11 5.91042 11 5.99995C11 6.08949 10.976 6.17738 10.9304 6.25445C10.8848 6.33152 10.8194 6.39493 10.7409 6.43808L0.74095 11.9381C0.667127 11.9787 0.584248 12 0.5 12Z", fill: "white" })), PH = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", className: "bi bi-arrow-counterclockwise", viewBox: "0 0 16 16", ...r }, /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", d: "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" }), /* @__PURE__ */ be.createElement("path", { d: "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" })), rXt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 18 18", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "#52C16B" }, /* @__PURE__ */ be.createElement("path", { d: "M9 0C4.0374 0 0 4.0375 0 9c0 4.9627 4.0374 9 9 9s9-4.0373 9-9c0-4.9625-4.0374-9-9-9zm0 16.3636c-4.0604 0-7.3636-3.3032-7.3636-7.3635 0-4.0604 3.3032-7.3637 7.3636-7.3637S16.3636 4.9397 16.3636 9c0 4.0603-3.3033 7.3635-7.3636 7.3635z" }), /* @__PURE__ */ be.createElement("path", { d: "M5.101 9.85C5.0337 9.78 5 9.675 5 9.605s.0337-.175.101-.245l.4711-.49c.1346-.14.3366-.14.4712 0l.0336.035 1.851 2.065c.0673.07.1683.07.2356 0l4.5096-4.865h.0336c.1346-.14.3366-.14.4712 0l.4711.49c.1347.14.1347.35 0 .49l-5.3846 5.81c-.0673.07-.1346.105-.2356.105s-.1682-.035-.2355-.105l-2.625-2.94-.0673-.105z" }))), sXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { clipPath: "url(#clip0_2557_56096)" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, transform: "translate(0.5)", fill: "transparent" }), /* @__PURE__ */ be.createElement("g", { clipPath: "url(#clip1_2557_56096)" }, /* @__PURE__ */ be.createElement("path", { d: "M9.69601 7.99995L15.5 4.63295V11.3669L9.69601 7.99995ZM8.90401 7.30395C8.78141 7.37414 8.67952 7.47547 8.60866 7.59769C8.5378 7.71991 8.50049 7.85868 8.50049 7.99995C8.50049 8.14122 8.5378 8.27999 8.60866 8.40221C8.67952 8.52442 8.78141 8.62576 8.90401 8.69595L15.267 12.3879C15.787 12.6899 16.5 12.3449 16.5 11.6919V4.30795C16.5 3.65495 15.787 3.30995 15.267 3.61195L8.90401 7.30395Z" }), /* @__PURE__ */ be.createElement("path", { d: "M1.69601 7.99995L7.50001 4.63295V11.3669L1.69601 7.99995ZM0.904006 7.30395C0.781405 7.37414 0.679521 7.47547 0.608663 7.59769C0.537805 7.71991 0.500488 7.85868 0.500488 7.99995C0.500488 8.14122 0.537805 8.27999 0.608663 8.40221C0.679521 8.52442 0.781405 8.62576 0.904006 8.69595L7.26701 12.3879C7.78701 12.6899 8.50001 12.3449 8.50001 11.6919V4.30795C8.50001 3.65495 7.78701 3.30995 7.26701 3.61195L0.904006 7.30395Z" }))), /* @__PURE__ */ be.createElement("defs", null, /* @__PURE__ */ be.createElement("clipPath", { id: "clip0_2557_56096" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" })), /* @__PURE__ */ be.createElement("clipPath", { id: "clip1_2557_56096" }, /* @__PURE__ */ be.createElement("rect", { width: 16, height: 16, fill: "white", transform: "translate(0.5)" })))), oXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 180, height: 180, viewBox: "0 0 180 180", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M150.804 55.8922L150.494 49.0623H126.417C126.82 39.786 126.418 29.1415 126.418 29.1415H53.5819C53.5819 29.1415 53.1795 39.786 53.5831 49.0623H29.5059L29.1962 55.8922C29.1692 56.4865 28.6164 70.6236 35.6237 86.0315C41.7589 99.5223 54.8975 116.447 82.846 122.946V131.977H77.9039V138.148H53.4032V152.456H126.597V138.148H102.096V131.977H97.1541V122.946C125.102 116.447 138.241 99.5222 144.376 86.0315C151.384 70.6235 150.831 56.4865 150.804 55.8922ZM48.8725 80.5957C45.861 74.1454 44.5261 67.8866 43.9383 63.3704H54.7619C56.2251 75.2305 59.1824 88.702 65.0259 99.9776C58.0146 95.0724 52.6113 88.6029 48.8725 80.5957ZM101.322 104.518H79.4116V92.1394H101.322V104.518ZM101.331 73.5114C101.279 80.9953 97.5643 85.2491 90.3501 85.2491C83.1358 85.2491 79.4211 80.9929 79.4211 73.5658L79.4116 49.2818C79.4637 41.798 83.1784 37.5441 90.3926 37.5441C97.6069 37.5441 101.322 41.8004 101.322 49.2818V53.8029H94.3864V48.8089C94.3864 45.4702 92.8801 44.1791 90.5652 44.1791C88.2007 44.1247 86.7417 45.4158 86.7417 48.7545V73.9962C86.7417 77.3349 88.2503 78.5196 90.5652 78.5196C92.9298 78.5196 94.3864 77.3373 94.3864 73.9962V67.321H101.331V73.5114ZM131.352 80.1083C127.607 88.3417 122.128 94.9736 114.974 99.9781C120.817 88.7023 123.775 75.2307 125.238 63.3704H136.06C135.486 67.7767 134.203 73.8395 131.352 80.1083Z", fill: "#FC5D0D" })), aXt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", d: "M13 5H11V11H5V13H11V19H13V13H19V11H13V5Z" })), lXt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22.0833 10H1.9167c-.55 0-.9167.3667-.9167.9167V12.75c0 .55.3667.9167.9167.9167h20.1666c.55 0 .9167-.3667.9167-.9167v-1.8333c0-.55-.3667-.9167-.9167-.9167z" })), cXt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 15 15", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", d: "M.531 8.031H1.697c.2461 2.798 2.487 5.026 5.272 5.2721v1.1658c0 .285.2332.5311.5311.5311.285 0 .531-.2332.531-.531V13.303c2.798-.2461 5.026-2.487 5.2721-5.272h1.1658c.285 0 .5311-.2332.5311-.5311 0-.285-.2332-.531-.531-.531H13.303c-.2461-2.798-2.487-5.026-5.272-5.2721V.531C8.031.246 7.7979 0 7.5 0c-.285 0-.531.2332-.531.531V1.697c-2.798.2461-5.026 2.487-5.2721 5.272H.531C.233 6.969 0 7.2021 0 7.5c0 .298.2461.531.531.531zm4.3654-1.062H2.759c.246-2.2151 2.0077-3.9768 4.2098-4.21v2.1374c0 .285.2332.531.5311.531.285 0 .531-.2331.531-.531V2.759c2.2151.246 3.9768 2.0077 4.21 4.2098h-2.1374c-.285 0-.531.2332-.531.5311 0 .285.2331.531.531.531h2.1373c-.246 2.2151-2.0077 3.9768-4.2098 4.21v-2.1374c0-.285-.2332-.531-.5311-.531-.285 0-.531.2331-.531.531v2.1373c-2.2151-.246-3.9768-2.0077-4.21-4.2098h2.1374c.285 0 .531-.2332.531-.5311 0-.285-.246-.531-.531-.531z" })), hXt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ...r }, /* @__PURE__ */ be.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.8557 1.5478a.3332.3332 0 0 0-.328-.009l-5.5162 2.9204-5.516-2.9204a.5482.5482 0 0 0-.0627-.0234c-.046-.0113-.0647-.0127-.0837-.0133-.0434 0-.061.0033-.0788.0073-.0213.0047-2.0354.6745-6.042 2.0096A.3334.3334 0 0 0 1 3.8356v14.3471a.334.334 0 0 0 .3337.3336.3279.3279 0 0 0 .1054-.0173l5.8876-1.9625 5.5577 2.2885c.0514.016.0887.025.127.025a.334.334 0 0 0 .0888-.013c.0407-.0154.0548-.019.0674-.0257l5.6721-3.0029a.334.334 0 0 0 .1775-.295V1.8338a.334.334 0 0 0-.1615-.286zM2.0598 4.6795l4.6633-1.5897v12.188l-4.6633 1.5898V4.6796zM7.783 3.0898l4.5573 2.6495v11.6583L7.783 15.2779V3.0898zm10.1744 11.9761l-4.5043 2.3317V5.7393l4.5043-2.6495v11.9761z" })), dXt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ be.createElement("path", { d: "M7.8434 11.358H1.7862a.7985.7985 0 1 0 0 1.5971h5.2587v5.2587a.7985.7985 0 1 0 1.597 0v-6.0572a.7985.7985 0 0 0-.7985-.7986zM18.2138 7.0449h-5.2586V1.7862a.7985.7985 0 1 0-1.5971 0v6.0572c0 .441.3575.7986.7985.7986h6.0572a.7985.7985 0 1 0 0-1.5971z" }), /* @__PURE__ */ be.createElement("path", { d: "M19.7667.2333a.7965.7965 0 0 0-1.1265 0l-7.0489 7.0489a.7966.7966 0 0 0 1.1265 1.1265l7.049-7.049a.7966.7966 0 0 0 0-1.1264zM8.4087 11.5913a.7965.7965 0 0 0-1.1265 0l-7.0489 7.049a.7965.7965 0 1 0 1.1265 1.1264l7.0489-7.049a.7965.7965 0 0 0 0-1.1264z" }))), uXt = (r) => /* @__PURE__ */ be.createElement("svg", { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ be.createElement("path", { d: "M19.2015 0h-6.0573a.7985.7985 0 1 0 0 1.5971h5.2587v5.2587a.7985.7985 0 1 0 1.5971 0V.7985A.7985.7985 0 0 0 19.2015 0zM6.8558 18.4029H1.597v-5.2587a.7985.7985 0 1 0-1.5971 0v6.0573c0 .441.3575.7985.7985.7985h6.0573a.7985.7985 0 1 0 0-1.5971z" }), /* @__PURE__ */ be.createElement("path", { d: "M19.7667.2333a.7965.7965 0 0 0-1.1265 0l-7.0489 7.0489a.7966.7966 0 0 0 1.1265 1.1265l7.049-7.049a.7966.7966 0 0 0 0-1.1264zM8.4087 11.5913a.7965.7965 0 0 0-1.1265 0l-7.0489 7.049a.7965.7965 0 1 0 1.1265 1.1264l7.0489-7.049a.7965.7965 0 0 0 0-1.1264z" }))), fXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 17, height: 15, viewBox: "0 0 17 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.7219 5.2691C8.6668 4.2126 7.7435 2.4757 7.0638 1.00772C7.0445 1.00316 7.0206 1 6.9941 1C6.9675 1 6.9436 1.00316 6.9243 1.00773C6.2447 2.4757 5.322 4.2122 4.2662 5.2687C3.2106 6.325 1.47501 7.2485 0.00802994 7.9287C0.00328994 7.9483 0 7.9728 0 8C0 8.0271 0.00324982 8.0515 0.00793982 8.071C1.47467 8.751 3.2101 9.6743 4.2659 10.7311C5.322 11.7875 6.2448 13.5244 6.9245 14.9923C6.9437 14.9969 6.9675 15 6.994 15C7.0205 15 7.0444 14.9968 7.0636 14.9923C7.7433 13.5244 8.666 11.7877 9.7215 10.7315M9.7215 10.7315C10.773 9.6791 12.4531 8.7468 13.8721 8.0577C13.8756 8.0415 13.878 8.0217 13.878 7.9998C13.878 7.9779 13.8756 7.9582 13.8721 7.942C12.4537 7.2529 10.7734 6.3207 9.7219 5.2691", fill: "white" }), /* @__PURE__ */ be.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4808 1.52468C15.104 1.14737 14.7742 0.52704 14.5315 0.00275993C14.5246 0.00112993 14.5161 0 14.5066 0C14.4971 0 14.4885 0.00112993 14.4817 0.00275993C14.2389 0.52705 13.9094 1.14721 13.5323 1.52455C13.1553 1.9018 12.5355 2.2316 12.0116 2.4745C12.0099 2.4815 12.0087 2.4903 12.0087 2.5C12.0087 2.5097 12.0099 2.5184 12.0115 2.5254C12.5354 2.7682 13.1552 3.098 13.5322 3.4754C13.9094 3.8527 14.239 4.473 14.4817 4.9972C14.4886 4.9989 14.4971 5 14.5066 5C14.516 5 14.5246 4.9989 14.5314 4.9972C14.7742 4.473 15.1037 3.8528 15.4806 3.4755M15.4806 3.4755C15.8562 3.0997 16.4562 2.7667 16.963 2.5206C16.9643 2.5148 16.9651 2.5078 16.9651 2.4999C16.9651 2.4921 16.9643 2.4851 16.963 2.4793C16.4565 2.2332 15.8563 1.90026 15.4808 1.52468", fill: "white" })), pXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 18, height: 16, viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M1.18528 15.25L9 1.03773L16.8147 15.25H1.18528Z", stroke: "white" })), gXt = (r) => /* @__PURE__ */ be.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14C30,8.3,23.7,2,16,2z M14.9,8h2.2v11h-2.2V8z M16,25   c-0.8,0-1.5-0.7-1.5-1.5S15.2,22,16,22c0.8,0,1.5,0.7,1.5,1.5S16.8,25,16,25z", fill: "currentColor" })), mXt = (r) => /* @__PURE__ */ be.createElement("svg", { width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...r }, /* @__PURE__ */ be.createElement("path", { d: "M12 3H4v10h8V3Z", fill: "#000" }), /* @__PURE__ */ be.createElement("path", { d: "M8 1C4.15 1 1 4.15 1 8s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7Zm-.55 3h1.1v5.5h-1.1V4ZM8 12.5c-.4 0-.75-.35-.75-.75S7.6 11 8 11s.75.35.75.75-.35.75-.75.75Z", fill: "#FF832B" })), AXt = q.div`
  height: 30px;
  margin: 5px 10px;
`, wXt = q(rXt)`
  width: 20px;
  vertical-align: middle;
`, vXt = q.span`
  margin-left: 5px;
  vertical-align: middle;
`, eM = q(mXt)`
  margin-right: 16px;
  float: left;
`;
function cxe(r) {
  let e;
  const t = [], n = /(\{\{\s*secrets\.(?<newSyntax>\S+?\s*)}})|(secrets\.(?<oldSyntax>([a-zA-Z0-9]+[\\/._-])*[a-zA-Z0-9]+))/g;
  for (; (e = n.exec(r)) !== null; )
    e.groups?.newSyntax ? t.push(e.groups.newSyntax.trim()) : e.groups?.oldSyntax && t.push(e.groups.oldSyntax);
  return t;
}
function bXt(r) {
  const e = [];
  return r.forEach((t) => {
    const n = kT(
      t,
      "zeebe:IoMapping"
    ).flatMap(
      (l) => l.get("inputParameters")
    ), i = kT(
      t,
      "zeebe:Properties"
    ).flatMap((l) => l.get("properties")), s = n.flatMap(
      (l) => cxe(l?.source ?? "")
    ), o = i.flatMap(
      (l) => cxe(l.value ?? "")
    ), a = [...s, ...o];
    a.length && e.push({
      element: t,
      secrets: [...new Set(a)]
    });
  }), e;
}
const hxe = {
  existingSecrets: [],
  connectorElements: [],
  connectorElementsWithSecrets: [],
  status: "initial"
};
class yXt {
  state = { ...hxe };
  constructor() {
    Hi(this);
  }
  setupConnectors = async () => {
    if (this.state.status !== "initial")
      return;
    this.startLoading();
    const e = Nt.elements?.filter((n) => {
      if (n.type === "label")
        return !1;
      const i = an(n);
      return Object.hasOwn(i, "modelerTemplate") || Object.hasOwn(i?.$attrs, "zeebe:modelerTemplate");
    }) ?? [], t = bXt(e);
    this.setConnectorElements(e), this.setConnectorElementsWithSecrets(t), await this.getConnectorSecrets(), this.finishLoading();
  };
  startLoading = () => {
    this.state.status = "loading";
  };
  finishLoading = () => {
    this.state.status = "ready";
  };
  get areConnectorsReady() {
    return this.state.status === "ready";
  }
  setExistingSecrets = (e) => {
    this.state.existingSecrets = e;
  };
  setConnectorElements = (e) => {
    this.state.connectorElements = e;
  };
  setConnectorElementsWithSecrets = (e) => {
    this.state.connectorElementsWithSecrets = e;
  };
  getConnectorSecrets = async () => {
    const { success: e, secrets: t } = await At.getConnectorSecrets();
    e && this.setExistingSecrets(t);
  };
  get connectorElementsWithMissingSecrets() {
    if (gt.authType === "sm")
      return [];
    const e = [];
    return this.state.connectorElementsWithSecrets.forEach(({ element: t, secrets: n }) => {
      const i = n.filter(
        (s) => !this.state.existingSecrets.some(
          ({ name: o, value: a }) => o === s && a.trim() !== ""
        )
      );
      i.length > 0 && e.push({ element: t, missingSecrets: i });
    }), e;
  }
  get connectorProblems() {
    return this.areConnectorsReady ? this.connectorElementsWithMissingSecrets.flatMap(
      ({ element: e, missingSecrets: t }) => t.map((n) => ({ element: e, missingSecret: n }))
    ) ?? [] : [];
  }
  setConnectorSecret = async (e, t) => {
    if ((await At.setConnectorSecret({ name: e, value: t }))?.success === !1)
      return !1;
    const i = [
      ...this.state.existingSecrets?.filter(
        (s) => s.name !== e
      ) ?? [],
      { name: e, value: t }
    ];
    return this.setExistingSecrets(i), !0;
  };
  reset = () => {
    this.state = { ...hxe };
  };
}
const Gd = new yXt();
class CXt {
  constructor() {
    Hi(this);
  }
  get problemCount() {
    return gt.fileProblems.length + Gd.connectorProblems.length + Nt.diagramProblemCount;
  }
  get hasProblems() {
    return gt.hasDiagramError || this.problemCount > 0;
  }
}
const FH = new CXt(), SPe = rt(() => {
  const { fileProblems: r } = gt;
  Pe(() => {
    const t = () => {
      document.visibilityState !== "hidden" && Gd.getConnectorSecrets();
    };
    return window.addEventListener("visibilitychange", t), () => {
      window.removeEventListener("visibilitychange", t);
    };
  }, []);
  const { elementsWithExecutionListeners: e } = Nt;
  return FH.hasProblems ? /* @__PURE__ */ x.jsxs(Y4, { size: "sm", children: [
    /* @__PURE__ */ x.jsx(X4, { children: /* @__PURE__ */ x.jsxs(ko, { children: [
      /* @__PURE__ */ x.jsx(to, { children: "Element Name" }),
      /* @__PURE__ */ x.jsx(to, { children: "Error Message" }),
      /* @__PURE__ */ x.jsx(to, { children: "File Name" }),
      /* @__PURE__ */ x.jsx(to, { children: "Actionable Solutions" })
    ] }) }),
    /* @__PURE__ */ x.jsxs(J4, { children: [
      r.map((t) => /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsxs(di, { children: [
          (t.status === "unsupported binding" || t.status === "not found" || t.status === "deployment error") && /* @__PURE__ */ x.jsx(eM, {}),
          /* @__PURE__ */ x.jsx("b", { children: t.elementBusinessObject.name || t.elementBusinessObject.id })
        ] }),
        /* @__PURE__ */ x.jsxs(di, { children: [
          t.status === "unsupported binding" && "Version tag binding is not supported in Play",
          t.status === "not found" && "File not found",
          t.status === "deployment error" && "Deployment error"
        ] }),
        /* @__PURE__ */ x.jsx(di, { children: t.filename || t.id }),
        /* @__PURE__ */ x.jsxs(di, { children: [
          t.status === "unsupported binding" && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            "Change the binding for the element.",
            " ",
            /* @__PURE__ */ x.jsx(
              ja,
              {
                href: "https://docs.camunda.io/docs/components/best-practices/modeling/choosing-the-resource-binding-type/",
                target: "_blank",
                rel: "noreferrer",
                children: "See how"
              }
            )
          ] }),
          t.status === "not found" && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
            "Verify file path or check file permissions.",
            " ",
            /* @__PURE__ */ x.jsx(
              ja,
              {
                href: `https://docs.camunda.io/docs/components/modeler/web-modeler/advanced-modeling/${t.type === "decision" ? "business-rule-task" : t.type === "form" ? "form" : "call-activity"}-linking/`,
                target: "_blank",
                rel: "noreferrer",
                children: "See how"
              }
            )
          ] }),
          t.status === "deployment error" && /* @__PURE__ */ x.jsx(
            ja,
            {
              href: `/diagrams/${_Pe(
                t.fileId,
                t.filename
              )}`,
              target: "_blank",
              children: "Go to file and fix problems"
            }
          )
        ] })
      ] }, t.id + Math.random().toString())),
      Gd.connectorProblems.map((t) => /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsxs(di, { children: [
          /* @__PURE__ */ x.jsx(eM, {}),
          /* @__PURE__ */ x.jsx("b", { children: t.element.businessObject.name || t.element.businessObject.id })
        ] }),
        /* @__PURE__ */ x.jsx(di, { children: `Secret "${t.missingSecret}" missing` }),
        /* @__PURE__ */ x.jsx(di, { children: "-" }),
        /* @__PURE__ */ x.jsx(di, { children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(
            ja,
            {
              href: gt.consoleSecretsUrl,
              target: "_blank",
              rel: "noreferrer",
              children: "Update connector secret."
            }
          ),
          " Skip connector element. ",
          /* @__PURE__ */ x.jsx(
            ja,
            {
              href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#modify-a-process-instance",
              target: "_blank",
              rel: "noreferrer",
              children: "See how"
            }
          )
        ] }) })
      ] }, t.element.id + t.missingSecret)),
      e.map((t) => /* @__PURE__ */ x.jsxs(ko, { children: [
        /* @__PURE__ */ x.jsxs(di, { children: [
          /* @__PURE__ */ x.jsx(eM, {}),
          /* @__PURE__ */ x.jsx("b", { children: t.businessObject.name || t.businessObject.id })
        ] }),
        /* @__PURE__ */ x.jsx(di, { children: "Execution listeners are not suppported in Play. See actionable solution to resolve the issue." }),
        /* @__PURE__ */ x.jsx(di, { children: "-" }),
        /* @__PURE__ */ x.jsx(di, { children: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          " Skip element. ",
          /* @__PURE__ */ x.jsx(
            ja,
            {
              href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#modify-a-process-instance",
              target: "_blank",
              rel: "noreferrer",
              children: "See how"
            }
          )
        ] }) })
      ] }, t.id + Math.random().toString()))
    ] })
  ] }) : /* @__PURE__ */ x.jsxs(AXt, { children: [
    /* @__PURE__ */ x.jsx(wXt, {}),
    /* @__PURE__ */ x.jsx(vXt, { children: "No problems found." })
  ] });
});
SPe.displayName = "ErrorPanel";
q(In)`
  ${yl.bodyCompact01};
`;
const tM = q(di)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: var(--cds-text-primary);
`, EXt = q.span`
  font-weight: 700;
  margin-left: var(--cds-spacing-02);
  color: var(--cds-text-primary);
`, _Xt = q(_7)`
  fill: var(--cds-support-success);
`, xXt = q(dI)`
  fill: var(--cds-support-error);
`, dxe = q(ko)`
  ${({ $isClickable: r }) => rs`
      ${r && "cursor: pointer;"}
    `}
`, SXt = q.div`
  display: flex;
  align-items: center;
`, MXt = q(In)`
  ${yl.bodyCompact01};
  color: var(--cds-text-primary);
  padding: 0 var(--cds-spacing-05) var(--cds-spacing-04) var(--cds-spacing-05);
`, MPe = rt(() => /* @__PURE__ */ x.jsxs("div", { children: [
  /* @__PURE__ */ x.jsx(
    HH,
    {
      align: "bottom-start",
      definition: /* @__PURE__ */ x.jsxs(In, { gap: 3, children: [
        "This percentage indicates how much of your process is covered with all of your saved scenarios.",
        /* @__PURE__ */ x.jsx(
          vPe,
          {
            href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#scenario-coverage",
            target: "_blank",
            children: "Learn more"
          }
        )
      ] }),
      openOnHover: !0,
      children: "Overall coverage:"
    }
  ),
  /* @__PURE__ */ x.jsxs(EXt, { children: [
    ui.currentTotalCoverage.toFixed(0),
    "%"
  ] })
] }));
MPe.displayName = "OverallCoverage";
const DXt = q(In)`
  ${yl.bodyCompact01};
  color: var(--cds-text-primary);
  padding: var(--cds-spacing-04) var(--cds-spacing-05);
  display: flex;
  align-items: center;
  height: 44px;
`, LXt = q(Rn)`
  display: flex;
  align-items: center;
  padding-left: 0;
`, DPe = rt(() => {
  const [r, e] = ye(!1), t = ui.state.scenarios, { processId: n } = gt;
  if (n !== void 0)
    return /* @__PURE__ */ x.jsxs(DXt, { gap: 5, orientation: "horizontal", children: [
      /* @__PURE__ */ x.jsx(MPe, {}),
      t.length !== 0 && /* @__PURE__ */ x.jsx(x.Fragment, { children: r ? /* @__PURE__ */ x.jsxs(In, { gap: 3, orientation: "horizontal", children: [
        /* @__PURE__ */ x.jsx(GT, { withOverlay: !1, small: !0 }),
        " Running scenarios... This might take a while"
      ] }) : /* @__PURE__ */ x.jsx(
        LXt,
        {
          size: "sm",
          kind: "ghost",
          renderIcon: fI,
          disabled: ui.isAnyScenarioRunning,
          onClick: async () => {
            e(!0), Jn.runScenarios(t.length), await Promise.all(
              t.map(async ({ name: i, actions: s }) => {
                await ui.runSingleScenario({
                  name: i,
                  processId: n,
                  actions: s
                });
              })
            ), e(!1);
          },
          children: "Run all scenarios"
        }
      ) })
    ] });
}), kXt = () => {
  const r = bn(qr);
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(DPe, {}),
    /* @__PURE__ */ x.jsxs(MXt, { gap: 4, children: [
      /* @__PURE__ */ x.jsxs("div", { children: [
        "No",
        " ",
        /* @__PURE__ */ x.jsx(
          HH,
          {
            align: "bottom-start",
            definition: /* @__PURE__ */ x.jsxs("div", { children: [
              /* @__PURE__ */ x.jsx("div", { children: "A scenario is a saved process instance that can be used to replay and verify your path." }),
              /* @__PURE__ */ x.jsx("div", { children: "Several combined scenarios can be used to verify the whole process." })
            ] }),
            openOnHover: !0,
            children: "scenarios"
          }
        ),
        " ",
        "created yet.",
        /* @__PURE__ */ x.jsx("div", { children: "Start to increase your coverage by saving completed process instances as scenarios." })
      ] }),
      /* @__PURE__ */ x.jsx(
        ja,
        {
          href: "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#scenarios",
          target: "_blank",
          children: "Learn more"
        }
      ),
      /* @__PURE__ */ x.jsx(
        Rn,
        {
          kind: "tertiary",
          size: "sm",
          onClick: () => {
            r.startInstance?.();
          },
          children: "Start new instance"
        }
      )
    ] })
  ] });
}, LPe = rt(() => {
  const [r, e] = ye(
    null
  ), { processId: t } = gt;
  Pe(() => {
    t !== void 0 && ui.loadScenarios(t);
  }, [t]);
  const { scenarios: n, selectedScenario: i } = ui.state;
  return n.length === 0 || t === void 0 ? /* @__PURE__ */ x.jsx(kXt, {}) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(DPe, {}),
    /* @__PURE__ */ x.jsxs(Y4, { size: "sm", children: [
      /* @__PURE__ */ x.jsx(X4, { children: /* @__PURE__ */ x.jsxs(dxe, { children: [
        /* @__PURE__ */ x.jsx(to, { children: "Scenario name" }),
        /* @__PURE__ */ x.jsx(to, { children: "Status" }),
        /* @__PURE__ */ x.jsx(to, { children: "Operations" })
      ] }) }),
      /* @__PURE__ */ x.jsx(J4, { children: n?.map((s) => {
        const { key: o, name: a, actions: l } = s, c = i?.name === a, d = ui.getScenarioRun(a), u = d?.status;
        return /* @__PURE__ */ x.jsxs(
          dxe,
          {
            "data-testid": o,
            $isClickable: !0,
            isSelected: c,
            onClick: () => {
              c ? ui.clearSelectedScenario() : ui.setSelectedScenario(s);
            },
            children: [
              /* @__PURE__ */ x.jsx(tM, { children: a }),
              /* @__PURE__ */ x.jsx(tM, { children: u === "Running" ? /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", gap: 3, children: [
                /* @__PURE__ */ x.jsx(GT, { withOverlay: !1, small: !0 }),
                " ",
                /* @__PURE__ */ x.jsx("div", { children: "Running..." })
              ] }) : u === "Completed" ? /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", gap: 3, children: [
                /* @__PURE__ */ x.jsx(_Xt, {}),
                " ",
                /* @__PURE__ */ x.jsx("div", { children: "Completed" })
              ] }) : u === "Failed" ? /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", gap: 3, children: [
                /* @__PURE__ */ x.jsx(xXt, {}),
                " ",
                /* @__PURE__ */ x.jsx("div", { children: "Failed" })
              ] }) : "-" }),
              /* @__PURE__ */ x.jsx(tM, { children: /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", children: [
                /* @__PURE__ */ x.jsx(
                  hM,
                  {
                    label: "Run scenario",
                    disabled: u === "Running",
                    kind: "ghost",
                    size: "sm",
                    onClick: async (f) => {
                      f.stopPropagation(), Jn.runScenarios(1), ui.runSingleScenario({
                        name: a,
                        processId: t,
                        actions: l
                      });
                    },
                    children: /* @__PURE__ */ x.jsx(fI, {})
                  }
                ),
                /* @__PURE__ */ x.jsx(
                  hM,
                  {
                    label: "Delete scenario",
                    disabled: u === "Running",
                    kind: "ghost",
                    size: "sm",
                    onClick: (f) => {
                      f.stopPropagation(), e(s);
                    },
                    children: /* @__PURE__ */ x.jsx(vMe, {})
                  }
                ),
                u === "Completed" && /* @__PURE__ */ x.jsx(
                  Rn,
                  {
                    kind: "ghost",
                    size: "sm",
                    onClick: () => {
                      Ne.setInstanceDetails({
                        instanceKey: d?.instanceKey,
                        instanceType: "EXISTING_INSTANCE"
                      });
                    },
                    children: "View scenario"
                  }
                ),
                u === "Failed" && /* @__PURE__ */ x.jsxs(SXt, { children: [
                  /* @__PURE__ */ x.jsx(
                    Rn,
                    {
                      kind: "ghost",
                      size: "sm",
                      onClick: () => {
                        Jn.runScenarios(1), ui.runSingleScenario({
                          name: a,
                          processId: t,
                          actions: l
                        });
                      },
                      children: "Retry"
                    }
                  ),
                  "",
                  "or",
                  /* @__PURE__ */ x.jsx(
                    Rn,
                    {
                      kind: "ghost",
                      size: "sm",
                      onClick: () => {
                        Ne.setInstanceDetails({
                          instanceKey: d?.instanceKey,
                          instanceType: "EXISTING_INSTANCE"
                        });
                      },
                      children: "manually complete and update the scenario"
                    }
                  )
                ] })
              ] }) })
            ]
          },
          o
        );
      }) })
    ] }),
    /* @__PURE__ */ x.jsx(
      M1,
      {
        open: r !== null,
        preventCloseOnClickOutside: !0,
        size: "sm",
        modalHeading: "Delete scenario",
        danger: !0,
        primaryButtonText: "Delete",
        secondaryButtonText: "Cancel",
        onRequestClose: () => {
          e(null);
        },
        onRequestSubmit: () => {
          t === void 0 || r === null || (e(null), ui.deleteScenario({
            processId: t,
            scenario: r
          }), ui.loadScenarios(t));
        },
        children: /* @__PURE__ */ x.jsx("div", { children: `Are you sure you want to delete '${r?.name}' scenario? This action cannot be undone.` })
      }
    )
  ] });
});
LPe.displayName = "Scenarios";
const NXt = q.div`
  padding: var(--cds-spacing-07);
`, TXt = q.div`
  color: var(--cds-text-primary);
  ${yl.heading03};
  margin-bottom: var(--cds-spacing-03);
`, IXt = q.div`
  color: var(--cds-text-secondary);
  ${yl.helperText02};
  font-weight: 400;
`, OXt = q.div`
  display: inline-block;
  margin-right: var(--cds-spacing-05);
  margin-top: -10px;
  transform: translateY(4px);
`, RXt = q(gPe)`
  color: var(--cds-link-primary);
  ${yl.body01};
  word-wrap: break-word;
  height: 20px;
`, nM = q(to)`
  width: 300px;
`, kPe = rt(() => {
  const r = OT.state.processInstances;
  return r.length === 0 ? /* @__PURE__ */ x.jsxs(NXt, { children: [
    /* @__PURE__ */ x.jsx(TXt, { children: "Start by activating a process instance" }),
    /* @__PURE__ */ x.jsx(IXt, { children: "To activate an instance, click the Play button on the canvas" })
  ] }) : /* @__PURE__ */ x.jsxs(Y4, { size: "sm", children: [
    /* @__PURE__ */ x.jsx(X4, { children: /* @__PURE__ */ x.jsxs(ko, { children: [
      /* @__PURE__ */ x.jsx(nM, { children: "Instance Key" }),
      /* @__PURE__ */ x.jsx(nM, { children: "Started at" }),
      /* @__PURE__ */ x.jsx(nM, { children: "Operations" })
    ] }) }),
    /* @__PURE__ */ x.jsx(J4, { children: r?.map(({ key: e, startDate: t, state: n, incident: i }) => /* @__PURE__ */ x.jsxs(ko, { children: [
      /* @__PURE__ */ x.jsxs(di, { children: [
        /* @__PURE__ */ x.jsx(OXt, { children: /* @__PURE__ */ x.jsx(RH, { state: i ? "INCIDENT" : n, size: 20 }) }),
        /* @__PURE__ */ x.jsx(
          RXt,
          {
            variant: "text",
            onClick: () => {
              Ne.setInstanceDetails({
                instanceKey: e,
                instanceType: "EXISTING_INSTANCE"
              });
            },
            children: e
          }
        )
      ] }),
      /* @__PURE__ */ x.jsx(di, { children: pPe(t) }),
      /* @__PURE__ */ x.jsx(di, { children: "-" })
    ] }, e)) ?? /* @__PURE__ */ x.jsx(ko, { children: /* @__PURE__ */ x.jsx(di, { children: "No Content" }) }) })
  ] });
});
kPe.displayName = "Processes";
const NPe = rt(() => {
  const r = bn(qr), { activeTab: e } = eo.state, t = r.featureFlags.isReplayScenariosEnabled, { problemCount: n } = FH;
  Pe(() => {
    n > 0 && eo.setActiveTab("problems");
  }, [n]);
  const { instanceKey: i } = Ne.state, s = yr.state.elementInstances?.filter(
    (o) => o.type !== "SEQUENCE_FLOW"
  );
  return i ? /* @__PURE__ */ x.jsx(EPe, { flowNodeInstances: s }) : /* @__PURE__ */ x.jsxs("div", { children: [
    /* @__PURE__ */ x.jsxs($Kt, { children: [
      t && /* @__PURE__ */ x.jsx(
        JS,
        {
          $isActive: e === "scenarios",
          onClick: () => eo.setActiveTab("scenarios"),
          children: /* @__PURE__ */ x.jsx(XS, { children: "Scenarios" })
        }
      ),
      /* @__PURE__ */ x.jsx(
        JS,
        {
          $isActive: e === "instances",
          onClick: () => eo.setActiveTab("instances"),
          children: /* @__PURE__ */ x.jsx(XS, { children: "Process Instances" })
        }
      ),
      /* @__PURE__ */ x.jsx(
        JS,
        {
          $isActive: e === "problems",
          onClick: () => eo.setActiveTab("problems"),
          children: /* @__PURE__ */ x.jsxs(XS, { children: [
            "Problems",
            " ",
            n > 0 && /* @__PURE__ */ x.jsx(
              tYt,
              {
                type: "gray",
                title: n.toString(),
                size: "sm",
                children: n.toString()
              }
            )
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ x.jsxs(eYt, { children: [
      e === "instances" && /* @__PURE__ */ x.jsx(kPe, {}),
      e === "problems" && /* @__PURE__ */ x.jsx(SPe, {}),
      t && e === "scenarios" && /* @__PURE__ */ x.jsx(LPe, {})
    ] })
  ] });
});
NPe.displayName = "BottomBar";
const VXt = "data:video/mp4;base64,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", HXt = q.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background-color: rgba(22, 22, 22, 0.5);
  z-index: 1;
`;
q(In)`
  background-color: #f4f4f4;
  width: 100%;
  padding: 88px;
`;
q.h4`
  color: var(--cds-text-secondary, #161616);

  /* Fixed heading styles/heading-03 */
  font-family: IBM Plex Sans;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 28px !important; /* 140% */
`;
q.div`
  color: var(--cds-text-secondary, #525252);

  /* Fixed Body styles/body-01 */
  font-family: IBM Plex Sans;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 20px !important; /* 142.857% */
  letter-spacing: 0.16px !important;
`;
const BXt = q.div`
  background-color: white;
  width: 640px;
  margin: 100px auto;
`, PXt = q.div`
  padding: 16px;
`, FXt = q.div`
  text-align: right;
`, iM = q(Rn)`
  width: 320px;
`;
q.div`
  background: #f6f8f5;
  height: 253px;
  display: flex;
  padding-top: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #000;

  text-align: center;
  /* Body styles/body-02 */
  font-family: IBM Plex Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */

  margin-bottom: 8px;
`;
const zXt = q.video`
  width: 100%;
  height: 100%;
`;
function WXt({
  isInitial: r,
  isDeployingFiles: e,
  hasDiagramError: t,
  hasProblems: n,
  areConnectorsReady: i
}) {
  return t || n ? {
    helperText: t ? `The diagram failed to deploy.
Please check the Output tab in the Implement mode for more details.` : "Some parts of your process will not work. Please check the problems tab for actionable solutions.",
    status: "error",
    label: "Failed",
    value: 100
  } : r ? {
    helperText: "Preparing Play environment...",
    status: "active",
    label: "In progress",
    value: 30
  } : e || !i ? {
    helperText: e ? "Auto-deploying supporting files..." : "Loading connectors...",
    status: "active",
    label: "In progress",
    value: 60
  } : {
    helperText: "Play environment is ready",
    status: "finished",
    label: "Completed",
    value: 100
  };
}
const TPe = rt(
  ({ authConfig: r, close: e, switchToImplementMode: t }) => {
    const n = r?.type, i = n === "saas" ? r.config.clusterId : void 0, s = An(null), {
      state: { status: o, isRedeployment: a }
    } = gt, { areConnectorsReady: l } = Gd, c = FH.hasProblems, d = gt.isEnvironmentCreated && l, { isLoaded: u } = Nt.state;
    Pe(() => {
      u && Gd.setupConnectors();
    }, [u]), Pe(() => {
      n === "saas" && !i || !u || o !== "initial" || gt.setupEnvironment();
    }, [u, i, o, n]), Pe(() => {
      a && d && !c && e?.();
    }, [a, d, c, e]);
    const {
      helperText: f,
      status: p,
      label: g,
      value: m
    } = WXt({
      isInitial: o === "initial",
      isDeployingFiles: o === "deploying-files",
      hasDiagramError: gt.hasDiagramError,
      hasProblems: c,
      areConnectorsReady: l
    });
    return /* @__PURE__ */ x.jsx(HXt, { children: /* @__PURE__ */ x.jsxs(BXt, { children: [
      /* @__PURE__ */ x.jsxs(PXt, { children: [
        /* @__PURE__ */ x.jsx(
          zXt,
          {
            ref: s,
            autoPlay: !0,
            onEnded: () => {
              s.current !== null && (s.current.currentTime = 0, s.current.play());
            },
            children: /* @__PURE__ */ x.jsx("source", { src: VXt, type: "video/mp4" })
          }
        ),
        /* @__PURE__ */ x.jsx(Wg, { children: /* @__PURE__ */ x.jsx(
          Kxe,
          {
            label: g,
            helperText: f,
            value: m,
            status: p
          }
        ) })
      ] }),
      /* @__PURE__ */ x.jsx(FXt, { children: /* @__PURE__ */ x.jsx(x.Fragment, { children: (() => {
        if (d) {
          if (gt.hasDiagramError)
            return /* @__PURE__ */ x.jsx(
              iM,
              {
                size: "xl",
                onClick: () => t?.(!0),
                children: "View errors in Implement mode"
              }
            );
          if (c)
            return /* @__PURE__ */ x.jsx(iM, { size: "xl", onClick: e, children: "View problems" });
          if (!a)
            return /* @__PURE__ */ x.jsx(iM, { size: "xl", onClick: e, children: "Start a process instance" });
        }
      })() }) })
    ] }) });
  }
);
TPe.displayName = "StartModal";
const jXt = {
  outline: {
    fill: "var(--cds-highlight, #d0e2ff)"
  },
  defaultFillColor: "var(--cds-layer-01, #fff)",
  defaultStrokeColor: "var(--cds-icon-secondary, #525252)",
  element: {
    text: "var(--cds-text-primary, #161616)",
    background: {
      default: "var(--cds-layer-01, #fff)"
    }
  }
};
function uxe(r, e) {
  return e !== void 0 && !e.includes(r.businessObject.id) && r.type !== "label" && rPe(r.businessObject);
}
const ZXt = "Modification is not supported for this flow node.";
class UXt {
  navigatedViewer = null;
  #n = null;
  selectedFlowNode;
  #t = [];
  #e;
  #i = [];
  import = async (e) => {
    this.navigatedViewer.off("element.click", this.#s), this.#t = [], this.#e = void 0, await this.navigatedViewer.importXML(e), this.navigatedViewer.on("element.click", this.#s);
  };
  render = async (e) => {
    const { container: t, xml: n, selectableFlowNodeIds: i, selectedFlowNodeIds: s } = e;
    if (this.navigatedViewer === null && this.#c(t), this.#n !== n && (this.#n = n, await this.import(n)), !Ar(this.#t, i)) {
      this.#t.forEach((l) => {
        this.removeMarker(l, "play-selectable");
      }), i.forEach((l) => {
        this.addMarker(l, "play-selectable");
      }), this.#t = i;
      const o = this.getElementRegistry();
      this.#i.forEach((l) => {
        this.removeMarker(l, "play-non-selectable"), this.#a(l);
      });
      const a = o?.filter(
        (l) => uxe(l, i)
      );
      a?.forEach(({ id: l }) => {
        this.addMarker(l, "play-non-selectable"), e.showModificationNotSupportedTooltip && this.#r(l, ZXt);
      }), this.#i = a ? a.map(({ id: l }) => l) : [];
    }
    if (!Ar(this.#e?.sort(), s?.sort())) {
      this.#e !== void 0 && (this.#e.forEach((a) => {
        this.removeMarker(a, "play-selected"), this.removeMarker(a, "play-selected-frame");
      }), this.selectedFlowNode = void 0);
      const o = this.getElementRegistry();
      s !== void 0 && s.forEach((a) => {
        this.addMarker(a, "play-selected"), this.addMarker(a, "play-selected-frame"), this.selectedFlowNode = o?.getGraphics(a);
      }), this.#e = s;
    }
  };
  addMarker = (e, t) => {
    const n = this.navigatedViewer?.get("canvas");
    this.getElementRegistry()?.get(e) !== void 0 && n?.addMarker(e, t);
  };
  #r = (e, t) => {
    if (document.querySelector(
      `[data-element-id="${e}"] title`
    ) === null) {
      const i = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "title"
      );
      i.textContent = t, document.querySelector(`[data-element-id="${e}"]`)?.appendChild(i);
    }
  };
  #a = (e) => {
    const t = document.querySelector(
      `[data-element-id="${e}"] title`
    );
    t !== null && document.querySelector(`[data-element-id="${e}"]`)?.removeChild(t);
  };
  removeMarker = (e, t) => {
    const n = this.navigatedViewer?.get("canvas");
    this.getElementRegistry()?.get(e) !== void 0 && n?.removeMarker(e, t);
  };
  #s = (e) => {
    const t = e.element;
    if (!(uxe(t, this.#t) || this.#t.length === 0))
      if (this.#t.includes(t.id) && (this.#e === void 0 || !this.#e.includes(t.id)))
        if (hl.isMovingToken) {
          kr.clearSelection(), hl.moveToken(
            t.id,
            t.businessObject?.name ?? t.id
          );
          return;
        } else
          kr.selectFlowNode({
            flowNodeId: t.id,
            flowNodeName: t.businessObject.name ?? t.id,
            isMultiInstance: TT(t.businessObject)
          });
      else this.#e !== void 0 && kr.clearSelection();
  };
  #o = (e, t) => {
    this.navigatedViewer?.get("overlays")?.remove({ type: e, element: t });
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addOverlay = (e, t, n) => {
    this.#o(t, e);
    const i = document.createElement("div");
    return this.navigatedViewer?.get("overlays")?.add(e.id, t, {
      html: i,
      position: n
    }), i;
  };
  #c = (e) => {
    this.#l(), this.navigatedViewer = new Sg({
      container: e,
      bpmnRenderer: jXt,
      additionalModules: [
        mV,
        UOe,
        KOe,
        sRe
      ]
    });
  };
  zoom = (e) => {
    this.navigatedViewer?.get("zoomScroll")?.stepZoom(e);
  };
  zoomIn = () => {
    this.zoom(0.1);
  };
  zoomOut = () => {
    this.zoom(-0.1);
  };
  toggleMinimap = () => {
    Nt.toggleMinimap(), this.navigatedViewer?.get("minimap").toggle();
  };
  zoomReset = () => {
    const e = this.navigatedViewer?.get("canvas");
    e != null && (e.resized(), e.zoom("fit-viewport", "auto"));
  };
  #l = () => {
    this.navigatedViewer?.destroy();
  };
  getElementRegistry = () => this.navigatedViewer?.get("elementRegistry");
  getGraphicsFactory = () => this.navigatedViewer?.get("graphicsFactory");
  getDefinitions = () => this.navigatedViewer?.getDefinitions();
  focusOnElement = (e) => {
    if (this.navigatedViewer === null)
      return;
    this.navigatedViewer.get("zoomScroll").reset();
    const t = this.navigatedViewer.get("elementRegistry").get(e);
    t !== void 0 && (this.navigatedViewer.get("canvas").scrollToElement(t), kr.selectFlowNode({
      flowNodeId: t.id,
      flowNodeName: t.businessObject?.name ?? t.id,
      isMultiInstance: TT(t.businessObject)
    }));
  };
  saveXML = async () => this.navigatedViewer?.saveXML({ format: !0 });
  reset = () => {
    this.#l();
  };
}
const qXt = q.div`
  width: 100%;
  position: relative;
  background-color: white;
  display: flex;
  flex: 1;
`, GXt = q.div`
  ${({ $isSelectionAllowed: r }) => rs`
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      .play-sequence-flow-taken .djs-visual path {
        stroke: var(--cds-background-brand) !important;
      }
      .play-sequence-flow-taken marker path {
        fill: var(--cds-background-brand) !important;
      }
      .play-flow-node-taken polygon,
      .play-flow-node-taken rect,
      .play-flow-node-taken circle {
        stroke: var(--cds-background-brand) !important;
      }
      .djs-container svg:focus {
        outline: none;
      }

      ${r ? rs`
            .play-selectable:hover {
              cursor: pointer;

              .djs-hit-all {
                cursor: pointer !important;
              }
            }

            .djs-outline {
              visibility: initial !important;
            }

            .play-selectable:hover .djs-outline,
            .play-selected-frame .djs-outline {
              stroke-width: 2px;
              stroke: var(--cds-link-inverse, #78a9ff);
            }

            .play-non-selectable {
              cursor: not-allowed;

              .djs-hit-all {
                cursor: not-allowed !important;
              }
            }

            .play-selected .djs-visual {
              rect,
              circle,
              polygon {
                fill: var(--cds-highlight, #d0e2ff) !important;
              }
            }
          ` : rs`
            .djs-hit {
              pointer-events: none;
            }
          `}
    `}
`, QXt = q.div`
  display: flex;
`, KXt = q(Rn)`
  width: 42px;
`, YXt = q(Rn)`
  width: 16px;

  > :first-child {
    min-width: 0;
    margin-top: 3px;
  }
`, Ih = ({ actions: r, disabled: e }) => {
  const [t, n] = ye(null), [i, ...s] = r;
  return /* @__PURE__ */ x.jsxs(QXt, { children: [
    /* @__PURE__ */ x.jsx(
      KXt,
      {
        hasIconOnly: !0,
        iconDescription: i.label,
        "data-testid": `${i.elementId}-${i.label}`,
        size: "sm",
        kind: i.kind ?? "primary",
        disabled: e || i.disabled,
        renderIcon: i.renderIcon,
        onClick: i.onClick
      }
    ),
    s.length > 0 && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        YXt,
        {
          hasIconOnly: !0,
          "data-testid": `secondary-${i.elementId}-${i.label}`,
          kind: "secondary",
          iconDescription: "Additional actions",
          size: "sm",
          disabled: e,
          onClick: (o) => {
            n(o.currentTarget);
          },
          renderIcon: () => /* @__PURE__ */ x.jsx(tXt, { color: "white" })
        }
      ),
      /* @__PURE__ */ x.jsx(
        sf,
        {
          align: "left",
          anchorEl: t,
          open: !!t,
          onClose: () => n(null),
          children: s.map((o) => o.type === "divider" ? /* @__PURE__ */ x.jsx(sf.ListItemDivider, {}, o.label) : (
            //@ts-expect-error Property 'ListItem' does not exist on type 'typeof Dropdown'.ts(2339)
            /* @__PURE__ */ x.jsx(
              sf.ListItem,
              {
                onClick: (...a) => (n(null), o?.onClick?.(...a)),
                children: o.label
              },
              o.label
            )
          ))
        }
      )
    ] })
  ] });
}, XXt = q(K4)`
  margin-bottom: var(--cds-spacing-03, 8px);
`;
q(Hf)`
  margin-top: var(--cds-spacing-06, 16px);
  max-width: unset;
`;
const JXt = q.div`
  min-width: 0; // https://github.com/microsoft/monaco-editor/issues/3393
`, $Xt = q.div`
  display: flex;
  min-height: var(--cds-layout-size-height-md);
  justify-content: space-between;
`, eJt = q.div`
  display: flex;
  flex-direction: column;
`, tJt = q(ja)`
  display: flex;
  width: fit-content;
`, nJt = q.div`
  width: 40%;
  min-width: fit-content;
  margin-left: var(--cds-spacing-05);
  display: flex;
  justify-content: end;
  align-items: start;
  > * {
    width: max-content;
  }
`, fxe = "camundaModeler:exampleOutputJson";
function iJt(r, e) {
  if (!rf(e))
    return !1;
  const t = an(r);
  if (bC(t) === e)
    return !1;
  const n = rJt(t), i = sJt(n), s = i.properties.find(
    (o) => o.name === fxe
  );
  if (s)
    s.value = e;
  else {
    const o = i.$model.create("zeebe:Property", {
      name: fxe,
      value: e
    });
    o.$parent = i, i.properties.push(o);
  }
  return !0;
}
function rJt(r) {
  let e = r.get("extensionElements");
  return e === void 0 && (e = r.$model.create("bpmn:ExtensionElements", {
    values: []
  }), e.$parent = r, r.extensionElements = e), e;
}
function sJt(r) {
  let e = r.get("values").find((t) => t.$type === "zeebe:Properties");
  return e || (e = r.$model.create("zeebe:Properties", {
    properties: []
  }), e.$parent = r, r.values.push(e)), e;
}
const _C = rt(
  ({
    isValid: r,
    editedValue: e,
    element: t,
    onSuccess: n,
    tooltipTextForInvalid: i = "Please enter valid JSON to save"
  }) => {
    const [s, o] = ye("initial"), a = bn(qr)?.switchToImplementMode, l = xQt(t);
    if (!gt.canUserSaveExampleData || l)
      return null;
    const c = bC(t), d = !r || e === "" || e === c, u = c !== void 0 ? "Update example data" : "Save example data";
    let f;
    !r || e === "" ? f = i : d && (f = "Please make changes to the example data to save");
    const p = async () => {
      const g = iJt(t, e), m = await gt.updateFile();
      g && m.success ? (o("success"), n()) : g && !m.success && m.reason === "conflict" ? o("conflict") : o("error");
    };
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsxs($Xt, { children: [
        /* @__PURE__ */ x.jsxs(eJt, { children: [
          /* @__PURE__ */ x.jsx("div", { children: "Save these variables as example data in the BPMN file for collaborative reuse" }),
          /* @__PURE__ */ x.jsx(
            tJt,
            {
              href: "https://docs.camunda.io/docs/components/modeler/data-handling/",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "Learn more"
            }
          )
        ] }),
        /* @__PURE__ */ x.jsx(nJt, { children: s === "success" ? /* @__PURE__ */ x.jsx(
          UT,
          {
            description: "Saved successfully",
            status: "finished",
            onSuccess: () => {
              o("initial");
            }
          }
        ) : d ? /* @__PURE__ */ x.jsx(ew, { align: "bottom-end", label: f, children: /* @__PURE__ */ x.jsx("div", { children: /* @__PURE__ */ x.jsx(
          Rn,
          {
            kind: "tertiary",
            size: "md",
            onClick: p,
            disabled: d,
            children: u
          }
        ) }) }) : /* @__PURE__ */ x.jsx(Rn, { kind: "tertiary", size: "md", onClick: p, children: u }) })
      ] }),
      s === "conflict" && /* @__PURE__ */ x.jsx(
        Hf,
        {
          inline: !0,
          kind: "error",
          lowContrast: !0,
          hideCloseButton: !0,
          statusIconDescription: "notification",
          subtitle: "Example data could not be saved. The diagram has been updated by another user. Got to Implement tab to see the latest version.",
          title: "File Conflict:",
          onActionButtonClick: () => {
            a?.(!1);
          },
          actionButtonLabel: "Go to Implement"
        }
      ),
      s === "error" && /* @__PURE__ */ x.jsx(
        qT,
        {
          kind: "error",
          lowContrast: !0,
          hideCloseButton: !0,
          statusIconDescription: "notification",
          subtitle: "An unknown error occurred. Please try again later",
          title: "Unknown Error:"
        }
      )
    ] });
  }
), oJt = q.div`
  display: flex;
  align-items: center;
  color: var(
    --cds-text-secondary,
    #525252
  ); // revisit after https://github.com/camunda/play/issues/143
  min-height: var(
    --cds-spacing-06,
    1.5rem
  ); // revisit after https://github.com/camunda/play/issues/143

  svg {
    fill: var(--cds-icon-secondary);
    margin-right: var(
      --cds-spacing-02,
      0.25rem
    ); // revisit after https://github.com/camunda/play/issues/143
  }
`, xC = ({
  originalSource: r,
  isDescriptionVisible: e
}) => {
  if (r === "none")
    return null;
  let t = "";
  return r === "bpmn" ? t = "Prefilled from the BPMN’s example data" : r === "cache" && (t = "Prefilled from a previous session"), /* @__PURE__ */ x.jsx(oJt, { children: e ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(uI, {}),
    t
  ] }) : null });
}, IPe = (r, e) => {
  const { prefillData: t, prefillSource: n } = qd({
    element: r,
    useCache: !0,
    processId: e
  }), [i, s] = ye(t), [o, a] = ye(n), [l, c] = ye(!1), d = rf(i) || i === "", u = () => {
    const { prefillData: p, prefillSource: g } = qd({
      element: r,
      useCache: !1,
      processId: e
    });
    s(p), a(g), c(!1);
  }, f = ds(
    (p) => {
      p !== i && (s(p), c(!0));
    },
    [i]
  );
  return {
    editedValue: i,
    isValid: d,
    prefillSource: o,
    isDirty: l,
    setEditedValue: f,
    resetPrefill: u
  };
}, OPe = rt(
  ({
    isOpen: r,
    initialMessageName: e,
    initialCorrelationKey: t,
    onClose: n,
    elementId: i,
    isStartEvent: s,
    element: o
  }) => {
    const a = bn(qr), l = Ne.state.processInstance, [c, d] = ye(e), [u, f] = ye(t), [p, g] = ye(""), [m, A] = ye(""), {
      editedValue: w,
      isValid: v,
      prefillSource: y,
      isDirty: _,
      setEditedValue: S,
      resetPrefill: D
    } = IPe(o, gt.processId), M = An(null);
    return Pe(() => {
      v && M.current?.hideMarkers();
    }, [v]), /* @__PURE__ */ x.jsx(
      g2,
      {
        title: "Publish message",
        isVisible: r,
        isPrimaryButtonDisabled: !v,
        primaryButtonLabel: "Publish",
        secondaryButton: { label: "Cancel", onClick: n },
        ghostButton: {
          label: "Reset",
          onClick: () => {
            d(e), f(t ?? ""), g(""), A(""), D();
          }
        },
        onClose: n,
        onSubmit: async () => {
          n();
          const L = await a.publishMessage?.({
            messageName: c,
            correlationKey: u,
            variables: w,
            timeToLive: p,
            messageId: m,
            isStartEvent: s
          });
          L?.success ? (L?.success && l !== void 0 && ao(rr(l.key), {
            action: "publishMessage",
            elementId: i,
            messageName: c,
            messageCorrelationKey: u,
            variables: w,
            timeToLive: p,
            messageId: m
          }), Jn.trackUserCompletesElement(o, w), s ? a.displayNotification?.success({
            title: hv
          }) : a.displayNotification?.info({
            title: `Message "${c}" published`,
            subtitle: `Correlation key: ${u}`
          }), cv({
            processId: gt.processId,
            elementId: o.id,
            variables: w ?? ""
          })) : a.displayNotification?.error(zr);
        },
        modalBody: /* @__PURE__ */ x.jsx($4, { children: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
          /* @__PURE__ */ x.jsxs(In, { gap: 2, children: [
            /* @__PURE__ */ x.jsx(XXt, { children: "Variables" }),
            /* @__PURE__ */ x.jsx(
              _C,
              {
                isValid: v,
                editedValue: w,
                element: o,
                onSuccess: () => {
                  D();
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              xC,
              {
                originalSource: y,
                isDescriptionVisible: !_
              }
            ),
            /* @__PURE__ */ x.jsx(JXt, { children: /* @__PURE__ */ x.jsx(
              EC,
              {
                height: "10vh",
                value: w,
                isVisible: r,
                placeholder: LH,
                onChange: (L) => {
                  S(L ?? "");
                },
                onMount: (L) => {
                  M.current = L;
                },
                hasJSONObjectValidation: !0
              }
            ) })
          ] }),
          /* @__PURE__ */ x.jsxs(In, { orientation: "horizontal", children: [
            /* @__PURE__ */ x.jsx(
              ha,
              {
                id: "message_name",
                labelText: "Message name",
                placeholder: "new order",
                value: c,
                onChange: (L) => {
                  d(L.target.value);
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              ha,
              {
                id: "correlation_key",
                labelText: "Message correlation key",
                placeholder: "order-key-123",
                value: u,
                onChange: (L) => {
                  f(L.target.value);
                }
              }
            )
          ] }),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "message_id",
              labelText: "Message ID",
              placeholder: "tracking-id-123",
              value: m,
              onChange: (L) => {
                A(L.target.value);
              }
            }
          ),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "ttl",
              labelText: "Message time-to-live (TTL)",
              placeholder: "PT5M",
              value: p,
              onChange: (L) => {
                g(L.target.value);
              },
              helperText: "Time duration defined as ISO 8601 durations format"
            }
          )
        ] }) })
      }
    );
  }
);
OPe.displayName = "PublishMessageModal";
function of({
  prefix: r = "",
  prefillSource: e
}) {
  return e === "bpmn" ? `${r} with example data` : e === "cache" ? `${r} with cached data` : r;
}
const PT = rt(
  ({
    messageSubscription: r,
    isRestartMode: e = !1,
    element: t,
    isStartEvent: n = !1
  }) => {
    const i = bn(qr), s = Ne.state.processInstance, [o, a] = ye(!1), l = e ? PH : nXt, { prefillData: c, prefillSource: d } = qd({
      element: t,
      useCache: !0,
      processId: gt.processId
    });
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        Ih,
        {
          actions: [
            {
              elementId: t.id,
              label: of({
                prefix: e ? "Restart process" : "Publish message",
                prefillSource: d
              }),
              //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
              renderIcon: () => /* @__PURE__ */ x.jsx(l, { color: "white" }),
              onClick: async () => {
                const u = await i.publishMessage?.({
                  messageName: r.messageName,
                  correlationKey: r.keyCandidate,
                  variables: c,
                  isStartEvent: n
                });
                u?.success ? (u?.success && s !== void 0 && ao(
                  rr(s.key),
                  {
                    action: "publishMessage",
                    elementId: t.id,
                    messageName: r.messageName,
                    messageCorrelationKey: r.keyCandidate,
                    variables: c
                  }
                ), Jn.trackUserCompletesElement(
                  t,
                  c
                ), n ? i.displayNotification?.success({
                  title: hv
                }) : i.displayNotification?.info({
                  title: `Message "${r.messageName}" published`,
                  subtitle: `Correlation key: ${r.keyCandidate}`
                })) : i.displayNotification?.error(zr);
              }
            },
            {
              label: "Edit variables and publish message",
              onClick: () => {
                a(!0);
              }
            }
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        OPe,
        {
          isOpen: o,
          onClose: () => a(!1),
          initialMessageName: r.messageName,
          initialCorrelationKey: n ? "" : r.keyCandidate,
          elementId: t.id,
          isStartEvent: n,
          element: t
        }
      )
    ] });
  }
);
PT.displayName = "TriggerMessageSubscriptionButton";
const aJt = { top: -20, left: -30 }, yc = { top: -38, left: 0 }, lJt = { bottom: 14, left: -6 }, rM = lJt, cJt = yc, hJt = yc, pxe = yc, dJt = yc, uJt = yc, fJt = yc, pJt = yc, gJt = { ...aJt, top: -40 }, mJt = yc, AJt = yc, gxe = yc, wJt = yc, mxe = (r) => rf(r) || r === "", zH = rt(
  ({ title: r, isVisible: e, primaryButtonLabel: t, onClose: n, onSubmit: i, element: s }) => {
    const [o, a] = ye(!0), { prefillData: l, prefillSource: c } = qd({
      element: s,
      useCache: o,
      processId: gt.processId
    }), [d, u] = ye(l), [f, p] = ye(c), g = mxe(d), [m, A] = ye(!1);
    return Pe(() => {
      u(l), p(c);
    }, [c, l]), /* @__PURE__ */ x.jsx(
      yPe,
      {
        hasResetButton: !0,
        placeholder: LH,
        title: r,
        isVisible: e,
        onClose: n,
        onSubmit: i,
        clearOnReset: !1,
        onReset: () => {
          a(!1);
          const { prefillData: w, prefillSource: v } = qd({
            element: s,
            useCache: !1,
            processId: gt.processId
          });
          u(w), p(v), A(!1);
        },
        value: d,
        primaryButtonLabel: t,
        secondaryButtonLabel: "Cancel",
        isValidInput: (w) => mxe(w),
        onChange: (w) => {
          u(w), A(!0);
        },
        editorTopContent: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(
            _C,
            {
              isValid: g,
              editedValue: d,
              element: s,
              onSuccess: () => {
                p("bpmn"), A(!1);
              }
            }
          ),
          /* @__PURE__ */ x.jsx(
            xC,
            {
              originalSource: f,
              isDescriptionVisible: !m
            }
          )
        ] }),
        hasJSONObjectValidation: !0
      }
    );
  }
);
function vJt(r) {
  const [e, t] = ye(!1), { displayNotification: n, startInstance: i } = bn(qr), s = ds(
    async ({
      variables: o,
      processId: a,
      successNotificationSubtitle: l
    }) => {
      if (t(!0), !await i?.(o)) {
        n?.error(zr), t(!1);
        return;
      }
      Jn.trackUserCompletesElement(r, o), cv({
        processId: a,
        elementId: r.id,
        variables: o
      }), n?.success({
        title: hv,
        subtitle: l
      });
    },
    [i, n, r]
  );
  return {
    isStartingInstance: e,
    startInstance: s
  };
}
function bJt(r, e) {
  const t = an(r), n = t.get("extensionElements");
  if (!n)
    return [];
  const i = n.get("values");
  return !i || !i.length ? [] : i.filter((s) => He(s, e));
}
const yJt = ({
  element: r,
  linkedStartForm: e,
  definitions: t
}) => {
  const n = p2(
    r,
    "zeebe:FormDefinition"
  );
  if (n?.formId !== void 0)
    return e;
  const s = n?.formKey, o = t ? HQt(t) : void 0;
  if (!(!s || !o))
    return bJt(o, "zeebe:userTaskForm").find(
      (a) => s.includes(a.id)
    )?.$body;
}, CJt = q.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff1f1;
  border: 1px solid #da1e28;
  height: 3rem;
  padding: 1rem;
  width: 100%;
  gap: 1rem;
`, Axe = ({
  element: r,
  processId: e
}) => {
  const t = bC(r), n = $Be({
    processId: e,
    elementId: r.id
  }), i = JSON.parse(n || "{}"), s = JSON.parse(t || "{}");
  return { cachedVariables: i, variablesFromExampleData: s };
}, EJt = (r, e) => r.reduce(
  (t, n) => (n in e && (t[n] = e[n]), t),
  {}
);
function _Jt({
  element: r,
  getFormBody: e,
  formPrefillSettings: t = { sanitizePrefillData: !1 }
}) {
  const [n, i] = ye(!1), [s, o] = ye("none"), [a, l] = ye(""), [c, d] = ye(!1), [u, f] = ye(!1), p = An(null), g = An(), m = ds(
    (M, L) => {
      const { cachedVariables: T, variablesFromExampleData: B } = Axe({
        element: r,
        processId: gt.processId
      }), V = L === "bpmn" && ku(M, B), N = L === "cache" && ku(M, T);
      return V || N;
    },
    [r]
  );
  Pe(() => {
    a && f(
      !m(
        JSON.parse(a),
        s
      )
    );
  }, [a, s, m]);
  const A = ds(
    ({ data: M, errors: L }) => {
      d(Object.keys(L).length === 0), l(JSON.stringify(M));
    },
    []
  ), w = ds(async () => {
    let M = {};
    if (t.sanitizePrefillData) {
      const { variables: B, success: V } = await At.fetchVariablesByUserTask(
        t.userTaskJobId
      );
      if (!V) {
        console.error("Could not fetch user task variables"), i(!0);
        return;
      }
      M = B.reduce((N, { name: R, value: H }) => (N[R] = JSON.parse(H), N), {});
    }
    const { cachedVariables: L, variablesFromExampleData: T } = Axe(
      {
        element: r,
        processId: gt.processId
      }
    );
    return {
      variablesFromExampleData: T,
      cachedVariables: L,
      processVariables: M
    };
  }, [r, t]), v = ds(async () => {
    let M = {};
    const L = await e();
    if (L === void 0) {
      i(!0);
      return;
    }
    try {
      M = JSON.parse(L ?? "{}");
    } catch {
      i(!0);
      return;
    }
    return M;
  }, [e]), y = ds(
    async ({
      ignoreCachedVariables: M = !1,
      parsedForm: L
    } = {
      ignoreCachedVariables: !1,
      parsedForm: void 0
    }) => {
      const T = await w();
      if (!T)
        return;
      const { variablesFromExampleData: B, cachedVariables: V, processVariables: N } = T, R = {
        ...B,
        ...M ? {} : V,
        ...N
      }, H = t.sanitizePrefillData ? EJt(dM(L), R) : R;
      let z = "none";
      return ku(H, B) ? z = "bpmn" : !M && ku(H, V) && (z = "cache"), o(z), l(JSON.stringify(H)), H;
    },
    [w, t]
  ), _ = ds(
    async ({
      ignoreCachedVariables: M = !1
    } = { ignoreCachedVariables: !1 }) => {
      const L = await v();
      if (L === void 0)
        return;
      const T = await y({
        parsedForm: L,
        ignoreCachedVariables: M
      }), { warnings: B } = await g.current?.importSchema(
        L,
        T
      ) ?? { warnings: [] };
      d(B.length === 0);
    },
    [v, y]
  ), S = ds(async () => {
    const M = new nw();
    if (g.current = M, p.current === null) {
      i(!0);
      return;
    }
    await _(), M.attachTo(p.current), M.on("changed", A);
  }, [A, _]), D = ds(async () => {
    _({ ignoreCachedVariables: !0 });
  }, [_]);
  return {
    renderForm: S,
    resetForm: D,
    isDirty: u,
    isFormContentValid: c,
    originalPrefillSource: s,
    setOriginalPrefillSource: o,
    formVariables: a,
    hasFormLoadError: n,
    setHasFormLoadError: i,
    formContainerRef: p,
    taskForm: g
  };
}
const RPe = ({
  isVisible: r,
  element: e,
  onClose: t,
  onSubmit: n,
  getFormBody: i,
  primaryButtonLabel: s,
  title: o,
  dataTestId: a,
  formPrefillSettings: l
}) => {
  const {
    renderForm: c,
    resetForm: d,
    isDirty: u,
    isFormContentValid: f,
    originalPrefillSource: p,
    setOriginalPrefillSource: g,
    formVariables: m,
    hasFormLoadError: A,
    setHasFormLoadError: w,
    formContainerRef: v,
    taskForm: y
  } = _Jt({
    element: e,
    formPrefillSettings: l,
    getFormBody: i
  });
  Pe(() => {
    if (!r && y.current) {
      y.current.detach(), y.current = void 0;
      return;
    }
    !r || !v.current || y.current || c();
  }, [c, r, v, y]);
  async function _() {
    const { data: S, errors: D } = y.current?.submit() ?? { data: {}, errors: {} };
    Object.keys(D).length === 0 && n(S);
  }
  return /* @__PURE__ */ x.jsx(
    g2,
    {
      title: o,
      size: "sm",
      isVisible: r,
      dataTestId: a,
      primaryButtonLabel: s,
      secondaryButton: {
        label: "Close",
        onClick: t
      },
      onClose: t,
      onSubmit: _,
      ghostButton: {
        label: "Reset",
        onClick: d
      },
      modalBody: /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
          /* @__PURE__ */ x.jsx(
            _C,
            {
              isValid: f,
              editedValue: m,
              element: e,
              onSuccess: () => {
                g("bpmn");
              },
              tooltipTextForInvalid: "Please enter valid data to save"
            }
          ),
          /* @__PURE__ */ x.jsx(
            xC,
            {
              originalSource: p,
              isDescriptionVisible: !u
            }
          )
        ] }),
        A && /* @__PURE__ */ x.jsxs(CJt, { children: [
          "We were unable to load the form",
          /* @__PURE__ */ x.jsx(
            Rn,
            {
              kind: "tertiary",
              size: "sm",
              renderIcon: uw,
              onClick: () => {
                w(!1), c();
              },
              children: "Retry"
            }
          )
        ] }),
        /* @__PURE__ */ x.jsx("div", { ref: v })
      ] })
    }
  );
}, VPe = rt(
  ({ element: r, isRestartMode: e }) => {
    const [t, n] = ye(!1), [i, s] = ye(!1), { isStartingInstance: o, startInstance: a } = vJt(r), l = yJt({
      element: r,
      linkedStartForm: Nt.state.linkedStartForm,
      definitions: Nt.state.definitions
    }), c = l !== void 0, d = e ? PH : c ? xPe : iXt, { prefillData: u, prefillSource: f } = qd({
      element: r,
      useCache: !0,
      processId: gt.processId
    }), p = of({
      prefix: "Start instance",
      prefillSource: f
    }), g = c ? "Restart process" : of({ prefix: "Restart process", prefillSource: f }), m = [
      {
        label: e ? g : c ? "Open Start Form" : p,
        //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
        renderIcon: () => /* @__PURE__ */ x.jsx(d, { color: "white" }),
        onClick: async () => {
          c ? n(!0) : a({
            processId: gt.processId,
            variables: u || "{}",
            successNotificationSubtitle: of({ prefillSource: f }) || void 0
          });
        }
      },
      {
        label: "Edit variables and start instance",
        onClick: () => {
          s(!0);
        }
      }
    ];
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(Ih, { disabled: o, actions: m }),
      /* @__PURE__ */ x.jsx(
        zH,
        {
          title: "Start instance with variables",
          isVisible: i,
          primaryButtonLabel: "Create new instance",
          onClose: () => s(!1),
          onSubmit: async (A) => {
            s(!1), a({
              processId: gt.processId,
              variables: A ?? ""
            });
          },
          element: r
        }
      ),
      /* @__PURE__ */ x.jsx(
        RPe,
        {
          title: "Start Form",
          isVisible: t,
          primaryButtonLabel: "Start Instance",
          dataTestId: "start-form-dialog",
          onClose: () => {
            n(!1);
          },
          onSubmit: async (A) => {
            n(!1), a({
              processId: gt.processId,
              variables: JSON.stringify(A)
            });
          },
          element: r,
          getFormBody: () => Promise.resolve(l)
        }
      )
    ] });
  }
);
VPe.displayName = "StartInstanceButton";
function xJt(r) {
  return p2(r, "zeebe:CalledElement")?.get("processId") ?? null;
}
const HPe = rt(({ element: r, isActive: e }) => {
  const { processedFiles: t } = gt.state, n = xJt(r), i = IT.state.childInstances.find(
    (s) => s.bpmnProcessId === n
  );
  return i === void 0 ? null : /* @__PURE__ */ x.jsx(
    Ih,
    {
      actions: [
        {
          kind: e ? "primary" : "secondary",
          label: "View called process",
          renderIcon: () => /* @__PURE__ */ x.jsx(S7, { color: "white" }),
          onClick: () => {
            const s = t?.find(
              (d) => d.id === n
            );
            if (s === void 0)
              return;
            const { fileId: o, filename: a } = s, l = window.location.pathname.split("/").slice(0, -1).join("/"), c = `${window.location.origin}${l}/${_Pe(o, a)}`;
            if (localStorage.setItem(
              "play-directAccess",
              JSON.stringify({
                processedFiles: t,
                instance: i.key
              })
            ), i.state !== "COMPLETED") {
              const d = JSON.parse(
                localStorage.getItem("play-calledProcesses") || "[]"
              );
              d.push(i.key), localStorage.setItem(
                "play-calledProcesses",
                JSON.stringify(d)
              );
            }
            window.open(c, "_blank").focus();
          }
        }
      ]
    }
  );
});
HPe.displayName = "ChildInstanceButton";
const wxe = q(In)`
  /* background-inverse */
  background-color: #393939;
  /* text-on-color */
  color: #fff;
  padding: 4px 8px 4px 4px;
  border-radius: 24px;
  align-items: center;
`, vxe = q(_7)`
  /* support-success */
  fill: #24a148;
`, SJt = q(Yxe)`
  justify-content: flex-end;
`, MJt = q.div`
  /* Body styles/body-01 */
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.16px;

  font-weight: 700;
`, DJt = q.div`
  /* Body styles/body-01 */
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.16px;
`, BPe = rt(() => {
  const { isCalledProcess: r, processInstance: e } = Ne.state, t = e?.key;
  return Pe(() => {
    if (r) {
      const n = JSON.parse(
        localStorage.getItem("play-calledProcesses") || "[]"
      );
      localStorage.setItem(
        "play-calledProcesses",
        JSON.stringify(
          n.filter((i) => i !== t)
        )
      );
    }
  }, [r, t]), r ? /* @__PURE__ */ x.jsxs(Xxe, { defaultOpen: r, align: "left", children: [
    /* @__PURE__ */ x.jsxs(wxe, { orientation: "horizontal", gap: 2, children: [
      /* @__PURE__ */ x.jsx(vxe, {}),
      /* @__PURE__ */ x.jsx("div", { children: "Completed" })
    ] }),
    /* @__PURE__ */ x.jsxs(Jxe, { children: [
      /* @__PURE__ */ x.jsx(MJt, { children: "Called process completed" }),
      /* @__PURE__ */ x.jsx(DJt, { children: "You may close this browser tab and return to the previous process instance" }),
      /* @__PURE__ */ x.jsx(SJt, { children: /* @__PURE__ */ x.jsx(
        Rn,
        {
          size: "sm",
          onClick: () => {
            window.close();
          },
          children: "Close tab"
        }
      ) })
    ] })
  ] }) : /* @__PURE__ */ x.jsxs(wxe, { orientation: "horizontal", gap: 2, children: [
    /* @__PURE__ */ x.jsx(vxe, {}),
    /* @__PURE__ */ x.jsx("div", { children: "Completed" })
  ] });
});
BPe.displayName = "CompletedOverlay";
const PPe = rt(({ element: r, incident: e }) => {
  const t = bn(qr), [n, i] = ye(!1), { processInstance: s } = Ne.state, o = t.featureFlags.areAIFeaturesEnabled, a = o, l = a || t.isUserOrgOwnerOrAdmin, c = gt.authType !== "sm" ? {
    label: a ? "Copy and ask AI" : "Enable incident copilot",
    id: o ? "camunda-ai-button" : void 0,
    icon: /* @__PURE__ */ x.jsx(fXt, {}),
    disabled: !l,
    title: l ? void 0 : "Contact your admin to enable this feature",
    onClick: () => {
      o ? (navigator.clipboard.writeText(
        `I got this incident. What does it mean, what is the root cause, and how do I fix it in Play? 
Error type: ${e.type} 
Error message: ${e.message}`
      ), t.displayNotification?.info({
        title: "AI prompt copied. Paste in the text area to continue."
      }), i(!1)) : window.open(`${t.organizationManagementPageUrl}/settings`), Jn.trackIncidentAIModalOpened({
        areAIFeaturesEnabled: o
      });
    }
  } : void 0;
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(
      Ih,
      {
        actions: [
          {
            elementId: r.id,
            label: "View Incident",
            kind: "danger",
            renderIcon: () => /* @__PURE__ */ x.jsx(gI, {}),
            onClick: () => {
              i(!0);
            }
          }
        ]
      }
    ),
    /* @__PURE__ */ x.jsx(
      g2,
      {
        title: "View incident",
        isVisible: n,
        primaryButtonLabel: "Retry incident",
        secondaryButton: c,
        ghostButton: {
          label: "Cancel",
          onClick: () => i(!1)
        },
        onClose: () => i(!1),
        onSubmit: async () => {
          if (i(!1), e.jobKey && !await Z4.updateRetries({
            jobKey: e.jobKey
          })) {
            t.displayNotification?.error(zr);
            return;
          }
          Jn.trackResolveIncident(gt.processId), (await Z4.resolveIncident(e.key))?.success === !1 ? t.displayNotification?.error(zr) : s !== void 0 && ao(rr(s.key), {
            action: "resolveIncident",
            elementId: r.id,
            hasJob: !!e.jobKey
          });
        },
        modalBody: /* @__PURE__ */ x.jsx(s7, { copyButtonDescription: "Copy", type: "multi", wrapText: !0, children: e.message })
      }
    )
  ] });
});
PPe.displayName = "IncidentButton";
const FPe = rt(({ element: r }) => {
  const { completedElementInstances: e } = yr, { isInstanceDetailPageVisible: t } = Ne, n = eo.state.activeTab === "scenarios", {
    state: { sequenceFlows: i }
  } = Vg, s = ui.state.selectedScenario?.coveredSequenceFlows ?? ui.allCoveredSequenceFlows;
  return Pe(() => {
    if (t)
      return i.includes(r.id) || r?.di?.bpmnElement?.sourceRef?.$type === "bpmn:EventBasedGateway" && e.some(
        (o) => o.flowNodeId === r.di.bpmnElement.targetRef.id
      ) ? Nt.state.viewer?.addMarker(
        r.id,
        "play-sequence-flow-taken"
      ) : Nt.state.viewer?.removeMarker(
        r.id,
        "play-sequence-flow-taken"
      ), () => {
        Nt.state.viewer?.removeMarker(
          r.id,
          "play-sequence-flow-taken"
        );
      };
  }, [
    i,
    r,
    e,
    t
  ]), Pe(() => {
    if (!t && s.length > 0 && n)
      return s.includes(r.id) ? Nt.state.viewer?.addMarker(
        r.id,
        "play-sequence-flow-taken"
      ) : Nt.state.viewer?.removeMarker(
        r.id,
        "play-sequence-flow-taken"
      ), () => {
        Nt.state.viewer?.removeMarker(
          r.id,
          "play-sequence-flow-taken"
        );
      };
  }, [
    r,
    t,
    n,
    s
  ]), null;
});
FPe.displayName = "SequenceFlowHighlighter";
const zPe = ({
  elementId: r,
  errorCode: e
}) => {
  let t = `${r ? `"${r}"` : "Error event"} manually triggered`;
  return e && (t = `${t} with error code "${e}"`), t;
};
function LJt(r) {
  const e = r.businessObject.$type;
  return e === "bpmn:IntermediateThrowEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message throw event" : e === "bpmn:EndEvent" && r.businessObject.eventDefinitions[0]?.$type === "bpmn:MessageEventDefinition" ? "message end event" : e.split(":")[1].split(/(?=[A-Z])/).map((i) => i.toLowerCase()).join(" ");
}
function FT(r, e, t) {
  const n = LJt(r), i = {
    title: `"${r.businessObject.name || r.businessObject.id}" ${n} completed manually`,
    subtitle: t
  };
  e?.success(i);
}
const WPe = rt(({ element: r }) => {
  const { displayNotification: e } = bn(qr), [t, n] = ye(!1), [i, s] = ye(!1), [o, a] = ye(""), [l, c] = ye(!1), { instanceKey: d, processInstance: u } = Ne.state, f = NH(r), g = na.state.statistics.some(
    ({ activityId: M, active: L }) => M === r.id && L > 0
  ) && tPe.includes(r.businessObject.$type) && f !== void 0, m = $b.state.userTasks?.find(
    (M) => M.taskDefinitionId === r.id && M.taskState === "CREATED"
  ), A = g || m !== void 0;
  Pe(() => {
    c(!1);
  }, [A]);
  const w = Nt.getAvailableErrorEvents(r), v = ds(async () => {
    s(!1), c(!0);
    const M = await Up.throwError({
      taskDefinitionType: f,
      processInstanceKey: d,
      errorCode: o,
      elementId: r.id
    });
    if (M && d !== void 0) {
      ao(rr(d), {
        action: "throwJob",
        elementId: r.id,
        errorCode: o,
        taskDefinitionType: f
      });
      const L = w.find(
        (T) => T.errorCode === o
      )?.errorElementId;
      e?.success(
        {
          title: zPe({
            elementId: L,
            errorCode: o
          })
        },
        {
          action: {
            label: "Learn more",
            onClick: () => {
              window.open(
                "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
                "_blank"
              );
            }
          }
        }
      );
    }
    M || (e?.error(zr), c(!1));
  }, [
    w,
    e,
    r.id,
    f,
    o,
    d
  ]);
  if (!d || !A)
    return null;
  const { prefillData: y, prefillSource: _ } = qd({
    element: r,
    useCache: !0,
    processId: gt.processId
  }), D = [
    {
      label: of({
        prefix: "Complete job",
        prefillSource: _
      }),
      elementId: r.id,
      renderIcon: () => /* @__PURE__ */ x.jsx(Qg, { color: "white" }),
      onClick: async () => {
        c(!0);
        let M = !1;
        if (r.type === "bpmn:UserTask") {
          const { success: L } = await At.completeUserTask({
            taskId: m?.id,
            variables: y,
            isZeebeUserTask: m?.implementation === "ZEEBE_USER_TASK"
          });
          M = L;
        } else
          M = await Up.completeJob({
            taskDefinitionType: f,
            processInstanceKey: u?.key,
            variables: y,
            elementId: r.id
          });
        if (M && u !== void 0 && (ao(rr(u.key), {
          action: "completeJob",
          type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
          elementId: r.id,
          variables: y || void 0,
          taskDefinitionType: f
        }), Jn.trackUserCompletesElement(r, y)), !M)
          e?.error(zr), c(!1);
        else {
          const L = of({ prefillSource: _ }) || void 0;
          FT(r, e, L);
        }
      }
    },
    {
      elementId: r.id,
      label: "Edit variables and complete job",
      onClick: () => {
        n(!0);
      }
    }
  ];
  return g && w.length > 0 && D.push(
    {
      //@ts-expect-error Object literal may only specify known properties, and 'type' does not exist in type '{ label: string; renderIcon: () => Element; onClick: () => Promise<void>; } | { label: string; onClick: () => void; renderIcon?: undefined; }'.ts(2353)
      type: "divider",
      label: "divider"
    },
    {
      label: "Throw Error",
      onClick: () => {
        a(""), s(!0);
      }
    }
  ), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(Ih, { disabled: l, actions: D }),
    /* @__PURE__ */ x.jsx(
      zH,
      {
        title: "Complete job with variables",
        isVisible: t,
        primaryButtonLabel: "Complete job",
        onClose: () => n(!1),
        element: r,
        onSubmit: async (M) => {
          n(!1), c(!0);
          let L = !1;
          if (r.type === "bpmn:UserTask") {
            const { success: T } = await At.completeUserTask({
              taskId: m?.id,
              variables: M ?? "{}",
              isZeebeUserTask: m?.implementation === "ZEEBE_USER_TASK"
            });
            L = T;
          } else
            L = await Up.completeJob({
              taskDefinitionType: f,
              processInstanceKey: u?.key,
              variables: M,
              elementId: r.id
            });
          L && u !== void 0 && (ao(rr(u.key), {
            action: "completeJob",
            type: r.type === "bpmn:UserTask" ? "userTask" : "serviceTask",
            elementId: r.id,
            variables: M ?? void 0,
            taskDefinitionType: f
          }), Jn.trackUserCompletesElement(
            r,
            M
          ), cv({
            processId: gt.processId,
            elementId: r.id,
            variables: M ?? ""
          })), L ? FT(r, e) : (e?.error(zr), c(!1));
        }
      }
    ),
    /* @__PURE__ */ x.jsx(
      g2,
      {
        isVisible: i,
        title: "Throw error",
        primaryButtonLabel: "Throw error",
        isPrimaryButtonDisabled: o === "",
        secondaryButton: {
          label: "Close",
          onClick: () => s(!1)
        },
        onClose: () => s(!1),
        enableContentOverflow: !0,
        onSubmit: v,
        modalBody: /* @__PURE__ */ x.jsx(
          tw,
          {
            titleText: "Error",
            id: "error",
            "aria-label": "Select an Error",
            items: w.map(
              ({ errorCode: M, errorName: L, errorElementId: T }) => ({
                id: M,
                label: L ?? T
              })
            ),
            onChange: ({ selectedItem: M }) => {
              if (M === null) {
                a("");
                return;
              }
              a(M?.id);
            }
          }
        )
      }
    )
  ] });
});
WPe.displayName = "JobCompleteButton";
const kJt = q(sXt)`
  fill: currentColor;
`, NJt = (r) => ru(async () => {
  const { success: e, processInstance: t } = await At.fetchInstanceDetails(r);
  return e ? t.key : null;
}), TJt = ({
  instanceKey: r,
  elementId: e
}) => ru(async () => {
  const { flowNodeInstances: t } = await At.fetchFlowNodeInstances(r);
  return t?.find(
    ({ flowNodeId: i }) => i === e
  ) !== void 0 ? !0 : null;
}), bxe = { isRewinding: !1 };
class IJt extends APe {
  state = { ...bxe };
  constructor() {
    super(), xs(this, {
      state: $n,
      startRewinding: Et,
      endRewinding: Et,
      reset: Et
    });
  }
  startRewinding = () => {
    this.state.isRewinding = !0;
  };
  endRewinding = () => {
    this.state.isRewinding = !1;
  };
  reset = () => {
    this.state = { ...bxe };
  };
}
const u0 = new IJt(), jPe = rt(({ element: r }) => {
  const e = bn(qr), { instanceKey: t, processInstance: n } = Ne.state, i = n?.state === "ACTIVE";
  return /* @__PURE__ */ x.jsx(
    Ih,
    {
      actions: [
        {
          elementId: r.id,
          label: "Rewind",
          kind: "tertiary",
          renderIcon: () => /* @__PURE__ */ x.jsx(kJt, {}),
          onClick: async () => {
            if (n === void 0)
              return;
            u0.startRewinding();
            const s = U4(
              rr(n.key)
            ), o = s.find(
              ({ action: c }) => c === "startInstance"
            );
            if (o === void 0) {
              u0.endRewinding(), e.displayNotification?.error({
                title: "Rewind failed",
                subtitle: "Please try again"
              });
              return;
            }
            const a = await u0.createNewInstance({
              startActionType: o.type,
              variables: o.variables,
              bpmnProcessId: n.bpmnProcessId
            });
            if (a === void 0) {
              u0.endRewinding(), e.displayNotification?.error({
                title: "Rewind failed",
                subtitle: "Please try again"
              });
              return;
            }
            await NJt(a), Jn.trackRewindedInstanceStart(), Ne.reset(), Ne.setInstanceDetails({
              instanceKey: a,
              instanceType: "REWOUND_INSTANCE"
            }), await u0.repeatUserActions({
              newInstanceKey: a,
              actions: s,
              untilElementId: r.id
            });
            const l = await TJt({
              instanceKey: a,
              elementId: r.id
            });
            i && At.terminateProcessInstance(t), l ? e.displayNotification?.success({
              title: "Rewind successful"
            }) : e.displayNotification?.warning(
              {
                title: "Rewind partially successful",
                content: "Some BPMN elements cannot be rewound"
              },
              {
                action: {
                  label: "Read docs",
                  onClick: () => {
                    window.open(
                      "https://docs.camunda.io/docs/components/modeler/web-modeler/play-your-process/#rewind-a-process",
                      "_blank"
                    );
                  }
                }
              }
            ), u0.endRewinding();
          }
        }
      ]
    }
  );
});
jPe.displayName = "RewindButton";
const OJt = q(K4)`
  margin-bottom: var(--cds-spacing-03, 8px);
`;
q(Hf)`
  margin-top: var(--cds-spacing-06, 16px);
  max-width: unset;
`;
const RJt = q.div`
  min-width: 0; // https://github.com/microsoft/monaco-editor/issues/3393
`, ZPe = rt(
  ({ isOpen: r, initialSignalName: e, onClose: t, isStartEvent: n, element: i }) => {
    const s = bn(qr), o = Ne.state.processInstance, [a, l] = ye(e), {
      editedValue: c,
      isValid: d,
      prefillSource: u,
      isDirty: f,
      setEditedValue: p,
      resetPrefill: g
    } = IPe(i, gt.processId), m = An(null);
    return Pe(() => {
      d && m.current?.hideMarkers();
    }, [d]), /* @__PURE__ */ x.jsx(
      g2,
      {
        title: "Broadcast signal",
        isVisible: r,
        isPrimaryButtonDisabled: !d,
        primaryButtonLabel: "Broadcast",
        secondaryButton: { label: "Cancel", onClick: t },
        ghostButton: {
          label: "Reset",
          onClick: () => {
            l(e), g();
          }
        },
        onClose: t,
        onSubmit: async () => {
          t();
          const A = await s.broadcastSignal?.({
            signalName: a,
            variables: c,
            isStartEvent: n
          });
          A?.success ? (A?.success && o !== void 0 && ao(rr(o.key), {
            action: "broadcastSignal",
            signalName: a,
            variables: c,
            elementId: i.id
          }), Jn.trackUserCompletesElement(i, c), n ? s.displayNotification?.success({
            title: hv
          }) : s.displayNotification?.info({
            title: `Signal "${a}" broadcasted`
          }), cv({
            processId: gt.processId,
            elementId: i.id,
            variables: c ?? ""
          })) : s.displayNotification?.error(zr);
        },
        modalBody: /* @__PURE__ */ x.jsx($4, { children: /* @__PURE__ */ x.jsxs(In, { gap: 5, children: [
          /* @__PURE__ */ x.jsxs(In, { gap: 2, children: [
            /* @__PURE__ */ x.jsx(OJt, { children: "Variables" }),
            /* @__PURE__ */ x.jsx(
              _C,
              {
                isValid: d,
                editedValue: c,
                element: i,
                onSuccess: () => {
                  g();
                }
              }
            ),
            /* @__PURE__ */ x.jsx(
              xC,
              {
                originalSource: u,
                isDescriptionVisible: !f
              }
            ),
            /* @__PURE__ */ x.jsx(RJt, { children: /* @__PURE__ */ x.jsx(
              EC,
              {
                height: "10vh",
                value: c,
                isVisible: r,
                placeholder: LH,
                onChange: (A) => {
                  p(A ?? "");
                },
                onMount: (A) => {
                  m.current = A;
                },
                hasJSONObjectValidation: !0
              }
            ) })
          ] }),
          /* @__PURE__ */ x.jsx(
            ha,
            {
              id: "signal_name",
              labelText: "Signal name",
              placeholder: "signal name",
              value: a,
              onChange: (A) => {
                l(A.target.value);
              }
            }
          )
        ] }) })
      }
    );
  }
);
ZPe.displayName = "BroadcastSignalModal";
const zT = rt(
  ({ signalCandidate: r, isRestartMode: e = !1, element: t, isStartEvent: n = !1 }) => {
    const i = bn(qr), s = Ne.state.processInstance, [o, a] = ye(!1), l = e ? PH : pXt, { prefillData: c, prefillSource: d } = qd({
      element: t,
      useCache: !0,
      processId: gt.processId
    });
    return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        Ih,
        {
          actions: [
            {
              elementId: t.id,
              label: of({
                prefix: e ? "Restart process" : "Broadcast signal",
                prefillSource: d
              }),
              //@ts-expect-error Property 'color' does not exist on type 'IntrinsicAttributes'.ts(2322)
              renderIcon: () => /* @__PURE__ */ x.jsx(l, { color: "white" }),
              onClick: async () => {
                const u = await i.broadcastSignal?.({
                  signalName: r.signalName,
                  variables: c,
                  isStartEvent: n
                });
                u?.success ? (u?.success && s !== void 0 && ao(
                  rr(s.key),
                  {
                    action: "broadcastSignal",
                    elementId: t.id,
                    signalName: r.signalName,
                    variables: c
                  }
                ), Jn.trackUserCompletesElement(
                  t,
                  c
                ), n ? i.displayNotification?.success({
                  title: hv
                }) : i.displayNotification?.info({
                  title: `Signal "${r.signalName}" broadcasted`
                })) : i.displayNotification?.error(zr);
              }
            },
            {
              label: "Edit variables and broadcast signal",
              onClick: () => {
                a(!0);
              }
            }
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        ZPe,
        {
          isOpen: o,
          onClose: () => a(!1),
          initialSignalName: r.signalName,
          elementId: t.id,
          isStartEvent: n,
          element: t
        }
      )
    ] });
  }
);
zT.displayName = "BroadcastSignalButton";
const UPe = rt(({ decisionId: r }) => {
  const e = RT.state.decisionInstances.find(
    (i) => i.decisionId === r
  ), { sanitizedOperateBaseUrl: t, hasLinkToOperate: n } = gt;
  return !n || e === void 0 ? null : /* @__PURE__ */ x.jsx(
    Ih,
    {
      actions: [
        {
          kind: "tertiary",
          label: "View decision instance in Operate",
          renderIcon: () => /* @__PURE__ */ x.jsx(M7, {}),
          onClick: () => {
            const i = `${t}/decisions/${e.id}`;
            window.open(i, "_blank"), Jn.openOperate(i);
          }
        }
      ]
    }
  );
});
UPe.displayName = "ViewDecisionInstanceButton";
const VJt = (r) => p2(r, "zeebe:CalledDecision")?.get("decisionId") ?? null, HJt = rt(({ element: r }) => {
  const [e, t] = ye(!1), [n, i] = ye(""), s = Ne.state.processInstance?.key, o = bn(qr), a = Up.errorThrowableJobsByErrorId[r.id];
  if (a === void 0)
    return null;
  const l = async (d) => {
    const { elementId: u, errorCode: f, taskDefinitionType: p } = d;
    if (t(!1), !await Up.throwError({
      taskDefinitionType: p,
      processInstanceKey: s,
      elementId: u,
      errorCode: f
    })) {
      o.displayNotification?.error(zr);
      return;
    }
    s !== void 0 && ao(rr(s), {
      action: "throwJob",
      taskDefinitionType: p,
      elementId: u,
      errorCode: f
    }), o.displayNotification?.success(
      {
        title: zPe({ elementId: r.id, errorCode: f })
      },
      {
        action: {
          label: "Learn more",
          onClick: () => {
            window.open(
              "https://docs.camunda.io/docs/components/modeler/bpmn/error-events/",
              "_blank"
            );
          }
        }
      }
    );
  }, c = [
    {
      label: "Throw Error",
      elementId: r.id,
      renderIcon: () => /* @__PURE__ */ x.jsx(Qg, {}),
      onClick: async () => {
        if (a.length === 1) {
          const d = a[0];
          l(d);
        } else
          t(!0);
      }
    }
  ];
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(Ih, { actions: c }),
    /* @__PURE__ */ x.jsx(
      g2,
      {
        isVisible: e,
        title: "Throw error",
        primaryButtonLabel: "Throw error",
        isPrimaryButtonDisabled: n === "",
        secondaryButton: {
          label: "Close",
          onClick: () => t(!1)
        },
        onClose: () => t(!1),
        enableContentOverflow: !0,
        onSubmit: async () => {
          const d = a.find(
            ({ elementId: u }) => u === n
          );
          d !== void 0 && l(d);
        },
        modalBody: /* @__PURE__ */ x.jsx(
          tw,
          {
            id: "job",
            "aria-label": "Select a Job",
            titleText: "Select a job to throw this error",
            items: a.map(
              ({ elementId: d, elementName: u }) => ({
                id: d,
                label: u
              })
            ),
            onChange: ({ selectedItem: d }) => {
              i(d?.id ?? "");
            }
          }
        )
      }
    )
  ] });
});
function BJt(r, e) {
  const [t, n] = ye(!1), { displayNotification: i } = bn(qr), s = ds(
    async ({
      variables: o,
      processInstanceKey: a,
      processId: l
    }) => {
      n(!0);
      const { success: c } = await At.completeUserTask({
        taskId: r?.id,
        variables: o,
        isZeebeUserTask: r?.implementation === "ZEEBE_USER_TASK"
      });
      if (!c) {
        i?.error(zr), n(!1);
        return;
      }
      FT(e, i), ao(rr(a), {
        action: "completeJob",
        type: "userTask",
        elementId: e.id,
        variables: o
      }), Jn.trackUserCompletesElement(e, o), cv({ processId: l, elementId: e.id, variables: o });
    },
    [r, i, e]
  );
  return {
    isCompletingUserTask: t,
    completeUserTask: s
  };
}
const PJt = "camunda-forms:bpmn:", FJt = async ({
  userTaskJob: r
}) => {
  const { success: e, schema: t } = await At.fetchUserTaskForm(
    r.formKey.replace(PJt, ""),
    r.processDefinitionKey
  );
  if (!(!e || !t))
    return t;
}, qPe = ({
  element: r,
  userTaskJob: e,
  processInstanceKey: t
}) => {
  const [n, i] = ye(!1), [s, o] = ye(!1), { isCompletingUserTask: a, completeUserTask: l } = BJt(
    e,
    r
  ), c = [
    {
      label: "Open Task Form",
      elementId: r.id,
      renderIcon: () => /* @__PURE__ */ x.jsx(xPe, {}),
      onClick: async () => {
        i(!0);
      }
    },
    {
      elementId: r.id,
      label: "Edit variables and complete job",
      onClick: () => {
        o(!0);
      }
    }
  ];
  return /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
    /* @__PURE__ */ x.jsx(Ih, { disabled: a, actions: c }),
    /* @__PURE__ */ x.jsx(
      zH,
      {
        title: "Complete job with variables",
        isVisible: s,
        primaryButtonLabel: "Complete job",
        onClose: () => o(!1),
        onSubmit: async (d) => {
          o(!1), l({
            processId: gt.processId,
            processInstanceKey: t,
            variables: d ?? "{}"
          });
        },
        element: r
      }
    ),
    /* @__PURE__ */ x.jsx(
      RPe,
      {
        title: "Task Form",
        isVisible: n,
        primaryButtonLabel: "Complete",
        dataTestId: "user-task-form-modal",
        onClose: () => {
          i(!1);
        },
        onSubmit: async (d) => {
          i(!1), l({
            processId: gt.processId,
            processInstanceKey: t,
            variables: JSON.stringify(d)
          });
        },
        element: r,
        getFormBody: () => FJt({ userTaskJob: e }),
        formPrefillSettings: {
          sanitizePrefillData: !0,
          userTaskJobId: e.id
        }
      }
    )
  ] });
};
qPe.displayName = "OpenTaskFormButton";
const GPe = rt(({ element: r, addOverlay: e }) => {
  const { instanceKey: t, processInstance: n } = Ne.state, i = Z4.incidents?.find(
    (y) => y.elementInstance?.element?.elementId === r.id && ["ACTIVE", "MIGRATED"].includes(y.state)
  );
  if (i) {
    const y = e(r, "INCIDENT_BUTTON", cJt);
    return un(
      /* @__PURE__ */ x.jsx(PPe, { element: r, incident: i }),
      y
    );
  }
  if (r.type === "bpmn:StartEvent" && ["bpmn:Process", "bpmn:Participant"].includes(r.parent?.type) && (!r.businessObject.eventDefinitions || r.businessObject.eventDefinitions.length === 0)) {
    const y = e(
      r,
      "START_INSTANCE_BUTTON",
      hJt
    );
    return un(
      /* @__PURE__ */ x.jsx(
        VPe,
        {
          element: r,
          isRestartMode: t !== void 0
        }
      ),
      y
    );
  }
  if (r.type === "bpmn:EndEvent" && Ne.state.processInstance?.state === "COMPLETED" && ["bpmn:Process", "bpmn:Participant"].includes(r.parent?.type) && na.completedElementIds.includes(r.id)) {
    const y = e(r, "FINISHED_OVERLAY", gJt);
    return un(/* @__PURE__ */ x.jsx(BPe, {}), y);
  }
  if (XGt.includes(r.type) && na.isElementProcessed(r.id) && !na.activeElementIds.includes(r.id)) {
    const y = e(r, "REWIND_OVERLAY", mJt);
    return un(/* @__PURE__ */ x.jsx(jPe, { element: r }), y);
  }
  const o = HT.activeMessageSubscriptionCandidates.find(
    (y) => y.elementId === r.id
  );
  if (o) {
    const y = e(
      r,
      "TRIGGER_MESSAGE_SUBSCRIPTION_BUTTON",
      pxe
    );
    return un(
      /* @__PURE__ */ x.jsx(
        PT,
        {
          element: r,
          messageSubscription: o
        }
      ),
      y
    );
  }
  const l = HT.startMessageSubscriptionCandidates?.find(
    (y) => y.elementId === r.id
  );
  if (l) {
    const y = e(
      r,
      "TRIGGER_MESSAGE_SUBSCRIPTION_BUTTON",
      pxe
    );
    return un(
      /* @__PURE__ */ x.jsx(
        PT,
        {
          element: r,
          messageSubscription: {
            ...l
          },
          isRestartMode: t !== void 0,
          isStartEvent: !0
        }
      ),
      y
    );
  }
  if (r.type === "bpmn:SequenceFlow") {
    const y = e(
      r,
      "SEQUENCE_FLOW_HIGHLIGHTER",
      dJt
    );
    return un(/* @__PURE__ */ x.jsx(FPe, { element: r }), y);
  }
  const {
    state: { connectorElements: c }
  } = Gd;
  if (t && c?.find((y) => y.id === r.id))
    return null;
  if (r.type === "bpmn:CallActivity" && na.isElementProcessed(r.id)) {
    const y = e(
      r,
      "CHILD_INSTANCE_BUTTON",
      uJt
    );
    return un(
      /* @__PURE__ */ x.jsx(
        HPe,
        {
          element: r,
          isActive: na.activeElementIds.includes(r.id)
        }
      ),
      y
    );
  }
  const f = VJt(r);
  if (r.type === "bpmn:BusinessRuleTask" && na.isElementProcessed(r.id) && f !== null) {
    const y = e(
      r,
      "VIEW_DECISION_INSTANCE_BUTTON",
      AJt
    );
    return un(
      /* @__PURE__ */ x.jsx(UPe, { decisionId: f }),
      y
    );
  }
  const g = BT.activeSignalCandidates.find(
    (y) => y.elementId === r.id
  );
  if (g) {
    const y = e(
      r,
      "BROADCAST_SIGNAL_BUTTON",
      gxe
    );
    return un(
      /* @__PURE__ */ x.jsx(zT, { element: r, signalCandidate: g }),
      y
    );
  }
  const A = BT.startSignalCandidates?.find(
    (y) => y.elementId === r.id
  );
  if (A) {
    const y = e(
      r,
      "BROADCAST_SIGNAL_BUTTON",
      gxe
    );
    return un(
      /* @__PURE__ */ x.jsx(
        zT,
        {
          element: r,
          signalCandidate: A,
          isStartEvent: !0
        }
      ),
      y
    );
  }
  if (Gg(r.businessObject) && ["bpmn:StartEvent", "bpmn:BoundaryEvent"].includes(r.type)) {
    const y = e(r, "THROW_ERROR_BUTTON", wJt);
    return un(/* @__PURE__ */ x.jsx(HJt, { element: r }), y);
  }
  const w = $b.state.userTasks?.find(
    (y) => y.taskDefinitionId === r.id && y.taskState === "CREATED" && !tSe(y.formKey)
  );
  if (w !== void 0 && n !== void 0) {
    const y = e(r, "TASK_FORM_BUTTON", pJt);
    return un(
      /* @__PURE__ */ x.jsx(
        qPe,
        {
          element: r,
          userTaskJob: w,
          processInstanceKey: n.key
        }
      ),
      y
    );
  }
  const v = e(r, "JOB_COMPLETE_BUTTON", fJt);
  return un(/* @__PURE__ */ x.jsx(WPe, { element: r }), v);
});
GPe.displayName = "DiagramOverlay";
const QPe = 0, WH = 1, zJt = 10, WJt = WH + QPe, jJt = WH + zJt, ZJt = WH + QPe, UJt = q.div`
  position: absolute;
  bottom: var(--spacing-medium, 20px);
  right: var(--spacing-medium, 20px);
  z-index: ${WJt};
`, qJt = q.div`
  display: flex;
  justify-content: center;
  color: var(--grey-darken-33);
  padding: 5px;
  background-color: var(--cm-color-white-base);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  border-radius: 2px;
`, dA = q.button`
  margin: 0px 5px;
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
  height: 20px;
  width: 20px;
  cursor: pointer;
  outline: none;
`, GJt = q.div`
  position: absolute;
  right: 0;
  bottom: 32px;
`, KPe = rt(
  ({
    handleZoomReset: r,
    handleZoomIn: e,
    handleZoomOut: t,
    handleMinimap: n,
    FeedbackButton: i
  }) => {
    const { handleFullscreenToggle: s } = Nt, { isFullscreenActive: o, isMinimapActive: a } = Nt.state, l = An(null);
    return /* @__PURE__ */ x.jsxs(UJt, { children: [
      /* @__PURE__ */ x.jsx(GJt, { ref: l, children: /* @__PURE__ */ x.jsx(
        i,
        {
          feedbackButtonSlotRef: l,
          from: "diagram-play"
        }
      ) }),
      /* @__PURE__ */ x.jsxs(qJt, { children: [
        /* @__PURE__ */ x.jsx(
          W2,
          {
            title: o ? "Disable fullscreen" : "Enable fullscreen",
            align: "top",
            showOnlyOnOverflow: !1,
            children: /* @__PURE__ */ x.jsx(
              dA,
              {
                "data-test": "toggle-fullscreen",
                onClick: s,
                title: "Toggle fullscreen mode",
                children: o ? (
                  //@ts-expect-error Property 'width' does not exist on type 'IntrinsicAttributes'.ts(2322)
                  /* @__PURE__ */ x.jsx(dXt, { width: "14", height: "14" })
                ) : (
                  //@ts-expect-error Property 'width' does not exist on type 'IntrinsicAttributes'.ts(2322)
                  /* @__PURE__ */ x.jsx(uXt, { width: "14", height: "14" })
                )
              }
            )
          }
        ),
        /* @__PURE__ */ x.jsx(
          W2,
          {
            title: "Toggle minimap",
            align: "top",
            showOnlyOnOverflow: !1,
            children: /* @__PURE__ */ x.jsx(
              dA,
              {
                "data-selector": "minimap-container",
                "data-test": "toggle-minimap",
                onClick: n,
                title: "Toggle minimap",
                children: /* @__PURE__ */ x.jsx(
                  hXt,
                  {
                    height: "18",
                    style: {
                      color: a && "var(--orange-base-60, hsl(34, 100%, 60%))"
                    }
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ x.jsx(
          W2,
          {
            title: "Reset viewport",
            align: "top",
            showOnlyOnOverflow: !1,
            children: /* @__PURE__ */ x.jsx(
              dA,
              {
                onClick: r,
                "data-test": "viewport-reset",
                title: "Reset viewport",
                children: /* @__PURE__ */ x.jsx(cXt, { width: "15", height: "15" })
              }
            )
          }
        ),
        /* @__PURE__ */ x.jsx(W2, { title: "Zoom out", align: "top", showOnlyOnOverflow: !1, children: /* @__PURE__ */ x.jsx(
          dA,
          {
            onClick: t,
            "data-test": "zoom-out",
            title: "Zoom out",
            children: /* @__PURE__ */ x.jsx(lXt, { width: "12", height: "12" })
          }
        ) }),
        /* @__PURE__ */ x.jsx(W2, { title: "Zoom in", align: "top", showOnlyOnOverflow: !1, children: /* @__PURE__ */ x.jsx(
          dA,
          {
            onClick: e,
            "data-test": "zoom-in",
            title: "Zoom in",
            children: /* @__PURE__ */ x.jsx(aXt, { width: "20", height: "20" })
          }
        ) })
      ] })
    ] });
  }
);
KPe.displayName = "DiagramControls";
const Hg = Math.min, af = Math.max, e7 = Math.round, r6 = Math.floor, x1 = (r) => ({
  x: r,
  y: r
}), QJt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, KJt = {
  start: "end",
  end: "start"
};
function YJt(r, e, t) {
  return af(r, Hg(e, t));
}
function SC(r, e) {
  return typeof r == "function" ? r(e) : r;
}
function Bg(r) {
  return r.split("-")[0];
}
function dv(r) {
  return r.split("-")[1];
}
function XJt(r) {
  return r === "x" ? "y" : "x";
}
function jH(r) {
  return r === "y" ? "height" : "width";
}
function q4(r) {
  return ["top", "bottom"].includes(Bg(r)) ? "y" : "x";
}
function ZH(r) {
  return XJt(q4(r));
}
function JJt(r, e, t) {
  t === void 0 && (t = !1);
  const n = dv(r), i = ZH(r), s = jH(i);
  let o = i === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (o = t7(o)), [o, t7(o)];
}
function $Jt(r) {
  const e = t7(r);
  return [WT(r), e, WT(e)];
}
function WT(r) {
  return r.replace(/start|end/g, (e) => KJt[e]);
}
function e$t(r, e, t) {
  const n = ["left", "right"], i = ["right", "left"], s = ["top", "bottom"], o = ["bottom", "top"];
  switch (r) {
    case "top":
    case "bottom":
      return t ? e ? i : n : e ? n : i;
    case "left":
    case "right":
      return e ? s : o;
    default:
      return [];
  }
}
function t$t(r, e, t, n) {
  const i = dv(r);
  let s = e$t(Bg(r), t === "start", n);
  return i && (s = s.map((o) => o + "-" + i), e && (s = s.concat(s.map(WT)))), s;
}
function t7(r) {
  return r.replace(/left|right|bottom|top/g, (e) => QJt[e]);
}
function n$t(r) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...r
  };
}
function YPe(r) {
  return typeof r != "number" ? n$t(r) : {
    top: r,
    right: r,
    bottom: r,
    left: r
  };
}
function n7(r) {
  const {
    x: e,
    y: t,
    width: n,
    height: i
  } = r;
  return {
    width: n,
    height: i,
    top: t,
    left: e,
    right: e + n,
    bottom: t + i,
    x: e,
    y: t
  };
}
function yxe(r, e, t) {
  let {
    reference: n,
    floating: i
  } = r;
  const s = q4(e), o = ZH(e), a = jH(o), l = Bg(e), c = s === "y", d = n.x + n.width / 2 - i.width / 2, u = n.y + n.height / 2 - i.height / 2, f = n[a] / 2 - i[a] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: d,
        y: n.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: u
      };
      break;
    case "left":
      p = {
        x: n.x - i.width,
        y: u
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (dv(e)) {
    case "start":
      p[o] -= f * (t && c ? -1 : 1);
      break;
    case "end":
      p[o] += f * (t && c ? -1 : 1);
      break;
  }
  return p;
}
const i$t = async (r, e, t) => {
  const {
    placement: n = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: o
  } = t, a = s.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: r,
    floating: e,
    strategy: i
  }), {
    x: d,
    y: u
  } = yxe(c, n, l), f = n, p = {}, g = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: A,
      fn: w
    } = a[m], {
      x: v,
      y,
      data: _,
      reset: S
    } = await w({
      x: d,
      y: u,
      initialPlacement: n,
      placement: f,
      strategy: i,
      middlewareData: p,
      rects: c,
      platform: o,
      elements: {
        reference: r,
        floating: e
      }
    });
    d = v ?? d, u = y ?? u, p = {
      ...p,
      [A]: {
        ...p[A],
        ..._
      }
    }, S && g <= 50 && (g++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await o.getElementRects({
      reference: r,
      floating: e,
      strategy: i
    }) : S.rects), {
      x: d,
      y: u
    } = yxe(c, f, l)), m = -1);
  }
  return {
    x: d,
    y: u,
    placement: f,
    strategy: i,
    middlewareData: p
  };
};
async function r$t(r, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: n,
    y: i,
    platform: s,
    rects: o,
    elements: a,
    strategy: l
  } = r, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = SC(e, r), g = YPe(p), A = a[f ? u === "floating" ? "reference" : "floating" : u], w = n7(await s.getClippingRect({
    element: (t = await (s.isElement == null ? void 0 : s.isElement(A))) == null || t ? A : A.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), v = u === "floating" ? {
    x: n,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), _ = await (s.isElement == null ? void 0 : s.isElement(y)) ? await (s.getScale == null ? void 0 : s.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = n7(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: v,
    offsetParent: y,
    strategy: l
  }) : v);
  return {
    top: (w.top - S.top + g.top) / _.y,
    bottom: (S.bottom - w.bottom + g.bottom) / _.y,
    left: (w.left - S.left + g.left) / _.x,
    right: (S.right - w.right + g.right) / _.x
  };
}
const s$t = (r) => ({
  name: "arrow",
  options: r,
  async fn(e) {
    const {
      x: t,
      y: n,
      placement: i,
      rects: s,
      platform: o,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: d = 0
    } = SC(r, e) || {};
    if (c == null)
      return {};
    const u = YPe(d), f = {
      x: t,
      y: n
    }, p = ZH(i), g = jH(p), m = await o.getDimensions(c), A = p === "y", w = A ? "top" : "left", v = A ? "bottom" : "right", y = A ? "clientHeight" : "clientWidth", _ = s.reference[g] + s.reference[p] - f[p] - s.floating[g], S = f[p] - s.reference[p], D = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let M = D ? D[y] : 0;
    (!M || !await (o.isElement == null ? void 0 : o.isElement(D))) && (M = a.floating[y] || s.floating[g]);
    const L = _ / 2 - S / 2, T = M / 2 - m[g] / 2 - 1, B = Hg(u[w], T), V = Hg(u[v], T), N = B, R = M - m[g] - V, H = M / 2 - m[g] / 2 + L, z = YJt(N, H, R), U = !l.arrow && dv(i) != null && H !== z && s.reference[g] / 2 - (H < N ? B : V) - m[g] / 2 < 0, ee = U ? H < N ? H - N : H - R : 0;
    return {
      [p]: f[p] + ee,
      data: {
        [p]: z,
        centerOffset: H - z - ee,
        ...U && {
          alignmentOffset: ee
        }
      },
      reset: U
    };
  }
}), o$t = function(r) {
  return r === void 0 && (r = {}), {
    name: "flip",
    options: r,
    async fn(e) {
      var t, n;
      const {
        placement: i,
        middlewareData: s,
        rects: o,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: d = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...A
      } = SC(r, e);
      if ((t = s.arrow) != null && t.alignmentOffset)
        return {};
      const w = Bg(i), v = q4(a), y = Bg(a) === a, _ = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = f || (y || !m ? [t7(a)] : $Jt(a)), D = g !== "none";
      !f && D && S.push(...t$t(a, m, g, _));
      const M = [a, ...S], L = await r$t(e, A), T = [];
      let B = ((n = s.flip) == null ? void 0 : n.overflows) || [];
      if (d && T.push(L[w]), u) {
        const H = JJt(i, o, _);
        T.push(L[H[0]], L[H[1]]);
      }
      if (B = [...B, {
        placement: i,
        overflows: T
      }], !T.every((H) => H <= 0)) {
        var V, N;
        const H = (((V = s.flip) == null ? void 0 : V.index) || 0) + 1, z = M[H];
        if (z)
          return {
            data: {
              index: H,
              overflows: B
            },
            reset: {
              placement: z
            }
          };
        let U = (N = B.filter((ee) => ee.overflows[0] <= 0).sort((ee, ce) => ee.overflows[1] - ce.overflows[1])[0]) == null ? void 0 : N.placement;
        if (!U)
          switch (p) {
            case "bestFit": {
              var R;
              const ee = (R = B.filter((ce) => {
                if (D) {
                  const se = q4(ce.placement);
                  return se === v || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  se === "y";
                }
                return !0;
              }).map((ce) => [ce.placement, ce.overflows.filter((se) => se > 0).reduce((se, te) => se + te, 0)]).sort((ce, se) => ce[1] - se[1])[0]) == null ? void 0 : R[0];
              ee && (U = ee);
              break;
            }
            case "initialPlacement":
              U = a;
              break;
          }
        if (i !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
async function a$t(r, e) {
  const {
    placement: t,
    platform: n,
    elements: i
  } = r, s = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), o = Bg(t), a = dv(t), l = q4(t) === "y", c = ["left", "top"].includes(o) ? -1 : 1, d = s && l ? -1 : 1, u = SC(e, r);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: g
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...u
  };
  return a && typeof g == "number" && (p = a === "end" ? g * -1 : g), l ? {
    x: p * d,
    y: f * c
  } : {
    x: f * c,
    y: p * d
  };
}
const l$t = function(r) {
  return r === void 0 && (r = 0), {
    name: "offset",
    options: r,
    async fn(e) {
      var t, n;
      const {
        x: i,
        y: s,
        placement: o,
        middlewareData: a
      } = e, l = await a$t(e, r);
      return o === ((t = a.offset) == null ? void 0 : t.placement) && (n = a.arrow) != null && n.alignmentOffset ? {} : {
        x: i + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
};
function _m(r) {
  return XPe(r) ? (r.nodeName || "").toLowerCase() : "#document";
}
function ba(r) {
  var e;
  return (r == null || (e = r.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function su(r) {
  var e;
  return (e = (XPe(r) ? r.ownerDocument : r.document) || window.document) == null ? void 0 : e.documentElement;
}
function XPe(r) {
  return r instanceof Node || r instanceof ba(r).Node;
}
function hc(r) {
  return r instanceof Element || r instanceof ba(r).Element;
}
function bh(r) {
  return r instanceof HTMLElement || r instanceof ba(r).HTMLElement;
}
function Cxe(r) {
  return typeof ShadowRoot > "u" ? !1 : r instanceof ShadowRoot || r instanceof ba(r).ShadowRoot;
}
function uv(r) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: n,
    display: i
  } = dc(r);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + t) && !["inline", "contents"].includes(i);
}
function c$t(r) {
  return ["table", "td", "th"].includes(_m(r));
}
function MC(r) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return r.matches(e);
    } catch {
      return !1;
    }
  });
}
function UH(r) {
  const e = qH(), t = hc(r) ? dc(r) : r;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (t.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (t.contain || "").includes(n));
}
function h$t(r) {
  let e = S1(r);
  for (; bh(e) && !Pg(e); ) {
    if (UH(e))
      return e;
    if (MC(e))
      return null;
    e = S1(e);
  }
  return null;
}
function qH() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Pg(r) {
  return ["html", "body", "#document"].includes(_m(r));
}
function dc(r) {
  return ba(r).getComputedStyle(r);
}
function DC(r) {
  return hc(r) ? {
    scrollLeft: r.scrollLeft,
    scrollTop: r.scrollTop
  } : {
    scrollLeft: r.scrollX,
    scrollTop: r.scrollY
  };
}
function S1(r) {
  if (_m(r) === "html")
    return r;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    r.assignedSlot || // DOM Element detected.
    r.parentNode || // ShadowRoot detected.
    Cxe(r) && r.host || // Fallback.
    su(r)
  );
  return Cxe(e) ? e.host : e;
}
function JPe(r) {
  const e = S1(r);
  return Pg(e) ? r.ownerDocument ? r.ownerDocument.body : r.body : bh(e) && uv(e) ? e : JPe(e);
}
function G4(r, e, t) {
  var n;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const i = JPe(r), s = i === ((n = r.ownerDocument) == null ? void 0 : n.body), o = ba(i);
  if (s) {
    const a = jT(o);
    return e.concat(o, o.visualViewport || [], uv(i) ? i : [], a && t ? G4(a) : []);
  }
  return e.concat(i, G4(i, [], t));
}
function jT(r) {
  return r.parent && Object.getPrototypeOf(r.parent) ? r.frameElement : null;
}
function $Pe(r) {
  const e = dc(r);
  let t = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const i = bh(r), s = i ? r.offsetWidth : t, o = i ? r.offsetHeight : n, a = e7(t) !== s || e7(n) !== o;
  return a && (t = s, n = o), {
    width: t,
    height: n,
    $: a
  };
}
function GH(r) {
  return hc(r) ? r : r.contextElement;
}
function qp(r) {
  const e = GH(r);
  if (!bh(e))
    return x1(1);
  const t = e.getBoundingClientRect(), {
    width: n,
    height: i,
    $: s
  } = $Pe(e);
  let o = (s ? e7(t.width) : t.width) / n, a = (s ? e7(t.height) : t.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const d$t = /* @__PURE__ */ x1(0);
function eFe(r) {
  const e = ba(r);
  return !qH() || !e.visualViewport ? d$t : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function u$t(r, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== ba(r) ? !1 : e;
}
function Vf(r, e, t, n) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const i = r.getBoundingClientRect(), s = GH(r);
  let o = x1(1);
  e && (n ? hc(n) && (o = qp(n)) : o = qp(r));
  const a = u$t(s, t, n) ? eFe(s) : x1(0);
  let l = (i.left + a.x) / o.x, c = (i.top + a.y) / o.y, d = i.width / o.x, u = i.height / o.y;
  if (s) {
    const f = ba(s), p = n && hc(n) ? ba(n) : n;
    let g = f, m = jT(g);
    for (; m && n && p !== g; ) {
      const A = qp(m), w = m.getBoundingClientRect(), v = dc(m), y = w.left + (m.clientLeft + parseFloat(v.paddingLeft)) * A.x, _ = w.top + (m.clientTop + parseFloat(v.paddingTop)) * A.y;
      l *= A.x, c *= A.y, d *= A.x, u *= A.y, l += y, c += _, g = ba(m), m = jT(g);
    }
  }
  return n7({
    width: d,
    height: u,
    x: l,
    y: c
  });
}
function f$t(r) {
  let {
    elements: e,
    rect: t,
    offsetParent: n,
    strategy: i
  } = r;
  const s = i === "fixed", o = su(n), a = e ? MC(e.floating) : !1;
  if (n === o || a && s)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = x1(1);
  const d = x1(0), u = bh(n);
  if ((u || !u && !s) && ((_m(n) !== "body" || uv(o)) && (l = DC(n)), bh(n))) {
    const f = Vf(n);
    c = qp(n), d.x = f.x + n.clientLeft, d.y = f.y + n.clientTop;
  }
  return {
    width: t.width * c.x,
    height: t.height * c.y,
    x: t.x * c.x - l.scrollLeft * c.x + d.x,
    y: t.y * c.y - l.scrollTop * c.y + d.y
  };
}
function p$t(r) {
  return Array.from(r.getClientRects());
}
function tFe(r) {
  return Vf(su(r)).left + DC(r).scrollLeft;
}
function g$t(r) {
  const e = su(r), t = DC(r), n = r.ownerDocument.body, i = af(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = af(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -t.scrollLeft + tFe(r);
  const a = -t.scrollTop;
  return dc(n).direction === "rtl" && (o += af(e.clientWidth, n.clientWidth) - i), {
    width: i,
    height: s,
    x: o,
    y: a
  };
}
function m$t(r, e) {
  const t = ba(r), n = su(r), i = t.visualViewport;
  let s = n.clientWidth, o = n.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    const c = qH();
    (!c || c && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
function A$t(r, e) {
  const t = Vf(r, !0, e === "fixed"), n = t.top + r.clientTop, i = t.left + r.clientLeft, s = bh(r) ? qp(r) : x1(1), o = r.clientWidth * s.x, a = r.clientHeight * s.y, l = i * s.x, c = n * s.y;
  return {
    width: o,
    height: a,
    x: l,
    y: c
  };
}
function Exe(r, e, t) {
  let n;
  if (e === "viewport")
    n = m$t(r, t);
  else if (e === "document")
    n = g$t(su(r));
  else if (hc(e))
    n = A$t(e, t);
  else {
    const i = eFe(r);
    n = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return n7(n);
}
function nFe(r, e) {
  const t = S1(r);
  return t === e || !hc(t) || Pg(t) ? !1 : dc(t).position === "fixed" || nFe(t, e);
}
function w$t(r, e) {
  const t = e.get(r);
  if (t)
    return t;
  let n = G4(r, [], !1).filter((a) => hc(a) && _m(a) !== "body"), i = null;
  const s = dc(r).position === "fixed";
  let o = s ? S1(r) : r;
  for (; hc(o) && !Pg(o); ) {
    const a = dc(o), l = UH(o);
    !l && a.position === "fixed" && (i = null), (s ? !l && !i : !l && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || uv(o) && !l && nFe(r, o)) ? n = n.filter((d) => d !== o) : i = a, o = S1(o);
  }
  return e.set(r, n), n;
}
function v$t(r) {
  let {
    element: e,
    boundary: t,
    rootBoundary: n,
    strategy: i
  } = r;
  const o = [...t === "clippingAncestors" ? MC(e) ? [] : w$t(e, this._c) : [].concat(t), n], a = o[0], l = o.reduce((c, d) => {
    const u = Exe(e, d, i);
    return c.top = af(u.top, c.top), c.right = Hg(u.right, c.right), c.bottom = Hg(u.bottom, c.bottom), c.left = af(u.left, c.left), c;
  }, Exe(e, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function b$t(r) {
  const {
    width: e,
    height: t
  } = $Pe(r);
  return {
    width: e,
    height: t
  };
}
function y$t(r, e, t) {
  const n = bh(e), i = su(e), s = t === "fixed", o = Vf(r, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = x1(0);
  if (n || !n && !s)
    if ((_m(e) !== "body" || uv(i)) && (a = DC(e)), n) {
      const u = Vf(e, !0, s, e);
      l.x = u.x + e.clientLeft, l.y = u.y + e.clientTop;
    } else i && (l.x = tFe(i));
  const c = o.left + a.scrollLeft - l.x, d = o.top + a.scrollTop - l.y;
  return {
    x: c,
    y: d,
    width: o.width,
    height: o.height
  };
}
function sM(r) {
  return dc(r).position === "static";
}
function _xe(r, e) {
  return !bh(r) || dc(r).position === "fixed" ? null : e ? e(r) : r.offsetParent;
}
function iFe(r, e) {
  const t = ba(r);
  if (MC(r))
    return t;
  if (!bh(r)) {
    let i = S1(r);
    for (; i && !Pg(i); ) {
      if (hc(i) && !sM(i))
        return i;
      i = S1(i);
    }
    return t;
  }
  let n = _xe(r, e);
  for (; n && c$t(n) && sM(n); )
    n = _xe(n, e);
  return n && Pg(n) && sM(n) && !UH(n) ? t : n || h$t(r) || t;
}
const C$t = async function(r) {
  const e = this.getOffsetParent || iFe, t = this.getDimensions, n = await t(r.floating);
  return {
    reference: y$t(r.reference, await e(r.floating), r.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function E$t(r) {
  return dc(r).direction === "rtl";
}
const _$t = {
  convertOffsetParentRelativeRectToViewportRelativeRect: f$t,
  getDocumentElement: su,
  getClippingRect: v$t,
  getOffsetParent: iFe,
  getElementRects: C$t,
  getClientRects: p$t,
  getDimensions: b$t,
  getScale: qp,
  isElement: hc,
  isRTL: E$t
};
function x$t(r, e) {
  let t = null, n;
  const i = su(r);
  function s() {
    var a;
    clearTimeout(n), (a = t) == null || a.disconnect(), t = null;
  }
  function o(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const {
      left: c,
      top: d,
      width: u,
      height: f
    } = r.getBoundingClientRect();
    if (a || e(), !u || !f)
      return;
    const p = r6(d), g = r6(i.clientWidth - (c + u)), m = r6(i.clientHeight - (d + f)), A = r6(c), v = {
      rootMargin: -p + "px " + -g + "px " + -m + "px " + -A + "px",
      threshold: af(0, Hg(1, l)) || 1
    };
    let y = !0;
    function _(S) {
      const D = S[0].intersectionRatio;
      if (D !== l) {
        if (!y)
          return o();
        D ? o(!1, D) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      y = !1;
    }
    try {
      t = new IntersectionObserver(_, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(_, v);
    }
    t.observe(r);
  }
  return o(!0), s;
}
function S$t(r, e, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = GH(r), d = i || s ? [...c ? G4(c) : [], ...G4(e)] : [];
  d.forEach((w) => {
    i && w.addEventListener("scroll", t, {
      passive: !0
    }), s && w.addEventListener("resize", t);
  });
  const u = c && a ? x$t(c, t) : null;
  let f = -1, p = null;
  o && (p = new ResizeObserver((w) => {
    let [v] = w;
    v && v.target === c && p && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), t();
  }), c && !l && p.observe(c), p.observe(e));
  let g, m = l ? Vf(r) : null;
  l && A();
  function A() {
    const w = Vf(r);
    m && (w.x !== m.x || w.y !== m.y || w.width !== m.width || w.height !== m.height) && t(), m = w, g = requestAnimationFrame(A);
  }
  return t(), () => {
    var w;
    d.forEach((v) => {
      i && v.removeEventListener("scroll", t), s && v.removeEventListener("resize", t);
    }), u?.(), (w = p) == null || w.disconnect(), p = null, l && cancelAnimationFrame(g);
  };
}
const M$t = l$t, D$t = o$t, xxe = s$t, L$t = (r, e, t) => {
  const n = /* @__PURE__ */ new Map(), i = {
    platform: _$t,
    ...t
  }, s = {
    ...i.platform,
    _c: n
  };
  return i$t(r, e, {
    ...i,
    platform: s
  });
};
var k$t = typeof document < "u", N$t = function() {
}, a8 = k$t ? Fg : N$t;
function i7(r, e) {
  if (r === e)
    return !0;
  if (typeof r != typeof e)
    return !1;
  if (typeof r == "function" && r.toString() === e.toString())
    return !0;
  let t, n, i;
  if (r && e && typeof r == "object") {
    if (Array.isArray(r)) {
      if (t = r.length, t !== e.length) return !1;
      for (n = t; n-- !== 0; )
        if (!i7(r[n], e[n]))
          return !1;
      return !0;
    }
    if (i = Object.keys(r), t = i.length, t !== Object.keys(e).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[n]))
        return !1;
    for (n = t; n-- !== 0; ) {
      const s = i[n];
      if (!(s === "_owner" && r.$$typeof) && !i7(r[s], e[s]))
        return !1;
    }
    return !0;
  }
  return r !== r && e !== e;
}
function rFe(r) {
  return typeof window > "u" ? 1 : (r.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Sxe(r, e) {
  const t = rFe(r);
  return Math.round(e * t) / t;
}
function oM(r) {
  const e = be.useRef(r);
  return a8(() => {
    e.current = r;
  }), e;
}
function T$t(r) {
  r === void 0 && (r = {});
  const {
    placement: e = "bottom",
    strategy: t = "absolute",
    middleware: n = [],
    platform: i,
    elements: {
      reference: s,
      floating: o
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = r, [d, u] = be.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = be.useState(n);
  i7(f, n) || p(n);
  const [g, m] = be.useState(null), [A, w] = be.useState(null), v = be.useCallback((ce) => {
    ce !== D.current && (D.current = ce, m(ce));
  }, []), y = be.useCallback((ce) => {
    ce !== M.current && (M.current = ce, w(ce));
  }, []), _ = s || g, S = o || A, D = be.useRef(null), M = be.useRef(null), L = be.useRef(d), T = l != null, B = oM(l), V = oM(i), N = oM(c), R = be.useCallback(() => {
    if (!D.current || !M.current)
      return;
    const ce = {
      placement: e,
      strategy: t,
      middleware: f
    };
    V.current && (ce.platform = V.current), L$t(D.current, M.current, ce).then((se) => {
      const te = {
        ...se,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: N.current !== !1
      };
      H.current && !i7(L.current, te) && (L.current = te, fFe.flushSync(() => {
        u(te);
      }));
    });
  }, [f, e, t, V, N]);
  a8(() => {
    c === !1 && L.current.isPositioned && (L.current.isPositioned = !1, u((ce) => ({
      ...ce,
      isPositioned: !1
    })));
  }, [c]);
  const H = be.useRef(!1);
  a8(() => (H.current = !0, () => {
    H.current = !1;
  }), []), a8(() => {
    if (_ && (D.current = _), S && (M.current = S), _ && S) {
      if (B.current)
        return B.current(_, S, R);
      R();
    }
  }, [_, S, R, B, T]);
  const z = be.useMemo(() => ({
    reference: D,
    floating: M,
    setReference: v,
    setFloating: y
  }), [v, y]), U = be.useMemo(() => ({
    reference: _,
    floating: S
  }), [_, S]), ee = be.useMemo(() => {
    const ce = {
      position: t,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return ce;
    const se = Sxe(U.floating, d.x), te = Sxe(U.floating, d.y);
    return a ? {
      ...ce,
      transform: "translate(" + se + "px, " + te + "px)",
      ...rFe(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: se,
      top: te
    };
  }, [t, a, U.floating, d.x, d.y]);
  return be.useMemo(() => ({
    ...d,
    update: R,
    refs: z,
    elements: U,
    floatingStyles: ee
  }), [d, R, z, U, ee]);
}
const I$t = (r) => {
  function e(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: r,
    fn(t) {
      const {
        element: n,
        padding: i
      } = typeof r == "function" ? r(t) : r;
      return n && e(n) ? n.current != null ? xxe({
        element: n.current,
        padding: i
      }).fn(t) : {} : n ? xxe({
        element: n,
        padding: i
      }).fn(t) : {};
    }
  };
}, O$t = (r, e) => ({
  ...M$t(r),
  options: [r, e]
}), R$t = (r, e) => ({
  ...D$t(r),
  options: [r, e]
}), V$t = (r, e) => ({
  ...I$t(r),
  options: [r, e]
}), H$t = q.div`
  position: absolute;
  width: ${I_e}px;
  height: ${I_e}px;
  background-color: var(--cds-layer);
  transform: rotate(45deg);
`, B$t = q.div`
  background-color: var(--cds-layer);
  box-shadow: 0 2px 6px var(--cds-shadow);
  color: var(--cds-text-secondary);
  padding: var(--cds-spacing-05);
`;
var aM, Mxe;
function P$t() {
  if (Mxe) return aM;
  Mxe = 1;
  function r(e) {
    return e == null;
  }
  return aM = r, aM;
}
var F$t = P$t();
const z$t = /* @__PURE__ */ a7(F$t);
function W$t({
  side: r,
  x: e,
  y: t
}) {
  return r === "top" ? {
    left: e,
    bottom: -9
  } : r === "bottom" ? {
    left: e,
    top: -9
  } : r === "left" ? {
    top: t,
    right: -9
  } : {
    top: t,
    left: -9
  };
}
function j$t(r) {
  const [e] = r.split("-");
  return e;
}
function s6(r) {
  return z$t(r) || isNaN(r) ? 0 : r;
}
const Z$t = ({
  referenceElement: r,
  children: e,
  placement: t = "bottom",
  className: n,
  onOutsideClick: i,
  middlewareOptions: s = [],
  autoUpdatePosition: o = !1
}) => {
  const a = An(null), {
    x: l,
    y: c,
    strategy: d,
    middlewareData: u,
    placement: f,
    refs: { floating: p, setFloating: g }
  } = T$t({
    placement: t,
    middleware: [...s, V$t({ element: a })],
    whileElementsMounted: o ? S$t : void 0,
    elements: {
      reference: r
    }
  }), [m, A] = ye(!1);
  Pe(() => {
    u.hide && p?.current !== null && A(!!u.hide.referenceHidden);
  }, [p, u]), Fg(() => {
    const y = (_) => {
      const S = _.target;
      S instanceof Element && !p.current?.contains(S) && i?.(_);
    };
    return document.body?.addEventListener("click", y, !0), () => {
      document.body?.removeEventListener("click", y, !0);
    };
  }, [i, p]);
  const { x: w, y: v } = u.arrow ?? {};
  return r === null ? null : un(
    /* @__PURE__ */ x.jsx(
      B$t,
      {
        className: n,
        ref: g,
        style: {
          position: d,
          top: s6(c),
          left: s6(l)
        },
        "data-testid": "play-popover",
        children: !m && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(
            H$t,
            {
              ref: a,
              style: {
                ...W$t({
                  side: j$t(f),
                  x: s6(w),
                  y: s6(v)
                })
              }
            }
          ),
          /* @__PURE__ */ x.jsx("div", { children: e })
        ] })
      }
    ),
    document.querySelector("[data-test='zeebe-play']") ?? document.body
  );
}, U$t = q.div`
  ${yl.headingCompact01};
`, q$t = q(Rn)`
  width: 100%;
`, G$t = ({ children: r, text: e, align: t }) => e ? /* @__PURE__ */ x.jsx(ew, { align: t, label: e, children: /* @__PURE__ */ x.jsx("div", { children: r }) }) : r, lM = rt(
  ({ title: r, label: e, renderIcon: t, onClick: n, notificationTitle: i }) => {
    const s = bn(qr);
    return /* @__PURE__ */ x.jsx(G$t, { align: "right", text: r, children: /* @__PURE__ */ x.jsx(
      q$t,
      {
        kind: "ghost",
        size: "sm",
        renderIcon: t,
        onClick: async () => {
          const o = await n();
          i !== void 0 && (o ? s.displayNotification?.info({
            title: i
          }) : s.displayNotification?.error(zr)), kr.clearSelection();
        },
        children: e
      }
    ) });
  }
), Q$t = rt(
  ({ selectedFlowNodeRef: r, diagramCanvasRef: e }) => {
    const t = kr.state.selection?.flowNodeId, n = kr.state.selection?.flowNodeName, {
      state: { processInstance: i },
      isRunning: s
    } = Ne, { availableModifications: o, canSelectedFlowNodeBeModified: a } = hl;
    return i === void 0 || t === void 0 || !s || !a ? null : /* @__PURE__ */ x.jsx(
      Z$t,
      {
        referenceElement: r,
        middlewareOptions: [
          O$t(10),
          R$t({
            fallbackPlacements: ["top", "left", "right"],
            boundary: e?.current ?? void 0
          })
        ],
        autoUpdatePosition: !0,
        children: /* @__PURE__ */ x.jsxs(In, { gap: 3, children: [
          /* @__PURE__ */ x.jsx(U$t, { children: "Flow node modifications" }),
          /* @__PURE__ */ x.jsx(In, { gap: 4, children: /* @__PURE__ */ x.jsxs(In, { gap: 2, children: [
            o.includes("add") && /* @__PURE__ */ x.jsx(
              lM,
              {
                renderIcon: E7,
                title: "Add single flow node instance",
                label: "Add",
                onClick: async () => {
                  const { success: l } = await At.modify({
                    processInstanceKey: i.key,
                    activateInstructions: [
                      {
                        elementId: t,
                        ancestorElementInstanceKey: -1,
                        variableInstructions: []
                      }
                    ]
                  });
                  return l && Jn.applyModifictation("add-token"), l;
                },
                notificationTitle: `Adding token on ${n}`
              }
            ),
            o.includes("cancel-all") && /* @__PURE__ */ x.jsx(x.Fragment, { children: (() => {
              const l = yr.state.elementInstances.filter(
                ({ state: c, flowNodeId: d }) => !["COMPLETED", "TERMINATED"].includes(c) && d === t
              ).map(({ key: c }) => ({
                elementInstanceKey: c
              }));
              return /* @__PURE__ */ x.jsx(
                lM,
                {
                  renderIcon: Vd,
                  title: "Cancel all running flow node instances in this flow node",
                  label: "Cancel all",
                  onClick: async () => {
                    const { success: c } = await At.modify({
                      processInstanceKey: i.key,
                      terminateInstructions: l
                    });
                    return c && Jn.applyModifictation("cancel-token"), c;
                  },
                  notificationTitle: `Canceling ${uPe(l.length, "token")} on ${n}`
                }
              );
            })() }),
            o.includes("move-all") && /* @__PURE__ */ x.jsx(
              lM,
              {
                renderIcon: mMe,
                title: "Move all running instances in this flow node to another target",
                label: "Move all",
                onClick: () => {
                  hl.startMovingToken(t), kr.clearSelection();
                }
              }
            )
          ] }) })
        ] })
      }
    );
  }
), ZT = q(gXt)`
  // taken and adapted from https://github.com/camunda/linting/blob/4f070d31dc615b26dd9352fffbfaa06f3d772f58/assets/linting.css#L14
  position: absolute;
  --icon-bg-color: var(--cl-color-warning, #ff832b);

  background: var(--icon-bg-color);
  color: white;
  border-radius: 100%;
  height: 20px;
  width: 20px;
  border: solid 4px var(--icon-bg-color);
`, sFe = rt(({ element: r }) => {
  const { authType: e } = gt;
  if (e === "sm")
    return;
  const { connectorElementsWithMissingSecrets: t } = Gd;
  if (t.find(
    (i) => i.element.id === r.id
  )?.missingSecrets?.[0] !== void 0)
    return /* @__PURE__ */ x.jsx(ZT, { "data-testid": "not-found-icon" });
});
sFe.displayName = "ConnectorSecretOverlay";
const oFe = rt(({ element: r, addOverlay: e }) => {
  const { instanceKey: t } = Ne.state, { fileProblems: n } = gt;
  if (t)
    return;
  if (n.find(
    (l) => l.elementBusinessObject.id === r.id
  )) {
    const l = e(r, "PROBLEM", rM);
    return un(/* @__PURE__ */ x.jsx(ZT, { "data-testid": "not-found-icon" }), l);
  }
  if (Nt.elementsWithExecutionListeners.some(
    ({ businessObject: l }) => l.id === r.id
  )) {
    const l = e(r, "EXECUTION_LISTENER_WARNING", rM);
    return un(
      /* @__PURE__ */ x.jsx(ZT, { "data-testid": "execution-listener-warning" }),
      l
    );
  }
  const {
    state: { connectorElementsWithSecrets: o }
  } = Gd;
  if (o?.find(
    (l) => l.element.id === r.id
  )) {
    const l = e(r, "CONNECTOR", rM);
    return un(/* @__PURE__ */ x.jsx(sFe, { element: r }), l);
  }
});
oFe.displayName = "ProblemOverlay";
const aFe = rt(({ element: r }) => {
  const { isInstanceDetailPageVisible: e } = Ne, t = ui.isSingleScenarioSelected ? ui.coveredFlowNodeIdsForSelectedScenario : ui.allCoveredFlowNodes.map(({ flowNodeId: i }) => i), n = eo.state.activeTab === "scenarios";
  return Pe(() => {
    if (!e && t.length > 0 && n)
      return t.includes(r.id) ? Nt.state.viewer?.addMarker(r.id, "play-flow-node-taken") : Nt.state.viewer?.removeMarker(
        r.id,
        "play-flow-node-taken"
      ), () => {
        Nt.state.viewer?.removeMarker(
          r.id,
          "play-flow-node-taken"
        );
      };
  }, [
    e,
    n,
    r,
    t
  ]), null;
});
aFe.displayName = "FlowNodeHighlighter";
const Dxe = "40px", K$t = q(Hf)`
  position: absolute;
  top: var(--cds-spacing-05);
  z-index: ${ZJt};
  max-inline-size: unset;
  margin: 0 ${Dxe};
  max-width: calc(100% - calc(2 * ${Dxe}));
`, lFe = rt(() => {
  if (Zp.isClusterHealthy)
    return null;
  const r = Zp.state.cluster?.name, e = Zp.state.cluster?.uuid;
  return /* @__PURE__ */ x.jsx(
    K$t,
    {
      inline: !0,
      kind: "error",
      hideCloseButton: !0,
      statusIconDescription: "notification",
      subtitle: `The cluster ${r ? `'${r}' ` : ""}is unavailable. Please select 'Manage cluster' to review and resolve the issue in the Console.`,
      title: "Cluster Unavailable",
      onActionButtonClick: () => {
        window.open(
          `${gt.consoleDashboardPageUrl}/cluster/${e}`,
          "_blank"
        );
      },
      actionButtonLabel: "Manage cluster"
    }
  );
});
lFe.displayName = "ClusterUnavailableNotification";
const cFe = rt(({ FeedbackButton: r }) => {
  const e = gt.xml, t = An(null), n = An(null), i = hl.isMovingToken, s = Nt.selectableFlowNodeIds, o = kr.state.selection?.flowNodeId, a = Ne.state.instanceKey;
  function l() {
    return n.current === null && (n.current = new UXt()), n.current;
  }
  const c = l();
  return Fg(() => {
    async function d() {
      if (e && t.current) {
        const u = o ? [o] : void 0;
        Nt.startLoading();
        const f = dPe(e);
        await Nt.setDiagramDetails(f), await c.render({
          container: t.current,
          xml: e,
          selectableFlowNodeIds: s,
          selectedFlowNodeIds: u,
          showModificationNotSupportedTooltip: i
        }), Nt.finishLoading(c);
      }
    }
    d();
  }, [e, c, s, o, i]), Pe(() => () => {
    c.reset();
  }, [c]), /* @__PURE__ */ x.jsxs(qXt, { "data-testid": "diagram", children: [
    /* @__PURE__ */ x.jsx(lFe, {}),
    /* @__PURE__ */ x.jsx(
      GXt,
      {
        ref: t,
        $isSelectionAllowed: a !== void 0
      }
    ),
    Nt.state.isLoaded && /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        KPe,
        {
          handleZoomIn: c.zoomIn,
          handleZoomOut: c.zoomOut,
          handleZoomReset: c.zoomReset,
          handleMinimap: c.toggleMinimap,
          FeedbackButton: r
        }
      ),
      Nt.elements?.map((d) => /* @__PURE__ */ x.jsx(
        GPe,
        {
          element: d,
          addOverlay: c.addOverlay
        },
        d.id
      )),
      Nt.elements?.map((d) => /* @__PURE__ */ x.jsx(
        oFe,
        {
          element: d,
          addOverlay: c.addOverlay
        },
        d.id
      )),
      o !== void 0 && /* @__PURE__ */ x.jsx(
        Q$t,
        {
          selectedFlowNodeRef: c.selectedFlowNode,
          diagramCanvasRef: t
        }
      ),
      Nt.elements?.map((d) => /* @__PURE__ */ x.jsx(aFe, { element: d }, d.id))
    ] })
  ] });
});
cFe.displayName = "Diagram";
const Lxe = q.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-border-subtle-selected-01, #c6c6c6);
  margin-bottom: var(--cds-spacing-05, 16px);
`, kxe = q(oXt)`
  width: 45px;
  height: 45px;
  animation: grow 1200ms forwards;

  @keyframes grow {
    from {
      width: 45px;
      height: 45px;
    }
    to {
      width: 180px;
      height: 180px;
    }
  }
`, hFe = rt(() => {
  const r = bn(qr), {
    instanceKey: e,
    processInstance: t,
    isProcessManuallyCompleted: n,
    isCalledProcess: i
  } = Ne.state, s = t?.bpmnProcessId;
  return s === void 0 || e === void 0 || !n || NT() || i ? null : (NT() || tQt(), r.featureFlags.isReplayScenariosEnabled ? /* @__PURE__ */ x.jsx(
    wPe,
    {
      title: "Scenario recorded!",
      isOpen: Ne.state.isProcessManuallyCompleted,
      onScenarioSaved: (o) => {
        try {
          nPe({
            bpmnProcessId: s,
            name: o,
            processInstanceId: e,
            actions: U4(rr(e)),
            coveredFlowNodes: yr.elementInstancesWithType,
            coveredSequenceFlows: Vg.state.sequenceFlows
          });
        } catch {
          r.displayNotification?.error(zr);
          return;
        }
        Ne.setScenarioName(o), r.displayNotification?.success(
          {
            title: "Scenario saved",
            subtitle: `${o} was successfully saved.`
          },
          {
            action: {
              label: "View scenario",
              onClick: () => {
                eo.setActiveTab("scenarios"), Ne.reset();
              }
            }
          }
        );
      },
      onClose: () => {
        Ne.setIsProcessManuallyCompleted(!1);
      },
      topContent: /* @__PURE__ */ x.jsx(Lxe, { children: /* @__PURE__ */ x.jsx(kxe, {}) })
    }
  ) : /* @__PURE__ */ x.jsxs(
    M1,
    {
      open: Ne.state.isProcessManuallyCompleted,
      size: "md",
      modalHeading: "Congratulations, you did it!",
      primaryButtonText: "Go to Implement mode",
      onRequestClose: () => {
        Ne.setIsProcessManuallyCompleted(!1);
      },
      onRequestSubmit: () => {
        r.switchToImplementMode?.();
      },
      preventCloseOnClickOutside: !0,
      children: [
        /* @__PURE__ */ x.jsx(Lxe, { children: /* @__PURE__ */ x.jsx(kxe, {}) }),
        /* @__PURE__ */ x.jsx("p", { children: "You’ve successfully completed your process in Play." }),
        /* @__PURE__ */ x.jsx("br", {}),
        /* @__PURE__ */ x.jsx("p", { children: "Let’s make your work even more efficient!" }),
        /* @__PURE__ */ x.jsxs("p", { children: [
          /* @__PURE__ */ x.jsx("b", { children: "Deploy" }),
          " your process to a live cluster from Implement mode to see it in action."
        ] })
      ]
    }
  ));
});
hFe.displayName = "ProcessInstanceSuccessfullyCompletedModal";
function Y$t(r) {
  return ms(
    () => yr.elementInstances,
    (e, t) => {
      if (t.length === 0 && Ne.state.instanceType !== "NEW_INSTANCE")
        return;
      const n = e.filter(
        (o) => o.type === "BUSINESS_RULE_TASK" && o.state === "COMPLETED"
      ), i = t.filter(
        (o) => o.type === "BUSINESS_RULE_TASK" && o.state === "COMPLETED"
      ).map(({ key: o }) => o);
      n.filter(
        ({ key: o }) => !i.includes(o)
      ).forEach(({ flowNodeName: o, flowNodeId: a }) => {
        r?.success({
          title: `"${o || a}" business rule task completed`
        });
      });
    }
  );
}
function X$t(r) {
  return ms(
    () => yr.elementInstances,
    (e, t) => {
      if (t.length === 0 && Ne.state.instanceType !== "NEW_INSTANCE")
        return;
      const n = e.filter(
        (o) => o.type === "EVENT_SUB_PROCESS"
      ), i = t.filter((o) => o.type === "EVENT_SUB_PROCESS").map(({ key: o }) => o);
      n.filter(
        ({ key: o }) => !i.includes(o)
      ).forEach(({ flowNodeName: o, flowNodeId: a }) => {
        r?.success(
          {
            title: `"${o || a}" event sub-process started`
          },
          {
            action: {
              label: "Go to sub-process",
              onClick: () => {
                Nt.focusOnElement(a);
              }
            }
          }
        );
      });
    }
  );
}
const J$t = q(In)`
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: var(--cds-overlay);
  color: white;
  z-index: ${jJt};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${yl.heading02};
`, $$t = ({ description: r }) => r === null ? null : /* @__PURE__ */ x.jsxs(J$t, { gap: 5, children: [
  /* @__PURE__ */ x.jsx(GT, { withOverlay: !1 }),
  r
] }), een = ({
  isLoadingProcessInstanceDetails: r,
  isRewinding: e
}) => r ? "Loading instance details..." : e ? "Rewinding..." : null, nin = ({
  authConfig: r,
  monacoLoaderConfig: e,
  xml: t,
  switchToImplementMode: n,
  onDeploymentError: i,
  projectId: s,
  processId: o,
  processName: a,
  displayNotification: l,
  mixpanelTrack: c,
  handleGetRequest: d,
  handlePostRequest: u,
  fetchFilesByProcessId: f,
  fetchFilesByDecisionId: p,
  fetchFilesByFormId: g,
  fetchFileById: m,
  featureFlags: A,
  consoleDashboardPageUrl: w,
  isUserOrgOwnerOrAdmin: v,
  organizationManagementPageUrl: y,
  currentDiagramRevision: _,
  updateFileById: S,
  originAppInstanceId: D,
  canUserSaveExampleData: M,
  diagramId: L,
  FeedbackButton: T
}) => {
  const B = localStorage.getItem("play-directAccess"), V = r?.type, N = r?.config?.operateBaseUrl, R = V === "saas" ? r.config.clusterId : void 0;
  if (B) {
    localStorage.removeItem("play-directAccess");
    const j = JSON.parse(B);
    Ne.setInstanceDetails({
      instanceKey: j.instance,
      instanceType: "EXISTING_INSTANCE"
    }), gt.setProcessedFiles(j.processedFiles);
  }
  const [H, z] = ye(!B), [U, ee] = ye(!1);
  Pe(
    () => ms(
      () => Ne.state.status === "first-fetch" && Ne.state.instanceType !== "REWOUND_INSTANCE",
      (j) => {
        ee(j);
      }
    ),
    []
  );
  const [ce, se] = ye(!1);
  Pe(
    () => ms(
      () => u0.state.isRewinding,
      (j) => {
        se(j);
      }
    ),
    []
  ), Pe(() => (V === "saas" && Zp.init(), eo.init(A?.isReplayScenariosEnabled), () => {
    V === "saas" && Zp.reset(), Ne.reset(), Gd.reset(), gt.reset(), Nt.reset(), eo.reset(), ui.reset();
  }), [A?.isReplayScenariosEnabled, V]), Pe(() => {
    V === "saas" && !R || (Jn.init({ mixpanelTrack: c, processId: o, diagramId: L }), At.init({
      authConfig: r,
      handlePostRequest: u,
      handleGetRequest: d
    }), hl.init(l));
  }, [R, V, o, L]), Pe(() => {
    gt.init({
      projectId: s,
      processId: o,
      processName: a,
      fetchFilesByProcessId: f,
      fetchFilesByDecisionId: p,
      fetchFileById: m,
      fetchFilesByFormId: g,
      onDeploymentError: i,
      xml: t,
      consoleDashboardPageUrl: w,
      clusterId: R,
      currentDiagramRevision: _,
      updateFileById: S,
      originAppInstanceId: D,
      canUserSaveExampleData: M,
      diagramId: L,
      authType: V,
      operateBaseUrl: N
    });
  }, [
    o,
    s,
    a,
    R,
    f,
    p,
    m,
    g,
    i,
    t,
    w,
    _,
    S,
    D,
    M,
    L,
    V,
    N
  ]);
  const te = aKt(V, R);
  Pe(() => {
    if (!ce) {
      const j = Y$t(l), pe = X$t(l);
      return () => {
        j(), pe();
      };
    }
  }, [l, ce]);
  function ue(j) {
    return ru(async () => {
      const { processInstances: pe, success: De } = await At.fetchInstances(
        gt.state.processDefinitionKey
      );
      if (De) {
        const Ce = pe[0];
        return Ce && Ce.key !== j[0]?.key ? Ce.key : null;
      } else
        return null;
    });
  }
  const G = {
    startInstance: async (j = "{}") => {
      const pe = await At.startInstance({
        bpmnProcessId: o,
        variables: j
      });
      return Ne.reset(), pe?.success && pe.instanceId !== void 0 && (Ne.setInstanceDetails({
        instanceKey: pe.instanceId,
        instanceType: "NEW_INSTANCE"
      }), ao(rr(pe.instanceId), {
        action: "startInstance",
        type: "start-event",
        variables: j
      })), pe?.success !== !1;
    },
    publishMessage: async ({
      messageName: j,
      correlationKey: pe,
      variables: De,
      timeToLive: Ce,
      messageId: F,
      isStartEvent: I
    }) => {
      let O = [];
      if (I) {
        const K = await At.fetchInstances(
          gt.state.processDefinitionKey
        );
        if (!K.success)
          return { success: !1 };
        O = K.processInstances;
      }
      if ((await At.publishMessage({
        messageName: j,
        correlationKey: pe,
        variables: De,
        timeToLive: Ce,
        messageId: F
      }))?.success === !1)
        return { success: !1 };
      if (I) {
        G.displayNotification?.info({
          title: `Message "${j}" published`
        }), ee(!0);
        const K = await ue(O);
        return K === null ? (console.error("Could not get new instance"), ee(!1), { success: !1 }) : (Ne.reset(), Ne.setInstanceDetails({
          instanceKey: K,
          instanceType: "NEW_INSTANCE"
        }), ee(!1), ao(rr(K), {
          action: "startInstance",
          type: "message-start-event",
          variables: De
        }), { success: !0, instanceId: K });
      }
      return { success: !0 };
    },
    broadcastSignal: async ({
      signalName: j,
      variables: pe,
      isStartEvent: De
    }) => {
      let Ce = [];
      if (De) {
        const I = await At.fetchInstances(
          gt.state.processDefinitionKey
        );
        if (!I.success)
          return { success: !1 };
        Ce = I.processInstances;
      }
      if ((await At.broadcastSignal({
        signalName: j,
        variables: pe
      }))?.success === !1)
        return { success: !1 };
      if (De) {
        G.displayNotification?.info({
          title: `Signal "${j}" broadcasted`
        }), ee(!0);
        const I = await ue(Ce);
        return I === null ? (console.error("Could not get new instance"), ee(!1), { success: !1 }) : (Ne.reset(), Ne.setInstanceDetails({
          instanceKey: I,
          instanceType: "NEW_INSTANCE"
        }), ee(!1), ao(rr(I), {
          action: "startInstance",
          type: "broadcast-signal-event",
          variables: pe
        }), { success: !0, instanceId: I });
      }
      return { success: !0 };
    },
    ...te,
    switchToImplementMode: n,
    displayNotification: l,
    monacoLoaderConfig: e,
    featureFlags: {
      areAIFeaturesEnabled: A?.areAIFeaturesEnabled ?? !1,
      isSaveExampleDataEnabled: A?.isSaveExampleDataEnabled ?? !1,
      isReplayScenariosEnabled: A?.isReplayScenariosEnabled ?? !1
    },
    isUserOrgOwnerOrAdmin: v,
    organizationManagementPageUrl: y
  };
  return /* @__PURE__ */ x.jsxs(qr.Provider, { value: G, children: [
    /* @__PURE__ */ x.jsx(
      $$t,
      {
        description: een({
          isLoadingProcessInstanceDetails: U,
          isRewinding: ce
        })
      }
    ),
    /* @__PURE__ */ x.jsx(bPe, {}),
    /* @__PURE__ */ x.jsx(cFe, { FeedbackButton: T }),
    H && /* @__PURE__ */ x.jsx(
      TPe,
      {
        authConfig: r,
        close: () => z(!1),
        switchToImplementMode: n
      }
    ),
    !H && /* @__PURE__ */ x.jsx(NPe, {}),
    /* @__PURE__ */ x.jsx(hFe, {})
  ] });
};
export {
  Ynn as P,
  nin as a,
  $St as m
};
